class $3791d940664efc96$export$2e2bcd8739ae039 {
    constructor(input, list, { tabInsertsSuggestions: tabInsertsSuggestions, defaultFirstOption: defaultFirstOption, scrollIntoViewOptions: scrollIntoViewOptions } = {}){
        this.input = input;
        this.list = list;
        this.tabInsertsSuggestions = tabInsertsSuggestions !== null && tabInsertsSuggestions !== void 0 ? tabInsertsSuggestions : true;
        this.defaultFirstOption = defaultFirstOption !== null && defaultFirstOption !== void 0 ? defaultFirstOption : false;
        this.scrollIntoViewOptions = scrollIntoViewOptions !== null && scrollIntoViewOptions !== void 0 ? scrollIntoViewOptions : {
            block: 'nearest',
            inline: 'nearest'
        };
        this.isComposing = false;
        if (!list.id) list.id = `combobox-${Math.random().toString().slice(2, 6)}`;
        this.ctrlBindings = !!navigator.userAgent.match(/Macintosh/);
        this.keyboardEventHandler = (event)=>$3791d940664efc96$var$keyboardBindings(event, this);
        this.compositionEventHandler = (event)=>$3791d940664efc96$var$trackComposition(event, this);
        this.inputHandler = this.clearSelection.bind(this);
        input.setAttribute('role', 'combobox');
        input.setAttribute('aria-controls', list.id);
        input.setAttribute('aria-expanded', 'false');
        input.setAttribute('aria-autocomplete', 'list');
        input.setAttribute('aria-haspopup', 'listbox');
    }
    destroy() {
        this.clearSelection();
        this.stop();
        this.input.removeAttribute('role');
        this.input.removeAttribute('aria-controls');
        this.input.removeAttribute('aria-expanded');
        this.input.removeAttribute('aria-autocomplete');
        this.input.removeAttribute('aria-haspopup');
    }
    start() {
        this.input.setAttribute('aria-expanded', 'true');
        this.input.addEventListener('compositionstart', this.compositionEventHandler);
        this.input.addEventListener('compositionend', this.compositionEventHandler);
        this.input.addEventListener('input', this.inputHandler);
        this.input.addEventListener('keydown', this.keyboardEventHandler);
        this.list.addEventListener('click', $3791d940664efc96$var$commitWithElement);
        this.indicateDefaultOption();
    }
    stop() {
        this.clearSelection();
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeEventListener('compositionstart', this.compositionEventHandler);
        this.input.removeEventListener('compositionend', this.compositionEventHandler);
        this.input.removeEventListener('input', this.inputHandler);
        this.input.removeEventListener('keydown', this.keyboardEventHandler);
        this.list.removeEventListener('click', $3791d940664efc96$var$commitWithElement);
    }
    indicateDefaultOption() {
        var _a;
        if (this.defaultFirstOption) (_a = Array.from(this.list.querySelectorAll('[role="option"]:not([aria-disabled="true"])')).filter($3791d940664efc96$var$visible)[0]) === null || _a === void 0 || _a.setAttribute('data-combobox-option-default', 'true');
    }
    navigate(indexDiff = 1) {
        const focusEl = Array.from(this.list.querySelectorAll('[aria-selected="true"]')).filter($3791d940664efc96$var$visible)[0];
        const els = Array.from(this.list.querySelectorAll('[role="option"]')).filter($3791d940664efc96$var$visible);
        const focusIndex = els.indexOf(focusEl);
        if (focusIndex === els.length - 1 && indexDiff === 1 || focusIndex === 0 && indexDiff === -1) {
            this.clearSelection();
            this.input.focus();
            return;
        }
        let indexOfItem = indexDiff === 1 ? 0 : els.length - 1;
        if (focusEl && focusIndex >= 0) {
            const newIndex = focusIndex + indexDiff;
            if (newIndex >= 0 && newIndex < els.length) indexOfItem = newIndex;
        }
        const target = els[indexOfItem];
        if (!target) return;
        for (const el of els){
            el.removeAttribute('data-combobox-option-default');
            if (target === el) {
                this.input.setAttribute('aria-activedescendant', target.id);
                target.setAttribute('aria-selected', 'true');
                $3791d940664efc96$var$fireSelectEvent(target);
                target.scrollIntoView(this.scrollIntoViewOptions);
            } else el.removeAttribute('aria-selected');
        }
    }
    clearSelection() {
        this.input.removeAttribute('aria-activedescendant');
        for (const el of this.list.querySelectorAll('[aria-selected="true"]'))el.removeAttribute('aria-selected');
        this.indicateDefaultOption();
    }
}
function $3791d940664efc96$var$keyboardBindings(event, combobox) {
    if (event.shiftKey || event.metaKey || event.altKey) return;
    if (!combobox.ctrlBindings && event.ctrlKey) return;
    if (combobox.isComposing) return;
    switch(event.key){
        case 'Enter':
            if ($3791d940664efc96$var$commit(combobox.input, combobox.list)) event.preventDefault();
            break;
        case 'Tab':
            if (combobox.tabInsertsSuggestions && $3791d940664efc96$var$commit(combobox.input, combobox.list)) event.preventDefault();
            break;
        case 'Escape':
            combobox.clearSelection();
            break;
        case 'ArrowDown':
            combobox.navigate(1);
            event.preventDefault();
            break;
        case 'ArrowUp':
            combobox.navigate(-1);
            event.preventDefault();
            break;
        case 'n':
            if (combobox.ctrlBindings && event.ctrlKey) {
                combobox.navigate(1);
                event.preventDefault();
            }
            break;
        case 'p':
            if (combobox.ctrlBindings && event.ctrlKey) {
                combobox.navigate(-1);
                event.preventDefault();
            }
            break;
        default:
            if (event.ctrlKey) break;
            combobox.clearSelection();
    }
}
function $3791d940664efc96$var$commitWithElement(event) {
    if (!(event.target instanceof Element)) return;
    const target = event.target.closest('[role="option"]');
    if (!target) return;
    if (target.getAttribute('aria-disabled') === 'true') return;
    $3791d940664efc96$var$fireCommitEvent(target, {
        event: event
    });
}
function $3791d940664efc96$var$commit(input, list) {
    const target = list.querySelector('[aria-selected="true"], [data-combobox-option-default="true"]');
    if (!target) return false;
    if (target.getAttribute('aria-disabled') === 'true') return true;
    target.click();
    return true;
}
function $3791d940664efc96$var$fireCommitEvent(target, detail) {
    target.dispatchEvent(new CustomEvent('combobox-commit', {
        bubbles: true,
        detail: detail
    }));
}
function $3791d940664efc96$var$fireSelectEvent(target) {
    target.dispatchEvent(new Event('combobox-select', {
        bubbles: true
    }));
}
function $3791d940664efc96$var$visible(el) {
    return !el.hidden && !(el instanceof HTMLInputElement && el.type === 'hidden') && (el.offsetWidth > 0 || el.offsetHeight > 0);
}
function $3791d940664efc96$var$trackComposition(event, combobox) {
    combobox.isComposing = event.type === 'compositionstart';
    const list = document.getElementById(combobox.input.getAttribute('aria-controls') || '');
    if (!list) return;
    combobox.clearSelection();
}


function $a43d8cb124a0d66b$export$2e2bcd8739ae039(callback, wait = 0) {
    let timeout;
    return function(...Rest) {
        clearTimeout(timeout);
        timeout = window.setTimeout(()=>{
            clearTimeout(timeout);
            callback(...Rest);
        }, wait);
    };
}


const $17d439654615f6cc$var$SCREEN_READER_DELAY = window.testScreenReaderDelay || 100;
class $17d439654615f6cc$export$2e2bcd8739ae039 {
    constructor(container, input, results, autoselectEnabled = false){
        var _a;
        this.container = container;
        this.input = input;
        this.results = results;
        this.combobox = new (0, $3791d940664efc96$export$2e2bcd8739ae039)(input, results, {
            defaultFirstOption: autoselectEnabled
        });
        this.feedback = container.getRootNode().getElementById(`${this.results.id}-feedback`);
        this.autoselectEnabled = autoselectEnabled;
        this.clearButton = container.getRootNode().getElementById(`${this.input.id || this.input.name}-clear`);
        this.clientOptions = results.querySelectorAll('[role=option]');
        if (this.feedback) {
            this.feedback.setAttribute('aria-live', 'polite');
            this.feedback.setAttribute('aria-atomic', 'true');
        }
        if (this.clearButton && !this.clearButton.getAttribute('aria-label')) {
            const labelElem = document.querySelector(`label[for="${this.input.name}"]`);
            this.clearButton.setAttribute('aria-label', `clear:`);
            this.clearButton.setAttribute('aria-labelledby', `${this.clearButton.id} ${(labelElem === null || labelElem === void 0 ? void 0 : labelElem.id) || ''}`);
        }
        if (!this.input.getAttribute('aria-expanded')) this.input.setAttribute('aria-expanded', 'false');
        if (this.results.popover) {
            if (this.results.matches(':popover-open')) this.results.hidePopover();
        } else this.results.hidden = true;
        if (!this.results.getAttribute('aria-label')) this.results.setAttribute('aria-label', 'results');
        this.input.setAttribute('autocomplete', 'off');
        this.input.setAttribute('spellcheck', 'false');
        this.interactingWithList = false;
        this.onInputChange = (0, $a43d8cb124a0d66b$export$2e2bcd8739ae039)(this.onInputChange.bind(this), 300);
        this.onResultsMouseDown = this.onResultsMouseDown.bind(this);
        this.onInputBlur = this.onInputBlur.bind(this);
        this.onInputFocus = this.onInputFocus.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onCommit = this.onCommit.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.input.addEventListener('keydown', this.onKeydown);
        this.input.addEventListener('focus', this.onInputFocus);
        this.input.addEventListener('blur', this.onInputBlur);
        this.input.addEventListener('input', this.onInputChange);
        this.results.addEventListener('mousedown', this.onResultsMouseDown);
        this.results.addEventListener('combobox-commit', this.onCommit);
        (_a = this.clearButton) === null || _a === void 0 || _a.addEventListener('click', this.handleClear);
    }
    destroy() {
        this.input.removeEventListener('keydown', this.onKeydown);
        this.input.removeEventListener('focus', this.onInputFocus);
        this.input.removeEventListener('blur', this.onInputBlur);
        this.input.removeEventListener('input', this.onInputChange);
        this.results.removeEventListener('mousedown', this.onResultsMouseDown);
        this.results.removeEventListener('combobox-commit', this.onCommit);
    }
    handleClear(event) {
        event.preventDefault();
        if (this.input.getAttribute('aria-expanded') === 'true') {
            this.input.setAttribute('aria-expanded', 'false');
            this.updateFeedbackForScreenReaders('Results hidden.');
        }
        this.input.value = '';
        this.container.value = '';
        this.input.focus();
        this.input.dispatchEvent(new Event('change'));
        this.close();
    }
    onKeydown(event) {
        if (event.key === 'Escape' && this.container.open) {
            this.close();
            event.stopPropagation();
            event.preventDefault();
        } else if (event.altKey && event.key === 'ArrowUp' && this.container.open) {
            this.close();
            event.stopPropagation();
            event.preventDefault();
        } else if (event.altKey && event.key === 'ArrowDown' && !this.container.open) {
            if (!this.input.value.trim()) return;
            this.open();
            event.stopPropagation();
            event.preventDefault();
        }
    }
    onInputFocus() {
        if (this.interactingWithList) return;
        this.fetchResults();
    }
    onInputBlur() {
        if (this.interactingWithList) return;
        this.close();
    }
    onCommit({ target: target }) {
        const selected = target;
        if (!(selected instanceof HTMLElement)) return;
        this.close();
        if (selected instanceof HTMLAnchorElement) return;
        const value = selected.getAttribute('data-autocomplete-value') || selected.textContent;
        this.updateFeedbackForScreenReaders(`${selected.textContent || ''} selected.`);
        this.container.value = value;
        if (!value) this.updateFeedbackForScreenReaders(`Results hidden.`);
    }
    onResultsMouseDown() {
        this.interactingWithList = true;
    }
    onInputChange() {
        if (this.feedback && this.feedback.textContent) this.feedback.textContent = '';
        this.container.removeAttribute('value');
        this.fetchResults();
    }
    identifyOptions() {
        let id = 0;
        for (const el of this.results.querySelectorAll('[role="option"]:not([id])'))el.id = `${this.results.id}-option-${id++}`;
    }
    updateFeedbackForScreenReaders(inputString) {
        setTimeout(()=>{
            if (this.feedback) this.feedback.textContent = inputString;
        }, $17d439654615f6cc$var$SCREEN_READER_DELAY);
    }
    fetchResults() {
        const query = this.input.value.trim();
        if (!query && !this.container.fetchOnEmpty) {
            this.close();
            return;
        }
        const src = this.container.src;
        if (!src) return;
        const url = new URL(src, window.location.href);
        const params = new URLSearchParams(url.search.slice(1));
        params.append('q', query);
        url.search = params.toString();
        this.container.dispatchEvent(new CustomEvent('loadstart'));
        this.container.fetchResult(url).then((html)=>{
            this.results.innerHTML = html;
            this.identifyOptions();
            this.combobox.indicateDefaultOption();
            const allNewOptions = this.results.querySelectorAll('[role="option"]');
            const hasResults = !!allNewOptions.length || !!this.results.querySelectorAll('[data-no-result-found="true"]').length;
            const numOptions = allNewOptions.length;
            const [firstOption] = allNewOptions;
            const firstOptionValue = firstOption === null || firstOption === void 0 ? void 0 : firstOption.textContent;
            if (this.autoselectEnabled && firstOptionValue) this.updateFeedbackForScreenReaders(`${numOptions} results. ${firstOptionValue} is the top result: Press Enter to activate.`);
            else this.updateFeedbackForScreenReaders(`${numOptions || 'No'} results.`);
            hasResults ? this.open() : this.close();
            this.container.dispatchEvent(new CustomEvent('load'));
            this.container.dispatchEvent(new CustomEvent('loadend'));
        }).catch(()=>{
            this.container.dispatchEvent(new CustomEvent('error'));
            this.container.dispatchEvent(new CustomEvent('loadend'));
        });
    }
    open() {
        const isHidden = this.results.popover ? !this.results.matches(':popover-open') : this.results.hidden;
        if (isHidden) {
            this.combobox.start();
            if (this.results.popover) this.results.showPopover();
            else this.results.hidden = false;
        }
        this.container.open = true;
        this.interactingWithList = true;
    }
    close() {
        const isVisible = this.results.popover ? this.results.matches(':popover-open') : !this.results.hidden;
        if (isVisible) {
            this.combobox.stop();
            if (this.results.popover) this.results.hidePopover();
            else this.results.hidden = true;
        }
        this.container.open = false;
        this.interactingWithList = false;
    }
}


var $2424af6bdadb9c22$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $2424af6bdadb9c22$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $2424af6bdadb9c22$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2424af6bdadb9c22$var$_AutoCompleteElement_instances, $2424af6bdadb9c22$var$_AutoCompleteElement_forElement, $2424af6bdadb9c22$var$_AutoCompleteElement_inputElement, $2424af6bdadb9c22$var$_AutoCompleteElement_reattachState, $2424af6bdadb9c22$var$_AutoCompleteElement_requestController;
const $2424af6bdadb9c22$var$HTMLElement = globalThis.HTMLElement || null;
class $2424af6bdadb9c22$export$bf58dbf529e87120 extends Event {
    constructor(type, _a){
        var { relatedTarget: relatedTarget } = _a, init = $2424af6bdadb9c22$var$__rest(_a, [
            "relatedTarget"
        ]);
        super(type, init);
        this.relatedTarget = relatedTarget;
    }
}
const $2424af6bdadb9c22$var$state = new WeakMap();
let $2424af6bdadb9c22$var$cspTrustedTypesPolicyPromise = null;
class $2424af6bdadb9c22$export$d22562a5dbba41e6 extends $2424af6bdadb9c22$var$HTMLElement {
    constructor(){
        super(...arguments);
        $2424af6bdadb9c22$var$_AutoCompleteElement_instances.add(this);
        $2424af6bdadb9c22$var$_AutoCompleteElement_forElement.set(this, null);
        $2424af6bdadb9c22$var$_AutoCompleteElement_inputElement.set(this, null);
        $2424af6bdadb9c22$var$_AutoCompleteElement_requestController.set(this, void 0);
    }
    static define(tag = 'auto-complete', registry = customElements) {
        registry.define(tag, this);
        return this;
    }
    static setCSPTrustedTypesPolicy(policy) {
        $2424af6bdadb9c22$var$cspTrustedTypesPolicyPromise = policy === null ? policy : Promise.resolve(policy);
    }
    get forElement() {
        var _a;
        if ((_a = $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_forElement, "f")) === null || _a === void 0 ? void 0 : _a.isConnected) return $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_forElement, "f");
        const id = this.getAttribute('for');
        const root = this.getRootNode();
        if (id && (root instanceof Document || root instanceof ShadowRoot)) return root.getElementById(id);
        return null;
    }
    set forElement(element) {
        $2424af6bdadb9c22$var$__classPrivateFieldSet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_forElement, element, "f");
        this.setAttribute('for', '');
    }
    get inputElement() {
        var _a;
        if ((_a = $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_inputElement, "f")) === null || _a === void 0 ? void 0 : _a.isConnected) return $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_inputElement, "f");
        return this.querySelector('input');
    }
    set inputElement(input) {
        $2424af6bdadb9c22$var$__classPrivateFieldSet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_inputElement, input, "f");
        $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_instances, "m", $2424af6bdadb9c22$var$_AutoCompleteElement_reattachState).call(this);
    }
    connectedCallback() {
        if (!this.isConnected) return;
        $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_instances, "m", $2424af6bdadb9c22$var$_AutoCompleteElement_reattachState).call(this);
        new MutationObserver(()=>{
            if (!$2424af6bdadb9c22$var$state.get(this)) $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_instances, "m", $2424af6bdadb9c22$var$_AutoCompleteElement_reattachState).call(this);
        }).observe(this, {
            subtree: true,
            childList: true
        });
    }
    disconnectedCallback() {
        const autocomplete = $2424af6bdadb9c22$var$state.get(this);
        if (autocomplete) {
            autocomplete.destroy();
            $2424af6bdadb9c22$var$state.delete(this);
        }
    }
    get src() {
        return this.getAttribute('src') || '';
    }
    set src(url) {
        this.setAttribute('src', url);
    }
    get value() {
        return this.getAttribute('value') || '';
    }
    set value(value) {
        this.setAttribute('value', value);
    }
    get open() {
        return this.hasAttribute('open');
    }
    set open(value) {
        if (value) this.setAttribute('open', '');
        else this.removeAttribute('open');
    }
    get fetchOnEmpty() {
        return this.hasAttribute('fetch-on-empty');
    }
    set fetchOnEmpty(fetchOnEmpty) {
        this.toggleAttribute('fetch-on-empty', fetchOnEmpty);
    }
    async fetchResult(url) {
        var _a;
        (_a = $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_requestController, "f")) === null || _a === void 0 || _a.abort();
        const { signal: signal } = $2424af6bdadb9c22$var$__classPrivateFieldSet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_requestController, new AbortController(), "f");
        const res = await fetch(url.toString(), {
            signal: signal,
            headers: {
                Accept: 'text/fragment+html'
            }
        });
        if (!res.ok) throw new Error(await res.text());
        if ($2424af6bdadb9c22$var$cspTrustedTypesPolicyPromise) {
            const cspTrustedTypesPolicy = await $2424af6bdadb9c22$var$cspTrustedTypesPolicyPromise;
            return cspTrustedTypesPolicy.createHTML(await res.text(), res);
        }
        return await res.text();
    }
    static get observedAttributes() {
        return [
            'open',
            'value',
            'for'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        var _a, _b;
        if (oldValue === newValue) return;
        const autocomplete = $2424af6bdadb9c22$var$state.get(this);
        if (!autocomplete) return;
        if (this.forElement !== ((_a = $2424af6bdadb9c22$var$state.get(this)) === null || _a === void 0 ? void 0 : _a.results) || this.inputElement !== ((_b = $2424af6bdadb9c22$var$state.get(this)) === null || _b === void 0 ? void 0 : _b.input)) $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_instances, "m", $2424af6bdadb9c22$var$_AutoCompleteElement_reattachState).call(this);
        switch(name){
            case 'open':
                newValue === null ? autocomplete.close() : autocomplete.open();
                break;
            case 'value':
                if (newValue !== null) autocomplete.input.value = newValue;
                this.dispatchEvent(new $2424af6bdadb9c22$export$bf58dbf529e87120('auto-complete-change', {
                    bubbles: true,
                    relatedTarget: autocomplete.input
                }));
                break;
        }
    }
}
$2424af6bdadb9c22$var$_AutoCompleteElement_forElement = new WeakMap(), $2424af6bdadb9c22$var$_AutoCompleteElement_inputElement = new WeakMap(), $2424af6bdadb9c22$var$_AutoCompleteElement_requestController = new WeakMap(), $2424af6bdadb9c22$var$_AutoCompleteElement_instances = new WeakSet(), $2424af6bdadb9c22$var$_AutoCompleteElement_reattachState = function _AutoCompleteElement_reattachState() {
    var _a;
    (_a = $2424af6bdadb9c22$var$state.get(this)) === null || _a === void 0 || _a.destroy();
    const { forElement: forElement, inputElement: inputElement } = this;
    if (!forElement || !inputElement) return;
    const autoselectEnabled = this.getAttribute('data-autoselect') === 'true';
    $2424af6bdadb9c22$var$state.set(this, new (0, $17d439654615f6cc$export$2e2bcd8739ae039)(this, inputElement, forElement, autoselectEnabled));
    forElement.setAttribute('role', 'listbox');
};
var $2424af6bdadb9c22$export$2e2bcd8739ae039 = $2424af6bdadb9c22$export$d22562a5dbba41e6;


const $139db8d084e757ca$var$root = typeof globalThis !== 'undefined' ? globalThis : window;
try {
    $139db8d084e757ca$var$root.AutocompleteElement = $139db8d084e757ca$var$root.AutoCompleteElement = (0, $2424af6bdadb9c22$export$d22562a5dbba41e6).define();
} catch (e) {
    if (!($139db8d084e757ca$var$root.DOMException && e instanceof DOMException && e.name === 'NotSupportedError') && !(e instanceof ReferenceError)) throw e;
}
var $139db8d084e757ca$export$2e2bcd8739ae039 = (0, $2424af6bdadb9c22$export$d22562a5dbba41e6);


function $a4ae59bd85166939$var$createNode(text) {
    const node = document.createElement('pre');
    node.style.width = '1px';
    node.style.height = '1px';
    node.style.position = 'fixed';
    node.style.top = '5px';
    node.textContent = text;
    return node;
}
function $a4ae59bd85166939$var$normalizeText(text) {
    return text.replace(/[\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000]/g, ' ').replace(/[\u200B-\u200D\u2060\uFEFF\u180E]/g, '');
}
function $a4ae59bd85166939$var$copySelection(node) {
    const selection = getSelection();
    if (selection == null) return Promise.reject(new Error());
    selection.removeAllRanges();
    const range = document.createRange();
    range.selectNodeContents(node);
    selection.addRange(range);
    document.execCommand('copy');
    selection.removeAllRanges();
    return Promise.resolve();
}
function $a4ae59bd85166939$export$978ef9948557240e(node) {
    return $a4ae59bd85166939$export$c8531afc97e1e0f8(node.textContent || '');
}
function $a4ae59bd85166939$export$c8531afc97e1e0f8(text) {
    const normalized = $a4ae59bd85166939$var$normalizeText(text);
    if ('clipboard' in navigator) return navigator.clipboard.writeText(normalized);
    const body = document.body;
    if (!body) return Promise.reject(new Error());
    const node = $a4ae59bd85166939$var$createNode(normalized);
    body.appendChild(node);
    $a4ae59bd85166939$var$copySelection(node);
    body.removeChild(node);
    return Promise.resolve();
}


async function $ef6a8c01f13c245c$var$copy(button) {
    const id = button.getAttribute('for');
    const text = button.getAttribute('value');
    function trigger() {
        button.dispatchEvent(new CustomEvent('clipboard-copy', {
            bubbles: true
        }));
    }
    if (button.getAttribute('aria-disabled') === 'true') return;
    if (text) {
        await (0, $a4ae59bd85166939$export$c8531afc97e1e0f8)(text);
        trigger();
    } else if (id) {
        const root = 'getRootNode' in Element.prototype ? button.getRootNode() : button.ownerDocument;
        if (!(root instanceof Document || 'ShadowRoot' in window && root instanceof ShadowRoot)) return;
        const node = root.getElementById(id);
        if (node) {
            await $ef6a8c01f13c245c$var$copyTarget(node);
            trigger();
        }
    }
}
function $ef6a8c01f13c245c$var$copyTarget(content) {
    if (content instanceof HTMLInputElement || content instanceof HTMLTextAreaElement) return (0, $a4ae59bd85166939$export$c8531afc97e1e0f8)(content.value);
    else if (content instanceof HTMLAnchorElement && content.hasAttribute('href')) return (0, $a4ae59bd85166939$export$c8531afc97e1e0f8)(content.href);
    else return (0, $a4ae59bd85166939$export$978ef9948557240e)(content);
}
function $ef6a8c01f13c245c$var$clicked(event) {
    const button = event.currentTarget;
    if (button instanceof HTMLElement) $ef6a8c01f13c245c$var$copy(button);
}
function $ef6a8c01f13c245c$var$keydown(event) {
    if (event.key === ' ' || event.key === 'Enter') {
        const button = event.currentTarget;
        if (button instanceof HTMLElement) {
            event.preventDefault();
            $ef6a8c01f13c245c$var$copy(button);
        }
    }
}
function $ef6a8c01f13c245c$var$focused(event) {
    event.currentTarget.addEventListener('keydown', $ef6a8c01f13c245c$var$keydown);
}
function $ef6a8c01f13c245c$var$blurred(event) {
    event.currentTarget.removeEventListener('keydown', $ef6a8c01f13c245c$var$keydown);
}
class $ef6a8c01f13c245c$export$c06ca7125051d4c8 extends HTMLElement {
    static define(tag = 'clipboard-copy', registry = customElements) {
        registry.define(tag, this);
        return this;
    }
    constructor(){
        super();
        this.addEventListener('click', $ef6a8c01f13c245c$var$clicked);
        this.addEventListener('focus', $ef6a8c01f13c245c$var$focused);
        this.addEventListener('blur', $ef6a8c01f13c245c$var$blurred);
    }
    connectedCallback() {
        if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');
        if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
    }
    get value() {
        return this.getAttribute('value') || '';
    }
    set value(text) {
        this.setAttribute('value', text);
    }
}



const $336c1e18e7b6ef2c$var$root = typeof globalThis !== 'undefined' ? globalThis : window;
try {
    $336c1e18e7b6ef2c$var$root.ClipboardCopyElement = (0, $ef6a8c01f13c245c$export$c06ca7125051d4c8).define();
} catch (e) {
    if (!($336c1e18e7b6ef2c$var$root.DOMException && e instanceof DOMException && e.name === 'NotSupportedError') && !(e instanceof ReferenceError)) throw e;
}
var $336c1e18e7b6ef2c$export$2e2bcd8739ae039 = (0, $ef6a8c01f13c245c$export$c06ca7125051d4c8);


var $e8d9fb58cefaae39$export$2e2bcd8739ae039 = (0, $ef6a8c01f13c245c$export$c06ca7125051d4c8);


class $8449f1a811eb81cd$var$DetailsMenuElement extends HTMLElement {
    get preload() {
        return this.hasAttribute('preload');
    }
    set preload(value) {
        if (value) this.setAttribute('preload', '');
        else this.removeAttribute('preload');
    }
    get src() {
        return this.getAttribute('src') || '';
    }
    set src(value) {
        this.setAttribute('src', value);
    }
    connectedCallback() {
        if (!this.hasAttribute('role')) this.setAttribute('role', 'menu');
        const details = this.parentElement;
        if (!details) return;
        const summary = details.querySelector('summary');
        if (summary) {
            summary.setAttribute('aria-haspopup', 'menu');
            if (!summary.hasAttribute('role')) summary.setAttribute('role', 'button');
        }
        const subscriptions = [
            $8449f1a811eb81cd$var$fromEvent(details, 'compositionstart', (e)=>$8449f1a811eb81cd$var$trackComposition(this, e)),
            $8449f1a811eb81cd$var$fromEvent(details, 'compositionend', (e)=>$8449f1a811eb81cd$var$trackComposition(this, e)),
            $8449f1a811eb81cd$var$fromEvent(details, 'click', (e)=>$8449f1a811eb81cd$var$shouldCommit(details, e)),
            $8449f1a811eb81cd$var$fromEvent(details, 'change', (e)=>$8449f1a811eb81cd$var$shouldCommit(details, e)),
            $8449f1a811eb81cd$var$fromEvent(details, 'keydown', (e)=>$8449f1a811eb81cd$var$keydown(details, this, e)),
            $8449f1a811eb81cd$var$fromEvent(details, 'toggle', ()=>$8449f1a811eb81cd$var$loadFragment(details, this), {
                once: true
            }),
            $8449f1a811eb81cd$var$fromEvent(details, 'toggle', ()=>$8449f1a811eb81cd$var$closeCurrentMenu(details)),
            this.preload ? $8449f1a811eb81cd$var$fromEvent(details, 'mouseover', ()=>$8449f1a811eb81cd$var$loadFragment(details, this), {
                once: true
            }) : $8449f1a811eb81cd$var$NullSubscription,
            ...$8449f1a811eb81cd$var$focusOnOpen(details)
        ];
        $8449f1a811eb81cd$var$states.set(this, {
            subscriptions: subscriptions,
            loaded: false,
            isComposing: false
        });
    }
    disconnectedCallback() {
        const state = $8449f1a811eb81cd$var$states.get(this);
        if (!state) return;
        $8449f1a811eb81cd$var$states.delete(this);
        for (const sub of state.subscriptions)sub.unsubscribe();
    }
}
const $8449f1a811eb81cd$var$states = new WeakMap();
const $8449f1a811eb81cd$var$NullSubscription = {
    unsubscribe () {}
};
function $8449f1a811eb81cd$var$fromEvent(target, eventName, onNext, options = false) {
    target.addEventListener(eventName, onNext, options);
    return {
        unsubscribe: ()=>{
            target.removeEventListener(eventName, onNext, options);
        }
    };
}
function $8449f1a811eb81cd$var$loadFragment(details, menu) {
    const src = menu.getAttribute('src');
    if (!src) return;
    const state = $8449f1a811eb81cd$var$states.get(menu);
    if (!state) return;
    if (state.loaded) return;
    state.loaded = true;
    const loader = menu.querySelector('include-fragment');
    if (loader && !loader.hasAttribute('src')) {
        loader.addEventListener('loadend', ()=>$8449f1a811eb81cd$var$autofocus(details));
        loader.setAttribute('src', src);
    }
}
function $8449f1a811eb81cd$var$focusOnOpen(details) {
    let isMouse = false;
    const onmousedown = ()=>isMouse = true;
    const onkeydown = ()=>isMouse = false;
    const ontoggle = ()=>{
        if (!details.hasAttribute('open')) return;
        if ($8449f1a811eb81cd$var$autofocus(details)) return;
        if (!isMouse) $8449f1a811eb81cd$var$focusFirstItem(details);
    };
    return [
        $8449f1a811eb81cd$var$fromEvent(details, 'mousedown', onmousedown),
        $8449f1a811eb81cd$var$fromEvent(details, 'keydown', onkeydown),
        $8449f1a811eb81cd$var$fromEvent(details, 'toggle', ontoggle)
    ];
}
function $8449f1a811eb81cd$var$closeCurrentMenu(details) {
    if (!details.hasAttribute('open')) return;
    for (const menu of document.querySelectorAll('details[open] > details-menu')){
        const opened = menu.closest('details');
        if (opened && opened !== details && !opened.contains(details)) opened.removeAttribute('open');
    }
}
function $8449f1a811eb81cd$var$autofocus(details) {
    if (!details.hasAttribute('open')) return false;
    const input = details.querySelector('details-menu [autofocus]');
    if (input) {
        input.focus();
        return true;
    } else return false;
}
function $8449f1a811eb81cd$var$focusFirstItem(details) {
    const selected = document.activeElement;
    if (selected && $8449f1a811eb81cd$var$isMenuItem(selected) && details.contains(selected)) return;
    const target = $8449f1a811eb81cd$var$sibling(details, true);
    if (target) target.focus();
}
function $8449f1a811eb81cd$var$sibling(details, next) {
    const options = Array.from(details.querySelectorAll('[role^="menuitem"]:not([hidden]):not([disabled])'));
    const selected = document.activeElement;
    const index = selected instanceof HTMLElement ? options.indexOf(selected) : -1;
    const found = next ? options[index + 1] : options[index - 1];
    const def = next ? options[0] : options[options.length - 1];
    return found || def;
}
const $8449f1a811eb81cd$var$ctrlBindings = navigator.userAgent.match(/Macintosh/);
function $8449f1a811eb81cd$var$shouldCommit(details, event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('details') !== details) return;
    if (event.type === 'click') {
        const menuitem = target.closest('[role="menuitem"], [role="menuitemradio"]');
        if (!menuitem) return;
        const input = menuitem.querySelector('input');
        if (menuitem.tagName === 'LABEL' && target === input) return;
        const onlyCommitOnChangeEvent = menuitem.tagName === 'LABEL' && input && !input.checked;
        if (!onlyCommitOnChangeEvent) $8449f1a811eb81cd$var$commit(menuitem, details);
    } else if (event.type === 'change') {
        const menuitem = target.closest('[role="menuitemradio"], [role="menuitemcheckbox"]');
        if (menuitem) $8449f1a811eb81cd$var$commit(menuitem, details);
    }
}
function $8449f1a811eb81cd$var$updateChecked(selected, details) {
    for (const el of details.querySelectorAll('[role="menuitemradio"], [role="menuitemcheckbox"]')){
        const input = el.querySelector('input[type="radio"], input[type="checkbox"]');
        let checkState = (el === selected).toString();
        if (input instanceof HTMLInputElement) checkState = input.indeterminate ? 'mixed' : input.checked.toString();
        el.setAttribute('aria-checked', checkState);
    }
}
function $8449f1a811eb81cd$var$commit(selected, details) {
    if (selected.hasAttribute('disabled') || selected.getAttribute('aria-disabled') === 'true') return;
    const menu = selected.closest('details-menu');
    if (!menu) return;
    const dispatched = menu.dispatchEvent(new CustomEvent('details-menu-select', {
        cancelable: true,
        detail: {
            relatedTarget: selected
        }
    }));
    if (!dispatched) return;
    $8449f1a811eb81cd$var$updateLabel(selected, details);
    $8449f1a811eb81cd$var$updateChecked(selected, details);
    if (selected.getAttribute('role') !== 'menuitemcheckbox') $8449f1a811eb81cd$var$close(details);
    menu.dispatchEvent(new CustomEvent('details-menu-selected', {
        detail: {
            relatedTarget: selected
        }
    }));
}
function $8449f1a811eb81cd$var$keydown(details, menu, event) {
    if (!(event instanceof KeyboardEvent)) return;
    if (details.querySelector('details[open]')) return;
    const state = $8449f1a811eb81cd$var$states.get(menu);
    if (!state || state.isComposing) return;
    const isSummaryFocused = event.target instanceof Element && event.target.tagName === 'SUMMARY';
    switch(event.key){
        case 'Escape':
            if (details.hasAttribute('open')) {
                $8449f1a811eb81cd$var$close(details);
                event.preventDefault();
                event.stopPropagation();
            }
            break;
        case 'ArrowDown':
            {
                if (isSummaryFocused && !details.hasAttribute('open')) details.setAttribute('open', '');
                const target = $8449f1a811eb81cd$var$sibling(details, true);
                if (target) target.focus();
                event.preventDefault();
            }
            break;
        case 'ArrowUp':
            {
                if (isSummaryFocused && !details.hasAttribute('open')) details.setAttribute('open', '');
                const target = $8449f1a811eb81cd$var$sibling(details, false);
                if (target) target.focus();
                event.preventDefault();
            }
            break;
        case 'n':
            if ($8449f1a811eb81cd$var$ctrlBindings && event.ctrlKey) {
                const target = $8449f1a811eb81cd$var$sibling(details, true);
                if (target) target.focus();
                event.preventDefault();
            }
            break;
        case 'p':
            if ($8449f1a811eb81cd$var$ctrlBindings && event.ctrlKey) {
                const target = $8449f1a811eb81cd$var$sibling(details, false);
                if (target) target.focus();
                event.preventDefault();
            }
            break;
        case ' ':
        case 'Enter':
            {
                const selected = document.activeElement;
                if (selected instanceof HTMLElement && $8449f1a811eb81cd$var$isMenuItem(selected) && selected.closest('details') === details) {
                    event.preventDefault();
                    event.stopPropagation();
                    selected.click();
                }
            }
            break;
    }
}
function $8449f1a811eb81cd$var$isMenuItem(el) {
    const role = el.getAttribute('role');
    return role === 'menuitem' || role === 'menuitemcheckbox' || role === 'menuitemradio';
}
function $8449f1a811eb81cd$var$close(details) {
    const wasOpen = details.hasAttribute('open');
    if (!wasOpen) return;
    details.removeAttribute('open');
    const summary = details.querySelector('summary');
    if (summary) summary.focus();
}
function $8449f1a811eb81cd$var$updateLabel(item, details) {
    const button = details.querySelector('[data-menu-button]');
    if (!button) return;
    const text = $8449f1a811eb81cd$var$labelText(item);
    if (text) button.textContent = text;
    else {
        const html = $8449f1a811eb81cd$var$labelHTML(item);
        if (html) button.innerHTML = html;
    }
}
function $8449f1a811eb81cd$var$labelText(el) {
    if (!el) return null;
    const textEl = el.hasAttribute('data-menu-button-text') ? el : el.querySelector('[data-menu-button-text]');
    if (!textEl) return null;
    return textEl.getAttribute('data-menu-button-text') || textEl.textContent;
}
function $8449f1a811eb81cd$var$labelHTML(el) {
    if (!el) return null;
    const contentsEl = el.hasAttribute('data-menu-button-contents') ? el : el.querySelector('[data-menu-button-contents]');
    return contentsEl ? contentsEl.innerHTML : null;
}
function $8449f1a811eb81cd$var$trackComposition(menu, event) {
    const state = $8449f1a811eb81cd$var$states.get(menu);
    if (!state) return;
    state.isComposing = event.type === 'compositionstart';
}
var $8449f1a811eb81cd$export$2e2bcd8739ae039 = $8449f1a811eb81cd$var$DetailsMenuElement;
if (!window.customElements.get('details-menu')) {
    window.DetailsMenuElement = $8449f1a811eb81cd$var$DetailsMenuElement;
    window.customElements.define('details-menu', $8449f1a811eb81cd$var$DetailsMenuElement);
}


class $60111cd6ea196be2$export$71e4db985cfcf9e3 {
    constructor(file, directory){
        this.file = file;
        this.directory = directory;
        this.state = 'pending';
        this.id = null;
        this.href = null;
        this.name = null;
        this.percent = 0;
    }
    static traverse(transfer, directory) {
        return $60111cd6ea196be2$var$transferredFiles(transfer, directory);
    }
    static from(files) {
        const result = [];
        for (const file of files){
            if (file instanceof File) result.push(new $60111cd6ea196be2$export$71e4db985cfcf9e3(file));
            else if (file instanceof $60111cd6ea196be2$export$71e4db985cfcf9e3) result.push(file);
            else throw new Error('Unexpected type');
        }
        return result;
    }
    get fullPath() {
        return this.directory ? `${this.directory}/${this.file.name}` : this.file.name;
    }
    isImage() {
        return [
            'image/gif',
            'image/png',
            'image/jpg',
            'image/jpeg',
            'image/svg+xml',
            'image/webp'
        ].indexOf(this.file.type) > -1;
    }
    isVideo() {
        return [
            'video/mp4',
            'video/quicktime'
        ].indexOf(this.file.type) > -1;
    }
    saving(percent) {
        if (this.state !== 'pending' && this.state !== 'saving') throw new Error(`Unexpected transition from ${this.state} to saving`);
        this.state = 'saving';
        this.percent = percent;
    }
    saved(attributes) {
        var _a, _b, _c;
        if (this.state !== 'pending' && this.state !== 'saving') throw new Error(`Unexpected transition from ${this.state} to saved`);
        this.state = 'saved';
        this.id = (_a = attributes === null || attributes === void 0 ? void 0 : attributes.id) !== null && _a !== void 0 ? _a : null;
        this.href = (_b = attributes === null || attributes === void 0 ? void 0 : attributes.href) !== null && _b !== void 0 ? _b : null;
        this.name = (_c = attributes === null || attributes === void 0 ? void 0 : attributes.name) !== null && _c !== void 0 ? _c : null;
    }
    isPending() {
        return this.state === 'pending';
    }
    isSaving() {
        return this.state === 'saving';
    }
    isSaved() {
        return this.state === 'saved';
    }
}
function $60111cd6ea196be2$var$transferredFiles(transfer, directory) {
    if (directory && $60111cd6ea196be2$var$isDirectory(transfer)) return $60111cd6ea196be2$var$traverse('', $60111cd6ea196be2$var$roots(transfer));
    return Promise.resolve($60111cd6ea196be2$var$visible(Array.from(transfer.files || [])).map((f)=>new $60111cd6ea196be2$export$71e4db985cfcf9e3(f)));
}
function $60111cd6ea196be2$var$hidden(file) {
    return file.name.startsWith('.');
}
function $60111cd6ea196be2$var$visible(files) {
    return Array.from(files).filter((file)=>!$60111cd6ea196be2$var$hidden(file));
}
function $60111cd6ea196be2$var$getFile(entry) {
    return new Promise(function(resolve, reject) {
        entry.file(resolve, reject);
    });
}
function $60111cd6ea196be2$var$getEntries(entry) {
    return new Promise(function(resolve, reject) {
        const result = [];
        const reader = entry.createReader();
        const read = ()=>{
            reader.readEntries((entries)=>{
                if (entries.length > 0) {
                    result.push(...entries);
                    read();
                } else resolve(result);
            }, reject);
        };
        read();
    });
}
async function $60111cd6ea196be2$var$traverse(path, entries) {
    const results = [];
    for (const entry of $60111cd6ea196be2$var$visible(entries))if (entry.isDirectory) results.push(...await $60111cd6ea196be2$var$traverse(entry.fullPath, await $60111cd6ea196be2$var$getEntries(entry)));
    else {
        const file = await $60111cd6ea196be2$var$getFile(entry);
        results.push(new $60111cd6ea196be2$export$71e4db985cfcf9e3(file, path));
    }
    return results;
}
function $60111cd6ea196be2$var$isDirectory(transfer) {
    return transfer.items && Array.from(transfer.items).some((item)=>{
        const entry = item.webkitGetAsEntry && item.webkitGetAsEntry();
        return entry && entry.isDirectory;
    });
}
function $60111cd6ea196be2$var$roots(transfer) {
    return Array.from(transfer.items).map((item)=>item.webkitGetAsEntry()).filter((entry)=>entry != null);
}
class $60111cd6ea196be2$export$2e2bcd8739ae039 extends HTMLElement {
    connectedCallback() {
        this.addEventListener('dragenter', $60111cd6ea196be2$var$onDragenter);
        this.addEventListener('dragover', $60111cd6ea196be2$var$onDragenter);
        this.addEventListener('dragleave', $60111cd6ea196be2$var$onDragleave);
        this.addEventListener('drop', $60111cd6ea196be2$var$onDrop);
        this.addEventListener('paste', $60111cd6ea196be2$var$onPaste);
        this.addEventListener('change', $60111cd6ea196be2$var$onChange);
    }
    disconnectedCallback() {
        this.removeEventListener('dragenter', $60111cd6ea196be2$var$onDragenter);
        this.removeEventListener('dragover', $60111cd6ea196be2$var$onDragenter);
        this.removeEventListener('dragleave', $60111cd6ea196be2$var$onDragleave);
        this.removeEventListener('drop', $60111cd6ea196be2$var$onDrop);
        this.removeEventListener('paste', $60111cd6ea196be2$var$onPaste);
        this.removeEventListener('change', $60111cd6ea196be2$var$onChange);
    }
    get directory() {
        return this.hasAttribute('directory');
    }
    set directory(value) {
        if (value) this.setAttribute('directory', '');
        else this.removeAttribute('directory');
    }
    async attach(transferred) {
        const attachments = transferred instanceof DataTransfer ? await $60111cd6ea196be2$export$71e4db985cfcf9e3.traverse(transferred, this.directory) : $60111cd6ea196be2$export$71e4db985cfcf9e3.from(transferred);
        const accepted = this.dispatchEvent(new CustomEvent('file-attachment-accept', {
            bubbles: true,
            cancelable: true,
            detail: {
                attachments: attachments
            }
        }));
        if (accepted && attachments.length) this.dispatchEvent(new CustomEvent('file-attachment-accepted', {
            bubbles: true,
            detail: {
                attachments: attachments
            }
        }));
    }
}
function $60111cd6ea196be2$var$hasFile(transfer) {
    return Array.from(transfer.types).indexOf('Files') >= 0;
}
let $60111cd6ea196be2$var$dragging = null;
function $60111cd6ea196be2$var$onDragenter(event) {
    const target = event.currentTarget;
    if ($60111cd6ea196be2$var$dragging) clearTimeout($60111cd6ea196be2$var$dragging);
    $60111cd6ea196be2$var$dragging = window.setTimeout(()=>target.removeAttribute('hover'), 200);
    const transfer = event.dataTransfer;
    if (!transfer || !$60111cd6ea196be2$var$hasFile(transfer)) return;
    transfer.dropEffect = 'copy';
    target.setAttribute('hover', '');
    event.preventDefault();
}
function $60111cd6ea196be2$var$onDragleave(event) {
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'none';
    const target = event.currentTarget;
    target.removeAttribute('hover');
    event.stopPropagation();
    event.preventDefault();
}
function $60111cd6ea196be2$var$onDrop(event) {
    const container = event.currentTarget;
    if (!(container instanceof $60111cd6ea196be2$export$2e2bcd8739ae039)) return;
    container.removeAttribute('hover');
    const transfer = event.dataTransfer;
    if (!transfer || !$60111cd6ea196be2$var$hasFile(transfer)) return;
    container.attach(transfer);
    event.stopPropagation();
    event.preventDefault();
}
const $60111cd6ea196be2$var$images = /^image\/(gif|png|jpeg)$/;
function $60111cd6ea196be2$var$pastedFile(items) {
    for (const item of items){
        if (item.kind === 'file' && $60111cd6ea196be2$var$images.test(item.type)) return item.getAsFile();
    }
    return null;
}
function $60111cd6ea196be2$var$onPaste(event) {
    if (!event.clipboardData) return;
    if (!event.clipboardData.items) return;
    const container = event.currentTarget;
    if (!(container instanceof $60111cd6ea196be2$export$2e2bcd8739ae039)) return;
    const file = $60111cd6ea196be2$var$pastedFile(event.clipboardData.items);
    if (!file) return;
    const files = [
        file
    ];
    container.attach(files);
    event.preventDefault();
}
function $60111cd6ea196be2$var$onChange(event) {
    const container = event.currentTarget;
    if (!(container instanceof $60111cd6ea196be2$export$2e2bcd8739ae039)) return;
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    const id = container.getAttribute('input');
    if (id && input.id !== id) return;
    const files = input.files;
    if (!files || files.length === 0) return;
    container.attach(files);
    input.value = '';
}
if (!window.customElements.get('file-attachment')) {
    window.FileAttachmentElement = $60111cd6ea196be2$export$2e2bcd8739ae039;
    window.customElements.define('file-attachment', $60111cd6ea196be2$export$2e2bcd8739ae039);
}


class $4a0ea0d445e524c4$var$FilterInputElement extends HTMLElement {
    constructor(){
        super();
        this.currentQuery = null;
        this.filter = null;
        this.debounceInputChange = $4a0ea0d445e524c4$var$debounce(()=>$4a0ea0d445e524c4$var$filterResults(this, true));
        this.boundFilterResults = ()=>{
            $4a0ea0d445e524c4$var$filterResults(this, false);
        };
    }
    static get observedAttributes() {
        return [
            'aria-owns'
        ];
    }
    attributeChangedCallback(name, oldValue) {
        if (oldValue && name === 'aria-owns') $4a0ea0d445e524c4$var$filterResults(this, false);
    }
    connectedCallback() {
        const input = this.input;
        if (!input) return;
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('spellcheck', 'false');
        input.addEventListener('focus', this.boundFilterResults);
        input.addEventListener('change', this.boundFilterResults);
        input.addEventListener('input', this.debounceInputChange);
    }
    disconnectedCallback() {
        const input = this.input;
        if (!input) return;
        input.removeEventListener('focus', this.boundFilterResults);
        input.removeEventListener('change', this.boundFilterResults);
        input.removeEventListener('input', this.debounceInputChange);
    }
    get input() {
        const input = this.querySelector('input');
        return input instanceof HTMLInputElement ? input : null;
    }
    reset() {
        const input = this.input;
        if (input) {
            input.value = '';
            input.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        }
    }
}
async function $4a0ea0d445e524c4$var$filterResults(filterInput, checkCurrentQuery = false) {
    const input = filterInput.input;
    if (!input) return;
    const query = input.value.trim();
    const id = filterInput.getAttribute('aria-owns');
    if (!id) return;
    const container = document.getElementById(id);
    if (!container) return;
    const list = container.hasAttribute('data-filter-list') ? container : container.querySelector('[data-filter-list]');
    if (!list) return;
    filterInput.dispatchEvent(new CustomEvent('filter-input-start', {
        bubbles: true
    }));
    if (checkCurrentQuery && filterInput.currentQuery === query) return;
    filterInput.currentQuery = query;
    const filter = filterInput.filter || $4a0ea0d445e524c4$var$matchSubstring;
    const total = list.childElementCount;
    let count = 0;
    let hideNew = false;
    for (const item of Array.from(list.children)){
        if (!(item instanceof HTMLElement)) continue;
        const itemText = $4a0ea0d445e524c4$var$getText(item);
        const result = filter(item, itemText, query);
        if (result.hideNew === true) hideNew = result.hideNew;
        item.hidden = !result.match;
        if (result.match) count++;
    }
    const newItem = container.querySelector('[data-filter-new-item]');
    const showCreateOption = !!newItem && query.length > 0 && !hideNew;
    if (newItem instanceof HTMLElement) {
        newItem.hidden = !showCreateOption;
        if (showCreateOption) $4a0ea0d445e524c4$var$updateNewItem(newItem, query);
    }
    $4a0ea0d445e524c4$var$toggleBlankslate(container, count > 0 || showCreateOption);
    filterInput.dispatchEvent(new CustomEvent('filter-input-updated', {
        bubbles: true,
        detail: {
            count: count,
            total: total
        }
    }));
}
function $4a0ea0d445e524c4$var$matchSubstring(_item, itemText, query) {
    const match = itemText.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    return {
        match: match,
        hideNew: itemText === query
    };
}
function $4a0ea0d445e524c4$var$getText(filterableItem) {
    const target = filterableItem.querySelector('[data-filter-item-text]') || filterableItem;
    return (target.textContent || '').trim();
}
function $4a0ea0d445e524c4$var$updateNewItem(newItem, query) {
    const newItemText = newItem.querySelector('[data-filter-new-item-text]');
    if (newItemText) newItemText.textContent = query;
    const newItemValue = newItem.querySelector('[data-filter-new-item-value]');
    if (newItemValue instanceof HTMLInputElement || newItemValue instanceof HTMLButtonElement) newItemValue.value = query;
}
function $4a0ea0d445e524c4$var$toggleBlankslate(container, force) {
    const emptyState = container.querySelector('[data-filter-empty-state]');
    if (emptyState instanceof HTMLElement) emptyState.hidden = force;
}
function $4a0ea0d445e524c4$var$debounce(callback) {
    let timeout;
    return function() {
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            clearTimeout(timeout);
            callback();
        }, 300);
    };
}
var $4a0ea0d445e524c4$export$2e2bcd8739ae039 = $4a0ea0d445e524c4$var$FilterInputElement;
if (!window.customElements.get('filter-input')) {
    window.FilterInputElement = $4a0ea0d445e524c4$var$FilterInputElement;
    window.customElements.define('filter-input', $4a0ea0d445e524c4$var$FilterInputElement);
}


const $76c7154c799bf107$var$startPositions = new WeakMap();
const $76c7154c799bf107$var$dragStartPositions = new WeakMap();
const $76c7154c799bf107$var$constructedElements = new WeakMap();
function $76c7154c799bf107$var$moveCropArea(event) {
    const el = event.currentTarget;
    if (!(el instanceof $76c7154c799bf107$var$ImageCropElement)) return;
    const { box: box, image: image } = $76c7154c799bf107$var$constructedElements.get(el) || {};
    if (!box || !image) return;
    let deltaX = 0;
    let deltaY = 0;
    if (event instanceof KeyboardEvent) {
        if (event.key === 'ArrowUp') deltaY = -1;
        else if (event.key === 'ArrowDown') deltaY = 1;
        else if (event.key === 'ArrowLeft') deltaX = -1;
        else if (event.key === 'ArrowRight') deltaX = 1;
    } else if ($76c7154c799bf107$var$dragStartPositions.has(el) && event instanceof MouseEvent) {
        const pos = $76c7154c799bf107$var$dragStartPositions.get(el);
        deltaX = event.pageX - pos.dragStartX;
        deltaY = event.pageY - pos.dragStartY;
    } else if ($76c7154c799bf107$var$dragStartPositions.has(el) && event instanceof TouchEvent) {
        const { pageX: pageX, pageY: pageY } = event.changedTouches[0];
        const { dragStartX: dragStartX, dragStartY: dragStartY } = $76c7154c799bf107$var$dragStartPositions.get(el);
        deltaX = pageX - dragStartX;
        deltaY = pageY - dragStartY;
    }
    if (deltaX !== 0 || deltaY !== 0) {
        const x = Math.min(Math.max(0, box.offsetLeft + deltaX), image.width - box.offsetWidth);
        const y = Math.min(Math.max(0, box.offsetTop + deltaY), image.height - box.offsetHeight);
        box.style.left = `${x}px`;
        box.style.top = `${y}px`;
        $76c7154c799bf107$var$fireChangeEvent(el, {
            x: x,
            y: y,
            width: box.offsetWidth,
            height: box.offsetHeight
        });
    }
    if (event instanceof MouseEvent) $76c7154c799bf107$var$dragStartPositions.set(el, {
        dragStartX: event.pageX,
        dragStartY: event.pageY
    });
    else if (event instanceof TouchEvent) {
        const { pageX: pageX, pageY: pageY } = event.changedTouches[0];
        $76c7154c799bf107$var$dragStartPositions.set(el, {
            dragStartX: pageX,
            dragStartY: pageY
        });
    }
}
function $76c7154c799bf107$var$updateCropArea(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const el = $76c7154c799bf107$var$getShadowHost(target);
    if (!(el instanceof $76c7154c799bf107$var$ImageCropElement)) return;
    const { box: box } = $76c7154c799bf107$var$constructedElements.get(el) || {};
    if (!box) return;
    const rect = el.getBoundingClientRect();
    let deltaX, deltaY, delta;
    if (event instanceof KeyboardEvent) {
        if (event.key === 'Escape') return $76c7154c799bf107$var$setInitialPosition(el);
        if (event.key === '-') delta = -10;
        if (event.key === '=') delta = 10;
        if (!delta) return;
        deltaX = box.offsetWidth + delta;
        deltaY = box.offsetHeight + delta;
        $76c7154c799bf107$var$startPositions.set(el, {
            startX: box.offsetLeft,
            startY: box.offsetTop
        });
    } else if (event instanceof MouseEvent) {
        const pos = $76c7154c799bf107$var$startPositions.get(el);
        if (!pos) return;
        deltaX = event.pageX - pos.startX - rect.left - window.pageXOffset;
        deltaY = event.pageY - pos.startY - rect.top - window.pageYOffset;
    } else if (event instanceof TouchEvent) {
        const pos = $76c7154c799bf107$var$startPositions.get(el);
        if (!pos) return;
        deltaX = event.changedTouches[0].pageX - pos.startX - rect.left - window.pageXOffset;
        deltaY = event.changedTouches[0].pageY - pos.startY - rect.top - window.pageYOffset;
    }
    if (deltaX && deltaY) $76c7154c799bf107$var$updateDimensions(el, deltaX, deltaY, !(event instanceof KeyboardEvent));
}
function $76c7154c799bf107$var$getShadowHost(el) {
    const rootNode = el.getRootNode();
    if (!(rootNode instanceof ShadowRoot)) return el;
    return rootNode.host;
}
function $76c7154c799bf107$var$startUpdate(event) {
    const currentTarget = event.currentTarget;
    if (!(currentTarget instanceof HTMLElement)) return;
    const el = $76c7154c799bf107$var$getShadowHost(currentTarget);
    if (!(el instanceof $76c7154c799bf107$var$ImageCropElement)) return;
    const { box: box } = $76c7154c799bf107$var$constructedElements.get(el) || {};
    if (!box) return;
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.hasAttribute('data-direction')) {
        const direction = target.getAttribute('data-direction') || '';
        el.addEventListener('mousemove', $76c7154c799bf107$var$updateCropArea);
        el.addEventListener('touchmove', $76c7154c799bf107$var$updateCropArea, {
            passive: true
        });
        if ([
            'nw',
            'se'
        ].indexOf(direction) >= 0) el.classList.add('nwse');
        if ([
            'ne',
            'sw'
        ].indexOf(direction) >= 0) el.classList.add('nesw');
        $76c7154c799bf107$var$startPositions.set(el, {
            startX: box.offsetLeft + ([
                'se',
                'ne'
            ].indexOf(direction) >= 0 ? 0 : box.offsetWidth),
            startY: box.offsetTop + ([
                'se',
                'sw'
            ].indexOf(direction) >= 0 ? 0 : box.offsetHeight)
        });
        $76c7154c799bf107$var$updateCropArea(event);
    } else {
        el.addEventListener('mousemove', $76c7154c799bf107$var$moveCropArea);
        el.addEventListener('touchmove', $76c7154c799bf107$var$moveCropArea, {
            passive: true
        });
    }
}
function $76c7154c799bf107$var$updateDimensions(target, deltaX, deltaY, reposition = true) {
    let newSide = Math.max(Math.abs(deltaX), Math.abs(deltaY), 10);
    const pos = $76c7154c799bf107$var$startPositions.get(target);
    if (!pos) return;
    const { box: box, image: image } = $76c7154c799bf107$var$constructedElements.get(target) || {};
    if (!box || !image) return;
    newSide = Math.min(newSide, deltaY > 0 ? image.height - pos.startY : pos.startY, deltaX > 0 ? image.width - pos.startX : pos.startX);
    const x = reposition ? Math.round(Math.max(0, deltaX > 0 ? pos.startX : pos.startX - newSide)) : box.offsetLeft;
    const y = reposition ? Math.round(Math.max(0, deltaY > 0 ? pos.startY : pos.startY - newSide)) : box.offsetTop;
    box.style.left = `${x}px`;
    box.style.top = `${y}px`;
    box.style.width = `${newSide}px`;
    box.style.height = `${newSide}px`;
    $76c7154c799bf107$var$fireChangeEvent(target, {
        x: x,
        y: y,
        width: newSide,
        height: newSide
    });
}
function $76c7154c799bf107$var$setInitialPosition(el) {
    const { image: image } = $76c7154c799bf107$var$constructedElements.get(el) || {};
    if (!image) return;
    const side = Math.round(image.clientWidth > image.clientHeight ? image.clientHeight : image.clientWidth);
    $76c7154c799bf107$var$startPositions.set(el, {
        startX: (image.clientWidth - side) / 2,
        startY: (image.clientHeight - side) / 2
    });
    $76c7154c799bf107$var$updateDimensions(el, side, side);
}
function $76c7154c799bf107$var$stopUpdate(event) {
    const el = event.currentTarget;
    if (!(el instanceof $76c7154c799bf107$var$ImageCropElement)) return;
    $76c7154c799bf107$var$dragStartPositions.delete(el);
    el.classList.remove('nwse', 'nesw');
    el.removeEventListener('mousemove', $76c7154c799bf107$var$updateCropArea);
    el.removeEventListener('mousemove', $76c7154c799bf107$var$moveCropArea);
    el.removeEventListener('touchmove', $76c7154c799bf107$var$updateCropArea);
    el.removeEventListener('touchmove', $76c7154c799bf107$var$moveCropArea);
}
function $76c7154c799bf107$var$fireChangeEvent(target, result) {
    const { image: image } = $76c7154c799bf107$var$constructedElements.get(target) || {};
    if (!image) return;
    const ratio = image.naturalWidth / image.width;
    for(const key in result){
        const value = Math.round(result[key] * ratio);
        result[key] = value;
        const slottedInput = target.querySelector(`[data-image-crop-input='${key}']`);
        if (slottedInput instanceof HTMLInputElement) slottedInput.value = value.toString();
    }
    target.dispatchEvent(new CustomEvent('image-crop-change', {
        bubbles: true,
        detail: result
    }));
}
class $76c7154c799bf107$var$ImageCropElement extends HTMLElement {
    connectedCallback() {
        if ($76c7154c799bf107$var$constructedElements.has(this)) return;
        const shadowRoot = this.attachShadow({
            mode: 'open'
        });
        shadowRoot.innerHTML = `
<style>
  :host { touch-action: none; display: block; }
  :host(.nesw) { cursor: nesw-resize; }
  :host(.nwse) { cursor: nwse-resize; }
  :host(.nesw) .crop-box, :host(.nwse) .crop-box { cursor: inherit; }
  :host([loaded]) .crop-image { display: block; }
  :host([loaded]) ::slotted([data-loading-slot]), .crop-image { display: none; }

  .crop-wrapper {
    position: relative;
    font-size: 0;
  }
  .crop-container {
    user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    position: absolute;
    overflow: hidden;
    z-index: 1;
    top: 0;
    width: 100%;
    height: 100%;
  }

  :host([rounded]) .crop-box {
    border-radius: 50%;
    box-shadow: 0 0 0 4000px rgba(0, 0, 0, 0.3);
  }
  .crop-box {
    position: absolute;
    border: 1px dashed #fff;
    box-sizing: border-box;
    cursor: move;
  }

  :host([rounded]) .crop-outline {
    outline: none;
  }
  .crop-outline {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    outline: 4000px solid rgba(0, 0, 0, .3);
  }

  .handle { position: absolute; }
  :host([rounded]) .handle::before { border-radius: 50%; }
  .handle:before {
    position: absolute;
    display: block;
    padding: 4px;
    transform: translate(-50%, -50%);
    content: ' ';
    background: #fff;
    border: 1px solid #767676;
  }
  .ne { top: 0; right: 0; cursor: nesw-resize; }
  .nw { top: 0; left: 0; cursor: nwse-resize; }
  .se { bottom: 0; right: 0; cursor: nwse-resize; }
  .sw { bottom: 0; left: 0; cursor: nesw-resize; }
</style>
<slot></slot>
<div class="crop-wrapper">
  <img width="100%" class="crop-image" alt="">
  <div class="crop-container">
    <div data-crop-box class="crop-box">
      <div class="crop-outline"></div>
      <div data-direction="nw" class="handle nw"></div>
      <div data-direction="ne" class="handle ne"></div>
      <div data-direction="sw" class="handle sw"></div>
      <div data-direction="se" class="handle se"></div>
    </div>
  </div>
</div>
`;
        const box = shadowRoot.querySelector('[data-crop-box]');
        if (!(box instanceof HTMLElement)) return;
        const image = shadowRoot.querySelector('img');
        if (!(image instanceof HTMLImageElement)) return;
        $76c7154c799bf107$var$constructedElements.set(this, {
            box: box,
            image: image
        });
        image.addEventListener('load', ()=>{
            this.loaded = true;
            $76c7154c799bf107$var$setInitialPosition(this);
        });
        this.addEventListener('mouseleave', $76c7154c799bf107$var$stopUpdate);
        this.addEventListener('touchend', $76c7154c799bf107$var$stopUpdate);
        this.addEventListener('mouseup', $76c7154c799bf107$var$stopUpdate);
        box.addEventListener('mousedown', $76c7154c799bf107$var$startUpdate);
        box.addEventListener('touchstart', $76c7154c799bf107$var$startUpdate, {
            passive: true
        });
        this.addEventListener('keydown', $76c7154c799bf107$var$moveCropArea);
        this.addEventListener('keydown', $76c7154c799bf107$var$updateCropArea);
        if (this.src) image.src = this.src;
    }
    static get observedAttributes() {
        return [
            'src'
        ];
    }
    get src() {
        return this.getAttribute('src');
    }
    set src(val) {
        if (val) this.setAttribute('src', val);
        else this.removeAttribute('src');
    }
    get loaded() {
        return this.hasAttribute('loaded');
    }
    set loaded(val) {
        if (val) this.setAttribute('loaded', '');
        else this.removeAttribute('loaded');
    }
    attributeChangedCallback(attribute, oldValue, newValue) {
        const { image: image } = $76c7154c799bf107$var$constructedElements.get(this) || {};
        if (attribute === 'src') {
            this.loaded = false;
            if (image) image.src = newValue;
        }
    }
}
var $76c7154c799bf107$export$2e2bcd8739ae039 = $76c7154c799bf107$var$ImageCropElement;
if (!window.customElements.get('image-crop')) {
    window.ImageCropElement = $76c7154c799bf107$var$ImageCropElement;
    window.customElements.define('image-crop', $76c7154c799bf107$var$ImageCropElement);
}


var $e10f768813a7f4c9$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $e10f768813a7f4c9$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, $e10f768813a7f4c9$var$_IncludeFragmentElement_busy, $e10f768813a7f4c9$var$_IncludeFragmentElement_observer, $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData, $e10f768813a7f4c9$var$_IncludeFragmentElement_getData, $e10f768813a7f4c9$var$_IncludeFragmentElement_getStringOrErrorData, $e10f768813a7f4c9$var$_IncludeFragmentElement_task, $e10f768813a7f4c9$var$_IncludeFragmentElement_fetchDataWithEvents;
const $e10f768813a7f4c9$var$privateData = new WeakMap();
function $e10f768813a7f4c9$var$isWildcard(accept) {
    return accept && !!accept.split(',').find((x)=>x.match(/^\s*\*\/\*/));
}
let $e10f768813a7f4c9$var$cspTrustedTypesPolicyPromise = null;
class $e10f768813a7f4c9$export$65e04f6f22ddde0e extends HTMLElement {
    constructor(){
        super(...arguments);
        $e10f768813a7f4c9$var$_IncludeFragmentElement_instances.add(this);
        $e10f768813a7f4c9$var$_IncludeFragmentElement_busy.set(this, false);
        $e10f768813a7f4c9$var$_IncludeFragmentElement_observer.set(this, new IntersectionObserver((entries)=>{
            for (const entry of entries)if (entry.isIntersecting) {
                const { target: target } = entry;
                $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_observer, "f").unobserve(target);
                if (!(target instanceof $e10f768813a7f4c9$export$65e04f6f22ddde0e)) return;
                if (target.loading === 'lazy') $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData).call(this);
            }
        }, {
            rootMargin: '0px 0px 256px 0px',
            threshold: 0.01
        }));
    }
    static define(tag = 'include-fragment', registry = customElements) {
        registry.define(tag, this);
        return this;
    }
    static setCSPTrustedTypesPolicy(policy) {
        $e10f768813a7f4c9$var$cspTrustedTypesPolicyPromise = policy === null ? policy : Promise.resolve(policy);
    }
    static get observedAttributes() {
        return [
            'src',
            'loading'
        ];
    }
    get src() {
        const src = this.getAttribute('src');
        if (src) {
            const link = this.ownerDocument.createElement('a');
            link.href = src;
            return link.href;
        } else return '';
    }
    set src(val) {
        this.setAttribute('src', val);
    }
    get loading() {
        if (this.getAttribute('loading') === 'lazy') return 'lazy';
        return 'eager';
    }
    set loading(value) {
        this.setAttribute('loading', value);
    }
    get accept() {
        return this.getAttribute('accept') || '';
    }
    set accept(val) {
        this.setAttribute('accept', val);
    }
    get data() {
        return $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_getStringOrErrorData).call(this);
    }
    attributeChangedCallback(attribute, oldVal) {
        if (attribute === 'src') {
            if (this.isConnected && this.loading === 'eager') $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData).call(this);
        } else if (attribute === 'loading') {
            if (this.isConnected && oldVal !== 'eager' && this.loading === 'eager') $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData).call(this);
        }
    }
    connectedCallback() {
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: 'open'
            });
            const style = document.createElement('style');
            style.textContent = `:host {display: block;}`;
            this.shadowRoot.append(style, document.createElement('slot'));
        }
        if (this.src && this.loading === 'eager') $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData).call(this);
        if (this.loading === 'lazy') $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_observer, "f").observe(this);
    }
    request() {
        const src = this.src;
        if (!src) throw new Error('missing src');
        return new Request(src, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: this.accept || 'text/html'
            }
        });
    }
    load() {
        return $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_getStringOrErrorData).call(this);
    }
    fetch(request) {
        return fetch(request);
    }
    refetch() {
        $e10f768813a7f4c9$var$privateData.delete(this);
        $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData).call(this);
    }
}
$e10f768813a7f4c9$var$_IncludeFragmentElement_busy = new WeakMap(), $e10f768813a7f4c9$var$_IncludeFragmentElement_observer = new WeakMap(), $e10f768813a7f4c9$var$_IncludeFragmentElement_instances = new WeakSet(), $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData = async function _IncludeFragmentElement_handleData() {
    if ($e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_busy, "f")) return;
    $e10f768813a7f4c9$var$__classPrivateFieldSet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_busy, true, "f");
    $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_observer, "f").unobserve(this);
    try {
        const data = await $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_getData).call(this);
        if (data instanceof Error) throw data;
        const dataTreatedAsString = data;
        const template = document.createElement('template');
        template.innerHTML = dataTreatedAsString;
        const fragment = document.importNode(template.content, true);
        const canceled = !this.dispatchEvent(new CustomEvent('include-fragment-replace', {
            cancelable: true,
            detail: {
                fragment: fragment
            }
        }));
        if (canceled) {
            $e10f768813a7f4c9$var$__classPrivateFieldSet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_busy, false, "f");
            return;
        }
        this.replaceWith(fragment);
        this.dispatchEvent(new CustomEvent('include-fragment-replaced'));
    } catch (_a) {
        this.classList.add('is-error');
    } finally{
        $e10f768813a7f4c9$var$__classPrivateFieldSet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_busy, false, "f");
    }
}, $e10f768813a7f4c9$var$_IncludeFragmentElement_getData = async function _IncludeFragmentElement_getData() {
    const src = this.src;
    const cachedData = $e10f768813a7f4c9$var$privateData.get(this);
    if (cachedData && cachedData.src === src) return cachedData.data;
    else {
        let data;
        if (src) data = $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_fetchDataWithEvents).call(this);
        else data = Promise.reject(new Error('missing src'));
        $e10f768813a7f4c9$var$privateData.set(this, {
            src: src,
            data: data
        });
        return data;
    }
}, $e10f768813a7f4c9$var$_IncludeFragmentElement_getStringOrErrorData = async function _IncludeFragmentElement_getStringOrErrorData() {
    const data = await $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_getData).call(this);
    if (data instanceof Error) throw data;
    return data.toString();
}, $e10f768813a7f4c9$var$_IncludeFragmentElement_task = async function _IncludeFragmentElement_task(eventsToDispatch, error) {
    await new Promise((resolve)=>setTimeout(resolve, 0));
    for (const eventType of eventsToDispatch)this.dispatchEvent(error ? new CustomEvent(eventType, {
        detail: {
            error: error
        }
    }) : new Event(eventType));
}, $e10f768813a7f4c9$var$_IncludeFragmentElement_fetchDataWithEvents = async function _IncludeFragmentElement_fetchDataWithEvents() {
    try {
        await $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_task).call(this, [
            'loadstart'
        ]);
        const response = await this.fetch(this.request());
        const ct = response.headers.get('Content-Type');
        if (!$e10f768813a7f4c9$var$isWildcard(this.accept) && (!ct || !ct.includes(this.accept ? this.accept : 'text/html'))) throw new Error(`Failed to load resource: expected ${this.accept || 'text/html'} but was ${ct}`);
        if (response.status !== 200) throw new Error(`Failed to load resource: the server responded with a status of ${response.status}`);
        const responseText = await response.text();
        let data = responseText;
        if ($e10f768813a7f4c9$var$cspTrustedTypesPolicyPromise) {
            const cspTrustedTypesPolicy = await $e10f768813a7f4c9$var$cspTrustedTypesPolicyPromise;
            data = cspTrustedTypesPolicy.createHTML(responseText, response);
        }
        $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_task).call(this, [
            'load',
            'loadend'
        ]);
        return data;
    } catch (error) {
        $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_task).call(this, [
            'error',
            'loadend'
        ], error);
        throw error;
    }
};



const $9871d058a4ab7a2d$var$root = typeof globalThis !== 'undefined' ? globalThis : window;
try {
    $9871d058a4ab7a2d$var$root.IncludeFragmentElement = (0, $e10f768813a7f4c9$export$65e04f6f22ddde0e).define();
} catch (e) {
    if (!($9871d058a4ab7a2d$var$root.DOMException && e instanceof DOMException && e.name === 'NotSupportedError') && !(e instanceof ReferenceError)) throw e;
}
var $9871d058a4ab7a2d$export$2e2bcd8739ae039 = (0, $e10f768813a7f4c9$export$65e04f6f22ddde0e);


var $4941bdcfe743ed78$export$2e2bcd8739ae039 = (0, $e10f768813a7f4c9$export$65e04f6f22ddde0e);


var $cb3b1a5cab3c6120$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_instances, $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_setLevelStyle;
const $cb3b1a5cab3c6120$var$buttonSelectors = [
    '[data-md-button]',
    'md-header',
    'md-bold',
    'md-italic',
    'md-quote',
    'md-code',
    'md-link',
    'md-image',
    'md-unordered-list',
    'md-ordered-list',
    'md-task-list',
    'md-mention',
    'md-ref',
    'md-strikethrough'
];
function $cb3b1a5cab3c6120$var$getButtons(toolbar) {
    const els = [];
    for (const button of toolbar.querySelectorAll($cb3b1a5cab3c6120$var$buttonSelectors.join(', '))){
        if (button.hidden || button.offsetWidth <= 0 && button.offsetHeight <= 0) continue;
        if (button.closest('markdown-toolbar') === toolbar) els.push(button);
    }
    return els;
}
function $cb3b1a5cab3c6120$var$keydown(fn) {
    return function(event) {
        if (event.key === ' ' || event.key === 'Enter') fn(event);
    };
}
const $cb3b1a5cab3c6120$var$styles = new WeakMap();
const $cb3b1a5cab3c6120$var$manualStyles = {
    'header-1': {
        prefix: '# '
    },
    'header-2': {
        prefix: '## '
    },
    'header-3': {
        prefix: '### '
    },
    'header-4': {
        prefix: '#### '
    },
    'header-5': {
        prefix: '##### '
    },
    'header-6': {
        prefix: '###### '
    },
    bold: {
        prefix: '**',
        suffix: '**',
        trimFirst: true
    },
    italic: {
        prefix: '_',
        suffix: '_',
        trimFirst: true
    },
    quote: {
        prefix: '> ',
        multiline: true,
        surroundWithNewlines: true
    },
    code: {
        prefix: '`',
        suffix: '`',
        blockPrefix: '```',
        blockSuffix: '```'
    },
    link: {
        prefix: '[',
        suffix: '](url)',
        replaceNext: 'url',
        scanFor: 'https?://'
    },
    image: {
        prefix: '![',
        suffix: '](url)',
        replaceNext: 'url',
        scanFor: 'https?://'
    },
    'unordered-list': {
        prefix: '- ',
        multiline: true,
        unorderedList: true
    },
    'ordered-list': {
        prefix: '1. ',
        multiline: true,
        orderedList: true
    },
    'task-list': {
        prefix: '- [ ] ',
        multiline: true,
        surroundWithNewlines: true
    },
    mention: {
        prefix: '@',
        prefixSpace: true
    },
    ref: {
        prefix: '#',
        prefixSpace: true
    },
    strikethrough: {
        prefix: '~~',
        suffix: '~~',
        trimFirst: true
    }
};
class $cb3b1a5cab3c6120$var$MarkdownButtonElement extends HTMLElement {
    constructor(){
        super();
        const apply = (event)=>{
            const style = $cb3b1a5cab3c6120$var$styles.get(this);
            if (!style) return;
            event.preventDefault();
            $cb3b1a5cab3c6120$var$applyStyle(this, style);
        };
        this.addEventListener('keydown', $cb3b1a5cab3c6120$var$keydown(apply));
        this.addEventListener('click', apply);
    }
    connectedCallback() {
        if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
    }
    click() {
        const style = $cb3b1a5cab3c6120$var$styles.get(this);
        if (!style) return;
        $cb3b1a5cab3c6120$var$applyStyle(this, style);
    }
}
class $cb3b1a5cab3c6120$var$MarkdownHeaderButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    constructor(){
        super(...arguments);
        $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_instances.add(this);
    }
    connectedCallback() {
        const level = parseInt(this.getAttribute('level') || '3', 10);
        $cb3b1a5cab3c6120$var$__classPrivateFieldGet(this, $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_instances, "m", $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_setLevelStyle).call(this, level);
    }
    static get observedAttributes() {
        return [
            'level'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name !== 'level') return;
        const level = parseInt(newValue || '3', 10);
        $cb3b1a5cab3c6120$var$__classPrivateFieldGet(this, $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_instances, "m", $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_setLevelStyle).call(this, level);
    }
}
$cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_instances = new WeakSet(), $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_setLevelStyle = function _MarkdownHeaderButtonElement_setLevelStyle(level) {
    if (level < 1 || level > 6) return;
    const prefix = `${'#'.repeat(level)} `;
    $cb3b1a5cab3c6120$var$styles.set(this, {
        prefix: prefix
    });
};
if (!window.customElements.get('md-header')) {
    window.MarkdownHeaderButtonElement = $cb3b1a5cab3c6120$var$MarkdownHeaderButtonElement;
    window.customElements.define('md-header', $cb3b1a5cab3c6120$var$MarkdownHeaderButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownBoldButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: '**',
            suffix: '**',
            trimFirst: true
        });
    }
}
if (!window.customElements.get('md-bold')) {
    window.MarkdownBoldButtonElement = $cb3b1a5cab3c6120$var$MarkdownBoldButtonElement;
    window.customElements.define('md-bold', $cb3b1a5cab3c6120$var$MarkdownBoldButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownItalicButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: '_',
            suffix: '_',
            trimFirst: true
        });
    }
}
if (!window.customElements.get('md-italic')) {
    window.MarkdownItalicButtonElement = $cb3b1a5cab3c6120$var$MarkdownItalicButtonElement;
    window.customElements.define('md-italic', $cb3b1a5cab3c6120$var$MarkdownItalicButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownQuoteButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: '> ',
            multiline: true,
            surroundWithNewlines: true
        });
    }
}
if (!window.customElements.get('md-quote')) {
    window.MarkdownQuoteButtonElement = $cb3b1a5cab3c6120$var$MarkdownQuoteButtonElement;
    window.customElements.define('md-quote', $cb3b1a5cab3c6120$var$MarkdownQuoteButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownCodeButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: '`',
            suffix: '`',
            blockPrefix: '```',
            blockSuffix: '```'
        });
    }
}
if (!window.customElements.get('md-code')) {
    window.MarkdownCodeButtonElement = $cb3b1a5cab3c6120$var$MarkdownCodeButtonElement;
    window.customElements.define('md-code', $cb3b1a5cab3c6120$var$MarkdownCodeButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownLinkButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: '[',
            suffix: '](url)',
            replaceNext: 'url',
            scanFor: 'https?://'
        });
    }
}
if (!window.customElements.get('md-link')) {
    window.MarkdownLinkButtonElement = $cb3b1a5cab3c6120$var$MarkdownLinkButtonElement;
    window.customElements.define('md-link', $cb3b1a5cab3c6120$var$MarkdownLinkButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownImageButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: '![',
            suffix: '](url)',
            replaceNext: 'url',
            scanFor: 'https?://'
        });
    }
}
if (!window.customElements.get('md-image')) {
    window.MarkdownImageButtonElement = $cb3b1a5cab3c6120$var$MarkdownImageButtonElement;
    window.customElements.define('md-image', $cb3b1a5cab3c6120$var$MarkdownImageButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownUnorderedListButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: '- ',
            multiline: true,
            unorderedList: true
        });
    }
}
if (!window.customElements.get('md-unordered-list')) {
    window.MarkdownUnorderedListButtonElement = $cb3b1a5cab3c6120$var$MarkdownUnorderedListButtonElement;
    window.customElements.define('md-unordered-list', $cb3b1a5cab3c6120$var$MarkdownUnorderedListButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownOrderedListButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: '1. ',
            multiline: true,
            orderedList: true
        });
    }
}
if (!window.customElements.get('md-ordered-list')) {
    window.MarkdownOrderedListButtonElement = $cb3b1a5cab3c6120$var$MarkdownOrderedListButtonElement;
    window.customElements.define('md-ordered-list', $cb3b1a5cab3c6120$var$MarkdownOrderedListButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownTaskListButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: '- [ ] ',
            multiline: true,
            surroundWithNewlines: true
        });
    }
}
if (!window.customElements.get('md-task-list')) {
    window.MarkdownTaskListButtonElement = $cb3b1a5cab3c6120$var$MarkdownTaskListButtonElement;
    window.customElements.define('md-task-list', $cb3b1a5cab3c6120$var$MarkdownTaskListButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownMentionButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: '@',
            prefixSpace: true
        });
    }
}
if (!window.customElements.get('md-mention')) {
    window.MarkdownMentionButtonElement = $cb3b1a5cab3c6120$var$MarkdownMentionButtonElement;
    window.customElements.define('md-mention', $cb3b1a5cab3c6120$var$MarkdownMentionButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownRefButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: '#',
            prefixSpace: true
        });
    }
}
if (!window.customElements.get('md-ref')) {
    window.MarkdownRefButtonElement = $cb3b1a5cab3c6120$var$MarkdownRefButtonElement;
    window.customElements.define('md-ref', $cb3b1a5cab3c6120$var$MarkdownRefButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownStrikethroughButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: '~~',
            suffix: '~~',
            trimFirst: true
        });
    }
}
if (!window.customElements.get('md-strikethrough')) {
    window.MarkdownStrikethroughButtonElement = $cb3b1a5cab3c6120$var$MarkdownStrikethroughButtonElement;
    window.customElements.define('md-strikethrough', $cb3b1a5cab3c6120$var$MarkdownStrikethroughButtonElement);
}
function $cb3b1a5cab3c6120$var$applyFromToolbar(event) {
    const { target: target, currentTarget: currentTarget } = event;
    if (!(target instanceof Element)) return;
    const mdButton = target.closest('[data-md-button]');
    if (!mdButton || mdButton.closest('markdown-toolbar') !== currentTarget) return;
    const mdButtonStyle = mdButton.getAttribute('data-md-button');
    const style = $cb3b1a5cab3c6120$var$manualStyles[mdButtonStyle];
    if (!style) return;
    event.preventDefault();
    $cb3b1a5cab3c6120$var$applyStyle(target, style);
}
function $cb3b1a5cab3c6120$var$setFocusManagement(toolbar) {
    toolbar.addEventListener('keydown', $cb3b1a5cab3c6120$var$focusKeydown);
    toolbar.setAttribute('tabindex', '0');
    toolbar.addEventListener('focus', $cb3b1a5cab3c6120$var$onToolbarFocus, {
        once: true
    });
}
function $cb3b1a5cab3c6120$var$unsetFocusManagement(toolbar) {
    toolbar.removeEventListener('keydown', $cb3b1a5cab3c6120$var$focusKeydown);
    toolbar.removeAttribute('tabindex');
    toolbar.removeEventListener('focus', $cb3b1a5cab3c6120$var$onToolbarFocus);
}
class $cb3b1a5cab3c6120$var$MarkdownToolbarElement extends HTMLElement {
    connectedCallback() {
        if (!this.hasAttribute('role')) this.setAttribute('role', 'toolbar');
        if (!this.hasAttribute('data-no-focus')) $cb3b1a5cab3c6120$var$setFocusManagement(this);
        this.addEventListener('keydown', $cb3b1a5cab3c6120$var$keydown($cb3b1a5cab3c6120$var$applyFromToolbar));
        this.addEventListener('click', $cb3b1a5cab3c6120$var$applyFromToolbar);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name !== 'data-no-focus') return;
        if (newValue === null) $cb3b1a5cab3c6120$var$setFocusManagement(this);
        else $cb3b1a5cab3c6120$var$unsetFocusManagement(this);
    }
    disconnectedCallback() {
        $cb3b1a5cab3c6120$var$unsetFocusManagement(this);
    }
    get field() {
        const id = this.getAttribute('for');
        if (!id) return null;
        const root = 'getRootNode' in this ? this.getRootNode() : document;
        let field;
        if (root instanceof Document || root instanceof ShadowRoot) field = root.getElementById(id);
        return field instanceof HTMLTextAreaElement ? field : null;
    }
}
$cb3b1a5cab3c6120$var$MarkdownToolbarElement.observedAttributes = [
    'data-no-focus'
];
function $cb3b1a5cab3c6120$var$onToolbarFocus({ target: target }) {
    if (!(target instanceof Element)) return;
    target.removeAttribute('tabindex');
    let tabindex = '0';
    for (const button of $cb3b1a5cab3c6120$var$getButtons(target)){
        button.setAttribute('tabindex', tabindex);
        if (tabindex === '0') {
            button.focus();
            tabindex = '-1';
        }
    }
}
function $cb3b1a5cab3c6120$var$focusKeydown(event) {
    const key = event.key;
    if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Home' && key !== 'End') return;
    const toolbar = event.currentTarget;
    if (!(toolbar instanceof HTMLElement)) return;
    const buttons = $cb3b1a5cab3c6120$var$getButtons(toolbar);
    const index = buttons.indexOf(event.target);
    const length = buttons.length;
    if (index === -1) return;
    let n = 0;
    if (key === 'ArrowLeft') n = index - 1;
    if (key === 'ArrowRight') n = index + 1;
    if (key === 'End') n = length - 1;
    if (n < 0) n = length - 1;
    if (n > length - 1) n = 0;
    for(let i = 0; i < length; i += 1)buttons[i].setAttribute('tabindex', i === n ? '0' : '-1');
    event.preventDefault();
    buttons[n].focus();
}
if (!window.customElements.get('markdown-toolbar')) {
    window.MarkdownToolbarElement = $cb3b1a5cab3c6120$var$MarkdownToolbarElement;
    window.customElements.define('markdown-toolbar', $cb3b1a5cab3c6120$var$MarkdownToolbarElement);
}
function $cb3b1a5cab3c6120$var$isMultipleLines(string) {
    return string.trim().split('\n').length > 1;
}
function $cb3b1a5cab3c6120$var$repeat(string, n) {
    return Array(n + 1).join(string);
}
function $cb3b1a5cab3c6120$var$wordSelectionStart(text, i) {
    let index = i;
    while(text[index] && text[index - 1] != null && !text[index - 1].match(/\s/))index--;
    return index;
}
function $cb3b1a5cab3c6120$var$wordSelectionEnd(text, i, multiline) {
    let index = i;
    const breakpoint = multiline ? /\n/ : /\s/;
    while(text[index] && !text[index].match(breakpoint))index++;
    return index;
}
let $cb3b1a5cab3c6120$var$canInsertText = null;
function $cb3b1a5cab3c6120$var$insertText(textarea, { text: text, selectionStart: selectionStart, selectionEnd: selectionEnd }) {
    const originalSelectionStart = textarea.selectionStart;
    const before = textarea.value.slice(0, originalSelectionStart);
    const after = textarea.value.slice(textarea.selectionEnd);
    if ($cb3b1a5cab3c6120$var$canInsertText === null || $cb3b1a5cab3c6120$var$canInsertText === true) {
        textarea.contentEditable = 'true';
        try {
            $cb3b1a5cab3c6120$var$canInsertText = document.execCommand('insertText', false, text);
        } catch (error) {
            $cb3b1a5cab3c6120$var$canInsertText = false;
        }
        textarea.contentEditable = 'false';
    }
    if ($cb3b1a5cab3c6120$var$canInsertText && !textarea.value.slice(0, textarea.selectionStart).endsWith(text)) $cb3b1a5cab3c6120$var$canInsertText = false;
    if (!$cb3b1a5cab3c6120$var$canInsertText) {
        try {
            document.execCommand('ms-beginUndoUnit');
        } catch (e) {}
        textarea.value = before + text + after;
        try {
            document.execCommand('ms-endUndoUnit');
        } catch (e) {}
        textarea.dispatchEvent(new CustomEvent('input', {
            bubbles: true,
            cancelable: true
        }));
    }
    if (selectionStart != null && selectionEnd != null) textarea.setSelectionRange(selectionStart, selectionEnd);
    else textarea.setSelectionRange(originalSelectionStart, textarea.selectionEnd);
}
function $cb3b1a5cab3c6120$var$styleSelectedText(textarea, styleArgs) {
    const text = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
    let result;
    if (styleArgs.orderedList || styleArgs.unorderedList) result = $cb3b1a5cab3c6120$var$listStyle(textarea, styleArgs);
    else if (styleArgs.multiline && $cb3b1a5cab3c6120$var$isMultipleLines(text)) result = $cb3b1a5cab3c6120$var$multilineStyle(textarea, styleArgs);
    else result = $cb3b1a5cab3c6120$var$blockStyle(textarea, styleArgs);
    $cb3b1a5cab3c6120$var$insertText(textarea, result);
}
function $cb3b1a5cab3c6120$var$expandSelectionToLine(textarea) {
    const lines = textarea.value.split('\n');
    let counter = 0;
    for(let index = 0; index < lines.length; index++){
        const lineLength = lines[index].length + 1;
        if (textarea.selectionStart >= counter && textarea.selectionStart < counter + lineLength) textarea.selectionStart = counter;
        if (textarea.selectionEnd >= counter && textarea.selectionEnd < counter + lineLength) textarea.selectionEnd = counter + lineLength - 1;
        counter += lineLength;
    }
}
function $cb3b1a5cab3c6120$var$expandSelectedText(textarea, prefixToUse, suffixToUse, multiline = false) {
    if (textarea.selectionStart === textarea.selectionEnd) {
        textarea.selectionStart = $cb3b1a5cab3c6120$var$wordSelectionStart(textarea.value, textarea.selectionStart);
        textarea.selectionEnd = $cb3b1a5cab3c6120$var$wordSelectionEnd(textarea.value, textarea.selectionEnd, multiline);
    } else {
        const expandedSelectionStart = textarea.selectionStart - prefixToUse.length;
        const expandedSelectionEnd = textarea.selectionEnd + suffixToUse.length;
        const beginsWithPrefix = textarea.value.slice(expandedSelectionStart, textarea.selectionStart) === prefixToUse;
        const endsWithSuffix = textarea.value.slice(textarea.selectionEnd, expandedSelectionEnd) === suffixToUse;
        if (beginsWithPrefix && endsWithSuffix) {
            textarea.selectionStart = expandedSelectionStart;
            textarea.selectionEnd = expandedSelectionEnd;
        }
    }
    return textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
}
function $cb3b1a5cab3c6120$var$newlinesToSurroundSelectedText(textarea) {
    const beforeSelection = textarea.value.slice(0, textarea.selectionStart);
    const afterSelection = textarea.value.slice(textarea.selectionEnd);
    const breaksBefore = beforeSelection.match(/\n*$/);
    const breaksAfter = afterSelection.match(/^\n*/);
    const newlinesBeforeSelection = breaksBefore ? breaksBefore[0].length : 0;
    const newlinesAfterSelection = breaksAfter ? breaksAfter[0].length : 0;
    let newlinesToAppend;
    let newlinesToPrepend;
    if (beforeSelection.match(/\S/) && newlinesBeforeSelection < 2) newlinesToAppend = $cb3b1a5cab3c6120$var$repeat('\n', 2 - newlinesBeforeSelection);
    if (afterSelection.match(/\S/) && newlinesAfterSelection < 2) newlinesToPrepend = $cb3b1a5cab3c6120$var$repeat('\n', 2 - newlinesAfterSelection);
    if (newlinesToAppend == null) newlinesToAppend = '';
    if (newlinesToPrepend == null) newlinesToPrepend = '';
    return {
        newlinesToAppend: newlinesToAppend,
        newlinesToPrepend: newlinesToPrepend
    };
}
function $cb3b1a5cab3c6120$var$blockStyle(textarea, arg) {
    let newlinesToAppend;
    let newlinesToPrepend;
    const { prefix: prefix, suffix: suffix, blockPrefix: blockPrefix, blockSuffix: blockSuffix, replaceNext: replaceNext, prefixSpace: prefixSpace, scanFor: scanFor, surroundWithNewlines: surroundWithNewlines } = arg;
    const originalSelectionStart = textarea.selectionStart;
    const originalSelectionEnd = textarea.selectionEnd;
    let selectedText = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
    let prefixToUse = $cb3b1a5cab3c6120$var$isMultipleLines(selectedText) && blockPrefix.length > 0 ? `${blockPrefix}\n` : prefix;
    let suffixToUse = $cb3b1a5cab3c6120$var$isMultipleLines(selectedText) && blockSuffix.length > 0 ? `\n${blockSuffix}` : suffix;
    if (prefixSpace) {
        const beforeSelection = textarea.value[textarea.selectionStart - 1];
        if (textarea.selectionStart !== 0 && beforeSelection != null && !beforeSelection.match(/\s/)) prefixToUse = ` ${prefixToUse}`;
    }
    selectedText = $cb3b1a5cab3c6120$var$expandSelectedText(textarea, prefixToUse, suffixToUse, arg.multiline);
    let selectionStart = textarea.selectionStart;
    let selectionEnd = textarea.selectionEnd;
    const hasReplaceNext = replaceNext.length > 0 && suffixToUse.indexOf(replaceNext) > -1 && selectedText.length > 0;
    if (surroundWithNewlines) {
        const ref = $cb3b1a5cab3c6120$var$newlinesToSurroundSelectedText(textarea);
        newlinesToAppend = ref.newlinesToAppend;
        newlinesToPrepend = ref.newlinesToPrepend;
        prefixToUse = newlinesToAppend + prefix;
        suffixToUse += newlinesToPrepend;
    }
    if (selectedText.startsWith(prefixToUse) && selectedText.endsWith(suffixToUse)) {
        const replacementText = selectedText.slice(prefixToUse.length, selectedText.length - suffixToUse.length);
        if (originalSelectionStart === originalSelectionEnd) {
            let position = originalSelectionStart - prefixToUse.length;
            position = Math.max(position, selectionStart);
            position = Math.min(position, selectionStart + replacementText.length);
            selectionStart = selectionEnd = position;
        } else selectionEnd = selectionStart + replacementText.length;
        return {
            text: replacementText,
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        };
    } else if (!hasReplaceNext) {
        let replacementText = prefixToUse + selectedText + suffixToUse;
        selectionStart = originalSelectionStart + prefixToUse.length;
        selectionEnd = originalSelectionEnd + prefixToUse.length;
        const whitespaceEdges = selectedText.match(/^\s*|\s*$/g);
        if (arg.trimFirst && whitespaceEdges) {
            const leadingWhitespace = whitespaceEdges[0] || '';
            const trailingWhitespace = whitespaceEdges[1] || '';
            replacementText = leadingWhitespace + prefixToUse + selectedText.trim() + suffixToUse + trailingWhitespace;
            selectionStart += leadingWhitespace.length;
            selectionEnd -= trailingWhitespace.length;
        }
        return {
            text: replacementText,
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        };
    } else if (scanFor.length > 0 && selectedText.match(scanFor)) {
        suffixToUse = suffixToUse.replace(replaceNext, selectedText);
        const replacementText = prefixToUse + suffixToUse;
        selectionStart = selectionEnd = selectionStart + prefixToUse.length;
        return {
            text: replacementText,
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        };
    } else {
        const replacementText = prefixToUse + selectedText + suffixToUse;
        selectionStart = selectionStart + prefixToUse.length + selectedText.length + suffixToUse.indexOf(replaceNext);
        selectionEnd = selectionStart + replaceNext.length;
        return {
            text: replacementText,
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        };
    }
}
function $cb3b1a5cab3c6120$var$multilineStyle(textarea, arg) {
    const { prefix: prefix, suffix: suffix, surroundWithNewlines: surroundWithNewlines } = arg;
    let text = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
    let selectionStart = textarea.selectionStart;
    let selectionEnd = textarea.selectionEnd;
    const lines = text.split('\n');
    const undoStyle = lines.every((line)=>line.startsWith(prefix) && line.endsWith(suffix));
    if (undoStyle) {
        text = lines.map((line)=>line.slice(prefix.length, line.length - suffix.length)).join('\n');
        selectionEnd = selectionStart + text.length;
    } else {
        text = lines.map((line)=>prefix + line + suffix).join('\n');
        if (surroundWithNewlines) {
            const { newlinesToAppend: newlinesToAppend, newlinesToPrepend: newlinesToPrepend } = $cb3b1a5cab3c6120$var$newlinesToSurroundSelectedText(textarea);
            selectionStart += newlinesToAppend.length;
            selectionEnd = selectionStart + text.length;
            text = newlinesToAppend + text + newlinesToPrepend;
        }
    }
    return {
        text: text,
        selectionStart: selectionStart,
        selectionEnd: selectionEnd
    };
}
function $cb3b1a5cab3c6120$var$undoOrderedListStyle(text) {
    const lines = text.split('\n');
    const orderedListRegex = /^\d+\.\s+/;
    const shouldUndoOrderedList = lines.every((line)=>orderedListRegex.test(line));
    let result = lines;
    if (shouldUndoOrderedList) result = lines.map((line)=>line.replace(orderedListRegex, ''));
    return {
        text: result.join('\n'),
        processed: shouldUndoOrderedList
    };
}
function $cb3b1a5cab3c6120$var$undoUnorderedListStyle(text) {
    const lines = text.split('\n');
    const unorderedListPrefix = '- ';
    const shouldUndoUnorderedList = lines.every((line)=>line.startsWith(unorderedListPrefix));
    let result = lines;
    if (shouldUndoUnorderedList) result = lines.map((line)=>line.slice(unorderedListPrefix.length, line.length));
    return {
        text: result.join('\n'),
        processed: shouldUndoUnorderedList
    };
}
function $cb3b1a5cab3c6120$var$makePrefix(index, unorderedList) {
    if (unorderedList) return '- ';
    else return `${index + 1}. `;
}
function $cb3b1a5cab3c6120$var$clearExistingListStyle(style, selectedText) {
    let undoResultOpositeList;
    let undoResult;
    let pristineText;
    if (style.orderedList) {
        undoResult = $cb3b1a5cab3c6120$var$undoOrderedListStyle(selectedText);
        undoResultOpositeList = $cb3b1a5cab3c6120$var$undoUnorderedListStyle(undoResult.text);
        pristineText = undoResultOpositeList.text;
    } else {
        undoResult = $cb3b1a5cab3c6120$var$undoUnorderedListStyle(selectedText);
        undoResultOpositeList = $cb3b1a5cab3c6120$var$undoOrderedListStyle(undoResult.text);
        pristineText = undoResultOpositeList.text;
    }
    return [
        undoResult,
        undoResultOpositeList,
        pristineText
    ];
}
function $cb3b1a5cab3c6120$var$listStyle(textarea, style) {
    const noInitialSelection = textarea.selectionStart === textarea.selectionEnd;
    let selectionStart = textarea.selectionStart;
    let selectionEnd = textarea.selectionEnd;
    $cb3b1a5cab3c6120$var$expandSelectionToLine(textarea);
    const selectedText = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
    const [undoResult, undoResultOpositeList, pristineText] = $cb3b1a5cab3c6120$var$clearExistingListStyle(style, selectedText);
    const prefixedLines = pristineText.split('\n').map((value, index)=>{
        return `${$cb3b1a5cab3c6120$var$makePrefix(index, style.unorderedList)}${value}`;
    });
    const totalPrefixLength = prefixedLines.reduce((previousValue, _currentValue, currentIndex)=>{
        return previousValue + $cb3b1a5cab3c6120$var$makePrefix(currentIndex, style.unorderedList).length;
    }, 0);
    const totalPrefixLengthOpositeList = prefixedLines.reduce((previousValue, _currentValue, currentIndex)=>{
        return previousValue + $cb3b1a5cab3c6120$var$makePrefix(currentIndex, !style.unorderedList).length;
    }, 0);
    if (undoResult.processed) {
        if (noInitialSelection) {
            selectionStart = Math.max(selectionStart - $cb3b1a5cab3c6120$var$makePrefix(0, style.unorderedList).length, 0);
            selectionEnd = selectionStart;
        } else {
            selectionStart = textarea.selectionStart;
            selectionEnd = textarea.selectionEnd - totalPrefixLength;
        }
        return {
            text: pristineText,
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        };
    }
    const { newlinesToAppend: newlinesToAppend, newlinesToPrepend: newlinesToPrepend } = $cb3b1a5cab3c6120$var$newlinesToSurroundSelectedText(textarea);
    const text = newlinesToAppend + prefixedLines.join('\n') + newlinesToPrepend;
    if (noInitialSelection) {
        selectionStart = Math.max(selectionStart + $cb3b1a5cab3c6120$var$makePrefix(0, style.unorderedList).length + newlinesToAppend.length, 0);
        selectionEnd = selectionStart;
    } else if (undoResultOpositeList.processed) {
        selectionStart = Math.max(textarea.selectionStart + newlinesToAppend.length, 0);
        selectionEnd = textarea.selectionEnd + newlinesToAppend.length + totalPrefixLength - totalPrefixLengthOpositeList;
    } else {
        selectionStart = Math.max(textarea.selectionStart + newlinesToAppend.length, 0);
        selectionEnd = textarea.selectionEnd + newlinesToAppend.length + totalPrefixLength;
    }
    return {
        text: text,
        selectionStart: selectionStart,
        selectionEnd: selectionEnd
    };
}
function $cb3b1a5cab3c6120$var$applyStyle(button, stylesToApply) {
    const toolbar = button.closest('markdown-toolbar');
    if (!(toolbar instanceof $cb3b1a5cab3c6120$var$MarkdownToolbarElement)) return;
    const defaults = {
        prefix: '',
        suffix: '',
        blockPrefix: '',
        blockSuffix: '',
        multiline: false,
        replaceNext: '',
        prefixSpace: false,
        scanFor: '',
        surroundWithNewlines: false,
        orderedList: false,
        unorderedList: false,
        trimFirst: false
    };
    const style = Object.assign(Object.assign({}, defaults), stylesToApply);
    const field = toolbar.field;
    if (field) {
        field.focus();
        $cb3b1a5cab3c6120$var$styleSelectedText(field, style);
    }
}
var $cb3b1a5cab3c6120$export$2e2bcd8739ae039 = $cb3b1a5cab3c6120$var$MarkdownToolbarElement;


var $ce0ee8f7f5614b6f$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ce0ee8f7f5614b6f$var$_LRUCache_map;
class $ce0ee8f7f5614b6f$var$LRUCache {
    constructor(max = 100){
        this.max = max;
        $ce0ee8f7f5614b6f$var$_LRUCache_map.set(this, new Map());
    }
    get(key) {
        const value = $ce0ee8f7f5614b6f$var$__classPrivateFieldGet(this, $ce0ee8f7f5614b6f$var$_LRUCache_map, "f").get(key);
        if (value !== undefined) {
            $ce0ee8f7f5614b6f$var$__classPrivateFieldGet(this, $ce0ee8f7f5614b6f$var$_LRUCache_map, "f").delete(key);
            $ce0ee8f7f5614b6f$var$__classPrivateFieldGet(this, $ce0ee8f7f5614b6f$var$_LRUCache_map, "f").set(key, value);
        }
        return value;
    }
    set(key, value) {
        $ce0ee8f7f5614b6f$var$__classPrivateFieldGet(this, $ce0ee8f7f5614b6f$var$_LRUCache_map, "f").delete(key);
        $ce0ee8f7f5614b6f$var$__classPrivateFieldGet(this, $ce0ee8f7f5614b6f$var$_LRUCache_map, "f").set(key, value);
        if ($ce0ee8f7f5614b6f$var$__classPrivateFieldGet(this, $ce0ee8f7f5614b6f$var$_LRUCache_map, "f").size > this.max) $ce0ee8f7f5614b6f$var$__classPrivateFieldGet(this, $ce0ee8f7f5614b6f$var$_LRUCache_map, "f").delete($ce0ee8f7f5614b6f$var$__classPrivateFieldGet(this, $ce0ee8f7f5614b6f$var$_LRUCache_map, "f").keys().next().value);
    }
    clear() {
        $ce0ee8f7f5614b6f$var$__classPrivateFieldGet(this, $ce0ee8f7f5614b6f$var$_LRUCache_map, "f").clear();
    }
}
$ce0ee8f7f5614b6f$var$_LRUCache_map = new WeakMap();
const $ce0ee8f7f5614b6f$var$registeredCaches = [];
function $ce0ee8f7f5614b6f$export$cf6fa0bbcc94b912(max) {
    const cache = new $ce0ee8f7f5614b6f$var$LRUCache(max);
    $ce0ee8f7f5614b6f$var$registeredCaches.push(cache);
    return cache;
}
function $ce0ee8f7f5614b6f$export$9ee92367e3462176() {
    for (const cache of $ce0ee8f7f5614b6f$var$registeredCaches)cache.clear();
}
if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') window.addEventListener('languagechange', $ce0ee8f7f5614b6f$export$9ee92367e3462176);
function $ce0ee8f7f5614b6f$var$cacheKey(locale, options) {
    return `${locale}\u0000${options ? JSON.stringify(options) : ''}`;
}
const $ce0ee8f7f5614b6f$var$dateTimeFormats = $ce0ee8f7f5614b6f$export$cf6fa0bbcc94b912();
function $ce0ee8f7f5614b6f$export$b434509d4a847712(locale, options) {
    const key = $ce0ee8f7f5614b6f$var$cacheKey(locale, options);
    let format = $ce0ee8f7f5614b6f$var$dateTimeFormats.get(key);
    if (!format) $ce0ee8f7f5614b6f$var$dateTimeFormats.set(key, format = new Intl.DateTimeFormat(locale, options));
    return format;
}
const $ce0ee8f7f5614b6f$var$relativeTimeFormats = $ce0ee8f7f5614b6f$export$cf6fa0bbcc94b912();
function $ce0ee8f7f5614b6f$export$87c7871fd3ccba48(locale, options) {
    const key = $ce0ee8f7f5614b6f$var$cacheKey(locale, options);
    let format = $ce0ee8f7f5614b6f$var$relativeTimeFormats.get(key);
    if (!format) $ce0ee8f7f5614b6f$var$relativeTimeFormats.set(key, format = new Intl.RelativeTimeFormat(locale, options));
    return format;
}
const $ce0ee8f7f5614b6f$var$numberFormats = $ce0ee8f7f5614b6f$export$cf6fa0bbcc94b912();
function $ce0ee8f7f5614b6f$export$688d13a530c5dcbc(locale, options) {
    const key = $ce0ee8f7f5614b6f$var$cacheKey(locale, options);
    let format = $ce0ee8f7f5614b6f$var$numberFormats.get(key);
    if (!format) $ce0ee8f7f5614b6f$var$numberFormats.set(key, format = new Intl.NumberFormat(locale, options));
    return format;
}
const $ce0ee8f7f5614b6f$var$locales = $ce0ee8f7f5614b6f$export$cf6fa0bbcc94b912();
function $ce0ee8f7f5614b6f$export$180605366c04f0cd(tag) {
    let value = $ce0ee8f7f5614b6f$var$locales.get(tag);
    if (!value) $ce0ee8f7f5614b6f$var$locales.set(tag, value = new Intl.Locale(tag));
    return value;
}


var $996dd9e14abad76e$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $996dd9e14abad76e$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $996dd9e14abad76e$var$_DurationFormat_options;
class $996dd9e14abad76e$var$ListFormatPonyFill {
    formatToParts(members) {
        const parts = [];
        for (const value of members){
            parts.push({
                type: 'element',
                value: value
            });
            parts.push({
                type: 'literal',
                value: ', '
            });
        }
        return parts.slice(0, -1);
    }
}
const $996dd9e14abad76e$var$ListFormat = typeof Intl !== 'undefined' && Intl.ListFormat || $996dd9e14abad76e$var$ListFormatPonyFill;
const $996dd9e14abad76e$var$listFormats = (0, $ce0ee8f7f5614b6f$export$cf6fa0bbcc94b912)();
function $996dd9e14abad76e$var$listFormat(locale, options) {
    const key = `${locale}\u0000${JSON.stringify(options)}`;
    let format = $996dd9e14abad76e$var$listFormats.get(key);
    if (!format) $996dd9e14abad76e$var$listFormats.set(key, format = new $996dd9e14abad76e$var$ListFormat(locale, options));
    return format;
}
const $996dd9e14abad76e$var$partsTable = [
    [
        'years',
        'year'
    ],
    [
        'months',
        'month'
    ],
    [
        'weeks',
        'week'
    ],
    [
        'days',
        'day'
    ],
    [
        'hours',
        'hour'
    ],
    [
        'minutes',
        'minute'
    ],
    [
        'seconds',
        'second'
    ],
    [
        'milliseconds',
        'millisecond'
    ]
];
const $996dd9e14abad76e$var$twoDigitFormatOptions = {
    minimumIntegerDigits: 2
};
class $996dd9e14abad76e$export$2e2bcd8739ae039 {
    constructor(locale, options = {}){
        $996dd9e14abad76e$var$_DurationFormat_options.set(this, void 0);
        let style = String(options.style || 'short');
        if (style !== 'long' && style !== 'short' && style !== 'narrow' && style !== 'digital') style = 'short';
        let prevStyle = style === 'digital' ? 'numeric' : style;
        const hours = options.hours || prevStyle;
        prevStyle = hours === '2-digit' ? 'numeric' : hours;
        const minutes = options.minutes || prevStyle;
        prevStyle = minutes === '2-digit' ? 'numeric' : minutes;
        const seconds = options.seconds || prevStyle;
        prevStyle = seconds === '2-digit' ? 'numeric' : seconds;
        const milliseconds = options.milliseconds || prevStyle;
        $996dd9e14abad76e$var$__classPrivateFieldSet(this, $996dd9e14abad76e$var$_DurationFormat_options, {
            locale: locale,
            style: style,
            years: options.years || style === 'digital' ? 'short' : style,
            yearsDisplay: options.yearsDisplay === 'always' ? 'always' : 'auto',
            months: options.months || style === 'digital' ? 'short' : style,
            monthsDisplay: options.monthsDisplay === 'always' ? 'always' : 'auto',
            weeks: options.weeks || style === 'digital' ? 'short' : style,
            weeksDisplay: options.weeksDisplay === 'always' ? 'always' : 'auto',
            days: options.days || style === 'digital' ? 'short' : style,
            daysDisplay: options.daysDisplay === 'always' ? 'always' : 'auto',
            hours: hours,
            hoursDisplay: options.hoursDisplay === 'always' ? 'always' : style === 'digital' ? 'always' : 'auto',
            minutes: minutes,
            minutesDisplay: options.minutesDisplay === 'always' ? 'always' : style === 'digital' ? 'always' : 'auto',
            seconds: seconds,
            secondsDisplay: options.secondsDisplay === 'always' ? 'always' : style === 'digital' ? 'always' : 'auto',
            milliseconds: milliseconds,
            millisecondsDisplay: options.millisecondsDisplay === 'always' ? 'always' : 'auto'
        }, "f");
    }
    resolvedOptions() {
        return $996dd9e14abad76e$var$__classPrivateFieldGet(this, $996dd9e14abad76e$var$_DurationFormat_options, "f");
    }
    formatToParts(duration) {
        const list = [];
        const options = $996dd9e14abad76e$var$__classPrivateFieldGet(this, $996dd9e14abad76e$var$_DurationFormat_options, "f");
        const style = options.style;
        const locale = options.locale;
        for (const [unit, nfUnit] of $996dd9e14abad76e$var$partsTable){
            const value = duration[unit];
            if (options[`${unit}Display`] === 'auto' && !value) continue;
            const unitStyle = options[unit];
            const nfOpts = unitStyle === '2-digit' ? $996dd9e14abad76e$var$twoDigitFormatOptions : unitStyle === 'numeric' ? {} : {
                style: 'unit',
                unit: nfUnit,
                unitDisplay: unitStyle
            };
            let formattedValue = (0, $ce0ee8f7f5614b6f$export$688d13a530c5dcbc)(locale, nfOpts).format(value);
            if (unit === 'months' && (unitStyle === 'narrow' || style === 'narrow' && formattedValue.endsWith('m'))) formattedValue = formattedValue.replace(/(\d+)m$/, '$1mo');
            list.push(formattedValue);
        }
        return $996dd9e14abad76e$var$listFormat(locale, {
            type: 'unit',
            style: style === 'digital' ? 'short' : style
        }).formatToParts(list);
    }
    format(duration) {
        return this.formatToParts(duration).map((p)=>p.value).join('');
    }
}
$996dd9e14abad76e$var$_DurationFormat_options = new WeakMap();



const $b25b272eec4d4cd0$var$durationRe = /^[-+]?P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?$/;
const $b25b272eec4d4cd0$var$durationFormats = (0, $ce0ee8f7f5614b6f$export$cf6fa0bbcc94b912)();
const $b25b272eec4d4cd0$var$durationFormatOptionFields = [
    'style',
    'years',
    'yearsDisplay',
    'months',
    'monthsDisplay',
    'weeks',
    'weeksDisplay',
    'days',
    'daysDisplay',
    'hours',
    'hoursDisplay',
    'minutes',
    'minutesDisplay',
    'seconds',
    'secondsDisplay',
    'milliseconds',
    'millisecondsDisplay'
];
function $b25b272eec4d4cd0$var$durationFormatKey(locale, opts) {
    var _a;
    let key = locale;
    for (const field of $b25b272eec4d4cd0$var$durationFormatOptionFields)key += `\u0000${(_a = opts[field]) !== null && _a !== void 0 ? _a : ''}`;
    return key;
}
const $b25b272eec4d4cd0$export$ab2b613392a6a176 = [
    'year',
    'month',
    'week',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
const $b25b272eec4d4cd0$export$757a451204d10ad6 = (str)=>$b25b272eec4d4cd0$var$durationRe.test(str);
class $b25b272eec4d4cd0$export$3b11bc38611c5941 {
    constructor(years = 0, months = 0, weeks = 0, days = 0, hours = 0, minutes = 0, seconds = 0, milliseconds = 0){
        this.years = years;
        this.months = months;
        this.weeks = weeks;
        this.days = days;
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = seconds;
        this.milliseconds = milliseconds;
        this.years || (this.years = 0);
        this.sign || (this.sign = Math.sign(this.years));
        this.months || (this.months = 0);
        this.sign || (this.sign = Math.sign(this.months));
        this.weeks || (this.weeks = 0);
        this.sign || (this.sign = Math.sign(this.weeks));
        this.days || (this.days = 0);
        this.sign || (this.sign = Math.sign(this.days));
        this.hours || (this.hours = 0);
        this.sign || (this.sign = Math.sign(this.hours));
        this.minutes || (this.minutes = 0);
        this.sign || (this.sign = Math.sign(this.minutes));
        this.seconds || (this.seconds = 0);
        this.sign || (this.sign = Math.sign(this.seconds));
        this.milliseconds || (this.milliseconds = 0);
        this.sign || (this.sign = Math.sign(this.milliseconds));
        this.blank = this.sign === 0;
    }
    abs() {
        return new $b25b272eec4d4cd0$export$3b11bc38611c5941(Math.abs(this.years), Math.abs(this.months), Math.abs(this.weeks), Math.abs(this.days), Math.abs(this.hours), Math.abs(this.minutes), Math.abs(this.seconds), Math.abs(this.milliseconds));
    }
    static from(durationLike) {
        var _a;
        if (typeof durationLike === 'string') {
            const str = String(durationLike).trim();
            const factor = str.startsWith('-') ? -1 : 1;
            const parsed = (_a = str.match($b25b272eec4d4cd0$var$durationRe)) === null || _a === void 0 ? void 0 : _a.slice(1).map((x)=>(Number(x) || 0) * factor);
            if (!parsed) return new $b25b272eec4d4cd0$export$3b11bc38611c5941();
            return new $b25b272eec4d4cd0$export$3b11bc38611c5941(...parsed);
        } else if (typeof durationLike === 'object') {
            const { years: years, months: months, weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds, milliseconds: milliseconds } = durationLike;
            return new $b25b272eec4d4cd0$export$3b11bc38611c5941(years, months, weeks, days, hours, minutes, seconds, milliseconds);
        }
        throw new RangeError('invalid duration');
    }
    static compare(one, two) {
        const now = Date.now();
        const oneApplied = Math.abs($b25b272eec4d4cd0$export$ba4b4889be7cd2f0(now, $b25b272eec4d4cd0$export$3b11bc38611c5941.from(one)).getTime() - now);
        const twoApplied = Math.abs($b25b272eec4d4cd0$export$ba4b4889be7cd2f0(now, $b25b272eec4d4cd0$export$3b11bc38611c5941.from(two)).getTime() - now);
        return oneApplied > twoApplied ? -1 : oneApplied < twoApplied ? 1 : 0;
    }
    toLocaleString(locale, opts) {
        const key = $b25b272eec4d4cd0$var$durationFormatKey(locale, opts);
        let format = $b25b272eec4d4cd0$var$durationFormats.get(key);
        if (!format) $b25b272eec4d4cd0$var$durationFormats.set(key, format = new (0, $996dd9e14abad76e$export$2e2bcd8739ae039)(locale, opts));
        return format.format(this);
    }
}
function $b25b272eec4d4cd0$export$ba4b4889be7cd2f0(date, duration) {
    const r = new Date(date);
    if (duration.sign < 0) {
        r.setUTCSeconds(r.getUTCSeconds() + duration.seconds);
        r.setUTCMinutes(r.getUTCMinutes() + duration.minutes);
        r.setUTCHours(r.getUTCHours() + duration.hours);
        r.setUTCDate(r.getUTCDate() + duration.weeks * 7 + duration.days);
        r.setUTCMonth(r.getUTCMonth() + duration.months);
        r.setUTCFullYear(r.getUTCFullYear() + duration.years);
    } else {
        r.setUTCFullYear(r.getUTCFullYear() + duration.years);
        r.setUTCMonth(r.getUTCMonth() + duration.months);
        r.setUTCDate(r.getUTCDate() + duration.weeks * 7 + duration.days);
        r.setUTCHours(r.getUTCHours() + duration.hours);
        r.setUTCMinutes(r.getUTCMinutes() + duration.minutes);
        r.setUTCSeconds(r.getUTCSeconds() + duration.seconds);
    }
    return r;
}
function $b25b272eec4d4cd0$export$1ea91570c695dfb2(date, precision = 'second', now = Date.now()) {
    const delta = date.getTime() - now;
    if (delta === 0) return new $b25b272eec4d4cd0$export$3b11bc38611c5941();
    const sign = Math.sign(delta);
    const ms = Math.abs(delta);
    const sec = Math.floor(ms / 1000);
    const min = Math.floor(sec / 60);
    const hr = Math.floor(min / 60);
    const day = Math.floor(hr / 24);
    const month = Math.floor(day / 30);
    const year = Math.floor(month / 12);
    const i = $b25b272eec4d4cd0$export$ab2b613392a6a176.indexOf(precision);
    return new $b25b272eec4d4cd0$export$3b11bc38611c5941(i >= 0 ? year * sign : 0, i >= 1 ? (month - year * 12) * sign : 0, 0, i >= 3 ? (day - month * 30) * sign : 0, i >= 4 ? (hr - day * 24) * sign : 0, i >= 5 ? (min - hr * 60) * sign : 0, i >= 6 ? (sec - min * 60) * sign : 0, i >= 7 ? (ms - sec * 1000) * sign : 0);
}
function $b25b272eec4d4cd0$export$56623f543516c50f(duration, { relativeTo: relativeTo = Date.now() } = {}) {
    relativeTo = new Date(relativeTo);
    if (duration.blank) return duration;
    const sign = duration.sign;
    let years = Math.abs(duration.years);
    let months = Math.abs(duration.months);
    let weeks = Math.abs(duration.weeks);
    let days = Math.abs(duration.days);
    let hours = Math.abs(duration.hours);
    let minutes = Math.abs(duration.minutes);
    let seconds = Math.abs(duration.seconds);
    let milliseconds = Math.abs(duration.milliseconds);
    if (milliseconds >= 900) seconds += Math.round(milliseconds / 1000);
    if (seconds || minutes || hours || days || weeks || months || years) milliseconds = 0;
    if (seconds >= 55) minutes += Math.round(seconds / 60);
    if (minutes || hours || days || weeks || months || years) seconds = 0;
    if (minutes >= 55) hours += Math.round(minutes / 60);
    if (hours || days || weeks || months || years) minutes = 0;
    if (days && hours >= 12) days += Math.round(hours / 24);
    if (!days && hours >= 21) days += Math.round(hours / 24);
    if (days || weeks || months || years) hours = 0;
    const currentYear = relativeTo.getFullYear();
    const currentMonth = relativeTo.getMonth();
    const currentDate = relativeTo.getDate();
    if (days >= 27 || years + months + days) {
        const newMonthDate = new Date(relativeTo);
        newMonthDate.setDate(1);
        newMonthDate.setMonth(currentMonth + months * sign + 1);
        newMonthDate.setDate(0);
        const monthDateCorrection = Math.max(0, currentDate - newMonthDate.getDate());
        const newDate = new Date(relativeTo);
        newDate.setFullYear(currentYear + years * sign);
        newDate.setDate(currentDate - monthDateCorrection);
        newDate.setMonth(currentMonth + months * sign);
        newDate.setDate(currentDate - monthDateCorrection + days * sign);
        const yearDiff = newDate.getFullYear() - relativeTo.getFullYear();
        const monthDiff = newDate.getMonth() - relativeTo.getMonth();
        const daysDiff = Math.abs(Math.round((Number(newDate) - Number(relativeTo)) / 86400000)) + monthDateCorrection;
        const monthsDiff = Math.abs(yearDiff * 12 + monthDiff);
        if (daysDiff < 27) {
            if (days >= 6) {
                weeks += Math.round(days / 7);
                days = 0;
            } else days = daysDiff;
            months = years = 0;
        } else if (monthsDiff <= 11) {
            months = monthsDiff;
            years = 0;
        } else {
            months = 0;
            years = yearDiff * sign;
        }
        if (months || years) days = 0;
    }
    if (years) months = 0;
    if (weeks >= 4) months += Math.round(weeks / 4);
    if (months || years) weeks = 0;
    if (days && weeks && !months && !years) {
        weeks += Math.round(days / 7);
        days = 0;
    }
    return new $b25b272eec4d4cd0$export$3b11bc38611c5941(years * sign, months * sign, weeks * sign, days * sign, hours * sign, minutes * sign, seconds * sign, milliseconds * sign);
}
function $b25b272eec4d4cd0$export$d2cb509fe1f5058d(duration, opts) {
    const rounded = $b25b272eec4d4cd0$export$56623f543516c50f(duration, opts);
    if (rounded.blank) return [
        0,
        'second'
    ];
    for (const unit of $b25b272eec4d4cd0$export$ab2b613392a6a176){
        if (unit === 'millisecond') continue;
        const val = rounded[`${unit}s`];
        if (val) return [
            val,
            unit
        ];
    }
    return [
        0,
        'second'
    ];
}



var $03ae7077c712265a$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $03ae7077c712265a$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $03ae7077c712265a$var$_RelativeTimeElement_instances, $03ae7077c712265a$var$_RelativeTimeElement_customTitle, $03ae7077c712265a$var$_RelativeTimeElement_updating, $03ae7077c712265a$var$_RelativeTimeElement_lang_get, $03ae7077c712265a$var$_RelativeTimeElement_renderRoot, $03ae7077c712265a$var$_RelativeTimeElement_getFormattedTitle, $03ae7077c712265a$var$_RelativeTimeElement_getExplicitThreshold, $03ae7077c712265a$var$_RelativeTimeElement_resolveFormat, $03ae7077c712265a$var$_RelativeTimeElement_getMicroDuration, $03ae7077c712265a$var$_RelativeTimeElement_getMicroRelativeFormat, $03ae7077c712265a$var$_RelativeTimeElement_getDurationFormat, $03ae7077c712265a$var$_RelativeTimeElement_getRelativeFormat, $03ae7077c712265a$var$_RelativeTimeElement_getDateTimeFormat, $03ae7077c712265a$var$_RelativeTimeElement_isToday, $03ae7077c712265a$var$_RelativeTimeElement_isCurrentYear, $03ae7077c712265a$var$_RelativeTimeElement_getUserPreferredAbsoluteTimeFormat, $03ae7077c712265a$var$_RelativeTimeElement_updateRenderRootContent, $03ae7077c712265a$var$_RelativeTimeElement_shouldDisplayUserPreferredAbsoluteTime, $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated;
const $03ae7077c712265a$var$HTMLElement = globalThis.HTMLElement || null;
const $03ae7077c712265a$var$emptyDuration = new (0, $b25b272eec4d4cd0$export$3b11bc38611c5941)();
const $03ae7077c712265a$var$microEmptyDuration = new (0, $b25b272eec4d4cd0$export$3b11bc38611c5941)(0, 0, 0, 0, 0, 1);
class $03ae7077c712265a$export$1d6cc3abc67a5072 extends Event {
    constructor(oldText, newText, oldTitle, newTitle){
        super('relative-time-updated', {
            bubbles: true,
            composed: true
        });
        this.oldText = oldText;
        this.newText = newText;
        this.oldTitle = oldTitle;
        this.newTitle = newTitle;
    }
}
function $03ae7077c712265a$var$getUnitFactor(el) {
    const date = el.date;
    if (!date) return Infinity;
    const now = Date.now();
    if (el.format === 'duration' || el.format === 'elapsed') {
        const precision = el.precision;
        if (precision === 'second') return 1000;
        else if (precision === 'minute') return 60000;
    }
    const ms = Math.abs(now - date.getTime());
    let factor = 3600000;
    if (ms < 60000) factor = 1000;
    else if (ms < 3600000) factor = 60000;
    const threshold = $03ae7077c712265a$var$getExplicitThreshold(el);
    if (el.format === 'micro' && threshold) {
        const thresholdDuration = (0, $b25b272eec4d4cd0$export$3b11bc38611c5941).from(threshold);
        const signedThresholdDuration = date.getTime() > now ? $03ae7077c712265a$var$negateDuration(thresholdDuration) : thresholdDuration;
        const thresholdTime = (0, $b25b272eec4d4cd0$export$ba4b4889be7cd2f0)(date, signedThresholdDuration).getTime();
        const msUntilThreshold = thresholdTime - now;
        if (msUntilThreshold > 0) factor = Math.min(factor, msUntilThreshold);
    }
    return factor;
}
function $03ae7077c712265a$var$negateDuration(duration) {
    return new (0, $b25b272eec4d4cd0$export$3b11bc38611c5941)(-duration.years, -duration.months, -duration.weeks, -duration.days, -duration.hours, -duration.minutes, -duration.seconds, -duration.milliseconds);
}
function $03ae7077c712265a$var$getExplicitThreshold(el) {
    const threshold = el.getAttribute('threshold');
    return threshold && (0, $b25b272eec4d4cd0$export$757a451204d10ad6)(threshold) ? threshold : null;
}
let $03ae7077c712265a$var$browser12hCycle;
function $03ae7077c712265a$var$isBrowser12hCycle() {
    if ($03ae7077c712265a$var$browser12hCycle === undefined) try {
        $03ae7077c712265a$var$browser12hCycle = new Intl.DateTimeFormat([], {
            hour: 'numeric'
        }).resolvedOptions().hour12 === true;
    } catch (_a) {
        $03ae7077c712265a$var$browser12hCycle = false;
    }
    return $03ae7077c712265a$var$browser12hCycle;
}
if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') window.addEventListener('languagechange', ()=>{
    $03ae7077c712265a$var$browser12hCycle = undefined;
});
const $03ae7077c712265a$var$dateObserver = new class {
    constructor(){
        this.elements = new Set();
        this.time = Infinity;
        this.updating = false;
        this.timer = -1;
    }
    observe(element) {
        this.elements.add(element);
        if (this.updating) return;
        const date = element.date;
        if (date && date.getTime()) {
            const ms = $03ae7077c712265a$var$getUnitFactor(element);
            const time = Date.now() + ms;
            if (time < this.time || this.time <= Date.now()) {
                clearTimeout(this.timer);
                this.timer = setTimeout(()=>this.update(), ms);
                this.time = time;
            }
        }
    }
    unobserve(element) {
        if (!this.elements.has(element)) return;
        this.elements.delete(element);
    }
    update() {
        clearTimeout(this.timer);
        if (!this.elements.size) return;
        let nearestDistance = Infinity;
        this.updating = true;
        try {
            for (const timeEl of this.elements){
                nearestDistance = Math.min(nearestDistance, $03ae7077c712265a$var$getUnitFactor(timeEl));
                timeEl.update();
            }
        } finally{
            this.updating = false;
        }
        this.time = Math.min(3600000, nearestDistance);
        this.timer = setTimeout(()=>this.update(), this.time);
        this.time += Date.now();
    }
}();
class $03ae7077c712265a$export$8f5d2bd03530cdd0 extends $03ae7077c712265a$var$HTMLElement {
    constructor(){
        super(...arguments);
        $03ae7077c712265a$var$_RelativeTimeElement_instances.add(this);
        $03ae7077c712265a$var$_RelativeTimeElement_customTitle.set(this, false);
        $03ae7077c712265a$var$_RelativeTimeElement_updating.set(this, false);
        $03ae7077c712265a$var$_RelativeTimeElement_renderRoot.set(this, this.shadowRoot ? this.shadowRoot : this.attachShadow ? this.attachShadow({
            mode: 'open'
        }) : this);
        $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated.set(this, null);
    }
    static define(tag = 'relative-time', registry = customElements) {
        registry.define(tag, this);
        return this;
    }
    get timeZone() {
        var _a;
        const tz = ((_a = this.closest('[time-zone]')) === null || _a === void 0 ? void 0 : _a.getAttribute('time-zone')) || this.ownerDocument.documentElement.getAttribute('time-zone');
        return tz || undefined;
    }
    get hourCycle() {
        var _a;
        const hc = ((_a = this.closest('[hour-cycle]')) === null || _a === void 0 ? void 0 : _a.getAttribute('hour-cycle')) || this.ownerDocument.documentElement.getAttribute('hour-cycle');
        if (hc === 'h11' || hc === 'h12' || hc === 'h23' || hc === 'h24') return hc;
        return $03ae7077c712265a$var$isBrowser12hCycle() ? 'h12' : 'h23';
    }
    static get observedAttributes() {
        return [
            'second',
            'minute',
            'hour',
            'weekday',
            'day',
            'month',
            'year',
            'time-zone-name',
            'prefix',
            'threshold',
            'tense',
            'precision',
            'format',
            'format-style',
            'no-title',
            'datetime',
            'lang',
            'title',
            'aria-hidden',
            'time-zone',
            'hour-cycle'
        ];
    }
    get onRelativeTimeUpdated() {
        return $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated, "f");
    }
    set onRelativeTimeUpdated(listener) {
        if ($03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated, "f")) this.removeEventListener('relative-time-updated', $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated, "f"));
        $03ae7077c712265a$var$__classPrivateFieldSet(this, $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated, typeof listener === 'object' || typeof listener === 'function' ? listener : null, "f");
        if (typeof listener === 'function') this.addEventListener('relative-time-updated', listener);
    }
    get second() {
        const second = this.getAttribute('second');
        if (second === 'numeric' || second === '2-digit') return second;
    }
    set second(value) {
        this.setAttribute('second', value || '');
    }
    get minute() {
        const minute = this.getAttribute('minute');
        if (minute === 'numeric' || minute === '2-digit') return minute;
    }
    set minute(value) {
        this.setAttribute('minute', value || '');
    }
    get hour() {
        const hour = this.getAttribute('hour');
        if (hour === 'numeric' || hour === '2-digit') return hour;
    }
    set hour(value) {
        this.setAttribute('hour', value || '');
    }
    get weekday() {
        const weekday = this.getAttribute('weekday');
        if (weekday === 'long' || weekday === 'short' || weekday === 'narrow') return weekday;
        if (this.format === 'datetime' && weekday !== '') return this.formatStyle;
    }
    set weekday(value) {
        this.setAttribute('weekday', value || '');
    }
    get day() {
        var _a;
        const day = (_a = this.getAttribute('day')) !== null && _a !== void 0 ? _a : 'numeric';
        if (day === 'numeric' || day === '2-digit') return day;
    }
    set day(value) {
        this.setAttribute('day', value || '');
    }
    get month() {
        const format = this.format;
        let month = this.getAttribute('month');
        if (month === '') return;
        month !== null && month !== void 0 ? month : month = format === 'datetime' ? this.formatStyle : 'short';
        if (month === 'numeric' || month === '2-digit' || month === 'short' || month === 'long' || month === 'narrow') return month;
    }
    set month(value) {
        this.setAttribute('month', value || '');
    }
    get year() {
        var _a;
        const year = this.getAttribute('year');
        if (year === 'numeric' || year === '2-digit') return year;
        if (!this.hasAttribute('year') && new Date().getUTCFullYear() !== ((_a = this.date) === null || _a === void 0 ? void 0 : _a.getUTCFullYear())) return 'numeric';
    }
    set year(value) {
        this.setAttribute('year', value || '');
    }
    get timeZoneName() {
        const name = this.getAttribute('time-zone-name');
        if (name === 'long' || name === 'short' || name === 'shortOffset' || name === 'longOffset' || name === 'shortGeneric' || name === 'longGeneric') return name;
    }
    set timeZoneName(value) {
        this.setAttribute('time-zone-name', value || '');
    }
    get prefix() {
        var _a;
        return (_a = this.getAttribute('prefix')) !== null && _a !== void 0 ? _a : this.format === 'datetime' ? '' : 'on';
    }
    set prefix(value) {
        this.setAttribute('prefix', value);
    }
    get threshold() {
        const threshold = this.getAttribute('threshold');
        return threshold && (0, $b25b272eec4d4cd0$export$757a451204d10ad6)(threshold) ? threshold : 'P30D';
    }
    set threshold(value) {
        this.setAttribute('threshold', value);
    }
    get tense() {
        const tense = this.getAttribute('tense');
        if (tense === 'past') return 'past';
        if (tense === 'future') return 'future';
        return 'auto';
    }
    set tense(value) {
        this.setAttribute('tense', value);
    }
    get precision() {
        const precision = this.getAttribute('precision');
        if ((0, $b25b272eec4d4cd0$export$ab2b613392a6a176).includes(precision)) return precision;
        if (this.format === 'micro') return 'minute';
        return 'second';
    }
    set precision(value) {
        this.setAttribute('precision', value);
    }
    get format() {
        const format = this.getAttribute('format');
        if (format === 'datetime') return 'datetime';
        if (format === 'relative') return 'relative';
        if (format === 'duration') return 'duration';
        if (format === 'micro') return 'micro';
        if (format === 'elapsed') return 'elapsed';
        return 'auto';
    }
    set format(value) {
        this.setAttribute('format', value);
    }
    get formatStyle() {
        const formatStyle = this.getAttribute('format-style');
        if (formatStyle === 'long') return 'long';
        if (formatStyle === 'short') return 'short';
        if (formatStyle === 'narrow') return 'narrow';
        const format = this.format;
        if (format === 'elapsed' || format === 'micro') return 'narrow';
        if (format === 'datetime') return 'short';
        return 'long';
    }
    set formatStyle(value) {
        this.setAttribute('format-style', value);
    }
    get noTitle() {
        return this.hasAttribute('no-title');
    }
    set noTitle(value) {
        this.toggleAttribute('no-title', value);
    }
    get datetime() {
        return this.getAttribute('datetime') || '';
    }
    set datetime(value) {
        this.setAttribute('datetime', value);
    }
    get date() {
        const parsed = Date.parse(this.datetime);
        return Number.isNaN(parsed) ? null : new Date(parsed);
    }
    set date(value) {
        this.datetime = (value === null || value === void 0 ? void 0 : value.toISOString()) || '';
    }
    connectedCallback() {
        this.update();
    }
    disconnectedCallback() {
        $03ae7077c712265a$var$dateObserver.unobserve(this);
    }
    attributeChangedCallback(attrName, oldValue, newValue) {
        if (oldValue === newValue) return;
        if (attrName === 'title') $03ae7077c712265a$var$__classPrivateFieldSet(this, $03ae7077c712265a$var$_RelativeTimeElement_customTitle, newValue !== null && (this.date && $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getFormattedTitle).call(this, this.date, $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "a", $03ae7077c712265a$var$_RelativeTimeElement_lang_get), this.timeZone, this.hourCycle)) !== newValue, "f");
        if (!$03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_updating, "f") && !(attrName === 'title' && $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_customTitle, "f"))) $03ae7077c712265a$var$__classPrivateFieldSet(this, $03ae7077c712265a$var$_RelativeTimeElement_updating, (async ()=>{
            await Promise.resolve();
            this.update();
            $03ae7077c712265a$var$__classPrivateFieldSet(this, $03ae7077c712265a$var$_RelativeTimeElement_updating, false, "f");
        })(), "f");
    }
    update() {
        const oldText = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_renderRoot, "f").textContent || this.textContent || '';
        const oldTitle = this.getAttribute('title') || '';
        let newTitle = oldTitle;
        const date = this.date;
        if (typeof Intl === 'undefined' || !Intl.DateTimeFormat || !date) {
            $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_renderRoot, "f").textContent = oldText;
            return;
        }
        const now = Date.now();
        const locale = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "a", $03ae7077c712265a$var$_RelativeTimeElement_lang_get);
        const timeZone = this.timeZone;
        const hourCycle = this.hourCycle;
        if (!$03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_customTitle, "f")) {
            newTitle = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getFormattedTitle).call(this, date, locale, timeZone, hourCycle) || '';
            if (newTitle && !this.noTitle && newTitle !== oldTitle) this.setAttribute('title', newTitle);
        }
        const duration = (0, $b25b272eec4d4cd0$export$1ea91570c695dfb2)(date, this.precision, now);
        const format = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_resolveFormat).call(this, duration, (0, $b25b272eec4d4cd0$export$1ea91570c695dfb2)(date, 'millisecond', now));
        let newText = oldText;
        const displayUserPreferredAbsoluteTime = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_shouldDisplayUserPreferredAbsoluteTime).call(this, format);
        if (displayUserPreferredAbsoluteTime) newText = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getUserPreferredAbsoluteTimeFormat).call(this, date, locale, timeZone, hourCycle);
        else {
            if (format === 'duration') {
                if (this.format === 'micro' && this.tense !== 'auto' && Intl.RelativeTimeFormat) newText = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getMicroRelativeFormat).call(this, duration, locale);
                else newText = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getDurationFormat).call(this, duration, locale);
            } else if (format === 'relative') newText = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getRelativeFormat).call(this, duration, locale);
            else newText = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getDateTimeFormat).call(this, date, locale, timeZone, hourCycle);
        }
        if (newText) $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_updateRenderRootContent).call(this, newText);
        else if (this.shadowRoot === $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_renderRoot, "f") && this.textContent) $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_updateRenderRootContent).call(this, this.textContent);
        if (newText !== oldText || newTitle !== oldTitle) this.dispatchEvent(new $03ae7077c712265a$export$1d6cc3abc67a5072(oldText, newText, oldTitle, newTitle));
        const shouldObserve = !displayUserPreferredAbsoluteTime && (format === 'relative' || format === 'duration') || this.format === 'micro' && Boolean($03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getExplicitThreshold).call(this)) && date.getTime() > now || displayUserPreferredAbsoluteTime && ($03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_isToday).call(this, date, locale, timeZone) || $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_isCurrentYear).call(this, date, locale, timeZone));
        if (shouldObserve) $03ae7077c712265a$var$dateObserver.observe(this);
        else $03ae7077c712265a$var$dateObserver.unobserve(this);
    }
}
$03ae7077c712265a$var$_RelativeTimeElement_customTitle = new WeakMap(), $03ae7077c712265a$var$_RelativeTimeElement_updating = new WeakMap(), $03ae7077c712265a$var$_RelativeTimeElement_renderRoot = new WeakMap(), $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated = new WeakMap(), $03ae7077c712265a$var$_RelativeTimeElement_instances = new WeakSet(), $03ae7077c712265a$var$_RelativeTimeElement_lang_get = function _RelativeTimeElement_lang_get() {
    var _a;
    const lang = ((_a = this.closest('[lang]')) === null || _a === void 0 ? void 0 : _a.getAttribute('lang')) || this.ownerDocument.documentElement.getAttribute('lang');
    if (!lang) return 'default';
    try {
        return (0, $ce0ee8f7f5614b6f$export$180605366c04f0cd)(lang).toString();
    } catch (_b) {
        return 'default';
    }
}, $03ae7077c712265a$var$_RelativeTimeElement_getFormattedTitle = function _RelativeTimeElement_getFormattedTitle(date, locale, timeZone, hourCycle) {
    return (0, $ce0ee8f7f5614b6f$export$b434509d4a847712)(locale, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short',
        timeZone: timeZone,
        hourCycle: hourCycle
    }).format(date);
}, $03ae7077c712265a$var$_RelativeTimeElement_getExplicitThreshold = function _RelativeTimeElement_getExplicitThreshold() {
    return $03ae7077c712265a$var$getExplicitThreshold(this);
}, $03ae7077c712265a$var$_RelativeTimeElement_resolveFormat = function _RelativeTimeElement_resolveFormat(duration, thresholdDuration = duration) {
    const format = this.format;
    if (format === 'datetime') return 'datetime';
    if (format === 'duration') return 'duration';
    if (format === 'elapsed') return 'duration';
    if (format === 'micro') {
        const threshold = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getExplicitThreshold).call(this);
        if (threshold && (0, $b25b272eec4d4cd0$export$3b11bc38611c5941).compare(thresholdDuration, threshold) === -1) return 'datetime';
        return 'duration';
    }
    if ((format === 'auto' || format === 'relative') && typeof Intl !== 'undefined' && Intl.RelativeTimeFormat) {
        const tense = this.tense;
        if (tense === 'past' || tense === 'future') return 'relative';
        if ((0, $b25b272eec4d4cd0$export$3b11bc38611c5941).compare(duration, this.threshold) === 1) return 'relative';
    }
    return 'datetime';
}, $03ae7077c712265a$var$_RelativeTimeElement_getMicroDuration = function _RelativeTimeElement_getMicroDuration(duration) {
    duration = (0, $b25b272eec4d4cd0$export$56623f543516c50f)(duration);
    if (duration.months === 0 && (this.tense === 'past' && duration.sign !== -1 || this.tense === 'future' && duration.sign !== 1)) return $03ae7077c712265a$var$microEmptyDuration;
    return duration;
}, $03ae7077c712265a$var$_RelativeTimeElement_getMicroRelativeFormat = function _RelativeTimeElement_getMicroRelativeFormat(duration, locale) {
    const relativeFormat = (0, $ce0ee8f7f5614b6f$export$87c7871fd3ccba48)(locale, {
        numeric: 'always',
        style: 'narrow'
    });
    duration = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getMicroDuration).call(this, duration);
    const [int, unit] = (0, $b25b272eec4d4cd0$export$d2cb509fe1f5058d)(duration.blank ? $03ae7077c712265a$var$microEmptyDuration : duration);
    return relativeFormat.format(Math.abs(int) * (this.tense === 'past' ? -1 : 1), unit);
}, $03ae7077c712265a$var$_RelativeTimeElement_getDurationFormat = function _RelativeTimeElement_getDurationFormat(duration, locale) {
    const format = this.format;
    const style = this.formatStyle;
    const tense = this.tense;
    let empty = $03ae7077c712265a$var$emptyDuration;
    if (format === 'micro') {
        duration = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getMicroDuration).call(this, duration);
        empty = $03ae7077c712265a$var$microEmptyDuration;
    } else if (tense === 'past' && duration.sign !== -1 || tense === 'future' && duration.sign !== 1) duration = empty;
    const display = `${this.precision}sDisplay`;
    if (duration.blank) return empty.toLocaleString(locale, {
        style: style,
        [display]: 'always'
    });
    return duration.abs().toLocaleString(locale, {
        style: style
    });
}, $03ae7077c712265a$var$_RelativeTimeElement_getRelativeFormat = function _RelativeTimeElement_getRelativeFormat(duration, locale) {
    const relativeFormat = (0, $ce0ee8f7f5614b6f$export$87c7871fd3ccba48)(locale, {
        numeric: 'auto',
        style: this.formatStyle
    });
    const tense = this.tense;
    if (tense === 'future' && duration.sign !== 1) duration = $03ae7077c712265a$var$emptyDuration;
    if (tense === 'past' && duration.sign !== -1) duration = $03ae7077c712265a$var$emptyDuration;
    const [int, unit] = (0, $b25b272eec4d4cd0$export$d2cb509fe1f5058d)(duration);
    if (unit === 'second' && int < 10) return relativeFormat.format(0, this.precision === 'millisecond' ? 'second' : this.precision);
    return relativeFormat.format(int, unit);
}, $03ae7077c712265a$var$_RelativeTimeElement_getDateTimeFormat = function _RelativeTimeElement_getDateTimeFormat(date, locale, timeZone, hourCycle) {
    const formatter = (0, $ce0ee8f7f5614b6f$export$b434509d4a847712)(locale, {
        second: this.second,
        minute: this.minute,
        hour: this.hour,
        weekday: this.weekday,
        day: this.day,
        month: this.month,
        year: this.year,
        timeZoneName: this.timeZoneName,
        timeZone: timeZone,
        hourCycle: hourCycle
    });
    return `${this.prefix} ${formatter.format(date)}`.trim();
}, $03ae7077c712265a$var$_RelativeTimeElement_isToday = function _RelativeTimeElement_isToday(date, locale, timeZone) {
    const now = new Date();
    const formatter = (0, $ce0ee8f7f5614b6f$export$b434509d4a847712)(locale, {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
    return formatter.format(now) === formatter.format(date);
}, $03ae7077c712265a$var$_RelativeTimeElement_isCurrentYear = function _RelativeTimeElement_isCurrentYear(date, locale, timeZone) {
    const now = new Date();
    const formatter = (0, $ce0ee8f7f5614b6f$export$b434509d4a847712)(locale, {
        timeZone: timeZone,
        year: 'numeric'
    });
    return formatter.format(now) === formatter.format(date);
}, $03ae7077c712265a$var$_RelativeTimeElement_getUserPreferredAbsoluteTimeFormat = function _RelativeTimeElement_getUserPreferredAbsoluteTimeFormat(date, locale, timeZone, hourCycle) {
    const timeOnlyOptions = {
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short',
        timeZone: timeZone,
        hourCycle: hourCycle
    };
    if ($03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_isToday).call(this, date, locale, timeZone)) {
        const relativeFormatter = (0, $ce0ee8f7f5614b6f$export$87c7871fd3ccba48)(locale, {
            numeric: 'auto'
        });
        let todayText = relativeFormatter.format(0, 'day');
        todayText = todayText.charAt(0).toLocaleUpperCase(locale) + todayText.slice(1);
        const timeOnly = (0, $ce0ee8f7f5614b6f$export$b434509d4a847712)(locale, timeOnlyOptions).format(date);
        return `${todayText} ${timeOnly}`;
    }
    const timeAndDateOptions = Object.assign(Object.assign({}, timeOnlyOptions), {
        day: 'numeric',
        month: 'short'
    });
    if ($03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_isCurrentYear).call(this, date, locale, timeZone)) return (0, $ce0ee8f7f5614b6f$export$b434509d4a847712)(locale, timeAndDateOptions).format(date);
    return (0, $ce0ee8f7f5614b6f$export$b434509d4a847712)(locale, Object.assign(Object.assign({}, timeAndDateOptions), {
        year: 'numeric'
    })).format(date);
}, $03ae7077c712265a$var$_RelativeTimeElement_updateRenderRootContent = function _RelativeTimeElement_updateRenderRootContent(content) {
    const root = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_renderRoot, "f");
    const ariaHidden = this.hasAttribute('aria-hidden') && this.getAttribute('aria-hidden') === 'true';
    let span = root.firstElementChild;
    if (!span || span.getAttribute('part') !== 'root' || root.childNodes.length !== 1) {
        span = document.createElement('span');
        span.setAttribute('part', 'root');
        root.replaceChildren(span);
    }
    if (ariaHidden) {
        if (span.getAttribute('aria-hidden') !== 'true') span.setAttribute('aria-hidden', 'true');
    } else if (span.hasAttribute('aria-hidden')) span.removeAttribute('aria-hidden');
    if (span.textContent !== content) span.textContent = content;
}, $03ae7077c712265a$var$_RelativeTimeElement_shouldDisplayUserPreferredAbsoluteTime = function _RelativeTimeElement_shouldDisplayUserPreferredAbsoluteTime(format) {
    var _a;
    if (format === 'duration' && this.format !== 'micro') return false;
    return this.ownerDocument.documentElement.getAttribute('data-prefers-absolute-time') === 'true' || ((_a = this.ownerDocument.body) === null || _a === void 0 ? void 0 : _a.getAttribute('data-prefers-absolute-time')) === 'true';
};
var $03ae7077c712265a$export$2e2bcd8739ae039 = $03ae7077c712265a$export$8f5d2bd03530cdd0;


const $14d9951328a8e257$var$root = typeof globalThis !== 'undefined' ? globalThis : window;
try {
    $14d9951328a8e257$var$root.RelativeTimeElement = (0, $03ae7077c712265a$export$8f5d2bd03530cdd0).define();
} catch (e) {
    if (!($14d9951328a8e257$var$root.DOMException && e instanceof DOMException && e.name === 'NotSupportedError') && !(e instanceof ReferenceError)) throw e;
}
var $14d9951328a8e257$export$2e2bcd8739ae039 = (0, $03ae7077c712265a$export$8f5d2bd03530cdd0);


var $554bd593dedd9121$export$2e2bcd8739ae039 = (0, $14d9951328a8e257$export$2e2bcd8739ae039);


const $59c92a63e141fec3$var$states = new WeakMap();
class $59c92a63e141fec3$var$RemoteInputElement extends HTMLElement {
    constructor(){
        super();
        const fetch1 = $59c92a63e141fec3$var$fetchResults.bind(null, this, true);
        const state = {
            currentQuery: null,
            oninput: $59c92a63e141fec3$var$debounce((e)=>fetch1(e)),
            fetch: fetch1,
            controller: null
        };
        $59c92a63e141fec3$var$states.set(this, state);
    }
    static get observedAttributes() {
        return [
            'src'
        ];
    }
    attributeChangedCallback(name, oldValue) {
        if (oldValue && name === 'src') $59c92a63e141fec3$var$fetchResults(this, false);
    }
    connectedCallback() {
        const input = this.input;
        if (!input) return;
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('spellcheck', 'false');
        const state = $59c92a63e141fec3$var$states.get(this);
        if (!state) return;
        input.addEventListener('focus', state.fetch);
        input.addEventListener('change', state.fetch);
        input.addEventListener('input', state.oninput);
    }
    disconnectedCallback() {
        const input = this.input;
        if (!input) return;
        const state = $59c92a63e141fec3$var$states.get(this);
        if (!state) return;
        input.removeEventListener('focus', state.fetch);
        input.removeEventListener('change', state.fetch);
        input.removeEventListener('input', state.oninput);
    }
    get input() {
        const input = this.querySelector('input, textarea');
        return input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement ? input : null;
    }
    get src() {
        return this.getAttribute('src') || '';
    }
    set src(url) {
        this.setAttribute('src', url);
    }
}
function $59c92a63e141fec3$var$makeAbortController() {
    if ('AbortController' in window) return new AbortController();
    return {
        signal: null,
        abort () {}
    };
}
async function $59c92a63e141fec3$var$fetchResults(remoteInput, checkCurrentQuery, event) {
    const input = remoteInput.input;
    if (!input) return;
    const state = $59c92a63e141fec3$var$states.get(remoteInput);
    if (!state) return;
    const query = input.value;
    if (checkCurrentQuery && state.currentQuery === query) return;
    state.currentQuery = query;
    const src = remoteInput.src;
    if (!src) return;
    const resultsContainer = document.getElementById(remoteInput.getAttribute('aria-owns') || '');
    if (!resultsContainer) return;
    const url = new URL(src, window.location.href);
    const params = new URLSearchParams(url.search);
    params.append(remoteInput.getAttribute('param') || 'q', query);
    url.search = params.toString();
    if (state.controller) state.controller.abort();
    else {
        remoteInput.dispatchEvent(new CustomEvent('loadstart'));
        remoteInput.setAttribute('loading', '');
    }
    state.controller = $59c92a63e141fec3$var$makeAbortController();
    let response;
    let html = '';
    try {
        response = await $59c92a63e141fec3$var$fetchWithNetworkEvents(remoteInput, url.toString(), {
            signal: state.controller.signal,
            credentials: 'same-origin',
            headers: {
                accept: 'text/fragment+html'
            }
        });
        html = await response.text();
        remoteInput.removeAttribute('loading');
        state.controller = null;
    } catch (error) {
        if (error instanceof Error && error.name !== 'AbortError') {
            remoteInput.removeAttribute('loading');
            state.controller = null;
        }
        return;
    }
    if (response && response.ok) {
        resultsContainer.innerHTML = html;
        remoteInput.dispatchEvent(new CustomEvent('remote-input-success', {
            bubbles: true,
            detail: {
                "eventType": event ? event.type : undefined
            }
        }));
    } else remoteInput.dispatchEvent(new CustomEvent('remote-input-error', {
        bubbles: true
    }));
}
async function $59c92a63e141fec3$var$fetchWithNetworkEvents(el, url, options) {
    try {
        const response = await fetch(url, options);
        el.dispatchEvent(new CustomEvent('load'));
        el.dispatchEvent(new CustomEvent('loadend'));
        return response;
    } catch (error) {
        if (error instanceof Error && (error === null || error === void 0 ? void 0 : error.name) !== 'AbortError') {
            el.dispatchEvent(new CustomEvent('error'));
            el.dispatchEvent(new CustomEvent('loadend'));
        }
        throw error;
    }
}
function $59c92a63e141fec3$var$debounce(callback) {
    let timeout;
    return function(args) {
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            clearTimeout(timeout);
            callback(args);
        }, 300);
    };
}
var $59c92a63e141fec3$export$2e2bcd8739ae039 = $59c92a63e141fec3$var$RemoteInputElement;
if (!window.customElements.get('remote-input')) {
    window.RemoteInputElement = $59c92a63e141fec3$var$RemoteInputElement;
    window.customElements.define('remote-input', $59c92a63e141fec3$var$RemoteInputElement);
}


var $938ab5d81a50cbfe$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $938ab5d81a50cbfe$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $938ab5d81a50cbfe$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $938ab5d81a50cbfe$var$_a;
var $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tabIndex, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_panel, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tab, $938ab5d81a50cbfe$var$_TabContainerElement_instances, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged, $938ab5d81a50cbfe$var$_TabContainerElement_tabList_get, $938ab5d81a50cbfe$var$_TabContainerElement_tabListWrapper_get, $938ab5d81a50cbfe$var$_TabContainerElement_tabListTabWrapper_get, $938ab5d81a50cbfe$var$_TabContainerElement_beforeTabsSlot_get, $938ab5d81a50cbfe$var$_TabContainerElement_afterTabsSlot_get, $938ab5d81a50cbfe$var$_TabContainerElement_afterPanelsSlot_get, $938ab5d81a50cbfe$var$_TabContainerElement_tabListSlot_get, $938ab5d81a50cbfe$var$_TabContainerElement_panelSlot_get, $938ab5d81a50cbfe$var$_TabContainerElement_tabs_get, $938ab5d81a50cbfe$var$_TabContainerElement_setupComplete, $938ab5d81a50cbfe$var$_TabContainerElement_internals, $938ab5d81a50cbfe$var$_TabContainerElement_handleKeydown, $938ab5d81a50cbfe$var$_TabContainerElement_handleClick, $938ab5d81a50cbfe$var$_TabContainerElement_reflectAttributeToShadow;
const $938ab5d81a50cbfe$var$HTMLElement = globalThis.HTMLElement || null;
const $938ab5d81a50cbfe$var$assignSlotWithFallback = 'assign' in ((($938ab5d81a50cbfe$var$_a = globalThis.HTMLSlotElement) === null || $938ab5d81a50cbfe$var$_a === void 0 ? void 0 : $938ab5d81a50cbfe$var$_a.prototype) || {}) ? (slot, ...elements)=>{
    slot.assign(...elements);
} : (slot, ...elements)=>{
    const host = slot.getRootNode().host;
    for (const element of host.querySelectorAll(`[slot="${slot.name}"]`))element.removeAttribute('slot');
    for (const element of elements)element.setAttribute('slot', slot.name);
};
class $938ab5d81a50cbfe$export$6a3733570e3be366 extends Event {
    constructor(type, _a){
        var { tabIndex: tabIndex, tab: tab, panel: panel } = _a, init = $938ab5d81a50cbfe$var$__rest(_a, [
            "tabIndex",
            "tab",
            "panel"
        ]);
        super(type, init);
        $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tabIndex.set(this, null);
        $938ab5d81a50cbfe$var$_TabContainerChangeEvent_panel.set(this, null);
        $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tab.set(this, null);
        $938ab5d81a50cbfe$var$__classPrivateFieldSet(this, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tab, tab || null, "f");
        $938ab5d81a50cbfe$var$__classPrivateFieldSet(this, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tabIndex, tabIndex || null, "f");
        $938ab5d81a50cbfe$var$__classPrivateFieldSet(this, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_panel, panel || null, "f");
    }
    get detail() {
        console.warn('TabContainerElement.detail is deprecated, please use .panel instead');
        return {
            relatedTarget: $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_panel, "f")
        };
    }
    get tabIndex() {
        return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tabIndex, "f");
    }
    get panel() {
        return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_panel, "f");
    }
    get tab() {
        return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tab, "f");
    }
}
$938ab5d81a50cbfe$var$_TabContainerChangeEvent_tabIndex = new WeakMap(), $938ab5d81a50cbfe$var$_TabContainerChangeEvent_panel = new WeakMap(), $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tab = new WeakMap();
class $938ab5d81a50cbfe$export$d423894cc51549d0 extends $938ab5d81a50cbfe$var$HTMLElement {
    constructor(){
        super(...arguments);
        $938ab5d81a50cbfe$var$_TabContainerElement_instances.add(this);
        $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange.set(this, null);
        $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged.set(this, null);
        $938ab5d81a50cbfe$var$_TabContainerElement_setupComplete.set(this, false);
        $938ab5d81a50cbfe$var$_TabContainerElement_internals.set(this, void 0);
    }
    static define(tag = 'tab-container', registry = customElements) {
        registry.define(tag, this);
        return this;
    }
    get onChange() {
        return this.onTabContainerChange;
    }
    set onChange(listener) {
        this.onTabContainerChange = listener;
    }
    get onTabContainerChange() {
        return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange, "f");
    }
    set onTabContainerChange(listener) {
        if ($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange, "f")) this.removeEventListener('tab-container-change', $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange, "f"));
        $938ab5d81a50cbfe$var$__classPrivateFieldSet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange, typeof listener === 'object' || typeof listener === 'function' ? listener : null, "f");
        if (typeof listener === 'function') this.addEventListener('tab-container-change', listener);
    }
    get onTabContainerChanged() {
        return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged, "f");
    }
    set onTabContainerChanged(listener) {
        if ($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged, "f")) this.removeEventListener('tab-container-changed', $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged, "f"));
        $938ab5d81a50cbfe$var$__classPrivateFieldSet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged, typeof listener === 'object' || typeof listener === 'function' ? listener : null, "f");
        if (typeof listener === 'function') this.addEventListener('tab-container-changed', listener);
    }
    get onChanged() {
        return this.onTabContainerChanged;
    }
    set onChanged(listener) {
        this.onTabContainerChanged = listener;
    }
    get activeTab() {
        return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabs_get)[this.selectedTabIndex];
    }
    get activePanel() {
        return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_panelSlot_get).assignedNodes()[0];
    }
    get vertical() {
        var _a;
        return ((_a = $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabList_get)) === null || _a === void 0 ? void 0 : _a.getAttribute('aria-orientation')) === 'vertical';
    }
    set vertical(isVertical) {
        const tabList = $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabList_get);
        if (tabList && isVertical) tabList.setAttribute('aria-orientation', 'vertical');
        else tabList.setAttribute('aria-orientation', 'horizontal');
    }
    connectedCallback() {
        $938ab5d81a50cbfe$var$__classPrivateFieldSet(this, $938ab5d81a50cbfe$var$_TabContainerElement_internals, $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_internals, "f") || (this.attachInternals ? this.attachInternals() : null), "f");
        const shadowRoot = this.shadowRoot || this.attachShadow({
            mode: 'open',
            slotAssignment: 'manual'
        });
        const tabListContainer = document.createElement('slot');
        tabListContainer.style.display = 'flex';
        tabListContainer.setAttribute('part', 'tablist-wrapper');
        tabListContainer.setAttribute('name', 'tablist-wrapper');
        const tabListTabWrapper = document.createElement('div');
        tabListTabWrapper.setAttribute('part', 'tablist-tab-wrapper');
        tabListTabWrapper.setAttribute('name', 'tablist-tab-wrapper');
        const tabListSlot = document.createElement('slot');
        tabListSlot.setAttribute('part', 'tablist');
        tabListSlot.setAttribute('name', 'tablist');
        tabListTabWrapper.append(tabListSlot);
        const panelSlot = document.createElement('slot');
        panelSlot.setAttribute('part', 'panel');
        panelSlot.setAttribute('name', 'panel');
        const beforeTabSlot = document.createElement('slot');
        beforeTabSlot.setAttribute('part', 'before-tabs');
        beforeTabSlot.setAttribute('name', 'before-tabs');
        const afterTabSlot = document.createElement('slot');
        afterTabSlot.setAttribute('part', 'after-tabs');
        afterTabSlot.setAttribute('name', 'after-tabs');
        tabListContainer.append(beforeTabSlot, tabListTabWrapper, afterTabSlot);
        const afterSlot = document.createElement('slot');
        afterSlot.setAttribute('part', 'after-panels');
        afterSlot.setAttribute('name', 'after-panels');
        shadowRoot.replaceChildren(tabListContainer, panelSlot, afterSlot);
        if ($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_internals, "f") && 'role' in $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_internals, "f")) $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_internals, "f").role = 'presentation';
        else this.setAttribute('role', 'presentation');
        this.addEventListener('keydown', this);
        this.addEventListener('click', this);
        this.selectTab(-1);
        if (!$938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_setupComplete, "f")) {
            const mutationObserver = new MutationObserver(()=>{
                this.selectTab(-1);
                if ($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_setupComplete, "f")) mutationObserver.disconnect();
            });
            mutationObserver.observe(this, {
                childList: true,
                subtree: true
            });
        }
    }
    attributeChangedCallback(name) {
        if (!this.isConnected || !this.shadowRoot) return;
        if (name === 'vertical') this.vertical = this.hasAttribute('vertical');
    }
    handleEvent(event) {
        if (event.type === 'click') return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "m", $938ab5d81a50cbfe$var$_TabContainerElement_handleClick).call(this, event);
        if (event.type === 'keydown') return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "m", $938ab5d81a50cbfe$var$_TabContainerElement_handleKeydown).call(this, event);
    }
    get selectedTabIndex() {
        return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabs_get).findIndex((el)=>el.matches('[aria-selected=true]'));
    }
    set selectedTabIndex(i) {
        this.selectTab(i);
    }
    get defaultTabIndex() {
        return Number(this.getAttribute('default-tab') || -1);
    }
    set defaultTabIndex(index) {
        this.setAttribute('default-tab', String(index));
    }
    selectTab(index, options = {}) {
        var _a;
        const { focus: focus = true } = options;
        if (!$938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_setupComplete, "f")) {
            const tabListSlot = $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabListSlot_get);
            const tabListWrapper = $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabListWrapper_get);
            const customTabList = this.querySelector('[role=tablist]');
            const customTabListWrapper = this.querySelector('[slot=tablist-wrapper]');
            if (customTabListWrapper && customTabListWrapper.closest(this.tagName) === this) $938ab5d81a50cbfe$var$assignSlotWithFallback(tabListWrapper, customTabListWrapper);
            else if (customTabList && customTabList.closest(this.tagName) === this) $938ab5d81a50cbfe$var$assignSlotWithFallback(tabListSlot, customTabList);
            else {
                $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabListTabWrapper_get).role = 'tablist';
                $938ab5d81a50cbfe$var$assignSlotWithFallback(tabListSlot, ...[
                    ...this.children
                ].filter((e)=>e.matches('[role=tab]')));
            }
            const tabList = $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabList_get);
            $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "m", $938ab5d81a50cbfe$var$_TabContainerElement_reflectAttributeToShadow).call(this, 'aria-description', tabList);
            $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "m", $938ab5d81a50cbfe$var$_TabContainerElement_reflectAttributeToShadow).call(this, 'aria-label', tabList);
            if (this.vertical) $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabList_get).setAttribute('aria-orientation', 'vertical');
            const bringsOwnWrapper = ((_a = this.querySelector('[slot=tablist-wrapper]')) === null || _a === void 0 ? void 0 : _a.closest(this.tagName)) === this;
            if (!bringsOwnWrapper) {
                const beforeSlotted = [];
                const afterTabSlotted = [];
                const afterSlotted = [];
                let autoSlotted = beforeSlotted;
                for (const child of this.children){
                    if (child.getAttribute('role') === 'tab' || child.getAttribute('role') === 'tablist') {
                        autoSlotted = afterTabSlotted;
                        continue;
                    }
                    if (child.getAttribute('role') === 'tabpanel') {
                        autoSlotted = afterSlotted;
                        continue;
                    }
                    if (child.getAttribute('slot') === 'before-tabs') beforeSlotted.push(child);
                    else if (child.getAttribute('slot') === 'after-tabs') afterTabSlotted.push(child);
                    else autoSlotted.push(child);
                }
                $938ab5d81a50cbfe$var$assignSlotWithFallback($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_beforeTabsSlot_get), ...beforeSlotted);
                $938ab5d81a50cbfe$var$assignSlotWithFallback($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_afterTabsSlot_get), ...afterTabSlotted);
                $938ab5d81a50cbfe$var$assignSlotWithFallback($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_afterPanelsSlot_get), ...afterSlotted);
            }
            const defaultTab = this.defaultTabIndex;
            const defaultIndex = defaultTab >= 0 ? defaultTab : this.selectedTabIndex;
            index = index >= 0 ? index : Math.max(0, defaultIndex);
        }
        const tabs = $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabs_get);
        const panels = Array.from(this.querySelectorAll('[role="tabpanel"]')).filter((panel)=>panel.closest(this.tagName) === this);
        if (index > tabs.length - 1) return;
        const selectedTab = tabs[index];
        const selectedPanel = panels[index];
        if (!selectedTab) return;
        if (!selectedPanel) return;
        if ($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_setupComplete, "f")) {
            const cancelled = !this.dispatchEvent(new $938ab5d81a50cbfe$export$6a3733570e3be366('tab-container-change', {
                tabIndex: index,
                bubbles: true,
                cancelable: true,
                tab: selectedTab,
                panel: selectedPanel
            }));
            if (cancelled) return;
        }
        for (const tab of tabs){
            tab.setAttribute('aria-selected', 'false');
            tab.setAttribute('tabindex', '-1');
        }
        for (const panel of panels)if (!panel.hasAttribute('tabindex') && !panel.hasAttribute('data-tab-container-no-tabstop')) panel.setAttribute('tabindex', '0');
        selectedTab.setAttribute('aria-selected', 'true');
        selectedTab.setAttribute('tabindex', '0');
        $938ab5d81a50cbfe$var$assignSlotWithFallback($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_panelSlot_get), selectedPanel);
        selectedPanel.hidden = false;
        if ($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_setupComplete, "f")) {
            if (focus) selectedTab.focus();
            this.dispatchEvent(new $938ab5d81a50cbfe$export$6a3733570e3be366('tab-container-changed', {
                tabIndex: index,
                bubbles: true,
                tab: selectedTab,
                panel: selectedPanel
            }));
        }
        $938ab5d81a50cbfe$var$__classPrivateFieldSet(this, $938ab5d81a50cbfe$var$_TabContainerElement_setupComplete, true, "f");
    }
}
$938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange = new WeakMap(), $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged = new WeakMap(), $938ab5d81a50cbfe$var$_TabContainerElement_setupComplete = new WeakMap(), $938ab5d81a50cbfe$var$_TabContainerElement_internals = new WeakMap(), $938ab5d81a50cbfe$var$_TabContainerElement_instances = new WeakSet(), $938ab5d81a50cbfe$var$_TabContainerElement_tabList_get = function _TabContainerElement_tabList_get() {
    const wrapper = this.querySelector('[slot=tablist-wrapper]');
    if ((wrapper === null || wrapper === void 0 ? void 0 : wrapper.closest(this.tagName)) === this) return wrapper.querySelector('[role=tablist]');
    const slot = $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabListSlot_get);
    if ($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabListTabWrapper_get).hasAttribute('role')) return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabListTabWrapper_get);
    else return slot.assignedNodes()[0];
}, $938ab5d81a50cbfe$var$_TabContainerElement_tabListWrapper_get = function _TabContainerElement_tabListWrapper_get() {
    return this.shadowRoot.querySelector('slot[part="tablist-wrapper"]');
}, $938ab5d81a50cbfe$var$_TabContainerElement_tabListTabWrapper_get = function _TabContainerElement_tabListTabWrapper_get() {
    return this.shadowRoot.querySelector('div[part="tablist-tab-wrapper"]');
}, $938ab5d81a50cbfe$var$_TabContainerElement_beforeTabsSlot_get = function _TabContainerElement_beforeTabsSlot_get() {
    return this.shadowRoot.querySelector('slot[part="before-tabs"]');
}, $938ab5d81a50cbfe$var$_TabContainerElement_afterTabsSlot_get = function _TabContainerElement_afterTabsSlot_get() {
    return this.shadowRoot.querySelector('slot[part="after-tabs"]');
}, $938ab5d81a50cbfe$var$_TabContainerElement_afterPanelsSlot_get = function _TabContainerElement_afterPanelsSlot_get() {
    return this.shadowRoot.querySelector('slot[part="after-panels"]');
}, $938ab5d81a50cbfe$var$_TabContainerElement_tabListSlot_get = function _TabContainerElement_tabListSlot_get() {
    return this.shadowRoot.querySelector('slot[part="tablist"]');
}, $938ab5d81a50cbfe$var$_TabContainerElement_panelSlot_get = function _TabContainerElement_panelSlot_get() {
    return this.shadowRoot.querySelector('slot[part="panel"]');
}, $938ab5d81a50cbfe$var$_TabContainerElement_tabs_get = function _TabContainerElement_tabs_get() {
    var _a;
    if ($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabListTabWrapper_get).matches('[role=tablist]')) return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabListSlot_get).assignedNodes();
    return Array.from(((_a = $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabList_get)) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[role="tab"]')) || []).filter((tab)=>tab instanceof $938ab5d81a50cbfe$var$HTMLElement && tab.closest(this.tagName) === this);
}, $938ab5d81a50cbfe$var$_TabContainerElement_handleKeydown = function _TabContainerElement_handleKeydown(event) {
    var _a, _b, _c;
    const tab = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest) === null || _b === void 0 ? void 0 : _b.call(_a, '[role="tab"]');
    if (!tab) return;
    const tabs = $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabs_get);
    if (!tabs.includes(tab)) return;
    const currentIndex = this.selectedTabIndex;
    const vertical = ((_c = tab.closest('[role="tablist"]')) === null || _c === void 0 ? void 0 : _c.getAttribute('aria-orientation')) === 'vertical';
    const prevTab = event.code === 'ArrowLeft' || vertical && event.code === 'ArrowUp';
    const nextTab = event.code === 'ArrowRight' || vertical && event.code === 'ArrowDown';
    if (nextTab) {
        let index = currentIndex + 1;
        if (index >= tabs.length) index = 0;
        this.selectTab(index);
    } else if (prevTab) {
        let index = currentIndex - 1;
        if (index < 0) index = tabs.length - 1;
        this.selectTab(index);
    } else if (event.code === 'Home') {
        this.selectTab(0);
        event.preventDefault();
    } else if (event.code === 'End') {
        this.selectTab(tabs.length - 1);
        event.preventDefault();
    }
}, $938ab5d81a50cbfe$var$_TabContainerElement_handleClick = function _TabContainerElement_handleClick(event) {
    var _a, _b;
    const tab = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest) === null || _b === void 0 ? void 0 : _b.call(_a, '[role=tab]');
    if (!tab) return;
    const tabs = $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_instances, "a", $938ab5d81a50cbfe$var$_TabContainerElement_tabs_get);
    const index = tabs.indexOf(tab);
    if (index >= 0) this.selectTab(index);
}, $938ab5d81a50cbfe$var$_TabContainerElement_reflectAttributeToShadow = function _TabContainerElement_reflectAttributeToShadow(name, node) {
    if (this.hasAttribute(name)) {
        node.setAttribute(name, this.getAttribute(name));
        this.removeAttribute(name);
    }
};
$938ab5d81a50cbfe$export$d423894cc51549d0.observedAttributes = [
    'vertical'
];



const $6e35d35d50cffb2c$var$root = typeof globalThis !== 'undefined' ? globalThis : window;
try {
    $6e35d35d50cffb2c$var$root.TabContainerElement = (0, $938ab5d81a50cbfe$export$d423894cc51549d0).define();
} catch (e) {
    if (!($6e35d35d50cffb2c$var$root.DOMException && e instanceof DOMException && e.name === 'NotSupportedError') && !(e instanceof ReferenceError)) throw e;
}
var $6e35d35d50cffb2c$export$2e2bcd8739ae039 = (0, $938ab5d81a50cbfe$export$d423894cc51549d0);


var $d684e09b0ab56ade$export$2e2bcd8739ae039 = (0, $938ab5d81a50cbfe$export$d423894cc51549d0);



const $f3c96cfcabe38876$var$boundary = /\s|\(|\[/;
function $f3c96cfcabe38876$var$query(text, key, cursor, { multiWord: multiWord, lookBackIndex: lookBackIndex, lastMatchPosition: lastMatchPosition } = {
    multiWord: false,
    lookBackIndex: 0,
    lastMatchPosition: null
}) {
    let keyIndex = text.lastIndexOf(key, cursor - 1);
    if (keyIndex === -1) return;
    if (keyIndex < lookBackIndex) return;
    if (multiWord) {
        if (lastMatchPosition != null) {
            if (lastMatchPosition === keyIndex) return;
            keyIndex = lastMatchPosition - key.length;
        }
        const charAfterKey = text[keyIndex + 1];
        if (charAfterKey === ' ' && cursor >= keyIndex + key.length + 1) return;
        const newLineIndex = text.lastIndexOf('\n', cursor - 1);
        if (newLineIndex > keyIndex) return;
        const dotIndex = text.lastIndexOf('.', cursor - 1);
        if (dotIndex > keyIndex) return;
    } else {
        const spaceIndex = text.lastIndexOf(' ', cursor - 1);
        if (spaceIndex > keyIndex) return;
    }
    const pre = text[keyIndex - 1];
    if (pre && !$f3c96cfcabe38876$var$boundary.test(pre)) return;
    const queryString = text.substring(keyIndex + key.length, cursor);
    return {
        text: queryString,
        position: keyIndex + key.length
    };
}
class $f3c96cfcabe38876$var$InputStyleCloneUpdateEvent extends Event {
    constructor(){
        super("update");
    }
}
const $f3c96cfcabe38876$var$CloneRegistry = new WeakMap();
/**
 * Creates an element that exactly matches an input pixel-for-pixel and automatically stays in sync with it. This
 * is a non-interactive overlay on to the input and can be used to affect the visual appearance of the input
 * without modifying its behavior. The clone element is hidden by default.
 *
 * This lower level API powers the `InputRange` but provides more advanced functionality including event updates.
 *
 * Emits `update` events whenever anything is recalculated: when the layout changes, when the user scrolls, when the
 * input is updated, etc. This event may be emitted more than once per change.
 *
 * @note There may be cases in which the clone cannot observe changes to the input and fails to automatically update.
 * For example, if the `value` property on the input is written to directly, no `input` event is emitted by the input
 * and the clone does not automatically update. In these cases, `forceUpdate` can be used to manually trigger an update.
 */ // PRIOR ART: This approach was adapted from the following MIT-licensed sources:
//  - primer/react (Copyright (c) 2018 GitHub, Inc.): https://github.com/primer/react/blob/a0db832302702b869aa22b0c4049ad9305ef631f/src/drafts/utils/character-coordinates.ts
//  - component/textarea-caret-position (Copyright (c) 2015 Jonathan Ong me@jongleberry.com): https://github.com/component/textarea-caret-position/blob/b5db7a7e47dd149c2a66276183c69234e4dabe30/index.js
//  - koddsson/textarea-caret-position (Copyright (c) 2015 Jonathan Ong me@jongleberry.com): https://github.com/koddsson/textarea-caret-position/blob/eba40ec8488eed4d77815f109af22e1d9c0751d3/index.js
class $f3c96cfcabe38876$var$InputStyleClone extends EventTarget {
    #styleObserver = new MutationObserver(()=>this.#updateStyles());
    #resizeObserver = new ResizeObserver(()=>this.#requestUpdateLayout());
    // This class is unique in that it will prevent itself from getting garbage collected because of the subscribed
    // observers (if never detached). Because of this, we want to avoid preventing the existence of this class from also
    // preventing the garbage collection of the associated input. This also allows us to automatically detach if the
    // input gets collected.
    #inputRef;
    #container = document.createElement("div");
    #cloneElement = document.createElement("div");
    /**
     * Get the clone for an input, reusing an existing one if available. This avoids creating unecessary clones, which
     * have a performance cost due to their high-frequency event-based updates. Because these elements are shared, they
     * should be mutated with caution. If you're planning to mutate the clone, consider constructing a new one instead.
     *
     * Upon initial creation the clone element will automatically be inserted into the DOM and begin observing the
     * linked input.
     * @param input The target input to clone.
     */ static for(input) {
        let clone = $f3c96cfcabe38876$var$CloneRegistry.get(input);
        if (!clone) {
            clone = new $f3c96cfcabe38876$var$InputStyleClone(input);
            $f3c96cfcabe38876$var$CloneRegistry.set(input, clone);
        }
        return clone;
    }
    /**
     * Connect this instance to a target input element and insert this instance into the DOM in the correct location.
     *
     * NOTE: calling the static `for` method is usually preferable as it will reuse an existing clone if available.
     * However, if reusing clones is problematic (ie, if the clone needs to be mutated), a clone can be constructed
     * directly with `new InputStyleClone(target)`.
     */ constructor(input){
        super();
        this.#inputRef = new WeakRef(input);
        // We want position:absolute so it doesn't take space in the layout, but that doesn't work with display:table-cell
        // used in the HTMLInputElement approach. So we need a wrapper.
        this.#container.style.position = "absolute";
        this.#container.style.pointerEvents = "none";
        this.#container.setAttribute("aria-hidden", "true");
        this.#container.appendChild(this.#cloneElement);
        this.#cloneElement.style.pointerEvents = "none";
        this.#cloneElement.style.userSelect = "none";
        this.#cloneElement.style.overflow = "hidden";
        this.#cloneElement.style.display = "block";
        // Important not to use display:none which would not render the content at all
        this.#cloneElement.style.visibility = "hidden";
        if (input instanceof HTMLTextAreaElement) {
            this.#cloneElement.style.whiteSpace = "pre-wrap";
            this.#cloneElement.style.wordWrap = "break-word";
        } else {
            this.#cloneElement.style.whiteSpace = "nowrap";
            // text in single-line inputs is vertically centered
            this.#cloneElement.style.display = "table-cell";
            this.#cloneElement.style.verticalAlign = "middle";
        }
        input.after(this.#container);
        this.#updateStyles();
        this.#updateText();
        this.#styleObserver.observe(input, {
            attributeFilter: [
                "style",
                "dir"
            ]
        });
        this.#resizeObserver.observe(input);
        document.addEventListener("scroll", this.#onDocumentScrollOrResize, {
            capture: true
        });
        window.addEventListener("resize", this.#onDocumentScrollOrResize, {
            capture: true
        });
        // capture so this happens first, so other things can respond to `input` events after this data updates
        input.addEventListener("input", this.#onInput, {
            capture: true
        });
    }
    /** Get the clone element. */ get element() {
        return this.#cloneElement;
    }
    /**
     * Force a recalculation. Will emit an `update` event. This is typically not needed unless the input has changed in
     * an unobservable way, eg by directly writing to the `value` property.
     */ forceUpdate() {
        this.#updateStyles();
        this.#updateText();
    }
    disconnect() {
        this.#container?.remove();
        this.#styleObserver.disconnect();
        this.#resizeObserver.disconnect();
        document.removeEventListener("scroll", this.#onDocumentScrollOrResize, {
            capture: true
        });
        window.removeEventListener("resize", this.#onDocumentScrollOrResize, {
            capture: true
        });
        // Can't use `usingInput` here since that could infinitely recurse
        const input = this.#input;
        if (input) {
            input.removeEventListener("input", this.#onInput, {
                capture: true
            });
            $f3c96cfcabe38876$var$CloneRegistry.delete(input);
        }
    }
    // --- private ---
    get #input() {
        return this.#inputRef?.deref();
    }
    /** Perform `fn` using the `input` if it is still available. If not, clean up the clone instead. */ #usingInput(fn) {
        const input = this.#input;
        if (!input) return this.disconnect();
        return fn(input);
    }
    /** Current relative x-adjustment in pixels, executed via CSS transform. */ #xOffset = 0;
    /** Current relative y-adjustment in pixels, executed via CSS transform. */ #yOffset = 0;
    /**
     * Update only geometric properties without recalculating styles. Typically call `#requestUpdateLayout` instead to
     * only update once per animation frame.
     */ #updateLayout() {
        // This runs often, so keep it as fast as possible! Avoid all unecessary updates.
        this.#usingInput((input)=>{
            const inputStyle = window.getComputedStyle(input);
            this.#cloneElement.style.height = inputStyle.height;
            this.#cloneElement.style.width = inputStyle.width;
            // Immediately re-adjust for browser inconsistencies in scrollbar handling, if necessary
            if (input.clientHeight !== this.#cloneElement.clientHeight) this.#cloneElement.style.height = `calc(${inputStyle.height} + ${input.clientHeight - this.#cloneElement.clientHeight}px)`;
            if (input.clientWidth !== this.#cloneElement.clientWidth) this.#cloneElement.style.width = `calc(${inputStyle.width} + ${input.clientWidth - this.#cloneElement.clientWidth}px)`;
            // Position on top of the input
            const inputRect = input.getBoundingClientRect();
            const cloneRect = this.#cloneElement.getBoundingClientRect();
            this.#xOffset = this.#xOffset + inputRect.left - cloneRect.left;
            this.#yOffset = this.#yOffset + inputRect.top - cloneRect.top;
            this.#cloneElement.style.transform = `translate(${this.#xOffset}px, ${this.#yOffset}px)`;
            this.#cloneElement.scrollTop = input.scrollTop;
            this.#cloneElement.scrollLeft = input.scrollLeft;
            this.dispatchEvent(new $f3c96cfcabe38876$var$InputStyleCloneUpdateEvent());
        });
    }
    #isLayoutUpdating = false;
    /** Request a layout update. Will only happen once per animation frame, to avoid unecessary updates. */ #requestUpdateLayout() {
        if (this.#isLayoutUpdating) return;
        this.#isLayoutUpdating = true;
        requestAnimationFrame(()=>{
            this.#updateLayout();
            this.#isLayoutUpdating = false;
        });
    }
    /** Update the styles of the clone based on the styles of the input, then request a layout update. */ #updateStyles() {
        this.#usingInput((input)=>{
            const inputStyle = window.getComputedStyle(input);
            for (const prop of $f3c96cfcabe38876$var$propertiesToCopy)this.#cloneElement.style[prop] = inputStyle[prop];
            this.#requestUpdateLayout();
        });
    }
    /**
     * Update the text content of the clone based on the text content of the input. Triggers a layout update in case the
     * text update caused scrolling.
     */ #updateText() {
        this.#usingInput((input)=>{
            this.#cloneElement.textContent = input.value;
            // This is often unecessary on a pure text update, but text updates could potentially cause layout updates like
            // scrolling or resizing. And we run the update on _every frame_ when scrolling, so this isn't that expensive.
            // We don't requestUpdateLayout here because this one should happen synchronously, so that clients can react
            // within their own `input` event handlers.
            this.#updateLayout();
        });
    }
    #onInput = ()=>this.#updateText();
    #onDocumentScrollOrResize = (event)=>{
        this.#usingInput((input)=>{
            if (event.target === document || event.target === window || event.target instanceof Node && event.target.contains(input)) this.#requestUpdateLayout();
        });
    };
}
// Note that some browsers, such as Firefox, do not concatenate properties
// into their shorthand (e.g. padding-top, padding-bottom etc. -> padding),
// so we have to list every single property explicitly.
const $f3c96cfcabe38876$var$propertiesToCopy = [
    // RTL / vertical writing modes support:
    "direction",
    "writingMode",
    "unicodeBidi",
    "textOrientation",
    "boxSizing",
    "borderTopWidth",
    "borderRightWidth",
    "borderBottomWidth",
    "borderLeftWidth",
    "borderStyle",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    // https://developer.mozilla.org/en-US/docs/Web/CSS/font
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "fontStretch",
    "fontSize",
    "fontSizeAdjust",
    "lineHeight",
    "fontFamily",
    "textAlign",
    "textTransform",
    "textIndent",
    "textDecoration",
    "letterSpacing",
    "wordSpacing",
    "tabSize",
    "MozTabSize"
];
class $f3c96cfcabe38876$var$InputRange {
    #inputElement;
    #startOffset;
    #endOffset;
    /**
     * Construct a new `InputRange`.
     * @param element The target input element that contains the content for the range.
     * @param startOffset The inclusive 0-based start index for the range. Will be adjusted to fit in the input contents.
     * @param endOffset The exclusive 0-based end index for the range. Will be adjusted to fit in the input contents.
     */ constructor(element, startOffset = 0, endOffset = startOffset){
        this.#inputElement = element;
        this.#startOffset = startOffset;
        this.#endOffset = endOffset;
    }
    /**
     * Create a new range from the current user selection. If the input is not focused, the range will just be the start
     * of the input (offsets `0` to `0`).
     *
     * This can be used to get the caret coordinates: if the resulting range is `collapsed`, the location of the
     * `getBoundingClientRect` will be the location of the caret caret (note, however, that the width will be `0` in
     * this case).
     */ static fromSelection(input) {
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = input;
        return new $f3c96cfcabe38876$var$InputRange(input, selectionStart ?? undefined, selectionEnd ?? undefined);
    }
    /** Returns true if the start is equal to the end of this range. */ get collapsed() {
        return this.startOffset === this.endOffset;
    }
    /** Always returns the containing input element. */ get commonAncestorContainer() {
        return this.#inputElement;
    }
    /** Always returns the containing input element. */ get endContainer() {
        return this.#inputElement;
    }
    /** Always returns the containing input element. */ get startContainer() {
        return this.#inputElement;
    }
    get startOffset() {
        return this.#startOffset;
    }
    get endOffset() {
        return this.#endOffset;
    }
    /** Update the inclusive start offset. Will be adjusted to fit within the content size. */ setStartOffset(offset) {
        this.#startOffset = this.#clampOffset(offset);
    }
    /** Update the exclusive end offset. Will be adjusted to fit within the content size. */ setEndOffset(offset) {
        this.#endOffset = this.#clampOffset(offset);
    }
    /**
     * Collapse this range to one side.
     * @param toStart If `true`, will collapse to the start side. Otherwise, will collapse to the end.
     */ collapse(toStart = false) {
        if (toStart) this.setEndOffset(this.startOffset);
        else this.setStartOffset(this.endOffset);
    }
    /** Returns a `DocumentFragment` containing a new `Text` node containing the content in the range. */ cloneContents() {
        return this.#createCloneRange().cloneContents();
    }
    /** Create a copy of this range. */ cloneRange() {
        return new $f3c96cfcabe38876$var$InputRange(this.#inputElement, this.startOffset, this.endOffset);
    }
    /**
     * Obtain one rect that contains the entire contents of the range. If the range spans multiple lines, this box will
     * contain all pieces of the range but may also contain some space outside the range.
     * @see https://iansan5653.github.io/dom-input-range/demos/playground/
     */ getBoundingClientRect() {
        return this.#createCloneRange().getBoundingClientRect();
    }
    /**
     * Obtain the rects that contain contents of this range. If the range spans multiple lines, there will be multiple
     * bounding boxes. These boxes can be used, for example, to draw a highlight over the range.
     * @see https://iansan5653.github.io/dom-input-range/demos/playground/
     */ getClientRects() {
        return this.#createCloneRange().getClientRects();
    }
    /** Get the contents of the range as a string. */ toString() {
        return this.#createCloneRange().toString();
    }
    /**
     * Get the underlying `InputStyleClone` instance powering these calculations. This can be used to listen for
     * updates to trigger layout recalculation.
     */ getStyleClone() {
        return this.#styleClone;
    }
    // --- private ---
    get #styleClone() {
        return $f3c96cfcabe38876$var$InputStyleClone.for(this.#inputElement);
    }
    get #cloneElement() {
        return this.#styleClone;
    }
    #clampOffset(offset) {
        return Math.max(0, Math.min(offset, this.#inputElement.value.length));
    }
    #createCloneRange() {
        // It's tempting to create a single Range and reuse it across the lifetime of the class. However, this wouldn't be
        // accurate because the contents of the input can change and the contents of the range would become stale. So we
        // must create a new range every time we need it.
        const range = document.createRange();
        const textNode = this.#cloneElement.element.childNodes[0];
        if (textNode) {
            range.setStart(textNode, this.startOffset);
            range.setEnd(textNode, this.endOffset);
        }
        return range;
    }
}
const $f3c96cfcabe38876$var$states = new WeakMap();
class $f3c96cfcabe38876$var$TextExpander {
    constructor(expander, input){
        this.expander = expander;
        this.input = input;
        this.combobox = null;
        this.menu = null;
        this.match = null;
        this.justPasted = false;
        this.lookBackIndex = 0;
        this.oninput = this.onInput.bind(this);
        this.onpaste = this.onPaste.bind(this);
        this.onkeydown = this.onKeydown.bind(this);
        this.oncommit = this.onCommit.bind(this);
        this.onmousedown = this.onMousedown.bind(this);
        this.onblur = this.onBlur.bind(this);
        this.interactingWithList = false;
        input.addEventListener('paste', this.onpaste);
        input.addEventListener('input', this.oninput);
        input.addEventListener('keydown', this.onkeydown);
        input.addEventListener('blur', this.onblur);
    }
    destroy() {
        this.input.removeEventListener('paste', this.onpaste);
        this.input.removeEventListener('input', this.oninput);
        this.input.removeEventListener('keydown', this.onkeydown);
        this.input.removeEventListener('blur', this.onblur);
    }
    dismissMenu() {
        if (this.deactivate()) this.lookBackIndex = this.input.selectionEnd || this.lookBackIndex;
    }
    activate(match, menu) {
        var _a, _b;
        if (this.input !== document.activeElement && this.input !== ((_b = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.activeElement)) return;
        this.deactivate();
        this.menu = menu;
        if (!menu.id) menu.id = `text-expander-${Math.floor(Math.random() * 100000).toString()}`;
        this.expander.append(menu);
        this.combobox = new (0, $3791d940664efc96$export$2e2bcd8739ae039)(this.input, menu);
        this.expander.dispatchEvent(new Event('text-expander-activate'));
        this.positionMenu(menu, match.position);
        this.combobox.start();
        menu.addEventListener('combobox-commit', this.oncommit);
        menu.addEventListener('mousedown', this.onmousedown);
        this.combobox.navigate(1);
    }
    positionMenu(menu, position) {
        const clampedPosition = Math.min(position, this.input.value.length);
        const caretRect = new $f3c96cfcabe38876$var$InputRange(this.input, clampedPosition).getBoundingClientRect();
        const targetPosition = {
            left: caretRect.left,
            top: caretRect.top + caretRect.height
        };
        const currentPosition = menu.getBoundingClientRect();
        const delta = {
            left: targetPosition.left - currentPosition.left,
            top: targetPosition.top - currentPosition.top
        };
        if (delta.left !== 0 || delta.top !== 0) {
            const currentStyle = getComputedStyle(menu);
            menu.style.left = currentStyle.left ? `calc(${currentStyle.left} + ${delta.left}px)` : `${delta.left}px`;
            menu.style.top = currentStyle.top ? `calc(${currentStyle.top} + ${delta.top}px)` : `${delta.top}px`;
        }
    }
    deactivate() {
        const menu = this.menu;
        if (!menu || !this.combobox) return false;
        this.expander.dispatchEvent(new Event('text-expander-deactivate'));
        this.menu = null;
        menu.removeEventListener('combobox-commit', this.oncommit);
        menu.removeEventListener('mousedown', this.onmousedown);
        this.combobox.destroy();
        this.combobox = null;
        menu.remove();
        return true;
    }
    onCommit({ target: target }) {
        var _a;
        const item = target;
        if (!(item instanceof HTMLElement)) return;
        if (!this.combobox) return;
        const match = this.match;
        if (!match) return;
        const beginning = this.input.value.substring(0, match.position - match.key.length);
        const remaining = this.input.value.substring(match.position + match.text.length);
        const detail = {
            item: item,
            key: match.key,
            value: null,
            continue: false
        };
        const canceled = !this.expander.dispatchEvent(new CustomEvent('text-expander-value', {
            cancelable: true,
            detail: detail
        }));
        if (canceled) return;
        if (!detail.value) return;
        let suffix = (_a = this.expander.getAttribute('suffix')) !== null && _a !== void 0 ? _a : ' ';
        if (detail.continue) suffix = '';
        const value = `${detail.value}${suffix}`;
        this.input.value = beginning + value + remaining;
        const cursor = beginning.length + value.length;
        this.deactivate();
        this.input.focus({
            preventScroll: true
        });
        this.input.selectionStart = cursor;
        this.input.selectionEnd = cursor;
        if (!detail.continue) {
            this.lookBackIndex = cursor;
            this.match = null;
        }
        this.expander.dispatchEvent(new CustomEvent('text-expander-committed', {
            cancelable: false,
            detail: {
                input: this.input
            }
        }));
    }
    onBlur() {
        if (this.interactingWithList) {
            this.interactingWithList = false;
            return;
        }
        this.deactivate();
    }
    onPaste() {
        this.justPasted = true;
    }
    isMatchStillValid(match) {
        return match.position <= this.input.value.length;
    }
    async onInput() {
        if (this.justPasted) {
            this.justPasted = false;
            return;
        }
        const match = this.findMatch();
        if (match) {
            this.match = match;
            const menu = await this.notifyProviders(match);
            if (!this.match || !this.isMatchStillValid(match)) {
                this.match = null;
                this.deactivate();
                return;
            }
            if (menu) this.activate(match, menu);
            else this.deactivate();
        } else {
            this.match = null;
            this.deactivate();
        }
    }
    findMatch() {
        const cursor = this.input.selectionEnd || 0;
        const text = this.input.value;
        if (cursor <= this.lookBackIndex) this.lookBackIndex = cursor - 1;
        for (const { key: key, multiWord: multiWord } of this.expander.keys){
            const found = $f3c96cfcabe38876$var$query(text, key, cursor, {
                multiWord: multiWord,
                lookBackIndex: this.lookBackIndex,
                lastMatchPosition: this.match ? this.match.position : null
            });
            if (found) return {
                text: found.text,
                key: key,
                position: found.position
            };
        }
    }
    async notifyProviders(match) {
        const providers = [];
        const provide = (result)=>providers.push(result);
        const changeEvent = new CustomEvent('text-expander-change', {
            cancelable: true,
            detail: {
                provide: provide,
                text: match.text,
                key: match.key
            }
        });
        const canceled = !this.expander.dispatchEvent(changeEvent);
        if (canceled) return;
        const all = await Promise.all(providers);
        const fragments = all.filter((x)=>x.matched).map((x)=>x.fragment);
        return fragments[0];
    }
    onMousedown() {
        this.interactingWithList = true;
    }
    onKeydown(event) {
        if (event.key === 'Escape') {
            this.match = null;
            if (this.deactivate()) {
                this.lookBackIndex = this.input.selectionEnd || this.lookBackIndex;
                event.stopImmediatePropagation();
                event.preventDefault();
            }
        }
    }
}
class $f3c96cfcabe38876$export$2e2bcd8739ae039 extends HTMLElement {
    get keys() {
        const keysAttr = this.getAttribute('keys');
        const keys = keysAttr ? keysAttr.split(' ') : [];
        const multiWordAttr = this.getAttribute('multiword');
        const multiWord = multiWordAttr ? multiWordAttr.split(' ') : [];
        const globalMultiWord = multiWord.length === 0 && this.hasAttribute('multiword');
        return keys.map((key)=>({
                key: key,
                multiWord: globalMultiWord || multiWord.includes(key)
            }));
    }
    set keys(value) {
        this.setAttribute('keys', value);
    }
    connectedCallback() {
        const input = this.querySelector('input[type="text"], textarea');
        if (!(input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement)) return;
        const state = new $f3c96cfcabe38876$var$TextExpander(this, input);
        $f3c96cfcabe38876$var$states.set(this, state);
    }
    disconnectedCallback() {
        const state = $f3c96cfcabe38876$var$states.get(this);
        if (!state) return;
        state.destroy();
        $f3c96cfcabe38876$var$states.delete(this);
    }
    dismiss() {
        const state = $f3c96cfcabe38876$var$states.get(this);
        if (!state) return;
        state.dismissMenu();
    }
}
if (!window.customElements.get('text-expander')) {
    window.TextExpanderElement = $f3c96cfcabe38876$export$2e2bcd8739ae039;
    window.customElements.define('text-expander', $f3c96cfcabe38876$export$2e2bcd8739ae039);
}


const $12c3f7ece07822ce$export$df1c34db1371eeed = [
    {
        locale: 'ar',
        dir: 'rtl',
        en_name: 'Arabic',
        name: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629"
    },
    {
        locale: 'de',
        dir: 'ltr',
        en_name: 'German',
        name: 'Deutsch'
    },
    {
        locale: 'en',
        dir: 'ltr',
        en_name: 'English',
        name: 'English'
    },
    {
        locale: 'es',
        dir: 'ltr',
        en_name: 'Spanish',
        name: "Espa\xf1ol"
    },
    {
        locale: 'fil',
        dir: 'ltr',
        en_name: 'Filipino',
        name: 'Filipino'
    },
    {
        locale: 'fr',
        dir: 'ltr',
        en_name: 'French',
        name: "Fran\xe7ais"
    },
    {
        locale: 'ht',
        dir: 'ltr',
        en_name: 'Haitian Creole',
        name: "Krey\xf2l ayisyen"
    },
    {
        locale: 'hi',
        dir: 'ltr',
        en_name: 'Hindi',
        name: "\u0939\u093F\u0902\u0926\u0940"
    },
    {
        locale: 'mww',
        dir: 'ltr',
        en_name: 'Hmong Daw (Latin)',
        name: 'Hmoob'
    },
    {
        locale: 'it',
        dir: 'ltr',
        en_name: 'Italian',
        name: 'Italiano'
    },
    {
        locale: 'ja',
        dir: 'ltr',
        en_name: 'Japanese',
        name: "\u65E5\u672C\u8A9E"
    },
    {
        locale: 'ko',
        dir: 'ltr',
        en_name: 'Korean',
        name: "\uD55C\uAD6D\uC5B4"
    },
    {
        locale: 'fa',
        dir: 'rtl',
        en_name: 'Persian',
        name: "\u0641\u0627\u0631\u0633\u06CC"
    },
    {
        locale: 'ps',
        dir: 'rtl',
        en_name: 'Pashto',
        name: "\u067E\u069A\u062A\u0648"
    },
    {
        locale: 'pt',
        dir: 'ltr',
        en_name: 'Portuguese (Brazil)',
        name: "Portugu\xeas (Brasil)"
    },
    {
        locale: 'pt-pt',
        dir: 'ltr',
        en_name: 'Portuguese (Portugal)',
        name: "Portugu\xeas (Portugal)"
    },
    {
        locale: 'ru',
        dir: 'ltr',
        en_name: 'Russian',
        name: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    {
        locale: 'sm',
        dir: 'ltr',
        en_name: 'Samoan',
        name: "S\u0101moa"
    },
    {
        locale: 'so',
        dir: 'ltr',
        en_name: 'Somali',
        name: 'Soomaali'
    },
    {
        locale: 'th',
        dir: 'ltr',
        en_name: 'Thai',
        name: "\u0E44\u0E17\u0E22"
    },
    {
        locale: 'ur',
        dir: 'rtl',
        en_name: 'Urdu',
        name: "\u0627\u0631\u062F\u0648"
    },
    {
        locale: 'vi',
        dir: 'ltr',
        en_name: 'Vietnamese',
        name: "Ti\xea\u0301ngVi\xea\u0323t"
    },
    {
        locale: 'zh-hans',
        dir: 'ltr',
        en_name: 'Chinese (Simplified)',
        name: "\u4E2D\u6587 (\u7B80\u4F53)"
    },
    {
        locale: 'zh-hant',
        dir: 'ltr',
        en_name: 'Chinese (Traditional)',
        name: "\u4E2D\u6587 (\u7E41\u9AD4)"
    }
];
const $12c3f7ece07822ce$export$bc9baa0814b80b55 = $12c3f7ece07822ce$export$df1c34db1371eeed.reduce((p, c)=>{
    p[c.locale] = c;
    return p;
}, {});
const $12c3f7ece07822ce$export$d7f512c98c859244 = 'en';

// THIS IS A GENERATED FILE - DO NOT EDIT.
// EDIT strings.js INSTEAD, THEN RUN "npm run localize" TO REGENERATE.
const $b11db1b62d4a8f76$var$TEMPLATE_RESULT = Symbol.for('cumulus.templates.result');
/*#__NO_SIDE_EFFECTS__*/ function $b11db1b62d4a8f76$var$html(strings, ...values) {
    return {
        [$b11db1b62d4a8f76$var$TEMPLATE_RESULT]: true,
        strings: strings,
        values: values
    };
}
function $b11db1b62d4a8f76$export$a520d1ac34aa3762(s) {
    return s// Remove trailing underscores, including the whitespace preceding the trailing underscores
    .replace(/(?:\s+)?_+$/, '')// Replace "covid-19" with "COVID-19"
    .replace(/([^\s])?covid-19([\s$])?/g, '$1COVID-19$2');
}
function $b11db1b62d4a8f76$export$9e3208c5100f4979(locale, s) {
    /**
   * @type {Record<string, Record<string, string>>}
   */ const overrides = {
        es: {
            Hembra: 'Femenino'
        }
    };
    return overrides[locale]?.[s] ?? s;
}
const $b11db1b62d4a8f76$export$a996a7c3beb45c0a = {
    ar: `\u{634}\u{647}\u{631} \u{648}\u{627}\u{62D}\u{62F}`,
    de: `1 Monat`,
    es: `1 mes`,
    fa: `\u{6F1} \u{645}\u{627}\u{647}`,
    fil: `1 buwan`,
    fr: `1 mois`,
    hi: `1 \u{92E}\u{939}\u{93F}\u{928}\u{93E}`,
    ht: `1 mwa`,
    it: `1 mese`,
    ja: `1\u{30F6}\u{6708}`,
    ko: `1\u{AC1C}\u{C6D4}`,
    mww: `1 lub hlis`,
    ps: `\u{6F1} \u{645}\u{6CC}\u{627}\u{634}\u{62A}`,
    pt: `1 m\xeas`,
    'pt-pt': `1 m\xeas`,
    ru: `1 \u{43C}\u{435}\u{441}\u{44F}\u{446}`,
    sm: `1 masina`,
    so: `1 bil`,
    th: `1 \u{E40}\u{E14}\u{E37}\u{E2D}\u{E19}`,
    ur: `1 \u{645}\u{6C1}\u{6CC}\u{646}\u{6C1}`,
    vi: `1 th\xe1ng`,
    'zh-hans': `1\u{4E2A}\u{6708}`,
    'zh-hant': `1\u{500B}\u{6708}`,
    en: `1 month`
};
const $b11db1b62d4a8f76$export$d8d4c4e910c06e8a = {
    ar: `\u{623}\u{633}\u{628}\u{648}\u{639} \u{648}\u{627}\u{62D}\u{62F}`,
    de: `1 Woche`,
    es: `1 semana`,
    fa: `\u{6CC}\u{6A9} \u{647}\u{641}\u{62A}\u{647}`,
    fil: `1 linggo`,
    fr: `1 semaine`,
    hi: `1 \u{938}\u{92A}\u{94D}\u{924}\u{93E}\u{939}`,
    ht: `1 sem\xe8n`,
    it: `1 settimana`,
    ja: `1\u{9031}\u{9593}`,
    ko: `1\u{C8FC}`,
    mww: `1 lub lim tiam`,
    ps: `\u{6F1} \u{627}\u{648}\u{646}\u{6CD}`,
    pt: `1 semana`,
    'pt-pt': `1 semana`,
    ru: `1 \u{43D}\u{435}\u{434}\u{435}\u{43B}\u{44F}`,
    sm: `1 vaiaso`,
    so: `1 toddobaad`,
    th: `1 \u{E2A}\u{E31}\u{E1B}\u{E14}\u{E32}\u{E2B}\u{E4C}`,
    ur: `1 \u{6C1}\u{641}\u{62A}\u{6C1}`,
    vi: `1 tu\u{1EA7}n`,
    'zh-hans': `\u{4E00}\u{5468}`,
    'zh-hant': `\u{4E00}\u{9031}`,
    en: `1 week`
};
const $b11db1b62d4a8f76$export$78e136b5d4cefe6a = {
    ar: `\u{623}\u{633}\u{628}\u{648}\u{639}\u{627}\u{646}`,
    de: `2 Wochen`,
    es: `2 semanas`,
    fa: `\u{6F2} \u{647}\u{641}\u{62A}\u{647}`,
    fil: `2 linggo`,
    fr: `2 semaines`,
    hi: `2 \u{938}\u{92A}\u{94D}\u{924}\u{93E}\u{939}`,
    ht: `2 sem\xe8n`,
    it: `2 settimane`,
    ja: `2\u{9031}\u{9593}`,
    ko: `2\u{C8FC}`,
    mww: `2 lub lis piam`,
    ps: `\u{6F2} \u{627}\u{648}\u{646}\u{6CD}`,
    pt: `2 semanas`,
    'pt-pt': `2 semanas`,
    ru: `2 \u{43D}\u{435}\u{434}\u{435}\u{43B}\u{438}`,
    sm: `2 vaiaso`,
    so: `2 toddobaad`,
    th: `2 \u{E2A}\u{E31}\u{E1B}\u{E14}\u{E32}\u{E2B}\u{E4C}`,
    ur: `2 \u{6C1}\u{641}\u{62A}\u{6D2}`,
    vi: `2 tu\u{1EA7}n`,
    'zh-hans': `\u{4E24}\u{5468}`,
    'zh-hant': `\u{5169}\u{9031}`,
    en: `2 weeks`
};
const $b11db1b62d4a8f76$export$b55416bb887a061e = {
    ar: `3 \u{623}\u{64A}\u{627}\u{645}`,
    de: `3 Tage`,
    es: `3 d\xedas`,
    fa: `\u{6F3} \u{631}\u{648}\u{632}`,
    fil: `3 araw`,
    fr: `3 jours`,
    hi: `3 \u{926}\u{93F}\u{928}`,
    ht: `3 jou`,
    it: `3 giorni`,
    ja: `3\u{65E5}\u{9593}`,
    ko: `3\u{C77C}`,
    mww: `3 hnub`,
    ps: `\u{6F3} \u{648}\u{631}\u{681}\u{6D0}`,
    pt: `3 dias`,
    'pt-pt': `3 dias`,
    ru: `3 \u{434}\u{43D}\u{44F}`,
    sm: `3 aso`,
    so: `3 maalmood`,
    th: `3 \u{E27}\u{E31}\u{E19}`,
    ur: `3 \u{62F}\u{646}`,
    vi: `3 ng\xe0y`,
    'zh-hans': `3\u{5929}`,
    'zh-hant': `\u{4E09}\u{5929}`,
    en: `3 days`
};
const $b11db1b62d4a8f76$export$651ee9ff79413819 = {
    ar: `\u{62D}\u{648}\u{644}`,
    de: `\xdcber uns`,
    es: `Acerca de`,
    fa: `\u{62F}\u{631}\u{628}\u{627}\u{631}\u{647}`,
    fil: `Tungkol sa`,
    fr: `\xc0 propos`,
    hi: `\u{915}\u{947} \u{92C}\u{93E}\u{930}\u{947} \u{92E}\u{947}\u{902}`,
    ht: `A pwopo`,
    it: `Informazioni`,
    ja: `\u{6982}\u{8981}`,
    ko: `\u{C18C}\u{AC1C}`,
    mww: `Hais txog`,
    ps: `\u{67E}\u{647} \u{627}\u{693}\u{647}`,
    pt: `Sobre`,
    'pt-pt': `Sobre`,
    ru: `\u{41E} \u{43A}\u{43E}\u{43C}\u{43F}\u{430}\u{43D}\u{438}\u{438}`,
    sm: `E uiga i`,
    so: `Ku saabsan`,
    th: `\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E01}\u{E31}\u{E1A}`,
    ur: `\u{628}\u{627}\u{631}\u{6D2} \u{645}\u{6CC}\u{6BA}`,
    vi: `Gi\u{1EDB}i thi\u{1EC7}u`,
    'zh-hans': `\u{5173}\u{4E8E}`,
    'zh-hant': `\u{95DC}\u{65BC}`,
    en: `About`
};
const $b11db1b62d4a8f76$export$903fdd498f951277 = {
    ar: `\u{642}\u{628}\u{648}\u{644} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}`,
    de: `Unterschrift akzeptieren`,
    es: `Aceptar firma`,
    fa: `\u{627}\u{645}\u{636}\u{627} \u{631}\u{627} \u{628}\u{67E}\u{630}\u{6CC}\u{631}\u{6CC}\u{62F}`,
    fil: `Tanggapin ang lagda`,
    fr: `Accepter la signature`,
    hi: `\u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Aksepte siyati`,
    it: `Accetta firma`,
    ja: `\u{7F72}\u{540D}\u{3092}\u{53D7}\u{3051}\u{5165}\u{308C}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{C11C}\u{BA85} \u{C218}\u{B77D}`,
    mww: `Txais kos npe`,
    ps: `\u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{648}\u{645}\u{646}\u{626}`,
    pt: `Aceitar assinatura`,
    'pt-pt': `Aceitar assinatura`,
    ru: `\u{41F}\u{440}\u{438}\u{43D}\u{44F}\u{442}\u{44C} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Talia le saini`,
    so: `Aqbal saxiixa`,
    th: `\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{642}\u{628}\u{648}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EA5}p nh\u{1EAD}n ch\u{1EEF} k\xfd`,
    'zh-hans': `\u{63A5}\u{53D7}\u{7B7E}\u{540D}`,
    'zh-hant': `\u{63A5}\u{53D7}\u{7C3D}\u{540D}`,
    en: `Accept signature`
};
const $b11db1b62d4a8f76$export$af9ce948ae07c9f4 = {
    ar: `\u{627}\u{644}\u{62D}\u{633}\u{627}\u{628} \u{645}\u{633}\u{62C}\u{644} \u{628}\u{627}\u{644}\u{641}\u{639}\u{644}. \u{633}\u{62C}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{625}\u{644}\u{649} \u{62D}\u{633}\u{627}\u{628}\u{643}.`,
    de: `Konto bereits registriert. Melden Sie sich in Ihrem Konto an.`,
    es: `Cuenta ya registrada. Inicia sesi\xf3n en tu cuenta.`,
    fa: `\u{62D}\u{633}\u{627}\u{628} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{6CC} \u{642}\u{628}\u{644}\u{627} \u{62B}\u{628}\u{62A} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{648}\u{627}\u{631}\u{62F} \u{62D}\u{633}\u{627}\u{628} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{6CC} \u{62E}\u{648}\u{62F} \u{634}\u{648}\u{6CC}\u{62F}.`,
    fil: `Nakarehistro na ang account. Mag-sign in sa iyong account.`,
    fr: `Compte d\xe9j\xe0 enregistr\xe9. Connectez-vous \xe0 votre compte.`,
    hi: `\u{916}\u{93E}\u{924}\u{93E} \u{92A}\u{939}\u{932}\u{947} \u{938}\u{947} \u{939}\u{940} \u{92A}\u{902}\u{91C}\u{940}\u{915}\u{943}\u{924} \u{939}\u{948}\u{964} \u{905}\u{92A}\u{928}\u{947} \u{916}\u{93E}\u{924}\u{947} \u{92E}\u{947}\u{902} \u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{915}\u{930}\u{947}\u{902}.`,
    ht: `Kont deja anrejistre Siyen nan kont ou.`,
    it: `Account gi\xe0 registrato. Accedi al tuo account.`,
    ja: `\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{306F}\u{3059}\u{3067}\u{306B}\u{767B}\u{9332}\u{6E08}\u{307F}\u{3067}\u{3059}\u{3002}\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{306B}\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{ACC4}\u{C815}\u{C740} \u{C774}\u{BBF8} \u{B4F1}\u{B85D}\u{B418}\u{C5B4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}. \u{ACC4}\u{C815}\u{C5D0} \u{B85C}\u{ADF8}\u{C778}\u{D558}\u{C138}\u{C694}.`,
    mww: `Tus account twb sau npe lawm. Kos npe rau hauv koj tus account.`,
    ps: `\u{62D}\u{633}\u{627}\u{628} \u{62B}\u{628}\u{62A} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}. \u{62E}\u{67E}\u{644} \u{62D}\u{633}\u{627}\u{628} \u{62A}\u{647} \u{646}\u{646}\u{648}\u{62A}\u{644}.`,
    pt: `Conta j\xe1 registrada. Fa\xe7a login na sua conta.`,
    'pt-pt': `Conta j\xe1 registada. Inicia sess\xe3o na tua conta.`,
    ru: `\u{410}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442} \u{443}\u{436}\u{435} \u{437}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}. \u{412}\u{43E}\u{439}\u{434}\u{438}\u{442}\u{435} \u{432} \u{441}\u{432}\u{43E}\u{439} \u{430}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442}.`,
    sm: `Ua uma ona lesitala le teugatupe. Saini i totonu o lau teuga tupe.`,
    so: `Akoonka hore ayaa loo diiwaan geliyay. Gali akoonkaaga.`,
    th: `\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}\u{E17}\u{E35}\u{E48}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E41}\u{E25}\u{E49}\u{E27} \u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{67E}\u{6C1}\u{644}\u{6D2} \u{6C1}\u{6CC} \u{631}\u{62C}\u{633}\u{679}\u{631}\u{688} \u{6C1}\u{6D2}\u{6D4} \u{627}\u{67E}\u{646}\u{6D2} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{645}\u{6CC}\u{6BA} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `T\xe0i kho\u{1EA3}n \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c \u{111}\u{103}ng k\xfd. \u{110}\u{103}ng nh\u{1EAD}p v\xe0o t\xe0i kho\u{1EA3}n c\u{1EE7}a b\u{1EA1}n.`,
    'zh-hans': `\u{8D26}\u{6237}\u{5DF2}\u{6CE8}\u{518C}\u{3002}\u{767B}\u{5F55}\u{60A8}\u{7684}\u{8D26}\u{6237}\u{3002}`,
    'zh-hant': `\u{5E33}\u{865F}\u{5DF2}\u{7D93}\u{8A3B}\u{518A}\u{3002}\u{767B}\u{5165}\u{4F60}\u{7684}\u{5E33}\u{865F}\u{3002}`,
    en: `Account already registered. Sign in to your account.`
};
const $b11db1b62d4a8f76$export$122be8021d71ebff = {
    ar: `\u{625}\u{646}\u{634}\u{627}\u{621} \u{62D}\u{633}\u{627}\u{628}`,
    de: `Konto erstellt`,
    es: `Cuenta creada`,
    fa: `\u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{62D}\u{633}\u{627}\u{628} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{6CC}`,
    fil: `Email Address *`,
    fr: `Compte cr\xe9\xe9`,
    hi: `\u{916}\u{93E}\u{924}\u{93E} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Kont kreye`,
    it: `Account creato`,
    ja: `\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{4F5C}\u{6210}`,
    ko: `\u{ACC4}\u{C815} \u{C0DD}\u{C131}`,
    mww: `Tus account tsim`,
    ps: `\u{62D}\u{633}\u{627}\u{628} \u{62C}\u{648}\u{693} \u{634}\u{648}`,
    pt: `Conta criada`,
    'pt-pt': `Conta criada`,
    ru: `\u{410}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}`,
    sm: `Fausiaina o le teugatupe`,
    so: `Xisaab la sameeyay`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}`,
    ur: `\u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{628}\u{646}\u{627}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `\u{110}\xe3 t\u{1EA1}o t\xe0i kho\u{1EA3}n`,
    'zh-hans': `\u{521B}\u{5EFA}\u{8D26}\u{6237}`,
    'zh-hant': `\u{5E33}\u{865F}\u{5DF2}\u{5EFA}\u{7ACB}`,
    en: `Account created`
};
const $b11db1b62d4a8f76$export$ebace49c2dd9e366 = {
    ar: (provider)=>`\u{62A}\u{645} \u{631}\u{628}\u{637} \u{62D}\u{633}\u{627}\u{628}\u{643} ${provider} \u{628}\u{646}\u{62C}\u{627}\u{62D}.`,
    de: (provider)=>`Dein ${provider} wurde erfolgreich verkn\xfcpft.`,
    es: (provider)=>`Tu cuenta ${provider} fue vinculada correctamente.`,
    fa: (provider)=>`\u{62D}\u{633}\u{627}\u{628} ${provider} \u{634}\u{645}\u{627} \u{628}\u{627} \u{645}\u{648}\u{641}\u{642}\u{6CC}\u{62A} \u{644}\u{6CC}\u{646}\u{6A9} \u{634}\u{62F}.`,
    fil: (provider)=>`Matagumpay na na-link ang iyong ${provider} account.`,
    fr: (provider)=>`Votre compte ${provider} a \xe9t\xe9 li\xe9 avec succ\xe8s.`,
    hi: (provider)=>`\u{906}\u{92A}\u{915}\u{93E} ${provider} \u{916}\u{93E}\u{924}\u{93E} \u{938}\u{92B}\u{932}\u{924}\u{93E}\u{92A}\u{942}\u{930}\u{94D}\u{935}\u{915} \u{932}\u{93F}\u{902}\u{915} \u{939}\u{94B} \u{917}\u{92F}\u{93E} \u{925}\u{93E}.`,
    ht: (provider)=>`Kont ${provider} ou te lye av\xe8k siks\xe8.`,
    it: (provider)=>`Il tuo account ${provider} \xe8 stato collegato con successo.`,
    ja: (provider)=>`\u{3042}\u{306A}\u{305F}\u{306E} ${provider} \u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{306F}\u{6B63}\u{5E38}\u{306B}\u{9023}\u{643A}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: (provider)=>`${provider} \u{ACC4}\u{C815}\u{C774} \u{C131}\u{ACF5}\u{C801}\u{C73C}\u{B85C} \u{C5F0}\u{ACB0}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (provider)=>`Koj ${provider} tau ua tiav txuas.`,
    ps: (provider)=>`\u{633}\u{62A}\u{627} ${provider} \u{62D}\u{633}\u{627}\u{628} \u{628}\u{631}\u{6CC}\u{627}\u{644}\u{6CC} \u{644}\u{6CC}\u{646}\u{6A9} \u{634}\u{648}.`,
    pt: (provider)=>`Sua conta ${provider} foi vinculada com sucesso.`,
    'pt-pt': (provider)=>`A sua conta ${provider} foi ligada com sucesso.`,
    ru: (provider)=>`\u{412}\u{430}\u{448} ${provider} \u{431}\u{44B}\u{43B} \u{443}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}.`,
    sm: (provider)=>`O lau ${provider} account na fa'afeso'ota'i ma le manuia.`,
    so: (provider)=>`Akoonkaaga ${provider} si guul leh ayaa loo xidhay.`,
    th: (provider)=>`\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35} ${provider} \u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E40}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E21}\u{E42}\u{E22}\u{E07}\u{E2A}\u{E4D}\u{E32}\u{E40}\u{E23}\u{E47}\u{E08}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: (provider)=>`\u{622}\u{67E} ${provider} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{6A9}\u{627}\u{645}\u{6CC}\u{627}\u{628}\u{6CC} \u{633}\u{6D2} \u{644}\u{646}\u{6A9} \u{6C1}\u{648} \u{6AF}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (provider)=>`T\xe0i kho\u{1EA3}n ${provider} c\u{1EE7}a b\u{1EA1}n \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c li\xean k\u{1EBF}t th\xe0nh c\xf4ng.`,
    'zh-hans': (provider)=>`\u{4F60}\u{7684} ${provider} \u{8D26}\u{6237}\u{5DF2}\u{6210}\u{529F}\u{5173}\u{8054}\u{3002}`,
    'zh-hant': (provider)=>`\u{4F60}\u{7684} ${provider} \u{5E33}\u{865F}\u{5DF2}\u{7D93}\u{6210}\u{529F}\u{9023}\u{7D50}\u{3002}`,
    en: (provider)=>`Your ${provider} account was successfully linked.`
};
const $b11db1b62d4a8f76$export$434691f2da57df3b = {
    ar: (cumulus)=>`\u{645}\u{631}\u{62D}\u{628}\u{627} \u{628}\u{643}\u{645} \u{641}\u{64A} ${cumulus}! \u{633}\u{62C}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{644}\u{628}\u{62F}\u{621} \u{627}\u{644}\u{62A}\u{639}\u{627}\u{648}\u{646}.`,
    de: (cumulus)=>`Willkommen bei ${cumulus}! Melden Sie sich an, um mit der Zusammenarbeit zu beginnen.`,
    es: (cumulus)=>`\xa1Bienvenido a ${cumulus}! Inicia sesi\xf3n para empezar a colaborar.`,
    fa: (cumulus)=>`\u{628}\u{647} ${cumulus} \u{62E}\u{648}\u{634} \u{622}\u{645}\u{62F}\u{6CC}\u{62F}! \u{628}\u{631}\u{627}\u{6CC} \u{634}\u{631}\u{648}\u{639} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{6CC} \u{648}\u{627}\u{631}\u{62F} \u{634}\u{648}\u{6CC}\u{62F}.`,
    fil: (cumulus)=>`Maligayang pagdating sa ${cumulus}! Mag-sign in upang simulan ang pakikipagtulungan.`,
    fr: (cumulus)=>`Bienvenue chez ${cumulus} ! Connectez-vous pour commencer \xe0 collaborer.`,
    hi: (cumulus)=>`${cumulus} \u{92E}\u{947}\u{902} \u{906}\u{92A}\u{915}\u{93E} \u{938}\u{94D}\u{935}\u{93E}\u{917}\u{924} \u{939}\u{948}! \u{938}\u{939}\u{92F}\u{94B}\u{917} \u{936}\u{941}\u{930}\u{942} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: (cumulus)=>`Byenveni nan ${cumulus}! Siyen pou k\xf2manse kolabore.`,
    it: (cumulus)=>`Benvenuto su ${cumulus}! Accedi per iniziare a collaborare.`,
    ja: (cumulus)=>`${cumulus}\u{3078}\u{3088}\u{3046}\u{3053}\u{305D}!\u{30B3}\u{30E9}\u{30DC}\u{30EC}\u{30FC}\u{30B7}\u{30E7}\u{30F3}\u{3092}\u{59CB}\u{3081}\u{308B}\u{306B}\u{306F}\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: (cumulus)=>`${cumulus}\u{C5D0} \u{C624}\u{C2E0} \u{AC83}\u{C744} \u{D658}\u{C601}\u{D569}\u{B2C8}\u{B2E4}! \u{D611}\u{C5C5}\u{C744} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} \u{B85C}\u{ADF8}\u{C778}\u{D558}\u{C138}\u{C694}.`,
    mww: (cumulus)=>`Zoo siab txais tos rau ${cumulus}! Kos npe rau hauv pib sib koom tes.`,
    ps: (cumulus)=>`${cumulus} \u{62A}\u{647} \u{69A}\u{647} \u{631}\u{627}\u{63A}\u{644}\u{627}\u{633}\u{62A}! \u{62F} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{6CD} \u{67E}\u{6CC}\u{644} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{646}\u{646}\u{648}\u{62A}\u{644}.`,
    pt: (cumulus)=>`Bem-vindo \xe0 ${cumulus}! Fa\xe7a login para come\xe7ar a colaborar.`,
    'pt-pt': (cumulus)=>`Bem-vindo \xe0 ${cumulus}! Inicia sess\xe3o para come\xe7ares a colaborar.`,
    ru: (cumulus)=>`\u{414}\u{43E}\u{431}\u{440}\u{43E} \u{43F}\u{43E}\u{436}\u{430}\u{43B}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{432} ${cumulus}! \u{412}\u{43E}\u{439}\u{434}\u{438}\u{442}\u{435} \u{432} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C} \u{441}\u{43E}\u{432}\u{43C}\u{435}\u{441}\u{442}\u{43D}\u{443}\u{44E} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{443}.`,
    sm: (cumulus)=>`Fa'afeiloa'i i ${cumulus}! Saini i totonu e amata galulue fa'atasi.`,
    so: (cumulus)=>`Ku soo dhawoow ${cumulus}! Isdiiwaangeli si aad iskaashi u bilowdo.`,
    th: (cumulus)=>`\u{E22}\u{E34}\u{E19}\u{E14}\u{E35}\u{E15}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E31}\u{E1A}\u{E2A}\u{E39}\u{E48} ${cumulus}! \u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E31}\u{E19}`,
    ur: (cumulus)=>`${cumulus} \u{645}\u{6CC}\u{6BA} \u{62E}\u{648}\u{634} \u{622}\u{645}\u{62F}\u{6CC}\u{62F}! \u{62A}\u{639}\u{627}\u{648}\u{646} \u{634}\u{631}\u{648}\u{639} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (cumulus)=>`Ch\xe0o m\u{1EEB}ng b\u{1EA1}n \u{111}\u{1EBF}n v\u{1EDB}i ${cumulus}! \u{110}\u{103}ng nh\u{1EAD}p \u{111}\u{1EC3} b\u{1EAF}t \u{111}\u{1EA7}u c\u{1ED9}ng t\xe1c.`,
    'zh-hans': (cumulus)=>`\u{6B22}\u{8FCE}\u{6765}\u{5230} ${cumulus}\u{FF01}\u{767B}\u{5F55}\u{5373}\u{53EF}\u{5F00}\u{59CB}\u{5408}\u{4F5C}\u{3002}`,
    'zh-hant': (cumulus)=>`\u{6B61}\u{8FCE}\u{4F86}\u{5230} ${cumulus}\u{FF01}\u{767B}\u{5165}\u{4EE5}\u{958B}\u{59CB}\u{5408}\u{4F5C}\u{3002}`,
    en: (cumulus)=>`Welcome to ${cumulus}! Sign in to start collaborating.`
};
const $b11db1b62d4a8f76$export$46084b934956323f = {
    ar: `\u{627}\u{644}\u{62D}\u{62F}\u{62B}`,
    de: `Aktion`,
    es: `Acci\xf3n`,
    fa: `\u{639}\u{645}\u{644}\u{6CC}\u{627}\u{62A}`,
    fil: `Aksyon`,
    fr: `Action`,
    hi: `\u{92E}\u{941}\u{915}\u{93C}\u{926}\u{92E}\u{93E}`,
    ht: `Aksyon`,
    it: `Azione`,
    ja: `\u{6226}\u{95D8}`,
    ko: `\u{C791}\u{C804}`,
    mww: `Kev nqis tes ua`,
    ps: `\u{639}\u{645}\u{644}`,
    pt: `A\xe7\xe3o`,
    'pt-pt': `A\xe7\xe3o`,
    ru: `\u{411}\u{43E}\u{439}`,
    sm: `Faatinoga`,
    so: `Ficil`,
    th: `\u{E01}\u{E32}\u{E23}\u{E01}\u{E23}\u{E30}\u{E17}\u{E4D}\u{E32}`,
    ur: `\u{6A9}\u{627}\u{631}\u{631}\u{648}\u{627}\u{626}\u{6CC}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{884C}\u{52A8}`,
    'zh-hant': `\u{884C}\u{52D5}`,
    en: `Action`
};
const $b11db1b62d4a8f76$export$145bab8279e1c23d = {
    ar: `\u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621} \u{627}\u{644}\u{645}\u{637}\u{644}\u{648}\u{628}`,
    de: `Handlungsbedarf`,
    es: `Se requiere acci\xf3n`,
    fa: `\u{627}\u{642}\u{62F}\u{627}\u{645} \u{644}\u{627}\u{632}\u{645} \u{627}\u{633}\u{62A}`,
    fil: `Kinakailangan ang aksyon`,
    fr: `Action requise`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{930}\u{935}\u{93E}\u{908} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{948}`,
    ht: `Aksyon obligatwa`,
    it: `Azione richiesta`,
    ja: `\u{5FC5}\u{8981}\u{306A}\u{884C}\u{52D5}`,
    ko: `\u{C870}\u{CE58} \u{D544}\u{C694}`,
    mww: `Yuav tsum tau nqis tes ua`,
    ps: `\u{627}\u{642}\u{62F}\u{627}\u{645} \u{62A}\u{647} \u{627}\u{693}\u{62A}\u{6CC}\u{627} \u{62F}\u{647}`,
    pt: `A\xe7\xe3o necess\xe1ria`,
    'pt-pt': `A\xe7\xe3o necess\xe1ria`,
    ru: `\u{422}\u{440}\u{435}\u{431}\u{443}\u{44E}\u{442}\u{441}\u{44F} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    sm: `Faatinoga e manaomia`,
    so: `Tallaabo loo baahan yahay`,
    th: `\u{E01}\u{E32}\u{E23}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E08}\u{E4D}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19}`,
    ur: `\u{6A9}\u{627}\u{631}\u{631}\u{648}\u{627}\u{626}\u{6CC} \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2}`,
    vi: `H\xe0nh \u{111}\u{1ED9}ng b\u{1EAF}t bu\u{1ED9}c`,
    'zh-hans': `\u{9700}\u{8981}\u{91C7}\u{53D6}\u{884C}\u{52A8}`,
    'zh-hant': `\u{9700}\u{8981}\u{63A1}\u{53D6}\u{884C}\u{52D5}`,
    en: `Action required`
};
const $b11db1b62d4a8f76$export$5be663618fa0493a = {
    ar: `\u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A}`,
    de: `Aktionen`,
    es: `Acciones`,
    fa: `\u{627}\u{642}\u{62F}\u{627}\u{645}\u{627}\u{62A}`,
    fil: `Mga Pagkilos`,
    fr: `Actions`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{930}\u{935}\u{93E}\u{908}`,
    ht: `Aksyon yo`,
    it: `Azioni`,
    ja: `\u{884C}\u{52D5}`,
    ko: `\u{C791}\u{C804}`,
    mww: `Kev Ua`,
    ps: `\u{6A9}\u{693}\u{646}\u{6D0}`,
    pt: `A\xe7\xf5es`,
    'pt-pt': `A\xe7\xf5es`,
    ru: `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    sm: `Faatinoga`,
    so: `Falalka`,
    th: `\u{E01}\u{E32}\u{E23}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{6A9}\u{627}\u{631}\u{631}\u{648}\u{627}\u{626}\u{6CC}\u{627}\u{6BA}`,
    vi: `H\xe0nh \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{884C}\u{52A8}`,
    'zh-hant': `\u{884C}\u{52D5}`,
    en: `Actions`
};
const $b11db1b62d4a8f76$export$42dfd041112bce24 = {
    ar: `\u{646}\u{634}\u{637}`,
    de: `Aktiv`,
    es: `Activo`,
    fa: `\u{641}\u{639}\u{627}\u{644}`,
    fil: `Aktibo`,
    fr: `Actifs`,
    hi: `\u{938}\u{915}\u{94D}\u{930}\u{93F}\u{92F}`,
    ht: `Aktif`,
    it: `Attivo`,
    ja: `\u{73FE}\u{5F79}`,
    ko: `\u{D65C}\u{C131}`,
    mww: `nquag`,
    ps: `\u{641}\u{639}\u{627}\u{644}`,
    pt: `Ativo`,
    'pt-pt': `Ativo`,
    ru: `\u{410}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{44B}\u{435}`,
    sm: `Toaga`,
    so: `Firfircoon`,
    th: `\u{E04}\u{E25}\u{E48}\u{E2D}\u{E07}\u{E41}\u{E04}\u{E25}\u{E48}\u{E27}`,
    ur: `\u{641}\u{639}\u{627}\u{644}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{6D3B}\u{8DC3}`,
    'zh-hant': `\u{73FE}\u{5F79}`,
    en: `Active`
};
const $b11db1b62d4a8f76$export$c649626dc103486 = {
    ar: `\u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629}`,
    de: `Aktivit\xe4ten`,
    es: `Actividades`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}`,
    fil: `Mga Aktibidad`,
    fr: `Activit\xe9s`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `Aktivite yo`,
    it: `Attivit\xe0`,
    ja: `\u{6D3B}\u{52D5}`,
    ko: `\u{D65C}\u{B3D9}`,
    mww: `Kev Ua Si`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Atividades`,
    'pt-pt': `Atividades`,
    ru: `\u{414}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Gaoioiga`,
    so: `Hawlaha`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{6D3B}\u{52D5}`,
    en: `Activities`
};
const $b11db1b62d4a8f76$export$3a7601aff7973201 = {
    ar: (count)=>`${count} \u{623}\u{646}\u{634}\u{637}\u{629}`,
    de: (count)=>`${count} Aktivit\xe4ten`,
    es: (count)=>`${count} actividades`,
    fa: (count)=>`${count} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    fil: (count)=>`${count} Mga Aktibidad`,
    fr: (count)=>`${count} activit\xe9s`,
    hi: (count)=>`${count} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: (count)=>`${count} Aktivite`,
    it: (count)=>`${count} attivit\xe0`,
    ja: (count)=>`${count} \u{3064}\u{306E}\u{6D3B}\u{52D5}`,
    ko: (count)=>`${count} \u{AC00}\u{C9C0} \u{D65C}\u{B3D9}`,
    mww: (count)=>`${count} kev ua ub no`,
    ps: (count)=>`${count} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: (count)=>`${count} atividades`,
    'pt-pt': (count)=>`${count} Atividades`,
    ru: (count)=>`${count} \u{432}\u{438}\u{434}\u{43E}\u{432} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: (count)=>`${count} Gaoioiga`,
    so: (count)=>`${count} Hawlo`,
    th: (count)=>`${count} \u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: (count)=>`${count} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}`,
    vi: (count)=>`${count} ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': (count)=>`${count} \u{6D3B}\u{52A8}`,
    'zh-hant': (count)=>`${count} \u{6D3B}\u{52D5}`,
    en: (count)=>`${count} activities`
};
const $b11db1b62d4a8f76$export$7b385c33eaf64565 = {
    ar: `\u{627}\u{644}\u{646}\u{634}\u{627}\u{637}`,
    de: `T\xe4tigkeit`,
    es: `Actividad`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}`,
    fil: `Aktibidad`,
    fr: `Activit\xe9`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}`,
    ht: `Aktivite`,
    it: `Attivit\xe0`,
    ja: `\u{6D3B}\u{52D5}`,
    ko: `\u{D65C}\u{B3D9}`,
    mww: `Kev Ua Si`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    pt: `Atividade`,
    'pt-pt': `Atividade`,
    ru: `\u{414}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Gaoioiga`,
    so: `Hawlaha`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{6D3B}\u{52D5}`,
    en: `Activity`
};
const $b11db1b62d4a8f76$export$8c6db5e01ccfbb18 = {
    ar: `\u{62A}\u{639}\u{631}\u{64A}\u{641} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}`,
    de: `Aktivit\xe4tsdefinition`,
    es: `Definici\xf3n de actividad`,
    fa: `\u{62A}\u{639}\u{631}\u{6CC}\u{641} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    fil: `Kahulugan ng aktibidad`,
    fr: `D\xe9finition de l\u{2019}activit\xe9`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930}\u{93F}\u{92D}\u{93E}\u{937}\u{93E}`,
    ht: `Definisyon aktivite`,
    it: `Definizione dell'attivit\xe0`,
    ja: `\u{6D3B}\u{52D5}\u{306E}\u{5B9A}\u{7FA9}`,
    ko: `\u{D65C}\u{B3D9} \u{C815}\u{C758}`,
    mww: `Kev ua haujlwm txhais`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{639}\u{631}\u{6CC}\u{641}`,
    pt: `Defini\xe7\xe3o de atividade`,
    'pt-pt': `Defini\xe7\xe3o de atividade`,
    ru: `\u{41E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Fa'amatalaga o le gaioiga`,
    so: `Qeexidda hawlaha`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E08}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E14}\u{E04}\u{E27}\u{E32}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6CC} \u{62A}\u{639}\u{631}\u{6CC}\u{641}`,
    vi: `\u{110}\u{1ECB}nh ngh\u{129}a ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{6D3B}\u{52A8}\u{5B9A}\u{4E49}`,
    'zh-hant': `\u{6D3B}\u{52D5}\u{5B9A}\u{7FA9}`,
    en: `Activity definition`
};
const $b11db1b62d4a8f76$export$89c7954a99376945 = {
    ar: (entityType)=>`\u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{645}\u{627}\u{62A} \u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631}\u{64A}\u{629} \u{648}\u{633}\u{62A}\u{638}\u{647}\u{631} \u{641}\u{64A} \u{623}\u{639}\u{644}\u{649} \u{643}\u{644} ${entityType}.`,
    de: (entityType)=>`Anweisungen sind optional und erscheinen am Anfang jeder ${entityType}.`,
    es: (entityType)=>`Las instrucciones son opcionales y aparecer\xe1n al principio de cada ${entityType}.`,
    fa: (entityType)=>`\u{62F}\u{633}\u{62A}\u{648}\u{631}\u{627}\u{644}\u{639}\u{645}\u{644} \u{647}\u{627} \u{627}\u{62E}\u{62A}\u{6CC}\u{627}\u{631}\u{6CC} \u{647}\u{633}\u{62A}\u{646}\u{62F} \u{648} \u{62F}\u{631} \u{627}\u{628}\u{62A}\u{62F}\u{627}\u{6CC} \u{647}\u{631} ${entityType} \u{638}\u{627}\u{647}\u{631} \u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: (entityType)=>`Ang mga tagubilin ay opsyonal at lilitaw sa tuktok ng bawat ${entityType}.`,
    fr: (entityType)=>`Les instructions sont optionnelles et appara\xeetront en haut de chaque ${entityType}.`,
    hi: (entityType)=>`\u{928}\u{93F}\u{930}\u{94D}\u{926}\u{947}\u{936} \u{935}\u{948}\u{915}\u{932}\u{94D}\u{92A}\u{93F}\u{915} \u{939}\u{948}\u{902} \u{914}\u{930} \u{92A}\u{94D}\u{930}\u{924}\u{94D}\u{92F}\u{947}\u{915} ${entityType} \u{915}\u{947} \u{936}\u{940}\u{930}\u{94D}\u{937} \u{92A}\u{930} \u{926}\u{93F}\u{916}\u{93E}\u{908} \u{926}\u{947}\u{902}\u{917}\u{947}\u{964}`,
    ht: (entityType)=>`Enstriksyon yo si ou vle epi yo pral par\xe8t nan t\xe8t chak ${entityType}.`,
    it: (entityType)=>`Le istruzioni sono opzionali e appariranno in cima a ogni ${entityType}.`,
    ja: (entityType)=>`\u{6307}\u{793A}\u{306F}\u{4EFB}\u{610F}\u{3067}\u{3001}\u{5404} ${entityType}\u{306E}\u{4E0A}\u{90E8}\u{306B}\u{8868}\u{793A}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: (entityType)=>`\u{C9C0}\u{CE68}\u{C740} \u{C120}\u{D0DD} \u{C0AC}\u{D56D}\u{C774}\u{BA70} \u{AC01} ${entityType} \u{C0C1}\u{B2E8}\u{C5D0} \u{B098}\u{D0C0}\u{B0A9}\u{B2C8}\u{B2E4}.`,
    mww: (entityType)=>`Cov lus qhia yog yeem thiab yuav tshwm sim rau sab saum toj ntawm txhua ${entityType}.`,
    ps: (entityType)=>`\u{644}\u{627}\u{631}\u{69A}\u{648}\u{648}\u{646}\u{6D0} \u{627}\u{62E}\u{62A}\u{6CC}\u{627}\u{631}\u{6CC} \u{62F}\u{6CC} \u{627}\u{648} \u{62F} \u{647}\u{631}\u{6D0} ${entityType} \u{67E}\u{647} \u{633}\u{631} \u{6A9}\u{6D0} \u{685}\u{631}\u{6AB}\u{646}\u{62F}\u{6CC}\u{696}\u{6CC}.`,
    pt: (entityType)=>`As instru\xe7\xf5es s\xe3o opcionais e aparecer\xe3o no topo de cada ${entityType}.`,
    'pt-pt': (entityType)=>`As instru\xe7\xf5es s\xe3o opcionais e aparecem no topo de cada ${entityType}.`,
    ru: (entityType)=>`\u{418}\u{43D}\u{441}\u{442}\u{440}\u{443}\u{43A}\u{446}\u{438}\u{438} \u{43D}\u{435}\u{43E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B} \u{438} \u{431}\u{443}\u{434}\u{443}\u{442} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{432} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{435} ${entityType}.`,
    sm: (entityType)=>`O faatonuga e faitaliatia ma o le a faaali mai i le pito i luga o ${entityType} taitasi.`,
    so: (entityType)=>`Tilmaamuhu waa ikhtiyaari waxayna ka soo muuqan doonaan dusha sare ee ${entityType} kasta.`,
    th: (entityType)=>`\u{E27}\u{E34}\u{E18}\u{E35}\u{E01}\u{E32}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E17}\u{E32}\u{E07}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E41}\u{E25}\u{E30}\u{E08}\u{E30}\u{E1B}\u{E23}\u{E32}\u{E01}\u{E0F}\u{E17}\u{E35}\u{E48}\u{E14}\u{E49}\u{E32}\u{E19}\u{E1A}\u{E19}\u{E02}\u{E2D}\u{E07}${entityType}`,
    ur: (entityType)=>`\u{6C1}\u{62F}\u{627}\u{6CC}\u{627}\u{62A} \u{627}\u{62E}\u{62A}\u{6CC}\u{627}\u{631}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{6C1}\u{631} ${entityType} \u{6A9}\u{6D2} \u{627}\u{648}\u{67E}\u{631} \u{638}\u{627}\u{6C1}\u{631} \u{6C1}\u{648}\u{6BA} \u{6AF}\u{6CC}\u{6D4}`,
    vi: (entityType)=>`H\u{1B0}\u{1EDB}ng d\u{1EAB}n l\xe0 t\xf9y ch\u{1ECD}n v\xe0 s\u{1EBD} xu\u{1EA5}t hi\u{1EC7}n \u{1EDF} \u{111}\u{1EA7}u m\u{1ED7}i ${entityType}.`,
    'zh-hans': (entityType)=>`\u{8BF4}\u{660E}\u{662F}\u{53EF}\u{9009}\u{7684}\u{FF0C}\u{4F1A}\u{663E}\u{793A}\u{5728}\u{6BCF}\u{4E2A} ${entityType}\u{7684}\u{9876}\u{90E8}\u{3002}`,
    'zh-hant': (entityType)=>`\u{8AAA}\u{660E}\u{66F8}\u{70BA}\u{53EF}\u{9078}\u{FF0C}\u{6703}\u{986F}\u{793A}\u{5728}\u{6BCF}\u{500B} ${entityType}\u{7684}\u{9802}\u{7AEF}\u{3002}`,
    en: (entityType)=>`Instructions are optional and will appear at the top of each ${entityType}.`
};
const $b11db1b62d4a8f76$export$5a2dd80712c90361 = {
    ar: `\u{62A}\u{639}\u{631}\u{64A}\u{641}\u{627}\u{62A} \u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629}`,
    de: `Aktivit\xe4tsdefinitionen`,
    es: `Definiciones de actividades`,
    fa: `\u{62A}\u{639}\u{627}\u{631}\u{6CC}\u{641} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}`,
    fil: `Mga kahulugan ng aktibidad`,
    fr: `D\xe9finitions d\u{2019}activit\xe9s`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930}\u{93F}\u{92D}\u{93E}\u{937}\u{93E}\u{90F}\u{901}`,
    ht: `Definisyon aktivite`,
    it: `Definizioni di attivit\xe0`,
    ja: `\u{6D3B}\u{52D5}\u{306E}\u{5B9A}\u{7FA9}`,
    ko: `\u{D65C}\u{B3D9} \u{C815}\u{C758}`,
    mww: `Cov lus txhais ntawm kev ua ub no`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{639}\u{631}\u{6CC}\u{641}\u{648}\u{646}\u{647}`,
    pt: `Defini\xe7\xf5es de atividades`,
    'pt-pt': `Defini\xe7\xf5es de atividades`,
    ru: `\u{41E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Faauigaga o gaoioiga`,
    so: `Qeexitaannada hawlaha`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E08}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E14}\u{E04}\u{E27}\u{E32}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{648}\u{6BA} \u{6A9}\u{6CC} \u{62A}\u{639}\u{631}\u{6CC}\u{641}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{1ECB}nh ngh\u{129}a ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{6D3B}\u{52A8}\u{5B9A}\u{4E49}`,
    'zh-hant': `\u{6D3B}\u{52D5}\u{5B9A}\u{7FA9}`,
    en: `Activity definitions`
};
const $b11db1b62d4a8f76$export$8e4ca99cc58f6f3e = {
    ar: `\u{633}\u{62C}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}\u{60C} \u{628}\u{627}\u{644}\u{625}\u{636}\u{627}\u{641}\u{629} \u{625}\u{644}\u{649} \u{627}\u{644}\u{62A}\u{631}\u{643}\u{64A}\u{628}\u{629} \u{627}\u{644}\u{633}\u{643}\u{627}\u{646}\u{64A}\u{629} \u{644}\u{644}\u{634}\u{62E}\u{635} \u{627}\u{644}\u{645}\u{639}\u{646}\u{64A} \u{648}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644} \u{628}\u{647}.`,
    de: `Aktivit\xe4tsaufzeichnungen sowie die demografischen Angaben und Kontaktdaten der zugeh\xf6rigen Person.`,
    es: `Registros de actividades, junto con la demograf\xeda y la informaci\xf3n de contacto de la persona asociada.`,
    fa: `\u{633}\u{648}\u{627}\u{628}\u{642} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{60C} \u{647}\u{645}\u{631}\u{627}\u{647} \u{628}\u{627} \u{62C}\u{645}\u{639}\u{6CC}\u{62A} \u{634}\u{646}\u{627}\u{633}\u{6CC} \u{648} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{62A}\u{645}\u{627}\u{633} \u{641}\u{631}\u{62F} \u{645}\u{631}\u{62A}\u{628}\u{637}.`,
    fil: `Mga talaan ng aktibidad, kasama ang demograpiko at impormasyon sa pakikipag-ugnay ng nauugnay na tao.`,
    fr: `Des dossiers d\u{2019}activit\xe9, ainsi que la d\xe9mographie et les coordonn\xe9es de la personne associ\xe9e.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921}, \u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F} \u{915}\u{940} \u{91C}\u{928}\u{938}\u{93E}\u{902}\u{916}\u{94D}\u{92F}\u{93F}\u{915}\u{940} \u{914}\u{930} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{91C}\u{93E}\u{928}\u{915}\u{93E}\u{930}\u{940} \u{915}\u{947} \u{938}\u{93E}\u{925}\u{964}`,
    ht: `Dosye aktivite, ansanm ak demografik moun ki asosye ak enf\xf2masyon kontak.`,
    it: `Registri delle attivit\xe0, insieme alla demografia e alle informazioni di contatto della persona associata.`,
    ja: `\u{6D3B}\u{52D5}\u{8A18}\u{9332}\u{3001}\u{95A2}\u{9023}\u{3059}\u{308B}\u{4EBA}\u{7269}\u{306E}\u{4EBA}\u{53E3}\u{7D71}\u{8A08}\u{3084}\u{9023}\u{7D61}\u{5148}\u{60C5}\u{5831}\u{3082}\u{542B}\u{3081}\u{3066}\u{3002}`,
    ko: `\u{D65C}\u{B3D9} \u{AE30}\u{B85D}\u{ACFC} \u{AD00}\u{B828}\u{B41C} \u{C0AC}\u{B78C}\u{C758} \u{C778}\u{AD6C}\u{D1B5}\u{ACC4} \u{BC0F} \u{C5F0}\u{B77D}\u{CC98} \u{C815}\u{BCF4}.`,
    mww: `Cov ntaub ntawv ua ub no, nrog rau tus neeg koom nrog cov pej xeem thiab cov ntaub ntawv tiv tauj.`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689}\u{648}\u{646}\u{647}\u{60C} \u{62F} \u{627}\u{693}\u{648}\u{646}\u{62F} \u{6A9}\u{633} \u{646}\u{641}\u{648}\u{633} \u{627}\u{648} \u{62F} \u{62A}\u{645}\u{627}\u{633} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}.`,
    pt: `Registros de atividades, junto com a demografia e informa\xe7\xf5es de contato da pessoa associada.`,
    'pt-pt': `Registos de atividades, juntamente com a demografia e informa\xe7\xf5es de contacto da pessoa associada.`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{438} \u{43E} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{438}, \u{430} \u{442}\u{430}\u{43A}\u{436}\u{435} \u{434}\u{435}\u{43C}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{435} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{438} \u{43A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}\u{43D}\u{44B}\u{435} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{441}\u{43E}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{435}\u{433}\u{43E} \u{43B}\u{438}\u{446}\u{430}.`,
    sm: `Faamaumauga o gaoioiga, faatasi ai ma le faitau aofai o tagata e fesootai ma faamatalaga e faafesootai ai.`,
    so: `Diiwaanka hawlaha, iyo sidoo kale tirakoobka dadka la xiriira iyo macluumaadka xiriirka.`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21} \u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E01}\u{E31}\u{E1A}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E1B}\u{E23}\u{E30}\u{E0A}\u{E32}\u{E01}\u{E23}\u{E41}\u{E25}\u{E30}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E02}\u{E2D}\u{E07}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{648}\u{6BA} \u{6A9}\u{6D2} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688}\u{632}\u{60C} \u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1} \u{634}\u{62E}\u{635} \u{6A9}\u{6CC} \u{622}\u{628}\u{627}\u{62F}\u{6CC}\u{627}\u{62A}\u{6CC} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{627}\u{648}\u{631} \u{631}\u{627}\u{628}\u{637}\u{6C1} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}\u{6D4}`,
    vi: `H\u{1ED3} s\u{1A1} ho\u{1EA1}t \u{111}\u{1ED9}ng, c\xf9ng v\u{1EDB}i th\xf4ng tin nh\xe2n kh\u{1EA9}u h\u{1ECD}c v\xe0 li\xean h\u{1EC7} c\u{1EE7}a ng\u{1B0}\u{1EDD}i \u{111}\u{1B0}\u{1EE3}c li\xean k\u{1EBF}t.`,
    'zh-hans': `\u{6D3B}\u{52A8}\u{8BB0}\u{5F55}\u{FF0C}\u{4EE5}\u{53CA}\u{76F8}\u{5173}\u{4EBA}\u{5458}\u{7684}\u{4EBA}\u{53E3}\u{7EDF}\u{8BA1}\u{548C}\u{8054}\u{7CFB}\u{65B9}\u{5F0F}\u{3002}`,
    'zh-hant': `\u{6D3B}\u{52D5}\u{7D00}\u{9304}\u{FF0C}\u{4EE5}\u{53CA}\u{76F8}\u{95DC}\u{4EBA}\u{54E1}\u{7684}\u{4EBA}\u{53E3}\u{7D71}\u{8A08}\u{8CC7}\u{6599}\u{548C}\u{806F}\u{7D61}\u{8CC7}\u{8A0A}\u{3002}`,
    en: `Activity records, along with the associated person's demographics and contact information.`
};
const $b11db1b62d4a8f76$export$e02107cc34dfe9c5 = {
    ar: `\u{625}\u{636}\u{627}\u{641}\u{629} \u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Adresse hinzuf\xfcgen`,
    es: `A\xf1adir direcci\xf3n`,
    fa: `\u{627}\u{641}\u{632}\u{648}\u{62F}\u{646} \u{622}\u{62F}\u{631}\u{633}`,
    fil: `Email Address`,
    fr: `Ajouter l\u{2019}adresse`,
    hi: `\u{92A}\u{924}\u{93E} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Ajoute adr\xe8s`,
    it: `Aggiungi indirizzo`,
    ja: `\u{30A2}\u{30C9}\u{30EC}\u{30B9}\u{3092}\u{8FFD}\u{52A0}`,
    ko: `\u{C8FC}\u{C18C} \u{CD94}\u{AC00}`,
    mww: `Ntxiv chaw nyob`,
    ps: `\u{62F} \u{67E}\u{62A}\u{647} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{648}\u{644}`,
    pt: `Adicionar endere\xe7o`,
    'pt-pt': `Adicionar morada`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{430}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Fa'aopopo le tuatusi`,
    so: `Cinwaanka ku dar`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Th\xeam \u{111}\u{1ECB}a ch\u{1EC9}`,
    'zh-hans': `\u{6DFB}\u{52A0}\u{5730}\u{5740}`,
    'zh-hant': `\u{65B0}\u{589E}\u{5730}\u{5740}`,
    en: `Add address`
};
const $b11db1b62d4a8f76$export$e6992f8339cfa0f6 = {
    ar: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">أضف ${activityTitle}</a> إلى <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    de: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Füge eine weitere ${activityTitle}</a> zur <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> hinzu.`,
    es: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Añade otra ${activityTitle}</a> al <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    fa: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">یک ${activityTitle} دیگر به</a> <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> اضافه کنید.`,
    fil: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Magdagdag ng isa pang ${activityTitle}</a> sa <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    fr: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Ajoutez une ${activityTitle}</a> à <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    hi: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> में <a class="text-bold" href="${addNextHref}">एक और ${activityTitle} जोड़ें</a>।`,
    ht: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Ajoute yon lòt ${activityTitle}</a> nan <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>`,
    it: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Aggiungi un ${activityTitle}</a> <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    ja: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`家庭<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>に<a class="text-bold" href="${addNextHref}">もう一${activityTitle}を追加</a>しましょう。`,
    ko: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>에 <a class="text-bold" href="${addNextHref}">또 다른 ${activityTitle}를 추가</a>하세요.`,
    mww: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Ntxiv lwm ${activityTitle}</a> rau <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    ps: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`د <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> <a class="text-bold" href="${addNextHref}">ته بله ${activityTitle} اضافه</a> کړه.`,
    pt: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Adicione mais uma ${activityTitle}</a> ao <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    'pt-pt': (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Adicione mais um ${activityTitle}</a> ao <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    ru: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Добавьте ещё один ${activityTitle}</a> в <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    sm: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Fa'aopopo se isi ${activityTitle}</a> i le <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    so: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Ku dar ${activityTitle}</a> dhacdada <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    th: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">เพิ่ม${activityTitle}อื่น</a>ใน<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>`,
    ur: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> میں <a class="text-bold" href="${addNextHref}">ایک اور ${activityTitle} شامل</a> کریں۔`,
    vi: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Thêm một ${activityTitle} khác</a> vào <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    'zh-hans': (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`在<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a><a class="text-bold" href="${addNextHref}">中添加另一项${activityTitle}</a>。`,
    'zh-hant': (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`在<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a><a class="text-bold" href="${addNextHref}">中新增另一${activityTitle}</a>。`,
    en: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$b11db1b62d4a8f76$var$html`<a class="text-bold" href="${addNextHref}">Add another ${activityTitle}</a> to <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`
};
const $b11db1b62d4a8f76$export$d6e293331174bdfd = {
    ar: `\u{625}\u{636}\u{627}\u{641}\u{629} \u{63A}\u{637}\u{627}\u{621}`,
    de: `Kappe hinzuf\xfcgen`,
    es: `A\xf1adir la tapa`,
    fa: `\u{627}\u{641}\u{632}\u{648}\u{62F}\u{646} \u{6A9}\u{644}\u{627}\u{647}`,
    fil: `Email Address *`,
    fr: `Ajouter un condensateur`,
    hi: `\u{91F}\u{94B}\u{92A}\u{940} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Ajoute bouchon`,
    it: `Aggiungi maiusculo`,
    ja: `\u{30AD}\u{30E3}\u{30C3}\u{30D7}\u{3092}\u{4ED8}\u{3051}\u{308B}`,
    ko: `\u{CEA1} \u{CD94}\u{AC00}\u{D558}\u{C138}\u{C694}`,
    mww: `Ntxiv lub kaus mom`,
    ps: `\u{62F} \u{6A9}\u{67E} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{648}\u{644}`,
    pt: `Adicionar tampa`,
    'pt-pt': `Adicionar mai\xfascula`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{44C} \u{43A}\u{440}\u{44B}\u{448}\u{43A}\u{443}`,
    sm: `Fa'aopopo pulou`,
    so: `Ku dar koofiyadda`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E1D}\u{E32}\u{E1B}\u{E34}\u{E14}`,
    ur: `\u{679}\u{648}\u{67E}\u{6CC} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Th\xeam n\u{1EAF}p`,
    'zh-hans': `\u{52A0}\u{76D6}`,
    'zh-hant': `\u{52A0}\u{84CB}`,
    en: `Add cap`
};
const $b11db1b62d4a8f76$export$e7fbeb47337d498d = {
    ar: `\u{623}\u{636}\u{641} \u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644}`,
    de: `Kontakt hinzuf\xfcgen`,
    es: `A\xf1adir contacto`,
    fa: `\u{62A}\u{645}\u{627}\u{633} \u{631}\u{627} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `Ajouter le contact`,
    hi: `\u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Ajoute kontak`,
    it: `Aggiungi contatto`,
    ja: `\u{9023}\u{7D61}\u{5148}\u{3092}\u{8FFD}\u{52A0}`,
    ko: `\u{C5F0}\u{B77D}\u{CC98} \u{CD94}\u{AC00}`,
    mww: `Ntxiv kev sib cuag`,
    ps: `\u{62A}\u{645}\u{627}\u{633} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Adicionar contato`,
    'pt-pt': `Adicionar contacto`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}`,
    sm: `Fa'aopopo le feso'ota'iga`,
    so: `Ku dar xiriirka`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E1C}\u{E39}\u{E49}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{631}\u{627}\u{628}\u{637}\u{6C1} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Th\xeam li\xean h\u{1EC7}`,
    'zh-hans': `\u{6DFB}\u{52A0}\u{8054}\u{7CFB}`,
    'zh-hant': `\u{65B0}\u{589E}\u{806F}\u{7D61}\u{4EBA}`,
    en: `Add contact`
};
const $b11db1b62d4a8f76$export$ebd631caeab7ad4a = {
    ar: `\u{625}\u{636}\u{627}\u{641}\u{629} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}`,
    de: `E-Mail hinzuf\xfcgen`,
    es: `A\xf1adir correo electr\xf3nico`,
    fa: `\u{627}\u{641}\u{632}\u{648}\u{62F}\u{646} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}`,
    fil: `Email Address`,
    fr: `Ajouter un email`,
    hi: `\u{908}\u{92E}\u{947}\u{932} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Ajoute im\xe8l`,
    it: `Aggiungi email`,
    ja: `\u{30E1}\u{30FC}\u{30EB}\u{3092}\u{8FFD}\u{52A0}`,
    ko: `\u{C774}\u{BA54}\u{C77C} \u{CD94}\u{AC00}\u{B85C}`,
    mww: `Ntxiv email`,
    ps: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Adicionar e-mail`,
    'pt-pt': `Adicionar email`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{443}\u{44E} \u{43F}\u{43E}\u{447}\u{442}\u{443}`,
    sm: `Fa'aopopo imeli`,
    so: `Ku dar email`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Th\xeam email`,
    'zh-hans': `\u{6DFB}\u{52A0}\u{90AE}\u{7BB1}`,
    'zh-hant': `\u{65B0}\u{589E}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}`,
    en: `Add email`
};
const $b11db1b62d4a8f76$export$e2f1a96242d6b597 = {
    ar: (date)=>`\u{623}\u{636}\u{641} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{629} \u{625}\u{644}\u{649} ${date}`,
    de: (date)=>`Eintritt hinzuf\xfcgen am ${date}`,
    es: (date)=>`A\xf1adir entrada al ${date}`,
    fa: (date)=>`\u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{631}\u{62F}\u{646} \u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{628}\u{647} ${date}`,
    fil: (date)=>`Magdagdag ng entry sa ${date}`,
    fr: (date)=>`Ajouter l\u{2019}entr\xe9e au ${date}`,
    hi: (date)=>`${date} \u{92E}\u{947}\u{902} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: (date)=>`Add entry to ${date}`,
    it: (date)=>`Aggiungi ${date}`,
    ja: (date)=>`${date}\u{3078}\u{306E}\u{53C2}\u{52A0}\u{8FFD}\u{52A0}`,
    ko: (date)=>`${date}\u{C5D0} \u{CC38}\u{AC00}\u{B97C} \u{CD94}\u{AC00}\u{D558}\u{C138}\u{C694}`,
    mww: (date)=>`Ntxiv nkag rau ${date}`,
    ps: (date)=>`\u{6AB}\u{689}\u{648}\u{646} ${date} \u{62A}\u{647} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: (date)=>`Adicionar entrada para ${date}`,
    'pt-pt': (date)=>`Adicionar entrada para ${date}`,
    ru: (date)=>`\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{432} ${date} \u{433}\u{43E}\u{434}\u{430}`,
    sm: (date)=>`Fa'aopopo le ulufale i le ${date}`,
    so: (date)=>`Ku dar gelitaanka ${date}`,
    th: (date)=>`\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E2A}\u{E34}\u{E17}\u{E18}\u{E34}\u{E4C}\u{E40}\u{E02}\u{E49}\u{E32} ${date}`,
    ur: (date)=>`${date} \u{6A9}\u{648} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: (date)=>`Th\xeam v\xe9 v\xe0o Th\u{1EE9} ${date}`,
    'zh-hans': (date)=>`\u{65B0}\u{589E}\u{62A5}\u{540D}\u{65E5}\u{671F}\u{FF1A} ${date}`,
    'zh-hant': (date)=>`\u{65B0}\u{589E}\u{5831}\u{540D}\u{65E5}\u{671F}\u{FF1A} ${date}`,
    en: (date)=>`Add entry to ${date}`
};
const $b11db1b62d4a8f76$export$47ed70605e6bc746 = {
    ar: `\u{623}\u{636}\u{641} \u{627}\u{644}\u{62F}\u{648}\u{627}\u{621}`,
    de: `Medikamente hinzuf\xfcgen`,
    es: `A\xf1adir medicaci\xf3n`,
    fa: `\u{62F}\u{627}\u{631}\u{648} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Magdagdag ng gamot`,
    fr: `Ajouter un m\xe9dicament`,
    hi: `\u{926}\u{935}\u{93E} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Ajoute medikaman`,
    it: `Aggiungi farmaci`,
    ja: `\u{85AC}\u{3092}\u{8FFD}\u{52A0}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{C57D}\u{BB3C} \u{BCF5}\u{C6A9}`,
    mww: `Ntxiv tshuaj`,
    ps: `\u{62F}\u{631}\u{645}\u{644} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Adicionar medica\xe7\xe3o`,
    'pt-pt': `Adicionar medica\xe7\xe3o`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{44C}\u{442}\u{435} \u{43B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432}\u{430}`,
    sm: `Fa'aopopo vaila'au`,
    so: `Daawo ku dar`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E22}\u{E32}`,
    ur: `\u{62F}\u{648}\u{627} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Th\xeam thu\u{1ED1}c`,
    'zh-hans': `\u{52A0}\u{836F}`,
    'zh-hant': `\u{52A0}\u{85E5}`,
    en: `Add medication`
};
const $b11db1b62d4a8f76$export$4e8e2daec699335e = {
    ar: `\u{625}\u{636}\u{627}\u{641}\u{629} \u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Neue hinzuf\xfcgen`,
    es: `A\xf1adir nuevo`,
    fa: `\u{627}\u{641}\u{632}\u{648}\u{62F}\u{646} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `Ajouter de nouvelles`,
    hi: `\u{928}\u{92F}\u{93E} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Ajoute nouvo`,
    it: `Aggiungi nuovo`,
    ja: `\u{65B0}\u{305F}\u{306B}\u{8FFD}\u{52A0}`,
    ko: `\u{C0C8} \u{C0C8} \u{D56D}\u{BAA9} \u{CD94}\u{AC00}.`,
    mww: `Ntxiv tshiab`,
    ps: `\u{646}\u{648}\u{6CC} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{693}\u{647}`,
    pt: `Adicionar novo`,
    'pt-pt': `Adicionar novo`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43D}\u{43E}\u{432}\u{44B}\u{435}`,
    sm: `Fa'aopopo fou`,
    so: `Ku dar cusub`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{6CC}\u{627} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Th\xeam`,
    'zh-hans': `\u{6DFB}\u{52A0}\u{65B0}\u{5185}\u{5BB9}`,
    'zh-hant': `\u{65B0}\u{589E}`,
    en: `Add new`
};
const $b11db1b62d4a8f76$export$36658e29488b888c = {
    ar: `\u{625}\u{636}\u{627}\u{641}\u{629} \u{627}\u{644}\u{647}\u{627}\u{62A}\u{641}`,
    de: `Handy hinzuf\xfcgen`,
    es: `A\xf1adir tel\xe9fono`,
    fa: `\u{627}\u{641}\u{632}\u{648}\u{62F}\u{646} \u{62A}\u{644}\u{641}\u{646}`,
    fil: `Email Address *`,
    fr: `Ajouter le t\xe9l\xe9phone`,
    hi: `\u{92B}\u{93C}\u{94B}\u{928} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Ajoute telef\xf2n`,
    it: `Aggiungi telefono`,
    ja: `\u{96FB}\u{8A71}\u{3092}\u{8FFD}\u{52A0}`,
    ko: `\u{C804}\u{D654} \u{CD94}\u{AC00}\u{D558}\u{C138}\u{C694}`,
    mww: `Ntxiv xov tooj`,
    ps: `\u{62F} \u{67C}\u{6CC}\u{644}\u{6CC}\u{641}\u{648}\u{646} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{648}\u{644}`,
    pt: `Adicionar telefone`,
    'pt-pt': `Adicionar telefone`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}`,
    sm: `Fa'aopopo le telefoni`,
    so: `Ku dar telefoonka`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}`,
    ur: `\u{627}\u{6CC}\u{688} \u{641}\u{648}\u{646}`,
    vi: `Th\xeam \u{111}i\u{1EC7}n tho\u{1EA1}i`,
    'zh-hans': `\u{6DFB}\u{52A0}\u{7535}\u{8BDD}`,
    'zh-hant': `\u{65B0}\u{589E}\u{96FB}\u{8A71}`,
    en: `Add phone`
};
const $b11db1b62d4a8f76$export$b1cfe4d9572aab22 = {
    ar: `\u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Adresse`,
    es: `Direcci\xf3n`,
    fa: `\u{622}\u{62F}\u{631}\u{633}`,
    fil: `Email Address`,
    fr: `Adresse`,
    hi: `\u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s`,
    it: `Indirizzo`,
    ja: `\u{4F4F}\u{6240}`,
    ko: `\u{C8FC}\u{C18C}`,
    mww: `Chaw Nyob`,
    ps: `\u{67E}\u{62A}\u{647}`,
    pt: `Endere\xe7o`,
    'pt-pt': `Endere\xe7o`,
    ru: `\u{410}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Tuatusi`,
    so: `Cinwaanka`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{62E}\u{637}\u{627}\u{628}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9}`,
    'zh-hans': `\u{5730}\u{5740}`,
    'zh-hant': `\u{5730}\u{5740}`,
    en: `Address`
};
const $b11db1b62d4a8f76$export$d1ed296619aa9769 = {
    ar: `\u{644}\u{645} \u{64A}\u{643}\u{646} \u{628}\u{627}\u{644}\u{625}\u{645}\u{643}\u{627}\u{646} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{645}\u{648}\u{642}\u{639} \u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Adresse konnte nicht geolokalisiert werden`,
    es: `La direcci\xf3n no pudo ser geolocalizada`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{631}\u{627} \u{646}\u{645}\u{6CC} \u{634}\u{62F} \u{645}\u{6A9}\u{627}\u{646} \u{6CC}\u{627}\u{628}\u{6CC} \u{6A9}\u{631}\u{62F}`,
    fil: `Hindi ma-geolocate ang address`,
    fr: `L\u{2019}adresse n\u{2019}a pas pu \xeatre g\xe9olocalis\xe9e`,
    hi: `\u{92A}\u{924}\u{93E} \u{91C}\u{93F}\u{92F}\u{94B}\u{932}\u{94B}\u{915}\u{947}\u{91F} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{93E}`,
    ht: `Adr\xe8s pa t 'kapab jeolokalize`,
    it: `L'indirizzo non poteva essere geolocalizzato`,
    ja: `\u{4F4F}\u{6240}\u{306F}\u{30B8}\u{30AA}\u{30ED}\u{30B1}\u{30FC}\u{30B7}\u{30E7}\u{30F3}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3067}\u{3057}\u{305F}`,
    ko: `\u{C8FC}\u{C18C}\u{B294} \u{C704}\u{CE58} \u{C9C0}\u{C815}\u{C774} \u{BD88}\u{AC00}\u{B2A5}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Chaw nyob tsis tau nrhiav tau qhov chaw nyob`,
    ps: `\u{67E}\u{62A}\u{647} \u{646}\u{634}\u{648}\u{647} \u{6A9}\u{648}\u{644}\u{627}\u{6CC} \u{62C}\u{63A}\u{631}\u{627}\u{641}\u{6CC}\u{627}\u{6CC}\u{6CC} \u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{693}\u{6CC}`,
    pt: `O endere\xe7o n\xe3o p\xf4de ser geolocalizado`,
    'pt-pt': `O endere\xe7o n\xe3o p\xf4de ser geolocalizado`,
    ru: `\u{410}\u{434}\u{440}\u{435}\u{441} \u{43D}\u{435} \u{43C}\u{43E}\u{433} \u{431}\u{44B}\u{442}\u{44C} \u{433}\u{435}\u{43E}\u{43B}\u{43E}\u{43A}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{435}\u{43D}`,
    sm: `E le mafai ona fa'apipi'i le tuatusi`,
    so: `Cinwaanka lama heli karin geolocation`,
    th: `\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E23}\u{E30}\u{E1A}\u{E38}\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{67E}\u{62A}\u{6C1} \u{62C}\u{6CC}\u{648} \u{644}\u{648}\u{6A9}\u{6CC}\u{634}\u{646} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{627} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{627} \u{62A}\u{6BE}\u{627}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} kh\xf4ng th\u{1EC3} \u{111}\u{1ECB}nh v\u{1ECB} \u{111}\u{1ECB}a l\xfd`,
    'zh-hans': `\u{5730}\u{5740}\u{65E0}\u{6CD5}\u{5B9A}\u{4F4D}`,
    'zh-hant': `\u{5730}\u{5740}\u{7121}\u{6CD5}\u{5B9A}\u{4F4D}`,
    en: `Address could not be geolocated`
};
const $b11db1b62d4a8f76$export$24912d79cf581cbb = {
    ar: `\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644} \u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Adressdetails`,
    es: `Detalles de la direcci\xf3n`,
    fa: `\u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A} \u{622}\u{62F}\u{631}\u{633}`,
    fil: `Mga detalye ng address`,
    fr: `D\xe9tails de l\u{2019}adresse`,
    hi: `\u{92A}\u{924}\u{947} \u{915}\u{93E} \u{935}\u{93F}\u{935}\u{930}\u{923}`,
    ht: `Adr\xe8s detay`,
    it: `Dettagli dell'indirizzo`,
    ja: `\u{4F4F}\u{6240}\u{306E}\u{8A73}\u{7D30}`,
    ko: `\u{C8FC}\u{C18C} \u{C138}\u{BD80}\u{C0AC}\u{D56D}`,
    mww: `Chaw nyob cov ntsiab lus`,
    ps: `\u{62F} \u{67E}\u{62A}\u{647} \u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    pt: `Detalhes do endere\xe7o`,
    'pt-pt': `Detalhes do endere\xe7o`,
    ru: `\u{414}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{430}\u{434}\u{440}\u{435}\u{441}\u{430}`,
    sm: `Faamatalaga o le tuatusi`,
    so: `Faahfaahinta cinwaanka`,
    th: `\u{E23}\u{E32}\u{E22}\u{E25}\u{E30}\u{E40}\u{E2D}\u{E35}\u{E22}\u{E14}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{67E}\u{62A}\u{6D2} \u{6A9}\u{6CC} \u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    vi: `Chi ti\u{1EBF}t \u{111}\u{1ECB}a ch\u{1EC9}`,
    'zh-hans': `\u{5730}\u{5740}\u{8BE6}\u{60C5}`,
    'zh-hant': `\u{5730}\u{5740}\u{8A73}\u{60C5}`,
    en: `Address details`
};
const $b11db1b62d4a8f76$export$fdbabd02c17c33c3 = {
    ar: `\u{627}\u{644}\u{639}\u{646}\u{627}\u{648}\u{64A}\u{646}`,
    de: `Adressen`,
    es: `Direcciones`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{647}\u{627}`,
    fil: `Email Address`,
    fr: `Allocutions`,
    hi: `\u{92A}\u{924}\u{947}`,
    ht: `Adr\xe8s yo`,
    it: `Indirizzi`,
    ja: `\u{4F4F}\u{6240}`,
    ko: `\u{C8FC}\u{C18C}`,
    mww: `Chaw Nyob`,
    ps: `\u{67E}\u{62A}\u{647} \u{6AB}\u{627}\u{646}\u{6D0}`,
    pt: `Endere\xe7os`,
    'pt-pt': `Endere\xe7os`,
    ru: `\u{410}\u{434}\u{440}\u{435}\u{441}\u{430}`,
    sm: `Tuatusi`,
    so: `Cinwaanada`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{62E}\u{637}\u{627}\u{628}\u{627}\u{62A}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9}`,
    'zh-hans': `\u{5730}\u{5740}`,
    'zh-hant': `\u{5730}\u{5740}`,
    en: `Addresses`
};
const $b11db1b62d4a8f76$export$f0481c89dafc20ec = {
    ar: `\u{625}\u{636}\u{627}\u{641}\u{629} \u{627}\u{644}\u{645}\u{648}\u{642}\u{639}`,
    de: `Webseite hinzuf\xfcgen`,
    es: `A\xf1adir sitio`,
    fa: `\u{627}\u{641}\u{632}\u{648}\u{62F}\u{646} \u{633}\u{627}\u{6CC}\u{62A}`,
    fil: `Email Address *`,
    fr: `Ajouter le site`,
    hi: `\u{938}\u{93E}\u{907}\u{91F} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Ajoute sit`,
    it: `Aggiungi sito`,
    ja: `\u{30B5}\u{30A4}\u{30C8}\u{3092}\u{8FFD}\u{52A0}`,
    ko: `\u{C0AC}\u{C774}\u{D2B8} \u{CD94}\u{AC00}`,
    mww: `Ntxiv qhov chaw`,
    ps: `\u{62F} \u{681}\u{627}\u{6CC} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{648}\u{644}`,
    pt: `Adicionar site`,
    'pt-pt': `Adicionar site`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{441}\u{430}\u{439}\u{442}`,
    sm: `Fa'aopopo le 'upega tafa'ilagi`,
    so: `Ku dar bogga`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}`,
    ur: `\u{633}\u{627}\u{626}\u{679} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Th\xeam trang web`,
    'zh-hans': `\u{6DFB}\u{52A0}\u{7F51}\u{7AD9}`,
    'zh-hant': `\u{65B0}\u{589E}\u{7DB2}\u{7AD9}`,
    en: `Add site`
};
const $b11db1b62d4a8f76$export$ebd370d4ef2d3663 = {
    ar: `\u{627}\u{644}\u{627}\u{644}\u{62A}\u{632}\u{627}\u{645}`,
    de: `Treue`,
    es: `Cumplimiento`,
    fa: `\u{67E}\u{627}\u{6CC}\u{628}\u{646}\u{62F}\u{6CC}`,
    fil: `Pagsunod`,
    fr: `Adh\xe9sion`,
    hi: `\u{92A}\u{93E}\u{932}\u{928}`,
    ht: `Adezyon`,
    it: `Adesione`,
    ja: `\u{9075}\u{5B88}`,
    ko: `\u{C900}\u{C218}`,
    mww: `Kev ua raws li`,
    ps: `\u{62A}\u{639}\u{642}\u{6CC}\u{628}`,
    pt: `Ades\xe3o`,
    'pt-pt': `Ades\xe3o`,
    ru: `\u{41F}\u{440}\u{438}\u{432}\u{435}\u{440}\u{436}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Tausisia`,
    so: `Adherance`,
    th: `\u{E01}\u{E32}\u{E23}\u{E22}\u{E36}\u{E14}\u{E21}\u{E31}\u{E48}\u{E19}`,
    ur: `\u{67E}\u{627}\u{628}\u{646}\u{62F}\u{6CC}`,
    vi: `Tu\xe2n th\u{1EE7}`,
    'zh-hans': `\u{9075}\u{5FAA}`,
    'zh-hant': `\u{9075}\u{5F9E}`,
    en: `Adherance`
};
const $b11db1b62d4a8f76$export$3bd695ac39288245 = {
    ar: `\u{627}\u{644}\u{625}\u{62F}\u{627}\u{631}\u{629}`,
    de: `Verwaltung`,
    es: `Administrativa`,
    fa: `\u{627}\u{62F}\u{627}\u{631}\u{6CC}`,
    fil: `Administratibo`,
    fr: `Administratif`,
    hi: `\u{938}\u{902}\u{91A}\u{93E}\u{932}\u{928}-\u{938}\u{902}\u{92C}\u{902}\u{927}\u{940}`,
    ht: `Administratif`,
    it: `Amministrativa`,
    ja: `\u{884C}\u{653F}`,
    ko: `\u{D589}\u{C815}`,
    mww: `Kev tswj hwm`,
    ps: `\u{627}\u{62F}\u{627}\u{631}\u{6CC}`,
    pt: `Administrativo`,
    'pt-pt': `Administrativo`,
    ru: `\u{410}\u{434}\u{43C}\u{438}\u{43D}\u{438}\u{441}\u{442}\u{440}\u{430}\u{442}\u{438}\u{432}\u{43D}\u{44B}\u{435}`,
    sm: `Pulega`,
    so: `Maamulka`,
    th: `\u{E18}\u{E38}\u{E23}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{627}\u{646}\u{62A}\u{638}\u{627}\u{645}\u{6CC}`,
    vi: `H\xe0nh ch\xednh`,
    'zh-hans': `\u{884C}\u{653F}`,
    'zh-hant': `\u{884C}\u{653F}`,
    en: `Administrative`
};
const $b11db1b62d4a8f76$export$927235c868aa0c00 = {
    ar: `\u{645}\u{62A}\u{642}\u{62F}\u{645}\u{629}`,
    de: `Fortgeschritten`,
    es: `Avanzado`,
    fa: `\u{67E}\u{6CC}\u{634}\u{631}\u{641}\u{62A}\u{647}`,
    fil: `Advanced`,
    fr: `Avanc\xe9`,
    hi: `\u{905}\u{917}\u{94D}\u{930}\u{935}\u{930}\u{94D}\u{924}\u{940}`,
    ht: `Avanse`,
    it: `Avanzato`,
    ja: `\u{4E0A}\u{7D1A}`,
    ko: `\u{ACE0}\u{AE09}`,
    mww: `siab heev`,
    ps: `\u{67E}\u{631}\u{645}\u{62E}\u{62A}\u{644}\u{644}\u{6CC}`,
    pt: `Avan\xe7ado`,
    'pt-pt': `Avan\xe7ado`,
    ru: `\u{41F}\u{440}\u{43E}\u{434}\u{432}\u{438}\u{43D}\u{443}\u{442}\u{44B}\u{439}`,
    sm: `Alualu i luma`,
    so: `Horumarsan`,
    th: `\u{E02}\u{E31}\u{E49}\u{E19}\u{E2A}\u{E39}\u{E07}`,
    ur: `\u{627}\u{6CC}\u{688}\u{648}\u{627}\u{646}\u{633}\u{688}`,
    vi: `N\xe2ng cao`,
    'zh-hans': `\u{9AD8}\u{7EA7}`,
    'zh-hant': `\u{9032}\u{968E}`,
    en: `Advanced`
};
const $b11db1b62d4a8f76$export$71895d4fc88671c0 = {
    ar: `\u{627}\u{644}\u{639}\u{645}\u{631}`,
    de: `Alter`,
    es: `Edad`,
    fa: `\u{633}\u{646}`,
    fil: `Edad`,
    fr: `\xc2ge`,
    hi: `\u{909}\u{92E}\u{94D}\u{930}`,
    ht: `Laj`,
    it: `Et\xe0`,
    ja: `\u{5E74}\u{4EE3}`,
    ko: `\u{C5F0}\u{C2DD}`,
    mww: `hnub nyoog`,
    ps: `\u{639}\u{645}\u{631}`,
    pt: `Idade`,
    'pt-pt': `Idade`,
    ru: `\u{412}\u{43E}\u{437}\u{440}\u{430}\u{441}\u{442}`,
    sm: `Tausaga`,
    so: `Da'da`,
    th: `\u{E2D}\u{E32}\u{E22}\u{E38}`,
    ur: `\u{639}\u{645}\u{631}`,
    vi: `Tu\u{1ED5}i t\xe1c`,
    'zh-hans': `\u{5E74}\u{9F84}`,
    'zh-hant': `\u{5E74}\u{4EE3}`,
    en: `Age`
};
const $b11db1b62d4a8f76$export$8d7a72727b917368 = {
    ar: `\u{627}\u{644}\u{648}\u{643}\u{627}\u{644}\u{629}`,
    de: `Agentur`,
    es: `Agencia`,
    fa: `\u{646}\u{645}\u{627}\u{6CC}\u{646}\u{62F}\u{6AF}\u{6CC}`,
    fil: `Ahensya`,
    fr: `Agence`,
    hi: `\u{938}\u{930}\u{915}\u{93E}\u{930}\u{940} \u{90F}\u{91C}\u{947}\u{902}\u{938}\u{940}`,
    ht: `Ajans`,
    it: `Agenzia`,
    ja: `\u{4EE3}\u{7406}\u{5E97}`,
    ko: `\u{AE30}\u{AD00}`,
    mww: `Lub koom haum`,
    ps: `\u{627}\u{62F}\u{627}\u{631}\u{647}`,
    pt: `Ag\xeancia`,
    'pt-pt': `Ag\xeancia`,
    ru: `\u{410}\u{433}\u{435}\u{43D}\u{442}\u{441}\u{442}\u{432}\u{43E}`,
    sm: `Faitalia`,
    so: `Hay'adda`,
    th: `\u{E2B}\u{E19}\u{E48}\u{E27}\u{E22}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{627}\u{6CC}\u{62C}\u{646}\u{633}\u{6CC}`,
    vi: `C\u{1A1} quan`,
    'zh-hans': `\u{4EE3}\u{7406}\u{673A}\u{6784}`,
    'zh-hant': `\u{4EE3}\u{7406}\u{6A5F}\u{69CB}`,
    en: `Agency`
};
const $b11db1b62d4a8f76$export$4cd024432c2a933c = {
    ar: (cumulus)=>`\u{623}\u{648}\u{627}\u{641}\u{642} \u{639}\u{644}\u{649} \u{634}\u{631}\u{648}\u{637} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} ${cumulus}`,
    de: (cumulus)=>`Ich stimme den ${cumulus} zu`,
    es: (cumulus)=>`Acepto los T\xe9rminos de Uso ${cumulus}`,
    fa: (cumulus)=>`\u{645}\u{646} \u{628}\u{627} \u{634}\u{631}\u{627}\u{6CC}\u{637} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} ${cumulus} \u{645}\u{648}\u{627}\u{641}\u{642}\u{645}`,
    fil: (cumulus)=>`Sumasang-ayon ako sa Mga Tuntunin ng Paggamit ${cumulus}`,
    fr: (cumulus)=>`J\u{2019}accepte les Conditions d\u{2019}utilisation ${cumulus}`,
    hi: (cumulus)=>`\u{92E}\u{948}\u{902} ${cumulus} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{940} \u{936}\u{930}\u{94D}\u{924}\u{94B}\u{902} \u{938}\u{947} \u{938}\u{939}\u{92E}\u{924} \u{939}\u{942}\u{902}`,
    ht: (cumulus)=>`Mwen dak\xf2 ak Regleman ${cumulus}`,
    it: (cumulus)=>`Accetto i Termini di Utilizzo ${cumulus}`,
    ja: (cumulus)=>`\u{79C1}\u{306F} ${cumulus} \u{5229}\u{7528}\u{898F}\u{7D04}\u{306B}\u{540C}\u{610F}\u{3057}\u{307E}\u{3059}`,
    ko: (cumulus)=>`\u{C800}\u{B294} ${cumulus} \u{C774}\u{C6A9} \u{C57D}\u{AD00}\u{C5D0} \u{B3D9}\u{C758}\u{D569}\u{B2C8}\u{B2E4}`,
    mww: (cumulus)=>`Kuv pom zoo rau ${cumulus} Cov Lus Cog Tseg ntawm Kev Siv`,
    ps: (cumulus)=>`\u{632}\u{647} \u{62F} ${cumulus} \u{62F} \u{6A9}\u{627}\u{631}\u{648}\u{646}\u{6D0} \u{634}\u{631}\u{627}\u{6CC}\u{637}\u{648} \u{633}\u{631}\u{647} \u{645}\u{648}\u{627}\u{641}\u{642} \u{6CC}\u{645}`,
    pt: (cumulus)=>`Concordo com os Termos de Uso ${cumulus}`,
    'pt-pt': (cumulus)=>`Concordo com os Termos de Utiliza\xe7\xe3o ${cumulus}`,
    ru: (cumulus)=>`\u{42F} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{441}\u{435}\u{43D} \u{441} \u{443}\u{441}\u{43B}\u{43E}\u{432}\u{438}\u{44F}\u{43C}\u{438} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} ${cumulus}`,
    sm: (cumulus)=>`Ou te ioe i tuutuuga o le fa'aaogaina o ${cumulus}`,
    so: (cumulus)=>`Waxaan ku raacsanahay Shuruudaha ${cumulus}`,
    th: (cumulus)=>`\u{E09}\u{E31}\u{E19}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E02}\u{E49}\u{E2D}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E01}\u{E32}\u{E23}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19} ${cumulus}`,
    ur: (cumulus)=>`\u{645}\u{6CC}\u{6BA} ${cumulus} \u{6A9}\u{6CC} \u{634}\u{631}\u{627}\u{626}\u{637} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{633}\u{6D2} \u{627}\u{62A}\u{641}\u{627}\u{642} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{648}\u{6BA}`,
    vi: (cumulus)=>`T\xf4i \u{111}\u{1ED3}ng \xfd v\u{1EDB}i \u{110}i\u{1EC1}u kho\u{1EA3}n s\u{1EED} d\u{1EE5}ng ${cumulus}`,
    'zh-hans': (cumulus)=>`\u{6211}\u{540C}\u{610F} ${cumulus} \u{4F7F}\u{7528}\u{6761}\u{6B3E}`,
    'zh-hant': (cumulus)=>`\u{6211}\u{540C}\u{610F} ${cumulus} \u{4F7F}\u{7528}\u{689D}\u{6B3E}`,
    en: (cumulus)=>`I agree to the ${cumulus} Terms of Use`
};
const $b11db1b62d4a8f76$export$8f5daf951e994b77 = {
    ar: `\u{627}\u{644}\u{62C}\u{645}\u{64A}\u{639}`,
    de: `Alle`,
    es: `Todos`,
    fa: `\u{647}\u{645}\u{647}`,
    fil: `Lahat`,
    fr: `Tous`,
    hi: `\u{938}\u{92D}\u{940}`,
    ht: `Tout`,
    it: `Tutti`,
    ja: `\u{5168}\u{54E1}`,
    ko: `\u{BAA8}\u{B450}`,
    mww: `tag nrho`,
    ps: `\u{67C}\u{648}\u{644}`,
    pt: `Todos`,
    'pt-pt': `Todos`,
    ru: `\u{412}\u{441}\u{435}`,
    sm: `Uma`,
    so: `Dhammaan`,
    th: `\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{633}\u{628}`,
    vi: `T\u{1EA5}t c\u{1EA3}`,
    'zh-hans': `\u{5168}\u{90E8}`,
    'zh-hant': `\u{5168}\u{90E8}`,
    en: `All`
};
const $b11db1b62d4a8f76$export$4d9501c486d51939 = {
    ar: `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629}`,
    de: `Alle Aktivit\xe4ten`,
    es: `Todas las actividades`,
    fa: `\u{62A}\u{645}\u{627}\u{645} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}`,
    fil: `Lahat ng Aktibidad`,
    fr: `Toutes les activit\xe9s`,
    hi: `\u{938}\u{92D}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `Tout aktivite`,
    it: `Tutte le attivit\xe0`,
    ja: `\u{3059}\u{3079}\u{3066}\u{306E}\u{6D3B}\u{52D5}`,
    ko: `\u{BAA8}\u{B4E0} \u{D65C}\u{B3D9}`,
    mww: `Txhua yam kev ua ub no`,
    ps: `\u{67C}\u{648}\u{644}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Todas as atividades`,
    'pt-pt': `Todas as atividades`,
    ru: `\u{412}\u{441}\u{435} \u{432}\u{438}\u{434}\u{44B} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Gaoioiga uma`,
    so: `Dhammaan hawlaha`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{62A}\u{645}\u{627}\u{645} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}`,
    vi: `T\u{1EA5}t c\u{1EA3} c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{6240}\u{6709}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{6240}\u{6709}\u{6D3B}\u{52D5}`,
    en: `All activities`
};
const $b11db1b62d4a8f76$export$c2d146f46bb77f34 = {
    ar: `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{648}\u{643}\u{627}\u{644}\u{627}\u{62A}`,
    de: `Alle Beh\xf6rden`,
    es: `Todas las agencias`,
    fa: `\u{62A}\u{645}\u{627}\u{645} \u{622}\u{698}\u{627}\u{646}\u{633} \u{647}\u{627}`,
    fil: `Lahat ng mga ahensya`,
    fr: `Toutes les agences`,
    hi: `\u{938}\u{92D}\u{940} \u{90F}\u{91C}\u{947}\u{902}\u{938}\u{93F}\u{92F}\u{93E}\u{902}`,
    ht: `Tout ajans yo`,
    it: `Tutte le agenzie`,
    ja: `\u{3059}\u{3079}\u{3066}\u{306E}\u{6A5F}\u{95A2}`,
    ko: `\u{BAA8}\u{B4E0} \u{AE30}\u{AD00}`,
    mww: `Tag nrho cov chaw ua hauj lwm`,
    ps: `\u{67C}\u{648}\u{644}\u{6D0} \u{627}\u{62F}\u{627}\u{631}\u{6D0}`,
    pt: `Todas as ag\xeancias`,
    'pt-pt': `Todas as ag\xeancias`,
    ru: `\u{412}\u{441}\u{435} \u{430}\u{433}\u{435}\u{43D}\u{442}\u{441}\u{442}\u{432}\u{430}`,
    sm: `Ofisa uma`,
    so: `Dhammaan hay'adaha`,
    th: `\u{E2B}\u{E19}\u{E48}\u{E27}\u{E22}\u{E07}\u{E32}\u{E19}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{62A}\u{645}\u{627}\u{645} \u{627}\u{6CC}\u{62C}\u{646}\u{633}\u{6CC}\u{627}\u{6BA}`,
    vi: `T\u{1EA5}t c\u{1EA3} c\xe1c c\u{1A1} quan`,
    'zh-hans': `\u{6240}\u{6709}\u{673A}\u{6784}`,
    'zh-hant': `\u{6240}\u{6709}\u{6A5F}\u{69CB}`,
    en: `All agencies`
};
const $b11db1b62d4a8f76$export$735af97578f62fd7 = {
    ar: `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{62D}\u{644}\u{642}\u{627}\u{62A} / \u{627}\u{644}\u{642}\u{636}\u{627}\u{64A}\u{627}`,
    de: `Alle Episoden / F\xe4lle`,
    es: `Todos los episodios / casos`,
    fa: `\u{62A}\u{645}\u{627}\u{645} \u{642}\u{633}\u{645}\u{62A} \u{647}\u{627} / \u{67E}\u{631}\u{648}\u{646}\u{62F}\u{647} \u{647}\u{627}`,
    fil: `Lahat ng mga episode / kaso`,
    fr: `Tous les \xe9pisodes / cas`,
    hi: `\u{938}\u{92D}\u{940} \u{90F}\u{92A}\u{93F}\u{938}\u{94B}\u{921}/\u{92E}\u{93E}\u{92E}\u{932}\u{947}`,
    ht: `Tout epiz\xf2d / ka`,
    it: `Tutti gli episodi / casi`,
    ja: `\u{5168}\u{30A8}\u{30D4}\u{30BD}\u{30FC}\u{30C9}/\u{4E8B}\u{4EF6}`,
    ko: `\u{BAA8}\u{B4E0} \u{C5D0}\u{D53C}\u{C18C}\u{B4DC} / \u{C0AC}\u{AC74}`,
    mww: `Txhua ntu / rooj plaub`,
    ps: `\u{67C}\u{648}\u{644}\u{6D0} \u{628}\u{631}\u{62E}\u{6D0} / \u{642}\u{636}\u{6CC}\u{6D0}`,
    pt: `Todos os epis\xf3dios / casos`,
    'pt-pt': `Todos os epis\xf3dios / casos`,
    ru: `\u{412}\u{441}\u{435} \u{44D}\u{43F}\u{438}\u{437}\u{43E}\u{434}\u{44B} / \u{434}\u{435}\u{43B}\u{430}`,
    sm: `Vaega uma / mataupu`,
    so: `Dhammaan qaybaha / kiisaska`,
    th: `\u{E17}\u{E38}\u{E01}\u{E15}\u{E2D}\u{E19} / \u{E01}\u{E23}\u{E13}\u{E35}`,
    ur: `\u{62A}\u{645}\u{627}\u{645} \u{627}\u{642}\u{633}\u{627}\u{637} / \u{6A9}\u{6CC}\u{633}\u{632}`,
    vi: `T\u{1EA5}t c\u{1EA3} c\xe1c t\u{1EAD}p / tr\u{1B0}\u{1EDD}ng h\u{1EE3}p`,
    'zh-hans': `\u{6240}\u{6709}\u{5267}\u{96C6}/\u{6848}\u{4EF6}`,
    'zh-hant': `\u{6240}\u{6709}\u{96C6}\u{6578}/\u{6848}\u{4EF6}`,
    en: `All episodes / cases`
};
const $b11db1b62d4a8f76$export$a0032eac4d6b29e7 = {
    ar: `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{641}\u{639}\u{627}\u{644}\u{64A}\u{627}\u{62A}`,
    de: `Alle Veranstaltungen`,
    es: `Todos los eventos`,
    fa: `\u{62A}\u{645}\u{627}\u{645} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{647}\u{627}`,
    fil: `Lahat ng mga kaganapan`,
    fr: `Tous les \xe9v\xe9nements`,
    hi: `\u{938}\u{92D}\u{940} \u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{915}\u{94D}\u{930}\u{92E}`,
    ht: `Tout ev\xe8nman`,
    it: `Tutti gli eventi`,
    ja: `\u{3059}\u{3079}\u{3066}\u{306E}\u{30A4}\u{30D9}\u{30F3}\u{30C8}`,
    ko: `\u{BAA8}\u{B4E0} \u{D589}\u{C0AC}`,
    mww: `Tag nrho cov xwm txheej`,
    ps: `\u{67C}\u{648}\u{644}\u{6D0} \u{67E}\u{6CC}\u{69A}\u{6D0}`,
    pt: `Todos os eventos`,
    'pt-pt': `Todos os eventos`,
    ru: `\u{412}\u{441}\u{435} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F}`,
    sm: `Mea uma na tutupu`,
    so: `Dhammaan dhacdooyinka`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{62A}\u{645}\u{627}\u{645} \u{627}\u{6CC}\u{648}\u{646}\u{679}\u{633}`,
    vi: `T\u{1EA5}t c\u{1EA3} c\xe1c s\u{1EF1} ki\u{1EC7}n`,
    'zh-hans': `\u{6240}\u{6709}\u{8D5B}\u{4E8B}`,
    'zh-hant': `\u{6240}\u{6709}\u{6D3B}\u{52D5}`,
    en: `All events`
};
const $b11db1b62d4a8f76$export$593663fd92e22ab4 = {
    ar: `\u{627}\u{644}\u{633}\u{645}\u{627}\u{62D} \u{628}\u{627}\u{644}\u{646}\u{633}\u{62E}`,
    de: `Kopieren erlaubt`,
    es: `Permitir la copia`,
    fa: `\u{627}\u{62C}\u{627}\u{632}\u{647} \u{6A9}\u{67E}\u{6CC} \u{6A9}\u{631}\u{62F}\u{646} \u{631}\u{627} \u{628}\u{62F}\u{647}\u{6CC}\u{62F}`,
    fil: `Payagan ang pagkopya`,
    fr: `Autoriser la copie`,
    hi: `\u{915}\u{949}\u{92A}\u{940} \u{915}\u{930}\u{928}\u{947} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{926}\u{947}\u{902}`,
    ht: `P\xe8m\xe8t kopi`,
    it: `Consentire la copia`,
    ja: `\u{30B3}\u{30D4}\u{30FC}\u{3092}\u{8A31}\u{53EF}\u{3059}\u{308B}`,
    ko: `\u{BCF5}\u{C0AC} \u{D5C8}\u{C6A9}`,
    mww: `Tso cai luam`,
    ps: `\u{6A9}\u{627}\u{67E}\u{6CC} \u{6A9}\u{648}\u{644} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{648}\u{631}\u{6A9}\u{693}\u{626}`,
    pt: `Permitir c\xf3pia`,
    'pt-pt': `Permitir c\xf3pia`,
    ru: `\u{420}\u{430}\u{437}\u{440}\u{435}\u{448}\u{438}\u{442}\u{44C} \u{43A}\u{43E}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Faataga le kopiina`,
    so: `Oggolaanshaha nuqulka`,
    th: `\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E04}\u{E31}\u{E14}\u{E25}\u{E2D}\u{E01}`,
    ur: `\u{646}\u{642}\u{644} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{62F}\u{6CC}\u{6BA}`,
    vi: `Cho ph\xe9p sao ch\xe9p`,
    'zh-hans': `\u{5141}\u{8BB8}\u{590D}\u{5236}`,
    'zh-hant': `\u{5141}\u{8A31}\u{8907}\u{88FD}`,
    en: `Allow copying`
};
const $b11db1b62d4a8f76$export$114824f4784b2ef6 = {
    ar: `\u{647}\u{644} \u{64A}\u{645}\u{643}\u{646} \u{627}\u{644}\u{633}\u{645}\u{627}\u{62D} \u{644}\u{644}\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}\u{64A}\u{646} \u{628}\u{639}\u{645}\u{644} \u{646}\u{633}\u{62E}\u{629} \u{645}\u{646} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}\u{61F}`,
    de: `Erlauben Sie Nutzern, eine Kopie dieser Aktivit\xe4t zu erstellen?`,
    es: `\xbfPermitir que los usuarios hagan una copia de esta actividad?`,
    fa: `\u{622}\u{6CC}\u{627} \u{628}\u{647} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{627}\u{646} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{62F}\u{627}\u{62F}\u{647} \u{645}\u{6CC} \u{634}\u{648}\u{62F} \u{6A9}\u{647} \u{6CC}\u{6A9} \u{646}\u{633}\u{62E}\u{647} \u{627}\u{632} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{647}\u{6CC}\u{647} \u{6A9}\u{646}\u{646}\u{62F}\u{61F}`,
    fil: `Papayagan ba ang mga gumagamit na gumawa ng kopya ng aktibidad na ito?`,
    fr: `Permettre aux utilisateurs de faire une copie de cette activit\xe9 ?`,
    hi: `\u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E}\u{913}\u{902} \u{915}\u{94B} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{940} \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{932}\u{93F}\u{92A}\u{93F} \u{92C}\u{928}\u{93E}\u{928}\u{947} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{926}\u{947}\u{902}?`,
    ht: `P\xe8m\xe8t itilizat\xe8 yo f\xe8 yon kopi aktivite sa a?`,
    it: `Permettere agli utenti di fare una copia di questa attivit\xe0?`,
    ja: `\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{304C}\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306E}\u{30B3}\u{30D4}\u{30FC}\u{3092}\u{4F5C}\u{6210}\u{3067}\u{304D}\u{308B}\u{3088}\u{3046}\u{306B}\u{3067}\u{304D}\u{307E}\u{3059}\u{304B}?`,
    ko: `\u{C0AC}\u{C6A9}\u{C790}\u{AC00} \u{C774} \u{D65C}\u{B3D9}\u{C758} \u{BCF5}\u{C0AC}\u{BCF8}\u{C744} \u{B9CC}\u{B4E4} \u{C218} \u{C788}\u{AC8C} \u{D558}\u{B098}\u{C694}?`,
    mww: `Tso cai rau cov neeg siv los ua ib daim qauv ntawm qhov kev ua no?`,
    ps: `\u{6A9}\u{627}\u{631}\u{648}\u{648}\u{646}\u{6A9}\u{648} \u{62A}\u{647} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{648}\u{631}\u{6A9}\u{648}\u{644} \u{686}\u{6D0} \u{62F} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{627}\u{67E}\u{6CC} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{6CC}\u{61F}`,
    pt: `Permitir que os usu\xe1rios fa\xe7am uma c\xf3pia dessa atividade?`,
    'pt-pt': `Permitir que os utilizadores fa\xe7am uma c\xf3pia desta atividade?`,
    ru: `\u{420}\u{430}\u{437}\u{440}\u{435}\u{448}\u{438}\u{442}\u{435} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F}\u{43C} \u{441}\u{434}\u{435}\u{43B}\u{430}\u{442}\u{44C} \u{43A}\u{43E}\u{43F}\u{438}\u{44E} \u{44D}\u{442}\u{43E}\u{439} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{438}?`,
    sm: `E mafai e tagata fa'aaoga ona faia se kopi o lenei gaoioiga?`,
    so: `Isticmaaleyaasha ma u oggolaan kartaa inay nuqul ka sameeyaan hawshan?`,
    th: `\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E17}\u{E4D}\u{E32}\u{E2A}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E32}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E44}\u{E14}\u{E49}\u{E44}\u{E2B}\u{E21}`,
    ur: `\u{6A9}\u{6CC}\u{627} \u{635}\u{627}\u{631}\u{641}\u{6CC}\u{646} \u{6A9}\u{648} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6CC} \u{6A9}\u{627}\u{67E}\u{6CC} \u{628}\u{646}\u{627}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{62F}\u{6CC} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{61F}`,
    vi: `Cho ph\xe9p ng\u{1B0}\u{1EDD}i d\xf9ng t\u{1EA1}o b\u{1EA3}n sao c\u{1EE7}a ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y?`,
    'zh-hans': `\u{5141}\u{8BB8}\u{7528}\u{6237}\u{590D}\u{5236}\u{8FD9}\u{9879}\u{6D3B}\u{52A8}\u{5417}\u{FF1F}`,
    'zh-hant': `\u{5141}\u{8A31}\u{4F7F}\u{7528}\u{8005}\u{8907}\u{88FD}\u{9019}\u{500B}\u{6D3B}\u{52D5}\u{FF1F}`,
    en: `Allow users to make a copy of this activity?`
};
const $b11db1b62d4a8f76$export$a0df3c8756d36e8 = {
    ar: `\u{627}\u{644}\u{633}\u{645}\u{627}\u{62D} \u{628}\u{627}\u{644}\u{62A}\u{62F}\u{627}\u{62E}\u{644}\u{627}\u{62A}`,
    de: `\xdcberlappungen erlauben`,
    es: `Permitir solapamientos`,
    fa: `\u{627}\u{62C}\u{627}\u{632}\u{647} \u{62F}\u{627}\u{62F}\u{646} \u{628}\u{647} \u{647}\u{645}\u{67E}\u{648}\u{634}\u{627}\u{646}\u{6CC} \u{647}\u{627}`,
    fil: `Payagan ang mga overlap`,
    fr: `Autoriser les chevauchements`,
    hi: `\u{913}\u{935}\u{930}\u{932}\u{948}\u{92A} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{926}\u{947}\u{902}`,
    ht: `P\xe8m\xe8t sip\xe8poze`,
    it: `Consentire sovrapposizioni`,
    ja: `\u{91CD}\u{8907}\u{3092}\u{8A8D}\u{3081}\u{308B}`,
    ko: `\u{C911}\u{CCA9} \u{D5C8}\u{C6A9}`,
    mww: `Tso cai sib tshooj`,
    ps: `\u{647}\u{645}\u{63A}\u{696}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{648}\u{631}\u{6A9}\u{693}\u{626}`,
    pt: `Permitir sobreposi\xe7\xf5es`,
    'pt-pt': `Permitir sobreposi\xe7\xf5es`,
    ru: `\u{420}\u{430}\u{437}\u{440}\u{435}\u{448}\u{438}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{43A}\u{440}\u{44B}\u{442}\u{438}\u{44F}`,
    sm: `Faatagaina overlaps`,
    so: `U oggolaa is-dhexgalka`,
    th: `\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E17}\u{E31}\u{E1A}\u{E0B}\u{E49}\u{E2D}\u{E19}\u{E01}\u{E31}\u{E19}`,
    ur: `\u{627}\u{648}\u{648}\u{631}\u{644}\u{6CC}\u{67E}\u{633} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{62F}\u{6CC}\u{6BA}`,
    vi: `Cho ph\xe9p tr\xf9ng l\u{1EB7}p`,
    'zh-hans': `\u{5141}\u{8BB8}\u{91CD}\u{53E0}`,
    'zh-hant': `\u{5141}\u{8A31}\u{91CD}\u{758A}`,
    en: `Allow overlaps`
};
const $b11db1b62d4a8f76$export$171ee5ff3328a010 = {
    ar: `\u{627}\u{633}\u{645}\u{62D} \u{644}\u{639}\u{62F}\u{629} \u{623}\u{646}\u{634}\u{637}\u{629} \u{645}\u{646} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{648}\u{639} \u{628}\u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} \u{644}\u{647}\u{627} \u{62A}\u{648}\u{627}\u{631}\u{64A}\u{62E} \u{628}\u{62F}\u{627}\u{64A}\u{629} \u{648}\u{646}\u{647}\u{627}\u{64A}\u{629} \u{645}\u{62A}\u{62F}\u{627}\u{62E}\u{644}\u{629}. \u{64A}\u{62A}\u{645} \u{627}\u{644}\u{62A}\u{62D}\u{642}\u{642} \u{645}\u{646} \u{62C}\u{645}\u{64A}\u{639} \u{62D}\u{627}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{628}\u{627}\u{633}\u{62A}\u{62B}\u{646}\u{627}\u{621} \u{627}\u{644}\u{645}\u{644}\u{63A}\u{627}\u{629} \u{639}\u{646}\u{62F} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{62F}\u{627}\u{62E}\u{644}.`,
    de: `Erlauben Sie, dass mehrere Aktivit\xe4ten dieser Art \xfcberlappende Start- und Enddaten haben. Alle Aktivit\xe4tsstatusse au\xdfer "Abgesagt" werden bei der Bestimmung der \xdcberlappung \xfcberpr\xfcft.`,
    es: `Permite que varias actividades de este tipo tengan fechas de inicio y fin que se solapan. Todos los estados de actividad excepto Cancelado se comprueban al determinar solapamientos.`,
    fa: `\u{627}\u{62C}\u{627}\u{632}\u{647} \u{62F}\u{647}\u{6CC}\u{62F} \u{686}\u{646}\u{62F}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{627}\u{632} \u{627}\u{6CC}\u{646} \u{646}\u{648}\u{639} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{647}\u{627}\u{6CC} \u{634}\u{631}\u{648}\u{639} \u{648} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{647}\u{645}\u{67E}\u{648}\u{634}\u{627}\u{646}\u{6CC} \u{62F}\u{627}\u{634}\u{62A}\u{647} \u{628}\u{627}\u{634}\u{646}\u{62F}. \u{62A}\u{645}\u{627}\u{645} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627} \u{628}\u{647} \u{62C}\u{632} \u{644}\u{63A}\u{648} \u{634}\u{62F}\u{647} \u{647}\u{646}\u{6AF}\u{627}\u{645} \u{62A}\u{639}\u{6CC}\u{6CC}\u{646} \u{647}\u{645}\u{67E}\u{648}\u{634}\u{627}\u{646}\u{6CC} \u{628}\u{631}\u{631}\u{633}\u{6CC} \u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: `Pahintulutan ang maramihang mga aktibidad ng ganitong uri na magkaroon ng magkakapatong na petsa ng pagsisimula at pagtatapos. Lahat ng katayuan ng aktibidad maliban sa Kinansela ay naka-check kapag tinutukoy ang overlap.`,
    fr: `Permettre \xe0 plusieurs activit\xe9s de ce type d\u{2019}avoir des dates de d\xe9but et de fin qui se chevauchent. Tous les statuts d\u{2019}activit\xe9 sauf Annul\xe9s sont v\xe9rifi\xe9s lors de la d\xe9termination du chevauchement.`,
    hi: `\u{907}\u{938} \u{92A}\u{94D}\u{930}\u{915}\u{93E}\u{930} \u{915}\u{940} \u{915}\u{908} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{913}\u{935}\u{930}\u{932}\u{948}\u{92A}\u{93F}\u{902}\u{917} \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{914}\u{930} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915} \u{930}\u{916}\u{928}\u{947} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{926}\u{947}\u{902}\u{964} \u{913}\u{935}\u{930}\u{932}\u{948}\u{92A} \u{915}\u{93E} \u{928}\u{93F}\u{930}\u{94D}\u{927}\u{93E}\u{930}\u{923} \u{915}\u{930}\u{924}\u{947} \u{938}\u{92E}\u{92F} \u{930}\u{926}\u{94D}\u{926} \u{915}\u{93F}\u{90F} \u{917}\u{90F} \u{915}\u{94B} \u{91B}\u{94B}\u{921}\u{93C}\u{915}\u{930} \u{938}\u{92D}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{940} \u{91C}\u{93E}\u{901}\u{91A} \u{915}\u{940} \u{91C}\u{93E}\u{924}\u{940} \u{939}\u{948}.`,
    ht: `P\xe8m\xe8t plizy\xe8 aktivite nan kalite sa a gen sip\xe8poze dat k\xf2manse ak fen. Tout estati aktivite eksepte anile yo tcheke l\xe8 det\xe8mine sip\xe8vizyon.`,
    it: `Consentire che pi\xf9 attivit\xe0 di questo tipo abbiano date di inizio e fine sovrapposte. Tutti gli stati delle attivit\xe0 tranne Cancellata vengono controllati quando si determina la sovrapposizione.`,
    ja: `\u{3053}\u{306E}\u{7A2E}\u{306E}\u{8907}\u{6570}\u{306E}\u{6D3B}\u{52D5}\u{304C}\u{958B}\u{59CB}\u{65E5}\u{3068}\u{7D42}\u{4E86}\u{65E5}\u{304C}\u{91CD}\u{306A}\u{308B}\u{3053}\u{3068}\u{3092}\u{8A31}\u{53EF}\u{3057}\u{307E}\u{3057}\u{3087}\u{3046}\u{3002}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3055}\u{308C}\u{305F}\u{4EE5}\u{5916}\u{306E}\u{3059}\u{3079}\u{3066}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}\u{306F}\u{91CD}\u{8907}\u{3092}\u{5224}\u{65AD}\u{3059}\u{308B}\u{969B}\u{306B}\u{30C1}\u{30A7}\u{30C3}\u{30AF}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774}\u{B7EC}\u{D55C} \u{C720}\u{D615}\u{C758} \u{C5EC}\u{B7EC} \u{D65C}\u{B3D9}\u{C774} \u{C2DC}\u{C791}\u{ACFC} \u{C885}\u{B8CC}\u{C77C}\u{C774} \u{ACB9}\u{CE58}\u{B3C4}\u{B85D} \u{D5C8}\u{C6A9}\u{D558}\u{C138}\u{C694}. \u{CDE8}\u{C18C}\u{B41C} \u{BAA8}\u{B4E0} \u{D65C}\u{B3D9} \u{C0C1}\u{D0DC}\u{B294} \u{C911}\u{BCF5} \u{C5EC}\u{BD80}\u{B97C} \u{D655}\u{C778}\u{D560} \u{B54C} \u{D655}\u{C778}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Tso cai rau ntau yam kev ua ub no ntawm hom no kom muaj cov hnub pib thiab xaus sib tshooj. Tag nrho cov xwm txheej kev ua ub no tshwj tsis yog Cancelled raug kuaj xyuas thaum txiav txim siab sib tshooj.`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{689}\u{648}\u{644} \u{685}\u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{648} \u{62A}\u{647} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{648}\u{631}\u{6A9}\u{693}\u{626} \u{686}\u{6D0} \u{62F} \u{67E}\u{6CC}\u{644} \u{627}\u{648} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{6D0} \u{633}\u{631}\u{647} \u{6AB}\u{689} \u{648}\u{6CC}. \u{67C}\u{648}\u{644} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{67E}\u{631}\u{62A}\u{647} \u{644}\u{647} \u{644}\u{63A}\u{648}\u{647} \u{634}\u{648}\u{6CC}\u{60C} \u{62F} \u{647}\u{645}\u{63A}\u{696}\u{6CC} \u{645}\u{639}\u{644}\u{648}\u{645}\u{648}\u{644}\u{648} \u{67E}\u{631} \u{645}\u{647}\u{627}\u{644} \u{686}\u{6A9} \u{6A9}\u{6D0}\u{696}\u{6CC}.`,
    pt: `Permitir que m\xfaltiplas atividades desse tipo tenham datas de in\xedcio e t\xe9rmino sobrepostas. Todos os status de atividade, exceto Cancelado, s\xe3o verificados ao determinar sobreposi\xe7\xe3o.`,
    'pt-pt': `Permitir que m\xfaltiplas atividades deste tipo tenham datas de in\xedcio e fim sobrepostas. Todos os estados das atividades, exceto Cancelado, s\xe3o verificados ao determinar sobreposi\xe7\xe3o.`,
    ru: `\u{41F}\u{43E}\u{437}\u{432}\u{43E}\u{43B}\u{438}\u{442}\u{44C} \u{43D}\u{435}\u{441}\u{43A}\u{43E}\u{43B}\u{44C}\u{43A}\u{438}\u{43C} \u{432}\u{438}\u{434}\u{430}\u{43C} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{442}\u{430}\u{43A}\u{43E}\u{433}\u{43E} \u{440}\u{43E}\u{434}\u{430} \u{438}\u{43C}\u{435}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{441}\u{435}\u{43A}\u{430}\u{44E}\u{449}\u{438}\u{435}\u{441}\u{44F} \u{434}\u{430}\u{442}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}. \u{412}\u{441}\u{435} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{44B} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{438}, \u{43A}\u{440}\u{43E}\u{43C}\u{435} \u{41E}\u{442}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{43D}\u{44B}\u{445}, \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{44F}\u{44E}\u{442}\u{441}\u{44F} \u{43F}\u{440}\u{438} \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{441}\u{435}\u{447}\u{435}\u{43D}\u{438}\u{44F}.`,
    sm: `Faataga le tele o gaoioiga o lenei ituaiga ina ia fesiligia aso amata ma aso faaiuga. O tulaga uma o gaoioiga sei vagana ai le Faaleaogaina e siakiina pe a fuafuaina le fesiligia.`,
    so: `U oggolaa hawlo badan oo noocan ah inay yeeshaan taariikho bilow iyo dhammaad isku dul saaran. Dhammaan xaaladaha hawlaha marka laga reebo Cancelled waa la hubiyaa marka la go'aamiyo isku-darka.`,
    th: `\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E2B}\u{E25}\u{E32}\u{E22}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E0A}\u{E19}\u{E34}\u{E14}\u{E19}\u{E35}\u{E49}\u{E21}\u{E35}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E41}\u{E25}\u{E30}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E17}\u{E35}\u{E48}\u{E17}\u{E31}\u{E1A}\u{E0B}\u{E49}\u{E2D}\u{E19}\u{E01}\u{E31}\u{E19} \u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}\u{E22}\u{E01}\u{E40}\u{E27}\u{E49}\u{E19}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E08}\u{E30}\u{E16}\u{E39}\u{E01}\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E40}\u{E21}\u{E37}\u{E48}\u{E2D}\u{E1E}\u{E34}\u{E08}\u{E32}\u{E23}\u{E13}\u{E32}\u{E01}\u{E32}\u{E23}\u{E17}\u{E31}\u{E1A}\u{E0B}\u{E49}\u{E2D}\u{E19}\u{E01}\u{E31}\u{E19}`,
    ur: `\u{627}\u{633} \u{642}\u{633}\u{645} \u{6A9}\u{6CC} \u{645}\u{62A}\u{639}\u{62F}\u{62F} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{648}\u{6BA} \u{6A9}\u{6CC} \u{634}\u{631}\u{648}\u{639}\u{627}\u{62A} \u{627}\u{648}\u{631} \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{6CC}\u{6BA} \u{627}\u{6CC}\u{6A9} \u{62C}\u{6CC}\u{633}\u{6CC} \u{6C1}\u{648}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{62F}\u{6CC}\u{6BA}\u{6D4} \u{62A}\u{645}\u{627}\u{645} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{648}\u{6BA} \u{6A9}\u{6CC} \u{62D}\u{627}\u{644}\u{62A}\u{6CC}\u{6BA} \u{633}\u{648}\u{627}\u{626}\u{6D2} '\u{645}\u{646}\u{633}\u{648}\u{62E}' \u{6A9}\u{6D2}\u{60C} \u{627}\u{648}\u{648}\u{631}\u{644}\u{6CC}\u{67E} \u{6A9}\u{627} \u{62A}\u{639}\u{6CC}\u{646} \u{6A9}\u{631}\u{62A}\u{6D2} \u{648}\u{642}\u{62A} \u{686}\u{6CC}\u{6A9} \u{6A9}\u{6CC} \u{62C}\u{627}\u{62A}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Cho ph\xe9p nhi\u{1EC1}u ho\u{1EA1}t \u{111}\u{1ED9}ng thu\u{1ED9}c lo\u{1EA1}i n\xe0y c\xf3 ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u v\xe0 ng\xe0y k\u{1EBF}t th\xfac tr\xf9ng l\u{1EB7}p. T\u{1EA5}t c\u{1EA3} c\xe1c tr\u{1EA1}ng th\xe1i ho\u{1EA1}t \u{111}\u{1ED9}ng ngo\u{1EA1}i tr\u{1EEB} \u{110}\xe3 h\u{1EE7}y \u{111}\u{1EC1}u \u{111}\u{1B0}\u{1EE3}c ki\u{1EC3}m tra khi x\xe1c \u{111}\u{1ECB}nh tr\xf9ng l\u{1EB7}p.`,
    'zh-hans': `\u{5141}\u{8BB8}\u{6B64}\u{7C7B}\u{591A}\u{4E2A}\u{6D3B}\u{52A8}\u{7684}\u{5F00}\u{59CB}\u{548C}\u{7ED3}\u{675F}\u{65E5}\u{671F}\u{91CD}\u{53E0}\u{3002}\u{5728}\u{786E}\u{5B9A}\u{91CD}\u{53E0}\u{65F6}\u{FF0C}\u{9664}\u{53D6}\u{6D88}\u{5916}\u{7684}\u{6240}\u{6709}\u{6D3B}\u{52A8}\u{72B6}\u{6001}\u{90FD}\u{4F1A}\u{88AB}\u{68C0}\u{67E5}\u{3002}`,
    'zh-hant': `\u{5141}\u{8A31}\u{6B64}\u{985E}\u{591A}\u{9805}\u{6D3B}\u{52D5}\u{7684}\u{958B}\u{59CB}\u{8207}\u{7D50}\u{675F}\u{65E5}\u{671F}\u{91CD}\u{758A}\u{3002}\u{5728}\u{5224}\u{65B7}\u{6D3B}\u{52D5}\u{91CD}\u{758A}\u{6642}\u{FF0C}\u{9664}\u{4E86}\u{53D6}\u{6D88}\u{5916}\u{FF0C}\u{6240}\u{6709}\u{6D3B}\u{52D5}\u{72C0}\u{614B}\u{90FD}\u{6703}\u{88AB}\u{6AA2}\u{67E5}\u{3002}`,
    en: `Permit multiple activities of this type to have overlapping start and end dates. All activity statuses except Cancelled are checked when determining overlap.`
};
const $b11db1b62d4a8f76$export$42922b4d18e68d58 = {
    ar: `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{641}\u{62A}\u{631}\u{627}\u{62A}`,
    de: `Alle Perioden`,
    es: `Todos los periodos`,
    fa: `\u{62A}\u{645}\u{627}\u{645} \u{62F}\u{648}\u{631}\u{647} \u{647}\u{627}`,
    fil: `Lahat ng mga panahon`,
    fr: `Toutes les p\xe9riodes`,
    hi: `\u{938}\u{92D}\u{940} \u{905}\u{935}\u{927}\u{93F}`,
    ht: `Tout pery\xf2d`,
    it: `Tutti i periodi`,
    ja: `\u{5168}\u{671F}\u{9593}`,
    ko: `\u{BAA8}\u{B4E0} \u{AE30}\u{AC04}`,
    mww: `Txhua lub sij hawm`,
    ps: `\u{67C}\u{648}\u{644}\u{6D0} \u{62F}\u{648}\u{631}\u{6D0}`,
    pt: `Todos os per\xedodos`,
    'pt-pt': `Todos os per\xedodos`,
    ru: `\u{412}\u{441}\u{435} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{44B}`,
    sm: `Vaitaimi uma`,
    so: `Dhammaan xilliyada`,
    th: `\u{E17}\u{E38}\u{E01}\u{E0A}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}`,
    ur: `\u{62A}\u{645}\u{627}\u{645} \u{627}\u{62F}\u{648}\u{627}\u{631}`,
    vi: `T\u{1EA5}t c\u{1EA3} c\xe1c giai \u{111}o\u{1EA1}n`,
    'zh-hans': `\u{6240}\u{6709}\u{65F6}\u{671F}`,
    'zh-hant': `\u{6240}\u{6709}\u{6642}\u{671F}`,
    en: `All periods`
};
const $b11db1b62d4a8f76$export$2471cd6859e40104 = {
    ar: `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{64A}\u{639}`,
    de: `Alle Projekte`,
    es: `Todos los proyectos`,
    fa: `\u{62A}\u{645}\u{627}\u{645} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{647}\u{627}`,
    fil: `Lahat ng proyekto`,
    fr: `Tous les projets`,
    hi: `\u{938}\u{92D}\u{940} \u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E}\u{90F}\u{902}`,
    ht: `Tout pwoj\xe8 yo`,
    it: `Tutti i progetti`,
    ja: `\u{3059}\u{3079}\u{3066}\u{306E}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}`,
    ko: `\u{BAA8}\u{B4E0} \u{D504}\u{B85C}\u{C81D}\u{D2B8}`,
    mww: `Tag nrho cov haujlwm`,
    ps: `\u{67C}\u{648}\u{644}\u{6D0} \u{67E}\u{631}\u{648}\u{698}\u{6D0}`,
    pt: `Todos os projetos`,
    'pt-pt': `Todos os projetos`,
    ru: `\u{412}\u{441}\u{435} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{44B}`,
    sm: `Galuega faatino uma`,
    so: `Dhammaan mashaariicda`,
    th: `\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{62A}\u{645}\u{627}\u{645} \u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2}`,
    vi: `T\u{1EA5}t c\u{1EA3} c\xe1c d\u{1EF1} \xe1n`,
    'zh-hans': `\u{6240}\u{6709}\u{9879}\u{76EE}`,
    'zh-hant': `\u{6240}\u{6709}\u{5C08}\u{6848}`,
    en: `All projects`
};
const $b11db1b62d4a8f76$export$a45dd6e2d42cfaa = {
    ar: `\u{62A}\u{645} \u{62A}\u{639}\u{628}\u{626}\u{629} \u{627}\u{644}\u{648}\u{62B}\u{64A}\u{642}\u{629} \u{628}\u{627}\u{644}\u{641}\u{639}\u{644}.`,
    de: `Das Dokument wurde bereits ausgef\xfcllt.`,
    es: `El documento ya ha sido rellenado.`,
    fa: `\u{633}\u{646}\u{62F} \u{642}\u{628}\u{644}\u{627} \u{67E}\u{631} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Nakumpleto na ang dokumento.`,
    fr: `Le document a d\xe9j\xe0 \xe9t\xe9 rempli.`,
    hi: `\u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C} \u{92A}\u{939}\u{932}\u{947} \u{939}\u{940} \u{92D}\u{930}\u{93E} \u{91C}\u{93E} \u{91A}\u{941}\u{915}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Dokiman an deja ranpli`,
    it: `Il documento \xe8 gi\xe0 stato compilato.`,
    ja: `\u{66F8}\u{985E}\u{306F}\u{3059}\u{3067}\u{306B}\u{8A18}\u{5165}\u{6E08}\u{307F}\u{3067}\u{3059}\u{3002}`,
    ko: `\u{BB38}\u{C11C}\u{B294} \u{C774}\u{BBF8} \u{C791}\u{C131}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Cov ntaub ntawv twb tau sau.`,
    ps: `\u{633}\u{646}\u{62F} \u{644}\u{627} \u{62F}\u{645}\u{62E}\u{647} \u{689}\u{6A9} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: `O documento j\xe1 foi preenchido.`,
    'pt-pt': `O documento j\xe1 foi preenchido.`,
    ru: `\u{414}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442} \u{443}\u{436}\u{435} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}.`,
    sm: `Ua uma ona fa'atumuina le pepa.`,
    so: `Dukumentigu hore ayaa loo buuxiyay.`,
    th: `\u{E01}\u{E23}\u{E2D}\u{E01}\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632} \u{67E}\u{6C1}\u{644}\u{6D2} \u{6C1}\u{6CC} \u{628}\u{6BE}\u{631} \u{62F}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `T\xe0i li\u{1EC7}u \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c \u{111}i\u{1EC1}n v\xe0o.`,
    'zh-hans': `\u{6587}\u{4EF6}\u{5DF2}\u{7ECF}\u{586B}\u{5199}\u{5B8C}\u{6BD5}\u{3002}`,
    'zh-hant': `\u{6587}\u{4EF6}\u{5DF2}\u{7D93}\u{586B}\u{5BEB}\u{5B8C}\u{7562}\u{3002}`,
    en: `The document has already been filled.`
};
const $b11db1b62d4a8f76$export$857dd38e1c47f95d = {
    ar: `\u{627}\u{644}\u{648}\u{62B}\u{64A}\u{642}\u{629} \u{642}\u{62F} \u{62A}\u{645} \u{62A}\u{648}\u{642}\u{64A}\u{639}\u{647}\u{627} \u{628}\u{627}\u{644}\u{641}\u{639}\u{644}.`,
    de: `Das Dokument wurde bereits unterschrieben.`,
    es: `El documento ya ha sido firmado.`,
    fa: `\u{633}\u{646}\u{62F} \u{642}\u{628}\u{644}\u{627} \u{627}\u{645}\u{636}\u{627} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Nilagdaan na ang dokumento.`,
    fr: `Le document a d\xe9j\xe0 \xe9t\xe9 sign\xe9.`,
    hi: `\u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C} \u{92A}\u{930} \u{92A}\u{939}\u{932}\u{947} \u{939}\u{940} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{93F}\u{90F} \u{91C}\u{93E} \u{91A}\u{941}\u{915}\u{947} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Dokiman an te deja siyen`,
    it: `Il documento \xe8 gi\xe0 stato firmato.`,
    ja: `\u{305D}\u{306E}\u{6587}\u{66F8}\u{306F}\u{3059}\u{3067}\u{306B}\u{7F72}\u{540D}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{BB38}\u{C11C}\u{B294} \u{C774}\u{BBF8} \u{C11C}\u{BA85}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Daim ntawv twb tau kos npe lawm.`,
    ps: `\u{633}\u{646}\u{62F} \u{644}\u{627} \u{62F}\u{645}\u{62E}\u{647} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: `O documento j\xe1 foi assinado.`,
    'pt-pt': `O documento j\xe1 foi assinado.`,
    ru: `\u{414}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442} \u{443}\u{436}\u{435} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}.`,
    sm: `Ua uma ona sainia le pepa.`,
    so: `Dukumentigu hore ayaa loo saxiixay.`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E19}\u{E32}\u{E21}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632} \u{67E}\u{631} \u{67E}\u{6C1}\u{644}\u{6D2} \u{6C1}\u{6CC} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6C1}\u{648} \u{686}\u{6A9}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `T\xe0i li\u{1EC7}u \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c k\xfd.`,
    'zh-hans': `\u{6587}\u{4EF6}\u{5DF2}\u{7ECF}\u{7B7E}\u{7F72}\u{3002}`,
    'zh-hant': `\u{6587}\u{4EF6}\u{5DF2}\u{7D93}\u{7C3D}\u{7F72}\u{3002}`,
    en: `The document has already been signed.`
};
const $b11db1b62d4a8f76$export$cfd6150258d9bcde = {
    ar: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>يمكنك أيضا التواصل معنا عبر البريد الإلكتروني ${email}، والهاتف ${phone}، وعبر البريد ${address}.</span>`,
    de: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>Sie können uns auch per E-Mail unter ${email}, telefonisch ${phone} und per Post unter ${address}, erreichen.</span>`,
    es: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>También puedes contactarnos por correo electrónico ${email}, por teléfono al ${phone} y por correo postal en ${address}.</span>`,
    fa: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>همچنین می توانید از طریق ایمیل ${email}، تلفن ${phone} و پست به ${address} با ما تماس بگیرید.</span>`,
    fil: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>Maaari mo ring maabot kami sa pamamagitan ng email sa ${email}, sa pamamagitan ng telepono sa ${phone}, at sa pamamagitan ng koreo sa ${address}.</span>`,
    fr: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>Vous pouvez également nous joindre par email ${email}, par téléphone au ${phone}, et par courrier à ${address}.</span>`,
    hi: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>आप हमें ${email} पर ईमेल के माध्यम से, ${phone} पर फोन द्वारा और ${address} पर मेल द्वारा भी संपर्क कर सकते हैं।</span>`,
    ht: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>Ou ka kontakte nou tou pa imèl ${email}, pa telefòn nan ${phone}, ak pa lapòs nan ${address}.</span>`,
    it: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>Potete anche contattarci via email ${email}, telefonicamente al ${phone} e per posta all'indirizzo ${address}.</span>`,
    ja: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>また、 ${email})、電話 ${phone}、郵便( ${address})でもご連絡いただけます。</span>`,
    ko: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>또한 ${email}, ${phone}, 우편 주소 ${address}로 연락하실 수 있습니다.</span>`,
    mww: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>Koj tseem tuaj yeem tiv tauj peb ntawm email ntawm ${email}, hauv xov tooj ntawm ${phone} thiab los ntawm kev xa ntawv ntawm ${address}.</span>`,
    ps: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>تاسو کولی شئ موږ ته د ایمیل له ${email}، د ${phone}، او د پوست له لارې په ${address} کې هم اړیکه ونیسئ.</span>`,
    pt: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>Você também pode nos contatar por e-mail ${email}, pelo ${phone} e pelo correio ${address}.</span>`,
    'pt-pt': (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>Também pode contactar-nos por email ${email}, por telefone para ${phone} e por correio para ${address}.</span>`,
    ru: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>Вы также можете связаться с нами по электронной почте ${email}, по ${phone} и по почте по ${address}.</span>`,
    sm: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>E mafai foi ona e fa'afeso'ota'i mai matou e ala i le imeli i ${email}, i le telefoni i ${phone}, ma le meli i le ${address}.</span>`,
    so: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>Waxaad sidoo kale nala xiriiri kartaa email ${email}, telefoonka ${phone}, iyo boostada ${address}.</span>`,
    th: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>คุณสามารถติดต่อเราทางอีเมลได้ที่ ${email} ทางโทรศัพท์ที่ ${phone} และทางไปรษณีย์ที่ ${address}</span>`,
    ur: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>آپ ہمیں ${email}، ${phone}، اور ${address} پر بھی رابطہ کر سکتے ہیں۔</span>`,
    vi: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>Bạn cũng có thể liên hệ với chúng tôi qua email theo địa chỉ ${email}, qua điện thoại ${phone} và qua đường bưu điện tại ${address}.</span>`,
    'zh-hans': (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>你也可以通过 ${email}、电话 ${phone}，以及邮寄至 ${address}号与我们联系。</span>`,
    'zh-hant': (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>您也可以透過電子郵件 ${email}、電話 ${phone}，以及郵寄至 ${address} 與我們聯繫。</span>`,
    en: (email, phone, address)=>$b11db1b62d4a8f76$var$html`<span>You can also reach us via email at ${email}, by phone at ${phone}, and by mail at ${address}.</span>`
};
const $b11db1b62d4a8f76$export$8325dd816b79073b = {
    ar: `\u{627}\u{644}\u{645}\u{628}\u{644}\u{63A}`,
    de: `Betrag`,
    es: `Cantidad`,
    fa: `\u{645}\u{642}\u{62F}\u{627}\u{631}`,
    fil: `Halaga`,
    fr: `Montant`,
    hi: `\u{915}\u{941}\u{932} \u{927}\u{928}\u{930}\u{93E}\u{936}\u{93F}`,
    ht: `Kantite lajan`,
    it: `Importo`,
    ja: `\u{91D1}\u{984D}`,
    ko: `\u{C591}`,
    mww: `nyiaj npaum li cas`,
    ps: `\u{645}\u{642}\u{62F}\u{627}\u{631}`,
    pt: `Valor`,
    'pt-pt': `Montante`,
    ru: `\u{421}\u{443}\u{43C}\u{43C}\u{430}`,
    sm: `Aofaiga`,
    so: `Qadarka`,
    th: `\u{E08}\u{E4D}\u{E32}\u{E19}\u{E27}\u{E19}\u{E40}\u{E07}\u{E34}\u{E19}`,
    ur: `\u{631}\u{642}\u{645}`,
    vi: `S\u{1ED1} ti\u{1EC1}n`,
    'zh-hans': `\u{6570}\u{91CF}`,
    'zh-hant': `\u{91D1}\u{984D}`,
    en: `Amount`
};
const $b11db1b62d4a8f76$export$bd981c29cbdf2d7a = {
    ar: `\u{623}\u{64A}`,
    de: `Irgendeine`,
    es: `Cualquiera`,
    fa: `\u{647}\u{6CC}\u{686}`,
    fil: `Anumang`,
    fr: `N\u{2019}importe lequel`,
    hi: `\u{915}\u{94B}\u{908} \u{92D}\u{940}`,
    ht: `Nenp\xf2t`,
    it: `Qualsiasi`,
    ja: `\u{3069}\u{3093}\u{306A}\u{4EBA}\u{3067}\u{3082}`,
    ko: `\u{C5B4}\u{B5A4} \u{AC83}\u{C774}\u{B4E0}`,
    mww: `Ib qho`,
    ps: `\u{647}\u{631}`,
    pt: `Qualquer`,
    'pt-pt': `Qualquer`,
    ru: `\u{41B}\u{44E}\u{431}\u{43E}\u{439}`,
    sm: `So'o se`,
    so: `Mid kasta`,
    th: `\u{E43}\u{E14} \u{E46}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC}`,
    vi: `B\u{1EA5}t k\u{1EF3}`,
    'zh-hans': `\u{4EFB}\u{4F55}`,
    'zh-hant': `\u{4EFB}\u{4F55}`,
    en: `Any`
};
const $b11db1b62d4a8f76$export$ac7cf36c103be088 = {
    ar: `\u{623}\u{64A} \u{645}\u{633}\u{627}\u{641}\u{629}`,
    de: `Jede Entfernung`,
    es: `Cualquier distancia`,
    fa: `\u{647}\u{631} \u{641}\u{627}\u{635}\u{644}\u{647} \u{627}\u{6CC}`,
    fil: `Anumang distansya`,
    fr: `N\u{2019}importe quelle distance`,
    hi: `\u{915}\u{94B}\u{908} \u{92D}\u{940} \u{926}\u{942}\u{930}\u{940}`,
    ht: `Nenp\xf2t distans`,
    it: `Qualsiasi distanza`,
    ja: `\u{3069}\u{3093}\u{306A}\u{8DDD}\u{96E2}\u{3067}\u{3082}`,
    ko: `\u{C5B4}\u{B5A4} \u{AC70}\u{B9AC}\u{B4E0}`,
    mww: `kev ncua deb`,
    ps: `\u{647}\u{631} \u{648}\u{627}\u{67C}\u{646}`,
    pt: `Qualquer dist\xe2ncia`,
    'pt-pt': `Qualquer dist\xe2ncia`,
    ru: `\u{41B}\u{44E}\u{431}\u{43E}\u{435} \u{440}\u{430}\u{441}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{435}`,
    sm: `So'o se mamao`,
    so: `Masaafad kasta`,
    th: `\u{E17}\u{E38}\u{E01}\u{E23}\u{E30}\u{E22}\u{E30}\u{E17}\u{E32}\u{E07}`,
    ur: `\u{6A9}\u{633}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{641}\u{627}\u{635}\u{644}\u{6D2} \u{67E}\u{631}`,
    vi: `B\u{1EA5}t k\u{1EF3} kho\u{1EA3}ng c\xe1ch n\xe0o`,
    'zh-hans': `\u{4EFB}\u{4F55}\u{8DDD}\u{79BB}`,
    'zh-hant': `\u{4EFB}\u{4F55}\u{8DDD}\u{96E2}`,
    en: `Any distance`
};
const $b11db1b62d4a8f76$export$122f173ea570fec7 = {
    ar: `\u{641}\u{64A} \u{623}\u{64A} \u{645}\u{643}\u{627}\u{646}`,
    de: `Irgendwo`,
    es: `En cualquier sitio`,
    fa: `\u{647}\u{631} \u{62C}\u{627}`,
    fil: `Kahit saan`,
    fr: `N\u{2019}importe o\xf9`,
    hi: `\u{915}\u{939}\u{940}\u{902} \u{92D}\u{940}`,
    ht: `Nenp\xf2t kote`,
    it: `Ovunque`,
    ja: `\u{3069}\u{3053}\u{3067}\u{3082}`,
    ko: `\u{C5B4}\u{B514}\u{C11C}\u{B4E0}`,
    mww: `nyob qhov twg`,
    ps: `\u{647}\u{631} \u{681}\u{627}\u{6CC}`,
    pt: `Em qualquer lugar`,
    'pt-pt': `Em qualquer lugar`,
    ru: `\u{413}\u{434}\u{435} \u{443}\u{433}\u{43E}\u{434}\u{43D}\u{43E}`,
    sm: `Soo se mea`,
    so: `Meel kasta`,
    th: `\u{E17}\u{E38}\u{E01}\u{E17}\u{E35}\u{E48}`,
    ur: `\u{6A9}\u{6C1}\u{6CC}\u{6BA} \u{628}\u{6BE}\u{6CC}`,
    vi: `B\u{1EA5}t c\u{1EE9} n\u{1A1}i n\xe0o`,
    'zh-hans': `\u{4EFB}\u{4F55}\u{5730}\u{65B9}`,
    'zh-hant': `\u{4EFB}\u{4F55}\u{5730}\u{65B9}`,
    en: `Anywhere`
};
const $b11db1b62d4a8f76$export$4712ee0299255910 = {
    ar: `\u{642}\u{62F}\u{645}`,
    de: `Bewerben Sie sich`,
    es: `Solicita`,
    fa: `\u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{628}\u{62F}\u{647}`,
    fil: `Mag-aplay`,
    fr: `Postulez`,
    hi: `\u{932}\u{93E}\u{917}\u{942} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Aplike`,
    it: `Candidati`,
    ja: `\u{5FDC}\u{52DF}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{C9C0}\u{C6D0}`,
    mww: `thov`,
    ps: `\u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{648}\u{631}\u{6A9}\u{693}\u{647}`,
    pt: `Candidate-se`,
    'pt-pt': `Candidata-te`,
    ru: `\u{41F}\u{43E}\u{434}\u{430}\u{439}\u{442}\u{435} \u{437}\u{430}\u{44F}\u{432}\u{43A}\u{443}`,
    sm: `Talosaga`,
    so: `Codso`,
    th: `\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}`,
    ur: `\u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{62F}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{103}ng k\xfd`,
    'zh-hans': `\u{7533}\u{8BF7}`,
    'zh-hant': `\u{7533}\u{8ACB}`,
    en: `Apply`
};
const $b11db1b62d4a8f76$export$c7ad39eb9edc2acd = {
    ar: `\u{62A}\u{645}\u{62A} \u{627}\u{644}\u{645}\u{648}\u{627}\u{641}\u{642}\u{629}`,
    de: `Genehmigt`,
    es: `Aprobado`,
    fa: `\u{62A}\u{623}\u{6CC}\u{6CC}\u{62F} \u{634}\u{62F}\u{647}`,
    fil: `Inaprubahan`,
    fr: `Approuv\xe9`,
    hi: `\u{938}\u{94D}\u{935}\u{940}\u{915}\u{943}\u{924}`,
    ht: `Apwouve`,
    it: `Approvato`,
    ja: `\u{627F}\u{8A8D}\u{6E08}\u{307F}`,
    ko: `\u{C2B9}\u{C778}`,
    mww: `Pom Zoo`,
    ps: `\u{62A}\u{635}\u{648}\u{6CC}\u{628} \u{634}\u{648}`,
    pt: `Aprovado`,
    'pt-pt': `Aprovado`,
    ru: `\u{41E}\u{434}\u{43E}\u{431}\u{440}\u{435}\u{43D}\u{43E}`,
    sm: `Faamaonia`,
    so: `La ansixiyay`,
    th: `\u{E2D}\u{E19}\u{E38}\u{E21}\u{E31}\u{E15}\u{E34}`,
    ur: `\u{645}\u{646}\u{638}\u{648}\u{631} \u{634}\u{62F}\u{6C1}`,
    vi: `\u{110}\xe3 \u{111}\u{1B0}\u{1EE3}c ph\xea duy\u{1EC7}t`,
    'zh-hans': `\u{6279}\u{51C6}\u{4E86}`,
    'zh-hant': `\u{5DF2}\u{6279}\u{51C6}`,
    en: `Approved`
};
const $b11db1b62d4a8f76$export$d35186a1032e6fb2 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{627}\u{641}\u{642}\u{629} \u{639}\u{644}\u{649} \u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{645}\u{648}\u{627}\u{639}\u{64A}\u{62F}`,
    de: `Stundenzettel genehmigen`,
    es: `Aprobar la hoja de horas`,
    fa: `\u{62A}\u{623}\u{6CC}\u{6CC}\u{62F} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646}`,
    fil: `Aprubahan ang timesheet`,
    fr: `Approuver la feuille de temps`,
    hi: `\u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{943}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Apwouve Timesheet`,
    it: `Approva il foglio orario`,
    ja: `\u{627F}\u{8A8D}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}`,
    ko: `\u{C2B9}\u{C778} \u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C}`,
    mww: `Pom zoo rau daim ntawv teev sijhawm`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647} \u{62A}\u{627}\u{6CC}\u{6CC}\u{62F} \u{6A9}\u{693}\u{626}`,
    pt: `Aprovar folha de ponto`,
    'pt-pt': `Aprovar folha de horas`,
    ru: `\u{423}\u{442}\u{432}\u{435}\u{440}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44C}\u{44F} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}`,
    sm: `Faamaonia le pepa o taimi`,
    so: `Ansixi jadwalka waqtiga`,
    th: `\u{E2D}\u{E19}\u{E38}\u{E21}\u{E31}\u{E15}\u{E34}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}`,
    ur: `\u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{6A9}\u{6CC} \u{645}\u{646}\u{638}\u{648}\u{631}\u{6CC} \u{62F}\u{6CC}\u{6BA}`,
    vi: `Ph\xea duy\u{1EC7}t b\u{1EA3}ng ch\u{1EA5}m c\xf4ng`,
    'zh-hans': `\u{6279}\u{51C6}\u{65F6}\u{95F4}\u{8868}`,
    'zh-hant': `\u{6279}\u{51C6}\u{5DE5}\u{6642}\u{8868}`,
    en: `Approve timesheet`
};
const $b11db1b62d4a8f76$export$14627eadadec29ea = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{642}\u{639} \u{627}\u{644}\u{62A}\u{642}\u{631}\u{64A}\u{628}\u{64A}`,
    de: `Ungef\xe4hrer Standort`,
    es: `Ubicaci\xf3n aproximada`,
    fa: `\u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A} \u{62A}\u{642}\u{631}\u{6CC}\u{628}\u{6CC}`,
    fil: `Tinatayang lokasyon`,
    fr: `Localisation approximative`,
    hi: `\u{905}\u{928}\u{941}\u{92E}\u{93E}\u{928}\u{93F}\u{924} \u{938}\u{94D}\u{925}\u{93E}\u{928}`,
    ht: `Kote apwoksimatif`,
    it: `Posizione approssimativa`,
    ja: `\u{304A}\u{304A}\u{3088}\u{305D}\u{306E}\u{4F4D}\u{7F6E}`,
    ko: `\u{B300}\u{B7B5}\u{C801}\u{C778} \u{C704}\u{CE58}`,
    mww: `Qhov chaw kwv yees`,
    ps: `\u{62A}\u{642}\u{631}\u{6CC}\u{628}\u{6CC} \u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A}`,
    pt: `Localiza\xe7\xe3o aproximada`,
    'pt-pt': `Localiza\xe7\xe3o aproximada`,
    ru: `\u{41F}\u{440}\u{438}\u{431}\u{43B}\u{438}\u{437}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{435} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Nofoaga fa'atatau`,
    so: `Goobta qiyaasta ah`,
    th: `\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E42}\u{E14}\u{E22}\u{E1B}\u{E23}\u{E30}\u{E21}\u{E32}\u{E13}`,
    ur: `\u{62A}\u{642}\u{631}\u{6CC}\u{628}\u{627} \u{645}\u{642}\u{627}\u{645}`,
    vi: `V\u{1ECB} tr\xed g\u{1EA7}n \u{111}\xfang`,
    'zh-hans': `\u{5927}\u{81F4}\u{4F4D}\u{7F6E}`,
    'zh-hant': `\u{5927}\u{81F4}\u{4F4D}\u{7F6E}`,
    en: `Approximate location`
};
const $b11db1b62d4a8f76$export$763476d2854d42f5 = {
    ar: (cumulusAssistant)=>`\u{627}\u{633}\u{623}\u{644} ${cumulusAssistant}`,
    de: (cumulusAssistant)=>`Fragen ${cumulusAssistant}`,
    es: (cumulusAssistant)=>`Pregunta ${cumulusAssistant}`,
    fa: (cumulusAssistant)=>`\u{627}\u{632} ${cumulusAssistant} \u{628}\u{67E}\u{631}\u{633}\u{6CC}\u{62F}`,
    fil: (cumulusAssistant)=>`Magtanong ${cumulusAssistant}`,
    fr: (cumulusAssistant)=>`Demandez ${cumulusAssistant}`,
    hi: (cumulusAssistant)=>`${cumulusAssistant} \u{92A}\u{942}\u{91B}\u{947}\u{902}`,
    ht: (cumulusAssistant)=>`Mande ${cumulusAssistant}`,
    it: (cumulusAssistant)=>`Chiedi ${cumulusAssistant}`,
    ja: (cumulusAssistant)=>`${cumulusAssistant}\u{30C8}\u{306B}\u{805E}\u{304F}`,
    ko: (cumulusAssistant)=>`${cumulusAssistant}\u{D2B8}\u{C5D0}\u{AC8C} \u{BB3C}\u{C5B4}\u{BCF4}\u{C138}\u{C694}`,
    mww: (cumulusAssistant)=>`Nug ${cumulusAssistant}`,
    ps: (cumulusAssistant)=>`${cumulusAssistant}`,
    pt: (cumulusAssistant)=>`Pergunte ${cumulusAssistant}`,
    'pt-pt': (cumulusAssistant)=>`Pergunte ${cumulusAssistant}`,
    ru: (cumulusAssistant)=>`${cumulusAssistant}`,
    sm: (cumulusAssistant)=>`Fesili ${cumulusAssistant}`,
    so: (cumulusAssistant)=>`Weydii ${cumulusAssistant}`,
    th: (cumulusAssistant)=>`\u{E16}\u{E32}\u{E21} ${cumulusAssistant}`,
    ur: (cumulusAssistant)=>`${cumulusAssistant} \u{633}\u{6D2} \u{67E}\u{648}\u{686}\u{6BE}\u{6CC}\u{6BA}`,
    vi: (cumulusAssistant)=>`H\u{1ECF}i ${cumulusAssistant}`,
    'zh-hans': (cumulusAssistant)=>`\u{95EE} ${cumulusAssistant}`,
    'zh-hant': (cumulusAssistant)=>`\u{554F} ${cumulusAssistant}`,
    en: (cumulusAssistant)=>`Ask ${cumulusAssistant}`
};
const $b11db1b62d4a8f76$export$16256a8f0e357bc4 = {
    ar: (login)=>$b11db1b62d4a8f76$var$html`التعيين <span>${login}</span>`,
    de: (login)=>$b11db1b62d4a8f76$var$html`Jane zugeteilt <span>${login}</span>`,
    es: (login)=>$b11db1b62d4a8f76$var$html`asignado a <span>${login}</span>`,
    fa: (login)=>$b11db1b62d4a8f76$var$html`اختصاص یافته به <span>${login}</span>`,
    fil: (login)=>$b11db1b62d4a8f76$var$html`Inatasan si <span>${login}</span>`,
    fr: (login)=>$b11db1b62d4a8f76$var$html`assigné à <span>${login}</span>`,
    hi: (login)=>$b11db1b62d4a8f76$var$html`जेन को सौंपा गया <span>${login}</span>`,
    ht: (login)=>$b11db1b62d4a8f76$var$html`asiyen nan <span>${login}</span>`,
    it: (login)=>$b11db1b62d4a8f76$var$html`assegnato a <span>${login}</span>`,
    ja: (login)=>$b11db1b62d4a8f76$var$html`<span>${login}に割り当てられた</span>`,
    ko: (login)=>$b11db1b62d4a8f76$var$html`<span>${login}에게 배정되었다</span>`,
    mww: (login)=>$b11db1b62d4a8f76$var$html`raug xa mus rau <span>${login}</span>`,
    ps: (login)=>$b11db1b62d4a8f76$var$html`جین ته ټاکل <span>${login}</span>`,
    pt: (login)=>$b11db1b62d4a8f76$var$html`Designado para <span>${login}</span>`,
    'pt-pt': (login)=>$b11db1b62d4a8f76$var$html`atribuído a <span>${login}</span>`,
    ru: (login)=>$b11db1b62d4a8f76$var$html`назначен на <span>${login}</span>`,
    sm: (login)=>$b11db1b62d4a8f76$var$html`Tofia ia <span>${login}</span>`,
    so: (login)=>$b11db1b62d4a8f76$var$html`<span>${login}</span>`,
    th: (login)=>$b11db1b62d4a8f76$var$html`มอบหมายให้ <span>${login}</span>`,
    ur: (login)=>$b11db1b62d4a8f76$var$html`جین کو تفویض <span>${login}</span>`,
    vi: (login)=>$b11db1b62d4a8f76$var$html`được giao cho <span>${login}</span>`,
    'zh-hans': (login)=>$b11db1b62d4a8f76$var$html`分配给 <span>${login}</span>`,
    'zh-hant': (login)=>$b11db1b62d4a8f76$var$html`被分配給 <span>${login}</span>`,
    en: (login)=>$b11db1b62d4a8f76$var$html`assigned to <span>${login}</span>`
};
const $b11db1b62d4a8f76$export$5db0ace58855f4c0 = {
    ar: `\u{62A}\u{645} \u{62A}\u{639}\u{64A}\u{64A}\u{646}\u{647} \u{644}\u{643}`,
    de: `Ihnen zugeteilt`,
    es: `Asignado a ti`,
    fa: `\u{628}\u{647} \u{62A}\u{648} \u{627}\u{62E}\u{62A}\u{635}\u{627}\u{635} \u{62F}\u{627}\u{62F}\u{647} \u{634}\u{62F}\u{647}`,
    fil: `Itinalaga sa iyo`,
    fr: `Assign\xe9 \xe0 toi`,
    hi: `\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{94C}\u{902}\u{92A}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Asiyen pou ou`,
    it: `Assegnato a te`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306B}\u{5272}\u{308A}\u{5F53}\u{3066}\u{3089}\u{308C}\u{305F}`,
    ko: `\u{B108}\u{C5D0}\u{AC8C} \u{BC30}\u{C815}\u{B410}\u{C5B4}`,
    mww: `Muab tso rau koj`,
    ps: `\u{62A}\u{627} \u{62A}\u{647} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC}`,
    pt: `Designado para voc\xea`,
    'pt-pt': `Atribu\xeddo a ti`,
    ru: `\u{41D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43E} \u{442}\u{435}\u{431}\u{435}`,
    sm: `Tofia ia te oe`,
    so: `Adiga ayaa loo xilsaaray`,
    th: `\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{648} \u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c ch\u{1EC9} \u{111}\u{1ECB}nh cho b\u{1EA1}n`,
    'zh-hans': `\u{5206}\u{914D}\u{7ED9}\u{4F60}`,
    'zh-hant': `\u{5206}\u{914D}\u{7D66}\u{4F60}`,
    en: `Assigned to you`
};
const $b11db1b62d4a8f76$export$1dc36e4b6908af26 = {
    ar: `\u{62A}\u{645} \u{62A}\u{639}\u{64A}\u{64A}\u{646}\u{647}\u{645} \u{641}\u{64A} \u{645}\u{646}\u{638}\u{645}\u{62A}\u{643}`,
    de: `Ihrer Organisation zugewiesen`,
    es: `Asignado a tu organizaci\xf3n`,
    fa: `\u{628}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{634}\u{645}\u{627} \u{627}\u{62E}\u{62A}\u{635}\u{627}\u{635} \u{62F}\u{627}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Itinalaga sa Iyong Organisasyon`,
    fr: `Affect\xe9 \xe0 votre organisation`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{94B} \u{905}\u{938}\u{93E}\u{907}\u{928} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Asiyen nan \xf2ganizasyon ou an`,
    it: `Assegnato alla tua organizzazione`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{7D44}\u{7E54}\u{306B}\u{914D}\u{5C5E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}`,
    ko: `\u{ADC0}\u{D558}\u{C758} \u{C870}\u{C9C1}\u{C5D0} \u{BC30}\u{C815}\u{B428}`,
    mww: `Raug xa mus rau koj lub koom haum`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62A}\u{647} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{6CC}\u{645}`,
    pt: `Designado para sua organiza\xe7\xe3o`,
    'pt-pt': `Atribu\xeddo \xe0 sua organiza\xe7\xe3o`,
    ru: `\u{41D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D} \u{432} \u{432}\u{430}\u{448}\u{443} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44E}`,
    sm: `Tofia i lau faalapotopotoga`,
    so: `Waxaa loo xilsaaray ururkaaga`,
    th: `\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E01}\u{E31}\u{E1A}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{645}\u{6CC}\u{6BA} \u{62A}\u{639}\u{6CC}\u{646}\u{627}\u{62A}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c ch\u{1EC9} \u{111}\u{1ECB}nh cho t\u{1ED5} ch\u{1EE9}c c\u{1EE7}a b\u{1EA1}n`,
    'zh-hans': `\u{5206}\u{914D}\u{5230}\u{4F60}\u{7684}\u{7EC4}\u{7EC7}`,
    'zh-hant': `\u{5206}\u{914D}\u{5230}\u{4F60}\u{7684}\u{7D44}\u{7E54}`,
    en: `Assigned to your organization`
};
const $b11db1b62d4a8f76$export$79dba243bd6a1f7c = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{632}\u{639}`,
    de: `Beauftragter`,
    es: `Asignado`,
    fa: `\u{645}\u{623}\u{645}\u{648}\u{631}`,
    fil: `Tagapag-atas`,
    fr: `Assign\xe9`,
    hi: `\u{905}\u{938}\u{93E}\u{907}\u{928}\u{940}`,
    ht: `Asiyen`,
    it: `Assegnato`,
    ja: `\u{914D}\u{5C5E}\u{5148}`,
    ko: `\u{D30C}\u{ACAC}\u{C790}`,
    mww: `Tus neeg ua hauj lwm`,
    ps: `\u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC}`,
    pt: `Cession\xe1rio`,
    'pt-pt': `Cedente`,
    ru: `\u{41F}\u{440}\u{430}\u{432}\u{43E}\u{43E}\u{431}\u{43B}\u{430}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44C}`,
    sm: `Tofia`,
    so: `Qofka la siiyay`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}`,
    ur: `\u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{634}\u{62F}\u{6C1}`,
    vi: `Ng\u{1B0}\u{1EDD}i \u{111}\u{1B0}\u{1EE3}c chuy\u{1EC3}n nh\u{1B0}\u{1EE3}ng`,
    'zh-hans': `\u{53D7}\u{6D3E}\u{4EBA}`,
    'zh-hant': `\u{53D7}\u{6D3E}\u{4EBA}`,
    en: `Assignee`
};
const $b11db1b62d4a8f76$export$82c671dcad5e7ee8 = {
    ar: `\u{627}\u{644}\u{62A}\u{639}\u{64A}\u{64A}\u{646} \u{644}\u{64A}`,
    de: `Geben Sie mir die Rechte zu.`,
    es: `Asigna a m\xed`,
    fa: `\u{628}\u{647} \u{645}\u{646} \u{627}\u{62E}\u{62A}\u{635}\u{627}\u{635} \u{628}\u{62F}\u{647}`,
    fil: `Atasan mo ako`,
    fr: `Assigne-moi`,
    hi: `\u{92E}\u{941}\u{91D}\u{947} \u{905}\u{938}\u{93E}\u{907}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Asiyen m '`,
    it: `Assegnami`,
    ja: `\u{79C1}\u{306B}\u{5272}\u{308A}\u{5F53}\u{3066}\u{3066}\u{304F}\u{308C}`,
    ko: `\u{B098}\u{D55C}\u{D14C} \u{B9E1}\u{ACA8}`,
    mww: `muab rau kuv`,
    ps: `\u{645}\u{627} \u{62A}\u{647} \u{648}\u{67C}\u{627}\u{6A9}\u{626}`,
    pt: `Me atribui`,
    'pt-pt': `Atribui-me`,
    ru: `\u{41D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{44C}\u{442}\u{435} \u{43C}\u{43D}\u{435}`,
    sm: `Tofi mai ia te a'u`,
    so: `I sii`,
    th: `\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E09}\u{E31}\u{E19}`,
    ur: `\u{645}\u{62C}\u{6BE}\u{6D2} \u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EC9} \u{111}\u{1ECB}nh cho t\xf4i`,
    'zh-hans': `\u{5206}\u{914D}\u{7ED9}\u{6211}`,
    'zh-hant': `\u{5206}\u{914D}\u{7D66}\u{6211}`,
    en: `Assign to me`
};
const $b11db1b62d4a8f76$export$b4a6f32dd234411c = {
    ar: (activityTitle, personName)=>`\u{642}\u{636}\u{64A}\u{629} \u{645}\u{631}\u{62A}\u{628}\u{637}\u{629} ${activityTitle} \u{645}\u{639} ${personName}\u{61F}`,
    de: (activityTitle, personName)=>`${activityTitle} mit Smith assoziieren${personName}?`,
    es: (activityTitle, personName)=>`\xbf ${activityTitle} con ${personName}?`,
    fa: (activityTitle, personName)=>`${activityTitle} \u{628}\u{627} ${personName}\u{61F}`,
    fil: (activityTitle, personName)=>`Iugnay ${activityTitle} kay ${personName}?`,
    fr: (activityTitle, personName)=>`Associer ${activityTitle} \xe0 ${personName} ?`,
    hi: (activityTitle, personName)=>`\u{938}\u{94D}\u{92E}\u{93F}\u{925}${personName} \u{915}\u{947} \u{938}\u{93E}\u{925} ${activityTitle} \u{915}\u{94B} \u{90F}\u{938}\u{94B}\u{938}\u{93F}\u{90F}\u{91F} \u{915}\u{930}\u{947}\u{902}?`,
    ht: (activityTitle, personName)=>`Asosye ${activityTitle} ak ${personName}?`,
    it: (activityTitle, personName)=>`Associare ${activityTitle} a ${personName}?`,
    ja: (activityTitle, personName)=>`${activityTitle}\u{3092}\u{30B9}\u{30DF}\u{30B9}\u{3068}\u{95A2}\u{9023}\u{4ED8}\u{3051}\u{308B}\u{306E}\u{304B}${personName}?`,
    ko: (activityTitle, personName)=>`${activityTitle}\u{C744} \u{C2A4}\u{BBF8}\u{C2A4}\u{C640} \u{C5F0}\u{AD00} \u{C9D3}\u{B294} \u{AC70}${personName}?`,
    mww: (activityTitle, personName)=>`Associate ${activityTitle} nrog ${personName}?`,
    ps: (activityTitle, personName)=>`\u{62F} ${activityTitle} \u{62F} \u{633}\u{645}\u{6CC}\u{62A} \u{633}\u{631}\u{647} \u{62A}\u{693}\u{627}\u{648} \u{644}\u{631}\u{6CC} ${personName}\u{61F}`,
    pt: (activityTitle, personName)=>`${activityTitle} com ${personName}?`,
    'pt-pt': (activityTitle, personName)=>`Associar ${activityTitle} ao ${personName}?`,
    ru: (activityTitle, personName)=>`\u{410}\u{441}\u{441}\u{43E}\u{446}\u{438}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{43E}\u{435} ${activityTitle} \u{441}\u{43E} ${personName}?`,
    sm: (activityTitle, personName)=>`Feso'ota'i ${activityTitle} ma ${personName}`,
    so: (activityTitle, personName)=>`${activityTitle} ee la xiriira ${personName}?`,
    th: (activityTitle, personName)=>`\u{E40}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E21}\u{E42}\u{E22}\u{E07} ${activityTitle} \u{E01}\u{E31}\u{E1A} ${personName}?`,
    ur: (activityTitle, personName)=>`\u{627}\u{633}\u{645}\u{62A}\u{6BE} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} ${activityTitle}${personName}\u{61F}`,
    vi: (activityTitle, personName)=>`Li\xean k\u{1EBF}t ${activityTitle} v\u{1EDB}i ${personName}?`,
    'zh-hans': (activityTitle, personName)=>`\u{7EA6}\u{7FF0}\u{FF0C}\u{628A} ${activityTitle} \u{5B50}\u{548C} ${personName}\u{8054}\u{7CFB}\u{8D77}\u{6765}\u{FF1F}`,
    'zh-hant': (activityTitle, personName)=>`\u{628A} ${activityTitle} \u{5B50}\u{548C} ${personName}\u{626F}\u{4E0A}\u{95DC}\u{4FC2}\u{FF0C}\u{7D04}\u{7FF0}\u{FF1F}`,
    en: (activityTitle, personName)=>`Associate ${activityTitle} with ${personName}?`
};
const $b11db1b62d4a8f76$export$4e3cc35166fd163b = {
    ar: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>ربط ${activityTitle} بالشخص</strong>: أنشئ شخصا جديدا`,
    de: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Verknüpfe die ${activityTitle} mit der Person</strong>: Erstelle eine neue Person`,
    es: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} con la persona</strong>: crear una nueva persona`,
    fa: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} را با فرد مرتبط</strong> کنید: یک فرد جدید بسازید`,
    fil: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Iugnay ang ${activityTitle} sa tao</strong>: lumikha ng bagong tao`,
    fr: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} à la personne</strong> : créer une nouvelle personne`,
    hi: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>व्यक्ति के साथ ${activityTitle} को संबद्ध करें</strong>: एक नया व्यक्ति बनाएं`,
    ht: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Asosye ${activityTitle} ak moun</strong>: kreye yon nouvo moun`,
    it: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} con una persona</strong>: crea una nuova persona`,
    ja: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle}を人と結びつける</strong>:新しい人を作る`,
    ko: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle}을 사람과 연관 짓기</strong>: 새로운 사람을 만들기.`,
    mww: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Associate ${activityTitle} nrog tus neeg</strong>: tsim ib tug neeg tshiab`,
    ps: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle}</strong> کول: یو نوی کس جوړول`,
    pt: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} com pessoa</strong>: crie uma nova pessoa`,
    'pt-pt': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} a pessoa</strong>: criar uma nova pessoa`,
    ru: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Ассоциируйте ${activityTitle} с человеком</strong>: создайте нового человека`,
    sm: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Fa'afeso'ota'i le ${activityTitle} ma le tagata</strong>: fatu se tagata fou`,
    so: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>La xiriir ${activityTitle} qof</strong>: abuur qof cusub`,
    th: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>เชื่อมโยง ${activityTitle} กับบุคคล</strong>: สร้างบุคคลใหม่`,
    ur: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} کو شخص کے ساتھ جوڑیں</strong>: ایک نیا شخص بنائیں`,
    vi: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Liên kết ${activityTitle} với người</strong>: tạo một người mới`,
    'zh-hans': (activityTitle)=>$b11db1b62d4a8f76$var$html`将<strong>${activityTitle}与个人联系起来</strong>：创建一个新的人`,
    'zh-hant': (activityTitle)=>$b11db1b62d4a8f76$var$html`將<strong>${activityTitle}與人連結</strong>：創造一個新的人`,
    en: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Associate ${activityTitle} with person</strong>: create a new person`
};
const $b11db1b62d4a8f76$export$591db6c0f1c5c1db = {
    ar: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>ربط ${activityTitle} مع الشخص</strong>: ابحث عن شخص`,
    de: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} mit der Person</strong>: Suche nach einer Person`,
    es: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} con la persona</strong>: buscar a una persona`,
    fa: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} را با شخص مرتبط</strong> کنید: به دنبال فرد بگردید`,
    fil: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Iugnay ang ${activityTitle} sa tao</strong>: maghanap ng isang tao`,
    fr: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} associée avec personne</strong> : recherche une personne`,
    hi: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>व्यक्ति के साथ ${activityTitle} को संबद्ध करें</strong>: किसी व्यक्ति की खोज करें`,
    ht: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Asosye ${activityTitle} ak moun</strong>: rechèch pou yon moun`,
    it: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} associata con persona</strong>: cerca una persona`,
    ja: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle}を人と関連付け</strong>る:人を検索する`,
    ko: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} 사람과 연관 짓</strong>기: 사람을 검색하세요`,
    mww: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Associate ${activityTitle} with person</strong>: nrhiav ib tug neeg`,
    ps: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle}</strong> کول: د یو کس لټون`,
    pt: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} associada com pessoa</strong>: procure por uma pessoa`,
    'pt-pt': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} associada com pessoa</strong>: procure uma pessoa`,
    ru: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Сотрудничество ${activityTitle} с человеком</strong>: поиск человека`,
    sm: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Fa'afeso'ota'i le ${activityTitle} ma le tagata</strong>: saili se tagata`,
    so: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Xiriir ${activityTitle} tixraac qof</strong>: raadi qof`,
    th: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>เชื่อมโยง ${activityTitle} กับบุคคล</strong>: ค้นหาบุคคล`,
    ur: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} کو شخص کے ساتھ منسلک</strong> کریں: کسی شخص کی تلاش کریں`,
    vi: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Liên kết ${activityTitle} với người</strong>: tìm kiếm một người`,
    'zh-hans': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>将 ${activityTitle} 与人联系起来</strong>：搜索一个人`,
    'zh-hant': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>將 ${activityTitle} 與人聯繫</strong>起來：搜尋一個人`,
    en: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Associate ${activityTitle} with person</strong>: search for a person`
};
const $b11db1b62d4a8f76$export$f2355c16748ba251 = {
    ar: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>ربط ${activityTitle} مع الشخص</strong>: اختر النشاط الذي سيرتبط به ${activityTitle} الجديدة`,
    de: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Überweisung mit Person ${activityTitle} verknüpfen</strong>: Wähle die Aktivität aus, mit der die neue ${activityTitle} verknüpft werden soll`,
    es: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} asociada con persona</strong>: selecciona la actividad con la que se asociará la nueva ${activityTitle}`,
    fa: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} را با شخص مرتبط</strong> کنید: فعالیتی را که ${activityTitle} جدید با آن مرتبط خواهد بود انتخاب کنید`,
    fil: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Iugnay ang ${activityTitle} sa tao</strong>: piliin ang aktibidad na maiuugnay sa bagong ${activityTitle}`,
    fr: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} associée avec la personne</strong> : sélectionnez l’activité à laquelle la nouvelle ${activityTitle} sera associée`,
    hi: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>व्यक्ति के साथ ${activityTitle} को संबद्ध करें</strong>: उस गतिविधि का चयन करें जिसके साथ नया ${activityTitle} जुड़ा होगा`,
    ht: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Asosye ${activityTitle} ak moun</strong>: chwazi aktivite nouvo ${activityTitle} lan pral asosye avèk`,
    it: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} associata con persona</strong>: seleziona l'attività a cui sarà associata la nuova ${activityTitle}`,
    ja: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>紹介を対象者${activityTitle}と関連付け</strong>る:新しい${activityTitle}が関連付けられる活動を選択します`,
    ko: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>추천을 사람과 ${activityTitle} 연관</strong>시키기: 새 ${activityTitle}이 연관될 활동을 선택하세요`,
    mww: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Koom nrog kev ${activityTitle} nrog tus neeg</strong>: xaiv qhov haujlwm uas kev ${activityTitle} tshiab yuav cuam tshuam nrog`,
    ps: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>د ${activityTitle}</strong> ورکول: هغه فعالیت وټاکئ چې نوی ${activityTitle} کول به ورسره تړاو ولری`,
    pt: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} associada com pessoa</strong>: selecione a atividade à qual a nova ${activityTitle} será associada`,
    'pt-pt': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} associada com pessoa</strong>: selecione a atividade à qual a nova ${activityTitle} estará associada`,
    ru: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Сотрудничество ${activityTitle} направления с человеком</strong>: выберите деятельность, с которой будет связана новая ${activityTitle}`,
    sm: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Fa'afeso'ota'i le ${activityTitle} ma le tagata</strong>: filifili le gaioiga o le a feso'ota'i ma le fa'asino fou ${activityTitle}`,
    so: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Xiriir ${activityTitle} iyo qof</strong>: dooro hawsha uu ${activityTitle} cusub la xiriiri doono`,
    th: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>เชื่อมโยง ${activityTitle} กับบุคคล</strong>: เลือกกิจกรรมที่จะเชื่อมโยงกับ ${activityTitle} ใหม่`,
    ur: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} کو شخص کے ساتھ منسلک</strong> کریں: وہ سرگرمی منتخب کریں جس سے نیا ${activityTitle} منسلک ہوگا`,
    vi: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Liên kết ${activityTitle} với người</strong>: chọn hoạt động mà ${activityTitle} mới sẽ được liên kết`,
    'zh-hans': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>将 ${activityTitle} 与个人关联</strong>：选择新 ${activityTitle} 将关联的活动`,
    'zh-hant': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>將 ${activityTitle} 與個人關聯</strong>：選擇新 ${activityTitle} 將關聯的活動`,
    en: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Associate ${activityTitle} with person</strong>: select the activity the new ${activityTitle} will be associated with`
};
const $b11db1b62d4a8f76$export$cba9aac5ce5c5768 = {
    ar: `\u{645}\u{631}\u{62A}\u{628}\u{637}\u{648}\u{646}`,
    de: `Assoziierte`,
    es: `Asociados`,
    fa: `\u{648}\u{627}\u{628}\u{633}\u{62A}\u{647}`,
    fil: `Nauugnay`,
    fr: `Associ\xe9s`,
    hi: `\u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927}`,
    ht: `Asosye`,
    it: `Associati`,
    ja: `\u{95A2}\u{9023}`,
    ko: `\u{AD00}\u{B828}`,
    mww: `Txuam`,
    ps: `\u{627}\u{633}\u{648}\u{634}\u{6CC}\u{67C}\u{689}`,
    pt: `Associados`,
    'pt-pt': `Associados`,
    ru: `\u{421}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{435}`,
    sm: `Feso'ota'iga`,
    so: `La xiriira`,
    th: `\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{648}\u{627}\u{628}\u{633}\u{62A}\u{6C1}`,
    vi: `Li\xean k\u{1EBF}t`,
    'zh-hans': `\u{76F8}\u{5173}`,
    'zh-hant': `\u{76F8}\u{95DC}`,
    en: `Associated`
};
const $b11db1b62d4a8f76$export$6afe45ba2034df4e = {
    ar: `\u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{631}\u{62A}\u{628}\u{637}\u{629}`,
    de: `Verwandte Aktivit\xe4ten`,
    es: `Actividades asociadas`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{645}\u{631}\u{62A}\u{628}\u{637}`,
    fil: `Mga kaugnay na aktibidad`,
    fr: `Activit\xe9s associ\xe9es`,
    hi: `\u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `Aktivite ki asosye yo`,
    it: `Attivit\xe0 associate`,
    ja: `\u{95A2}\u{9023}\u{6D3B}\u{52D5}`,
    ko: `\u{AD00}\u{B828} \u{D65C}\u{B3D9}`,
    mww: `Cov kev ua ub no cuam tshuam`,
    ps: `\u{627}\u{693}\u{648}\u{646}\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Atividades associadas`,
    'pt-pt': `Atividades associadas`,
    ru: `\u{421}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{432}\u{438}\u{434}\u{44B} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Gaoioiga fesootai`,
    so: `Hawlaha la xiriira`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}`,
    vi: `C\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng li\xean quan`,
    'zh-hans': `\u{76F8}\u{5173}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{76F8}\u{95DC}\u{6D3B}\u{52D5}`,
    en: `Associated activities`
};
const $b11db1b62d4a8f76$export$65e55a627c6c5408 = {
    ar: `\u{623}\u{62F}\u{62E}\u{644} \u{631}\u{642}\u{645} \u{647}\u{627}\u{62A}\u{641}\u{643} \u{623}\u{62F}\u{646}\u{627}\u{647}. \u{633}\u{64A}\u{62A}\u{645} \u{625}\u{631}\u{633}\u{627}\u{644} \u{631}\u{633}\u{627}\u{644}\u{629} \u{646}\u{635}\u{64A}\u{629} \u{625}\u{644}\u{649} \u{630}\u{644}\u{643} \u{627}\u{644}\u{631}\u{642}\u{645} \u{645}\u{639} \u{631}\u{645}\u{632} \u{644}\u{625}\u{62F}\u{62E}\u{627}\u{644}\u{647} \u{641}\u{64A} \u{627}\u{644}\u{634}\u{627}\u{634}\u{629} \u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}\u{629}.`,
    de: `Geben Sie unten Ihre Telefonnummer ein. Eine SMS wird an diese Nummer gesendet, mit einem Code, den man auf dem n\xe4chsten Bildschirm eingeben kann.`,
    es: `Introduce tu n\xfamero de tel\xe9fono a continuaci\xf3n. Se enviar\xe1 un SMS a ese n\xfamero con un c\xf3digo para introducir en la siguiente pantalla.`,
    fa: `\u{634}\u{645}\u{627}\u{631}\u{647} \u{62A}\u{644}\u{641}\u{646} \u{62E}\u{648}\u{62F} \u{631}\u{627} \u{62F}\u{631} \u{632}\u{6CC}\u{631} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}. \u{6CC}\u{6A9} \u{67E}\u{6CC}\u{627}\u{645}\u{6A9} \u{628}\u{647} \u{622}\u{646} \u{634}\u{645}\u{627}\u{631}\u{647} \u{627}\u{631}\u{633}\u{627}\u{644} \u{645}\u{6CC} \u{634}\u{648}\u{62F} \u{6A9}\u{647} \u{6A9}\u{62F}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{631}\u{62F}\u{646} \u{62F}\u{631} \u{635}\u{641}\u{62D}\u{647} \u{628}\u{639}\u{62F}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `Ipasok ang iyong numero ng telepono sa ibaba. Isang SMS ang ipapadala sa numerong iyon na may code na ipasok sa susunod na screen.`,
    fr: `Saisissez votre num\xe9ro de t\xe9l\xe9phone ci-dessous. Un SMS sera envoy\xe9 \xe0 ce num\xe9ro avec un code \xe0 saisir \xe0 l\u{2019}\xe9cran suivant.`,
    hi: `\u{928}\u{940}\u{91A}\u{947} \u{905}\u{92A}\u{928}\u{93E} \u{92B}\u{93C}\u{94B}\u{928} \u{928}\u{902}\u{92C}\u{930} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902}\u{964} \u{905}\u{917}\u{932}\u{940} \u{938}\u{94D}\u{915}\u{94D}\u{930}\u{940}\u{928} \u{92A}\u{930} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{90F}\u{915} \u{915}\u{94B}\u{921} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{909}\u{938} \u{928}\u{902}\u{92C}\u{930} \u{92A}\u{930} \u{90F}\u{915} \u{90F}\u{938}\u{90F}\u{92E}\u{90F}\u{938} \u{92D}\u{947}\u{91C}\u{93E} \u{91C}\u{93E}\u{90F}\u{917}\u{93E}\u{964}`,
    ht: `Antre nimewo telef\xf2n ou anba a. Yon SMS yo pral voye nan nimewo sa a ak yon k\xf2d antre nan ekran kap vini an.`,
    it: `Inserisci il tuo numero di telefono qui sotto. Un SMS verr\xe0 inviato a quel numero con un codice da inserire nella schermata successiva.`,
    ja: `\u{4EE5}\u{4E0B}\u{306B}\u{96FB}\u{8A71}\u{756A}\u{53F7}\u{3092}\u{5165}\u{529B}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}\u{6B21}\u{306E}\u{753B}\u{9762}\u{3067}\u{5165}\u{529B}\u{3059}\u{308B}\u{30B3}\u{30FC}\u{30C9}\u{4ED8}\u{304D}\u{306E}SMS\u{304C}\u{305D}\u{306E}\u{756A}\u{53F7}\u{306B}\u{9001}\u{3089}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C544}\u{B798}\u{C5D0} \u{C804}\u{D654}\u{BC88}\u{D638}\u{B97C} \u{C785}\u{B825}\u{D558}\u{C138}\u{C694}. \u{B2E4}\u{C74C} \u{D654}\u{BA74}\u{C5D0} \u{C785}\u{B825}\u{D560} \u{CF54}\u{B4DC}\u{AC00} \u{D3EC}\u{D568}\u{B41C} SMS\u{AC00} \u{D574}\u{B2F9} \u{BC88}\u{D638}\u{B85C} \u{C804}\u{C1A1}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Sau koj tus xov tooj hauv qab no. Ib qho SMS yuav raug xa mus rau tus xov tooj ntawd nrog tus lej nkag mus rau ntawm lub vijtsam tom ntej.`,
    ps: `\u{644}\u{627}\u{646}\u{62F}\u{6D0} \u{62E}\u{67E}\u{644} \u{62F} \u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646} \u{634}\u{645}\u{6D0}\u{631}\u{647} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626}. \u{6CC}\u{648} SMS \u{628}\u{647} \u{647}\u{63A}\u{647} \u{634}\u{645}\u{6D0}\u{631}\u{647} \u{62A}\u{647} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{644} \u{634}\u{6CC} \u{686}\u{6D0} \u{67E}\u{647} \u{628}\u{644} \u{633}\u{6A9}\u{631}\u{6CC}\u{646} \u{6A9}\u{6D0} \u{6A9}\u{648}\u{689} \u{67E}\u{6A9}\u{6D0} \u{634}\u{627}\u{645}\u{644} \u{634}\u{6CC}.`,
    pt: `Insira seu n\xfamero de telefone abaixo. Um SMS ser\xe1 enviado para esse n\xfamero com um c\xf3digo para inserir na pr\xf3xima tela.`,
    'pt-pt': `Insira o seu n\xfamero de telefone abaixo. Ser\xe1 enviado um SMS para esse n\xfamero com um c\xf3digo para introduzir no ecr\xe3 seguinte.`,
    ru: `\u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{439} \u{43D}\u{43E}\u{43C}\u{435}\u{440} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{430} \u{43D}\u{438}\u{436}\u{435}. \u{41D}\u{430} \u{44D}\u{442}\u{43E}\u{442} \u{43D}\u{43E}\u{43C}\u{435}\u{440} \u{431}\u{443}\u{434}\u{435}\u{442} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{43E} SMS \u{441} \u{43A}\u{43E}\u{434}\u{43E}\u{43C} \u{434}\u{43B}\u{44F} \u{432}\u{432}\u{43E}\u{434}\u{430} \u{43D}\u{430} \u{441}\u{43B}\u{435}\u{434}\u{443}\u{44E}\u{449}\u{435}\u{43C} \u{44D}\u{43A}\u{440}\u{430}\u{43D}\u{435}.`,
    sm: `Ulu atu i lau numera telefoni o loo i lalo. O le a lafoina se SMS i lena numera ma se code e ulufale ai i le isi lau.`,
    so: `Geli lambarkaaga telefoonka hoos. SMS ayaa loo diri doonaa lambarkaas iyadoo la heli karo koodh lagu galo shaashadda xigta.`,
    th: `\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E40}\u{E25}\u{E02}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E14}\u{E49}\u{E32}\u{E19}\u{E25}\u{E48}\u{E32}\u{E07} SMS \u{E08}\u{E30}\u{E16}\u{E39}\u{E01}\u{E2A}\u{E48}\u{E07}\u{E44}\u{E1B}\u{E22}\u{E31}\u{E07}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E40}\u{E25}\u{E02}\u{E19}\u{E31}\u{E49}\u{E19}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E43}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E08}\u{E2D}\u{E16}\u{E31}\u{E14}\u{E44}\u{E1B}`,
    ur: `\u{646}\u{6CC}\u{686}\u{6D2} \u{627}\u{67E}\u{646}\u{627} \u{641}\u{648}\u{646} \u{646}\u{645}\u{628}\u{631} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4} \u{627}\u{633} \u{646}\u{645}\u{628}\u{631} \u{67E}\u{631} \u{627}\u{6CC}\u{6A9} \u{627}\u{6CC}\u{633} \u{627}\u{6CC}\u{645} \u{627}\u{6CC}\u{633} \u{628}\u{6BE}\u{6CC}\u{62C}\u{627} \u{62C}\u{627}\u{626}\u{6D2} \u{6AF}\u{627} \u{62C}\u{633} \u{645}\u{6CC}\u{6BA} \u{627}\u{6AF}\u{644}\u{6CC} \u{627}\u{633}\u{6A9}\u{631}\u{6CC}\u{646} \u{67E}\u{631} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{6A9}\u{648}\u{688} \u{6C1}\u{648}\u{6AF}\u{627}\u{6D4}`,
    vi: `Nh\u{1EAD}p s\u{1ED1} \u{111}i\u{1EC7}n tho\u{1EA1}i c\u{1EE7}a b\u{1EA1}n b\xean d\u{1B0}\u{1EDB}i. M\u{1ED9}t tin nh\u{1EAF}n SMS s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c g\u{1EED}i \u{111}\u{1EBF}n s\u{1ED1} \u{111}\xf3 v\u{1EDB}i m\u{1ED9}t m\xe3 \u{111}\u{1EC3} nh\u{1EAD}p v\xe0o m\xe0n h\xecnh ti\u{1EBF}p theo.`,
    'zh-hans': `\u{8BF7}\u{5728}\u{4E0B}\u{65B9}\u{8F93}\u{5165}\u{60A8}\u{7684}\u{7535}\u{8BDD}\u{53F7}\u{7801}\u{3002}\u{4F1A}\u{5411}\u{8BE5}\u{53F7}\u{7801}\u{53D1}\u{9001}\u{77ED}\u{4FE1}\u{FF0C}\u{5E76}\u{9644}\u{6709}\u{4EE3}\u{7801}\u{FF0C}\u{9700}\u{5728}\u{4E0B}\u{4E00}\u{9875}\u{8F93}\u{5165}\u{3002}`,
    'zh-hant': `\u{8ACB}\u{5728}\u{4E0B}\u{65B9}\u{8F38}\u{5165}\u{60A8}\u{7684}\u{96FB}\u{8A71}\u{865F}\u{78BC}\u{3002}\u{8A72}\u{865F}\u{78BC}\u{6703}\u{767C}\u{9001}\u{7C21}\u{8A0A}\u{FF0C}\u{4E26}\u{9644}\u{6709}\u{4EE3}\u{78BC}\u{FF0C}\u{9700}\u{5728}\u{4E0B}\u{4E00}\u{500B}\u{756B}\u{9762}\u{8F38}\u{5165}\u{3002}`,
    en: `Enter your phone number below. An SMS will be sent to that number with a code to enter on the next screen.`
};
const $b11db1b62d4a8f76$export$c387a5524a2ac6b3 = {
    ar: `\u{642}\u{645} \u{628}\u{645}\u{633}\u{62D} \u{631}\u{645}\u{632} QR \u{623}\u{639}\u{644}\u{627}\u{647} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{62A}\u{637}\u{628}\u{64A}\u{642} \u{627}\u{644}\u{645}\u{635}\u{627}\u{62F}\u{642}\u{629} \u{627}\u{644}\u{645}\u{641}\u{636}\u{644} \u{644}\u{62F}\u{64A}\u{643} \u{62B}\u{645} \u{623}\u{62F}\u{62E}\u{644} \u{627}\u{644}\u{631}\u{645}\u{632} \u{627}\u{644}\u{645}\u{62E}\u{635}\u{635} \u{644}\u{645}\u{631}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629} \u{623}\u{62F}\u{646}\u{627}\u{647}.`,
    de: `Scannen Sie den oben genannten QR-Code mit Ihrer bevorzugten Authenticator-App und geben Sie dann den unten angegebenen Einmalcode ein.`,
    es: `Escanea el c\xf3digo QR de arriba usando tu aplicaci\xf3n de autenticaci\xf3n favorita y luego introduce el c\xf3digo de un solo uso proporcionado a continuaci\xf3n.`,
    fa: `\u{6A9}\u{62F} QR \u{628}\u{627}\u{644}\u{627} \u{631}\u{627} \u{628}\u{627} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{627}\u{62D}\u{631}\u{627}\u{632} \u{647}\u{648}\u{6CC}\u{62A} \u{645}\u{648}\u{631}\u{62F} \u{639}\u{644}\u{627}\u{642}\u{647} \u{62A}\u{627}\u{646} \u{627}\u{633}\u{6A9}\u{646} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{633}\u{67E}\u{633} \u{6A9}\u{62F} \u{6CC}\u{6A9} \u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641} \u{627}\u{631}\u{627}\u{626}\u{647} \u{634}\u{62F}\u{647} \u{631}\u{627} \u{62F}\u{631} \u{632}\u{6CC}\u{631} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `I-scan ang QR Code sa itaas gamit ang iyong ginustong authenticator app at pagkatapos ay ipasok ang ibinigay na one-time code sa ibaba.`,
    fr: `Scannez le QR Code ci-dessus \xe0 l\u{2019}aide de votre application d\u{2019}authentification pr\xe9f\xe9r\xe9e, puis entrez le code \xe0 usage unique fourni ci-dessous.`,
    hi: `\u{905}\u{92A}\u{928}\u{947} \u{92A}\u{938}\u{902}\u{926}\u{940}\u{926}\u{93E} \u{92A}\u{94D}\u{930}\u{92E}\u{93E}\u{923}\u{915} \u{910}\u{92A} \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{915}\u{947} \u{90A}\u{92A}\u{930} \u{926}\u{93F}\u{90F} \u{917}\u{90F} \u{915}\u{94D}\u{92F}\u{942}\u{906}\u{930} \u{915}\u{94B}\u{921} \u{915}\u{94B} \u{938}\u{94D}\u{915}\u{948}\u{928} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{92B}\u{93F}\u{930} \u{928}\u{940}\u{91A}\u{947} \u{926}\u{93F}\u{90F} \u{917}\u{90F} \u{935}\u{928}-\u{91F}\u{93E}\u{907}\u{92E} \u{915}\u{94B}\u{921} \u{915}\u{94B} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Eskane K\xf2d QR ki anwo a l\xe8 l s\xe8vi av\xe8k app otantifikat\xe8 ou pi pito ak L\xe8 sa a, antre nan k\xf2d la bay yon s\xe8l-fwa anba a.`,
    it: `Scansiona il codice QR sopra usando la tua app di autenticazione preferita e poi inserisci il codice monouso fornito qui sotto.`,
    ja: `\u{304A}\u{597D}\u{307F}\u{306E}\u{8A8D}\u{8A3C}\u{30A2}\u{30D7}\u{30EA}\u{3067}\u{4E0A}\u{8A18}\u{306E}QR\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{30B9}\u{30AD}\u{30E3}\u{30F3}\u{3057}\u{3001}\u{4E0B}\u{8A18}\u{306E}\u{30EF}\u{30F3}\u{30BF}\u{30A4}\u{30E0}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{5165}\u{529B}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C704}\u{C758} QR \u{CF54}\u{B4DC}\u{B97C} \u{C120}\u{D638}\u{D558}\u{B294} \u{C778}\u{C99D} \u{C571}\u{C73C}\u{B85C} \u{C2A4}\u{CE94}\u{D55C} \u{D6C4}, \u{C544}\u{B798}\u{C5D0} \u{C81C}\u{ACF5}\u{B41C} \u{C77C}\u{D68C}\u{C6A9} \u{CF54}\u{B4DC}\u{B97C} \u{C785}\u{B825}\u{D558}\u{C138}\u{C694}.`,
    mww: `Luam theej duab QR Code saum toj no siv koj nyiam authenticator app thiab tom qab ntawd nkag mus rau tus lej ib zaug hauv qab no.`,
    ps: `\u{67E}\u{648}\u{631}\u{62A}\u{647} QR \u{6A9}\u{648}\u{689} \u{62F} \u{62E}\u{67E}\u{644} \u{62E}\u{648}\u{69A} \u{634}\u{648}\u{6CC} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{67E}\u{647} \u{6A9}\u{627}\u{631}\u{648}\u{644}\u{648} \u{633}\u{631}\u{647} \u{633}\u{6A9}\u{6CC}\u{646} \u{6A9}\u{693}\u{626} \u{627}\u{648} \u{628}\u{6CC}\u{627} \u{644}\u{627}\u{646}\u{62F}\u{6D0} \u{648}\u{631}\u{6A9}\u{693}\u{644} \u{634}\u{648}\u{6CC} \u{6CC}\u{648} \u{681}\u{644} \u{6A9}\u{648}\u{689} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626}.`,
    pt: `Escaneie o QR Code acima usando seu aplicativo de autentica\xe7\xe3o preferido e ent\xe3o insira o c\xf3digo \xfanico fornecido abaixo.`,
    'pt-pt': `Digitalize o C\xf3digo QR acima usando a sua aplica\xe7\xe3o de autentica\xe7\xe3o preferida e depois introduza o c\xf3digo \xfanico fornecido abaixo.`,
    ru: `\u{41E}\u{442}\u{441}\u{43A}\u{430}\u{43D}\u{438}\u{440}\u{443}\u{439}\u{442}\u{435} QR-\u{43A}\u{43E}\u{434} \u{432}\u{44B}\u{448}\u{435} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{43F}\u{440}\u{435}\u{434}\u{43F}\u{43E}\u{447}\u{438}\u{442}\u{430}\u{435}\u{43C}\u{43E}\u{433}\u{43E} \u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{430}\u{443}\u{442}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{438}, \u{430} \u{437}\u{430}\u{442}\u{435}\u{43C} \u{432}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{43E}\u{434}\u{43D}\u{43E}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{44B}\u{439} \u{43A}\u{43E}\u{434} \u{43D}\u{438}\u{436}\u{435}.`,
    sm: `Fa'ata'ita'i le QR Code i luga e fa'aaoga ai lau authenticator app e te fiafia i ai ona ulufale lea i le code e tasi le taimi o lo'o i lalo.`,
    so: `Iska baar QR Code-ka kor ku xusan adigoo isticmaalaya app-ka authenticator-ka aad doorbideyso, kadibna geli koodhka hal mar ee la bixiyay hoos.`,
    th: `\u{E2A}\u{E41}\u{E01}\u{E19} QR Code \u{E14}\u{E49}\u{E32}\u{E19}\u{E1A}\u{E19}\u{E42}\u{E14}\u{E22}\u{E43}\u{E0A}\u{E49}\u{E41}\u{E2D}\u{E1B}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E15}\u{E31}\u{E27}\u{E15}\u{E19}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23} \u{E08}\u{E32}\u{E01}\u{E19}\u{E31}\u{E49}\u{E19}\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E17}\u{E35}\u{E48}\u{E43}\u{E2B}\u{E49}\u{E44}\u{E27}\u{E49}\u{E14}\u{E49}\u{E32}\u{E19}\u{E25}\u{E48}\u{E32}\u{E07}`,
    ur: `\u{627}\u{648}\u{67E}\u{631} \u{62F}\u{6CC}\u{6D2} \u{6AF}\u{626}\u{6D2} QR \u{6A9}\u{648}\u{688} \u{6A9}\u{648} \u{627}\u{67E}\u{646}\u{6CC} \u{67E}\u{633}\u{646}\u{62F}\u{6CC}\u{62F}\u{6C1} \u{622}\u{62A}\u{6BE}\u{646}\u{679}\u{6CC} \u{6A9}\u{6CC}\u{679}\u{631} \u{627}\u{6CC}\u{67E} \u{633}\u{6D2} \u{627}\u{633}\u{6A9}\u{6CC}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{67E}\u{6BE}\u{631} \u{646}\u{6CC}\u{686}\u{6D2} \u{62F}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{648}\u{646} \u{679}\u{627}\u{626}\u{645} \u{6A9}\u{648}\u{688} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Qu\xe9t M\xe3 QR \u{1EDF} tr\xean b\u{1EB1}ng \u{1EE9}ng d\u{1EE5}ng x\xe1c th\u{1EF1}c \u{1B0}a th\xedch c\u{1EE7}a b\u{1EA1}n v\xe0 sau \u{111}\xf3 nh\u{1EAD}p m\xe3 d\xf9ng m\u{1ED9}t l\u{1EA7}n \u{111}\u{1B0}\u{1EE3}c cung c\u{1EA5}p b\xean d\u{1B0}\u{1EDB}i.`,
    'zh-hans': `\u{4F7F}\u{7528}\u{60A8}\u{504F}\u{597D}\u{7684}\u{8EAB}\u{4EFD}\u{9A8C}\u{8BC1}\u{5E94}\u{7528}\u{626B}\u{63CF}\u{4E0A}\u{65B9}\u{4E8C}\u{7EF4}\u{7801}\u{FF0C}\u{7136}\u{540E}\u{8F93}\u{5165}\u{4E0B}\u{65B9}\u{63D0}\u{4F9B}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{9A8C}\u{8BC1}\u{7801}\u{3002}`,
    'zh-hant': `\u{4F7F}\u{7528}\u{60A8}\u{504F}\u{597D}\u{7684}\u{9A57}\u{8B49}\u{61C9}\u{7528}\u{7A0B}\u{5F0F}\u{6383}\u{63CF}\u{4E0A}\u{65B9}\u{7684} QR \u{78BC}\u{FF0C}\u{7136}\u{5F8C}\u{8F38}\u{5165}\u{4E0B}\u{65B9}\u{63D0}\u{4F9B}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{9A57}\u{8B49}\u{78BC}\u{3002}`,
    en: `Scan the QR Code above using your preferred authenticator app and then enter the provided one-time code below.`
};
const $b11db1b62d4a8f76$export$20459fc508a64fd2 = {
    ar: `\u{627}\u{644}\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645} \u{627}\u{644}\u{645}\u{633}\u{627}\u{639}\u{62F}`,
    de: `Assoziierter Nutzer`,
    es: `Usuario asociado`,
    fa: `\u{6A9}\u{627}\u{631}\u{628}\u{631} \u{647}\u{645}\u{6A9}\u{627}\u{631}`,
    fil: `Email Address *`,
    fr: `Utilisateur associ\xe9`,
    hi: `\u{938}\u{939}\u{92F}\u{94B}\u{917}\u{940} \u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E}`,
    ht: `Asosye itilizat\xe8`,
    it: `Utente associato`,
    ja: `\u{30A2}\u{30BD}\u{30B7}\u{30A8}\u{30A4}\u{30C8}\u{30E6}\u{30FC}\u{30B6}\u{30FC}`,
    ko: `\u{C5B4}\u{C18C}\u{C2DC}\u{C5D0}\u{C774}\u{D2B8} \u{C0AC}\u{C6A9}\u{C790}`,
    mww: `Associate neeg siv`,
    ps: `\u{647}\u{645}\u{6A9}\u{627}\u{631} \u{6A9}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Usu\xe1rio associado`,
    'pt-pt': `Utilizador associado`,
    ru: `\u{410}\u{441}\u{441}\u{43E}\u{446}\u{438}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}`,
    sm: `Tagata faaaoga lagolago`,
    so: `Isticmaale la shaqeeya`,
    th: `\u{E40}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E21}\u{E42}\u{E22}\u{E07}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}`,
    ur: `\u{627}\u{6CC}\u{633}\u{648}\u{633}\u{6CC} \u{627}\u{6CC}\u{679} \u{6CC}\u{648}\u{632}\u{631}`,
    vi: `Li\xean k\u{1EBF}t ng\u{1B0}\u{1EDD}i d\xf9ng`,
    'zh-hans': `\u{52A9}\u{7406}\u{7528}\u{6237}`,
    'zh-hant': `\u{526F}\u{7528}\u{6236}`,
    en: `Associate user`
};
const $b11db1b62d4a8f76$export$147e2816670703ab = {
    ar: `\u{623}\u{631}\u{641}\u{642} \u{627}\u{644}\u{645}\u{644}\u{641}\u{627}\u{62A} \u{639}\u{646} \u{637}\u{631}\u{64A}\u{642} \u{627}\u{644}\u{633}\u{62D}\u{628} \u{648}\u{627}\u{644}\u{625}\u{641}\u{644}\u{627}\u{62A}\u{60C} \u{627}\u{644}\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631}\u{60C} \u{623}\u{648} \u{644}\u{635}\u{642}\u{647}\u{627}.`,
    de: `F\xfcgen Sie Dateien an, indem Sie sie ziehen und absetzen, ausw\xe4hlen oder einf\xfcgen.`,
    es: `Adjunta archivos arrastr\xe1ndolos y solt\xe1ndolos, seleccion\xe1ndolos o peg\xe1ndolos.`,
    fa: `\u{641}\u{627}\u{6CC}\u{644} \u{647}\u{627} \u{631}\u{627} \u{628}\u{627} \u{6A9}\u{634}\u{6CC}\u{62F}\u{646} \u{648} \u{631}\u{647}\u{627} \u{6A9}\u{631}\u{62F}\u{646}\u{60C} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6CC}\u{627} \u{67E}\u{6CC}\u{633}\u{62A} \u{6A9}\u{631}\u{62F}\u{646} \u{636}\u{645}\u{6CC}\u{645}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Ilakip ang mga file sa pamamagitan ng pag-drag at pag-drop, pagpili, o pag-paste ng mga ito.`,
    fr: `Attachez les fichiers en les faisant glisser-d\xe9poser, s\xe9lectionner ou coller.`,
    hi: `\u{92B}\u{93C}\u{93E}\u{907}\u{932}\u{94B}\u{902} \u{915}\u{94B} \u{916}\u{940}\u{902}\u{91A}\u{915}\u{930} \u{914}\u{930} \u{91B}\u{94B}\u{921}\u{93C}\u{915}\u{930}, \u{91A}\u{941}\u{928}\u{915}\u{930} \u{92F}\u{93E} \u{91A}\u{93F}\u{92A}\u{915}\u{93E}\u{928}\u{947} \u{915}\u{947} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{905}\u{928}\u{941}\u{932}\u{917}\u{94D}\u{928} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Tache dosye pa trennen & jete, chwazi, oswa kole yo.`,
    it: `Allega i file trascinandoli e rilasciandoli, selezionandoli o incollandoli.`,
    ja: `\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{30C9}\u{30E9}\u{30C3}\u{30B0}&\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3001}\u{9078}\u{629E}\u{3001}\u{307E}\u{305F}\u{306F}\u{8CBC}\u{308A}\u{4ED8}\u{3051}\u{3067}\u{6DFB}\u{4ED8}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{D30C}\u{C77C}\u{C744} \u{B4DC}\u{B798}\u{ADF8} \u{C564} \u{B4DC}\u{B86D}, \u{C120}\u{D0DD} \u{B610}\u{B294} \u{BD99}\u{C5EC}\u{B123}\u{AE30}\u{B85C} \u{CCA8}\u{BD80}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Txuas cov ntaub ntawv los ntawm dragging & poob, xaiv los yog pasting lawv.`,
    ps: `\u{641}\u{627}\u{6CC}\u{644}\u{648}\u{646}\u{647} \u{62F} \u{631}\u{627}\u{6A9}\u{634} \u{627}\u{648} \u{63A}\u{648}\u{631}\u{681}\u{648}\u{644}\u{648}\u{60C} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6CC}\u{627} \u{67E}\u{6CC}\u{633}\u{67C}\u{648}\u{644}\u{648} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{648}\u{635}\u{644} \u{6A9}\u{693}\u{626}.`,
    pt: `Anexe arquivos arrastando e soltando, selecionando ou colando.`,
    'pt-pt': `Anexe ficheiros arrastando-os e soltando-os, selecionando-os ou colando-os.`,
    ru: `\u{41F}\u{440}\u{438}\u{43A}\u{440}\u{435}\u{43F}\u{43B}\u{44F}\u{439}\u{442}\u{435} \u{444}\u{430}\u{439}\u{43B}\u{44B}, \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{44F}, \u{432}\u{44B}\u{431}\u{438}\u{440}\u{430}\u{44F} \u{438}\u{43B}\u{438} \u{432}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{44F}\u{44F} \u{438}\u{445}.`,
    sm: `Fa'apipi'i faila e ala i le tosoina ma pa'u, filifilia, pe fa'apipi'i i latou.`,
    so: `Faylasha ku xir adigoo jiidaya oo la daadinayaa, dooranaya, ama ku dhejiya.`,
    th: `\u{E41}\u{E19}\u{E1A}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E42}\u{E14}\u{E22}\u{E01}\u{E32}\u{E23}\u{E25}\u{E32}\u{E01}\u{E41}\u{E25}\u{E30}\u{E27}\u{E32}\u{E07} \u{E40}\u{E25}\u{E37}\u{E2D}\u{E01} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E27}\u{E32}\u{E07}\u{E44}\u{E1F}\u{E25}\u{E4C}`,
    ur: `\u{641}\u{627}\u{626}\u{644}\u{632} \u{6A9}\u{648} \u{688}\u{631}\u{6CC}\u{6AF} \u{627}\u{648}\u{631} \u{688}\u{631}\u{627}\u{67E}\u{60C} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6CC}\u{627} \u{67E}\u{6CC}\u{633}\u{679} \u{6A9}\u{631} \u{6A9}\u{6D2} \u{627}\u{679}\u{6CC}\u{686} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `\u{110}\xednh k\xe8m t\u{1EC7}p b\u{1EB1}ng c\xe1ch k\xe9o v\xe0 th\u{1EA3}, ch\u{1ECD}n ho\u{1EB7}c d\xe1n ch\xfang.`,
    'zh-hans': `\u{901A}\u{8FC7}\u{62D6}\u{62FD}\u{3001}\u{9009}\u{62E9}\u{6216}\u{7C98}\u{8D34}\u{6587}\u{4EF6}\u{6765}\u{9644}\u{52A0}\u{6587}\u{4EF6}\u{3002}`,
    'zh-hant': `\u{900F}\u{904E}\u{62D6}\u{653E}\u{3001}\u{9078}\u{53D6}\u{6216}\u{8CBC}\u{4E0A}\u{6A94}\u{6848}\u{4F86}\u{9644}\u{52A0}\u{6A94}\u{6848}\u{3002}`,
    en: `Attach files by dragging & dropping, selecting, or pasting them.`
};
const $b11db1b62d4a8f76$export$f2d46716c5f95f03 = {
    ar: `\u{627}\u{644}\u{627}\u{631}\u{62A}\u{628}\u{627}\u{637}`,
    de: `Anhang`,
    es: `Anexo`,
    fa: `\u{648}\u{627}\u{628}\u{633}\u{62A}\u{6AF}\u{6CC}`,
    fil: `Attachment`,
    fr: `Attachement`,
    hi: `\u{905}\u{928}\u{941}\u{932}\u{917}\u{94D}\u{928}\u{915}`,
    ht: `Atachman`,
    it: `Allegamento`,
    ja: `\u{611B}\u{7740}`,
    ko: `\u{BD80}\u{CC29}`,
    mww: `Txuas`,
    ps: `\u{636}\u{645}\u{6CC}\u{645}\u{647}`,
    pt: `Anexo`,
    'pt-pt': `Anexo`,
    ru: `\u{41F}\u{440}\u{438}\u{43A}\u{440}\u{435}\u{43F}\u{43B}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Fa'apipi'i`,
    so: `Ku xiran`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E41}\u{E19}\u{E1A}`,
    ur: `\u{648}\u{627}\u{628}\u{633}\u{62A}\u{6AF}\u{6CC}`,
    vi: `T\u{1EC7}p \u{111}\xednh k\xe8m`,
    'zh-hans': `\u{4F9D}\u{9644}`,
    'zh-hant': `\u{4F9D}\u{9644}`,
    en: `Attachment`
};
const $b11db1b62d4a8f76$export$965c739f5b069c37 = {
    ar: `\u{627}\u{644}\u{645}\u{644}\u{62D}\u{642}\u{627}\u{62A}`,
    de: `Anh\xe4nge`,
    es: `Accesorios`,
    fa: `\u{636}\u{645}\u{6CC}\u{645}\u{647} \u{647}\u{627}`,
    fil: `Mga Attachment`,
    fr: `Accessoires`,
    hi: `\u{905}\u{928}\u{941}\u{930}\u{915}\u{94D}\u{924}\u{93F}`,
    ht: `Atachman`,
    it: `Allegati`,
    ja: `\u{4ED8}\u{5C5E}\u{65BD}\u{8A2D}`,
    ko: `\u{BD80}\u{C18D} \u{C790}\u{B8CC}`,
    mww: `Cov ntawv txuas`,
    ps: `\u{636}\u{645}\u{6CC}\u{645}\u{6D0}`,
    pt: `Anexos`,
    'pt-pt': `Anexos`,
    ru: `\u{412}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Fa'apipi'i`,
    so: `Lifaaqyo`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E41}\u{E19}\u{E1A}`,
    ur: `\u{627}\u{679}\u{6CC}\u{686}\u{645}\u{646}\u{679}\u{633}`,
    vi: `T\u{1EC7}p \u{111}\xednh k\xe8m`,
    'zh-hans': `\u{9644}\u{5C5E}\u{54C1}`,
    'zh-hant': `\u{9644}\u{5C6C}\u{8A2D}\u{65BD}`,
    en: `Attachments`
};
const $b11db1b62d4a8f76$export$e806b319d1de2b0f = {
    ar: `\u{627}\u{644}\u{62A}\u{641}\u{648}\u{64A}\u{636} \u{63A}\u{64A}\u{631} \u{635}\u{627}\u{644}\u{62D}.`,
    de: `Autorisierung ung\xfcltig.`,
    es: `Autorizaci\xf3n inv\xe1lida.`,
    fa: `\u{645}\u{62C}\u{648}\u{632} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631} \u{627}\u{633}\u{62A}.`,
    fil: `Hindi wasto ang awtorisasyon.`,
    fr: `Autorisation invalide.`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{927}\u{93F}\u{915}\u{930}\u{923} \u{905}\u{92E}\u{93E}\u{928}\u{94D}\u{92F}\u{964}`,
    ht: `Otorizasyon envalid`,
    it: `Autorizzazione non valida.`,
    ja: `\u{8A8D}\u{8A3C}\u{7121}\u{52B9}\u{3067}\u{3059}\u{3002}`,
    ko: `\u{AD8C}\u{D55C}\u{C774} \u{BB34}\u{D6A8}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Kev tso cai tsis raug.`,
    ps: `\u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{627}\u{642}\u{627}\u{646}\u{648}\u{646}\u{647} \u{62F}\u{647}.`,
    pt: `Autoriza\xe7\xe3o inv\xe1lida.`,
    'pt-pt': `Autoriza\xe7\xe3o inv\xe1lida.`,
    ru: `\u{410}\u{432}\u{442}\u{43E}\u{440}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{43D}\u{435}\u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{430}.`,
    sm: `E le aoga le faatagaga.`,
    so: `Oggolaanshuhu waa mid aan sax ahayn.`,
    th: `\u{E01}\u{E32}\u{E23}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{627}\u{645}\u{6C1} \u{63A}\u{6CC}\u{631} \u{645}\u{639}\u{62A}\u{628}\u{631} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `\u{1EE6}y quy\u{1EC1}n kh\xf4ng h\u{1EE3}p l\u{1EC7}.`,
    'zh-hans': `\u{6388}\u{6743}\u{65E0}\u{6548}\u{3002}`,
    'zh-hant': `\u{6388}\u{6B0A}\u{7121}\u{6548}\u{3002}`,
    en: `Authorization invalid.`
};
const $b11db1b62d4a8f76$export$7d65561be707926c = {
    ar: `\u{627}\u{644}\u{62A}\u{641}\u{648}\u{64A}\u{636} \u{645}\u{641}\u{642}\u{648}\u{62F}.`,
    de: `Genehmigung fehlt.`,
    es: `Falta autorizaci\xf3n.`,
    fa: `\u{645}\u{62C}\u{648}\u{632} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `Nawawala ang awtorisasyon.`,
    fr: `Autorisation manquante.`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{927}\u{93F}\u{915}\u{930}\u{923} \u{905}\u{928}\u{941}\u{92A}\u{932}\u{92C}\u{94D}\u{927}\u{964}`,
    ht: `Otorizasyon ki manke.`,
    it: `Autorizzazione mancante.`,
    ja: `\u{627F}\u{8A8D}\u{304C}\u{629C}\u{3051}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C2B9}\u{C778} \u{BD80}\u{C871}.`,
    mww: `Kev tso cai ploj lawm.`,
    ps: `\u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{634}\u{62A}\u{647}.`,
    pt: `Autoriza\xe7\xe3o faltando.`,
    'pt-pt': `Autoriza\xe7\xe3o em falta.`,
    ru: `\u{420}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{435} \u{43E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442}.`,
    sm: `Ua misi le faatagaga.`,
    so: `Oggolaansho ma jirto.`,
    th: `\u{E02}\u{E32}\u{E14}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}`,
    ur: `\u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{627}\u{645}\u{6C1} \u{63A}\u{627}\u{626}\u{628} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Thi\u{1EBF}u \u{1EE7}y quy\u{1EC1}n.`,
    'zh-hans': `\u{7F3A}\u{5C11}\u{6388}\u{6743}\u{3002}`,
    'zh-hant': `\u{7F3A}\u{5C11}\u{6388}\u{6B0A}\u{3002}`,
    en: `Authorization missing.`
};
const $b11db1b62d4a8f76$export$344c4ed476f79fd1 = {
    ar: `\u{627}\u{644}\u{62A}\u{648}\u{627}\u{632}\u{646}`,
    de: `Gleichgewicht`,
    es: `Equilibrio`,
    fa: `\u{62A}\u{639}\u{627}\u{62F}\u{644}`,
    fil: `Balanse`,
    fr: `\xc9quilibre`,
    hi: `\u{938}\u{902}\u{924}\u{941}\u{932}\u{928}`,
    ht: `Balans`,
    it: `Bilanciamento`,
    ja: `\u{30D0}\u{30E9}\u{30F3}\u{30B9}`,
    ko: `\u{BC38}\u{B7F0}\u{C2A4}`,
    mww: `Sib npaug`,
    ps: `\u{62A}\u{648}\u{627}\u{632}\u{646}`,
    pt: `Equil\xedbrio`,
    'pt-pt': `Equil\xedbrio`,
    ru: `\u{411}\u{430}\u{43B}\u{430}\u{43D}\u{441}`,
    sm: `Paleni`,
    so: `Dheelitirka`,
    th: `\u{E2A}\u{E21}\u{E14}\u{E38}\u{E25}`,
    ur: `\u{62A}\u{648}\u{627}\u{632}\u{646}`,
    vi: `C\xe2n b\u{1EB1}ng`,
    'zh-hans': `\u{5E73}\u{8861}`,
    'zh-hant': `\u{5E73}\u{8861}`,
    en: `Balance`
};
const $b11db1b62d4a8f76$export$58faafdea4528c0c = {
    ar: `\u{627}\u{644}\u{62A}\u{635}\u{646}\u{64A}\u{641}`,
    de: `Abrechnung`,
    es: `Facturaci\xf3n`,
    fa: `\u{635}\u{648}\u{631}\u{62A}\u{62D}\u{633}\u{627}\u{628}`,
    fil: `Email Address *`,
    fr: `Facturation`,
    hi: `\u{92C}\u{93F}\u{932}\u{93F}\u{902}\u{917}`,
    ht: `B\xf2dwo`,
    it: `Pubblicazione`,
    ja: `\u{8ACB}\u{6C42}`,
    ko: `\u{CCAD}\u{AD6C}`,
    mww: `Kev them nqi`,
    ps: `\u{628}\u{6CC}\u{644}\u{6CC}\u{646}\u{6AB}`,
    pt: `Faturamento`,
    'pt-pt': `Faturamento`,
    ru: `\u{411}\u{438}\u{43B}\u{43B}\u{438}\u{43D}\u{433}`,
    sm: `Pili`,
    so: `Qiimeynta`,
    th: `\u{E01}\u{E32}\u{E23}\u{E40}\u{E23}\u{E35}\u{E22}\u{E01}\u{E40}\u{E01}\u{E47}\u{E1A}\u{E40}\u{E07}\u{E34}\u{E19}`,
    ur: `\u{628}\u{644}\u{646}\u{6AF}`,
    vi: `Thanh to\xe1n`,
    'zh-hans': `\u{8D26}\u{5355}`,
    'zh-hant': `\u{8A08}\u{8CBB}`,
    en: `Billing`
};
const $b11db1b62d4a8f76$export$ad587a73bfb0a4a7 = {
    ar: `\u{645}\u{644}\u{641}\u{627}\u{62A} \u{627}\u{644}\u{641}\u{648}\u{62A}\u{631}\u{629}`,
    de: `Abrechnungsprofile`,
    es: `Perfiles de facturaci\xf3n`,
    fa: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644} \u{647}\u{627}\u{6CC} \u{635}\u{648}\u{631}\u{62A}\u{62D}\u{633}\u{627}\u{628}`,
    fil: `Mga Profile sa Pagsingil`,
    fr: `Profils de facturation`,
    hi: `\u{92C}\u{93F}\u{932}\u{93F}\u{902}\u{917} \u{92A}\u{94D}\u{930}\u{94B}\u{92B}\u{93E}\u{907}\u{932}`,
    ht: `B\xf2dwo Des`,
    it: `Profili di fatturazione`,
    ja: `\u{8ACB}\u{6C42}\u{30D7}\u{30ED}\u{30D5}\u{30A1}\u{30A4}\u{30EB}`,
    ko: `\u{CCAD}\u{AD6C} \u{D504}\u{B85C}\u{D544}`,
    mww: `Them nqi profiles`,
    ps: `\u{62F} \u{628}\u{6CC}\u{644}\u{6CC}\u{646}\u{6AB} \u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644}\u{648}\u{646}\u{647}`,
    pt: `Perfis de faturamento`,
    'pt-pt': `Perfis de fatura\xe7\xe3o`,
    ru: `\u{41F}\u{440}\u{43E}\u{444}\u{438}\u{43B}\u{438} \u{432}\u{44B}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{441}\u{447}\u{435}\u{442}\u{43E}\u{432}`,
    sm: `Talaaga otooto o pili`,
    so: `Astaamaha Billing-ka`,
    th: `\u{E42}\u{E1B}\u{E23}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E01}\u{E32}\u{E23}\u{E40}\u{E23}\u{E35}\u{E22}\u{E01}\u{E40}\u{E01}\u{E47}\u{E1A}\u{E40}\u{E07}\u{E34}\u{E19}`,
    ur: `\u{628}\u{644}\u{646}\u{6AF} \u{67E}\u{631}\u{648}\u{641}\u{627}\u{626}\u{644}\u{632}`,
    vi: `H\u{1ED3} s\u{1A1} thanh to\xe1n`,
    'zh-hans': `\u{8BA1}\u{8D39}\u{914D}\u{7F6E}\u{6587}\u{4EF6}`,
    'zh-hant': `\u{8A08}\u{8CBB}\u{8A2D}\u{5B9A}\u{6A94}`,
    en: `Billing profiles`
};
const $b11db1b62d4a8f76$export$f888adb3a9692674 = {
    ar: `\u{627}\u{644}\u{633}\u{64A}\u{631}\u{629} \u{627}\u{644}\u{630}\u{627}\u{62A}\u{64A}\u{629}`,
    de: `Biografie`,
    es: `Biograf\xeda`,
    fa: `\u{632}\u{646}\u{62F}\u{6AF}\u{6CC} \u{646}\u{627}\u{645}\u{647}`,
    fil: `Talambuhay`,
    fr: `Biographie`,
    hi: `\u{91C}\u{948}\u{935}`,
    ht: `Biyo`,
    it: `Biografia`,
    ja: `\u{7D4C}\u{6B74}`,
    ko: `\u{C57D}\u{B825}`,
    mww: `Bio`,
    ps: `\u{698}\u{648}\u{646}\u{62F}\u{644}\u{6CC}\u{6A9}`,
    pt: `Biografia`,
    'pt-pt': `Biografia`,
    ru: `\u{411}\u{438}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{44F}`,
    sm: `Talaaga`,
    so: `Taariikh nololeed`,
    th: `\u{E0A}\u{E35}\u{E27}\u{E1B}\u{E23}\u{E30}\u{E27}\u{E31}\u{E15}\u{E34}`,
    ur: `\u{633}\u{648}\u{627}\u{646}\u{62D} \u{62D}\u{6CC}\u{627}\u{62A}`,
    vi: `Ti\u{1EC3}u s\u{1EED}`,
    'zh-hans': `\u{7B80}\u{4ECB}`,
    'zh-hant': `\u{7C21}\u{4ECB}`,
    en: `Bio`
};
const $b11db1b62d4a8f76$export$436322b83076ec62 = {
    ar: `\u{62C}\u{62F}\u{648}\u{644} \u{632}\u{645}\u{646}\u{64A} \u{641}\u{627}\u{631}\u{63A} \u{644} SCSEP`,
    de: `Leeres SCSEP-Stundenblatt`,
    es: `Hoja de horas SCSEP en blanco`,
    fa: `\u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{62E}\u{627}\u{644}\u{6CC} SCSEP`,
    fil: `Blangko SCSEP timesheet`,
    fr: `Feuille horaire SCSEP vierge`,
    hi: `\u{930}\u{93F}\u{915}\u{94D}\u{924} SCSEP \u{938}\u{92E}\u{92F} \u{92A}\u{924}\u{94D}\u{930}\u{915}`,
    ht: `Blank SCSEP timesheet`,
    it: `Foglio orario SCSEP vuoto`,
    ja: `\u{7A7A}\u{767D}\u{306E}SCSEP\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}`,
    ko: `\u{BE48} SCSEP \u{C2DC}\u{AC04}\u{D45C}`,
    mww: `Dawb paug SCSEP daim ntawv teev sij hawm`,
    ps: `\u{62F} SCSEP \u{62E}\u{627}\u{644}\u{6CC} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647}`,
    pt: `Folha de horas SCSEP em branco`,
    'pt-pt': `Folha de horas SCSEP em branco`,
    ru: `\u{41F}\u{443}\u{441}\u{442}\u{43E}\u{439} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44C} SCSEP`,
    sm: `Avanoa SCSEP timesheet`,
    so: `Jadwalka SCSEP ee madhan`,
    th: `\u{E41}\u{E1C}\u{E48}\u{E19}\u{E40}\u{E27}\u{E25}\u{E32} SCSEP \u{E40}\u{E1B}\u{E25}\u{E48}\u{E32}`,
    ur: `\u{62E}\u{627}\u{644}\u{6CC} SCSEP \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679}`,
    vi: `B\u{1EA3}ng ch\u{1EA5}m c\xf4ng SCSEP tr\u{1ED1}ng`,
    'zh-hans': `\u{7A7A}\u{767D}SCSEP\u{65F6}\u{95F4}\u{8868}`,
    'zh-hant': `\u{7A7A}\u{767D}SCSEP\u{5DE5}\u{6642}\u{8868}`,
    en: `Blank SCSEP timesheet`
};
const $b11db1b62d4a8f76$export$5b7df3b8bc3c3ce8 = {
    ar: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">التحرر</span> من تكنولوجيا المعلومات المعقدة`,
    de: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Befreie dich</span> aus der komplizierten IT`,
    es: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Libérate</span> de la informática complicada`,
    fa: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">رهایی</span> از فناوری اطلاعات پیچیده`,
    fil: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Alisin</span> ang tiyan mula sa kumplikadong pag-uugali`,
    fr: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Libérez-vous</span> de l’informatique compliquée`,
    hi: $b11db1b62d4a8f76$var$html`जटिल आईटी से <span class="text-gradient text-gradient--purple-pink">मुक्त हो जाओ</span>`,
    ht: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Kraze soti</span> nan IT konplike`,
    it: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Liberarsi</span> dall'IT complicato`,
    ja: $b11db1b62d4a8f76$var$html`複雑なITからの<span class="text-gradient text-gradient--purple-pink">脱</span>却`,
    ko: $b11db1b62d4a8f76$var$html`복잡한 IT에서 <span class="text-gradient text-gradient--purple-pink">벗어나</span>`,
    mww: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Tawg tawm</span> ntawm IT nyuaj`,
    ps: $b11db1b62d4a8f76$var$html`له پېچلو آی ټی څخه <span class="text-gradient text-gradient--purple-pink">ځان خلاص کړه</span>`,
    pt: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Liberte-se</span> de TI complicada`,
    'pt-pt': $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Liberta-te</span> de TI complicada`,
    ru: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Освободиться</span> от сложной ИТ`,
    sm: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Fa'asa'oloto mai</span> le fa'alavelave fa'alavelave`,
    so: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Ka bax</span> IT-ga adag`,
    th: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">หลุดพ้น</span> จากไอทีที่ซับซ้อน`,
    ur: $b11db1b62d4a8f76$var$html`پیچیدہ آئی ٹی سے <span class="text-gradient text-gradient--purple-pink">آزاد ہونا</span>`,
    vi: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Thoát khỏi</span> CNTT phức tạp`,
    'zh-hans': $b11db1b62d4a8f76$var$html`摆<span class="text-gradient text-gradient--purple-pink">脱</span>复杂的IT困境`,
    'zh-hant': $b11db1b62d4a8f76$var$html`擺脫<span class="text-gradient text-gradient--purple-pink"></span>複雜的 IT 困境`,
    en: $b11db1b62d4a8f76$var$html`<span class="text-gradient text-gradient--purple-pink">Break free</span> from complicated IT`
};
const $b11db1b62d4a8f76$export$c92d48fbe6bc8bd = {
    ar: `\u{627}\u{644}\u{645}\u{64A}\u{632}\u{627}\u{646}\u{64A}\u{629}`,
    de: `Budget`,
    es: `Presupuesto`,
    fa: `\u{628}\u{648}\u{62F}\u{62C}\u{647}`,
    fil: `Badyet`,
    fr: `Budget`,
    hi: `\u{92C}\u{939}\u{941}\u{924} \u{938}\u{938}\u{94D}\u{200D}\u{924}\u{93E}`,
    ht: `Bidj\xe8`,
    it: `Budget`,
    ja: `\u{4E88}\u{7B97}`,
    ko: `\u{C608}\u{C0B0}`,
    mww: `Nyiaj Txiag`,
    ps: `\u{628}\u{648}\u{62F}\u{6CC}\u{62C}\u{647}`,
    pt: `Or\xe7amento`,
    'pt-pt': `Or\xe7amento`,
    ru: `\u{411}\u{44E}\u{434}\u{436}\u{435}\u{442}`,
    sm: `Paketi`,
    so: `Miisaaniyadda`,
    th: `\u{E07}\u{E1A}\u{E1B}\u{E23}\u{E30}\u{E21}\u{E32}\u{E13}`,
    ur: `\u{628}\u{62C}\u{679}`,
    vi: `Ng\xe2n s\xe1ch`,
    'zh-hans': `\u{9884}\u{7B97}`,
    'zh-hant': `\u{9810}\u{7B97}`,
    en: `Budget`
};
const $b11db1b62d4a8f76$export$17569330350e22fe = {
    ar: `\u{627}\u{644}\u{645}\u{64A}\u{632}\u{627}\u{646}\u{64A}\u{627}\u{62A}`,
    de: `Budgets`,
    es: `Presupuestos`,
    fa: `\u{628}\u{648}\u{62F}\u{62C}\u{647} \u{647}\u{627}`,
    fil: `Mga badyet`,
    fr: `Budgets`,
    hi: `\u{92C}\u{91C}\u{91F}`,
    ht: `Bidj\xe8 yo`,
    it: `Bilanci`,
    ja: `\u{4E88}\u{7B97}`,
    ko: `\u{C608}\u{C0B0}`,
    mww: `Cov Nyiaj Txiag`,
    ps: `\u{628}\u{648}\u{62F}\u{6CC}\u{62C}\u{647}`,
    pt: `Or\xe7amentos`,
    'pt-pt': `Or\xe7amentos`,
    ru: `\u{411}\u{44E}\u{434}\u{436}\u{435}\u{442}\u{44B}`,
    sm: `Paketi`,
    so: `Miisaaniyadda`,
    th: `\u{E07}\u{E1A}\u{E1B}\u{E23}\u{E30}\u{E21}\u{E32}\u{E13}`,
    ur: `\u{628}\u{62C}\u{679}`,
    vi: `Ng\xe2n s\xe1ch`,
    'zh-hans': `\u{9884}\u{7B97}`,
    'zh-hant': `\u{9810}\u{7B97}`,
    en: `Budgets`
};
const $b11db1b62d4a8f76$export$ef8fbe21b6debfe7 = {
    ar: `\u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{627}\u{644}\u{62A}\u{62C}\u{627}\u{631}\u{64A}`,
    de: `Gesch\xe4fts-E-Mail`,
    es: `Correo electr\xf3nico empresarial`,
    fa: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{62A}\u{62C}\u{627}\u{631}\u{6CC}`,
    fil: `Email Address *`,
    fr: `Email professionnel`,
    hi: `\u{935}\u{94D}\u{92F}\u{93E}\u{92A}\u{93E}\u{930} \u{908}\u{92E}\u{947}\u{932}`,
    ht: `Im\xe8l biznis`,
    it: `Email aziendale`,
    ja: `\u{30D3}\u{30B8}\u{30CD}\u{30B9}\u{30E1}\u{30FC}\u{30EB}`,
    ko: `\u{BE44}\u{C988}\u{B2C8}\u{C2A4} \u{C774}\u{BA54}\u{C77C}`,
    mww: `Kev lag luam email`,
    ps: `\u{62F} \u{633}\u{648}\u{62F}\u{627}\u{6AB}\u{631}\u{6CD} \u{628}\u{631}\u{6D0}\u{69A}\u{646}\u{627}\u{644}\u{6CC}\u{6A9}`,
    pt: `E-mail empresarial`,
    'pt-pt': `Email empresarial`,
    ru: `\u{414}\u{435}\u{43B}\u{43E}\u{432}\u{430}\u{44F} \u{43F}\u{43E}\u{447}\u{442}\u{430}`,
    sm: `Pisinisi imeli`,
    so: `Email ganacsi`,
    th: `\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E18}\u{E38}\u{E23}\u{E01}\u{E34}\u{E08}`,
    ur: `\u{6A9}\u{627}\u{631}\u{648}\u{628}\u{627}\u{631}\u{6CC} \u{627}\u{6CC} \u{645}\u{6CC}\u{644}`,
    vi: `Email doanh nghi\u{1EC7}p`,
    'zh-hans': `\u{5546}\u{52A1}\u{90AE}\u{7BB1}`,
    'zh-hant': `\u{5546}\u{696D}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}`,
    en: `Business email`
};
const $b11db1b62d4a8f76$export$c5b368b2998a6f37 = {
    ar: `\u{625}\u{644}\u{63A}\u{627}\u{621}`,
    de: `Stornieren`,
    es: `Cancelar`,
    fa: `\u{644}\u{63A}\u{648}`,
    fil: `Kanselahin`,
    fr: `Annuler`,
    hi: `\u{930}\u{926}\u{94D}\u{926} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `Anile`,
    it: `Cancella`,
    ja: `\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}`,
    ko: `\u{CDE8}\u{C18C}`,
    mww: `rho tawm`,
    ps: `\u{644}\u{63A}\u{648}\u{647} \u{6A9}\u{648}\u{644}`,
    pt: `Cancelar`,
    'pt-pt': `Cancelar`,
    ru: `\u{41E}\u{442}\u{43C}\u{435}\u{43D}\u{430}`,
    sm: `Fa'al\u{113}\u{101}og\u{101}ina`,
    so: `Jooji`,
    th: `\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}`,
    ur: `\u{645}\u{646}\u{633}\u{648}\u{62E} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `H\u{1EE7}y b\u{1ECF}`,
    'zh-hans': `\u{53D6}\u{6D88}`,
    'zh-hant': `\u{53D6}\u{6D88}`,
    en: `Cancel`
};
const $b11db1b62d4a8f76$export$c6aa1bfa918ebf18 = {
    ar: `\u{62A}\u{645} \u{627}\u{644}\u{625}\u{644}\u{63A}\u{627}\u{621}`,
    de: `Eingestellt`,
    es: `Cancelado`,
    fa: `\u{644}\u{63A}\u{648} \u{634}\u{62F}\u{647}`,
    fil: `Kinansela`,
    fr: `Annul\xe9`,
    hi: `\u{930}\u{926}\u{94D}\u{926} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Anile`,
    it: `Cancellato`,
    ja: `\u{4E2D}\u{6B62}`,
    ko: `\u{CDE8}\u{C18C}\u{B428}`,
    mww: `muab tso tseg`,
    ps: `\u{644}\u{63A}\u{648}\u{647} \u{634}\u{648}`,
    pt: `Cancelado`,
    'pt-pt': `Cancelado`,
    ru: `\u{41E}\u{442}\u{43C}\u{435}\u{43D}\u{451}\u{43D}`,
    sm: `Fa'aleaogaina`,
    so: `La joojiyay`,
    th: `\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}`,
    ur: `\u{645}\u{646}\u{633}\u{648}\u{62E} \u{634}\u{62F}\u{6C1}`,
    vi: `\u{110}\xe3 h\u{1EE7}y`,
    'zh-hans': `\u{53D6}\u{6D88}`,
    'zh-hant': `\u{53D6}\u{6D88}`,
    en: `Cancelled`
};
const $b11db1b62d4a8f76$export$de87c35595e5d750 = {
    ar: `\u{644}\u{645} \u{62A}\u{643}\u{62A}\u{645}\u{644} \u{647}\u{630}\u{647} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}\u{627}\u{62A}.`,
    de: `Die Aktivit\xe4t wurde nicht abgeschlossen.`,
    es: `La actividad no se complet\xf3.`,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{647} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{646}\u{631}\u{633}\u{6CC}\u{62F}.`,
    fil: `Hindi pa tapos ang aktibidad.`,
    fr: `L\u{2019}activit\xe9 n\u{2019}a pas \xe9t\xe9 achev\xe9e.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{942}\u{930}\u{940} \u{928}\u{939}\u{940}\u{902} \u{939}\u{941}\u{908} \u{925}\u{940}\u{964}`,
    ht: `Aktivite a pa t fini`,
    it: `L'attivit\xe0 non fu completata.`,
    ja: `\u{3057}\u{304B}\u{3057}\u{3001}\u{305D}\u{306E}\u{6D3B}\u{52D5}\u{306F}\u{5B8C}\u{4E86}\u{3057}\u{307E}\u{305B}\u{3093}\u{3067}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{ADF8}\u{B7EC}\u{B098} \u{C774} \u{D65C}\u{B3D9}\u{C740} \u{C644}\u{B8CC}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kev ua haujlwm tsis tiav.`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{634}\u{67E}\u{693} \u{646}\u{647} \u{634}\u{648}.`,
    pt: `A atividade n\xe3o foi conclu\xedda.`,
    'pt-pt': `A atividade n\xe3o foi conclu\xedda.`,
    ru: `\u{414}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{43D}\u{435} \u{431}\u{44B}\u{43B}\u{430} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{430}.`,
    sm: `E le'i mae'a le gaoioiga.`,
    so: `Hawshaas lama dhammeystirin.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6A9}\u{645}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{626}\u{6CC}\u{6D4}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng ch\u{1B0}a ho\xe0n th\xe0nh.`,
    'zh-hans': `\u{8BE5}\u{6D3B}\u{52A8}\u{672A}\u{5B8C}\u{6210}\u{3002}`,
    'zh-hant': `\u{8A72}\u{6D3B}\u{52D5}\u{5C1A}\u{672A}\u{5B8C}\u{6210}\u{3002}`,
    en: `The activity was not completed.`
};
const $b11db1b62d4a8f76$export$da467b70cb2c174f = {
    ar: `\u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{644}\u{627} \u{64A}\u{645}\u{643}\u{646}\u{647} \u{625}\u{646}\u{634}\u{627}\u{621} \u{633}\u{62C}\u{644}\u{627}\u{62A} \u{62C}\u{62F}\u{64A}\u{62F}\u{629}.`,
    de: `Diese Aktivit\xe4t kann keine neuen Datens\xe4tze erstellen.`,
    es: `Esta actividad no puede crear nuevos registros.`,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{631}\u{6A9}\u{648}\u{631}\u{62F}\u{647}\u{627}\u{6CC} \u{62C}\u{62F}\u{6CC}\u{62F}\u{6CC} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{646}\u{62F}.`,
    fil: `Ang aktibidad na ito ay hindi maaaring lumikha ng mga bagong talaan.`,
    fr: `Cette activit\xe9 ne peut pas cr\xe9er de nouveaux enregistrements.`,
    hi: `\u{92F}\u{939} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{928}\u{90F} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{928}\u{939}\u{940}\u{902} \u{92C}\u{928}\u{93E} \u{938}\u{915}\u{924}\u{940}.`,
    ht: `Aktivite sa a pa ka kreye nouvo dosye.`,
    it: `Questa attivit\xe0 non pu\xf2 creare nuovi record.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306F}\u{65B0}\u{3057}\u{3044}\u{8A18}\u{9332}\u{3092}\u{4F5C}\u{6210}\u{3059}\u{308B}\u{3053}\u{3068}\u{306F}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C740} \u{C0C8}\u{B85C}\u{C6B4} \u{AE30}\u{B85D}\u{C744} \u{C0DD}\u{C131}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kev ua no tsis tuaj yeem tsim cov ntaub ntawv tshiab.`,
    ps: `\u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{646}\u{634}\u{6CC} \u{6A9}\u{648}\u{644}\u{627}\u{6CC} \u{646}\u{648}\u{6CC} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689}\u{648}\u{646}\u{647} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{6CC}.`,
    pt: `Essa atividade n\xe3o pode criar novos registros.`,
    'pt-pt': `Esta atividade n\xe3o pode criar novos registos.`,
    ru: `\u{42D}\u{442}\u{430} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{432}\u{430}\u{442}\u{44C} \u{43D}\u{43E}\u{432}\u{44B}\u{435} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}.`,
    sm: `E le mafai e lenei gaoioiga ona fatuina ni faamaumauga fou.`,
    so: `Hawlgalkan ma abuuri karo diiwaanno cusub.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E43}\u{E2B}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{646}\u{626}\u{6D2} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688}\u{632} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{628}\u{646}\u{627} \u{633}\u{6A9}\u{62A}\u{6CC}\u{6D4}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y kh\xf4ng th\u{1EC3} t\u{1EA1}o b\u{1EA3}n ghi m\u{1EDB}i.`,
    'zh-hans': `\u{8BE5}\u{6D3B}\u{52A8}\u{65E0}\u{6CD5}\u{521B}\u{9020}\u{65B0}\u{8BB0}\u{5F55}\u{3002}`,
    'zh-hant': `\u{6B64}\u{6D3B}\u{52D5}\u{7121}\u{6CD5}\u{5275}\u{9020}\u{65B0}\u{7D00}\u{9304}\u{3002}`,
    en: `This activity cannot create new records.`
};
const $b11db1b62d4a8f76$export$c99911026360dab2 = {
    ar: `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646}\u{646}\u{64A} \u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644}. \u{623}\u{646}\u{62A} \u{645}\u{633}\u{62C}\u{644}\u{629} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{628}\u{627}\u{644}\u{641}\u{639}\u{644}.`,
    de: `Kann mich nicht anmelden. Sie sind bereits angemeldet.`,
    es: `No puedo inscribirme. Ya has iniciado sesi\xf3n.`,
    fa: `\u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{645} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{6A9}\u{646}\u{645}. \u{634}\u{645}\u{627} \u{642}\u{628}\u{644}\u{627} \u{648}\u{627}\u{631}\u{62F} \u{634}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: `Hindi makapag-sign up. Naka-sign in ka na.`,
    fr: `Je ne peux pas m\u{2019}inscrire. Vous \xeates d\xe9j\xe0 connect\xe9.`,
    hi: `\u{938}\u{93E}\u{907}\u{928} \u{905}\u{92A} \u{928}\u{939}\u{940}\u{902} \u{915}\u{930} \u{938}\u{915}\u{924}\u{93E}. \u{906}\u{92A} \u{92A}\u{939}\u{932}\u{947} \u{938}\u{947} \u{939}\u{940} \u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{939}\u{948}\u{902}.`,
    ht: `Pa ka enskri. Ou deja siyen nan.`,
    it: `Non posso iscrivermi. Sei gi\xe0 registrato.`,
    ja: `\u{767B}\u{9332}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}\u{3059}\u{3067}\u{306B}\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{AC00}\u{C785}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C774}\u{BBF8} \u{B85C}\u{ADF8}\u{C778}\u{B418}\u{C5B4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis tuaj yeem sau npe. Koj twb tau kos npe lawm.`,
    ps: `\u{646}\u{634}\u{645} \u{6A9}\u{648}\u{644}\u{627}\u{6CC} \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{648}\u{6A9}\u{693}\u{645}. \u{62A}\u{647} \u{644}\u{627} \u{62F}\u{645}\u{62E}\u{647} \u{62B}\u{628}\u{62A} \u{634}\u{648}\u{6CC} \u{6CC}\u{6D0}.`,
    pt: `N\xe3o posso me inscrever. Voc\xea j\xe1 est\xe1 logado.`,
    'pt-pt': `N\xe3o posso inscrever-me. J\xe1 est\xe1 registado.`,
    ru: `\u{41D}\u{435} \u{43C}\u{43E}\u{433}\u{443} \u{437}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{44F}. \u{412}\u{44B} \u{443}\u{436}\u{435} \u{432}\u{43E}\u{448}\u{43B}\u{438} \u{432} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443}.`,
    sm: `E le mafai ona saini. Ua uma ona e saini i totonu.`,
    so: `Ma isdiiwaangelin karo. Waxaad horey u diiwaangelisay.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E44}\u{E14}\u{E49} \u{E04}\u{E38}\u{E13}\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{633}\u{627}\u{626}\u{646} \u{627}\u{67E} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{631} \u{633}\u{6A9}\u{62A}\u{627}\u{6D4} \u{622}\u{67E} \u{67E}\u{6C1}\u{644}\u{6D2} \u{6C1}\u{6CC} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{631} \u{686}\u{6A9}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Kh\xf4ng th\u{1EC3} \u{111}\u{103}ng k\xfd. B\u{1EA1}n \u{111}\xe3 \u{111}\u{103}ng nh\u{1EAD}p.`,
    'zh-hans': `\u{65E0}\u{6CD5}\u{6CE8}\u{518C}\u{3002}\u{4F60}\u{5DF2}\u{7ECF}\u{767B}\u{5F55}\u{4E86}\u{3002}`,
    'zh-hant': `\u{7121}\u{6CD5}\u{8A3B}\u{518A}\u{3002}\u{4F60}\u{5DF2}\u{7D93}\u{767B}\u{5165}\u{4E86}\u{3002}`,
    en: `Cannot sign up. You are already signed in.`
};
const $b11db1b62d4a8f76$export$fd0d41fee0431b60 = {
    ar: `\u{642}\u{628}\u{639}\u{629}`,
    de: `Cap`,
    es: `Cap`,
    fa: `\u{6A9}\u{644}\u{627}\u{647}`,
    fil: `Cap`,
    fr: `Cap`,
    hi: `\u{91F}\u{94B}\u{92A}\u{940}`,
    ht: `Bouchon`,
    it: `Cap`,
    ja: `\u{30AD}\u{30E3}\u{30C3}\u{30D7}`,
    ko: `\u{CEA1}`,
    mww: `kaus mom`,
    ps: `\u{6A9}\u{67E}`,
    pt: `Cap`,
    'pt-pt': `Cap`,
    ru: `\u{41A}\u{435}\u{43F}\u{43A}\u{430}`,
    sm: `Pulou`,
    so: `Koofiyadda`,
    th: `\u{E2B}\u{E21}\u{E27}\u{E01}`,
    ur: `\u{6A9}\u{6CC}\u{67E}`,
    vi: `M\u{169} l\u{1B0}\u{1EE1}i trai`,
    'zh-hans': `\u{5E3D}`,
    'zh-hant': `\u{5E3D}`,
    en: `Cap`
};
const $b11db1b62d4a8f76$export$bb9d567bc71db07c = {
    ar: `\u{627}\u{644}\u{643}\u{627}\u{628}\u{633}`,
    de: `Caps`,
    es: `Internacionalidades`,
    fa: `\u{6A9}\u{644}\u{627}\u{647} \u{647}\u{627}`,
    fil: `Mga Takip`,
    fr: `S\xe9lections`,
    hi: `\u{915}\u{948}\u{92A}\u{94D}\u{938}`,
    ht: `Bouchon`,
    it: `Presenze`,
    ja: `\u{30AD}\u{30E3}\u{30C3}\u{30D7}`,
    ko: `\u{BAA8}\u{C790}`,
    mww: `Kaus mom`,
    ps: `\u{6A9}\u{67E}\u{648}\u{646}\u{647}`,
    pt: `Partidas`,
    'pt-pt': `Internacionaliza\xe7\xf5es`,
    ru: `\u{41A}\u{430}\u{43F}\u{44B}`,
    sm: `Pulou`,
    so: `Koobabka ciyaaraha`,
    th: `\u{E2B}\u{E21}\u{E27}\u{E01}`,
    ur: `\u{6A9}\u{6CC}\u{67E}\u{633}`,
    vi: `M\u{169} l\u{1B0}\u{1EE1}i trai`,
    'zh-hans': `\u{5E3D}`,
    'zh-hant': `\u{5E3D}`,
    en: `Caps`
};
const $b11db1b62d4a8f76$export$1bc06abb2b281050 = {
    ar: `\u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631}`,
    de: `Passwort \xe4ndern`,
    es: `Cambiar la contrase\xf1a`,
    fa: `\u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631}`,
    fil: `Password`,
    fr: `Changer le mot de passe`,
    hi: `\u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} \u{92C}\u{926}\u{932}\u{947}\u{902}`,
    ht: `Chanje modpas`,
    it: `Cambia password`,
    ja: `\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}\u{5909}\u{66F4}`,
    ko: `\u{BE44}\u{BC00}\u{BC88}\u{D638} \u{BCC0}\u{ACBD}`,
    mww: `Hloov lo lus zais`,
    ps: `\u{631}\u{645}\u{632} \u{628}\u{62F}\u{644} \u{6A9}\u{693}\u{647}`,
    pt: `Alterar a senha`,
    'pt-pt': `Alterar palavra-passe`,
    ru: `\u{421}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44C}`,
    sm: `Sui le uputatala`,
    so: `Beddel erayga sirta ah`,
    th: `\u{E40}\u{E1B}\u{E25}\u{E35}\u{E48}\u{E22}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}`,
    ur: `\u{67E}\u{627}\u{633} \u{648}\u{631}\u{688} \u{62A}\u{628}\u{62F}\u{6CC}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Thay \u{111}\u{1ED5}i m\u{1EAD}t kh\u{1EA9}u`,
    'zh-hans': `\u{66F4}\u{6539}\u{5BC6}\u{7801}`,
    'zh-hant': `\u{66F4}\u{6539}\u{5BC6}\u{78BC}`,
    en: `Change password`
};
const $b11db1b62d4a8f76$export$a4d3798dfe980a26 = {
    ar: `\u{623}\u{631}\u{633}\u{644} \u{631}\u{627}\u{628}\u{637}\u{627} \u{639}\u{628}\u{631} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{644}\u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631}. \u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631} \u{633}\u{64A}\u{62C}\u{639}\u{644}\u{643} \u{62A}\u{62E}\u{631}\u{62C} \u{645}\u{646} Cumulus.`,
    de: `Senden Sie eine E-Mail mit einem Link, um Ihr Passwort zu \xe4ndern. Wenn du dein Passwort \xe4nderst, meldest du dich von Cumulus ab.`,
    es: `Env\xeda un enlace por correo electr\xf3nico para cambiar tu contrase\xf1a. Cambiar tu contrase\xf1a te desconectar\xe1 de Cumulus.`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9}\u{6CC} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{6A9}\u{646}\u{6CC}\u{62F} \u{62A}\u{627} \u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631} \u{62E}\u{648}\u{62F} \u{631}\u{627} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{62F}\u{647}\u{6CC}\u{62F}. \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631} \u{634}\u{645}\u{627} \u{631}\u{627} \u{627}\u{632} Cumulus \u{62E}\u{627}\u{631}\u{62C} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F}.`,
    fil: `Mag-email ng link para baguhin ang iyong password. Ang pagbabago ng iyong password ay mag-sign out sa iyo mula sa Cumulus.`,
    fr: `Envoyez un lien par email pour changer votre mot de passe. Changer votre mot de passe vous d\xe9connectera de Cumulus.`,
    hi: `\u{905}\u{92A}\u{928}\u{93E} \u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} \u{92C}\u{926}\u{932}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{90F}\u{915} \u{932}\u{93F}\u{902}\u{915} \u{908}\u{92E}\u{947}\u{932} \u{915}\u{930}\u{947}\u{902}. \u{905}\u{92A}\u{928}\u{93E} \u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} \u{92C}\u{926}\u{932}\u{928}\u{947} \u{938}\u{947} \u{906}\u{92A} \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{941}\u{932}\u{938} \u{938}\u{947} \u{92C}\u{93E}\u{939}\u{930} \u{939}\u{94B} \u{91C}\u{93E}\u{90F}\u{902}\u{917}\u{947}\u{964}`,
    ht: `Im\xe8l yon lyen pou chanje modpas ou. Chanje modpas ou pral siyen ou soti nan Cumulus.`,
    it: `Invia un link via email per cambiare la password. Cambiare la password ti far\xe0 uscire da Cumulus.`,
    ja: `\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}\u{5909}\u{66F4}\u{306E}\u{305F}\u{3081}\u{306E}\u{30EA}\u{30F3}\u{30AF}\u{3092}\u{30E1}\u{30FC}\u{30EB}\u{3067}\u{9001}\u{3063}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}\u{3092}\u{5909}\u{66F4}\u{3059}\u{308B}\u{3068}Cumulus\u{304B}\u{3089}\u{30B5}\u{30A4}\u{30F3}\u{30A2}\u{30A6}\u{30C8}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{BE44}\u{BC00}\u{BC88}\u{D638}\u{B97C} \u{BCC0}\u{ACBD}\u{D558}\u{B824}\u{BA74} \u{B9C1}\u{D06C}\u{B97C} \u{C774}\u{BA54}\u{C77C}\u{B85C} \u{BCF4}\u{B0B4}\u{C138}\u{C694}. \u{BE44}\u{BC00}\u{BC88}\u{D638}\u{B97C} \u{BCC0}\u{ACBD}\u{D558}\u{BA74} Cumulus\u{C5D0}\u{C11C} \u{B85C}\u{ADF8}\u{C544}\u{C6C3}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Email ib qhov txuas los hloov koj tus password. Hloov koj lo lus zais yuav kos npe rau koj tawm ntawm Cumulus.`,
    ps: `\u{62F} \u{67E}\u{627}\u{633}\u{648}\u{631}\u{689} \u{628}\u{62F}\u{644}\u{648}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{644}\u{6CC}\u{646}\u{6A9} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{6A9}\u{693}\u{626}. \u{67E}\u{627}\u{633}\u{648}\u{631}\u{689} \u{628}\u{62F}\u{644}\u{648}\u{644} \u{628}\u{647} \u{62A}\u{627} \u{644}\u{647} \u{6A9}\u{648}\u{645}\u{6CC}\u{648}\u{644}\u{633} \u{685}\u{62E}\u{647} \u{648}\u{628}\u{627}\u{633}\u{6CC}.`,
    pt: `Envie um link para mudar sua senha. Mudar sua senha vai fazer voc\xea sair do Cumulus.`,
    'pt-pt': `Envie um link por email para alterar a sua palavra-passe. Mudar a sua palavra-passe vai desconectar-se da Cumulus.`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{44C}\u{442}\u{435} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443} \u{43F}\u{43E} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{447}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{441}\u{43C}\u{435}\u{43D}\u{44B} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44F}. \u{421}\u{43C}\u{435}\u{43D}\u{430} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44F} \u{432}\u{44B}\u{439}\u{434}\u{435}\u{442} \u{438}\u{437} Cumulus.`,
    sm: `Imeli mai se sootaga e sui ai lau uputatala. O le suia o lau uputatala o le a saini ai oe mai Cumulus.`,
    so: `U dir email link si aad u beddesho erayga sirta sirta ah. Beddelidda erayga sirta ah waxay kaa saari doontaa Cumulus.`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E17}\u{E32}\u{E07}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E1B}\u{E25}\u{E35}\u{E48}\u{E22}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19} \u{E01}\u{E32}\u{E23}\u{E40}\u{E1B}\u{E25}\u{E35}\u{E48}\u{E22}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E08}\u{E30}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E01}\u{E32}\u{E23}\u{E19}\u{E4D}\u{E32}\u{E04}\u{E38}\u{E13}\u{E2D}\u{E2D}\u{E01}\u{E08}\u{E32}\u{E01}\u{E23}\u{E30}\u{E1A}\u{E1A} Cumulus`,
    ur: `\u{627}\u{67E}\u{646}\u{627} \u{67E}\u{627}\u{633} \u{648}\u{631}\u{688} \u{62A}\u{628}\u{62F}\u{6CC}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{644}\u{646}\u{6A9} \u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4} \u{627}\u{67E}\u{646}\u{627} \u{67E}\u{627}\u{633} \u{648}\u{631}\u{688} \u{62A}\u{628}\u{62F}\u{6CC}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{633}\u{6D2} \u{622}\u{67E} Cumulus \u{633}\u{6D2} \u{628}\u{627}\u{6C1}\u{631} \u{6C1}\u{648} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA} \u{6AF}\u{6D2}\u{6D4}`,
    vi: `G\u{1EED}i li\xean k\u{1EBF}t qua email \u{111}\u{1EC3} thay \u{111}\u{1ED5}i m\u{1EAD}t kh\u{1EA9}u c\u{1EE7}a b\u{1EA1}n. Thay \u{111}\u{1ED5}i m\u{1EAD}t kh\u{1EA9}u c\u{1EE7}a b\u{1EA1}n s\u{1EBD} \u{111}\u{103}ng xu\u{1EA5}t b\u{1EA1}n kh\u{1ECF}i Cumulus.`,
    'zh-hans': `\u{901A}\u{8FC7}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{53D1}\u{9001}\u{66F4}\u{6539}\u{5BC6}\u{7801}\u{7684}\u{94FE}\u{63A5}\u{3002}\u{66F4}\u{6539}\u{5BC6}\u{7801}\u{4F1A}\u{8BA9}\u{4F60}\u{767B}\u{51FA}Cumulus\u{3002}`,
    'zh-hant': `\u{900F}\u{904E}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{767C}\u{9001}\u{66F4}\u{6539}\u{5BC6}\u{78BC}\u{7684}\u{9023}\u{7D50}\u{3002}\u{66F4}\u{6539}\u{5BC6}\u{78BC}\u{6703}\u{8B93}\u{4F60}\u{767B}\u{51FA} Cumulus\u{3002}`,
    en: `Email a link to change your password. Changing your password will sign you out of Cumulus.`
};
const $b11db1b62d4a8f76$export$97386b479e6932ad = {
    ar: `\u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{631}\u{627}\u{628}\u{637} \u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631} \u{623}\u{631}\u{633}\u{644}\u{62A}`,
    de: `Passwort \xe4ndern Link gesendet`,
    es: `Enlace de cambio de contrase\xf1a enviado`,
    fa: `\u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631} \u{644}\u{6CC}\u{646}\u{6A9} \u{627}\u{631}\u{633}\u{627}\u{644} \u{634}\u{62F}`,
    fil: `Baguhin ang link ng password na ipinadala`,
    fr: `Lien de changement de mot de passe envoy\xe9`,
    hi: `\u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} \u{92C}\u{926}\u{932}\u{947}\u{902} \u{932}\u{93F}\u{902}\u{915} \u{92D}\u{947}\u{91C}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Chanje lyen modpas voye`,
    it: `Modifica password link inviato`,
    ja: `\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}\u{5909}\u{66F4}\u{30EA}\u{30F3}\u{30AF}\u{9001}\u{4FE1}\u{6E08}\u{307F}`,
    ko: `\u{BE44}\u{BC00}\u{BC88}\u{D638} \u{BCC0}\u{ACBD} \u{B9C1}\u{D06C} \u{C804}\u{C1A1}`,
    mww: `Hloov lo lus zais txuas xa`,
    ps: `\u{62F} \u{67E}\u{627}\u{633}\u{648}\u{631}\u{689} \u{628}\u{62F}\u{644}\u{648}\u{646} \u{644}\u{6CC}\u{646}\u{6A9} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{644} \u{634}\u{648}`,
    pt: `Link de mudan\xe7a de senha enviado`,
    'pt-pt': `Link de altera\xe7\xe3o de palavra-passe enviado`,
    ru: `\u{421}\u{441}\u{44B}\u{43B}\u{43A}\u{430} \u{43D}\u{430} \u{441}\u{43C}\u{435}\u{43D}\u{443} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44F} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{430}`,
    sm: `Suia le sootaga o le uputatala na auina atu`,
    so: `Beddel erayga sirta ah link la diray`,
    th: `\u{E40}\u{E1B}\u{E25}\u{E35}\u{E48}\u{E22}\u{E19}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E48}\u{E07}`,
    ur: `\u{67E}\u{627}\u{633} \u{648}\u{631}\u{688} \u{644}\u{646}\u{6A9} \u{62A}\u{628}\u{62F}\u{6CC}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Thay \u{111}\u{1ED5}i li\xean k\u{1EBF}t m\u{1EAD}t kh\u{1EA9}u \u{111}\xe3 g\u{1EED}i`,
    'zh-hans': `\u{66F4}\u{6539}\u{5BC6}\u{7801}\u{94FE}\u{63A5}\u{5DF2}\u{53D1}\u{9001}`,
    'zh-hant': `\u{66F4}\u{6539}\u{5BC6}\u{78BC}\u{9023}\u{7D50}\u{5DF2}\u{767C}\u{9001}`,
    en: `Change password link sent`
};
const $b11db1b62d4a8f76$export$f73a87d45ab02f08 = {
    ar: `\u{62A}\u{645} \u{625}\u{631}\u{633}\u{627}\u{644} \u{631}\u{627}\u{628}\u{637} \u{644}\u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631} \u{625}\u{644}\u{649} \u{628}\u{631}\u{64A}\u{62F}\u{643} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}. \u{648}\u{627}\u{635}\u{644} \u{639}\u{645}\u{644}\u{64A}\u{629} \u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{631}\u{627}\u{628}\u{637} \u{627}\u{644}\u{630}\u{64A} \u{627}\u{633}\u{62A}\u{644}\u{645}\u{62A}\u{647}.`,
    de: `Ein Link zur \xc4nderung Ihres Passworts wurde an Ihre E-Mail-Adresse gesendet. Setzen Sie den Passwort\xe4nderungsprozess \xfcber den erhaltenen Link fort.`,
    es: `Se ha enviado un enlace para cambiar tu contrase\xf1a a tu direcci\xf3n de correo electr\xf3nico. Contin\xfaa el proceso de cambio de contrase\xf1a usando el enlace que has recibido.`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631} \u{628}\u{647} \u{622}\u{62F}\u{631}\u{633} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{634}\u{645}\u{627} \u{627}\u{631}\u{633}\u{627}\u{644} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{641}\u{631}\u{622}\u{6CC}\u{646}\u{62F} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631} \u{631}\u{627} \u{628}\u{627} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{627}\u{632} \u{644}\u{6CC}\u{646}\u{6A9}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{62F} \u{627}\u{62F}\u{627}\u{645}\u{647} \u{62F}\u{647}\u{6CC}\u{62F}.`,
    fil: `Isang link upang baguhin ang iyong password ay ipinadala sa iyong email address. Ipagpatuloy ang proseso ng pagbabago ng password gamit ang link na natanggap mo.`,
    fr: `Un lien pour changer votre mot de passe a \xe9t\xe9 envoy\xe9 \xe0 votre adresse e-mail. Poursuivez le processus de changement de mot de passe en utilisant le lien que vous avez re\xe7u.`,
    hi: `\u{905}\u{92A}\u{928}\u{93E} \u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} \u{92C}\u{926}\u{932}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{90F}\u{915} \u{932}\u{93F}\u{902}\u{915} \u{906}\u{92A}\u{915}\u{947} \u{908}\u{92E}\u{947}\u{932} \u{92A}\u{924}\u{947} \u{92A}\u{930} \u{92D}\u{947}\u{91C}\u{93E} \u{917}\u{92F}\u{93E} \u{939}\u{948}\u{964} \u{906}\u{92A}\u{915}\u{94B} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{932}\u{93F}\u{902}\u{915} \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{915}\u{947} \u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} \u{92C}\u{926}\u{932}\u{947}\u{902} \u{92A}\u{94D}\u{930}\u{915}\u{94D}\u{930}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E}\u{930}\u{940} \u{930}\u{916}\u{947}\u{902}\u{964}`,
    ht: `Yon lyen pou chanje modpas ou te voye nan adr\xe8s imel ou. Kontinye pwosesis la chanje modpas l\xe8 l s\xe8vi av\xe8k lyen ou te resevwa a.`,
    it: `Un link per cambiare la password \xe8 stato inviato al tuo indirizzo email. Continua il processo di modifica password usando il link che hai ricevuto.`,
    ja: `\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}\u{5909}\u{66F4}\u{306E}\u{30EA}\u{30F3}\u{30AF}\u{304C}\u{3042}\u{306A}\u{305F}\u{306E}\u{30E1}\u{30FC}\u{30EB}\u{30A2}\u{30C9}\u{30EC}\u{30B9}\u{306B}\u{9001}\u{4FE1}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}\u{53D7}\u{3051}\u{53D6}\u{3063}\u{305F}\u{30EA}\u{30F3}\u{30AF}\u{3092}\u{4F7F}\u{3063}\u{3066}\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}\u{5909}\u{66F4}\u{306E}\u{624B}\u{7D9A}\u{304D}\u{3092}\u{7D9A}\u{3051}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{BE44}\u{BC00}\u{BC88}\u{D638} \u{BCC0}\u{ACBD} \u{B9C1}\u{D06C}\u{AC00} \u{C774}\u{BA54}\u{C77C} \u{C8FC}\u{C18C}\u{B85C} \u{C804}\u{C1A1}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{BC1B}\u{C740} \u{B9C1}\u{D06C}\u{B97C} \u{C0AC}\u{C6A9}\u{D574} \u{BE44}\u{BC00}\u{BC88}\u{D638} \u{BCC0}\u{ACBD} \u{ACFC}\u{C815}\u{C744} \u{ACC4}\u{C18D}\u{D558}\u{C138}\u{C694}.`,
    mww: `Ib qhov txuas los hloov koj lo lus zais tau xa mus rau koj tus email chaw nyob. Txuas ntxiv cov txheej txheem hloov lo lus zais siv qhov txuas uas koj tau txais.`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{67E}\u{627}\u{633}\u{648}\u{631}\u{689} \u{628}\u{62F}\u{644}\u{648}\u{644}\u{648} \u{644}\u{6CC}\u{646}\u{6A9} \u{633}\u{62A}\u{627}\u{633}\u{648} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{62A}\u{647} \u{644}\u{6CC}\u{696}\u{644} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}. \u{62F} \u{67E}\u{627}\u{633}\u{648}\u{631}\u{689} \u{628}\u{62F}\u{644}\u{648}\u{644}\u{648} \u{67E}\u{631}\u{648}\u{633}\u{647} \u{62F} \u{647}\u{63A}\u{647} \u{644}\u{6CC}\u{646}\u{6A9} \u{67E}\u{647} \u{6A9}\u{627}\u{631}\u{648}\u{644}\u{648} \u{633}\u{631}\u{647} \u{62F}\u{648}\u{627}\u{645} \u{648}\u{631}\u{6A9}\u{693}\u{626} \u{686}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{645}\u{648} \u{6A9}\u{693}\u{6CC}.`,
    pt: `Um link para alterar sua senha foi enviado para seu endere\xe7o de e-mail. Continue o processo de mudan\xe7a de senha usando o link que voc\xea recebeu.`,
    'pt-pt': `Foi enviado um link para alterar a sua palavra-passe para o seu endere\xe7o de email. Continue o processo de altera\xe7\xe3o de palavra-passe usando o link que recebeu.`,
    ru: `\u{421}\u{441}\u{44B}\u{43B}\u{43A}\u{430} \u{434}\u{43B}\u{44F} \u{441}\u{43C}\u{435}\u{43D}\u{44B} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44F} \u{431}\u{44B}\u{43B}\u{430} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{430} \u{43D}\u{430} \u{432}\u{430}\u{448} \u{430}\u{434}\u{440}\u{435}\u{441} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{447}\u{442}\u{44B}. \u{41F}\u{440}\u{43E}\u{434}\u{43E}\u{43B}\u{436}\u{430}\u{439}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441} \u{441}\u{43C}\u{435}\u{43D}\u{44B} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44F}, \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{44F} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{43D}\u{443}\u{44E} \u{432}\u{430}\u{43C}\u{438} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443}.`,
    sm: `Ua auina atu se sootaga e sui ai lau uputatala i lau tuatusi imeli. Faaauau pea le faagasologa o le suia o le uputatala e faaaoga ai le sootaga ua e mauaina.`,
    so: `Xiriir lagu beddelo erayga sirta ah ayaa loo diray cinwaankaaga email-ka. Sii wad habka beddelka erayga sirta ah adigoo adeegsanaya xiriirka aad heshay.`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E40}\u{E1B}\u{E25}\u{E35}\u{E48}\u{E22}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E16}\u{E39}\u{E01}\u{E2A}\u{E48}\u{E07}\u{E44}\u{E1B}\u{E22}\u{E31}\u{E07}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E41}\u{E25}\u{E49}\u{E27} \u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E40}\u{E1B}\u{E25}\u{E35}\u{E48}\u{E22}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}\u{E42}\u{E14}\u{E22}\u{E43}\u{E0A}\u{E49}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6D2} \u{67E}\u{627}\u{633} \u{648}\u{631}\u{688} \u{62A}\u{628}\u{62F}\u{6CC}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{627} \u{644}\u{646}\u{6A9} \u{622}\u{67E} \u{6A9}\u{6D2} \u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633} \u{67E}\u{631} \u{628}\u{6BE}\u{6CC}\u{62C} \u{62F}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4} \u{67E}\u{627}\u{633} \u{648}\u{631}\u{688} \u{62A}\u{628}\u{62F}\u{6CC}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{627} \u{639}\u{645}\u{644} \u{627}\u{633} \u{644}\u{646}\u{6A9} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{62C}\u{627}\u{631}\u{6CC} \u{631}\u{6A9}\u{6BE}\u{6CC}\u{6BA} \u{62C}\u{648} \u{622}\u{67E} \u{6A9}\u{648} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED9}t li\xean k\u{1EBF}t \u{111}\u{1EC3} thay \u{111}\u{1ED5}i m\u{1EAD}t kh\u{1EA9}u c\u{1EE7}a b\u{1EA1}n \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c g\u{1EED}i \u{111}\u{1EBF}n \u{111}\u{1ECB}a ch\u{1EC9} email c\u{1EE7}a b\u{1EA1}n. Ti\u{1EBF}p t\u{1EE5}c qu\xe1 tr\xecnh thay \u{111}\u{1ED5}i m\u{1EAD}t kh\u{1EA9}u b\u{1EB1}ng li\xean k\u{1EBF}t b\u{1EA1}n \u{111}\xe3 nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c.`,
    'zh-hans': `\u{66F4}\u{6539}\u{5BC6}\u{7801}\u{7684}\u{94FE}\u{63A5}\u{5DF2}\u{53D1}\u{9001}\u{5230}\u{60A8}\u{7684}\u{90AE}\u{7BB1}\u{5730}\u{5740}\u{3002}\u{8BF7}\u{7EE7}\u{7EED}\u{4F7F}\u{7528}\u{60A8}\u{6536}\u{5230}\u{7684}\u{94FE}\u{63A5}\u{66F4}\u{6539}\u{5BC6}\u{7801}\u{3002}`,
    'zh-hant': `\u{5DF2}\u{767C}\u{9001}\u{5230}\u{60A8}\u{7684}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{5730}\u{5740}\u{FF0C}\u{6709}\u{66F4}\u{6539}\u{5BC6}\u{78BC}\u{7684}\u{9023}\u{7D50}\u{3002}\u{8ACB}\u{7E7C}\u{7E8C}\u{4F7F}\u{7528}\u{4F60}\u{6536}\u{5230}\u{7684}\u{9023}\u{7D50}\u{66F4}\u{6539}\u{5BC6}\u{78BC}\u{3002}`,
    en: `A link to change your password has been sent to your email address. Continue the change password process using the link you've received.`
};
const $b11db1b62d4a8f76$export$6ad4e1f26ee3fd98 = {
    ar: `\u{644}\u{62E}\u{635} \u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644}`,
    de: `Fasse diesen Rekord zusammen`,
    es: `Resume este registro`,
    fa: `\u{627}\u{6CC}\u{646} \u{631}\u{6A9}\u{648}\u{631}\u{62F} \u{631}\u{627} \u{62E}\u{644}\u{627}\u{635}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Ibuod ang talaang ito`,
    fr: `R\xe9sumez ce record`,
    hi: `\u{907}\u{938} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{915}\u{94B} \u{938}\u{902}\u{915}\u{94D}\u{937}\u{947}\u{92A} \u{92E}\u{947}\u{902} \u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Rezime dosye sa a`,
    it: `Riassumi questo record`,
    ja: `\u{3053}\u{306E}\u{8A18}\u{9332}\u{3092}\u{307E}\u{3068}\u{3081}\u{3066}\u{307F}\u{3066}`,
    ko: `\u{C774} \u{AE30}\u{B85D}\u{C744} \u{C694}\u{C57D}\u{D574} \u{C8FC}\u{C138}\u{C694}`,
    mww: `Sau cov ntaub ntawv no`,
    ps: `\u{62F}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{644}\u{646}\u{689}\u{6CC}\u{632} \u{6A9}\u{693}\u{626}`,
    pt: `Resuma este registro`,
    'pt-pt': `Resuma este registo`,
    ru: `\u{41A}\u{440}\u{430}\u{442}\u{43A}\u{43E} \u{438}\u{437}\u{43B}\u{43E}\u{436}\u{438}\u{442}\u{435} \u{44D}\u{442}\u{43E}\u{442} \u{440}\u{435}\u{43A}\u{43E}\u{440}\u{434}`,
    sm: `Otooto le faamaumauga lenei`,
    so: `Soo koob rikoodhkan`,
    th: `\u{E2A}\u{E23}\u{E38}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{627} \u{62E}\u{644}\u{627}\u{635}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\xf3m t\u{1EAF}t h\u{1ED3} s\u{1A1} n\xe0y`,
    'zh-hans': `\u{603B}\u{7ED3}\u{4E00}\u{4E0B}\u{8FD9}\u{4EFD}\u{8BB0}\u{5F55}`,
    'zh-hant': `\u{7E3D}\u{7D50}\u{9019}\u{4EFD}\u{7D00}\u{9304}`,
    en: `Summarize this record`
};
const $b11db1b62d4a8f76$export$170d4e08b9b91ae4 = {
    ar: `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{627}\u{644}\u{62E}\u{637}\u{648}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}\u{629}`,
    de: `Identifizieren Sie die n\xe4chsten Schritte`,
    es: `Identificar los siguientes pasos`,
    fa: `\u{634}\u{646}\u{627}\u{633}\u{627}\u{6CC}\u{6CC} \u{6AF}\u{627}\u{645} \u{647}\u{627}\u{6CC} \u{628}\u{639}\u{62F}\u{6CC}`,
    fil: `Tukuyin ang mga susunod na hakbang`,
    fr: `Identifier les prochaines \xe9tapes`,
    hi: `\u{905}\u{917}\u{932}\u{947} \u{91A}\u{930}\u{923}\u{94B}\u{902} \u{915}\u{940} \u{92A}\u{939}\u{91A}\u{93E}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Idantifye pwochen etap yo`,
    it: `Individuare i prossimi passi`,
    ja: `\u{6B21}\u{306E}\u{30B9}\u{30C6}\u{30C3}\u{30D7}\u{3092}\u{7279}\u{5B9A}\u{3059}\u{308B}`,
    ko: `\u{B2E4}\u{C74C} \u{B2E8}\u{ACC4} \u{D30C}\u{C545}`,
    mww: `Txheeb xyuas cov kauj ruam tom ntej`,
    ps: `\u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6CC} \u{6AB}\u{627}\u{645}\u{648}\u{646}\u{647} \u{648}\u{67E}\u{6CC}\u{698}\u{646}\u{626}`,
    pt: `Identifique os pr\xf3ximos passos`,
    'pt-pt': `Identificar os pr\xf3ximos passos`,
    ru: `\u{41E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{438}\u{442}\u{435} \u{441}\u{43B}\u{435}\u{434}\u{443}\u{44E}\u{449}\u{438}\u{435} \u{448}\u{430}\u{433}\u{438}`,
    sm: `Faailoa laasaga e sosoo ai`,
    so: `Aqoonso tallaabooyinka xiga`,
    th: `\u{E23}\u{E30}\u{E1A}\u{E38}\u{E02}\u{E31}\u{E49}\u{E19}\u{E15}\u{E2D}\u{E19}\u{E16}\u{E31}\u{E14}\u{E44}\u{E1B}`,
    ur: `\u{627}\u{6AF}\u{644}\u{6D2} \u{627}\u{642}\u{62F}\u{627}\u{645}\u{627}\u{62A} \u{6A9}\u{6CC} \u{646}\u{634}\u{627}\u{646}\u{62F}\u{6C1}\u{6CC} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xe1c \u{111}\u{1ECB}nh c\xe1c b\u{1B0}\u{1EDB}c ti\u{1EBF}p theo`,
    'zh-hans': `\u{786E}\u{5B9A}\u{4E0B}\u{4E00}\u{6B65}\u{884C}\u{52A8}`,
    'zh-hant': `\u{627E}\u{51FA}\u{4E0B}\u{4E00}\u{6B65}`,
    en: `Identify next steps`
};
const $b11db1b62d4a8f76$export$7aebbc760fcb6d39 = {
    ar: `\u{627}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{639}\u{644}\u{627}\u{645}\u{627}\u{62A} \u{62A}\u{62D}\u{630}\u{64A}\u{631} \u{623}\u{648} \u{642}\u{636}\u{627}\u{64A}\u{627} \u{639}\u{627}\u{62C}\u{644}\u{629}`,
    de: `Finde Warnsignale oder dringende Probleme`,
    es: `Encuentra se\xf1ales de alerta o problemas urgentes`,
    fa: `\u{646}\u{634}\u{627}\u{646}\u{647} \u{647}\u{627}\u{6CC} \u{647}\u{634}\u{62F}\u{627}\u{631}\u{62F}\u{647}\u{646}\u{62F}\u{647} \u{6CC}\u{627} \u{645}\u{633}\u{627}\u{626}\u{644} \u{641}\u{648}\u{631}\u{6CC} \u{631}\u{627} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Maghanap ng mga pulang bandila o mga kagyat na isyu`,
    fr: `Trouvez les signaux d\u{2019}alerte ou les probl\xe8mes urgents`,
    hi: `\u{932}\u{93E}\u{932} \u{91D}\u{902}\u{921}\u{947} \u{92F}\u{93E} \u{905}\u{924}\u{94D}\u{92F}\u{93E}\u{935}\u{936}\u{94D}\u{92F}\u{915} \u{938}\u{92E}\u{938}\u{94D}\u{92F}\u{93E}\u{90F}\u{902} \u{922}\u{942}\u{902}\u{922}\u{947}\u{902}`,
    ht: `Jwenn drapo wouj oswa pwobl\xe8m ijan`,
    it: `Individua segnali d'allarme o problemi urgenti`,
    ja: `\u{8D64}\u{4FE1}\u{53F7}\u{3084}\u{7DCA}\u{6025}\u{306E}\u{554F}\u{984C}\u{3092}\u{898B}\u{3064}\u{3051}\u{307E}\u{3057}\u{3087}\u{3046}`,
    ko: `\u{ACBD}\u{ACE0} \u{C2E0}\u{D638}\u{B098} \u{AE34}\u{AE09}\u{D55C} \u{BB38}\u{C81C}\u{B97C} \u{CC3E}\u{C544}\u{BCF4}\u{C138}\u{C694}`,
    mww: `Nrhiav chij liab lossis teeb meem ceev`,
    ps: `\u{633}\u{648}\u{631} \u{646}\u{69A}\u{6D0} \u{6CC}\u{627} \u{639}\u{627}\u{62C}\u{644}\u{6D0} \u{633}\u{62A}\u{648}\u{646}\u{632}\u{6D0} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{693}\u{626}`,
    pt: `Encontre sinais de alerta ou quest\xf5es urgentes`,
    'pt-pt': `Encontre sinais de alerta ou problemas urgentes`,
    ru: `\u{41D}\u{430}\u{439}\u{434}\u{438}\u{442}\u{435} \u{442}\u{440}\u{435}\u{432}\u{43E}\u{436}\u{43D}\u{44B}\u{435} \u{441}\u{438}\u{433}\u{43D}\u{430}\u{43B}\u{44B} \u{438}\u{43B}\u{438} \u{441}\u{440}\u{43E}\u{447}\u{43D}\u{44B}\u{435} \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{44B}`,
    sm: `Saili fu'a mumu po'o fa'afitauli faanatinati`,
    so: `Hel calan cas ama arrimo degdeg ah`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E18}\u{E07}\u{E2A}\u{E35}\u{E41}\u{E14}\u{E07}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E1B}\u{E31}\u{E0D}\u{E2B}\u{E32}\u{E40}\u{E23}\u{E48}\u{E07}\u{E14}\u{E48}\u{E27}\u{E19}`,
    ur: `\u{62E}\u{637}\u{631}\u{6D2} \u{6A9}\u{6CC} \u{62C}\u{6BE}\u{646}\u{688}\u{6CC}\u{627}\u{6BA} \u{6CC}\u{627} \u{641}\u{648}\u{631}\u{6CC} \u{645}\u{633}\u{627}\u{626}\u{644} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\xecm c\u{1EDD} \u{111}\u{1ECF} ho\u{1EB7}c v\u{1EA5}n \u{111}\u{1EC1} kh\u{1EA9}n c\u{1EA5}p`,
    'zh-hans': `\u{53D1}\u{73B0}\u{5371}\u{9669}\u{4FE1}\u{53F7}\u{6216}\u{7D27}\u{6025}\u{95EE}\u{9898}`,
    'zh-hant': `\u{627E}\u{51FA}\u{8B66}\u{8A0A}\u{6216}\u{7DCA}\u{6025}\u{554F}\u{984C}`,
    en: `Find red flags or urgent issues`
};
const $b11db1b62d4a8f76$export$7855d74a051318c3 = {
    ar: `\u{642}\u{627}\u{626}\u{645}\u{629} \u{628}\u{627}\u{644}\u{62A}\u{62F}\u{62E}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{631}\u{626}\u{64A}\u{633}\u{64A}\u{629} \u{648}\u{62A}\u{623}\u{62B}\u{64A}\u{631}\u{627}\u{62A}\u{647}\u{627}`,
    de: `Listen Sie wichtige Interventionen und deren Auswirkungen auf`,
    es: `Enumera las intervenciones clave y sus efectos`,
    fa: `\u{641}\u{647}\u{631}\u{633}\u{62A} \u{645}\u{62F}\u{627}\u{62E}\u{644}\u{627}\u{62A} \u{6A9}\u{644}\u{6CC}\u{62F}\u{6CC} \u{648} \u{62A}\u{623}\u{62B}\u{6CC}\u{631}\u{627}\u{62A} \u{622}\u{646} \u{647}\u{627}`,
    fil: `Ilista ang mga pangunahing interbensyon at ang kanilang mga epekto`,
    fr: `\xc9num\xe9rez les interventions cl\xe9s et leurs effets`,
    hi: `\u{92A}\u{94D}\u{930}\u{92E}\u{941}\u{916} \u{939}\u{938}\u{94D}\u{924}\u{915}\u{94D}\u{937}\u{947}\u{92A}\u{94B}\u{902} \u{914}\u{930} \u{909}\u{928}\u{915}\u{947} \u{92A}\u{94D}\u{930}\u{92D}\u{93E}\u{935}\u{94B}\u{902} \u{915}\u{940} \u{938}\u{942}\u{91A}\u{940} \u{92C}\u{928}\u{93E}\u{90F}\u{902}`,
    ht: `Lis ent\xe8vansyon kle yo ak ef\xe8 yo`,
    it: `Elencare gli interventi chiave e i loro effetti`,
    ja: `\u{4E3B}\u{8981}\u{306A}\u{4ECB}\u{5165}\u{7B56}\u{3068}\u{305D}\u{306E}\u{52B9}\u{679C}\u{3092}\u{30EA}\u{30B9}\u{30C8}`,
    ko: `\u{C8FC}\u{C694} \u{AC1C}\u{C785}\u{ACFC} \u{ADF8} \u{D6A8}\u{ACFC} \u{BAA9}\u{B85D}`,
    mww: `Sau cov kev cuam tshuam tseem ceeb thiab lawv cov teebmeem`,
    ps: `\u{645}\u{647}\u{645}\u{6D0} \u{645}\u{62F}\u{627}\u{62E}\u{644}\u{6D0} \u{627}\u{648} \u{62F} \u{647}\u{63A}\u{648}\u{6CC} \u{627}\u{63A}\u{6D0}\u{632}\u{6D0} \u{644}\u{6CC}\u{633}\u{62A} \u{6A9}\u{693}\u{626}`,
    pt: `Liste as principais interven\xe7\xf5es e seus efeitos`,
    'pt-pt': `Liste as principais interven\xe7\xf5es e os seus efeitos`,
    ru: `\u{421}\u{43F}\u{438}\u{441}\u{43E}\u{43A} \u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{432}\u{44B}\u{445} \u{432}\u{43C}\u{435}\u{448}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{441}\u{442}\u{432} \u{438} \u{438}\u{445} \u{44D}\u{444}\u{444}\u{435}\u{43A}\u{442}\u{43E}\u{432}`,
    sm: `Lisi o fa'alavelave fa'afuase'i ma o latou a'afiaga`,
    so: `Liiska faragelinta muhiimka ah iyo saameyntooda`,
    th: `\u{E41}\u{E2A}\u{E14}\u{E07}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E01}\u{E32}\u{E23}\u{E41}\u{E17}\u{E23}\u{E01}\u{E41}\u{E0B}\u{E07}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E4D}\u{E32}\u{E04}\u{E31}\u{E0D}\u{E41}\u{E25}\u{E30}\u{E1C}\u{E25}\u{E01}\u{E23}\u{E30}\u{E17}\u{E1A}`,
    ur: `\u{627}\u{6C1}\u{645} \u{645}\u{62F}\u{627}\u{62E}\u{644}\u{62A}\u{648}\u{6BA} \u{627}\u{648}\u{631} \u{627}\u{646} \u{6A9}\u{6D2} \u{627}\u{62B}\u{631}\u{627}\u{62A} \u{6A9}\u{6CC} \u{641}\u{6C1}\u{631}\u{633}\u{62A} \u{62F}\u{6CC}\u{6BA}`,
    vi: `Li\u{1EC7}t k\xea c\xe1c can thi\u{1EC7}p ch\xednh v\xe0 t\xe1c d\u{1EE5}ng c\u{1EE7}a ch\xfang`,
    'zh-hans': `\u{5217}\u{51FA}\u{5173}\u{952E}\u{5E72}\u{9884}\u{63AA}\u{65BD}\u{53CA}\u{5176}\u{6548}\u{679C}`,
    'zh-hant': `\u{5217}\u{51FA}\u{4E3B}\u{8981}\u{4ECB}\u{5165}\u{63AA}\u{65BD}\u{53CA}\u{5176}\u{5F71}\u{97FF}`,
    en: `List key interventions and their effects`
};
const $b11db1b62d4a8f76$export$d3e6e2f9776d6812 = {
    ar: `\u{62A}\u{62D}\u{644}\u{64A}\u{644} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{645}\u{648}\u{627}\u{631}\u{62F}`,
    de: `Analyse der Ressourcennutzung`,
    es: `Analizar la utilizaci\xf3n de recursos`,
    fa: `\u{62A}\u{62D}\u{644}\u{6CC}\u{644} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{627}\u{632} \u{645}\u{646}\u{627}\u{628}\u{639}`,
    fil: `Suriin ang paggamit ng mapagkukunan`,
    fr: `Analyser l\u{2019}utilisation des ressources`,
    hi: `\u{938}\u{902}\u{938}\u{93E}\u{927}\u{928} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{93E} \u{935}\u{93F}\u{936}\u{94D}\u{932}\u{947}\u{937}\u{923} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Analize itilizasyon resous yo`,
    it: `Analizza l'utilizzo delle risorse`,
    ja: `\u{8CC7}\u{6E90}\u{5229}\u{7528}\u{306E}\u{5206}\u{6790}`,
    ko: `\u{C790}\u{C6D0} \u{D65C}\u{C6A9} \u{BD84}\u{C11D}`,
    mww: `Txheeb xyuas kev siv cov peev txheej`,
    ps: `\u{62F} \u{633}\u{631}\u{686}\u{6CC}\u{646}\u{648} \u{6A9}\u{627}\u{631}\u{648}\u{646}\u{647} \u{62A}\u{62D}\u{644}\u{6CC}\u{644} \u{6A9}\u{693}\u{626}`,
    pt: `Analisar a utiliza\xe7\xe3o de recursos`,
    'pt-pt': `Analisar a utiliza\xe7\xe3o de recursos`,
    ru: `\u{410}\u{43D}\u{430}\u{43B}\u{438}\u{437} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{440}\u{435}\u{441}\u{443}\u{440}\u{441}\u{43E}\u{432}`,
    sm: `Iloilo le faaaogaina o punaoa`,
    so: `Falanqeeyo isticmaalka kheyraadka`,
    th: `\u{E27}\u{E34}\u{E40}\u{E04}\u{E23}\u{E32}\u{E30}\u{E2B}\u{E4C}\u{E01}\u{E32}\u{E23}\u{E43}\u{E0A}\u{E49}\u{E17}\u{E23}\u{E31}\u{E1E}\u{E22}\u{E32}\u{E01}\u{E23}`,
    ur: `\u{648}\u{633}\u{627}\u{626}\u{644} \u{6A9}\u{6D2} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{627} \u{62A}\u{62C}\u{632}\u{6CC}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ph\xe2n t\xedch vi\u{1EC7}c s\u{1EED} d\u{1EE5}ng t\xe0i nguy\xean`,
    'zh-hans': `\u{5206}\u{6790}\u{8D44}\u{6E90}\u{5229}\u{7528}\u{60C5}\u{51B5}`,
    'zh-hant': `\u{5206}\u{6790}\u{8CC7}\u{6E90}\u{5229}\u{7528}\u{7387}`,
    en: `Analyze resource utilization`
};
const $b11db1b62d4a8f76$export$7d76bfe38189f305 = {
    ar: `\u{627}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{62B}\u{63A}\u{631}\u{627}\u{62A} \u{623}\u{648} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{645}\u{641}\u{642}\u{648}\u{62F}\u{629}`,
    de: `Finde L\xfccken oder fehlende Informationen`,
    es: `Encuentra lagunas o informaci\xf3n que falta`,
    fa: `\u{62E}\u{644}\u{623}\u{647}\u{627} \u{6CC}\u{627} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{6AF}\u{645}\u{634}\u{62F}\u{647} \u{631}\u{627} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Maghanap ng mga puwang o nawawalang impormasyon`,
    fr: `Trouver des lacunes ou des informations manquantes`,
    hi: `\u{905}\u{902}\u{924}\u{930}\u{93E}\u{932} \u{92F}\u{93E} \u{905}\u{928}\u{941}\u{92A}\u{932}\u{92C}\u{94D}\u{927} \u{91C}\u{93E}\u{928}\u{915}\u{93E}\u{930}\u{940} \u{922}\u{942}\u{902}\u{922}\u{947}\u{902}`,
    ht: `Jwenn twou vid oswa enf\xf2masyon ki manke`,
    it: `Individua lacune o informazioni mancanti`,
    ja: `\u{60C5}\u{5831}\u{306E}\u{629C}\u{3051}\u{3084}\u{6B20}\u{843D}\u{3092}\u{898B}\u{3064}\u{3051}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{BE48}\u{D2C8}\u{C774}\u{B098} \u{B204}\u{B77D}\u{B41C} \u{C815}\u{BCF4}\u{B97C} \u{CC3E}\u{C544}\u{BCF4}\u{C138}\u{C694}`,
    mww: `Nrhiav qhov khoob lossis cov ntaub ntawv uas ploj lawm`,
    ps: `\u{62A}\u{634}\u{6D0} \u{6CC}\u{627} \u{648}\u{631}\u{6A9} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{693}\u{626}`,
    pt: `Encontre lacunas ou informa\xe7\xf5es faltantes`,
    'pt-pt': `Encontre lacunas ou informa\xe7\xf5es em falta`,
    ru: `\u{41D}\u{430}\u{439}\u{434}\u{438}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{431}\u{435}\u{43B}\u{44B} \u{438}\u{43B}\u{438} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{44E}\u{449}\u{443}\u{44E} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44E}`,
    sm: `Saili avanoa po o faamatalaga o loo misi`,
    so: `Hel meelaha bannaan ama macluumaad maqan`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E0A}\u{E48}\u{E2D}\u{E07}\u{E27}\u{E48}\u{E32}\u{E07}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E17}\u{E35}\u{E48}\u{E02}\u{E32}\u{E14}\u{E2B}\u{E32}\u{E22}\u{E44}\u{E1B}`,
    ur: `\u{62E}\u{627}\u{644}\u{6CC} \u{62C}\u{6AF}\u{6C1}\u{6CC}\u{6BA} \u{6CC}\u{627} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\xecm kho\u{1EA3}ng tr\u{1ED1}ng ho\u{1EB7}c th\xf4ng tin b\u{1ECB} thi\u{1EBF}u`,
    'zh-hans': `\u{67E5}\u{627E}\u{7F3A}\u{53E3}\u{6216}\u{7F3A}\u{5931}\u{4FE1}\u{606F}`,
    'zh-hant': `\u{5C0B}\u{627E}\u{7A7A}\u{767D}\u{6216}\u{7F3A}\u{5931}\u{8CC7}\u{8A0A}`,
    en: `Find gaps or missing information`
};
const $b11db1b62d4a8f76$export$4573cdd5f888d123 = {
    ar: `\u{62A}\u{62D}\u{642}\u{642} \u{645}\u{646} \u{627}\u{644}\u{645}\u{634}\u{627}\u{639}\u{631}/\u{627}\u{644}\u{631}\u{636}\u{627}`,
    de: `Pr\xfcfen Sie Stimmung/Zufriedenheit`,
    es: `Comprueba el sentimiento/satisfacci\xf3n`,
    fa: `\u{627}\u{62D}\u{633}\u{627}\u{633}\u{627}\u{62A} \u{648} \u{631}\u{636}\u{627}\u{6CC}\u{62A} \u{631}\u{627} \u{628}\u{631}\u{631}\u{633}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Suriin ang damdamin/kasiyahan`,
    fr: `V\xe9rifiez le sentiment/la satisfaction`,
    hi: `\u{92D}\u{93E}\u{935}\u{928}\u{93E}/\u{938}\u{902}\u{924}\u{941}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{940} \u{91C}\u{93E}\u{901}\u{91A} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Tcheke santiman / satisfaksyon`,
    it: `Controlla sentimento/soddisfazione`,
    ja: `\u{611F}\u{60C5}\u{3084}\u{6E80}\u{8DB3}\u{5EA6}\u{3092}\u{78BA}\u{8A8D}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{AC10}\u{C815}/\u{B9CC}\u{C871}\u{B3C4}\u{B97C} \u{D655}\u{C778}\u{D558}\u{C138}\u{C694}`,
    mww: `Xyuas kev xav / kev txaus siab`,
    ps: `\u{627}\u{62D}\u{633}\u{627}\u{633}\u{627}\u{62A}/\u{631}\u{636}\u{627}\u{6CC}\u{62A} \u{648}\u{6AB}\u{648}\u{631}\u{647}`,
    pt: `Verifique sentimento/satisfa\xe7\xe3o`,
    'pt-pt': `Verifica sentimento/satisfa\xe7\xe3o`,
    ru: `\u{41F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{44C}\u{442}\u{435} \u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43D}\u{438}\u{435}/\u{443}\u{434}\u{43E}\u{432}\u{43B}\u{435}\u{442}\u{432}\u{43E}\u{440}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Siaki lagona / faamalieina`,
    so: `Hubi dareenka/qanacsanaanta`,
    th: `\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}/\u{E04}\u{E27}\u{E32}\u{E21}\u{E1E}\u{E36}\u{E07}\u{E1E}\u{E2D}\u{E43}\u{E08}`,
    ur: `\u{62C}\u{630}\u{628}\u{627}\u{62A}/\u{627}\u{637}\u{645}\u{6CC}\u{646}\u{627}\u{646} \u{686}\u{6CC}\u{6A9} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ki\u{1EC3}m tra c\u{1EA3}m x\xfac/s\u{1EF1} h\xe0i l\xf2ng`,
    'zh-hans': `\u{68C0}\u{67E5}\u{60C5}\u{611F}/\u{6EE1}\u{610F}\u{5EA6}`,
    'zh-hant': `\u{6AA2}\u{67E5}\u{60C5}\u{7DD2}/\u{6EFF}\u{610F}\u{5EA6}`,
    en: `Check sentiment/satisfaction`
};
const $b11db1b62d4a8f76$export$36e250b70ea85db6 = {
    ar: `\u{642}\u{64A}\u{645} \u{62A}\u{642}\u{62F}\u{645} \u{627}\u{644}\u{639}\u{645}\u{64A}\u{644}`,
    de: `Bewerten Sie den Fortschritt des Kunden`,
    es: `Eval\xfaa el progreso del cliente`,
    fa: `\u{67E}\u{6CC}\u{634}\u{631}\u{641}\u{62A} \u{645}\u{634}\u{62A}\u{631}\u{6CC} \u{631}\u{627} \u{627}\u{631}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Suriin ang pag-unlad ng kliyente`,
    fr: `\xc9valuer les progr\xe8s du client`,
    hi: `\u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915} \u{915}\u{940} \u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{915}\u{93E} \u{92E}\u{942}\u{932}\u{94D}\u{92F}\u{93E}\u{902}\u{915}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Evalye pwogr\xe8 kliyan an`,
    it: `Valuta i progressi del cliente`,
    ja: `\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}\u{306E}\u{9032}\u{6357}\u{3092}\u{8A55}\u{4FA1}\u{3059}\u{308B}`,
    ko: `\u{B0B4}\u{B2F4}\u{C790}\u{C758} \u{C9C4}\u{D589} \u{C0C1}\u{D669}\u{C744} \u{D3C9}\u{AC00}\u{D558}\u{C138}\u{C694}`,
    mww: `Txheeb xyuas tus neeg tau txais kev pab`,
    ps: `\u{62F} \u{645}\u{631}\u{627}\u{62C}\u{639} \u{67E}\u{631}\u{645}\u{62E}\u{62A}\u{6AB} \u{627}\u{631}\u{632}\u{648}\u{646}\u{647}`,
    pt: `Avalie o progresso do cliente`,
    'pt-pt': `Avalie o progresso do cliente`,
    ru: `\u{41E}\u{446}\u{435}\u{43D}\u{438}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{433}\u{440}\u{435}\u{441}\u{441} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}`,
    sm: `Iloilo le alualu i luma o le tagata fa'atau`,
    so: `Qiimee horumarka macmiilka`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E40}\u{E21}\u{E34}\u{E19}\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E37}\u{E1A}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E02}\u{E2D}\u{E07}\u{E25}\u{E39}\u{E01}\u{E04}\u{E49}\u{E32}`,
    ur: `\u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679} \u{6A9}\u{6CC} \u{67E}\u{6CC}\u{634} \u{631}\u{641}\u{62A} \u{6A9}\u{627} \u{62C}\u{627}\u{626}\u{632}\u{6C1} \u{644}\u{6CC}\u{6BA}`,
    vi: `\u{110}\xe1nh gi\xe1 s\u{1EF1} ti\u{1EBF}n b\u{1ED9} c\u{1EE7}a kh\xe1ch h\xe0ng`,
    'zh-hans': `\u{8BC4}\u{4F30}\u{5BA2}\u{6237}\u{7684}\u{8FDB}\u{5C55}\u{60C5}\u{51B5}`,
    'zh-hant': `\u{8A55}\u{4F30}\u{5BA2}\u{6236}\u{7684}\u{9032}\u{5C55}`,
    en: `Evaluate the client's progress`
};
const $b11db1b62d4a8f76$export$d941f7fe21e3e76c = {
    ar: `\u{62A}\u{633}\u{644}\u{64A}\u{637} \u{627}\u{644}\u{636}\u{648}\u{621} \u{639}\u{644}\u{649} \u{642}\u{635}\u{635} \u{627}\u{644}\u{646}\u{62C}\u{627}\u{62D}`,
    de: `Erfolgsgeschichten hervorheben`,
    es: `Destaca historias de \xe9xito`,
    fa: `\u{62F}\u{627}\u{633}\u{62A}\u{627}\u{646} \u{647}\u{627}\u{6CC} \u{645}\u{648}\u{641}\u{642}\u{6CC}\u{62A} \u{631}\u{627} \u{628}\u{631}\u{62C}\u{633}\u{62A}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `I-highlight ang mga kwento ng tagumpay`,
    fr: `Mettez en avant les histoires de r\xe9ussite`,
    hi: `\u{938}\u{92B}\u{932}\u{924}\u{93E} \u{915}\u{940} \u{915}\u{939}\u{93E}\u{928}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{939}\u{93E}\u{907}\u{932}\u{93E}\u{907}\u{91F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Mete aksan sou istwa siks\xe8`,
    it: `Metti in evidenza le storie di successo`,
    ja: `\u{6210}\u{529F}\u{4E8B}\u{4F8B}\u{3092}\u{7D39}\u{4ECB}\u{3057}\u{307E}\u{3059}`,
    ko: `\u{C131}\u{ACF5} \u{C0AC}\u{B840} \u{D558}\u{C774}\u{B77C}\u{C774}\u{D2B8}`,
    mww: `Qhia txog cov dab neeg ua tiav`,
    ps: `\u{62F} \u{628}\u{631}\u{6CC}\u{627} \u{6A9}\u{6CC}\u{633}\u{6D0} \u{631}\u{648}\u{69A}\u{627}\u{646}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Destaque hist\xf3rias de sucesso`,
    'pt-pt': `Destaque hist\xf3rias de sucesso`,
    ru: `\u{412}\u{44B}\u{434}\u{435}\u{43B}\u{44F}\u{439}\u{442}\u{435} \u{438}\u{441}\u{442}\u{43E}\u{440}\u{438}\u{438} \u{443}\u{441}\u{43F}\u{435}\u{445}\u{430}`,
    sm: `Fa'ailoa tala manuia`,
    so: `Sheekooyinka guusha ee muhiimka ah`,
    th: `\u{E40}\u{E19}\u{E49}\u{E19}\u{E40}\u{E23}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E23}\u{E32}\u{E27}\u{E04}\u{E27}\u{E32}\u{E21}\u{E2A}\u{E4D}\u{E32}\u{E40}\u{E23}\u{E47}\u{E08}`,
    ur: `\u{6A9}\u{627}\u{645}\u{6CC}\u{627}\u{628}\u{6CC} \u{6A9}\u{6CC} \u{6A9}\u{6C1}\u{627}\u{646}\u{6CC}\u{627}\u{6BA} \u{646}\u{645}\u{627}\u{6CC}\u{627}\u{6BA} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `L\xe0m n\u{1ED5}i b\u{1EAD}t nh\u{1EEF}ng c\xe2u chuy\u{1EC7}n th\xe0nh c\xf4ng`,
    'zh-hans': `\u{7A81}\u{51FA}\u{6210}\u{529F}\u{6848}\u{4F8B}`,
    'zh-hant': `\u{91CD}\u{9EDE}\u{4ECB}\u{7D39}\u{6210}\u{529F}\u{6848}\u{4F8B}`,
    en: `Highlight success stories`
};
const $b11db1b62d4a8f76$export$2beae1cfd23206a = {
    ar: `\u{62A}\u{62D}\u{642}\u{642} \u{645}\u{646} \u{643}\u{644} \u{645}\u{627} \u{64A}\u{646}\u{637}\u{628}\u{642}`,
    de: `\xdcberpr\xfcfen Sie alles, was gelten`,
    es: `Comprueba todo lo que se aplica`,
    fa: `\u{647}\u{645}\u{647} \u{627}\u{6CC}\u{646} \u{645}\u{648}\u{627}\u{631}\u{62F} \u{631}\u{627} \u{628}\u{631}\u{631}\u{633}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Suriin ang lahat ng naaangkop`,
    fr: `V\xe9rifiez tout ce qui s\u{2019}applique`,
    hi: `\u{932}\u{93E}\u{917}\u{942} \u{939}\u{94B}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{938}\u{92D}\u{940} \u{915}\u{940} \u{91C}\u{93E}\u{901}\u{91A} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Tcheke tout sa ki aplike`,
    it: `Controlla tutto ci\xf2 che si applica`,
    ja: `\u{3059}\u{3079}\u{3066}\u{306E}\u{9069}\u{7528}\u{60C5}\u{5831}\u{3092}\u{78BA}\u{8A8D}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{BAA8}\u{B4E0} \u{C9C0}\u{C6D0}\u{C0AC}\u{D56D}\u{C744} \u{D655}\u{C778}\u{D574} \u{BCF4}\u{C138}\u{C694}`,
    mww: `Xyuas txhua yam uas siv tau`,
    ps: `\u{67C}\u{648}\u{644} \u{647}\u{63A}\u{647} \u{685}\u{647} \u{648}\u{6AB}\u{648}\u{631}\u{647} \u{686}\u{6D0} \u{62A}\u{637}\u{628}\u{6CC}\u{642} \u{6A9}\u{6CC}\u{696}\u{6CC}`,
    pt: `Verifique tudo que se aplica`,
    'pt-pt': `Verifique tudo o que se aplica`,
    ru: `\u{41F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{44C}\u{442}\u{435} \u{432}\u{441}\u{451}, \u{447}\u{442}\u{43E} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{43C}\u{43E}`,
    sm: `Siaki mea uma e faatatau i ai`,
    so: `Hubi dhammaan kuwa khuseeya`,
    th: `\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{627}\u{646} \u{633}\u{628} \u{686}\u{6CC}\u{632}\u{648}\u{6BA} \u{6A9}\u{648} \u{686}\u{6CC}\u{6A9} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{62C}\u{648} \u{644}\u{627}\u{6AF}\u{648} \u{6C1}\u{648}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `Ki\u{1EC3}m tra t\u{1EA5}t c\u{1EA3} nh\u{1EEF}ng g\xec \xe1p d\u{1EE5}ng`,
    'zh-hans': `\u{67E5}\u{770B}\u{6240}\u{6709}\u{76F8}\u{5173}\u{5185}\u{5BB9}`,
    'zh-hant': `\u{8ACB}\u{6AA2}\u{67E5}\u{6240}\u{6709}\u{9069}\u{7528}\u{8CC7}\u{8A0A}`,
    en: `Check all that apply`
};
const $b11db1b62d4a8f76$export$80b830b9f3f50b1c = {
    ar: `\u{62A}\u{62D}\u{642}\u{642} \u{645}\u{646} \u{628}\u{631}\u{64A}\u{62F}\u{643} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{644}\u{644}\u{62E}\u{637}\u{648}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}\u{629}.`,
    de: `\xdcberpr\xfcfen Sie Ihre E-Mail f\xfcr die n\xe4chsten Schritte.`,
    es: `Consulta tu correo electr\xf3nico para ver los siguientes pasos.`,
    fa: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{62E}\u{648}\u{62F} \u{631}\u{627} \u{628}\u{631}\u{627}\u{6CC} \u{6AF}\u{627}\u{645} \u{647}\u{627}\u{6CC} \u{628}\u{639}\u{62F}\u{6CC} \u{628}\u{631}\u{631}\u{633}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Suriin ang iyong email para sa mga susunod na hakbang.`,
    fr: `Consultez vos e-mails pour conna\xeetre les prochaines \xe9tapes.`,
    hi: `\u{905}\u{917}\u{932}\u{947} \u{91A}\u{930}\u{923}\u{94B}\u{902} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{92A}\u{928}\u{93E} \u{908}\u{92E}\u{947}\u{932} \u{91C}\u{93E}\u{902}\u{91A}\u{947}\u{902}\u{964}`,
    ht: `Tcheke im\xe8l ou pou pwochen etap yo.`,
    it: `Controlla la tua email per i prossimi passi.`,
    ja: `\u{6B21}\u{306E}\u{30B9}\u{30C6}\u{30C3}\u{30D7}\u{306F}\u{30E1}\u{30FC}\u{30EB}\u{3067}\u{78BA}\u{8A8D}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{B2E4}\u{C74C} \u{B2E8}\u{ACC4}\u{B294} \u{C774}\u{BA54}\u{C77C}\u{C744} \u{D655}\u{C778}\u{D558}\u{C138}\u{C694}.`,
    mww: `Tshawb xyuas koj tus email rau cov kauj ruam tom ntej.`,
    ps: `\u{62F} \u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6CC} \u{6AB}\u{627}\u{645}\u{648}\u{646}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62E}\u{67E}\u{644} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{648}\u{6AB}\u{648}\u{631}\u{647}.`,
    pt: `Confira seu e-mail para os pr\xf3ximos passos.`,
    'pt-pt': `Verifique o seu email para os pr\xf3ximos passos.`,
    ru: `\u{41F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{44C}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{44E} \u{43F}\u{43E}\u{447}\u{442}\u{443} \u{434}\u{43B}\u{44F} \u{434}\u{430}\u{43B}\u{44C}\u{43D}\u{435}\u{439}\u{448}\u{438}\u{445} \u{448}\u{430}\u{433}\u{43E}\u{432}.`,
    sm: `Siaki lau imeli mo laasaga e sosoo ai.`,
    so: `Hubi email-kaaga si aad u aragto tallaabooyinka xiga.`,
    th: `\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E02}\u{E31}\u{E49}\u{E19}\u{E15}\u{E2D}\u{E19}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}`,
    ur: `\u{627}\u{6AF}\u{644}\u{6D2} \u{627}\u{642}\u{62F}\u{627}\u{645}\u{627}\u{62A} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{67E}\u{646}\u{627} \u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{686}\u{6CC}\u{6A9} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Ki\u{1EC3}m tra email c\u{1EE7}a b\u{1EA1}n \u{111}\u{1EC3} bi\u{1EBF}t c\xe1c b\u{1B0}\u{1EDB}c ti\u{1EBF}p theo.`,
    'zh-hans': `\u{8BF7}\u{67E5}\u{770B}\u{60A8}\u{7684}\u{90AE}\u{7BB1}\u{FF0C}\u{4E86}\u{89E3}\u{4E0B}\u{4E00}\u{6B65}\u{3002}`,
    'zh-hant': `\u{8ACB}\u{67E5}\u{770B}\u{60A8}\u{7684}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{4EE5}\u{4E86}\u{89E3}\u{4E0B}\u{4E00}\u{6B65}\u{3002}`,
    en: `Check your email for next steps.`
};
const $b11db1b62d4a8f76$export$71ce3894269b4f63 = {
    ar: (email)=>$b11db1b62d4a8f76$var$html`لم تستلم بريدا إلكترونيا؟ ابحث عن <strong>${email}</strong> في رسائل البريد المزعج.`,
    de: (email)=>$b11db1b62d4a8f76$var$html`Keine E-Mail erhalten? Suche in deinem Spam nach <strong>${email}</strong> .`,
    es: (email)=>$b11db1b62d4a8f76$var$html`¿No recibiste ningún correo? Busca <strong>${email}</strong> en tu spam.`,
    fa: (email)=>$b11db1b62d4a8f76$var$html`ایمیلی دریافت نکردی؟ در اسپم خود <strong>${email}</strong> را جستجو کنید.`,
    fil: (email)=>$b11db1b62d4a8f76$var$html`Hindi ka ba nakatanggap ng email? Hanapin ang <strong>${email}</strong> sa iyong spam.`,
    fr: (email)=>$b11db1b62d4a8f76$var$html`Vous n’avez pas reçu d’e-mail ? Cherchez <strong>${email}</strong> dans votre spam.`,
    hi: (email)=>$b11db1b62d4a8f76$var$html`कोई ईमेल प्राप्त नहीं हुआ? अपने स्पैम में <strong>${email}</strong> खोजें।`,
    ht: (email)=>$b11db1b62d4a8f76$var$html`Pa t 'resevwa yon imèl? Rechèch <strong>${email}</strong> nan Spam ou`,
    it: (email)=>$b11db1b62d4a8f76$var$html`Non hai ricevuto un'email? Cerca <strong>${email}</strong> nel tuo spam.`,
    ja: (email)=>$b11db1b62d4a8f76$var$html`メールが届かなかったのですか?迷路メールで「 <strong>${email}</strong> 」を検索してください。`,
    ko: (email)=>$b11db1b62d4a8f76$var$html`이메일을 못 받았나요? 스팸에서 <strong>${email}</strong> 를 검색해 보세요.`,
    mww: (email)=>$b11db1b62d4a8f76$var$html`Tsis tau txais email? Tshawb rau <strong>${email}</strong> hauv koj spam.`,
    ps: (email)=>$b11db1b62d4a8f76$var$html`ایمیل دې نه دی ترلاسه کړی؟ په خپل سپیم کې <strong>${email}</strong> لټون وکړئ.`,
    pt: (email)=>$b11db1b62d4a8f76$var$html`Não recebeu nenhum e-mail? Procure <strong>${email}</strong> no seu spam.`,
    'pt-pt': (email)=>$b11db1b62d4a8f76$var$html`Não recebeste email? Procure <strong>${email}</strong> no seu spam.`,
    ru: (email)=>$b11db1b62d4a8f76$var$html`Не получили письмо? Ищите <strong>${email}</strong> в спам.`,
    sm: (email)=>$b11db1b62d4a8f76$var$html`E te le'i mauaina se imeli? Saili mo <strong>${email}</strong> i lau spam.`,
    so: (email)=>$b11db1b62d4a8f76$var$html`Ma helin email? Ka raadi <strong>${email}</strong> spam-kaaga.`,
    th: (email)=>$b11db1b62d4a8f76$var$html`ไม่ได้รับอีเมลใช่ไหม ค้นหา <strong>${email}</strong> ในสแปมของคุณ`,
    ur: (email)=>$b11db1b62d4a8f76$var$html`کیا آپ کو ای میل موصول نہیں ہوئی؟ اپنے اسپیم میں <strong>${email}</strong> تلاش کریں۔`,
    vi: (email)=>$b11db1b62d4a8f76$var$html`Bạn không nhận được email? Tìm kiếm <strong>${email}</strong> trong thư rác của bạn.`,
    'zh-hans': (email)=>$b11db1b62d4a8f76$var$html`没收到邮件？在垃圾邮件中搜索“ <strong>${email}</strong> ”。`,
    'zh-hant': (email)=>$b11db1b62d4a8f76$var$html`沒收到電子郵件嗎？在垃圾郵件中搜尋 <strong>${email}</strong> 。`,
    en: (email)=>$b11db1b62d4a8f76$var$html`Didn't receive an email? Search for <strong>${email}</strong> in your spam.`
};
const $b11db1b62d4a8f76$export$3d47969f22871c3a = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}`,
    de: `W\xe4hle eine Aktivit\xe4t`,
    es: `Elige la actividad`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Pumili ng aktibidad`,
    fr: `Choisir l\u{2019}activit\xe9`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi aktivite`,
    it: `Scegli l'attivit\xe0`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{9078}\u{3073}\u{307E}\u{3057}\u{3087}\u{3046}`,
    ko: `\u{D65C}\u{B3D9}\u{C744} \u{C120}\u{D0DD}\u{D558}\u{C138}\u{C694}`,
    mww: `Xaiv kev ua si`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Escolha atividade`,
    'pt-pt': `Escolha atividade`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{437}\u{430}\u{43D}\u{44F}\u{442}\u{438}\u{435}`,
    sm: `Filifili gaoioiga`,
    so: `Dooro hawlaha`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{9009}\u{62E9}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{9078}\u{64C7}\u{6D3B}\u{52D5}`,
    en: `Choose activity`
};
const $b11db1b62d4a8f76$export$363d9660a18487e1 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{646}\u{648}\u{639} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}`,
    de: `W\xe4hlen Sie den Aktivit\xe4tstyp`,
    es: `Elige el tipo de actividad`,
    fa: `\u{646}\u{648}\u{639} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Pumili ng uri ng aktibidad`,
    fr: `Choisir le type d\u{2019}activit\xe9`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{94D}\u{930}\u{915}\u{93E}\u{930} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi kalite aktivite`,
    it: `Scegli il tipo di attivit\xe0`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{30BF}\u{30A4}\u{30D7}\u{3092}\u{9078}\u{3076}`,
    ko: `\u{D65C}\u{B3D9} \u{C720}\u{D615} \u{C120}\u{D0DD}`,
    mww: `Xaiv hom kev ua si`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{689}\u{648}\u{644} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Escolha o tipo de atividade`,
    'pt-pt': `Escolha o tipo de atividade`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{442}\u{438}\u{43F} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Filifili le ituaiga o gaoioiga`,
    so: `Dooro nooca hawlgalka`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6CC} \u{642}\u{633}\u{645} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n lo\u{1EA1}i ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{9009}\u{62E9}\u{6D3B}\u{52A8}\u{7C7B}\u{578B}`,
    'zh-hant': `\u{9078}\u{64C7}\u{6D3B}\u{52D5}\u{985E}\u{578B}`,
    en: `Choose activity type`
};
const $b11db1b62d4a8f76$export$f56cee0972c07638 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{645}\u{648}\u{638}\u{641}`,
    de: `W\xe4hle den Zugewiesenen`,
    es: `Elegir asignado`,
    fa: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{645}\u{623}\u{645}\u{648}\u{631}`,
    fil: `Piliin ang tagapag-atas`,
    fr: `Choisir le destinataire`,
    hi: `\u{905}\u{938}\u{93E}\u{907}\u{928}\u{940} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi asiyen`,
    it: `Scegli l'assegnato`,
    ja: `\u{5272}\u{308A}\u{5F53}\u{3066}\u{8005}\u{3092}\u{9078}\u{3076}`,
    ko: `\u{D560}\u{B2F9}\u{C790} \u{C120}\u{D0DD}`,
    mww: `Xaiv tus neeg ua hauj lwm`,
    ps: `\u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Escolha o designado`,
    'pt-pt': `Escolher o cedente`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{43F}\u{440}\u{430}\u{432}\u{43E}\u{43E}\u{431}\u{43B}\u{430}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F}`,
    sm: `Filifili le tagata ua tofia`,
    so: `Dooro qofka la siiyay`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E1C}\u{E39}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}`,
    ur: `assignee \u{6A9}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n ng\u{1B0}\u{1EDD}i \u{111}\u{1B0}\u{1EE3}c giao`,
    'zh-hans': `\u{9009}\u{62E9}\u{53D7}\u{8BA9}\u{4EBA}`,
    'zh-hant': `\u{9078}\u{64C7}\u{53D7}\u{8B93}\u{4EBA}`,
    en: `Choose assignee`
};
const $b11db1b62d4a8f76$export$adc83afbd0334463 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{645}\u{644}\u{62D}\u{642}\u{627}\u{62A}`,
    de: `W\xe4hle Anh\xe4nge`,
    es: `Elegir accesorios`,
    fa: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{636}\u{645}\u{6CC}\u{645}\u{647} \u{647}\u{627}`,
    fil: `Pumili ng mga attachment`,
    fr: `Choisir des pi\xe8ces jointes`,
    hi: `\u{905}\u{928}\u{941}\u{932}\u{917}\u{94D}\u{928}\u{915} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi atachman`,
    it: `Scegli gli allegati`,
    ja: `\u{6DFB}\u{4ED8}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{9078}\u{3076}`,
    ko: `\u{CCA8}\u{BD80} \u{C790}\u{B8CC} \u{C120}\u{D0DD}`,
    mww: `Xaiv cov ntawv txuas`,
    ps: `\u{636}\u{645}\u{6CC}\u{645}\u{6D0} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Escolha anexos`,
    'pt-pt': `Escolha anexos`,
    ru: `\u{412}\u{44B}\u{431}\u{438}\u{440}\u{430}\u{439}\u{442}\u{435} \u{43F}\u{440}\u{438}\u{43A}\u{440}\u{435}\u{43F}\u{43B}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Filifili mea fa'apipi'i`,
    so: `Dooro lifaaqyo`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E41}\u{E19}\u{E1A}`,
    ur: `\u{627}\u{679}\u{6CC}\u{686}\u{645}\u{646}\u{679}\u{633} \u{6A9}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n t\u{1EC7}p \u{111}\xednh k\xe8m`,
    'zh-hans': `\u{9009}\u{62E9}\u{9644}\u{4EF6}`,
    'zh-hant': `\u{9078}\u{64C7}\u{9644}\u{4EF6}`,
    en: `Choose attachments`
};
const $b11db1b62d4a8f76$export$fa932f10b592a16 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{645}\u{628}\u{62F}\u{639}`,
    de: `W\xe4hle den Ersteller`,
    es: `Elige creador`,
    fa: `\u{62E}\u{627}\u{644}\u{642} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Piliin ang tagalikha`,
    fr: `Choisir le cr\xe9ateur`,
    hi: `\u{915}\u{94D}\u{930}\u{93F}\u{90F}\u{91F}\u{930} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi kreyat\xe8`,
    it: `Scegli creatore`,
    ja: `\u{30AF}\u{30EA}\u{30A8}\u{30A4}\u{30BF}\u{30FC}\u{3092}\u{9078}\u{3076}`,
    ko: `\u{CC3D}\u{C791}\u{C790}\u{B97C} \u{C120}\u{D0DD}\u{D558}\u{C138}\u{C694}`,
    mww: `Xaiv tus tsim`,
    ps: `\u{62E}\u{627}\u{644}\u{642} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Escolha criador`,
    'pt-pt': `Escolher criador`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F}`,
    sm: `Filifili le foafoa`,
    so: `Dooro abuuraha`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E04}\u{E23}\u{E35}\u{E40}\u{E2D}\u{E40}\u{E15}\u{E2D}\u{E23}\u{E4C}`,
    ur: `\u{62E}\u{627}\u{644}\u{642} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n ng\u{1B0}\u{1EDD}i s\xe1ng t\u{1EA1}o`,
    'zh-hans': `\u{9009}\u{62E9}\u{521B}\u{4F5C}\u{8005}`,
    'zh-hant': `\u{9078}\u{64C7}\u{5275}\u{4F5C}\u{8005}`,
    en: `Choose creator`
};
const $b11db1b62d4a8f76$export$2ad44f7b3aea488a = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{623}\u{64A}\u{646} \u{62A}\u{631}\u{633}\u{644}`,
    de: `W\xe4hle, wohin du schicken m\xf6chtest`,
    es: `Elige d\xf3nde enviar`,
    fa: `\u{645}\u{62D}\u{644} \u{627}\u{631}\u{633}\u{627}\u{644} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Piliin kung saan ipapadala`,
    fr: `Choisissez o\xf9 envoyer`,
    hi: `\u{91A}\u{941}\u{928}\u{947}\u{902} \u{915}\u{93F} \u{915}\u{939}\u{93E}\u{902} \u{92D}\u{947}\u{91C}\u{928}\u{93E} \u{939}\u{948}`,
    ht: `Chwazi ki kote yo voye`,
    it: `Scegli dove inviare`,
    ja: `\u{9001}\u{308B}\u{5834}\u{6240}\u{3092}\u{9078}\u{3079}\u{307E}\u{3059}`,
    ko: `\u{C5B4}\u{B514}\u{B85C} \u{BCF4}\u{B0B4}\u{C57C} \u{D560}\u{C9C0} \u{C120}\u{D0DD}\u{D558}\u{C138}\u{C694}`,
    mww: `Xaiv qhov twg xa`,
    ps: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626} \u{686}\u{6D0} \u{686}\u{6CC}\u{631}\u{62A}\u{647} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{644} \u{634}\u{626}`,
    pt: `Escolha para onde enviar`,
    'pt-pt': `Escolha para onde enviar`,
    ru: `\u{412}\u{44B}\u{431}\u{438}\u{440}\u{430}\u{439}\u{442}\u{435}, \u{43A}\u{443}\u{434}\u{430} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{44F}\u{442}\u{44C}`,
    sm: `Filifili le mea e auina atu ai`,
    so: `Dooro meesha aad dirto`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E2A}\u{E48}\u{E07}`,
    ur: `\u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{6A9}\u{6C1} \u{6A9}\u{6C1}\u{627}\u{6BA} \u{628}\u{6BE}\u{6CC}\u{62C}\u{646}\u{627} \u{6C1}\u{6D2}`,
    vi: `Ch\u{1ECD}n n\u{1A1}i g\u{1EED}i`,
    'zh-hans': `\u{9009}\u{62E9}\u{53D1}\u{9001}\u{5730}\u{5740}`,
    'zh-hant': `\u{9078}\u{64C7}\u{5BC4}\u{5F80}\u{54EA}\u{88E1}`,
    en: `Choose where to send`
};
const $b11db1b62d4a8f76$export$88c2845785c80e49 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645} \u{627}\u{644}\u{645}\u{630}\u{643}\u{648}\u{631}`,
    de: `W\xe4hlen Sie den genannten Nutzer aus`,
    es: `Elige el usuario mencionado`,
    fa: `\u{6A9}\u{627}\u{631}\u{628}\u{631} \u{645}\u{630}\u{6A9}\u{648}\u{631} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Piliin ang nabanggit na tagagamit`,
    fr: `Choisissez l\u{2019}utilisateur mentionn\xe9`,
    hi: `\u{909}\u{932}\u{94D}\u{932}\u{93F}\u{916}\u{93F}\u{924} \u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi mansyone itilizat\xe8`,
    it: `Scegli l'utente menzionato`,
    ja: `\u{8A00}\u{53CA}\u{3055}\u{308C}\u{305F}\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{3092}\u{9078}\u{629E}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{C5B8}\u{AE09}\u{B41C} \u{C0AC}\u{C6A9}\u{C790}\u{B97C} \u{C120}\u{D0DD}\u{D558}\u{C138}\u{C694}`,
    mww: `Xaiv hais tus neeg siv`,
    ps: `\u{6CC}\u{627}\u{62F} \u{634}\u{648}\u{6CC} \u{6A9}\u{627}\u{631}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{648}\u{67C}\u{627}\u{6A9}\u{626}`,
    pt: `Escolha o usu\xe1rio mencionado`,
    'pt-pt': `Escolha o utilizador mencionado`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{443}\u{43F}\u{43E}\u{43C}\u{44F}\u{43D}\u{443}\u{442}\u{43E}\u{433}\u{43E} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F}`,
    sm: `Filifili tagata faaaoga ua ta'ua`,
    so: `Dooro isticmaalaha la xusay`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E17}\u{E35}\u{E48}\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}`,
    ur: `\u{645}\u{630}\u{6A9}\u{648}\u{631}\u{6C1} \u{635}\u{627}\u{631}\u{641} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n ng\u{1B0}\u{1EDD}i d\xf9ng \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EC1} c\u{1EAD}p`,
    'zh-hans': `\u{9009}\u{62E9}\u{88AB}\u{63D0}\u{53CA}\u{7684}\u{7528}\u{6237}`,
    'zh-hant': `\u{9078}\u{64C7}\u{88AB}\u{63D0}\u{53CA}\u{7684}\u{4F7F}\u{7528}\u{8005}`,
    en: `Choose mentioned user`
};
const $b11db1b62d4a8f76$export$d58c1dcaf781d61 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639}`,
    de: `Projekt ausw\xe4hlen`,
    es: `Elige proyecto`,
    fa: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{67E}\u{631}\u{648}\u{698}\u{647}`,
    fil: `Piliin ang proyekto`,
    fr: `Choisir le projet`,
    hi: `\u{92A}\u{94D}\u{930}\u{94B}\u{91C}\u{947}\u{915}\u{94D}\u{91F} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi pwoj\xe8`,
    it: `Scegli il progetto`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{3092}\u{9078}\u{3093}\u{3067}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{D504}\u{B85C}\u{C81D}\u{D2B8}\u{B97C} \u{C120}\u{D0DD}\u{D558}\u{C138}\u{C694}`,
    mww: `Xaiv qhov project`,
    ps: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{67E}\u{631}\u{648}\u{698}\u{647}`,
    pt: `Escolha projeto`,
    'pt-pt': `Escolher projeto`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}`,
    sm: `Filifili le galuega faatino`,
    so: `Mashruuca Choose`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n d\u{1EF1} \xe1n`,
    'zh-hans': `\u{9009}\u{62E9}\u{9879}\u{76EE}`,
    'zh-hant': `\u{9078}\u{64C7}\u{5C08}\u{6848}`,
    en: `Choose project`
};
const $b11db1b62d4a8f76$export$4f97e0fce8f146d7 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{646}\u{648}\u{639} \u{627}\u{644}\u{62A}\u{642}\u{631}\u{64A}\u{631}`,
    de: `W\xe4hlen Sie Berichtstyp`,
    es: `Elegir tipo de informe`,
    fa: `\u{646}\u{648}\u{639} \u{6AF}\u{632}\u{627}\u{631}\u{634} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Pumili ng uri ng ulat`,
    fr: `Choisir le type de rapport`,
    hi: `\u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F} \u{915}\u{93E} \u{92A}\u{94D}\u{930}\u{915}\u{93E}\u{930} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi kalite rap\xf2`,
    it: `Scegli il tipo di rapporto`,
    ja: `\u{30EC}\u{30DD}\u{30FC}\u{30C8}\u{306E}\u{7A2E}\u{985E}\u{3092}\u{9078}\u{629E}\u{3059}\u{308B}`,
    ko: `\u{BCF4}\u{ACE0}\u{C11C} \u{C720}\u{D615} \u{C120}\u{D0DD}`,
    mww: `Xaiv hom ntawv ceeb toom`,
    ps: `\u{62F} \u{631}\u{627}\u{67E}\u{648}\u{631} \u{689}\u{648}\u{644} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Escolha o tipo de relat\xf3rio`,
    'pt-pt': `Escolher o tipo de relat\xf3rio`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{442}\u{438}\u{43F} \u{43E}\u{442}\u{447}\u{435}\u{442}\u{430}`,
    sm: `Filifili le ituaiga lipoti`,
    so: `Dooro nooca warbixinta`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{631}\u{67E}\u{648}\u{631}\u{679} \u{6A9}\u{6CC} \u{642}\u{633}\u{645} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n lo\u{1EA1}i b\xe1o c\xe1o`,
    'zh-hans': `\u{9009}\u{62E9}\u{62A5}\u{544A}\u{7C7B}\u{578B}`,
    'zh-hant': `\u{9078}\u{64C7}\u{5831}\u{544A}\u{985E}\u{578B}`,
    en: `Choose report type`
};
const $b11db1b62d4a8f76$export$a6d146c40c1e2681 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{641}\u{631}\u{632}`,
    de: `W\xe4hlen Sie Sortierung`,
    es: `Elegir ordenar`,
    fa: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{645}\u{631}\u{62A}\u{628} \u{633}\u{627}\u{632}\u{6CC}`,
    fil: `Piliin ang pag-uuri`,
    fr: `Choisir le tri`,
    hi: `\u{938}\u{949}\u{930}\u{94D}\u{91F} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi s\xf2t`,
    it: `Scegli l'ordinamento`,
    ja: `\u{30BD}\u{30FC}\u{30C8}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{C815}\u{B82C} \u{C120}\u{D0DD}`,
    mww: `Xaiv hom`,
    ps: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{62A}\u{631}\u{62A}\u{6CC}\u{628}`,
    pt: `Escolha ordena\xe7\xe3o`,
    'pt-pt': `Escolha ordena\xe7\xe3o`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{430}`,
    sm: `Filifili le fa'avasegaina`,
    so: `Xulo kala soocidda`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E40}\u{E23}\u{E35}\u{E22}\u{E07}\u{E25}\u{E4D}\u{E32}\u{E14}\u{E31}\u{E1A}`,
    ur: `\u{62A}\u{631}\u{62A}\u{6CC}\u{628} \u{6A9}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n s\u{1EAF}p x\u{1EBF}p`,
    'zh-hans': `\u{9009}\u{62E9}\u{6392}\u{5E8F}`,
    'zh-hant': `\u{9078}\u{64C7}\u{6392}\u{5E8F}`,
    en: `Choose sort`
};
const $b11db1b62d4a8f76$export$db4f0c4f1f094613 = {
    ar: `\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{629}`,
    de: `Status w\xe4hlen`,
    es: `Elegir estado`,
    fa: `\u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}`,
    fil: `Piliin ang katayuan`,
    fr: `Choisir le statut`,
    hi: `\u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi estati`,
    it: `Scegli lo stato`,
    ja: `\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}\u{3092}\u{9078}\u{3076}`,
    ko: `\u{C2E0}\u{BD84} \u{C120}\u{D0DD}`,
    mww: `Xaiv cov xwm txheej`,
    ps: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{62D}\u{627}\u{644}\u{62A}`,
    pt: `Escolher status`,
    'pt-pt': `Escolher o estado`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}`,
    sm: `Filifili le tulaga`,
    so: `Xulo xaaladda`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}`,
    ur: `\u{62D}\u{6CC}\u{62B}\u{6CC}\u{62A} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n tr\u{1EA1}ng th\xe1i`,
    'zh-hans': `\u{9009}\u{62E9}\u{5730}\u{4F4D}`,
    'zh-hant': `\u{9078}\u{64C7}\u{5730}\u{4F4D}`,
    en: `Choose status`
};
const $b11db1b62d4a8f76$export$ffeb9312ef3f9dcb = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{645}\u{648}\u{636}\u{648}\u{639}\u{627}`,
    de: `W\xe4hle ein Thema`,
    es: `Elige un tema`,
    fa: `\u{6CC}\u{6A9} \u{62A}\u{645} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Pumili ng Tema`,
    fr: `Choisissez un th\xe8me`,
    hi: `\u{90F}\u{915} \u{925}\u{940}\u{92E} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi yon t\xe8m`,
    it: `Scegli un tema`,
    ja: `\u{30C6}\u{30FC}\u{30DE}\u{3092}\u{9078}\u{3073}\u{307E}\u{3057}\u{3087}\u{3046}`,
    ko: `\u{C8FC}\u{C81C}\u{B97C} \u{C120}\u{D0DD}\u{D558}\u{C138}\u{C694}`,
    mww: `Xaiv ib lub ntsiab lus`,
    ps: `\u{6CC}\u{648} \u{645}\u{648}\u{636}\u{648}\u{639} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Escolha um tema`,
    'pt-pt': `Escolha um tema`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{442}\u{435}\u{43C}\u{443}`,
    sm: `Filifili se autu`,
    so: `Dooro mowduuc`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E18}\u{E35}\u{E21}`,
    ur: `\u{62A}\u{6BE}\u{6CC}\u{645} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n ch\u{1EE7} \u{111}\u{1EC1}`,
    'zh-hans': `\u{9009}\u{62E9}\u{4E00}\u{4E2A}\u{4E3B}\u{9898}`,
    'zh-hant': `\u{9078}\u{64C7}\u{4E00}\u{500B}\u{4E3B}\u{984C}`,
    en: `Choose a theme`
};
const $b11db1b62d4a8f76$export$da02c3490a9bad8a = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{62C}\u{62F}\u{648}\u{644} \u{632}\u{645}\u{646}\u{64A} \u{644}\u{625}\u{646}\u{634}\u{627}\u{626}\u{647} \u{623}\u{648} \u{641}\u{62A}\u{62D}\u{647}. \u{627}\u{644}\u{62C}\u{62F}\u{627}\u{648}\u{644} \u{627}\u{644}\u{632}\u{645}\u{646}\u{64A}\u{629} \u{627}\u{644}\u{62A}\u{64A} \u{633}\u{628}\u{642}\u{62A} \u{641}\u{62A}\u{631}\u{629} \u{627}\u{644}\u{62F}\u{641}\u{639} \u{627}\u{644}\u{633}\u{627}\u{628}\u{642}\u{629} \u{63A}\u{64A}\u{631} \u{645}\u{62A}\u{627}\u{62D}\u{629} \u{644}\u{644}\u{625}\u{646}\u{634}\u{627}\u{621} \u{647}\u{646}\u{627}.`,
    de: `W\xe4hle einen Stundenzettel zum Erstellen oder \xd6ffnen aus. Stundenzettel von vor dem vorherigen Abrechnungszeitraum k\xf6nnen hier nicht erstellt werden.`,
    es: `Elige una hoja de horas para crear o abrir. No est\xe1 disponible para crear hojas de horas anteriores al periodo de pago anterior.`,
    fa: `\u{6CC}\u{6A9} \u{62A}\u{627}\u{6CC}\u{645} \u{634}\u{6CC}\u{62A} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6CC}\u{627} \u{628}\u{627}\u{632} \u{6A9}\u{631}\u{62F}\u{646} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}. \u{628}\u{631}\u{6AF}\u{647} \u{647}\u{627}\u{6CC} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{642}\u{628}\u{644} \u{627}\u{632} \u{62F}\u{648}\u{631}\u{647} \u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A} \u{642}\u{628}\u{644}\u{6CC} \u{62F}\u{631} \u{627}\u{6CC}\u{646}\u{62C}\u{627} \u{642}\u{627}\u{628}\u{644} \u{62A}\u{647}\u{6CC}\u{647} \u{646}\u{6CC}\u{633}\u{62A}\u{646}\u{62F}.`,
    fil: `Pumili ng isang timesheet upang lumikha o buksan. Ang mga timesheet mula bago ang nakaraang panahon ng pagbabayad ay hindi magagamit upang lumikha dito.`,
    fr: `Choisissez une feuille de temps \xe0 cr\xe9er ou \xe0 ouvrir. Les feuilles de temps d\u{2019}avant la p\xe9riode de paie pr\xe9c\xe9dente ne sont pas disponibles \xe0 la cr\xe9ation ici.`,
    hi: `\u{92C}\u{928}\u{93E}\u{928}\u{947} \u{92F}\u{93E} \u{916}\u{94B}\u{932}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{94B}\u{908} \u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{91A}\u{941}\u{928}\u{947}\u{902}. \u{92A}\u{93F}\u{91B}\u{932}\u{940} \u{935}\u{947}\u{924}\u{928} \u{905}\u{935}\u{927}\u{93F} \u{938}\u{947} \u{92A}\u{939}\u{932}\u{947} \u{915}\u{940} \u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{92F}\u{939}\u{93E}\u{902} \u{92C}\u{928}\u{93E}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{909}\u{92A}\u{932}\u{92C}\u{94D}\u{927} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Chwazi yon Timesheet yo kreye oswa louvri. Timesheets soti nan anvan pery\xf2d peman anvan yo pa disponib pou kreye isit la.`,
    it: `Scegli un foglio orario da creare o da aprire. I fogli di pagamento precedenti al periodo di paga precedente non sono disponibili da creare qui.`,
    ja: `\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{3092}\u{4F5C}\u{6210}\u{307E}\u{305F}\u{306F}\u{958B}\u{5C01}\u{3059}\u{308B}\u{3082}\u{306E}\u{3092}\u{9078}\u{3073}\u{307E}\u{3057}\u{3087}\u{3046}\u{3002}\u{524D}\u{56DE}\u{306E}\u{7D66}\u{4E0E}\u{671F}\u{9593}\u{4EE5}\u{524D}\u{306E}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{306F}\u{3053}\u{3053}\u{3067}\u{4F5C}\u{6210}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{D0C0}\u{C784}\u{C2DC}\u{D2B8}\u{B97C} \u{C120}\u{D0DD}\u{D574} \u{B9CC}\u{B4E4}\u{AC70}\u{B098} \u{C5F4}\u{C5B4}\u{BCF4}\u{C138}\u{C694}. \u{C774}\u{C804} \u{AE09}\u{C5EC} \u{AE30}\u{AC04} \u{C774}\u{C804}\u{C758} \u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C}\u{B294} \u{C5EC}\u{AE30}\u{C11C} \u{C791}\u{C131}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Xaiv ib daim ntawv teev sij hawm los tsim los yog qhib. Cov ntawv teev sijhawm los ntawm ua ntej lub sijhawm them nyiaj yav dhau los tsis muaj los tsim ntawm no.`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647} \u{62F} \u{62C}\u{648}\u{693}\u{648}\u{644}\u{648} \u{6CC}\u{627} \u{67E}\u{631}\u{627}\u{646}\u{633}\u{62A}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}. \u{62F} \u{62A}\u{6D0}\u{631}\u{6D0} \u{645}\u{639}\u{627}\u{634} \u{645}\u{648}\u{62F}\u{647} \u{645}\u{62E}\u{6A9}\u{6D0} \u{648}\u{62E}\u{62A}\u{67E}\u{627}\u{6BC}\u{6D0} \u{62F}\u{644}\u{62A}\u{647} \u{62F} \u{62C}\u{648}\u{693}\u{648}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{646}\u{634}\u{62A}\u{647}.`,
    pt: `Escolha uma folha de ponto para criar ou abrir. Folhas de ponto anteriores ao per\xedodo anterior n\xe3o est\xe3o dispon\xedveis para cria\xe7\xe3o aqui.`,
    'pt-pt': `Escolha uma folha de horas para criar ou abrir. Folhas de ponto anteriores ao per\xedodo de pagamento anterior n\xe3o est\xe3o dispon\xedveis para criar aqui.`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{434}\u{43B}\u{44F} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{44F} \u{438}\u{43B}\u{438} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{438}\u{44F}. \u{422}\u{430}\u{431}\u{435}\u{43B}\u{438} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{434}\u{43E} \u{43F}\u{440}\u{435}\u{434}\u{44B}\u{434}\u{443}\u{449}\u{435}\u{433}\u{43E} \u{43F}\u{43B}\u{430}\u{442}\u{435}\u{436}\u{43D}\u{43E}\u{433}\u{43E} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430} \u{437}\u{434}\u{435}\u{441}\u{44C} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{44B} \u{434}\u{43B}\u{44F} \u{441}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}.`,
    sm: `Filifili se fa'ata'ita'iga e fa'apipi'i pe tatalaina. E le o maua iinei ia pepa o taimi a o lei oo i le vaitau o totogi ua mavae.`,
    so: `Dooro xaashiyaha waqtiga si aad u abuurto ama u furto. Waqtiyada ka hor muddadii mushaharka hore laguma heli karo halkan.`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E1B}\u{E34}\u{E14} \u{E41}\u{E1C}\u{E48}\u{E19}\u{E40}\u{E27}\u{E25}\u{E32}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E23}\u{E2D}\u{E1A}\u{E23}\u{E30}\u{E22}\u{E30}\u{E40}\u{E27}\u{E25}\u{E32}\u{E01}\u{E32}\u{E23}\u{E08}\u{E48}\u{E32}\u{E22}\u{E40}\u{E07}\u{E34}\u{E19}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E44}\u{E14}\u{E49}\u{E17}\u{E35}\u{E48}\u{E19}\u{E35}\u{E48}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA} \u{6CC}\u{627} \u{6A9}\u{6BE}\u{648}\u{644}\u{6CC}\u{6BA}\u{6D4} \u{67E}\u{686}\u{6BE}\u{644}\u{6CC} \u{627}\u{62F}\u{627}\u{626}\u{6CC}\u{6AF}\u{6CC} \u{6A9}\u{6CC} \u{645}\u{62F}\u{62A} \u{633}\u{6D2} \u{67E}\u{6C1}\u{644}\u{6D2} \u{6A9}\u{6CC} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679}\u{633} \u{6CC}\u{6C1}\u{627}\u{6BA} \u{62A}\u{6CC}\u{627}\u{631} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{62F}\u{633}\u{62A}\u{6CC}\u{627}\u{628} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Ch\u{1ECD}n b\u{1EA3}ng ch\u{1EA5}m c\xf4ng \u{111}\u{1EC3} t\u{1EA1}o ho\u{1EB7}c m\u{1EDF}. B\u{1EA3}ng ch\u{1EA5}m c\xf4ng t\u{1EEB} tr\u{1B0}\u{1EDB}c k\u{1EF3} thanh to\xe1n tr\u{1B0}\u{1EDB}c \u{111}\xf3 kh\xf4ng c\xf3 s\u{1EB5}n \u{111}\u{1EC3} t\u{1EA1}o t\u{1EA1}i \u{111}\xe2y.`,
    'zh-hans': `\u{9009}\u{62E9}\u{4E00}\u{4EFD}\u{5DE5}\u{65F6}\u{8868}\u{6765}\u{521B}\u{5EFA}\u{6216}\u{6253}\u{5F00}\u{3002}\u{4E0A}\u{4E00}\u{4E2A}\u{5DE5}\u{8D44}\u{671F}\u{4E4B}\u{524D}\u{7684}\u{5DE5}\u{65F6}\u{8868}\u{65E0}\u{6CD5}\u{5728}\u{6B64}\u{521B}\u{5EFA}\u{3002}`,
    'zh-hant': `\u{9078}\u{64C7}\u{4E00}\u{4EFD}\u{5DE5}\u{6642}\u{8868}\u{4F86}\u{88FD}\u{4F5C}\u{6216}\u{6253}\u{958B}\u{3002}\u{4E0A}\u{4E00}\u{85AA}\u{8CC7}\u{671F}\u{4E4B}\u{524D}\u{7684}\u{5DE5}\u{6642}\u{8868}\u{7121}\u{6CD5}\u{5728}\u{6B64}\u{5EFA}\u{7ACB}\u{3002}`,
    en: `Choose a timesheet to create or open. Timesheets from before the previous pay period are not available to create here.`
};
const $b11db1b62d4a8f76$export$2e5611c44d7e00ce = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{646}\u{648}\u{639}`,
    de: `W\xe4hlen Sie den Typ`,
    es: `Elegir tipo`,
    fa: `\u{646}\u{648}\u{639} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Piliin ang uri`,
    fr: `Choisir le type`,
    hi: `\u{92A}\u{94D}\u{930}\u{915}\u{93E}\u{930} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi kalite`,
    it: `Scegli il tipo`,
    ja: `\u{30BF}\u{30A4}\u{30D7}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{C720}\u{D615}\u{C744} \u{C120}\u{D0DD}\u{D558}\u{C138}\u{C694}`,
    mww: `Xaiv hom`,
    ps: `\u{689}\u{648}\u{644} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Escolha o tipo`,
    'pt-pt': `Escolha o tipo`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{442}\u{438}\u{43F}`,
    sm: `Filifili le ituaiga`,
    so: `Xulo nooca`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}`,
    ur: `\u{642}\u{633}\u{645} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n lo\u{1EA1}i`,
    'zh-hans': `\u{9009}\u{62E9}\u{7C7B}\u{578B}`,
    'zh-hant': `\u{9078}\u{64C7}\u{985E}\u{578B}`,
    en: `Choose type`
};
const $b11db1b62d4a8f76$export$da83d15bfc8b67f1 = {
    ar: `\u{627}\u{644}\u{645}\u{62F}\u{64A}\u{646}\u{629}`,
    de: `Stadt`,
    es: `Ciudad`,
    fa: `\u{634}\u{647}\u{631}`,
    fil: `Lungsod`,
    fr: `Ville`,
    hi: `\u{936}\u{939}\u{930}`,
    ht: `Vil la`,
    it: `Citt\xe0`,
    ja: `\u{90FD}\u{5E02}`,
    ko: `\u{B3C4}\u{C2DC}`,
    mww: `Lub nroog`,
    ps: `\u{69A}\u{627}\u{631}`,
    pt: `Cidade`,
    'pt-pt': `Cidade`,
    ru: `\u{413}\u{43E}\u{440}\u{43E}\u{434}`,
    sm: `Aai`,
    so: `Magaalo`,
    th: `\u{E40}\u{E21}\u{E37}\u{E2D}\u{E07}`,
    ur: `\u{634}\u{6C1}\u{631}`,
    vi: `Th\xe0nh ph\u{1ED1}`,
    'zh-hans': `\u{57CE}\u{5E02}`,
    'zh-hant': `\u{57CE}\u{5E02}`,
    en: `City`
};
const $b11db1b62d4a8f76$export$a73b2018b0c7ea0d = {
    ar: `\u{62F}\u{641}\u{639}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{637}\u{627}\u{644}\u{628}\u{629}`,
    de: `Claim-Chargen`,
    es: `Lotes de reclamaciones`,
    fa: `\u{62F}\u{633}\u{62A}\u{647} \u{647}\u{627}\u{6CC} \u{627}\u{62F}\u{639}\u{627}\u{6CC}\u{6CC}`,
    fil: `Mga batch ng pag-angkin`,
    fr: `Groupes de revendications`,
    hi: `\u{926}\u{93E}\u{935}\u{93E} \u{92C}\u{948}\u{91A}`,
    ht: `Reklamasyon pak\xe8t`,
    it: `Lotti di richiesta`,
    ja: `\u{30AF}\u{30EC}\u{30FC}\u{30E0}\u{30D0}\u{30C3}\u{30C1}`,
    ko: `\u{D074}\u{B808}\u{C784} \u{BC30}\u{CE58}`,
    mww: `Thov pawg`,
    ps: `\u{62F} \u{627}\u{62F}\u{639}\u{627} \u{689}\u{644}\u{6D0}`,
    pt: `Lotes de reivindica\xe7\xe3o`,
    'pt-pt': `Lotes de reivindica\xe7\xe3o`,
    ru: `\u{41F}\u{430}\u{440}\u{442}\u{438}\u{438} \u{437}\u{430}\u{44F}\u{432}\u{43E}\u{43A}`,
    sm: `Talosaga faaputuga`,
    so: `Qaybaha sheegashada`,
    th: `\u{E23}\u{E31}\u{E1A}\u{E41}\u{E1A}\u{E17}\u{E0A}\u{E4C}`,
    ur: `\u{6A9}\u{644}\u{6CC}\u{645} \u{628}\u{6CC}\u{686}\u{632}`,
    vi: `Y\xeau c\u{1EA7}u l\xf4 h\xe0ng`,
    'zh-hans': `\u{7D22}\u{8D54}\u{6279}\u{6B21}`,
    'zh-hant': `\u{7D22}\u{8CE0}\u{6279}\u{6B21}`,
    en: `Claim batches`
};
const $b11db1b62d4a8f76$export$df43ba9fb6c5a259 = {
    ar: `\u{648}\u{627}\u{636}\u{62D}`,
    de: `Frei`,
    es: `\xa1Libre`,
    fa: `\u{67E}\u{627}\u{6A9} \u{627}\u{633}\u{62A}`,
    fil: `I-clear`,
    fr: `Clair`,
    hi: `\u{938}\u{93E}\u{92B}\u{93C} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Kl\xe8`,
    it: `Libero`,
    ja: `\u{30AF}\u{30EA}\u{30A2}`,
    ko: `\u{BE44}\u{CF1C}`,
    mww: `ntshiab`,
    ps: `\u{67E}\u{627}\u{6A9}\u{647}`,
    pt: `Limpo`,
    'pt-pt': `Limpo`,
    ru: `\u{427}\u{438}\u{441}\u{442}\u{43E}`,
    sm: `Manino`,
    so: `Nadiif`,
    th: `\u{E25}\u{E49}\u{E32}\u{E07}\u{E04}\u{E48}\u{E32}\u{E01}\u{E32}\u{E23}\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}`,
    ur: `\u{635}\u{627}\u{641}`,
    vi: `X\xf3a`,
    'zh-hans': `\u{6E05}\u{573A}`,
    'zh-hant': `\u{6E05}\u{5834}`,
    en: `Clear`
};
const $b11db1b62d4a8f76$export$cb6ce79010bc6290 = {
    ar: `\u{646}\u{638}\u{641} \u{643}\u{644} \u{634}\u{64A}\u{621}`,
    de: `Alles wegr\xe4umen`,
    es: `Limpiar todo`,
    fa: `\u{647}\u{645}\u{647} \u{631}\u{648} \u{67E}\u{627}\u{6A9} \u{6A9}\u{646}`,
    fil: `I-clear ang lahat`,
    fr: `\xc9cartez tout`,
    hi: `\u{938}\u{92D}\u{940} \u{938}\u{93E}\u{92B}\u{93C} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Kl\xe8 tout`,
    it: `Cancella tutto`,
    ja: `\u{3059}\u{3079}\u{3066}\u{30AF}\u{30EA}\u{30A2}`,
    ko: `\u{BAA8}\u{B450} \u{C815}\u{B9AC}`,
    mww: `Tshem tag nrho`,
    ps: `\u{67C}\u{648}\u{644} \u{67E}\u{627}\u{6A9} \u{6A9}\u{693}\u{647}`,
    pt: `Limpar tudo`,
    'pt-pt': `Limpar tudo`,
    ru: `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{432}\u{441}\u{451}`,
    sm: `T\u{101}p\u{113} uma`,
    so: `Dhammaan tirtir`,
    th: `\u{E25}\u{E49}\u{E32}\u{E07}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{633}\u{628} \u{635}\u{627}\u{641} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xf3a t\u{1EA5}t c\u{1EA3}`,
    'zh-hans': `\u{5168}\u{90E8}\u{6E05}\u{7A7A}`,
    'zh-hant': `\u{5168}\u{90E8}\u{6E05}\u{7A7A}`,
    en: `Clear all`
};
const $b11db1b62d4a8f76$export$b5cfc9ee72391036 = {
    ar: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">امسح تفضيلي اللغوي</button> على هذا الموقع`,
    de: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">Meine Sprachpräferenz klar zu machen</button> auf dieser Seite`,
    es: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">Aclara mi preferencia lingüística</button> en este sitio`,
    fa: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">ترجیح زبانی ام را پاک کن</button> در این سایت`,
    fil: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">I-clear ang aking kagustuhan sa wika</button> Sa site na ito`,
    fr: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">Clarifiez ma préférence linguistique</button> sur ce site`,
    hi: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">मेरी भाषा वरीयता साफ़ करें</button> इस साइट पर`,
    ht: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">Klè preferans lang mwen</button> sou sit sa a`,
    it: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">Chiarisce la mia preferenza linguistica</button> su questo sito`,
    ja: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">言語の好みをクリアする</button> このサイトで`,
    ko: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">내 언어 선호를 지워</button> 이 사이트에서`,
    mww: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">Tshem kuv cov lus nyiam</button> ntawm qhov chaw no`,
    ps: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">زما د ژبې ترجیح پاکه کړه</button> په دې سایټ کې`,
    pt: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">Esclarecer minha preferência de idioma</button> neste site`,
    'pt-pt': $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">Esclareça a minha preferência linguística</button> neste site`,
    ru: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">Прояснив свои языковые предпочтения</button> На этом сайте`,
    sm: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">Kilia la'u gagana e fiafia i ai</button> i luga o lenei 'upega tafa'ilagi`,
    so: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">Nadiifi doorashadayda luqadayda</button> boggan`,
    th: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">ล้างค่ากําหนดภาษาของฉัน</button> บนเว็บไซต์นี้`,
    ur: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">میری زبان کی ترجیح صاف کریں</button> اس سائٹ پر`,
    vi: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">Xóa tùy chọn ngôn ngữ của tôi</button> trên trang web này`,
    'zh-hans': $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">清除我的语言偏好</button> 在本网站上`,
    'zh-hant': $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">清除我的語言偏好</button> 在這個網站上`,
    en: $b11db1b62d4a8f76$var$html`<button class="btn-link" type="submit" name="locale" value="">Clear my language preference</button> on this site`
};
const $b11db1b62d4a8f76$export$e02e892747becbe2 = {
    ar: `\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631} \u{648}\u{627}\u{636}\u{62D}`,
    de: `Klare Auswahl`,
    es: `Selecci\xf3n clara`,
    fa: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{634}\u{641}\u{627}\u{641}`,
    fil: `I-clear ang pagpili`,
    fr: `S\xe9lection claire`,
    hi: `\u{91A}\u{92F}\u{928} \u{938}\u{93E}\u{92B}\u{93C} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Kl\xe8 seleksyon`,
    it: `Selezione chiara`,
    ja: `\u{30AF}\u{30EA}\u{30A2}\u{30BB}\u{30EC}\u{30AF}\u{30B7}\u{30E7}\u{30F3}`,
    ko: `\u{BA85}\u{D655}\u{D55C} \u{C120}\u{BC1C}`,
    mww: `Kev xaiv kom meej`,
    ps: `\u{67E}\u{627}\u{6A9} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}`,
    pt: `Sele\xe7\xe3o clara`,
    'pt-pt': `Sele\xe7\xe3o clara`,
    ru: `\u{427}\u{438}\u{441}\u{442}\u{44B}\u{439} \u{432}\u{44B}\u{431}\u{43E}\u{440}`,
    sm: `Filifiliga manino`,
    so: `Xulasho cad`,
    th: `\u{E25}\u{E49}\u{E32}\u{E07}\u{E01}\u{E32}\u{E23}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}`,
    ur: `\u{6A9}\u{644}\u{626}\u{6CC}\u{631} \u{633}\u{644}\u{6CC}\u{6A9}\u{634}\u{646}`,
    vi: `L\u{1EF1}a ch\u{1ECD}n r\xf5 r\xe0ng`,
    'zh-hans': `\u{6E05}\u{6670}\u{9009}\u{62E9}`,
    'zh-hant': `\u{660E}\u{78BA}\u{9078}\u{64C7}`,
    en: `Clear selection`
};
const $b11db1b62d4a8f76$export$ab57077c7aa64ad3 = {
    ar: `\u{627}\u{644}\u{639}\u{645}\u{644}\u{627}\u{621}`,
    de: `Kunden`,
    es: `Clientes`,
    fa: `\u{645}\u{634}\u{62A}\u{631}\u{6CC}\u{627}\u{646}`,
    fil: `Mga kliyente`,
    fr: `Clients`,
    hi: `\u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915}\u{94B}\u{902}`,
    ht: `Kliyan yo`,
    it: `Clienti`,
    ja: `\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}`,
    ko: `\u{ACE0}\u{AC1D}`,
    mww: `Cov neeg siv khoom`,
    ps: `\u{645}\u{631}\u{627}\u{62C}\u{639}\u{6CC}\u{646}`,
    pt: `Clientes`,
    'pt-pt': `Clientes`,
    ru: `\u{41A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{44B}`,
    sm: `Tagata fa'atau`,
    so: `Macaamiisha`,
    th: `\u{E25}\u{E39}\u{E01}\u{E04}\u{E49}\u{E32}`,
    ur: `\u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679}\u{633}`,
    vi: `Kh\xe1ch h\xe0ng`,
    'zh-hans': `\u{5BA2}\u{6237}`,
    'zh-hant': `\u{5BA2}\u{6236}`,
    en: `Clients`
};
const $b11db1b62d4a8f76$export$478f773b207f692f = {
    ar: `\u{625}\u{63A}\u{644}\u{627}\u{642}`,
    de: `Schlie\xdfen`,
    es: `Cierre`,
    fa: `\u{628}\u{633}\u{62A}\u{647} \u{634}\u{62F}\u{646}`,
    fil: `Isara`,
    fr: `Fermer`,
    hi: `\u{918}\u{941}\u{91F}\u{928}\u{92D}\u{930}\u{93E}`,
    ht: `F\xe8men`,
    it: `Chiudi`,
    ja: `\u{9589}\u{3058}\u{308B}`,
    ko: `\u{B2EB}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `kaw`,
    ps: `\u{646}\u{696}\u{62F}\u{6D0}`,
    pt: `Fechar`,
    'pt-pt': `Fechar`,
    ru: `\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44C}`,
    sm: `Tapuni`,
    so: `Xir`,
    th: `\u{E1B}\u{E34}\u{E14}`,
    ur: `\u{628}\u{646}\u{62F}`,
    vi: `\u{110}\xf3ng`,
    'zh-hans': `\u{7ED3}\u{675F}`,
    'zh-hant': `\u{7D50}\u{675F}`,
    en: `Close`
};
const $b11db1b62d4a8f76$export$147ffe3f4dd416a4 = {
    ar: `\u{633}\u{62A}\u{638}\u{647}\u{631} \u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{643}\u{62A}\u{645}\u{644}\u{629} \u{648}\u{627}\u{644}\u{645}\u{644}\u{63A}\u{627}\u{629} \u{647}\u{646}\u{627}.`,
    de: `Abgeschlossene und abgesagte Aktivit\xe4ten erscheinen hier.`,
    es: `Las actividades completadas y canceladas aparecer\xe1n aqu\xed.`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{634}\u{62F}\u{647} \u{648} \u{644}\u{63A}\u{648} \u{634}\u{62F}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646}\u{62C}\u{627} \u{646}\u{645}\u{627}\u{6CC}\u{634} \u{62F}\u{627}\u{62F}\u{647} \u{62E}\u{648}\u{627}\u{647}\u{646}\u{62F} \u{634}\u{62F}.`,
    fil: `Ang mga nakumpleto at kinansela na mga aktibidad ay lilitaw dito.`,
    fr: `Les activit\xe9s termin\xe9es et annul\xe9es appara\xeetront ici.`,
    hi: `\u{92A}\u{942}\u{930}\u{94D}\u{923} \u{914}\u{930} \u{930}\u{926}\u{94D}\u{926} \u{915}\u{940} \u{917}\u{908} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901} \u{92F}\u{939}\u{93E}\u{901} \u{926}\u{93F}\u{916}\u{93E}\u{908} \u{926}\u{947}\u{902}\u{917}\u{940}\u{964}`,
    ht: `Aktivite yo fini ak anile ap par\xe8t isit la.`,
    it: `Le attivit\xe0 completate e cancellate appariranno qui.`,
    ja: `\u{5B8C}\u{4E86}\u{6E08}\u{307F}\u{304A}\u{3088}\u{3073}\u{4E2D}\u{6B62}\u{3055}\u{308C}\u{305F}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{3053}\u{3053}\u{306B}\u{63B2}\u{8F09}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C644}\u{B8CC} \u{BC0F} \u{CDE8}\u{C18C}\u{B41C} \u{D65C}\u{B3D9}\u{C740} \u{C5EC}\u{AE30}\u{C5D0} \u{D45C}\u{C2DC}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Cov haujlwm ua tiav thiab tshem tawm yuav tshwm sim ntawm no.`,
    ps: `\u{628}\u{634}\u{67E}\u{693} \u{634}\u{648}\u{6CC} \u{627}\u{648} \u{644}\u{63A}\u{648}\u{647} \u{634}\u{648}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{628}\u{647} \u{62F}\u{644}\u{62A}\u{647} \u{69A}\u{6A9}\u{627}\u{631}\u{647} \u{634}\u{6CC}.`,
    pt: `Atividades conclu\xeddas e canceladas aparecer\xe3o aqui.`,
    'pt-pt': `Atividades conclu\xeddas e canceladas aparecer\xe3o aqui.`,
    ru: `\u{417}\u{434}\u{435}\u{441}\u{44C} \u{431}\u{443}\u{434}\u{443}\u{442} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{451}\u{43D}\u{43D}\u{44B}\u{435} \u{438} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{451}\u{43D}\u{43D}\u{44B}\u{435} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{438}.`,
    sm: `O gaoioiga ua maea ma ua faaleaogaina o le a faaali mai iinei.`,
    so: `Hawlaha la dhammeystiray iyo kuwa la joojiyay ayaa halkan lagu soo bandhigi doonaa.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E41}\u{E25}\u{E30}\u{E16}\u{E39}\u{E01}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E08}\u{E30}\u{E1B}\u{E23}\u{E32}\u{E01}\u{E0F}\u{E17}\u{E35}\u{E48}\u{E19}\u{E35}\u{E48}`,
    ur: `\u{645}\u{6A9}\u{645}\u{644} \u{627}\u{648}\u{631} \u{645}\u{646}\u{633}\u{648}\u{62E} \u{634}\u{62F}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{6CC}\u{6C1}\u{627}\u{6BA} \u{638}\u{627}\u{6C1}\u{631} \u{6C1}\u{648}\u{6BA} \u{6AF}\u{6CC}\u{6D4}`,
    vi: `C\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\xe3 ho\xe0n th\xe0nh v\xe0 b\u{1ECB} h\u{1EE7}y s\u{1EBD} xu\u{1EA5}t hi\u{1EC7}n t\u{1EA1}i \u{111}\xe2y.`,
    'zh-hans': `\u{5DF2}\u{5B8C}\u{6210}\u{548C}\u{53D6}\u{6D88}\u{7684}\u{6D3B}\u{52A8}\u{5C06}\u{5728}\u{6B64}\u{663E}\u{793A}\u{3002}`,
    'zh-hant': `\u{5DF2}\u{5B8C}\u{6210}\u{53CA}\u{53D6}\u{6D88}\u{7684}\u{6D3B}\u{52D5}\u{5C07}\u{986F}\u{793A}\u{65BC}\u{6B64}\u{3002}`,
    en: `Completed and cancelled activities will appear here.`
};
const $b11db1b62d4a8f76$export$dd90b1584f439f31 = {
    ar: (count)=>`${count} \u{645}\u{63A}\u{644}\u{642}\u{64A}\u{646}`,
    de: (count)=>`${count} geschlossen`,
    es: (count)=>`${count} cerrado`,
    fa: (count)=>`${count} \u{646}\u{641}\u{631} \u{628}\u{633}\u{62A}\u{647} \u{634}\u{62F}\u{646}\u{62F}`,
    fil: (count)=>`${count} Sarado`,
    fr: (count)=>`${count} ferm\xe9`,
    hi: (count)=>`${count} \u{92C}\u{902}\u{926}`,
    ht: (count)=>`${count} f\xe8men`,
    it: (count)=>`${count} chiuso`,
    ja: (count)=>`${count} \u{9589}\u{9396}`,
    ko: (count)=>`${count} \u{D3D0}\u{C1C4}`,
    mww: (count)=>`${count} kaw`,
    ps: (count)=>`${count} \u{62A}\u{693}\u{644} \u{634}\u{648}\u{6CC}`,
    pt: (count)=>`${count} fechados`,
    'pt-pt': (count)=>`${count} fechados`,
    ru: (count)=>`${count} \u{437}\u{430}\u{43A}\u{440}\u{44B}\u{442}`,
    sm: (count)=>`${count} tapunia`,
    so: (count)=>`${count} waa la xidhay`,
    th: (count)=>`${count} \u{E1B}\u{E34}\u{E14}\u{E17}\u{E4D}\u{E32}\u{E01}\u{E32}\u{E23}`,
    ur: (count)=>`${count} \u{628}\u{646}\u{62F}`,
    vi: (count)=>`${count} \u{111}\xe3 \u{111}\xf3ng c\u{1EED}a`,
    'zh-hans': (count)=>`${count} \u{53F7}\u{5173}\u{95ED}`,
    'zh-hant': (count)=>`${count} \u{865F}\u{95DC}\u{9589}`,
    en: (count)=>`${count} closed`
};
const $b11db1b62d4a8f76$export$caeb5e6004a803ab = {
    ar: `\u{627}\u{644}\u{62D}\u{627}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{63A}\u{644}\u{642}\u{629}`,
    de: `Geschlossene Zust\xe4nde`,
    es: `Fechas`,
    fa: `\u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{628}\u{633}\u{62A}\u{647} \u{634}\u{62F}\u{647}`,
    fil: `Email Address *`,
    fr: `Statuts ferm\xe9s`,
    hi: `\u{92C}\u{902}\u{926} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `Estati f\xe8men`,
    it: `Status chiuso`,
    ja: `\u{9589}\u{9396}\u{72B6}\u{614B}`,
    ko: `\u{D3D0}\u{C1C4} \u{C0C1}\u{D0DC}`,
    mww: `Cov xwm txheej kaw`,
    ps: `\u{62A}\u{693}\u{644} \u{634}\u{648}\u{6CC} \u{62D}\u{627}\u{644}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Status fechado`,
    'pt-pt': `Status de encerramento`,
    ru: `\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{435} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{44B}`,
    sm: `Tulaga tapunia`,
    so: `Xaaladaha xiran`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E1B}\u{E34}\u{E14}`,
    ur: `\u{628}\u{646}\u{62F} \u{62D}\u{627}\u{644}\u{62A}\u{6CC}\u{6BA}`,
    vi: `Tr\u{1EA1}ng th\xe1i \u{111}\xf3ng`,
    'zh-hans': `\u{5173}\u{95ED}\u{72B6}\u{6001}`,
    'zh-hant': `\u{95DC}\u{9589}\u{72C0}\u{614B}`,
    en: `Closed statuses`
};
const $b11db1b62d4a8f76$export$d3bf1e6107f4313 = {
    ar: `\u{625}\u{63A}\u{644}\u{627}\u{642} \u{627}\u{644}\u{62A}\u{639}\u{62F}\u{64A}\u{644}`,
    de: `Schnitt geschlossen`,
    es: `Edici\xf3n cerrada`,
    fa: `\u{628}\u{633}\u{62A}\u{646} \u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634}`,
    fil: `Isara ang pag-edit`,
    fr: `\xc9dition finale`,
    hi: `\u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902} \u{92C}\u{902}\u{926} \u{915}\u{930}\u{947}\u{902}`,
    ht: `F\xe8men modifikasyon`,
    it: `Modifica chiusa`,
    ja: `\u{7DE8}\u{96C6}\u{3092}\u{9589}\u{3058}\u{308B}`,
    ko: `\u{B9C8}\u{AC10} \u{D3B8}\u{C9D1}`,
    mww: `Kaw kho kom raug`,
    ps: `\u{628}\u{646}\u{62F} \u{633}\u{645}\u{648}\u{646}`,
    pt: `Edi\xe7\xe3o fechada`,
    'pt-pt': `Edi\xe7\xe3o fechada`,
    ru: `\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{43E}\u{435} \u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Tapunia faasa'oga`,
    so: `Tafatir xir`,
    th: `\u{E1B}\u{E34}\u{E14}\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}`,
    ur: `\u{62A}\u{631}\u{645}\u{6CC}\u{645} \u{628}\u{646}\u{62F} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `\u{110}\xf3ng ch\u{1EC9}nh s\u{1EED}a`,
    'zh-hans': `\u{7F16}\u{8F91}`,
    'zh-hant': `\u{7DE8}\u{8F2F}\u{5B8C}\u{7562}`,
    en: `Close edit`
};
const $b11db1b62d4a8f76$export$bcb597a2bb0c6ebd = {
    ar: `\u{625}\u{63A}\u{644}\u{627}\u{642} \u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629}`,
    de: `Men\xfc schlie\xdfen`,
    es: `Men\xfa cerrado`,
    fa: `\u{628}\u{633}\u{62A}\u{646} \u{645}\u{646}\u{648}`,
    fil: `Email Address *`,
    fr: `Fermer le menu`,
    hi: `\u{92E}\u{947}\u{928}\u{942} \u{92C}\u{902}\u{926} \u{915}\u{930}\u{947}\u{902}`,
    ht: `F\xe8men meni`,
    it: `Chiudi menu`,
    ja: `\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{3092}\u{9589}\u{3058}\u{308B}`,
    ko: `\u{BA54}\u{B274} \u{B2EB}\u{AE30}`,
    mww: `Kaw cov ntawv qhia zaub mov`,
    ps: `\u{645}\u{6CC}\u{646}\u{648} \u{648}\u{62A}\u{693}\u{626}`,
    pt: `Fechar card\xe1pio`,
    'pt-pt': `Fechar menu`,
    ru: `\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44E}`,
    sm: `Tapuni le lisi autu`,
    so: `Liiska xir`,
    th: `\u{E1B}\u{E34}\u{E14}\u{E40}\u{E21}\u{E19}\u{E39}`,
    ur: `\u{645}\u{6CC}\u{646}\u{648} \u{628}\u{646}\u{62F} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `\u{110}\xf3ng menu`,
    'zh-hans': `\u{5173}\u{95ED}\u{83DC}\u{5355}`,
    'zh-hant': `\u{95DC}\u{9589}\u{9078}\u{55AE}`,
    en: `Close menu`
};
const $b11db1b62d4a8f76$export$748f3ce2bc9515d1 = {
    ar: `\u{62A}\u{639}\u{644}\u{64A}\u{642}`,
    de: `Kommentar`,
    es: `Comentario`,
    fa: `\u{646}\u{638}\u{631}`,
    fil: `Komento`,
    fr: `Commentaire`,
    hi: `\u{938}\u{92E}\u{94D}\u{200D}\u{92E}\u{924}\u{93F} \u{926}\u{947}\u{928}\u{93E}`,
    ht: `K\xf2mant\xe8`,
    it: `Commento`,
    ja: `\u{30B3}\u{30E1}\u{30F3}\u{30C8}`,
    ko: `\u{B313}\u{AE00}`,
    mww: `Tawm tswv yim`,
    ps: `\u{62A}\u{628}\u{635}\u{631}\u{647}`,
    pt: `Coment\xe1rio`,
    'pt-pt': `Coment\xe1rio`,
    ru: `\u{41A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{439}`,
    sm: `Faamatalaga`,
    so: `Faallo`,
    th: `\u{E41}\u{E2A}\u{E14}\u{E07}\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}`,
    ur: `\u{62A}\u{628}\u{635}\u{631}\u{6C1}`,
    vi: `B\xecnh lu\u{1EAD}n`,
    'zh-hans': `\u{8BC4}\u{8BBA}`,
    'zh-hant': `\u{7559}\u{8A00}`,
    en: `Comment`
};
const $b11db1b62d4a8f76$export$371c1bb164daf210 = {
    ar: `\u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{642}`,
    de: `Kommentaraktionen`,
    es: `Acciones de comentario`,
    fa: `\u{627}\u{642}\u{62F}\u{627}\u{645}\u{627}\u{62A} \u{646}\u{638}\u{631}`,
    fil: `Mga aksyon ng komento`,
    fr: `Actions sur le commentaire`,
    hi: `\u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{940} \u{915}\u{94D}\u{930}\u{93F}\u{92F}\u{93E}\u{90F}\u{901}`,
    ht: `Aksyon k\xf2mant\xe8`,
    it: `Azioni commento`,
    ja: `\u{30B3}\u{30E1}\u{30F3}\u{30C8}\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}`,
    ko: `\u{B313}\u{AE00} \u{D589}\u{B3D9}`,
    mww: `Tawm tswv yim ua`,
    ps: `\u{62F} \u{646}\u{638}\u{631}\u{648}\u{646}\u{648} \u{6A9}\u{693}\u{646}\u{6D0}`,
    pt: `A\xe7\xf5es do coment\xe1rio`,
    'pt-pt': `A\xe7\xf5es de coment\xe1rio`,
    ru: `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{441} \u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{44F}\u{43C}\u{438}`,
    sm: `Faatinoga o faamatalaga`,
    so: `Falalka faallooyinka`,
    th: `\u{E01}\u{E32}\u{E23}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E41}\u{E2A}\u{E14}\u{E07}\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}`,
    ur: `\u{62A}\u{628}\u{635}\u{631}\u{6C1} \u{6A9}\u{6D2} \u{627}\u{642}\u{62F}\u{627}\u{645}\u{627}\u{62A}`,
    vi: `H\xe0nh \u{111}\u{1ED9}ng nh\u{1EAD}n x\xe9t`,
    'zh-hans': `\u{8BC4}\u{8BBA}\u{64CD}\u{4F5C}`,
    'zh-hant': `\u{7559}\u{8A00}\u{64CD}\u{4F5C}`,
    en: `Comment actions`
};
const $b11db1b62d4a8f76$export$abf4bfeea8a809b3 = {
    ar: (count)=>`${count} \u{62A}\u{639}\u{644}\u{64A}\u{642}\u{627}\u{62A}`,
    de: (count)=>`${count} Kommentare`,
    es: (count)=>`${count} comentarios`,
    fa: (count)=>`${count} \u{646}\u{638}\u{631}`,
    fil: (count)=>`${count} Mga Komento`,
    fr: (count)=>`${count} commentaires`,
    hi: (count)=>`${count} \u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: (count)=>`${count} k\xf2mant\xe8`,
    it: (count)=>`${count} commenti`,
    ja: (count)=>`${count} \u{4EF6}\u{306E}\u{30B3}\u{30E1}\u{30F3}\u{30C8}`,
    ko: (count)=>`${count} \u{AC1C}\u{C758} \u{B313}\u{AE00}`,
    mww: (count)=>`${count} comments`,
    ps: (count)=>`${count} \u{62A}\u{628}\u{635}\u{631}\u{6D0}`,
    pt: (count)=>`${count} coment\xe1rios`,
    'pt-pt': (count)=>`${count} coment\xe1rios`,
    ru: (count)=>`${count} \u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{435}\u{432}`,
    sm: (count)=>`${count} fa'amatalaga`,
    so: (count)=>`${count} faallooyin`,
    th: (count)=>`${count} \u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}`,
    ur: (count)=>`${count} \u{62A}\u{628}\u{635}\u{631}\u{6D2}`,
    vi: (count)=>`${count} b\xecnh lu\u{1EAD}n`,
    'zh-hans': (count)=>`${count} \u{6761}\u{8BC4}\u{8BBA}`,
    'zh-hant': (count)=>`${count} \u{5247}\u{7559}\u{8A00}`,
    en: (count)=>`${count} comments`
};
const $b11db1b62d4a8f76$export$e0f8ffeffb71452 = {
    ar: `\u{62A}\u{639}\u{644}\u{64A}\u{642} \u{648}\u{627}\u{62D}\u{62F}`,
    de: `1 Kommentar`,
    es: `1 comentario`,
    fa: `\u{6F1} \u{646}\u{638}\u{631}`,
    fil: `1 komento`,
    fr: `1 commentaire`,
    hi: `1 \u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{940}`,
    ht: `1 k\xf2mant\xe8`,
    it: `1 commento`,
    ja: `1\u{4EF6}\u{306E}\u{30B3}\u{30E1}\u{30F3}\u{30C8}`,
    ko: `\u{B313}\u{AE00} 1\u{AC1C}`,
    mww: `1 saib`,
    ps: `\u{6F1} \u{62A}\u{628}\u{635}\u{631}\u{647}`,
    pt: `1 coment\xe1rio`,
    'pt-pt': `1 coment\xe1rio`,
    ru: `1 \u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{439}`,
    sm: `1 faamatalaga`,
    so: `1 faallo`,
    th: `1 \u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}`,
    ur: `1 \u{62A}\u{628}\u{635}\u{631}\u{6C1}`,
    vi: `1 b\xecnh lu\u{1EAD}n`,
    'zh-hans': `1\u{6761}\u{8BC4}\u{8BBA}`,
    'zh-hant': `1\u{5247}\u{7559}\u{8A00}`,
    en: `1 comment`
};
const $b11db1b62d4a8f76$export$6572ae3c15566261 = {
    ar: `\u{639}\u{644}\u{642}\u{62A} \u{639}\u{644}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Zu dieser Aktivit\xe4t kommentiert.`,
    es: `Coment\xe9 sobre esta actividad.`,
    fa: `\u{62F}\u{631} \u{645}\u{648}\u{631}\u{62F} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{646}\u{638}\u{631} \u{62F}\u{627}\u{62F}\u{645}.`,
    fil: `Nagkomento tungkol sa aktibidad na ito.`,
    fr: `Comment\xe9 cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930} \u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{940} \u{915}\u{940}\u{964}`,
    ht: `K\xf2mant\xe8 sou aktivite sa a.`,
    it: `Ho commentato questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306B}\u{3064}\u{3044}\u{3066}\u{30B3}\u{30E1}\u{30F3}\u{30C8}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{B300}\u{D574} \u{B313}\u{AE00}\u{C744} \u{B2EC}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tawm tswv yim txog qhov kev ua no.`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{67E}\u{647} \u{627}\u{693}\u{647} \u{645}\u{6D0} \u{62A}\u{628}\u{635}\u{631}\u{647} \u{6A9}\u{693}\u{6D0} \u{648}\u{647}.`,
    pt: `Comentei sobre essa atividade.`,
    'pt-pt': `Comentei sobre esta atividade.`,
    ru: `\u{41F}\u{440}\u{43E}\u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43B} \u{44D}\u{442}\u{443} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `Na ia fa'amatalaina lenei gaoioiga.`,
    so: `Waxaan faallo ka bixiyay hawshan.`,
    th: `\u{E41}\u{E2A}\u{E14}\u{E07}\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E01}\u{E31}\u{E1A}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{67E}\u{631} \u{62A}\u{628}\u{635}\u{631}\u{6C1} \u{6A9}\u{6CC}\u{627}\u{6D4}`,
    vi: `Nh\u{1EAD}n x\xe9t v\u{1EC1} ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{5BF9}\u{6B64}\u{6D3B}\u{52A8}\u{53D1}\u{8868}\u{4E86}\u{8BC4}\u{8BBA}\u{3002}`,
    'zh-hant': `\u{6211}\u{5C0D}\u{9019}\u{500B}\u{6D3B}\u{52D5}\u{6709}\u{7559}\u{8A00}\u{3002}`,
    en: `Commented on this activity.`
};
const $b11db1b62d4a8f76$export$2a78fded91470879 = {
    ar: `\u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{642} \u{645}\u{637}\u{644}\u{648}\u{628} \u{639}\u{646}\u{62F} \u{631}\u{641}\u{636} \u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{632}\u{645}\u{646}.`,
    de: `Ein Kommentar ist erforderlich, wenn man einen Stundenzettel ablehnt.`,
    es: `Es necesario comentar al negar una hoja de horas.`,
    fa: `\u{647}\u{646}\u{6AF}\u{627}\u{645} \u{631}\u{62F} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC}\u{60C} \u{646}\u{638}\u{631} \u{62F}\u{627}\u{62F}\u{646} \u{644}\u{627}\u{632}\u{645} \u{627}\u{633}\u{62A}.`,
    fil: `Kinakailangan ang komento kapag tinanggihan ang isang timesheet.`,
    fr: `Un commentaire est n\xe9cessaire lorsqu\u{2019}on refuse une feuille de temps.`,
    hi: `\u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{915}\u{94B} \u{905}\u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{915}\u{930}\u{924}\u{947} \u{938}\u{92E}\u{92F} \u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{940} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{94B}\u{924}\u{940} \u{939}\u{948}\u{964}`,
    ht: `K\xf2mant\xe8 obligatwa l\xe8 rejte yon Timesheet.`,
    it: `\xc8 necessario commentare quando si nega un foglio presenze.`,
    ja: `\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{3092}\u{62D2}\u{5426}\u{3059}\u{308B}\u{5834}\u{5408}\u{306F}\u{30B3}\u{30E1}\u{30F3}\u{30C8}\u{304C}\u{5FC5}\u{8981}\u{3067}\u{3059}\u{3002}`,
    ko: `\u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C}\u{B97C} \u{AC70}\u{BD80}\u{D560} \u{B54C}\u{B294} \u{C758}\u{ACAC}\u{C774} \u{D544}\u{C694}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Yuav tsum tau tawm tswv yim thaum tsis kam lees ib daim ntawv teev sijhawm.`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{6D0} \u{62F} \u{631}\u{62F}\u{648}\u{644}\u{648} \u{67E}\u{631} \u{645}\u{647}\u{627}\u{644} \u{62A}\u{628}\u{635}\u{631}\u{647} \u{627}\u{693}\u{6CC}\u{646} \u{62F}\u{647}.`,
    pt: `Coment\xe1rio \xe9 necess\xe1rio ao negar uma folha de ponto.`,
    'pt-pt': `\xc9 necess\xe1rio comentar ao negar uma folha de pontos.`,
    ru: `\u{41F}\u{440}\u{438} \u{43E}\u{442}\u{43A}\u{430}\u{437}\u{435} \u{432} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{435} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{442}\u{440}\u{435}\u{431}\u{443}\u{435}\u{442}\u{441}\u{44F} \u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{439}.`,
    sm: `E mana'omia se fa'amatalaga pe a teena se pepa o taimi.`,
    so: `Faallo ayaa loo baahan yahay marka la diidayo warqadda waqtiga.`,
    th: `\u{E08}\u{E4D}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E41}\u{E2A}\u{E14}\u{E07}\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}\u{E40}\u{E21}\u{E37}\u{E48}\u{E2D}\u{E1B}\u{E0F}\u{E34}\u{E40}\u{E2A}\u{E18}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}`,
    ur: `\u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{6A9}\u{648} \u{645}\u{633}\u{62A}\u{631}\u{62F} \u{6A9}\u{631}\u{62A}\u{6D2} \u{648}\u{642}\u{62A} \u{62A}\u{628}\u{635}\u{631}\u{6C1} \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Nh\u{1EAD}n x\xe9t l\xe0 b\u{1EAF}t bu\u{1ED9}c khi t\u{1EEB} ch\u{1ED1}i b\u{1EA3}ng ch\u{1EA5}m c\xf4ng.`,
    'zh-hans': `\u{62D2}\u{7EDD}\u{5DE5}\u{65F6}\u{8868}\u{65F6}\u{5FC5}\u{987B}\u{53D1}\u{8868}\u{8BC4}\u{8BBA}\u{3002}`,
    'zh-hant': `\u{62D2}\u{7D55}\u{5DE5}\u{6642}\u{8868}\u{6642}\u{5FC5}\u{9808}\u{63D0}\u{51FA}\u{8A55}\u{8AD6}\u{3002}`,
    en: `Comment is required when denying a timesheet.`
};
const $b11db1b62d4a8f76$export$2a353ffa74523b9e = {
    ar: `\u{62A}\u{639}\u{644}\u{64A}\u{642}\u{627}\u{62A}`,
    de: `Kommentare`,
    es: `Comentarios`,
    fa: `\u{646}\u{638}\u{631}\u{627}\u{62A}`,
    fil: `Mga Komento`,
    fr: `Commentaires`,
    hi: `\u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `K\xf2mant\xe8`,
    it: `Commenti`,
    ja: `\u{30B3}\u{30E1}\u{30F3}\u{30C8}`,
    ko: `\u{B313}\u{AE00}`,
    mww: `Cov lus`,
    ps: `\u{62A}\u{628}\u{635}\u{631}\u{6D0}`,
    pt: `Coment\xe1rios`,
    'pt-pt': `Coment\xe1rios`,
    ru: `\u{41A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{438}`,
    sm: `Faamatalaga`,
    so: `Faallooyin`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}`,
    ur: `\u{62A}\u{628}\u{635}\u{631}\u{6D2}`,
    vi: `B\xecnh lu\u{1EAD}n`,
    'zh-hans': `\u{8BC4}\u{8BBA}`,
    'zh-hant': `\u{7559}\u{8A00}`,
    en: `Comments`
};
const $b11db1b62d4a8f76$export$e4f377e71a52d72f = {
    ar: `\u{627}\u{644}\u{634}\u{631}\u{643}\u{629}`,
    de: `Gesellschaft`,
    es: `Compa\xf1\xeda`,
    fa: `\u{634}\u{631}\u{6A9}\u{62A}`,
    fil: `Kumpanya`,
    fr: `Entreprise`,
    hi: `\u{905}\u{924}\u{93F}\u{925}\u{93F}`,
    ht: `Konpayi an`,
    it: `Azienda`,
    ja: `\u{4F1A}\u{793E}`,
    ko: `\u{D68C}\u{C0AC}`,
    mww: `Lub tuam txhab`,
    ps: `\u{634}\u{631}\u{6A9}\u{62A}`,
    pt: `Empresa`,
    'pt-pt': `Empresa`,
    ru: `\u{41A}\u{43E}\u{43C}\u{43F}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Kamupani`,
    so: `Shirkad`,
    th: `\u{E1A}\u{E23}\u{E34}\u{E29}\u{E31}\u{E17}`,
    ur: `\u{6A9}\u{645}\u{67E}\u{646}\u{6CC}`,
    vi: `C\xf4ng ty`,
    'zh-hans': `\u{516C}\u{53F8}`,
    'zh-hant': `\u{516C}\u{53F8}`,
    en: `Company`
};
const $b11db1b62d4a8f76$export$999899789a85b9f2 = {
    ar: `\u{627}\u{643}\u{62A}\u{645}\u{644}`,
    de: `Vollst\xe4ndig`,
    es: `Completo`,
    fa: `\u{6A9}\u{627}\u{645}\u{644}`,
    fil: `Kumpleto`,
    fr: `Complet`,
    hi: `\u{92A}\u{942}\u{930}\u{93E}`,
    ht: `Konplete`,
    it: `Completa`,
    ja: `\u{5B8C}\u{4E86}`,
    ko: `\u{C644}\u{C804}`,
    mww: `Ua tiav`,
    ps: `\u{628}\u{634}\u{67E}\u{693}`,
    pt: `Completo`,
    'pt-pt': `Completo`,
    ru: `\u{417}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43E}`,
    sm: `Mae'a`,
    so: `Dhameystiran`,
    th: `\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{645}\u{6A9}\u{645}\u{644}`,
    vi: `Ho\xe0n ch\u{1EC9}nh`,
    'zh-hans': `\u{5B8C}\u{6574}`,
    'zh-hant': `\u{5B8C}\u{7D50}`,
    en: `Complete`
};
const $b11db1b62d4a8f76$export$49b81392f6018765 = {
    ar: `\u{627}\u{643}\u{62A}\u{645}\u{644}`,
    de: `Abgeschlossen`,
    es: `Completado`,
    fa: `\u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{634}\u{62F}\u{647}`,
    fil: `Nakumpleto`,
    fr: `Ach\xe8vement`,
    hi: `\u{92A}\u{942}\u{930}\u{93E}`,
    ht: `Konplete`,
    it: `Completato`,
    ja: `\u{5B8C}\u{4E86}`,
    ko: `\u{C644}\u{C131}\u{B428}`,
    mww: `ua tiav`,
    ps: `\u{628}\u{634}\u{67E}\u{693} \u{634}\u{648}\u{6CC}`,
    pt: `Conclu\xeddo`,
    'pt-pt': `Conclu\xeddo`,
    ru: `\u{417}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43E}`,
    sm: `Faamaeaina`,
    so: `La dhammeystiray`,
    th: `\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{645}\u{6A9}\u{645}\u{644}`,
    vi: `\u{110}\xe3 ho\xe0n th\xe0nh`,
    'zh-hans': `\u{5B8C}\u{5DE5}`,
    'zh-hant': `\u{5B8C}\u{6210}`,
    en: `Completed`
};
const $b11db1b62d4a8f76$export$ecd960c60eeecfdb = {
    ar: `\u{62A}\u{645} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621} \u{645}\u{646} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Die Aktivit\xe4t ist abgeschlossen.`,
    es: `La actividad ha finalizado.`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{647} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{631}\u{633}\u{6CC}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Nakumpleto na ang aktibidad.`,
    fr: `L\u{2019}activit\xe9 est termin\xe9e.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{942}\u{930}\u{940} \u{939}\u{94B} \u{91A}\u{941}\u{915}\u{940} \u{939}\u{948}\u{964}`,
    ht: `Aktivite a te konplete`,
    it: `L'attivit\xe0 \xe8 stata completata.`,
    ja: `\u{6D3B}\u{52D5}\u{306F}\u{5B8C}\u{4E86}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{D65C}\u{B3D9}\u{C740} \u{C644}\u{B8CC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kev ua haujlwm tau ua tiav.`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{634}\u{67E}\u{693} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: `A atividade foi conclu\xedda.`,
    'pt-pt': `A atividade foi conclu\xedda.`,
    ru: `\u{414}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{430}.`,
    sm: `Ua mae'a le gaoioiga.`,
    so: `Hawlgalka waa la dhammeeyay.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6A9}\u{645}\u{644} \u{6C1}\u{648} \u{686}\u{6A9}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\xe3 ho\xe0n t\u{1EA5}t.`,
    'zh-hans': `\u{6D3B}\u{52A8}\u{5DF2}\u{5B8C}\u{6210}\u{3002}`,
    'zh-hant': `\u{6D3B}\u{52D5}\u{5DF2}\u{5B8C}\u{6210}\u{3002}`,
    en: `The activity has been completed.`
};
const $b11db1b62d4a8f76$export$fb65fe225f63a528 = {
    ar: `\u{642}\u{631}\u{627}\u{621}\u{629} \u{645}\u{634}\u{631}\u{648}\u{637}\u{629} \u{641}\u{642}\u{637}`,
    de: `Bedingt schreibgesch\xfctzt`,
    es: `Solo lectura condicional`,
    fa: `\u{641}\u{642}\u{637} \u{62E}\u{648}\u{627}\u{646}\u{62F}\u{646}\u{6CC} \u{634}\u{631}\u{637}\u{6CC}`,
    fil: `Kundisyonal na basahin lamang`,
    fr: `Lecture seule conditionnelle`,
    hi: `\u{938}\u{936}\u{930}\u{94D}\u{924} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{915}\u{947}\u{935}\u{932}-\u{92A}\u{922}\u{93C}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F}`,
    ht: `Kondisyon li s\xe8lman`,
    it: `Lettura di sola condizionata`,
    ja: `\u{6761}\u{4EF6}\u{4ED8}\u{304D}\u{8AAD}\u{307F}\u{53D6}\u{308A}\u{5C02}\u{7528}`,
    ko: `\u{C870}\u{AC74}\u{BD80} \u{C77D}\u{AE30} \u{C804}\u{C6A9}`,
    mww: `Conditionally nyeem nkaus xwb`,
    ps: `\u{6CC}\u{648}\u{627}\u{632}\u{6D0} \u{62F} \u{645}\u{634}\u{631}\u{648}\u{637} \u{644}\u{648}\u{633}\u{62A}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647}`,
    pt: `Somente leitura condicional`,
    'pt-pt': `Apenas leitura condicional`,
    ru: `\u{423}\u{441}\u{43B}\u{43E}\u{432}\u{43D}\u{43E} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{434}\u{43B}\u{44F} \u{447}\u{442}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Faitau na'o tuutuuga`,
    so: `Shuruud ahaan akhris kaliya`,
    th: `\u{E2D}\u{E48}\u{E32}\u{E19}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E41}\u{E1A}\u{E1A}\u{E21}\u{E35}\u{E40}\u{E07}\u{E37}\u{E48}\u{E2D}\u{E19}\u{E44}\u{E02}`,
    ur: `\u{645}\u{634}\u{631}\u{648}\u{637} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{635}\u{631}\u{641} \u{67E}\u{691}\u{6BE}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2}`,
    vi: `Ch\u{1EC9} \u{111}\u{1ECD}c c\xf3 \u{111}i\u{1EC1}u ki\u{1EC7}n`,
    'zh-hans': `\u{6761}\u{4EF6}\u{53EA}\u{8BFB}`,
    'zh-hant': `\u{689D}\u{4EF6}\u{552F}\u{8B80}`,
    en: `Conditionally read-only`
};
const $b11db1b62d4a8f76$export$6532cc8711b7a07d = {
    ar: `\u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644} \u{644}\u{644}\u{642}\u{631}\u{627}\u{621}\u{629} \u{641}\u{642}\u{637} \u{628}\u{633}\u{628}\u{628} \u{634}\u{631}\u{648}\u{637} \u{64A}\u{62D}\u{62F}\u{62F}\u{647}\u{627} \u{645}\u{633}\u{624}\u{648}\u{644} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639}.`,
    de: `Dieser Datensatz ist schreibgesch\xfctzt aufgrund der vom Projektadministrator gesetzten Bedingungen.`,
    es: `Este registro es de solo lectura debido a condiciones establecidas por el administrador del proyecto.`,
    fa: `\u{627}\u{6CC}\u{646} \u{631}\u{6A9}\u{648}\u{631}\u{62F} \u{628}\u{647} \u{62F}\u{644}\u{6CC}\u{644} \u{634}\u{631}\u{627}\u{6CC}\u{637}\u{6CC} \u{6A9}\u{647} \u{62A}\u{648}\u{633}\u{637} \u{645}\u{62F}\u{6CC}\u{631} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{62A}\u{639}\u{6CC}\u{6CC}\u{646} \u{634}\u{62F}\u{647}\u{60C} \u{641}\u{642}\u{637} \u{62E}\u{648}\u{627}\u{646}\u{62F}\u{646}\u{6CC} \u{627}\u{633}\u{62A}.`,
    fil: `Ang rekord na ito ay read-only dahil sa mga kondisyon na itinakda ng tagapangasiwa ng proyekto.`,
    fr: `Cet enregistrement est en lecture seule en raison des conditions impos\xe9es par l\u{2019}administrateur du projet.`,
    hi: `\u{92F}\u{939} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{92A}\u{94D}\u{930}\u{94B}\u{91C}\u{947}\u{915}\u{94D}\u{91F} \u{935}\u{94D}\u{92F}\u{935}\u{938}\u{94D}\u{925}\u{93E}\u{92A}\u{915} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{938}\u{947}\u{91F} \u{915}\u{940} \u{917}\u{908} \u{936}\u{930}\u{94D}\u{924}\u{94B}\u{902} \u{915}\u{947} \u{915}\u{93E}\u{930}\u{923} \u{915}\u{947}\u{935}\u{932}-\u{92A}\u{922}\u{93C}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{939}\u{948}\u{964}`,
    ht: `Dosye sa a se li s\xe8lman ak\xf2z kondisyon ki etabli pa administrat\xe8 pwoj\xe8 a.`,
    it: `Questo record \xe8 di sola lettura a causa delle condizioni imposte dall'amministratore del progetto.`,
    ja: `\u{3053}\u{306E}\u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{306F}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{7BA1}\u{7406}\u{8005}\u{304C}\u{8A2D}\u{5B9A}\u{3057}\u{305F}\u{6761}\u{4EF6}\u{306B}\u{3088}\u{308A}\u{8AAD}\u{307F}\u{53D6}\u{308A}\u{5C02}\u{7528}\u{3067}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{B808}\u{CF54}\u{B4DC}\u{B294} \u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{AD00}\u{B9AC}\u{C790}\u{AC00} \u{C124}\u{C815}\u{D55C} \u{C870}\u{AC74} \u{B54C}\u{BB38}\u{C5D0} \u{C77D}\u{AE30} \u{C804}\u{C6A9}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Cov ntaub ntawv no yog nyeem nkaus xwb vim yog cov xwm txheej uas tau teev tseg los ntawm tus thawj tswj hwm qhov project.`,
    ps: `\u{62F}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{6CC}\u{648}\u{627}\u{632}\u{6D0} \u{62F} \u{644}\u{648}\u{633}\u{62A}\u{644}\u{648} \u{648}\u{693} \u{62F}\u{6CC} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62F} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{645}\u{62F}\u{6CC}\u{631} \u{644}\u{62E}\u{648}\u{627} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{634}\u{631}\u{627}\u{6CC}\u{637} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: `Este registro \xe9 somente leitura devido a condi\xe7\xf5es estabelecidas pelo administrador do projeto.`,
    'pt-pt': `Este registo \xe9 apenas de leitura devido a condi\xe7\xf5es definidas pelo administrador do projeto.`,
    ru: `\u{42D}\u{442}\u{430} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{434}\u{43B}\u{44F} \u{447}\u{442}\u{435}\u{43D}\u{438}\u{44F} \u{438}\u{437}-\u{437}\u{430} \u{443}\u{441}\u{43B}\u{43E}\u{432}\u{438}\u{439}, \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{445} \u{430}\u{434}\u{43C}\u{438}\u{43D}\u{438}\u{441}\u{442}\u{440}\u{430}\u{442}\u{43E}\u{440}\u{43E}\u{43C} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{430}.`,
    sm: `O lenei faamaumauga e na o le faitauina ona o tuutuuga ua setiina e le pule o le galuega faatino.`,
    so: `Diiwaankan waa akhris kaliya sababtoo ah shuruudaha uu dejiyay maamulaha mashruuca.`,
    th: `\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E19}\u{E35}\u{E49}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E41}\u{E1A}\u{E1A}\u{E2D}\u{E48}\u{E32}\u{E19}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E40}\u{E07}\u{E37}\u{E48}\u{E2D}\u{E19}\u{E44}\u{E02}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E42}\u{E14}\u{E22}\u{E1C}\u{E39}\u{E49}\u{E14}\u{E39}\u{E41}\u{E25}\u{E23}\u{E30}\u{E1A}\u{E1A}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{6CC}\u{6C1} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{635}\u{631}\u{641} \u{67E}\u{691}\u{6BE}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{6C1}\u{648}\u{62A}\u{627} \u{6C1}\u{6D2} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679} \u{627}\u{6CC}\u{688}\u{645}\u{646}\u{633}\u{679}\u{631}\u{6CC}\u{679}\u{631} \u{646}\u{6D2} \u{634}\u{631}\u{627}\u{626}\u{637} \u{645}\u{642}\u{631}\u{631} \u{6A9}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `B\u{1EA3}n ghi n\xe0y \u{1EDF} ch\u{1EBF} \u{111}\u{1ED9} ch\u{1EC9} \u{111}\u{1ECD}c do c\xe1c \u{111}i\u{1EC1}u ki\u{1EC7}n do qu\u{1EA3}n tr\u{1ECB} vi\xean d\u{1EF1} \xe1n \u{111}\u{1EB7}t ra.`,
    'zh-hans': `\u{7531}\u{4E8E}\u{9879}\u{76EE}\u{7BA1}\u{7406}\u{5458}\u{8BBE}\u{5B9A}\u{7684}\u{6761}\u{4EF6}\u{FF0C}\u{8BE5}\u{8BB0}\u{5F55}\u{4E3A}\u{53EA}\u{8BFB}\u{3002}`,
    'zh-hant': `\u{7531}\u{65BC}\u{5C08}\u{6848}\u{7BA1}\u{7406}\u{54E1}\u{8A2D}\u{5B9A}\u{7684}\u{689D}\u{4EF6}\u{FF0C}\u{6B64}\u{7D00}\u{9304}\u{70BA}\u{552F}\u{8B80}\u{3002}`,
    en: `This record is read-only due to conditions set by the project administrator.`
};
const $b11db1b62d4a8f76$export$1b959d4366715b3b = {
    ar: `\u{62A}\u{623}\u{643}\u{64A}\u{62F}`,
    de: `Best\xe4tigen`,
    es: `Confirmar`,
    fa: `\u{62A}\u{623}\u{6CC}\u{6CC}\u{62F}`,
    fil: `Kumpirmahin`,
    fr: `Confirmez`,
    hi: `\u{938}\u{941}\u{926}\u{943}\u{922}\u{93C} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `Konfime`,
    it: `Conferma`,
    ja: `\u{78BA}\u{8A8D}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{D655}\u{C778}\u{D574}`,
    mww: `Paub meej`,
    ps: `\u{62A}\u{627}\u{6CC}\u{6CC}\u{62F} \u{6A9}\u{693}\u{647}`,
    pt: `Confirme`,
    'pt-pt': `Confirmar`,
    ru: `\u{41F}\u{43E}\u{434}\u{442}\u{432}\u{435}\u{440}\u{434}\u{438}\u{442}\u{435}`,
    sm: `Fa'amaonia`,
    so: `Xaqiiji`,
    th: `\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}`,
    ur: `\u{62A}\u{635}\u{62F}\u{6CC}\u{642}`,
    vi: `X\xe1c nh\u{1EAD}n`,
    'zh-hans': `\u{786E}\u{8BA4}`,
    'zh-hant': `\u{78BA}\u{8A8D}`,
    en: `Confirm`
};
const $b11db1b62d4a8f76$export$d3f083e9ed202085 = {
    ar: `\u{62A}\u{623}\u{643}\u{64A}\u{62F} \u{62D}\u{630}\u{641}`,
    de: `Best\xe4tigen, l\xf6schen`,
    es: `Confirmar eliminar`,
    fa: `\u{62A}\u{623}\u{6CC}\u{6CC}\u{62F} \u{62D}\u{630}\u{641}`,
    fil: `Kumpirmahin ang pagtanggal`,
    fr: `Confirmer supprimer`,
    hi: `\u{939}\u{91F}\u{93E}\u{90F} \u{91C}\u{93E}\u{928}\u{947} \u{915}\u{940} \u{92A}\u{941}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Konfime efase`,
    it: `Conferma elimina`,
    ja: `\u{78BA}\u{8A8D} \u{524A}\u{9664}`,
    ko: `\u{D655}\u{C778} \u{C0AD}\u{C81C}`,
    mww: `Paub meej tias rho tawm`,
    ps: `\u{62A}\u{627}\u{6CC}\u{6CC}\u{62F}\u{60C} \u{62D}\u{630}\u{641}`,
    pt: `Confirmar exclus\xe3o`,
    'pt-pt': `Confirmar elimina\xe7\xe3o`,
    ru: `\u{41F}\u{43E}\u{434}\u{442}\u{432}\u{435}\u{440}\u{434}\u{438}\u{442}\u{44C}, \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}`,
    sm: `Faamaonia le tapeina`,
    so: `Xaqiiji tirtirka`,
    th: `\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E01}\u{E32}\u{E23}\u{E25}\u{E1A}`,
    ur: `\u{688}\u{6CC}\u{644}\u{6CC}\u{679} \u{6A9}\u{6CC} \u{62A}\u{635}\u{62F}\u{6CC}\u{642}`,
    vi: `X\xe1c nh\u{1EAD}n x\xf3a`,
    'zh-hans': `\u{786E}\u{8BA4}\u{5220}\u{9664}`,
    'zh-hant': `\u{78BA}\u{8A8D}\u{522A}\u{9664}`,
    en: `Confirm delete`
};
const $b11db1b62d4a8f76$export$30aaf2514f0013cf = {
    ar: `\u{647}\u{644} \u{623}\u{646}\u{62A} \u{645}\u{62A}\u{623}\u{643}\u{62F} \u{623}\u{646}\u{643} \u{62A}\u{631}\u{64A}\u{62F} \u{62D}\u{630}\u{641} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}\u{61F}`,
    de: `Bist du sicher, dass du diese Signatur l\xf6schen willst?`,
    es: `\xbfEst\xe1s seguro de que quieres borrar esta firma?`,
    fa: `\u{645}\u{637}\u{645}\u{626}\u{646}\u{6CC} \u{645}\u{6CC} \u{62E}\u{648}\u{627}\u{6CC} \u{627}\u{6CC}\u{646} \u{627}\u{645}\u{636}\u{627} \u{631}\u{648} \u{62D}\u{630}\u{641} \u{6A9}\u{646}\u{6CC}\u{61F}`,
    fil: `Sigurado ka bang nais mong tanggalin ang lagda na ito?`,
    fr: `\xcates-vous s\xfbr de vouloir supprimer cette signature ?`,
    hi: `\u{915}\u{94D}\u{92F}\u{93E} \u{906}\u{92A} \u{935}\u{93E}\u{915}\u{908} \u{907}\u{938} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{94B} \u{939}\u{91F}\u{93E}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{924}\u{947} \u{939}\u{948}\u{902}?`,
    ht: `\xc8ske ou s\xe8ten ou vle efase siyati sa a?`,
    it: `Sei sicuro di voler cancellare questa firma?`,
    ja: `\u{672C}\u{5F53}\u{306B}\u{3053}\u{306E}\u{7F72}\u{540D}\u{3092}\u{524A}\u{9664}\u{3057}\u{305F}\u{3044}\u{306E}\u{3067}\u{3059}\u{304B}?`,
    ko: `\u{C774} \u{C11C}\u{BA85}\u{C744} \u{C0AD}\u{C81C}\u{D560} \u{AC70} \u{D655}\u{C2E4}\u{D574}?`,
    mww: `Koj puas paub tseeb tias koj xav rho tawm qhov kos npe no?`,
    ps: `\u{62A}\u{647} \u{689}\u{627}\u{689}\u{647} \u{6CC}\u{6D0} \u{686}\u{6D0} \u{62F}\u{627} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{62D}\u{630}\u{641} \u{6A9}\u{648}\u{644} \u{63A}\u{648}\u{627}\u{693}\u{6D0}\u{61F}`,
    pt: `Tem certeza de que quer apagar essa assinatura?`,
    'pt-pt': `Tens a certeza de que queres apagar esta assinatura?`,
    ru: `\u{412}\u{44B} \u{443}\u{432}\u{435}\u{440}\u{435}\u{43D}\u{44B}, \u{447}\u{442}\u{43E} \u{445}\u{43E}\u{442}\u{438}\u{442}\u{435} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{44D}\u{442}\u{443} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}?`,
    sm: `E te mautinoa e te manao e tapeese lenei saini?`,
    so: `Ma hubtaa inaad rabto inaad tirtirto saxiixan?`,
    th: `\u{E04}\u{E38}\u{E13}\u{E41}\u{E19}\u{E48}\u{E43}\u{E08}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E44}\u{E21}\u{E48}\u{E27}\u{E48}\u{E32}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E25}\u{E1A}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E19}\u{E35}\u{E49}?`,
    ur: `\u{6A9}\u{6CC}\u{627} \u{622}\u{67E} \u{648}\u{627}\u{642}\u{639}\u{6CC} \u{627}\u{633} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{648} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{61F}`,
    vi: `B\u{1EA1}n c\xf3 ch\u{1EAF}c ch\u{1EAF}n mu\u{1ED1}n x\xf3a ch\u{1EEF} k\xfd n\xe0y kh\xf4ng?`,
    'zh-hans': `\u{4F60}\u{786E}\u{5B9A}\u{8981}\u{5220}\u{9664}\u{8FD9}\u{4E2A}\u{7B7E}\u{540D}\u{5417}\u{FF1F}`,
    'zh-hant': `\u{4F60}\u{78BA}\u{5B9A}\u{8981}\u{522A}\u{9664}\u{9019}\u{500B}\u{7C3D}\u{540D}\u{55CE}\u{FF1F}`,
    en: `Are you sure you want to delete this signature?`
};
const $b11db1b62d4a8f76$export$1a8a254672f8f802 = {
    ar: (person)=>$b11db1b62d4a8f76$var$html`<span>أكد أن هذا العميل نسخة مكررة من ${person}</span>`,
    de: (person)=>$b11db1b62d4a8f76$var$html`<span>Bestätigen Sie, dass dieser Kunde ein Duplikat von ${person} ist.</span>`,
    es: (person)=>$b11db1b62d4a8f76$var$html`<span>Confirma que este cliente es un duplicado de ${person}</span>`,
    fa: (person)=>$b11db1b62d4a8f76$var$html`<span>تأیید کنید این مشتری کپی ${person} است</span>`,
    fil: (person)=>$b11db1b62d4a8f76$var$html`<span>Kumpirmahin na ang kliyente na ito ay isang duplicate ng ${person}</span>`,
    fr: (person)=>$b11db1b62d4a8f76$var$html`<span>Confirmez que ce client est un double de ${person}</span>`,
    hi: (person)=>$b11db1b62d4a8f76$var$html`<span>पुष्टि करें कि यह क्लाइंट ${person} का डुप्लिकेट है</span>`,
    ht: (person)=>$b11db1b62d4a8f76$var$html`<span>Konfime kliyan sa a se yon kopi ${person}</span>`,
    it: (person)=>$b11db1b62d4a8f76$var$html`<span>Conferma che questo cliente sia un duplicato di ${person}</span>`,
    ja: (person)=>$b11db1b62d4a8f76$var$html`<span>このクライアントが${person}複製であることを確認してください</span>`,
    ko: (person)=>$b11db1b62d4a8f76$var$html`<span>이 클라이언트가 ${person}의 중복인지 확인해 주세요</span>`,
    mww: (person)=>$b11db1b62d4a8f76$var$html`<span>Paub tseeb tias tus neeg siv khoom no yog ib qho theej tawm ntawm ${person}</span>`,
    ps: (person)=>$b11db1b62d4a8f76$var$html`<span>تایید کړه چې دا مشتری ${person} نقل دی</span>`,
    pt: (person)=>$b11db1b62d4a8f76$var$html`<span>Confirme que este cliente é um duplicado de ${person}</span>`,
    'pt-pt': (person)=>$b11db1b62d4a8f76$var$html`<span>Confirme que este cliente é um duplicado de ${person}</span>`,
    ru: (person)=>$b11db1b62d4a8f76$var$html`<span>Подтвердите, что этот клиент — копия ${person}</span>`,
    sm: (person)=>$b11db1b62d4a8f76$var$html`<span>Ia faamaonia o lenei tagata o se kopi o ${person}</span>`,
    so: (person)=>$b11db1b62d4a8f76$var$html`<span>Xaqiiji in macmiilkan uu yahay nuqul ${person}</span>`,
    th: (person)=>$b11db1b62d4a8f76$var$html`<span>ยืนยันว่าไคลเอ็นต์นี้เป็นสําเนาของ ${person}</span>`,
    ur: (person)=>$b11db1b62d4a8f76$var$html`<span>تصدیق کریں کہ یہ کلائنٹ ${person} کا نقل ہے</span>`,
    vi: (person)=>$b11db1b62d4a8f76$var$html`<span>Xác nhận ứng dụng này là bản sao của ${person}</span>`,
    'zh-hans': (person)=>$b11db1b62d4a8f76$var$html`<span>确认这个客户是${person}的复制品</span>`,
    'zh-hant': (person)=>$b11db1b62d4a8f76$var$html`<span>確認此客戶是否為${person}的複製品</span>`,
    en: (person)=>$b11db1b62d4a8f76$var$html`<span>Confirm this client is a duplicate of ${person}</span>`
};
const $b11db1b62d4a8f76$export$1bfba6da06977d47 = {
    ar: `\u{62A}\u{623}\u{643}\u{64A}\u{62F} \u{627}\u{644}\u{62F}\u{645}\u{62C}`,
    de: `Zusammenf\xfchrung best\xe4tigen`,
    es: `Confirmar fusi\xf3n`,
    fa: `\u{627}\u{62F}\u{63A}\u{627}\u{645} \u{631}\u{627} \u{62A}\u{623}\u{6CC}\u{6CC}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Kumpirmahin ang pagsasanib`,
    fr: `Confirmer la fusion`,
    hi: `\u{92E}\u{930}\u{94D}\u{91C} \u{915}\u{940} \u{92A}\u{941}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Konfime rantre`,
    it: `Conferma la fusione`,
    ja: `\u{7D71}\u{5408}\u{3092}\u{78BA}\u{8A8D}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{D569}\u{BCD1} \u{D655}\u{C778}`,
    mww: `Paub meej tias merge`,
    ps: `\u{627}\u{62F}\u{63A}\u{627}\u{645} \u{62A}\u{627}\u{6CC}\u{6CC}\u{62F} \u{6A9}\u{693}\u{647}`,
    pt: `Confirmar fus\xe3o`,
    'pt-pt': `Confirmar fus\xe3o`,
    ru: `\u{41F}\u{43E}\u{434}\u{442}\u{432}\u{435}\u{440}\u{434}\u{438}\u{442}\u{44C} \u{441}\u{43B}\u{438}\u{44F}\u{43D}\u{438}\u{435}`,
    sm: `Fa'amaonia le tu'ufa'atasia`,
    so: `Xaqiiji isku-darka`,
    th: `\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E01}\u{E32}\u{E23}\u{E1C}\u{E2A}\u{E32}\u{E19}`,
    ur: `\u{645}\u{631}\u{62C} \u{6A9}\u{6CC} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xe1c nh\u{1EAD}n h\u{1EE3}p nh\u{1EA5}t`,
    'zh-hans': `\u{786E}\u{8BA4}\u{5408}\u{5E76}`,
    'zh-hant': `\u{78BA}\u{8A8D}\u{5408}\u{4F75}`,
    en: `Confirm merge`
};
const $b11db1b62d4a8f76$export$6b387f31c62c31e2 = {
    ar: (phone_number)=>`\u{623}\u{631}\u{633}\u{644}\u{646}\u{627} \u{631}\u{633}\u{627}\u{644}\u{629} \u{646}\u{635}\u{64A}\u{629} \u{625}\u{644}\u{649} +1 ${phone_number}. \u{623}\u{62F}\u{62E}\u{644} \u{627}\u{644}\u{631}\u{645}\u{632} \u{627}\u{644}\u{645}\u{643}\u{648}\u{646} \u{645}\u{646} 6 \u{623}\u{631}\u{642}\u{627}\u{645} \u{645}\u{646} \u{627}\u{644}\u{631}\u{633}\u{627}\u{644}\u{629} \u{627}\u{644}\u{646}\u{635}\u{64A}\u{629} \u{627}\u{644}\u{62A}\u{64A} \u{627}\u{633}\u{62A}\u{644}\u{645}\u{62A}\u{647}\u{627}.`,
    de: (phone_number)=>`Wir haben eine SMS an +1 ${phone_number} gesendet. Gib den sechsstelligen Code aus der erhaltenen SMS ein.`,
    es: (phone_number)=>`Hemos enviado un mensaje de texto al +1 ${phone_number}. Introduce el c\xf3digo de 6 d\xedgitos del mensaje de texto que recibiste.`,
    fa: (phone_number)=>`\u{645}\u{627} \u{6CC}\u{6A9} \u{67E}\u{6CC}\u{627}\u{645}\u{6A9} \u{628}\u{647} +1 ${phone_number} \u{627}\u{631}\u{633}\u{627}\u{644} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{645}. \u{6A9}\u{62F} \u{6F6} \u{631}\u{642}\u{645}\u{6CC} \u{67E}\u{6CC}\u{627}\u{645}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{62F} \u{631}\u{627} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: (phone_number)=>`Nagpadala kami ng text message sa +1 ${phone_number}. Ipasok ang 6-digit na code mula sa text message na natanggap mo.`,
    fr: (phone_number)=>`Nous avons envoy\xe9 un message texte au +1 ${phone_number}. Saisissez le code \xe0 6 chiffres du message texte que vous avez re\xe7u.`,
    hi: (phone_number)=>`\u{939}\u{92E}\u{928}\u{947} +1 ${phone_number} \u{92A}\u{930} \u{90F}\u{915} \u{91F}\u{947}\u{915}\u{94D}\u{938}\u{94D}\u{91F} \u{938}\u{902}\u{926}\u{947}\u{936} \u{92D}\u{947}\u{91C}\u{93E} \u{939}\u{948}\u{964} \u{906}\u{92A}\u{915}\u{94B} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{92A}\u{93E}\u{920} \u{938}\u{902}\u{926}\u{947}\u{936} \u{938}\u{947} 6-\u{905}\u{902}\u{915}\u{940}\u{92F} \u{915}\u{94B}\u{921} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: (phone_number)=>`Nou voye yon mesaj t\xe8ks nan +1 ${phone_number} Antre k\xf2d 6 chif nan t\xe8ks mesaj ou te resevwa a.`,
    it: (phone_number)=>`Abbiamo inviato un messaggio di testo al numero +1 ${phone_number}. Inserisci il codice a 6 cifre dal messaggio di testo che hai ricevuto.`,
    ja: (phone_number)=>`\u{79C1}\u{305F}\u{3061}\u{306F}+1 ${phone_number}\u{306B}\u{30C6}\u{30AD}\u{30B9}\u{30C8}\u{30E1}\u{30C3}\u{30BB}\u{30FC}\u{30B8}\u{3092}\u{9001}\u{4FE1}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}\u{53D7}\u{3051}\u{53D6}\u{3063}\u{305F}\u{30C6}\u{30AD}\u{30B9}\u{30C8}\u{30E1}\u{30C3}\u{30BB}\u{30FC}\u{30B8}\u{306E}6\u{6841}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{5165}\u{529B}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: (phone_number)=>`\u{BB38}\u{C790} \u{BA54}\u{C2DC}\u{C9C0}\u{B97C} +1 ${phone_number}\u{B85C} \u{BCF4}\u{B0C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{BC1B}\u{C740} \u{BB38}\u{C790} \u{BA54}\u{C2DC}\u{C9C0}\u{C758} 6\u{C790}\u{B9AC} \u{CF54}\u{B4DC}\u{B97C} \u{C785}\u{B825}\u{D558}\u{C138}\u{C694}.`,
    mww: (phone_number)=>`Peb tau xa cov ntawv nyeem rau +1 ${phone_number}. Sau tus lej 6 tus lej los ntawm cov ntawv nyeem uas koj tau txais.`,
    ps: (phone_number)=>`\u{645}\u{648}\u{696} \u{6CC}\u{648} \u{67E}\u{6CC}\u{63A}\u{627}\u{645} +\u{6F1} ${phone_number} \u{62A}\u{647} \u{644}\u{6CC}\u{696}\u{644}\u{6CC} \u{62F}\u{6CC}. \u{62F} \u{647}\u{63A}\u{647} \u{67E}\u{6CC}\u{63A}\u{627}\u{645} \u{685}\u{62E}\u{647} \u{6F6} \u{639}\u{62F}\u{62F}\u{6CC} \u{6A9}\u{648}\u{689} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626} \u{686}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{645}\u{648} \u{6A9}\u{693}\u{6CC} \u{62F}\u{6CC}.`,
    pt: (phone_number)=>`Enviamos uma mensagem de texto para o +1 ${phone_number}. Digite o c\xf3digo de 6 d\xedgitos da mensagem de texto que voc\xea recebeu.`,
    'pt-pt': (phone_number)=>`Envi\xe1mos uma mensagem de texto para o +1 ${phone_number}. Introduza o c\xf3digo de 6 d\xedgitos da mensagem de texto que recebeu.`,
    ru: (phone_number)=>`\u{41C}\u{44B} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{438} \u{442}\u{435}\u{43A}\u{441}\u{442}\u{43E}\u{432}\u{43E}\u{435} \u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435} \u{43D}\u{430} +1 ${phone_number}. \u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{448}\u{435}\u{441}\u{442}\u{438}\u{437}\u{43D}\u{430}\u{447}\u{43D}\u{44B}\u{439} \u{43A}\u{43E}\u{434} \u{438}\u{437} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{442}\u{435}\u{43A}\u{441}\u{442}\u{43E}\u{432}\u{43E}\u{433}\u{43E} \u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{44F}.`,
    sm: (phone_number)=>`Na matou lafoina se feau tusitusia i le +1 ${phone_number}. Ulu atu i le numera numera 6-digit mai le feau tusitusia na e mauaina.`,
    so: (phone_number)=>`Waxaan fariin qoraal ah u dirnay +1 ${phone_number}. Geli koodhka 6-lambar ee farriinta qoraalka ah ee aad heshay.`,
    th: (phone_number)=>`\u{E40}\u{E23}\u{E32}\u{E44}\u{E14}\u{E49}\u{E2A}\u{E48}\u{E07}\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E44}\u{E1B}\u{E17}\u{E35}\u{E48} +1 ${phone_number} \u{E1B}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A} 6 \u{E2B}\u{E25}\u{E31}\u{E01}\u{E08}\u{E32}\u{E01}\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}`,
    ur: (phone_number)=>`\u{6C1}\u{645} \u{646}\u{6D2} +1 ${phone_number} \u{67E}\u{631} \u{679}\u{6CC}\u{6A9}\u{633}\u{679} \u{645}\u{6CC}\u{633}\u{62C} \u{628}\u{6BE}\u{6CC}\u{62C}\u{627} \u{6C1}\u{6D2}\u{6D4} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{679}\u{6CC}\u{6A9}\u{633}\u{679} \u{645}\u{6CC}\u{633}\u{62C} \u{633}\u{6D2} 6 \u{6C1}\u{646}\u{62F}\u{633}\u{648}\u{6BA} \u{6A9}\u{627} \u{6A9}\u{648}\u{688} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (phone_number)=>`Ch\xfang t\xf4i \u{111}\xe3 g\u{1EED}i tin nh\u{1EAF}n v\u{103}n b\u{1EA3}n \u{111}\u{1EBF}n +1 ${phone_number}. Nh\u{1EAD}p m\xe3 g\u{1ED3}m 6 ch\u{1EEF} s\u{1ED1} t\u{1EEB} tin nh\u{1EAF}n v\u{103}n b\u{1EA3}n b\u{1EA1}n nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c.`,
    'zh-hans': (phone_number)=>`\u{6211}\u{4EEC}\u{5DF2}\u{53D1}\u{9001}\u{77ED}\u{4FE1}\u{81F3}+1 ${phone_number}\u{3002}\u{8F93}\u{5165}\u{4F60}\u{6536}\u{5230}\u{77ED}\u{4FE1}\u{4E2D}\u{7684}6\u{4F4D}\u{6570}\u{4EE3}\u{7801}\u{3002}`,
    'zh-hant': (phone_number)=>`\u{6211}\u{5011}\u{5DF2}\u{767C}\u{9001}\u{7C21}\u{8A0A}\u{81F3}+1 ${phone_number}\u{3002}\u{8F38}\u{5165}\u{4F60}\u{6536}\u{5230}\u{7684}\u{7C21}\u{8A0A}\u{4E2D}\u{7684}\u{516D}\u{4F4D}\u{6578}\u{4EE3}\u{78BC}\u{3002}`,
    en: (phone_number)=>`We've sent a text message to +1 ${phone_number}. Enter the 6-digit code from the text message you received.`
};
const $b11db1b62d4a8f76$export$d47944b58a508bad = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{627}\u{641}\u{642}\u{629}`,
    de: `Zustimmung`,
    es: `Consentimiento`,
    fa: `\u{631}\u{636}\u{627}\u{6CC}\u{62A}`,
    fil: `Pahintulot`,
    fr: `Consentement`,
    hi: `\u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F}`,
    ht: `Konsantman`,
    it: `Consenso`,
    ja: `\u{540C}\u{610F}`,
    ko: `\u{B3D9}\u{C758}`,
    mww: `Kev tso cai`,
    ps: `\u{631}\u{636}\u{627}`,
    pt: `Consentimento`,
    'pt-pt': `Consentimento`,
    ru: `\u{421}\u{43E}\u{433}\u{43B}\u{430}\u{441}\u{438}\u{435}`,
    sm: `Maliega`,
    so: `Ogolaansho`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E22}\u{E34}\u{E19}\u{E22}\u{E2D}\u{E21}`,
    ur: `\u{631}\u{636}\u{627}\u{645}\u{646}\u{62F}\u{6CC}`,
    vi: `S\u{1EF1} \u{111}\u{1ED3}ng \xfd`,
    'zh-hans': `\u{540C}\u{610F}`,
    'zh-hant': `\u{540C}\u{610F}`,
    en: `Consent`
};
const $b11db1b62d4a8f76$export$120f8f20e674504b = {
    ar: `\u{628}\u{642}\u{628}\u{648}\u{644} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}\u{60C} \u{641}\u{625}\u{646}\u{643} \u{62A}\u{648}\u{627}\u{641}\u{642} \u{639}\u{644}\u{649} \u{623}\u{646} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{64A}\u{645}\u{643}\u{646} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} \u{645}\u{648}\u{642}\u{639}\u{627} \u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}\u{627}\u{60C} \u{648}\u{623}\u{646} \u{627}\u{644}\u{62A}\u{648}\u{627}\u{642}\u{64A}\u{639} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}\u{629} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{638}\u{647}\u{631} \u{639}\u{644}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{647}\u{64A} \u{646}\u{641}\u{633}\u{647}\u{627} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{643}\u{62A}\u{648}\u{628}\u{629} \u{628}\u{62E}\u{637} \u{627}\u{644}\u{64A}\u{62F} \u{644}\u{623}\u{63A}\u{631}\u{627}\u{636} \u{627}\u{644}\u{635}\u{644}\u{627}\u{62D}\u{64A}\u{629} \u{648}\u{627}\u{644}\u{642}\u{627}\u{628}\u{644}\u{64A}\u{629} \u{644}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630} \u{648}\u{627}\u{644}\u{642}\u{628}\u{648}\u{644}.`,
    de: `Mit der Annahme dieser Unterschrift stimmen Sie zu, dass diese Aktivit\xe4t elektronisch unterzeichnet werden darf und dass die auf dieser Aktivit\xe4t erscheinenden elektronischen Unterschriften handschriftlichen Unterschriften im Hinblick auf G\xfcltigkeit, Durchsetzbarkeit und Zul\xe4ssigkeit entsprechen.`,
    es: `Al aceptar esta firma, aceptas que esta actividad puede ser firmada electr\xf3nicamente y que las firmas electr\xf3nicas que aparecen en esta actividad son iguales a las firmas manuscritas para fines de validez, exigibilidad y admisibilidad.`,
    fa: `\u{628}\u{627} \u{67E}\u{630}\u{6CC}\u{631}\u{634} \u{627}\u{6CC}\u{646} \u{627}\u{645}\u{636}\u{627}\u{60C} \u{634}\u{645}\u{627} \u{645}\u{648}\u{627}\u{641}\u{642}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{6A9}\u{647} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{645}\u{645}\u{6A9}\u{646} \u{627}\u{633}\u{62A} \u{628}\u{647} \u{635}\u{648}\u{631}\u{62A} \u{627}\u{644}\u{6A9}\u{62A}\u{631}\u{648}\u{646}\u{6CC}\u{6A9}\u{6CC} \u{627}\u{645}\u{636}\u{627} \u{634}\u{648}\u{62F} \u{648} \u{627}\u{645}\u{636}\u{627}\u{647}\u{627}\u{6CC} \u{627}\u{644}\u{6A9}\u{62A}\u{631}\u{648}\u{646}\u{6CC}\u{6A9}\u{6CC} \u{638}\u{627}\u{647}\u{631} \u{634}\u{62F}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{645}\u{627}\u{646} \u{627}\u{645}\u{636}\u{627}\u{647}\u{627}\u{6CC} \u{62F}\u{633}\u{62A} \u{646}\u{648}\u{6CC}\u{633} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{647}\u{62F}\u{627}\u{641} \u{627}\u{639}\u{62A}\u{628}\u{627}\u{631}\u{60C} \u{642}\u{627}\u{628}\u{644}\u{6CC}\u{62A} \u{627}\u{62C}\u{631}\u{627} \u{648} \u{67E}\u{630}\u{6CC}\u{631}\u{634} \u{647}\u{633}\u{62A}\u{646}\u{62F}.`,
    fil: `Sa pamamagitan ng pagtanggap ng lagda na ito, sumasang-ayon ka na ang aktibidad na ito ay maaaring lagdaan nang elektroniko at ang mga elektronikong lagda na lumilitaw sa aktibidad na ito ay kapareho ng mga sulat-kamay na lagda para sa mga layunin ng bisa, pagpapatupad, at katanggap-tanggap.`,
    fr: `En acceptant cette signature, vous acceptez que cette activit\xe9 puisse \xeatre sign\xe9e \xe9lectroniquement et que les signatures \xe9lectroniques apparaissant sur cette activit\xe9 soient identiques \xe0 celles manuscrites, en ce qui concerne la validit\xe9, l\u{2019}ex\xe9cutabilit\xe9 et l\u{2019}admissibilit\xe9.`,
    hi: `\u{907}\u{938} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{94B} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{915}\u{930}\u{915}\u{947} \u{906}\u{92A} \u{938}\u{939}\u{92E}\u{924} \u{939}\u{948}\u{902} \u{915}\u{93F} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{94B} \u{907}\u{932}\u{947}\u{915}\u{94D}\u{91F}\u{94D}\u{930}\u{949}\u{928}\u{93F}\u{915} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930}\u{93F}\u{924} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948} \u{914}\u{930} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930} \u{926}\u{93F}\u{916}\u{93E}\u{908} \u{926}\u{947}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{907}\u{932}\u{947}\u{915}\u{94D}\u{91F}\u{94D}\u{930}\u{949}\u{928}\u{93F}\u{915} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{935}\u{948}\u{927}\u{924}\u{93E}, \u{92A}\u{94D}\u{930}\u{935}\u{930}\u{94D}\u{924}\u{928}\u{940}\u{92F}\u{924}\u{93E} \u{914}\u{930} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{924}\u{93E} \u{915}\u{947} \u{92A}\u{94D}\u{930}\u{92F}\u{94B}\u{91C}\u{928}\u{94B}\u{902} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{939}\u{938}\u{94D}\u{924}\u{932}\u{93F}\u{916}\u{93F}\u{924} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{947} \u{938}\u{92E}\u{93E}\u{928} \u{939}\u{948}\u{902}\u{964}`,
    ht: `L\xe8 w aksepte siyati sa a, ou dak\xf2 ke aktivite sa a ka siyen elektwonikman e ke siyati elektwonik ki par\xe8t sou aktivite sa a se menm bagay la k\xf2m siyati ekri men pou rezon validite, aplikabilite, ak admisibilite.`,
    it: `Accettando questa firma, accetti che questa attivit\xe0 possa essere firmata elettronicamente e che le firme elettroniche presenti in questa attivit\xe0 siano le stesse delle firme manoscritte ai fini di validit\xe0, applicabilit\xe0 e ammissibilit\xe0.`,
    ja: `\u{3053}\u{306E}\u{7F72}\u{540D}\u{3092}\u{53D7}\u{3051}\u{5165}\u{308C}\u{308B}\u{3053}\u{3068}\u{3067}\u{3001}\u{672C}\u{6D3B}\u{52D5}\u{304C}\u{96FB}\u{5B50}\u{7684}\u{306B}\u{7F72}\u{540D}\u{3055}\u{308C}\u{308B}\u{3053}\u{3068}\u{3001}\u{305D}\u{3057}\u{3066}\u{6709}\u{52B9}\u{6027}\u{3001}\u{57F7}\u{884C}\u{53EF}\u{80FD}\u{6027}\u{3001}\u{8A3C}\u{62E0}\u{6027}\u{306E}\u{89B3}\u{70B9}\u{304B}\u{3089}\u{624B}\u{66F8}\u{304D}\u{7F72}\u{540D}\u{3068}\u{540C}\u{4E00}\u{3067}\u{3042}\u{308B}\u{3053}\u{3068}\u{306B}\u{540C}\u{610F}\u{3057}\u{305F}\u{3053}\u{3068}\u{306B}\u{306A}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{C11C}\u{BA85}\u{C744} \u{C218}\u{B77D}\u{D568}\u{C73C}\u{B85C}\u{C368} \u{ADC0}\u{D558}\u{B294} \u{C774} \u{D65C}\u{B3D9}\u{C774} \u{C804}\u{C790}\u{C801}\u{C73C}\u{B85C} \u{C11C}\u{BA85}\u{B420} \u{C218} \u{C788}\u{C73C}\u{BA70}, \u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{B098}\u{D0C0}\u{B098}\u{B294} \u{C804}\u{C790} \u{C11C}\u{BA85}\u{C774} \u{C720}\u{D6A8}\u{C131}, \u{C9D1}\u{D589} \u{AC00}\u{B2A5}\u{C131} \u{BC0F} \u{C99D}\u{AC70} \u{CC44}\u{D0DD} \u{BAA9}\u{C801}\u{C0C1} \u{C190}\u{AE00}\u{C528} \u{C11C}\u{BA85}\u{ACFC} \u{B3D9}\u{C77C}\u{D558}\u{B2E4}\u{B294} \u{B370} \u{B3D9}\u{C758}\u{D558}\u{B294} \u{AC83}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Yog koj lees txais qhov kos npe no, koj pom zoo tias tej zaum yuav kos npe rau hauv tshuab hluav taws xob thiab cov kos npe hauv tshuab hluav taws xob uas tshwm rau ntawm qhov kev ua no yog tib yam li cov kos npe ntawm tes sau rau lub hom phiaj ntawm kev siv tau, siv tau, thiab kev lees paub.`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{645}\u{646}\u{644}\u{648} \u{633}\u{631}\u{647} \u{62A}\u{627}\u{633}\u{648} \u{645}\u{648}\u{627}\u{641}\u{642}\u{647} \u{6A9}\u{648}\u{626} \u{686}\u{6D0} \u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{627}\u{644}\u{6A9}\u{62A}\u{631}\u{648}\u{646}\u{6CC}\u{6A9}\u{6CC} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{6A9}\u{6D0}\u{62F}\u{627}\u{6CC} \u{634}\u{6CC} \u{627}\u{648} \u{67E}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D0} \u{69A}\u{6A9}\u{627}\u{631}\u{647} \u{634}\u{648}\u{6CC} \u{627}\u{644}\u{6A9}\u{62A}\u{631}\u{648}\u{646}\u{6CC}\u{6A9}\u{6CC} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647} \u{62F} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9}\u{646}\u{648} \u{633}\u{631}\u{647} \u{628}\u{631}\u{627}\u{628}\u{631} \u{62F}\u{6CC} \u{62F} \u{627}\u{639}\u{62A}\u{628}\u{627}\u{631}\u{60C} \u{67E}\u{644}\u{6CC} \u{6A9}\u{6CC}\u{62F}\u{648} \u{627}\u{648} \u{645}\u{646}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647}.`,
    pt: `Ao aceitar esta assinatura, voc\xea concorda que essa atividade pode ser assinada eletronicamente e que as assinaturas eletr\xf4nicas presentes nesta atividade s\xe3o as mesmas das assinaturas manuscritas, para fins de validade, aplicabilidade e admissibilidade.`,
    'pt-pt': `Ao aceitar esta assinatura, concorda que esta atividade pode ser assinada eletronicamente e que as assinaturas eletr\xf3nicas presentes nesta atividade s\xe3o iguais \xe0s assinaturas manuscritas, para efeitos de validade, execu\xe7\xe3o e admissibilidade.`,
    ru: `\u{41F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{44F} \u{44D}\u{442}\u{443} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}, \u{432}\u{44B} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{448}\u{430}\u{435}\u{442}\u{435}\u{441}\u{44C} \u{441} \u{442}\u{435}\u{43C}, \u{447}\u{442}\u{43E} \u{44D}\u{442}\u{430} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{430} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}, \u{438} \u{447}\u{442}\u{43E} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{44B}\u{435} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438}, \u{43F}\u{43E}\u{44F}\u{432}\u{43B}\u{44F}\u{44E}\u{449}\u{438}\u{435}\u{441}\u{44F} \u{43D}\u{430} \u{43D}\u{435}\u{439}, \u{441}\u{43E}\u{432}\u{43F}\u{430}\u{434}\u{430}\u{44E}\u{442} \u{441} \u{440}\u{443}\u{43A}\u{43E}\u{43F}\u{438}\u{441}\u{43D}\u{44B}\u{43C}\u{438} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44F}\u{43C}\u{438} \u{434}\u{43B}\u{44F} \u{446}\u{435}\u{43B}\u{435}\u{439} \u{434}\u{43E}\u{441}\u{442}\u{43E}\u{432}\u{435}\u{440}\u{43D}\u{43E}\u{441}\u{442}\u{438}, \u{441}\u{438}\u{43B}\u{44B} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{438} \u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{43E}\u{441}\u{442}\u{438}.`,
    sm: `E ala i le taliaina o lenei saini ua e malilie ai o lenei gaioiga e mafai ona sainia faaeletonika ma o saini faaeletonika o lo'o aliali mai i luga o lenei gaioiga e tutusa ma saini tusilima mo le fa'amoemoe o le aoga, fa'amalosia, ma le taliaina.`,
    so: `Adigoo aqbalaya saxiixan waxaad ku raacsan tahay in hawlgalkan si elektaroonik ah loo saxiixi karo iyo in saxiixyada elektarooniga ah ee ka muuqda hawshan ay la mid yihiin saxiixyada gacanta lagu qoray ujeeddooyinka saxnaanta ah, dhaqan gelinta, iyo aqbalaadda.`,
    th: `\u{E01}\u{E32}\u{E23}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E19}\u{E35}\u{E49}\u{E41}\u{E2A}\u{E14}\u{E07}\u{E27}\u{E48}\u{E32}\u{E04}\u{E38}\u{E13}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E27}\u{E48}\u{E32}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E2D}\u{E32}\u{E08}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E19}\u{E32}\u{E21}\u{E17}\u{E32}\u{E07}\u{E2D}\u{E34}\u{E40}\u{E25}\u{E47}\u{E01}\u{E17}\u{E23}\u{E2D}\u{E19}\u{E34}\u{E01}\u{E2A}\u{E4C} \u{E41}\u{E25}\u{E30}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E2D}\u{E34}\u{E40}\u{E25}\u{E47}\u{E01}\u{E17}\u{E23}\u{E2D}\u{E19}\u{E34}\u{E01}\u{E2A}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E1B}\u{E23}\u{E32}\u{E01}\u{E0F}\u{E43}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E40}\u{E2B}\u{E21}\u{E37}\u{E2D}\u{E19}\u{E01}\u{E31}\u{E1A}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E02}\u{E35}\u{E22}\u{E19}\u{E14}\u{E49}\u{E27}\u{E22}\u{E25}\u{E32}\u{E22}\u{E21}\u{E37}\u{E2D}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E27}\u{E31}\u{E15}\u{E16}\u{E38}\u{E1B}\u{E23}\u{E30}\u{E2A}\u{E07}\u{E04}\u{E4C}\u{E43}\u{E19}\u{E04}\u{E27}\u{E32}\u{E21}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{627}\u{633} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{648} \u{642}\u{628}\u{648}\u{644} \u{6A9}\u{631} \u{6A9}\u{6D2} \u{622}\u{67E} \u{627}\u{633} \u{628}\u{627}\u{62A} \u{633}\u{6D2} \u{627}\u{62A}\u{641}\u{627}\u{642} \u{6A9}\u{631}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6C1} \u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{627}\u{644}\u{6CC}\u{6A9}\u{679}\u{631}\u{627}\u{646}\u{6A9} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6C1}\u{648} \u{633}\u{6A9}\u{62A}\u{6CC} \u{6C1}\u{6D2} \u{627}\u{648}\u{631} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{67E}\u{631} \u{638}\u{627}\u{6C1}\u{631} \u{6C1}\u{648}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{627}\u{644}\u{6CC}\u{6A9}\u{679}\u{631}\u{627}\u{646}\u{6A9} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6C1}\u{627}\u{62A}\u{6BE} \u{633}\u{6D2} \u{644}\u{6A9}\u{6BE}\u{6D2} \u{6C1}\u{648}\u{626}\u{6D2} \u{62F}\u{633}\u{62A}\u{62E}\u{637}\u{648}\u{6BA} \u{6A9}\u{6D2} \u{628}\u{631}\u{627}\u{628}\u{631} \u{6C1}\u{6CC}\u{6BA}\u{60C} \u{62A}\u{627}\u{6A9}\u{6C1} \u{62F}\u{631}\u{633}\u{62A}\u{6AF}\u{6CC}\u{60C} \u{646}\u{641}\u{627}\u{630} \u{627}\u{648}\u{631} \u{642}\u{628}\u{648}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D2} \u{645}\u{642}\u{627}\u{635}\u{62F} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{6CC}\u{6D2} \u{62C}\u{627} \u{633}\u{6A9}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `B\u{1EB1}ng c\xe1ch ch\u{1EA5}p nh\u{1EAD}n ch\u{1EEF} k\xfd n\xe0y, b\u{1EA1}n \u{111}\u{1ED3}ng \xfd r\u{1EB1}ng ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y c\xf3 th\u{1EC3} \u{111}\u{1B0}\u{1EE3}c k\xfd \u{111}i\u{1EC7}n t\u{1EED} v\xe0 ch\u{1EEF} k\xfd \u{111}i\u{1EC7}n t\u{1EED} xu\u{1EA5}t hi\u{1EC7}n tr\xean ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y gi\u{1ED1}ng nh\u{1B0} ch\u{1EEF} k\xfd vi\u{1EBF}t tay v\xec m\u{1EE5}c \u{111}\xedch h\u{1EE3}p l\u{1EC7}, th\u{1EF1}c thi v\xe0 \u{111}\u{1B0}\u{1EE3}c ch\u{1EA5}p nh\u{1EAD}n.`,
    'zh-hans': `\u{63A5}\u{53D7}\u{8BE5}\u{7B7E}\u{540D}\u{5373}\u{8868}\u{793A}\u{60A8}\u{540C}\u{610F}\u{8BE5}\u{6D3B}\u{52A8}\u{53EF}\u{8FDB}\u{884C}\u{7535}\u{5B50}\u{7B7E}\u{540D}\u{FF0C}\u{4E14}\u{8BE5}\u{6D3B}\u{52A8}\u{4E0A}\u{7684}\u{7535}\u{5B50}\u{7B7E}\u{540D}\u{4E0E}\u{624B}\u{5199}\u{7B7E}\u{540D}\u{76F8}\u{540C}\u{FF0C}\u{4EE5}\u{786E}\u{4FDD}\u{5176}\u{6709}\u{6548}\u{6027}\u{3001}\u{53EF}\u{6267}\u{884C}\u{6027}\u{548C}\u{53EF}\u{91C7}\u{6027}\u{3002}`,
    'zh-hant': `\u{63A5}\u{53D7}\u{6B64}\u{7C3D}\u{540D}\u{5373}\u{8868}\u{793A}\u{60A8}\u{540C}\u{610F}\u{672C}\u{6D3B}\u{52D5}\u{53EF}\u{96FB}\u{5B50}\u{7C3D}\u{7F72}\u{FF0C}\u{4E14}\u{8A72}\u{6D3B}\u{52D5}\u{4E0A}\u{7684}\u{96FB}\u{5B50}\u{7C3D}\u{540D}\u{5728}\u{6709}\u{6548}\u{6027}\u{3001}\u{53EF}\u{57F7}\u{884C}\u{6027}\u{53CA}\u{53EF}\u{63A1}\u{6027}\u{4E0A}\u{8207}\u{624B}\u{5BEB}\u{7C3D}\u{540D}\u{76F8}\u{540C}\u{3002}`,
    en: `By accepting this signature you agree that this activity may be electronically signed and that the electronic signatures appearing on this activity are the same as handwritten signatures for the purposes of validity, enforceability, and admissibility.`
};
const $b11db1b62d4a8f76$export$74fea7e61c88e830 = {
    ar: `\u{627}\u{644}\u{645}\u{633}\u{62A}\u{647}\u{644}\u{643}`,
    de: `Verbraucher`,
    es: `Consumidor`,
    fa: `\u{645}\u{635}\u{631}\u{641} \u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: `Mamimili`,
    fr: `Consommateur`,
    hi: `\u{909}\u{92A}\u{92D}\u{94B}\u{915}\u{94D}\u{924}\u{93E}`,
    ht: `Konsomat\xe8 yo`,
    it: `Consumatore`,
    ja: `\u{6D88}\u{8CBB}\u{8005}\u{5411}\u{3051}`,
    ko: `\u{C18C}\u{BE44}\u{C790}`,
    mww: `Tus neeg siv khoom`,
    ps: `\u{645}\u{635}\u{631}\u{641} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Consumidor`,
    'pt-pt': `Consumidor`,
    ru: `\u{41F}\u{43E}\u{442}\u{440}\u{435}\u{431}\u{438}\u{442}\u{435}\u{43B}\u{44C}`,
    sm: `Tagata fa'atau`,
    so: `Macaamiil`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E1A}\u{E23}\u{E34}\u{E42}\u{E20}\u{E04}`,
    ur: `\u{635}\u{627}\u{631}\u{641}`,
    vi: `Ng\u{1B0}\u{1EDD}i ti\xeau d\xf9ng`,
    'zh-hans': `\u{6D88}\u{8D39}\u{8005}`,
    'zh-hant': `\u{6D88}\u{8CBB}\u{8005}`,
    en: `Consumer`
};
const $b11db1b62d4a8f76$export$abbaaad1d33cfcf9 = {
    ar: `\u{627}\u{644}\u{645}\u{633}\u{62A}\u{647}\u{644}\u{643} \u{64A}\u{62F}\u{64A}\u{631} \u{631}\u{639}\u{627}\u{64A}\u{62A}\u{647} \u{628}\u{646}\u{641}\u{633}\u{647}.`,
    de: `Der Verbraucher verwaltet seine Versorgung selbst.`,
    es: `El consumidor gestiona su propio cuidado.`,
    fa: `\u{645}\u{635}\u{631}\u{641} \u{6A9}\u{646}\u{646}\u{62F}\u{647} \u{645}\u{631}\u{627}\u{642}\u{628}\u{62A} \u{62E}\u{648}\u{62F} \u{631}\u{627} \u{62E}\u{648}\u{62F}\u{634} \u{645}\u{62F}\u{6CC}\u{631}\u{6CC}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F}.`,
    fil: `Ang mamimili ang namamahala sa kanilang sariling pangangalaga.`,
    fr: `Le consommateur g\xe8re lui-m\xeame ses soins.`,
    hi: `\u{909}\u{92A}\u{92D}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{905}\u{92A}\u{928}\u{940} \u{926}\u{947}\u{916}\u{92D}\u{93E}\u{932} \u{915}\u{93E} \u{92A}\u{94D}\u{930}\u{92C}\u{902}\u{927}\u{928} \u{938}\u{94D}\u{935}\u{92F}\u{902} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Konsomat\xe8 a jere pw\xf2p swen li.`,
    it: `Il consumatore gestisce la propria cura.`,
    ja: `\u{6D88}\u{8CBB}\u{8005}\u{306F}\u{81EA}\u{5206}\u{81EA}\u{8EAB}\u{306E}\u{30B1}\u{30A2}\u{3092}\u{7BA1}\u{7406}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C18C}\u{BE44}\u{C790}\u{B294} \u{C790}\u{C2E0}\u{C758} \u{AD00}\u{B9AC}\u{B97C} \u{C2A4}\u{C2A4}\u{B85C} \u{AD00}\u{B9AC}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Tus neeg tau txais kev pab tswj hwm nws tus kheej.`,
    ps: `\u{645}\u{635}\u{631}\u{641} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{62E}\u{67E}\u{644}\u{647} \u{67E}\u{627}\u{645}\u{644}\u{631}\u{646}\u{647} \u{67E}\u{62E}\u{67E}\u{644}\u{647} \u{627}\u{62F}\u{627}\u{631}\u{647} \u{6A9}\u{648}\u{6CC}.`,
    pt: `O consumidor gerencia seu pr\xf3prio cuidado.`,
    'pt-pt': `O consumidor gere os seus pr\xf3prios cuidados.`,
    ru: `\u{41F}\u{43E}\u{442}\u{440}\u{435}\u{431}\u{438}\u{442}\u{435}\u{43B}\u{44C} \u{441}\u{430}\u{43C} \u{437}\u{430}\u{431}\u{43E}\u{442}\u{438}\u{442}\u{441}\u{44F} \u{43E} \u{441}\u{432}\u{43E}\u{451}\u{43C} \u{443}\u{445}\u{43E}\u{434}\u{435}.`,
    sm: `O le tagata fa'atau e fa'atautaia a latou lava tausiga.`,
    so: `Macaamiisha ayaa isagu maamula daryeelkooda.`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E1A}\u{E23}\u{E34}\u{E42}\u{E20}\u{E04}\u{E08}\u{E31}\u{E14}\u{E01}\u{E32}\u{E23}\u{E01}\u{E32}\u{E23}\u{E14}\u{E39}\u{E41}\u{E25}\u{E02}\u{E2D}\u{E07}\u{E15}\u{E19}\u{E40}\u{E2D}\u{E07}`,
    ur: `\u{635}\u{627}\u{631}\u{641} \u{627}\u{67E}\u{646}\u{6CC} \u{62F}\u{6CC}\u{6A9}\u{6BE} \u{628}\u{6BE}\u{627}\u{644} \u{62E}\u{648}\u{62F} \u{633}\u{646}\u{628}\u{6BE}\u{627}\u{644}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ng\u{1B0}\u{1EDD}i ti\xeau d\xf9ng t\u{1EF1} qu\u{1EA3}n l\xfd vi\u{1EC7}c ch\u{103}m s\xf3c c\u{1EE7}a h\u{1ECD}.`,
    'zh-hans': `\u{6D88}\u{8D39}\u{8005}\u{81EA}\u{884C}\u{7BA1}\u{7406}\u{81EA}\u{5DF1}\u{7684}\u{533B}\u{7597}\u{670D}\u{52A1}\u{3002}`,
    'zh-hant': `\u{6D88}\u{8CBB}\u{8005}\u{81EA}\u{884C}\u{7BA1}\u{7406}\u{81EA}\u{5DF1}\u{7684}\u{7167}\u{8B77}\u{3002}`,
    en: `The consumer manages their own care.`
};
const $b11db1b62d4a8f76$export$8df4b8d565bc65be = {
    ar: `\u{627}\u{644}\u{645}\u{633}\u{62A}\u{647}\u{644}\u{643}\u{648}\u{646}`,
    de: `Verbraucher`,
    es: `Consumidores`,
    fa: `\u{645}\u{635}\u{631}\u{641} \u{6A9}\u{646}\u{646}\u{62F}\u{6AF}\u{627}\u{646}`,
    fil: `Mga mamimili`,
    fr: `Consommateurs`,
    hi: `\u{909}\u{92A}\u{92D}\u{94B}\u{915}\u{94D}\u{924}\u{93E}\u{913}\u{902}`,
    ht: `Konsomat\xe8 yo`,
    it: `Consumatori`,
    ja: `\u{6D88}\u{8CBB}\u{8005}`,
    ko: `\u{C18C}\u{BE44}\u{C790}`,
    mww: `Cov neeg siv khoom`,
    ps: `\u{645}\u{635}\u{631}\u{641} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Consumidores`,
    'pt-pt': `Consumidores`,
    ru: `\u{41F}\u{43E}\u{442}\u{440}\u{435}\u{431}\u{438}\u{442}\u{435}\u{43B}\u{438}`,
    sm: `Tagata fa'atau`,
    so: `Macaamiisha`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E1A}\u{E23}\u{E34}\u{E42}\u{E20}\u{E04}`,
    ur: `\u{635}\u{627}\u{631}\u{641}\u{6CC}\u{646}`,
    vi: `Ng\u{1B0}\u{1EDD}i ti\xeau d\xf9ng`,
    'zh-hans': `\u{6D88}\u{8D39}\u{8005}`,
    'zh-hant': `\u{6D88}\u{8CBB}\u{8005}`,
    en: `Consumers`
};
const $b11db1b62d4a8f76$export$29fd1d46de7a7ac0 = {
    ar: `\u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644}`,
    de: `Kontakt`,
    es: `Contacto`,
    fa: `\u{62A}\u{645}\u{627}\u{633}`,
    fil: `Makipag-ugnay`,
    fr: `Contact`,
    hi: `\u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Kontak`,
    it: `Contatto`,
    ja: `\u{9023}\u{7D61}\u{5148}`,
    ko: `\u{C5F0}\u{B77D}\u{CC98}`,
    mww: `Hu rau`,
    ps: `\u{62A}\u{645}\u{627}\u{633}`,
    pt: `Contato`,
    'pt-pt': `Contacto`,
    ru: `\u{41A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}`,
    sm: `Fa'afeso'ota'i`,
    so: `Xiriir`,
    th: `\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{631}\u{627}\u{628}\u{637}\u{6C1}`,
    vi: `Li\xean h\u{1EC7}`,
    'zh-hans': `\u{8054}\u{7CFB}\u{65B9}\u{5F0F}`,
    'zh-hant': `\u{806F}\u{7D61}\u{4EBA}`,
    en: `Contact`
};
const $b11db1b62d4a8f76$export$3684597712fc8ec9 = {
    ar: `\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{648}\u{627}\u{635}\u{644}`,
    de: `Kontakt-E-Mail`,
    es: `Correo electr\xf3nico de contacto`,
    fa: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{62A}\u{645}\u{627}\u{633}`,
    fil: `Email ng kontak`,
    fr: `Email de contact`,
    hi: `\u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{908}\u{92E}\u{947}\u{932}`,
    ht: `Kontakte im\xe8l`,
    it: `Email di contatto`,
    ja: `\u{304A}\u{554F}\u{3044}\u{5408}\u{308F}\u{305B}\u{30E1}\u{30FC}\u{30EB}`,
    ko: `\u{C5F0}\u{B77D}\u{CC98} \u{C774}\u{BA54}\u{C77C}`,
    mww: `Email tiv tauj`,
    ps: `\u{62F} \u{627}\u{693}\u{6CC}\u{6A9}\u{6D0} \u{628}\u{631}\u{6D0}\u{69A}\u{646}\u{627}\u{644}\u{6CC}\u{6A9}`,
    pt: `E-mail de contato`,
    'pt-pt': `Email de contacto`,
    ru: `\u{41A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}\u{43D}\u{430}\u{44F} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{430}\u{44F} \u{43F}\u{43E}\u{447}\u{442}\u{430}`,
    sm: `Fa'afeso'ota'i imeli`,
    so: `Email-ka xiriirka`,
    th: `\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{631}\u{627}\u{628}\u{637}\u{6C1} \u{627}\u{6CC} \u{645}\u{6CC}\u{644}`,
    vi: `Email li\xean h\u{1EC7}`,
    'zh-hans': `\u{8054}\u{7CFB}\u{90AE}\u{7BB1}`,
    'zh-hant': `\u{806F}\u{7D61}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}`,
    en: `Contact email`
};
const $b11db1b62d4a8f76$export$7f950070e52dbc51 = {
    ar: `\u{62A}\u{648}\u{627}\u{635}\u{644} \u{645}\u{639} \u{641}\u{631}\u{64A}\u{642}\u{646}\u{627}`,
    de: `Kontaktieren Sie unser Team`,
    es: `Contacta con nuestro equipo`,
    fa: `\u{628}\u{627} \u{62A}\u{6CC}\u{645} \u{645}\u{627} \u{62A}\u{645}\u{627}\u{633} \u{628}\u{6AF}\u{6CC}\u{631}\u{6CC}\u{62F}`,
    fil: `Makipag-ugnay sa aming koponan`,
    fr: `Contactez notre \xe9quipe`,
    hi: `\u{939}\u{92E}\u{93E}\u{930}\u{940} \u{91F}\u{940}\u{92E} \u{938}\u{947} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Kontakte ekip nou an`,
    it: `Contatta il nostro team`,
    ja: `\u{5F53}\u{30C1}\u{30FC}\u{30E0}\u{306B}\u{304A}\u{554F}\u{3044}\u{5408}\u{308F}\u{305B}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{C800}\u{D76C} \u{D300}\u{C5D0} \u{C5F0}\u{B77D}\u{D558}\u{C138}\u{C694}`,
    mww: `Hu rau peb pab neeg`,
    ps: `\u{632}\u{645}\u{648}\u{696} \u{67C}\u{6CC}\u{645} \u{633}\u{631}\u{647} \u{627}\u{693}\u{6CC}\u{6A9}\u{647} \u{648}\u{646}\u{6CC}\u{633}\u{626}`,
    pt: `Entre em contato com nossa equipe`,
    'pt-pt': `Contacte a nossa equipa`,
    ru: `\u{421}\u{432}\u{44F}\u{436}\u{438}\u{442}\u{435}\u{441}\u{44C} \u{441} \u{43D}\u{430}\u{448}\u{435}\u{439} \u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{43E}\u{439}`,
    sm: `Fa'afeso'ota'i la matou 'au`,
    so: `La xiriir kooxdeena`,
    th: `\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E17}\u{E35}\u{E21}\u{E07}\u{E32}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E23}\u{E32}`,
    ur: `\u{6C1}\u{645}\u{627}\u{631}\u{6CC} \u{679}\u{6CC}\u{645} \u{633}\u{6D2} \u{631}\u{627}\u{628}\u{637}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Li\xean h\u{1EC7} v\u{1EDB}i nh\xf3m c\u{1EE7}a ch\xfang t\xf4i`,
    'zh-hans': `\u{8054}\u{7CFB}\u{6211}\u{4EEC}\u{7684}\u{56E2}\u{961F}`,
    'zh-hant': `\u{806F}\u{7D61}\u{6211}\u{5011}\u{7684}\u{5718}\u{968A}`,
    en: `Contact our team`
};
const $b11db1b62d4a8f76$export$cc3231ec75ca8dd7 = {
    ar: `\u{647}\u{627}\u{62A}\u{641} \u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644}`,
    de: `Kontakttelefon`,
    es: `Tel\xe9fono de contacto`,
    fa: `\u{62A}\u{644}\u{641}\u{646} \u{62A}\u{645}\u{627}\u{633}`,
    fil: `Telepono ng kontak`,
    fr: `Contact t\xe9l\xe9phonique`,
    hi: `\u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{92B}\u{94B}\u{928}`,
    ht: `Kontak telef\xf2n`,
    it: `Telefono di contatto`,
    ja: `\u{9023}\u{7D61}\u{5148}\u{96FB}\u{8A71}`,
    ko: `\u{C5F0}\u{B77D}\u{CC98} \u{C804}\u{D654}`,
    mww: `Xov tooj tiv tauj`,
    ps: `\u{62F} \u{62A}\u{645}\u{627}\u{633} \u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646}`,
    pt: `Telefone de contato`,
    'pt-pt': `Telefone de contacto`,
    ru: `\u{41A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}\u{43D}\u{44B}\u{439} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}`,
    sm: `Fa'afeso'ota'i telefoni`,
    so: `Xiriirka telefoonka`,
    th: `\u{E2B}\u{E21}\u{E32}\u{E22}\u{E40}\u{E25}\u{E02}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{631}\u{627}\u{628}\u{637}\u{6C1} \u{641}\u{648}\u{646}`,
    vi: `S\u{1ED1} \u{111}i\u{1EC7}n tho\u{1EA1}i li\xean h\u{1EC7}`,
    'zh-hans': `\u{8054}\u{7CFB}\u{7535}\u{8BDD}`,
    'zh-hant': `\u{806F}\u{7D61}\u{96FB}\u{8A71}`,
    en: `Contact phone`
};
const $b11db1b62d4a8f76$export$c5f031247cf9cf4d = {
    ar: `\u{62C}\u{647}\u{627}\u{62A} \u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644}`,
    de: `Kontakte`,
    es: `Contactos`,
    fa: `\u{627}\u{631}\u{62A}\u{628}\u{627}\u{637}\u{627}\u{62A}`,
    fil: `Email Address *`,
    fr: `Contacts`,
    hi: `\u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915}`,
    ht: `Kontak`,
    it: `Contatti`,
    ja: `\u{9023}\u{7D61}\u{5148}`,
    ko: `\u{C5F0}\u{B77D}\u{CC98}`,
    mww: `Hu rau`,
    ps: `\u{627}\u{693}\u{6CC}\u{6A9}\u{6D0}`,
    pt: `Contatos`,
    'pt-pt': `Contactos`,
    ru: `\u{41A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}\u{44B}`,
    sm: `Fa'afeso'ota'iga`,
    so: `Xiriirada`,
    th: `\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{631}\u{627}\u{628}\u{637}\u{6D2}`,
    vi: `Li\xean h\u{1EC7}`,
    'zh-hans': `\u{8054}\u{7CFB}\u{4EBA}`,
    'zh-hant': `\u{806F}\u{7D61}\u{4EBA}`,
    en: `Contacts`
};
const $b11db1b62d4a8f76$export$8cff90f8fc359b41 = {
    ar: `\u{645}\u{628}\u{64A}\u{639}\u{627}\u{62A} \u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644}`,
    de: `Kontakt zum Vertrieb`,
    es: `Ventas de contacto`,
    fa: `\u{641}\u{631}\u{648}\u{634} \u{62A}\u{645}\u{627}\u{633}`,
    fil: `Makipag-ugnay sa mga benta`,
    fr: `Ventes de contact`,
    hi: `\u{92C}\u{93F}\u{915}\u{94D}\u{930}\u{940} \u{938}\u{947} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Kontakte lavant`,
    it: `Contatta vendite`,
    ja: `\u{55B6}\u{696D}\u{306B}\u{9023}\u{7D61}`,
    ko: `\u{C601}\u{C5C5} \u{C5F0}\u{B77D}\u{CC98}`,
    mww: `Hu rau kev muag khoom`,
    ps: `\u{62F} \u{62A}\u{645}\u{627}\u{633} \u{67E}\u{644}\u{648}\u{631}`,
    pt: `Vendas de contato`,
    'pt-pt': `Vendas de contacto`,
    ru: `\u{41A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}\u{43D}\u{44B}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{430}\u{436}\u{438}`,
    sm: `Fa'afeso'ota'i tagata fa'`,
    so: `Xiriirka iibka`,
    th: `\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E1D}\u{E48}\u{E32}\u{E22}\u{E02}\u{E32}\u{E22}`,
    ur: `\u{631}\u{627}\u{628}\u{637}\u{6C1} \u{633}\u{6CC}\u{644}\u{632}`,
    vi: `Li\xean h\u{1EC7} v\u{1EDB}i b\u{1ED9} ph\u{1EAD}n b\xe1n h\xe0ng`,
    'zh-hans': `\u{8054}\u{7CFB}\u{9500}\u{552E}`,
    'zh-hant': `\u{806F}\u{7D61}\u{92B7}\u{552E}`,
    en: `Contact sales`
};
const $b11db1b62d4a8f76$export$bb68965f68169d12 = {
    ar: $b11db1b62d4a8f76$var$html`<a href="/support">تواصل مع الدعم</a> للحصول على المساعدة في تغيير بريدك الإلكتروني أو اسم المستخدم.`,
    de: $b11db1b62d4a8f76$var$html`<a href="/support">Kontaktieren Sie den Support</a> für Hilfe bei der Änderung Ihrer E-Mail-Adresse oder Ihres Benutzernamens.`,
    es: $b11db1b62d4a8f76$var$html`<a href="/support">Contacta con el soporte</a> para recibir ayuda para cambiar tu correo electrónico o nombre de usuario.`,
    fa: $b11db1b62d4a8f76$var$html`برای دریافت کمک در تغییر ایمیل یا نام کاربری <a href="/support">خود با پشتیبانی تماس بگیرید</a>.`,
    fil: $b11db1b62d4a8f76$var$html`<a href="/support">Makipag-ugnay sa suporta</a> para sa tulong sa pagbabago ng iyong email o username.`,
    fr: $b11db1b62d4a8f76$var$html`<a href="/support">Contactez le support</a> pour obtenir de l’aide afin de changer votre adresse e-mail ou votre nom d’utilisateur.`,
    hi: $b11db1b62d4a8f76$var$html`अपना ईमेल या उपयोगकर्ता नाम बदलने में सहायता के लिए <a href="/support">सहायता सहायता से संपर्क करें</a>.`,
    ht: $b11db1b62d4a8f76$var$html`<a href="/support">Kontakte sipò</a> pou asistans chanje imèl ou oswa non itilizatè ou.`,
    it: $b11db1b62d4a8f76$var$html`<a href="/support">Contatta l'assistenza</a> per assistenza nella modifica della tua email o del tuo username.`,
    ja: $b11db1b62d4a8f76$var$html`メールアドレスやユーザー名の変更についてサポート<a href="/support">までご連絡</a>ください。`,
    ko: $b11db1b62d4a8f76$var$html`이메일이나 사용자 이름 변경에 도움을 원하시면 <a href="/support">지원팀에 연락</a>하세요.`,
    mww: $b11db1b62d4a8f76$var$html`<a href="/support">Hu rau kev txhawb nqa</a> rau kev pab hloov koj tus email lossis username.`,
    ps: $b11db1b62d4a8f76$var$html`د ایمیل یا کارن نوم بدلولو کې <a href="/support">د مرستې لپاره له ملاتړ سره اړیکه ونیسئ</a>.`,
    pt: $b11db1b62d4a8f76$var$html`<a href="/support">Entre em contato com o suporte</a> para obter ajuda para alterar seu e-mail ou nome de usuário.`,
    'pt-pt': $b11db1b62d4a8f76$var$html`<a href="/support">Contacte o suporte</a> para obter ajuda para alterar o seu email ou nome de utilizador.`,
    ru: $b11db1b62d4a8f76$var$html`<a href="/support">Свяжитесь с поддержкой</a> для помощи в изменении электронной почты или имени пользователя.`,
    sm: $b11db1b62d4a8f76$var$html`<a href="/support">Faafesootai le lagolago</a> mo se fesoasoani e suia ai lau imeli po o le igoa faaaoga.`,
    so: $b11db1b62d4a8f76$var$html`<a href="/support">La xiriir taageerada</a> si aad u hesho caawimaad beddelidda email-kaaga ama username-kaaga.`,
    th: $b11db1b62d4a8f76$var$html`<a href="/support">ติดต่อฝ่ายสนับสนุน</a> เพื่อขอความช่วยเหลือในการเปลี่ยนอีเมลหรือชื่อผู้ใช้ของคุณ`,
    ur: $b11db1b62d4a8f76$var$html`اپنا ای میل یا یوزر نیم تبدیل کرنے میں مدد کے <a href="/support">لیے سپورٹ سے رابطہ کریں۔</a>`,
    vi: $b11db1b62d4a8f76$var$html`<a href="/support">Liên hệ với bộ phận hỗ trợ</a> để được hỗ trợ thay đổi email hoặc tên người dùng của bạn.`,
    'zh-hans': $b11db1b62d4a8f76$var$html`如需更改邮箱或用户名，<a href="/support">请联系客服</a>协助。`,
    'zh-hant': $b11db1b62d4a8f76$var$html`如需協助更改您的電子郵件或使用者名稱，<a href="/support">請聯絡客服</a>。`,
    en: $b11db1b62d4a8f76$var$html`<a href="/support">Contact support</a> for assistance changing your email or username.`
};
const $b11db1b62d4a8f76$export$ae37e96fda2663b7 = {
    ar: `\u{62A}\u{648}\u{627}\u{635}\u{644} \u{645}\u{639}\u{646}\u{627}`,
    de: `Kontaktieren Sie uns`,
    es: `Cont\xe1ctanos`,
    fa: `\u{628}\u{627} \u{645}\u{627} \u{62A}\u{645}\u{627}\u{633} \u{628}\u{6AF}\u{6CC}\u{631}\u{6CC}\u{62F}`,
    fil: `Makipag-ugnayan sa amin`,
    fr: `Contactez-nous`,
    hi: `\u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Kontakte nou`,
    it: `Contattaci`,
    ja: `\u{304A}\u{554F}\u{3044}\u{5408}\u{308F}\u{305B}`,
    ko: `\u{BB38}\u{C758}\u{D574} \u{C8FC}\u{C138}\u{C694}`,
    mww: `Tiv tauj peb`,
    ps: `\u{644}\u{647} \u{645}\u{648}\u{696} \u{633}\u{631}\u{647} \u{627}\u{693}\u{6CC}\u{6A9}\u{647} \u{648}\u{646}\u{6CC}\u{633}\u{626}`,
    pt: `Entre em contato conosco`,
    'pt-pt': `Contacte-nos`,
    ru: `\u{421}\u{432}\u{44F}\u{436}\u{438}\u{442}\u{435}\u{441}\u{44C} \u{441} \u{43D}\u{430}\u{43C}\u{438}`,
    sm: `Fa'afeso'ota'i mai matou`,
    so: `Nala soo xiriir`,
    th: `\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E40}\u{E23}\u{E32}`,
    ur: `\u{6C1}\u{645} \u{633}\u{6D2} \u{631}\u{627}\u{628}\u{637}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Li\xean h\u{1EC7} v\u{1EDB}i ch\xfang t\xf4i`,
    'zh-hans': `\u{8054}\u{7CFB}\u{6211}\u{4EEC}`,
    'zh-hant': `\u{806F}\u{7D61}\u{6211}\u{5011}`,
    en: `Contact us`
};
const $b11db1b62d4a8f76$export$c9858e641d40383c = {
    ar: `\u{62A}\u{62C}\u{639}\u{644} Cumulus \u{645}\u{646} \u{627}\u{644}\u{633}\u{647}\u{644} \u{62C}\u{645}\u{639} \u{627}\u{644}\u{634}\u{631}\u{643}\u{627}\u{621} \u{645}\u{639}\u{627}\u{2014}\u{62D}\u{62A}\u{649} \u{639}\u{628}\u{631} \u{623}\u{646}\u{638}\u{645}\u{629} \u{62A}\u{643}\u{646}\u{648}\u{644}\u{648}\u{62C}\u{64A}\u{627} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{644}\u{641}\u{629}. \u{645}\u{646} \u{627}\u{644}\u{642}\u{628}\u{648}\u{644} \u{648}\u{627}\u{644}\u{62A}\u{642}\u{64A}\u{64A}\u{645} \u{625}\u{644}\u{649} \u{62A}\u{646}\u{633}\u{64A}\u{642} \u{627}\u{644}\u{631}\u{639}\u{627}\u{64A}\u{629} \u{648}\u{62A}\u{62A}\u{628}\u{639} \u{627}\u{644}\u{625}\u{62D}\u{627}\u{644}\u{627}\u{62A}\u{60C} \u{62A}\u{633}\u{627}\u{639}\u{62F} Cumulus \u{627}\u{644}\u{641}\u{631}\u{642} \u{639}\u{644}\u{649} \u{627}\u{644}\u{639}\u{645}\u{644} \u{643}\u{648}\u{62D}\u{62F}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629}.`,
    de: `Cumulus macht es einfach, Partner zusammenzubringen \u{2013} selbst \xfcber verschiedene IT-Systeme hinweg. Von der Aufnahme und Beurteilung \xfcber die Koordination der Versorgung bis hin zur \xdcberweisungsverfolgung hilft Cumulus den Teams, als Einheit zusammenzuarbeiten.`,
    es: `Cumulus facilita la uni\xf3n de socios, incluso a trav\xe9s de diferentes sistemas inform\xe1ticos. Desde la admisi\xf3n y evaluaci\xf3n hasta la coordinaci\xf3n de cuidados y el seguimiento de derivaciones, Cumulus ayuda a los equipos a trabajar como uno solo.`,
    fa: `Cumulus \u{628}\u{647} \u{631}\u{627}\u{62D}\u{62A}\u{6CC} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646} \u{634}\u{631}\u{6A9}\u{627} \u{631}\u{627} \u{6AF}\u{631}\u{62F} \u{647}\u{645} \u{622}\u{648}\u{631}\u{62F}\u{2014}\u{62D}\u{62A}\u{6CC} \u{62F}\u{631} \u{633}\u{6CC}\u{633}\u{62A}\u{645} \u{647}\u{627}\u{6CC} \u{645}\u{62E}\u{62A}\u{644}\u{641} \u{641}\u{646}\u{627}\u{648}\u{631}\u{6CC} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A}. \u{627}\u{632} \u{67E}\u{630}\u{6CC}\u{631}\u{634} \u{648} \u{627}\u{631}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{6AF}\u{631}\u{641}\u{62A}\u{647} \u{62A}\u{627} \u{647}\u{645}\u{627}\u{647}\u{646}\u{6AF}\u{6CC} \u{645}\u{631}\u{627}\u{642}\u{628}\u{62A} \u{648} \u{67E}\u{6CC}\u{6AF}\u{6CC}\u{631}\u{6CC} \u{627}\u{631}\u{62C}\u{627}\u{639}\u{60C} Cumulus \u{628}\u{647} \u{62A}\u{6CC}\u{645} \u{647}\u{627} \u{6A9}\u{645}\u{6A9} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F} \u{62A}\u{627} \u{628}\u{647} \u{635}\u{648}\u{631}\u{62A} \u{6CC}\u{6A9}\u{67E}\u{627}\u{631}\u{686}\u{647} \u{6A9}\u{627}\u{631} \u{6A9}\u{646}\u{646}\u{62F}.`,
    fil: `Ginagawang madali ng Cumulus na pagsamahin ang mga kasosyo - kahit na sa iba't ibang mga sistema ng IT. Mula sa pagkuha at pagtatasa hanggang sa koordinasyon ng pangangalaga at pagsubaybay sa referral, tinutulungan ng Cumulus ang mga koponan na magtrabaho bilang isa.`,
    fr: `Cumulus facilite la r\xe9unification des partenaires \u{2014} m\xeame \xe0 travers diff\xe9rents syst\xe8mes informatiques. De l\u{2019}admission et l\u{2019}\xe9valuation \xe0 la coordination des soins et au suivi des orientations, Cumulus aide les \xe9quipes \xe0 fonctionner comme une seule personne.`,
    hi: `\u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{941}\u{932}\u{938} \u{92D}\u{93E}\u{917}\u{940}\u{926}\u{93E}\u{930}\u{94B}\u{902} \u{915}\u{94B} \u{90F}\u{915} \u{938}\u{93E}\u{925} \u{932}\u{93E}\u{928}\u{93E} \u{906}\u{938}\u{93E}\u{928} \u{92C}\u{928}\u{93E}\u{924}\u{93E} \u{939}\u{948} - \u{92F}\u{939}\u{93E}\u{902} \u{924}\u{915} \u{915}\u{93F} \u{935}\u{93F}\u{92D}\u{93F}\u{928}\u{94D}\u{928} \u{906}\u{908}\u{91F}\u{940} \u{92A}\u{94D}\u{930}\u{923}\u{93E}\u{932}\u{93F}\u{92F}\u{94B}\u{902} \u{92E}\u{947}\u{902} \u{92D}\u{940}\u{964} \u{938}\u{947}\u{935}\u{928} \u{914}\u{930} \u{92E}\u{942}\u{932}\u{94D}\u{92F}\u{93E}\u{902}\u{915}\u{928} \u{938}\u{947} \u{932}\u{947}\u{915}\u{930} \u{926}\u{947}\u{916}\u{92D}\u{93E}\u{932} \u{938}\u{92E}\u{928}\u{94D}\u{935}\u{92F} \u{914}\u{930} \u{930}\u{947}\u{92B}\u{930}\u{932} \u{91F}\u{94D}\u{930}\u{948}\u{915}\u{93F}\u{902}\u{917} \u{924}\u{915}, \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{941}\u{932}\u{938} \u{91F}\u{940}\u{92E}\u{94B}\u{902} \u{915}\u{94B} \u{90F}\u{915} \u{915}\u{947} \u{930}\u{942}\u{92A} \u{92E}\u{947}\u{902} \u{915}\u{93E}\u{92E} \u{915}\u{930}\u{928}\u{947} \u{92E}\u{947}\u{902} \u{92E}\u{926}\u{926} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Cumulus f\xe8 li fasil yo pote patn\xe8 ansanm - menm atrav\xe8 diferan sist\xe8m IT. Soti nan konsomasyon ak evalyasyon nan kow\xf2dinasyon swen ak swiv referans, Cumulus ede ekip travay k\xf2m yon s\xe8l.`,
    it: `Cumulus rende facile unire i partner\u{2014}anche tra diversi sistemi IT. Dall'accoglienza e valutazione al coordinamento delle cure e al monitoraggio delle segnalazioni, Cumulus aiuta i team a lavorare come uno solo.`,
    ja: `Cumulus\u{306F}\u{3001}\u{7570}\u{306A}\u{308B}IT\u{30B7}\u{30B9}\u{30C6}\u{30E0}\u{9593}\u{3067}\u{3082}\u{30D1}\u{30FC}\u{30C8}\u{30CA}\u{30FC}\u{3092}\u{7C21}\u{5358}\u{306B}\u{7D50}\u{3073}\u{3064}\u{3051}\u{308B}\u{3053}\u{3068}\u{304C}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}\u{53D7}\u{3051}\u{5165}\u{308C}\u{3084}\u{8A55}\u{4FA1}\u{304B}\u{3089}\u{30B1}\u{30A2}\u{306E}\u{8ABF}\u{6574}\u{3001}\u{7D39}\u{4ECB}\u{306E}\u{8FFD}\u{8DE1}\u{306B}\u{81F3}\u{308B}\u{307E}\u{3067}\u{3001}Cumulus\u{306F}\u{30C1}\u{30FC}\u{30E0}\u{304C}\u{4E00}\u{4F53}\u{3068}\u{306A}\u{3063}\u{3066}\u{50CD}\u{304F}\u{306E}\u{3092}\u{652F}\u{63F4}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `Cumulus\u{B294} \u{C11C}\u{B85C} \u{B2E4}\u{B978} IT \u{C2DC}\u{C2A4}\u{D15C} \u{AC04}\u{C5D0} \u{D30C}\u{D2B8}\u{B108}\u{B97C} \u{C27D}\u{AC8C} \u{BAA8}\u{C744} \u{C218} \u{C788}\u{AC8C} \u{D569}\u{B2C8}\u{B2E4}. \u{C811}\u{C218} \u{BC0F} \u{D3C9}\u{AC00}\u{BD80}\u{D130} \u{CF00}\u{C5B4} \u{C870}\u{C815}\u{ACFC} \u{C758}\u{B8B0} \u{CD94}\u{C801}\u{C5D0} \u{C774}\u{B974}\u{AE30}\u{AE4C}\u{C9C0}, Cumulus\u{B294} \u{D300}\u{C774} \u{D558}\u{B098}\u{B85C} \u{D611}\u{B825}\u{D560} \u{C218} \u{C788}\u{B3C4}\u{B85D} \u{B3D5}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Cumulus ua rau nws yooj yim los coj cov neeg koom tes ua ke-txawm tias thoob plaws IT systems sib txawv. Los ntawm kev nkag thiab kev ntsuam xyuas mus rau kev saib xyuas kev saib xyuas thiab kev xa mus taug qab, Cumulus pab pab pawg ua haujlwm ua ib qho.`,
    ps: `Cumulus \u{62F}\u{627} \u{627}\u{633}\u{627}\u{646}\u{647} \u{6A9}\u{648}\u{6CC} \u{686}\u{6D0} \u{634}\u{631}\u{6CC}\u{6A9}\u{627}\u{646} \u{633}\u{631}\u{647} \u{631}\u{627}\u{67C}\u{648}\u{644} \u{634}\u{6CC}\u{2014}\u{62D}\u{62A}\u{6CC} \u{62F} \u{645}\u{62E}\u{62A}\u{644}\u{641}\u{648} IT \u{633}\u{6CC}\u{633}\u{67C}\u{645}\u{648}\u{646}\u{648} \u{67E}\u{647} \u{645}\u{646}\u{681} \u{6A9}\u{6D0}. \u{644}\u{647} \u{62F}\u{627}\u{62E}\u{644}\u{6D0}\u{62F}\u{648} \u{627}\u{648} \u{627}\u{631}\u{632}\u{648}\u{646}\u{6D0} \u{685}\u{62E}\u{647} \u{62A}\u{631} \u{67E}\u{627}\u{645}\u{644}\u{631}\u{646}\u{6D0} \u{647}\u{645}\u{63A}\u{696}\u{6CD} \u{627}\u{648} \u{631}\u{627}\u{62C}\u{639} \u{6A9}\u{648}\u{644}\u{648} \u{62A}\u{639}\u{642}\u{6CC}\u{628} \u{67E}\u{648}\u{631}\u{6D0}\u{60C} Cumulus \u{67C}\u{6CC}\u{645}\u{648}\u{646}\u{648} \u{633}\u{631}\u{647} \u{645}\u{631}\u{633}\u{62A}\u{647} \u{6A9}\u{648}\u{6CC} \u{686}\u{6D0} \u{6CC}\u{648} \u{681}\u{627}\u{6CC} \u{6A9}\u{627}\u{631} \u{648}\u{6A9}\u{693}\u{6CC}.`,
    pt: `A Cumulus facilita a aproxima\xe7\xe3o de parceiros \u{2014} mesmo entre diferentes sistemas de TI. Desde a admiss\xe3o e avalia\xe7\xe3o at\xe9 a coordena\xe7\xe3o de cuidados e o acompanhamento de encaminhamentos, a Cumulus ajuda as equipes a funcionarem como uma s\xf3.`,
    'pt-pt': `A Cumulus facilita a aproxima\xe7\xe3o de parceiros \u{2014} mesmo em diferentes sistemas de TI. Desde a admiss\xe3o e avalia\xe7\xe3o at\xe9 \xe0 coordena\xe7\xe3o de cuidados e acompanhamento de encaminhamentos, a Cumulus ajuda as equipas a funcionar como uma s\xf3.`,
    ru: `Cumulus \u{43E}\u{431}\u{43B}\u{435}\u{433}\u{447}\u{430}\u{435}\u{442} \u{43E}\u{431}\u{44A}\u{435}\u{434}\u{438}\u{43D}\u{435}\u{43D}\u{438}\u{435} \u{43F}\u{430}\u{440}\u{442}\u{43D}\u{435}\u{440}\u{43E}\u{432} \u{2014} \u{434}\u{430}\u{436}\u{435} \u{432} \u{440}\u{430}\u{437}\u{43D}\u{44B}\u{445} \u{418}\u{422}-\u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{430}\u{445}. \u{41E}\u{442} \u{43F}\u{440}\u{438}\u{451}\u{43C}\u{430} \u{438} \u{43E}\u{446}\u{435}\u{43D}\u{43A}\u{438} \u{434}\u{43E} \u{43A}\u{43E}\u{43E}\u{440}\u{434}\u{438}\u{43D}\u{430}\u{446}\u{438}\u{438} \u{443}\u{445}\u{43E}\u{434}\u{430} \u{438} \u{43E}\u{442}\u{441}\u{43B}\u{435}\u{436}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{43D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{439} \u{2014} Cumulus \u{43F}\u{43E}\u{43C}\u{43E}\u{433}\u{430}\u{435}\u{442} \u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{430}\u{43C} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{430}\u{442}\u{44C} \u{43A}\u{430}\u{43A} \u{435}\u{434}\u{438}\u{43D}\u{43E}\u{435} \u{446}\u{435}\u{43B}\u{43E}\u{435}.`,
    sm: `Cumulus fa'afaigofie ona tu'ufa'atasia pa'aga-e o'o lava i faiga IT eseese. Mai le fa'aaogaina ma le iloiloga i le fa'amaopoopoina o le tausiga ma le siakiina o fa'asino atu, Cumulus fesoasoani i 'au e galulue o se tasi.`,
    so: `Cumulus waxay fududeysaa in la iskeeno la-hawlgalayaal\u{2014}xitaa nidaamyada IT-ga ee kala duwan. Laga bilaabo qaadashada iyo qiimeynta ilaa isku-duwidda daryeelka iyo raadraaca tixraaca, Cumulus waxay ka caawisaa kooxaha inay si hal ah u shaqeeyaan.`,
    th: `Cumulus \u{E17}\u{E4D}\u{E32}\u{E43}\u{E2B}\u{E49}\u{E01}\u{E32}\u{E23}\u{E19}\u{E4D}\u{E32}\u{E1E}\u{E32}\u{E23}\u{E4C}\u{E17}\u{E40}\u{E19}\u{E2D}\u{E23}\u{E4C}\u{E21}\u{E32}\u{E23}\u{E27}\u{E21}\u{E01}\u{E31}\u{E19}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E40}\u{E23}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E07}\u{E48}\u{E32}\u{E22}\u{E41}\u{E21}\u{E49}\u{E43}\u{E19}\u{E23}\u{E30}\u{E1A}\u{E1A}\u{E44}\u{E2D}\u{E17}\u{E35}\u{E17}\u{E35}\u{E48}\u{E41}\u{E15}\u{E01}\u{E15}\u{E48}\u{E32}\u{E07}\u{E01}\u{E31}\u{E19} \u{E15}\u{E31}\u{E49}\u{E07}\u{E41}\u{E15}\u{E48}\u{E01}\u{E32}\u{E23}\u{E23}\u{E31}\u{E1A}\u{E40}\u{E02}\u{E49}\u{E32}\u{E41}\u{E25}\u{E30}\u{E01}\u{E32}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E21}\u{E34}\u{E19}\u{E44}\u{E1B}\u{E08}\u{E19}\u{E16}\u{E36}\u{E07}\u{E01}\u{E32}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E2A}\u{E32}\u{E19}\u{E07}\u{E32}\u{E19}\u{E01}\u{E32}\u{E23}\u{E14}\u{E39}\u{E41}\u{E25}\u{E41}\u{E25}\u{E30}\u{E01}\u{E32}\u{E23}\u{E15}\u{E34}\u{E14}\u{E15}\u{E32}\u{E21}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E15}\u{E48}\u{E2D} Cumulus \u{E0A}\u{E48}\u{E27}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E17}\u{E35}\u{E21}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}`,
    ur: `Cumulus \u{634}\u{631}\u{627}\u{6A9}\u{62A} \u{62F}\u{627}\u{631}\u{648}\u{6BA} \u{6A9}\u{648} \u{627}\u{6CC}\u{6A9} \u{633}\u{627}\u{62A}\u{6BE} \u{644}\u{627}\u{646}\u{627} \u{622}\u{633}\u{627}\u{646} \u{628}\u{646}\u{627}\u{62A}\u{627} \u{6C1}\u{6D2}\u{2014}\u{686}\u{627}\u{6C1}\u{6D2} \u{645}\u{62E}\u{62A}\u{644}\u{641} \u{622}\u{626}\u{6CC} \u{679}\u{6CC} \u{633}\u{633}\u{679}\u{645}\u{632} \u{645}\u{6CC}\u{6BA} \u{6C1}\u{6CC} \u{6A9}\u{6CC}\u{648}\u{6BA} \u{646}\u{6C1} \u{6C1}\u{648}\u{6BA}\u{6D4} \u{627}\u{646}\u{679}\u{6CC}\u{6A9} \u{627}\u{648}\u{631} \u{62A}\u{634}\u{62E}\u{6CC}\u{635} \u{633}\u{6D2} \u{644}\u{6D2} \u{6A9}\u{631} \u{62F}\u{6CC}\u{6A9}\u{6BE} \u{628}\u{6BE}\u{627}\u{644} \u{6A9}\u{6CC} \u{6C1}\u{645} \u{622}\u{6C1}\u{646}\u{6AF}\u{6CC} \u{627}\u{648}\u{631} \u{631}\u{6CC}\u{641}\u{631}\u{644} \u{679}\u{631}\u{6CC}\u{6A9}\u{646}\u{6AF} \u{62A}\u{6A9}\u{60C} Cumulus \u{679}\u{6CC}\u{645}\u{648}\u{6BA} \u{6A9}\u{648} \u{627}\u{6CC}\u{6A9} \u{633}\u{627}\u{62A}\u{6BE} \u{6A9}\u{627}\u{645} \u{6A9}\u{631}\u{646}\u{6D2} \u{645}\u{6CC}\u{6BA} \u{645}\u{62F}\u{62F} \u{62F}\u{6CC}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Cumulus gi\xfap b\u{1EA1}n d\u{1EC5} d\xe0ng k\u{1EBF}t n\u{1ED1}i c\xe1c \u{111}\u{1ED1}i t\xe1c l\u{1EA1}i v\u{1EDB}i nhau\u{2014}ngay c\u{1EA3} tr\xean c\xe1c h\u{1EC7} th\u{1ED1}ng CNTT kh\xe1c nhau. T\u{1EEB} ti\u{1EBF}p nh\u{1EAD}n v\xe0 \u{111}\xe1nh gi\xe1 \u{111}\u{1EBF}n \u{111}i\u{1EC1}u ph\u{1ED1}i ch\u{103}m s\xf3c v\xe0 theo d\xf5i gi\u{1EDB}i thi\u{1EC7}u, Cumulus gi\xfap c\xe1c nh\xf3m l\xe0m vi\u{1EC7}c nh\u{1B0} m\u{1ED9}t.`,
    'zh-hans': `Cumulus\u{4F7F}\u{5F97}\u{8DE8}\u{4E0D}\u{540C}IT\u{7CFB}\u{7EDF}\u{7684}\u{5408}\u{4F5C}\u{4F19}\u{4F34}\u{80FD}\u{591F}\u{8F7B}\u{677E}\u{805A}\u{96C6}\u{5728}\u{4E00}\u{8D77}\u{3002}\u{4ECE}\u{63A5}\u{6536}\u{548C}\u{8BC4}\u{4F30}\u{5230}\u{62A4}\u{7406}\u{534F}\u{8C03}\u{548C}\u{8F6C}\u{8BCA}\u{8DDF}\u{8E2A}\u{FF0C}Cumulus\u{5E2E}\u{52A9}\u{56E2}\u{961F}\u{534F}\u{4F5C}\u{3002}`,
    'zh-hant': `Cumulus \u{8B93}\u{8DE8} IT \u{7CFB}\u{7D71}\u{7684}\u{5408}\u{4F5C}\u{5925}\u{4F34}\u{66F4}\u{5BB9}\u{6613}\u{805A}\u{96C6}\u{5728}\u{4E00}\u{8D77}\u{3002}\u{5F9E}\u{63A5}\u{6536}\u{8207}\u{8A55}\u{4F30}\u{5230}\u{7167}\u{8B77}\u{5354}\u{8ABF}\u{8207}\u{8F49}\u{4ECB}\u{8FFD}\u{8E64}\u{FF0C}Cumulus \u{5E6B}\u{52A9}\u{5718}\u{968A}\u{9F4A}\u{5FC3}\u{5354}\u{529B}\u{3002}`,
    en: `Cumulus makes it easy to bring partners together\u{2014}even across different IT systems. From intake and assessment to care coordination and referral tracking, Cumulus helps teams work as one.`
};
const $b11db1b62d4a8f76$export$8096129ee55f6e7c = {
    ar: `\u{62A}\u{648}\u{627}\u{635}\u{644} \u{645}\u{639}\u{646}\u{627} \u{644}\u{627}\u{633}\u{62A}\u{643}\u{634}\u{627}\u{641} \u{643}\u{64A}\u{641} \u{64A}\u{645}\u{643}\u{646}\u{643} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{629} \u{627}\u{644}\u{642}\u{635}\u{648}\u{649} \u{645}\u{646} Cumulus!`,
    de: `Kontaktieren Sie uns, um herauszufinden, wie Sie das Beste aus Cumulus herausholen k\xf6nnen!`,
    es: `\xa1Cont\xe1ctanos para descubrir c\xf3mo puedes sacar el m\xe1ximo partido a Cumulus!`,
    fa: `\u{628}\u{627} \u{645}\u{627} \u{62A}\u{645}\u{627}\u{633} \u{628}\u{6AF}\u{6CC}\u{631}\u{6CC}\u{62F} \u{62A}\u{627} \u{628}\u{628}\u{6CC}\u{646}\u{6CC}\u{62F} \u{686}\u{6AF}\u{648}\u{646}\u{647} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{6CC}\u{62F} \u{628}\u{6CC}\u{634}\u{62A}\u{631}\u{6CC}\u{646} \u{628}\u{647}\u{631}\u{647} \u{631}\u{627} \u{627}\u{632} Cumulus \u{628}\u{628}\u{631}\u{6CC}\u{62F}!`,
    fil: `Makipag-ugnay sa amin upang malaman kung paano mo makukuha ang pinaka-out ng Cumulus!`,
    fr: `Contactez-nous pour d\xe9couvrir comment tirer le meilleur parti de Cumulus !`,
    hi: `\u{92F}\u{939} \u{91C}\u{93E}\u{928}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{939}\u{92E}\u{938}\u{947} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{915}\u{930}\u{947}\u{902} \u{915}\u{93F} \u{906}\u{92A} \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{94D}\u{92F}\u{932}\u{938} \u{938}\u{947} \u{905}\u{927}\u{93F}\u{915}\u{924}\u{92E} \u{932}\u{93E}\u{92D} \u{915}\u{948}\u{938}\u{947} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{930} \u{938}\u{915}\u{924}\u{947} \u{939}\u{948}\u{902}!`,
    ht: `Kontakte nou yo eksplore ki jan ou ka jwenn pi plis soti nan Cumulus!`,
    it: `Contattaci per scoprire come ottenere il massimo da Cumulus!`,
    ja: `Cumulus\u{3092}\u{6700}\u{5927}\u{9650}\u{306B}\u{6D3B}\u{7528}\u{3059}\u{308B}\u{65B9}\u{6CD5}\u{3092}\u{305C}\u{3072}\u{3054}\u{76F8}\u{8AC7}\u{304F}\u{3060}\u{3055}\u{3044}!`,
    ko: `Cumulus\u{B97C} \u{CD5C}\u{B300}\u{D55C} \u{D65C}\u{C6A9}\u{D560} \u{C218} \u{C788}\u{B294} \u{BC29}\u{BC95}\u{C744} \u{C54C}\u{C544}\u{BCF4}\u{ACE0} \u{C2F6}\u{C73C}\u{C2DC}\u{BA74} \u{C800}\u{D76C}\u{C5D0}\u{AC8C} \u{C5F0}\u{B77D}\u{D574} \u{C8FC}\u{C138}\u{C694}!`,
    mww: `Tiv tauj peb los tshawb nrhiav yuav ua li cas koj tuaj yeem tau txais txiaj ntsig zoo tshaj plaws ntawm Cumulus!`,
    ps: `\u{645}\u{648}\u{696} \u{633}\u{631}\u{647} \u{627}\u{693}\u{6CC}\u{6A9}\u{647} \u{648}\u{646}\u{6CC}\u{633}\u{626} \u{62A}\u{631}\u{685}\u{648} \u{648}\u{6AB}\u{648}\u{631}\u{626} \u{685}\u{646}\u{6AB}\u{647} \u{6A9}\u{648}\u{644}\u{6CC} \u{634}\u{626} \u{644}\u{647} Cumulus \u{685}\u{62E}\u{647} \u{62A}\u{631} \u{67C}\u{648}\u{644}\u{648} \u{632}\u{6CC}\u{627}\u{62A} \u{6AB}\u{67C}\u{647} \u{648}\u{627}\u{62E}\u{644}\u{626}!`,
    pt: `Entre em contato conosco para descobrir como voc\xea pode aproveitar ao m\xe1ximo a Cumulus!`,
    'pt-pt': `Contacte-nos para descobrir como pode tirar o m\xe1ximo partido da Cumulus!`,
    ru: `\u{421}\u{432}\u{44F}\u{436}\u{438}\u{442}\u{435}\u{441}\u{44C} \u{441} \u{43D}\u{430}\u{43C}\u{438}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{443}\u{437}\u{43D}\u{430}\u{442}\u{44C}, \u{43A}\u{430}\u{43A} \u{432}\u{44B} \u{43C}\u{43E}\u{436}\u{435}\u{442}\u{435} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C} \u{43C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C} \u{43E}\u{442} Cumulus!`,
    sm: `Fa'afeso'ota'i mai matou e su'esu'e pe fa'afefea ona e maua le tele o mea mai Cumulus!`,
    so: `Nala soo xiriir si aad u ogaato sida aad uga faa'iideysan karto Cumulus!`,
    th: `\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E40}\u{E23}\u{E32}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E2A}\u{E4D}\u{E32}\u{E23}\u{E27}\u{E08}\u{E27}\u{E48}\u{E32}\u{E04}\u{E38}\u{E13}\u{E08}\u{E30}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E1B}\u{E23}\u{E30}\u{E42}\u{E22}\u{E0A}\u{E19}\u{E4C}\u{E2A}\u{E39}\u{E07}\u{E2A}\u{E38}\u{E14}\u{E08}\u{E32}\u{E01} Cumulus \u{E44}\u{E14}\u{E49}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E44}\u{E23}!`,
    ur: `\u{6C1}\u{645} \u{633}\u{6D2} \u{631}\u{627}\u{628}\u{637}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{62A}\u{627}\u{6A9}\u{6C1} \u{622}\u{67E} Cumulus \u{633}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{633}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{641}\u{627}\u{626}\u{62F}\u{6C1} \u{6A9}\u{6CC}\u{633}\u{6D2} \u{627}\u{679}\u{6BE}\u{627} \u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}!`,
    vi: `Li\xean h\u{1EC7} v\u{1EDB}i ch\xfang t\xf4i \u{111}\u{1EC3} kh\xe1m ph\xe1 c\xe1ch b\u{1EA1}n c\xf3 th\u{1EC3} t\u{1EAD}n d\u{1EE5}ng t\u{1ED1}i \u{111}a Cumulus!`,
    'zh-hans': `\u{8054}\u{7CFB}\u{6211}\u{4EEC}\u{FF0C}\u{63A2}\u{7D22}\u{5982}\u{4F55}\u{6700}\u{5927}\u{5316}\u{5229}\u{7528}Cumulus\u{FF01}`,
    'zh-hant': `\u{6B61}\u{8FCE}\u{806F}\u{7D61}\u{6211}\u{5011}\u{FF0C}\u{63A2}\u{7D22}\u{5982}\u{4F55}\u{6700}\u{5927}\u{5316} Cumulus \u{7684}\u{6548}\u{76CA}\u{FF01}`,
    en: `Contact us to explore how you can get the most out of Cumulus!`
};
const $b11db1b62d4a8f76$export$ab0574a7cbce7d0d = {
    ar: `\u{628}\u{645}\u{627}\u{630}\u{627} \u{64A}\u{645}\u{643}\u{646}\u{646}\u{627} \u{645}\u{633}\u{627}\u{639}\u{62F}\u{62A}\u{643}\u{61F}`,
    de: `Wobei k\xf6nnen wir Ihnen helfen?`,
    es: `\xbfEn qu\xe9 podemos ayudarte?`,
    fa: `\u{686}\u{647} \u{6A9}\u{645}\u{6A9}\u{6CC} \u{627}\u{632} \u{62F}\u{633}\u{62A}\u{645}\u{627}\u{646} \u{628}\u{631}\u{645}\u{6CC} \u{622}\u{6CC}\u{62F}\u{61F}`,
    fil: `Ano ang matutulungan namin sa iyo?`,
    fr: `En quoi pouvons-nous vous aider ?`,
    hi: `\u{939}\u{92E} \u{906}\u{92A}\u{915}\u{940} \u{915}\u{94D}\u{92F}\u{93E} \u{92E}\u{926}\u{926} \u{915}\u{930} \u{938}\u{915}\u{924}\u{947} \u{939}\u{948}\u{902}?`,
    ht: `Kisa nou ka ede ou?`,
    it: `In cosa possiamo aiutarla?`,
    ja: `\u{4F55}\u{306E}\u{3054}\u{7528}\u{4EF6}\u{3067}\u{3057}\u{3087}\u{3046}\u{304B}?`,
    ko: `\u{BB34}\u{C5C7}\u{C744} \u{B3C4}\u{C640}\u{B4DC}\u{B9B4}\u{AE4C}\u{C694}?`,
    mww: `Peb tuaj yeem pab koj nrog dab tsi?`,
    ps: `\u{645}\u{648}\u{696} \u{685}\u{646}\u{6AB}\u{647} \u{645}\u{631}\u{633}\u{62A}\u{647} \u{6A9}\u{648}\u{644}\u{6CC} \u{634}\u{648}\u{61F}`,
    pt: `Com o que podemos ajudar?`,
    'pt-pt': `Em que podemos ajudar?`,
    ru: `\u{427}\u{435}\u{43C} \u{43C}\u{44B} \u{43C}\u{43E}\u{436}\u{435}\u{43C} \u{432}\u{430}\u{43C} \u{43F}\u{43E}\u{43C}\u{43E}\u{447}\u{44C}?`,
    sm: `O le a se mea e mafai ona matou fesoasoani ia te oe?`,
    so: `Maxaan ku caawin karnaa?`,
    th: `\u{E40}\u{E23}\u{E32}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E0A}\u{E48}\u{E27}\u{E22}\u{E04}\u{E38}\u{E13}\u{E2D}\u{E30}\u{E44}\u{E23}\u{E44}\u{E14}\u{E49}\u{E1A}\u{E49}\u{E32}\u{E07}?`,
    ur: `\u{6C1}\u{645} \u{622}\u{67E} \u{6A9}\u{6CC} \u{6A9}\u{633} \u{637}\u{631}\u{62D} \u{645}\u{62F}\u{62F} \u{6A9}\u{631} \u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{61F}`,
    vi: `Ch\xfang t\xf4i c\xf3 th\u{1EC3} gi\xfap b\u{1EA1}n \u{111}i\u{1EC1}u g\xec?`,
    'zh-hans': `\u{6211}\u{4EEC}\u{80FD}\u{5E2E}\u{60A8}\u{4EC0}\u{4E48}\u{FF1F}`,
    'zh-hant': `\u{6211}\u{5011}\u{80FD}\u{5E6B}\u{4F60}\u{4EC0}\u{9EBC}\u{FF1F}`,
    en: `What can we help you with?`
};
const $b11db1b62d4a8f76$export$29d8a84b5523a40f = {
    ar: `\u{62A}\u{648}\u{627}\u{635}\u{644} \u{645}\u{639} \u{627}\u{644}\u{645}\u{633}\u{624}\u{648}\u{644} \u{627}\u{644}\u{62E}\u{627}\u{635} \u{628}\u{643} \u{644}\u{644}\u{62D}\u{635}\u{648}\u{644} \u{639}\u{644}\u{649} \u{627}\u{644}\u{645}\u{633}\u{627}\u{639}\u{62F}\u{629}.`,
    de: `Kontaktieren Sie Ihren Administrator f\xfcr Unterst\xfctzung.`,
    es: `Contacta con tu administrador para recibir ayuda.`,
    fa: `\u{628}\u{631}\u{627}\u{6CC} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{645}\u{6A9} \u{628}\u{627} \u{645}\u{62F}\u{6CC}\u{631} \u{62E}\u{648}\u{62F} \u{62A}\u{645}\u{627}\u{633} \u{628}\u{6AF}\u{6CC}\u{631}\u{6CC}\u{62F}.`,
    fil: `Makipag-ugnay sa iyong administrator para sa tulong.`,
    fr: `Contactez votre administrateur pour obtenir de l\u{2019}aide.`,
    hi: `\u{938}\u{939}\u{93E}\u{92F}\u{924}\u{93E} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{92A}\u{928}\u{947} \u{935}\u{94D}\u{92F}\u{935}\u{938}\u{94D}\u{925}\u{93E}\u{92A}\u{915} \u{938}\u{947} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{915}\u{930}\u{947}\u{902}.`,
    ht: `Kontakte administrat\xe8 ou pou \xe8d.`,
    it: `Contatta il tuo amministratore per assistenza.`,
    ja: `\u{652F}\u{63F4}\u{304C}\u{5FC5}\u{8981}\u{306A}\u{5834}\u{5408}\u{306F}\u{7BA1}\u{7406}\u{8005}\u{306B}\u{304A}\u{554F}\u{3044}\u{5408}\u{308F}\u{305B}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{B3C4}\u{C6C0}\u{C774} \u{D544}\u{C694}\u{D558}\u{BA74} \u{AD00}\u{B9AC}\u{C790}\u{C5D0}\u{AC8C} \u{C5F0}\u{B77D}\u{D558}\u{C138}\u{C694}.`,
    mww: `Hu rau koj tus thawj tswj hwm kom tau kev pab.`,
    ps: `\u{62F} \u{645}\u{631}\u{633}\u{62A}\u{6D0} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{644}\u{647} \u{62E}\u{67E}\u{644} \u{645}\u{62F}\u{6CC}\u{631} \u{633}\u{631}\u{647} \u{627}\u{693}\u{6CC}\u{6A9}\u{647} \u{648}\u{646}\u{6CC}\u{633}\u{626}.`,
    pt: `Entre em contato com seu administrador para obter assist\xeancia.`,
    'pt-pt': `Contacte o seu administrador para obter ajuda.`,
    ru: `\u{421}\u{432}\u{44F}\u{436}\u{438}\u{442}\u{435}\u{441}\u{44C} \u{441} \u{430}\u{434}\u{43C}\u{438}\u{43D}\u{438}\u{441}\u{442}\u{440}\u{430}\u{442}\u{43E}\u{440}\u{43E}\u{43C} \u{434}\u{43B}\u{44F} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{438}\u{44F} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{438}.`,
    sm: `Faafesootai lou pule mo se fesoasoani.`,
    so: `La xiriir maamulahaaga si aad u hesho caawimaad.`,
    th: `\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E1C}\u{E39}\u{E49}\u{E14}\u{E39}\u{E41}\u{E25}\u{E23}\u{E30}\u{E1A}\u{E1A}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E02}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E0A}\u{E48}\u{E27}\u{E22}\u{E40}\u{E2B}\u{E25}\u{E37}\u{E2D}`,
    ur: `\u{645}\u{62F}\u{62F} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{67E}\u{646}\u{6D2} \u{627}\u{6CC}\u{688}\u{645}\u{646}\u{633}\u{679}\u{631}\u{6CC}\u{679}\u{631} \u{633}\u{6D2} \u{631}\u{627}\u{628}\u{637}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Li\xean h\u{1EC7} v\u{1EDB}i qu\u{1EA3}n tr\u{1ECB} vi\xean c\u{1EE7}a b\u{1EA1}n \u{111}\u{1EC3} \u{111}\u{1B0}\u{1EE3}c h\u{1ED7} tr\u{1EE3}.`,
    'zh-hans': `\u{8BF7}\u{8054}\u{7CFB}\u{60A8}\u{7684}\u{7BA1}\u{7406}\u{5458}\u{5BFB}\u{6C42}\u{5E2E}\u{52A9}\u{3002}`,
    'zh-hant': `\u{8ACB}\u{806F}\u{7D61}\u{4F60}\u{7684}\u{7BA1}\u{7406}\u{54E1}\u{5C0B}\u{6C42}\u{5354}\u{52A9}\u{3002}`,
    en: `Contact your administrator for assistance.`
};
const $b11db1b62d4a8f76$export$d1b8bb849ba247c6 = {
    ar: `\u{62A}\u{627}\u{628}\u{639}`,
    de: `Weitermachen`,
    es: `Contin\xfaa`,
    fa: `\u{627}\u{62F}\u{627}\u{645}\u{647} \u{628}\u{62F}\u{647}`,
    fil: `Magpatuloy`,
    fr: `Continuez`,
    hi: `\u{906}\u{917}\u{947} \u{92C}\u{922}\u{93C}\u{928}\u{93E}`,
    ht: `Kontinye`,
    it: `Continua`,
    ja: `\u{7D9A}\u{3051}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{ACC4}\u{C18D}`,
    mww: `txuas ntxiv`,
    ps: `\u{62F}\u{648}\u{627}\u{645} \u{648}\u{631}\u{6A9}\u{693}\u{647}`,
    pt: `Continue`,
    'pt-pt': `Continuar`,
    ru: `\u{41F}\u{440}\u{43E}\u{434}\u{43E}\u{43B}\u{436}\u{430}\u{439}\u{442}\u{435}`,
    sm: `Fa'aauau`,
    so: `Sii wad`,
    th: `\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{62C}\u{627}\u{631}\u{6CC} \u{631}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Ti\u{1EBF}p t\u{1EE5}c`,
    'zh-hans': `\u{7EE7}\u{7EED}`,
    'zh-hant': `\u{7E7C}\u{7E8C}`,
    en: `Continue`
};
const $b11db1b62d4a8f76$export$f5cada3af2ad26dd = {
    ar: (provider)=>`\u{62A}\u{627}\u{628}\u{639} \u{645}\u{639} ${provider}`,
    de: (provider)=>`Fahren Sie mit ${provider} fort`,
    es: (provider)=>`Contin\xfaa con ${provider}`,
    fa: (provider)=>`\u{627}\u{62F}\u{627}\u{645}\u{647} ${provider}`,
    fil: (provider)=>`Magpatuloy sa ${provider}`,
    fr: (provider)=>`Continuez avec ${provider}`,
    hi: (provider)=>`${provider} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{91C}\u{93E}\u{930}\u{940} \u{930}\u{916}\u{947}\u{902}`,
    ht: (provider)=>`Kontinye ak ${provider}`,
    it: (provider)=>`Continua con ${provider}`,
    ja: (provider)=>`${provider}\u{3067}\u{7D9A}\u{3051}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: (provider)=>`${provider}\u{B85C} \u{ACC4}\u{C18D} \u{C774}\u{C5B4}\u{AC00}\u{C138}\u{C694}`,
    mww: (provider)=>`Txuas ntxiv nrog ${provider}`,
    ps: (provider)=>`\u{644}\u{647} ${provider} \u{633}\u{631}\u{647} \u{62F}\u{648}\u{627}\u{645} \u{648}\u{631}\u{6A9}\u{693}\u{626}`,
    pt: (provider)=>`Continue com ${provider}`,
    'pt-pt': (provider)=>`Continue com ${provider}`,
    ru: (provider)=>`\u{41F}\u{440}\u{43E}\u{434}\u{43E}\u{43B}\u{436}\u{430}\u{439}\u{442}\u{435} \u{441} ${provider}`,
    sm: (provider)=>`Fa'aauau pea ma ${provider}`,
    so: (provider)=>`Sii wad ${provider}`,
    th: (provider)=>`\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E15}\u{E48}\u{E2D}\u{E14}\u{E49}\u{E27}\u{E22} ${provider}`,
    ur: (provider)=>`${provider} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{62C}\u{627}\u{631}\u{6CC} \u{631}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: (provider)=>`Ti\u{1EBF}p t\u{1EE5}c v\u{1EDB}i ${provider}`,
    'zh-hans': (provider)=>`\u{7EE7}\u{7EED}\u{7528} ${provider}`,
    'zh-hant': (provider)=>`\u{7E7C}\u{7E8C}\u{7528} ${provider}`,
    en: (provider)=>`Continue with ${provider}`
};
const $b11db1b62d4a8f76$export$5f3f16f9a09161d9 = {
    ar: `\u{627}\u{644}\u{639}\u{642}\u{62F}`,
    de: `Vertrag`,
    es: `Contrato`,
    fa: `\u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F}`,
    fil: `Kontrata`,
    fr: `Contrat`,
    hi: `\u{907}\u{915}\u{93C}\u{930}\u{93E}\u{930}\u{928}\u{93E}\u{92E}\u{93E} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `Kontra`,
    it: `Contratto`,
    ja: `\u{5951}\u{7D04}`,
    ko: `\u{ACC4}\u{C57D}`,
    mww: `Daim Ntawv Cog Lus`,
    ps: `\u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F}`,
    pt: `Contrato`,
    'pt-pt': `Contrato`,
    ru: `\u{41A}\u{43E}\u{43D}\u{442}\u{440}\u{430}\u{43A}\u{442}`,
    sm: `Konekarate`,
    so: `Qandaraaska`,
    th: `\u{E2A}\u{E31}\u{E0D}\u{E0D}\u{E32}`,
    ur: `\u{645}\u{639}\u{627}\u{6C1}\u{62F}\u{6C1}`,
    vi: `H\u{1EE3}p \u{111}\u{1ED3}ng`,
    'zh-hans': `\u{5408}\u{540C}`,
    'zh-hant': `\u{5408}\u{7D04}`,
    en: `Contract`
};
const $b11db1b62d4a8f76$export$e783655bdf5d6389 = {
    ar: `\u{62A}\u{639}\u{627}\u{642}\u{62F}\u{62A} \u{645}\u{639} \u{645}\u{646}\u{638}\u{645}\u{629} \u{62A}\u{634}\u{627}\u{631}\u{643} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Beauftragte eine Organisation, die an dieser Aktivit\xe4t beteiligt war.`,
    es: `Contratamos a una organizaci\xf3n que participa en esta actividad.`,
    fa: `\u{628}\u{627} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{634}\u{631}\u{6A9}\u{62A} \u{62F}\u{627}\u{631}\u{62F} \u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F} \u{628}\u{633}\u{62A}.`,
    fil: `Nakipag-ugnayan sa isang organisasyon na nakikilahok sa aktibidad na ito.`,
    fr: `A contract\xe9 une organisation participant \xe0 cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92E}\u{947}\u{902} \u{92D}\u{93E}\u{917} \u{932}\u{947}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{90F}\u{915} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{94B} \u{905}\u{928}\u{941}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{915}\u{93F}\u{92F}\u{93E}\u{964}`,
    ht: `Kontrate yon \xf2ganizasyon k ap patisipe nan aktivite sa a.`,
    it: `Ha incaricato un'organizzazione che partecipa a questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306B}\u{53C2}\u{52A0}\u{3059}\u{308B}\u{7D44}\u{7E54}\u{3068}\u{5951}\u{7D04}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{CC38}\u{C5EC}\u{D558}\u{B294} \u{B2E8}\u{CCB4}\u{C640} \u{ACC4}\u{C57D}\u{C744} \u{B9FA}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Cog lus rau ib lub koom haum koom nrog txoj haujlwm no.`,
    ps: `\u{645}\u{627} \u{62F} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{67E}\u{647} \u{628}\u{631}\u{62E}\u{647} \u{6A9}\u{6D0} \u{62F} \u{6CC}\u{648}\u{6D0} \u{627}\u{62F}\u{627}\u{631}\u{6D0} \u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F} \u{648}\u{6A9}\u{693}.`,
    pt: `Contratou uma organiza\xe7\xe3o que participe dessa atividade.`,
    'pt-pt': `Contratou uma organiza\xe7\xe3o que participe nesta atividade.`,
    ru: `\u{417}\u{430}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{43B} \u{43A}\u{43E}\u{43D}\u{442}\u{440}\u{430}\u{43A}\u{442} \u{441} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{435}\u{439}, \u{443}\u{447}\u{430}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{435}\u{439} \u{432} \u{44D}\u{442}\u{43E}\u{439} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}.`,
    sm: `Fa'afeso'ota'i se fa'alapotopotoga o lo'o auai i lenei gaoioiga.`,
    so: `Wuxuu qandaraas la galay urur ka qayb qaadanaya hawshan.`,
    th: `\u{E17}\u{E4D}\u{E32}\u{E2A}\u{E31}\u{E0D}\u{E0D}\u{E32}\u{E01}\u{E31}\u{E1A}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{62D}\u{635}\u{6C1} \u{644}\u{6CC}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6CC} \u{627}\u{6CC}\u{6A9} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{633}\u{6D2} \u{645}\u{639}\u{627}\u{6C1}\u{62F}\u{6C1} \u{6A9}\u{6CC}\u{627}\u{6D4}`,
    vi: `\u{110}\xe3 k\xfd h\u{1EE3}p \u{111}\u{1ED3}ng v\u{1EDB}i m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c tham gia ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{7B7E}\u{7EA6}\u{4E86}\u{4E00}\u{4E2A}\u{53C2}\u{4E0E}\u{8BE5}\u{6D3B}\u{52A8}\u{7684}\u{7EC4}\u{7EC7}\u{3002}`,
    'zh-hant': `\u{8207}\u{53C3}\u{8207}\u{6B64}\u{6D3B}\u{52D5}\u{7684}\u{7D44}\u{7E54}\u{7C3D}\u{7D04}\u{3002}`,
    en: `Contracted an organization participating in this activity.`
};
const $b11db1b62d4a8f76$export$5f486e535de293fa = {
    ar: `\u{646}\u{633}\u{62E}\u{629}`,
    de: `Verstanden`,
    es: `Copiado`,
    fa: `\u{6A9}\u{67E}\u{6CC}`,
    fil: `Kopyahin`,
    fr: `Bien re\xe7u`,
    hi: `\u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{932}\u{93F}\u{92A}\u{93F}`,
    ht: `Kopi`,
    it: `Ricevuto`,
    ja: `\u{4E86}\u{89E3}`,
    ko: `\u{C54C}\u{ACA0}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `luam`,
    ps: `\u{6A9}\u{627}\u{67E}\u{6CC}`,
    pt: `C\xf3pia`,
    'pt-pt': `C\xf3pia`,
    ru: `\u{41F}\u{440}\u{438}\u{43D}\u{44F}\u{442}\u{43E}`,
    sm: `Kopi`,
    so: `Fahmay`,
    th: `\u{E2A}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E32}`,
    ur: `\u{646}\u{642}\u{644}`,
    vi: `Sao ch\xe9p`,
    'zh-hans': `\u{6536}\u{5230}`,
    'zh-hant': `\u{6536}\u{5230}`,
    en: `Copy`
};
const $b11db1b62d4a8f76$export$461c419fb0e50d24 = {
    ar: `\u{631}\u{627}\u{628}\u{637} \u{627}\u{644}\u{646}\u{633}\u{62E}`,
    de: `Link kopieren`,
    es: `Copiar enlace`,
    fa: `\u{6A9}\u{67E}\u{6CC} \u{644}\u{6CC}\u{646}\u{6A9}`,
    fil: `Email Address *`,
    fr: `Lien copi\xe9`,
    hi: `\u{932}\u{93F}\u{902}\u{915} \u{915}\u{949}\u{92A}\u{940} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Kopi lyen`,
    it: `Copia link`,
    ja: `\u{30EA}\u{30F3}\u{30AF}\u{3092}\u{30B3}\u{30D4}\u{30FC}\u{3057}\u{307E}\u{3059}`,
    ko: `\u{B9C1}\u{D06C} \u{BCF5}\u{C0AC}`,
    mww: `Luam qhov txuas`,
    ps: `\u{6A9}\u{627}\u{67E}\u{6CC} \u{644}\u{6CC}\u{646}\u{6A9}`,
    pt: `Copiar link`,
    'pt-pt': `Copiar link`,
    ru: `\u{421}\u{43A}\u{43E}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443}`,
    sm: `Kopi sootaga`,
    so: `Nuqul link`,
    th: `\u{E04}\u{E31}\u{E14}\u{E25}\u{E2D}\u{E01}\u{E25}\u{E34}\u{E07}\u{E04}\u{E4C}`,
    ur: `\u{6A9}\u{627}\u{67E}\u{6CC} \u{644}\u{646}\u{6A9}`,
    vi: `Sao ch\xe9p li\xean k\u{1EBF}t`,
    'zh-hans': `\u{590D}\u{5236}\u{94FE}\u{63A5}`,
    'zh-hant': `\u{8907}\u{88FD}\u{9023}\u{7D50}`,
    en: `Copy link`
};
const $b11db1b62d4a8f76$export$11b12d95aadca158 = {
    ar: `\u{627}\u{646}\u{633}\u{62E} \u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{639}\u{627}\u{62F}\u{629} \u{647}\u{630}\u{627} \u{648}\u{627}\u{62D}\u{62A}\u{641}\u{638} \u{628}\u{647} \u{641}\u{64A} \u{645}\u{643}\u{627}\u{646} \u{622}\u{645}\u{646}. \u{633}\u{62A}\u{62D}\u{62A}\u{627}\u{62C}\u{647} \u{625}\u{630}\u{627} \u{627}\u{62D}\u{62A}\u{62C}\u{62A} \u{64A}\u{648}\u{645}\u{627} \u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{628}\u{62F}\u{648}\u{646} \u{62C}\u{647}\u{627}\u{632}\u{643}.`,
    de: `Kopiere diesen Wiederherstellungscode und bewahre ihn an einem sicheren Ort auf. Du wirst es brauchen, falls du dich jemals ohne dein Ger\xe4t anmelden musst.`,
    es: `Copia este c\xf3digo de recuperaci\xf3n y gu\xe1rdalo en un lugar seguro. La necesitar\xe1s si alguna vez necesitas iniciar sesi\xf3n sin tu dispositivo.`,
    fa: `\u{627}\u{6CC}\u{646} \u{6A9}\u{62F} \u{628}\u{627}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{631}\u{627} \u{6A9}\u{67E}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{62C}\u{627}\u{6CC}\u{6CC} \u{627}\u{645}\u{646} \u{646}\u{6AF}\u{647} \u{62F}\u{627}\u{631}\u{6CC}\u{62F}. \u{627}\u{6AF}\u{631} \u{631}\u{648}\u{632}\u{6CC} \u{646}\u{6CC}\u{627}\u{632} \u{628}\u{647} \u{648}\u{631}\u{648}\u{62F} \u{628}\u{62F}\u{648}\u{646} \u{62F}\u{633}\u{62A}\u{6AF}\u{627}\u{647} \u{62F}\u{627}\u{634}\u{62A}\u{6CC}\u{62F}\u{60C} \u{628}\u{647} \u{622}\u{646} \u{646}\u{6CC}\u{627}\u{632} \u{62E}\u{648}\u{627}\u{647}\u{6CC}\u{62F} \u{62F}\u{627}\u{634}\u{62A}.`,
    fil: `Kopyahin ang recovery code na ito at itago ito sa isang lugar na ligtas. Kakailanganin mo ito kung sakaling kailangan mong mag-log in nang wala ang iyong aparato.`,
    fr: `Copiez ce code de r\xe9cup\xe9ration et gardez-le en lieu s\xfbr. Vous en aurez besoin si jamais vous devez vous connecter sans votre appareil.`,
    hi: `\u{907}\u{938} \u{930}\u{93F}\u{915}\u{935}\u{930}\u{940} \u{915}\u{94B}\u{921} \u{915}\u{94B} \u{915}\u{949}\u{92A}\u{940} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{907}\u{938}\u{947} \u{915}\u{939}\u{940}\u{902} \u{938}\u{941}\u{930}\u{915}\u{94D}\u{937}\u{93F}\u{924} \u{930}\u{916}\u{947}\u{902}\u{964} \u{92F}\u{926}\u{93F} \u{906}\u{92A}\u{915}\u{94B} \u{915}\u{92D}\u{940} \u{92D}\u{940} \u{905}\u{92A}\u{928}\u{947} \u{921}\u{93F}\u{935}\u{93E}\u{907}\u{938} \u{915}\u{947} \u{92C}\u{93F}\u{928}\u{93E} \u{932}\u{949}\u{917} \u{907}\u{928} \u{915}\u{930}\u{928}\u{947} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{94B}\u{924}\u{940} \u{939}\u{948} \u{924}\u{94B} \u{906}\u{92A}\u{915}\u{94B} \u{907}\u{938}\u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{94B}\u{917}\u{940}\u{964}`,
    ht: `Kopi k\xf2d gerizon sa a epi kenbe li yon kote ki an sekirite. Ou pral bezwen li si ou janm bezwen ouvri sesyon an san yo pa apar\xe8y ou an.`,
    it: `Copia questo codice di recupero e tienilo in un posto sicuro. Ti servir\xe0 se mai dovrai accedere senza il dispositivo.`,
    ja: `\u{3053}\u{306E}\u{30EA}\u{30AB}\u{30D0}\u{30EA}\u{30FC}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{30B3}\u{30D4}\u{30FC}\u{3057}\u{3066}\u{5B89}\u{5168}\u{306A}\u{5834}\u{6240}\u{306B}\u{4FDD}\u{7BA1}\u{3057}\u{308D}\u{3002}\u{3082}\u{3057}\u{30C7}\u{30D0}\u{30A4}\u{30B9}\u{306A}\u{3057}\u{3067}\u{30ED}\u{30B0}\u{30A4}\u{30F3}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308B}\u{5834}\u{5408}\u{3001}\u{5FC5}\u{305A}\u{5FC5}\u{8981}\u{306B}\u{306A}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{BCF5}\u{AD6C} \u{CF54}\u{B4DC}\u{B97C} \u{BCF5}\u{C0AC}\u{D574}\u{C11C} \u{C548}\u{C804}\u{D55C} \u{ACF3}\u{C5D0} \u{BCF4}\u{AD00}\u{D558}\u{C138}\u{C694}. \u{AE30}\u{AE30} \u{C5C6}\u{C774} \u{B85C}\u{ADF8}\u{C778}\u{D574}\u{C57C} \u{D560} \u{B54C} \u{D544}\u{C694}\u{D560} \u{B54C} \u{AF2D} \u{D544}\u{C694}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Luam no rov qab code thiab cia nws nyob qhov chaw nyab xeeb. Koj yuav xav tau nws yog tias koj puas tau nkag mus yam tsis muaj koj lub cuab yeej.`,
    ps: `\u{62F}\u{627} \u{62F} \u{628}\u{6CC}\u{627} \u{631}\u{63A}\u{648}\u{646}\u{6D0} \u{6A9}\u{648}\u{689} \u{6A9}\u{627}\u{67E}\u{6CC} \u{6A9}\u{693}\u{647} \u{627}\u{648} \u{67E}\u{647} \u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{681}\u{627}\u{6CC} \u{6A9}\u{6D0} \u{6CC}\u{6D0} \u{6A9}\u{6D0}\u{696}\u{62F}\u{647}. \u{6A9}\u{647} \u{6A9}\u{644}\u{647} \u{647}\u{645} \u{627}\u{693}\u{62A}\u{6CC}\u{627} \u{648}\u{6CC} \u{686}\u{6D0} \u{628}\u{6D0} \u{644}\u{647} \u{62E}\u{67E}\u{644} \u{622}\u{644}\u{6D0} \u{646}\u{646}\u{648}\u{62A}\u{644} \u{648}\u{6A9}\u{693}\u{6D0}\u{60C} \u{646}\u{648} \u{62A}\u{647} \u{628}\u{647} \u{648}\u{631}\u{62A}\u{647} \u{627}\u{693}\u{62A}\u{6CC}\u{627} \u{648}\u{644}\u{631}\u{6D0}.`,
    pt: `Copie esse c\xf3digo de recupera\xe7\xe3o e guarde em um lugar seguro. Voc\xea vai precisar dele se algum dia precisar fazer login sem seu dispositivo.`,
    'pt-pt': `Copie este c\xf3digo de recupera\xe7\xe3o e guarde-o num local seguro. Vais precisar dele se alguma vez precisares de iniciar sess\xe3o sem o teu dispositivo.`,
    ru: `\u{421}\u{43A}\u{43E}\u{43F}\u{438}\u{440}\u{443}\u{439}\u{442}\u{435} \u{44D}\u{442}\u{43E}\u{442} \u{43A}\u{43E}\u{434} \u{432}\u{43E}\u{441}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{438} \u{445}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{435} \u{435}\u{433}\u{43E} \u{432} \u{431}\u{435}\u{437}\u{43E}\u{43F}\u{430}\u{441}\u{43D}\u{43E}\u{43C} \u{43C}\u{435}\u{441}\u{442}\u{435}. \u{41E}\u{43D} \u{43F}\u{43E}\u{43D}\u{430}\u{434}\u{43E}\u{431}\u{438}\u{442}\u{441}\u{44F}, \u{435}\u{441}\u{43B}\u{438} \u{43A}\u{43E}\u{433}\u{434}\u{430}-\u{43D}\u{438}\u{431}\u{443}\u{434}\u{44C} \u{43D}\u{443}\u{436}\u{43D}\u{43E} \u{432}\u{43E}\u{439}\u{442}\u{438} \u{431}\u{435}\u{437} \u{443}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{441}\u{442}\u{432}\u{430}.`,
    sm: `Kopi lenei numera laiti toe faaleleia ma teu i se mea saogalemu. O le ae manaomia ai pe afai e te manaomia e alu i totonu e aunoa ma lau masini.`,
    so: `Nuqul ka qaad koodhkan soo kabashada oo meel ammaan ah ku hay. Waxaad u baahan doontaa haddii aad mar walba u baahato inaad gasho adigoon qalabkaaga wato.`,
    th: `\u{E04}\u{E31}\u{E14}\u{E25}\u{E2D}\u{E01}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E01}\u{E39}\u{E49}\u{E04}\u{E37}\u{E19}\u{E19}\u{E35}\u{E49}\u{E41}\u{E25}\u{E30}\u{E40}\u{E01}\u{E47}\u{E1A}\u{E44}\u{E27}\u{E49}\u{E43}\u{E19}\u{E17}\u{E35}\u{E48}\u{E1B}\u{E25}\u{E2D}\u{E14}\u{E20}\u{E31}\u{E22} \u{E04}\u{E38}\u{E13}\u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E43}\u{E0A}\u{E49}\u{E21}\u{E31}\u{E19}\u{E2B}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E40}\u{E02}\u{E49}\u{E32}\u{E2A}\u{E39}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E1A}\u{E42}\u{E14}\u{E22}\u{E44}\u{E21}\u{E48}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E43}\u{E0A}\u{E49}\u{E2D}\u{E38}\u{E1B}\u{E01}\u{E23}\u{E13}\u{E4C}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{648}\u{631}\u{6CC} \u{6A9}\u{648}\u{688} \u{6A9}\u{648} \u{6A9}\u{627}\u{67E}\u{6CC} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{627}\u{633}\u{6D2} \u{645}\u{62D}\u{641}\u{648}\u{638} \u{62C}\u{6AF}\u{6C1} \u{67E}\u{631} \u{631}\u{6A9}\u{6BE}\u{6CC}\u{6BA}\u{6D4} \u{627}\u{6AF}\u{631} \u{6A9}\u{628}\u{6BE}\u{6CC} \u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{67E}\u{646}\u{6D2} \u{688}\u{6CC}\u{648}\u{627}\u{626}\u{633} \u{6A9}\u{6D2} \u{628}\u{63A}\u{6CC}\u{631} \u{644}\u{627}\u{6AF} \u{627}\u{646} \u{6A9}\u{631}\u{646}\u{627} \u{67E}\u{691}\u{6D2} \u{62A}\u{648} \u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} \u{6A9}\u{6CC} \u{636}\u{631}\u{648}\u{631}\u{62A} \u{67E}\u{691}\u{6D2} \u{6AF}\u{6CC}\u{6D4}`,
    vi: `Sao ch\xe9p m\xe3 kh\xf4i ph\u{1EE5}c n\xe0y v\xe0 gi\u{1EEF} n\xf3 \u{1EDF} n\u{1A1}i an to\xe0n. B\u{1EA1}n s\u{1EBD} c\u{1EA7}n n\xf3 n\u{1EBF}u b\u{1EA1}n c\u{1EA7}n \u{111}\u{103}ng nh\u{1EAD}p m\xe0 kh\xf4ng c\u{1EA7}n thi\u{1EBF}t b\u{1ECB} c\u{1EE7}a m\xecnh.`,
    'zh-hans': `\u{590D}\u{5236}\u{8FD9}\u{4E2A}\u{6062}\u{590D}\u{7801}\u{FF0C}\u{653E}\u{5728}\u{5B89}\u{5168}\u{7684}\u{5730}\u{65B9}\u{3002}\u{5982}\u{679C}\u{4F60}\u{9700}\u{8981}\u{5728}\u{6CA1}\u{6709}\u{8BBE}\u{5907}\u{7684}\u{60C5}\u{51B5}\u{4E0B}\u{767B}\u{5F55}\u{FF0C}\u{4F60}\u{4F1A}\u{9700}\u{8981}\u{5B83}\u{3002}`,
    'zh-hant': `\u{8907}\u{88FD}\u{9019}\u{500B}\u{5FA9}\u{539F}\u{78BC}\u{FF0C}\u{4E26}\u{59A5}\u{5584}\u{4FDD}\u{7BA1}\u{3002}\u{5982}\u{679C}\u{4F60}\u{9700}\u{8981}\u{5728}\u{6C92}\u{6709}\u{88DD}\u{7F6E}\u{7684}\u{60C5}\u{6CC1}\u{4E0B}\u{767B}\u{5165}\u{FF0C}\u{9019}\u{529F}\u{80FD}\u{6703}\u{5F88}\u{91CD}\u{8981}\u{3002}`,
    en: `Copy this recovery code and keep it somewhere safe. You\u{2019}ll need it if you ever need to log in without your device.`
};
const $b11db1b62d4a8f76$export$630755366f6c788e = {
    ar: `\u{646}\u{633}\u{62E} \u{631}\u{627}\u{628}\u{637} \u{642}\u{627}\u{628}\u{644} \u{644}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{629}`,
    de: `Teilbarer Link kopieren`,
    es: `Copiar enlace compartible`,
    fa: `\u{6A9}\u{67E}\u{6CC} \u{644}\u{6CC}\u{646}\u{6A9} \u{642}\u{627}\u{628}\u{644} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6AF}\u{630}\u{627}\u{631}\u{6CC}`,
    fil: `Kopyahin ang link na maaaring ibahagi`,
    fr: `Lien partageable \xe0 copier`,
    hi: `\u{938}\u{93E}\u{91D}\u{93E} \u{915}\u{930}\u{928}\u{947} \u{92F}\u{94B}\u{917}\u{94D}\u{92F} \u{932}\u{93F}\u{902}\u{915} \u{915}\u{940} \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{932}\u{93F}\u{92A}\u{93F} \u{92C}\u{928}\u{93E}\u{90F}\u{901}`,
    ht: `Kopi lyen pataje`,
    it: `Copia link condividere`,
    ja: `\u{5171}\u{6709}\u{53EF}\u{80FD}\u{306A}\u{30EA}\u{30F3}\u{30AF}\u{3092}\u{30B3}\u{30D4}\u{30FC}\u{3057}\u{307E}\u{3059}`,
    ko: `\u{ACF5}\u{C720} \u{AC00}\u{B2A5}\u{D55C} \u{B9C1}\u{D06C} \u{BCF5}\u{C0AC}`,
    mww: `Luam qhov txuas sib koom`,
    ps: `\u{634}\u{631}\u{6CC}\u{6A9}\u{6D0}\u{62F}\u{648}\u{646}\u{6A9}\u{6CC} \u{644}\u{6CC}\u{646}\u{6A9} \u{6A9}\u{627}\u{67E}\u{6CC} \u{6A9}\u{693}\u{626}`,
    pt: `Copiar link compartilh\xe1vel`,
    'pt-pt': `Copiar link partilh\xe1vel`,
    ru: `\u{421}\u{43A}\u{43E}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443} \u{434}\u{43B}\u{44F} \u{43E}\u{431}\u{43C}\u{435}\u{43D}\u{430}`,
    sm: `Kopi sootaga e mafai ona faasoa atu`,
    so: `Nuqul ka qaado xiriirka la wadaagi karo`,
    th: `\u{E04}\u{E31}\u{E14}\u{E25}\u{E2D}\u{E01}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E41}\u{E0A}\u{E23}\u{E4C}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{634}\u{6CC}\u{626}\u{631} \u{627}\u{6CC}\u{628}\u{644} \u{644}\u{646}\u{6A9} \u{6A9}\u{627}\u{67E}\u{6CC} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Sao ch\xe9p li\xean k\u{1EBF}t c\xf3 th\u{1EC3} chia s\u{1EBB}`,
    'zh-hans': `\u{590D}\u{5236}\u{53EF}\u{5206}\u{4EAB}\u{94FE}\u{63A5}`,
    'zh-hant': `\u{8907}\u{88FD}\u{53EF}\u{5206}\u{4EAB}\u{9023}\u{7D50}`,
    en: `Copy shareable link`
};
const $b11db1b62d4a8f76$export$684753ce26f19e56 = {
    ar: `\u{643}\u{627}\u{646}\u{62A}\u{631}\u{64A}`,
    de: `Land`,
    es: `Pa\xeds`,
    fa: `\u{6A9}\u{627}\u{646}\u{62A}\u{631}\u{6CC}`,
    fil: `Bansa`,
    fr: `Pays`,
    hi: `\u{92D}\u{942}\u{915}\u{94D}\u{937}\u{947}\u{924}\u{94D}\u{930}`,
    ht: `Peyi a`,
    it: `Paese`,
    ja: `\u{56FD}`,
    ko: `\u{AD6D}\u{AC00}`,
    mww: `Lub teb chaws`,
    ps: `\u{6A9}\u{646}\u{67C}\u{631}\u{6CC}`,
    pt: `Pa\xeds`,
    'pt-pt': `Pa\xeds`,
    ru: `\u{41A}\u{430}\u{43D}\u{442}\u{440}\u{438}`,
    sm: `Atunuu`,
    so: `Dalka`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E40}\u{E17}\u{E28}`,
    ur: `\u{6A9}\u{646}\u{679}\u{631}\u{6CC}`,
    vi: `Qu\u{1ED1}c gia`,
    'zh-hans': `\u{4E61}\u{6751}`,
    'zh-hant': `\u{9109}\u{6751}`,
    en: `Country`
};
const $b11db1b62d4a8f76$export$b71244072853bd35 = {
    ar: `\u{627}\u{644}\u{645}\u{642}\u{627}\u{637}\u{639}\u{629}`,
    de: `Bezirk`,
    es: `Condado`,
    fa: `\u{634}\u{647}\u{631}\u{633}\u{62A}\u{627}\u{646}`,
    fil: `County`,
    fr: `Comt\xe9`,
    hi: `\u{915}\u{93E}\u{909}\u{902}\u{91F}\u{940}`,
    ht: `Konte`,
    it: `Contea`,
    ja: `\u{90E1}`,
    ko: `\u{CE74}\u{C6B4}\u{D2F0}`,
    mww: `Lub Nroog`,
    ps: `\u{648}\u{644}\u{627}\u{6CC}\u{62A}`,
    pt: `Condado`,
    'pt-pt': `Condado`,
    ru: `\u{413}\u{440}\u{430}\u{444}\u{441}\u{442}\u{432}\u{43E}`,
    sm: `Itumalo`,
    so: `Degmada`,
    th: `\u{E40}\u{E04}\u{E32}\u{E19}\u{E4C}\u{E15}\u{E35}`,
    ur: `\u{6A9}\u{627}\u{624}\u{646}\u{679}\u{6CC}`,
    vi: `Qu\u{1EAD}n`,
    'zh-hans': `\u{53BF}\u{7EA7}`,
    'zh-hant': `\u{7E23}`,
    en: `County`
};
const $b11db1b62d4a8f76$export$baff25308003b0cc = {
    ar: `\u{627}\u{635}\u{646}\u{639}`,
    de: `Erstellen Sie`,
    es: `Crear`,
    fa: `\u{62E}\u{644}\u{642} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Lumikha`,
    fr: `Cr\xe9er`,
    hi: `\u{92C}\u{928}\u{93E}\u{90F}\u{902}`,
    ht: `Kreye`,
    it: `Crea`,
    ja: `\u{4F5C}\u{6210}`,
    ko: `\u{CC3D}\u{C870}`,
    mww: `tsim`,
    ps: `Create`,
    pt: `Criar`,
    'pt-pt': `Criar`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{439}\u{442}\u{435}`,
    sm: `Fausia`,
    so: `Abuur`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{62A}\u{62E}\u{644}\u{6CC}\u{642}`,
    vi: `T\u{1EA1}o`,
    'zh-hans': `\u{521B}\u{4F5C}`,
    'zh-hant': `\u{5275}\u{4F5C}`,
    en: `Create`
};
const $b11db1b62d4a8f76$export$8a05c018a7add2a1 = {
    ar: `\u{625}\u{646}\u{634}\u{627}\u{621} \u{644}\u{648}\u{62D}\u{629} \u{62A}\u{62D}\u{643}\u{645}`,
    de: `Erstellen Sie ein Dashboard`,
    es: `Crea un panel de control`,
    fa: `\u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F}`,
    fil: `Email Address *`,
    fr: `Cr\xe9er un tableau de bord`,
    hi: `\u{90F}\u{915} \u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{92C}\u{928}\u{93E}\u{90F}\u{902}`,
    ht: `Kreye yon tablodb\xf2`,
    it: `Crea una dashboard`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{3092}\u{4F5C}\u{6210}\u{3059}\u{308B}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC} \u{C0DD}\u{C131}`,
    mww: `Tsim ib lub dashboard`,
    ps: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{689} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{626}`,
    pt: `Crie um painel`,
    'pt-pt': `Crie um painel de controlo`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{439}\u{442}\u{435} \u{434}\u{430}\u{448}\u{431}\u{43E}\u{440}\u{434}`,
    sm: `Fausia se dashboard`,
    so: `Samee dashboard`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}`,
    ur: `\u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA1}o b\u{1EA3}ng th\xf4ng tin`,
    'zh-hans': `\u{521B}\u{5EFA}\u{4E00}\u{4E2A}\u{4EEA}\u{8868}\u{76D8}`,
    'zh-hant': `\u{5EFA}\u{7ACB}\u{5100}\u{8868}\u{677F}`,
    en: `Create a dashboard`
};
const $b11db1b62d4a8f76$export$4b66abb8fbd01da6 = {
    ar: `\u{623}\u{646}\u{634}\u{626} \u{639}\u{645}\u{64A}\u{644}\u{627} / \u{645}\u{631}\u{64A}\u{636}\u{627} / \u{639}\u{636}\u{648}\u{627} \u{62C}\u{62F}\u{64A}\u{62F}\u{627}`,
    de: `Erstelle einen neuen Kunden / Patienten / Mitglied`,
    es: `Crea un nuevo cliente / paciente / miembro`,
    fa: `\u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6CC}\u{6A9} \u{645}\u{631}\u{627}\u{62C}\u{639} / \u{628}\u{6CC}\u{645}\u{627}\u{631} / \u{639}\u{636}\u{648} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Lumikha ng isang bagong kliyente / pasyente / miyembro`,
    fr: `Cr\xe9er un nouveau client / patient / membre`,
    hi: `\u{90F}\u{915} \u{928}\u{92F}\u{93E} \u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915}/\u{930}\u{94B}\u{917}\u{940}/\u{938}\u{926}\u{938}\u{94D}\u{92F} \u{92C}\u{928}\u{93E}\u{90F}\u{902}`,
    ht: `Kreye yon nouvo kliyan / pasyan / manm`,
    it: `Crea un nuovo cliente / paziente / membro`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}/\u{60A3}\u{8005}/\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3092}\u{4F5C}\u{6210}\u{3059}\u{308B}`,
    ko: `\u{C0C8}\u{B85C}\u{C6B4} \u{D074}\u{B77C}\u{C774}\u{C5B8}\u{D2B8} / \u{D658}\u{C790} / \u{D68C}\u{C6D0} \u{C0DD}\u{C131}\u{D558}\u{AE30}`,
    mww: `Tsim tus neeg siv khoom / tus neeg mob / tus tswv cuab tshiab`,
    ps: `\u{6CC}\u{648} \u{646}\u{648}\u{6CC} \u{645}\u{631}\u{627}\u{62C}\u{639} / \u{646}\u{627}\u{631}\u{648}\u{63A} / \u{63A}\u{693}\u{6CC} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{626}`,
    pt: `Crie um novo cliente / paciente / membro`,
    'pt-pt': `Crie um novo cliente / paciente / membro`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{439}\u{442}\u{435} \u{43D}\u{43E}\u{432}\u{43E}\u{433}\u{43E} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430} / \u{43F}\u{430}\u{446}\u{438}\u{435}\u{43D}\u{442}\u{430} / \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{430}`,
    sm: `Fausia se tagata fou / tagata ma'i / tagata`,
    so: `Abuur macmiil cusub / bukaan / xubin`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E25}\u{E39}\u{E01}\u{E04}\u{E49}\u{E32} / \u{E1C}\u{E39}\u{E49}\u{E1B}\u{E48}\u{E27}\u{E22} / \u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{6CC}\u{627} \u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679} / \u{645}\u{631}\u{6CC}\u{636} / \u{645}\u{645}\u{628}\u{631} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA1}o kh\xe1ch h\xe0ng / b\u{1EC7}nh nh\xe2n / th\xe0nh vi\xean m\u{1EDB}i`,
    'zh-hans': `\u{521B}\u{5EFA}\u{4E00}\u{4E2A}\u{65B0}\u{7684}\u{5BA2}\u{6237}/\u{60A3}\u{8005}/\u{4F1A}\u{5458}`,
    'zh-hant': `\u{5EFA}\u{7ACB}\u{65B0}\u{7684}\u{5BA2}\u{6236}/\u{75C5}\u{4EBA}/\u{6703}\u{54E1}`,
    en: `Create a new client / patient / member`
};
const $b11db1b62d4a8f76$export$d34624142074fad = {
    ar: `\u{623}\u{646}\u{634}\u{626} \u{62A}\u{648}\u{635}\u{64A}\u{629} \u{62C}\u{62F}\u{64A}\u{62F}\u{629}`,
    de: `Erstelle eine neue Empfehlung`,
    es: `Crea una nueva derivaci\xf3n`,
    fa: `\u{6CC}\u{6A9} \u{645}\u{639}\u{631}\u{641}\u{6CC} \u{646}\u{627}\u{645}\u{647} \u{62C}\u{62F}\u{6CC}\u{62F} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Lumikha ng Bagong Referral`,
    fr: `Cr\xe9ez une nouvelle recommandation`,
    hi: `\u{90F}\u{915} \u{928}\u{92F}\u{93E} \u{930}\u{947}\u{92B}\u{93C}\u{930}\u{932} \u{92C}\u{928}\u{93E}\u{90F}\u{902}`,
    ht: `Kreye yon nouvo referans`,
    it: `Crea una nuova segnalazione`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{7D39}\u{4ECB}\u{3092}\u{4F5C}\u{6210}\u{3059}\u{308B}`,
    ko: `\u{C0C8} \u{C758}\u{B8B0} \u{C0DD}\u{C131}`,
    mww: `Tsim ib qho kev xa mus tshiab`,
    ps: `\u{646}\u{648}\u{6D0} \u{645}\u{639}\u{631}\u{641}\u{6CC} \u{646}\u{627}\u{645}\u{647} \u{62C}\u{648}\u{693}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Crie uma nova indica\xe7\xe3o`,
    'pt-pt': `Crie uma nova refer\xeancia`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{439}\u{442}\u{435} \u{43D}\u{43E}\u{432}\u{43E}\u{435} \u{43D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Fausia se fa'asino fou`,
    so: `Samee tixraac cusub`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E49}\u{E32}\u{E07}\u{E2D}\u{E34}\u{E07}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{6CC}\u{627} \u{631}\u{6CC}\u{641}\u{631}\u{644} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA1}o gi\u{1EDB}i thi\u{1EC7}u m\u{1EDB}i`,
    'zh-hans': `\u{521B}\u{5EFA}\u{4E00}\u{4E2A}\u{65B0}\u{7684}\u{8F6C}\u{8BCA}`,
    'zh-hant': `\u{5EFA}\u{7ACB}\u{65B0}\u{7684}\u{8F49}\u{4ECB}`,
    en: `Create a new referral`
};
const $b11db1b62d4a8f76$export$3638f35b5780d612 = {
    ar: `\u{62A}\u{623}\u{633}\u{64A}\u{633}`,
    de: `Erstellt`,
    es: `Creaci\xf3n`,
    fa: `\u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{634}\u{62F}\u{647}`,
    fil: `Nilikha`,
    fr: `Cr\xe9ation`,
    hi: `\u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Te kreye`,
    it: `Creazione`,
    ja: `\u{5275}\u{8A2D}`,
    ko: `\u{CC3D}\u{C870}`,
    mww: `tsim`,
    ps: `\u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}`,
    pt: `Cria\xe7\xe3o`,
    'pt-pt': `Cria\xe7\xe3o`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Foafoaina`,
    so: `La abuuray`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{62A}\u{62E}\u{644}\u{6CC}\u{642} \u{634}\u{62F}\u{6C1}`,
    vi: `\u{110}\xe3 t\u{1EA1}o`,
    'zh-hans': `\u{521B}\u{4F5C}`,
    'zh-hant': `\u{5275}\u{4F5C}`,
    en: `Created`
};
const $b11db1b62d4a8f76$export$db187209f2aa905e = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{625}\u{646}\u{634}\u{627}\u{621}`,
    de: `Erstellungsdatum`,
    es: `Fecha de creaci\xf3n`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{627}\u{6CC}\u{62C}\u{627}\u{62F}`,
    fil: `Email Address *`,
    fr: `Date de cr\xe9ation`,
    hi: `\u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915} \u{92C}\u{928}\u{93E}\u{90F}\u{901}`,
    ht: `Kreye dat`,
    it: `Data di creazione`,
    ja: `\u{65E5}\u{4ED8}\u{4F5C}\u{6210}`,
    ko: `\u{B0A0}\u{C9DC} \u{C0DD}\u{C131}`,
    mww: `Tsim hnub`,
    ps: `\u{62F} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{62C}\u{648}\u{693}\u{648}\u{644}\u{648} \u{646}\u{6D0}\u{67C}\u{647}`,
    pt: `Data de cria\xe7\xe3o`,
    'pt-pt': `Data de cria\xe7\xe3o`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Fatu aso`,
    so: `Taariikhda abuurista`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `Ng\xe0y t\u{1EA1}o`,
    'zh-hans': `\u{521B}\u{5EFA}\u{65E5}\u{671F}`,
    'zh-hant': `\u{5EFA}\u{7ACB}\u{65E5}\u{671F}`,
    en: `Create date`
};
const $b11db1b62d4a8f76$export$f5d4437ca730d57d = {
    ar: (login)=>$b11db1b62d4a8f76$var$html`أنشأتها <span>${login}</span>`,
    de: (login)=>$b11db1b62d4a8f76$var$html`Erstellt von <span>${login}</span>`,
    es: (login)=>$b11db1b62d4a8f76$var$html`Creado por <span>${login}</span>`,
    fa: (login)=>$b11db1b62d4a8f76$var$html`خلق شده <span>${login}</span>`,
    fil: (login)=>$b11db1b62d4a8f76$var$html`Nilikha ni <span>${login}</span>`,
    fr: (login)=>$b11db1b62d4a8f76$var$html`Créé par <span>${login}</span>`,
    hi: (login)=>$b11db1b62d4a8f76$var$html`जेन द्वारा बनाया गया <span>${login}</span>`,
    ht: (login)=>$b11db1b62d4a8f76$var$html`Te kreye pa <span>${login}</span>`,
    it: (login)=>$b11db1b62d4a8f76$var$html`Creato da <span>${login}</span>`,
    ja: (login)=>$b11db1b62d4a8f76$var$html`ジェ<span>${login}作成</span>`,
    ko: (login)=>$b11db1b62d4a8f76$var$html`<span>${login}이 창작함</span>`,
    mww: (login)=>$b11db1b62d4a8f76$var$html`Tsim los ntawm <span>${login}</span>`,
    ps: (login)=>$b11db1b62d4a8f76$var$html`د جین لخوا جوړ شوی <span>${login}</span>`,
    pt: (login)=>$b11db1b62d4a8f76$var$html`Criado por <span>${login}</span>`,
    'pt-pt': (login)=>$b11db1b62d4a8f76$var$html`Criado por <span>${login}</span>`,
    ru: (login)=>$b11db1b62d4a8f76$var$html`Создано <span>${login}</span>`,
    sm: (login)=>$b11db1b62d4a8f76$var$html`Saunia e <span>${login}</span>`,
    so: (login)=>$b11db1b62d4a8f76$var$html`Waxaa abuuray <span>${login}</span>`,
    th: (login)=>$b11db1b62d4a8f76$var$html`สร้างโดย <span>${login}</span>`,
    ur: (login)=>$b11db1b62d4a8f76$var$html`<span>${login}</span>`,
    vi: (login)=>$b11db1b62d4a8f76$var$html`Tạo bởi <span>${login}</span>`,
    'zh-hans': (login)=>$b11db1b62d4a8f76$var$html`由<span>${login}创作</span>`,
    'zh-hant': (login)=>$b11db1b62d4a8f76$var$html`由<span>${login}創作</span>`,
    en: (login)=>$b11db1b62d4a8f76$var$html`Created by <span>${login}</span>`
};
const $b11db1b62d4a8f76$export$905a4a015f56885d = {
    ar: `\u{62E}\u{644}\u{642}\u{62A} \u{628}\u{648}\u{627}\u{633}\u{637}\u{62A}\u{643}`,
    de: `Von dir erschaffen`,
    es: `Creado por ti`,
    fa: `\u{62E}\u{644}\u{642} \u{634}\u{62F}\u{647} \u{62A}\u{648}\u{633}\u{637} \u{62A}\u{648}`,
    fil: `Nilikha Mo`,
    fr: `Cr\xe9\xe9 par toi`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Kreye pa ou`,
    it: `Creato da te`,
    ja: `\u{3042}\u{306A}\u{305F}\u{304C}\u{4F5C}\u{3063}\u{305F}`,
    ko: `\u{B124}\u{AC00} \u{B9CC}\u{B4E0} \u{AC70}\u{C57C}`,
    mww: `Tsim los ntawm koj`,
    ps: `\u{633}\u{62A}\u{627} \u{644}\u{62E}\u{648}\u{627} \u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}`,
    pt: `Criado por voc\xea`,
    'pt-pt': `Criado por ti`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{43E} \u{432}\u{430}\u{43C}\u{438}`,
    sm: `Faauta, sa ia lei faia ea mo oe se faataitaiga lelei?`,
    so: `Adiga ayaa abuuray`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E42}\u{E14}\u{E22}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{62A}\u{645}\u{6C1}\u{627}\u{631}\u{6D2} \u{628}\u{646}\u{627}\u{626}\u{6D2} \u{6C1}\u{648}\u{626}\u{6D2}`,
    vi: `Do b\u{1EA1}n t\u{1EA1}o ra`,
    'zh-hans': `\u{7531}\u{4F60}\u{521B}\u{9020}`,
    'zh-hant': `\u{7531}\u{4F60}\u{5275}\u{9020}`,
    en: `Created by you`
};
const $b11db1b62d4a8f76$export$40ea98e2465fefe1 = {
    ar: `\u{62A}\u{645} \u{625}\u{646}\u{634}\u{627}\u{624}\u{647}\u{627} \u{645}\u{646} \u{642}\u{628}\u{644} \u{645}\u{646}\u{638}\u{645}\u{62A}\u{643}`,
    de: `Erstellt von Ihrer Organisation`,
    es: `Creado por tu organizaci\xf3n`,
    fa: `\u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{634}\u{62F}\u{647} \u{62A}\u{648}\u{633}\u{637} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{634}\u{645}\u{627}`,
    fil: `Nilikha ng Iyong Organisasyon`,
    fr: `Cr\xe9\xe9 par votre organisation`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Kreye pa \xf2ganizasyon ou an`,
    it: `Creato dalla tua organizzazione`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{7D44}\u{7E54}\u{306B}\u{3088}\u{3063}\u{3066}\u{4F5C}\u{6210}\u{3055}\u{308C}\u{305F}`,
    ko: `\u{ADC0}\u{D558}\u{C758} \u{C870}\u{C9C1}\u{C5D0}\u{C11C} \u{C81C}\u{C791}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsim los ntawm koj lub koom haum`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{644}\u{62E}\u{648}\u{627} \u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}`,
    pt: `Criado pela sua organiza\xe7\xe3o`,
    'pt-pt': `Criado pela sua organiza\xe7\xe3o`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{43E} \u{432}\u{430}\u{448}\u{435}\u{439} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{435}\u{439}`,
    sm: `Fausiaina e lau fa'alapotopotoga`,
    so: `Waxaa abuuray ururkaaga`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E42}\u{E14}\u{E22}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{646}\u{6D2} \u{62A}\u{62E}\u{644}\u{6CC}\u{642} \u{6A9}\u{6CC}\u{627}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c t\u{1EA1}o b\u{1EDF}i t\u{1ED5} ch\u{1EE9}c c\u{1EE7}a b\u{1EA1}n`,
    'zh-hans': `\u{7531}\u{8D35}\u{7EC4}\u{7EC7}\u{521B}\u{5EFA}`,
    'zh-hant': `\u{7531}\u{4F60}\u{5011}\u{7D44}\u{7E54}\u{5275}\u{5EFA}`,
    en: `Created by your organization`
};
const $b11db1b62d4a8f76$export$9244b719ec504ae6 = {
    ar: (date)=>$b11db1b62d4a8f76$var$html`تم إنشاؤه <span>${date}</span>`,
    de: (date)=>$b11db1b62d4a8f76$var$html`Vor <span>${date} erstellt</span>`,
    es: (date)=>$b11db1b62d4a8f76$var$html`Creado <span>${date}</span>`,
    fa: (date)=>$b11db1b62d4a8f76$var$html`<span>${date}</span>`,
    fil: (date)=>$b11db1b62d4a8f76$var$html`Nilikha <span>${date}</span>`,
    fr: (date)=>$b11db1b62d4a8f76$var$html`Créé <span>${date}</span>`,
    hi: (date)=>$b11db1b62d4a8f76$var$html`3 <span>${date} गया</span>`,
    ht: (date)=>$b11db1b62d4a8f76$var$html`Created <span>${date}</span>`,
    it: (date)=>$b11db1b62d4a8f76$var$html`Creato <span>${date}</span>`,
    ja: (date)=>$b11db1b62d4a8f76$var$html`<span>${date}作成</span>`,
    ko: (date)=>$b11db1b62d4a8f76$var$html`<span>${date} 작성됨</span>`,
    mww: (date)=>$b11db1b62d4a8f76$var$html`Tsim <span>${date}</span>`,
    ps: (date)=>$b11db1b62d4a8f76$var$html`<span>${date} جوړ شوی</span>`,
    pt: (date)=>$b11db1b62d4a8f76$var$html`Criado <span>${date}</span>`,
    'pt-pt': (date)=>$b11db1b62d4a8f76$var$html`Criado <span>${date}</span>`,
    ru: (date)=>$b11db1b62d4a8f76$var$html`<span>${date}</span>`,
    sm: (date)=>$b11db1b62d4a8f76$var$html`Foafoaina <span>${date}</span>`,
    so: (date)=>$b11db1b62d4a8f76$var$html`Waxaa la abuuray <span>${date}</span>`,
    th: (date)=>$b11db1b62d4a8f76$var$html`สร้างเมื่อ <span>${date}</span>`,
    ur: (date)=>$b11db1b62d4a8f76$var$html`<span>${date} بنایا گیا</span>`,
    vi: (date)=>$b11db1b62d4a8f76$var$html`Đã tạo <span>${date}</span>`,
    'zh-hans': (date)=>$b11db1b62d4a8f76$var$html`创建 <span>${date}</span>`,
    'zh-hant': (date)=>$b11db1b62d4a8f76$var$html`三<span>${date}建立</span>`,
    en: (date)=>$b11db1b62d4a8f76$var$html`Created <span>${date}</span>`
};
const $b11db1b62d4a8f76$export$d1f064ee71265e0c = {
    ar: `\u{623}\u{646}\u{634}\u{623}\u{62A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Ich habe diese Aktivit\xe4t erstellt.`,
    es: `Cre\xe9 esta actividad.`,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{631}\u{62F}\u{645}.`,
    fil: `Nilikha ang aktibidad na ito.`,
    fr: `J\u{2019}ai cr\xe9\xe9 cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{94B} \u{92C}\u{928}\u{93E}\u{92F}\u{93E}\u{964}`,
    ht: `Te kreye aktivite sa a.`,
    it: `Ho creato questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{4F5C}\u{308A}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C744} \u{B9CC}\u{B4E4}\u{C5C8}\u{C5B4}\u{C694}.`,
    mww: `Tsim qhov kev ua no.`,
    ps: `\u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{645}\u{6D0} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{6CC}.`,
    pt: `Criei essa atividade.`,
    'pt-pt': `Criei esta atividade.`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{43B} \u{44D}\u{442}\u{43E} \u{437}\u{430}\u{43D}\u{44F}\u{442}\u{438}\u{435}.`,
    sm: `Fausiaina lenei gaoioiga.`,
    so: `Wuxuu abuuray hawshan.`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{645}\u{6CC}\u{6BA} \u{646}\u{6D2} \u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{6CC}\u{6D4}`,
    vi: `\u{110}\xe3 t\u{1EA1}o ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{521B}\u{5EFA}\u{4E86}\u{8FD9}\u{4E2A}\u{6D3B}\u{52A8}\u{3002}`,
    'zh-hant': `\u{6211}\u{5275}\u{5EFA}\u{4E86}\u{9019}\u{500B}\u{6D3B}\u{52D5}\u{3002}`,
    en: `Created this activity.`
};
const $b11db1b62d4a8f76$export$7435a31034ac26af = {
    ar: `\u{625}\u{646}\u{634}\u{627}\u{621} \u{62C}\u{62F}\u{648}\u{644} \u{632}\u{645}\u{646}\u{64A}`,
    de: `Stundenzettel erstellen`,
    es: `Crear hoja de horas`,
    fa: `\u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646} \u{628}\u{646}\u{62F}\u{6CC}`,
    fil: `Lumikha ng timesheet`,
    fr: `Cr\xe9er une feuille de temps`,
    hi: `\u{938}\u{92E}\u{92F} \u{92A}\u{924}\u{94D}\u{930}\u{915} \u{92C}\u{928}\u{93E}\u{90F}\u{901}`,
    ht: `Kreye Timesheet`,
    it: `Crea il foglio orario`,
    ja: `\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{306E}\u{4F5C}\u{6210}`,
    ko: `\u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C} \u{C791}\u{C131}`,
    mww: `Tsim daim ntawv teev sijhawm`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647} \u{62C}\u{648}\u{693}\u{648}\u{644}`,
    pt: `Criar folha de ponto`,
    'pt-pt': `Criar folha de horas`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}`,
    sm: `Fatu le pepa o taimi`,
    so: `Abuur jadwalka waqtiga`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}`,
    ur: `\u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA1}o b\u{1EA3}ng ch\u{1EA5}m c\xf4ng`,
    'zh-hans': `\u{5236}\u{4F5C}\u{5DE5}\u{65F6}\u{8868}`,
    'zh-hant': `\u{5EFA}\u{7ACB}\u{5DE5}\u{6642}\u{8868}`,
    en: `Create timesheet`
};
const $b11db1b62d4a8f76$export$1208bb24a94b0c6b = {
    ar: `\u{623}\u{646}\u{634}\u{626} \u{62D}\u{633}\u{627}\u{628}\u{643}`,
    de: `Erstellen Sie Ihr Konto`,
    es: `Crea tu cuenta`,
    fa: `\u{62D}\u{633}\u{627}\u{628} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{6CC} \u{62E}\u{648}\u{62F} \u{631}\u{627} \u{628}\u{633}\u{627}\u{632}\u{6CC}\u{62F}`,
    fil: `Email:`,
    fr: `Cr\xe9ez votre compte`,
    hi: `\u{905}\u{92A}\u{928}\u{93E} \u{916}\u{93E}\u{924}\u{93E} \u{92C}\u{928}\u{93E}\u{90F}\u{902}`,
    ht: `Kreye kont ou`,
    it: `Crea il tuo account`,
    ja: `\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{4F5C}\u{6210}`,
    ko: `\u{ACC4}\u{C815} \u{C0DD}\u{C131}`,
    mww: `Tsim koj tus account`,
    ps: `\u{62E}\u{67E}\u{644} \u{62D}\u{633}\u{627}\u{628} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{626}`,
    pt: `Crie sua conta`,
    'pt-pt': `Crie a sua conta`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{439}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{439} \u{430}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442}`,
    sm: `Fausia lau teuga tupe`,
    so: `Abuur akoonkaaga`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{627}\u{67E}\u{646}\u{627} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA1}o t\xe0i kho\u{1EA3}n c\u{1EE7}a b\u{1EA1}n`,
    'zh-hans': `\u{521B}\u{5EFA}\u{60A8}\u{7684}\u{8D26}\u{6237}`,
    'zh-hant': `\u{5EFA}\u{7ACB}\u{60A8}\u{7684}\u{5E33}\u{865F}`,
    en: `Create your account`
};
const $b11db1b62d4a8f76$export$d66da69c1b21f144 = {
    ar: `\u{627}\u{644}\u{645}\u{628}\u{62F}\u{639}`,
    de: `Sch\xf6pfer`,
    es: `Creador`,
    fa: `\u{62E}\u{627}\u{644}\u{642}`,
    fil: `Lumikha`,
    fr: `Cr\xe9ateur`,
    hi: `\u{938}\u{943}\u{91C}\u{928}\u{915}\u{930}\u{94D}\u{924}\u{93E}`,
    ht: `kreyat\xe8`,
    it: `Creatore`,
    ja: `\u{30AF}\u{30EA}\u{30A8}\u{30A4}\u{30BF}\u{30FC}`,
    ko: `\u{CC3D}\u{C870}\u{C790}`,
    mww: `Tus tsim`,
    ps: `\u{62E}\u{627}\u{644}\u{642}`,
    pt: `Criador`,
    'pt-pt': `Criador`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44C}`,
    sm: `Foafoa`,
    so: `Abuuraha`,
    th: `\u{E04}\u{E23}\u{E35}\u{E40}\u{E2D}\u{E40}\u{E15}\u{E2D}\u{E23}\u{E4C}`,
    ur: `\u{62A}\u{62E}\u{644}\u{6CC}\u{642} \u{6A9}\u{627}\u{631}`,
    vi: `Ng\u{1B0}\u{1EDD}i s\xe1ng t\u{1EA1}o`,
    'zh-hans': `\u{521B}\u{4F5C}\u{8005}`,
    'zh-hant': `\u{5275}\u{4F5C}\u{8005}`,
    en: `Creator`
};
const $b11db1b62d4a8f76$export$2faa540e64d0b3a6 = {
    ar: `\u{627}\u{644}\u{631}\u{635}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{631}\u{627}\u{643}\u{645}\u{64A}`,
    de: `Kumulativer Saldo`,
    es: `Saldo acumulativo`,
    fa: `\u{645}\u{627}\u{646}\u{62F}\u{647} \u{62A}\u{62C}\u{645}\u{639}\u{6CC}`,
    fil: `Pinagsama-samang balanse`,
    fr: `Solde cumulatif`,
    hi: `\u{938}\u{902}\u{91A}\u{92F}\u{940} \u{936}\u{947}\u{937}`,
    ht: `Balans kimilatif`,
    it: `Saldo cumulativo`,
    ja: `\u{7D2F}\u{7A4D}\u{6B8B}\u{9AD8}`,
    ko: `\u{B204}\u{C801} \u{C794}\u{C561}`,
    mww: `Kev sib npaug sib npaug`,
    ps: `\u{67C}\u{648}\u{644}\u{6CC}\u{632} \u{62A}\u{648}\u{627}\u{632}\u{646}`,
    pt: `Saldo acumulado`,
    'pt-pt': `Saldo cumulativo`,
    ru: `\u{41A}\u{443}\u{43C}\u{443}\u{43B}\u{44F}\u{442}\u{438}\u{432}\u{43D}\u{44B}\u{439} \u{431}\u{430}\u{43B}\u{430}\u{43D}\u{441}`,
    sm: `Paleni faaputuputu`,
    so: `Isku-dheelitirka guud`,
    th: `\u{E22}\u{E2D}\u{E14}\u{E04}\u{E07}\u{E40}\u{E2B}\u{E25}\u{E37}\u{E2D}\u{E2A}\u{E30}\u{E2A}\u{E21}`,
    ur: `\u{645}\u{62C}\u{645}\u{648}\u{639}\u{6CC} \u{628}\u{6CC}\u{644}\u{646}\u{633}`,
    vi: `S\u{1ED1} d\u{1B0} t\xedch l\u{169}y`,
    'zh-hans': `\u{7D2F}\u{79EF}\u{4F59}\u{989D}`,
    'zh-hant': `\u{7D2F}\u{7A4D}\u{9918}\u{984D}`,
    en: `Cumulative balance`
};
const $b11db1b62d4a8f76$export$1172bcae68ec2278 = {
    ar: (cumulus)=>`${cumulus} \u{628}\u{648}\u{627}\u{628}\u{629} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{64A}\u{646}`,
    de: (cumulus)=>`${cumulus} Teilnehmerportal`,
    es: (cumulus)=>`${cumulus} Portal de Participantes`,
    fa: (cumulus)=>`${cumulus} \u{67E}\u{648}\u{631}\u{62A}\u{627}\u{644} \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{6AF}\u{627}\u{646}`,
    fil: (cumulus)=>`${cumulus} Portal ng Kalahok`,
    fr: (cumulus)=>`${cumulus} Portail des participants`,
    hi: (cumulus)=>`${cumulus} \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{940} \u{92A}\u{94B}\u{930}\u{94D}\u{91F}\u{932}`,
    ht: (cumulus)=>`${cumulus} Patisipan Portal`,
    it: (cumulus)=>`${cumulus} Portale Partecipanti`,
    ja: (cumulus)=>`${cumulus} \u{53C2}\u{52A0}\u{8005}\u{30DD}\u{30FC}\u{30BF}\u{30EB}`,
    ko: (cumulus)=>`${cumulus} \u{CC38}\u{C5EC}\u{C790} \u{D3EC}\u{D138}`,
    mww: (cumulus)=>`${cumulus} Cov Neeg Koom Portal`,
    ps: (cumulus)=>`${cumulus} \u{62F} \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644} \u{67E}\u{648}\u{631}\u{67C}\u{644}`,
    pt: (cumulus)=>`${cumulus} Portal de Participantes`,
    'pt-pt': (cumulus)=>`${cumulus} Portal de Participantes`,
    ru: (cumulus)=>`${cumulus} \u{41F}\u{43E}\u{440}\u{442}\u{430}\u{43B} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{43E}\u{432}`,
    sm: (cumulus)=>`${cumulus} Faitotoa a le Tagata Auai`,
    so: (cumulus)=>`${cumulus} Albaabka Ka Qaybgalayaasha`,
    th: (cumulus)=>`${cumulus} \u{E1E}\u{E2D}\u{E23}\u{E4C}\u{E17}\u{E31}\u{E25}\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}`,
    ur: (cumulus)=>`${cumulus} \u{634}\u{631}\u{6A9}\u{627}\u{621} \u{6A9}\u{627} \u{67E}\u{648}\u{631}\u{679}\u{644}`,
    vi: (cumulus)=>`${cumulus} C\u{1ED5}ng th\xf4ng tin ng\u{1B0}\u{1EDD}i tham gia`,
    'zh-hans': (cumulus)=>`${cumulus} \u{53C2}\u{4E0E}\u{8005}\u{95E8}\u{6237}`,
    'zh-hant': (cumulus)=>`${cumulus} \u{53C3}\u{8207}\u{8005}\u{5165}\u{53E3}\u{7DB2}\u{7AD9}`,
    en: (cumulus)=>`${cumulus} Participant Portal`
};
const $b11db1b62d4a8f76$export$3b2da883f08c50ff = {
    ar: (activityTitle, org)=>`\u{623}\u{646}\u{634}\u{637}\u{629} ${activityTitle} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}\u{629} \u{648}\u{627}\u{644}\u{642}\u{627}\u{62F}\u{645}\u{629} \u{645}\u{646} ${org}\u{60C} \u{645}\u{631}\u{62A}\u{628}\u{629} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{645}\u{633}\u{627}\u{641}\u{629} \u{645}\u{646} \u{645}\u{648}\u{642}\u{639}\u{643}.`,
    de: (activityTitle, org)=>`Aktuelle und kommende ${activityTitle} von ${org}, sortiert nach Entfernung zu Ihrem Standort.`,
    es: (activityTitle, org)=>`Actividades actuales y pr\xf3ximas ${activityTitle} de ${org}, ordenadas por distancia desde tu ubicaci\xf3n.`,
    fa: (activityTitle, org)=>`\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} ${activityTitle} \u{62A}\u{648}\u{633}\u{637} ${org}\u{60C} \u{645}\u{631}\u{62A}\u{628} \u{634}\u{62F}\u{647} \u{628}\u{631} \u{627}\u{633}\u{627}\u{633} \u{641}\u{627}\u{635}\u{644}\u{647} \u{627}\u{632} \u{645}\u{62D}\u{644} \u{633}\u{6A9}\u{648}\u{646}\u{62A}.`,
    fil: (activityTitle, org)=>`Kasalukuyan at paparating na mga aktibidad sa ${activityTitle} ng ${org}, na pinagsunod-sunod ayon sa distansya mula sa iyong lokasyon.`,
    fr: (activityTitle, org)=>`Activit\xe9s actuelles et \xe0 venir de ${activityTitle} de ${org}, class\xe9es par distance depuis votre localisation.`,
    hi: (activityTitle, org)=>`${org} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{935}\u{930}\u{94D}\u{924}\u{92E}\u{93E}\u{928} \u{914}\u{930} \u{906}\u{917}\u{93E}\u{92E}\u{940} ${activityTitle} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901}, \u{906}\u{92A}\u{915}\u{947} \u{938}\u{94D}\u{925}\u{93E}\u{928} \u{938}\u{947} \u{926}\u{942}\u{930}\u{940} \u{915}\u{947} \u{906}\u{927}\u{93E}\u{930} \u{92A}\u{930} \u{915}\u{94D}\u{930}\u{92E}\u{92C}\u{926}\u{94D}\u{927} \u{915}\u{940} \u{91C}\u{93E}\u{924}\u{940} \u{939}\u{948}\u{902}\u{964}`,
    ht: (activityTitle, org)=>`Aktivite klinik ${activityTitle} akty\xe8l ak k ap vini yo pa ${org}, triye pa distans soti nan kote w ye a.`,
    it: (activityTitle, org)=>`Attivit\xe0 attuali e future ${activityTitle} di ${org}, ordinate per distanza dalla tua sede.`,
    ja: (activityTitle, org)=>`\u{30EA}${org}\u{306B}\u{3088}\u{308B}\u{73FE}\u{5728}\u{304A}\u{3088}\u{3073}\u{4ECA}\u{5F8C}\u{306E}${activityTitle}\u{306E}\u{6D3B}\u{52D5}\u{3092}\u{3001}\u{3042}\u{306A}\u{305F}\u{306E}\u{6240}\u{5728}\u{5730}\u{304B}\u{3089}\u{306E}\u{8DDD}\u{96E2}\u{9806}\u{306B}\u{6574}\u{7406}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (activityTitle, org)=>`${org}\u{C758} \u{D604}\u{C7AC} \u{BC0F} \u{C608}\u{C815}\u{B41C} ${activityTitle}\u{C740} \u{ADC0}\u{D558}\u{C758} \u{C704}\u{CE58}\u{C640}\u{C758} \u{AC70}\u{B9AC}\u{BCC4}\u{B85C} \u{C815}\u{B82C}\u{B418}\u{C5B4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (activityTitle, org)=>`Cov kev ua ub no tam sim no thiab tom ntej no ${activityTitle} ${org}, txheeb raws qhov deb ntawm koj qhov chaw.`,
    ps: (activityTitle, org)=>`\u{62F} ${org} \u{644}\u{62E}\u{648}\u{627} \u{62F} ${activityTitle} \u{627}\u{648}\u{633}\u{646}\u{6CC} \u{627}\u{648} \u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}\u{60C} \u{686}\u{6D0} \u{633}\u{62A}\u{627}\u{633}\u{648} \u{644}\u{647} \u{681}\u{627}\u{6CC}\u{647} \u{62F} \u{648}\u{627}\u{67C}\u{646} \u{644}\u{647} \u{645}\u{62E}\u{6D0} \u{62A}\u{631}\u{62A}\u{6CC}\u{628} \u{634}\u{648}\u{6CC}.`,
    pt: (activityTitle, org)=>`Atividades atuais e futuras ${activityTitle} da ${org}, organizadas por dist\xe2ncia da sua localiza\xe7\xe3o.`,
    'pt-pt': (activityTitle, org)=>`Atividades atuais e futuras ${activityTitle} da ${org}, ordenadas pela dist\xe2ncia \xe0 sua localiza\xe7\xe3o.`,
    ru: (activityTitle, org)=>`\u{422}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{435} \u{438} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{438}\u{435} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F} ${activityTitle} \u{43E}\u{442} ${org}, \u{43E}\u{442}\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{43F}\u{43E} \u{440}\u{430}\u{441}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{44E} \u{43E}\u{442} \u{432}\u{430}\u{448}\u{435}\u{433}\u{43E} \u{43C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}.`,
    sm: (activityTitle, org)=>`O lo'o i ai nei ma le lumana'i o gaioiga a le ${activityTitle} e ${org}, fa'avasegaina i le mamao mai lou nofoaga.`,
    so: (activityTitle, org)=>`Hawlaha hadda iyo kuwa soo socda ${activityTitle} ee ${org}, oo loo kala saaray masaafada ka fog goobtaada.`,
    th: (activityTitle, org)=>`\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21} ${activityTitle} \u{E43}\u{E19}\u{E1B}\u{E31}\u{E08}\u{E08}\u{E38}\u{E1A}\u{E31}\u{E19}\u{E41}\u{E25}\u{E30}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E08}\u{E30}\u{E40}\u{E01}\u{E34}\u{E14}\u{E02}\u{E36}\u{E49}\u{E19}\u{E42}\u{E14}\u{E22} ${org} \u{E40}\u{E23}\u{E35}\u{E22}\u{E07}\u{E15}\u{E32}\u{E21}\u{E23}\u{E30}\u{E22}\u{E30}\u{E17}\u{E32}\u{E07}\u{E08}\u{E32}\u{E01}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: (activityTitle, org)=>`${org} \u{6A9}\u{6CC} \u{645}\u{648}\u{62C}\u{648}\u{62F}\u{6C1} \u{627}\u{648}\u{631} \u{622}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6CC} ${activityTitle} \u{6A9}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}\u{60C} \u{62C}\u{648} \u{622}\u{67E} \u{6A9}\u{6D2} \u{645}\u{642}\u{627}\u{645} \u{633}\u{6D2} \u{641}\u{627}\u{635}\u{644}\u{6D2} \u{6A9}\u{6D2} \u{62D}\u{633}\u{627}\u{628} \u{633}\u{6D2} \u{62A}\u{631}\u{62A}\u{6CC}\u{628} \u{62F}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (activityTitle, org)=>`C\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng ${activityTitle} hi\u{1EC7}n t\u{1EA1}i v\xe0 s\u{1EAF}p t\u{1EDB}i theo ${org}, \u{111}\u{1B0}\u{1EE3}c s\u{1EAF}p x\u{1EBF}p theo kho\u{1EA3}ng c\xe1ch t\u{1EEB} v\u{1ECB} tr\xed c\u{1EE7}a b\u{1EA1}n.`,
    'zh-hans': (activityTitle, org)=>`${org}\u{63D0}\u{4F9B}\u{7684}\u{5F53}\u{524D}\u{53CA}\u{5373}\u{5C06}\u{5F00}\u{5C55}${activityTitle}\u{6D3B}\u{52A8}\u{FF0C}\u{6309}\u{60A8}\u{6240}\u{5728}\u{5730}\u{7684}\u{8DDD}\u{79BB}\u{6392}\u{5E8F}\u{3002}`,
    'zh-hant': (activityTitle, org)=>`${org}\u{76EE}\u{524D}\u{53CA}\u{5373}\u{5C07}\u{8209}\u{8FA6}\u{7684}${activityTitle}\u{6D3B}\u{52D5}\u{FF0C}\u{4F9D}\u{7167}\u{60A8}\u{6240}\u{5728}\u{5730}\u{5340}\u{7684}\u{8DDD}\u{96E2}\u{6392}\u{5E8F}\u{3002}`,
    en: (activityTitle, org)=>`Current and upcoming ${activityTitle} activities by ${org}, sorted by distance from your location.`
};
const $b11db1b62d4a8f76$export$5178e1572c9e18b9 = {
    ar: (name)=>$b11db1b62d4a8f76$var$html`الاختيار الحالي: <strong>${name}</strong>`,
    de: (name)=>$b11db1b62d4a8f76$var$html`Aktuelle Auswahl: <strong>${name}</strong>`,
    es: (name)=>$b11db1b62d4a8f76$var$html`Selección actual: <strong>${name}</strong>`,
    fa: (name)=>$b11db1b62d4a8f76$var$html`انتخاب فعلی: <strong>${name}</strong>`,
    fil: (name)=>$b11db1b62d4a8f76$var$html`Kasalukuyang seleksyon: <strong>${name}</strong>`,
    fr: (name)=>$b11db1b62d4a8f76$var$html`Sélection actuelle : <strong>${name}</strong>`,
    hi: (name)=>$b11db1b62d4a8f76$var$html`वर्तमान चयन: <strong>${name}</strong>`,
    ht: (name)=>$b11db1b62d4a8f76$var$html`Seleksyon aktyèl: <strong>${name}</strong>`,
    it: (name)=>$b11db1b62d4a8f76$var$html`Selezione attuale: <strong>${name}</strong>`,
    ja: (name)=>$b11db1b62d4a8f76$var$html`現在の選考: <strong>${name}</strong>`,
    ko: (name)=>$b11db1b62d4a8f76$var$html`현재 선발: <strong>${name}</strong>`,
    mww: (name)=>$b11db1b62d4a8f76$var$html`Kev xaiv tam sim no: <strong>${name}</strong>`,
    ps: (name)=>$b11db1b62d4a8f76$var$html`اوسنی انتخاب: <strong>${name}</strong>`,
    pt: (name)=>$b11db1b62d4a8f76$var$html`Seleção atual: <strong>${name}</strong>`,
    'pt-pt': (name)=>$b11db1b62d4a8f76$var$html`Seleção atual: <strong>${name}</strong>`,
    ru: (name)=>$b11db1b62d4a8f76$var$html`Текущий отбор: <strong>${name}</strong>`,
    sm: (name)=>$b11db1b62d4a8f76$var$html`Filifiliga o lo'o i ai nei: <strong>${name}</strong>`,
    so: (name)=>$b11db1b62d4a8f76$var$html`Xulashada hadda: <strong>${name}</strong>`,
    th: (name)=>$b11db1b62d4a8f76$var$html`การเลือกปัจจุบัน: <strong>${name}</strong>`,
    ur: (name)=>$b11db1b62d4a8f76$var$html`موجودہ انتخاب: <strong>${name}</strong>`,
    vi: (name)=>$b11db1b62d4a8f76$var$html`Lựa chọn hiện tại: <strong>${name}</strong>`,
    'zh-hans': (name)=>$b11db1b62d4a8f76$var$html`当前选择： <strong>${name}</strong>`,
    'zh-hant': (name)=>$b11db1b62d4a8f76$var$html`目前選擇： <strong>${name}</strong>`,
    en: (name)=>$b11db1b62d4a8f76$var$html`Current selection: <strong>${name}</strong>`
};
const $b11db1b62d4a8f76$export$bb7fcedaeeca6850 = {
    ar: `\u{641}\u{62A}\u{631}\u{629} \u{627}\u{644}\u{62F}\u{641}\u{639} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}\u{629}`,
    de: `Aktueller Abrechnungszeitraum`,
    es: `Periodo de pago actual`,
    fa: `\u{62F}\u{648}\u{631}\u{647} \u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A} \u{641}\u{639}\u{644}\u{6CC}`,
    fil: `Kasalukuyang panahon ng suweldo`,
    fr: `P\xe9riode de paie actuelle`,
    hi: `\u{935}\u{930}\u{94D}\u{924}\u{92E}\u{93E}\u{928} \u{935}\u{947}\u{924}\u{928} \u{905}\u{935}\u{927}\u{93F}`,
    ht: `Pery\xf2d peman akty\xe8l la`,
    it: `Periodo di paga attuale`,
    ja: `\u{73FE}\u{5728}\u{306E}\u{7D66}\u{4E0E}\u{671F}\u{9593}`,
    ko: `\u{D604}\u{C7AC} \u{AE09}\u{C5EC} \u{AE30}\u{AC04}`,
    mww: `Lub sijhawm them nyiaj tam sim no`,
    ps: `\u{627}\u{648}\u{633}\u{646}\u{6CC} \u{62F} \u{645}\u{639}\u{627}\u{634} \u{645}\u{648}\u{62F}\u{647}`,
    pt: `Per\xedodo atual de pagamento`,
    'pt-pt': `Per\xedodo de pagamento atual`,
    ru: `\u{422}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434} \u{43E}\u{43F}\u{43B}\u{430}\u{442}\u{44B}`,
    sm: `Vaitau o totogi o loo i ai nei`,
    so: `Muddada mushaarka hadda`,
    th: `\u{E23}\u{E2D}\u{E1A}\u{E23}\u{E30}\u{E22}\u{E30}\u{E40}\u{E27}\u{E25}\u{E32}\u{E01}\u{E32}\u{E23}\u{E08}\u{E48}\u{E32}\u{E22}\u{E40}\u{E07}\u{E34}\u{E19}\u{E1B}\u{E31}\u{E08}\u{E08}\u{E38}\u{E1A}\u{E31}\u{E19}`,
    ur: `\u{645}\u{648}\u{62C}\u{648}\u{62F}\u{6C1} \u{62A}\u{646}\u{62E}\u{648}\u{627}\u{6C1} \u{6A9}\u{6CC} \u{645}\u{62F}\u{62A}`,
    vi: `K\u{1EF3} tr\u{1EA3} l\u{1B0}\u{1A1}ng hi\u{1EC7}n t\u{1EA1}i`,
    'zh-hans': `\u{5F53}\u{524D}\u{85AA}\u{916C}\u{5468}\u{671F}`,
    'zh-hant': `\u{76EE}\u{524D}\u{85AA}\u{8CC7}\u{671F}\u{9593}`,
    en: `Current pay period`
};
const $b11db1b62d4a8f76$export$aef7b42ff8a126b3 = {
    ar: `\u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{627}\u{644}\u{645}\u{62E}\u{635}\u{635}`,
    de: `Benutzerdefinierte E-Mail-Adresse`,
    es: `Direcci\xf3n de correo electr\xf3nico personalizada`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{633}\u{641}\u{627}\u{631}\u{634}\u{6CC}`,
    fil: `Pasadyang email address`,
    fr: `Adresse e-mail personnalis\xe9e`,
    hi: `\u{915}\u{938}\u{94D}\u{91F}\u{92E} \u{908}\u{92E}\u{947}\u{932} \u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s imel koutim`,
    it: `Indirizzo email personalizzato`,
    ja: `\u{30AB}\u{30B9}\u{30BF}\u{30E0}\u{30E1}\u{30FC}\u{30EB}\u{30A2}\u{30C9}\u{30EC}\u{30B9}`,
    ko: `\u{B9DE}\u{CDA4} \u{C774}\u{BA54}\u{C77C} \u{C8FC}\u{C18C}`,
    mww: `Kev cai email chaw nyob`,
    ps: `\u{62F}\u{648}\u{62F}\u{6CC}\u{632} \u{628}\u{631}\u{6D0}\u{69A}\u{646}\u{627}\u{644}\u{6CC}\u{6A9} \u{67E}\u{62A}\u{647}`,
    pt: `Endere\xe7o de e-mail personalizado`,
    'pt-pt': `Endere\xe7o de email personalizado`,
    ru: `\u{41F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{441}\u{43A}\u{438}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{447}\u{442}\u{44B}`,
    sm: `Tuatusi imeli masani`,
    so: `Cinwaanka email-ka gaarka ah`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E40}\u{E2D}\u{E07}`,
    ur: `\u{6A9}\u{633}\u{679}\u{645} \u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} email t\xf9y ch\u{1EC9}nh`,
    'zh-hans': `\u{81EA}\u{5B9A}\u{4E49}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{5730}\u{5740}`,
    'zh-hant': `\u{81EA}\u{8A02}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{5730}\u{5740}`,
    en: `Custom email address`
};
const $b11db1b62d4a8f76$export$1da1e429a8e76bf5 = {
    ar: `\u{631}\u{642}\u{645} \u{647}\u{627}\u{62A}\u{641} \u{645}\u{62E}\u{635}\u{635}`,
    de: `Individuelle Telefonnummer`,
    es: `N\xfamero de tel\xe9fono personalizado`,
    fa: `\u{634}\u{645}\u{627}\u{631}\u{647} \u{62A}\u{644}\u{641}\u{646} \u{633}\u{641}\u{627}\u{631}\u{634}\u{6CC}`,
    fil: `Pasadyang numero ng telepono`,
    fr: `Num\xe9ro de t\xe9l\xe9phone personnalis\xe9`,
    hi: `\u{915}\u{938}\u{94D}\u{91F}\u{92E} \u{92B}\u{93C}\u{94B}\u{928} \u{928}\u{902}\u{92C}\u{930}`,
    ht: `Nimewo telef\xf2n koutim`,
    it: `Numero di telefono personalizzato`,
    ja: `\u{30AB}\u{30B9}\u{30BF}\u{30E0}\u{96FB}\u{8A71}\u{756A}\u{53F7}`,
    ko: `\u{B9DE}\u{CDA4} \u{C804}\u{D654}\u{BC88}\u{D638}`,
    mww: `Kev cai xov tooj`,
    ps: `\u{62F}\u{648}\u{62F}\u{6CC}\u{632} \u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646} \u{634}\u{645}\u{6D0}\u{631}\u{647}`,
    pt: `N\xfamero de telefone personalizado`,
    'pt-pt': `N\xfamero de telefone personalizado`,
    ru: `\u{418}\u{43D}\u{434}\u{438}\u{432}\u{438}\u{434}\u{443}\u{430}\u{43B}\u{44C}\u{43D}\u{44B}\u{439} \u{43D}\u{43E}\u{43C}\u{435}\u{440} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{430}`,
    sm: `Numera telefoni masani`,
    so: `Lambarka telefoonka ee gaarka ah`,
    th: `\u{E2B}\u{E21}\u{E32}\u{E22}\u{E40}\u{E25}\u{E02}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E40}\u{E2D}\u{E07}`,
    ur: `\u{6A9}\u{633}\u{679}\u{645} \u{641}\u{648}\u{646} \u{646}\u{645}\u{628}\u{631}`,
    vi: `S\u{1ED1} \u{111}i\u{1EC7}n tho\u{1EA1}i t\xf9y ch\u{1EC9}nh`,
    'zh-hans': `\u{81EA}\u{5B9A}\u{4E49}\u{7535}\u{8BDD}\u{53F7}\u{7801}`,
    'zh-hant': `\u{81EA}\u{8A02}\u{96FB}\u{8A71}\u{865F}\u{78BC}`,
    en: `Custom phone number`
};
const $b11db1b62d4a8f76$export$355b3fec45de38c5 = {
    ar: `\u{628}\u{631}\u{648}\u{62A}\u{627}\u{646}\u{648}\u{628}\u{64A}\u{627} \u{627}\u{644}\u{645}\u{638}\u{644}\u{645}\u{629} \u{648}\u{627}\u{644}\u{62F}\u{64A}\u{648}\u{62A}\u{64A}\u{631}\u{627}\u{646}\u{648}\u{628}\u{64A}\u{627}`,
    de: `Dunkle Protanopie & Deuteranopie`,
    es: `Protanop\xeda oscura y deuteranop\xeda`,
    fa: `\u{67E}\u{631}\u{648}\u{62A}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627} \u{62A}\u{627}\u{631}\u{6CC}\u{6A9} \u{648} \u{62F}\u{648}\u{62A}\u{631}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    fil: `Madilim na Protanopia at Deuteranopia`,
    fr: `Protanopie sombre et deut\xe9ranopie`,
    hi: `\u{921}\u{93E}\u{930}\u{94D}\u{915} \u{92A}\u{94D}\u{930}\u{94B}\u{91F}\u{93E}\u{928}\u{94B}\u{92A}\u{93F}\u{92F}\u{93E} \u{914}\u{930} \u{921}\u{94D}\u{92F}\u{942}\u{91F}\u{947}\u{930}\u{93E}\u{928}\u{94B}\u{92A}\u{93F}\u{92F}\u{93E}`,
    ht: `Nwa Protanopia & Deuteranopia`,
    it: `Protanopia Oscura e Deuteranopia`,
    ja: `\u{30C0}\u{30FC}\u{30AF}\u{30D7}\u{30ED}\u{30BF}\u{30CE}\u{30D4}\u{30A2}\u{3068}\u{30C7}\u{30E5}\u{30A6}\u{30C6}\u{30E9}\u{30CE}\u{30D4}\u{30A2}`,
    ko: `\u{B2E4}\u{D06C} \u{D504}\u{B85C}\u{D0C0}\u{B178}\u{D53C}\u{C544} \u{BC0F} \u{B3C4}\u{D14C}\u{B77C}\u{B178}\u{D53C}\u{C544}`,
    mww: `Tsaus Protanopia & Deuteranopia`,
    ps: `\u{62A}\u{648}\u{631}\u{647} \u{67E}\u{631}\u{648}\u{62A}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627} \u{627}\u{648} \u{62F}\u{6CC}\u{648}\u{62A}\u{631}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    pt: `Protanopia Escura e Deuteranopia`,
    'pt-pt': `Protanopia Escura e Deuteranopia`,
    ru: `\u{422}\u{451}\u{43C}\u{43D}\u{430}\u{44F} \u{43F}\u{440}\u{43E}\u{442}\u{430}\u{43D}\u{43E}\u{43F}\u{438}\u{44F} \u{438} \u{434}\u{435}\u{439}\u{442}\u{435}\u{440}\u{430}\u{43D}\u{43E}\u{43F}\u{438}\u{44F}`,
    sm: `Pogisa Protanopia ma Deuteranopia`,
    so: `Dark Protanopia & Deuteranopia`,
    th: `\u{E42}\u{E1E}\u{E23}\u{E15}\u{E32}\u{E42}\u{E19}\u{E40}\u{E1B}\u{E35}\u{E22}\u{E21}\u{E37}\u{E14} & \u{E14}\u{E34}\u{E27}\u{E40}\u{E17}\u{E23}\u{E32}\u{E42}\u{E19}\u{E40}\u{E1B}\u{E35}\u{E22}`,
    ur: `\u{688}\u{627}\u{631}\u{6A9} \u{67E}\u{631}\u{648}\u{679}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627} \u{627}\u{648}\u{631} \u{688}\u{6CC}\u{648}\u{679}\u{6CC}\u{631}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    vi: `Protanopia \u{111}en & Deuteranopia`,
    'zh-hans': `\u{6697}\u{8272}\u{76F2}\u{4E0E}\u{675C}\u{7279}\u{62C9}\u{8BFA}\u{76AE}\u{4E9A}`,
    'zh-hant': `\u{6697}\u{539F}\u{751F}\u{76F2}\u{8207}\u{675C}\u{7279}\u{62C9}\u{8AFE}\u{76AE}\u{4E9E}`,
    en: `Dark Protanopia & Deuteranopia`
};
const $b11db1b62d4a8f76$export$e6d78ef699b242e3 = {
    ar: `\u{627}\u{644}\u{648}\u{636}\u{639} \u{627}\u{644}\u{645}\u{627}\u{644}\u{64A} \u{627}\u{644}\u{645}\u{638}\u{644}\u{645}`,
    de: `Dark Default`,
    es: `Defecto Oscuro`,
    fa: `\u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636} \u{62A}\u{627}\u{631}\u{6CC}\u{6A9}`,
    fil: `Madilim na Default`,
    fr: `D\xe9faut Sombre`,
    hi: `\u{921}\u{93E}\u{930}\u{94D}\u{915} \u{921}\u{93F}\u{92B}\u{949}\u{932}\u{94D}\u{91F}`,
    ht: `Nwa Default`,
    it: `Dark Default`,
    ja: `\u{30C0}\u{30FC}\u{30AF}\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}`,
    ko: `\u{B2E4}\u{D06C} \u{B514}\u{D3F4}\u{D2B8}`,
    mww: `Tsaus Ntuj Neej ntawd`,
    ps: `\u{689}\u{627}\u{631}\u{6A9} \u{689}\u{6CC}\u{641}\u{627}\u{644}\u{67C}`,
    pt: `Padr\xe3o Sombrio`,
    'pt-pt': `Padr\xe3o Sombrio`,
    ru: `Dark Default`,
    sm: `Pogisa Faaletonu`,
    so: `Dark Default`,
    th: `\u{E04}\u{E48}\u{E32}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E17}\u{E35}\u{E48}\u{E21}\u{E37}\u{E14}`,
    ur: `\u{688}\u{627}\u{631}\u{6A9} \u{688}\u{6CC}\u{641}\u{627}\u{644}\u{679}`,
    vi: `M\u{1EB7}c \u{111}\u{1ECB}nh t\u{1ED1}i`,
    'zh-hans': `\u{9ED1}\u{6697}\u{9ED8}\u{8BA4}`,
    'zh-hant': `\u{9ED1}\u{6697}\u{9810}\u{8A2D}`,
    en: `Dark Default`
};
const $b11db1b62d4a8f76$export$2c3e747abbbbfa2e = {
    ar: `\u{627}\u{644}\u{638}\u{644}\u{627}\u{645} \u{627}\u{644}\u{62E}\u{627}\u{641}\u{62A}`,
    de: `Dunkel gedimmt`,
    es: `Oscuridad Atenuada`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{6A9} \u{6A9}\u{645} \u{646}\u{648}\u{631}`,
    fil: `Madilim na Malabo`,
    fr: `Sombre Att\xe9nu\xe9`,
    hi: `\u{921}\u{93E}\u{930}\u{94D}\u{915} \u{921}\u{93F}\u{92E}\u{94D}\u{921}`,
    ht: `Nwa Dimmed`,
    it: `Dark si affievoliva`,
    ja: `\u{6697}\u{3044}`,
    ko: `\u{C5B4}\u{B460} \u{C5B4}\u{B460}`,
    mww: `tsaus nti tsaus nti`,
    ps: `\u{689}\u{627}\u{631}\u{6A9} \u{689}\u{6CC}\u{645}\u{689}`,
    pt: `Escurid\xe3o Atenuada`,
    'pt-pt': `Escurid\xe3o Apagada`,
    ru: `Dark Dimmed`,
    sm: `Pogisa pogisa`,
    so: `Dark Dimmed`,
    th: `\u{E21}\u{E37}\u{E14}\u{E2A}\u{E25}\u{E31}\u{E27}`,
    ur: `\u{688}\u{627}\u{631}\u{6A9} \u{688}\u{645}\u{688}`,
    vi: `M\u{1EDD} t\u{1ED1}i`,
    'zh-hans': `\u{9ED1}\u{6697}\u{6697}\u{6DE1}`,
    'zh-hant': `\u{9ED1}\u{6697}\u{6697}\u{6DE1}`,
    en: `Dark Dimmed`
};
const $b11db1b62d4a8f76$export$6853c47cb425f877 = {
    ar: `\u{627}\u{644}\u{62A}\u{628}\u{627}\u{64A}\u{646} \u{627}\u{644}\u{639}\u{627}\u{644}\u{64A} \u{627}\u{644}\u{62F}\u{627}\u{643}\u{646}`,
    de: `Dunkel, hoher Kontrast`,
    es: `Alto contraste oscuro`,
    fa: `\u{6A9}\u{646}\u{62A}\u{631}\u{627}\u{633}\u{62A} \u{62A}\u{627}\u{631}\u{6CC}\u{6A9} \u{628}\u{627}\u{644}\u{627}`,
    fil: `Madilim na Mataas na Pagkakaiba`,
    fr: `Contraste \xe0 fort contraste sombre`,
    hi: `\u{921}\u{93E}\u{930}\u{94D}\u{915} \u{939}\u{93E}\u{908} \u{915}\u{902}\u{91F}\u{94D}\u{930}\u{93E}\u{938}\u{94D}\u{91F}`,
    ht: `F\xe8 nwa kontras segond\xe8`,
    it: `Scuro ad alto contrasto`,
    ja: `\u{30C0}\u{30FC}\u{30AF}\u{30FB}\u{30CF}\u{30A4}\u{30FB}\u{30B3}\u{30F3}\u{30C8}\u{30E9}\u{30B9}\u{30C8}`,
    ko: `\u{B2E4}\u{D06C} \u{D558}\u{C774} \u{CF58}\u{D2B8}\u{B77C}\u{C2A4}\u{D2B8}`,
    mww: `Tsaus Siab Sib Piv`,
    ps: `\u{62A}\u{6CC}\u{627}\u{631}\u{647} \u{644}\u{648}\u{693} \u{6A9}\u{646}\u{67C}\u{631}\u{627}\u{633}\u{62A}`,
    pt: `Alto Contraste Escuro`,
    'pt-pt': `Alto Contraste Escuro`,
    ru: `\u{422}\u{451}\u{43C}\u{43D}\u{44B}\u{439} \u{432}\u{44B}\u{441}\u{43E}\u{43A}\u{438}\u{439} \u{43A}\u{43E}\u{43D}\u{442}\u{440}\u{430}\u{441}\u{442}`,
    sm: `Pogisa Maualuga Eseesega`,
    so: `Dark High Contrast`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E21}\u{E0A}\u{E31}\u{E14}\u{E2A}\u{E39}\u{E07}\u{E17}\u{E35}\u{E48}\u{E21}\u{E37}\u{E14}`,
    ur: `\u{688}\u{627}\u{631}\u{6A9} \u{6C1}\u{627}\u{626}\u{6CC} \u{6A9}\u{646}\u{679}\u{631}\u{627}\u{633}\u{679}`,
    vi: `\u{110}\u{1ED9} t\u{1B0}\u{1A1}ng ph\u{1EA3}n cao t\u{1ED1}i`,
    'zh-hans': `\u{6697}\u{9AD8}\u{5BF9}\u{6BD4}`,
    'zh-hant': `\u{6697}\u{9AD8}\u{5C0D}\u{6BD4}`,
    en: `Dark High Contrast`
};
const $b11db1b62d4a8f76$export$7ea2cd3bde4da51f = {
    ar: `\u{62A}\u{631}\u{64A}\u{62A}\u{627}\u{646}\u{648}\u{628}\u{64A}\u{627} \u{627}\u{644}\u{645}\u{638}\u{644}\u{645}\u{629}`,
    de: `Dunkle Tritanopie`,
    es: `Tritanopia Oscura`,
    fa: `\u{62A}\u{631}\u{6CC}\u{62A}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{6A9}`,
    fil: `Madilim na Tritanopia`,
    fr: `Tritanopie Sombre`,
    hi: `\u{921}\u{93E}\u{930}\u{94D}\u{915} \u{91F}\u{94D}\u{930}\u{93F}\u{91F}\u{93E}\u{928}\u{94B}\u{92A}\u{93F}\u{92F}\u{93E}`,
    ht: `Tritanopia f\xe8 nwa`,
    it: `Tritanopia Oscura`,
    ja: `\u{30C0}\u{30FC}\u{30AF}\u{30FB}\u{30C8}\u{30EA}\u{30BF}\u{30CE}\u{30D4}\u{30A2}`,
    ko: `\u{B2E4}\u{D06C} \u{D2B8}\u{B9AC}\u{D0C0}\u{B178}\u{D53C}\u{C544}`,
    mww: `Tsaus Tritanopia`,
    ps: `\u{689}\u{627}\u{631}\u{6A9} \u{67C}\u{631}\u{6CC}\u{67C}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    pt: `Tritanopia Sombria`,
    'pt-pt': `Tritanopia Sombria`,
    ru: `\u{422}\u{451}\u{43C}\u{43D}\u{430}\u{44F} \u{422}\u{440}\u{438}\u{442}\u{430}\u{43D}\u{43E}\u{43F}\u{438}\u{44F}`,
    sm: `Tritanopia pogisa`,
    so: `Tritanopia Madow`,
    th: `\u{E17}\u{E23}\u{E34}\u{E17}\u{E32}\u{E42}\u{E19}\u{E40}\u{E1B}\u{E35}\u{E22}\u{E21}\u{E37}\u{E14}`,
    ur: `\u{688}\u{627}\u{631}\u{6A9} \u{679}\u{631}\u{627}\u{626}\u{6CC}\u{679}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    vi: `Tritanopia \u{111}en t\u{1ED1}i`,
    'zh-hans': `\u{6697}\u{4E09}\u{89D2}\u{6D32}`,
    'zh-hant': `\u{9ED1}\u{6697}\u{4E09}\u{8449}\u{7247}`,
    en: `Dark Tritanopia`
};
const $b11db1b62d4a8f76$export$95c55fc320a5b72c = {
    ar: `\u{644}\u{648}\u{62D}\u{629} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    de: `Armaturenbrett`,
    es: `Salpicadero`,
    fa: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F}`,
    fil: `Dashboard`,
    fr: `Tableau de bord`,
    hi: `\u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921}`,
    ht: `Tablodb\xf2`,
    it: `Cruscotto`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC}`,
    mww: `Dashboard`,
    ps: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{689}`,
    pt: `Painel`,
    'pt-pt': `Painel de instrumentos`,
    ru: `\u{41F}\u{430}\u{43D}\u{435}\u{43B}\u{44C} \u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Dashboard`,
    so: `Dashboard`,
    th: `\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}`,
    ur: `\u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688}`,
    vi: `B\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n`,
    'zh-hans': `\u{4EEA}\u{8868}\u{76D8}`,
    'zh-hant': `\u{5100}\u{8868}\u{677F}`,
    en: `Dashboard`
};
const $b11db1b62d4a8f76$export$48721beab27c0258 = {
    ar: `\u{644}\u{648}\u{62D}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    de: `Dashboards`,
    es: `Paneles`,
    fa: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F}\u{647}\u{627}`,
    fil: `Mga Dashboard`,
    fr: `Tableaux de bord`,
    hi: `\u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921}`,
    ht: `Tablodb\xf2 yo`,
    it: `Cruscotti`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC}`,
    mww: `Dashboards`,
    ps: `\u{689}\u{634}\u{628}\u{648}\u{631}\u{689}`,
    pt: `Pain\xe9is de controle`,
    'pt-pt': `Dashboards`,
    ru: `\u{414}\u{430}\u{448}\u{431}\u{43E}\u{440}\u{434}\u{44B}`,
    sm: `Dashboard`,
    so: `Dashboards`,
    th: `\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}`,
    ur: `\u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688}\u{632}`,
    vi: `B\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n`,
    'zh-hans': `\u{4EEA}\u{8868}\u{76D8}`,
    'zh-hant': `\u{5100}\u{8868}\u{677F}`,
    en: `Dashboards`
};
const $b11db1b62d4a8f76$export$a71a2b68f9dc2327 = {
    ar: `\u{627}\u{644}\u{62A}\u{627}\u{631}\u{64A}\u{62E}`,
    de: `Datum`,
    es: `Fecha`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    fil: `Petsa`,
    fr: `Date`,
    hi: `\u{924}\u{93E}\u{930}\u{940}\u{916}`,
    ht: `Dat`,
    it: `Data`,
    ja: `\u{65E5}\u{4ED8}`,
    ko: `\u{B0A0}\u{C9DC}`,
    mww: `Hnub Tim`,
    ps: `\u{646}\u{6D0}\u{67C}\u{647}`,
    pt: `Data`,
    'pt-pt': `Data`,
    ru: `\u{414}\u{430}\u{442}\u{430}`,
    sm: `Aso`,
    so: `Taariikhda`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}`,
    ur: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y`,
    'zh-hans': `\u{65E5}\u{671F}`,
    'zh-hant': `\u{65E5}\u{671F}`,
    en: `Date`
};
const $b11db1b62d4a8f76$export$a290c6ac04e2eada = {
    ar: (eventDate, location)=>`${eventDate} \u{641}\u{64A} ${location}`,
    de: (eventDate, location)=>`${eventDate} in ${location}`,
    es: (eventDate, location)=>`5${eventDate} en ${location}`,
    fa: (eventDate, location)=>`${eventDate} \u{62F}\u{631} ${location}`,
    fil: (eventDate, location)=>`${eventDate} sa ${location}`,
    fr: (eventDate, location)=>`${eventDate} au ${location}`,
    hi: (eventDate, location)=>`${eventDate} ${location} \u{92A}\u{930}`,
    ht: (eventDate, location)=>`${eventDate} nan ${location}`,
    it: (eventDate, location)=>`${eventDate} al ${location}`,
    ja: (eventDate, location)=>`${eventDate}\u{65E5}\u{3001}1\u{30E1}\u{30A4}\u{30F3}${location}\u{306B}\u{3066}`,
    ko: (eventDate, location)=>`${eventDate} , 1 ${location}`,
    mww: (eventDate, location)=>`${eventDate} ntawm ${location}`,
    ps: (eventDate, location)=>`${eventDate} \u{67E}\u{647} ${location}`,
    pt: (eventDate, location)=>`${eventDate} na ${location}`,
    'pt-pt': (eventDate, location)=>`${eventDate} na ${location}`,
    ru: (eventDate, location)=>`${eventDate} \u{43F}\u{43E} \u{430}\u{434}\u{440}\u{435}\u{441}\u{443}: ${location}`,
    sm: (eventDate, location)=>`${eventDate} i ${location}`,
    so: (eventDate, location)=>`${eventDate} 1 ${location}`,
    th: (eventDate, location)=>`${eventDate} \u{E17}\u{E35}\u{E48} ${location}`,
    ur: (eventDate, location)=>`${eventDate} \u{60C} ${location}`,
    vi: (eventDate, location)=>`${eventDate} t\u{1EA1}i ${location}`,
    'zh-hans': (eventDate, location)=>`${eventDate} \u{65E5}\u{FF0C}\u{5730}\u{70B9}\u{FF1A} ${location}`,
    'zh-hant': (eventDate, location)=>`${eventDate} \u{FF0C}\u{5730}\u{9EDE}\u{FF1A} ${location}`,
    en: (eventDate, location)=>`${eventDate} at ${location}`
};
const $b11db1b62d4a8f76$export$7ad47ed13860da91 = {
    ar: `\u{627}\u{644}\u{62A}\u{648}\u{627}\u{631}\u{64A}\u{62E}`,
    de: `Daten`,
    es: `Fechas`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{647}\u{627}`,
    fil: `Mga Petsa`,
    fr: `Dates`,
    hi: `\u{916}\u{91C}\u{942}\u{930}`,
    ht: `Dat yo`,
    it: `Date`,
    ja: `\u{65E5}\u{4ED8}`,
    ko: `\u{B0A0}\u{C9DC}`,
    mww: `Hnub tim`,
    ps: `\u{646}\u{6CC}\u{67C}\u{6D0}`,
    pt: `Datas`,
    'pt-pt': `Datas`,
    ru: `\u{414}\u{430}\u{442}\u{44B}`,
    sm: `Aso`,
    so: `Taariikhaha`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}`,
    ur: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{6CC}\u{6BA}`,
    vi: `Ng\xe0y`,
    'zh-hans': `\u{65E5}\u{671F}`,
    'zh-hant': `\u{65E5}\u{671F}`,
    en: `Dates`
};
const $b11db1b62d4a8f76$export$f52fcfda8c8c5d90 = {
    ar: `\u{623}\u{64A}\u{627}\u{645} \u{627}\u{644}\u{639}\u{645}\u{644}`,
    de: `Gearbeitete Tage`,
    es: `D\xedas trabajados`,
    fa: `\u{631}\u{648}\u{632}\u{647}\u{627}\u{6CC} \u{6A9}\u{627}\u{631}`,
    fil: `Mga araw na nagtrabaho`,
    fr: `Jours de travail`,
    hi: `\u{915}\u{93E}\u{92E} \u{915}\u{93F}\u{90F} \u{917}\u{90F} \u{926}\u{93F}\u{928}`,
    ht: `Jou travay`,
    it: `Giornate lavorate`,
    ja: `\u{52B4}\u{50CD}\u{65E5}\u{6570}`,
    ko: `\u{ADFC}\u{BB34} \u{C2DC}\u{AC04}`,
    mww: `Hnub ua haujlwm`,
    ps: `\u{648}\u{631}\u{681}\u{6D0} \u{686}\u{6D0} \u{6A9}\u{627}\u{631} \u{6A9}\u{648}\u{6CC}`,
    pt: `Dias trabalhados`,
    'pt-pt': `Dias trabalhados`,
    ru: `\u{420}\u{430}\u{431}\u{43E}\u{447}\u{438}\u{435} \u{434}\u{43D}\u{438}`,
    sm: `Aso faigaluega`,
    so: `Maalmo la shaqeeyay`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6A9}\u{627}\u{645} \u{6A9}\u{6D2} \u{62F}\u{646}`,
    vi: `S\u{1ED1} ng\xe0y l\xe0m vi\u{1EC7}c`,
    'zh-hans': `\u{5DE5}\u{4F5C}\u{65E5}\u{6570}`,
    'zh-hant': `\u{5DE5}\u{4F5C}\u{65E5}`,
    en: `Days worked`
};
const $b11db1b62d4a8f76$export$168e7f4521755dda = {
    ar: `\u{62D}\u{630}\u{641}`,
    de: `L\xf6schen`,
    es: `Borrar`,
    fa: `\u{62D}\u{630}\u{641}`,
    fil: `Tanggalin`,
    fr: `Supprimer`,
    hi: `\u{92E}\u{93F}\u{91F}\u{93E}\u{928}\u{93E}`,
    ht: `Efase`,
    it: `Elimina`,
    ja: `\u{524A}\u{9664}`,
    ko: `\u{C0AD}\u{C81C}`,
    mww: `Rho tawm`,
    ps: `\u{62D}\u{630}\u{641} \u{6A9}\u{693}\u{647}`,
    pt: `Excluir`,
    'pt-pt': `Eliminar`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}`,
    sm: `Aveese`,
    so: `Tirtir`,
    th: `\u{E25}\u{E1A}`,
    ur: `\u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xf3a`,
    'zh-hans': `\u{5220}\u{9664}`,
    'zh-hant': `\u{522A}\u{9664}`,
    en: `Delete`
};
const $b11db1b62d4a8f76$export$4a4b0db14c023cd8 = {
    ar: (title)=>`\u{647}\u{644} \u{623}\u{646}\u{62A} \u{645}\u{62A}\u{623}\u{643}\u{62F} \u{623}\u{646}\u{643} \u{62A}\u{631}\u{64A}\u{62F} \u{62D}\u{630}\u{641} "${title}"\u{61F}`,
    de: (title)=>`Bist du sicher, dass du "${title}" l\xf6schen willst?`,
    es: (title)=>`\xbfEst\xe1s seguro de que quieres borrar "${title}"?`,
    fa: (title)=>`\u{645}\u{637}\u{645}\u{626}\u{646}\u{6CC} \u{645}\u{6CC} \u{62E}\u{648}\u{627}\u{6CC} \xab${title}\xbb \u{631}\u{648} \u{62D}\u{630}\u{641} \u{6A9}\u{646}\u{6CC}\u{61F}`,
    fil: (title)=>`Sigurado ka bang gusto mong tanggalin ang "${title}"?`,
    fr: (title)=>`\xcates-vous s\xfbr de vouloir supprimer \xab ${title} \xbb ?`,
    hi: (title)=>`\u{915}\u{94D}\u{92F}\u{93E} \u{906}\u{92A} \u{935}\u{93E}\u{915}\u{908} "${title} \u{915}\u{94B} \u{939}\u{91F}\u{93E}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{924}\u{947} \u{939}\u{948}\u{902}?`,
    ht: (title)=>`Ou s\xe8ten ou vle efase "${title}"?`,
    it: (title)=>`Sei sicuro di voler cancellare "${title}"?`,
    ja: (title)=>`\u{300C}${title}\u{300D}\u{3092}\u{524A}\u{9664}\u{3057}\u{305F}\u{3044}\u{306E}\u{3067}\u{3059}\u{304B}?`,
    ko: (title)=>`"${title}\u{B97C} \u{C0AD}\u{C81C}\u{D560} \u{AC70} \u{D655}\u{C2E4}\u{D574}?`,
    mww: (title)=>`Koj puas paub tseeb tias koj xav rho tawm "${title}"?`,
    ps: (title)=>`\u{62A}\u{647} \u{689}\u{627}\u{689}\u{647} \u{6CC}\u{6D0} \u{686}\u{6D0} "${title}" \u{62D}\u{630}\u{641} \u{6A9}\u{648}\u{644} \u{63A}\u{648}\u{627}\u{693}\u{6D0}\u{61F}`,
    pt: (title)=>`Voc\xea tem certeza de que quer deletar "${title}"?`,
    'pt-pt': (title)=>`Tens a certeza que queres apagar "${title}"?`,
    ru: (title)=>`\u{412}\u{44B} \u{443}\u{432}\u{435}\u{440}\u{435}\u{43D}\u{44B}, \u{447}\u{442}\u{43E} \u{445}\u{43E}\u{442}\u{438}\u{442}\u{435} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \xab${title}\xbb?`,
    sm: (title)=>`E te mautinoa e te mana'o e aveese le "${title}"?`,
    so: (title)=>`Ma hubtaa inaad rabto inaad tirtirto "${title}"?`,
    th: (title)=>`\u{E04}\u{E38}\u{E13}\u{E41}\u{E19}\u{E48}\u{E43}\u{E08}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E44}\u{E21}\u{E48}\u{E27}\u{E48}\u{E32}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E25}\u{E1A} "${title}"`,
    ur: (title)=>`\u{6A9}\u{6CC}\u{627} \u{622}\u{67E} \u{648}\u{627}\u{642}\u{639}\u{6CC} "${title}" \u{6A9}\u{648} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{61F}`,
    vi: (title)=>`B\u{1EA1}n c\xf3 ch\u{1EAF}c ch\u{1EAF}n mu\u{1ED1}n x\xf3a "${title}" kh\xf4ng?`,
    'zh-hans': (title)=>`\u{4F60}\u{786E}\u{5B9A}\u{8981}\u{5220}\u{9664}\u{201C}${title}\u{6C0F}\u{201D}\u{5417}\u{FF1F}`,
    'zh-hant': (title)=>`\u{4F60}\u{78BA}\u{5B9A}\u{8981}\u{522A}\u{9664}\u{300C}${title}\u{300D}\u{55CE}\u{FF1F}`,
    en: (title)=>`Are you sure you want to delete "${title}"?`
};
const $b11db1b62d4a8f76$export$ca32c32188d8bc1a = {
    ar: `\u{62D}\u{630}\u{641} \u{627}\u{644}\u{645}\u{62F}\u{62E}\u{644}`,
    de: `Eintrag l\xf6schen`,
    es: `Eliminar entrada`,
    fa: `\u{62D}\u{630}\u{641} \u{648}\u{631}\u{648}\u{62F}\u{6CC}`,
    fil: `Tanggalin ang entry`,
    fr: `Supprimer l\u{2019}entr\xe9e`,
    hi: `\u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F} \u{939}\u{91F}\u{93E}\u{90F}\u{902}`,
    ht: `Efase antre`,
    it: `Elimina la voce`,
    ja: `\u{30A8}\u{30F3}\u{30C8}\u{30EA}\u{3092}\u{524A}\u{9664}`,
    ko: `\u{D56D}\u{BAA9} \u{C0AD}\u{C81C}`,
    mww: `Rho tawm nkag`,
    ps: `\u{646}\u{646}\u{648}\u{62A} \u{62D}\u{630}\u{641} \u{6A9}\u{693}\u{626}`,
    pt: `Excluir entrada`,
    'pt-pt': `Eliminar entrada`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Aveese le tusiga`,
    so: `Tirtir qoraalka`,
    th: `\u{E25}\u{E1A}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xf3a m\u{1EE5}c nh\u{1EAD}p`,
    'zh-hans': `\u{5220}\u{9664}\u{6761}\u{76EE}`,
    'zh-hant': `\u{522A}\u{9664}\u{689D}\u{76EE}`,
    en: `Delete entry`
};
const $b11db1b62d4a8f76$export$9a0f2f001137b3b8 = {
    ar: `\u{62D}\u{630}\u{641} \u{627}\u{644}\u{634}\u{62E}\u{635}`,
    de: `Person l\xf6schen`,
    es: `Eliminar persona`,
    fa: `\u{62D}\u{630}\u{641} \u{634}\u{62E}\u{635}`,
    fil: `Tanggalin ang tao`,
    fr: `Supprimer la personne`,
    hi: `\u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F} \u{915}\u{94B} \u{92E}\u{93F}\u{91F}\u{93E}\u{928}\u{93E}`,
    ht: `Efase moun`,
    it: `Elimina persona`,
    ja: `\u{4EBA}\u{3092}\u{524A}\u{9664}`,
    ko: `\u{C0AC}\u{B78C} \u{C0AD}\u{C81C}`,
    mww: `Rho tawm tus neeg`,
    ps: `\u{634}\u{62E}\u{635} \u{62D}\u{630}\u{641} \u{6A9}\u{693}\u{626}`,
    pt: `Excluir pessoa`,
    'pt-pt': `Eliminar pessoa`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{447}\u{435}\u{43B}\u{43E}\u{432}\u{435}\u{43A}\u{430}`,
    sm: `Aveese le tagata`,
    so: `Qof tirtir`,
    th: `\u{E25}\u{E1A}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}`,
    ur: `\u{634}\u{62E}\u{635} \u{6A9}\u{648} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xf3a ng\u{1B0}\u{1EDD}i`,
    'zh-hans': `\u{5220}\u{9664}\u{4EBA}`,
    'zh-hant': `\u{522A}\u{9664}\u{4EBA}`,
    en: `Delete person`
};
const $b11db1b62d4a8f76$export$31a34480861da9d9 = {
    ar: `\u{62D}\u{630}\u{641} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}`,
    de: `Signatur l\xf6schen`,
    es: `Eliminar firma`,
    fa: `\u{62D}\u{630}\u{641} \u{627}\u{645}\u{636}\u{627}`,
    fil: `Tanggalin ang lagda`,
    fr: `Supprimer la signature`,
    hi: `\u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{939}\u{91F}\u{93E}\u{928}\u{93E}`,
    ht: `Efase siyati`,
    it: `Elimina firma`,
    ja: `\u{7F72}\u{540D}\u{3092}\u{524A}\u{9664}`,
    ko: `\u{C11C}\u{BA85} \u{C0AD}\u{C81C}`,
    mww: `Rho tawm kos npe`,
    ps: `\u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{62D}\u{630}\u{641} \u{6A9}\u{693}\u{626}`,
    pt: `Excluir assinatura`,
    'pt-pt': `Eliminar assinatura`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Tape le saini`,
    so: `Tirtir saxiixa`,
    th: `\u{E25}\u{E1A}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xf3a ch\u{1EEF} k\xfd`,
    'zh-hans': `\u{5220}\u{9664}\u{7B7E}\u{540D}`,
    'zh-hant': `\u{522A}\u{9664}\u{7C3D}\u{7AE0}`,
    en: `Delete signature`
};
const $b11db1b62d4a8f76$export$9279b045541daaab = {
    ar: (title)=>`\u{62D}\u{630}\u{641} ${title}`,
    de: (title)=>`${title} l\xf6schen`,
    es: (title)=>`Eliminar ${title}`,
    fa: (title)=>`${title} \u{631}\u{627} \u{62D}\u{630}\u{641} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: (title)=>`Tanggalin ${title}`,
    fr: (title)=>`Supprimer ${title}`,
    hi: (title)=>`${title} \u{939}\u{91F}\u{93E}\u{90F}\u{902}`,
    ht: (title)=>`Efase ${title}`,
    it: (title)=>`Elimina ${title}`,
    ja: (title)=>`${title}\u{3092}\u{524A}\u{9664}`,
    ko: (title)=>`${title} \u{C0AD}\u{C81C}`,
    mww: (title)=>`Rho tawm ${title}`,
    ps: (title)=>`${title} \u{62D}\u{630}\u{641} \u{6A9}\u{693}\u{647}`,
    pt: (title)=>`${title}`,
    'pt-pt': (title)=>`Eliminar ${title}`,
    ru: (title)=>`\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} ${title}`,
    sm: (title)=>`Aveese ${title}`,
    so: (title)=>`${title}`,
    th: (title)=>`\u{E25}\u{E1A} ${title}`,
    ur: (title)=>`${title} \u{6A9}\u{648} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: (title)=>`X\xf3a ${title}`,
    'zh-hans': (title)=>`\u{5220}\u{9664} ${title}`,
    'zh-hant': (title)=>`\u{522A}\u{9664} ${title}`,
    en: (title)=>`Delete ${title}`
};
const $b11db1b62d4a8f76$export$626e23a726c6538e = {
    ar: `\u{631}\u{641}\u{636} \u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{62A}`,
    de: `Zeiterfassung abweisen`,
    es: `Rechazar hoja de horas`,
    fa: `\u{631}\u{62F} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646}`,
    fil: `Tanggihan ang timesheet`,
    fr: `Refuser la feuille de temps`,
    hi: `\u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{915}\u{94B} \u{905}\u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Refize Timesheet`,
    it: `Nega il foglio orario`,
    ja: `\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{62D2}\u{5426}`,
    ko: `\u{ADFC}\u{BB34} \u{AE30}\u{B85D} \u{AC70}\u{BD80}`,
    mww: `Tsis kam lees daim ntawv teev sijhawm`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647} \u{631}\u{62F} \u{6A9}\u{693}\u{647}`,
    pt: `Negar folha de ponto`,
    'pt-pt': `Negar folha de horas`,
    ru: `\u{422}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{43E}\u{442}\u{43A}\u{43B}\u{43E}\u{43D}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Teena le pepa o taimi`,
    so: `Diido jadwalka waqtiga`,
    th: `\u{E1B}\u{E0F}\u{E34}\u{E40}\u{E2A}\u{E18}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}`,
    ur: `\u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{633}\u{6D2} \u{627}\u{646}\u{6A9}\u{627}\u{631} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\u{1EEB} ch\u{1ED1}i b\u{1EA3}ng ch\u{1EA5}m c\xf4ng`,
    'zh-hans': `\u{62D2}\u{7EDD}\u{5DE5}\u{65F6}\u{8868}`,
    'zh-hant': `\u{62D2}\u{7D55}\u{5DE5}\u{6642}\u{8868}`,
    en: `Deny timesheet`
};
const $b11db1b62d4a8f76$export$ef7806003a9d6713 = {
    ar: `\u{627}\u{644}\u{648}\u{635}\u{641}`,
    de: `Beschreibung`,
    es: `Descripci\xf3n`,
    fa: `\u{62A}\u{648}\u{636}\u{6CC}\u{62D}\u{627}\u{62A}`,
    fil: `Paglalarawan`,
    fr: `Description`,
    hi: `\u{92F}\u{93E} \u{915}\u{93C}\u{93F}\u{938}\u{94D}\u{200D}\u{92E}`,
    ht: `Deskripsyon`,
    it: `Descrizione`,
    ja: `\u{6982}\u{8981}`,
    ko: `\u{C124}\u{BA85}`,
    mww: `Kev piav qhia`,
    ps: `\u{62A}\u{648}\u{636}\u{6CC}\u{62D}\u{627}\u{62A}`,
    pt: `Descri\xe7\xe3o`,
    'pt-pt': `Descri\xe7\xe3o`,
    ru: `\u{41E}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Faamatalaga`,
    so: `Sharaxaad`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E2D}\u{E18}\u{E34}\u{E1A}\u{E32}\u{E22}`,
    ur: `\u{62A}\u{641}\u{635}\u{6CC}\u{644}`,
    vi: `S\u{1EF1} mi\xeau t\u{1EA3}`,
    'zh-hans': `\u{63CF}\u{8FF0}`,
    'zh-hant': `\u{63CF}\u{8FF0}`,
    en: `Description`
};
const $b11db1b62d4a8f76$export$f9485ec7bd437160 = {
    ar: `\u{627}\u{644}\u{648}\u{635}\u{641} / \u{627}\u{644}\u{633}\u{62C}\u{644}`,
    de: `Beschreibung / Aufzeichnung`,
    es: `Descripci\xf3n / registro`,
    fa: `\u{62A}\u{648}\u{636}\u{6CC}\u{62D}\u{627}\u{62A} / \u{633}\u{648}\u{627}\u{628}\u{642}`,
    fil: `Paglalarawan / talaan`,
    fr: `Description / dossier`,
    hi: `\u{935}\u{93F}\u{935}\u{930}\u{923}/\u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921}`,
    ht: `Deskripsyon / dosye`,
    it: `Descrizione / record`,
    ja: `\u{8AAC}\u{660E}/\u{8A18}\u{9332}`,
    ko: `\u{C124}\u{BA85} / \u{AE30}\u{B85D}`,
    mww: `Cov lus piav qhia / cov ntaub ntawv`,
    ps: `\u{62A}\u{634}\u{631}\u{6CC}\u{62D} / \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689}`,
    pt: `Descri\xe7\xe3o / registro`,
    'pt-pt': `Descri\xe7\xe3o / registo`,
    ru: `\u{41E}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435} / \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Fa'amatalaga / fa'amaumauga`,
    so: `Sharaxaad / rikoodh`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E2D}\u{E18}\u{E34}\u{E1A}\u{E32}\u{E22} / \u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}`,
    ur: `\u{62A}\u{641}\u{635}\u{6CC}\u{644} / \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688}`,
    vi: `M\xf4 t\u{1EA3} / h\u{1ED3} s\u{1A1}`,
    'zh-hans': `\u{63CF}\u{8FF0} / \u{8BB0}\u{5F55}`,
    'zh-hant': `\u{63CF}\u{8FF0} / \u{7D00}\u{9304}`,
    en: `Description / record`
};
const $b11db1b62d4a8f76$export$6c21f55a4815481c = {
    ar: `\u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631} \u{627}\u{644}\u{62D}\u{628}\u{631} \u{627}\u{644}\u{631}\u{637}\u{628}`,
    de: `Nass-Tinte deaktivieren`,
    es: `Desseleccionar tinta h\xfameda`,
    fa: `\u{644}\u{63A}\u{648} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{62C}\u{648}\u{647}\u{631} \u{645}\u{631}\u{637}\u{648}\u{628}`,
    fil: `I-deselect ang wet ink`,
    fr: `D\xe9s\xe9lectionner l\u{2019}encre humide`,
    hi: `\u{917}\u{940}\u{932}\u{940} \u{938}\u{94D}\u{92F}\u{93E}\u{939}\u{940} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{930}\u{926}\u{94D}\u{926} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Deselect lank mouye`,
    it: `Deseleziona l'inchiostro umido`,
    ja: `\u{30A6}\u{30A7}\u{30C3}\u{30C8}\u{30A4}\u{30F3}\u{30AF}\u{306E}\u{9078}\u{629E}\u{89E3}\u{9664}`,
    ko: `\u{C816}\u{C740} \u{C789}\u{D06C} \u{C120}\u{D0DD} \u{D574}\u{C81C}`,
    mww: `Deselect tus cwj mem ntub`,
    ps: `\u{62F} \u{644}\u{648}\u{646}\u{62F} \u{631}\u{646}\u{6AB} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{644}\u{63A}\u{648}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Desselecionar tinta \xfamida`,
    'pt-pt': `Desselecionar tinta h\xfamida`,
    ru: `\u{41E}\u{442}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{432}\u{44B}\u{431}\u{43E}\u{440} \u{432}\u{43B}\u{430}\u{436}\u{43D}\u{44B}\u{445} \u{447}\u{435}\u{440}\u{43D}\u{438}\u{43B}`,
    sm: `Aveese le filifilia o le vaitusi susu`,
    so: `Ka saar doorashada khad qoyan`,
    th: `\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E01}\u{E32}\u{E23}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E2B}\u{E21}\u{E36}\u{E01}\u{E40}\u{E1B}\u{E35}\u{E22}\u{E01}`,
    ur: `\u{6AF}\u{6CC}\u{644}\u{6CC} \u{633}\u{6CC}\u{627}\u{6C1}\u{6CC} \u{6A9}\u{648} \u{63A}\u{6CC}\u{631} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `B\u{1ECF} ch\u{1ECD}n m\u{1EF1}c \u{1B0}\u{1EDB}t`,
    'zh-hans': `\u{53D6}\u{6D88}\u{9009}\u{62E9}\u{6E7F}\u{58A8}\u{6C34}`,
    'zh-hant': `\u{53D6}\u{6D88}\u{9078}\u{64C7}\u{6FD5}\u{58A8}\u{6C34}`,
    en: `Deselect wet ink`
};
const $b11db1b62d4a8f76$export$55830664ab17444 = {
    ar: `\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644}`,
    de: `Details`,
    es: `Detalles`,
    fa: `\u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A}`,
    fil: `Mga Detalye`,
    fr: `D\xe9tails`,
    hi: `\u{935}\u{93F}\u{935}\u{930}\u{923}`,
    ht: `Detay`,
    it: `Dettagli`,
    ja: `\u{8A73}\u{7D30}`,
    ko: `\u{C138}\u{BD80} \u{C0AC}\u{D56D}`,
    mww: `Cov ntsiab lus`,
    ps: `\u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    pt: `Detalhes`,
    'pt-pt': `Detalhes`,
    ru: `\u{41F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Auiliiliga`,
    so: `Faahfaahin`,
    th: `\u{E23}\u{E32}\u{E22}\u{E25}\u{E30}\u{E40}\u{E2D}\u{E35}\u{E22}\u{E14}`,
    ur: `\u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    vi: `Th\xf4ng tin chi ti\u{1EBF}t`,
    'zh-hans': `\u{8BE6}\u{60C5}`,
    'zh-hant': `\u{8A73}\u{60C5}`,
    en: `Details`
};
const $b11db1b62d4a8f76$export$601313e6ac7ce64c = {
    ar: `\u{647}\u{644} \u{643}\u{646}\u{62A} \u{62A}\u{639}\u{644}\u{645} \u{623}\u{646}\u{647} \u{64A}\u{645}\u{643}\u{646}\u{643} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} Cumulus \u{644}\u{628}\u{631}\u{627}\u{645}\u{62C} \u{623}\u{62E}\u{631}\u{649}\u{61F}`,
    de: `Wusstest du, dass man Cumulus f\xfcr andere Programme nutzen kann?`,
    es: `\xbfSab\xedas que puedes usar Cumulus para otros programas?`,
    fa: `\u{622}\u{6CC}\u{627} \u{645}\u{6CC} \u{62F}\u{627}\u{646}\u{633}\u{62A}\u{6CC}\u{62F} \u{6A9}\u{647} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{6CC}\u{62F} \u{627}\u{632} Cumulus \u{628}\u{631}\u{627}\u{6CC} \u{628}\u{631}\u{646}\u{627}\u{645}\u{647} \u{647}\u{627}\u{6CC} \u{62F}\u{6CC}\u{6AF}\u{631} \u{647}\u{645} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}\u{61F}`,
    fil: `Alam mo ba na maaari mong gamitin ang Cumulus para sa iba pang mga programa?`,
    fr: `Saviez-vous que vous pouvez utiliser Cumulus pour d\u{2019}autres programmes ?`,
    hi: `\u{915}\u{94D}\u{92F}\u{93E} \u{906}\u{92A} \u{91C}\u{93E}\u{928}\u{924}\u{947} \u{939}\u{948}\u{902} \u{915}\u{93F} \u{906}\u{92A} \u{905}\u{928}\u{94D}\u{92F} \u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{915}\u{94D}\u{930}\u{92E}\u{94B}\u{902} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{94D}\u{92F}\u{932}\u{938} \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930} \u{938}\u{915}\u{924}\u{947} \u{939}\u{948}\u{902}?`,
    ht: `\xc8ske w te konnen ou ka itilize Cumulus pou l\xf2t pwogram?`,
    it: `Sapevi che puoi usare Cumulus per altri programmi?`,
    ja: `Cumulus\u{306F}\u{4ED6}\u{306E}\u{30D7}\u{30ED}\u{30B0}\u{30E9}\u{30E0}\u{3067}\u{3082}\u{4F7F}\u{3048}\u{308B}\u{3063}\u{3066}\u{77E5}\u{3063}\u{3066}\u{305F}?`,
    ko: `Cumulus\u{B97C} \u{B2E4}\u{B978} \u{D504}\u{B85C}\u{ADF8}\u{B7A8}\u{C5D0}\u{B3C4} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C788}\u{B2E4}\u{B294} \u{C0AC}\u{C2E4} \u{C54C}\u{ACE0} \u{ACC4}\u{C168}\u{B098}\u{C694}?`,
    mww: `Koj puas paub tias koj tuaj yeem siv Cumulus rau lwm cov kev pab cuam?`,
    ps: `\u{62A}\u{647} \u{67E}\u{648}\u{647}\u{6D0}\u{62F}\u{6D0} \u{686}\u{6D0} Cumulus \u{62A}\u{647} \u{62F} \u{646}\u{648}\u{631}\u{648} \u{67E}\u{631}\u{648}\u{6AB}\u{631}\u{627}\u{645}\u{648}\u{646}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{647}\u{645} \u{6A9}\u{627}\u{631}\u{648}\u{644} \u{6A9}\u{6D0}\u{62F}\u{627}\u{6CC} \u{634}\u{6CC}\u{61F}`,
    pt: `Voc\xea sabia que pode usar o Cumulus para outros programas?`,
    'pt-pt': `Sabias que podes usar o Cumulus para outros programas?`,
    ru: `\u{417}\u{43D}\u{430}\u{435}\u{442}\u{435} \u{43B}\u{438} \u{432}\u{44B}, \u{447}\u{442}\u{43E} Cumulus \u{43C}\u{43E}\u{436}\u{43D}\u{43E} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{438} \u{434}\u{43B}\u{44F} \u{434}\u{440}\u{443}\u{433}\u{438}\u{445} \u{43F}\u{440}\u{43E}\u{433}\u{440}\u{430}\u{43C}\u{43C}?`,
    sm: `Na e iloa e mafai ona e fa'aaogaina le Cumulus mo isi polokalama?`,
    so: `Ma ogtahay inaad Cumulus u isticmaali karto barnaamijyo kale?`,
    th: `\u{E04}\u{E38}\u{E13}\u{E23}\u{E39}\u{E49}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E44}\u{E21}\u{E48}\u{E27}\u{E48}\u{E32}\u{E04}\u{E38}\u{E13}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E43}\u{E0A}\u{E49} Cumulus \u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E42}\u{E1B}\u{E23}\u{E41}\u{E01}\u{E23}\u{E21}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{6A9}\u{6CC}\u{627} \u{622}\u{67E} \u{62C}\u{627}\u{646}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6C1} \u{622}\u{67E} Cumulus \u{6A9}\u{648} \u{62F}\u{648}\u{633}\u{631}\u{6D2} \u{67E}\u{631}\u{648}\u{6AF}\u{631}\u{627}\u{645}\u{632} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{628}\u{6BE}\u{6CC} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631} \u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{61F}`,
    vi: `B\u{1EA1}n c\xf3 bi\u{1EBF}t b\u{1EA1}n c\xf3 th\u{1EC3} s\u{1EED} d\u{1EE5}ng Cumulus cho c\xe1c ch\u{1B0}\u{1A1}ng tr\xecnh kh\xe1c kh\xf4ng?`,
    'zh-hans': `\u{4F60}\u{77E5}\u{9053}Cumulus\u{4E5F}\u{53EF}\u{4EE5}\u{7528}\u{6765}\u{505A}\u{5176}\u{4ED6}\u{9879}\u{76EE}\u{5417}\u{FF1F}`,
    'zh-hant': `\u{4F60}\u{77E5}\u{9053} Cumulus \u{4E5F}\u{53EF}\u{4EE5}\u{7528}\u{4F86}\u{505A}\u{5176}\u{4ED6}\u{7A0B}\u{5F0F}\u{55CE}\u{FF1F}`,
    en: `Did you know you can use Cumulus for other programs?`
};
const $b11db1b62d4a8f76$export$9b48d93bf8321532 = {
    ar: `\u{627}\u{644}\u{645}\u{633}\u{627}\u{641}\u{629}`,
    de: `Entfernung`,
    es: `Distancia`,
    fa: `\u{641}\u{627}\u{635}\u{644}\u{647}`,
    fil: `Distansya`,
    fr: `Distance`,
    hi: `\u{926}\u{942}\u{930}\u{940}`,
    ht: `Distans`,
    it: `Distanza`,
    ja: `\u{8DDD}\u{96E2}`,
    ko: `\u{AC70}\u{B9AC}`,
    mww: `Kev ncua deb`,
    ps: `\u{641}\u{627}\u{635}\u{644}\u{647}`,
    pt: `Dist\xe2ncia`,
    'pt-pt': `Dist\xe2ncia`,
    ru: `\u{420}\u{430}\u{441}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{435}`,
    sm: `Mamao`,
    so: `Masaafada`,
    th: `\u{E23}\u{E30}\u{E22}\u{E30}\u{E17}\u{E32}\u{E07}`,
    ur: `\u{641}\u{627}\u{635}\u{644}\u{6C1}`,
    vi: `Kho\u{1EA3}ng c\xe1ch`,
    'zh-hans': `\u{8DDD}\u{79BB}`,
    'zh-hant': `\u{8DDD}\u{96E2}`,
    en: `Distance`
};
const $b11db1b62d4a8f76$export$52b278509a791a5 = {
    ar: (distance, location)=>`${distance} \u{645}\u{646} ${location}`,
    de: (distance, location)=>`${distance} von ${location} entfernt`,
    es: (distance, location)=>`${distance} desde ${location}`,
    fa: (distance, location)=>`${distance} \u{627}\u{632} ${location} \u{641}\u{627}\u{635}\u{644}\u{647} \u{62F}\u{627}\u{631}\u{62F}`,
    fil: (distance, location)=>`${distance} mula sa ${location}`,
    fr: (distance, location)=>`${distance} depuis ${location}`,
    hi: (distance, location)=>`54 ${location} ${distance} \u{92A}\u{930}`,
    ht: (distance, location)=>`${distance} soti nan ${location}`,
    it: (distance, location)=>`${distance} da ${location}`,
    ja: (distance, location)=>`\u{30D0}\u{30FC}${location}\u{756A}\u{5730}\u{304B}\u{3089}${distance}`,
    ko: (distance, location)=>`12 \u{B2E4}\u{C774}\u{C544}\u{BAAC}\u{B4DC} \u{C2A4}\u{D2B8}\u{B9AC}\u{D2B8}\u{C5D0}\u{C11C} ${distance} \u{B5A8}\u{C5B4}\u{C9C4} \u{C138}${location}`,
    mww: (distance, location)=>`${distance} ntawm ${location}`,
    ps: (distance, location)=>`${distance} \u{644}\u{647} \u{6F1}\u{6F2} ${location} \u{685}\u{62E}\u{647}`,
    pt: (distance, location)=>`${distance} a ${location}`,
    'pt-pt': (distance, location)=>`${distance} a partir do ${location}`,
    ru: (distance, location)=>`${distance} \u{43E}\u{442} ${location}`,
    sm: (distance, location)=>`${distance} mai le ${location}`,
    so: (distance, location)=>`${distance} laga bilaabo ${location}`,
    th: (distance, location)=>`${distance} \u{E08}\u{E32}\u{E01} ${location}`,
    ur: (distance, location)=>`${location} \u{633}\u{6D2} ${distance} \u{62F}\u{648}\u{631}`,
    vi: (distance, location)=>`C\xe1ch ${location} ${distance}`,
    'zh-hans': (distance, location)=>`\u{8DDD}\u{79BB}${location}\u{53F7}${distance}`,
    'zh-hant': (distance, location)=>`\u{8DDD}\u{96E2}${location}\u{865F}${distance}`,
    en: (distance, location)=>`${distance} from ${location}`
};
const $b11db1b62d4a8f76$export$ad71bb6288618a96 = {
    ar: (distance)=>`${distance} \u{623}\u{645}\u{64A}\u{627}\u{644} \u{645}\u{646} \u{645}\u{648}\u{642}\u{639}\u{643}`,
    de: (distance)=>`${distance} Meilen von Ihrem Standort entfernt`,
    es: (distance)=>`${distance} millas de tu ubicaci\xf3n`,
    fa: (distance)=>`${distance} \u{645}\u{627}\u{6CC}\u{644} \u{627}\u{632} \u{645}\u{62D}\u{644} \u{634}\u{645}\u{627} \u{641}\u{627}\u{635}\u{644}\u{647} \u{62F}\u{627}\u{631}\u{62F}`,
    fil: (distance)=>`${distance} km mula sa iyong lokasyon`,
    fr: (distance)=>`${distance} miles de votre position`,
    hi: (distance)=>`\u{906}\u{92A}\u{915}\u{947} \u{938}\u{94D}\u{925}\u{93E}\u{928} \u{938}\u{947} ${distance} \u{92E}\u{940}\u{932} \u{915}\u{940} \u{926}\u{942}\u{930}\u{940} \u{92A}\u{930}`,
    ht: (distance)=>`${distance} mil soti nan kote ou ye`,
    it: (distance)=>`${distance} miglia dalla tua posizione`,
    ja: (distance)=>`\u{3042}\u{306A}\u{305F}\u{306E}\u{5834}\u{6240}\u{304B}\u{3089}${distance}\u{30DE}\u{30A4}\u{30EB}`,
    ko: (distance)=>`\u{B2F9}\u{C2E0} \u{C704}\u{CE58}\u{C5D0}\u{C11C} ${distance}\u{B9C8}\u{C77C} \u{B5A8}\u{C5B4}\u{C838} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: (distance)=>`${distance} mais ntawm koj qhov chaw nyob`,
    ps: (distance)=>`\u{633}\u{62A}\u{627}\u{633}\u{648} \u{644}\u{647} \u{681}\u{627}\u{6CC}\u{647} ${distance} \u{645}\u{6CC}\u{644} \u{644}\u{631}\u{6D0}`,
    pt: (distance)=>`${distance} milhas da sua localiza\xe7\xe3o`,
    'pt-pt': (distance)=>`${distance} milhas da sua localiza\xe7\xe3o`,
    ru: (distance)=>`${distance} \u{43C}\u{438}\u{43B}\u{44C} \u{43E}\u{442} \u{432}\u{430}\u{448}\u{435}\u{433}\u{43E} \u{43C}\u{435}\u{441}\u{442}\u{430}`,
    sm: (distance)=>`${distance} maila mai lou nofoaga`,
    so: (distance)=>`${distance} mayl ka fog meesha aad joogtay`,
    th: (distance)=>`${distance} \u{E01}\u{E21}. \u{E08}\u{E32}\u{E01}\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: (distance)=>`\u{622}\u{67E} \u{6A9}\u{6D2} \u{645}\u{642}\u{627}\u{645} \u{633}\u{6D2} ${distance} \u{645}\u{6CC}\u{644} \u{62F}\u{648}\u{631}`,
    vi: (distance)=>`${distance} d\u{1EB7}m t\u{1EEB} v\u{1ECB} tr\xed c\u{1EE7}a b\u{1EA1}n`,
    'zh-hans': (distance)=>`\u{8DDD}\u{79BB}\u{4F60}\u{6240}\u{5728}\u{5730}${distance}\u{82F1}\u{91CC}`,
    'zh-hant': (distance)=>`\u{8DDD}\u{96E2}\u{4F60}\u{6240}\u{5728}\u{5730}${distance}\u{82F1}\u{91CC}`,
    en: (distance)=>`${distance} miles from your location`
};
const $b11db1b62d4a8f76$export$45aff9897ef243bc = {
    ar: `\u{627}\u{644}\u{645}\u{646}\u{637}\u{642}\u{629}`,
    de: `Bezirk`,
    es: `Distrito`,
    fa: `\u{62D}\u{648}\u{632}\u{647} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}\u{6CC}\u{647}`,
    fil: `Distrito`,
    fr: `Circonscription`,
    hi: `\u{91C}\u{93F}\u{932}\u{93E}`,
    ht: `Distri a`,
    it: `Distretto`,
    ja: `\u{5730}\u{533A}`,
    ko: `\u{C9C0}\u{AD6C}`,
    mww: `Cheeb Tsam Tsev Kawm`,
    ps: `\u{648}\u{644}\u{633}\u{648}\u{627}\u{644}\u{6CD}`,
    pt: `Distrito`,
    'pt-pt': `Distrito`,
    ru: `\u{41E}\u{43A}\u{440}\u{443}\u{433}`,
    sm: `Itumalo`,
    so: `Degmada`,
    th: `\u{E40}\u{E02}\u{E15}`,
    ur: `\u{636}\u{644}\u{639}`,
    vi: `Qu\u{1EAD}n`,
    'zh-hans': `\u{533A}`,
    'zh-hant': `\u{9078}\u{5340}`,
    en: `District`
};
const $b11db1b62d4a8f76$export$4277e4cc1c707d62 = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{645}\u{64A}\u{644}\u{627}\u{62F}`,
    de: `Geburtstag`,
    es: `DATA de nacimiento`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{62A}\u{648}\u{644}\u{62F}`,
    fil: `Tangga ng Batas`,
    fr: `Date de naissance`,
    hi: `\u{91C}\u{928}\u{94D}\u{92E} \u{924}\u{93F}\u{925}\u{93F}`,
    ht: `KOTE`,
    it: `Data di nascita`,
    ja: `\u{751F}\u{5E74}\u{6708}\u{65E5}`,
    ko: `\u{C0DD}\u{B144}\u{C6D4}\u{C77C}`,
    mww: `hnub yug`,
    ps: `\u{62F} \u{632}\u{6CC}\u{696}\u{648}\u{646} \u{648}\u{62E}\u{62A}`,
    pt: `Data de nascimento`,
    'pt-pt': `Data de nascimento`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{440}\u{43E}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Aso o le Fanau`,
    so: `Dhalasho`,
    th: `\u{E27}\u{E31}\u{E19}\u{E40}\u{E01}\u{E34}\u{E14}`,
    ur: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{67E}\u{6CC}\u{62F}\u{627}\u{626}\u{634}:`,
    vi: `Ng\xe0y sinh`,
    'zh-hans': `\u{51FA}\u{751F}\u{65E5}\u{671F}`,
    'zh-hant': `\u{51FA}\u{751F}\u{65E5}\u{671F}`,
    en: `DOB`
};
const $b11db1b62d4a8f76$export$ce92d729d899b6b1 = {
    ar: `\u{648}\u{62B}\u{627}\u{626}\u{642}`,
    de: `Docs`,
    es: `Docs`,
    fa: `\u{645}\u{633}\u{62A}\u{646}\u{62F}\u{627}\u{62A}`,
    fil: `Mga Dokumento`,
    fr: `Docs`,
    hi: `\u{921}\u{949}\u{915}\u{94D}\u{938}`,
    ht: `Dokiman yo`,
    it: `Documentazione`,
    ja: `\u{30C9}\u{30AD}\u{30E5}\u{30E1}\u{30F3}\u{30BF}\u{30EA}\u{30FC}`,
    ko: `\u{BB38}\u{C11C}`,
    mww: `Cov ntaub ntawv`,
    ps: `\u{627}\u{633}\u{646}\u{627}\u{62F}`,
    pt: `Docs`,
    'pt-pt': `Docs`,
    ru: `\u{414}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{44B}`,
    sm: `Docs`,
    so: `Dukumentiyada`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}`,
    ur: `\u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632}\u{627}\u{62A}`,
    vi: `T\xe0i li\u{1EC7}u`,
    'zh-hans': `\u{6587}\u{6863}`,
    'zh-hant': `\u{6587}\u{4EF6}`,
    en: `Docs`
};
const $b11db1b62d4a8f76$export$9b5acd9f7aa56838 = {
    ar: `\u{627}\u{644}\u{648}\u{62B}\u{627}\u{626}\u{642}`,
    de: `Dokumentation`,
    es: `Documentaci\xf3n`,
    fa: `\u{645}\u{633}\u{62A}\u{646}\u{62F}\u{627}\u{62A}`,
    fil: `Dokumentasyon`,
    fr: `Documentation`,
    hi: `\u{92A}\u{94D}\u{930}\u{932}\u{947}\u{916}\u{928}`,
    ht: `Dokimantasyon`,
    it: `Documentazione`,
    ja: `\u{6587}\u{66F8}`,
    ko: `\u{BB38}\u{C11C}`,
    mww: `Cov ntaub ntawv`,
    ps: `\u{627}\u{633}\u{646}\u{627}\u{62F}`,
    pt: `Documenta\xe7\xe3o`,
    'pt-pt': `Documenta\xe7\xe3o`,
    ru: `\u{414}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Fa'amaumauga`,
    so: `Dukumentiyada`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E01}\u{E2D}\u{E1A}`,
    ur: `\u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632}\u{627}\u{62A}`,
    vi: `T\xe0i li\u{1EC7}u`,
    'zh-hans': `\u{6587}\u{732E}\u{8D44}\u{6599}`,
    'zh-hant': `\u{6587}\u{4EF6}`,
    en: `Documentation`
};
const $b11db1b62d4a8f76$export$b011bc40a80b195d = {
    ar: `\u{644}\u{645} \u{64A}\u{639}\u{62F} \u{647}\u{630}\u{627} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{646}\u{62F} \u{645}\u{648}\u{62C}\u{648}\u{62F}\u{627}.`,
    de: `Das Dokument existiert nicht mehr.`,
    es: `El documento ya no existe.`,
    fa: `\u{627}\u{6CC}\u{646} \u{633}\u{646}\u{62F} \u{62F}\u{6CC}\u{6AF}\u{631} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `Hindi na umiiral ang dokumento.`,
    fr: `Le document n\u{2019}existe plus.`,
    hi: `\u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C} \u{905}\u{92C} \u{92E}\u{94C}\u{91C}\u{942}\u{926} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}.`,
    ht: `Dokiman an pa egziste ank\xf2.`,
    it: `Il documento non esiste pi\xf9.`,
    ja: `\u{305D}\u{306E}\u{6587}\u{66F8}\u{306F}\u{3082}\u{306F}\u{3084}\u{5B58}\u{5728}\u{3057}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774} \u{BB38}\u{C11C}\u{B294} \u{B354} \u{C774}\u{C0C1} \u{C874}\u{C7AC}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Daim ntawv tsis muaj lawm.`,
    ps: `\u{633}\u{646}\u{62F} \u{646}\u{648}\u{631} \u{646}\u{634}\u{62A}\u{647}.`,
    pt: `O documento n\xe3o existe mais.`,
    'pt-pt': `O documento j\xe1 n\xe3o existe.`,
    ru: `\u{42D}\u{442}\u{43E}\u{442} \u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{43D}\u{435} \u{441}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442}.`,
    sm: `E le o toe i ai le pepa.`,
    so: `Dukumentigu hadda ma jiro.`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E2D}\u{E35}\u{E01}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}`,
    ur: `\u{6CC}\u{6C1} \u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632} \u{627}\u{628} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `T\xe0i li\u{1EC7}u kh\xf4ng c\xf2n t\u{1ED3}n t\u{1EA1}i.`,
    'zh-hans': `\u{8BE5}\u{6587}\u{4EF6}\u{73B0}\u{5DF2}\u{4E0D}\u{590D}\u{5B58}\u{5728}\u{3002}`,
    'zh-hant': `\u{8A72}\u{6587}\u{4EF6}\u{5DF2}\u{4E0D}\u{5FA9}\u{5B58}\u{5728}\u{3002}`,
    en: `The document no longer exists.`
};
const $b11db1b62d4a8f76$export$79314ffabcde95c5 = {
    ar: `\u{63A}\u{64A}\u{631} \u{642}\u{627}\u{62F}\u{631} \u{639}\u{644}\u{649} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{649} \u{648}\u{62B}\u{64A}\u{642}\u{629}`,
    de: `Dokument nicht gefunden`,
    es: `No se puede encontrar el documento`,
    fa: `\u{6CC}\u{627}\u{641}\u{62A}\u{646} \u{633}\u{646}\u{62F} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Hindi mahanap ang dokumento`,
    fr: `Impossible de trouver le document`,
    hi: `\u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C} \u{922}\u{942}\u{901}\u{922}\u{928}\u{947} \u{92E}\u{947}\u{902} \u{905}\u{938}\u{92E}\u{930}\u{94D}\u{925}`,
    ht: `Pa kapab jwenn dokiman`,
    it: `Impossibile trovare il documento`,
    ja: `\u{6587}\u{66F8}\u{304C}\u{898B}\u{3064}\u{304B}\u{3089}\u{306A}\u{3044}`,
    ko: `\u{BB38}\u{C11C}\u{B97C} \u{CC3E}\u{C744} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis tuaj yeem nrhiav cov ntaub ntawv`,
    ps: `\u{633}\u{646}\u{62F} \u{646}\u{647} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{6A9}\u{6D0}\u{696}\u{6CC}`,
    pt: `N\xe3o consegui encontrar o documento`,
    'pt-pt': `N\xe3o consigo encontrar documento`,
    ru: `\u{41D}\u{435} \u{443}\u{434}\u{430}\u{451}\u{442}\u{441}\u{44F} \u{43D}\u{430}\u{439}\u{442}\u{438} \u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}`,
    sm: `E le mafai ona maua se pepa o faamatalaga`,
    so: `Lama heli karo dukumenti`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}`,
    ur: `\u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{646}\u{6D2} \u{633}\u{6D2} \u{642}\u{627}\u{635}\u{631}`,
    vi: `Kh\xf4ng th\u{1EC3} t\xecm th\u{1EA5}y t\xe0i li\u{1EC7}u`,
    'zh-hans': `\u{627E}\u{4E0D}\u{5230}\u{6587}\u{6863}`,
    'zh-hant': `\u{627E}\u{4E0D}\u{5230}\u{6587}\u{4EF6}`,
    en: `Unable to find document`
};
const $b11db1b62d4a8f76$export$d4ca19934acb7bf3 = {
    ar: `\u{627}\u{646}\u{62A}\u{647}\u{62A} \u{635}\u{644}\u{627}\u{62D}\u{64A}\u{629} \u{637}\u{644}\u{628} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{646}\u{62F}`,
    de: `Dokumentenanfrage abgelaufen`,
    es: `Solicitud de documento expirada`,
    fa: `\u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{633}\u{646}\u{62F} \u{645}\u{646}\u{642}\u{636}\u{6CC} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Nag-expire na ang kahilingan sa dokumento`,
    fr: `Demande de document expir\xe9e`,
    hi: `\u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927} \u{915}\u{940} \u{938}\u{92E}\u{92F} \u{938}\u{940}\u{92E}\u{93E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{917}\u{908}`,
    ht: `Demann dokiman ekspire`,
    it: `Richiesta di documento scaduta`,
    ja: `\u{66F8}\u{985E}\u{8ACB}\u{6C42}\u{304C}\u{671F}\u{9650}\u{5207}\u{308C}\u{3068}\u{306A}\u{308A}\u{307E}\u{3057}\u{305F}`,
    ko: `\u{BB38}\u{C11C} \u{C694}\u{CCAD} \u{B9CC}\u{B8CC}`,
    mww: `Daim ntawv thov tas sij hawm`,
    ps: `\u{62F} \u{633}\u{646}\u{62F} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{647} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{631}\u{633}\u{6D0}\u{62F}\u{644}\u{6D0}`,
    pt: `Solicita\xe7\xe3o de documento expirada`,
    'pt-pt': `Pedido de documento expirado`,
    ru: `\u{417}\u{430}\u{43F}\u{440}\u{43E}\u{441} \u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432} \u{438}\u{441}\u{442}\u{451}\u{43A}`,
    sm: `Ua uma le aoga o le talosaga mo pepa o faamatalaga`,
    so: `Codsiga dukumentiga wuu dhacay`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E02}\u{E2D}\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38}`,
    ur: `\u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{6A9}\u{6CC} \u{645}\u{6CC}\u{639}\u{627}\u{62F} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{6AF}\u{626}\u{6CC}`,
    vi: `Y\xeau c\u{1EA7}u t\xe0i li\u{1EC7}u \u{111}\xe3 h\u{1EBF}t h\u{1EA1}n`,
    'zh-hans': `\u{6587}\u{4EF6}\u{8BF7}\u{6C42}\u{5DF2}\u{8FC7}\u{671F}`,
    'zh-hant': `\u{6587}\u{4EF6}\u{7533}\u{8ACB}\u{5DF2}\u{904E}\u{671F}`,
    en: `Document request expired`
};
const $b11db1b62d4a8f76$export$3f68c37b8e9a0a78 = {
    ar: (when)=>$b11db1b62d4a8f76$var$html`<p>انتهى هذا الطلب لإكمال المستند ${when}.</p>`,
    de: (when)=>$b11db1b62d4a8f76$var$html`<p>Diese Anfrage, das Dokument auszufüllen, ist ${when} abgelaufen.</p>`,
    es: (when)=>$b11db1b62d4a8f76$var$html`<p>Esta solicitud para completar el documento ${when}.</p>`,
    fa: (when)=>$b11db1b62d4a8f76$var$html`<p>این درخواست برای تکمیل سند ${when} منقضی شده است.</p>`,
    fil: (when)=>$b11db1b62d4a8f76$var$html`<p>Ang kahilingan na ito na kumpletuhin ang dokumento ay nag-expire ${when}.</p>`,
    fr: (when)=>$b11db1b62d4a8f76$var$html`<p>Cette demande de complétion du document a ${when}.</p>`,
    hi: (when)=>$b11db1b62d4a8f76$var$html`<p>दस्तावेज़ को पूरा करने के लिए यह अनुरोध ${when} समाप्त हो गया था।</p>`,
    ht: (when)=>$b11db1b62d4a8f76$var$html`<p>Demann sa a pou ranpli dokiman an ekspire ${when}</p>`,
    it: (when)=>$b11db1b62d4a8f76$var$html`<p>Questa richiesta di completare il documento è ${when}.</p>`,
    ja: (when)=>$b11db1b62d4a8f76$var$html`<p>この書類の完成要求は ${when}期限切れとなりました。</p>`,
    ko: (when)=>$b11db1b62d4a8f76$var$html`<p>이 문서 작성 요청은 ${when} 만료되었습니다.</p>`,
    mww: (when)=>$b11db1b62d4a8f76$var$html`<p>Qhov kev thov no kom ua tiav cov ntaub ntawv tas sij hawm ${when}.</p>`,
    ps: (when)=>$b11db1b62d4a8f76$var$html`<p>دا غوښتنه د سند بشپړولو لپاره ۴ ${when} پای ته رسېدلې.</p>`,
    pt: (when)=>$b11db1b62d4a8f76$var$html`<p>Esse pedido para completar o documento expirou ${when}.</p>`,
    'pt-pt': (when)=>$b11db1b62d4a8f76$var$html`<p>Este pedido para completar o documento ${when}.</p>`,
    ru: (when)=>$b11db1b62d4a8f76$var$html`<p>Этот запрос на заполнение документа истёк ${when}.</p>`,
    sm: (when)=>$b11db1b62d4a8f76$var$html`<p>O lenei talosaga e fa'amae'a ai le pepa na mae'a i le ${when}.</p>`,
    so: (when)=>$b11db1b62d4a8f76$var$html`<p>Codsigan dhameystirka dukumentiga wuxuu dhacay ${when}.</p>`,
    th: (when)=>$b11db1b62d4a8f76$var$html`<p>คําขอให้กรอกเอกสารนี้หมดอายุเมื่อ ${when}</p>`,
    ur: (when)=>$b11db1b62d4a8f76$var$html`<p>دستاویز مکمل کرنے کی یہ درخواست ${when} ختم ہو چکی ہے۔</p>`,
    vi: (when)=>$b11db1b62d4a8f76$var$html`<p>Yêu cầu hoàn thành tài liệu này đã hết hạn ${when}.</p>`,
    'zh-hans': (when)=>$b11db1b62d4a8f76$var$html`<p>填写文件的请求在 ${when}已过期。</p>`,
    'zh-hant': (when)=>$b11db1b62d4a8f76$var$html`<p>這個填寫文件的請求在 ${when}就過期了。</p>`,
    en: (when)=>$b11db1b62d4a8f76$var$html`<p>This request to complete the document expired ${when}.</p>`
};
const $b11db1b62d4a8f76$export$782f782fd64eafa0 = {
    ar: `\u{627}\u{644}\u{648}\u{62B}\u{627}\u{626}\u{642}`,
    de: `Dokumente`,
    es: `Documentos`,
    fa: `\u{627}\u{633}\u{646}\u{627}\u{62F}`,
    fil: `Mga Dokumento`,
    fr: `Documents`,
    hi: `\u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C}`,
    ht: `Dokiman yo`,
    it: `Documenti`,
    ja: `\u{6587}\u{66F8}`,
    ko: `\u{BB38}\u{C11C}`,
    mww: `Cov ntaub ntawv`,
    ps: `\u{627}\u{633}\u{646}\u{627}\u{62F}`,
    pt: `Documentos`,
    'pt-pt': `Documentos`,
    ru: `\u{414}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{44B}`,
    sm: `Pepa aloaia`,
    so: `Dukumentiyada`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}`,
    ur: `\u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632}\u{627}\u{62A}`,
    vi: `T\xe0i li\u{1EC7}u`,
    'zh-hans': `\u{6587}\u{732E}`,
    'zh-hant': `\u{6587}\u{4EF6}`,
    en: `Documents`
};
const $b11db1b62d4a8f76$export$c04ceb9143b0afba = {
    ar: `\u{627}\u{644}\u{645}\u{633}\u{62A}\u{646}\u{62F} \u{627}\u{644}\u{645}\u{642}\u{62F}\u{645}`,
    de: `Dokument eingereicht`,
    es: `Documento presentado`,
    fa: `\u{633}\u{646}\u{62F} \u{627}\u{631}\u{633}\u{627}\u{644} \u{634}\u{62F}\u{647}`,
    fil: `Dokumento na isinumite`,
    fr: `Document soumis`,
    hi: `\u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C} \u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Dokiman ki soum\xe8t`,
    it: `Documento inviato`,
    ja: `\u{63D0}\u{51FA}\u{3055}\u{308C}\u{305F}\u{66F8}\u{985E}`,
    ko: `\u{C81C}\u{CD9C}\u{B41C} \u{BB38}\u{C11C}`,
    mww: `Cov ntaub ntawv xa tuaj`,
    ps: `\u{633}\u{646}\u{62F} \u{633}\u{67E}\u{627}\u{631}\u{644} \u{634}\u{648}\u{6CC}`,
    pt: `Documento submetido`,
    'pt-pt': `Documento submetido`,
    ru: `\u{414}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}`,
    sm: `Pepa na tuuina atu`,
    so: `Dukumenti la gudbiyay`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E48}\u{E07}`,
    ur: `\u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{627}\u{626}\u{6CC} \u{6AF}\u{626}\u{6CC}`,
    vi: `T\xe0i li\u{1EC7}u \u{111}\xe3 n\u{1ED9}p`,
    'zh-hans': `\u{63D0}\u{4EA4}\u{7684}\u{6587}\u{4EF6}`,
    'zh-hant': `\u{63D0}\u{4EA4}\u{6587}\u{4EF6}`,
    en: `Document submitted`
};
const $b11db1b62d4a8f76$export$6c5051f57328b480 = {
    ar: `\u{62A}\u{645}`,
    de: `Fertig`,
    es: `Hecho`,
    fa: `\u{627}\u{646}\u{62C}\u{627}\u{645} \u{634}\u{62F}`,
    fil: `Tapos na`,
    fr: `March\xe9 conclu`,
    hi: `\u{939}\u{94B} \u{917}\u{92F}\u{93E}`,
    ht: `F\xe8`,
    it: `Fatto`,
    ja: `\u{7D42}\u{308F}\u{3063}\u{305F}`,
    ko: `\u{B05D}\u{B0AC}\u{C5B4}`,
    mww: `Ua tiav lawm`,
    ps: `\u{62E}\u{644}\u{627}\u{635} \u{634}\u{648}`,
    pt: `Feito`,
    'pt-pt': `Feito`,
    ru: `\u{413}\u{43E}\u{442}\u{43E}\u{432}\u{43E}`,
    sm: `Ua mae'a`,
    so: `Waa la qabtay`,
    th: `\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{6C1}\u{648} \u{6AF}\u{6CC}\u{627}`,
    vi: `Xong`,
    'zh-hans': `\u{5B8C}\u{6210}`,
    'zh-hant': `\u{5B8C}\u{6210}`,
    en: `Done`
};
const $b11db1b62d4a8f76$export$221f6232852822e8 = {
    ar: `\u{627}\u{644}\u{62C}\u{631}\u{639}\u{629} \u{648}\u{627}\u{644}\u{62A}\u{643}\u{631}\u{627}\u{631}`,
    de: `Dosis und H\xe4ufigkeit`,
    es: `Dosis y frecuencia`,
    fa: `\u{62F}\u{648}\u{632} \u{648} \u{641}\u{631}\u{627}\u{648}\u{627}\u{646}\u{6CC}`,
    fil: `Dosis at dalas`,
    fr: `Dose et fr\xe9quence`,
    hi: `\u{916}\u{941}\u{930}\u{93E}\u{915} \u{914}\u{930} \u{906}\u{935}\u{943}\u{924}\u{94D}\u{924}\u{93F}`,
    ht: `D\xf2z & frekans`,
    it: `Dose e frequenza`,
    ja: `\u{6295}\u{4E0E}\u{91CF}\u{3068}\u{983B}\u{5EA6}`,
    ko: `\u{C6A9}\u{B7C9} \u{BC0F} \u{BE48}\u{B3C4}`,
    mww: `Koob tshuaj & zaus`,
    ps: `\u{62F}\u{648}\u{632} \u{627}\u{648} \u{641}\u{631}\u{6CC}\u{6A9}\u{648}\u{646}\u{633}\u{6CC}`,
    pt: `Dose e frequ\xeancia`,
    'pt-pt': `Dose e frequ\xeancia`,
    ru: `\u{414}\u{43E}\u{437}\u{430} \u{438} \u{447}\u{430}\u{441}\u{442}\u{43E}\u{442}\u{430}`,
    sm: `Dose ma taimi`,
    so: `Qiyaasta iyo soo noqnoqoshada`,
    th: `\u{E1B}\u{E23}\u{E34}\u{E21}\u{E32}\u{E13}\u{E41}\u{E25}\u{E30}\u{E04}\u{E27}\u{E32}\u{E21}\u{E16}\u{E35}\u{E48}`,
    ur: `\u{62E}\u{648}\u{631}\u{627}\u{6A9} \u{627}\u{648}\u{631} \u{62A}\u{639}\u{62F}\u{62F}`,
    vi: `Li\u{1EC1}u l\u{1B0}\u{1EE3}ng v\xe0 t\u{1EA7}n su\u{1EA5}t`,
    'zh-hans': `\u{5242}\u{91CF}\u{4E0E}\u{9891}\u{7387}`,
    'zh-hant': `\u{5291}\u{91CF}\u{8207}\u{983B}\u{7387}`,
    en: `Dose & frequency`
};
const $b11db1b62d4a8f76$export$8a371d5eac4e99f8 = {
    ar: `\u{62A}\u{62D}\u{645}\u{64A}\u{644}`,
    de: `Download`,
    es: `Descargar`,
    fa: `\u{62F}\u{627}\u{646}\u{644}\u{648}\u{62F}`,
    fil: `I-download`,
    fr: `T\xe9l\xe9charger`,
    hi: `\u{921}\u{93E}\u{909}\u{928}\u{932}\u{94B}\u{921}`,
    ht: `Rale dosye`,
    it: `Scarica`,
    ja: `\u{30C0}\u{30A6}\u{30F3}\u{30ED}\u{30FC}\u{30C9}`,
    ko: `\u{B2E4}\u{C6B4}\u{B85C}\u{B4DC}`,
    mww: `Download tau`,
    ps: `\u{689}\u{627}\u{648}\u{646}\u{644}\u{648}\u{689}`,
    pt: `Baixar`,
    'pt-pt': `Descarregar`,
    ru: `\u{421}\u{43A}\u{430}\u{447}\u{430}\u{442}\u{44C}`,
    sm: `Sii mai`,
    so: `Soo dejiso`,
    th: `\u{E14}\u{E32}\u{E27}\u{E19}\u{E4C}\u{E42}\u{E2B}\u{E25}\u{E14}`,
    ur: `\u{688}\u{627}\u{624}\u{646} \u{644}\u{648}\u{688} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA3}i v\u{1EC1}`,
    'zh-hans': `\u{4E0B}\u{8F7D}`,
    'zh-hant': `\u{4E0B}\u{8F09}`,
    en: `Download`
};
const $b11db1b62d4a8f76$export$e00cc420d819de60 = {
    ar: `\u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{645}\u{644}\u{641} PDF`,
    de: `PDF herunterladen`,
    es: `Descargar PDF`,
    fa: `\u{62F}\u{627}\u{646}\u{644}\u{648}\u{62F} PDF`,
    fil: `I-download ang PDF`,
    fr: `T\xe9l\xe9charger PDF`,
    hi: `\u{92A}\u{940}\u{921}\u{940}\u{90F}\u{92B} \u{921}\u{93E}\u{909}\u{928}\u{932}\u{94B}\u{921} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Download PDF`,
    it: `Scarica PDF`,
    ja: `PDF\u{3092}\u{30C0}\u{30A6}\u{30F3}\u{30ED}\u{30FC}\u{30C9}`,
    ko: `PDF \u{B2E4}\u{C6B4}\u{B85C}\u{B4DC}`,
    mww: `Rub tawm PDF`,
    ps: `PDF \u{689}\u{627}\u{648}\u{646}\u{644}\u{648}\u{689} \u{6A9}\u{693}\u{626}`,
    pt: `Baixar PDF`,
    'pt-pt': `Descarregar PDF`,
    ru: `\u{421}\u{43A}\u{430}\u{447}\u{430}\u{442}\u{44C} PDF`,
    sm: `Sii mai PDF`,
    so: `Soo dejiso PDF`,
    th: `\u{E14}\u{E32}\u{E27}\u{E19}\u{E4C}\u{E42}\u{E2B}\u{E25}\u{E14}\u{E44}\u{E1F}\u{E25}\u{E4C} PDF`,
    ur: `\u{67E}\u{6CC} \u{688}\u{6CC} \u{627}\u{6CC}\u{641} \u{688}\u{627}\u{624}\u{646} \u{644}\u{648}\u{688} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA3}i PDF`,
    'zh-hans': `\u{4E0B}\u{8F7D}PDF`,
    'zh-hant': `\u{4E0B}\u{8F09} PDF`,
    en: `Download PDF`
};
const $b11db1b62d4a8f76$export$e72884dd57779385 = {
    ar: `\u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{645}\u{644}\u{641} ZIP`,
    de: `ZIP herunterladen`,
    es: `Descargar ZIP`,
    fa: `\u{62F}\u{627}\u{646}\u{644}\u{648}\u{62F} ZIP`,
    fil: `I-download ang ZIP`,
    fr: `T\xe9l\xe9charger ZIP`,
    hi: `\u{921}\u{93E}\u{909}\u{928}\u{932}\u{94B}\u{921} ZIP`,
    ht: `Download ZIP`,
    it: `Scarica ZIP`,
    ja: `ZIP\u{3092}\u{30C0}\u{30A6}\u{30F3}\u{30ED}\u{30FC}\u{30C9}`,
    ko: `ZIP \u{B2E4}\u{C6B4}\u{B85C}\u{B4DC}`,
    mww: `Download ZIP`,
    ps: `ZIP \u{689}\u{627}\u{648}\u{646}\u{644}\u{648}\u{689} \u{6A9}\u{693}\u{626}`,
    pt: `Baixar ZIP`,
    'pt-pt': `Descarregar ZIP`,
    ru: `\u{421}\u{43A}\u{430}\u{447}\u{430}\u{442}\u{44C} ZIP`,
    sm: `Sii mai le ZIP`,
    so: `Soo dejiso ZIP`,
    th: `\u{E14}\u{E32}\u{E27}\u{E19}\u{E4C}\u{E42}\u{E2B}\u{E25}\u{E14} ZIP`,
    ur: `ZIP \u{688}\u{627}\u{624}\u{646} \u{644}\u{648}\u{688} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA3}i xu\u{1ED1}ng ZIP`,
    'zh-hans': `\u{4E0B}\u{8F7D}ZIP`,
    'zh-hant': `\u{4E0B}\u{8F09} ZIP`,
    en: `Download ZIP`
};
const $b11db1b62d4a8f76$export$f3f08f4011de90bf = {
    ar: `\u{627}\u{644}\u{645}\u{633}\u{648}\u{62F}\u{629}`,
    de: `Entwurf`,
    es: `Draft`,
    fa: `\u{62F}\u{631}\u{641}\u{62A}`,
    fil: `Draft`,
    fr: `Rep\xeachage`,
    hi: `\u{921}\u{94D}\u{930}\u{93E}\u{92B}\u{94D}\u{91F}`,
    ht: `Bouyon`,
    it: `Draft`,
    ja: `\u{30C9}\u{30E9}\u{30D5}\u{30C8}`,
    ko: `\u{B4DC}\u{B798}\u{D504}\u{D2B8}`,
    mww: `Draft`,
    ps: `\u{645}\u{633}\u{648}\u{62F}\u{647}`,
    pt: `Draft`,
    'pt-pt': `Draft`,
    ru: `\u{414}\u{440}\u{430}\u{444}\u{442}`,
    sm: `Fa'ata'ita'iga`,
    so: `Qabashada`,
    th: `\u{E41}\u{E1A}\u{E1A}\u{E23}\u{E48}\u{E32}\u{E07}`,
    ur: `\u{688}\u{631}\u{627}\u{641}\u{679}`,
    vi: `B\u{1EA3}n nh\xe1p`,
    'zh-hans': `\u{9009}\u{79C0}`,
    'zh-hant': `\u{9078}\u{79C0}`,
    en: `Draft`
};
const $b11db1b62d4a8f76$export$dfc3117aefd0fe77 = {
    ar: `\u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{644}\u{64A}\u{633} \u{62C}\u{627}\u{647}\u{632}\u{627} \u{628}\u{639}\u{62F} \u{644}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630}.`,
    de: `Die Aktivit\xe4t ist noch nicht bereit, umgesetzt zu werden.`,
    es: `La actividad a\xfan no est\xe1 lista para ser llevada a cabo.`,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{646}\u{648}\u{632} \u{622}\u{645}\u{627}\u{62F}\u{647} \u{627}\u{642}\u{62F}\u{627}\u{645} \u{646}\u{6CC}\u{633}\u{62A}.`,
    fil: `Ang aktibidad ay hindi pa handa na kumilos.`,
    fr: `L\u{2019}activit\xe9 n\u{2019}est pas encore pr\xeate \xe0 \xeatre mise en \u{153}uvre.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{905}\u{92D}\u{940} \u{924}\u{915} \u{915}\u{93E}\u{930}\u{94D}\u{930}\u{935}\u{93E}\u{908} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{924}\u{948}\u{92F}\u{93E}\u{930} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{964}`,
    ht: `Aktivite a poko pare pou yo aji.`,
    it: `L'attivit\xe0 non \xe8 ancora pronta per essere attuata.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306F}\u{307E}\u{3060}\u{884C}\u{52D5}\u{306B}\u{79FB}\u{3059}\u{6E96}\u{5099}\u{304C}\u{3067}\u{304D}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C740} \u{C544}\u{C9C1} \u{D589}\u{B3D9}\u{C5D0} \u{C62E}\u{AE38} \u{C900}\u{BE44}\u{AC00} \u{B418}\u{C5B4} \u{C788}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kev ua haujlwm tseem tsis tau npaj txhij los ua haujlwm.`,
    ps: `\u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{644}\u{627} \u{62A}\u{631} \u{627}\u{648}\u{633}\u{647} \u{62F} \u{639}\u{645}\u{644} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{686}\u{645}\u{62A}\u{648} \u{646}\u{647} \u{62F}\u{6CC}.`,
    pt: `A atividade ainda n\xe3o est\xe1 pronta para ser executada.`,
    'pt-pt': `A atividade ainda n\xe3o est\xe1 pronta para ser executada.`,
    ru: `\u{414}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{435}\u{449}\u{451} \u{43D}\u{435} \u{433}\u{43E}\u{442}\u{43E}\u{432}\u{430} \u{43A} \u{440}\u{435}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}.`,
    sm: `E le'i sauni le gaioiga e faatinoina.`,
    so: `Hawlgu weli diyaar uma aha in la fuliyo.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{627}\u{628}\u{6BE}\u{6CC} \u{62A}\u{6A9} \u{639}\u{645}\u{644}\u{6CC} \u{62C}\u{627}\u{645}\u{6C1} \u{67E}\u{6C1}\u{646}\u{627}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{62A}\u{6CC}\u{627}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y v\u{1EAB}n ch\u{1B0}a s\u{1EB5}n s\xe0ng \u{111}\u{1EC3} th\u{1EF1}c hi\u{1EC7}n.`,
    'zh-hans': `\u{8BE5}\u{6D3B}\u{52A8}\u{5C1A}\u{672A}\u{51C6}\u{5907}\u{597D}\u{91C7}\u{53D6}\u{884C}\u{52A8}\u{3002}`,
    'zh-hant': `\u{9019}\u{9805}\u{6D3B}\u{52D5}\u{5C1A}\u{672A}\u{6E96}\u{5099}\u{597D}\u{4ED8}\u{8AF8}\u{884C}\u{52D5}\u{3002}`,
    en: `The activity is not yet ready to be acted upon.`
};
const $b11db1b62d4a8f76$export$d590014f0ce29ae9 = {
    ar: `\u{627}\u{644}\u{633}\u{62D}\u{628}`,
    de: `Auslosung`,
    es: `Empate`,
    fa: `\u{642}\u{631}\u{639}\u{647} \u{6A9}\u{634}\u{6CC}`,
    fil: `Gumuhit`,
    fr: `Match nul`,
    hi: `\u{906}\u{915}\u{930}\u{94D}\u{937}\u{93F}\u{924}`,
    ht: `Trase`,
    it: `Draw`,
    ja: `\u{5F15}\u{304D}\u{5206}\u{3051}`,
    ko: `\u{B4DC}\u{B85C}\u{C6B0}`,
    mww: `kos duab`,
    ps: `\u{631}\u{633}\u{645} \u{6A9}\u{693}\u{647}`,
    pt: `Sorteio`,
    'pt-pt': `Sorteio`,
    ru: `\u{416}\u{435}\u{440}\u{435}\u{431}\u{44C}\u{451}\u{432}\u{43A}\u{430}`,
    sm: `Ata`,
    so: `Draw`,
    th: `\u{E27}\u{E32}\u{E14}`,
    ur: `\u{688}\u{631}\u{627}`,
    vi: `H\xf2a`,
    'zh-hans': `\u{62BD}\u{7B7E}`,
    'zh-hant': `\u{62BD}\u{7C64}`,
    en: `Draw`
};
const $b11db1b62d4a8f76$export$c8a4223ddf73b309 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{639}\u{62F}`,
    de: `F\xe4llig`,
    es: `Debido`,
    fa: `\u{645}\u{648}\u{639}\u{62F}`,
    fil: `Dahil`,
    fr: `Due`,
    hi: `\u{92C}\u{93F}\u{932}\u{94D}\u{200D}\u{915}\u{941}\u{932}`,
    ht: `Ak\xf2z`,
    it: `Due`,
    ja: `\u{671F}\u{9650}`,
    ko: `\u{AE30}\u{BD84}`,
    mww: `tsim nyog`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{644}\u{647} \u{627}\u{645}\u{644}\u{647}`,
    pt: `Devido`,
    'pt-pt': `Devido`,
    ru: `\u{421}\u{440}\u{43E}\u{43A}`,
    sm: `E tatau ona`,
    so: `Waqtiga`,
    th: `\u{E04}\u{E23}\u{E1A}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}`,
    ur: `\u{688}\u{6CC}\u{648}`,
    vi: `\u{110}\u{1EBF}n h\u{1EA1}n`,
    'zh-hans': `\u{8BE5}`,
    'zh-hant': `\u{8A72}`,
    en: `Due`
};
const $b11db1b62d4a8f76$export$d0810dde2fad6b9a = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{648}\u{644}\u{627}\u{62F}\u{629}`,
    de: `Geburtstermin`,
    es: `Fecha prevista de parto`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{62A}\u{648}\u{644}\u{62F}`,
    fil: `Takdang petsa`,
    fr: `Date d\u{2019}accouchement`,
    hi: `\u{928}\u{93F}\u{92F}\u{924} \u{924}\u{93E}\u{930}\u{940}\u{916}`,
    ht: `Dat limit yo`,
    it: `Data prevista`,
    ja: `\u{51FA}\u{7523}\u{4E88}\u{5B9A}\u{65E5}`,
    ko: `\u{CD9C}\u{C0B0} \u{C608}\u{C815}\u{C77C}`,
    mww: `Hnub kawg`,
    ps: `\u{62F} \u{632}\u{6D0}\u{696}\u{648}\u{646} \u{646}\u{6D0}\u{67C}\u{647}`,
    pt: `Data prevista para o parto`,
    'pt-pt': `Data prevista para o parto`,
    ru: `\u{421}\u{440}\u{43E}\u{43A} \u{440}\u{43E}\u{434}\u{43E}\u{432}`,
    sm: `Aso e faagata ai`,
    so: `Taariikhda dhalashada`,
    th: `\u{E27}\u{E31}\u{E19}\u{E04}\u{E23}\u{E1A}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}`,
    ur: `\u{688}\u{6CC}\u{644}\u{6CC}\u{648}\u{631}\u{6CC} \u{688}\u{6CC}\u{679}`,
    vi: `Ng\xe0y \u{111}\u{1EBF}n h\u{1EA1}n`,
    'zh-hans': `\u{9884}\u{4EA7}\u{671F}`,
    'zh-hant': `\u{9810}\u{7522}\u{671F}`,
    en: `Due date`
};
const $b11db1b62d4a8f76$export$8a23b76271eff460 = {
    ar: (dueDate)=>`\u{645}\u{648}\u{639}\u{62F} \u{635}\u{62F}\u{648}\u{631} ${dueDate}`,
    de: (dueDate)=>`f\xe4llig am ${dueDate}`,
    es: (dueDate)=>`Fecha prevista para ${dueDate}`,
    fa: (dueDate)=>`\u{645}\u{648}\u{639}\u{62F} \u{62A}\u{62D}\u{648}\u{6CC}\u{644} \u{62F}\u{631} ${dueDate}`,
    fil: (dueDate)=>`dahil sa ${dueDate}`,
    fr: (dueDate)=>`Pr\xe9vu pour le ${dueDate}`,
    hi: (dueDate)=>`${dueDate} \u{915}\u{94B} \u{926}\u{947}\u{92F}`,
    ht: (dueDate)=>`ak\xf2z sou ${dueDate}`,
    it: (dueDate)=>`Previsto per il ${dueDate}`,
    ja: (dueDate)=>`\u{63D0}\u{51FA}\u{4E88}\u{5B9A}\u{65E5}\u{306F}${dueDate}\u{3067}\u{3059}`,
    ko: (dueDate)=>`${dueDate}\u{C77C} \u{C81C}\u{CD9C} \u{C608}\u{C815}\u{C77C}`,
    mww: (dueDate)=>`Them rau ${dueDate}`,
    ps: (dueDate)=>`\u{62F} ${dueDate} \u{646}\u{6CC}\u{67C}\u{647}`,
    pt: (dueDate)=>`Previsto para ${dueDate}`,
    'pt-pt': (dueDate)=>`Previsto para ${dueDate}`,
    ru: (dueDate)=>`\u{421}\u{440}\u{43E}\u{43A} \u{43D}\u{430} ${dueDate}`,
    sm: (dueDate)=>`Fa'atatau i le ${dueDate}`,
    so: (dueDate)=>`Waa la filayaa ${dueDate}`,
    th: (dueDate)=>`\u{E04}\u{E23}\u{E1A}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E44}\u{E16}\u{E48}\u{E16}\u{E2D}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48} ${dueDate}`,
    ur: (dueDate)=>`2${dueDate} \u{6A9}\u{648} \u{645}\u{62A}\u{648}\u{642}\u{639}`,
    vi: (dueDate)=>`\u{111}\u{1EBF}n h\u{1EA1}n ${dueDate}`,
    'zh-hans': (dueDate)=>`\u{622A}\u{6B62}\u{65E5}\u{671F}\u{4E3A} ${dueDate}`,
    'zh-hant': (dueDate)=>`\u{622A}\u{6B62}\u{65E5}\u{671F}\u{70BA} ${dueDate}`,
    en: (dueDate)=>`due on ${dueDate}`
};
const $b11db1b62d4a8f76$export$928d05dbe3d6dc8f = {
    ar: `\u{62C}\u{62F}\u{627}\u{648}\u{644} \u{632}\u{645}\u{646}\u{64A}\u{629} \u{633}\u{627}\u{628}\u{642}\u{629}`,
    de: `Fr\xfchere Stundenzettel`,
    es: `Hojas de horas anteriores`,
    fa: `\u{62C}\u{62F}\u{648}\u{644} \u{647}\u{627}\u{6CC} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{642}\u{628}\u{644}\u{6CC}`,
    fil: `Mga naunang timesheet`,
    fr: `Feuilles de temps ant\xe9rieures`,
    hi: `\u{92A}\u{939}\u{932}\u{947} \u{915}\u{940} \u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F}`,
    ht: `Fich tan pi bon\xe8`,
    it: `Fogli orari precedenti`,
    ja: `\u{521D}\u{671F}\u{306E}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}`,
    ko: `\u{C774}\u{C804} \u{D0C0}\u{C784}\u{C2DC}\u{D2B8}`,
    mww: `Cov ntawv teev sijhawm ua ntej`,
    ps: `\u{67E}\u{62E}\u{648}\u{627}\u{646}\u{6CC} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{6D0}`,
    pt: `Folhas de ponto anteriores`,
    'pt-pt': `Folhas de horas anteriores`,
    ru: `\u{420}\u{430}\u{43D}\u{43D}\u{438}\u{435} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{438} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}`,
    sm: `Pepa o taimi muamua`,
    so: `Jadwalka hore`,
    th: `\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{628}\u{62A}\u{62F}\u{627}\u{626}\u{6CC} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679}\u{633}`,
    vi: `B\u{1EA3}ng ch\u{1EA5}m c\xf4ng tr\u{1B0}\u{1EDB}c \u{111}\xf3`,
    'zh-hans': `\u{65E9}\u{671F}\u{8BA1}\u{65F6}\u{8868}`,
    'zh-hant': `\u{65E9}\u{671F}\u{5DE5}\u{6642}\u{8868}`,
    en: `Earlier timesheets`
};
const $b11db1b62d4a8f76$export$68ee5e97498a5881 = {
    ar: `\u{623}\u{642}\u{62F}\u{645} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{646}\u{647}\u{627}\u{64A}\u{629}`,
    de: `Fr\xfchestes Enddatum`,
    es: `Fecha de finalizaci\xf3n m\xe1s temprana`,
    fa: `\u{632}\u{648}\u{62F}\u{62A}\u{631}\u{6CC}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{67E}\u{627}\u{6CC}\u{627}\u{646}`,
    fil: `Pinakamaagang petsa ng pagtatapos`,
    fr: `Date de fin la plus ancienne`,
    hi: `\u{938}\u{92C}\u{938}\u{947} \u{92A}\u{939}\u{932}\u{947} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{924}\u{93F}\u{925}\u{93F}`,
    ht: `Pi bon\xe8 dat fen`,
    it: `Data di fine pi\xf9 antica`,
    ja: `\u{6700}\u{3082}\u{65E9}\u{3044}\u{7D42}\u{4E86}\u{65E5}`,
    ko: `\u{AC00}\u{C7A5} \u{C774}\u{B978} \u{C885}\u{B8CC}\u{C77C}`,
    mww: `Hnub xaus ntxov tshaj plaws`,
    ps: `\u{62A}\u{631} \u{67C}\u{648}\u{644}\u{648} \u{698}\u{631} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{647}`,
    pt: `Data de t\xe9rmino mais antiga`,
    'pt-pt': `Data de fim mais antiga`,
    ru: `\u{421}\u{430}\u{43C}\u{430}\u{44F} \u{440}\u{430}\u{43D}\u{43D}\u{44F}\u{44F} \u{434}\u{430}\u{442}\u{430} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Aso fa'amutaina muamua`,
    so: `Taariikhda ugu horreysa ee dhammaadka`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E40}\u{E23}\u{E47}\u{E27}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{633}\u{628} \u{633}\u{6D2} \u{627}\u{628}\u{62A}\u{62F}\u{627}\u{626}\u{6CC} \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y k\u{1EBF}t th\xfac s\u{1EDB}m nh\u{1EA5}t`,
    'zh-hans': `\u{6700}\u{65E9}\u{7684}\u{7EC8}\u{6B62}\u{65E5}\u{671F}`,
    'zh-hant': `\u{6700}\u{65E9}\u{7D50}\u{675F}\u{65E5}\u{671F}`,
    en: `Earliest end date`
};
const $b11db1b62d4a8f76$export$765b926830e4f6a5 = {
    ar: `\u{623}\u{642}\u{62F}\u{645} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{628}\u{62F}\u{621}`,
    de: `Fr\xfchester Starttermin`,
    es: `Fecha de inicio m\xe1s temprana`,
    fa: `\u{632}\u{648}\u{62F}\u{62A}\u{631}\u{6CC}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{634}\u{631}\u{648}\u{639}`,
    fil: `Pinakamaagang petsa ng pagsisimula`,
    fr: `Date de d\xe9but la plus ancienne`,
    hi: `\u{91C}\u{932}\u{94D}\u{926} \u{938}\u{947} \u{91C}\u{932}\u{94D}\u{926} \u{936}\u{941}\u{930}\u{942} \u{939}\u{94B}\u{928}\u{947} \u{915}\u{940} \u{924}\u{93E}\u{930}\u{940}\u{916}`,
    ht: `Premye dat k\xf2manse`,
    it: `Data di inizio pi\xf9 antica`,
    ja: `\u{6700}\u{3082}\u{65E9}\u{3044}\u{958B}\u{59CB}\u{65E5}`,
    ko: `\u{AC00}\u{C7A5} \u{C774}\u{B978} \u{C2DC}\u{C791}\u{C77C}`,
    mww: `Hnub pib ntxov tshaj plaws`,
    ps: `\u{62A}\u{631} \u{67C}\u{648}\u{644}\u{648} \u{698}\u{631} \u{62F} \u{67E}\u{6CC}\u{644} \u{646}\u{6D0}\u{67C}\u{647}`,
    pt: `Data de in\xedcio mais antiga`,
    'pt-pt': `Data de in\xedcio mais antiga`,
    ru: `\u{421}\u{430}\u{43C}\u{430}\u{44F} \u{440}\u{430}\u{43D}\u{43D}\u{44F}\u{44F} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430}`,
    sm: `Aso amata muamua`,
    so: `Taariikhda ugu horreysa ee bilowga`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E40}\u{E23}\u{E47}\u{E27}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{633}\u{628} \u{633}\u{6D2} \u{62C}\u{644}\u{62F} \u{622}\u{63A}\u{627}\u{632} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u s\u{1EDB}m nh\u{1EA5}t`,
    'zh-hans': `\u{6700}\u{65E9}\u{7684}\u{8D77}\u{59CB}\u{65E5}\u{671F}`,
    'zh-hant': `\u{6700}\u{65E9}\u{7684}\u{958B}\u{59CB}\u{65E5}\u{671F}`,
    en: `Earliest start date`
};
const $b11db1b62d4a8f76$export$dad4342a62c89f83 = {
    ar: `\u{62A}\u{639}\u{62F}\u{64A}\u{644}`,
    de: `Bearbeitung`,
    es: `Edici\xf3n`,
    fa: `\u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634}`,
    fil: `Baguhin`,
    fr: `\xc9dit`,
    hi: `\u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `modifye`,
    it: `Modifica`,
    ja: `\u{7DE8}\u{96C6}`,
    ko: `\u{C218}\u{C815}`,
    mww: `Kho kom raug`,
    ps: `\u{633}\u{645}\u{648}\u{646}`,
    pt: `Edit`,
    'pt-pt': `Editar`,
    ru: `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Fa'asa'o`,
    so: `Tafatir`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}`,
    ur: `\u{62A}\u{631}\u{645}\u{6CC}\u{645}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a`,
    'zh-hans': `\u{7F16}\u{8F91}`,
    'zh-hant': `\u{7DE8}\u{8F2F}`,
    en: `Edit`
};
const $b11db1b62d4a8f76$export$7a2f179ce2201367 = {
    ar: `\u{62A}\u{639}\u{62F}\u{64A}\u{644} \u{627}\u{644}\u{62A}\u{631}\u{643}\u{64A}\u{628}\u{629} \u{627}\u{644}\u{633}\u{643}\u{627}\u{646}\u{64A}\u{629}`,
    de: `Demografie bearbeiten`,
    es: `Editar demograf\xeda`,
    fa: `\u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{62C}\u{645}\u{639}\u{6CC}\u{62A} \u{634}\u{646}\u{627}\u{633}\u{6CC}`,
    fil: `I-edit ang demograpiko`,
    fr: `Modifier la d\xe9mographie`,
    hi: `\u{91C}\u{928}\u{938}\u{93E}\u{902}\u{916}\u{94D}\u{92F}\u{93F}\u{915}\u{940} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Edite demografik`,
    it: `Modifica demografia`,
    ja: `\u{7DE8}\u{96C6}:\u{4EBA}\u{53E3}\u{7D71}\u{8A08}`,
    ko: `\u{D3B8}\u{C9D1} \u{C778}\u{AD6C} \u{D1B5}\u{ACC4}`,
    mww: `Kho kom raug demographics`,
    ps: `\u{633}\u{645}\u{648}\u{646} \u{646}\u{641}\u{648}\u{633}`,
    pt: `Editar demografia`,
    'pt-pt': `Editar demografia`,
    ru: `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{434}\u{435}\u{43C}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{44E}`,
    sm: `Fa'asa'o le faitau aofa'i o tagata`,
    so: `Wax ka beddel tirakoobka dadka`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E1B}\u{E23}\u{E30}\u{E0A}\u{E32}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{631}\u{645}\u{6CC}\u{645} \u{622}\u{628}\u{627}\u{62F}\u{6CC}\u{627}\u{62A}\u{6CC} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a nh\xe2n kh\u{1EA9}u h\u{1ECD}c`,
    'zh-hans': `\u{7F16}\u{8F91} \u{4EBA}\u{53E3}\u{7EDF}\u{8BA1}`,
    'zh-hant': `\u{7DE8}\u{8F2F}\u{FF1A}\u{4EBA}\u{53E3}\u{7D71}\u{8A08}`,
    en: `Edit demographics`
};
const $b11db1b62d4a8f76$export$49059a112cc2b793 = {
    ar: `\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644} \u{62A}\u{639}\u{62F}\u{64A}\u{644}`,
    de: `Bearbeitungsdetails`,
    es: `Detalles de edici\xf3n`,
    fa: `\u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A} \u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634}`,
    fil: `I-edit ang mga detalye`,
    fr: `D\xe9tails de la modification`,
    hi: `\u{935}\u{93F}\u{935}\u{930}\u{923} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Edit detay yo`,
    it: `Dettagli modifica`,
    ja: `\u{7DE8}\u{96C6}\u{8A73}\u{7D30}`,
    ko: `\u{D3B8}\u{C9D1} \u{C138}\u{BD80}\u{C0AC}\u{D56D}`,
    mww: `Kho kom raug cov ntsiab lus`,
    ps: `\u{62F} \u{633}\u{645}\u{648}\u{646} \u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A}`,
    pt: `Detalhes da edi\xe7\xe3o`,
    'pt-pt': `Detalhes de edi\xe7\xe3o`,
    ru: `\u{414}\u{435}\u{442}\u{430}\u{43B}\u{438} \u{43F}\u{440}\u{430}\u{432}\u{43A}\u{438}`,
    sm: `Fa'asa'o auiliiliga`,
    so: `Faahfaahinta wax ka beddel`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E23}\u{E32}\u{E22}\u{E25}\u{E30}\u{E40}\u{E2D}\u{E35}\u{E22}\u{E14}`,
    ur: `\u{62A}\u{631}\u{645}\u{6CC}\u{645}\u{6CC} \u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a chi ti\u{1EBF}t`,
    'zh-hans': `\u{7F16}\u{8F91}\u{8BE6}\u{60C5}`,
    'zh-hant': `\u{7DE8}\u{8F2F}\u{7D30}\u{7BC0}`,
    en: `Edit details`
};
const $b11db1b62d4a8f76$export$11bac38300b66c09 = {
    ar: `\u{639}\u{646}\u{635}\u{631} \u{627}\u{644}\u{62A}\u{639}\u{62F}\u{64A}\u{644}`,
    de: `Bearbeitungselement`,
    es: `Elemento de edici\xf3n`,
    fa: `\u{639}\u{646}\u{635}\u{631} \u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634}`,
    fil: `I-edit ang elemento`,
    fr: `\xc9l\xe9ment d\u{2019}\xe9dition`,
    hi: `\u{924}\u{924}\u{94D}\u{935} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Edit eleman`,
    it: `Modifica elemento`,
    ja: `\u{7DE8}\u{96C6}\u{8981}\u{7D20}`,
    ko: `\u{D3B8}\u{C9D1} \u{C694}\u{C18C}`,
    mww: `Kho kom raug`,
    ps: `\u{627}\u{6CC}\u{689}\u{6CC}\u{67C} \u{639}\u{646}\u{635}\u{631}`,
    pt: `Elemento de edi\xe7\xe3o`,
    'pt-pt': `Elemento de edi\xe7\xe3o`,
    ru: `\u{42D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Fa'asa'o elemene`,
    so: `Qaybta tafatirka`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E1B}\u{E23}\u{E30}\u{E01}\u{E2D}\u{E1A}`,
    ur: `\u{627}\u{6CC}\u{688}\u{6CC}\u{679} \u{627}\u{6CC}\u{644}\u{6CC}\u{645}\u{646}\u{679}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a ph\u{1EA7}n t\u{1EED}`,
    'zh-hans': `\u{7F16}\u{8F91}\u{5143}\u{7D20}`,
    'zh-hant': `\u{7DE8}\u{8F2F}\u{5143}\u{7D20}`,
    en: `Edit element`
};
const $b11db1b62d4a8f76$export$a4e580c414d52706 = {
    ar: `\u{62A}\u{645} \u{62A}\u{639}\u{637}\u{64A}\u{644} \u{627}\u{644}\u{62A}\u{62D}\u{631}\u{64A}\u{631}`,
    de: `Bearbeitung deaktiviert`,
    es: `Edici\xf3n deshabilitada`,
    fa: `\u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{63A}\u{6CC}\u{631}\u{641}\u{639}\u{627}\u{644} \u{634}\u{62F}`,
    fil: `Hindi pinagana ang pag-edit`,
    fr: `Montage d\xe9sactiv\xe9`,
    hi: `\u{938}\u{902}\u{92A}\u{93E}\u{926}\u{928} \u{905}\u{915}\u{94D}\u{937}\u{92E}`,
    ht: `Modification enfim`,
    it: `Editing disabilitato`,
    ja: `\u{7DE8}\u{96C6}\u{7121}\u{52B9}`,
    ko: `\u{D3B8}\u{C9D1} \u{BE44}\u{D65C}\u{C131}\u{D654}`,
    mww: `Kho cov neeg xiam oob khab`,
    ps: `\u{627}\u{6CC}\u{689}\u{6CC}\u{67C}\u{646}\u{6AB} \u{63A}\u{6CC}\u{631} \u{641}\u{639}\u{627}\u{644} \u{634}\u{648}`,
    pt: `Edi\xe7\xe3o desativada`,
    'pt-pt': `Edi\xe7\xe3o desativada`,
    ru: `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{43E}\u{442}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{43E}`,
    sm: `Fa'asa'oina le fa'aleagaina`,
    so: `Tafatirka waa la joojiyay`,
    th: `\u{E01}\u{E32}\u{E23}\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E16}\u{E39}\u{E01}\u{E1B}\u{E34}\u{E14}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{627}\u{6CC}\u{688}\u{6CC}\u{679}\u{646}\u{6AF} \u{63A}\u{6CC}\u{631} \u{641}\u{639}\u{627}\u{644}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a b\u{1ECB} v\xf4 hi\u{1EC7}u h\xf3a`,
    'zh-hans': `\u{7981}\u{7528}\u{7F16}\u{8F91}`,
    'zh-hant': `\u{7DE8}\u{8F2F}\u{529F}\u{80FD}\u{88AB}\u{505C}\u{7528}`,
    en: `Editing disabled`
};
const $b11db1b62d4a8f76$export$84d2a03f81848e1 = {
    ar: `\u{645}\u{62D}\u{631}\u{631}`,
    de: `Herausgeber`,
    es: `Editor`,
    fa: `\u{648}\u{6CC}\u{631}\u{627}\u{633}\u{62A}\u{627}\u{631}`,
    fil: `Editor`,
    fr: `R\xe9dacteur en chef`,
    hi: `\u{938}\u{902}\u{92A}\u{93E}\u{926}\u{915}`,
    ht: `Edit\xe8`,
    it: `Direttore`,
    ja: `\u{7DE8}\u{96C6}\u{8005}`,
    ko: `\u{D3B8}\u{C9D1}\u{C790}`,
    mww: `Editor`,
    ps: `\u{627}\u{6CC}\u{689}\u{6CC}\u{67C}\u{631}`,
    pt: `Editor`,
    'pt-pt': `Editor`,
    ru: `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{43E}\u{440}`,
    sm: `Faatonu`,
    so: `Tifaftiraha`,
    th: `\u{E1A}\u{E23}\u{E23}\u{E13}\u{E32}\u{E18}\u{E34}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{627}\u{6CC}\u{688}\u{6CC}\u{679}\u{631}`,
    vi: `Bi\xean t\u{1EAD}p vi\xean`,
    'zh-hans': `\u{7F16}\u{8F91}`,
    'zh-hant': `\u{4E3B}\u{7DE8}`,
    en: `Editor`
};
const $b11db1b62d4a8f76$export$6380852208e673e5 = {
    ar: `\u{62A}\u{639}\u{62F}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{644}\u{641} \u{627}\u{644}\u{634}\u{62E}\u{635}\u{64A} \u{648}\u{627}\u{644}\u{62D}\u{633}\u{627}\u{628}`,
    de: `Profil bearbeiten & Konto`,
    es: `Editar perfil y cuenta`,
    fa: `\u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644} \u{648} \u{62D}\u{633}\u{627}\u{628} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{6CC}`,
    fil: `I-edit ang profile at account`,
    fr: `Modifier le profil et le compte`,
    hi: `\u{92A}\u{94D}\u{930}\u{94B}\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{914}\u{930} \u{916}\u{93E}\u{924}\u{93E} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Edit pwofil & kont`,
    it: `Modifica profilo e account`,
    ja: `\u{30D7}\u{30ED}\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{3068}\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{3092}\u{7DE8}\u{96C6}`,
    ko: `\u{D504}\u{B85C}\u{D544} \u{BC0F} \u{ACC4}\u{C815} \u{D3B8}\u{C9D1}`,
    mww: `Kho kom raug profile & account`,
    ps: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644} \u{627}\u{648} \u{62D}\u{633}\u{627}\u{628} \u{633}\u{645}\u{648}\u{646} \u{6A9}\u{693}\u{626}`,
    pt: `Editar perfil & conta`,
    'pt-pt': `Editar perfil & conta`,
    ru: `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{43F}\u{440}\u{43E}\u{444}\u{438}\u{43B}\u{44C} \u{438} \u{430}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442}`,
    sm: `Fa'asa'o talaaga otooto ma teuga tupe`,
    so: `Wax ka beddel profile & account`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E42}\u{E1B}\u{E23}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E41}\u{E25}\u{E30}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}`,
    ur: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{626}\u{644} \u{627}\u{648}\u{631} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{645}\u{6CC}\u{6BA} \u{62A}\u{631}\u{645}\u{6CC}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a h\u{1ED3} s\u{1A1} v\xe0 t\xe0i kho\u{1EA3}n`,
    'zh-hans': `\u{7F16}\u{8F91}\u{4E2A}\u{4EBA}\u{8D44}\u{6599}\u{548C}\u{8D26}\u{6237}`,
    'zh-hant': `\u{7DE8}\u{8F2F}\u{500B}\u{4EBA}\u{6A94}\u{6848}\u{8207}\u{5E33}\u{865F}`,
    en: `Edit profile & account`
};
const $b11db1b62d4a8f76$export$c2a86e55c5145eaf = {
    ar: `\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631} \u{627}\u{644}\u{62A}\u{639}\u{62F}\u{64A}\u{644}`,
    de: `Bearbeitungsauswahl`,
    es: `Selecci\xf3n de edici\xf3n`,
    fa: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634}`,
    fil: `I-edit ang pagpili`,
    fr: `S\xe9lection de la modification`,
    hi: `\u{91A}\u{92F}\u{928} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Edit seleksyon`,
    it: `Modifica selezione`,
    ja: `\u{7DE8}\u{96C6}\u{9078}\u{629E}`,
    ko: `\u{D3B8}\u{C9D1} \u{C120}\u{D0DD}`,
    mww: `Kho kom raug xaiv`,
    ps: `\u{62F} \u{633}\u{645}\u{648}\u{646} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}`,
    pt: `Sele\xe7\xe3o de edi\xe7\xe3o`,
    'pt-pt': `Sele\xe7\xe3o de edi\xe7\xe3o`,
    ru: `\u{412}\u{44B}\u{431}\u{43E}\u{440} \u{43F}\u{440}\u{430}\u{432}\u{43A}\u{438}`,
    sm: `Fa'asa'o filifiliga`,
    so: `Xulashada tafatirka`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E2A}\u{E48}\u{E27}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}`,
    ur: `\u{62A}\u{631}\u{645}\u{6CC}\u{645}\u{6CC} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a l\u{1EF1}a ch\u{1ECD}n`,
    'zh-hans': `\u{7F16}\u{8F91}\u{9009}\u{62E9}`,
    'zh-hant': `\u{7DE8}\u{8F2F}\u{9078}\u{64C7}`,
    en: `Edit selection`
};
const $b11db1b62d4a8f76$export$61a240d3d3e2bc6c = {
    ar: `\u{639}\u{62F}\u{644} \u{647}\u{630}\u{647} \u{644}\u{648}\u{62D}\u{629} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    de: `Bearbeiten Sie dieses Dashboard`,
    es: `Editar este panel de control`,
    fa: `\u{627}\u{6CC}\u{646} \u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F} \u{631}\u{627} \u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `I-edit ang dashboard na ito`,
    fr: `Modifier ce tableau de bord`,
    hi: `\u{907}\u{938} \u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{915}\u{94B} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Edite tablodb\xf2 sa a`,
    it: `Modifica questa dashboard`,
    ja: `\u{3053}\u{306E}\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{3092}\u{7DE8}\u{96C6}`,
    ko: `\u{C774} \u{B300}\u{C2DC}\u{BCF4}\u{B4DC}\u{B97C} \u{D3B8}\u{C9D1}\u{D558}\u{C138}\u{C694}`,
    mww: `Kho kom raug no dashboard`,
    ps: `\u{62F}\u{627} \u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{689} \u{627}\u{6CC}\u{689}\u{6CC}\u{67C} \u{6A9}\u{693}\u{626}`,
    pt: `Editar este painel`,
    'pt-pt': `Editar este painel`,
    ru: `\u{41E}\u{442}\u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{44D}\u{442}\u{443} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44C} \u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Fa'asa'o lenei dashboard`,
    so: `Wax ka beddel dashboard-kan`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688} \u{645}\u{6CC}\u{6BA} \u{62A}\u{631}\u{645}\u{6CC}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a b\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n n\xe0y`,
    'zh-hans': `\u{7F16}\u{8F91}\u{6B64}\u{4EEA}\u{8868}\u{76D8}`,
    'zh-hant': `\u{7DE8}\u{8F2F}\u{6B64}\u{5100}\u{8868}\u{677F}`,
    en: `Edit this dashboard`
};
const $b11db1b62d4a8f76$export$456174b22f68b1ac = {
    ar: `\u{62A}\u{639}\u{62F}\u{64A}\u{644} \u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{645}\u{648}\u{627}\u{639}\u{64A}\u{62F}`,
    de: `Stundenzettel bearbeiten`,
    es: `Hoja de horas de edici\xf3n`,
    fa: `\u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646}`,
    fil: `I-edit ang timesheet`,
    fr: `Feuille d\u{2019}heure de modification`,
    hi: `\u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Edite F\xe8y tan`,
    it: `Modifica foglio orario`,
    ja: `\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{3092}\u{7DE8}\u{96C6}`,
    ko: `\u{D0C0}\u{C784}\u{C2DC}\u{D2B8} \u{D3B8}\u{C9D1}`,
    mww: `Kho kom raug daim ntawv teev sijhawm`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647} \u{633}\u{645}\u{648}\u{646} \u{6A9}\u{693}\u{626}`,
    pt: `Editar folha de ponto`,
    'pt-pt': `Folha de horas de edi\xe7\xe3o`,
    ru: `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44F}`,
    sm: `Fa'asa'o le pepa o taimi`,
    so: `Tafatir jadwalka waqtiga`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}`,
    ur: `\u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{645}\u{6CC}\u{6BA} \u{62A}\u{631}\u{645}\u{6CC}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a b\u{1EA3}ng ch\u{1EA5}m c\xf4ng`,
    'zh-hans': `\u{7F16}\u{8F91}\u{65F6}\u{95F4}\u{8868}`,
    'zh-hant': `\u{7DE8}\u{8F2F}\u{6642}\u{9593}\u{8868}`,
    en: `Edit timesheet`
};
const $b11db1b62d4a8f76$export$535dc873d3acbcb5 = {
    ar: `\u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}`,
    de: `E-Mail`,
    es: `Correo electr\xf3nico`,
    fa: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644}`,
    fil: `Email`,
    fr: `Email`,
    hi: `\u{908}\u{92E}\u{947}\u{932}`,
    ht: `Imel`,
    it: `E-mail`,
    ja: `\u{30E1}\u{30FC}\u{30EB}`,
    ko: `\u{C774}\u{BA54}\u{C77C}`,
    mww: `Tus email`,
    ps: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644}`,
    pt: `E-mail`,
    'pt-pt': `Email`,
    ru: `\u{42D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{430}\u{44F} \u{43F}\u{43E}\u{447}\u{442}\u{430}`,
    sm: `Imeli`,
    so: `Email`,
    th: `\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644}`,
    vi: `Th\u{1B0} \u{111}i\u{1EC7}n t\u{1EED}`,
    'zh-hans': `\u{7535}\u{5B50}\u{90AE}\u{4EF6}`,
    'zh-hant': `\u{96FB}\u{5B50}\u{90F5}\u{4EF6}`,
    en: `Email`
};
const $b11db1b62d4a8f76$export$110c810b17b2bbae = {
    ar: `\u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} & \u{627}\u{633}\u{645} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}`,
    de: `E-Mail & Benutzername`,
    es: `Correo electr\xf3nico y nombre de usuario`,
    fa: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{648} \u{646}\u{627}\u{645} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{6CC}`,
    fil: `Email at Username`,
    fr: `Email & Nom d\u{2019}utilisateur`,
    hi: `\u{908}\u{92E}\u{947}\u{932} \u{914}\u{930} \u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E} \u{928}\u{93E}\u{92E}`,
    ht: `Im\xe8l & Non itilizat\xe8`,
    it: `Email e Nome utente`,
    ja: `\u{30E1}\u{30FC}\u{30EB}\u{30A2}\u{30C9}\u{30EC}\u{30B9}\u{3068}\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{540D}`,
    ko: `\u{C774}\u{BA54}\u{C77C} \u{BC0F} \u{C0AC}\u{C6A9}\u{C790} \u{C774}\u{B984}`,
    mww: `Email & Username`,
    ps: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{627}\u{648} \u{6A9}\u{627}\u{631}\u{646} \u{646}\u{648}\u{645}`,
    pt: `E-mail & Nome de Usu\xe1rio`,
    'pt-pt': `Email & Nome de Utilizador`,
    ru: `\u{42D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{430}\u{44F} \u{43F}\u{43E}\u{447}\u{442}\u{430} \u{438} \u{438}\u{43C}\u{44F} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F}`,
    sm: `Imeli ma Username`,
    so: `Email & Username`,
    th: `\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E41}\u{E25}\u{E30}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{627}\u{648}\u{631} \u{6CC}\u{648}\u{632}\u{631} \u{646}\u{6CC}\u{645}`,
    vi: `Email & T\xean \u{111}\u{103}ng nh\u{1EAD}p`,
    'zh-hans': `\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{53CA}\u{7528}\u{6237}\u{540D}`,
    'zh-hant': `\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{8207}\u{4F7F}\u{7528}\u{8005}\u{540D}\u{7A31}`,
    en: `Email & Username`
};
const $b11db1b62d4a8f76$export$86381633ec82cace = {
    ar: `\u{631}\u{633}\u{627}\u{626}\u{644} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}`,
    de: `E-Mails`,
    es: `Correos electr\xf3nicos`,
    fa: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{647}\u{627}`,
    fil: `Email Address *`,
    fr: `Emails`,
    hi: `\u{908}\u{92E}\u{947}\u{932}`,
    ht: `Im\xe8l`,
    it: `Email`,
    ja: `\u{30E1}\u{30FC}\u{30EB}`,
    ko: `\u{C774}\u{BA54}\u{C77C}`,
    mww: `Emails`,
    ps: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644}\u{648}\u{646}\u{647}`,
    pt: `E-mails`,
    'pt-pt': `Emails`,
    ru: `\u{42D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{44B}\u{435} \u{43F}\u{438}\u{441}\u{44C}\u{43C}\u{430}`,
    sm: `Imeli`,
    so: `Emaillo`,
    th: `\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644}\u{632}`,
    vi: `Th\u{1B0} \u{111}i\u{1EC7}n t\u{1EED}`,
    'zh-hans': `\u{7535}\u{5B50}\u{90AE}\u{4EF6}`,
    'zh-hant': `\u{96FB}\u{5B50}\u{90F5}\u{4EF6}`,
    en: `Emails`
};
const $b11db1b62d4a8f76$export$9a8ae3f9271bed90 = {
    ar: `\u{62A}\u{645} \u{625}\u{631}\u{633}\u{627}\u{644} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}`,
    de: `E-Mail gesendet`,
    es: `Correo electr\xf3nico enviado`,
    fa: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{627}\u{631}\u{633}\u{627}\u{644} \u{634}\u{62F}`,
    fil: `Email Address *`,
    fr: `Email envoy\xe9`,
    hi: `\u{908}\u{92E}\u{947}\u{932} \u{92D}\u{947}\u{91C}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Im\xe8l voye`,
    it: `Email inviata`,
    ja: `\u{30E1}\u{30FC}\u{30EB}\u{9001}\u{4FE1}\u{6E08}\u{307F}`,
    ko: `\u{C774}\u{BA54}\u{C77C} \u{BCF4}\u{B0B8}`,
    mww: `Email xa`,
    ps: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{644} \u{634}\u{648}`,
    pt: `E-mail enviado`,
    'pt-pt': `Email enviado`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{43E} \u{43F}\u{438}\u{441}\u{44C}\u{43C}\u{43E}`,
    sm: `Auina atu imeli`,
    so: `Email la diray`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{628}\u{6BE}\u{6CC}\u{62C}\u{6CC} \u{6AF}\u{626}\u{6CC}`,
    vi: `Email \u{111}\xe3 g\u{1EED}i`,
    'zh-hans': `\u{5DF2}\u{53D1}\u{9001}\u{90AE}\u{4EF6}`,
    'zh-hant': `\u{5DF2}\u{767C}\u{9001}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}`,
    en: `Email sent`
};
const $b11db1b62d4a8f76$export$4f221ed82c867b0d = {
    ar: `\u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{63A}\u{64A}\u{631} \u{642}\u{627}\u{628}\u{644} \u{644}\u{644}\u{62A}\u{633}\u{644}\u{64A}\u{645}. \u{62A}\u{648}\u{627}\u{635}\u{644} \u{645}\u{639} \u{627}\u{644}\u{62F}\u{639}\u{645} \u{644}\u{644}\u{62D}\u{635}\u{648}\u{644} \u{639}\u{644}\u{649} \u{627}\u{644}\u{645}\u{633}\u{627}\u{639}\u{62F}\u{629} \u{625}\u{630}\u{627} \u{643}\u{646}\u{62A} \u{62A}\u{639}\u{62A}\u{642}\u{62F} \u{623}\u{646} \u{647}\u{630}\u{627} \u{62E}\u{637}\u{623}.`,
    de: `Die E-Mail-Adresse ist nicht zustellbar. Kontaktieren Sie den Support f\xfcr Unterst\xfctzung, wenn Sie glauben, dass dies ein Fehler ist.`,
    es: `La direcci\xf3n de correo electr\xf3nico no se puede entregar. Contacta con el soporte si crees que esto es un error.`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{642}\u{627}\u{628}\u{644} \u{62A}\u{62D}\u{648}\u{6CC}\u{644} \u{646}\u{6CC}\u{633}\u{62A}. \u{627}\u{6AF}\u{631} \u{641}\u{6A9}\u{631} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{627}\u{6CC}\u{646} \u{6CC}\u{6A9} \u{627}\u{634}\u{62A}\u{628}\u{627}\u{647} \u{627}\u{633}\u{62A}\u{60C} \u{628}\u{627} \u{67E}\u{634}\u{62A}\u{6CC}\u{628}\u{627}\u{646}\u{6CC} \u{62A}\u{645}\u{627}\u{633} \u{628}\u{6AF}\u{6CC}\u{631}\u{6CC}\u{62F}.`,
    fil: `Ang email address ay hindi maihahatid. Makipag-ugnay sa suporta para sa tulong kung sa palagay mo ito ay isang pagkakamali.`,
    fr: `L\u{2019}adresse e-mail n\u{2019}est pas livrable. Contactez le support pour obtenir de l\u{2019}aide si vous pensez qu\u{2019}il s\u{2019}agit d\u{2019}une erreur.`,
    hi: `\u{908}\u{92E}\u{947}\u{932} \u{92A}\u{924}\u{93E} \u{921}\u{93F}\u{932}\u{940}\u{935}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964} \u{92F}\u{926}\u{93F} \u{906}\u{92A} \u{907}\u{938}\u{947} \u{90F}\u{915} \u{924}\u{94D}\u{930}\u{941}\u{91F}\u{93F} \u{92E}\u{93E}\u{928}\u{924}\u{947} \u{939}\u{948}\u{902} \u{924}\u{94B} \u{938}\u{939}\u{93E}\u{92F}\u{924}\u{93E} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{92E}\u{930}\u{94D}\u{925}\u{928} \u{938}\u{947} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Adr\xe8s imel se undeliverable. Kontakte sip\xf2 pou asistans si ou kw\xe8 sa a se yon er\xe8.`,
    it: `L'indirizzo email non \xe8 consegnabile. Contatta l'assistenza per assistenza se ritieni che si tratti di un errore.`,
    ja: `\u{30E1}\u{30FC}\u{30EB}\u{30A2}\u{30C9}\u{30EC}\u{30B9}\u{306F}\u{914D}\u{9054}\u{4E0D}\u{53EF}\u{3067}\u{3059}\u{3002}\u{3082}\u{3057}\u{3053}\u{308C}\u{304C}\u{8AA4}\u{308A}\u{3060}\u{3068}\u{601D}\u{308F}\u{308C}\u{308B}\u{5834}\u{5408}\u{306F}\u{30B5}\u{30DD}\u{30FC}\u{30C8}\u{306B}\u{9023}\u{7D61}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C774}\u{BA54}\u{C77C} \u{C8FC}\u{C18C}\u{AC00} \u{BC30}\u{B2EC} \u{BD88}\u{AC00}\u{C785}\u{B2C8}\u{B2E4}. \u{C774}\u{AC8C} \u{C624}\u{B958}\u{B77C}\u{ACE0} \u{C0DD}\u{AC01}\u{B418}\u{BA74} \u{C9C0}\u{C6D0}\u{D300}\u{C5D0} \u{C5F0}\u{B77D}\u{D574} \u{B3C4}\u{C6C0}\u{C744} \u{BC1B}\u{C73C}\u{C138}\u{C694}.`,
    mww: `Email chaw nyob yog unsupplyable. Hu rau kev pab txhawb nqa yog koj ntseeg tias qhov no yog ib qho yuam kev.`,
    ps: `\u{62F} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{67E}\u{62A}\u{647} \u{646}\u{647} \u{633}\u{67E}\u{627}\u{631}\u{644} \u{6A9}\u{6D0}\u{696}\u{6CC}. \u{6A9}\u{647} \u{62A}\u{627}\u{633}\u{648} \u{641}\u{6A9}\u{631} \u{6A9}\u{648}\u{626} \u{686}\u{6D0} \u{62F}\u{627} \u{62A}\u{6D0}\u{631}\u{648}\u{62A}\u{646}\u{647} \u{62F}\u{647}\u{60C} \u{644}\u{647} \u{645}\u{644}\u{627}\u{62A}\u{693} \u{633}\u{631}\u{647} \u{627}\u{693}\u{6CC}\u{6A9}\u{647} \u{648}\u{646}\u{6CC}\u{633}\u{626}.`,
    pt: `Endere\xe7o de e-mail n\xe3o pode ser entregue. Entre em contato com o suporte para obter ajuda se voc\xea acreditar que isso foi um erro.`,
    'pt-pt': `O endere\xe7o de email n\xe3o pode ser entregue. Contacte o apoio ao p\xfablico para obter assist\xeancia se achar que isto \xe9 um erro.`,
    ru: `\u{410}\u{434}\u{440}\u{435}\u{441} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{447}\u{442}\u{44B} \u{43D}\u{435} \u{43F}\u{43E}\u{434}\u{43B}\u{435}\u{436}\u{438}\u{442} \u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43A}\u{435}. \u{41E}\u{431}\u{440}\u{430}\u{442}\u{438}\u{442}\u{435}\u{441}\u{44C} \u{432} \u{43F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{443} \u{437}\u{430} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E}, \u{435}\u{441}\u{43B}\u{438} \u{441}\u{447}\u{438}\u{442}\u{430}\u{435}\u{442}\u{435} \u{44D}\u{442}\u{43E} \u{43E}\u{448}\u{438}\u{431}\u{43A}\u{43E}\u{439}.`,
    sm: `O le tuatusi imeli e le mafai ona tu'uina atu. Fa'afeso'ota'i le lagolago mo se fesoasoani pe afai e te manatu o se mea sese.`,
    so: `Cinwaanka email-ka lama gaarsiin karo. La xiriir taageerada si aad u hesho caawimaad haddii aad u malaynayso in tani ay khalad tahay.`,
    th: `\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E2A}\u{E48}\u{E07}\u{E44}\u{E14}\u{E49} \u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E1D}\u{E48}\u{E32}\u{E22}\u{E2A}\u{E19}\u{E31}\u{E1A}\u{E2A}\u{E19}\u{E38}\u{E19}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E02}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E0A}\u{E48}\u{E27}\u{E22}\u{E40}\u{E2B}\u{E25}\u{E37}\u{E2D}\u{E2B}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E40}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E27}\u{E48}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E02}\u{E49}\u{E2D}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633} \u{642}\u{627}\u{628}\u{644} \u{62A}\u{631}\u{633}\u{6CC}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4} \u{627}\u{6AF}\u{631} \u{622}\u{67E} \u{6A9}\u{648} \u{644}\u{6AF}\u{62A}\u{627} \u{6C1}\u{6D2} \u{6A9}\u{6C1} \u{6CC}\u{6C1} \u{63A}\u{644}\u{637}\u{6CC} \u{6C1}\u{6D2} \u{62A}\u{648} \u{645}\u{62F}\u{62F} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{633}\u{67E}\u{648}\u{631}\u{679} \u{633}\u{6D2} \u{631}\u{627}\u{628}\u{637}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} email kh\xf4ng th\u{1EC3} g\u{1EED}i \u{111}\u{1B0}\u{1EE3}c. Li\xean h\u{1EC7} v\u{1EDB}i b\u{1ED9} ph\u{1EAD}n h\u{1ED7} tr\u{1EE3} \u{111}\u{1EC3} \u{111}\u{1B0}\u{1EE3}c h\u{1ED7} tr\u{1EE3} n\u{1EBF}u b\u{1EA1}n cho r\u{1EB1}ng \u{111}\xe2y l\xe0 l\u{1ED7}i.`,
    'zh-hans': `\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{5730}\u{5740}\u{65E0}\u{6CD5}\u{6295}\u{9012}\u{3002}\u{5982}\u{679C}\u{4F60}\u{8BA4}\u{4E3A}\u{8FD9}\u{662F}\u{9519}\u{8BEF}\u{FF0C}\u{8BF7}\u{8054}\u{7CFB}\u{5BA2}\u{670D}\u{5BFB}\u{6C42}\u{5E2E}\u{52A9}\u{3002}`,
    'zh-hant': `\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{5730}\u{5740}\u{7121}\u{6CD5}\u{6295}\u{905E}\u{3002}\u{5982}\u{679C}\u{4F60}\u{8A8D}\u{70BA}\u{9019}\u{662F}\u{932F}\u{8AA4}\u{FF0C}\u{8ACB}\u{806F}\u{7D61}\u{5BA2}\u{670D}\u{5C0B}\u{6C42}\u{5354}\u{52A9}\u{3002}`,
    en: `Email address is undeliverable. Contact support for assistance if you believe this to be an error.`
};
const $b11db1b62d4a8f76$export$fe135b503360e0f5 = {
    ar: `\u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{645}\u{631}\u{626}\u{64A} \u{644}\u{623}\u{639}\u{636}\u{627}\u{621} Cumulus \u{627}\u{644}\u{630}\u{64A}\u{646} \u{62A}\u{62A}\u{639}\u{627}\u{648}\u{646} \u{645}\u{639}\u{647}\u{645}.`,
    de: `Die E-Mail ist f\xfcr Cumulus-Mitglieder, mit denen Sie zusammenarbeiten, sichtbar.`,
    es: `El correo electr\xf3nico es visible para los miembros de Cumulus con los que colaboras.`,
    fa: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{639}\u{636}\u{627}\u{6CC} Cumulus \u{6A9}\u{647} \u{628}\u{627} \u{622}\u{646} \u{647}\u{627} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{6CC} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{642}\u{627}\u{628}\u{644} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Ang email ay nakikita ng mga miyembro ng Cumulus na nakikipagtulungan ka.`,
    fr: `L\u{2019}email est visible pour les membres Cumulus avec lesquels vous collaborez.`,
    hi: `\u{908}\u{92E}\u{947}\u{932} \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{94D}\u{92F}\u{932}\u{938} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{926}\u{93F}\u{916}\u{93E}\u{908} \u{926}\u{947}\u{924}\u{93E} \u{939}\u{948} \u{91C}\u{93F}\u{928}\u{915}\u{947} \u{938}\u{93E}\u{925} \u{906}\u{92A} \u{938}\u{939}\u{92F}\u{94B}\u{917} \u{915}\u{930} \u{930}\u{939}\u{947} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Im\xe8l vizib pou Cumulus manm ou ap kolabore av\xe8k yo.`,
    it: `L'email \xe8 visibile ai membri Cumulus con cui collabori.`,
    ja: `\u{30E1}\u{30FC}\u{30EB}\u{306F}\u{3001}\u{5354}\u{529B}\u{3057}\u{3066}\u{3044}\u{308B}Cumulus\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{306B}\u{3082}\u{95B2}\u{89A7}\u{53EF}\u{80FD}\u{3067}\u{3059}\u{3002}`,
    ko: `\u{C774}\u{BA54}\u{C77C}\u{C740} \u{D611}\u{C5C5} \u{C911}\u{C778} Cumulus \u{D68C}\u{C6D0}\u{B4E4}\u{C5D0}\u{AC8C} \u{ACF5}\u{AC1C}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Email yog pom rau Cumulus cov tswv cuab uas koj tab tom koom tes nrog.`,
    ps: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{62F} Cumulus \u{647}\u{63A}\u{648} \u{63A}\u{693}\u{648} \u{62A}\u{647} \u{69A}\u{6A9}\u{627}\u{631}\u{647} \u{62F}\u{6CC} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{648}\u{631}\u{633}\u{631}\u{647} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{6CC} \u{6A9}\u{648}\u{626}.`,
    pt: `O e-mail \xe9 vis\xedvel para os membros da Cumulus com quem voc\xea est\xe1 colaborando.`,
    'pt-pt': `O email \xe9 vis\xedvel para os membros da Cumulus com quem colabora.`,
    ru: `\u{42D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{430}\u{44F} \u{43F}\u{43E}\u{447}\u{442}\u{430} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{430}\u{43C} Cumulus, \u{441} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{43C}\u{438} \u{432}\u{44B} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{447}\u{430}\u{435}\u{442}\u{435}.`,
    sm: `O le imeli e mafai ona va'aia e tagata o le Cumulus o lo'o e galulue fa'atasi.`,
    so: `Email-ka waa la arki karaa xubnaha Cumulus ee aad la shaqaynayso.`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01} Cumulus \u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E31}\u{E19}\u{E08}\u{E30}\u{E21}\u{E2D}\u{E07}\u{E40}\u{E2B}\u{E47}\u{E19}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{627}\u{646} \u{6A9}\u{6CC}\u{648}\u{645}\u{6CC}\u{648}\u{644}\u{633} \u{645}\u{645}\u{628}\u{631}\u{627}\u{646} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{646}\u{638}\u{631} \u{622}\u{62A}\u{6CC} \u{6C1}\u{6D2} \u{62C}\u{646} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{622}\u{67E} \u{62A}\u{639}\u{627}\u{648}\u{646} \u{6A9}\u{631} \u{631}\u{6C1}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Email hi\u{1EC3}n th\u{1ECB} cho c\xe1c th\xe0nh vi\xean Cumulus m\xe0 b\u{1EA1}n \u{111}ang c\u{1ED9}ng t\xe1c.`,
    'zh-hans': `\u{90AE}\u{4EF6}\u{5BF9}\u{4F60}\u{5408}\u{4F5C}\u{7684}Cumulus\u{6210}\u{5458}\u{53EF}\u{89C1}\u{3002}`,
    'zh-hant': `\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{5C0D}\u{4F60}\u{5408}\u{4F5C}\u{7684} Cumulus \u{6703}\u{54E1}\u{53EF}\u{898B}\u{3002}`,
    en: `Email is visible to Cumulus members you are collaborating with.`
};
const $b11db1b62d4a8f76$export$e6d3bbcb6498fe45 = {
    ar: `\u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644} \u{627}\u{644}\u{637}\u{627}\u{631}\u{626}`,
    de: `Notfallkontakt`,
    es: `Contacto de emergencia`,
    fa: `\u{62A}\u{645}\u{627}\u{633} \u{627}\u{636}\u{637}\u{631}\u{627}\u{631}\u{6CC}`,
    fil: `Pakikipag-ugnay sa Emergency`,
    fr: `Contact d\u{2019}urgence`,
    hi: `\u{906}\u{92A}\u{93E}\u{924}\u{915}\u{93E}\u{932}\u{940}\u{928} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915}`,
    ht: `Kontak ijans`,
    it: `Contatto di emergenza`,
    ja: `\u{7DCA}\u{6025}\u{9023}\u{7D61}\u{5148}`,
    ko: `\u{BE44}\u{C0C1} \u{C5F0}\u{B77D}\u{CC98}`,
    mww: `Kev Tiv Tauj Thaum Muaj Xwm Ceev`,
    ps: `\u{628}\u{6CC}\u{693}\u{646}\u{6CC} \u{62A}\u{645}\u{627}\u{633}`,
    pt: `Contato de Emerg\xeancia`,
    'pt-pt': `Contacto de Emerg\xeancia`,
    ru: `\u{42D}\u{43A}\u{441}\u{442}\u{440}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{43A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}`,
    sm: `Fa'afeso'ota'iga mo Fa'alavelave`,
    so: `Xiriirka Degdegga ah`,
    th: `\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E09}\u{E38}\u{E01}\u{E40}\u{E09}\u{E34}\u{E19}`,
    ur: `\u{627}\u{6CC}\u{645}\u{631}\u{62C}\u{646}\u{633}\u{6CC} \u{631}\u{627}\u{628}\u{637}\u{6C1}`,
    vi: `Li\xean h\u{1EC7} kh\u{1EA9}n c\u{1EA5}p`,
    'zh-hans': `\u{7D27}\u{6025}\u{8054}\u{7CFB}\u{4EBA}`,
    'zh-hant': `\u{7DCA}\u{6025}\u{806F}\u{7D61}\u{4EBA}`,
    en: `Emergency Contact`
};
const $b11db1b62d4a8f76$export$3dee267180bf6286 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{638}\u{641}`,
    de: `Mitarbeiter`,
    es: `Empleado`,
    fa: `\u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F}`,
    fil: `Empleyado`,
    fr: `Employ\xe9`,
    hi: `\u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940}`,
    ht: `Anplwaye`,
    it: `Dipendente`,
    ja: `\u{5F93}\u{696D}\u{54E1}`,
    ko: `\u{C9C1}\u{C6D0}`,
    mww: `Tus neeg ua hauj lwm`,
    ps: `\u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Funcion\xe1rio`,
    'pt-pt': `Funcion\xe1rio`,
    ru: `\u{421}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}`,
    sm: `Tagata faigaluega`,
    so: `Shaqaale`,
    th: `\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{645}\u{644}\u{627}\u{632}\u{645}`,
    vi: `Nh\xe2n vi\xean`,
    'zh-hans': `\u{5458}\u{5DE5}`,
    'zh-hant': `\u{54E1}\u{5DE5}`,
    en: `Employee`
};
const $b11db1b62d4a8f76$export$b66259fc9a6cc420 = {
    ar: `\u{645}\u{631}\u{627}\u{62C}\u{639}\u{629} \u{627}\u{644}\u{645}\u{648}\u{638}\u{641}\u{64A}\u{646}`,
    de: `Mitarbeiterbewertung`,
    es: `Evaluaci\xf3n del empleado`,
    fa: `\u{628}\u{631}\u{631}\u{633}\u{6CC} \u{6A9}\u{627}\u{631}\u{6A9}\u{646}\u{627}\u{646}`,
    fil: `Pagsusuri ng empleyado`,
    fr: `\xc9valuation des employ\xe9s`,
    hi: `\u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{938}\u{92E}\u{940}\u{915}\u{94D}\u{937}\u{93E}`,
    ht: `Revizyon anplwaye yo`,
    it: `Recensione del dipendente`,
    ja: `\u{5F93}\u{696D}\u{54E1}\u{30EC}\u{30D3}\u{30E5}\u{30FC}`,
    ko: `\u{C9C1}\u{C6D0} \u{D3C9}\u{AC00}`,
    mww: `Kev tshuaj xyuas cov neeg ua haujlwm`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{648} \u{628}\u{6CC}\u{627}\u{6A9}\u{62A}\u{646}\u{647}`,
    pt: `Avalia\xe7\xe3o de funcion\xe1rios`,
    'pt-pt': `Avalia\xe7\xe3o de colaboradores`,
    ru: `\u{41E}\u{442}\u{437}\u{44B}\u{432} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{43E}\u{432}`,
    sm: `Iloiloga a tagata faigaluega`,
    so: `Dib u eegista shaqaalaha`,
    th: `\u{E01}\u{E32}\u{E23}\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{645}\u{644}\u{627}\u{632}\u{645}\u{6CC}\u{646} \u{6A9}\u{627} \u{62C}\u{627}\u{626}\u{632}\u{6C1}`,
    vi: `\u{110}\xe1nh gi\xe1 c\u{1EE7}a nh\xe2n vi\xean`,
    'zh-hans': `\u{5458}\u{5DE5}\u{8BC4}\u{5BA1}`,
    'zh-hant': `\u{54E1}\u{5DE5}\u{8A55}\u{9451}`,
    en: `Employee review`
};
const $b11db1b62d4a8f76$export$ad981cdc21c869aa = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{638}\u{641}\u{648}\u{646}`,
    de: `Mitarbeiter`,
    es: `Empleados`,
    fa: `\u{6A9}\u{627}\u{631}\u{6A9}\u{646}\u{627}\u{646}`,
    fil: `Mga empleyado`,
    fr: `Employ\xe9s`,
    hi: `\u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940}`,
    ht: `Anplwaye yo`,
    it: `Dipendenti`,
    ja: `\u{5F93}\u{696D}\u{54E1}`,
    ko: `\u{C9C1}\u{C6D0}`,
    mww: `Cov neeg ua hauj lwm`,
    ps: `\u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Funcion\xe1rios`,
    'pt-pt': `Funcion\xe1rios`,
    ru: `\u{421}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{438}`,
    sm: `Tagata faigaluega`,
    so: `Shaqaalaha`,
    th: `\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{645}\u{644}\u{627}\u{632}\u{645}\u{6CC}\u{646}`,
    vi: `Nh\xe2n vi\xean`,
    'zh-hans': `\u{5458}\u{5DE5}`,
    'zh-hant': `\u{54E1}\u{5DE5}`,
    en: `Employees`
};
const $b11db1b62d4a8f76$export$f26cbd52422ea099 = {
    ar: `\u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644}`,
    de: `Arbeitgeber`,
    es: `Empleador`,
    fa: `\u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627}`,
    fil: `Tagapag-empleyo`,
    fr: `Employeur`,
    hi: `\u{92E}\u{93E}\u{932}\u{93F}\u{915}`,
    ht: `Anplway\xe8`,
    it: `Datore di lavoro`,
    ja: `\u{96C7}\u{7528}\u{4E3B}`,
    ko: `\u{ACE0}\u{C6A9}\u{C8FC}`,
    mww: `Tus tswv hauj lwm`,
    ps: `\u{6A9}\u{627}\u{631}\u{6AB}\u{645}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Empregador`,
    'pt-pt': `Empregador`,
    ru: `\u{420}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44C}`,
    sm: `Pule o le galuega`,
    so: `Shaqaale`,
    th: `\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{622}\u{62C}\u{631}`,
    vi: `Nh\xe0 tuy\u{1EC3}n d\u{1EE5}ng`,
    'zh-hans': `\u{96C7}\u{4E3B}`,
    'zh-hant': `\u{96C7}\u{4E3B}`,
    en: `Employer`
};
const $b11db1b62d4a8f76$export$9a8f041a9ed338e2 = {
    ar: `\u{645}\u{631}\u{627}\u{62C}\u{639}\u{629} \u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644}`,
    de: `Arbeitgeberbewertung`,
    es: `Revisi\xf3n del empleador`,
    fa: `\u{628}\u{631}\u{631}\u{633}\u{6CC} \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627}`,
    fil: `Pagsusuri ng employer`,
    fr: `Avis de l\u{2019}employeur`,
    hi: `\u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{915}\u{940} \u{938}\u{92E}\u{940}\u{915}\u{94D}\u{937}\u{93E}`,
    ht: `Revizyon anplway\xe8`,
    it: `Revisione del datore di lavoro`,
    ja: `\u{96C7}\u{7528}\u{4E3B}\u{30EC}\u{30D3}\u{30E5}\u{30FC}`,
    ko: `\u{ACE0}\u{C6A9}\u{C8FC} \u{AC80}\u{D1A0}`,
    mww: `Kev tshuaj xyuas ntawm tus tswv hauj lwm`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631}\u{6AB}\u{645}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC} \u{628}\u{6CC}\u{627}\u{6A9}\u{62A}\u{646}\u{647}`,
    pt: `Avalia\xe7\xe3o do empregador`,
    'pt-pt': `Revis\xe3o do empregador`,
    ru: `\u{41F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{43C}`,
    sm: `Iloiloga a le pule o le galuega`,
    so: `Dib-u-eegista shaqo-bixiyeyaasha`,
    th: `\u{E01}\u{E32}\u{E23}\u{E17}\u{E1A}\u{E17}\u{E27}\u{E19}\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{622}\u{62C}\u{631} \u{6A9}\u{627} \u{62C}\u{627}\u{626}\u{632}\u{6C1}`,
    vi: `\u{110}\xe1nh gi\xe1 c\u{1EE7}a nh\xe0 tuy\u{1EC3}n d\u{1EE5}ng`,
    'zh-hans': `\u{96C7}\u{4E3B}\u{5BA1}\u{67E5}`,
    'zh-hant': `\u{96C7}\u{4E3B}\u{5BE9}\u{67E5}`,
    en: `Employer review`
};
const $b11db1b62d4a8f76$export$e39a77fcdb881a0d = {
    ar: `\u{627}\u{644}\u{646}\u{647}\u{627}\u{64A}\u{629}`,
    de: `Ende`,
    es: `Fin`,
    fa: `\u{67E}\u{627}\u{6CC}\u{627}\u{646}`,
    fil: `Wakas`,
    fr: `Fin`,
    hi: `\u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}`,
    ht: `Fen`,
    it: `Fine`,
    ja: `\u{7D42}\u{308F}\u{308A}`,
    ko: `\u{B05D}`,
    mww: `xaus`,
    ps: `\u{67E}\u{627}\u{6CC}`,
    pt: `Fim`,
    'pt-pt': `Fim`,
    ru: `\u{41A}\u{43E}\u{43D}\u{435}\u{446}`,
    sm: `Fa'ai'uga`,
    so: `Dhammaad`,
    th: `\u{E08}\u{E1A}`,
    ur: `\u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645}`,
    vi: `K\u{1EBF}t th\xfac`,
    'zh-hans': `\u{7ED3}\u{675F}`,
    'zh-hant': `\u{7D50}\u{675F}`,
    en: `End`
};
const $b11db1b62d4a8f76$export$5ac70ff8a5f1a5bf = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{646}\u{647}\u{627}\u{64A}\u{629}`,
    de: `Enddatum`,
    es: `Fecha de finalizaci\xf3n`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{67E}\u{627}\u{6CC}\u{627}\u{646}`,
    fil: `Petsa ng pagtatapos`,
    fr: `Date de fin`,
    hi: `\u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{924}\u{93F}\u{925}\u{93F}`,
    ht: `Dat fen`,
    it: `Data di fine`,
    ja: `\u{7D42}\u{4E86}\u{65E5}`,
    ko: `\u{C885}\u{B8CC}\u{C77C}`,
    mww: `Hnub xaus`,
    ps: `\u{62F} \u{67E}\u{627}\u{6CC} \u{646}\u{6D0}\u{67C}\u{647}`,
    pt: `Data de t\xe9rmino`,
    'pt-pt': `Data de fim`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Aso fa'amutaina`,
    so: `Taariikhda dhammaadka`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y k\u{1EBF}t th\xfac`,
    'zh-hans': `\u{7ED3}\u{675F}\u{65E5}\u{671F}`,
    'zh-hant': `\u{7D50}\u{675F}\u{65E5}\u{671F}`,
    en: `End date`
};
const $b11db1b62d4a8f76$export$5782ac31c0db0c03 = {
    ar: `\u{646}\u{647}\u{627}\u{64A}\u{629} \u{627}\u{644}\u{632}\u{645}\u{646}`,
    de: `Endzeit`,
    es: `Fin del tiempo`,
    fa: `\u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{632}\u{645}\u{627}\u{646}`,
    fil: `Oras ng pagtatapos`,
    fr: `Fin des temps`,
    hi: `\u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{938}\u{92E}\u{92F}`,
    ht: `Fen tan`,
    it: `Fine dei tempi`,
    ja: `\u{7D42}\u{7109}`,
    ko: `\u{C885}\u{B9D0}`,
    mww: `Lub sijhawm xaus`,
    ps: `\u{62F} \u{67E}\u{627}\u{6CC} \u{648}\u{62E}\u{62A}`,
    pt: `Fim dos tempos`,
    'pt-pt': `Fim dos tempos`,
    ru: `\u{41A}\u{43E}\u{43D}\u{435}\u{446}`,
    sm: `Taimi faamutaina`,
    so: `Waqtiga dhammaadka`,
    th: `\u{E40}\u{E27}\u{E25}\u{E32}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645}\u{6CC} \u{648}\u{642}\u{62A}`,
    vi: `Th\u{1EDD}i gian k\u{1EBF}t th\xfac`,
    'zh-hans': `\u{672B}\u{65E5}`,
    'zh-hant': `\u{7D42}\u{7D50}\u{6642}\u{9593}`,
    en: `End time`
};
const $b11db1b62d4a8f76$export$35a92ba66af9f452 = {
    ar: `\u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644}`,
    de: `Einschreibung`,
    es: `Inscribirse`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645}`,
    fil: `Email Address *`,
    fr: `Inscrivez-vous`,
    hi: `\u{926}\u{93E}\u{916}\u{93F}\u{932}\u{93E} \u{932}\u{947}\u{928}\u{93E}`,
    ht: `Enskri`,
    it: `Iscriviti`,
    ja: `\u{5165}\u{5B66}`,
    ko: `\u{B4F1}\u{B85D}\u{D558}\u{C138}\u{C694}`,
    mww: `Sau npe`,
    ps: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645}`,
    pt: `Matricular-se`,
    'pt-pt': `Inscreva-se`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{430}\u{442}\u{44C}\u{441}\u{44F}`,
    sm: `Lesitala`,
    so: `Diiwaangelinta`,
    th: `\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}`,
    ur: `\u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{103}ng k\xfd`,
    'zh-hans': `\u{62A5}\u{540D}`,
    'zh-hant': `\u{5831}\u{540D}`,
    en: `Enroll`
};
const $b11db1b62d4a8f76$export$8b2e65d03b9395df = {
    ar: `\u{645}\u{633}\u{62C}\u{644}\u{648}\u{646}`,
    de: `Eingeschrieben`,
    es: `Matriculados`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{634}\u{62F}\u{647}`,
    fil: `Nagpatala`,
    fr: `Inscrit`,
    hi: `\u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{93F}\u{924}`,
    ht: `Enskri`,
    it: `Iscritti`,
    ja: `\u{5165}\u{5B66}\u{8005}`,
    ko: `\u{B4F1}\u{B85D}`,
    mww: `Sau npe`,
    ps: `\u{62B}\u{628}\u{62A} \u{634}\u{648}\u{6CC}`,
    pt: `Matriculados`,
    'pt-pt': `Inscritos`,
    ru: `\u{41F}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{438}\u{43B}`,
    sm: `Lesitala`,
    so: `Iska diiwaangelinta`,
    th: `\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{634}\u{62F}\u{6C1}`,
    vi: `\u{110}\xe3 ghi danh`,
    'zh-hans': `\u{6CE8}\u{518C}`,
    'zh-hant': `\u{8A3B}\u{518A}`,
    en: `Enrolled`
};
const $b11db1b62d4a8f76$export$65672aeb85122938 = {
    ar: (name)=>`\u{645}\u{633}\u{62C}\u{644} \u{641}\u{64A} ${name}`,
    de: (name)=>`Eingeschrieben mit ${name}`,
    es: (name)=>`Matriculado en ${name}`,
    fa: (name)=>`\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{628}\u{627} ${name}`,
    fil: (name)=>`Email: ${name}`,
    fr: (name)=>`Inscrit au ${name}`,
    hi: (name)=>`${name} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{93F}\u{924}`,
    ht: (name)=>`Enskri nan ${name}`,
    it: (name)=>`Iscritto al ${name}`,
    ja: (name)=>`${name}\u{306B}\u{767B}\u{9332}`,
    ko: (name)=>`${name}\u{C5D0} \u{B4F1}\u{B85D}\u{B428}`,
    mww: (name)=>`Sau npe nrog ${name}`,
    ps: (name)=>`\u{62F} ${name} \u{633}\u{631}\u{647} \u{62B}\u{628}\u{62A} \u{634}\u{648}\u{6CC}`,
    pt: (name)=>`Matriculado no ${name}`,
    'pt-pt': (name)=>`Inscrito no ${name}`,
    ru: (name)=>`\u{417}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D} \u{43F}\u{43E} ${name}`,
    sm: (name)=>`Lesitala i le ${name}`,
    so: (name)=>`Waxaa lagu diiwaangeliyey ${name}`,
    th: (name)=>`\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E01}\u{E31}\u{E1A} ${name}`,
    ur: (name)=>`${name} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: (name)=>`\u{110}\xe3 \u{111}\u{103}ng k\xfd v\u{1EDB}i ${name}`,
    'zh-hans': (name)=>`\u{6CE8}\u{518C}\u{7535}\u{8BDD}\u{4E3A} ${name}`,
    'zh-hant': (name)=>`\u{5DF2}\u{900F}\u{904E}${name}\u{5831}\u{540D}`,
    en: (name)=>`Enrolled with ${name}`
};
const $b11db1b62d4a8f76$export$5b1aa37b1a35964c = {
    ar: `\u{644}\u{627} \u{623}\u{633}\u{62A}\u{637}\u{64A}\u{639} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{649} \u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{630}\u{64A} \u{623}\u{628}\u{62D}\u{62B} \u{639}\u{646}\u{647}. \u{623}\u{62D}\u{62A}\u{627}\u{62C} \u{625}\u{644}\u{649} \u{625}\u{62F}\u{62E}\u{627}\u{644} \u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646} \u{64A}\u{62F}\u{648}\u{64A}\u{627}.`,
    de: `Ich finde die Adresse, die ich suche, nicht. Ich muss die Adresse manuell eingeben.`,
    es: `No encuentro la direcci\xf3n que busco. Necesito introducir la direcci\xf3n manualmente.`,
    fa: `\u{622}\u{62F}\u{631}\u{633}\u{6CC} \u{6A9}\u{647} \u{62F}\u{646}\u{628}\u{627}\u{644}\u{634} \u{647}\u{633}\u{62A}\u{645} \u{631}\u{627} \u{67E}\u{6CC}\u{62F}\u{627} \u{646}\u{645}\u{6CC} \u{6A9}\u{646}\u{645}. \u{628}\u{627}\u{6CC}\u{62F} \u{622}\u{62F}\u{631}\u{633} \u{631}\u{648} \u{62F}\u{633}\u{62A}\u{6CC} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{645}.`,
    fil: `Hindi ko mahanap ang address na hinahanap ko. Kailangan kong manu-manong ipasok ang address.`,
    fr: `Je ne trouve pas l\u{2019}adresse que je cherche. Je dois entrer l\u{2019}adresse manuellement.`,
    hi: `\u{92E}\u{941}\u{91D}\u{947} \u{935}\u{939} \u{92A}\u{924}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{93E} \u{939}\u{948} \u{91C}\u{93F}\u{938}\u{947} \u{92E}\u{948}\u{902} \u{922}\u{942}\u{902}\u{922} \u{930}\u{939}\u{93E} \u{939}\u{942}\u{902}\u{964} \u{92E}\u{941}\u{91D}\u{947} \u{92E}\u{948}\u{928}\u{94D}\u{92F}\u{941}\u{905}\u{932} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{92A}\u{924}\u{93E} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{928}\u{947} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Mwen pa ka jwenn adr\xe8s la mwen ap ch\xe8che pou. Mwen bezwen antre adr\xe8s la many\xe8lman.`,
    it: `Non riesco a trovare l'indirizzo che sto cercando. Devo inserire l'indirizzo manualmente.`,
    ja: `\u{63A2}\u{3057}\u{3066}\u{3044}\u{308B}\u{4F4F}\u{6240}\u{304C}\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}\u{4F4F}\u{6240}\u{3092}\u{624B}\u{52D5}\u{3067}\u{5165}\u{529B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{B0B4}\u{AC00} \u{CC3E}\u{B294} \u{C8FC}\u{C18C}\u{B97C} \u{BABB} \u{CC3E}\u{ACA0}\u{C5B4}. \u{C8FC}\u{C18C}\u{B97C} \u{C218}\u{B3D9}\u{C73C}\u{B85C} \u{C785}\u{B825}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Kuv nrhiav tsis tau qhov chaw nyob uas kuv tab tom nrhiav. Kuv yuav tsum tau sau qhov chaw nyob manually.`,
    ps: `\u{632}\u{647} \u{647}\u{63A}\u{647} \u{67E}\u{62A}\u{647} \u{646}\u{647} \u{634}\u{645} \u{645}\u{648}\u{646}\u{62F}\u{644}\u{6CC} \u{686}\u{6D0} \u{632}\u{647} \u{6CC}\u{6D0} \u{644}\u{67C}\u{648}\u{645}. \u{632}\u{647} \u{628}\u{627}\u{6CC}\u{62F} \u{67E}\u{62A}\u{647} \u{67E}\u{647} \u{644}\u{627}\u{633} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{645}.`,
    pt: `N\xe3o consigo encontrar o endere\xe7o que estou procurando. Preciso inserir o endere\xe7o manualmente.`,
    'pt-pt': `N\xe3o consigo encontrar a morada que procuro. Preciso de introduzir o endere\xe7o manualmente.`,
    ru: `\u{42F} \u{43D}\u{435} \u{43C}\u{43E}\u{433}\u{443} \u{43D}\u{430}\u{439}\u{442}\u{438} \u{43D}\u{443}\u{436}\u{43D}\u{44B}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441}. \u{41C}\u{43D}\u{435} \u{43D}\u{443}\u{436}\u{43D}\u{43E} \u{432}\u{432}\u{435}\u{441}\u{442}\u{438} \u{430}\u{434}\u{440}\u{435}\u{441} \u{432}\u{440}\u{443}\u{447}\u{43D}\u{443}\u{44E}.`,
    sm: `E le mafai ona ou mauaina le tuatusi o lo'o ou sailia. E tatau ona ou ulufale i le tuatusi i le lima.`,
    so: `Ma heli karo cinwaanka aan raadinayo. Waxaan u baahanahay inaan cinwaanka gacanta ku geliyo.`,
    th: `\u{E09}\u{E31}\u{E19}\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E35}\u{E48}\u{E09}\u{E31}\u{E19}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E21}\u{E2D}\u{E07}\u{E2B}\u{E32} \u{E09}\u{E31}\u{E19}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E14}\u{E49}\u{E27}\u{E22}\u{E15}\u{E19}\u{E40}\u{E2D}\u{E07}`,
    ur: `\u{645}\u{62C}\u{6BE}\u{6D2} \u{648}\u{6C1} \u{67E}\u{62A}\u{6C1} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{644} \u{631}\u{6C1}\u{627} \u{62C}\u{633} \u{6A9}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631} \u{631}\u{6C1}\u{627} \u{6C1}\u{648}\u{6BA}\u{6D4} \u{645}\u{62C}\u{6BE}\u{6D2} \u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633} \u{62F}\u{633}\u{62A}\u{6CC} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{646}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `T\xf4i kh\xf4ng th\u{1EC3} t\xecm th\u{1EA5}y \u{111}\u{1ECB}a ch\u{1EC9} m\xe0 t\xf4i \u{111}ang t\xecm ki\u{1EBF}m. T\xf4i c\u{1EA7}n nh\u{1EAD}p \u{111}\u{1ECB}a ch\u{1EC9} theo c\xe1ch th\u{1EE7} c\xf4ng.`,
    'zh-hans': `\u{6211}\u{627E}\u{4E0D}\u{5230}\u{6211}\u{8981}\u{627E}\u{7684}\u{5730}\u{5740}\u{3002}\u{6211}\u{9700}\u{8981}\u{624B}\u{52A8}\u{8F93}\u{5165}\u{5730}\u{5740}\u{3002}`,
    'zh-hant': `\u{6211}\u{627E}\u{4E0D}\u{5230}\u{6211}\u{8981}\u{627E}\u{7684}\u{5730}\u{5740}\u{3002}\u{6211}\u{9700}\u{8981}\u{624B}\u{52D5}\u{8F38}\u{5165}\u{5730}\u{5740}\u{3002}`,
    en: `I can't find the address I'm looking for. I need to enter the address manually.`
};
const $b11db1b62d4a8f76$export$65c54202207e2d18 = {
    ar: `\u{623}\u{62F}\u{62E}\u{644} \u{628}\u{631}\u{64A}\u{62F}\u{643} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{644}\u{62A}\u{635}\u{644}\u{643} \u{627}\u{644}\u{62E}\u{637}\u{648}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}\u{629}.`,
    de: `Geben Sie Ihre E-Mail-Adresse ein, um die n\xe4chsten Schritte zu erhalten.`,
    es: `Introduce tu correo electr\xf3nico para recibir los siguientes pasos.`,
    fa: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{62E}\u{648}\u{62F} \u{631}\u{627} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F} \u{62A}\u{627} \u{645}\u{631}\u{627}\u{62D}\u{644} \u{628}\u{639}\u{62F}\u{6CC} \u{631}\u{627} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Ipasok ang iyong email upang matanggap ang mga susunod na hakbang.`,
    fr: `Saisissez votre adresse e-mail pour recevoir les prochaines \xe9tapes.`,
    hi: `\u{905}\u{917}\u{932}\u{947} \u{91A}\u{930}\u{923} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{92A}\u{928}\u{93E} \u{908}\u{92E}\u{947}\u{932} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Antre im\xe8l ou pou resevwa pwochen etap yo.`,
    it: `Inserisci la tua email per ricevere i prossimi passi.`,
    ja: `\u{6B21}\u{306E}\u{30B9}\u{30C6}\u{30C3}\u{30D7}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{308B}\u{305F}\u{3081}\u{306B}\u{30E1}\u{30FC}\u{30EB}\u{30A2}\u{30C9}\u{30EC}\u{30B9}\u{3092}\u{5165}\u{529B}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{B2E4}\u{C74C} \u{B2E8}\u{ACC4}\u{B97C} \u{BC1B}\u{C73C}\u{B824}\u{BA74} \u{C774}\u{BA54}\u{C77C}\u{C744} \u{C785}\u{B825}\u{D558}\u{C138}\u{C694}.`,
    mww: `Sau koj tus email kom tau txais cov kauj ruam tom ntej.`,
    ps: `\u{62E}\u{67E}\u{644} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626} \u{62A}\u{631}\u{685}\u{648} \u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6CC} \u{6AB}\u{627}\u{645}\u{648}\u{646}\u{647} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{693}\u{626}.`,
    pt: `Insira seu e-mail para receber os pr\xf3ximos passos.`,
    'pt-pt': `Insira o seu email para receber os pr\xf3ximos passos.`,
    ru: `\u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{439} email, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{442}\u{44C} \u{434}\u{430}\u{43B}\u{44C}\u{43D}\u{435}\u{439}\u{448}\u{438}\u{435} \u{448}\u{430}\u{433}\u{438}.`,
    sm: `Ulufale i lau imeli e maua ai laasaga e sosoo ai.`,
    so: `Geli email-kaaga si aad u hesho tallaabooyinka xiga.`,
    th: `\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E23}\u{E31}\u{E1A}\u{E02}\u{E31}\u{E49}\u{E19}\u{E15}\u{E2D}\u{E19}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}`,
    ur: `\u{627}\u{6AF}\u{644}\u{6D2} \u{627}\u{642}\u{62F}\u{627}\u{645}\u{627}\u{62A} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{67E}\u{646}\u{627} \u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Nh\u{1EAD}p email c\u{1EE7}a b\u{1EA1}n \u{111}\u{1EC3} nh\u{1EAD}n c\xe1c b\u{1B0}\u{1EDB}c ti\u{1EBF}p theo.`,
    'zh-hans': `\u{8F93}\u{5165}\u{60A8}\u{7684}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{4EE5}\u{63A5}\u{6536}\u{4E0B}\u{4E00}\u{6B65}\u{6B65}\u{9AA4}\u{3002}`,
    'zh-hant': `\u{8ACB}\u{8F38}\u{5165}\u{60A8}\u{7684}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{4EE5}\u{63A5}\u{6536}\u{5F8C}\u{7E8C}\u{6B65}\u{9A5F}\u{3002}`,
    en: `Enter your email to receive next steps.`
};
const $b11db1b62d4a8f76$export$1238033b1df59ed5 = {
    ar: `\u{623}\u{62F}\u{62E}\u{644} \u{631}\u{645}\u{632} \u{627}\u{644}\u{645}\u{631}\u{629} \u{627}\u{644}\u{648}\u{627}\u{62D}\u{62F}\u{629} \u{645}\u{646} \u{62A}\u{637}\u{628}\u{64A}\u{642} \u{627}\u{644}\u{645}\u{635}\u{627}\u{62F}\u{642}\u{629} \u{627}\u{644}\u{62E}\u{627}\u{635} \u{628}\u{643}.`,
    de: `Geben Sie den Einmalcode aus Ihrer Authenticator-App ein.`,
    es: `Introduce el c\xf3digo de un solo uso desde tu aplicaci\xf3n de autenticaci\xf3n.`,
    fa: `\u{6A9}\u{62F} \u{6CC}\u{6A9} \u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641} \u{631}\u{627} \u{627}\u{632} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{627}\u{62D}\u{631}\u{627}\u{632} \u{647}\u{648}\u{6CC}\u{62A} \u{62E}\u{648}\u{62F} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Ipasok ang one-time code mula sa iyong authenticator app.`,
    fr: `Saisissez le code \xe0 usage unique depuis votre application d\u{2019}authentification.`,
    hi: `\u{905}\u{92A}\u{928}\u{947} \u{92A}\u{94D}\u{930}\u{92E}\u{93E}\u{923}\u{915} \u{910}\u{92A} \u{938}\u{947} \u{90F}\u{915} \u{92C}\u{93E}\u{930} \u{915}\u{93E} \u{915}\u{94B}\u{921} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Antre k\xf2d la yon s\xe8l-fwa soti nan app otantifikat\xe8 ou.`,
    it: `Inserisci il codice monouso dalla tua app autenticatrice.`,
    ja: `\u{8A8D}\u{8A3C}\u{30A2}\u{30D7}\u{30EA}\u{304B}\u{3089}\u{4E00}\u{5EA6}\u{304D}\u{308A}\u{306E}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{5165}\u{529B}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C778}\u{C99D} \u{C571}\u{C5D0}\u{C11C} \u{C77C}\u{D68C}\u{C6A9} \u{CF54}\u{B4DC}\u{B97C} \u{C785}\u{B825}\u{D558}\u{C138}\u{C694}.`,
    mww: `Sau tus lej ib zaug los ntawm koj lub authenticator app.`,
    ps: `\u{62F} \u{62E}\u{67E}\u{644} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{685}\u{62E}\u{647} \u{6CC}\u{648} \u{681}\u{644} \u{6A9}\u{648}\u{689} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626}.`,
    pt: `Insira o c\xf3digo de uso \xfanico do seu aplicativo autenticador.`,
    'pt-pt': `Insira o c\xf3digo de utiliza\xe7\xe3o \xfanica na sua aplica\xe7\xe3o de autentica\xe7\xe3o.`,
    ru: `\u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{43E}\u{434}\u{43D}\u{43E}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{44B}\u{439} \u{43A}\u{43E}\u{434} \u{438}\u{437} \u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{430}\u{443}\u{442}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{438}.`,
    sm: `Ulu atu i le code e tasi le taimi mai lau authenticator app.`,
    so: `Geli koodhka hal mar ee app-kaaga authenticator-ka.`,
    th: `\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E08}\u{E32}\u{E01}\u{E41}\u{E2D}\u{E1B}\u{E15}\u{E31}\u{E27}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E15}\u{E31}\u{E27}\u{E15}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{627}\u{67E}\u{646}\u{6D2} \u{622}\u{62A}\u{6BE}\u{646}\u{679}\u{6CC} \u{6A9}\u{6CC}\u{679}\u{631} \u{627}\u{6CC}\u{67E} \u{633}\u{6D2} \u{648}\u{646} \u{679}\u{627}\u{626}\u{645} \u{6A9}\u{648}\u{688} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Nh\u{1EAD}p m\xe3 d\xf9ng m\u{1ED9}t l\u{1EA7}n t\u{1EEB} \u{1EE9}ng d\u{1EE5}ng x\xe1c th\u{1EF1}c.`,
    'zh-hans': `\u{8F93}\u{5165}\u{4F60}\u{8BA4}\u{8BC1}\u{5668}\u{5E94}\u{7528}\u{4E2D}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{9A8C}\u{8BC1}\u{7801}\u{3002}`,
    'zh-hant': `\u{8F38}\u{5165}\u{4F60}\u{9A57}\u{8B49}\u{5668}\u{61C9}\u{7528}\u{7A0B}\u{5F0F}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{9A57}\u{8B49}\u{78BC}\u{3002}`,
    en: `Enter the one-time code from your authenticator app.`
};
const $b11db1b62d4a8f76$export$b389af0af99fc043 = {
    ar: (type)=>`\u{645}\u{62C}\u{627}\u{644} ${type}`,
    de: (type)=>`${type}`,
    es: (type)=>`${type}`,
    fa: (type)=>`\u{62D}\u{648}\u{632}\u{647} ${type}`,
    fil: (type)=>`Larangan ${type}`,
    fr: (type)=>`${type}`,
    hi: (type)=>`${type} \u{915}\u{94D}\u{937}\u{947}\u{924}\u{94D}\u{930}`,
    ht: (type)=>`${type} an`,
    it: (type)=>`Campo ${type}`,
    ja: (type)=>`${type}`,
    ko: (type)=>`${type} \u{BD84}\u{C57C}`,
    mww: (type)=>`${type} teb`,
    ps: (type)=>`${type} \u{633}\u{627}\u{62D}\u{647}`,
    pt: (type)=>`Campo ${type}`,
    'pt-pt': (type)=>`${type}`,
    ru: (type)=>`${type}`,
    sm: (type)=>`${type} fanua`,
    so: (type)=>`${type}`,
    th: (type)=>`\u{E1F}\u{E34}\u{E25}\u{E14}\u{E4C}${type}`,
    ur: (type)=>`${type} \u{645}\u{6CC}\u{62F}\u{627}\u{646}`,
    vi: (type)=>`L\u{129}nh v\u{1EF1}c ${type}`,
    'zh-hans': (type)=>`${type} \u{9886}\u{57DF}`,
    'zh-hant': (type)=>`${type} \u{9818}\u{57DF}`,
    en: (type)=>`${type} field`
};
const $b11db1b62d4a8f76$export$52452736f47d9d32 = {
    ar: (type)=>`\u{62A}\u{642}\u{631}\u{64A}\u{631} ${type}`,
    de: (type)=>`${type}`,
    es: (type)=>`Informe ${type}`,
    fa: (type)=>`\u{6AF}\u{632}\u{627}\u{631}\u{634} ${type}`,
    fil: (type)=>`Ulat ng ${type}`,
    fr: (type)=>`Rapport ${type}`,
    hi: (type)=>`${type} \u{915}\u{940} \u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F}`,
    ht: (type)=>`${type} an`,
    it: (type)=>`Rapporto ${type}`,
    ja: (type)=>`${type} \u{5831}\u{544A}`,
    ko: (type)=>`${type} \u{BCF4}\u{ACE0}\u{C11C}`,
    mww: (type)=>`${type}`,
    ps: (type)=>`${type} \u{631}\u{627}\u{67E}\u{648}\u{631}`,
    pt: (type)=>`Relat\xf3rio ${type}`,
    'pt-pt': (type)=>`Relat\xf3rio ${type}`,
    ru: (type)=>`${type}`,
    sm: (type)=>`Lipoti a ${type}`,
    so: (type)=>`${type}`,
    th: (type)=>`\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}${type}`,
    ur: (type)=>`${type} \u{631}\u{67E}\u{648}\u{631}\u{679}`,
    vi: (type)=>`B\xe1o c\xe1o ${type}`,
    'zh-hans': (type)=>`${type} \u{62A5}\u{544A}`,
    'zh-hant': (type)=>`${type} \u{5831}\u{544A}`,
    en: (type)=>`${type} report`
};
const $b11db1b62d4a8f76$export$7cb726a88b5ad586 = {
    ar: `\u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{627}\u{62A}`,
    de: `Eintr\xe4ge`,
    es: `Inscripciones`,
    fa: `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{647}\u{627}`,
    fil: `Mga Entry`,
    fr: `Participations`,
    hi: `\u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `Antre yo`,
    it: `Iscrizioni`,
    ja: `\u{30A8}\u{30F3}\u{30C8}\u{30EA}\u{30FC}`,
    ko: `\u{CD9C}\u{C804}`,
    mww: `Nkag`,
    ps: `\u{62F}\u{627}\u{62E}\u{644}\u{6D0}`,
    pt: `Inscri\xe7\xf5es`,
    'pt-pt': `Inscri\xe7\xf5es`,
    ru: `\u{423}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{438}`,
    sm: `Ulufale`,
    so: `Diiwaangelinta`,
    th: `\u{E1C}\u{E25}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C}\u{627}\u{62A}`,
    vi: `B\xe0i d\u{1EF1} thi`,
    'zh-hans': `\u{53C2}\u{8D5B}\u{4F5C}\u{54C1}`,
    'zh-hant': `\u{53C3}\u{8CFD}\u{4F5C}\u{54C1}`,
    en: `Entries`
};
const $b11db1b62d4a8f76$export$1568d17c0bd54353 = {
    ar: `\u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644}`,
    de: `Eintritt`,
    es: `Entrada`,
    fa: `\u{648}\u{631}\u{648}\u{62F}`,
    fil: `Entry`,
    fr: `Entr\xe9e`,
    hi: `\u{92A}\u{94D}\u{930}\u{935}\u{947}\u{936}-\u{926}\u{94D}\u{935}\u{93E}\u{930}`,
    ht: `Antre`,
    it: `Partecipazione`,
    ja: `\u{30A8}\u{30F3}\u{30C8}\u{30EA}\u{30FC}`,
    ko: `\u{C785}\u{AD6D}`,
    mww: `Nkag mus`,
    ps: `\u{62F}\u{627}\u{62E}\u{644}\u{6D0}`,
    pt: `Entrada`,
    'pt-pt': `Entrada`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Ulufale`,
    so: `Gelitaanka`,
    th: `\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{627}\u{646}\u{679}\u{631}\u{6CC}`,
    vi: `Nh\u{1EAD}p c\u{1EA3}nh`,
    'zh-hans': `\u{53C2}\u{8D5B}`,
    'zh-hant': `\u{53C3}\u{8CFD}`,
    en: `Entry`
};
const $b11db1b62d4a8f76$export$6f53e2157c028eb0 = {
    ar: `\u{627}\u{644}\u{645}\u{62F}\u{62E}\u{644} \u{627}\u{644}\u{639}\u{627}\u{634}\u{631}`,
    de: `Eintrag X`,
    es: `Entrada X`,
    fa: `\u{648}\u{631}\u{648}\u{62F}\u{6CC} X`,
    fil: `Entry X`,
    fr: `Entr\xe9e X`,
    hi: `\u{92A}\u{94D}\u{930}\u{935}\u{947}\u{936} X`,
    ht: `Antre X`,
    it: `Voce X`,
    ja: `\u{30A8}\u{30F3}\u{30C8}\u{30EA}\u{30FC}X`,
    ko: `\u{AE30}\u{B85D} X`,
    mww: `Nkag X`,
    ps: `\u{646}\u{646}\u{648}\u{62A} X`,
    pt: `Entrada X`,
    'pt-pt': `Entrada X`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C} X`,
    sm: `Ulufale X`,
    so: `Gelitaanka X`,
    th: `\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23} X`,
    ur: `\u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} X`,
    vi: `M\u{1EE5}c X`,
    'zh-hans': `\u{6761}\u{76EE}X\u{3002}`,
    'zh-hant': `\u{689D}\u{76EE}X\u{3002}`,
    en: `Entry X`
};
const $b11db1b62d4a8f76$export$b107d9e8ea84b92a = {
    ar: `\u{627}\u{644}\u{645}\u{62F}\u{62E}\u{644} Y`,
    de: `Eintrag Y`,
    es: `Entrada Y`,
    fa: `\u{648}\u{631}\u{648}\u{62F}\u{6CC} Y`,
    fil: `Entry Y`,
    fr: `Entr\xe9e Y`,
    hi: `\u{92A}\u{94D}\u{930}\u{935}\u{947}\u{936} Y`,
    ht: `Antre Y`,
    it: `Voce Y`,
    ja: `\u{30A8}\u{30F3}\u{30C8}\u{30EA}\u{30FC} Y`,
    ko: `\u{D56D}\u{BAA9} Y`,
    mww: `Nkag Y`,
    ps: `\u{62F}\u{627}\u{62E}\u{644}\u{6CC} Y`,
    pt: `Entrada Y`,
    'pt-pt': `Entrada Y`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C} Y`,
    sm: `Ulufale Y`,
    so: `Gelitaanka Y`,
    th: `\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23} Y`,
    ur: `\u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} Y`,
    vi: `M\u{1EE5}c nh\u{1EAD}p Y`,
    'zh-hans': `\u{6761}\u{76EE} Y`,
    'zh-hant': `\u{689D}\u{76EE} Y`,
    en: `Entry Y`
};
const $b11db1b62d4a8f76$export$83664f80d17a8cfa = {
    ar: `\u{62E}\u{637}\u{623}`,
    de: `Fehler`,
    es: `Error`,
    fa: `\u{62E}\u{637}\u{627}`,
    fil: `Error`,
    fr: `Erreur`,
    hi: `\u{91A}\u{942}\u{915}`,
    ht: `Er\xe8`,
    it: `Errore`,
    ja: `\u{30A8}\u{30E9}\u{30FC}`,
    ko: `\u{C624}\u{B958}`,
    mww: `yuam kev`,
    ps: `\u{62A}\u{6D0}\u{631}\u{648}\u{62A}\u{646}\u{647}`,
    pt: `Erro`,
    'pt-pt': `Erro`,
    ru: `\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430}`,
    sm: `Mea sese`,
    so: `Khalad`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}`,
    ur: `\u{63A}\u{644}\u{637}\u{6CC}`,
    vi: `l\u{1ED7}i`,
    'zh-hans': `\u{9519}\u{8BEF}`,
    'zh-hant': `\u{932F}\u{8AA4}`,
    en: `Error`
};
const $b11db1b62d4a8f76$export$d4871e941f765117 = {
    ar: (cumulus)=>`\u{627}\u{62E}\u{62A}\u{631} \u{623}\u{62D}\u{62F} \u{627}\u{644}\u{631}\u{648}\u{627}\u{628}\u{637} \u{623}\u{62F}\u{646}\u{627}\u{647} \u{644}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{649} \u{645}\u{646}\u{637}\u{642}\u{629} \u{623}\u{62E}\u{631}\u{649} \u{645}\u{646} ${cumulus}.`,
    de: (cumulus)=>`W\xe4hlen Sie einen der untenstehenden Links, um auf einen weiteren ${cumulus} zuzugreifen.`,
    es: (cumulus)=>`Selecciona uno de los enlaces a continuaci\xf3n para acceder a otra zona de ${cumulus}.`,
    fa: (cumulus)=>`\u{6CC}\u{6A9}\u{6CC} \u{627}\u{632} \u{644}\u{6CC}\u{646}\u{6A9} \u{647}\u{627}\u{6CC} \u{632}\u{6CC}\u{631} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F} \u{62A}\u{627} \u{628}\u{647} \u{645}\u{646}\u{637}\u{642}\u{647} \u{62F}\u{6CC}\u{6AF}\u{631}\u{6CC} \u{627}\u{632} ${cumulus} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: (cumulus)=>`Pumili ng isa sa mga link sa ibaba upang ma-access ang isa pang lugar ng ${cumulus}.`,
    fr: (cumulus)=>`S\xe9lectionnez l\u{2019}un des liens ci-dessous pour acc\xe9der \xe0 une autre zone de ${cumulus}.`,
    hi: (cumulus)=>`${cumulus} \u{915}\u{947} \u{915}\u{93F}\u{938}\u{940} \u{905}\u{928}\u{94D}\u{92F} \u{915}\u{94D}\u{937}\u{947}\u{924}\u{94D}\u{930} \u{924}\u{915} \u{92A}\u{939}\u{941}\u{902}\u{91A}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{928}\u{940}\u{91A}\u{947} \u{926}\u{93F}\u{90F} \u{917}\u{90F} \u{932}\u{93F}\u{902}\u{915} \u{92E}\u{947}\u{902} \u{938}\u{947} \u{90F}\u{915} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: (cumulus)=>`Chwazi youn nan lyen ki anba yo jwenn aks\xe8 nan yon l\xf2t z\xf2n ${cumulus}.`,
    it: (cumulus)=>`Seleziona uno dei link qui sotto per accedere a un'altra area di ${cumulus}.`,
    ja: (cumulus)=>`\u{4E0B}\u{306E}\u{30EA}\u{30F3}\u{30AF}\u{306E}\u{3044}\u{305A}\u{308C}\u{304B}\u{3092}\u{9078}\u{629E}\u{3057}\u{3066}\u{3001} ${cumulus}\u{306E}\u{5225}\u{306E}\u{30A8}\u{30EA}\u{30A2}\u{306B}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: (cumulus)=>`\u{C544}\u{B798} \u{B9C1}\u{D06C} \u{C911} \u{D558}\u{B098}\u{B97C} \u{C120}\u{D0DD}\u{D558}\u{C5EC} ${cumulus}\u{C758} \u{B2E4}\u{B978} \u{C601}\u{C5ED}\u{C5D0} \u{C811}\u{C18D}\u{D558}\u{C138}\u{C694}.`,
    mww: (cumulus)=>`Xaiv ib qho ntawm cov kev txuas hauv qab no kom nkag mus rau lwm qhov chaw ntawm ${cumulus}.`,
    ps: (cumulus)=>`\u{644}\u{627}\u{646}\u{62F}\u{6D0} \u{644}\u{6CC}\u{646}\u{6A9}\u{648}\u{646}\u{648} \u{685}\u{62E}\u{647} \u{6CC}\u{648} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626} \u{62A}\u{631}\u{685}\u{648} \u{62F} ${cumulus} \u{628}\u{644}\u{6D0} \u{633}\u{6CC}\u{645}\u{6D0} \u{62A}\u{647} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{648}\u{644}\u{631}\u{626}.`,
    pt: (cumulus)=>`Selecione um dos links abaixo para acessar outra \xe1rea de ${cumulus}.`,
    'pt-pt': (cumulus)=>`Selecione um dos links abaixo para aceder a outra \xe1rea de ${cumulus}.`,
    ru: (cumulus)=>`\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{43E}\u{434}\u{43D}\u{443} \u{438}\u{437} \u{441}\u{441}\u{44B}\u{43B}\u{43E}\u{43A} \u{43D}\u{438}\u{436}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{43A} \u{434}\u{440}\u{443}\u{433}\u{43E}\u{439} \u{447}\u{430}\u{441}\u{442}\u{438} ${cumulus}.`,
    sm: (cumulus)=>`Filifili se tasi o feso'ota'iga o lo'o i lalo e ulufale ai i se isi vaega o ${cumulus}.`,
    so: (cumulus)=>`Dooro mid ka mid ah xiriiriyeyaasha hoose si aad u gasho aag kale oo ${cumulus} ah.`,
    th: (cumulus)=>`\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E43}\u{E14}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E14}\u{E49}\u{E32}\u{E19}\u{E25}\u{E48}\u{E32}\u{E07}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E1E}\u{E37}\u{E49}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E02}\u{E2D}\u{E07} ${cumulus}`,
    ur: (cumulus)=>`\u{646}\u{6CC}\u{686}\u{6D2} \u{62F}\u{6CC}\u{6D2} \u{6AF}\u{626}\u{6D2} \u{644}\u{646}\u{6A9}\u{633} \u{645}\u{6CC}\u{6BA} \u{633}\u{6D2} \u{6A9}\u{633}\u{6CC} \u{627}\u{6CC}\u{6A9} \u{6A9}\u{648} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{62A}\u{627}\u{6A9}\u{6C1} ${cumulus} \u{6A9}\u{6D2} \u{62F}\u{648}\u{633}\u{631}\u{6D2} \u{639}\u{644}\u{627}\u{642}\u{6D2} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{6CC} \u{62C}\u{627} \u{633}\u{6A9}\u{6D2}\u{6D4}`,
    vi: (cumulus)=>`Ch\u{1ECD}n m\u{1ED9}t trong c\xe1c li\xean k\u{1EBF}t b\xean d\u{1B0}\u{1EDB}i \u{111}\u{1EC3} truy c\u{1EAD}p m\u{1ED9}t khu v\u{1EF1}c kh\xe1c c\u{1EE7}a ${cumulus}.`,
    'zh-hans': (cumulus)=>`\u{8BF7}\u{9009}\u{62E9}\u{4EE5}\u{4E0B}\u{94FE}\u{63A5}\u{4E4B}\u{4E00}\u{FF0C}\u{8BBF}\u{95EE} ${cumulus}\u{7684}\u{53E6}\u{4E00}\u{4E2A}\u{533A}\u{57DF}\u{3002}`,
    'zh-hant': (cumulus)=>`\u{8ACB}\u{9078}\u{64C7}\u{4EE5}\u{4E0B}\u{9023}\u{7D50}\u{4E4B}\u{4E00}\u{FF0C}\u{5373}\u{53EF}\u{9032}\u{5165} ${cumulus} \u{7684}\u{53E6}\u{4E00}\u{500B}\u{5340}\u{57DF}\u{3002}`,
    en: (cumulus)=>`Select one of the links below to access another area of ${cumulus}.`
};
const $b11db1b62d4a8f76$export$ab5742ac4d4c8094 = {
    ar: `\u{627}\u{644}\u{639}\u{631}\u{642}`,
    de: `Ethnizit\xe4t`,
    es: `Etnia`,
    fa: `\u{642}\u{648}\u{645}\u{6CC}\u{62A}`,
    fil: `Etnisidad`,
    fr: `Ethnicit\xe9`,
    hi: `\u{91C}\u{93E}\u{924}\u{940}\u{92F}\u{924}\u{93E}`,
    ht: `Etnisite`,
    it: `Etnicit\xe0`,
    ja: `\u{6C11}\u{65CF}`,
    ko: `\u{BBFC}\u{C871}`,
    mww: `Haiv Neeg`,
    ps: `\u{642}\u{648}\u{645}\u{6CC}\u{62A}`,
    pt: `Etnia`,
    'pt-pt': `Etnia`,
    ru: `\u{42D}\u{442}\u{43D}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{430}\u{44F} \u{43F}\u{440}\u{438}\u{43D}\u{430}\u{434}\u{43B}\u{435}\u{436}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Ituaiga`,
    so: `Qowmiyad`,
    th: `\u{E40}\u{E0A}\u{E37}\u{E49}\u{E2D}\u{E0A}\u{E32}\u{E15}\u{E34}`,
    ur: `\u{646}\u{633}\u{644}\u{6CC} \u{634}\u{646}\u{627}\u{62E}\u{62A}`,
    vi: `D\xe2n t\u{1ED9}c`,
    'zh-hans': `\u{65CF}\u{88D4}`,
    'zh-hant': `\u{65CF}\u{7FA4}`,
    en: `Ethnicity`
};
const $b11db1b62d4a8f76$export$c1de9343f1c61b4e = {
    ar: `\u{627}\u{644}\u{62D}\u{62F}\u{62B}`,
    de: `Veranstaltung`,
    es: `Evento`,
    fa: `\u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}`,
    fil: `Kaganapan`,
    fr: `\xc9v\xe9nement`,
    hi: `\u{906}\u{92F}\u{94B}\u{91C}\u{928}`,
    ht: `Ev\xe8nman an`,
    it: `Evento`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}`,
    ko: `\u{D589}\u{C0AC}`,
    mww: `Kev tshwm sim`,
    ps: `\u{67E}\u{6CC}\u{69A}\u{647}`,
    pt: `Evento`,
    'pt-pt': `Evento`,
    ru: `\u{421}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{435}`,
    sm: `Mea na tupu`,
    so: `Dhacdo`,
    th: `\u{E40}\u{E2B}\u{E15}\u{E38}\u{E01}\u{E32}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{62A}\u{642}\u{631}\u{6CC}\u{628}`,
    vi: `S\u{1EF1} ki\u{1EC7}n`,
    'zh-hans': `\u{4E8B}\u{4EF6}`,
    'zh-hant': `\u{6D3B}\u{52D5}`,
    en: `Event`
};
const $b11db1b62d4a8f76$export$549aaa164d88224e = {
    ar: `\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644} \u{627}\u{644}\u{62D}\u{62F}\u{62B}`,
    de: `Veranstaltungsdetails`,
    es: `Detalles del evento`,
    fa: `\u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}`,
    fil: `Mga detalye ng kaganapan`,
    fr: `D\xe9tails de l\u{2019}\xe9v\xe9nement`,
    hi: `\u{918}\u{91F}\u{928}\u{93E} \u{935}\u{93F}\u{935}\u{930}\u{923}`,
    ht: `Detay ev\xe8nman an`,
    it: `Dettagli dell'evento`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306E}\u{8A73}\u{7D30}`,
    ko: `\u{D589}\u{C0AC} \u{C138}\u{BD80} \u{C815}\u{BCF4}`,
    mww: `Cov ntsiab lus xwm txheej`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{69A}\u{6D0} \u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    pt: `Detalhes do evento`,
    'pt-pt': `Detalhes do evento`,
    ru: `\u{41F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F}`,
    sm: `Auiliiliga o mea na tutupu`,
    so: `Faahfaahinta dhacdada`,
    th: `\u{E23}\u{E32}\u{E22}\u{E25}\u{E30}\u{E40}\u{E2D}\u{E35}\u{E22}\u{E14}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{627}\u{6CC}\u{648}\u{646}\u{679} \u{6A9}\u{6CC} \u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    vi: `Chi ti\u{1EBF}t s\u{1EF1} ki\u{1EC7}n`,
    'zh-hans': `\u{6D3B}\u{52A8}\u{8BE6}\u{60C5}`,
    'zh-hant': `\u{6D3B}\u{52D5}\u{8A73}\u{60C5}`,
    en: `Event details`
};
const $b11db1b62d4a8f76$export$da4501150c96ef27 = {
    ar: `\u{644}\u{642}\u{62F} \u{648}\u{635}\u{644}\u{62A}\u{645} \u{628}\u{627}\u{644}\u{631}\u{643}\u{628}`,
    de: `Du bist ganz auf dem neuesten Stand`,
    es: `Ya est\xe1is al d\xeda`,
    fa: `\u{647}\u{645}\u{647} \u{686}\u{6CC}\u{632} \u{631}\u{648} \u{628}\u{647} \u{631}\u{648}\u{632} \u{6A9}\u{631}\u{62F}\u{6CC}`,
    fil: `Nakahabol ka na`,
    fr: `Tu es \xe0 jour`,
    hi: `\u{924}\u{941}\u{92E} \u{938}\u{92C} \u{909}\u{932}\u{91D}\u{947} \u{939}\u{941}\u{90F} \u{939}\u{94B}`,
    ht: `Nou tout kenbe`,
    it: `Sei completamente aggiornato`,
    ja: `\u{3082}\u{3046}\u{5168}\u{90E8}\u{8FFD}\u{3044}\u{3064}\u{3044}\u{305F}\u{3088}`,
    ko: `\u{B2E4} \u{B530}\u{B77C}\u{C7A1}\u{C558}\u{B124}`,
    mww: `Koj twb paub tag lawm`,
    ps: `\u{62A}\u{647} \u{67C}\u{648}\u{644} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{693}\u{6D0}`,
    pt: `Voc\xea est\xe1 totalmente em dia`,
    'pt-pt': `J\xe1 est\xe1s em dia`,
    ru: `\u{412}\u{44B} \u{432}\u{441}\u{451} \u{432} \u{43A}\u{443}\u{440}\u{441}\u{435}`,
    sm: `Ua outou maua uma i luga`,
    so: `Dhammaan waad la socotaa`,
    th: `\u{E04}\u{E38}\u{E13}\u{E15}\u{E32}\u{E21}\u{E17}\u{E31}\u{E19}\u{E2B}\u{E21}\u{E14}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{622}\u{67E} \u{633}\u{628} \u{6A9}\u{686}\u{6BE} \u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6A9}\u{631} \u{686}\u{6A9}\u{6D2} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `B\u{1EA1}n \u{111}\xe3 n\u{1EAF}m b\u{1EAF}t h\u{1EBF}t r\u{1ED3}i`,
    'zh-hans': `\u{4F60}\u{90FD}\u{8DDF}\u{4E0A}\u{4E86}`,
    'zh-hant': `\u{4F60}\u{5DF2}\u{7D93}\u{5168}\u{90E8}\u{8FFD}\u{4E0A}\u{9032}\u{5EA6}\u{4E86}`,
    en: `You're all caught up`
};
const $b11db1b62d4a8f76$export$d268bce29d80a46f = {
    ar: `\u{627}\u{643}\u{62A}\u{645}\u{627}\u{644} \u{627}\u{644}\u{62D}\u{62F}\u{62B}`,
    de: `Veranstaltung abgeschlossen`,
    es: `Evento completado`,
    fa: `\u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{6A9}\u{627}\u{645}\u{644} \u{634}\u{62F}`,
    fil: `Natapos na ang kaganapan`,
    fr: `\xc9v\xe9nement termin\xe9`,
    hi: `\u{918}\u{91F}\u{928}\u{93E} \u{92A}\u{942}\u{930}\u{94D}\u{923}`,
    ht: `Ev\xe8nman konpl\xe8`,
    it: `Evento completato`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{5B8C}\u{4E86}`,
    ko: `\u{C774}\u{BCA4}\u{D2B8} \u{C644}\u{B8CC}`,
    mww: `Kev tshwm sim tiav lawm`,
    ps: `\u{67E}\u{6CC}\u{69A}\u{647} \u{628}\u{634}\u{67E}\u{693}\u{647} \u{634}\u{648}\u{647}`,
    pt: `Evento conclu\xeddo`,
    'pt-pt': `Evento conclu\xeddo`,
    ru: `\u{41C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43E}`,
    sm: `Mae'a le mea na tupu`,
    so: `Dhacdada la dhammeystiray`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{627}\u{6CC}\u{648}\u{646}\u{679} \u{645}\u{6A9}\u{645}\u{644}`,
    vi: `S\u{1EF1} ki\u{1EC7}n ho\xe0n th\xe0nh`,
    'zh-hans': `\u{6D3B}\u{52A8}\u{7ED3}\u{675F}`,
    'zh-hant': `\u{6D3B}\u{52D5}\u{5B8C}\u{6210}`,
    en: `Event complete`
};
const $b11db1b62d4a8f76$export$dbb41c103af33749 = {
    ar: `\u{627}\u{646}\u{62A}\u{647}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62D}\u{62F}\u{62B}.`,
    de: `Dieses Ereignis ist beendet.`,
    es: `Este evento ha terminado.`,
    fa: `\u{627}\u{6CC}\u{646} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{628}\u{647} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{631}\u{633}\u{6CC}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Tapos na ang kaganapang ito.`,
    fr: `Cet \xe9v\xe9nement est termin\xe9.`,
    hi: `\u{92F}\u{939} \u{918}\u{91F}\u{928}\u{93E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{917}\u{908} \u{939}\u{948}\u{964}`,
    ht: `Ev\xe8nman sa a te fini.`,
    it: `Questo evento \xe8 finito.`,
    ja: `\u{3053}\u{306E}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306F}\u{7D42}\u{4E86}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D589}\u{C0AC}\u{B294} \u{B05D}\u{B0AC}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kev tshwm sim no twb xaus lawm.`,
    ps: `\u{62F}\u{627} \u{67E}\u{6CC}\u{69A}\u{647} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{6D0}\u{62F}\u{647}.`,
    pt: `Este evento acabou.`,
    'pt-pt': `Este evento terminou.`,
    ru: `\u{42D}\u{442}\u{43E} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435} \u{437}\u{430}\u{43A}\u{43E}\u{43D}\u{447}\u{438}\u{43B}\u{43E}\u{441}\u{44C}.`,
    sm: `Ua mae'a lenei mea na tupu.`,
    so: `Dhacdadan waa dhammaatay.`,
    th: `\u{E07}\u{E32}\u{E19}\u{E19}\u{E35}\u{E49}\u{E08}\u{E1A}\u{E25}\u{E07}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{6CC}\u{6C1} \u{648}\u{627}\u{642}\u{639}\u{6C1} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{686}\u{6A9}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `S\u{1EF1} ki\u{1EC7}n n\xe0y \u{111}\xe3 k\u{1EBF}t th\xfac.`,
    'zh-hans': `\u{8FD9}\u{4E2A}\u{6D3B}\u{52A8}\u{5DF2}\u{7ECF}\u{7ED3}\u{675F}\u{3002}`,
    'zh-hant': `\u{9019}\u{500B}\u{6D3B}\u{52D5}\u{5DF2}\u{7D93}\u{7D50}\u{675F}\u{4E86}\u{3002}`,
    en: `This event has ended.`
};
const $b11db1b62d4a8f76$export$de041e483895f9f1 = {
    ar: `\u{645}\u{646} \u{62E}\u{644}\u{627}\u{644} \u{62A}\u{642}\u{62F}\u{64A}\u{645} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{645}\u{648}\u{630}\u{62C}\u{60C} \u{62A}\u{648}\u{627}\u{641}\u{642} \u{639}\u{644}\u{649} \u{62A}\u{644}\u{642}\u{64A} \u{631}\u{633}\u{627}\u{626}\u{644} \u{628}\u{631}\u{64A}\u{62F} \u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{62D}\u{648}\u{644} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62D}\u{62F}\u{62B}\u{60C} \u{628}\u{645}\u{627} \u{641}\u{64A} \u{630}\u{644}\u{643} \u{62A}\u{62D}\u{62F}\u{64A}\u{62B}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644}\u{60C} \u{648}\u{627}\u{644}\u{646}\u{645}\u{627}\u{630}\u{62C} \u{627}\u{644}\u{645}\u{637}\u{644}\u{648}\u{628}\u{629}\u{60C} \u{648}\u{62A}\u{63A}\u{64A}\u{64A}\u{631}\u{627}\u{62A} \u{627}\u{644}\u{62C}\u{62F}\u{648}\u{644}\u{60C} \u{648}\u{627}\u{644}\u{62A}\u{630}\u{643}\u{64A}\u{631}\u{627}\u{62A}.`,
    de: `Mit dem Einreichen dieses Formulars stimmen Sie zu, E-Mails zu dieser Veranstaltung zu erhalten, einschlie\xdflich Aktualisierungen zur Anmeldung, erforderlichen Formularen, Termin\xe4nderungen und Erinnerungen.`,
    es: `Al enviar este formulario, aceptas recibir correos electr\xf3nicos sobre este evento, incluyendo actualizaciones sobre inscripciones, formularios obligatorios, cambios de horario y recordatorios.`,
    fa: `\u{628}\u{627} \u{627}\u{631}\u{633}\u{627}\u{644} \u{627}\u{6CC}\u{646} \u{641}\u{631}\u{645}\u{60C} \u{634}\u{645}\u{627} \u{645}\u{648}\u{627}\u{641}\u{642}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{6A9}\u{647} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{647}\u{627}\u{6CC}\u{6CC} \u{62F}\u{631}\u{628}\u{627}\u{631}\u{647} \u{627}\u{6CC}\u{646} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{646}\u{6CC}\u{62F}\u{60C} \u{627}\u{632} \u{62C}\u{645}\u{644}\u{647} \u{628}\u{647} \u{631}\u{648}\u{632}\u{631}\u{633}\u{627}\u{646}\u{6CC} \u{647}\u{627}\u{6CC} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645}\u{60C} \u{641}\u{631}\u{645} \u{647}\u{627}\u{6CC} \u{627}\u{644}\u{632}\u{627}\u{645}\u{6CC}\u{60C} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631}\u{627}\u{62A} \u{628}\u{631}\u{646}\u{627}\u{645}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{648} \u{6CC}\u{627}\u{62F}\u{622}\u{648}\u{631}\u{6CC} \u{647}\u{627}.`,
    fil: `Sa pagsusumite ng form na ito, sumasang-ayon kang makatanggap ng mga email tungkol sa event na ito, kabilang ang mga update sa enrollment, mga kinakailangang form, pagbabago sa iskedyul, at mga paalala.`,
    fr: `En soumettant ce formulaire, vous acceptez de recevoir des e-mails concernant cet \xe9v\xe9nement, incluant des mises \xe0 jour sur les inscriptions, les formulaires obligatoires, les modifications du calendrier et les rappels.`,
    hi: `\u{907}\u{938} \u{92B}\u{949}\u{930}\u{94D}\u{92E} \u{915}\u{94B} \u{938}\u{92C}\u{92E}\u{93F}\u{91F} \u{915}\u{930}\u{915}\u{947}, \u{906}\u{92A} \u{907}\u{938} \u{908}\u{935}\u{947}\u{902}\u{91F} \u{915}\u{947} \u{92C}\u{93E}\u{930}\u{947} \u{92E}\u{947}\u{902} \u{908}\u{92E}\u{947}\u{932} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{939}\u{92E}\u{924} \u{939}\u{94B}\u{924}\u{947} \u{939}\u{948}\u{902}, \u{91C}\u{93F}\u{938}\u{92E}\u{947}\u{902} \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{928} \u{905}\u{92A}\u{921}\u{947}\u{91F}, \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915} \u{92B}\u{949}\u{930}\u{94D}\u{92E}, \u{936}\u{947}\u{921}\u{94D}\u{92F}\u{942}\u{932} \u{92A}\u{930}\u{93F}\u{935}\u{930}\u{94D}\u{924}\u{928} \u{914}\u{930} \u{905}\u{928}\u{941}\u{938}\u{94D}\u{92E}\u{93E}\u{930}\u{915} \u{936}\u{93E}\u{92E}\u{93F}\u{932} \u{939}\u{948}\u{902}\u{964}`,
    ht: `L\xe8 w soum\xe8t f\xf2m sa a, ou dak\xf2 pou resevwa im\xe8l sou ev\xe8nman sa a, ki gen ladan mizajou enskripsyon, f\xf2m obligatwa, chanjman or\xe8 ak rap\xe8l.`,
    it: `Inviando questo modulo, accetti di ricevere email relative a questo evento, inclusi aggiornamenti sulle iscrizioni, moduli richiesti, modifiche al calendario e promemoria.`,
    ja: `\u{3053}\u{306E}\u{30D5}\u{30A9}\u{30FC}\u{30E0}\u{3092}\u{63D0}\u{51FA}\u{3059}\u{308B}\u{3053}\u{3068}\u{3067}\u{3001}\u{767B}\u{9332}\u{72B6}\u{6CC1}\u{306E}\u{66F4}\u{65B0}\u{3001}\u{5FC5}\u{8981}\u{306A}\u{30D5}\u{30A9}\u{30FC}\u{30E0}\u{3001}\u{30B9}\u{30B1}\u{30B8}\u{30E5}\u{30FC}\u{30EB}\u{5909}\u{66F4}\u{3001}\u{30EA}\u{30DE}\u{30A4}\u{30F3}\u{30C0}\u{30FC}\u{306A}\u{3069}\u{306E}\u{30E1}\u{30FC}\u{30EB}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{308B}\u{3053}\u{3068}\u{306B}\u{540C}\u{610F}\u{3057}\u{305F}\u{3053}\u{3068}\u{306B}\u{306A}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{C591}\u{C2DD}\u{C744} \u{C81C}\u{CD9C}\u{D568}\u{C73C}\u{B85C}\u{C368} \u{B4F1}\u{B85D} \u{C5C5}\u{B370}\u{C774}\u{D2B8}, \u{D544}\u{C218} \u{C591}\u{C2DD}, \u{C77C}\u{C815} \u{BCC0}\u{ACBD} \u{BC0F} \u{C54C}\u{B9BC} \u{B4F1} \u{C774} \u{D589}\u{C0AC}\u{C5D0} \u{AD00}\u{D55C} \u{C774}\u{BA54}\u{C77C}\u{C744} \u{BC1B}\u{AE30}\u{B85C} \u{B3D9}\u{C758}\u{D558}\u{B294} \u{AC83}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Los ntawm kev xa daim foos no, koj pom zoo txais email txog qhov kev tshwm sim no, suav nrog kev hloov tshiab sau npe, cov foos tsim nyog, hloov sijhawm, thiab kev ceeb toom.`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{641}\u{648}\u{631}\u{645}\u{6D0} \u{633}\u{67E}\u{627}\u{631}\u{644}\u{648} \u{633}\u{631}\u{647}\u{60C} \u{62A}\u{627}\u{633}\u{648} \u{645}\u{648}\u{627}\u{641}\u{642}\u{647} \u{6A9}\u{648}\u{626} \u{686}\u{6D0} \u{62F} \u{62F}\u{6D0} \u{67E}\u{6CC}\u{69A}\u{6D0} \u{67E}\u{647} \u{627}\u{693}\u{647} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}\u{648}\u{646}\u{647} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{693}\u{626}\u{60C} \u{686}\u{6D0} \u{67E}\u{6A9}\u{6D0} \u{62F} \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{6D0} \u{62A}\u{627}\u{632}\u{647} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}\u{60C} \u{627}\u{693}\u{6CC}\u{646} \u{641}\u{648}\u{631}\u{645}\u{6D0}\u{60C} \u{645}\u{647}\u{627}\u{644}\u{648}\u{6CC}\u{634} \u{628}\u{62F}\u{644}\u{648}\u{646}\u{648}\u{646}\u{647}\u{60C} \u{627}\u{648} \u{6CC}\u{627}\u{62F}\u{648}\u{646}\u{6D0} \u{634}\u{627}\u{645}\u{644}\u{6D0} \u{62F}\u{6CC}.`,
    pt: `Ao enviar este formul\xe1rio, voc\xea concorda em receber e-mails sobre este evento, incluindo atualiza\xe7\xf5es sobre inscri\xe7\xf5es, formul\xe1rios obrigat\xf3rios, altera\xe7\xf5es de agenda e lembretes.`,
    'pt-pt': `Ao submeter este formul\xe1rio, concorda em receber emails sobre este evento, incluindo atualiza\xe7\xf5es sobre inscri\xe7\xf5es, formul\xe1rios obrigat\xf3rios, altera\xe7\xf5es no hor\xe1rio e lembretes.`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{44F}\u{44F} \u{44D}\u{442}\u{443} \u{444}\u{43E}\u{440}\u{43C}\u{443}, \u{432}\u{44B} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{448}\u{430}\u{435}\u{442}\u{435}\u{441}\u{44C} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{442}\u{44C} \u{43F}\u{438}\u{441}\u{44C}\u{43C}\u{430} \u{43F}\u{43E} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{447}\u{442}\u{435} \u{43E}\u{431} \u{44D}\u{442}\u{43E}\u{43C} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{438}, \u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{44F} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{43E} \u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438}, \u{43D}\u{435}\u{43E}\u{431}\u{445}\u{43E}\u{434}\u{438}\u{43C}\u{44B}\u{435} \u{444}\u{43E}\u{440}\u{43C}\u{44B}, \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{430}\u{441}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{44F} \u{438} \u{43D}\u{430}\u{43F}\u{43E}\u{43C}\u{438}\u{43D}\u{430}\u{43D}\u{438}\u{44F}.`,
    sm: `E ala i le tu'uina atu o lenei fomu, ua e malilie e maua imeli e uiga i lenei mea na tupu, e aofia ai fa'afouga o le lesitalaina, fomu mana'omia, suiga o le fa'asologa, ma fa'amanatuga.`,
    so: `Adigoo gudbinaya foomkan, waxaad ogolaatay inaad hesho iimaylo ku saabsan dhacdadan, oo ay ku jiraan cusbooneysiinta diiwaangelinta, foomamka loo baahan yahay, isbeddelada jadwalka, iyo xusuusinta.`,
    th: `\u{E42}\u{E14}\u{E22}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E41}\u{E1A}\u{E1A}\u{E1F}\u{E2D}\u{E23}\u{E4C}\u{E21}\u{E19}\u{E35}\u{E49} \u{E04}\u{E38}\u{E13}\u{E15}\u{E01}\u{E25}\u{E07}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E01}\u{E31}\u{E1A}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49} \u{E23}\u{E27}\u{E21}\u{E16}\u{E36}\u{E07}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15}\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19} \u{E41}\u{E1A}\u{E1A}\u{E1F}\u{E2D}\u{E23}\u{E4C}\u{E21}\u{E17}\u{E35}\u{E48}\u{E08}\u{E4D}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19} \u{E01}\u{E32}\u{E23}\u{E40}\u{E1B}\u{E25}\u{E35}\u{E48}\u{E22}\u{E19}\u{E41}\u{E1B}\u{E25}\u{E07}\u{E15}\u{E32}\u{E23}\u{E32}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32} \u{E41}\u{E25}\u{E30}\u{E01}\u{E32}\u{E23}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E04}\u{E27}\u{E32}\u{E21}\u{E08}\u{E4D}\u{E32}`,
    ur: `\u{6CC}\u{6C1} \u{641}\u{627}\u{631}\u{645} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{648}\u{627} \u{6A9}\u{631}\u{60C} \u{622}\u{67E} \u{627}\u{633} \u{648}\u{627}\u{642}\u{639}\u{6D2} \u{6A9}\u{6D2} \u{628}\u{627}\u{631}\u{6D2} \u{645}\u{6CC}\u{6BA} \u{627}\u{6CC} \u{645}\u{6CC}\u{644}\u{632} \u{648}\u{635}\u{648}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{633}\u{6D2} \u{627}\u{62A}\u{641}\u{627}\u{642} \u{6A9}\u{631}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{60C} \u{62C}\u{646} \u{645}\u{6CC}\u{6BA} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{6A9}\u{6CC} \u{62A}\u{627}\u{632}\u{6C1} \u{6A9}\u{627}\u{631}\u{6CC}\u{60C} \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{641}\u{627}\u{631}\u{645}\u{60C} \u{634}\u{6CC}\u{688}\u{648}\u{644} \u{645}\u{6CC}\u{6BA} \u{62A}\u{628}\u{62F}\u{6CC}\u{644}\u{6CC}\u{627}\u{6BA}\u{60C} \u{627}\u{648}\u{631} \u{6CC}\u{627}\u{62F} \u{62F}\u{6C1}\u{627}\u{646}\u{6CC}\u{627}\u{6BA} \u{634}\u{627}\u{645}\u{644} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `B\u{1EB1}ng c\xe1ch g\u{1EED}i bi\u{1EC3}u m\u{1EAB}u n\xe0y, b\u{1EA1}n \u{111}\u{1ED3}ng \xfd nh\u{1EAD}n email v\u{1EC1} s\u{1EF1} ki\u{1EC7}n n\xe0y, bao g\u{1ED3}m c\u{1EAD}p nh\u{1EAD}t \u{111}\u{103}ng k\xfd, bi\u{1EC3}u m\u{1EAB}u b\u{1EAF}t bu\u{1ED9}c, thay \u{111}\u{1ED5}i l\u{1ECB}ch tr\xecnh v\xe0 nh\u{1EAF}c nh\u{1EDF}.`,
    'zh-hans': `\u{63D0}\u{4EA4}\u{6B64}\u{8868}\u{683C}\u{5373}\u{8868}\u{793A}\u{60A8}\u{540C}\u{610F}\u{63A5}\u{6536}\u{6709}\u{5173}\u{672C}\u{6B21}\u{6D3B}\u{52A8}\u{7684}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{FF0C}\u{5305}\u{62EC}\u{62A5}\u{540D}\u{66F4}\u{65B0}\u{3001}\u{5FC5}\u{9700}\u{8868}\u{683C}\u{3001}\u{65E5}\u{7A0B}\u{53D8}\u{66F4}\u{548C}\u{63D0}\u{9192}\u{3002}`,
    'zh-hant': `\u{63D0}\u{4EA4}\u{6B64}\u{8868}\u{55AE}\u{5373}\u{8868}\u{793A}\u{60A8}\u{540C}\u{610F}\u{63A5}\u{6536}\u{6709}\u{95DC}\u{672C}\u{6B21}\u{6D3B}\u{52D5}\u{7684}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{FF0C}\u{5305}\u{62EC}\u{5831}\u{540D}\u{66F4}\u{65B0}\u{3001}\u{5FC5}\u{9700}\u{8868}\u{683C}\u{3001}\u{884C}\u{7A0B}\u{8B8A}\u{66F4}\u{53CA}\u{63D0}\u{9192}\u{3002}`,
    en: `By submitting this form, you agree to receive emails about this event, including enrollment updates, required forms, schedule changes, and reminders.`
};
const $b11db1b62d4a8f76$export$944bf01e25c0942f = {
    ar: `\u{623}\u{646}\u{62A} \u{645}\u{633}\u{62C}\u{644}\u{629}`,
    de: `Du bist eingeschrieben`,
    es: `Est\xe1s matriculado`,
    fa: `\u{634}\u{645}\u{627} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}`,
    fil: `Naka-enroll ka na`,
    fr: `Vous \xeates inscrit`,
    hi: `\u{906}\u{92A} \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{93F}\u{924} \u{939}\u{948}\u{902}`,
    ht: `Ou enskri`,
    it: `Sei iscritto`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306F}\u{767B}\u{9332}\u{6E08}\u{307F}\u{3067}\u{3059}`,
    ko: `\u{B4F1}\u{B85D} \u{C644}\u{B8CC}`,
    mww: `Koj tau sau npe lawm`,
    ps: `\u{62A}\u{647} \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{6A9}\u{693}\u{6D0}`,
    pt: `Voc\xea est\xe1 matriculado`,
    'pt-pt': `Est\xe1s inscrito`,
    ru: `\u{422}\u{44B} \u{437}\u{430}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}`,
    sm: `Ua e lesitala`,
    so: `Waad is diiwaan gashay`,
    th: `\u{E04}\u{E38}\u{E13}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{622}\u{67E} \u{62F}\u{627}\u{62E}\u{644} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `B\u{1EA1}n \u{111}\xe3 \u{111}\u{103}ng k\xfd`,
    'zh-hans': `\u{4F60}\u{5DF2}\u{7ECF}\u{6CE8}\u{518C}\u{4E86}`,
    'zh-hant': `\u{4F60}\u{5DF2}\u{7D93}\u{8A3B}\u{518A}\u{4E86}`,
    en: `You're enrolled`
};
const $b11db1b62d4a8f76$export$69571df2a40cffb9 = {
    ar: `\u{62A}\u{645} \u{62A}\u{623}\u{643}\u{64A}\u{62F} \u{62A}\u{633}\u{62C}\u{64A}\u{644}\u{643}.`,
    de: `Ihre Einschreibung wurde best\xe4tigt.`,
    es: `Tu matr\xedcula ha sido confirmada.`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{634}\u{645}\u{627} \u{62A}\u{623}\u{6CC}\u{6CC}\u{62F} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Nakumpirma na ang iyong pag-enroll.`,
    fr: `Votre inscription a \xe9t\xe9 confirm\xe9e.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{928} \u{915}\u{940} \u{92A}\u{941}\u{937}\u{94D}\u{91F}\u{93F} \u{939}\u{94B} \u{917}\u{908} \u{939}\u{948}\u{964}`,
    ht: `Yo te konfime enskripsyon ou.`,
    it: `La tua iscrizione \xe8 stata confermata.`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{767B}\u{9332}\u{306F}\u{78BA}\u{8A8D}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{B4F1}\u{B85D}\u{C774} \u{D655}\u{C815}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Koj qhov kev sau npe tau lees paub lawm.`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{62A}\u{627}\u{6CC}\u{6CC}\u{62F} \u{634}\u{648}\u{647}.`,
    pt: `Sua matr\xedcula foi confirmada.`,
    'pt-pt': `A sua inscri\xe7\xe3o foi confirmada.`,
    ru: `\u{412}\u{430}\u{448}\u{430} \u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{43F}\u{43E}\u{434}\u{442}\u{432}\u{435}\u{440}\u{436}\u{434}\u{435}\u{43D}\u{430}.`,
    sm: `Ua fa'amaonia lau lesitalaina.`,
    so: `Diiwaangelintaada waa la xaqiijiyay.`,
    th: `\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62F}\u{627}\u{62E}\u{644}\u{6C1} \u{6A9}\u{6CC} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6C1}\u{648} \u{6AF}\u{626}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Vi\u{1EC7}c \u{111}\u{103}ng k\xfd c\u{1EE7}a b\u{1EA1}n \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c x\xe1c nh\u{1EAD}n.`,
    'zh-hans': `\u{60A8}\u{7684}\u{6CE8}\u{518C}\u{5DF2}\u{786E}\u{8BA4}\u{3002}`,
    'zh-hant': `\u{60A8}\u{7684}\u{8A3B}\u{518A}\u{5DF2}\u{78BA}\u{8A8D}\u{3002}`,
    en: `Your enrollment has been confirmed.`
};
const $b11db1b62d4a8f76$export$8d68149702d64b0a = {
    ar: `\u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{645}\u{648}\u{630}\u{62C} \u{62C}\u{632}\u{621} \u{645}\u{646} \u{62A}\u{633}\u{62C}\u{64A}\u{644}\u{643} \u{641}\u{64A} \u{627}\u{644}\u{641}\u{639}\u{627}\u{644}\u{64A}\u{629}. \u{623}\u{643}\u{645}\u{644}\u{648}\u{647} \u{623}\u{62F}\u{646}\u{627}\u{647}. \u{628}\u{639}\u{62F} \u{62A}\u{642}\u{62F}\u{64A}\u{645}\u{647}\u{60C} \u{633}\u{62A}\u{639}\u{648}\u{62F} \u{625}\u{644}\u{649} \u{635}\u{641}\u{62D}\u{629} \u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{641}\u{64A} \u{627}\u{644}\u{641}\u{639}\u{627}\u{644}\u{64A}\u{629}.`,
    de: `Dieses Formular ist Teil Ihrer Veranstaltungsanmeldung. F\xfcllen Sie es unten aus. Nachdem Sie es abgegeben haben, kehren Sie zu Ihrer Veranstaltungsanmeldeseite zur\xfcck.`,
    es: `Este formulario forma parte de tu inscripci\xf3n al evento. Rellena a continuaci\xf3n. Despu\xe9s de enviarlo, volver\xe1s a tu p\xe1gina de inscripci\xf3n al evento.`,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{631}\u{645} \u{628}\u{62E}\u{634}\u{6CC} \u{627}\u{632} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{634}\u{645}\u{627}\u{633}\u{62A}. \u{622}\u{646} \u{631}\u{627} \u{62F}\u{631} \u{627}\u{62F}\u{627}\u{645}\u{647} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{6A9}\u{646}\u{6CC}\u{62F}. \u{67E}\u{633} \u{627}\u{632} \u{627}\u{631}\u{633}\u{627}\u{644}\u{60C} \u{628}\u{647} \u{635}\u{641}\u{62D}\u{647} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{62E}\u{648}\u{62F} \u{628}\u{627}\u{632}\u{62E}\u{648}\u{627}\u{647}\u{6CC}\u{62F} \u{6AF}\u{634}\u{62A}.`,
    fil: `Ang form na ito ay bahagi ng iyong event enrollment. Punan mo ito sa ibaba. Pagkatapos mong isumite, babalik ka sa iyong event enrollment page.`,
    fr: `Ce formulaire fait partie de votre inscription \xe0 l\u{2019}\xe9v\xe9nement. Remplissez-le ci-dessous. Apr\xe8s l\u{2019}avoir soumis, vous retournerez \xe0 votre page d\u{2019}inscription \xe0 l\u{2019}\xe9v\xe9nement.`,
    hi: `\u{92F}\u{939} \u{92B}\u{93C}\u{949}\u{930}\u{94D}\u{92E} \u{906}\u{92A}\u{915}\u{947} \u{908}\u{935}\u{947}\u{902}\u{91F} \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{928} \u{915}\u{93E} \u{939}\u{93F}\u{938}\u{94D}\u{938}\u{93E} \u{939}\u{948}. \u{907}\u{938}\u{947} \u{928}\u{940}\u{91A}\u{947} \u{92A}\u{942}\u{930}\u{93E} \u{915}\u{930}\u{947}\u{902}. \u{907}\u{938}\u{947} \u{938}\u{92C}\u{92E}\u{93F}\u{91F} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{92C}\u{93E}\u{926}, \u{906}\u{92A} \u{905}\u{92A}\u{928}\u{947} \u{908}\u{935}\u{947}\u{902}\u{91F} \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{928} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{92A}\u{930} \u{935}\u{93E}\u{92A}\u{938} \u{906} \u{91C}\u{93E}\u{90F}\u{902}\u{917}\u{947}.`,
    ht: `F\xf2m sa a f\xe8 pati enskripsyon ev\xe8nman ou. Ranpli li anba a. Apre ou fin soum\xe8t li, ou pral retounen nan paj enskripsyon ev\xe8nman ou an.`,
    it: `Questo modulo fa parte della tua iscrizione all'evento. Compilalo qui sotto. Dopo averlo inviato, tornerai alla pagina di iscrizione all'evento.`,
    ja: `\u{3053}\u{306E}\u{30D5}\u{30A9}\u{30FC}\u{30E0}\u{306F}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{767B}\u{9332}\u{306E}\u{4E00}\u{90E8}\u{3067}\u{3059}\u{3002}\u{4E0B}\u{8A18}\u{306B}\u{8A18}\u{5165}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}\u{63D0}\u{51FA}\u{5F8C}\u{3001}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{767B}\u{9332}\u{30DA}\u{30FC}\u{30B8}\u{306B}\u{623B}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{C591}\u{C2DD}\u{C740} \u{C774}\u{BCA4}\u{D2B8} \u{B4F1}\u{B85D}\u{C758} \u{C77C}\u{BD80}\u{C785}\u{B2C8}\u{B2E4}. \u{C544}\u{B798}\u{C5D0} \u{C791}\u{C131}\u{D574} \u{C8FC}\u{C138}\u{C694}. \u{C81C}\u{CD9C} \u{D6C4} \u{C774}\u{BCA4}\u{D2B8} \u{B4F1}\u{B85D} \u{D398}\u{C774}\u{C9C0}\u{B85C} \u{B3CC}\u{C544}\u{AC00}\u{AC8C} \u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Daim foos no yog ib feem ntawm koj qhov kev sau npe kev tshwm sim. Sau nws hauv qab no. Tom qab koj xa nws, koj yuav rov qab mus rau koj nplooj ntawv sau npe kev tshwm sim.`,
    ps: `\u{62F}\u{627} \u{641}\u{648}\u{631}\u{645}\u{647} \u{633}\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{67E}\u{6CC}\u{69A}\u{648} \u{62F} \u{62B}\u{628}\u{62A} \u{6CC}\u{648}\u{647} \u{628}\u{631}\u{62E}\u{647} \u{62F}\u{647}. \u{644}\u{627}\u{646}\u{62F}\u{6D0} \u{6CC}\u{6D0} \u{628}\u{634}\u{67E}\u{693}\u{647} \u{6A9}\u{693}\u{626}. \u{6A9}\u{644}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{62F}\u{627} \u{648}\u{633}\u{67E}\u{627}\u{631}\u{626}\u{60C} \u{62A}\u{627}\u{633}\u{648} \u{628}\u{647} \u{62E}\u{67E}\u{644} \u{62F} \u{67E}\u{6CC}\u{69A}\u{6D0} \u{62F} \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{6D0} \u{67E}\u{627}\u{6BC}\u{6D0} \u{62A}\u{647} \u{633}\u{62A}\u{627}\u{646}\u{647} \u{634}\u{626}.`,
    pt: `Este formul\xe1rio faz parte da sua inscri\xe7\xe3o no evento. Preencha abaixo. Ap\xf3s envi\xe1-lo, voc\xea retornar\xe1 \xe0 sua p\xe1gina de inscri\xe7\xe3o no evento.`,
    'pt-pt': `Este formul\xe1rio faz parte da sua inscri\xe7\xe3o no evento. Preencha-o abaixo. Depois de o submeter, dever\xe1 voltar \xe0 p\xe1gina de inscri\xe7\xe3o no seu evento.`,
    ru: `\u{42D}\u{442}\u{430} \u{444}\u{43E}\u{440}\u{43C}\u{430} \u{44F}\u{432}\u{43B}\u{44F}\u{435}\u{442}\u{441}\u{44F} \u{447}\u{430}\u{441}\u{442}\u{44C}\u{44E} \u{432}\u{430}\u{448}\u{435}\u{439} \u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{43D}\u{430} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435}. \u{417}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435} \u{435}\u{451} \u{43D}\u{438}\u{436}\u{435}. \u{41F}\u{43E}\u{441}\u{43B}\u{435} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{438} \u{432}\u{44B} \u{432}\u{435}\u{440}\u{43D}\u{451}\u{442}\u{435}\u{441}\u{44C} \u{43D}\u{430} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{443} \u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438} \u{43D}\u{430} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435}.`,
    sm: `O lenei fomu o se vaega o lau lesitala i le mea na tupu. Fa'atumu i lalo. A mae'a ona e tu'uina atu, o le a e toe fo'i i lau itulau lesitala o mea na tutupu.`,
    so: `Foomkan waa qayb ka mid ah diiwaangelinta dhacdadaada. Buuxi hoos. Markaad gudbiso, waxaad ku soo laaban doontaa bogga diiwaangelinta dhacdadaada.`,
    th: `\u{E41}\u{E1A}\u{E1A}\u{E1F}\u{E2D}\u{E23}\u{E4C}\u{E21}\u{E19}\u{E35}\u{E49}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E2A}\u{E48}\u{E27}\u{E19}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E01}\u{E23}\u{E2D}\u{E01}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E14}\u{E49}\u{E32}\u{E19}\u{E25}\u{E48}\u{E32}\u{E07}\u{E2B}\u{E25}\u{E31}\u{E07}\u{E08}\u{E32}\u{E01}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E2A}\u{E48}\u{E07}\u{E41}\u{E1A}\u{E1A}\u{E1F}\u{E2D}\u{E23}\u{E4C}\u{E21}\u{E41}\u{E25}\u{E49}\u{E27} \u{E04}\u{E38}\u{E13}\u{E08}\u{E30}\u{E01}\u{E25}\u{E31}\u{E1A}\u{E44}\u{E1B}\u{E22}\u{E31}\u{E07}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{6CC}\u{6C1} \u{641}\u{627}\u{631}\u{645} \u{622}\u{67E} \u{6A9}\u{6D2} \u{627}\u{6CC}\u{648}\u{646}\u{679} \u{627}\u{646}\u{631}\u{648}\u{644}\u{645}\u{646}\u{679} \u{6A9}\u{627} \u{62D}\u{635}\u{6C1} \u{6C1}\u{6D2}\u{6D4} \u{627}\u{633}\u{6D2} \u{646}\u{6CC}\u{686}\u{6D2} \u{645}\u{6A9}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{648}\u{627}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{628}\u{639}\u{62F}\u{60C} \u{622}\u{67E} \u{627}\u{67E}\u{646}\u{6D2} \u{627}\u{6CC}\u{648}\u{646}\u{679} \u{627}\u{646}\u{631}\u{648}\u{644}\u{645}\u{646}\u{679} \u{67E}\u{6CC}\u{62C} \u{67E}\u{631} \u{648}\u{627}\u{67E}\u{633} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA} \u{6AF}\u{6D2}\u{6D4}`,
    vi: `Bi\u{1EC3}u m\u{1EAB}u n\xe0y l\xe0 m\u{1ED9}t ph\u{1EA7}n c\u{1EE7}a \u{111}\u{103}ng k\xfd s\u{1EF1} ki\u{1EC7}n c\u{1EE7}a b\u{1EA1}n. Ho\xe0n th\xe0nh b\xean d\u{1B0}\u{1EDB}i. Sau khi b\u{1EA1}n g\u{1EED}i, b\u{1EA1}n s\u{1EBD} quay l\u{1EA1}i trang \u{111}\u{103}ng k\xfd s\u{1EF1} ki\u{1EC7}n c\u{1EE7}a m\xecnh.`,
    'zh-hans': `\u{6B64}\u{8868}\u{683C}\u{662F}\u{60A8}\u{6D3B}\u{52A8}\u{62A5}\u{540D}\u{7684}\u{4E00}\u{90E8}\u{5206}\u{3002}\u{8BF7}\u{586B}\u{5199}\u{4E0B}\u{65B9}\u{3002}\u{63D0}\u{4EA4}\u{540E}\u{FF0C}\u{60A8}\u{5C06}\u{8FD4}\u{56DE}\u{60A8}\u{7684}\u{6D3B}\u{52A8}\u{62A5}\u{540D}\u{9875}\u{9762}\u{3002}`,
    'zh-hant': `\u{6B64}\u{8868}\u{55AE}\u{662F}\u{60A8}\u{6D3B}\u{52D5}\u{5831}\u{540D}\u{7684}\u{4E00}\u{90E8}\u{5206}\u{3002}\u{8ACB}\u{5728}\u{4E0B}\u{65B9}\u{586B}\u{5BEB}\u{3002}\u{63D0}\u{4EA4}\u{5F8C}\u{FF0C}\u{60A8}\u{5C07}\u{8FD4}\u{56DE}\u{6D3B}\u{52D5}\u{5831}\u{540D}\u{9801}\u{9762}\u{3002}`,
    en: `This form is part of your event enrollment. Complete it below. After you submit it, you'll return to your event enrollment page.`
};
const $b11db1b62d4a8f76$export$792631d2f632be94 = {
    ar: (url)=>`\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{645} \u{647}\u{630}\u{627} \u{627}\u{644}\u{631}\u{627}\u{628}\u{637} \u{644}\u{639}\u{631}\u{636} \u{62A}\u{633}\u{62C}\u{64A}\u{644}\u{643} \u{641}\u{64A} \u{627}\u{644}\u{62D}\u{62F}\u{62B} \u{648}\u{627}\u{644}\u{62E}\u{637}\u{648}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}\u{629}: ${url}`,
    de: (url)=>`Nutzen Sie diesen Link, um Ihre Veranstaltungsanmeldung und die n\xe4chsten Schritte einzusehen: ${url}`,
    es: (url)=>`Utiliza este enlace para ver tu inscripci\xf3n en el evento y los siguientes pasos: ${url}`,
    fa: (url)=>`\u{627}\u{632} \u{627}\u{6CC}\u{646} \u{644}\u{6CC}\u{646}\u{6A9} \u{628}\u{631}\u{627}\u{6CC} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{648} \u{645}\u{631}\u{627}\u{62D}\u{644} \u{628}\u{639}\u{62F}\u{6CC} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}: ${url}`,
    fil: (url)=>`Gamitin ang link na ito upang makita ang iyong pag-enroll sa event at mga susunod na hakbang: ${url}`,
    fr: (url)=>`Utilisez ce lien pour consulter votre inscription \xe0 l\u{2019}\xe9v\xe9nement et les prochaines \xe9tapes : ${url}`,
    hi: (url)=>`\u{905}\u{92A}\u{928}\u{947} \u{908}\u{935}\u{947}\u{902}\u{91F} \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{928} \u{914}\u{930} \u{905}\u{917}\u{932}\u{947} \u{91A}\u{930}\u{923}\u{94B}\u{902} \u{915}\u{94B} \u{926}\u{947}\u{916}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{907}\u{938} \u{932}\u{93F}\u{902}\u{915} \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{947}\u{902}: ${url}`,
    ht: (url)=>`S\xe8vi ak lyen sa a pou w w\xe8 enskripsyon ev\xe8nman ou ak pwochen etap yo: ${url}`,
    it: (url)=>`Usa questo link per visualizzare l'iscrizione all'evento e i prossimi passaggi: ${url}`,
    ja: (url)=>`\u{3053}\u{3061}\u{3089}\u{306E}\u{30EA}\u{30F3}\u{30AF}\u{304B}\u{3089}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{767B}\u{9332}\u{72B6}\u{6CC1}\u{3068}\u{4ECA}\u{5F8C}\u{306E}\u{30B9}\u{30C6}\u{30C3}\u{30D7}\u{3092}\u{78BA}\u{8A8D}\u{3067}\u{304D}\u{307E}\u{3059}: ${url}`,
    ko: (url)=>`\u{C774} \u{B9C1}\u{D06C}\u{B97C} \u{C774}\u{C6A9}\u{D574} \u{C774}\u{BCA4}\u{D2B8} \u{B4F1}\u{B85D} \u{BC0F} \u{B2E4}\u{C74C} \u{B2E8}\u{ACC4}\u{B97C} \u{D655}\u{C778}\u{D558}\u{C138}\u{C694}: ${url}`,
    mww: (url)=>`Siv qhov txuas no los saib koj qhov kev sau npe thiab cov kauj ruam tom ntej: ${url}`,
    ps: (url)=>`\u{62F}\u{627} \u{644}\u{6CC}\u{646}\u{6A9} \u{648}\u{6A9}\u{627}\u{631}\u{648}\u{626} \u{62A}\u{631}\u{685}\u{648} \u{62F} \u{62E}\u{67E}\u{644} \u{67E}\u{6CC}\u{69A}\u{648} \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{627}\u{648} \u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6CC} \u{6AB}\u{627}\u{645}\u{648}\u{646}\u{647} \u{648}\u{6AB}\u{648}\u{631}\u{626}: ${url}`,
    pt: (url)=>`Use este link para ver sua inscri\xe7\xe3o no evento e os pr\xf3ximos passos: ${url}`,
    'pt-pt': (url)=>`Use este link para ver a inscri\xe7\xe3o no seu evento e os pr\xf3ximos passos: ${url}`,
    ru: (url)=>`\u{418}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{439}\u{442}\u{435} \u{44D}\u{442}\u{443} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{443}\u{432}\u{438}\u{434}\u{435}\u{442}\u{44C} \u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44E} \u{43D}\u{430} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435} \u{438} \u{441}\u{43B}\u{435}\u{434}\u{443}\u{44E}\u{449}\u{438}\u{435} \u{448}\u{430}\u{433}\u{438}: ${url}`,
    sm: (url)=>`Fa'aaoga lenei feso'ota'iga e va'ai ai i lau lesitala ma isi la'asaga: ${url}`,
    so: (url)=>`Isticmaal xiriirkan si aad u aragto diiwaangelinta dhacdadaada iyo tallaabooyinka xiga: ${url}`,
    th: (url)=>`\u{E43}\u{E0A}\u{E49}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E19}\u{E35}\u{E49}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E14}\u{E39}\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E41}\u{E25}\u{E30}\u{E02}\u{E31}\u{E49}\u{E19}\u{E15}\u{E2D}\u{E19}\u{E16}\u{E31}\u{E14}\u{E44}\u{E1B}: ${url}`,
    ur: (url)=>`\u{627}\u{67E}\u{646}\u{6D2} \u{627}\u{6CC}\u{648}\u{646}\u{679} \u{645}\u{6CC}\u{6BA} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{627}\u{648}\u{631} \u{627}\u{6AF}\u{644}\u{6D2} \u{627}\u{642}\u{62F}\u{627}\u{645}\u{627}\u{62A} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{633} \u{644}\u{646}\u{6A9} \u{6A9}\u{627} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}: ${url}`,
    vi: (url)=>`S\u{1EED} d\u{1EE5}ng li\xean k\u{1EBF}t n\xe0y \u{111}\u{1EC3} xem vi\u{1EC7}c \u{111}\u{103}ng k\xfd s\u{1EF1} ki\u{1EC7}n v\xe0 c\xe1c b\u{1B0}\u{1EDB}c ti\u{1EBF}p theo: ${url}`,
    'zh-hans': (url)=>`\u{8BF7}\u{4F7F}\u{7528}\u{6B64}\u{94FE}\u{63A5}\u{67E5}\u{770B}\u{60A8}\u{7684}\u{6D3B}\u{52A8}\u{62A5}\u{540D}\u{60C5}\u{51B5}\u{53CA}\u{4E0B}\u{4E00}\u{6B65}\u{6B65}\u{9AA4}\u{FF1A} ${url}`,
    'zh-hant': (url)=>`\u{4F7F}\u{7528}\u{6B64}\u{9023}\u{7D50}\u{67E5}\u{770B}\u{60A8}\u{7684}\u{6D3B}\u{52D5}\u{5831}\u{540D}\u{53CA}\u{5F8C}\u{7E8C}\u{6B65}\u{9A5F}\u{FF1A} ${url}`,
    en: (url)=>`Use this link to view your event enrollment and next steps: ${url}`
};
const $b11db1b62d4a8f76$export$d208ef48676d3ec7 = {
    ar: `\u{633}\u{62A}\u{643}\u{648}\u{646} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{627}\u{62C}\u{62A}\u{645}\u{627}\u{639}\u{627}\u{62A} \u{645}\u{62A}\u{627}\u{62D}\u{629} \u{628}\u{645}\u{62C}\u{631}\u{62F} \u{62A}\u{623}\u{643}\u{64A}\u{62F} \u{62A}\u{633}\u{62C}\u{64A}\u{644}\u{643}.`,
    de: `Informationen zu den Sitzungen werden verf\xfcgbar sein, sobald Ihre Einschreibung best\xe4tigt ist.`,
    es: `La informaci\xf3n sobre la reuni\xf3n estar\xe1 disponible una vez confirmada tu inscripci\xf3n.`,
    fa: `\u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{62C}\u{644}\u{633}\u{647} \u{67E}\u{633} \u{627}\u{632} \u{62A}\u{623}\u{6CC}\u{6CC}\u{62F} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{634}\u{645}\u{627} \u{62F}\u{631} \u{62F}\u{633}\u{62A}\u{631}\u{633} \u{62E}\u{648}\u{627}\u{647}\u{62F} \u{628}\u{648}\u{62F}.`,
    fil: `Ang impormasyon tungkol sa meeting ay magiging available kapag nakumpirma na ang iyong enrollment.`,
    fr: `Les informations sur la r\xe9union seront disponibles une fois votre inscription confirm\xe9e.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{928} \u{915}\u{940} \u{92A}\u{941}\u{937}\u{94D}\u{91F}\u{93F} \u{939}\u{94B}\u{928}\u{947} \u{915}\u{947} \u{92C}\u{93E}\u{926} \u{92E}\u{940}\u{91F}\u{93F}\u{902}\u{917} \u{915}\u{940} \u{91C}\u{93E}\u{928}\u{915}\u{93E}\u{930}\u{940} \u{909}\u{92A}\u{932}\u{92C}\u{94D}\u{927} \u{939}\u{94B}\u{917}\u{940}\u{964}`,
    ht: `Enf\xf2masyon sou reyinyon yo ap disponib yon fwa yo konfime enskripsyon ou.`,
    it: `Le informazioni sugli incontri saranno disponibili una volta confermata la tua iscrizione.`,
    ja: `\u{767B}\u{9332}\u{304C}\u{78BA}\u{8A8D}\u{3055}\u{308C}\u{6B21}\u{7B2C}\u{3001}\u{30DF}\u{30FC}\u{30C6}\u{30A3}\u{30F3}\u{30B0}\u{60C5}\u{5831}\u{304C}\u{516C}\u{958B}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{B4F1}\u{B85D}\u{C774} \u{D655}\u{C815}\u{B418}\u{BA74} \u{D68C}\u{C758} \u{C815}\u{BCF4}\u{AC00} \u{C81C}\u{ACF5}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Cov ntaub ntawv txog kev sib tham yuav muaj thaum koj tau lees paub kev sau npe.`,
    ps: `\u{62F} \u{63A}\u{648}\u{646}\u{689}\u{6D0} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{628}\u{647} \u{647}\u{63A}\u{647} \u{648}\u{62E}\u{62A} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{634}\u{6CC} \u{6A9}\u{644}\u{647} \u{686}\u{6D0} \u{633}\u{62A}\u{627}\u{633}\u{648} \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{62A}\u{627}\u{6CC}\u{6CC}\u{62F} \u{634}\u{6CC}.`,
    pt: `As informa\xe7\xf5es sobre a reuni\xe3o estar\xe3o dispon\xedveis assim que sua matr\xedcula for confirmada.`,
    'pt-pt': `A informa\xe7\xe3o sobre a reuni\xe3o estar\xe1 dispon\xedvel assim que a sua inscri\xe7\xe3o for confirmada.`,
    ru: `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F} \u{43E} \u{432}\u{441}\u{442}\u{440}\u{435}\u{447}\u{435} \u{431}\u{443}\u{434}\u{435}\u{442} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430} \u{43F}\u{43E}\u{441}\u{43B}\u{435} \u{43F}\u{43E}\u{434}\u{442}\u{432}\u{435}\u{440}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{44F} \u{432}\u{430}\u{448}\u{435}\u{439} \u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{438}.`,
    sm: `O le a maua fa'amatalaga o fonotaga pe a mae'a ona fa'amaonia lau lesitala.`,
    so: `Macluumaadka shirarka ayaa la heli doonaa marka diiwaangelintaada la xaqiijiyo.`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E01}\u{E32}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E0A}\u{E38}\u{E21}\u{E08}\u{E30}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E40}\u{E21}\u{E37}\u{E48}\u{E2D}\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{645}\u{6CC}\u{679}\u{646}\u{6AF} \u{6A9}\u{6CC} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{622}\u{67E} \u{6A9}\u{6D2} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{6A9}\u{6CC} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{6D2} \u{628}\u{639}\u{62F} \u{62F}\u{633}\u{62A}\u{6CC}\u{627}\u{628} \u{6C1}\u{648} \u{62C}\u{627}\u{626}\u{6D2} \u{6AF}\u{6CC}\u{6D4}`,
    vi: `Th\xf4ng tin v\u{1EC1} cu\u{1ED9}c h\u{1ECD}p s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c cung c\u{1EA5}p khi b\u{1EA1}n x\xe1c nh\u{1EAD}n \u{111}\u{103}ng k\xfd.`,
    'zh-hans': `\u{4E00}\u{65E6}\u{4F60}\u{7684}\u{62A5}\u{540D}\u{786E}\u{8BA4}\u{FF0C}\u{4F1A}\u{8BAE}\u{4FE1}\u{606F}\u{5C06}\u{4F1A}\u{516C}\u{5E03}\u{3002}`,
    'zh-hant': `\u{6703}\u{8B70}\u{8CC7}\u{8A0A}\u{5C07}\u{5728}\u{60A8}\u{7684}\u{5831}\u{540D}\u{78BA}\u{8A8D}\u{5F8C}\u{516C}\u{5E03}\u{3002}`,
    en: `Meeting information will be available once your enrollment is confirmed.`
};
const $b11db1b62d4a8f76$export$ff66e2c8f0d97341 = {
    ar: `\u{627}\u{644}\u{62E}\u{637}\u{648}\u{629} \u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}\u{629}`,
    de: `N\xe4chster Schritt`,
    es: `Siguiente paso`,
    fa: `\u{6AF}\u{627}\u{645} \u{628}\u{639}\u{62F}\u{6CC}`,
    fil: `Susunod na hakbang`,
    fr: `\xc9tape suivante`,
    hi: `\u{905}\u{917}\u{932}\u{93E} \u{915}\u{926}\u{92E}`,
    ht: `Pwochen etap`,
    it: `Passo successivo`,
    ja: `\u{6B21}\u{306E}\u{30B9}\u{30C6}\u{30C3}\u{30D7}`,
    ko: `\u{B2E4}\u{C74C} \u{B2E8}\u{ACC4}`,
    mww: `Kauj ruam tom ntej`,
    ps: `\u{628}\u{644} \u{6AB}\u{627}\u{645}`,
    pt: `Pr\xf3ximo passo`,
    'pt-pt': `Pr\xf3ximo passo`,
    ru: `\u{421}\u{43B}\u{435}\u{434}\u{443}\u{44E}\u{449}\u{438}\u{439} \u{448}\u{430}\u{433}`,
    sm: `O le isi laasaga`,
    so: `Tallaabada xigta`,
    th: `\u{E02}\u{E31}\u{E49}\u{E19}\u{E15}\u{E2D}\u{E19}\u{E16}\u{E31}\u{E14}\u{E44}\u{E1B}`,
    ur: `\u{627}\u{6AF}\u{644}\u{627} \u{645}\u{631}\u{62D}\u{644}\u{6C1}`,
    vi: `B\u{1B0}\u{1EDB}c ti\u{1EBF}p theo`,
    'zh-hans': `\u{4E0B}\u{4E00}\u{6B65}`,
    'zh-hant': `\u{4E0B}\u{4E00}\u{6B65}`,
    en: `Next step`
};
const $b11db1b62d4a8f76$export$40105b51a4dc7c06 = {
    ar: `\u{644}\u{645} \u{64A}\u{643}\u{62A}\u{645}\u{644}`,
    de: `Nicht fertiggestellt`,
    es: `No completado`,
    fa: `\u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{646}\u{634}\u{62F}\u{647}`,
    fil: `Hindi pa natapos`,
    fr: `Non termin\xe9`,
    hi: `\u{92A}\u{942}\u{930}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{939}\u{941}\u{906}`,
    ht: `Pa fini`,
    it: `Non completato`,
    ja: `\u{672A}\u{5B8C}\u{6210}`,
    ko: `\u{C644}\u{C131}\u{B418}\u{C9C0} \u{C54A}\u{C74C}`,
    mww: `Tsis tau tiav`,
    ps: `\u{628}\u{634}\u{67E}\u{693} \u{634}\u{648}\u{6CC} \u{646}\u{647} \u{62F}\u{6CC}`,
    pt: `N\xe3o conclu\xeddo`,
    'pt-pt': `N\xe3o conclu\xeddo`,
    ru: `\u{41D}\u{435} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43E}`,
    sm: `E le'i mae'a`,
    so: `Lama dhammeystirin`,
    th: `\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{645}\u{6A9}\u{645}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{627}`,
    vi: `Ch\u{1B0}a ho\xe0n th\xe0nh`,
    'zh-hans': `\u{672A}\u{5B8C}\u{6210}`,
    'zh-hant': `\u{672A}\u{5B8C}\u{6210}`,
    en: `Not completed`
};
const $b11db1b62d4a8f76$export$1e8c2990a95deddd = {
    ar: `\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{641}\u{639}\u{627}\u{644}\u{64A}\u{627}\u{62A}`,
    de: `Teilnehmerzahl an Veranstaltungen`,
    es: `Inscripci\xf3n en eventos`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{62F}\u{631} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{647}\u{627}`,
    fil: `Pag-enroll sa mga kaganapan`,
    fr: `Inscription aux \xe9v\xe9nements`,
    hi: `\u{907}\u{935}\u{947}\u{902}\u{91F} \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{928}`,
    ht: `Enskripsyon ev\xe8nman an`,
    it: `Iscrizione agli eventi`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{767B}\u{9332}`,
    ko: `\u{D589}\u{C0AC} \u{B4F1}\u{B85D}`,
    mww: `Kev sau npe rau kev tshwm sim`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{69A}\u{648} \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647}`,
    pt: `Inscri\xe7\xe3o em eventos`,
    'pt-pt': `Inscri\xe7\xe3o em eventos`,
    ru: `\u{41A}\u{43E}\u{43B}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{43E} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{43E}\u{432} \u{43D}\u{430} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F}\u{445}`,
    sm: `Lesitala o mea na tutupu`,
    so: `Diiwaangelinta dhacdooyinka`,
    th: `\u{E01}\u{E32}\u{E23}\u{E23}\u{E31}\u{E1A}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{627}\u{6CC}\u{648}\u{646}\u{679} \u{645}\u{6CC}\u{6BA} \u{62F}\u{627}\u{62E}\u{644}\u{6C1}`,
    vi: `\u{110}\u{103}ng k\xfd s\u{1EF1} ki\u{1EC7}n`,
    'zh-hans': `\u{6D3B}\u{52A8}\u{62A5}\u{540D}`,
    'zh-hant': `\u{6D3B}\u{52D5}\u{5831}\u{540D}`,
    en: `Event enrollment`
};
const $b11db1b62d4a8f76$export$7cee4e3b74407eb3 = {
    ar: `\u{627}\u{644}\u{627}\u{644}\u{62A}\u{62D}\u{627}\u{642} \u{627}\u{644}\u{645}\u{642}\u{631}\u{631}`,
    de: `Einschreibung steht noch aus`,
    es: `Matr\xedcula pendiente`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{62F}\u{631} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`,
    fil: `Nakabinbin ang enrollment`,
    fr: `Inscription en attente`,
    hi: `\u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{928} \u{932}\u{902}\u{92C}\u{93F}\u{924} \u{939}\u{948}`,
    ht: `Annatant enskripsyon an`,
    it: `Iscrizione in attesa`,
    ja: `\u{5165}\u{5B66}\u{4E88}\u{5B9A}`,
    ko: `\u{B4F1}\u{B85D} \u{C9C4}\u{D589} \u{B300}\u{AE30} \u{C911}\u{C785}\u{B2C8}\u{B2E4}`,
    mww: `Kev sau npe tseem tos`,
    ps: `\u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{644}\u{627} \u{647}\u{645} \u{646}\u{647} \u{62F}\u{647}`,
    pt: `Matr\xedcula pendente`,
    'pt-pt': `Inscri\xe7\xe3o pendente`,
    ru: `\u{420}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{43D}\u{430}\u{445}\u{43E}\u{434}\u{438}\u{442}\u{441}\u{44F} \u{43D}\u{430} \u{441}\u{442}\u{430}\u{434}\u{438}\u{438}`,
    sm: `Lesitala o lo'o fa'atali`,
    so: `Diiwaangelinta ayaa sugaysa`,
    th: `\u{E23}\u{E2D}\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}`,
    ur: `\u{62F}\u{627}\u{62E}\u{644}\u{6C1} \u{632}\u{6CC}\u{631} \u{627}\u{644}\u{62A}\u{648}\u{627}`,
    vi: `\u{110}ang ch\u{1EDD} \u{111}\u{103}ng k\xfd`,
    'zh-hans': `\u{6CE8}\u{518C}\u{5F85}\u{5B9A}`,
    'zh-hant': `\u{8A3B}\u{518A}\u{5F85}\u{5B9A}`,
    en: `Enrollment pending`
};
const $b11db1b62d4a8f76$export$73ab6404084d8f8f = {
    ar: `\u{64A}\u{62A}\u{645} \u{645}\u{631}\u{627}\u{62C}\u{639}\u{629} \u{62A}\u{633}\u{62C}\u{64A}\u{644}\u{643}.`,
    de: `Ihre Einschreibung wird \xfcberpr\xfcft.`,
    es: `Tu matr\xedcula est\xe1 siendo revisada.`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{634}\u{645}\u{627} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{628}\u{631}\u{631}\u{633}\u{6CC} \u{627}\u{633}\u{62A}.`,
    fil: `Sinusuri ang iyong enrollment.`,
    fr: `Votre inscription est en cours d\u{2019}examen.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{928} \u{915}\u{940} \u{938}\u{92E}\u{940}\u{915}\u{94D}\u{937}\u{93E} \u{915}\u{940} \u{91C}\u{93E} \u{930}\u{939}\u{940} \u{939}\u{948}\u{964}`,
    ht: `Yo revize enskripsyon ou an.`,
    it: `La tua iscrizione \xe8 in fase di revisione.`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{767B}\u{9332}\u{306F}\u{5BE9}\u{67FB}\u{4E2D}\u{3067}\u{3059}\u{3002}`,
    ko: `\u{B4F1}\u{B85D} \u{AE30}\u{B85D}\u{C774} \u{AC80}\u{D1A0} \u{C911}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Koj qhov kev sau npe tab tom raug tshuaj xyuas.`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{627}\u{631}\u{632}\u{648}\u{644} \u{6A9}\u{6D0}\u{696}\u{6CC}.`,
    pt: `Sua matr\xedcula est\xe1 sendo revisada.`,
    'pt-pt': `A sua inscri\xe7\xe3o est\xe1 a ser revista.`,
    ru: `\u{412}\u{430}\u{448}\u{430} \u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{43F}\u{435}\u{440}\u{435}\u{441}\u{43C}\u{430}\u{442}\u{440}\u{438}\u{432}\u{430}\u{435}\u{442}\u{441}\u{44F}.`,
    sm: `O lo'o toe iloiloina lau lesitalaina.`,
    so: `Diiwaangelintaada ayaa dib loo eegayaa.`,
    th: `\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E16}\u{E39}\u{E01}\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{631}\u{62C}\u{633}\u{679}\u{631}\u{6CC}\u{634}\u{646} \u{6A9}\u{627} \u{62C}\u{627}\u{626}\u{632}\u{6C1} \u{644}\u{6CC}\u{627} \u{62C}\u{627} \u{631}\u{6C1}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Vi\u{1EC7}c \u{111}\u{103}ng k\xfd c\u{1EE7}a b\u{1EA1}n \u{111}ang \u{111}\u{1B0}\u{1EE3}c xem x\xe9t.`,
    'zh-hans': `\u{4F60}\u{7684}\u{6CE8}\u{518C}\u{6B63}\u{5728}\u{88AB}\u{5BA1}\u{6838}\u{3002}`,
    'zh-hant': `\u{4F60}\u{7684}\u{767B}\u{8A18}\u{6B63}\u{5728}\u{88AB}\u{5BE9}\u{67E5}\u{3002}`,
    en: `Your enrollment is being reviewed.`
};
const $b11db1b62d4a8f76$export$de2a5abc3daebc4d = {
    ar: `\u{639}\u{631}\u{636} \u{627}\u{644}\u{645}\u{648}\u{627}\u{62F} \u{627}\u{644}\u{642}\u{627}\u{62F}\u{645}\u{629}`,
    de: `Sehen Sie kommende Artikel an`,
    es: `Ver pr\xf3ximos art\xedculos`,
    fa: `\u{645}\u{648}\u{627}\u{631}\u{62F} \u{622}\u{6CC}\u{646}\u{62F}\u{647} \u{631}\u{627} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Tingnan ang mga paparating na item`,
    fr: `Voir les prochains articles`,
    hi: `\u{906}\u{917}\u{93E}\u{92E}\u{940} \u{906}\u{907}\u{91F}\u{92E} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `Gade atik kap vini yo`,
    it: `Visualizza i prossimi articoli`,
    ja: `\u{4ECA}\u{5F8C}\u{306E}\u{5546}\u{54C1}\u{3092}\u{898B}\u{308B}`,
    ko: `\u{B2E4}\u{AC00}\u{C624}\u{B294} \u{D56D}\u{BAA9} \u{BCF4}\u{AE30}`,
    mww: `Saib cov khoom uas yuav los tom ntej`,
    ps: `\u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6CC} \u{62A}\u{648}\u{6A9}\u{6CC} \u{648}\u{6AB}\u{648}\u{631}\u{626}`,
    pt: `Veja os pr\xf3ximos itens`,
    'pt-pt': `Ver os pr\xf3ximos artigos`,
    ru: `\u{41F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{438}\u{445} \u{43C}\u{430}\u{442}\u{435}\u{440}\u{438}\u{430}\u{43B}\u{43E}\u{432}`,
    sm: `Va'ai aitema o lo'o lumana'i`,
    so: `Daawo alaabooyinka soo socda`,
    th: `\u{E14}\u{E39}\u{E2A}\u{E34}\u{E19}\u{E04}\u{E49}\u{E32}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E21}\u{E32}\u{E16}\u{E36}\u{E07}`,
    ur: `\u{622}\u{626}\u{646}\u{62F}\u{6C1} \u{622}\u{626}\u{679}\u{645}\u{632} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Xem c\xe1c m\u{1EB7}t h\xe0ng s\u{1EAF}p t\u{1EDB}i`,
    'zh-hans': `\u{67E5}\u{770B}\u{5373}\u{5C06}\u{53D1}\u{5E03}\u{7684}\u{5185}\u{5BB9}`,
    'zh-hant': `\u{67E5}\u{770B}\u{5373}\u{5C07}\u{63A8}\u{51FA}\u{7684}\u{9805}\u{76EE}`,
    en: `View upcoming items`
};
const $b11db1b62d4a8f76$export$41b540ca56b46291 = {
    ar: `\u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{641}\u{639}\u{627}\u{644}\u{64A}\u{627}\u{62A}`,
    de: `Veranstaltungsplan`,
    es: `Calendario de eventos`,
    fa: `\u{628}\u{631}\u{646}\u{627}\u{645}\u{647} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{647}\u{627}`,
    fil: `Iskedyul ng kaganapan`,
    fr: `Programme des \xe9v\xe9nements`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{915}\u{94D}\u{930}\u{92E} \u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{915}\u{94D}\u{930}\u{92E}`,
    ht: `Or\xe8 ev\xe8nman an`,
    it: `Programma degli eventi`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{30B9}\u{30B1}\u{30B8}\u{30E5}\u{30FC}\u{30EB}`,
    ko: `\u{D589}\u{C0AC} \u{C77C}\u{C815}`,
    mww: `Cov sij hawm tshwm sim`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{69A}\u{648} \u{645}\u{647}\u{627}\u{644}\u{648}\u{6CC}\u{634}`,
    pt: `Programa\xe7\xe3o de eventos`,
    'pt-pt': `Calend\xe1rio de eventos`,
    ru: `\u{420}\u{430}\u{441}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{439}`,
    sm: `Faasologa o mea na tutupu`,
    so: `Jadwalka Tartanka`,
    th: `\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E01}\u{E32}\u{E23}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{627}\u{6CC}\u{648}\u{646}\u{679} \u{634}\u{6CC}\u{688}\u{648}\u{644}`,
    vi: `L\u{1ECB}ch tr\xecnh s\u{1EF1} ki\u{1EC7}n`,
    'zh-hans': `\u{6D3B}\u{52A8}\u{65E5}\u{7A0B}`,
    'zh-hant': `\u{6D3B}\u{52D5}\u{884C}\u{7A0B}`,
    en: `Event schedule`
};
const $b11db1b62d4a8f76$export$8fb7fba5f9645ce2 = {
    ar: (email)=>$b11db1b62d4a8f76$var$html`لديك حساب <strong>${email}</strong>.`,
    de: (email)=>$b11db1b62d4a8f76$var$html`Du hast bereits ein Konto für <strong>${email}</strong>.`,
    es: (email)=>$b11db1b62d4a8f76$var$html`Ya tienes una cuenta para <strong>${email}</strong>.`,
    fa: (email)=>$b11db1b62d4a8f76$var$html`شما قبلا برای <strong>${email}</strong> حساب کاربری دارید.`,
    fil: (email)=>$b11db1b62d4a8f76$var$html`Mayroon ka nang account para <strong>${email}</strong>.`,
    fr: (email)=>$b11db1b62d4a8f76$var$html`Vous avez déjà un compte pour <strong>${email}</strong>.`,
    hi: (email)=>$b11db1b62d4a8f76$var$html`आपके पास पहले से ही <strong>${email}</strong> लिए एक खाता है।`,
    ht: (email)=>$b11db1b62d4a8f76$var$html`Ou deja gen yon kont pou <strong>${email}</strong>`,
    it: (email)=>$b11db1b62d4a8f76$var$html`Hai già un account per <strong>${email}</strong>.`,
    ja: (email)=>$b11db1b62d4a8f76$var$html`すでに <strong>${email}</strong> のアカウントを持っています。`,
    ko: (email)=>$b11db1b62d4a8f76$var$html`이미 <strong>${email}</strong> 계정이 있으시네요.`,
    mww: (email)=>$b11db1b62d4a8f76$var$html`Koj twb muaj ib tug account rau <strong>${email}</strong>.`,
    ps: (email)=>$b11db1b62d4a8f76$var$html`ته لا دمخه حساب <strong>${email}</strong>.`,
    pt: (email)=>$b11db1b62d4a8f76$var$html`Você já tem uma conta <strong>${email}</strong>.`,
    'pt-pt': (email)=>$b11db1b62d4a8f76$var$html`Já tens uma conta para <strong>${email}</strong>.`,
    ru: (email)=>$b11db1b62d4a8f76$var$html`У вас уже есть аккаунт <strong>${email}</strong>.`,
    sm: (email)=>$b11db1b62d4a8f76$var$html`Ua uma ona i ai sau teuga tupe mo <strong>${email}</strong>.`,
    so: (email)=>$b11db1b62d4a8f76$var$html`Waxaad horey u leedahay <strong>${email}</strong>.`,
    th: (email)=>$b11db1b62d4a8f76$var$html`คุณมีบัญชีสําหรับ <strong>${email}</strong> อยู่แล้ว`,
    ur: (email)=>$b11db1b62d4a8f76$var$html`آپ کے پاس <strong>${email}</strong> کا اکاؤنٹ ہے۔`,
    vi: (email)=>$b11db1b62d4a8f76$var$html`Bạn đã có tài khoản cho <strong>${email}</strong>.`,
    'zh-hans': (email)=>$b11db1b62d4a8f76$var$html`你已经有 <strong>${email}</strong> 账户了。`,
    'zh-hant': (email)=>$b11db1b62d4a8f76$var$html`你已經有 <strong>${email}</strong> 帳號了。`,
    en: (email)=>$b11db1b62d4a8f76$var$html`You already have an account for <strong>${email}</strong>.`
};
const $b11db1b62d4a8f76$export$1c2c06cdef0021b5 = {
    ar: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`النشاط <a href="${activityHref}">الأخير</a> عمره أكثر ${max_age} يوما. يجب إنشاء نشاط جديد.`,
    de: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`Die <a href="${activityHref}">jüngste Aktivität</a> ist älter als ${max_age} Tage. Eine neue Aktivität muss geschaffen werden.`,
    es: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`La <a href="${activityHref}">actividad más reciente</a> tiene más de ${max_age} días. Debe crearse una nueva actividad.`,
    fa: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">جدیدترین فعالیت</a> بیش از ${max_age} روز قدمت دارد. باید فعالیت جدیدی ایجاد شود.`,
    fil: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`Ang <a href="${activityHref}">pinakahuling aktibidad</a> ay higit sa ${max_age} araw gulang. Kailangang lumikha ng isang bagong aktibidad.`,
    fr: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">L’activité la plus récente</a> date de plus ${max_age} jours. Une nouvelle activité doit être créée.`,
    hi: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">सबसे हालिया गतिविधि</a> ${max_age} दिनों से अधिक पुरानी है। एक नई गतिविधि बनाई जानी चाहिए।`,
    ht: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">Aktivite ki pi resan</a> an gen plis pase ${max_age} jou. Yon nouvo aktivite dwe kreye.`,
    it: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">L'attività più recente</a> ha più di ${max_age} giorni. Deve essere creata una nuova attività.`,
    ja: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`最近の <a href="${activityHref}">活動</a> は ${max_age} 日以上前です。新しい活動を創出しなければなりません。`,
    ko: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">가장 최근의 활동</a>은 ${max_age}일이 넘었어요. 새로운 활동이 만들어져야 합니다.`,
    mww: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`Qhov <a href="${activityHref}">kev ua ub no tsis ntev los</a> no yog ntau dua ${max_age} hnub. Ib qho haujlwm tshiab yuav tsum tau tsim.`,
    ps: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">وروستی فعالیت</a> له ${max_age} ورځو څخه زیات عمر لری. یو نوی فعالیت باید رامنځته شی.`,
    pt: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`A <a href="${activityHref}">atividade mais recente</a> tem mais de ${max_age} dias. Uma nova atividade precisa ser criada.`,
    'pt-pt': (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`A <a href="${activityHref}">atividade mais recente</a> tem mais de ${max_age} dias. É preciso criar uma nova atividade.`,
    ru: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">Последняя активность</a> существует более ${max_age} дней. Нужно создать новое занятие.`,
    sm: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`O le <a href="${activityHref}">gaioiga aupito lata mai</a> ua silia ma ${max_age} aso le matua. E tatau ona fausiaina se gaoioiga fou.`,
    so: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">Dhaqdhaqaaqii ugu dambeeyay</a> waa in ka badan ${max_age} maalmood jir. Hawl cusub waa in la abuuraa.`,
    th: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">กิจกรรมล่าสุด</a>มีอายุมากกว่า ${max_age} วัน ต้องสร้างกิจกรรมใหม่`,
    ur: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">تازہ ترین سرگرمی</a> ${max_age} دن سے زیادہ پرانی ہے۔ ایک نئی سرگرمی تخلیق کی جانی چاہیے۔`,
    vi: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">Hoạt động gần đây nhất</a> đã hơn ${max_age} ngày. Một hoạt động mới phải được tạo.`,
    'zh-hans': (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`最近一次 <a href="${activityHref}">活动</a> 已经超过 ${max_age} 天了。必须创造一项新的活动。`,
    'zh-hant': (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`最近一次 <a href="${activityHref}">活動</a> 已經超過 ${max_age} 天了。必須創造一項新活動。`,
    en: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`The <a href="${activityHref}">most recent activity</a> is more than ${max_age} days old. A new activity must be created.`
};
const $b11db1b62d4a8f76$export$bc9bb9e082f01bf8 = {
    ar: `\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621} \u{627}\u{644}\u{635}\u{644}\u{627}\u{62D}\u{64A}\u{629}`,
    de: `G\xfcltigkeit`,
    es: `Caduca`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{627}\u{646}\u{642}\u{636}\u{627}`,
    fil: `Nag-e-expire`,
    fr: `Expiration`,
    hi: `\u{938}\u{92E}\u{92F} \u{938}\u{940}\u{92E}\u{93E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B}\u{924}\u{940} \u{939}\u{948}`,
    ht: `ekspire`,
    it: `Scadenza`,
    ja: `\u{671F}\u{9650}\u{5207}\u{308C}`,
    ko: `\u{B9CC}\u{B8CC}`,
    mww: `tas sij hawm`,
    ps: `\u{62E}\u{62A}\u{645} \u{634}\u{648}\u{6CC}`,
    pt: `Expira`,
    'pt-pt': `Expira`,
    ru: `\u{421}\u{440}\u{43E}\u{43A} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Fa'amutaina`,
    so: `Wuu dhacayaa`,
    th: `\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38}`,
    ur: `\u{645}\u{6CC}\u{639}\u{627}\u{62F} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{62C}\u{627}\u{62A}\u{627} \u{6C1}\u{6D2}`,
    vi: `H\u{1EBF}t h\u{1EA1}n`,
    'zh-hans': `\u{8FC7}\u{671F}`,
    'zh-hant': `\u{904E}\u{671F}`,
    en: `Expires`
};
const $b11db1b62d4a8f76$export$aaee57b9a7bca4d4 = {
    ar: `\u{627}\u{633}\u{62A}\u{643}\u{634}\u{627}\u{641}`,
    de: `Entdecken Sie`,
    es: `Explorar`,
    fa: `\u{6A9}\u{627}\u{648}\u{634}`,
    fil: `Galugarin`,
    fr: `Explorer`,
    hi: `\u{92A}\u{924}\u{93E} \u{932}\u{917}\u{93E}\u{928}\u{93E}`,
    ht: `Eksplore`,
    it: `Esplora`,
    ja: `\u{63A2}\u{7D22}`,
    ko: `\u{D0D0}\u{D5D8}\u{D574} \u{BCF4}\u{C138}\u{C694}`,
    mww: `Tshawb nrhiav`,
    ps: `\u{67E}\u{644}\u{67C}\u{646}\u{647}`,
    pt: `Explore`,
    'pt-pt': `Explorar`,
    ru: `\u{418}\u{441}\u{441}\u{43B}\u{435}\u{434}\u{443}\u{439}\u{442}\u{435}`,
    sm: `Su'esu'e`,
    so: `Sahamin`,
    th: `\u{E2A}\u{E4D}\u{E32}\u{E23}\u{E27}\u{E08}`,
    ur: `\u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Kh\xe1m ph\xe1`,
    'zh-hans': `\u{63A2}\u{7D22}`,
    'zh-hant': `\u{63A2}\u{7D22}`,
    en: `Explore`
};
const $b11db1b62d4a8f76$export$9e1fe7d7fd318c28 = {
    ar: $b11db1b62d4a8f76$var$html`الامتداد<span class="sr-only"></span>`,
    de: $b11db1b62d4a8f76$var$html`Außer<span class="sr-only">Ension</span>`,
    es: $b11db1b62d4a8f76$var$html`<span class="sr-only">Extensión</span>`,
    fa: $b11db1b62d4a8f76$var$html`گسترش<span class="sr-only"></span>`,
    fil: $b11db1b62d4a8f76$var$html`Ext<span class="sr-only">ension</span>`,
    fr: $b11db1b62d4a8f76$var$html`<span class="sr-only">Extension de la direction</span>`,
    hi: $b11db1b62d4a8f76$var$html`विस्तार<span class="sr-only"></span>`,
    ht: $b11db1b62d4a8f76$var$html`Ext<span class="sr-only">ension</span>`,
    it: $b11db1b62d4a8f76$var$html`<span class="sr-only">Estensione</span>`,
    ja: $b11db1b62d4a8f76$var$html`外<span class="sr-only">延</span>`,
    ko: $b11db1b62d4a8f76$var$html`익스텐<span class="sr-only">션</span>`,
    mww: $b11db1b62d4a8f76$var$html`Ext<span class="sr-only">ension</span>`,
    ps: $b11db1b62d4a8f76$var$html`Ext<span class="sr-only">ension</span>`,
    pt: $b11db1b62d4a8f76$var$html`<span class="sr-only">Extensão</span>`,
    'pt-pt': $b11db1b62d4a8f76$var$html`<span class="sr-only">Extensão</span>`,
    ru: $b11db1b62d4a8f76$var$html`Ext<span class="sr-only">ension</span>`,
    sm: $b11db1b62d4a8f76$var$html`Ext<span class="sr-only">ension</span>`,
    so: $b11db1b62d4a8f76$var$html`<span class="sr-only">Ballaarinta</span>`,
    th: $b11db1b62d4a8f76$var$html`ขยาย<span class="sr-only"></span>`,
    ur: $b11db1b62d4a8f76$var$html`توسیع<span class="sr-only"></span>`,
    vi: $b11db1b62d4a8f76$var$html`Mở rộng<span class="sr-only"></span>`,
    'zh-hans': $b11db1b62d4a8f76$var$html`延伸<span class="sr-only"></span>`,
    'zh-hant': $b11db1b62d4a8f76$var$html`延<span class="sr-only">展</span>`,
    en: $b11db1b62d4a8f76$var$html`Ext<span class="sr-only">ension</span>`
};
const $b11db1b62d4a8f76$export$71cd312d72359181 = {
    ar: `\u{627}\u{644}\u{645}\u{639}\u{631}\u{641} \u{627}\u{644}\u{62E}\u{627}\u{631}\u{62C}\u{64A}`,
    de: `Externe ID`,
    es: `ID externo`,
    fa: `\u{634}\u{646}\u{627}\u{633}\u{647} \u{62E}\u{627}\u{631}\u{62C}\u{6CC}`,
    fil: `Panlabas na ID`,
    fr: `ID externe`,
    hi: `\u{92C}\u{93E}\u{939}\u{930}\u{940} \u{906}\u{908}\u{921}\u{940}`,
    ht: `ID ekst\xe8n`,
    it: `ID esterno`,
    ja: `\u{5916}\u{90E8}ID`,
    ko: `\u{C678}\u{BD80} ID`,
    mww: `Tus ID sab nraud`,
    ps: `\u{628}\u{647}\u{631}\u{646}\u{6CC} ID`,
    pt: `ID externo`,
    'pt-pt': `ID externo`,
    ru: `\u{412}\u{43D}\u{435}\u{448}\u{43D}\u{438}\u{439} \u{438}\u{434}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440}`,
    sm: `ID i fafo`,
    so: `Aqoonsiga Dibadda`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E20}\u{E32}\u{E22}\u{E19}\u{E2D}\u{E01}`,
    ur: `\u{628}\u{6CC}\u{631}\u{648}\u{646}\u{6CC} \u{634}\u{646}\u{627}\u{62E}\u{62A}\u{6CC} \u{6A9}\u{627}\u{631}\u{688}`,
    vi: `ID b\xean ngo\xe0i`,
    'zh-hans': `\u{5916}\u{90E8}\u{6807}\u{8BC6}`,
    'zh-hant': `\u{5916}\u{90E8}\u{8B58}\u{5225}\u{78BC}`,
    en: `External ID`
};
const $b11db1b62d4a8f76$export$e3a6c49230b600d = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{62E}\u{627}\u{631}\u{62C}\u{64A}`,
    de: `Externe Verwendung`,
    es: `Uso externo`,
    fa: `\u{6A9}\u{627}\u{631}\u{628}\u{631}\u{62F} \u{62E}\u{627}\u{631}\u{62C}\u{6CC}`,
    fil: `Panlabas na paggamit`,
    fr: `Usage externe`,
    hi: `\u{92C}\u{93E}\u{939}\u{930}\u{940} \u{909}\u{92A}\u{92F}\u{94B}\u{917}`,
    ht: `Itilizasyon ekst\xe8n`,
    it: `Uso esterno`,
    ja: `\u{5916}\u{90E8}\u{3067}\u{306E}\u{4F7F}\u{7528}`,
    ko: `\u{C678}\u{BD80} \u{C0AC}\u{C6A9}`,
    mww: `Kev siv sab nraud`,
    ps: `\u{628}\u{647}\u{631}\u{646}\u{6CC} \u{6A9}\u{627}\u{631}\u{648}\u{646}\u{647}`,
    pt: `Uso externo`,
    'pt-pt': `Utiliza\xe7\xe3o externa`,
    ru: `\u{412}\u{43D}\u{435}\u{448}\u{43D}\u{435}\u{435} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Faaaogaina i fafo`,
    so: `Isticmaalka dibadda`,
    th: `\u{E01}\u{E32}\u{E23}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E20}\u{E32}\u{E22}\u{E19}\u{E2D}\u{E01}`,
    ur: `\u{628}\u{6CC}\u{631}\u{648}\u{646}\u{6CC} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644}`,
    vi: `S\u{1EED} d\u{1EE5}ng b\xean ngo\xe0i`,
    'zh-hans': `\u{5916}\u{90E8}\u{7528}\u{6CD5}`,
    'zh-hant': `\u{5916}\u{90E8}\u{7528}\u{9014}`,
    en: `External usage`
};
const $b11db1b62d4a8f76$export$d75858c4590354b7 = {
    ar: `\u{627}\u{644}\u{645}\u{64A}\u{633}\u{631}\u{648}\u{646}`,
    de: `Moderatoren`,
    es: `Facilitadores`,
    fa: `\u{62A}\u{633}\u{647}\u{6CC}\u{644} \u{6AF}\u{631}\u{627}\u{646}`,
    fil: `Mga Tagapagpadala`,
    fr: `Facilitateurs`,
    hi: `\u{938}\u{942}\u{924}\u{94D}\u{930}\u{927}\u{93E}\u{930}`,
    ht: `Fasilitat\xe8 yo`,
    it: `Facilitatori`,
    ja: `\u{30D5}\u{30A1}\u{30B7}\u{30EA}\u{30C6}\u{30FC}\u{30BF}\u{30FC}`,
    ko: `\u{C9C4}\u{D589}\u{C790}`,
    mww: `Cov neeg pab txhawb`,
    ps: `\u{62A}\u{633}\u{647}\u{6CC}\u{644} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Facilitadores`,
    'pt-pt': `Facilitadores`,
    ru: `\u{424}\u{430}\u{441}\u{438}\u{43B}\u{438}\u{442}\u{430}\u{442}\u{43E}\u{440}\u{44B}`,
    sm: `Tagata e Faagaoioia`,
    so: `Fududeeyayaal`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{633}\u{6C1}\u{648}\u{644}\u{62A} \u{6A9}\u{627}\u{631}`,
    vi: `Ng\u{1B0}\u{1EDD}i \u{111}i\u{1EC1}u ph\u{1ED1}i`,
    'zh-hans': `\u{4E3B}\u{6301}\u{4EBA}`,
    'zh-hant': `\u{4E3B}\u{6301}\u{4EBA}`,
    en: `Facilitators`
};
const $b11db1b62d4a8f76$export$70154fb96da70b31 = {
    ar: `\u{627}\u{644}\u{648}\u{643}\u{627}\u{644}\u{629} \u{627}\u{644}\u{641}\u{64A}\u{62F}\u{631}\u{627}\u{644}\u{64A}\u{629}`,
    de: `Bundesbeh\xf6rde`,
    es: `Agencia Federal`,
    fa: `\u{622}\u{698}\u{627}\u{646}\u{633} \u{641}\u{62F}\u{631}\u{627}\u{644}`,
    fil: `Ahensya ng Pederal`,
    fr: `Agence f\xe9d\xe9rale`,
    hi: `\u{938}\u{902}\u{918}\u{940}\u{92F} \u{90F}\u{91C}\u{947}\u{902}\u{938}\u{940}`,
    ht: `Ajans Federal`,
    it: `Agenzia Federale`,
    ja: `\u{9023}\u{90A6}\u{6A5F}\u{95A2}`,
    ko: `\u{C5F0}\u{BC29} \u{AE30}\u{AD00}`,
    mww: `Tsoom Fwv Teb Chaws Lub Koom Haum`,
    ps: `\u{641}\u{62F}\u{631}\u{627}\u{644}\u{6CC} \u{627}\u{62F}\u{627}\u{631}\u{647}`,
    pt: `Ag\xeancia Federal`,
    'pt-pt': `Ag\xeancia Federal`,
    ru: `\u{424}\u{435}\u{434}\u{435}\u{440}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435} \u{430}\u{433}\u{435}\u{43D}\u{442}\u{441}\u{442}\u{432}\u{43E}`,
    sm: `Ofisa Feterale`,
    so: `Hay'adda Federaalka`,
    th: `\u{E2B}\u{E19}\u{E48}\u{E27}\u{E22}\u{E07}\u{E32}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E23}\u{E31}\u{E10}\u{E1A}\u{E32}\u{E25}\u{E01}\u{E25}\u{E32}\u{E07}`,
    ur: `\u{648}\u{641}\u{627}\u{642}\u{6CC} \u{627}\u{6CC}\u{62C}\u{646}\u{633}\u{6CC}`,
    vi: `C\u{1A1} quan li\xean bang`,
    'zh-hans': `\u{8054}\u{90A6}\u{673A}\u{6784}`,
    'zh-hant': `\u{806F}\u{90A6}\u{6A5F}\u{69CB}`,
    en: `Federal Agency`
};
const $b11db1b62d4a8f76$export$334596baad7ddd4b = {
    ar: `\u{623}\u{646}\u{62B}\u{649}`,
    de: `Weiblich`,
    es: `Femenino`,
    fa: `\u{632}\u{646}`,
    fil: `Babae`,
    fr: `F\xe9minin`,
    hi: `\u{92E}\u{939}\u{93F}\u{932}\u{93E}`,
    ht: `Fi`,
    it: `Femmina`,
    ja: `\u{5973}\u{6027}`,
    ko: `\u{C5EC}\u{C131}`,
    mww: `poj niam`,
    ps: `\u{69A}\u{681}\u{6CC}\u{646}\u{647}`,
    pt: `Feminino`,
    'pt-pt': `Feminino`,
    ru: `\u{416}\u{435}\u{43D}\u{441}\u{43A}\u{438}\u{439}`,
    sm: `Tama'ita'i`,
    so: `Dumar`,
    th: `\u{E2B}\u{E0D}\u{E34}\u{E07}`,
    ur: `\u{62E}\u{627}\u{62A}\u{648}\u{646}`,
    vi: `N\u{1EEF}`,
    'zh-hans': `\u{5973}\u{6027}`,
    'zh-hant': `\u{5973}\u{6027}`,
    en: `Female`
};
const $b11db1b62d4a8f76$export$f0026183ed7cd579 = {
    ar: `\u{627}\u{644}\u{645}\u{64A}\u{62F}\u{627}\u{646}`,
    de: `Spielfeld`,
    es: `Campo`,
    fa: `\u{645}\u{6CC}\u{62F}\u{627}\u{646}`,
    fil: `Larangan`,
    fr: `Terrain`,
    hi: `\u{92B}\u{93C}\u{940}\u{932}\u{94D}\u{921}`,
    ht: `Jaden an`,
    it: `Campo`,
    ja: `\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{30C9}`,
    ko: `\u{D544}\u{B4DC}`,
    mww: `Daim teb`,
    ps: `\u{645}\u{6CC}\u{62F}\u{627}\u{646}`,
    pt: `Campo`,
    'pt-pt': `Campo`,
    ru: `\u{41F}\u{43E}\u{43B}\u{435}`,
    sm: `Fanua`,
    so: `Garoonka`,
    th: `\u{E1F}\u{E34}\u{E25}\u{E14}\u{E4C}`,
    ur: `\u{645}\u{6CC}\u{62F}\u{627}\u{646}`,
    vi: `L\u{129}nh v\u{1EF1}c`,
    'zh-hans': `\u{573A}\u{5730}`,
    'zh-hant': `\u{5834}\u{5730}`,
    en: `Field`
};
const $b11db1b62d4a8f76$export$989066564c2ca33b = {
    ar: `\u{627}\u{644}\u{62D}\u{642}\u{648}\u{644}`,
    de: `Felder`,
    es: `Campos`,
    fa: `\u{632}\u{645}\u{6CC}\u{646} \u{647}\u{627}`,
    fil: `Mga patlang`,
    fr: `Champs`,
    hi: `\u{92B}\u{93C}\u{940}\u{932}\u{94D}\u{921}\u{94D}\u{938}`,
    ht: `Jaden yo`,
    it: `Campi`,
    ja: `\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{30C9}`,
    ko: `\u{D544}\u{B4DC}`,
    mww: `Liaj teb`,
    ps: `\u{645}\u{6CC}\u{62F}\u{627}\u{646}\u{648}\u{646}\u{647}`,
    pt: `Campos`,
    'pt-pt': `Campos`,
    ru: `\u{41E}\u{431}\u{43B}\u{430}\u{441}\u{442}\u{438}`,
    sm: `Fanua`,
    so: `Garoomada`,
    th: `\u{E1F}\u{E34}\u{E25}\u{E14}\u{E4C}`,
    ur: `\u{645}\u{6CC}\u{62F}\u{627}\u{646}\u{6CC}\u{6BA}`,
    vi: `Tr\u{1B0}\u{1EDD}ng`,
    'zh-hans': `\u{573A}`,
    'zh-hant': `\u{5834}`,
    en: `Fields`
};
const $b11db1b62d4a8f76$export$c06f7f206b1f633e = {
    ar: `50 \u{645}\u{64A}\u{644}\u{627}`,
    de: `50 Meilen`,
    es: `50 millas`,
    fa: `\u{6F5}\u{6F0} \u{645}\u{627}\u{6CC}\u{644}`,
    fil: `50 milya`,
    fr: `50 miles`,
    hi: `50 \u{92E}\u{940}\u{932}`,
    ht: `50 mil`,
    it: `50 miglia`,
    ja: `50\u{30DE}\u{30A4}\u{30EB}`,
    ko: `50\u{B9C8}\u{C77C}`,
    mww: `50 mais`,
    ps: `\u{6F5}\u{6F0} \u{645}\u{6CC}\u{644}`,
    pt: `50 milhas`,
    'pt-pt': `50 milhas`,
    ru: `50 \u{43C}\u{438}\u{43B}\u{44C}`,
    sm: `50 maila`,
    so: `50 mayl`,
    th: `80.1 \u{E01}\u{E21}.`,
    ur: `50 \u{645}\u{6CC}\u{644}`,
    vi: `50 d\u{1EB7}m`,
    'zh-hans': `50\u{82F1}\u{91CC}`,
    'zh-hant': `50\u{82F1}\u{91CC}`,
    en: `50 miles`
};
const $b11db1b62d4a8f76$export$c4b05ddd15bcedcd = {
    ar: (filename)=>`\u{627}\u{644}\u{645}\u{644}\u{641} \u{641}\u{627}\u{631}\u{63A}: "${filename}".`,
    de: (filename)=>`Datei ist leer: "${filename}".`,
    es: (filename)=>`El archivo est\xe1 vac\xedo: "${filename}".`,
    fa: (filename)=>`\u{641}\u{627}\u{6CC}\u{644} \u{62E}\u{627}\u{644}\u{6CC} \u{627}\u{633}\u{62A}: \xab${filename}\xbb.`,
    fil: (filename)=>`Walang laman ang file: "${filename}".`,
    fr: (filename)=>`Le fichier est vide : \xab ${filename} \xbb.`,
    hi: (filename)=>`\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{916}\u{93E}\u{932}\u{940} \u{939}\u{948}: "${filename}.`,
    ht: (filename)=>`Dosye vid: "${filename}".`,
    it: (filename)=>`File vuoto: "${filename}".`,
    ja: (filename)=>`\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{306F}\u{7A7A}:\u{300C}${filename}\u{300D}\u{3002}`,
    ko: (filename)=>`\u{D30C}\u{C77C}\u{C740} \u{BE44}\u{C5B4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}: "${filename}".`,
    mww: (filename)=>`Cov ntaub ntawv khoob: "${filename}".`,
    ps: (filename)=>`\u{641}\u{627}\u{6CC}\u{644} \u{62E}\u{627}\u{644}\u{6CC} \u{62F}\u{6CC}: "${filename}".`,
    pt: (filename)=>`O arquivo est\xe1 vazio: "${filename}".`,
    'pt-pt': (filename)=>`O ficheiro est\xe1 vazio: "${filename}".`,
    ru: (filename)=>`\u{424}\u{430}\u{439}\u{43B} \u{43F}\u{443}\u{441}\u{442}\u{43E}\u{439}: \xab${filename}\xbb.`,
    sm: (filename)=>`E gaogao le faila: "${filename}".`,
    so: (filename)=>`Faylku waa madhan yahay: ${filename}".`,
    th: (filename)=>`\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E27}\u{E48}\u{E32}\u{E07}\u{E40}\u{E1B}\u{E25}\u{E48}\u{E32}: "${filename}"`,
    ur: (filename)=>`\u{641}\u{627}\u{626}\u{644} \u{62E}\u{627}\u{644}\u{6CC} \u{6C1}\u{6D2}: "${filename}"\u{6D4}`,
    vi: (filename)=>`T\u{1EC7}p tr\u{1ED1}ng: "${filename}".`,
    'zh-hans': (filename)=>`\u{6587}\u{4EF6}\u{4E3A}\u{7A7A}\u{FF1A}\u{201C}${filename}\u{201D}\u{3002}`,
    'zh-hant': (filename)=>`\u{6A94}\u{6848}\u{70BA}\u{7A7A}\u{FF1A}\u{300C}${filename}\u{300D}\u{3002}`,
    en: (filename)=>`File is empty: "${filename}".`
};
const $b11db1b62d4a8f76$export$24543fd1c6c63614 = {
    ar: `\u{627}\u{633}\u{645} \u{627}\u{644}\u{645}\u{644}\u{641}`,
    de: `Dateiname`,
    es: `Nombre del archivo`,
    fa: `\u{646}\u{627}\u{645} \u{641}\u{627}\u{6CC}\u{644}`,
    fil: `Pangalan ng File`,
    fr: `Nom de fichier`,
    hi: `\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{915}\u{93E} \u{928}\u{93E}\u{92E}`,
    ht: `Non dosye a`,
    it: `Nome file`,
    ja: `\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{540D}`,
    ko: `\u{D30C}\u{C77C}\u{B124}\u{C784}`,
    mww: `Lub npe filename`,
    ps: `\u{62F} \u{641}\u{627}\u{6CC}\u{644} \u{646}\u{648}\u{645}`,
    pt: `Nome do arquivo`,
    'pt-pt': `Nome do ficheiro`,
    ru: `\u{418}\u{43C}\u{44F} \u{444}\u{430}\u{439}\u{43B}\u{430}`,
    sm: `Igoa o le faila`,
    so: `Magaca faylka`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E44}\u{E1F}\u{E25}\u{E4C}`,
    ur: `\u{641}\u{627}\u{626}\u{644} \u{646}\u{6CC}\u{645}`,
    vi: `T\xean t\u{1EAD}p tin`,
    'zh-hans': `\u{6587}\u{4EF6}\u{540D}`,
    'zh-hant': `\u{6A94}\u{6848}\u{540D}\u{7A31}`,
    en: `Filename`
};
const $b11db1b62d4a8f76$export$d508f7bb704b781f = {
    ar: (filename, maxLength)=>`\u{627}\u{633}\u{645} \u{627}\u{644}\u{645}\u{644}\u{641} \u{637}\u{648}\u{64A}\u{644} \u{62C}\u{62F}\u{627}: "${filename}". \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} \u{623}\u{633}\u{645}\u{627}\u{621} \u{627}\u{644}\u{645}\u{644}\u{641}\u{627}\u{62A} ${maxLength} \u{62D}\u{631}\u{641} \u{623}\u{648} \u{623}\u{642}\u{644}.`,
    de: (filename, maxLength)=>`Dateiname zu lang: "${filename}". Dateinamen m\xfcssen ${maxLength} Zeichen oder weniger sein.`,
    es: (filename, maxLength)=>`Nombre de archivo demasiado largo: "${filename}". Los nombres de archivo deben tener ${maxLength} caracteres o menos.`,
    fa: (filename, maxLength)=>`\u{646}\u{627}\u{645} \u{641}\u{627}\u{6CC}\u{644} \u{62E}\u{6CC}\u{644}\u{6CC} \u{637}\u{648}\u{644}\u{627}\u{646}\u{6CC} \u{627}\u{633}\u{62A}: \xab${filename}\xbb. \u{646}\u{627}\u{645} \u{641}\u{627}\u{6CC}\u{644} \u{647}\u{627} \u{628}\u{627}\u{6CC}\u{62F} ${maxLength} \u{6A9}\u{627}\u{631}\u{627}\u{6A9}\u{62A}\u{631} \u{6CC}\u{627} \u{6A9}\u{645}\u{62A}\u{631} \u{628}\u{627}\u{634}\u{646}\u{62F}.`,
    fil: (filename, maxLength)=>`Masyadong mahaba ang filename: "${filename}". Ang mga pangalan ng file ay dapat na ${maxLength} character o mas mababa.`,
    fr: (filename, maxLength)=>`Nom de fichier trop long : \xab ${filename} \xbb. Les noms de fichiers doivent faire ${maxLength} caract\xe8res ou moins.`,
    hi: (filename, maxLength)=>`\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{928}\u{93E}\u{92E} \u{92C}\u{939}\u{941}\u{924} \u{932}\u{902}\u{92C}\u{93E}: "${filename}"\u{964} \u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{928}\u{93E}\u{92E} ${maxLength} \u{935}\u{930}\u{94D}\u{923} \u{92F}\u{93E} \u{909}\u{938}\u{938}\u{947} \u{915}\u{92E} \u{939}\u{94B}\u{928}\u{947} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}\u{964}`,
    ht: (filename, maxLength)=>`Non dosye tw\xf2 lontan: "${filename}". Non dosye yo dwe ${maxLength} karakt\xe8 oswa mwens.`,
    it: (filename, maxLength)=>`Nome file troppo lungo: "${filename}". I nomi dei file devono avere ${maxLength} caratteri.`,
    ja: (filename, maxLength)=>`\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{540D}\u{304C}\u{9577}\u{3059}\u{304E}\u{308B}:\u{300C}${filename}\u{300D}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{540D}\u{306F} ${maxLength} \u{6587}\u{5B57}\u{4EE5}\u{5185}\u{3067}\u{306A}\u{3051}\u{308C}\u{3070}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (filename, maxLength)=>`\u{D30C}\u{C77C} \u{C774}\u{B984}\u{C774} \u{B108}\u{BB34} \u{AE38}\u{C5B4}\u{C694}: "${filename}". \u{D30C}\u{C77C} \u{C774}\u{B984}\u{C740} ${maxLength} \u{C790} \u{C774}\u{B0B4}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (filename, maxLength)=>`Filename ntev dhau: "${filename}". Cov npe filenames yuav tsum yog ${maxLength} cim lossis tsawg dua.`,
    ps: (filename, maxLength)=>`\u{62F} \u{641}\u{627}\u{6CC}\u{644} \u{646}\u{648}\u{645} \u{689}\u{6D0}\u{631} \u{627}\u{648}\u{696}\u{62F} \u{62F}\u{6CC}: "${filename}". \u{62F} \u{641}\u{627}\u{6CC}\u{644} \u{646}\u{648}\u{645}\u{648}\u{646}\u{647} \u{628}\u{627}\u{6CC}\u{62F} ${maxLength} \u{6A9}\u{631}\u{6A9}\u{67C}\u{631}\u{648}\u{646}\u{647} \u{6CC}\u{627} \u{6A9}\u{645} \u{648}\u{6CC}.`,
    pt: (filename, maxLength)=>`Nome do arquivo muito longo: "${filename}". Os nomes dos arquivos devem ter ${maxLength} caracteres ou menos.`,
    'pt-pt': (filename, maxLength)=>`Nome do ficheiro demasiado longo: "${filename}". Os nomes dos ficheiros devem ter ${maxLength} caracteres ou menos.`,
    ru: (filename, maxLength)=>`\u{41D}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{444}\u{430}\u{439}\u{43B}\u{430} \u{441}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{434}\u{43B}\u{438}\u{43D}\u{43D}\u{43E}\u{435}: \xab${filename}\xbb. \u{418}\u{43C}\u{435}\u{43D}\u{430} \u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{44B} \u{431}\u{44B}\u{442}\u{44C} ${maxLength} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{432}.`,
    sm: (filename, maxLength)=>`Igoa o le faila e umi tele: "${filename}". O igoa o faila e tatau ona ${maxLength} mataitusi pe itiiti ifo.`,
    so: (filename, maxLength)=>`Magaca faylka aad u dheer: "${filename}". Magacyada faylasha waa in ay ${maxLength} xaraf ama ka yar.`,
    th: (filename, maxLength)=>`\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E22}\u{E32}\u{E27}\u{E40}\u{E01}\u{E34}\u{E19}\u{E44}\u{E1B}: "${filename}" \u{E0A}\u{E37}\u{E48}\u{E2D}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E2D}\u{E31}\u{E01}\u{E02}\u{E23}\u{E30}\u{E44}\u{E21}\u{E48}\u{E40}\u{E01}\u{E34}\u{E19} ${maxLength} \u{E15}\u{E31}\u{E27}`,
    ur: (filename, maxLength)=>`\u{641}\u{627}\u{626}\u{644} \u{646}\u{6CC}\u{645} \u{628}\u{6C1}\u{62A} \u{644}\u{645}\u{628}\u{627} \u{6C1}\u{6D2}: "${filename}"\u{6D4} \u{641}\u{627}\u{626}\u{644} \u{646}\u{627}\u{645} ${maxLength} \u{62D}\u{631}\u{648}\u{641} \u{6CC}\u{627} \u{627}\u{633} \u{633}\u{6D2} \u{6A9}\u{645} \u{6C1}\u{648}\u{646}\u{6D2} \u{686}\u{627}\u{6C1}\u{626}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (filename, maxLength)=>`T\xean t\u{1EC7}p qu\xe1 d\xe0i: "${filename}". T\xean t\u{1EC7}p ph\u{1EA3}i c\xf3 t\u{1EEB} ${maxLength} k\xfd t\u{1EF1} tr\u{1EDF} xu\u{1ED1}ng.`,
    'zh-hans': (filename, maxLength)=>`\u{6587}\u{4EF6}\u{540D}\u{592A}\u{957F}\u{FF1A}\u{201C}${filename}\u{201D}\u{3002}\u{6587}\u{4EF6}\u{540D}\u{5FC5}\u{987B}\u{4E0D}\u{8D85}\u{8FC7} ${maxLength} \u{5B57}\u{7B26}\u{3002}`,
    'zh-hant': (filename, maxLength)=>`\u{6A94}\u{540D}\u{592A}\u{9577}\u{FF1A}\u{300C}${filename}\u{300D}\u{3002}\u{6A94}\u{540D}\u{5FC5}\u{9808}\u{4E0D}\u{8D85}\u{904E} ${maxLength} \u{5B57}\u{5143}\u{3002}`,
    en: (filename, maxLength)=>`Filename too long: "${filename}". Filenames must be ${maxLength} characters or less.`
};
const $b11db1b62d4a8f76$export$20aa924aeb55054c = {
    ar: (filename, extension, maxSize)=>`\u{645}\u{644}\u{641} \u{643}\u{628}\u{64A}\u{631} \u{62C}\u{62F}\u{627}: "${filename}". \u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{642}\u{635}\u{649} \u{644}\u{62D}\u{62C}\u{645} \u{627}\u{644}\u{645}\u{644}\u{641} \u{644}\u{645}\u{644}\u{641}\u{627}\u{62A} "${extension}" \u{647}\u{648} ${maxSize}.`,
    de: (filename, extension, maxSize)=>`Datei zu gro\xdf: "${filename}". Die maximale Dateigr\xf6\xdfe f\xfcr "${extension}"-Dateien betr\xe4gt ${maxSize}.`,
    es: (filename, extension, maxSize)=>`Archivo demasiado grande: "${filename}". El tama\xf1o m\xe1ximo de archivo para archivos "${extension}" es ${maxSize}.`,
    fa: (filename, extension, maxSize)=>`\u{641}\u{627}\u{6CC}\u{644} \u{62E}\u{6CC}\u{644}\u{6CC} \u{628}\u{632}\u{631}\u{6AF} \u{627}\u{633}\u{62A}: \xab${filename}\xbb. \u{62D}\u{62F}\u{627}\u{6A9}\u{62B}\u{631} \u{62D}\u{62C}\u{645} \u{641}\u{627}\u{6CC}\u{644} \u{628}\u{631}\u{627}\u{6CC} \u{641}\u{627}\u{6CC}\u{644} \u{647}\u{627}\u{6CC} \xab${extension}\xbb ${maxSize} \u{627}\u{633}\u{62A}.`,
    fil: (filename, extension, maxSize)=>`File masyadong malaki: "${filename}". Ang maximum na laki ng file para sa "${extension}" na mga file ay ${maxSize}.`,
    fr: (filename, extension, maxSize)=>`Fichier trop grand : \xab ${filename} \xbb. La taille maximale des fichiers \xab ${extension} \xbb est ${maxSize}.`,
    hi: (filename, extension, maxSize)=>`\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{92C}\u{939}\u{941}\u{924} \u{92C}\u{921}\u{93C}\u{940} \u{939}\u{948}: "${filename}"\u{964} "${extension}" \u{92B}\u{93C}\u{93E}\u{907}\u{932}\u{94B}\u{902} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{927}\u{93F}\u{915}\u{924}\u{92E} \u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{906}\u{915}\u{93E}\u{930} ${maxSize} \u{939}\u{948}\u{964}`,
    ht: (filename, extension, maxSize)=>`Dosye tw\xf2 gwo: "${filename}". Gwos\xe8 a ranpli maksim\xf2m pou "${extension}" fichiers se ${maxSize}.`,
    it: (filename, extension, maxSize)=>`File troppo grande: "${filename}". La dimensione massima dei file per i file "${extension}" \xe8 ${maxSize}.`,
    ja: (filename, extension, maxSize)=>`\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{304C}\u{5927}\u{304D}\u{3059}\u{304E}\u{308B}:\u{300C}${filename}\u{300D}\u{3067}\u{3059}\u{3002}\u{300C}${extension}\u{300D}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{306E}\u{6700}\u{5927}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{30B5}\u{30A4}\u{30BA}\u{306F} ${maxSize}\u{3067}\u{3059}\u{3002}`,
    ko: (filename, extension, maxSize)=>`\u{D30C}\u{C77C} \u{D06C}\u{AE30}\u{AC00} \u{B108}\u{BB34} \u{CEE4}: "${filename}". "${extension}" \u{D30C}\u{C77C}\u{C758} \u{CD5C}\u{B300} \u{D30C}\u{C77C} \u{D06C}\u{AE30}\u{B294} ${maxSize}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (filename, extension, maxSize)=>`Cov ntaub ntawv loj dhau: ${filename}". Qhov siab tshaj plaws cov ntaub ntawv loj rau cov ntaub ntawv "${extension}" yog ${maxSize}.`,
    ps: (filename, extension, maxSize)=>`\u{62F}\u{648}\u{633}\u{6CC}\u{647} \u{689}\u{6D0}\u{631}\u{647} \u{644}\u{648}\u{6CC}\u{647} \u{62F}\u{647}: "${filename}". \u{62F} "${extension}" \u{641}\u{627}\u{6CC}\u{644}\u{648}\u{646}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{627}\u{639}\u{638}\u{645}\u{6CC} \u{641}\u{627}\u{6CC}\u{644} \u{627}\u{646}\u{62F}\u{627}\u{632}\u{647} ${maxSize} \u{62F}\u{647}.`,
    pt: (filename, extension, maxSize)=>`Arquivo muito grande: "${filename}". O tamanho m\xe1ximo de arquivo para arquivos "${extension}" \xe9 ${maxSize}.`,
    'pt-pt': (filename, extension, maxSize)=>`Ficheiro demasiado grande: "${filename}". O tamanho m\xe1ximo do ficheiro para ficheiros "${extension}" \xe9 ${maxSize}.`,
    ru: (filename, extension, maxSize)=>`\u{424}\u{430}\u{439}\u{43B} \u{441}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{43E}\u{439}: \xab${filename}\xbb. \u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{44B}\u{439} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440} \u{444}\u{430}\u{439}\u{43B}\u{430} \u{434}\u{43B}\u{44F} "${extension}" \u{2014} ${maxSize}.`,
    sm: (filename, extension, maxSize)=>`Faila tele tele: "${filename}". O le lapo'a faila aupito maualuga mo faila "${extension}" o ${maxSize}.`,
    so: (filename, extension, maxSize)=>`Fayl aad u weyn: ${filename}". Cabbirka ugu badan ee faylasha "${extension}" waa ${maxSize}.`,
    th: (filename, extension, maxSize)=>`\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E43}\u{E2B}\u{E0D}\u{E48}\u{E40}\u{E01}\u{E34}\u{E19}\u{E44}\u{E1B}: "${filename}" \u{E02}\u{E19}\u{E32}\u{E14}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E2A}\u{E39}\u{E07}\u{E2A}\u{E38}\u{E14}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E44}\u{E1F}\u{E25}\u{E4C} "${extension}" \u{E04}\u{E37}\u{E2D} ${maxSize}`,
    ur: (filename, extension, maxSize)=>`\u{641}\u{627}\u{626}\u{644} \u{628}\u{6C1}\u{62A} \u{628}\u{691}\u{6CC} \u{6C1}\u{6D2}: "${filename}"\u{6D4} "${extension}" \u{641}\u{627}\u{626}\u{644}\u{632} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{633}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{641}\u{627}\u{626}\u{644} \u{633}\u{627}\u{626}\u{632} ${maxSize} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (filename, extension, maxSize)=>`T\u{1EC7}p qu\xe1 l\u{1EDB}n: "${filename}". K\xedch th\u{1B0}\u{1EDB}c t\u{1EC7}p t\u{1ED1}i \u{111}a cho t\u{1EC7}p "${extension}" l\xe0 ${maxSize}.`,
    'zh-hans': (filename, extension, maxSize)=>`\u{6587}\u{4EF6}\u{592A}\u{5927}\u{FF1A}\u{201C}${filename}\u{201D}\u{3002}\u{201C}${extension}\u{201D}\u{6587}\u{4EF6}\u{7684}\u{6700}\u{5927}\u{6587}\u{4EF6}\u{5927}\u{5C0F}\u{4E3A} ${maxSize}\u{3002}`,
    'zh-hant': (filename, extension, maxSize)=>`\u{6A94}\u{6848}\u{592A}\u{5927}\u{FF1A}\u{300C}${filename}\u{300D}\u{3002}\u{300C}${extension}\u{300D}\u{6A94}\u{6848}\u{7684}\u{6700}\u{5927}\u{6A94}\u{6848}\u{5927}\u{5C0F}\u{70BA} ${maxSize}\u{3002}`,
    en: (filename, extension, maxSize)=>`File too large: "${filename}". The maximum file size for "${extension}" files is ${maxSize}.`
};
const $b11db1b62d4a8f76$export$a3be3a5535cf4dfb = {
    ar: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} أرسل لك هذا النموذج لتكمله. إذا كان لديك أسئلة، تواصل ${senderGivenName} عبر البريد الإلكتروني <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. ستنتهي صلاحية هذا النموذج ${expires}`,
    de: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} hat Ihnen dieses Formular zum Ausfüllen geschickt. Wenn Sie Fragen haben, kontaktieren ${senderGivenName} per E-Mail unter <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Dieses Formular läuft ${expires}`,
    es: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} te envió este formulario para que lo rellenes. Si tienes preguntas, contacta ${senderGivenName} por correo electrónico en <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulario caducará ${expires}`,
    fa: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} این فرم را برای تکمیل برایت فرستاده است. اگر سوالی دارید، با ${senderGivenName} از طریق ایمیل <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> تماس بگیرید. این فرم ${expires} منقضی خواهد شد.`,
    fil: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`Ipinadala sa iyo ${senderName} ang form na ito upang kumpletuhin ang form na ito. Kung mayroon kang mga katanungan, makipag-ugnay kay ${senderGivenName} sa pamamagitan ng email sa <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Ang form na ito ay mag-e-expire ${expires}`,
    fr: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} t’a envoyé ce formulaire à remplir. Si vous avez des questions, contactez ${senderGivenName} par email à <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Ce formulaire expirera ${expires}`,
    hi: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} ने आपको यह फॉर्म पूरा करने के लिए भेजा है। यदि आपके कोई प्रश्न हैं, तो <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> ईमेल के माध्यम से ${senderGivenName} संपर्क करें। यह फॉर्म ${expires} समाप्त हो जाएगा।`,
    ht: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} voye ou fòm sa a pou w ranpli. Si ou gen kesyon, kontakte ${senderGivenName} pa imèl nan <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Fòm sa a ap ekspire ${expires}`,
    it: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} ti ha inviato questo modulo da compilare. Se hai domande, contatta ${senderGivenName} via email <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Questo modulo scadrà ${expires}`,
    ja: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName}このフォームを送ってきました。ご質問がある場合は、<a class="Link--primary" href="${senderEmail}">${senderEmail}</a> までメールで${senderGivenName}にご連絡ください。このフォームは${expires}で期限切れとなります。`,
    ko: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} 이 양식을 작성하라고 보냈습니다. 궁금한 점이 있으면 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> 로 이메일을 ${senderGivenName}에게 연락해 주세요. 이 양식은 ${expires}에 만료됩니다.`,
    mww: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} tau xa daim ntawv no rau koj kom tiav. Yog tias koj muaj lus nug, hu rau ${senderGivenName} ntawm email ntawm <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Daim ntawv no yuav tas sij hawm ${expires}`,
    ps: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} دا فورمه درلیږلې چې بشپړه یې کړې. که پوښتنه لرئ، ${senderGivenName} ته په ایمیل کې <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. دا فورمه به ${expires} پای ته ورسېږی.`,
    pt: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} enviou este formulário para você preencher. Se tiver dúvidas, entre em contato ${senderGivenName} por e-mail <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulário expirará ${expires}`,
    'pt-pt': (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} enviou-lhe este formulário para preencher. Se tiver dúvidas, contacte ${senderGivenName} por email <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulário expira ${expires}`,
    ru: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} прислал вам эту форму для заполнения. Если у вас есть вопросы, свяжитесь ${senderGivenName} по электронной почте <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Эта форма истекает ${expires}`,
    sm: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`Na auina atu ${senderName} le fomu lenei e faatumu. Afai ei ai ni au fesili, fa'afeso'ota'i ${senderGivenName} e ala i le imeli i le <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. O lenei fomu o le a muta ${expires}`,
    so: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} ayaa kuu soo diray foomkan si aad u buuxiso. Haddii aad su'aalo qabtid, la xiriir ${senderGivenName} email <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Foomkan wuxuu dhici ${expires}`,
    th: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName}ส่งแบบฟอร์มนี้ให้คุณกรอก หากคุณมีคําถาม โปรดติดต่อ${senderGivenName}ทางอีเมลที่ <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> แบบฟอร์มนี้จะหมดอายุใน${expires}`,
    ur: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} نے آپ کو یہ فارم مکمل کرنے کے لیے بھیجا ہے۔ اگر آپ کے سوالات ہیں تو ${senderGivenName} سے ای میل <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> پر رابطہ کریں۔ یہ فارم ${expires} ختم ہو جائے گا۔`,
    vi: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} đã gửi cho bạn biểu mẫu này để hoàn thành. Nếu bạn có thắc mắc, hãy liên hệ với ${senderGivenName} qua email theo số <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Biểu mẫu này sẽ hết hạn vào ${expires}`,
    'zh-hans': (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} 寄给你填写这份表格。如有疑问，请通过电子邮件联系 ${senderGivenName} ，邮箱为 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>。该表格将于 ${expires}）到期。`,
    'zh-hant': (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} 寄給你這份表格，請你填寫。如有疑問，請透過電子郵件聯絡 ${senderGivenName} ，電子郵件為 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>。此表格將於 ${expires}）到期。`,
    en: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} sent you this form to complete. If you have questions, contact ${senderGivenName} via email at <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. This form will expire ${expires}.`
};
const $b11db1b62d4a8f76$export$ca5f05f951113039 = {
    ar: `\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{62A}\u{635}\u{641}\u{64A}\u{629}`,
    de: `Filteraktivit\xe4ten`,
    es: `Actividades de filtrado`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{641}\u{6CC}\u{644}\u{62A}\u{631}`,
    fil: `I-filter ang mga aktibidad`,
    fr: `Activit\xe9s de filtrage`,
    hi: `\u{92B}\u{93C}\u{93F}\u{932}\u{94D}\u{91F}\u{930} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `Filtre aktivite`,
    it: `Attivit\xe0 di filtro`,
    ja: `\u{30D5}\u{30A3}\u{30EB}\u{30BF}\u{30FC}\u{6D3B}\u{52D5}`,
    ko: `\u{D544}\u{D130} \u{D65C}\u{B3D9}`,
    mww: `Lim cov kev ua ub no`,
    ps: `\u{641}\u{644}\u{67C}\u{631} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Atividades de filtro`,
    'pt-pt': `Atividades de filtro`,
    ru: `\u{424}\u{438}\u{43B}\u{44C}\u{442}\u{440}\u{443}\u{44E}\u{449}\u{438}\u{435} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Gaoioiga faamama`,
    so: `Hawlaha filter-ka`,
    th: `\u{E01}\u{E23}\u{E2D}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{641}\u{644}\u{679}\u{631} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}`,
    vi: `L\u{1ECD}c ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{8FC7}\u{6EE4}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{904E}\u{6FFE}\u{6D3B}\u{52D5}`,
    en: `Filter activities`
};
const $b11db1b62d4a8f76$export$5d8f4ce75feb8c2f = {
    ar: `\u{644}\u{648}\u{62D}\u{627}\u{62A} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{635}\u{641}\u{64A}\u{629}`,
    de: `Filter-Dashboards`,
    es: `Paneles de control de filtros`,
    fa: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F}\u{647}\u{627}\u{6CC} \u{641}\u{6CC}\u{644}\u{62A}\u{631}`,
    fil: `I-filter ang mga dashboard`,
    fr: `Tableaux de bord \xe0 filtres`,
    hi: `\u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{92B}\u{93C}\u{93F}\u{932}\u{94D}\u{91F}\u{930} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Filtre tablodb\xf2`,
    it: `Dashboard a filtro`,
    ja: `\u{30D5}\u{30A3}\u{30EB}\u{30BF}\u{30FC}\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}`,
    ko: `\u{D544}\u{D130} \u{B300}\u{C2DC}\u{BCF4}\u{B4DC}`,
    mww: `Lim dashboards`,
    ps: `\u{641}\u{644}\u{67C}\u{631} \u{689}\u{634}\u{628}\u{648}\u{631}\u{689}\u{648}\u{646}\u{647}`,
    pt: `Dashboards de filtro`,
    'pt-pt': `Pain\xe9is de painel de filtros`,
    ru: `\u{41F}\u{430}\u{43D}\u{435}\u{43B}\u{438} \u{444}\u{438}\u{43B}\u{44C}\u{442}\u{440}\u{43E}\u{432}`,
    sm: `Faamama dashboards`,
    so: `Dashboards-ka filter-ka`,
    th: `\u{E01}\u{E23}\u{E2D}\u{E07}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}`,
    ur: `\u{641}\u{644}\u{679}\u{631} \u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688}\u{632}`,
    vi: `L\u{1ECD}c b\u{1EA3}ng th\xf4ng tin`,
    'zh-hans': `\u{8FC7}\u{6EE4}\u{5668}\u{4EEA}\u{8868}\u{76D8}`,
    'zh-hant': `\u{7BE9}\u{9078}\u{5100}\u{8868}\u{677F}`,
    en: `Filter dashboards`
};
const $b11db1b62d4a8f76$export$bddf96b1b6d3652a = {
    ar: `\u{641}\u{644}\u{62A}\u{631}...`,
    de: `Filter...`,
    es: `Filtro...`,
    fa: `\u{641}\u{6CC}\u{644}\u{62A}\u{631}...`,
    fil: `Filter ...`,
    fr: `Filtre...`,
    hi: `\u{92B}\u{93C}\u{93F}\u{932}\u{94D}\u{91F}\u{930}.`,
    ht: `Filtre ...`,
    it: `Filtro...`,
    ja: `\u{30D5}\u{30A3}\u{30EB}\u{30BF}\u{30FC}...`,
    ko: `\u{D544}\u{D130}...`,
    mww: `Lim...`,
    ps: `\u{641}\u{644}\u{67C}\u{631}...`,
    pt: `Filtro...`,
    'pt-pt': `Filtro...`,
    ru: `\u{424}\u{438}\u{43B}\u{44C}\u{442}\u{440}...`,
    sm: `Faamama ...`,
    so: `Shaandhee...`,
    th: `\u{E01}\u{E23}\u{E2D}\u{E07}...`,
    ur: `\u{641}\u{644}\u{679}\u{631}...`,
    vi: `B\u{1ED9} l\u{1ECD}c...`,
    'zh-hans': `\u{8FC7}\u{6EE4}......`,
    'zh-hant': `\u{904E}\u{6FFE}\u{5668}......`,
    en: `Filter...`
};
const $b11db1b62d4a8f76$export$e21476f0b13ef471 = {
    ar: `\u{62A}\u{642}\u{627}\u{631}\u{64A}\u{631} \u{627}\u{644}\u{62A}\u{635}\u{641}\u{64A}\u{629}`,
    de: `Filterberichte`,
    es: `Informes de filtros`,
    fa: `\u{6AF}\u{632}\u{627}\u{631}\u{634} \u{647}\u{627}\u{6CC} \u{641}\u{6CC}\u{644}\u{62A}\u{631}`,
    fil: `I-filter ang mga ulat`,
    fr: `Rapports de filtres`,
    hi: `\u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F} \u{92B}\u{93C}\u{93F}\u{932}\u{94D}\u{91F}\u{930} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Filtre rap\xf2`,
    it: `Rapporti di filtro`,
    ja: `\u{30D5}\u{30A3}\u{30EB}\u{30BF}\u{30FC}\u{30EC}\u{30DD}\u{30FC}\u{30C8}`,
    ko: `\u{D544}\u{D130} \u{BCF4}\u{ACE0}\u{C11C}`,
    mww: `Lim cov ntawv ceeb toom`,
    ps: `\u{62F} \u{641}\u{644}\u{67C}\u{631} \u{631}\u{627}\u{67E}\u{648}\u{631}\u{648}\u{646}\u{647}`,
    pt: `Relat\xf3rios de filtro`,
    'pt-pt': `Relat\xf3rios de filtro`,
    ru: `\u{41E}\u{442}\u{447}\u{451}\u{442}\u{44B} \u{444}\u{438}\u{43B}\u{44C}\u{442}\u{440}\u{43E}\u{432}`,
    sm: `Faamama lipoti`,
    so: `Warbixinnada filter-ka`,
    th: `\u{E01}\u{E23}\u{E2D}\u{E07}\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{641}\u{644}\u{679}\u{631} \u{631}\u{67E}\u{648}\u{631}\u{679}\u{633}`,
    vi: `L\u{1ECD}c b\xe1o c\xe1o`,
    'zh-hans': `\u{8FC7}\u{6EE4}\u{5668}\u{62A5}\u{544A}`,
    'zh-hant': `\u{904E}\u{6FFE}\u{5668}\u{5831}\u{544A}`,
    en: `Filter reports`
};
const $b11db1b62d4a8f76$export$6d4ad4d085a9e023 = {
    ar: `\u{627}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{627}\u{644}\u{645}\u{648}\u{643}\u{64A}\u{644}`,
    de: `Finde den Zugewiesenen`,
    es: `Encontrar asignado`,
    fa: `\u{6CC}\u{627}\u{641}\u{62A}\u{646} \u{645}\u{623}\u{645}\u{648}\u{631}`,
    fil: `Email Address *`,
    fr: `Trouver l\u{2019}assign\xe9`,
    hi: `\u{905}\u{938}\u{93E}\u{907}\u{928}\u{940} \u{916}\u{94B}\u{91C}\u{947}\u{902}`,
    ht: `Jwenn asiyen`,
    it: `Trova l'assegnato`,
    ja: `\u{8B72}\u{53D7}\u{4EBA}\u{3092}\u{63A2}\u{3059}`,
    ko: `\u{C591}\u{B3C4}\u{C778} \u{CC3E}\u{AE30}`,
    mww: `Nrhiav tus neeg ua hauj lwm`,
    ps: `\u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{693}\u{626}`,
    pt: `Encontrar o designado`,
    'pt-pt': `Encontrar o cedente`,
    ru: `\u{41D}\u{430}\u{439}\u{442}\u{438} \u{43F}\u{440}\u{430}\u{432}\u{43E}\u{43E}\u{431}\u{43B}\u{430}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F}`,
    sm: `Saili le tagata ua tofia`,
    so: `Raadi qofka loo wareejiyay`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E1C}\u{E39}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}`,
    ur: `\u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{634}\u{62F}\u{6C1} \u{6A9}\u{648} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\xecm ng\u{1B0}\u{1EDD}i \u{111}\u{1B0}\u{1EE3}c giao`,
    'zh-hans': `\u{67E5}\u{627E}\u{53D7}\u{8BA9}\u{4EBA}`,
    'zh-hant': `\u{5C0B}\u{627E}\u{53D7}\u{8B93}\u{4EBA}`,
    en: `Find assignee`
};
const $b11db1b62d4a8f76$export$f31b0b9d247af8c4 = {
    ar: `\u{627}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{627}\u{644}\u{646}\u{633}\u{62E} \u{627}\u{644}\u{645}\u{643}\u{631}\u{631}\u{629}`,
    de: `Finde Duplikate`,
    es: `Encontrar duplicados`,
    fa: `\u{6CC}\u{627}\u{641}\u{62A}\u{646} \u{646}\u{633}\u{62E}\u{647} \u{647}\u{627}\u{6CC} \u{62A}\u{6A9}\u{631}\u{627}\u{631}\u{6CC}`,
    fil: `Maghanap ng mga duplicate`,
    fr: `Trouver des doublons`,
    hi: `\u{921}\u{941}\u{92A}\u{94D}\u{932}\u{93F}\u{915}\u{947}\u{91F} \u{916}\u{94B}\u{91C}\u{947}\u{902}`,
    ht: `Jwenn doublons`,
    it: `Trova duplicati`,
    ja: `\u{91CD}\u{8907}\u{306E}\u{767A}\u{898B}`,
    ko: `\u{C911}\u{BCF5} \u{CC3E}\u{AE30}`,
    mww: `Nrhiav duplicates`,
    ps: `\u{646}\u{642}\u{644}\u{648}\u{646}\u{647} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{693}\u{626}`,
    pt: `Encontre duplicatas`,
    'pt-pt': `Encontrar duplicados`,
    ru: `\u{41D}\u{430}\u{439}\u{442}\u{438} \u{434}\u{443}\u{431}\u{43B}\u{438}\u{43A}\u{430}\u{442}\u{44B}`,
    sm: `Saili ni kopi`,
    so: `Raadi heesaha laba-laab ah`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E0B}\u{E49}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E19}`,
    ur: `\u{688}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{679}\u{633} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\xecm b\u{1EA3}n sao`,
    'zh-hans': `\u{5BFB}\u{627E}\u{91CD}\u{590D}\u{7684}`,
    'zh-hant': `\u{5C0B}\u{627E}\u{91CD}\u{8907}\u{7684}`,
    en: `Find duplicates`
};
const $b11db1b62d4a8f76$export$ed63c7f9196b45e2 = {
    ar: `\u{627}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{627}\u{644}\u{623}\u{62D}\u{62F}\u{627}\u{62B}`,
    de: `Finden Sie Veranstaltungen`,
    es: `Encontrar eventos`,
    fa: `\u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{647}\u{627} \u{631}\u{627} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Maghanap ng mga kaganapan`,
    fr: `Trouver des \xe9v\xe9nements`,
    hi: `\u{908}\u{935}\u{947}\u{902}\u{91F} \u{922}\u{942}\u{902}\u{922}\u{947}\u{902}`,
    ht: `Jwenn ev\xe8nman yo`,
    it: `Trova eventi`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{3092}\u{63A2}\u{3059}`,
    ko: `\u{C774}\u{BCA4}\u{D2B8} \u{CC3E}\u{AE30}`,
    mww: `Nrhiav cov xwm txheej`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{69A}\u{648} \u{645}\u{648}\u{646}\u{62F}\u{646}\u{647}`,
    pt: `Encontre eventos`,
    'pt-pt': `Encontre eventos`,
    ru: `\u{41D}\u{430}\u{439}\u{442}\u{438} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F}`,
    sm: `Saili mea na tutupu`,
    so: `Hel dhacdooyinka`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{627}\u{6CC}\u{648}\u{646}\u{679}\u{633} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\xecm s\u{1EF1} ki\u{1EC7}n`,
    'zh-hans': `\u{67E5}\u{627E}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{5C0B}\u{627E}\u{6D3B}\u{52D5}`,
    en: `Find events`
};
const $b11db1b62d4a8f76$export$6747acadeb6f7ebf = {
    ar: `\u{627}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{627}\u{644}\u{641}\u{639}\u{627}\u{644}\u{64A}\u{627}\u{62A} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}\u{629} \u{648}\u{627}\u{644}\u{642}\u{627}\u{62F}\u{645}\u{629} \u{648}\u{633}\u{62C}\u{644} \u{639}\u{628}\u{631} \u{627}\u{644}\u{625}\u{646}\u{62A}\u{631}\u{646}\u{62A}.`,
    de: `Suchen Sie nach aktuellen und bevorstehenden Veranstaltungen und melden Sie sich online an.`,
    es: `Busca eventos actuales y pr\xf3ximos y reg\xedstrate online.`,
    fa: `\u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{647}\u{627}\u{6CC} \u{62C}\u{627}\u{631}\u{6CC} \u{648} \u{622}\u{6CC}\u{646}\u{62F}\u{647} \u{631}\u{627} \u{62C}\u{633}\u{62A}\u{62C}\u{648} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{628}\u{647} \u{635}\u{648}\u{631}\u{62A} \u{622}\u{646}\u{644}\u{627}\u{6CC}\u{646} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Maghanap ng mga kasalukuyan at paparating na kaganapan at magparehistro online.`,
    fr: `Recherchez les \xe9v\xe9nements actuels et \xe0 venir et inscrivez-vous en ligne.`,
    hi: `\u{935}\u{930}\u{94D}\u{924}\u{92E}\u{93E}\u{928} \u{914}\u{930} \u{906}\u{917}\u{93E}\u{92E}\u{940} \u{918}\u{91F}\u{928}\u{93E}\u{913}\u{902} \u{915}\u{94B} \u{916}\u{94B}\u{91C}\u{947}\u{902} \u{914}\u{930} \u{911}\u{928}\u{932}\u{93E}\u{907}\u{928} \u{92A}\u{902}\u{91C}\u{940}\u{915}\u{930}\u{923} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Rech\xe8ch ev\xe8nman akty\xe8l ak kap vini yo epi enskri sou ent\xe8n\xe8t`,
    it: `Cerca eventi attuali e prossimi e registrati online.`,
    ja: `\u{73FE}\u{5728}\u{304A}\u{3088}\u{3073}\u{4ECA}\u{5F8C}\u{306E}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{3092}\u{691C}\u{7D22}\u{3057}\u{3001}\u{30AA}\u{30F3}\u{30E9}\u{30A4}\u{30F3}\u{3067}\u{767B}\u{9332}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{D604}\u{C7AC} \u{BC0F} \u{C608}\u{C815}\u{B41C} \u{D589}\u{C0AC}\u{B97C} \u{AC80}\u{C0C9}\u{D558}\u{ACE0} \u{C628}\u{B77C}\u{C778}\u{C73C}\u{B85C} \u{B4F1}\u{B85D}\u{D558}\u{C138}\u{C694}.`,
    mww: `Nrhiav cov xwm txheej tam sim no thiab tom ntej thiab sau npe hauv online.`,
    ps: `\u{627}\u{648}\u{633}\u{646}\u{6CC} \u{627}\u{648} \u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0} \u{67E}\u{6CC}\u{69A}\u{6D0} \u{648}\u{644}\u{67C}\u{648}\u{626} \u{627}\u{648} \u{622}\u{646}\u{644}\u{627}\u{6CC}\u{646} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{648}\u{6A9}\u{693}\u{626}.`,
    pt: `Pesquise eventos atuais e futuros e inscreva-se online.`,
    'pt-pt': `Pesquise eventos atuais e futuros e inscreva-se online.`,
    ru: `\u{418}\u{449}\u{438}\u{442}\u{435} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{435} \u{438} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{438}\u{435} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F} \u{438} \u{437}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{438}\u{440}\u{443}\u{439}\u{442}\u{435}\u{441}\u{44C} \u{43E}\u{43D}\u{43B}\u{430}\u{439}\u{43D}.`,
    sm: `Su'e mea o lo'o tutupu i le taimi nei ma le lumana'i ma lesitala i luga ole laiga.`,
    so: `Ka raadi dhacdooyinka hadda socda iyo kuwa soo socda oo iska diiwaangeli online.`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E1B}\u{E31}\u{E08}\u{E08}\u{E38}\u{E1A}\u{E31}\u{E19}\u{E41}\u{E25}\u{E30}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E40}\u{E01}\u{E34}\u{E14}\u{E02}\u{E36}\u{E49}\u{E19} \u{E41}\u{E25}\u{E30}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E2D}\u{E2D}\u{E19}\u{E44}\u{E25}\u{E19}\u{E4C}`,
    ur: `\u{645}\u{648}\u{62C}\u{648}\u{62F}\u{6C1} \u{627}\u{648}\u{631} \u{622}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{627}\u{6CC}\u{648}\u{646}\u{679}\u{633} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{622}\u{646} \u{644}\u{627}\u{626}\u{646} \u{631}\u{62C}\u{633}\u{679}\u{631} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `T\xecm ki\u{1EBF}m c\xe1c s\u{1EF1} ki\u{1EC7}n hi\u{1EC7}n t\u{1EA1}i v\xe0 s\u{1EAF}p t\u{1EDB}i v\xe0 \u{111}\u{103}ng k\xfd tr\u{1EF1}c tuy\u{1EBF}n.`,
    'zh-hans': `\u{641C}\u{7D22}\u{5F53}\u{524D}\u{548C}\u{5373}\u{5C06}\u{4E3E}\u{884C}\u{7684}\u{6D3B}\u{52A8}\u{5E76}\u{5728}\u{7EBF}\u{6CE8}\u{518C}\u{3002}`,
    'zh-hant': `\u{641C}\u{5C0B}\u{7576}\u{524D}\u{53CA}\u{5373}\u{5C07}\u{8209}\u{8FA6}\u{7684}\u{6D3B}\u{52D5}\u{4E26}\u{7DDA}\u{4E0A}\u{5831}\u{540D}\u{3002}`,
    en: `Search current and upcoming events and register online.`
};
const $b11db1b62d4a8f76$export$8db4589b927d8eb = {
    ar: `\u{627}\u{644}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{627}\u{644}\u{644}\u{63A}\u{629}`,
    de: `Sprache finden`,
    es: `Encontrar lenguaje`,
    fa: `\u{632}\u{628}\u{627}\u{646} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{646}`,
    fil: `Email Address *`,
    fr: `Trouver la langue`,
    hi: `\u{92D}\u{93E}\u{937}\u{93E} \u{916}\u{94B}\u{91C}\u{947}\u{902}`,
    ht: `Jwenn lang`,
    it: `Trova la lingua`,
    ja: `\u{8A00}\u{8A9E}\u{3092}\u{898B}\u{3064}\u{3051}\u{308B}`,
    ko: `\u{C5B8}\u{C5B4}\u{B97C} \u{CC3E}\u{C544}`,
    mww: `Nrhiav lus`,
    ps: `\u{62F} \u{698}\u{628}\u{6D0} \u{645}\u{648}\u{646}\u{62F}\u{644}`,
    pt: `Encontrar linguagem`,
    'pt-pt': `Encontrar linguagem`,
    ru: `\u{41D}\u{430}\u{439}\u{442}\u{438} \u{44F}\u{437}\u{44B}\u{43A}`,
    sm: `Su'e le gagana`,
    so: `Raadi luqadda`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E20}\u{E32}\u{E29}\u{E32}`,
    ur: `\u{632}\u{628}\u{627}\u{646} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\xecm ng\xf4n ng\u{1EEF}`,
    'zh-hans': `\u{5BFB}\u{627E}\u{8BED}\u{8A00}`,
    'zh-hant': `\u{5C0B}\u{627E}\u{8A9E}\u{8A00}`,
    en: `Find language`
};
const $b11db1b62d4a8f76$export$1bba205d4ce00b33 = {
    ar: `\u{627}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{623}\u{646}\u{634}\u{637}\u{629} \u{645}\u{641}\u{62A}\u{648}\u{62D}\u{629}:`,
    de: `Finden Sie offene Aktivit\xe4ten:`,
    es: `Encuentra actividades abiertas:`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{628}\u{627}\u{632} \u{631}\u{627} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{646}\u{6CC}\u{62F}:`,
    fil: `Maghanap ng mga bukas na aktibidad:`,
    fr: `Trouvez des activit\xe9s ouvertes :`,
    hi: `\u{916}\u{941}\u{932}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901} \u{916}\u{94B}\u{91C}\u{947}\u{902}:`,
    ht: `Jwenn aktivite ouv\xe8:`,
    it: `Trova attivit\xe0 aperte:`,
    ja: `\u{30AA}\u{30FC}\u{30D7}\u{30F3}\u{306A}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306E}\u{63A2}\u{3057}\u{65B9}:`,
    ko: `\u{C5F4}\u{B9B0} \u{D65C}\u{B3D9} \u{CC3E}\u{AE30}:`,
    mww: `Nrhiav cov kev ua ub no qhib:`,
    ps: `\u{62E}\u{644}\u{627}\u{635} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{693}\u{626}:`,
    pt: `Encontre atividades abertas:`,
    'pt-pt': `Encontre atividades abertas:`,
    ru: `\u{41D}\u{430}\u{439}\u{434}\u{438}\u{442}\u{435} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{435} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{438}:`,
    sm: `Saili gaoioiga tatala:`,
    so: `Ka hel hawlo furan:`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E1B}\u{E34}\u{E14}\u{E2D}\u{E22}\u{E39}\u{E48}:`,
    ur: `\u{6A9}\u{6BE}\u{644}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}:`,
    vi: `T\xecm c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng m\u{1EDF}:`,
    'zh-hans': `\u{5BFB}\u{627E}\u{5F00}\u{653E}\u{6D3B}\u{52A8}\u{FF1A}`,
    'zh-hant': `\u{5C0B}\u{627E}\u{958B}\u{653E}\u{6D3B}\u{52D5}\u{FF1A}`,
    en: `Find open activities:`
};
const $b11db1b62d4a8f76$export$8c646c40ec95190f = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{645} \u{627}\u{644}\u{623}\u{648}\u{644}`,
    de: `Vorname`,
    es: `Nombre de pila`,
    fa: `\u{646}\u{627}\u{645} \u{6A9}\u{648}\u{686}\u{6A9}`,
    fil: `Unang pangalan`,
    fr: `Pr\xe9nom`,
    hi: `\u{92A}\u{939}\u{932}\u{93E} \u{928}\u{93E}\u{92E}`,
    ht: `Premye non`,
    it: `Nome di battesimo`,
    ja: `\u{540D}\u{524D}`,
    ko: `\u{C774}\u{B984}`,
    mww: `Lub npe`,
    ps: `\u{644}\u{648}\u{645}\u{693}\u{6CC} \u{646}\u{648}\u{645}`,
    pt: `Primeiro nome`,
    'pt-pt': `Primeiro nome`,
    ru: `\u{418}\u{43C}\u{44F}`,
    sm: `Igoa muamua`,
    so: `Magaca koowaad`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E08}\u{E23}\u{E34}\u{E07}`,
    ur: `\u{67E}\u{6C1}\u{644}\u{627} \u{646}\u{627}\u{645}`,
    vi: `T\xean`,
    'zh-hans': `\u{540D}\u{5B57}`,
    'zh-hant': `\u{540D}\u{5B57}`,
    en: `First name`
};
const $b11db1b62d4a8f76$export$c7ba48ed86b7d220 = {
    ar: `\u{645}\u{645}\u{646}\u{648}\u{639}`,
    de: `Verboten`,
    es: `Prohibido`,
    fa: `\u{645}\u{645}\u{646}\u{648}\u{639}\u{647}`,
    fil: `Ipinagbabawal`,
    fr: `Interdit`,
    hi: `\u{928}\u{93F}\u{937}\u{93F}\u{926}\u{94D}\u{927}`,
    ht: `Ent\xe8di`,
    it: `Proibito`,
    ja: `\u{7981}\u{65AD}`,
    ko: `\u{AE08}\u{C9C0}`,
    mww: `txwv tsis pub`,
    ps: `\u{645}\u{645}\u{646}\u{648}\u{639}`,
    pt: `Proibido`,
    'pt-pt': `Proibido`,
    ru: `\u{417}\u{430}\u{43F}\u{440}\u{435}\u{449}\u{435}\u{43D}\u{43E}`,
    sm: `Faasaina`,
    so: `Mamnuuc`,
    th: `\u{E15}\u{E49}\u{E2D}\u{E07}\u{E2B}\u{E49}\u{E32}\u{E21}`,
    ur: `\u{645}\u{645}\u{646}\u{648}\u{639}\u{6C1}`,
    vi: `B\u{1ECB} c\u{1EA5}m`,
    'zh-hans': `\u{7981}\u{6B62}`,
    'zh-hant': `\u{7981}\u{6B62}`,
    en: `Forbidden`
};
const $b11db1b62d4a8f76$export$17d11b1f539b6085 = {
    ar: `\u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} \u{645}\u{648}\u{62C}\u{648}\u{62F}\u{629} \u{644}\u{643}\u{646} \u{62F}\u{648}\u{631}\u{643} \u{623}\u{648} \u{639}\u{636}\u{648}\u{64A}\u{629} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629} \u{644}\u{627} \u{62A}\u{645}\u{646}\u{62D}\u{643} \u{625}\u{630}\u{646}\u{627} \u{644}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{64A}\u{647}\u{627}.`,
    de: `Diese Seite existiert, aber Ihre Rolle oder Mitgliedschaft in der Organisation gew\xe4hrt Ihnen keinen Zugriff darauf.`,
    es: `Esta p\xe1gina existe, pero tu rol u organizaci\xf3n no te otorga permiso de acceso a ella.`,
    fa: `\u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{648}\u{62C}\u{648}\u{62F} \u{62F}\u{627}\u{631}\u{62F} \u{627}\u{645}\u{627} \u{646}\u{642}\u{634} \u{6CC}\u{627} \u{639}\u{636}\u{648}\u{6CC}\u{62A} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{634}\u{645}\u{627} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{628}\u{647} \u{622}\u{646} \u{631}\u{627} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Umiiral ang pahinang ito ngunit ang iyong tungkulin o pagiging miyembro ng organisasyon ay hindi nagbibigay sa iyo ng pahintulot na ma-access ito.`,
    fr: `Cette page existe mais votre r\xf4le ou votre appartenance \xe0 l\u{2019}organisation ne vous accorde pas la permission d\u{2019}y acc\xe9der.`,
    hi: `\u{92F}\u{939} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{92E}\u{94C}\u{91C}\u{942}\u{926} \u{939}\u{948} \u{932}\u{947}\u{915}\u{93F}\u{928} \u{906}\u{92A}\u{915}\u{940} \u{92D}\u{942}\u{92E}\u{93F}\u{915}\u{93E} \u{92F}\u{93E} \u{938}\u{902}\u{917}\u{920}\u{928} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{906}\u{92A}\u{915}\u{94B} \u{909}\u{938} \u{924}\u{915} \u{92A}\u{939}\u{941}\u{901}\u{91A} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{928}\u{939}\u{940}\u{902} \u{926}\u{947}\u{924}\u{940} \u{939}\u{948}.`,
    ht: `Paj sa a egziste men w\xf2l ou oswa manm \xf2ganizasyon ou pa ba ou p\xe8misyon aks\xe8 nan li.`,
    it: `Questa pagina esiste, ma il tuo ruolo o l'appartenenza all'organizzazione non ti concedono il permesso di accedervi.`,
    ja: `\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{306F}\u{5B58}\u{5728}\u{3057}\u{307E}\u{3059}\u{304C}\u{3001}\u{3042}\u{306A}\u{305F}\u{306E}\u{5F79}\u{5272}\u{3084}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{30B7}\u{30C3}\u{30D7}\u{306B}\u{3088}\u{3063}\u{3066}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{6A29}\u{306F}\u{4E0E}\u{3048}\u{3089}\u{308C}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774} \u{D398}\u{C774}\u{C9C0}\u{B294} \u{C874}\u{C7AC}\u{D558}\u{C9C0}\u{B9CC}, \u{ADC0}\u{D558}\u{C758} \u{C5ED}\u{D560}\u{C774}\u{B098} \u{C870}\u{C9C1} \u{D68C}\u{C6D0} \u{C790}\u{ACA9}\u{C774} \u{C811}\u{ADFC} \u{AD8C}\u{D55C}\u{C744} \u{BD80}\u{C5EC}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Nplooj ntawv no muaj tab sis koj lub luag haujlwm lossis lub koom haum ua tswv cuab tsis tso cai rau koj nkag mus rau nws.`,
    ps: `\u{62F}\u{627} \u{67E}\u{627}\u{6BC}\u{647} \u{634}\u{62A}\u{647} \u{62E}\u{648} \u{633}\u{62A}\u{627}\u{633}\u{648} \u{631}\u{648}\u{644} \u{6CC}\u{627} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{63A}\u{693}\u{6CC}\u{62A}\u{648}\u{628} \u{62A}\u{627}\u{633}\u{648} \u{62A}\u{647} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{647} \u{62F}\u{631}\u{6A9}\u{648}\u{6CC} \u{686}\u{6D0} \u{648}\u{631}\u{62A}\u{647} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{648}\u{644}\u{631}\u{626}.`,
    pt: `Esta p\xe1gina existe, mas seu papel ou associa\xe7\xe3o \xe0 organiza\xe7\xe3o n\xe3o concede permiss\xe3o para acess\xe1-la.`,
    'pt-pt': `Esta p\xe1gina existe, mas a sua participa\xe7\xe3o no cargo ou na organiza\xe7\xe3o n\xe3o lhe concede permiss\xe3o de acesso a ela.`,
    ru: `\u{42D}\u{442}\u{430} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430} \u{441}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442}, \u{43D}\u{43E} \u{447}\u{43B}\u{435}\u{43D}\u{441}\u{442}\u{432}\u{43E} \u{432} \u{432}\u{430}\u{448}\u{435}\u{439} \u{440}\u{43E}\u{43B}\u{438} \u{438}\u{43B}\u{438} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{43D}\u{435} \u{434}\u{430}\u{451}\u{442} \u{432}\u{430}\u{43C} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{44F} \u{43D}\u{430} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{43A} \u{43D}\u{435}\u{439}.`,
    sm: `O loo i ai le itulau lenei, ae o lau matafaioi po o le avea ma sui auai o le faalapotopotoga e le tuuina atu ia te oe se faatagaga e faaaoga ai.`,
    so: `Boggan wuu jiraa laakiin doorkaaga ama xubinnimadaada ururka ma siinayso ogolaanshaha.`,
    th: `\u{E40}\u{E1E}\u{E08}\u{E19}\u{E35}\u{E49}\u{E21}\u{E35}\u{E2D}\u{E22}\u{E39}\u{E48} \u{E41}\u{E15}\u{E48}\u{E1A}\u{E17}\u{E1A}\u{E32}\u{E17}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E01}\u{E32}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E43}\u{E2B}\u{E49}\u{E2A}\u{E34}\u{E17}\u{E18}\u{E34}\u{E4C}\u{E01}\u{E32}\u{E23}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E40}\u{E1E}\u{E08}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{6CC}\u{6C1} \u{635}\u{641}\u{62D}\u{6C1} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{6C1}\u{6D2} \u{644}\u{6CC}\u{6A9}\u{646} \u{622}\u{67E} \u{6A9}\u{627} \u{6A9}\u{631}\u{62F}\u{627}\u{631} \u{6CC}\u{627} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6CC} \u{631}\u{6A9}\u{646}\u{6CC}\u{62A} \u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{62F}\u{6CC}\u{62A}\u{6CC}\u{6D4}`,
    vi: `Trang n\xe0y t\u{1ED3}n t\u{1EA1}i nh\u{1B0}ng vai tr\xf2 ho\u{1EB7}c t\u{1B0} c\xe1ch th\xe0nh vi\xean t\u{1ED5} ch\u{1EE9}c c\u{1EE7}a b\u{1EA1}n kh\xf4ng c\u{1EA5}p cho b\u{1EA1}n quy\u{1EC1}n truy c\u{1EAD}p v\xe0o trang n\xe0y.`,
    'zh-hans': `\u{672C}\u{9875}\u{9762}\u{5B58}\u{5728}\u{FF0C}\u{4F46}\u{60A8}\u{7684}\u{89D2}\u{8272}\u{6216}\u{7EC4}\u{7EC7}\u{6210}\u{5458}\u{8EAB}\u{4EFD}\u{4E0D}\u{6388}\u{4E88}\u{60A8}\u{8BBF}\u{95EE}\u{6743}\u{9650}\u{3002}`,
    'zh-hant': `\u{672C}\u{9801}\u{9762}\u{5B58}\u{5728}\u{FF0C}\u{4F46}\u{60A8}\u{7684}\u{89D2}\u{8272}\u{6216}\u{7D44}\u{7E54}\u{6703}\u{54E1}\u{8EAB}\u{4EFD}\u{4E0D}\u{6388}\u{4E88}\u{60A8}\u{5B58}\u{53D6}\u{6B0A}\u{9650}\u{3002}`,
    en: `This page exists but your role or organization membership does not grant you permission access to it.`
};
const $b11db1b62d4a8f76$export$a0198b98f746600d = {
    ar: `\u{644}\u{64A}\u{633} \u{644}\u{62F}\u{64A}\u{643} \u{62D}\u{642} \u{627}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{649} \u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629}.`,
    de: `Sie haben keinen Zugriff auf diese Seite.`,
    es: `No tienes acceso a esta p\xe1gina.`,
    fa: `\u{634}\u{645}\u{627} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{646}\u{62F}\u{627}\u{631}\u{6CC}\u{62F}.`,
    fil: `Wala kang access sa pahinang ito.`,
    fr: `Vous n\u{2019}avez pas acc\xe8s \xe0 cette page.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{92A}\u{93E}\u{938} \u{907}\u{938} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{924}\u{915} \u{92A}\u{939}\u{941}\u{901}\u{91A} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}.`,
    ht: `Ou pa gen aks\xe8 a paj sa a.`,
    it: `Non hai accesso a questa pagina.`,
    ja: `\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{3078}\u{306E}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{306F}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774} \u{D398}\u{C774}\u{C9C0}\u{C5D0} \u{C811}\u{ADFC}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Koj tsis muaj kev nkag mus rau nplooj ntawv no.`,
    ps: `\u{62A}\u{647} \u{62F}\u{6D0} \u{67E}\u{627}\u{6BC}\u{6D0} \u{62A}\u{647} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{646}\u{647} \u{644}\u{631}\u{6D0}.`,
    pt: `Voc\xea n\xe3o tem acesso a esta p\xe1gina.`,
    'pt-pt': `N\xe3o tem acesso a esta p\xe1gina.`,
    ru: `\u{423} \u{432}\u{430}\u{441} \u{43D}\u{435}\u{442} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{430} \u{43A} \u{44D}\u{442}\u{43E}\u{439} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{435}.`,
    sm: `E le mafai ona e ulufale i lenei itulau.`,
    so: `Ma heli kartid boggan.`,
    th: `\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E2A}\u{E34}\u{E17}\u{E18}\u{E34}\u{E4C}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `B\u{1EA1}n kh\xf4ng c\xf3 quy\u{1EC1}n truy c\u{1EAD}p v\xe0o trang n\xe0y.`,
    'zh-hans': `\u{60A8}\u{65E0}\u{6CD5}\u{8BBF}\u{95EE}\u{672C}\u{9875}\u{9762}\u{3002}`,
    'zh-hant': `\u{60A8}\u{7121}\u{6CD5}\u{5B58}\u{53D6}\u{6B64}\u{9801}\u{9762}\u{3002}`,
    en: `You do not have access to this page.`
};
const $b11db1b62d4a8f76$export$a368b07bc550762f = {
    ar: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{627}\u{62A} \u{645}\u{62A}\u{643}\u{631}\u{631}\u{629}`,
    de: `H\xe4ufig angesehen`,
    es: `Frecuentes`,
    fa: `\u{67E}\u{631}\u{628}\u{627}\u{632}\u{62F}\u{6CC}\u{62F}`,
    fil: `Madalas na tiningnan`,
    fr: `Fr\xe9quemment visionn\xe9`,
    hi: `\u{905}\u{915}\u{94D}\u{938}\u{930} \u{926}\u{947}\u{916}\u{947} \u{91C}\u{93E}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947}`,
    ht: `W\xe8 souvan`,
    it: `Frequentemente visto`,
    ja: `\u{3088}\u{304F}\u{898B}\u{3089}\u{308C}\u{307E}\u{3059}`,
    ko: `\u{C790}\u{C8FC} \u{C870}\u{D68C}\u{B418}\u{B294}`,
    mww: `Nquag saib`,
    ps: `\u{689}\u{6D0}\u{631} \u{644}\u{6CC}\u{62F}\u{644} \u{6A9}\u{6D0}\u{696}\u{6CC}`,
    pt: `Frequentemente assistido`,
    'pt-pt': `Frequentemente visto`,
    ru: `\u{427}\u{430}\u{441}\u{442}\u{43E} \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{430}\u{442}\u{440}\u{438}\u{432}\u{430}\u{435}\u{43C}\u{44B}\u{435}`,
    sm: `E masani ona va'aia`,
    so: `Si joogto ah loo daawado`,
    th: `\u{E14}\u{E39}\u{E1A}\u{E48}\u{E2D}\u{E22}`,
    ur: `\u{627}\u{6A9}\u{62B}\u{631} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{627} \u{62C}\u{627}\u{62A}\u{627} \u{6C1}\u{6D2}`,
    vi: `Th\u{1B0}\u{1EDD}ng xem`,
    'zh-hans': `\u{5E38}\u{89C1}\u{5185}\u{5BB9}`,
    'zh-hant': `\u{5E38}\u{898B}\u{89C0}\u{773E}`,
    en: `Frequently viewed`
};
const $b11db1b62d4a8f76$export$67815b20c800fa3f = {
    ar: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{62A}\u{647} \u{628}\u{634}\u{643}\u{644} \u{645}\u{62A}\u{643}\u{631}\u{631} \u{645}\u{646} \u{642}\u{628}\u{644}\u{643}`,
    de: `H\xe4ufig von Ihnen angesehen`,
    es: `Lo ves con frecuencia`,
    fa: `\u{627}\u{63A}\u{644}\u{628} \u{62A}\u{648}\u{633}\u{637} \u{634}\u{645}\u{627} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{645}\u{6CC} \u{634}\u{648}\u{62F}`,
    fil: `Madalas mong panoorin`,
    fr: `Souvent regard\xe9 par vous`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{905}\u{915}\u{94D}\u{938}\u{930} \u{926}\u{947}\u{916}\u{93E} \u{91C}\u{93E}\u{924}\u{93E} \u{939}\u{948}`,
    ht: `Souvan w\xe8 pa ou`,
    it: `Spesso visto da te`,
    ja: `\u{983B}\u{7E41}\u{306B}\u{898B}\u{3066}\u{3044}\u{308B}`,
    ko: `\u{C790}\u{C8FC} \u{BCF4}\u{B294} \u{B124}\u{AC00}`,
    mww: `Nquag saib los ntawm koj`,
    ps: `\u{62A}\u{627}\u{633}\u{648} \u{689}\u{6D0}\u{631} \u{681}\u{644}\u{647} \u{6AB}\u{648}\u{631}\u{626}`,
    pt: `Frequentemente assistido por voc\xea`,
    'pt-pt': `Frequentemente visto por ti`,
    ru: `\u{427}\u{430}\u{441}\u{442}\u{43E} \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{430}\u{442}\u{440}\u{438}\u{432}\u{430}\u{435}\u{442}\u{441}\u{44F} \u{432}\u{430}\u{43C}\u{438}`,
    sm: `E masani ona e va'ai i ai`,
    so: `Adiga oo si joogto ah u daawado`,
    th: `\u{E04}\u{E38}\u{E13}\u{E14}\u{E39}\u{E1A}\u{E48}\u{E2D}\u{E22}`,
    ur: `\u{622}\u{67E} \u{627}\u{6A9}\u{62B}\u{631} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `B\u{1EA1}n th\u{1B0}\u{1EDD}ng xuy\xean xem`,
    'zh-hans': `\u{4F60}\u{7ECF}\u{5E38}\u{770B}\u{5230}`,
    'zh-hant': `\u{4F60}\u{7D93}\u{5E38}\u{770B}\u{5230}`,
    en: `Frequently viewed by you`
};
const $b11db1b62d4a8f76$export$51302d31667bfaf2 = {
    ar: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`أحدث <a href="${activityHref}">نشاط</a> عمره أقل ${max_age} يوما. لا حاجة لأي إجراء.`,
    de: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`Die <a href="${activityHref}">jüngste Aktivität</a> ist weniger als ${max_age} Tage alt. Es sind keine Maßnahmen erforderlich.`,
    es: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`La <a href="${activityHref}">actividad más reciente</a> tiene menos de ${max_age} días. No se requiere ninguna acción.`,
    fa: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">جدیدترین فعالیت</a> کمتر از ${max_age} روز قدمت دارد. هیچ اقدامی لازم نیست.`,
    fil: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`Ang <a href="${activityHref}">pinakahuling aktibidad</a> ay mas mababa sa ${max_age} araw gulang. Walang kinakailangang pagkilos.`,
    fr: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">L’activité la plus récente</a> a moins de ${max_age} jours. Aucune action n’est requise.`,
    hi: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">सबसे हालिया गतिविधि</a> ${max_age} दिनों से कम पुरानी है। किसी कार्रवाई की आवश्यकता नहीं है।`,
    ht: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">Aktivite ki pi resan</a> an se mwens pase ${max_age} jou fin vye granmoun. Pa gen okenn aksyon ki nesesè.`,
    it: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">L'attività più recente</a> ha meno di ${max_age} giorni. Non è necessaria alcuna azione.`,
    ja: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">最新の活動</a>は${max_age}日未満です。何の対応も必要ありません。`,
    ko: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">가장 최근의 활동</a>은 ${max_age}일도 채 되지 않았습니다. 별도의 조치는 필요 없습니다.`,
    mww: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`Qhov <a href="${activityHref}">kev ua ub no tsis ntev los</a> no yog hnub nyoog tsawg ${max_age} hnub. Tsis tas yuav nqis tes ua.`,
    ps: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">وروستی فعالیت</a> له ${max_age} عمر لری. هیڅ اقدام ته اړتیا نشته.`,
    pt: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`A <a href="${activityHref}">atividade mais recente</a> tem menos de ${max_age} dias. Nenhuma ação é necessária.`,
    'pt-pt': (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`A <a href="${activityHref}">atividade mais recente</a> tem menos de ${max_age} dias. Não é necessária qualquer ação.`,
    ru: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">Последняя активность</a> существует менее ${max_age} дней. Никаких действий не требуется.`,
    sm: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`O le <a href="${activityHref}">gaioiga aupito lata mai</a> e itiiti ifo i le ${max_age} aso le matua. E leai se gaioiga e mana'omia.`,
    so: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">Dhaqdhaqaaqa ugu dambeeyay</a> waa wax ka yar ${max_age} maalmood. Tallaabo looma baahna.`,
    th: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">กิจกรรมล่าสุด</a>มีอายุน้อยกว่า ${max_age} วัน ไม่จําเป็นต้องดําเนินการใดๆ`,
    ur: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">تازہ ترین سرگرمی</a> ${max_age} دن سے کم پرانی ہے۔ کسی کارروائی کی ضرورت نہیں۔`,
    vi: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">Hoạt động gần đây nhất</a> chưa đầy ${max_age} ngày. Không cần thực hiện hành động nào.`,
    'zh-hans': (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">最近的一次活动</a>不到${max_age}天。无需采取任何行动。`,
    'zh-hant': (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`最近一次 <a href="${activityHref}">活動</a> 不到 ${max_age} 天。不需要採取行動。`,
    en: (activityHref, max_age)=>$b11db1b62d4a8f76$var$html`The <a href="${activityHref}">most recent activity</a> is less than ${max_age} days old. No action is required.`
};
const $b11db1b62d4a8f76$export$b2139dca3685e20c = {
    ar: `\u{645}\u{646} \u{627}\u{644}\u{62A}\u{627}\u{631}\u{64A}\u{62E}`,
    de: `Ab dem Datum`,
    es: `De la fecha`,
    fa: `\u{627}\u{632} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    fil: `Mula sa petsa`,
    fr: `Depuis la date`,
    hi: `\u{924}\u{93F}\u{925}\u{93F} \u{938}\u{947}`,
    ht: `Soti nan dat`,
    it: `Dalla data`,
    ja: `\u{65E5}\u{4ED8}\u{304B}\u{3089}`,
    ko: `\u{B0A0}\u{C9DC}\u{BD80}\u{D130}`,
    mww: `Txij hnub tim`,
    ps: `\u{644}\u{647} \u{646}\u{6CC}\u{67C}\u{6D0} \u{685}\u{62E}\u{647}`,
    pt: `A partir da data`,
    'pt-pt': `Desde a data`,
    ru: `\u{421} \u{43C}\u{43E}\u{43C}\u{435}\u{43D}\u{442}\u{430}`,
    sm: `Mai le aso`,
    so: `Laga bilaabo taariikhda`,
    th: `\u{E15}\u{E31}\u{E49}\u{E07}\u{E41}\u{E15}\u{E48}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}`,
    ur: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{633}\u{6D2}`,
    vi: `T\u{1EEB} ng\xe0y`,
    'zh-hans': `\u{81EA}\u{90A3}\u{65F6}\u{8D77}`,
    'zh-hant': `\u{81EA}\u{73FE}\u{4EE5}\u{4F86}`,
    en: `From date`
};
const $b11db1b62d4a8f76$export$5e08d6073723aa2e = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{645} \u{627}\u{644}\u{643}\u{627}\u{645}\u{644}`,
    de: `Vollst\xe4ndiger Name`,
    es: `Nombre completo`,
    fa: `\u{646}\u{627}\u{645} \u{6A9}\u{627}\u{645}\u{644}`,
    fil: `Buong pangalan`,
    fr: `Nom complet`,
    hi: `\u{92A}\u{942}\u{930}\u{93E} \u{928}\u{93E}\u{92E}`,
    ht: `Non konpl\xe8`,
    it: `Nome completo`,
    ja: `\u{30D5}\u{30EB}\u{30CD}\u{30FC}\u{30E0}`,
    ko: `\u{C804}\u{CCB4} \u{C774}\u{B984}`,
    mww: `Lub npe tag nrho`,
    ps: `\u{628}\u{634}\u{67E}\u{693} \u{646}\u{648}\u{645}`,
    pt: `Nome completo`,
    'pt-pt': `Nome completo`,
    ru: `\u{41F}\u{43E}\u{43B}\u{43D}\u{43E}\u{435} \u{438}\u{43C}\u{44F}`,
    sm: `Igoa atoa`,
    so: `Magaca buuxa`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E15}\u{E47}\u{E21}`,
    ur: `\u{67E}\u{648}\u{631}\u{627} \u{646}\u{627}\u{645}`,
    vi: `H\u{1ECD} v\xe0 t\xean`,
    'zh-hans': `\u{5168}\u{540D}`,
    'zh-hant': `\u{5168}\u{540D}`,
    en: `Full name`
};
const $b11db1b62d4a8f76$export$c34792aaa3afdd0c = {
    ar: `\u{627}\u{644}\u{62C}\u{646}\u{633}`,
    de: `Geschlecht`,
    es: `G\xe9nero`,
    fa: `\u{62C}\u{646}\u{633}\u{6CC}\u{62A}`,
    fil: `Kasarian`,
    fr: `Genre`,
    hi: `\u{932}\u{93F}\u{902}\u{917}`,
    ht: `S\xe8ks`,
    it: `Genere`,
    ja: `\u{6027}\u{5225}`,
    ko: `\u{C131}\u{BCC4}`,
    mww: `Poj niam txiv neej`,
    ps: `\u{62C}\u{646}\u{633}\u{6CC}\u{62A}`,
    pt: `G\xeanero`,
    'pt-pt': `G\xe9nero`,
    ru: `\u{41F}\u{43E}\u{43B}`,
    sm: `Itupa`,
    so: `Jinsiga`,
    th: `\u{E40}\u{E1E}\u{E28}`,
    ur: `\u{62C}\u{646}\u{633}`,
    vi: `Gi\u{1EDB}i t\xednh`,
    'zh-hans': `\u{6027}\u{522B}`,
    'zh-hant': `\u{6027}\u{5225}`,
    en: `Gender`
};
const $b11db1b62d4a8f76$export$ed143b7c52257e6c = {
    ar: `\u{627}\u{644}\u{647}\u{648}\u{64A}\u{629} \u{627}\u{644}\u{62C}\u{646}\u{62F}\u{631}\u{64A}\u{629}`,
    de: `Geschlechtsidentit\xe4t`,
    es: `Identidad de g\xe9nero`,
    fa: `\u{647}\u{648}\u{6CC}\u{62A} \u{62C}\u{646}\u{633}\u{6CC}\u{62A}\u{6CC}`,
    fil: `Pagkakakilanlan ng kasarian`,
    fr: `Identit\xe9 de genre`,
    hi: `\u{932}\u{93F}\u{902}\u{917} \u{92A}\u{939}\u{91A}\u{93E}\u{928}`,
    ht: `Idantite s\xe8ks`,
    it: `Identit\xe0 di genere`,
    ja: `\u{6027}\u{81EA}\u{8A8D}`,
    ko: `\u{C131} \u{C815}\u{CCB4}\u{C131}`,
    mww: `Poj niam txiv neej yog leej twg`,
    ps: `\u{62C}\u{646}\u{633}\u{6CC}\u{62A}\u{6CC} \u{647}\u{648}\u{6CC}\u{62A}`,
    pt: `Identidade de g\xeanero`,
    'pt-pt': `Identidade de g\xe9nero`,
    ru: `\u{413}\u{435}\u{43D}\u{434}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{438}\u{434}\u{435}\u{43D}\u{442}\u{438}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Fa'asinomaga o itupa`,
    so: `Aqoonsiga jinsiga`,
    th: `\u{E2D}\u{E31}\u{E15}\u{E25}\u{E31}\u{E01}\u{E29}\u{E13}\u{E4C}\u{E17}\u{E32}\u{E07}\u{E40}\u{E1E}\u{E28}`,
    ur: `\u{62C}\u{646}\u{633} \u{6A9}\u{6CC} \u{634}\u{646}\u{627}\u{62E}\u{62A}`,
    vi: `B\u{1EA3}n d\u{1EA1}ng gi\u{1EDB}i`,
    'zh-hans': `\u{6027}\u{522B}\u{8BA4}\u{540C}`,
    'zh-hant': `\u{6027}\u{5225}\u{8A8D}\u{540C}`,
    en: `Gender identity`
};
const $b11db1b62d4a8f76$export$58fcd031c5120426 = {
    ar: `\u{627}\u{62D}\u{635}\u{644} \u{639}\u{644}\u{649} \u{645}\u{632}\u{64A}\u{62F} \u{645}\u{646} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    de: `Weitere Informationen erhalten`,
    es: `Obt\xe9n m\xe1s informaci\xf3n`,
    fa: `\u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{628}\u{6CC}\u{634}\u{62A}\u{631}`,
    fil: `Kumuha ng karagdagang impormasyon`,
    fr: `Obtenez plus d\u{2019}informations`,
    hi: `\u{905}\u{927}\u{93F}\u{915} \u{91C}\u{93E}\u{928}\u{915}\u{93E}\u{930}\u{940} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Jwenn plis enf\xf2masyon`,
    it: `Ottieni maggiori informazioni`,
    ja: `\u{8A73}\u{7D30}\u{60C5}\u{5831}`,
    ko: `\u{B354} \u{B9CE}\u{C740} \u{C815}\u{BCF4} \u{BCF4}\u{AE30}`,
    mww: `Tau txais cov ntaub ntawv ntxiv`,
    ps: `\u{646}\u{648}\u{631} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Obtenha mais informa\xe7\xf5es`,
    'pt-pt': `Obtenha mais informa\xe7\xf5es`,
    ru: `\u{423}\u{437}\u{43D}\u{430}\u{439}\u{442}\u{435} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435}`,
    sm: `Maua nisi fa'amatalaga`,
    so: `Hel macluumaad dheeraad ah`,
    th: `\u{E14}\u{E39}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E40}\u{E15}\u{E34}\u{E21}`,
    ur: `\u{645}\u{632}\u{6CC}\u{62F} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Xem th\xeam th\xf4ng tin`,
    'zh-hans': `\u{83B7}\u{53D6}\u{66F4}\u{591A}\u{4FE1}\u{606F}`,
    'zh-hant': `\u{7372}\u{53D6}\u{66F4}\u{591A}\u{8CC7}\u{8A0A}`,
    en: `Get more information`
};
const $b11db1b62d4a8f76$export$fb5986ba5dcfdda3 = {
    ar: `\u{627}\u{644}\u{631}\u{62C}\u{648}\u{639} \u{644}\u{644}\u{62E}\u{644}\u{641}`,
    de: `Geh zur\xfcck`,
    es: `Vuelve atr\xe1s`,
    fa: `\u{628}\u{631}\u{6AF}\u{631}\u{62F}`,
    fil: `Bumalik`,
    fr: `Retourne`,
    hi: `\u{92A}\u{938} \u{91C}\u{93E}\u{913}`,
    ht: `Tounen`,
    it: `Torna indietro`,
    ja: `\u{623B}\u{3063}\u{3066}`,
    ko: `\u{B3CC}\u{C544}\u{AC00}`,
    mww: `Mus rov qab`,
    ps: `\u{628}\u{6CC}\u{631}\u{62A}\u{647} \u{644}\u{627}\u{693} \u{634}\u{647}`,
    pt: `Volte`,
    'pt-pt': `Volta para tr\xe1s`,
    ru: `\u{412}\u{43E}\u{437}\u{432}\u{440}\u{430}\u{449}\u{430}\u{439}\u{441}\u{44F}`,
    sm: `Toe fo'i`,
    so: `Soo laabo`,
    th: `\u{E22}\u{E49}\u{E2D}\u{E19}\u{E01}\u{E25}\u{E31}\u{E1A}\u{E44}\u{E1B}`,
    ur: `\u{648}\u{627}\u{67E}\u{633} \u{62C}\u{627}\u{624}`,
    vi: `Quay l\u{1EA1}i`,
    'zh-hans': `\u{56DE}\u{53BB}`,
    'zh-hant': `\u{56DE}\u{53BB}`,
    en: `Go back`
};
const $b11db1b62d4a8f76$export$283b97007da4ee4f = {
    ar: `\u{627}\u{630}\u{647}\u{628} \u{625}\u{644}\u{649} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}`,
    de: `Geh zur Aktivit\xe4t`,
    es: `Ir a actividad`,
    fa: `\u{628}\u{647} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{631}\u{648}\u{6CC}\u{62F}`,
    fil: `Pumunta sa Aktibidad`,
    fr: `Aller \xe0 l\u{2019}activit\xe9`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930} \u{91C}\u{93E}\u{90F}\u{901}`,
    ht: `Ale nan aktivite`,
    it: `Vai all'attivit\xe0`,
    ja: `\u{6D3B}\u{52D5}\u{958B}\u{59CB}`,
    ko: `\u{D65C}\u{B3D9} \u{C2DC}\u{C791}`,
    mww: `Mus ua si`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{647} \u{644}\u{627}\u{693} \u{634}\u{647}`,
    pt: `Ir para atividade`,
    'pt-pt': `Ir para atividade`,
    ru: `\u{41F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438} \u{43A} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Alu i le gaoioiga`,
    so: `U gudub hawlaha`,
    th: `\u{E44}\u{E1B}\u{E17}\u{E35}\u{E48}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `\u{110}i \u{111}\u{1EBF}n ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{8FDB}\u{5165}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{9032}\u{5165}\u{6D3B}\u{52D5}`,
    en: `Go to activity`
};
const $b11db1b62d4a8f76$export$20bb97b417f71755 = {
    ar: `\u{627}\u{630}\u{647}\u{628} \u{625}\u{644}\u{649} \u{627}\u{644}\u{62D}\u{62F}\u{62B}`,
    de: `Geh zur Veranstaltung`,
    es: `Ir al evento`,
    fa: `\u{628}\u{647} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{628}\u{631}\u{648}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `Rendez-vous \xe0 l\u{2019}\xe9v\xe9nement`,
    hi: `\u{907}\u{935}\u{947}\u{902}\u{91F} \u{92A}\u{930} \u{91C}\u{93E}\u{90F}\u{902}`,
    ht: `Ale nan ev\xe8nman an`,
    it: `Partecipa all'evento`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306B}\u{884C}\u{3053}\u{3046}`,
    ko: `\u{D589}\u{C0AC} \u{CC38}\u{C11D}`,
    mww: `Mus rau qhov kev tshwm sim`,
    ps: `\u{67E}\u{6CC}\u{69A}\u{6D0} \u{62A}\u{647} \u{644}\u{627}\u{693} \u{634}\u{647}`,
    pt: `V\xe1 ao evento`,
    'pt-pt': `Ir ao evento`,
    ru: `\u{41F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438} \u{43D}\u{430} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435}`,
    sm: `Alu i le mea na tupu`,
    so: `Tag dhacdada`,
    th: `\u{E44}\u{E1B}\u{E17}\u{E35}\u{E48}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{627}\u{6CC}\u{648}\u{646}\u{679} \u{645}\u{6CC}\u{6BA} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `\u{110}i \u{111}\u{1EBF}n s\u{1EF1} ki\u{1EC7}n`,
    'zh-hans': `\u{524D}\u{5F80}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{524D}\u{5F80}\u{6D3B}\u{52D5}`,
    en: `Go to event`
};
const $b11db1b62d4a8f76$export$60bccc00e91b24bf = {
    ar: `\u{62D}\u{635}\u{644}\u{62A} \u{639}\u{644}\u{649} \u{648}\u{635}\u{648}\u{644} \u{645}\u{646} \u{62E}\u{644}\u{627}\u{644} \u{646}\u{634}\u{627}\u{637} \u{645}\u{631}\u{62A}\u{628}\u{637}.`,
    de: `Erhielt Zugriff \xfcber eine zugeh\xf6rige Aktivit\xe4t.`,
    es: `Recibimos acceso a trav\xe9s de una actividad asociada.`,
    fa: `\u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{645}\u{631}\u{62A}\u{628}\u{637} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{631}\u{62F}.`,
    fil: `Nakatanggap ng access sa pamamagitan ng isang kaugnay na aktibidad.`,
    fr: `Acc\xe8s re\xe7u via une activit\xe9 associ\xe9e.`,
    hi: `\u{915}\u{93F}\u{938}\u{940} \u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{92A}\u{939}\u{941}\u{901}\u{91A} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{940}.`,
    ht: `Resevwa aks\xe8 atrav\xe8 yon aktivite ki asosye`,
    it: `Ricevuto accesso tramite un'attivit\xe0 associata.`,
    ja: `\u{95A2}\u{9023}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{901A}\u{3058}\u{3066}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{6A29}\u{3092}\u{5F97}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{AD00}\u{B828} \u{D65C}\u{B3D9}\u{C744} \u{D1B5}\u{D574} \u{C811}\u{ADFC} \u{AD8C}\u{D55C}\u{C744} \u{BC1B}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tau txais kev nkag mus los ntawm ib qho kev ua ub no.`,
    ps: `\u{62F} \u{627}\u{693}\u{648}\u{646}\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{693}.`,
    pt: `Recebi acesso por meio de uma atividade associada.`,
    'pt-pt': `Recebi acesso atrav\xe9s de uma atividade associada.`,
    ru: `\u{41F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{447}\u{435}\u{440}\u{435}\u{437} \u{441}\u{43E}\u{43F}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{443}\u{44E} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `Mauaina le avanoa e ala i se gaoioiga e fesootai i ai.`,
    so: `Helitaanka marin iyada oo loo marayo hawl la xiriira.`,
    th: `\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E2A}\u{E34}\u{E17}\u{E18}\u{E34}\u{E4C}\u{E01}\u{E32}\u{E23}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{6A9}\u{633}\u{6CC} \u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{6CC}\u{6D4}`,
    vi: `\u{110}\xe3 nh\u{1EAD}n quy\u{1EC1}n truy c\u{1EAD}p th\xf4ng qua m\u{1ED9}t ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\u{1B0}\u{1EE3}c li\xean k\u{1EBF}t.`,
    'zh-hans': `\u{901A}\u{8FC7}\u{76F8}\u{5173}\u{6D3B}\u{52A8}\u{83B7}\u{5F97}\u{4E86}\u{8BBF}\u{95EE}\u{6743}\u{9650}\u{3002}`,
    'zh-hant': `\u{900F}\u{904E}\u{76F8}\u{95DC}\u{6D3B}\u{52D5}\u{7372}\u{5F97}\u{5B58}\u{53D6}\u{6B0A}\u{9650}\u{3002}`,
    en: `Received access through an associated activity.`
};
const $b11db1b62d4a8f76$export$30763d83faa276a = {
    ar: `\u{62D}\u{635}\u{644}\u{62A} \u{639}\u{644}\u{649} \u{648}\u{635}\u{648}\u{644} \u{645}\u{646} \u{62E}\u{644}\u{627}\u{644} \u{646}\u{634}\u{627}\u{637} \u{64A}\u{634}\u{64A}\u{631} \u{625}\u{644}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Habe Zugriff \xfcber eine Aktivit\xe4t erhalten, die auf diese Aktivit\xe4t verweist.`,
    es: `Recibimos acceso a trav\xe9s de una actividad que hace referencia a esta actividad.`,
    fa: `\u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{6CC} \u{6A9}\u{647} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{627}\u{634}\u{627}\u{631}\u{647} \u{62F}\u{627}\u{631}\u{62F} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{631}\u{62F}\u{645}.`,
    fil: `Nakatanggap ng access sa pamamagitan ng isang aktibidad na tumutukoy sa aktibidad na ito.`,
    fr: `Acc\xe8s re\xe7u via une activit\xe9 qui fait r\xe9f\xe9rence \xe0 cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{94B} \u{938}\u{902}\u{926}\u{930}\u{94D}\u{92D}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{92A}\u{939}\u{941}\u{901}\u{91A} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{940}.`,
    ht: `Resevwa aks\xe8 atrav\xe8 yon aktivite ki referans aktivite sa a.`,
    it: `Accesso ricevuto tramite un'attivit\xe0 che fa riferimento a questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{53C2}\u{7167}\u{3059}\u{308B}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{901A}\u{3058}\u{3066}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{6A29}\u{3092}\u{53D6}\u{5F97}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C744} \u{CC38}\u{C870}\u{D558}\u{B294} \u{D65C}\u{B3D9}\u{C744} \u{D1B5}\u{D574} \u{C811}\u{ADFC} \u{AD8C}\u{D55C}\u{C744} \u{BC1B}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tau txais kev nkag los ntawm ib qho kev ua ub no uas hais txog qhov kev ua no.`,
    ps: `\u{62F} \u{6CC}\u{648}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{6D0} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{693} \u{686}\u{6D0} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{647} \u{627}\u{634}\u{627}\u{631}\u{647} \u{6A9}\u{648}\u{6CC}.`,
    pt: `Recebi acesso por meio de uma atividade que faz refer\xeancia a essa atividade.`,
    'pt-pt': `Recebi acesso atrav\xe9s de uma atividade que faz refer\xeancia a esta atividade.`,
    ru: `\u{41F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{447}\u{435}\u{440}\u{435}\u{437} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C}, \u{441}\u{441}\u{44B}\u{43B}\u{430}\u{44E}\u{449}\u{443}\u{44E}\u{441}\u{44F} \u{43D}\u{430} \u{44D}\u{442}\u{443} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `Na maua le avanoa e ala i se gaoioiga e faasino i lenei gaoioiga.`,
    so: `Waxaa loo helay marin hawl tixraacaya hawlgalkan.`,
    th: `\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E2A}\u{E34}\u{E17}\u{E18}\u{E34}\u{E4C}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E49}\u{E32}\u{E07}\u{E2D}\u{E34}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{6C1}\u{6D2} \u{62C}\u{648} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{627} \u{62D}\u{648}\u{627}\u{644}\u{6C1} \u{62F}\u{6CC}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Nh\u{1EAD}n quy\u{1EC1}n truy c\u{1EAD}p th\xf4ng qua m\u{1ED9}t ho\u{1EA1}t \u{111}\u{1ED9}ng tham chi\u{1EBF}u \u{111}\u{1EBF}n ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{901A}\u{8FC7}\u{4E00}\u{4E2A}\u{4E0E}\u{8BE5}\u{6D3B}\u{52A8}\u{76F8}\u{5173}\u{7684}\u{5185}\u{5BB9}\u{83B7}\u{5F97}\u{4E86}\u{8BBF}\u{95EE}\u{6743}\u{9650}\u{3002}`,
    'zh-hant': `\u{900F}\u{904E}\u{4E00}\u{500B}\u{8207}\u{6B64}\u{6D3B}\u{52D5}\u{76F8}\u{95DC}\u{7684}\u{6D3B}\u{52D5}\u{7372}\u{5F97}\u{5B58}\u{53D6}\u{6B0A}\u{9650}\u{3002}`,
    en: `Received access through an activity that references this activity.`
};
const $b11db1b62d4a8f76$export$7221236cb49b6ee2 = {
    ar: `\u{644}\u{62F}\u{64A}\u{647} \u{623}\u{639}\u{636}\u{627}\u{621} \u{62A}\u{645} \u{62A}\u{639}\u{64A}\u{64A}\u{646}\u{647}\u{645} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Hat Mitglieder, die dieser Aktivit\xe4t zugeteilt wurden.`,
    es: `Tiene miembros asignados a esta actividad.`,
    fa: `\u{627}\u{639}\u{636}\u{627}\u{6CC}\u{6CC} \u{62F}\u{627}\u{631}\u{62F} \u{6A9}\u{647} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{627}\u{62E}\u{62A}\u{635}\u{627}\u{635} \u{62F}\u{627}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{646}\u{62F}.`,
    fil: `May mga miyembro na naatasan sa aktibidad na ito.`,
    fr: `A des membres qui ont \xe9t\xe9 affect\xe9s \xe0 cette activit\xe9.`,
    hi: `\u{910}\u{938}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{939}\u{948}\u{902} \u{91C}\u{93F}\u{928}\u{94D}\u{939}\u{947}\u{902} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{94C}\u{902}\u{92A}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E}\u{964}`,
    ht: `Gen manm yo te asiyen nan aktivite sa a.`,
    it: `Ha membri assegnati a questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306B}\u{5272}\u{308A}\u{5F53}\u{3066}\u{3089}\u{308C}\u{305F}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{304C}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{BC30}\u{C815}\u{B41C} \u{D68C}\u{C6D0}\u{B4E4}\u{C774} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Muaj cov tswv cuab uas tau raug xa mus rau qhov kev ua no.`,
    ps: `\u{647}\u{63A}\u{647} \u{63A}\u{693}\u{6CC} \u{644}\u{631}\u{6CC} \u{686}\u{6D0} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{647} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{648}\u{648}.`,
    pt: `Tem membros que foram designados para essa atividade.`,
    'pt-pt': `Tem membros que foram atribu\xeddos a esta atividade.`,
    ru: `\u{415}\u{441}\u{442}\u{44C} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{438}, \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44B}\u{435} \u{43D}\u{430} \u{44D}\u{442}\u{443} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `O loo i ai tagata o e na tofia i lenei gaoioiga.`,
    so: `Waxay leedahay xubno loo xilsaaray hawshan.`,
    th: `\u{E21}\u{E35}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E17}\u{E35}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E17}\u{E4D}\u{E32}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{6A9}\u{6D2} \u{627}\u{631}\u{6A9}\u{627}\u{646} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{645}\u{642}\u{631}\u{631} \u{6A9}\u{6CC}\u{6D2} \u{6AF}\u{626}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `C\xf3 c\xe1c t\xedn h\u{1EEF}u \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c ch\u{1EC9} \u{111}\u{1ECB}nh cho sinh ho\u{1EA1}t n\xe0y.`,
    'zh-hans': `\u{6709}\u{6210}\u{5458}\u{88AB}\u{5206}\u{914D}\u{5230}\u{8FD9}\u{9879}\u{6D3B}\u{52A8}\u{3002}`,
    'zh-hant': `\u{6709}\u{6210}\u{54E1}\u{88AB}\u{6307}\u{6D3E}\u{53C3}\u{8207}\u{9019}\u{9805}\u{6D3B}\u{52D5}\u{3002}`,
    en: `Has members who were assigned to this activity.`
};
const $b11db1b62d4a8f76$export$33534dcbc6b4d188 = {
    ar: `\u{644}\u{62F}\u{64A}\u{647} \u{623}\u{639}\u{636}\u{627}\u{621} \u{62A}\u{645} \u{630}\u{643}\u{631}\u{647}\u{645} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Hat Mitglieder, die in dieser Aktivit\xe4t erw\xe4hnt wurden.`,
    es: `Tiene miembros que fueron mencionados en esta actividad.`,
    fa: `\u{627}\u{639}\u{636}\u{627}\u{6CC}\u{6CC} \u{62F}\u{627}\u{631}\u{62F} \u{6A9}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{630}\u{6A9}\u{631} \u{634}\u{62F}\u{647} \u{627}\u{646}\u{62F}.`,
    fil: `May mga miyembro na binanggit sa aktibidad na ito.`,
    fr: `A des membres mentionn\xe9s dans cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{915}\u{932}\u{93E}\u{92A} \u{92E}\u{947}\u{902} \u{91C}\u{93F}\u{928} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{94B}\u{902} \u{915}\u{93E} \u{909}\u{932}\u{94D}\u{932}\u{947}\u{916} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E}, \u{909}\u{928}\u{915}\u{947} \u{92A}\u{93E}\u{938} \u{939}\u{948}\u{964}`,
    ht: `Gen manm yo mansyone nan aktivite sa a.`,
    it: `Ha membri menzionati in questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{3067}\u{8A00}\u{53CA}\u{3055}\u{308C}\u{305F}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{304C}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0}\u{C11C} \u{C5B8}\u{AE09}\u{B41C} \u{BA64}\u{BC84}\u{B4E4}\u{C774} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Muaj cov tswv cuab uas tau hais hauv qhov kev ua no.`,
    ps: `\u{647}\u{63A}\u{647} \u{63A}\u{693}\u{6CC} \u{644}\u{631}\u{6CC} \u{686}\u{6D0} \u{67E}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D0} \u{6CC}\u{627}\u{62F} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: `Tem membros mencionados nesta atividade.`,
    'pt-pt': `Tem membros mencionados nesta atividade.`,
    ru: `\u{415}\u{441}\u{442}\u{44C} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{438}, \u{443}\u{43F}\u{43E}\u{43C}\u{44F}\u{43D}\u{443}\u{442}\u{44B}\u{435} \u{432} \u{44D}\u{442}\u{43E}\u{43C} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{438}.`,
    sm: `E i ai tagata o le ekalesia o e na ta'ua i lenei gaoioiga.`,
    so: `Waxay leedahay xubno lagu xusay hawshan.`,
    th: `\u{E21}\u{E35}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E17}\u{E35}\u{E48}\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}\u{E43}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{6A9}\u{6D2} \u{627}\u{631}\u{6A9}\u{627}\u{646} \u{62C}\u{646} \u{6A9}\u{627} \u{630}\u{6A9}\u{631} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{62A}\u{6BE}\u{627}\u{6D4}`,
    vi: `C\xf3 c\xe1c t\xedn h\u{1EEF}u \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EC1} c\u{1EAD}p trong sinh ho\u{1EA1}t n\xe0y.`,
    'zh-hans': `\u{6709}\u{6210}\u{5458}\u{5728}\u{672C}\u{6D3B}\u{52A8}\u{4E2D}\u{88AB}\u{63D0}\u{53CA}\u{3002}`,
    'zh-hant': `\u{6210}\u{54E1}\u{5728}\u{672C}\u{6D3B}\u{52D5}\u{4E2D}\u{88AB}\u{63D0}\u{53CA}\u{3002}`,
    en: `Has members who were mentioned in this activity.`
};
const $b11db1b62d4a8f76$export$2763be9aeff0aa97 = {
    ar: `\u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Kurs`,
    es: `Rumbos`,
    fa: `\u{633}\u{631}\u{628}\u{646}\u{62F}\u{6CC}`,
    fil: `Pamagat`,
    fr: `T\xeate`,
    hi: `\u{936}\u{940}\u{930}\u{94D}\u{937}\u{915}`,
    ht: `Heading`,
    it: `Intestazione`,
    ja: `\u{898B}\u{51FA}\u{3057}`,
    ko: `\u{C81C}\u{BAA9}`,
    mww: `Lub taub hau`,
    ps: `\u{633}\u{631}\u{644}\u{6CC}\u{6A9}`,
    pt: `Rumo`,
    'pt-pt': `Rumo`,
    ru: `\u{417}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43E}\u{43A}`,
    sm: `Ulutala`,
    so: `Jihada`,
    th: `\u{E2B}\u{E31}\u{E27}\u{E40}\u{E23}\u{E37}\u{E48}\u{E2D}\u{E07}`,
    ur: `\u{633}\u{631}\u{62E}\u{6CC}`,
    vi: `Ti\xeau \u{111}\u{1EC1}`,
    'zh-hans': `\u{6807}\u{9898}`,
    'zh-hant': `\u{6A19}\u{984C}`,
    en: `Heading`
};
const $b11db1b62d4a8f76$export$99349eb448fe574e = {
    ar: `\u{645}\u{633}\u{627}\u{639}\u{62F}\u{629} \u{641}\u{64A} \u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629}`,
    de: `Hilfe mit dieser Seite`,
    es: `Ayuda con esta p\xe1gina`,
    fa: `\u{6A9}\u{645}\u{6A9} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647}`,
    fil: `Tulong sa pahinang ito`,
    fr: `Aide pour cette page`,
    hi: `\u{907}\u{938} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{938}\u{939}\u{93E}\u{92F}\u{924}\u{93E}`,
    ht: `\xc8d ak paj sa a`,
    it: `Aiuto con questa pagina`,
    ja: `\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{306E}\u{52A9}\u{3051}`,
    ko: `\u{C774} \u{D398}\u{C774}\u{C9C0}\u{C5D0} \u{B300}\u{D55C} \u{B3C4}\u{C6C0}`,
    mww: `Pab nrog nplooj ntawv no`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{67E}\u{627}\u{6BC}\u{6D0} \u{633}\u{631}\u{647} \u{645}\u{631}\u{633}\u{62A}\u{647}`,
    pt: `Ajuda com esta p\xe1gina`,
    'pt-pt': `Ajuda com esta p\xe1gina`,
    ru: `\u{41F}\u{43E}\u{43C}\u{43E}\u{433}\u{438}\u{442}\u{435} \u{441} \u{44D}\u{442}\u{43E}\u{439} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{435}\u{439}`,
    sm: `Fesoasoani i lenei itulau`,
    so: `Caawimaad boggan`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E0A}\u{E48}\u{E27}\u{E22}\u{E40}\u{E2B}\u{E25}\u{E37}\u{E2D}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E01}\u{E31}\u{E1A}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{6A9}\u{6D2} \u{628}\u{627}\u{631}\u{6D2} \u{645}\u{6CC}\u{6BA} \u{645}\u{62F}\u{62F}`,
    vi: `Tr\u{1EE3} gi\xfap v\u{1EDB}i trang n\xe0y`,
    'zh-hans': `\u{672C}\u{9875}\u{6C42}\u{52A9}`,
    'zh-hant': `\u{672C}\u{9801}\u{6C42}\u{52A9}`,
    en: `Help with this page`
};
const $b11db1b62d4a8f76$export$4bba775f79bdb050 = {
    ar: (count)=>`${count} \u{639}\u{646}\u{627}\u{635}\u{631} \u{645}\u{62E}\u{641}\u{64A}\u{629}.`,
    de: (count)=>`${count} versteckte Gegenst\xe4nde.`,
    es: (count)=>`${count} objetos ocultos.`,
    fa: (count)=>`${count} \u{622}\u{6CC}\u{62A}\u{645} \u{645}\u{62E}\u{641}\u{6CC}.`,
    fil: (count)=>`${count} nakatagong mga item.`,
    fr: (count)=>`${count} objets cach\xe9s.`,
    hi: (count)=>`${count} \u{91B}\u{93F}\u{92A}\u{940} \u{939}\u{941}\u{908} \u{906}\u{907}\u{91F}\u{92E}\u{964}`,
    ht: (count)=>`${count} atik kache`,
    it: (count)=>`${count} oggetti nascosti.`,
    ja: (count)=>`\u{96A0}\u{3057}\u{30A2}\u{30A4}\u{30C6}\u{30E0}${count}\u{3064}\u{3002}`,
    ko: (count)=>`${count} \u{AC1C}.`,
    mww: (count)=>`${count} yam zais.`,
    ps: (count)=>`${count} \u{67E}\u{67C} \u{62A}\u{648}\u{6A9}\u{6CC}.`,
    pt: (count)=>`${count} itens escondidos.`,
    'pt-pt': (count)=>`${count} itens escondidos.`,
    ru: (count)=>`${count} \u{441}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{445} \u{43F}\u{440}\u{435}\u{434}\u{43C}\u{435}\u{442}\u{430}.`,
    sm: (count)=>`${count} mea natia.`,
    so: (count)=>`${count} shay oo qarsoon.`,
    th: (count)=>`${count} \u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E0B}\u{E48}\u{E2D}\u{E19}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: (count)=>`${count} \u{686}\u{6BE}\u{67E}\u{6D2} \u{6C1}\u{648}\u{626}\u{6D2} \u{627}\u{634}\u{6CC}\u{627}\u{621}\u{6D4}`,
    vi: (count)=>`${count} v\u{1EAD}t ph\u{1EA9}m \u{1EA9}n.`,
    'zh-hans': (count)=>`${count} \u{4E2A}\u{9690}\u{85CF}\u{7269}\u{54C1}\u{3002}`,
    'zh-hant': (count)=>`${count} \u{500B}\u{96B1}\u{85CF}\u{7269}\u{54C1}\u{3002}`,
    en: (count)=>`${count} hidden items.`
};
const $b11db1b62d4a8f76$export$ccbee3a13ebf2866 = {
    ar: `\u{627}\u{644}\u{62A}\u{627}\u{631}\u{64A}\u{62E}`,
    de: `Geschichte`,
    es: `Historia`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{686}\u{647}`,
    fil: `Kasaysayan`,
    fr: `Histoire`,
    hi: `\u{907}\u{924}\u{93F}\u{939}\u{93E}\u{938}`,
    ht: `Istwa`,
    it: `Storia`,
    ja: `\u{6B74}\u{53F2}`,
    ko: `\u{C5ED}\u{C0AC}`,
    mww: `Keeb Kwm`,
    ps: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{686}\u{647}`,
    pt: `Hist\xf3ria`,
    'pt-pt': `Hist\xf3ria`,
    ru: `\u{418}\u{441}\u{442}\u{43E}\u{440}\u{438}\u{44F}`,
    sm: `Talafaasolopito`,
    so: `Taariikhda`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E27}\u{E31}\u{E15}\u{E34}`,
    ur: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `L\u{1ECB}ch s\u{1EED}`,
    'zh-hans': `\u{5386}\u{53F2}`,
    'zh-hant': `\u{6B77}\u{53F2}`,
    en: `History`
};
const $b11db1b62d4a8f76$export$177202d8e35cf0d5 = {
    ar: `\u{627}\u{644}\u{645}\u{646}\u{632}\u{644}`,
    de: `Zuhause`,
    es: `Inicio`,
    fa: `\u{62E}\u{627}\u{646}\u{647}`,
    fil: `Tahanan`,
    fr: `Accueil`,
    hi: `\u{918}\u{930}`,
    ht: `Kay`,
    it: `Casa`,
    ja: `\u{30DB}\u{30FC}\u{30E0}`,
    ko: `\u{D648}`,
    mww: `Tsev`,
    ps: `\u{6A9}\u{648}\u{631}`,
    pt: `Casa`,
    'pt-pt': `Casa`,
    ru: `\u{414}\u{43E}\u{43C}`,
    sm: `Aiga`,
    so: `Guriga`,
    th: `\u{E2B}\u{E19}\u{E49}\u{E32}\u{E41}\u{E23}\u{E01}`,
    ur: `\u{6AF}\u{6BE}\u{631}`,
    vi: `Trang ch\u{1EE7}`,
    'zh-hans': `\u{9996}\u{9875}`,
    'zh-hant': `\u{9996}\u{9801}`,
    en: `Home`
};
const $b11db1b62d4a8f76$export$54870058574035d1 = {
    ar: `\u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{625}\u{644}\u{649} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{634}\u{641}\u{649}`,
    de: `Krankenhausaufenthalt`,
    es: `Hospitalizaci\xf3n`,
    fa: `\u{628}\u{633}\u{62A}\u{631}\u{6CC} \u{634}\u{62F}\u{646}`,
    fil: `Pag-ospital`,
    fr: `Hospitalisation`,
    hi: `\u{905}\u{938}\u{94D}\u{92A}\u{924}\u{93E}\u{932} \u{92E}\u{947}\u{902} \u{92D}\u{930}\u{94D}\u{924}\u{940}`,
    ht: `Hospitalisation`,
    it: `Ricovero`,
    ja: `\u{5165}\u{9662}`,
    ko: `\u{C785}\u{C6D0}`,
    mww: `Mus pw hauv tsev kho mob`,
    ps: `\u{631}\u{648}\u{63A}\u{62A}\u{648}\u{646} \u{62A}\u{647} \u{62F}\u{627}\u{62E}\u{644}\u{6D0}\u{62F}\u{644}`,
    pt: `Hospitaliza\xe7\xe3o`,
    'pt-pt': `Hospitaliza\xe7\xe3o`,
    ru: `\u{413}\u{43E}\u{441}\u{43F}\u{438}\u{442}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Falema'i`,
    so: `Isbitaal`,
    th: `\u{E01}\u{E32}\u{E23}\u{E23}\u{E31}\u{E01}\u{E29}\u{E32}\u{E43}\u{E19}\u{E42}\u{E23}\u{E07}\u{E1E}\u{E22}\u{E32}\u{E1A}\u{E32}\u{E25}`,
    ur: `\u{6C1}\u{633}\u{67E}\u{62A}\u{627}\u{644} \u{645}\u{6CC}\u{6BA} \u{62F}\u{627}\u{62E}\u{644} \u{6C1}\u{648}\u{646}\u{627}`,
    vi: `Nh\u{1EAD}p vi\u{1EC7}n`,
    'zh-hans': `\u{4F4F}\u{9662}`,
    'zh-hant': `\u{4F4F}\u{9662}`,
    en: `Hospitalization`
};
const $b11db1b62d4a8f76$export$e11e9b12e6d082f9 = {
    ar: `\u{633}\u{627}\u{639}\u{627}\u{62A} \u{627}\u{644}\u{639}\u{645}\u{644}`,
    de: `\xd6ffnungszeiten`,
    es: `Horarios`,
    fa: `\u{633}\u{627}\u{639}\u{627}\u{62A} \u{6A9}\u{627}\u{631}\u{6CC}`,
    fil: `Mga Oras`,
    fr: `Horaires`,
    hi: `\u{918}\u{902}\u{91F}\u{947}`,
    ht: `\xe8dtan`,
    it: `Orari`,
    ja: `\u{55B6}\u{696D}\u{6642}\u{9593}`,
    ko: `\u{C6B4}\u{C601} \u{C2DC}\u{AC04}`,
    mww: `Cov Sij Hawm`,
    ps: `\u{633}\u{627}\u{639}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Hor\xe1rio`,
    'pt-pt': `Hor\xe1rio`,
    ru: `\u{427}\u{430}\u{441}\u{44B} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}`,
    sm: `Itula`,
    so: `Saacadaha`,
    th: `\u{E40}\u{E27}\u{E25}\u{E32}\u{E17}\u{E4D}\u{E32}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{627}\u{648}\u{642}\u{627}\u{62A}`,
    vi: `Gi\u{1EDD}`,
    'zh-hans': `\u{5F00}\u{653E}\u{65F6}\u{95F4}`,
    'zh-hant': `\u{71DF}\u{696D}\u{6642}\u{9593}`,
    en: `Hours`
};
const $b11db1b62d4a8f76$export$c0d76ff4ae66221d = {
    ar: `\u{646}\u{62D}\u{646} \u{647}\u{646}\u{627} \u{644}\u{644}\u{645}\u{633}\u{627}\u{639}\u{62F}\u{629}. \u{62F}\u{639}\u{648}\u{646}\u{627} \u{646}\u{62A}\u{62D}\u{62F}\u{62B} \u{639}\u{646} \u{643}\u{64A}\u{641} \u{64A}\u{645}\u{643}\u{646} \u{644}\u{643}\u{648}\u{645}\u{648}\u{644}\u{648}\u{633} \u{62F}\u{639}\u{645} \u{623}\u{647}\u{62F}\u{627}\u{641}\u{643}.`,
    de: `Wir sind hier, um zu helfen. Lassen Sie uns dar\xfcber sprechen, wie Cumulus Ihre Ziele unterst\xfctzen kann.`,
    es: `Estamos aqu\xed para ayudarte. Hablemos de c\xf3mo Cumulus puede apoyar tus objetivos.`,
    fa: `\u{645}\u{627} \u{627}\u{6CC}\u{646}\u{62C}\u{627}\u{6CC}\u{6CC}\u{645} \u{6A9}\u{647} \u{6A9}\u{645}\u{6A9} \u{6A9}\u{646}\u{6CC}\u{645}. \u{628}\u{6CC}\u{627}\u{6CC}\u{6CC}\u{62F} \u{62F}\u{631}\u{628}\u{627}\u{631}\u{647} \u{627}\u{6CC}\u{646}\u{6A9}\u{647} \u{686}\u{6AF}\u{648}\u{646}\u{647} Cumulus \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{627}\u{647}\u{62F}\u{627}\u{641} \u{634}\u{645}\u{627} \u{631}\u{627} \u{62D}\u{645}\u{627}\u{6CC}\u{62A} \u{6A9}\u{646}\u{62F} \u{635}\u{62D}\u{628}\u{62A} \u{6A9}\u{646}\u{6CC}\u{645}.`,
    fil: `Narito kami upang tumulong. Pag-usapan natin kung paano masuportahan ng Cumulus ang iyong mga layunin.`,
    fr: `Nous sommes l\xe0 pour vous aider. Parlons de la fa\xe7on dont Cumulus peut soutenir vos objectifs.`,
    hi: `\u{939}\u{92E}\u{932}\u{94B}\u{917} \u{92F}\u{939}\u{93E}\u{902} \u{938}\u{939}\u{93E}\u{92F}\u{924}\u{93E} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{939}\u{948}\u{902}\u{964} \u{906}\u{907}\u{90F} \u{92C}\u{93E}\u{924} \u{915}\u{930}\u{924}\u{947} \u{939}\u{948}\u{902} \u{915}\u{93F} \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{94D}\u{92F}\u{932}\u{938} \u{906}\u{92A}\u{915}\u{947} \u{932}\u{915}\u{94D}\u{937}\u{94D}\u{92F}\u{94B}\u{902} \u{915}\u{93E} \u{938}\u{92E}\u{930}\u{94D}\u{925}\u{928} \u{915}\u{948}\u{938}\u{947} \u{915}\u{930} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Nou la pou nou ede. Ann pale sou ki jan Cumulus ka sip\xf2te objektif ou yo.`,
    it: `Siamo qui per aiutarti. Parliamo di come Cumulus possa supportare i tuoi obiettivi.`,
    ja: `\u{79C1}\u{305F}\u{3061}\u{306F}\u{304A}\u{624B}\u{4F1D}\u{3044}\u{3057}\u{307E}\u{3059}\u{3002}Cumulus\u{304C}\u{3069}\u{306E}\u{3088}\u{3046}\u{306B}\u{3042}\u{306A}\u{305F}\u{306E}\u{76EE}\u{6A19}\u{3092}\u{652F}\u{63F4}\u{3067}\u{304D}\u{308B}\u{304B}\u{306B}\u{3064}\u{3044}\u{3066}\u{8A71}\u{3057}\u{307E}\u{3057}\u{3087}\u{3046}\u{3002}`,
    ko: `\u{C800}\u{D76C}\u{AC00} \u{B3C4}\u{C640}\u{B4DC}\u{B9AC}\u{B7EC} \u{C654}\u{C2B5}\u{B2C8}\u{B2E4}. Cumulus\u{AC00} \u{C5B4}\u{B5BB}\u{AC8C} \u{C5EC}\u{B7EC}\u{BD84}\u{C758} \u{BAA9}\u{D45C}\u{B97C} \u{C9C0}\u{C6D0}\u{D560} \u{C218} \u{C788}\u{B294}\u{C9C0} \u{C774}\u{C57C}\u{AE30}\u{D574} \u{BD05}\u{C2DC}\u{B2E4}.`,
    mww: `Peb nyob ntawm no los pab. Cia peb tham txog yuav ua li cas Cumulus tuaj yeem txhawb koj lub hom phiaj.`,
    ps: `\u{645}\u{648}\u{696} \u{62F}\u{644}\u{62A}\u{647} \u{62F} \u{645}\u{631}\u{633}\u{62A}\u{6D0} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{6CC}\u{648}. \u{631}\u{627}\u{681}\u{626} \u{62E}\u{628}\u{631}\u{6D0} \u{648}\u{6A9}\u{693}\u{648} \u{686}\u{6D0} \u{685}\u{646}\u{6AB}\u{647} Cumulus \u{633}\u{62A}\u{627}\u{633}\u{648} \u{647}\u{62F}\u{641}\u{648}\u{646}\u{647} \u{645}\u{644}\u{627}\u{62A}\u{693} \u{6A9}\u{648}\u{644}\u{6CC} \u{634}\u{6CC}.`,
    pt: `Estamos aqui para ajudar. Vamos falar sobre como o Cumulus pode apoiar seus objetivos.`,
    'pt-pt': `Estamos aqui para ajudar. Vamos falar sobre como a Cumulus pode apoiar os seus objetivos.`,
    ru: `\u{41C}\u{44B} \u{437}\u{434}\u{435}\u{441}\u{44C}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{43E}\u{43C}\u{43E}\u{447}\u{44C}. \u{414}\u{430}\u{432}\u{430}\u{439}\u{442}\u{435} \u{43F}\u{43E}\u{433}\u{43E}\u{432}\u{43E}\u{440}\u{438}\u{43C} \u{43E} \u{442}\u{43E}\u{43C}, \u{43A}\u{430}\u{43A} Cumulus \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{43F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{442}\u{44C} \u{432}\u{430}\u{448}\u{438} \u{446}\u{435}\u{43B}\u{438}.`,
    sm: `Ua matou i ai iinei e fesoasoani. Se'i o tatou talanoa e uiga i le auala e mafai ai e Cumulus ona lagolagoina au sini.`,
    so: `Waxaan halkan u joognaa inaan caawino. Aan ka hadalno sida Cumulus ay u taageeri karto yoolalkaaga.`,
    th: `\u{E40}\u{E23}\u{E32}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E43}\u{E2B}\u{E49}\u{E04}\u{E27}\u{E32}\u{E21}\u{E0A}\u{E48}\u{E27}\u{E22}\u{E40}\u{E2B}\u{E25}\u{E37}\u{E2D} \u{E21}\u{E32}\u{E1E}\u{E39}\u{E14}\u{E16}\u{E36}\u{E07}\u{E27}\u{E34}\u{E18}\u{E35}\u{E17}\u{E35}\u{E48} Cumulus \u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E2A}\u{E19}\u{E31}\u{E1A}\u{E2A}\u{E19}\u{E38}\u{E19}\u{E40}\u{E1B}\u{E49}\u{E32}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{6C1}\u{645} \u{645}\u{62F}\u{62F} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{6CC}\u{6C1}\u{627}\u{6BA} \u{6C1}\u{6CC}\u{6BA}\u{6D4} \u{622}\u{626}\u{6CC}\u{6D2} \u{628}\u{627}\u{62A} \u{6A9}\u{631}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6C1} Cumulus \u{622}\u{67E} \u{6A9}\u{6D2} \u{645}\u{642}\u{627}\u{635}\u{62F} \u{6A9}\u{6CC} \u{6A9}\u{633} \u{637}\u{631}\u{62D} \u{62D}\u{645}\u{627}\u{6CC}\u{62A} \u{6A9}\u{631} \u{633}\u{6A9}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ch\xfang t\xf4i s\u{1EB5}n s\xe0ng tr\u{1EE3} gi\xfap. H\xe3y n\xf3i v\u{1EC1} c\xe1ch Cumulus c\xf3 th\u{1EC3} h\u{1ED7} tr\u{1EE3} m\u{1EE5}c ti\xeau c\u{1EE7}a b\u{1EA1}n.`,
    'zh-hans': `\u{6211}\u{4EEC}\u{6765}\u{5E2E}\u{4F60}\u{3002}\u{8BA9}\u{6211}\u{4EEC}\u{6765}\u{8C08}\u{8C08}Cumulus\u{5982}\u{4F55}\u{652F}\u{6301}\u{4F60}\u{7684}\u{76EE}\u{6807}\u{3002}`,
    'zh-hant': `\u{6211}\u{5011}\u{5728}\u{9019}\u{88E1}\u{5354}\u{52A9}\u{4F60}\u{3002}\u{8B93}\u{6211}\u{5011}\u{4F86}\u{8AC7}\u{8AC7} Cumulus \u{5982}\u{4F55}\u{652F}\u{6301}\u{4F60}\u{7684}\u{76EE}\u{6A19}\u{3002}`,
    en: `We're here to help. Let\u{2019}s talk about how Cumulus can support your goals.`
};
const $b11db1b62d4a8f76$export$68919206df5157d9 = {
    ar: `\u{62A}\u{62A}\u{645} \u{625}\u{62F}\u{627}\u{631}\u{629} \u{62A}\u{639}\u{631}\u{64A}\u{641}\u{627}\u{62A} \u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{641}\u{64A} \u{625}\u{639}\u{62F}\u{627}\u{62F}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{64A}\u{639} \u{627}\u{644}\u{62E}\u{627}\u{635}\u{629} \u{628}\u{645}\u{624}\u{633}\u{633}\u{62A}\u{643}.`,
    de: `Aktivit\xe4tendefinitionen werden in den Projekteinstellungen Ihrer Organisation verwaltet.`,
    es: `Las definiciones de actividades se gestionan en la configuraci\xf3n del proyecto de tu organizaci\xf3n.`,
    fa: `\u{62A}\u{639}\u{627}\u{631}\u{6CC}\u{641} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627} \u{62F}\u{631} \u{645}\u{62D}\u{6CC}\u{637} \u{647}\u{627}\u{6CC} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{634}\u{645}\u{627} \u{645}\u{62F}\u{6CC}\u{631}\u{6CC}\u{62A} \u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: `Ang mga kahulugan ng aktibidad ay pinamamahalaan sa mga setting ng proyekto ng iyong organisasyon.`,
    fr: `Les d\xe9finitions d\u{2019}activit\xe9s sont g\xe9r\xe9es dans les param\xe8tres de projet de votre organisation.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930}\u{93F}\u{92D}\u{93E}\u{937}\u{93E}\u{90F}\u{901} \u{906}\u{92A}\u{915}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{940} \u{92A}\u{94D}\u{930}\u{94B}\u{91C}\u{947}\u{915}\u{94D}\u{91F} \u{938}\u{947}\u{91F}\u{93F}\u{902}\u{917}\u{94D}\u{938} \u{92E}\u{947}\u{902} \u{92A}\u{94D}\u{930}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{915}\u{940} \u{91C}\u{93E}\u{924}\u{940} \u{939}\u{948}\u{902}.`,
    ht: `Definisyon aktivite yo jere nan anviw\xf2nman pwoj\xe8 \xf2ganizasyon ou an.`,
    it: `Le definizioni di attivit\xe0 sono gestite nelle impostazioni del progetto della tua organizzazione.`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306E}\u{5B9A}\u{7FA9}\u{306F}\u{3001}\u{7D44}\u{7E54}\u{306E}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{8A2D}\u{5B9A}\u{3067}\u{7BA1}\u{7406}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{D65C}\u{B3D9} \u{C815}\u{C758}\u{B294} \u{C870}\u{C9C1}\u{C758} \u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{D658}\u{ACBD}\u{C5D0}\u{C11C} \u{AD00}\u{B9AC}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Cov lus txhais ntawm kev ua ub no yog tswj nyob rau hauv koj lub koom haum qhov project chaw.`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{648} \u{62A}\u{639}\u{631}\u{6CC}\u{641}\u{648}\u{646}\u{647} \u{633}\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62F} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{67E}\u{647} \u{686}\u{648}\u{6A9}\u{627}\u{67C} \u{6A9}\u{6D0} \u{645}\u{62F}\u{6CC}\u{631}\u{6CC}\u{62A} \u{6A9}\u{6CC}\u{696}\u{6CC}.`,
    pt: `As defini\xe7\xf5es de atividades s\xe3o gerenciadas nas configura\xe7\xf5es do projeto da sua organiza\xe7\xe3o.`,
    'pt-pt': `As defini\xe7\xf5es de atividades s\xe3o geridas nas defini\xe7\xf5es do projeto da sua organiza\xe7\xe3o.`,
    ru: `\u{41E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{44F}\u{44E}\u{442}\u{441}\u{44F} \u{432} \u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{430}\u{445} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{430} \u{432}\u{430}\u{448}\u{435}\u{439} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}.`,
    sm: `O faauigaga o gaoioiga o loo pulea i faatulagaga o galuega faatino a lau faalapotopotoga.`,
    so: `Qeexitaannada hawlaha waxaa lagu maamulaa dejinta mashruuca ururkaaga.`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E08}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E14}\u{E04}\u{E27}\u{E32}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E08}\u{E31}\u{E14}\u{E01}\u{E32}\u{E23}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E15}\u{E31}\u{E49}\u{E07}\u{E04}\u{E48}\u{E32}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6CC} \u{62A}\u{639}\u{631}\u{6CC}\u{641}\u{6CC}\u{6BA} \u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679} \u{633}\u{6CC}\u{679}\u{646}\u{6AF}\u{632} \u{645}\u{6CC}\u{6BA} \u{645}\u{646}\u{638}\u{645} \u{6A9}\u{6CC} \u{62C}\u{627}\u{62A}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `\u{110}\u{1ECB}nh ngh\u{129}a ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\u{1B0}\u{1EE3}c qu\u{1EA3}n l\xfd trong c\xe0i \u{111}\u{1EB7}t d\u{1EF1} \xe1n c\u{1EE7}a t\u{1ED5} ch\u{1EE9}c b\u{1EA1}n.`,
    'zh-hans': `\u{6D3B}\u{52A8}\u{5B9A}\u{4E49}\u{5728}\u{60A8}\u{7EC4}\u{7EC7}\u{7684}\u{9879}\u{76EE}\u{8BBE}\u{7F6E}\u{4E2D}\u{8FDB}\u{884C}\u{7BA1}\u{7406}\u{3002}`,
    'zh-hant': `\u{6D3B}\u{52D5}\u{5B9A}\u{7FA9}\u{6703}\u{5728}\u{60A8}\u{7D44}\u{7E54}\u{7684}\u{5C08}\u{6848}\u{8A2D}\u{5B9A}\u{4E2D}\u{7BA1}\u{7406}\u{3002}`,
    en: `Activity definitions are managed in your organization's project settings.`
};
const $b11db1b62d4a8f76$export$66ac5ac68c1dcca4 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{627}\u{631}\u{62F} \u{627}\u{644}\u{628}\u{634}\u{631}\u{64A}\u{629}`,
    de: `Personalwesen`,
    es: `Recursos humanos`,
    fa: `\u{645}\u{646}\u{627}\u{628}\u{639} \u{627}\u{646}\u{633}\u{627}\u{646}\u{6CC}`,
    fil: `Mga mapagkukunan ng tao`,
    fr: `Ressources humaines`,
    hi: `\u{92E}\u{93E}\u{928}\u{935} \u{938}\u{902}\u{938}\u{93E}\u{927}\u{928}`,
    ht: `Resous imen`,
    it: `Risorse umane`,
    ja: `\u{4EBA}\u{4E8B}`,
    ko: `\u{C778}\u{C0AC} \u{C790}\u{C6D0}`,
    mww: `Cov peev txheej tib neeg`,
    ps: `\u{628}\u{634}\u{631}\u{6CC} \u{633}\u{631}\u{686}\u{6CC}\u{646}\u{6D0}`,
    pt: `Recursos humanos`,
    'pt-pt': `Recursos humanos`,
    ru: `\u{41A}\u{430}\u{434}\u{440}\u{44B}`,
    sm: `Punaoa a tagata`,
    so: `Kheyraadka aadanaha`,
    th: `\u{E17}\u{E23}\u{E31}\u{E1E}\u{E22}\u{E32}\u{E01}\u{E23}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}`,
    ur: `\u{627}\u{646}\u{633}\u{627}\u{646}\u{6CC} \u{648}\u{633}\u{627}\u{626}\u{644}`,
    vi: `Ngu\u{1ED3}n nh\xe2n l\u{1EF1}c`,
    'zh-hans': `\u{4EBA}\u{529B}\u{8D44}\u{6E90}`,
    'zh-hant': `\u{4EBA}\u{529B}\u{8CC7}\u{6E90}`,
    en: `Human resources`
};
const $b11db1b62d4a8f76$export$64c614ea27884e4c = {
    ar: `ID`,
    de: `ID`,
    es: `ID`,
    fa: `\u{634}\u{646}\u{627}\u{633}\u{647}`,
    fil: `ID`,
    fr: `ID`,
    hi: `\u{92A}\u{930}\u{93F}\u{91A}\u{92F}`,
    ht: `Didantite`,
    it: `ID`,
    ja: `\u{8EAB}\u{5206}\u{8A3C}`,
    ko: `\u{C2E0}\u{BD84}\u{C99D}`,
    mww: `ID`,
    ps: `ID`,
    pt: `ID`,
    'pt-pt': `ID`,
    ru: `ID`,
    sm: `ID`,
    so: `Aqoonsiga`,
    th: `\u{E1A}\u{E31}\u{E15}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E08}\u{E4D}\u{E32}\u{E15}\u{E31}\u{E27}`,
    ur: `\u{622}\u{626}\u{6CC} \u{688}\u{6CC}`,
    vi: `ID`,
    'zh-hans': `\u{8EAB}\u{4EFD}\u{8BC1}`,
    'zh-hant': `\u{8EAB}\u{5206}\u{8B49}`,
    en: `ID`
};
const $b11db1b62d4a8f76$export$66ca751dbda0aefb = {
    ar: `\u{627}\u{644}\u{645}\u{639}\u{631}\u{641}\u{627}\u{62A}`,
    de: `Kennungen`,
    es: `Identificadores`,
    fa: `\u{634}\u{646}\u{627}\u{633}\u{647} \u{647}\u{627}`,
    fil: `Mga Identifier`,
    fr: `Identifiants`,
    hi: `\u{92A}\u{939}\u{91A}\u{93E}\u{928}\u{915}\u{930}\u{94D}\u{924}\u{93E}`,
    ht: `Idantifyan yo`,
    it: `Identificatori`,
    ja: `\u{8B58}\u{5225}\u{5B50}`,
    ko: `\u{C2DD}\u{BCC4}\u{C790}`,
    mww: `Cov cim qhia txog`,
    ps: `\u{67E}\u{6CC}\u{698}\u{646}\u{62F}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Identificadores`,
    'pt-pt': `Identificadores`,
    ru: `\u{418}\u{434}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440}\u{44B}`,
    sm: `Fa'ailoaina`,
    so: `Aqoonsiyada`,
    th: `\u{E15}\u{E31}\u{E27}\u{E23}\u{E30}\u{E1A}\u{E38}`,
    ur: `\u{634}\u{646}\u{627}\u{62E}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{6AF}\u{627}\u{646}`,
    vi: `M\xe3 \u{111}\u{1ECB}nh danh`,
    'zh-hans': `\u{6807}\u{8BC6}\u{7B26}`,
    'zh-hant': `\u{8B58}\u{5225}\u{78BC}`,
    en: `Identifiers`
};
const $b11db1b62d4a8f76$export$6a584c99ae610576 = {
    ar: `\u{635}\u{648}\u{631}\u{629}`,
    de: `Bild`,
    es: `Imagen`,
    fa: `\u{62A}\u{635}\u{648}\u{6CC}\u{631}`,
    fil: `Imahe`,
    fr: `Image`,
    hi: `\u{91B}\u{935}\u{93F}`,
    ht: `Imaj`,
    it: `Immagine`,
    ja: `\u{753B}\u{50CF}`,
    ko: `\u{C774}\u{BBF8}\u{C9C0}`,
    mww: `Duab`,
    ps: `\u{627}\u{646}\u{681}\u{648}\u{631}`,
    pt: `Imagem`,
    'pt-pt': `Imagem`,
    ru: `\u{418}\u{437}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Ata`,
    so: `Sawir`,
    th: `\u{E20}\u{E32}\u{E1E}`,
    ur: `\u{62A}\u{635}\u{648}\u{6CC}\u{631}`,
    vi: `H\xecnh \u{1EA2}nh`,
    'zh-hans': `\u{56FE}\u{7247}`,
    'zh-hant': `\u{5716}\u{7247}`,
    en: `Image`
};
const $b11db1b62d4a8f76$export$92af69dc7dbf9bcd = {
    ar: `\u{623}\u{646}\u{627} \u{623}\u{633}\u{62A}\u{62E}\u{62F}\u{645} Cumulus \u{628}\u{627}\u{644}\u{641}\u{639}\u{644} \u{648}\u{623}\u{62D}\u{62A}\u{627}\u{62C} \u{625}\u{644}\u{649} \u{627}\u{644}\u{62F}\u{639}\u{645}`,
    de: `Ich benutze bereits Cumulus und brauche Unterst\xfctzung`,
    es: `Ya uso Cumulus y necesito apoyo`,
    fa: `\u{645}\u{646} \u{642}\u{628}\u{644}\u{627} \u{627}\u{632} Cumulus \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{645}\u{6CC} \u{6A9}\u{646}\u{645} \u{648} \u{628}\u{647} \u{67E}\u{634}\u{62A}\u{6CC}\u{628}\u{627}\u{646}\u{6CC} \u{646}\u{6CC}\u{627}\u{632} \u{62F}\u{627}\u{631}\u{645}`,
    fil: `Gumagamit na ako ng Cumulus at kailangan ko ng suporta`,
    fr: `J\u{2019}utilise d\xe9j\xe0 Cumulus et j\u{2019}ai besoin de soutien`,
    hi: `\u{92E}\u{948}\u{902} \u{92A}\u{939}\u{932}\u{947} \u{938}\u{947} \u{939}\u{940} \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{941}\u{932}\u{938} \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{942}\u{902} \u{914}\u{930} \u{938}\u{92E}\u{930}\u{94D}\u{925}\u{928} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{948}`,
    ht: `Mwen deja itilize Cumulus epi mwen bezwen sip\xf2`,
    it: `Uso gi\xe0 Cumulus e ho bisogno di supporto`,
    ja: `\u{79C1}\u{306F}\u{3059}\u{3067}\u{306B}Cumulus\u{3092}\u{4F7F}\u{3063}\u{3066}\u{3044}\u{3066}\u{3001}\u{30B5}\u{30DD}\u{30FC}\u{30C8}\u{304C}\u{5FC5}\u{8981}\u{3067}\u{3059}`,
    ko: `\u{C800}\u{B294} \u{C774}\u{BBF8} Cumulus\u{B97C} \u{C0AC}\u{C6A9} \u{C911}\u{C774}\u{ACE0} \u{C9C0}\u{C6D0}\u{C774} \u{D544}\u{C694}\u{D569}\u{B2C8}\u{B2E4}`,
    mww: `Kuv twb siv Cumulus thiab xav tau kev txhawb nqa`,
    ps: `\u{632}\u{647} \u{644}\u{627} \u{62F}\u{645}\u{62E}\u{647} Cumulus \u{6A9}\u{627}\u{631}\u{648}\u{645} \u{627}\u{648} \u{645}\u{644}\u{627}\u{62A}\u{693} \u{62A}\u{647} \u{627}\u{693}\u{62A}\u{6CC}\u{627} \u{644}\u{631}\u{645}`,
    pt: `J\xe1 uso o Cumulus e preciso de suporte`,
    'pt-pt': `J\xe1 uso o Cumulus e preciso de apoio`,
    ru: `\u{42F} \u{443}\u{436}\u{435} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{44E} Cumulus \u{438} \u{43C}\u{43D}\u{435} \u{43D}\u{443}\u{436}\u{43D}\u{430} \u{43F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{430}`,
    sm: `Ua uma ona ou fa'aaogaina Cumulus ma mana'omia le lagolago`,
    so: `Anigu hore ayaan u isticmaalaa Cumulus waxaanan u baahanahay taageero`,
    th: `\u{E09}\u{E31}\u{E19}\u{E43}\u{E0A}\u{E49} Cumulus \u{E2D}\u{E22}\u{E39}\u{E48}\u{E41}\u{E25}\u{E49}\u{E27}\u{E41}\u{E25}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E19}\u{E31}\u{E1A}\u{E2A}\u{E19}\u{E38}\u{E19}`,
    ur: `\u{645}\u{6CC}\u{6BA} \u{67E}\u{6C1}\u{644}\u{6D2} \u{6C1}\u{6CC} Cumulus \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{648}\u{6BA} \u{627}\u{648}\u{631} \u{645}\u{62C}\u{6BE}\u{6D2} \u{633}\u{67E}\u{648}\u{631}\u{679} \u{6A9}\u{6CC} \u{636}\u{631}\u{648}\u{631}\u{62A} \u{6C1}\u{6D2}`,
    vi: `T\xf4i \u{111}\xe3 s\u{1EED} d\u{1EE5}ng Cumulus v\xe0 c\u{1EA7}n h\u{1ED7} tr\u{1EE3}`,
    'zh-hans': `\u{6211}\u{5DF2}\u{7ECF}\u{7528}Cumulus\u{4E86}\u{FF0C}\u{9700}\u{8981}\u{652F}\u{6301}\u{3002}`,
    'zh-hant': `\u{6211}\u{5DF2}\u{7D93}\u{5728}\u{7528} Cumulus\u{FF0C}\u{9700}\u{8981}\u{652F}\u{63F4}`,
    en: `I already use Cumulus and need support`
};
const $b11db1b62d4a8f76$export$48582d35b48df56b = {
    ar: `\u{645}\u{647}\u{645}`,
    de: `Wichtig`,
    es: `Importante`,
    fa: `\u{645}\u{647}\u{645}`,
    fil: `Mahalaga`,
    fr: `Important`,
    hi: `\u{92E}\u{939}\u{924}\u{94D}\u{935}\u{92A}\u{942}\u{930}\u{94D}\u{923}`,
    ht: `Ki enp\xf2tan`,
    it: `Importante`,
    ja: `\u{91CD}\u{8981}`,
    ko: `\u{C911}\u{C694}`,
    mww: `Tseem ceeb`,
    ps: `\u{645}\u{647}\u{645}`,
    pt: `Importante`,
    'pt-pt': `Importante`,
    ru: `\u{412}\u{430}\u{436}\u{43D}\u{43E}`,
    sm: `Taua`,
    so: `Muhiim`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E2A}\u{E4D}\u{E32}\u{E04}\u{E31}\u{E0D}`,
    ur: `\u{627}\u{6C1}\u{645}`,
    vi: `Quan tr\u{1ECD}ng`,
    'zh-hans': `\u{91CD}\u{8981}`,
    'zh-hant': `\u{91CD}\u{8981}`,
    en: `Important`
};
const $b11db1b62d4a8f76$export$e2557e2ea820ad3b = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{62A}\u{64A}\u{631}\u{627}\u{62F} / \u{627}\u{644}\u{62A}\u{635}\u{62F}\u{64A}\u{631}`,
    de: `Import / Export`,
    es: `Importaci\xf3n / Exportaci\xf3n`,
    fa: `\u{648}\u{627}\u{631}\u{62F}\u{627}\u{62A} / \u{635}\u{627}\u{62F}\u{631}\u{627}\u{62A}`,
    fil: `Pag-import / Pag-export`,
    fr: `Importation / Exportation`,
    hi: `\u{906}\u{92F}\u{93E}\u{924}/\u{928}\u{93F}\u{930}\u{94D}\u{92F}\u{93E}\u{924}`,
    ht: `Enp\xf2te / Eksp\xf2tasyon`,
    it: `Importazione / Esportazione`,
    ja: `\u{8F38}\u{5165}/\u{8F38}\u{51FA}`,
    ko: `\u{C218}\u{C785}/\u{C218}\u{CD9C}`,
    mww: `Ntshuam / Export`,
    ps: `\u{648}\u{627}\u{631}\u{62F}\u{627}\u{62A} / \u{635}\u{627}\u{62F}\u{631}\u{627}\u{62A}`,
    pt: `Importa\xe7\xe3o / Exporta\xe7\xe3o`,
    'pt-pt': `Importa\xe7\xe3o / Exporta\xe7\xe3o`,
    ru: `\u{418}\u{43C}\u{43F}\u{43E}\u{440}\u{442} / \u{42D}\u{43A}\u{441}\u{43F}\u{43E}\u{440}\u{442}`,
    sm: `Fa'aulufale mai / auina atu i fafo`,
    so: `Soo dejinta / Dhoofinta`,
    th: `\u{E19}\u{E4D}\u{E32}\u{E40}\u{E02}\u{E49}\u{E32} / \u{E2A}\u{E48}\u{E07}\u{E2D}\u{E2D}\u{E01}`,
    ur: `\u{62F}\u{631}\u{622}\u{645}\u{62F} / \u{628}\u{631}\u{622}\u{645}\u{62F}`,
    vi: `Xu\u{1EA5}t nh\u{1EAD}p kh\u{1EA9}u`,
    'zh-hans': `\u{8FDB}\u{53E3}/\u{51FA}\u{53E3}`,
    'zh-hant': `\u{9032}\u{53E3}/\u{51FA}\u{53E3}`,
    en: `Import / Export`
};
const $b11db1b62d4a8f76$export$96e776fd723fc349 = {
    ar: `\u{627}\u{644}\u{648}\u{627}\u{631}\u{62F}\u{627}\u{62A}`,
    de: `Importe`,
    es: `Importaciones`,
    fa: `\u{648}\u{627}\u{631}\u{62F}\u{627}\u{62A}`,
    fil: `Mga Pag-import`,
    fr: `Importations`,
    hi: `\u{906}\u{92F}\u{93E}\u{924}`,
    ht: `Enp\xf2tasyon`,
    it: `Importazioni`,
    ja: `\u{8F38}\u{5165}`,
    ko: `\u{C218}\u{C785}`,
    mww: `Kev Ntshuam`,
    ps: `\u{648}\u{627}\u{631}\u{62F}\u{627}\u{62A}\u{6CC}`,
    pt: `Importa\xe7\xf5es`,
    'pt-pt': `Importa\xe7\xf5es`,
    ru: `\u{418}\u{43C}\u{43F}\u{43E}\u{440}\u{442}`,
    sm: `Fa'aulufale mai`,
    so: `Soo dejinta`,
    th: `\u{E01}\u{E32}\u{E23}\u{E19}\u{E4D}\u{E32}\u{E40}\u{E02}\u{E49}\u{E32}`,
    ur: `\u{62F}\u{631}\u{622}\u{645}\u{62F}\u{627}\u{62A}`,
    vi: `Nh\u{1EAD}p kh\u{1EA9}u`,
    'zh-hans': `\u{8FDB}\u{53E3}`,
    'zh-hant': `\u{9032}\u{53E3}\u{8ECA}`,
    en: `Imports`
};
const $b11db1b62d4a8f76$export$6526f51dd1e52ad2 = {
    ar: `\u{63A}\u{64A}\u{631} \u{646}\u{634}\u{637}`,
    de: `Inaktiv`,
    es: `Inactivo`,
    fa: `\u{63A}\u{6CC}\u{631}\u{641}\u{639}\u{627}\u{644}`,
    fil: `Hindi aktibo`,
    fr: `Inactifs`,
    hi: `\u{928}\u{93F}\u{937}\u{94D}\u{915}\u{94D}\u{930}\u{93F}\u{92F}`,
    ht: `Inaktif`,
    it: `Inattivi`,
    ja: `\u{975E}\u{7A3C}\u{50CD}`,
    ko: `\u{BE44}\u{D65C}\u{C131}\u{D654}`,
    mww: `Tsis ua hauj lwm`,
    ps: `\u{63A}\u{6CC}\u{631} \u{641}\u{639}\u{627}\u{644}`,
    pt: `Inativo`,
    'pt-pt': `Inativo`,
    ru: `\u{41D}\u{435}\u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{430}`,
    sm: `Le toaga`,
    so: `Aan firfircoonayn`,
    th: `\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{641}\u{639}\u{627}\u{644}`,
    vi: `Kh\xf4ng ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{5DF2}\u{505C}\u{7528}`,
    'zh-hant': `\u{5DF2}\u{505C}\u{7528}`,
    en: `Inactive`
};
const $b11db1b62d4a8f76$export$7c1b73b3fc2f0159 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{627}\u{641}\u{642}\u{629}`,
    de: `Zustimmung`,
    es: `Consentimiento`,
    fa: `\u{631}\u{636}\u{627}\u{6CC}\u{62A}`,
    fil: `Pahintulot`,
    fr: `Consentement`,
    hi: `\u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F}`,
    ht: `Konsantman`,
    it: `Consenso`,
    ja: `\u{540C}\u{610F}`,
    ko: `\u{B3D9}\u{C758}`,
    mww: `Kev tso cai`,
    ps: `\u{631}\u{636}\u{627}`,
    pt: `Consentimento`,
    'pt-pt': `Consentimento`,
    ru: `\u{421}\u{43E}\u{433}\u{43B}\u{430}\u{441}\u{438}\u{435}`,
    sm: `Maliega`,
    so: `Ogolaansho`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E22}\u{E34}\u{E19}\u{E22}\u{E2D}\u{E21}`,
    ur: `\u{631}\u{636}\u{627}\u{645}\u{646}\u{62F}\u{6CC}`,
    vi: `S\u{1EF1} \u{111}\u{1ED3}ng \xfd`,
    'zh-hans': `\u{540C}\u{610F}`,
    'zh-hant': `\u{540C}\u{610F}`,
    en: `Consent`
};
const $b11db1b62d4a8f76$export$1aab9202c7b650e6 = {
    ar: `\u{633}\u{62C}\u{644} \u{644}\u{627}\u{62A}\u{641}\u{627}\u{642} \u{644}\u{62C}\u{645}\u{639} \u{623}\u{648} \u{627}\u{644}\u{648}\u{635}\u{648}\u{644} \u{623}\u{648} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{623}\u{648} \u{627}\u{644}\u{643}\u{634}\u{641} (\u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{629}) \u{644}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}.`,
    de: `Eine Aufzeichnung einer Vereinbarung zur Sammlung, zum Zugriff darauf, Nutzung oder zur Offenlegung (Weitergabe) von Informationen.`,
    es: `Un registro de un acuerdo para recopilar, acceder, usar o divulgar (compartir) informaci\xf3n.`,
    fa: `\u{631}\u{6A9}\u{648}\u{631}\u{62F}\u{6CC} \u{627}\u{632} \u{62A}\u{648}\u{627}\u{641}\u{642} \u{628}\u{631}\u{627}\u{6CC} \u{62C}\u{645}\u{639} \u{622}\u{648}\u{631}\u{6CC}\u{60C} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC}\u{60C} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{6CC}\u{627} \u{627}\u{641}\u{634}\u{627}\u{6CC} (\u{628}\u{647} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6AF}\u{630}\u{627}\u{631}\u{6CC}) \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A}.`,
    fil: `Isang talaan ng isang kasunduan upang mangolekta, ma-access, gamitin o ibunyag (ibahagi) ang impormasyon.`,
    fr: `Un enregistrement d\u{2019}un accord de collecte, d\u{2019}acc\xe8s, d\u{2019}utilisation ou de divulgation (partage) d\u{2019}informations.`,
    hi: `\u{91C}\u{93E}\u{928}\u{915}\u{93E}\u{930}\u{940} \u{90F}\u{915}\u{924}\u{94D}\u{930} \u{915}\u{930}\u{928}\u{947}, \u{909}\u{938} \u{924}\u{915} \u{92A}\u{939}\u{941}\u{901}\u{91A}\u{928}\u{947}, \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{928}\u{947} \u{92F}\u{93E} \u{92A}\u{94D}\u{930}\u{915}\u{91F} \u{915}\u{930}\u{928}\u{947} (\u{938}\u{93E}\u{91D}\u{93E}) \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{93F}\u{938}\u{940} \u{905}\u{928}\u{941}\u{92C}\u{902}\u{927} \u{915}\u{93E} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921}.`,
    ht: `Yon dosye sou yon ak\xf2 pou kolekte, aks\xe8, itilize oswa divilge (pataje) enf\xf2masyon.`,
    it: `Un documento di un accordo per raccogliere, accedere, utilizzare o divulgare (condividere) informazioni.`,
    ja: `\u{60C5}\u{5831}\u{306E}\u{53CE}\u{96C6}\u{3001}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3001}\u{4F7F}\u{7528}\u{3001}\u{958B}\u{793A}(\u{5171}\u{6709})\u{306B}\u{95A2}\u{3059}\u{308B}\u{5408}\u{610F}\u{306E}\u{8A18}\u{9332}\u{3002}`,
    ko: `\u{C815}\u{BCF4} \u{C218}\u{C9D1}, \u{C811}\u{ADFC}, \u{C0AC}\u{C6A9} \u{B610}\u{B294} \u{ACF5}\u{AC1C}(\u{ACF5}\u{C720}) \u{D569}\u{C758}\u{C758} \u{AE30}\u{B85D}.`,
    mww: `Ib daim ntawv teev tseg ntawm kev pom zoo los sau, nkag mus, siv lossis qhia tawm (sib qhia) cov ntaub ntawv.`,
    ps: `\u{62F} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}\u{648} \u{631}\u{627}\u{67C}\u{648}\u{644}\u{648}\u{644}\u{60C} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC}\u{60C} \u{6A9}\u{627}\u{631}\u{648}\u{644}\u{648} \u{6CC}\u{627} \u{627}\u{641}\u{634}\u{627} \u{6A9}\u{648}\u{644}\u{648} (\u{634}\u{631}\u{6CC}\u{6A9}\u{648}\u{644}) \u{62F} \u{62A}\u{693}\u{648}\u{646} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689}.`,
    pt: `Um registro de um acordo para coletar, acessar, usar ou divulgar (compartilhar) informa\xe7\xf5es.`,
    'pt-pt': `Um registo de um acordo para recolher, aceder, utilizar ou divulgar (partilhar) informa\xe7\xe3o.`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{448}\u{435}\u{43D}\u{438}\u{44F} \u{43E} \u{441}\u{431}\u{43E}\u{440}\u{435}, \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{435}, \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{438} \u{438}\u{43B}\u{438} \u{440}\u{430}\u{441}\u{43A}\u{440}\u{44B}\u{442}\u{438}\u{438} (\u{440}\u{430}\u{441}\u{43F}\u{440}\u{43E}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{438}\u{438}) \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{438}.`,
    sm: `O se fa'amaumauga o se maliega e aoina, fa'aaogaina, fa'aaoga pe fa'aalia (fa'asoa) fa'amatalaga.`,
    so: `Diiwaanka heshiis lagu ururinayo, gelina, isticmaalka ama la shaacinayo (wadaagista) macluumaadka.`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E02}\u{E49}\u{E2D}\u{E15}\u{E01}\u{E25}\u{E07}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E40}\u{E01}\u{E47}\u{E1A}\u{E23}\u{E27}\u{E1A}\u{E23}\u{E27}\u{E21} \u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07} \u{E43}\u{E0A}\u{E49} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E1B}\u{E34}\u{E14}\u{E40}\u{E1C}\u{E22} (\u{E41}\u{E1A}\u{E48}\u{E07}\u{E1B}\u{E31}\u{E19}) \u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}`,
    ur: `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{646}\u{6D2}\u{60C} \u{631}\u{633}\u{627}\u{626}\u{6CC}\u{60C} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{6CC}\u{627} \u{638}\u{627}\u{6C1}\u{631} \u{6A9}\u{631}\u{646}\u{6D2} (\u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9}) \u{6A9}\u{6D2} \u{645}\u{639}\u{627}\u{6C1}\u{62F}\u{6D2} \u{6A9}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688}\u{6D4}`,
    vi: `H\u{1ED3} s\u{1A1} v\u{1EC1} th\u{1ECF}a thu\u{1EAD}n thu th\u{1EAD}p, truy c\u{1EAD}p, s\u{1EED} d\u{1EE5}ng ho\u{1EB7}c ti\u{1EBF}t l\u{1ED9} (chia s\u{1EBB}) th\xf4ng tin.`,
    'zh-hans': `\u{4E00}\u{4EFD}\u{5173}\u{4E8E}\u{6536}\u{96C6}\u{3001}\u{8BBF}\u{95EE}\u{3001}\u{4F7F}\u{7528}\u{6216}\u{62AB}\u{9732}\u{FF08}\u{5171}\u{4EAB}\u{FF09}\u{4FE1}\u{606F}\u{534F}\u{8BAE}\u{7684}\u{8BB0}\u{5F55}\u{3002}`,
    'zh-hant': `\u{4E00}\u{4EFD}\u{95DC}\u{65BC}\u{6536}\u{96C6}\u{3001}\u{5B58}\u{53D6}\u{3001}\u{4F7F}\u{7528}\u{6216}\u{63ED}\u{9732}\u{FF08}\u{5206}\u{4EAB}\u{FF09}\u{8CC7}\u{8A0A}\u{7684}\u{5354}\u{8B70}\u{7D00}\u{9304}\u{3002}`,
    en: `A record of an agreement to collect, access, use or disclose (share) information.`
};
const $b11db1b62d4a8f76$export$1f61287e5d30e3cf = {
    ar: `\u{627}\u{644}\u{644}\u{642}\u{627}\u{621}`,
    de: `Begegnung`,
    es: `Encuentro`,
    fa: `\u{628}\u{631}\u{62E}\u{648}\u{631}\u{62F}`,
    fil: `Tagpo`,
    fr: `Rencontre`,
    hi: `\u{92E}\u{941}\u{920}\u{92D}\u{947}\u{95C}`,
    ht: `Rankont`,
    it: `Incontro`,
    ja: `\u{906D}\u{9047}`,
    ko: `\u{B9CC}\u{B0A8}`,
    mww: `ntsib`,
    ps: `\u{645}\u{62E}\u{627}\u{645}\u{62E} \u{6A9}\u{6D0}\u{62F}\u{644}`,
    pt: `Encontro`,
    'pt-pt': `Encontro`,
    ru: `\u{412}\u{441}\u{442}\u{440}\u{435}\u{447}\u{430}`,
    sm: `Feiloa'iga`,
    so: `Kulanka`,
    th: `\u{E01}\u{E32}\u{E23}\u{E40}\u{E1C}\u{E0A}\u{E34}\u{E0D}\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: `\u{645}\u{644}\u{627}\u{642}\u{627}\u{62A}`,
    vi: `G\u{1EB7}p g\u{1EE1}`,
    'zh-hans': `\u{906D}\u{9047}`,
    'zh-hant': `\u{906D}\u{9047}`,
    en: `Encounter`
};
const $b11db1b62d4a8f76$export$aac1b84c33b9a082 = {
    ar: `\u{62A}\u{641}\u{627}\u{639}\u{644} \u{628}\u{64A}\u{646} \u{627}\u{644}\u{645}\u{631}\u{64A}\u{636} \u{648}\u{645}\u{642}\u{62F}\u{645} \u{627}\u{644}\u{631}\u{639}\u{627}\u{64A}\u{629} \u{627}\u{644}\u{635}\u{62D}\u{64A}\u{629} \u{644}\u{63A}\u{631}\u{636} \u{62A}\u{642}\u{62F}\u{64A}\u{645} \u{62E}\u{62F}\u{645}\u{627}\u{62A} \u{635}\u{62D}\u{64A}\u{629} \u{623}\u{648} \u{62A}\u{642}\u{64A}\u{64A}\u{645} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{629} \u{627}\u{644}\u{635}\u{62D}\u{64A}\u{629} \u{644}\u{644}\u{645}\u{631}\u{64A}\u{636}.`,
    de: `Eine Interaktion zwischen einem Patienten und Gesundheitsdienstleistern mit dem Ziel, Gesundheitsdienstleistungen bereitzustellen oder den Gesundheitszustand eines Patienten zu bewerten.`,
    es: `Una interacci\xf3n entre un paciente y o(s) profesional(es) sanitario(s) con el prop\xf3sito de proporcionar o/s servicio(s) sanitario(s) o evaluar el estado de salud de un paciente.`,
    fa: `\u{62A}\u{639}\u{627}\u{645}\u{644} \u{628}\u{6CC}\u{646} \u{628}\u{6CC}\u{645}\u{627}\u{631} \u{648} \u{627}\u{631}\u{627}\u{626}\u{647} \u{62F}\u{647}\u{646}\u{62F}\u{647}(\u{647}\u{627}\u{6CC}) \u{645}\u{631}\u{627}\u{642}\u{628}\u{62A} \u{647}\u{627}\u{6CC} \u{628}\u{647}\u{62F}\u{627}\u{634}\u{62A}\u{6CC} \u{628}\u{647} \u{645}\u{646}\u{638}\u{648}\u{631} \u{627}\u{631}\u{627}\u{626}\u{647} \u{62E}\u{62F}\u{645}\u{627}\u{62A} \u{62F}\u{631}\u{645}\u{627}\u{646}\u{6CC} \u{6CC}\u{627} \u{627}\u{631}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{633}\u{644}\u{627}\u{645}\u{62A} \u{628}\u{6CC}\u{645}\u{627}\u{631}.`,
    fil: `Isang pakikipag-ugnayan sa pagitan ng isang pasyente at (mga) tagapagbigay ng pangangalagang pangkalusugan para sa layunin ng pagbibigay ng (mga) serbisyo sa pangangalagang pangkalusugan o pagtatasa ng katayuan sa kalusugan ng isang pasyente.`,
    fr: `Une interaction entre un patient et un ou plusieurs prestataires de soins de sant\xe9 dans le but de fournir un ou plusieurs services de sant\xe9 ou d\u{2019}\xe9valuer l\u{2019}\xe9tat de sant\xe9 d\u{2019}un patient.`,
    hi: `\u{938}\u{94D}\u{935}\u{93E}\u{938}\u{94D}\u{925}\u{94D}\u{92F} \u{938}\u{947}\u{935}\u{93E} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{928} \u{915}\u{930}\u{928}\u{947} \u{92F}\u{93E} \u{930}\u{94B}\u{917}\u{940} \u{915}\u{940} \u{938}\u{94D}\u{935}\u{93E}\u{938}\u{94D}\u{925}\u{94D}\u{92F} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{915}\u{93E} \u{906}\u{915}\u{932}\u{928} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{909}\u{926}\u{94D}\u{926}\u{947}\u{936}\u{94D}\u{92F} \u{938}\u{947} \u{930}\u{94B}\u{917}\u{940} \u{914}\u{930} \u{938}\u{94D}\u{935}\u{93E}\u{938}\u{94D}\u{925}\u{94D}\u{92F} \u{938}\u{947}\u{935}\u{93E} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{924}\u{93E} (\u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{924}\u{93E}\u{913}\u{902}) \u{915}\u{947} \u{92C}\u{940}\u{91A} \u{92C}\u{93E}\u{924}\u{91A}\u{940}\u{924}\u{964}`,
    ht: `Yon ent\xe8raksyon ant yon pasyan ak founis\xe8 swen sante (yo) nan bi pou yo bay s\xe8vis (yo) swen sante (yo) oswa evalye eta sante yon pasyan.`,
    it: `Un'interazione tra un paziente e un operatore sanitario al fine di fornire un servizio sanitario o di valutare lo stato di salute di un paziente.`,
    ja: `\u{60A3}\u{8005}\u{3068}\u{533B}\u{7642}\u{63D0}\u{4F9B}\u{8005}\u{306E}\u{9593}\u{3067}\u{3001}\u{533B}\u{7642}\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{306E}\u{63D0}\u{4F9B}\u{3084}\u{60A3}\u{8005}\u{306E}\u{5065}\u{5EB7}\u{72B6}\u{614B}\u{3092}\u{8A55}\u{4FA1}\u{3059}\u{308B}\u{305F}\u{3081}\u{306E}\u{3084}\u{308A}\u{53D6}\u{308A}\u{3002}`,
    ko: `\u{D658}\u{C790}\u{C640} \u{C758}\u{B8CC} \u{C81C}\u{ACF5}\u{C790} \u{AC04}\u{C758} \u{C0C1}\u{D638}\u{C791}\u{C6A9}\u{C744} \u{C758}\u{BBF8}\u{D558}\u{BA70}, \u{C758}\u{B8CC} \u{C11C}\u{BE44}\u{C2A4}\u{B97C} \u{C81C}\u{ACF5}\u{D558}\u{AC70}\u{B098} \u{D658}\u{C790}\u{C758} \u{AC74}\u{AC15} \u{C0C1}\u{D0DC}\u{B97C} \u{D3C9}\u{AC00}\u{D558}\u{AE30} \u{C704}\u{D55C} \u{AC83}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib qho kev sib cuam tshuam ntawm tus neeg mob thiab tus neeg saib xyuas kev noj qab haus huv rau lub hom phiaj ntawm kev muab kev pabcuam (cov) kev noj qab haus huv lossis ntsuas qhov kev noj qab haus huv ntawm tus neeg mob.`,
    ps: `\u{62F} \u{646}\u{627}\u{631}\u{648}\u{63A} \u{627}\u{648} \u{631}\u{648}\u{63A}\u{62A}\u{6CC}\u{627}\u{6CC}\u{6CC} \u{62E}\u{62F}\u{645}\u{627}\u{62A}\u{648} \u{648}\u{693}\u{627}\u{646}\u{62F}\u{6D0} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}(\u{648}\u{646}\u{648}) \u{62A}\u{631}\u{645}\u{646}\u{681} \u{62A}\u{639}\u{627}\u{645}\u{644}\u{60C} \u{62F} \u{631}\u{648}\u{63A}\u{62A}\u{6CC}\u{627}\u{6CC}\u{6CC} \u{62E}\u{62F}\u{645}\u{62A}\u{648}\u{646}\u{648} \u{648}\u{693}\u{627}\u{646}\u{62F}\u{6D0} \u{6A9}\u{648}\u{644}\u{648} \u{6CC}\u{627} \u{62F} \u{646}\u{627}\u{631}\u{648}\u{63A} \u{62F} \u{631}\u{648}\u{63A}\u{62A}\u{6CC}\u{627} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{627}\u{631}\u{632}\u{648}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647}.`,
    pt: `Uma intera\xe7\xe3o entre um paciente e o(s) provedor(es) de sa\xfade(s) com o objetivo de fornecer o(s) servi\xe7o(s) de sa\xfade ou avaliar o estado de sa\xfade de um paciente.`,
    'pt-pt': `Uma intera\xe7\xe3o entre um paciente e o(s) prestador(es) de cuidados de sa\xfade com o objetivo de prestar o(s) servi\xe7o(s) de sa\xfade ou avaliar o estado de sa\xfade de um paciente.`,
    ru: `\u{412}\u{437}\u{430}\u{438}\u{43C}\u{43E}\u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435} \u{43C}\u{435}\u{436}\u{434}\u{443} \u{43F}\u{430}\u{446}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{43C} \u{438} \u{43C}\u{435}\u{434}\u{438}\u{446}\u{438}\u{43D}\u{441}\u{43A}\u{438}\u{43C} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43D}\u{438}\u{43A}\u{43E}\u{43C}(\u{430}\u{43C}\u{438}) \u{441} \u{446}\u{435}\u{43B}\u{44C}\u{44E} \u{43F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{43C}\u{435}\u{434}\u{438}\u{446}\u{438}\u{43D}\u{441}\u{43A}\u{438}\u{445} \u{443}\u{441}\u{43B}\u{443}\u{433} \u{438}\u{43B}\u{438} \u{43E}\u{446}\u{435}\u{43D}\u{43A}\u{438} \u{441}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{44F} \u{437}\u{434}\u{43E}\u{440}\u{43E}\u{432}\u{44C}\u{44F} \u{43F}\u{430}\u{446}\u{438}\u{435}\u{43D}\u{442}\u{430}.`,
    sm: `O se fegalegaleaiga i le va o se tagata ma'i ma le tausi soifua maloloina mo le fa'amoemoe o le tu'uina atu o auaunaga tau soifua maloloina po'o le iloiloina o le tulaga o le soifua maloloina o se tagata ma'i.`,
    so: `Is-dhexgal u dhexeeya bukaanka iyo bixiyeyaasha daryeelka caafimaadka si loo bixiyo adeegyo caafimaad ama qiimeyn xaaladda caafimaad ee bukaanka.`,
    th: `\u{E1B}\u{E0F}\u{E34}\u{E2A}\u{E31}\u{E21}\u{E1E}\u{E31}\u{E19}\u{E18}\u{E4C}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07}\u{E1C}\u{E39}\u{E49}\u{E1B}\u{E48}\u{E27}\u{E22}\u{E41}\u{E25}\u{E30}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E2B}\u{E49}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}\u{E14}\u{E49}\u{E32}\u{E19}\u{E01}\u{E32}\u{E23}\u{E14}\u{E39}\u{E41}\u{E25}\u{E2A}\u{E38}\u{E02}\u{E20}\u{E32}\u{E1E}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E27}\u{E31}\u{E15}\u{E16}\u{E38}\u{E1B}\u{E23}\u{E30}\u{E2A}\u{E07}\u{E04}\u{E4C}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E43}\u{E2B}\u{E49}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}\u{E14}\u{E49}\u{E32}\u{E19}\u{E2A}\u{E38}\u{E02}\u{E20}\u{E32}\u{E1E}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E21}\u{E34}\u{E19}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E2A}\u{E38}\u{E02}\u{E20}\u{E32}\u{E1E}\u{E02}\u{E2D}\u{E07}\u{E1C}\u{E39}\u{E49}\u{E1B}\u{E48}\u{E27}\u{E22}`,
    ur: `\u{645}\u{631}\u{6CC}\u{636} \u{627}\u{648}\u{631} \u{635}\u{62D}\u{62A} \u{6A9}\u{6CC} \u{62F}\u{6CC}\u{6A9}\u{6BE} \u{628}\u{6BE}\u{627}\u{644} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{631}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{6A9}\u{6D2} \u{62F}\u{631}\u{645}\u{6CC}\u{627}\u{646} \u{627}\u{6CC}\u{6A9} \u{62A}\u{639}\u{627}\u{645}\u{644}\u{60C} \u{635}\u{62D}\u{62A} \u{6A9}\u{6CC} \u{62E}\u{62F}\u{645}\u{627}\u{62A} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{631}\u{646}\u{6D2} \u{6CC}\u{627} \u{645}\u{631}\u{6CC}\u{636} \u{6A9}\u{6CC} \u{635}\u{62D}\u{62A} \u{6A9}\u{6CC} \u{62D}\u{627}\u{644}\u{62A} \u{6A9}\u{627} \u{62C}\u{627}\u{626}\u{632}\u{6C1} \u{644}\u{6CC}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2}\u{6D4}`,
    vi: `T\u{1B0}\u{1A1}ng t\xe1c gi\u{1EEF}a b\u{1EC7}nh nh\xe2n v\xe0 (c\xe1c) nh\xe0 cung c\u{1EA5}p d\u{1ECB}ch v\u{1EE5} ch\u{103}m s\xf3c s\u{1EE9}c kh\u{1ECF}e nh\u{1EB1}m m\u{1EE5}c \u{111}\xedch cung c\u{1EA5}p (c\xe1c) d\u{1ECB}ch v\u{1EE5} ch\u{103}m s\xf3c s\u{1EE9}c kh\u{1ECF}e ho\u{1EB7}c \u{111}\xe1nh gi\xe1 t\xecnh tr\u{1EA1}ng s\u{1EE9}c kh\u{1ECF}e c\u{1EE7}a b\u{1EC7}nh nh\xe2n.`,
    'zh-hans': `\u{60A3}\u{8005}\u{4E0E}\u{533B}\u{7597}\u{670D}\u{52A1}\u{63D0}\u{4F9B}\u{8005}\u{4E4B}\u{95F4}\u{7684}\u{4E92}\u{52A8}\u{FF0C}\u{76EE}\u{7684}\u{662F}\u{63D0}\u{4F9B}\u{533B}\u{7597}\u{670D}\u{52A1}\u{6216}\u{8BC4}\u{4F30}\u{60A3}\u{8005}\u{7684}\u{5065}\u{5EB7}\u{72B6}\u{51B5}\u{3002}`,
    'zh-hant': `\u{60A3}\u{8005}\u{8207}\u{91AB}\u{7642}\u{63D0}\u{4F9B}\u{8005}\u{4E4B}\u{9593}\u{7684}\u{4E92}\u{52D5}\u{FF0C}\u{76EE}\u{7684}\u{662F}\u{63D0}\u{4F9B}\u{91AB}\u{7642}\u{670D}\u{52D9}\u{6216}\u{8A55}\u{4F30}\u{60A3}\u{8005}\u{7684}\u{5065}\u{5EB7}\u{72C0}\u{6CC1}\u{3002}`,
    en: `An interaction between a patient and healthcare provider(s) for the purpose of providing healthcare service(s) or assessing the health status of a patient.`
};
const $b11db1b62d4a8f76$export$9ea0062ee8a62693 = {
    ar: `\u{62D}\u{644}\u{642}\u{629} \u{627}\u{644}\u{631}\u{639}\u{627}\u{64A}\u{629}`,
    de: `Pflegeepisode`,
    es: `Episodio de atenci\xf3n`,
    fa: `\u{62F}\u{648}\u{631}\u{647} \u{645}\u{631}\u{627}\u{642}\u{628}\u{62A}`,
    fil: `Episode ng pangangalaga`,
    fr: `\xc9pisode de soins`,
    hi: `\u{926}\u{947}\u{916}\u{92D}\u{93E}\u{932} \u{915}\u{93E} \u{90F}\u{92A}\u{93F}\u{938}\u{94B}\u{921}`,
    ht: `Episode nan swen`,
    it: `Episodio di cura`,
    ja: `\u{30B1}\u{30A2}\u{306E}\u{30A8}\u{30D4}\u{30BD}\u{30FC}\u{30C9}`,
    ko: `\u{B3CC}\u{BD04} \u{C5D0}\u{D53C}\u{C18C}\u{B4DC}`,
    mww: `Tshooj ntawm kev saib xyuas`,
    ps: `\u{62F} \u{67E}\u{627}\u{645}\u{644}\u{631}\u{646}\u{6D0} \u{628}\u{631}\u{62E}\u{647}`,
    pt: `Epis\xf3dio de cuidado`,
    'pt-pt': `Epis\xf3dio de cuidados`,
    ru: `\u{42D}\u{43F}\u{438}\u{437}\u{43E}\u{434} \u{443}\u{445}\u{43E}\u{434}\u{430}`,
    sm: `Vaega o le tausiga`,
    so: `Qaybta daryeelka`,
    th: `\u{E15}\u{E2D}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E14}\u{E39}\u{E41}\u{E25}`,
    ur: `\u{62F}\u{6CC}\u{6A9}\u{6BE} \u{628}\u{6BE}\u{627}\u{644} \u{6A9}\u{627} \u{648}\u{627}\u{642}\u{639}\u{6C1}`,
    vi: `Giai \u{111}o\u{1EA1}n ch\u{103}m s\xf3c`,
    'zh-hans': `\u{62A4}\u{7406}\u{53D1}\u{4F5C}`,
    'zh-hant': `\u{7167}\u{8B77}\u{6642}\u{671F}`,
    en: `Episode of care`
};
const $b11db1b62d4a8f76$export$b1642650037543f = {
    ar: `\u{627}\u{631}\u{62A}\u{628}\u{627}\u{637} \u{628}\u{64A}\u{646} \u{627}\u{644}\u{645}\u{631}\u{64A}\u{636} \u{648}\u{645}\u{646}\u{638}\u{645}\u{629} / \u{645}\u{642}\u{62F}\u{645} \u{627}\u{644}\u{631}\u{639}\u{627}\u{64A}\u{629} \u{627}\u{644}\u{635}\u{62D}\u{64A}\u{629} \u{642}\u{62F} \u{62A}\u{62D}\u{62F}\u{62B} \u{62E}\u{644}\u{627}\u{644}\u{647}\u{627} \u{644}\u{642}\u{627}\u{621}\u{627}\u{62A}. \u{62A}\u{62A}\u{62D}\u{645}\u{644} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629} \u{627}\u{644}\u{625}\u{62F}\u{627}\u{631}\u{64A}\u{629} \u{645}\u{633}\u{62A}\u{648}\u{649} \u{645}\u{646} \u{627}\u{644}\u{645}\u{633}\u{624}\u{648}\u{644}\u{64A}\u{629} \u{62A}\u{62C}\u{627}\u{647} \u{627}\u{644}\u{645}\u{631}\u{64A}\u{636} \u{62E}\u{644}\u{627}\u{644} \u{647}\u{630}\u{647} \u{627}\u{644}\u{641}\u{62A}\u{631}\u{629}.`,
    de: `Eine Verbindung zwischen einem Patienten und einer Organisation bzw. medizinischen Fachkr\xe4ften, w\xe4hrend der Zeitr\xe4ume Begegnungen stattfinden k\xf6nnen. Die leitende Organisation \xfcbernimmt in dieser Zeit eine gewisse Verantwortung f\xfcr den Patienten.`,
    es: `Una asociaci\xf3n entre un paciente y una organizaci\xf3n o proveedor sanitario durante la cual pueden producirse encuentros. La organizaci\xf3n gestora asume un nivel de responsabilidad sobre el paciente durante este tiempo.`,
    fa: `\u{627}\u{631}\u{62A}\u{628}\u{627}\u{637}\u{6CC} \u{628}\u{6CC}\u{646} \u{6CC}\u{6A9} \u{628}\u{6CC}\u{645}\u{627}\u{631} \u{648} \u{6CC}\u{6A9} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} / \u{627}\u{631}\u{627}\u{626}\u{647} \u{62F}\u{647}\u{646}\u{62F}\u{647} \u{62E}\u{62F}\u{645}\u{627}\u{62A} \u{628}\u{647}\u{62F}\u{627}\u{634}\u{62A}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{622}\u{646} \u{645}\u{645}\u{6A9}\u{646} \u{627}\u{633}\u{62A} \u{628}\u{631}\u{62E}\u{648}\u{631}\u{62F}\u{647}\u{627}\u{6CC}\u{6CC} \u{631}\u{62E} \u{62F}\u{647}\u{62F}. \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{645}\u{62F}\u{6CC}\u{631}\u{6CC}\u{62A}\u{6CC} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{645}\u{62F}\u{62A} \u{633}\u{637}\u{62D}\u{6CC} \u{627}\u{632} \u{645}\u{633}\u{626}\u{648}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{646}\u{633}\u{628}\u{62A} \u{628}\u{647} \u{628}\u{6CC}\u{645}\u{627}\u{631} \u{628}\u{631} \u{639}\u{647}\u{62F}\u{647} \u{645}\u{6CC} \u{6AF}\u{6CC}\u{631}\u{62F}.`,
    fil: `Isang asosasyon sa pagitan ng isang pasyente at isang organisasyon / tagapagbigay ng pangangalagang pangkalusugan kung saan maaaring mangyari ang mga nakatagpo ng oras. Ang pamamahala ng organisasyon ay may antas ng responsibilidad para sa pasyente sa panahong ito.`,
    fr: `Une association entre un patient et une organisation / prestataire de soins de sant\xe9 durant laquelle des rencontres peuvent avoir lieu. L\u{2019}organisation gestionnaire assume un certain niveau de responsabilit\xe9 envers le patient durant cette p\xe9riode.`,
    hi: `\u{90F}\u{915} \u{930}\u{94B}\u{917}\u{940} \u{914}\u{930} \u{90F}\u{915} \u{938}\u{902}\u{917}\u{920}\u{928}/\u{938}\u{94D}\u{935}\u{93E}\u{938}\u{94D}\u{925}\u{94D}\u{92F} \u{938}\u{947}\u{935}\u{93E} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{924}\u{93E} (\u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{924}\u{93E}\u{913}\u{902}) \u{915}\u{947} \u{92C}\u{940}\u{91A} \u{90F}\u{915} \u{938}\u{902}\u{92C}\u{902}\u{927} \u{91C}\u{93F}\u{938}\u{915}\u{947} \u{926}\u{94C}\u{930}\u{93E}\u{928} \u{92E}\u{941}\u{920}\u{92D}\u{947}\u{921}\u{93C} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{940} \u{939}\u{948}\u{964} \u{92A}\u{94D}\u{930}\u{92C}\u{902}\u{927} \u{938}\u{902}\u{917}\u{920}\u{928} \u{907}\u{938} \u{938}\u{92E}\u{92F} \u{915}\u{947} \u{926}\u{94C}\u{930}\u{93E}\u{928} \u{930}\u{94B}\u{917}\u{940} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{91C}\u{93F}\u{92E}\u{94D}\u{92E}\u{947}\u{926}\u{93E}\u{930}\u{940} \u{915}\u{93E} \u{90F}\u{915} \u{938}\u{94D}\u{924}\u{930} \u{92E}\u{93E}\u{928}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Yon asosyasyon ant yon pasyan ak yon \xf2ganizasyon / founis\xe8 swen sante (yo) pandan ki tan rankont ka rive. \xd2ganizasyon an jere sipoze yon nivo responsablite pou pasyan an pandan tan sa a.`,
    it: `Un'associazione tra un paziente e un'organizzazione / operatore sanitario durante la quale possono verificarsi incontri. L'organizzazione gestore assume un certo livello di responsabilit\xe0 per il paziente durante questo periodo.`,
    ja: `\u{60A3}\u{8005}\u{3068}\u{7D44}\u{7E54}\u{3084}\u{533B}\u{7642}\u{63D0}\u{4F9B}\u{8005}\u{3068}\u{306E}\u{9593}\u{306B}\u{3001}\u{63A5}\u{89E6}\u{304C}\u{884C}\u{308F}\u{308C}\u{308B}\u{53EF}\u{80FD}\u{6027}\u{306E}\u{3042}\u{308B}\u{95A2}\u{4FC2}\u{3002}\u{7BA1}\u{7406}\u{7D44}\u{7E54}\u{306F}\u{3053}\u{306E}\u{671F}\u{9593}\u{4E2D}\u{3001}\u{60A3}\u{8005}\u{306B}\u{5BFE}\u{3057}\u{3066}\u{4E00}\u{5B9A}\u{306E}\u{8CAC}\u{4EFB}\u{3092}\u{8CA0}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{D658}\u{C790}\u{C640} \u{C870}\u{C9C1} \u{B610}\u{B294} \u{C758}\u{B8CC} \u{C81C}\u{ACF5}\u{C790} \u{AC04}\u{C758} \u{C5F0}\u{AD00}\u{C131}\u{C73C}\u{B85C}, \u{ADF8} \u{AE30}\u{AC04} \u{B3D9}\u{C548} \u{B9CC}\u{B0A8}\u{C774} \u{BC1C}\u{C0DD}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}. \u{AD00}\u{B9AC} \u{C870}\u{C9C1}\u{C740} \u{C774} \u{AE30}\u{AC04} \u{B3D9}\u{C548} \u{D658}\u{C790}\u{C5D0} \u{B300}\u{D55C} \u{CC45}\u{C784}\u{C744} \u{C77C}\u{C815} \u{C218}\u{C900} \u{BD80}\u{B2F4}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Ib qho kev sib raug zoo ntawm tus neeg mob thiab ib lub koom haum / tus neeg saib xyuas kev noj qab haus huv thaum lub sijhawm yuav tshwm sim. Lub koom haum tswj hwm coj ib theem ntawm lub luag haujlwm rau tus neeg mob thaum lub sijhawm no.`,
    ps: `\u{62F} \u{646}\u{627}\u{631}\u{648}\u{63A} \u{627}\u{648} \u{6CC}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}/\u{631}\u{648}\u{63A}\u{62A}\u{6CC}\u{627}\u{6CC}\u{6CC} \u{686}\u{645}\u{62A}\u{648} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}(\u{648}\u{646}\u{648}) \u{62A}\u{631}\u{645}\u{646}\u{681} \u{627}\u{693}\u{6CC}\u{6A9}\u{647} \u{686}\u{6D0} \u{67E}\u{647} \u{62F}\u{6D0} \u{645}\u{648}\u{62F}\u{647} \u{6A9}\u{6D0} \u{645}\u{645}\u{6A9}\u{646}\u{647} \u{67E}\u{6D0}\u{69A}\u{6D0} \u{631}\u{627}\u{645}\u{646}\u{681}\u{62A}\u{647} \u{634}\u{6CC}. \u{62F} \u{645}\u{62F}\u{6CC}\u{631}\u{6CC}\u{62A} \u{627}\u{62F}\u{627}\u{631}\u{647} \u{67E}\u{647} \u{62F}\u{6D0} \u{645}\u{648}\u{62F}\u{647} \u{6A9}\u{6D0} \u{62F} \u{646}\u{627}\u{631}\u{648}\u{63A} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{6CC}\u{648}\u{647} \u{6A9}\u{686}\u{647} \u{645}\u{633}\u{624}\u{644}\u{6CC}\u{62A} \u{67E}\u{631} \u{63A}\u{627}\u{693}\u{647} \u{627}\u{62E}\u{644}\u{6CC}.`,
    pt: `Uma associa\xe7\xe3o entre um paciente e uma organiza\xe7\xe3o/prestador(es) de sa\xfade(s) durante a qual podem ocorrer encontros. A organiza\xe7\xe3o gestora assume um n\xedvel de responsabilidade pelo paciente durante esse per\xedodo.`,
    'pt-pt': `Uma associa\xe7\xe3o entre um paciente e uma organiza\xe7\xe3o / prestador(es) de cuidados de sa\xfade durante a qual podem ocorrer encontros. A organiza\xe7\xe3o gestora assume um certo n\xedvel de responsabilidade pelo paciente durante este per\xedodo.`,
    ru: `\u{410}\u{441}\u{441}\u{43E}\u{446}\u{438}\u{430}\u{446}\u{438}\u{44F} \u{43C}\u{435}\u{436}\u{434}\u{443} \u{43F}\u{430}\u{446}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{43C} \u{438} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{435}\u{439} / \u{43C}\u{435}\u{434}\u{438}\u{446}\u{438}\u{43D}\u{441}\u{43A}\u{438}\u{43C} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43D}\u{438}\u{43A}\u{43E}\u{43C}(\u{430}\u{43C}\u{438}), \u{432} \u{442}\u{435}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{445} \u{43C}\u{43E}\u{433}\u{443}\u{442} \u{43F}\u{440}\u{43E}\u{438}\u{441}\u{445}\u{43E}\u{434}\u{438}\u{442}\u{44C} \u{432}\u{441}\u{442}\u{440}\u{435}\u{447}\u{438}. \u{423}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{44F}\u{44E}\u{449}\u{430}\u{44F} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{431}\u{435}\u{440}\u{451}\u{442} \u{43D}\u{430} \u{441}\u{435}\u{431}\u{44F} \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{451}\u{43D}\u{43D}\u{44B}\u{439} \u{443}\u{440}\u{43E}\u{432}\u{435}\u{43D}\u{44C} \u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{437}\u{430} \u{43F}\u{430}\u{446}\u{438}\u{435}\u{43D}\u{442}\u{430} \u{432} \u{44D}\u{442}\u{43E}\u{442} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}.`,
    sm: `O se feso'ota'iga i le va o se tagata ma'i ma se fa'alapotopotoga / tausi soifua maloloina (s) i le taimi e ono tupu ai feiloaiga. O le fa'alapotopotoga fa'atautaia o lo'o i ai se tulaga o le tiutetauave mo le tagata ma'i i lenei taimi.`,
    so: `Xiriir u dhexeeya bukaanka iyo hay'adda/bixiyaha daryeelka caafimaadka, muddadaas ay kulamo ka dhici karaan. Hay'adda maareynta ayaa qaadata heer mas'uuliyad u ah bukaanka inta lagu jiro waqtigan.`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E2A}\u{E31}\u{E21}\u{E1E}\u{E31}\u{E19}\u{E18}\u{E4C}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07}\u{E1C}\u{E39}\u{E49}\u{E1B}\u{E48}\u{E27}\u{E22}\u{E01}\u{E31}\u{E1A}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23} / \u{E1C}\u{E39}\u{E49}\u{E43}\u{E2B}\u{E49}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}\u{E14}\u{E49}\u{E32}\u{E19}\u{E01}\u{E32}\u{E23}\u{E14}\u{E39}\u{E41}\u{E25}\u{E2A}\u{E38}\u{E02}\u{E20}\u{E32}\u{E1E}\u{E43}\u{E19}\u{E0A}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E32}\u{E08}\u{E40}\u{E01}\u{E34}\u{E14}\u{E01}\u{E32}\u{E23}\u{E40}\u{E1C}\u{E0A}\u{E34}\u{E0D}\u{E2B}\u{E19}\u{E49}\u{E32} \u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E08}\u{E31}\u{E14}\u{E01}\u{E32}\u{E23}\u{E16}\u{E37}\u{E2D}\u{E27}\u{E48}\u{E32}\u{E21}\u{E35}\u{E04}\u{E27}\u{E32}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E1C}\u{E34}\u{E14}\u{E0A}\u{E2D}\u{E1A}\u{E15}\u{E48}\u{E2D}\u{E1C}\u{E39}\u{E49}\u{E1B}\u{E48}\u{E27}\u{E22}\u{E43}\u{E19}\u{E0A}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{645}\u{631}\u{6CC}\u{636} \u{627}\u{648}\u{631} \u{627}\u{6CC}\u{6A9} \u{62A}\u{646}\u{638}\u{6CC}\u{645}/\u{635}\u{62D}\u{62A} \u{6A9}\u{6CC} \u{62F}\u{6CC}\u{6A9}\u{6BE} \u{628}\u{6BE}\u{627}\u{644} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{646}\u{646}\u{62F}\u{6C1}(\u{632}) \u{6A9}\u{6D2} \u{62F}\u{631}\u{645}\u{6CC}\u{627}\u{646} \u{627}\u{6CC}\u{6A9} \u{62A}\u{639}\u{644}\u{642} \u{62C}\u{633} \u{62F}\u{648}\u{631}\u{627}\u{646} \u{645}\u{644}\u{627}\u{642}\u{627}\u{62A}\u{6CC}\u{6BA} \u{6C1}\u{648} \u{633}\u{6A9}\u{62A}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{645}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{627}\u{633} \u{62F}\u{648}\u{631}\u{627}\u{646} \u{645}\u{631}\u{6CC}\u{636} \u{6A9}\u{6CC} \u{627}\u{6CC}\u{6A9} \u{633}\u{637}\u{62D} \u{6A9}\u{6CC} \u{630}\u{645}\u{6C1} \u{62F}\u{627}\u{631}\u{6CC} \u{633}\u{646}\u{628}\u{6BE}\u{627}\u{644}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED1}i li\xean h\u{1EC7} gi\u{1EEF}a b\u{1EC7}nh nh\xe2n v\xe0 (c\xe1c) t\u{1ED5} ch\u{1EE9}c / nh\xe0 cung c\u{1EA5}p d\u{1ECB}ch v\u{1EE5} ch\u{103}m s\xf3c s\u{1EE9}c kh\u{1ECF}e trong th\u{1EDD}i gian \u{111}\xf3 c\xf3 th\u{1EC3} x\u{1EA3}y ra c\xe1c cu\u{1ED9}c g\u{1EB7}p g\u{1EE1}. T\u{1ED5} ch\u{1EE9}c qu\u{1EA3}n l\xfd \u{111}\u{1EA3}m nh\u{1EAD}n m\u{1ED9}t m\u{1EE9}c \u{111}\u{1ED9} tr\xe1ch nhi\u{1EC7}m \u{111}\u{1ED1}i v\u{1EDB}i b\u{1EC7}nh nh\xe2n trong th\u{1EDD}i gian n\xe0y.`,
    'zh-hans': `\u{60A3}\u{8005}\u{4E0E}\u{7EC4}\u{7EC7}/\u{533B}\u{7597}\u{670D}\u{52A1}\u{63D0}\u{4F9B}\u{8005}\u{4E4B}\u{95F4}\u{7684}\u{5173}\u{8054}\u{FF0C}\u{5728}\u{6B64}\u{671F}\u{95F4}\u{53EF}\u{80FD}\u{4F1A}\u{53D1}\u{751F}\u{63A5}\u{89E6}\u{3002}\u{7BA1}\u{7406}\u{673A}\u{6784}\u{5728}\u{6B64}\u{671F}\u{95F4}\u{627F}\u{62C5}\u{60A3}\u{8005}\u{4E00}\u{5B9A}\u{7684}\u{8D23}\u{4EFB}\u{3002}`,
    'zh-hant': `\u{6307}\u{60A3}\u{8005}\u{8207}\u{7D44}\u{7E54}/\u{91AB}\u{7642}\u{63D0}\u{4F9B}\u{8005}\u{4E4B}\u{9593}\u{7684}\u{95DC}\u{806F}\u{FF0C}\u{671F}\u{9593}\u{53EF}\u{80FD}\u{6703}\u{767C}\u{751F}\u{63A5}\u{89F8}\u{3002}\u{7BA1}\u{7406}\u{7D44}\u{7E54}\u{5728}\u{6B64}\u{671F}\u{9593}\u{5C0D}\u{75C5}\u{60A3}\u{627F}\u{64D4}\u{4E00}\u{5B9A}\u{8CAC}\u{4EFB}\u{3002}`,
    en: `An association between a patient and an organization / healthcare provider(s) during which time encounters may occur. The managing organization assumes a level of responsibility for the patient during this time.`
};
const $b11db1b62d4a8f76$export$375f6e4643646315 = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646}`,
    de: `Fragebogen`,
    es: `Cuestionario`,
    fa: `\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647}`,
    fil: `Talatanungan`,
    fr: `Questionnaire`,
    hi: `\u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{200D}\u{928}\u{93E}\u{935}\u{932}\u{940}`,
    ht: `Kesyon\xe8`,
    it: `Questionario`,
    ja: `\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}`,
    ko: `\u{C124}\u{BB38}\u{C9C0}`,
    mww: `Cov lus nug`,
    ps: `\u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9}`,
    pt: `Question\xe1rio`,
    'pt-pt': `Question\xe1rio`,
    ru: `\u{410}\u{43D}\u{43A}\u{435}\u{442}\u{430}`,
    sm: `Fesili`,
    so: `Su'aalo`,
    th: `\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}`,
    ur: `\u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6C1}`,
    vi: `B\u{1EA3}ng c\xe2u h\u{1ECF}i`,
    'zh-hans': `\u{95EE}\u{5377}`,
    'zh-hant': `\u{554F}\u{5377}`,
    en: `Questionnaire`
};
const $b11db1b62d4a8f76$export$a9202f9fc8a3c137 = {
    ar: `\u{645}\u{62C}\u{645}\u{648}\u{639}\u{629} \u{645}\u{646}\u{638}\u{645}\u{629} \u{645}\u{646} \u{627}\u{644}\u{623}\u{633}\u{626}\u{644}\u{629} \u{627}\u{644}\u{645}\u{62A}\u{639}\u{644}\u{642}\u{629} \u{628}\u{627}\u{644}\u{639}\u{645}\u{64A}\u{644}\u{60C} \u{62A}\u{647}\u{62F}\u{641} \u{625}\u{644}\u{649} \u{62A}\u{648}\u{62C}\u{64A}\u{647} \u{62C}\u{645}\u{639} \u{627}\u{644}\u{625}\u{62C}\u{627}\u{628}\u{627}\u{62A} \u{645}\u{646} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}\u{64A}\u{646} \u{627}\u{644}\u{646}\u{647}\u{627}\u{626}\u{64A}\u{64A}\u{646}.`,
    de: `Ein strukturierter Satz von Fragen zu einem Kunden, der die Sammlung von Antworten von Endnutzern leiten soll.`,
    es: `Un conjunto estructurado de preguntas relacionadas con un cliente, destinado a guiar la recopilaci\xf3n de respuestas de los usuarios finales.`,
    fa: `\u{645}\u{62C}\u{645}\u{648}\u{639}\u{647} \u{627}\u{6CC} \u{633}\u{627}\u{62E}\u{62A}\u{627}\u{631}\u{6CC}\u{627}\u{641}\u{62A}\u{647} \u{627}\u{632} \u{633}\u{648}\u{627}\u{644}\u{627}\u{62A} \u{645}\u{631}\u{62A}\u{628}\u{637} \u{628}\u{627} \u{6CC}\u{6A9} \u{645}\u{634}\u{62A}\u{631}\u{6CC}\u{60C} \u{6A9}\u{647} \u{647}\u{62F}\u{641} \u{622}\u{646} \u{647}\u{62F}\u{627}\u{6CC}\u{62A} \u{62C}\u{645}\u{639} \u{622}\u{648}\u{631}\u{6CC} \u{67E}\u{627}\u{633}\u{62E} \u{647}\u{627} \u{627}\u{632} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{627}\u{646} \u{646}\u{647}\u{627}\u{6CC}\u{6CC} \u{627}\u{633}\u{62A}.`,
    fil: `Isang nakabalangkas na hanay ng mga katanungan na may kaugnayan sa isang kliyente, na inilaan upang gabayan ang koleksyon ng mga sagot mula sa mga end-user.`,
    fr: `Un ensemble structur\xe9 de questions li\xe9es \xe0 un client, destin\xe9 \xe0 guider la collecte des r\xe9ponses des utilisateurs finaux.`,
    hi: `\u{90F}\u{915} \u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915} \u{938}\u{947} \u{938}\u{902}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{94B}\u{902} \u{915}\u{93E} \u{90F}\u{915} \u{938}\u{902}\u{930}\u{91A}\u{93F}\u{924} \u{938}\u{947}\u{91F}, \u{91C}\u{93F}\u{938}\u{915}\u{93E} \u{909}\u{926}\u{94D}\u{926}\u{947}\u{936}\u{94D}\u{92F} \u{905}\u{902}\u{924}\u{93F}\u{92E} \u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E}\u{913}\u{902} \u{938}\u{947} \u{909}\u{924}\u{94D}\u{924}\u{930}\u{94B}\u{902} \u{915}\u{947} \u{938}\u{902}\u{917}\u{94D}\u{930}\u{939} \u{915}\u{93E} \u{92E}\u{93E}\u{930}\u{94D}\u{917}\u{926}\u{930}\u{94D}\u{936}\u{928} \u{915}\u{930}\u{928}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Yon seri estriktire nan kesyon ki gen rap\xf2 ak yon kliyan, gen entansyon gide koleksyon an nan repons soti nan itilizat\xe8 fen.`,
    it: `Un insieme strutturato di domande relative a un cliente, pensato per guidare la raccolta delle risposte degli utenti finali.`,
    ja: `\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}\u{306B}\u{95A2}\u{9023}\u{3059}\u{308B}\u{69CB}\u{9020}\u{5316}\u{3055}\u{308C}\u{305F}\u{8CEA}\u{554F}\u{306E}\u{30BB}\u{30C3}\u{30C8}\u{3067}\u{3001}\u{30A8}\u{30F3}\u{30C9}\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{304B}\u{3089}\u{306E}\u{56DE}\u{7B54}\u{53CE}\u{96C6}\u{3092}\u{5C0E}\u{304F}\u{3053}\u{3068}\u{3092}\u{76EE}\u{7684}\u{3068}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{D074}\u{B77C}\u{C774}\u{C5B8}\u{D2B8}\u{C640} \u{AD00}\u{B828}\u{B41C} \u{AD6C}\u{C870}\u{D654}\u{B41C} \u{C9C8}\u{BB38} \u{C9D1}\u{D569}\u{C73C}\u{B85C}, \u{CD5C}\u{C885} \u{C0AC}\u{C6A9}\u{C790}\u{B85C}\u{BD80}\u{D130} \u{B2F5}\u{BCC0}\u{C744} \u{C218}\u{C9D1}\u{D558}\u{B294} \u{AC83}\u{C744} \u{C548}\u{B0B4}\u{D558}\u{AE30} \u{C704}\u{D55C} \u{AC83}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib qho txheej txheem ntawm cov lus nug ntsig txog tus neeg siv khoom, npaj los coj kev sau cov lus teb los ntawm cov neeg siv kawg.`,
    ps: `\u{62F} \u{6A9}\u{644}\u{627}\u{6CC}\u{646}\u{67C} \u{627}\u{693}\u{648}\u{646}\u{62F} \u{6CC}\u{648} \u{645}\u{646}\u{638}\u{645} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{648} \u{67C}\u{648}\u{644}\u{6AB}\u{647}\u{60C} \u{686}\u{6D0} \u{647}\u{62F}\u{641} \u{6CC}\u{6D0} \u{62F} \u{67E}\u{627}\u{6CC} \u{6A9}\u{627}\u{631}\u{648}\u{648}\u{646}\u{6A9}\u{648} \u{685}\u{62E}\u{647} \u{62F} \u{681}\u{648}\u{627}\u{628}\u{648}\u{646}\u{648} \u{631}\u{627}\u{67C}\u{648}\u{644}\u{648}\u{644}\u{648} \u{644}\u{627}\u{631}\u{69A}\u{648}\u{648}\u{646}\u{647} \u{62F}\u{647}.`,
    pt: `Um conjunto estruturado de perguntas relacionadas a um cliente, destinado a guiar a coleta de respostas dos usu\xe1rios finais.`,
    'pt-pt': `Um conjunto estruturado de perguntas relacionadas com um cliente, destinado a orientar a recolha de respostas dos utilizadores finais.`,
    ru: `\u{421}\u{442}\u{440}\u{443}\u{43A}\u{442}\u{443}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{43D}\u{430}\u{431}\u{43E}\u{440} \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{43E}\u{432}, \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{43C}, \u{43F}\u{440}\u{435}\u{434}\u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{434}\u{43B}\u{44F} \u{440}\u{443}\u{43A}\u{43E}\u{432}\u{43E}\u{434}\u{441}\u{442}\u{432}\u{430} \u{441}\u{431}\u{43E}\u{440}\u{43E}\u{43C} \u{43E}\u{442}\u{432}\u{435}\u{442}\u{43E}\u{432} \u{43E}\u{442} \u{43A}\u{43E}\u{43D}\u{435}\u{447}\u{43D}\u{44B}\u{445} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{439}.`,
    sm: `O se seti fa'atulagaina o fesili e feso'ota'i ma se tagata fa'atau, fa'amoemoe e ta'ita'ia le aoina o tali mai tagata fa'aoga.`,
    so: `Waa su'aalo nidaamsan oo la xiriira macmiil, looguna talagalay in lagu hago ururinta jawaabaha ka yimaada isticmaaleyaasha dhammaadka.`,
    th: `\u{E0A}\u{E38}\u{E14}\u{E04}\u{E4D}\u{E32}\u{E16}\u{E32}\u{E21}\u{E17}\u{E35}\u{E48}\u{E21}\u{E35}\u{E42}\u{E04}\u{E23}\u{E07}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E25}\u{E39}\u{E01}\u{E04}\u{E49}\u{E32} \u{E0B}\u{E36}\u{E48}\u{E07}\u{E21}\u{E35}\u{E08}\u{E38}\u{E14}\u{E1B}\u{E23}\u{E30}\u{E2A}\u{E07}\u{E04}\u{E4C}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E41}\u{E19}\u{E27}\u{E17}\u{E32}\u{E07}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E23}\u{E27}\u{E1A}\u{E23}\u{E27}\u{E21}\u{E04}\u{E4D}\u{E32}\u{E15}\u{E2D}\u{E1A}\u{E08}\u{E32}\u{E01}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E1B}\u{E25}\u{E32}\u{E22}\u{E17}\u{E32}\u{E07}`,
    ur: `\u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679} \u{633}\u{6D2} \u{645}\u{62A}\u{639}\u{644}\u{642} \u{627}\u{6CC}\u{6A9} \u{645}\u{646}\u{638}\u{645} \u{633}\u{648}\u{627}\u{644}\u{627}\u{62A} \u{6A9}\u{627} \u{645}\u{62C}\u{645}\u{648}\u{639}\u{6C1}\u{60C} \u{62C}\u{633} \u{6A9}\u{627} \u{645}\u{642}\u{635}\u{62F} \u{635}\u{627}\u{631}\u{641}\u{6CC}\u{646} \u{633}\u{6D2} \u{62C}\u{648}\u{627}\u{628}\u{627}\u{62A} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{631}\u{6C1}\u{646}\u{645}\u{627}\u{626}\u{6CC} \u{6A9}\u{631}\u{646}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED9}t t\u{1EAD}p h\u{1EE3}p c\xe1c c\xe2u h\u{1ECF}i c\xf3 c\u{1EA5}u tr\xfac li\xean quan \u{111}\u{1EBF}n kh\xe1ch h\xe0ng, nh\u{1EB1}m h\u{1B0}\u{1EDB}ng d\u{1EAB}n thu th\u{1EAD}p c\xe2u tr\u{1EA3} l\u{1EDD}i t\u{1EEB} ng\u{1B0}\u{1EDD}i d\xf9ng cu\u{1ED1}i.`,
    'zh-hans': `\u{4E00}\u{7EC4}\u{7ED3}\u{6784}\u{5316}\u{7684}\u{95EE}\u{9898}\u{FF0C}\u{4E0E}\u{5BA2}\u{6237}\u{76F8}\u{5173}\u{FF0C}\u{65E8}\u{5728}\u{5F15}\u{5BFC}\u{6700}\u{7EC8}\u{7528}\u{6237}\u{7684}\u{56DE}\u{7B54}\u{6536}\u{96C6}\u{3002}`,
    'zh-hant': `\u{4E00}\u{7D44}\u{8207}\u{5BA2}\u{6236}\u{76F8}\u{95DC}\u{7684}\u{7D50}\u{69CB}\u{5316}\u{554F}\u{984C}\u{FF0C}\u{65E8}\u{5728}\u{5F15}\u{5C0E}\u{6700}\u{7D42}\u{4F7F}\u{7528}\u{8005}\u{7684}\u{56DE}\u{7B54}\u{6536}\u{96C6}\u{3002}`,
    en: `A structured set of questions related to a client, intended to guide the collection of answers from end-users.`
};
const $b11db1b62d4a8f76$export$ff6a452cc674d674 = {
    ar: `\u{627}\u{644}\u{625}\u{62D}\u{627}\u{644}\u{629}`,
    de: `Vermittlung`,
    es: `Recomendaci\xf3n`,
    fa: `\u{627}\u{631}\u{62C}\u{627}\u{639}`,
    fil: `Email Address *`,
    fr: `Recommandation`,
    hi: `\u{930}\u{947}\u{92B}\u{930}\u{932}`,
    ht: `Referans`,
    it: `Segnalazione`,
    ja: `\u{7D39}\u{4ECB}`,
    ko: `\u{C758}\u{B8B0}`,
    mww: `Kev xa mus rau`,
    ps: `\u{631}\u{627}\u{62C}\u{639} \u{6A9}\u{648}\u{644}`,
    pt: `Encaminhamento`,
    'pt-pt': `Encaminhamento`,
    ru: `\u{41D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Fa'asino`,
    so: `Tixraac`,
    th: `\u{E01}\u{E32}\u{E23}\u{E2D}\u{E49}\u{E32}\u{E07}\u{E2D}\u{E34}\u{E07}`,
    ur: `\u{62D}\u{648}\u{627}\u{644}\u{6C1}`,
    vi: `Gi\u{1EDB}i thi\u{1EC7}u`,
    'zh-hans': `\u{8F6C}\u{8BCA}`,
    'zh-hant': `\u{8F49}\u{4ECB}`,
    en: `Referral`
};
const $b11db1b62d4a8f76$export$90f6380a62d43dd9 = {
    ar: `\u{633}\u{62C}\u{644} \u{644}\u{637}\u{644}\u{628} \u{627}\u{644}\u{62E}\u{62F}\u{645}\u{629} \u{645}\u{62B}\u{644} \u{627}\u{644}\u{62A}\u{62D}\u{642}\u{64A}\u{642}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{634}\u{62E}\u{64A}\u{635}\u{64A}\u{629} \u{623}\u{648} \u{627}\u{644}\u{639}\u{644}\u{627}\u{62C}\u{627}\u{62A} \u{623}\u{648} \u{627}\u{644}\u{639}\u{645}\u{644}\u{64A}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{64A} \u{64A}\u{62C}\u{628} \u{625}\u{62C}\u{631}\u{627}\u{624}\u{647}\u{627}.`,
    de: `Eine Aufzeichnung einer Bitte um eine Dienstleistung wie diagnostische Untersuchungen, Behandlungen oder durchzuf\xfchrende Operationen.`,
    es: `Un registro de una solicitud de servicio, como investigaciones diagn\xf3sticas, tratamientos u operaciones a realizar.`,
    fa: `\u{631}\u{6A9}\u{648}\u{631}\u{62F}\u{6CC} \u{627}\u{632} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{62E}\u{62F}\u{645}\u{627}\u{62A} \u{645}\u{627}\u{646}\u{646}\u{62F} \u{628}\u{631}\u{631}\u{633}\u{6CC} \u{647}\u{627}\u{6CC} \u{62A}\u{634}\u{62E}\u{6CC}\u{635}\u{6CC}\u{60C} \u{62F}\u{631}\u{645}\u{627}\u{646} \u{647}\u{627} \u{6CC}\u{627} \u{62C}\u{631}\u{627}\u{62D}\u{6CC} \u{647}\u{627}\u{6CC}\u{6CC} \u{6A9}\u{647} \u{628}\u{627}\u{6CC}\u{62F} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: `Isang talaan ng isang kahilingan para sa serbisyo tulad ng mga pagsisiyasat sa diagnostic, paggamot, o operasyon na isasagawa.`,
    fr: `Un enregistrement d\u{2019}une demande de service telle que des examens diagnostiques, des traitements ou des op\xe9rations \xe0 effectuer.`,
    hi: `\u{938}\u{947}\u{935}\u{93E} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927} \u{915}\u{93E} \u{90F}\u{915} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{91C}\u{948}\u{938}\u{947} \u{928}\u{948}\u{926}\u{93E}\u{928}\u{93F}\u{915} \u{91C}\u{93E}\u{902}\u{91A}, \u{909}\u{92A}\u{91A}\u{93E}\u{930}, \u{92F}\u{93E} \u{915}\u{93F}\u{90F} \u{91C}\u{93E}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{911}\u{92A}\u{930}\u{947}\u{936}\u{928}\u{964}`,
    ht: `Dosye yon demann pou s\xe8vis tankou envestigasyon dyagnostik, tretman oswa operasyon ki dwe f\xe8t.`,
    it: `Un registro di una richiesta di servizio come indagini diagnostiche, trattamenti o operazioni da eseguire.`,
    ja: `\u{8A3A}\u{65AD}\u{691C}\u{67FB}\u{3001}\u{6CBB}\u{7642}\u{3001}\u{307E}\u{305F}\u{306F}\u{5B9F}\u{65BD}\u{3055}\u{308C}\u{308B}\u{624B}\u{8853}\u{306A}\u{3069}\u{306E}\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{8981}\u{8ACB}\u{306E}\u{8A18}\u{9332}\u{3002}`,
    ko: `\u{C9C4}\u{B2E8} \u{C870}\u{C0AC}, \u{CE58}\u{B8CC} \u{B610}\u{B294} \u{C2DC}\u{D589}\u{D560} \u{C218}\u{C220}\u{ACFC} \u{AC19}\u{C740} \u{C11C}\u{BE44}\u{C2A4} \u{C694}\u{CCAD} \u{AE30}\u{B85D}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib daim ntawv teev tseg ntawm kev thov kev pabcuam xws li kev kuaj mob, kev kho mob, lossis kev ua haujlwm.`,
    ps: `\u{62F} \u{62E}\u{62F}\u{645}\u{62A} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{6D0} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{644}\u{6A9}\u{647} \u{62A}\u{634}\u{62E}\u{6CC}\u{635}\u{6CC} \u{62A}\u{62D}\u{642}\u{6CC}\u{642}\u{627}\u{62A}\u{60C} \u{62F}\u{631}\u{645}\u{644}\u{646}\u{6D0}\u{60C} \u{6CC}\u{627} \u{62F} \u{62A}\u{631}\u{633}\u{631}\u{647} \u{6A9}\u{648}\u{644}\u{648} \u{639}\u{645}\u{644}\u{6CC}\u{627}\u{62A}.`,
    pt: `Um registro de um pedido de servi\xe7o, como investiga\xe7\xf5es diagn\xf3sticas, tratamentos ou opera\xe7\xf5es a serem realizadas.`,
    'pt-pt': `Um registo de um pedido de servi\xe7o, como investiga\xe7\xf5es diagn\xf3sticas, tratamentos ou opera\xe7\xf5es a realizar.`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430} \u{43D}\u{430} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{443}\u{441}\u{43B}\u{443}\u{433}, \u{442}\u{430}\u{43A}\u{43E}\u{439} \u{43A}\u{430}\u{43A} \u{434}\u{438}\u{430}\u{433}\u{43D}\u{43E}\u{441}\u{442}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{435} \u{438}\u{441}\u{441}\u{43B}\u{435}\u{434}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}, \u{43B}\u{435}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{438}\u{43B}\u{438} \u{43E}\u{43F}\u{435}\u{440}\u{430}\u{446}\u{438}\u{438}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{44B} \u{431}\u{44B}\u{442}\u{44C} \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{44B}.`,
    sm: `O se fa'amaumauga o se talosaga mo auaunaga e pei o su'esu'ega fa'ama'i, togafitiga, po'o taotoga e fa'atinoina.`,
    so: `Diiwaanka codsiga adeegga sida baaritaannada baaritaanka, daaweynta, ama qalliinnada la samaynayo.`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E01}\u{E32}\u{E23}\u{E23}\u{E49}\u{E2D}\u{E07}\u{E02}\u{E2D}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23} \u{E40}\u{E0A}\u{E48}\u{E19} \u{E01}\u{E32}\u{E23}\u{E15}\u{E23}\u{E27}\u{E08}\u{E27}\u{E34}\u{E19}\u{E34}\u{E08}\u{E09}\u{E31}\u{E22} \u{E01}\u{E32}\u{E23}\u{E23}\u{E31}\u{E01}\u{E29}\u{E32} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E01}\u{E32}\u{E23}\u{E1C}\u{E48}\u{E32}\u{E15}\u{E31}\u{E14}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{627}\u{6CC}\u{633}\u{6CC} \u{633}\u{631}\u{648}\u{633} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{6A9}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688}\u{60C} \u{62C}\u{6CC}\u{633}\u{6D2} \u{62A}\u{634}\u{62E}\u{6CC}\u{635}\u{6CC} \u{62A}\u{62D}\u{642}\u{6CC}\u{642}\u{627}\u{62A}\u{60C} \u{639}\u{644}\u{627}\u{62C}\u{60C} \u{6CC}\u{627} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{62F}\u{6CC}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{622}\u{67E}\u{631}\u{6CC}\u{634}\u{646}\u{632}\u{6D4}`,
    vi: `H\u{1ED3} s\u{1A1} y\xeau c\u{1EA7}u d\u{1ECB}ch v\u{1EE5} nh\u{1B0} \u{111}i\u{1EC1}u tra ch\u{1EA9}n \u{111}o\xe1n, \u{111}i\u{1EC1}u tr\u{1ECB} ho\u{1EB7}c ph\u{1EAB}u thu\u{1EAD}t s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c th\u{1EF1}c hi\u{1EC7}n.`,
    'zh-hans': `\u{8BF7}\u{6C42}\u{670D}\u{52A1}\u{7684}\u{8BB0}\u{5F55}\u{FF0C}\u{5982}\u{8BCA}\u{65AD}\u{68C0}\u{67E5}\u{3001}\u{6CBB}\u{7597}\u{6216}\u{624B}\u{672F}\u{3002}`,
    'zh-hant': `\u{95DC}\u{65BC}\u{670D}\u{52D9}\u{8ACB}\u{6C42}\u{7684}\u{7D00}\u{9304}\u{FF0C}\u{4F8B}\u{5982}\u{8A3A}\u{65B7}\u{6AA2}\u{67E5}\u{3001}\u{6CBB}\u{7642}\u{6216}\u{624B}\u{8853}\u{3002}`,
    en: `A record of a request for service such as diagnostic investigations, treatments, or operations to be performed.`
};
const $b11db1b62d4a8f76$export$e31ed6ed548e255b = {
    ar: `\u{627}\u{644}\u{645}\u{647}\u{645}\u{629}`,
    de: `Aufgabe`,
    es: `Tarea`,
    fa: `\u{648}\u{638}\u{6CC}\u{641}\u{647}`,
    fil: `Gawain`,
    fr: `T\xe2che`,
    hi: `\u{928}\u{93F}\u{92F}\u{924} \u{915}\u{93E}\u{930}\u{94D}\u{92F}`,
    ht: `Travay la`,
    it: `Compito`,
    ja: `\u{4EFB}\u{52D9}`,
    ko: `\u{C784}\u{BB34}`,
    mww: `Tes haujlwm`,
    ps: `\u{62F}\u{646}\u{62F}\u{647}`,
    pt: `Tarefa`,
    'pt-pt': `Tarefa`,
    ru: `\u{417}\u{430}\u{434}\u{430}\u{447}\u{430}`,
    sm: `Galuega`,
    so: `Hawl`,
    th: `\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6A9}\u{627}\u{645}`,
    vi: `Nhi\u{1EC7}m v\u{1EE5}`,
    'zh-hans': `\u{4EFB}\u{52A1}`,
    'zh-hant': `\u{4EFB}\u{52D9}`,
    en: `Task`
};
const $b11db1b62d4a8f76$export$dad853a619f75d14 = {
    ar: `\u{645}\u{647}\u{645}\u{629} \u{645}\u{62A}\u{639}\u{644}\u{642}\u{629} \u{628}\u{627}\u{644}\u{639}\u{645}\u{64A}\u{644} \u{645}\u{62B}\u{644} \u{645}\u{62A}\u{627}\u{628}\u{639}\u{629} \u{64A}\u{645}\u{643}\u{646} \u{62A}\u{646}\u{641}\u{64A}\u{630}\u{647}\u{627}.`,
    de: `Eine Aufgabe, die mit einem Kunden zusammenh\xe4ngt, wie zum Beispiel eine Nachverfolgung, die ausgef\xfchrt werden kann.`,
    es: `Una tarea relacionada con un cliente, como un seguimiento que pueda realizarse.`,
    fa: `\u{6CC}\u{6A9} \u{648}\u{638}\u{6CC}\u{641}\u{647} \u{645}\u{631}\u{62A}\u{628}\u{637} \u{628}\u{627} \u{6CC}\u{6A9} \u{645}\u{634}\u{62A}\u{631}\u{6CC} \u{645}\u{627}\u{646}\u{646}\u{62F} \u{67E}\u{6CC}\u{6AF}\u{6CC}\u{631}\u{6CC} \u{6A9}\u{647} \u{642}\u{627}\u{628}\u{644} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{627}\u{633}\u{62A}.`,
    fil: `Isang gawain na may kaugnayan sa isang kliyente tulad ng isang follow-up na maaaring maisagawa.`,
    fr: `Une t\xe2che li\xe9e \xe0 un client, comme un suivi pouvant \xeatre effectu\xe9.`,
    hi: `\u{915}\u{93F}\u{938}\u{940} \u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915} \u{938}\u{947} \u{938}\u{902}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{91C}\u{948}\u{938}\u{947} \u{905}\u{928}\u{941}\u{935}\u{930}\u{94D}\u{924}\u{940} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{91C}\u{93F}\u{938}\u{947} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Yon travay ki gen rap\xf2 ak yon kliyan tankou yon swivi ki ka f\xe8t.`,
    it: `Un compito correlato a un cliente, come un follow-up, che pu\xf2 essere eseguito.`,
    ja: `\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}\u{306B}\u{95A2}\u{9023}\u{3059}\u{308B}\u{30BF}\u{30B9}\u{30AF}\u{3001}\u{4F8B}\u{3048}\u{3070}\u{30D5}\u{30A9}\u{30ED}\u{30FC}\u{30A2}\u{30C3}\u{30D7}\u{3092}\u{884C}\u{3046}\u{3053}\u{3068}\u{3002}`,
    ko: `\u{C218}\u{D589} \u{AC00}\u{B2A5}\u{D55C} \u{D6C4}\u{C18D} \u{C870}\u{CE58}\u{C640} \u{AC19}\u{C740} \u{D074}\u{B77C}\u{C774}\u{C5B8}\u{D2B8}\u{C640} \u{AD00}\u{B828}\u{B41C} \u{C791}\u{C5C5}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib txoj haujlwm ntsig txog tus neeg siv khoom xws li kev taug qab uas tuaj yeem ua tau.`,
    ps: `\u{6CC}\u{648} \u{6A9}\u{627}\u{631} \u{686}\u{6D0} \u{62F} \u{645}\u{631}\u{627}\u{62C}\u{639} \u{633}\u{631}\u{647} \u{62A}\u{693}\u{627}\u{648} \u{644}\u{631}\u{6CC} \u{644}\u{6A9}\u{647} \u{62A}\u{639}\u{642}\u{6CC}\u{628}\u{6CC} \u{686}\u{6D0} \u{62A}\u{631}\u{633}\u{631}\u{647} \u{6A9}\u{6D0}\u{62F}\u{627}\u{6CC} \u{634}\u{6CC}.`,
    pt: `Uma tarefa relacionada a um cliente, como um acompanhamento, que pode ser realizada.`,
    'pt-pt': `Uma tarefa relacionada com um cliente, como um seguimento, que pode ser realizada.`,
    ru: `\u{417}\u{430}\u{434}\u{430}\u{447}\u{430}, \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{441} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{43C}, \u{43D}\u{430}\u{43F}\u{440}\u{438}\u{43C}\u{435}\u{440}, \u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{443}\u{44E}\u{449}\u{438}\u{439} \u{43A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{439} \u{43C}\u{43E}\u{436}\u{43D}\u{43E} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{44C}.`,
    sm: `O se galuega e feso'ota'i ma se tagata fa'atau e pei o se tulitatao e mafai ona fa'atinoina.`,
    so: `Hawl la xiriirta macmiil sida raac la qaban karo.`,
    th: `\u{E07}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E25}\u{E39}\u{E01}\u{E04}\u{E49}\u{E32} \u{E40}\u{E0A}\u{E48}\u{E19} \u{E01}\u{E32}\u{E23}\u{E15}\u{E34}\u{E14}\u{E15}\u{E32}\u{E21}\u{E1C}\u{E25}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E17}\u{E4D}\u{E32}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{627}\u{6CC}\u{633}\u{627} \u{6A9}\u{627}\u{645} \u{62C}\u{648} \u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679} \u{633}\u{6D2} \u{645}\u{62A}\u{639}\u{644}\u{642} \u{6C1}\u{648}\u{60C} \u{62C}\u{6CC}\u{633}\u{6D2} \u{6A9}\u{6C1} \u{641}\u{627}\u{644}\u{648} \u{627}\u{67E} \u{62C}\u{648} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{62F}\u{6CC}\u{627} \u{62C}\u{627} \u{633}\u{6A9}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED9}t nhi\u{1EC7}m v\u{1EE5} li\xean quan \u{111}\u{1EBF}n kh\xe1ch h\xe0ng, ch\u{1EB3}ng h\u{1EA1}n nh\u{1B0} theo d\xf5i c\xf3 th\u{1EC3} \u{111}\u{1B0}\u{1EE3}c th\u{1EF1}c hi\u{1EC7}n.`,
    'zh-hans': `\u{4E0E}\u{5BA2}\u{6237}\u{76F8}\u{5173}\u{7684}\u{4EFB}\u{52A1}\u{FF0C}\u{6BD4}\u{5982}\u{53EF}\u{4EE5}\u{6267}\u{884C}\u{7684}\u{540E}\u{7EED}\u{8DDF}\u{8E2A}\u{3002}`,
    'zh-hant': `\u{8207}\u{5BA2}\u{6236}\u{76F8}\u{95DC}\u{7684}\u{4EFB}\u{52D9}\u{FF0C}\u{4F8B}\u{5982}\u{53EF}\u{4EE5}\u{57F7}\u{884C}\u{7684}\u{5F8C}\u{7E8C}\u{8FFD}\u{8E64}\u{3002}`,
    en: `A task related to a client such as a follow-up that can be performed.`
};
const $b11db1b62d4a8f76$export$e3df7b8d35edbd9d = {
    ar: `\u{642}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630}`,
    de: `In Arbeit`,
    es: `En progreso`,
    fa: `\u{62F}\u{631} \u{62D}\u{627}\u{644} \u{627}\u{646}\u{62C}\u{627}\u{645}`,
    fil: `Sa pag-unlad`,
    fr: `En cours`,
    hi: `\u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{92A}\u{930} \u{939}\u{948}`,
    ht: `An pwogr\xe8`,
    it: `In corso`,
    ja: `\u{9032}\u{884C}\u{4E2D}`,
    ko: `\u{C9C4}\u{D589} \u{C911}\u{C785}\u{B2C8}\u{B2E4}`,
    mww: `Nyob rau hauv kev kawm`,
    ps: `\u{67E}\u{647} \u{62C}\u{631}\u{6CC}\u{627}\u{646} \u{6A9}\u{6D0}`,
    pt: `Em andamento`,
    'pt-pt': `Em progresso`,
    ru: `\u{412} \u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{435}`,
    sm: `O loo faagasolo`,
    so: `Soconaya`,
    th: `\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{62C}\u{627}\u{631}\u{6CC}`,
    vi: `\u{110}ang ti\u{1EBF}n h\xe0nh`,
    'zh-hans': `\u{8FDB}\u{884C}\u{4E2D}`,
    'zh-hant': `\u{9032}\u{884C}\u{4E2D}`,
    en: `In progress`
};
const $b11db1b62d4a8f76$export$878e78a909bcb42c = {
    ar: `\u{62A}\u{645} \u{628}\u{62F}\u{621} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{644}\u{643}\u{646}\u{647} \u{644}\u{645} \u{64A}\u{643}\u{62A}\u{645}\u{644} \u{628}\u{639}\u{62F}.`,
    de: `Die Aktivit\xe4t wurde begonnen, ist aber noch nicht abgeschlossen.`,
    es: `La actividad ya ha comenzado pero a\xfan no est\xe1 completa.`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{622}\u{63A}\u{627}\u{632} \u{634}\u{62F}\u{647} \u{627}\u{645}\u{627} \u{647}\u{646}\u{648}\u{632} \u{6A9}\u{627}\u{645}\u{644} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Sinimulan na ang aktibidad ngunit hindi pa rin kumpleto.`,
    fr: `L\u{2019}activit\xe9 a commenc\xe9 mais n\u{2019}est pas encore termin\xe9e.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{936}\u{941}\u{930}\u{942} \u{915}\u{930} \u{926}\u{940} \u{917}\u{908} \u{939}\u{948} \u{932}\u{947}\u{915}\u{93F}\u{928} \u{905}\u{92D}\u{940} \u{924}\u{915} \u{92A}\u{942}\u{930}\u{940} \u{928}\u{939}\u{940}\u{902} \u{939}\u{941}\u{908} \u{939}\u{948}\u{964}`,
    ht: `Aktivite a te k\xf2manse, men li poko fini.`,
    it: `L'attivit\xe0 \xe8 gi\xe0 iniziata ma non \xe8 ancora completata.`,
    ja: `\u{6D3B}\u{52D5}\u{306F}\u{958B}\u{59CB}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}\u{304C}\u{3001}\u{307E}\u{3060}\u{5B8C}\u{4E86}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{D65C}\u{B3D9}\u{C740} \u{C2DC}\u{C791}\u{B418}\u{C5C8}\u{C9C0}\u{B9CC} \u{C544}\u{C9C1} \u{C644}\u{B8CC}\u{B418}\u{C9C0}\u{B294} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kev ua haujlwm tau pib tab sis tseem tsis tau tiav.`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{67E}\u{6CC}\u{644} \u{634}\u{648}\u{6CC} \u{62E}\u{648} \u{644}\u{627} \u{628}\u{634}\u{67E}\u{693} \u{634}\u{648}\u{6CC} \u{646}\u{647} \u{62F}\u{6CC}.`,
    pt: `A atividade j\xe1 foi iniciada, mas ainda n\xe3o est\xe1 conclu\xedda.`,
    'pt-pt': `A atividade j\xe1 foi iniciada, mas ainda n\xe3o est\xe1 conclu\xedda.`,
    ru: `\u{414}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{443}\u{436}\u{435} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{430}, \u{43D}\u{43E} \u{435}\u{449}\u{451} \u{43D}\u{435} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{430}.`,
    sm: `Ua uma ona amataina le gaoioiga ae e le'i mae'a.`,
    so: `Hawlgalka waa la bilaabay balse weli lama dhameystirin.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E44}\u{E14}\u{E49}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E41}\u{E25}\u{E49}\u{E27} \u{E41}\u{E15}\u{E48}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{634}\u{631}\u{648}\u{639} \u{6C1}\u{648} \u{686}\u{6A9}\u{6CC} \u{6C1}\u{6D2} \u{644}\u{6CC}\u{6A9}\u{646} \u{627}\u{628}\u{6BE}\u{6CC} \u{645}\u{6A9}\u{645}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{626}\u{6CC}\u{6D4}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c b\u{1EAF}t \u{111}\u{1EA7}u nh\u{1B0}ng ch\u{1B0}a ho\xe0n t\u{1EA5}t.`,
    'zh-hans': `\u{8BE5}\u{6D3B}\u{52A8}\u{5DF2}\u{542F}\u{52A8}\u{FF0C}\u{4F46}\u{5C1A}\u{672A}\u{5B8C}\u{6210}\u{3002}`,
    'zh-hant': `\u{8A72}\u{6D3B}\u{52D5}\u{5DF2}\u{958B}\u{59CB}\u{FF0C}\u{4F46}\u{5C1A}\u{672A}\u{5B8C}\u{6210}\u{3002}`,
    en: `The activity has been started but is not yet complete.`
};
const $b11db1b62d4a8f76$export$8153d26e08d9149d = {
    ar: `\u{62A}\u{645} \u{627}\u{633}\u{62A}\u{644}\u{627}\u{645} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{641}\u{633}\u{627}\u{631}`,
    de: `Anfrage erhalten`,
    es: `Consulta recibida`,
    fa: `\u{627}\u{633}\u{62A}\u{639}\u{644}\u{627}\u{645} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{634}\u{62F}`,
    fil: `Natanggap ang pagtatanong`,
    fr: `Demande re\xe7ue`,
    hi: `\u{91C}\u{93E}\u{902}\u{91A} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{941}\u{908}`,
    ht: `Rech\xe8ch te resevwa`,
    it: `Richiesta ricevuta`,
    ja: `\u{554F}\u{3044}\u{5408}\u{308F}\u{305B}\u{53D7}\u{7406}`,
    ko: `\u{BB38}\u{C758} \u{C811}\u{C218}`,
    mww: `Kev nug tau txais`,
    ps: `\u{67E}\u{644}\u{67C}\u{646}\u{647} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{634}\u{648}\u{647}`,
    pt: `Consulta recebida`,
    'pt-pt': `Inqu\xe9rito recebido`,
    ru: `\u{417}\u{430}\u{43F}\u{440}\u{43E}\u{441} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}`,
    sm: `Mauaina le suesuega`,
    so: `Baaritaan la helay`,
    th: `\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E04}\u{E4D}\u{E32}\u{E16}\u{E32}\u{E21}`,
    ur: `\u{627}\u{646}\u{6A9}\u{648}\u{627}\u{626}\u{631}\u{6CC} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648}\u{626}\u{6CC}`,
    vi: `Y\xeau c\u{1EA7}u \u{111}\xe3 nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c`,
    'zh-hans': `\u{5DF2}\u{6536}\u{5230}\u{8BE2}\u{95EE}`,
    'zh-hant': `\u{6536}\u{5230}\u{7684}\u{8A62}\u{554F}`,
    en: `Inquiry received`
};
const $b11db1b62d4a8f76$export$be1654b1c3daa3bb = {
    ar: (mailto, email)=>$b11db1b62d4a8f76$var$html`تم استلام استفسارك! سنتواصل معك قريبا. يمكنك أيضا التواصل معنا مباشرة على <a href="${mailto}">${email}</a>.`,
    de: (mailto, email)=>$b11db1b62d4a8f76$var$html`Ihre Anfrage ist eingegangen! Wir werden uns in Kürze melden. Sie können uns auch direkt unter <a href="${mailto}">${email}</a> kontaktieren.`,
    es: (mailto, email)=>$b11db1b62d4a8f76$var$html`¡Ha recibido su consulta! Nos pondremos en contacto con ella en breve. También puedes contactarnos directamente en <a href="${mailto}">${email}</a>.`,
    fa: (mailto, email)=>$b11db1b62d4a8f76$var$html`درخواست شما دریافت شد! به زودی با شما تماس خواهیم گرفت. همچنین می توانید مستقیما با ما از <a href="${mailto}">${email}</a> تماس بگیرید.`,
    fil: (mailto, email)=>$b11db1b62d4a8f76$var$html`Natanggap na ang inyong pagtatanong! Maabot namin sa lalong madaling panahon. Maaari ka ring makipag-ugnay sa amin nang direkta sa <a href="${mailto}">${email}</a>.`,
    fr: (mailto, email)=>$b11db1b62d4a8f76$var$html`Votre demande a été reçue ! Nous vous contacterons sous peu. Vous pouvez également nous contacter directement à <a href="${mailto}">${email}</a>.`,
    hi: (mailto, email)=>$b11db1b62d4a8f76$var$html`आपकी पूछताछ प्राप्त हो गई है! हम जल्द ही संपर्क करेंगे। आप हमसे सीधे <a href="${mailto}">${email}</a> पर भी संपर्क कर सकते हैं।`,
    ht: (mailto, email)=>$b11db1b62d4a8f76$var$html`Rechèch ou an te resevwa! Nou pral kontakte yon ti tan Ou kapab tou kontakte nou dirèkteman nan <a href="${mailto}">${email}</a>.`,
    it: (mailto, email)=>$b11db1b62d4a8f76$var$html`La tua richiesta è stata ricevuta! Ti contatteremo a breve. Puoi anche contattarci direttamente <a href="${mailto}">${email}</a>.`,
    ja: (mailto, email)=>$b11db1b62d4a8f76$var$html`お問い合わせはお届けしました!近いうちにご連絡いたします。また、 <a href="${mailto}">${email}</a> まで直接お問い合わせいただくことも可能です。`,
    ko: (mailto, email)=>$b11db1b62d4a8f76$var$html`문의가 접수되었습니다! 곧 연락드리겠습니다. <a href="${mailto}">${email}</a> 에서도 직접 연락하실 수 있습니다.`,
    mww: (mailto, email)=>$b11db1b62d4a8f76$var$html`Koj qhov kev nug tau txais! Peb yuav ncav tes sai sai. Koj tseem tuaj yeem tiv tauj peb ncaj qha ntawm <a href="${mailto}">${email}</a>.`,
    ps: (mailto, email)=>$b11db1b62d4a8f76$var$html`ستاسو پوښتنه ترلاسه شوه! موږ به ژر اړیکه ونیسو. تاسو کولی شئ موږ سره مستقیم په <a href="${mailto}">${email}</a> اړیکه ونیسئ.`,
    pt: (mailto, email)=>$b11db1b62d4a8f76$var$html`Sua consulta foi recebida! Entraremos em contato em breve. Você também pode nos contatar diretamente pelo <a href="${mailto}">${email}</a>.`,
    'pt-pt': (mailto, email)=>$b11db1b62d4a8f76$var$html`A sua consulta foi recebida! Entraremos em contacto em breve. Também pode contactar-nos diretamente através <a href="${mailto}">${email}</a>.`,
    ru: (mailto, email)=>$b11db1b62d4a8f76$var$html`Ваш запрос получен! Мы скоро свяжемся с нами. Вы также можете связаться с нами напрямую по <a href="${mailto}">${email}</a>.`,
    sm: (mailto, email)=>$b11db1b62d4a8f76$var$html`Ua mae'a lau su'esu'ega! O le a tatou aapa atu i se taimi lata mai. E mafai foi ona e fa'afeso'ota'i sa'o mai matou i le <a href="${mailto}">${email}</a>.`,
    so: (mailto, email)=>$b11db1b62d4a8f76$var$html`Su'aashaada waa la helay! Waxaan dhowaan la xiriiri doonaa. Waxaad sidoo kale nala soo xiriiri kartaa si toos ah <a href="${mailto}">${email}</a>.`,
    th: (mailto, email)=>$b11db1b62d4a8f76$var$html`ได้รับคําถามของคุณแล้ว! เราจะติดต่อในไม่ช้า คุณสามารถติดต่อเราได้โดยตรงที่ <a href="${mailto}">${email}</a>`,
    ur: (mailto, email)=>$b11db1b62d4a8f76$var$html`آپ کی استفسار موصول ہو گئی ہے! ہم جلد ہی رابطہ کریں گے۔ آپ ہم سے <a href="${mailto}">${email}</a> پر بھی رابطہ کر سکتے ہیں۔`,
    vi: (mailto, email)=>$b11db1b62d4a8f76$var$html`Yêu cầu của bạn đã được nhận! Chúng tôi sẽ liên hệ trong thời gian ngắn. Bạn cũng có thể liên hệ trực tiếp với chúng tôi tại <a href="${mailto}">${email}</a>.`,
    'zh-hans': (mailto, email)=>$b11db1b62d4a8f76$var$html`您的咨询已收到！我们很快会联系你。您也可以直接通过 <a href="${mailto}">${email}</a> 联系我们。`,
    'zh-hant': (mailto, email)=>$b11db1b62d4a8f76$var$html`您的詢問已收到！我們很快就會聯絡你。您也可以直接透過 <a href="${mailto}">${email}</a> 與我們聯繫。`,
    en: (mailto, email)=>$b11db1b62d4a8f76$var$html`Your inquiry has been received! We'll be reaching out shortly. You can also contact us directly at <a href="${mailto}">${email}</a>.`
};
const $b11db1b62d4a8f76$export$7226b538ca62ac55 = {
    ar: `\u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{645}\u{627}\u{62A}`,
    de: `Anleitung`,
    es: `Instrucciones`,
    fa: `\u{62F}\u{633}\u{62A}\u{648}\u{631}\u{627}\u{644}\u{639}\u{645}\u{644} \u{647}\u{627}`,
    fil: `Mga tagubilin`,
    fr: `Instructions`,
    hi: `\u{905}\u{928}\u{941}\u{926}\u{947}\u{936}`,
    ht: `Enstriksyon yo`,
    it: `Istruzioni`,
    ja: `\u{6307}\u{793A}`,
    ko: `\u{C9C0}\u{CE68}`,
    mww: `Cov lus qhia`,
    ps: `\u{644}\u{627}\u{631}\u{69A}\u{648}\u{648}\u{646}\u{6D0}`,
    pt: `Instru\xe7\xf5es`,
    'pt-pt': `Instru\xe7\xf5es`,
    ru: `\u{418}\u{43D}\u{441}\u{442}\u{440}\u{443}\u{43A}\u{446}\u{438}\u{438}`,
    sm: `Faatonuga`,
    so: `Tilmaamaha`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E41}\u{E19}\u{E30}\u{E19}\u{E4D}\u{E32}`,
    ur: `\u{6C1}\u{62F}\u{627}\u{6CC}\u{627}\u{62A}`,
    vi: `H\u{1B0}\u{1EDB}ng d\u{1EAB}n`,
    'zh-hans': `\u{8BF4}\u{660E}\u{4E66}`,
    'zh-hant': `\u{8AAA}\u{660E}`,
    en: `Instructions`
};
const $b11db1b62d4a8f76$export$394c96a95e34e24a = {
    ar: (entityType)=>`\u{62A}\u{648}\u{641}\u{64A}\u{631} \u{62A}\u{639}\u{644}\u{64A}\u{645}\u{627}\u{62A} ${entityType}`,
    de: (entityType)=>`Geben Sie ${entityType} bereit`,
    es: (entityType)=>`Proporcionar instrucciones ${entityType}`,
    fa: (entityType)=>`\u{62F}\u{633}\u{62A}\u{648}\u{631}\u{627}\u{644}\u{639}\u{645}\u{644} ${entityType} \u{631}\u{627} \u{627}\u{631}\u{627}\u{626}\u{647} \u{62F}\u{647}\u{6CC}\u{62F}`,
    fil: (entityType)=>`Magbigay ng mga tagubilin ${entityType}`,
    fr: (entityType)=>`Fournir des instructions ${entityType}`,
    hi: (entityType)=>`${entityType} \u{928}\u{93F}\u{930}\u{94D}\u{926}\u{947}\u{936} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: (entityType)=>`Bay ${entityType} yo`,
    it: (entityType)=>`Fornire istruzioni ${entityType}`,
    ja: (entityType)=>`${entityType}\u{6307}\u{793A}\u{3092}\u{63D0}\u{4F9B}\u{3059}\u{308B}`,
    ko: (entityType)=>`${entityType} \u{C9C0}\u{CE68}\u{C744} \u{C81C}\u{ACF5}\u{D558}\u{C138}\u{C694}`,
    mww: (entityType)=>`Muab cov lus ${entityType}`,
    ps: (entityType)=>`${entityType} \u{644}\u{627}\u{631}\u{69A}\u{648}\u{648}\u{646}\u{6D0} \u{648}\u{631}\u{6A9}\u{648}\u{644}`,
    pt: (entityType)=>`Forne\xe7a instru\xe7\xf5es ${entityType}`,
    'pt-pt': (entityType)=>`Forne\xe7a instru\xe7\xf5es ${entityType}`,
    ru: (entityType)=>`\u{41F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{44C}\u{442}\u{435} ${entityType}`,
    sm: (entityType)=>`Tuuina atu faatonuga ${entityType}`,
    so: (entityType)=>`Bixi ${entityType}`,
    th: (entityType)=>`\u{E43}\u{E2B}\u{E49}\u{E04}\u{E4D}\u{E32}\u{E41}\u{E19}\u{E30}\u{E19}\u{E4D}\u{E32}${entityType}`,
    ur: (entityType)=>`${entityType} \u{6A9}\u{6CC} \u{6C1}\u{62F}\u{627}\u{6CC}\u{627}\u{62A} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: (entityType)=>`Cung c\u{1EA5}p h\u{1B0}\u{1EDB}ng d\u{1EAB}n ${entityType}`,
    'zh-hans': (entityType)=>`\u{63D0}\u{4F9B} ${entityType} \u{6307}\u{4EE4}`,
    'zh-hant': (entityType)=>`\u{63D0}\u{4F9B} ${entityType} \u{6307}\u{4EE4}`,
    en: (entityType)=>`Provide ${entityType} instructions`
};
const $b11db1b62d4a8f76$export$df8757b11bea02f0 = {
    ar: `\u{634}\u{631}\u{643}\u{629} \u{627}\u{644}\u{62A}\u{623}\u{645}\u{64A}\u{646}`,
    de: `Versicherungsgesellschaft`,
    es: `Compa\xf1\xeda de seguros`,
    fa: `\u{634}\u{631}\u{6A9}\u{62A} \u{628}\u{6CC}\u{645}\u{647}`,
    fil: `Kumpanya ng Seguro`,
    fr: `Compagnie d\u{2019}assurance`,
    hi: `\u{92C}\u{940}\u{92E}\u{93E} \u{915}\u{902}\u{92A}\u{928}\u{940}`,
    ht: `Konpayi asirans`,
    it: `Compagnia di assicurazioni`,
    ja: `\u{4FDD}\u{967A}\u{4F1A}\u{793E}`,
    ko: `\u{BCF4}\u{D5D8}\u{D68C}\u{C0AC}`,
    mww: `Lub Tuam Txhab Pov Hwm`,
    ps: `\u{62F} \u{628}\u{6CC}\u{645}\u{6D0} \u{634}\u{631}\u{6A9}\u{62A}`,
    pt: `Companhia de Seguros`,
    'pt-pt': `Companhia de Seguros`,
    ru: `\u{421}\u{442}\u{440}\u{430}\u{445}\u{43E}\u{432}\u{430}\u{44F} \u{43A}\u{43E}\u{43C}\u{43F}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Kamupani Inisiua`,
    so: `Shirkadda Caymiska`,
    th: `\u{E1A}\u{E23}\u{E34}\u{E29}\u{E31}\u{E17}\u{E1B}\u{E23}\u{E30}\u{E01}\u{E31}\u{E19}\u{E20}\u{E31}\u{E22}`,
    ur: `\u{627}\u{646}\u{634}\u{648}\u{631}\u{646}\u{633} \u{6A9}\u{645}\u{67E}\u{646}\u{6CC}`,
    vi: `C\xf4ng ty b\u{1EA3}o hi\u{1EC3}m`,
    'zh-hans': `\u{4FDD}\u{9669}\u{516C}\u{53F8}`,
    'zh-hant': `\u{4FDD}\u{96AA}\u{516C}\u{53F8}`,
    en: `Insurance Company`
};
const $b11db1b62d4a8f76$export$3b461b3cd4146c7b = {
    ar: `\u{62E}\u{637}\u{623} \u{62F}\u{627}\u{62E}\u{644}\u{64A} \u{641}\u{64A} \u{627}\u{644}\u{62E}\u{627}\u{62F}\u{645}`,
    de: `Interner Serverfehler`,
    es: `Error interno del servidor`,
    fa: `\u{62E}\u{637}\u{627}\u{6CC} \u{62F}\u{627}\u{62E}\u{644}\u{6CC} \u{633}\u{631}\u{648}\u{631}`,
    fil: `Error sa panloob na server`,
    fr: `Erreur interne du serveur`,
    hi: `\u{906}\u{902}\u{924}\u{930}\u{93F}\u{915} \u{938}\u{930}\u{94D}\u{935}\u{930} \u{924}\u{94D}\u{930}\u{941}\u{91F}\u{93F}`,
    ht: `Er\xe8 s\xe8v\xe8 ent\xe8n`,
    it: `Errore interno del server`,
    ja: `\u{5185}\u{90E8}\u{30B5}\u{30FC}\u{30D0}\u{30FC}\u{30A8}\u{30E9}\u{30FC}`,
    ko: `\u{B0B4}\u{BD80} \u{C11C}\u{BC84} \u{C624}\u{B958}`,
    mww: `Sab hauv neeg rau zaub mov yuam kev`,
    ps: `\u{62F}\u{627}\u{62E}\u{644}\u{6CC} \u{633}\u{631}\u{648}\u{631} \u{62A}\u{6D0}\u{631}\u{648}\u{62A}\u{646}\u{647}`,
    pt: `Erro interno do servidor`,
    'pt-pt': `Erro interno do servidor`,
    ru: `\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{432}\u{43D}\u{443}\u{442}\u{440}\u{435}\u{43D}\u{43D}\u{435}\u{433}\u{43E} \u{441}\u{435}\u{440}\u{432}\u{435}\u{440}\u{430}`,
    sm: `Mea sese i totonu o le server`,
    so: `Khalad server gudaha ah`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}\u{E20}\u{E32}\u{E22}\u{E43}\u{E19}\u{E40}\u{E0B}\u{E34}\u{E23}\u{E4C}\u{E1F}\u{E40}\u{E27}\u{E2D}\u{E23}\u{E4C}`,
    ur: `\u{627}\u{646}\u{62F}\u{631}\u{648}\u{646}\u{6CC} \u{633}\u{631}\u{648}\u{631} \u{6A9}\u{6CC} \u{62E}\u{631}\u{627}\u{628}\u{6CC}`,
    vi: `L\u{1ED7}i m\xe1y ch\u{1EE7} n\u{1ED9}i b\u{1ED9}`,
    'zh-hans': `\u{5185}\u{90E8}\u{670D}\u{52A1}\u{5668}\u{9519}\u{8BEF}`,
    'zh-hant': `\u{5167}\u{90E8}\u{4F3A}\u{670D}\u{5668}\u{932F}\u{8AA4}`,
    en: `Internal server error`
};
const $b11db1b62d4a8f76$export$9377a6ec42555e17 = {
    ar: `\u{62D}\u{62F}\u{62B} \u{62E}\u{637}\u{623} \u{623}\u{62B}\u{646}\u{627}\u{621} \u{645}\u{639}\u{627}\u{644}\u{62C}\u{629} \u{637}\u{644}\u{628}\u{643}. \u{62A}\u{645} \u{62A}\u{646}\u{628}\u{64A}\u{647} \u{641}\u{631}\u{64A}\u{642} \u{643}\u{648}\u{645}\u{648}\u{644}\u{648}\u{633}. \u{625}\u{630}\u{627} \u{627}\u{633}\u{62A}\u{645}\u{631}\u{62A} \u{627}\u{644}\u{645}\u{634}\u{643}\u{644}\u{629} \u{623}\u{648} \u{643}\u{627}\u{646} \u{644}\u{62F}\u{64A}\u{643} \u{623}\u{64A} \u{623}\u{633}\u{626}\u{644}\u{629}\u{60C} \u{64A}\u{631}\u{62C}\u{649} \u{627}\u{644}\u{62A}\u{648}\u{627}\u{635}\u{644} \u{645}\u{639} \u{627}\u{644}\u{62F}\u{639}\u{645}.`,
    de: `W\xe4hrend der Bearbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Das Cumulus-Team wurde alarmiert. Wenn das Problem weiterhin besteht oder Sie Fragen haben, wenden Sie sich bitte an den Support.`,
    es: `Se produjo un error mientras procesaba tu solicitud. El equipo de Cumulus ha sido alertado. Si el problema persiste o tienes alguna pregunta, por favor contacta con el soporte t\xe9cnico.`,
    fa: `\u{62F}\u{631} \u{62D}\u{6CC}\u{646} \u{67E}\u{631}\u{62F}\u{627}\u{632}\u{634} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{634}\u{645}\u{627}\u{60C} \u{62E}\u{637}\u{627}\u{6CC}\u{6CC} \u{631}\u{62E} \u{62F}\u{627}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{62A}\u{6CC}\u{645} \u{6A9}\u{648}\u{645}\u{648}\u{644}\u{648}\u{633} \u{645}\u{637}\u{644}\u{639} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{627}\u{6AF}\u{631} \u{645}\u{634}\u{6A9}\u{644} \u{627}\u{62F}\u{627}\u{645}\u{647} \u{62F}\u{627}\u{634}\u{62A} \u{6CC}\u{627} \u{633}\u{648}\u{627}\u{644}\u{6CC} \u{62F}\u{627}\u{634}\u{62A}\u{6CC}\u{62F}\u{60C} \u{644}\u{637}\u{641}\u{627} \u{628}\u{627} \u{67E}\u{634}\u{62A}\u{6CC}\u{628}\u{627}\u{646}\u{6CC} \u{62A}\u{645}\u{627}\u{633} \u{628}\u{6AF}\u{6CC}\u{631}\u{6CC}\u{62F}.`,
    fil: `Nagkaroon ng error habang pinoproseso ang iyong kahilingan. Inalerto na ang Cumulus team. Kung ang problema ay nagpapatuloy o mayroon kang anumang mga katanungan, mangyaring makipag-ugnay sa suporta.`,
    fr: `Une erreur s\u{2019}est produite lors du traitement de votre demande. L\u{2019}\xe9quipe Cumulus a \xe9t\xe9 alert\xe9e. Si le probl\xe8me persiste ou si vous avez des questions, veuillez contacter le support.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927} \u{915}\u{94B} \u{938}\u{902}\u{938}\u{93E}\u{927}\u{93F}\u{924} \u{915}\u{930}\u{924}\u{947} \u{938}\u{92E}\u{92F} \u{915}\u{94B}\u{908} \u{924}\u{94D}\u{930}\u{941}\u{91F}\u{93F} \u{909}\u{924}\u{94D}\u{92A}\u{928}\u{94D}\u{928} \u{939}\u{941}\u{908}. \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{941}\u{932}\u{938} \u{91F}\u{940}\u{92E} \u{915}\u{94B} \u{938}\u{924}\u{930}\u{94D}\u{915} \u{915}\u{930} \u{926}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{939}\u{948}\u{964} \u{92F}\u{926}\u{93F} \u{938}\u{92E}\u{938}\u{94D}\u{92F}\u{93E} \u{92C}\u{928}\u{940} \u{930}\u{939}\u{924}\u{940} \u{939}\u{948} \u{92F}\u{93E} \u{906}\u{92A}\u{915}\u{947} \u{915}\u{94B}\u{908} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928} \u{939}\u{948}\u{902}, \u{924}\u{94B} \u{915}\u{943}\u{92A}\u{92F}\u{93E} \u{938}\u{939}\u{93E}\u{92F}\u{924}\u{93E} \u{938}\u{947} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Yon er\xe8 te rive pandan y ap trete demann ou an. Ekip Cumulus la te al\xe8t Si pwobl\xe8m nan kontinye oswa ou gen nenp\xf2t kesyon, tanpri kontakte sip\xf2.`,
    it: `Si \xe8 verificato un errore durante l'elaborazione della tua richiesta. Il team Cumulus \xe8 stato allertato. Se il problema persiste o hai domande, contatta l'assistenza.`,
    ja: `\u{30EA}\u{30AF}\u{30A8}\u{30B9}\u{30C8}\u{51E6}\u{7406}\u{4E2D}\u{306B}\u{30A8}\u{30E9}\u{30FC}\u{304C}\u{767A}\u{751F}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}\u{30AD}\u{30E5}\u{30E0}\u{30E9}\u{30B9}\u{30C1}\u{30FC}\u{30E0}\u{306B}\u{901A}\u{5831}\u{6E08}\u{307F}\u{3002}\u{554F}\u{984C}\u{304C}\u{7D9A}\u{304F}\u{5834}\u{5408}\u{3084}\u{8CEA}\u{554F}\u{304C}\u{3042}\u{308B}\u{5834}\u{5408}\u{306F}\u{3001}\u{30B5}\u{30DD}\u{30FC}\u{30C8}\u{306B}\u{3054}\u{9023}\u{7D61}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C694}\u{CCAD}\u{C744} \u{CC98}\u{B9AC}\u{D558}\u{B294} \u{ACFC}\u{C815}\u{C5D0}\u{C11C} \u{C624}\u{B958}\u{AC00} \u{BC1C}\u{C0DD}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}. \u{D050}\u{BBAC}\u{B7EC}\u{C2A4} \u{D300}\u{C5D0} \u{ACBD}\u{BCF4}\u{AC00} \u{B4E4}\u{C5B4}\u{AC14}\u{C2B5}\u{B2C8}\u{B2E4}. \u{BB38}\u{C81C}\u{AC00} \u{ACC4}\u{C18D}\u{B418}\u{AC70}\u{B098} \u{AD81}\u{AE08}\u{D55C} \u{C810}\u{C774} \u{C788}\u{C73C}\u{BA74} \u{ACE0}\u{AC1D} \u{C9C0}\u{C6D0}\u{C5D0} \u{C5F0}\u{B77D}\u{D574} \u{C8FC}\u{C138}\u{C694}.`,
    mww: `Ib qho yuam kev tshwm sim thaum ua koj qhov kev thov. Pab pawg Cumulus tau ceeb toom. Yog tias qhov teeb meem tseem txuas ntxiv lossis koj muaj lus nug, thov hu rau cov kev txhawb nqa.`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{6D0} \u{62F} \u{67E}\u{631}\u{648}\u{633}\u{633} \u{67E}\u{631} \u{645}\u{647}\u{627}\u{644} \u{6CC}\u{648}\u{647} \u{62A}\u{6D0}\u{631}\u{648}\u{62A}\u{646}\u{647} \u{631}\u{627}\u{645}\u{646}\u{681}\u{62A}\u{647} \u{634}\u{648}\u{647}. \u{62F} \u{6A9}\u{648}\u{645}\u{6CC}\u{648}\u{644}\u{633} \u{67C}\u{6CC}\u{645} \u{62E}\u{628}\u{631} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}. \u{6A9}\u{647} \u{633}\u{62A}\u{648}\u{646}\u{632}\u{647} \u{62F}\u{648}\u{627}\u{645} \u{648}\u{644}\u{631}\u{6CC} \u{6CC}\u{627} \u{6A9}\u{648}\u{645}\u{647} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{647} \u{644}\u{631}\u{626}\u{60C} \u{645}\u{647}\u{631}\u{628}\u{627}\u{646}\u{6CC} \u{648}\u{6A9}\u{693}\u{626} \u{644}\u{647} \u{645}\u{644}\u{627}\u{62A}\u{693} \u{633}\u{631}\u{647} \u{627}\u{693}\u{6CC}\u{6A9}\u{647} \u{648}\u{646}\u{6CC}\u{633}\u{626}.`,
    pt: `Ocorreu um erro durante o processamento do seu pedido. A equipe Cumulus foi alertada. Se o problema persistir ou voc\xea tiver alguma d\xfavida, por favor, entre em contato com o suporte.`,
    'pt-pt': `Ocorreu um erro durante o processamento do seu pedido. A equipa Cumulus foi alertada. Se o problema persistir ou tiver alguma d\xfavida, por favor contacte o suporte.`,
    ru: `\u{412}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{44F} \u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{438} \u{432}\u{430}\u{448}\u{435}\u{433}\u{43E} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430} \u{43F}\u{440}\u{43E}\u{438}\u{437}\u{43E}\u{448}\u{43B}\u{430} \u{43E}\u{448}\u{438}\u{431}\u{43A}\u{430}. \u{41A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{430} \u{41A}\u{443}\u{43C}\u{443}\u{43B}\u{443}\u{441} \u{431}\u{44B}\u{43B}\u{430} \u{43F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{430}. \u{415}\u{441}\u{43B}\u{438} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{430} \u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{44F}\u{435}\u{442}\u{441}\u{44F} \u{438}\u{43B}\u{438} \u{443} \u{432}\u{430}\u{441} \u{435}\u{441}\u{442}\u{44C} \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{44B}, \u{43F}\u{43E}\u{436}\u{430}\u{43B}\u{443}\u{439}\u{441}\u{442}\u{430}, \u{441}\u{432}\u{44F}\u{436}\u{438}\u{442}\u{435}\u{441}\u{44C} \u{441} \u{43F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{43E}\u{439}.`,
    sm: `Sa i ai se mea sese a o faagaoioia lau talosaga. Ua lapataia le 'au a Cumulus. Afai o lo'o fa'aauau pea le fa'afitauli pe ei ai ni au fesili, fa'amolemole fa'afeso'ota'i le lagolago.`,
    so: `Khalad ayaa dhacay intii lagu guda jiray codsigaaga. Kooxda Cumulus waa la ogeysiiyay. Haddii dhibaatadu sii socoto ama aad su'aalo qabto, fadlan la xiriir taageerada.`,
    th: `\u{E40}\u{E01}\u{E34}\u{E14}\u{E02}\u{E49}\u{E2D}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}\u{E02}\u{E13}\u{E30}\u{E1B}\u{E23}\u{E30}\u{E21}\u{E27}\u{E25}\u{E1C}\u{E25}\u{E04}\u{E4D}\u{E32}\u{E02}\u{E2D}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13} \u{E17}\u{E35}\u{E21} Cumulus \u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E41}\u{E25}\u{E49}\u{E27} \u{E2B}\u{E32}\u{E01}\u{E1B}\u{E31}\u{E0D}\u{E2B}\u{E32}\u{E22}\u{E31}\u{E07}\u{E04}\u{E07}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E04}\u{E38}\u{E13}\u{E21}\u{E35}\u{E04}\u{E4D}\u{E32}\u{E16}\u{E32}\u{E21}\u{E43}\u{E14}\u{E46} \u{E42}\u{E1B}\u{E23}\u{E14}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E1D}\u{E48}\u{E32}\u{E22}\u{E2A}\u{E19}\u{E31}\u{E1A}\u{E2A}\u{E19}\u{E38}\u{E19}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{67E}\u{631} \u{639}\u{645}\u{644} \u{6A9}\u{631}\u{62A}\u{6D2} \u{6C1}\u{648}\u{626}\u{6D2} \u{627}\u{6CC}\u{6A9} \u{63A}\u{644}\u{637}\u{6CC} \u{67E}\u{6CC}\u{634} \u{622}\u{626}\u{6CC}\u{6D4} \u{6A9}\u{648}\u{645}\u{6CC}\u{648}\u{644}\u{633} \u{679}\u{6CC}\u{645} \u{6A9}\u{648} \u{627}\u{637}\u{644}\u{627}\u{639} \u{645}\u{644} \u{6AF}\u{626}\u{6CC} \u{6C1}\u{6D2}\u{6D4} \u{627}\u{6AF}\u{631} \u{645}\u{633}\u{626}\u{644}\u{6C1} \u{628}\u{631}\u{642}\u{631}\u{627}\u{631} \u{631}\u{6C1}\u{6D2} \u{6CC}\u{627} \u{622}\u{67E} \u{6A9}\u{6D2} \u{6A9}\u{648}\u{626}\u{6CC} \u{633}\u{648}\u{627}\u{644}\u{627}\u{62A} \u{6C1}\u{648}\u{6BA} \u{62A}\u{648} \u{628}\u{631}\u{627}\u{6C1} \u{6A9}\u{631}\u{645} \u{633}\u{67E}\u{648}\u{631}\u{679} \u{633}\u{6D2} \u{631}\u{627}\u{628}\u{637}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `\u{110}\xe3 x\u{1EA3}y ra l\u{1ED7}i trong khi x\u{1EED} l\xfd y\xeau c\u{1EA7}u c\u{1EE7}a b\u{1EA1}n. Nh\xf3m Cumulus \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c c\u{1EA3}nh b\xe1o. N\u{1EBF}u s\u{1EF1} c\u{1ED1} v\u{1EAB}n ti\u{1EBF}p di\u{1EC5}n ho\u{1EB7}c b\u{1EA1}n c\xf3 b\u{1EA5}t k\u{1EF3} c\xe2u h\u{1ECF}i n\xe0o, vui l\xf2ng li\xean h\u{1EC7} v\u{1EDB}i b\u{1ED9} ph\u{1EAD}n h\u{1ED7} tr\u{1EE3}.`,
    'zh-hans': `\u{5904}\u{7406}\u{60A8}\u{7684}\u{8BF7}\u{6C42}\u{65F6}\u{53D1}\u{751F}\u{4E86}\u{9519}\u{8BEF}\u{3002}\u{79EF}\u{4E91}\u{56E2}\u{961F}\u{5DF2}\u{88AB}\u{901A}\u{77E5}\u{3002}\u{5982}\u{679C}\u{95EE}\u{9898}\u{4F9D}\u{65E7}\u{6216}\u{6709}\u{4EFB}\u{4F55}\u{7591}\u{95EE}\u{FF0C}\u{8BF7}\u{8054}\u{7CFB}\u{5BA2}\u{670D}\u{3002}`,
    'zh-hant': `\u{5728}\u{8655}\u{7406}\u{60A8}\u{7684}\u{7533}\u{8ACB}\u{6642}\u{767C}\u{751F}\u{932F}\u{8AA4}\u{3002}Cumulus\u{5718}\u{968A}\u{5DF2}\u{88AB}\u{901A}\u{77E5}\u{3002}\u{5982}\u{679C}\u{554F}\u{984C}\u{6301}\u{7E8C}\u{5B58}\u{5728}\u{6216}\u{6709}\u{4EFB}\u{4F55}\u{554F}\u{984C}\u{FF0C}\u{8ACB}\u{806F}\u{7D61}\u{5BA2}\u{670D}\u{3002}`,
    en: `An error occurred while processing your request. The Cumulus team has been alerted. If the problem persists or you have any questions, please contact support.`
};
const $b11db1b62d4a8f76$export$851426c3646bd4c5 = {
    ar: `\u{62D}\u{62F}\u{62B} \u{62E}\u{637}\u{623} \u{645}\u{627} \u{645}\u{646} \u{62C}\u{627}\u{646}\u{628}\u{646}\u{627}.`,
    de: `Bei uns ist etwas schiefgelaufen.`,
    es: `Algo sali\xf3 mal por nuestra parte.`,
    fa: `\u{6CC}\u{647} \u{645}\u{634}\u{6A9}\u{644}\u{6CC} \u{627}\u{632} \u{637}\u{631}\u{641} \u{645}\u{627} \u{67E}\u{6CC}\u{634} \u{627}\u{648}\u{645}\u{62F}.`,
    fil: `May mali sa dulo namin.`,
    fr: `Quelque chose a mal tourn\xe9 de notre c\xf4t\xe9.`,
    hi: `\u{939}\u{92E}\u{93E}\u{930}\u{940} \u{913}\u{930} \u{938}\u{947} \u{915}\u{941}\u{91B} \u{917}\u{932}\u{924} \u{939}\u{94B} \u{917}\u{92F}\u{93E}\u{964}`,
    ht: `Yon bagay te ale mal sou b\xf2 nou an.`,
    it: `Qualcosa \xe8 andato storto da parte nostra.`,
    ja: `\u{3046}\u{3061}\u{3067}\u{4F55}\u{304B}\u{554F}\u{984C}\u{304C}\u{8D77}\u{304D}\u{305F}\u{3093}\u{3060}\u{3002}`,
    ko: `\u{C6B0}\u{B9AC} \u{CABD}\u{C5D0}\u{C11C} \u{BB54}\u{AC00} \u{C798}\u{BABB}\u{B410}\u{C5B4}.`,
    mww: `Ib yam dab tsi mus tsis ncaj ncees lawm ntawm peb kawg.`,
    ps: `\u{632}\u{645}\u{648}\u{696} \u{644}\u{647} \u{62E}\u{648}\u{627} \u{685}\u{647} \u{63A}\u{644}\u{637} \u{634}\u{648}\u{644}.`,
    pt: `Algo deu errado do nosso lado.`,
    'pt-pt': `Algo correu mal do nosso lado.`,
    ru: `\u{427}\u{442}\u{43E}-\u{442}\u{43E} \u{43F}\u{43E}\u{448}\u{43B}\u{43E} \u{43D}\u{435} \u{442}\u{430}\u{43A} \u{441} \u{43D}\u{430}\u{448}\u{435}\u{439} \u{441}\u{442}\u{43E}\u{440}\u{43E}\u{43D}\u{44B}.`,
    sm: `Sa i ai se mea na sese i lo matou itu.`,
    so: `Waxbaa naga qaldamay.`,
    th: `\u{E21}\u{E35}\u{E1A}\u{E32}\u{E07}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}\u{E43}\u{E19}\u{E15}\u{E2D}\u{E19}\u{E17}\u{E49}\u{E32}\u{E22}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E23}\u{E32}`,
    ur: `\u{6C1}\u{645}\u{627}\u{631}\u{6CC} \u{637}\u{631}\u{641} \u{633}\u{6D2} \u{6A9}\u{686}\u{6BE} \u{63A}\u{644}\u{637} \u{6C1}\u{648} \u{6AF}\u{6CC}\u{627}\u{6D4}`,
    vi: `C\xf3 \u{111}i\u{1EC1}u g\xec \u{111}\xf3 kh\xf4ng \u{1ED5}n t\u{1EEB} ph\xeda ch\xfang t\xf4i.`,
    'zh-hans': `\u{6211}\u{4EEC}\u{8FD9}\u{8FB9}\u{51FA}\u{4E86}\u{70B9}\u{95EE}\u{9898}\u{3002}`,
    'zh-hant': `\u{6211}\u{5011}\u{9019}\u{908A}\u{51FA}\u{4E86}\u{9EDE}\u{554F}\u{984C}\u{3002}`,
    en: `Something went wrong on our end.`
};
const $b11db1b62d4a8f76$export$bb3c71098daa2c51 = {
    ar: `\u{627}\u{644}\u{62A}\u{634}\u{63A}\u{64A}\u{644} \u{627}\u{644}\u{628}\u{64A}\u{646}\u{64A}`,
    de: `Interoperabilit\xe4t`,
    es: `Interoperabilidad`,
    fa: `\u{642}\u{627}\u{628}\u{644}\u{6CC}\u{62A} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{6CC}`,
    fil: `Interoperability`,
    fr: `Interop\xe9rabilit\xe9`,
    hi: `\u{907}\u{902}\u{91F}\u{930}\u{911}\u{92A}\u{930}\u{947}\u{92C}\u{93F}\u{932}\u{93F}\u{91F}\u{940}`,
    ht: `Ent\xe8operabilite`,
    it: `Interoperabilit\xe0`,
    ja: `\u{76F8}\u{4E92}\u{904B}\u{7528}\u{6027}`,
    ko: `\u{C0C1}\u{D638}\u{C6B4}\u{C6A9}\u{C131}`,
    mww: `Kev sib cuam tshuam`,
    ps: `\u{647}\u{645}\u{63A}\u{696}\u{6CC}`,
    pt: `Interoperabilidade`,
    'pt-pt': `Interoperabilidade`,
    ru: `\u{421}\u{43E}\u{432}\u{43C}\u{435}\u{441}\u{442}\u{438}\u{43C}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Feso'ota'iga`,
    so: `Is-waafajinta`,
    th: `\u{E01}\u{E32}\u{E23}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E31}\u{E19}`,
    ur: `\u{627}\u{646}\u{679}\u{631}\u{622}\u{67E}\u{631}\u{6CC}\u{628}\u{644}\u{679}\u{6CC}`,
    vi: `Kh\u{1EA3} n\u{103}ng t\u{1B0}\u{1A1}ng t\xe1c`,
    'zh-hans': `\u{4E92}\u{64CD}\u{4F5C}\u{6027}`,
    'zh-hant': `\u{4E92}\u{901A}\u{6027}`,
    en: `Interoperability`
};
const $b11db1b62d4a8f76$export$b18ef22a06052160 = {
    ar: (label)=>`\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${label} \u{628}\u{635}\u{64A}\u{63A}\u{629} MM/DD/YYYY.`,
    de: (label)=>`${label} muss im Format MM/DD/YYYY sein.`,
    es: (label)=>`${label} debe estar en el formato MM/DD/YYYY.`,
    fa: (label)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{62F}\u{631} \u{642}\u{627}\u{644}\u{628} MM/DD/YYYY \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label)=>`Ang ${label} ay dapat na nasa format na MM/DD/YYYYY.`,
    fr: (label)=>`${label} doit \xeatre au format MM/DD/YYYY.`,
    hi: (label)=>`${label} MM/DD/YYYY \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{942}\u{92A} \u{92E}\u{947}\u{902} \u{939}\u{94B}\u{928}\u{940} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}\u{964}`,
    ht: (label)=>`${label} dwe nan f\xf2ma MM/JJ/AAAA.`,
    it: (label)=>`${label} deve essere nel formato MM/DD/YYYY.`,
    ja: (label)=>`${label} \u{306F}MM/DD/YYYY\u{306E}\u{30D5}\u{30A9}\u{30FC}\u{30DE}\u{30C3}\u{30C8}\u{3067}\u{306A}\u{3051}\u{308C}\u{3070}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label)=>`${label} \u{C740} MM/DD/YYYY \u{D615}\u{C2DD}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} yuav tsum yog hom ntawv MM/DD/YYYY.`,
    ps: (label)=>`${label} \u{648}\u{631}\u{681} \u{628}\u{627}\u{6CC}\u{62F} \u{62F} MM/DD/YYYY \u{67E}\u{647} \u{628}\u{6BC}\u{647} \u{648}\u{6CC}.`,
    pt: (label)=>`${label} deve estar no formato MM/DD/YYYY.`,
    'pt-pt': (label)=>`${label} deve estar no formato MM/DD/YYYY.`,
    ru: (label)=>`${label} \u{440}\u{43E}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{44F} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{432} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}\u{435} MM/DD/YYYY.`,
    sm: (label)=>`${label} e tatau ona i ai i le faatulagaga MM / DD / YYYY.`,
    so: (label)=>`${label} waa in ay ku jirtaa qaabka MM/DD/YYYY.`,
    th: (label)=>`${label} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E43}\u{E19}\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A} MM/DD/YYYY`,
    ur: (label)=>`${label} \u{67E}\u{6CC}\u{62F}\u{627}\u{626}\u{634} \u{644}\u{627}\u{632}\u{645}\u{6CC} \u{637}\u{648}\u{631} \u{67E}\u{631} MM/DD/YYYY \u{641}\u{627}\u{631}\u{645}\u{6CC}\u{679} \u{645}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{646}\u{6CC} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}\u{6D4}`,
    vi: (label)=>`${label} \u{1EDF} \u{111}\u{1ECB}nh d\u{1EA1}ng MM / DD / YYYY.`,
    'zh-hans': (label)=>`${label} \u{5FC5}\u{987B}\u{662F}MM/DD/YYYY\u{683C}\u{5F0F}\u{3002}`,
    'zh-hant': (label)=>`${label} \u{5FC5}\u{9808}\u{662F}MM/DD/YYYY\u{683C}\u{5F0F}\u{3002}`,
    en: (label)=>`${label} must be in the format MM/DD/YYYY.`
};
const $b11db1b62d4a8f76$export$17cc4069ead581d4 = {
    ar: (label)=>`\u{64A}\u{62C}\u{628} ${label} \u{628}\u{635}\u{64A}\u{63A}\u{629} name@example.com.`,
    de: (label)=>`${label} muss im Format name@example.com sein.`,
    es: (label)=>`${label} debe estar en el formato name@example.com.`,
    fa: (label)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{62F}\u{631} \u{642}\u{627}\u{644}\u{628} name@example.com \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label)=>`Ang ${label} ay dapat na nasa format na name@example.com.`,
    fr: (label)=>`${label} doit \xeatre au format name@example.com.`,
    hi: (label)=>`${label} name@example.com \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{942}\u{92A} \u{92E}\u{947}\u{902} \u{939}\u{94B}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}\u{964}`,
    ht: (label)=>`${label} dwe nan f\xf2ma name@example.com.`,
    it: (label)=>`${label} deve essere nel formato name@example.com.`,
    ja: (label)=>`${label} name@example.com \u{306E}\u{30D5}\u{30A9}\u{30FC}\u{30DE}\u{30C3}\u{30C8}\u{3067}\u{306A}\u{3051}\u{308C}\u{3070}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label)=>`${label} name@example.com \u{D615}\u{C2DD}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} yuav tsum nyob rau hauv hom ntawv name@example.com.`,
    ps: (label)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{67E}\u{647} \u{647}\u{63A}\u{647} \u{628}\u{6BC}\u{647} \u{648}\u{6CC} \u{686}\u{6D0} name@example.com.`,
    pt: (label)=>`${label} deve estar no formato name@example.com.`,
    'pt-pt': (label)=>`${label} deve estar no formato name@example.com.`,
    ru: (label)=>`${label} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{432} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}\u{435} name@example.com.`,
    sm: (label)=>`${label} e tatau ona i ai i le faatulagaga name@example.com.`,
    so: (label)=>`${label} waa inuu ku jiraa qaabka name@example.com.`,
    th: (label)=>`${label} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E43}\u{E19}\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A} name@example.com`,
    ur: (label)=>`${label} \u{627}\u{633} \u{641}\u{627}\u{631}\u{645}\u{6CC}\u{679} \u{645}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{646}\u{6CC} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2} name@example.com \u{6C1}\u{6D2}\u{6D4}`,
    vi: (label)=>`${label} ph\u{1EA3}i \u{1EDF} \u{111}\u{1ECB}nh d\u{1EA1}ng name@example.com.`,
    'zh-hans': (label)=>`\u{7535}\u{5B50}\u{90AE}\u{4EF6}${label}\u{7B26}\u{5408} name@example.com\u{3002}`,
    'zh-hant': (label)=>`${label} \u{683C}\u{5F0F}\u{5FC5}\u{9808}\u{7B26}\u{5408} name@example.com\u{3002}`,
    en: (label)=>`${label} must be in the format name@example.com.`
};
const $b11db1b62d4a8f76$export$a61f4000938e5ea3 = {
    ar: (extension, filename, supportedExtensions)=>`\u{627}\u{645}\u{62A}\u{62F}\u{627}\u{62F} \u{63A}\u{64A}\u{631} \u{635}\u{627}\u{644}\u{62D} "${extension}" \u{641}\u{64A} "${filename}". \u{627}\u{644}\u{625}\u{636}\u{627}\u{641}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{62F}\u{639}\u{648}\u{645}\u{629} \u{647}\u{64A} ${supportedExtensions}.`,
    de: (extension, filename, supportedExtensions)=>`Ung\xfcltige Erweiterung "${extension}" in "${filename}". Unterst\xfctzte Erweiterungen sind ${supportedExtensions}.`,
    es: (extension, filename, supportedExtensions)=>`Extensi\xf3n inv\xe1lida "${extension}" en "${filename}". Las extensiones soportadas son ${supportedExtensions}.`,
    fa: (extension, filename, supportedExtensions)=>`\u{67E}\u{633}\u{648}\u{646}\u{62F} \xab${extension}\xbb \u{62F}\u{631} \xab${filename}\xbb \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631} \u{627}\u{633}\u{62A}. \u{627}\u{641}\u{632}\u{648}\u{646}\u{647} \u{647}\u{627}\u{6CC} \u{67E}\u{634}\u{62A}\u{6CC}\u{628}\u{627}\u{646}\u{6CC} \u{634}\u{62F}\u{647} ${supportedExtensions} \u{647}\u{633}\u{62A}\u{646}\u{62F}.`,
    fil: (extension, filename, supportedExtensions)=>`Hindi wastong extension na "${extension}" sa "${filename}". Ang mga suportadong extension ay ${supportedExtensions}.`,
    fr: (extension, filename, supportedExtensions)=>`Extension invalide \xab ${extension} \xbb dans \xab ${filename} \xbb. Les extensions prises en charge sont ${supportedExtensions}.`,
    hi: (extension, filename, supportedExtensions)=>`\u{905}\u{92E}\u{93E}\u{928}\u{94D}\u{92F} \u{90F}\u{915}\u{94D}\u{938}\u{91F}\u{947}\u{902}\u{936}\u{928} "${filename} \u{92E}\u{947}\u{902} "${extension}"\u{964} \u{938}\u{92E}\u{930}\u{94D}\u{925}\u{93F}\u{924} \u{90F}\u{915}\u{94D}\u{938}\u{91F}\u{947}\u{902}\u{936}\u{928} ${supportedExtensions} \u{939}\u{948}\u{902}\u{964}`,
    ht: (extension, filename, supportedExtensions)=>`Ekstansyon envalid "${extension}" nan "${filename}". Sip\xf2te ekstansyon yo se ${supportedExtensions}.`,
    it: (extension, filename, supportedExtensions)=>`Estensione invalida "${extension}" in "${filename}". Le estensioni supportate sono ${supportedExtensions}.`,
    ja: (extension, filename, supportedExtensions)=>`\u{300C}${filename}\u{300D}\u{306E}\u{7121}\u{52B9}\u{306A}\u{62E1}\u{5F35}\u{300C}${extension}\u{300D}\u{3002}\u{5BFE}\u{5FDC}\u{3057}\u{3066}\u{3044}\u{308B}\u{62E1}\u{5F35}\u{5B50}\u{306F}${supportedExtensions}\u{3067}\u{3059}\u{3002}`,
    ko: (extension, filename, supportedExtensions)=>`"${filename}"\u{C5D0} \u{C798}\u{BABB}\u{B41C} \u{D655}\u{C7A5} \u{D504}\u{B85C}\u{ADF8}\u{B7A8} "${extension}"\u{AC00} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C9C0}\u{C6D0}\u{B418}\u{B294} \u{D655}\u{C7A5}\u{C790}\u{B294} ${supportedExtensions}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (extension, filename, supportedExtensions)=>`Kev txuas ntxiv tsis raug "${extension}" hauv "${filename}". Cov kev txhawb nqa txuas ntxiv yog ${supportedExtensions}.`,
    ps: (extension, filename, supportedExtensions)=>`\u{62F} "${extension}" \u{67E}\u{647} "${filename}" \u{6A9}\u{6D0} \u{646}\u{627}\u{633}\u{645} \u{67E}\u{633}\u{648}\u{646}\u{62F} "". \u{645}\u{644}\u{627}\u{62A}\u{693} \u{634}\u{648}\u{6CC} \u{67E}\u{631}\u{627}\u{62E}\u{648}\u{646}\u{6D0} ${supportedExtensions} \u{62F}\u{6CC}.`,
    pt: (extension, filename, supportedExtensions)=>`Extens\xe3o inv\xe1lida "${extension}" em "${filename}". Extens\xf5es suportadas s\xe3o ${supportedExtensions}.`,
    'pt-pt': (extension, filename, supportedExtensions)=>`Extens\xe3o inv\xe1lida "${extension}" em "${filename}". As extens\xf5es suportadas s\xe3o ${supportedExtensions}.`,
    ru: (extension, filename, supportedExtensions)=>`\u{41D}\u{435}\u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{435} \u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{435} \xab${extension}\xbb \u{432} \xab${filename}\xbb. \u{41F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{435}\u{43C}\u{44B}\u{435} \u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{44F} \u{2014} ${supportedExtensions}.`,
    sm: (extension, filename, supportedExtensions)=>`Fa'aopoopoga le aoga "${extension}" i le "${filename}". Lagolagoina fa'aopoopoga o ${supportedExtensions}.`,
    so: (extension, filename, supportedExtensions)=>`Kordhin aan sax ahayn "${extension}" oo ku jira "${filename}". Kordhinta la taageero waa ${supportedExtensions}.`,
    th: (extension, filename, supportedExtensions)=>`\u{E19}\u{E32}\u{E21}\u{E2A}\u{E01}\u{E38}\u{E25} "${extension}" \u{E43}\u{E19} "${filename}" \u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07} \u{E2A}\u{E48}\u{E27}\u{E19}\u{E02}\u{E22}\u{E32}\u{E22}\u{E17}\u{E35}\u{E48}\u{E23}\u{E2D}\u{E07}\u{E23}\u{E31}\u{E1A}\u{E04}\u{E37}\u{E2D} ${supportedExtensions}`,
    ur: (extension, filename, supportedExtensions)=>`\u{63A}\u{644}\u{637} \u{627}\u{6CC}\u{6A9}\u{633}\u{679}\u{6CC}\u{646}\u{634}\u{646} "${extension}" \u{645}\u{6CC}\u{6BA} "${filename}"\u{6D4} \u{633}\u{67E}\u{648}\u{631}\u{679}\u{688} \u{627}\u{6CC}\u{6A9}\u{633}\u{679}\u{6CC}\u{646}\u{634}\u{646}\u{632} ${supportedExtensions} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (extension, filename, supportedExtensions)=>`Ph\u{1EA7}n m\u{1EDF} r\u{1ED9}ng "${extension}" kh\xf4ng h\u{1EE3}p l\u{1EC7} trong "${filename}". C\xe1c ti\u{1EC7}n \xedch m\u{1EDF} r\u{1ED9}ng \u{111}\u{1B0}\u{1EE3}c h\u{1ED7} tr\u{1EE3} l\xe0 ${supportedExtensions}.`,
    'zh-hans': (extension, filename, supportedExtensions)=>`\u{201C}${filename}\u{201D}\u{4E2D}\u{7684}\u{65E0}\u{6548}\u{6269}\u{5C55}\u{540D}\u{201C}${extension}\u{201D}\u{3002}\u{652F}\u{6301}\u{7684}\u{6269}\u{5C55}\u{540D}\u{6709}${supportedExtensions}\u{3002}`,
    'zh-hant': (extension, filename, supportedExtensions)=>`\u{300C}${filename}\u{300D}\u{4E2D}\u{7684}\u{7121}\u{6548}\u{64F4}\u{5C55}\u{540D}\u{300C}${extension}\u{300D}\u{3002}\u{652F}\u{63F4}\u{7684}\u{526F}\u{6A94}\u{540D}\u{6709} ${supportedExtensions}\u{3002}`,
    en: (extension, filename, supportedExtensions)=>`Invalid extension "${extension}" in "${filename}". Supported extensions are ${supportedExtensions}.`
};
const $b11db1b62d4a8f76$export$91e9ba9f3f646b82 = {
    ar: (filename)=>`\u{627}\u{633}\u{645} \u{627}\u{644}\u{645}\u{644}\u{641} \u{63A}\u{64A}\u{631} \u{635}\u{627}\u{644}\u{62D}: "${filename}".`,
    de: (filename)=>`Ung\xfcltiger Dateiname: "${filename}".`,
    es: (filename)=>`Nombre de archivo inv\xe1lido: "${filename}".`,
    fa: (filename)=>`\u{646}\u{627}\u{645} \u{641}\u{627}\u{6CC}\u{644} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \xab${filename}\xbb.`,
    fil: (filename)=>`Hindi wastong pangalan ng file: "${filename}".`,
    fr: (filename)=>`Nom de fichier invalide : \xab ${filename} \xbb.`,
    hi: (filename)=>`\u{905}\u{92E}\u{93E}\u{928}\u{94D}\u{92F} \u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{928}\u{93E}\u{92E}: "${filename}"\u{964}`,
    ht: (filename)=>`Non dosye ki pa valid: "${filename}".`,
    it: (filename)=>`Nome file non valido: "${filename}".`,
    ja: (filename)=>`\u{7121}\u{52B9}\u{306A}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{540D}:\u{300C}${filename}\u{300D}\u{3002}`,
    ko: (filename)=>`\u{C720}\u{D6A8}\u{D558}\u{C9C0} \u{C54A}\u{C740} \u{D30C}\u{C77C}\u{BA85}: "${filename}".`,
    mww: (filename)=>`Cov ntaub ntawv tsis raug: "${filename}".`,
    ps: (filename)=>`\u{646}\u{627}\u{633}\u{645} \u{641}\u{627}\u{6CC}\u{644} \u{646}\u{648}\u{645}: "${filename}".`,
    pt: (filename)=>`Nome de arquivo inv\xe1lido: "${filename}".`,
    'pt-pt': (filename)=>`Nome de ficheiro inv\xe1lido: "${filename}".`,
    ru: (filename)=>`\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{43E}\u{435} \u{438}\u{43C}\u{44F} \u{444}\u{430}\u{439}\u{43B}\u{430}: "${filename}".`,
    sm: (filename)=>`Igoa faila e le aoga: "${filename}".`,
    so: (filename)=>`Magac faylka oo aan sax ahayn: ${filename}".`,
    th: (filename)=>`\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: "${filename}"`,
    ur: (filename)=>`\u{63A}\u{644}\u{637} \u{641}\u{627}\u{626}\u{644} \u{646}\u{627}\u{645}: "${filename}"\u{6D4}`,
    vi: (filename)=>`T\xean t\u{1EC7}p kh\xf4ng h\u{1EE3}p l\u{1EC7}: "${filename}".`,
    'zh-hans': (filename)=>`\u{6587}\u{4EF6}\u{540D}\u{65E0}\u{6548}\u{FF1A}\u{201C}${filename}\u{201D}\u{3002}`,
    'zh-hant': (filename)=>`\u{6A94}\u{6848}\u{540D}\u{7A31}\u{7121}\u{6548}\u{FF1A}\u{300C}${filename}\u{300D}\u{3002}`,
    en: (filename)=>`Invalid filename: "${filename}".`
};
const $b11db1b62d4a8f76$export$dd0340f9174b778 = {
    ar: (label)=>`${label} \u{645}\u{646}\u{633}\u{642} \u{628}\u{634}\u{643}\u{644} \u{63A}\u{64A}\u{631} \u{635}\u{62D}\u{64A}\u{62D}.`,
    de: (label)=>`${label} ist falsch formatiert.`,
    es: (label)=>`${label} est\xe1 mal formateado.`,
    fa: (label)=>`${label} \u{628}\u{647} \u{627}\u{634}\u{62A}\u{628}\u{627}\u{647} \u{642}\u{627}\u{644}\u{628} \u{628}\u{646}\u{62F}\u{6CC} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: (label)=>`Mali ang format ng ${label}.`,
    fr: (label)=>`${label} est mal format\xe9.`,
    hi: (label)=>`${label} \u{917}\u{932}\u{924} \u{924}\u{930}\u{940}\u{915}\u{947} \u{938}\u{947} \u{938}\u{94D}\u{935}\u{930}\u{942}\u{92A}\u{93F}\u{924} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (label)=>`${label} se f\xf2ma mal.`,
    it: (label)=>`${label} \xe8 formattato in modo errato.`,
    ja: (label)=>`${label} \u{306E}\u{30D5}\u{30A9}\u{30FC}\u{30DE}\u{30C3}\u{30C8}\u{304C}\u{8AA4}\u{3063}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (label)=>`${label} \u{C774} \u{C798}\u{BABB} \u{C11C}\u{C2DD}\u{B418}\u{C5B4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} tsis ncaj ncees lawm.`,
    ps: (label)=>`${label} \u{63A}\u{644}\u{637} \u{641}\u{627}\u{631}\u{645}\u{6CC}\u{67C} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: (label)=>`${label} est\xe1 formatado incorretamente.`,
    'pt-pt': (label)=>`${label} est\xe1 formatado incorretamente.`,
    ru: (label)=>`${label} \u{43D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{43E} \u{43E}\u{442}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43E}.`,
    sm: (label)=>`E le sa'o le ${label}.`,
    so: (label)=>`${label} si khaldan ayaa loo qaabeeyay.`,
    th: (label)=>`${label} \u{E16}\u{E39}\u{E01}\u{E08}\u{E31}\u{E14}\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`,
    ur: (label)=>`${label} \u{63A}\u{644}\u{637} \u{641}\u{627}\u{631}\u{645}\u{6CC}\u{679} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (label)=>`${label} \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1ECB}nh d\u{1EA1}ng kh\xf4ng ch\xednh x\xe1c.`,
    'zh-hans': (label)=>`${label} \u{683C}\u{5F0F}\u{9519}\u{8BEF}\u{3002}`,
    'zh-hant': (label)=>`${label} \u{683C}\u{5F0F}\u{932F}\u{8AA4}\u{3002}`,
    en: (label)=>`${label} is incorrectly formatted.`
};
const $b11db1b62d4a8f76$export$6c61a0cedd6edf45 = {
    ar: (label)=>`${label} \u{63A}\u{64A}\u{631} \u{635}\u{627}\u{644}\u{62D}.`,
    de: (label)=>`${label} ist ung\xfcltig.`,
    es: (label)=>`El ${label} no es v\xe1lido.`,
    fa: (label)=>`${label} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631} \u{627}\u{633}\u{62A}.`,
    fil: (label)=>`Hindi wasto ang ${label}.`,
    fr: (label)=>`${label} est invalide.`,
    hi: (label)=>`${label} \u{905}\u{92E}\u{93E}\u{928}\u{94D}\u{92F} \u{939}\u{948}\u{964}`,
    ht: (label)=>`${label} envalid`,
    it: (label)=>`Il ${label} non \xe8 valido.`,
    ja: (label)=>`${label} \u{306F}\u{7121}\u{52B9}\u{3067}\u{3059}\u{3002}`,
    ko: (label)=>`${label} \u{C774} \u{C720}\u{D6A8}\u{D558}\u{C9C0} \u{C54A}\u{C544}\u{C694}.`,
    mww: (label)=>`${label} tsis raug.`,
    ps: (label)=>`${label} \u{646}\u{627}\u{633}\u{645} \u{62F}\u{6CC}.`,
    pt: (label)=>`${label} \xe9 inv\xe1lido.`,
    'pt-pt': (label)=>`${label} \xe9 inv\xe1lido.`,
    ru: (label)=>`${label} \u{43D}\u{435}\u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}.`,
    sm: (label)=>`E le o sa'o ${label}.`,
    so: (label)=>`${label} waa mid aan sax ahayn.`,
    th: (label)=>`${label} \u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`,
    ur: (label)=>`${label} \u{63A}\u{644}\u{637} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (label)=>`${label} kh\xf4ng h\u{1EE3}p l\u{1EC7}.`,
    'zh-hans': (label)=>`${label} \u{65E0}\u{6548}\u{3002}`,
    'zh-hant': (label)=>`${label} \u{7121}\u{6548}\u{3002}`,
    en: (label)=>`${label} is invalid.`
};
const $b11db1b62d4a8f76$export$cd31f99195471735 = {
    ar: (label)=>`${label} \u{644}\u{627} \u{64A}\u{633}\u{645}\u{62D} \u{628}\u{627}\u{644}\u{643}\u{633}\u{648}\u{631}.`,
    de: (label)=>`${label} erlaubt keine Br\xfcche.`,
    es: (label)=>`${label} no permite fracciones.`,
    fa: (label)=>`${label} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{6A9}\u{633}\u{631}\u{647}\u{627} \u{631}\u{627} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: (label)=>`Hindi pinapayagan ${label} ang mga fraction.`,
    fr: (label)=>`${label} n\u{2019}autorise pas les fractions.`,
    hi: (label)=>`${label} \u{92D}\u{93F}\u{928}\u{94D}\u{928}\u{94B}\u{902} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{928}\u{939}\u{940}\u{902} \u{926}\u{947}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (label)=>`${label} pa p\xe8m\xe8t fraksyon.`,
    it: (label)=>`${label} non permette frazioni.`,
    ja: (label)=>`${label} \u{3067}\u{306F}\u{5206}\u{6570}\u{306F}\u{8A31}\u{3055}\u{308C}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label)=>`${label} \u{C740} \u{BD84}\u{C218}\u{B97C} \u{D5C8}\u{C6A9}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} tsis pub cov zauv feem.`,
    ps: (label)=>`${label} \u{62F} \u{6A9}\u{633}\u{631}\u{648}\u{646}\u{648} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{647} \u{648}\u{631}\u{6A9}\u{648}\u{6CC}.`,
    pt: (label)=>`${label} n\xe3o permite fra\xe7\xf5es.`,
    'pt-pt': (label)=>`${label} n\xe3o permite fra\xe7\xf5es.`,
    ru: (label)=>`${label} \u{43D}\u{435} \u{434}\u{43E}\u{43F}\u{443}\u{441}\u{43A}\u{430}\u{435}\u{442} \u{434}\u{440}\u{43E}\u{431}\u{438}.`,
    sm: (label)=>`E le faatagaina e ${label} ni vaega ninii.`,
    so: (label)=>`${label} ma oggola jajabyo.`,
    th: (label)=>`${label} \u{E44}\u{E21}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E28}\u{E29}\u{E2A}\u{E48}\u{E27}\u{E19}`,
    ur: (label)=>`${label} \u{645}\u{6CC}\u{6BA} \u{6A9}\u{633}\u{631}\u{648}\u{6BA} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (label)=>`${label} kh\xf4ng cho ph\xe9p ph\xe2n s\u{1ED1}.`,
    'zh-hans': (label)=>`${label} \u{4E0D}\u{5141}\u{8BB8}\u{5206}\u{6570}\u{3002}`,
    'zh-hant': (label)=>`${label} \u{4E0D}\u{5141}\u{8A31}\u{5206}\u{6578}\u{3002}`,
    en: (label)=>`${label} does not permit fractions.`
};
const $b11db1b62d4a8f76$export$ebdc8e5d5931ff1b = {
    ar: (label, maxLabel)=>`${label} \u{623}\u{642}\u{644} \u{645}\u{646} ${maxLabel}.`,
    de: (label, maxLabel)=>`Das ${label} muss k\xfcrzer als ${maxLabel} sein.`,
    es: (label, maxLabel)=>`La ${label} debe ser inferior a ${maxLabel}.`,
    fa: (label, maxLabel)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{6A9}\u{645}\u{62A}\u{631} \u{627}\u{632} ${maxLabel} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label, maxLabel)=>`Ang ${label} ay dapat na mas mababa kaysa sa ${maxLabel}.`,
    fr: (label, maxLabel)=>`${label} doit \xeatre inf\xe9rieure \xe0 ${maxLabel}.`,
    hi: (label, maxLabel)=>`${label} ${maxLabel} \u{915}\u{92E} \u{939}\u{94B}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}.`,
    ht: (label, maxLabel)=>`${label} dwe mwens pase ${maxLabel}`,
    it: (label, maxLabel)=>`${label} deve essere inferiore alla ${maxLabel}.`,
    ja: (label, maxLabel)=>`${label} \u{306F} ${maxLabel}\u{3088}\u{308A}\u{77ED}\u{3044}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: (label, maxLabel)=>`${label} \u{C740} ${maxLabel}\u{BCF4}\u{B2E4} \u{C9E7}\u{C544}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (label, maxLabel)=>`${label} yuav tsum tsawg dua ${maxLabel}.`,
    ps: (label, maxLabel)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{62F} ${maxLabel} \u{685}\u{62E}\u{647} \u{6A9}\u{645}\u{647} \u{648}\u{6CC}.`,
    pt: (label, maxLabel)=>`${label} deve ser inferior \xe0 ${maxLabel}.`,
    'pt-pt': (label, maxLabel)=>`${label} deve ser inferior \xe0 ${maxLabel}.`,
    ru: (label, maxLabel)=>`${label} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{438}\u{436}\u{435} ${maxLabel}.`,
    sm: (label, maxLabel)=>`O le ${label} e tatau ona itiiti ifo nai lo le ${maxLabel} ai.`,
    so: (label, maxLabel)=>`${label} waa inay ka yar ${maxLabel}.`,
    th: (label, maxLabel)=>`${label}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E19}\u{E49}\u{E2D}\u{E22}\u{E01}\u{E27}\u{E48}\u{E32}${maxLabel}`,
    ur: (label, maxLabel)=>`${label} ${maxLabel} \u{633}\u{6D2} \u{6A9}\u{645} \u{6C1}\u{648}\u{646}\u{6CC} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}\u{6D4}`,
    vi: (label, maxLabel)=>`${label} ph\u{1EA3}i nh\u{1ECF} h\u{1A1}n ${maxLabel}.`,
    'zh-hans': (label, maxLabel)=>`${label} \u{5FC5}\u{987B}\u{5C0F} ${maxLabel}\u{3002}`,
    'zh-hant': (label, maxLabel)=>`${label} \u{5FC5}\u{9808}\u{5C0F} ${maxLabel}\u{3002}`,
    en: (label, maxLabel)=>`${label} must be less than ${maxLabel}.`
};
const $b11db1b62d4a8f76$export$5d0a69f765a632f4 = {
    ar: (label, maxLabel)=>`${label} \u{623}\u{642}\u{644} \u{623}\u{648} \u{64A}\u{633}\u{627}\u{648}\u{64A} ${maxLabel}.`,
    de: (label, maxLabel)=>`Das ${label} muss kleiner oder gleich dem ${maxLabel} sein.`,
    es: (label, maxLabel)=>`${label} debe ser menor o igual a ${maxLabel}.`,
    fa: (label, maxLabel)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{6A9}\u{645}\u{62A}\u{631} \u{6CC}\u{627} \u{628}\u{631}\u{627}\u{628}\u{631} \u{628}\u{627} ${maxLabel} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label, maxLabel)=>`Ang ${label} ay dapat na mas mababa o katumbas ng ${maxLabel}.`,
    fr: (label, maxLabel)=>`${label} doit \xeatre inf\xe9rieure ou \xe9gale \xe0 ${maxLabel}.`,
    hi: (label, maxLabel)=>`${label} ${maxLabel} \u{938}\u{947} \u{915}\u{92E} \u{92F}\u{93E} \u{909}\u{938}\u{915}\u{947} \u{92C}\u{930}\u{93E}\u{92C}\u{930} \u{939}\u{94B}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}.`,
    ht: (label, maxLabel)=>`${label} dwe mwens pase oswa egal a ${maxLabel}`,
    it: (label, maxLabel)=>`${label} deve essere inferiore o uguale alla ${maxLabel}.`,
    ja: (label, maxLabel)=>`${label} \u{306F} ${maxLabel}\u{3088}\u{308A}\u{4E0B}\u{3067}\u{306A}\u{3051}\u{308C}\u{3070}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label, maxLabel)=>`${label} \u{C740} ${maxLabel}\u{BCF4}\u{B2E4} \u{C791}\u{C544}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (label, maxLabel)=>`${label} yuav tsum tsawg dua los yog sib npaug rau ${maxLabel}.`,
    ps: (label, maxLabel)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{62F} ${maxLabel} \u{685}\u{62E}\u{647} \u{6A9}\u{645}\u{647} \u{6CC}\u{627} \u{645}\u{633}\u{627}\u{648}\u{6CC} \u{648}\u{6CC}.`,
    pt: (label, maxLabel)=>`${label} deve ser menor ou igual \xe0 ${maxLabel}.`,
    'pt-pt': (label, maxLabel)=>`${label} deve ser inferior ou igual \xe0 ${maxLabel}.`,
    ru: (label, maxLabel)=>`${label} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44C}\u{448}\u{435} \u{438}\u{43B}\u{438} \u{440}\u{430}\u{432}\u{43D}\u{430} ${maxLabel}.`,
    sm: (label, maxLabel)=>`O le ${label} e tatau ona itiiti ifo pe tutusa foi ma le ${maxLabel} ai.`,
    so: (label, maxLabel)=>`${label} waa inay ka yar tahay ama la mid ${maxLabel}.`,
    th: (label, maxLabel)=>`${label}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E19}\u{E49}\u{E2D}\u{E22}\u{E01}\u{E27}\u{E48}\u{E32}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E17}\u{E48}\u{E32}\u{E01}\u{E31}\u{E1A}${maxLabel}`,
    ur: (label, maxLabel)=>`${label} ${maxLabel} \u{6C1}\u{648}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{633}\u{6D2} \u{6A9}\u{645} \u{6CC}\u{627} \u{627}\u{633} \u{6A9}\u{6D2} \u{628}\u{631}\u{627}\u{628}\u{631} \u{6C1}\u{648}\u{646}\u{6CC} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}\u{6D4}`,
    vi: (label, maxLabel)=>`${label} ph\u{1EA3}i nh\u{1ECF} h\u{1A1}n ho\u{1EB7}c b\u{1EB1}ng ${maxLabel}.`,
    'zh-hans': (label, maxLabel)=>`${label} \u{5FC5}\u{987B}\u{5C0F}\u{4E8E}\u{6216}\u{7B49}\u{4E8E} ${maxLabel}\u{3002}`,
    'zh-hant': (label, maxLabel)=>`${label} \u{5FC5}\u{9808}\u{5C0F}\u{65BC}\u{6216}\u{7B49}\u{65BC} ${maxLabel}\u{3002}`,
    en: (label, maxLabel)=>`${label} must be less than or equal to ${maxLabel}.`
};
const $b11db1b62d4a8f76$export$110dcc8e73edbe8a = {
    ar: (label)=>`\u{642}\u{62F} \u{64A}\u{62D}\u{62A}\u{648}\u{64A} ${label} \u{639}\u{644}\u{649} \u{62D}\u{631}\u{648}\u{641} \u{623}\u{648} \u{623}\u{631}\u{642}\u{627}\u{645} \u{623}\u{648} \u{634}\u{631}\u{637}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629} \u{641}\u{642}\u{637}\u{60C} \u{648}\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{623}\u{646} \u{64A}\u{628}\u{62F}\u{623} \u{623}\u{648} \u{64A}\u{646}\u{62A}\u{647}\u{64A} \u{628}\u{634}\u{631}\u{637}\u{629}.`,
    de: (label)=>`${label} darf nur Buchstaben, Zahlen oder einzelne Bindestriche enthalten und darf nicht mit einem Bindestrich beginnen oder enden.`,
    es: (label)=>`El ${label} puede contener solo letras, n\xfameros o guiones individuales, y no puede comenzar ni terminar con un guion.`,
    fa: (label)=>`${label} \u{645}\u{645}\u{6A9}\u{646} \u{627}\u{633}\u{62A} \u{641}\u{642}\u{637} \u{634}\u{627}\u{645}\u{644} \u{62D}\u{631}\u{648}\u{641}\u{60C} \u{627}\u{639}\u{62F}\u{627}\u{62F} \u{6CC}\u{627} \u{62E}\u{637} \u{62A}\u{6CC}\u{631}\u{647} \u{647}\u{627}\u{6CC} \u{645}\u{646}\u{641}\u{631}\u{62F} \u{628}\u{627}\u{634}\u{62F} \u{648} \u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{628}\u{627} \u{62E}\u{637} \u{62A}\u{6CC}\u{631}\u{647} \u{634}\u{631}\u{648}\u{639} \u{6CC}\u{627} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{6CC}\u{627}\u{628}\u{62F}.`,
    fil: (label)=>`${label} ay maaaring maglaman lamang ng mga titik, numero, o solong hyphen, at hindi maaaring magsimula o magtapos sa isang hyphen.`,
    fr: (label)=>`${label} ne peut contenir que des lettres, des chiffres ou des traits d\u{2019}union simples, et ne peut ni commencer ni se terminer par un trait d\u{2019}union.`,
    hi: (label)=>`${label} \u{92E}\u{947}\u{902} \u{915}\u{947}\u{935}\u{932} \u{905}\u{915}\u{94D}\u{937}\u{930}, \u{938}\u{902}\u{916}\u{94D}\u{92F}\u{93E}\u{90F}\u{901} \u{92F}\u{93E} \u{90F}\u{915}\u{932} \u{939}\u{93E}\u{907}\u{92B}\u{93C}\u{928} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{947} \u{939}\u{948}\u{902}, \u{914}\u{930} \u{939}\u{93E}\u{907}\u{92B}\u{93C}\u{928} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{92F}\u{93E} \u{905}\u{902}\u{924} \u{928}\u{939}\u{940}\u{902} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (label)=>`${label} ka gen s\xe8lman l\xe8t, nimewo, oswa tir\xe8 s\xe8l, epi yo pa ka k\xf2manse oswa fini ak yon tir\xe8.`,
    it: (label)=>`${label} pu\xf2 contenere solo lettere, numeri o trattini singoli e non pu\xf2 iniziare o terminare con un trattino.`,
    ja: (label)=>`${label} \u{306F}\u{6587}\u{5B57}\u{3001}\u{6570}\u{5B57}\u{3001}\u{307E}\u{305F}\u{306F}\u{5358}\u{4E00}\u{306E}\u{30CF}\u{30A4}\u{30D5}\u{30F3}\u{306E}\u{307F}\u{3067}\u{69CB}\u{6210}\u{3055}\u{308C}\u{308B}\u{3053}\u{3068}\u{304C}\u{3067}\u{304D}\u{3001}\u{30CF}\u{30A4}\u{30D5}\u{30F3}\u{3067}\u{59CB}\u{307E}\u{3063}\u{305F}\u{308A}\u{7D42}\u{308F}\u{3063}\u{305F}\u{308A}\u{3059}\u{308B}\u{3053}\u{3068}\u{306F}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label)=>`${label} \u{C740} \u{AE00}\u{C790}, \u{C22B}\u{C790} \u{B610}\u{B294} \u{B2E8}\u{C77C} \u{D558}\u{C774}\u{D508}\u{B9CC} \u{D3EC}\u{D568}\u{D560} \u{C218} \u{C788}\u{C73C}\u{BA70}, \u{D558}\u{C774}\u{D508}\u{C73C}\u{B85C} \u{C2DC}\u{C791}\u{D558}\u{AC70}\u{B098} \u{B05D}\u{B0A0} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} tsuas muaj cov tsiaj ntawv, cov zauv, lossis ib tus zauv xwb, thiab tsis tuaj yeem pib lossis xaus nrog tus zawm zawm.`,
    ps: (label)=>`${label} \u{6A9}\u{6D0}\u{62F}\u{627}\u{6CC} \u{634}\u{6CC} \u{6CC}\u{648}\u{627}\u{632}\u{6D0} \u{62A}\u{648}\u{631}\u{6CC}\u{60C} \u{634}\u{645}\u{6D0}\u{631}\u{6D0}\u{60C} \u{6CC}\u{627} \u{6CC}\u{648} \u{648}\u{627}\u{62D}\u{62F} \u{647}\u{627}\u{6CC}\u{641}\u{646} \u{648}\u{644}\u{631}\u{6CC}\u{60C} \u{627}\u{648} \u{646}\u{634}\u{6CC} \u{6A9}\u{648}\u{644}\u{627}\u{6CC} \u{62F} \u{647}\u{627}\u{6CC}\u{641}\u{646} \u{633}\u{631}\u{647} \u{67E}\u{6CC}\u{644} \u{6CC}\u{627} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{6CC}\u{696}\u{6CC}.`,
    pt: (label)=>`${label} pode conter apenas letras, n\xfameros ou h\xedfens simples, e n\xe3o pode come\xe7ar ou terminar com h\xedfen.`,
    'pt-pt': (label)=>`${label} pode conter apenas letras, n\xfameros ou h\xedfens simples, e n\xe3o pode come\xe7ar nem terminar com um h\xedfen.`,
    ru: (label)=>`${label} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{431}\u{443}\u{43A}\u{432}\u{44B}, \u{446}\u{438}\u{444}\u{440}\u{44B} \u{438}\u{43B}\u{438} \u{43E}\u{442}\u{434}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{435} \u{434}\u{435}\u{444}\u{438}\u{441}\u{44B} \u{438} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{43D}\u{430}\u{447}\u{438}\u{43D}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{438}\u{43B}\u{438} \u{437}\u{430}\u{43A}\u{430}\u{43D}\u{447}\u{438}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{434}\u{435}\u{444}\u{438}\u{441}\u{43E}\u{43C}.`,
    sm: (label)=>`${label} e mafai ona na o mataitusi, fuainumera, po o vase se tasi, ma e le mafai ona amata pe faaiu i se vase upu.`,
    so: (label)=>`${label} wuxuu ka koobnaan karaa oo kaliya xarfo, tirooyin, ama xarfaha hal xariiq, mana ku bilaabi karo ama ku dhammaan karo xarfaha xarfaha isku xiran.`,
    th: (label)=>`${label} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E40}\u{E09}\u{E1E}\u{E32}\u{E30}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23} \u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E02} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E22}\u{E31}\u{E15}\u{E34}\u{E20}\u{E31}\u{E07}\u{E04}\u{E4C}\u{E40}\u{E14}\u{E35}\u{E48}\u{E22}\u{E27} \u{E41}\u{E25}\u{E30}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E02}\u{E36}\u{E49}\u{E19}\u{E15}\u{E49}\u{E19}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E25}\u{E07}\u{E17}\u{E49}\u{E32}\u{E22}\u{E14}\u{E49}\u{E27}\u{E22}\u{E22}\u{E31}\u{E15}\u{E34}\u{E20}\u{E31}\u{E07}\u{E04}\u{E4C}\u{E44}\u{E14}\u{E49}`,
    ur: (label)=>`${label} \u{645}\u{6CC}\u{6BA} \u{635}\u{631}\u{641} \u{62D}\u{631}\u{648}\u{641}\u{60C} \u{627}\u{639}\u{62F}\u{627}\u{62F} \u{6CC}\u{627} \u{633}\u{646}\u{6AF}\u{644} \u{6C1}\u{627}\u{626}\u{641}\u{646} \u{634}\u{627}\u{645}\u{644} \u{6C1}\u{648} \u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{60C} \u{627}\u{648}\u{631} \u{6CC}\u{6C1} \u{6C1}\u{627}\u{626}\u{641}\u{646} \u{633}\u{6D2} \u{634}\u{631}\u{648}\u{639} \u{6CC}\u{627} \u{62E}\u{62A}\u{645} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648} \u{633}\u{6A9}\u{62A}\u{627}\u{6D4}`,
    vi: (label)=>`${label} ch\u{1EC9} c\xf3 th\u{1EC3} ch\u{1EE9}a c\xe1c ch\u{1EEF} c\xe1i, s\u{1ED1} ho\u{1EB7}c d\u{1EA5}u g\u{1EA1}ch n\u{1ED1}i \u{111}\u{1A1}n l\u{1EBB} v\xe0 kh\xf4ng \u{111}\u{1B0}\u{1EE3}c b\u{1EAF}t \u{111}\u{1EA7}u ho\u{1EB7}c k\u{1EBF}t th\xfac b\u{1EB1}ng d\u{1EA5}u g\u{1EA1}ch n\u{1ED1}i.`,
    'zh-hans': (label)=>`${label} \u{53EA}\u{80FD}\u{5305}\u{542B}\u{5B57}\u{6BCD}\u{3001}\u{6570}\u{5B57}\u{6216}\u{5355}\u{8FDE}\u{5B57}\u{7B26}\u{FF0C}\u{4E14}\u{4E0D}\u{80FD}\u{4EE5}\u{8FDE}\u{5B57}\u{7B26}\u{5F00}\u{5934}\u{6216}\u{7ED3}\u{5C3E}\u{3002}`,
    'zh-hant': (label)=>`${label} \u{53EA}\u{80FD}\u{5305}\u{542B}\u{5B57}\u{6BCD}\u{3001}\u{6578}\u{5B57}\u{6216}\u{55AE}\u{9023}\u{5B57}\u{865F}\u{FF0C}\u{4E14}\u{4E0D}\u{5F97}\u{4EE5}\u{9023}\u{5B57}\u{865F}\u{958B}\u{982D}\u{6216}\u{7D50}\u{5C3E}\u{3002}`,
    en: (label)=>`${label} may only contain letters, numbers, or single hyphens, and cannot begin or end with a hyphen.`
};
const $b11db1b62d4a8f76$export$22ec1f3944b408e9 = {
    ar: (length)=>`\u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{642}\u{635}\u{649} \u{644}\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{647}\u{648} ${length}.`,
    de: (length)=>`Die maximale Anzahl an Gegenst\xe4nden betr\xe4gt ${length}.`,
    es: (length)=>`El n\xfamero m\xe1ximo de objetos es ${length}.`,
    fa: (length)=>`\u{62D}\u{62F}\u{627}\u{6A9}\u{62B}\u{631} \u{62A}\u{639}\u{62F}\u{627}\u{62F} \u{622}\u{6CC}\u{62A}\u{645} ${length} \u{627}\u{633}\u{62A}.`,
    fil: (length)=>`Ang maximum na bilang ng mga item ay ${length}.`,
    fr: (length)=>`Le nombre maximal d\u{2019}objets est ${length}.`,
    hi: (length)=>`\u{935}\u{938}\u{94D}\u{924}\u{941}\u{913}\u{902} \u{915}\u{940} \u{905}\u{927}\u{93F}\u{915}\u{924}\u{92E} \u{938}\u{902}\u{916}\u{94D}\u{92F}\u{93E} ${length} \u{939}\u{948}\u{964}`,
    ht: (length)=>`Maksim\xf2m kantite atik se ${length}`,
    it: (length)=>`Il numero massimo di oggetti \xe8 ${length}.`,
    ja: (length)=>`\u{6700}\u{5927}\u{30A2}\u{30A4}\u{30C6}\u{30E0}\u{6570}\u{306F} ${length}\u{70B9}\u{3067}\u{3059}\u{3002}`,
    ko: (length)=>`\u{CD5C}\u{B300} \u{C544}\u{C774}\u{D15C} \u{C218}\u{B294} ${length}\u{AC1C}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (length)=>`Qhov siab tshaj plaws ntawm cov khoom yog ${length}.`,
    ps: (length)=>`\u{627}\u{639}\u{638}\u{645}\u{6CC} \u{62A}\u{648}\u{6A9}\u{6CC} ${length} \u{62F}\u{6CC}.`,
    pt: (length)=>`O n\xfamero m\xe1ximo de itens \xe9 ${length}.`,
    'pt-pt': (length)=>`O n\xfamero m\xe1ximo de itens \xe9 ${length}.`,
    ru: (length)=>`\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435} \u{43A}\u{43E}\u{43B}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{43E} \u{43F}\u{440}\u{435}\u{434}\u{43C}\u{435}\u{442}\u{43E}\u{432} \u{2014} ${length}.`,
    sm: (length)=>`O le aofa'i aupito maualuga o aitema o le ${length}.`,
    so: (length)=>`Tirada ugu badan ee alaabta waa ${length}.`,
    th: (length)=>`\u{E08}\u{E4D}\u{E32}\u{E19}\u{E27}\u{E19}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E39}\u{E07}\u{E2A}\u{E38}\u{E14}\u{E04}\u{E37}\u{E2D} ${length} \u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}`,
    ur: (length)=>`\u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{633}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{627}\u{634}\u{6CC}\u{627}\u{621} ${length} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (length)=>`S\u{1ED1} l\u{1B0}\u{1EE3}ng m\u{1EB7}t h\xe0ng t\u{1ED1}i \u{111}a l\xe0 ${length}.`,
    'zh-hans': (length)=>`\u{6700}\u{591A}\u{53EF}\u{643A}\u{5E26} ${length}\u{4EF6}\u{7269}\u{54C1}\u{3002}`,
    'zh-hant': (length)=>`\u{6700}\u{591A}\u{53EF}\u{85CF} ${length}\u{4EF6}\u{3002}`,
    en: (length)=>`Maximum number of items is ${length}.`
};
const $b11db1b62d4a8f76$export$eefaf1eea407a083 = {
    ar: (label, max)=>`\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} ${label} \u{623}\u{637}\u{648}\u{644} ${max} \u{62D}\u{631}\u{641}\u{627}.`,
    de: (label, max)=>`${label} darf nicht l\xe4nger als ${max} Zeichen sein.`,
    es: (label, max)=>`El ${label} no puede superar ${max} caracteres.`,
    fa: (label, max)=>`${label} \u{646}\u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{6CC}\u{634} \u{627}\u{632} ${max} \u{6A9}\u{627}\u{631}\u{627}\u{6A9}\u{62A}\u{631} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label, max)=>`${label} ay hindi maaaring lumampas sa ${max} character.`,
    fr: (label, max)=>`Le ${label} ne peut pas d\xe9passer ${max} caract\xe8res.`,
    hi: (label, max)=>`${label} ${max} \u{935}\u{930}\u{94D}\u{923}\u{94B}\u{902} \u{938}\u{947} \u{905}\u{927}\u{93F}\u{915} \u{932}\u{902}\u{92C}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{93E}.`,
    ht: (label, max)=>`${label} pa ka pi long pase ${max} karakt\xe8.`,
    it: (label, max)=>`Il ${label} non pu\xf2 superare ${max} caratteri.`,
    ja: (label, max)=>`${label} \u{306F} ${max} \u{6587}\u{5B57}\u{3092}\u{8D85}\u{3048}\u{3066}\u{306F}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label, max)=>`${label} \u{C740} ${max} \u{C790}\u{B97C} \u{B118}\u{C744} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label, max)=>`${label} tsis tuaj yeem ntev tshaj ${max} tus cim.`,
    ps: (label, max)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{644}\u{647} ${max} \u{62A}\u{648}\u{631}\u{648} \u{685}\u{62E}\u{647} \u{627}\u{648}\u{696}\u{62F} \u{646}\u{647} \u{648}\u{6CC}.`,
    pt: (label, max)=>`${label} n\xe3o pode ter mais de ${max} caracteres.`,
    'pt-pt': (label, max)=>`${label} n\xe3o pode ter mais de ${max} caracteres.`,
    ru: (label, max)=>`${label} \u{43D}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{434}\u{43B}\u{438}\u{43D}\u{43D}\u{435}\u{435} ${max} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{432}.`,
    sm: (label, max)=>`E le mafai ona sili atu ma ${max} mataitusi le ${label}.`,
    so: (label, max)=>`${label} ma noqon karo mid ka badan ${max} xaraf.`,
    th: (label, max)=>`${label} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E04}\u{E27}\u{E32}\u{E21}\u{E22}\u{E32}\u{E27}\u{E44}\u{E21}\u{E48}\u{E40}\u{E01}\u{E34}\u{E19} ${max} \u{E2D}\u{E31}\u{E01}\u{E02}\u{E23}\u{E30}`,
    ur: (label, max)=>`${label} ${max} \u{62D}\u{631}\u{648}\u{641} \u{633}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{644}\u{645}\u{628}\u{627} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}\u{6D4}`,
    vi: (label, max)=>`${label} kh\xf4ng \u{111}\u{1B0}\u{1EE3}c d\xe0i h\u{1A1}n ${max} k\xfd t\u{1EF1}.`,
    'zh-hans': (label, max)=>`${label} \u{4E0D}\u{5F97}\u{8D85}\u{8FC7} ${max} \u{4E2A}\u{5B57}\u{7B26}\u{3002}`,
    'zh-hant': (label, max)=>`${label} \u{4E0D}\u{5F97}\u{8D85}\u{904E} ${max} \u{500B}\u{5B57}\u{5143}\u{3002}`,
    en: (label, max)=>`${label} cannot be longer than ${max} characters.`
};
const $b11db1b62d4a8f76$export$7090c56f2894c141 = {
    ar: (label, max)=>`\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} ${label} \u{623}\u{643}\u{628}\u{631} ${max}.`,
    de: (label, max)=>`${label} darf nicht gr\xf6\xdfer als ${max} sein.`,
    es: (label, max)=>`El ${label} no puede ser mayor de ${max}.`,
    fa: (label, max)=>`${label} \u{646}\u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{6CC}\u{634}\u{62A}\u{631} ${max} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label, max)=>`${label} ay hindi maaaring hihigit sa ${max}.`,
    fr: (label, max)=>`${label} ne peut pas d\xe9passer ${max}.`,
    hi: (label, max)=>`${label} ${max} \u{938}\u{947} \u{905}\u{927}\u{93F}\u{915} \u{928}\u{939}\u{940}\u{902} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{93E}\u{964}`,
    ht: (label, max)=>`${label} pa ka pi gran pase ${max}`,
    it: (label, max)=>`${label} non pu\xf2 superare ${max}.`,
    ja: (label, max)=>`${label} \u{306F} ${max}\u{3092}\u{8D85}\u{3048}\u{3066}\u{306F}\u{3044}\u{3051}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label, max)=>`${label} \u{C740} ${max}\u{C744} \u{B118}\u{C744} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label, max)=>`${label} tsis tuaj yeem ntau tshaj ${max}.`,
    ps: (label, max)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{644}\u{647} ${max} \u{685}\u{62E}\u{647} \u{632}\u{6CC}\u{627}\u{62A} \u{646}\u{647} \u{648}\u{6CC}.`,
    pt: (label, max)=>`${label} n\xe3o pode ser maior que ${max}.`,
    'pt-pt': (label, max)=>`${label} n\xe3o pode ser superior ${max}.`,
    ru: (label, max)=>`${label} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} ${max}.`,
    sm: (label, max)=>`O ${label} le mafai ona sili atu nai lo ${max}.`,
    so: (label, max)=>`${label} ma noqon karo mid ka weyn ${max}.`,
    th: (label, max)=>`${label}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E44}\u{E21}\u{E48}\u{E40}\u{E01}\u{E34}\u{E19} ${max}`,
    ur: (label, max)=>`${label} ${max} \u{633}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648} \u{633}\u{6A9}\u{62A}\u{627}\u{6D4}`,
    vi: (label, max)=>`${label} kh\xf4ng \u{111}\u{1B0}\u{1EE3}c l\u{1EDB}n h\u{1A1}n ${max}.`,
    'zh-hans': (label, max)=>`${label} \u{4E0D}\u{80FD}\u{8D85}\u{8FC7} ${max}\u{3002}`,
    'zh-hant': (label, max)=>`${label} \u{4E0D}\u{80FD}\u{8D85}\u{904E} ${max}\u{3002}`,
    en: (label, max)=>`${label} cannot be greater than ${max}.`
};
const $b11db1b62d4a8f76$export$9138bb72343fb2ba = {
    ar: (label, min)=>`\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${label} \u{639}\u{644}\u{649} ${min} \u{623}\u{62D}\u{631}\u{641} \u{641}\u{642}\u{637}.`,
    de: (label, min)=>`${label} muss mindestens ${min} Zeichen umfassen.`,
    es: (label, min)=>`El ${label} debe tener al ${min} caracteres.`,
    fa: (label, min)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{62D}\u{62F}\u{627}\u{642}\u{644} ${min} \u{6A9}\u{627}\u{631}\u{627}\u{6A9}\u{62A}\u{631} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label, min)=>`${label} ay dapat na hindi bababa sa ${min} character.`,
    fr: (label, min)=>`Le ${label} doit comporter au ${min} caract\xe8res.`,
    hi: (label, min)=>`${label} \u{915}\u{92E} \u{938}\u{947} \u{915}\u{92E} ${min} \u{905}\u{915}\u{94D}\u{937}\u{930}\u{94B}\u{902} \u{915}\u{93E} \u{939}\u{94B}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}\u{964}`,
    ht: (label, min)=>`${label} dwe omwen ${min} karakt\xe8.`,
    it: (label, min)=>`Il ${label} deve avere almeno ${min} caratteri.`,
    ja: (label, min)=>`${label} \u{306F}\u{6700}\u{4F4E} ${min} \u{6587}\u{5B57}\u{3067}\u{306A}\u{3051}\u{308C}\u{3070}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label, min)=>`${label} \u{C740} \u{CD5C}\u{C18C} ${min} \u{C790} \u{C774}\u{C0C1}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (label, min)=>`${label} yuav tsum muaj tsawg ${min} tus cim.`,
    ps: (label, min)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{644}\u{696} \u{62A}\u{631} \u{644}\u{696}\u{647} ${min} \u{6A9}\u{631}\u{6A9}\u{67C}\u{631}\u{648}\u{646}\u{647} \u{648}\u{6CC}.`,
    pt: (label, min)=>`${label} deve ter pelo ${min} caracteres.`,
    'pt-pt': (label, min)=>`${label} deve ter pelo ${min} caracteres.`,
    ru: (label, min)=>`${label} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{435} \u{43C}\u{435}\u{43D}\u{435}\u{435} ${min} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{432}.`,
    sm: (label, min)=>`${label} e tatau ona le itiiti ifo ma ${min} mataitusi.`,
    so: (label, min)=>`${label} waa inuu noqdaa ugu yaraan ${min} xaraf.`,
    th: (label, min)=>`${label} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E19}\u{E49}\u{E2D}\u{E22} ${min} \u{E2D}\u{E31}\u{E01}\u{E02}\u{E23}\u{E30}`,
    ur: (label, min)=>`${label} \u{6A9}\u{645} \u{627}\u{632} \u{6A9}\u{645} ${min} \u{62D}\u{631}\u{648}\u{641} \u{67E}\u{631} \u{645}\u{634}\u{62A}\u{645}\u{644} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}\u{6D4}`,
    vi: (label, min)=>`${label} ph\u{1EA3}i c\xf3 \xedt nh\u{1EA5}t ${min} k\xfd t\u{1EF1}.`,
    'zh-hans': (label, min)=>`${label} \u{5FC5}\u{987B}\u{81F3}\u{5C11}\u{6709} ${min} \u{4E2A}\u{5B57}\u{7B26}\u{3002}`,
    'zh-hant': (label, min)=>`${label} \u{5FC5}\u{9808}\u{81F3}\u{5C11}\u{6709} ${min} \u{5B57}\u{5143}\u{3002}`,
    en: (label, min)=>`${label} must be at least ${min} characters.`
};
const $b11db1b62d4a8f76$export$76d1215b01ac474d = {
    ar: (label, min)=>`\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${label} \u{623}\u{642}\u{644} ${min}.`,
    de: (label, min)=>`${label} darf nicht kleiner als ${min} sein.`,
    es: (label, min)=>`${label} no puede ser menor de ${min}.`,
    fa: (label, min)=>`${label} \u{646}\u{628}\u{627}\u{6CC}\u{62F} \u{6A9}\u{645}\u{62A}\u{631} ${min} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label, min)=>`${label} ay hindi maaaring mas mababa sa ${min}.`,
    fr: (label, min)=>`${label} ne doit pas \xeatre inf\xe9rieur ${min}.`,
    hi: (label, min)=>`${label} ${min} \u{938}\u{947} \u{915}\u{92E} \u{928}\u{939}\u{940}\u{902} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{93E}\u{964}`,
    ht: (label, min)=>`${label} pa ka mwens pase ${min}`,
    it: (label, min)=>`${label} non pu\xf2 essere inferiore ${min}.`,
    ja: (label, min)=>`${label} \u{306F} ${min}\u{672A}\u{6E80}\u{3067}\u{3042}\u{3063}\u{3066}\u{306F}\u{306A}\u{3089}\u{306A}\u{3044}\u{3002}`,
    ko: (label, min)=>`${label} \u{C774} ${min} \u{C774}\u{D558}\u{C77C} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label, min)=>`${label} tsis tuaj yeem tsawg ${min}.`,
    ps: (label, min)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{644}\u{647} ${min} \u{685}\u{62E}\u{647} \u{6A9}\u{645} \u{646}\u{647} \u{648}\u{6CC}.`,
    pt: (label, min)=>`${label} n\xe3o pode ser menor que ${min}.`,
    'pt-pt': (label, min)=>`${label} n\xe3o pode ser inferior ${min}.`,
    ru: (label, min)=>`${label} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44C}\u{448}\u{435} ${min}.`,
    sm: (label, min)=>`${label} e le mafai ona itiiti ifo ma ${min}.`,
    so: (label, min)=>`${label} ma noqon karo mid ka yar ${min}.`,
    th: (label, min)=>`${label}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E44}\u{E21}\u{E48}\u{E19}\u{E49}\u{E2D}\u{E22}\u{E01}\u{E27}\u{E48}\u{E32} ${min}`,
    ur: (label, min)=>`${label} ${min} \u{633}\u{6D2} \u{6A9}\u{645} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648} \u{633}\u{6A9}\u{62A}\u{627}\u{6D4}`,
    vi: (label, min)=>`${label} kh\xf4ng \u{111}\u{1B0}\u{1EE3}c nh\u{1ECF} h\u{1A1}n ${min}.`,
    'zh-hans': (label, min)=>`${label} \u{4E0D}\u{80FD}\u{5C11}\u{4E8E} ${min}\u{3002}`,
    'zh-hant': (label, min)=>`${label} \u{4E0D}\u{80FD}\u{5C11}\u{65BC} ${min}\u{3002}`,
    en: (label, min)=>`${label} cannot be less than ${min}.`
};
const $b11db1b62d4a8f76$export$b79fa817bdc814b1 = {
    ar: (label, step)=>`\u{64A}\u{62C}\u{628} ${label} \u{645}\u{636}\u{627}\u{639}\u{641}\u{627} ${step}`,
    de: (label, step)=>`${label} muss ein Vielfaches von ${step} sein`,
    es: (label, step)=>`${label} debe ser m\xfaltiplo de ${step}`,
    fa: (label, step)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{645}\u{636}\u{631}\u{628}\u{6CC} ${step} \u{628}\u{627}\u{634}\u{62F}`,
    fil: (label, step)=>`Ang ${label} ay dapat na maramihang ${step}`,
    fr: (label, step)=>`${label} doit \xeatre un multiple de ${step}`,
    hi: (label, step)=>`${label} ${step} \u{915}\u{93E} \u{917}\u{941}\u{923}\u{91C} \u{939}\u{94B}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}`,
    ht: (label, step)=>`${label} dwe yon miltip nan ${step}`,
    it: (label, step)=>`${label} deve essere un multiplo di ${step}`,
    ja: (label, step)=>`${label}\u{306F}${step}\u{306E}\u{500D}\u{6570}\u{3067}\u{306A}\u{3051}\u{308C}\u{3070}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: (label, step)=>`${label}\u{C740} ${step}\u{C758} \u{BC30}\u{C218}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`,
    mww: (label, step)=>`${label} yuav tsum yog qhov sib npaug ntawm ${step}`,
    ps: (label, step)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{62F} ${step} \u{636}\u{631}\u{628} \u{648}\u{6CC}`,
    pt: (label, step)=>`${label} deve ser m\xfaltiplo de ${step}`,
    'pt-pt': (label, step)=>`${label} deve ser m\xfaltiplo de ${step}`,
    ru: (label, step)=>`${label} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{44B}\u{43C} ${step}`,
    sm: (label, step)=>`${label} e tatau ona i ai se numera o le ${step}`,
    so: (label, step)=>`${label} waa inuu noqdaa tiro ${step}`,
    th: (label, step)=>`${label} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E17}\u{E27}\u{E35}\u{E04}\u{E39}\u{E13}\u{E02}\u{E2D}\u{E07} ${step}`,
    ur: (label, step)=>`${label} ${step} \u{6A9}\u{627} \u{645}\u{636}\u{631}\u{628} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`,
    vi: (label, step)=>`${label} ph\u{1EA3}i l\xe0 b\u{1ED9}i s\u{1ED1} c\u{1EE7}a ${step}`,
    'zh-hans': (label, step)=>`${label}\u{5FC5}\u{987B}\u{662F}${step}\u{7684}\u{500D}\u{6570}`,
    'zh-hant': (label, step)=>`${label}\u{5FC5}\u{9808}\u{662F}${step}\u{7684}\u{500D}\u{6578}`,
    en: (label, step)=>`${label} must be a multiple of ${step}`
};
const $b11db1b62d4a8f76$export$4f13f582f2377533 = {
    ar: (label, step)=>`\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${label} \u{628}\u{641}\u{62A}\u{631}\u{627}\u{62A} ${step} \u{62F}\u{642}\u{64A}\u{642}\u{629}.`,
    de: (label, step)=>`${label} muss in ${step} Minuten angegeben werden.`,
    es: (label, step)=>`El ${label} debe estar en incrementos de ${step} minutos.`,
    fa: (label, step)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{62F}\u{631} \u{628}\u{627}\u{632}\u{647} ${step} \u{62F}\u{642}\u{6CC}\u{642}\u{647} \u{627}\u{6CC} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label, step)=>`${label} ay dapat na nasa increments ng ${step} minuto.`,
    fr: (label, step)=>`Le ${label} doit \xeatre fait par incr\xe9ments de ${step} minutes.`,
    hi: (label, step)=>`${label} ${step} \u{92E}\u{93F}\u{928}\u{91F} \u{915}\u{940} \u{935}\u{943}\u{926}\u{94D}\u{927}\u{93F} \u{92E}\u{947}\u{902} \u{939}\u{94B}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}\u{964}`,
    ht: (label, step)=>`${label} dwe nan ogmantasyon ${step} minit.`,
    it: (label, step)=>`Il ${label} deve essere fatto a intervalli di ${step} minuti.`,
    ja: (label, step)=>`${label} \u{306F} ${step} \u{5206}\u{5358}\u{4F4D}\u{3067}\u{8A18}\u{8F09}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: (label, step)=>`${label} \u{C740} ${step} \u{BD84} \u{B2E8}\u{C704}\u{B85C} \u{D45C}\u{C2DC}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (label, step)=>`${label} yuav tsum nce ${step} feeb.`,
    ps: (label, step)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{67E}\u{647} ${step} \u{62F}\u{642}\u{6CC}\u{642}\u{648} \u{6A9}\u{6D0} \u{648}\u{6CC}.`,
    pt: (label, step)=>`${label} deve ser em incrementos de ${step} minutos.`,
    'pt-pt': (label, step)=>`O ${label} deve estar em incrementos de ${step} minutos.`,
    ru: (label, step)=>`${label} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{430}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{43E} \u{441} ${step} \u{43C}\u{438}\u{43D}\u{443}\u{442}.`,
    sm: (label, step)=>`${label} e tatau ona i ai i se faaopoopoga o le ${step} minute.`,
    so: (label, step)=>`${label} waa inuu noqdaa qayb ${step} daqiiqo.`,
    th: (label, step)=>`${label} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E02}\u{E36}\u{E49}\u{E19}\u{E17}\u{E35}\u{E25}\u{E30} ${step} \u{E19}\u{E32}\u{E17}\u{E35}`,
    ur: (label, step)=>`${label} ${step} \u{645}\u{646}\u{679} \u{6A9}\u{6D2} \u{648}\u{642}\u{641}\u{648}\u{6BA} \u{645}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}\u{6D4}`,
    vi: (label, step)=>`${label} ph\u{1EA3}i t\u{103}ng d\u{1EA7}n ${step} ph\xfat.`,
    'zh-hans': (label, step)=>`${label} \u{5FC5}\u{987B}\u{4EE5} ${step} \u{5206}\u{949F}\u{4E3A}\u{5355}\u{4F4D}\u{3002}`,
    'zh-hant': (label, step)=>`${label} \u{5FC5}\u{9808}\u{4EE5} ${step} \u{5206}\u{9418}\u{70BA}\u{55AE}\u{4F4D}\u{3002}`,
    en: (label, step)=>`${label} must be in increments of ${step} minutes.`
};
const $b11db1b62d4a8f76$export$433bde3ee140c661 = {
    ar: (label)=>`${label} \u{645}\u{637}\u{644}\u{648}\u{628}.`,
    de: (label)=>`${label} ist erforderlich.`,
    es: (label)=>`Se ${label}.`,
    fa: (label)=>`${label} \u{644}\u{627}\u{632}\u{645} \u{627}\u{633}\u{62A}.`,
    fil: (label)=>`Kinakailangan ang ${label}.`,
    fr: (label)=>`${label} est requis.`,
    hi: (label)=>`${label} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (label)=>`${label} obligatwa`,
    it: (label)=>`Il ${label} \xe8 richiesto.`,
    ja: (label)=>`${label} \u{304C}\u{5FC5}\u{8981}\u{3067}\u{3059}\u{3002}`,
    ko: (label)=>`${label} \u{C774} \u{D544}\u{C694}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`Yuav tsum ${label}.`,
    ps: (label)=>`${label} \u{627}\u{693}\u{6CC}\u{646} \u{62F}\u{6CC}.`,
    pt: (label)=>`${label} \xe9 obrigat\xf3rio.`,
    'pt-pt': (label)=>`${label} \xe9 obrigat\xf3rio.`,
    ru: (label)=>`${label} \u{43E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}.`,
    sm: (label)=>`E mana'omia le ${label}.`,
    so: (label)=>`${label} ayaa loo baahan yahay.`,
    th: (label)=>`\u{E15}\u{E49}\u{E2D}\u{E07}\u{E23}\u{E30}\u{E1A}\u{E38}${label}`,
    ur: (label)=>`${label} \u{62F}\u{631}\u{6A9}\u{627}\u{631} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (label)=>`${label} l\xe0 b\u{1EAF}t bu\u{1ED9}c.`,
    'zh-hans': (label)=>`\u{9700}\u{8981}${label}\u{3002}`,
    'zh-hant': (label)=>`\u{9700}${label}\u{3002}`,
    en: (label)=>`${label} is required.`
};
const $b11db1b62d4a8f76$export$410707f7b09eb086 = {
    ar: (label)=>`\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${label} \u{635}\u{627}\u{644}\u{62D}\u{627} \u{645}\u{639} \u{635}\u{628}\u{627}\u{62D} \u{623}\u{648} \u{645}\u{633}\u{627}\u{621}\u{60C} \u{645}\u{62B}\u{644} 7 \u{635}\u{628}\u{627}\u{62D}\u{627} \u{623}\u{648} 7:15 \u{645}\u{633}\u{627}\u{621}.`,
    de: (label)=>`${label} muss mit morgens oder abends g\xfcltig sein, zum Beispiel 7 Uhr morgens oder 19:15 Uhr.`,
    es: (label)=>`${label} debe ser v\xe1lida con la ma\xf1ana o la tarde, como las 7 o las 7:15 de la tarde.`,
    fa: (label)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{627} \u{633}\u{627}\u{639}\u{62A} \u{635}\u{628}\u{62D} \u{6CC}\u{627} \u{639}\u{635}\u{631} \u{645}\u{639}\u{62A}\u{628}\u{631} \u{628}\u{627}\u{634}\u{62F}\u{60C} \u{645}\u{62B}\u{644}\u{627} \u{633}\u{627}\u{639}\u{62A} \u{6F7} \u{635}\u{628}\u{62D} \u{6CC}\u{627} \u{6F7}:\u{6F1}\u{6F5} \u{639}\u{635}\u{631}.`,
    fil: (label)=>`${label} ay dapat na isang wastong oras sa AM o PM, tulad ng 7am o 7:15pm.`,
    fr: (label)=>`${label} doit \xeatre valide avec le matin ou le soir, comme 7h ou 19h15.`,
    hi: (label)=>`${label} \u{938}\u{941}\u{92C}\u{939} \u{92F}\u{93E} \u{936}\u{93E}\u{92E} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{90F}\u{915} \u{935}\u{948}\u{927} \u{938}\u{92E}\u{92F} \u{939}\u{94B}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}, \u{91C}\u{948}\u{938}\u{947} \u{938}\u{941}\u{92C}\u{939} 7 \u{92C}\u{91C}\u{947} \u{92F}\u{93E} \u{936}\u{93E}\u{92E} 7:15 \u{92C}\u{91C}\u{947}\u{964}`,
    ht: (label)=>`${label} dwe yon tan valab ak AM oswa PM, tankou 7am oswa 7:15pm.`,
    it: (label)=>`${label} deve essere valido con il mattino o il pomeriggio, ad esempio le 7:00 o le 19:15.`,
    ja: (label)=>`${label} \u{306F}\u{5348}\u{524D}\u{307E}\u{305F}\u{306F}\u{5348}\u{5F8C}\u{306E}\u{6709}\u{52B9}\u{306A}\u{6642}\u{9593}\u{3067}\u{306A}\u{3051}\u{308C}\u{3070}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}\u{4F8B}\u{3048}\u{3070}\u{3001}\u{5348}\u{524D}7\u{6642}\u{3084}\u{5348}\u{5F8C}7\u{6642}15\u{5206}\u{306A}\u{3069}\u{3067}\u{3059}\u{3002}`,
    ko: (label)=>`${label} \u{C624}\u{C804} \u{B610}\u{B294} \u{C624}\u{D6C4} \u{AE30}\u{C900} \u{C720}\u{D6A8} \u{C2DC}\u{AC04}\u{C774}\u{C5B4}\u{C57C} \u{D558}\u{BA70}, \u{C608}\u{B97C} \u{B4E4}\u{C5B4} \u{C624}\u{C804} 7\u{C2DC} \u{B610}\u{B294} \u{C624}\u{D6C4} 7\u{C2DC} 15\u{BD84}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} yuav tsum yog lub sijhawm siv tau nrog teev sawv ntxov lossis teev tsaus ntuj, xws li 7 teev sawv ntxov lossis 7:15 teev tsaus ntuj.`,
    ps: (label)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{62F} \u{633}\u{647}\u{627}\u{631} \u{6CC}\u{627} \u{645}\u{627}\u{69A}\u{627}\u{645} \u{633}\u{631}\u{647} \u{645}\u{639}\u{62A}\u{628}\u{631} \u{648}\u{6CC}\u{60C} \u{644}\u{6A9}\u{647} \u{633}\u{647}\u{627}\u{631} \u{6F7} \u{628}\u{62C}\u{6D0} \u{6CC}\u{627} \u{6F7}:\u{6F1}\u{6F5} \u{645}\u{627}\u{69A}\u{627}\u{645}.`,
    pt: (label)=>`${label} deve ser v\xe1lido com a manh\xe3 ou a tarde, como 7h ou 19h15.`,
    'pt-pt': (label)=>`${label} deve ser v\xe1lida com a manh\xe3 ou a tarde, como \xe0s 7h ou \xe0s 19h15.`,
    ru: (label)=>`${label} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{43C} \u{441} \u{443}\u{442}\u{440}\u{430} \u{438}\u{43B}\u{438} \u{432}\u{435}\u{447}\u{435}\u{440}\u{43E}\u{43C}, \u{43D}\u{430}\u{43F}\u{440}\u{438}\u{43C}\u{435}\u{440}, \u{432} 7 \u{443}\u{442}\u{440}\u{430} \u{438}\u{43B}\u{438} 19:15.`,
    sm: (label)=>`${label} e tatau ona avea ma taimi aoga ma le AM po'o le PM, e pei o le 7am po'o le 7:15pm.`,
    so: (label)=>`${label} waa inuu ahaadaa waqti sax ah marka la isticmaalo subaxnimo ama galabnimo, sida 7 subaxnimo ama 7:15 fiidnimo.`,
    th: (label)=>`${label} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E40}\u{E27}\u{E25}\u{E32}\u{E17}\u{E35}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A} AM \u{E2B}\u{E23}\u{E37}\u{E2D} PM \u{E40}\u{E0A}\u{E48}\u{E19} 7.00 \u{E19}. \u{E2B}\u{E23}\u{E37}\u{E2D} 19.15 \u{E19}.`,
    ur: (label)=>`${label} \u{635}\u{628}\u{62D} \u{6CC}\u{627} \u{634}\u{627}\u{645} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{62F}\u{631}\u{633}\u{62A} \u{648}\u{642}\u{62A} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}\u{60C} \u{62C}\u{6CC}\u{633}\u{6D2} \u{635}\u{628}\u{62D} 7 \u{628}\u{62C}\u{6D2} \u{6CC}\u{627} \u{634}\u{627}\u{645} 7:15 \u{628}\u{62C}\u{6D2}\u{6D4}`,
    vi: (label)=>`${label} ph\u{1EA3}i l\xe0 th\u{1EDD}i gian h\u{1EE3}p l\u{1EC7} v\u{1EDB}i AM ho\u{1EB7}c PM, ch\u{1EB3}ng h\u{1EA1}n nh\u{1B0} 7 gi\u{1EDD} s\xe1ng ho\u{1EB7}c 7:15 t\u{1ED1}i.`,
    'zh-hans': (label)=>`${label} \u{5FC5}\u{987B}\u{4E3A}\u{6709}\u{6548}\u{7684}\u{65F6}\u{95F4}\u{FF0C}\u{5305}\u{62EC}\u{4E0A}\u{5348}\u{6216}\u{665A}\u{4E0A}\u{FF0C}\u{5982}\u{65E9}\u{4E0A}7\u{70B9}\u{6216}\u{665A}\u{4E0A}7\u{70B9}15\u{5206}\u{3002}`,
    'zh-hant': (label)=>`${label} \u{5FC5}\u{9808}\u{662F}\u{6709}\u{6548}\u{7684}\u{6642}\u{9593}\u{FF0C}\u{5305}\u{62EC}\u{4E0A}\u{5348}\u{6216}\u{4E0B}\u{5348}\u{FF0C}\u{4F8B}\u{5982}\u{65E9}\u{4E0A}7\u{9EDE}\u{6216}\u{665A}\u{4E0A}7\u{9EDE}15\u{5206}\u{3002}`,
    en: (label)=>`${label} must be a valid time with AM or PM, such as 7am or 7:15pm.`
};
const $b11db1b62d4a8f76$export$edb12e2f2b2628ce = {
    ar: (label)=>`\u{64A}\u{62C}\u{628} ${label} \u{641}\u{631}\u{64A}\u{62F}\u{627}.`,
    de: (label)=>`${label} muss einzigartig sein.`,
    es: (label)=>`El ${label} debe ser \xfanico.`,
    fa: (label)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{645}\u{646}\u{62D}\u{635}\u{631} \u{628}\u{647} \u{641}\u{631}\u{62F} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label)=>`${label} ay dapat na natatangi.`,
    fr: (label)=>`Le ${label} doit \xeatre unique.`,
    hi: (label)=>`${label} \u{905}\u{926}\u{94D}\u{935}\u{93F}\u{924}\u{940}\u{92F} \u{939}\u{94B}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}\u{964}`,
    ht: (label)=>`${label} dwe inik.`,
    it: (label)=>`${label} deve essere unico.`,
    ja: (label)=>`${label} \u{306F}\u{552F}\u{4E00}\u{7121}\u{4E8C}\u{3067}\u{306A}\u{3051}\u{308C}\u{3070}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label)=>`${label} \u{C740} \u{ACE0}\u{C720}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} yuav tsum yog qhov tshwj xeeb.`,
    ps: (label)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{681}\u{627}\u{646}\u{6AB}\u{693}\u{6CC} \u{648}\u{6CC}.`,
    pt: (label)=>`${label} precisa ser \xfanico.`,
    'pt-pt': (label)=>`${label} tem de ser \xfanico.`,
    ru: (label)=>`${label} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{443}\u{43D}\u{438}\u{43A}\u{430}\u{43B}\u{44C}\u{43D}\u{44B}\u{43C}.`,
    sm: (label)=>`${label} e tatau ona tulaga ese.`,
    so: (label)=>`${label} waa inuu noqdaa mid gaar ah.`,
    th: (label)=>`${label} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E44}\u{E21}\u{E48}\u{E0B}\u{E49}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E19}`,
    ur: (label)=>`${label} \u{645}\u{646}\u{641}\u{631}\u{62F} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}\u{6D4}`,
    vi: (label)=>`${label} ph\u{1EA3}i l\xe0 duy nh\u{1EA5}t.`,
    'zh-hans': (label)=>`${label} \u{5FC5}\u{987B}\u{662F}\u{552F}\u{4E00}\u{7684}\u{3002}`,
    'zh-hant': (label)=>`${label} \u{5FC5}\u{9808}\u{662F}\u{552F}\u{4E00}\u{7684}\u{3002}`,
    en: (label)=>`${label} must be unique.`
};
const $b11db1b62d4a8f76$export$18d990bed133506d = {
    ar: (label, count)=>`\u{64A}\u{645}\u{643}\u{646} \u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631} \u{646}\u{641}\u{633} ${label} ${count} \u{641}\u{642}\u{637}.`,
    de: (label, count)=>`Derselbe ${label} kann nur ${count} ausgew\xe4hlt werden.`,
    es: (label, count)=>`El ${label} solo puede seleccionarse ${count} veces.`,
    fa: (label, count)=>`\u{647}\u{645}\u{627}\u{646} ${label} \u{641}\u{642}\u{637} ${count} \u{628}\u{627}\u{631} \u{642}\u{627}\u{628}\u{644} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{627}\u{633}\u{62A}.`,
    fil: (label, count)=>`Dalawang ${count} mapipili ang ${label}.`,
    fr: (label, count)=>`Le m\xeame ${label} ne peut \xeatre s\xe9lectionn\xe9 que ${count} fois.`,
    hi: (label, count)=>`\u{90F}\u{915} \u{939}\u{940} ${label} \u{915}\u{947}\u{935}\u{932} ${count} \u{92C}\u{93E}\u{930} \u{91A}\u{941}\u{928}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (label, count)=>`Menm ${label} an ka s\xe8lman ${count} fwa.`,
    it: (label, count)=>`Lo stesso ${label} pu\xf2 essere selezionato solo ${count} volte.`,
    ja: (label, count)=>`\u{540C}\u{3058} ${label} \u{306F} ${count} \u{56DE}\u{3057}\u{304B}\u{9078}\u{629E}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label, count)=>`\u{AC19}\u{C740} ${label} \u{C740} ${count} \u{B9CC} \u{C120}\u{D0DD}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label, count)=>`Tib ${label} tsuas xaiv ${count} zaug.`,
    ps: (label, count)=>`\u{6CC}\u{648} ${label} \u{6CC}\u{648}\u{627}\u{632}\u{6D0} ${count} \u{681}\u{644}\u{647} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{6D0}\u{62F}\u{627}\u{6CC} \u{634}\u{6CC}.`,
    pt: (label, count)=>`O mesmo ${label} s\xf3 pode ser selecionado ${count} vezes.`,
    'pt-pt': (label, count)=>`O mesmo ${label} s\xf3 pode ser ${count} vezes.`,
    ru: (label, count)=>`\u{41E}\u{434}\u{43D}\u{43E} ${label} \u{43C}\u{43E}\u{436}\u{43D}\u{43E} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C} ${count} \u{440}\u{430}\u{437}\u{430}.`,
    sm: (label, count)=>`O le ${label} lava lea e tasi e mafai ona filifilia na o ${count} taimi.`,
    so: (label, count)=>`${label} isku mid ah waa la dooran ${count} jeer oo kaliya.`,
    th: (label, count)=>`${label}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E01}\u{E31}\u{E19}\u{E44}\u{E14}\u{E49}\u{E40}\u{E1E}\u{E35}\u{E22}\u{E07} ${count} \u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E17}\u{E48}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}`,
    ur: (label, count)=>`\u{627}\u{6CC}\u{6A9} ${label} \u{635}\u{631}\u{641} ${count} \u{628}\u{627}\u{631} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{6CC}\u{627} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (label, count)=>`C\xf9ng m\u{1ED9}t ${label} ch\u{1EC9} c\xf3 th\u{1EC3} \u{111}\u{1B0}\u{1EE3}c ch\u{1ECD}n ${count} l\u{1EA7}n.`,
    'zh-hans': (label, count)=>`\u{540C} ${label} \u{53EA}\u{80FD}\u{9009}\u{62E9} ${count} \u{3002}`,
    'zh-hant': (label, count)=>`\u{540C} ${label} \u{53EA}\u{80FD}\u{9078} ${count} \u{3002}`,
    en: (label, count)=>`The same ${label} can only be selected ${count} times.`
};
const $b11db1b62d4a8f76$export$799b086346acd04d = {
    ar: `\u{62F}\u{639}\u{648}\u{629} \u{645}\u{637}\u{644}\u{648}\u{628}\u{629}`,
    de: `Einladung erforderlich`,
    es: `Invitaci\xf3n requerida`,
    fa: `\u{62F}\u{639}\u{648}\u{62A} \u{646}\u{627}\u{645}\u{647} \u{644}\u{627}\u{632}\u{645} \u{627}\u{633}\u{62A}`,
    fil: `Kailangan ng imbitasyon`,
    fr: `Invitation requise`,
    hi: `\u{928}\u{93F}\u{92E}\u{902}\u{924}\u{94D}\u{930}\u{923} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915} \u{939}\u{948}`,
    ht: `Envitasyon obligatwa`,
    it: `Invito richiesto`,
    ja: `\u{62DB}\u{5F85}\u{304C}\u{5FC5}\u{8981}\u{3067}\u{3059}`,
    ko: `\u{CD08}\u{B300}\u{C7A5} \u{D544}\u{C694}`,
    mww: `Yuav tsum tau caw`,
    ps: `\u{628}\u{644}\u{646}\u{647} \u{627}\u{693}\u{6CC}\u{646}\u{647} \u{62F}\u{647}`,
    pt: `Convite necess\xe1rio`,
    'pt-pt': `Convite obrigat\xf3rio`,
    ru: `\u{422}\u{440}\u{435}\u{431}\u{443}\u{435}\u{442}\u{441}\u{44F} \u{43F}\u{440}\u{438}\u{433}\u{43B}\u{430}\u{448}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Manaomia le valaaulia`,
    so: `Casuumaad ayaa loo baahan yahay`,
    th: `\u{E15}\u{E49}\u{E2D}\u{E07}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E04}\u{E4D}\u{E32}\u{E40}\u{E0A}\u{E34}\u{E0D}`,
    ur: `\u{62F}\u{639}\u{648}\u{62A} \u{646}\u{627}\u{645}\u{6C1} \u{62F}\u{631}\u{6A9}\u{627}\u{631}`,
    vi: `Y\xeau c\u{1EA7}u l\u{1EDD}i m\u{1EDD}i`,
    'zh-hans': `\u{9700}\u{9080}\u{8BF7}`,
    'zh-hant': `\u{9700}\u{9080}\u{8ACB}\u{51FD}`,
    en: `Invitation required`
};
const $b11db1b62d4a8f76$export$8de27a4942de48e1 = {
    ar: (email)=>$b11db1b62d4a8f76$var$html`لم يتم العثور على دعوة مفتوحة <span class="text-bold">${email}</span>. إذا تلقيت بريد دعوة إلكتروني، تأكد أنك تستخدم نفس عنوان البريد الإلكتروني الذي أرسلت إليه الدعوة. وإلا، اطلب من المسؤول إرسال دعوة جديدة.`,
    de: (email)=>$b11db1b62d4a8f76$var$html`Keine offene Einladung für <span class="text-bold">${email}</span> gefunden. Wenn Sie eine Einladung per E-Mail erhalten haben, bestätigen Sie, dass Sie dieselbe E-Mail-Adresse verwenden, an die die Einladung gesendet wurde. Ansonsten bitten Sie Ihren Administrator, eine neue Einladung zu senden.`,
    es: (email)=>$b11db1b62d4a8f76$var$html`No se encontró ninguna invitación abierta para <span class="text-bold">${email}</span>. Si recibiste un correo de invitación, confirma que estás usando la misma dirección de correo a la que se envió la invitación. Si no, pide a tu administrador que envíe una nueva invitación.`,
    fa: (email)=>$b11db1b62d4a8f76$var$html`هیچ دعوت نامه باز برای <span class="text-bold">${email}</span> پیدا نشد. اگر ایمیل دعوت نامه دریافت کرده اید، تأیید کنید که از همان آدرس ایمیلی که دعوت نامه به آن ارسال شده استفاده می کنید. در غیر این صورت، از مدیر خود بخواهید دعوت نامه جدیدی ارسال کند.`,
    fil: (email)=>$b11db1b62d4a8f76$var$html`Walang natagpuang bukas na imbitasyon para <span class="text-bold">${email}</span>. Kung nakatanggap ka ng email ng imbitasyon, kumpirmahin na ginagamit mo ang parehong email address na ipinadala sa imbitasyon. Kung hindi, hilingin sa iyong administrator na magpadala ng bagong imbitasyon.`,
    fr: (email)=>$b11db1b62d4a8f76$var$html`Aucune invitation ouverte n’a été trouvée pour <span class="text-bold">${email}</span>. Si vous avez reçu un e-mail d’invitation, confirmez que vous utilisez la même adresse e-mail à laquelle l’invitation a été envoyée. Sinon, demandez à votre administrateur d’envoyer une nouvelle invitation.`,
    hi: (email)=>$b11db1b62d4a8f76$var$html`<span class="text-bold">${email}</span> लिए कोई खुला आमंत्रण नहीं मिला। अगर आपको कोई आमंत्रण ईमेल प्राप्त हुआ है, तो पुष्टि करें कि आप उसी ईमेल पते का उपयोग कर रहे हैं जिस पर आमंत्रण भेजा गया था. अन्यथा, अपने व्यवस्थापक से एक नया आमंत्रण भेजने के लिए कहें.`,
    ht: (email)=>$b11db1b62d4a8f76$var$html`Pa gen envitasyon louvri yo te jwenn pou <span class="text-bold">${email}</span> Si ou te resevwa yon imèl envitasyon, konfime w ap itilize menm adrès imel envitasyon an te voye. Sinon, mande administratè ou a voye yon nouvo envitasyon.`,
    it: (email)=>$b11db1b62d4a8f76$var$html`Nessun invito aperto per <span class="text-bold">${email}</span>. Se hai ricevuto un'email di invito, conferma di utilizzare lo stesso indirizzo email a cui è stato inviato l'invito. Altrimenti, chiedi al tuo amministratore di inviare un nuovo invito.`,
    ja: (email)=>$b11db1b62d4a8f76$var$html`<span class="text-bold">${email}</span> にオープンな招待状は見つかりませんでした。招待メールを受け取った場合は、招待状が送られたメールアドレスと同じアドレスを使っているか確認してください。そうでなければ、管理者に新しい招待状を送ってもらうよう依頼してください。`,
    ko: (email)=>$b11db1b62d4a8f76$var$html`<span class="text-bold">${email}</span> 에 대한 공개 초대는 찾지 못했습니다. 초대 이메일을 받았다면, 초대장이 발송된 이메일 주소와 동일한지 확인하세요. 그렇지 않으면 관리자에게 새 초대장을 보내달라고 요청하세요.`,
    mww: (email)=>$b11db1b62d4a8f76$var$html`Tsis muaj kev caw qhib pom <span class="text-bold">${email}</span>. Yog tias koj tau txais email caw, paub tseeb tias koj siv tib tus email chaw nyob uas qhov kev caw tau xa mus. Txwv tsis pub, nug koj tus thawj tswj hwm kom xa ib daim ntawv caw tshiab.`,
    ps: (email)=>$b11db1b62d4a8f76$var$html`هیڅ خلاصه بلنه نه ده موندل <span class="text-bold">${email}</span>. که تاسو د بلنې ایمیل ترلاسه کړی، تایید کړئ چې تاسو هماغه ایمیل پته کاروئ چې بلنه ورته لیږل شوې وه. که نه، خپل مدیر ته ووایه چې نوې بلنه واستوی.`,
    pt: (email)=>$b11db1b62d4a8f76$var$html`Não foi encontrado nenhum convite aberto para <span class="text-bold">${email}</span>. Se você recebeu um e-mail de convite, confirme que está usando o mesmo endereço de e-mail para o qual o convite foi enviado. Caso contrário, peça ao seu administrador para enviar um novo convite.`,
    'pt-pt': (email)=>$b11db1b62d4a8f76$var$html`Não foi encontrado nenhum convite aberto para <span class="text-bold">${email}</span>. Se recebeu um e-mail de convite, confirme que está a usar o mesmo endereço de email para onde o convite foi enviado. Caso contrário, peça ao seu administrador para enviar um novo convite.`,
    ru: (email)=>$b11db1b62d4a8f76$var$html`Открытого приглашения для <span class="text-bold">${email}</span> не найдено. Если вы получили приглашение, подтвердите, что используете тот же адрес, на который было отправлено приглашение. В противном случае попросите администратора отправить новое приглашение.`,
    sm: (email)=>$b11db1b62d4a8f76$var$html`E leai se valaaulia tatala na maua mo <span class="text-bold">${email}</span>. Afai na e mauaina se imeli valaaulia, ia faamaonia o loo e faaaogaina le tuatusi imeli lava lea e tasi na auina atu i ai le valaaulia. A leai, fai atu i lou pule e auina mai se valaaulia fou.`,
    so: (email)=>$b11db1b62d4a8f76$var$html`Ma jirto casuumaad furan <span class="text-bold">${email}</span>. Haddii aad heshay email casuumaad ah, xaqiiji inaad isticmaalayso isla cinwaanka email-ka ee casuumaadku loo diray. Haddii kale, weydii maamulahaaga inuu soo diro casuumaad cusub.`,
    th: (email)=>$b11db1b62d4a8f76$var$html`ไม่พบคําเชิญที่เปิดอยู่สําหรับ <span class="text-bold">${email}</span> หากคุณได้รับอีเมลคําเชิญ ให้ยืนยันว่าคุณใช้ที่อยู่อีเมลเดียวกันกับที่ส่งคําเชิญไปให้ มิฉะนั้น ให้ขอให้ผู้ดูแลระบบส่งคําเชิญใหม่`,
    ur: (email)=>$b11db1b62d4a8f76$var$html`<span class="text-bold">${email}</span> کے لیے کوئی کھلا دعوت نامہ نہیں ملا۔ اگر آپ کو دعوت نامہ ای میل موصول ہوا ہے تو تصدیق کریں کہ آپ وہی ای میل ایڈریس استعمال کر رہے ہیں جس پر دعوت نامہ بھیجا گیا تھا۔ ورنہ، اپنے ایڈمنسٹریٹر سے کہیں کہ نیا دعوت نامہ بھیجے۔`,
    vi: (email)=>$b11db1b62d4a8f76$var$html`Không tìm thấy lời mời mở cho <span class="text-bold">${email}</span>. Nếu bạn nhận được email mời, hãy xác nhận rằng bạn đang sử dụng cùng địa chỉ email mà lời mời được gửi đến. Nếu không, hãy yêu cầu quản trị viên của bạn gửi lời mời mới.`,
    'zh-hans': (email)=>$b11db1b62d4a8f76$var$html`没有找到任何公开邀请 <span class="text-bold">${email}</span>。如果你收到了邀请邮件，请确认你使用的是邀请邮件发送的同一个邮箱地址。否则，请你的管理员重新发送邀请函。`,
    'zh-hant': (email)=>$b11db1b62d4a8f76$var$html`沒有找到任何公開邀請 <span class="text-bold">${email}</span>。如果你收到邀請信，請確認你使用的是邀請函寄出的同一個電子郵件地址。否則，請你的管理員重新寄出邀請函。`,
    en: (email)=>$b11db1b62d4a8f76$var$html`No open invitation found for <span class="text-bold">${email}</span>. If you received an invitation email, confirm you're using the same email address the invitation was sent to. Otherwise, ask your administrator to send a new invitation.`
};
const $b11db1b62d4a8f76$export$1c104532ca7e9cac = {
    ar: (login)=>`\u{627}\u{62F}\u{639} \u{639}\u{636}\u{648}\u{627} \u{641}\u{64A} ${login}`,
    de: (login)=>`Lade ein Mitglied von ${login} ein`,
    es: (login)=>`Invita a un miembro de ${login}`,
    fa: (login)=>`\u{639}\u{636}\u{648}\u{6CC} \u{627}\u{632} ${login} \u{631}\u{627} \u{62F}\u{639}\u{648}\u{62A} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: (login)=>`Mag-imbita ng isang miyembro ng ${login}`,
    fr: (login)=>`Invitez un membre de ${login}`,
    hi: (login)=>`${login} \u{915}\u{947} \u{915}\u{93F}\u{938}\u{940} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{915}\u{94B} \u{906}\u{92E}\u{902}\u{924}\u{94D}\u{930}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: (login)=>`Envite yon manm ${login}`,
    it: (login)=>`Invita un membro di ${login}`,
    ja: (login)=>`${login}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3092}\u{62DB}\u{5F85}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: (login)=>`${login}\u{C758} \u{D68C}\u{C6D0}\u{C744} \u{CD08}\u{B300}\u{D558}\u{C138}\u{C694}`,
    mww: (login)=>`Caw ib tug tswv cuab ntawm ${login}`,
    ps: (login)=>`\u{62F} ${login} \u{63A}\u{693}\u{6CC} \u{631}\u{627}\u{648}\u{628}\u{644}\u{644}`,
    pt: (login)=>`Convide um membro do ${login}`,
    'pt-pt': (login)=>`Convide um membro do ${login}`,
    ru: (login)=>`\u{41F}\u{440}\u{438}\u{433}\u{43B}\u{430}\u{441}\u{438}\u{442}\u{435} \u{447}\u{43B}\u{435}\u{43D}\u{430} ${login}`,
    sm: (login)=>`Valaaulia se tagata o le ${login}`,
    so: (login)=>`Casuum xubin ${login}`,
    th: (login)=>`\u{E40}\u{E0A}\u{E34}\u{E0D}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07} ${login}`,
    ur: (login)=>`${login} \u{6A9}\u{6D2} \u{6A9}\u{633}\u{6CC} \u{631}\u{6A9}\u{646} \u{6A9}\u{648} \u{645}\u{62F}\u{639}\u{648} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: (login)=>`M\u{1EDD}i m\u{1ED9}t th\xe0nh vi\xean c\u{1EE7}a ${login}`,
    'zh-hans': (login)=>`\u{9080}\u{8BF7}${login}\u{7684}\u{4E00}\u{4F4D}\u{6210}\u{5458}`,
    'zh-hant': (login)=>`\u{9080}\u{8ACB}${login}\u{7684}\u{6210}\u{54E1}`,
    en: (login)=>`Invite a member of ${login}`
};
const $b11db1b62d4a8f76$export$1c1f62683fb8f = {
    ar: `\u{627}\u{644}\u{641}\u{648}\u{627}\u{62A}\u{64A}\u{631}`,
    de: `Rechnungen`,
    es: `Facturas`,
    fa: `\u{641}\u{627}\u{6A9}\u{62A}\u{648}\u{631}\u{647}\u{627}`,
    fil: `Email Address *`,
    fr: `Factures`,
    hi: `\u{91A}\u{93E}\u{932}\u{93E}\u{928}`,
    ht: `Fakti yo`,
    it: `Fatture`,
    ja: `\u{8ACB}\u{6C42}\u{66F8}`,
    ko: `\u{C1A1}\u{C7A5}`,
    mww: `Cov ntawv sau nqi`,
    ps: `\u{631}\u{633}\u{6CC}\u{62F}\u{648}\u{646}\u{647}`,
    pt: `Faturas`,
    'pt-pt': `Faturas`,
    ru: `\u{421}\u{447}\u{435}\u{442}\u{430}`,
    sm: `Pili`,
    so: `Biilasha`,
    th: `\u{E43}\u{E1A}\u{E41}\u{E08}\u{E49}\u{E07}\u{E2B}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{646}\u{648}\u{627}\u{626}\u{633}\u{632}`,
    vi: `H\xf3a \u{111}\u{1A1}n`,
    'zh-hans': `\u{53D1}\u{7968}`,
    'zh-hant': `\u{767C}\u{7968}`,
    en: `Invoices`
};
const $b11db1b62d4a8f76$export$20662d46cbc0efe7 = {
    ar: `\u{623}\u{646}\u{627} \u{623}\u{641}\u{647}\u{645}`,
    de: `Ich verstehe`,
    es: `Lo entiendo`,
    fa: `\u{645}\u{62A}\u{648}\u{62C}\u{647} \u{634}\u{62F}\u{645}`,
    fil: `Naiintindihan ko`,
    fr: `Je comprends`,
    hi: `\u{92E}\u{948}\u{902} \u{938}\u{92E}\u{91D}\u{924}\u{93E} \u{939}\u{942}\u{901}`,
    ht: `Mwen konprann`,
    it: `Capisco`,
    ja: `\u{308F}\u{304B}\u{308A}\u{307E}\u{3057}\u{305F}`,
    ko: `\u{C774}\u{D574}\u{D569}\u{B2C8}\u{B2E4}`,
    mww: `Kuv nkag siab`,
    ps: `\u{632}\u{647} \u{67E}\u{648}\u{647}\u{6D0}\u{696}\u{645}`,
    pt: `Eu entendo`,
    'pt-pt': `Compreendo`,
    ru: `\u{41F}\u{43E}\u{43D}\u{438}\u{43C}\u{430}\u{44E}`,
    sm: `Oute malamalama`,
    so: `Waan ku fahmaa`,
    th: `\u{E09}\u{E31}\u{E19}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E08}`,
    ur: `\u{645}\u{6CC}\u{6BA} \u{633}\u{645}\u{62C}\u{6BE}\u{62A}\u{627} \u{6C1}\u{648}\u{6BA}`,
    vi: `T\xf4i hi\u{1EC3}u`,
    'zh-hans': `\u{6211}\u{660E}\u{767D}`,
    'zh-hant': `\u{6211}\u{660E}\u{767D}`,
    en: `I understand`
};
const $b11db1b62d4a8f76$export$1590a27f0f1e7951 = {
    ar: `\u{623}\u{646}\u{627} \u{623}\u{633}\u{62A}\u{643}\u{634}\u{641} Cumulus \u{644}\u{645}\u{646}\u{638}\u{645}\u{62A}\u{64A}`,
    de: `Ich erkunde Cumulus f\xfcr meine Organisation`,
    es: `Estoy explorando Cumulus para mi organizaci\xf3n`,
    fa: `\u{645}\u{646} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{6A9}\u{627}\u{648}\u{634} \u{62F}\u{631} Cumulus \u{628}\u{631}\u{627}\u{6CC} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{645} \u{647}\u{633}\u{62A}\u{645}`,
    fil: `Ginalugad ko ang Cumulus para sa aking organisasyon`,
    fr: `J\u{2019}explore Cumulus pour mon organisation`,
    hi: `\u{92E}\u{948}\u{902} \u{905}\u{92A}\u{928}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{94D}\u{92F}\u{932}\u{938} \u{915}\u{940} \u{916}\u{94B}\u{91C} \u{915}\u{930} \u{930}\u{939}\u{93E} \u{939}\u{942}\u{902}`,
    ht: `Mwen eksplore Cumulus pou \xf2ganizasyon mwen an`,
    it: `Sto esplorando Cumulus per la mia organizzazione`,
    ja: `\u{79C1}\u{306F}\u{81EA}\u{5206}\u{306E}\u{7D44}\u{7E54}\u{306E}\u{305F}\u{3081}\u{306B}Cumulus\u{3092}\u{63A2}\u{6C42}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}`,
    ko: `\u{C800}\u{B294} \u{C81C} \u{C870}\u{C9C1}\u{C744} \u{C704}\u{D574} Cumulus\u{B97C} \u{D0D0}\u{C0C9}\u{D558}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Kuv tabtom tshawb nrhiav Cumulus rau kuv lub koom haum`,
    ps: `\u{632}\u{647} \u{62F} \u{62E}\u{67E}\u{644} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{644}\u{67E}\u{627}\u{631}\u{647} Cumulus \u{633}\u{67E}\u{693}\u{645}`,
    pt: `Estou explorando o Cumulus para minha organiza\xe7\xe3o`,
    'pt-pt': `Estou a explorar o Cumulus para a minha organiza\xe7\xe3o`,
    ru: `\u{42F} \u{438}\u{437}\u{443}\u{447}\u{430}\u{44E} Cumulus \u{434}\u{43B}\u{44F} \u{441}\u{432}\u{43E}\u{435}\u{439} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `O lo'o ou su'esu'eina Cumulus mo la'u fa'alapotopotoga`,
    so: `Waxaan baarayaa Cumulus ee ururkayga`,
    th: `\u{E09}\u{E31}\u{E19}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E2A}\u{E4D}\u{E32}\u{E23}\u{E27}\u{E08} Cumulus \u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E09}\u{E31}\u{E19}`,
    ur: `\u{645}\u{6CC}\u{6BA} \u{627}\u{67E}\u{646}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} Cumulus \u{6A9}\u{648} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{631} \u{631}\u{6C1}\u{627} \u{6C1}\u{648}\u{6BA}`,
    vi: `T\xf4i \u{111}ang kh\xe1m ph\xe1 Cumulus cho t\u{1ED5} ch\u{1EE9}c c\u{1EE7}a m\xecnh`,
    'zh-hans': `\u{6211}\u{6B63}\u{5728}\u{4E3A}\u{6211}\u{7684}\u{7EC4}\u{7EC7}\u{63A2}\u{7D22}Cumulus`,
    'zh-hant': `\u{6211}\u{6B63}\u{5728}\u{70BA}\u{6211}\u{7684}\u{7D44}\u{7E54}\u{63A2}\u{7D22} Cumulus`,
    en: `I am exploring Cumulus for my organization`
};
const $b11db1b62d4a8f76$export$138b109760131bdd = {
    ar: `\u{627}\u{62D}\u{62A}\u{641}\u{638}`,
    de: `Keep`,
    es: `Mantener`,
    fa: `\u{646}\u{6AF}\u{647} \u{62F}\u{627}\u{634}\u{62A}\u{646}`,
    fil: `Panatilihin`,
    fr: `Garde`,
    hi: `\u{930}\u{916}\u{928}\u{93E}`,
    ht: `Kenbe`,
    it: `Tieni`,
    ja: `\u{30AD}\u{30FC}\u{30D7}`,
    ko: `\u{C9C0}\u{D0A4}\u{C138}\u{C694}`,
    mww: `khaws cia`,
    ps: `\u{648}\u{633}\u{627}\u{62A}\u{647}`,
    pt: `Fique`,
    'pt-pt': `Manter`,
    ru: `\u{414}\u{435}\u{440}\u{436}\u{438}`,
    sm: `Tausia`,
    so: `Hayso`,
    th: `\u{E40}\u{E01}\u{E47}\u{E1A}`,
    ur: `\u{631}\u{6A9}\u{6BE}\u{648}`,
    vi: `Gi\u{1EEF}`,
    'zh-hans': `\u{5B88}`,
    'zh-hant': `\u{5B88}\u{4F4F}`,
    en: `Keep`
};
const $b11db1b62d4a8f76$export$aa8574e0ba44bca8 = {
    ar: (language)=>`\u{645}\u{62D}\u{62F}\u{62F} \u{644}\u{63A}\u{629} \u{627}\u{644}\u{645}\u{62D}\u{62A}\u{648}\u{649}. \u{62D}\u{627}\u{644}\u{64A}\u{627} \u{62A}\u{645} \u{636}\u{628}\u{637}\u{647} \u{639}\u{644}\u{649} ${language}`,
    de: (language)=>`Inhaltssprachauswahl. Derzeit auf ${language} eingestellt`,
    es: (language)=>`Selector de lenguaje de contenido. Actualmente configurado en ${language}`,
    fa: (language)=>`\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{646}\u{62F}\u{647} \u{632}\u{628}\u{627}\u{646} \u{645}\u{62D}\u{62A}\u{648}\u{627}. \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{62D}\u{627}\u{636}\u{631} \u{628}\u{647} ${language} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: (language)=>`Tagapili ng wika ng nilalaman. Kasalukuyang nakatakda sa ${language}`,
    fr: (language)=>`S\xe9lecteur de langage de contenu. Actuellement en ${language}`,
    hi: (language)=>`\u{938}\u{93E}\u{92E}\u{917}\u{94D}\u{930}\u{940} \u{92D}\u{93E}\u{937}\u{93E} \u{91A}\u{92F}\u{928}\u{915}\u{930}\u{94D}\u{924}\u{93E}. \u{935}\u{930}\u{94D}\u{924}\u{92E}\u{93E}\u{928} \u{92E}\u{947}\u{902} ${language} \u{92A}\u{930} \u{938}\u{947}\u{91F} \u{939}\u{948}`,
    ht: (language)=>`Seleksyon lang kontni Kounye a mete nan ${language}`,
    it: (language)=>`Selettore del linguaggio dei contenuti. Attualmente impostato in ${language}`,
    ja: (language)=>`\u{30B3}\u{30F3}\u{30C6}\u{30F3}\u{30C4}\u{8A00}\u{8A9E}\u{30BB}\u{30EC}\u{30AF}\u{30BF}\u{30FC}\u{3002}\u{73FE}\u{5728}\u{306F}${language}\u{8A2D}\u{5B9A}`,
    ko: (language)=>`\u{CF58}\u{D150}\u{CE20} \u{C5B8}\u{C5B4} \u{C120}\u{D0DD}\u{AE30}. \u{D604}\u{C7AC} ${language}\u{B85C} \u{C124}\u{C815}\u{B428}`,
    mww: (language)=>`Cov ntsiab lus selector. Tam sim no teem rau ${language}`,
    ps: (language)=>`\u{62F} \u{645}\u{62D}\u{62A}\u{648}\u{627} \u{698}\u{628}\u{6D0} \u{67C}\u{627}\u{6A9}\u{648}\u{646}\u{6A9}\u{6CC}. \u{627}\u{648}\u{633} \u{645}\u{647}\u{627}\u{644} ${language} \u{62A}\u{647} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{634}\u{648}\u{6CC}`,
    pt: (language)=>`Seletor de linguagem de conte\xfado. Atualmente configurado para ${language}`,
    'pt-pt': (language)=>`Seletor de linguagem de conte\xfado. Atualmente definido para ${language}`,
    ru: (language)=>`\u{421}\u{435}\u{43B}\u{435}\u{43A}\u{442}\u{43E}\u{440} \u{44F}\u{437}\u{44B}\u{43A}\u{430} \u{43A}\u{43E}\u{43D}\u{442}\u{435}\u{43D}\u{442}\u{430}. \u{412} \u{43D}\u{430}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{435}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F} \u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43D}\u{43E} \u{43D}\u{430} ${language}`,
    sm: (language)=>`Tagata filifilia o le gagana o le anotusi. O lo'o fa'atulagaina nei i le ${language}`,
    so: (language)=>`Xulaha luqadda nuxurka. Hadda waxaa loo dejiyay ${language}`,
    th: (language)=>`\u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E20}\u{E32}\u{E29}\u{E32}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E19}\u{E37}\u{E49}\u{E2D}\u{E2B}\u{E32} \u{E1B}\u{E31}\u{E08}\u{E08}\u{E38}\u{E1A}\u{E31}\u{E19}\u{E15}\u{E31}\u{E49}\u{E07}\u{E04}\u{E48}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19} ${language}`,
    ur: (language)=>`\u{6A9}\u{646}\u{679}\u{6CC}\u{646}\u{679} \u{644}\u{6CC}\u{646}\u{6AF}\u{648}\u{6CC}\u{62C} \u{633}\u{644}\u{6CC}\u{6A9}\u{679}\u{631}\u{6D4} \u{641}\u{6CC} \u{627}\u{644}\u{62D}\u{627}\u{644} ${language} \u{67E}\u{631} \u{633}\u{6CC}\u{679} \u{6C1}\u{6D2}`,
    vi: (language)=>`B\u{1ED9} ch\u{1ECD}n ng\xf4n ng\u{1EEF} n\u{1ED9}i dung. Hi\u{1EC7}n \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EB7}t th\xe0nh ${language}`,
    'zh-hans': (language)=>`\u{5185}\u{5BB9}\u{8BED}\u{8A00}\u{9009}\u{62E9}\u{5668}\u{3002}\u{76EE}\u{524D}\u{5DF2}\u{8BBE}\u{7F6E}\u{4E3A} ${language}`,
    'zh-hant': (language)=>`\u{5167}\u{5BB9}\u{8A9E}\u{8A00}\u{9078}\u{64C7}\u{5668}\u{3002}\u{76EE}\u{524D}\u{8A2D}\u{5B9A}\u{70BA} ${language}`,
    en: (language)=>`Content language selector. Currently set to ${language}`
};
const $b11db1b62d4a8f76$export$3fe2ec103c6ce16a = {
    ar: `\u{639}\u{631}\u{636} \u{631}\u{645}\u{632} QR \u{643}\u{628}\u{64A}\u{631}`,
    de: `Gro\xdfen QR-Code anzeigen`,
    es: `Ver c\xf3digo QR grande`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{6A9}\u{62F} QR \u{628}\u{632}\u{631}\u{6AF}`,
    fil: `Tingnan ang malaking QR code`,
    fr: `Voir un grand code QR`,
    hi: `\u{92C}\u{921}\u{93C}\u{93E} \u{915}\u{94D}\u{92F}\u{942}\u{906}\u{930} \u{915}\u{94B}\u{921} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `Gade gwo k\xf2d QR`,
    it: `Visualizza il codice QR in grandi dimensioni`,
    ja: `\u{5927}\u{304D}\u{306A}QR\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{8868}\u{793A}`,
    ko: `\u{D070} QR \u{CF54}\u{B4DC} \u{BCF4}\u{AE30}`,
    mww: `Saib QR code loj`,
    ps: `\u{644}\u{648}\u{6CC} QR \u{6A9}\u{648}\u{689} \u{648}\u{6AB}\u{648}\u{631}\u{626}`,
    pt: `Veja o c\xf3digo QR grande`,
    'pt-pt': `Ver c\xf3digo QR grande`,
    ru: `\u{41F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{43E}\u{433}\u{43E} QR-\u{43A}\u{43E}\u{434}\u{430}`,
    sm: `Va'ai tele QR code`,
    so: `Eeg QR code weyn`,
    th: `\u{E14}\u{E39}\u{E23}\u{E2B}\u{E31}\u{E2A} QR \u{E02}\u{E19}\u{E32}\u{E14}\u{E43}\u{E2B}\u{E0D}\u{E48}`,
    ur: `\u{628}\u{691}\u{627} QR \u{6A9}\u{648}\u{688} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Xem m\xe3 QR l\u{1EDB}n`,
    'zh-hans': `\u{67E5}\u{770B}\u{5927}\u{578B}\u{4E8C}\u{7EF4}\u{7801}`,
    'zh-hant': `\u{67E5}\u{770B}\u{5927}\u{578B} QR \u{78BC}`,
    en: `View large QR code`
};
const $b11db1b62d4a8f76$export$522222a759715010 = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{645} \u{627}\u{644}\u{623}\u{62E}\u{64A}\u{631}`,
    de: `Nachname`,
    es: `Apellido`,
    fa: `\u{646}\u{627}\u{645} \u{62E}\u{627}\u{646}\u{648}\u{627}\u{62F}\u{6AF}\u{6CC}`,
    fil: `Apelyido`,
    fr: `Nom de famille`,
    hi: `\u{905}\u{902}\u{924}\u{93F}\u{92E} \u{928}\u{93E}\u{92E}`,
    ht: `Siyati`,
    it: `Cognome`,
    ja: `\u{59D3}`,
    ko: `\u{C131}`,
    mww: `Lub xeem`,
    ps: `\u{62A}\u{62E}\u{644}\u{635}`,
    pt: `Sobrenome`,
    'pt-pt': `Apelido`,
    ru: `\u{424}\u{430}\u{43C}\u{438}\u{43B}\u{438}\u{44F}`,
    sm: `Igoa faaiu`,
    so: `Magaca dambe`,
    th: `\u{E19}\u{E32}\u{E21}\u{E2A}\u{E01}\u{E38}\u{E25}`,
    ur: `\u{622}\u{62E}\u{631}\u{6CC} \u{646}\u{627}\u{645}`,
    vi: `H\u{1ECD}`,
    'zh-hans': `\u{59D3}\u{6C0F}`,
    'zh-hant': `\u{59D3}\u{6C0F}`,
    en: `Last name`
};
const $b11db1b62d4a8f76$export$86b7c879f7775f06 = {
    ar: `\u{622}\u{62E}\u{631} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{646}\u{647}\u{627}\u{64A}\u{629}`,
    de: `Letztes Enddatum`,
    es: `Fecha de finalizaci\xf3n m\xe1s tard\xeda`,
    fa: `\u{622}\u{62E}\u{631}\u{6CC}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{67E}\u{627}\u{6CC}\u{627}\u{646}`,
    fil: `Pinakabagong petsa ng pagtatapos`,
    fr: `Date de fin la plus tardive`,
    hi: `\u{928}\u{935}\u{940}\u{928}\u{924}\u{92E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{924}\u{93F}\u{925}\u{93F}`,
    ht: `D\xe8nye dat fen`,
    it: `Data di fine pi\xf9 recente`,
    ja: `\u{6700}\u{3082}\u{9045}\u{3044}\u{7D42}\u{4E86}\u{65E5}`,
    ko: `\u{AC00}\u{C7A5} \u{B2A6}\u{C740} \u{C885}\u{B8CC}\u{C77C}`,
    mww: `Hnub kawg kawg`,
    ps: `\u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{647}`,
    pt: `Data de t\xe9rmino mais recente`,
    'pt-pt': `Data de t\xe9rmino mais recente`,
    ru: `\u{41F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{44F}\u{44F} \u{434}\u{430}\u{442}\u{430} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Aso lata mai e faamuta ai`,
    so: `Taariikhda ugu dambeysa ee dhammaadka`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{62A}\u{627}\u{632}\u{6C1} \u{62A}\u{631}\u{6CC}\u{646} \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y k\u{1EBF}t th\xfac mu\u{1ED9}n nh\u{1EA5}t`,
    'zh-hans': `\u{6700}\u{665A}\u{7ED3}\u{675F}\u{65E5}\u{671F}`,
    'zh-hant': `\u{6700}\u{665A}\u{7D50}\u{675F}\u{65E5}\u{671F}`,
    en: `Latest end date`
};
const $b11db1b62d4a8f76$export$10c6e283027663f4 = {
    ar: `\u{623}\u{62D}\u{62F}\u{62B} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{628}\u{62F}\u{621}`,
    de: `Letztes Startdatum`,
    es: `Fecha de inicio m\xe1s tard\xeda`,
    fa: `\u{622}\u{62E}\u{631}\u{6CC}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{634}\u{631}\u{648}\u{639}`,
    fil: `Pinakabagong petsa ng pagsisimula`,
    fr: `Date de d\xe9but la plus r\xe9cente`,
    hi: `\u{928}\u{935}\u{940}\u{928}\u{924}\u{92E} \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{924}\u{93F}\u{925}\u{93F}`,
    ht: `D\xe8nye dat k\xf2manse`,
    it: `Data di inizio pi\xf9 recente`,
    ja: `\u{6700}\u{65B0}\u{306E}\u{958B}\u{59CB}\u{65E5}`,
    ko: `\u{CD5C}\u{ADFC} \u{C2DC}\u{C791}\u{C77C}`,
    mww: `Hnub pib kawg`,
    ps: `\u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC} \u{67E}\u{6CC}\u{644} \u{646}\u{6CC}\u{67C}\u{647}`,
    pt: `Data de in\xedcio mais recente`,
    'pt-pt': `Data de in\xedcio mais recente`,
    ru: `\u{41F}\u{43E}\u{437}\u{434}\u{43D}\u{44F}\u{44F} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}`,
    sm: `Aso amata lata mai`,
    so: `Taariikhda ugu dambeysa ee bilowga`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{62A}\u{627}\u{632}\u{6C1} \u{62A}\u{631}\u{6CC}\u{646} \u{622}\u{63A}\u{627}\u{632} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u mu\u{1ED9}n nh\u{1EA5}t`,
    'zh-hans': `\u{6700}\u{665A}\u{5F00}\u{5DE5}\u{65E5}\u{671F}`,
    'zh-hant': `\u{6700}\u{665A}\u{958B}\u{64AD}\u{65E5}\u{671F}`,
    en: `Latest start date`
};
const $b11db1b62d4a8f76$export$3c5d839e22f29bf6 = {
    ar: `\u{62A}\u{639}\u{631}\u{641} \u{639}\u{644}\u{649} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}`,
    de: `Erfahren Sie mehr`,
    es: `M\xe1s informaci\xf3n`,
    fa: `\u{628}\u{6CC}\u{634}\u{62A}\u{631} \u{628}\u{62F}\u{627}\u{646}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `En savoir plus`,
    hi: `\u{914}\u{930} \u{91C}\u{93E}\u{928}\u{94B}`,
    ht: `Aprann plis`,
    it: `Scopri di pi\xf9`,
    ja: `\u{8A73}\u{3057}\u{304F}\u{306F}\u{3053}\u{3061}\u{3089}`,
    ko: `\u{B354} \u{C54C}\u{C544}\u{BCF4}\u{AE30}`,
    mww: `Kawm ntxiv`,
    ps: `\u{646}\u{648}\u{631} \u{632}\u{62F}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Saiba mais`,
    'pt-pt': `Saiba mais`,
    ru: `\u{423}\u{437}\u{43D}\u{430}\u{442}\u{44C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435}`,
    sm: `Su'esu'e atili`,
    so: `Waxbadan baro`,
    th: `\u{E40}\u{E23}\u{E35}\u{E22}\u{E19}\u{E23}\u{E39}\u{E49}\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E40}\u{E15}\u{E34}\u{E21}`,
    ur: `\u{645}\u{632}\u{6CC}\u{62F} \u{62C}\u{627}\u{646}\u{6CC}\u{6BA}`,
    vi: `T\xecm hi\u{1EC3}u th\xeam`,
    'zh-hans': `\u{4E86}\u{89E3}\u{66F4}\u{591A}`,
    'zh-hant': `\u{4E86}\u{89E3}\u{66F4}\u{591A}`,
    en: `Learn more`
};
const $b11db1b62d4a8f76$export$86d05dcef079cc14 = {
    ar: `\u{627}\u{644}\u{623}\u{642}\u{644} \u{625}\u{646}\u{634}\u{627}\u{621} \u{645}\u{624}\u{62E}\u{631}\u{627}`,
    de: `Am wenigsten k\xfcrzlich erschaffen`,
    es: `Menos recientemente creado`,
    fa: `\u{6A9}\u{645}\u{62A}\u{631}\u{6CC}\u{646} \u{634}\u{6A9}\u{644} \u{627}\u{62E}\u{6CC}\u{631}`,
    fil: `Hindi bababa sa kamakailan-lamang na nilikha`,
    fr: `Le moins r\xe9cemment cr\xe9\xe9`,
    hi: `\u{915}\u{92E} \u{938}\u{947} \u{915}\u{92E} \u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Pi piti resamman kreye`,
    it: `Meno recente creato`,
    ja: `\u{6700}\u{3082}\u{6700}\u{8FD1}\u{4F5C}\u{3089}\u{308C}\u{305F}\u{3082}\u{306E}`,
    ko: `\u{AC00}\u{C7A5} \u{CD5C}\u{ADFC}\u{C5D0} \u{C0DD}\u{C131}\u{B41C} \u{AC83}`,
    mww: `Tsawg kawg tsis ntev los no tsim`,
    ps: `\u{62A}\u{631} \u{67C}\u{648}\u{644}\u{648} \u{644}\u{696} \u{62A}\u{627}\u{632}\u{647} \u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}`,
    pt: `Menos recentemente criado`,
    'pt-pt': `Menos recentemente criado`,
    ru: `\u{41D}\u{430}\u{438}\u{43C}\u{435}\u{43D}\u{435}\u{435} \u{43D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{439}`,
    sm: `E le'i leva ona faia`,
    so: `Ugu yaraan dhawaan la sameeyay`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{633}\u{628} \u{633}\u{6D2} \u{6A9}\u{645} \u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{62A}\u{62E}\u{644}\u{6CC}\u{642} \u{634}\u{62F}\u{6C1}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c t\u{1EA1}o g\u{1EA7}n \u{111}\xe2y nh\u{1EA5}t`,
    'zh-hans': `\u{6700}\u{8FD1}\u{521B}\u{5EFA}\u{7684}`,
    'zh-hant': `\u{6700}\u{4E0D}\u{8FD1}\u{671F}\u{5275}\u{5EFA}`,
    en: `Least recently created`
};
const $b11db1b62d4a8f76$export$bda66586c2970932 = {
    ar: `\u{627}\u{644}\u{623}\u{642}\u{644} \u{62A}\u{62D}\u{62F}\u{64A}\u{62B}\u{627} \u{645}\u{624}\u{62E}\u{631}\u{627}`,
    de: `Am wenigsten k\xfcrzlich aktualisiert`,
    es: `Menos recientemente actualizado`,
    fa: `\u{6A9}\u{645}\u{62A}\u{631}\u{6CC}\u{646} \u{628}\u{647} \u{631}\u{648}\u{632}\u{631}\u{633}\u{627}\u{646}\u{6CC} \u{627}\u{62E}\u{6CC}\u{631}`,
    fil: `Hindi bababa sa kamakailan-lamang na na-update`,
    fr: `Mise \xe0 jour la moins r\xe9cente`,
    hi: `\u{915}\u{92E} \u{938}\u{947} \u{915}\u{92E} \u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{905}\u{92A}\u{921}\u{947}\u{91F} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Pi piti d\xe8ny\xe8man mete ajou`,
    it: `Aggiornato meno recentemente`,
    ja: `\u{6700}\u{8FD1}\u{66F4}\u{65B0}\u{304C}\u{9045}\u{3044}`,
    ko: `\u{AC00}\u{C7A5} \u{CD5C}\u{ADFC}\u{C5D0} \u{C5C5}\u{B370}\u{C774}\u{D2B8}\u{B41C} \u{AC83}`,
    mww: `Tsawg kawg tsis ntev los no hloov kho`,
    ps: `\u{62A}\u{631} \u{67C}\u{648}\u{644}\u{648} \u{644}\u{696} \u{62A}\u{627}\u{632}\u{647} \u{634}\u{648}\u{6CC}`,
    pt: `Atualiza\xe7\xe3o menos recente`,
    'pt-pt': `Atualiza\xe7\xe3o menos recente`,
    ru: `\u{41D}\u{430}\u{438}\u{43C}\u{435}\u{43D}\u{435}\u{435} \u{43D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{43E}`,
    sm: `Fa'afouina talu ai nei`,
    so: `Ugu yaraan dhawaan la cusbooneysiiyay`,
    th: `\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{633}\u{628} \u{633}\u{6D2} \u{6A9}\u{645} \u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{627}\u{67E} \u{688}\u{6CC}\u{679}`,
    vi: `C\u{1EAD}p nh\u{1EAD}t \xedt g\u{1EA7}n \u{111}\xe2y nh\u{1EA5}t`,
    'zh-hans': `\u{66F4}\u{65B0}\u{6700}\u{5C11}`,
    'zh-hant': `\u{66F4}\u{65B0}\u{6700}\u{5C11}`,
    en: `Least recently updated`
};
const $b11db1b62d4a8f76$export$30a33fbafb74fce6 = {
    ar: `\u{627}\u{62A}\u{631}\u{643} \u{62A}\u{639}\u{644}\u{64A}\u{642}\u{627}`,
    de: `Hinterlasse einen Kommentar`,
    es: `Deja un comentario`,
    fa: `\u{6CC}\u{6A9} \u{646}\u{638}\u{631} \u{628}\u{6AF}\u{630}\u{627}\u{631}\u{6CC}\u{62F}`,
    fil: `Mag-iwan ng komento`,
    fr: `Laissez un commentaire`,
    hi: `\u{90F}\u{915} \u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{940} \u{91B}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Kite yon k\xf2mant\xe8`,
    it: `Lascia un commento`,
    ja: `\u{30B3}\u{30E1}\u{30F3}\u{30C8}\u{3092}\u{6B8B}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{B313}\u{AE00}\u{C744} \u{B0A8}\u{ACA8}\u{C8FC}\u{C138}\u{C694}`,
    mww: `Cia ib saib`,
    ps: `\u{62A}\u{628}\u{635}\u{631}\u{647} \u{67E}\u{631}\u{6D0}\u{696}\u{62F}\u{626}`,
    pt: `Deixe um coment\xe1rio`,
    'pt-pt': `Deixe um coment\xe1rio`,
    ru: `\u{41E}\u{441}\u{442}\u{430}\u{432}\u{44C}\u{442}\u{435} \u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{439}`,
    sm: `Tu'u se fa'amatalaga`,
    so: `Ka tag faallo`,
    th: `\u{E17}\u{E34}\u{E49}\u{E07}\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E44}\u{E27}\u{E49}`,
    ur: `\u{62A}\u{628}\u{635}\u{631}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{1EC3} l\u{1EA1}i m\u{1ED9}t b\xecnh lu\u{1EAD}n`,
    'zh-hans': `\u{6B22}\u{8FCE}\u{7559}\u{8A00}`,
    'zh-hant': `\u{6B61}\u{8FCE}\u{7559}\u{8A00}`,
    en: `Leave a comment`
};
const $b11db1b62d4a8f76$export$2613d5a53126ea74 = {
    ar: `\u{642}\u{648}\u{627}\u{644}\u{628} \u{623}\u{642}\u{644}`,
    de: `Weniger Vorlagen`,
    es: `Menos plantillas`,
    fa: `\u{642}\u{627}\u{644}\u{628} \u{647}\u{627}\u{6CC} \u{6A9}\u{645}\u{62A}\u{631}`,
    fil: `Mas kaunting mga template`,
    fr: `Moins de mod\xe8les`,
    hi: `\u{915}\u{92E} \u{91F}\u{947}\u{92E}\u{94D}\u{92A}\u{932}\u{947}\u{91F}\u{94D}\u{938}`,
    ht: `Mwens mod\xe8l`,
    it: `Meno template`,
    ja: `\u{30C6}\u{30F3}\u{30D7}\u{30EC}\u{30FC}\u{30C8}\u{3092}\u{6E1B}\u{3089}\u{3059}`,
    ko: `\u{D15C}\u{D50C}\u{B9BF} \u{AC10}\u{C18C}`,
    mww: `Tsawg templates`,
    ps: `\u{6A9}\u{645}\u{6D0} \u{642}\u{627}\u{644}\u{628}\u{648}\u{646}\u{647}`,
    pt: `Menos modelos`,
    'pt-pt': `Menos modelos`,
    ru: `\u{41C}\u{435}\u{43D}\u{44C}\u{448}\u{435} \u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{43E}\u{432}`,
    sm: `Itiiti mamanu`,
    so: `Templates yar`,
    th: `\u{E40}\u{E17}\u{E21}\u{E40}\u{E1E}\u{E25}\u{E15}\u{E19}\u{E49}\u{E2D}\u{E22}\u{E25}\u{E07}`,
    ur: `\u{6A9}\u{645} \u{679}\u{6CC}\u{645}\u{67E}\u{644}\u{6CC}\u{679}\u{633}`,
    vi: `\xcdt m\u{1EAB}u h\u{1A1}n`,
    'zh-hans': `\u{6A21}\u{677F}\u{51CF}\u{5C11}`,
    'zh-hant': `\u{6E1B}\u{5C11}\u{7BC4}\u{672C}`,
    en: `Less templates`
};
const $b11db1b62d4a8f76$export$1dc738496858a682 = {
    ar: `\u{628}\u{631}\u{648}\u{62A}\u{627}\u{646}\u{648}\u{628}\u{64A}\u{627} \u{627}\u{644}\u{636}\u{648}\u{621} \u{648}\u{62F}\u{64A}\u{648}\u{62A}\u{64A}\u{631}\u{627}\u{646}\u{648}\u{628}\u{64A}\u{627}`,
    de: `Lichtprotanopie & Deuteranopie`,
    es: `Protanop\xeda y Deuteranop\xeda Ligera`,
    fa: `\u{67E}\u{631}\u{648}\u{62A}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627} \u{631}\u{648}\u{634}\u{646} \u{648} \u{62F}\u{648}\u{62A}\u{631}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    fil: `Banayad na Protanopia at Deuteranopia`,
    fr: `Protanopie l\xe9g\xe8re et deut\xe9ranopie`,
    hi: `\u{932}\u{93E}\u{907}\u{91F} \u{92A}\u{94D}\u{930}\u{94B}\u{91F}\u{93E}\u{928}\u{94B}\u{92A}\u{93F}\u{92F}\u{93E} \u{914}\u{930} \u{921}\u{94D}\u{92F}\u{942}\u{91F}\u{947}\u{930}\u{93E}\u{928}\u{94B}\u{92A}\u{93F}\u{92F}\u{93E}`,
    ht: `Protanopia limy\xe8 & Deuteranopia`,
    it: `Protanopia e Deuteranopia Leggera`,
    ja: `\u{8EFD}\u{3044}\u{30D7}\u{30ED}\u{30BF}\u{30CE}\u{30D4}\u{30A2}\u{3068}\u{30C7}\u{30E5}\u{30A6}\u{30C6}\u{30E9}\u{30CE}\u{30D4}\u{30A2}`,
    ko: `\u{B77C}\u{C774}\u{D2B8} \u{D504}\u{B85C}\u{D0C0}\u{B178}\u{D53C}\u{C544} \u{BC0F} \u{B3C4}\u{D14C}\u{B77C}\u{B178}\u{D53C}\u{C544}`,
    mww: `Lub teeb Protanopia & Deuteranopia`,
    ps: `\u{631}\u{6BC}\u{627} \u{67E}\u{631}\u{648}\u{62A}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627} \u{627}\u{648} \u{689}\u{6CC}\u{648}\u{62A}\u{631}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    pt: `Protanopia e Deuteranopia Leve`,
    'pt-pt': `Protanopia e Deuteranopia Leve`,
    ru: `\u{41B}\u{451}\u{433}\u{43A}\u{430}\u{44F} \u{43F}\u{440}\u{43E}\u{442}\u{430}\u{43D}\u{43E}\u{43F}\u{438}\u{44F} \u{438} \u{434}\u{435}\u{439}\u{442}\u{435}\u{440}\u{430}\u{43D}\u{43E}\u{43F}\u{438}\u{44F}`,
    sm: `Malamalama Protanopia ma Deuteranopia`,
    so: `Protanopia Fudud & Deuteranopia`,
    th: `\u{E42}\u{E1B}\u{E23}\u{E15}\u{E32}\u{E42}\u{E19}\u{E40}\u{E1B}\u{E35}\u{E22}\u{E40}\u{E1A}\u{E32} & \u{E14}\u{E34}\u{E27}\u{E40}\u{E17}\u{E23}\u{E32}\u{E42}\u{E19}\u{E40}\u{E1B}\u{E35}\u{E22}`,
    ur: `\u{644}\u{627}\u{626}\u{679} \u{67E}\u{631}\u{648}\u{679}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627} \u{627}\u{648}\u{631} \u{688}\u{6CC}\u{648}\u{679}\u{6CC}\u{631}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    vi: `Protanopia nh\u{1EB9} & Deuteranopia`,
    'zh-hans': `\u{6D45}\u{8272}\u{7EA2}\u{76F2}\u{4E0E}\u{675C}\u{7279}\u{62C9}\u{8BFA}\u{76AE}\u{4E9A}`,
    'zh-hant': `\u{8F15}\u{5EA6}\u{8272}\u{76F2}\u{8207}\u{675C}\u{7279}\u{62C9}\u{8AFE}\u{76AE}\u{4E9E}`,
    en: `Light Protanopia & Deuteranopia`
};
const $b11db1b62d4a8f76$export$6dbdd35290b5a961 = {
    ar: `\u{627}\u{644}\u{648}\u{636}\u{639} \u{627}\u{644}\u{627}\u{641}\u{62A}\u{631}\u{627}\u{636}\u{64A} \u{644}\u{644}\u{636}\u{648}\u{621}`,
    de: `Leichter Standard`,
    es: `Luz predeterminada`,
    fa: `\u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636} \u{646}\u{648}\u{631}`,
    fil: `Banayad na Default`,
    fr: `Lumi\xe8re par d\xe9faut`,
    hi: `\u{932}\u{93E}\u{907}\u{91F} \u{921}\u{93F}\u{92B}\u{949}\u{932}\u{94D}\u{91F}`,
    ht: `Limy\xe8 Default`,
    it: `Luce predefinita`,
    ja: `\u{30E9}\u{30A4}\u{30C8}\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}`,
    ko: `\u{B77C}\u{C774}\u{D2B8} \u{B514}\u{D3F4}\u{D2B8}`,
    mww: `Lub Teeb Neej Ntawd`,
    ps: `\u{631}\u{6BC}\u{627} \u{689}\u{6CC}\u{641}\u{627}\u{644}\u{67C}`,
    pt: `Padr\xe3o de Luz`,
    'pt-pt': `Padr\xe3o de Luz`,
    ru: `Light Default`,
    sm: `Fa'aletonu Malamalama`,
    so: `Light Default`,
    th: `\u{E04}\u{E48}\u{E32}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E41}\u{E2A}\u{E07}`,
    ur: `\u{644}\u{627}\u{626}\u{679} \u{688}\u{6CC}\u{641}\u{627}\u{644}\u{679}`,
    vi: `M\u{1EB7}c \u{111}\u{1ECB}nh \xe1nh s\xe1ng`,
    'zh-hans': `\u{5149}\u{660E}\u{9ED8}\u{8BA4}`,
    'zh-hant': `\u{5149}\u{7167}\u{9810}\u{8A2D}`,
    en: `Light Default`
};
const $b11db1b62d4a8f76$export$e3e04cfa8cb29bc6 = {
    ar: `\u{627}\u{644}\u{636}\u{648}\u{621} \u{639}\u{627}\u{644}\u{64A} \u{627}\u{644}\u{62A}\u{628}\u{627}\u{64A}\u{646}`,
    de: `Lichthoher Kontrast`,
    es: `Luz de alto contraste`,
    fa: `\u{6A9}\u{646}\u{62A}\u{631}\u{627}\u{633}\u{62A} \u{646}\u{648}\u{631} \u{628}\u{627}\u{644}\u{627}`,
    fil: `Banayad na Mataas na Pagkakaiba`,
    fr: `Contraste lumineux et \xe9lev\xe9`,
    hi: `\u{932}\u{93E}\u{907}\u{91F} \u{939}\u{93E}\u{908} \u{915}\u{902}\u{91F}\u{94D}\u{930}\u{93E}\u{938}\u{94D}\u{91F}`,
    ht: `Limy\xe8 Segond\xe8 kontras`,
    it: `Luce ad alto contrasto`,
    ja: `\u{5149}\u{306E}\u{30CF}\u{30A4}\u{30B3}\u{30F3}\u{30C8}\u{30E9}\u{30B9}\u{30C8}`,
    ko: `\u{BE5B} \u{ACE0}\u{B300}\u{BE44}`,
    mww: `Lub teeb Siab Sib Piv`,
    ps: `\u{633}\u{67E}\u{6A9} \u{644}\u{648}\u{693} \u{6A9}\u{646}\u{67C}\u{631}\u{627}\u{633}\u{62A}`,
    pt: `Luz Alto Contraste`,
    'pt-pt': `Luz de Alto Contraste`,
    ru: `\u{421}\u{432}\u{435}\u{442} \u{441} \u{432}\u{44B}\u{441}\u{43E}\u{43A}\u{438}\u{43C} \u{43A}\u{43E}\u{43D}\u{442}\u{440}\u{430}\u{441}\u{442}\u{43E}\u{43C}`,
    sm: `Malamalama Maualuga Eseesega`,
    so: `Light High Contrast`,
    th: `\u{E41}\u{E2A}\u{E07}\u{E04}\u{E2D}\u{E19}\u{E17}\u{E23}\u{E32}\u{E2A}\u{E15}\u{E4C}\u{E2A}\u{E39}\u{E07}`,
    ur: `\u{644}\u{627}\u{626}\u{679} \u{6C1}\u{627}\u{626}\u{6CC} \u{6A9}\u{646}\u{679}\u{631}\u{627}\u{633}\u{679}`,
    vi: `\u{110}\u{1ED9} t\u{1B0}\u{1A1}ng ph\u{1EA3}n cao \xe1nh s\xe1ng`,
    'zh-hans': `\u{5149}\u{9AD8}\u{5BF9}\u{6BD4}`,
    'zh-hant': `\u{5149}\u{7DDA}\u{9AD8}\u{5C0D}\u{6BD4}`,
    en: `Light High Contrast`
};
const $b11db1b62d4a8f76$export$ec1bd9825525d3c4 = {
    ar: `\u{62A}\u{631}\u{64A}\u{62A}\u{627}\u{646}\u{648}\u{628}\u{64A}\u{627} \u{627}\u{644}\u{62E}\u{641}\u{64A}\u{641}\u{629}`,
    de: `Leichte Tritanopie`,
    es: `Tritanopia ligera`,
    fa: `\u{644}\u{627}\u{6CC}\u{62A} \u{62A}\u{631}\u{6CC}\u{62A}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    fil: `Banayad na Tritanopia`,
    fr: `Tritanopie l\xe9g\xe8re`,
    hi: `\u{932}\u{93E}\u{907}\u{91F} \u{91F}\u{94D}\u{930}\u{93F}\u{91F}\u{93E}\u{928}\u{94B}\u{92A}\u{93F}\u{92F}\u{93E}`,
    ht: `Limy\xe8 Tritanopia`,
    it: `Tritanopia Leggera`,
    ja: `\u{30E9}\u{30A4}\u{30C8}\u{30C8}\u{30EA}\u{30BF}\u{30CE}\u{30D4}\u{30A2}`,
    ko: `\u{B77C}\u{C774}\u{D2B8} \u{D2B8}\u{B9AC}\u{D0C0}\u{B178}\u{D53C}\u{C544}`,
    mww: `Lub teeb Tritanopia`,
    ps: `\u{631}\u{6BC}\u{627} \u{67C}\u{631}\u{6CC}\u{67C}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    pt: `Tritanopia Leve`,
    'pt-pt': `Tritanopia Leve`,
    ru: `\u{41B}\u{451}\u{433}\u{43A}\u{430}\u{44F} \u{442}\u{440}\u{438}\u{442}\u{430}\u{43D}\u{43E}\u{43F}\u{438}\u{44F}`,
    sm: `Tritanopia Malamalama`,
    so: `Tritanopia Iftiinka`,
    th: `\u{E44}\u{E25}\u{E17}\u{E4C}\u{E44}\u{E17}\u{E23}\u{E15}\u{E32}\u{E42}\u{E19}\u{E40}\u{E1B}\u{E35}\u{E22}`,
    ur: `\u{644}\u{627}\u{626}\u{679} \u{679}\u{631}\u{627}\u{626}\u{6CC}\u{679}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    vi: `Tritanopia \xe1nh s\xe1ng`,
    'zh-hans': `\u{8F7B}\u{578B}\u{4E09}\u{53F6}\u{76EE}`,
    'zh-hant': `\u{8F15}\u{5EA6}\u{4E09}\u{8449}\u{76EE}`,
    en: `Light Tritanopia`
};
const $b11db1b62d4a8f76$export$b7dfe9dcefcdd37a = {
    ar: `\u{631}\u{627}\u{628}\u{637}`,
    de: `Link`,
    es: `Enlace`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9}`,
    fil: `Link`,
    fr: `Lien`,
    hi: `\u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915}`,
    ht: `Lyen`,
    it: `Link`,
    ja: `\u{30EA}\u{30F3}\u{30AF}`,
    ko: `\u{B9C1}\u{D06C}`,
    mww: `Txuas`,
    ps: `\u{644}\u{6CC}\u{646}\u{6A9}`,
    pt: `Link`,
    'pt-pt': `Link`,
    ru: `\u{421}\u{441}\u{44B}\u{43B}\u{43A}\u{430}`,
    sm: `Sootaga`,
    so: `Xiriir`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}`,
    ur: `\u{644}\u{646}\u{6A9}`,
    vi: `Li\xean k\u{1EBF}t`,
    'zh-hans': `\u{94FE}\u{63A5}`,
    'zh-hant': `\u{9023}\u{7D50}`,
    en: `Link`
};
const $b11db1b62d4a8f76$export$9672b4d8b606a658 = {
    ar: `\u{627}\u{631}\u{628}\u{637} \u{62D}\u{633}\u{627}\u{628}\u{627}\u{62A}\u{643}`,
    de: `Verkn\xfcpfe deine Konten`,
    es: `Vincula tus cuentas`,
    fa: `\u{62D}\u{633}\u{627}\u{628} \u{647}\u{627}\u{6CC} \u{62E}\u{648}\u{62F} \u{631}\u{627} \u{644}\u{6CC}\u{646}\u{6A9} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `I-link ang iyong mga account`,
    fr: `Liez vos comptes`,
    hi: `\u{905}\u{92A}\u{928}\u{947} \u{916}\u{93E}\u{924}\u{947} \u{932}\u{93F}\u{902}\u{915} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Konekte kont ou yo`,
    it: `Collega i tuoi account`,
    ja: `\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{3092}\u{30EA}\u{30F3}\u{30AF}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{ACC4}\u{C88C} \u{C5F0}\u{B3D9}`,
    mww: `Txuas koj cov nyiaj`,
    ps: `\u{62E}\u{67E}\u{644} \u{62D}\u{633}\u{627}\u{628}\u{648}\u{646}\u{647} \u{648}\u{635}\u{644} \u{6A9}\u{693}\u{626}`,
    pt: `Vincule suas contas`,
    'pt-pt': `Liga as tuas contas`,
    ru: `\u{421}\u{432}\u{44F}\u{436}\u{438}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{438} \u{430}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442}\u{44B}`,
    sm: `Fa'afeso'ota'i au teuga tupe`,
    so: `Isku xir akoonnadaada`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}`,
    ur: `\u{627}\u{67E}\u{646}\u{6D2} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679}\u{633} \u{644}\u{646}\u{6A9} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Li\xean k\u{1EBF}t t\xe0i kho\u{1EA3}n c\u{1EE7}a b\u{1EA1}n`,
    'zh-hans': `\u{5173}\u{8054}\u{4F60}\u{7684}\u{8D26}\u{6237}`,
    'zh-hant': `\u{9023}\u{7D50}\u{4F60}\u{7684}\u{5E33}\u{865F}`,
    en: `Link your accounts`
};
const $b11db1b62d4a8f76$export$4334bd49e607fffd = {
    ar: `\u{627}\u{646}\u{62A}\u{647}\u{62A} \u{635}\u{644}\u{627}\u{62D}\u{64A}\u{629} \u{627}\u{644}\u{631}\u{627}\u{628}\u{637}`,
    de: `Link ist abgelaufen`,
    es: `Enlace expirado`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9} \u{645}\u{646}\u{642}\u{636}\u{6CC} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Nag-expire na ang link`,
    fr: `Lien expir\xe9`,
    hi: `\u{932}\u{93F}\u{902}\u{915} \u{915}\u{940} \u{938}\u{92E}\u{92F} \u{938}\u{940}\u{92E}\u{93E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{917}\u{908}`,
    ht: `Link ekspire`,
    it: `Link scaduto`,
    ja: `\u{30EA}\u{30F3}\u{30AF}\u{306F}\u{671F}\u{9650}\u{5207}\u{308C}`,
    ko: `\u{B9C1}\u{D06C} \u{B9CC}\u{B8CC}`,
    mww: `Txuas tas sij hawm`,
    ps: `\u{644}\u{6CC}\u{646}\u{6A9} \u{62E}\u{62A}\u{645} \u{634}\u{648}`,
    pt: `Link expirado`,
    'pt-pt': `Link expirado`,
    ru: `\u{421}\u{432}\u{44F}\u{437}\u{44C} \u{438}\u{441}\u{442}\u{435}\u{43A}\u{43B}\u{430}`,
    sm: `Ua mae'a le feso'ota'iga`,
    so: `Xiriirkii wuu dhacay`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38}`,
    ur: `\u{644}\u{646}\u{6A9} \u{6A9}\u{6CC} \u{645}\u{6CC}\u{639}\u{627}\u{62F} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{6AF}\u{626}\u{6CC}`,
    vi: `Link h\u{1EBF}t h\u{1EA1}n`,
    'zh-hans': `\u{94FE}\u{63A5}\u{5DF2}\u{8FC7}\u{671F}`,
    'zh-hant': `\u{9023}\u{7D50}\u{5DF2}\u{904E}\u{671F}`,
    en: `Link expired`
};
const $b11db1b62d4a8f76$export$7cb9f321b1960244 = {
    ar: `\u{627}\u{646}\u{62A}\u{647}\u{62A} \u{635}\u{644}\u{627}\u{62D}\u{64A}\u{629} \u{627}\u{644}\u{631}\u{627}\u{628}\u{637}. \u{623}\u{62F}\u{62E}\u{644} \u{628}\u{631}\u{64A}\u{62F}\u{643} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{644}\u{62A}\u{635}\u{644}\u{643} \u{631}\u{627}\u{628}\u{637}\u{627} \u{62C}\u{62F}\u{64A}\u{62F}\u{627}.`,
    de: `Link ist abgestorben. Geben Sie Ihre E-Mail-Adresse ein, um einen neuen Link zu erhalten.`,
    es: `El enlace caduc\xf3. Introduce tu correo electr\xf3nico para recibir un nuevo enlace.`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9} \u{645}\u{646}\u{642}\u{636}\u{6CC} \u{634}\u{62F}. \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{62E}\u{648}\u{62F} \u{631}\u{627} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F} \u{62A}\u{627} \u{644}\u{6CC}\u{646}\u{6A9} \u{62C}\u{62F}\u{6CC}\u{62F}\u{6CC} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Nag-expire na ang link. Ipasok ang iyong email upang makatanggap ng isang bagong link.`,
    fr: `Lien expir\xe9. Saisissez votre adresse e-mail pour recevoir un nouveau lien.`,
    hi: `\u{932}\u{93F}\u{902}\u{915} \u{915}\u{940} \u{938}\u{92E}\u{92F} \u{938}\u{940}\u{92E}\u{93E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{917}\u{908} \u{939}\u{948}\u{964} \u{928}\u{92F}\u{93E} \u{932}\u{93F}\u{902}\u{915} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{92A}\u{928}\u{93E} \u{908}\u{92E}\u{947}\u{932} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Link ekspire Antre im\xe8l ou pou resevwa yon nouvo lyen.`,
    it: `Il collegamento \xe8 scaduto. Inserisci la tua email per ricevere un nuovo link.`,
    ja: `\u{30EA}\u{30F3}\u{30AF}\u{306F}\u{4EA1}\u{304F}\u{306A}\u{3063}\u{305F}\u{3002}\u{30E1}\u{30FC}\u{30EB}\u{30A2}\u{30C9}\u{30EC}\u{30B9}\u{3092}\u{5165}\u{529B}\u{3057}\u{3066}\u{65B0}\u{3057}\u{3044}\u{30EA}\u{30F3}\u{30AF}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{3063}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{B9C1}\u{D06C}\u{B294} \u{C8FD}\u{C5C8}\u{B2E4}. \u{C774}\u{BA54}\u{C77C}\u{C744} \u{C785}\u{B825}\u{D558}\u{BA74} \u{C0C8} \u{B9C1}\u{D06C}\u{B97C} \u{BC1B}\u{C544}\u{BCF4}\u{C138}\u{C694}.`,
    mww: `Txuas tas sij hawm. Sau koj tus email kom tau txais qhov txuas tshiab.`,
    ps: `\u{644}\u{6CC}\u{646}\u{6A9} \u{62E}\u{62A}\u{645} \u{634}\u{648}. \u{62E}\u{67E}\u{644} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626} \u{62A}\u{631}\u{685}\u{648} \u{646}\u{648}\u{6CC} \u{644}\u{6CC}\u{646}\u{6A9} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{693}\u{626}.`,
    pt: `Link expirou. Digite seu e-mail para receber um novo link.`,
    'pt-pt': `O link expirou. Introduza o seu email para receber um novo link.`,
    ru: `\u{421}\u{432}\u{44F}\u{437}\u{44C} \u{438}\u{441}\u{442}\u{435}\u{43A}\u{43B}\u{430}. \u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{439} email, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C} \u{43D}\u{43E}\u{432}\u{443}\u{44E} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443}.`,
    sm: `Ua mae'a le feso'ota'iga. Ulufale i lau imeli e maua ai se feso'ota'iga fou.`,
    so: `Xiriirku wuu dhacay. Geli email-kaaga si aad u hesho xiriir cusub.`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38} \u{E1B}\u{E49}\u{E2D}\u{E19}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E23}\u{E31}\u{E1A}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{644}\u{646}\u{6A9} \u{6A9}\u{6CC} \u{645}\u{6CC}\u{639}\u{627}\u{62F} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{6AF}\u{626}\u{6CC}\u{6D4} \u{646}\u{6CC}\u{627} \u{644}\u{646}\u{6A9} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{67E}\u{646}\u{627} \u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Li\xean k\u{1EBF}t \u{111}\xe3 h\u{1EBF}t h\u{1EA1}n. Nh\u{1EAD}p email c\u{1EE7}a b\u{1EA1}n \u{111}\u{1EC3} nh\u{1EAD}n li\xean k\u{1EBF}t m\u{1EDB}i.`,
    'zh-hans': `\u{6797}\u{514B}\u{6B7B}\u{53BB}\u{4E86}\u{3002}\u{8F93}\u{5165}\u{60A8}\u{7684}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{5373}\u{53EF}\u{63A5}\u{6536}\u{65B0}\u{94FE}\u{63A5}\u{3002}`,
    'zh-hant': `\u{9023}\u{7D50}\u{5DF2}\u{904E}\u{4E16}\u{3002}\u{8F38}\u{5165}\u{60A8}\u{7684}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{5373}\u{53EF}\u{63A5}\u{6536}\u{65B0}\u{9023}\u{7D50}\u{3002}`,
    en: `Link expired. Enter your email to receive a new link.`
};
const $b11db1b62d4a8f76$export$14f8ee10fb1dede3 = {
    ar: (when)=>$b11db1b62d4a8f76$var$html`<span>انتهت صلاحية الرابط ${when}</span>`,
    de: (when)=>$b11db1b62d4a8f76$var$html`<span>Link ist ${when} abgelaufen</span>`,
    es: (when)=>$b11db1b62d4a8f76$var$html`<span>El enlace ${when}</span>`,
    fa: (when)=>$b11db1b62d4a8f76$var$html`<span>لینک ${when} منقضی شد</span>`,
    fil: (when)=>$b11db1b62d4a8f76$var$html`<span>Nag-expire ang link ${when}</span>`,
    fr: (when)=>$b11db1b62d4a8f76$var$html`<span>Le lien a ${when}</span>`,
    hi: (when)=>$b11db1b62d4a8f76$var$html`<span>लिंक की समय सीमा 5 ${when} हो गई</span>`,
    ht: (when)=>$b11db1b62d4a8f76$var$html`<span>Link ekspire ${when}</span>`,
    it: (when)=>$b11db1b62d4a8f76$var$html`<span>Il link è ${when}</span>`,
    ja: (when)=>$b11db1b62d4a8f76$var$html`<span>リンクは${when}期限切れになりました</span>`,
    ko: (when)=>$b11db1b62d4a8f76$var$html`<span>링크가 ${when} 만료됐어요</span>`,
    mww: (when)=>$b11db1b62d4a8f76$var$html`<span>Txuas tas sij ${when}</span>`,
    ps: (when)=>$b11db1b62d4a8f76$var$html`<span>لینک ${when} ختم شو</span>`,
    pt: (when)=>$b11db1b62d4a8f76$var$html`<span>Link ${when}</span>`,
    'pt-pt': (when)=>$b11db1b62d4a8f76$var$html`<span>O link ${when}</span>`,
    ru: (when)=>$b11db1b62d4a8f76$var$html`<span>Ссылка ${when}</span>`,
    sm: (when)=>$b11db1b62d4a8f76$var$html`<span>Link expired ${when}</span>`,
    so: (when)=>$b11db1b62d4a8f76$var$html`<span>Xiriirku wuu dhacay ${when}</span>`,
    th: (when)=>$b11db1b62d4a8f76$var$html`<span>ลิงก์หมดอายุเมื่อ ${when}</span>`,
    ur: (when)=>$b11db1b62d4a8f76$var$html`<span>لنک ${when} ختم ہو چکا ہے</span>`,
    vi: (when)=>$b11db1b62d4a8f76$var$html`<span>Link hết hạn ${when}</span>`,
    'zh-hans': (when)=>$b11db1b62d4a8f76$var$html`<span>链接${when}前过期了</span>`,
    'zh-hant': (when)=>$b11db1b62d4a8f76$var$html`<span>連結${when}過期了</span>`,
    en: (when)=>$b11db1b62d4a8f76$var$html`<span>Link expired ${when}</span>`
};
const $b11db1b62d4a8f76$export$25a57b30938bf753 = {
    ar: `\u{62C}\u{627}\u{631} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    de: `L\xe4dt...`,
    es: `Cargando...`,
    fa: `\u{62F}\u{631} \u{62D}\u{627}\u{644} \u{628}\u{627}\u{631}\u{6AF}\u{630}\u{627}\u{631}\u{6CC}...`,
    fil: `Naglo-load...`,
    fr: `Chargement...`,
    hi: `\u{932}\u{94B}\u{921} \u{939}\u{94B} \u{930}\u{939}\u{93E} \u{939}\u{948}...`,
    ht: `Chaje ...`,
    it: `Caricamento...`,
    ja: `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    ko: `\u{B85C}\u{B529} \u{C911}...`,
    mww: `Chaw thau khoom...`,
    ps: `\u{628}\u{627}\u{631}\u{6D0}\u{696}\u{6CC}...`,
    pt: `Carregando...`,
    'pt-pt': `A carregar...`,
    ru: `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    sm: `Utaina ...`,
    so: `Soo ridaya...`,
    th: `\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E42}\u{E2B}\u{E25}\u{E14}...`,
    ur: `\u{644}\u{648}\u{688} \u{6C1}\u{648} \u{631}\u{6C1}\u{627} \u{6C1}\u{6D2}...`,
    vi: `\u{110}ang t\u{1EA3}i...`,
    'zh-hans': `\u{52A0}\u{8F7D}\u{4E2D}......`,
    'zh-hant': `\u{8F09}\u{5165}\u{4E2D}......`,
    en: `Loading...`
};
const $b11db1b62d4a8f76$export$797cd83670254ff = {
    ar: `\u{62D}\u{645}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`,
    de: `Mehr laden...`,
    es: `Carga m\xe1s...`,
    fa: `\u{628}\u{6CC}\u{634}\u{62A}\u{631} \u{628}\u{627}\u{631}\u{6AF}\u{630}\u{627}\u{631}\u{6CC} \u{6A9}\u{646}...`,
    fil: `Mag-load ng higit pa ...`,
    fr: `Chargez plus...`,
    hi: `\u{905}\u{927}\u{93F}\u{915} \u{932}\u{94B}\u{921} \u{915}\u{930}\u{947}\u{902}...`,
    ht: `Chaje plis...`,
    it: `Carica ancora...`,
    ja: `\u{3082}\u{3063}\u{3068}\u{8AAD}\u{307F}\u{8FBC}\u{3093}\u{3067}...`,
    ko: `\u{B354} \u{BD88}\u{B7EC}\u{C640}...`,
    mww: `Load ntxiv...`,
    ps: `\u{646}\u{648}\u{631} \u{628}\u{627}\u{631} \u{6A9}\u{693}\u{647}...`,
    pt: `Carregue mais...`,
    'pt-pt': `Carrega mais...`,
    ru: `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{438}\u{442}\u{44C} \u{435}\u{449}\u{451}...`,
    sm: `Uta atili ...`,
    so: `Rar dheeraad ah...`,
    th: `\u{E42}\u{E2B}\u{E25}\u{E14}\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E40}\u{E15}\u{E34}\u{E21}...`,
    ur: `\u{645}\u{632}\u{6CC}\u{62F} \u{644}\u{648}\u{688} \u{6A9}\u{631}\u{648}...`,
    vi: `T\u{1EA3}i th\xeam...`,
    'zh-hans': `\u{52A0}\u{8F7D}\u{66F4}\u{591A}......`,
    'zh-hant': `\u{7E7C}\u{7E8C}\u{8F09}\u{5165}......`,
    en: `Load more...`
};
const $b11db1b62d4a8f76$export$628276daeb5dfc7e = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{642}\u{639}`,
    de: `Lage`,
    es: `Ubicaci\xf3n`,
    fa: `\u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A}`,
    fil: `Lokasyon`,
    fr: `Emplacement`,
    hi: `\u{938}\u{94D}\u{925}\u{93E}\u{928}`,
    ht: `Kote yo ye`,
    it: `Posizione`,
    ja: `\u{6240}\u{5728}\u{5730}`,
    ko: `\u{C704}\u{CE58}`,
    mww: `Qhov chaw nyob`,
    ps: `\u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A}`,
    pt: `Localiza\xe7\xe3o`,
    'pt-pt': `Localiza\xe7\xe3o`,
    ru: `\u{420}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Nofoaga`,
    so: `Goobta`,
    th: `\u{E17}\u{E35}\u{E48}\u{E15}\u{E31}\u{E49}\u{E07}`,
    ur: `\u{645}\u{642}\u{627}\u{645}`,
    vi: `\u{110}\u{1ECB}a \u{111}i\u{1EC3}m`,
    'zh-hans': `\u{4F4D}\u{7F6E}`,
    'zh-hant': `\u{5730}\u{7406}\u{4F4D}\u{7F6E}`,
    en: `Location`
};
const $b11db1b62d4a8f76$export$90176409bb979027 = {
    ar: `\u{623}\u{62F}\u{62E}\u{644} \u{645}\u{648}\u{642}\u{639}\u{627} \u{644}\u{62A}\u{635}\u{641}\u{64A}\u{629} \u{623}\u{648} \u{641}\u{631}\u{632} \u{627}\u{644}\u{623}\u{62D}\u{62F}\u{627}\u{62B} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{645}\u{633}\u{627}\u{641}\u{629}.`,
    de: `Geben Sie einen Ort ein, um Ereignisse nach Entfernung zu filtern oder zu sortieren.`,
    es: `Introduce una ubicaci\xf3n para filtrar o ordenar los eventos por distancia.`,
    fa: `\u{6CC}\u{6A9} \u{645}\u{6A9}\u{627}\u{646} \u{631}\u{627} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F} \u{62A}\u{627} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{647}\u{627} \u{631}\u{627} \u{628}\u{631} \u{627}\u{633}\u{627}\u{633} \u{641}\u{627}\u{635}\u{644}\u{647} \u{641}\u{6CC}\u{644}\u{62A}\u{631} \u{6CC}\u{627} \u{645}\u{631}\u{62A}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Maglagay ng lokasyon para i-filter o ayusin ang mga event ayon sa distansya.`,
    fr: `Saisissez un lieu pour filtrer ou trier les \xe9v\xe9nements par distance.`,
    hi: `\u{926}\u{942}\u{930}\u{940} \u{915}\u{947} \u{906}\u{927}\u{93E}\u{930} \u{92A}\u{930} \u{908}\u{935}\u{947}\u{902}\u{91F} \u{915}\u{94B} \u{92B}\u{93C}\u{93F}\u{932}\u{94D}\u{91F}\u{930} \u{915}\u{930}\u{928}\u{947} \u{92F}\u{93E} \u{938}\u{949}\u{930}\u{94D}\u{91F} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{94B}\u{908} \u{938}\u{94D}\u{925}\u{93E}\u{928} \u{921}\u{93E}\u{932}\u{947}\u{902}.`,
    ht: `Antre nan yon kote pou filtre oswa s\xf2t ev\xe8nman pa distans`,
    it: `Inserisci una posizione per filtrare o ordinare gli eventi per distanza.`,
    ja: `\u{5834}\u{6240}\u{3092}\u{5165}\u{529B}\u{3057}\u{3066}\u{3001}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{3092}\u{8DDD}\u{96E2}\u{3067}\u{7D5E}\u{308A}\u{8FBC}\u{307F}\u{3084}\u{30BD}\u{30FC}\u{30C8}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C704}\u{CE58}\u{B97C} \u{C785}\u{B825}\u{D558}\u{BA74} \u{C774}\u{BCA4}\u{D2B8}\u{B97C} \u{AC70}\u{B9AC}\u{BCC4}\u{B85C} \u{D544}\u{D130}\u{B9C1}\u{D558}\u{AC70}\u{B098} \u{C815}\u{B82C}\u{D558}\u{C138}\u{C694}.`,
    mww: `Sau ib qho chaw kom lim lossis txiav txim cov xwm txheej raws li deb.`,
    ps: `\u{6CC}\u{648} \u{681}\u{627}\u{6CC} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626} \u{62A}\u{631}\u{685}\u{648} \u{67E}\u{6CC}\u{69A}\u{6D0} \u{62F} \u{648}\u{627}\u{67C}\u{646} \u{644}\u{647} \u{645}\u{62E}\u{6D0} \u{641}\u{644}\u{67C}\u{631} \u{6CC}\u{627} \u{62A}\u{631}\u{62A}\u{6CC}\u{628} \u{634}\u{6CC}.`,
    pt: `Insira um local para filtrar ou ordenar eventos por dist\xe2ncia.`,
    'pt-pt': `Insira um local para filtrar ou ordenar eventos por dist\xe2ncia.`,
    ru: `\u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{43C}\u{435}\u{441}\u{442}\u{43E}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{444}\u{438}\u{43B}\u{44C}\u{442}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{438}\u{43B}\u{438} \u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F} \u{43F}\u{43E} \u{440}\u{430}\u{441}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{44E}.`,
    sm: `Ulu atu i se nofoaga e faamama pe faavasega ai mea na tutupu i le mamao.`,
    so: `Geli goob si aad u shaandheyso ama u kala saarto dhacdooyinka masaafada.`,
    th: `\u{E01}\u{E23}\u{E2D}\u{E01}\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E01}\u{E23}\u{E2D}\u{E07}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E08}\u{E31}\u{E14}\u{E40}\u{E23}\u{E35}\u{E22}\u{E07}\u{E40}\u{E2B}\u{E15}\u{E38}\u{E01}\u{E32}\u{E23}\u{E13}\u{E4C}\u{E15}\u{E32}\u{E21}\u{E23}\u{E30}\u{E22}\u{E30}\u{E17}\u{E32}\u{E07}`,
    ur: `\u{641}\u{627}\u{635}\u{644}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{62D}\u{627}\u{638} \u{633}\u{6D2} \u{648}\u{627}\u{642}\u{639}\u{627}\u{62A} \u{6A9}\u{648} \u{641}\u{644}\u{679}\u{631} \u{6CC}\u{627} \u{62A}\u{631}\u{62A}\u{6CC}\u{628} \u{62F}\u{6CC}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{6A9}\u{648}\u{626}\u{6CC} \u{645}\u{642}\u{627}\u{645} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Nh\u{1EAD}p v\u{1ECB} tr\xed \u{111}\u{1EC3} l\u{1ECD}c ho\u{1EB7}c s\u{1EAF}p x\u{1EBF}p s\u{1EF1} ki\u{1EC7}n theo kho\u{1EA3}ng c\xe1ch.`,
    'zh-hans': `\u{8F93}\u{5165}\u{5730}\u{70B9}\u{4EE5}\u{7B5B}\u{9009}\u{6216}\u{6392}\u{5E8F}\u{4E8B}\u{4EF6}\u{7684}\u{8DDD}\u{79BB}\u{3002}`,
    'zh-hant': `\u{8F38}\u{5165}\u{5730}\u{9EDE}\u{4EE5}\u{7BE9}\u{9078}\u{6216}\u{6392}\u{5E8F}\u{4E8B}\u{4EF6}\u{8DDD}\u{96E2}\u{3002}`,
    en: `Enter a location to filter or sort events by distance.`
};
const $b11db1b62d4a8f76$export$5c435af30e2c59d2 = {
    ar: `\u{627}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{639}\u{646}\u{648}\u{627}\u{646}\u{60C} \u{645}\u{62F}\u{64A}\u{646}\u{629}\u{60C} \u{648}\u{644}\u{627}\u{64A}\u{629}\u{60C} \u{631}\u{645}\u{632} \u{628}\u{631}\u{64A}\u{62F} \u{623}\u{648} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{645} \u{645}\u{648}\u{642}\u{639}\u{643} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}.`,
    de: `Suchen Sie nach einer Adresse, Stadt, Bundesstaat, Postleitzahl oder verwenden Sie Ihren aktuellen Standort.`,
    es: `Busca una direcci\xf3n, ciudad, estado, c\xf3digo postal o utiliza tu ubicaci\xf3n actual.`,
    fa: `\u{628}\u{647} \u{62F}\u{646}\u{628}\u{627}\u{644} \u{622}\u{62F}\u{631}\u{633}\u{60C} \u{634}\u{647}\u{631}\u{60C} \u{627}\u{6CC}\u{627}\u{644}\u{62A}\u{60C} \u{6A9}\u{62F} \u{67E}\u{633}\u{62A}\u{6CC} \u{6CC}\u{627} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{627}\u{632} \u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A} \u{641}\u{639}\u{644}\u{6CC} \u{62E}\u{648}\u{62F} \u{628}\u{6AF}\u{631}\u{62F}\u{6CC}\u{62F}.`,
    fil: `Maghanap para sa isang address, lungsod, estado, zip o gamitin ang iyong kasalukuyang lokasyon.`,
    fr: `Recherchez une adresse, une ville, un \xc9tat, un code postal ou utilisez votre localisation actuelle.`,
    hi: `\u{92A}\u{924}\u{93E}, \u{936}\u{939}\u{930}, \u{930}\u{93E}\u{91C}\u{94D}\u{92F}, \u{91C}\u{93C}\u{93F}\u{92A} \u{916}\u{94B}\u{91C}\u{947}\u{902} \u{92F}\u{93E} \u{905}\u{92A}\u{928}\u{947} \u{935}\u{930}\u{94D}\u{924}\u{92E}\u{93E}\u{928} \u{938}\u{94D}\u{925}\u{93E}\u{928} \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Rech\xe8ch pou yon adr\xe8s, vil, eta, postal oswa s\xe8vi ak kote ou ye kounye a.`,
    it: `Cerca un indirizzo, citt\xe0, stato, codice postale o usa la tua posizione attuale.`,
    ja: `\u{4F4F}\u{6240}\u{3001}\u{5E02}\u{3001}\u{5DDE}\u{3001}\u{90F5}\u{4FBF}\u{756A}\u{53F7}\u{3001}\u{307E}\u{305F}\u{306F}\u{73FE}\u{5728}\u{306E}\u{6240}\u{5728}\u{5730}\u{3092}\u{691C}\u{7D22}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C8FC}\u{C18C}, \u{B3C4}\u{C2DC}, \u{C8FC}, \u{C6B0}\u{D3B8}\u{BC88}\u{D638}\u{B97C} \u{AC80}\u{C0C9}\u{D558}\u{AC70}\u{B098} \u{D604}\u{C7AC} \u{C704}\u{CE58}\u{B97C} \u{C0AC}\u{C6A9}\u{D558}\u{C138}\u{C694}.`,
    mww: `Nrhiav chaw nyob, nroog, xeev, zip lossis siv koj qhov chaw nyob tam sim no.`,
    ps: `\u{62F} \u{67E}\u{62A}\u{647}\u{60C} \u{69A}\u{627}\u{631}\u{60C} \u{627}\u{6CC}\u{627}\u{644}\u{62A}\u{60C} \u{632}\u{67E} \u{6CC}\u{627} \u{62E}\u{67E}\u{644} \u{627}\u{648}\u{633}\u{646}\u{6CC} \u{681}\u{627}\u{6CC} \u{648}\u{67E}\u{644}\u{67C}\u{626}.`,
    pt: `Procure por endere\xe7o, cidade, estado, c\xf3digo postal ou use sua localiza\xe7\xe3o atual.`,
    'pt-pt': `Procure morada, cidade, estado, c\xf3digo postal ou use a sua localiza\xe7\xe3o atual.`,
    ru: `\u{41D}\u{430}\u{439}\u{434}\u{438}\u{442}\u{435} \u{430}\u{434}\u{440}\u{435}\u{441}, \u{433}\u{43E}\u{440}\u{43E}\u{434}, \u{448}\u{442}\u{430}\u{442}, \u{438}\u{43D}\u{434}\u{435}\u{43A}\u{441} \u{438}\u{43B}\u{438} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{439}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{451} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{435}\u{435} \u{43C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}.`,
    sm: `Saili mo se tuatusi, taulaga, setete, zip pe fa'aaoga lou nofoaga o lo'o i ai nei.`,
    so: `Raadi cinwaan, magaalo, gobol, zip ama isticmaal goobtaada hadda.`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48} \u{E40}\u{E21}\u{E37}\u{E2D}\u{E07} \u{E23}\u{E31}\u{E10} \u{E0B}\u{E34}\u{E1B} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E43}\u{E0A}\u{E49}\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E1B}\u{E31}\u{E08}\u{E08}\u{E38}\u{E1A}\u{E31}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{6A9}\u{633}\u{6CC} \u{67E}\u{62A}\u{6C1}\u{60C} \u{634}\u{6C1}\u{631}\u{60C} \u{631}\u{6CC}\u{627}\u{633}\u{62A}\u{60C} \u{632}\u{67E} (zip) \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{6CC}\u{627} \u{627}\u{67E}\u{646}\u{6CC} \u{645}\u{648}\u{62C}\u{648}\u{62F}\u{6C1} \u{62C}\u{6AF}\u{6C1} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `T\xecm ki\u{1EBF}m \u{111}\u{1ECB}a ch\u{1EC9}, th\xe0nh ph\u{1ED1}, ti\u{1EC3}u bang, zip ho\u{1EB7}c s\u{1EED} d\u{1EE5}ng v\u{1ECB} tr\xed hi\u{1EC7}n t\u{1EA1}i c\u{1EE7}a b\u{1EA1}n.`,
    'zh-hans': `\u{641C}\u{7D22}\u{5730}\u{5740}\u{3001}\u{57CE}\u{5E02}\u{3001}\u{5DDE}\u{3001}\u{90AE}\u{7F16}\u{6216}\u{4F7F}\u{7528}\u{60A8}\u{5F53}\u{524D}\u{6240}\u{5728}\u{7684}\u{4F4D}\u{7F6E}\u{3002}`,
    'zh-hant': `\u{641C}\u{5C0B}\u{5730}\u{5740}\u{3001}\u{57CE}\u{5E02}\u{3001}\u{5DDE}\u{3001}\u{90F5}\u{905E}\u{5340}\u{865F}\u{6216}\u{4F7F}\u{7528}\u{60A8}\u{76EE}\u{524D}\u{6240}\u{5728}\u{7684}\u{4F4D}\u{7F6E}\u{3002}`,
    en: `Search for an address, city, state, zip or use your current location.`
};
const $b11db1b62d4a8f76$export$2f17416cb5918cc2 = {
    ar: `\u{633}\u{62C}\u{644}`,
    de: `Log`,
    es: `Registro`,
    fa: `\u{6AF}\u{632}\u{627}\u{631}\u{634}`,
    fil: `Email Address *`,
    fr: `Journal`,
    hi: `\u{932}\u{91F}\u{94D}\u{920}\u{93E}`,
    ht: `Bout\xe8y demi lit`,
    it: `Log`,
    ja: `\u{30ED}\u{30B0}`,
    ko: `\u{B85C}\u{ADF8}`,
    mww: `cav`,
    ps: `\u{644}\u{627}\u{6AB}`,
    pt: `Registro`,
    'pt-pt': `Log`,
    ru: `\u{411}\u{440}\u{435}\u{432}\u{43D}\u{43E}`,
    sm: `Ogalaau`,
    so: `Diiwaanka`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}`,
    ur: `\u{644}\u{627}\u{6AF}`,
    vi: `Nh\u{1EAD}t k\xfd`,
    'zh-hans': `\u{65E5}\u{5FD7}`,
    'zh-hant': `\u{65E5}\u{8A8C}`,
    en: `Log`
};
const $b11db1b62d4a8f76$export$d167610aee409914 = {
    ar: `\u{64A}\u{633}\u{62A}\u{62E}\u{62F}\u{645}\u{647}\u{627} \u{632}\u{645}\u{644}\u{627}\u{624}\u{643} \u{644}\u{630}\u{643}\u{631}\u{643} \u{641}\u{64A} \u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{642}\u{627}\u{62A}. \u{627}\u{644}\u{62D}\u{631}\u{648}\u{641}\u{60C} \u{627}\u{644}\u{623}\u{631}\u{642}\u{627}\u{645}\u{60C} \u{648}\u{627}\u{644}\u{634}\u{631}\u{637}\u{627}\u{62A} \u{641}\u{642}\u{637}.`,
    de: `Wird von Teamkollegen verwendet, um dich in den Kommentaren zu erw\xe4hnen. Nur Buchstaben, Zahlen und Bindestriche.`,
    es: `Usado por compa\xf1eros para mencionarte en los comentarios. Solo letras, n\xfameros y guiones.`,
    fa: `\u{62A}\u{648}\u{633}\u{637} \u{647}\u{645} \u{62A}\u{6CC}\u{645}\u{6CC} \u{647}\u{627} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{634}\u{627}\u{631}\u{647} \u{628}\u{647} \u{634}\u{645}\u{627} \u{62F}\u{631} \u{6A9}\u{627}\u{645}\u{646}\u{62A} \u{647}\u{627} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{645}\u{6CC} \u{634}\u{648}\u{62F}. \u{641}\u{642}\u{637} \u{62D}\u{631}\u{648}\u{641}\u{60C} \u{627}\u{639}\u{62F}\u{627}\u{62F} \u{648} \u{62E}\u{637} \u{62A}\u{6CC}\u{631}\u{647} \u{647}\u{627}.`,
    fil: `Ginamit ng mga kasamahan sa koponan para banggitin ka sa mga komento. Mga titik, numero, at hyphens lamang.`,
    fr: `Utilis\xe9 par mes co\xe9quipiers pour te mentionner dans les commentaires. Lettres, chiffres et traits d\u{2019}union uniquement.`,
    hi: `\u{91F}\u{940}\u{92E} \u{915}\u{947} \u{938}\u{93E}\u{925}\u{93F}\u{92F}\u{94B}\u{902} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{906}\u{92A}\u{915}\u{93E} \u{909}\u{932}\u{94D}\u{932}\u{947}\u{916} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E}\u{924}\u{93E} \u{939}\u{948} \u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{93F}\u{92F}\u{93E}\u{901}. \u{915}\u{947}\u{935}\u{932} \u{905}\u{915}\u{94D}\u{937}\u{930}, \u{938}\u{902}\u{916}\u{94D}\u{92F}\u{93E}\u{90F}\u{901} \u{914}\u{930} \u{939}\u{93E}\u{907}\u{92B}\u{93C}\u{928}\u{964}`,
    ht: `Itilize pa koekipye mansyone ou nan k\xf2mant\xe8. L\xe8t, nimewo, ak tir\xe8 s\xe8lman.`,
    it: `Usato dai compagni di squadra per menzionarti nei commenti. Solo lettere, numeri e trattini.`,
    ja: `\u{30C1}\u{30FC}\u{30E0}\u{30E1}\u{30A4}\u{30C8}\u{304C}\u{30B3}\u{30E1}\u{30F3}\u{30C8}\u{3067}\u{3042}\u{306A}\u{305F}\u{3092}\u{7D39}\u{4ECB}\u{3059}\u{308B}\u{305F}\u{3081}\u{306B}\u{4F7F}\u{3063}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}\u{6587}\u{5B57}\u{3001}\u{6570}\u{5B57}\u{3001}\u{30CF}\u{30A4}\u{30D5}\u{30F3}\u{306E}\u{307F}\u{3002}`,
    ko: `\u{D300}\u{C6D0}\u{B4E4}\u{C774} \u{B313}\u{AE00}\u{C5D0}\u{C11C} \u{B2F9}\u{C2E0}\u{C744} \u{C5B8}\u{AE09}\u{D560} \u{B54C} \u{C0AC}\u{C6A9}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C624}\u{C9C1} \u{BB38}\u{C790}, \u{C22B}\u{C790}, \u{D558}\u{C774}\u{D508}\u{B9CC}.`,
    mww: `Siv los ntawm teammates los hais txog koj hauv cov lus. Cov tsiaj ntawv, cov zauv thiab cov zauv xwb.`,
    ps: `\u{62F} \u{67C}\u{6CC}\u{645} \u{645}\u{644}\u{6AB}\u{631}\u{648} \u{644}\u{62E}\u{648}\u{627} \u{62F} \u{62A}\u{628}\u{635}\u{631}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{6A9}\u{627}\u{631}\u{648}\u{644} \u{634}\u{648}\u{6CC}. \u{6CC}\u{648}\u{627}\u{632}\u{6D0} \u{62D}\u{631}\u{648}\u{641}\u{60C} \u{634}\u{645}\u{6D0}\u{631}\u{6D0}\u{60C} \u{627}\u{648} \u{647}\u{627}\u{6CC}\u{641}\u{646}\u{648}\u{646}\u{647}.`,
    pt: `Usado pelos colegas de equipe para te mencionar nos coment\xe1rios. Apenas letras, n\xfameros e h\xedfens.`,
    'pt-pt': `Usado pelos colegas de equipa para te mencionar nos coment\xe1rios. Apenas letras, n\xfameros e h\xedfens.`,
    ru: `\u{415}\u{433}\u{43E} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{44E}\u{442} \u{442}\u{43E}\u{432}\u{430}\u{440}\u{438}\u{449}\u{438} \u{43F}\u{43E} \u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{443}\u{43F}\u{43E}\u{43C}\u{438}\u{43D}\u{430}\u{442}\u{44C} \u{442}\u{435}\u{431}\u{44F} \u{432} \u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{44F}\u{445}. \u{422}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{431}\u{443}\u{43A}\u{432}\u{44B}, \u{446}\u{438}\u{444}\u{440}\u{44B} \u{438} \u{434}\u{435}\u{444}\u{438}\u{441}\u{44B}.`,
    sm: `Fa'aaogaina e le 'au e ta'u atu ai oe i fa'amatalaga. Na'o mataitusi, fuainumera, ma vase fa'apitoa.`,
    so: `Xubnaha kooxda ayaa u isticmaalay inay ku xusaan faallooyinka. Xarfo, lambarrada, iyo xarfaha kala duwan oo kaliya.`,
    th: `\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E19}\u{E23}\u{E48}\u{E27}\u{E21}\u{E17}\u{E35}\u{E21}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}\u{E04}\u{E38}\u{E13}\u{E43}\u{E19}\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19} \u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23} \u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E02} \u{E41}\u{E25}\u{E30}\u{E22}\u{E31}\u{E15}\u{E34}\u{E20}\u{E31}\u{E07}\u{E04}\u{E4C}\u{E40}\u{E17}\u{E48}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}`,
    ur: `\u{679}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE}\u{6CC} \u{6A9}\u{645}\u{646}\u{679}\u{633} \u{645}\u{6CC}\u{6BA} \u{622}\u{67E} \u{6A9}\u{627} \u{630}\u{6A9}\u{631} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4} \u{635}\u{631}\u{641} \u{62D}\u{631}\u{648}\u{641}\u{60C} \u{627}\u{639}\u{62F}\u{627}\u{62F} \u{627}\u{648}\u{631} \u{6C1}\u{627}\u{626}\u{641}\u{646}\u{632} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2}\u{6D4}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c \u{111}\u{1ED3}ng \u{111}\u{1ED9}i s\u{1EED} d\u{1EE5}ng \u{111}\u{1EC3} nh\u{1EAF}c \u{111}\u{1EBF}n b\u{1EA1}n trong b\xecnh lu\u{1EAD}n. Ch\u{1EC9} ch\u{1EEF} c\xe1i, s\u{1ED1} v\xe0 d\u{1EA5}u g\u{1EA1}ch n\u{1ED1}i.`,
    'zh-hans': `\u{961F}\u{53CB}\u{4EEC}\u{7528}\u{6765}\u{5728}\u{8BC4}\u{8BBA}\u{91CC}\u{63D0}\u{5230}\u{4F60}\u{3002}\u{4EC5}\u{9650}\u{5B57}\u{6BCD}\u{3001}\u{6570}\u{5B57}\u{548C}\u{8FDE}\u{5B57}\u{7B26}\u{3002}`,
    'zh-hant': `\u{968A}\u{53CB}\u{7528}\u{4F86}\u{5728}\u{7559}\u{8A00}\u{4E2D}\u{63D0}\u{5230}\u{4F60}\u{3002}\u{53EA}\u{5141}\u{8A31}\u{5B57}\u{6BCD}\u{3001}\u{6578}\u{5B57}\u{548C}\u{9023}\u{5B57}\u{865F}\u{3002}`,
    en: `Used by teammates to mention you in comments. Letters, numbers, and hyphens only.`
};
const $b11db1b62d4a8f76$export$4aff0780a4d562fe = {
    ar: `\u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F}`,
    de: `Versand`,
    es: `Env\xedo postal`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644} \u{67E}\u{633}\u{62A}\u{6CC}`,
    fil: `Email Address *`,
    fr: `Envoi postal`,
    hi: `\u{92E}\u{947}\u{932}\u{93F}\u{902}\u{917}`,
    ht: `Voye pa lap\xf2s`,
    it: `Spedizione postale`,
    ja: `\u{90F5}\u{9001}`,
    ko: `\u{C6B0}\u{D3B8} \u{BC1C}\u{C1A1}`,
    mww: `Kev Xa Ntawv`,
    ps: `\u{645}\u{6CC}\u{644} \u{6A9}\u{648}\u{644}`,
    pt: `Envio por correspond\xeancia`,
    'pt-pt': `Envio postal`,
    ru: `\u{420}\u{430}\u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{430}`,
    sm: `Meli`,
    so: `Boostada`,
    th: `\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E08}\u{E14}\u{E2B}\u{E21}\u{E32}\u{E22}`,
    ur: `\u{688}\u{627}\u{6A9}`,
    vi: `G\u{1EED}i th\u{1B0}`,
    'zh-hans': `\u{90AE}\u{5BC4}`,
    'zh-hant': `\u{90F5}\u{5BC4}`,
    en: `Mailing`
};
const $b11db1b62d4a8f76$export$6f6a6bca1bcd46f9 = {
    ar: `\u{627}\u{635}\u{646}\u{639} \u{646}\u{633}\u{62E}\u{629}`,
    de: `Mach eine Kopie`,
    es: `Haz una copia`,
    fa: `\u{6CC}\u{6A9} \u{6A9}\u{67E}\u{6CC} \u{62A}\u{647}\u{6CC}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Gumawa ng kopya`,
    fr: `Faites-en une copie`,
    hi: `\u{90F}\u{915} \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{932}\u{93F}\u{92A}\u{93F} \u{92C}\u{928}\u{93E}\u{90F}\u{901}`,
    ht: `F\xe8 yon kopi`,
    it: `Fai una copia`,
    ja: `\u{30B3}\u{30D4}\u{30FC}\u{3092}\u{4F5C}\u{3063}\u{3066}`,
    ko: `\u{BCF5}\u{C0AC}\u{D574}`,
    mww: `theej`,
    ps: `\u{6CC}\u{648}\u{647} \u{6A9}\u{627}\u{67E}\u{6CC} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{647}`,
    pt: `Fa\xe7a uma c\xf3pia`,
    'pt-pt': `Faz uma c\xf3pia`,
    ru: `\u{421}\u{434}\u{435}\u{43B}\u{430}\u{439} \u{43A}\u{43E}\u{43F}\u{438}\u{44E}`,
    sm: `Fai se kopi`,
    so: `Samee nuqul`,
    th: `\u{E17}\u{E4D}\u{E32}\u{E2A}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E32}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{646}\u{642}\u{644} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA1}o m\u{1ED9}t b\u{1EA3}n sao`,
    'zh-hans': `\u{590D}\u{5370}\u{4E00}\u{4EFD}`,
    'zh-hant': `\u{8907}\u{88FD}\u{4E00}\u{4EFD}`,
    en: `Make a copy`
};
const $b11db1b62d4a8f76$export$9f7401092d07c779 = {
    ar: `\u{627}\u{62C}\u{639}\u{644} \u{647}\u{630}\u{627} \u{62A}\u{648}\u{642}\u{64A}\u{639}\u{64A} \u{627}\u{644}\u{627}\u{641}\u{62A}\u{631}\u{627}\u{636}\u{64A}`,
    de: `Mach das zu meiner Standardsignatur`,
    es: `Haz de esta mi firma por defecto`,
    fa: `\u{627}\u{6CC}\u{646} \u{631}\u{627} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636} \u{645}\u{646} \u{642}\u{631}\u{627}\u{631} \u{62F}\u{647}\u{6CC}\u{62F}`,
    fil: `Gawin itong default na lagda ko`,
    fr: `Faites de ceci ma signature par d\xe9faut`,
    hi: `\u{907}\u{938}\u{947} \u{92E}\u{947}\u{930}\u{93E} \u{921}\u{93F}\u{92B}\u{93C}\u{949}\u{932}\u{94D}\u{91F} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{92C}\u{928}\u{93E}\u{90F}\u{902}`,
    ht: `F\xe8 sa a siyati default mwen an`,
    it: `Fai in modo che questa sia la mia firma predefinita`,
    ja: `\u{3053}\u{308C}\u{3092}\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}\u{306E}\u{7F72}\u{540D}\u{306B}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{C774}\u{AC78} \u{B0B4} \u{AE30}\u{BCF8} \u{C11C}\u{BA85}\u{C73C}\u{B85C} \u{B9CC}\u{B4E4}\u{C5B4}`,
    mww: `Ua qhov no kuv lub neej ntawd kos npe`,
    ps: `\u{62F}\u{627} \u{632}\u{645}\u{627} \u{627}\u{635}\u{644}\u{6CC} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{6A9}\u{693}\u{647}`,
    pt: `Fa\xe7a disso minha assinatura padr\xe3o`,
    'pt-pt': `Faz desta a minha assinatura padr\xe3o`,
    ru: `\u{421}\u{434}\u{435}\u{43B}\u{430}\u{439}\u{442}\u{435} \u{44D}\u{442}\u{43E} \u{441}\u{432}\u{43E}\u{435}\u{439} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}\u{44E} \u{43F}\u{43E} \u{443}\u{43C}\u{43E}\u{43B}\u{447}\u{430}\u{43D}\u{438}\u{44E}`,
    sm: `Fai lenei mea o la'u saini faaletonu`,
    so: `Ka dhig tan saxiixa aan leeyahay`,
    th: `\u{E17}\u{E4D}\u{E32}\u{E43}\u{E2B}\u{E49}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E19}\u{E35}\u{E49}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E09}\u{E31}\u{E19}`,
    ur: `\u{627}\u{633}\u{6D2} \u{645}\u{6CC}\u{631}\u{627} \u{688}\u{6CC}\u{641}\u{627}\u{644}\u{679} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{1EB7}t \u{111}\xe2y l\xe0 ch\u{1EEF} k\xfd m\u{1EB7}c \u{111}\u{1ECB}nh c\u{1EE7}a t\xf4i`,
    'zh-hans': `\u{628A}\u{5B83}\u{8BBE}\u{4E3A}\u{9ED8}\u{8BA4}\u{7B7E}\u{540D}`,
    'zh-hant': `\u{628A}\u{9019}\u{500B}\u{8A2D}\u{70BA}\u{6211}\u{7684}\u{9810}\u{8A2D}\u{7C3D}\u{540D}`,
    en: `Make this my default signature`
};
const $b11db1b62d4a8f76$export$f857c2eb7655a729 = {
    ar: `\u{623}\u{62F}\u{62E}\u{644} \u{627}\u{644}\u{631}\u{645}\u{632} \u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A} \u{64A}\u{62F}\u{648}\u{64A}\u{627} \u{641}\u{64A} \u{62A}\u{637}\u{628}\u{64A}\u{642} \u{627}\u{644}\u{645}\u{635}\u{627}\u{62F}\u{642}\u{629} \u{627}\u{644}\u{645}\u{641}\u{636}\u{644} \u{644}\u{62F}\u{64A}\u{643} \u{62B}\u{645} \u{623}\u{62F}\u{62E}\u{644} \u{627}\u{644}\u{631}\u{645}\u{632} \u{627}\u{644}\u{645}\u{624}\u{642}\u{62A} \u{627}\u{644}\u{645}\u{631}\u{641}\u{642} \u{623}\u{62F}\u{646}\u{627}\u{647}.`,
    de: `Geben Sie den folgenden Code manuell in Ihre bevorzugte Authenticator-App ein und geben Sie dann den unten angegebenen Einmalcode ein.`,
    es: `Introduce manualmente el siguiente c\xf3digo en tu aplicaci\xf3n de autenticaci\xf3n preferida y luego introduce el c\xf3digo \xfanico proporcionado a continuaci\xf3n.`,
    fa: `\u{6A9}\u{62F} \u{632}\u{6CC}\u{631} \u{631}\u{627} \u{628}\u{647} \u{635}\u{648}\u{631}\u{62A} \u{62F}\u{633}\u{62A}\u{6CC} \u{62F}\u{631} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{627}\u{62D}\u{631}\u{627}\u{632} \u{647}\u{648}\u{6CC}\u{62A} \u{645}\u{648}\u{631}\u{62F} \u{639}\u{644}\u{627}\u{642}\u{647} \u{62E}\u{648}\u{62F} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{633}\u{67E}\u{633} \u{6A9}\u{62F} \u{6CC}\u{6A9} \u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641} \u{627}\u{631}\u{627}\u{626}\u{647} \u{634}\u{62F}\u{647} \u{631}\u{627} \u{62F}\u{631} \u{632}\u{6CC}\u{631} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Manu-manong ipasok ang sumusunod na code sa iyong ginustong authenticator app at pagkatapos ay ipasok ang ibinigay na one-time code sa ibaba.`,
    fr: `Saisissez manuellement le code suivant dans votre application d\u{2019}authentification pr\xe9f\xe9r\xe9e, puis saisissez le code \xe0 usage unique fourni ci-dessous.`,
    hi: `\u{905}\u{92A}\u{928}\u{947} \u{92A}\u{938}\u{902}\u{926}\u{940}\u{926}\u{93E} \u{92A}\u{94D}\u{930}\u{92E}\u{93E}\u{923}\u{915} \u{910}\u{92A} \u{92E}\u{947}\u{902} \u{92E}\u{948}\u{928}\u{94D}\u{92F}\u{941}\u{905}\u{932} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{928}\u{93F}\u{92E}\u{94D}\u{928} \u{915}\u{94B}\u{921} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{92B}\u{93F}\u{930} \u{928}\u{940}\u{91A}\u{947} \u{926}\u{93F}\u{90F} \u{917}\u{90F} \u{935}\u{928}-\u{91F}\u{93E}\u{907}\u{92E} \u{915}\u{94B}\u{921} \u{915}\u{94B} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Many\xe8lman antre k\xf2d sa yo nan app otantifikat\xe8 ou pi pito ak L\xe8 sa a, antre nan k\xf2d la bay yon s\xe8l-fwa anba a.`,
    it: `Inserisci manualmente il seguente codice nell'app autenticatrice preferita e poi inserisci il codice monouso fornito qui sotto.`,
    ja: `\u{4EE5}\u{4E0B}\u{306E}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{624B}\u{52D5}\u{3067}\u{304A}\u{597D}\u{307F}\u{306E}\u{8A8D}\u{8A3C}\u{30A2}\u{30D7}\u{30EA}\u{306B}\u{5165}\u{529B}\u{3057}\u{3001}\u{4E0B}\u{8A18}\u{306E}\u{4E00}\u{5EA6}\u{9650}\u{308A}\u{306E}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{5165}\u{529B}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{B2E4}\u{C74C} \u{CF54}\u{B4DC}\u{B97C} \u{C9C1}\u{C811} \u{C6D0}\u{D558}\u{B294} \u{C778}\u{C99D} \u{C571}\u{C5D0} \u{C785}\u{B825}\u{D55C} \u{D6C4}, \u{C544}\u{B798}\u{C5D0} \u{C81C}\u{ACF5}\u{B41C} \u{C77C}\u{D68C}\u{C6A9} \u{CF54}\u{B4DC}\u{B97C} \u{C785}\u{B825}\u{D558}\u{C138}\u{C694}.`,
    mww: `Manually sau cov cai hauv qab no rau hauv koj nyiam authenticator app thiab tom qab ntawd nkag mus rau tus lej ib-zaug hauv qab no.`,
    ps: `\u{644}\u{627}\u{646}\u{62F}\u{6D0} \u{6A9}\u{648}\u{689} \u{67E}\u{647} \u{644}\u{627}\u{633}\u{6CC} \u{689}\u{648}\u{644} \u{62E}\u{67E}\u{644} \u{62E}\u{648}\u{69A} \u{634}\u{648}\u{6CC} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{62A}\u{647} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626} \u{627}\u{648} \u{628}\u{6CC}\u{627} \u{644}\u{627}\u{646}\u{62F}\u{6D0} \u{648}\u{631}\u{6A9}\u{693}\u{644} \u{634}\u{648}\u{6CC} \u{6CC}\u{648} \u{681}\u{644} \u{6A9}\u{648}\u{689} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626}.`,
    pt: `Insira manualmente o c\xf3digo a seguir no seu aplicativo autenticador preferido e ent\xe3o insira o c\xf3digo \xfanico fornecido abaixo.`,
    'pt-pt': `Introduza manualmente o seguinte c\xf3digo na sua aplica\xe7\xe3o de autentica\xe7\xe3o preferida e depois introduza o c\xf3digo \xfanico fornecido abaixo.`,
    ru: `\u{412}\u{440}\u{443}\u{447}\u{43D}\u{443}\u{44E} \u{432}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{441}\u{43B}\u{435}\u{434}\u{443}\u{44E}\u{449}\u{438}\u{439} \u{43A}\u{43E}\u{434} \u{432} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{435} \u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435} \u{430}\u{443}\u{442}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{438}, \u{430} \u{437}\u{430}\u{442}\u{435}\u{43C} \u{432}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{435}\u{434}\u{438}\u{43D}\u{43E}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{43A}\u{43E}\u{434} \u{43D}\u{438}\u{436}\u{435}.`,
    sm: `Ulufale lima i le code lenei i lau authenticator app e te fiafia i ai ona ulu atu lea i le code e tasi le taimi o loo i lalo.`,
    so: `Si gacanta ah ugu geli koodhka soo socda app-ka authenticator-ka aad doorbideyso, kadibna geli koodhka hal mar ee hoos ku xusan.`,
    th: `\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}\u{E19}\u{E35}\u{E49}\u{E25}\u{E07}\u{E43}\u{E19}\u{E41}\u{E2D}\u{E1B}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E15}\u{E31}\u{E27}\u{E15}\u{E19}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E14}\u{E49}\u{E27}\u{E22}\u{E15}\u{E19}\u{E40}\u{E2D}\u{E07} \u{E08}\u{E32}\u{E01}\u{E19}\u{E31}\u{E49}\u{E19}\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E17}\u{E35}\u{E48}\u{E43}\u{E2B}\u{E49}\u{E44}\u{E27}\u{E49}\u{E14}\u{E49}\u{E32}\u{E19}\u{E25}\u{E48}\u{E32}\u{E07}`,
    ur: `\u{627}\u{67E}\u{646}\u{6CC} \u{67E}\u{633}\u{646}\u{62F}\u{6CC}\u{62F}\u{6C1} \u{622}\u{62A}\u{6BE}\u{646}\u{679}\u{6CC} \u{6A9}\u{6CC}\u{679}\u{631} \u{627}\u{6CC}\u{67E} \u{645}\u{6CC}\u{6BA} \u{62F}\u{631}\u{62C} \u{630}\u{6CC}\u{644} \u{6A9}\u{648}\u{688} \u{62F}\u{633}\u{62A}\u{6CC} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{67E}\u{6BE}\u{631} \u{646}\u{6CC}\u{686}\u{6D2} \u{62F}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{648}\u{646} \u{679}\u{627}\u{626}\u{645} \u{6A9}\u{648}\u{688} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Nh\u{1EAD}p th\u{1EE7} c\xf4ng m\xe3 sau v\xe0o \u{1EE9}ng d\u{1EE5}ng x\xe1c th\u{1EF1}c \u{1B0}a th\xedch c\u{1EE7}a b\u{1EA1}n, sau \u{111}\xf3 nh\u{1EAD}p m\xe3 d\xf9ng m\u{1ED9}t l\u{1EA7}n \u{111}\u{1B0}\u{1EE3}c cung c\u{1EA5}p b\xean d\u{1B0}\u{1EDB}i.`,
    'zh-hans': `\u{624B}\u{52A8}\u{5C06}\u{4EE5}\u{4E0B}\u{9A8C}\u{8BC1}\u{7801}\u{8F93}\u{5165}\u{60A8}\u{504F}\u{597D}\u{7684}\u{8BA4}\u{8BC1}\u{5E94}\u{7528}\u{FF0C}\u{7136}\u{540E}\u{8F93}\u{5165}\u{4E0B}\u{65B9}\u{63D0}\u{4F9B}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{9A8C}\u{8BC1}\u{7801}\u{3002}`,
    'zh-hant': `\u{8ACB}\u{624B}\u{52D5}\u{8F38}\u{5165}\u{4EE5}\u{4E0B}\u{9A57}\u{8B49}\u{78BC}\u{5230}\u{60A8}\u{504F}\u{597D}\u{7684}\u{9A57}\u{8B49}\u{61C9}\u{7528}\u{7A0B}\u{5F0F}\u{FF0C}\u{7136}\u{5F8C}\u{8F38}\u{5165}\u{4E0B}\u{65B9}\u{63D0}\u{4F9B}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{9A57}\u{8B49}\u{78BC}\u{3002}`,
    en: `Manually enter the following code into your preferred authenticator app and then enter the provided one-time code below.`
};
const $b11db1b62d4a8f76$export$c36fb3befca1b570 = {
    ar: `\u{627}\u{644}\u{62D}\u{627}\u{644}\u{629} \u{627}\u{644}\u{627}\u{62C}\u{62A}\u{645}\u{627}\u{639}\u{64A}\u{629}`,
    de: `Familienstand`,
    es: `Estado civil`,
    fa: `\u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{62A}\u{623}\u{647}\u{644}`,
    fil: `Katayuan sa pag-aasawa`,
    fr: `\xc9tat civil`,
    hi: `\u{935}\u{948}\u{935}\u{93E}\u{939}\u{93F}\u{915} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F}`,
    ht: `Sitiyasyon sivil la`,
    it: `Stato civile`,
    ja: `\u{5A5A}\u{59FB}\u{72B6}\u{6CC1}`,
    ko: `\u{ACB0}\u{D63C} \u{C0C1}\u{D0DC}`,
    mww: `Xwm txheej txij nkawm`,
    ps: `\u{648}\u{627}\u{62F}\u{647} \u{634}\u{648}\u{6CC} \u{62D}\u{627}\u{644}\u{62A}`,
    pt: `Estado civil`,
    'pt-pt': `Estado civil`,
    ru: `\u{421}\u{435}\u{43C}\u{435}\u{439}\u{43D}\u{43E}\u{435} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Tulaga fa'aipoipo`,
    so: `Xaaladda guurka`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E20}\u{E32}\u{E1E}\u{E2A}\u{E21}\u{E23}\u{E2A}`,
    ur: `\u{627}\u{632}\u{62F}\u{648}\u{627}\u{62C}\u{6CC} \u{62D}\u{6CC}\u{62B}\u{6CC}\u{62A}`,
    vi: `T\xecnh tr\u{1EA1}ng h\xf4n nh\xe2n`,
    'zh-hans': `\u{5A5A}\u{59FB}\u{72B6}\u{51B5}`,
    'zh-hant': `\u{5A5A}\u{59FB}\u{72C0}\u{6CC1}`,
    en: `Marital status`
};
const $b11db1b62d4a8f76$export$5b428e0e41cc0f54 = {
    ar: `\u{645}\u{627}\u{631}\u{643}\u{62F}\u{627}\u{648}\u{646}`,
    de: `Markdown`,
    es: `Descuento`,
    fa: `\u{645}\u{627}\u{631}\u{6A9} \u{62F}\u{627}\u{648}\u{646}`,
    fil: `Markdown`,
    fr: `Markdown`,
    hi: `\u{92E}\u{93E}\u{930}\u{94D}\u{915}\u{921}\u{93E}\u{909}\u{928}`,
    ht: `Markdown`,
    it: `Sconto`,
    ja: `\u{5272}\u{5F15}`,
    ko: `\u{D560}\u{C778}`,
    mww: `Markdown`,
    ps: `\u{645}\u{627}\u{631}\u{6A9} \u{689}\u{627}\u{648}\u{646}`,
    pt: `Markdown`,
    'pt-pt': `Markdown`,
    ru: `Markdown`,
    sm: `Markdown`,
    so: `Qiimo dhimis`,
    th: `\u{E21}\u{E32}\u{E23}\u{E4C}\u{E01}\u{E14}\u{E32}\u{E27}\u{E19}\u{E4C}`,
    ur: `\u{645}\u{627}\u{631}\u{6A9} \u{688}\u{627}\u{624}\u{646}`,
    vi: `\u{110}\xe1nh d\u{1EA5}u`,
    'zh-hans': `\u{6298}\u{6263}`,
    'zh-hant': `\u{6298}\u{6263}`,
    en: `Markdown`
};
const $b11db1b62d4a8f76$export$5e1f42c18cafdbb = {
    ar: `\u{627}\u{644}\u{645}\u{628}\u{627}\u{631}\u{64A}\u{627}\u{62A}`,
    de: `Spiele`,
    es: `Partidos`,
    fa: `\u{645}\u{633}\u{627}\u{628}\u{642}\u{627}\u{62A}`,
    fil: `Mga Tugma`,
    fr: `Matchs`,
    hi: `\u{92E}\u{948}\u{91A}`,
    ht: `Alim\xe8t yo`,
    it: `Partite`,
    ja: `\u{8A66}\u{5408}`,
    ko: `\u{ACBD}\u{AE30}`,
    mww: `Cov ntais ntawv`,
    ps: `\u{633}\u{6CC}\u{627}\u{644}\u{6CD}`,
    pt: `Partidas`,
    'pt-pt': `Jogos`,
    ru: `\u{41C}\u{430}\u{442}\u{447}\u{438}`,
    sm: `Ta'aloga`,
    so: `Kulamada`,
    th: `\u{E41}\u{E21}\u{E15}\u{E0A}\u{E4C}`,
    ur: `\u{645}\u{6CC}\u{686}\u{632}`,
    vi: `C\xe1c tr\u{1EAD}n \u{111}\u{1EA5}u`,
    'zh-hans': `\u{6BD4}\u{8D5B}`,
    'zh-hant': `\u{6BD4}\u{8CFD}`,
    en: `Matches`
};
const $b11db1b62d4a8f76$export$c4819f0e7be0b5f0 = {
    ar: `MBI`,
    de: `MBI`,
    es: `MBI`,
    fa: `MBI`,
    fil: `MBI`,
    fr: `MBI`,
    hi: `\u{90F}\u{92E}\u{92C}\u{940}\u{906}\u{908}`,
    ht: `MBI`,
    it: `MBI`,
    ja: `MBI`,
    ko: `MBI`,
    mww: `MBI`,
    ps: `MBI`,
    pt: `MBI`,
    'pt-pt': `MBI`,
    ru: `MBI`,
    sm: `MBI`,
    so: `MBI`,
    th: `MBI`,
    ur: `\u{627}\u{6CC}\u{645} \u{628}\u{6CC} \u{622}\u{626}\u{6CC}`,
    vi: `MBI`,
    'zh-hans': `MBI`,
    'zh-hant': `MBI`,
    en: `MBI`
};
const $b11db1b62d4a8f76$export$eae583bedfb9ff6a = {
    ar: `\u{645}\u{64A}\u{62F}\u{64A}\u{643}\u{64A}\u{62F}`,
    de: `Medicaid`,
    es: `Medicaid`,
    fa: `\u{645}\u{62F}\u{6CC}\u{6A9}\u{6CC}\u{62F}`,
    fil: `Medicaid`,
    fr: `Medicaid`,
    hi: `\u{92E}\u{947}\u{921}\u{93F}\u{915}\u{947}\u{921}`,
    ht: `Medicaid`,
    it: `Medicaid`,
    ja: `\u{30E1}\u{30C7}\u{30A3}\u{30B1}\u{30A4}\u{30C9}`,
    ko: `\u{BA54}\u{B514}\u{CF00}\u{C774}\u{B4DC}`,
    mww: `Medicaid`,
    ps: `\u{645}\u{6CC}\u{689}\u{6CC}\u{6A9}\u{6D0}\u{689}`,
    pt: `Medicaid`,
    'pt-pt': `Medicaid`,
    ru: `Medicaid`,
    sm: `Medicaid`,
    so: `Medicaid`,
    th: `\u{E40}\u{E21}\u{E14}\u{E34}\u{E40}\u{E04}\u{E14}`,
    ur: `\u{645}\u{6CC}\u{688}\u{6CC}\u{6A9}\u{6CC}\u{688}`,
    vi: `Medicaid`,
    'zh-hans': `\u{533B}\u{7597}\u{8865}\u{52A9}`,
    'zh-hant': `\u{91AB}\u{7642}\u{88DC}\u{52A9}`,
    en: `Medicaid`
};
const $b11db1b62d4a8f76$export$efe5565d4cb41e84 = {
    ar: `\u{645}\u{639}\u{631}\u{641} \u{645}\u{64A}\u{62F}\u{64A}\u{643}\u{64A}\u{62F}`,
    de: `Medicaid-ID`,
    es: `Identificaci\xf3n de Medicaid`,
    fa: `\u{634}\u{646}\u{627}\u{633}\u{647} \u{645}\u{62F}\u{6CC}\u{6A9}\u{6CC}\u{62F}`,
    fil: `Medicaid ID`,
    fr: `Identifiant Medicaid`,
    hi: `\u{92E}\u{947}\u{921}\u{93F}\u{915}\u{947}\u{921} \u{906}\u{908}\u{921}\u{940}`,
    ht: `Medicaid ID`,
    it: `Medicaid ID`,
    ja: `\u{30E1}\u{30C7}\u{30A3}\u{30B1}\u{30A4}\u{30C9}ID`,
    ko: `\u{BA54}\u{B514}\u{CF00}\u{C774}\u{B4DC} \u{C2E0}\u{BD84}\u{C99D}`,
    mww: `Medicaid ID`,
    ps: `\u{62F} \u{645}\u{6CC}\u{689}\u{6CC}\u{6A9}\u{6D0}\u{689} ID`,
    pt: `Identifica\xe7\xe3o do Medicaid`,
    'pt-pt': `Medicaid ID`,
    ru: `Medicaid ID`,
    sm: `Medicaid ID`,
    so: `Aqoonsiga Medicaid`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A} Medicaid`,
    ur: `\u{645}\u{6CC}\u{688}\u{6CC}\u{6A9}\u{6CC}\u{688} \u{622}\u{626}\u{6CC} \u{688}\u{6CC}`,
    vi: `Medicaid ID`,
    'zh-hans': `\u{533B}\u{7597}\u{8865}\u{52A9}\u{8EAB}\u{4EFD}\u{8BC1}`,
    'zh-hant': `\u{91AB}\u{7642}\u{88DC}\u{52A9}\u{8B58}\u{5225}\u{78BC}`,
    en: `Medicaid ID`
};
const $b11db1b62d4a8f76$export$11fd4b7b485b377d = {
    ar: `\u{645}\u{639}\u{631}\u{641} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{641}\u{64A}\u{62F} \u{645}\u{646} \u{645}\u{64A}\u{62F}\u{64A}\u{643}\u{64A}\u{631} (MBI)`,
    de: `Medicare-Beg\xfcnstigten-ID (MBI)`,
    es: `Identificador de Beneficiario de Medicare (MBI)`,
    fa: `\u{634}\u{646}\u{627}\u{633}\u{647} \u{630}\u{6CC}\u{646}\u{641}\u{639} \u{645}\u{62F}\u{6CC}\u{6A9}\u{631} (MBI)`,
    fil: `Medicare Beneficiary ID (MBI)`,
    fr: `Identifiant de b\xe9n\xe9ficiaire Medicare (MBI)`,
    hi: `\u{92E}\u{947}\u{921}\u{93F}\u{915}\u{947}\u{92F}\u{930} \u{932}\u{93E}\u{92D}\u{93E}\u{930}\u{94D}\u{925}\u{940} \u{906}\u{908}\u{921}\u{940} (\u{90F}\u{92E}\u{92C}\u{940}\u{906}\u{908})`,
    ht: `ID Benefisy\xe8 Medicare (MBI)`,
    it: `Identificazione Beneficiario Medicare (MBI)`,
    ja: `\u{30E1}\u{30C7}\u{30A3}\u{30B1}\u{30A2}\u{53D7}\u{53D6}\u{4EBA}\u{8B58}\u{5225}\u{756A}\u{53F7}(MBI)`,
    ko: `\u{BA54}\u{B514}\u{CF00}\u{C5B4} \u{C218}\u{D61C}\u{C790} \u{C2DD}\u{BCC4} \u{BC88}\u{D638}(MBI)`,
    mww: `Medicare Beneficiary ID (MBI)`,
    ps: `\u{62F} \u{645}\u{6CC}\u{689}\u{6A9}\u{6D0}\u{631} \u{6AB}\u{67C}\u{647} \u{627}\u{62E}\u{6CC}\u{633}\u{62A}\u{648}\u{646}\u{6A9}\u{6CC} ID (MBI)`,
    pt: `Identifica\xe7\xe3o de Benefici\xe1rio do Medicare (MBI)`,
    'pt-pt': `ID de Benefici\xe1rio do Medicare (MBI)`,
    ru: `\u{423}\u{434}\u{43E}\u{441}\u{442}\u{43E}\u{432}\u{435}\u{440}\u{435}\u{43D}\u{438}\u{435} \u{43B}\u{438}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{431}\u{435}\u{43D}\u{435}\u{444}\u{438}\u{446}\u{438}\u{430}\u{440}\u{430} \u{43F}\u{43E} Medicare (MBI)`,
    sm: `Medicare Beneficiary ID (MBI)`,
    so: `Aqoonsiga Faa'iidada Medicare (MBI)`,
    th: `\u{E1A}\u{E31}\u{E15}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E08}\u{E4D}\u{E32}\u{E15}\u{E31}\u{E27}\u{E1C}\u{E39}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E1C}\u{E25}\u{E1B}\u{E23}\u{E30}\u{E42}\u{E22}\u{E0A}\u{E19}\u{E4C} Medicare (MBI)`,
    ur: `\u{645}\u{6CC}\u{688}\u{6CC}\u{6A9}\u{6CC}\u{626}\u{631} \u{628}\u{6CC}\u{646}\u{6CC}\u{641}\u{634}\u{631}\u{6CC} \u{622}\u{626}\u{6CC} \u{688}\u{6CC} (MBI)`,
    vi: `M\xe3 s\u{1ED1} Ng\u{1B0}\u{1EDD}i th\u{1EE5} h\u{1B0}\u{1EDF}ng Medicare (MBI)`,
    'zh-hans': `\u{533B}\u{7597}\u{4FDD}\u{9669}\u{53D7}\u{76CA}\u{4EBA}\u{8EAB}\u{4EFD}\u{8BC6}\u{522B}\u{7801}\u{FF08}MBI\u{FF09}`,
    'zh-hant': `\u{91AB}\u{7642}\u{4FDD}\u{96AA}\u{53D7}\u{76CA}\u{4EBA}\u{8B58}\u{5225}\u{78BC}\u{FF08}MBI\u{FF09}`,
    en: `Medicare Beneficiary ID (MBI)`
};
const $b11db1b62d4a8f76$export$ce3f596f77dce502 = {
    ar: `\u{627}\u{644}\u{623}\u{62F}\u{648}\u{64A}\u{629}`,
    de: `Medikamente`,
    es: `Medicaci\xf3n`,
    fa: `\u{62F}\u{627}\u{631}\u{648}`,
    fil: `Gamot`,
    fr: `M\xe9dication`,
    hi: `\u{907}\u{932}\u{93E}\u{91C}`,
    ht: `Medikaman`,
    it: `Farmaci`,
    ja: `\u{85AC}\u{7269}\u{6CBB}\u{7642}`,
    ko: `\u{C57D}\u{BB3C} \u{CE58}\u{B8CC}`,
    mww: `tshuaj`,
    ps: `\u{62F}\u{631}\u{645}\u{644}`,
    pt: `Medica\xe7\xe3o`,
    'pt-pt': `Medica\xe7\xe3o`,
    ru: `\u{41C}\u{435}\u{434}\u{438}\u{43A}\u{430}\u{43C}\u{435}\u{43D}\u{442}\u{44B}`,
    sm: `Vaila'au`,
    so: `Daawo`,
    th: `\u{E22}\u{E32}`,
    ur: `\u{627}\u{62F}\u{648}\u{6CC}\u{627}\u{62A}`,
    vi: `Thu\u{1ED1}c`,
    'zh-hans': `\u{7528}\u{836F}`,
    'zh-hant': `\u{85E5}\u{7269}\u{6CBB}\u{7642}`,
    en: `Medication`
};
const $b11db1b62d4a8f76$export$882d412b594b2f7f = {
    ar: `\u{62A}\u{641}\u{627}\u{639}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{623}\u{62F}\u{648}\u{64A}\u{629}`,
    de: `Medikamentenwechselwirkungen`,
    es: `Interacciones con medicamentos`,
    fa: `\u{62A}\u{62F}\u{627}\u{62E}\u{644}\u{627}\u{62A} \u{62F}\u{627}\u{631}\u{648}\u{6CC}\u{6CC}`,
    fil: `Mga pakikipag-ugnayan sa gamot`,
    fr: `Interactions m\xe9dicamenteuses`,
    hi: `\u{926}\u{935}\u{93E} \u{907}\u{902}\u{91F}\u{930}\u{948}\u{915}\u{94D}\u{936}\u{928}`,
    ht: `Dw\xf2g ent\xe8raksyon`,
    it: `Interazioni farmacologiche`,
    ja: `\u{85AC}\u{7269}\u{76F8}\u{4E92}\u{4F5C}\u{7528}`,
    ko: `\u{C57D}\u{BB3C} \u{C0C1}\u{D638}\u{C791}\u{C6A9}`,
    mww: `Kev sib cuam tshuam tshuaj`,
    ps: `\u{62F} \u{62F}\u{631}\u{645}\u{644}\u{648} \u{62A}\u{639}\u{627}\u{645}\u{644}\u{627}\u{62A}`,
    pt: `Intera\xe7\xf5es com medicamentos`,
    'pt-pt': `Intera\xe7\xf5es com medica\xe7\xe3o`,
    ru: `\u{412}\u{437}\u{430}\u{438}\u{43C}\u{43E}\u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435} \u{43B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432}`,
    sm: `Fegalegaleaiga o vaila'au`,
    so: `Is-dhexgalka daawooyinka`,
    th: `\u{E1B}\u{E0F}\u{E34}\u{E2A}\u{E31}\u{E21}\u{E1E}\u{E31}\u{E19}\u{E18}\u{E4C}\u{E02}\u{E2D}\u{E07}\u{E22}\u{E32}`,
    ur: `\u{627}\u{62F}\u{648}\u{6CC}\u{627}\u{62A} \u{6A9}\u{6D2} \u{62A}\u{639}\u{627}\u{645}\u{644}\u{627}\u{62A}`,
    vi: `T\u{1B0}\u{1A1}ng t\xe1c thu\u{1ED1}c`,
    'zh-hans': `\u{836F}\u{7269}\u{76F8}\u{4E92}\u{4F5C}\u{7528}`,
    'zh-hant': `\u{85E5}\u{7269}\u{4EA4}\u{4E92}\u{4F5C}\u{7528}`,
    en: `Medication interactions`
};
const $b11db1b62d4a8f76$export$76565219a9d3ec16 = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{649} \u{623}\u{64A} \u{62A}\u{62F}\u{627}\u{62E}\u{644}\u{627}\u{62A} \u{62F}\u{648}\u{627}\u{626}\u{64A}\u{629}`,
    de: `Keine Medikamentenwechselwirkungen gefunden`,
    es: `No se encontraron interacciones con medicaci\xf3n`,
    fa: `\u{647}\u{6CC}\u{686} \u{62A}\u{62F}\u{627}\u{62E}\u{644} \u{62F}\u{627}\u{631}\u{648}\u{6CC}\u{6CC} \u{6CC}\u{627}\u{641}\u{62A} \u{646}\u{634}\u{62F}`,
    fil: `Walang natagpuang pakikipag-ugnayan sa gamot`,
    fr: `Aucune interaction m\xe9dicamenteuse n\u{2019}a \xe9t\xe9 trouv\xe9e`,
    hi: `\u{915}\u{94B}\u{908} \u{926}\u{935}\u{93E} \u{907}\u{902}\u{91F}\u{930}\u{948}\u{915}\u{94D}\u{936}\u{928} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932}\u{93E}`,
    ht: `Pa gen ent\xe8raksyon medikaman yo te jwenn`,
    it: `Nessuna interazione farmacologica riscontrata`,
    ja: `\u{85AC}\u{5264}\u{306E}\u{76F8}\u{4E92}\u{4F5C}\u{7528}\u{306F}\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}\u{3067}\u{3057}\u{305F}`,
    ko: `\u{C57D}\u{BB3C} \u{C0C1}\u{D638}\u{C791}\u{C6A9}\u{C740} \u{BC1C}\u{ACAC}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj kev sib cuam tshuam nrog tshuaj pom`,
    ps: `\u{62F} \u{62F}\u{631}\u{645}\u{644}\u{648} \u{62A}\u{62F}\u{627}\u{62E}\u{644}\u{627}\u{62A} \u{648}\u{646}\u{647} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{634}\u{648}\u{644}`,
    pt: `Nenhuma intera\xe7\xe3o com medicamentos foi encontrada`,
    'pt-pt': `N\xe3o foram encontradas intera\xe7\xf5es com medica\xe7\xe3o`,
    ru: `\u{412}\u{437}\u{430}\u{438}\u{43C}\u{43E}\u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{43B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432} \u{43D}\u{435} \u{43E}\u{431}\u{43D}\u{430}\u{440}\u{443}\u{436}\u{435}\u{43D}\u{43E}`,
    sm: `Leai ni fegalegaleaiga o vailaau na maua`,
    so: `Wax is-dhexgal daawo ah lama helin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}\u{E1B}\u{E0F}\u{E34}\u{E01}\u{E34}\u{E23}\u{E34}\u{E22}\u{E32}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07}\u{E22}\u{E32}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{62F}\u{648}\u{627} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{62A}\u{639}\u{627}\u{645}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{644}\u{627}`,
    vi: `Kh\xf4ng t\xecm th\u{1EA5}y t\u{1B0}\u{1A1}ng t\xe1c thu\u{1ED1}c`,
    'zh-hans': `\u{672A}\u{53D1}\u{73B0}\u{836F}\u{7269}\u{76F8}\u{4E92}\u{4F5C}\u{7528}`,
    'zh-hant': `\u{6C92}\u{6709}\u{767C}\u{73FE}\u{85E5}\u{7269}\u{4EA4}\u{4E92}\u{4F5C}\u{7528}`,
    en: `No medication interactions found`
};
const $b11db1b62d4a8f76$export$e61a58cd3b6c5f7a = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{645}\u{60C} \u{627}\u{644}\u{642}\u{648}\u{629}\u{60C} \u{627}\u{644}\u{645}\u{633}\u{627}\u{631}\u{60C} \u{627}\u{644}\u{634}\u{643}\u{644}`,
    de: `Name, St\xe4rke, Route, Form`,
    es: `Nombre, fuerza, ruta, forma`,
    fa: `\u{646}\u{627}\u{645}\u{60C} \u{642}\u{62F}\u{631}\u{62A}\u{60C} \u{645}\u{633}\u{6CC}\u{631}\u{60C} \u{641}\u{631}\u{645}`,
    fil: `Pangalan, lakas, ruta, anyo`,
    fr: `Nom, force, itin\xe9raire, forme`,
    hi: `\u{928}\u{93E}\u{92E}, \u{936}\u{915}\u{94D}\u{924}\u{93F}, \u{92E}\u{93E}\u{930}\u{94D}\u{917}, \u{930}\u{942}\u{92A}`,
    ht: `Non, f\xf2s, wout, f\xf2m`,
    it: `Nome, forza, percorso, forma`,
    ja: `\u{540D}\u{524D}\u{3001}\u{5F37}\u{3055}\u{3001}\u{30EB}\u{30FC}\u{30C8}\u{3001}\u{5F62}\u{5F0F}`,
    ko: `\u{C774}\u{B984}, \u{D798}, \u{ACBD}\u{B85C}, \u{D615}\u{D0DC}`,
    mww: `Lub npe, lub zog, txoj kev, daim ntawv`,
    ps: `\u{646}\u{648}\u{645}\u{60C} \u{681}\u{648}\u{627}\u{6A9}\u{60C} \u{644}\u{627}\u{631}\u{647}\u{60C} \u{628}\u{6BC}\u{647}`,
    pt: `Nome, for\xe7a, rota, forma`,
    'pt-pt': `Nome, for\xe7a, rota, forma`,
    ru: `\u{418}\u{43C}\u{44F}, \u{441}\u{438}\u{43B}\u{430}, \u{43C}\u{430}\u{440}\u{448}\u{440}\u{443}\u{442}, \u{444}\u{43E}\u{440}\u{43C}\u{430}`,
    sm: `Igoa, malosi, auala, fomu`,
    so: `Magaca, xoogga, jidka, qaabka`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D} \u{E04}\u{E27}\u{E32}\u{E21}\u{E41}\u{E02}\u{E47}\u{E07}\u{E41}\u{E23}\u{E07} \u{E40}\u{E2A}\u{E49}\u{E19}\u{E17}\u{E32}\u{E07} \u{E41}\u{E1A}\u{E1A}\u{E1F}\u{E2D}\u{E23}\u{E4C}\u{E21}`,
    ur: `\u{646}\u{627}\u{645}\u{60C} \u{637}\u{627}\u{642}\u{62A}\u{60C} \u{631}\u{627}\u{633}\u{62A}\u{6C1}\u{60C} \u{634}\u{6A9}\u{644}`,
    vi: `T\xean, s\u{1EE9}c m\u{1EA1}nh, tuy\u{1EBF}n \u{111}\u{1B0}\u{1EDD}ng, h\xecnh th\u{1EE9}c`,
    'zh-hans': `\u{540D}\u{79F0}\u{3001}\u{529B}\u{91CF}\u{3001}\u{8DEF}\u{7EBF}\u{3001}\u{5F62}\u{6001}`,
    'zh-hant': `\u{540D}\u{7A31}\u{3001}\u{529B}\u{91CF}\u{3001}\u{8DEF}\u{7DDA}\u{3001}\u{5F62}\u{614B}`,
    en: `Name, strength, route, form`
};
const $b11db1b62d4a8f76$export$3ad2c0fa16cc7069 = {
    ar: `\u{627}\u{644}\u{623}\u{62F}\u{648}\u{64A}\u{629}`,
    de: `Medikamente`,
    es: `Medicamentos`,
    fa: `\u{62F}\u{627}\u{631}\u{648}\u{647}\u{627}`,
    fil: `Mga gamot`,
    fr: `M\xe9dicaments`,
    hi: `\u{926}\u{935}\u{93E}\u{913}\u{902}`,
    ht: `Medikaman yo`,
    it: `Farmaci`,
    ja: `\u{85AC}\u{5264}`,
    ko: `\u{C57D}\u{BB3C}`,
    mww: `Tshuaj`,
    ps: `\u{62F}\u{631}\u{645}\u{644}`,
    pt: `Medicamentos`,
    'pt-pt': `Medicamentos`,
    ru: `\u{41C}\u{435}\u{434}\u{438}\u{43A}\u{430}\u{43C}\u{435}\u{43D}\u{442}\u{44B}`,
    sm: `Vaila'au`,
    so: `Daawooyinka`,
    th: `\u{E22}\u{E32}`,
    ur: `\u{627}\u{62F}\u{648}\u{6CC}\u{627}\u{62A}`,
    vi: `Thu\u{1ED1}c`,
    'zh-hans': `\u{836F}\u{7269}`,
    'zh-hant': `\u{85E5}\u{7269}`,
    en: `Medications`
};
const $b11db1b62d4a8f76$export$ce95bef4f1834e30 = {
    ar: `\u{623}\u{637}\u{628}\u{627}\u{621} \u{627}\u{644}\u{623}\u{62F}\u{648}\u{64A}\u{629}`,
    de: `Medikamenten-\xc4rzte`,
    es: `M\xe9dicos de medicamentos`,
    fa: `\u{67E}\u{632}\u{634}\u{6A9}\u{627}\u{646} \u{62F}\u{627}\u{631}\u{648}\u{647}\u{627}`,
    fil: `Mga Gamot Docs`,
    fr: `M\xe9decins m\xe9dicamentaires`,
    hi: `\u{926}\u{935}\u{93E}\u{90F}\u{902} \u{921}\u{949}\u{915}\u{94D}\u{938}`,
    ht: `Medikaman Docs`,
    it: `Medici medici`,
    ja: `\u{85AC}\u{306E}\u{533B}\u{5E2B}`,
    ko: `\u{C57D}\u{BB3C} \u{C758}\u{C0AC}`,
    mww: `Cov tshuaj docs`,
    ps: `\u{62F} \u{62F}\u{631}\u{645}\u{644}\u{648} \u{689}\u{627}\u{6A9}\u{67C}\u{631}\u{627}\u{646}`,
    pt: `M\xe9dicos de medicamentos`,
    'pt-pt': `M\xe9dicos de medica\xe7\xe3o`,
    ru: `\u{412}\u{440}\u{430}\u{447}\u{438} \u{43F}\u{43E} \u{43C}\u{435}\u{434}\u{438}\u{43A}\u{430}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{43C}`,
    sm: `Vaila'au Docs`,
    so: `Daawooyinka dukumentiyada`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E22}\u{E32}`,
    ur: `\u{627}\u{62F}\u{648}\u{6CC}\u{627}\u{62A} \u{6A9}\u{6D2} \u{688}\u{627}\u{6A9}\u{679}\u{631}\u{632}`,
    vi: `T\xe0i li\u{1EC7}u thu\u{1ED1}c`,
    'zh-hans': `\u{836F}\u{7269}\u{533B}\u{751F}`,
    'zh-hant': `\u{85E5}\u{7269}\u{91AB}\u{5E2B}`,
    en: `Medications docs`
};
const $b11db1b62d4a8f76$export$491842644a914539 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{62F}\u{648}\u{64A}\u{629}`,
    de: `Es gibt keine Medikamente`,
    es: `No hay medicamentos`,
    fa: `\u{647}\u{6CC}\u{686} \u{62F}\u{627}\u{631}\u{648}\u{6CC}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang gamot`,
    fr: `Il n\u{2019}y a pas de m\xe9dicaments`,
    hi: `\u{915}\u{94B}\u{908} \u{926}\u{935}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}`,
    ht: `Pa gen medikaman`,
    it: `Non ci sono farmaci`,
    ja: `\u{85AC}\u{306F}\u{4F7F}\u{308F}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C57D}\u{C740} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj tshuaj`,
    ps: `\u{647}\u{6CC}\u{685} \u{62F}\u{631}\u{645}\u{644} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o existem medicamentos`,
    'pt-pt': `N\xe3o existem medicamentos`,
    ru: `\u{41D}\u{435}\u{442} \u{43D}\u{438}\u{43A}\u{430}\u{43A}\u{438}\u{445} \u{43B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432}`,
    sm: `E leai ni vaila'au`,
    so: `Daawo ma jiraan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E22}\u{E32}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{62F}\u{648}\u{627} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}`,
    vi: `Kh\xf4ng c\xf3 thu\u{1ED1}c`,
    'zh-hans': `\u{6CA1}\u{6709}\u{836F}\u{7269}`,
    'zh-hant': `\u{6C92}\u{6709}\u{85E5}\u{7269}`,
    en: `There are no medications`
};
const $b11db1b62d4a8f76$export$bd82cabb2462b435 = {
    ar: `\u{645}\u{639}\u{631}\u{641} \u{627}\u{644}\u{627}\u{62C}\u{62A}\u{645}\u{627}\u{639}`,
    de: `Meeting-ID`,
    es: `ID de la reuni\xf3n`,
    fa: `\u{634}\u{646}\u{627}\u{633}\u{647} \u{62C}\u{644}\u{633}\u{647}`,
    fil: `Meeting ID`,
    fr: `ID de r\xe9union`,
    hi: `\u{92E}\u{940}\u{91F}\u{93F}\u{902}\u{917} \u{906}\u{908}\u{921}\u{940}`,
    ht: `ID reyinyon an`,
    it: `ID riunione`,
    ja: `\u{30DF}\u{30FC}\u{30C6}\u{30A3}\u{30F3}\u{30B0}ID`,
    ko: `\u{D68C}\u{C758} ID`,
    mww: `Kev Sib Tham ID`,
    ps: `\u{62F} \u{63A}\u{648}\u{646}\u{689}\u{6D0} ID`,
    pt: `ID da Reuni\xe3o`,
    'pt-pt': `ID da Reuni\xe3o`,
    ru: `\u{418}\u{434}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} \u{432}\u{441}\u{442}\u{440}\u{435}\u{447}\u{438}`,
    sm: `ID o le fonotaga`,
    so: `Aqoonsiga Kulanka`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E01}\u{E32}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E0A}\u{E38}\u{E21}`,
    ur: `\u{645}\u{6CC}\u{679}\u{646}\u{6AF} \u{622}\u{626}\u{6CC} \u{688}\u{6CC}`,
    vi: `ID cu\u{1ED9}c h\u{1ECD}p`,
    'zh-hans': `\u{4F1A}\u{8BAE}\u{7F16}\u{53F7}`,
    'zh-hant': `\u{6703}\u{8B70}\u{7DE8}\u{865F}`,
    en: `Meeting ID`
};
const $b11db1b62d4a8f76$export$48430d752a7f8c60 = {
    ar: `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{627}\u{62C}\u{62A}\u{645}\u{627}\u{639}`,
    de: `Meetinginformationen`,
    es: `Informaci\xf3n de la reuni\xf3n`,
    fa: `\u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{62C}\u{644}\u{633}\u{647}`,
    fil: `Impormasyon tungkol sa pagpupulong`,
    fr: `Informations sur les r\xe9unions`,
    hi: `\u{92C}\u{948}\u{920}\u{915} \u{915}\u{940} \u{91C}\u{93E}\u{928}\u{915}\u{93E}\u{930}\u{940}`,
    ht: `Reyinyon enf\xf2masyon`,
    it: `Informazioni sulla riunione`,
    ja: `\u{4F1A}\u{8B70}\u{60C5}\u{5831}`,
    ko: `\u{D68C}\u{C758} \u{C815}\u{BCF4}`,
    mww: `Cov ntaub ntawv sib tham`,
    ps: `\u{62F} \u{63A}\u{648}\u{646}\u{689}\u{6D0} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    pt: `Informa\xe7\xf5es sobre a reuni\xe3o`,
    'pt-pt': `Informa\xe7\xf5es sobre a reuni\xe3o`,
    ru: `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F} \u{43E} \u{432}\u{441}\u{442}\u{440}\u{435}\u{447}\u{435}`,
    sm: `Faamatalaga o le fonotaga`,
    so: `Macluumaadka shirarka`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E01}\u{E32}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E0A}\u{E38}\u{E21}`,
    ur: `\u{645}\u{6CC}\u{679}\u{646}\u{6AF} \u{6A9}\u{6CC} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    vi: `Th\xf4ng tin v\u{1EC1} cu\u{1ED9}c h\u{1ECD}p`,
    'zh-hans': `\u{4F1A}\u{8BAE}\u{4FE1}\u{606F}`,
    'zh-hant': `\u{6703}\u{8B70}\u{8CC7}\u{8A0A}`,
    en: `Meeting information`
};
const $b11db1b62d4a8f76$export$3eb35648a5fedb38 = {
    ar: `\u{631}\u{627}\u{628}\u{637} \u{627}\u{644}\u{627}\u{62C}\u{62A}\u{645}\u{627}\u{639}`,
    de: `Treffenverbindung`,
    es: `Enlace de encuentro`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9} \u{62C}\u{644}\u{633}\u{647}`,
    fil: `Link ng pagpupulong`,
    fr: `Lien de rencontre`,
    hi: `\u{92E}\u{940}\u{91F}\u{93F}\u{902}\u{917} \u{932}\u{93F}\u{902}\u{915}`,
    ht: `Reyinyon lyen`,
    it: `Collegamento dell'incontro`,
    ja: `\u{4F1A}\u{8B70}\u{30EA}\u{30F3}\u{30AF}`,
    ko: `\u{D68C}\u{C758} \u{B9C1}\u{D06C}`,
    mww: `Kev txuas sib tham`,
    ps: `\u{62F} \u{63A}\u{648}\u{646}\u{689}\u{6D0} \u{644}\u{6CC}\u{646}\u{6A9}`,
    pt: `Link de encontro`,
    'pt-pt': `Link de encontro`,
    ru: `\u{421}\u{441}\u{44B}\u{43B}\u{43A}\u{430} \u{43D}\u{430} \u{432}\u{441}\u{442}\u{440}\u{435}\u{447}\u{443}`,
    sm: `Feso'ota'iga o le fonotaga`,
    so: `Xiriirka kulanka`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E01}\u{E32}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E0A}\u{E38}\u{E21}`,
    ur: `\u{645}\u{6CC}\u{679}\u{646}\u{6AF} \u{644}\u{646}\u{6A9}`,
    vi: `Li\xean k\u{1EBF}t cu\u{1ED9}c h\u{1ECD}p`,
    'zh-hans': `\u{4F1A}\u{8BAE}\u{94FE}\u{63A5}`,
    'zh-hant': `\u{6703}\u{8B70}\u{9023}\u{7D50}`,
    en: `Meeting link`
};
const $b11db1b62d4a8f76$export$91c6327a8e878ba = {
    ar: `\u{631}\u{645}\u{632} \u{645}\u{631}\u{648}\u{631} \u{627}\u{644}\u{627}\u{62C}\u{62A}\u{645}\u{627}\u{639}`,
    de: `Meeting-Code`,
    es: `C\xf3digo de acceso para reuniones`,
    fa: `\u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631} \u{62C}\u{644}\u{633}\u{647}`,
    fil: `Passcode ng pagpupulong`,
    fr: `Code d\u{2019}acc\xe8s pour les r\xe9unions`,
    hi: `\u{92E}\u{940}\u{91F}\u{93F}\u{902}\u{917} \u{92A}\u{93E}\u{938}\u{915}\u{94B}\u{921}`,
    ht: `Modpas reyinyon an`,
    it: `Codice di accesso per l'incontro`,
    ja: `\u{30DF}\u{30FC}\u{30C6}\u{30A3}\u{30F3}\u{30B0}\u{30D1}\u{30B9}\u{30B3}\u{30FC}\u{30C9}`,
    ko: `\u{D68C}\u{C758} \u{BE44}\u{BC00}\u{BC88}\u{D638}`,
    mww: `Password sib tham`,
    ps: `\u{62F} \u{63A}\u{648}\u{646}\u{689}\u{6D0} \u{67E}\u{627}\u{633}\u{6A9}\u{648}\u{689}`,
    pt: `C\xf3digo de acesso para reuni\xf5es`,
    'pt-pt': `C\xf3digo de acesso para reuni\xf5es`,
    ru: `\u{41A}\u{43E}\u{434} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{430} \u{43A} \u{432}\u{441}\u{442}\u{440}\u{435}\u{447}\u{435}`,
    sm: `Fonotaga passcode`,
    so: `Koodhka shirarka`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E01}\u{E32}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E0A}\u{E38}\u{E21}`,
    ur: `\u{645}\u{6CC}\u{679}\u{646}\u{6AF} \u{67E}\u{627}\u{633} \u{6A9}\u{648}\u{688}`,
    vi: `M\xe3 truy c\u{1EAD}p cu\u{1ED9}c h\u{1ECD}p`,
    'zh-hans': `\u{4F1A}\u{8BAE}\u{5BC6}\u{7801}`,
    'zh-hant': `\u{6703}\u{8B70}\u{5BC6}\u{78BC}`,
    en: `Meeting passcode`
};
const $b11db1b62d4a8f76$export$73391a6b8d1cff8a = {
    ar: `\u{639}\u{636}\u{648} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629} \u{627}\u{644}\u{630}\u{64A} \u{643}\u{644}\u{641} \u{628}\u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Mitglied der Organisation, der diese T\xe4tigkeit zugewiesen wurde.`,
    es: `Miembro de la organizaci\xf3n asignada a esta actividad.`,
    fa: `\u{639}\u{636}\u{648}\u{6CC} \u{627}\u{632} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{628}\u{631} \u{639}\u{647}\u{62F}\u{647} \u{62F}\u{627}\u{634}\u{62A}.`,
    fil: `Miyembro ng organisasyon na naatasan sa aktibidad na ito.`,
    fr: `Membre de l\u{2019}organisation qui s\u{2019}est vu confier cette activit\xe9.`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{91C}\u{93F}\u{928}\u{94D}\u{939}\u{947}\u{902} \u{92F}\u{939} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{938}\u{94C}\u{902}\u{92A}\u{940} \u{917}\u{908} \u{925}\u{940}\u{964}`,
    ht: `Manm \xf2ganizasyon ki te asiyen aktivite sa a.`,
    it: `Membro dell'organizzazione a cui \xe8 stata assegnata questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{3092}\u{62C5}\u{5F53}\u{3057}\u{305F}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C744} \u{B2F4}\u{B2F9}\u{D55C} \u{C870}\u{C9C1}\u{C758} \u{AD6C}\u{C131}\u{C6D0}.`,
    mww: `Tus tswv cuab ntawm lub koom haum uas tau muab txoj haujlwm no.`,
    ps: `\u{62F} \u{647}\u{63A}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{63A}\u{693}\u{6CC} \u{686}\u{6D0} \u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{648}\u{631}\u{62A}\u{647} \u{633}\u{67E}\u{627}\u{631}\u{644} \u{634}\u{648}\u{6CC} \u{648}.`,
    pt: `Membro da organiza\xe7\xe3o que foi designado para essa atividade.`,
    'pt-pt': `Membro da organiza\xe7\xe3o que foi designado para esta atividade.`,
    ru: `\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{43E}\u{43C}\u{443} \u{43F}\u{43E}\u{440}\u{443}\u{447}\u{438}\u{43B}\u{438} \u{44D}\u{442}\u{443} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `Sui o le faalapotopotoga lea na tofia i lenei gaoioiga.`,
    so: `Xubin ka tirsan ururka loo xilsaaray hawshan.`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{631}\u{6A9}\u{646} \u{62C}\u{633}\u{6D2} \u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{633}\u{648}\u{646}\u{67E}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{62A}\u{6BE}\u{6CC}\u{6D4}`,
    vi: `Th\xe0nh vi\xean c\u{1EE7}a t\u{1ED5} ch\u{1EE9}c \u{111}\u{1B0}\u{1EE3}c giao ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{7EC4}\u{7EC7}\u{6210}\u{5458}\u{FF0C}\u{8D1F}\u{8D23}\u{8FD9}\u{9879}\u{4EFB}\u{52A1}\u{3002}`,
    'zh-hant': `\u{8CA0}\u{8CAC}\u{6B64}\u{6D3B}\u{52D5}\u{7684}\u{7D44}\u{7E54}\u{6210}\u{54E1}\u{3002}`,
    en: `Member of organization who was assigned this activity.`
};
const $b11db1b62d4a8f76$export$611b0f37f4164ee6 = {
    ar: `\u{639}\u{636}\u{648} \u{641}\u{64A} \u{645}\u{646}\u{638}\u{645}\u{629} \u{62A}\u{639}\u{627}\u{642}\u{62F}\u{62A} \u{645}\u{639} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Mitglied einer Organisation, die diese T\xe4tigkeit beauftragt hat.`,
    es: `Miembro de una organizaci\xf3n que contrat\xf3 esta actividad.`,
    fa: `\u{639}\u{636}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{628}\u{647} \u{62F}\u{633}\u{62A} \u{622}\u{648}\u{631}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Miyembro ng isang organisasyon na nakipagkumpitensya sa aktibidad na ito.`,
    fr: `Membre d\u{2019}une organisation qui a souscrit cette activit\xe9.`,
    hi: `\u{90F}\u{915} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{91C}\u{93F}\u{938}\u{928}\u{947} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{94B} \u{905}\u{928}\u{941}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{915}\u{93F}\u{92F}\u{93E}\u{964}`,
    ht: `Manm yon \xf2ganizasyon ki te kontrakte aktivite sa a.`,
    it: `Membro di un'organizzazione che ha contrattato questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{3092}\u{5951}\u{7D04}\u{3057}\u{305F}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C744} \u{ACC4}\u{C57D}\u{D55C} \u{C870}\u{C9C1}\u{C758} \u{C77C}\u{C6D0}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Tus tswv cuab ntawm ib lub koom haum uas tau cog lus rau qhov kev ua no.`,
    ps: `\u{62F} \u{6CC}\u{648}\u{6D0} \u{627}\u{62F}\u{627}\u{631}\u{6D0} \u{63A}\u{693}\u{6CC} \u{686}\u{6D0} \u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6CC}\u{6D0} \u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F} \u{6A9}\u{693}\u{6CC}.`,
    pt: `Membro de uma organiza\xe7\xe3o que contratou essa atividade.`,
    'pt-pt': `Membro de uma organiza\xe7\xe3o que contratou esta atividade.`,
    ru: `\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{430}\u{44F} \u{437}\u{430}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{43B}\u{430} \u{437}\u{430}\u{43A}\u{430}\u{437} \u{43D}\u{430} \u{44D}\u{442}\u{443} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `Sui o se fa'alapotopotoga na fa'atautaia lenei fa'alapotopotoga.`,
    so: `Xubin ka tirsan urur qandaraas ka qaatay hawshan.`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E2A}\u{E31}\u{E0D}\u{E0D}\u{E32}\u{E01}\u{E31}\u{E1A}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{631}\u{6A9}\u{646} \u{62C}\u{633} \u{646}\u{6D2} \u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{6CC}\u{6D4}`,
    vi: `Th\xe0nh vi\xean c\u{1EE7}a m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c \u{111}\xe3 k\xfd h\u{1EE3}p \u{111}\u{1ED3}ng v\u{1EDB}i ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{66FE}\u{53C2}\u{4E0E}\u{8FC7}\u{7C7B}\u{4F3C}\u{6D3B}\u{52A8}\u{7684}\u{7EC4}\u{7EC7}\u{6210}\u{5458}\u{3002}`,
    'zh-hant': `\u{662F}\u{627F}\u{5305}\u{9019}\u{9805}\u{6D3B}\u{52D5}\u{7684}\u{7D44}\u{7E54}\u{6210}\u{54E1}\u{3002}`,
    en: `Member of an organization that contracted this activity.`
};
const $b11db1b62d4a8f76$export$bc45edeb9111b25a = {
    ar: `\u{639}\u{636}\u{648} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629} \u{627}\u{644}\u{62A}\u{64A} \u{623}\u{646}\u{634}\u{623}\u{62A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Mitglied der Organisation, die diese Aktivit\xe4t ins Leben gerufen hat.`,
    es: `Miembro de la organizaci\xf3n que cre\xf3 esta actividad.`,
    fa: `\u{639}\u{636}\u{648}\u{6CC} \u{627}\u{632} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Miyembro ng organisasyon na lumikha ng aktibidad na ito.`,
    fr: `Membre de l\u{2019}organisation qui a cr\xe9\xe9 cette activit\xe9.`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{91C}\u{93F}\u{928}\u{94D}\u{939}\u{94B}\u{902}\u{928}\u{947} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{94B} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Manm \xf2ganizasyon ki kreye aktivite sa a.`,
    it: `Membro dell'organizzazione che ha creato questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{3092}\u{5275}\u{8A2D}\u{3057}\u{305F}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C744} \u{B9CC}\u{B4E0} \u{C870}\u{C9C1}\u{C758} \u{D68C}\u{C6D0}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Tus tswv cuab ntawm lub koom haum uas tsim qhov kev ua no.`,
    ps: `\u{62F} \u{647}\u{63A}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{63A}\u{693}\u{6CC} \u{686}\u{6D0} \u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6CC}\u{6D0} \u{631}\u{627}\u{645}\u{646}\u{681}\u{62A}\u{647} \u{6A9}\u{693}\u{6CC}.`,
    pt: `Membro da organiza\xe7\xe3o que criou essa atividade.`,
    'pt-pt': `Membro da organiza\xe7\xe3o que criou esta atividade.`,
    ru: `\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{441}\u{43E}\u{437}\u{434}\u{430}\u{432}\u{448}\u{435}\u{439} \u{44D}\u{442}\u{443} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `Sui o le faalapotopotoga na faavaeina lenei gaoioiga.`,
    so: `Xubin ka tirsan ururka abuuray hawshan.`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{631}\u{6A9}\u{646} \u{62C}\u{633} \u{646}\u{6D2} \u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{62A}\u{62E}\u{644}\u{6CC}\u{642} \u{6A9}\u{6CC}\u{6D4}`,
    vi: `Th\xe0nh vi\xean c\u{1EE7}a t\u{1ED5} ch\u{1EE9}c \u{111}\xe3 t\u{1EA1}o ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{521B}\u{5EFA}\u{6B64}\u{6D3B}\u{52A8}\u{7684}\u{7EC4}\u{7EC7}\u{6210}\u{5458}\u{3002}`,
    'zh-hant': `\u{5275}\u{7ACB}\u{6B64}\u{6D3B}\u{52D5}\u{7684}\u{7D44}\u{7E54}\u{6210}\u{54E1}\u{3002}`,
    en: `Member of organization who created this activity.`
};
const $b11db1b62d4a8f76$export$1963ca3fcfedab3 = {
    ar: `\u{639}\u{636}\u{648} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629} \u{627}\u{644}\u{630}\u{64A} \u{630}\u{643}\u{631} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Mitglied der Organisation, die in dieser Aktivit\xe4t erw\xe4hnt wurde.`,
    es: `Miembro de la organizaci\xf3n que fue mencionado en esta actividad.`,
    fa: `\u{639}\u{636}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{630}\u{6A9}\u{631} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Miyembro ng organisasyon na binanggit sa aktibidad na ito.`,
    fr: `Membre de l\u{2019}organisation mentionn\xe9 dans cette activit\xe9.`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{91C}\u{93F}\u{928}\u{915}\u{93E} \u{909}\u{932}\u{94D}\u{932}\u{947}\u{916} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92E}\u{947}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E}\u{964}`,
    ht: `Manm \xf2ganizasyon ki mansyone nan aktivite sa a.`,
    it: `Membro dell'organizzazione menzionato in questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{3067}\u{8A00}\u{53CA}\u{3055}\u{308C}\u{305F}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{C5B8}\u{AE09}\u{B41C} \u{C870}\u{C9C1}\u{C758} \u{C77C}\u{C6D0}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Tus tswv cuab ntawm lub koom haum uas tau hais hauv qhov kev ua no.`,
    ps: `\u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{63A}\u{693}\u{6CC} \u{686}\u{6D0} \u{67E}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D0} \u{6CC}\u{627}\u{62F} \u{634}\u{648}\u{6CC} \u{648}.`,
    pt: `Membro da organiza\xe7\xe3o que foi mencionado nesta atividade.`,
    'pt-pt': `Membro da organiza\xe7\xe3o que foi mencionado nesta atividade.`,
    ru: `\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{443}\u{43F}\u{43E}\u{43C}\u{44F}\u{43D}\u{443}\u{442}\u{44B}\u{439} \u{432} \u{44D}\u{442}\u{43E}\u{43C} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{438}.`,
    sm: `Sui o le faalapotopotoga lea na ta'ua i lenei gaoioiga.`,
    so: `Xubin ka tirsan ururka oo lagu xusay hawshan.`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}\u{E43}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{631}\u{6A9}\u{646} \u{62C}\u{633} \u{6A9}\u{627} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{630}\u{6A9}\u{631} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}\u{6D4}`,
    vi: `Th\xe0nh vi\xean c\u{1EE7}a t\u{1ED5} ch\u{1EE9}c \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EC1} c\u{1EAD}p trong ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{8BE5}\u{7EC4}\u{7EC7}\u{6210}\u{5458}\u{66FE}\u{88AB}\u{63D0}\u{53CA}\u{3002}`,
    'zh-hant': `\u{8A72}\u{7D44}\u{7E54}\u{6210}\u{54E1}\u{66FE}\u{88AB}\u{63D0}\u{53CA}\u{3002}`,
    en: `Member of organization who was mentioned in this activity.`
};
const $b11db1b62d4a8f76$export$c21fad0a67d5499c = {
    ar: `\u{639}\u{636}\u{648} \u{641}\u{64A} \u{645}\u{646}\u{638}\u{645}\u{629} \u{62A}\u{634}\u{631}\u{641} \u{639}\u{644}\u{649} \u{645}\u{646}\u{638}\u{645}\u{629} \u{623}\u{62E}\u{631}\u{649} \u{62A}\u{634}\u{627}\u{631}\u{643} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Mitglied einer Organisation, die eine andere Organisation beaufsichtigt, die an dieser Aktivit\xe4t teilnimmt.`,
    es: `Miembro de una organizaci\xf3n que supervisa a otra organizaci\xf3n que participa en esta actividad.`,
    fa: `\u{639}\u{636}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{628}\u{631} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62F}\u{6CC}\u{6AF}\u{631}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{634}\u{631}\u{6A9}\u{62A} \u{62F}\u{627}\u{631}\u{62F} \u{646}\u{638}\u{627}\u{631}\u{62A} \u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `Miyembro ng isang organisasyon na nangangasiwa sa ibang organisasyon na nakikilahok sa aktibidad na ito.`,
    fr: `Membre d\u{2019}une organisation supervisant une autre organisation participant \xe0 cette activit\xe9.`,
    hi: `\u{90F}\u{915} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{93E} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{91C}\u{94B} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92E}\u{947}\u{902} \u{92D}\u{93E}\u{917} \u{932}\u{947}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{915}\u{93F}\u{938}\u{940} \u{905}\u{928}\u{94D}\u{92F} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{940} \u{926}\u{947}\u{916}\u{930}\u{947}\u{916} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Manm yon \xf2ganizasyon ki sip\xe8vize yon l\xf2t \xf2ganizasyon k ap patisipe nan aktivite sa a.`,
    it: `Membro di un'organizzazione che supervisiona un'altra organizzazione partecipante a questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306B}\u{53C2}\u{52A0}\u{3057}\u{3066}\u{3044}\u{308B}\u{4ED6}\u{306E}\u{7D44}\u{7E54}\u{3092}\u{76E3}\u{7763}\u{3059}\u{308B}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{CC38}\u{C5EC}\u{D558}\u{B294} \u{B2E4}\u{B978} \u{C870}\u{C9C1}\u{C744} \u{AC10}\u{B3C5}\u{D558}\u{B294} \u{C870}\u{C9C1}\u{C758} \u{D68C}\u{C6D0}.`,
    mww: `Tus tswv cuab ntawm ib lub koom haum uas saib xyuas lwm lub koom haum uas koom nrog txoj haujlwm no.`,
    ps: `\u{62F} \u{6CC}\u{648}\u{6D0} \u{627}\u{62F}\u{627}\u{631}\u{6D0} \u{63A}\u{693}\u{6CC} \u{686}\u{6D0} \u{628}\u{644} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{685}\u{627}\u{631}\u{6CC}.`,
    pt: `Membro de uma organiza\xe7\xe3o que supervisiona outra organiza\xe7\xe3o que participe dessa atividade.`,
    'pt-pt': `Membro de uma organiza\xe7\xe3o que supervisiona outra organiza\xe7\xe3o que participe nesta atividade.`,
    ru: `\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{430}\u{44F} \u{43A}\u{443}\u{440}\u{438}\u{440}\u{443}\u{435}\u{442} \u{434}\u{440}\u{443}\u{433}\u{443}\u{44E} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44E}, \u{43F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{44E}\u{449}\u{443}\u{44E} \u{443}\u{447}\u{430}\u{441}\u{442}\u{438}\u{435} \u{432} \u{44D}\u{442}\u{43E}\u{439} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}.`,
    sm: `Sui o se faalapotopotoga o loo vaavaaia se isi faalapotopotoga o loo auai i lenei gaoioiga.`,
    so: `Xubin ka tirsan urur kormeera urur kale oo ka qayb qaadanaya hawshan.`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E14}\u{E39}\u{E41}\u{E25}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{6CC}\u{633}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{631}\u{6A9}\u{646} \u{62C}\u{648} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{62D}\u{635}\u{6C1} \u{644}\u{6CC}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6CC} \u{62F}\u{648}\u{633}\u{631}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6CC} \u{646}\u{6AF}\u{631}\u{627}\u{646}\u{6CC} \u{6A9}\u{631}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Th\xe0nh vi\xean c\u{1EE7}a m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c gi\xe1m s\xe1t m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c kh\xe1c tham gia ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{96B6}\u{5C5E}\u{4E8E}\u{76D1}\u{7763}\u{53C2}\u{4E0E}\u{8BE5}\u{6D3B}\u{52A8}\u{7684}\u{53E6}\u{4E00}\u{4E2A}\u{7EC4}\u{7EC7}\u{7684}\u{7EC4}\u{7EC7}\u{3002}`,
    'zh-hant': `\u{96B8}\u{5C6C}\u{65BC}\u{76E3}\u{7763}\u{53C3}\u{8207}\u{6B64}\u{6D3B}\u{52D5}\u{7684}\u{53E6}\u{4E00}\u{500B}\u{7D44}\u{7E54}\u{7684}\u{7D44}\u{7E54}\u{6210}\u{54E1}\u{3002}`,
    en: `Member of an organization that supervises another organization participating in this activity.`
};
const $b11db1b62d4a8f76$export$9dfa01f928fcc96e = {
    ar: (project)=>`\u{639}\u{636}\u{648} \u{641}\u{64A} \u{645}\u{646}\u{638}\u{645}\u{629} \u{62A}\u{634}\u{631}\u{641} \u{639}\u{644}\u{649} \u{645}\u{634}\u{631}\u{648}\u{639} ${project} .`,
    de: (project)=>`Mitglied einer Organisation, die das ${project} \xfcberwacht.`,
    es: (project)=>`Miembro de una organizaci\xf3n que supervisa el proyecto ${project} .`,
    fa: (project)=>`\u{639}\u{636}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{67E}\u{631}\u{648}\u{698}\u{647} ${project} \u{631}\u{627} \u{646}\u{638}\u{627}\u{631}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F}.`,
    fil: (project)=>`Miyembro ng isang organisasyon na nangangasiwa sa ${project} .`,
    fr: (project)=>`Membre d\u{2019}une organisation qui supervise le projet ${project} .`,
    hi: (project)=>`\u{90F}\u{915} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{91C}\u{94B} ${project} \u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E} \u{915}\u{940} \u{926}\u{947}\u{916}\u{930}\u{947}\u{916} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (project)=>`Manm yon \xf2ganizasyon ki sip\xe8vize pwoj\xe8 ${project} la.`,
    it: (project)=>`Membro di un'organizzazione che supervisiona il progetto ${project} .`,
    ja: (project)=>`${project}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{3092}\u{76E3}\u{7763}\u{3059}\u{308B}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3002}`,
    ko: (project)=>`${project} \u{D504}\u{B85C}\u{C81D}\u{D2B8}\u{B97C} \u{AC10}\u{B3C5}\u{D558}\u{B294} \u{C870}\u{C9C1}\u{C758} \u{C77C}\u{C6D0}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (project)=>`Tus tswv cuab ntawm ib lub koom haum uas saib xyuas txoj haujlwm ${project} .`,
    ps: (project)=>`\u{62F} \u{6CC}\u{648}\u{6D0} \u{627}\u{62F}\u{627}\u{631}\u{6D0} \u{63A}\u{693}\u{6CC} \u{686}\u{6D0} ${project} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{685}\u{627}\u{631}\u{6CC}.`,
    pt: (project)=>`Membro de uma organiza\xe7\xe3o que supervisiona o projeto ${project} .`,
    'pt-pt': (project)=>`Membro de uma organiza\xe7\xe3o que supervisiona o projeto ${project} .`,
    ru: (project)=>`\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{430}\u{44F} \u{43A}\u{43E}\u{43D}\u{442}\u{440}\u{43E}\u{43B}\u{438}\u{440}\u{443}\u{435}\u{442} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442} ${project} .`,
    sm: (project)=>`Sui o se fa'alapotopotoga o lo'o va'ava'aia le poloketi o ${project} .`,
    so: (project)=>`Xubin ka tirsan urur kormeera mashruuca ${project} karo.`,
    th: (project)=>`\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E14}\u{E39}\u{E41}\u{E25}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}${project}`,
    ur: (project)=>`\u{627}\u{6CC}\u{6A9} \u{627}\u{6CC}\u{633}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{631}\u{6A9}\u{646} \u{62C}\u{648} ${project} \u{6A9}\u{6D2} \u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2} \u{6A9}\u{6CC} \u{646}\u{6AF}\u{631}\u{627}\u{646}\u{6CC} \u{6A9}\u{631}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (project)=>`Th\xe0nh vi\xean c\u{1EE7}a m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c gi\xe1m s\xe1t d\u{1EF1} \xe1n ${project} .`,
    'zh-hans': (project)=>`\u{662F}\u{8D1F}\u{8D23}\u{76D1}\u{7763} ${project} \u{9879}\u{76EE}\u{7684}\u{7EC4}\u{7EC7}\u{6210}\u{5458}\u{3002}`,
    'zh-hant': (project)=>`\u{662F}\u{76E3}\u{7763} ${project} \u{8A08}\u{756B}\u{7684}\u{7D44}\u{7E54}\u{6210}\u{54E1}\u{3002}`,
    en: (project)=>`Member of an organization that supervises the ${project} project.`
};
const $b11db1b62d4a8f76$export$6a34f8e82a464786 = {
    ar: `\u{627}\u{644}\u{625}\u{634}\u{627}\u{631}\u{627}\u{62A}`,
    de: `Erw\xe4hnungen`,
    es: `Menciones`,
    fa: `\u{630}\u{6A9}\u{631}\u{647}\u{627}`,
    fil: `Mga pagbanggit`,
    fr: `Mentions`,
    hi: `\u{909}\u{932}\u{94D}\u{932}\u{947}\u{916}`,
    ht: `Mansyone`,
    it: `Menzioni`,
    ja: `\u{8A00}\u{53CA}`,
    ko: `\u{C5B8}\u{AE09}`,
    mww: `Cov lus hais`,
    ps: `\u{6CC}\u{627}\u{62F}\u{648}\u{646}\u{647}`,
    pt: `Men\xe7\xf5es`,
    'pt-pt': `Men\xe7\xf5es`,
    ru: `\u{423}\u{43F}\u{43E}\u{43C}\u{438}\u{43D}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Ta'ua`,
    so: `Xuska`,
    th: `\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}`,
    ur: `\u{630}\u{6A9}\u{631}`,
    vi: `\u{110}\u{1EC1} c\u{1EAD}p`,
    'zh-hans': `\u{63D0}\u{53CA}`,
    'zh-hant': `\u{63D0}\u{53CA}`,
    en: `Mentions`
};
const $b11db1b62d4a8f76$export$71c4c52d4f37ac21 = {
    ar: `\u{64A}\u{630}\u{643}\u{631}\u{643}`,
    de: `Erw\xe4hnt dich`,
    es: `Te menciona`,
    fa: `\u{627}\u{633}\u{645} \u{62A}\u{648} \u{631}\u{648} \u{645}\u{6CC} \u{628}\u{631}\u{647}.`,
    fil: `Binanggit ka`,
    fr: `Te mentionne`,
    hi: `\u{906}\u{92A}\u{915}\u{93E} \u{909}\u{932}\u{94D}\u{932}\u{947}\u{916} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}`,
    ht: `Mansyone ou`,
    it: `Ti menziona`,
    ja: `\u{541B}\u{306E}\u{3053}\u{3068}\u{3092}\u{8A00}\u{53CA}\u{3057}\u{3066}\u{308B}`,
    ko: `\u{B108} \u{C598}\u{AE30}\u{D574}`,
    mww: `Hais txog koj`,
    ps: `\u{633}\u{62A}\u{627} \u{6CC}\u{627}\u{62F}\u{648}\u{646}\u{647} \u{6A9}\u{648}\u{6CC}`,
    pt: `Menciona voc\xea`,
    'pt-pt': `Menciona-te`,
    ru: `\u{423}\u{43F}\u{43E}\u{43C}\u{438}\u{43D}\u{430}\u{435}\u{442} \u{442}\u{435}\u{431}\u{44F}`,
    sm: `Ta'ua oe`,
    so: `Adiga ayaa lagu xusay`,
    th: `\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{62A}\u{645}\u{6C1}\u{627}\u{631}\u{627} \u{630}\u{6A9}\u{631} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{6D2}`,
    vi: `\u{110}\u{1EC1} c\u{1EAD}p \u{111}\u{1EBF}n b\u{1EA1}n`,
    'zh-hans': `\u{63D0}\u{5230}\u{4F60}`,
    'zh-hant': `\u{63D0}\u{5230}\u{4F60}`,
    en: `Mentions you`
};
const $b11db1b62d4a8f76$export$5a9a90c319cc6950 = {
    ar: `\u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629} \u{642}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}`,
    de: `Men\xfc l\xe4dt gerade`,
    es: `El men\xfa est\xe1 cargando`,
    fa: `\u{645}\u{646}\u{648} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{628}\u{627}\u{631}\u{6AF}\u{630}\u{627}\u{631}\u{6CC} \u{627}\u{633}\u{62A}`,
    fil: `Naglo-load ang menu`,
    fr: `Le menu se charge`,
    hi: `\u{92E}\u{947}\u{928}\u{942} \u{932}\u{94B}\u{921} \u{939}\u{94B} \u{930}\u{939}\u{93E} \u{939}\u{948}`,
    ht: `Meni ap chaje`,
    it: `Il menu si sta caricando`,
    ja: `\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{304C}\u{8AAD}\u{307F}\u{8FBC}\u{307E}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}`,
    ko: `\u{BA54}\u{B274}\u{AC00} \u{B85C}\u{B529} \u{C911}\u{C785}\u{B2C8}\u{B2E4}`,
    mww: `Ntawv qhia zaub mov yog chaw thau khoom`,
    ps: `\u{645}\u{6CC}\u{646}\u{648} \u{67E}\u{648}\u{631}\u{62A}\u{647} \u{6A9}\u{6D0}\u{696}\u{6CC}`,
    pt: `O card\xe1pio est\xe1 carregando`,
    'pt-pt': `O menu est\xe1 a carregar`,
    ru: `\u{41C}\u{435}\u{43D}\u{44E} \u{437}\u{430}\u{433}\u{440}\u{443}\u{436}\u{430}\u{435}\u{442}\u{441}\u{44F}`,
    sm: `O lo'o utaina le lisi`,
    so: `Menu-ga waa la shubanayaa`,
    th: `\u{E40}\u{E21}\u{E19}\u{E39}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E42}\u{E2B}\u{E25}\u{E14}`,
    ur: `\u{645}\u{6CC}\u{646}\u{648} \u{644}\u{648}\u{688} \u{6C1}\u{648} \u{631}\u{6C1}\u{627} \u{6C1}\u{6D2}`,
    vi: `Menu \u{111}ang t\u{1EA3}i`,
    'zh-hans': `\u{83DC}\u{5355}\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{4E2D}`,
    'zh-hant': `\u{9078}\u{55AE}\u{6B63}\u{5728}\u{8F09}\u{5165}`,
    en: `Menu is loading`
};
const $b11db1b62d4a8f76$export$71ec55e0d6f09dfe = {
    ar: `\u{627}\u{644}\u{627}\u{646}\u{62F}\u{645}\u{627}\u{62C}`,
    de: `Zusammenf\xfchrung`,
    es: `Fusi\xf3n`,
    fa: `\u{627}\u{62F}\u{63A}\u{627}\u{645}`,
    fil: `Pagsamahin`,
    fr: `Fusion`,
    hi: `\u{92E}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Rantre nan`,
    it: `Fusione`,
    ja: `\u{5408}\u{4F75}`,
    ko: `\u{D569}\u{BCD1}`,
    mww: `Kev sib koom ua ke`,
    ps: `\u{6CC}\u{648}\u{681}\u{627}\u{6CC} \u{6A9}\u{648}\u{644}`,
    pt: `Fus\xe3o`,
    'pt-pt': `Fus\xe3o`,
    ru: `\u{421}\u{43B}\u{438}\u{44F}\u{43D}\u{438}\u{435}`,
    sm: `Tuufaatasi`,
    so: `Isku-darka`,
    th: `\u{E1C}\u{E2A}\u{E32}\u{E19}`,
    ur: `\u{627}\u{646}\u{636}\u{645}\u{627}\u{645}`,
    vi: `H\u{1EE3}p nh\u{1EA5}t`,
    'zh-hans': `\u{5408}\u{5E76}`,
    'zh-hant': `\u{5408}\u{4F75}`,
    en: `Merge`
};
const $b11db1b62d4a8f76$export$5603a2ca1ae8c068 = {
    ar: (title)=>`\u{647}\u{644} \u{623}\u{646}\u{62A} \u{645}\u{62A}\u{623}\u{643}\u{62F} \u{623}\u{646}\u{643} \u{62A}\u{631}\u{64A}\u{62F} \u{62F}\u{645}\u{62C} "${title}"\u{61F} \u{633}\u{64A}\u{62A}\u{645} \u{62D}\u{630}\u{641} \u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644} \u{648}\u{633}\u{64A}\u{62A}\u{645} \u{646}\u{642}\u{644} \u{623}\u{646}\u{634}\u{637}\u{62A}\u{647} \u{625}\u{644}\u{649} \u{627}\u{644}\u{633}\u{62C}\u{644} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{647}\u{62F}\u{641}.`,
    de: (title)=>`Bist du sicher, dass du "${title}" fusionieren willst? Dieser Datensatz wird gel\xf6scht und seine Aktivit\xe4ten werden auf den Zieldatensatz verschoben.`,
    es: (title)=>`\xbfEst\xe1s seguro de que quieres fusionar "${title}"? Este registro ser\xe1 eliminado y sus actividades se trasladar\xe1n al registro objetivo.`,
    fa: (title)=>`\u{645}\u{637}\u{645}\u{626}\u{646}\u{6CC} \u{645}\u{6CC} \u{62E}\u{648}\u{627}\u{647}\u{6CC} \xab${title}\xbb \u{631}\u{627} \u{627}\u{62F}\u{63A}\u{627}\u{645} \u{6A9}\u{646}\u{6CC}\u{61F} \u{627}\u{6CC}\u{646} \u{631}\u{6A9}\u{648}\u{631}\u{62F} \u{62D}\u{630}\u{641} \u{62E}\u{648}\u{627}\u{647}\u{62F} \u{634}\u{62F} \u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{622}\u{646} \u{628}\u{647} \u{631}\u{6A9}\u{648}\u{631}\u{62F} \u{647}\u{62F}\u{641} \u{645}\u{646}\u{62A}\u{642}\u{644} \u{62E}\u{648}\u{627}\u{647}\u{62F} \u{634}\u{62F}.`,
    fil: (title)=>`Sigurado ka bang gusto mong i-merge ang "${title}"? Ang rekord na ito ay tatanggalin at ang mga aktibidad nito ay ililipat sa target na talaan.`,
    fr: (title)=>`\xcates-vous s\xfbr de vouloir fusionner \xab ${title} \xbb ? Cet enregistrement sera supprim\xe9 et ses activit\xe9s transf\xe9r\xe9es vers l\u{2019}enregistrement cible.`,
    hi: (title)=>`\u{915}\u{94D}\u{92F}\u{93E} \u{906}\u{92A} \u{935}\u{93E}\u{915}\u{908} "${title} \u{915}\u{94B} \u{92E}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{924}\u{947} \u{939}\u{948}\u{902}? \u{92F}\u{939} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{939}\u{91F}\u{93E} \u{926}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E}\u{90F}\u{917}\u{93E} \u{914}\u{930} \u{907}\u{938}\u{915}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{932}\u{915}\u{94D}\u{937}\u{94D}\u{92F} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{92E}\u{947}\u{902} \u{932}\u{947} \u{91C}\u{93E}\u{92F}\u{93E} \u{91C}\u{93E}\u{90F}\u{917}\u{93E}.`,
    ht: (title)=>`\xc8ske ou s\xe8ten ou vle rantre "${title}"? Dosye sa a pral efase ak aktivite li yo pral deplase nan dosye sib la.`,
    it: (title)=>`Sei sicuro di voler unire "${title}"? Questo record sar\xe0 cancellato e le sue attivit\xe0 trasferite al record target.`,
    ja: (title)=>`\u{300C}${title}\u{300D}\u{3092}\u{5408}\u{4F75}\u{3059}\u{308B}\u{3064}\u{3082}\u{308A}\u{3067}\u{3059}\u{304B}?\u{3053}\u{306E}\u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{306F}\u{524A}\u{9664}\u{3055}\u{308C}\u{3001}\u{305D}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{30BF}\u{30FC}\u{30B2}\u{30C3}\u{30C8}\u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{306B}\u{79FB}\u{52D5}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: (title)=>`"${title}"\u{B97C} \u{D569}\u{CE58}\u{ACE0} \u{C2F6}\u{C740} \u{AC8C} \u{D655}\u{C2E4}\u{D574}? \u{C774} \u{B808}\u{CF54}\u{B4DC}\u{B294} \u{C0AD}\u{C81C}\u{B418}\u{BA70}, \u{ADF8} \u{D65C}\u{B3D9}\u{C740} \u{B300}\u{C0C1} \u{B808}\u{CF54}\u{B4DC}\u{B85C} \u{C774}\u{B3D9}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (title)=>`Koj puas paub tseeb tias koj xav sib koom ua ke "${title}"? Cov ntaub ntawv no yuav raug tshem tawm thiab nws cov kev ua ub no yuav raug tsiv mus rau lub hom phiaj ntaub ntawv.`,
    ps: (title)=>`\u{62A}\u{647} \u{689}\u{627}\u{689}\u{647} \u{6CC}\u{6D0} \u{686}\u{6D0} \u{63A}\u{648}\u{627}\u{693}\u{6D0} "${title}" \u{633}\u{631}\u{647} \u{6CC}\u{648} \u{681}\u{627}\u{6CC} \u{6A9}\u{693}\u{6D0}\u{61F} \u{62F}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{628}\u{647} \u{62D}\u{630}\u{641} \u{634}\u{6CC} \u{627}\u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{628}\u{647} \u{6CC}\u{6D0} \u{647}\u{62F}\u{641} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{62A}\u{647} \u{627}\u{646}\u{62A}\u{642}\u{627}\u{644} \u{634}\u{6CC}.`,
    pt: (title)=>`Voc\xea tem certeza de que quer fundir "${title}"? Esse registro ser\xe1 exclu\xeddo e suas atividades ser\xe3o transferidas para o registro alvo.`,
    'pt-pt': (title)=>`Tens a certeza de que queres fundir "${title}"? Este registo ser\xe1 eliminado e as suas atividades ser\xe3o transferidas para o registo alvo.`,
    ru: (title)=>`\u{422}\u{44B} \u{443}\u{432}\u{435}\u{440}\u{435}\u{43D}, \u{447}\u{442}\u{43E} \u{445}\u{43E}\u{447}\u{435}\u{448}\u{44C} \u{43E}\u{431}\u{44A}\u{435}\u{434}\u{438}\u{43D}\u{438}\u{442}\u{44C} \xab${title}\xbb? \u{42D}\u{442}\u{430} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{431}\u{443}\u{434}\u{435}\u{442} \u{443}\u{434}\u{430}\u{43B}\u{435}\u{43D}\u{430}, \u{430} \u{435}\u{451} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{43D}\u{435}\u{441}\u{435}\u{43D}\u{430} \u{432} \u{446}\u{435}\u{43B}\u{435}\u{432}\u{443}\u{44E} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}.`,
    sm: (title)=>`E te mautinoa e te mana'o e tu'ufa'atasia le "${title}"? O lenei faamaumauga o le a aveesea ma o le a siitia ana gaoioiga i le faamaumauga faamoemoeina.`,
    so: (title)=>`Ma hubtaa inaad rabto inaad isku darto "${title}"? Diiwaankan waa la tirtiri doonaa waxaana hawlihiisa loo wareejin doonaa diiwaanka bartilmaameedka.`,
    th: (title)=>`\u{E04}\u{E38}\u{E13}\u{E41}\u{E19}\u{E48}\u{E43}\u{E08}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E44}\u{E21}\u{E48}\u{E27}\u{E48}\u{E32}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E23}\u{E27}\u{E21} "${title}" \u{E40}\u{E02}\u{E49}\u{E32}\u{E14}\u{E49}\u{E27}\u{E22}\u{E01}\u{E31}\u{E19}? \u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E19}\u{E35}\u{E49}\u{E08}\u{E30}\u{E16}\u{E39}\u{E01}\u{E25}\u{E1A}\u{E41}\u{E25}\u{E30}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E08}\u{E30}\u{E16}\u{E39}\u{E01}\u{E22}\u{E49}\u{E32}\u{E22}\u{E44}\u{E1B}\u{E22}\u{E31}\u{E07}\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E40}\u{E1B}\u{E49}\u{E32}\u{E2B}\u{E21}\u{E32}\u{E22}`,
    ur: (title)=>`\u{6A9}\u{6CC}\u{627} \u{622}\u{67E} \u{648}\u{627}\u{642}\u{639}\u{6CC} "${title}" \u{6A9}\u{648} \u{636}\u{645} \u{6A9}\u{631}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{61F} \u{6CC}\u{6C1} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{62D}\u{630}\u{641} \u{6A9}\u{631} \u{62F}\u{6CC}\u{627} \u{62C}\u{627}\u{626}\u{6D2} \u{6AF}\u{627} \u{627}\u{648}\u{631} \u{627}\u{633} \u{6A9}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{6C1}\u{62F}\u{641} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{67E}\u{631} \u{645}\u{646}\u{62A}\u{642}\u{644} \u{6A9}\u{631} \u{62F}\u{6CC} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA} \u{6AF}\u{6CC}\u{6D4}`,
    vi: (title)=>`B\u{1EA1}n c\xf3 ch\u{1EAF}c ch\u{1EAF}n mu\u{1ED1}n h\u{1EE3}p nh\u{1EA5}t "${title}" kh\xf4ng? B\u{1EA3}n ghi n\xe0y s\u{1EBD} b\u{1ECB} x\xf3a v\xe0 c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng c\u{1EE7}a n\xf3 s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c chuy\u{1EC3}n \u{111}\u{1EBF}n b\u{1EA3}n ghi \u{111}\xedch.`,
    'zh-hans': (title)=>`\u{4F60}\u{786E}\u{5B9A}\u{8981}\u{5408}\u{5E76}\u{201C}${title}\u{5417}\u{FF1F}\u{8BE5}\u{8BB0}\u{5F55}\u{5C06}\u{88AB}\u{5220}\u{9664}\u{FF0C}\u{5176}\u{6D3B}\u{52A8}\u{5C06}\u{88AB}\u{79FB}\u{81F3}\u{76EE}\u{6807}\u{8BB0}\u{5F55}\u{3002}`,
    'zh-hant': (title)=>`\u{4F60}\u{78BA}\u{5B9A}\u{8981}\u{5408}\u{4F75}\u{300C}${title}\u{300D}\u{55CE}\u{FF1F}\u{6B64}\u{7D00}\u{9304}\u{5C07}\u{88AB}\u{522A}\u{9664}\u{FF0C}\u{5176}\u{6D3B}\u{52D5}\u{5C07}\u{79FB}\u{81F3}\u{76EE}\u{6A19}\u{7D00}\u{9304}\u{3002}`,
    en: (title)=>`Are you sure you want to merge "${title}"? This record will be deleted and its activities will be moved to the target record.`
};
const $b11db1b62d4a8f76$export$86d899f5f51717cd = {
    ar: `\u{633}\u{64A}\u{62A}\u{645} \u{62D}\u{630}\u{641} \u{647}\u{630}\u{627} \u{627}\u{644}\u{634}\u{62E}\u{635} \u{648}\u{633}\u{64A}\u{62A}\u{645} \u{646}\u{642}\u{644} \u{646}\u{634}\u{627}\u{637}\u{627}\u{62A}\u{647} \u{625}\u{644}\u{649} \u{634}\u{62E}\u{635} "\u{627}\u{644}\u{627}\u{62D}\u{62A}\u{641}\u{627}\u{638} \u{628}\u{647}".`,
    de: `Diese Person wird gel\xf6scht und ihre Aktivit\xe4ten werden auf die "Behalten"-Person verschoben.`,
    es: `Esta persona ser\xe1 eliminada y sus actividades pasar\xe1n a la persona de "Conservar".`,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{631}\u{62F} \u{62D}\u{630}\u{641} \u{645}\u{6CC} \u{634}\u{648}\u{62F} \u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC}\u{634} \u{628}\u{647} \u{634}\u{62E}\u{635} \xab\u{646}\u{6AF}\u{647} \u{62F}\u{627}\u{631}\xbb \u{645}\u{646}\u{62A}\u{642}\u{644} \u{645}\u{6CC} \u{634}\u{648}\u{62F}.`,
    fil: `Ang taong ito ay tatanggalin at ang kanilang mga aktibidad ay ililipat sa taong "Panatilihin."`,
    fr: `Cette personne sera supprim\xe9e et ses activit\xe9s transf\xe9r\xe9es \xe0 la personne \xab Conserver \xbb.`,
    hi: `\u{907}\u{938} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F} \u{915}\u{94B} \u{939}\u{91F}\u{93E} \u{926}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E}\u{90F}\u{917}\u{93E} \u{914}\u{930} \u{909}\u{928}\u{915}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} "\u{915}\u{940}\u{92A}" \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F} \u{915}\u{947} \u{92A}\u{93E}\u{938} \u{932}\u{947} \u{91C}\u{93E}\u{92F}\u{93E} \u{91C}\u{93E}\u{90F}\u{917}\u{93E}\u{964}`,
    ht: `Moun sa a pral efase ak aktivite yo pral demenaje ale rete nan moun nan"Kenbe".`,
    it: `Questa persona verr\xe0 eliminata e le sue attivit\xe0 saranno trasferite alla persona "Conserva".`,
    ja: `\u{3053}\u{306E}\u{4EBA}\u{306F}\u{524A}\u{9664}\u{3055}\u{308C}\u{3001}\u{305D}\u{306E}\u{6D3B}\u{52D5}\u{306F}\u{300C}\u{30AD}\u{30FC}\u{30D7}\u{300D}\u{62C5}\u{5F53}\u{8005}\u{306B}\u{79FB}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{C0AC}\u{B78C}\u{C740} \u{C0AD}\u{C81C}\u{B418}\u{BA70}, \u{D65C}\u{B3D9}\u{C740} '\u{C720}\u{C9C0}' \u{B2F4}\u{B2F9}\u{C790}\u{C5D0}\u{AC8C} \u{C62E}\u{ACA8}\u{C9D1}\u{B2C8}\u{B2E4}.`,
    mww: `Tus neeg no yuav raug tshem tawm thiab nws cov haujlwm yuav raug tsiv mus rau tus neeg "Khaws cia".`,
    ps: `\u{62F}\u{627} \u{6A9}\u{633} \u{628}\u{647} \u{62D}\u{630}\u{641} \u{634}\u{6CC} \u{627}\u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{628}\u{647} \u{6CC}\u{6D0} "Keep" \u{6A9}\u{633} \u{62A}\u{647} \u{627}\u{646}\u{62A}\u{642}\u{627}\u{644} \u{634}\u{6CC}.`,
    pt: `Essa pessoa ser\xe1 deletada e suas atividades ser\xe3o transferidas para a pessoa "Guardar".`,
    'pt-pt': `Esta pessoa ser\xe1 eliminada e as suas atividades ser\xe3o transferidas para a pessoa "Guardar".`,
    ru: `\u{42D}\u{442}\u{43E}\u{442} \u{447}\u{435}\u{43B}\u{43E}\u{432}\u{435}\u{43A} \u{431}\u{443}\u{434}\u{435}\u{442} \u{443}\u{434}\u{430}\u{43B}\u{451}\u{43D}, \u{430} \u{435}\u{433}\u{43E} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{430} \u{43A} \u{447}\u{435}\u{43B}\u{43E}\u{432}\u{435}\u{43A}\u{443} \xab\u{421}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{44C}\xbb.`,
    sm: `O lenei tagata o le a ave'esea ma o le a siitia atu a latou gaioiga i le tagata "Keep".`,
    so: `Qofkan waa la tirtiri doonaa waxaana hawlihiisa loo wareejin doonaa qofka "Keep".`,
    th: `\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}\u{E19}\u{E35}\u{E49}\u{E08}\u{E30}\u{E16}\u{E39}\u{E01}\u{E25}\u{E1A}\u{E41}\u{E25}\u{E30}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E1E}\u{E27}\u{E01}\u{E40}\u{E02}\u{E32}\u{E08}\u{E30}\u{E16}\u{E39}\u{E01}\u{E22}\u{E49}\u{E32}\u{E22}\u{E44}\u{E1B}\u{E22}\u{E31}\u{E07}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25} "\u{E40}\u{E01}\u{E47}\u{E1A}"`,
    ur: `\u{627}\u{633} \u{634}\u{62E}\u{635} \u{6A9}\u{648} \u{62D}\u{630}\u{641} \u{6A9}\u{631} \u{62F}\u{6CC}\u{627} \u{62C}\u{627}\u{626}\u{6D2} \u{6AF}\u{627} \u{627}\u{648}\u{631} \u{627}\u{633} \u{6A9}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} "Keep" \u{648}\u{627}\u{644}\u{6D2} \u{634}\u{62E}\u{635} \u{6A9}\u{648} \u{645}\u{646}\u{62A}\u{642}\u{644} \u{6A9}\u{631} \u{62F}\u{6CC} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA} \u{6AF}\u{6CC}\u{6D4}`,
    vi: `Ng\u{1B0}\u{1EDD}i n\xe0y s\u{1EBD} b\u{1ECB} x\xf3a v\xe0 ho\u{1EA1}t \u{111}\u{1ED9}ng c\u{1EE7}a h\u{1ECD} s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c chuy\u{1EC3}n sang ng\u{1B0}\u{1EDD}i "Keep".`,
    'zh-hans': `\u{8FD9}\u{4E2A}\u{4EBA}\u{4F1A}\u{88AB}\u{5220}\u{9664}\u{FF0C}\u{4ED6}\u{4EEC}\u{7684}\u{6D3B}\u{52A8}\u{4F1A}\u{8F6C}\u{79FB}\u{5230}\u{201C}\u{4FDD}\u{7559}\u{201D}\u{7684}\u{4EBA}\u{624B}\u{4E2D}\u{3002}`,
    'zh-hant': `\u{6B64}\u{4EBA}\u{5C07}\u{88AB}\u{522A}\u{9664}\u{FF0C}\u{5176}\u{6D3B}\u{52D5}\u{5C07}\u{79FB}\u{81F3}\u{300C}\u{4FDD}\u{7559}\u{300D}\u{8005}\u{3002}`,
    en: `This person will be deleted and their activities will be moved to the "Keep" person.`
};
const $b11db1b62d4a8f76$export$c11b37785f183e45 = {
    ar: `\u{627}\u{646}\u{62F}\u{645}\u{62C}...`,
    de: `Verschmelzen...`,
    es: `Fusionar...`,
    fa: `\u{627}\u{62F}\u{63A}\u{627}\u{645}...`,
    fil: `Pagsamahin ...`,
    fr: `Fusion...`,
    hi: `\u{92E}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902}...`,
    ht: `Rantre ...`,
    it: `Fusione...`,
    ja: `\u{5408}\u{6D41}...`,
    ko: `\u{D569}\u{BCD1}...`,
    mww: `Sib koom ua ke...`,
    ps: `\u{6CC}\u{648}\u{681}\u{627}\u{6CC} \u{634}\u{647}...`,
    pt: `Fus\xe3o...`,
    'pt-pt': `Fus\xe3o...`,
    ru: `\u{421}\u{43B}\u{438}\u{44F}\u{43D}\u{438}\u{435}...`,
    sm: `Tu'ufa'atasia...`,
    so: `Isku biir...`,
    th: `\u{E1C}\u{E2A}\u{E32}\u{E19}...`,
    ur: `\u{645}\u{631}\u{62C}...`,
    vi: `H\u{1EE3}p nh\u{1EA5}t...`,
    'zh-hans': `\u{5408}\u{5E76}......`,
    'zh-hant': `\u{5408}\u{4F75}......`,
    en: `Merge...`
};
const $b11db1b62d4a8f76$export$59ba7fdd912a06df = {
    ar: `\u{633}\u{64A}\u{62D}\u{635}\u{644} \u{647}\u{630}\u{627} \u{627}\u{644}\u{634}\u{62E}\u{635} \u{639}\u{644}\u{649} \u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{645}\u{646} \u{634}\u{62E}\u{635} "\u{627}\u{644}\u{62F}\u{645}\u{62C}".`,
    de: `Diese Person erh\xe4lt die Aktivit\xe4ten von der "Merge"-Person.`,
    es: `Esta persona recibir\xe1 las actividades de la persona de "Fusionar".`,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{631}\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627} \u{631}\u{627} \u{627}\u{632} \u{641}\u{631}\u{62F} \xab\u{627}\u{62F}\u{63A}\u{627}\u{645}\xbb \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{62E}\u{648}\u{627}\u{647}\u{62F} \u{6A9}\u{631}\u{62F}.`,
    fil: `Ang taong ito ay makakatanggap ng mga aktibidad mula sa "Merge" na tao.`,
    fr: `Cette personne recevra les activit\xe9s de la personne \xab Fusion \xbb.`,
    hi: `\u{92F}\u{939} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F} "\u{92E}\u{930}\u{94D}\u{91C}" \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F} \u{938}\u{947} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{930}\u{947}\u{917}\u{93E}\u{964}`,
    ht: `Moun sa a ap resevwa aktivite yo nan men moun nan"Fusione".`,
    it: `Questa persona ricever\xe0 le attivit\xe0 dalla persona "Merge".`,
    ja: `\u{3053}\u{306E}\u{4EBA}\u{306F}\u{300C}\u{30DE}\u{30FC}\u{30B8}\u{300D}\u{62C5}\u{5F53}\u{8005}\u{304B}\u{3089}\u{6D3B}\u{52D5}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{C0AC}\u{B78C}\u{C740} '\u{D569}\u{BCD1}' \u{B2F4}\u{B2F9}\u{C790}\u{B85C}\u{BD80}\u{D130} \u{D65C}\u{B3D9}\u{C744} \u{BC1B}\u{AC8C} \u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Tus neeg no yuav tau txais cov kev ua ub no los ntawm tus neeg "Merge".`,
    ps: `\u{62F}\u{627} \u{6A9}\u{633} \u{628}\u{647} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{62F} "Merge" \u{6A9}\u{633} \u{685}\u{62E}\u{647} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{693}\u{6CC}.`,
    pt: `Essa pessoa receber\xe1 as atividades da pessoa "Fus\xe3o".`,
    'pt-pt': `Esta pessoa receber\xe1 as atividades da pessoa "Fus\xe3o".`,
    ru: `\u{42D}\u{442}\u{43E}\u{442} \u{447}\u{435}\u{43B}\u{43E}\u{432}\u{435}\u{43A} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{43E}\u{442} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{430} \xab\u{421}\u{43B}\u{438}\u{44F}\u{43D}\u{438}\u{44F}\xbb.`,
    sm: `O lenei tagata o le a mauaina gaoioiga mai le tagata "Tuufaatasia".`,
    so: `Qofkan wuxuu ka heli doonaa hawlaha qofka "Merge".`,
    th: `\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}\u{E19}\u{E35}\u{E49}\u{E08}\u{E30}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E08}\u{E32}\u{E01}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25} "\u{E1C}\u{E2A}\u{E32}\u{E19}"`,
    ur: `\u{6CC}\u{6C1} \u{634}\u{62E}\u{635} "\u{645}\u{631}\u{62C}" \u{634}\u{62E}\u{635} \u{633}\u{6D2} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{648}\u{635}\u{648}\u{644} \u{6A9}\u{631}\u{6D2} \u{6AF}\u{627}\u{6D4}`,
    vi: `Ng\u{1B0}\u{1EDD}i n\xe0y s\u{1EBD} nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng t\u{1EEB} ng\u{1B0}\u{1EDD}i "H\u{1EE3}p nh\u{1EA5}t".`,
    'zh-hans': `\u{8BE5}\u{4EBA}\u{5C06}\u{4ECE}\u{201C}\u{5408}\u{5E76}\u{201D}\u{8005}\u{90A3}\u{91CC}\u{83B7}\u{5F97}\u{6D3B}\u{52A8}\u{3002}`,
    'zh-hant': `\u{6B64}\u{4EBA}\u{5C07}\u{5F9E}\u{300C}\u{5408}\u{4F75}\u{300D}\u{8005}\u{90A3}\u{88E1}\u{63A5}\u{6536}\u{6D3B}\u{52D5}\u{3002}`,
    en: `This person will receive the activities from the "Merge" person.`
};
const $b11db1b62d4a8f76$export$98aba71d3bbdcf70 = {
    ar: `\u{633}\u{62C}\u{644}\u{627}\u{62A} \u{62F}\u{645}\u{62C} \u{627}\u{644}\u{646}\u{627}\u{633}`,
    de: `Merge People Records`,
    es: `Registros de la fusi\xf3n de personas`,
    fa: `\u{631}\u{6A9}\u{648}\u{631}\u{62F}\u{647}\u{627}\u{6CC} Merge People`,
    fil: `Pagsamahin ang mga talaan ng mga tao`,
    fr: `Fusion des dossiers de personnes`,
    hi: `\u{932}\u{94B}\u{917}\u{94B}\u{902} \u{915}\u{947} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{92E}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `Rantre dosye moun`,
    it: `Fusione dei record delle persone`,
    ja: `\u{4EBA}\u{3005}\u{306E}\u{8A18}\u{9332}\u{3092}\u{7D71}\u{5408}\u{3059}\u{308B}`,
    ko: `\u{AE30}\u{B85D} \u{D569}\u{BCD1}`,
    mww: `Merge tib neeg cov ntaub ntawv`,
    ps: `\u{62F} \u{62E}\u{644}\u{6A9}\u{648} \u{62F} \u{6CC}\u{648}\u{681}\u{627}\u{6CC} \u{6A9}\u{648}\u{644}\u{648} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689}\u{648}\u{646}\u{647}`,
    pt: `Fus\xe3o de registros de pessoas`,
    'pt-pt': `Fus\xe3o de registos de pessoas`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{438} Merge People`,
    sm: `Tuufaatasi faamaumauga a tagata`,
    so: `Isku-darka diiwaanka dadka`,
    th: `\u{E23}\u{E27}\u{E21}\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}`,
    ur: `\u{645}\u{631}\u{62C} \u{67E}\u{6CC}\u{67E}\u{644} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688}\u{632}`,
    vi: `H\u{1EE3}p nh\u{1EA5}t b\u{1EA3}n ghi m\u{1ECD}i ng\u{1B0}\u{1EDD}i`,
    'zh-hans': `\u{5408}\u{5E76}\u{4EBA}\u{7269}\u{8BB0}\u{5F55}`,
    'zh-hant': `\u{5408}\u{4F75}\u{4EBA}\u{54E1}\u{7D00}\u{9304}`,
    en: `Merge people records`
};
const $b11db1b62d4a8f76$export$e3c857cb76e039ae = {
    ar: `\u{627}\u{644}\u{631}\u{633}\u{627}\u{644}\u{629}`,
    de: `Botschaft`,
    es: `Mensaje`,
    fa: `\u{67E}\u{6CC}\u{627}\u{645}`,
    fil: `Mensahe`,
    fr: `Message`,
    hi: `\u{938}\u{902}\u{926}\u{947}\u{936}`,
    ht: `Mesaj`,
    it: `Messaggio`,
    ja: `\u{30E1}\u{30C3}\u{30BB}\u{30FC}\u{30B8}`,
    ko: `\u{BA54}\u{C2DC}\u{C9C0}`,
    mww: `Lus`,
    ps: `\u{67E}\u{6CC}\u{63A}\u{627}\u{645}`,
    pt: `Mensagem`,
    'pt-pt': `Mensagem`,
    ru: `\u{421}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Savali`,
    so: `Fariin`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}`,
    ur: `\u{67E}\u{6CC}\u{63A}\u{627}\u{645}`,
    vi: `Th\xf4ng \u{111}i\u{1EC7}p`,
    'zh-hans': `\u{4FE1}\u{606F}`,
    'zh-hant': `\u{8A0A}\u{606F}`,
    en: `Message`
};
const $b11db1b62d4a8f76$export$a1f1f7c132479018 = {
    ar: `\u{627}\u{644}\u{642}\u{64A}\u{627}\u{633}`,
    de: `Metrik`,
    es: `M\xe9trica`,
    fa: `\u{645}\u{62A}\u{631}\u{6CC}\u{6A9}`,
    fil: `Sukatan`,
    fr: `M\xe9trique`,
    hi: `\u{92A}\u{930}\u{93F}\u{92E}\u{93E}\u{923}\u{93E}\u{924}\u{94D}\u{200D}\u{92E}\u{915}`,
    ht: `Metrik`,
    it: `Metrica`,
    ja: `\u{30E1}\u{30FC}\u{30C8}\u{30EB}\u{6CD5}`,
    ko: `\u{BBF8}\u{D130}\u{BC95}`,
    mww: `Kev ntsuas`,
    ps: `\u{645}\u{62A}\u{631}\u{6CC}\u{6A9}`,
    pt: `M\xe9trica`,
    'pt-pt': `M\xe9trica`,
    ru: `\u{41C}\u{435}\u{442}\u{440}\u{438}\u{43A}\u{430}`,
    sm: `Metric`,
    so: `Metric`,
    th: `\u{E40}\u{E21}\u{E15}\u{E23}\u{E34}\u{E01}`,
    ur: `\u{645}\u{6CC}\u{679}\u{631}\u{6A9}`,
    vi: `S\u{1ED1} li\u{1EC7}u`,
    'zh-hans': `\u{5EA6}\u{89C4}`,
    'zh-hant': `\u{516C}\u{5236}`,
    en: `Metric`
};
const $b11db1b62d4a8f76$export$d4f90ee0b10e05d4 = {
    ar: `\u{627}\u{644}\u{645}\u{646}\u{637}\u{642}\u{629} \u{627}\u{644}\u{62D}\u{636}\u{631}\u{64A}\u{629}`,
    de: `Metropolregion`,
    es: `\xc1rea metropolitana`,
    fa: `\u{645}\u{646}\u{637}\u{642}\u{647} \u{6A9}\u{644}\u{627}\u{646} \u{634}\u{647}\u{631}\u{6CC}`,
    fil: `Lugar ng Metro`,
    fr: `Zone m\xe9tropolitaine`,
    hi: `\u{92E}\u{947}\u{91F}\u{94D}\u{930}\u{94B} \u{915}\u{94D}\u{937}\u{947}\u{924}\u{94D}\u{930}`,
    ht: `Z\xf2n m\xe9tro`,
    it: `Area metropolitana`,
    ja: `\u{90FD}\u{5E02}\u{570F}`,
    ko: `\u{B300}\u{B3C4}\u{C2DC}\u{AD8C}`,
    mww: `Metro cheeb tsam`,
    ps: `\u{645}\u{6CC}\u{67C}\u{631}\u{648} \u{633}\u{6CC}\u{645}\u{647}`,
    pt: `\xc1rea metropolitana`,
    'pt-pt': `\xc1rea metropolitana`,
    ru: `\u{421}\u{442}\u{43E}\u{43B}\u{438}\u{447}\u{43D}\u{44B}\u{439} \u{440}\u{430}\u{439}\u{43E}\u{43D}`,
    sm: `Eria o le metro`,
    so: `Aagga metro-ga`,
    th: `\u{E40}\u{E02}\u{E15}\u{E23}\u{E16}\u{E44}\u{E1F}\u{E43}\u{E15}\u{E49}\u{E14}\u{E34}\u{E19}`,
    ur: `\u{645}\u{6CC}\u{679}\u{631}\u{648} \u{639}\u{644}\u{627}\u{642}\u{6C1}`,
    vi: `Khu v\u{1EF1}c t\xe0u \u{111}i\u{1EC7}n ng\u{1EA7}m`,
    'zh-hans': `\u{5927}\u{90FD}\u{4F1A}\u{533A}`,
    'zh-hant': `\u{90FD}\u{6703}\u{5340}`,
    en: `Metro area`
};
const $b11db1b62d4a8f76$export$4dc1171ed58e1ff2 = {
    ar: `\u{1F512} \u{633}\u{64A}\u{643}\u{648}\u{646} \u{645}\u{637}\u{644}\u{648}\u{628}\u{627} \u{627}\u{644}\u{62D}\u{635}\u{648}\u{644} \u{639}\u{644}\u{649} \u{627}\u{644}\u{645}\u{627}\u{62C}\u{633}\u{62A}\u{64A}\u{631} \u{641}\u{64A} 13/11.`,
    de: `\u{1F512} Ein MFA ist am 13.11. erforderlich.`,
    es: `\u{1F512} El MFA ser\xe1 obligatorio el 13/11.`,
    fa: `\u{1F512} MFA \u{62F}\u{631} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6F1}\u{6F3}/\u{6F1}\u{6F1} \u{627}\u{644}\u{632}\u{627}\u{645}\u{6CC} \u{62E}\u{648}\u{627}\u{647}\u{62F} \u{628}\u{648}\u{62F}.`,
    fil: `\u{1F512} Kinakailangan ang MFA sa 11/13.`,
    fr: `\u{1F512} Le MFA sera obligatoire le 13/11.`,
    hi: `\u{1F512} 11/13 \u{915}\u{94B} \u{90F}\u{92E}\u{90F}\u{92B}\u{90F} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{94B}\u{917}\u{940}\u{964}`,
    ht: `\u{1F512} MFA yo pral obligatwa sou 11/13`,
    it: `\u{1F512} L'MFA sar\xe0 richiesto il 13/11.`,
    ja: `\u{1F512} MFA\u{306F}11\u{6708}13\u{65E5}\u{306B}\u{5FC5}\u{9808}\u{3068}\u{306A}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{1F512} MFA\u{B294} 11\u{C6D4} 13\u{C77C}\u{C5D0} \u{D544}\u{C218}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `\u{1F512} MFA yuav tsum tau nyob rau hnub tim 11/13.`,
    ps: `\u{1F512} MFA \u{628}\u{647} \u{62F} 11/13 \u{646}\u{6D0}\u{67C}\u{647} \u{627}\u{693}\u{6CC}\u{646} \u{648}\u{6CC}.`,
    pt: `\u{1F512} O MFA ser\xe1 exigido em 13/11.`,
    'pt-pt': `\u{1F512} O MFA ser\xe1 obrigat\xf3rio a 13/11.`,
    ru: `\u{1F512} MFA \u{431}\u{443}\u{434}\u{435}\u{442} \u{43E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{43C} 13.11.`,
    sm: `\u{1F512} MFA o le a mana'omia i le 11/13.`,
    so: `\u{1F512} MFA waxaa loo baahan doonaa 11/13.`,
    th: `\u{1F512} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35} MFA \u{E43}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48} 13/11`,
    ur: `\u{1F512} MFA 13/11 \u{6A9}\u{648} \u{644}\u{627}\u{632}\u{645}\u{6CC} \u{6C1}\u{648}\u{6AF}\u{627}\u{6D4}`,
    vi: `\u{1F512} MFA s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c y\xeau c\u{1EA7}u v\xe0o ng\xe0y 13/11.`,
    'zh-hans': `\u{1F512} MFA\u{5C06}\u{4E8E}11\u{6708}13\u{65E5}\u{5B8C}\u{6210}\u{3002}`,
    'zh-hant': `\u{1F512} 11\u{6708}13\u{65E5}\u{5C07}\u{8981}\u{6C42}\u{5B8C}\u{6210}MFA\u{3002}`,
    en: `\u{1F512} MFA will be required on 11/13.`
};
const $b11db1b62d4a8f76$export$6b2e2f87d210949b = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{645} \u{627}\u{644}\u{623}\u{648}\u{633}\u{637}`,
    de: `Zweiter Vorname`,
    es: `Segundo nombre`,
    fa: `\u{646}\u{627}\u{645} \u{645}\u{6CC}\u{627}\u{646}\u{6CC}`,
    fil: `Gitnang pangalan`,
    fr: `Deuxi\xe8me pr\xe9nom`,
    hi: `\u{92E}\u{927}\u{94D}\u{92F} \u{928}\u{93E}\u{92E}`,
    ht: `Non presegond\xe8`,
    it: `Secondo nome`,
    ja: `\u{30DF}\u{30C9}\u{30EB}\u{30CD}\u{30FC}\u{30E0}`,
    ko: `\u{C911}\u{AC04} \u{C774}\u{B984}`,
    mww: `Lub npe nruab nrab`,
    ps: `\u{645}\u{646}\u{681}\u{646}\u{6CC} \u{646}\u{648}\u{645}`,
    pt: `Nome do meio`,
    'pt-pt': `Nome do meio`,
    ru: `\u{412}\u{442}\u{43E}\u{440}\u{43E}\u{435} \u{438}\u{43C}\u{44F}`,
    sm: `Igoa ogatotonu`,
    so: `Magaca dhexe`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E01}\u{E25}\u{E32}\u{E07}`,
    ur: `\u{62F}\u{631}\u{645}\u{6CC}\u{627}\u{646}\u{6CC} \u{646}\u{627}\u{645}`,
    vi: `T\xean \u{111}\u{1EC7}m`,
    'zh-hans': `\u{4E2D}\u{95F4}\u{540D}`,
    'zh-hant': `\u{4E2D}\u{9593}\u{540D}`,
    en: `Middle name`
};
const $b11db1b62d4a8f76$export$43611afc6ffa7128 = {
    ar: (distance)=>`${distance} \u{623}\u{645}\u{64A}\u{627}\u{644}`,
    de: (distance)=>`${distance} Meilen entfernt`,
    es: (distance)=>`${distance} millas de distancia`,
    fa: (distance)=>`${distance} \u{645}\u{627}\u{6CC}\u{644} \u{62F}\u{648}\u{631}\u{62A}\u{631}`,
    fil: (distance)=>`${distance} km ang layo`,
    fr: (distance)=>`${distance} miles de l\xe0`,
    hi: (distance)=>`${distance} \u{92E}\u{940}\u{932} \u{926}\u{942}\u{930}`,
    ht: (distance)=>`${distance} kilom\xe8t lwen`,
    it: (distance)=>`${distance} miglia di distanza`,
    ja: (distance)=>`${distance} \u{30DE}\u{30A4}\u{30EB}\u{96E2}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}`,
    ko: (distance)=>`${distance} \u{B9C8}\u{C77C} \u{B5A8}\u{C5B4}\u{C838} \u{C788}\u{C5B4}`,
    mww: (distance)=>`${distance} mais deb`,
    ps: (distance)=>`${distance} \u{645}\u{6CC}\u{644} \u{644}\u{631}\u{6D0}`,
    pt: (distance)=>`${distance} milhas de dist\xe2ncia`,
    'pt-pt': (distance)=>`${distance} milhas de dist\xe2ncia`,
    ru: (distance)=>`${distance} \u{43C}\u{438}\u{43B}\u{44C} \u{43E}\u{442}\u{441}\u{44E}\u{434}\u{430}`,
    sm: (distance)=>`${distance} maila le mamao`,
    so: (distance)=>`${distance} mayl u jirta`,
    th: (distance)=>`\u{E2B}\u{E48}\u{E32}\u{E07}\u{E2D}\u{E2D}\u{E01}\u{E44}\u{E1B} ${distance} \u{E01}\u{E21}.`,
    ur: (distance)=>`${distance} \u{645}\u{6CC}\u{644} \u{62F}\u{648}\u{631}`,
    vi: (distance)=>`C\xe1ch ${distance} km`,
    'zh-hans': (distance)=>`${distance} \u{82F1}\u{91CC}\u{5916}`,
    'zh-hant': (distance)=>`\u{8DDD}\u{96E2}${distance}\u{82F1}\u{91CC}`,
    en: (distance)=>`${distance} miles away`
};
const $b11db1b62d4a8f76$export$df24ac9db9ed80e4 = {
    ar: (filename)=>`\u{627}\u{633}\u{645} \u{645}\u{644}\u{641} \u{63A}\u{64A}\u{631} \u{635}\u{62D}\u{64A}\u{62D}: "${filename}". \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62A}\u{636}\u{645}\u{646} \u{627}\u{633}\u{645} \u{627}\u{644}\u{645}\u{644}\u{641} \u{627}\u{645}\u{62A}\u{62F}\u{627}\u{62F}\u{627}.`,
    de: (filename)=>`Ung\xfcltiger Dateiname: "${filename}". Der Dateiname muss eine Erweiterung enthalten.`,
    es: (filename)=>`Nombre de archivo inv\xe1lido: "${filename}". El nombre del archivo debe incluir una extensi\xf3n.`,
    fa: (filename)=>`\u{646}\u{627}\u{645} \u{641}\u{627}\u{6CC}\u{644} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \xab${filename}\xbb. \u{646}\u{627}\u{645} \u{641}\u{627}\u{6CC}\u{644} \u{628}\u{627}\u{6CC}\u{62F} \u{634}\u{627}\u{645}\u{644} \u{67E}\u{633}\u{648}\u{646}\u{62F} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (filename)=>`Hindi wastong pangalan ng file: "${filename}". Ang pangalan ng file ay dapat magsama ng isang extension.`,
    fr: (filename)=>`Nom de fichier invalide : \xab ${filename} \xbb. Le nom du fichier doit inclure une extension.`,
    hi: (filename)=>`\u{905}\u{92E}\u{93E}\u{928}\u{94D}\u{92F} \u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{928}\u{93E}\u{92E}: "${filename}"\u{964} \u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{928}\u{93E}\u{92E} \u{92E}\u{947}\u{902} \u{90F}\u{915} \u{90F}\u{915}\u{94D}\u{938}\u{91F}\u{947}\u{902}\u{936}\u{928} \u{936}\u{93E}\u{92E}\u{93F}\u{932} \u{939}\u{94B}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}\u{964}`,
    ht: (filename)=>`Non dosye ki pa valid: "${filename}". Non dosye dwe gen ladan yon ekstansyon.`,
    it: (filename)=>`Nome file non valido: "${filename}". Il nome del file deve includere un'estensione.`,
    ja: (filename)=>`\u{7121}\u{52B9}\u{306A}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{540D}:\u{300C}${filename}\u{300D}\u{3002}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{540D}\u{306B}\u{306F}\u{62E1}\u{5F35}\u{5B50}\u{3092}\u{542B}\u{3081}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: (filename)=>`\u{C720}\u{D6A8}\u{D558}\u{C9C0} \u{C54A}\u{C740} \u{D30C}\u{C77C}\u{BA85}: "${filename}". \u{D30C}\u{C77C} \u{C774}\u{B984}\u{C5D0}\u{B294} \u{D655}\u{C7A5}\u{C790}\u{AC00} \u{BC18}\u{B4DC}\u{C2DC} \u{D3EC}\u{D568}\u{B418}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (filename)=>`Cov ntaub ntawv tsis raug: "${filename}". Filename yuav tsum muaj ib qho txuas ntxiv.`,
    ps: (filename)=>`\u{646}\u{627}\u{633}\u{645}\u{647} \u{641}\u{627}\u{6CC}\u{644} \u{646}\u{648}\u{645}: "${filename}". \u{62F} \u{641}\u{627}\u{6CC}\u{644} \u{646}\u{648}\u{645} \u{628}\u{627}\u{6CC}\u{62F} \u{67E}\u{633}\u{648}\u{646}\u{62F} \u{648}\u{644}\u{631}\u{6CC}.`,
    pt: (filename)=>`Nome de arquivo inv\xe1lido: "${filename}". O nome do arquivo deve incluir uma extens\xe3o.`,
    'pt-pt': (filename)=>`Nome de ficheiro inv\xe1lido: "${filename}". O nome do ficheiro deve incluir uma extens\xe3o.`,
    ru: (filename)=>`\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{43E}\u{435} \u{438}\u{43C}\u{44F} \u{444}\u{430}\u{439}\u{43B}\u{430}: "${filename}". \u{418}\u{43C}\u{44F} \u{444}\u{430}\u{439}\u{43B}\u{430} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{435}.`,
    sm: (filename)=>`Igoa faila e le aoga: "${filename}". O le igoa o le faila e tatau ona aofia ai se faaopoopoga.`,
    so: (filename)=>`Magac fayl aan sax ahayn: "${filename}". Magaca faylka waa inuu ku jiro kordhin.`,
    th: (filename)=>`\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: "${filename}" \u{E0A}\u{E37}\u{E48}\u{E2D}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E19}\u{E32}\u{E21}\u{E2A}\u{E01}\u{E38}\u{E25}`,
    ur: (filename)=>`\u{63A}\u{644}\u{637} \u{641}\u{627}\u{626}\u{644} \u{646}\u{627}\u{645}: "${filename}"\u{6D4} \u{641}\u{627}\u{626}\u{644} \u{646}\u{6CC}\u{645} \u{645}\u{6CC}\u{6BA} \u{627}\u{6CC}\u{6A9} \u{62A}\u{648}\u{633}\u{6CC}\u{639} \u{634}\u{627}\u{645}\u{644} \u{6C1}\u{648}\u{646}\u{6CC} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}\u{6D4}`,
    vi: (filename)=>`T\xean t\u{1EC7}p kh\xf4ng h\u{1EE3}p l\u{1EC7}: "${filename}". T\xean t\u{1EC7}p ph\u{1EA3}i bao g\u{1ED3}m ph\u{1EA7}n m\u{1EDF} r\u{1ED9}ng.`,
    'zh-hans': (filename)=>`\u{6587}\u{4EF6}\u{540D}\u{65E0}\u{6548}\u{FF1A}\u{201C}${filename}\u{201D}\u{3002}\u{6587}\u{4EF6}\u{540D}\u{5FC5}\u{987B}\u{5305}\u{542B}\u{6269}\u{5C55}\u{540D}\u{3002}`,
    'zh-hant': (filename)=>`\u{6A94}\u{6848}\u{540D}\u{7A31}\u{7121}\u{6548}\u{FF1A}\u{300C}${filename}\u{300D}\u{3002}\u{6A94}\u{540D}\u{5FC5}\u{9808}\u{5305}\u{542B}\u{526F}\u{6A94}\u{540D}\u{3002}`,
    en: (filename)=>`Invalid filename: "${filename}". Filename must include an extension.`
};
const $b11db1b62d4a8f76$export$bb1915d7c58e991 = {
    ar: `\u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}`,
    de: `Mehr`,
    es: `M\xe1s`,
    fa: `\u{628}\u{6CC}\u{634}\u{62A}\u{631}`,
    fil: `Higit pa`,
    fr: `Plus`,
    hi: `\u{905}\u{927}\u{93F}\u{915}`,
    ht: `Plis`,
    it: `Altro`,
    ja: `\u{7D9A}\u{304D}`,
    ko: `\u{B354} \u{BCF4}\u{AE30}`,
    mww: `Ntau`,
    ps: `\u{646}\u{648}\u{631}`,
    pt: `Mais`,
    'pt-pt': `Mais`,
    ru: `\u{41F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{435}\u{435}`,
    sm: `Sili atu`,
    so: `Wax badan`,
    th: `\u{E21}\u{E32}\u{E01}\u{E01}\u{E27}\u{E48}\u{E32}`,
    ur: `\u{645}\u{632}\u{6CC}\u{62F}`,
    vi: `Xem th\xeam`,
    'zh-hans': `\u{66F4}\u{591A}`,
    'zh-hant': `\u{66F4}\u{591A}`,
    en: `More`
};
const $b11db1b62d4a8f76$export$4b88cb26e2f74b1c = {
    ar: (org)=>$b11db1b62d4a8f76$var$html`<span>المزيد من برامج ${org}</span>`,
    de: (org)=>$b11db1b62d4a8f76$var$html`<span>Weitere ${org}</span>`,
    es: (org)=>$b11db1b62d4a8f76$var$html`<span>Más programas ${org}</span>`,
    fa: (org)=>$b11db1b62d4a8f76$var$html`<span>برنامه های ${org}</span>`,
    fil: (org)=>$b11db1b62d4a8f76$var$html`<span>Higit pang mga programa ${org}</span>`,
    fr: (org)=>$b11db1b62d4a8f76$var$html`<span>Plus de programmes ${org}</span>`,
    hi: (org)=>$b11db1b62d4a8f76$var$html`<span>अधिक ${org} कार्यक्रम</span>`,
    ht: (org)=>$b11db1b62d4a8f76$var$html`<span>Plis ${org}</span>`,
    it: (org)=>$b11db1b62d4a8f76$var$html`<span>Altri programmi ${org}</span>`,
    ja: (org)=>$b11db1b62d4a8f76$var$html`<span>さらに多くの ${org} プログラム</span>`,
    ko: (org)=>$b11db1b62d4a8f76$var$html`<span>더 많은 ${org} 프로그램</span>`,
    mww: (org)=>$b11db1b62d4a8f76$var$html`<span>Ntau ${org} cov kev pab cuam</span>`,
    ps: (org)=>$b11db1b62d4a8f76$var$html`<span>نور ${org} پروګرامونه</span>`,
    pt: (org)=>$b11db1b62d4a8f76$var$html`<span>Mais programas ${org}</span>`,
    'pt-pt': (org)=>$b11db1b62d4a8f76$var$html`<span>Mais programas ${org}</span>`,
    ru: (org)=>$b11db1b62d4a8f76$var$html`<span>Больше программ ${org}</span>`,
    sm: (org)=>$b11db1b62d4a8f76$var$html`<span>Isi polokalame ${org}</span>`,
    so: (org)=>$b11db1b62d4a8f76$var$html`<span>Barnaamijyo ${org} ah</span>`,
    th: (org)=>$b11db1b62d4a8f76$var$html`<span>โปรแกรม ${org} เพิ่มเติม</span>`,
    ur: (org)=>$b11db1b62d4a8f76$var$html`<span>${org} پروگرامز</span>`,
    vi: (org)=>$b11db1b62d4a8f76$var$html`<span>Các chương trình ${org} khác</span>`,
    'zh-hans': (org)=>$b11db1b62d4a8f76$var$html`<span>更多 ${org} 项目</span>`,
    'zh-hant': (org)=>$b11db1b62d4a8f76$var$html`<span>更多 ${org} 計畫</span>`,
    en: (org)=>$b11db1b62d4a8f76$var$html`<span>More ${org} programs</span>`
};
const $b11db1b62d4a8f76$export$6b147bba08746303 = {
    ar: `\u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F} \u{645}\u{646} \u{627}\u{644}\u{642}\u{648}\u{627}\u{644}\u{628}`,
    de: `Weitere Vorlagen`,
    es: `M\xe1s plantillas`,
    fa: `\u{642}\u{627}\u{644}\u{628} \u{647}\u{627}\u{6CC} \u{628}\u{6CC}\u{634}\u{62A}\u{631}`,
    fil: `Higit pang mga template`,
    fr: `Plus de mod\xe8les`,
    hi: `\u{905}\u{927}\u{93F}\u{915} \u{91F}\u{947}\u{92E}\u{94D}\u{92A}\u{932}\u{947}\u{91F}`,
    ht: `Plis mod\xe8l`,
    it: `Altri modelli`,
    ja: `\u{3055}\u{3089}\u{306B}\u{30C6}\u{30F3}\u{30D7}\u{30EC}\u{30FC}\u{30C8}`,
    ko: `\u{B354} \u{B9CE}\u{C740} \u{D15C}\u{D50C}\u{B9BF}`,
    mww: `Ntau templates`,
    ps: `\u{646}\u{648}\u{631} \u{642}\u{627}\u{644}\u{628}\u{648}\u{646}\u{647}`,
    pt: `Mais modelos`,
    'pt-pt': `Mais modelos`,
    ru: `\u{411}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{43E}\u{432}`,
    sm: `Nisi fa'ata'ita'iga`,
    so: `Templates dheeraad ah`,
    th: `\u{E40}\u{E17}\u{E21}\u{E40}\u{E1E}\u{E25}\u{E15}\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E40}\u{E15}\u{E34}\u{E21}`,
    ur: `\u{645}\u{632}\u{6CC}\u{62F} \u{679}\u{6CC}\u{645}\u{67E}\u{644}\u{6CC}\u{679}\u{633}`,
    vi: `C\xe1c m\u{1EAB}u kh\xe1c`,
    'zh-hans': `\u{66F4}\u{591A}\u{6A21}\u{677F}`,
    'zh-hant': `\u{66F4}\u{591A}\u{7BC4}\u{672C}`,
    en: `More templates`
};
const $b11db1b62d4a8f76$export$61168040ae64a77d = {
    ar: `\u{627}\u{644}\u{645}\u{635}\u{627}\u{62F}\u{642}\u{629} \u{645}\u{62A}\u{639}\u{62F}\u{62F}\u{629} \u{627}\u{644}\u{639}\u{648}\u{627}\u{645}\u{644} (MFA)`,
    de: `Multi-Faktor-Authentifizierung (MFA)`,
    es: `Autenticaci\xf3n multifactor (MFA)`,
    fa: `\u{627}\u{62D}\u{631}\u{627}\u{632} \u{647}\u{648}\u{6CC}\u{62A} \u{686}\u{646}\u{62F}\u{639}\u{627}\u{645}\u{644}\u{6CC} (MFA)`,
    fil: `Multi-factor na pagpapatunay (MFA)`,
    fr: `Authentification multifacteur (MFA)`,
    hi: `\u{92C}\u{939}\u{941}-\u{915}\u{93E}\u{930}\u{915} \u{92A}\u{94D}\u{930}\u{92E}\u{93E}\u{923}\u{940}\u{915}\u{930}\u{923} (MFA)`,
    ht: `Multi-fakt\xe8 otantifikasyon (MFA)`,
    it: `Autenticazione multifattore (MFA)`,
    ja: `\u{591A}\u{8981}\u{7D20}\u{8A8D}\u{8A3C}(MFA)`,
    ko: `\u{B2E4}\u{C911}\u{C778}\u{C99D}(MFA)`,
    mww: `Multi-factor authentication (MFA)`,
    ps: `\u{685}\u{648}-\u{641}\u{6A9}\u{62A}\u{648}\u{631}\u{6CC} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} (MFA)`,
    pt: `Autentica\xe7\xe3o multifator (MFA)`,
    'pt-pt': `Autentica\xe7\xe3o multifator (MFA)`,
    ru: `\u{41C}\u{43D}\u{43E}\u{433}\u{43E}\u{444}\u{430}\u{43A}\u{442}\u{43E}\u{440}\u{43D}\u{430}\u{44F} \u{430}\u{443}\u{442}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{44F} (MFA)`,
    sm: `Fa'amaoniga Fa'apitoa (MFA)`,
    so: `Multi-factor authentication (MFA)`,
    th: `\u{E01}\u{E32}\u{E23}\u{E23}\u{E31}\u{E1A}\u{E23}\u{E2D}\u{E07}\u{E04}\u{E27}\u{E32}\u{E21}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E41}\u{E1A}\u{E1A}\u{E2B}\u{E25}\u{E32}\u{E22}\u{E1B}\u{E31}\u{E08}\u{E08}\u{E31}\u{E22} (MFA)`,
    ur: `\u{645}\u{644}\u{679}\u{6CC} \u{641}\u{6CC}\u{6A9}\u{679}\u{631} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} (MFA)`,
    vi: `X\xe1c th\u{1EF1}c \u{111}a y\u{1EBF}u t\u{1ED1} (MFA)`,
    'zh-hans': `\u{591A}\u{56E0}\u{7D20}\u{8BA4}\u{8BC1}\u{FF08}MFA\u{FF09}`,
    'zh-hant': `\u{591A}\u{91CD}\u{9A57}\u{8B49}\u{FF08}MFA\u{FF09}`,
    en: `Multi-factor authentication (MFA)`
};
const $b11db1b62d4a8f76$export$dd7aa9dbdc015ba1 = {
    ar: (count)=>`${count} \u{645}\u{644}\u{62D}\u{642}\u{627}\u{62A}`,
    de: (count)=>`${count} Anh\xe4nge`,
    es: (count)=>`${count} accesorios`,
    fa: (count)=>`${count} \u{636}\u{645}\u{6CC}\u{645}\u{647}`,
    fil: (count)=>`${count} Mga Attachment`,
    fr: (count)=>`${count} pi\xe8ces jointes`,
    hi: (count)=>`${count} \u{938}\u{902}\u{932}\u{917}\u{94D}\u{928}\u{915}`,
    ht: (count)=>`${count} atachman`,
    it: (count)=>`${count} allegati`,
    ja: (count)=>`${count} \u{3064}\u{306E}\u{4ED8}\u{5C5E}\u{54C1}`,
    ko: (count)=>`${count} \u{BD80}\u{C18D}\u{D488}`,
    mww: (count)=>`${count} Attachments`,
    ps: (count)=>`${count} \u{636}\u{645}\u{6CC}\u{645}\u{6D0}`,
    pt: (count)=>`${count} anexos`,
    'pt-pt': (count)=>`${count} anexos`,
    ru: (count)=>`${count} \u{412}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{439}`,
    sm: (count)=>`${count} fa'apipi'i`,
    so: (count)=>`${count} Lifaaq`,
    th: (count)=>`${count} \u{E44}\u{E1F}\u{E25}\u{E4C}\u{E41}\u{E19}\u{E1A}`,
    ur: (count)=>`${count} \u{627}\u{679}\u{6CC}\u{686}\u{645}\u{646}\u{679}\u{633}`,
    vi: (count)=>`${count} t\u{1EC7}p \u{111}\xednh k\xe8m`,
    'zh-hans': (count)=>`${count} \u{9644}\u{4EF6}`,
    'zh-hant': (count)=>`${count} \u{9644}\u{4EF6}`,
    en: (count)=>`${count} attachments`
};
const $b11db1b62d4a8f76$export$350b3a9617100f99 = {
    ar: (count)=>`${count} \u{639}\u{64A}\u{627}\u{62F}\u{627}\u{62A}`,
    de: (count)=>`${count} Kliniken`,
    es: (count)=>`${count} cl\xednicas`,
    fa: (count)=>`${count} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9}`,
    fil: (count)=>`${count} Mga klinika`,
    fr: (count)=>`${count} cliniques`,
    hi: (count)=>`${count} \u{915}\u{94D}\u{932}\u{940}\u{928}\u{93F}\u{915}`,
    ht: (count)=>`${count} klinik`,
    it: (count)=>`${count} cliniche`,
    ja: (count)=>`${count} \u{3064}\u{306E}\u{30AF}\u{30EA}\u{30CB}\u{30C3}\u{30AF}`,
    ko: (count)=>`${count} \u{AC1C}\u{C758} \u{D074}\u{B9AC}\u{B2C9}`,
    mww: (count)=>`${count} lub tsev kho mob`,
    ps: (count)=>`${count} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9}\u{648}\u{646}\u{647}`,
    pt: (count)=>`${count} cl\xednicas`,
    'pt-pt': (count)=>`${count} cl\xednicas`,
    ru: (count)=>`${count} \u{43A}\u{43B}\u{438}\u{43D}\u{438}\u{43A}`,
    sm: (count)=>`${count} falema'i`,
    so: (count)=>`${count} Kliniko`,
    th: (count)=>`${count} \u{E04}\u{E25}\u{E34}\u{E19}\u{E34}\u{E01}`,
    ur: (count)=>`${count} \u{6A9}\u{644}\u{6CC}\u{646}\u{6A9}\u{633}`,
    vi: (count)=>`${count} ph\xf2ng kh\xe1m`,
    'zh-hans': (count)=>`${count} \u{4E2A}\u{8BCA}\u{6240}`,
    'zh-hant': (count)=>`${count} \u{9593}\u{8A3A}\u{6240}`,
    en: (count)=>`${count} clinics`
};
const $b11db1b62d4a8f76$export$ed772f351541e086 = {
    ar: (count)=>`${count} \u{645}\u{633}\u{627}\u{647}\u{645}\u{64A}\u{646}`,
    de: (count)=>`${count} Mitwirkende`,
    es: (count)=>`${count} colaboradores`,
    fa: (count)=>`${count} \u{645}\u{634}\u{627}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: (count)=>`${count} mga nag-ambag`,
    fr: (count)=>`${count} contributeurs`,
    hi: (count)=>`${count} \u{92F}\u{94B}\u{917}\u{926}\u{93E}\u{928}\u{915}\u{930}\u{94D}\u{924}\u{93E}`,
    ht: (count)=>`${count} kontribit\xe8 yo`,
    it: (count)=>`${count} collaboratori`,
    ja: (count)=>`${count} \u{4EBA}\u{306E}\u{5BC4}\u{7A3F}\u{8005}`,
    ko: (count)=>`${count} \u{BA85}\u{C758} \u{AE30}\u{C5EC}\u{C790}`,
    mww: (count)=>`${count} cov neeg koom tes`,
    ps: (count)=>`${count} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{627}\u{646}`,
    pt: (count)=>`${count} colaboradores`,
    'pt-pt': (count)=>`${count} colaboradores`,
    ru: (count)=>`${count} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{43E}\u{432}`,
    sm: (count)=>`${count} tagata fai saofaga`,
    so: (count)=>`${count} qoraayaal`,
    th: (count)=>`\u{E1C}\u{E39}\u{E49}\u{E23}\u{E48}\u{E27}\u{E21}\u{E43}\u{E2B}\u{E49}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25} ${count} \u{E04}\u{E19}`,
    ur: (count)=>`${count} \u{645}\u{639}\u{627}\u{648}\u{646}\u{6CC}\u{646}`,
    vi: (count)=>`${count} ng\u{1B0}\u{1EDD}i \u{111}\xf3ng g\xf3p`,
    'zh-hans': (count)=>`${count} \u{4F4D}\u{8D21}\u{732E}\u{8005}`,
    'zh-hant': (count)=>`${count} \u{4F4D}\u{8CA2}\u{737B}\u{8005}`,
    en: (count)=>`${count} contributors`
};
const $b11db1b62d4a8f76$export$a7ad54c5a26c2c49 = {
    ar: (count)=>`${count} \u{625}\u{635}\u{62F}\u{627}\u{631}\u{627}\u{62A} \u{633}\u{627}\u{628}\u{642}\u{629}`,
    de: (count)=>`${count} Fr\xfchere Versionen`,
    es: (count)=>`${count} versiones anteriores`,
    fa: (count)=>`${count} \u{646}\u{633}\u{62E}\u{647} \u{647}\u{627}\u{6CC} \u{642}\u{628}\u{644}\u{6CC}`,
    fil: (count)=>`${count} naunang mga bersyon`,
    fr: (count)=>`${count} versions ant\xe9rieures`,
    hi: (count)=>`${count} \u{92A}\u{941}\u{930}\u{93E}\u{928}\u{947} \u{938}\u{902}\u{938}\u{94D}\u{915}\u{930}\u{923}`,
    ht: (count)=>`${count} v\xe8syon anvan yo`,
    it: (count)=>`${count} versioni precedenti`,
    ja: (count)=>`${count} \u{3064}\u{306E}\u{521D}\u{671F}\u{30D0}\u{30FC}\u{30B8}\u{30E7}\u{30F3}`,
    ko: (count)=>`${count} \u{AC1C}\u{C758} \u{C774}\u{C804} \u{BC84}\u{C804}`,
    mww: (count)=>`${count} ua ntej versions`,
    ps: (count)=>`${count} \u{67E}\u{62E}\u{648}\u{627}\u{646}\u{6CD} \u{646}\u{633}\u{62E}\u{6D0}`,
    pt: (count)=>`${count} vers\xf5es anteriores`,
    'pt-pt': (count)=>`${count} vers\xf5es anteriores`,
    ru: (count)=>`${count} \u{440}\u{430}\u{43D}\u{43D}\u{438}\u{445} \u{432}\u{435}\u{440}\u{441}\u{438}\u{439}`,
    sm: (count)=>`${count} lomiga muamua`,
    so: (count)=>`${count} nooc oo hore`,
    th: (count)=>`${count} \u{E40}\u{E27}\u{E2D}\u{E23}\u{E4C}\u{E0A}\u{E31}\u{E19}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: (count)=>`${count} \u{67E}\u{631}\u{627}\u{646}\u{6D2} \u{648}\u{631}\u{698}\u{646}\u{632}`,
    vi: (count)=>`${count} Phi\xean b\u{1EA3}n tr\u{1B0}\u{1EDB}c \u{111}\xf3`,
    'zh-hans': (count)=>`${count} \u{4E2A}\u{65E9}\u{671F}\u{7248}\u{672C}`,
    'zh-hant': (count)=>`${count} \u{500B}\u{65E9}\u{671F}\u{7248}\u{672C}`,
    en: (count)=>`${count} earlier versions`
};
const $b11db1b62d4a8f76$export$f0eebbc9975b97cb = {
    ar: (count)=>`${count} \u{623}\u{62D}\u{62F}\u{627}\u{62B} \u{62A}\u{645} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{64A}\u{647}\u{627}`,
    de: (count)=>`${count} gefundene Ereignisse`,
    es: (count)=>`${count} eventos encontrados`,
    fa: (count)=>`${count} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{6CC}\u{627}\u{641}\u{62A} \u{634}\u{62F}\u{647}`,
    fil: (count)=>`${count} kaganapan na natagpuan`,
    fr: (count)=>`${count} \xe9v\xe9nements trouv\xe9s`,
    hi: (count)=>`${count} \u{907}\u{935}\u{947}\u{902}\u{91F} \u{92E}\u{93F}\u{932}\u{947}`,
    ht: (count)=>`${count} Ev\xe8nman yo te jwenn`,
    it: (count)=>`${count} eventi trovati`,
    ja: (count)=>`${count} \u{3064}\u{306E}\u{51FA}\u{6765}\u{4E8B}\u{304C}\u{767A}\u{898B}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}`,
    ko: (count)=>`${count} \u{AC1C}\u{C758} \u{C0AC}\u{AC74}\u{C774} \u{BC1C}\u{ACAC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: (count)=>`${count} qhov xwm txheej pom`,
    ps: (count)=>`${count} \u{67E}\u{6CC}\u{69A}\u{6D0} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{634}\u{648}\u{6D0}`,
    pt: (count)=>`${count} eventos encontrados`,
    'pt-pt': (count)=>`${count} eventos encontrados`,
    ru: (count)=>`${count} \u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}\u{43D}\u{44B}\u{445} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{439}`,
    sm: (count)=>`${count} mea na tutupu na maua`,
    so: (count)=>`${count} dhacdo oo la helay`,
    th: (count)=>`\u{E1E}\u{E1A}\u{E40}\u{E2B}\u{E15}\u{E38}\u{E01}\u{E32}\u{E23}\u{E13}\u{E4C} ${count} \u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}`,
    ur: (count)=>`${count} \u{648}\u{627}\u{642}\u{639}\u{627}\u{62A}`,
    vi: (count)=>`T\xecm th\u{1EA5}y ${count} s\u{1EF1} ki\u{1EC7}n`,
    'zh-hans': (count)=>`5\u{4E2A}${count}`,
    'zh-hant': (count)=>`5 ${count}`,
    en: (count)=>`${count} events found`
};
const $b11db1b62d4a8f76$export$a9eeb925e66f3fef = {
    ar: (count)=>`${count} \u{645}\u{644}\u{641}\u{627}\u{62A}`,
    de: (count)=>`${count} Akten`,
    es: (count)=>`${count} archivos`,
    fa: (count)=>`${count} \u{641}\u{627}\u{6CC}\u{644}`,
    fil: (count)=>`${count} Mga File`,
    fr: (count)=>`${count} fichiers`,
    hi: (count)=>`${count} \u{92B}\u{93C}\u{93E}\u{907}\u{932}\u{947}\u{902}`,
    ht: (count)=>`${count} dosye`,
    it: (count)=>`${count} file`,
    ja: (count)=>`${count} \u{3064}\u{306E}\u{30D5}\u{30A1}\u{30A4}\u{30EB}`,
    ko: (count)=>`${count} \u{AC1C}\u{C758} \u{D30C}\u{C77C}`,
    mww: (count)=>`${count} cov ntaub ntawv`,
    ps: (count)=>`${count} \u{641}\u{627}\u{6CC}\u{644}\u{648}\u{646}\u{647}`,
    pt: (count)=>`${count} arquivos`,
    'pt-pt': (count)=>`${count} ficheiros`,
    ru: (count)=>`${count} \u{444}\u{430}\u{439}\u{43B}\u{430}`,
    sm: (count)=>`${count} faila`,
    so: (count)=>`${count} faylal`,
    th: (count)=>`${count} \u{E44}\u{E1F}\u{E25}\u{E4C}`,
    ur: (count)=>`${count} \u{641}\u{627}\u{626}\u{644}\u{6CC}\u{6BA}`,
    vi: (count)=>`${count} t\u{1EAD}p tin`,
    'zh-hans': (count)=>`${count} \u{4E2A}\u{6587}\u{4EF6}`,
    'zh-hant': (count)=>`${count} \u{500B}\u{6A94}\u{6848}`,
    en: (count)=>`${count} files`
};
const $b11db1b62d4a8f76$export$814fd764a5b35e2f = {
    ar: (count)=>`${count} \u{623}\u{62F}\u{648}\u{64A}\u{629}`,
    de: (count)=>`${count} Medikamente`,
    es: (count)=>`${count} medicamentos`,
    fa: (count)=>`${count} \u{62F}\u{627}\u{631}\u{648}`,
    fil: (count)=>`${count} gamot`,
    fr: (count)=>`${count} m\xe9dicaments`,
    hi: (count)=>`${count} \u{926}\u{935}\u{93E}\u{90F}\u{902}`,
    ht: (count)=>`${count} medikaman`,
    it: (count)=>`${count} farmaci`,
    ja: (count)=>`${count} \u{3064}\u{306E}\u{85AC}`,
    ko: (count)=>`${count} \u{AC00}\u{C9C0} \u{C57D}\u{BB3C}`,
    mww: (count)=>`${count} tshuaj`,
    ps: (count)=>`${count} \u{62F}\u{631}\u{645}\u{644}`,
    pt: (count)=>`${count} medicamentos`,
    'pt-pt': (count)=>`${count} medicamentos`,
    ru: (count)=>`${count} \u{43B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432}\u{430}`,
    sm: (count)=>`${count} vaila'au`,
    so: (count)=>`${count} Daawo`,
    th: (count)=>`${count} \u{E22}\u{E32}`,
    ur: (count)=>`${count} \u{627}\u{62F}\u{648}\u{6CC}\u{627}\u{62A}`,
    vi: (count)=>`${count} Thu\u{1ED1}c`,
    'zh-hans': (count)=>`${count} \u{79CD}\u{836F}\u{7269}`,
    'zh-hant': (count)=>`${count} \u{7A2E}\u{85E5}\u{7269}`,
    en: (count)=>`${count} medications`
};
const $b11db1b62d4a8f76$export$39afa205509dcbe8 = {
    ar: (count)=>`${count} \u{645}\u{646}\u{638}\u{645}\u{627}\u{62A}`,
    de: (count)=>`${count} Organisationen`,
    es: (count)=>`${count} organizaciones`,
    fa: (count)=>`${count} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: (count)=>`${count} Mga Organisasyon`,
    fr: (count)=>`${count} organisations`,
    hi: (count)=>`${count} \u{938}\u{902}\u{917}\u{920}\u{928}`,
    ht: (count)=>`${count} \xf2ganizasyon`,
    it: (count)=>`${count} organizzazioni`,
    ja: (count)=>`${count} \u{3064}\u{306E}\u{7D44}\u{7E54}`,
    ko: (count)=>`${count} \u{AC1C} \u{C870}\u{C9C1}`,
    mww: (count)=>`${count} lub koom haum`,
    ps: (count)=>`${count} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{647}`,
    pt: (count)=>`${count} organiza\xe7\xf5es`,
    'pt-pt': (count)=>`${count} organiza\xe7\xf5es`,
    ru: (count)=>`${count} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{439}`,
    sm: (count)=>`${count} fa'alapotopotoga`,
    so: (count)=>`${count} Urur`,
    th: (count)=>`${count} \u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: (count)=>`${count} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{6CC}\u{6BA}`,
    vi: (count)=>`${count} T\u{1ED5} ch\u{1EE9}c`,
    'zh-hans': (count)=>`${count} \u{4E2A}\u{7EC4}\u{7EC7}`,
    'zh-hant': (count)=>`${count} \u{500B}\u{7D44}\u{7E54}`,
    en: (count)=>`${count} organizations`
};
const $b11db1b62d4a8f76$export$fadf449bba626fc1 = {
    ar: (count)=>`${count} \u{645}\u{634}\u{627}\u{631}\u{643}\u{648}\u{646}`,
    de: (count)=>`${count} Teilnehmer`,
    es: (count)=>`${count} participantes`,
    fa: (count)=>`${count} \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: (count)=>`${count} kalahok`,
    fr: (count)=>`${count} participants`,
    hi: (count)=>`${count} \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{940}`,
    ht: (count)=>`${count} patisipan yo`,
    it: (count)=>`${count} partecipanti`,
    ja: (count)=>`${count} \u{540D}`,
    ko: (count)=>`${count} \u{BA85}\u{C758} \u{CC38}\u{AC00}\u{C790}`,
    mww: (count)=>`${count} tus neeg koom nrog`,
    ps: (count)=>`${count} \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644}`,
    pt: (count)=>`${count} participantes`,
    'pt-pt': (count)=>`${count} participantes`,
    ru: (count)=>`${count} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{43E}\u{432}`,
    sm: (count)=>`${count} tagata auai`,
    so: (count)=>`${count} ka qaybgalayaal`,
    th: (count)=>`\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21} ${count} \u{E04}\u{E19}`,
    ur: (count)=>`${count} \u{634}\u{631}\u{6A9}\u{627}\u{621}`,
    vi: (count)=>`${count} ng\u{1B0}\u{1EDD}i tham gia`,
    'zh-hans': (count)=>`${count} \u{540D}\u{53C2}\u{8D5B}\u{8005}`,
    'zh-hant': (count)=>`${count} \u{540D}\u{53C3}\u{8CFD}\u{8005}`,
    en: (count)=>`${count} participants`
};
const $b11db1b62d4a8f76$export$88044af7e8639ccb = {
    ar: (count)=>`${count} \u{62A}\u{648}\u{642}\u{64A}\u{639}\u{627}\u{62A}`,
    de: (count)=>`${count} Unterschriften`,
    es: (count)=>`${count} firmas`,
    fa: (count)=>`${count} \u{627}\u{645}\u{636}\u{627}`,
    fil: (count)=>`${count} lagda`,
    fr: (count)=>`${count} signatures`,
    hi: (count)=>`${count} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930}`,
    ht: (count)=>`${count} siyati`,
    it: (count)=>`${count} firme`,
    ja: (count)=>`${count} \u{3064}\u{306E}\u{7F72}\u{540D}`,
    ko: (count)=>`${count} \u{AC1C}`,
    mww: (count)=>`${count} kos npe`,
    ps: (count)=>`${count} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647}`,
    pt: (count)=>`${count} assinaturas`,
    'pt-pt': (count)=>`${count} assinaturas`,
    ru: (count)=>`${count} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438}`,
    sm: (count)=>`${count} saini`,
    so: (count)=>`${count} saxiix`,
    th: (count)=>`${count} \u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: (count)=>`${count} \u{62F}\u{633}\u{62A}\u{62E}\u{637}`,
    vi: (count)=>`${count} ch\u{1EEF} k\xfd`,
    'zh-hans': (count)=>`${count} \u{4E2A}\u{7B7E}\u{540D}`,
    'zh-hant': (count)=>`${count} \u{500B}\u{7C3D}\u{540D}`,
    en: (count)=>`${count} signatures`
};
const $b11db1b62d4a8f76$export$6a1c2e563a22c4e0 = {
    ar: `\u{645}\u{648}\u{642}\u{639}\u{64A}`,
    de: `Mein Standort`,
    es: `Mi ubicaci\xf3n`,
    fa: `\u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A} \u{645}\u{646}`,
    fil: `Ang aking lokasyon`,
    fr: `Ma localisation`,
    hi: `\u{92E}\u{947}\u{930}\u{93E} \u{938}\u{94D}\u{925}\u{93E}\u{928}`,
    ht: `Kote mwen an`,
    it: `La mia posizione`,
    ja: `\u{79C1}\u{306E}\u{5C45}\u{5834}\u{6240}`,
    ko: `\u{B0B4} \u{C704}\u{CE58}`,
    mww: `Kuv qhov chaw nyob`,
    ps: `\u{632}\u{645}\u{627} \u{681}\u{627}\u{6CC}`,
    pt: `Minha localiza\xe7\xe3o`,
    'pt-pt': `A minha localiza\xe7\xe3o`,
    ru: `\u{41C}\u{43E}\u{451} \u{43C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `O lo'u nofoaga`,
    so: `Goobtayda`,
    th: `\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E17}\u{E35}\u{E48}\u{E15}\u{E31}\u{E49}\u{E07}\u{E02}\u{E2D}\u{E07}\u{E09}\u{E31}\u{E19}`,
    ur: `\u{645}\u{6CC}\u{631}\u{627} \u{645}\u{642}\u{627}\u{645}`,
    vi: `V\u{1ECB} tr\xed c\u{1EE7}a t\xf4i`,
    'zh-hans': `\u{6211}\u{7684}\u{4F4D}\u{7F6E}`,
    'zh-hant': `\u{6211}\u{7684}\u{4F4D}\u{7F6E}`,
    en: `My location`
};
const $b11db1b62d4a8f76$export$e50c34f3203f75cb = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{645}`,
    de: `Name`,
    es: `Nombre`,
    fa: `\u{646}\u{627}\u{645}`,
    fil: `Pangalan`,
    fr: `Nom`,
    hi: `\u{928}\u{93E}\u{92E}`,
    ht: `Fe-apel`,
    it: `Nome`,
    ja: `\u{540D}\u{79F0}`,
    ko: `\u{C774}\u{B984}`,
    mww: `Lub Npe`,
    ps: `\u{646}\u{648}\u{645}`,
    pt: `Nome`,
    'pt-pt': `Nome`,
    ru: `\u{41D}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Igoa`,
    so: `Magaca`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D}`,
    ur: `\u{646}\u{627}\u{645}`,
    vi: `T\xean`,
    'zh-hans': `\u{540D}\u{79F0}`,
    'zh-hant': `\u{540D}\u{7A31}`,
    en: `Name`
};
const $b11db1b62d4a8f76$export$7c0278eb6fbbdd9e = {
    ar: `\u{627}\u{644}\u{645}\u{644}\u{627}\u{62D}\u{629}`,
    de: `Navigation`,
    es: `Navegaci\xf3n`,
    fa: `\u{646}\u{627}\u{648}\u{628}\u{631}\u{6CC}`,
    fil: `Nabigasyon`,
    fr: `Navigation`,
    hi: `\u{928}\u{947}\u{935}\u{93F}\u{917}\u{947}\u{936}\u{928}`,
    ht: `Navigasyon`,
    it: `Navigazione`,
    ja: `\u{30CA}\u{30D3}\u{30B2}\u{30FC}\u{30B7}\u{30E7}\u{30F3}`,
    ko: `\u{D56D}\u{D574}`,
    mww: `Kev taw qhia`,
    ps: `\u{646}\u{6CC}\u{648}\u{6CC}\u{6AB}\u{6CC}\u{634}\u{646}`,
    pt: `Navega\xe7\xe3o`,
    'pt-pt': `Navega\xe7\xe3o`,
    ru: `\u{41D}\u{430}\u{432}\u{438}\u{433}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Fa'atautaia`,
    so: `Navigation-ka`,
    th: `\u{E01}\u{E32}\u{E23}\u{E40}\u{E14}\u{E34}\u{E19}\u{E40}\u{E23}\u{E37}\u{E2D}`,
    ur: `\u{646}\u{6CC}\u{648}\u{6CC}\u{6AF}\u{6CC}\u{634}\u{646}`,
    vi: `\u{110}i\u{1EC1}u h\u{1B0}\u{1EDB}ng`,
    'zh-hans': `\u{5BFC}\u{822A}`,
    'zh-hant': `\u{5C0E}\u{822A}`,
    en: `Navigation`
};
const $b11db1b62d4a8f76$export$ec72a48abb8cabe8 = {
    ar: (address)=>`\u{628}\u{627}\u{644}\u{642}\u{631}\u{628} \u{645}\u{646} ${address}`,
    de: (address)=>`In der N\xe4he ${address}`,
    es: (address)=>`Cerca ${address}`,
    fa: (address)=>`\u{646}\u{632}\u{62F}\u{6CC}\u{6A9} ${address}`,
    fil: (address)=>`Malapit sa ${address}`,
    fr: (address)=>`Pr\xe8s ${address}`,
    hi: (address)=>`${address} \u{915}\u{947} \u{92A}\u{93E}\u{938}`,
    ht: (address)=>`Toupre ${address}`,
    it: (address)=>`Vicino ${address}`,
    ja: (address)=>`\u{30EF}\u{30B7}\u{30F3}\u{30C8}\u{30F3}${address}\u{756A}\u{5730}\u{4ED8}\u{8FD1}`,
    ko: (address)=>`\u{C6CC}${address} \u{ADFC}\u{CC98}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (address)=>`Nyob ze ${address}`,
    ps: (address)=>`\u{62F} ${address} \u{62A}\u{647} \u{646}\u{696}\u{62F}\u{6D0}`,
    pt: (address)=>`Perto ${address}`,
    'pt-pt': (address)=>`Perto ${address}`,
    ru: (address)=>`\u{420}\u{44F}\u{434}\u{43E}\u{43C} \u{441} ${address}`,
    sm: (address)=>`Latalata i ${address}`,
    so: (address)=>`Agagaarka ${address}`,
    th: (address)=>`Near ${address}`,
    ur: (address)=>`${address} \u{6A9}\u{6D2} \u{642}\u{631}\u{6CC}\u{628}`,
    vi: (address)=>`G\u{1EA7}n ${address}`,
    'zh-hans': (address)=>`\u{9760}\u{8FD1}${address}\u{53F7}`,
    'zh-hant': (address)=>`\u{9760}\u{8FD1}${address}\u{865F}`,
    en: (address)=>`Near ${address}`
};
const $b11db1b62d4a8f76$export$5e3c89a229d55fe9 = {
    ar: `\u{627}\u{644}\u{62D}\u{64A}`,
    de: `Nachbarschaft`,
    es: `Barrio`,
    fa: `\u{645}\u{62D}\u{644}\u{647}`,
    fil: `Kapitbahayan`,
    fr: `Quartier`,
    hi: `\u{92A}\u{921}\u{93C}\u{94B}\u{938}`,
    ht: `Katye`,
    it: `Quartiere`,
    ja: `\u{8FD1}\u{96A3}`,
    ko: `\u{B3D9}\u{B124}`,
    mww: `Neeg Zej Zog`,
    ps: `\u{6AB}\u{627}\u{648}\u{646}\u{689}`,
    pt: `Bairro`,
    'pt-pt': `Bairro`,
    ru: `\u{420}\u{430}\u{439}\u{43E}\u{43D}`,
    sm: `Tuaoi`,
    so: `Xaafadda`,
    th: `\u{E22}\u{E48}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E1E}\u{E31}\u{E01}`,
    ur: `\u{645}\u{62D}\u{644}\u{6C1}`,
    vi: `Khu v\u{1EF1}c l\xe2n c\u{1EAD}n`,
    'zh-hans': `\u{793E}\u{533A}`,
    'zh-hant': `\u{793E}\u{5340}`,
    en: `Neighborhood`
};
const $b11db1b62d4a8f76$export$3098cb3a0f5aeabc = {
    ar: `\u{623}\u{628}\u{62F}\u{627}`,
    de: `Niemals`,
    es: `Nunca`,
    fa: `\u{647}\u{631}\u{6AF}\u{632}`,
    fil: `Hindi kailanman`,
    fr: `Jamais`,
    hi: `\u{915}\u{92D}\u{940} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa janm`,
    it: `Mai`,
    ja: `\u{7D76}\u{5BFE}\u{306B}`,
    ko: `\u{C808}\u{B300} \u{C548} \u{B3FC}`,
    mww: `yeej tsis tau`,
    ps: `\u{647}\u{6CC}\u{685}\u{6A9}\u{644}\u{647}`,
    pt: `Nunca`,
    'pt-pt': `Nunca`,
    ru: `\u{41D}\u{438}\u{43A}\u{43E}\u{433}\u{434}\u{430}`,
    sm: `E le'i`,
    so: `Marnaba`,
    th: `\u{E44}\u{E21}\u{E48}\u{E40}\u{E04}\u{E22}`,
    ur: `\u{6A9}\u{628}\u{6BE}\u{6CC} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng bao gi\u{1EDD}`,
    'zh-hans': `\u{7EDD}\u{4E0D}`,
    'zh-hant': `\u{7D55}\u{4E0D}`,
    en: `Never`
};
const $b11db1b62d4a8f76$export$da0039b16b06a993 = {
    ar: `\u{627}\u{644}\u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Neu`,
    es: `Nuevo`,
    fa: `\u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Bago`,
    fr: `Nouveau`,
    hi: `\u{928}\u{92F}\u{93E}`,
    ht: `Nouvo`,
    it: `Nuovo`,
    ja: `\u{65B0}\u{4F5C}`,
    ko: `\u{C2E0}\u{ADDC}`,
    mww: `Tshiab`,
    ps: `\u{646}\u{648}\u{6CC}`,
    pt: `Novo`,
    'pt-pt': `Novo`,
    ru: `\u{41D}\u{43E}\u{432}\u{438}\u{43D}\u{43A}\u{430}`,
    sm: `Fou`,
    so: `Cusub`,
    th: `\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{6CC}\u{627}`,
    vi: `M\u{1EDB}i`,
    'zh-hans': `\u{65B0}`,
    'zh-hant': `\u{65B0}`,
    en: `New`
};
const $b11db1b62d4a8f76$export$c7ccf165d99d4bc7 = {
    ar: `\u{646}\u{634}\u{627}\u{637} \u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Neue Aktivit\xe4ten`,
    es: `Nueva actividad`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Bagong aktibidad`,
    fr: `Nouvelle activit\xe9`,
    hi: `\u{928}\u{908} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}`,
    ht: `Nouvo aktivite`,
    it: `Nuove attivit\xe0`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{6D3B}\u{52D5}`,
    ko: `\u{C0C8}\u{B85C}\u{C6B4} \u{D65C}\u{B3D9}`,
    mww: `Kev ua haujlwm tshiab`,
    ps: `\u{646}\u{648}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    pt: `Nova atividade`,
    'pt-pt': `Nova atividade`,
    ru: `\u{41D}\u{43E}\u{432}\u{430}\u{44F} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Gaoioiga fou`,
    so: `Hawlaha cusub`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{626}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng m\u{1EDB}i`,
    'zh-hans': `\u{65B0}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{65B0}\u{6D3B}\u{52D5}`,
    en: `New activity`
};
const $b11db1b62d4a8f76$export$b352d5c1a5b9238 = {
    ar: `\u{62A}\u{639}\u{631}\u{64A}\u{641} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{627}\u{644}\u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Neue Aktivit\xe4tsdefinition`,
    es: `Nueva definici\xf3n de actividad`,
    fa: `\u{62A}\u{639}\u{631}\u{6CC}\u{641} \u{62C}\u{62F}\u{6CC}\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    fil: `Bagong kahulugan ng aktibidad`,
    fr: `Nouvelle d\xe9finition de l\u{2019}activit\xe9`,
    hi: `\u{928}\u{908} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930}\u{93F}\u{92D}\u{93E}\u{937}\u{93E}`,
    ht: `Nouvo definisyon aktivite`,
    it: `Nuova definizione di attivit\xe0`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{6D3B}\u{52D5}\u{306E}\u{5B9A}\u{7FA9}`,
    ko: `\u{C0C8}\u{B85C}\u{C6B4} \u{D65C}\u{B3D9} \u{C815}\u{C758}`,
    mww: `Tshiab kev ua ub no txhais`,
    ps: `\u{646}\u{648}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{639}\u{631}\u{6CC}\u{641}`,
    pt: `Nova defini\xe7\xe3o de atividade`,
    'pt-pt': `Nova defini\xe7\xe3o de atividade`,
    ru: `\u{41D}\u{43E}\u{432}\u{43E}\u{435} \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Fa'auigaga fou o gaioiga`,
    so: `Qeexid hawl cusub`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E08}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E14}\u{E04}\u{E27}\u{E32}\u{E21}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{626}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6CC} \u{62A}\u{639}\u{631}\u{6CC}\u{641}`,
    vi: `\u{110}\u{1ECB}nh ngh\u{129}a ho\u{1EA1}t \u{111}\u{1ED9}ng m\u{1EDB}i`,
    'zh-hans': `\u{65B0}\u{6D3B}\u{52A8}\u{5B9A}\u{4E49}`,
    'zh-hant': `\u{65B0}\u{6D3B}\u{52D5}\u{5B9A}\u{7FA9}`,
    en: `New activity definition`
};
const $b11db1b62d4a8f76$export$5a1b1a4071572031 = {
    ar: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} جديدة</strong>: أنشئ شخصا جديدا`,
    de: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Neue ${activityTitle}</strong> Erstelle eine neue Person`,
    es: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nueva ${activityTitle}</strong>: crea una nueva persona`,
    fa: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} جدید</strong>: ایجاد یک فرد جدید`,
    fil: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Bagong ${activityTitle}</strong>: Lumikha ng Bagong Tao`,
    fr: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nouvelle ${activityTitle}</strong> : créez une nouvelle personne`,
    hi: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>नया ${activityTitle}</strong>: एक नया व्यक्ति बनाएं`,
    ht: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nouvo ${activityTitle}</strong>: kreye yon nouvo moun`,
    it: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nuova ${activityTitle}</strong>: crea una nuova persona`,
    ja: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>新しい ${activityTitle}</strong>:新しい人を作成する`,
    ko: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>새 ${activityTitle}</strong>: 새로운 사람을 만드세요`,
    mww: (activityTitle)=>$b11db1b62d4a8f76$var$html`Kev <strong>${activityTitle} mus</strong> tshiab: tsim ib tus neeg tshiab`,
    ps: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>نوې ${activityTitle}</strong>: یو نوی کس پیدا کړئ`,
    pt: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nova ${activityTitle}</strong>: crie uma nova pessoa`,
    'pt-pt': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nova ${activityTitle}</strong>: crie uma nova pessoa`,
    ru: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Новая ${activityTitle}</strong>: создайте нового человека`,
    sm: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle}</strong>: Fausia se Tagata Fou`,
    so: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} cusub</strong>: samee qof cusub`,
    th: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle}ใหม่</strong>: สร้างบุคคลใหม่`,
    ur: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>نیا ${activityTitle}</strong>: ایک نیا شخص بنائیں`,
    vi: (activityTitle)=>$b11db1b62d4a8f76$var$html`Giới <strong>${activityTitle} mới</strong>: tạo người mới`,
    'zh-hans': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>新 ${activityTitle}</strong>：创建一个新人`,
    'zh-hant': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>新 ${activityTitle}</strong>：創建新對象`,
    en: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>New ${activityTitle}</strong>: create a new person`
};
const $b11db1b62d4a8f76$export$4d733303d0e71344 = {
    ar: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} جديدة</strong>: ابحث عن شخص`,
    de: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Neue ${activityTitle}</strong> Suche nach einer Person`,
    es: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nueva ${activityTitle}</strong>: busca a una persona`,
    fa: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} جدید</strong>: جستجو برای یک فرد`,
    fil: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Bagong ${activityTitle}</strong>: Paghahanap ng Isang Tao`,
    fr: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nouvelle ${activityTitle}</strong> : recherche une personne`,
    hi: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>नया ${activityTitle}</strong>: किसी व्यक्ति की खोज करें`,
    ht: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nouvo ${activityTitle}</strong>: rechèch pou yon moun`,
    it: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nuova ${activityTitle}</strong>: cerca una persona`,
    ja: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>新しい ${activityTitle}</strong>:人を検索する`,
    ko: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>새 ${activityTitle}</strong>: 사람을 찾아`,
    mww: (activityTitle)=>$b11db1b62d4a8f76$var$html`Kev <strong>${activityTitle} tshiab</strong>: nrhiav ib tus neeg`,
    ps: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>نوې ${activityTitle}</strong> کول: د یو کس لټون وکړئ`,
    pt: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nova ${activityTitle}</strong>: procure por uma pessoa`,
    'pt-pt': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nova ${activityTitle}</strong>: procura uma pessoa`,
    ru: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Новое ${activityTitle}</strong>: поиск человека`,
    sm: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle}</strong>: Saili se Tagata`,
    so: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} cusub</strong>: raadi qof`,
    th: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle}ใหม่</strong>: ค้นหาบุคคล`,
    ur: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>نیا ${activityTitle}</strong>: کسی شخص کی تلاش کریں`,
    vi: (activityTitle)=>$b11db1b62d4a8f76$var$html`Giới <strong>${activityTitle} mới</strong>: tìm kiếm một người`,
    'zh-hans': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>新 ${activityTitle}</strong>：搜索某人`,
    'zh-hant': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>新 ${activityTitle}</strong>：搜尋某人`,
    en: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>New ${activityTitle}</strong>: search for a person`
};
const $b11db1b62d4a8f76$export$1746a150ab2ffbf4 = {
    ar: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} جديدة</strong>: اختر النشاط الذي سيرتبط به ${activityTitle} الجديدة`,
    de: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Neue ${activityTitle}</strong>: Wählen Sie die Aktivität aus, mit der die neue ${activityTitle} verknüpft sein wird`,
    es: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nueva ${activityTitle}</strong>: selecciona la actividad con la que se asociará la nueva ${activityTitle}`,
    fa: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} جدید</strong>: فعالیتی را انتخاب کنید که ${activityTitle} جدید با آن مرتبط خواهد بود`,
    fil: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Bagong ${activityTitle}</strong>: piliin ang aktibidad na maiuugnay sa bagong ${activityTitle}`,
    fr: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nouvelle ${activityTitle}</strong> : sélectionnez l’activité à laquelle la nouvelle ${activityTitle} sera associée`,
    hi: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>नया ${activityTitle}</strong>: उस गतिविधि का चयन करें जिससे नया ${activityTitle} संबद्ध होगा`,
    ht: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nouvo ${activityTitle}</strong>: chwazi aktivite nouvo ${activityTitle} lan pral asosye avèk`,
    it: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nuova ${activityTitle}</strong>: seleziona l'attività a cui la nuova ${activityTitle} sarà associata`,
    ja: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>新しい ${activityTitle}</strong>:新しい ${activityTitle} が関連付けられる活動を選択します`,
    ko: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>신규 ${activityTitle}</strong>: 새 ${activityTitle} 가 연관될 활동을 선택하세요`,
    mww: (activityTitle)=>$b11db1b62d4a8f76$var$html`Kev <strong>${activityTitle} mus tshiab</strong>: xaiv qhov haujlwm uas yuav ${activityTitle} lwm tus tshiab`,
    ps: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>نوې ${activityTitle}</strong>: هغه فعالیت وټاکه چې نوی ${activityTitle} کول به ورسره تړاو ولری`,
    pt: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nova ${activityTitle}</strong>: selecione a atividade à qual a nova ${activityTitle} estará associada`,
    'pt-pt': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Nova ${activityTitle}</strong>: selecione a atividade à qual a nova ${activityTitle} estará associada`,
    ru: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>Новое ${activityTitle}</strong>: выберите деятельность, с которой будет ${activityTitle}`,
    sm: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} fou</strong>: filifili le gaioiga o le a feso'ota'i ma le ${activityTitle} fou`,
    so: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle} cusub</strong>: dooro hawsha uu ${activityTitle} cusub la xiriiri doono`,
    th: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>${activityTitle}ใหม่</strong>: เลือกกิจกรรมที่จะเชื่อมโยงกับ${activityTitle}ใหม่`,
    ur: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>نیا ${activityTitle}</strong>: اس سرگرمی کا انتخاب کریں جس سے نیا ${activityTitle} منسلک ہوگا`,
    vi: (activityTitle)=>$b11db1b62d4a8f76$var$html`Giới <strong>${activityTitle} mới</strong>: chọn hoạt động mà ${activityTitle} mới sẽ được liên kết`,
    'zh-hans': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>新 ${activityTitle}</strong>：选择新 ${activityTitle} 将关联的活动`,
    'zh-hant': (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>新 ${activityTitle}</strong>：選擇該轉 ${activityTitle} 將關聯的活動`,
    en: (activityTitle)=>$b11db1b62d4a8f76$var$html`<strong>New ${activityTitle}</strong>: select the activity the new ${activityTitle} will be associated with`
};
const $b11db1b62d4a8f76$export$73296539e54235cd = {
    ar: `\u{644}\u{648}\u{62D}\u{629} \u{62A}\u{62D}\u{643}\u{645} \u{62C}\u{62F}\u{64A}\u{62F}\u{629}`,
    de: `Neues Armaturenbrett`,
    es: `Nuevo salpicadero`,
    fa: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Bagong dashboard`,
    fr: `Nouveau tableau de bord`,
    hi: `\u{928}\u{92F}\u{93E} \u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921}`,
    ht: `Nouvo tablodb\xf2`,
    it: `Nuovo cruscotto`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}`,
    ko: `\u{C0C8} \u{B300}\u{C2DC}\u{BCF4}\u{B4DC}`,
    mww: `Tshiab dashboard`,
    ps: `\u{646}\u{648}\u{6CC} \u{689}\u{634}\u{628}\u{648}\u{631}\u{689}`,
    pt: `Novo painel`,
    'pt-pt': `Novo painel de instrumentos`,
    ru: `\u{41D}\u{43E}\u{432}\u{430}\u{44F} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44C} \u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Dashboard fou`,
    so: `Dashboard cusub`,
    th: `\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{6CC}\u{627} \u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688}`,
    vi: `B\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n m\u{1EDB}i`,
    'zh-hans': `\u{65B0}\u{4EEA}\u{8868}\u{76D8}`,
    'zh-hant': `\u{65B0}\u{5100}\u{8868}\u{677F}`,
    en: `New dashboard`
};
const $b11db1b62d4a8f76$export$aac94472455dcfa2 = {
    ar: (entity)=>`${entity} \u{62C}\u{62F}\u{64A}\u{62F}`,
    de: (entity)=>`Neuer ${entity}`,
    es: (entity)=>`${entity}`,
    fa: (entity)=>`${entity} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: (entity)=>`Bagong ${entity}`,
    fr: (entity)=>`Nouvel ${entity}`,
    hi: (entity)=>`\u{928}\u{92F}\u{93E} ${entity}`,
    ht: (entity)=>`Nouvo ${entity}`,
    it: (entity)=>`Nuovo ${entity}`,
    ja: (entity)=>`\u{65B0} ${entity}`,
    ko: (entity)=>`\u{C2E0} ${entity}`,
    mww: (entity)=>`${entity}`,
    ps: (entity)=>`\u{646}\u{648}\u{6D0} ${entity}`,
    pt: (entity)=>`Novo ${entity}`,
    'pt-pt': (entity)=>`${entity}`,
    ru: (entity)=>`\u{41D}\u{43E}\u{432}\u{44B}\u{439} ${entity}`,
    sm: (entity)=>`${entity} fou`,
    so: (entity)=>`Shayga ${entity} cusub`,
    th: (entity)=>`${entity}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: (entity)=>`\u{646}\u{6CC}\u{627} ${entity}`,
    vi: (entity)=>`${entity} m\u{1EDB}i`,
    'zh-hans': (entity)=>`\u{65B0} ${entity}`,
    'zh-hant': (entity)=>`\u{65B0} ${entity}`,
    en: (entity)=>`New ${entity}`
};
const $b11db1b62d4a8f76$export$8f6c7fb70aba14e3 = {
    ar: `\u{623}\u{62D}\u{62F}\u{62B}`,
    de: `Neuere`,
    es: `M\xe1s recientes`,
    fa: `\u{62C}\u{62F}\u{6CC}\u{62F}\u{62A}\u{631}`,
    fil: `Mas bagong`,
    fr: `Plus r\xe9cent`,
    hi: `\u{928}\u{92F}\u{93E}`,
    ht: `Pi nouvo`,
    it: `Pi\xf9 recenti`,
    ja: `\u{65B0}\u{3057}\u{3044}`,
    ko: `\u{B354} \u{C2E0}\u{D615}`,
    mww: `Tshiab dua`,
    ps: `\u{646}\u{648}\u{6D0}`,
    pt: `Mais recentes`,
    'pt-pt': `Mais recentes`,
    ru: `\u{41D}\u{43E}\u{432}\u{44B}\u{435}`,
    sm: `Fou`,
    so: `Cusub`,
    th: `\u{E43}\u{E2B}\u{E21}\u{E48}\u{E01}\u{E27}\u{E48}\u{E32}`,
    ur: `\u{646}\u{6CC}\u{627}`,
    vi: `M\u{1EDB}i h\u{1A1}n`,
    'zh-hans': `\u{8F83}\u{65B0}\u{7684}`,
    'zh-hant': `\u{8F03}\u{65B0}\u{7684}`,
    en: `Newer`
};
const $b11db1b62d4a8f76$export$3be7560a0cd57dae = {
    ar: `\u{634}\u{62E}\u{635} \u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Neue Person`,
    es: `Nueva persona`,
    fa: `\u{634}\u{62E}\u{635} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Bagong tao`,
    fr: `Nouvelle personne`,
    hi: `\u{928}\u{92F}\u{93E} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F}`,
    ht: `Nouvo moun`,
    it: `Persona nuova`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{4EBA}\u{7269}`,
    ko: `\u{C0C8}\u{B85C}\u{C6B4} \u{C0AC}\u{B78C}`,
    mww: `tus tshiab`,
    ps: `\u{646}\u{648}\u{6CC} \u{6A9}\u{633}`,
    pt: `Pessoa nova`,
    'pt-pt': `Pessoa nova`,
    ru: `\u{41D}\u{43E}\u{432}\u{44B}\u{439} \u{447}\u{435}\u{43B}\u{43E}\u{432}\u{435}\u{43A}`,
    sm: `Tagata fou`,
    so: `Qof cusub`,
    th: `\u{E04}\u{E19}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{6CC}\u{627} \u{634}\u{62E}\u{635}`,
    vi: `Ng\u{1B0}\u{1EDD}i m\u{1EDB}i`,
    'zh-hans': `\u{65B0}\u{6210}\u{5458}`,
    'zh-hant': `\u{65B0}\u{6210}\u{54E1}`,
    en: `New person`
};
const $b11db1b62d4a8f76$export$49c950bfab67049 = {
    ar: `\u{62C}\u{62F}\u{64A}\u{62F}\u{61F}`,
    de: `Neu?`,
    es: `\xbfNuevo?`,
    fa: `\u{62C}\u{62F}\u{6CC}\u{62F}\u{61F}`,
    fil: `Bago?`,
    fr: `Nouveau ?`,
    hi: `\u{928}\u{92F}\u{93E}?`,
    ht: `Nouvo?`,
    it: `Nuovo?`,
    ja: `\u{65B0}\u{3057}\u{3044}?`,
    ko: `\u{C0C8}\u{B85C} \u{C628} \u{AC70}\u{C57C}?`,
    mww: `Tshiab?`,
    ps: `\u{646}\u{648}\u{6CC}?`,
    pt: `Novo?`,
    'pt-pt': `Novo?`,
    ru: `\u{41D}\u{43E}\u{432}\u{44B}\u{439}?`,
    sm: `Fou?`,
    so: `Cusub?`,
    th: `\u{E43}\u{E2B}\u{E21}\u{E48}?`,
    ur: `\u{646}\u{6CC}\u{627}\u{61F}`,
    vi: `M\u{1EDB}i?`,
    'zh-hans': `\u{65B0}\u{6765}\u{7684}\u{FF1F}`,
    'zh-hant': `\u{65B0}\u{4F86}\u{7684}\u{FF1F}`,
    en: `New?`
};
const $b11db1b62d4a8f76$export$c68bdfe37180f9da = {
    ar: `\u{62A}\u{642}\u{631}\u{64A}\u{631} \u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Neuer Bericht`,
    es: `Nuevo informe`,
    fa: `\u{6AF}\u{632}\u{627}\u{631}\u{634} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Bagong ulat`,
    fr: `Nouveau rapport`,
    hi: `\u{928}\u{908} \u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F}`,
    ht: `Nouvo rap\xf2`,
    it: `Nuovo rapporto`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{5831}\u{544A}\u{66F8}`,
    ko: `\u{C0C8} \u{BCF4}\u{ACE0}\u{C11C}`,
    mww: `Daim ntawv qhia tshiab`,
    ps: `\u{646}\u{648}\u{6D0} \u{631}\u{627}\u{67E}\u{648}\u{631}`,
    pt: `Novo relat\xf3rio`,
    'pt-pt': `Novo relat\xf3rio`,
    ru: `\u{41D}\u{43E}\u{432}\u{44B}\u{439} \u{43E}\u{442}\u{447}\u{435}\u{442}`,
    sm: `Lipoti fou`,
    so: `Warbixin cusub`,
    th: `\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{626}\u{6CC} \u{631}\u{67E}\u{648}\u{631}\u{679}`,
    vi: `B\xe1o c\xe1o m\u{1EDB}i`,
    'zh-hans': `\u{65B0}\u{62A5}\u{544A}`,
    'zh-hant': `\u{65B0}\u{5831}\u{544A}`,
    en: `New report`
};
const $b11db1b62d4a8f76$export$55a5d9027c8ca2e0 = {
    ar: `\u{627}\u{644}\u{623}\u{62E}\u{628}\u{627}\u{631}`,
    de: `Nachrichten`,
    es: `Noticias`,
    fa: `\u{627}\u{62E}\u{628}\u{627}\u{631}`,
    fil: `Balita`,
    fr: `Actualit\xe9s`,
    hi: `\u{938}\u{92E}\u{93E}\u{91A}\u{93E}\u{930}`,
    ht: `Nouv\xe8l`,
    it: `Notizie`,
    ja: `\u{30CB}\u{30E5}\u{30FC}\u{30B9}`,
    ko: `\u{B274}\u{C2A4}`,
    mww: `Xov xwm`,
    ps: `\u{62E}\u{628}\u{631}\u{648}\u{646}\u{647}`,
    pt: `Not\xedcias`,
    'pt-pt': `Not\xedcias`,
    ru: `\u{41D}\u{43E}\u{432}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Tala Fou`,
    so: `Wararka`,
    th: `\u{E02}\u{E48}\u{E32}\u{E27}\u{E2A}\u{E32}\u{E23}`,
    ur: `\u{62E}\u{628}\u{631}\u{6CC}\u{6BA}`,
    vi: `Tin t\u{1EE9}c`,
    'zh-hans': `\u{65B0}\u{95FB}`,
    'zh-hant': `\u{65B0}\u{805E}`,
    en: `News`
};
const $b11db1b62d4a8f76$export$57b040909205b648 = {
    ar: `\u{627}\u{644}\u{62E}\u{62F}\u{645}\u{629} \u{627}\u{644}\u{62C}\u{62F}\u{64A}\u{62F}\u{629}`,
    de: `Neuer Dienst`,
    es: `Nuevo servicio`,
    fa: `\u{62E}\u{62F}\u{645}\u{62A} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Bagong serbisyo`,
    fr: `Nouveau service`,
    hi: `\u{928}\u{908} \u{938}\u{947}\u{935}\u{93E}`,
    ht: `Nouvo s\xe8vis`,
    it: `Nuovo servizio`,
    ja: `\u{65B0}\u{30B5}\u{30FC}\u{30D3}\u{30B9}`,
    ko: `\u{C2E0}\u{ADDC} \u{C11C}\u{BE44}\u{C2A4}`,
    mww: `Kev pabcuam tshiab`,
    ps: `\u{646}\u{648}\u{6D0} \u{62E}\u{62F}\u{645}\u{62A}`,
    pt: `Novo servi\xe7o`,
    'pt-pt': `Novo servi\xe7o`,
    ru: `\u{41D}\u{43E}\u{432}\u{430}\u{44F} \u{441}\u{43B}\u{443}\u{436}\u{431}\u{430}`,
    sm: `Auaunaga fou`,
    so: `Adeeg cusub`,
    th: `\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{626}\u{6CC} \u{633}\u{631}\u{648}\u{633}`,
    vi: `D\u{1ECB}ch v\u{1EE5} m\u{1EDB}i`,
    'zh-hans': `\u{65B0}\u{670D}\u{52A1}`,
    'zh-hant': `\u{65B0}\u{670D}\u{52D9}`,
    en: `New service`
};
const $b11db1b62d4a8f76$export$a366cce3cb8e241d = {
    ar: `\u{62A}\u{641}\u{648}\u{64A}\u{636} \u{627}\u{644}\u{62E}\u{62F}\u{645}\u{629} \u{627}\u{644}\u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Neue Dienstgenehmigung`,
    es: `Nueva autorizaci\xf3n de servicio`,
    fa: `\u{645}\u{62C}\u{648}\u{632} \u{633}\u{631}\u{648}\u{6CC}\u{633} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Bagong pahintulot sa serbisyo`,
    fr: `Nouvelle autorisation de service`,
    hi: `\u{928}\u{908} \u{938}\u{947}\u{935}\u{93E} \u{92A}\u{94D}\u{930}\u{93E}\u{927}\u{93F}\u{915}\u{930}\u{923}`,
    ht: `Nouvo otorizasyon s\xe8vis`,
    it: `Nuova autorizzazione al servizio`,
    ja: `\u{65B0}\u{898F}\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{8A8D}\u{53EF}`,
    ko: `\u{C2E0}\u{ADDC} \u{C11C}\u{BE44}\u{C2A4} \u{C2B9}\u{C778}`,
    mww: `Kev tso cai pabcuam tshiab`,
    ps: `\u{62F} \u{646}\u{648}\u{6D0} \u{62E}\u{62F}\u{645}\u{62A} \u{627}\u{62C}\u{627}\u{632}\u{647}`,
    pt: `Nova autoriza\xe7\xe3o de servi\xe7o`,
    'pt-pt': `Nova autoriza\xe7\xe3o de servi\xe7o`,
    ru: `\u{41D}\u{43E}\u{432}\u{43E}\u{435} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{435} \u{43D}\u{430} \u{441}\u{43B}\u{443}\u{436}\u{431}\u{443}`,
    sm: `Faatagaga Auaunaga Fou`,
    so: `Oggolaansho adeeg cusub`,
    th: `\u{E01}\u{E32}\u{E23}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{626}\u{6CC} \u{633}\u{631}\u{648}\u{633} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A}`,
    vi: `\u{1EE6}y quy\u{1EC1}n d\u{1ECB}ch v\u{1EE5} m\u{1EDB}i`,
    'zh-hans': `\u{65B0}\u{670D}\u{5F79}\u{6388}\u{6743}`,
    'zh-hant': `\u{65B0}\u{670D}\u{5F79}\u{6388}\u{6B0A}`,
    en: `New service authorization`
};
const $b11db1b62d4a8f76$export$159a9b56ba47cbb1 = {
    ar: `\u{62C}\u{62F}\u{648}\u{644} \u{632}\u{645}\u{646}\u{64A} \u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Neuer Stundenzettel`,
    es: `Nueva hoja de horas`,
    fa: `\u{62C}\u{62F}\u{648}\u{644} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Bagong timesheet`,
    fr: `Nouvelle feuille de temps`,
    hi: `\u{928}\u{908} \u{938}\u{92E}\u{92F} \u{92A}\u{924}\u{94D}\u{930}\u{915}`,
    ht: `Nouvo Timesheet`,
    it: `Nuovo foglio orari`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}`,
    ko: `\u{C0C8} \u{C2DC}\u{AC04}\u{D45C}`,
    mww: `Daim ntawv qhia sijhawm tshiab`,
    ps: `\u{646}\u{648}\u{6D0} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647}`,
    pt: `Nova folha de ponto`,
    'pt-pt': `Nova folha de horas`,
    ru: `\u{41D}\u{43E}\u{432}\u{44B}\u{439} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}`,
    sm: `Pepa o taimi fou`,
    so: `Jadwalka cusub`,
    th: `\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{6CC}\u{627} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679}`,
    vi: `B\u{1EA3}ng ch\u{1EA5}m c\xf4ng m\u{1EDB}i`,
    'zh-hans': `\u{65B0}\u{5DE5}\u{65F6}\u{8868}`,
    'zh-hant': `\u{65B0}\u{6642}\u{9593}\u{8868}`,
    en: `New timesheet`
};
const $b11db1b62d4a8f76$export$726aa351c1c86373 = {
    ar: `\u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}`,
    de: `Als N\xe4chstes`,
    es: `Siguiente`,
    fa: `\u{628}\u{639}\u{62F}\u{6CC}`,
    fil: `Susunod`,
    fr: `Suivant`,
    hi: `\u{905}\u{917}\u{932}\u{93E}`,
    ht: `Next`,
    it: `Prossimo`,
    ja: `\u{6B21}`,
    ko: `\u{B2E4}\u{C74C}`,
    mww: `Tom ntej no`,
    ps: `\u{628}\u{644}`,
    pt: `Pr\xf3ximo`,
    'pt-pt': `Pr\xf3ximo`,
    ru: `\u{414}\u{430}\u{43B}\u{435}\u{435}`,
    sm: `Sosoo ai`,
    so: `Xiga`,
    th: `\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}`,
    ur: `\u{627}\u{6AF}\u{644}\u{627}`,
    vi: `K\u{1EBF} ti\u{1EBF}p`,
    'zh-hans': `\u{4E0B}\u{4E00}\u{4E2A}`,
    'zh-hant': `\u{4E0B}\u{4E00}\u{7BC7}`,
    en: `Next`
};
const $b11db1b62d4a8f76$export$f5494529e20e3385 = {
    ar: `\u{627}\u{644}\u{642}\u{631}\u{64A}\u{628} \u{645}\u{646} \u{627}\u{644}\u{639}\u{627}\u{626}\u{644}\u{629}`,
    de: `Nachwuchsangeh\xf6riger`,
    es: `Parientes m\xe1s cercanos`,
    fa: `\u{62E}\u{648}\u{6CC}\u{634}\u{627}\u{648}\u{646}\u{62F} \u{646}\u{632}\u{62F}\u{6CC}\u{6A9}`,
    fil: `Susunod na kamag-anak`,
    fr: `Proche parent`,
    hi: `\u{92A}\u{930}\u{93F}\u{91C}\u{928}\u{94B}\u{902} \u{915}\u{947} \u{92C}\u{917}\u{932} \u{92E}\u{947}\u{902}`,
    ht: `Next-of-Kin`,
    it: `Parenti pi\xf9 prossimi`,
    ja: `\u{89AA}\u{65CF}\u{6B21}`,
    ko: `\u{CE5C}\u{CC99}`,
    mww: `Tom ntej-ntawm-Kin`,
    ps: `\u{646}\u{696}\u{62F}\u{6D0} \u{62F} \u{62E}\u{67E}\u{644}\u{648}\u{627}\u{646}\u{648}`,
    pt: `Parentes mais pr\xf3ximos`,
    'pt-pt': `Parentes mais pr\xf3ximos`,
    ru: `\u{411}\u{43B}\u{438}\u{436}\u{430}\u{439}\u{448}\u{438}\u{439} \u{440}\u{43E}\u{434}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{438}\u{43A}`,
    sm: `Aiga e sosoo ai`,
    so: `Qaraabada Dhow`,
    th: `\u{E0D}\u{E32}\u{E15}\u{E34}\u{E04}\u{E19}\u{E43}\u{E01}\u{E25}\u{E49}\u{E0A}\u{E34}\u{E14}`,
    ur: `\u{642}\u{631}\u{6CC}\u{628}\u{6CC} \u{631}\u{634}\u{62A}\u{6C1} \u{62F}\u{627}\u{631}`,
    vi: `Ng\u{1B0}\u{1EDD}i th\xe2n g\u{1EA7}n nh\u{1EA5}t`,
    'zh-hans': `\u{8FD1}\u{4EB2}`,
    'zh-hant': `\u{8FD1}\u{89AA}`,
    en: `Next-of-Kin`
};
const $b11db1b62d4a8f76$export$2a0609f6de79c668 = {
    ar: `\u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} \u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}\u{629}`,
    de: `N\xe4chste Seite`,
    es: `P\xe1gina siguiente`,
    fa: `\u{635}\u{641}\u{62D}\u{647} \u{628}\u{639}\u{62F}`,
    fil: `Susunod na pahina`,
    fr: `Page suivante`,
    hi: `\u{905}\u{917}\u{932}\u{93E} \u{92A}\u{943}\u{937}\u{94D}\u{920}`,
    ht: `Pwochen paj la`,
    it: `Pagina successiva`,
    ja: `\u{6B21}\u{306E}\u{30DA}\u{30FC}\u{30B8}`,
    ko: `\u{B2E4}\u{C74C} \u{D398}\u{C774}\u{C9C0}`,
    mww: `Nplooj ntawv tom ntej`,
    ps: `\u{628}\u{644}\u{647} \u{67E}\u{627}\u{6BC}\u{647}`,
    pt: `Pr\xf3xima p\xe1gina`,
    'pt-pt': `P\xe1gina seguinte`,
    ru: `\u{421}\u{43B}\u{435}\u{434}\u{443}\u{44E}\u{449}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430}`,
    sm: `Itulau e sosoo ai`,
    so: `Bogga xiga`,
    th: `\u{E2B}\u{E19}\u{E49}\u{E32}\u{E16}\u{E31}\u{E14}\u{E44}\u{E1B}`,
    ur: `\u{627}\u{6AF}\u{644}\u{627} \u{635}\u{641}\u{62D}\u{6C1}`,
    vi: `Trang ti\u{1EBF}p theo`,
    'zh-hans': `\u{4E0B}\u{4E00}\u{9875}`,
    'zh-hant': `\u{4E0B}\u{4E00}\u{9801}`,
    en: `Next page`
};
const $b11db1b62d4a8f76$export$a95d26a48a2ca108 = {
    ar: `\u{627}\u{644}\u{62E}\u{637}\u{648}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}\u{629}`,
    de: `N\xe4chste Schritte`,
    es: `Pr\xf3ximos pasos`,
    fa: `\u{6AF}\u{627}\u{645} \u{647}\u{627}\u{6CC} \u{628}\u{639}\u{62F}\u{6CC}`,
    fil: `Mga susunod na hakbang`,
    fr: `Prochaines \xe9tapes`,
    hi: `\u{905}\u{917}\u{932}\u{947} \u{91A}\u{930}\u{923}`,
    ht: `Pwochen etap yo`,
    it: `Passi successivi`,
    ja: `\u{4ECA}\u{5F8C}\u{306E}\u{30B9}\u{30C6}\u{30C3}\u{30D7}`,
    ko: `\u{B2E4}\u{C74C} \u{B2E8}\u{ACC4}`,
    mww: `Kauj ruam tom ntej`,
    ps: `\u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6CC} \u{6AB}\u{627}\u{645}\u{648}\u{646}\u{647}`,
    pt: `Pr\xf3ximos passos`,
    'pt-pt': `Pr\xf3ximos passos`,
    ru: `\u{421}\u{43B}\u{435}\u{434}\u{443}\u{44E}\u{449}\u{438}\u{435} \u{448}\u{430}\u{433}\u{438}`,
    sm: `Laasaga e sosoo ai`,
    so: `Tallaabooyinka xiga`,
    th: `\u{E02}\u{E31}\u{E49}\u{E19}\u{E15}\u{E2D}\u{E19}\u{E16}\u{E31}\u{E14}\u{E44}\u{E1B}`,
    ur: `\u{627}\u{6AF}\u{644}\u{6D2} \u{627}\u{642}\u{62F}\u{627}\u{645}\u{627}\u{62A}`,
    vi: `C\xe1c b\u{1B0}\u{1EDB}c ti\u{1EBF}p theo`,
    'zh-hans': `\u{4E0B}\u{4E00}\u{6B65}`,
    'zh-hant': `\u{4E0B}\u{4E00}\u{6B65}`,
    en: `Next steps`
};
const $b11db1b62d4a8f76$export$8783e8cbf2f3613 = {
    ar: `\u{627}\u{644}\u{644}\u{642}\u{628}`,
    de: `Spitzname`,
    es: `Apodo`,
    fa: `\u{644}\u{642}\u{628}`,
    fil: `Palayaw`,
    fr: `Surnom`,
    hi: `\u{909}\u{92A}\u{928}\u{93E}\u{92E}`,
    ht: `Tinon`,
    it: `Soprannome`,
    ja: `\u{30CB}\u{30C3}\u{30AF}\u{30CD}\u{30FC}\u{30E0}`,
    ko: `\u{BCC4}\u{BA85}`,
    mww: `Npe menyuam yaus`,
    ps: `\u{644}\u{642}\u{628}`,
    pt: `Apelido`,
    'pt-pt': `Alcunha`,
    ru: `\u{41F}\u{440}\u{43E}\u{437}\u{432}\u{438}\u{449}\u{435}`,
    sm: `Igoa tauvalaau`,
    so: `Naanays`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E25}\u{E48}\u{E19}`,
    ur: `\u{639}\u{631}\u{641}\u{6CC}\u{62A}`,
    vi: `Bi\u{1EC7}t danh`,
    'zh-hans': `\u{6635}\u{79F0}`,
    'zh-hant': `\u{7DBD}\u{865F}`,
    en: `Nickname`
};
const $b11db1b62d4a8f76$export$9692d1a0658a3861 = {
    ar: `\u{644}\u{627}`,
    de: `Nein`,
    es: `No`,
    fa: `\u{646}\u{647}`,
    fil: `Hindi`,
    fr: `Non`,
    hi: `\u{928}\u{939}\u{940}\u{902}`,
    ht: `Non`,
    it: `No`,
    ja: `\u{3044}\u{3044}\u{3048}`,
    ko: `\u{C544}\u{B2C8}`,
    mww: `Tsis yog`,
    ps: `\u{646}\u{627}`,
    pt: `N\xe3o`,
    'pt-pt': `N\xe3o`,
    ru: `\u{41D}\u{435}\u{442}`,
    sm: `Leai`,
    so: `Maya`,
    th: `\u{E44}\u{E21}\u{E48}`,
    ur: `\u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng`,
    'zh-hans': `\u{4E0D}`,
    'zh-hant': `\u{4E0D}`,
    en: `No`
};
const $b11db1b62d4a8f76$export$2a0324215672f5c = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{64A} \u{645}\u{646}\u{638}\u{645}\u{629} \u{644}\u{62F}\u{64A}\u{647}\u{627} \u{639}\u{642}\u{62F} \u{646}\u{634}\u{637} \u{645}\u{639} \u{627}\u{644}\u{634}\u{62E}\u{635} \u{627}\u{644}\u{630}\u{64A} \u{62A}\u{645} \u{627}\u{644}\u{62A}\u{641}\u{648}\u{64A}\u{636} \u{625}\u{644}\u{64A}\u{647} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}.`,
    de: `Keine Organisation hat einen aktiven Vertrag mit dem ausgew\xe4hlten Empf\xe4nger.`,
    es: `Ninguna organizaci\xf3n tiene un contrato activo con el cesionario seleccionado.`,
    fa: `\u{647}\u{6CC}\u{686} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC} \u{628}\u{627} \u{645}\u{623}\u{645}\u{648}\u{631} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{634}\u{62F}\u{647} \u{646}\u{62F}\u{627}\u{634}\u{62A}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Walang organisasyon ang may aktibong kontrata sa napiling assignee.`,
    fr: `Aucune organisation n\u{2019}a de contrat actif avec le cessionnaire s\xe9lectionn\xe9.`,
    hi: `\u{91A}\u{92F}\u{928}\u{93F}\u{924} \u{905}\u{938}\u{93E}\u{907}\u{928}\u{940} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{915}\u{93F}\u{938}\u{940} \u{92D}\u{940} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{93E} \u{938}\u{915}\u{94D}\u{930}\u{93F}\u{92F} \u{905}\u{928}\u{941}\u{92C}\u{902}\u{927} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}.`,
    ht: `Pa gen \xf2ganizasyon ki gen yon kontra aktif ak asiyen chwazi a.`,
    it: `Nessuna organizzazione ha un contratto attivo con l'assegnato selezionato.`,
    ja: `\u{3069}\u{306E}\u{7D44}\u{7E54}\u{3082}\u{9078}\u{3070}\u{308C}\u{305F}\u{8B72}\u{53D7}\u{4EBA}\u{3068}\u{6709}\u{52B9}\u{306A}\u{5951}\u{7D04}\u{3092}\u{7D50}\u{3093}\u{3067}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C5B4}\u{B5A4} \u{C870}\u{C9C1}\u{B3C4} \u{C120}\u{C815}\u{B41C} \u{D30C}\u{ACAC}\u{C778}\u{ACFC} \u{D65C}\u{C131} \u{ACC4}\u{C57D}\u{C744} \u{B9FA}\u{ACE0} \u{C788}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj ib lub koom haum muaj daim ntawv cog lus nquag nrog tus neeg xaiv tsa.`,
    ps: `\u{647}\u{6CC}\u{685} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62F} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{633}\u{631}\u{647} \u{641}\u{639}\u{627}\u{644} \u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: `Nenhuma organiza\xe7\xe3o possui um contrato ativo com o cession\xe1rio selecionado.`,
    'pt-pt': `Nenhuma organiza\xe7\xe3o tem um contrato ativo com o cession\xe1rio selecionado.`,
    ru: `\u{41D}\u{438} \u{43E}\u{434}\u{43D}\u{430} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{43D}\u{435} \u{438}\u{43C}\u{435}\u{435}\u{442} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{435}\u{433}\u{43E} \u{43A}\u{43E}\u{43D}\u{442}\u{440}\u{430}\u{43A}\u{442}\u{430} \u{441} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{43C} \u{43F}\u{440}\u{430}\u{432}\u{43E}\u{43F}\u{440}\u{435}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{438}\u{43A}\u{43E}\u{43C}.`,
    sm: `E leai se fa'alapotopotoga o lo'o i ai se konekarate fa'apitoa ma le tagata ua filifilia.`,
    so: `Ma jiraan ururo heshiis firfircoon la leh qofka la doortay.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E43}\u{E14}\u{E17}\u{E35}\u{E48}\u{E21}\u{E35}\u{E2A}\u{E31}\u{E0D}\u{E0D}\u{E32}\u{E17}\u{E35}\u{E48}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E01}\u{E31}\u{E1A}\u{E1C}\u{E39}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E17}\u{E35}\u{E48}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}`,
    ur: `\u{6A9}\u{633}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{62F}\u{6C1} \u{627}\u{633}\u{627}\u{626}\u{646}\u{6CC} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{641}\u{639}\u{627}\u{644} \u{645}\u{639}\u{627}\u{6C1}\u{62F}\u{6C1} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{62A}\u{627}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 t\u{1ED5} ch\u{1EE9}c n\xe0o c\xf3 h\u{1EE3}p \u{111}\u{1ED3}ng \u{111}ang ho\u{1EA1}t \u{111}\u{1ED9}ng v\u{1EDB}i ng\u{1B0}\u{1EDD}i \u{111}\u{1B0}\u{1EE3}c chuy\u{1EC3}n nh\u{1B0}\u{1EE3}ng \u{111}\xe3 ch\u{1ECD}n.`,
    'zh-hans': `\u{6CA1}\u{6709}\u{4EFB}\u{4F55}\u{7EC4}\u{7EC7}\u{4E0E}\u{88AB}\u{9009}\u{4E2D}\u{7684}\u{53D7}\u{8BA9}\u{4EBA}\u{7B7E}\u{8BA2}\u{6709}\u{6548}\u{5408}\u{540C}\u{3002}`,
    'zh-hant': `\u{6C92}\u{6709}\u{4EFB}\u{4F55}\u{7D44}\u{7E54}\u{8207}\u{88AB}\u{9078}\u{4E2D}\u{7684}\u{53D7}\u{6D3E}\u{4EBA}\u{54E1}\u{6709}\u{6709}\u{6548}\u{5408}\u{7D04}\u{3002}`,
    en: `No organizations have an active contract with the selected assignee.`
};
const $b11db1b62d4a8f76$export$9ac3dfbd508312f1 = {
    ar: `\u{644}\u{627} \u{64A}\u{648}\u{62C}\u{62F} \u{645}\u{648}\u{638}\u{641}\u{648}\u{646} \u{646}\u{634}\u{637}\u{648}\u{646}`,
    de: `Keine aktiven Mitarbeiter`,
    es: `No hay empleados activos`,
    fa: `\u{647}\u{6CC}\u{686} \u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang aktibong empleyado`,
    fr: `Aucun employ\xe9 actif`,
    hi: `\u{915}\u{94B}\u{908} \u{938}\u{915}\u{94D}\u{930}\u{93F}\u{92F} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen anplwaye aktif`,
    it: `Nessun dipendente attivo`,
    ja: `\u{73FE}\u{5F79}\u{306E}\u{5F93}\u{696D}\u{54E1}\u{306F}\u{3044}\u{306A}\u{3044}`,
    ko: `\u{D604}\u{C5ED} \u{C9C1}\u{C6D0}\u{C740} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj cov neeg ua haujlwm nquag`,
    ps: `\u{647}\u{6CC}\u{685} \u{641}\u{639}\u{627}\u{644} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Nenhum funcion\xe1rio ativo`,
    'pt-pt': `Sem funcion\xe1rios ativos`,
    ru: `\u{41D}\u{435}\u{442} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{438}\u{445} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{43E}\u{432}`,
    sm: `Leai ni tagata faigaluega`,
    so: `Shaqaale firfircoon ma jiraan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{641}\u{639}\u{627}\u{644} \u{645}\u{644}\u{627}\u{632}\u{645} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 nh\xe2n vi\xean t\xedch c\u{1EF1}c`,
    'zh-hans': `\u{6CA1}\u{6709}\u{73B0}\u{5F79}\u{5458}\u{5DE5}`,
    'zh-hant': `\u{6C92}\u{6709}\u{73FE}\u{5F79}\u{54E1}\u{5DE5}`,
    en: `No active employees`
};
const $b11db1b62d4a8f76$export$5815e44228ccc787 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{641}\u{639}\u{627}\u{644}\u{64A}\u{627}\u{62A} \u{646}\u{634}\u{637}\u{629} \u{623}\u{648} \u{642}\u{627}\u{62F}\u{645}\u{629}`,
    de: `Keine aktiven oder bevorstehenden Veranstaltungen`,
    es: `No hay eventos activos ni pr\xf3ximos`,
    fa: `\u{647}\u{6CC}\u{686} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{641}\u{639}\u{627}\u{644} \u{6CC}\u{627} \u{622}\u{6CC}\u{646}\u{62F}\u{647} \u{627}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang aktibo o paparating na mga kaganapan`,
    fr: `Aucun \xe9v\xe9nement actif ou \xe0 venir`,
    hi: `\u{915}\u{94B}\u{908} \u{938}\u{915}\u{94D}\u{930}\u{93F}\u{92F} \u{92F}\u{93E} \u{906}\u{917}\u{93E}\u{92E}\u{940} \u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{915}\u{94D}\u{930}\u{92E} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen ev\xe8nman aktif oswa kap vini`,
    it: `Nessun evento attivo o in arrivo`,
    ja: `\u{73FE}\u{5728}\u{9032}\u{884C}\u{4E2D}\u{306E}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{3084}\u{4ECA}\u{5F8C}\u{306E}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C9C4}\u{D589} \u{C911}\u{C774}\u{AC70}\u{B098} \u{C608}\u{C815}\u{B41C} \u{D589}\u{C0AC}\u{B294} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj active los yog tom ntej no cov txheej xwm`,
    ps: `\u{647}\u{6CC}\u{685} \u{641}\u{639}\u{627}\u{644}\u{647} \u{6CC}\u{627} \u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0} \u{67E}\u{6CC}\u{69A}\u{6D0} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Nenhum evento ativo ou pr\xf3ximo`,
    'pt-pt': `Sem eventos ativos ou futuros`,
    ru: `\u{410}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{44B}\u{445} \u{438}\u{43B}\u{438} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{438}\u{445} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{439} \u{43D}\u{435}\u{442}.`,
    sm: `Leai ni mea e tutupu pe o lo'o lumana'i`,
    so: `Ma jiraan dhacdooyin firfircoon ama soo socda`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E08}\u{E30}\u{E40}\u{E01}\u{E34}\u{E14}\u{E02}\u{E36}\u{E49}\u{E19}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{641}\u{639}\u{627}\u{644} \u{6CC}\u{627} \u{622}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{627} \u{627}\u{6CC}\u{648}\u{646}\u{679} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 s\u{1EF1} ki\u{1EC7}n \u{111}ang ho\u{1EA1}t \u{111}\u{1ED9}ng ho\u{1EB7}c s\u{1EAF}p t\u{1EDB}i`,
    'zh-hans': `\u{6CA1}\u{6709}\u{6B63}\u{5728}\u{8FDB}\u{884C}\u{6216}\u{5373}\u{5C06}\u{4E3E}\u{884C}\u{7684}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{6C92}\u{6709}\u{6D3B}\u{52D5}\u{6216}\u{5373}\u{5C07}\u{8209}\u{8FA6}\u{7684}\u{6D3B}\u{52D5}`,
    en: `No active or upcoming events`
};
const $b11db1b62d4a8f76$export$cabc58d813df6052 = {
    ar: `\u{644}\u{627} \u{623}\u{646}\u{634}\u{637}\u{629}`,
    de: `Keine Aktivit\xe4ten`,
    es: `Sin actividades`,
    fa: `\u{647}\u{6CC}\u{686} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang mga aktibidad`,
    fr: `Aucune activit\xe9`,
    hi: `\u{915}\u{94B}\u{908} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen aktivite`,
    it: `Nessuna attivit\xe0`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{D65C}\u{B3D9} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj kev ua ub no`,
    ps: `\u{647}\u{6CC}\u{685} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem atividades`,
    'pt-pt': `Sem atividades`,
    ru: `\u{41D}\u{438}\u{43A}\u{430}\u{43A}\u{438}\u{445} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{439}`,
    sm: `Leai ni gaoioiga`,
    so: `Hawlo ma jiraan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{65E0}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{7121}\u{6D3B}\u{52D5}`,
    en: `No activities`
};
const $b11db1b62d4a8f76$export$891b945946a1cefd = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{62A}\u{639}\u{631}\u{64A}\u{641}\u{627}\u{62A} \u{646}\u{634}\u{627}\u{637} \u{642}\u{627}\u{628}\u{644}\u{629} \u{644}\u{644}\u{62A}\u{637}\u{628}\u{64A}\u{642}`,
    de: `Keine anwendbaren Aktivit\xe4tsdefinitionen`,
    es: `No hay definiciones de actividades aplicables`,
    fa: `\u{647}\u{6CC}\u{686} \u{62A}\u{639}\u{631}\u{6CC}\u{641} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang naaangkop na mga kahulugan ng aktibidad`,
    fr: `Aucune d\xe9finition d\u{2019}activit\xe9 applicable`,
    hi: `\u{915}\u{94B}\u{908} \u{932}\u{93E}\u{917}\u{942} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930}\u{93F}\u{92D}\u{93E}\u{937}\u{93E} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen definisyon aktivite ki aplikab`,
    it: `Nessuna definizione applicabile di attivit\xe0`,
    ja: `\u{9069}\u{7528}\u{53EF}\u{80FD}\u{306A}\u{6D3B}\u{52D5}\u{5B9A}\u{7FA9}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C801}\u{C6A9} \u{AC00}\u{B2A5}\u{D55C} \u{D65C}\u{B3D9} \u{C815}\u{C758} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj kev txhais ua haujlwm siv tau`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{639}\u{631}\u{6CC}\u{641}\u{648}\u{646}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Nenhuma defini\xe7\xe3o de atividade aplic\xe1vel`,
    'pt-pt': `Sem defini\xe7\xf5es de atividade aplic\xe1veis`,
    ru: `\u{41D}\u{435}\u{442} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{43C}\u{44B}\u{445} \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{439} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `E leai ni faauigaga talafeagai o gaoioiga`,
    so: `Ma jiraan qeexitaanno hawleed oo khuseynaya`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E04}\u{E4D}\u{E32}\u{E08}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E14}\u{E04}\u{E27}\u{E32}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{642}\u{627}\u{628}\u{644} \u{627}\u{637}\u{644}\u{627}\u{642} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6CC} \u{62A}\u{639}\u{631}\u{6CC}\u{641}\u{6CC}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 \u{111}\u{1ECB}nh ngh\u{129}a ho\u{1EA1}t \u{111}\u{1ED9}ng \xe1p d\u{1EE5}ng`,
    'zh-hans': `\u{65E0}\u{9002}\u{7528}\u{7684}\u{6D3B}\u{52A8}\u{5B9A}\u{4E49}`,
    'zh-hant': `\u{7121}\u{9069}\u{7528}\u{7684}\u{6D3B}\u{52D5}\u{5B9A}\u{7FA9}`,
    en: `No applicable activity definitions`
};
const $b11db1b62d4a8f76$export$597b5e961013f9bf = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{646}\u{634}\u{637}\u{629} \u{645}\u{631}\u{62A}\u{628}\u{637}\u{629}`,
    de: `Es gibt keine damit verbundenen Aktivit\xe4ten`,
    es: `No hay actividades asociadas`,
    fa: `\u{647}\u{6CC}\u{686} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{645}\u{631}\u{62A}\u{628}\u{637}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang mga kaugnay na aktibidad`,
    fr: `Il n\u{2019}y a pas d\u{2019}activit\xe9s associ\xe9es`,
    hi: `\u{915}\u{94B}\u{908} \u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}`,
    ht: `Pa gen okenn aktivite ki asosye`,
    it: `Non ci sono attivit\xe0 associate`,
    ja: `\u{95A2}\u{9023}\u{3059}\u{308B}\u{6D3B}\u{52D5}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{AD00}\u{B828} \u{D65C}\u{B3D9}\u{C740} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj kev ua ub no`,
    ps: `\u{647}\u{6CC}\u{685} \u{627}\u{693}\u{648}\u{646}\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o h\xe1 atividades associadas`,
    'pt-pt': `N\xe3o existem atividades associadas`,
    ru: `\u{421}\u{43E}\u{43F}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{438}\u{445} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{435}\u{439} \u{43D}\u{435}\u{442}.`,
    sm: `E leai ni gaioiga e feso'ota'i`,
    so: `Ma jiraan hawlo la xiriira`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ho\u{1EA1}t \u{111}\u{1ED9}ng li\xean quan`,
    'zh-hans': `\u{6CA1}\u{6709}\u{76F8}\u{5173}\u{7684}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{6C92}\u{6709}\u{76F8}\u{95DC}\u{7684}\u{6D3B}\u{52D5}`,
    en: `There are no associated activities`
};
const $b11db1b62d4a8f76$export$f036bc4eb2090575 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{646}\u{634}\u{637}\u{629} \u{645}\u{631}\u{62A}\u{628}\u{637}\u{629} \u{628}\u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629}`,
    de: `Auf dieser Seite gibt es keine zugeh\xf6rigen Aktivit\xe4ten`,
    es: `No hay actividades asociadas en esta p\xe1gina`,
    fa: `\u{647}\u{6CC}\u{686} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{645}\u{631}\u{62A}\u{628}\u{637}\u{6CC} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang mga kaugnay na aktibidad sa pahinang ito`,
    fr: `Aucune activit\xe9 associ\xe9e n\u{2019}est disponible sur cette page`,
    hi: `\u{907}\u{938} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{92A}\u{930} \u{915}\u{94B}\u{908} \u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}`,
    ht: `Pa gen okenn aktivite ki asosye sou paj sa a`,
    it: `Non ci sono attivit\xe0 associate a questa pagina`,
    ja: `\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{306B}\u{306F}\u{95A2}\u{9023}\u{3059}\u{308B}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C774} \u{D398}\u{C774}\u{C9C0}\u{C5D0}\u{B294} \u{AD00}\u{B828} \u{D65C}\u{B3D9}\u{C774} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj cov haujlwm cuam tshuam rau ntawm nplooj ntawv no`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{67E}\u{627}\u{6BC}\u{647} \u{6A9}\u{6D0} \u{647}\u{6CC}\u{685} \u{627}\u{693}\u{648}\u{646}\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o h\xe1 atividades associadas nesta p\xe1gina`,
    'pt-pt': `N\xe3o existem atividades associadas nesta p\xe1gina`,
    ru: `\u{41D}\u{430} \u{44D}\u{442}\u{43E}\u{439} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{435} \u{43D}\u{435}\u{442} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441} \u{44D}\u{442}\u{438}\u{43C} \u{437}\u{430}\u{43D}\u{44F}\u{442}\u{438}\u{439}`,
    sm: `E leai ni gaioiga e feso'ota'i i luga o lenei itulau`,
    so: `Boggan ma jiraan hawlo la xiriira`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E43}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{67E}\u{631} \u{6A9}\u{648}\u{626}\u{6CC} \u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0o \u{111}\u{1B0}\u{1EE3}c li\xean k\u{1EBF}t tr\xean trang n\xe0y`,
    'zh-hans': `\u{672C}\u{9875}\u{65E0}\u{76F8}\u{5173}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{672C}\u{9801}\u{7121}\u{76F8}\u{95DC}\u{6D3B}\u{52D5}`,
    en: `There are no associated activities on this page`
};
const $b11db1b62d4a8f76$export$c2f977e20fcfd8d9 = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{649} \u{645}\u{64A}\u{632}\u{627}\u{646}\u{64A}\u{627}\u{62A}`,
    de: `Keine Budgets gefunden`,
    es: `No se han encontrado presupuestos`,
    fa: `\u{628}\u{648}\u{62F}\u{62C}\u{647} \u{627}\u{6CC} \u{67E}\u{6CC}\u{62F}\u{627} \u{646}\u{634}\u{62F}.`,
    fil: `Walang natagpuang badyet`,
    fr: `Aucun budget trouv\xe9`,
    hi: `\u{915}\u{94B}\u{908} \u{92C}\u{91C}\u{91F} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932}\u{93E}`,
    ht: `Pa gen bidj\xe8 yo te jwenn`,
    it: `Nessun budget trovato`,
    ja: `\u{4E88}\u{7B97}\u{306F}\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}\u{3067}\u{3057}\u{305F}`,
    ko: `\u{C608}\u{C0B0}\u{C740} \u{CC3E}\u{C9C0} \u{BABB}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj peev nyiaj nrhiav tau`,
    ps: `\u{647}\u{6CC}\u{685} \u{628}\u{648}\u{62F}\u{6CC}\u{62C}\u{647} \u{648}\u{646}\u{647} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{634}\u{648}\u{647}`,
    pt: `Nenhum or\xe7amento encontrado`,
    'pt-pt': `Sem or\xe7amentos encontrados`,
    ru: `\u{411}\u{44E}\u{434}\u{436}\u{435}\u{442}\u{43E}\u{432} \u{43D}\u{435} \u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}\u{43E}`,
    sm: `E leai ni paketi na maua`,
    so: `Miisaaniyad lama helin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}\u{E07}\u{E1A}\u{E1B}\u{E23}\u{E30}\u{E21}\u{E32}\u{E13}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{62C}\u{679} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{644}\u{627}`,
    vi: `Kh\xf4ng t\xecm th\u{1EA5}y ng\xe2n s\xe1ch`,
    'zh-hans': `\u{672A}\u{627E}\u{5230}\u{9884}\u{7B97}`,
    'zh-hant': `\u{672A}\u{627E}\u{5230}\u{4EFB}\u{4F55}\u{9810}\u{7B97}`,
    en: `No budgets found`
};
const $b11db1b62d4a8f76$export$cd0535b23494e91b = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{63A}\u{637}\u{64A}\u{629}`,
    de: `Keine Kappen`,
    es: `Sin gorras`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{62F}\u{631}\u{67E}\u{648}\u{634}`,
    fil: `Walang mga takip`,
    fr: `Pas de capuchons`,
    hi: `\u{915}\u{94B}\u{908} \u{91F}\u{94B}\u{92A}\u{940} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen bouchon`,
    it: `Senza cappucci`,
    ja: `\u{5927}\u{6587}\u{5B57}\u{306F}\u{4F7F}\u{308F}\u{306A}\u{3044}`,
    ko: `\u{B300}\u{BB38}\u{C790} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj lub kaus mom`,
    ps: `\u{647}\u{6CC}\u{685} \u{6A9}\u{67E}\u{648}\u{646}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem tampas`,
    'pt-pt': `Sem tampas`,
    ru: `\u{411}\u{435}\u{437} \u{43A}\u{435}\u{43F}\u{43A}\u{43E}\u{432}`,
    sm: `Leai ni pulou`,
    so: `Ma jiraan koobab`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E15}\u{E31}\u{E27}\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E43}\u{E2B}\u{E0D}\u{E48}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{6A9}\u{6CC}\u{67E} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ch\u{1EEF} hoa`,
    'zh-hans': `\u{6CA1}\u{6709}\u{5927}\u{5199}`,
    'zh-hant': `\u{6C92}\u{6709}\u{5927}\u{5BEB}`,
    en: `No caps`
};
const $b11db1b62d4a8f76$export$fe55b45226a83947 = {
    ar: `\u{644}\u{627} \u{64A}\u{648}\u{62C}\u{62F} \u{645}\u{62F}\u{64A}\u{631} \u{62D}\u{627}\u{644}\u{629} \u{645}\u{639}\u{64A}\u{646}`,
    de: `Kein Fallmanager zugewiesen`,
    es: `No hay gestor de caso asignado`,
    fa: `\u{647}\u{6CC}\u{686} \u{645}\u{62F}\u{6CC}\u{631} \u{67E}\u{631}\u{648}\u{646}\u{62F}\u{647} \u{627}\u{6CC} \u{62A}\u{639}\u{6CC}\u{6CC}\u{646} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Walang case manager na nakatalaga`,
    fr: `Aucun gestionnaire de dossier assign\xe9`,
    hi: `\u{915}\u{94B}\u{908} \u{92E}\u{93E}\u{92E}\u{932}\u{93E} \u{92A}\u{94D}\u{930}\u{92C}\u{902}\u{927}\u{915} \u{905}\u{938}\u{93E}\u{907}\u{928} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Pa gen manadj\xe8 ka asiyen`,
    it: `Nessun case manager assegnato`,
    ja: `\u{30B1}\u{30FC}\u{30B9}\u{30DE}\u{30CD}\u{30FC}\u{30B8}\u{30E3}\u{30FC}\u{306F}\u{5272}\u{308A}\u{5F53}\u{3066}\u{3089}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C0AC}\u{B840} \u{AD00}\u{B9AC}\u{C790} \u{BC30}\u{CE58} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj tus neeg saib xyuas rooj plaub`,
    ps: `\u{62F} \u{642}\u{636}\u{6CC}\u{6D0} \u{645}\u{62F}\u{6CC}\u{631} \u{646}\u{647} \u{62F}\u{6CC} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC}`,
    pt: `Nenhum gerente de caso designado`,
    'pt-pt': `Sem gestor de caso atribu\xeddo`,
    ru: `\u{41C}\u{435}\u{43D}\u{435}\u{434}\u{436}\u{435}\u{440} \u{43F}\u{43E} \u{434}\u{435}\u{43B}\u{443} \u{43D}\u{435} \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}`,
    sm: `E leai se pule o mataupu ua tofia`,
    so: `Maareeye kiis lama magacaabin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E1C}\u{E39}\u{E49}\u{E08}\u{E31}\u{E14}\u{E01}\u{E32}\u{E23}\u{E40}\u{E04}\u{E2A}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{6A9}\u{6CC}\u{633} \u{645}\u{6CC}\u{646}\u{6CC}\u{62C}\u{631} \u{645}\u{642}\u{631}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `Kh\xf4ng c\xf3 ng\u{1B0}\u{1EDD}i qu\u{1EA3}n l\xfd h\u{1ED3} s\u{1A1} n\xe0o \u{111}\u{1B0}\u{1EE3}c ch\u{1EC9} \u{111}\u{1ECB}nh`,
    'zh-hans': `\u{6CA1}\u{6709}\u{6307}\u{5B9A}\u{4E2A}\u{6848}\u{7ECF}\u{7406}`,
    'zh-hant': `\u{6C92}\u{6709}\u{6307}\u{6D3E}\u{500B}\u{6848}\u{7BA1}\u{7406}\u{54E1}`,
    en: `No case manager assigned`
};
const $b11db1b62d4a8f76$export$a4ed9e70242756ec = {
    ar: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`للمتابعة، أنشئ السجل من <a href="${parentHref}">${parentType}</a>.`,
    de: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`Um fortzufahren, erstellen Sie den Datensatz aus der <a href="${parentHref}">${parentType}</a>.`,
    es: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`Para continuar, crea el registro a partir de la <a href="${parentHref}">${parentType}</a>.`,
    fa: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`برای ادامه، رکورد را از <a href="${parentHref}">${parentType}</a> ایجاد کنید.`,
    fil: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`Upang magpatuloy, lumikha ng talaan mula sa <a href="${parentHref}">${parentType}</a>.`,
    fr: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`Pour continuer, créez le dossier à partir de la <a href="${parentHref}">${parentType}</a>.`,
    hi: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`जारी रखने के लिए, <a href="${parentHref}">${parentType}</a> से रिकॉर्ड बनाएं।`,
    ht: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`Pou kontinye, kreye dosye a soti nan <a href="${parentHref}">${parentType}</a> la.`,
    it: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`Per continuare, crea il record dal <a href="${parentHref}">${parentType}</a>.`,
    ja: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`続けて、 <a href="${parentHref}">${parentType}</a>から記録を作成してください。`,
    ko: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`계속하려면, <a href="${parentHref}">${parentType}</a>에서 기록을 생성하세요.`,
    mww: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`Txhawm rau txuas ntxiv, tsim cov ntaub ntawv los ntawm <a href="${parentHref}">${parentType}</a>.`,
    ps: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`د دوام لپاره، د <a href="${parentHref}">${parentType}</a> کولو ریکارډ جوړ کړئ.`,
    pt: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`Para continuar, crie o registro a partir do <a href="${parentHref}">${parentType}</a>.`,
    'pt-pt': (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`Para continuar, crie o registo a partir do <a href="${parentHref}">${parentType}</a>.`,
    ru: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`Чтобы продолжить, создайте запись по <a href="${parentHref}">${parentType}</a>.`,
    sm: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`Ina ia fa'aauau, fa'apipi'i le fa'amaumauga mai le <a href="${parentHref}">${parentType}</a>.`,
    so: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`Si aad u sii waddo, samee diiwaanka <a href="${parentHref}">${parentType}</a>.`,
    th: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`หากต้องการดําเนินการต่อ ให้สร้างบันทึกจากการ<a href="${parentHref}">${parentType}</a>`,
    ur: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`آگے بڑھنے کے لیے، <a href="${parentHref}">${parentType}</a> سے ریکارڈ تیار کریں۔`,
    vi: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`Để tiếp tục, hãy tạo bản ghi từ <a href="${parentHref}">${parentType}</a>.`,
    'zh-hans': (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`继续，从 <a href="${parentHref}">${parentType}</a>中创建记录。`,
    'zh-hant': (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`繼續，請從 <a href="${parentHref}">${parentType}</a>建立紀錄。`,
    en: (parentHref, parentType)=>$b11db1b62d4a8f76$var$html`To continue, create the record from the <a href="${parentHref}">${parentType}</a>.`
};
const $b11db1b62d4a8f76$export$cc22a6e93b844310 = {
    ar: (type)=>`${type} \u{644}\u{627} \u{62A}\u{633}\u{645}\u{62D} \u{628}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{623}\u{637}\u{641}\u{627}\u{644}`,
    de: (type)=>`Die ${type} erlaubt keine Aktivit\xe4ten f\xfcr Kinder`,
    es: (type)=>`La ${type} no permite actividades infantiles`,
    fa: (type)=>`${type} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{6A9}\u{648}\u{62F}\u{6A9}\u{627}\u{646} \u{631}\u{627} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}`,
    fil: (type)=>`Hindi pinapayagan ng ${type} ang mga aktibidad ng bata`,
    fr: (type)=>`La ${type} n\u{2019}autorise pas les activit\xe9s pour enfants`,
    hi: (type)=>`${type} \u{92C}\u{91A}\u{94D}\u{91A}\u{947} \u{915}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{928}\u{939}\u{940}\u{902} \u{926}\u{947}\u{924}\u{93E} \u{939}\u{948}`,
    ht: (type)=>`${type} pa p\xe8m\xe8t aktivite timoun yo`,
    it: (type)=>`Il ${type} non consente attivit\xe0 per bambini`,
    ja: (type)=>`${type} \u{5B50}\u{3069}\u{3082}\u{306E}\u{6D3B}\u{52D5}\u{3092}\u{8A31}\u{53EF}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
    ko: (type)=>`${type} \u{C544}\u{B3D9} \u{D65C}\u{B3D9}\u{C744} \u{D5C8}\u{C6A9}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: (type)=>`Kev ${type} tsis pub ua si rau menyuam yaus`,
    ps: (type)=>`${type} \u{6A9}\u{648}\u{644} \u{62F} \u{645}\u{627}\u{634}\u{648}\u{645}\u{627}\u{646}\u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{648} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{647} \u{648}\u{631}\u{6A9}\u{648}\u{6CC}`,
    pt: (type)=>`${type} n\xe3o permite atividades infantis`,
    'pt-pt': (type)=>`${type} n\xe3o permite atividades para crian\xe7as`,
    ru: (type)=>`${type} \u{43D}\u{430} \u{434}\u{43E}\u{43C} \u{43D}\u{435} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{430}\u{435}\u{442} \u{437}\u{430}\u{43D}\u{44F}\u{442}\u{438}\u{44F} \u{441} \u{434}\u{435}\u{442}\u{44C}\u{43C}\u{438}`,
    sm: (type)=>`E le fa'atagaina e le ${type} gaioiga a tamaiti`,
    so: (type)=>`${type} lagu keeno ma oggola hawlaha carruurta`,
    th: (type)=>`\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}${type}\u{E44}\u{E21}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E40}\u{E14}\u{E47}\u{E01}`,
    ur: (type)=>`${type} \u{628}\u{686}\u{648}\u{6BA} \u{6A9}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{648}\u{6BA} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{62F}\u{6CC}\u{62A}\u{6CC}`,
    vi: (type)=>`Gi\u{1EDB}i ${type} kh\xf4ng cho ph\xe9p c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng c\u{1EE7}a tr\u{1EBB} em`,
    'zh-hans': (type)=>`\u{9001}${type}\u{4E0D}\u{5141}\u{8BB8}\u{513F}\u{7AE5}\u{53C2}\u{4E0E}\u{6D3B}\u{52A8}`,
    'zh-hant': (type)=>`\u{9001}${type}\u{4E0D}\u{5141}\u{8A31}\u{5152}\u{7AE5}\u{6D3B}\u{52D5}`,
    en: (type)=>`${type} does not permit child activities`
};
const $b11db1b62d4a8f76$export$a860e676d405bc34 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{646}\u{634}\u{637}\u{629} \u{645}\u{63A}\u{644}\u{642}\u{629}`,
    de: `Keine geschlossenen Aktivit\xe4ten`,
    es: `No hay actividades cerradas`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{628}\u{633}\u{62A}\u{647} \u{645}\u{645}\u{646}\u{648}\u{639}`,
    fil: `Walang saradong aktibidad`,
    fr: `Aucune activit\xe9 ferm\xe9e`,
    hi: `\u{915}\u{94B}\u{908} \u{92C}\u{902}\u{926} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen aktivite f\xe8men`,
    it: `Niente attivit\xe0 chiuse`,
    ja: `\u{9589}\u{9396}\u{3055}\u{308C}\u{305F}\u{6D3B}\u{52D5}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{D3D0}\u{C1C4} \u{D65C}\u{B3D9}\u{C740} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj kev ua ub no kaw`,
    ps: `\u{647}\u{6CC}\u{685} \u{62A}\u{693}\u{644}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Nenhuma atividade fechada`,
    'pt-pt': `Sem atividades encerradas`,
    ru: `\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{435} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F} \u{437}\u{430}\u{43F}\u{440}\u{435}\u{449}\u{435}\u{43D}\u{44B}`,
    sm: `Leai ni gaoioiga tapunia`,
    so: `Ma jiraan hawlo xiran`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E1B}\u{E34}\u{E14}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{646}\u{62F} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\xf3ng c\u{1EED}a`,
    'zh-hans': `\u{7981}\u{6B62}\u{95ED}\u{95E8}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{7981}\u{6B62}\u{9589}\u{9580}\u{6D3B}\u{52D5}`,
    en: `No closed activities`
};
const $b11db1b62d4a8f76$export$5810e207609e8996 = {
    ar: (org, activityTitle)=>`\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{646}\u{634}\u{637}\u{629} ${activityTitle} \u{641}\u{64A} ${org}.`,
    de: (org, activityTitle)=>`${org} hat keine Aktivit\xe4ten f\xfcr ${activityTitle} geplant.`,
    es: (org, activityTitle)=>`${org} no tiene actividades programadas para ${activityTitle} .`,
    fa: (org, activityTitle)=>`\u{645}\u{631}\u{6A9}\u{632} ${org} \u{647}\u{6CC}\u{686} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} ${activityTitle} \u{628}\u{631}\u{646}\u{627}\u{645}\u{647} \u{631}\u{6CC}\u{632}\u{6CC} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: (org, activityTitle)=>`Ang ${org} ay walang naka-iskedyul na mga aktibidad sa ${activityTitle}.`,
    fr: (org, activityTitle)=>`${org} n\u{2019}a pas d\u{2019}activit\xe9s de ${activityTitle} programm\xe9es.`,
    hi: (org, activityTitle)=>`${org} \u{915}\u{94B}\u{908} ${activityTitle} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{902} \u{928}\u{93F}\u{930}\u{94D}\u{927}\u{93E}\u{930}\u{93F}\u{924} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}\u{964}`,
    ht: (org, activityTitle)=>`${org} pa gen okenn ${activityTitle} pwograme.`,
    it: (org, activityTitle)=>`${org} non prevede attivit\xe0 di ${activityTitle} .`,
    ja: (org, activityTitle)=>`${org} \u{30F3}\u{30B0}\u{306F} ${activityTitle} \u{306E}\u{6D3B}\u{52D5}\u{3092}\u{4E88}\u{5B9A}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (org, activityTitle)=>`${org} ${activityTitle} \u{D65C}\u{B3D9}\u{C774} \u{C608}\u{C815}\u{B418}\u{C5B4} \u{C788}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (org, activityTitle)=>`${org} tsis muaj cov haujlwm hauv tsev ${activityTitle} tau teem tseg.`,
    ps: (org, activityTitle)=>`${org} \u{62F} ${activityTitle} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{645}\u{647}\u{627}\u{644}\u{648}\u{6CC}\u{634} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: (org, activityTitle)=>`${org} n\xe3o tem atividades ${activityTitle} .`,
    'pt-pt': (org, activityTitle)=>`${org} n\xe3o tem atividades ${activityTitle} .`,
    ru: (org, activityTitle)=>`${org} \u{43D}\u{435}\u{442} \u{437}\u{430}\u{43F}\u{43B}\u{430}\u{43D}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{445} ${activityTitle} .`,
    sm: (org, activityTitle)=>`${org} e leai ni gaioiga a le ${activityTitle} o tui ua fa'atulagaina.`,
    so: (org, activityTitle)=>`${org} ma laha hawlo ${activityTitle} oo la qorsheeyay.`,
    th: (org, activityTitle)=>`${org} \u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}${activityTitle}`,
    ur: (org, activityTitle)=>`${org} \u{645}\u{6CC}\u{6BA} ${activityTitle} \u{6A9}\u{6CC} \u{6A9}\u{648}\u{626}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{634}\u{6CC}\u{688}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (org, activityTitle)=>`${org} kh\xf4ng c\xf3 ho\u{1EA1}t \u{111}\u{1ED9}ng ${activityTitle} n\xe0o \u{111}\u{1B0}\u{1EE3}c l\xean l\u{1ECB}ch.`,
    'zh-hans': (org, activityTitle)=>`\u{6CB3}${org}\u{4E2D}\u{5FC3}\u{6CA1}\u{6709}\u{5B89}\u{6392}${activityTitle}\u{6D3B}\u{52A8}\u{3002}`,
    'zh-hant': (org, activityTitle)=>`${org} \u{76EE}\u{524D}\u{6C92}\u{6709}\u{75AB}\u{82D7} ${activityTitle} \u{6D3B}\u{52D5}\u{5B89}\u{6392}\u{3002}`,
    en: (org, activityTitle)=>`${org} has no ${activityTitle} activities scheduled.`
};
const $b11db1b62d4a8f76$export$2bd44f364b60a031 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{644}\u{648}\u{62D}\u{627}\u{62A} \u{62A}\u{62D}\u{643}\u{645}`,
    de: `Keine Dashboards`,
    es: `Sin salpicaderos`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F}`,
    fil: `Walang mga dashboard`,
    fr: `Pas de tableaux de bord`,
    hi: `\u{915}\u{94B}\u{908} \u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen tablodb\xf2`,
    it: `Nessuna cruscotta`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{306F}\u{306A}\u{3057}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj dashboards`,
    ps: `\u{647}\u{6CC}\u{685} \u{689}\u{634}\u{628}\u{648}\u{631}\u{689} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem pain\xe9is de controle`,
    'pt-pt': `Sem tabliers`,
    ru: `\u{41D}\u{435}\u{442} \u{434}\u{430}\u{448}\u{431}\u{43E}\u{440}\u{434}\u{43E}\u{432}`,
    sm: `Leai ni dashboard`,
    so: `Ma jiraan dashboards`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688}\u{632} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 b\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n`,
    'zh-hans': `\u{6CA1}\u{6709}\u{4EEA}\u{8868}\u{76D8}`,
    'zh-hant': `\u{6C92}\u{6709}\u{5100}\u{8868}\u{677F}`,
    en: `No dashboards`
};
const $b11db1b62d4a8f76$export$e2af1ceb767bc9f2 = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{625}\u{646}\u{634}\u{627}\u{621} \u{623}\u{64A} \u{644}\u{648}\u{62D}\u{627}\u{62A} \u{62A}\u{62D}\u{643}\u{645} \u{62D}\u{62A}\u{649} \u{627}\u{644}\u{622}\u{646}.`,
    de: `Es wurden noch keine Dashboards erstellt.`,
    es: `A\xfan no se han creado paneles de control.`,
    fa: `\u{647}\u{646}\u{648}\u{632} \u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F}\u{6CC} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Wala pang mga dashboard na nilikha.`,
    fr: `Aucun tableau de bord n\u{2019}a encore \xe9t\xe9 cr\xe9\xe9.`,
    hi: `\u{905}\u{92D}\u{940} \u{924}\u{915} \u{915}\u{94B}\u{908} \u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{928}\u{939}\u{940}\u{902} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Pa gen tablodb\xf2 yo te kreye ank\xf2.`,
    it: `Non sono ancora state create dashboard.`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{306F}\u{307E}\u{3060}\u{4F5C}\u{6210}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C544}\u{C9C1} \u{B300}\u{C2DC}\u{BCF4}\u{B4DC}\u{B294} \u{B9CC}\u{B4E4}\u{C5B4}\u{C9C0}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj dashboards tsis tau tsim.`,
    ps: `\u{62A}\u{631} \u{627}\u{648}\u{633}\u{647} \u{647}\u{6CC}\u{685} \u{689}\u{634}\u{628}\u{648}\u{631}\u{689} \u{646}\u{647} \u{62F}\u{6CC} \u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}.`,
    pt: `Ainda n\xe3o foram criados dashboards.`,
    'pt-pt': `Ainda n\xe3o foram criados dashboards.`,
    ru: `\u{41F}\u{43E}\u{43A}\u{430} \u{43D}\u{435} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{44B} \u{434}\u{430}\u{448}\u{431}\u{43E}\u{440}\u{434}\u{44B}.`,
    sm: `E le'i faia ni dashboard i le taimi nei.`,
    so: `Dashboards weli lama abuurin.`,
    th: `\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}`,
    ur: `\u{627}\u{628}\u{6BE}\u{6CC} \u{62A}\u{6A9} \u{6A9}\u{648}\u{626}\u{6CC} \u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{628}\u{646}\u{627}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}\u{6D4}`,
    vi: `Ch\u{1B0}a c\xf3 b\u{1EA3}ng th\xf4ng tin n\xe0o \u{111}\u{1B0}\u{1EE3}c t\u{1EA1}o.`,
    'zh-hans': `\u{76EE}\u{524D}\u{8FD8}\u{6CA1}\u{6709}\u{521B}\u{5EFA}\u{4EFB}\u{4F55}\u{4EEA}\u{8868}\u{76D8}\u{3002}`,
    'zh-hant': `\u{76EE}\u{524D}\u{9084}\u{6C92}\u{6709}\u{5EFA}\u{7ACB}\u{5100}\u{8868}\u{677F}\u{3002}`,
    en: `No dashboards have been created yet.`
};
const $b11db1b62d4a8f76$export$31d8741dfa1c43a7 = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{645}\u{634}\u{627}\u{631}\u{643}\u{629} \u{623}\u{64A} \u{644}\u{648}\u{62D}\u{627}\u{62A} \u{62A}\u{62D}\u{643}\u{645} \u{645}\u{639}\u{643}.`,
    de: `Es wurden keine Dashboards mit Ihnen geteilt.`,
    es: `No se ha compartido ning\xfan panel contigo.`,
    fa: `\u{647}\u{6CC}\u{686} \u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F}\u{6CC} \u{628}\u{627} \u{634}\u{645}\u{627} \u{628}\u{647} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6AF}\u{630}\u{627}\u{634}\u{62A}\u{647} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Walang mga dashboard na ibinahagi sa iyo.`,
    fr: `Aucun tableau de bord ne vous a \xe9t\xe9 communiqu\xe9.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{938}\u{93E}\u{925} \u{915}\u{94B}\u{908} \u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{938}\u{93E}\u{91D}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Pa gen tablodb\xf2 yo te pataje av\xe8k ou.`,
    it: `Non ti sono state condivise dashboard.`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{306F}\u{5171}\u{6709}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC}\u{B294} \u{ACF5}\u{C720}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj dashboards tau muab qhia rau koj.`,
    ps: `\u{647}\u{6CC}\u{685} \u{689}\u{634}\u{628}\u{648}\u{631}\u{689} \u{644}\u{647} \u{62A}\u{627}\u{633}\u{648} \u{633}\u{631}\u{647} \u{646}\u{647} \u{62F}\u{6CC} \u{634}\u{631}\u{6CC}\u{6A9} \u{634}\u{648}\u{6CC}.`,
    pt: `Nenhum painel foi compartilhado com voc\xea.`,
    'pt-pt': `Nenhum painel de controlo foi partilhado consigo.`,
    ru: `\u{421} \u{432}\u{430}\u{43C}\u{438} \u{43D}\u{435} \u{434}\u{435}\u{43B}\u{44F}\u{442}\u{441}\u{44F} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{438} \u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}.`,
    sm: `E leai ni fa'ata'ita'iga na tufatufaina atu ia te oe.`,
    so: `Dashboards laguma wadaagin adiga.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E41}\u{E0A}\u{E23}\u{E4C}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E01}\u{E31}\u{E1A}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{6A9}\u{648}\u{626}\u{6CC} \u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688} \u{634}\u{6CC}\u{626}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 b\u{1EA3}ng th\xf4ng tin n\xe0o \u{111}\u{1B0}\u{1EE3}c chia s\u{1EBB} v\u{1EDB}i b\u{1EA1}n.`,
    'zh-hans': `\u{6CA1}\u{6709}\u{4EFB}\u{4F55}\u{4EEA}\u{8868}\u{76D8}\u{88AB}\u{5206}\u{4EAB}\u{7ED9}\u{4F60}\u{3002}`,
    'zh-hant': `\u{6C92}\u{6709}\u{4EFB}\u{4F55}\u{5100}\u{8868}\u{677F}\u{88AB}\u{5206}\u{4EAB}\u{7D66}\u{4F60}\u{3002}`,
    en: `No dashboards have been shared with you.`
};
const $b11db1b62d4a8f76$export$c3b2af361dc85df7 = {
    ar: `\u{644}\u{627} \u{64A}\u{648}\u{62C}\u{62F} \u{62A}\u{648}\u{642}\u{64A}\u{639} \u{627}\u{641}\u{62A}\u{631}\u{627}\u{636}\u{64A}`,
    de: `Keine Standardsignatur`,
    es: `Sin firma predeterminada`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636}`,
    fil: `Walang default na lagda`,
    fr: `Pas de signature par d\xe9faut`,
    hi: `\u{915}\u{94B}\u{908} \u{921}\u{93F}\u{92B}\u{93C}\u{949}\u{932}\u{94D}\u{91F} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen siyati default`,
    it: `Nessuna firma predefinita`,
    ja: `\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}\u{306E}\u{7F72}\u{540D}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{AE30}\u{BCF8} \u{C11C}\u{BA85}\u{C740} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj lub neej ntawd kos npe`,
    ps: `\u{647}\u{6CC}\u{685} \u{689}\u{6CC}\u{641}\u{627}\u{644}\u{67C} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem assinatura padr\xe3o`,
    'pt-pt': `Sem assinatura padr\xe3o`,
    ru: `\u{41D}\u{435}\u{442} \u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438}`,
    sm: `E leai se saini faaletonu`,
    so: `Ma jiro saxiix default ah`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{688}\u{6CC}\u{641}\u{627}\u{644}\u{679} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ch\u{1EEF} k\xfd m\u{1EB7}c \u{111}\u{1ECB}nh`,
    'zh-hans': `\u{6CA1}\u{6709}\u{9ED8}\u{8BA4}\u{7B7E}\u{540D}`,
    'zh-hant': `\u{6C92}\u{6709}\u{9810}\u{8A2D}\u{7C3D}\u{540D}`,
    en: `No default signature`
};
const $b11db1b62d4a8f76$export$4f405bdda60d10a2 = {
    ar: $b11db1b62d4a8f76$var$html`ليس لديك توقيع افتراضي بعد. استخدم زر التوقيع لتوقيع النشاط وحدد خيار <em>جعل هذا المربع الافتراضي لحفظ</em> التوقيع للاستخدام المستقبلي.`,
    de: $b11db1b62d4a8f76$var$html`Du hast noch keine Standardsignatur. Benutze die Unterschrift-Schaltfläche, um die Aktivität zu signieren, und aktiviere <em>das Feld "Mach dies zu meiner Standardsignatur",</em> um die Signatur für die Zukunft zu speichern.`,
    es: $b11db1b62d4a8f76$var$html`Aún no tienes una firma predeterminada. Usa el botón de firmar para firmar la actividad y marca la <em>casilla de hacer que esta sea mi firma predeterminada</em> para guardar la firma para uso futuro.`,
    fa: $b11db1b62d4a8f76$var$html`شما هنوز امضای پیش فرض ندارید. از دکمه امضا برای امضای فعالیت استفاده کنید و گزینه « <em>این را به عنوان امضای پیش فرض من بسازم</em> » را علامت بزنید تا امضا را برای استفاده های بعدی ذخیره کنید.`,
    fil: $b11db1b62d4a8f76$var$html`Wala ka pa ring default signature. Gamitin ang sign button para lagdaan ang aktibidad at lagyan ng tsek ang <em>kahon na gawing default kong lagda ito</em> para mai-save ang lagda para magamit sa hinaharap.`,
    fr: $b11db1b62d4a8f76$var$html`Vous n’avez pas encore de signature par défaut. Utilisez le bouton de signature pour signer l’activité et cochez la case <em>« faire de cette signature » ma signature par défaut</em> pour sauvegarder la signature pour une utilisation ultérieure.`,
    hi: $b11db1b62d4a8f76$var$html`आपके पास अभी तक कोई डिफ़ॉल्ट हस्ताक्षर नहीं है. गतिविधि पर हस्ताक्षर करने के लिए साइन बटन का उपयोग करें और भविष्य में उपयोग के लिए हस्ताक्षर को सहेजने के लिए <em>इसे मेरा डिफ़ॉल्ट हस्ताक्षर बनाएं</em> बॉक्स को चेक करें।`,
    ht: $b11db1b62d4a8f76$var$html`Ou pa gen yon siyati default ankò. Sèvi ak bouton an siyen siyen aktivite a epi tcheke la fè sa a bwat <em>siyati default mwen</em> an pou konsève pou siyati a pou itilizasyon nan lavni.`,
    it: $b11db1b62d4a8f76$var$html`Non hai ancora una firma predefinita. Usa il pulsante di firma per firmare l'attività e seleziona la casella <em>''fai questa firma di default</em> ' per salvarla per un uso futuro.`,
    ja: $b11db1b62d4a8f76$var$html`まだデフォルトの署名は持っていません。署名ボタンを使って活動に署名し、「 <em>これをデフォルトの署名にする</em> 」ボックスにチェックを入れて、署名を保存して後回の使用に使ってください。`,
    ko: $b11db1b62d4a8f76$var$html`아직 기본 서명이 없으신 거예요. 서명 버튼을 사용해 활동에 서명하고, 서명을 저장하기 위해 ' <em>이 항목을 기본 서명으로 만들기</em> ' 박스를 체크하세요.`,
    mww: $b11db1b62d4a8f76$var$html`Koj tseem tsis tau kos npe rau lub neej ntawd. Siv lub pob kos npe kos npe rau qhov kev ua ub no thiab khij <em>qhov ua qhov no kuv lub neej ntawd kos npe</em> lub thawv kom txuag tau kos npe rau yav tom ntej siv.`,
    ps: $b11db1b62d4a8f76$var$html`ته لا هم اصلی لاسلیک نه لرې. د فعالیت لاسلیک لپاره د نښې تڼۍ وکاروئ او د ' <em>دا زما د اصلی لاسلیک</em> بکس کړئ' وټاکئ ترڅو لاسلیک د راتلونکی کارونې لپاره وساتم.`,
    pt: $b11db1b62d4a8f76$var$html`Você ainda não tem uma assinatura padrão. Use o botão de assinar para assinar a atividade e marque a caixa <em>''faça essa minha assinatura padrão</em> ' para salvar a assinatura para uso futuro.`,
    'pt-pt': $b11db1b62d4a8f76$var$html`Ainda não tens uma assinatura por defeito. Usa o botão de assinar para assinar a atividade e marca a caixa <em>de 'fazer esta a minha assinatura predefinida</em> ' para guardar a assinatura para uso futuro.`,
    ru: $b11db1b62d4a8f76$var$html`У вас ещё нет стандартной подписи. Используйте кнопку подписи, чтобы подписать активность, и поставьте галочку « <em>сделать это моей стандартной подписью</em> », чтобы сохранить подпись для будущего использования.`,
    sm: $b11db1b62d4a8f76$var$html`E te le'i mauaina se saini faaletonu i le taimi nei. Faaaoga le faamau faailoga e saini ai le gaoioiga ma siaki le pusa ia <em>avea lenei ma la'u saini faaletonu</em> e sefe ai le saini mo le faaaogaina i le lumanai.`,
    so: $b11db1b62d4a8f76$var$html`Weli ma haysatid saxiix caadi ah. Isticmaal badhanka saxiixa si aad u saxiixdo hawsha oo hubiso <em>sanduuqa 'make this my default signature</em> si loo keydiyo saxiixa mustaqbalka.`,
    th: $b11db1b62d4a8f76$var$html`คุณยังไม่มีลายเซ็นเริ่มต้น ใช้ปุ่มลงชื่อเข้าใช้เพื่อลงนามในกิจกรรมและทําเครื่องหมายที่ช่อง <em>ทําให้เป็นลายเซ็นเริ่มต้นของฉัน</em> เพื่อบันทึกลายเซ็นเพื่อใช้ในอนาคต`,
    ur: $b11db1b62d4a8f76$var$html`آپ کے پاس ابھی تک ڈیفالٹ دستخط نہیں ہیں۔ سائن بٹن استعمال کریں تاکہ ایکٹیویٹی پر دستخط کریں اور ' <em>Make This my default signature</em> box' کو چیک کریں تاکہ دستخط مستقبل کے لیے محفوظ رہیں۔`,
    vi: $b11db1b62d4a8f76$var$html`Bạn chưa có chữ ký mặc định. Sử dụng nút ký để ký hoạt động và chọn hộp <em>đặt chữ ký mặc định này của tôi</em> để lưu chữ ký để sử dụng trong tương lai.`,
    'zh-hans': $b11db1b62d4a8f76$var$html`你还没有默认签名。使用签名按钮签署活动，并勾选 <em>“设为默认签名</em> ”框以保存签名以备将来使用。`,
    'zh-hant': $b11db1b62d4a8f76$var$html`你還沒有預設簽名。使用簽名按鈕簽署活動，並勾選 <em>「設為我的預設簽名</em> 」方框，以保存簽名以備未來使用。`,
    en: $b11db1b62d4a8f76$var$html`You don't have a default signature yet. Use the sign button to sign the activity and check the <em>make this my default signature</em> box to save the signature for future use.`
};
const $b11db1b62d4a8f76$export$e115406b3def244 = {
    ar: `\u{644}\u{627} \u{645}\u{634}\u{627}\u{631}\u{643}\u{627}\u{62A}`,
    de: `Keine Eintr\xe4ge`,
    es: `No participaciones`,
    fa: `\u{647}\u{6CC}\u{686} \u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{627}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Email Address *`,
    fr: `Aucune participation`,
    hi: `\u{915}\u{94B}\u{908} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F}\u{92F}\u{93E}\u{901} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen antre`,
    it: `Nessuna partecipazione`,
    ja: `\u{30A8}\u{30F3}\u{30C8}\u{30EA}\u{30FC}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{CD9C}\u{D488} \u{AE08}\u{C9C0}`,
    mww: `Tsis muaj nkag`,
    ps: `\u{647}\u{6CC}\u{685} \u{6AB}\u{689}\u{648}\u{646} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem inscri\xe7\xf5es`,
    'pt-pt': `Sem inscri\xe7\xf5es`,
    ru: `\u{417}\u{430}\u{44F}\u{432}\u{43E}\u{43A} \u{43D}\u{435}\u{442}`,
    sm: `Leai ni fa'amatalaga`,
    so: `Ma jiraan wax ka qaybgal ah`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C}\u{627}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 m\u{1EE5}c nh\u{1EAD}p`,
    'zh-hans': `\u{65E0}\u{6761}\u{76EE}`,
    'zh-hant': `\u{7121}\u{689D}\u{76EE}`,
    en: `No entries`
};
const $b11db1b62d4a8f76$export$1392407ab41a66ad = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{649} \u{623}\u{62D}\u{62F}\u{627}\u{62B}`,
    de: `Keine Ereignisse gefunden`,
    es: `No se han encontrado eventos`,
    fa: `\u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{6CC} \u{6CC}\u{627}\u{641}\u{62A} \u{646}\u{634}\u{62F}`,
    fil: `Walang natagpuang kaganapan`,
    fr: `Aucun \xe9v\xe9nement trouv\xe9`,
    hi: `\u{915}\u{94B}\u{908} \u{908}\u{935}\u{947}\u{902}\u{91F} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932}\u{93E}`,
    ht: `Pa gen ev\xe8nman yo te jwenn`,
    it: `Nessun evento trovato`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306F}\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}\u{3067}\u{3057}\u{305F}`,
    ko: `\u{C0AC}\u{AC74}\u{C740} \u{BC1C}\u{ACAC}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis pom kev tshwm sim`,
    ps: `\u{647}\u{6CC}\u{685} \u{67E}\u{6D0}\u{69A}\u{647} \u{648}\u{646}\u{647} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{634}\u{648}\u{647}`,
    pt: `Nenhum evento encontrado`,
    'pt-pt': `Nenhum evento encontrado`,
    ru: `\u{421}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{439} \u{43D}\u{435} \u{43E}\u{431}\u{43D}\u{430}\u{440}\u{443}\u{436}\u{435}\u{43D}\u{43E}`,
    sm: `E leai ni mea na tutupu na maua`,
    so: `Wax dhacdooyin ah lama helin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}\u{E40}\u{E2B}\u{E15}\u{E38}\u{E01}\u{E32}\u{E23}\u{E13}\u{E4C}\u{E43}\u{E14} \u{E46}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{648}\u{627}\u{642}\u{639}\u{6C1} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{644}\u{627}`,
    vi: `Kh\xf4ng t\xecm th\u{1EA5}y s\u{1EF1} ki\u{1EC7}n n\xe0o`,
    'zh-hans': `\u{672A}\u{53D1}\u{73B0}\u{4E8B}\u{4EF6}`,
    'zh-hant': `\u{672A}\u{767C}\u{73FE}\u{4E8B}\u{4EF6}`,
    en: `No events found`
};
const $b11db1b62d4a8f76$export$b167159b5ac99a42 = {
    ar: `\u{62D}\u{627}\u{648}\u{644} \u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{623}\u{648} \u{645}\u{633}\u{62D} \u{648}\u{627}\u{62D}\u{62F} \u{623}\u{648} \u{623}\u{643}\u{62B}\u{631} \u{645}\u{646} \u{641}\u{644}\u{627}\u{62A}\u{631} \u{627}\u{644}\u{628}\u{62D}\u{62B}.`,
    de: `Versuche, einen oder mehrere Suchfilter zu \xe4ndern oder zu l\xf6schen.`,
    es: `Prueba a cambiar o borrar uno o m\xe1s filtros de b\xfasqueda.`,
    fa: `\u{633}\u{639}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{6CC}\u{6A9} \u{6CC}\u{627} \u{686}\u{646}\u{62F} \u{641}\u{6CC}\u{644}\u{62A}\u{631} \u{62C}\u{633}\u{62A}\u{62C}\u{648} \u{631}\u{627} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{62F}\u{647}\u{6CC}\u{62F} \u{6CC}\u{627} \u{67E}\u{627}\u{6A9} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Subukang baguhin o i-clear ang isa o higit pang search filters.`,
    fr: `Essayez de changer ou de supprimer un ou plusieurs filtres de recherche.`,
    hi: `\u{90F}\u{915} \u{92F}\u{93E} \u{905}\u{927}\u{93F}\u{915} \u{916}\u{94B}\u{91C} \u{92B}\u{93C}\u{93F}\u{932}\u{94D}\u{91F}\u{930} \u{92C}\u{926}\u{932}\u{928}\u{947} \u{92F}\u{93E} \u{938}\u{93E}\u{92B}\u{93C} \u{915}\u{930}\u{928}\u{947} \u{915}\u{93E} \u{92A}\u{94D}\u{930}\u{92F}\u{93E}\u{938} \u{915}\u{930}\u{947}\u{902}.`,
    ht: `Eseye chanje oswa netwaye youn oswa plis filt\xe8 rech\xe8ch.`,
    it: `Prova a cambiare o cancellare uno o pi\xf9 filtri di ricerca.`,
    ja: `\u{691C}\u{7D22}\u{30D5}\u{30A3}\u{30EB}\u{30BF}\u{30FC}\u{3092}1\u{3064}\u{4EE5}\u{4E0A}\u{5909}\u{66F4}\u{307E}\u{305F}\u{306F}\u{30AF}\u{30EA}\u{30A2}\u{3057}\u{3066}\u{307F}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{D558}\u{B098} \u{C774}\u{C0C1}\u{C758} \u{AC80}\u{C0C9} \u{D544}\u{D130}\u{B97C} \u{BCC0}\u{ACBD}\u{D558}\u{AC70}\u{B098} \u{C9C0}\u{C6CC}\u{BCF4}\u{C138}\u{C694}.`,
    mww: `Sim hloov lossis tshem tawm ib lossis ntau qhov lim tshawb nrhiav.`,
    ps: `\u{6CC}\u{648} \u{6CC}\u{627} \u{685}\u{648} \u{644}\u{67C}\u{648}\u{646} \u{641}\u{644}\u{67C}\u{631}\u{648}\u{646}\u{647} \u{628}\u{62F}\u{644} \u{6CC}\u{627} \u{67E}\u{627}\u{6A9} \u{6A9}\u{693}\u{626}.`,
    pt: `Tente mudar ou limpar um ou mais filtros de busca.`,
    'pt-pt': `Tente mudar ou apagar um ou mais filtros de pesquisa.`,
    ru: `\u{41F}\u{43E}\u{43F}\u{440}\u{43E}\u{431}\u{443}\u{439}\u{442}\u{435} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{438}\u{43B}\u{438} \u{43E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{43E}\u{434}\u{438}\u{43D} \u{438}\u{43B}\u{438} \u{43D}\u{435}\u{441}\u{43A}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{444}\u{438}\u{43B}\u{44C}\u{442}\u{440}\u{43E}\u{432} \u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430}.`,
    sm: `Taumafai e sui pe kilia se tasi pe sili atu faamama o sailiga.`,
    so: `Isku day inaad beddesho ama ka saarto hal ama in ka badan shaandhada raadinta.`,
    th: `\u{E25}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E25}\u{E35}\u{E48}\u{E22}\u{E19}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E25}\u{E49}\u{E32}\u{E07}\u{E15}\u{E31}\u{E27}\u{E01}\u{E23}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E21}\u{E32}\u{E01}\u{E01}\u{E27}\u{E48}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{6CC}\u{627} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{633}\u{631}\u{686} \u{641}\u{644}\u{679}\u{631}\u{632} \u{6A9}\u{648} \u{62A}\u{628}\u{62F}\u{6CC}\u{644} \u{6CC}\u{627} \u{635}\u{627}\u{641} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{6A9}\u{648}\u{634}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `H\xe3y th\u{1EED} thay \u{111}\u{1ED5}i ho\u{1EB7}c x\xf3a m\u{1ED9}t ho\u{1EB7}c nhi\u{1EC1}u b\u{1ED9} l\u{1ECD}c t\xecm ki\u{1EBF}m.`,
    'zh-hans': `\u{8BD5}\u{7740}\u{66F4}\u{6539}\u{6216}\u{6E05}\u{9664}\u{4E00}\u{4E2A}\u{6216}\u{591A}\u{4E2A}\u{641C}\u{7D22}\u{7B5B}\u{9009}\u{6761}\u{4EF6}\u{3002}`,
    'zh-hant': `\u{8A66}\u{8457}\u{66F4}\u{6539}\u{6216}\u{6E05}\u{9664}\u{4E00}\u{500B}\u{6216}\u{591A}\u{500B}\u{641C}\u{5C0B}\u{7BE9}\u{9078}\u{5668}\u{3002}`,
    en: `Try changing or clearing one or more search filters.`
};
const $b11db1b62d4a8f76$export$8ccf4d57ae99918d = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{641}\u{648}\u{627}\u{62A}\u{64A}\u{631}`,
    de: `Keine Rechnungen`,
    es: `Sin facturas`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{641}\u{627}\u{6A9}\u{62A}\u{648}\u{631}`,
    fil: `Walang mga invoice`,
    fr: `Pas de factures`,
    hi: `\u{915}\u{94B}\u{908} \u{91A}\u{93E}\u{932}\u{93E}\u{928} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen b\xf2dwo`,
    it: `Nessuna fattura`,
    ja: `\u{8ACB}\u{6C42}\u{66F8}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{CCAD}\u{AD6C}\u{C11C}\u{AC00} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj cov ntawv sau nqi`,
    ps: `\u{647}\u{6CC}\u{685} \u{631}\u{633}\u{6CC}\u{62F}\u{648}\u{646}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem faturas`,
    'pt-pt': `Sem faturas`,
    ru: `\u{421}\u{447}\u{435}\u{442}\u{43E}\u{432} \u{43D}\u{435}\u{442}.`,
    sm: `Leai ni pili`,
    so: `Ma jiraan biilal`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E43}\u{E1A}\u{E41}\u{E08}\u{E49}\u{E07}\u{E2B}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{627}\u{646}\u{648}\u{627}\u{626}\u{633} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 h\xf3a \u{111}\u{1A1}n`,
    'zh-hans': `\u{6CA1}\u{6709}\u{53D1}\u{7968}`,
    'zh-hant': `\u{6C92}\u{6709}\u{767C}\u{7968}`,
    en: `No invoices`
};
const $b11db1b62d4a8f76$export$9bcb1cec33b64194 = {
    ar: `\u{644}\u{627} \u{634}\u{64A}\u{621}`,
    de: `Keine`,
    es: `Ninguno`,
    fa: `\u{647}\u{6CC}\u{686} \u{6A9}\u{62F}\u{627}\u{645}`,
    fil: `Wala`,
    fr: `Aucun`,
    hi: `\u{915}\u{94B}\u{908} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen yonn`,
    it: `Nessuna`,
    ja: `\u{5168}\u{304F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C804}\u{D600} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj`,
    ps: `\u{647}\u{6CC}\u{685} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Nenhum`,
    'pt-pt': `Nenhuma`,
    ru: `\u{41D}\u{435}\u{442}`,
    sm: `Leai se tasi`,
    so: `Midna ma jiro`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3`,
    'zh-hans': `\u{6CA1}\u{6709}`,
    'zh-hant': `\u{6C92}\u{6709}`,
    en: `None`
};
const $b11db1b62d4a8f76$export$15565a177ad68852 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{646}\u{634}\u{637}\u{629} \u{645}\u{641}\u{62A}\u{648}\u{62D}\u{629}`,
    de: `Keine offenen Aktivit\xe4ten`,
    es: `No hay actividades abiertas`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{622}\u{632}\u{627}\u{62F} \u{645}\u{645}\u{646}\u{648}\u{639} \u{627}\u{633}\u{62A}`,
    fil: `Walang bukas na aktibidad`,
    fr: `Pas d\u{2019}activit\xe9s ouvertes`,
    hi: `\u{915}\u{94B}\u{908} \u{916}\u{941}\u{932}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen aktivite ouv\xe8`,
    it: `Niente attivit\xe0 aperte`,
    ja: `\u{516C}\u{958B}\u{6D3B}\u{52D5}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{ACF5}\u{AC1C} \u{D65C}\u{B3D9} \u{AE08}\u{C9C0}`,
    mww: `Tsis muaj kev qhib kev ua ub no`,
    ps: `\u{647}\u{6CC}\u{685} \u{62E}\u{644}\u{627}\u{635} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem atividades abertas`,
    'pt-pt': `Sem atividades abertas`,
    ru: `\u{41E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{445} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{439} \u{437}\u{430}\u{43F}\u{440}\u{435}\u{449}\u{435}\u{43D}\u{43E}`,
    sm: `Leai ni gaoioiga tatala`,
    so: `Ma jiraan hawlo furan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E40}\u{E1B}\u{E34}\u{E14}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{6A9}\u{6BE}\u{644}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ho\u{1EA1}t \u{111}\u{1ED9}ng m\u{1EDF}`,
    'zh-hans': `\u{7981}\u{6B62}\u{5F00}\u{653E}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{7121}\u{958B}\u{653E}\u{6D3B}\u{52D5}`,
    en: `No open activities`
};
const $b11db1b62d4a8f76$export$1e4bf543b85be185 = {
    ar: (name)=>`${name} \u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{646}\u{634}\u{637}\u{629} \u{645}\u{641}\u{62A}\u{648}\u{62D}\u{629}`,
    de: (name)=>`${name} hat keine offenen Aktivit\xe4ten`,
    es: (name)=>`${name} no tiene actividades abiertas`,
    fa: (name)=>`${name} \u{647}\u{6CC}\u{686} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{627}\u{632} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: (name)=>`Si ${name} ay walang mga aktibidad na may kinalaman sa pag-aalaga`,
    fr: (name)=>`${name} n\u{2019}a aucune activit\xe9 ouverte`,
    hi: (name)=>`${name} \u{915}\u{947} \u{92A}\u{93E}\u{938} \u{915}\u{94B}\u{908} \u{916}\u{941}\u{932}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}`,
    ht: (name)=>`${name} pa gen okenn aktivite ouv\xe8`,
    it: (name)=>`${name} non ha attivit\xe0 aperte`,
    ja: (name)=>`\u{30B9}${name}\u{306B}\u{306F}\u{30AA}\u{30FC}\u{30D7}\u{30F3}\u{306A}\u{6D3B}\u{52D5}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: (name)=>`${name} \u{C740} \u{ACF5}\u{AC1C} \u{D65C}\u{B3D9}\u{C774} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: (name)=>`${name} tsis muaj kev qhib kev ua ub no`,
    ps: (name)=>`${name} \u{647}\u{6CC}\u{685} \u{62E}\u{644}\u{627}\u{635} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{646}\u{647} \u{644}\u{631}\u{6CC}`,
    pt: (name)=>`${name} n\xe3o tem atividades abertas`,
    'pt-pt': (name)=>`${name} n\xe3o tem atividades abertas`,
    ru: (name)=>`${name} \u{43D}\u{435}\u{442} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{445} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{439}`,
    sm: (name)=>`${name} e leai ni gaoioiga tatala`,
    so: (name)=>`${name} ma laha hawlo furan`,
    th: (name)=>`${name} \u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E40}\u{E1B}\u{E34}\u{E14}`,
    ur: (name)=>`${name} \u{6A9}\u{6D2} \u{67E}\u{627}\u{633} \u{6A9}\u{648}\u{626}\u{6CC} \u{6A9}\u{6BE}\u{644}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}`,
    vi: (name)=>`${name} kh\xf4ng c\xf3 b\u{1EA5}t k\u{1EF3} ho\u{1EA1}t \u{111}\u{1ED9}ng m\u{1EDF} n\xe0o`,
    'zh-hans': (name)=>`\u{53F2}${name}\u{6CA1}\u{6709}\u{4EFB}\u{4F55}\u{516C}\u{5F00}\u{6D3B}\u{52A8}`,
    'zh-hant': (name)=>`\u{53F2}${name}\u{6C92}\u{6709}\u{4EFB}\u{4F55}\u{958B}\u{653E}\u{6D3B}\u{52D5}`,
    en: (name)=>`${name} does not have any open activities`
};
const $b11db1b62d4a8f76$export$a6ef6b8d8b7cd7e8 = {
    ar: `\u{644}\u{627} \u{64A}\u{648}\u{62C}\u{62F} \u{645}\u{634}\u{627}\u{631}\u{643}\u{648}\u{646}`,
    de: `Keine Teilnehmer`,
    es: `Sin participantes`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: `Walang mga kalahok`,
    fr: `Aucun participant`,
    hi: `\u{915}\u{94B}\u{908} \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{940} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen patisipan yo`,
    it: `Nessun partecipante`,
    ja: `\u{53C2}\u{52A0}\u{8005}\u{306F}\u{3044}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{CC38}\u{AC00}\u{C790} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj neeg koom nrog`,
    ps: `\u{647}\u{6CC}\u{685} \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem participantes`,
    'pt-pt': `Sem participantes`,
    ru: `\u{423}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{43E}\u{432} \u{43D}\u{435}\u{442}`,
    sm: `Leai ni tagata auai`,
    so: `Ma jiraan ka qaybgalayaal`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{634}\u{631}\u{6A9}\u{627}\u{621} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ng\u{1B0}\u{1EDD}i tham gia`,
    'zh-hans': `\u{65E0}\u{53C2}\u{4E0E}\u{8005}`,
    'zh-hant': `\u{7121}\u{53C3}\u{8207}\u{8005}`,
    en: `No participants`
};
const $b11db1b62d4a8f76$export$932c42e8cc865452 = {
    ar: `\u{62D}\u{633}\u{627}\u{628}\u{643} \u{63A}\u{64A}\u{631} \u{645}\u{631}\u{62A}\u{628}\u{637} \u{628}\u{623}\u{64A} \u{645}\u{634}\u{627}\u{631}\u{643} \u{628}\u{634}\u{643}\u{644} \u{646}\u{634}\u{637}. \u{625}\u{630}\u{627} \u{643}\u{646}\u{62A} \u{62A}\u{639}\u{62A}\u{642}\u{62F} \u{623}\u{646} \u{647}\u{630}\u{627} \u{62E}\u{637}\u{623}\u{60C} \u{64A}\u{631}\u{62C}\u{649} \u{627}\u{644}\u{62A}\u{648}\u{627}\u{635}\u{644} \u{645}\u{639} \u{645}\u{645}\u{62B}\u{644} \u{648}\u{643}\u{627}\u{644}\u{62A}\u{643}.`,
    de: `Dein Konto ist nicht aktiv mit irgendwelchen Teilnehmern verkn\xfcpft. Wenn Sie denken, dass dies ein Fehler ist, wenden Sie sich bitte an Ihren Vertreter der Agentur.`,
    es: `Tu cuenta no est\xe1 activamente asociada con ning\xfan participante. Si crees que esto es un error, por favor contacta con el representante de tu agencia.`,
    fa: `\u{62D}\u{633}\u{627}\u{628} \u{634}\u{645}\u{627} \u{628}\u{647} \u{637}\u{648}\u{631} \u{641}\u{639}\u{627}\u{644} \u{628}\u{627} \u{647}\u{6CC}\u{686} \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647} \u{627}\u{6CC} \u{645}\u{631}\u{62A}\u{628}\u{637} \u{646}\u{6CC}\u{633}\u{62A}. \u{627}\u{6AF}\u{631} \u{641}\u{6A9}\u{631} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{627}\u{6CC}\u{646} \u{6CC}\u{6A9} \u{627}\u{634}\u{62A}\u{628}\u{627}\u{647} \u{627}\u{633}\u{62A}\u{60C} \u{644}\u{637}\u{641}\u{627} \u{628}\u{627} \u{646}\u{645}\u{627}\u{6CC}\u{646}\u{62F}\u{647} \u{622}\u{698}\u{627}\u{646}\u{633} \u{62E}\u{648}\u{62F} \u{62A}\u{645}\u{627}\u{633} \u{628}\u{6AF}\u{6CC}\u{631}\u{6CC}\u{62F}.`,
    fil: `Ang iyong account ay hindi aktibong nauugnay sa anumang mga kalahok. Kung sa palagay mo ay isang pagkakamali ito, mangyaring makipag-ugnay sa kinatawan ng iyong ahensya.`,
    fr: `Votre compte n\u{2019}est pas activement associ\xe9 \xe0 des participants. Si vous pensez qu\u{2019}il s\u{2019}agit d\u{2019}une erreur, veuillez contacter votre repr\xe9sentant d\u{2019}agence.`,
    hi: `\u{906}\u{92A}\u{915}\u{93E} \u{916}\u{93E}\u{924}\u{93E} \u{915}\u{93F}\u{938}\u{940} \u{92D}\u{940} \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{940} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{938}\u{915}\u{94D}\u{930}\u{93F}\u{92F} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}. \u{905}\u{917}\u{930} \u{906}\u{92A}\u{915}\u{94B} \u{932}\u{917}\u{924}\u{93E} \u{939}\u{948} \u{915}\u{93F} \u{92F}\u{939} \u{917}\u{932}\u{924}\u{940} \u{939}\u{948}, \u{924}\u{94B} \u{915}\u{943}\u{92A}\u{92F}\u{93E} \u{905}\u{92A}\u{928}\u{940} \u{90F}\u{91C}\u{947}\u{902}\u{938}\u{940} \u{915}\u{947} \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{928}\u{93F}\u{927}\u{93F} \u{938}\u{947} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Kont ou se pa aktivman asosye ak nenp\xf2t patisipan yo. Si ou panse sa a se yon er\xe8, tanpri kontakte reprezantan ajans ou an.`,
    it: `Il tuo account non \xe8 attivamente associato a nessun partecipante. Se pensi che sia un errore, contatta il rappresentante della tua agenzia.`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{306F}\u{53C2}\u{52A0}\u{8005}\u{3068}\u{7A4D}\u{6975}\u{7684}\u{306B}\u{9023}\u{643A}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}\u{3082}\u{3057}\u{3053}\u{308C}\u{304C}\u{9593}\u{9055}\u{3044}\u{3060}\u{3068}\u{601D}\u{3046}\u{5834}\u{5408}\u{306F}\u{3001}\u{6240}\u{5C5E}\u{6A5F}\u{95A2}\u{306E}\u{62C5}\u{5F53}\u{8005}\u{306B}\u{3054}\u{9023}\u{7D61}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{ADC0}\u{D558}\u{C758} \u{ACC4}\u{C815}\u{C740} \u{C5B4}\u{B5A4} \u{CC38}\u{AC00}\u{C790}\u{C640}\u{B3C4} \u{C801}\u{ADF9}\u{C801}\u{C73C}\u{B85C} \u{C5F0}\u{ACB0}\u{B418}\u{C5B4} \u{C788}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C774}\u{AC83}\u{C774} \u{C2E4}\u{C218}\u{B77C}\u{ACE0} \u{C0DD}\u{AC01}\u{B41C}\u{B2E4}\u{BA74}, \u{AE30}\u{AD00} \u{B2F4}\u{B2F9}\u{C790}\u{C5D0}\u{AC8C} \u{C5F0}\u{B77D}\u{D574} \u{C8FC}\u{C138}\u{C694}.`,
    mww: `Koj tus as khauj tsis nquag koom nrog ib tus neeg koom nrog. Yog koj xav tias qhov no yog ib qho yuam kev, thov hu rau koj tus neeg sawv cev rau lub koom haum.`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{62D}\u{633}\u{627}\u{628} \u{641}\u{639}\u{627}\u{644}\u{647} \u{644}\u{647} \u{647}\u{6D0}\u{685} \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644} \u{633}\u{631}\u{647} \u{62A}\u{693}\u{627}\u{648} \u{646}\u{647} \u{644}\u{631}\u{6CC}. \u{6A9}\u{647} \u{641}\u{6A9}\u{631} \u{6A9}\u{648}\u{626} \u{62F}\u{627} \u{627}\u{634}\u{62A}\u{628}\u{627}\u{647} \u{62F}\u{647}\u{60C} \u{645}\u{647}\u{631}\u{628}\u{627}\u{646}\u{6CC} \u{648}\u{6A9}\u{693}\u{626} \u{644}\u{647} \u{62E}\u{67E}\u{644} \u{627}\u{62F}\u{627}\u{631}\u{6D0} \u{627}\u{633}\u{62A}\u{627}\u{632}\u{6CC} \u{633}\u{631}\u{647} \u{627}\u{693}\u{6CC}\u{6A9}\u{647} \u{648}\u{646}\u{6CC}\u{633}\u{626}.`,
    pt: `Sua conta n\xe3o est\xe1 ativamente associada a nenhum participante. Se voc\xea acha que isso \xe9 um erro, por favor, entre em contato com o representante da sua ag\xeancia.`,
    'pt-pt': `A sua conta n\xe3o est\xe1 ativamente associada a nenhum participante. Se achar que isto \xe9 um erro, por favor contacte o representante da sua ag\xeancia.`,
    ru: `\u{412}\u{430}\u{448} \u{430}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442} \u{43D}\u{435} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E} \u{441} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{430}\u{43C}\u{438}. \u{415}\u{441}\u{43B}\u{438} \u{432}\u{44B} \u{441}\u{447}\u{438}\u{442}\u{430}\u{435}\u{442}\u{435}, \u{447}\u{442}\u{43E} \u{44D}\u{442}\u{43E} \u{43E}\u{448}\u{438}\u{431}\u{43A}\u{430}, \u{43F}\u{43E}\u{436}\u{430}\u{43B}\u{443}\u{439}\u{441}\u{442}\u{430}, \u{441}\u{432}\u{44F}\u{436}\u{438}\u{442}\u{435}\u{441}\u{44C} \u{441} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{435}\u{43C} \u{432}\u{430}\u{448}\u{435}\u{433}\u{43E} \u{430}\u{433}\u{435}\u{43D}\u{442}\u{441}\u{442}\u{432}\u{430}.`,
    sm: `E le o feso'ota'i malosi lau teuga tupe ma so'o se tagata auai. Afai e te manatu o se mea sese lenei, faamolemole faafesootai le sui o lou ofisa.`,
    so: `Akoonkaaga si firfircoon looma xiriirin cidna ka qaybgalayaasha. Haddii aad u malaynayso in tani ay khalad tahay, fadlan la xiriir wakiilka hay'addaada.`,
    th: `\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E40}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E21}\u{E42}\u{E22}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}\u{E43}\u{E14} \u{E46} \u{E2B}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E04}\u{E34}\u{E14}\u{E27}\u{E48}\u{E32}\u{E19}\u{E35}\u{E48}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E04}\u{E27}\u{E32}\u{E21}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14} \u{E42}\u{E1B}\u{E23}\u{E14}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E15}\u{E31}\u{E27}\u{E41}\u{E17}\u{E19}\u{E40}\u{E2D}\u{E40}\u{E08}\u{E19}\u{E0B}\u{E35}\u{E48}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{627} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{6A9}\u{633}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{634}\u{631}\u{6A9}\u{627}\u{621} \u{633}\u{6D2} \u{641}\u{639}\u{627}\u{644} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{645}\u{646}\u{633}\u{644}\u{6A9} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4} \u{627}\u{6AF}\u{631} \u{622}\u{67E} \u{6A9}\u{648} \u{644}\u{6AF}\u{62A}\u{627} \u{6C1}\u{6D2} \u{6A9}\u{6C1} \u{6CC}\u{6C1} \u{63A}\u{644}\u{637}\u{6CC} \u{6C1}\u{6D2} \u{62A}\u{648} \u{628}\u{631}\u{627}\u{6C1} \u{6A9}\u{631}\u{645} \u{627}\u{67E}\u{646}\u{6D2} \u{627}\u{6CC}\u{62C}\u{646}\u{633}\u{6CC} \u{6A9}\u{6D2} \u{646}\u{645}\u{627}\u{626}\u{646}\u{62F}\u{6D2} \u{633}\u{6D2} \u{631}\u{627}\u{628}\u{637}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `T\xe0i kho\u{1EA3}n c\u{1EE7}a b\u{1EA1}n kh\xf4ng \u{111}\u{1B0}\u{1EE3}c li\xean k\u{1EBF}t t\xedch c\u{1EF1}c v\u{1EDB}i b\u{1EA5}t k\u{1EF3} ng\u{1B0}\u{1EDD}i tham gia n\xe0o. N\u{1EBF}u b\u{1EA1}n cho r\u{1EB1}ng \u{111}\xe2y l\xe0 m\u{1ED9}t sai l\u{1EA7}m, vui l\xf2ng li\xean h\u{1EC7} v\u{1EDB}i \u{111}\u{1EA1}i di\u{1EC7}n \u{111}\u{1EA1}i l\xfd c\u{1EE7}a b\u{1EA1}n.`,
    'zh-hans': `\u{60A8}\u{7684}\u{8D26}\u{6237}\u{5E76}\u{672A}\u{4E0E}\u{4EFB}\u{4F55}\u{53C2}\u{4E0E}\u{8005}\u{6709}\u{5173}\u{8054}\u{3002}\u{5982}\u{679C}\u{60A8}\u{8BA4}\u{4E3A}\u{8FD9}\u{662F}\u{9519}\u{8BEF}\u{FF0C}\u{8BF7}\u{8054}\u{7CFB}\u{60A8}\u{7684}\u{673A}\u{6784}\u{4EE3}\u{8868}\u{3002}`,
    'zh-hant': `\u{60A8}\u{7684}\u{5E33}\u{865F}\u{4E26}\u{672A}\u{8207}\u{4EFB}\u{4F55}\u{53C3}\u{8207}\u{8005}\u{6709}\u{7A4D}\u{6975}\u{95DC}\u{806F}\u{3002}\u{5982}\u{679C}\u{60A8}\u{8A8D}\u{70BA}\u{9019}\u{662F}\u{932F}\u{8AA4}\u{FF0C}\u{8ACB}\u{806F}\u{7E6B}\u{60A8}\u{7684}\u{6A5F}\u{69CB}\u{4EE3}\u{8868}\u{3002}`,
    en: `Your account is not actively associated with any participants. If you think this is a mistake, please contact your agency representative.`
};
const $b11db1b62d4a8f76$export$74bd8576c7833637 = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{625}\u{635}\u{62F}\u{627}\u{631} \u{623}\u{64A} \u{62A}\u{642}\u{627}\u{631}\u{64A}\u{631} \u{62D}\u{62A}\u{649} \u{627}\u{644}\u{622}\u{646}.`,
    de: `Es wurden bisher keine Berichte erstellt.`,
    es: `A\xfan no se han creado informes.`,
    fa: `\u{647}\u{646}\u{648}\u{632} \u{6AF}\u{632}\u{627}\u{631}\u{634}\u{6CC} \u{645}\u{646}\u{62A}\u{634}\u{631} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Wala pang mga ulat na nabuo.`,
    fr: `Aucun rapport n\u{2019}a encore \xe9t\xe9 cr\xe9\xe9.`,
    hi: `\u{905}\u{92D}\u{940} \u{924}\u{915} \u{915}\u{94B}\u{908} \u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F} \u{928}\u{939}\u{940}\u{902} \u{92C}\u{928}\u{93E}\u{908} \u{917}\u{908} \u{939}\u{948}\u{964}`,
    ht: `Pa gen rap\xf2 yo te kreye ank\xf2.`,
    it: `Non sono ancora state create segnalazioni.`,
    ja: `\u{307E}\u{3060}\u{5831}\u{544A}\u{306F}\u{4F5C}\u{6210}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C544}\u{C9C1} \u{BCF4}\u{ACE0}\u{B294} \u{C811}\u{C218}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj ntawv ceeb toom tseem tsis tau tsim.`,
    ps: `\u{62A}\u{631} \u{627}\u{648}\u{633}\u{647} \u{6A9}\u{648}\u{645} \u{631}\u{627}\u{67E}\u{648}\u{631} \u{646}\u{647} \u{62F}\u{6CC} \u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}.`,
    pt: `Ainda n\xe3o foram criados relat\xf3rios.`,
    'pt-pt': `Ainda n\xe3o foram criados relat\xf3rios.`,
    ru: `\u{41F}\u{43E}\u{43A}\u{430} \u{43E}\u{442}\u{447}\u{451}\u{442}\u{44B} \u{43D}\u{435} \u{441}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{44B}.`,
    sm: `E le'i faia ni lipoti i le taimi nei.`,
    so: `Warbixino weli lama helin.`,
    th: `\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{627}\u{628}\u{6BE}\u{6CC} \u{62A}\u{6A9} \u{6A9}\u{648}\u{626}\u{6CC} \u{631}\u{67E}\u{648}\u{631}\u{679} \u{62A}\u{6CC}\u{627}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ch\u{1B0}a c\xf3 b\xe1o c\xe1o n\xe0o \u{111}\u{1B0}\u{1EE3}c t\u{1EA1}o.`,
    'zh-hans': `\u{76EE}\u{524D}\u{8FD8}\u{6CA1}\u{6709}\u{62A5}\u{544A}\u{3002}`,
    'zh-hant': `\u{76EE}\u{524D}\u{5C1A}\u{672A}\u{6536}\u{5230}\u{4EFB}\u{4F55}\u{5831}\u{544A}\u{3002}`,
    en: `No reports have been created yet.`
};
const $b11db1b62d4a8f76$export$b3813783e354bd5f = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{649} \u{646}\u{62A}\u{627}\u{626}\u{62C}`,
    de: `Keine Ergebnisse gefunden`,
    es: `No se encontraron resultados`,
    fa: `\u{647}\u{6CC}\u{686} \u{646}\u{62A}\u{6CC}\u{62C}\u{647} \u{627}\u{6CC} \u{6CC}\u{627}\u{641}\u{62A} \u{646}\u{634}\u{62F}`,
    fil: `Walang natagpuang resulta`,
    fr: `Aucun r\xe9sultat trouv\xe9`,
    hi: `\u{915}\u{94B}\u{908} \u{92A}\u{930}\u{93F}\u{923}\u{93E}\u{92E} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932}\u{93E}`,
    ht: `Pa gen rezilta yo te jwenn`,
    it: `Nessun risultato trovato`,
    ja: `\u{7D50}\u{679C}\u{306F}\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}\u{3067}\u{3057}\u{305F}`,
    ko: `\u{AC80}\u{C0C9} \u{ACB0}\u{ACFC}\u{AC00} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj txiaj ntsig pom`,
    ps: `\u{647}\u{6CC}\u{685} \u{646}\u{62A}\u{6CC}\u{62C}\u{647} \u{648}\u{646}\u{647} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{634}\u{648}\u{647}`,
    pt: `Nenhum resultado encontrado`,
    'pt-pt': `Sem resultados encontrados`,
    ru: `\u{420}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{43E}\u{432} \u{43D}\u{435} \u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}\u{43E}`,
    sm: `E leai ni taunuuga na maua`,
    so: `Natiijo lama helin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}\u{E1C}\u{E25}\u{E25}\u{E31}\u{E1E}\u{E18}\u{E4C}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{646}\u{62A}\u{627}\u{626}\u{62C} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{644}\u{6D2}`,
    vi: `Kh\xf4ng t\xecm th\u{1EA5}y k\u{1EBF}t qu\u{1EA3}`,
    'zh-hans': `\u{672A}\u{627E}\u{5230}\u{7ED3}\u{679C}`,
    'zh-hant': `\u{672A}\u{627E}\u{5230}\u{7D50}\u{679C}`,
    en: `No results found`
};
const $b11db1b62d4a8f76$export$6d3a7d28d4befbaa = {
    ar: `\u{644}\u{645} \u{62A}\u{62A}\u{637}\u{627}\u{628}\u{642} \u{623}\u{64A} \u{646}\u{62A}\u{627}\u{626}\u{62C} \u{645}\u{639} \u{628}\u{62D}\u{62B}\u{643}.`,
    de: `Keine Ergebnisse passten zu deiner Suche.`,
    es: `Ning\xfan resultado coincid\xeda con tu b\xfasqueda.`,
    fa: `\u{647}\u{6CC}\u{686} \u{646}\u{62A}\u{6CC}\u{62C}\u{647} \u{627}\u{6CC} \u{628}\u{627} \u{62C}\u{633}\u{62A}\u{62C}\u{648}\u{6CC} \u{634}\u{645}\u{627} \u{645}\u{637}\u{627}\u{628}\u{642}\u{62A} \u{646}\u{62F}\u{627}\u{634}\u{62A}.`,
    fil: `Walang mga resulta na tumutugma sa iyong paghahanap.`,
    fr: `Aucun r\xe9sultat ne correspond \xe0 votre recherche.`,
    hi: `\u{906}\u{92A}\u{915}\u{940} \u{916}\u{94B}\u{91C} \u{938}\u{947} \u{915}\u{94B}\u{908} \u{92E}\u{947}\u{932} \u{928}\u{939}\u{940}\u{902} \u{916}\u{93E}\u{924}\u{93E}.`,
    ht: `Pa gen rezilta matche ak rech\xe8ch ou an.`,
    it: `Nessun risultato corrispondeva alla tua ricerca.`,
    ja: `\u{691C}\u{7D22}\u{7D50}\u{679C}\u{306B}\u{4E00}\u{81F4}\u{3059}\u{308B}\u{3082}\u{306E}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}\u{3067}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{AC80}\u{C0C9} \u{ACB0}\u{ACFC}\u{C640} \u{C77C}\u{CE58}\u{D558}\u{B294} \u{AC83}\u{C740} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj cov txiaj ntsig phim koj txoj kev tshawb nrhiav.`,
    ps: `\u{647}\u{6CC}\u{685} \u{646}\u{62A}\u{6CC}\u{62C}\u{647} \u{633}\u{62A}\u{627} \u{62F} \u{644}\u{67C}\u{648}\u{646} \u{633}\u{631}\u{647} \u{628}\u{631}\u{627}\u{628}\u{631}\u{647} \u{646}\u{647} \u{648}\u{647}.`,
    pt: `Nenhum resultado correspondeu \xe0 sua busca.`,
    'pt-pt': `Nenhum resultado corresponde \xe0 sua pesquisa.`,
    ru: `\u{420}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}\u{44B} \u{43D}\u{435} \u{441}\u{43E}\u{432}\u{43F}\u{430}\u{43B}\u{438} \u{441} \u{432}\u{430}\u{448}\u{438}\u{43C} \u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{43E}\u{43C}.`,
    sm: `E leai ni taunuuga e tutusa ma lau sailiga.`,
    so: `Natiijooyin ma aysan la mid ahayn raadintaada.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E1C}\u{E25}\u{E25}\u{E31}\u{E1E}\u{E18}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E15}\u{E23}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{646}\u{62A}\u{6CC}\u{62C}\u{6C1} \u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{644}\u{627}\u{634} \u{633}\u{6D2} \u{645}\u{6CC}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6BE}\u{627}\u{62A}\u{627}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 k\u{1EBF}t qu\u{1EA3} n\xe0o kh\u{1EDB}p v\u{1EDB}i t\xecm ki\u{1EBF}m c\u{1EE7}a b\u{1EA1}n.`,
    'zh-hans': `\u{6CA1}\u{6709}\u{7ED3}\u{679C}\u{4E0E}\u{4F60}\u{7684}\u{641C}\u{7D22}\u{7ED3}\u{679C}\u{76F8}\u{7B26}\u{3002}`,
    'zh-hant': `\u{6C92}\u{6709}\u{7D50}\u{679C}\u{7B26}\u{5408}\u{4F60}\u{7684}\u{641C}\u{5C0B}\u{7D50}\u{679C}\u{3002}`,
    en: `No results matched your search.`
};
const $b11db1b62d4a8f76$export$359f76fe8b5f03e6 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{62A}\u{635}\u{627}\u{631}\u{64A}\u{62D} \u{62E}\u{62F}\u{645}\u{629}`,
    de: `Keine Service-Autorisierungen`,
    es: `No hay autorizaciones de servicio`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{645}\u{62C}\u{648}\u{632} \u{62E}\u{62F}\u{645}\u{627}\u{62A}`,
    fil: `Walang mga pahintulot sa serbisyo`,
    fr: `Aucune autorisation de service`,
    hi: `\u{915}\u{94B}\u{908} \u{938}\u{947}\u{935}\u{93E} \u{92A}\u{94D}\u{930}\u{93E}\u{927}\u{93F}\u{915}\u{930}\u{923} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen otorizasyon s\xe8vis`,
    it: `Nessuna autorizzazione al servizio`,
    ja: `\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{627F}\u{8A8D}\u{306A}\u{3057}`,
    ko: `\u{C11C}\u{BE44}\u{C2A4} \u{C2B9}\u{C778} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj kev tso cai pabcuam`,
    ps: `\u{647}\u{6CC}\u{685} \u{62E}\u{62F}\u{645}\u{62A} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem autoriza\xe7\xf5es de servi\xe7o`,
    'pt-pt': `Sem autoriza\xe7\xf5es de servi\xe7o`,
    ru: `\u{41D}\u{435}\u{442} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{44F} \u{43D}\u{430} \u{43E}\u{431}\u{441}\u{43B}\u{443}\u{436}\u{438}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Leai ni fa'atagaga tautua`,
    so: `Ma jirto oggolaansho adeeg`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{633}\u{631}\u{648}\u{633} \u{627}\u{62C}\u{627}\u{632}\u{62A}\u{6CC}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 \u{1EE7}y quy\u{1EC1}n d\u{1ECB}ch v\u{1EE5}`,
    'zh-hans': `\u{65E0}\u{670D}\u{52A1}\u{6388}\u{6743}`,
    'zh-hant': `\u{7121}\u{670D}\u{52D9}\u{6388}\u{6B0A}`,
    en: `No service authorizations`
};
const $b11db1b62d4a8f76$export$65b975e57b2c1017 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{62E}\u{62F}\u{645}\u{627}\u{62A}`,
    de: `Keine Verbindungen`,
    es: `Sin servicios`,
    fa: `\u{647}\u{6CC}\u{686} \u{62E}\u{62F}\u{645}\u{627}\u{62A}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang Mga Serbisyo`,
    fr: `Aucun service`,
    hi: `\u{915}\u{94B}\u{908} \u{938}\u{947}\u{935}\u{93E} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen s\xe8vis`,
    it: `Nessun servizio`,
    ja: `\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C11C}\u{BE44}\u{C2A4} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj kev pabcuam`,
    ps: `\u{647}\u{6CC}\u{685} \u{62E}\u{62F}\u{645}\u{62A} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem servi\xe7os`,
    'pt-pt': `Sem servi\xe7os`,
    ru: `\u{41E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{438}\u{435} \u{443}\u{441}\u{43B}\u{443}\u{433}`,
    sm: `Leai se auaunaga`,
    so: `Adeegyo ma jiraan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{633}\u{631}\u{648}\u{633} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 d\u{1ECB}ch v\u{1EE5}`,
    'zh-hans': `\u{65E0}\u{670D}\u{52A1}`,
    'zh-hant': `\u{7121}\u{670D}\u{52D9}`,
    en: `No services`
};
const $b11db1b62d4a8f76$export$7169d18ac1bffb58 = {
    ar: `\u{644}\u{627} \u{64A}\u{648}\u{62C}\u{62F} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{628}\u{62F}\u{621} \u{645}\u{62A}\u{627}\u{62D}`,
    de: `Kein Starttermin verf\xfcgbar`,
    es: `No hay fecha de inicio disponible`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{634}\u{631}\u{648}\u{639} \u{62F}\u{631} \u{62F}\u{633}\u{62A}\u{631}\u{633} \u{646}\u{6CC}\u{633}\u{62A}`,
    fil: `Walang available na petsa ng pagsisimula`,
    fr: `Aucune date de d\xe9but disponible`,
    hi: `\u{915}\u{94B}\u{908} \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{924}\u{93F}\u{925}\u{93F} \u{909}\u{92A}\u{932}\u{92C}\u{94D}\u{927} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}`,
    ht: `Pa gen dat k\xf2manse ki disponib`,
    it: `Nessuna data di inizio disponibile`,
    ja: `\u{958B}\u{59CB}\u{65E5}\u{306F}\u{4E0D}\u{660E}\u{3067}\u{3059}`,
    ko: `\u{C2DC}\u{C791} \u{B0A0}\u{C9DC}\u{B294} \u{C54C}\u{B824}\u{C9C0}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj hnub pib muaj`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{644} \u{646}\u{6D0}\u{67C}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem data de in\xedcio dispon\xedvel`,
    'pt-pt': `N\xe3o h\xe1 data de in\xedcio dispon\xedvel`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{43D}\u{435}\u{438}\u{437}\u{432}\u{435}\u{441}\u{442}\u{43D}\u{430}`,
    sm: `E leai se aso amata e maua`,
    so: `Taariikh bilaabasho lama heli karo`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{634}\u{631}\u{648}\u{639} \u{6C1}\u{648}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{62F}\u{633}\u{62A}\u{6CC}\u{627}\u{628} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}`,
    vi: `Kh\xf4ng c\xf3 ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u`,
    'zh-hans': `\u{5C1A}\u{65E0}\u{5F00}\u{5B66}\u{65E5}\u{671F}`,
    'zh-hant': `\u{5C1A}\u{7121}\u{958B}\u{5B78}\u{65E5}\u{671F}`,
    en: `No start date available`
};
const $b11db1b62d4a8f76$export$d4226372e874963a = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{645}\u{62A}\u{648}\u{641}\u{631}\u{629} \u{62D}\u{62A}\u{649} \u{627}\u{644}\u{622}\u{646}.`,
    de: `Noch keine Ausz\xfcge verf\xfcgbar.`,
    es: `A\xfan no hay declaraciones disponibles.`,
    fa: `\u{647}\u{646}\u{648}\u{632} \u{628}\u{6CC}\u{627}\u{646}\u{6CC}\u{647} \u{627}\u{6CC} \u{62F}\u{631} \u{62F}\u{633}\u{62A}\u{631}\u{633} \u{646}\u{6CC}\u{633}\u{62A}.`,
    fil: `Wala pang available na statements.`,
    fr: `Aucune d\xe9claration n\u{2019}est encore disponible.`,
    hi: `\u{905}\u{92D}\u{940} \u{924}\u{915} \u{915}\u{94B}\u{908} \u{92C}\u{92F}\u{93E}\u{928} \u{909}\u{92A}\u{932}\u{92C}\u{94D}\u{927} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{964}`,
    ht: `Pa gen deklarasyon ki disponib ank\xf2.`,
    it: `Nessuna dichiarazione \xe8 ancora disponibile.`,
    ja: `\u{307E}\u{3060}\u{58F0}\u{660E}\u{306F}\u{51FA}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C544}\u{C9C1} \u{C131}\u{BA85}\u{C740} \u{B098}\u{C624}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj daim ntawv qhia nyiaj txiag tam sim no.`,
    ps: `\u{62A}\u{631} \u{627}\u{648}\u{633}\u{647} \u{6A9}\u{648}\u{645} \u{628}\u{6CC}\u{627}\u{646} \u{646}\u{634}\u{62A}\u{647}.`,
    pt: `Ainda n\xe3o h\xe1 extratos dispon\xedveis.`,
    'pt-pt': `Ainda n\xe3o h\xe1 extratos dispon\xedveis.`,
    ru: `\u{41F}\u{43E}\u{43A}\u{430} \u{43D}\u{435}\u{442} \u{437}\u{430}\u{44F}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{439}.`,
    sm: `E leai ni fa'amatalaga o lo'o maua i le taimi nei.`,
    so: `Wali wax hadal ah lama heli karo.`,
    th: `\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E43}\u{E1A}\u{E41}\u{E08}\u{E49}\u{E07}\u{E22}\u{E2D}\u{E14}`,
    ur: `\u{627}\u{628}\u{6BE}\u{6CC} \u{62A}\u{6A9} \u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6CC}\u{627}\u{646}\u{627}\u{62A} \u{62F}\u{633}\u{62A}\u{6CC}\u{627}\u{628} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Ch\u{1B0}a c\xf3 sao k\xea.`,
    'zh-hans': `\u{76EE}\u{524D}\u{5C1A}\u{65E0}\u{4EFB}\u{4F55}\u{58F0}\u{660E}\u{53EF}\u{7528}\u{3002}`,
    'zh-hant': `\u{76EE}\u{524D}\u{5C1A}\u{7121}\u{53EF}\u{53D6}\u{5F97}\u{7684}\u{8072}\u{660E}\u{3002}`,
    en: `No statements available yet.`
};
const $b11db1b62d4a8f76$export$905c65de4ff97758 = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{62A}\u{639}\u{64A}\u{64A}\u{646}\u{647}`,
    de: `Nicht zugewiesen`,
    es: `No asignado`,
    fa: `\u{627}\u{62E}\u{62A}\u{635}\u{627}\u{635} \u{62F}\u{627}\u{62F}\u{647} \u{646}\u{634}\u{62F}\u{647}`,
    fil: `Hindi nakatalaga`,
    fr: `Non assign\xe9`,
    hi: `\u{905}\u{938}\u{93E}\u{907}\u{928} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Pa asiyen`,
    it: `Non assegnato`,
    ja: `\u{5272}\u{308A}\u{5F53}\u{3066}\u{3089}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{BC30}\u{C815}\u{B418}\u{C9C0} \u{C54A}\u{C74C}`,
    mww: `Tsis raug xa mus`,
    ps: `\u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{646}\u{647} \u{62F}\u{6CC}`,
    pt: `N\xe3o atribu\xeddo`,
    'pt-pt': `N\xe3o atribu\xeddo`,
    ru: `\u{41D}\u{435} \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}`,
    sm: `E le'i tofia`,
    so: `Lama xilsaarin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}`,
    ur: `\u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `Kh\xf4ng \u{111}\u{1B0}\u{1EE3}c ch\u{1EC9} \u{111}\u{1ECB}nh`,
    'zh-hans': `\u{672A}\u{5206}\u{914D}`,
    'zh-hant': `\u{672A}\u{5206}\u{914D}`,
    en: `Not assigned`
};
const $b11db1b62d4a8f76$export$fe098bb3d98d7f63 = {
    ar: `\u{63A}\u{64A}\u{631} \u{645}\u{635}\u{631}\u{62D} \u{628}\u{647}`,
    de: `Nicht autorisiert`,
    es: `No autorizado`,
    fa: `\u{645}\u{62C}\u{627}\u{632} \u{646}\u{6CC}\u{633}\u{62A}`,
    fil: `Hindi awtorisado`,
    fr: `Non autoris\xe9`,
    hi: `\u{905}\u{927}\u{93F}\u{915}\u{943}\u{924} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa otorize`,
    it: `Non autorizzato`,
    ja: `\u{8A31}\u{53EF}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{D5C8}\u{AC00}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis tau tso cai`,
    ps: `\u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{647} \u{62F}\u{647} \u{648}\u{631}\u{6A9}\u{693}\u{644} \u{634}\u{648}\u{6D0}`,
    pt: `N\xe3o autorizado`,
    'pt-pt': `N\xe3o autorizado`,
    ru: `\u{41D}\u{435} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{43E}`,
    sm: `E le faatagaina`,
    so: `Lama oggolaan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}`,
    ur: `\u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng \u{111}\u{1B0}\u{1EE3}c ph\xe9p`,
    'zh-hans': `\u{672A}\u{83B7}\u{6388}\u{6743}`,
    'zh-hant': `\u{672A}\u{7D93}\u{6388}\u{6B0A}`,
    en: `Not authorized`
};
const $b11db1b62d4a8f76$export$1a76e3b764e36082 = {
    ar: `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} \u{645}\u{633}\u{62C}\u{644}\u{627} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{644}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{649} \u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629}.`,
    de: `Sie m\xfcssen angemeldet sein, um auf diese Seite zugreifen zu k\xf6nnen.`,
    es: `Debes estar conectado para acceder a esta p\xe1gina.`,
    fa: `\u{628}\u{631}\u{627}\u{6CC} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{628}\u{627}\u{6CC}\u{62F} \u{648}\u{627}\u{631}\u{62F} \u{634}\u{648}\u{6CC}\u{62F}.`,
    fil: `Kailangan mong mag-sign in upang ma-access ang pahinang ito.`,
    fr: `Vous devez \xeatre connect\xe9 pour acc\xe9der \xe0 cette page.`,
    hi: `\u{907}\u{938} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{924}\u{915} \u{92A}\u{939}\u{941}\u{901}\u{91A}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{906}\u{92A}\u{915}\u{94B} \u{938}\u{93E}\u{907}\u{928}-\u{907}\u{928} \u{915}\u{930}\u{928}\u{93E} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915} \u{939}\u{948}.`,
    ht: `Ou dwe siyen nan jwenn aks\xe8 nan paj sa a.`,
    it: `Devi essere connesso per accedere a questa pagina.`,
    ja: `\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{306B}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3059}\u{308B}\u{306B}\u{306F}\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}\u{304C}\u{5FC5}\u{8981}\u{3067}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{D398}\u{C774}\u{C9C0}\u{C5D0} \u{C811}\u{ADFC}\u{D558}\u{B824}\u{BA74} \u{B85C}\u{ADF8}\u{C778}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Koj yuav tsum tau kos npe rau hauv thiaj li nkag mus rau nplooj ntawv no.`,
    ps: `\u{62A}\u{627}\u{633}\u{648} \u{628}\u{627}\u{6CC}\u{62F} \u{62F} \u{62F}\u{6D0} \u{67E}\u{627}\u{6BC}\u{6D0} \u{62F} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{646}\u{646}\u{648}\u{62A}\u{644} \u{634}\u{648}\u{6CC} \u{6CC}\u{627}\u{633}\u{62A}.`,
    pt: `Voc\xea deve estar logado para acessar esta p\xe1gina.`,
    'pt-pt': `Tem de estar iniciado sess\xe3o para aceder a esta p\xe1gina.`,
    ru: `\u{414}\u{43B}\u{44F} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{430} \u{43A} \u{44D}\u{442}\u{43E}\u{439} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{435} \u{43D}\u{435}\u{43E}\u{431}\u{445}\u{43E}\u{434}\u{438}\u{43C}\u{43E} \u{432}\u{43E}\u{439}\u{442}\u{438} \u{432} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443}.`,
    sm: `E tatau ona e saini i totonu e ulufale ai i lenei itulau.`,
    so: `Waa inaad isdiiwaangelisaa si aad u gasho boggan.`,
    th: `\u{E04}\u{E38}\u{E13}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{622}\u{67E} \u{6A9}\u{648} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6C1}\u{648}\u{646}\u{627} \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `B\u{1EA1}n ph\u{1EA3}i \u{111}\u{103}ng nh\u{1EAD}p \u{111}\u{1EC3} truy c\u{1EAD}p trang n\xe0y.`,
    'zh-hans': `\u{60A8}\u{5FC5}\u{987B}\u{767B}\u{5F55}\u{540E}\u{624D}\u{80FD}\u{8BBF}\u{95EE}\u{6B64}\u{9875}\u{9762}\u{3002}`,
    'zh-hant': `\u{60A8}\u{5FC5}\u{9808}\u{767B}\u{5165}\u{624D}\u{80FD}\u{5B58}\u{53D6}\u{6B64}\u{9801}\u{9762}\u{3002}`,
    en: `You must be signed-in to access this page.`
};
const $b11db1b62d4a8f76$export$5b8670ede2f40912 = {
    ar: `\u{633}\u{62C}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{644}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{649} \u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629}.`,
    de: `Melden Sie sich an, um auf diese Seite zuzugreifen.`,
    es: `Inicia sesi\xf3n para acceder a esta p\xe1gina.`,
    fa: `\u{628}\u{631}\u{627}\u{6CC} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{648}\u{627}\u{631}\u{62F} \u{634}\u{648}\u{6CC}\u{62F}.`,
    fil: `Mag-sign in upang ma-access ang pahinang ito.`,
    fr: `Connectez-vous pour acc\xe9der \xe0 cette page.`,
    hi: `\u{907}\u{938} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{924}\u{915} \u{92A}\u{939}\u{941}\u{901}\u{91A}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Siyen pou jwenn aks\xe8 nan paj sa a.`,
    it: `Accedi per accedere a questa pagina.`,
    ja: `\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{306B}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3059}\u{308B}\u{306B}\u{306F}\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C774} \u{D398}\u{C774}\u{C9C0}\u{C5D0} \u{C811}\u{ADFC}\u{D558}\u{B824}\u{BA74} \u{B85C}\u{ADF8}\u{C778}\u{D558}\u{C138}\u{C694}.`,
    mww: `Kos npe nkag mus rau nplooj ntawv no.`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{67E}\u{627}\u{6BC}\u{6D0} \u{62F} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{646}\u{646}\u{648}\u{62A}\u{644} \u{648}\u{6A9}\u{693}\u{626}.`,
    pt: `Fa\xe7a login para acessar esta p\xe1gina.`,
    'pt-pt': `Inicie sess\xe3o para aceder a esta p\xe1gina.`,
    ru: `\u{412}\u{43E}\u{439}\u{434}\u{438}\u{442}\u{435} \u{432} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{43A} \u{44D}\u{442}\u{43E}\u{439} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{435}.`,
    sm: `Saini i totonu e ulufale ai i lenei itulau.`,
    so: `Gali si aad u gasho boggan.`,
    th: `\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E2A}\u{E39}\u{E48}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `\u{110}\u{103}ng nh\u{1EAD}p \u{111}\u{1EC3} truy c\u{1EAD}p trang n\xe0y.`,
    'zh-hans': `\u{767B}\u{5F55}\u{4EE5}\u{8BBF}\u{95EE}\u{6B64}\u{9875}\u{9762}\u{3002}`,
    'zh-hant': `\u{767B}\u{5165}\u{4EE5}\u{9032}\u{5165}\u{6B64}\u{9801}\u{9762}\u{3002}`,
    en: `Sign in to access this page.`
};
const $b11db1b62d4a8f76$export$b0c0c11c015ae973 = {
    ar: (date)=>`\u{63A}\u{64A}\u{631} \u{645}\u{635}\u{631}\u{62D} \u{644}\u{647} \u{628}\u{62A}\u{642}\u{62F}\u{64A}\u{645} \u{627}\u{644}\u{62E}\u{62F}\u{645}\u{627}\u{62A} \u{641}\u{64A} ${date}`,
    de: (date)=>`Am ${date} nicht autorisiert, Dienstleistungen zu erbringen`,
    es: (date)=>`No autorizado para prestar servicios el ${date}`,
    fa: (date)=>`\u{645}\u{62C}\u{648}\u{632} \u{627}\u{631}\u{627}\u{626}\u{647} \u{62E}\u{62F}\u{645}\u{627}\u{62A} \u{62F}\u{631} ${date} \u{631}\u{627} \u{646}\u{62F}\u{627}\u{634}\u{62A}\u{645}`,
    fil: (date)=>`Hindi pinahihintulutan na magbigay ng mga serbisyo sa ${date}`,
    fr: (date)=>`Non autoris\xe9 \xe0 fournir des services le ${date}`,
    hi: (date)=>`${date} \u{915}\u{94B} \u{938}\u{947}\u{935}\u{93E}\u{90F}\u{902} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{928} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{927}\u{93F}\u{915}\u{943}\u{924} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}`,
    ht: (date)=>`Pa gen otorizasyon pou bay s\xe8vis sou ${date}`,
    it: (date)=>`Non autorizzato a fornire servizi il ${date}`,
    ja: (date)=>`${date}\u{65E5}\u{306B}\u{306F}\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{63D0}\u{4F9B}\u{306E}\u{8A31}\u{53EF}\u{306A}\u{3057}`,
    ko: (date)=>`${date}\u{C77C}\u{C5D0} \u{C11C}\u{BE44}\u{C2A4} \u{C81C}\u{ACF5} \u{AD8C}\u{D55C}\u{C774} \u{C5C6}\u{C74C}`,
    mww: (date)=>`Tsis tau kev tso cai muab kev pab rau hnub ${date}`,
    ps: (date)=>`\u{62F} ${date} \u{646}\u{6D0}\u{67C}\u{647} \u{62F} \u{62E}\u{62F}\u{645}\u{62A}\u{648}\u{646}\u{648} \u{648}\u{693}\u{627}\u{646}\u{62F}\u{6D0} \u{6A9}\u{648}\u{644}\u{648} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{647} \u{62F}\u{647}`,
    pt: (date)=>`N\xe3o autorizado a prestar servi\xe7os em ${date}`,
    'pt-pt': (date)=>`N\xe3o autorizado a prestar servi\xe7os a ${date}`,
    ru: (date)=>`\u{41D}\u{435} \u{443}\u{43F}\u{43E}\u{43B}\u{43D}\u{43E}\u{43C}\u{43E}\u{447}\u{435}\u{43D} \u{43D}\u{430} \u{43F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435} \u{443}\u{441}\u{43B}\u{443}\u{433} ${date}`,
    sm: (date)=>`E le fa'atagaina e tu'uina atu auaunaga i le ${date}`,
    so: (date)=>`Looma oggolaan inay adeegyo bixiso ${date}`,
    th: (date)=>`\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E43}\u{E2B}\u{E49}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}\u{E43}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48} ${date}`,
    ur: (date)=>`${date} \u{6A9}\u{648} \u{62E}\u{62F}\u{645}\u{627}\u{62A} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: (date)=>`Kh\xf4ng \u{111}\u{1B0}\u{1EE3}c ph\xe9p cung c\u{1EA5}p d\u{1ECB}ch v\u{1EE5} v\xe0o ng\xe0y ${date}`,
    'zh-hans': (date)=>`4${date}\u{65E5}\u{672A}\u{83B7}\u{6388}\u{6743}\u{63D0}\u{4F9B}\u{670D}\u{52A1}`,
    'zh-hant': (date)=>`4${date}\u{65E5}\u{672A}\u{7372}\u{6388}\u{6B0A}\u{63D0}\u{4F9B}\u{670D}\u{52D9}`,
    en: (date)=>`Not authorized to provide services on ${date}`
};
const $b11db1b62d4a8f76$export$9e24ad1ff1e71692 = {
    ar: `\u{63A}\u{64A}\u{631} \u{645}\u{633}\u{62C}\u{644}\u{629}`,
    de: `Nicht eingeschrieben`,
    es: `No matriculado`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{646}\u{634}\u{62F}\u{647}`,
    fil: `Hindi nakatala`,
    fr: `Non inscrit`,
    hi: `\u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{93F}\u{924} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa enskri`,
    it: `Non iscritto`,
    ja: `\u{672A}\u{767B}\u{9332}`,
    ko: `\u{B4F1}\u{B85D}\u{D558}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj npe`,
    ps: `\u{62B}\u{628}\u{62A} \u{634}\u{648}\u{6CC} \u{646}\u{647} \u{6CC}\u{645}`,
    pt: `N\xe3o matriculado`,
    'pt-pt': `N\xe3o inscritos`,
    ru: `\u{41D}\u{435} \u{437}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}`,
    sm: `E le'i lesitala`,
    so: `Ma diiwaan gelin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}`,
    ur: `\u{62F}\u{627}\u{62E}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{627}`,
    vi: `Ch\u{1B0}a \u{111}\u{103}ng k\xfd`,
    'zh-hans': `\u{672A}\u{6CE8}\u{518C}`,
    'zh-hant': `\u{672A}\u{8A3B}\u{518A}`,
    en: `Not enrolled`
};
const $b11db1b62d4a8f76$export$b114e63c46d8a391 = {
    ar: `\u{645}\u{644}\u{627}\u{62D}\u{638}\u{627}\u{62A}`,
    de: `Anmerkungen`,
    es: `Notas`,
    fa: `\u{6CC}\u{627}\u{62F}\u{62F}\u{627}\u{634}\u{62A} \u{647}\u{627}`,
    fil: `Mga Tala`,
    fr: `Notes`,
    hi: `\u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `N\xf2t yo`,
    it: `Note`,
    ja: `\u{6CE8}\u{8A18}`,
    ko: `\u{C8FC}\u{C11D}`,
    mww: `Cov ntawv sau tseg`,
    ps: `\u{6CC}\u{627}\u{62F}\u{69A}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Notas`,
    'pt-pt': `Notas`,
    ru: `\u{41F}\u{440}\u{438}\u{43C}\u{435}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Faamatalaga`,
    so: `Xusuusin`,
    th: `\u{E2B}\u{E21}\u{E32}\u{E22}\u{E40}\u{E2B}\u{E15}\u{E38}`,
    ur: `\u{646}\u{648}\u{679}\u{633}`,
    vi: `Ghi ch\xfa`,
    'zh-hans': `\u{6CE8}\u{91CA}`,
    'zh-hant': `\u{8A3B}\u{91CB}`,
    en: `Notes`
};
const $b11db1b62d4a8f76$export$323c96d727586c01 = {
    ar: `\u{644}\u{645} \u{64A}\u{639}\u{62B}\u{631} \u{639}\u{644}\u{64A}\u{647}`,
    de: `Nicht gefunden`,
    es: `No encontrado`,
    fa: `\u{67E}\u{6CC}\u{62F}\u{627} \u{646}\u{634}\u{62F}`,
    fil: `Hindi natagpuan`,
    fr: `Non trouv\xe9`,
    hi: `\u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932}\u{93E}`,
    ht: `Pa jwenn`,
    it: `Non trovato`,
    ja: `\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{CC3E}\u{C9C0} \u{BABB}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis pom`,
    ps: `\u{648}\u{646}\u{647} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{634}\u{648}\u{644}`,
    pt: `N\xe3o encontrado`,
    'pt-pt': `N\xe3o encontrado`,
    ru: `\u{41D}\u{435} \u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}\u{43E}`,
    sm: `E le'i maua`,
    so: `Lama helin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}`,
    ur: `\u{646}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{644}\u{627}`,
    vi: `Kh\xf4ng t\xecm th\u{1EA5}y`,
    'zh-hans': `\u{672A}\u{627E}\u{5230}`,
    'zh-hant': `\u{672A}\u{627E}\u{5230}`,
    en: `Not found`
};
const $b11db1b62d4a8f76$export$1621713e0e89d236 = {
    ar: `\u{642}\u{62F} \u{64A}\u{643}\u{648}\u{646} \u{627}\u{644}\u{631}\u{627}\u{628}\u{637} \u{645}\u{643}\u{62A}\u{648}\u{628}\u{627} \u{628}\u{634}\u{643}\u{644} \u{62E}\u{627}\u{637}\u{626} \u{623}\u{648} \u{623}\u{646} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{628}\u{62D}\u{62B} \u{639}\u{646}\u{647}\u{627} \u{644}\u{645} \u{62A}\u{639}\u{62F} \u{645}\u{62A}\u{627}\u{62D}\u{629}.`,
    de: `Die URL kann falsch geschrieben sein oder die gesuchte Seite ist nicht mehr verf\xfcgbar.`,
    es: `La URL puede estar mal escrita o la p\xe1gina que buscas ya no est\xe9 disponible.`,
    fa: `\u{645}\u{645}\u{6A9}\u{646} \u{627}\u{633}\u{62A} \u{622}\u{62F}\u{631}\u{633} \u{627}\u{6CC}\u{646}\u{62A}\u{631}\u{646}\u{62A}\u{6CC} \u{627}\u{634}\u{62A}\u{628}\u{627}\u{647} \u{646}\u{648}\u{634}\u{62A}\u{647} \u{634}\u{62F}\u{647} \u{628}\u{627}\u{634}\u{62F} \u{6CC}\u{627} \u{635}\u{641}\u{62D}\u{647} \u{627}\u{6CC} \u{6A9}\u{647} \u{628}\u{647} \u{62F}\u{646}\u{628}\u{627}\u{644} \u{622}\u{646} \u{647}\u{633}\u{62A}\u{6CC}\u{62F} \u{62F}\u{6CC}\u{6AF}\u{631} \u{62F}\u{631} \u{62F}\u{633}\u{62A}\u{631}\u{633} \u{646}\u{628}\u{627}\u{634}\u{62F}.`,
    fil: `Maaaring mali ang spelling ng URL o hindi na available ang pahinang hinahanap mo.`,
    fr: `L\u{2019}URL peut \xeatre mal orthographi\xe9e ou la page que vous cherchez n\u{2019}est plus disponible.`,
    hi: `\u{939}\u{94B} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948} \u{915}\u{93F} URL \u{915}\u{940} \u{935}\u{930}\u{94D}\u{924}\u{928}\u{940} \u{917}\u{932}\u{924} \u{939}\u{94B} \u{92F}\u{93E} \u{906}\u{92A} \u{91C}\u{93F}\u{938} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{915}\u{940} \u{924}\u{932}\u{93E}\u{936} \u{915}\u{930} \u{930}\u{939}\u{947} \u{939}\u{948}\u{902} \u{935}\u{939} \u{905}\u{92C} \u{909}\u{92A}\u{932}\u{92C}\u{94D}\u{927} \u{928} \u{939}\u{94B}.`,
    ht: `URL la ka ekri mal oswa paj ou ap ch\xe8che a pa disponib ank\xf2.`,
    it: `L'URL potrebbe essere scritto male o la pagina che cerchi non \xe8 pi\xf9 disponibile.`,
    ja: `URL\u{306E}\u{30B9}\u{30DA}\u{30EB}\u{30DF}\u{30B9}\u{3084}\u{3001}\u{304A}\u{63A2}\u{3057}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{304C}\u{3082}\u{3046}\u{5229}\u{7528}\u{3067}\u{304D}\u{3066}\u{3044}\u{306A}\u{3044}\u{53EF}\u{80FD}\u{6027}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `URL\u{C774} \u{C798}\u{BABB} \u{C4F0}\u{C600}\u{AC70}\u{B098}, \u{CC3E}\u{ACE0} \u{C788}\u{B294} \u{D398}\u{C774}\u{C9C0}\u{AC00} \u{B354} \u{C774}\u{C0C1} \u{C81C}\u{ACF5}\u{B418}\u{C9C0} \u{C54A}\u{C744} \u{C218}\u{B3C4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov URL yuav raug sau yuam kev lossis nplooj ntawv koj tab tom nrhiav tsis muaj lawm.`,
    ps: `\u{645}\u{645}\u{6A9}\u{646} URL \u{63A}\u{644}\u{637} \u{644}\u{6CC}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{648}\u{6CC} \u{6CC}\u{627} \u{647}\u{63A}\u{647} \u{67E}\u{627}\u{6BC}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{6CC}\u{6D0} \u{644}\u{67C}\u{648}\u{626} \u{646}\u{648}\u{631} \u{634}\u{62A}\u{648}\u{646} \u{648}\u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: `A URL pode estar com erros ortogr\xe1ficos ou a p\xe1gina que voc\xea procura n\xe3o est\xe1 mais dispon\xedvel.`,
    'pt-pt': `O URL pode estar mal escrito ou a p\xe1gina que procura j\xe1 n\xe3o est\xe1 dispon\xedvel.`,
    ru: `URL \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{430}\u{43F}\u{438}\u{441}\u{430}\u{43D} \u{441} \u{43E}\u{448}\u{438}\u{431}\u{43A}\u{43E}\u{439} \u{438}\u{43B}\u{438} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{443}\u{44E} \u{432}\u{44B} \u{438}\u{449}\u{435}\u{442}\u{435}, \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}.`,
    sm: `E mafai ona sese le sipelaga o le URL pe o le itulau o lo'o e sailia e le o toe maua.`,
    so: `URL-ka waxaa laga yaabaa inuu khaldan yahay ama bogga aad raadineyso hadda lama heli karo.`,
    th: `URL \u{E2D}\u{E32}\u{E08}\u{E2A}\u{E30}\u{E01}\u{E14}\u{E1C}\u{E34}\u{E14}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E21}\u{E2D}\u{E07}\u{E2B}\u{E32}\u{E44}\u{E21}\u{E48}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E2D}\u{E35}\u{E01}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}`,
    ur: `\u{6CC}\u{648} \u{622}\u{631} \u{627}\u{6CC}\u{644} \u{63A}\u{644}\u{637} \u{627}\u{645}\u{644}\u{627} \u{6C1}\u{648} \u{633}\u{6A9}\u{62A}\u{627} \u{6C1}\u{6D2} \u{6CC}\u{627} \u{62C}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{6A9}\u{6CC} \u{622}\u{67E} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631} \u{631}\u{6C1}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{648}\u{6C1} \u{627}\u{628} \u{62F}\u{633}\u{62A}\u{6CC}\u{627}\u{628} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `URL c\xf3 th\u{1EC3} b\u{1ECB} sai ch\xednh t\u{1EA3} ho\u{1EB7}c trang b\u{1EA1}n \u{111}ang t\xecm ki\u{1EBF}m kh\xf4ng c\xf2n n\u{1EEF}a.`,
    'zh-hans': `URL\u{53EF}\u{80FD}\u{62FC}\u{5199}\u{9519}\u{8BEF}\u{FF0C}\u{6216}\u{8005}\u{4F60}\u{60F3}\u{8981}\u{7684}\u{9875}\u{9762}\u{5DF2}\u{4E0D}\u{518D}\u{53EF}\u{7528}\u{3002}`,
    'zh-hant': `\u{7DB2}\u{5740}\u{53EF}\u{80FD}\u{62FC}\u{932F}\u{FF0C}\u{6216}\u{4F60}\u{5C0B}\u{627E}\u{7684}\u{9801}\u{9762}\u{5DF2}\u{7121}\u{6CD5}\u{53D6}\u{5F97}\u{3002}`,
    en: `The URL may be misspelled or the page you're looking for is no longer available.`
};
const $b11db1b62d4a8f76$export$6c160a05a0ea4da0 = {
    ar: `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{649} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} \u{627}\u{644}\u{62A}\u{64A} \u{637}\u{644}\u{628}\u{62A}\u{647}\u{627}.`,
    de: `Die von Ihnen angeforderte Seite kann nicht gefunden werden.`,
    es: `No se puede encontrar la p\xe1gina que solicitaste.`,
    fa: `\u{635}\u{641}\u{62D}\u{647} \u{627}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{6A9}\u{631}\u{62F}\u{647} \u{628}\u{648}\u{62F}\u{6CC}\u{62F} \u{67E}\u{6CC}\u{62F}\u{627} \u{646}\u{645}\u{6CC} \u{634}\u{648}\u{62F}.`,
    fil: `Hindi matagpuan ang pahinang hiniling mo.`,
    fr: `La page que vous avez demand\xe9e est introuvable.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927}\u{93F}\u{924} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{928}\u{939}\u{940}\u{902} \u{922}\u{942}\u{901}\u{922}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E}.`,
    ht: `Paj ou mande a pa ka jwenn.`,
    it: `La pagina che hai richiesto non \xe8 disponibile.`,
    ja: `\u{3054}\u{4F9D}\u{983C}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{306F}\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C694}\u{CCAD}\u{D558}\u{C2E0} \u{D398}\u{C774}\u{C9C0}\u{B97C} \u{CC3E}\u{C744} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Nplooj ntawv koj thov nrhiav tsis tau.`,
    ps: `\u{647}\u{63A}\u{647} \u{67E}\u{627}\u{6BC}\u{647} \u{686}\u{6D0} \u{62A}\u{627} \u{63A}\u{648}\u{69A}\u{62A}\u{6D0} \u{646}\u{647} \u{62F}\u{647} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{6A9}\u{6D0}\u{62F}\u{627}\u{6CC}.`,
    pt: `A p\xe1gina que voc\xea solicitou n\xe3o pode ser encontrada.`,
    'pt-pt': `A p\xe1gina que pediu n\xe3o pode ser encontrada.`,
    ru: `\u{421}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{443}\u{44E} \u{432}\u{44B} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{438}\u{43B}\u{438}, \u{43D}\u{435} \u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}\u{430}.`,
    sm: `E le mafai ona maua le itulau na e talosagaina.`,
    so: `Bogga aad codsatay lama heli karo.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E23}\u{E49}\u{E2D}\u{E07}\u{E02}\u{E2D}`,
    ur: `\u{648}\u{6C1} \u{635}\u{641}\u{62D}\u{6C1} \u{62C}\u{648} \u{622}\u{67E} \u{646}\u{6D2} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{6A9}\u{6CC} \u{62A}\u{6BE}\u{6CC} \u{648}\u{6C1} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{644} \u{631}\u{6C1}\u{627}\u{6D4}`,
    vi: `Kh\xf4ng th\u{1EC3} t\xecm th\u{1EA5}y trang b\u{1EA1}n y\xeau c\u{1EA7}u.`,
    'zh-hans': `\u{60A8}\u{8BF7}\u{6C42}\u{7684}\u{9875}\u{9762}\u{65E0}\u{6CD5}\u{627E}\u{5230}\u{3002}`,
    'zh-hant': `\u{60A8}\u{6240}\u{8981}\u{6C42}\u{7684}\u{9801}\u{9762}\u{7121}\u{6CD5}\u{627E}\u{5230}\u{3002}`,
    en: `The page you requested cannot be found.`
};
const $b11db1b62d4a8f76$export$fff7de9eec117c98 = {
    ar: `\u{644}\u{627} \u{64A}\u{648}\u{62C}\u{62F} \u{634}\u{64A}\u{621} \u{644}\u{644}\u{645}\u{639}\u{627}\u{64A}\u{646}\u{629}`,
    de: `Nichts zum Vorschauen`,
    es: `Nada que previsualizar`,
    fa: `\u{686}\u{6CC}\u{632}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{67E}\u{6CC}\u{634} \u{646}\u{645}\u{627}\u{6CC}\u{634} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang dapat i-preview`,
    fr: `Rien \xe0 pr\xe9visualiser`,
    hi: `\u{92A}\u{942}\u{930}\u{94D}\u{935}\u{93E}\u{935}\u{932}\u{94B}\u{915}\u{928} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{941}\u{91B} \u{92D}\u{940} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen anyen pou aper\xe7u`,
    it: `Niente da anticipare`,
    ja: `\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}\u{3059}\u{308B}\u{3082}\u{306E}\u{306F}\u{4F55}\u{3082}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{BBF8}\u{B9AC} \u{BCFC} \u{B9CC}\u{D55C} \u{AC83}\u{C740} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj dab tsi los saib ua ntej`,
    ps: `\u{647}\u{6CC}\u{685} \u{646}\u{69A}\u{6D0} \u{646}\u{634}\u{62A}\u{647} \u{686}\u{6D0} \u{645}\u{62E}\u{6A9}\u{6D0} \u{648}\u{6AB}\u{648}\u{631}\u{645}`,
    pt: `Nada para pr\xe9-visualizar`,
    'pt-pt': `Nada para pr\xe9-visualizar`,
    ru: `\u{41D}\u{435}\u{447}\u{435}\u{433}\u{43E} \u{43F}\u{440}\u{435}\u{434}\u{432}\u{430}\u{440}\u{438}\u{442}\u{44C}`,
    sm: `Leai se mea e muai va'ai`,
    so: `Waxba ma jiraan oo la saadaalin karo`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E2D}\u{E30}\u{E44}\u{E23}\u{E43}\u{E2B}\u{E49}\u{E14}\u{E39}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}`,
    ur: `\u{67E}\u{6CC}\u{634} \u{646}\u{638}\u{627}\u{631}\u{6C1} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{6A9}\u{686}\u{6BE} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 g\xec \u{111}\u{1EC3} xem tr\u{1B0}\u{1EDB}c`,
    'zh-hans': `\u{6CA1}\u{6709}\u{4EC0}\u{4E48}\u{53EF}\u{9884}\u{89C8}\u{7684}`,
    'zh-hant': `\u{6C92}\u{6709}\u{4EC0}\u{9EBC}\u{597D}\u{9810}\u{89BD}\u{7684}`,
    en: `Nothing to preview`
};
const $b11db1b62d4a8f76$export$a9564ee2df9884f7 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646} \u{647}\u{630}\u{627} ${type} \u{62A}\u{645} \u{62A}\u{639}\u{64A}\u{64A}\u{646}\u{647} \u{644}\u{643}.`,
    de: (type)=>`Du bekommst Benachrichtigungen, weil dir diese ${type} zugewiesen wurde.`,
    es: (type)=>`Est\xe1s recibiendo notificaciones porque te asignaron esta ${type}.`,
    fa: (type)=>`\u{634}\u{645}\u{627} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{686}\u{648}\u{646} \u{627}\u{6CC}\u{646} ${type} \u{628}\u{647} \u{634}\u{645}\u{627} \u{627}\u{62E}\u{62A}\u{635}\u{627}\u{635} \u{62F}\u{627}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil naatasan ka sa ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications parce que cette ${type} vous a \xe9t\xe9 attribu\xe9e.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{915}\u{94B} \u{92F}\u{939} ${type} \u{905}\u{938}\u{93E}\u{907}\u{928} \u{915}\u{940} \u{917}\u{908} \u{925}\u{940}.`,
    ht: (type)=>`Ou ap resevwa notifikasyon paske yo te asiyen ${type} sa a.`,
    it: (type)=>`Stai ricevendo notifiche perch\xe9 ti \xe8 stata assegnata questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{304C}\u{5272}\u{308A}\u{5F53}\u{3066}\u{3089}\u{308C}\u{305F}\u{305F}\u{3081}\u{901A}\u{77E5}\u{304C}\u{5C4A}\u{3044}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type}\u{C774} \u{D560}\u{B2F9}\u{B418}\u{C5C8}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{B294} \u{AC83}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj tab tom tau txais cov ntawv ceeb toom vim tias koj tau muab txoj ${type} no.`,
    ps: (type)=>`\u{62A}\u{647} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{6D0} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62F}\u{627} ${type} \u{62F}\u{631}\u{6A9}\u{693}\u{644} \u{634}\u{648}\u{6CC}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque foi designado para essa ${type}.`,
    'pt-pt': (type)=>`Est\xe1 a receber notifica\xe7\xf5es porque lhe foi atribu\xedda esta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{432}\u{430}\u{43C} \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{438}\u{43B}\u{438} \u{44D}\u{442}\u{443} ${type}.`,
    sm: (type)=>`O loo e mauaina ni faasilasilaga ona sa tofia oe i lenei ${type}`,
    so: (type)=>`Waxaad helaysaa ogeysiisyo sababtoo ah waxaa laguu ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{646}\u{648}\u{679}\u{6CC}\u{641}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646}\u{632} \u{627}\u{633} \u{644}\u{6CC}\u{6D2} \u{645}\u{644} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{6A9}\u{648} \u{6CC}\u{6C1} ${type} \u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{6A9}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec b\u{1EA1}n \u{111}\u{1B0}\u{1EE3}c ch\u{1EC9} \u{111}\u{1ECB}nh ${type} n\xe0y.`,
    'zh-hans': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{4E3A}\u{4F60}\u{88AB}\u{5206}\u{914D}\u{4E86}\u{8FD9}\u{9879} ${type}\u{3002}`,
    'zh-hant': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{70BA}\u{4F60}\u{88AB}\u{5206}\u{914D}\u{4E86}\u{9019}\u{500B} ${type}\u{3002}`,
    en: (type)=>`You're receiving notifications because you were assigned this ${type}.`
};
const $b11db1b62d4a8f76$export$9e80186c98919fd3 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{643} \u{62A}\u{645} \u{627}\u{644}\u{627}\u{634}\u{62A}\u{631}\u{627}\u{643} \u{62A}\u{644}\u{642}\u{627}\u{626}\u{64A}\u{627} \u{641}\u{64A} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Du bekommst Benachrichtigungen, weil du automatisch f\xfcr diese ${type} abonniert wurdest.`,
    es: (type)=>`Est\xe1s recibiendo notificaciones porque estabas suscrito autom\xe1ticamente a esta ${type}.`,
    fa: (type)=>`\u{634}\u{645}\u{627} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{686}\u{648}\u{646} \u{628}\u{647} \u{637}\u{648}\u{631} \u{62E}\u{648}\u{62F}\u{6A9}\u{627}\u{631} \u{62F}\u{631} \u{627}\u{6CC}\u{646} ${type} \u{645}\u{634}\u{62A}\u{631}\u{6A9} \u{634}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil awtomatikong naka-subscribe ka sa ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications parce que vous \xe9tiez automatiquement abonn\xe9 \xe0 cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{928}\u{947} \u{907}\u{938} ${type} \u{915}\u{940} \u{938}\u{94D}\u{935}\u{91A}\u{93E}\u{932}\u{93F}\u{924} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{932}\u{947} \u{932}\u{940} \u{939}\u{948}.`,
    ht: (type)=>`Ou ap resevwa notifikasyon paske ou te enskri otomatikman nan ${type} sa a.`,
    it: (type)=>`Ricevi notifiche perch\xe9 sei stato automaticamente iscritto a questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{306B}\u{81EA}\u{52D5}\u{7684}\u{306B}\u{767B}\u{9332}\u{3055}\u{308C}\u{305F}\u{305F}\u{3081}\u{901A}\u{77E5}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{3063}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type}\u{C5D0} \u{C790}\u{B3D9}\u{C73C}\u{B85C} \u{AD6C}\u{B3C5}\u{B418}\u{C5C8}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{B294} \u{AC83}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj tab tom tau txais cov ntawv ceeb toom vim tias koj tau cia li sau npe rau qhov ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{67E}\u{647} \u{627}\u{62A}\u{648}\u{645}\u{627}\u{62A} \u{689}\u{648}\u{644} \u{62F} \u{62F}\u{6D0} ${type} \u{6AB}\u{689}\u{648}\u{646} \u{6A9}\u{693}\u{6CC} \u{6CC}\u{627}\u{633}\u{62A}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque foi automaticamente assinado ${type}.`,
    'pt-pt': (type)=>`Est\xe1 a receber notifica\xe7\xf5es porque foi automaticamente subscrito a esta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43B}\u{438}\u{441}\u{44C} \u{43D}\u{430} \u{44D}\u{442}\u{443} ${type}.`,
    sm: (type)=>`O loo e mauaina ni faasilasilaga ona sa otometi lava ona e lesitala i lenei ${type}`,
    so: (type)=>`Waxaad helaysaa ogeysiisyo sababtoo ah si toos ah ayaa laguu diiwaan geliyay ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E23}\u{E31}\u{E1A} ${type}\u{E19}\u{E35}\u{E49}\u{E42}\u{E14}\u{E22}\u{E2D}\u{E31}\u{E15}\u{E42}\u{E19}\u{E21}\u{E31}\u{E15}\u{E34}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{646}\u{648}\u{679}\u{6CC}\u{641}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646}\u{632} \u{627}\u{633} \u{644}\u{6CC}\u{6D2} \u{645}\u{644} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{62E}\u{648}\u{62F} \u{628}\u{62E}\u{648}\u{62F} \u{627}\u{633} ${type} \u{6A9}\u{648} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{6A9}\u{631} \u{686}\u{6A9}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec b\u{1EA1}n \u{111}\xe3 t\u{1EF1} \u{111}\u{1ED9}ng \u{111}\u{103}ng k\xfd ${type} n\xe0y.`,
    'zh-hans': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{4E3A}\u{4F60}\u{88AB}\u{81EA}\u{52A8}\u{8BA2}\u{9605}\u{4E86}\u{8FD9}\u{4E2A} ${type}\u{3002}`,
    'zh-hant': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{70BA}\u{4F60}\u{88AB}\u{81EA}\u{52D5}\u{8A02}\u{95B1}\u{4E86}\u{9019}\u{500B} ${type}\u{3002}`,
    en: (type)=>`You're receiving notifications because you were automatically subscribed to this ${type}.`
};
const $b11db1b62d4a8f76$export$3f7a9c0c6b45d6d2 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{643} \u{639}\u{644}\u{642}\u{62A} \u{639}\u{644}\u{649} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Du bekommst Benachrichtigungen, weil du zu dieser ${type} kommentiert hast.`,
    es: (type)=>`Est\xe1s recibiendo notificaciones porque has comentado sobre esta ${type}.`,
    fa: (type)=>`\u{634}\u{645}\u{627} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{686}\u{648}\u{646} \u{62F}\u{631}\u{628}\u{627}\u{631}\u{647} \u{627}\u{6CC}\u{646} ${type} \u{646}\u{638}\u{631} \u{62F}\u{627}\u{62F}\u{6CC}\u{62F}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil nagkomento ka sa ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications parce que vous avez comment\xe9 cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{928}\u{947} \u{907}\u{938} ${type} \u{92A}\u{930} \u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{940} \u{915}\u{940} \u{939}\u{948}.`,
    ht: (type)=>`Ou ap resevwa notifikasyon paske ou te f\xe8 k\xf2mant\xe8 sou ${type} sa a.`,
    it: (type)=>`Ricevi notifiche perch\xe9 hai commentato questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{306B}\u{30B3}\u{30E1}\u{30F3}\u{30C8}\u{3057}\u{305F}\u{3053}\u{3068}\u{3067}\u{901A}\u{77E5}\u{304C}\u{5C4A}\u{304F}\u{306E}\u{3067}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type}\u{C5D0} \u{B313}\u{AE00}\u{C744} \u{B2EC}\u{C558}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{B294} \u{AC70}\u{C608}\u{C694}.`,
    mww: (type)=>`Koj tau txais cov ntawv ceeb toom vim tias koj tau tawm tswv yim txog qhov ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{67E}\u{647} ${type} \u{62A}\u{628}\u{635}\u{631}\u{647} \u{6A9}\u{693}\u{6D0} \u{62F}\u{647}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque comentou sobre essa ${type}.`,
    'pt-pt': (type)=>`Est\xe1 a receber notifica\xe7\xf5es porque comentou esta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{43F}\u{440}\u{43E}\u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43B}\u{438} \u{44D}\u{442}\u{443} ${type}.`,
    sm: (type)=>`O lo'o e mauaina ni fa'asilasilaga ona ua e fa'amatalaina lenei ${type}.`,
    so: (type)=>`Waxaad helaysaa ogeysiisyo sababtoo ah waxaad faallo ka bixisay ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E41}\u{E2A}\u{E14}\u{E07}\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E01}\u{E31}\u{E1A} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} ${type} \u{67E}\u{631} \u{62A}\u{628}\u{635}\u{631}\u{6C1} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{648}\u{62C}\u{6C1} \u{633}\u{6D2} \u{646}\u{648}\u{679}\u{6CC}\u{641}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646}\u{632} \u{645}\u{644} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec b\u{1EA1}n \u{111}\xe3 nh\u{1EAD}n x\xe9t v\u{1EC1} ${type} n\xe0y.`,
    'zh-hans': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{4E3A}\u{4F60}\u{8BC4}\u{8BBA}\u{4E86}\u{8FD9}\u{9879} ${type}\u{3002}`,
    'zh-hant': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{70BA}\u{4F60}\u{5C0D} ${type}\u{7559}\u{8A00}\u{3002}`,
    en: (type)=>`You're receiving notifications because you commented on this ${type}.`
};
const $b11db1b62d4a8f76$export$d1d1e7344faf74a9 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{643} \u{623}\u{646}\u{634}\u{623}\u{62A} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Du bekommst Benachrichtigungen, weil du diese ${type} erstellt hast.`,
    es: (type)=>`Est\xe1s recibiendo notificaciones porque has creado esta ${type}.`,
    fa: (type)=>`\u{634}\u{645}\u{627} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{686}\u{648}\u{646} \u{627}\u{6CC}\u{646} ${type} \u{631}\u{627} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil nilikha mo ang ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications parce que vous avez cr\xe9\xe9 cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{928}\u{947} \u{92F}\u{939} ${type} \u{92C}\u{928}\u{93E}\u{908} \u{939}\u{948}.`,
    ht: (type)=>`Ou ap resevwa notifikasyon paske ou te kreye ${type} sa a.`,
    it: (type)=>`Ricevi notifiche perch\xe9 hai creato questa ${type}.`,
    ja: (type)=>`\u{3042}\u{306A}\u{305F}\u{304C}\u{3053}\u{306E} ${type}\u{3092}\u{4F5C}\u{6210}\u{3057}\u{305F}\u{305F}\u{3081}\u{306B}\u{901A}\u{77E5}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{3063}\u{3066}\u{3044}\u{308B}\u{306E}\u{3067}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type} \u{C0DD}\u{C131}\u{D588}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{B294} \u{AC83}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj tau txais cov ntawv ceeb toom vim tias koj tau tsim qhov ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{62F}\u{627} ${type} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{6CC} \u{62F}\u{6CC}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque criou essa ${type}.`,
    'pt-pt': (type)=>`Est\xe1 a receber notifica\xe7\xf5es porque criou esta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43B}\u{438} \u{44D}\u{442}\u{443} ${type}.`,
    sm: (type)=>`O loo e mauaina ni faasilasilaga ona sa e fatuina lenei ${type}.`,
    so: (type)=>`Waxaad helaysaa ogeysiisyo sababtoo ah adigu waad ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{646}\u{648}\u{679}\u{6CC}\u{641}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646}\u{632} \u{627}\u{633} \u{644}\u{6CC}\u{6D2} \u{645}\u{644} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{646}\u{6D2} \u{6CC}\u{6C1} ${type} \u{628}\u{646}\u{627}\u{626}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec \u{111}\xe3 t\u{1EA1}o ${type} n\xe0y.`,
    'zh-hans': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{4E3A}\u{4F60}\u{521B}\u{5EFA}\u{4E86}\u{8FD9}\u{4E2A} ${type}\u{3002}`,
    'zh-hant': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{70BA}\u{4F60}\u{5EFA}\u{7ACB}\u{4E86}\u{9019}\u{500B} ${type}\u{3002}`,
    en: (type)=>`You're receiving notifications because you created this ${type}.`
};
const $b11db1b62d4a8f76$export$a34bc0eefd7e0f6 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{643} \u{627}\u{634}\u{62A}\u{631}\u{643}\u{62A} \u{641}\u{64A} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Sie erhalten Benachrichtigungen, weil Sie diese ${type} abonniert haben.`,
    es: (type)=>`Est\xe1s recibiendo notificaciones porque te suscribiste a esta ${type}.`,
    fa: (type)=>`\u{634}\u{645}\u{627} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{686}\u{648}\u{646} \u{62F}\u{631} \u{627}\u{6CC}\u{646} ${type} \u{639}\u{636}\u{648} \u{634}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil nag-subscribe ka sa ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications parce que vous vous \xeates abonn\xe9 \xe0 cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{928}\u{947} \u{907}\u{938} ${type} \u{915}\u{940} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{932}\u{940} \u{939}\u{948}.`,
    ht: (type)=>`Ou ap resevwa notifikasyon paske ou te ab\xf2nman nan ${type} sa a.`,
    it: (type)=>`Stai ricevendo notifiche perch\xe9 ti sei iscritto a questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{3092}\u{8CFC}\u{8AAD}\u{3057}\u{305F}\u{305F}\u{3081}\u{901A}\u{77E5}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{3063}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type} \u{AD6C}\u{B3C5}\u{D588}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{B294} \u{AC83}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj tau txais cov ntawv ceeb toom vim tias koj tau sau npe rau qhov ${type} no.`,
    ps: (type)=>`\u{62A}\u{647} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{6D0} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{647} \u{62F}\u{6D0} ${type} \u{62A}\u{647} \u{6AB}\u{689}\u{648}\u{646} \u{6A9}\u{693}\u{6CC} \u{62F}\u{6CC}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque se inscreveu ${type}.`,
    'pt-pt': (type)=>`Est\xe1 a receber notifica\xe7\xf5es porque subscreveu esta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43B}\u{438}\u{441}\u{44C} \u{43D}\u{430} \u{44D}\u{442}\u{443} ${type}.`,
    sm: (type)=>`O lo'o e mauaina fa'asilasilaga ona ua e lesitala i lenei ${type}.`,
    so: (type)=>`Waxaad helaysaa ogeysiisyo sababtoo ah waxaad isdiiwaangelisay ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E23}\u{E31}\u{E1A} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{646}\u{648}\u{679}\u{6CC}\u{641}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646}\u{632} \u{627}\u{633} \u{644}\u{6CC}\u{6D2} \u{645}\u{644} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{646}\u{6D2} \u{627}\u{633} ${type} \u{6A9}\u{648} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{6A9}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec \u{111}\xe3 \u{111}\u{103}ng k\xfd ${type} n\xe0y.`,
    'zh-hans': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{4E3A}\u{4F60}\u{8BA2}\u{9605}\u{4E86}\u{8FD9}\u{4E2A} ${type}\u{3002}`,
    'zh-hant': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{70BA}\u{4F60}\u{8A02}\u{95B1}\u{4E86}\u{9019}\u{500B} ${type}\u{3002}`,
    en: (type)=>`You're receiving notifications because you subscribed to this ${type}.`
};
const $b11db1b62d4a8f76$export$d5792a6242510aa5 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{643} \u{630}\u{643}\u{631}\u{62A} \u{645}\u{628}\u{627}\u{634}\u{631}\u{629} \u{641}\u{64A} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Sie erhalten Benachrichtigungen, weil Sie in dieser ${type} direkt erw\xe4hnt wurden.`,
    es: (type)=>`Est\xe1s recibiendo notificaciones porque te mencionaron directamente en esta ${type}.`,
    fa: (type)=>`\u{634}\u{645}\u{627} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{686}\u{648}\u{646} \u{645}\u{633}\u{62A}\u{642}\u{6CC}\u{645}\u{627} \u{62F}\u{631} \u{627}\u{6CC}\u{646} ${type} \u{646}\u{627}\u{645} \u{628}\u{631}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil direktang binanggit ka sa ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications parce que vous avez \xe9t\xe9 directement mentionn\xe9 dans cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{907}\u{938} ${type} \u{92E}\u{947}\u{902} \u{906}\u{92A}\u{915}\u{93E} \u{938}\u{940}\u{927}\u{947} \u{909}\u{932}\u{94D}\u{932}\u{947}\u{916} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E}.`,
    ht: (type)=>`Ou ap resevwa notifikasyon paske ou te mansyone dir\xe8kteman nan ${type} sa a.`,
    it: (type)=>`Stai ricevendo notifiche perch\xe9 sei stato menzionato direttamente in questa ${type}.`,
    ja: (type)=>`\u{3042}\u{306A}\u{305F}\u{304C}\u{901A}\u{77E5}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{3063}\u{3066}\u{3044}\u{308B}\u{306E}\u{306F}\u{3001}\u{3053}\u{306E} ${type}\u{3067}\u{76F4}\u{63A5}\u{8A00}\u{53CA}\u{3055}\u{308C}\u{305F}\u{304B}\u{3089}\u{3067}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type}\u{C5D0}\u{C11C} \u{C9C1}\u{C811} \u{C5B8}\u{AE09}\u{B418}\u{C5C8}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{B294} \u{AC70}\u{C608}\u{C694}.`,
    mww: (type)=>`Koj tau txais cov ntawv ceeb toom vim tias koj tau hais ncaj qha hauv qhov ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{67E}\u{647} ${type} \u{6A9}\u{6D0} \u{645}\u{633}\u{62A}\u{642}\u{6CC}\u{645} \u{6CC}\u{627}\u{62F} \u{634}\u{648}\u{6CC} \u{6CC}\u{627}\u{633}\u{62A}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque foi mencionado diretamente nesta ${type}.`,
    'pt-pt': (type)=>`Est\xe1s a receber notifica\xe7\xf5es porque foste mencionado diretamente nesta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{432}\u{430}\u{441} \u{43D}\u{430}\u{43F}\u{440}\u{44F}\u{43C}\u{443}\u{44E} \u{443}\u{43F}\u{43E}\u{43C}\u{44F}\u{43D}\u{443}\u{43B}\u{438} \u{432} ${type}.`,
    sm: (type)=>`O loo e mauaina ni faasilasilaga ona sa ta'ua sa'o lava oe i lenei ${type}`,
    so: (type)=>`Waxaad helaysaa ogeysiisyo sababtoo ah si toos ah laguu xusay ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}\u{E04}\u{E38}\u{E13}\u{E42}\u{E14}\u{E22}\u{E15}\u{E23}\u{E07}\u{E43}\u{E19} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{646}\u{648}\u{679}\u{6CC}\u{641}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646}\u{632} \u{627}\u{633} \u{644}\u{6CC}\u{6D2} \u{645}\u{644} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{6A9}\u{627} \u{628}\u{631}\u{627}\u{6C1} \u{631}\u{627}\u{633}\u{62A} \u{630}\u{6A9}\u{631} \u{627}\u{633} ${type} \u{645}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{62A}\u{6BE}\u{627}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec b\u{1EA1}n \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EC1} c\u{1EAD}p tr\u{1EF1}c ti\u{1EBF}p trong ${type} n\xe0y.`,
    'zh-hans': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{4E3A}\u{4F60}\u{5728}\u{8FD9}\u{6B21} ${type}\u{4E2D}\u{88AB}\u{76F4}\u{63A5}\u{63D0}\u{53CA}\u{3002}`,
    'zh-hant': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{70BA}\u{4F60}\u{88AB}\u{76F4}\u{63A5}\u{63D0}\u{5230}\u{4E86}\u{9019}\u{500B} ${type}\u{3002}`,
    en: (type)=>`You're receiving notifications because you were directly mentioned in this ${type}.`
};
const $b11db1b62d4a8f76$export$a07a7cb78e70dc7 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{644}\u{627} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Sie erhalten keine Benachrichtigungen f\xfcr diese ${type}.`,
    es: (type)=>`No est\xe1s recibiendo notificaciones de esta ${type}.`,
    fa: (type)=>`\u{634}\u{645}\u{627} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{6CC}\u{646} ${type} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{646}\u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: (type)=>`Hindi ka nakakatanggap ng mga abiso para sa ${type} na ito.`,
    fr: (type)=>`Vous ne recevez pas de notifications pour cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{907}\u{938} ${type} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902}.`,
    ht: (type)=>`Ou pa resevwa notifikasyon pou ${type} sa a.`,
    it: (type)=>`Non ricevi notifiche per questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{306B}\u{95A2}\u{3059}\u{308B}\u{901A}\u{77E5}\u{306F}\u{5C4A}\u{3044}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (type)=>`\u{C774} ${type}\u{C5D0} \u{B300}\u{D55C} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{C9C0} \u{BABB}\u{D558}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj tsis tau txais kev ceeb toom rau ${type}.`,
    ps: (type)=>`\u{62A}\u{647} \u{62F} ${type} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{646}\u{647} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{6D0}.`,
    pt: (type)=>`Voc\xea n\xe3o est\xe1 recebendo notifica\xe7\xf5es dessa ${type}.`,
    'pt-pt': (type)=>`N\xe3o est\xe1 a receber notifica\xe7\xf5es desta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43D}\u{435} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{43E}\u{431} \u{44D}\u{442}\u{43E}\u{439} ${type}.`,
    sm: (type)=>`E te le o mauaina ni faasilasilaga mo lenei ${type}`,
    so: (type)=>`Ma helaysid ogeysiisyo ku saabsan ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} ${type} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{646}\u{648}\u{679}\u{6CC}\u{641}\u{6A9}\u{6CC}\u{634}\u{646} \u{645}\u{648}\u{635}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648} \u{631}\u{6C1}\u{6D2}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n kh\xf4ng nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\u{1EC1} ${type} n\xe0y.`,
    'zh-hans': (type)=>`\u{4F60}\u{4E0D}\u{4F1A}\u{6536}\u{5230}\u{8FD9}\u{4E2A} ${type}\u{7684}\u{901A}\u{77E5}\u{3002}`,
    'zh-hant': (type)=>`\u{4F60}\u{4E0D}\u{6703}\u{6536}\u{5230}\u{9019}\u{9805} ${type}\u{7684}\u{901A}\u{77E5}\u{3002}`,
    en: (type)=>`You're not receiving notifications for this ${type}.`
};
const $b11db1b62d4a8f76$export$94b61b888e588ac2 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646} \u{641}\u{631}\u{64A}\u{642}\u{627} \u{623}\u{646}\u{62A} \u{639}\u{636}\u{648} \u{641}\u{64A}\u{647} \u{630}\u{643}\u{631} \u{641}\u{64A} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Sie erhalten Benachrichtigungen, weil ein Team, dem Sie angeh\xf6ren, in dieser ${type} erw\xe4hnt wurde.`,
    es: (type)=>`Est\xe1s recibiendo notificaciones porque se mencion\xf3 a un equipo del que eres miembro en esta ${type}.`,
    fa: (type)=>`\u{634}\u{645}\u{627} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{686}\u{648}\u{646} \u{62A}\u{6CC}\u{645}\u{6CC} \u{6A9}\u{647} \u{639}\u{636}\u{648} \u{622}\u{646} \u{647}\u{633}\u{62A}\u{6CC}\u{62F} \u{62F}\u{631} \u{627}\u{6CC}\u{646} ${type} \u{630}\u{6A9}\u{631} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil ang isang koponan na iyong kinabibilangan ay binanggit sa ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications parce qu\u{2019}une \xe9quipe dont vous faites partie a \xe9t\xe9 mentionn\xe9e dans cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{907}\u{938} ${type} \u{92E}\u{947}\u{902} \u{906}\u{92A} \u{91C}\u{93F}\u{938} \u{91F}\u{940}\u{92E} \u{915}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{939}\u{948}\u{902}, \u{909}\u{938}\u{915}\u{93E} \u{909}\u{932}\u{94D}\u{932}\u{947}\u{916} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E}.`,
    ht: (type)=>`Ou ap resevwa notifikasyon paske yon ekip ou se yon manm nan te mansyone nan ${type} sa a.`,
    it: (type)=>`Ricevi notifiche perch\xe9 in questa ${type} \xe8 stato menzionato un team di cui fai parte.`,
    ja: (type)=>`\u{3042}\u{306A}\u{305F}\u{304C}\u{6240}\u{5C5E}\u{3057}\u{3066}\u{3044}\u{308B}\u{30C1}\u{30FC}\u{30E0}\u{304C}\u{3053}\u{306E} ${type}\u{3067}\u{8A00}\u{53CA}\u{3055}\u{308C}\u{305F}\u{305F}\u{3081}\u{306B}\u{901A}\u{77E5}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{3063}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (type)=>`\u{B2F9}\u{C2E0}\u{C774} \u{C18D}\u{D55C} \u{D300}\u{C774} \u{C774} ${type}\u{C5D0} \u{C5B8}\u{AE09}\u{B418}\u{C5B4} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{B294} \u{AC83}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj tab tom tau txais cov ntawv ceeb toom vim tias ib pab neeg koj yog ib tus tswv cuab tau hais hauv qhov ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{6CC}\u{648} \u{67C}\u{6CC}\u{645} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{6CC}\u{6D0} \u{63A}\u{693}\u{6CC} \u{6CC}\u{627}\u{633}\u{62A}\u{60C} \u{67E}\u{647} \u{62F}\u{6D0} ${type} \u{6A9}\u{6D0} \u{6CC}\u{627}\u{62F} \u{634}\u{648}\u{6CC} \u{648}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque uma equipe da qual faz parte foi mencionada nesta ${type}.`,
    'pt-pt': (type)=>`Est\xe1s a receber notifica\xe7\xf5es porque uma equipa da qual fazes parte foi mencionada nesta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{432} \u{44D}\u{442}\u{43E}\u{439} ${type} \u{431}\u{44B}\u{43B}\u{430} \u{443}\u{43F}\u{43E}\u{43C}\u{44F}\u{43D}\u{443}\u{442}\u{430} \u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{430}, \u{432} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{43E}\u{439} \u{432}\u{44B} \u{44F}\u{432}\u{43B}\u{44F}\u{435}\u{442}\u{435}\u{441}\u{44C}.`,
    sm: (type)=>`O lo'o e mauaina ni fa'asilasilaga ona o se 'au o oe o se sui na ta'ua i lenei ${type}.`,
    so: (type)=>`Waxaad helaysaa ogeysiisyo sababtoo ah koox aad xubin ka tahay ayaa lagu xusay ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}\u{E17}\u{E35}\u{E21}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E43}\u{E19} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{646}\u{648}\u{679}\u{6CC}\u{641}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646}\u{632} \u{627}\u{633} \u{644}\u{6CC}\u{6D2} \u{645}\u{644} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{627}\u{633} ${type} \u{645}\u{6CC}\u{6BA} \u{62C}\u{633} \u{679}\u{6CC}\u{645} \u{6A9}\u{627} \u{622}\u{67E} \u{631}\u{6A9}\u{646} \u{6C1}\u{6CC}\u{6BA} \u{627}\u{633} \u{6A9}\u{627} \u{630}\u{6A9}\u{631} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{62A}\u{6BE}\u{627}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec nh\xf3m m\xe0 b\u{1EA1}n l\xe0 th\xe0nh vi\xean \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EC1} c\u{1EAD}p trong ${type} n\xe0y.`,
    'zh-hans': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{4E3A}\u{4F60}\u{6240}\u{5728}\u{7684}\u{56E2}\u{961F}\u{5728}\u{672C}\u{6B21} ${type}\u{4E2D}\u{88AB}\u{63D0}\u{53CA}\u{3002}`,
    'zh-hant': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{70BA}\u{4F60}\u{6240}\u{5C6C}\u{7684}\u{5718}\u{968A}\u{88AB}\u{63D0}\u{53CA}\u{3002}${type}`,
    en: (type)=>`You're receiving notifications because a team you're a member of was mentioned in this ${type}.`
};
const $b11db1b62d4a8f76$export$870104d5b672042c = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{644}\u{627} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{647}\u{630}\u{627} ${type} \u{644}\u{623}\u{646}\u{643} \u{623}\u{644}\u{63A}\u{64A}\u{62A} \u{627}\u{644}\u{627}\u{634}\u{62A}\u{631}\u{627}\u{643}.`,
    de: (type)=>`Du bekommst keine Benachrichtigungen f\xfcr diese ${type} , weil du dich abgemeldet hast.`,
    es: (type)=>`No est\xe1s recibiendo notificaciones de esta ${type} porque te has dado de baja.`,
    fa: (type)=>`\u{628}\u{631}\u{627}\u{6CC} \u{627}\u{6CC}\u{646} ${type} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{646}\u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{686}\u{648}\u{646} \u{644}\u{63A}\u{648} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: (type)=>`Hindi ka nakakatanggap ng mga abiso para sa ${type} na ito dahil nag-unsubscribe ka.`,
    fr: (type)=>`Vous ne recevez pas de notifications pour cette ${type} parce que vous vous \xeates d\xe9sabonn\xe9.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{907}\u{938} ${type} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902}, \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{928}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{930} \u{926}\u{940} \u{939}\u{948}.`,
    ht: (type)=>`Ou pa resevwa notifikasyon pou ${type} sa a paske ou koupe ab\xf2nman.`,
    it: (type)=>`Non ricevi notifiche per questa ${type} perch\xe9 ti sei disiscritto.`,
    ja: (type)=>`\u{8CFC}\u{8AAD}\u{3092}\u{89E3}\u{9664}\u{3057}\u{305F}\u{305F}\u{3081}\u{3001}\u{3053}\u{306E} ${type} \u{306E}\u{901A}\u{77E5}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{308C}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (type)=>`\u{AD6C}\u{B3C5}\u{C744} \u{CDE8}\u{C18C}\u{D588}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C774} ${type} \u{C5D0} \u{B300}\u{D55C} \u{C54C}\u{B9BC}\u{C774} \u{C624}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj tsis tau txais cov ntawv ceeb toom rau qhov ${type} no vim tias koj unsubscribed.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62F} ${type} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{646}\u{647} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{644}\u{63A}\u{648}\u{647} \u{6A9}\u{693}\u{6CC} \u{6CC}\u{627}\u{633}\u{62A}.`,
    pt: (type)=>`Voc\xea n\xe3o est\xe1 recebendo notifica\xe7\xf5es dessa ${type} porque cancelou a inscri\xe7\xe3o.`,
    'pt-pt': (type)=>`N\xe3o est\xe1s a receber notifica\xe7\xf5es desta ${type} porque cancelaste a subscri\xe7\xe3o.`,
    ru: (type)=>`\u{412}\u{44B} \u{43D}\u{435} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{43E}\u{431} \u{44D}\u{442}\u{43E}\u{439} ${type} , \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{43E}\u{442}\u{43F}\u{438}\u{441}\u{430}\u{43B}\u{438}\u{441}\u{44C}.`,
    sm: (type)=>`E te le mauaina ni faasilasilaga mo lenei ${type} ona ua e le lesitalaina.`,
    so: (type)=>`Ma helaysid ogeysiisyo ku saabsan ${type} sababtoo ah waad ka baxday isdiiwaangelinta.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A} ${type} \u{E19}\u{E35}\u{E49}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E23}\u{E31}\u{E1A}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} ${type} \u{6A9}\u{6CC} \u{627}\u{637}\u{644}\u{627}\u{639} \u{627}\u{633} \u{644}\u{6CC}\u{6D2} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{644} \u{631}\u{6C1}\u{6CC} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{646}\u{6D2} \u{627}\u{646} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{6A9}\u{631} \u{62F}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n kh\xf4ng nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\u{1EC1} ${type} n\xe0y v\xec b\u{1EA1}n \u{111}\xe3 h\u{1EE7}y \u{111}\u{103}ng k\xfd.`,
    'zh-hans': (type)=>`\u{4F60}\u{56E0}\u{4E3A}\u{53D6}\u{6D88}\u{8BA2}\u{9605}\u{800C}\u{6CA1}\u{6709}\u{6536}\u{5230}\u{8FD9} ${type} \u{7684}\u{901A}\u{77E5}\u{3002}`,
    'zh-hant': (type)=>`\u{4F60}\u{56E0}\u{70BA}\u{53D6}\u{6D88}\u{8A02}\u{95B1}\u{800C}\u{6536}\u{4E0D}\u{5230}\u{9019} ${type} \u{7684}\u{901A}\u{77E5}\u{3002}`,
    en: (type)=>`You're not receiving notifications for this ${type} because you unsubscribed.`
};
const $b11db1b62d4a8f76$export$cc74ec0e2bf1c390 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{643} \u{642}\u{645}\u{62A} \u{628}\u{62A}\u{62D}\u{62F}\u{64A}\u{62B} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Du bekommst Benachrichtigungen, weil du diese ${type} aktualisiert hast.`,
    es: (type)=>`Est\xe1s recibiendo notificaciones porque has actualizado esta ${type}.`,
    fa: (type)=>`\u{634}\u{645}\u{627} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{686}\u{648}\u{646} \u{627}\u{6CC}\u{646} ${type} \u{631}\u{627} \u{628}\u{647} \u{631}\u{648}\u{632}\u{631}\u{633}\u{627}\u{646}\u{6CC} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: (type)=>`Tumatanggap ka ng mga notification dahil na-update mo ang ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications parce que vous avez mis \xe0 jour cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{928}\u{947} \u{907}\u{938} ${type} \u{915}\u{94B} \u{905}\u{92A}\u{921}\u{947}\u{91F} \u{915}\u{93F}\u{92F}\u{93E} \u{939}\u{948}.`,
    ht: (type)=>`Ou resevwa notifikasyon paske ou mete ajou ${type} sa a.`,
    it: (type)=>`Ricevi notifiche perch\xe9 hai aggiornato questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{3092}\u{66F4}\u{65B0}\u{3057}\u{305F}\u{3053}\u{3068}\u{3067}\u{901A}\u{77E5}\u{304C}\u{5C4A}\u{304F}\u{306E}\u{3067}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type} \u{C5C5}\u{B370}\u{C774}\u{D2B8}\u{D574}\u{C11C} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{B294} \u{AC70}\u{C608}\u{C694}.`,
    mww: (type)=>`Koj tau txais cov ntawv ceeb toom vim tias koj tau hloov kho qhov ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} ${type} \u{62A}\u{627}\u{632}\u{647} \u{6A9}\u{693}\u{6CC} \u{62F}\u{6CC}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque atualizou essa ${type}.`,
    'pt-pt': (type)=>`Est\xe1 a receber notifica\xe7\xf5es porque atualizou esta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{438}\u{43B}\u{438} ${type}.`,
    sm: (type)=>`O loo e mauaina ni faasilasilaga ona ua e faafouina lenei ${type}.`,
    so: (type)=>`Waxaad helaysaa ogeysiisyo sababtoo ah waxaad cusbooneysiisay ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{646}\u{648}\u{679}\u{6CC}\u{641}\u{6A9}\u{6CC}\u{634}\u{646} \u{627}\u{633} \u{644}\u{6CC}\u{6D2} \u{645}\u{644} \u{631}\u{6C1}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{646}\u{6D2} \u{6CC}\u{6C1} ${type} \u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6A9}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec b\u{1EA1}n \u{111}\xe3 c\u{1EAD}p nh\u{1EAD}t ${type} n\xe0y.`,
    'zh-hans': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{4E3A}\u{4F60}\u{66F4}\u{65B0}\u{4E86} ${type}\u{3002}`,
    'zh-hant': (type)=>`\u{4F60}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{70BA}\u{4F60}\u{66F4}\u{65B0}\u{4E86}\u{9019}\u{500B} ${type}\u{3002}`,
    en: (type)=>`You're receiving notifications because you updated this ${type}.`
};
const $b11db1b62d4a8f76$export$6087b4868abacb19 = {
    ar: `\u{644}\u{627} \u{62C}\u{62F}\u{627}\u{648}\u{644} \u{632}\u{645}\u{646}\u{64A}\u{629}`,
    de: `Keine Stundenzettel`,
    es: `Sin hojas de horas`,
    fa: `\u{647}\u{6CC}\u{686} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang mga timesheet`,
    fr: `Pas de feuilles de temps`,
    hi: `\u{915}\u{94B}\u{908} \u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen Timesheets`,
    it: `Nessun foglo orario`,
    ja: `\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{306F}\u{306A}\u{3057}`,
    ko: `\u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C}\u{B294} \u{C5C6}\u{C5B4}`,
    mww: `Tsis muaj daim ntawv teev sijhawm`,
    ps: `\u{647}\u{6CC}\u{685} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{6D0} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem folhas de ponto`,
    'pt-pt': `Sem folhas de horas`,
    ru: `\u{41D}\u{435}\u{442} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{435}\u{439} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}`,
    sm: `Leai ni pepa o taimi`,
    so: `Ma jiraan jadwalka waqtiga`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 b\u{1EA3}ng ch\u{1EA5}m c\xf4ng`,
    'zh-hans': `\u{6CA1}\u{6709}\u{5DE5}\u{65F6}\u{8868}`,
    'zh-hant': `\u{6C92}\u{6709}\u{5DE5}\u{6642}\u{8868}`,
    en: `No timesheets`
};
const $b11db1b62d4a8f76$export$19c02d664a886ca5 = {
    ar: `\u{63A}\u{64A}\u{631} \u{645}\u{634}\u{62A}\u{631}\u{643}`,
    de: `Nicht abonniert`,
    es: `No suscrito`,
    fa: `\u{645}\u{634}\u{62A}\u{631}\u{6A9} \u{646}\u{6CC}\u{633}\u{62A}\u{645}`,
    fil: `Hindi naka-subscribe`,
    fr: `Non abonn\xe9`,
    hi: `\u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{932}\u{940} \u{917}\u{908}`,
    ht: `Pa abone`,
    it: `Non abbonato`,
    ja: `\u{8CFC}\u{8AAD}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{AD6C}\u{B3C5}\u{D558}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis sau npe`,
    ps: `\u{6AB}\u{689}\u{648}\u{646} \u{646}\u{647} \u{644}\u{631}\u{645}`,
    pt: `N\xe3o assinado`,
    'pt-pt': `N\xe3o subscrito`,
    ru: `\u{41D}\u{435} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}`,
    sm: `E le'i lesitala`,
    so: `Ma aha mid isdiiwaangelin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}`,
    ur: `\u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{627}`,
    vi: `Ch\u{1B0}a \u{111}\u{103}ng k\xfd`,
    'zh-hans': `\u{672A}\u{8BA2}\u{9605}`,
    'zh-hant': `\u{672A}\u{8A02}\u{95B1}`,
    en: `Not subscribed`
};
const $b11db1b62d4a8f76$export$20fb51c9c7417e8e = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{641}\u{639}\u{627}\u{644}\u{64A}\u{627}\u{62A} \u{642}\u{627}\u{62F}\u{645}\u{629}`,
    de: `Keine bevorstehenden Veranstaltungen`,
    es: `No hay eventos pr\xf3ximos`,
    fa: `\u{647}\u{6CC}\u{686} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{622}\u{6CC}\u{646}\u{62F}\u{647} \u{627}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang paparating na mga kaganapan`,
    fr: `Aucun \xe9v\xe9nement \xe0 venir`,
    hi: `\u{915}\u{94B}\u{908} \u{906}\u{917}\u{93E}\u{92E}\u{940} \u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{915}\u{94D}\u{930}\u{92E} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen ev\xe8nman kap vini yo`,
    it: `Nessun evento in arrivo`,
    ja: `\u{4ECA}\u{5F8C}\u{306E}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C608}\u{C815}\u{B41C} \u{D589}\u{C0AC}\u{B294} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj kev tshwm sim tom ntej`,
    ps: `\u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0} \u{67E}\u{6CC}\u{69A}\u{6D0} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem eventos futuros`,
    'pt-pt': `Sem eventos pr\xf3ximos`,
    ru: `\u{41F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{438}\u{445} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{439} \u{43D}\u{435}\u{442}.`,
    sm: `Leai ni mea e tutupu i le lumana'i`,
    so: `Ma jiraan dhacdooyin soo socda`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E40}\u{E01}\u{E34}\u{E14}\u{E02}\u{E36}\u{E49}\u{E19}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{622}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{627}\u{6CC}\u{648}\u{646}\u{679}\u{633} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 s\u{1EF1} ki\u{1EC7}n s\u{1EAF}p t\u{1EDB}i`,
    'zh-hans': `\u{6CA1}\u{6709}\u{5373}\u{5C06}\u{4E3E}\u{529E}\u{7684}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{6C92}\u{6709}\u{5373}\u{5C07}\u{8209}\u{8FA6}\u{7684}\u{6D3B}\u{52D5}`,
    en: `No upcoming events`
};
const $b11db1b62d4a8f76$export$c82e5e8fb0a6c10e = {
    ar: `\u{633}\u{64A}\u{62A}\u{645} \u{625}\u{62F}\u{631}\u{627}\u{62C} \u{627}\u{644}\u{641}\u{639}\u{627}\u{644}\u{64A}\u{627}\u{62A} \u{627}\u{644}\u{642}\u{627}\u{62F}\u{645}\u{629} \u{647}\u{646}\u{627}.`,
    de: `Bevorstehende Veranstaltungen werden hier aufgef\xfchrt.`,
    es: `Los pr\xf3ximos eventos se listar\xe1n aqu\xed.`,
    fa: `\u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{647}\u{627}\u{6CC} \u{622}\u{6CC}\u{646}\u{62F}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646}\u{62C}\u{627} \u{641}\u{647}\u{631}\u{633}\u{62A} \u{62E}\u{648}\u{627}\u{647}\u{646}\u{62F} \u{634}\u{62F}.`,
    fil: `Ang mga paparating na kaganapan ay ililista dito.`,
    fr: `Les prochains \xe9v\xe9nements seront list\xe9s ici.`,
    hi: `\u{906}\u{917}\u{93E}\u{92E}\u{940} \u{918}\u{91F}\u{928}\u{93E}\u{913}\u{902} \u{915}\u{94B} \u{92F}\u{939}\u{93E}\u{902} \u{938}\u{942}\u{91A}\u{940}\u{92C}\u{926}\u{94D}\u{927} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E}\u{90F}\u{917}\u{93E}\u{964}`,
    ht: `Ev\xe8nman kap vini yo pral ki nan lis isit la.`,
    it: `Gli eventi in programma saranno elencati qui.`,
    ja: `\u{4ECA}\u{5F8C}\u{306E}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306F}\u{3053}\u{3061}\u{3089}\u{306B}\u{63B2}\u{8F09}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{B2E4}\u{AC00}\u{C624}\u{B294} \u{D589}\u{C0AC}\u{B294} \u{C5EC}\u{AE30}\u{C5D0} \u{B098}\u{C5F4}\u{B420} \u{C608}\u{C815}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Cov xwm txheej tom ntej yuav raug teev tseg ntawm no.`,
    ps: `\u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0} \u{67E}\u{6CC}\u{69A}\u{6D0} \u{628}\u{647} \u{62F}\u{644}\u{62A}\u{647} \u{644}\u{6CC}\u{633}\u{62A} \u{634}\u{6CC}.`,
    pt: `Os pr\xf3ximos eventos ser\xe3o listados aqui.`,
    'pt-pt': `Os pr\xf3ximos eventos ser\xe3o listados aqui.`,
    ru: `\u{417}\u{434}\u{435}\u{441}\u{44C} \u{431}\u{443}\u{434}\u{443}\u{442} \u{43F}\u{435}\u{440}\u{435}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}\u{44B} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{438}\u{435} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F}.`,
    sm: `O mea o lo'o lumana'i o le a lisiina iinei.`,
    so: `Dhacdooyinka soo socda waxaa lagu taxi doonaa halkan.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E40}\u{E01}\u{E34}\u{E14}\u{E02}\u{E36}\u{E49}\u{E19}\u{E08}\u{E30}\u{E16}\u{E39}\u{E01}\u{E23}\u{E30}\u{E1A}\u{E38}\u{E44}\u{E27}\u{E49}\u{E17}\u{E35}\u{E48}\u{E19}\u{E35}\u{E48}`,
    ur: `\u{622}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{627}\u{6CC}\u{648}\u{646}\u{679}\u{633} \u{6CC}\u{6C1}\u{627}\u{6BA} \u{62F}\u{631}\u{62C} \u{6A9}\u{6CC}\u{6D2} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA} \u{6AF}\u{6D2}\u{6D4}`,
    vi: `C\xe1c s\u{1EF1} ki\u{1EC7}n s\u{1EAF}p t\u{1EDB}i s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c li\u{1EC7}t k\xea t\u{1EA1}i \u{111}\xe2y.`,
    'zh-hans': `\u{5373}\u{5C06}\u{4E3E}\u{529E}\u{7684}\u{6D3B}\u{52A8}\u{5C06}\u{5728}\u{8FD9}\u{91CC}\u{5217}\u{51FA}\u{3002}`,
    'zh-hant': `\u{5373}\u{5C07}\u{8209}\u{8FA6}\u{7684}\u{6D3B}\u{52D5}\u{5C07}\u{5728}\u{6B64}\u{5217}\u{51FA}\u{3002}`,
    en: `Upcoming events will be listed here.`
};
const $b11db1b62d4a8f76$export$d9ef83e0281253ed = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{639}\u{64A}\u{627}\u{62F}\u{627}\u{62A} \u{644}\u{642}\u{627}\u{62D} \u{642}\u{627}\u{62F}\u{645}\u{629}`,
    de: `Keine bevorstehenden Impfkliniken`,
    es: `No hay pr\xf3ximas cl\xednicas de vacunaci\xf3n`,
    fa: `\u{647}\u{6CC}\u{686} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9} \u{648}\u{627}\u{6A9}\u{633}\u{646}\u{6CC} \u{62F}\u{631} \u{622}\u{6CC}\u{646}\u{62F}\u{647} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang paparating na mga klinika sa bakuna`,
    fr: `Aucune clinique de vaccination \xe0 venir`,
    hi: `\u{915}\u{94B}\u{908} \u{906}\u{917}\u{93E}\u{92E}\u{940} \u{935}\u{948}\u{915}\u{94D}\u{938}\u{940}\u{928} \u{915}\u{94D}\u{932}\u{940}\u{928}\u{93F}\u{915} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen klinik vaksen kap vini yo`,
    it: `Nessuna clinica vaccinale in programma`,
    ja: `\u{4ECA}\u{5F8C}\u{306E}\u{30EF}\u{30AF}\u{30C1}\u{30F3}\u{30AF}\u{30EA}\u{30CB}\u{30C3}\u{30AF}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{ACE7} \u{C788}\u{C744} \u{BC31}\u{C2E0} \u{D074}\u{B9AC}\u{B2C9}\u{C740} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj cov chaw txhaj tshuaj tiv thaiv tom ntej`,
    ps: `\u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6CC} \u{648}\u{627}\u{6A9}\u{633}\u{6CC}\u{646} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9}\u{648}\u{646}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o h\xe1 pr\xf3ximas cl\xednicas de vacina\xe7\xe3o`,
    'pt-pt': `N\xe3o h\xe1 cl\xednicas de vacina\xe7\xe3o previstas`,
    ru: `\u{412} \u{431}\u{43B}\u{438}\u{436}\u{430}\u{439}\u{448}\u{438}\u{435} \u{43A}\u{43B}\u{438}\u{43D}\u{438}\u{43A}\u{438} \u{432}\u{430}\u{43A}\u{446}\u{438}\u{43D}\u{430}\u{446}\u{438}\u{438} \u{43D}\u{435} \u{431}\u{443}\u{434}\u{435}\u{442}.`,
    sm: `Leai se falema'i tui o lo'o lumana'i`,
    so: `Ma jiraan rugaha tallaalka ee soo socda`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E04}\u{E25}\u{E34}\u{E19}\u{E34}\u{E01}\u{E27}\u{E31}\u{E04}\u{E0B}\u{E35}\u{E19}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E08}\u{E30}\u{E21}\u{E32}\u{E16}\u{E36}\u{E07}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{622}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{627} \u{648}\u{6CC}\u{6A9}\u{633}\u{6CC}\u{646} \u{6A9}\u{644}\u{6CC}\u{646}\u{6A9} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ph\xf2ng kh\xe1m v\u{1EAF}c-xin s\u{1EAF}p t\u{1EDB}i`,
    'zh-hans': `\u{6CA1}\u{6709}\u{5373}\u{5C06}\u{5230}\u{6765}\u{7684}\u{75AB}\u{82D7}\u{8BCA}\u{6240}`,
    'zh-hant': `\u{6C92}\u{6709}\u{5373}\u{5C07}\u{8209}\u{8FA6}\u{7684}\u{75AB}\u{82D7}\u{8A3A}\u{6240}`,
    en: `No upcoming vaccine clinics`
};
const $b11db1b62d4a8f76$export$bb4351fd313d52e7 = {
    ar: `\u{633}\u{64A}\u{62A}\u{645} \u{625}\u{62F}\u{631}\u{627}\u{62C} \u{639}\u{64A}\u{627}\u{62F}\u{627}\u{62A} \u{627}\u{644}\u{644}\u{642}\u{627}\u{62D}\u{627}\u{62A} \u{627}\u{644}\u{642}\u{627}\u{62F}\u{645}\u{629} \u{636}\u{645}\u{646} \u{627}\u{644}\u{646}\u{637}\u{627}\u{642} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631} \u{647}\u{646}\u{627}.`,
    de: `Kommende Impfkliniken im ausgew\xe4hlten Bereich werden hier aufgef\xfchrt.`,
    es: `Aqu\xed se listar\xe1n las pr\xf3ximas cl\xednicas de vacunaci\xf3n dentro del rango seleccionado.`,
    fa: `\u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9} \u{647}\u{627}\u{6CC} \u{648}\u{627}\u{6A9}\u{633}\u{646} \u{622}\u{6CC}\u{646}\u{62F}\u{647} \u{62F}\u{631} \u{645}\u{62D}\u{62F}\u{648}\u{62F}\u{647} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{634}\u{62F}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646}\u{62C}\u{627} \u{641}\u{647}\u{631}\u{633}\u{62A} \u{62E}\u{648}\u{627}\u{647}\u{646}\u{62F} \u{634}\u{62F}.`,
    fil: `Ang mga paparating na klinika ng bakuna sa loob ng napiling saklaw ay nakalista dito.`,
    fr: `Les prochains cliniques de vaccination dans la plage s\xe9lectionn\xe9e seront list\xe9es ici.`,
    hi: `\u{91A}\u{92F}\u{928}\u{93F}\u{924} \u{938}\u{940}\u{92E}\u{93E} \u{915}\u{947} \u{92D}\u{940}\u{924}\u{930} \u{906}\u{917}\u{93E}\u{92E}\u{940} \u{935}\u{948}\u{915}\u{94D}\u{938}\u{940}\u{928} \u{915}\u{94D}\u{932}\u{940}\u{928}\u{93F}\u{915}\u{94B}\u{902} \u{915}\u{94B} \u{92F}\u{939}\u{93E}\u{902} \u{938}\u{942}\u{91A}\u{940}\u{92C}\u{926}\u{94D}\u{927} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E}\u{90F}\u{917}\u{93E}\u{964}`,
    ht: `Klinik vaksen kap vini yo nan seri chwazi a pral nan lis isit la.`,
    it: `Le prossime cliniche vaccinali all'interno dell'intervallo selezionato saranno elencate qui.`,
    ja: `\u{9078}\u{5B9A}\u{7BC4}\u{56F2}\u{5185}\u{306E}\u{4ECA}\u{5F8C}\u{306E}\u{30EF}\u{30AF}\u{30C1}\u{30F3}\u{30AF}\u{30EA}\u{30CB}\u{30C3}\u{30AF}\u{306F}\u{3053}\u{3053}\u{306B}\u{63B2}\u{8F09}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C120}\u{D0DD}\u{B41C} \u{BC94}\u{C704} \u{B0B4}\u{C758} \u{ACE7} \u{AC1C}\u{C124}\u{B420} \u{BC31}\u{C2E0} \u{D074}\u{B9AC}\u{B2C9}\u{C740} \u{C5EC}\u{AE30}\u{C5D0} \u{B098}\u{C5F4}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Cov chaw txhaj tshuaj tiv thaiv kab mob tom ntej nyob rau hauv qhov kev xaiv yuav muab teev tseg ntawm no.`,
    ps: `\u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0} \u{648}\u{627}\u{6A9}\u{633}\u{6CC}\u{646} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9}\u{648}\u{646}\u{647} \u{686}\u{6D0} \u{62F} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{62D}\u{62F} \u{62F}\u{646}\u{646}\u{647} \u{62F}\u{6CC}\u{60C} \u{62F}\u{644}\u{62A}\u{647} \u{644}\u{6CC}\u{633}\u{62A} \u{6A9}\u{6CC}\u{696}\u{6CC}.`,
    pt: `As pr\xf3ximas cl\xednicas de vacina\xe7\xe3o dentro da faixa selecionada ser\xe3o listadas aqui.`,
    'pt-pt': `As pr\xf3ximas cl\xednicas de vacina\xe7\xe3o dentro do intervalo selecionado ser\xe3o listadas aqui.`,
    ru: `\u{417}\u{434}\u{435}\u{441}\u{44C} \u{431}\u{443}\u{434}\u{443}\u{442} \u{43F}\u{435}\u{440}\u{435}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}\u{44B} \u{431}\u{443}\u{434}\u{443}\u{449}\u{438}\u{435} \u{43A}\u{43B}\u{438}\u{43D}\u{438}\u{43A}\u{438} \u{432}\u{430}\u{43A}\u{446}\u{438}\u{43D}\u{430}\u{446}\u{438}\u{438} \u{432} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{43C} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{435}.`,
    sm: `O falema'i o lo'o lumana'i i totonu o le vaega filifilia o le a lisiina iinei.`,
    so: `Rugaha tallaalka ee soo socda ee ku jira xadka la doortay ayaa halkan lagu taxi doonaa.`,
    th: `\u{E04}\u{E25}\u{E34}\u{E19}\u{E34}\u{E01}\u{E27}\u{E31}\u{E04}\u{E0B}\u{E35}\u{E19}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E08}\u{E30}\u{E21}\u{E32}\u{E16}\u{E36}\u{E07}\u{E20}\u{E32}\u{E22}\u{E43}\u{E19}\u{E0A}\u{E48}\u{E27}\u{E07}\u{E17}\u{E35}\u{E48}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E08}\u{E30}\u{E41}\u{E2A}\u{E14}\u{E07}\u{E44}\u{E27}\u{E49}\u{E17}\u{E35}\u{E48}\u{E19}\u{E35}\u{E48}`,
    ur: `\u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{62F}\u{6C1} \u{631}\u{6CC}\u{646}\u{62C} \u{645}\u{6CC}\u{6BA} \u{622}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{648}\u{6CC}\u{6A9}\u{633}\u{6CC}\u{646} \u{6A9}\u{644}\u{6CC}\u{646}\u{6A9}\u{633} \u{6CC}\u{6C1}\u{627}\u{6BA} \u{62F}\u{631}\u{62C} \u{6A9}\u{6CC}\u{6D2} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA} \u{6AF}\u{6D2}\u{6D4}`,
    vi: `C\xe1c ph\xf2ng kh\xe1m v\u{1EAF}c-xin s\u{1EAF}p t\u{1EDB}i trong ph\u{1EA1}m vi \u{111}\xe3 ch\u{1ECD}n s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c li\u{1EC7}t k\xea t\u{1EA1}i \u{111}\xe2y.`,
    'zh-hans': `\u{9009}\u{5B9A}\u{8303}\u{56F4}\u{5185}\u{5373}\u{5C06}\u{5F00}\u{8BBE}\u{7684}\u{75AB}\u{82D7}\u{8BCA}\u{6240}\u{5C06}\u{5728}\u{6B64}\u{5217}\u{51FA}\u{3002}`,
    'zh-hant': `\u{9078}\u{5B9A}\u{7BC4}\u{570D}\u{5167}\u{5373}\u{5C07}\u{958B}\u{8A2D}\u{7684}\u{75AB}\u{82D7}\u{8A3A}\u{6240}\u{5C07}\u{5728}\u{6B64}\u{5217}\u{51FA}\u{3002}`,
    en: `Upcoming vaccine clinics within the selected range will be listed here.`
};
const $b11db1b62d4a8f76$export$e211dde49807643b = {
    ar: `\u{623}\u{642}\u{62F}\u{645}`,
    de: `\xc4lter`,
    es: `M\xe1s antigua`,
    fa: `\u{642}\u{62F}\u{6CC}\u{645}\u{6CC} \u{62A}\u{631}`,
    fil: `Mas matanda`,
    fr: `Plus anciens`,
    hi: `\u{92A}\u{941}\u{930}\u{93E}\u{928}\u{93E}`,
    ht: `Pi gran`,
    it: `Pi\xf9 antichi`,
    ja: `\u{5E74}\u{4E0A}`,
    ko: `\u{B354} \u{C624}\u{B798}\u{B41C}`,
    mww: `laus`,
    ps: `\u{632}\u{648}\u{693}`,
    pt: `Mais antigos`,
    'pt-pt': `Mais antigos`,
    ru: `\u{421}\u{442}\u{430}\u{440}\u{448}\u{435}`,
    sm: `Matutua`,
    so: `Da'da weyn`,
    th: `\u{E40}\u{E01}\u{E48}\u{E32}\u{E01}\u{E27}\u{E48}\u{E32}`,
    ur: `\u{67E}\u{631}\u{627}\u{646}\u{627}`,
    vi: `C\u{169} h\u{1A1}n`,
    'zh-hans': `\u{5E74}\u{957F}`,
    'zh-hant': `\u{8F03}\u{65E9}`,
    en: `Older`
};
const $b11db1b62d4a8f76$export$2bcd46d6d21f9b9e = {
    ar: `\u{646}\u{634}\u{627}\u{637} \u{648}\u{627}\u{62D}\u{62F}`,
    de: `1 Aktivit\xe4t`,
    es: `1 Actividad`,
    fa: `\u{6F1} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    fil: `1 aktibidad`,
    fr: `1 Activit\xe9`,
    hi: `1 \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}`,
    ht: `1 aktivite`,
    it: `1 Attivit\xe0`,
    ja: `1 \u{6D3B}\u{52D5}`,
    ko: `1 \u{D65C}\u{B3D9}`,
    mww: `1 kev ua si`,
    ps: `\u{6F1} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    pt: `1 Atividade`,
    'pt-pt': `1 Atividade`,
    ru: `1 \u{414}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `1 Gaoioiga`,
    so: `1 Hawlaha`,
    th: `1 \u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `1 \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}`,
    vi: `1 ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `1 \u{6D3B}\u{52A8}`,
    'zh-hant': `1 \u{6D3B}\u{52D5}`,
    en: `1 activity`
};
const $b11db1b62d4a8f76$export$7619b24364f89159 = {
    ar: `\u{639}\u{64A}\u{627}\u{62F}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629}`,
    de: `Eine Klinik`,
    es: `Una cl\xednica`,
    fa: `\u{6CC}\u{6A9} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9}`,
    fil: `Isang klinika`,
    fr: `Une clinique`,
    hi: `\u{90F}\u{915} \u{915}\u{94D}\u{932}\u{93F}\u{928}\u{93F}\u{915}`,
    ht: `Yon klinik`,
    it: `Una clinica`,
    ja: `1\u{3064}\u{306E}\u{30AF}\u{30EA}\u{30CB}\u{30C3}\u{30AF}`,
    ko: `\u{D55C} \u{AC1C}\u{C758} \u{D074}\u{B9AC}\u{B2C9}`,
    mww: `Ib lub tsev kho mob`,
    ps: `\u{6CC}\u{648}\u{647} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9}`,
    pt: `Uma cl\xednica`,
    'pt-pt': `Uma cl\xednica`,
    ru: `\u{41E}\u{434}\u{43D}\u{430} \u{43A}\u{43B}\u{438}\u{43D}\u{438}\u{43A}\u{430}`,
    sm: `Tasi le falema'i`,
    so: `Hal rug caafimaad`,
    th: `\u{E04}\u{E25}\u{E34}\u{E19}\u{E34}\u{E01} 1 \u{E41}\u{E2B}\u{E48}\u{E07}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{6A9}\u{644}\u{6CC}\u{646}\u{6A9}`,
    vi: `M\u{1ED9}t ph\xf2ng kh\xe1m`,
    'zh-hans': `\u{4E00}\u{5BB6}\u{8BCA}\u{6240}`,
    'zh-hant': `\u{4E00}\u{9593}\u{8A3A}\u{6240}`,
    en: `One clinic`
};
const $b11db1b62d4a8f76$export$7201cbe02063e8f6 = {
    ar: `\u{62D}\u{62F}\u{62B} \u{648}\u{627}\u{62D}\u{62F} \u{62A}\u{645} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{64A}\u{647}`,
    de: `Ein gefundenes Ereignis`,
    es: `Un evento encontrado`,
    fa: `\u{6CC}\u{6A9} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{6CC}\u{627}\u{641}\u{62A} \u{634}\u{62F}`,
    fil: `Isang pangyayari ang natagpuan`,
    fr: `Un \xe9v\xe9nement trouv\xe9`,
    hi: `\u{90F}\u{915} \u{918}\u{91F}\u{928}\u{93E} \u{92E}\u{93F}\u{932}\u{940}`,
    ht: `Yon s\xe8l ev\xe8nman te jwenn`,
    it: `Un evento trovato`,
    ja: `\u{4E00}\u{3064}\u{306E}\u{51FA}\u{6765}\u{4E8B}\u{304C}\u{898B}\u{3064}\u{304B}\u{3063}\u{305F}`,
    ko: `\u{D55C} \u{AC00}\u{C9C0} \u{C0AC}\u{AC74}\u{C774} \u{BC1C}\u{ACAC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Ib qho xwm txheej pom`,
    ps: `\u{6CC}\u{648}\u{647} \u{67E}\u{6D0}\u{69A}\u{647} \u{648}\u{645}\u{648}\u{646}\u{62F}\u{644} \u{634}\u{648}\u{647}`,
    pt: `Um evento encontrado`,
    'pt-pt': `Um evento encontrado`,
    ru: `\u{41E}\u{434}\u{43D}\u{43E} \u{438}\u{437} \u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}\u{43D}\u{44B}\u{445} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{439}`,
    sm: `Tasi le mea na tupu na maua`,
    so: `Hal dhacdo ayaa la helay`,
    th: `\u{E1E}\u{E1A}\u{E40}\u{E2B}\u{E15}\u{E38}\u{E01}\u{E32}\u{E23}\u{E13}\u{E4C}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{648}\u{627}\u{642}\u{639}\u{6C1} \u{645}\u{644}\u{627}`,
    vi: `Ph\xe1t hi\u{1EC7}n m\u{1ED9}t s\u{1EF1} ki\u{1EC7}n`,
    'zh-hans': `\u{53D1}\u{73B0}\u{4E86}\u{4E00}\u{4EF6}\u{4E8B}`,
    'zh-hant': `\u{767C}\u{73FE}\u{4E00}\u{500B}\u{4E8B}\u{4EF6}`,
    en: `One event found`
};
const $b11db1b62d4a8f76$export$9c74c928b7f96fab = {
    ar: `\u{645}\u{644}\u{641} \u{648}\u{627}\u{62D}\u{62F}`,
    de: `1 Datei`,
    es: `1 archivo`,
    fa: `\u{6F1} \u{641}\u{627}\u{6CC}\u{644}`,
    fil: `1 file`,
    fr: `1 dossier`,
    hi: `1 \u{92B}\u{93C}\u{93E}\u{907}\u{932}`,
    ht: `1 dosye`,
    it: `1 file`,
    ja: `1\u{30D5}\u{30A1}\u{30A4}\u{30EB}`,
    ko: `1 \u{D30C}\u{C77C}`,
    mww: `1 ntaub ntawv`,
    ps: `\u{6F1} \u{641}\u{627}\u{6CC}\u{644}`,
    pt: `1 arquivo`,
    'pt-pt': `1 ficheiro`,
    ru: `1 \u{444}\u{430}\u{439}\u{43B}`,
    sm: `1 faila`,
    so: `1 fayl`,
    th: `1 \u{E44}\u{E1F}\u{E25}\u{E4C}`,
    ur: `1 \u{641}\u{627}\u{626}\u{644}`,
    vi: `1 t\u{1EAD}p tin`,
    'zh-hans': `1\u{4E2A}\u{6587}\u{4EF6}`,
    'zh-hant': `1 \u{6A94}\u{6848}`,
    en: `1 file`
};
const $b11db1b62d4a8f76$export$7619abd293e6c35f = {
    ar: `100 \u{645}\u{64A}\u{644}`,
    de: `100 Meilen`,
    es: `100 millas`,
    fa: `\u{6F1}\u{6F0}\u{6F0} \u{645}\u{627}\u{6CC}\u{644}`,
    fil: `100 milya`,
    fr: `100 miles`,
    hi: `100 \u{92E}\u{940}\u{932}`,
    ht: `100 mil`,
    it: `100 miglia`,
    ja: `100\u{30DE}\u{30A4}\u{30EB}`,
    ko: `100\u{B9C8}\u{C77C}`,
    mww: `100 mais`,
    ps: `\u{6F1}\u{6F0}\u{6F0} \u{645}\u{6CC}\u{644}`,
    pt: `100 milhas`,
    'pt-pt': `100 milhas`,
    ru: `100 \u{43C}\u{438}\u{43B}\u{44C}`,
    sm: `100 maila`,
    so: `100 mayl`,
    th: `100.1 \u{E01}\u{E21}.`,
    ur: `100 \u{645}\u{6CC}\u{644}`,
    vi: `100 d\u{1EB7}m`,
    'zh-hans': `100\u{82F1}\u{91CC}`,
    'zh-hant': `100\u{82F1}\u{91CC}`,
    en: `100 miles`
};
const $b11db1b62d4a8f76$export$1ff6720e765bd764 = {
    ar: `\u{62F}\u{648}\u{627}\u{621} \u{648}\u{627}\u{62D}\u{62F}`,
    de: `Ein Medikament`,
    es: `Un medicamento`,
    fa: `\u{6CC}\u{6A9} \u{62F}\u{627}\u{631}\u{648}`,
    fil: `Isang gamot`,
    fr: `Un m\xe9dicament`,
    hi: `\u{90F}\u{915} \u{926}\u{935}\u{93E}`,
    ht: `Yon medikaman`,
    it: `Un farmaco`,
    ja: `1\u{7A2E}\u{985E}\u{306E}\u{85AC}`,
    ko: `\u{C57D} \u{D55C} \u{AC00}\u{C9C0}`,
    mww: `Ib qho tshuaj`,
    ps: `\u{6CC}\u{648}\u{647} \u{62F}\u{631}\u{645}\u{644}`,
    pt: `Um medicamento`,
    'pt-pt': `Um medicamento`,
    ru: `\u{41E}\u{434}\u{43D}\u{43E} \u{43B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432}\u{43E}`,
    sm: `Tasi le vaila'au`,
    so: `Hal daawo`,
    th: `\u{E22}\u{E32}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E15}\u{E31}\u{E27}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{62F}\u{648}\u{627}`,
    vi: `M\u{1ED9}t lo\u{1EA1}i thu\u{1ED1}c`,
    'zh-hans': `\u{4E00}\u{79CD}\u{836F}\u{7269}`,
    'zh-hant': `\u{4E00}\u{7A2E}\u{85E5}\u{7269}`,
    en: `One medication`
};
const $b11db1b62d4a8f76$export$5b2dff051546c71 = {
    ar: `\u{62A}\u{648}\u{642}\u{64A}\u{639} \u{648}\u{627}\u{62D}\u{62F}`,
    de: `1 Signatur`,
    es: `1 firma`,
    fa: `\u{6F1} \u{627}\u{645}\u{636}\u{627}`,
    fil: `1 lagda`,
    fr: `1 signature`,
    hi: `1 \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930}`,
    ht: `1 siyati`,
    it: `1 firma`,
    ja: `1\u{3064}\u{306E}\u{7F72}\u{540D}`,
    ko: `\u{C11C}\u{BA85} 1\u{AC1C}`,
    mww: `1 kos npe`,
    ps: `\u{6F1} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9}`,
    pt: `1 assinatura`,
    'pt-pt': `1 assinatura`,
    ru: `1 \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `1 saini`,
    so: `1 saxiix`,
    th: `1 \u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `1 \u{62F}\u{633}\u{62A}\u{62E}\u{637}`,
    vi: `1 ch\u{1EEF} k\xfd`,
    'zh-hans': `1\u{4E2A}\u{7B7E}\u{540D}`,
    'zh-hant': `1 \u{500B}\u{7C3D}\u{540D}`,
    en: `1 signature`
};
const $b11db1b62d4a8f76$export$f9a7fd5427e6dd0b = {
    ar: `\u{645}\u{634}\u{62A}\u{631}\u{643} \u{648}\u{627}\u{62D}\u{62F}`,
    de: `Ein Abonnent`,
    es: `Un suscriptor`,
    fa: `\u{6CC}\u{6A9} \u{645}\u{634}\u{62A}\u{631}\u{6A9}`,
    fil: `Isang tagasuskribi`,
    fr: `Un abonn\xe9`,
    hi: `\u{90F}\u{915} \u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915}`,
    ht: `Yon ab\xf2nen`,
    it: `Un abbonato`,
    ja: `\u{52A0}\u{5165}\u{8005}1\u{540D}`,
    ko: `\u{AC00}\u{C785}\u{C790} 1\u{BA85}`,
    mww: `Ib tus neeg rau npe`,
    ps: `\u{6CC}\u{648} \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644}`,
    pt: `Um assinante`,
    'pt-pt': `Um assinante`,
    ru: `\u{41E}\u{434}\u{438}\u{43D} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{447}\u{438}\u{43A}`,
    sm: `Tasi le tagata fai saofaga`,
    so: `Hal macaamiil`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E04}\u{E19}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628}\u{631}`,
    vi: `M\u{1ED9}t ng\u{1B0}\u{1EDD}i \u{111}\u{103}ng k\xfd`,
    'zh-hans': `\u{4E00}\u{540D}\u{8BA2}\u{9605}\u{8005}`,
    'zh-hant': `\u{4E00}\u{540D}\u{8A02}\u{95B1}\u{8005}`,
    en: `One subscriber`
};
const $b11db1b62d4a8f76$export$a2c4e850ecd3273f = {
    ar: `\u{631}\u{645}\u{632} \u{644}\u{645}\u{631}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629}`,
    de: `Einmalcode`,
    es: `C\xf3digo de un solo uso`,
    fa: `\u{6A9}\u{62F} \u{6CC}\u{6A9} \u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641}`,
    fil: `Isang beses na code`,
    fr: `Code \xe0 usage unique`,
    hi: `\u{90F}\u{915} \u{92C}\u{93E}\u{930} \u{915}\u{93E} \u{915}\u{94B}\u{921}`,
    ht: `Yon s\xe8l fwa k\xf2d`,
    it: `Codice monouso`,
    ja: `\u{30EF}\u{30F3}\u{30BF}\u{30A4}\u{30E0}\u{30B3}\u{30FC}\u{30C9}`,
    ko: `\u{C77C}\u{D68C}\u{C131} \u{CF54}\u{B4DC}`,
    mww: `Ib-lub sij hawm code`,
    ps: `\u{6CC}\u{648} \u{681}\u{644} \u{6A9}\u{648}\u{689}`,
    pt: `C\xf3digo de uso \xfanico`,
    'pt-pt': `C\xf3digo de uso \xfanico`,
    ru: `\u{41E}\u{434}\u{43D}\u{43E}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{44B}\u{439} \u{43A}\u{43E}\u{434}`,
    sm: `Tasi le taimi code`,
    so: `Koodh hal mar ah`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{648}\u{642}\u{62A}\u{6CC} \u{6A9}\u{648}\u{688}`,
    vi: `M\xe3 m\u{1ED9}t l\u{1EA7}n`,
    'zh-hans': `\u{4E00}\u{6B21}\u{6027}\u{4EE3}\u{7801}`,
    'zh-hant': `\u{4E00}\u{6B21}\u{6027}\u{4EE3}\u{78BC}`,
    en: `One-time code`
};
const $b11db1b62d4a8f76$export$5d983b2e23c4cd6 = {
    ar: `\u{639}\u{631}\u{636} \u{648}\u{627}\u{62D}\u{62F} \u{641}\u{64A} \u{627}\u{644}\u{634}\u{647}\u{631} \u{627}\u{644}\u{645}\u{627}\u{636}\u{64A}`,
    de: `1 Ansicht im vergangenen Monat`,
    es: `1 visualizaci\xf3n en el \xfaltimo mes`,
    fa: `\u{6F1} \u{628}\u{627}\u{632}\u{62F}\u{6CC}\u{62F} \u{62F}\u{631} \u{645}\u{627}\u{647} \u{6AF}\u{630}\u{634}\u{62A}\u{647}`,
    fil: `1 view sa nakaraang buwan`,
    fr: `1 vue le mois dernier`,
    hi: `\u{92A}\u{93F}\u{91B}\u{932}\u{947} \u{92E}\u{939}\u{940}\u{928}\u{947} \u{92E}\u{947}\u{902} 1 \u{926}\u{943}\u{936}\u{94D}\u{92F}`,
    ht: `1 View nan mwa ki sot pase yo`,
    it: `1 visualizzazione nell'ultimo mese`,
    ja: `\u{904E}\u{53BB}1\u{304B}\u{6708}\u{306E}\u{95B2}\u{89A7}\u{6570}`,
    ko: `\u{C9C0}\u{B09C} \u{D55C} \u{B2EC}\u{AC04} 1\u{D68C} \u{C870}\u{D68C}\u{C218}`,
    mww: `1 saib nyob rau hauv lub hli dhau los`,
    ps: `\u{67E}\u{647} \u{62A}\u{6D0}\u{631}\u{648} \u{645}\u{6CC}\u{627}\u{634}\u{62A}\u{648} \u{6A9}\u{6D0} \u{6F1} \u{644}\u{6CC}\u{62F}`,
    pt: `1 visualiza\xe7\xe3o no \xfaltimo m\xeas`,
    'pt-pt': `1 visualiza\xe7\xe3o no \xfaltimo m\xeas`,
    ru: `1 \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440} \u{437}\u{430} \u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{438}\u{439} \u{43C}\u{435}\u{441}\u{44F}\u{446}`,
    sm: `1 vaaiga i le masina talu ai`,
    so: `1 aragti bishii la soo dhaafay`,
    th: `\u{E14}\u{E39} 1 \u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E43}\u{E19}\u{E40}\u{E14}\u{E37}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E21}\u{E32}`,
    ur: `\u{6AF}\u{632}\u{634}\u{62A}\u{6C1} \u{645}\u{6C1}\u{6CC}\u{646}\u{6D2} \u{645}\u{6CC}\u{6BA} 1 \u{645}\u{646}\u{638}\u{631}`,
    vi: `1 l\u{1B0}\u{1EE3}t xem trong th\xe1ng qua`,
    'zh-hans': `\u{8FC7}\u{53BB}\u{4E00}\u{4E2A}\u{6708}\u{7684}1\u{6B21}\u{6D4F}\u{89C8}`,
    'zh-hant': `\u{904E}\u{53BB}\u{4E00}\u{500B}\u{6708}\u{7684}1\u{6B21}\u{700F}\u{89BD}`,
    en: `1 view in past month`
};
const $b11db1b62d4a8f76$export$33511990654f64a1 = {
    ar: `\u{645}\u{633}\u{62A}\u{645}\u{631}`,
    de: `Laufend`,
    es: `En curso`,
    fa: `\u{627}\u{62F}\u{627}\u{645}\u{647} \u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Patuloy`,
    fr: `En cours`,
    hi: `\u{938}\u{924}\u{924}`,
    ht: `Kontiny\xe8l`,
    it: `In corso`,
    ja: `\u{9032}\u{884C}\u{4E2D}`,
    ko: `\u{C9C4}\u{D589} \u{C911}`,
    mww: `Tsis tu ncua`,
    ps: `\u{631}\u{648}\u{627}\u{646} \u{62F}\u{6CC}`,
    pt: `Em andamento`,
    'pt-pt': `Em curso`,
    ru: `\u{41F}\u{440}\u{43E}\u{434}\u{43E}\u{43B}\u{436}\u{430}\u{435}\u{442}\u{441}\u{44F}`,
    sm: `Fa'aauau pea`,
    so: `Socda`,
    th: `\u{E15}\u{E48}\u{E2D}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}`,
    ur: `\u{62C}\u{627}\u{631}\u{6CC}`,
    vi: `\u{110}ang di\u{1EC5}n ra`,
    'zh-hans': `\u{6B63}\u{5728}\u{8FDB}\u{884C}\u{4E2D}`,
    'zh-hant': `\u{6301}\u{7E8C}\u{9032}\u{884C}\u{4E2D}`,
    en: `Ongoing`
};
const $b11db1b62d4a8f76$export$9f13a839d14cd3a4 = {
    ar: `\u{639}\u{644}\u{649} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`,
    de: `In der Warteschleife`,
    es: `En espera`,
    fa: `\u{62F}\u{631} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`,
    fil: `Naka-hold`,
    fr: `En attente`,
    hi: `\u{939}\u{94B}\u{932}\u{94D}\u{921} \u{92A}\u{930}`,
    ht: `Sou kenbe`,
    it: `In attesa`,
    ja: `\u{4FDD}\u{7559}\u{4E2D}`,
    ko: `\u{B300}\u{AE30} \u{C911}\u{C785}\u{B2C8}\u{B2E4}`,
    mww: `Tuav`,
    ps: `\u{67E}\u{647} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{631} \u{6A9}\u{6D0}`,
    pt: `Em espera`,
    'pt-pt': `Em espera`,
    ru: `\u{41D}\u{430} \u{443}\u{434}\u{435}\u{440}\u{436}\u{430}\u{43D}\u{438}\u{438}`,
    sm: `O lo'o taofia`,
    so: `Ku jirta hakad`,
    th: `\u{E1E}\u{E31}\u{E01}\u{E2A}\u{E32}\u{E22}`,
    ur: `\u{6C1}\u{648}\u{644}\u{688} \u{67E}\u{631}`,
    vi: `T\u{1EA1}m d\u{1EEB}ng`,
    'zh-hans': `\u{7B49}\u{5F85}\u{4E2D}`,
    'zh-hant': `\u{7B49}\u{5F85}\u{4E2D}`,
    en: `On hold`
};
const $b11db1b62d4a8f76$export$46d49c80898a4f02 = {
    ar: `\u{62A}\u{645} \u{628}\u{62F}\u{621} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{644}\u{643}\u{646} \u{62A}\u{645} \u{625}\u{64A}\u{642}\u{627}\u{641} \u{627}\u{644}\u{639}\u{645}\u{644}.`,
    de: `Die Aktivit\xe4t wurde aufgenommen, aber die Arbeit wurde pausiert.`,
    es: `La actividad ya ha comenzado, pero el trabajo se ha pausado.`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{622}\u{63A}\u{627}\u{632} \u{634}\u{62F}\u{647} \u{627}\u{645}\u{627} \u{6A9}\u{627}\u{631} \u{645}\u{62A}\u{648}\u{642}\u{641} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Sinimulan na ang aktibidad ngunit natigil pa rin ang trabaho.`,
    fr: `L\u{2019}activit\xe9 a \xe9t\xe9 lanc\xe9e mais les travaux ont \xe9t\xe9 mis en pause.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{936}\u{941}\u{930}\u{942} \u{915}\u{930} \u{926}\u{940} \u{917}\u{908} \u{939}\u{948} \u{932}\u{947}\u{915}\u{93F}\u{928} \u{915}\u{93E}\u{92E} \u{930}\u{94B}\u{915} \u{926}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Aktivite a te k\xf2manse, men travay la te poze.`,
    it: `L'attivit\xe0 \xe8 gi\xe0 iniziata ma i lavori sono stati sospesi.`,
    ja: `\u{6D3B}\u{52D5}\u{306F}\u{59CB}\u{307E}\u{3063}\u{3066}\u{3044}\u{307E}\u{3059}\u{304C}\u{3001}\u{4F5C}\u{696D}\u{306F}\u{4E00}\u{6642}\u{4E2D}\u{65AD}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{D65C}\u{B3D9}\u{C740} \u{C2DC}\u{C791}\u{B418}\u{C5C8}\u{C73C}\u{B098} \u{C791}\u{C5C5}\u{C774} \u{C911}\u{B2E8}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kev ua haujlwm tau pib tab sis kev ua haujlwm tau ncua.`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{67E}\u{6CC}\u{644} \u{634}\u{648}\u{6CC} \u{62E}\u{648} \u{6A9}\u{627}\u{631} \u{648}\u{62F}\u{631}\u{648}\u{644} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: `A atividade j\xe1 foi iniciada, mas o trabalho foi pausado.`,
    'pt-pt': `A atividade j\xe1 foi iniciada, mas os trabalhos foram suspensos.`,
    ru: `\u{410}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{430}, \u{43D}\u{43E} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{430} \u{43F}\u{440}\u{438}\u{43E}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{430}.`,
    sm: `Ua amataina le gaoioiga, ae ua taofi le galuega.`,
    so: `Hawlgalka waa la bilaabay laakiin shaqada waa la hakiyay.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E44}\u{E14}\u{E49}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E41}\u{E25}\u{E49}\u{E27} \u{E41}\u{E15}\u{E48}\u{E07}\u{E32}\u{E19}\u{E16}\u{E39}\u{E01}\u{E2B}\u{E22}\u{E38}\u{E14}\u{E0A}\u{E31}\u{E48}\u{E27}\u{E04}\u{E23}\u{E32}\u{E27}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{634}\u{631}\u{648}\u{639} \u{6C1}\u{648} \u{686}\u{6A9}\u{6CC} \u{6C1}\u{6D2} \u{644}\u{6CC}\u{6A9}\u{646} \u{6A9}\u{627}\u{645} \u{631}\u{648}\u{6A9} \u{62F}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c b\u{1EAF}t \u{111}\u{1EA7}u nh\u{1B0}ng c\xf4ng vi\u{1EC7}c \u{111}\xe3 b\u{1ECB} t\u{1EA1}m d\u{1EEB}ng.`,
    'zh-hans': `\u{6D3B}\u{52A8}\u{5DF2}\u{7ECF}\u{5F00}\u{59CB}\u{FF0C}\u{4F46}\u{5DE5}\u{4F5C}\u{6682}\u{65F6}\u{6682}\u{505C}\u{3002}`,
    'zh-hant': `\u{6D3B}\u{52D5}\u{5DF2}\u{958B}\u{59CB}\u{FF0C}\u{4F46}\u{5DE5}\u{7A0B}\u{66AB}\u{505C}\u{3002}`,
    en: `The activity has been started but work has been paused.`
};
const $b11db1b62d4a8f76$export$41e323ff2c7efe95 = {
    ar: `\u{645}\u{641}\u{62A}\u{648}\u{62D}`,
    de: `Offen`,
    es: `Abierto`,
    fa: `\u{628}\u{627}\u{632}`,
    fil: `Buksan`,
    fr: `Ouvre`,
    hi: `\u{916}\u{94B}\u{932}\u{928}\u{93E}`,
    ht: `ouv\xe8`,
    it: `Open`,
    ja: `\u{958B}\u{3051}\u{3066}`,
    ko: `\u{C624}\u{D508}`,
    mww: `qhib`,
    ps: `\u{62E}\u{644}\u{627}\u{635} \u{6A9}\u{693}\u{647}`,
    pt: `Aberto`,
    'pt-pt': `Aberto`,
    ru: `\u{41E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C}`,
    sm: `Tatala`,
    so: `Fur`,
    th: `\u{E40}\u{E1B}\u{E34}\u{E14}`,
    ur: `\u{627}\u{648}\u{67E}\u{646}`,
    vi: `M\u{1EDF}`,
    'zh-hans': `\u{5F00}\u{95E8}`,
    'zh-hant': `\u{958B}\u{5834}`,
    en: `Open`
};
const $b11db1b62d4a8f76$export$2f02f1858fbebbb9 = {
    ar: `\u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{641}\u{62A}\u{648}\u{62D}\u{629}`,
    de: `Offene Aktivit\xe4ten`,
    es: `Actividades abiertas`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{622}\u{632}\u{627}\u{62F}`,
    fil: `Mga Bukas na Aktibidad`,
    fr: `Activit\xe9s ouvertes`,
    hi: `\u{916}\u{941}\u{932}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `Louvri aktivite yo`,
    it: `Attivit\xe0 aperte`,
    ja: `\u{30AA}\u{30FC}\u{30D7}\u{30F3}\u{6D3B}\u{52D5}`,
    ko: `\u{C624}\u{D508} \u{D65C}\u{B3D9}`,
    mww: `Qhib kev ua si`,
    ps: `\u{67E}\u{631}\u{627}\u{646}\u{6CC}\u{633}\u{62A}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Atividades abertas`,
    'pt-pt': `Atividades abertas`,
    ru: `\u{41E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{435} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F}`,
    sm: `Gaoioiga tatala`,
    so: `Hawlaha furan`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E41}\u{E1A}\u{E1A}\u{E40}\u{E1B}\u{E34}\u{E14}`,
    ur: `\u{6A9}\u{6BE}\u{644}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng m\u{1EDF}`,
    'zh-hans': `\u{5F00}\u{653E}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{958B}\u{653E}\u{6D3B}\u{52D5}`,
    en: `Open activities`
};
const $b11db1b62d4a8f76$export$fa90a448dd1987f = {
    ar: `\u{633}\u{64A}\u{62A}\u{645} \u{625}\u{62F}\u{631}\u{627}\u{62C} \u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{633}\u{648}\u{62F}\u{629}\u{60C} \u{648}\u{627}\u{644}\u{62C}\u{627}\u{647}\u{632}\u{60C} \u{648}\u{627}\u{644}\u{62C}\u{627}\u{631}\u{64A}\u{629}\u{60C} \u{648}\u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{639}\u{644}\u{642}\u{629} \u{647}\u{646}\u{627}.`,
    de: `Entwurf-, Ready-, In-Progress- und In-Hold-Aktivit\xe4ten werden hier aufgef\xfchrt.`,
    es: `Aqu\xed se listar\xe1n las actividades en borrador, listas, en curso y en espera.`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{67E}\u{6CC}\u{634} \u{646}\u{648}\u{6CC}\u{633}\u{60C} \u{622}\u{645}\u{627}\u{62F}\u{647}\u{60C} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{648} \u{62F}\u{631} \u{62D}\u{627}\u{644}\u{62A} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{631} \u{62F}\u{631} \u{627}\u{6CC}\u{646}\u{62C}\u{627} \u{641}\u{647}\u{631}\u{633}\u{62A} \u{62E}\u{648}\u{627}\u{647}\u{646}\u{62F} \u{634}\u{62F}.`,
    fil: `Ang mga draft, handa, in-progress, at on-hold na mga aktibidad ay nakalista dito.`,
    fr: `Les activit\xe9s de brouillon, pr\xeates, en cours et en attente seront list\xe9es ici.`,
    hi: `\u{921}\u{94D}\u{930}\u{93E}\u{92B}\u{94D}\u{91F}, \u{924}\u{948}\u{92F}\u{93E}\u{930}, \u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{92A}\u{930} \u{914}\u{930} \u{911}\u{928}-\u{939}\u{94B}\u{932}\u{94D}\u{921} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{92F}\u{939}\u{93E}\u{902} \u{938}\u{942}\u{91A}\u{940}\u{92C}\u{926}\u{94D}\u{927} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E}\u{90F}\u{917}\u{93E}\u{964}`,
    ht: `Draft, pare, nan-pwogr\xe8 ak sou kenbe aktivite yo pral ki nan lis isit la.`,
    it: `Le attivit\xe0 di bozza, pronte, in corso e in sospeso saranno elencate qui.`,
    ja: `\u{30C9}\u{30E9}\u{30D5}\u{30C8}\u{3001}\u{6E96}\u{5099}\u{4E2D}\u{3001}\u{9032}\u{884C}\u{4E2D}\u{3001}\u{4FDD}\u{7559}\u{4E2D}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{3053}\u{3053}\u{306B}\u{63B2}\u{8F09}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{CD08}\u{C548}, \u{C900}\u{BE44} \u{C644}\u{B8CC}, \u{C9C4}\u{D589} \u{C911}, \u{BCF4}\u{B958} \u{D65C}\u{B3D9}\u{C774} \u{C5EC}\u{AE30}\u{C5D0} \u{B098}\u{C5F4}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Cov ntawv sau, npaj txhij, tab tom ua, thiab tuav cov haujlwm yuav muaj teev nyob ntawm no.`,
    ps: `\u{645}\u{633}\u{648}\u{62F}\u{647}\u{60C} \u{686}\u{645}\u{62A}\u{648}\u{60C} \u{631}\u{648}\u{627}\u{646}\u{647} \u{627}\u{648} \u{67E}\u{647} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{631} \u{6A9}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{628}\u{647} \u{62F}\u{644}\u{62A}\u{647} \u{644}\u{6CC}\u{633}\u{62A} \u{634}\u{6CC}.`,
    pt: `Atividades de rascunho, prontas, em andamento e em espera ser\xe3o listadas aqui.`,
    'pt-pt': `Atividades de rascunho, prontas, em curso e em espera ser\xe3o listadas aqui.`,
    ru: `\u{417}\u{434}\u{435}\u{441}\u{44C} \u{431}\u{443}\u{434}\u{443}\u{442} \u{43F}\u{435}\u{440}\u{435}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}\u{44B} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{44B}, \u{433}\u{43E}\u{442}\u{43E}\u{432}\u{44B}\u{435}, \u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{435} \u{438} \u{43D}\u{430}\u{445}\u{43E}\u{434}\u{44F}\u{449}\u{438}\u{435}\u{441}\u{44F} \u{43D}\u{430} \u{443}\u{434}\u{435}\u{440}\u{436}\u{430}\u{43D}\u{438}\u{438}.`,
    sm: `O gaioiga fa'ata'ita'i, saunia, o lo'o alualu i luma, ma o lo'o taofia o le a lisiina iinei.`,
    so: `Hawlaha la qabtay, diyaar, socda, iyo kuwa la sugayo ayaa halkan lagu taxi doonaa.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E41}\u{E1A}\u{E1A}\u{E23}\u{E48}\u{E32}\u{E07} \u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21} \u{E2D}\u{E22}\u{E39}\u{E48}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23} \u{E41}\u{E25}\u{E30}\u{E23}\u{E30}\u{E07}\u{E31}\u{E1A}\u{E08}\u{E30}\u{E41}\u{E2A}\u{E14}\u{E07}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E19}\u{E35}\u{E48}`,
    ur: `\u{688}\u{631}\u{627}\u{641}\u{679}\u{60C} \u{631}\u{6CC}\u{688}\u{6CC}\u{60C} \u{62C}\u{627}\u{631}\u{6CC} \u{627}\u{648}\u{631} \u{6C1}\u{648}\u{644}\u{688} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{6CC}\u{6C1}\u{627}\u{6BA} \u{62F}\u{631}\u{62C} \u{6C1}\u{648}\u{6BA} \u{6AF}\u{6CC}\u{6D4}`,
    vi: `C\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng nh\xe1p, s\u{1EB5}n s\xe0ng, \u{111}ang ti\u{1EBF}n h\xe0nh v\xe0 t\u{1EA1}m d\u{1EEB}ng s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c li\u{1EC7}t k\xea t\u{1EA1}i \u{111}\xe2y.`,
    'zh-hans': `\u{8349}\u{7A3F}\u{3001}\u{51C6}\u{5907}\u{4E2D}\u{3001}\u{8FDB}\u{884C}\u{4E2D}\u{548C}\u{6682}\u{505C}\u{6D3B}\u{52A8}\u{5C06}\u{5728}\u{8FD9}\u{91CC}\u{5217}\u{51FA}\u{3002}`,
    'zh-hant': `\u{8349}\u{7A3F}\u{3001}\u{5DF2}\u{5B8C}\u{6210}\u{3001}\u{9032}\u{884C}\u{4E2D}\u{53CA}\u{66AB}\u{505C}\u{6D3B}\u{52D5}\u{5C07}\u{5728}\u{6B64}\u{5217}\u{51FA}\u{3002}`,
    en: `Draft, ready, in-progress, and on-hold activities will be listed here.`
};
const $b11db1b62d4a8f76$export$46b94f4580a8ef35 = {
    ar: (count)=>`${count} \u{645}\u{641}\u{62A}\u{648}\u{62D}`,
    de: (count)=>`${count} offen`,
    es: (count)=>`${count} abiertos`,
    fa: (count)=>`${count} \u{628}\u{627}\u{632}`,
    fil: (count)=>`${count} Buksan`,
    fr: (count)=>`${count} ouvert`,
    hi: (count)=>`${count} \u{916}\u{941}\u{932}\u{93E}`,
    ht: (count)=>`${count} louvri`,
    it: (count)=>`${count} open`,
    ja: (count)=>`${count} \u{30AA}\u{30FC}\u{30D7}\u{30F3}`,
    ko: (count)=>`${count} \u{C624}\u{D508}`,
    mww: (count)=>`${count} qhib`,
    ps: (count)=>`${count} \u{62E}\u{644}\u{627}\u{635}`,
    pt: (count)=>`${count} abertos`,
    'pt-pt': (count)=>`${count} abertos`,
    ru: (count)=>`${count} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{445}`,
    sm: (count)=>`${count} tatala`,
    so: (count)=>`${count} furan`,
    th: (count)=>`${count} \u{E40}\u{E1B}\u{E34}\u{E14}`,
    ur: (count)=>`${count} \u{6A9}\u{6BE}\u{644}\u{627}`,
    vi: (count)=>`${count} M\u{1EDF}`,
    'zh-hans': (count)=>`${count} \u{53F7}\u{5F00}\u{653E}`,
    'zh-hant': (count)=>`${count} \u{7A7A}\u{6A94}`,
    en: (count)=>`${count} open`
};
const $b11db1b62d4a8f76$export$e396d027002e4e67 = {
    ar: `\u{627}\u{644}\u{62D}\u{644}\u{642}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{641}\u{62A}\u{648}\u{62D}\u{629} \u{648}\u{627}\u{644}\u{639}\u{644}\u{627}\u{642}\u{627}\u{62A}`,
    de: `Offene Episoden & Beziehungen`,
    es: `Episodios abiertos y relaciones`,
    fa: `\u{642}\u{633}\u{645}\u{62A} \u{647}\u{627}\u{6CC} \u{628}\u{627}\u{632} \u{648} \u{631}\u{648}\u{627}\u{628}\u{637}`,
    fil: `Mga Bukas na Episode at Relasyon`,
    fr: `\xc9pisodes ouverts et relations`,
    hi: `\u{916}\u{941}\u{932}\u{947} \u{90F}\u{92A}\u{93F}\u{938}\u{94B}\u{921} \u{914}\u{930} \u{938}\u{902}\u{92C}\u{902}\u{927}`,
    ht: `Epiz\xf2d louvri & relasyon`,
    it: `Episodi aperti e relazioni`,
    ja: `\u{516C}\u{958B}\u{30A8}\u{30D4}\u{30BD}\u{30FC}\u{30C9}\u{3068}\u{95A2}\u{4FC2}`,
    ko: `\u{ACF5}\u{AC1C} \u{C5D0}\u{D53C}\u{C18C}\u{B4DC} \u{BC0F} \u{AD00}\u{ACC4}`,
    mww: `Qhib ntu & kev sib raug zoo`,
    ps: `\u{62E}\u{644}\u{627}\u{635}\u{6D0} \u{628}\u{631}\u{62E}\u{6D0} \u{627}\u{648} \u{627}\u{693}\u{6CC}\u{6A9}\u{6D0}`,
    pt: `Epis\xf3dios abertos e rela\xe7\xf5es`,
    'pt-pt': `Epis\xf3dios abertos e rela\xe7\xf5es`,
    ru: `\u{41E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{435} \u{44D}\u{43F}\u{438}\u{437}\u{43E}\u{434}\u{44B} \u{438} \u{43E}\u{442}\u{43D}\u{43E}\u{448}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Tatala vaega ma sootaga`,
    so: `Qaybaha furan iyo xiriirka`,
    th: `\u{E40}\u{E1B}\u{E34}\u{E14}\u{E15}\u{E2D}\u{E19}\u{E41}\u{E25}\u{E30}\u{E04}\u{E27}\u{E32}\u{E21}\u{E2A}\u{E31}\u{E21}\u{E1E}\u{E31}\u{E19}\u{E18}\u{E4C}`,
    ur: `\u{6A9}\u{6BE}\u{644}\u{6D2} \u{627}\u{642}\u{633}\u{627}\u{637} \u{627}\u{648}\u{631} \u{62A}\u{639}\u{644}\u{642}\u{627}\u{62A}`,
    vi: `M\u{1EDF} c\xe1c t\u{1EAD}p v\xe0 m\u{1ED1}i quan h\u{1EC7}`,
    'zh-hans': `\u{516C}\u{5F00}\u{5267}\u{96C6}\u{4E0E}\u{5173}\u{7CFB}`,
    'zh-hant': `\u{516C}\u{958B}\u{96C6}\u{6578}\u{8207}\u{95DC}\u{4FC2}`,
    en: `Open episodes & relations`
};
const $b11db1b62d4a8f76$export$b9b36d40df6756f8 = {
    ar: `\u{627}\u{644}\u{62D}\u{627}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{641}\u{62A}\u{648}\u{62D}\u{629}`,
    de: `Offene Status`,
    es: `Estatus abiertos`,
    fa: `\u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{628}\u{627}\u{632}`,
    fil: `Mga Bukas na Katayuan`,
    fr: `Statuts ouverts`,
    hi: `\u{916}\u{941}\u{932}\u{940} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `Estati louvri`,
    it: `Status aperti`,
    ja: `\u{30AA}\u{30FC}\u{30D7}\u{30F3}\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}`,
    ko: `\u{C624}\u{D508} \u{C0C1}\u{D0DC}`,
    mww: `Qhib cov xwm txheej`,
    ps: `\u{67E}\u{631}\u{627}\u{646}\u{6CC}\u{633}\u{62A}\u{6D0} \u{62D}\u{627}\u{644}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Status abertos`,
    'pt-pt': `Estatutos abertos`,
    ru: `\u{41E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{435} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{44B}`,
    sm: `Tatala tulaga`,
    so: `Xaaladaha furan`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E40}\u{E1B}\u{E34}\u{E14}`,
    ur: `\u{6A9}\u{6BE}\u{644}\u{6CC} \u{62D}\u{627}\u{644}\u{62A}\u{6CC}\u{6BA}`,
    vi: `Tr\u{1EA1}ng th\xe1i m\u{1EDF}`,
    'zh-hans': `\u{516C}\u{5F00}\u{72B6}\u{6001}`,
    'zh-hant': `\u{516C}\u{958B}\u{72C0}\u{614B}`,
    en: `Open statuses`
};
const $b11db1b62d4a8f76$export$44c733070f06d86e = {
    ar: `\u{623}\u{648}`,
    de: `Oder`,
    es: `O`,
    fa: `\u{6CC}\u{627}`,
    fil: `O`,
    fr: `Ou`,
    hi: `\u{92F}\u{93E}`,
    ht: `oswa`,
    it: `Oppure`,
    ja: `\u{3042}\u{308B}\u{3044}\u{306F}`,
    ko: `\u{B610}\u{B294}`,
    mww: `los yog`,
    ps: `\u{6CC}\u{627}`,
    pt: `Ou`,
    'pt-pt': `Ou`,
    ru: `\u{418}\u{43B}\u{438}`,
    sm: `po'o le`,
    so: `Ama`,
    th: `\u{E2B}\u{E23}\u{E37}\u{E2D}`,
    ur: `\u{6CC}\u{627}`,
    vi: `ho\u{1EB7}c`,
    'zh-hans': `\u{6216}\u{8005}`,
    'zh-hant': `\u{6216}\u{8005}`,
    en: `Or`
};
const $b11db1b62d4a8f76$export$7bda472d63b843a4 = {
    ar: `\u{627}\u{644}\u{62A}\u{646}\u{638}\u{64A}\u{645}`,
    de: `Organisation`,
    es: `Organizaci\xf3n`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{62F}\u{647}\u{6CC}`,
    fil: `Organisasyon`,
    fr: `Organisation`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928}`,
    ht: `\xd2ganizasyon an`,
    it: `Organizzazione`,
    ja: `\u{7D44}\u{7E54}`,
    ko: `\u{C870}\u{C9C1}`,
    mww: `Lub koom haum`,
    ps: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    pt: `Organiza\xe7\xe3o`,
    'pt-pt': `Organiza\xe7\xe3o`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Fa'alapotopotoga`,
    so: `Qaab-dhismeedka`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645}`,
    vi: `T\u{1ED5} ch\u{1EE9}c`,
    'zh-hans': `\u{7EC4}\u{7EC7}\u{7ED3}\u{6784}`,
    'zh-hant': `\u{7D44}\u{7E54}\u{67B6}\u{69CB}`,
    en: `Organization`
};
const $b11db1b62d4a8f76$export$6ef445400e80da34 = {
    ar: `\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629}`,
    de: `Organisationsaktivit\xe4ten`,
    es: `Actividades organizativas`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC}`,
    fil: `Mga aktibidad ng organisasyon`,
    fr: `Activit\xe9s organisationnelles`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `Aktivite \xf2ganizasyon an`,
    it: `Attivit\xe0 organizzative`,
    ja: `\u{7D44}\u{7E54}\u{6D3B}\u{52D5}`,
    ko: `\u{C870}\u{C9C1} \u{D65C}\u{B3D9}`,
    mww: `Lub koom haum kev ua ub no`,
    ps: `\u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Atividades organizacionais`,
    'pt-pt': `Atividades organizacionais`,
    ru: `\u{414}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Gaoioiga a le faalapotopotoga`,
    so: `Hawlaha ururka`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng t\u{1ED5} ch\u{1EE9}c`,
    'zh-hans': `\u{7EC4}\u{7EC7}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{7D44}\u{7E54}\u{6D3B}\u{52D5}`,
    en: `Organization activities`
};
const $b11db1b62d4a8f76$export$c679b7129661e5e0 = {
    ar: `\u{645}\u{646}\u{638}\u{645}\u{629} \u{62A}\u{634}\u{627}\u{631}\u{643} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639} \u{644}\u{627} \u{64A}\u{645}\u{62A}\u{644}\u{643} \u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}\u{648}\u{647}\u{627} \u{62D}\u{633}\u{627}\u{628}\u{627}\u{62A} Cumulus.`,
    de: `Eine Organisation, die am Projekt teilnimmt und deren Nutzer keine Cumulus-Konten haben.`,
    es: `Una organizaci\xf3n que participa en el proyecto cuyos usuarios no tienen cuentas de Cumulus.`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{634}\u{631}\u{6A9}\u{62A} \u{62F}\u{627}\u{631}\u{62F} \u{648} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{627}\u{646}\u{634} \u{62D}\u{633}\u{627}\u{628} Cumulus \u{646}\u{62F}\u{627}\u{631}\u{646}\u{62F}.`,
    fil: `Isang organisasyon na lumahok sa proyekto na ang mga gumagamit ay walang Cumulus account.`,
    fr: `Une organisation participant au projet dont les utilisateurs n\u{2019}ont pas de compte Cumulus.`,
    hi: `\u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E} \u{92E}\u{947}\u{902} \u{92D}\u{93E}\u{917} \u{932}\u{947}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{93E} \u{90F}\u{915} \u{938}\u{902}\u{917}\u{920}\u{928} \u{91C}\u{93F}\u{938}\u{915}\u{947} \u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E}\u{913}\u{902} \u{915}\u{947} \u{92A}\u{93E}\u{938} \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{94D}\u{92F}\u{932}\u{938} \u{916}\u{93E}\u{924}\u{947} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Yon \xf2ganizasyon k ap patisipe nan pwoj\xe8 a ki gen itilizat\xe8 yo pa gen kont Cumulus`,
    it: `Un'organizzazione che partecipa al progetto i cui utenti non hanno account Cumulus.`,
    ja: `Cumulus\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{3092}\u{6301}\u{305F}\u{306A}\u{3044}\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{3067}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{306B}\u{53C2}\u{52A0}\u{3057}\u{3066}\u{3044}\u{308B}\u{7D44}\u{7E54}\u{3002}`,
    ko: `Cumulus \u{ACC4}\u{C815}\u{C774} \u{C5C6}\u{B294} \u{C0AC}\u{C6A9}\u{C790}\u{AC00} \u{CC38}\u{C5EC}\u{D558}\u{B294} \u{C870}\u{C9C1}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib lub koom haum koom nrog txoj haujlwm uas nws cov neeg siv tsis muaj tus account Cumulus.`,
    ps: `\u{6CC}\u{648}\u{647} \u{627}\u{62F}\u{627}\u{631}\u{647} \u{686}\u{6D0} \u{67E}\u{647} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{6A9}\u{6D0} \u{628}\u{631}\u{62E}\u{647} \u{644}\u{631}\u{6CC} \u{627}\u{648} \u{6A9}\u{627}\u{631}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{6CC}\u{6D0} \u{62F} Cumulus \u{62D}\u{633}\u{627}\u{628}\u{648}\u{646}\u{647} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: `Uma organiza\xe7\xe3o que participa do projeto cujos usu\xe1rios n\xe3o possuem contas Cumulus.`,
    'pt-pt': `Uma organiza\xe7\xe3o que participa no projeto cujos utilizadores n\xe3o t\xeam contas Cumulus.`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F}, \u{443}\u{447}\u{430}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{430}\u{44F} \u{432} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{435}, \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{438} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{43E}\u{439} \u{43D}\u{435} \u{438}\u{43C}\u{435}\u{44E}\u{442} \u{430}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442}\u{43E}\u{432} Cumulus.`,
    sm: `O se fa'alapotopotoga o lo'o auai i le poloketi o ona tagata fa'aoga e leai ni teuga tupe a Cumulus.`,
    so: `Hay'ad ka qayb qaadanaysa mashruuca oo isticmaalayaashiisu aysan lahayn xisaab Cumulus ah.`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}\u{E43}\u{E19}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35} Cumulus`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{62C}\u{648} \u{627}\u{633} \u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2} \u{645}\u{6CC}\u{6BA} \u{634}\u{627}\u{645}\u{644} \u{6C1}\u{6D2} \u{627}\u{648}\u{631} \u{62C}\u{633} \u{6A9}\u{6D2} \u{635}\u{627}\u{631}\u{641}\u{6CC}\u{646} \u{6A9}\u{6D2} \u{67E}\u{627}\u{633} Cumulus \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679}\u{633} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `M\u{1ED9}t t\u{1ED5} ch\u{1EE9}c tham gia v\xe0o d\u{1EF1} \xe1n c\xf3 ng\u{1B0}\u{1EDD}i d\xf9ng kh\xf4ng c\xf3 t\xe0i kho\u{1EA3}n Cumulus.`,
    'zh-hans': `\u{53C2}\u{4E0E}\u{8BE5}\u{9879}\u{76EE}\u{7684}\u{7EC4}\u{7EC7}\u{FF0C}\u{5176}\u{7528}\u{6237}\u{6CA1}\u{6709}Cumulus\u{8D26}\u{6237}\u{3002}`,
    'zh-hant': `\u{4E00}\u{500B}\u{53C3}\u{8207}\u{5C08}\u{6848}\u{7684}\u{7D44}\u{7E54}\u{FF0C}\u{5176}\u{7528}\u{6236}\u{6C92}\u{6709} Cumulus \u{5E33}\u{865F}\u{3002}`,
    en: `An organization participating in the project whose users do not have Cumulus accounts.`
};
const $b11db1b62d4a8f76$export$57bf9fa377c63d51 = {
    ar: (membersHref)=>$b11db1b62d4a8f76$var$html`سجل جهات الاتصال الإدارية والفوترية وأنواع أخرى من الاتصالات. استخدم <a class="Link--secondary text-bold" href="${membersHref}">قسم الأعضاء</a> لإضافة مستخدمين إلى منظمتك.`,
    de: (membersHref)=>$b11db1b62d4a8f76$var$html`Erfassen Sie Verwaltungs-, Abrechnungs- und andere Kontakte. Nutzen Sie den <a class="Link--secondary text-bold" href="${membersHref}">Mitgliederbereich</a> , um Benutzer zu Ihrer Organisation hinzuzufügen.`,
    es: (membersHref)=>$b11db1b62d4a8f76$var$html`Registrar contactos administrativos, de facturación y de otros tipos de contactos. Utiliza la <a class="Link--secondary text-bold" href="${membersHref}">sección de miembros</a> para añadir usuarios a tu organización.`,
    fa: (membersHref)=>$b11db1b62d4a8f76$var$html`تماس های اداری، صورتحساب و سایر انواع تماس ها را ثبت کنید. از <a class="Link--secondary text-bold" href="${membersHref}">بخش اعضا</a> برای افزودن کاربران به سازمان خود استفاده کنید.`,
    fil: (membersHref)=>$b11db1b62d4a8f76$var$html`I-record ang mga administratibo, pagsingil, at iba pang mga uri ng mga contact. Gamitin ang <a class="Link--secondary text-bold" href="${membersHref}">seksyon ng mga miyembro</a> upang magdagdag ng mga gumagamit sa iyong samahan.`,
    fr: (membersHref)=>$b11db1b62d4a8f76$var$html`Enregistrez les contacts administratifs, facturants et autres. Utilisez la <a class="Link--secondary text-bold" href="${membersHref}">section membres</a> pour ajouter des utilisateurs à votre organisation.`,
    hi: (membersHref)=>$b11db1b62d4a8f76$var$html`प्रशासनिक, बिलिंग और अन्य प्रकार के संपर्कों को रिकॉर्ड करें. उपयोगकर्ताओं को अपने संगठन में जोड़ने के लिए <a class="Link--secondary text-bold" href="${membersHref}">सदस्य अनुभाग</a> का उपयोग करें.`,
    ht: (membersHref)=>$b11db1b62d4a8f76$var$html`Dosye administratif, bòdwo, ak lòt kalite kontak. Sèvi ak <a class="Link--secondary text-bold" href="${membersHref}">seksyon manm</a> yo ajoute itilizatè yo nan òganizasyon ou an.`,
    it: (membersHref)=>$b11db1b62d4a8f76$var$html`Registra contatti amministrativi, di fatturazione e di altri tipi di contatti. Usa la <a class="Link--secondary text-bold" href="${membersHref}">sezione membri</a> per aggiungere utenti alla tua organizzazione.`,
    ja: (membersHref)=>$b11db1b62d4a8f76$var$html`管理、請求、その他の連絡を記録する。メンバー <a class="Link--secondary text-bold" href="${membersHref}">セクション</a> を使ってユーザーを組織に追加してください。`,
    ko: (membersHref)=>$b11db1b62d4a8f76$var$html`행정, 청구 및 기타 연락처를 기록하세요. <a class="Link--secondary text-bold" href="${membersHref}">회원 섹션</a> 을 이용해 조직에 사용자를 추가하세요.`,
    mww: (membersHref)=>$b11db1b62d4a8f76$var$html`Sau cov ntaub ntawv tswj hwm, them nqi thiab lwm yam kev sib cuag. Siv cov <a class="Link--secondary text-bold" href="${membersHref}">tswv cuab seem</a> ntxiv cov neeg siv rau koj lub koom haum.`,
    ps: (membersHref)=>$b11db1b62d4a8f76$var$html`اداری، بیلینګ، او نور ډول اړیکې ثبت کړئ. د <a class="Link--secondary text-bold" href="${membersHref}">غړو برخه</a> وکاروئ ترڅو خپل سازمان ته کاروونکی اضافه کړئ.`,
    pt: (membersHref)=>$b11db1b62d4a8f76$var$html`Registre contatos administrativos, de faturamento e outros tipos. Use a <a class="Link--secondary text-bold" href="${membersHref}">seção de membros</a> para adicionar usuários à sua organização.`,
    'pt-pt': (membersHref)=>$b11db1b62d4a8f76$var$html`Registar contactos administrativos, de faturação e outros tipos de contactos. Use a <a class="Link--secondary text-bold" href="${membersHref}">secção de membros</a> para adicionar utilizadores à sua organização.`,
    ru: (membersHref)=>$b11db1b62d4a8f76$var$html`Фиксируйте административные, выставленные и другие контакты. Используйте <a class="Link--secondary text-bold" href="${membersHref}">раздел участников</a> , чтобы добавить пользователей в вашу организацию.`,
    sm: (membersHref)=>$b11db1b62d4a8f76$var$html`Faamaumau faamaumauga o le pulega, pili, ma isi ituaiga o fesootaiga. Faaaoga le vaega o tagata <a class="Link--secondary text-bold" href="${membersHref}">o le ekalesia</a> e faaopoopo ai tagata faaaoga i lau faalapotopotoga.`,
    so: (membersHref)=>$b11db1b62d4a8f76$var$html`Diiwaangeli xiriirada maamulka, biilka, iyo noocyada kale ee xiriirka. Isticmaal <a class="Link--secondary text-bold" href="${membersHref}">qaybta xubnaha</a> si aad ugu darsato isticmaaleyaal ururkaaga.`,
    th: (membersHref)=>$b11db1b62d4a8f76$var$html`บันทึกผู้ดูแลระบบ การเรียกเก็บเงิน และผู้ติดต่อชนิดอื่นๆ ใช้ <a class="Link--secondary text-bold" href="${membersHref}">ส่วนสมาชิก</a> เพื่อเพิ่มผู้ใช้ในองค์กรของคุณ`,
    ur: (membersHref)=>$b11db1b62d4a8f76$var$html`انتظامی، بلنگ اور دیگر اقسام کے رابطوں کو ریکارڈ کریں۔ اپنی تنظیم میں صارفین شامل کرنے کے <a class="Link--secondary text-bold" href="${membersHref}">لیے ممبرز سیکشن</a> استعمال کریں۔`,
    vi: (membersHref)=>$b11db1b62d4a8f76$var$html`Ghi lại các loại liên hệ quản trị, thanh toán và các loại liên hệ khác. Sử dụng <a class="Link--secondary text-bold" href="${membersHref}">phần thành viên</a> để thêm người dùng vào tổ chức của bạn.`,
    'zh-hans': (membersHref)=>$b11db1b62d4a8f76$var$html`记录行政、账单及其他类型的联系。使用 <a class="Link--secondary text-bold" href="${membersHref}">成员部分</a> 添加用户到你的组织。`,
    'zh-hant': (membersHref)=>$b11db1b62d4a8f76$var$html`記錄行政、帳單及其他類型的聯絡。使用 <a class="Link--secondary text-bold" href="${membersHref}">會員區</a> 塊來新增使用者到你的組織。`,
    en: (membersHref)=>$b11db1b62d4a8f76$var$html`Record administrative, billing, and other types of contacts. Use the <a class="Link--secondary text-bold" href="${membersHref}">members section</a> to add users to your organization.`
};
const $b11db1b62d4a8f76$export$d23e7a1502780659 = {
    ar: `\u{627}\u{644}\u{62D}\u{62F}\u{62B}`,
    de: `Veranstaltung`,
    es: `Evento`,
    fa: `\u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}`,
    fil: `Kaganapan`,
    fr: `\xc9v\xe9nement`,
    hi: `\u{906}\u{92F}\u{94B}\u{91C}\u{928}`,
    ht: `Ev\xe8nman an`,
    it: `Evento`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}`,
    ko: `\u{D589}\u{C0AC}`,
    mww: `Kev tshwm sim`,
    ps: `\u{67E}\u{6CC}\u{69A}\u{647}`,
    pt: `Evento`,
    'pt-pt': `Evento`,
    ru: `\u{421}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{435}`,
    sm: `Mea na tupu`,
    so: `Dhacdo`,
    th: `\u{E40}\u{E2B}\u{E15}\u{E38}\u{E01}\u{E32}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{62A}\u{642}\u{631}\u{6CC}\u{628}`,
    vi: `S\u{1EF1} ki\u{1EC7}n`,
    'zh-hans': `\u{4E8B}\u{4EF6}`,
    'zh-hant': `\u{6D3B}\u{52D5}`,
    en: `Event`
};
const $b11db1b62d4a8f76$export$fd5fa5d7e2f6be5d = {
    ar: `\u{62D}\u{62F}\u{62B} \u{645}\u{628}\u{627}\u{634}\u{631} \u{623}\u{648} \u{62D}\u{645}\u{644}\u{629} \u{623}\u{648} \u{646}\u{634}\u{627}\u{637} \u{622}\u{62E}\u{631} \u{64A}\u{633}\u{62A}\u{647}\u{62F}\u{641} \u{645}\u{62C}\u{645}\u{648}\u{639}\u{629} \u{645}\u{646} \u{627}\u{644}\u{623}\u{641}\u{631}\u{627}\u{62F}.`,
    de: `Eine Live-Veranstaltung, Kampagne oder andere Aktivit\xe4t, die sich an eine Gruppe von Personen richtet.`,
    es: `Un evento presencial en vivo, campa\xf1a u otra actividad dirigida a un grupo de personas.`,
    fa: `\u{6CC}\u{6A9} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{632}\u{646}\u{62F}\u{647}\u{60C} \u{6A9}\u{645}\u{67E}\u{6CC}\u{646} \u{6CC}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62D}\u{636}\u{648}\u{631}\u{6CC} \u{6A9}\u{647} \u{6AF}\u{631}\u{648}\u{647}\u{6CC} \u{627}\u{632} \u{627}\u{641}\u{631}\u{627}\u{62F} \u{631}\u{627} \u{647}\u{62F}\u{641} \u{642}\u{631}\u{627}\u{631} \u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Isang personal na live na kaganapan, kampanya, o iba pang aktibidad na nagta-target sa isang pangkat ng mga indibidwal.`,
    fr: `Un \xe9v\xe9nement en pr\xe9sentiel, une campagne ou une autre activit\xe9 ciblant un groupe d\u{2019}individus.`,
    hi: `\u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{947} \u{938}\u{92E}\u{942}\u{939} \u{915}\u{94B} \u{932}\u{915}\u{94D}\u{937}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{93E} \u{90F}\u{915} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F}\u{917}\u{924} \u{932}\u{93E}\u{907}\u{935} \u{907}\u{935}\u{947}\u{902}\u{91F}, \u{905}\u{92D}\u{93F}\u{92F}\u{93E}\u{928} \u{92F}\u{93E} \u{905}\u{928}\u{94D}\u{92F} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}.`,
    ht: `Yon ev\xe8nman an dir\xe8k an p\xe8s\xf2n, kanpay, oswa l\xf2t aktivite ki vize yon gwoup moun.`,
    it: `Un evento dal vivo in presenza, una campagna o un'altra attivit\xe0 rivolta a un gruppo di persone.`,
    ja: `\u{500B}\u{4EBA}\u{30B0}\u{30EB}\u{30FC}\u{30D7}\u{3092}\u{5BFE}\u{8C61}\u{3068}\u{3057}\u{305F}\u{5BFE}\u{9762}\u{306E}\u{30E9}\u{30A4}\u{30D6}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{3001}\u{30AD}\u{30E3}\u{30F3}\u{30DA}\u{30FC}\u{30F3}\u{3001}\u{307E}\u{305F}\u{306F}\u{305D}\u{306E}\u{4ED6}\u{306E}\u{6D3B}\u{52D5}\u{3002}`,
    ko: `\u{AC1C}\u{C778}\u{C744} \u{B300}\u{C0C1}\u{C73C}\u{B85C} \u{D55C} \u{B300}\u{BA74} \u{B77C}\u{C774}\u{BE0C} \u{C774}\u{BCA4}\u{D2B8}, \u{CEA0}\u{D398}\u{C778} \u{B610}\u{B294} \u{AE30}\u{D0C0} \u{D65C}\u{B3D9}.`,
    mww: `Ib qho kev tshwm sim nyob ntawm tus kheej, phiaj xwm, lossis lwm yam haujlwm uas tsom rau ib pab pawg neeg.`,
    ps: `\u{6CC}\u{648} \u{62D}\u{636}\u{648}\u{631}\u{6CC} \u{698}\u{648}\u{646}\u{62F}\u{6CD} \u{67E}\u{6CC}\u{69A}\u{647}\u{60C} \u{6A9}\u{645}\u{67E}\u{627}\u{6CC}\u{646}\u{60C} \u{6CC}\u{627} \u{628}\u{644} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{686}\u{6D0} \u{62F} \u{627}\u{641}\u{631}\u{627}\u{62F}\u{648} \u{6CC}\u{648}\u{6D0} \u{689}\u{644}\u{6D0} \u{62A}\u{647} \u{647}\u{62F}\u{641} \u{648}\u{6CC}.`,
    pt: `Um evento presencial ao vivo, campanha ou outra atividade voltada para um grupo de pessoas.`,
    'pt-pt': `Um evento presencial ao vivo, campanha ou outra atividade direcionada a um grupo de indiv\xedduos.`,
    ru: `\u{416}\u{438}\u{432}\u{43E}\u{435} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435}, \u{43A}\u{430}\u{43C}\u{43F}\u{430}\u{43D}\u{438}\u{44F} \u{438}\u{43B}\u{438} \u{434}\u{440}\u{443}\u{433}\u{43E}\u{435} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435}, \u{43E}\u{440}\u{438}\u{435}\u{43D}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{43E}\u{435} \u{43D}\u{430} \u{433}\u{440}\u{443}\u{43F}\u{43F}\u{443} \u{43B}\u{44E}\u{434}\u{435}\u{439}.`,
    sm: `O se mea na tupu i le tagata lava ia, tauiviga, po'o isi gaioiga e fa'atatau i se vaega o tagata ta'ito'atasi.`,
    so: `Dhacdo toos ah, ololaha, ama hawl kale oo lagu beegsanayo koox shakhsiyaad ah.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E16}\u{E48}\u{E32}\u{E22}\u{E17}\u{E2D}\u{E14}\u{E2A}\u{E14}\u{E41}\u{E1A}\u{E1A}\u{E15}\u{E31}\u{E27}\u{E15}\u{E48}\u{E2D}\u{E15}\u{E31}\u{E27} \u{E41}\u{E04}\u{E21}\u{E40}\u{E1B}\u{E0D} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E46} \u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E40}\u{E1B}\u{E49}\u{E32}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E44}\u{E1B}\u{E22}\u{E31}\u{E07}\u{E01}\u{E25}\u{E38}\u{E48}\u{E21}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}`,
    ur: `\u{630}\u{627}\u{62A}\u{6CC} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{644}\u{627}\u{626}\u{6CC}\u{648} \u{627}\u{6CC}\u{648}\u{646}\u{679}\u{60C} \u{645}\u{6C1}\u{645}\u{60C} \u{6CC}\u{627} \u{6A9}\u{648}\u{626}\u{6CC} \u{627}\u{648}\u{631} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{62C}\u{648} \u{627}\u{641}\u{631}\u{627}\u{62F} \u{6A9}\u{6D2} \u{627}\u{6CC}\u{6A9} \u{6AF}\u{631}\u{648}\u{67E} \u{6A9}\u{648} \u{6C1}\u{62F}\u{641} \u{628}\u{646}\u{627}\u{62A}\u{6CC} \u{6C1}\u{648}\u{6D4}`,
    vi: `S\u{1EF1} ki\u{1EC7}n tr\u{1EF1}c ti\u{1EBF}p, chi\u{1EBF}n d\u{1ECB}ch ho\u{1EB7}c ho\u{1EA1}t \u{111}\u{1ED9}ng kh\xe1c nh\u{1EAF}m m\u{1EE5}c ti\xeau \u{111}\u{1EBF}n m\u{1ED9}t nh\xf3m c\xe1 nh\xe2n.`,
    'zh-hans': `\u{9488}\u{5BF9}\u{4E00}\u{7FA4}\u{4EBA}\u{7684}\u{73B0}\u{573A}\u{6D3B}\u{52A8}\u{3001}\u{6D3B}\u{52A8}\u{6216}\u{5176}\u{4ED6}\u{6D3B}\u{52A8}\u{3002}`,
    'zh-hant': `\u{91DD}\u{5C0D}\u{4E00}\u{7FA4}\u{4EBA}\u{8209}\u{8FA6}\u{7684}\u{73FE}\u{5834}\u{6D3B}\u{52D5}\u{3001}\u{6D3B}\u{52D5}\u{6216}\u{5176}\u{4ED6}\u{6D3B}\u{52D5}\u{3002}`,
    en: `An in-person live event, campaign, or other activity targeting a group of individuals.`
};
const $b11db1b62d4a8f76$export$7854ec72d946e9da = {
    ar: `\u{639}\u{636}\u{648} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629}`,
    de: `Mitglied der Organisation`,
    es: `Miembro de la organizaci\xf3n`,
    fa: `\u{639}\u{636}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: `Miyembro ng organisasyon`,
    fr: `Membre de l\u{2019}organisation`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F}`,
    ht: `Manm \xf2ganizasyon an`,
    it: `Membro dell'organizzazione`,
    ja: `\u{7D44}\u{7E54}\u{30E1}\u{30F3}\u{30D0}\u{30FC}`,
    ko: `\u{C870}\u{C9C1} \u{D68C}\u{C6D0}`,
    mww: `Tus tswv cuab ntawm lub koom haum`,
    ps: `\u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{63A}\u{693}\u{6CC}`,
    pt: `Membro da organiza\xe7\xe3o`,
    'pt-pt': `Membro da organiza\xe7\xe3o`,
    ru: `\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Sui o le faalapotopotoga`,
    so: `Xubin urur`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{631}\u{6A9}\u{646}`,
    vi: `Th\xe0nh vi\xean t\u{1ED5} ch\u{1EE9}c`,
    'zh-hans': `\u{7EC4}\u{7EC7}\u{6210}\u{5458}`,
    'zh-hant': `\u{7D44}\u{7E54}\u{6210}\u{54E1}`,
    en: `Organization member`
};
const $b11db1b62d4a8f76$export$875c8af227bd90db = {
    ar: `\u{623}\u{639}\u{636}\u{627}\u{621} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629}`,
    de: `Mitglieder der Organisation`,
    es: `Miembros de la organizaci\xf3n`,
    fa: `\u{627}\u{639}\u{636}\u{627}\u{6CC} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: `Mga miyembro ng organisasyon`,
    fr: `Membres de l\u{2019}organisation`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F}`,
    ht: `Manm \xf2ganizasyon an`,
    it: `Membri dell'organizzazione`,
    ja: `\u{7D44}\u{7E54}\u{30E1}\u{30F3}\u{30D0}\u{30FC}`,
    ko: `\u{C870}\u{C9C1} \u{AD6C}\u{C131}\u{C6D0}`,
    mww: `Cov tswv cuab ntawm lub koom haum`,
    ps: `\u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{63A}\u{693}\u{6CC}`,
    pt: `Membros da organiza\xe7\xe3o`,
    'pt-pt': `Membros da organiza\xe7\xe3o`,
    ru: `\u{427}\u{43B}\u{435}\u{43D}\u{44B} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Sui o le faalapotopotoga`,
    so: `Xubnaha ururka`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{627}\u{631}\u{6A9}\u{627}\u{646}`,
    vi: `Th\xe0nh vi\xean t\u{1ED5} ch\u{1EE9}c`,
    'zh-hans': `\u{7EC4}\u{7EC7}\u{6210}\u{5458}`,
    'zh-hant': `\u{7D44}\u{7E54}\u{6210}\u{54E1}`,
    en: `Organization members`
};
const $b11db1b62d4a8f76$export$6d10fa154c9a0e20 = {
    ar: `\u{625}\u{637}\u{627}\u{631} \u{632}\u{645}\u{646}\u{64A} \u{64A}\u{633}\u{62A}\u{62E}\u{62F}\u{645} \u{644}\u{645}\u{62D}\u{627}\u{630}\u{627}\u{629} \u{62A}\u{648}\u{627}\u{631}\u{64A}\u{62E} \u{628}\u{62F}\u{621} \u{648}\u{646}\u{647}\u{627}\u{64A}\u{629} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{645}\u{639} \u{646}\u{637}\u{627}\u{642} \u{632}\u{645}\u{646}\u{64A} \u{645}\u{62D}\u{62F}\u{62F}.`,
    de: `Ein Zeitrahmen, der verwendet wird, um Start- und Enddaten der Aktivit\xe4ten auf einen bestimmten Zeitraum abzustimmen.`,
    es: `Un marco temporal utilizado para alinear las fechas de inicio y fin de la actividad con un rango de fechas espec\xedfico.`,
    fa: `\u{6CC}\u{6A9} \u{628}\u{627}\u{632}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{647}\u{645}\u{627}\u{647}\u{646}\u{6AF} \u{6A9}\u{631}\u{62F}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{647}\u{627}\u{6CC} \u{634}\u{631}\u{648}\u{639} \u{648} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{627} \u{6CC}\u{6A9} \u{628}\u{627}\u{632}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{645}\u{634}\u{62E}\u{635} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{645}\u{6CC} \u{634}\u{648}\u{62F}.`,
    fil: `Isang time-frame na ginagamit upang ihanay ang mga petsa ng pagsisimula at pagtatapos ng aktibidad sa isang tiyak na hanay ng petsa.`,
    fr: `Un d\xe9lai utilis\xe9 pour aligner les dates de d\xe9but et de fin des activit\xe9s \xe0 une plage de dates sp\xe9cifique.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{914}\u{930} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{924}\u{93F}\u{925}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{915}\u{93F}\u{938}\u{940} \u{935}\u{93F}\u{936}\u{93F}\u{937}\u{94D}\u{91F} \u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915} \u{938}\u{940}\u{92E}\u{93E} \u{938}\u{947} \u{938}\u{902}\u{930}\u{947}\u{916}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{940} \u{91C}\u{93E}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{940} \u{938}\u{92E}\u{92F}-\u{938}\u{940}\u{92E}\u{93E}.`,
    ht: `Yon tan-ankadreman itilize pou aliman dat k\xf2manse ak fen aktivite nan yon seri dat espesifik.`,
    it: `Un intervallo temporale utilizzato per allineare le date di inizio e fine delle attivit\xe0 a un intervallo di date specifico.`,
    ja: `\u{6D3B}\u{52D5}\u{958B}\u{59CB}\u{65E5}\u{3068}\u{7D42}\u{4E86}\u{65E5}\u{3092}\u{7279}\u{5B9A}\u{306E}\u{65E5}\u{4ED8}\u{7BC4}\u{56F2}\u{306B}\u{5408}\u{308F}\u{305B}\u{308B}\u{305F}\u{3081}\u{306E}\u{6642}\u{9593}\u{67A0}\u{3067}\u{3059}\u{3002}`,
    ko: `\u{D65C}\u{B3D9} \u{C2DC}\u{C791}\u{C77C}\u{ACFC} \u{C885}\u{B8CC}\u{C77C}\u{C744} \u{D2B9}\u{C815} \u{B0A0}\u{C9DC} \u{BC94}\u{C704}\u{C5D0} \u{B9DE}\u{CD94}\u{AE30} \u{C704}\u{D574} \u{C0AC}\u{C6A9}\u{B418}\u{B294} \u{C2DC}\u{AC04} \u{D504}\u{B808}\u{C784}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib lub sij hawm siv los kho cov hnub pib thiab xaus rau ib lub sijhawm tshwj xeeb.`,
    ps: `\u{6CC}\u{648} \u{648}\u{62E}\u{62A} \u{686}\u{648}\u{6A9}\u{627}\u{67C} \u{686}\u{6D0} \u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62F} \u{67E}\u{6CC}\u{644} \u{627}\u{648} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{6D0} \u{62F} \u{6CC}\u{648}\u{6D0} \u{681}\u{627}\u{646}\u{6AB}\u{693}\u{6D0} \u{646}\u{6D0}\u{67C}\u{6D0} \u{633}\u{631}\u{647} \u{62F} \u{62A}\u{637}\u{627}\u{628}\u{642} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{6A9}\u{627}\u{631}\u{648}\u{644} \u{6A9}\u{6D0}\u{696}\u{6CC}.`,
    pt: `Um per\xedodo de tempo usado para alinhar as datas de in\xedcio e t\xe9rmino das atividades a um intervalo de datas espec\xedfico.`,
    'pt-pt': `Um marco temporal usado para alinhar as datas de in\xedcio e fim da atividade a um intervalo de datas espec\xedfico.`,
    ru: `\u{412}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{43E}\u{439} \u{43F}\u{440}\u{43E}\u{43C}\u{435}\u{436}\u{443}\u{442}\u{43E}\u{43A}, \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{435}\u{43C}\u{44B}\u{439} \u{434}\u{43B}\u{44F} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{441}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{434}\u{430}\u{442} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{441} \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{451}\u{43D}\u{43D}\u{44B}\u{43C} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{43E}\u{43C} \u{434}\u{430}\u{442}.`,
    sm: `O se taimi fa'atulagaina e fa'aaoga e fa'afetaui ai aso amata ma fa'ai'u o gaioiga i se aso fa'apitoa.`,
    so: `Waqti loo isticmaalo in lagu waafajiyo taariikhaha bilowga iyo dhammaadka hawlaha si loo waafajiyo taariikh gaar ah.`,
    th: `\u{E01}\u{E23}\u{E2D}\u{E1A}\u{E40}\u{E27}\u{E25}\u{E32}\u{E17}\u{E35}\u{E48}\u{E43}\u{E0A}\u{E49}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E08}\u{E31}\u{E14}\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E41}\u{E25}\u{E30}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E43}\u{E2B}\u{E49}\u{E15}\u{E23}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E0A}\u{E48}\u{E27}\u{E07}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E35}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{648}\u{642}\u{62A} \u{6A9}\u{627} \u{641}\u{631}\u{6CC}\u{645} \u{62C}\u{648} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6D2} \u{622}\u{63A}\u{627}\u{632} \u{627}\u{648}\u{631} \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{648}\u{6BA} \u{6A9}\u{648} \u{645}\u{62E}\u{635}\u{648}\u{635} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{6CC} \u{62D}\u{62F} \u{6A9}\u{6D2} \u{645}\u{637}\u{627}\u{628}\u{642} \u{62A}\u{631}\u{62A}\u{6CC}\u{628} \u{62F}\u{6CC}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6C1}\u{648}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Khung th\u{1EDD}i gian \u{111}\u{1B0}\u{1EE3}c s\u{1EED} d\u{1EE5}ng \u{111}\u{1EC3} c\u{103}n ch\u{1EC9}nh ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u v\xe0 ng\xe0y k\u{1EBF}t th\xfac ho\u{1EA1}t \u{111}\u{1ED9}ng theo m\u{1ED9}t ph\u{1EA1}m vi ng\xe0y c\u{1EE5} th\u{1EC3}.`,
    'zh-hans': `\u{4E00}\u{4E2A}\u{65F6}\u{95F4}\u{6846}\u{67B6}\u{FF0C}\u{7528}\u{4E8E}\u{5C06}\u{6D3B}\u{52A8}\u{5F00}\u{59CB}\u{548C}\u{7ED3}\u{675F}\u{65E5}\u{671F}\u{5BF9}\u{9F50}\u{5230}\u{7279}\u{5B9A}\u{7684}\u{65E5}\u{671F}\u{8303}\u{56F4}\u{3002}`,
    'zh-hant': `\u{4E00}\u{500B}\u{7528}\u{4F86}\u{5C07}\u{6D3B}\u{52D5}\u{958B}\u{59CB}\u{8207}\u{7D50}\u{675F}\u{65E5}\u{671F}\u{5C0D}\u{9F4A}\u{7279}\u{5B9A}\u{65E5}\u{671F}\u{7BC4}\u{570D}\u{7684}\u{6642}\u{9593}\u{6846}\u{67B6}\u{3002}`,
    en: `A time-frame used to align activity start and end dates to a specific date range.`
};
const $b11db1b62d4a8f76$export$fc6d25d72e8dca9c = {
    ar: `\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646} \u{627}\u{644}\u{62A}\u{646}\u{638}\u{64A}\u{645}`,
    de: `Organisationsfragebogen`,
    es: `Cuestionario de organizaci\xf3n`,
    fa: `\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC}`,
    fil: `Talatanungan ng organisasyon`,
    fr: `Questionnaire sur l\u{2019}organisation`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{93E}\u{935}\u{932}\u{940}`,
    ht: `Kesyon\xe8 \xf2ganizasyon an`,
    it: `Questionario organizzativo`,
    ja: `\u{7D44}\u{7E54}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}`,
    ko: `\u{C870}\u{C9C1} \u{C124}\u{BB38}\u{C9C0}`,
    mww: `Cov lus nug ntawm lub koom haum`,
    ps: `\u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9}`,
    pt: `Question\xe1rio da organiza\xe7\xe3o`,
    'pt-pt': `Question\xe1rio da organiza\xe7\xe3o`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{430}\u{44F} \u{430}\u{43D}\u{43A}\u{435}\u{442}\u{430}`,
    sm: `Fesili a le faalapotopotoga`,
    so: `Su'aalaha ururka`,
    th: `\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{6CC} \u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6C1}`,
    vi: `B\u{1EA3}ng c\xe2u h\u{1ECF}i t\u{1ED5} ch\u{1EE9}c`,
    'zh-hans': `\u{7EC4}\u{7EC7}\u{95EE}\u{5377}`,
    'zh-hant': `\u{7D44}\u{7E54}\u{554F}\u{5377}`,
    en: `Organization questionnaire`
};
const $b11db1b62d4a8f76$export$d010d50b14e45bda = {
    ar: `\u{645}\u{62C}\u{645}\u{648}\u{639}\u{629} \u{645}\u{646} \u{627}\u{644}\u{623}\u{633}\u{626}\u{644}\u{629} \u{627}\u{644}\u{645}\u{62A}\u{639}\u{644}\u{642}\u{629} \u{628}\u{645}\u{646}\u{638}\u{645}\u{629} \u{623}\u{648} \u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}\u{60C} \u{63A}\u{64A}\u{631} \u{645}\u{631}\u{62A}\u{628}\u{637}\u{629} \u{628}\u{639}\u{645}\u{64A}\u{644} \u{645}\u{639}\u{64A}\u{646}.`,
    de: `Eine Reihe von Fragen, die sich auf eine Organisation oder einen Nutzer beziehen, aber nichts mit einem bestimmten Kunden zu tun haben.`,
    es: `Un conjunto de preguntas relacionadas con una organizaci\xf3n o usuario, no relacionadas con un cliente espec\xedfico.`,
    fa: `\u{645}\u{62C}\u{645}\u{648}\u{639}\u{647} \u{627}\u{6CC} \u{627}\u{632} \u{633}\u{648}\u{627}\u{644}\u{627}\u{62A} \u{645}\u{631}\u{62A}\u{628}\u{637} \u{628}\u{627} \u{6CC}\u{6A9} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{6CC}\u{627} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{60C} \u{6A9}\u{647} \u{628}\u{647} \u{6CC}\u{6A9} \u{645}\u{634}\u{62A}\u{631}\u{6CC} \u{62E}\u{627}\u{635} \u{645}\u{631}\u{62A}\u{628}\u{637} \u{646}\u{6CC}\u{633}\u{62A}.`,
    fil: `Isang hanay ng mga katanungan na may kaugnayan sa isang organisasyon o gumagamit, na walang kaugnayan sa isang partikular na kliyente.`,
    fr: `Un ensemble de questions li\xe9es \xe0 une organisation ou \xe0 un utilisateur, sans rapport avec un client sp\xe9cifique.`,
    hi: `\u{915}\u{93F}\u{938}\u{940} \u{938}\u{902}\u{917}\u{920}\u{928} \u{92F}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E} \u{938}\u{947} \u{938}\u{902}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{94B}\u{902} \u{915}\u{93E} \u{90F}\u{915} \u{938}\u{947}\u{91F}, \u{91C}\u{94B} \u{915}\u{93F}\u{938}\u{940} \u{935}\u{93F}\u{936}\u{93F}\u{937}\u{94D}\u{91F} \u{915}\u{94D}\u{932}\u{93E}\u{907}\u{902}\u{91F} \u{938}\u{947} \u{905}\u{938}\u{902}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{939}\u{94B}\u{924}\u{93E} \u{939}\u{948}.`,
    ht: `Yon seri kesyon ki gen rap\xf2 ak yon \xf2ganizasyon oswa itilizat\xe8, ki pa gen rap\xf2 ak yon kliyan espesifik.`,
    it: `Un insieme di domande relative a un'organizzazione o a un utente, non collegate a un cliente specifico.`,
    ja: `\u{7279}\u{5B9A}\u{306E}\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}\u{3068}\u{306F}\u{95A2}\u{4FC2}\u{306E}\u{306A}\u{3044}\u{3001}\u{7D44}\u{7E54}\u{3084}\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{306B}\u{95A2}\u{3059}\u{308B}\u{4E00}\u{9023}\u{306E}\u{8CEA}\u{554F}\u{3067}\u{3059}\u{3002}`,
    ko: `\u{D2B9}\u{C815} \u{D074}\u{B77C}\u{C774}\u{C5B8}\u{D2B8}\u{C640}\u{B294} \u{BB34}\u{AD00}\u{D55C} \u{C870}\u{C9C1}\u{C774}\u{B098} \u{C0AC}\u{C6A9}\u{C790}\u{C640} \u{AD00}\u{B828}\u{B41C} \u{C9C8}\u{BB38} \u{C9D1}\u{D569}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib pawg ntawm cov lus nug ntsig txog ib lub koom haum lossis tus neeg siv, tsis cuam tshuam nrog tus neeg siv khoom tshwj xeeb.`,
    ps: `\u{62F} \u{6CC}\u{648}\u{6D0} \u{627}\u{62F}\u{627}\u{631}\u{6D0} \u{6CC}\u{627} \u{6A9}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC} \u{627}\u{693}\u{648}\u{646}\u{62F} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{648} \u{67C}\u{648}\u{644}\u{6AB}\u{647}\u{60C} \u{686}\u{6D0} \u{644}\u{647} \u{681}\u{627}\u{646}\u{6AB}\u{693}\u{6CC} \u{67E}\u{6CC}\u{631}\u{648}\u{62F}\u{648}\u{646}\u{6A9}\u{6CC} \u{633}\u{631}\u{647} \u{62A}\u{693}\u{627}\u{648} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: `Um conjunto de perguntas relacionadas a uma organiza\xe7\xe3o ou usu\xe1rio, sem rela\xe7\xe3o com um cliente espec\xedfico.`,
    'pt-pt': `Um conjunto de perguntas relacionadas com uma organiza\xe7\xe3o ou utilizador, n\xe3o relacionadas com um cliente espec\xedfico.`,
    ru: `\u{41D}\u{430}\u{431}\u{43E}\u{440} \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{43E}\u{432}, \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{435}\u{439} \u{438}\u{43B}\u{438} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{43C}, \u{43D}\u{435} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441} \u{43A}\u{43E}\u{43D}\u{43A}\u{440}\u{435}\u{442}\u{43D}\u{44B}\u{43C} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{43C}.`,
    sm: `O se seti o fesili e feso'ota'i ma se fa'alapotopotoga po'o se tagata fa'aaoga, e le feso'ota'i ma se tagata fa'apitoa.`,
    so: `Su'aalo la xiriira urur ama isticmaale, oo aan la xiriirin macmiil gaar ah.`,
    th: `\u{E0A}\u{E38}\u{E14}\u{E04}\u{E4D}\u{E32}\u{E16}\u{E32}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49} \u{E0B}\u{E36}\u{E48}\u{E07}\u{E44}\u{E21}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E44}\u{E04}\u{E25}\u{E40}\u{E2D}\u{E47}\u{E19}\u{E15}\u{E4C}\u{E40}\u{E09}\u{E1E}\u{E32}\u{E30}`,
    ur: `\u{6A9}\u{633}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6CC}\u{627} \u{635}\u{627}\u{631}\u{641} \u{633}\u{6D2} \u{645}\u{62A}\u{639}\u{644}\u{642} \u{633}\u{648}\u{627}\u{644}\u{627}\u{62A} \u{6A9}\u{627} \u{645}\u{62C}\u{645}\u{648}\u{639}\u{6C1}\u{60C} \u{62C}\u{648} \u{6A9}\u{633}\u{6CC} \u{645}\u{62E}\u{635}\u{648}\u{635} \u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679} \u{633}\u{6D2} \u{645}\u{62A}\u{639}\u{644}\u{642} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED9}t t\u{1EAD}p h\u{1EE3}p c\xe1c c\xe2u h\u{1ECF}i li\xean quan \u{111}\u{1EBF}n m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c ho\u{1EB7}c ng\u{1B0}\u{1EDD}i d\xf9ng, kh\xf4ng li\xean quan \u{111}\u{1EBF}n m\u{1ED9}t kh\xe1ch h\xe0ng c\u{1EE5} th\u{1EC3}.`,
    'zh-hans': `\u{4E00}\u{7EC4}\u{4E0E}\u{67D0}\u{4E2A}\u{7EC4}\u{7EC7}\u{6216}\u{7528}\u{6237}\u{76F8}\u{5173}\u{7684}\u{95EE}\u{9898}\u{FF0C}\u{4E0E}\u{7279}\u{5B9A}\u{5BA2}\u{6237}\u{65E0}\u{5173}\u{3002}`,
    'zh-hant': `\u{4E00}\u{7D44}\u{8207}\u{7D44}\u{7E54}\u{6216}\u{4F7F}\u{7528}\u{8005}\u{76F8}\u{95DC}\u{7684}\u{554F}\u{984C}\u{FF0C}\u{8207}\u{7279}\u{5B9A}\u{5BA2}\u{6236}\u{7121}\u{95DC}\u{3002}`,
    en: `A set of questions related to an organization or user, unrelated to a specific client.`
};
const $b11db1b62d4a8f76$export$318c8afd1f8ee455 = {
    ar: `\u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{627}\u{62A}`,
    de: `Organisationen`,
    es: `Organizaciones`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{647}\u{627}`,
    fil: `Mga Organisasyon`,
    fr: `Organisations`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928}\u{94B}\u{902}`,
    ht: `\xd2ganizasyon yo`,
    it: `Organizzazioni`,
    ja: `\u{7D44}\u{7E54}`,
    ko: `\u{B2E8}\u{CCB4}`,
    mww: `Cov koom haum`,
    ps: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{647}`,
    pt: `Organiza\xe7\xf5es`,
    'pt-pt': `Organiza\xe7\xf5es`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Fa'alapotopotoga`,
    so: `Ururada`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{6CC}\u{6BA}`,
    vi: `T\u{1ED5} ch\u{1EE9}c`,
    'zh-hans': `\u{7EC4}\u{7EC7}`,
    'zh-hant': `\u{7D44}\u{7E54}`,
    en: `Organizations`
};
const $b11db1b62d4a8f76$export$8a207254b784b0a6 = {
    ar: `\u{645}\u{648}\u{642}\u{639} \u{62A}\u{62C}\u{631}\u{64A} \u{641}\u{64A}\u{647} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629} \u{639}\u{645}\u{644}\u{64A}\u{627}\u{62A}\u{647}\u{627}.`,
    de: `Ein Ort, an dem eine Organisation t\xe4tig ist.`,
    es: `Un lugar donde una organizaci\xf3n realiza sus operaciones.`,
    fa: `\u{645}\u{6A9}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{6CC}\u{6A9} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62F}\u{631} \u{622}\u{646} \u{639}\u{645}\u{644}\u{6CC}\u{627}\u{62A} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Isang lugar kung saan ang isang organisasyon ay nagsasagawa ng mga operasyon.`,
    fr: `Un lieu o\xf9 une organisation m\xe8ne ses op\xe9rations.`,
    hi: `\u{90F}\u{915} \u{938}\u{94D}\u{925}\u{93E}\u{928} \u{91C}\u{939}\u{93E}\u{902} \u{90F}\u{915} \u{938}\u{902}\u{917}\u{920}\u{928} \u{938}\u{902}\u{91A}\u{93E}\u{932}\u{928} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Yon kote yon \xf2ganizasyon ap f\xe8 operasyon.`,
    it: `Un luogo dove un'organizzazione conduce operazioni.`,
    ja: `\u{7D44}\u{7E54}\u{304C}\u{4F5C}\u{6226}\u{3092}\u{884C}\u{3046}\u{5834}\u{6240}\u{3002}`,
    ko: `\u{C870}\u{C9C1}\u{C774} \u{C6B4}\u{C601}\u{C744} \u{C218}\u{D589}\u{D558}\u{B294} \u{C7A5}\u{C18C}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib qho chaw uas ib lub koom haum ua haujlwm.`,
    ps: `\u{6CC}\u{648} \u{681}\u{627}\u{6CC} \u{686}\u{6D0} \u{6CC}\u{648}\u{647} \u{627}\u{62F}\u{627}\u{631}\u{647} \u{67E}\u{6A9}\u{6D0} \u{639}\u{645}\u{644}\u{6CC}\u{627}\u{62A} \u{62A}\u{631}\u{633}\u{631}\u{647} \u{6A9}\u{648}\u{6CC}.`,
    pt: `Um local onde uma organiza\xe7\xe3o realiza opera\xe7\xf5es.`,
    'pt-pt': `Um local onde uma organiza\xe7\xe3o realiza opera\xe7\xf5es.`,
    ru: `\u{41C}\u{435}\u{441}\u{442}\u{43E}, \u{433}\u{434}\u{435} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{43F}\u{440}\u{43E}\u{432}\u{43E}\u{434}\u{438}\u{442} \u{43E}\u{43F}\u{435}\u{440}\u{430}\u{446}\u{438}\u{438}.`,
    sm: `O se nofoaga e fa'atautaia ai e se fa'alapotopotoga gaioiga.`,
    so: `Goob ay urur ka hawlgallo ka wado.`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{627}\u{6CC}\u{633}\u{6CC} \u{62C}\u{6AF}\u{6C1} \u{62C}\u{6C1}\u{627}\u{6BA} \u{6A9}\u{648}\u{626}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{622}\u{67E}\u{631}\u{6CC}\u{634}\u{646}\u{632} \u{6A9}\u{631}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED9}t \u{111}\u{1ECB}a \u{111}i\u{1EC3}m m\xe0 m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c ti\u{1EBF}n h\xe0nh c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng.`,
    'zh-hans': `\u{4E00}\u{4E2A}\u{7EC4}\u{7EC7}\u{8FDB}\u{884C}\u{8FD0}\u{8425}\u{7684}\u{5730}\u{70B9}\u{3002}`,
    'zh-hant': `\u{4E00}\u{500B}\u{7D44}\u{7E54}\u{9032}\u{884C}\u{904B}\u{4F5C}\u{7684}\u{5730}\u{9EDE}\u{3002}`,
    en: `A location where an organization conducts operations.`
};
const $b11db1b62d4a8f76$export$979ca5d8ff2b59d0 = {
    ar: `\u{633}\u{62C}\u{644} \u{627}\u{633}\u{645} \u{648}\u{631}\u{642}\u{645} \u{647}\u{627}\u{62A}\u{641} \u{648}\u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{645}\u{648}\u{627}\u{642}\u{639} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{639}\u{645}\u{644} \u{641}\u{64A}\u{647}\u{627} \u{634}\u{631}\u{643}\u{62A}\u{643}.`,
    de: `Notieren Sie den Namen, die Telefonnummer und die Adresse der Standorte, an denen Ihr Unternehmen t\xe4tig ist.`,
    es: `Registra el nombre, n\xfamero de tel\xe9fono y direcci\xf3n de los sitios donde opera tu organizaci\xf3n.`,
    fa: `\u{646}\u{627}\u{645}\u{60C} \u{634}\u{645}\u{627}\u{631}\u{647} \u{62A}\u{644}\u{641}\u{646} \u{648} \u{622}\u{62F}\u{631}\u{633} \u{633}\u{627}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC}\u{6CC} \u{6A9}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{634}\u{645}\u{627} \u{62F}\u{631} \u{622}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F} \u{631}\u{627} \u{62B}\u{628}\u{62A} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Itala ang pangalan, numero ng telepono, at address ng mga site kung saan nagpapatakbo ang iyong samahan.`,
    fr: `Notez le nom, le num\xe9ro de t\xe9l\xe9phone et l\u{2019}adresse des sites o\xf9 votre organisation op\xe8re.`,
    hi: `\u{909}\u{928} \u{938}\u{93E}\u{907}\u{91F}\u{94B}\u{902} \u{915}\u{93E} \u{928}\u{93E}\u{92E}, \u{92B}\u{93C}\u{94B}\u{928} \u{928}\u{902}\u{92C}\u{930} \u{914}\u{930} \u{92A}\u{924}\u{93E} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{915}\u{930}\u{947}\u{902} \u{91C}\u{939}\u{93E}\u{901} \u{906}\u{92A}\u{915}\u{93E} \u{938}\u{902}\u{917}\u{920}\u{928} \u{938}\u{902}\u{91A}\u{93E}\u{932}\u{93F}\u{924} \u{939}\u{94B}\u{924}\u{93E} \u{939}\u{948}.`,
    ht: `Anrejistre non, nimewo telef\xf2n, ak adr\xe8s sit kote \xf2ganizasyon w lan ap travay.`,
    it: `Annota nome, numero di telefono e indirizzo dei siti dove opera la tua organizzazione.`,
    ja: `\u{7D44}\u{7E54}\u{304C}\u{904B}\u{55B6}\u{3057}\u{3066}\u{3044}\u{308B}\u{5834}\u{6240}\u{306E}\u{540D}\u{524D}\u{3001}\u{96FB}\u{8A71}\u{756A}\u{53F7}\u{3001}\u{4F4F}\u{6240}\u{3092}\u{8A18}\u{9332}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C870}\u{C9C1}\u{C774} \u{C6B4}\u{C601}\u{D558}\u{B294} \u{C0AC}\u{C774}\u{D2B8}\u{C758} \u{C774}\u{B984}, \u{C804}\u{D654}\u{BC88}\u{D638}, \u{C8FC}\u{C18C}\u{B97C} \u{AE30}\u{B85D}\u{D558}\u{C138}\u{C694}.`,
    mww: `Sau lub npe, xov tooj, thiab chaw nyob ntawm cov chaw uas koj lub koom haum ua haujlwm.`,
    ps: `\u{62F} \u{647}\u{63A}\u{648} \u{633}\u{627}\u{6CC}\u{67C}\u{648}\u{646}\u{648} \u{646}\u{648}\u{645}\u{60C} \u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646} \u{634}\u{645}\u{6D0}\u{631}\u{647}\u{60C} \u{627}\u{648} \u{67E}\u{62A}\u{647} \u{62B}\u{628}\u{62A} \u{6A9}\u{693}\u{626} \u{686}\u{6D0} \u{633}\u{62A}\u{627}\u{633}\u{648} \u{627}\u{62F}\u{627}\u{631}\u{647} \u{67E}\u{6A9}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{648}\u{6CC}.`,
    pt: `Registre o nome, telefone e endere\xe7o dos sites onde sua organiza\xe7\xe3o opera.`,
    'pt-pt': `Registe o nome, n\xfamero de telefone e morada dos sites onde a sua organiza\xe7\xe3o opera.`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{448}\u{438}\u{442}\u{435} \u{43D}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{438}\u{435}, \u{43D}\u{43E}\u{43C}\u{435}\u{440} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{430} \u{438} \u{430}\u{434}\u{440}\u{435}\u{441} \u{441}\u{430}\u{439}\u{442}\u{43E}\u{432}, \u{433}\u{434}\u{435} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{430}\u{435}\u{442} \u{432}\u{430}\u{448}\u{430} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F}.`,
    sm: `Faamaumau le igoa, numera o le telefoni, ma le tuatusi o nofoaga o loo faagaoioia ai lau faalapotopotoga.`,
    so: `Diiwaangeli magaca, lambarka telefoonka, iyo cinwaanka goobaha ay ururkaagu ka shaqeeyo.`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E0A}\u{E37}\u{E48}\u{E2D} \u{E2B}\u{E21}\u{E32}\u{E22}\u{E40}\u{E25}\u{E02}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C} \u{E41}\u{E25}\u{E30}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{627}\u{646} \u{633}\u{627}\u{626}\u{679}\u{633} \u{6A9}\u{627} \u{646}\u{627}\u{645}\u{60C} \u{641}\u{648}\u{646} \u{646}\u{645}\u{628}\u{631}\u{60C} \u{627}\u{648}\u{631} \u{67E}\u{62A}\u{6C1} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{62C}\u{6C1}\u{627}\u{6BA} \u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627}\u{645} \u{6A9}\u{631}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ghi l\u{1EA1}i t\xean, s\u{1ED1} \u{111}i\u{1EC7}n tho\u{1EA1}i v\xe0 \u{111}\u{1ECB}a ch\u{1EC9} c\u{1EE7}a c\xe1c trang web n\u{1A1}i t\u{1ED5} ch\u{1EE9}c c\u{1EE7}a b\u{1EA1}n ho\u{1EA1}t \u{111}\u{1ED9}ng.`,
    'zh-hans': `\u{8BB0}\u{5F55}\u{8D35}\u{7EC4}\u{7EC7}\u{8FD0}\u{8425}\u{5730}\u{70B9}\u{7684}\u{540D}\u{79F0}\u{3001}\u{7535}\u{8BDD}\u{53F7}\u{7801}\u{548C}\u{5730}\u{5740}\u{3002}`,
    'zh-hant': `\u{8A18}\u{9304}\u{4F60}\u{7D44}\u{7E54}\u{71DF}\u{904B}\u{5730}\u{9EDE}\u{7684}\u{540D}\u{7A31}\u{3001}\u{96FB}\u{8A71}\u{865F}\u{78BC}\u{548C}\u{5730}\u{5740}\u{3002}`,
    en: `Record the name, phone number, and address of sites where your organization operates.`
};
const $b11db1b62d4a8f76$export$e57aa8d203496d61 = {
    ar: (label)=>`${label} \u{645}\u{646}\u{638}\u{645}\u{629} \u{623}\u{62E}\u{631}\u{649} \u{644}\u{62F}\u{64A}\u{647}\u{627} \u{648}\u{635}\u{648}\u{644} \u{639}\u{646} \u{637}\u{631}\u{64A}\u{642} \u{627}\u{644}\u{645}\u{648}\u{627}\u{641}\u{642}\u{629}`,
    de: (label)=>`${label} weitere Organisationen haben Zugang per Zustimmung`,
    es: (label)=>`${label} organizaciones m\xe1s tienen acceso mediante consentimiento`,
    fa: (label)=>`\u{6F1}\u{6F2} ${label} \u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{631}\u{636}\u{627}\u{6CC}\u{62A} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{62F}\u{627}\u{631}\u{646}\u{62F}`,
    fil: (label)=>`${label} higit pang mga organisasyon ang may access sa pamamagitan ng pahintulot`,
    fr: (label)=>`${label} autres organisations y ont acc\xe8s par consentement`,
    hi: (label)=>`${label} \u{914}\u{930} \u{938}\u{902}\u{917}\u{920}\u{928}\u{94B}\u{902} \u{915}\u{947} \u{92A}\u{93E}\u{938} \u{938}\u{939}\u{92E}\u{924}\u{93F} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{92A}\u{939}\u{941}\u{902}\u{91A} \u{939}\u{948}`,
    ht: (label)=>`${label} plis \xf2ganizasyon gen aks\xe8 atrav\xe8 konsantman`,
    it: (label)=>`${label} organizzazioni hanno accesso tramite consenso`,
    ja: (label)=>`\u{3055}\u{3089}\u{306B}${label}\u{306E}\u{56E3}\u{4F53}\u{304C}\u{540C}\u{610F}\u{306B}\u{3088}\u{308B}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{6A29}\u{3092}\u{6301}\u{3063}\u{3066}\u{3044}\u{307E}\u{3059}`,
    ko: (label)=>`${label} \u{AC1C} \u{C774}\u{C0C1}\u{C758} \u{B2E8}\u{CCB4}\u{AC00} \u{B3D9}\u{C758}\u{B97C} \u{D1B5}\u{D574} \u{C811}\u{ADFC}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: (label)=>`${label} lub koom haum ntxiv muaj kev nkag mus los ntawm kev pom zoo`,
    ps: (label)=>`\u{6F1}\u{6F2} ${label} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{647} \u{62F} \u{631}\u{636}\u{627}\u{6CC}\u{62A} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{644}\u{631}\u{6CC}`,
    pt: (label)=>`Mais ${label} organiza\xe7\xf5es t\xeam acesso por consentimento`,
    'pt-pt': (label)=>`Mais ${label} organiza\xe7\xf5es t\xeam acesso por consentimento`,
    ru: (label)=>`${label} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{439} \u{438}\u{43C}\u{435}\u{44E}\u{442} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{43F}\u{43E} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{441}\u{438}\u{44E}`,
    sm: (label)=>`${label} isi fa'alapotopotoga e mafai ona maua e ala i le maliega`,
    so: (label)=>`${label} urur oo kale ayaa helaya ogolaansho`,
    th: (label)=>`\u{E2D}\u{E35}\u{E01} ${label} \u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E44}\u{E14}\u{E49}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E04}\u{E27}\u{E32}\u{E21}\u{E22}\u{E34}\u{E19}\u{E22}\u{E2D}\u{E21}`,
    ur: (label)=>`\u{645}\u{632}\u{6CC}\u{62F} ${label} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{648}\u{6BA} \u{6A9}\u{648} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6C1}\u{6D2}`,
    vi: (label)=>`${label} t\u{1ED5} ch\u{1EE9}c kh\xe1c c\xf3 quy\u{1EC1}n truy c\u{1EAD}p th\xf4ng qua s\u{1EF1} \u{111}\u{1ED3}ng \xfd`,
    'zh-hans': (label)=>`\u{53E6}\u{5916}${label}\u{4E2A}\u{7EC4}\u{7EC7}\u{901A}\u{8FC7}\u{540C}\u{610F}\u{83B7}\u{5F97}\u{4E86}\u{8BBF}\u{95EE}\u{6743}\u{9650}`,
    'zh-hant': (label)=>`\u{53E6}\u{5916}${label}\u{500B}\u{7D44}\u{7E54}\u{53EF}\u{900F}\u{904E}\u{540C}\u{610F}\u{53D6}\u{5F97}\u{5B58}\u{53D6}\u{6B0A}`,
    en: (label)=>`${label} more organizations have access via consent`
};
const $b11db1b62d4a8f76$export$a38a7850cefdb2b2 = {
    ar: `\u{645}\u{647}\u{645}\u{629} \u{627}\u{644}\u{62A}\u{646}\u{638}\u{64A}\u{645}`,
    de: `Organisationsaufgabe`,
    es: `Tareas organizativas`,
    fa: `\u{648}\u{638}\u{6CC}\u{641}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{62F}\u{647}\u{6CC}`,
    fil: `Gawain ng organisasyon`,
    fr: `T\xe2che d\u{2019}organisation`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{93E}\u{930}\u{94D}\u{92F}`,
    ht: `Travay \xf2ganizasyon an`,
    it: `Compito organizzativo`,
    ja: `\u{7D44}\u{7E54}\u{8AB2}\u{984C}`,
    ko: `\u{C870}\u{C9C1} \u{ACFC}\u{C81C}`,
    mww: `Lub koom haum ua haujlwm`,
    ps: `\u{62F} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{62F}\u{646}\u{62F}\u{647}`,
    pt: `Tarefa de organiza\xe7\xe3o`,
    'pt-pt': `Tarefa de organiza\xe7\xe3o`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{430}\u{44F} \u{437}\u{430}\u{434}\u{430}\u{447}\u{430}`,
    sm: `Galuega a le faalapotopotoga`,
    so: `Hawsha abaabulka`,
    th: `\u{E07}\u{E32}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{6CC} \u{6A9}\u{627}\u{645}`,
    vi: `Nhi\u{1EC7}m v\u{1EE5} t\u{1ED5} ch\u{1EE9}c`,
    'zh-hans': `\u{7EC4}\u{7EC7}\u{4EFB}\u{52A1}`,
    'zh-hant': `\u{7D44}\u{7E54}\u{4EFB}\u{52D9}`,
    en: `Organization task`
};
const $b11db1b62d4a8f76$export$f20156ec63e0a45d = {
    ar: `\u{645}\u{647}\u{645}\u{629} \u{62A}\u{633}\u{62A}\u{647}\u{62F}\u{641} \u{645}\u{646}\u{638}\u{645}\u{629} \u{623}\u{648} \u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}\u{627}\u{60C} \u{63A}\u{64A}\u{631} \u{645}\u{631}\u{62A}\u{628}\u{637}\u{629} \u{628}\u{639}\u{645}\u{64A}\u{644} \u{645}\u{639}\u{64A}\u{646}.`,
    de: `Eine Aufgabe, die sich an eine Organisation oder einen Nutzer richtet und nichts mit einem bestimmten Kunden zu tun hat.`,
    es: `Una tarea dirigida a una organizaci\xf3n o usuario, sin relaci\xf3n con un cliente espec\xedfico.`,
    fa: `\u{648}\u{638}\u{6CC}\u{641}\u{647} \u{627}\u{6CC} \u{6A9}\u{647} \u{6CC}\u{6A9} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{6CC}\u{627} \u{6A9}\u{627}\u{631}\u{628}\u{631} \u{631}\u{627} \u{647}\u{62F}\u{641} \u{642}\u{631}\u{627}\u{631} \u{645}\u{6CC} \u{62F}\u{647}\u{62F} \u{648} \u{627}\u{631}\u{62A}\u{628}\u{627}\u{637}\u{6CC} \u{628}\u{627} \u{6CC}\u{6A9} \u{645}\u{634}\u{62A}\u{631}\u{6CC} \u{62E}\u{627}\u{635} \u{646}\u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `Isang gawain na nagta-target sa isang organisasyon o gumagamit, na walang kaugnayan sa isang tukoy na kliyente.`,
    fr: `Une t\xe2che ciblant une organisation ou un utilisateur, sans lien avec un client sp\xe9cifique.`,
    hi: `\u{915}\u{93F}\u{938}\u{940} \u{938}\u{902}\u{917}\u{920}\u{928} \u{92F}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E} \u{915}\u{94B} \u{932}\u{915}\u{94D}\u{937}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{93E} \u{915}\u{93E}\u{930}\u{94D}\u{92F}, \u{91C}\u{94B} \u{915}\u{93F}\u{938}\u{940} \u{935}\u{93F}\u{936}\u{93F}\u{937}\u{94D}\u{91F} \u{915}\u{94D}\u{932}\u{93E}\u{907}\u{902}\u{91F} \u{938}\u{947} \u{905}\u{938}\u{902}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{939}\u{948}.`,
    ht: `Yon travay ki vize yon \xf2ganizasyon oswa itilizat\xe8, ki pa gen rap\xf2 ak yon kliyan espesifik.`,
    it: `Un compito rivolto a un'organizzazione o a un utente, non correlato a un client specifico.`,
    ja: `\u{7279}\u{5B9A}\u{306E}\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}\u{3068}\u{306F}\u{7121}\u{95A2}\u{4FC2}\u{306A}\u{7D44}\u{7E54}\u{3084}\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{3092}\u{5BFE}\u{8C61}\u{3068}\u{3057}\u{305F}\u{30BF}\u{30B9}\u{30AF}\u{3002}`,
    ko: `\u{D2B9}\u{C815} \u{D074}\u{B77C}\u{C774}\u{C5B8}\u{D2B8}\u{C640} \u{AD00}\u{B828} \u{C5C6}\u{B294} \u{C870}\u{C9C1}\u{C774}\u{B098} \u{C0AC}\u{C6A9}\u{C790}\u{B97C} \u{B300}\u{C0C1}\u{C73C}\u{B85C} \u{D55C} \u{C791}\u{C5C5}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib txoj haujlwm tsom rau ib lub koom haum lossis tus neeg siv, tsis muaj feem xyuam rau tus neeg siv khoom tshwj xeeb.`,
    ps: `\u{6CC}\u{648}\u{647} \u{62F}\u{646}\u{62F}\u{647} \u{686}\u{6D0} \u{6CC}\u{648}\u{647} \u{627}\u{62F}\u{627}\u{631}\u{647} \u{6CC}\u{627} \u{6A9}\u{627}\u{631}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{647}\u{62F}\u{641} \u{6AB}\u{631}\u{681}\u{648}\u{6CC}\u{60C} \u{627}\u{648} \u{644}\u{647} \u{681}\u{627}\u{646}\u{6AB}\u{693}\u{6CC} \u{67E}\u{6CC}\u{631}\u{648}\u{62F}\u{648}\u{646}\u{6A9}\u{6CC} \u{633}\u{631}\u{647} \u{62A}\u{693}\u{627}\u{648} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: `Uma tarefa direcionada a uma organiza\xe7\xe3o ou usu\xe1rio, sem rela\xe7\xe3o com um cliente espec\xedfico.`,
    'pt-pt': `Uma tarefa direcionada a uma organiza\xe7\xe3o ou utilizador, sem rela\xe7\xe3o com um cliente espec\xedfico.`,
    ru: `\u{417}\u{430}\u{434}\u{430}\u{447}\u{430}, \u{43D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{43D}\u{430}\u{44F} \u{43D}\u{430} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44E} \u{438}\u{43B}\u{438} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F}, \u{43D}\u{435} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{441} \u{43A}\u{43E}\u{43D}\u{43A}\u{440}\u{435}\u{442}\u{43D}\u{44B}\u{43C} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{43C}.`,
    sm: `O se galuega e fa'atatau i se fa'alapotopotoga po'o se tagata fa'aaoga, e le feso'ota'i ma se tagata fa'atau fa'apitoa.`,
    so: `Hawl bartilmaameedsatay urur ama isticmaale, oo aan la xiriirin macmiil gaar ah.`,
    th: `\u{E07}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E40}\u{E1B}\u{E49}\u{E32}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49} \u{E0B}\u{E36}\u{E48}\u{E07}\u{E44}\u{E21}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E44}\u{E04}\u{E25}\u{E40}\u{E2D}\u{E47}\u{E19}\u{E15}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E40}\u{E09}\u{E1E}\u{E32}\u{E30}\u{E40}\u{E08}\u{E32}\u{E30}\u{E08}\u{E07}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{627}\u{6CC}\u{633}\u{627} \u{6A9}\u{627}\u{645} \u{62C}\u{648} \u{6A9}\u{633}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6CC}\u{627} \u{635}\u{627}\u{631}\u{641} \u{6A9}\u{648} \u{6C1}\u{62F}\u{641} \u{628}\u{646}\u{627}\u{62A}\u{627} \u{6C1}\u{6D2}\u{60C} \u{62C}\u{648} \u{6A9}\u{633}\u{6CC} \u{645}\u{62E}\u{635}\u{648}\u{635} \u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679} \u{633}\u{6D2} \u{645}\u{62A}\u{639}\u{644}\u{642} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED9}t nhi\u{1EC7}m v\u{1EE5} nh\u{1EAF}m m\u{1EE5}c ti\xeau \u{111}\u{1EBF}n m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c ho\u{1EB7}c ng\u{1B0}\u{1EDD}i d\xf9ng, kh\xf4ng li\xean quan \u{111}\u{1EBF}n m\u{1ED9}t kh\xe1ch h\xe0ng c\u{1EE5} th\u{1EC3}.`,
    'zh-hans': `\u{9488}\u{5BF9}\u{67D0}\u{4E2A}\u{7EC4}\u{7EC7}\u{6216}\u{7528}\u{6237}\u{7684}\u{4EFB}\u{52A1}\u{FF0C}\u{4E0E}\u{7279}\u{5B9A}\u{5BA2}\u{6237}\u{65E0}\u{5173}\u{3002}`,
    'zh-hant': `\u{91DD}\u{5C0D}\u{7D44}\u{7E54}\u{6216}\u{4F7F}\u{7528}\u{8005}\u{7684}\u{4EFB}\u{52D9}\u{FF0C}\u{8207}\u{7279}\u{5B9A}\u{5BA2}\u{6236}\u{7121}\u{95DC}\u{3002}`,
    en: `A task targeting an organization or user, unrelated to a specific client.`
};
const $b11db1b62d4a8f76$export$894700ab5cf52639 = {
    ar: `\u{645}\u{646}\u{638}\u{645}\u{629} \u{623}\u{62E}\u{631}\u{649} \u{644}\u{62F}\u{64A}\u{647}\u{627} \u{648}\u{635}\u{648}\u{644} \u{639}\u{646} \u{637}\u{631}\u{64A}\u{642} \u{627}\u{644}\u{645}\u{648}\u{627}\u{641}\u{642}\u{629}`,
    de: `Eine weitere Organisation hat Zugang per Einwilligung`,
    es: `1 Otra organizaci\xf3n tiene acceso mediante consentimiento`,
    fa: `\u{6CC}\u{6A9} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62F}\u{6CC}\u{6AF}\u{631} \u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{631}\u{636}\u{627}\u{6CC}\u{62A} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{62F}\u{627}\u{631}\u{62F}`,
    fil: `1 higit pang organisasyon ang may access sa pamamagitan ng pahintulot`,
    fr: `1 Organisation suppl\xe9mentaire a acc\xe8s par consentement`,
    hi: `1 \u{914}\u{930} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{92A}\u{93E}\u{938} \u{938}\u{939}\u{92E}\u{924}\u{93F} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{92A}\u{939}\u{941}\u{902}\u{91A} \u{939}\u{948}`,
    ht: `1 plis \xf2ganizasyon gen aks\xe8 atrav\xe8 konsantman`,
    it: `1 un'altra organizzazione ha accesso tramite consenso`,
    ja: `1\u{3064}\u{306E}\u{7D44}\u{7E54}\u{304C}\u{540C}\u{610F}\u{306B}\u{3088}\u{308A}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{6A29}\u{3092}\u{6301}\u{3064}`,
    ko: `1\u{AC1C} \u{C774}\u{C0C1}\u{C758} \u{B2E8}\u{CCB4}\u{AC00} \u{B3D9}\u{C758}\u{B97C} \u{D1B5}\u{D574} \u{C811}\u{ADFC} \u{AD8C}\u{D55C}\u{C744} \u{AC00}\u{C9C8} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `1 lub koom haum ntxiv muaj kev nkag mus los ntawm kev tso cai`,
    ps: `\u{6F1} \u{646}\u{648}\u{631} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62F} \u{631}\u{636}\u{627}\u{6CC}\u{62A} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{644}\u{631}\u{6CC}`,
    pt: `1 Mais uma organiza\xe7\xe3o tem acesso por consentimento`,
    'pt-pt': `1 Mais uma organiza\xe7\xe3o tem acesso por consentimento`,
    ru: `\u{415}\u{449}\u{451} \u{43E}\u{434}\u{43D}\u{430} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{438}\u{43C}\u{435}\u{435}\u{442} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{43F}\u{43E} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{441}\u{438}\u{44E}`,
    sm: `1 isi fa'alapotopotoga e mafai ona fa'aaogaina e ala i le maliega`,
    so: `1 urur oo kale ayaa heli kara ogolaansho`,
    th: `\u{E2D}\u{E35}\u{E01} 1 \u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E44}\u{E14}\u{E49}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E04}\u{E27}\u{E32}\u{E21}\u{E22}\u{E34}\u{E19}\u{E22}\u{E2D}\u{E21}`,
    ur: `1 \u{645}\u{632}\u{6CC}\u{62F} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{648} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6C1}\u{6D2}`,
    vi: `Th\xeam 1 t\u{1ED5} ch\u{1EE9}c c\xf3 quy\u{1EC1}n truy c\u{1EAD}p th\xf4ng qua s\u{1EF1} \u{111}\u{1ED3}ng \xfd`,
    'zh-hans': `1 \u{53E6}\u{4E00}\u{4E2A}\u{7EC4}\u{7EC7}\u{901A}\u{8FC7}\u{540C}\u{610F}\u{83B7}\u{5F97}\u{8BBF}\u{95EE}\u{6743}\u{9650}`,
    'zh-hant': `1 \u{500B}\u{7D44}\u{7E54}\u{53EF}\u{900F}\u{904E}\u{540C}\u{610F}\u{53D6}\u{5F97}\u{5B58}\u{53D6}\u{6B0A}`,
    en: `1 more organization has access via consent`
};
const $b11db1b62d4a8f76$export$acaa6c92d3a7e6ea = {
    ar: `\u{641}\u{631}\u{64A}\u{642}\u{646}\u{627}`,
    de: `Unser Team`,
    es: `Nuestro equipo`,
    fa: `\u{62A}\u{6CC}\u{645} \u{645}\u{627}`,
    fil: `Ang aming koponan`,
    fr: `Notre \xe9quipe`,
    hi: `\u{939}\u{92E}\u{93E}\u{930}\u{940} \u{91F}\u{940}\u{92E}`,
    ht: `Ekip nou an`,
    it: `La nostra squadra`,
    ja: `\u{79C1}\u{305F}\u{3061}\u{306E}\u{30C1}\u{30FC}\u{30E0}`,
    ko: `\u{C6B0}\u{B9AC} \u{D300}`,
    mww: `Peb pab neeg`,
    ps: `\u{632}\u{645}\u{648}\u{696} \u{67C}\u{6CC}\u{645}`,
    pt: `Nossa equipe`,
    'pt-pt': `A nossa equipa`,
    ru: `\u{41D}\u{430}\u{448}\u{430} \u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{430}`,
    sm: `O la matou 'au`,
    so: `Kooxdeena`,
    th: `\u{E17}\u{E35}\u{E21}\u{E07}\u{E32}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E23}\u{E32}`,
    ur: `\u{6C1}\u{645}\u{627}\u{631}\u{6CC} \u{679}\u{6CC}\u{645}`,
    vi: `\u{110}\u{1ED9}i ng\u{169} c\u{1EE7}a ch\xfang t\xf4i`,
    'zh-hans': `\u{6211}\u{4EEC}\u{7684}\u{56E2}\u{961F}`,
    'zh-hant': `\u{6211}\u{5011}\u{7684}\u{5718}\u{968A}`,
    en: `Our team`
};
const $b11db1b62d4a8f76$export$a1d4557cbee536a7 = {
    ar: `\u{62E}\u{627}\u{631}\u{62C} \u{627}\u{644}\u{645}\u{646}\u{635}\u{628}`,
    de: `Nicht im Amt`,
    es: `Fuera del cargo`,
    fa: `\u{62E}\u{627}\u{631}\u{62C} \u{627}\u{632} \u{633}\u{645}\u{62A}`,
    fil: `Sa labas ng opisina`,
    fr: `Hors du pouvoir`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{93E}\u{932}\u{92F} \u{938}\u{947} \u{92C}\u{93E}\u{939}\u{930}`,
    ht: `Soti nan biwo`,
    it: `Fuori dall'incarico`,
    ja: `\u{516C}\u{8077}\u{5916}`,
    ko: `\u{ACF5}\u{C9C1} \u{D6C4}`,
    mww: `Tawm ntawm chaw ua haujlwm`,
    ps: `\u{644}\u{647} \u{62F}\u{641}\u{62A}\u{631}\u{647} \u{628}\u{647}\u{631}`,
    pt: `Fora do cargo`,
    'pt-pt': `Fora do cargo`,
    ru: `\u{412}\u{43D}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Fafo atu o le ofisa`,
    so: `Xafiiska ka maqan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E4D}\u{E32}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{639}\u{6C1}\u{62F}\u{6D2} \u{633}\u{6D2} \u{628}\u{627}\u{6C1}\u{631}`,
    vi: `V\u{1EAF}ng m\u{1EB7}t t\u{1EA1}i v\u{103}n ph\xf2ng`,
    'zh-hans': `\u{79BB}\u{5F00}\u{4EFB}\u{671F}`,
    'zh-hant': `\u{96E2}\u{4EFB}`,
    en: `Out of office`
};
const $b11db1b62d4a8f76$export$65b8313cea6950af = {
    ar: `\u{647}\u{644} \u{623}\u{639}\u{631}\u{636} \u{645}\u{624}\u{634}\u{631} \u{62E}\u{631}\u{648}\u{62C} \u{645}\u{646} \u{627}\u{644}\u{645}\u{643}\u{62A}\u{628} \u{648}\u{631}\u{633}\u{627}\u{644}\u{629} \u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631}\u{64A}\u{629} \u{644}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{64A}\u{646}\u{61F}`,
    de: `Eine Abwesenheitsanzeige und eine optionale Nachricht an die Mitarbeitenden anzeigen?`,
    es: `\xbfMostrar un indicador de ausencia y un mensaje opcional a los colaboradores?`,
    fa: `\u{646}\u{645}\u{627}\u{6CC}\u{634} \u{6CC}\u{6A9} \u{639}\u{644}\u{627}\u{645}\u{62A} \u{62E}\u{631}\u{648}\u{62C} \u{627}\u{632} \u{62F}\u{641}\u{62A}\u{631} \u{648} \u{67E}\u{6CC}\u{627}\u{645} \u{627}\u{62E}\u{62A}\u{6CC}\u{627}\u{631}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{627}\u{646}\u{61F}`,
    fil: `Magpakita ng out of office indicator at opsyonal na mensahe sa mga collaborator?`,
    fr: `Afficher un indicateur d\u{2019}absence du bureau et un message optionnel aux collaborateurs ?`,
    hi: `\u{938}\u{939}\u{92F}\u{94B}\u{917}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{93E}\u{932}\u{92F} \u{938}\u{947} \u{92C}\u{93E}\u{939}\u{930} \u{938}\u{902}\u{915}\u{947}\u{924}\u{915} \u{914}\u{930} \u{935}\u{948}\u{915}\u{932}\u{94D}\u{92A}\u{93F}\u{915} \u{938}\u{902}\u{926}\u{947}\u{936} \u{92A}\u{94D}\u{930}\u{926}\u{930}\u{94D}\u{936}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}?`,
    ht: `Montre yon endikat\xe8 soti nan biwo ak mesaj opsyon\xe8l bay kolaborat\xe8?`,
    it: `Mostrare un indicatore di assenza e un messaggio opzionale ai collaboratori?`,
    ja: `\u{4E0D}\u{5728}\u{6642}\u{306E}\u{30A4}\u{30F3}\u{30B8}\u{30B1}\u{30FC}\u{30BF}\u{30FC}\u{3068}\u{3001}\u{5354}\u{529B}\u{8005}\u{306B}\u{4EFB}\u{610F}\u{306E}\u{30E1}\u{30C3}\u{30BB}\u{30FC}\u{30B8}\u{3092}\u{8868}\u{793A}\u{3059}\u{308B}?`,
    ko: `\u{BD80}\u{C7AC} \u{D45C}\u{C2DC}\u{AE30}\u{C640} \u{C120}\u{D0DD}\u{C801} \u{BA54}\u{C2DC}\u{C9C0}\u{B97C} \u{D611}\u{C5C5}\u{C790}\u{C5D0}\u{AC8C} \u{D45C}\u{C2DC}\u{D560} \u{C218} \u{C788}\u{C744}\u{AE4C}\u{C694}?`,
    mww: `Tso saib qhov qhia tawm ntawm chaw ua haujlwm thiab cov lus xaiv rau cov neeg koom tes?`,
    ps: `\u{62F} \u{62F}\u{641}\u{62A}\u{631} \u{685}\u{62E}\u{647} \u{628}\u{647}\u{631} \u{646}\u{69A}\u{647} \u{627}\u{648} \u{627}\u{62E}\u{62A}\u{6CC}\u{627}\u{631}\u{6CC} \u{67E}\u{6CC}\u{63A}\u{627}\u{645} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{627}\u{646}\u{648} \u{62A}\u{647} \u{648}\u{69A}\u{6CC}\u{645}\u{61F}`,
    pt: `Exibir um indicador de aus\xeancia do escrit\xf3rio e uma mensagem opcional para colaboradores?`,
    'pt-pt': `Mostrar um indicador de aus\xeancia do escrit\xf3rio e uma mensagem opcional aos colaboradores?`,
    ru: `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{44B}\u{432}\u{430}\u{442}\u{44C} \u{438}\u{43D}\u{434}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} \u{43E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{43E}\u{444}\u{438}\u{441}\u{430} \u{438} \u{43D}\u{435}\u{43E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{435} \u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{43B}\u{44F} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{43E}\u{432}?`,
    sm: `Fa'aali se fa'ailoga i fafo atu o le ofisa ma se fe'au fa'apitoa i tagata faigaluega?`,
    so: `Ma muujin kartaa tilmaame ka baxsan xafiiska iyo fariin ikhtiyaari ah oo loogu talagalay wada-shaqeeyayaasha?`,
    th: `\u{E41}\u{E2A}\u{E14}\u{E07}\u{E15}\u{E31}\u{E27}\u{E1A}\u{E48}\u{E07}\u{E0A}\u{E35}\u{E49}\u{E01}\u{E32}\u{E23}\u{E44}\u{E21}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E4D}\u{E32}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E41}\u{E25}\u{E30}\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E40}\u{E2A}\u{E23}\u{E34}\u{E21}\u{E16}\u{E36}\u{E07}\u{E1C}\u{E39}\u{E49}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E31}\u{E19}\u{E43}\u{E0A}\u{E48}\u{E44}\u{E2B}\u{E21}`,
    ur: `\u{62F}\u{641}\u{62A}\u{631} \u{633}\u{6D2} \u{628}\u{627}\u{6C1}\u{631} \u{6A9}\u{627} \u{627}\u{634}\u{627}\u{631}\u{6C1} \u{627}\u{648}\u{631} \u{633}\u{627}\u{62A}\u{6BE}\u{6CC}\u{648}\u{6BA} \u{6A9}\u{648} \u{627}\u{62E}\u{62A}\u{6CC}\u{627}\u{631}\u{6CC} \u{67E}\u{6CC}\u{63A}\u{627}\u{645} \u{62F}\u{6A9}\u{6BE}\u{627}\u{646}\u{627}\u{61F}`,
    vi: `Hi\u{1EC3}n th\u{1ECB} ch\u{1EC9} b\xe1o v\u{1EAF}ng m\u{1EB7}t v\xe0 th\xf4ng b\xe1o t\xf9y ch\u{1ECD}n cho c\u{1ED9}ng t\xe1c vi\xean?`,
    'zh-hans': `\u{7ED9}\u{534F}\u{4F5C}\u{8005}\u{663E}\u{793A}\u{51FA}\u{51FA}\u{52E4}\u{6307}\u{793A}\u{548C}\u{53EF}\u{9009}\u{6D88}\u{606F}\u{FF1F}`,
    'zh-hant': `\u{986F}\u{793A}\u{4E0D}\u{5728}\u{8FA6}\u{516C}\u{5BA4}\u{7684}\u{6307}\u{793A}\u{5668}\u{548C}\u{53EF}\u{9078}\u{8A0A}\u{606F}\u{7D66}\u{5408}\u{4F5C}\u{5925}\u{4F34}\u{FF1F}`,
    en: `Display an out of office indicator and optional message to collaborators?`
};
const $b11db1b62d4a8f76$export$3ef5dbd89b66b685 = {
    ar: `\u{631}\u{633}\u{627}\u{644}\u{629} \u{62E}\u{627}\u{631}\u{62C} \u{627}\u{644}\u{645}\u{643}\u{62A}\u{628}`,
    de: `Abwesenheitsnachricht`,
    es: `Mensaje de ausencia`,
    fa: `\u{67E}\u{6CC}\u{627}\u{645} \u{62E}\u{627}\u{631}\u{62C} \u{627}\u{632} \u{62F}\u{641}\u{62A}\u{631}`,
    fil: `Mensahe sa labas ng opisina`,
    fr: `Message d\u{2019}absence`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{93E}\u{932}\u{92F} \u{938}\u{947} \u{92C}\u{93E}\u{939}\u{930} \u{938}\u{902}\u{926}\u{947}\u{936}`,
    ht: `Soti nan mesaj biwo`,
    it: `Messaggio fuori ufficio`,
    ja: `\u{30AA}\u{30D5}\u{30A3}\u{30B9}\u{5916}\u{304B}\u{3089}\u{306E}\u{30E1}\u{30C3}\u{30BB}\u{30FC}\u{30B8}`,
    ko: `\u{BD80}\u{C7AC} \u{BA54}\u{C2DC}\u{C9C0}`,
    mww: `Tawm ntawm chaw ua hauj lwm lus`,
    ps: `\u{62F} \u{62F}\u{641}\u{62A}\u{631} \u{685}\u{62E}\u{647} \u{628}\u{647}\u{631} \u{67E}\u{6CC}\u{63A}\u{627}\u{645}`,
    pt: `Mensagem fora do escrit\xf3rio`,
    'pt-pt': `Mensagem fora do escrit\xf3rio`,
    ru: `\u{421}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435} \u{43E} \u{432}\u{43D}\u{435} \u{43E}\u{444}\u{438}\u{441}\u{430}`,
    sm: `Savali i fafo atu o le ofisa`,
    so: `Farriinta ka baxsan xafiiska`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E44}\u{E21}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E4D}\u{E32}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{62F}\u{641}\u{62A}\u{631} \u{633}\u{6D2} \u{628}\u{627}\u{6C1}\u{631} \u{67E}\u{6CC}\u{63A}\u{627}\u{645}`,
    vi: `Th\xf4ng b\xe1o v\u{1EAF}ng m\u{1EB7}t`,
    'zh-hans': `\u{79BB}\u{5C97}\u{6D88}\u{606F}`,
    'zh-hant': `\u{96E2}\u{8077}\u{8A0A}\u{606F}`,
    en: `Out of office message`
};
const $b11db1b62d4a8f76$export$94f48f83a3a50121 = {
    ar: `\u{627}\u{644}\u{648}\u{642}\u{62A} \u{627}\u{644}\u{625}\u{636}\u{627}\u{641}\u{64A}`,
    de: `Verl\xe4ngerung`,
    es: `Pr\xf3rroga`,
    fa: `\u{648}\u{642}\u{62A} \u{627}\u{636}\u{627}\u{641}\u{647}`,
    fil: `Paglipas ng oras`,
    fr: `Prolongation`,
    hi: `\u{913}\u{935}\u{930}\u{91F}\u{93E}\u{907}\u{92E}`,
    ht: `Siplemant\xe8`,
    it: `Tempo supplementare`,
    ja: `\u{5EF6}\u{9577}\u{6226}`,
    ko: `\u{C5F0}\u{C7A5}\u{C804}`,
    mww: `Sijhawm dhau sijhawm`,
    ps: `\u{627}\u{636}\u{627}\u{641}\u{6CC} \u{648}\u{62E}\u{62A}`,
    pt: `Prorroga\xe7\xe3o`,
    'pt-pt': `Prorroga\xe7\xe3o`,
    ru: `\u{41E}\u{432}\u{435}\u{440}\u{442}\u{430}\u{439}\u{43C}`,
    sm: `Ovataimi`,
    so: `Waqti dheeri ah`,
    th: `\u{E01}\u{E32}\u{E23}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E25}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}`,
    ur: `\u{627}\u{648}\u{648}\u{631} \u{679}\u{627}\u{626}\u{645}`,
    vi: `L\xe0m th\xeam gi\u{1EDD}`,
    'zh-hans': `\u{52A0}\u{65F6}\u{8D5B}`,
    'zh-hant': `\u{52A0}\u{6642}\u{8CFD}`,
    en: `Overtime`
};
const $b11db1b62d4a8f76$export$fab6bcf1e8d90e76 = {
    ar: `\u{646}\u{638}\u{631}\u{629} \u{639}\u{627}\u{645}\u{629}`,
    de: `\xdcberblick`,
    es: `Resumen`,
    fa: `\u{628}\u{631}\u{631}\u{633}\u{6CC} \u{627}\u{62C}\u{645}\u{627}\u{644}\u{6CC}`,
    fil: `Pangkalahatang-ideya`,
    fr: `Aper\xe7u`,
    hi: `\u{935}\u{93F}\u{939}\u{902}\u{917}\u{93E}\u{935}\u{932}\u{94B}\u{915}\u{928}`,
    ht: `Ap\xe8si sou lek\xf2l la`,
    it: `Panoramica`,
    ja: `\u{6982}\u{8981}`,
    ko: `\u{AC1C}\u{C694}`,
    mww: `Txheej txheem cej luam`,
    ps: `\u{639}\u{645}\u{648}\u{645}\u{6CC} \u{6A9}\u{62A}\u{646}\u{647}`,
    pt: `Vis\xe3o geral`,
    'pt-pt': `Vis\xe3o geral`,
    ru: `\u{41E}\u{431}\u{437}\u{43E}\u{440}`,
    sm: `Aotelega`,
    so: `Guudmar`,
    th: `\u{E20}\u{E32}\u{E1E}\u{E23}\u{E27}\u{E21}`,
    ur: `\u{62C}\u{627}\u{626}\u{632}\u{6C1}`,
    vi: `T\u{1ED5}ng quan`,
    'zh-hans': `\u{6982}\u{8FF0}`,
    'zh-hant': `\u{6982}\u{8FF0}`,
    en: `Overview`
};
const $b11db1b62d4a8f76$export$80b56597ed9748d5 = {
    ar: `\u{635}\u{641}\u{62D}\u{629}`,
    de: `Page`,
    es: `P\xe1gina`,
    fa: `\u{635}\u{641}\u{62D}\u{647}`,
    fil: `Pahina`,
    fr: `Page`,
    hi: `\u{92A}\u{943}\u{937}\u{94D}\u{920}`,
    ht: `Paj`,
    it: `Pagina`,
    ja: `\u{30DA}\u{30FC}\u{30B8}`,
    ko: `\u{D398}\u{C774}\u{C9C0}`,
    mww: `Nplooj ntawv`,
    ps: `\u{67E}\u{627}\u{6BC}\u{647}`,
    pt: `Page`,
    'pt-pt': `P\xe1gina`,
    ru: `\u{421}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430}`,
    sm: `Itulau`,
    so: `Bog`,
    th: `\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: `\u{635}\u{641}\u{62D}\u{6C1}`,
    vi: `Trang`,
    'zh-hans': `\u{9875}\u{9762}`,
    'zh-hant': `\u{9801}`,
    en: `Page`
};
const $b11db1b62d4a8f76$export$322db104d06f2add = {
    ar: `\u{62A}\u{642}\u{633}\u{64A}\u{645} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{627}\u{62A}`,
    de: `Paginierung`,
    es: `Paginaci\xf3n`,
    fa: `\u{635}\u{641}\u{62D}\u{647} \u{628}\u{646}\u{62F}\u{6CC}`,
    fil: `Pagination`,
    fr: `Pagination`,
    hi: `\u{92A}\u{947}\u{91C}\u{93F}\u{928}\u{947}\u{936}\u{928}`,
    ht: `Paginasyon`,
    it: `Paginazione`,
    ja: `\u{30DA}\u{30FC}\u{30B8}\u{5206}\u{3051}`,
    ko: `\u{D398}\u{C774}\u{C9C0} \u{BC30}\u{CE58}`,
    mww: `Pagination`,
    ps: `\u{67E}\u{627}\u{6BC}\u{647} \u{628}\u{646}\u{62F}\u{6CC}`,
    pt: `Pagina\xe7\xe3o`,
    'pt-pt': `Pagina\xe7\xe3o`,
    ru: `\u{41F}\u{430}\u{433}\u{438}\u{43D}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Itulau`,
    so: `Qaybinta`,
    th: `\u{E01}\u{E32}\u{E23}\u{E41}\u{E1A}\u{E48}\u{E07}\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: `\u{635}\u{641}\u{62D}\u{6C1} \u{628}\u{646}\u{62F}\u{6CC}`,
    vi: `Ph\xe2n trang`,
    'zh-hans': `\u{5206}\u{9875}`,
    'zh-hant': `\u{9801}\u{78BC}`,
    en: `Pagination`
};
const $b11db1b62d4a8f76$export$2b75e18102dd39c2 = {
    ar: `\u{646}\u{634}\u{627}\u{637} \u{627}\u{644}\u{648}\u{627}\u{644}\u{62F}\u{64A}\u{646}`,
    de: `Elternt\xe4tigkeit`,
    es: `Actividad principal`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{648}\u{627}\u{644}\u{62F}\u{6CC}\u{646}`,
    fil: `Aktibidad ng magulang`,
    fr: `Activit\xe9 parentale`,
    hi: `\u{92E}\u{93E}\u{924}\u{93E}-\u{92A}\u{93F}\u{924}\u{93E} \u{915}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}`,
    ht: `Aktivite paran yo`,
    it: `Attivit\xe0 genitore`,
    ja: `\u{89AA}\u{306E}\u{6D3B}\u{52D5}`,
    ko: `\u{BD80}\u{BAA8} \u{D65C}\u{B3D9}`,
    mww: `Niam txiv kev ua ub no`,
    ps: `\u{62F} \u{645}\u{648}\u{631} \u{627}\u{648} \u{67E}\u{644}\u{627}\u{631} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    pt: `Atividade dos pais`,
    'pt-pt': `Atividade parental`,
    ru: `\u{420}\u{43E}\u{434}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{441}\u{43A}\u{430}\u{44F} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Gaoioiga a matua`,
    so: `Hawlaha waalidka`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E1C}\u{E39}\u{E49}\u{E1B}\u{E01}\u{E04}\u{E23}\u{E2D}\u{E07}`,
    ur: `\u{648}\u{627}\u{644}\u{62F}\u{6CC}\u{646} \u{6A9}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng c\u{1EE7}a cha m\u{1EB9}`,
    'zh-hans': `\u{5BB6}\u{957F}\u{6D3B}\u{52A8}`,
    'zh-hant': `\u{5BB6}\u{9577}\u{6D3B}\u{52D5}`,
    en: `Parent activity`
};
const $b11db1b62d4a8f76$export$79b37e7cab1a95c3 = {
    ar: $b11db1b62d4a8f76$var$html`كل عميل ترتبط به مدرج أدناه. يرجى مراجعة المعلومات الموجودة في الملف. إذا بدا أي شيء غير صحيح، <a href="/support">تواصل مع الدعم</a>.`,
    de: $b11db1b62d4a8f76$var$html`Jeder Kunde, mit dem Sie verbunden sind, ist unten aufgeführt. Bitte überprüfen Sie die Informationen, die wir haben. Wenn etwas falsch aussieht, <a href="/support">kontaktiere den Support</a>.`,
    es: $b11db1b62d4a8f76$var$html`Cada consumidor con el que estás asociado se muestra a continuación. Por favor, revise la información que tenemos archivada. Si algo no te parece correcto, <a href="/support">contacta con el soporte</a> técnico.`,
    fa: $b11db1b62d4a8f76$var$html`هر مشتری ای که با آن ارتباط دارید در زیر فهرست شده است. لطفا اطلاعات موجود در پرونده را مرور کنید. اگر چیزی اشتباه به نظر می رسد، <a href="/support">با پشتیبانی تماس بگیرید</a>.`,
    fil: $b11db1b62d4a8f76$var$html`Ang bawat mamimili na nauugnay sa iyo ay nakalista sa ibaba. Mangyaring suriin ang impormasyong nasa file namin. Kung ang anumang bagay ay mukhang mali, <a href="/support">makipag-ugnay sa suporta.</a>`,
    fr: $b11db1b62d4a8f76$var$html`Chaque consommateur auquel vous êtes associé est listé ci-dessous. Veuillez consulter les informations que nous avons dans nos dossiers. Si quelque chose semble incorrect, <a href="/support">contactez le support.</a>`,
    hi: $b11db1b62d4a8f76$var$html`आप जिस भी उपभोक्ता से जुड़े हैं, वह नीचे सूचीबद्ध है. कृपया फ़ाइल पर हमारे पास मौजूद जानकारी की समीक्षा करें। यदि कुछ भी गलत लगता है, <a href="/support">तो समर्थन से संपर्क करें</a>।`,
    ht: $b11db1b62d4a8f76$var$html`Chak konsomatè w ap asosye avèk yo ki nan lis anba a. Tanpri revize enfòmasyon nou genyen nan dosye. Si anyen sanble mal, <a href="/support">kontakte sipò.</a>`,
    it: $b11db1b62d4a8f76$var$html`Ogni consumatore con cui sei associato è elencato di seguito. Per favore, esamina le informazioni che abbiamo in archivio. Se qualcosa non ti sembra corretto, <a href="/support">contatta l'assistenza</a>.`,
    ja: $b11db1b62d4a8f76$var$html`あなたが関わっている各消費者は以下の通りです。当サイトの情報を確認してください。何かおかしい点があれば <a href="/support">サポートに連絡</a>してください。`,
    ko: $b11db1b62d4a8f76$var$html`여러분이 연관된 각 소비자는 아래에 나열되어 있습니다. 저희가 보유한 정보를 검토해 주시기 바랍니다. 이상한 점이 있으면 <a href="/support">고객 지원에 연락</a>하세요.`,
    mww: $b11db1b62d4a8f76$var$html`Txhua tus neeg tau txais kev pab uas koj koom nrog muaj npe hauv qab no. Thov saib cov ntaub ntawv peb muaj nyob rau hauv cov ntaub ntawv. Yog tias muaj dab tsi zoo li tsis raug, <a href="/support">hu rau kev txhawb nqa</a>.`,
    ps: $b11db1b62d4a8f76$var$html`هر مصرف کوونکی چې تاسو ورسره تړلی یاست، لاندې لیست شوی دی. مهربانی وکړئ هغه معلومات وګورئ چې موږ په دوسیه کې لرو. که څه ناسم ښکاری، <a href="/support">له ملاتړ سره اړیکه ونیسئ</a>.`,
    pt: $b11db1b62d4a8f76$var$html`Cada consumidor com quem você está associado está listado abaixo. Por favor, revise as informações que temos em arquivo. Se algo parecer errado, <a href="/support">entre em contato com o suporte</a>.`,
    'pt-pt': $b11db1b62d4a8f76$var$html`Cada consumidor com quem está associado está listado abaixo. Por favor, reveja a informação que temos em arquivo. Se algo parecer errado, <a href="/support">contacte o suporte</a>.`,
    ru: $b11db1b62d4a8f76$var$html`Каждый потребитель, с которым вы связаны, перечислен ниже. Пожалуйста, ознакомьтесь с имеющейся у нас информацией. Если что-то кажется неправильным, <a href="/support">обращайтесь в поддержку</a>.`,
    sm: $b11db1b62d4a8f76$var$html`O tagata fa'atau ta'itasi o lo'o e feso'ota'i ma oe o lo'o lisiina atu i lalo. Fa'amolemole siaki fa'amatalaga o lo'o ia i matou i le faila. Afai e i ai se mea e foliga mai e le sa'o, <a href="/support">fa'afeso'ota'i le lagolago</a>.`,
    so: $b11db1b62d4a8f76$var$html`Macaamiil kasta oo aad la xiriirto waa lagu taxay hoos. Fadlan dib u eeg macluumaadka aan hayno kaydka. Haddii wax qaldan muuqdaan, <a href="/support">la xiriir taageerada</a>.`,
    th: $b11db1b62d4a8f76$var$html`ผู้บริโภคแต่ละรายที่คุณเชื่อมโยงด้วยแสดงอยู่ด้านล่าง โปรดตรวจสอบข้อมูลที่เรามีในไฟล์ หากมีสิ่งใดไม่ถูกต้อง <a href="/support">โปรดติดต่อฝ่ายสนับสนุน</a>`,
    ur: $b11db1b62d4a8f76$var$html`ہر صارف جس سے آپ وابستہ ہیں، نیچے درج ہے۔ براہ کرم ہمارے پاس موجود معلومات کا جائزہ لیں۔ اگر کچھ غلط لگے تو <a href="/support">سپورٹ سے رابطہ</a> کریں۔`,
    vi: $b11db1b62d4a8f76$var$html`Mỗi người tiêu dùng mà bạn liên kết được liệt kê dưới đây. Vui lòng xem lại thông tin chúng tôi có trong hồ sơ. Nếu có bất kỳ điều gì không chính xác, <a href="/support">hãy liên hệ với bộ phận hỗ trợ</a>.`,
    'zh-hans': $b11db1b62d4a8f76$var$html`你所关联的每一位消费者名单如下。请查看我们所存档案中的信息。如果有任何异常， <a href="/support">请联系客服</a>。`,
    'zh-hant': $b11db1b62d4a8f76$var$html`你所關聯的每位消費者名單如下。請審閱我們所存的資訊。如果有任何異常，請 <a href="/support">聯絡客服</a>。`,
    en: $b11db1b62d4a8f76$var$html`Each consumer you're associated with is listed below. Please review the information we have on file. If anything looks incorrect, <a href="/support">contact support</a>.`
};
const $b11db1b62d4a8f76$export$352b9d9027baf16d = {
    ar: `\u{631}\u{627}\u{628}\u{637} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{64A}\u{646}`,
    de: `Teilnehmer-Link`,
    es: `Enlace de participantes`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9} \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: `Link ng kalahok`,
    fr: `Lien participant`,
    hi: `\u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{940} \u{932}\u{93F}\u{902}\u{915}`,
    ht: `Lyen patisipan yo`,
    it: `Collegamento dei partecipanti`,
    ja: `\u{53C2}\u{52A0}\u{8005}\u{30EA}\u{30F3}\u{30AF}`,
    ko: `\u{CC38}\u{AC00}\u{C790} \u{B9C1}\u{D06C}`,
    mww: `Txuas rau cov neeg koom`,
    ps: `\u{62F} \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644} \u{644}\u{6CC}\u{646}\u{6A9}`,
    pt: `Link de participante`,
    'pt-pt': `Link de participantes`,
    ru: `\u{421}\u{441}\u{44B}\u{43B}\u{43A}\u{430} \u{43D}\u{430} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{430}`,
    sm: `Feso'ota'iga a le tagata auai`,
    so: `Xiriirka ka qaybgalka`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}`,
    ur: `\u{634}\u{631}\u{6A9}\u{627}\u{621} \u{6A9}\u{627} \u{644}\u{646}\u{6A9}`,
    vi: `Li\xean k\u{1EBF}t ng\u{1B0}\u{1EDD}i tham gia`,
    'zh-hans': `\u{53C2}\u{4E0E}\u{8005}\u{94FE}\u{63A5}`,
    'zh-hant': `\u{53C3}\u{8207}\u{8005}\u{9023}\u{7D50}`,
    en: `Participant link`
};
const $b11db1b62d4a8f76$export$83b0c45cbec1c6ea = {
    ar: `\u{628}\u{648}\u{627}\u{628}\u{629} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{64A}\u{646}`,
    de: `Teilnehmerportal`,
    es: `Portal de Participantes`,
    fa: `\u{67E}\u{648}\u{631}\u{62A}\u{627}\u{644} \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{6AF}\u{627}\u{646}`,
    fil: `Portal ng Kalahok`,
    fr: `Portail des participants`,
    hi: `\u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{940} \u{92A}\u{94B}\u{930}\u{94D}\u{91F}\u{932}`,
    ht: `Patisipan Portal`,
    it: `Portale Partecipanti`,
    ja: `\u{53C2}\u{52A0}\u{8005}\u{30DD}\u{30FC}\u{30BF}\u{30EB}`,
    ko: `\u{CC38}\u{C5EC}\u{C790} \u{D3EC}\u{D138}`,
    mww: `Cov Neeg Koom Portal`,
    ps: `\u{62F} \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644} \u{67E}\u{648}\u{631}\u{67C}\u{644}`,
    pt: `Portal de Participantes`,
    'pt-pt': `Portal de Participantes`,
    ru: `\u{41F}\u{43E}\u{440}\u{442}\u{430}\u{43B} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{43E}\u{432}`,
    sm: `Faitotoa a le Tagata Auai`,
    so: `Albaabka Ka Qaybgalayaasha`,
    th: `\u{E1E}\u{E2D}\u{E23}\u{E4C}\u{E17}\u{E31}\u{E25}\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}`,
    ur: `\u{634}\u{631}\u{6A9}\u{627}\u{621} \u{6A9}\u{627} \u{67E}\u{648}\u{631}\u{679}\u{644}`,
    vi: `C\u{1ED5}ng th\xf4ng tin ng\u{1B0}\u{1EDD}i tham gia`,
    'zh-hans': `\u{53C2}\u{4E0E}\u{8005}\u{95E8}\u{6237}`,
    'zh-hant': `\u{53C3}\u{8207}\u{8005}\u{5165}\u{53E3}\u{7DB2}\u{7AD9}`,
    en: `Participant Portal`
};
const $b11db1b62d4a8f76$export$b9fd781b55f35c4e = {
    ar: `\u{642}\u{62F}\u{645} \u{62C}\u{62F}\u{627}\u{648}\u{644} \u{627}\u{644}\u{632}\u{645}\u{646}\u{60C} \u{648}\u{62A}\u{62A}\u{628}\u{639} \u{627}\u{644}\u{625}\u{646}\u{641}\u{627}\u{642}\u{60C} \u{648}\u{646}\u{638}\u{645} \u{631}\u{639}\u{627}\u{64A}\u{62A}\u{643} \u{641}\u{64A} \u{645}\u{643}\u{627}\u{646} \u{648}\u{627}\u{62D}\u{62F}.`,
    de: `Reichen Sie Stundenzettel ein, verfolgen Sie die Ausgaben und verwalten Sie Ihre Betreuung an einem Ort.`,
    es: `Env\xeda hojas de horas, registra los gastos y gestiona tu atenci\xf3n en un solo lugar.`,
    fa: `\u{628}\u{631}\u{6AF}\u{647} \u{647}\u{627}\u{6CC} \u{632}\u{645}\u{627}\u{646} \u{628}\u{646}\u{62F}\u{6CC} \u{631}\u{627} \u{627}\u{631}\u{633}\u{627}\u{644} \u{6A9}\u{646}\u{6CC}\u{62F}\u{60C} \u{647}\u{632}\u{6CC}\u{646}\u{647} \u{647}\u{627} \u{631}\u{627} \u{67E}\u{6CC}\u{6AF}\u{6CC}\u{631}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{645}\u{631}\u{627}\u{642}\u{628}\u{62A} \u{62E}\u{648}\u{62F} \u{631}\u{627} \u{62F}\u{631} \u{6CC}\u{6A9} \u{645}\u{6A9}\u{627}\u{646} \u{645}\u{62F}\u{6CC}\u{631}\u{6CC}\u{62A} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Magsumite ng mga timesheet, subaybayan ang paggastos, at pamahalaan ang iyong pangangalaga sa isang lugar.`,
    fr: `Soumettez des feuilles de temps, suivez vos d\xe9penses et g\xe9rez vos soins en un seul endroit.`,
    hi: `\u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{91C}\u{92E}\u{93E} \u{915}\u{930}\u{947}\u{902}, \u{916}\u{930}\u{94D}\u{91A} \u{92A}\u{930} \u{928}\u{91C}\u{93C}\u{930} \u{930}\u{916}\u{947}\u{902} \u{914}\u{930} \u{90F}\u{915} \u{939}\u{940} \u{938}\u{94D}\u{925}\u{93E}\u{928} \u{92A}\u{930} \u{905}\u{92A}\u{928}\u{940} \u{926}\u{947}\u{916}\u{92D}\u{93E}\u{932} \u{915}\u{93E} \u{92A}\u{94D}\u{930}\u{92C}\u{902}\u{927}\u{928} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Soum\xe8t fich tan, swiv depanse, ak jere swen ou nan yon s\xe8l kote.`,
    it: `Invia i fogli di servizio, tieni traccia delle spese e gestisci la tua assistenza in un unico posto.`,
    ja: `\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{306E}\u{63D0}\u{51FA}\u{3001}\u{652F}\u{51FA}\u{306E}\u{8FFD}\u{8DE1}\u{3001}\u{30B1}\u{30A2}\u{7BA1}\u{7406}\u{3092}\u{4E00}\u{304B}\u{6240}\u{3067}\u{884C}\u{3048}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C}\u{B97C} \u{C81C}\u{CD9C}\u{D558}\u{ACE0}, \u{C9C0}\u{CD9C}\u{C744} \u{CD94}\u{C801}\u{D558}\u{BA70}, \u{D55C} \u{ACF3}\u{C5D0}\u{C11C} \u{C9C4}\u{B8CC}\u{B97C} \u{AD00}\u{B9AC}\u{D558}\u{C138}\u{C694}.`,
    mww: `Xa cov ntawv teev sijhawm, taug qab kev siv nyiaj, thiab tswj koj txoj kev saib xyuas hauv ib qho chaw.`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{6D0} \u{648}\u{633}\u{67E}\u{627}\u{631}\u{626}\u{60C} \u{644}\u{6AB}\u{69A}\u{62A}\u{648}\u{646}\u{647} \u{62A}\u{639}\u{642}\u{6CC}\u{628} \u{6A9}\u{693}\u{626}\u{60C} \u{627}\u{648} \u{62E}\u{67E}\u{644} \u{67E}\u{627}\u{645}\u{644}\u{631}\u{646}\u{647} \u{67E}\u{647} \u{6CC}\u{648}\u{647} \u{681}\u{627}\u{6CC} \u{6A9}\u{6D0} \u{645}\u{62F}\u{6CC}\u{631}\u{6CC}\u{62A} \u{6A9}\u{693}\u{626}.`,
    pt: `Envie folhas de ponto, acompanhe os gastos e gerencie seu cuidado em um s\xf3 lugar.`,
    'pt-pt': `Envie folhas de horas, acompanhe os gastos e gere os seus cuidados num s\xf3 local.`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{44F}\u{439}\u{442}\u{435} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{438} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}, \u{43E}\u{442}\u{441}\u{43B}\u{435}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{440}\u{430}\u{441}\u{445}\u{43E}\u{434}\u{44B} \u{438} \u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{44F}\u{439}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{438}\u{43C} \u{443}\u{445}\u{43E}\u{434}\u{43E}\u{43C} \u{432} \u{43E}\u{434}\u{43D}\u{43E}\u{43C} \u{43C}\u{435}\u{441}\u{442}\u{435}.`,
    sm: `Tu'uina atu pepa o taimi, siaki tupe fa'aalu, ma fa'atautaia lau tausiga i le nofoaga e tasi.`,
    so: `Soo gudbi jadwalka waqtiyada, la soco kharashaadka, oo maaree daryeelkaaga hal meel.`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17} \u{E15}\u{E34}\u{E14}\u{E15}\u{E32}\u{E21}\u{E01}\u{E32}\u{E23}\u{E43}\u{E0A}\u{E49}\u{E08}\u{E48}\u{E32}\u{E22} \u{E41}\u{E25}\u{E30}\u{E08}\u{E31}\u{E14}\u{E01}\u{E32}\u{E23}\u{E01}\u{E32}\u{E23}\u{E14}\u{E39}\u{E41}\u{E25}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E43}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}`,
    ur: `\u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679}\u{633} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{648}\u{627}\u{626}\u{6CC}\u{6BA}\u{60C} \u{627}\u{62E}\u{631}\u{627}\u{62C}\u{627}\u{62A} \u{6A9}\u{648} \u{679}\u{631}\u{6CC}\u{6A9} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{60C} \u{627}\u{648}\u{631} \u{627}\u{67E}\u{646}\u{6CC} \u{62F}\u{6CC}\u{6A9}\u{6BE} \u{628}\u{6BE}\u{627}\u{644} \u{6A9}\u{648} \u{627}\u{6CC}\u{6A9} \u{6C1}\u{6CC} \u{62C}\u{6AF}\u{6C1} \u{67E}\u{631} \u{645}\u{646}\u{638}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `G\u{1EED}i b\u{1EA3}ng ch\u{1EA5}m c\xf4ng, theo d\xf5i chi ti\xeau v\xe0 qu\u{1EA3}n l\xfd d\u{1ECB}ch v\u{1EE5} ch\u{103}m s\xf3c c\u{1EE7}a b\u{1EA1}n \u{1EDF} m\u{1ED9}t n\u{1A1}i.`,
    'zh-hans': `\u{63D0}\u{4EA4}\u{5DE5}\u{65F6}\u{8868}\u{3001}\u{8DDF}\u{8E2A}\u{652F}\u{51FA}\u{FF0C}\u{5E76}\u{7BA1}\u{7406}\u{60A8}\u{7684}\u{62A4}\u{7406}\u{5DE5}\u{4F5C}\u{3002}`,
    'zh-hant': `\u{63D0}\u{4EA4}\u{5DE5}\u{6642}\u{8868}\u{3001}\u{8FFD}\u{8E64}\u{652F}\u{51FA}\u{FF0C}\u{4E26}\u{5728}\u{540C}\u{4E00}\u{5730}\u{9EDE}\u{7BA1}\u{7406}\u{60A8}\u{7684}\u{7167}\u{8B77}\u{3002}`,
    en: `Submit timesheets, track spending, and manage your care in one place.`
};
const $b11db1b62d4a8f76$export$9e677559c8b1a46f = {
    ar: (name, expires)=>$b11db1b62d4a8f76$var$html`يعرض البوابة باسم <strong>${name}</strong>. ينتهي صلاحيته ${expires}.`,
    de: (name, expires)=>$b11db1b62d4a8f76$var$html`Das <strong>${name}</strong> betrachtet. Läuft ${expires} ab.`,
    es: (name, expires)=>$b11db1b62d4a8f76$var$html`Observando el portal como <strong>${name}</strong>. ${expires}.`,
    fa: (name, expires)=>$b11db1b62d4a8f76$var$html`در حال مشاهده پورتال به عنوان <strong>${name}</strong>. ${expires} منقضی می شود.`,
    fil: (name, expires)=>$b11db1b62d4a8f76$var$html`Tinitingnan ang portal bilang <strong>${name}</strong>. ${expires} nang mag-expire.`,
    fr: (name, expires)=>$b11db1b62d4a8f76$var$html`Regardant le portail en <strong>${name}</strong>. ${expires}.`,
    hi: (name, expires)=>$b11db1b62d4a8f76$var$html`पोर्टल को <strong>${name}</strong> के रूप में देखना। जल्द ${expires} समाप्त हो रहा है।`,
    ht: (name, expires)=>$b11db1b62d4a8f76$var$html`Gade pòtal la kòm <strong>${name}</strong> Ekspire ${expires}`,
    it: (name, expires)=>$b11db1b62d4a8f76$var$html`Guardando il portale come <strong>${name}</strong>. Sta ${expires} scadere.`,
    ja: (name, expires)=>$b11db1b62d4a8f76$var$html`<strong>${name}</strong>としてポータルを見ている。${expires}期限切れだ。`,
    ko: (name, expires)=>$b11db1b62d4a8f76$var$html`<strong>${name}</strong>로 포털을 보고 있어. ${expires} 만료돼.`,
    mww: (name, expires)=>$b11db1b62d4a8f76$var$html`Saib lub portal ua <strong>${name}</strong>. Yuav xaus ${expires} no.`,
    ps: (name, expires)=>$b11db1b62d4a8f76$var$html`دروازه د <strong>${name}</strong> په توګه ګوری. ${expires} ختمیږی.`,
    pt: (name, expires)=>$b11db1b62d4a8f76$var$html`Vendo o portal como <strong>${name}</strong>. ${expires}.`,
    'pt-pt': (name, expires)=>$b11db1b62d4a8f76$var$html`A ver o portal como <strong>${name}</strong>. ${expires}.`,
    ru: (name, expires)=>$b11db1b62d4a8f76$var$html`Смотря на портал как <strong>${name}</strong>. ${expires} истекает.`,
    sm: (name, expires)=>$b11db1b62d4a8f76$var$html`Va'ai i le faitoto'a o <strong>${name}</strong>. E ${expires}.`,
    so: (name, expires)=>$b11db1b62d4a8f76$var$html`Wuxuu daawanayaa albaabka sida <strong>${name}</strong>. Wuxuu ${expires}.`,
    th: (name, expires)=>$b11db1b62d4a8f76$var$html`มองประตูมิติในชื่อ<strong>${name}</strong>จะหมดอายุ${expires}`,
    ur: (name, expires)=>$b11db1b62d4a8f76$var$html`<strong>${name}</strong> کے طور پر دیکھنا۔ ${expires} ختم ہو جائے گا۔`,
    vi: (name, expires)=>$b11db1b62d4a8f76$var$html`Xem cổng dịch chuyển như <strong>${name}</strong>. Sắp hết hạn ${expires}.`,
    'zh-hans': (name, expires)=>$b11db1b62d4a8f76$var$html`以 <strong>${name}</strong>的身份查看传送门。 ${expires}过期。`,
    'zh-hant': (name, expires)=>$b11db1b62d4a8f76$var$html`以 <strong>${name}</strong>的身份觀看傳送門。 ${expires}過期。`,
    en: (name, expires)=>$b11db1b62d4a8f76$var$html`Viewing the portal as <strong>${name}</strong>. Expires ${expires}.`
};
const $b11db1b62d4a8f76$export$fb57c5c0e64664ee = {
    ar: `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{625}\u{62C}\u{631}\u{627}\u{621} \u{62A}\u{639}\u{62F}\u{64A}\u{644}\u{627}\u{62A} \u{623}\u{62B}\u{646}\u{627}\u{621} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{629} \u{628}\u{648}\u{627}\u{628}\u{629} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{64A}\u{646} \u{643}\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645} \u{622}\u{62E}\u{631}.`,
    de: `\xc4nderungen k\xf6nnen nicht vorgenommen werden, w\xe4hrend man das Teilnehmerportal als anderer Nutzer betrachtet.`,
    es: `No se pueden hacer modificaciones mientras se visualiza el portal de participantes como otro usuario.`,
    fa: `\u{647}\u{646}\u{6AF}\u{627}\u{645} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{67E}\u{648}\u{631}\u{62A}\u{627}\u{644} \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647} \u{628}\u{647} \u{639}\u{646}\u{648}\u{627}\u{646} \u{6A9}\u{627}\u{631}\u{628}\u{631} \u{62F}\u{6CC}\u{6AF}\u{631}\u{60C} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631}\u{627}\u{62A}\u{6CC} \u{627}\u{639}\u{645}\u{627}\u{644} \u{646}\u{645}\u{6CC} \u{634}\u{648}\u{62F}.`,
    fil: `Hindi maaaring gawin ang mga pagbabago habang tinitingnan ang participant portal bilang ibang user.`,
    fr: `Aucune modification ne peut \xeatre effectu\xe9e en consultant le portail participant en tant qu\u{2019}utilisateur d\u{2019}un autre.`,
    hi: `\u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{940} \u{92A}\u{94B}\u{930}\u{94D}\u{91F}\u{932} \u{915}\u{94B} \u{915}\u{93F}\u{938}\u{940} \u{905}\u{928}\u{94D}\u{92F} \u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E} \u{915}\u{947} \u{930}\u{942}\u{92A} \u{92E}\u{947}\u{902} \u{926}\u{947}\u{916}\u{924}\u{947} \u{938}\u{92E}\u{92F} \u{938}\u{902}\u{936}\u{94B}\u{927}\u{928} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{90F} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{947}.`,
    ht: `Modifikasyon pa ka f\xe8t pandan y ap gade p\xf2tal patisipan an k\xf2m yon l\xf2t itilizat\xe8.`,
    it: `Non possono essere apportate modifiche mentre si visualizza il portale partecipante come un altro utente.`,
    ja: `\u{53C2}\u{52A0}\u{8005}\u{30DD}\u{30FC}\u{30BF}\u{30EB}\u{3092}\u{4ED6}\u{306E}\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{3068}\u{3057}\u{3066}\u{95B2}\u{89A7}\u{3057}\u{3066}\u{3044}\u{308B}\u{9593}\u{306F}\u{5909}\u{66F4}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{B2E4}\u{B978} \u{C0AC}\u{C6A9}\u{C790}\u{B85C} \u{CC38}\u{C5EC}\u{C790} \u{D3EC}\u{D138}\u{C744} \u{BCFC} \u{B54C}\u{B294} \u{C218}\u{C815}\u{C774} \u{BD88}\u{AC00}\u{B2A5}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis tuaj yeem hloov kho thaum saib lub portal koom nrog ua ib tug neeg siv lwm tus.`,
    ps: `\u{62F} \u{6AB}\u{689}\u{648}\u{646} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{67E}\u{648}\u{631}\u{67C}\u{644} \u{62F} \u{628}\u{644} \u{6A9}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC} \u{67E}\u{647} \u{62A}\u{648}\u{6AB}\u{647} \u{6A9}\u{62A}\u{644} \u{67E}\u{631} \u{645}\u{647}\u{627}\u{644} \u{62A}\u{639}\u{62F}\u{6CC}\u{644}\u{627}\u{62A} \u{646}\u{634}\u{6CC} \u{6A9}\u{6D0}\u{62F}\u{627}\u{6CC}.`,
    pt: `Modifica\xe7\xf5es n\xe3o podem ser feitas enquanto visualizam o portal de participantes como outro usu\xe1rio.`,
    'pt-pt': `N\xe3o podem ser feitas modifica\xe7\xf5es enquanto se visualiza o portal do participante como outro utilizador.`,
    ru: `\u{418}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{43D}\u{435}\u{43B}\u{44C}\u{437}\u{44F}, \u{43A}\u{43E}\u{433}\u{434}\u{430} \u{43F}\u{43E}\u{440}\u{442}\u{430}\u{43B} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{430} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{430}\u{435}\u{442}\u{441}\u{44F} \u{43A}\u{430}\u{43A} \u{434}\u{440}\u{443}\u{433}\u{43E}\u{439} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}.`,
    sm: `E le mafai ona faia ni suiga a o maimoa i le faitotoa o tagata auai o se isi tagata faaaoga.`,
    so: `Wax ka beddel lama samayn karo marka la arko portal-ka ka qaybgalka sida isticmaale kale.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E44}\u{E14}\u{E49}\u{E02}\u{E13}\u{E30}\u{E14}\u{E39}\u{E1E}\u{E2D}\u{E23}\u{E4C}\u{E17}\u{E31}\u{E25}\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}\u{E43}\u{E19}\u{E10}\u{E32}\u{E19}\u{E30}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E19}\u{E2D}\u{E37}\u{E48}\u{E19}`,
    ur: `\u{634}\u{631}\u{6A9}\u{627}\u{621} \u{6A9}\u{6D2} \u{67E}\u{648}\u{631}\u{679}\u{644} \u{6A9}\u{648} \u{62F}\u{648}\u{633}\u{631}\u{6D2} \u{635}\u{627}\u{631}\u{641} \u{6A9}\u{6D2} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{62A}\u{6D2} \u{6C1}\u{648}\u{626}\u{6D2} \u{62A}\u{628}\u{62F}\u{6CC}\u{644}\u{6CC}\u{627}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Kh\xf4ng th\u{1EC3} th\u{1EF1}c hi\u{1EC7}n ch\u{1EC9}nh s\u{1EED}a khi \u{111}ang xem c\u{1ED5}ng th\xf4ng tin ng\u{1B0}\u{1EDD}i tham gia v\u{1EDB}i t\u{1B0} c\xe1ch ng\u{1B0}\u{1EDD}i d\xf9ng kh\xe1c.`,
    'zh-hans': `\u{5728}\u{4EE5}\u{5176}\u{4ED6}\u{7528}\u{6237}\u{8EAB}\u{4EFD}\u{67E5}\u{770B}\u{53C2}\u{4E0E}\u{8005}\u{95E8}\u{6237}\u{65F6}\u{FF0C}\u{4E0D}\u{80FD}\u{8FDB}\u{884C}\u{4FEE}\u{6539}\u{3002}`,
    'zh-hant': `\u{5728}\u{4EE5}\u{5176}\u{4ED6}\u{4F7F}\u{7528}\u{8005}\u{8EAB}\u{4EFD}\u{67E5}\u{770B}\u{53C3}\u{8207}\u{8005}\u{5165}\u{53E3}\u{6642}\u{FF0C}\u{7121}\u{6CD5}\u{9032}\u{884C}\u{4FEE}\u{6539}\u{3002}`,
    en: `Modifications cannot be made while viewing the participant portal as another user.`
};
const $b11db1b62d4a8f76$export$aeb79ee2d087e8f3 = {
    ar: `\u{62A}\u{648}\u{642}\u{641} \u{639}\u{646} \u{627}\u{644}\u{645}\u{634}\u{627}\u{647}\u{62F}\u{629}`,
    de: `H\xf6ren Sie auf zu schauen`,
    es: `Dejar de ver`,
    fa: `\u{62A}\u{645}\u{627}\u{634}\u{627} \u{631}\u{627} \u{645}\u{62A}\u{648}\u{642}\u{641} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Itigil ang pagtingin`,
    fr: `Arr\xeater de regarder`,
    hi: `\u{926}\u{947}\u{916}\u{928}\u{93E} \u{92C}\u{902}\u{926} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Sispann gade`,
    it: `Interrompi la visione`,
    ja: `\u{8996}\u{8074}\u{3092}\u{3084}\u{3081}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{C2DC}\u{CCAD} \u{C911}\u{C9C0}`,
    mww: `Nres saib`,
    ps: `\u{6A9}\u{62A}\u{644} \u{628}\u{646}\u{62F} \u{6A9}\u{693}\u{626}`,
    pt: `Parar de assistir`,
    'pt-pt': `Parar de ver`,
    ru: `\u{41F}\u{440}\u{435}\u{43A}\u{440}\u{430}\u{442}\u{438}\u{442}\u{44C} \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}`,
    sm: `Taofi le maimoaina`,
    so: `Jooji daawashada`,
    th: `\u{E2B}\u{E22}\u{E38}\u{E14}\u{E14}\u{E39}`,
    ur: `\u{62F}\u{6CC}\u{6A9}\u{6BE}\u{646}\u{627} \u{628}\u{646}\u{62F} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `D\u{1EEB}ng xem`,
    'zh-hans': `\u{505C}\u{6B62}\u{89C2}\u{770B}`,
    'zh-hant': `\u{505C}\u{6B62}\u{89C0}\u{770B}`,
    en: `Stop viewing`
};
const $b11db1b62d4a8f76$export$ce7e13cfc7b01fec = {
    ar: `\u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{648}\u{646}`,
    de: `Teilnehmer`,
    es: `Participantes`,
    fa: `\u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{6AF}\u{627}\u{646}`,
    fil: `Mga Kalahok`,
    fr: `Participants`,
    hi: `\u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{93F}\u{92F}\u{94B}\u{902}`,
    ht: `Patisipan yo`,
    it: `Partecipanti`,
    ja: `\u{53C2}\u{52A0}\u{8005}`,
    ko: `\u{CC38}\u{AC00}\u{C790}`,
    mww: `Cov neeg koom`,
    ps: `\u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644}`,
    pt: `Participantes`,
    'pt-pt': `Participantes`,
    ru: `\u{423}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{438}`,
    sm: `Tagata auai`,
    so: `Ka qaybgalayaasha`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}`,
    ur: `\u{634}\u{631}\u{6A9}\u{627}\u{621}`,
    vi: `C\xe1c th\xe0nh vi\xean tham gia`,
    'zh-hans': `\u{53C2}\u{8D5B}\u{8005}`,
    'zh-hant': `\u{53C3}\u{8207}\u{8005}`,
    en: `Participants`
};
const $b11db1b62d4a8f76$export$d734e117cd0267f9 = {
    ar: `\u{627}\u{644}\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}`,
    de: `Teilnehmer-Nutzer`,
    es: `Usuario participante`,
    fa: `\u{6A9}\u{627}\u{631}\u{628}\u{631} \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: `Gumagamit ng kalahok`,
    fr: `Utilisateur participant`,
    hi: `\u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{940} \u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E}`,
    ht: `Itilizat\xe8 patisipan yo`,
    it: `Utente partecipante`,
    ja: `\u{53C2}\u{52A0}\u{8005}\u{30E6}\u{30FC}\u{30B6}\u{30FC}`,
    ko: `\u{CC38}\u{C5EC} \u{C0AC}\u{C6A9}\u{C790}`,
    mww: `Tus neeg koom nrog`,
    ps: `\u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644} \u{6A9}\u{627}\u{631}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Usu\xe1rio participante`,
    'pt-pt': `Utilizador participante`,
    ru: `\u{423}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}-\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}`,
    sm: `Tagata auai`,
    so: `Isticmaalaha ka qaybgalka`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E17}\u{E35}\u{E48}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}`,
    ur: `\u{634}\u{631}\u{6CC}\u{6A9} \u{635}\u{627}\u{631}\u{641}`,
    vi: `Ng\u{1B0}\u{1EDD}i d\xf9ng tham gia`,
    'zh-hans': `\u{53C2}\u{4E0E}\u{7528}\u{6237}`,
    'zh-hant': `\u{53C3}\u{8207}\u{8005}\u{4F7F}\u{7528}\u{8005}`,
    en: `Participant user`
};
const $b11db1b62d4a8f76$export$91a0a4481eddf2b2 = {
    ar: `\u{631}\u{645}\u{632} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631}`,
    de: `Passcode`,
    es: `C\xf3digo de acceso`,
    fa: `\u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631}`,
    fil: `Passcode`,
    fr: `Code d\u{2019}acc\xe8s`,
    hi: `\u{92A}\u{93E}\u{938}\u{915}\u{94B}\u{921}`,
    ht: `Passcode`,
    it: `Codice di accesso`,
    ja: `\u{30D1}\u{30B9}\u{30B3}\u{30FC}\u{30C9}`,
    ko: `\u{BE44}\u{BC00}\u{BC88}\u{D638}`,
    mww: `Passcode`,
    ps: `\u{67E}\u{627}\u{633}\u{6A9}\u{648}\u{689}`,
    pt: `C\xf3digo de acesso`,
    'pt-pt': `C\xf3digo de acesso`,
    ru: `\u{41F}\u{430}\u{440}\u{43E}\u{43B}\u{44C}`,
    sm: `Passcode`,
    so: `Koodhka sirta ah`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}`,
    ur: `\u{67E}\u{627}\u{633} \u{6A9}\u{648}\u{688}`,
    vi: `M\xe3 truy c\u{1EAD}p`,
    'zh-hans': `\u{5BC6}\u{7801}`,
    'zh-hant': `\u{5BC6}\u{78BC}`,
    en: `Passcode`
};
const $b11db1b62d4a8f76$export$7561cac8e8e89a56 = {
    ar: `\u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631}`,
    de: `Passwort`,
    es: `Contrase\xf1a`,
    fa: `\u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631}`,
    fil: `Password`,
    fr: `Mot de passe`,
    hi: `\u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921}`,
    ht: `Modpas`,
    it: `Password`,
    ja: `\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}`,
    ko: `\u{BE44}\u{BC00}\u{BC88}\u{D638}`,
    mww: `Lo lus zais`,
    ps: `\u{631}\u{645}\u{632}`,
    pt: `Senha`,
    'pt-pt': `Palavra-passe`,
    ru: `\u{41F}\u{430}\u{440}\u{43E}\u{43B}\u{44C}`,
    sm: `Upu faataga`,
    so: `Erayga sirta ah`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}`,
    ur: `\u{67E}\u{627}\u{633} \u{648}\u{631}\u{688}`,
    vi: `M\u{1EAD}t kh\u{1EA9}u`,
    'zh-hans': `\u{5BC6}\u{7801}`,
    'zh-hant': `\u{5BC6}\u{78BC}`,
    en: `Password`
};
const $b11db1b62d4a8f76$export$c004222406ecc458 = {
    ar: (minLength)=>`\u{639}\u{644}\u{649} \u{627}\u{644}\u{623}\u{642}\u{644} ${minLength} \u{634}\u{62E}\u{635}\u{64A}\u{627}\u{62A}. \u{646}\u{642}\u{648}\u{645} \u{628}\u{62D}\u{62C}\u{628} \u{643}\u{644}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631} \u{648}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{627}\u{644}\u{627}\u{639}\u{62A}\u{645}\u{627}\u{62F} \u{627}\u{644}\u{634}\u{627}\u{626}\u{639}\u{629} \u{627}\u{644}\u{645}\u{639}\u{631}\u{648}\u{641}\u{629} \u{628}\u{623}\u{646}\u{647}\u{627} \u{62A}\u{645} \u{627}\u{62E}\u{62A}\u{631}\u{627}\u{642}\u{647}\u{627}.`,
    de: (minLength)=>`Mindestens ${minLength} Zeichen. Wir blockieren g\xe4ngige Passw\xf6rter und Zugangsdaten, von denen bekannt ist, dass sie gehackt wurden.`,
    es: (minLength)=>`Al menos ${minLength} personajes. Bloqueamos contrase\xf1as y credenciales comunes que se sabe que han sido vulneradas.`,
    fa: (minLength)=>`\u{62D}\u{62F}\u{627}\u{642}\u{644} ${minLength} \u{634}\u{62E}\u{635}\u{6CC}\u{62A}. \u{645}\u{627} \u{631}\u{645}\u{632}\u{647}\u{627}\u{6CC} \u{639}\u{628}\u{648}\u{631} \u{648} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{648}\u{631}\u{648}\u{62F} \u{631}\u{627}\u{6CC}\u{62C}\u{6CC} \u{6A9}\u{647} \u{634}\u{646}\u{627}\u{62E}\u{62A}\u{647} \u{634}\u{62F}\u{647} \u{646}\u{642}\u{636} \u{634}\u{62F}\u{647} \u{627}\u{646}\u{62F} \u{631}\u{627} \u{645}\u{633}\u{62F}\u{648}\u{62F} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{645}.`,
    fil: (minLength)=>`Hindi bababa sa ${minLength} character. Hinaharangan namin ang mga karaniwang password at kredensyal na alam na nilabag.`,
    fr: (minLength)=>`Au moins ${minLength} personnages. Nous bloqueons les mots de passe et identifiants courants dont on sait qu\u{2019}ils ont \xe9t\xe9 viol\xe9s.`,
    hi: (minLength)=>`\u{915}\u{92E} \u{938}\u{947} \u{915}\u{92E} ${minLength} \u{935}\u{930}\u{94D}\u{923}\u{964} \u{939}\u{92E} \u{909}\u{928} \u{938}\u{93E}\u{92E}\u{93E}\u{928}\u{94D}\u{92F} \u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} \u{914}\u{930} \u{915}\u{94D}\u{930}\u{947}\u{921}\u{947}\u{902}\u{936}\u{93F}\u{92F}\u{932}\u{94D}\u{938} \u{915}\u{94B} \u{92C}\u{94D}\u{932}\u{949}\u{915} \u{915}\u{930}\u{924}\u{947} \u{939}\u{948}\u{902} \u{91C}\u{93F}\u{928}\u{94D}\u{939}\u{947}\u{902} \u{909}\u{932}\u{94D}\u{932}\u{902}\u{918}\u{928} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{91C}\u{93E}\u{928}\u{93E} \u{91C}\u{93E}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (minLength)=>`Omwen ${minLength} karakt\xe8 Nou bloke modpas komen ak kalifikasyon yo konnen yo te vyole.`,
    it: (minLength)=>`Almeno ${minLength} personaggi. Blocchiamo password e credenziali comuni che si sa siano state violate.`,
    ja: (minLength)=>`\u{5C11}\u{306A}\u{304F}\u{3068}\u{3082} ${minLength} \u{6587}\u{5B57}\u{306F}\u{5FC5}\u{8981}\u{3067}\u{3059}\u{3002}\u{79C1}\u{305F}\u{3061}\u{306F}\u{3001}\u{4FB5}\u{5BB3}\u{304C}\u{78BA}\u{8A8D}\u{3055}\u{308C}\u{3066}\u{3044}\u{308B}\u{4E00}\u{822C}\u{7684}\u{306A}\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}\u{3084}\u{8A8D}\u{8A3C}\u{60C5}\u{5831}\u{3092}\u{30D6}\u{30ED}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (minLength)=>`\u{CD5C}\u{C18C} ${minLength} \u{BA85}\u{C758} \u{CE90}\u{B9AD}\u{D130}\u{AC00} \u{D544}\u{C694}\u{D569}\u{B2C8}\u{B2E4}. \u{C6B0}\u{B9AC}\u{B294} \u{C720}\u{CD9C}\u{B41C} \u{AC83}\u{C73C}\u{B85C} \u{C54C}\u{B824}\u{C9C4} \u{C77C}\u{BC18}\u{C801}\u{C778} \u{BE44}\u{BC00}\u{BC88}\u{D638}\u{C640} \u{C790}\u{ACA9} \u{C99D}\u{BA85}\u{C744} \u{CC28}\u{B2E8}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (minLength)=>`Tsawg kawg ${minLength} cim. Peb thaiv cov lus zais thiab cov ntawv pov thawj uas paub tias tau ua txhaum.`,
    ps: (minLength)=>`\u{644}\u{696} \u{62A}\u{631} \u{644}\u{696}\u{647} ${minLength} \u{6A9}\u{631}\u{6A9}\u{67C}\u{631}\u{648}\u{646}\u{647}. \u{645}\u{648}\u{696} \u{639}\u{627}\u{645} \u{67E}\u{627}\u{633}\u{648}\u{631}\u{689}\u{648}\u{646}\u{647} \u{627}\u{648} \u{627}\u{633}\u{646}\u{627}\u{62F} \u{628}\u{646}\u{62F}\u{648}\u{648} \u{686}\u{6D0} \u{67E}\u{6CC}\u{698}\u{646}\u{62F}\u{644} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC} \u{686}\u{6D0} \u{645}\u{627}\u{62A} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: (minLength)=>`Pelo menos ${minLength} personagens. Bloqueamos senhas e credenciais comuns que se sabe terem sido violadas.`,
    'pt-pt': (minLength)=>`Pelo menos ${minLength} personagens. Bloqueamos palavras-passe e credenciais comuns que se sabe terem sido violadas.`,
    ru: (minLength)=>`\u{41C}\u{438}\u{43D}\u{438}\u{43C}\u{443}\u{43C} ${minLength} \u{43F}\u{435}\u{440}\u{441}\u{43E}\u{43D}\u{430}\u{436}\u{435}\u{439}. \u{41C}\u{44B} \u{431}\u{43B}\u{43E}\u{43A}\u{438}\u{440}\u{443}\u{435}\u{43C} \u{440}\u{430}\u{441}\u{43F}\u{440}\u{43E}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{451}\u{43D}\u{43D}\u{44B}\u{435} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{438} \u{438} \u{443}\u{447}\u{435}\u{442}\u{43D}\u{44B}\u{435} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{435} \u{438}\u{437}\u{432}\u{435}\u{441}\u{442}\u{43D}\u{44B} \u{43A}\u{430}\u{43A} \u{432}\u{437}\u{43B}\u{43E}\u{43C}\u{430}\u{43D}\u{44B}.`,
    sm: (minLength)=>`Le itiiti ifo ma ${minLength} mataitusi. Matou te poloka upu faataga masani ma fa'amaoniga ua iloa ua solia.`,
    so: (minLength)=>`Ugu yaraan ${minLength} xaraf. Waxaan xannibanaa erayada sirta ah iyo aqoonsiga caadiga ah ee la ogyahay in la jebiyay.`,
    th: (minLength)=>`\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E19}\u{E49}\u{E2D}\u{E22} ${minLength} \u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23} \u{E40}\u{E23}\u{E32}\u{E1A}\u{E25}\u{E47}\u{E2D}\u{E01}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E41}\u{E25}\u{E30}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E1B}\u{E23}\u{E30}\u{E08}\u{E4D}\u{E32}\u{E15}\u{E31}\u{E27}\u{E17}\u{E31}\u{E48}\u{E27}\u{E44}\u{E1B}\u{E17}\u{E35}\u{E48}\u{E17}\u{E23}\u{E32}\u{E1A}\u{E27}\u{E48}\u{E32}\u{E16}\u{E39}\u{E01}\u{E25}\u{E30}\u{E40}\u{E21}\u{E34}\u{E14}`,
    ur: (minLength)=>`\u{6A9}\u{645} \u{627}\u{632} \u{6A9}\u{645} ${minLength} \u{6A9}\u{631}\u{62F}\u{627}\u{631}\u{6D4} \u{6C1}\u{645} \u{639}\u{627}\u{645} \u{67E}\u{627}\u{633} \u{648}\u{631}\u{688}\u{632} \u{627}\u{648}\u{631} \u{627}\u{633}\u{646}\u{627}\u{62F} \u{6A9}\u{648} \u{628}\u{644}\u{627}\u{6A9} \u{6A9}\u{631} \u{62F}\u{6CC}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{62C}\u{646} \u{6A9}\u{6D2} \u{62E}\u{644}\u{627}\u{641} \u{62E}\u{644}\u{627}\u{641} \u{648}\u{631}\u{632}\u{6CC} \u{6A9}\u{627} \u{639}\u{644}\u{645} \u{6C1}\u{648}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (minLength)=>`\xcdt nh\u{1EA5}t ${minLength} k\xfd t\u{1EF1}. Ch\xfang t\xf4i ch\u{1EB7}n c\xe1c m\u{1EAD}t kh\u{1EA9}u v\xe0 th\xf4ng tin \u{111}\u{103}ng nh\u{1EAD}p ph\u{1ED5} bi\u{1EBF}n \u{111}\u{1B0}\u{1EE3}c bi\u{1EBF}t l\xe0 \u{111}\xe3 b\u{1ECB} vi ph\u{1EA1}m.`,
    'zh-hans': (minLength)=>`\u{81F3}\u{5C11}\u{6709} ${minLength} \u{4E2A}\u{89D2}\u{8272}\u{3002}\u{6211}\u{4EEC}\u{4F1A}\u{5C4F}\u{853D}\u{5DF2}\u{77E5}\u{88AB}\u{6CC4}\u{9732}\u{7684}\u{5E38}\u{89C1}\u{5BC6}\u{7801}\u{548C}\u{51ED}\u{8BC1}\u{3002}`,
    'zh-hant': (minLength)=>`\u{81F3}\u{5C11} ${minLength} \u{500B}\u{89D2}\u{8272}\u{3002}\u{6211}\u{5011}\u{6703}\u{5C01}\u{9396}\u{5DF2}\u{77E5}\u{88AB}\u{5165}\u{4FB5}\u{7684}\u{5E38}\u{898B}\u{5BC6}\u{78BC}\u{548C}\u{6191}\u{8B49}\u{3002}`,
    en: (minLength)=>`At least ${minLength} characters. We block common passwords and credentials that are known to have been breached.`
};
const $b11db1b62d4a8f76$export$2d750338a85d58cd = {
    ar: `\u{645}\u{644}\u{641}\u{627}\u{62A} \u{62C}\u{647}\u{629} \u{627}\u{644}\u{62F}\u{641}\u{639}`,
    de: `Kostentr\xe4gerdateien`,
    es: `Archivos del pagador`,
    fa: `\u{67E}\u{631}\u{648}\u{646}\u{62F}\u{647}\u{200C}\u{647}\u{627}\u{6CC} \u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A}\u{200C}\u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: `Mga file ng nagbabayad`,
    fr: `Fichiers du payeur`,
    hi: `\u{92D}\u{941}\u{917}\u{924}\u{93E}\u{928}\u{915}\u{930}\u{94D}\u{924}\u{93E} \u{92B}\u{93C}\u{93E}\u{907}\u{932}\u{947}\u{902}`,
    ht: `Fichye pey\xe8`,
    it: `File del pagatore`,
    ja: `\u{652F}\u{6255}\u{8005}\u{30D5}\u{30A1}\u{30A4}\u{30EB}`,
    ko: `\u{C9C0}\u{AE09}\u{C790} \u{D30C}\u{C77C}`,
    mww: `Tus neeg them nyiaj cov ntaub ntawv`,
    ps: `\u{62F} \u{62A}\u{627}\u{62F}\u{6CC}\u{647} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{64A} \u{641}\u{627}\u{6CC}\u{644}\u{648}\u{646}\u{647}`,
    pt: `Arquivos do pagador`,
    'pt-pt': `Ficheiros do pagador`,
    ru: `\u{424}\u{430}\u{439}\u{43B}\u{44B} \u{43F}\u{43B}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{449}\u{438}\u{43A}\u{430}`,
    sm: `Faila a le tagata totogi`,
    so: `Faylasha bixiyaha`,
    th: `\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E1C}\u{E39}\u{E49}\u{E0A}\u{E33}\u{E23}\u{E30}\u{E40}\u{E07}\u{E34}\u{E19}`,
    ur: `\u{627}\u{62F}\u{627}\u{626}\u{6CC}\u{6AF}\u{6CC} \u{6A9}\u{646}\u{646}\u{62F}\u{6C1} \u{6A9}\u{6CC} \u{641}\u{627}\u{626}\u{644}\u{6CC}\u{6BA}`,
    vi: `T\u{1EC7}p b\xean thanh to\xe1n`,
    'zh-hans': `\u{4ED8}\u{6B3E}\u{65B9}\u{6587}\u{4EF6}`,
    'zh-hant': `\u{4ED8}\u{6B3E}\u{65B9}\u{6A94}\u{6848}`,
    en: `Payer files`
};
const $b11db1b62d4a8f76$export$2cea9b5b0a64eca3 = {
    ar: `\u{627}\u{644}\u{639}\u{627}\u{645}\u{644}`,
    de: `Zahler`,
    es: `Pagador`,
    fa: `\u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: `Nagbabayad`,
    fr: `Payeur`,
    hi: `\u{92D}\u{941}\u{917}\u{924}\u{93E}\u{928}\u{915}\u{930}\u{94D}\u{924}\u{93E}`,
    ht: `Payor`,
    it: `Pagatore`,
    ja: `\u{652F}\u{6255}\u{8005}`,
    ko: `\u{C9C0}\u{AE09}\u{C790}`,
    mww: `Tus neeg them nyiaj`,
    ps: `\u{67E}\u{627}\u{6CC}\u{648}\u{631}`,
    pt: `Pagador`,
    'pt-pt': `Pagador`,
    ru: `\u{41F}\u{43B}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{449}\u{438}\u{43A}`,
    sm: `Tagata totogi`,
    so: `Bixiyaha`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E08}\u{E48}\u{E32}\u{E22}\u{E40}\u{E07}\u{E34}\u{E19}`,
    ur: `\u{67E}\u{6CC}\u{626}\u{631}`,
    vi: `Ng\u{1B0}\u{1EDD}i thanh to\xe1n`,
    'zh-hans': `\u{4ED8}\u{6B3E}\u{65B9}`,
    'zh-hant': `\u{4ED8}\u{6B3E}\u{65B9}`,
    en: `Payor`
};
const $b11db1b62d4a8f76$export$3beaebc2227194ba = {
    ar: `\u{641}\u{62A}\u{631}\u{629} \u{627}\u{644}\u{62F}\u{641}\u{639}`,
    de: `Abrechnungszeitraum`,
    es: `Periodo de pago`,
    fa: `\u{62F}\u{648}\u{631}\u{647} \u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A}`,
    fil: `Panahon ng Pagbabayad`,
    fr: `P\xe9riode de paie`,
    hi: `\u{92D}\u{941}\u{917}\u{924}\u{93E}\u{928} \u{905}\u{935}\u{927}\u{93F}`,
    ht: `Pery\xf2d peman an`,
    it: `Periodo di paga`,
    ja: `\u{7D66}\u{4E0E}\u{671F}\u{9593}`,
    ko: `\u{AE09}\u{C5EC} \u{AE30}\u{AC04}`,
    mww: `Lub sijhawm them nyiaj`,
    ps: `\u{62F} \u{645}\u{639}\u{627}\u{634} \u{645}\u{648}\u{62F}\u{647}`,
    pt: `Per\xedodo de pagamento`,
    'pt-pt': `Per\xedodo de pagamento`,
    ru: `\u{41F}\u{435}\u{440}\u{438}\u{43E}\u{434} \u{43E}\u{43F}\u{43B}\u{430}\u{442}\u{44B}`,
    sm: `Vaitaimi o totogi`,
    so: `Muddada mushaharka`,
    th: `\u{E23}\u{E30}\u{E22}\u{E30}\u{E40}\u{E27}\u{E25}\u{E32}\u{E01}\u{E32}\u{E23}\u{E08}\u{E48}\u{E32}\u{E22}\u{E40}\u{E07}\u{E34}\u{E19}`,
    ur: `\u{62A}\u{646}\u{62E}\u{648}\u{627}\u{6C1} \u{6A9}\u{627} \u{62F}\u{648}\u{631}\u{627}\u{646}\u{6CC}\u{6C1}`,
    vi: `Th\u{1EDD}i gian thanh to\xe1n`,
    'zh-hans': `\u{53D1}\u{85AA}\u{5468}\u{671F}`,
    'zh-hant': `\u{85AA}\u{8CC7}\u{671F}\u{9593}`,
    en: `Pay period`
};
const $b11db1b62d4a8f76$export$4ababb78e2d2bf96 = {
    ar: `\u{642}\u{648}\u{627}\u{644}\u{628} PDF`,
    de: `PDF-Vorlagen`,
    es: `Plantillas PDF`,
    fa: `\u{642}\u{627}\u{644}\u{628} \u{647}\u{627}\u{6CC} PDF`,
    fil: `Mga template ng PDF`,
    fr: `Mod\xe8les PDF`,
    hi: `\u{92A}\u{940}\u{921}\u{940}\u{90F}\u{92B} \u{91F}\u{947}\u{92E}\u{94D}\u{92A}\u{932}\u{947}\u{91F}\u{94D}\u{938}`,
    ht: `Mod\xe8l PDF`,
    it: `Modelli PDF`,
    ja: `PDF\u{30C6}\u{30F3}\u{30D7}\u{30EC}\u{30FC}\u{30C8}`,
    ko: `PDF \u{D15C}\u{D50C}\u{B9BF}`,
    mww: `PDF templates`,
    ps: `PDF \u{67C}\u{6CC}\u{645}\u{67E}\u{644}\u{6CC}\u{67C}\u{648}\u{646}\u{647}`,
    pt: `Modelos PDF`,
    'pt-pt': `Modelos PDF`,
    ru: `\u{428}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{44B} PDF`,
    sm: `PDF templates`,
    so: `Qaababka PDF`,
    th: `\u{E40}\u{E17}\u{E21}\u{E40}\u{E1E}\u{E25}\u{E15} PDF`,
    ur: `\u{67E}\u{6CC} \u{688}\u{6CC} \u{627}\u{6CC}\u{641} \u{679}\u{6CC}\u{645}\u{67E}\u{644}\u{6CC}\u{679}\u{633}`,
    vi: `M\u{1EAB}u PDF`,
    'zh-hans': `PDF\u{6A21}\u{677F}`,
    'zh-hant': `PDF \u{7BC4}\u{672C}`,
    en: `PDF templates`
};
const $b11db1b62d4a8f76$export$cb4bba10862c0265 = {
    ar: `\u{642}\u{64A}\u{62F} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`,
    de: `Ausstehend`,
    es: `Pendiente`,
    fa: `\u{62F}\u{631} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`,
    fil: `Nakabinbin`,
    fr: `En attente`,
    hi: `\u{932}\u{902}\u{92C}\u{93F}\u{924}`,
    ht: `Annatant`,
    it: `In attesa`,
    ja: `\u{4FDD}\u{7559}\u{4E2D}`,
    ko: `\u{B300}\u{AE30} \u{C911}\u{C785}\u{B2C8}\u{B2E4}`,
    mww: `Tos`,
    ps: `\u{627}\u{646}\u{62A}\u{638}\u{627}\u{631} \u{6A9}\u{6D0} \u{62F}\u{6CC}`,
    pt: `Pendente`,
    'pt-pt': `Pendente`,
    ru: `\u{412} \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43D}\u{438}\u{438}`,
    sm: `Fa'atali`,
    so: `Sugaya`,
    th: `\u{E23}\u{E2D}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{632}\u{6CC}\u{631} \u{627}\u{644}\u{62A}\u{648}\u{627}\u{621}`,
    vi: `\u{110}ang ch\u{1EDD} x\u{1EED} l\xfd`,
    'zh-hans': `\u{5F85}\u{5904}\u{7406}`,
    'zh-hant': `\u{5F85}\u{5B9A}`,
    en: `Pending`
};
const $b11db1b62d4a8f76$export$28a95c66c8c9db40 = {
    ar: (count)=>`${count} \u{62A}\u{648}\u{642}\u{64A}\u{639} \u{645}\u{639}\u{644}\u{642}\u{627}\u{646}`,
    de: (count)=>`${count} ausstehende Unterschriftsanfragen`,
    es: (count)=>`${count} solicitudes de firma pendientes`,
    fa: (count)=>`${count} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{627}\u{645}\u{636}\u{627} \u{62F}\u{631} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`,
    fil: (count)=>`${count} nakabinbing mga kahilingan sa lagda`,
    fr: (count)=>`${count} demandes de signature en attente`,
    hi: (count)=>`${count} \u{932}\u{902}\u{92C}\u{93F}\u{924} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927}`,
    ht: (count)=>`${count} annatant demann siyati`,
    it: (count)=>`${count} richieste di firma pendenti`,
    ja: (count)=>`${count} \u{4EF6}\u{306E}\u{4FDD}\u{7559}\u{4E2D}\u{306E}\u{7F72}\u{540D}\u{8981}\u{6C42}`,
    ko: (count)=>`${count} \u{AC1C}\u{C758} \u{B300}\u{AE30} \u{C11C}\u{BA85} \u{C694}\u{CCAD}`,
    mww: (count)=>`${count} Tos kos npe thov`,
    ps: (count)=>`${count} \u{62F} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{6D0} \u{67E}\u{627}\u{62A}\u{6D0} \u{62F}\u{6CC}`,
    pt: (count)=>`${count} pedidos de assinatura pendentes`,
    'pt-pt': (count)=>`${count} pedidos de assinatura pendentes`,
    ru: (count)=>`${count} \u{41E}\u{436}\u{438}\u{434}\u{430}\u{44E}\u{449}\u{438}\u{435} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{44B} \u{43D}\u{430} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: (count)=>`${count} talosaga o saini o loo faatalitali`,
    so: (count)=>`${count} codsi saxiix oo sugaya`,
    th: (count)=>`\u{E04}\u{E4D}\u{E32}\u{E02}\u{E2D}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E17}\u{E35}\u{E48}\u{E23}\u{E2D}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23} ${count} \u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}`,
    ur: (count)=>`${count} \u{632}\u{6CC}\u{631} \u{627}\u{644}\u{62A}\u{648}\u{627} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA}`,
    vi: (count)=>`${count} y\xeau c\u{1EA7}u ch\u{1EEF} k\xfd \u{111}ang ch\u{1EDD} x\u{1EED} l\xfd`,
    'zh-hans': (count)=>`${count} \u{4E2A}\u{5F85}\u{5904}\u{7406}\u{7B7E}\u{540D}\u{8BF7}\u{6C42}`,
    'zh-hant': (count)=>`${count} \u{500B}\u{5F85}\u{8655}\u{7406}\u{7684}\u{7C3D}\u{7AE0}\u{8ACB}\u{6C42}`,
    en: (count)=>`${count} pending signature requests`
};
const $b11db1b62d4a8f76$export$47c9f9f1e2696157 = {
    ar: `\u{637}\u{644}\u{628} \u{62A}\u{648}\u{642}\u{64A}\u{639} \u{645}\u{639}\u{644}\u{642} \u{648}\u{627}\u{62D}\u{62F}`,
    de: `1 ausstehende Unterschriftsanfrage`,
    es: `1 solicitud de firma pendiente`,
    fa: `\u{6F1} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{627}\u{645}\u{636}\u{627} \u{62F}\u{631} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`,
    fil: `1 nakabinbin na kahilingan sa lagda`,
    fr: `1 demande de signature en attente`,
    hi: `1 \u{932}\u{902}\u{92C}\u{93F}\u{924} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927}`,
    ht: `1 annatant demann siyati`,
    it: `1 richiesta di firma in attesa`,
    ja: `\u{7F72}\u{540D}\u{7533}\u{8ACB}\u{4FDD}\u{7559}1\u{4EF6}`,
    ko: `\u{C11C}\u{BA85} \u{C694}\u{CCAD} 1\u{AC74} \u{B300}\u{AE30} \u{C911}\u{C785}\u{B2C8}\u{B2E4}`,
    mww: `1 Tos kos npe thov`,
    ps: `\u{6F1} \u{62F} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{647} \u{67E}\u{627}\u{62A}\u{6D0} \u{62F}\u{647}`,
    pt: `1 pedido de assinatura pendente`,
    'pt-pt': `1 pedido de assinatura pendente`,
    ru: `1 \u{41E}\u{436}\u{438}\u{434}\u{430}\u{44E}\u{449}\u{438}\u{439} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441} \u{43D}\u{430} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `1 talosaga o saini o loo faatalitali`,
    so: `1 codsi saxiix oo sugaya`,
    th: `1 \u{E04}\u{E4D}\u{E32}\u{E02}\u{E2D}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E17}\u{E35}\u{E48}\u{E23}\u{E2D}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}`,
    ur: `1 \u{632}\u{6CC}\u{631} \u{627}\u{644}\u{62A}\u{648}\u{627}\u{621} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}`,
    vi: `1 y\xeau c\u{1EA7}u ch\u{1EEF} k\xfd \u{111}ang ch\u{1EDD} x\u{1EED} l\xfd`,
    'zh-hans': `1\u{4E2A}\u{5F85}\u{7B7E}\u{7B7E}\u{540D}\u{8BF7}\u{6C42}`,
    'zh-hant': `1 \u{500B}\u{5F85}\u{7C3D}\u{6536}\u{8ACB}\u{6C42}`,
    en: `1 pending signature request`
};
const $b11db1b62d4a8f76$export$9a0b973819fb310 = {
    ar: `\u{627}\u{644}\u{623}\u{634}\u{62E}\u{627}\u{635}`,
    de: `Personen`,
    es: `Personas`,
    fa: `\u{627}\u{641}\u{631}\u{627}\u{62F}`,
    fil: `Mga Tao`,
    fr: `Personnalit\xe9s`,
    hi: `\u{932}\u{94B}\u{917}`,
    ht: `Moun`,
    it: `Persone`,
    ja: `\u{4EBA}\u{3005}`,
    ko: `\u{C778}\u{BB3C}`,
    mww: `Cov neeg`,
    ps: `\u{62E}\u{644}\u{6A9}`,
    pt: `Pessoas`,
    'pt-pt': `Pessoas`,
    ru: `\u{41B}\u{44E}\u{434}\u{438}`,
    sm: `Tagata`,
    so: `Dadka`,
    th: `\u{E1A}\u{E38}\u{E04}\u{E25}\u{E32}\u{E01}\u{E23}`,
    ur: `\u{644}\u{648}\u{6AF}`,
    vi: `Con ng\u{1B0}\u{1EDD}i`,
    'zh-hans': `\u{4EBA}\u{7269}`,
    'zh-hant': `\u{4EBA}\u{7269}`,
    en: `People`
};
const $b11db1b62d4a8f76$export$9f1bef56f6a3904b = {
    ar: `\u{627}\u{644}\u{623}\u{62F}\u{627}\u{621}`,
    de: `Leistung`,
    es: `Rendimiento`,
    fa: `\u{639}\u{645}\u{644}\u{6A9}\u{631}\u{62F}`,
    fil: `Pagganap`,
    fr: `Performances`,
    hi: `\u{92A}\u{94D}\u{930}\u{926}\u{930}\u{94D}\u{936}\u{928}`,
    ht: `P\xe8f\xf2mans`,
    it: `Prestazioni`,
    ja: `\u{30D1}\u{30D5}\u{30A9}\u{30FC}\u{30DE}\u{30F3}\u{30B9}`,
    ko: `\u{C131}\u{B2A5}`,
    mww: `Kev ua tau zoo`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    pt: `Desempenho`,
    'pt-pt': `Desempenho`,
    ru: `\u{425}\u{430}\u{440}\u{430}\u{43A}\u{442}\u{435}\u{440}\u{438}\u{441}\u{442}\u{438}\u{43A}\u{438}`,
    sm: `Fa'atinoga`,
    so: `Waxqabadka`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E2A}\u{E34}\u{E17}\u{E18}\u{E34}\u{E20}\u{E32}\u{E1E}`,
    ur: `\u{6A9}\u{627}\u{631}\u{6A9}\u{631}\u{62F}\u{6AF}\u{6CC}`,
    vi: `Hi\u{1EC7}u su\u{1EA5}t bay`,
    'zh-hans': `\u{6027}\u{80FD}`,
    'zh-hant': `\u{6027}\u{80FD}`,
    en: `Performance`
};
const $b11db1b62d4a8f76$export$94c8daae5f9ab256 = {
    ar: `\u{646}\u{642}\u{637}\u{629} \u{639}\u{644}\u{649} \u{627}\u{644}\u{633}\u{637}\u{631}`,
    de: `Punkt`,
    es: `Punto`,
    fa: `\u{62A}\u{645}\u{627}\u{645}.`,
    fil: `Panahon`,
    fr: `Point`,
    hi: `\u{905}\u{935}\u{927}\u{93F}`,
    ht: `Pery\xf2d`,
    it: `Punto`,
    ja: `\u{4EE5}\u{4E0A}`,
    ko: `\u{B05D}`,
    mww: `Lub Sij Hawm`,
    ps: `\u{628}\u{633}`,
    pt: `Ponto final`,
    'pt-pt': `Ponto final`,
    ru: `\u{422}\u{43E}\u{447}\u{43A}\u{430}`,
    sm: `Vaitaimi`,
    so: `Muddada`,
    th: `\u{E23}\u{E30}\u{E22}\u{E30}\u{E40}\u{E27}\u{E25}\u{E32}`,
    ur: `\u{62E}\u{62A}\u{645}`,
    vi: `Th\u{1EDD}i gian`,
    'zh-hans': `\u{5C31}\u{8FD9}\u{6837}`,
    'zh-hant': `\u{5C31}\u{9019}\u{6A23}`,
    en: `Period`
};
const $b11db1b62d4a8f76$export$bf95549dd21eca03 = {
    ar: `\u{627}\u{644}\u{62A}\u{635}\u{631}\u{64A}\u{62D} \u{627}\u{644}\u{645}\u{62C}\u{647}\u{648}\u{644}`,
    de: `Genehmigung anonym`,
    es: `Permiso an\xf3nimo`,
    fa: `\u{645}\u{62C}\u{648}\u{632} \u{646}\u{627}\u{634}\u{646}\u{627}\u{633}`,
    fil: `Pahintulutan na hindi nagpapakilala`,
    fr: `Permis anonyme`,
    hi: `\u{905}\u{928}\u{93E}\u{92E} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{926}\u{947}\u{902}`,
    ht: `P\xe8mi anonim`,
    it: `Permesso anonimo`,
    ja: `\u{8A31}\u{53EF}\u{8A3C}\u{306F}\u{533F}\u{540D}\u{3067}`,
    ko: `\u{C775}\u{BA85} \u{D5C8}\u{AC00}`,
    mww: `Tso cai tsis qhia npe`,
    ps: `\u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{627}\u{645}\u{647} \u{628}\u{6D0} \u{646}\u{648}\u{645}\u{647}`,
    pt: `Permiss\xe3o an\xf4nima`,
    'pt-pt': `Permiss\xe3o an\xf3nima`,
    ru: `\u{410}\u{43D}\u{43E}\u{43D}\u{438}\u{43C}\u{43D}\u{44B}\u{439} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{438}\u{442}\u{435}\u{43B}\u{44C}`,
    sm: `Fa'atagaina le le fa'ailoaina`,
    so: `Permit anonymous`,
    th: `\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}\u{E0A}\u{E37}\u{E48}\u{E2D}`,
    ur: `\u{67E}\u{631}\u{645}\u{679} \u{6AF}\u{645}\u{646}\u{627}\u{645}`,
    vi: `Cho ph\xe9p \u{1EA9}n danh`,
    'zh-hans': `\u{533F}\u{540D}\u{8BB8}\u{53EF}`,
    'zh-hant': `\u{8A31}\u{53EF}\u{533F}\u{540D}`,
    en: `Permit anonymous`
};
const $b11db1b62d4a8f76$export$f88a30428911aa95 = {
    ar: (cumulus)=>`\u{64A}\u{645}\u{643}\u{646} \u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{633}\u{645}\u{62D} \u{628}\u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{627}\u{644}\u{645}\u{62C}\u{647}\u{648}\u{644} \u{62F}\u{648}\u{646} \u{627}\u{631}\u{62A}\u{628}\u{627}\u{637} \u{628}\u{634}\u{62E}\u{635} \u{645}\u{633}\u{62C}\u{644} \u{641}\u{64A} ${cumulus}.`,
    de: (cumulus)=>`Frageb\xf6gen, die anonyme Einreise erlauben, k\xf6nnen ohne Zuordnung zu einer registrierten ${cumulus} eingetragen werden.`,
    es: (cumulus)=>`Los cuestionarios que permiten la entrada an\xf3nima pueden registrarse sin asociaci\xf3n con una persona registrada en ${cumulus}.`,
    fa: (cumulus)=>`\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647} \u{647}\u{627}\u{6CC}\u{6CC} \u{6A9}\u{647} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{648}\u{631}\u{648}\u{62F} \u{646}\u{627}\u{634}\u{646}\u{627}\u{633} \u{631}\u{627} \u{645}\u{6CC} \u{62F}\u{647}\u{646}\u{62F}\u{60C} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{646}\u{62F} \u{628}\u{62F}\u{648}\u{646} \u{627}\u{631}\u{62A}\u{628}\u{627}\u{637} \u{628}\u{627} \u{641}\u{631}\u{62F} \u{62B}\u{628}\u{62A} \u{634}\u{62F}\u{647} \u{62F}\u{631} ${cumulus} \u{62B}\u{628}\u{62A} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: (cumulus)=>`Ang mga questionnaire na nagpapahintulot sa hindi nagpapakilalang pagpasok ay maaaring maitala nang walang kaugnayan sa isang rehistradong tao sa ${cumulus}.`,
    fr: (cumulus)=>`Les questionnaires permettant l\u{2019}entr\xe9e anonyme peuvent \xeatre enregistr\xe9s sans association avec une personne enregistr\xe9e \xe0 ${cumulus}.`,
    hi: (cumulus)=>`\u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{93E}\u{935}\u{932}\u{940} \u{91C}\u{94B} \u{917}\u{941}\u{92E}\u{928}\u{93E}\u{92E} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{926}\u{947}\u{924}\u{940} \u{939}\u{948}, \u{909}\u{938}\u{947} ${cumulus} \u{92E}\u{947}\u{902} \u{90F}\u{915} \u{92A}\u{902}\u{91C}\u{940}\u{915}\u{943}\u{924} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{938}\u{902}\u{92C}\u{902}\u{927} \u{915}\u{947} \u{92C}\u{93F}\u{928}\u{93E} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (cumulus)=>`Kesyon\xe8 ki p\xe8m\xe8t antre anonim ka anrejistre san asosyasyon ak yon moun ki anrejistre nan ${cumulus}.`,
    it: (cumulus)=>`I questionari che consentono l'ingresso anonimo possono essere registrati senza associazione con una persona registrata a ${cumulus}.`,
    ja: (cumulus)=>`\u{533F}\u{540D}\u{53C2}\u{52A0}\u{3092}\u{8A31}\u{53EF}\u{3059}\u{308B}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}\u{306F}\u{3001} ${cumulus}\u{306B}\u{767B}\u{9332}\u{3055}\u{308C}\u{305F}\u{4EBA}\u{7269}\u{3068}\u{95A2}\u{4FC2}\u{306A}\u{304F}\u{8A18}\u{9332}\u{3059}\u{308B}\u{3053}\u{3068}\u{304C}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`,
    ko: (cumulus)=>`\u{C775}\u{BA85} \u{CC38}\u{C5EC}\u{AC00} \u{AC00}\u{B2A5}\u{D55C} \u{C124}\u{BB38}\u{C9C0}\u{B294} ${cumulus}\u{C5D0} \u{B4F1}\u{B85D}\u{B41C} \u{C0AC}\u{B78C}\u{ACFC} \u{C5F0}\u{AD00}\u{C5C6}\u{C774} \u{AE30}\u{B85D}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (cumulus)=>`Cov lus nug uas tso cai nkag mus tsis qhia npe tuaj yeem sau tseg yam tsis muaj kev koom tes nrog ib tus neeg sau npe hauv ${cumulus}.`,
    ps: (cumulus)=>`\u{647}\u{63A}\u{647} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647} \u{686}\u{6D0} \u{62F} \u{646}\u{627}\u{645}\u{639}\u{644}\u{648}\u{645} \u{62F}\u{627}\u{62E}\u{644}\u{6D0}\u{62F}\u{648} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{648}\u{631}\u{6A9}\u{648}\u{6CC}\u{60C} \u{67E}\u{631}\u{62A}\u{647} \u{644}\u{647} \u{62F}\u{6D0} \u{686}\u{6D0} ${cumulus} \u{6A9}\u{6D0} \u{644}\u{647} \u{62B}\u{628}\u{62A} \u{634}\u{648}\u{6CC} \u{6A9}\u{633} \u{633}\u{631}\u{647} \u{62A}\u{693}\u{627}\u{648} \u{648}\u{644}\u{631}\u{6CC}\u{60C} \u{62B}\u{628}\u{62A} \u{6A9}\u{6D0}\u{62F}\u{627}\u{6CC} \u{634}\u{6CC}.`,
    pt: (cumulus)=>`Question\xe1rios que permitem entrada an\xf4nima podem ser registrados sem associa\xe7\xe3o com uma pessoa registrada em ${cumulus}.`,
    'pt-pt': (cumulus)=>`Os question\xe1rios que permitem a entrada an\xf3nima podem ser registados sem associa\xe7\xe3o com uma pessoa registada em ${cumulus}.`,
    ru: (cumulus)=>`\u{410}\u{43D}\u{43A}\u{435}\u{442}\u{44B}, \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{430}\u{44E}\u{449}\u{438}\u{435} \u{430}\u{43D}\u{43E}\u{43D}\u{438}\u{43C}\u{43D}\u{44B}\u{439} \u{432}\u{445}\u{43E}\u{434}, \u{43C}\u{43E}\u{433}\u{443}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{44B} \u{431}\u{435}\u{437} \u{441}\u{432}\u{44F}\u{437}\u{438} \u{441} \u{437}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{43C} \u{43B}\u{438}\u{446}\u{43E}\u{43C} \u{432} ${cumulus}.`,
    sm: (cumulus)=>`O fesili e fa'atagaina ai le ulufale e le fa'ailoaina e mafai ona pu'eina e aunoa ma le feso'ota'iga ma se tagata lesitala i ${cumulus}.`,
    so: (cumulus)=>`Su'aalaha oggolaanaya gelitaanka magac la'aanta ah waa la diiwaan gelin karaa iyada oo aan la xiriirin qof diiwaangashan oo ku sugan ${cumulus}.`,
    th: (cumulus)=>`\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E42}\u{E14}\u{E22}\u{E44}\u{E21}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E44}\u{E14}\u{E49}\u{E42}\u{E14}\u{E22}\u{E44}\u{E21}\u{E48}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}\u{E17}\u{E35}\u{E48}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E43}\u{E19} ${cumulus}`,
    ur: (cumulus)=>`\u{648}\u{6C1} \u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6D2} \u{62C}\u{648} \u{6AF}\u{645}\u{646}\u{627}\u{645} \u{62F}\u{627}\u{62E}\u{644}\u{6D2} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{62F}\u{6CC}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{60C} ${cumulus} \u{645}\u{6CC}\u{6BA} \u{631}\u{62C}\u{633}\u{679}\u{631}\u{688} \u{634}\u{62E}\u{635} \u{633}\u{6D2} \u{648}\u{627}\u{628}\u{633}\u{62A}\u{6AF}\u{6CC} \u{6A9}\u{6D2} \u{628}\u{63A}\u{6CC}\u{631} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{6CC}\u{6D2} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (cumulus)=>`B\u{1EA3}ng c\xe2u h\u{1ECF}i cho ph\xe9p nh\u{1EAD}p c\u{1EA3}nh \u{1EA9}n danh c\xf3 th\u{1EC3} \u{111}\u{1B0}\u{1EE3}c ghi l\u{1EA1}i m\xe0 kh\xf4ng li\xean quan \u{111}\u{1EBF}n ng\u{1B0}\u{1EDD}i \u{111}\xe3 \u{111}\u{103}ng k\xfd trong ${cumulus}.`,
    'zh-hans': (cumulus)=>`\u{5141}\u{8BB8}\u{533F}\u{540D}\u{8BBF}\u{95EE}\u{7684}\u{95EE}\u{5377}\u{53EF}\u{4EE5}\u{5728}\u{4E0D}\u{4E0E} ${cumulus}\u{6CE8}\u{518C}\u{4EBA}\u{6709}\u{5173}\u{8054}\u{7684}\u{60C5}\u{51B5}\u{4E0B}\u{8FDB}\u{884C}\u{8BB0}\u{5F55}\u{3002}`,
    'zh-hant': (cumulus)=>`\u{5141}\u{8A31}\u{533F}\u{540D}\u{586B}\u{5BEB}\u{7684}\u{554F}\u{5377}\u{53EF}\u{5728} ${cumulus} \u{4E2D}\u{7121}\u{9700}\u{8207}\u{767B}\u{8A18}\u{4EBA}\u{6709}\u{95DC}\u{806F}\u{7684}\u{60C5}\u{6CC1}\u{4E0B}\u{9032}\u{884C}\u{8A18}\u{9304}\u{3002}`,
    en: (cumulus)=>`Questionnaires which permit anonymous entry can be recorded without association with a registered person in ${cumulus}.`
};
const $b11db1b62d4a8f76$export$e81e1f6da08081e8 = {
    ar: `\u{627}\u{644}\u{634}\u{62E}\u{635}\u{64A}\u{629}`,
    de: `Person`,
    es: `Persona`,
    fa: `\u{634}\u{62E}\u{635}`,
    fil: `Tao`,
    fr: `Personne`,
    hi: `\u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F}`,
    ht: `Moun`,
    it: `Persona`,
    ja: `\u{4EBA}\u{7269}`,
    ko: `\u{C778}\u{BB3C}`,
    mww: `neeg`,
    ps: `\u{634}\u{62E}\u{635}`,
    pt: `Pessoa`,
    'pt-pt': `Pessoa`,
    ru: `\u{41F}\u{435}\u{440}\u{441}\u{43E}\u{43D}\u{430}\u{436}`,
    sm: `Tagata`,
    so: `Qof`,
    th: `\u{E04}\u{E19}`,
    ur: `\u{634}\u{62E}\u{635}`,
    vi: `Ng\u{1B0}\u{1EDD}i`,
    'zh-hans': `\u{4EBA}\u{7269}`,
    'zh-hant': `\u{4EBA}\u{7269}`,
    en: `Person`
};
const $b11db1b62d4a8f76$export$b0c7d0e1aa59ce97 = {
    ar: `\u{631}\u{633}\u{627}\u{644}\u{629} \u{634}\u{62E}\u{635}\u{64A}\u{629}`,
    de: `Pers\xf6nliche Botschaft`,
    es: `Mensaje personal`,
    fa: `\u{67E}\u{6CC}\u{627}\u{645} \u{634}\u{62E}\u{635}\u{6CC}`,
    fil: `Personal na mensahe`,
    fr: `Message personnel`,
    hi: `\u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F}\u{917}\u{924} \u{938}\u{902}\u{926}\u{947}\u{936}`,
    ht: `Mesaj p\xe8son\xe8l`,
    it: `Messaggio personale`,
    ja: `\u{500B}\u{4EBA}\u{7684}\u{306A}\u{30E1}\u{30C3}\u{30BB}\u{30FC}\u{30B8}`,
    ko: `\u{AC1C}\u{C778} \u{BA54}\u{C2DC}\u{C9C0}`,
    mww: `Cov lus ntawm tus kheej`,
    ps: `\u{634}\u{62E}\u{635}\u{6CC} \u{67E}\u{6CC}\u{63A}\u{627}\u{645}`,
    pt: `Mensagem pessoal`,
    'pt-pt': `Mensagem pessoal`,
    ru: `\u{41B}\u{438}\u{447}\u{43D}\u{43E}\u{435} \u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Savali patino`,
    so: `Fariin shaqsi ah`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E2A}\u{E48}\u{E27}\u{E19}\u{E15}\u{E31}\u{E27}`,
    ur: `\u{630}\u{627}\u{62A}\u{6CC} \u{67E}\u{6CC}\u{63A}\u{627}\u{645}`,
    vi: `Tin nh\u{1EAF}n c\xe1 nh\xe2n`,
    'zh-hans': `\u{4E2A}\u{4EBA}\u{7559}\u{8A00}`,
    'zh-hant': `\u{500B}\u{4EBA}\u{8A0A}\u{606F}`,
    en: `Personal message`
};
const $b11db1b62d4a8f76$export$271b9858e6eb4f93 = {
    ar: `\u{631}\u{633}\u{627}\u{644}\u{629} \u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631}\u{64A}\u{629} \u{644}\u{62A}\u{636}\u{645}\u{64A}\u{646}\u{647}\u{627} \u{641}\u{64A} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{625}\u{644}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{645}\u{648}\u{642}\u{639}.`,
    de: `Optionale Nachricht, die in die E-Mail an diesen Unterzeichner aufgenommen werden kann.`,
    es: `Mensaje opcional para incluir en el correo electr\xf3nico a este firmante.`,
    fa: `\u{67E}\u{6CC}\u{627}\u{645} \u{627}\u{62E}\u{62A}\u{6CC}\u{627}\u{631}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{62F}\u{631}\u{62C} \u{62F}\u{631} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{627}\u{645}\u{636}\u{627} \u{6A9}\u{646}\u{646}\u{62F}\u{647}.`,
    fil: `Opsyonal na mensahe na isama sa email sa lumagda na ito.`,
    fr: `Message optionnel \xe0 inclure dans l\u{2019}email \xe0 ce signataire.`,
    hi: `\u{907}\u{938} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930}\u{915}\u{930}\u{94D}\u{924}\u{93E} \u{915}\u{94B} \u{908}\u{92E}\u{947}\u{932} \u{92E}\u{947}\u{902} \u{936}\u{93E}\u{92E}\u{93F}\u{932} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{935}\u{948}\u{915}\u{932}\u{94D}\u{92A}\u{93F}\u{915} \u{938}\u{902}\u{926}\u{947}\u{936}.`,
    ht: `Si ou vle mesaj yo enkli nan im\xe8l la bay siyen sa a.`,
    it: `Messaggio opzionale da includere nell'email a questo firmatario.`,
    ja: `\u{3053}\u{306E}\u{7F72}\u{540D}\u{8005}\u{3078}\u{306E}\u{30E1}\u{30FC}\u{30EB}\u{306B}\u{542B}\u{3081}\u{308B}\u{4EFB}\u{610F}\u{306E}\u{30E1}\u{30C3}\u{30BB}\u{30FC}\u{30B8}\u{3067}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{C11C}\u{BA85}\u{C790}\u{C5D0}\u{AC8C} \u{BCF4}\u{B0B4}\u{B294} \u{C774}\u{BA54}\u{C77C}\u{C5D0} \u{D3EC}\u{D568}\u{D560} \u{C218} \u{C788}\u{B294} \u{C120}\u{D0DD}\u{C801} \u{BA54}\u{C2DC}\u{C9C0}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Yeem cov lus kom suav nrog hauv email rau tus neeg kos npe no.`,
    ps: `\u{627}\u{62E}\u{62A}\u{6CC}\u{627}\u{631}\u{6CC} \u{67E}\u{6CC}\u{63A}\u{627}\u{645} \u{686}\u{6D0} \u{67E}\u{647} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{6A9}\u{6D0} \u{62F}\u{6D0} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{62A}\u{647} \u{634}\u{627}\u{645}\u{644} \u{634}\u{6CC}.`,
    pt: `Mensagem opcional para incluir no e-mail para este signat\xe1rio.`,
    'pt-pt': `Mensagem opcional a incluir no email para este signat\xe1rio.`,
    ru: `\u{41D}\u{435}\u{43E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{435} \u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{43B}\u{44F} \u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{44F} \u{432} \u{43F}\u{438}\u{441}\u{44C}\u{43C}\u{43E} \u{44D}\u{442}\u{43E}\u{43C}\u{443} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{442}\u{443}.`,
    sm: `Savali e filifili ai e aofia ai i le imeli i le tagata saini lenei.`,
    so: `Fariin ikhtiyaari ah oo lagu dari karo email-ka saxiixaha.`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E1A}\u{E31}\u{E07}\u{E04}\u{E31}\u{E1A}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E23}\u{E27}\u{E21}\u{E44}\u{E27}\u{E49}\u{E43}\u{E19}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E16}\u{E36}\u{E07}\u{E1C}\u{E39}\u{E49}\u{E25}\u{E07}\u{E19}\u{E32}\u{E21}\u{E23}\u{E32}\u{E22}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{646}\u{646}\u{62F}\u{6C1} \u{6A9}\u{648} \u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{645}\u{6CC}\u{6BA} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{62E}\u{62A}\u{6CC}\u{627}\u{631}\u{6CC} \u{67E}\u{6CC}\u{63A}\u{627}\u{645}\u{6D4}`,
    vi: `Tin nh\u{1EAF}n t\xf9y ch\u{1ECD}n \u{111}\u{1EC3} \u{111}\u{1B0}a v\xe0o email cho ng\u{1B0}\u{1EDD}i k\xfd n\xe0y.`,
    'zh-hans': `\u{53D1}\u{7ED9}\u{8BE5}\u{7B7E}\u{7F72}\u{4EBA}\u{7684}\u{90AE}\u{4EF6}\u{4E2D}\u{53EF}\u{9644}\u{7684}\u{53EF}\u{9009}\u{4FE1}\u{606F}\u{3002}`,
    'zh-hant': `\u{8ACB}\u{5728}\u{5BC4}\u{7D66}\u{6B64}\u{7C3D}\u{7F72}\u{4EBA}\u{7684}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{4E2D}\u{9644}\u{4E0A}\u{53EF}\u{9078}\u{8A0A}\u{606F}\u{3002}`,
    en: `Optional message to include in the email to this signer.`
};
const $b11db1b62d4a8f76$export$f04072ad92ec82d0 = {
    ar: `\u{627}\u{644}\u{639}\u{644}\u{627}\u{642}\u{629} \u{627}\u{644}\u{634}\u{62E}\u{635}\u{64A}\u{629}`,
    de: `Personenbeziehung`,
    es: `Relaci\xf3n con la persona`,
    fa: `\u{631}\u{627}\u{628}\u{637}\u{647} \u{641}\u{631}\u{62F}\u{6CC}`,
    fil: `Relasyon ng tao`,
    fr: `Relation avec la personne`,
    hi: `\u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F} \u{938}\u{902}\u{92C}\u{902}\u{927}`,
    ht: `Relasyon moun`,
    it: `Relazione con la persona`,
    ja: `\u{4EBA}\u{9593}\u{95A2}\u{4FC2}`,
    ko: `\u{C778}\u{BB3C} \u{AD00}\u{ACC4}`,
    mww: `Kev sib raug zoo ntawm tus neeg`,
    ps: `\u{634}\u{62E}\u{635}\u{6CC} \u{627}\u{693}\u{6CC}\u{6A9}\u{647}`,
    pt: `Relacionamento entre pessoas`,
    'pt-pt': `Rela\xe7\xe3o com a pessoa`,
    ru: `\u{41B}\u{438}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{43D}\u{44B}\u{435} \u{43E}\u{442}\u{43D}\u{43E}\u{448}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Sootaga a le tagata`,
    so: `Xiriirka shaqsiga`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E2A}\u{E31}\u{E21}\u{E1E}\u{E31}\u{E19}\u{E18}\u{E4C}\u{E02}\u{E2D}\u{E07}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}`,
    ur: `\u{634}\u{62E}\u{635}\u{6CC} \u{62A}\u{639}\u{644}\u{642}`,
    vi: `M\u{1ED1}i quan h\u{1EC7} con ng\u{1B0}\u{1EDD}i`,
    'zh-hans': `\u{4EBA}\u{9645}\u{5173}\u{7CFB}`,
    'zh-hant': `\u{4EBA}\u{8207}\u{4EBA}\u{95DC}\u{4FC2}`,
    en: `Person relationship`
};
const $b11db1b62d4a8f76$export$cc63ffe88c29fbfb = {
    ar: `\u{633}\u{62C}\u{644} \u{64A}\u{62B}\u{628}\u{62A} \u{627}\u{644}\u{639}\u{644}\u{627}\u{642}\u{629} \u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629} \u{639}\u{644}\u{649} \u{627}\u{644}\u{62F}\u{648}\u{631} \u{628}\u{64A}\u{646} \u{634}\u{62E}\u{635}\u{64A}\u{646}\u{60C} \u{645}\u{62B}\u{644} \u{645}\u{642}\u{62F}\u{645} \u{627}\u{644}\u{631}\u{639}\u{627}\u{64A}\u{629} \u{648}\u{645}\u{62A}\u{644}\u{642}\u{64A} \u{627}\u{644}\u{631}\u{639}\u{627}\u{64A}\u{629} \u{623}\u{648} \u{627}\u{644}\u{645}\u{648}\u{638}\u{641} \u{648}\u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644}.`,
    de: `Ein Dokument, das die rollenbasierte Beziehung zwischen zwei Personen festlegt, wie etwa Pflegeperson und Pflegeempf\xe4nger oder Arbeitnehmer und Arbeitgeber.`,
    es: `Un registro que establezca la relaci\xf3n basada en el rol entre dos personas, como cuidador y beneficiario de cuidado o empleado y empleador.`,
    fa: `\u{6CC}\u{6A9} \u{633}\u{627}\u{628}\u{642}\u{647} \u{6A9}\u{647} \u{631}\u{627}\u{628}\u{637}\u{647} \u{645}\u{628}\u{62A}\u{646}\u{6CC} \u{628}\u{631} \u{646}\u{642}\u{634} \u{628}\u{6CC}\u{646} \u{62F}\u{648} \u{641}\u{631}\u{62F}\u{60C} \u{645}\u{627}\u{646}\u{646}\u{62F} \u{645}\u{631}\u{627}\u{642}\u{628} \u{648} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647} \u{645}\u{631}\u{627}\u{642}\u{628}\u{62A} \u{6CC}\u{627} \u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F} \u{648} \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627} \u{631}\u{627} \u{627}\u{62B}\u{628}\u{627}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F}.`,
    fil: `Isang talaan na nagtatatag ng relasyon na nakabatay sa papel sa pagitan ng dalawang indibidwal, tulad ng tagapag-alaga at tatanggap ng pangangalaga o empleyado at employer.`,
    fr: `Un document \xe9tablissant la relation bas\xe9e sur le r\xf4le entre deux individus, tels que l\u{2019}aidant et le b\xe9n\xe9ficiaire de soins ou l\u{2019}employ\xe9 et l\u{2019}employeur.`,
    hi: `\u{926}\u{94B} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F}\u{92F}\u{94B}\u{902}, \u{91C}\u{948}\u{938}\u{947} \u{926}\u{947}\u{916}\u{92D}\u{93E}\u{932} \u{915}\u{930}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{914}\u{930} \u{926}\u{947}\u{916}\u{92D}\u{93E}\u{932} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924}\u{915}\u{930}\u{94D}\u{924}\u{93E} \u{92F}\u{93E} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{914}\u{930} \u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{915}\u{947} \u{92C}\u{940}\u{91A} \u{92D}\u{942}\u{92E}\u{93F}\u{915}\u{93E}-\u{906}\u{927}\u{93E}\u{930}\u{93F}\u{924} \u{938}\u{902}\u{92C}\u{902}\u{927} \u{938}\u{94D}\u{925}\u{93E}\u{92A}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{93E} \u{90F}\u{915} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921}\u{964}`,
    ht: `Yon dosye ki etabli relasyon ki baze sou w\xf2l ant de moun, tankou moun kap bay swen ak moun k ap resevwa swen oswa anplwaye ak anplway\xe8.`,
    it: `Un documento che attesti la relazione basata sul ruolo tra due individui, come caregiver e beneficiario di assistenza o dipendente e datore di lavoro.`,
    ja: `\u{4ECB}\u{8B77}\u{8005}\u{3068}\u{4ECB}\u{8B77}\u{3092}\u{53D7}\u{3051}\u{308B}\u{8005}\u{3001}\u{307E}\u{305F}\u{306F}\u{5F93}\u{696D}\u{54E1}\u{3068}\u{96C7}\u{7528}\u{4E3B}\u{306A}\u{3069}\u{3001}\u{4E8C}\u{4EBA}\u{306E}\u{500B}\u{4EBA}\u{3068}\u{306E}\u{5F79}\u{5272}\u{306B}\u{57FA}\u{3065}\u{304F}\u{95A2}\u{4FC2}\u{3092}\u{78BA}\u{7ACB}\u{3059}\u{308B}\u{8A18}\u{9332}\u{3002}`,
    ko: `\u{BCF4}\u{D638}\u{C790}\u{C640} \u{BCF4}\u{D638}\u{C790} \u{B610}\u{B294} \u{C9C1}\u{C6D0}\u{ACFC} \u{ACE0}\u{C6A9}\u{C8FC} \u{B4F1} \u{B450} \u{AC1C}\u{C778} \u{AC04}\u{C758} \u{C5ED}\u{D560} \u{AE30}\u{BC18} \u{AD00}\u{ACC4}\u{B97C} \u{D655}\u{B9BD}\u{D558}\u{B294} \u{AE30}\u{B85D}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib daim ntaub ntawv teev tseg txog kev sib raug zoo ntawm ob tug neeg, xws li tus neeg saib xyuas thiab tus neeg tau txais kev saib xyuas lossis tus neeg ua hauj lwm thiab chaw ua hauj lwm.`,
    ps: `\u{6CC}\u{648} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{686}\u{6D0} \u{62F} \u{62F}\u{648}\u{648} \u{627}\u{641}\u{631}\u{627}\u{62F}\u{648} \u{62A}\u{631}\u{645}\u{646}\u{681} \u{62F} \u{631}\u{648}\u{644} \u{67E}\u{631} \u{628}\u{646}\u{633}\u{67C} \u{627}\u{693}\u{6CC}\u{6A9}\u{647} \u{62B}\u{627}\u{628}\u{62A}\u{648}\u{6CC}\u{60C} \u{644}\u{6A9}\u{647} \u{62F} \u{67E}\u{627}\u{645}\u{644}\u{631}\u{646}\u{6D0} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{627}\u{648} \u{67E}\u{627}\u{645}\u{644}\u{631}\u{646}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{6CC}\u{627} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{627}\u{648} \u{6A9}\u{627}\u{631}\u{6AB}\u{645}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC}.`,
    pt: `Um registro que estabele\xe7a a rela\xe7\xe3o baseada em fun\xe7\xf5es entre dois indiv\xedduos, como cuidador e benefici\xe1rio de cuidados ou empregado e empregador.`,
    'pt-pt': `Um registo que estabelece a rela\xe7\xe3o baseada no papel entre dois indiv\xedduos, como cuidador e benefici\xe1rio de cuidados ou empregado e empregador.`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C}, \u{443}\u{441}\u{442}\u{430}\u{43D}\u{430}\u{432}\u{43B}\u{438}\u{432}\u{430}\u{44E}\u{449}\u{430}\u{44F} \u{440}\u{43E}\u{43B}\u{435}\u{432}\u{44B}\u{435} \u{43E}\u{442}\u{43D}\u{43E}\u{448}\u{435}\u{43D}\u{438}\u{44F} \u{43C}\u{435}\u{436}\u{434}\u{443} \u{434}\u{432}\u{443}\u{43C}\u{44F} \u{43B}\u{44E}\u{434}\u{44C}\u{43C}\u{438}, \u{442}\u{430}\u{43A}\u{438}\u{43C}\u{438} \u{43A}\u{430}\u{43A} \u{43E}\u{43F}\u{435}\u{43A}\u{443}\u{43D} \u{438} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{442}\u{435}\u{43B}\u{44C} \u{43E}\u{43F}\u{435}\u{43A}\u{443}\u{43D}\u{44B} \u{438}\u{43B}\u{438} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A} \u{438} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44C}.`,
    sm: `O se fa'amaumauga e fa'amautuina ai le sootaga fa'avae i le va o tagata e to'alua, e pei o le tagata tausi ma le tagata e mauaina le tausiga po'o le tagata faigaluega ma le kamupani.`,
    so: `Diiwaan muujinaya xiriirka ku saleysan doorka u dhexeeya laba qof, sida daryeelaha iyo qaataha daryeelka ama shaqaale iyo shaqo-bixiye.`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E04}\u{E27}\u{E32}\u{E21}\u{E2A}\u{E31}\u{E21}\u{E1E}\u{E31}\u{E19}\u{E18}\u{E4C}\u{E15}\u{E32}\u{E21}\u{E1A}\u{E17}\u{E1A}\u{E32}\u{E17}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}\u{E2A}\u{E2D}\u{E07}\u{E04}\u{E19} \u{E40}\u{E0A}\u{E48}\u{E19} \u{E1C}\u{E39}\u{E49}\u{E14}\u{E39}\u{E41}\u{E25}\u{E41}\u{E25}\u{E30}\u{E1C}\u{E39}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E14}\u{E39}\u{E41}\u{E25} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E25}\u{E39}\u{E01}\u{E08}\u{E49}\u{E32}\u{E07}\u{E41}\u{E25}\u{E30}\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{62C}\u{648} \u{62F}\u{648} \u{627}\u{641}\u{631}\u{627}\u{62F}\u{60C} \u{62C}\u{6CC}\u{633}\u{6D2} \u{646}\u{6AF}\u{6C1}\u{62F}\u{627}\u{634}\u{62A} \u{6A9}\u{631}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{627}\u{60C} \u{62F}\u{6CC}\u{6A9}\u{6BE} \u{628}\u{6BE}\u{627}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{627}\u{60C} \u{6CC}\u{627} \u{645}\u{644}\u{627}\u{632}\u{645} \u{627}\u{648}\u{631} \u{622}\u{62C}\u{631} \u{6A9}\u{6D2} \u{62F}\u{631}\u{645}\u{6CC}\u{627}\u{646} \u{6A9}\u{631}\u{62F}\u{627}\u{631} \u{67E}\u{631} \u{645}\u{628}\u{646}\u{6CC} \u{62A}\u{639}\u{644}\u{642} \u{642}\u{627}\u{626}\u{645} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `H\u{1ED3} s\u{1A1} thi\u{1EBF}t l\u{1EAD}p m\u{1ED1}i quan h\u{1EC7} d\u{1EF1}a tr\xean vai tr\xf2 gi\u{1EEF}a hai c\xe1 nh\xe2n, ch\u{1EB3}ng h\u{1EA1}n nh\u{1B0} ng\u{1B0}\u{1EDD}i ch\u{103}m s\xf3c v\xe0 ng\u{1B0}\u{1EDD}i nh\u{1EAD}n ch\u{103}m s\xf3c ho\u{1EB7}c nh\xe2n vi\xean v\xe0 ch\u{1EE7} lao \u{111}\u{1ED9}ng.`,
    'zh-hans': `\u{5EFA}\u{7ACB}\u{4E24}\u{4E2A}\u{4EBA}\u{4E4B}\u{95F4}\u{57FA}\u{4E8E}\u{89D2}\u{8272}\u{7684}\u{5173}\u{7CFB}\u{7684}\u{8BB0}\u{5F55}\u{FF0C}\u{4F8B}\u{5982}\u{7167}\u{62A4}\u{8005}\u{4E0E}\u{7167}\u{62A4}\u{8005}\u{FF0C}\u{6216}\u{96C7}\u{5458}\u{4E0E}\u{96C7}\u{4E3B}\u{3002}`,
    'zh-hant': `\u{5EFA}\u{7ACB}\u{5169}\u{500B}\u{4EBA}\u{4E4B}\u{9593}\u{57FA}\u{65BC}\u{89D2}\u{8272}\u{7684}\u{95DC}\u{4FC2}\u{7D00}\u{9304}\u{FF0C}\u{4F8B}\u{5982}\u{7167}\u{8B77}\u{8005}\u{8207}\u{7167}\u{8B77}\u{8005}\u{FF0C}\u{6216}\u{54E1}\u{5DE5}\u{8207}\u{96C7}\u{4E3B}\u{3002}`,
    en: `A record establishing the role-based relationship between two individuals, such as caregiver and care recipient or employee and employer.`
};
const $b11db1b62d4a8f76$export$90a412476a587834 = {
    ar: `\u{627}\u{644}\u{62F}\u{64A}\u{645}\u{648}\u{63A}\u{631}\u{627}\u{641}\u{64A}\u{627}\u{60C} \u{627}\u{644}\u{639}\u{646}\u{627}\u{648}\u{64A}\u{646}\u{60C} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}\u{60C} \u{648}\u{627}\u{644}\u{647}\u{648}\u{627}\u{62A}\u{641}.`,
    de: `Demografie, Adressen, E-Mails und Telefone.`,
    es: `Demograf\xeda, direcciones, correos electr\xf3nicos y tel\xe9fonos.`,
    fa: `\u{62C}\u{645}\u{639}\u{6CC}\u{62A} \u{634}\u{646}\u{627}\u{633}\u{6CC}\u{60C} \u{622}\u{62F}\u{631}\u{633} \u{647}\u{627}\u{60C} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{647}\u{627} \u{648} \u{62A}\u{644}\u{641}\u{646} \u{647}\u{627}.`,
    fil: `Demograpiko, address, email, at telepono.`,
    fr: `D\xe9mographie, adresses, e-mails et t\xe9l\xe9phones.`,
    hi: `\u{91C}\u{928}\u{938}\u{93E}\u{902}\u{916}\u{94D}\u{92F}\u{93F}\u{915}\u{940}, \u{92A}\u{924}\u{947}, \u{908}\u{92E}\u{947}\u{932} \u{914}\u{930} \u{92B}\u{94B}\u{928}\u{964}`,
    ht: `Demografik, adr\xe8s, im\xe8l, ak telef\xf2n.`,
    it: `Demografia, indirizzi, email e telefoni.`,
    ja: `\u{4EBA}\u{53E3}\u{7D71}\u{8A08}\u{3001}\u{4F4F}\u{6240}\u{3001}\u{30E1}\u{30FC}\u{30EB}\u{3001}\u{96FB}\u{8A71}\u{756A}\u{53F7}\u{3002}`,
    ko: `\u{C778}\u{AD6C} \u{D1B5}\u{ACC4}, \u{C8FC}\u{C18C}, \u{C774}\u{BA54}\u{C77C}, \u{C804}\u{D654}\u{BC88}\u{D638} \u{B4F1}.`,
    mww: `Cov pej xeem, chaw nyob, email thiab xov tooj.`,
    ps: `\u{689}\u{6CC}\u{645}\u{648}\u{6AB}\u{631}\u{627}\u{641}\u{6CC}\u{60C} \u{67E}\u{62A}\u{647}\u{60C} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}\u{648}\u{646}\u{647}\u{60C} \u{627}\u{648} \u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646}\u{648}\u{646}\u{647}.`,
    pt: `Demografia, endere\xe7os, e-mails e telefones.`,
    'pt-pt': `Demografia, moradas, emails e telefones.`,
    ru: `\u{414}\u{435}\u{43C}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{44F}, \u{430}\u{434}\u{440}\u{435}\u{441}\u{430}, \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{430}\u{44F} \u{43F}\u{43E}\u{447}\u{442}\u{430} \u{438} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{44B}.`,
    sm: `Faitau aofai o tagata, tuatusi, imeli, ma telefoni.`,
    so: `Tirakoobka, cinwaanada, emailada, iyo telefoonada.`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E1B}\u{E23}\u{E30}\u{E0A}\u{E32}\u{E01}\u{E23} \u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48} \u{E2D}\u{E35}\u{E40}\u{E21}\u{E25} \u{E41}\u{E25}\u{E30}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}`,
    ur: `\u{622}\u{628}\u{627}\u{62F}\u{6CC}\u{627}\u{62A}\u{60C} \u{67E}\u{62A}\u{6D2}\u{60C} \u{627}\u{6CC} \u{645}\u{6CC}\u{644}\u{632}\u{60C} \u{627}\u{648}\u{631} \u{641}\u{648}\u{646}\u{632}\u{6D4}`,
    vi: `Nh\xe2n kh\u{1EA9}u h\u{1ECD}c, \u{111}\u{1ECB}a ch\u{1EC9}, email v\xe0 \u{111}i\u{1EC7}n tho\u{1EA1}i.`,
    'zh-hans': `\u{4EBA}\u{53E3}\u{7EDF}\u{8BA1}\u{3001}\u{5730}\u{5740}\u{3001}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{548C}\u{7535}\u{8BDD}\u{3002}`,
    'zh-hant': `\u{4EBA}\u{53E3}\u{7D71}\u{8A08}\u{3001}\u{5730}\u{5740}\u{3001}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{548C}\u{96FB}\u{8A71}\u{3002}`,
    en: `Demographics, addresses, emails, and phones.`
};
const $b11db1b62d4a8f76$export$a70d58ffe5e7000d = {
    ar: `\u{627}\u{644}\u{647}\u{627}\u{62A}\u{641}`,
    de: `Telefon`,
    es: `Tel\xe9fono`,
    fa: `\u{62A}\u{644}\u{641}\u{646}`,
    fil: `Telepono`,
    fr: `T\xe9l\xe9phone`,
    hi: `\u{92B}\u{93C}\u{94B}\u{928}`,
    ht: `Telef\xf2n`,
    it: `Telefono`,
    ja: `\u{96FB}\u{8A71}`,
    ko: `\u{C804}\u{D654}`,
    mww: `Xov tooj`,
    ps: `\u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646}`,
    pt: `Telefone`,
    'pt-pt': `Telefone`,
    ru: `\u{422}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}`,
    sm: `Telefoni`,
    so: `Telefoon`,
    th: `\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}`,
    ur: `\u{641}\u{648}\u{646}`,
    vi: `\u{110}i\u{1EC7}n tho\u{1EA1}i`,
    'zh-hans': `\u{7535}\u{8BDD}`,
    'zh-hant': `\u{96FB}\u{8A71}`,
    en: `Phone`
};
const $b11db1b62d4a8f76$export$271900c637039020 = {
    ar: `\u{631}\u{642}\u{645} \u{627}\u{644}\u{647}\u{627}\u{62A}\u{641}`,
    de: `Telefonnummer`,
    es: `N\xfamero de tel\xe9fono`,
    fa: `\u{634}\u{645}\u{627}\u{631}\u{647} \u{62A}\u{644}\u{641}\u{646}`,
    fil: `Numero ng telepono`,
    fr: `Num\xe9ro de t\xe9l\xe9phone`,
    hi: `\u{92B}\u{94B}\u{928} \u{938}\u{902}\u{916}\u{94D}\u{92F}\u{93E}`,
    ht: `Nimewo telef\xf2n`,
    it: `Numero di telefono`,
    ja: `\u{96FB}\u{8A71}\u{756A}\u{53F7}`,
    ko: `\u{C804}\u{D654}\u{BC88}\u{D638}`,
    mww: `Tus xov tooj`,
    ps: `\u{62F} \u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646} \u{634}\u{645}\u{6D0}\u{631}\u{647}`,
    pt: `N\xfamero de telefone`,
    'pt-pt': `N\xfamero de telefone`,
    ru: `\u{41D}\u{43E}\u{43C}\u{435}\u{440} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{430}`,
    sm: `Numera o le telefoni`,
    so: `Lambarka telefoonka`,
    th: `\u{E2B}\u{E21}\u{E32}\u{E22}\u{E40}\u{E25}\u{E02}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}`,
    ur: `\u{641}\u{648}\u{646} \u{646}\u{645}\u{628}\u{631}`,
    vi: `S\u{1ED1} \u{111}i\u{1EC7}n tho\u{1EA1}i`,
    'zh-hans': `\u{7535}\u{8BDD}\u{53F7}\u{7801}`,
    'zh-hant': `\u{96FB}\u{8A71}\u{865F}\u{78BC}`,
    en: `Phone number`
};
const $b11db1b62d4a8f76$export$97029ce3bcf4d498 = {
    ar: `\u{627}\u{644}\u{647}\u{648}\u{627}\u{62A}\u{641}`,
    de: `Telefone`,
    es: `Tel\xe9fonos`,
    fa: `\u{62A}\u{644}\u{641}\u{646} \u{647}\u{627}`,
    fil: `Mga Telepono`,
    fr: `T\xe9l\xe9phones`,
    hi: `\u{92B}\u{93C}\u{94B}\u{928}`,
    ht: `Telef\xf2n yo`,
    it: `Telefoni`,
    ja: `\u{96FB}\u{8A71}`,
    ko: `\u{C804}\u{D654}\u{AE30}`,
    mww: `Cov xov tooj`,
    ps: `\u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646}\u{648}\u{646}\u{647}`,
    pt: `Telefones`,
    'pt-pt': `Telem\xf3veis`,
    ru: `\u{422}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{44B}`,
    sm: `Telefoni`,
    so: `Telefoonada`,
    th: `\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}`,
    ur: `\u{641}\u{648}\u{646}\u{632}`,
    vi: `\u{110}i\u{1EC7}n tho\u{1EA1}i`,
    'zh-hans': `\u{7535}\u{8BDD}`,
    'zh-hant': `\u{96FB}\u{8A71}`,
    en: `Phones`
};
const $b11db1b62d4a8f76$export$f3aeac60053b3d5 = {
    ar: `\u{627}\u{644}\u{647}\u{627}\u{62A}\u{641} (SMS)`,
    de: `Telefon (SMS)`,
    es: `Tel\xe9fono (SMS)`,
    fa: `\u{62A}\u{644}\u{641}\u{646} (\u{67E}\u{6CC}\u{627}\u{645}\u{6A9})`,
    fil: `Telepono (SMS)`,
    fr: `T\xe9l\xe9phone (SMS)`,
    hi: `\u{92B}\u{94B}\u{928} (\u{90F}\u{938}\u{90F}\u{92E}\u{90F}\u{938})`,
    ht: `Telef\xf2n (SMS)`,
    it: `Telefono (SMS)`,
    ja: `\u{96FB}\u{8A71}(SMS)`,
    ko: `\u{C804}\u{D654} (SMS)`,
    mww: `Xov tooj (SMS)`,
    ps: `\u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646} (SMS)`,
    pt: `Telefone (SMS)`,
    'pt-pt': `Telefone (SMS)`,
    ru: `\u{422}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D} (SMS)`,
    sm: `Telefoni (SMS)`,
    so: `Telefoon (SMS)`,
    th: `\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C} (SMS)`,
    ur: `\u{641}\u{648}\u{646} (\u{627}\u{6CC}\u{633} \u{627}\u{6CC}\u{645} \u{627}\u{6CC}\u{633})`,
    vi: `\u{110}i\u{1EC7}n tho\u{1EA1}i (SMS)`,
    'zh-hans': `\u{7535}\u{8BDD}\u{FF08}\u{77ED}\u{4FE1}\u{FF09}`,
    'zh-hant': `\u{96FB}\u{8A71}\u{FF08}\u{7C21}\u{8A0A}\u{FF09}`,
    en: `Phone (SMS)`
};
const $b11db1b62d4a8f76$export$9b9ce1ed1bbddcb8 = {
    ar: `\u{627}\u{644}\u{62C}\u{633}\u{62F}\u{64A}\u{629}`,
    de: `Physisch`,
    es: `F\xedsico`,
    fa: `\u{627}\u{632} \u{646}\u{638}\u{631} \u{641}\u{6CC}\u{632}\u{6CC}\u{6A9}\u{6CC}`,
    fil: `Pisikal`,
    fr: `Physique`,
    hi: `\u{92D}\u{94C}\u{924}\u{93F}\u{915}`,
    ht: `Fizik`,
    it: `Fisica`,
    ja: `\u{7269}\u{7406}\u{7684}`,
    ko: `\u{C2E0}\u{CCB4}`,
    mww: `Lub cev nqaij daim tawv`,
    ps: `\u{641}\u{632}\u{6CC}\u{6A9}\u{6CC}`,
    pt: `F\xedsico`,
    'pt-pt': `F\xedsico`,
    ru: `\u{424}\u{438}\u{437}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{435} \u{445}\u{430}\u{440}\u{430}\u{43A}\u{442}\u{435}\u{440}\u{438}\u{441}\u{442}\u{438}\u{43A}\u{438}`,
    sm: `Faaletino`,
    so: `Jirka`,
    th: `\u{E17}\u{E32}\u{E07}\u{E01}\u{E32}\u{E22}\u{E20}\u{E32}\u{E1E}`,
    ur: `\u{62C}\u{633}\u{645}\u{627}\u{646}\u{6CC}`,
    vi: `V\u{1EAD}t l\xfd`,
    'zh-hans': `\u{7269}\u{7406}`,
    'zh-hant': `\u{7269}\u{7406}`,
    en: `Physical`
};
const $b11db1b62d4a8f76$export$b8ebd0c3b299fb5c = {
    ar: `\u{645}\u{648}\u{642}\u{639} \u{627}\u{644}\u{631}\u{635}\u{64A}\u{641}`,
    de: `Plattformstandort`,
    es: `Emplazamiento del and\xe9n`,
    fa: `\u{645}\u{62D}\u{644} \u{633}\u{6A9}\u{648}\u{647}\u{627}`,
    fil: `Site ng Platform`,
    fr: `Site du quai`,
    hi: `\u{92A}\u{94D}\u{932}\u{947}\u{91F}\u{92B}\u{93E}\u{930}\u{94D}\u{92E} \u{938}\u{93E}\u{907}\u{91F}`,
    ht: `Sit platf\xf2m`,
    it: `Sito della banchina`,
    ja: `\u{30D7}\u{30E9}\u{30C3}\u{30C8}\u{30D5}\u{30A9}\u{30FC}\u{30E0}\u{30B5}\u{30A4}\u{30C8}`,
    ko: `\u{D50C}\u{B7AB}\u{D3FC} \u{C0AC}\u{C774}\u{D2B8}`,
    mww: `Platform site`,
    ps: `\u{62F} \u{67E}\u{644}\u{627}\u{62A}\u{641}\u{648}\u{631}\u{645} \u{681}\u{627}\u{6CC}`,
    pt: `Site da plataforma`,
    'pt-pt': `Site da plataforma`,
    ru: `\u{41F}\u{43B}\u{43E}\u{449}\u{430}\u{434}\u{43A}\u{430} \u{43F}\u{43B}\u{430}\u{442}\u{444}\u{43E}\u{440}\u{43C}\u{44B}`,
    sm: `Nofoaga o le tulaga`,
    so: `Goobta madal`,
    th: `\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}\u{E41}\u{E1E}\u{E25}\u{E15}\u{E1F}\u{E2D}\u{E23}\u{E4C}\u{E21}`,
    ur: `\u{67E}\u{644}\u{6CC}\u{679} \u{641}\u{627}\u{631}\u{645} \u{633}\u{627}\u{626}\u{679}`,
    vi: `Trang web n\u{1EC1}n t\u{1EA3}ng`,
    'zh-hans': `\u{7AD9}\u{53F0}\u{7F51}\u{7AD9}`,
    'zh-hant': `\u{6708}\u{53F0}\u{7DB2}\u{7AD9}`,
    en: `Platform site`
};
const $b11db1b62d4a8f76$export$b8208eb80f0d07f4 = {
    ar: `\u{627}\u{644}\u{62A}\u{643}\u{631}\u{627}\u{631}\u{627}\u{62A} \u{623}\u{648} \u{627}\u{644}\u{639}\u{644}\u{627}\u{642}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{62D}\u{62A}\u{645}\u{644}\u{629}`,
    de: `M\xf6gliche Duplikate oder Beziehungen`,
    es: `Duplicados o relaciones potenciales`,
    fa: `\u{62A}\u{6A9}\u{631}\u{627}\u{631}\u{647}\u{627} \u{6CC}\u{627} \u{631}\u{648}\u{627}\u{628}\u{637} \u{627}\u{62D}\u{62A}\u{645}\u{627}\u{644}\u{6CC}`,
    fil: `Mga potensyal na duplicate o relasyon`,
    fr: `Doubles ou relations potentielles`,
    hi: `\u{938}\u{902}\u{92D}\u{93E}\u{935}\u{93F}\u{924} \u{921}\u{941}\u{92A}\u{94D}\u{932}\u{93F}\u{915}\u{947}\u{91F} \u{92F}\u{93E} \u{938}\u{902}\u{92C}\u{902}\u{927}`,
    ht: `Kopi potansy\xe8l oswa relasyon`,
    it: `Potenziali duplicati o relazioni`,
    ja: `\u{6F5C}\u{5728}\u{7684}\u{306A}\u{91CD}\u{8907}\u{3084}\u{95A2}\u{4FC2}`,
    ko: `\u{C7A0}\u{C7AC}\u{C801} \u{C911}\u{BCF5} \u{B610}\u{B294} \u{AD00}\u{ACC4}`,
    mww: `Tej zaum duplicates los yog kev sib raug zoo`,
    ps: `\u{627}\u{62D}\u{62A}\u{645}\u{627}\u{644}\u{6CC} \u{646}\u{642}\u{644}\u{648}\u{646}\u{647} \u{6CC}\u{627} \u{627}\u{693}\u{6CC}\u{6A9}\u{6D0}`,
    pt: `Potenciais duplicados ou rela\xe7\xf5es`,
    'pt-pt': `Potenciais duplicados ou rela\xe7\xf5es`,
    ru: `\u{412}\u{43E}\u{437}\u{43C}\u{43E}\u{436}\u{43D}\u{44B}\u{435} \u{434}\u{443}\u{431}\u{43B}\u{438}\u{43A}\u{430}\u{442}\u{44B} \u{438}\u{43B}\u{438} \u{43E}\u{442}\u{43D}\u{43E}\u{448}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Ono fa'aluaina po'o feso'ota'iga`,
    so: `Nuqullo suurtagal ah ama xiriirro`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E0B}\u{E49}\u{E4D}\u{E32}\u{E0B}\u{E49}\u{E2D}\u{E19}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E2A}\u{E31}\u{E21}\u{E1E}\u{E31}\u{E19}\u{E18}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E32}\u{E08}\u{E40}\u{E01}\u{E34}\u{E14}\u{E02}\u{E36}\u{E49}\u{E19}`,
    ur: `\u{645}\u{645}\u{6A9}\u{646}\u{6C1} \u{646}\u{642}\u{648}\u{644} \u{6CC}\u{627} \u{62A}\u{639}\u{644}\u{642}\u{627}\u{62A}`,
    vi: `C\xe1c b\u{1EA3}n sao ho\u{1EB7}c m\u{1ED1}i quan h\u{1EC7} ti\u{1EC1}m \u{1EA9}n`,
    'zh-hans': `\u{6F5C}\u{5728}\u{7684}\u{91CD}\u{590D}\u{6216}\u{5173}\u{7CFB}`,
    'zh-hant': `\u{6F5B}\u{5728}\u{7684}\u{91CD}\u{8907}\u{6216}\u{95DC}\u{806F}`,
    en: `Potential duplicates or relations`
};
const $b11db1b62d4a8f76$export$a793bbaad7f3eb70 = {
    ar: (cumulus)=>`\u{645}\u{62F}\u{639}\u{648}\u{645} \u{645}\u{646} ${cumulus}`,
    de: (cumulus)=>`Angetrieben von ${cumulus}`,
    es: (cumulus)=>`Impulsado por ${cumulus}`,
    fa: (cumulus)=>`\u{628}\u{627} \u{642}\u{62F}\u{631}\u{62A} ${cumulus}`,
    fil: (cumulus)=>`Username: ${cumulus}`,
    fr: (cumulus)=>`Propuls\xe9 par ${cumulus}`,
    hi: (cumulus)=>`${cumulus} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{938}\u{902}\u{91A}\u{93E}\u{932}\u{93F}\u{924}`,
    ht: (cumulus)=>`Patrone pa ${cumulus}`,
    it: (cumulus)=>`Alimentato ${cumulus}`,
    ja: (cumulus)=>`${cumulus}\u{306B}\u{3088}\u{308B}\u{63D0}\u{4F9B}`,
    ko: (cumulus)=>`${cumulus} \u{C81C}\u{ACF5}`,
    mww: (cumulus)=>`Powered los ntawm ${cumulus}`,
    ps: (cumulus)=>`\u{62F} ${cumulus} \u{644}\u{62E}\u{648}\u{627} \u{681}\u{648}\u{627}\u{6A9}\u{645}\u{646} \u{634}\u{648}\u{6CC}`,
    pt: (cumulus)=>`Equipado com ${cumulus}`,
    'pt-pt': (cumulus)=>`Alimentado por ${cumulus}`,
    ru: (cumulus)=>`\u{420}\u{430}\u{431}\u{43E}\u{442}\u{430}\u{435}\u{442} ${cumulus}`,
    sm: (cumulus)=>`Fa'amalosia e ${cumulus}`,
    so: (cumulus)=>`Waxaa ku shaqeeya ${cumulus}`,
    th: (cumulus)=>`\u{E02}\u{E31}\u{E1A}\u{E40}\u{E04}\u{E25}\u{E37}\u{E48}\u{E2D}\u{E19}\u{E42}\u{E14}\u{E22} ${cumulus}`,
    ur: (cumulus)=>`\u{67E}\u{627}\u{648}\u{631}\u{688} \u{628}\u{627}\u{626}\u{6CC} ${cumulus}`,
    vi: (cumulus)=>`\u{110}\u{1B0}\u{1EE3}c cung c\u{1EA5}p b\u{1EDF}i ${cumulus}`,
    'zh-hans': (cumulus)=>`\u{7531}${cumulus}\u{63D0}\u{4F9B}\u{52A8}\u{529B}`,
    'zh-hant': (cumulus)=>`\u{7531} ${cumulus} \u{63D0}\u{4F9B}\u{52D5}\u{529B}`,
    en: (cumulus)=>`Powered by ${cumulus}`
};
const $b11db1b62d4a8f76$export$453f74456d906753 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{642}\u{639} \u{627}\u{644}\u{62F}\u{642}\u{64A}\u{642}`,
    de: `Genauer Ort`,
    es: `Ubicaci\xf3n precisa`,
    fa: `\u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A} \u{62F}\u{642}\u{6CC}\u{642}`,
    fil: `Tumpak na lokasyon`,
    fr: `Emplacement pr\xe9cis`,
    hi: `\u{938}\u{91F}\u{940}\u{915} \u{938}\u{94D}\u{925}\u{93E}\u{928}`,
    ht: `Kote egzak`,
    it: `Posizione precisa`,
    ja: `\u{6B63}\u{78BA}\u{306A}\u{4F4D}\u{7F6E}`,
    ko: `\u{C815}\u{D655}\u{D55C} \u{C704}\u{CE58}`,
    mww: `Qhov chaw meej`,
    ps: `\u{62F}\u{642}\u{6CC}\u{642} \u{681}\u{627}\u{6CC}`,
    pt: `Localiza\xe7\xe3o precisa`,
    'pt-pt': `Localiza\xe7\xe3o precisa`,
    ru: `\u{422}\u{43E}\u{447}\u{43D}\u{43E}\u{435} \u{440}\u{430}\u{441}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Nofoaga tonu`,
    so: `Goobta saxda ah`,
    th: `\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E17}\u{E35}\u{E48}\u{E41}\u{E21}\u{E48}\u{E19}\u{E22}\u{E4D}\u{E32}`,
    ur: `\u{62F}\u{631}\u{633}\u{62A} \u{645}\u{642}\u{627}\u{645}`,
    vi: `V\u{1ECB} tr\xed ch\xednh x\xe1c`,
    'zh-hans': `\u{7CBE}\u{786E}\u{4F4D}\u{7F6E}`,
    'zh-hant': `\u{7CBE}\u{78BA}\u{4F4D}\u{7F6E}`,
    en: `Precise location`
};
const $b11db1b62d4a8f76$export$861cff1ec844001d = {
    ar: `\u{627}\u{644}\u{62F}\u{642}\u{629}`,
    de: `Pr\xe4zision`,
    es: `Precisi\xf3n`,
    fa: `\u{62F}\u{642}\u{62A}`,
    fil: `Katumpakan`,
    fr: `Pr\xe9cision`,
    hi: `\u{936}\u{941}\u{926}\u{94D}\u{927}\u{924}\u{93E}`,
    ht: `Presizyon`,
    it: `Precisione`,
    ja: `\u{7CBE}\u{5BC6}\u{3055}`,
    ko: `\u{C815}\u{BC00}\u{B3C4}`,
    mww: `Qhov tseeb`,
    ps: `\u{62F}\u{642}\u{62A}`,
    pt: `Precis\xe3o`,
    'pt-pt': `Precis\xe3o`,
    ru: `\u{422}\u{43E}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Sa'o`,
    so: `Saxnaan`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E41}\u{E21}\u{E48}\u{E19}\u{E22}\u{E4D}\u{E32}`,
    ur: `\u{62F}\u{631}\u{633}\u{62A}\u{6AF}\u{6CC}`,
    vi: `\u{110}\u{1ED9} ch\xednh x\xe1c`,
    'zh-hans': `\u{7CBE}\u{5EA6}`,
    'zh-hant': `\u{7CBE}\u{5EA6}`,
    en: `Precision`
};
const $b11db1b62d4a8f76$export$c9f73a5b7a46c2df = {
    ar: `\u{62A}\u{62D}\u{636}\u{64A}\u{631} \u{627}\u{644}\u{648}\u{62B}\u{627}\u{626}\u{642}`,
    de: `Bereite Dokumente vor`,
    es: `Prepara documentos`,
    fa: `\u{62A}\u{647}\u{6CC}\u{647} \u{627}\u{633}\u{646}\u{627}\u{62F}`,
    fil: `Maghanda ng mga dokumento`,
    fr: `Pr\xe9parer les documents`,
    hi: `\u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C} \u{924}\u{948}\u{92F}\u{93E}\u{930} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Prepare dokiman yo`,
    it: `Preparare i documenti`,
    ja: `\u{66F8}\u{985E}\u{3092}\u{6E96}\u{5099}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{BB38}\u{C11C} \u{C900}\u{BE44}`,
    mww: `Npaj cov ntaub ntawv`,
    ps: `\u{627}\u{633}\u{646}\u{627}\u{62F} \u{686}\u{645}\u{62A}\u{648} \u{6A9}\u{693}\u{626}`,
    pt: `Preparar documentos`,
    'pt-pt': `Preparar documentos`,
    ru: `\u{41F}\u{43E}\u{434}\u{433}\u{43E}\u{442}\u{43E}\u{432}\u{44C}\u{442}\u{435} \u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{44B}`,
    sm: `Saunia pepa aloaia`,
    so: `Diyaari dukumentiyada`,
    th: `\u{E40}\u{E15}\u{E23}\u{E35}\u{E22}\u{E21}\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}`,
    ur: `\u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632}\u{627}\u{62A} \u{62A}\u{6CC}\u{627}\u{631} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Chu\u{1EA9}n b\u{1ECB} h\u{1ED3} s\u{1A1}`,
    'zh-hans': `\u{51C6}\u{5907}\u{6587}\u{4EF6}`,
    'zh-hant': `\u{6E96}\u{5099}\u{6587}\u{4EF6}`,
    en: `Prepare documents`
};
const $b11db1b62d4a8f76$export$ce13d05b1c25268f = {
    ar: `\u{627}\u{644}\u{637}\u{628}\u{64A}\u{628}`,
    de: `Verschreiber`,
    es: `Prescriptor`,
    fa: `\u{62A}\u{62C}\u{648}\u{6CC}\u{632}\u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: `Tagapagreseta`,
    fr: `Prescripteur`,
    hi: `\u{92A}\u{94D}\u{930}\u{93F}\u{938}\u{94D}\u{915}\u{94D}\u{930}\u{93E}\u{907}\u{92C}\u{930}`,
    ht: `Preskri`,
    it: `Prescrittore`,
    ja: `\u{51E6}\u{65B9}\u{8005}`,
    ko: `\u{CC98}\u{BC29}\u{C790}`,
    mww: `Tus kws sau ntawv`,
    ps: `\u{646}\u{633}\u{62E}\u{647} \u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Prescritor`,
    'pt-pt': `Prescritor`,
    ru: `\u{412}\u{440}\u{430}\u{447}`,
    sm: `Prescriber`,
    so: `Qoraa`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E2A}\u{E31}\u{E48}\u{E07}\u{E08}\u{E48}\u{E32}\u{E22}\u{E22}\u{E32}`,
    ur: `\u{62A}\u{62C}\u{648}\u{6CC}\u{632} \u{6A9}\u{646}\u{646}\u{62F}\u{6C1}`,
    vi: `Ng\u{1B0}\u{1EDD}i k\xea \u{111}\u{1A1}n`,
    'zh-hans': `\u{5F00}\u{836F}\u{8005}`,
    'zh-hant': `\u{958B}\u{85E5}\u{8005}`,
    en: `Prescriber`
};
const $b11db1b62d4a8f76$export$f8432d94cae4776c = {
    ar: `\u{627}\u{644}\u{635}\u{62D}\u{627}\u{641}\u{629}`,
    de: `Presse`,
    es: `Prensa`,
    fa: `\u{645}\u{637}\u{628}\u{648}\u{639}\u{627}\u{62A}`,
    fil: `Pindutin`,
    fr: `Presse`,
    hi: `\u{926}\u{92C}\u{93E}\u{928}\u{93E}`,
    ht: `Peze`,
    it: `Stampa`,
    ja: `\u{5831}\u{9053}`,
    ko: `\u{C5B8}\u{B860}`,
    mww: `Xovxwm`,
    ps: `\u{645}\u{637}\u{628}\u{648}\u{639}\u{627}\u{62A}`,
    pt: `Imprensa`,
    'pt-pt': `Imprensa`,
    ru: `\u{41F}\u{440}\u{435}\u{441}\u{441}\u{430}`,
    sm: `Fa'asalalau`,
    so: `Warbaahinta`,
    th: `\u{E02}\u{E48}\u{E32}\u{E27}\u{E1B}\u{E23}\u{E30}\u{E0A}\u{E32}`,
    ur: `\u{67E}\u{631}\u{6CC}\u{633}`,
    vi: `\u{1EA4}n B\u{1EA3}n`,
    'zh-hans': `\u{5A92}\u{4F53}`,
    'zh-hant': `\u{5A92}\u{9AD4}\u{5831}\u{5C0E}`,
    en: `Press`
};
const $b11db1b62d4a8f76$export$777328b73ed02304 = {
    ar: `\u{645}\u{639}\u{627}\u{64A}\u{646}\u{629}`,
    de: `Vorschau`,
    es: `Avance`,
    fa: `\u{67E}\u{6CC}\u{634} \u{646}\u{645}\u{627}\u{6CC}\u{634}`,
    fil: `Preview`,
    fr: `Aper\xe7u`,
    hi: `\u{92A}\u{942}\u{930}\u{94D}\u{935}\u{938}\u{92E}\u{940}\u{915}\u{94D}\u{937}\u{93E}`,
    ht: `Preview`,
    it: `Anteprima`,
    ja: `\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}`,
    ko: `\u{BBF8}\u{B9AC}\u{BCF4}\u{AE30}`,
    mww: `Saib ua ntej`,
    ps: `\u{645}\u{62E}\u{6A9}\u{62A}\u{646}\u{647}`,
    pt: `Pr\xe9via`,
    'pt-pt': `Pr\xe9-visualiza\xe7\xe3o`,
    ru: `\u{41F}\u{440}\u{435}\u{432}\u{44C}\u{44E}`,
    sm: `Muai vaaiga`,
    so: `Hordhac`,
    th: `\u{E15}\u{E31}\u{E27}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}`,
    ur: `\u{67E}\u{6CC}\u{634} \u{646}\u{638}\u{627}\u{631}\u{6C1}`,
    vi: `Xem tr\u{1B0}\u{1EDB}c`,
    'zh-hans': `\u{9884}\u{89C8}`,
    'zh-hant': `\u{9810}\u{89BD}`,
    en: `Preview`
};
const $b11db1b62d4a8f76$export$d6400e97e0c26987 = {
    ar: `\u{627}\u{644}\u{633}\u{627}\u{628}\u{642}`,
    de: `Fr\xfcher`,
    es: `Anterior`,
    fa: `\u{6AF}\u{630}\u{634}\u{62A}\u{647}`,
    fil: `Nakaraan`,
    fr: `Pr\xe9c\xe9dent`,
    hi: `\u{92A}\u{93F}\u{91B}\u{932}\u{93E}`,
    ht: `Previousin`,
    it: `Precedente`,
    ja: `\u{904E}\u{53BB}`,
    ko: `\u{C774}\u{C804}`,
    mww: `Yav dhau los`,
    ps: `\u{67E}\u{62E}\u{648}\u{627}\u{646}\u{6CC}`,
    pt: `Anterior`,
    'pt-pt': `Anterior`,
    ru: `\u{41F}\u{440}\u{435}\u{434}\u{44B}\u{434}\u{443}\u{449}\u{438}\u{435}`,
    sm: `Muamua`,
    so: `Hore`,
    th: `\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: `\u{67E}\u{686}\u{6BE}\u{644}\u{627}`,
    vi: `Tr\u{1B0}\u{1EDB}c`,
    'zh-hans': `\u{4E4B}\u{524D}`,
    'zh-hant': `\u{5148}\u{524D}`,
    en: `Previous`
};
const $b11db1b62d4a8f76$export$7a315f334a00da32 = {
    ar: `\u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} \u{627}\u{644}\u{633}\u{627}\u{628}\u{642}\u{629}`,
    de: `Vorherige Seite`,
    es: `P\xe1gina anterior`,
    fa: `\u{635}\u{641}\u{62D}\u{647} \u{642}\u{628}\u{644}\u{6CC}`,
    fil: `Nakaraang pahina`,
    fr: `Page pr\xe9c\xe9dente`,
    hi: `\u{92A}\u{93F}\u{91B}\u{932}\u{93E} \u{92A}\u{943}\u{937}\u{94D}\u{920}`,
    ht: `Paj anvan an`,
    it: `Pagina precedente`,
    ja: `\u{524D}\u{306E}\u{30DA}\u{30FC}\u{30B8}`,
    ko: `\u{C774}\u{C804} \u{D398}\u{C774}\u{C9C0}`,
    mww: `Nplooj ntawv dhau los`,
    ps: `\u{645}\u{62E}\u{6A9}\u{6D0}\u{646}\u{6CC} \u{67E}\u{627}\u{6BC}\u{647}`,
    pt: `P\xe1gina anterior`,
    'pt-pt': `P\xe1gina anterior`,
    ru: `\u{41F}\u{440}\u{435}\u{434}\u{44B}\u{434}\u{443}\u{449}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430}`,
    sm: `Itulau talu ai`,
    so: `Boggii hore`,
    th: `\u{E2B}\u{E19}\u{E49}\u{E32}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: `\u{67E}\u{686}\u{6BE}\u{644}\u{627} \u{635}\u{641}\u{62D}\u{6C1}`,
    vi: `Trang tr\u{1B0}\u{1EDB}c`,
    'zh-hans': `\u{4E0A}\u{4E00}\u{9875}`,
    'zh-hant': `\u{4E0A}\u{4E00}\u{9801}`,
    en: `Previous page`
};
const $b11db1b62d4a8f76$export$4a4f916898ae94e0 = {
    ar: `\u{641}\u{62A}\u{631}\u{629} \u{627}\u{644}\u{62F}\u{641}\u{639} \u{627}\u{644}\u{633}\u{627}\u{628}\u{642}\u{629}`,
    de: `Fr\xfchere Abrechnungsperiode`,
    es: `Periodo de pago anterior`,
    fa: `\u{62F}\u{648}\u{631}\u{647} \u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A} \u{642}\u{628}\u{644}\u{6CC}`,
    fil: `Nakaraang panahon ng suweldo`,
    fr: `P\xe9riode de paie pr\xe9c\xe9dente`,
    hi: `\u{92A}\u{93F}\u{91B}\u{932}\u{940} \u{935}\u{947}\u{924}\u{928} \u{905}\u{935}\u{927}\u{93F}`,
    ht: `Pery\xf2d peman anvan an`,
    it: `Periodo di paga precedente`,
    ja: `\u{524D}\u{56DE}\u{306E}\u{7D66}\u{4E0E}\u{671F}\u{9593}`,
    ko: `\u{C774}\u{C804} \u{AE09}\u{C5EC} \u{AE30}\u{AC04}`,
    mww: `Lub sijhawm them nyiaj yav dhau los`,
    ps: `\u{645}\u{62E}\u{6A9}\u{6CC}\u{646}\u{6CC} \u{645}\u{639}\u{627}\u{634} \u{62F}\u{648}\u{631}\u{647}`,
    pt: `Per\xedodo de pagamento anterior`,
    'pt-pt': `Per\xedodo de pagamento anterior`,
    ru: `\u{41F}\u{440}\u{435}\u{434}\u{44B}\u{434}\u{443}\u{449}\u{438}\u{439} \u{43F}\u{43B}\u{430}\u{442}\u{451}\u{436}\u{43D}\u{44B}\u{439} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}`,
    sm: `Vaitau o totogi talu ai`,
    so: `Muddadii mushaharkii hore`,
    th: `\u{E23}\u{E2D}\u{E1A}\u{E23}\u{E30}\u{E22}\u{E30}\u{E40}\u{E27}\u{E25}\u{E32}\u{E01}\u{E32}\u{E23}\u{E08}\u{E48}\u{E32}\u{E22}\u{E40}\u{E07}\u{E34}\u{E19}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: `\u{67E}\u{686}\u{6BE}\u{644}\u{6CC} \u{62A}\u{646}\u{62E}\u{648}\u{627}\u{6C1} \u{6A9}\u{6CC} \u{645}\u{62F}\u{62A}`,
    vi: `K\u{1EF3} tr\u{1EA3} l\u{1B0}\u{1A1}ng tr\u{1B0}\u{1EDB}c`,
    'zh-hans': `\u{4E0A}\u{4E00}\u{671F}\u{5DE5}\u{8D44}`,
    'zh-hant': `\u{524D}\u{4E00}\u{85AA}\u{8CC7}\u{671F}\u{9593}`,
    en: `Previous pay period`
};
const $b11db1b62d4a8f76$export$c860bd028d704467 = {
    ar: `\u{627}\u{644}\u{627}\u{628}\u{62A}\u{62F}\u{627}\u{626}\u{64A}`,
    de: `Grundschule`,
    es: `Primaria`,
    fa: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}\u{627}\u{62A} \u{645}\u{642}\u{62F}\u{645}\u{627}\u{62A}\u{6CC}`,
    fil: `Pangunahin`,
    fr: `Primaire`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{925}\u{92E}\u{93F}\u{915}`,
    ht: `Prensipal`,
    it: `Primarie`,
    ja: `\u{5C0F}\u{5B66}\u{6821}`,
    ko: `\u{CD08}\u{B4F1}\u{D559}\u{AD50}`,
    mww: `thawj zaug`,
    ps: `\u{644}\u{648}\u{645}\u{693}\u{646}\u{6CC} \u{67E}\u{693}\u{627}\u{648}`,
    pt: `Prim\xe1ria`,
    'pt-pt': `Prim\xe1ria`,
    ru: `\u{41F}\u{435}\u{440}\u{432}\u{438}\u{447}\u{43D}\u{430}\u{44F} \u{448}\u{43A}\u{43E}\u{43B}\u{430}`,
    sm: `Peraimeri`,
    so: `Doorashooyinka Aasaasiga ah`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E16}\u{E21}\u{E28}\u{E36}\u{E01}\u{E29}\u{E32}`,
    ur: `\u{67E}\u{631}\u{627}\u{626}\u{645}\u{631}\u{6CC}`,
    vi: `Ti\u{1EC3}u h\u{1ECD}c`,
    'zh-hans': `\u{5C0F}\u{5B66}`,
    'zh-hant': `\u{5C0F}\u{5B78}`,
    en: `Primary`
};
const $b11db1b62d4a8f76$export$c9238058729ccab6 = {
    ar: `\u{62C}\u{647}\u{629} \u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644} \u{627}\u{644}\u{631}\u{626}\u{64A}\u{633}\u{64A}\u{629} \u{644}\u{644}\u{637}\u{648}\u{627}\u{631}\u{626}`,
    de: `Prim\xe4rer Notfallkontakt`,
    es: `Contacto de Emergencia Principal`,
    fa: `\u{62A}\u{645}\u{627}\u{633} \u{627}\u{636}\u{637}\u{631}\u{627}\u{631}\u{6CC} \u{627}\u{635}\u{644}\u{6CC}`,
    fil: `Pangunahing Emergency Contact`,
    fr: `Contact d\u{2019}urgence principal`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{925}\u{92E}\u{93F}\u{915} \u{906}\u{92A}\u{93E}\u{924}\u{915}\u{93E}\u{932}\u{940}\u{928} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915}`,
    ht: `Kontak Ijans Prensipal`,
    it: `Contatto Primaria di Emergenza`,
    ja: `\u{4E3B}\u{306A}\u{7DCA}\u{6025}\u{9023}\u{7D61}\u{5148}`,
    ko: `\u{C8FC}\u{C694} \u{AE34}\u{AE09} \u{C5F0}\u{B77D}\u{CC98}`,
    mww: `Thawj Kev Tiv Tauj Thaum Muaj Xwm Txheej Ceev`,
    ps: `\u{627}\u{635}\u{644}\u{6CC} \u{628}\u{6CC}\u{693}\u{646}\u{6CC} \u{62A}\u{645}\u{627}\u{633}`,
    pt: `Contato Prim\xe1rio de Emerg\xeancia`,
    'pt-pt': `Contacto Prim\xe1rio de Emerg\xeancia`,
    ru: `\u{41E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{439} \u{43A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442} \u{434}\u{43B}\u{44F} \u{44D}\u{43A}\u{441}\u{442}\u{440}\u{435}\u{43D}\u{43D}\u{44B}\u{445} \u{441}\u{438}\u{442}\u{443}\u{430}\u{446}\u{438}\u{439}`,
    sm: `Tagata e Faafesootai i le Peraimeri mo Faalavelave Tutupu Faafuasei`,
    so: `Xiriirka Degdegga ah ee Muhiimka ah`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E09}\u{E38}\u{E01}\u{E40}\u{E09}\u{E34}\u{E19}\u{E40}\u{E1A}\u{E37}\u{E49}\u{E2D}\u{E07}\u{E15}\u{E49}\u{E19}`,
    ur: `\u{628}\u{646}\u{6CC}\u{627}\u{62F}\u{6CC} \u{6C1}\u{646}\u{6AF}\u{627}\u{645}\u{6CC} \u{631}\u{627}\u{628}\u{637}\u{6C1}`,
    vi: `Li\xean h\u{1EC7} kh\u{1EA9}n c\u{1EA5}p ch\xednh`,
    'zh-hans': `\u{4E3B}\u{8981}\u{7D27}\u{6025}\u{8054}\u{7CFB}\u{4EBA}`,
    'zh-hant': `\u{4E3B}\u{8981}\u{7DCA}\u{6025}\u{806F}\u{7D61}\u{4EBA}`,
    en: `Primary Emergency Contact`
};
const $b11db1b62d4a8f76$export$2a2eee6a115fe8fd = {
    ar: `\u{627}\u{644}\u{644}\u{63A}\u{629} \u{627}\u{644}\u{623}\u{633}\u{627}\u{633}\u{64A}\u{629}`,
    de: `Hauptsprache`,
    es: `Lengua primaria`,
    fa: `\u{632}\u{628}\u{627}\u{646} \u{627}\u{635}\u{644}\u{6CC}`,
    fil: `Pangunahing wika`,
    fr: `Langue principale`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{925}\u{92E}\u{93F}\u{915} \u{92D}\u{93E}\u{937}\u{93E}`,
    ht: `Premye lang`,
    it: `Lingua primaria`,
    ja: `\u{4E3B}\u{306A}\u{8A00}\u{8A9E}`,
    ko: `\u{C8FC}\u{C694} \u{C5B8}\u{C5B4}`,
    mww: `Thawj hom lus`,
    ps: `\u{627}\u{635}\u{644}\u{6CC} \u{698}\u{628}\u{647}`,
    pt: `L\xedngua prim\xe1ria`,
    'pt-pt': `L\xedngua principal`,
    ru: `\u{41E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{439} \u{44F}\u{437}\u{44B}\u{43A}`,
    sm: `Gagana autu`,
    so: `Luuqadda Koowaad`,
    th: `\u{E20}\u{E32}\u{E29}\u{E32}\u{E2B}\u{E25}\u{E31}\u{E01}`,
    ur: `\u{628}\u{646}\u{6CC}\u{627}\u{62F}\u{6CC} \u{632}\u{628}\u{627}\u{646}`,
    vi: `Ng\xf4n ng\u{1EEF} ch\xednh`,
    'zh-hans': `\u{4E3B}\u{8981}\u{8BED}\u{8A00}`,
    'zh-hant': `\u{4E3B}\u{8981}\u{8A9E}\u{8A00}`,
    en: `Primary language`
};
const $b11db1b62d4a8f76$export$f6414b5b24376f44 = {
    ar: `\u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F}\u{64A} \u{627}\u{644}\u{631}\u{626}\u{64A}\u{633}\u{64A}`,
    de: `Hauptpostadresse`,
    es: `Direcci\xf3n postal principal`,
    fa: `\u{646}\u{634}\u{627}\u{646}\u{6CC} \u{67E}\u{633}\u{62A}\u{6CC} \u{627}\u{635}\u{644}\u{6CC}`,
    fil: `Pangunahing address ng koreo`,
    fr: `Adresse postale principale`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{925}\u{92E}\u{93F}\u{915} \u{921}\u{93E}\u{915} \u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s postal prensipal`,
    it: `Indirizzo postale principale`,
    ja: `\u{4E3B}\u{306A}\u{90F5}\u{9001}\u{5148}\u{4F4F}\u{6240}`,
    ko: `\u{C8FC}\u{C694} \u{C6B0}\u{D3B8} \u{C8FC}\u{C18C}`,
    mww: `Thawj qhov chaw nyob xa ntawv`,
    ps: `\u{627}\u{635}\u{644}\u{6CC} \u{62F} \u{67E}\u{648}\u{633}\u{62A}\u{6D0} \u{67E}\u{62A}\u{647}`,
    pt: `Endere\xe7o principal de correspond\xeancia`,
    'pt-pt': `Endere\xe7o postal principal`,
    ru: `\u{41E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{44B}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Tuatusi meli autu`,
    so: `Cinwaanka boostada ugu weyn`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E32}\u{E07}\u{E44}\u{E1B}\u{E23}\u{E29}\u{E13}\u{E35}\u{E22}\u{E4C}\u{E2B}\u{E25}\u{E31}\u{E01}`,
    ur: `\u{628}\u{646}\u{6CC}\u{627}\u{62F}\u{6CC} \u{688}\u{627}\u{6A9} \u{6A9}\u{627} \u{67E}\u{62A}\u{6C1}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} g\u{1EED}i th\u{1B0} ch\xednh`,
    'zh-hans': `\u{4E3B}\u{8981}\u{90AE}\u{5BC4}\u{5730}\u{5740}`,
    'zh-hant': `\u{4E3B}\u{8981}\u{90F5}\u{5BC4}\u{5730}\u{5740}`,
    en: `Primary mailing address`
};
const $b11db1b62d4a8f76$export$88423193c62995c6 = {
    ar: `\u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{641}\u{64A}\u{632}\u{64A}\u{627}\u{626}\u{64A} \u{627}\u{644}\u{623}\u{633}\u{627}\u{633}\u{64A}`,
    de: `Prim\xe4re physische Adresse`,
    es: `Direcci\xf3n f\xedsica principal`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{641}\u{6CC}\u{632}\u{6CC}\u{6A9}\u{6CC} \u{627}\u{635}\u{644}\u{6CC}`,
    fil: `Pangunahing pisikal na address`,
    fr: `Adresse physique principale`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{925}\u{92E}\u{93F}\u{915} \u{92D}\u{94C}\u{924}\u{93F}\u{915} \u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s fizik prensipal`,
    it: `Indirizzo fisico principale`,
    ja: `\u{30D7}\u{30E9}\u{30A4}\u{30DE}\u{30EA}\u{7269}\u{7406}\u{30A2}\u{30C9}\u{30EC}\u{30B9}`,
    ko: `\u{C8FC}\u{C694} \u{BB3C}\u{B9AC}\u{C801} \u{C8FC}\u{C18C}`,
    mww: `Thawj qhov chaw nyob ntawm lub cev`,
    ps: `\u{627}\u{635}\u{644}\u{6CC} \u{641}\u{632}\u{6CC}\u{6A9}\u{6CC} \u{67E}\u{62A}\u{647}`,
    pt: `Endere\xe7o f\xedsico principal`,
    'pt-pt': `Endere\xe7o f\xedsico principal`,
    ru: `\u{41E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{439} \u{444}\u{438}\u{437}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Tuatusi faaletino o le Peraimeri`,
    so: `Cinwaanka ugu weyn ee jirka`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E32}\u{E07}\u{E01}\u{E32}\u{E22}\u{E20}\u{E32}\u{E1E}\u{E2B}\u{E25}\u{E31}\u{E01}`,
    ur: `\u{628}\u{646}\u{6CC}\u{627}\u{62F}\u{6CC} \u{62C}\u{633}\u{645}\u{627}\u{646}\u{6CC} \u{67E}\u{62A}\u{6C1}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} th\u{1EF1}c t\u{1EBF} ch\xednh`,
    'zh-hans': `\u{4E3B}\u{8981}\u{7269}\u{7406}\u{5730}\u{5740}`,
    'zh-hant': `\u{4E3B}\u{8981}\u{5BE6}\u{9AD4}\u{5730}\u{5740}`,
    en: `Primary physical address`
};
const $b11db1b62d4a8f76$export$ca2e5371c05fb46f = {
    ar: `\u{627}\u{644}\u{637}\u{628}\u{627}\u{639}\u{629}`,
    de: `Druck`,
    es: `Impresi\xf3n`,
    fa: `\u{686}\u{627}\u{67E}`,
    fil: `I-print`,
    fr: `Imprim\xe9`,
    hi: `\u{92B}\u{93C}\u{94B}\u{91F}\u{94B}`,
    ht: `Ekri an l\xe8t detache`,
    it: `Stampa`,
    ja: `\u{5370}\u{5237}\u{7269}`,
    ko: `\u{C778}\u{C1C4}`,
    mww: `Luam tawm`,
    ps: `\u{686}\u{627}\u{67E}`,
    pt: `Impress\xe3o`,
    'pt-pt': `Impress\xe3o`,
    ru: `\u{41F}\u{435}\u{447}\u{430}\u{442}\u{44C}`,
    sm: `Lolomi`,
    so: `Daabacaad`,
    th: `\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}`,
    ur: `\u{67E}\u{631}\u{646}\u{679}`,
    vi: `In \u{1EA5}n`,
    'zh-hans': `\u{5370}\u{5237}`,
    'zh-hant': `\u{5370}\u{5237}\u{54C1}`,
    en: `Print`
};
const $b11db1b62d4a8f76$export$637e72f98a969f91 = {
    ar: `\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644} \u{627}\u{644}\u{637}\u{628}\u{627}\u{639}\u{629}`,
    de: `Printdetails`,
    es: `Detalles de impresi\xf3n`,
    fa: `\u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A} \u{686}\u{627}\u{67E}`,
    fil: `Email Address *`,
    fr: `D\xe9tails imprim\xe9s`,
    hi: `\u{92A}\u{94D}\u{930}\u{93F}\u{902}\u{91F} \u{935}\u{93F}\u{935}\u{930}\u{923}`,
    ht: `Ekri an l\xe8t detache detay`,
    it: `Dettagli di stampa`,
    ja: `\u{5370}\u{5237}\u{8A73}\u{7D30}`,
    ko: `\u{C778}\u{C1C4} \u{C815}\u{BCF4}`,
    mww: `Luam tawm cov ntsiab lus`,
    ps: `\u{62F} \u{686}\u{627}\u{67E} \u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    pt: `Detalhes da impress\xe3o`,
    'pt-pt': `Detalhes de impress\xe3o`,
    ru: `\u{414}\u{435}\u{442}\u{430}\u{43B}\u{438} \u{43F}\u{435}\u{447}\u{430}\u{442}\u{438}`,
    sm: `Lolomi auiliiliga`,
    so: `Faahfaahinta daabacaadda`,
    th: `\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E23}\u{E32}\u{E22}\u{E25}\u{E30}\u{E40}\u{E2D}\u{E35}\u{E22}\u{E14}`,
    ur: `\u{67E}\u{631}\u{646}\u{679} \u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    vi: `In chi ti\u{1EBF}t`,
    'zh-hans': `\u{5370}\u{5237}\u{8BE6}\u{60C5}`,
    'zh-hant': `\u{5370}\u{5237}\u{8A73}\u{60C5}`,
    en: `Print details`
};
const $b11db1b62d4a8f76$export$2d2b792cc2ae3e56 = {
    ar: `\u{645}\u{644}\u{62E}\u{635} \u{627}\u{644}\u{637}\u{628}\u{627}\u{639}\u{629}`,
    de: `Druckzusammenfassung`,
    es: `Resumen impreso`,
    fa: `\u{62E}\u{644}\u{627}\u{635}\u{647} \u{686}\u{627}\u{67E}`,
    fil: `I-print ang buod`,
    fr: `R\xe9sum\xe9 imprim\xe9`,
    hi: `\u{92A}\u{94D}\u{930}\u{93F}\u{902}\u{91F} \u{938}\u{93E}\u{930}\u{93E}\u{902}\u{936}`,
    ht: `Rezime enprime`,
    it: `Riassunto cartaceato`,
    ja: `\u{5370}\u{5237}\u{6982}\u{8981}`,
    ko: `\u{C778}\u{C1C4} \u{C694}\u{C57D}`,
    mww: `Sau cov ntsiab lus`,
    ps: `\u{62F} \u{686}\u{627}\u{67E} \u{644}\u{646}\u{689}\u{6CC}\u{632}`,
    pt: `Resumo impresso`,
    'pt-pt': `Resumo impresso`,
    ru: `\u{41A}\u{440}\u{430}\u{442}\u{43A}\u{43E}\u{435} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{43D}\u{438}\u{435} \u{43F}\u{435}\u{447}\u{430}\u{442}\u{438}`,
    sm: `Lolomi le aotelega`,
    so: `Soo koobid daabacaad`,
    th: `\u{E2A}\u{E23}\u{E38}\u{E1B}\u{E01}\u{E32}\u{E23}\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}`,
    ur: `\u{67E}\u{631}\u{646}\u{679} \u{62E}\u{644}\u{627}\u{635}\u{6C1}`,
    vi: `In t\xf3m t\u{1EAF}t`,
    'zh-hans': `\u{5370}\u{5237}\u{6458}\u{8981}`,
    'zh-hant': `\u{5370}\u{5237}\u{6458}\u{8981}`,
    en: `Print summary`
};
const $b11db1b62d4a8f76$export$f3b2c456a689c995 = {
    ar: `\u{645}\u{644}\u{62E}\u{635} \u{645}\u{637}\u{628}\u{648}\u{639} \u{645}\u{639} \u{627}\u{644}\u{62A}\u{627}\u{631}\u{64A}\u{62E}`,
    de: `Druckzusammenfassung mit Geschichte`,
    es: `Resumen impreso con historia`,
    fa: `\u{62E}\u{644}\u{627}\u{635}\u{647} \u{686}\u{627}\u{67E}\u{6CC} \u{647}\u{645}\u{631}\u{627}\u{647} \u{628}\u{627} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{686}\u{647}`,
    fil: `I-print ang buod na may kasaysayan`,
    fr: `R\xe9sum\xe9 imprim\xe9 avec histoire`,
    hi: `\u{907}\u{924}\u{93F}\u{939}\u{93E}\u{938} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{938}\u{93E}\u{930}\u{93E}\u{902}\u{936} \u{92A}\u{94D}\u{930}\u{93F}\u{902}\u{91F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Enprime rezime ak istwa`,
    it: `Riassunto stampato con la storia`,
    ja: `\u{6B74}\u{53F2}\u{4ED8}\u{304D}\u{5370}\u{5237}\u{8981}\u{7D04}`,
    ko: `\u{C5ED}\u{C0AC}\u{AC00} \u{D3EC}\u{D568}\u{B41C} \u{C778}\u{C1C4} \u{C694}\u{C57D}`,
    mww: `Luam tawm cov ntsiab lus nrog keeb kwm`,
    ps: `\u{62F} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{633}\u{631}\u{647} \u{62F} \u{686}\u{627}\u{67E} \u{644}\u{646}\u{689}\u{6CC}\u{632}`,
    pt: `Resumo impresso com hist\xf3rico`,
    'pt-pt': `Resumo impresso com hist\xf3ria`,
    ru: `\u{41A}\u{440}\u{430}\u{442}\u{43A}\u{43E}\u{435} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{43D}\u{438}\u{435} \u{43F}\u{435}\u{447}\u{430}\u{442}\u{438} \u{441} \u{438}\u{441}\u{442}\u{43E}\u{440}\u{438}\u{435}\u{439}`,
    sm: `Lolomi le aotelega ma le talafaasolopito`,
    so: `Soo koobid daabacaad oo leh taariikh`,
    th: `\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E2A}\u{E23}\u{E38}\u{E1B}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E1B}\u{E23}\u{E30}\u{E27}\u{E31}\u{E15}\u{E34}`,
    ur: `\u{67E}\u{631}\u{646}\u{679} \u{62E}\u{644}\u{627}\u{635}\u{6C1} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE}`,
    vi: `In t\xf3m t\u{1EAF}t v\u{1EDB}i l\u{1ECB}ch s\u{1EED}`,
    'zh-hans': `\u{5370}\u{5237}\u{6458}\u{8981}\u{53CA}\u{5386}\u{53F2}`,
    'zh-hant': `\u{5370}\u{5237}\u{6458}\u{8981}\u{53CA}\u{6B77}\u{53F2}`,
    en: `Print summary with history`
};
const $b11db1b62d4a8f76$export$ecc1ea6da30d4fe9 = {
    ar: `\u{627}\u{644}\u{62A}\u{648}\u{627}\u{632}\u{646} \u{627}\u{644}\u{633}\u{627}\u{628}\u{642}`,
    de: `Prior-Saldo`,
    es: `Saldo previo`,
    fa: `\u{645}\u{627}\u{646}\u{62F}\u{647} \u{642}\u{628}\u{644}\u{6CC}`,
    fil: `Naunang balanse`,
    fr: `Solde ant\xe9rieur`,
    hi: `\u{92A}\u{942}\u{930}\u{94D}\u{935} \u{936}\u{947}\u{937}`,
    ht: `Balans anvan`,
    it: `Saldo precedente`,
    ja: `\u{4E8B}\u{524D}\u{6B8B}\u{9AD8}`,
    ko: `\u{C120}\u{C804} \u{C794}\u{C561}`,
    mww: `Nyiaj tshuav ua ntej`,
    ps: `\u{645}\u{62E}\u{6A9}\u{6CC}\u{646}\u{6CC} \u{62A}\u{648}\u{627}\u{632}\u{646}`,
    pt: `Saldo anterior`,
    'pt-pt': `Saldo anterior`,
    ru: `\u{41F}\u{440}\u{435}\u{434}\u{44B}\u{434}\u{443}\u{449}\u{438}\u{439} \u{431}\u{430}\u{43B}\u{430}\u{43D}\u{441}`,
    sm: `Paleni muamua`,
    so: `Xisaabtii hore`,
    th: `\u{E22}\u{E2D}\u{E14}\u{E04}\u{E07}\u{E40}\u{E2B}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: `\u{633}\u{627}\u{628}\u{642}\u{6C1} \u{628}\u{6CC}\u{644}\u{646}\u{633}`,
    vi: `S\u{1ED1} d\u{1B0} tr\u{1B0}\u{1EDB}c`,
    'zh-hans': `\u{5148}\u{884C}\u{4F59}\u{989D}`,
    'zh-hant': `\u{5148}\u{884C}\u{9918}\u{984D}`,
    en: `Prior balance`
};
const $b11db1b62d4a8f76$export$24834e47a9adf0a8 = {
    ar: `\u{627}\u{644}\u{62E}\u{635}\u{648}\u{635}\u{64A}\u{629}`,
    de: `Privatsph\xe4re`,
    es: `Privacidad`,
    fa: `\u{62D}\u{631}\u{6CC}\u{645} \u{62E}\u{635}\u{648}\u{635}\u{6CC}`,
    fil: `Pagkapribado`,
    fr: `Confidentialit\xe9`,
    hi: `\u{917}\u{94B}\u{92A}\u{928}\u{940}\u{92F}\u{924}\u{93E}`,
    ht: `Konfidansyalite`,
    it: `Privacy`,
    ja: `\u{30D7}\u{30E9}\u{30A4}\u{30D0}\u{30B7}\u{30FC}`,
    ko: `\u{D504}\u{B77C}\u{C774}\u{BC84}\u{C2DC}`,
    mww: `Tsis pub twg paub`,
    ps: `\u{645}\u{62D}\u{631}\u{645}\u{6CC}\u{62A}`,
    pt: `Privacidade`,
    'pt-pt': `Privacidade`,
    ru: `\u{41A}\u{43E}\u{43D}\u{444}\u{438}\u{434}\u{435}\u{43D}\u{446}\u{438}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Le faalauaiteleina`,
    so: `Asturnaanta`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E2A}\u{E48}\u{E27}\u{E19}\u{E15}\u{E31}\u{E27}`,
    ur: `\u{67E}\u{631}\u{627}\u{626}\u{6CC}\u{648}\u{6CC}\u{633}\u{6CC}`,
    vi: `Quy\u{1EC1}n ri\xeang t\u{1B0}`,
    'zh-hans': `\u{9690}\u{79C1}`,
    'zh-hant': `\u{96B1}\u{79C1}`,
    en: `Privacy`
};
const $b11db1b62d4a8f76$export$5a0ce4614252dcd9 = {
    ar: `\u{62C}\u{646}\u{62F}\u{64A} \u{62E}\u{627}\u{635}`,
    de: `Gefreiter`,
    es: `Soldado`,
    fa: `\u{62E}\u{635}\u{648}\u{635}\u{6CC}`,
    fil: `Pribado`,
    fr: `Priv\xe9`,
    hi: `\u{92E}\u{93E}\u{92E}\u{942}\u{932}\u{940} \u{938}\u{93F}\u{92A}\u{93E}\u{939}\u{940}`,
    ht: `Prive`,
    it: `Privato`,
    ja: `\u{79C1}\u{7ACB}`,
    ko: `\u{C0AC}\u{C124}`,
    mww: `Ntiag tug`,
    ps: `\u{62E}\u{635}\u{648}\u{635}\u{6CC}`,
    pt: `Privado`,
    'pt-pt': `Privado`,
    ru: `\u{427}\u{430}\u{441}\u{442}\u{43D}\u{430}\u{44F} \u{441}\u{43B}\u{443}\u{436}\u{431}\u{430}`,
    sm: `Tumaoti`,
    so: `Gaarka ah`,
    th: `\u{E2A}\u{E48}\u{E27}\u{E19}\u{E15}\u{E31}\u{E27}`,
    ur: `\u{67E}\u{631}\u{627}\u{626}\u{6CC}\u{648}\u{6CC}\u{679}`,
    vi: `Ri\xeang t\u{1B0}`,
    'zh-hans': `\u{79C1}\u{4EBA}`,
    'zh-hant': `\u{79C1}\u{4EBA}`,
    en: `Private`
};
const $b11db1b62d4a8f76$export$30804cb60b7ca511 = {
    ar: `\u{62A}\u{645}\u{62A} \u{645}\u{639}\u{627}\u{644}\u{62C}\u{62A}\u{647}`,
    de: `Verarbeitet`,
    es: `Procesado`,
    fa: `\u{67E}\u{631}\u{62F}\u{627}\u{632}\u{634} \u{634}\u{62F}\u{647}`,
    fil: `Naproseso`,
    fr: `Trait\xe9`,
    hi: `\u{938}\u{902}\u{938}\u{93E}\u{927}\u{93F}\u{924}`,
    ht: `Trete`,
    it: `Processato`,
    ja: `\u{51E6}\u{7406}`,
    ko: `\u{AC00}\u{ACF5}`,
    mww: `Ua tiav`,
    ps: `\u{67E}\u{631}\u{648}\u{633}\u{633} \u{634}\u{648}\u{6CC}`,
    pt: `Processado`,
    'pt-pt': `Processado`,
    ru: `\u{41E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{430}`,
    sm: `Fa'agasologa`,
    so: `La farsameeyay`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E21}\u{E27}\u{E25}\u{E1C}\u{E25}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{67E}\u{631}\u{627}\u{633}\u{6CC}\u{633} \u{634}\u{62F}\u{6C1}`,
    vi: `\u{110}\xe3 x\u{1EED} l\xfd`,
    'zh-hans': `\u{52A0}\u{5DE5}`,
    'zh-hant': `\u{52A0}\u{5DE5}`,
    en: `Processed`
};
const $b11db1b62d4a8f76$export$5b664e7de9fc10d5 = {
    ar: `\u{627}\u{644}\u{645}\u{639}\u{627}\u{644}\u{62C}\u{629}`,
    de: `Verarbeitung`,
    es: `Procesamiento`,
    fa: `\u{67E}\u{631}\u{62F}\u{627}\u{632}\u{634}`,
    fil: `Pagproseso`,
    fr: `Traitement`,
    hi: `\u{92A}\u{94D}\u{930}\u{938}\u{902}\u{938}\u{94D}\u{915}\u{930}\u{923}`,
    ht: `Pwosesis`,
    it: `Lavorazione`,
    ja: `\u{52A0}\u{5DE5}`,
    ko: `\u{AC00}\u{ACF5}`,
    mww: `Kev Ua Haujlwm`,
    ps: `\u{67E}\u{631}\u{648}\u{633}\u{633} \u{6A9}\u{648}\u{644}`,
    pt: `Processamento`,
    'pt-pt': `Processamento`,
    ru: `\u{41E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{430}`,
    sm: `Fa'agasologa`,
    so: `Habaynta`,
    th: `\u{E01}\u{E32}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E21}\u{E27}\u{E25}\u{E1C}\u{E25}`,
    ur: `\u{67E}\u{631}\u{648}\u{633}\u{6CC}\u{633}\u{646}\u{6AF}`,
    vi: `Ch\u{1EBF} bi\u{1EBF}n`,
    'zh-hans': `\u{52A0}\u{5DE5}`,
    'zh-hant': `\u{52A0}\u{5DE5}`,
    en: `Processing`
};
const $b11db1b62d4a8f76$export$e4eac9e9c050fc35 = {
    ar: `\u{627}\u{644}\u{645}\u{646}\u{62A}\u{62C}`,
    de: `Produkt`,
    es: `Producto`,
    fa: `\u{645}\u{62D}\u{635}\u{648}\u{644}`,
    fil: `Produkto`,
    fr: `Produit`,
    hi: `\u{917}\u{941}\u{923}\u{928}\u{92B}\u{932}`,
    ht: `Pwodwi`,
    it: `Prodotto`,
    ja: `\u{88FD}\u{54C1}`,
    ko: `\u{C81C}\u{D488}`,
    mww: `Cov khoom lag luam`,
    ps: `\u{645}\u{62D}\u{635}\u{648}\u{644}`,
    pt: `Produto`,
    'pt-pt': `Produto`,
    ru: `\u{41F}\u{440}\u{43E}\u{434}\u{443}\u{43A}\u{442}`,
    sm: `Oloa`,
    so: `Alaabta`,
    th: `\u{E1C}\u{E25}\u{E34}\u{E15}\u{E20}\u{E31}\u{E13}\u{E11}\u{E4C}`,
    ur: `\u{67E}\u{631}\u{648}\u{688}\u{6A9}\u{679}`,
    vi: `S\u{1EA3}n ph\u{1EA9}m`,
    'zh-hans': `\u{4EA7}\u{54C1}`,
    'zh-hant': `\u{7522}\u{54C1}`,
    en: `Product`
};
const $b11db1b62d4a8f76$export$a059c6be0ddd76be = {
    ar: `\u{645}\u{648}\u{642}\u{639} \u{627}\u{644}\u{625}\u{646}\u{62A}\u{627}\u{62C}`,
    de: `Produktionsst\xe4tte`,
    es: `Lugar de producci\xf3n`,
    fa: `\u{645}\u{62D}\u{644} \u{62A}\u{648}\u{644}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `Site de production`,
    hi: `\u{909}\u{924}\u{94D}\u{92A}\u{93E}\u{926}\u{928} \u{938}\u{94D}\u{925}\u{932}`,
    ht: `Sit pwodiksyon an`,
    it: `Sito di produzione`,
    ja: `\u{751F}\u{7523}\u{62E0}\u{70B9}`,
    ko: `\u{C0DD}\u{C0B0} \u{D604}\u{C7A5}`,
    mww: `Qhov chaw tsim khoom`,
    ps: `\u{62F} \u{62A}\u{648}\u{644}\u{6CC}\u{62F} \u{681}\u{627}\u{6CC}`,
    pt: `Local de produ\xe7\xe3o`,
    'pt-pt': `Local de produ\xe7\xe3o`,
    ru: `\u{41F}\u{43B}\u{43E}\u{449}\u{430}\u{434}\u{43A}\u{430} \u{43F}\u{440}\u{43E}\u{438}\u{437}\u{432}\u{43E}\u{434}\u{441}\u{442}\u{432}\u{430}`,
    sm: `Nofoaga o gaosiga`,
    so: `Goobta wax-soo-saarka`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E1C}\u{E25}\u{E34}\u{E15}`,
    ur: `\u{67E}\u{631}\u{648}\u{688}\u{6A9}\u{634}\u{646} \u{633}\u{627}\u{626}\u{679}`,
    vi: `\u{110}\u{1ECB}a \u{111}i\u{1EC3}m s\u{1EA3}n xu\u{1EA5}t`,
    'zh-hans': `\u{751F}\u{4EA7}\u{57FA}\u{5730}`,
    'zh-hant': `\u{88FD}\u{4F5C}\u{5834}\u{5730}`,
    en: `Production site`
};
const $b11db1b62d4a8f76$export$8bb47d4df782672a = {
    ar: `\u{627}\u{644}\u{645}\u{644}\u{641} \u{627}\u{644}\u{634}\u{62E}\u{635}\u{64A}`,
    de: `Profil`,
    es: `Perfil`,
    fa: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644}`,
    fil: `Profile`,
    fr: `Profil`,
    hi: `\u{916}\u{93C}\u{93E}\u{915}\u{93E}`,
    ht: `Pwofil`,
    it: `Profilo`,
    ja: `\u{30D7}\u{30ED}\u{30D5}\u{30A3}\u{30FC}\u{30EB}`,
    ko: `\u{D504}\u{B85C}\u{D544}`,
    mww: `Profile`,
    ps: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644}`,
    pt: `Perfil`,
    'pt-pt': `Perfil`,
    ru: `\u{41F}\u{440}\u{43E}\u{444}\u{438}\u{43B}\u{44C}`,
    sm: `Talaaga otooto`,
    so: `Xogta`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E2A}\u{E48}\u{E27}\u{E19}\u{E15}\u{E31}\u{E27}`,
    ur: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{626}\u{644}`,
    vi: `Ti\u{1EC3}u s\u{1EED}`,
    'zh-hans': `\u{7B80}\u{4ECB}`,
    'zh-hant': `\u{7C21}\u{4ECB}`,
    en: `Profile`
};
const $b11db1b62d4a8f76$export$5b642f15da12d382 = {
    ar: `\u{635}\u{648}\u{631}\u{629} \u{627}\u{644}\u{645}\u{644}\u{641} \u{627}\u{644}\u{634}\u{62E}\u{635}\u{64A}`,
    de: `Profilbild`,
    es: `Foto de perfil`,
    fa: `\u{639}\u{6A9}\u{633} \u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644}`,
    fil: `Email Address *`,
    fr: `Photo de profil`,
    hi: `\u{92A}\u{94D}\u{930}\u{94B}\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{91A}\u{93F}\u{924}\u{94D}\u{930}`,
    ht: `Foto pwofil`,
    it: `Foto profilo`,
    ja: `\u{30D7}\u{30ED}\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{5199}\u{771F}`,
    ko: `\u{D504}\u{B85C}\u{D544} \u{C0AC}\u{C9C4}`,
    mww: `Daim duab profile`,
    ps: `\u{62F} \u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644} \u{639}\u{6A9}\u{633}`,
    pt: `Foto de perfil`,
    'pt-pt': `Foto de perfil`,
    ru: `\u{41F}\u{440}\u{43E}\u{444}\u{438}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{444}\u{43E}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{44F}`,
    sm: `Ata o le talaaga otooto`,
    so: `Sawirka profile`,
    th: `\u{E23}\u{E39}\u{E1B}\u{E42}\u{E1B}\u{E23}\u{E44}\u{E1F}\u{E25}\u{E4C}`,
    ur: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{626}\u{644} \u{62A}\u{635}\u{648}\u{6CC}\u{631}`,
    vi: `\u{1EA2}nh h\u{1ED3} s\u{1A1}`,
    'zh-hans': `\u{5934}\u{50CF}`,
    'zh-hant': `\u{500B}\u{4EBA}\u{982D}\u{50CF}`,
    en: `Profile picture`
};
const $b11db1b62d4a8f76$export$a322d260bed4c6fe = {
    ar: `\u{627}\u{633}\u{645}\u{643}\u{60C} \u{633}\u{64A}\u{631}\u{62A}\u{643} \u{627}\u{644}\u{630}\u{627}\u{62A}\u{64A}\u{629}\u{60C} \u{648}\u{635}\u{648}\u{631}\u{62A}\u{643} \u{645}\u{631}\u{626}\u{64A}\u{629} \u{644}\u{644}\u{62C}\u{645}\u{647}\u{648}\u{631} \u{639}\u{644}\u{649} Cumulus. \u{639}\u{646}\u{648}\u{627}\u{646} \u{628}\u{631}\u{64A}\u{62F}\u{643} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}\u{60C} \u{623}\u{631}\u{642}\u{627}\u{645} \u{647}\u{648}\u{627}\u{62A}\u{641}\u{643}\u{60C} \u{648}\u{62D}\u{627}\u{644}\u{629} \u{62E}\u{627}\u{631}\u{62C}\u{643} \u{645}\u{646} \u{627}\u{644}\u{645}\u{643}\u{62A}\u{628} \u{645}\u{631}\u{626}\u{64A}\u{629} \u{641}\u{642}\u{637} \u{644}\u{623}\u{639}\u{636}\u{627}\u{621} Cumulus \u{627}\u{644}\u{630}\u{64A}\u{646} \u{62A}\u{62A}\u{639}\u{627}\u{648}\u{646} \u{645}\u{639}\u{647}\u{645}.`,
    de: `Dein Name, deine Bio und dein Bild sind auf Cumulus \xf6ffentlich sichtbar. Ihre E-Mail-Adresse, Ihre Telefonnummern und Ihr Abwesenheitsstatus sind nur f\xfcr Cumulus-Mitglieder sichtbar, mit denen Sie zusammenarbeiten.`,
    es: `Tu nombre, biograf\xeda y foto son visibles p\xfablicamente en Cumulus. Tu direcci\xf3n de correo electr\xf3nico, n\xfameros de tel\xe9fono y estado de ausencia solo son visibles para los miembros de Cumulus con los que colabores.`,
    fa: `\u{646}\u{627}\u{645}\u{60C} \u{628}\u{6CC}\u{648}\u{6AF}\u{631}\u{627}\u{641}\u{6CC} \u{648} \u{639}\u{6A9}\u{633} \u{634}\u{645}\u{627} \u{628}\u{647} \u{635}\u{648}\u{631}\u{62A} \u{639}\u{645}\u{648}\u{645}\u{6CC} \u{62F}\u{631} Cumulus \u{642}\u{627}\u{628}\u{644} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{622}\u{62F}\u{631}\u{633} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}\u{60C} \u{634}\u{645}\u{627}\u{631}\u{647} \u{62A}\u{644}\u{641}\u{646} \u{648} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{62E}\u{627}\u{631}\u{62C} \u{627}\u{632} \u{62F}\u{641}\u{62A}\u{631} \u{634}\u{645}\u{627} \u{641}\u{642}\u{637} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{639}\u{636}\u{627}\u{6CC} Cumulus \u{6A9}\u{647} \u{628}\u{627} \u{622}\u{646} \u{647}\u{627} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{6CC} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{642}\u{627}\u{628}\u{644} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Ang iyong pangalan, bio, at larawan ay makikita sa publiko sa Cumulus. Ang iyong email address, numero ng telepono, at katayuan sa labas ng opisina ay makikita lamang ng mga miyembro ng Cumulus na nakikipagtulungan ka.`,
    fr: `Votre nom, votre biographie et votre photo sont visibles publiquement sur Cumulus. Votre adresse e-mail, vos num\xe9ros de t\xe9l\xe9phone et votre statut d\u{2019}absence ne sont visibles que pour les membres Cumulus avec lesquels vous collaborez.`,
    hi: `\u{906}\u{92A}\u{915}\u{93E} \u{928}\u{93E}\u{92E}, \u{92C}\u{93E}\u{92F}\u{94B} \u{914}\u{930} \u{924}\u{938}\u{94D}\u{935}\u{940}\u{930} \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{94D}\u{92F}\u{932}\u{938} \u{92A}\u{930} \u{938}\u{93E}\u{930}\u{94D}\u{935}\u{91C}\u{928}\u{93F}\u{915} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{926}\u{93F}\u{916}\u{93E}\u{908} \u{926}\u{947} \u{930}\u{939}\u{940} \u{939}\u{948}\u{964} \u{906}\u{92A}\u{915}\u{93E} \u{908}\u{92E}\u{947}\u{932} \u{92A}\u{924}\u{93E}, \u{92B}\u{93C}\u{94B}\u{928} \u{928}\u{902}\u{92C}\u{930} \u{914}\u{930} \u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{93E}\u{932}\u{92F} \u{938}\u{947} \u{92C}\u{93E}\u{939}\u{930} \u{915}\u{940} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{915}\u{947}\u{935}\u{932} \u{909}\u{928} \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{94D}\u{92F}\u{932}\u{938} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{926}\u{93F}\u{916}\u{93E}\u{908} \u{926}\u{947}\u{924}\u{940} \u{939}\u{948} \u{91C}\u{93F}\u{928}\u{915}\u{947} \u{938}\u{93E}\u{925} \u{906}\u{92A} \u{938}\u{939}\u{92F}\u{94B}\u{917} \u{915}\u{930} \u{930}\u{939}\u{947} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Non ou, bio ak foto yo piblikman vizib sou Cumulus. Adr\xe8s imel ou, nimewo telef\xf2n ou, ak estati ou-of-biwo yo s\xe8lman vizib pou manm Cumulus ou ap kolabore av\xe8k yo.`,
    it: `Il tuo nome, la tua biografia e la tua foto sono visibili pubblicamente su Cumulus. Il tuo indirizzo email, numeri di telefono e stato di assenza sono visibili solo ai membri Cumulus con cui collabori.`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{540D}\u{524D}\u{3001}\u{30D7}\u{30ED}\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{3001}\u{5199}\u{771F}\u{306F}Cumulus\u{3067}\u{516C}\u{958B}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}\u{30E1}\u{30FC}\u{30EB}\u{30A2}\u{30C9}\u{30EC}\u{30B9}\u{3001}\u{96FB}\u{8A71}\u{756A}\u{53F7}\u{3001}\u{4E0D}\u{5728}\u{72B6}\u{6CC1}\u{306F}\u{3001}\u{5354}\u{529B}\u{3057}\u{3066}\u{3044}\u{308B}Cumulus\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{306E}\u{307F}\u{306B}\u{516C}\u{958B}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{B2F9}\u{C2E0}\u{C758} \u{C774}\u{B984}, \u{C57D}\u{B825}, \u{C0AC}\u{C9C4}\u{C740} Cumulus\u{C5D0} \u{ACF5}\u{AC1C}\u{B418}\u{C5B4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C774}\u{BA54}\u{C77C} \u{C8FC}\u{C18C}, \u{C804}\u{D654}\u{BC88}\u{D638}, \u{BD80}\u{C7AC} \u{C5EC}\u{BD80}\u{B294} \u{D611}\u{C5C5} \u{C911}\u{C778} Cumulus \u{D68C}\u{C6D0}\u{C5D0}\u{AC8C}\u{B9CC} \u{BCFC} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Koj lub npe, bio thiab daim duab yog pej xeem pom ntawm Cumulus. Koj tus email chaw nyob, xov tooj, thiab cov xwm txheej tawm ntawm chaw ua haujlwm tsuas yog pom rau Cumulus cov tswv cuab uas koj koom tes nrog.`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{646}\u{648}\u{645}\u{60C} \u{698}\u{648}\u{646}\u{62F}\u{644}\u{6CC}\u{6A9}\u{60C} \u{627}\u{648} \u{639}\u{6A9}\u{633} \u{67E}\u{647} \u{6A9}\u{648}\u{645}\u{6CC}\u{648}\u{644}\u{633} \u{6A9}\u{6D0} \u{639}\u{627}\u{645} \u{645}\u{62D}\u{636}\u{631} \u{6A9}\u{6D0} \u{69A}\u{6A9}\u{627}\u{631}\u{647} \u{62F}\u{6CC}. \u{633}\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{67E}\u{62A}\u{647}\u{60C} \u{62F} \u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646} \u{634}\u{645}\u{6CC}\u{631}\u{6D0}\u{60C} \u{627}\u{648} \u{62F} \u{62F}\u{641}\u{62A}\u{631} \u{685}\u{62E}\u{647} \u{628}\u{647}\u{631} \u{62D}\u{627}\u{644}\u{62A} \u{6CC}\u{648}\u{627}\u{632}\u{6D0} \u{62F} Cumulus \u{647}\u{63A}\u{648} \u{63A}\u{693}\u{648} \u{62A}\u{647} \u{69A}\u{6A9}\u{627}\u{631}\u{647} \u{6A9}\u{6CC}\u{696}\u{6CC} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{648}\u{631}\u{633}\u{631}\u{647} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{6CC} \u{6A9}\u{648}\u{626}.`,
    pt: `Seu nome, biografia e foto est\xe3o publicamente vis\xedveis no Cumulus. Seu endere\xe7o de e-mail, n\xfameros de telefone e status de aus\xeancia s\xe3o vis\xedveis apenas para os membros da Cumulus com quem voc\xea est\xe1 colaborando.`,
    'pt-pt': `O teu nome, biografia e fotografia s\xe3o vis\xedveis publicamente na Cumulus. O seu endere\xe7o de email, n\xfameros de telefone e estado de aus\xeancia s\xf3 s\xe3o vis\xedveis para os membros da Cumulus com quem colabora.`,
    ru: `\u{412}\u{430}\u{448}\u{435} \u{438}\u{43C}\u{44F}, \u{431}\u{438}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{44F} \u{438} \u{444}\u{43E}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{44F} \u{43F}\u{443}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{43E} \u{432}\u{438}\u{434}\u{43D}\u{44B} \u{43D}\u{430} Cumulus. \u{412}\u{430}\u{448} \u{430}\u{434}\u{440}\u{435}\u{441} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{447}\u{442}\u{44B}, \u{43D}\u{43E}\u{43C}\u{435}\u{440}\u{430} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{43E}\u{432} \u{438} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441} \u{432}\u{43D}\u{435} \u{43E}\u{444}\u{438}\u{441}\u{430} \u{432}\u{438}\u{434}\u{43D}\u{44B} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{430}\u{43C} Cumulus, \u{441} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{43C}\u{438} \u{432}\u{44B} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{447}\u{430}\u{435}\u{442}\u{435}.`,
    sm: `O lou igoa, bio, ma le ata o lo'o fa'aalia lautele i luga o Cumulus. O lau tuatusi imeli, numera telefoni, ma le tulaga i fafo atu o le ofisa e na'o tagata o le Cumulus o lo'o e galulue fa'atasi e va'aia.`,
    so: `Magacaaga, taariikhdaada, iyo sawirkaaga si guud ayaa looga arki karaa Cumulus. Cinwaankaaga email-ka, lambarrada telefoonka, iyo xaaladda xafiiska ka baxsan waa la arki karaa oo kaliya xubnaha Cumulus ee aad la shaqeyneyso.`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D} \u{E1B}\u{E23}\u{E30}\u{E27}\u{E31}\u{E15}\u{E34} \u{E41}\u{E25}\u{E30}\u{E23}\u{E39}\u{E1B}\u{E20}\u{E32}\u{E1E}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E1B}\u{E23}\u{E32}\u{E01}\u{E0F}\u{E15}\u{E48}\u{E2D}\u{E2A}\u{E32}\u{E18}\u{E32}\u{E23}\u{E13}\u{E30}\u{E1A}\u{E19} Cumulus \u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25} \u{E2B}\u{E21}\u{E32}\u{E22}\u{E40}\u{E25}\u{E02}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C} \u{E41}\u{E25}\u{E30}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E44}\u{E21}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E4D}\u{E32}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E08}\u{E30}\u{E1B}\u{E23}\u{E32}\u{E01}\u{E0F}\u{E15}\u{E48}\u{E2D}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01} Cumulus \u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E31}\u{E19}\u{E40}\u{E17}\u{E48}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{627} \u{646}\u{627}\u{645}\u{60C} \u{633}\u{648}\u{627}\u{646}\u{62D} \u{639}\u{645}\u{631}\u{6CC}\u{60C} \u{627}\u{648}\u{631} \u{62A}\u{635}\u{648}\u{6CC}\u{631} Cumulus \u{67E}\u{631} \u{639}\u{648}\u{627}\u{645}\u{6CC} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{646}\u{638}\u{631} \u{622}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4} \u{622}\u{67E} \u{6A9}\u{627} \u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633}\u{60C} \u{641}\u{648}\u{646} \u{646}\u{645}\u{628}\u{631}\u{632}\u{60C} \u{627}\u{648}\u{631} \u{62F}\u{641}\u{62A}\u{631} \u{633}\u{6D2} \u{628}\u{627}\u{6C1}\u{631} \u{6C1}\u{648}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{62D}\u{627}\u{644}\u{62A} \u{635}\u{631}\u{641} \u{627}\u{646} \u{6A9}\u{6CC}\u{648}\u{645}\u{6CC}\u{648}\u{644}\u{633} \u{645}\u{645}\u{628}\u{631}\u{627}\u{646} \u{6A9}\u{648} \u{646}\u{638}\u{631} \u{622}\u{62A}\u{6CC} \u{6C1}\u{6D2} \u{62C}\u{646} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{622}\u{67E} \u{62A}\u{639}\u{627}\u{648}\u{646} \u{6A9}\u{631} \u{631}\u{6C1}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `T\xean, ti\u{1EC3}u s\u{1EED} v\xe0 h\xecnh \u{1EA3}nh c\u{1EE7}a b\u{1EA1}n \u{111}\u{1B0}\u{1EE3}c hi\u{1EC3}n th\u{1ECB} c\xf4ng khai tr\xean Cumulus. \u{110}\u{1ECB}a ch\u{1EC9} email, s\u{1ED1} \u{111}i\u{1EC7}n tho\u{1EA1}i v\xe0 tr\u{1EA1}ng th\xe1i v\u{1EAF}ng m\u{1EB7}t c\u{1EE7}a b\u{1EA1}n ch\u{1EC9} hi\u{1EC3}n th\u{1ECB} v\u{1EDB}i c\xe1c th\xe0nh vi\xean Cumulus m\xe0 b\u{1EA1}n \u{111}ang c\u{1ED9}ng t\xe1c.`,
    'zh-hans': `\u{4F60}\u{7684}\u{59D3}\u{540D}\u{3001}\u{7B80}\u{4ECB}\u{548C}\u{7167}\u{7247}\u{90FD}\u{5DF2}\u{5728}Cumulus\u{4E0A}\u{516C}\u{5F00}\u{53EF}\u{89C1}\u{3002}\u{60A8}\u{7684}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{5730}\u{5740}\u{3001}\u{7535}\u{8BDD}\u{53F7}\u{7801}\u{548C}\u{4F11}\u{5047}\u{72B6}\u{6001}\u{4EC5}\u{5BF9}\u{60A8}\u{5408}\u{4F5C}\u{7684} Cumulus \u{6210}\u{5458}\u{53EF}\u{89C1}\u{3002}`,
    'zh-hant': `\u{4F60}\u{7684}\u{59D3}\u{540D}\u{3001}\u{7C21}\u{4ECB}\u{548C}\u{7167}\u{7247}\u{6703}\u{5728} Cumulus \u{4E0A}\u{516C}\u{958B}\u{986F}\u{793A}\u{3002}\u{60A8}\u{7684}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{5730}\u{5740}\u{3001}\u{96FB}\u{8A71}\u{865F}\u{78BC}\u{53CA}\u{4F11}\u{5047}\u{72C0}\u{614B}\u{50C5}\u{5C0D}\u{60A8}\u{5408}\u{4F5C}\u{7684} Cumulus \u{6703}\u{54E1}\u{53EF}\u{898B}\u{3002}`,
    en: `Your name, bio, and picture are publicly visible on Cumulus. Your email address, phone numbers, and out-of-office status are only visible to Cumulus members you are collaborating with.`
};
const $b11db1b62d4a8f76$export$199f6a9e175b2ff9 = {
    ar: `\u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639}`,
    de: `Projekt`,
    es: `Proyecto`,
    fa: `\u{67E}\u{631}\u{648}\u{698}\u{647}`,
    fil: `Proyekto`,
    fr: `Projet`,
    hi: `\u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E}`,
    ht: `Pwoj\xe8`,
    it: `Progetto`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}`,
    ko: `\u{D504}\u{B85C}\u{C81D}\u{D2B8}`,
    mww: `Qhov project`,
    ps: `\u{67E}\u{631}\u{648}\u{698}\u{647}`,
    pt: `Projeto`,
    'pt-pt': `Projeto`,
    ru: `\u{41F}\u{440}\u{43E}\u{435}\u{43A}\u{442}`,
    sm: `Galuega faatino`,
    so: `Mashruuc`,
    th: `\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679}`,
    vi: `D\u{1EF1} \xe1n`,
    'zh-hans': `\u{9879}\u{76EE}`,
    'zh-hant': `\u{8A08}\u{756B}`,
    en: `Project`
};
const $b11db1b62d4a8f76$export$2a505cf562ed1f0f = {
    ar: `\u{62A}\u{646}\u{638}\u{64A}\u{645} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639}`,
    de: `Projektorganisation`,
    es: `Organizaci\xf3n del proyecto`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{62F}\u{647}\u{6CC} \u{67E}\u{631}\u{648}\u{698}\u{647}`,
    fil: `Organisasyon ng proyekto`,
    fr: `Organisation du projet`,
    hi: `\u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E} \u{938}\u{902}\u{917}\u{920}\u{928}`,
    ht: `\xd2ganizasyon pwoj\xe8 a`,
    it: `Organizzazione del progetto`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{7DE8}\u{6210}`,
    ko: `\u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{C870}\u{C9C1}`,
    mww: `Lub koom haum Project`,
    ps: `\u{62F} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{62A}\u{646}\u{638}\u{6CC}\u{645}`,
    pt: `Organiza\xe7\xe3o do projeto`,
    'pt-pt': `Organiza\xe7\xe3o do projeto`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{430}`,
    sm: `Fa'alapotopotoga o poloketi`,
    so: `Qaab-dhismeedka mashruuca`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645}`,
    vi: `T\u{1ED5} ch\u{1EE9}c d\u{1EF1} \xe1n`,
    'zh-hans': `\u{9879}\u{76EE}\u{7EC4}\u{7EC7}`,
    'zh-hant': `\u{5C08}\u{6848}\u{7D44}\u{7E54}`,
    en: `Project organization`
};
const $b11db1b62d4a8f76$export$60f60aa90d727a55 = {
    ar: `\u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{62A}\u{639}\u{627}\u{648}\u{646} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{64A}\u{639} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{634}\u{627}\u{631}\u{643} \u{641}\u{64A}\u{647}\u{627}.`,
    de: `Organisationen, die an Projekten zusammenarbeiten, an denen Sie teilnehmen.`,
    es: `Organizaciones que colaboran en proyectos en los que participas.`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{647}\u{627}\u{6CC}\u{6CC} \u{6A9}\u{647} \u{631}\u{648}\u{6CC} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{647}\u{627}\u{6CC}\u{6CC} \u{6A9}\u{647} \u{634}\u{645}\u{627} \u{62F}\u{631} \u{622}\u{646} \u{647}\u{627} \u{634}\u{631}\u{6A9}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{6CC} \u{645}\u{6CC} \u{6A9}\u{646}\u{646}\u{62F}.`,
    fil: `Mga organisasyong nakikipagtulungan sa mga proyektong iyong kinabibilangan.`,
    fr: `Des organisations qui collaborent sur des projets auxquels vous participez.`,
    hi: `\u{91C}\u{93F}\u{928} \u{938}\u{902}\u{917}\u{920}\u{928}\u{94B}\u{902} \u{92E}\u{947}\u{902} \u{906}\u{92A} \u{92D}\u{93E}\u{917} \u{932}\u{947} \u{930}\u{939}\u{947} \u{939}\u{948}\u{902}, \u{909}\u{928} \u{92A}\u{930} \u{938}\u{939}\u{92F}\u{94B}\u{917} \u{915}\u{930} \u{930}\u{939}\u{947} \u{939}\u{948}\u{902}\u{964}`,
    ht: `\xd2ganizasyon k ap kolabore sou pwoj\xe8 w ap patisipe nan.`,
    it: `Organizzazioni che collaborano su progetti a cui partecipi.`,
    ja: `\u{3042}\u{306A}\u{305F}\u{304C}\u{53C2}\u{52A0}\u{3057}\u{3066}\u{3044}\u{308B}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{3067}\u{5354}\u{529B}\u{3057}\u{3066}\u{3044}\u{308B}\u{7D44}\u{7E54}\u{3002}`,
    ko: `\u{C5EC}\u{B7EC}\u{BD84}\u{C774} \u{CC38}\u{C5EC}\u{D558}\u{B294} \u{D504}\u{B85C}\u{C81D}\u{D2B8}\u{C5D0} \u{D611}\u{B825}\u{D558}\u{B294} \u{C870}\u{C9C1}\u{B4E4}.`,
    mww: `Cov koom haum koom tes ntawm cov haujlwm uas koj tab tom koom nrog.`,
    ps: `\u{647}\u{63A}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{647} \u{686}\u{6D0} \u{67E}\u{647} \u{647}\u{63A}\u{648} \u{67E}\u{631}\u{648}\u{698}\u{648} \u{6A9}\u{6D0} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{6CC} \u{6A9}\u{648}\u{6CC} \u{686}\u{6D0} \u{62A}\u{647} \u{67E}\u{6A9}\u{6D0} \u{628}\u{631}\u{62E}\u{647} \u{627}\u{62E}\u{644}\u{6CC}.`,
    pt: `Organiza\xe7\xf5es colaborando em projetos dos quais voc\xea est\xe1 participando.`,
    'pt-pt': `Organiza\xe7\xf5es que colaboram em projetos em que est\xe1 a participar.`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{435} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{447}\u{430}\u{44E}\u{442} \u{43D}\u{430}\u{434} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{430}\u{43C}\u{438}, \u{432} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{445} \u{432}\u{44B} \u{443}\u{447}\u{430}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442}\u{435}.`,
    sm: `Fa'alapotopotoga o lo'o galulue fa'atasi i poloketi o lo'o e auai.`,
    so: `Ururada iska kaashanaya mashaariicda aad ka qayb qaadanayso.`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E31}\u{E19}\u{E43}\u{E19}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}`,
    ur: `\u{648}\u{6C1} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{6CC}\u{6BA} \u{62C}\u{648} \u{622}\u{67E} \u{6A9}\u{6D2} \u{627}\u{646} \u{645}\u{646}\u{635}\u{648}\u{628}\u{648}\u{6BA} \u{67E}\u{631} \u{62A}\u{639}\u{627}\u{648}\u{646} \u{6A9}\u{631} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{62C}\u{646} \u{645}\u{6CC}\u{6BA} \u{622}\u{67E} \u{62D}\u{635}\u{6C1} \u{644}\u{6D2} \u{631}\u{6C1}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `C\xe1c t\u{1ED5} ch\u{1EE9}c c\u{1ED9}ng t\xe1c trong c\xe1c d\u{1EF1} \xe1n m\xe0 b\u{1EA1}n \u{111}ang tham gia.`,
    'zh-hans': `\u{7EC4}\u{7EC7}\u{4E0E}\u{4F60}\u{53C2}\u{4E0E}\u{7684}\u{9879}\u{76EE}\u{5408}\u{4F5C}\u{3002}`,
    'zh-hant': `\u{7D44}\u{7E54}\u{8207}\u{4F60}\u{5408}\u{4F5C}\u{53C3}\u{8207}\u{7684}\u{5C08}\u{6848}\u{3002}`,
    en: `Organizations collaborating on projects you are participating in.`
};
const $b11db1b62d4a8f76$export$1465cd6a5dc70bb9 = {
    ar: `\u{645}\u{646}\u{638}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639}`,
    de: `Projektorganisationen`,
    es: `Organizaciones del proyecto`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{647}\u{627}\u{6CC} \u{67E}\u{631}\u{648}\u{698}\u{647}`,
    fil: `Mga organisasyon ng proyekto`,
    fr: `Organisations de projet`,
    hi: `\u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E} \u{938}\u{902}\u{917}\u{920}\u{928}`,
    ht: `\xd2ganizasyon pwoj\xe8 yo`,
    it: `Organizzazioni di progetto`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{7D44}\u{7E54}`,
    ko: `\u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{C870}\u{C9C1}`,
    mww: `Cov koom haum Project`,
    ps: `\u{62F} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{647}`,
    pt: `Organiza\xe7\xf5es do projeto`,
    'pt-pt': `Organiza\xe7\xf5es de projeto`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{43E}\u{432}`,
    sm: `Fa'alapotopotoga o Poloketi`,
    so: `Ururada mashruuca`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{6CC}\u{6BA}`,
    vi: `T\u{1ED5} ch\u{1EE9}c d\u{1EF1} \xe1n`,
    'zh-hans': `\u{9879}\u{76EE}\u{7EC4}\u{7EC7}`,
    'zh-hant': `\u{5C08}\u{6848}\u{7D44}\u{7E54}`,
    en: `Project organizations`
};
const $b11db1b62d4a8f76$export$223a3cbc60d01473 = {
    ar: `\u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{64A}\u{639}`,
    de: `Projekte`,
    es: `Proyectos`,
    fa: `\u{67E}\u{631}\u{648}\u{698}\u{647} \u{647}\u{627}`,
    fil: `Mga proyekto`,
    fr: `Projets`,
    hi: `\u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E}\u{913}\u{902}`,
    ht: `Pwoj\xe8 yo`,
    it: `Progetti`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}`,
    ko: `\u{D504}\u{B85C}\u{C81D}\u{D2B8}`,
    mww: `Tej yaam num`,
    ps: `\u{67E}\u{631}\u{648}\u{698}\u{6D0}`,
    pt: `Projetos`,
    'pt-pt': `Projetos`,
    ru: `\u{41F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{44B}`,
    sm: `Galuega faatino`,
    so: `Mashaariicda`,
    th: `\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2}`,
    vi: `D\u{1EF1} \xe1n`,
    'zh-hans': `\u{9879}\u{76EE}`,
    'zh-hant': `\u{5C08}\u{6848}`,
    en: `Projects`
};
const $b11db1b62d4a8f76$export$707a8412863caea1 = {
    ar: `\u{625}\u{639}\u{62F}\u{627}\u{62F}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639}`,
    de: `Projektsettings`,
    es: `Configuraci\xf3n del proyecto`,
    fa: `\u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{627}\u{62A} \u{67E}\u{631}\u{648}\u{698}\u{647}`,
    fil: `Mga setting ng proyekto`,
    fr: `Param\xe8tres du projet`,
    hi: `\u{92A}\u{94D}\u{930}\u{94B}\u{91C}\u{947}\u{915}\u{94D}\u{91F} \u{938}\u{947}\u{91F}\u{93F}\u{902}\u{917}\u{94D}\u{938}`,
    ht: `Anviw\xf2nman pwoj\xe8`,
    it: `Ambientazioni del progetto`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{8A2D}\u{5B9A}`,
    ko: `\u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{C124}\u{C815}`,
    mww: `Cov phiaj xwm teeb tsa`,
    ps: `\u{62F} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{627}\u{62A}`,
    pt: `Configura\xe7\xf5es do projeto`,
    'pt-pt': `Cen\xe1rios do projeto`,
    ru: `\u{41D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{438} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{430}`,
    sm: `Tulaga o galuega faatino`,
    so: `Dejinta mashruuca`,
    th: `\u{E01}\u{E32}\u{E23}\u{E15}\u{E31}\u{E49}\u{E07}\u{E04}\u{E48}\u{E32}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679} \u{633}\u{6CC}\u{679}\u{646}\u{6AF}\u{632}`,
    vi: `C\xe0i \u{111}\u{1EB7}t d\u{1EF1} \xe1n`,
    'zh-hans': `\u{9879}\u{76EE}\u{8BBE}\u{7F6E}`,
    'zh-hant': `\u{5C08}\u{6848}\u{8A2D}\u{5B9A}`,
    en: `Project settings`
};
const $b11db1b62d4a8f76$export$8c1159d8bda8df7d = {
    ar: (org, project)=>$b11db1b62d4a8f76$var$html`<span>مقدم من ${org} من خلال مشروع ${project} .</span>`,
    de: (org, project)=>$b11db1b62d4a8f76$var$html`<span>Bereitgestellt von ${org} im Rahmen des ${project} Projekts.</span>`,
    es: (org, project)=>$b11db1b62d4a8f76$var$html`<span>Proporcionado por ${org} a través del proyecto ${project} .</span>`,
    fa: (org, project)=>$b11db1b62d4a8f76$var$html`<span>ارائه شده توسط ${org} از طریق ${project} .</span>`,
    fil: (org, project)=>$b11db1b62d4a8f76$var$html`<span>Ibinigay ng ${org} sa pamamagitan ng proyekto ng ${project} .</span>`,
    fr: (org, project)=>$b11db1b62d4a8f76$var$html`<span>Fourni par ${org} via le projet ${project} Project.</span>`,
    hi: (org, project)=>$b11db1b62d4a8f76$var$html`<span>${project} परियोजना के माध्यम से ${org} द्वारा प्रदान किया गया।</span>`,
    ht: (org, project)=>$b11db1b62d4a8f76$var$html`<span>Founi ${org} atravè pwojè ${project} a.</span>`,
    it: (org, project)=>$b11db1b62d4a8f76$var$html`<span>Fornito da ${org} attraverso il progetto ${project} .</span>`,
    ja: (org, project)=>$b11db1b62d4a8f76$var$html`<span>リ ${org} が ${project} を通じて提供しています。</span>`,
    ko: (org, project)=>$b11db1b62d4a8f76$var$html`<span>리 ${org} 드는 ${project} 프로젝트를 통해 제공했습니다.</span>`,
    mww: (org, project)=>$b11db1b62d4a8f76$var$html`<span>Muab los ntawm ${org} los ntawm ${project} project.</span>`,
    ps: (org, project)=>$b11db1b62d4a8f76$var$html`<span>د ${org} لخوا د ${project} پروژې له لارې برابر شوی.</span>`,
    pt: (org, project)=>$b11db1b62d4a8f76$var$html`<span>Fornecido pelo ${org} através do projeto ${project} Project.</span>`,
    'pt-pt': (org, project)=>$b11db1b62d4a8f76$var$html`<span>Fornecido pela ${org} através do projeto ${project} .</span>`,
    ru: (org, project)=>$b11db1b62d4a8f76$var$html`<span>Предоставлено ${org} через проект ${project} .</span>`,
    sm: (org, project)=>$b11db1b62d4a8f76$var$html`<span>Saunia e ${org} e ala i le poloketi o le ${project} .</span>`,
    so: (org, project)=>$b11db1b62d4a8f76$var$html`<span>Waxaa bixiyay ${org} iyada oo loo marayo mashruuca ${project} .</span>`,
    th: (org, project)=>$b11db1b62d4a8f76$var$html`<span>จัดทําโดย ${org} ผ่านโครงการ${project}</span>`,
    ur: (org, project)=>$b11db1b62d4a8f76$var$html`<span>${org} کی جانب سے ${project} پروجیکٹ کے ذریعے فراہم کیا گیا۔</span>`,
    vi: (org, project)=>$b11db1b62d4a8f76$var$html`<span>Được cung cấp bởi ${org} thông qua dự ${project} .</span>`,
    'zh-hans': (org, project)=>$b11db1b62d4a8f76$var$html`<span>由 ${org} 通过 ${project} 提供。</span>`,
    'zh-hant': (org, project)=>$b11db1b62d4a8f76$var$html`<span>由 ${org} 透過 ${project} 提供。</span>`,
    en: (org, project)=>$b11db1b62d4a8f76$var$html`<span>Provided by ${org} through the ${project} project.</span>`
};
const $b11db1b62d4a8f76$export$178bd34954964b38 = {
    ar: `\u{627}\u{644}\u{639}\u{627}\u{645}`,
    de: `\xd6ffentlich`,
    es: `P\xfablico`,
    fa: `\u{639}\u{645}\u{648}\u{645}`,
    fil: `Publiko`,
    fr: `Public`,
    hi: `\u{938}\u{93E}\u{930}\u{94D}\u{935}\u{91C}\u{928}\u{93F}\u{915}`,
    ht: `Piblik`,
    it: `Pubblico`,
    ja: `\u{516C}\u{5171}`,
    ko: `\u{ACF5}\u{ACF5}`,
    mww: `Pej xeem`,
    ps: `\u{639}\u{627}\u{645}\u{647}`,
    pt: `P\xfablico`,
    'pt-pt': `P\xfablico`,
    ru: `\u{41E}\u{431}\u{449}\u{435}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Tagata lautele`,
    so: `Dadweynaha`,
    th: `\u{E2A}\u{E32}\u{E18}\u{E32}\u{E23}\u{E13}\u{E30}`,
    ur: `\u{639}\u{648}\u{627}\u{645}\u{6CC}`,
    vi: `C\xf4ng c\u{1ED9}ng`,
    'zh-hans': `\u{516C}\u{5171}`,
    'zh-hant': `\u{516C}\u{5171}`,
    en: `Public`
};
const $b11db1b62d4a8f76$export$8f9aad74ce8cb2cb = {
    ar: `\u{627}\u{644}\u{648}\u{635}\u{648}\u{644} \u{627}\u{644}\u{639}\u{627}\u{645} \u{625}\u{644}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646}`,
    de: `\xd6ffentlicher Zugang zu diesem Fragebogen`,
    es: `Acceso p\xfablico a este cuestionario`,
    fa: `\u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{639}\u{645}\u{648}\u{645}\u{6CC} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647}`,
    fil: `Pag-access ng publiko sa palatanungan na ito`,
    fr: `Acc\xe8s public \xe0 ce questionnaire`,
    hi: `\u{907}\u{938} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{93E}\u{935}\u{932}\u{940} \u{924}\u{915} \u{938}\u{93E}\u{930}\u{94D}\u{935}\u{91C}\u{928}\u{93F}\u{915} \u{92A}\u{939}\u{941}\u{902}\u{91A}`,
    ht: `Aks\xe8 piblik la a kesyon\xe8 sa a`,
    it: `Accesso pubblico a questo questionario`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}\u{3078}\u{306E}\u{4E00}\u{822C}\u{516C}\u{958B}\u{30A2}\u{30AF}\u{30BB}\u{30B9}`,
    ko: `\u{C774} \u{C124}\u{BB38}\u{C9C0}\u{C5D0} \u{B300}\u{D55C} \u{B300}\u{C911} \u{C811}\u{ADFC}`,
    mww: `Pej xeem nkag mus rau cov lus nug no`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9} \u{62A}\u{647} \u{639}\u{627}\u{645}\u{647} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC}`,
    pt: `Acesso p\xfablico a este question\xe1rio`,
    'pt-pt': `Acesso p\xfablico a este question\xe1rio`,
    ru: `\u{41E}\u{431}\u{449}\u{435}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{43A} \u{44D}\u{442}\u{43E}\u{43C}\u{443} \u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{43D}\u{438}\u{43A}\u{443}`,
    sm: `Avanoa lautele i lenei fesili`,
    so: `Helitaanka dadweynaha ee su'aalahan`,
    th: `\u{E01}\u{E32}\u{E23}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}\u{E19}\u{E35}\u{E49}\u{E42}\u{E14}\u{E22}\u{E2A}\u{E32}\u{E18}\u{E32}\u{E23}\u{E13}\u{E30}`,
    ur: `\u{627}\u{633} \u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6D2} \u{62A}\u{6A9} \u{639}\u{648}\u{627}\u{645}\u{6CC} \u{631}\u{633}\u{627}\u{626}\u{6CC}`,
    vi: `Truy c\u{1EAD}p c\xf4ng khai v\xe0o b\u{1EA3}ng c\xe2u h\u{1ECF}i n\xe0y`,
    'zh-hans': `\u{516C}\u{4F17}\u{53EF}\u{8BBF}\u{95EE}\u{6B64}\u{95EE}\u{5377}`,
    'zh-hant': `\u{516C}\u{773E}\u{53EF}\u{53D6}\u{5F97}\u{6B64}\u{554F}\u{5377}`,
    en: `Public access to this questionnaire`
};
const $b11db1b62d4a8f76$export$a063efdd29fc6d29 = {
    ar: `\u{644}\u{645} \u{62A}\u{639}\u{62F} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{627}\u{62A} \u{645}\u{642}\u{628}\u{648}\u{644}\u{629}.`,
    de: `Einsendungen werden nicht mehr angenommen.`,
    es: `Ya no se aceptan propuestas.`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644} \u{647}\u{627} \u{62F}\u{6CC}\u{6AF}\u{631} \u{67E}\u{630}\u{6CC}\u{631}\u{641}\u{62A}\u{647} \u{646}\u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: `Hindi na tinatanggap ang mga pagsusumite.`,
    fr: `Les soumissions ne sont plus accept\xe9es.`,
    hi: `\u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924}\u{93F}\u{92F}\u{93E}\u{901} \u{905}\u{92C} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{91C}\u{93E} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Soum\xe8t yo pa aksepte ank\xf2.`,
    it: `Le proposte non vengono pi\xf9 accettate.`,
    ja: `\u{6295}\u{7A3F}\u{306F}\u{3082}\u{3046}\u{53D7}\u{3051}\u{4ED8}\u{3051}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{B354} \u{C774}\u{C0C1} \u{C81C}\u{CD9C}\u{C774} \u{C811}\u{C218}\u{B418}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Kev xa tawm tsis raug lees txais lawm.`,
    ps: `\u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{6D0} \u{646}\u{648}\u{631} \u{646}\u{647} \u{645}\u{646}\u{644} \u{6A9}\u{6D0}\u{696}\u{6CC}.`,
    pt: `As inscri\xe7\xf5es n\xe3o est\xe3o mais sendo aceitas.`,
    'pt-pt': `As submiss\xf5es j\xe1 n\xe3o est\xe3o a ser aceites.`,
    ru: `\u{41F}\u{443}\u{431}\u{43B}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{438} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{43D}\u{435} \u{43F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{44E}\u{442}\u{441}\u{44F}.`,
    sm: `E le o toe taliaina talosaga.`,
    so: `Soo gudbinta hadda lama aqbalo.`,
    th: `\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E2D}\u{E35}\u{E01}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}`,
    ur: `\u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{627}\u{626}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA} \u{627}\u{628} \u{642}\u{628}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{62C}\u{627} \u{631}\u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `B\xe0i d\u{1EF1} thi kh\xf4ng c\xf2n \u{111}\u{1B0}\u{1EE3}c ch\u{1EA5}p nh\u{1EAD}n.`,
    'zh-hans': `\u{6295}\u{7A3F}\u{4E0D}\u{518D}\u{63A5}\u{53D7}\u{3002}`,
    'zh-hant': `\u{6295}\u{7A3F}\u{5DF2}\u{4E0D}\u{518D}\u{63A5}\u{53D7}\u{3002}`,
    en: `Submissions are no longer being accepted.`
};
const $b11db1b62d4a8f76$export$63ea46d9afebdb1d = {
    ar: (parentType, endDate)=>`\u{644}\u{645} \u{62A}\u{639}\u{62F} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{627}\u{62A} \u{645}\u{642}\u{628}\u{648}\u{644}\u{629}. \u{627}\u{646}\u{62A}\u{647}\u{62A} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{627}\u{62A} \u{644}\u{647}\u{630}\u{627} ${parentType} \u{641}\u{64A} ${endDate}.`,
    de: (parentType, endDate)=>`Einsendungen werden nicht mehr angenommen. Die Einreichungen f\xfcr diese ${parentType} endeten am ${endDate}.`,
    es: (parentType, endDate)=>`Ya no se aceptan propuestas. Las inscripciones para este ${parentType} finalizaron el ${endDate}.`,
    fa: (parentType, endDate)=>`\u{627}\u{631}\u{633}\u{627}\u{644} \u{647}\u{627} \u{62F}\u{6CC}\u{6AF}\u{631} \u{67E}\u{630}\u{6CC}\u{631}\u{641}\u{62A}\u{647} \u{646}\u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}. \u{627}\u{631}\u{633}\u{627}\u{644} \u{622}\u{62B}\u{627}\u{631} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{6CC}\u{646} ${parentType} \u{62F}\u{631} ${endDate} \u{628}\u{647} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{631}\u{633}\u{6CC}\u{62F}.`,
    fil: (parentType, endDate)=>`Hindi na tinatanggap ang mga pagsusumite. Natapos ang mga pagsusumite para sa ${parentType} ito noong ${endDate}.`,
    fr: (parentType, endDate)=>`Les soumissions ne sont plus accept\xe9es. Les soumissions pour cet ${parentType} se sont termin\xe9es le ${endDate}.`,
    hi: (parentType, endDate)=>`\u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924}\u{93F}\u{92F}\u{93E}\u{901} \u{905}\u{92C} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{91C}\u{93E} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902}\u{964} \u{907}\u{938} ${parentType} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924}\u{93F}\u{92F}\u{93E}\u{901} ${endDate} \u{915}\u{94B} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{917}\u{908}\u{902}\u{964}`,
    ht: (parentType, endDate)=>`Soum\xe8t yo pa aksepte ank\xf2. Soum\xe8t yo te fini pou ${parentType} sa a ${endDate}`,
    it: (parentType, endDate)=>`Le proposte non vengono pi\xf9 accettate. Le iscrizioni per questo ${parentType} si sono concluse il ${endDate}.`,
    ja: (parentType, endDate)=>`\u{6295}\u{7A3F}\u{306F}\u{3082}\u{3046}\u{53D7}\u{3051}\u{4ED8}\u{3051}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}\u{3053}\u{306E} ${parentType} \u{306E}\u{5FDC}\u{52DF}\u{306F} ${endDate}\u{65E5}\u{306B}\u{7DE0}\u{3081}\u{5207}\u{3089}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: (parentType, endDate)=>`\u{B354} \u{C774}\u{C0C1} \u{C81C}\u{CD9C}\u{C774} \u{C811}\u{C218}\u{B418}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C774} ${parentType} \u{C758} \u{C81C}\u{CD9C} \u{B9C8}\u{AC10} ${endDate}\u{C77C}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (parentType, endDate)=>`Kev xa tawm tsis raug lees txais lawm. Kev xa tawm xaus rau qhov ${parentType} no thaum ${endDate}.`,
    ps: (parentType, endDate)=>`\u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{6D0} \u{646}\u{648}\u{631} \u{646}\u{647} \u{645}\u{646}\u{644} \u{6A9}\u{6D0}\u{696}\u{6CC}. \u{62F} \u{62F}\u{6D0} ${parentType} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{6D0} \u{62F} ${endDate} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{6D0}\u{62F}\u{6D0}.`,
    pt: (parentType, endDate)=>`As inscri\xe7\xf5es n\xe3o est\xe3o mais sendo aceitas. As inscri\xe7\xf5es para este ${parentType} terminaram em ${endDate}.`,
    'pt-pt': (parentType, endDate)=>`As submiss\xf5es j\xe1 n\xe3o est\xe3o a ser aceites. As submiss\xf5es para este ${parentType} terminaram a ${endDate}.`,
    ru: (parentType, endDate)=>`\u{41F}\u{443}\u{431}\u{43B}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{438} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{43D}\u{435} \u{43F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{44E}\u{442}\u{441}\u{44F}. \u{41F}\u{440}\u{438}\u{451}\u{43C} \u{437}\u{430}\u{44F}\u{432}\u{43E}\u{43A} \u{43D}\u{430} ${parentType} ${endDate}.`,
    sm: (parentType, endDate)=>`E le o toe taliaina talosaga. O le aso ${endDate} na fa'amutaina ai le talosaga mo lenei ${parentType}.`,
    so: (parentType, endDate)=>`Soo gudbinta hadda lama aqbalo. Soo gudbinta tartankan waxay ${parentType} ${endDate}.`,
    th: (parentType, endDate)=>`\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E2D}\u{E35}\u{E01}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B} \u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E1C}\u{E25}\u{E07}\u{E32}\u{E19}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E25}\u{E07}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}${parentType}\u{E19}\u{E35}\u{E49}\u{E43}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48} ${endDate}`,
    ur: (parentType, endDate)=>`\u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{627}\u{626}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA} \u{627}\u{628} \u{642}\u{628}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{62C}\u{627} \u{631}\u{6C1}\u{6CC}\u{6BA}\u{6D4} \u{627}\u{633} ${parentType} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{633}\u{628}\u{645}\u{6CC}\u{634}\u{646}\u{632} ${endDate}`,
    vi: (parentType, endDate)=>`B\xe0i d\u{1EF1} thi kh\xf4ng c\xf2n \u{111}\u{1B0}\u{1EE3}c ch\u{1EA5}p nh\u{1EAD}n. Vi\u{1EC7}c g\u{1EED}i k\u{1EBF}t th\xfac cho ${parentType} n\xe0y v\xe0o ${endDate}.`,
    'zh-hans': (parentType, endDate)=>`\u{6295}\u{7A3F}\u{4E0D}\u{518D}\u{63A5}\u{53D7}\u{3002}\u{672C}\u{6B21} ${parentType} \u{7684}\u{6295}\u{7A3F}\u{622A}\u{6B62}\u{65E5}\u{671F}\u{4E3A} ${endDate}\u{65E5}\u{3002}`,
    'zh-hant': (parentType, endDate)=>`\u{6295}\u{7A3F}\u{5DF2}\u{4E0D}\u{518D}\u{63A5}\u{53D7}\u{3002}\u{672C}\u{6B21} ${parentType} \u{7684}\u{6295}\u{7A3F}\u{622A}\u{6B62}\u{65E5}\u{671F}\u{70BA} ${endDate}\u{65E5}\u{3002}`,
    en: (parentType, endDate)=>`Submissions are no longer being accepted. Submissions ended for this ${parentType} on ${endDate}.`
};
const $b11db1b62d4a8f76$export$9d1cf369ea644da7 = {
    ar: (parentType)=>`\u{62A}\u{645} \u{625}\u{644}\u{63A}\u{627}\u{621} \u{647}\u{630}\u{627} ${parentType} . \u{644}\u{627} \u{64A}\u{62A}\u{645} \u{642}\u{628}\u{648}\u{644} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{627}\u{62A} \u{641}\u{64A} \u{627}\u{644}\u{648}\u{642}\u{62A} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}.`,
    de: (parentType)=>`Diese ${parentType} wurde abgesagt. Einsendungen werden derzeit nicht entgegengenommen.`,
    es: (parentType)=>`Este ${parentType} fue cancelado. No se aceptan propuestas en este momento.`,
    fa: (parentType)=>`\u{627}\u{6CC}\u{646} ${parentType} \u{644}\u{63A}\u{648} \u{634}\u{62F}. \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{62D}\u{627}\u{636}\u{631} \u{627}\u{631}\u{633}\u{627}\u{644} \u{647}\u{627} \u{67E}\u{630}\u{6CC}\u{631}\u{641}\u{62A}\u{647} \u{646}\u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: (parentType)=>`Kinansela ang ${parentType} na ito. Ang mga pagsusumite ay hindi tinatanggap sa oras na ito.`,
    fr: (parentType)=>`Cet ${parentType} a \xe9t\xe9 annul\xe9. Les soumissions ne sont pas accept\xe9es pour le moment.`,
    hi: (parentType)=>`\u{907}\u{938} ${parentType} \u{915}\u{94B} \u{930}\u{926}\u{94D}\u{926} \u{915}\u{930} \u{926}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E}\u{964} \u{907}\u{938} \u{938}\u{92E}\u{92F} \u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924}\u{93F}\u{92F}\u{93E}\u{901} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{91C}\u{93E} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902}\u{964}`,
    ht: (parentType)=>`${parentType} sa a te anile Soum\xe8t yo pa aksepte nan moman sa a.`,
    it: (parentType)=>`Questo ${parentType} \xe8 stato cancellato. Al momento non vengono accettate candidature.`,
    ja: (parentType)=>`\u{3053}\u{306E} ${parentType} \u{306F}\u{4E2D}\u{6B62}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}\u{73FE}\u{6642}\u{70B9}\u{3067}\u{306F}\u{6295}\u{7A3F}\u{3092}\u{53D7}\u{3051}\u{4ED8}\u{3051}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (parentType)=>`\u{C774} ${parentType} \u{B294} \u{CDE8}\u{C18C}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{D604}\u{C7AC} \u{C81C}\u{CD9C} \u{C811}\u{C218}\u{B418}\u{C9C0} \u{C54A}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (parentType)=>`Qhov ${parentType} no tau muab tso tseg. Cov ntawv xa tawm tsis raug lees txais lub sijhawm no.`,
    ps: (parentType)=>`\u{62F}\u{627} ${parentType} \u{644}\u{63A}\u{648}\u{647} \u{634}\u{648}\u{647}. \u{62F}\u{627} \u{645}\u{647}\u{627}\u{644} \u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{6D0} \u{646}\u{647} \u{645}\u{646}\u{644} \u{6A9}\u{6D0}\u{696}\u{6CC}.`,
    pt: (parentType)=>`Esse ${parentType} foi cancelado. As submiss\xf5es n\xe3o est\xe3o sendo aceitas no momento.`,
    'pt-pt': (parentType)=>`Este ${parentType} foi cancelado. As submiss\xf5es n\xe3o est\xe3o a ser aceites neste momento.`,
    ru: (parentType)=>`${parentType} \u{431}\u{44B}\u{43B}\u{43E} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{43E}. \u{412} \u{43D}\u{430}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{435}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F} \u{437}\u{430}\u{44F}\u{432}\u{43A}\u{438} \u{43D}\u{435} \u{43F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{44E}\u{442}\u{441}\u{44F}.`,
    sm: (parentType)=>`O lenei ${parentType} na faaleaogaina. E le o taliaina talosaga i le taimi nei.`,
    so: (parentType)=>`${parentType} waa la joojiyay. Soo gudbinta lama aqbalayo waqtigan.`,
    th: (parentType)=>`${parentType}\u{E19}\u{E35}\u{E49}\u{E16}\u{E39}\u{E01}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01} \u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E43}\u{E19}\u{E02}\u{E13}\u{E30}\u{E19}\u{E35}\u{E49}`,
    ur: (parentType)=>`\u{6CC}\u{6C1} ${parentType} \u{645}\u{646}\u{633}\u{648}\u{62E} \u{6A9}\u{631} \u{62F}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}\u{6D4} \u{627}\u{633} \u{648}\u{642}\u{62A} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{627}\u{626}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA} \u{642}\u{628}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{62C}\u{627} \u{631}\u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (parentType)=>`${parentType} n\xe0y \u{111}\xe3 b\u{1ECB} h\u{1EE7}y b\u{1ECF}. B\xe0i d\u{1EF1} thi kh\xf4ng \u{111}\u{1B0}\u{1EE3}c ch\u{1EA5}p nh\u{1EAD}n t\u{1EA1}i th\u{1EDD}i \u{111}i\u{1EC3}m n\xe0y.`,
    'zh-hans': (parentType)=>`\u{8BE5} ${parentType} \u{88AB}\u{53D6}\u{6D88}\u{3002}\u{76EE}\u{524D}\u{4E0D}\u{63A5}\u{53D7}\u{6295}\u{7A3F}\u{3002}`,
    'zh-hant': (parentType)=>`\u{8A72} ${parentType} \u{88AB}\u{53D6}\u{6D88}\u{3002}\u{76EE}\u{524D}\u{4E0D}\u{63A5}\u{53D7}\u{6295}\u{7A3F}\u{3002}`,
    en: (parentType)=>`This ${parentType} was cancelled. Submissions are not being accepted at this time.`
};
const $b11db1b62d4a8f76$export$8b4e6df3749387ef = {
    ar: `\u{627}\u{644}\u{62A}\u{642}\u{62F}\u{64A}\u{645} \u{644}\u{645} \u{64A}\u{641}\u{62A}\u{62D} \u{628}\u{639}\u{62F}.`,
    de: `Die Einreichungen sind noch nicht ge\xf6ffnet.`,
    es: `Las inscripciones a\xfan no est\xe1n abiertas.`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644} \u{622}\u{62B}\u{627}\u{631} \u{647}\u{646}\u{648}\u{632} \u{628}\u{627}\u{632} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Hindi pa bukas ang mga pagsusumite.`,
    fr: `Les soumissions ne sont pas encore ouvertes.`,
    hi: `\u{938}\u{92C}\u{92E}\u{93F}\u{936}\u{928} \u{905}\u{92D}\u{940} \u{924}\u{915} \u{916}\u{941}\u{932}\u{947} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Soum\xe8t yo pa louvri ank\xf2.`,
    it: `Le candidature non sono ancora aperte.`,
    ja: `\u{5FDC}\u{52DF}\u{306F}\u{307E}\u{3060}\u{53D7}\u{4ED8}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C544}\u{C9C1} \u{C81C}\u{CD9C}\u{C774} \u{C2DC}\u{C791}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Kev xa tawm tseem tsis tau qhib.`,
    ps: `\u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{6D0} \u{644}\u{627} \u{646}\u{647} \u{62F}\u{6CC} \u{67E}\u{631}\u{627}\u{646}\u{6CC}\u{633}\u{62A}\u{6D0}.`,
    pt: `As inscri\xe7\xf5es ainda n\xe3o est\xe3o abertas.`,
    'pt-pt': `As submiss\xf5es ainda n\xe3o est\xe3o abertas.`,
    ru: `\u{41F}\u{440}\u{438}\u{451}\u{43C} \u{437}\u{430}\u{44F}\u{432}\u{43E}\u{43A} \u{435}\u{449}\u{451} \u{43D}\u{435} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}.`,
    sm: `E le'i tatala talosaga i le taimi nei.`,
    so: `Soo gudbinta weli ma furan.`,
    th: `\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E40}\u{E1B}\u{E34}\u{E14}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E1C}\u{E25}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{627}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA} \u{627}\u{628}\u{6BE}\u{6CC} \u{62A}\u{6A9} \u{6A9}\u{6BE}\u{644}\u{6CC} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `B\xe0i d\u{1EF1} thi v\u{1EAB}n ch\u{1B0}a m\u{1EDF}.`,
    'zh-hans': `\u{6295}\u{7A3F}\u{5C1A}\u{672A}\u{5F00}\u{653E}\u{3002}`,
    'zh-hant': `\u{6295}\u{7A3F}\u{5C1A}\u{672A}\u{958B}\u{653E}\u{3002}`,
    en: `Submissions are not open yet.`
};
const $b11db1b62d4a8f76$export$50c79941ce29473c = {
    ar: (parentType, startDate)=>`\u{627}\u{644}\u{62A}\u{642}\u{62F}\u{64A}\u{645} \u{644}\u{645} \u{64A}\u{641}\u{62A}\u{62D} \u{628}\u{639}\u{62F}. \u{64A}\u{645}\u{643}\u{646}\u{643} \u{627}\u{644}\u{62A}\u{642}\u{62F}\u{64A}\u{645} \u{644}\u{647}\u{630}\u{627} ${parentType} \u{628}\u{62F}\u{621}\u{627} \u{645}\u{646} ${startDate}.`,
    de: (parentType, startDate)=>`Die Einreichungen sind noch nicht ge\xf6ffnet. Sie k\xf6nnen sich f\xfcr diese ${parentType} ab ${startDate} bewerben.`,
    es: (parentType, startDate)=>`Las inscripciones a\xfan no est\xe1n abiertas. Puedes postularte para este ${parentType} a partir del ${startDate}.`,
    fa: (parentType, startDate)=>`\u{627}\u{631}\u{633}\u{627}\u{644} \u{622}\u{62B}\u{627}\u{631} \u{647}\u{646}\u{648}\u{632} \u{628}\u{627}\u{632} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{634}\u{645}\u{627} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{6CC}\u{62F} \u{627}\u{632} ${startDate} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{6CC}\u{646} ${parentType} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: (parentType, startDate)=>`Hindi pa bukas ang mga pagsusumite. Maaari kang magsumite para sa ${parentType} ito simula sa ${startDate}.`,
    fr: (parentType, startDate)=>`Les soumissions ne sont pas encore ouvertes. Vous pouvez postuler pour cet ${parentType} \xe0 partir du ${startDate}.`,
    hi: (parentType, startDate)=>`\u{938}\u{92C}\u{92E}\u{93F}\u{936}\u{928} \u{905}\u{92D}\u{940} \u{924}\u{915} \u{916}\u{941}\u{932}\u{947} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}\u{964} \u{906}\u{92A} ${startDate} \u{938}\u{947} \u{936}\u{941}\u{930}\u{942} \u{939}\u{94B}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{907}\u{938} ${parentType} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{92C}\u{92E}\u{93F}\u{91F} \u{915}\u{930} \u{938}\u{915}\u{924}\u{947} \u{939}\u{948}\u{902}\u{964}`,
    ht: (parentType, startDate)=>`Soum\xe8t yo pa louvri ank\xf2. Ou ka soum\xe8t pou ${parentType} sa a apati ${startDate}`,
    it: (parentType, startDate)=>`Le candidature non sono ancora aperte. Puoi candidarti a questo ${parentType} a partire dal ${startDate}.`,
    ja: (parentType, startDate)=>`\u{5FDC}\u{52DF}\u{306F}\u{307E}\u{3060}\u{53D7}\u{4ED8}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}\u{3053}\u{306E} ${parentType} \u{3078}\u{306E}\u{5FDC}\u{52DF}\u{306F} ${startDate}\u{65E5}\u{304B}\u{3089}\u{59CB}\u{307E}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: (parentType, startDate)=>`\u{C544}\u{C9C1} \u{C81C}\u{CD9C}\u{C774} \u{C2DC}\u{C791}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}. ${startDate}\u{C77C}\u{BD80}\u{D130} \u{C774} ${parentType}\u{C5D0} \u{C9C0}\u{C6D0}\u{D558}\u{C2E4} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (parentType, startDate)=>`Kev xa tawm tseem tsis tau qhib. Koj tuaj yeem xa rau qhov ${parentType} no pib thaum ${startDate}.`,
    ps: (parentType, startDate)=>`\u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{6D0} \u{644}\u{627} \u{646}\u{647} \u{62F}\u{6CC} \u{67E}\u{631}\u{627}\u{646}\u{6CC}\u{633}\u{62A}\u{6D0}. \u{62A}\u{627}\u{633}\u{648} \u{6A9}\u{648}\u{644}\u{6CC} \u{634}\u{626} \u{62F} \u{62F}\u{6D0} ${parentType} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62F} ${startDate} \u{685}\u{62E}\u{647} \u{67E}\u{6CC}\u{644} \u{648}\u{6A9}\u{693}\u{626}.`,
    pt: (parentType, startDate)=>`As inscri\xe7\xf5es ainda n\xe3o est\xe3o abertas. Voc\xea pode se inscrever para este ${parentType} a partir de ${startDate}.`,
    'pt-pt': (parentType, startDate)=>`As submiss\xf5es ainda n\xe3o est\xe3o abertas. Pode submeter-se para este ${parentType} a partir de ${startDate}.`,
    ru: (parentType, startDate)=>`\u{41F}\u{440}\u{438}\u{451}\u{43C} \u{437}\u{430}\u{44F}\u{432}\u{43E}\u{43A} \u{435}\u{449}\u{451} \u{43D}\u{435} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}. \u{412}\u{44B} \u{43C}\u{43E}\u{436}\u{435}\u{442}\u{435} \u{43F}\u{43E}\u{434}\u{430}\u{442}\u{44C} \u{437}\u{430}\u{44F}\u{432}\u{43A}\u{443} \u{43D}\u{430} \u{44D}\u{442}\u{43E} ${parentType} , \u{43D}\u{430}\u{447}\u{438}\u{43D}\u{430}\u{44F} ${startDate}.`,
    sm: (parentType, startDate)=>`E le'i tatala talosaga i le taimi nei. E mafai ona e tu'uina atu lenei ${parentType} e amata ia ${startDate}.`,
    so: (parentType, startDate)=>`Soo gudbinta weli ma furan. Waxaad u gudbin kartaa ${parentType} laga bilaabo ${startDate}.`,
    th: (parentType, startDate)=>`\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E40}\u{E1B}\u{E34}\u{E14}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E1C}\u{E25}\u{E07}\u{E32}\u{E19} \u{E04}\u{E38}\u{E13}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E2A}\u{E48}\u{E07}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}${parentType}\u{E19}\u{E35}\u{E49}\u{E44}\u{E14}\u{E49}\u{E15}\u{E31}\u{E49}\u{E07}\u{E41}\u{E15}\u{E48}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48} ${startDate}`,
    ur: (parentType, startDate)=>`\u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{627}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA} \u{627}\u{628}\u{6BE}\u{6CC} \u{62A}\u{6A9} \u{6A9}\u{6BE}\u{644}\u{6CC} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}\u{6D4} \u{622}\u{67E} \u{627}\u{633} ${parentType} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} ${startDate} \u{633}\u{6D2} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{627} \u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (parentType, startDate)=>`B\xe0i d\u{1EF1} thi v\u{1EAB}n ch\u{1B0}a m\u{1EDF}. B\u{1EA1}n c\xf3 th\u{1EC3} g\u{1EED}i cho ${parentType} n\xe0y b\u{1EAF}t \u{111}\u{1EA7}u t\u{1EEB} ${startDate}.`,
    'zh-hans': (parentType, startDate)=>`\u{6295}\u{7A3F}\u{5C1A}\u{672A}\u{5F00}\u{653E}\u{3002}\u{60A8}\u{53EF}\u{4EE5}\u{4ECE}${startDate}\u{65E5}\u{5F00}\u{59CB}\u{62A5}\u{540D}\u{53C2}\u{52A0}\u{672C}\u{6B21}${parentType}\u{3002}`,
    'zh-hant': (parentType, startDate)=>`\u{6295}\u{7A3F}\u{5C1A}\u{672A}\u{958B}\u{653E}\u{3002}\u{60A8}\u{53EF}\u{4EE5}\u{5F9E}${startDate}\u{65E5}\u{958B}\u{59CB}\u{5831}\u{540D}\u{53C3}\u{52A0}\u{6B64}${parentType}\u{3002}`,
    en: (parentType, startDate)=>`Submissions are not open yet. You can submit for this ${parentType} starting on ${startDate}.`
};
const $b11db1b62d4a8f76$export$4d96585b016fbc25 = {
    ar: (parentType)=>`\u{647}\u{630}\u{627} ${parentType} \u{645}\u{639}\u{644}\u{642}. \u{644}\u{627} \u{64A}\u{62A}\u{645} \u{642}\u{628}\u{648}\u{644} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{627}\u{62A} \u{641}\u{64A} \u{627}\u{644}\u{648}\u{642}\u{62A} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}.`,
    de: (parentType)=>`Diese ${parentType} ist ausgesetzt. Einsendungen werden derzeit nicht entgegengenommen.`,
    es: (parentType)=>`Este ${parentType} est\xe1 en pausa. No se aceptan propuestas en este momento.`,
    fa: (parentType)=>`\u{627}\u{6CC}\u{646} ${parentType} \u{645}\u{62A}\u{648}\u{642}\u{641} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{62D}\u{627}\u{636}\u{631} \u{627}\u{631}\u{633}\u{627}\u{644} \u{647}\u{627} \u{67E}\u{630}\u{6CC}\u{631}\u{641}\u{62A}\u{647} \u{646}\u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: (parentType)=>`Ang ${parentType} ay naka-hold. Ang mga pagsusumite ay hindi tinatanggap sa oras na ito.`,
    fr: (parentType)=>`Cet ${parentType} est en pause. Les soumissions ne sont pas accept\xe9es pour le moment.`,
    hi: (parentType)=>`\u{92F}\u{939} ${parentType} \u{911}\u{928}-\u{939}\u{94B}\u{932}\u{94D}\u{921} \u{939}\u{948}\u{964} \u{907}\u{938} \u{938}\u{92E}\u{92F} \u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924}\u{93F}\u{92F}\u{93E}\u{901} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{91C}\u{93E} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902}\u{964}`,
    ht: (parentType)=>`${parentType} sa a se sou-kenbe Soum\xe8t yo pa aksepte nan moman sa a.`,
    it: (parentType)=>`Questo ${parentType} \xe8 in sospeso. Al momento non vengono accettate candidature.`,
    ja: (parentType)=>`\u{3053}\u{306E} ${parentType} \u{306F}\u{4FDD}\u{7559}\u{4E2D}\u{3067}\u{3059}\u{3002}\u{73FE}\u{6642}\u{70B9}\u{3067}\u{306F}\u{6295}\u{7A3F}\u{3092}\u{53D7}\u{3051}\u{4ED8}\u{3051}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (parentType)=>`\u{C774} ${parentType} \u{B294} \u{BCF4}\u{B958} \u{C911}\u{C785}\u{B2C8}\u{B2E4}. \u{D604}\u{C7AC} \u{C81C}\u{CD9C} \u{C811}\u{C218}\u{B418}\u{C9C0} \u{C54A}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (parentType)=>`Qhov ${parentType} no yog tuav. Cov ntawv xa tawm tsis raug lees txais lub sijhawm no.`,
    ps: (parentType)=>`\u{62F}\u{627} ${parentType} \u{681}\u{646}\u{689}\u{648}\u{644} \u{634}\u{648}\u{6D0} \u{62F}\u{647}. \u{62F}\u{627} \u{645}\u{647}\u{627}\u{644} \u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{6D0} \u{646}\u{647} \u{645}\u{646}\u{644} \u{6A9}\u{6D0}\u{696}\u{6CC}.`,
    pt: (parentType)=>`Este ${parentType} est\xe1 em espera. As submiss\xf5es n\xe3o est\xe3o sendo aceitas no momento.`,
    'pt-pt': (parentType)=>`Este ${parentType} est\xe1 suspenso. As submiss\xf5es n\xe3o est\xe3o a ser aceites neste momento.`,
    ru: (parentType)=>`${parentType} \u{43F}\u{440}\u{438}\u{43E}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{43E}. \u{412} \u{43D}\u{430}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{435}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F} \u{437}\u{430}\u{44F}\u{432}\u{43A}\u{438} \u{43D}\u{435} \u{43F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{44E}\u{442}\u{441}\u{44F}.`,
    sm: (parentType)=>`O lenei ${parentType} o lo'o taofiofia. E le o taliaina talosaga i le taimi nei.`,
    so: (parentType)=>`${parentType} waa la hakiyay. Soo gudbinta lama aqbalayo waqtigan.`,
    th: (parentType)=>`${parentType}\u{E19}\u{E35}\u{E49}\u{E16}\u{E39}\u{E01}\u{E23}\u{E30}\u{E07}\u{E31}\u{E1A} \u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E43}\u{E19}\u{E02}\u{E13}\u{E30}\u{E19}\u{E35}\u{E49}`,
    ur: (parentType)=>`\u{6CC}\u{6C1} ${parentType} \u{645}\u{639}\u{637}\u{644} \u{6C1}\u{6D2}\u{6D4} \u{627}\u{633} \u{648}\u{642}\u{62A} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{627}\u{626}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA} \u{642}\u{628}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{62C}\u{627} \u{631}\u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (parentType)=>`${parentType} n\xe0y \u{111}ang b\u{1ECB} t\u{1EA1}m d\u{1EEB}ng. B\xe0i d\u{1EF1} thi kh\xf4ng \u{111}\u{1B0}\u{1EE3}c ch\u{1EA5}p nh\u{1EAD}n t\u{1EA1}i th\u{1EDD}i \u{111}i\u{1EC3}m n\xe0y.`,
    'zh-hans': (parentType)=>`\u{672C}\u{6B21} ${parentType} \u{6682}\u{505C}\u{3002}\u{76EE}\u{524D}\u{4E0D}\u{63A5}\u{53D7}\u{6295}\u{7A3F}\u{3002}`,
    'zh-hant': (parentType)=>`\u{6B64} ${parentType} \u{66AB}\u{505C}\u{3002}\u{76EE}\u{524D}\u{4E0D}\u{63A5}\u{53D7}\u{6295}\u{7A3F}\u{3002}`,
    en: (parentType)=>`This ${parentType} is on-hold. Submissions are not being accepted at this time.`
};
const $b11db1b62d4a8f76$export$87995671b0da5a1d = {
    ar: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`تم التحويل من <a href="${activityHref}">${title}</a> التي انتهت في ${endDate}.`,
    de: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`Weitergeleitet von <a href="${activityHref}">${title}</a> , die am ${endDate} endete.`,
    es: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`Redirigido desde <a href="${activityHref}">${title}</a> , que terminó el ${endDate}.`,
    fa: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`از <a href="${activityHref}">${title}</a> که در ${endDate} پایان یافت، هدایت شده است.`,
    fil: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`Idinirekta mula sa <a href="${activityHref}">${title}</a> na natapos noong ${endDate}`,
    fr: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`Redirigé depuis <a href="${activityHref}">${title}</a> , qui s’est terminée le ${endDate}.`,
    hi: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">${title}</a> से अनुप्रेषित जो ${endDate} को समाप्त हुआ।`,
    ht: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`Redireksyon soti nan <a href="${activityHref}">${title}</a> ki te fini ${endDate}`,
    it: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`Reindirizzato dalla <a href="${activityHref}">${title}</a> , che si è conclusa il ${endDate}.`,
    ja: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`7${endDate}日に終了した<a href="${activityHref}">${title}</a>からリダイレクトされました。`,
    ko: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`7${endDate}일에 종료된 <a href="${activityHref}">${title}</a>에서 리디렉션되었습니다.`,
    mww: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`Redirected los ntawm <a href="${activityHref}">${title}</a> uas xaus rau ${endDate}.`,
    ps: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`د <a href="${activityHref}">${title}</a> څخه چې ${endDate} پای ته ورسېد، بیا لارښوونه شوه.`,
    pt: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`Redirecionado da <a href="${activityHref}">${title}</a> , que terminou em ${endDate}.`,
    'pt-pt': (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`Redirecionado de <a href="${activityHref}">${title}</a> , que terminou a ${endDate}.`,
    ru: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`Перенаправлено с <a href="${activityHref}">${title}</a> , которая завершилась ${endDate}.`,
    sm: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`Toe fa'afo'i mai le <a href="${activityHref}">${title}</a> lea na fa'amutaina ia ${endDate}.`,
    so: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`Waxaa loo wareejiyay <a href="${activityHref}">${title}</a> oo dhammaatay July ${endDate}.`,
    th: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`เปลี่ยนทางจาก <a href="${activityHref}">${title}</a> ซึ่งสิ้นสุดเมื่อวันที่ ${endDate}`,
    ur: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`<a href="${activityHref}">${title}</a> سے ری ڈائریکٹ کیا گیا جو ${endDate} کو ختم ہوا۔`,
    vi: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`đổi hướng từ <a href="${activityHref}">${title}</a> which ended on ${endDate}.`,
    'zh-hans': (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`重定向自7${endDate}日结束的<a href="${activityHref}">${title}</a>。`,
    'zh-hant': (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`已從7${endDate}日結束的<a href="${activityHref}">${title}</a>重新導向。`,
    en: (activityHref, title, endDate)=>$b11db1b62d4a8f76$var$html`Redirected from <a href="${activityHref}">${title}</a> which ended on ${endDate}.`
};
const $b11db1b62d4a8f76$export$542d8f2b7fbbccd2 = {
    ar: (cumulus)=>`\u{64A}\u{645}\u{643}\u{646} \u{631}\u{628}\u{637} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{627}\u{644}\u{639}\u{627}\u{645}\u{629} \u{628}\u{627}\u{644}\u{641}\u{639}\u{627}\u{644}\u{64A}\u{627}\u{62A} \u{648}\u{62A}\u{639}\u{628}\u{626}\u{62A}\u{647}\u{627} \u{645}\u{646} \u{642}\u{628}\u{644} \u{623}\u{634}\u{62E}\u{627}\u{635} \u{644}\u{627} \u{64A}\u{645}\u{644}\u{643}\u{648}\u{646} \u{62D}\u{633}\u{627}\u{628}\u{627} ${cumulus} .`,
    de: (cumulus)=>`\xd6ffentliche Frageb\xf6gen k\xf6nnen mit Veranstaltungen verkn\xfcpft und von Personen ohne ${cumulus} ausgef\xfcllt werden.`,
    es: (cumulus)=>`Los cuestionarios p\xfablicos pueden estar asociados a eventos y ser rellenados por personas sin cuenta ${cumulus} .`,
    fa: (cumulus)=>`\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647} \u{647}\u{627}\u{6CC} \u{639}\u{645}\u{648}\u{645}\u{6CC} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{646}\u{62F} \u{628}\u{627} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{647}\u{627} \u{645}\u{631}\u{62A}\u{628}\u{637} \u{634}\u{648}\u{646}\u{62F} \u{648} \u{62A}\u{648}\u{633}\u{637} \u{627}\u{641}\u{631}\u{627}\u{62F}\u{6CC} \u{6A9}\u{647} \u{62D}\u{633}\u{627}\u{628} ${cumulus} \u{646}\u{62F}\u{627}\u{631}\u{646}\u{62F} \u{67E}\u{631} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: (cumulus)=>`Ang mga pampublikong questionnaire ay maaaring maiugnay sa mga kaganapan at punan ng mga indibidwal na walang ${cumulus} account.`,
    fr: (cumulus)=>`Les questionnaires publics peuvent \xeatre associ\xe9s \xe0 des \xe9v\xe9nements et remplis par des personnes sans compte ${cumulus} .`,
    hi: (cumulus)=>`\u{938}\u{93E}\u{930}\u{94D}\u{935}\u{91C}\u{928}\u{93F}\u{915} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{93E}\u{935}\u{932}\u{940} \u{915}\u{94B} \u{918}\u{91F}\u{928}\u{93E}\u{913}\u{902} \u{938}\u{947} \u{91C}\u{94B}\u{921}\u{93C}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948} \u{914}\u{930} ${cumulus} \u{916}\u{93E}\u{924}\u{947} \u{915}\u{947} \u{92C}\u{93F}\u{928}\u{93E} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F}\u{92F}\u{94B}\u{902} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{92D}\u{930}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (cumulus)=>`Piblik kesyon\xe8 yo ka Asosye av\xe8k ev\xe8nman yo ak ranpli pa Moun ki pa gen okenn ${cumulus} kont.`,
    it: (cumulus)=>`I questionari pubblici possono essere associati agli eventi e compilati da persone senza un account ${cumulus} .`,
    ja: (cumulus)=>`\u{516C}\u{958B}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}\u{306F}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306B}\u{95A2}\u{9023}\u{4ED8}\u{3051}\u{3089}\u{308C}\u{3001} ${cumulus} \u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{3092}\u{6301}\u{305F}\u{306A}\u{3044}\u{500B}\u{4EBA}\u{3067}\u{3082}\u{8A18}\u{5165}\u{53EF}\u{80FD}\u{3067}\u{3059}\u{3002}`,
    ko: (cumulus)=>`\u{ACF5}\u{AC1C} \u{C124}\u{BB38}\u{C9C0}\u{B294} \u{D589}\u{C0AC}\u{C640} \u{C5F0}\u{AD00}\u{B418}\u{C5B4} ${cumulus} \u{ACC4}\u{C815}\u{C774} \u{C5C6}\u{B294} \u{AC1C}\u{C778}\u{B3C4} \u{C791}\u{C131}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (cumulus)=>`Cov lus nug pej xeem tuaj yeem cuam tshuam nrog cov xwm txheej thiab sau los ntawm cov tib neeg uas tsis muaj tus ${cumulus} .`,
    ps: (cumulus)=>`\u{639}\u{627}\u{645}\u{647} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647} \u{62F} \u{67E}\u{6CC}\u{69A}\u{648} \u{633}\u{631}\u{647} \u{62A}\u{693}\u{644}\u{6CC} \u{6A9}\u{6CC}\u{62F}\u{627}\u{6CC} \u{634}\u{6CC} \u{627}\u{648} \u{62F} \u{647}\u{63A}\u{648} \u{6A9}\u{633}\u{627}\u{646}\u{648} \u{644}\u{62E}\u{648}\u{627} \u{689}\u{6A9} \u{634}\u{6CC} \u{686}\u{6D0} ${cumulus} \u{62D}\u{633}\u{627}\u{628} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: (cumulus)=>`Question\xe1rios p\xfablicos podem ser associados a eventos e preenchidos por pessoas sem conta ${cumulus} .`,
    'pt-pt': (cumulus)=>`Question\xe1rios p\xfablicos podem estar associados a eventos e preenchidos por indiv\xedduos sem conta ${cumulus} .`,
    ru: (cumulus)=>`\u{41F}\u{443}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{44B}\u{435} \u{430}\u{43D}\u{43A}\u{435}\u{442}\u{44B} \u{43C}\u{43E}\u{433}\u{443}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{44B} \u{441} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F}\u{43C}\u{438} \u{438} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{44B} \u{43B}\u{438}\u{446}\u{430}\u{43C}\u{438} \u{431}\u{435}\u{437} ${cumulus} .`,
    sm: (cumulus)=>`O fesili lautele e mafai ona feso'ota'i ma mea na tutupu ma fa'atumuina e tagata ta'ito'atasi e aunoa ma se ${cumulus} account.`,
    so: (cumulus)=>`Su'aalaha dadweynaha waxaa lala xiriirin karaa dhacdooyinka, waxaana buuxin kara shakhsiyaad aan lahayn akoon ${cumulus} ah.`,
    th: (cumulus)=>`\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}\u{E2A}\u{E32}\u{E18}\u{E32}\u{E23}\u{E13}\u{E30}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E21}\u{E42}\u{E22}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E41}\u{E25}\u{E30}\u{E01}\u{E23}\u{E2D}\u{E01}\u{E42}\u{E14}\u{E22}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35} ${cumulus}`,
    ur: (cumulus)=>`\u{639}\u{648}\u{627}\u{645}\u{6CC} \u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6D2} \u{648}\u{627}\u{642}\u{639}\u{627}\u{62A} \u{633}\u{6D2} \u{645}\u{646}\u{633}\u{644}\u{6A9} \u{6A9}\u{6CC}\u{6D2} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{627}\u{6CC}\u{633}\u{6D2} \u{627}\u{641}\u{631}\u{627}\u{62F} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{628}\u{6BE}\u{631}\u{6D2} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{62C}\u{646} \u{6A9}\u{6D2} ${cumulus} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{62A}\u{627}\u{6D4}`,
    vi: (cumulus)=>`B\u{1EA3}ng c\xe2u h\u{1ECF}i c\xf4ng khai c\xf3 th\u{1EC3} \u{111}\u{1B0}\u{1EE3}c li\xean k\u{1EBF}t v\u{1EDB}i c\xe1c s\u{1EF1} ki\u{1EC7}n v\xe0 \u{111}\u{1B0}\u{1EE3}c \u{111}i\u{1EC1}n b\u{1EDF}i c\xe1c c\xe1 nh\xe2n kh\xf4ng c\xf3 t\xe0i kho\u{1EA3}n ${cumulus} .`,
    'zh-hans': (cumulus)=>`\u{516C}\u{5F00}\u{95EE}\u{5377}\u{53EF}\u{4EE5}\u{5173}\u{8054}\u{4E8B}\u{4EF6}\u{FF0C}\u{5E76}\u{7531}\u{6CA1}\u{6709} ${cumulus} \u{8D26}\u{6237}\u{7684}\u{4E2A}\u{4EBA}\u{586B}\u{5199}\u{3002}`,
    'zh-hant': (cumulus)=>`\u{516C}\u{958B}\u{554F}\u{5377}\u{53EF}\u{8207}\u{6D3B}\u{52D5}\u{76F8}\u{95DC}\u{806F}\u{FF0C}\u{4E26}\u{7531}\u{6C92}\u{6709} ${cumulus} \u{5E33}\u{865F}\u{7684}\u{500B}\u{4EBA}\u{586B}\u{5BEB}\u{3002}`,
    en: (cumulus)=>`Public questionnaires can be associated with events and filled out by individuals without a ${cumulus} account.`
};
const $b11db1b62d4a8f76$export$dce4e5c439230d88 = {
    ar: `\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646} \u{639}\u{627}\u{645} (\u{642}\u{627}\u{628}\u{644} \u{644}\u{644}\u{637}\u{628}\u{627}\u{639}\u{629})`,
    de: `\xd6ffentlicher Fragebogen (ausdruckbar)`,
    es: `Cuestionario p\xfablico (imprimible)`,
    fa: `\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647} \u{639}\u{645}\u{648}\u{645}\u{6CC} (\u{642}\u{627}\u{628}\u{644} \u{686}\u{627}\u{67E})`,
    fil: `Pampublikong palatanungan (mai-print)`,
    fr: `Questionnaire public (imprimable)`,
    hi: `\u{938}\u{93E}\u{930}\u{94D}\u{935}\u{91C}\u{928}\u{93F}\u{915} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{93E}\u{935}\u{932}\u{940} (\u{92A}\u{94D}\u{930}\u{93F}\u{902}\u{91F} \u{915}\u{930}\u{928}\u{947} \u{92F}\u{94B}\u{917}\u{94D}\u{92F})`,
    ht: `Kesyon\xe8 piblik (enprime)`,
    it: `Questionario pubblico (stampabile)`,
    ja: `\u{516C}\u{958B}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}(\u{5370}\u{5237}\u{53EF}\u{80FD})`,
    ko: `\u{ACF5}\u{AC1C} \u{C124}\u{BB38}\u{C9C0} (\u{C778}\u{C1C4} \u{AC00}\u{B2A5})`,
    mww: `Cov lus nug rau pej xeem (luam tawm)`,
    ps: `\u{639}\u{627}\u{645}\u{647} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9} (\u{686}\u{627}\u{67E} \u{6A9}\u{6D0}\u{62F}\u{648}\u{646}\u{6A9}\u{6CC})`,
    pt: `Question\xe1rio p\xfablico (imprim\xedvel)`,
    'pt-pt': `Question\xe1rio p\xfablico (imprim\xedvel)`,
    ru: `\u{41F}\u{443}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{44B}\u{439} \u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{43D}\u{438}\u{43A} (\u{440}\u{430}\u{441}\u{43F}\u{435}\u{447}\u{430}\u{442}\u{430}\u{43D}\u{43D}\u{44B}\u{439})`,
    sm: `Fesili a le Malo (lolomiina)`,
    so: `Su'aalaha dadweynaha (la daabaco)`,
    th: `\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}\u{E2A}\u{E32}\u{E18}\u{E32}\u{E23}\u{E13}\u{E30} (\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E44}\u{E14}\u{E49})`,
    ur: `\u{639}\u{648}\u{627}\u{645}\u{6CC} \u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6C1} (\u{67E}\u{631}\u{646}\u{679} \u{627}\u{6CC}\u{628}\u{644})`,
    vi: `B\u{1EA3}ng c\xe2u h\u{1ECF}i c\xf4ng khai (c\xf3 th\u{1EC3} in)`,
    'zh-hans': `\u{516C}\u{5F00}\u{95EE}\u{5377}\u{FF08}\u{53EF}\u{6253}\u{5370}\u{FF09}`,
    'zh-hant': `\u{516C}\u{958B}\u{554F}\u{5377}\u{FF08}\u{53EF}\u{5217}\u{5370}\u{FF09}`,
    en: `Public questionnaire (printable)`
};
const $b11db1b62d4a8f76$export$46741619b6614a26 = {
    ar: `\u{633}\u{62A}\u{643}\u{648}\u{646} \u{627}\u{644}\u{631}\u{627}\u{628}\u{637} \u{627}\u{644}\u{639}\u{627}\u{645}\u{60C} \u{648}\u{631}\u{645}\u{632} QR\u{60C} \u{648}\u{648}\u{631}\u{642}\u{629} \u{627}\u{644}\u{639}\u{645}\u{644} \u{627}\u{644}\u{642}\u{627}\u{628}\u{644}\u{629} \u{644}\u{644}\u{637}\u{628}\u{627}\u{639}\u{629} \u{645}\u{62A}\u{627}\u{62D}\u{629} \u{628}\u{639}\u{62F} \u{627}\u{644}\u{62D}\u{641}\u{638}.`,
    de: `\xd6ffentliche URL, QR-Code und ausdruckbares Arbeitsblatt sind nach dem Speichern verf\xfcgbar.`,
    es: `La URL p\xfablica, el c\xf3digo QR y la hoja de trabajo imprimible estar\xe1n disponibles tras guardar.`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{639}\u{645}\u{648}\u{645}\u{6CC}\u{60C} \u{6A9}\u{62F} QR \u{648} \u{628}\u{631}\u{6AF}\u{647} \u{642}\u{627}\u{628}\u{644} \u{686}\u{627}\u{67E} \u{67E}\u{633} \u{627}\u{632} \u{630}\u{62E}\u{6CC}\u{631}\u{647} \u{62F}\u{631} \u{62F}\u{633}\u{62A}\u{631}\u{633} \u{62E}\u{648}\u{627}\u{647}\u{646}\u{62F} \u{628}\u{648}\u{62F}.`,
    fil: `Ang pampublikong url, QR code, at mai-print na worksheet ay magagamit pagkatapos i-save.`,
    fr: `URL publique, code QR et fiche d\u{2019}exercices imprimables seront disponibles apr\xe8s sauvegarde.`,
    hi: `\u{938}\u{939}\u{947}\u{91C}\u{928}\u{947} \u{915}\u{947} \u{92C}\u{93E}\u{926} \u{938}\u{93E}\u{930}\u{94D}\u{935}\u{91C}\u{928}\u{93F}\u{915} \u{92F}\u{942}\u{906}\u{930}\u{90F}\u{932}, \u{915}\u{94D}\u{92F}\u{942}\u{906}\u{930} \u{915}\u{94B}\u{921} \u{914}\u{930} \u{92A}\u{94D}\u{930}\u{93F}\u{902}\u{91F} \u{915}\u{930}\u{928}\u{947} \u{92F}\u{94B}\u{917}\u{94D}\u{92F} \u{935}\u{930}\u{94D}\u{915}\u{936}\u{940}\u{91F} \u{909}\u{92A}\u{932}\u{92C}\u{94D}\u{927} \u{939}\u{94B}\u{917}\u{940}\u{964}`,
    ht: `Url piblik, k\xf2d QR, ak F\xe8y travay ki ka enprime yo ap disponib apre ekonomize`,
    it: `URL pubblico, codice QR e scheda stampabile saranno disponibili dopo il salvataggio.`,
    ja: `\u{4FDD}\u{5B58}\u{5F8C}\u{306F}\u{516C}\u{958B}URL\u{3001}QR\u{30B3}\u{30FC}\u{30C9}\u{3001}\u{5370}\u{5237}\u{53EF}\u{80FD}\u{306A}\u{30EF}\u{30FC}\u{30AF}\u{30B7}\u{30FC}\u{30C8}\u{304C}\u{5229}\u{7528}\u{53EF}\u{80FD}\u{306B}\u{306A}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{ACF5}\u{AC1C} URL, QR \u{CF54}\u{B4DC}, \u{C778}\u{C1C4} \u{AC00}\u{B2A5}\u{D55C} \u{C6CC}\u{D06C}\u{C2DC}\u{D2B8}\u{B294} \u{C800}\u{C7A5} \u{D6C4} \u{C81C}\u{ACF5}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Pej xeem url, QR code, thiab printable worksheet yuav muaj tom qab txuag tau.`,
    ps: `\u{639}\u{627}\u{645}\u{647} URL\u{60C} QR \u{6A9}\u{648}\u{689}\u{60C} \u{627}\u{648} \u{686}\u{627}\u{67E}\u{6D0}\u{62F}\u{648}\u{646}\u{6A9}\u{6CC} \u{648}\u{631}\u{6A9} \u{634}\u{6CC}\u{67C} \u{628}\u{647} \u{62F} \u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{6A9}\u{648}\u{644}\u{648} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{647} \u{634}\u{62A}\u{648}\u{646} \u{648}\u{644}\u{631}\u{6CC}.`,
    pt: `URL p\xfablica, c\xf3digo QR e planilha imprim\xedvel estar\xe3o dispon\xedveis ap\xf3s salvar.`,
    'pt-pt': `URL p\xfablico, c\xf3digo QR e folha de trabalho imprim\xedvel estar\xe3o dispon\xedveis ap\xf3s a grava\xe7\xe3o.`,
    ru: `\u{41F}\u{443}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{44B}\u{439} URL, QR-\u{43A}\u{43E}\u{434} \u{438} \u{440}\u{430}\u{441}\u{43F}\u{435}\u{447}\u{430}\u{442}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{438}\u{439} \u{43B}\u{438}\u{441}\u{442} \u{431}\u{443}\u{434}\u{443}\u{442} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{44B} \u{43F}\u{43E}\u{441}\u{43B}\u{435} \u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{438}\u{44F}.`,
    sm: `O le a maua le URL lautele, QR code, ma le pepa o galuega e mafai ona lolomiina pe a uma ona sefeina.`,
    so: `URL-ka dadweynaha, koodhka QR, iyo xaashida shaqada ee la daabaci karo ayaa la heli doonaa marka la keydiyo.`,
    th: `URL \u{E2A}\u{E32}\u{E18}\u{E32}\u{E23}\u{E13}\u{E30} \u{E23}\u{E2B}\u{E31}\u{E2A} QR \u{E41}\u{E25}\u{E30}\u{E41}\u{E1C}\u{E48}\u{E19}\u{E07}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E44}\u{E14}\u{E49}\u{E08}\u{E30}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E2B}\u{E25}\u{E31}\u{E07}\u{E08}\u{E32}\u{E01}\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}`,
    ur: `\u{67E}\u{628}\u{644}\u{6A9} \u{6CC}\u{648} \u{622}\u{631} \u{627}\u{6CC}\u{644}\u{60C} \u{6A9}\u{6CC}\u{648} \u{622}\u{631} \u{6A9}\u{648}\u{688}\u{60C} \u{627}\u{648}\u{631} \u{67E}\u{631}\u{646}\u{679} \u{627}\u{6CC}\u{628}\u{644} \u{648}\u{631}\u{6A9} \u{634}\u{6CC}\u{679} \u{645}\u{62D}\u{641}\u{648}\u{638} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{628}\u{639}\u{62F} \u{62F}\u{633}\u{62A}\u{6CC}\u{627}\u{628} \u{6C1}\u{648}\u{6BA} \u{6AF}\u{6D2}\u{6D4}`,
    vi: `URL c\xf4ng khai, m\xe3 QR v\xe0 b\u{1EA3}ng t\xednh c\xf3 th\u{1EC3} in s\u{1EBD} c\xf3 s\u{1EB5}n sau khi l\u{1B0}u.`,
    'zh-hans': `\u{4FDD}\u{5B58}\u{540E}\u{5C06}\u{63D0}\u{4F9B}\u{516C}\u{5F00}\u{7F51}\u{5740}\u{3001}\u{4E8C}\u{7EF4}\u{7801}\u{548C}\u{53EF}\u{6253}\u{5370}\u{7684}\u{5DE5}\u{4F5C}\u{8868}\u{3002}`,
    'zh-hant': `\u{5132}\u{5B58}\u{5F8C}\u{5C07}\u{958B}\u{653E}\u{516C}\u{958B}\u{7DB2}\u{5740}\u{3001}QR \u{78BC}\u{53CA}\u{53EF}\u{5217}\u{5370}\u{5DE5}\u{4F5C}\u{8868}\u{3002}`,
    en: `Public url, QR code, and printable worksheet will be available after saving.`
};
const $b11db1b62d4a8f76$export$29ba8b81c6cc7b43 = {
    ar: `\u{631}\u{645}\u{632} QR`,
    de: `QR-Code`,
    es: `C\xf3digo QR`,
    fa: `\u{6A9}\u{62F} QR`,
    fil: `Email Address *`,
    fr: `Code QR`,
    hi: `QR \u{915}\u{94B}\u{921}`,
    ht: `K\xf2d QR`,
    it: `Codice QR`,
    ja: `QR\u{30B3}\u{30FC}\u{30C9}`,
    ko: `QR \u{CF54}\u{B4DC}`,
    mww: `QR code`,
    ps: `QR \u{6A9}\u{648}\u{689}`,
    pt: `C\xf3digo QR`,
    'pt-pt': `C\xf3digo QR`,
    ru: `QR-\u{43A}\u{43E}\u{434}`,
    sm: `QR code`,
    so: `QR code`,
    th: `\u{E04}\u{E34}\u{E27}\u{E2D}\u{E32}\u{E23}\u{E4C}\u{E42}\u{E04}\u{E49}\u{E14}`,
    ur: `\u{6A9}\u{6CC}\u{648} \u{622}\u{631} \u{6A9}\u{648}\u{688}`,
    vi: `M\xe3 QR`,
    'zh-hans': `\u{4E8C}\u{7EF4}\u{7801}`,
    'zh-hant': `QR \u{78BC}`,
    en: `QR code`
};
const $b11db1b62d4a8f76$export$9a7334e53061c984 = {
    ar: $b11db1b62d4a8f76$var$html`<ol><li>افتح تطبيق الكاميرا.</li><li>اختر الكاميرا المواجهة للخلف في وضع الصورة أو الكاميرا.</li><li>ضع رمز الاستجابة السريعة في مركز الشاشة وثبت هاتفك لبضع ثوان.</li><li>اضغط على الإشعار الذي يظهر لفتح الرابط.</li></ol>`,
    de: $b11db1b62d4a8f76$var$html`<ol><li>Öffne die Kamera-App.</li><li>Wählen Sie die Rückkamera im Foto- oder Kameramodus.</li><li>Zentriere den QR-Code auf dem Bildschirm und halte dein Handy für ein paar Sekunden ruhig.</li><li>Tippe auf die Benachrichtigung, die erscheint, um den Link zu öffnen.</li></ol>`,
    es: $b11db1b62d4a8f76$var$html`<ol><li>Abre la app de la cámara.</li><li>Selecciona la cámara trasera en modo Foto o Cámara.</li><li>Centra el código QR en la pantalla y mantén el móvil firme durante un par de segundos.</li><li>Toca la notificación que aparece para abrir el enlace.</li></ol>`,
    fa: $b11db1b62d4a8f76$var$html`<ol><li>اپلیکیشن دوربین را باز کن.</li><li>دوربین عقب را در حالت عکس یا دوربین انتخاب کنید.</li><li>کد QR را روی صفحه قرار دهید و گوشی را چند ثانیه ثابت نگه دارید.</li><li>روی اعلان که ظاهر می شود ضربه بزنید تا لینک باز شود.</li></ol>`,
    fil: $b11db1b62d4a8f76$var$html`<ol><li>Buksan ang app ng camera.</li><li>Piliin ang camera na nakaharap sa likuran sa mode ng Larawan o Camera.</li><li>Isentro ang QR code sa screen at hawakan nang matatag ang iyong telepono nang ilang segundo.</li><li>I-tap ang abiso na nag-pop up upang buksan ang link.</li></ol>`,
    fr: $b11db1b62d4a8f76$var$html`<ol><li>Ouvre l’application caméra.</li><li>Sélectionnez l’appareil photo arrière en mode Photo ou Appareil photo.</li><li>Centrez le code QR sur l’écran et maintenez votre téléphone stable pendant quelques secondes.</li><li>Tapez sur la notification qui apparaît pour ouvrir le lien.</li></ol>`,
    hi: $b11db1b62d4a8f76$var$html`<ol><li>कैमरा ऐप खोलें।</li><li>फ़ोटो या कैमरा मोड में पीछे की ओर वाले कैमरे का चयन करें।</li><li>क्यूआर कोड को स्क्रीन पर केंद्रित करें और अपने फोन को कुछ सेकंड के लिए स्थिर रखें।</li><li>लिंक खोलने के लिए पॉप अप होने वाली सूचना पर टैप करें.</li></ol>`,
    ht: $b11db1b62d4a8f76$var$html`<ol><li>Louvri app kamera a.</li><li>Chwazi dèyè fè fas a kamera nan mòd foto oswa kamera</li><li>Sant kòd QR la sou ekran an epi kenbe telefòn ou fiks pou yon koup la segonn.</li><li>Tape notifikasyon an ki pete moute pou louvri lyen an.</li></ol>`,
    it: $b11db1b62d4a8f76$var$html`<ol><li>Apri l'app della fotocamera.</li><li>Seleziona la fotocamera posteriore in modalità Foto o Fotocamera.</li><li>Centra il codice QR sullo schermo e tieni il telefono fermo per qualche secondo.</li><li>Tocca la notifica che appare per aprire il link.</li></ol>`,
    ja: $b11db1b62d4a8f76$var$html`<ol><li>カメラアプリを開いてください。</li><li>写真モードまたはカメラモードで後ろ向きカメラを選択してください。</li><li>QRコードを画面の中央に合わせ、数秒間スマホをしっかり持っておきます。</li><li>表示される通知をタップしてリンクを開きます。</li></ol>`,
    ko: $b11db1b62d4a8f76$var$html`<ol><li>카메라 앱을 열어보세요.</li><li>사진 또는 카메라 모드에서 후면 카메라를 선택하세요.</li><li>QR 코드를 화면 중앙에 맞추고 휴대폰을 몇 초간 안정적으로 잡으세요.</li><li>알림이 뜨는 것을 탭하면 링크를 열어보세요.</li></ol>`,
    mww: $b11db1b62d4a8f76$var$html`<ol><li>Qhib lub koob yees duab app.</li><li>Xaiv lub koob yees duab rov qab hauv hom Diam duab lossis Lub Koob Yees Duab.</li><li>Center QR code rau ntawm qhov screen thiab tuav koj lub xov tooj ruaj khov rau ib tug ob peb vib nas this.</li><li>Coj mus rhaub qhov kev ceeb toom uas pops mus qhib qhov txuas.</li></ol>`,
    ps: $b11db1b62d4a8f76$var$html`<ol><li>د کمرې اپلیکیشن خلاص کړه.</li><li>شاته مخامخ کامره په عکس یا کامره حالت کې وټاکئ.</li><li>QR کوډ په سکرین کې مرکز کړئ او خپل موبایل څو ثانیې ثابت وساتئ.</li><li>هغه خبرتیا چې راښکاره کېږی، ټک وهه چې لینک پرانیزی.</li></ol>`,
    pt: $b11db1b62d4a8f76$var$html`<ol><li>Abra o aplicativo da câmera.</li><li>Selecione a câmera traseira no modo Foto ou Câmera.</li><li>Centralize o código QR na tela e mantenha o celular estável por alguns segundos.</li><li>Toque na notificação que aparece para abrir o link.</li></ol>`,
    'pt-pt': $b11db1b62d4a8f76$var$html`<ol><li>Abre a aplicação da câmara.</li><li>Selecione a câmara traseira em modo Foto ou Câmara.</li><li>Centra o código QR no ecrã e mantém o telemóvel estável durante alguns segundos.</li><li>Toque na notificação que aparece para abrir o link.</li></ol>`,
    ru: $b11db1b62d4a8f76$var$html`<ol><li>Откройте приложение камеры.</li><li>Выберите заднюю камеру в режиме Фото или Камера.</li><li>Центрируйте QR-код на экране и удержите телефон на пару секунд.</li><li>Нажмите на уведомление, которое появится, чтобы открыть ссылку.</li></ol>`,
    sm: $b11db1b62d4a8f76$var$html`<ol><li>Tatala le polokalama o le mea pu'eata.</li><li>Filifili le mea pu'eata i tua i le Ata po'o le Mea Pueata.</li><li>Fa'apipi'i le QR code i luga o le lau ma taofi lau telefoni mo ni nai sekone.</li><li>Kiliki i le fa'asilasilaga o lo'o oso a'e i luga e tatala ai le sootaga.</li></ol>`,
    so: $b11db1b62d4a8f76$var$html`<ol><li>Fur app-ka kamaradda.</li><li>Dooro kamaradda gadaal u jeeda habka Sawir ama Kamarad.</li><li>Bartamaha QR code-ka shaashadda ku hay oo telefoonkaaga si deggan u hay dhowr ilbiriqsi.</li><li>Taabo ogeysiiska soo baxaya si aad u furto xiriirka.</li></ol>`,
    th: $b11db1b62d4a8f76$var$html`<ol><li>เปิดแอปกล้องถ่ายรูป</li><li>เลือกกล้องหลังในโหมดภาพถ่ายหรือกล้อง</li><li>วางคิวอาร์โค้ดไว้ตรงกลางหน้าจอและถือโทรศัพท์ให้นิ่งสองสามวินาที</li><li>แตะการแจ้งเตือนที่ปรากฏขึ้นเพื่อเปิดลิงก์</li></ol>`,
    ur: $b11db1b62d4a8f76$var$html`<ol><li>کیمرہ ایپ کھولو۔</li><li>فوٹو یا کیمرہ موڈ میں ریئر فیسنگ کیمرہ منتخب کریں۔</li><li>کیو آر کوڈ کو اسکرین پر مرکز میں رکھیں اور فون کو چند سیکنڈ کے لیے مستحکم رکھیں۔</li><li>لنک کھولنے کے لیے پاپ اپ ہونے والی نوٹیفکیشن پر ٹیپ کریں۔</li></ol>`,
    vi: $b11db1b62d4a8f76$var$html`<ol><li>Mở ứng dụng máy ảnh.</li><li>Chọn camera phía sau ở chế độ Ảnh hoặc Máy ảnh.</li><li>Căn giữa mã QR trên màn hình và giữ điện thoại của bạn ổn định trong vài giây.</li><li>Nhấn vào thông báo bật lên để mở liên kết.</li></ol>`,
    'zh-hans': $b11db1b62d4a8f76$var$html`<ol><li>打开相机应用。</li><li>在拍照或相机模式中选择后置摄像头。</li><li>将二维码置中，手机稳稳地握住几秒钟。</li><li>点击弹出的通知即可打开链接。</li></ol>`,
    'zh-hant': $b11db1b62d4a8f76$var$html`<ol><li>打開相機應用程式。</li><li>在拍照或相機模式中選擇後置相機。</li><li>將 QR 碼置中，並穩定握住手機幾秒鐘。</li><li>點擊跳出的通知即可開啟連結。</li></ol>`,
    en: $b11db1b62d4a8f76$var$html`<ol><li>Open the camera app.</li><li>Select the rear-facing camera in Photo or Camera mode.</li><li>Center the QR code on the screen and hold your phone steady for a couple of seconds.</li><li>Tap the notification that pops up to open the link.</li></ol>`
};
const $b11db1b62d4a8f76$export$fd61571d318841e9 = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646}`,
    de: `Fragebogen`,
    es: `Cuestionario`,
    fa: `\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647}`,
    fil: `Talatanungan`,
    fr: `Questionnaire`,
    hi: `\u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{200D}\u{928}\u{93E}\u{935}\u{932}\u{940}`,
    ht: `Kesyon\xe8`,
    it: `Questionario`,
    ja: `\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}`,
    ko: `\u{C124}\u{BB38}\u{C9C0}`,
    mww: `Cov lus nug`,
    ps: `\u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9}`,
    pt: `Question\xe1rio`,
    'pt-pt': `Question\xe1rio`,
    ru: `\u{410}\u{43D}\u{43A}\u{435}\u{442}\u{430}`,
    sm: `Fesili`,
    so: `Su'aalo`,
    th: `\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}`,
    ur: `\u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6C1}`,
    vi: `B\u{1EA3}ng c\xe2u h\u{1ECF}i`,
    'zh-hans': `\u{95EE}\u{5377}`,
    'zh-hant': `\u{554F}\u{5377}`,
    en: `Questionnaire`
};
const $b11db1b62d4a8f76$export$d9537d64b8fd7c31 = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A}`,
    de: `Frageb\xf6gen`,
    es: `Cuestionarios`,
    fa: `\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647} \u{647}\u{627}`,
    fil: `Mga talatanungan`,
    fr: `Questionnaires`,
    hi: `\u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{93E}\u{935}\u{932}\u{940}`,
    ht: `Kesyon\xe8 yo`,
    it: `Questionari`,
    ja: `\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}`,
    ko: `\u{C124}\u{BB38}\u{C9C0}`,
    mww: `Cov lus nug`,
    ps: `\u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647}`,
    pt: `Question\xe1rios`,
    'pt-pt': `Question\xe1rios`,
    ru: `\u{410}\u{43D}\u{43A}\u{435}\u{442}\u{44B}`,
    sm: `Fesili`,
    so: `Su'aalaha`,
    th: `\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}`,
    ur: `\u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6D2}`,
    vi: `B\u{1EA3}ng c\xe2u h\u{1ECF}i`,
    'zh-hans': `\u{95EE}\u{5377}`,
    'zh-hant': `\u{554F}\u{5377}`,
    en: `Questionnaires`
};
const $b11db1b62d4a8f76$export$e68caf1d725bc48e = {
    ar: `\u{641}\u{644}\u{627}\u{62A}\u{631} \u{633}\u{631}\u{64A}\u{639}\u{629}`,
    de: `Schnelle Filter`,
    es: `Filtros r\xe1pidos`,
    fa: `\u{641}\u{6CC}\u{644}\u{62A}\u{631}\u{647}\u{627}\u{6CC} \u{633}\u{631}\u{6CC}\u{639}`,
    fil: `Mabilis na mga filter`,
    fr: `Filtres rapides`,
    hi: `\u{924}\u{94D}\u{935}\u{930}\u{93F}\u{924} \u{92B}\u{93F}\u{932}\u{94D}\u{91F}\u{930}`,
    ht: `Filt\xe8 rapid`,
    it: `Filtri rapidi`,
    ja: `\u{30AF}\u{30A4}\u{30C3}\u{30AF}\u{30D5}\u{30A3}\u{30EB}\u{30BF}\u{30FC}`,
    ko: `\u{BE60}\u{B978} \u{D544}\u{D130}`,
    mww: `Cov ntxaij lim dej ceev`,
    ps: `\u{686}\u{67C}\u{6A9} \u{641}\u{644}\u{67C}\u{631}\u{648}\u{646}\u{647}`,
    pt: `Filtros r\xe1pidos`,
    'pt-pt': `Filtros r\xe1pidos`,
    ru: `\u{411}\u{44B}\u{441}\u{442}\u{440}\u{44B}\u{435} \u{444}\u{438}\u{43B}\u{44C}\u{442}\u{440}\u{44B}`,
    sm: `Faamama vave`,
    so: `Shaandheeyada degdega ah`,
    th: `\u{E15}\u{E31}\u{E27}\u{E01}\u{E23}\u{E2D}\u{E07}\u{E14}\u{E48}\u{E27}\u{E19}`,
    ur: `\u{641}\u{648}\u{631}\u{6CC} \u{641}\u{644}\u{679}\u{631}\u{632}`,
    vi: `B\u{1ED9} l\u{1ECD}c nhanh`,
    'zh-hans': `\u{5FEB}\u{901F}\u{8FC7}\u{6EE4}`,
    'zh-hant': `\u{5FEB}\u{901F}\u{7BE9}\u{9078}`,
    en: `Quick filters`
};
const $b11db1b62d4a8f76$export$70a61f2978bae1e9 = {
    ar: `\u{631}\u{62F} \u{627}\u{642}\u{62A}\u{628}\u{627}\u{633}`,
    de: `Zitatantantwort`,
    es: `Respuesta de la cita`,
    fa: `\u{67E}\u{627}\u{633}\u{62E} \u{646}\u{642}\u{644} \u{642}\u{648}\u{644}`,
    fil: `Email Address *`,
    fr: `R\xe9ponse de citation`,
    hi: `\u{909}\u{926}\u{94D}\u{927}\u{930}\u{923} \u{909}\u{924}\u{94D}\u{924}\u{930}`,
    ht: `Quote reply`,
    it: `Risposta a citazione`,
    ja: `\u{5F15}\u{7528}\u{8FD4}\u{4FE1}`,
    ko: `\u{C778}\u{C6A9} \u{B2F5}\u{BCC0}`,
    mww: `Quote teb`,
    ps: `\u{62F} \u{627}\u{642}\u{62A}\u{628}\u{627}\u{633} \u{681}\u{648}\u{627}\u{628}`,
    pt: `Resposta de cita\xe7\xe3o`,
    'pt-pt': `Resposta de cita\xe7\xe3o`,
    ru: `\u{41E}\u{442}\u{432}\u{435}\u{442} \u{446}\u{438}\u{442}\u{430}\u{442}\u{44B}`,
    sm: `Upusii tali`,
    so: `Jawaab xigasho`,
    th: `\u{E2D}\u{E49}\u{E32}\u{E07}\u{E04}\u{E4D}\u{E32}\u{E15}\u{E2D}\u{E1A}`,
    ur: `\u{62D}\u{648}\u{627}\u{644}\u{6C1} \u{62C}\u{648}\u{627}\u{628}`,
    vi: `Tr\xedch d\u{1EAB}n tr\u{1EA3} l\u{1EDD}i`,
    'zh-hans': `\u{5F15}\u{7528}\u{56DE}\u{590D}`,
    'zh-hant': `\u{5F15}\u{7528}\u{56DE}\u{8986}`,
    en: `Quote reply`
};
const $b11db1b62d4a8f76$export$32a9f9c862497dc6 = {
    ar: `\u{627}\u{644}\u{633}\u{628}\u{627}\u{642}`,
    de: `Rennen`,
    es: `Carrera`,
    fa: `\u{645}\u{633}\u{627}\u{628}\u{642}\u{647}`,
    fil: `Lahi`,
    fr: `Course`,
    hi: `\u{926}\u{94C}\u{921}\u{93C}`,
    ht: `Ras`,
    it: `Gara`,
    ja: `\u{30EC}\u{30FC}\u{30B9}`,
    ko: `\u{B808}\u{C774}\u{C2A4}`,
    mww: `haiv neeg`,
    ps: `\u{633}\u{6CC}\u{627}\u{644}\u{6CC}`,
    pt: `Corrida`,
    'pt-pt': `Corrida`,
    ru: `\u{413}\u{43E}\u{43D}\u{43A}\u{430}`,
    sm: `Tuuga`,
    so: `Tartanka`,
    th: `\u{E01}\u{E32}\u{E23}\u{E41}\u{E02}\u{E48}\u{E07}\u{E02}\u{E31}\u{E19}`,
    ur: `\u{631}\u{6CC}\u{633}`,
    vi: `Cu\u{1ED9}c \u{111}ua`,
    'zh-hans': `\u{6BD4}\u{8D5B}`,
    'zh-hant': `\u{6BD4}\u{8CFD}`,
    en: `Race`
};
const $b11db1b62d4a8f76$export$4567b664cc755c4d = {
    ar: `\u{627}\u{644}\u{646}\u{637}\u{627}\u{642}`,
    de: `Verbreitung`,
    es: `Distribuci\xf3n`,
    fa: `\u{67E}\u{631}\u{627}\u{6A9}\u{646}\u{62F}\u{6AF}\u{6CC}`,
    fil: `Saklaw`,
    fr: `R\xe9partition`,
    hi: `\u{938}\u{940}\u{92E}\u{93E}`,
    ht: `Ranje`,
    it: `Distribuzione`,
    ja: `\u{5206}\u{5E03}\u{57DF}`,
    ko: `\u{BD84}\u{D3EC}`,
    mww: `Ntau yam`,
    ps: `\u{633}\u{627}\u{62D}\u{647}`,
    pt: `Distribui\xe7\xe3o`,
    'pt-pt': `Distribui\xe7\xe3o`,
    ru: `\u{410}\u{440}\u{435}\u{430}\u{43B}`,
    sm: `Tele`,
    so: `Baaxadda`,
    th: `\u{E1E}\u{E34}\u{E2A}\u{E31}\u{E22}`,
    ur: `\u{631}\u{6CC}\u{646}\u{62C}`,
    vi: `Ph\u{1EA1}m vi`,
    'zh-hans': `\u{5206}\u{5E03}\u{8303}\u{56F4}`,
    'zh-hant': `\u{5206}\u{5E03}\u{7BC4}\u{570D}`,
    en: `Range`
};
const $b11db1b62d4a8f76$export$f8107b180cdf43b3 = {
    ar: `\u{62C}\u{627}\u{647}\u{632}`,
    de: `Bereit`,
    es: `Listo`,
    fa: `\u{622}\u{645}\u{627}\u{62F}\u{647} \u{627}\u{645}`,
    fil: `Handa na`,
    fr: `Pr\xeat`,
    hi: `\u{924}\u{948}\u{92F}\u{93E}\u{930}`,
    ht: `Pare`,
    it: `Pronto`,
    ja: `\u{6E96}\u{5099}`,
    ko: `\u{C900}\u{BE44}\u{B410}\u{C5B4}`,
    mww: `npaj txhij`,
    ps: `\u{686}\u{645}\u{62A}\u{648} \u{6CC}\u{645}`,
    pt: `Pronto`,
    'pt-pt': `Pronto`,
    ru: `\u{413}\u{43E}\u{442}\u{43E}\u{432}\u{44B}`,
    sm: `Sauni`,
    so: `Diyaar`,
    th: `\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}`,
    ur: `\u{62A}\u{6CC}\u{627}\u{631}`,
    vi: `S\u{1EB5}n s\xe0ng`,
    'zh-hans': `\u{51C6}\u{5907}\u{597D}\u{4E86}`,
    'zh-hant': `\u{6E96}\u{5099}\u{597D}\u{4E86}`,
    en: `Ready`
};
const $b11db1b62d4a8f76$export$fc65ca123a4d95d5 = {
    ar: `\u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{62C}\u{627}\u{647}\u{632} \u{644}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630}\u{60C} \u{644}\u{643}\u{646} \u{644}\u{645} \u{64A}\u{62A}\u{645} \u{627}\u{62A}\u{62E}\u{627}\u{630} \u{623}\u{64A} \u{625}\u{62C}\u{631}\u{627}\u{621} \u{628}\u{639}\u{62F}. `,
    de: `Die Aktivit\xe4t ist bereit, durchgef\xfchrt zu werden, aber es wurde noch keine Ma\xdfnahme ergriffen. `,
    es: `La actividad est\xe1 lista para realizarse, pero a\xfan no se ha tomado ninguna medida. `,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{622}\u{645}\u{627}\u{62F}\u{647} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{627}\u{633}\u{62A}\u{60C} \u{627}\u{645}\u{627} \u{647}\u{646}\u{648}\u{632} \u{627}\u{642}\u{62F}\u{627}\u{645}\u{6CC} \u{635}\u{648}\u{631}\u{62A} \u{646}\u{6AF}\u{631}\u{641}\u{62A}\u{647} \u{627}\u{633}\u{62A}. `,
    fil: `Handa nang isagawa ang aktibidad, ngunit wala pang aksyon na ginawa. `,
    fr: `L\u{2019}activit\xe9 est pr\xeate \xe0 \xeatre r\xe9alis\xe9e, mais aucune action n\u{2019}a encore \xe9t\xe9 prise. `,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{94D}\u{930}\u{926}\u{930}\u{94D}\u{936}\u{928} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{924}\u{948}\u{92F}\u{93E}\u{930} \u{939}\u{948}, \u{932}\u{947}\u{915}\u{93F}\u{928} \u{905}\u{92D}\u{940} \u{924}\u{915} \u{915}\u{94B}\u{908} \u{915}\u{93E}\u{930}\u{94D}\u{930}\u{935}\u{93E}\u{908} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{917}\u{908} \u{939}\u{948}\u{964} `,
    ht: `Aktivite a se pare yo dwe f\xe8t, men pa gen okenn aksyon ank\xf2 yo te pran. `,
    it: `L'attivit\xe0 \xe8 pronta per essere eseguita, ma non \xe8 ancora stata intrapresa alcuna azione. `,
    ja: `\u{6D3B}\u{52D5}\u{306F}\u{5B9F}\u{65BD}\u{306E}\u{6E96}\u{5099}\u{304C}\u{6574}\u{3063}\u{3066}\u{3044}\u{307E}\u{3059}\u{304C}\u{3001}\u{307E}\u{3060}\u{5177}\u{4F53}\u{7684}\u{306A}\u{884C}\u{52D5}\u{306F}\u{53D6}\u{3089}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002} `,
    ko: `\u{D65C}\u{B3D9}\u{C740} \u{C900}\u{BE44}\u{AC00} \u{B418}\u{C5B4} \u{C788}\u{C73C}\u{B098} \u{C544}\u{C9C1} \u{C870}\u{CE58}\u{AC00} \u{CDE8}\u{D574}\u{C9C0}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}. `,
    mww: `Qhov kev ua haujlwm tau npaj txhij los ua, tab sis tseem tsis tau nqis tes ua. `,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62F} \u{62A}\u{631}\u{633}\u{631}\u{647} \u{6A9}\u{648}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{686}\u{645}\u{62A}\u{648} \u{62F}\u{6CC}\u{60C} \u{62E}\u{648} \u{62A}\u{631} \u{627}\u{648}\u{633}\u{647} \u{647}\u{6CC}\u{685} \u{627}\u{642}\u{62F}\u{627}\u{645} \u{646}\u{647} \u{62F}\u{6CC} \u{634}\u{648}\u{6CC}. `,
    pt: `A atividade est\xe1 pronta para ser realizada, mas nenhuma a\xe7\xe3o foi tomada ainda. `,
    'pt-pt': `A atividade est\xe1 pronta para ser realizada, mas ainda n\xe3o foi tomada qualquer a\xe7\xe3o. `,
    ru: `\u{410}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{433}\u{43E}\u{442}\u{43E}\u{432}\u{430} \u{43A} \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{438}\u{44E}, \u{43D}\u{43E} \u{43F}\u{43E}\u{43A}\u{430} \u{43D}\u{438}\u{43A}\u{430}\u{43A}\u{438}\u{445} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{439} \u{43D}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43F}\u{440}\u{438}\u{43D}\u{44F}\u{442}\u{43E}. `,
    sm: `O le gaioiga ua sauni e faatino, ae e leai se gaioiga na faia. `,
    so: `Hawlgalku waa diyaar in la qabto, laakiin weli wax tallaabo ah lama qaadin. `,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23} \u{E41}\u{E15}\u{E48}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E43}\u{E14}\u{E46} `,
    ur: `\u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{62F}\u{6CC}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{62A}\u{6CC}\u{627}\u{631} \u{6C1}\u{6D2}\u{60C} \u{644}\u{6CC}\u{6A9}\u{646} \u{627}\u{628}\u{6BE}\u{6CC} \u{62A}\u{6A9} \u{6A9}\u{648}\u{626}\u{6CC} \u{6A9}\u{627}\u{631}\u{631}\u{648}\u{627}\u{626}\u{6CC} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{6AF}\u{626}\u{6CC}\u{6D4} `,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\xe3 s\u{1EB5}n s\xe0ng \u{111}\u{1EC3} th\u{1EF1}c hi\u{1EC7}n, nh\u{1B0}ng ch\u{1B0}a c\xf3 h\xe0nh \u{111}\u{1ED9}ng n\xe0o \u{111}\u{1B0}\u{1EE3}c th\u{1EF1}c hi\u{1EC7}n. `,
    'zh-hans': `\u{6D3B}\u{52A8}\u{5DF2}\u{51C6}\u{5907}\u{5C31}\u{7EEA}\u{FF0C}\u{4F46}\u{5C1A}\u{672A}\u{91C7}\u{53D6}\u{4EFB}\u{4F55}\u{884C}\u{52A8}\u{3002} `,
    'zh-hant': `\u{6D3B}\u{52D5}\u{5DF2}\u{6E96}\u{5099}\u{597D}\u{9032}\u{884C}\u{FF0C}\u{4F46}\u{5C1A}\u{672A}\u{63A1}\u{53D6}\u{4EFB}\u{4F55}\u{884C}\u{52D5}\u{3002} `,
    en: `The activity is ready to be performed, but no action has yet been taken. `
};
const $b11db1b62d4a8f76$export$3f499ea389b2ed12 = {
    ar: `\u{62C}\u{627}\u{647}\u{632} \u{644}\u{644}\u{625}\u{628}\u{62F}\u{627}\u{639}`,
    de: `Bereit zum Erstellen`,
    es: `Listo para crear`,
    fa: `\u{622}\u{645}\u{627}\u{62F}\u{647} \u{62E}\u{644}\u{642}`,
    fil: `Handa nang lumikha`,
    fr: `Pr\xeat \xe0 cr\xe9er`,
    hi: `\u{92C}\u{928}\u{93E}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{924}\u{948}\u{92F}\u{93E}\u{930}`,
    ht: `Pare pou kreye`,
    it: `Pronto a creare`,
    ja: `\u{5275}\u{9020}\u{306E}\u{6E96}\u{5099}\u{304C}\u{3067}\u{304D}\u{307E}\u{3057}\u{305F}`,
    ko: `\u{CC3D}\u{C870}\u{D560} \u{C900}\u{BE44}\u{AC00} \u{B418}\u{C5B4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Npaj txhij los tsim`,
    ps: `\u{62F} \u{62C}\u{648}\u{693}\u{648}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{686}\u{645}\u{62A}\u{648} \u{6CC}\u{645}`,
    pt: `Pronto para criar`,
    'pt-pt': `Pronto para criar`,
    ru: `\u{413}\u{43E}\u{442}\u{43E}\u{432} \u{43A} \u{442}\u{432}\u{43E}\u{440}\u{447}\u{435}\u{441}\u{442}\u{432}\u{443}`,
    sm: `Sauni e fausiaina`,
    so: `Diyaar u ah abuurista`,
    th: `\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{62A}\u{62E}\u{644}\u{6CC}\u{642} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{62A}\u{6CC}\u{627}\u{631}`,
    vi: `S\u{1EB5}n s\xe0ng s\xe1ng t\u{1EA1}o`,
    'zh-hans': `\u{51C6}\u{5907}\u{521B}\u{4F5C}`,
    'zh-hant': `\u{6E96}\u{5099}\u{5275}\u{4F5C}`,
    en: `Ready to create`
};
const $b11db1b62d4a8f76$export$f3a7249fa8103164 = {
    ar: `\u{627}\u{644}\u{633}\u{628}\u{628}`,
    de: `Grund`,
    es: `Motivo`,
    fa: `\u{62F}\u{644}\u{6CC}\u{644}`,
    fil: `Dahilan`,
    fr: `Raison`,
    hi: `\u{915}\u{93E}\u{930}\u{923}`,
    ht: `Rezon ki f\xe8`,
    it: `Motivo`,
    ja: `\u{7406}\u{7531}`,
    ko: `\u{C774}\u{C720}`,
    mww: `Vim li cas`,
    ps: `\u{62F}\u{644}\u{6CC}\u{644}`,
    pt: `Motivo`,
    'pt-pt': `Raz\xe3o`,
    ru: `\u{41F}\u{440}\u{438}\u{447}\u{438}\u{43D}\u{430}`,
    sm: `Mafua'aga`,
    so: `Sababta`,
    th: `\u{E40}\u{E2B}\u{E15}\u{E38}\u{E1C}\u{E25}`,
    ur: `\u{648}\u{62C}\u{6C1}`,
    vi: `L\xfd do`,
    'zh-hans': `\u{539F}\u{56E0}`,
    'zh-hant': `\u{539F}\u{56E0}`,
    en: `Reason`
};
const $b11db1b62d4a8f76$export$9783dfaf4b8f5180 = {
    ar: $b11db1b62d4a8f76$var$html`هذا الموقع محمي بموجب reCAPTCHA <a class="Link--secondary" href="https://policies.google.com/privacy">وسياسة الخصوصية</a> <a class="Link--secondary" href="https://policies.google.com/terms">وشروط الخدمة</a> الخاصة بجوجل تنطبق.`,
    de: $b11db1b62d4a8f76$var$html`Diese Seite ist durch reCAPTCHA geschützt und die <a class="Link--secondary" href="https://policies.google.com/privacy">Google-Datenschutzrichtlinie</a> sowie <a class="Link--secondary" href="https://policies.google.com/terms">Nutzungsbedingungen</a> gelten.`,
    es: $b11db1b62d4a8f76$var$html`Este sitio está protegido por reCAPTCHA y se aplican la <a class="Link--secondary" href="https://policies.google.com/privacy">Política de Privacidad</a> y <a class="Link--secondary" href="https://policies.google.com/terms">los Términos de Servicio</a> de Google.`,
    fa: $b11db1b62d4a8f76$var$html`این سایت توسط reCAPTCHA محافظت می شود و <a class="Link--secondary" href="https://policies.google.com/privacy">سیاست حفظ حریم خصوصی</a> و <a class="Link--secondary" href="https://policies.google.com/terms">شرایط خدمات</a> گوگل اعمال می شود.`,
    fil: $b11db1b62d4a8f76$var$html`Ang site na ito ay protektado ng reCAPTCHA at nalalapat ang <a class="Link--secondary" href="https://policies.google.com/privacy">Patakaran sa Privacy</a> at <a class="Link--secondary" href="https://policies.google.com/terms">Mga Tuntunin ng Serbisyo</a> ng Google.`,
    fr: $b11db1b62d4a8f76$var$html`Ce site est protégé par reCAPTCHA et la <a class="Link--secondary" href="https://policies.google.com/privacy">politique de confidentialité</a> ainsi que les <a class="Link--secondary" href="https://policies.google.com/terms">Conditions d’utilisation</a> de Google s’appliquent.`,
    hi: $b11db1b62d4a8f76$var$html`यह साइट reCAPTCHA द्वारा सुरक्षित है और Google <a class="Link--secondary" href="https://policies.google.com/privacy">गोपनीयता नीति</a> और <a class="Link--secondary" href="https://policies.google.com/terms">सेवा की शर्तें</a> लागू होती हैं।`,
    ht: $b11db1b62d4a8f76$var$html`Sit sa a pwoteje pa reCAPTCHA ak Google <a class="Link--secondary" href="https://policies.google.com/privacy">Règleman sou enfòmasyon prive</a> ak <a class="Link--secondary" href="https://policies.google.com/terms">Regleman pou Sèvis</a> aplike.`,
    it: $b11db1b62d4a8f76$var$html`Questo sito è protetto da reCAPTCHA e si applicano <a class="Link--secondary" href="https://policies.google.com/privacy">l'Informativa sulla Privacy</a> di Google e <a class="Link--secondary" href="https://policies.google.com/terms">i Termini di Servizio</a> .`,
    ja: $b11db1b62d4a8f76$var$html`このサイトはreCAPTCHAによって保護されており、Googleの <a class="Link--secondary" href="https://policies.google.com/privacy">プライバシーポリシー</a> および <a class="Link--secondary" href="https://policies.google.com/terms">利用規約</a> が適用されます。`,
    ko: $b11db1b62d4a8f76$var$html`이 사이트는 reCAPTCHA에 의해 보호되며, 구글 <a class="Link--secondary" href="https://policies.google.com/privacy">개인정보처리방침</a> 과 <a class="Link--secondary" href="https://policies.google.com/terms">이용 약관</a> 이 적용됩니다.`,
    mww: $b11db1b62d4a8f76$var$html`Lub xaib no muaj kev tiv thaiv los ntawm reCAPTCHA thiab Google <a class="Link--secondary" href="https://policies.google.com/privacy">Txoj Cai Tswjfwm Ntiag Tug</a> thiab <a class="Link--secondary" href="https://policies.google.com/terms">Cov Lus Cog Tseg ntawm Kev Pabcuam</a> siv.`,
    ps: $b11db1b62d4a8f76$var$html`دا سایټ د reCAPTCHA لخوا خوندی دی او د ګوګل <a class="Link--secondary" href="https://policies.google.com/privacy">د محرمیت پالیسۍ</a> او <a class="Link--secondary" href="https://policies.google.com/terms">د خدمت شرایط</a> تطبیق کیږی.`,
    pt: $b11db1b62d4a8f76$var$html`Este site é protegido pelo reCAPTCHA e a <a class="Link--secondary" href="https://policies.google.com/privacy">Política de Privacidade</a> e <a class="Link--secondary" href="https://policies.google.com/terms">os Termos de Serviço</a> do Google se aplicam.`,
    'pt-pt': $b11db1b62d4a8f76$var$html`Este site está protegido pelo reCAPTCHA e aplicam-se a <a class="Link--secondary" href="https://policies.google.com/privacy">Política de Privacidade</a> e <a class="Link--secondary" href="https://policies.google.com/terms">os Termos de Serviço</a> da Google.`,
    ru: $b11db1b62d4a8f76$var$html`Этот сайт защищён reCAPTCHA, и применяются <a class="Link--secondary" href="https://policies.google.com/privacy">Политика конфиденциальности</a> Google и <a class="Link--secondary" href="https://policies.google.com/terms">Условия использования</a> .`,
    sm: $b11db1b62d4a8f76$var$html`O lenei 'upega tafa'ilagi e puipuia e le reCAPTCHA ma le Google <a class="Link--secondary" href="https://policies.google.com/privacy">faalauaiteleina Faiga Faavae</a> ma <a class="Link--secondary" href="https://policies.google.com/terms">Tuutuuga o Auaunaga fa'aaogaina</a> .`,
    so: $b11db1b62d4a8f76$var$html`Boggan waxaa ilaaliya reCAPTCHA, waxaana khuseeya <a class="Link--secondary" href="https://policies.google.com/privacy">Siyaasadda Asturnaanta</a> Google iyo <a class="Link--secondary" href="https://policies.google.com/terms">Shuruudaha Adeegga</a> .`,
    th: $b11db1b62d4a8f76$var$html`เว็บไซต์นี้ได้รับการคุ้มครองโดย reCAPTCHA และ <a class="Link--secondary" href="https://policies.google.com/privacy">นโยบายความเป็นส่วนตัว</a> และ <a class="Link--secondary" href="https://policies.google.com/terms">ข้อกําหนดในการให้บริการ</a> ของ Google มีผลบังคับใช้`,
    ur: $b11db1b62d4a8f76$var$html`یہ سائٹ reCAPTCHA کے تحت محفوظ ہے اور گوگل <a class="Link--secondary" href="https://policies.google.com/privacy">کی پرائیویسی پالیسی</a> اور <a class="Link--secondary" href="https://policies.google.com/terms">سروس کی شرائط</a> لاگو ہوتی ہیں۔`,
    vi: $b11db1b62d4a8f76$var$html`Trang web này được bảo vệ bởi reCAPTCHA và áp dụng <a class="Link--secondary" href="https://policies.google.com/privacy">Chính sách quyền riêng tư</a> và <a class="Link--secondary" href="https://policies.google.com/terms">Điều khoản dịch vụ</a> của Google.`,
    'zh-hans': $b11db1b62d4a8f76$var$html`本网站受reCAPTCHA保护，并适用谷歌 <a class="Link--secondary" href="https://policies.google.com/privacy">隐私政策</a> 和 <a class="Link--secondary" href="https://policies.google.com/terms">服务条款</a> 。`,
    'zh-hant': $b11db1b62d4a8f76$var$html`本網站受 reCAPTCHA 保護，並適用 Google <a class="Link--secondary" href="https://policies.google.com/privacy">隱私政策</a> 及 <a class="Link--secondary" href="https://policies.google.com/terms">服務條款</a> 。`,
    en: $b11db1b62d4a8f76$var$html`This site is protected by reCAPTCHA and the Google <a class="Link--secondary" href="https://policies.google.com/privacy">Privacy Policy</a> and <a class="Link--secondary" href="https://policies.google.com/terms">Terms of Service</a> apply.`
};
const $b11db1b62d4a8f76$export$cc229f46dc8c878f = {
    ar: `\u{62A}\u{645} \u{627}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{64A}\u{647}\u{627} \u{645}\u{624}\u{62E}\u{631}\u{627}`,
    de: `K\xfcrzlich aufgerufen`,
    es: `Consultado recientemente`,
    fa: `\u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{627}\u{62E}\u{6CC}\u{631}`,
    fil: `Kamakailan lamang na na-access`,
    fr: `R\xe9cemment consult\xe9`,
    hi: `\u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{90F}\u{915}\u{94D}\u{938}\u{947}\u{938} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Aks\xe8 d\xe8ny\xe8man`,
    it: `Accesso recente`,
    ja: `\u{6700}\u{8FD1}\u{30A2}\u{30AF}\u{30BB}\u{30B9}`,
    ko: `\u{CD5C}\u{ADFC} \u{C811}\u{C18D}`,
    mww: `Tsis ntev los no nkag mus`,
    ps: `\u{62A}\u{627}\u{632}\u{647} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC}`,
    pt: `Acessado recentemente`,
    'pt-pt': `Acedido recentemente`,
    ru: `\u{41D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}`,
    sm: `Mauaina talu ai nei`,
    so: `Dhawaan la helay`,
    th: `\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{6CC} \u{6AF}\u{626}\u{6CC}`,
    vi: `Truy c\u{1EAD}p g\u{1EA7}n \u{111}\xe2y`,
    'zh-hans': `\u{6700}\u{8FD1}\u{8BBF}\u{95EE}`,
    'zh-hant': `\u{8FD1}\u{671F}\u{5B58}\u{53D6}`,
    en: `Recently accessed`
};
const $b11db1b62d4a8f76$export$6fd132dad37489aa = {
    ar: `\u{62A}\u{645} \u{625}\u{646}\u{634}\u{627}\u{624}\u{647} \u{645}\u{624}\u{62E}\u{631}\u{627}`,
    de: `K\xfcrzlich geschaffen`,
    es: `Creado recientemente`,
    fa: `\u{62A}\u{627}\u{632}\u{647} \u{62A}\u{623}\u{633}\u{6CC}\u{633} \u{634}\u{62F}\u{647}`,
    fil: `Kamakailan-lamang na nilikha`,
    fr: `R\xe9cemment cr\xe9\xe9e`,
    hi: `\u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `D\xe8ny\xe8man kreye`,
    it: `Creato di recente`,
    ja: `\u{6700}\u{8FD1}\u{4F5C}\u{6210}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}`,
    ko: `\u{CD5C}\u{ADFC} \u{C81C}\u{C791}`,
    mww: `Tsis ntev los no tsim`,
    ps: `\u{62A}\u{627}\u{632}\u{647} \u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}`,
    pt: `Criado recentemente`,
    'pt-pt': `Criado recentemente`,
    ru: `\u{41D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{43E}`,
    sm: `Talu ai nei na foafoaina`,
    so: `Dhawaan la abuuray`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{62A}\u{62E}\u{644}\u{6CC}\u{642} \u{634}\u{62F}\u{6C1}`,
    vi: `T\u{1EA1}o g\u{1EA7}n \u{111}\xe2y`,
    'zh-hans': `\u{6700}\u{8FD1}\u{521B}\u{5EFA}`,
    'zh-hant': `\u{8FD1}\u{671F}\u{5275}\u{5EFA}`,
    en: `Recently created`
};
const $b11db1b62d4a8f76$export$27a0f09f35c8868f = {
    ar: (date, user)=>$b11db1b62d4a8f76$var$html`<span>تم إنشاؤه ${date} بواسطة ${user}</span>`,
    de: (date, user)=>$b11db1b62d4a8f76$var$html`<span>Vor ${date} erstellt von ${user}</span>`,
    es: (date, user)=>$b11db1b62d4a8f76$var$html`<span>Creado ${date} por ${user}</span>`,
    fa: (date, user)=>$b11db1b62d4a8f76$var$html`<span>${date} توسط ${user} است</span>`,
    fil: (date, user)=>$b11db1b62d4a8f76$var$html`<span>Nilikha 5 ${date} sa pamamagitan ng ${user}</span>`,
    fr: (date, user)=>$b11db1b62d4a8f76$var$html`<span>Créé ${date} par ${user}</span>`,
    hi: (date, user)=>$b11db1b62d4a8f76$var$html`<span>द्वारा निर्मित ${date} ${user}</span>`,
    ht: (date, user)=>$b11db1b62d4a8f76$var$html`<span>Te kreye ${date} pa ${user}</span>`,
    it: (date, user)=>$b11db1b62d4a8f76$var$html`<span>Creato ${date} da ${user}</span>`,
    ja: (date, user)=>$b11db1b62d4a8f76$var$html`<span>${date}に${user}によって作成されました</span>`,
    ko: (date, user)=>$b11db1b62d4a8f76$var$html`<span>${date} ${user}가 작성함</span>`,
    mww: (date, user)=>$b11db1b62d4a8f76$var$html`<span>Tsim ${date} los ntawm ${user}</span>`,
    ps: (date, user)=>$b11db1b62d4a8f76$var$html`<span>${date} ${user} لخوا جوړ شوی</span>`,
    pt: (date, user)=>$b11db1b62d4a8f76$var$html`<span>Criado ${date} por ${user}</span>`,
    'pt-pt': (date, user)=>$b11db1b62d4a8f76$var$html`<span>Criado ${date} por ${user}</span>`,
    ru: (date, user)=>$b11db1b62d4a8f76$var$html`<span>Создано ${date} ${user}</span>`,
    sm: (date, user)=>$b11db1b62d4a8f76$var$html`<span>Faia 5 ${date} e ${user}</span>`,
    so: (date, user)=>$b11db1b62d4a8f76$var$html`<span>Waxaa abuuray ${date} hor ${user}</span>`,
    th: (date, user)=>$b11db1b62d4a8f76$var$html`<span>สร้างเมื่อ ${date} โดย ${user}</span>`,
    ur: (date, user)=>$b11db1b62d4a8f76$var$html`<span>${date} ${user} نے تخلیق کیا</span>`,
    vi: (date, user)=>$b11db1b62d4a8f76$var$html`<span>Được tạo cách ${date} ${user}</span>`,
    'zh-hans': (date, user)=>$b11db1b62d4a8f76$var$html`<span>由${user}于${date}创建</span>`,
    'zh-hant': (date, user)=>$b11db1b62d4a8f76$var$html`<span>由 ${user} 於 ${date}前創建</span>`,
    en: (date, user)=>$b11db1b62d4a8f76$var$html`<span>Created ${date} by ${user}</span>`
};
const $b11db1b62d4a8f76$export$882b48c7f78937db = {
    ar: `\u{62A}\u{645} \u{625}\u{646}\u{634}\u{627}\u{624}\u{647} \u{645}\u{624}\u{62E}\u{631}\u{627} \u{645}\u{646} \u{642}\u{628}\u{644}\u{643}`,
    de: `K\xfcrzlich von dir erstellt`,
    es: `Creado recientemente por ti`,
    fa: `\u{627}\u{62E}\u{6CC}\u{631}\u{627} \u{62A}\u{648}\u{633}\u{637} \u{634}\u{645}\u{627} \u{633}\u{627}\u{62E}\u{62A}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Kamakailan lamang ay nilikha mo`,
    fr: `R\xe9cemment cr\xe9\xe9 par toi`,
    hi: `\u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{906}\u{92A}\u{915}\u{947} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `D\xe8ny\xe8man te kreye pa ou`,
    it: `Recentemente creato da te`,
    ja: `\u{6700}\u{8FD1}\u{3042}\u{306A}\u{305F}\u{304C}\u{4F5C}\u{3063}\u{305F}\u{3082}\u{306E}\u{3067}\u{3059}`,
    ko: `\u{CD5C}\u{ADFC}\u{C5D0} \u{B2F9}\u{C2E0}\u{C774} \u{B9CC}\u{B4E0} \u{AC83}`,
    mww: `Tsis ntev los no tsim los ntawm koj`,
    ps: `\u{62A}\u{627}\u{632}\u{647} \u{633}\u{62A}\u{627} \u{644}\u{62E}\u{648}\u{627} \u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}`,
    pt: `Criado recentemente por voc\xea`,
    'pt-pt': `Recentemente criado por ti`,
    ru: `\u{41D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{43E} \u{432}\u{430}\u{43C}\u{438}`,
    sm: `Faauta, sa ia lei faia ea mo oe se faataitaiga lelei?`,
    so: `Dhawaan adiga ayaa abuuray`,
    th: `\u{E04}\u{E38}\u{E13}\u{E40}\u{E1E}\u{E34}\u{E48}\u{E07}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{622}\u{67E} \u{646}\u{6D2} \u{62A}\u{62E}\u{644}\u{6CC}\u{642} \u{6A9}\u{6CC}\u{627}`,
    vi: `G\u{1EA7}n \u{111}\xe2y do b\u{1EA1}n t\u{1EA1}o`,
    'zh-hans': `\u{6700}\u{8FD1}\u{7531}\u{4F60}\u{521B}\u{5EFA}`,
    'zh-hant': `\u{6700}\u{8FD1}\u{7531}\u{4F60}\u{5275}\u{4F5C}`,
    en: `Recently created by you`
};
const $b11db1b62d4a8f76$export$7e0f74c500a6d00 = {
    ar: `\u{62A}\u{645} \u{627}\u{644}\u{62A}\u{62D}\u{62F}\u{64A}\u{62B} \u{645}\u{624}\u{62E}\u{631}\u{627}`,
    de: `K\xfcrzlich aktualisiert`,
    es: `Actualizado recientemente`,
    fa: `\u{627}\u{62E}\u{6CC}\u{631}\u{627} \u{628}\u{647} \u{631}\u{648}\u{632}\u{631}\u{633}\u{627}\u{646}\u{6CC} \u{634}\u{62F}\u{647}`,
    fil: `Kamakailan-lamang na na-update`,
    fr: `Mise \xe0 jour r\xe9cente`,
    hi: `\u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{905}\u{92A}\u{921}\u{947}\u{91F} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `D\xe8ny\xe8man mete ajou`,
    it: `Aggiornato di recente`,
    ja: `\u{6700}\u{8FD1}\u{66F4}\u{65B0}\u{6E08}\u{307F}`,
    ko: `\u{CD5C}\u{ADFC} \u{C5C5}\u{B370}\u{C774}\u{D2B8}`,
    mww: `Tsis ntev los no hloov kho`,
    ps: `\u{62A}\u{627}\u{632}\u{647} \u{62A}\u{627}\u{632}\u{647} \u{634}\u{648}\u{6CC}`,
    pt: `Atualizado recentemente`,
    'pt-pt': `Atualizado recentemente`,
    ru: `\u{41D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{43E}`,
    sm: `Fa'afouina talu ai nei`,
    so: `Dhawaan la cusbooneysiiyay`,
    th: `\u{E2D}\u{E31}\u{E1E}\u{E40}\u{E14}\u{E17}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6C1}\u{648}\u{627} \u{6C1}\u{6D2}`,
    vi: `C\u{1EAD}p nh\u{1EAD}t g\u{1EA7}n \u{111}\xe2y`,
    'zh-hans': `\u{6700}\u{8FD1}\u{66F4}\u{65B0}`,
    'zh-hant': `\u{6700}\u{8FD1}\u{66F4}\u{65B0}`,
    en: `Recently updated`
};
const $b11db1b62d4a8f76$export$440dea32dee3ec02 = {
    ar: `\u{62A}\u{645}\u{62A} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{62A}\u{647} \u{645}\u{624}\u{62E}\u{631}\u{627} \u{645}\u{646} \u{642}\u{628}\u{644}\u{643}`,
    de: `K\xfcrzlich von dir angesehen`,
    es: `Visto recientemente por ti`,
    fa: `\u{627}\u{62E}\u{6CC}\u{631}\u{627} \u{62A}\u{648}\u{633}\u{637} \u{634}\u{645}\u{627} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Kamakailan lamang ay tiningnan mo`,
    fr: `R\xe9cemment regard\xe9 par vous`,
    hi: `\u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{906}\u{92A}\u{915}\u{947} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{926}\u{947}\u{916}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `D\xe8ny\xe8man w\xe8 pa ou`,
    it: `Recentemente visto da te`,
    ja: `\u{6700}\u{8FD1}\u{3042}\u{306A}\u{305F}\u{304C}\u{95B2}\u{89A7}\u{3057}\u{305F}`,
    ko: `\u{CD5C}\u{ADFC}\u{C5D0} \u{B2F9}\u{C2E0}\u{C774} \u{BCF8} \u{AE00}`,
    mww: `Tsis ntev los no saib los ntawm koj`,
    ps: `\u{633}\u{62A}\u{627} \u{644}\u{62E}\u{648}\u{627} \u{62A}\u{627}\u{632}\u{647} \u{644}\u{6CC}\u{62F}\u{644} \u{634}\u{648}\u{6CC}`,
    pt: `Recentemente assistido por voc\xea`,
    'pt-pt': `Recentemente visto por ti`,
    ru: `\u{41D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E} \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{435}\u{43D}\u{43E} \u{432}\u{430}\u{43C}\u{438}`,
    sm: `Talu ai nei na e va'ai ai`,
    so: `Dhawaan ayaad daawateen`,
    th: `\u{E04}\u{E38}\u{E13}\u{E40}\u{E1E}\u{E34}\u{E48}\u{E07}\u{E14}\u{E39}`,
    ur: `\u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{622}\u{67E} \u{646}\u{6D2} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{627}`,
    vi: `B\u{1EA1}n \u{111}\xe3 xem g\u{1EA7}n \u{111}\xe2y`,
    'zh-hans': `\u{6700}\u{8FD1}\u{88AB}\u{4F60}\u{89C2}\u{770B}`,
    'zh-hant': `\u{6700}\u{8FD1}\u{88AB}\u{4F60}\u{700F}\u{89BD}`,
    en: `Recently viewed by you`
};
const $b11db1b62d4a8f76$export$38392dd61f638ef6 = {
    ar: `\u{627}\u{644}\u{62D}\u{627}\u{635}\u{644}\u{648}\u{646} \u{639}\u{644}\u{649} \u{627}\u{644}\u{62C}\u{627}\u{626}\u{632}\u{629}`,
    de: `Preistr\xe4ger`,
    es: `Galardonados`,
    fa: `\u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{6AF}\u{627}\u{646}`,
    fil: `Mga tatanggap`,
    fr: `R\xe9cipiendaires`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924}\u{915}\u{930}\u{94D}\u{924}\u{93E}`,
    ht: `Moun k ap resevwa yo`,
    it: `Vincitori`,
    ja: `\u{53D7}\u{8CDE}\u{8005}`,
    ko: `\u{C218}\u{C0C1}\u{C790}`,
    mww: `Cov neeg tau txais kev pab`,
    ps: `\u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Recipientes`,
    'pt-pt': `Recipientes`,
    ru: `\u{41B}\u{430}\u{443}\u{440}\u{435}\u{430}\u{442}\u{44B}`,
    sm: `Tagata e mauaina`,
    so: `Ku guuleystayaasha`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E23}\u{E31}\u{E1A}`,
    ur: `\u{648}\u{635}\u{648}\u{644} \u{6A9}\u{646}\u{646}\u{62F}\u{6AF}\u{627}\u{646}`,
    vi: `Ng\u{1B0}\u{1EDD}i nh\u{1EAD}n`,
    'zh-hans': `\u{83B7}\u{5956}\u{8005}`,
    'zh-hant': `\u{5F97}\u{734E}\u{8005}`,
    en: `Recipients`
};
const $b11db1b62d4a8f76$export$de23dc6ad7910785 = {
    ar: `\u{627}\u{644}\u{62A}\u{648}\u{635}\u{64A}\u{629}`,
    de: `Empfehlung`,
    es: `Recomendaci\xf3n`,
    fa: `\u{62A}\u{648}\u{635}\u{6CC}\u{647} \u{646}\u{627}\u{645}\u{647}`,
    fil: `Rekomendasyon`,
    fr: `Recommandation`,
    hi: `\u{938}\u{93F}\u{92B}\u{93C}\u{93E}\u{930}\u{93F}\u{936}`,
    ht: `Rek\xf2mandasyon`,
    it: `Raccomandazione`,
    ja: `\u{63A8}\u{5968}\u{4E8B}\u{9805}`,
    ko: `\u{CD94}\u{CC9C}`,
    mww: `Kev pom zoo`,
    ps: `\u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{647}`,
    pt: `Recomenda\xe7\xe3o`,
    'pt-pt': `Recomenda\xe7\xe3o`,
    ru: `\u{420}\u{435}\u{43A}\u{43E}\u{43C}\u{435}\u{43D}\u{434}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Fautuaga`,
    so: `Talo`,
    th: `\u{E41}\u{E19}\u{E30}\u{E19}\u{E4D}\u{E32}`,
    ur: `\u{633}\u{641}\u{627}\u{631}\u{634}`,
    vi: `Khuy\u{1EBF}n ngh\u{1ECB}`,
    'zh-hans': `\u{63A8}\u{8350}`,
    'zh-hant': `\u{63A8}\u{85A6}`,
    en: `Recommendation`
};
const $b11db1b62d4a8f76$export$d1befcb33b768152 = {
    ar: `\u{645}\u{648}\u{635}\u{649} \u{628}\u{647}`,
    de: `Empfohlen`,
    es: `Recomendado`,
    fa: `\u{62A}\u{648}\u{635}\u{6CC}\u{647} \u{634}\u{62F}\u{647}`,
    fil: `Inirerekumenda`,
    fr: `Recommand\xe9`,
    hi: `\u{905}\u{927}\u{93F}\u{915}:`,
    ht: `Rek\xf2mande`,
    it: `Consigliato`,
    ja: `\u{304A}\u{3059}\u{3059}\u{3081}`,
    ko: `\u{CD94}\u{CC9C}`,
    mww: `pom zoo`,
    ps: `\u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{647} \u{634}\u{648}\u{6D0}`,
    pt: `Recomendado`,
    'pt-pt': `Recomendado`,
    ru: `\u{420}\u{435}\u{43A}\u{43E}\u{43C}\u{435}\u{43D}\u{434}\u{443}\u{435}\u{43C}`,
    sm: `Fautuaina`,
    so: `Waxaa lagu taliyay`,
    th: `\u{E41}\u{E19}\u{E30}\u{E19}\u{E4D}\u{E32}`,
    ur: `\u{62A}\u{62C}\u{648}\u{6CC}\u{632} \u{6A9}\u{631}\u{62F}\u{6C1}`,
    vi: `\u{110}\u{1EC1} xu\u{1EA5}t`,
    'zh-hans': `\u{63A8}\u{8350}\u{9605}\u{8BFB}`,
    'zh-hant': `\u{63A8}\u{85A6}`,
    en: `Recommended`
};
const $b11db1b62d4a8f76$export$e4d3ce7fbdaf370e = {
    ar: `\u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{631}\u{62F}\u{627}\u{62F}`,
    de: `Wiederherstellungscode`,
    es: `C\xf3digo de recuperaci\xf3n`,
    fa: `\u{6A9}\u{62F} \u{628}\u{627}\u{632}\u{6CC}\u{627}\u{628}\u{6CC}`,
    fil: `Code ng pagbawi`,
    fr: `Code de r\xe9cup\xe9ration`,
    hi: `\u{92A}\u{941}\u{928}\u{930}\u{94D}\u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{915}\u{94B}\u{921}`,
    ht: `K\xf2d Recovery`,
    it: `Codice di recupero`,
    ja: `\u{30EA}\u{30AB}\u{30D0}\u{30EA}\u{30FC}\u{30B3}\u{30FC}\u{30C9}`,
    ko: `\u{BCF5}\u{AD6C} \u{CF54}\u{B4DC}`,
    mww: `Rov qab code`,
    ps: `\u{62F} \u{628}\u{6CC}\u{627} \u{631}\u{63A}\u{648}\u{646}\u{6D0} \u{6A9}\u{648}\u{689}`,
    pt: `C\xf3digo de recupera\xe7\xe3o`,
    'pt-pt': `C\xf3digo de recupera\xe7\xe3o`,
    ru: `\u{41A}\u{43E}\u{434} \u{432}\u{43E}\u{441}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Numera o le toe faaleleia`,
    so: `Koodhka soo kabashada`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E01}\u{E39}\u{E49}\u{E04}\u{E37}\u{E19}`,
    ur: `\u{631}\u{6CC}\u{6A9}\u{648}\u{631}\u{6CC} \u{6A9}\u{648}\u{688}`,
    vi: `M\xe3 kh\xf4i ph\u{1EE5}c`,
    'zh-hans': `\u{6062}\u{590D}\u{7801}`,
    'zh-hant': `\u{5FA9}\u{539F}\u{4EE3}\u{78BC}`,
    en: `Recovery code`
};
const $b11db1b62d4a8f76$export$7ae26229b4f2e761 = {
    ar: `\u{625}\u{639}\u{627}\u{62F}\u{629} \u{62A}\u{648}\u{62C}\u{64A}\u{647}...`,
    de: `Umleitung...`,
    es: `Redirigiendo...`,
    fa: `\u{62F}\u{631} \u{62D}\u{627}\u{644} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{645}\u{633}\u{6CC}\u{631}...`,
    fil: `Pag-redirect ...`,
    fr: `Redirigeant...`,
    hi: `\u{92A}\u{941}\u{928}\u{930}\u{94D}\u{928}\u{93F}\u{930}\u{94D}\u{926}\u{947}\u{936}\u{928}...`,
    ht: `Redireksyon ...`,
    it: `Sto reindirizzando...`,
    ja: `\u{65B9}\u{5411}\u{8EE2}\u{63DB}...`,
    ko: `\u{BC29}\u{D5A5} \u{C804}\u{D658} \u{C911}...`,
    mww: `Redirecting...`,
    ps: `\u{628}\u{6CC}\u{627} \u{644}\u{627}\u{631}\u{69A}\u{648}\u{648}\u{646}\u{647} \u{6A9}\u{648}\u{645}...`,
    pt: `Redirecionando...`,
    'pt-pt': `Redirecionar...`,
    ru: `\u{41F}\u{435}\u{440}\u{435}\u{43D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}...`,
    sm: `Toe fa'afo'i...`,
    so: `Dib u jihayn...`,
    th: `\u{E01}\u{E32}\u{E23}\u{E40}\u{E1B}\u{E25}\u{E35}\u{E48}\u{E22}\u{E19}\u{E40}\u{E2A}\u{E49}\u{E19}\u{E17}\u{E32}\u{E07}...`,
    ur: `\u{631}\u{6CC} \u{688}\u{627}\u{626}\u{631}\u{6CC}\u{6A9}\u{679}...`,
    vi: `\u{110}ang chuy\u{1EC3}n h\u{1B0}\u{1EDB}ng...`,
    'zh-hans': `\u{8F6C}\u{5411}......`,
    'zh-hant': `\u{8F49}\u{79FB}\u{6CE8}\u{610F}\u{529B}......`,
    en: `Redirecting...`
};
const $b11db1b62d4a8f76$export$5ed4ca5ae1852886 = {
    ar: `\u{631}\u{627}\u{62C}\u{639}`,
    de: `Siehe`,
    es: `Consulta`,
    fa: `\u{645}\u{631}\u{627}\u{62C}\u{639}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Sumangguni`,
    fr: `Voir`,
    hi: `\u{930}\u{947}\u{92B}\u{930} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `Al gade`,
    it: `Consulta`,
    ja: `\u{53C2}\u{7167}`,
    ko: `\u{CC38}\u{C870}`,
    mww: `Xa mus`,
    ps: `\u{631}\u{62C}\u{648}\u{639} \u{648}\u{6A9}\u{693}\u{626}`,
    pt: `Consulte`,
    'pt-pt': `Consulte`,
    ru: `\u{421}\u{43C}.`,
    sm: `Fa'asino`,
    so: `Tixraac`,
    th: `\u{E2D}\u{E49}\u{E32}\u{E07}\u{E2D}\u{E34}\u{E07}`,
    ur: `\u{62D}\u{648}\u{627}\u{644}\u{6C1}`,
    vi: `Tham kh\u{1EA3}o`,
    'zh-hans': `\u{53C2}\u{8003}\u{6587}\u{732E}`,
    'zh-hant': `\u{53C3}\u{8003}\u{8CC7}\u{6599}`,
    en: `Refer`
};
const $b11db1b62d4a8f76$export$44f2e10589b682de = {
    ar: `\u{627}\u{644}\u{625}\u{62D}\u{627}\u{644}\u{629}`,
    de: `Vermittlung`,
    es: `Recomendaci\xf3n`,
    fa: `\u{627}\u{631}\u{62C}\u{627}\u{639}`,
    fil: `Email Address *`,
    fr: `Recommandation`,
    hi: `\u{930}\u{947}\u{92B}\u{930}\u{932}`,
    ht: `Referans`,
    it: `Segnalazione`,
    ja: `\u{7D39}\u{4ECB}`,
    ko: `\u{C758}\u{B8B0}`,
    mww: `Kev xa mus rau`,
    ps: `\u{631}\u{627}\u{62C}\u{639} \u{6A9}\u{648}\u{644}`,
    pt: `Encaminhamento`,
    'pt-pt': `Encaminhamento`,
    ru: `\u{41D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Fa'asino`,
    so: `Tixraac`,
    th: `\u{E01}\u{E32}\u{E23}\u{E2D}\u{E49}\u{E32}\u{E07}\u{E2D}\u{E34}\u{E07}`,
    ur: `\u{62D}\u{648}\u{627}\u{644}\u{6C1}`,
    vi: `Gi\u{1EDB}i thi\u{1EC7}u`,
    'zh-hans': `\u{8F6C}\u{8BCA}`,
    'zh-hant': `\u{8F49}\u{4ECB}`,
    en: `Referral`
};
const $b11db1b62d4a8f76$export$9ccc96e97b65b30b = {
    ar: `\u{627}\u{644}\u{62A}\u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Regenerieren`,
    es: `Regenera`,
    fa: `\u{628}\u{627}\u{632}\u{633}\u{627}\u{632}\u{6CC}`,
    fil: `Muling Pagbuo`,
    fr: `R\xe9g\xe9n\xe9ration`,
    hi: `\u{92A}\u{941}\u{928}: \u{909}\u{924}\u{94D}\u{92A}\u{928}\u{94D}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Rejenerasyon`,
    it: `Rigenerazione`,
    ja: `\u{518D}\u{751F}`,
    ko: `\u{C7AC}\u{C0DD}`,
    mww: `rov tsim dua tshiab`,
    ps: `\u{628}\u{6CC}\u{627} \u{631}\u{63A}\u{648}\u{646}\u{647}`,
    pt: `Regenerar`,
    'pt-pt': `Regenerar`,
    ru: `\u{420}\u{435}\u{433}\u{435}\u{43D}\u{435}\u{440}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Toe fa'afouina`,
    so: `Regenerate`,
    th: `\u{E1F}\u{E37}\u{E49}\u{E19}\u{E1F}\u{E39}`,
    ur: `\u{631}\u{6CC} \u{62C}\u{646}\u{631}\u{6CC}\u{679}`,
    vi: `T\xe1i t\u{1EA1}o`,
    'zh-hans': `\u{518D}\u{751F}`,
    'zh-hant': `\u{518D}\u{751F}`,
    en: `Regenerate`
};
const $b11db1b62d4a8f76$export$612e5b9f7a9c488d = {
    ar: `\u{625}\u{639}\u{627}\u{62F}\u{629} \u{62A}\u{648}\u{644}\u{64A}\u{62F} \u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{631}\u{62F}\u{627}\u{62F}`,
    de: `Regenerieren von Wiederherstellungscode`,
    es: `C\xf3digo de recuperaci\xf3n de regeneraci\xf3n`,
    fa: `\u{628}\u{627}\u{632}\u{633}\u{627}\u{632}\u{6CC} \u{6A9}\u{62F} \u{628}\u{627}\u{632}\u{6CC}\u{627}\u{628}\u{6CC}`,
    fil: `Muling buuin ang code ng pagbawi`,
    fr: `R\xe9g\xe9n\xe9rer le code de r\xe9cup\xe9ration`,
    hi: `\u{92A}\u{941}\u{928}\u{930}\u{94D}\u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{915}\u{94B}\u{921} \u{92A}\u{941}\u{928}: \u{909}\u{924}\u{94D}\u{92A}\u{928}\u{94D}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Rejenere k\xf2d rekiperasyon`,
    it: `Rigenerare codice di recupero`,
    ja: `\u{30EA}\u{30AB}\u{30D0}\u{30EA}\u{30FC}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{518D}\u{751F}`,
    ko: `\u{BCF5}\u{AD6C} \u{CF54}\u{B4DC} \u{C7AC}\u{C0DD}`,
    mww: `Regenerate rov qab code`,
    ps: `\u{62F} \u{628}\u{6CC}\u{627} \u{631}\u{63A}\u{648}\u{646}\u{6D0} \u{6A9}\u{648}\u{689} \u{628}\u{6CC}\u{627} \u{62A}\u{648}\u{644}\u{6CC}\u{62F}`,
    pt: `C\xf3digo de recupera\xe7\xe3o de regenera\xe7\xe3o`,
    'pt-pt': `Regenerar c\xf3digo de recupera\xe7\xe3o`,
    ru: `\u{420}\u{435}\u{433}\u{435}\u{43D}\u{435}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{43A}\u{43E}\u{434} \u{432}\u{43E}\u{441}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Toe faafouina le numera o le toe faaleleia`,
    so: `Dib u soo celi koodhka soo kabashada`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E01}\u{E32}\u{E23}\u{E01}\u{E39}\u{E49}\u{E04}\u{E37}\u{E19}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{631}\u{6CC}\u{6A9}\u{648}\u{631}\u{6CC} \u{6A9}\u{648}\u{688} \u{6A9}\u{648} \u{62F}\u{648}\u{628}\u{627}\u{631}\u{6C1} \u{62C}\u{646}\u{631}\u{6CC}\u{679} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA1}o l\u{1EA1}i m\xe3 kh\xf4i ph\u{1EE5}c`,
    'zh-hans': `\u{91CD}\u{65B0}\u{751F}\u{6210}\u{6062}\u{590D}\u{7801}`,
    'zh-hant': `\u{91CD}\u{65B0}\u{751F}\u{6210}\u{5FA9}\u{539F}\u{78BC}`,
    en: `Regenerate recovery code`
};
const $b11db1b62d4a8f76$export$f9f8f2d1914b7cf3 = {
    ar: `\u{623}\u{639}\u{62F} \u{62A}\u{648}\u{644}\u{64A}\u{62F} \u{627}\u{644}\u{643}\u{648}\u{62F} \u{627}\u{644}\u{630}\u{64A} \u{64A}\u{645}\u{643}\u{646}\u{643} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645}\u{647} \u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{639}\u{646}\u{62F}\u{645}\u{627} \u{644}\u{627} \u{64A}\u{643}\u{648}\u{646} \u{644}\u{62F}\u{64A}\u{643} \u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{649} \u{62C}\u{647}\u{627}\u{632} \u{623}\u{648} \u{623}\u{62C}\u{647}\u{632}\u{629} \u{627}\u{644}\u{645}\u{635}\u{627}\u{62F}\u{642}\u{629} \u{627}\u{644}\u{62E}\u{627}\u{635} \u{628}\u{643}.`,
    de: `Regeneriere den Code, mit dem du dich anmelden kannst, wenn du keinen Zugriff auf dein Authenticator-Ger\xe4t hast.`,
    es: `Regenera el c\xf3digo que puedes usar para iniciar sesi\xf3n cuando no tengas acceso a tu(s) dispositivo(s) autenticador(es).`,
    fa: `\u{6A9}\u{62F}\u{6CC} \u{631}\u{627} \u{6A9}\u{647} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{6CC}\u{62F} \u{647}\u{646}\u{6AF}\u{627}\u{645} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{628}\u{647} \u{62F}\u{633}\u{62A}\u{6AF}\u{627}\u{647}(\u{647}\u{627}\u{6CC}) \u{627}\u{62D}\u{631}\u{627}\u{632} \u{647}\u{648}\u{6CC}\u{62A} \u{62E}\u{648}\u{62F} \u{628}\u{631}\u{627}\u{6CC} \u{648}\u{631}\u{648}\u{62F} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}\u{60C} \u{62F}\u{648}\u{628}\u{627}\u{631}\u{647} \u{62A}\u{648}\u{644}\u{6CC}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `I-regenerate ang code na maaari mong gamitin upang mag-login kapag wala kang access sa iyong (mga) authenticator device.`,
    fr: `R\xe9g\xe9n\xe9rez le code que vous pouvez utiliser pour vous connecter lorsque vous n\u{2019}avez pas acc\xe8s \xe0 votre ou vos appareils authentificateurs.`,
    hi: `\u{909}\u{938} \u{915}\u{94B}\u{921} \u{915}\u{94B} \u{92A}\u{941}\u{928}: \u{91C}\u{928}\u{930}\u{947}\u{91F} \u{915}\u{930}\u{947}\u{902} \u{91C}\u{93F}\u{938}\u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{906}\u{92A} \u{932}\u{949}\u{917}\u{93F}\u{928} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{930} \u{938}\u{915}\u{924}\u{947} \u{939}\u{948}\u{902} \u{91C}\u{92C} \u{906}\u{92A}\u{915}\u{947} \u{92A}\u{93E}\u{938} \u{905}\u{92A}\u{928}\u{947} \u{92A}\u{94D}\u{930}\u{92E}\u{93E}\u{923}\u{915} \u{921}\u{93F}\u{935}\u{93E}\u{907}\u{938} \u{924}\u{915} \u{92A}\u{939}\u{941}\u{902}\u{91A} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{964}`,
    ht: `Rejenere k\xf2d ou ka itilize pou konekte l\xe8 ou pa gen aks\xe8 a apar\xe8y (yo) otantifikasyon ou a.`,
    it: `Rigenera il codice che puoi usare per accedere quando non hai accesso ai tuoi dispositivi autenticatori.`,
    ja: `\u{8A8D}\u{8A3C}\u{30C7}\u{30D0}\u{30A4}\u{30B9}\u{306B}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3067}\u{304D}\u{306A}\u{3044}\u{3068}\u{304D}\u{306B}\u{30ED}\u{30B0}\u{30A4}\u{30F3}\u{3067}\u{304D}\u{308B}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{518D}\u{751F}\u{6210}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C778}\u{C99D} \u{C7A5}\u{CE58}\u{C5D0} \u{C811}\u{ADFC}\u{D560} \u{C218} \u{C5C6}\u{C744} \u{B54C} \u{B85C}\u{ADF8}\u{C778}\u{D560} \u{C218} \u{C788}\u{B294} \u{CF54}\u{B4DC}\u{B97C} \u{B2E4}\u{C2DC} \u{C0DD}\u{C131}\u{D558}\u{C138}\u{C694}.`,
    mww: `Rov tsim cov lej uas koj tuaj yeem siv los nkag mus thaum koj tsis muaj kev nkag mus rau koj lub cuab yeej (cov) authenticator.`,
    ps: `\u{647}\u{63A}\u{647} \u{6A9}\u{648}\u{689} \u{628}\u{6CC}\u{627} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{626} \u{686}\u{6D0} \u{6A9}\u{644}\u{647} \u{62A}\u{627}\u{633}\u{648} \u{62E}\u{67E}\u{644} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{648}\u{633}\u{627}\u{6CC}\u{644}\u{648} \u{62A}\u{647} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{646}\u{647} \u{644}\u{631}\u{626}\u{60C} \u{62F} \u{646}\u{646}\u{648}\u{62A}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{6CC}\u{6D0} \u{6A9}\u{627}\u{631}\u{648}\u{644}\u{6CC} \u{634}\u{626}.`,
    pt: `Regenere o c\xf3digo que voc\xea pode usar para fazer login quando n\xe3o tiver acesso a(s) seu(s) dispositivo(s) autenticador(es).`,
    'pt-pt': `Regenere o c\xf3digo que pode usar para iniciar sess\xe3o quando n\xe3o tiver acesso ao(s) seu(s) dispositivo(s) autenticador(es).`,
    ru: `\u{41F}\u{435}\u{440}\u{435}\u{433}\u{435}\u{43D}\u{435}\u{440}\u{438}\u{440}\u{443}\u{439}\u{442}\u{435} \u{43A}\u{43E}\u{434}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{439} \u{43C}\u{43E}\u{436}\u{43D}\u{43E} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{434}\u{43B}\u{44F} \u{432}\u{445}\u{43E}\u{434}\u{430}, \u{435}\u{441}\u{43B}\u{438} \u{443} \u{432}\u{430}\u{441} \u{43D}\u{435}\u{442} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{430} \u{43A} \u{443}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{441}\u{442}\u{432}\u{443}-\u{430}\u{443}\u{442}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440}\u{443}.`,
    sm: `Toe fa'afouina le code e mafai ona e fa'aaogaina e login ai pe a leai sau avanoa i lau masini fa'amaonia.`,
    so: `Dib u soo celi koodhka aad u isticmaali karto inaad gasho marka aadan heli karin qalabka authenticator-kaaga.`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E43}\u{E2B}\u{E21}\u{E48}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E2A}\u{E39}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E1A}\u{E40}\u{E21}\u{E37}\u{E48}\u{E2D}\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E2D}\u{E38}\u{E1B}\u{E01}\u{E23}\u{E13}\u{E4C}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E15}\u{E31}\u{E27}\u{E15}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{648}\u{6C1} \u{6A9}\u{648}\u{688} \u{62F}\u{648}\u{628}\u{627}\u{631}\u{6C1} \u{62C}\u{646}\u{631}\u{6CC}\u{679} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{62C}\u{633}\u{6D2} \u{622}\u{67E} \u{644}\u{627}\u{6AF} \u{627}\u{646} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631} \u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{62C}\u{628} \u{622}\u{67E} \u{6A9}\u{6D2} \u{67E}\u{627}\u{633} \u{627}\u{67E}\u{646}\u{6D2} \u{622}\u{62A}\u{6BE}\u{646}\u{679}\u{6CC}\u{6A9}\u{6CC}\u{679}\u{631} \u{688}\u{6CC}\u{648}\u{627}\u{626}\u{633}\u{632} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{646}\u{6C1} \u{6C1}\u{648}\u{6D4}`,
    vi: `T\u{1EA1}o l\u{1EA1}i m\xe3 b\u{1EA1}n c\xf3 th\u{1EC3} s\u{1EED} d\u{1EE5}ng \u{111}\u{1EC3} \u{111}\u{103}ng nh\u{1EAD}p khi b\u{1EA1}n kh\xf4ng c\xf3 quy\u{1EC1}n truy c\u{1EAD}p v\xe0o (c\xe1c) thi\u{1EBF}t b\u{1ECB} x\xe1c th\u{1EF1}c c\u{1EE7}a m\xecnh.`,
    'zh-hans': `\u{91CD}\u{65B0}\u{751F}\u{6210}\u{4F60}\u{65E0}\u{6CD5}\u{8BBF}\u{95EE}\u{8BA4}\u{8BC1}\u{5668}\u{8BBE}\u{5907}\u{65F6}\u{7528}\u{6765}\u{767B}\u{5F55}\u{7684}\u{4EE3}\u{7801}\u{3002}`,
    'zh-hant': `\u{91CD}\u{65B0}\u{7522}\u{751F}\u{4F60}\u{7121}\u{6CD5}\u{4F7F}\u{7528}\u{9A57}\u{8B49}\u{5668}\u{88DD}\u{7F6E}\u{6642}\u{53EF}\u{7528}\u{4F86}\u{767B}\u{5165}\u{7684}\u{7A0B}\u{5F0F}\u{78BC}\u{3002}`,
    en: `Regenerate the code you can use to login when you do not have access to your authenticator device(s).`
};
const $b11db1b62d4a8f76$export$d48f93ace41e530 = {
    ar: `\u{627}\u{644}\u{645}\u{646}\u{637}\u{642}\u{629}`,
    de: `Region`,
    es: `Regi\xf3n`,
    fa: `\u{645}\u{646}\u{637}\u{642}\u{647}`,
    fil: `Rehiyon`,
    fr: `R\xe9gion`,
    hi: `\u{915}\u{94D}\u{937}\u{947}\u{924}\u{94D}\u{930}`,
    ht: `Rejyon an`,
    it: `Regione`,
    ja: `\u{5730}\u{57DF}`,
    ko: `\u{C9C0}\u{C5ED}`,
    mww: `Cheeb Tsam`,
    ps: `\u{633}\u{6CC}\u{645}\u{647}`,
    pt: `Regi\xe3o`,
    'pt-pt': `Regi\xe3o`,
    ru: `\u{420}\u{435}\u{433}\u{438}\u{43E}\u{43D}`,
    sm: `Itulagi`,
    so: `Gobol`,
    th: `\u{E20}\u{E39}\u{E21}\u{E34}\u{E20}\u{E32}\u{E04}`,
    ur: `\u{639}\u{644}\u{627}\u{642}\u{6C1}`,
    vi: `Khu v\u{1EF1}c`,
    'zh-hans': `\u{5730}\u{533A}`,
    'zh-hant': `\u{5340}\u{57DF}`,
    en: `Region`
};
const $b11db1b62d4a8f76$export$a92aa0df32e7f5a3 = {
    ar: `\u{625}\u{63A}\u{644}\u{627}\u{642} \u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644}`,
    de: `Die Anmeldung schlie\xdft`,
    es: `Cierre de inscripciones`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{628}\u{633}\u{62A}\u{647} \u{645}\u{6CC} \u{634}\u{648}\u{62F}`,
    fil: `Nagsasara ang pagpaparehistro`,
    fr: `Cl\xf4ture des inscriptions`,
    hi: `\u{92A}\u{902}\u{91C}\u{940}\u{915}\u{930}\u{923} \u{92C}\u{902}\u{926} \u{939}\u{94B} \u{91C}\u{93E}\u{924}\u{93E} \u{939}\u{948}`,
    ht: `Enskripsyon an f\xe8men`,
    it: `Chiusura delle iscrizioni`,
    ja: `\u{767B}\u{9332}\u{7DE0}\u{5207}`,
    ko: `\u{B4F1}\u{B85D} \u{B9C8}\u{AC10}`,
    mww: `Kev sau npe kaw`,
    ps: `\u{62B}\u{628}\u{62A} \u{648}\u{62A}\u{693}\u{644} \u{634}\u{648}`,
    pt: `Encerramento das inscri\xe7\xf5es`,
    'pt-pt': `Encerramento do registo`,
    ru: `\u{420}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{437}\u{430}\u{43A}\u{440}\u{44B}\u{432}\u{430}\u{435}\u{442}\u{441}\u{44F}`,
    sm: `Tapunia le lesitala`,
    so: `Diiwaangelintu way xirtay`,
    th: `\u{E1B}\u{E34}\u{E14}\u{E23}\u{E31}\u{E1A}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}`,
    ur: `\u{631}\u{62C}\u{633}\u{679}\u{631}\u{6CC}\u{634}\u{646} \u{628}\u{646}\u{62F} \u{6C1}\u{648} \u{6AF}\u{626}\u{6CC}`,
    vi: `\u{110}\u{103}ng k\xfd \u{111}\xf3ng`,
    'zh-hans': `\u{62A5}\u{540D}\u{622A}\u{6B62}`,
    'zh-hant': `\u{5831}\u{540D}\u{622A}\u{6B62}`,
    en: `Registration closes`
};
const $b11db1b62d4a8f76$export$262df8563ddd9323 = {
    ar: `\u{645}\u{646}\u{62A}\u{638}\u{645}`,
    de: `Regul\xe4r`,
    es: `Regular`,
    fa: `\u{645}\u{646}\u{638}\u{645}`,
    fil: `Regular`,
    fr: `R\xe9gulier`,
    hi: `\u{928}\u{93F}\u{92F}\u{92E}\u{93F}\u{924} \u{938}\u{948}\u{928}\u{93F}\u{915}`,
    ht: `Regilye`,
    it: `Regolare`,
    ja: `\u{30EC}\u{30AE}\u{30E5}\u{30E9}\u{30FC}`,
    ko: `\u{C815}\u{ADDC}`,
    mww: `tsis tu ncua`,
    ps: `\u{645}\u{646}\u{638}\u{645}`,
    pt: `Regular`,
    'pt-pt': `Regular`,
    ru: `\u{420}\u{435}\u{433}\u{443}\u{43B}\u{44F}\u{440}\u{43D}\u{44B}\u{435}`,
    sm: `Masani`,
    so: `Joogto`,
    th: `\u{E1B}\u{E01}\u{E15}\u{E34}`,
    ur: `\u{631}\u{6CC}\u{6AF}\u{648}\u{644}\u{631}`,
    vi: `Th\u{1B0}\u{1EDD}ng xuy\xean`,
    'zh-hans': `\u{5E38}\u{89C4}`,
    'zh-hant': `\u{5E38}\u{898F}`,
    en: `Regular`
};
const $b11db1b62d4a8f76$export$23f7b14637c3f133 = {
    ar: `\u{630}\u{627}\u{62A} \u{635}\u{644}\u{629}`,
    de: `Verwandte Themen`,
    es: `Relacionado`,
    fa: `\u{645}\u{631}\u{62A}\u{628}\u{637}`,
    fil: `Kaugnay`,
    fr: `Connexe`,
    hi: `\u{938}\u{92E}\u{94D}\u{92C}\u{902}\u{927}\u{93F}\u{924}`,
    ht: `Ki gen rap\xf2 ak`,
    it: `Correlati`,
    ja: `\u{95A2}\u{9023}`,
    ko: `\u{AD00}\u{B828}`,
    mww: `Muaj feem xyuam`,
    ps: `\u{627}\u{693}\u{648}\u{646}\u{62F}`,
    pt: `Relacionado`,
    'pt-pt': `Relacionado`,
    ru: `\u{421}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{43E}\u{435}`,
    sm: `Feso'ota'iga`,
    so: `La xiriira`,
    th: `\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1}`,
    vi: `S\u{1EA3}n ph\u{1EA9}m li\xean quan`,
    'zh-hans': `\u{76F8}\u{5173}`,
    'zh-hant': `\u{76F8}\u{95DC}`,
    en: `Related`
};
const $b11db1b62d4a8f76$export$ef35e69eecb4ff92 = {
    ar: `\u{645}\u{644}\u{627}\u{62D}\u{638}\u{627}\u{62A} \u{627}\u{644}\u{625}\u{635}\u{62F}\u{627}\u{631}`,
    de: `Ver\xf6ffentlichungsnotizen`,
    es: `Notas de lanzamiento`,
    fa: `\u{6CC}\u{627}\u{62F}\u{62F}\u{627}\u{634}\u{62A} \u{647}\u{627}\u{6CC} \u{627}\u{646}\u{62A}\u{634}\u{627}\u{631}`,
    fil: `Mga tala ng paglabas`,
    fr: `Notes de sortie`,
    hi: `\u{930}\u{93F}\u{932}\u{940}\u{91C} \u{928}\u{94B}\u{91F}\u{94D}\u{938}`,
    ht: `n\xf2t lage`,
    it: `Note di pubblicazione`,
    ja: `\u{30EA}\u{30EA}\u{30FC}\u{30B9}\u{30CE}\u{30FC}\u{30C8}`,
    ko: `\u{CD9C}\u{C2DC} \u{B178}\u{D2B8}`,
    mww: `Cov ntawv tso tawm`,
    ps: `\u{62F} \u{62E}\u{67E}\u{631}\u{648}\u{644}\u{648} \u{6CC}\u{627}\u{62F}\u{69A}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Notas de lan\xe7amento`,
    'pt-pt': `Notas de lan\xe7amento`,
    ru: `\u{41F}\u{440}\u{438}\u{43C}\u{435}\u{447}\u{430}\u{43D}\u{438}\u{44F} \u{43A} \u{440}\u{435}\u{43B}\u{438}\u{437}\u{443}`,
    sm: `Fa'amatalaga fa'asalalau`,
    so: `Qoraallo sii deynta`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E1B}\u{E23}\u{E30}\u{E08}\u{E4D}\u{E32}\u{E23}\u{E38}\u{E48}\u{E19}`,
    ur: `\u{631}\u{6CC}\u{644}\u{6CC}\u{632} \u{646}\u{648}\u{679}\u{633}`,
    vi: `Ghi ch\xfa ph\xe1t h\xe0nh`,
    'zh-hans': `\u{53D1}\u{884C}\u{8BF4}\u{660E}`,
    'zh-hant': `\u{767C}\u{884C}\u{8AAA}\u{660E}`,
    en: `Release notes`
};
const $b11db1b62d4a8f76$export$750b6bccddd2f3b5 = {
    ar: `\u{630}\u{643}\u{631}`,
    de: `Erinnere dich`,
    es: `Recuerda`,
    fa: `\u{6CC}\u{627}\u{62F}\u{622}\u{648}\u{631}\u{6CC} \u{6A9}\u{646}`,
    fil: `Paalalahanan`,
    fr: `Rappeler`,
    hi: `\u{92F}\u{93E}\u{926} \u{915}\u{930}\u{93E}\u{928}\u{93E}`,
    ht: `Sonje`,
    it: `Ricorda`,
    ja: `\u{30EA}\u{30DE}\u{30A4}\u{30F3}\u{30C9}`,
    ko: `\u{C0C1}\u{AE30}\u{C2DC}\u{CF1C} \u{C8FC}\u{C138}\u{C694}`,
    mww: `nco ntsoov`,
    ps: `\u{6CC}\u{627}\u{62F}\u{648}\u{646}\u{647} \u{648}\u{6A9}\u{693}\u{647}`,
    pt: `Lembre`,
    'pt-pt': `Lembrar`,
    ru: `\u{41D}\u{430}\u{43F}\u{43E}\u{43C}\u{43D}\u{438}`,
    sm: `Faamanatu`,
    so: `Xasuusi`,
    th: `\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}`,
    ur: `\u{6CC}\u{627}\u{62F} \u{62F}\u{644}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `Nh\u{1EAF}c nh\u{1EDF}`,
    'zh-hans': `\u{63D0}\u{9192}\u{4E00}\u{4E0B}`,
    'zh-hant': `\u{63D0}\u{9192}\u{4E00}\u{4E0B}`,
    en: `Remind`
};
const $b11db1b62d4a8f76$export$6e3e4890c7ca1b12 = {
    ar: `\u{62A}\u{62D}\u{648}\u{64A}\u{644}\u{627}\u{62A}`,
    de: `\xdcberweisungen`,
    es: `Remesas`,
    fa: `\u{62D}\u{648}\u{627}\u{644}\u{647} \u{647}\u{627}`,
    fil: `Mga Remittances`,
    fr: `Envois de fonds`,
    hi: `\u{92A}\u{94D}\u{930}\u{947}\u{937}\u{923}`,
    ht: `Ref\xe8`,
    it: `Rimesse`,
    ja: `\u{9001}\u{91D1}`,
    ko: `\u{C1A1}\u{AE08}`,
    mww: `Cov nyiaj xa tawm`,
    ps: `\u{644}\u{6CC}\u{696}\u{644} \u{634}\u{648}\u{6CC} \u{67E}\u{6CC}\u{633}\u{6D0}`,
    pt: `Remessas`,
    'pt-pt': `Remessas`,
    ru: `\u{414}\u{435}\u{43D}\u{435}\u{436}\u{43D}\u{44B}\u{435} \u{43F}\u{435}\u{440}\u{435}\u{432}\u{43E}\u{434}\u{44B}`,
    sm: `Tupe Totogi`,
    so: `Diraacaada`,
    th: `\u{E01}\u{E32}\u{E23}\u{E42}\u{E2D}\u{E19}\u{E40}\u{E07}\u{E34}\u{E19}`,
    ur: `\u{62A}\u{631}\u{633}\u{6CC}\u{644}\u{627}\u{62A} \u{632}\u{631}`,
    vi: `Ki\u{1EC1}u h\u{1ED1}i`,
    'zh-hans': `\u{6C47}\u{6B3E}`,
    'zh-hant': `\u{532F}\u{6B3E}`,
    en: `Remittances`
};
const $b11db1b62d4a8f76$export$5b0a88ee249e8720 = {
    ar: `\u{625}\u{632}\u{627}\u{644}\u{629}`,
    de: `Entfernen`,
    es: `Eliminar`,
    fa: `\u{62D}\u{630}\u{641}`,
    fil: `Alisin`,
    fr: `Retirer`,
    hi: `\u{939}\u{91F}\u{93E}\u{928}\u{93E}`,
    ht: `Retire`,
    it: `Rimuovere`,
    ja: `\u{524A}\u{9664}`,
    ko: `\u{C81C}\u{AC70}`,
    mww: `tshem tawm`,
    ps: `\u{644}\u{631}\u{6D0} \u{6A9}\u{648}\u{644}`,
    pt: `Remover`,
    'pt-pt': `Remover`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}`,
    sm: `Aveese`,
    so: `Ka saar`,
    th: `\u{E25}\u{E1A}`,
    ur: `\u{6C1}\u{679}\u{627} \u{62F}\u{6CC}\u{627} \u{62C}\u{627}\u{626}\u{6D2}`,
    vi: `Lo\u{1EA1}i b\u{1ECF}`,
    'zh-hans': `\u{5220}\u{9664}`,
    'zh-hant': `\u{79FB}\u{9664}`,
    en: `Remove`
};
const $b11db1b62d4a8f76$export$ec21648e7732b648 = {
    ar: `\u{625}\u{632}\u{627}\u{644}\u{629} \u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Adresse entfernen`,
    es: `Eliminar direcci\xf3n`,
    fa: `\u{62D}\u{630}\u{641} \u{622}\u{62F}\u{631}\u{633}`,
    fil: `Tanggalin ang address`,
    fr: `Supprimer l\u{2019}adresse`,
    hi: `\u{92A}\u{924}\u{93E} \u{939}\u{91F}\u{93E}\u{928}\u{93E}`,
    ht: `Retire adr\xe8s`,
    it: `Rimuovere indirizzo`,
    ja: `\u{30A2}\u{30C9}\u{30EC}\u{30B9}\u{3092}\u{524A}\u{9664}`,
    ko: `\u{C8FC}\u{C18C} \u{C81C}\u{AC70}`,
    mww: `Tshem tawm qhov chaw nyob`,
    ps: `\u{67E}\u{62A}\u{647} \u{644}\u{631}\u{6D0} \u{6A9}\u{693}\u{647}`,
    pt: `Remover endere\xe7o`,
    'pt-pt': `Remover endere\xe7o`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{430}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Aveese le tuatusi`,
    so: `Ka saar cinwaanka`,
    th: `\u{E25}\u{E1A}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{67E}\u{62A}\u{6C1} \u{6C1}\u{679}\u{627} \u{62F}\u{6CC}\u{6BA}`,
    vi: `X\xf3a \u{111}\u{1ECB}a ch\u{1EC9}`,
    'zh-hans': `\u{5220}\u{9664}\u{5730}\u{5740}`,
    'zh-hant': `\u{79FB}\u{9664}\u{5730}\u{5740}`,
    en: `Remove address`
};
const $b11db1b62d4a8f76$export$a6918c6011afcb74 = {
    ar: (title)=>`\u{647}\u{644} \u{623}\u{646}\u{62A} \u{645}\u{62A}\u{623}\u{643}\u{62F} \u{623}\u{646}\u{643} \u{62A}\u{631}\u{64A}\u{62F} \u{625}\u{632}\u{627}\u{644}\u{629} ${title}\u{61F}`,
    de: (title)=>`Bist du sicher, dass du ${title} entfernen m\xf6chtest?`,
    es: (title)=>`\xbfEst\xe1s seguro de que quieres eliminar ${title}?`,
    fa: (title)=>`\u{645}\u{637}\u{645}\u{626}\u{646}\u{6CC} \u{645}\u{6CC} \u{62E}\u{648}\u{627}\u{647}\u{6CC} ${title} \u{631}\u{627} \u{62D}\u{630}\u{641} \u{6A9}\u{646}\u{6CC}\u{61F}`,
    fil: (title)=>`Sigurado ka bang nais mong tanggalin ang ${title}?`,
    fr: (title)=>`\xcates-vous s\xfbr de vouloir supprimer ${title} ?`,
    hi: (title)=>`\u{915}\u{94D}\u{92F}\u{93E} \u{906}\u{92A} \u{935}\u{93E}\u{915}\u{908} ${title} \u{915}\u{94B} \u{939}\u{91F}\u{93E}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{924}\u{947} \u{939}\u{948}\u{902}?`,
    ht: (title)=>`\xc8ske ou asire w ke ou vle retire ${title}?`,
    it: (title)=>`Sei sicuro di voler rimuovere ${title}?`,
    ja: (title)=>`\u{672C}\u{5F53}\u{306B} ${title}\u{3092}\u{524A}\u{9664}\u{3057}\u{305F}\u{3044}\u{3067}\u{3059}\u{304B}?`,
    ko: (title)=>`\u{C815}\u{B9D0} ${title} \u{C81C}\u{AC70}\u{D558}\u{ACE0} \u{C2F6}\u{C73C}\u{C2E0}\u{AC00}\u{C694}?`,
    mww: (title)=>`Koj puas paub tseeb tias koj xav tshem tawm ${title}?`,
    ps: (title)=>`\u{62A}\u{647} \u{689}\u{627}\u{689}\u{647} \u{6CC}\u{6D0} \u{686}\u{6D0} ${title} \u{644}\u{631}\u{6D0} \u{6A9}\u{693}\u{6D0}\u{61F}`,
    pt: (title)=>`Voc\xea tem certeza de que quer remover ${title}?`,
    'pt-pt': (title)=>`Tem a certeza de que quer remover ${title}?`,
    ru: (title)=>`\u{412}\u{44B} \u{443}\u{432}\u{435}\u{440}\u{435}\u{43D}\u{44B}, \u{447}\u{442}\u{43E} \u{445}\u{43E}\u{442}\u{438}\u{442}\u{435} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} ${title}?`,
    sm: (title)=>`E te mautinoa e te mana'o e aveese le ${title}?`,
    so: (title)=>`Ma hubtaa inaad rabto inaad ka saarto ${title}?`,
    th: (title)=>`\u{E04}\u{E38}\u{E13}\u{E41}\u{E19}\u{E48}\u{E43}\u{E08}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E44}\u{E21}\u{E48}\u{E27}\u{E48}\u{E32}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E25}\u{E1A}${title}`,
    ur: (title)=>`\u{6A9}\u{6CC}\u{627} \u{622}\u{67E} \u{648}\u{627}\u{642}\u{639}\u{6CC} ${title} \u{6A9}\u{648} \u{6C1}\u{679}\u{627}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{61F}`,
    vi: (title)=>`B\u{1EA1}n c\xf3 ch\u{1EAF}c ch\u{1EAF}n mu\u{1ED1}n x\xf3a ${title} kh\xf4ng?`,
    'zh-hans': (title)=>`\u{4F60}\u{786E}\u{5B9A}\u{8981}\u{79FB}\u{9664} ${title}\u{5417}\u{FF1F}`,
    'zh-hant': (title)=>`\u{4F60}\u{78BA}\u{5B9A}\u{8981}\u{79FB}\u{9664} ${title}\u{55CE}\u{FF1F}`,
    en: (title)=>`Are you sure you want to remove ${title}?`
};
const $b11db1b62d4a8f76$export$6ffe635ef5e99d9d = {
    ar: `\u{625}\u{632}\u{627}\u{644}\u{629} \u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644}`,
    de: `Kontakt entfernen`,
    es: `Eliminar el contacto`,
    fa: `\u{642}\u{637}\u{639} \u{62A}\u{645}\u{627}\u{633}`,
    fil: `Tanggalin ang contact`,
    fr: `Coupez le contact`,
    hi: `\u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{939}\u{91F}\u{93E}\u{90F}\u{902}`,
    ht: `Retire kontak`,
    it: `Rimuovere il contatto`,
    ja: `\u{9023}\u{7D61}\u{3092}\u{65AD}\u{3064}`,
    ko: `\u{C5F0}\u{B77D}\u{C744} \u{B04A}\u{C73C}\u{C138}\u{C694}`,
    mww: `Tshem tawm kev sib cuag`,
    ps: `\u{62A}\u{645}\u{627}\u{633} \u{644}\u{631}\u{6D0} \u{6A9}\u{693}\u{626}`,
    pt: `Remover contato`,
    'pt-pt': `Remover contacto`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{43A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}`,
    sm: `Aveese le fesootaiga`,
    so: `Ka saar xiriirka`,
    th: `\u{E25}\u{E1A}\u{E1C}\u{E39}\u{E49}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{631}\u{627}\u{628}\u{637}\u{6C1} \u{6C1}\u{679}\u{627} \u{62F}\u{6CC}\u{6BA}`,
    vi: `X\xf3a li\xean h\u{1EC7}`,
    'zh-hans': `\u{5207}\u{65AD}\u{8054}\u{7CFB}`,
    'zh-hant': `\u{65B7}\u{958B}\u{806F}\u{7D61}`,
    en: `Remove contact`
};
const $b11db1b62d4a8f76$export$70463e241666d488 = {
    ar: `\u{625}\u{632}\u{627}\u{644}\u{629} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}`,
    de: `E-Mail entfernen`,
    es: `Eliminar el correo electr\xf3nico`,
    fa: `\u{62D}\u{630}\u{641} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}`,
    fil: `Email Address *`,
    fr: `Supprimer l\u{2019}email`,
    hi: `\u{908}\u{92E}\u{947}\u{932} \u{939}\u{91F}\u{93E}\u{90F}\u{902}`,
    ht: `Retire im\xe8l`,
    it: `Rimuovi l'email`,
    ja: `\u{30E1}\u{30FC}\u{30EB}\u{3092}\u{524A}\u{9664}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{C774}\u{BA54}\u{C77C} \u{C0AD}\u{C81C}`,
    mww: `Tshem tawm email`,
    ps: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{644}\u{631}\u{6D0} \u{6A9}\u{648}\u{644}`,
    pt: `Remover e-mail`,
    'pt-pt': `Remover email`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{443}\u{44E} \u{43F}\u{43E}\u{447}\u{442}\u{443}`,
    sm: `Aveese imeli`,
    so: `Ka saar email-ka`,
    th: `\u{E25}\u{E1A}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{6C1}\u{679}\u{627} \u{62F}\u{6CC}\u{6BA}`,
    vi: `X\xf3a email`,
    'zh-hans': `\u{5220}\u{9664}\u{90AE}\u{7BB1}`,
    'zh-hant': `\u{79FB}\u{9664}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}`,
    en: `Remove email`
};
const $b11db1b62d4a8f76$export$b1dbe6dbf0b8b848 = {
    ar: `\u{625}\u{632}\u{627}\u{644}\u{629} \u{627}\u{644}\u{647}\u{627}\u{62A}\u{641}`,
    de: `Nimm das Handy weg`,
    es: `Quitar tel\xe9fono`,
    fa: `\u{6AF}\u{648}\u{634}\u{6CC} \u{631}\u{627} \u{62D}\u{630}\u{641} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Tanggalin ang telepono`,
    fr: `Supprimer le t\xe9l\xe9phone`,
    hi: `\u{92B}\u{93C}\u{94B}\u{928} \u{939}\u{91F}\u{93E}\u{90F}\u{901}`,
    ht: `Retire telef\xf2n`,
    it: `Rimuovi il telefono`,
    ja: `\u{96FB}\u{8A71}\u{3092}\u{53D6}\u{308A}\u{9664}\u{3051}`,
    ko: `\u{D734}\u{B300}\u{D3F0} \u{C81C}\u{AC70}`,
    mww: `Tshem tawm xov tooj`,
    ps: `\u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646} \u{644}\u{631}\u{6D0} \u{6A9}\u{693}\u{647}`,
    pt: `Remover o telefone`,
    'pt-pt': `Remover o telefone`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}`,
    sm: `Aveese le telefoni`,
    so: `Ka saar telefoonka`,
    th: `\u{E25}\u{E1A}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}`,
    ur: `\u{641}\u{648}\u{646} \u{6C1}\u{679}\u{627} \u{62F}\u{6CC}\u{6BA}`,
    vi: `X\xf3a \u{111}i\u{1EC7}n tho\u{1EA1}i`,
    'zh-hans': `\u{79FB}\u{9664}\u{624B}\u{673A}`,
    'zh-hant': `\u{79FB}\u{9664}\u{624B}\u{6A5F}`,
    en: `Remove phone`
};
const $b11db1b62d4a8f76$export$70f2a6d0b7f693e7 = {
    ar: `\u{625}\u{632}\u{627}\u{644}\u{629} \u{627}\u{644}\u{645}\u{648}\u{642}\u{639}`,
    de: `Entfernen der Website`,
    es: `Eliminar el sitio`,
    fa: `\u{62D}\u{630}\u{641} \u{633}\u{627}\u{6CC}\u{62A}`,
    fil: `Tanggalin ang site`,
    fr: `Supprimer le site`,
    hi: `\u{938}\u{93E}\u{907}\u{91F} \u{939}\u{91F}\u{93E}\u{928}\u{93E}`,
    ht: `Retire sit`,
    it: `Rimuovere il sito`,
    ja: `\u{30B5}\u{30A4}\u{30C8}\u{3092}\u{524A}\u{9664}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{C0AC}\u{C774}\u{D2B8} \u{C0AD}\u{C81C}`,
    mww: `Tshem tawm qhov chaw`,
    ps: `\u{633}\u{627}\u{6CC}\u{67C} \u{644}\u{631}\u{6D0} \u{6A9}\u{648}\u{644}`,
    pt: `Remover o site`,
    'pt-pt': `Remover o site`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{441}\u{430}\u{439}\u{442}`,
    sm: `Aveese le saite`,
    so: `Ka saar goobta`,
    th: `\u{E25}\u{E1A}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}`,
    ur: `\u{633}\u{627}\u{626}\u{679} \u{6C1}\u{679}\u{627} \u{62F}\u{6CC}\u{6BA}`,
    vi: `X\xf3a trang web`,
    'zh-hans': `\u{5220}\u{9664}\u{7F51}\u{7AD9}`,
    'zh-hant': `\u{79FB}\u{9664}\u{7DB2}\u{7AD9}`,
    en: `Remove site`
};
const $b11db1b62d4a8f76$export$684321e2b70e9dca = {
    ar: `\u{627}\u{644}\u{62A}\u{642}\u{631}\u{64A}\u{631}`,
    de: `Bericht`,
    es: `Informe`,
    fa: `\u{6AF}\u{632}\u{627}\u{631}\u{634}`,
    fil: `Ulat`,
    fr: `Rapport`,
    hi: `\u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F}`,
    ht: `Rap\xf2`,
    it: `Rapporto`,
    ja: `\u{30EC}\u{30DD}\u{30FC}\u{30C8}`,
    ko: `\u{B9AC}\u{D3EC}\u{D2B8}`,
    mww: `Daim ntawv qhia`,
    ps: `\u{631}\u{627}\u{67E}\u{648}\u{631}`,
    pt: `Relat\xf3rio`,
    'pt-pt': `Relat\xf3rio`,
    ru: `\u{41E}\u{442}\u{447}\u{451}\u{442}`,
    sm: `Lipoti`,
    so: `Warbixin`,
    th: `\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{631}\u{67E}\u{648}\u{631}\u{679}`,
    vi: `B\xe1o c\xe1o`,
    'zh-hans': `\u{62A5}\u{9053}`,
    'zh-hant': `\u{8CFD}\u{4E8B}\u{5831}\u{5C0E}`,
    en: `Report`
};
const $b11db1b62d4a8f76$export$9fbf3f92c2783805 = {
    ar: `\u{631}\u{648}\u{627}\u{628}\u{637} \u{627}\u{644}\u{62A}\u{642}\u{631}\u{64A}\u{631}`,
    de: `Berichtslinks`,
    es: `Enlaces de reporte`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9} \u{647}\u{627}\u{6CC} \u{6AF}\u{632}\u{627}\u{631}\u{634}`,
    fil: `Email Address *`,
    fr: `Liens de rapport`,
    hi: `\u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F} \u{932}\u{93F}\u{902}\u{915}`,
    ht: `Rap\xf2 lyen`,
    it: `Link dei rapporti`,
    ja: `\u{30EC}\u{30DD}\u{30FC}\u{30C8}\u{30EA}\u{30F3}\u{30AF}`,
    ko: `\u{BCF4}\u{ACE0} \u{B9C1}\u{D06C}`,
    mww: `Daim ntawv qhia txog kev sib txuas`,
    ps: `\u{62F} \u{631}\u{627}\u{67E}\u{648}\u{631} \u{644}\u{6CC}\u{646}\u{6A9}\u{648}\u{646}\u{647}`,
    pt: `Links de reportagem`,
    'pt-pt': `Links para reportar`,
    ru: `\u{421}\u{441}\u{44B}\u{43B}\u{43A}\u{438} \u{43D}\u{430} \u{43E}\u{442}\u{447}\u{435}\u{442}\u{44B}`,
    sm: `Lipoti feso'ota'iga`,
    so: `Xiriiriyeyaasha warbixinta`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{631}\u{67E}\u{648}\u{631}\u{679} \u{6A9}\u{6D2} \u{631}\u{648}\u{627}\u{628}\u{637}`,
    vi: `\u{110}\u{1B0}\u{1EDD}ng li\xean k\u{1EBF}t b\xe1o c\xe1o`,
    'zh-hans': `\u{62A5}\u{544A}\u{94FE}\u{63A5}`,
    'zh-hant': `\u{5831}\u{544A}\u{9023}\u{7D50}`,
    en: `Report links`
};
const $b11db1b62d4a8f76$export$e57713d0322a6cbc = {
    ar: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} غير قابل للتعديل لأن دورك في <strong>${organization}</strong> هو <strong>${role}</strong>`,
    de: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} ist nicht bearbeitbar, weil deine Rolle in <strong>${organization}</strong> <strong>${role}</strong> ist`,
    es: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`El ${entity} no es editable porque tu rol en <strong>${organization}</strong> es <strong>${role}</strong>`,
    fa: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} قابل ویرایش نیست چون نقش شما در <strong>${organization}</strong> <strong>${role}</strong> است`,
    fil: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`Hindi mai-edit ang ${entity} dahil ang papel mo sa <strong>${organization}</strong> ay <strong>${role}</strong>`,
    fr: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} n’est pas modifiable car votre rôle dans <strong>${organization}</strong> est <strong>${role}</strong>`,
    hi: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} संपादन योग्य नहीं है क्योंकि <strong>${organization}</strong> में आपकी भूमिका <strong>${role}</strong> है`,
    ht: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} pa editable paske wòl ou nan <strong>${organization}</strong> se <strong>${role}</strong>`,
    it: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`Il ${entity} non è modificabile perché il tuo ruolo in <strong>${organization}</strong> è <strong>${role}</strong>`,
    ja: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity}は編集できません。なぜなら、<strong>${organization}</strong>におけるあなたの役割は<strong>${role}</strong>だからです`,
    ko: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity}는 편집할 수 없는데, 리<strong>${organization}</strong>에서 당신의 역할이 <strong>${role}</strong>이기 때문입니다`,
    mww: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} tsis tuaj yeem kho tau vim tias koj lub luag haujlwm hauv <strong>${organization}</strong> yog <strong>${role}</strong> Ntawv`,
    ps: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} ایډیټ کېدای نشی ځکه چې ستاسو رول <strong>${organization}</strong> <strong>${role}</strong> دی`,
    pt: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} não é editável porque seu papel na <strong>${organization}</strong> é <strong>${role}</strong>`,
    'pt-pt': (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} não é editável porque o seu papel na <strong>${organization}</strong> é <strong>${role}</strong>`,
    ru: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} не подлежит редактированию, потому что ваша роль в <strong>${organization}</strong> — <strong>${role}</strong>`,
    sm: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} le mafai ona fa'asa'oina le lipoti aua o lau matafaioi i <strong>${organization}</strong> o <strong>${role}</strong>`,
    so: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} lama tafatiri karo sababtoo ah doorkaaga <strong>${organization}</strong> waa <strong>${role}</strong>`,
    th: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} ไม่สามารถแก้ไขได้เนื่องจากบทบาทของคุณใน <strong>${organization}</strong> คือ <strong>${role}</strong>`,
    ur: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} ایڈیٹنگ کے قابل نہیں کیونکہ <strong>${organization}</strong> میں <strong>${role}</strong> ہے`,
    vi: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} không thể chỉnh sửa được vì vai trò của bạn trong <strong>${organization}</strong> là <strong>${role}</strong>`,
    'zh-hans': (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} 不可编辑，因为您在 <strong>${organization}</strong> 中的角色是 <strong>${role}</strong>`,
    'zh-hant': (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} 不可編輯，因為您在 <strong>${organization}</strong> 的角色是 <strong>${role}</strong>`,
    en: (entity, organization, role)=>$b11db1b62d4a8f76$var$html`${entity} is not editable because your role in <strong>${organization}</strong> is <strong>${role}</strong>`
};
const $b11db1b62d4a8f76$export$c35d6441a1e5a3ac = {
    ar: (entity)=>$b11db1b62d4a8f76$var$html`${entity} المشتركة لا يمكن تعديلها إلا من قبل منشئ المحتوى أو أعضاء منظمة المبدع الذين يكونون <strong>بدور المالك</strong> أو <strong>المسؤول</strong>.`,
    de: (entity)=>$b11db1b62d4a8f76$var$html`Geteilte ${entity} können nur vom Ersteller oder von Mitgliedern der Organisation des Erstellers mit der <strong>Rolle Eigentümer</strong> oder <strong>Administrator</strong> bearbeitet werden.`,
    es: (entity)=>$b11db1b62d4a8f76$var$html`Los ${entity} compartidos solo pueden ser editados por su creador o miembros de la organización del creador con el rol <strong>de Propietario</strong> o <strong>Administrador</strong> .`,
    fa: (entity)=>$b11db1b62d4a8f76$var$html`${entity} های به اشتراک گذاشته شده فقط توسط خالق خود یا اعضای سازمان سازنده با نقش <strong>مالک</strong> یا <strong>مدیر</strong> قابل ویرایش هستند.`,
    fil: (entity)=>$b11db1b62d4a8f76$var$html`Ang mga ibinahaging ${entity} ay maaaring i-edit lamang ng tagalikha nito o ng mga miyembro ng organisasyon ng tagalikha na may papel na <strong>May-ari</strong> o <strong>Admin</strong> .`,
    fr: (entity)=>$b11db1b62d4a8f76$var$html`Les ${entity} partagés ne peuvent être modifiés que par leur créateur ou les membres de l’organisation du créateur ayant les rôles <strong>de Propriétaire</strong> ou <strong>d’Administrateur</strong> .`,
    hi: (entity)=>$b11db1b62d4a8f76$var$html`साझा की गई ${entity} केवल उनके निर्माता या निर्माता के संगठन के सदस्यों द्वारा <strong>स्वामी या</strong> <strong>व्यवस्थापक</strong> भूमिका के साथ संपादित की जा सकती हैं.`,
    ht: (entity)=>$b11db1b62d4a8f76$var$html`${entity} pataje yo sèlman editab pa kreyatè yo oswa manm nan òganizasyon kreyatè a ki gen wòl <strong>Pwopriyetè</strong> oswa <strong>Admin</strong>.`,
    it: (entity)=>$b11db1b62d4a8f76$var$html`I ${entity} condivisi sono modificabili solo dal loro creatore o dai membri dell'organizzazione del creatore con il ruolo <strong>di Proprietario</strong> o <strong>Amministratore</strong> .`,
    ja: (entity)=>$b11db1b62d4a8f76$var$html`共有 ${entity} は、作成者本人またはその組織のメンバーが <strong>所有者</strong> または <strong>管理者</strong> の役割を持つ者のみが編集可能です。`,
    ko: (entity)=>$b11db1b62d4a8f76$var$html`공유 ${entity} 는 오직 창작자 또는 창작자 조직의 <strong>소유자</strong> 또는 <strong>관리자</strong> 역할의 회원만이 편집할 수 있습니다.`,
    mww: (entity)=>$b11db1b62d4a8f76$var$html`Cov ${entity} sib koom tsuas yog kho tau los ntawm lawv tus tsim lossis cov tswv cuab ntawm tus tsim lub koom haum nrog <strong>Tus Tswv</strong> lossis <strong>Tus Thawj Tswj</strong> Hwm lub luag haujlwm.`,
    ps: (entity)=>$b11db1b62d4a8f76$var$html`شریک ${entity} یوازې د خپل خالق یا د خالق د سازمان غړو لخوا چې <strong>مالک</strong> یا <strong>مدیر</strong> رول لری، ایډیټ کیدی شی.`,
    pt: (entity)=>$b11db1b62d4a8f76$var$html`${entity} compartilhados só podem ser editados pelo criador ou membros da organização do criador com a função <strong>de Proprietário</strong> ou <strong>Administrador</strong>.`,
    'pt-pt': (entity)=>$b11db1b62d4a8f76$var$html`${entity} partilhados só podem ser editados pelo criador ou membros da organização do criador com as funções <strong>de Proprietário</strong> ou <strong>Administrador</strong>.`,
    ru: (entity)=>$b11db1b62d4a8f76$var$html`Общие ${entity} могут редактировать только их создатель или члены организации создателя с <strong>ролью Владельца</strong> или <strong>Администратора</strong> .`,
    sm: (entity)=>$b11db1b62d4a8f76$var$html`O ${entity} fa'asoa e na'o le mafai ona fa'asa'oina e le latou foafoa po'o sui o le fa'alapotopotoga a le foafoa ma le <strong>Matafaioi</strong> a le Pule po'o le <strong>Pule.</strong>`,
    so: (entity)=>$b11db1b62d4a8f76$var$html`${entity} la wadaago waxaa kaliya wax ka beddeli kara abuuraha ama xubnaha ururka abuuraha oo leh doorka <strong>Milkiilaha</strong> ama <strong>Maamulaha</strong>.`,
    th: (entity)=>$b11db1b62d4a8f76$var$html`${entity}ที่แชร์จะแก้ไขได้โดยผู้สร้างหรือสมาชิกในองค์กรของครีเอเตอร์ที่มีบทบาท<strong>เป็นเจ้าของ</strong>หรือ<strong>ผู้ดูแลระบบ</strong>เท่านั้น`,
    ur: (entity)=>$b11db1b62d4a8f76$var$html`شیئرڈ ${entity} صرف ان کے تخلیق کار یا تخلیق کار کی تنظیم کے ارکان کے ذریعے ایڈٹ کی جا سکتی ہیں جن کا <strong>کردار مالک</strong> یا <strong>ایڈمن</strong> کا کردار ہوتا ہے۔`,
    vi: (entity)=>$b11db1b62d4a8f76$var$html`${entity} được chia sẻ chỉ có thể chỉnh sửa bởi người tạo hoặc thành viên trong tổ chức của người sáng tạo có vai trò <strong>Chủ sở hữu</strong> hoặc <strong>Quản trị viên</strong>.`,
    'zh-hans': (entity)=>$b11db1b62d4a8f76$var$html`共享 ${entity} 只能由其创作者或其组织成员以 <strong>所有者</strong> 或 <strong>管理员</strong> 身份编辑。`,
    'zh-hant': (entity)=>$b11db1b62d4a8f76$var$html`共享 ${entity} 僅能由創作者本人或其組織中以 <strong>擁有者</strong> 或 <strong>管理員</strong> 角色的成員編輯。`,
    en: (entity)=>$b11db1b62d4a8f76$var$html`Shared ${entity} are only editable by their creator or members of the creator's organization with the <strong>Owner</strong> or <strong>Admin</strong> role.`
};
const $b11db1b62d4a8f76$export$f783852a4ad65ea8 = {
    ar: `\u{627}\u{644}\u{62A}\u{642}\u{627}\u{631}\u{64A}\u{631}`,
    de: `Berichte`,
    es: `Informes`,
    fa: `\u{6AF}\u{632}\u{627}\u{631}\u{634} \u{647}\u{627}`,
    fil: `Mga Ulat`,
    fr: `Rapports`,
    hi: `\u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F}`,
    ht: `Rap\xf2 yo`,
    it: `Rapporti`,
    ja: `\u{5831}\u{544A}\u{66F8}`,
    ko: `\u{BCF4}\u{ACE0}\u{C11C}`,
    mww: `Cov ntawv ceeb toom`,
    ps: `\u{631}\u{627}\u{67E}\u{648}\u{631}\u{648}\u{646}\u{647}`,
    pt: `Relat\xf3rios`,
    'pt-pt': `Relat\xf3rios`,
    ru: `\u{41E}\u{442}\u{447}\u{451}\u{442}\u{44B}`,
    sm: `Lipoti`,
    so: `Warbixinno`,
    th: `\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{631}\u{67E}\u{648}\u{631}\u{679}\u{633}`,
    vi: `B\xe1o c\xe1o`,
    'zh-hans': `\u{62A5}\u{544A}`,
    'zh-hant': `\u{5831}\u{544A}`,
    en: `Reports`
};
const $b11db1b62d4a8f76$export$bf155eef9c17fa3b = {
    ar: `(\u{645}\u{637}\u{644}\u{648}\u{628})`,
    de: `(Erforderlich)`,
    es: `(Obligatorio)`,
    fa: `(\u{627}\u{644}\u{632}\u{627}\u{645}\u{6CC})`,
    fil: `(Kinakailangan)`,
    fr: `(Obligatoire)`,
    hi: `(\u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915})`,
    ht: `(Obligatwa)`,
    it: `(Richiesto)`,
    ja: `(\u{5FC5}\u{9808})`,
    ko: `(\u{D544}\u{C218})`,
    mww: `(Yuav tsum tau)`,
    ps: `(\u{627}\u{693}\u{6CC}\u{646} \u{62F}\u{6CC})`,
    pt: `(Obrigat\xf3rio)`,
    'pt-pt': `(Obrigat\xf3rio)`,
    ru: `(\u{41E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E})`,
    sm: `(Mana'omia)`,
    so: `(Loo baahan yahay)`,
    th: `(\u{E08}\u{E4D}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19})`,
    ur: `(\u{636}\u{631}\u{648}\u{631}\u{6CC})`,
    vi: `(B\u{1EAF}t bu\u{1ED9}c)`,
    'zh-hans': `\u{FF08}\u{5FC5}\u{4FEE}\u{FF09}`,
    'zh-hant': `\u{FF08}\u{5FC5}\u{4FEE}\u{FF09}`,
    en: `(Required)`
};
const $b11db1b62d4a8f76$export$f0da3073951c1479 = {
    ar: (label)=>`"${label}" \u{645}\u{637}\u{644}\u{648}\u{628}\u{629} \u{648}\u{64A}\u{62C}\u{628} \u{625}\u{646}\u{634}\u{627}\u{624}\u{647}\u{627} \u{642}\u{628}\u{644} \u{62A}\u{62D}\u{62F}\u{64A}\u{62B} \u{62D}\u{627}\u{644}\u{629} \u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644}. \u{627}\u{644}\u{62A}\u{631}\u{627}\u{62C}\u{639} \u{639}\u{646} \u{627}\u{644}\u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{625}\u{644}\u{649} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{629}\u{60C} \u{627}\u{644}\u{62D}\u{641}\u{638}\u{60C} \u{62B}\u{645} \u{625}\u{646}\u{634}\u{627}\u{621} "${label}" \u{642}\u{628}\u{644} \u{645}\u{62D}\u{627}\u{648}\u{644}\u{629} \u{62A}\u{62D}\u{62F}\u{64A}\u{62B} \u{62D}\u{627}\u{644}\u{629} \u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644}.`,
    de: (label)=>`Eine "${label}" ist erforderlich und muss erstellt werden, bevor der Status dieses Datensatzes aktualisiert werden kann. Status\xe4nderung r\xfcckg\xe4ngig machen, speichern und dann "${label}" erstellen, bevor Sie versuchen, den Status dieses Datensatzes zu aktualisieren.`,
    es: (label)=>`Se requiere la "${label}" y debe crearse antes de que se pueda actualizar el estado de este registro. Deshacer el cambio de estado, guardarlo y luego crear una "${label}" antes de intentar actualizar el estado de este registro.`,
    fa: (label)=>`\xab${label} \u{628}\u{648}\u{62F}\u{646}\xbb \u{627}\u{644}\u{632}\u{627}\u{645}\u{6CC} \u{627}\u{633}\u{62A} \u{648} \u{628}\u{627}\u{6CC}\u{62F} \u{642}\u{628}\u{644} \u{627}\u{632} \u{628}\u{647} \u{631}\u{648}\u{632}\u{631}\u{633}\u{627}\u{646}\u{6CC} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{627}\u{6CC}\u{646} \u{631}\u{6A9}\u{648}\u{631}\u{62F} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{634}\u{648}\u{62F}. \u{642}\u{628}\u{644} \u{627}\u{632} \u{62A}\u{644}\u{627}\u{634} \u{628}\u{631}\u{627}\u{6CC} \u{628}\u{647} \u{631}\u{648}\u{632}\u{631}\u{633}\u{627}\u{646}\u{6CC} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{627}\u{6CC}\u{646} \u{631}\u{6A9}\u{648}\u{631}\u{62F}\u{60C} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{631}\u{627} \u{644}\u{63A}\u{648} \u{6A9}\u{646}\u{6CC}\u{62F}\u{60C} \u{630}\u{62E}\u{6CC}\u{631}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}\u{60C} \u{633}\u{67E}\u{633} \xab${label}\xbb \u{631}\u{627} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: (label)=>`Kinakailangan ang "${label}" at dapat likhain bago ma-update ang katayuan ng rekord na ito. I-undo ang pagbabago sa katayuan, i-save, pagkatapos ay lumikha ${label}" bago subukang i-update ang katayuan ng rekord na ito.`,
    fr: (label)=>`La \xab ${label} \xbb est requise et doit \xeatre cr\xe9\xe9e avant que le statut de ce dossier puisse \xeatre mis \xe0 jour. Annulez le changement de statut, enregistrez, puis cr\xe9ez \xab ${label} \xbb avant de tenter de mettre \xe0 jour le statut de ce dossier.`,
    hi: (label)=>`"${label}" \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915} \u{939}\u{948} \u{914}\u{930} \u{907}\u{938} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{915}\u{940} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{915}\u{94B} \u{905}\u{92A}\u{921}\u{947}\u{91F} \u{915}\u{930}\u{928}\u{947} \u{938}\u{947} \u{92A}\u{939}\u{932}\u{947} \u{907}\u{938}\u{947} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{91C}\u{93E}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}\u{964} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{92E}\u{947}\u{902} \u{92A}\u{930}\u{93F}\u{935}\u{930}\u{94D}\u{924}\u{928} \u{915}\u{94B} \u{92A}\u{942}\u{930}\u{94D}\u{935}\u{935}\u{924} \u{915}\u{930}\u{947}\u{902}, \u{938}\u{939}\u{947}\u{91C}\u{947}\u{902}, \u{92B}\u{93F}\u{930} \u{907}\u{938} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{915}\u{940} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{915}\u{94B} \u{905}\u{926}\u{94D}\u{92F}\u{924}\u{928} \u{915}\u{930}\u{928}\u{947} \u{915}\u{93E} \u{92A}\u{94D}\u{930}\u{92F}\u{93E}\u{938} \u{915}\u{930}\u{928}\u{947} \u{938}\u{947} \u{92A}\u{939}\u{932}\u{947} "\u{92A}\u{93E}\u{924}\u{94D}\u{930}\u{924}\u{93E} ${label}" \u{92C}\u{928}\u{93E}\u{90F}\u{902}\u{964}`,
    ht: (label)=>`"${label}" obligatwa epi yo dwe kreye anvan estati dosye sa a ka mete ajou. Def\xe8t chanjman nan estati, sove, L\xe8 sa a, kreye "${label}" anvan ou eseye mete ajou estati dosye sa a.`,
    it: (label)=>`\xc8 richiesta la "${label}" che deve essere creata prima che lo stato di questo documento possa essere aggiornato. Annulla la modifica dello stato, salva, poi crea la "${label}" prima di tentare di aggiornare lo stato di questo registro.`,
    ja: (label)=>`\u{300C}${label}\u{300D}\u{304C}\u{5FC5}\u{8981}\u{3067}\u{3042}\u{308A}\u{3001}\u{3053}\u{306E}\u{8A18}\u{9332}\u{306E}\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}\u{3092}\u{66F4}\u{65B0}\u{3059}\u{308B}\u{524D}\u{306B}\u{4F5C}\u{6210}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}\u{306E}\u{5909}\u{66F4}\u{3092}\u{5143}\u{306B}\u{623B}\u{3057}\u{3001}\u{4FDD}\u{5B58}\u{3057}\u{3066}\u{304B}\u{3089}\u{300C}${label}\u{300D}\u{3092}\u{4F5C}\u{6210}\u{3057}\u{3001}\u{3053}\u{306E}\u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{306E}\u{72B6}\u{614B}\u{3092}\u{66F4}\u{65B0}\u{3057}\u{3088}\u{3046}\u{3068}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: (label)=>`"${label}\u{C11C}"\u{AC00} \u{D544}\u{C694}\u{D558}\u{BA70}, \u{C774} \u{AE30}\u{B85D}\u{C758} \u{C0C1}\u{D0DC}\u{B97C} \u{AC31}\u{C2E0}\u{D558}\u{AE30} \u{C804}\u{C5D0} \u{BC18}\u{B4DC}\u{C2DC} \u{C791}\u{C131}\u{B418}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}. \u{C0C1}\u{D0DC} \u{BCC0}\u{ACBD} \u{CDE8}\u{C18C} \u{D6C4} \u{C800}\u{C7A5}\u{D55C} \u{B4A4}, "${label}"\u{C744} \u{C0DD}\u{C131}\u{D55C} \u{D6C4} \u{C774} \u{AE30}\u{B85D}\u{C758} \u{C0C1}\u{D0DC}\u{B97C} \u{C5C5}\u{B370}\u{C774}\u{D2B8}\u{D558}\u{B824}\u{ACE0} \u{C2DC}\u{B3C4}\u{D558}\u{C138}\u{C694}.`,
    mww: (label)=>`Yuav tsum tau "${label}" thiab yuav tsum tau tsim ua ntej cov xwm txheej ntawm cov ntaub ntawv no tuaj yeem hloov kho. Thim rov qab hloov mus rau qhov xwm txheej, txuag, tom qab ntawd tsim "${label}" ua ntej sim hloov kho cov ntaub ntawv no.`,
    ps: (label)=>`"${label}" \u{627}\u{693}\u{6CC}\u{646} \u{62F}\u{6CC} \u{627}\u{648} \u{628}\u{627}\u{6CC}\u{62F} \u{62C}\u{648}\u{693} \u{634}\u{6CC} \u{645}\u{62E}\u{6A9}\u{6D0} \u{644}\u{647} \u{62F}\u{6D0} \u{686}\u{6D0} \u{62F} \u{62F}\u{6D0} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{62D}\u{627}\u{644}\u{62A} \u{62A}\u{627}\u{632}\u{647} \u{634}\u{6CC}. \u{62F} \u{62D}\u{627}\u{644}\u{62A} \u{628}\u{62F}\u{644}\u{648}\u{646} \u{628}\u{6CC}\u{631}\u{62A}\u{647} \u{648}\u{627}\u{62E}\u{644}\u{626}\u{60C} \u{630}\u{62E}\u{6CC}\u{631}\u{647} \u{6A9}\u{693}\u{626}\u{60C} \u{628}\u{6CC}\u{627} "${label}" \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{626} \u{645}\u{62E}\u{6A9}\u{6D0} \u{644}\u{647} \u{62F}\u{6D0} \u{686}\u{6D0} \u{62F} \u{62F}\u{6D0} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{62D}\u{627}\u{644}\u{62A} \u{62A}\u{627}\u{632}\u{647} \u{6A9}\u{693}\u{626}.`,
    pt: (label)=>`A "${label}" \xe9 necess\xe1ria e deve ser criada antes que o status deste registro possa ser atualizado. Desfa\xe7a a altera\xe7\xe3o de status, salve e depois crie a "${label}" antes de tentar atualizar o status deste registro.`,
    'pt-pt': (label)=>`\xc9 necess\xe1ria a "${label}" e deve ser criada antes que o estado deste registo possa ser atualizado. Desfa\xe7a a altera\xe7\xe3o de estado, guarde e depois crie a "${label}" antes de tentar atualizar o estado deste registo.`,
    ru: (label)=>`\u{422}\u{440}\u{435}\u{431}\u{443}\u{435}\u{442}\u{441}\u{44F} \xab${label}\xbb \u{438} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{43E} \u{434}\u{43E} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{430} \u{44D}\u{442}\u{43E}\u{439} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}. \u{41E}\u{442}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{435} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{435} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{430}, \u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{435}, \u{437}\u{430}\u{442}\u{435}\u{43C} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{439}\u{442}\u{435} \xab${label} \u{441}\u{43E}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{438}\u{435}\xbb \u{43F}\u{435}\u{440}\u{435}\u{434} \u{43F}\u{43E}\u{43F}\u{44B}\u{442}\u{43A}\u{43E}\u{439} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441} \u{44D}\u{442}\u{43E}\u{439} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}.`,
    sm: (label)=>`E mana'omia le "${label}" ma e tatau ona fatuina a'o le'i mafai ona fa'afouina le tulaga o lenei fa'amaumauga. Faaleaogaina le suiga i le tulaga, sefe, ona fatu lea o le "${label} agavaa" a o lei taumafai e faafou le tulaga o lenei faamaumauga.`,
    so: (label)=>`"${label}" waa in la abuuraa ka hor inta aan la cusbooneysiin xaaladda diiwaankan. Ka noqo beddelka xaaladda, kaydi, kadibna abuur "${label}" ka hor inta aan la isku dayin inaad cusbooneysiiso xaaladda diiwaankan.`,
    th: (label)=>`\u{E08}\u{E4D}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35} "${label}" \u{E41}\u{E25}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E02}\u{E36}\u{E49}\u{E19}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E08}\u{E36}\u{E07}\u{E08}\u{E30}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E19}\u{E35}\u{E49}\u{E44}\u{E14}\u{E49} \u{E40}\u{E25}\u{E34}\u{E01}\u{E17}\u{E4D}\u{E32}\u{E01}\u{E32}\u{E23}\u{E40}\u{E1B}\u{E25}\u{E35}\u{E48}\u{E22}\u{E19}\u{E41}\u{E1B}\u{E25}\u{E07}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30} \u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01} \u{E08}\u{E32}\u{E01}\u{E19}\u{E31}\u{E49}\u{E19}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07} "${label}" \u{E01}\u{E48}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E1E}\u{E22}\u{E32}\u{E22}\u{E32}\u{E21}\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E19}\u{E35}\u{E49}`,
    ur: (label)=>`"${label}" \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2} \u{627}\u{648}\u{631} \u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{6CC} \u{62D}\u{6CC}\u{62B}\u{6CC}\u{62A} \u{6A9}\u{648} \u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6A9}\u{631}\u{646}\u{6D2} \u{633}\u{6D2} \u{67E}\u{6C1}\u{644}\u{6D2} \u{627}\u{633}\u{6D2} \u{62A}\u{6CC}\u{627}\u{631} \u{6A9}\u{631}\u{646}\u{627} \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2}\u{6D4} \u{627}\u{633}\u{679}\u{6CC}\u{679}\u{633} \u{645}\u{6CC}\u{6BA} \u{62A}\u{628}\u{62F}\u{6CC}\u{644}\u{6CC} \u{6A9}\u{648} \u{648}\u{627}\u{67E}\u{633} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{60C} \u{645}\u{62D}\u{641}\u{648}\u{638} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{60C} \u{67E}\u{6BE}\u{631} "${label}" \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA} \u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{6CC} \u{62D}\u{627}\u{644}\u{62A} \u{6A9}\u{648} \u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{6A9}\u{648}\u{634}\u{634} \u{6A9}\u{631}\u{646}\u{6D2} \u{633}\u{6D2} \u{67E}\u{6C1}\u{644}\u{6D2}\u{6D4}`,
    vi: (label)=>`"${label}" l\xe0 b\u{1EAF}t bu\u{1ED9}c v\xe0 ph\u{1EA3}i \u{111}\u{1B0}\u{1EE3}c t\u{1EA1}o tr\u{1B0}\u{1EDB}c khi c\xf3 th\u{1EC3} c\u{1EAD}p nh\u{1EAD}t tr\u{1EA1}ng th\xe1i c\u{1EE7}a h\u{1ED3} s\u{1A1} n\xe0y. Ho\xe0n t\xe1c thay \u{111}\u{1ED5}i tr\u{1EA1}ng th\xe1i, l\u{1B0}u, sau \u{111}\xf3 t\u{1EA1}o "${label}" tr\u{1B0}\u{1EDB}c khi c\u{1ED1} g\u{1EAF}ng c\u{1EAD}p nh\u{1EAD}t tr\u{1EA1}ng th\xe1i c\u{1EE7}a b\u{1EA3}n ghi n\xe0y.`,
    'zh-hans': (label)=>`\u{201C}${label}\u{201D}\u{662F}\u{5FC5}\u{9700}\u{7684}\u{FF0C}\u{5FC5}\u{987B}\u{5148}\u{521B}\u{5EFA}\u{FF0C}\u{624D}\u{80FD}\u{66F4}\u{65B0}\u{672C}\u{8BB0}\u{5F55}\u{72B6}\u{6001}\u{3002}\u{64A4}\u{9500}\u{72B6}\u{6001}\u{66F4}\u{6539}\u{FF0C}\u{4FDD}\u{5B58}\u{FF0C}\u{7136}\u{540E}\u{521B}\u{5EFA}\u{201C}${label}\u{201D}\u{FF0C}\u{518D}\u{5C1D}\u{8BD5}\u{66F4}\u{65B0}\u{8BE5}\u{8BB0}\u{5F55}\u{7684}\u{72B6}\u{6001}\u{3002}`,
    'zh-hant': (label)=>`\u{300C}${label}\u{300D}\u{5FC5}\u{9808}\u{5148}\u{5EFA}\u{7ACB}\u{FF0C}\u{624D}\u{80FD}\u{66F4}\u{65B0}\u{672C}\u{7D00}\u{9304}\u{72C0}\u{614B}\u{3002}\u{5148}\u{9084}\u{539F}\u{72C0}\u{614B}\u{8B8A}\u{66F4}\u{FF0C}\u{5132}\u{5B58}\u{5F8C}\u{5EFA}\u{7ACB}\u{300C}${label}\u{300D}\u{FF0C}\u{518D}\u{5617}\u{8A66}\u{66F4}\u{65B0}\u{6B64}\u{7D00}\u{9304}\u{72C0}\u{614B}\u{3002}`,
    en: (label)=>`"${label}" is required and must be created before the status of this record can be updated. Undo change to status, save, then create "${label}" before attempting to update this record's status.`
};
const $b11db1b62d4a8f76$export$54d71384411eecde = {
    ar: `\u{625}\u{639}\u{627}\u{62F}\u{629} \u{627}\u{644}\u{62A}\u{639}\u{64A}\u{64A}\u{646}`,
    de: `Reset`,
    es: `Reinicio`,
    fa: `\u{628}\u{627}\u{632}\u{646}\u{634}\u{627}\u{646}\u{6CC}`,
    fil: `I-reset`,
    fr: `R\xe9initialisation`,
    hi: `\u{930}\u{940}\u{938}\u{947}\u{91F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Reyajiste`,
    it: `Reset`,
    ja: `\u{30EA}\u{30BB}\u{30C3}\u{30C8}`,
    ko: `\u{B9AC}\u{C14B}`,
    mww: `Rov pib dua`,
    ps: `\u{628}\u{6CC}\u{627} \u{62A}\u{646}\u{638}\u{6CC}\u{645}`,
    pt: `Reiniciar`,
    'pt-pt': `Reiniciar`,
    ru: `\u{421}\u{431}\u{440}\u{43E}\u{441}`,
    sm: `Toe setiina`,
    so: `Dib u dejin`,
    th: `\u{E23}\u{E35}\u{E40}\u{E0B}\u{E47}\u{E15}`,
    ur: `\u{631}\u{6CC} \u{633}\u{6CC}\u{679} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xf3a v\xe0 l\xe0m l\u{1EA1}i`,
    'zh-hans': `\u{91CD}\u{7F6E}`,
    'zh-hant': `\u{91CD}\u{7F6E}`,
    en: `Reset`
};
const $b11db1b62d4a8f76$export$51e87c4ec4bfa4c8 = {
    ar: `\u{625}\u{639}\u{627}\u{62F}\u{629} \u{62A}\u{639}\u{64A}\u{64A}\u{646} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639} \u{627}\u{644}\u{627}\u{641}\u{62A}\u{631}\u{627}\u{636}\u{64A}`,
    de: `Standardsignatur zur\xfccksetzen`,
    es: `Restablecer firma predeterminada`,
    fa: `\u{628}\u{627}\u{632}\u{646}\u{634}\u{627}\u{646}\u{6CC} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636}`,
    fil: `I-reset ang default na lagda`,
    fr: `R\xe9initialiser la signature par d\xe9faut`,
    hi: `\u{921}\u{93F}\u{92B}\u{93C}\u{949}\u{932}\u{94D}\u{91F} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{930}\u{940}\u{938}\u{947}\u{91F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Reyajiste default siyati`,
    it: `Reset della firma predefinita`,
    ja: `\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}\u{7F72}\u{540D}\u{3092}\u{30EA}\u{30BB}\u{30C3}\u{30C8}\u{3059}\u{308B}`,
    ko: `\u{AE30}\u{BCF8} \u{C11C}\u{BA85} \u{C7AC}\u{C124}\u{C815}`,
    mww: `Rov pib dua lub neej ntawd kos npe`,
    ps: `\u{627}\u{635}\u{644}\u{6CC} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{628}\u{6CC}\u{627} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{693}\u{626}`,
    pt: `Redefinir assinatura padr\xe3o`,
    'pt-pt': `Redefinir assinatura por defeito`,
    ru: `\u{421}\u{431}\u{440}\u{43E}\u{441}\u{438}\u{442}\u{44C} \u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{443}\u{44E} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Toe seti le saini faaletonu`,
    so: `Dib u celi saxiixa caadiga ah`,
    th: `\u{E23}\u{E35}\u{E40}\u{E0B}\u{E47}\u{E15}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}`,
    ur: `\u{688}\u{6CC}\u{641}\u{627}\u{644}\u{679} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{648} \u{631}\u{6CC} \u{633}\u{6CC}\u{679} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{1EB7}t l\u{1EA1}i ch\u{1EEF} k\xfd m\u{1EB7}c \u{111}\u{1ECB}nh`,
    'zh-hans': `\u{91CD}\u{7F6E}\u{9ED8}\u{8BA4}\u{7B7E}\u{540D}`,
    'zh-hant': `\u{91CD}\u{8A2D}\u{9810}\u{8A2D}\u{7C3D}\u{7AE0}`,
    en: `Reset default signature`
};
const $b11db1b62d4a8f76$export$33217432000ff923 = {
    ar: (preciseLocation)=>`\u{644}\u{62D}\u{644} \u{647}\u{630}\u{647} \u{627}\u{644}\u{645}\u{634}\u{643}\u{644}\u{629}\u{60C} \u{642}\u{645} \u{628}\u{62A}\u{639}\u{62F}\u{64A}\u{644} \u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{641}\u{639}\u{644}\u{64A} \u{627}\u{644}\u{623}\u{633}\u{627}\u{633}\u{64A} \u{648}\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631} \u{627}\u{642}\u{62A}\u{631}\u{627}\u{62D} \u{635}\u{627}\u{644}\u{62D} \u{644}\u{64A}\u{638}\u{647}\u{631} \u{645}\u{624}\u{634}\u{631} "${preciseLocation}".`,
    de: (preciseLocation)=>`Um dieses Problem zu l\xf6sen, bearbeite die prim\xe4re physische Adresse und w\xe4hle einen g\xfcltigen Vorschlag aus, sodass der Indikator "${preciseLocation}" erscheint.`,
    es: (preciseLocation)=>`Para resolver este problema, edita la direcci\xf3n f\xedsica principal y selecciona una sugerencia v\xe1lida para que aparezca el indicador "${preciseLocation}".`,
    fa: (preciseLocation)=>`\u{628}\u{631}\u{627}\u{6CC} \u{62D}\u{644} \u{627}\u{6CC}\u{646} \u{645}\u{634}\u{6A9}\u{644}\u{60C} \u{622}\u{62F}\u{631}\u{633} \u{641}\u{6CC}\u{632}\u{6CC}\u{6A9}\u{6CC} \u{627}\u{635}\u{644}\u{6CC} \u{631}\u{627} \u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{6CC}\u{6A9} \u{67E}\u{6CC}\u{634}\u{646}\u{647}\u{627}\u{62F} \u{645}\u{639}\u{62A}\u{628}\u{631} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F} \u{62A}\u{627} \u{634}\u{627}\u{62E}\u{635} \xab${preciseLocation}\xbb \u{638}\u{627}\u{647}\u{631} \u{634}\u{648}\u{62F}.`,
    fil: (preciseLocation)=>`Upang malutas ang isyung ito, i-edit ang pangunahing pisikal na address at pumili ng valid na mungkahi upang lumabas ang indicator na "${preciseLocation}".`,
    fr: (preciseLocation)=>`Pour r\xe9soudre ce probl\xe8me, modifiez l\u{2019}adresse physique principale et s\xe9lectionnez une suggestion valide afin que l\u{2019}indicateur \xab ${preciseLocation} \xbb apparaisse.`,
    hi: (preciseLocation)=>`\u{907}\u{938} \u{938}\u{92E}\u{938}\u{94D}\u{92F}\u{93E} \u{915}\u{94B} \u{939}\u{932} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F}, \u{92A}\u{94D}\u{930}\u{93E}\u{925}\u{92E}\u{93F}\u{915} \u{92D}\u{94C}\u{924}\u{93F}\u{915} \u{92A}\u{924}\u{947} \u{915}\u{94B} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{90F}\u{915} \u{92E}\u{93E}\u{928}\u{94D}\u{92F} \u{938}\u{941}\u{91D}\u{93E}\u{935} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902} \u{924}\u{93E}\u{915}\u{93F} "${preciseLocation}" \u{938}\u{902}\u{915}\u{947}\u{924}\u{915} \u{926}\u{93F}\u{916}\u{93E}\u{908} \u{926}\u{947}\u{964}`,
    ht: (preciseLocation)=>`Pou rezoud pwobl\xe8m sa a, edite adr\xe8s fizik prensipal la epi chwazi yon sijesyon ki valab pou endikat\xe8 "${preciseLocation}" la par\xe8t.`,
    it: (preciseLocation)=>`Per risolvere questo problema, modifica l'indirizzo fisico principale e seleziona un suggerimento valido in modo che appaia l'indicatore "${preciseLocation}".`,
    ja: (preciseLocation)=>`\u{3053}\u{306E}\u{554F}\u{984C}\u{3092}\u{89E3}\u{6C7A}\u{3059}\u{308B}\u{306B}\u{306F}\u{3001}\u{30D7}\u{30E9}\u{30A4}\u{30DE}\u{30EA}\u{306E}\u{7269}\u{7406}\u{30A2}\u{30C9}\u{30EC}\u{30B9}\u{3092}\u{7DE8}\u{96C6}\u{3057}\u{3001}\u{300C}${preciseLocation}\u{300D}\u{30A4}\u{30F3}\u{30B8}\u{30B1}\u{30FC}\u{30BF}\u{30FC}\u{304C}\u{8868}\u{793A}\u{3055}\u{308C}\u{308B}\u{6709}\u{52B9}\u{306A}\u{63D0}\u{6848}\u{3092}\u{9078}\u{629E}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: (preciseLocation)=>`\u{C774} \u{BB38}\u{C81C}\u{B97C} \u{D574}\u{ACB0}\u{D558}\u{B824}\u{BA74} \u{AE30}\u{BCF8} \u{BB3C}\u{B9AC}\u{C801} \u{C8FC}\u{C18C}\u{B97C} \u{D3B8}\u{C9D1}\u{D558}\u{ACE0} \u{C720}\u{D6A8}\u{D55C} \u{C81C}\u{C548}\u{C744} \u{C120}\u{D0DD}\u{D558}\u{C5EC} "${preciseLocation}" \u{D45C}\u{C2DC}\u{AC00} \u{B098}\u{D0C0}\u{B0A9}\u{B2C8}\u{B2E4}.`,
    mww: (preciseLocation)=>`Txhawm rau daws qhov teeb meem no, kho qhov chaw nyob tseem ceeb thiab xaiv ib qho kev pom zoo kom muaj "${preciseLocation}" qhia.`,
    ps: (preciseLocation)=>`\u{62F} \u{62F}\u{6D0} \u{633}\u{62A}\u{648}\u{646}\u{632}\u{6D0} \u{62F} \u{62D}\u{644} \u{644}\u{67E}\u{627}\u{631}\u{647}\u{60C} \u{627}\u{635}\u{644}\u{6CC} \u{641}\u{632}\u{6CC}\u{6A9}\u{6CC} \u{67E}\u{62A}\u{647} \u{627}\u{6CC}\u{689}\u{6CC}\u{67C} \u{6A9}\u{693}\u{626} \u{627}\u{648} \u{6CC}\u{648} \u{645}\u{639}\u{62A}\u{628}\u{631} \u{648}\u{693}\u{627}\u{646}\u{62F}\u{6CC}\u{632} \u{648}\u{67C}\u{627}\u{6A9}\u{626} \u{62A}\u{631}\u{685}\u{648} \u{62F} "${preciseLocation}" \u{646}\u{69A}\u{647} \u{69A}\u{6A9}\u{627}\u{631}\u{647} \u{634}\u{6CC}.`,
    pt: (preciseLocation)=>`Para resolver esse problema, edite o endere\xe7o f\xedsico principal e selecione uma sugest\xe3o v\xe1lida para que o indicador "${preciseLocation}" apare\xe7a.`,
    'pt-pt': (preciseLocation)=>`Para resolver este problema, edite o endere\xe7o f\xedsico principal e selecione uma sugest\xe3o v\xe1lida para que apare\xe7a o indicador "${preciseLocation}".`,
    ru: (preciseLocation)=>`\u{427}\u{442}\u{43E}\u{431}\u{44B} \u{440}\u{435}\u{448}\u{438}\u{442}\u{44C} \u{44D}\u{442}\u{443} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{443}, \u{43E}\u{442}\u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{443}\u{439}\u{442}\u{435} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{439} \u{444}\u{438}\u{437}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441} \u{438} \u{432}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{43E}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{43E}\u{44F}\u{432}\u{438}\u{43B}\u{441}\u{44F} \u{438}\u{43D}\u{434}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} \xab${preciseLocation}\xbb.`,
    sm: (preciseLocation)=>`Ina ia foia lenei faafitauli, faasa'o le tuatusi autu faaletino ma filifili se fautuaga aoga ina ia faaali mai le faailo o le "${preciseLocation}".`,
    so: (preciseLocation)=>`Si arrintan loo xalliyo, wax ka beddel cinwaanka jireed ee ugu muhiimsan oo dooro talo sax ah si uu u muuqdo tilmaamaha "${preciseLocation}".`,
    th: (preciseLocation)=>`\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E1B}\u{E31}\u{E0D}\u{E2B}\u{E32}\u{E19}\u{E35}\u{E49} \u{E43}\u{E2B}\u{E49}\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E32}\u{E07}\u{E01}\u{E32}\u{E22}\u{E20}\u{E32}\u{E1E}\u{E2B}\u{E25}\u{E31}\u{E01}\u{E41}\u{E25}\u{E30}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E04}\u{E4D}\u{E32}\u{E41}\u{E19}\u{E30}\u{E19}\u{E4D}\u{E32}\u{E17}\u{E35}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E43}\u{E2B}\u{E49}\u{E41}\u{E2A}\u{E14}\u{E07}\u{E15}\u{E31}\u{E27}\u{E1A}\u{E48}\u{E07}\u{E0A}\u{E35}\u{E49} "${preciseLocation}" \u{E1B}\u{E23}\u{E32}\u{E01}\u{E0F}\u{E02}\u{E36}\u{E49}\u{E19}`,
    ur: (preciseLocation)=>`\u{627}\u{633} \u{645}\u{633}\u{626}\u{644}\u{6D2} \u{6A9}\u{648} \u{62D}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2}\u{60C} \u{67E}\u{631}\u{627}\u{626}\u{645}\u{631}\u{6CC} \u{641}\u{632}\u{6CC}\u{6A9}\u{644} \u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633} \u{627}\u{6CC}\u{688}\u{679} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{627}\u{6CC}\u{6A9} \u{62F}\u{631}\u{633}\u{62A} \u{62A}\u{62C}\u{648}\u{6CC}\u{632} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{62A}\u{627}\u{6A9}\u{6C1} "${preciseLocation}" \u{627}\u{646}\u{688}\u{6CC}\u{6A9}\u{6CC}\u{679}\u{631} \u{638}\u{627}\u{6C1}\u{631} \u{6C1}\u{648}\u{6D4}`,
    vi: (preciseLocation)=>`\u{110}\u{1EC3} gi\u{1EA3}i quy\u{1EBF}t v\u{1EA5}n \u{111}\u{1EC1} n\xe0y, h\xe3y ch\u{1EC9}nh s\u{1EED}a \u{111}\u{1ECB}a ch\u{1EC9} v\u{1EAD}t l\xfd ch\xednh v\xe0 ch\u{1ECD}n m\u{1ED9}t g\u{1EE3}i \xfd h\u{1EE3}p l\u{1EC7} \u{111}\u{1EC3} ch\u{1EC9} b\xe1o "${preciseLocation}" xu\u{1EA5}t hi\u{1EC7}n.`,
    'zh-hans': (preciseLocation)=>`\u{8981}\u{89E3}\u{51B3}\u{8FD9}\u{4E2A}\u{95EE}\u{9898}\u{FF0C}\u{8BF7}\u{7F16}\u{8F91}\u{4E3B}\u{5730}\u{5740}\u{5E76}\u{9009}\u{62E9}\u{4E00}\u{4E2A}\u{6709}\u{6548}\u{7684}\u{5EFA}\u{8BAE}\u{FF0C}\u{4F7F}\u{201C}${preciseLocation}\u{201D}\u{6307}\u{793A}\u{5668}\u{51FA}\u{73B0}\u{3002}`,
    'zh-hant': (preciseLocation)=>`\u{8981}\u{89E3}\u{6C7A}\u{9019}\u{500B}\u{554F}\u{984C}\u{FF0C}\u{8ACB}\u{7DE8}\u{8F2F}\u{4E3B}\u{8981}\u{5BE6}\u{9AD4}\u{5730}\u{5740}\u{4E26}\u{9078}\u{64C7}\u{6709}\u{6548}\u{7684}\u{5EFA}\u{8B70}\u{FF0C}\u{8B93}\u{300C}${preciseLocation}\u{300D}\u{6307}\u{793A}\u{5668}\u{51FA}\u{73FE}\u{3002}`,
    en: (preciseLocation)=>`To resolve this issue, edit the primary physical address and select a valid suggestion so the \u{201C}${preciseLocation}\u{201D} indicator appears.`
};
const $b11db1b62d4a8f76$export$6af53a849aeeeae9 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{627}\u{631}\u{62F}`,
    de: `Ressourcen`,
    es: `Recursos`,
    fa: `\u{645}\u{646}\u{627}\u{628}\u{639}`,
    fil: `Mga Mapagkukunan`,
    fr: `Ressources`,
    hi: `\u{909}\u{92A}\u{92F}\u{941}\u{915}\u{94D}\u{924} \u{938}\u{902}\u{938}\u{93E}\u{927}\u{928} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Resous yo`,
    it: `Risorse`,
    ja: `\u{8CC7}\u{6599}`,
    ko: `\u{C790}\u{B8CC}`,
    mww: `Cov peev txheej`,
    ps: `\u{633}\u{631}\u{686}\u{6CC}\u{646}\u{6D0}`,
    pt: `Recursos`,
    'pt-pt': `Recursos`,
    ru: `\u{420}\u{435}\u{441}\u{443}\u{440}\u{441}\u{44B}`,
    sm: `Punaoa`,
    so: `Ilo`,
    th: `\u{E41}\u{E2B}\u{E25}\u{E48}\u{E07}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}`,
    ur: `\u{648}\u{633}\u{627}\u{626}\u{644}`,
    vi: `T\xe0i nguy\xean`,
    'zh-hans': `\u{8D44}\u{6E90}`,
    'zh-hant': `\u{8CC7}\u{6E90}`,
    en: `Resources`
};
const $b11db1b62d4a8f76$export$2ac06249e0216e67 = {
    ar: `\u{627}\u{644}\u{631}\u{62F}\u{648}\u{62F}`,
    de: `Antworten`,
    es: `Respuestas`,
    fa: `\u{67E}\u{627}\u{633}\u{62E} \u{647}\u{627}`,
    fil: `Mga tugon`,
    fr: `R\xe9ponses`,
    hi: `\u{91C}\u{935}\u{93E}\u{92C}`,
    ht: `Repons yo`,
    it: `Risposte`,
    ja: `\u{56DE}\u{7B54}`,
    ko: `\u{BC18}\u{C751}`,
    mww: `Cov lus teb`,
    ps: `\u{681}\u{648}\u{627}\u{628}\u{648}\u{646}\u{647}`,
    pt: `Respostas`,
    'pt-pt': `Respostas`,
    ru: `\u{41E}\u{442}\u{432}\u{435}\u{442}\u{44B}`,
    sm: `Tali`,
    so: `Jawaabaha`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E15}\u{E2D}\u{E1A}`,
    ur: `\u{62C}\u{648}\u{627}\u{628}\u{627}\u{62A}`,
    vi: `C\xe2u tr\u{1EA3} l\u{1EDD}i`,
    'zh-hans': `\u{56DE}\u{5E94}`,
    'zh-hant': `\u{56DE}\u{61C9}`,
    en: `Responses`
};
const $b11db1b62d4a8f76$export$eef42b3d4552220 = {
    ar: `\u{645}\u{631}\u{627}\u{62C}\u{639}\u{629}`,
    de: `Rezension`,
    es: `Rese\xf1a`,
    fa: `\u{628}\u{631}\u{631}\u{633}\u{6CC}`,
    fil: `Repasuhin`,
    fr: `Critique`,
    hi: `\u{938}\u{92E}\u{940}\u{915}\u{94D}\u{937}\u{93E}`,
    ht: `Revizyon`,
    it: `Recensione`,
    ja: `\u{30EC}\u{30D3}\u{30E5}\u{30FC}`,
    ko: `\u{B9AC}\u{BDF0}`,
    mww: `Kev Ntsuam Xyuas`,
    ps: `\u{628}\u{6CC}\u{627}\u{6A9}\u{62A}\u{646}\u{647}`,
    pt: `An\xe1lise`,
    'pt-pt': `Cr\xedtica`,
    ru: `\u{41E}\u{431}\u{437}\u{43E}\u{440}`,
    sm: `Iloiloga`,
    so: `Dib u eegis`,
    th: `\u{E17}\u{E1A}\u{E17}\u{E27}\u{E19}`,
    ur: `\u{62C}\u{627}\u{626}\u{632}\u{6C1}`,
    vi: `\u{110}\xe1nh gi\xe1`,
    'zh-hans': `\u{5F71}\u{8BC4}`,
    'zh-hant': `\u{8A55}\u{8AD6}`,
    en: `Review`
};
const $b11db1b62d4a8f76$export$d3aa83d53a73dbf9 = {
    ar: `\u{631}\u{627}\u{62C}\u{639} \u{648}\u{62D}\u{631}\u{631} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{639}\u{627}\u{631}\u{636} \u{639}\u{644}\u{649} \u{627}\u{644}\u{64A}\u{633}\u{627}\u{631}.`,
    de: `\xdcberpr\xfcfen und bearbeiten Sie mit dem Betrachter links.`,
    es: `Revisa y edita usando el visor de la izquierda.`,
    fa: `\u{628}\u{627}\u{632}\u{628}\u{6CC}\u{646}\u{6CC} \u{648} \u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{628}\u{627} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{627}\u{632} \u{646}\u{645}\u{627}\u{6CC}\u{634}\u{6AF}\u{631} \u{633}\u{645}\u{62A} \u{686}\u{67E}.`,
    fil: `Suriin at i-edit gamit ang viewer sa kaliwa.`,
    fr: `Examinez et \xe9ditez en utilisant le visualiseur \xe0 gauche.`,
    hi: `\u{92C}\u{93E}\u{908}\u{902} \u{913}\u{930} \u{915}\u{947} \u{935}\u{94D}\u{92F}\u{942}\u{905}\u{930} \u{915}\u{93E} \u{907}\u{938}\u{94D}\u{924}\u{947}\u{92E}\u{93E}\u{932} \u{915}\u{930}\u{915}\u{947} \u{938}\u{92E}\u{940}\u{915}\u{94D}\u{937}\u{93E} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{909}\u{938}\u{92E}\u{947}\u{902} \u{92C}\u{926}\u{932}\u{93E}\u{935} \u{915}\u{930}\u{947}\u{902}.`,
    ht: `Revize ak modifye l\xe8 l s\xe8vi av\xe8k visualiseur a sou b\xf2 g\xf2ch la.`,
    it: `Rivedi e modifica usando il visualizzatore a sinistra.`,
    ja: `\u{5DE6}\u{5074}\u{306E}\u{30D3}\u{30E5}\u{30FC}\u{30A2}\u{30FC}\u{3092}\u{4F7F}\u{3063}\u{3066}\u{30EC}\u{30D3}\u{30E5}\u{30FC}\u{3068}\u{7DE8}\u{96C6}\u{3092}\u{884C}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C67C}\u{CABD} \u{BDF0}\u{C5B4}\u{B97C} \u{C0AC}\u{C6A9}\u{D574} \u{AC80}\u{D1A0}\u{D558}\u{ACE0} \u{D3B8}\u{C9D1}\u{D558}\u{C138}\u{C694}.`,
    mww: `Xyuas thiab hloov siv tus saib rau sab laug.`,
    ps: `\u{62F} \u{6A9}\u{6CC}\u{6BC} \u{627}\u{693}\u{62E} \u{644}\u{6CC}\u{62F}\u{648}\u{646}\u{6A9}\u{6CC} \u{67E}\u{647} \u{6A9}\u{627}\u{631}\u{648}\u{644}\u{648} \u{633}\u{631}\u{647} \u{628}\u{6CC}\u{627}\u{6A9}\u{62A}\u{646}\u{647} \u{627}\u{648} \u{627}\u{6CC}\u{689}\u{6CC}\u{67C} \u{6A9}\u{693}\u{626}.`,
    pt: `Revise e edite usando o visualizador \xe0 esquerda.`,
    'pt-pt': `Rev\xea e edita usando o visualizador \xe0 esquerda.`,
    ru: `\u{41F}\u{440}\u{43E}\u{441}\u{43C}\u{430}\u{442}\u{440}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{438} \u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{443}\u{439}\u{442}\u{435} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{437}\u{440}\u{438}\u{442}\u{435}\u{43B}\u{44F} \u{441}\u{43B}\u{435}\u{432}\u{430}.`,
    sm: `Toe iloilo ma faasa'o e faaaoga ai le tagata matamata i le itu tauagavale.`,
    so: `Dib u eegis iyo tafatir adigoo adeegsanaya daawadayaasha bidixda.`,
    th: `\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E41}\u{E25}\u{E30}\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E42}\u{E14}\u{E22}\u{E43}\u{E0A}\u{E49}\u{E42}\u{E1B}\u{E23}\u{E41}\u{E01}\u{E23}\u{E21}\u{E14}\u{E39}\u{E17}\u{E32}\u{E07}\u{E14}\u{E49}\u{E32}\u{E19}\u{E0B}\u{E49}\u{E32}\u{E22}`,
    ur: `\u{628}\u{627}\u{626}\u{6CC}\u{6BA} \u{637}\u{631}\u{641} \u{648}\u{627}\u{644}\u{6D2} \u{648}\u{6CC}\u{648}\u{626}\u{631} \u{6A9}\u{627} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{62A}\u{6D2} \u{6C1}\u{648}\u{626}\u{6D2} \u{62C}\u{627}\u{626}\u{632}\u{6C1} \u{627}\u{648}\u{631} \u{62A}\u{631}\u{645}\u{6CC}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Xem l\u{1EA1}i v\xe0 ch\u{1EC9}nh s\u{1EED}a b\u{1EB1}ng tr\xecnh xem \u{1EDF} b\xean tr\xe1i.`,
    'zh-hans': `\u{8BF7}\u{4F7F}\u{7528}\u{5DE6}\u{4FA7}\u{7684}\u{67E5}\u{770B}\u{5668}\u{8FDB}\u{884C}\u{5BA1}\u{6838}\u{548C}\u{7F16}\u{8F91}\u{3002}`,
    'zh-hant': `\u{8ACB}\u{4F7F}\u{7528}\u{5DE6}\u{5074}\u{7684}\u{6AA2}\u{8996}\u{5668}\u{6AA2}\u{8996}\u{4E26}\u{7DE8}\u{8F2F}\u{3002}`,
    en: `Review and edit using the viewer on the left.`
};
const $b11db1b62d4a8f76$export$9776f34c1b3ae0a1 = {
    ar: `\u{645}\u{631}\u{627}\u{62C}\u{639}\u{629} \u{648}\u{62A}\u{642}\u{62F}\u{64A}\u{645}`,
    de: `\xdcberpr\xfcfen und reichen Sie ein`,
    es: `Revisar y enviar`,
    fa: `\u{628}\u{627}\u{632}\u{628}\u{6CC}\u{646}\u{6CC} \u{648} \u{627}\u{631}\u{633}\u{627}\u{644}`,
    fil: `Suriin at isumite`,
    fr: `Examiner et soumettre`,
    hi: `\u{938}\u{92E}\u{940}\u{915}\u{94D}\u{937}\u{93E} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{938}\u{92C}\u{92E}\u{93F}\u{91F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Revize epi soum\xe8t`,
    it: `Revisiona e invia`,
    ja: `\u{5BE9}\u{67FB}\u{3068}\u{63D0}\u{51FA}`,
    ko: `\u{AC80}\u{D1A0} \u{BC0F} \u{C81C}\u{CD9C}`,
    mww: `Txheeb xyuas thiab xa`,
    ps: `\u{628}\u{6CC}\u{627}\u{6A9}\u{62A}\u{646}\u{647} \u{627}\u{648} \u{633}\u{67E}\u{627}\u{631}\u{644}`,
    pt: `Revise e envie`,
    'pt-pt': `Rever e submeter`,
    ru: `\u{41F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440} \u{438} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{430}`,
    sm: `Iloilo ma auina atu`,
    so: `Dib u eeg oo soo gudbi`,
    th: `\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E41}\u{E25}\u{E30}\u{E2A}\u{E48}\u{E07}`,
    ur: `\u{62C}\u{627}\u{626}\u{632}\u{6C1} \u{644}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `Xem x\xe9t v\xe0 g\u{1EED}i`,
    'zh-hans': `\u{5BA1}\u{6838}\u{5E76}\u{63D0}\u{4EA4}`,
    'zh-hant': `\u{5BE9}\u{6838}\u{4E26}\u{63D0}\u{4EA4}`,
    en: `Review and submit`
};
const $b11db1b62d4a8f76$export$3ba58c70835f318d = {
    ar: `\u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{645}\u{631}\u{627}\u{62C}\u{639}\u{629}`,
    de: `\xdcberpr\xfcfungs-Stundenzettel`,
    es: `Hoja de horas de revisi\xf3n`,
    fa: `\u{62C}\u{62F}\u{648}\u{644} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{645}\u{631}\u{648}\u{631}`,
    fil: `Suriin ang timesheet`,
    fr: `Feuille de temps de r\xe9vision`,
    hi: `\u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{915}\u{940} \u{938}\u{92E}\u{940}\u{915}\u{94D}\u{937}\u{93E} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Revize Timesheet`,
    it: `Foglio orario di revisione`,
    ja: `\u{5FA9}\u{7FD2}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}`,
    ko: `\u{BCF5}\u{C2B5} \u{C2DC}\u{AC04}\u{D45C}`,
    mww: `Txheeb xyuas daim ntawv teev sijhawm`,
    ps: `\u{62F} \u{628}\u{6CC}\u{627}\u{6A9}\u{62A}\u{646}\u{6D0} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647}`,
    pt: `Revisar a folha de ponto`,
    'pt-pt': `Revis\xe3o da folha de horas`,
    ru: `\u{422}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{43F}\u{43E}\u{432}\u{442}\u{43E}\u{440}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Toe iloilo le pepa o taimi`,
    so: `Waqtiga dib-u-eegista`,
    th: `\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}`,
    ur: `\u{62C}\u{627}\u{626}\u{632}\u{6C1} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679}`,
    vi: `Xem l\u{1EA1}i b\u{1EA3}ng ch\u{1EA5}m c\xf4ng`,
    'zh-hans': `\u{590D}\u{4E60}\u{65F6}\u{95F4}\u{8868}`,
    'zh-hant': `\u{56DE}\u{9867}\u{6642}\u{9593}\u{8868}`,
    en: `Review timesheet`
};
const $b11db1b62d4a8f76$export$7f180462ad092f82 = {
    ar: `\u{62F}\u{648}\u{631}\u{643} \u{644}\u{627} \u{64A}\u{633}\u{645}\u{62D} \u{644}\u{643} \u{628}\u{62A}\u{62D}\u{631}\u{64A}\u{631} \u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644}.`,
    de: `Ihre Rolle erlaubt es Ihnen nicht, diesen Datensatz zu bearbeiten.`,
    es: `Tu funci\xf3n no te permite editar este registro.`,
    fa: `\u{646}\u{642}\u{634} \u{634}\u{645}\u{627} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{627}\u{6CC}\u{646} \u{67E}\u{631}\u{648}\u{646}\u{62F}\u{647} \u{631}\u{627} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Hindi ka pinapayagan ng iyong tungkulin na i-edit ang talaang ito.`,
    fr: `Votre r\xf4le ne vous permet pas de modifier ce dossier.`,
    hi: `\u{906}\u{92A}\u{915}\u{940} \u{92D}\u{942}\u{92E}\u{93F}\u{915}\u{93E} \u{906}\u{92A}\u{915}\u{94B} \u{907}\u{938} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{915}\u{94B} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{928}\u{939}\u{940}\u{902} \u{926}\u{947}\u{924}\u{940} \u{939}\u{948}.`,
    ht: `W\xf2l ou pa p\xe8m\xe8t ou edite dosye sa a.`,
    it: `Il tuo ruolo non ti permette di modificare questo registro.`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{5F79}\u{5272}\u{3067}\u{306F}\u{3053}\u{306E}\u{8A18}\u{9332}\u{3092}\u{7DE8}\u{96C6}\u{3059}\u{308B}\u{3053}\u{3068}\u{306F}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{B2F9}\u{C2E0}\u{C758} \u{C5ED}\u{D560}\u{C0C1} \u{C774} \u{AE30}\u{B85D}\u{C744} \u{D3B8}\u{C9D1}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Koj lub luag haujlwm tsis tso cai rau koj los kho cov ntaub ntawv no.`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{631}\u{648}\u{644} \u{62A}\u{627}\u{633}\u{648} \u{62A}\u{647} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{647} \u{62F}\u{631}\u{6A9}\u{648}\u{6CC} \u{686}\u{6D0} \u{62F}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{627}\u{6CC}\u{689}\u{6CC}\u{67C} \u{6A9}\u{693}\u{626}.`,
    pt: `Seu cargo n\xe3o permite que voc\xea edite este registro.`,
    'pt-pt': `O seu cargo n\xe3o lhe permite editar este registo.`,
    ru: `\u{412}\u{430}\u{448}\u{430} \u{440}\u{43E}\u{43B}\u{44C} \u{43D}\u{435} \u{43F}\u{43E}\u{437}\u{432}\u{43E}\u{43B}\u{44F}\u{435}\u{442} \u{432}\u{430}\u{43C} \u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{44D}\u{442}\u{443} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}.`,
    sm: `E le faatagaina oe e lau matafaioi ona faasa'o lenei faamaumauga.`,
    so: `Doorkaaga ma ogola inaad tafatirto rikoodhkan.`,
    th: `\u{E1A}\u{E17}\u{E1A}\u{E32}\u{E17}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E04}\u{E38}\u{E13}\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{627} \u{6A9}\u{631}\u{62F}\u{627}\u{631} \u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{645}\u{6CC}\u{6BA} \u{62A}\u{631}\u{645}\u{6CC}\u{645} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{62F}\u{6CC}\u{62A}\u{627}\u{6D4}`,
    vi: `Vai tr\xf2 c\u{1EE7}a b\u{1EA1}n kh\xf4ng cho ph\xe9p b\u{1EA1}n ch\u{1EC9}nh s\u{1EED}a b\u{1EA3}n ghi n\xe0y.`,
    'zh-hans': `\u{4F60}\u{7684}\u{804C}\u{8D23}\u{4E0D}\u{5141}\u{8BB8}\u{4F60}\u{7F16}\u{8F91}\u{8FD9}\u{4EFD}\u{8BB0}\u{5F55}\u{3002}`,
    'zh-hant': `\u{4F60}\u{7684}\u{8077}\u{52D9}\u{4E0D}\u{5141}\u{8A31}\u{4F60}\u{7DE8}\u{8F2F}\u{6B64}\u{7D00}\u{9304}\u{3002}`,
    en: `Your role does not permit you to edit this record.`
};
const $b11db1b62d4a8f76$export$9a65256abc3742fe = {
    ar: `\u{631}\u{648}\u{641}\u{62A}\u{648}\u{628} \u{625}\u{643}\u{633}`,
    de: `Rooftop X`,
    es: `Azotea X`,
    fa: `\u{631}\u{648}\u{641} \u{62A}\u{627}\u{67E} \u{627}\u{6CC}\u{6A9}\u{633}`,
    fil: `Bubong X`,
    fr: `Toit X`,
    hi: `\u{930}\u{942}\u{92B}\u{91F}\u{949}\u{92A} \u{90F}\u{915}\u{94D}\u{938}`,
    ht: `Do kay X`,
    it: `Tetto X`,
    ja: `\u{30EB}\u{30FC}\u{30D5}\u{30C8}\u{30C3}\u{30D7}X`,
    ko: `\u{B8E8}\u{D504}\u{D0D1} X`,
    mww: `Lub ru tsev X`,
    ps: `\u{631}\u{648}\u{641}\u{67C}\u{627}\u{67E} \u{627}\u{6CC}\u{6A9}\u{633}`,
    pt: `Rooftop X`,
    'pt-pt': `Telhado X`,
    ru: `Rooftop X`,
    sm: `Taualuga X`,
    so: `Saqafka X`,
    th: `\u{E23}\u{E39}\u{E1F}\u{E17}\u{E47}\u{E2D}\u{E1B} X`,
    ur: `\u{631}\u{648}\u{641} \u{679}\u{627}\u{67E} \u{627}\u{6CC}\u{6A9}\u{633}`,
    vi: `T\u{1EA7}ng th\u{1B0}\u{1EE3}ng X`,
    'zh-hans': `\u{5C4B}\u{9876}X`,
    'zh-hant': `\u{5C4B}\u{9802}X`,
    en: `Rooftop X`
};
const $b11db1b62d4a8f76$export$2b1f8eb454fd1c67 = {
    ar: `\u{633}\u{637}\u{62D} Y`,
    de: `Decke Y`,
    es: `Azotea Y`,
    fa: `\u{67E}\u{634}\u{62A} \u{628}\u{627}\u{645} \u{648}\u{627}\u{6CC}`,
    fil: `Bubong Y`,
    fr: `Toit Y`,
    hi: `\u{930}\u{942}\u{92B}\u{91F}\u{949}\u{92A} \u{935}\u{93E}\u{908}`,
    ht: `Do-kay Y`,
    it: `Tetto Y`,
    ja: `\u{5C4B}\u{4E0A}Y`,
    ko: `\u{C625}\u{C0C1} Y`,
    mww: `Ru tsev Y`,
    ps: `\u{686}\u{62A} Y`,
    pt: `Telhado Y`,
    'pt-pt': `Telhado Y`,
    ru: `\u{41A}\u{440}\u{44B}\u{448}\u{430} Y`,
    sm: `Taualuga Y`,
    so: `Saqafka Y`,
    th: `\u{E23}\u{E39}\u{E1F}\u{E17}\u{E47}\u{E2D}\u{E1B} Y`,
    ur: `\u{686}\u{6BE}\u{62A} Y`,
    vi: `T\u{1EA7}ng th\u{1B0}\u{1EE3}ng Y`,
    'zh-hans': `\u{5C4B}\u{9876}Y\u{578B}`,
    'zh-hant': `\u{5C4B}\u{9802}Y\u{578B}`,
    en: `Rooftop Y`
};
const $b11db1b62d4a8f76$export$fe1476deb809859b = {
    ar: `\u{646}\u{641}\u{633} \u{627}\u{644}\u{634}\u{64A}\u{621} \u{643}\u{645}\u{633}\u{62A}\u{647}\u{644}\u{643} (\u{645}\u{648}\u{62C}\u{647} \u{630}\u{627}\u{62A}\u{64A}\u{627})`,
    de: `Dasselbe wie Konsument (selbstgesteuert)`,
    es: `Lo mismo que el consumidor (autodirigido)`,
    fa: `\u{647}\u{645}\u{627}\u{646}\u{646}\u{62F} \u{645}\u{635}\u{631}\u{641} \u{6A9}\u{646}\u{646}\u{62F}\u{647} (\u{62E}\u{648}\u{62F}\u{6AF}\u{631}\u{62F}\u{627}\u{646})`,
    fil: `Katulad ng mamimili (self-directed)`,
    fr: `C\u{2019}est pareil pour le consommateur (auto-dirig\xe9)`,
    hi: `\u{909}\u{92A}\u{92D}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{915}\u{947} \u{938}\u{92E}\u{93E}\u{928} (\u{938}\u{94D}\u{935}-\u{928}\u{93F}\u{930}\u{94D}\u{926}\u{947}\u{936}\u{93F}\u{924})`,
    ht: `Menm jan ak konsomat\xe8 (pw\xf2p t\xe8t ou-dirije)`,
    it: `Stessa cosa per il consumatore (autogestito)`,
    ja: `\u{6D88}\u{8CBB}\u{8005}(\u{81EA}\u{5DF1}\u{4E3B}\u{5C0E}\u{578B})\u{3068}\u{540C}\u{3058}\u{3067}\u{3059}`,
    ko: `\u{C18C}\u{BE44}\u{C790}(\u{C790}\u{C728})\u{C640} \u{B3D9}\u{C77C}\u{D569}\u{B2C8}\u{B2E4}`,
    mww: `Tib yam li tus neeg tau txais kev pab (tus kheej)`,
    ps: `\u{62F} \u{645}\u{635}\u{631}\u{641} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} (\u{62E}\u{67E}\u{644}\u{648}\u{627}\u{6A9}\u{647} \u{644}\u{627}\u{631}\u{69A}\u{648}\u{648}\u{646}\u{647}) \u{67E}\u{647} \u{685}\u{6D0}\u{631}`,
    pt: `O mesmo que o consumidor (autodirigido)`,
    'pt-pt': `O mesmo que o consumidor (autodirigido)`,
    ru: `\u{422}\u{43E} \u{436}\u{435} \u{441}\u{430}\u{43C}\u{43E}\u{435}, \u{447}\u{442}\u{43E} \u{438} \u{43F}\u{43E}\u{442}\u{440}\u{435}\u{431}\u{438}\u{442}\u{435}\u{43B}\u{44C} (\u{441}\u{430}\u{43C}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{439})`,
    sm: `E pei lava o le tagata fa'atau (fa'atonutonu e le tagata lava ia)`,
    so: `Sida macaamiisha (is-maamul)`,
    th: `\u{E40}\u{E0A}\u{E48}\u{E19}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E01}\u{E31}\u{E1A}\u{E1C}\u{E39}\u{E49}\u{E1A}\u{E23}\u{E34}\u{E42}\u{E20}\u{E04} (\u{E01}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E1A}\u{E15}\u{E19}\u{E40}\u{E2D}\u{E07})`,
    ur: `\u{635}\u{627}\u{631}\u{641} (\u{62E}\u{648}\u{62F} \u{6C1}\u{62F}\u{627}\u{6CC}\u{62A} \u{6A9}\u{627}\u{631}) \u{6A9}\u{6CC} \u{637}\u{631}\u{62D}`,
    vi: `T\u{1B0}\u{1A1}ng t\u{1EF1} nh\u{1B0} ng\u{1B0}\u{1EDD}i ti\xeau d\xf9ng (t\u{1EF1} \u{111}\u{1ECB}nh h\u{1B0}\u{1EDB}ng)`,
    'zh-hans': `\u{548C}\u{6D88}\u{8D39}\u{8005}\u{FF08}\u{81EA}\u{6211}\u{5BFC}\u{5411}\u{FF09}\u{4E00}\u{6837}`,
    'zh-hant': `\u{548C}\u{6D88}\u{8CBB}\u{8005}\u{FF08}\u{81EA}\u{6211}\u{5C0E}\u{5411}\u{FF09}\u{4E00}\u{6A23}`,
    en: `Same as consumer (self-directed)`
};
const $b11db1b62d4a8f76$export$f093e2a834170186 = {
    ar: `\u{62D}\u{641}\u{638}`,
    de: `Speichern`,
    es: `Salvar`,
    fa: `\u{630}\u{62E}\u{6CC}\u{631}\u{647}`,
    fil: `I-save`,
    fr: `Sauvegarder`,
    hi: `\u{938}\u{939}\u{947}\u{91C}\u{947}\u{902}`,
    ht: `Sove`,
    it: `Salva`,
    ja: `\u{30BB}\u{30FC}\u{30D6}`,
    ko: `\u{C800}\u{C7A5}`,
    mww: `txuag`,
    ps: `\u{698}\u{63A}\u{648}\u{631}\u{646}\u{647}`,
    pt: `Salvar`,
    'pt-pt': `Guardar`,
    ru: `\u{421}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{44C}`,
    sm: `Sefe`,
    so: `Badbaadi`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}`,
    ur: `\u{633}\u{6CC}\u{648}`,
    vi: `L\u{1B0}u`,
    'zh-hans': `\u{4FDD}\u{5B58}`,
    'zh-hant': `\u{5B58}\u{6A94}`,
    en: `Save`
};
const $b11db1b62d4a8f76$export$22c655126149ff60 = {
    ar: `\u{627}\u{62D}\u{641}\u{638} \u{648}\u{623}\u{636}\u{641} \u{622}\u{62E}\u{631}`,
    de: `Speichere und f\xfcge einen weiteren hinzu`,
    es: `Guardar y a\xf1adir otro`,
    fa: `\u{630}\u{62E}\u{6CC}\u{631}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{6CC}\u{6A9}\u{6CC} \u{62F}\u{6CC}\u{6AF}\u{631} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `I-save at magdagdag ng isa pa`,
    fr: `Sauvegarder et ajouter un autre`,
    hi: `\u{938}\u{939}\u{947}\u{91C}\u{947}\u{902} \u{914}\u{930} \u{90F}\u{915} \u{914}\u{930} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Sove & ajoute yon l\xf2t`,
    it: `Salva e aggiungine un'altra`,
    ja: `\u{4FDD}\u{5B58}\u{3057}\u{3066}\u{5225}\u{306E}\u{3082}\u{306E}\u{3092}\u{8FFD}\u{52A0}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{C800}\u{C7A5} \u{D6C4} \u{B2E4}\u{B978} \u{C0AC}\u{B78C} \u{CD94}\u{AC00}\u{D558}\u{AE30}`,
    mww: `Txuag & ntxiv lwm`,
    ps: `\u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{6A9}\u{693}\u{647} \u{627}\u{648} \u{628}\u{644} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{693}\u{647}`,
    pt: `Salvar e adicionar outro`,
    'pt-pt': `Guardar e adicionar outro`,
    ru: `\u{421}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{435} \u{438} \u{434}\u{43E}\u{431}\u{430}\u{432}\u{44C}\u{442}\u{435} \u{435}\u{449}\u{451} \u{43E}\u{434}\u{438}\u{43D}`,
    sm: `Sefe ma faaopoopo se isi`,
    so: `Kaydi oo ku dar mid kale`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E41}\u{E25}\u{E30}\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E2D}\u{E35}\u{E01}`,
    ur: `\u{645}\u{62D}\u{641}\u{648}\u{638} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{627}\u{6CC}\u{6A9} \u{627}\u{648}\u{631} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `L\u{1B0}u v\xe0 th\xeam m\u{1ED9}t`,
    'zh-hans': `\u{4FDD}\u{5B58}\u{5E76}\u{6DFB}\u{52A0}\u{53E6}\u{4E00}\u{4E2A}`,
    'zh-hant': `\u{5132}\u{5B58}\u{4E26}\u{65B0}\u{589E}\u{53E6}\u{4E00}\u{500B}`,
    en: `Save & add another`
};
const $b11db1b62d4a8f76$export$4657f281036b2f1 = {
    ar: `\u{645}\u{633}\u{648}\u{62F}\u{629} \u{627}\u{644}\u{62D}\u{641}\u{638}`,
    de: `Wehrpflicht speichern`,
    es: `Borrador de salvaci\xf3n`,
    fa: `\u{62F}\u{631}\u{641}\u{62A} \u{630}\u{62E}\u{6CC}\u{631}\u{647}`,
    fil: `I-save ang draft`,
    fr: `Draft de sauvegarde`,
    hi: `\u{921}\u{94D}\u{930}\u{93E}\u{92B}\u{94D}\u{91F} \u{938}\u{939}\u{947}\u{91C}\u{947}\u{902}`,
    ht: `Sove bouyon`,
    it: `Salvezza draft`,
    ja: `\u{30BB}\u{30FC}\u{30D6}\u{30C9}\u{30E9}\u{30D5}\u{30C8}`,
    ko: `\u{C138}\u{C774}\u{BE0C} \u{B4DC}\u{B798}\u{D504}\u{D2B8}`,
    mww: `Txuag draft`,
    ps: `\u{62F} \u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{6A9}\u{648}\u{644}\u{648} \u{645}\u{633}\u{648}\u{62F}\u{647}`,
    pt: `Salve o rascunho`,
    'pt-pt': `Draft de salvamento`,
    ru: `\u{421}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{438}\u{435} \u{447}\u{435}\u{440}\u{43D}\u{43E}\u{432}\u{438}\u{43A}\u{430}`,
    sm: `Sefe le ata`,
    so: `Save draft`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E41}\u{E1A}\u{E1A}\u{E23}\u{E48}\u{E32}\u{E07}`,
    ur: `\u{633}\u{6CC}\u{648} \u{688}\u{631}\u{627}\u{641}\u{679}`,
    vi: `L\u{1B0}u b\u{1EA3}n nh\xe1p`,
    'zh-hans': `\u{4FDD}\u{5B58}\u{9009}\u{79C0}`,
    'zh-hant': `\u{5132}\u{5B58}\u{9078}\u{79C0}`,
    en: `Save draft`
};
const $b11db1b62d4a8f76$export$4b4fd12b6177ee4b = {
    ar: `\u{633}\u{62C}\u{644} \u{627}\u{644}\u{62D}\u{641}\u{638}`,
    de: `Stundenzettel speichern`,
    es: `Hoja de horas de ahorro`,
    fa: `\u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646} \u{630}\u{62E}\u{6CC}\u{631}\u{647}`,
    fil: `I-save ang timesheet`,
    fr: `Feuille de temps \xe9conomis\xe9e`,
    hi: `\u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{938}\u{939}\u{947}\u{91C}\u{947}\u{902}`,
    ht: `Save Timesheet`,
    it: `Risparmia il foglio di tempo`,
    ja: `\u{4FDD}\u{5B58}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}`,
    ko: `\u{D0C0}\u{C784}\u{C2DC}\u{D2B8} \u{C800}\u{C7A5}`,
    mww: `Txuag daim ntawv teev sijhawm`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647} \u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{6A9}\u{693}\u{647}`,
    pt: `Folha de ponto para economizar`,
    'pt-pt': `Poupar folha de horas`,
    ru: `\u{421}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{44C} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{445}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}`,
    sm: `Sefe le pepa o taimi`,
    so: `Kaydi waqti`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}`,
    ur: `\u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{645}\u{62D}\u{641}\u{648}\u{638} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `L\u{1B0}u b\u{1EA3}ng ch\u{1EA5}m c\xf4ng`,
    'zh-hans': `\u{4FDD}\u{5B58}\u{65F6}\u{95F4}\u{8868}`,
    'zh-hant': `\u{5132}\u{5B58}\u{6642}\u{9593}\u{8868}`,
    en: `Save timesheet`
};
const $b11db1b62d4a8f76$export$71ed7fbcb5f2fe37 = {
    ar: `\u{627}\u{644}\u{62A}\u{645}\u{631}\u{64A}\u{631} \u{625}\u{644}\u{649} \u{627}\u{644}\u{623}\u{639}\u{644}\u{649}`,
    de: `Scroll nach oben`,
    es: `Despl\xe1zate hasta arriba`,
    fa: `\u{627}\u{633}\u{6A9}\u{631}\u{648}\u{644} \u{628}\u{647} \u{628}\u{627}\u{644}\u{627}`,
    fil: `Mag-scroll sa itaas`,
    fr: `D\xe9filer vers le haut`,
    hi: `\u{936}\u{940}\u{930}\u{94D}\u{937} \u{92A}\u{930} \u{938}\u{94D}\u{915}\u{94D}\u{930}\u{949}\u{932} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Scroll nan t\xe8t`,
    it: `Scorri fino in alto`,
    ja: `\u{30B9}\u{30AF}\u{30ED}\u{30FC}\u{30EB}\u{3057}\u{3066}\u{30C8}\u{30C3}\u{30D7}\u{3078}`,
    ko: `\u{B9E8} \u{C704}\u{B85C} \u{C2A4}\u{D06C}\u{B864}`,
    mww: `Scroll mus rau sab saum`,
    ps: `\u{67E}\u{648}\u{631}\u{62A}\u{647} \u{62A}\u{647} \u{633}\u{6A9}\u{631}\u{648}\u{644} \u{6A9}\u{693}\u{626}`,
    pt: `Rolar at\xe9 o topo`,
    'pt-pt': `Deslocar at\xe9 ao topo`,
    ru: `\u{41F}\u{440}\u{43E}\u{43A}\u{440}\u{443}\u{442}\u{438}\u{442}\u{435} \u{43D}\u{430}\u{432}\u{435}\u{440}\u{445}`,
    sm: `Tusi i le pito i luga`,
    so: `U rog sare`,
    th: `\u{E40}\u{E25}\u{E37}\u{E48}\u{E2D}\u{E19}\u{E44}\u{E1B}\u{E14}\u{E49}\u{E32}\u{E19}\u{E1A}\u{E19}`,
    ur: `\u{627}\u{648}\u{67E}\u{631} \u{633}\u{6A9}\u{631}\u{648}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Di chuy\u{1EC3}n l\xean \u{111}\u{1EA7}u trang`,
    'zh-hans': `\u{6EDA}\u{52A8}\u{5230}\u{9876}\u{90E8}`,
    'zh-hant': `\u{5F80}\u{4E0A}\u{6372}\u{52D5}`,
    en: `Scroll to top`
};
const $b11db1b62d4a8f76$export$cca989f3b2769926 = {
    ar: `\u{645}\u{639}\u{631}\u{641} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{64A}\u{646} SCSEP`,
    de: `SCSEP-Teilnehmer-ID`,
    es: `ID de participante SCSEP`,
    fa: `\u{634}\u{646}\u{627}\u{633}\u{647} \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647} SCSEP`,
    fil: `ID ng Kalahok ng SCSEP`,
    fr: `Identifiant participant SCSEP`,
    hi: `\u{90F}\u{938}\u{938}\u{940}\u{90F}\u{938}\u{908}\u{92A}\u{940} \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{940} \u{906}\u{908}\u{921}\u{940}`,
    ht: `ID patisipan SCSEP`,
    it: `ID partecipante SCSEP`,
    ja: `SCSEP\u{53C2}\u{52A0}\u{8005}ID`,
    ko: `SCSEP \u{CC38}\u{AC00}\u{C790} ID`,
    mww: `SCSEP Tus Neeg Koom Daim ID`,
    ps: `\u{62F} SCSEP \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644} ID`,
    pt: `ID de Participante SCSEP`,
    'pt-pt': `ID de participante SCSEP`,
    ru: `\u{418}\u{434}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{430} SCSEP`,
    sm: `SCSEP ID Tagata Auai`,
    so: `Aqoonsiga Ka-qaybgalaha SCSEP`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21} SCSEP`,
    ur: `SCSEP \u{634}\u{631}\u{6A9}\u{627}\u{621} \u{6A9}\u{6CC} \u{634}\u{646}\u{627}\u{62E}\u{62A}`,
    vi: `ID ng\u{1B0}\u{1EDD}i tham gia SCSEP`,
    'zh-hans': `SCSEP\u{53C2}\u{4E0E}\u{8005}ID`,
    'zh-hant': `SCSEP \u{53C3}\u{8207}\u{8005}\u{8B58}\u{5225}\u{78BC}`,
    en: `SCSEP Participant ID`
};
const $b11db1b62d4a8f76$export$b6fc2912e8df702f = {
    ar: `\u{627}\u{644}\u{628}\u{62D}\u{62B}`,
    de: `Suche`,
    es: `B\xfasqueda`,
    fa: `\u{62C}\u{633}\u{62A}\u{62C}\u{648}`,
    fil: `Paghahanap`,
    fr: `Recherche`,
    hi: `\u{916}\u{94B}\u{91C}`,
    ht: `Rech\xe8ch`,
    it: `Ricerca`,
    ja: `\u{691C}\u{7D22}`,
    ko: `\u{AC80}\u{C0C9}`,
    mww: `Tshawb nrhiav`,
    ps: `\u{644}\u{67C}\u{648}\u{646}`,
    pt: `Busca`,
    'pt-pt': `Pesquisa`,
    ru: `\u{41F}\u{43E}\u{438}\u{441}\u{43A}`,
    sm: `Saili`,
    so: `Raadinta`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}`,
    ur: `\u{62A}\u{644}\u{627}\u{634}`,
    vi: `T\xecm ki\u{1EBF}m`,
    'zh-hans': `\u{641C}\u{7D22}`,
    'zh-hant': `\u{641C}\u{5C0B}`,
    en: `Search`
};
const $b11db1b62d4a8f76$export$29d2183eeaae25bf = {
    ar: `\u{627}\u{644}\u{628}\u{62D}\u{62B} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{631}\u{645}\u{632} \u{623}\u{648} \u{627}\u{644}\u{648}\u{635}\u{641}`,
    de: `Suche nach Code oder Beschreibung`,
    es: `Buscar por c\xf3digo o descripci\xf3n`,
    fa: `\u{62C}\u{633}\u{62A}\u{62C}\u{648} \u{628}\u{631} \u{627}\u{633}\u{627}\u{633} \u{6A9}\u{62F} \u{6CC}\u{627} \u{62A}\u{648}\u{635}\u{6CC}\u{641}`,
    fil: `Maghanap sa pamamagitan ng code o paglalarawan`,
    fr: `Recherche par code ou description`,
    hi: `\u{915}\u{94B}\u{921} \u{92F}\u{93E} \u{935}\u{93F}\u{935}\u{930}\u{923} \u{915}\u{947} \u{906}\u{927}\u{93E}\u{930} \u{92A}\u{930} \u{916}\u{94B}\u{91C}\u{947}\u{902}`,
    ht: `Search pa k\xf2d oswa deskripsyon`,
    it: `Cerca per codice o descrizione`,
    ja: `\u{30B3}\u{30FC}\u{30C9}\u{307E}\u{305F}\u{306F}\u{8AAC}\u{660E}\u{306B}\u{3088}\u{308B}\u{691C}\u{7D22}`,
    ko: `\u{CF54}\u{B4DC} \u{B610}\u{B294} \u{C124}\u{BA85}\u{C73C}\u{B85C} \u{AC80}\u{C0C9}`,
    mww: `Tshawb nrhiav los ntawm tus lej lossis cov lus piav qhia`,
    ps: `\u{62F} \u{6A9}\u{648}\u{689} \u{6CC}\u{627} \u{62A}\u{634}\u{631}\u{6CC}\u{62D} \u{644}\u{647} \u{645}\u{62E}\u{6D0} \u{644}\u{67C}\u{648}\u{646}`,
    pt: `Busque por c\xf3digo ou descri\xe7\xe3o`,
    'pt-pt': `Pesquisa por c\xf3digo ou descri\xe7\xe3o`,
    ru: `\u{41F}\u{43E}\u{438}\u{441}\u{43A} \u{43F}\u{43E} \u{43A}\u{43E}\u{434}\u{443} \u{438}\u{43B}\u{438} \u{43E}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{44E}`,
    sm: `Saili e ala i le code po o le faamatalaga`,
    so: `Raadi koodh ama sharaxaad`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E15}\u{E32}\u{E21}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E04}\u{E4D}\u{E32}\u{E2D}\u{E18}\u{E34}\u{E1A}\u{E32}\u{E22}`,
    ur: `\u{6A9}\u{648}\u{688} \u{6CC}\u{627} \u{62A}\u{641}\u{635}\u{6CC}\u{644} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\xecm ki\u{1EBF}m theo m\xe3 ho\u{1EB7}c m\xf4 t\u{1EA3}`,
    'zh-hans': `\u{6309}\u{4EE3}\u{7801}\u{6216}\u{63CF}\u{8FF0}\u{641C}\u{7D22}`,
    'zh-hant': `\u{4F9D}\u{4EE3}\u{78BC}\u{6216}\u{63CF}\u{8FF0}\u{641C}\u{5C0B}`,
    en: `Search by code or description`
};
const $b11db1b62d4a8f76$export$27b7da156abe137b = {
    ar: `\u{627}\u{644}\u{628}\u{62D}\u{62B} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Suche nach Titel`,
    es: `Buscar por t\xedtulo`,
    fa: `\u{62C}\u{633}\u{62A}\u{62C}\u{648} \u{628}\u{631} \u{627}\u{633}\u{627}\u{633} \u{639}\u{646}\u{648}\u{627}\u{646}`,
    fil: `Maghanap ayon sa pamagat`,
    fr: `Recherche par titre`,
    hi: `\u{936}\u{940}\u{930}\u{94D}\u{937}\u{915} \u{915}\u{947} \u{906}\u{927}\u{93E}\u{930} \u{92A}\u{930} \u{916}\u{94B}\u{91C}\u{947}\u{902}`,
    ht: `Rech\xe8ch pa`,
    it: `Ricerca per titolo`,
    ja: `\u{30BF}\u{30A4}\u{30C8}\u{30EB}\u{306B}\u{3088}\u{308B}\u{691C}\u{7D22}`,
    ko: `\u{C81C}\u{BAA9}\u{BCC4} \u{AC80}\u{C0C9}`,
    mww: `Tshawb nrhiav los ntawm lub npe`,
    ps: `\u{62F} \u{633}\u{631}\u{644}\u{6CC}\u{6A9} \u{644}\u{647} \u{645}\u{62E}\u{6D0} \u{644}\u{67C}\u{648}\u{646}`,
    pt: `Busca por t\xedtulo`,
    'pt-pt': `Pesquisa por t\xedtulo`,
    ru: `\u{41F}\u{43E}\u{438}\u{441}\u{43A} \u{43F}\u{43E} \u{43D}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{438}\u{44E}`,
    sm: `Saili i le ulutala`,
    so: `Raadinta cinwaanka`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E15}\u{E32}\u{E21}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E23}\u{E37}\u{E48}\u{E2D}\u{E07}`,
    ur: `\u{639}\u{646}\u{648}\u{627}\u{646} \u{6A9}\u{6D2} \u{644}\u{62D}\u{627}\u{638} \u{633}\u{6D2} \u{62A}\u{644}\u{627}\u{634}`,
    vi: `T\xecm ki\u{1EBF}m theo ti\xeau \u{111}\u{1EC1}`,
    'zh-hans': `\u{6309}\u{6807}\u{9898}\u{641C}\u{7D22}`,
    'zh-hant': `\u{4EE5}\u{6A19}\u{984C}\u{641C}\u{5C0B}`,
    en: `Search by title`
};
const $b11db1b62d4a8f76$export$13ddb5340ae7eaf3 = {
    ar: `\u{628}\u{62D}\u{62B}...`,
    de: `Suche...`,
    es: `Buscar...`,
    fa: `\u{62C}\u{633}\u{62A}\u{62C}\u{648}...`,
    fil: `Paghahanap...`,
    fr: `Chercher...`,
    hi: `\u{916}\u{94B}\u{91C}\u{947}\u{902}...`,
    ht: `Rech\xe8ch...`,
    it: `Cerca...`,
    ja: `\u{635C}\u{7D22}...`,
    ko: `\u{C218}\u{C0C9}...`,
    mww: `Tshawb nrhiav...`,
    ps: `\u{67E}\u{644}\u{67C}\u{646}\u{647}...`,
    pt: `Procurar...`,
    'pt-pt': `Procurar...`,
    ru: `\u{41F}\u{43E}\u{438}\u{441}\u{43A}\u{438}...`,
    sm: `Su'esu'e...`,
    so: `Raadi...`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}...`,
    ur: `\u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{648}...`,
    vi: `T\xecm ki\u{1EBF}m...`,
    'zh-hans': `\u{641C}\u{7D22}......`,
    'zh-hant': `\u{641C}\u{5C0B}......`,
    en: `Search...`
};
const $b11db1b62d4a8f76$export$31273d7b8f2d8a6b = {
    ar: `\u{627}\u{628}\u{62D}\u{62B} \u{62D}\u{633}\u{628} \u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{62D}\u{62F}\u{62B} \u{623}\u{648} \u{648}\u{635}\u{641}\u{647} \u{623}\u{648} \u{627}\u{644}\u{645}\u{64A}\u{633}\u{631}.`,
    de: `Suchen Sie nach Veranstaltungstitel, Beschreibung oder Moderator.`,
    es: `Busca por t\xedtulo del evento, descripci\xf3n o facilitador.`,
    fa: `\u{628}\u{631} \u{627}\u{633}\u{627}\u{633} \u{639}\u{646}\u{648}\u{627}\u{646} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{60C} \u{62A}\u{648}\u{636}\u{6CC}\u{62D}\u{627}\u{62A} \u{6CC}\u{627} \u{62A}\u{633}\u{647}\u{6CC}\u{644} \u{6AF}\u{631} \u{62C}\u{633}\u{62A}\u{62C}\u{648} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Maghanap ayon sa pamagat ng event, paglalarawan, o facilitator.`,
    fr: `Recherchez par titre de l\u{2019}\xe9v\xe9nement, description ou animateur.`,
    hi: `\u{908}\u{935}\u{947}\u{902}\u{91F} \u{936}\u{940}\u{930}\u{94D}\u{937}\u{915}, \u{935}\u{93F}\u{935}\u{930}\u{923} \u{92F}\u{93E} \u{938}\u{941}\u{935}\u{93F}\u{927}\u{93E}\u{915}\u{930}\u{94D}\u{924}\u{93E} \u{915}\u{947} \u{906}\u{927}\u{93E}\u{930} \u{92A}\u{930} \u{916}\u{94B}\u{91C}\u{947}\u{902}\u{964}`,
    ht: `Rech\xe8ch pa ev\xe8nman, deskripsyon, oswa fasilitat\xe8`,
    it: `Cerca per titolo dell'evento, descrizione o facilitatore.`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{30BF}\u{30A4}\u{30C8}\u{30EB}\u{3001}\u{8AAC}\u{660E}\u{3001}\u{30D5}\u{30A1}\u{30B7}\u{30EA}\u{30C6}\u{30FC}\u{30BF}\u{30FC}\u{3067}\u{691C}\u{7D22}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{D589}\u{C0AC} \u{C81C}\u{BAA9}, \u{C124}\u{BA85}, \u{C9C4}\u{D589}\u{C790}\u{B85C} \u{AC80}\u{C0C9}\u{D558}\u{C138}\u{C694}.`,
    mww: `Nrhiav raws li lub npe kev tshwm sim, piav qhia, lossis tus neeg pab.`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{69A}\u{6D0} \u{633}\u{631}\u{644}\u{6CC}\u{6A9}\u{60C} \u{62A}\u{634}\u{631}\u{6CC}\u{62D}\u{60C} \u{6CC}\u{627} \u{62A}\u{633}\u{647}\u{6CC}\u{644} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{644}\u{647} \u{645}\u{62E}\u{6D0} \u{644}\u{67C}\u{648}\u{646} \u{648}\u{6A9}\u{693}\u{626}.`,
    pt: `Pesquise por t\xedtulo do evento, descri\xe7\xe3o ou facilitador.`,
    'pt-pt': `Pesquise por t\xedtulo do evento, descri\xe7\xe3o ou facilitador.`,
    ru: `\u{418}\u{449}\u{438}\u{442}\u{435} \u{43F}\u{43E} \u{43D}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{438}\u{44E} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F}, \u{43E}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{44E} \u{438}\u{43B}\u{438} \u{444}\u{430}\u{441}\u{438}\u{43B}\u{438}\u{442}\u{430}\u{442}\u{43E}\u{440}\u{443}.`,
    sm: `Saili e ala i le ulutala o le mea na tupu, faamatalaga, po o le tagata e faagaoioia.`,
    so: `Raadi cinwaanka dhacdada, sharaxaadda, ama fududeeyaha.`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E15}\u{E32}\u{E21}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21} \u{E04}\u{E4D}\u{E32}\u{E2D}\u{E18}\u{E34}\u{E1A}\u{E32}\u{E22} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E1C}\u{E39}\u{E49}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{627}\u{6CC}\u{648}\u{646}\u{679} \u{6A9}\u{6D2} \u{639}\u{646}\u{648}\u{627}\u{646}\u{60C} \u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{60C} \u{6CC}\u{627} \u{633}\u{6C1}\u{648}\u{644}\u{62A} \u{6A9}\u{627}\u{631} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `T\xecm ki\u{1EBF}m theo ti\xeau \u{111}\u{1EC1} s\u{1EF1} ki\u{1EC7}n, m\xf4 t\u{1EA3} ho\u{1EB7}c ng\u{1B0}\u{1EDD}i \u{111}i\u{1EC1}u ph\u{1ED1}i.`,
    'zh-hans': `\u{6309}\u{6D3B}\u{52A8}\u{6807}\u{9898}\u{3001}\u{63CF}\u{8FF0}\u{6216}\u{4E3B}\u{6301}\u{4EBA}\u{641C}\u{7D22}\u{3002}`,
    'zh-hant': `\u{4F9D}\u{6D3B}\u{52D5}\u{6A19}\u{984C}\u{3001}\u{63CF}\u{8FF0}\u{6216}\u{4E3B}\u{6301}\u{4EBA}\u{641C}\u{5C0B}\u{3002}`,
    en: `Search by event title, description, or facilitator.`
};
const $b11db1b62d4a8f76$export$3683b845e3e1f006 = {
    ar: (person)=>`\u{627}\u{644}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{646}\u{633}\u{62E} \u{645}\u{643}\u{631}\u{631}\u{629} ${person}`,
    de: (person)=>`Suche nach Duplikaten von ${person}`,
    es: (person)=>`B\xfasqueda de duplicados de ${person}`,
    fa: (person)=>`\u{62C}\u{633}\u{62A}\u{62C}\u{648} \u{628}\u{631}\u{627}\u{6CC} \u{646}\u{633}\u{62E}\u{647} \u{647}\u{627}\u{6CC} \u{62A}\u{6A9}\u{631}\u{627}\u{631}\u{6CC} ${person}`,
    fil: (person)=>`Hanapin ang mga kopya ng ${person}`,
    fr: (person)=>`Recherche de duplicatas de ${person}`,
    hi: (person)=>`${person} \u{915}\u{947} \u{921}\u{941}\u{92A}\u{94D}\u{932}\u{93F}\u{915}\u{947}\u{91F} \u{916}\u{94B}\u{91C}\u{947}\u{902}`,
    ht: (person)=>`Rech\xe8ch pou doublon John ${person}`,
    it: (person)=>`Ricerca di duplicati di ${person}`,
    ja: (person)=>`${person}\u{91CD}\u{8907}\u{3092}\u{63A2}\u{3059}`,
    ko: (person)=>`${person}\u{C758} \u{C911}\u{BCF5} \u{AC80}\u{C0C9}`,
    mww: (person)=>`Tshawb rau cov ntawv theej tawm ntawm ${person}`,
    ps: (person)=>`${person} \u{62F} \u{646}\u{642}\u{644}\u{648}\u{646}\u{648} \u{644}\u{67C}\u{648}\u{646}`,
    pt: (person)=>`Busca por duplicatas de ${person}`,
    'pt-pt': (person)=>`Procura por duplicados de ${person}`,
    ru: (person)=>`\u{41F}\u{43E}\u{438}\u{441}\u{43A} \u{43A}\u{43E}\u{43F}\u{438}\u{439} ${person}`,
    sm: (person)=>`Saili mo kopi o ${person}`,
    so: (person)=>`Raadinta nuqulo ${person}`,
    th: (person)=>`\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E2A}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E32}\u{E02}\u{E2D}\u{E07} ${person}`,
    ur: (person)=>`${person} \u{6A9}\u{6CC} \u{646}\u{642}\u{644}\u{6CC}\u{6BA} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: (person)=>`T\xecm ki\u{1EBF}m b\u{1EA3}n sao c\u{1EE7}a ${person}`,
    'zh-hans': (person)=>`\u{641C}\u{7D22}${person}\u{7684}\u{91CD}\u{590D}\u{7BC7}`,
    'zh-hant': (person)=>`\u{641C}\u{5C0B}${person}\u{7684}\u{91CD}\u{8907}\u{4F5C}\u{54C1}`,
    en: (person)=>`Search for duplicates of ${person}`
};
const $b11db1b62d4a8f76$export$c76e75bd8a6bfedf = {
    ar: `\u{633}\u{62C}\u{644} \u{627}\u{644}\u{628}\u{62D}\u{62B}...`,
    de: `Suchverlauf...`,
    es: `Historial de b\xfasquedas...`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{686}\u{647} \u{62C}\u{633}\u{62A}\u{62C}\u{648}...`,
    fil: `Kasaysayan ng Paghahanap ...`,
    fr: `Historique de recherche...`,
    hi: `\u{916}\u{94B}\u{91C} \u{907}\u{924}\u{93F}\u{939}\u{93E}\u{938}...`,
    ht: `Istwa rech\xe8ch...`,
    it: `Cronologia delle ricerche...`,
    ja: `\u{691C}\u{7D22}\u{5C65}\u{6B74}...`,
    ko: `\u{AC80}\u{C0C9} \u{AE30}\u{B85D}...`,
    mww: `Tshawb nrhiav keeb kwm...`,
    ps: `\u{62F} \u{644}\u{67C}\u{648}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{686}\u{647}...`,
    pt: `Hist\xf3rico de buscas...`,
    'pt-pt': `Hist\xf3rico de pesquisas...`,
    ru: `\u{418}\u{441}\u{442}\u{43E}\u{440}\u{438}\u{44F} \u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430}...`,
    sm: `Su'esu'e talafa'asolopito ...`,
    so: `Taariikhda raadinta...`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E27}\u{E31}\u{E15}\u{E34}\u{E01}\u{E32}\u{E23}\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}...`,
    ur: `\u{633}\u{631}\u{686} \u{6C1}\u{633}\u{679}\u{631}\u{6CC}...`,
    vi: `L\u{1ECB}ch s\u{1EED} t\xecm ki\u{1EBF}m...`,
    'zh-hans': `\u{641C}\u{7D22}\u{5386}\u{53F2}......`,
    'zh-hant': `\u{641C}\u{5C0B}\u{7D00}\u{9304}......`,
    en: `Search history...`
};
const $b11db1b62d4a8f76$export$75a75bf937031f1 = {
    ar: `\u{627}\u{628}\u{62D}\u{62B} \u{627}\u{644}\u{646}\u{627}\u{633}`,
    de: `Suchpersonen`,
    es: `Buscar personas`,
    fa: `\u{627}\u{641}\u{631}\u{627}\u{62F} \u{62C}\u{633}\u{62A}\u{62C}\u{648}`,
    fil: `Maghanap ng mga tao`,
    fr: `Rechercher des personnes`,
    hi: `\u{932}\u{94B}\u{917}\u{94B}\u{902} \u{915}\u{94B} \u{916}\u{94B}\u{91C}\u{947}\u{902}`,
    ht: `Ch\xe8che moun`,
    it: `Cerca persone`,
    ja: `\u{691C}\u{7D22}\u{5BFE}\u{8C61}`,
    ko: `\u{C778}\u{BB3C}\u{C744} \u{CC3E}\u{C544}`,
    mww: `Tshawb nrhiav neeg`,
    ps: `\u{62F} \u{62E}\u{644}\u{6A9}\u{648} \u{644}\u{67C}\u{648}\u{646}`,
    pt: `Pesquisar pessoas`,
    'pt-pt': `Pesquisar pessoas`,
    ru: `\u{41F}\u{43E}\u{438}\u{441}\u{43A} \u{43B}\u{44E}\u{434}\u{435}\u{439}`,
    sm: `Saili tagata`,
    so: `Raadinta dadka`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}`,
    ur: `\u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{644}\u{648}\u{6AF}`,
    vi: `T\xecm ki\u{1EBF}m m\u{1ECD}i ng\u{1B0}\u{1EDD}i`,
    'zh-hans': `\u{641C}\u{5BFB}\u{4EBA}\u{5458}`,
    'zh-hant': `\u{641C}\u{5C0B}\u{4EBA}\u{54E1}`,
    en: `Search people`
};
const $b11db1b62d4a8f76$export$853cb2674bffdf8f = {
    ar: `\u{62A}\u{623}\u{645}\u{64A}\u{646} \u{62D}\u{633}\u{627}\u{628}\u{643} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{647}\u{627}\u{62A}\u{641} (SMS)`,
    de: `Sichern Sie Ihr Konto mit Telefon (SMS)`,
    es: `Protege tu cuenta usando el tel\xe9fono (SMS)`,
    fa: `\u{62D}\u{633}\u{627}\u{628} \u{62E}\u{648}\u{62F} \u{631}\u{627} \u{628}\u{627} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{627}\u{632} \u{62A}\u{644}\u{641}\u{646} (\u{67E}\u{6CC}\u{627}\u{645}\u{6A9}) \u{627}\u{6CC}\u{645}\u{646} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `I-secure ang iyong account gamit ang Telepono (SMS)`,
    fr: `S\xe9curisez votre compte par t\xe9l\xe9phone (SMS)`,
    hi: `\u{92B}\u{93C}\u{94B}\u{928} (SMS) \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{915}\u{947} \u{905}\u{92A}\u{928}\u{93E} \u{916}\u{93E}\u{924}\u{93E} \u{938}\u{941}\u{930}\u{915}\u{94D}\u{937}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Sekirite kont ou l\xe8 l s\xe8vi av\xe8k Telef\xf2n (SMS)`,
    it: `Proteggi il tuo account tramite telefono (SMS)`,
    ja: `\u{96FB}\u{8A71}(SMS)\u{3067}\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{3092}\u{5B89}\u{5168}\u{306B}\u{4FDD}\u{3064}`,
    ko: `\u{D734}\u{B300}\u{D3F0}(SMS)\u{C73C}\u{B85C} \u{ACC4}\u{C815}\u{C744} \u{BCF4}\u{D638}\u{D558}\u{C138}\u{C694}`,
    mww: `Ruaj ntseg koj tus account siv Xov tooj (SMS)`,
    ps: `\u{62E}\u{67E}\u{644} \u{62D}\u{633}\u{627}\u{628} \u{62F} \u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646} (SMS) \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{6A9}\u{693}\u{626}`,
    pt: `Proteja sua conta usando Telefone (SMS)`,
    'pt-pt': `Proteja a sua conta atrav\xe9s do Telefone (SMS)`,
    ru: `\u{417}\u{430}\u{449}\u{438}\u{442}\u{438}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{439} \u{430}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{430} (SMS)`,
    sm: `Malupuipuia lau teuga tupe e ala i le Telefoni (SMS)`,
    so: `Sug akoonkaaga adigoo adeegsanaya Telefoonka (SMS)`,
    th: `\u{E23}\u{E31}\u{E01}\u{E29}\u{E32}\u{E04}\u{E27}\u{E32}\u{E21}\u{E1B}\u{E25}\u{E2D}\u{E14}\u{E20}\u{E31}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E01}\u{E31}\u{E1A}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E42}\u{E14}\u{E22}\u{E43}\u{E0A}\u{E49}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C} (SMS)`,
    ur: `\u{641}\u{648}\u{646} (SMS) \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{627}\u{67E}\u{646}\u{627} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{645}\u{62D}\u{641}\u{648}\u{638} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `B\u{1EA3}o m\u{1EAD}t t\xe0i kho\u{1EA3}n c\u{1EE7}a b\u{1EA1}n b\u{1EB1}ng \u{110}i\u{1EC7}n tho\u{1EA1}i (SMS)`,
    'zh-hans': `\u{4F7F}\u{7528}\u{624B}\u{673A}\u{FF08}\u{77ED}\u{4FE1}\u{FF09}\u{4FDD}\u{62A4}\u{60A8}\u{7684}\u{8D26}\u{6237}\u{5B89}\u{5168}`,
    'zh-hant': `\u{4F7F}\u{7528}\u{624B}\u{6A5F}\u{FF08}\u{7C21}\u{8A0A}\u{FF09}\u{4FDD}\u{8B77}\u{60A8}\u{7684}\u{5E33}\u{865F}`,
    en: `Secure your account using Phone (SMS)`
};
const $b11db1b62d4a8f76$export$6ce1ba6fa10570bc = {
    ar: `\u{623}\u{645}\u{646} \u{62D}\u{633}\u{627}\u{628}\u{643} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631} \u{644}\u{645}\u{631}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629} (TOTP) \u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629} \u{639}\u{644}\u{649} \u{627}\u{644}\u{648}\u{642}\u{62A}`,
    de: `Sichern Sie Ihr Konto mit dem zeitbasierten Einmalpasswort (TOTP)`,
    es: `Protege tu cuenta usando la Contrase\xf1a de Un Solo Uso Basada en el Tiempo (TOTP)`,
    fa: `\u{62D}\u{633}\u{627}\u{628} \u{62E}\u{648}\u{62F} \u{631}\u{627} \u{628}\u{627} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{627}\u{632} \u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631} \u{6CC}\u{6A9} \u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641} \u{645}\u{628}\u{62A}\u{646}\u{6CC} \u{628}\u{631} \u{632}\u{645}\u{627}\u{646} (TOTP) \u{627}\u{6CC}\u{645}\u{646} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `I-secure ang iyong account gamit ang Time-based One-Time Password (TOTP)`,
    fr: `S\xe9curisez votre compte avec un mot de passe \xe0 usage unique bas\xe9 sur le temps (TOTP)`,
    hi: `\u{938}\u{92E}\u{92F}-\u{906}\u{927}\u{93E}\u{930}\u{93F}\u{924} \u{935}\u{928}-\u{91F}\u{93E}\u{907}\u{92E} \u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} (TOTP) \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{915}\u{947} \u{905}\u{92A}\u{928}\u{93E} \u{916}\u{93E}\u{924}\u{93E} \u{938}\u{941}\u{930}\u{915}\u{94D}\u{937}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Sekirite kont ou l\xe8 l s\xe8vi av\xe8k Tan ki baze sou yon s\xe8l-fwa modpas (TOTP)`,
    it: `Proteggi il tuo account usando la Password Uni-Uso Basata sul Tempo (TOTP)`,
    ja: `\u{30BF}\u{30A4}\u{30E0}\u{30D9}\u{30FC}\u{30B9}\u{30EF}\u{30F3}\u{30BF}\u{30A4}\u{30E0}\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}(TOTP)\u{3067}\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{3092}\u{4FDD}\u{8B77}\u{3057}\u{307E}\u{3057}\u{3087}\u{3046}`,
    ko: `\u{C2DC}\u{AC04} \u{AE30}\u{BC18} \u{C77C}\u{D68C}\u{C6A9} \u{BE44}\u{BC00}\u{BC88}\u{D638}(TOTP)\u{B85C} \u{ACC4}\u{C815}\u{C744} \u{C548}\u{C804}\u{D558}\u{AC8C} \u{BCF4}\u{D638}\u{D558}\u{C138}\u{C694}`,
    mww: `Ruaj ntseg koj tus account siv Time-based One-Time Password (TOTP)`,
    ps: `\u{62E}\u{67E}\u{644} \u{62D}\u{633}\u{627}\u{628} \u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{631} \u{628}\u{646}\u{633}\u{67C} \u{6CC}\u{648} \u{681}\u{644} \u{67E}\u{627}\u{633}\u{648}\u{631}\u{689} (TOTP) \u{67E}\u{647} \u{6A9}\u{627}\u{631}\u{648}\u{644}\u{648} \u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{6A9}\u{693}\u{626}`,
    pt: `Proteja sua conta usando a Senha \xdanica Baseada em Tempo (TOTP)`,
    'pt-pt': `Proteja a sua conta usando uma palavra-passe de uso \xfanico baseada no tempo (TOTP)`,
    ru: `\u{417}\u{430}\u{449}\u{438}\u{442}\u{438}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{439} \u{430}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{43E}\u{434}\u{43D}\u{43E}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{43E}\u{433}\u{43E} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44F} \u{43D}\u{430} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} (TOTP)`,
    sm: `Fa'amautu lau teuga tupe e fa'aaoga ai le Time-Based One-Time Password (TOTP)`,
    so: `Sug akoonkaaga adigoo adeegsanaya Time-based One-Time Password (TOTP)`,
    th: `\u{E23}\u{E31}\u{E01}\u{E29}\u{E32}\u{E04}\u{E27}\u{E32}\u{E21}\u{E1B}\u{E25}\u{E2D}\u{E14}\u{E20}\u{E31}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E01}\u{E31}\u{E1A}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E42}\u{E14}\u{E22}\u{E43}\u{E0A}\u{E49}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E15}\u{E32}\u{E21}\u{E40}\u{E27}\u{E25}\u{E32} (TOTP)`,
    ur: `\u{627}\u{67E}\u{646}\u{6D2} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{6A9}\u{648} \u{679}\u{627}\u{626}\u{645} \u{628}\u{6CC}\u{633}\u{688} \u{648}\u{646} \u{679}\u{627}\u{626}\u{645} \u{67E}\u{627}\u{633} \u{648}\u{631}\u{688} (TOTP) \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{645}\u{62D}\u{641}\u{648}\u{638} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `B\u{1EA3}o m\u{1EAD}t t\xe0i kho\u{1EA3}n c\u{1EE7}a b\u{1EA1}n b\u{1EB1}ng M\u{1EAD}t kh\u{1EA9}u m\u{1ED9}t l\u{1EA7}n d\u{1EF1}a tr\xean th\u{1EDD}i gian (TOTP)`,
    'zh-hans': `\u{4F7F}\u{7528}\u{57FA}\u{4E8E}\u{65F6}\u{95F4}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{5BC6}\u{7801}\u{FF08}TOTP\u{FF09}\u{4FDD}\u{62A4}\u{60A8}\u{7684}\u{8D26}\u{6237}\u{5B89}\u{5168}`,
    'zh-hant': `\u{4F7F}\u{7528}\u{57FA}\u{65BC}\u{6642}\u{9593}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{5BC6}\u{78BC}\u{FF08}TOTP\u{FF09}\u{4FDD}\u{8B77}\u{60A8}\u{7684}\u{5E33}\u{6236}`,
    en: `Secure your account using Time-based One-Time Password (TOTP)`
};
const $b11db1b62d4a8f76$export$815d12d51263bc71 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{644}\u{63A}\u{629}`,
    de: `W\xe4hle eine Sprache aus`,
    es: `Seleccione un idioma`,
    fa: `\u{6CC}\u{6A9} \u{632}\u{628}\u{627}\u{646} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Pumili ng Wika`,
    fr: `S\xe9lectionnez une langue`,
    hi: `\u{90F}\u{915} \u{92D}\u{93E}\u{937}\u{93E} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Chwazi yon lang`,
    it: `Seleziona una lingua`,
    ja: `\u{8A00}\u{8A9E}\u{3092}\u{9078}\u{629E}\u{3059}\u{308B}`,
    ko: `\u{C5B8}\u{C5B4}\u{B97C} \u{C120}\u{D0DD}\u{D558}\u{C138}\u{C694}`,
    mww: `Xaiv ib hom lus`,
    ps: `\u{6CC}\u{648}\u{647} \u{698}\u{628}\u{647} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Selecione um idioma`,
    'pt-pt': `Selecione uma l\xedngua`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{44F}\u{437}\u{44B}\u{43A}`,
    sm: `Filifili se gagana`,
    so: `Xulo luqad`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E20}\u{E32}\u{E29}\u{E32}`,
    ur: `\u{632}\u{628}\u{627}\u{646} \u{6A9}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n ng\xf4n ng\u{1EEF}`,
    'zh-hans': `\u{9009}\u{62E9}\u{4E00}\u{79CD}\u{8BED}\u{8A00}`,
    'zh-hant': `\u{9078}\u{64C7}\u{4E00}\u{7A2E}\u{8A9E}\u{8A00}`,
    en: `Select a language`
};
const $b11db1b62d4a8f76$export$7b32e602dd1fda8d = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{62C}\u{645}\u{64A}\u{639}`,
    de: `Alle ausw\xe4hlen`,
    es: `Seleccionar todo`,
    fa: `\u{647}\u{645}\u{647} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `S\xe9lectionner tout`,
    hi: `\u{938}\u{92D}\u{940} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Chwazi tout`,
    it: `Seleziona tutti`,
    ja: `\u{3059}\u{3079}\u{3066}\u{9078}\u{629E}`,
    ko: `\u{BAA8}\u{B450} \u{C120}\u{D0DD}`,
    mww: `Xaiv tag nrho`,
    ps: `\u{67C}\u{648}\u{644} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Selecionar todos`,
    'pt-pt': `Selecionar todos`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{432}\u{441}\u{435}`,
    sm: `Filifili uma`,
    so: `Xulo dhammaan`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{633}\u{628} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n t\u{1EA5}t c\u{1EA3}`,
    'zh-hans': `\u{5168}\u{90E8}\u{9009}\u{62E9}`,
    'zh-hant': `\u{5168}\u{90E8}\u{9078}\u{64C7}`,
    en: `Select all`
};
const $b11db1b62d4a8f76$export$6f2c68acb22ba7fc = {
    ar: `(\u{627}\u{62E}\u{62A}\u{631} \u{62E}\u{62F}\u{645}\u{629})`,
    de: `(Einen Service ausw\xe4hlen)`,
    es: `(Seleccione un servicio)`,
    fa: `(\u{6CC}\u{6A9} \u{633}\u{631}\u{648}\u{6CC}\u{633} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F})`,
    fil: `(Pumili ng Serbisyo)`,
    fr: `(S\xe9lectionnez un service)`,
    hi: `(\u{90F}\u{915} \u{938}\u{947}\u{935}\u{93E} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902})`,
    ht: `(Chwazi yon s\xe8vis)`,
    it: `(Seleziona un servizio)`,
    ja: `(\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{3092}\u{9078}\u{629E}\u{3059}\u{308B})`,
    ko: `(\u{C11C}\u{BE44}\u{C2A4} \u{C120}\u{D0DD})`,
    mww: `(Xaiv ib qho kev pabcuam)`,
    ps: `(\u{62E}\u{62F}\u{645}\u{62A} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626})`,
    pt: `(Selecione um servi\xe7o)`,
    'pt-pt': `(Selecione um servi\xe7o)`,
    ru: `(\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{441}\u{43B}\u{443}\u{436}\u{431}\u{443})`,
    sm: `(Filifili se auaunaga)`,
    so: `(Xulo adeeg)`,
    th: `(\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23})`,
    ur: `(\u{633}\u{631}\u{648}\u{633} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA})`,
    vi: `(Ch\u{1ECD}n m\u{1ED9}t d\u{1ECB}ch v\u{1EE5})`,
    'zh-hans': `\u{FF08}\u{9009}\u{62E9}\u{670D}\u{52A1}\u{FF09}`,
    'zh-hant': `\u{FF08}\u{9078}\u{64C7}\u{670D}\u{52D9}\u{FF09}`,
    en: `(Select a service)`
};
const $b11db1b62d4a8f76$export$e527bc53a502a71e = {
    ar: `\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631} \u{644}\u{648}\u{62D}\u{629} \u{627}\u{644}\u{62A}\u{62D}\u{643}\u{645}`,
    de: `Dashboard ausw\xe4hlen`,
    es: `Seleccionar panel`,
    fa: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Piliin ang dashboard`,
    fr: `S\xe9lectionner tableau de bord`,
    hi: `\u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Chwazi tablodb\xf2`,
    it: `Seleziona dashboard`,
    ja: `Select\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC} \u{C120}\u{D0DD}`,
    mww: `Xaiv dashboard`,
    ps: `\u{689}\u{634}\u{628}\u{648}\u{631}\u{689} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Selecionar painel`,
    'pt-pt': `Selecionar painel`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44C} \u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Filifili le dashboard`,
    so: `Select dashboard`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}`,
    ur: `\u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n b\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n`,
    'zh-hans': `\u{9009}\u{62E9}\u{4EEA}\u{8868}\u{76D8}`,
    'zh-hant': `\u{9078}\u{64C7}\u{5100}\u{8868}\u{677F}`,
    en: `Select dashboard`
};
const $b11db1b62d4a8f76$export$28f2b51f2446468e = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{644}\u{648}\u{62D}\u{629} \u{627}\u{644}\u{62A}\u{62D}\u{643}\u{645}. \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}:`,
    de: `W\xe4hle Dashboard. Aktuell:`,
    es: `Selecciona el panel de control. Actualidad:`,
    fa: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}. \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{62C}\u{627}\u{631}\u{6CC}:`,
    fil: `Piliin ang dashboard. Kasalukuyang:`,
    fr: `S\xe9lectionnez tableau de bord. Actuel :`,
    hi: `\u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{91A}\u{941}\u{928}\u{947}\u{902}. \u{935}\u{930}\u{94D}\u{924}\u{92E}\u{93E}\u{928}:`,
    ht: `Chwazi tablodb\xf2 Akty\xe8l:`,
    it: `Seleziona dashboard. Attuali:`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3059}\u{3002}\u{73FE}\u{5728}:`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC}\u{B97C} \u{C120}\u{D0DD}\u{D558}\u{C138}\u{C694}. \u{D604}\u{C7AC}:`,
    mww: `Xaiv dashboard. Tam sim no:`,
    ps: `\u{689}\u{634}\u{628}\u{648}\u{631}\u{689} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{647}. \u{627}\u{648}\u{633}\u{646}\u{6CC}:`,
    pt: `Selecione o painel. Atual:`,
    'pt-pt': `Selecione o painel de controlo. Atual:`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{434}\u{430}\u{448}\u{431}\u{43E}\u{440}\u{434}. \u{422}\u{435}\u{43A}\u{443}\u{449}\u{430}\u{44F}:`,
    sm: `Filifili le dashboard. Taimi nei:`,
    so: `Dooro dashboard-ka. Hadda:`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14} \u{E1B}\u{E31}\u{E08}\u{E08}\u{E38}\u{E1A}\u{E31}\u{E19}:`,
    ur: `\u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4} \u{645}\u{648}\u{62C}\u{648}\u{62F}\u{6C1}:`,
    vi: `Ch\u{1ECD}n b\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n. Hi\u{1EC7}n t\u{1EA1}i:`,
    'zh-hans': `\u{9009}\u{62E9}\u{4EEA}\u{8868}\u{76D8}\u{3002}\u{73B0}\u{72B6}\u{FF1A}`,
    'zh-hant': `\u{9078}\u{64C7}\u{5100}\u{8868}\u{677F}\u{3002}\u{76EE}\u{524D}\u{FF1A}`,
    en: `Select dashboard. Current:`
};
const $b11db1b62d4a8f76$export$6f78c8f07dfb07db = {
    ar: `\u{648}\u{62B}\u{627}\u{626}\u{642} \u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`,
    de: `Ausgew\xe4hlte Dokumente`,
    es: `Documentos seleccionados`,
    fa: `\u{627}\u{633}\u{646}\u{627}\u{62F} \u{645}\u{646}\u{62A}\u{62E}\u{628}`,
    fil: `Email Address *`,
    fr: `Documents s\xe9lectionn\xe9s`,
    hi: `\u{91A}\u{92F}\u{928}\u{93F}\u{924} \u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}`,
    ht: `Chwazi dokiman yo`,
    it: `Documenti selezionati`,
    ja: `\u{4E3B}\u{306A}\u{6587}\u{66F8}`,
    ko: `\u{C120}\u{D0DD}\u{B41C} \u{BB38}\u{C11C}`,
    mww: `Cov ntaub ntawv xaiv`,
    ps: `\u{645}\u{646}\u{62A}\u{62E}\u{628} \u{627}\u{633}\u{646}\u{627}\u{62F}`,
    pt: `Documentos selecionados`,
    'pt-pt': `Documentos selecionados`,
    ru: `\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{44B}`,
    sm: `Pepa aloaia filifilia`,
    so: `Dukumentiyo la xushay`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}`,
    ur: `\u{645}\u{646}\u{62A}\u{62E}\u{628} \u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632}\u{627}\u{62A}`,
    vi: `T\xe0i li\u{1EC7}u \u{111}\u{1B0}\u{1EE3}c ch\u{1ECD}n`,
    'zh-hans': `\u{7CBE}\u{9009}\u{6587}\u{732E}`,
    'zh-hant': `\u{7CBE}\u{9078}\u{6587}\u{4EF6}`,
    en: `Selected documents`
};
const $b11db1b62d4a8f76$export$207ef50faa6f86f9 = {
    ar: `\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631} \u{627}\u{644}\u{645}\u{644}\u{641}\u{627}\u{62A}`,
    de: `Dateien ausw\xe4hlen`,
    es: `Archivos seleccionados`,
    fa: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{641}\u{627}\u{6CC}\u{644} \u{647}\u{627}`,
    fil: `Email Address *`,
    fr: `S\xe9lection de fichiers`,
    hi: `\u{92B}\u{93C}\u{93E}\u{907}\u{932}\u{94B}\u{902} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Chwazi dosye yo`,
    it: `Seleziona file`,
    ja: `\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{9078}\u{629E}`,
    ko: `\u{D30C}\u{C77C} \u{C120}\u{D0DD}`,
    mww: `Xaiv cov ntaub ntawv`,
    ps: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{641}\u{627}\u{6CC}\u{644}\u{648}\u{646}\u{647}`,
    pt: `Arquivos selecionados`,
    'pt-pt': `Ficheiros selecionados`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{444}\u{430}\u{439}\u{43B}\u{44B}`,
    sm: `Filifili faila`,
    so: `Faylasha la xushay`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E44}\u{E1F}\u{E25}\u{E4C}`,
    ur: `\u{641}\u{627}\u{626}\u{644}\u{632} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n t\u{1EC7}p`,
    'zh-hans': `\u{9009}\u{62E9}\u{6587}\u{4EF6}`,
    'zh-hant': `\u{9078}\u{64C7}\u{6A94}\u{6848}`,
    en: `Select files`
};
const $b11db1b62d4a8f76$export$d954651d35c76c4d = {
    ar: `\u{644}\u{63A}\u{629} \u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`,
    de: `Ausgew\xe4hlte Sprache`,
    es: `Idioma seleccionado`,
    fa: `\u{632}\u{628}\u{627}\u{646} \u{645}\u{646}\u{62A}\u{62E}\u{628}`,
    fil: `Pumili ng wika`,
    fr: `Langue choisie`,
    hi: `\u{92D}\u{93E}\u{937}\u{93E} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Chwazi lang`,
    it: `Linguaggio selezionato`,
    ja: `\u{8A00}\u{8A9E}\u{9078}\u{629E}`,
    ko: `\u{C120}\u{D0DD} \u{C5B8}\u{C5B4}`,
    mww: `Xaiv hom lus`,
    ps: `\u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6D0} \u{698}\u{628}\u{647}`,
    pt: `Idioma selecionado`,
    'pt-pt': `L\xedngua selecionada`,
    ru: `\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{44F}\u{437}\u{44B}\u{43A}\u{438}`,
    sm: `Filifili le gagana`,
    so: `Luuqad la xushay`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E20}\u{E32}\u{E29}\u{E32}`,
    ur: `\u{645}\u{646}\u{62A}\u{62E}\u{628} \u{632}\u{628}\u{627}\u{646}`,
    vi: `Ch\u{1ECD}n ng\xf4n ng\u{1EEF}`,
    'zh-hans': `\u{9009}\u{62E9}\u{8BED}\u{8A00}`,
    'zh-hant': `\u{9078}\u{64C7}\u{8A9E}\u{8A00}`,
    en: `Select language`
};
const $b11db1b62d4a8f76$export$7ccdf3f9358a96c4 = {
    ar: `\u{644}\u{627} \u{64A}\u{62E}\u{62A}\u{627}\u{631} \u{623}\u{64A}`,
    de: `W\xe4hle keine aus`,
    es: `No selecciones ninguno`,
    fa: `\u{647}\u{6CC}\u{686} \u{6A9}\u{62F}\u{627}\u{645} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{646}\u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Pumili ng wala`,
    fr: `Aucun n\u{2019}en s\xe9lectionner`,
    hi: `\u{915}\u{94B}\u{908} \u{928}\u{939}\u{940}\u{902} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi okenn`,
    it: `Non ne seleziona nessuno`,
    ja: `\u{9078}\u{629E}\u{306A}\u{3057}`,
    ko: `\u{C120}\u{D0DD}\u{D558}\u{C9C0} \u{C54A}\u{C74C}`,
    mww: `Xaiv tsis muaj`,
    ps: `\u{647}\u{6CC}\u{685} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{646}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Nenhuma escolha`,
    'pt-pt': `N\xe3o selecione nenhuma`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{43D}\u{438} \u{43E}\u{434}\u{43D}\u{43E}\u{433}\u{43E}`,
    sm: `Filifili se tasi`,
    so: `Xulasho midna`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{646}\u{6C1} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{646}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n kh\xf4ng c\xf3`,
    'zh-hans': `\u{9009}\u{62E9}\u{65E0}`,
    'zh-hant': `\u{9078}\u{64C7}\u{7121}`,
    en: `Select none`
};
const $b11db1b62d4a8f76$export$24bd8284d2d99ce0 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{648}\u{627}\u{62D}\u{62F}\u{627} \u{641}\u{642}\u{637}`,
    de: `W\xe4hlen Sie nur eine aus`,
    es: `Selecciona solo uno`,
    fa: `\u{641}\u{642}\u{637} \u{6CC}\u{6A9}\u{6CC} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Pumili lamang ng isa`,
    fr: `S\xe9lectionne-en un seul`,
    hi: `\u{915}\u{947}\u{935}\u{932} \u{90F}\u{915} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Chwazi s\xe8lman yon s\xe8l`,
    it: `Selezionane solo uno`,
    ja: `\u{4E00}\u{3064}\u{3060}\u{3051}\u{9078}\u{3093}\u{3067}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{D558}\u{B098}\u{B9CC} \u{C120}\u{D0DD}\u{D558}\u{C138}\u{C694}`,
    mww: `Xaiv ib qho xwb`,
    ps: `\u{6CC}\u{648}\u{627}\u{632}\u{6D0} \u{6CC}\u{648} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Selecione apenas um`,
    'pt-pt': `Selecione apenas um`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{43E}\u{434}\u{438}\u{43D}`,
    sm: `Filifili na o le tasi`,
    so: `Dooro hal qof oo kaliya`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E40}\u{E1E}\u{E35}\u{E22}\u{E07}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{635}\u{631}\u{641} \u{627}\u{6CC}\u{6A9} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EC9} ch\u{1ECD}n m\u{1ED9}t`,
    'zh-hans': `\u{53EA}\u{9009}\u{4E00}\u{4E2A}`,
    'zh-hant': `\u{53EA}\u{9078}\u{4E00}\u{500B}`,
    en: `Select only one`
};
const $b11db1b62d4a8f76$export$c87f29a6fdc46bf3 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{62D}\u{628}\u{631} \u{627}\u{644}\u{631}\u{637}\u{628}`,
    de: `W\xe4hle Nass-Tinte`,
    es: `Tinta h\xfameda Select`,
    fa: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{62C}\u{648}\u{647}\u{631} \u{645}\u{631}\u{637}\u{648}\u{628}`,
    fil: `Pumili ng basang tinta`,
    fr: `S\xe9lectionner l\u{2019}encre humide`,
    hi: `\u{917}\u{940}\u{932}\u{940} \u{938}\u{94D}\u{92F}\u{93E}\u{939}\u{940} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Chwazi lank mouye`,
    it: `Seleziona l'inchiostro umido`,
    ja: `\u{30A6}\u{30A7}\u{30C3}\u{30C8}\u{30A4}\u{30F3}\u{30AF}\u{3092}\u{9078}\u{629E}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{C2B5}\u{C2DD} \u{C789}\u{D06C} \u{C120}\u{D0DD}`,
    mww: `Xaiv tus cwj mem ntub`,
    ps: `\u{644}\u{648}\u{646}\u{62F} \u{631}\u{646}\u{6AB} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Selecione tinta \xfamida`,
    'pt-pt': `Tinta h\xfamida selecionada`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{432}\u{43B}\u{430}\u{436}\u{43D}\u{44B}\u{435} \u{447}\u{435}\u{440}\u{43D}\u{438}\u{43B}\u{430}`,
    sm: `Filifili vaitusi susu`,
    so: `Xulo khad qoyan`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E2B}\u{E21}\u{E36}\u{E01}\u{E40}\u{E1B}\u{E35}\u{E22}\u{E01}`,
    ur: `\u{648}\u{6CC}\u{679} \u{627}\u{646}\u{6A9} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n m\u{1EF1}c \u{1B0}\u{1EDB}t`,
    'zh-hans': `\u{9009}\u{62E9}\u{6E7F}\u{58A8}\u{6C34}`,
    'zh-hant': `\u{9078}\u{64C7}\u{6FD5}\u{58A8}\u{6C34}`,
    en: `Select wet ink`
};
const $b11db1b62d4a8f76$export$8c5b118cdadf3b75 = {
    ar: `\u{623}\u{631}\u{633}\u{644}\u{646}\u{64A}`,
    de: `Senden`,
    es: `Env\xeda`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644}`,
    fil: `Email Address *`,
    fr: `Envoyer`,
    hi: `\u{92D}\u{947}\u{91C}\u{947}\u{902}`,
    ht: `Voye`,
    it: `Invia`,
    ja: `\u{9001}\u{4FE1}`,
    ko: `\u{BCF4}\u{B0B4}\u{C138}\u{C694}`,
    mww: `Xa`,
    ps: `\u{648}\u{627}\u{633}\u{62A}\u{648}\u{647}`,
    pt: `Enviar`,
    'pt-pt': `Enviar`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C}`,
    sm: `Auina atu`,
    so: `Dir`,
    th: `\u{E2A}\u{E48}\u{E07}`,
    ur: `\u{628}\u{6BE}\u{6CC}\u{62C}\u{6CC}\u{6BA}`,
    vi: `G\u{1EED}i`,
    'zh-hans': `\u{53D1}\u{9001}`,
    'zh-hant': `\u{767C}\u{9001}`,
    en: `Send`
};
const $b11db1b62d4a8f76$export$795ca06633a7104a = {
    ar: `\u{623}\u{631}\u{633}\u{644}...`,
    de: `Schick...`,
    es: `Enviar...`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644}...`,
    fil: `Magpadala...`,
    fr: `Envoyer...`,
    hi: `\u{92D}\u{947}\u{91C}\u{947}\u{902}...`,
    ht: `Voye ...`,
    it: `Invia...`,
    ja: `\u{9001}\u{4FE1}...`,
    ko: `\u{BCF4}\u{B0B4}...`,
    mww: `Xa ...`,
    ps: `\u{648}\u{627}\u{633}\u{62A}\u{648}\u{647}...`,
    pt: `Enviar...`,
    'pt-pt': `Enviar...`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{44C}...`,
    sm: `Auina atu...`,
    so: `Dir...`,
    th: `\u{E2A}\u{E48}\u{E07}...`,
    ur: `\u{628}\u{6BE}\u{6CC}\u{62C}\u{648}...`,
    vi: `G\u{1EED}i...`,
    'zh-hans': `\u{53D1}\u{9001}......`,
    'zh-hant': `\u{50B3}\u{9001}......`,
    en: `Send...`
};
const $b11db1b62d4a8f76$export$c7cc0c1336c98071 = {
    ar: `\u{644}\u{645} \u{64A}\u{639}\u{62F} \u{627}\u{644}\u{645}\u{631}\u{633}\u{644} \u{646}\u{634}\u{637}\u{627} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639}.`,
    de: `Absender ist im Projekt nicht mehr aktiv.`,
    es: `El remitente ya no est\xe1 activo en el proyecto.`,
    fa: `\u{641}\u{631}\u{633}\u{62A}\u{646}\u{62F}\u{647} \u{62F}\u{6CC}\u{6AF}\u{631} \u{62F}\u{631} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{641}\u{639}\u{627}\u{644} \u{646}\u{6CC}\u{633}\u{62A}.`,
    fil: `Hindi na aktibo sa proyekto ang Tagalog.`,
    fr: `L\u{2019}exp\xe9diteur n\u{2019}est plus actif dans le projet.`,
    hi: `\u{92A}\u{94D}\u{930}\u{947}\u{937}\u{915} \u{905}\u{92C} \u{92A}\u{94D}\u{930}\u{94B}\u{91C}\u{947}\u{915}\u{94D}\u{91F} \u{92E}\u{947}\u{902} \u{938}\u{915}\u{94D}\u{930}\u{93F}\u{92F} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{964}`,
    ht: `Moun k pa aktif ank\xf2 nan pwoj\xe8 a.`,
    it: `Il mittente non \xe8 pi\xf9 attivo nel progetto.`,
    ja: `\u{9001}\u{4FE1}\u{8005}\u{306F}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{3067}\u{6D3B}\u{52D5}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{BC1C}\u{C2E0}\u{C790}\u{B294} \u{B354} \u{C774}\u{C0C1} \u{D504}\u{B85C}\u{C81D}\u{D2B8}\u{C5D0}\u{C11C} \u{D65C}\u{B3D9}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Sender tsis active nyob rau hauv qhov project lawm.`,
    ps: `\u{644}\u{6CC}\u{696}\u{648}\u{646}\u{6A9}\u{6CC} \u{646}\u{648}\u{631} \u{67E}\u{647} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{6A9}\u{6D0} \u{641}\u{639}\u{627}\u{644} \u{646}\u{647} \u{62F}\u{6CC}.`,
    pt: `O remetente n\xe3o est\xe1 mais ativo no projeto.`,
    'pt-pt': `O remetente j\xe1 n\xe3o est\xe1 ativo no projeto.`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{44C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{43D}\u{435} \u{443}\u{447}\u{430}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442} \u{432} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{435}.`,
    sm: `E le o toe toaga le tagata auina atu i le galuega faatino.`,
    so: `Sender mar dambe ma ka qaybqaato mashruuca.`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E2A}\u{E48}\u{E07}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E43}\u{E19}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E35}\u{E01}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}`,
    ur: `\u{633}\u{6CC}\u{646}\u{688}\u{631} \u{627}\u{628} \u{627}\u{633} \u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679} \u{645}\u{6CC}\u{6BA} \u{633}\u{631}\u{6AF}\u{631}\u{645} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{631}\u{6C1}\u{627}\u{6D4}`,
    vi: `Ng\u{1B0}\u{1EDD}i g\u{1EED}i kh\xf4ng c\xf2n ho\u{1EA1}t \u{111}\u{1ED9}ng trong d\u{1EF1} \xe1n.`,
    'zh-hans': `\u{53D1}\u{4EF6}\u{4EBA}\u{5DF2}\u{4E0D}\u{518D}\u{6D3B}\u{8DC3}\u{4E8E}\u{8BE5}\u{9879}\u{76EE}\u{3002}`,
    'zh-hant': `\u{5BC4}\u{4EF6}\u{4EBA}\u{5DF2}\u{4E0D}\u{518D}\u{53C3}\u{8207}\u{8A72}\u{5C08}\u{6848}\u{3002}`,
    en: `Sender no longer active in the project.`
};
const $b11db1b62d4a8f76$export$8ae1ce505b31aab6 = {
    ar: `\u{623}\u{631}\u{633}\u{644} \u{644}\u{644}\u{625}\u{643}\u{645}\u{627}\u{644}`,
    de: `Senden Sie zum Abschluss`,
    es: `Enviar para completar`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644} \u{628}\u{631}\u{627}\u{6CC} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644}`,
    fil: `Ipadala para sa pagkumpleto`,
    fr: `Envoyer pour compl\xe9tion`,
    hi: `\u{92A}\u{942}\u{930}\u{93E} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{92D}\u{947}\u{91C}\u{947}\u{902}`,
    ht: `Voye pou fini`,
    it: `Invia per il completamento`,
    ja: `\u{5B8C}\u{4E86}\u{306E}\u{305F}\u{3081}\u{306B}\u{9001}\u{4FE1}`,
    ko: `\u{C644}\u{C131}\u{C744} \u{C704}\u{D574} \u{BCF4}\u{B0B4}\u{C138}\u{C694}`,
    mww: `Xa rau kev ua tiav`,
    ps: `\u{62F} \u{628}\u{634}\u{67E}\u{693}\u{648}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{644}`,
    pt: `Envie para conclus\xe3o`,
    'pt-pt': `Enviar para conclus\xe3o`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{44C}\u{442}\u{435} \u{43D}\u{430} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Auina atu mo le faamaeaina`,
    so: `U dir dhammaystirka`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E43}\u{E2B}\u{E49}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{628}\u{6BE}\u{6CC}\u{62C}\u{6CC}\u{6BA}`,
    vi: `G\u{1EED}i \u{111}\u{1EC3} ho\xe0n th\xe0nh`,
    'zh-hans': `\u{53D1}\u{9001}\u{5B8C}\u{6210}`,
    'zh-hant': `\u{767C}\u{9001}\u{88DC}\u{5B8C}`,
    en: `Send for completion`
};
const $b11db1b62d4a8f76$export$f38f60103f92482f = {
    ar: `\u{623}\u{631}\u{633}\u{644} \u{631}\u{627}\u{628}\u{637}\u{627} \u{644}\u{634}\u{62E}\u{635} \u{645}\u{627} \u{644}\u{625}\u{646}\u{634}\u{627}\u{621} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}\u{627}.`,
    de: `Schicke jemandem einen Link, um diesen Datensatz elektronisch zu erstellen.`,
    es: `Env\xeda a alguien un enlace para crear este registro electr\xf3nicamente.`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{633}\u{627}\u{62E}\u{62A} \u{627}\u{6CC}\u{646} \u{622}\u{644}\u{628}\u{648}\u{645} \u{628}\u{647} \u{635}\u{648}\u{631}\u{62A} \u{627}\u{644}\u{6A9}\u{62A}\u{631}\u{648}\u{646}\u{6CC}\u{6A9}\u{6CC} \u{628}\u{647} \u{6A9}\u{633}\u{6CC} \u{628}\u{641}\u{631}\u{633}\u{62A}\u{6CC}\u{62F}.`,
    fil: `Magpadala ng link sa isang tao para lumikha ng rekord na ito sa elektronikong paraan.`,
    fr: `Envoyez un lien \xe0 quelqu\u{2019}un pour cr\xe9er ce dossier \xe9lectroniquement.`,
    hi: `\u{907}\u{938} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{915}\u{94B} \u{907}\u{932}\u{947}\u{915}\u{94D}\u{91F}\u{94D}\u{930}\u{949}\u{928}\u{93F}\u{915} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{92C}\u{928}\u{93E}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{93F}\u{938}\u{940} \u{915}\u{94B} \u{90F}\u{915} \u{932}\u{93F}\u{902}\u{915} \u{92D}\u{947}\u{91C}\u{947}\u{902}\u{964}`,
    ht: `Voye yon moun yon lyen pou kreye dosye sa elektwonik.`,
    it: `Invia a qualcuno un link per creare questo record elettronicamente.`,
    ja: `\u{8AB0}\u{304B}\u{306B}\u{30EA}\u{30F3}\u{30AF}\u{3092}\u{9001}\u{3063}\u{3066}\u{3001}\u{3053}\u{306E}\u{8A18}\u{9332}\u{3092}\u{96FB}\u{5B50}\u{7684}\u{306B}\u{4F5C}\u{6210}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C774} \u{AE30}\u{B85D}\u{C744} \u{C804}\u{C790}\u{C801}\u{C73C}\u{B85C} \u{B9CC}\u{B4E4} \u{C218} \u{C788}\u{B294} \u{B9C1}\u{D06C}\u{B97C} \u{B204}\u{AD70}\u{AC00}\u{C5D0}\u{AC8C} \u{BCF4}\u{B0B4}\u{C8FC}\u{C138}\u{C694}.`,
    mww: `Xa ib tus neeg txuas los tsim cov ntaub ntawv no hauv tshuab hluav taws xob.`,
    ps: `\u{686}\u{627} \u{62A}\u{647} \u{644}\u{6CC}\u{646}\u{6A9} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{647} \u{686}\u{6D0} \u{62F}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{627}\u{644}\u{6A9}\u{62A}\u{631}\u{648}\u{646}\u{6CC}\u{6A9}\u{6CC} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{6CC}.`,
    pt: `Envie um link para algu\xe9m criar esse registro eletronicamente.`,
    'pt-pt': `Envie a algu\xe9m um link para criar este registo eletronicamente.`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{44C}\u{442}\u{435} \u{43A}\u{43E}\u{43C}\u{443}-\u{43D}\u{438}\u{431}\u{443}\u{434}\u{44C} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443} \u{434}\u{43B}\u{44F} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{44F} \u{44D}\u{442}\u{43E}\u{439} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438} \u{432} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{43C} \u{432}\u{438}\u{434}\u{435}.`,
    sm: `Auina atu i se tasi se sootaga e fatu ai lenei faamaumauga faaeletonika.`,
    so: `U dir qof xiriir si uu u sameeyo rikoodhkan elektaroonik ahaan.`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E43}\u{E2B}\u{E49}\u{E1C}\u{E39}\u{E49}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E23}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E19}\u{E35}\u{E49}\u{E17}\u{E32}\u{E07}\u{E2D}\u{E34}\u{E40}\u{E25}\u{E47}\u{E01}\u{E17}\u{E23}\u{E2D}\u{E19}\u{E34}\u{E01}\u{E2A}\u{E4C}`,
    ur: `\u{6A9}\u{633}\u{6CC} \u{6A9}\u{648} \u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{648} \u{627}\u{644}\u{6CC}\u{6A9}\u{679}\u{631}\u{627}\u{646}\u{6A9} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{628}\u{646}\u{627}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{644}\u{646}\u{6A9} \u{628}\u{6BE}\u{6CC}\u{62C}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `G\u{1EED}i cho ai \u{111}\xf3 m\u{1ED9}t li\xean k\u{1EBF}t \u{111}\u{1EC3} t\u{1EA1}o b\u{1EA3}n ghi n\xe0y b\u{1EB1}ng \u{111}i\u{1EC7}n t\u{1EED}.`,
    'zh-hans': `\u{7ED9}\u{67D0}\u{4EBA}\u{53D1}\u{94FE}\u{63A5}\u{FF0C}\u{7535}\u{5B50}\u{5236}\u{4F5C}\u{8FD9}\u{4EFD}\u{8BB0}\u{5F55}\u{3002}`,
    'zh-hant': `\u{8ACB}\u{5BC4}\u{7D66}\u{67D0}\u{4EBA}\u{4E00}\u{500B}\u{9023}\u{7D50}\u{FF0C}\u{8B93}\u{4ED6}\u{80FD}\u{96FB}\u{5B50}\u{5316}\u{88FD}\u{4F5C}\u{9019}\u{4EFD}\u{7D00}\u{9304}\u{3002}`,
    en: `Send someone a link to create this record electronically.`
};
const $b11db1b62d4a8f76$export$ea478d0e3175475c = {
    ar: `\u{623}\u{631}\u{633}\u{644} \u{637}\u{644}\u{628}\u{627} \u{644}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}`,
    de: `Unterschrift schicken`,
    es: `Pide firma`,
    fa: `\u{628}\u{631}\u{627}\u{6CC} \u{627}\u{645}\u{636}\u{627} \u{627}\u{631}\u{633}\u{627}\u{644} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `Envoyez la signature`,
    hi: `\u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{92D}\u{947}\u{91C}\u{947}\u{902}`,
    ht: `Voye pou siyati`,
    it: `Mandate la firma`,
    ja: `\u{7F72}\u{540D}\u{3092}\u{4F9D}\u{983C}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{C11C}\u{BA85} \u{C694}\u{CCAD}\u{D558}\u{C138}\u{C694}`,
    mww: `Xa mus kos npe`,
    ps: `\u{62F} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{647} \u{648}\u{6A9}\u{693}\u{626}`,
    pt: `Pe\xe7a assinatura`,
    'pt-pt': `Pede assinatura`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{44C}\u{442}\u{435} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Auina atu mo le saini`,
    so: `U dir saxiix`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E02}\u{E2D}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{628}\u{6BE}\u{6CC}\u{62C}\u{6CC}\u{6BA}`,
    vi: `G\u{1EED}i ch\u{1EEF} k\xfd`,
    'zh-hans': `\u{8BF7}\u{9001}\u{7B7E}`,
    'zh-hant': `\u{8ACB}\u{7C3D}\u{540D}`,
    en: `Send for signature`
};
const $b11db1b62d4a8f76$export$e76dfe62b7986ed9 = {
    ar: `\u{623}\u{631}\u{633}\u{644} \u{631}\u{627}\u{628}\u{637}\u{627} \u{644}\u{634}\u{62E}\u{635} \u{645}\u{627} \u{644}\u{64A}\u{648}\u{642}\u{639} \u{647}\u{630}\u{627} \u{627}\u{644}\u{623}\u{644}\u{628}\u{648}\u{645} \u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}\u{627}.`,
    de: `Schick jemandem einen Link, um diesen Untergrund elektronisch zu unterschreiben.`,
    es: `Env\xeda a alguien un enlace para que firme este expediente electr\xf3nicamente.`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{627}\u{644}\u{6A9}\u{62A}\u{631}\u{648}\u{646}\u{6CC}\u{6A9}\u{6CC} \u{627}\u{6CC}\u{646} \u{622}\u{644}\u{628}\u{648}\u{645} \u{628}\u{647} \u{6A9}\u{633}\u{6CC} \u{628}\u{641}\u{631}\u{633}\u{62A}\u{6CC}\u{62F}.`,
    fil: `Magpadala ng link sa isang tao para lagdaan ang talaang ito sa elektronikong paraan.`,
    fr: `Envoyez un lien \xe0 quelqu\u{2019}un pour signer ce document \xe9lectroniquement.`,
    hi: `\u{907}\u{938} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{92A}\u{930} \u{907}\u{932}\u{947}\u{915}\u{94D}\u{91F}\u{94D}\u{930}\u{949}\u{928}\u{93F}\u{915} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{93F}\u{938}\u{940} \u{915}\u{94B} \u{90F}\u{915} \u{932}\u{93F}\u{902}\u{915} \u{92D}\u{947}\u{91C}\u{947}\u{902}\u{964}`,
    ht: `Voye yon moun yon lyen pou siyen dosye sa elektwonikman.`,
    it: `Invia a qualcuno un link per firmare questo documento elettronicamente.`,
    ja: `\u{3053}\u{306E}\u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{306B}\u{96FB}\u{5B50}\u{7684}\u{306B}\u{7F72}\u{540D}\u{3059}\u{308B}\u{305F}\u{3081}\u{306E}\u{30EA}\u{30F3}\u{30AF}\u{3092}\u{8AB0}\u{304B}\u{306B}\u{9001}\u{3063}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C774} \u{AE30}\u{B85D}\u{C5D0} \u{C804}\u{C790}\u{C801}\u{C73C}\u{B85C} \u{C11C}\u{BA85}\u{D560} \u{C218} \u{C788}\u{B294} \u{B9C1}\u{D06C}\u{B97C} \u{B204}\u{AD70}\u{AC00}\u{C5D0}\u{AC8C} \u{BCF4}\u{B0B4}\u{C8FC}\u{C138}\u{C694}.`,
    mww: `Xa ib tus neeg txuas mus kos npe rau cov ntaub ntawv no hauv tshuab hluav taws xob.`,
    ps: `\u{686}\u{627} \u{62A}\u{647} \u{644}\u{6CC}\u{646}\u{6A9} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{647} \u{686}\u{6D0} \u{62F}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{627}\u{644}\u{6A9}\u{62A}\u{631}\u{648}\u{646}\u{6CC}\u{6A9}\u{6CC} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{6A9}\u{693}\u{6CC}.`,
    pt: `Envie um link para algu\xe9m assinar esse registro eletronicamente.`,
    'pt-pt': `Envie a algu\xe9m um link para assinar este registo eletronicamente.`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{44C}\u{442}\u{435} \u{43A}\u{43E}\u{43C}\u{443}-\u{43D}\u{438}\u{431}\u{443}\u{434}\u{44C} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443} \u{434}\u{43B}\u{44F} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438} \u{44D}\u{442}\u{43E}\u{439} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}.`,
    sm: `Auina atu i se tasi se sootaga e saini faaeletonika ai lenei faamaumauga.`,
    so: `U dir qof xiriir si uu diiwaankan si elektaroonik ah u saxiixo.`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E43}\u{E2B}\u{E49}\u{E1C}\u{E39}\u{E49}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E25}\u{E07}\u{E19}\u{E32}\u{E21}\u{E43}\u{E19}\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E19}\u{E35}\u{E49}\u{E17}\u{E32}\u{E07}\u{E2D}\u{E34}\u{E40}\u{E25}\u{E47}\u{E01}\u{E17}\u{E23}\u{E2D}\u{E19}\u{E34}\u{E01}\u{E2A}\u{E4C}`,
    ur: `\u{6A9}\u{633}\u{6CC} \u{6A9}\u{648} \u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{67E}\u{631} \u{627}\u{644}\u{6CC}\u{6A9}\u{679}\u{631}\u{627}\u{646}\u{6A9} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{644}\u{646}\u{6A9} \u{628}\u{6BE}\u{6CC}\u{62C}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `G\u{1EED}i cho ai \u{111}\xf3 m\u{1ED9}t li\xean k\u{1EBF}t \u{111}\u{1EC3} k\xfd v\xe0o h\u{1ED3} s\u{1A1} n\xe0y b\u{1EB1}ng \u{111}i\u{1EC7}n t\u{1EED}.`,
    'zh-hans': `\u{7ED9}\u{67D0}\u{4EBA}\u{53D1}\u{94FE}\u{63A5}\u{FF0C}\u{7535}\u{5B50}\u{7B7E}\u{540D}\u{8FD9}\u{5F20}\u{5531}\u{7247}\u{3002}`,
    'zh-hant': `\u{8ACB}\u{5BC4}\u{9023}\u{7D50}\u{7D66}\u{67D0}\u{4EBA}\u{96FB}\u{5B50}\u{7C3D}\u{540D}\u{9019}\u{5F35}\u{7D00}\u{9304}\u{3002}`,
    en: `Send someone a link to sign this record electronically.`
};
const $b11db1b62d4a8f76$export$9a1991ee11ae922e = {
    ar: `\u{625}\u{631}\u{633}\u{627}\u{644} \u{62A}\u{639}\u{637}\u{64A}\u{644}. \u{64A}\u{62A}\u{637}\u{644}\u{628} \u{645}\u{633}\u{62A}\u{646}\u{62F} \u{623}\u{648} \u{623}\u{643}\u{62B}\u{631} \u{62A}\u{648}\u{642}\u{64A}\u{639} \u{62D}\u{628}\u{631} \u{645}\u{628}\u{644}\u{644}.`,
    de: `Senden deaktiviert. Ein oder mehrere Dokumente erfordern eine Nass-Tinten-Unterschrift.`,
    es: `Env\xedo deshabilitado. Uno o m\xe1s documentos requieren firma de tinta h\xfameda.`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644} \u{63A}\u{6CC}\u{631}\u{641}\u{639}\u{627}\u{644} \u{634}\u{62F}\u{646}. \u{6CC}\u{6A9} \u{6CC}\u{627} \u{686}\u{646}\u{62F} \u{633}\u{646}\u{62F} \u{646}\u{6CC}\u{627}\u{632} \u{628}\u{647} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{62C}\u{648}\u{647}\u{631} \u{645}\u{631}\u{637}\u{648}\u{628} \u{62F}\u{627}\u{631}\u{646}\u{62F}.`,
    fil: `Hindi pinagana ang pagpapadala. Ang isa o higit pang mga dokumento ay nangangailangan ng lagda ng wet ink.`,
    fr: `Envoi d\xe9sactiv\xe9. Un ou plusieurs documents n\xe9cessitent une signature \xe0 l\u{2019}encre humide.`,
    hi: `\u{905}\u{915}\u{94D}\u{937}\u{92E} \u{92D}\u{947}\u{91C}\u{928}\u{93E}\u{964} \u{90F}\u{915} \u{92F}\u{93E} \u{905}\u{927}\u{93F}\u{915} \u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C}\u{94B}\u{902} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{917}\u{940}\u{932}\u{940} \u{938}\u{94D}\u{92F}\u{93E}\u{939}\u{940} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{94B}\u{924}\u{940} \u{939}\u{948}\u{964}`,
    ht: `Voye enfim Youn oswa plis dokiman mande pou siyati lank mouye.`,
    it: `Invio disabilitato. Uno o pi\xf9 documenti richiedono la firma dell'inchiostro umido.`,
    ja: `\u{9001}\u{4FE1}\u{304C}\u{7121}\u{52B9}\u{3067}\u{3059}\u{3002}1\u{3064}\u{4EE5}\u{4E0A}\u{306E}\u{6587}\u{66F8}\u{306B}\u{306F}\u{30A6}\u{30A7}\u{30C3}\u{30C8}\u{30A4}\u{30F3}\u{30AF}\u{7F72}\u{540D}\u{304C}\u{5FC5}\u{8981}\u{3067}\u{3059}\u{3002}`,
    ko: `\u{C804}\u{C1A1} \u{BE44}\u{D65C}\u{C131}\u{D654}. \u{D558}\u{B098} \u{C774}\u{C0C1}\u{C758} \u{BB38}\u{C11C}\u{B294} \u{C2B5}\u{C2DD} \u{C789}\u{D06C} \u{C11C}\u{BA85}\u{C774} \u{D544}\u{C694}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Xa xiam oob qhab. Ib los yog ntau cov ntaub ntawv yuav tsum tau kos npe number case ntub dej.`,
    ps: `\u{63A}\u{6CC}\u{631} \u{641}\u{639}\u{627}\u{644} \u{644}\u{6CC}\u{696}\u{644}. \u{6CC}\u{648} \u{6CC}\u{627} \u{685}\u{648} \u{627}\u{633}\u{646}\u{627}\u{62F} \u{644}\u{648}\u{646}\u{62F} \u{631}\u{646}\u{6AB} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{62A}\u{647} \u{627}\u{693}\u{62A}\u{6CC}\u{627} \u{644}\u{631}\u{6CC}.`,
    pt: `Envio desativado. Um ou mais documentos exigem assinatura de tinta \xfamida.`,
    'pt-pt': `Envio desativado. Um ou mais documentos requerem assinatura de tinta h\xfamida.`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{430} \u{43E}\u{442}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{430}. \u{41E}\u{434}\u{438}\u{43D} \u{438}\u{43B}\u{438} \u{43D}\u{435}\u{441}\u{43A}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432} \u{442}\u{440}\u{435}\u{431}\u{443}\u{44E}\u{442} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438} \u{432}\u{43B}\u{430}\u{436}\u{43D}\u{44B}\u{43C}\u{438} \u{447}\u{435}\u{440}\u{43D}\u{438}\u{43B}\u{430}\u{43C}\u{438}.`,
    sm: `Auina atu le atoatoa. E tasi pe sili atu pepa o faamatalaga e manaomia ai le saini vaitusi susu.`,
    so: `Diritaanka waa la naafiyaday. Hal ama in ka badan dukumentiyo waxay u baahan yihiin saxiix khad qoyan.`,
    th: `\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E16}\u{E39}\u{E01}\u{E1B}\u{E34}\u{E14}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19} \u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E19}\u{E49}\u{E2D}\u{E22}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E09}\u{E1A}\u{E31}\u{E1A}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E2B}\u{E21}\u{E36}\u{E01}\u{E40}\u{E1B}\u{E35}\u{E22}\u{E01}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{641}\u{639}\u{627}\u{644} \u{628}\u{6BE}\u{6CC}\u{62C} \u{631}\u{6C1}\u{627} \u{6C1}\u{648}\u{6BA}\u{6D4} \u{627}\u{6CC}\u{6A9} \u{6CC}\u{627} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632}\u{627}\u{62A} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{6AF}\u{6CC}\u{644}\u{6CC} \u{633}\u{6CC}\u{627}\u{6C1}\u{6CC} \u{6A9}\u{6D2} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{62F}\u{631}\u{6A9}\u{627}\u{631} \u{6C1}\u{648}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `\u{110}ang g\u{1EED}i b\u{1ECB} v\xf4 hi\u{1EC7}u h\xf3a. M\u{1ED9}t ho\u{1EB7}c nhi\u{1EC1}u t\xe0i li\u{1EC7}u y\xeau c\u{1EA7}u ch\u{1EEF} k\xfd m\u{1EF1}c \u{1B0}\u{1EDB}t.`,
    'zh-hans': `\u{53D1}\u{9001}\u{88AB}\u{7981}\u{7528}\u{3002}\u{4E00}\u{4EFD}\u{6216}\u{591A}\u{4EFD}\u{6587}\u{4EF6}\u{9700}\u{8981}\u{6E7F}\u{58A8}\u{6C34}\u{7B7E}\u{540D}\u{3002}`,
    'zh-hant': `\u{50B3}\u{9001}\u{5DF2}\u{505C}\u{7528}\u{3002}\u{4E00}\u{4EFD}\u{6216}\u{591A}\u{4EFD}\u{6587}\u{4EF6}\u{9700}\u{8981}\u{6FD5}\u{58A8}\u{6C34}\u{7C3D}\u{540D}\u{3002}`,
    en: `Sending disabled. One or more documents require wet ink signature.`
};
const $b11db1b62d4a8f76$export$ca7425fc94b55c26 = {
    ar: `\u{623}\u{631}\u{633}\u{644} \u{639}\u{628}\u{631} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}`,
    de: `Per E-Mail senden`,
    es: `Enviar por correo electr\xf3nico`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644} \u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}`,
    fil: `Email:`,
    fr: `Envoyer par e-mail`,
    hi: `\u{908}\u{92E}\u{947}\u{932} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{92D}\u{947}\u{91C}\u{947}\u{902}`,
    ht: `Voye pa Im\xe8l`,
    it: `Invia via email`,
    ja: `\u{30E1}\u{30FC}\u{30EB}\u{3067}\u{9001}\u{4FE1}`,
    ko: `\u{C774}\u{BA54}\u{C77C}\u{B85C} \u{BCF4}\u{B0B4}\u{AE30}`,
    mww: `Xa ntawm Email`,
    ps: `\u{62F} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{644}`,
    pt: `Envie por e-mail`,
    'pt-pt': `Enviar por Email`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{44C}\u{442}\u{435} \u{43F}\u{43E} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{447}\u{442}\u{435}`,
    sm: `Auina atu e ala i le imeli`,
    so: `U dir email`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E17}\u{E32}\u{E07}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{628}\u{6BE}\u{6CC}\u{62C}\u{6CC}\u{6BA}`,
    vi: `G\u{1EED}i qua email`,
    'zh-hans': `\u{901A}\u{8FC7}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{53D1}\u{9001}`,
    'zh-hant': `\u{900F}\u{904E}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{767C}\u{9001}`,
    en: `Send via Email`
};
const $b11db1b62d4a8f76$export$bb196278a1e8147e = {
    ar: `\u{625}\u{631}\u{633}\u{627}\u{644} \u{639}\u{628}\u{631} \u{631}\u{633}\u{627}\u{644}\u{629} \u{646}\u{635}\u{64A}\u{629}`,
    de: `Per SMS senden`,
    es: `Enviar por mensaje de texto`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644} \u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{67E}\u{6CC}\u{627}\u{645}\u{6A9}`,
    fil: `Email: Text Message`,
    fr: `Envoyer par message texte`,
    hi: `\u{92A}\u{93E}\u{920} \u{938}\u{902}\u{926}\u{947}\u{936} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{92D}\u{947}\u{91C}\u{947}\u{902}`,
    ht: `Voye pa mesaj t\xe8ks`,
    it: `Invia via messaggio di testo`,
    ja: `\u{30C6}\u{30AD}\u{30B9}\u{30C8}\u{30E1}\u{30C3}\u{30BB}\u{30FC}\u{30B8}\u{3067}\u{9001}\u{4FE1}`,
    ko: `\u{BB38}\u{C790} \u{BA54}\u{C2DC}\u{C9C0}\u{B85C} \u{BCF4}\u{B0B4}\u{AE30}`,
    mww: `Xa los ntawm Cov Ntawv Nyeem`,
    ps: `\u{62F} \u{645}\u{62A}\u{646} \u{67E}\u{6CC}\u{63A}\u{627}\u{645} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{644}`,
    pt: `Enviar por Mensagem de Texto`,
    'pt-pt': `Enviar por Mensagem de Texto`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{447}\u{435}\u{440}\u{435}\u{437} \u{442}\u{435}\u{43A}\u{441}\u{442}\u{43E}\u{432}\u{43E}\u{435} \u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Auina atu e ala i feau tusitusia`,
    so: `Fariin qoraal ah u dir`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E17}\u{E32}\u{E07}\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}`,
    ur: `\u{679}\u{6CC}\u{6A9}\u{633}\u{679} \u{645}\u{6CC}\u{633}\u{62C} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{628}\u{6BE}\u{6CC}\u{62C}\u{6CC}\u{6BA}`,
    vi: `G\u{1EED}i qua tin nh\u{1EAF}n v\u{103}n b\u{1EA3}n`,
    'zh-hans': `\u{901A}\u{8FC7}\u{77ED}\u{4FE1}\u{53D1}\u{9001}`,
    'zh-hant': `\u{900F}\u{904E}\u{7C21}\u{8A0A}\u{767C}\u{9001}`,
    en: `Send via Text Message`
};
const $b11db1b62d4a8f76$export$8ccd6a2ee7701f03 = {
    ar: `\u{627}\u{644}\u{62E}\u{62F}\u{645}\u{629}`,
    de: `Dienst`,
    es: `Servicio`,
    fa: `\u{62E}\u{62F}\u{645}\u{62A}`,
    fil: `Serbisyo`,
    fr: `Service`,
    hi: `\u{938}\u{947}\u{935}\u{93E}`,
    ht: `S\xe8vis`,
    it: `Servizio`,
    ja: `\u{904B}\u{7528}`,
    ko: `\u{C6B4}\u{C6A9}`,
    mww: `Kev Pabcuam`,
    ps: `\u{62E}\u{62F}\u{645}\u{62A}`,
    pt: `Servi\xe7o`,
    'pt-pt': `Servi\xe7o`,
    ru: `\u{421}\u{43B}\u{443}\u{436}\u{431}\u{430}`,
    sm: `Auaunaga`,
    so: `Adeegga`,
    th: `\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{62E}\u{62F}\u{645}\u{627}\u{62A}`,
    vi: `D\u{1ECB}ch v\u{1EE5}`,
    'zh-hans': `\u{670D}\u{5F79}\u{7ECF}\u{5386}`,
    'zh-hant': `\u{670D}\u{5F79}`,
    en: `Service`
};
const $b11db1b62d4a8f76$export$f2b0a648ca23158c = {
    ar: `\u{62A}\u{641}\u{648}\u{64A}\u{636} \u{627}\u{644}\u{62E}\u{62F}\u{645}\u{629}`,
    de: `Dienstgenehmigung`,
    es: `Autorizaci\xf3n de servicio`,
    fa: `\u{645}\u{62C}\u{648}\u{632} \u{62E}\u{62F}\u{645}\u{62A}`,
    fil: `Pahintulot sa serbisyo`,
    fr: `Autorisation de service`,
    hi: `\u{938}\u{947}\u{935}\u{93E} \u{92A}\u{94D}\u{930}\u{93E}\u{927}\u{93F}\u{915}\u{930}\u{923}`,
    ht: `S\xe8vis otorizasyon`,
    it: `Autorizzazione al servizio`,
    ja: `\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{627F}\u{8A8D}`,
    ko: `\u{C11C}\u{BE44}\u{C2A4} \u{C2B9}\u{C778}`,
    mww: `Kev tso cai pabcuam`,
    ps: `\u{62F} \u{62E}\u{62F}\u{645}\u{62A} \u{627}\u{62C}\u{627}\u{632}\u{647}`,
    pt: `Autoriza\xe7\xe3o de servi\xe7o`,
    'pt-pt': `Autoriza\xe7\xe3o de servi\xe7o`,
    ru: `\u{410}\u{432}\u{442}\u{43E}\u{440}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{441}\u{435}\u{440}\u{432}\u{438}\u{441}\u{430}`,
    sm: `Faatagaga o auaunaga`,
    so: `Oggolaanshaha adeegga`,
    th: `\u{E01}\u{E32}\u{E23}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{633}\u{631}\u{648}\u{633} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A}`,
    vi: `\u{1EE6}y quy\u{1EC1}n d\u{1ECB}ch v\u{1EE5}`,
    'zh-hans': `\u{670D}\u{52A1}\u{6388}\u{6743}`,
    'zh-hant': `\u{670D}\u{52D9}\u{6388}\u{6B0A}`,
    en: `Service authorization`
};
const $b11db1b62d4a8f76$export$72b12d7c5f2fa41f = {
    ar: `\u{62A}\u{635}\u{627}\u{631}\u{64A}\u{62D} \u{627}\u{644}\u{62E}\u{62F}\u{645}\u{629}`,
    de: `Dienstgenehmigungen`,
    es: `Autorizaciones de servicio`,
    fa: `\u{645}\u{62C}\u{648}\u{632}\u{647}\u{627}\u{6CC} \u{62E}\u{62F}\u{645}\u{62A}`,
    fil: `Mga pahintulot sa serbisyo`,
    fr: `Autorisations de service`,
    hi: `\u{938}\u{947}\u{935}\u{93E} \u{92A}\u{94D}\u{930}\u{93E}\u{927}\u{93F}\u{915}\u{930}\u{923}`,
    ht: `Otorizasyon s\xe8vis yo`,
    it: `Autorizzazioni al servizio`,
    ja: `\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{627F}\u{8A8D}`,
    ko: `\u{C11C}\u{BE44}\u{C2A4} \u{C2B9}\u{C778}`,
    mww: `Kev tso cai pabcuam`,
    ps: `\u{62F} \u{62E}\u{62F}\u{645}\u{62A} \u{627}\u{62C}\u{627}\u{632}\u{6D0}`,
    pt: `Autoriza\xe7\xf5es de servi\xe7o`,
    'pt-pt': `Autoriza\xe7\xf5es de servi\xe7o`,
    ru: `\u{410}\u{432}\u{442}\u{43E}\u{440}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{43D}\u{430} \u{443}\u{441}\u{43B}\u{443}\u{433}\u{438}`,
    sm: `Fa'atagaga tautua`,
    so: `Ogolaanshaha adeegga`,
    th: `\u{E01}\u{E32}\u{E23}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{633}\u{631}\u{648}\u{633} \u{627}\u{62C}\u{627}\u{632}\u{62A}\u{6CC}\u{6BA}`,
    vi: `\u{1EE6}y quy\u{1EC1}n d\u{1ECB}ch v\u{1EE5}`,
    'zh-hans': `\u{670D}\u{5F79}\u{6388}\u{6743}`,
    'zh-hant': `\u{670D}\u{52D9}\u{6388}\u{6B0A}`,
    en: `Service authorizations`
};
const $b11db1b62d4a8f76$export$403a32688f6224ee = {
    ar: `\u{627}\u{646}\u{62A}\u{647}\u{62A} \u{627}\u{644}\u{62C}\u{644}\u{633}\u{629}`,
    de: `Die Sitzung endete`,
    es: `Sesi\xf3n finalizada`,
    fa: `\u{62C}\u{644}\u{633}\u{647} \u{628}\u{647} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{631}\u{633}\u{6CC}\u{62F}`,
    fil: `Nag-expire na ang sesyon`,
    fr: `Session expir\xe9e`,
    hi: `\u{938}\u{924}\u{94D}\u{930} \u{915}\u{940} \u{938}\u{92E}\u{92F} \u{938}\u{940}\u{92E}\u{93E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{917}\u{908}`,
    ht: `Sesyon ekspire`,
    it: `Sessione terminata`,
    ja: `\u{4F1A}\u{671F}\u{7D42}\u{4E86}`,
    ko: `\u{D68C}\u{AE30} \u{C885}\u{B8CC}`,
    mww: `Kev sib kho tas sij hawm`,
    ps: `\u{63A}\u{648}\u{646}\u{689}\u{647} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{6D0}\u{62F}\u{647}`,
    pt: `Sess\xe3o encerrada`,
    'pt-pt': `Sess\xe3o terminada`,
    ru: `\u{421}\u{435}\u{441}\u{441}\u{438}\u{44F} \u{437}\u{430}\u{43A}\u{43E}\u{43D}\u{447}\u{438}\u{43B}\u{430}\u{441}\u{44C}`,
    sm: `Ua uma le aoga o le sauniga`,
    so: `Kalfadhiga wuu dhammaaday`,
    th: `\u{E40}\u{E0B}\u{E2A}\u{E0A}\u{E31}\u{E19}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38}`,
    ur: `\u{633}\u{6CC}\u{634}\u{646} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{6AF}\u{6CC}\u{627}`,
    vi: `Phi\xean \u{111}\xe3 h\u{1EBF}t h\u{1EA1}n`,
    'zh-hans': `\u{4F1A}\u{8BAE}\u{7ED3}\u{675F}`,
    'zh-hant': `\u{6703}\u{671F}\u{5DF2}\u{7D50}\u{675F}`,
    en: `Session expired`
};
const $b11db1b62d4a8f76$export$9edf02e96340159c = {
    ar: `\u{635}\u{64A}\u{63A}\u{629} \u{627}\u{644}\u{62C}\u{644}\u{633}\u{629}`,
    de: `Sitzungsformat`,
    es: `Formato de la sesi\xf3n`,
    fa: `\u{641}\u{631}\u{645}\u{62A} \u{62C}\u{644}\u{633}\u{647}`,
    fil: `Format ng sesyon`,
    fr: `Format de la session`,
    hi: `\u{938}\u{924}\u{94D}\u{930} \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{942}\u{92A}`,
    ht: `F\xf2ma sesyon an`,
    it: `Formato della sessione`,
    ja: `\u{30BB}\u{30C3}\u{30B7}\u{30E7}\u{30F3}\u{5F62}\u{5F0F}`,
    ko: `\u{C138}\u{C158} \u{D615}\u{C2DD}`,
    mww: `Qauv kev sib tham`,
    ps: `\u{62F} \u{633}\u{6CC}\u{634}\u{646} \u{641}\u{648}\u{631}\u{645}\u{67C}`,
    pt: `Formato da sess\xe3o`,
    'pt-pt': `Formato da sess\xe3o`,
    ru: `\u{424}\u{43E}\u{440}\u{43C}\u{430}\u{442} \u{441}\u{435}\u{441}\u{441}\u{438}\u{438}`,
    sm: `Faatulagaga o le sauniga`,
    so: `Qaabka kalfadhiga`,
    th: `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E40}\u{E0B}\u{E2A}\u{E0A}\u{E31}\u{E19}`,
    ur: `\u{633}\u{6CC}\u{634}\u{646} \u{641}\u{627}\u{631}\u{645}\u{6CC}\u{679}`,
    vi: `\u{110}\u{1ECB}nh d\u{1EA1}ng phi\xean l\xe0m vi\u{1EC7}c`,
    'zh-hans': `\u{4F1A}\u{8BDD}\u{683C}\u{5F0F}`,
    'zh-hant': `\u{6703}\u{8A71}\u{5F62}\u{5F0F}`,
    en: `Session format`
};
const $b11db1b62d4a8f76$export$93c766db6ab6fc80 = {
    ar: (status)=>`${status} \u{627}\u{644}\u{62F}\u{64A}\u{643}\u{648}\u{631}`,
    de: (status)=>`${status}`,
    es: (status)=>`${status}`,
    fa: (status)=>`${status}`,
    fil: (status)=>`${status}`,
    fr: (status)=>`${status}`,
    hi: (status)=>`\u{938}\u{947}\u{91F} ${status}`,
    ht: (status)=>`${status}`,
    it: (status)=>`${status}`,
    ja: (status)=>`${status}`,
    ko: (status)=>`${status}`,
    mww: (status)=>`Teeb ${status}`,
    ps: (status)=>`\u{633}\u{6CC}\u{67C} ${status}`,
    pt: (status)=>`${status}`,
    'pt-pt': (status)=>`${status}`,
    ru: (status)=>`${status}`,
    sm: (status)=>`${status}`,
    so: (status)=>`${status}`,
    th: (status)=>`\u{E40}\u{E0B}\u{E47}\u{E15} ${status}`,
    ur: (status)=>`\u{633}\u{6CC}\u{679} ${status}`,
    vi: (status)=>`B\u{1ED9} \u{111}\xe3 ${status}`,
    'zh-hans': (status)=>`\u{5E03}\u{666F} ${status}`,
    'zh-hant': (status)=>`${status}`,
    en: (status)=>`Set ${status}`
};
const $b11db1b62d4a8f76$export$d10d41ec6043e1b1 = {
    ar: `\u{627}\u{644}\u{625}\u{639}\u{62F}\u{627}\u{62F}\u{627}\u{62A}`,
    de: `Einstellungen`,
    es: `Escenarios`,
    fa: `\u{645}\u{62D}\u{6CC}\u{637} \u{647}\u{627}`,
    fil: `Mga Setting`,
    fr: `D\xe9cors`,
    hi: `\u{938}\u{947}\u{91F}\u{93F}\u{902}\u{917}`,
    ht: `Anviw\xf2nman yo`,
    it: `Impostazioni`,
    ja: `\u{821E}\u{53F0}\u{8A2D}\u{5B9A}`,
    ko: `\u{C124}\u{C815}`,
    mww: `Cov chaw`,
    ps: `\u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{627}\u{62A}`,
    pt: `Configura\xe7\xf5es`,
    'pt-pt': `Configura\xe7\xf5es`,
    ru: `\u{41C}\u{435}\u{441}\u{442}\u{430} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    sm: `Tulaga`,
    so: `Dejinta`,
    th: `\u{E01}\u{E32}\u{E23}\u{E15}\u{E31}\u{E49}\u{E07}\u{E04}\u{E48}\u{E32}`,
    ur: `\u{633}\u{6CC}\u{679}\u{646}\u{6AF}\u{632}`,
    vi: `C\xe0i \u{111}\u{1EB7}t`,
    'zh-hans': `\u{80CC}\u{666F}\u{8BBE}\u{5B9A}`,
    'zh-hant': `\u{5834}\u{666F}\u{8A2D}\u{5B9A}`,
    en: `Settings`
};
const $b11db1b62d4a8f76$export$f679e9a796dab31c = {
    ar: `\u{627}\u{644}\u{62C}\u{646}\u{633}`,
    de: `Geschlecht`,
    es: `Sexo`,
    fa: `Sex`,
    fil: `Kasarian`,
    fr: `Sex`,
    hi: `\u{932}\u{93F}\u{902}\u{917}`,
    ht: `S\xe8ks`,
    it: `Sex`,
    ja: `\u{6027}\u{5225}`,
    ko: `\u{C131}\u{BCC4}`,
    mww: `Poj niam txiv `,
    ps: `Sex`,
    pt: `Sexo`,
    'pt-pt': `Sexo`,
    ru: `\u{41F}\u{43E}\u{43B}`,
    sm: `Feusuaiga`,
    so: `Sex`,
    th: `\u{E40}\u{E1E}\u{E28}`,
    ur: `\u{62C}\u{646}\u{633}`,
    vi: `Gi\u{1EDB}i t\xednh`,
    'zh-hans': `\u{6027}\u{522B}`,
    'zh-hant': `\u{6027}\u{5225}`,
    en: `Sex`
};
const $b11db1b62d4a8f76$export$5461db7cc7c84cd = {
    ar: `\u{627}\u{644}\u{62A}\u{648}\u{62C}\u{647} \u{627}\u{644}\u{62C}\u{646}\u{633}\u{64A}`,
    de: `Sexuelle Orientierung`,
    es: `Orientaci\xf3n sexual`,
    fa: `\u{6AF}\u{631}\u{627}\u{6CC}\u{634} \u{62C}\u{646}\u{633}\u{6CC}`,
    fil: `Sekswal na oryentasyon`,
    fr: `Orientation sexuelle`,
    hi: `\u{92F}\u{94C}\u{928} \u{905}\u{92D}\u{93F}\u{935}\u{93F}\u{928}\u{94D}\u{92F}\u{93E}\u{938}`,
    ht: `oryantasyon seksy\xe8l`,
    it: `Orientamento sessuale`,
    ja: `\u{6027}\u{7684}\u{6307}\u{5411}`,
    ko: `\u{C131}\u{C801} \u{C9C0}\u{D5A5}`,
    mww: `Kev sib deev`,
    ps: `\u{62C}\u{646}\u{633}\u{6CC} \u{62A}\u{645}\u{627}\u{6CC}\u{644}`,
    pt: `Orienta\xe7\xe3o sexual`,
    'pt-pt': `Orienta\xe7\xe3o sexual`,
    ru: `\u{421}\u{435}\u{43A}\u{441}\u{443}\u{430}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{43E}\u{440}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Fa'afeusuaiga`,
    so: `Jihada galmada`,
    th: `\u{E23}\u{E2A}\u{E19}\u{E34}\u{E22}\u{E21}\u{E17}\u{E32}\u{E07}\u{E40}\u{E1E}\u{E28}`,
    ur: `\u{62C}\u{646}\u{633}\u{6CC} \u{631}\u{62C}\u{62D}\u{627}\u{646}`,
    vi: `Khuynh h\u{1B0}\u{1EDB}ng t\xecnh d\u{1EE5}c`,
    'zh-hans': `\u{6027}\u{53D6}\u{5411}`,
    'zh-hant': `\u{6027}\u{53D6}\u{5411}`,
    en: `Sexual orientation`
};
const $b11db1b62d4a8f76$export$f5d212d89b478295 = {
    ar: `\u{633}\u{64A}\u{643}\u{648}\u{646} \u{627}\u{644}\u{631}\u{627}\u{628}\u{637} \u{627}\u{644}\u{642}\u{627}\u{628}\u{644} \u{644}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{629} \u{645}\u{62A}\u{627}\u{62D}\u{627} \u{628}\u{639}\u{62F} \u{627}\u{644}\u{62D}\u{641}\u{638}.`,
    de: `Ein teilbarer Link wird nach dem Speichern verf\xfcgbar sein.`,
    es: `El enlace compartible estar\xe1 disponible tras guardar.`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9} \u{642}\u{627}\u{628}\u{644} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6AF}\u{630}\u{627}\u{631}\u{6CC} \u{67E}\u{633} \u{627}\u{632} \u{630}\u{62E}\u{6CC}\u{631}\u{647} \u{62F}\u{631} \u{62F}\u{633}\u{62A}\u{631}\u{633} \u{62E}\u{648}\u{627}\u{647}\u{62F} \u{628}\u{648}\u{62F}.`,
    fil: `Magagamit ang shareable link pagkatapos i-save.`,
    fr: `Un lien partageable sera disponible apr\xe8s la sauvegarde.`,
    hi: `\u{938}\u{939}\u{947}\u{91C}\u{928}\u{947} \u{915}\u{947} \u{92C}\u{93E}\u{926} \u{938}\u{93E}\u{91D}\u{93E} \u{915}\u{930}\u{928}\u{947} \u{92F}\u{94B}\u{917}\u{94D}\u{92F} \u{932}\u{93F}\u{902}\u{915} \u{909}\u{92A}\u{932}\u{92C}\u{94D}\u{927} \u{939}\u{94B}\u{917}\u{93E}\u{964}`,
    ht: `Lyen pataje ap disponib apre ekonomize`,
    it: `Il link condivisibile sar\xe0 disponibile dopo aver salvato.`,
    ja: `\u{4FDD}\u{5B58}\u{5F8C}\u{3001}\u{5171}\u{6709}\u{53EF}\u{80FD}\u{306A}\u{30EA}\u{30F3}\u{30AF}\u{304C}\u{5229}\u{7528}\u{53EF}\u{80FD}\u{306B}\u{306A}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C800}\u{C7A5} \u{D6C4} \u{ACF5}\u{C720} \u{AC00}\u{B2A5}\u{D55C} \u{B9C1}\u{D06C}\u{AC00} \u{C81C}\u{ACF5}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Sib koom txuas yuav muaj tom qab khaws cia.`,
    ps: `\u{634}\u{631}\u{6CC}\u{6A9}\u{6D0}\u{62F}\u{648}\u{646}\u{6A9}\u{6CC} \u{644}\u{6CC}\u{646}\u{6A9} \u{628}\u{647} \u{62F} \u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{6A9}\u{648}\u{644}\u{648} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{647} \u{634}\u{62A}\u{648}\u{646} \u{648}\u{644}\u{631}\u{6CC}.`,
    pt: `O link compartilh\xe1vel estar\xe1 dispon\xedvel ap\xf3s salvar.`,
    'pt-pt': `Um link partilh\xe1vel estar\xe1 dispon\xedvel ap\xf3s a grava\xe7\xe3o.`,
    ru: `\u{421}\u{441}\u{44B}\u{43B}\u{43A}\u{430} \u{434}\u{43B}\u{44F} \u{43E}\u{431}\u{43C}\u{435}\u{43D}\u{430} \u{431}\u{443}\u{434}\u{435}\u{442} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430} \u{43F}\u{43E}\u{441}\u{43B}\u{435} \u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{438}\u{44F}.`,
    sm: `O le a maua le sootaga e mafai ona faasoa atu pe a uma ona faasaoina.`,
    so: `Xiriirka la wadaagi karo ayaa la heli doonaa marka la keydiyo.`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E41}\u{E0A}\u{E23}\u{E4C}\u{E44}\u{E14}\u{E49}\u{E08}\u{E30}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E2B}\u{E25}\u{E31}\u{E07}\u{E08}\u{E32}\u{E01}\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}`,
    ur: `\u{634}\u{6CC}\u{626}\u{631} \u{627}\u{6CC}\u{628}\u{644} \u{644}\u{646}\u{6A9} \u{645}\u{62D}\u{641}\u{648}\u{638} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{628}\u{639}\u{62F} \u{62F}\u{633}\u{62A}\u{6CC}\u{627}\u{628} \u{6C1}\u{648}\u{6AF}\u{627}\u{6D4}`,
    vi: `Li\xean k\u{1EBF}t c\xf3 th\u{1EC3} chia s\u{1EBB} s\u{1EBD} c\xf3 s\u{1EB5}n sau khi l\u{1B0}u.`,
    'zh-hans': `\u{4FDD}\u{5B58}\u{540E}\u{4F1A}\u{5F00}\u{653E}\u{53EF}\u{5206}\u{4EAB}\u{7684}\u{94FE}\u{63A5}\u{3002}`,
    'zh-hant': `\u{5132}\u{5B58}\u{5F8C}\u{6703}\u{958B}\u{653E}\u{53EF}\u{5206}\u{4EAB}\u{9023}\u{7D50}\u{3002}`,
    en: `Shareable link will be available after saving.`
};
const $b11db1b62d4a8f76$export$462717a398ee94f9 = {
    ar: `\u{645}\u{634}\u{627}\u{631}\u{643} \u{645}\u{639} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629}`,
    de: `Geteilt mit der Organisation`,
    es: `Compartido con la organizaci\xf3n`,
    fa: `\u{628}\u{647} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6AF}\u{630}\u{627}\u{634}\u{62A}\u{647} \u{634}\u{62F}\u{647} \u{628}\u{627} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: `Ibinahagi sa organisasyon`,
    fr: `Partag\xe9 avec l\u{2019}organisation`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{938}\u{93E}\u{91D}\u{93E} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Pataje ak \xf2ganizasyon`,
    it: `Condiviso con l'organizzazione`,
    ja: `\u{7D44}\u{7E54}\u{3068}\u{5171}\u{6709}`,
    ko: `\u{C870}\u{C9C1}\u{ACFC} \u{ACF5}\u{C720}\u{B428}`,
    mww: `Qhia rau lub koom haum`,
    ps: `\u{644}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{633}\u{631}\u{647} \u{634}\u{631}\u{6CC}\u{6A9} \u{634}\u{648}\u{6CC}`,
    pt: `Compartilhado com a organiza\xe7\xe3o`,
    'pt-pt': `Partilhado com a organiza\xe7\xe3o`,
    ru: `\u{421}\u{43E}\u{432}\u{43C}\u{435}\u{441}\u{442}\u{43D}\u{43E}\u{435} \u{441} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{435}\u{439}`,
    sm: `Fa'asoa ma le fa'alapotopotoga`,
    so: `La wadaag ururka`,
    th: `\u{E41}\u{E0A}\u{E23}\u{E4C}\u{E01}\u{E31}\u{E1A}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{634}\u{6CC}\u{626}\u{631} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `Chia s\u{1EBB} v\u{1EDB}i t\u{1ED5} ch\u{1EE9}c`,
    'zh-hans': `\u{4E0E}\u{7EC4}\u{7EC7}\u{5171}\u{4EAB}`,
    'zh-hant': `\u{8207}\u{7D44}\u{7E54}\u{5171}\u{4EAB}`,
    en: `Shared with organization`
};
const $b11db1b62d4a8f76$export$f0d24def9ad4e77b = {
    ar: (project)=>`\u{645}\u{634}\u{627}\u{631}\u{643} \u{645}\u{639} ${project}`,
    de: (project)=>`Geteilt mit ${project}`,
    es: (project)=>`Compartido con el proyecto ${project}`,
    fa: (project)=>`\u{628}\u{647} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6AF}\u{630}\u{627}\u{634}\u{62A}\u{647} \u{634}\u{62F}\u{647} \u{628}\u{627} ${project}`,
    fil: (project)=>`Ibinahagi sa proyekto ${project}`,
    fr: (project)=>`Partag\xe9 avec le projet ${project}`,
    hi: (project)=>`${project} \u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{938}\u{93E}\u{91D}\u{93E} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: (project)=>`Pataje ak ${project}`,
    it: (project)=>`Condiviso con il progetto ${project}`,
    ja: (project)=>`${project}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{3068}\u{5171}\u{6709}`,
    ko: (project)=>`${project} \u{D504}\u{B85C}\u{C81D}\u{D2B8}\u{C640} \u{ACF5}\u{C720}\u{B428}`,
    mww: (project)=>`Qhia nrog ${project} project`,
    ps: (project)=>`\u{62F} ${project} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{633}\u{631}\u{647} \u{634}\u{631}\u{6CC}\u{6A9} \u{634}\u{648}\u{6CC}`,
    pt: (project)=>`Compartilhado com o projeto ${project}`,
    'pt-pt': (project)=>`Partilhado com o projeto ${project}`,
    ru: (project)=>`\u{421}\u{43E}\u{432}\u{43C}\u{435}\u{441}\u{442}\u{43D}\u{43E} \u{441} ${project}`,
    sm: (project)=>`Fa'asoa ma ${project}`,
    so: (project)=>`La wadaagay ${project}`,
    th: (project)=>`\u{E43}\u{E0A}\u{E49}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E31}\u{E1A}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23} ${project}`,
    ur: (project)=>`${project} \u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{634}\u{6CC}\u{626}\u{631} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: (project)=>`Chia s\u{1EBB} v\u{1EDB}i d\u{1EF1} \xe1n ${project}`,
    'zh-hans': (project)=>`\u{4E0E} ${project} \u{9879}\u{76EE}\u{5171}\u{4EAB}`,
    'zh-hant': (project)=>`\u{8207} ${project} \u{5C08}\u{6848}\u{5171}\u{4EAB}`,
    en: (project)=>`Shared with ${project} project`
};
const $b11db1b62d4a8f76$export$e1839d6b7af6839 = {
    ar: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>هل ترغب في استخدام ${cumulus} لبرامج ${org} الأخرى؟</span>`,
    de: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>Möchten Sie Cumulus für andere ${org} verwenden?${cumulus}</span>`,
    es: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>¿Quieres usar ${cumulus} para otros programas ${org} ?</span>`,
    fa: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>می خواهید ${cumulus} برای برنامه های ${org} استفاده کنید؟</span>`,
    fil: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>Gusto mo bang gamitin ang ${cumulus} para sa iba pang mga programa ng ${org}</span>`,
    fr: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>Vous souhaitez utiliser ${cumulus} pour d’autres programmes ${org} ?</span>`,
    hi: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>अन्य ${org} कार्यक्रमों के लिए ${cumulus} का उपयोग करना चाहते हैं?</span>`,
    ht: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>Vle sèvi ak ${cumulus} pou lòt pwogram ${org} ?</span>`,
    it: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>Vuoi usare ${cumulus} per altri programmi ${org} ?</span>`,
    ja: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>他の${org}プログラムで${cumulus}を使いたいですか?</span>`,
    ko: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>다른 ${org} 프로그램에서 ${cumulus}를 사용하고 싶으신가요?</span>`,
    mww: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>Xav siv ${cumulus} rau lwm cov ${org} ?</span>`,
    ps: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>غواړئ ${cumulus} د نورو ${org} پروګرامونو لپاره وکاروئ؟</span>`,
    pt: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>Quer usar ${cumulus} para outros programas ${org} ?</span>`,
    'pt-pt': (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>Quer usar ${cumulus} para outros programas ${org} ?</span>`,
    ru: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>Хотите использовать ${cumulus} для других ${org} ?</span>`,
    sm: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>E te mana'o e ${cumulus} mo isi ${org}</span>`,
    so: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>Ma rabtaa inaad ${cumulus} barnaamijyada ${org} ?</span>`,
    th: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>ต้องการใช้ ${cumulus} สําหรับโปรแกรม ${org} อื่นๆ หรือไม่?</span>`,
    ur: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>کیا آپ ${cumulus} کو دوسرے ${org} پروگرامز کے لیے استعمال کرنا چاہتے ہیں؟</span>`,
    vi: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>Bạn muốn sử dụng ${cumulus} cho các chương trình ${org} khác?</span>`,
    'zh-hans': (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>想用 ${cumulus} 做其他 ${org} 项目吗？</span>`,
    'zh-hant': (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>想用 ${cumulus} 做其他 ${org} 計畫嗎？</span>`,
    en: (cumulus, org)=>$b11db1b62d4a8f76$var$html`<span>Want to use ${cumulus} for other ${org} programs?</span>`
};
const $b11db1b62d4a8f76$export$deaf0532c0f7c33c = {
    ar: `\u{627}\u{644}\u{625}\u{634}\u{627}\u{631}\u{629}`,
    de: `Zeichen`,
    es: `Signo`,
    fa: `\u{62A}\u{627}\u{628}\u{644}\u{648}`,
    fil: `Mag-sign`,
    fr: `Signe`,
    hi: `\u{938}\u{902}\u{915}\u{947}\u{924}`,
    ht: `Siy`,
    it: `Insegna`,
    ja: `\u{770B}\u{677F}`,
    ko: `\u{C9D5}\u{D6C4}`,
    mww: `kos npe`,
    ps: `\u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9}`,
    pt: `Placa`,
    'pt-pt': `Placa`,
    ru: `\u{417}\u{43D}\u{430}\u{43A}`,
    sm: `Saini`,
    so: `Calaamad`,
    th: `\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}`,
    ur: `\u{633}\u{627}\u{626}\u{646}`,
    vi: `K\xfd hi\u{1EC7}u`,
    'zh-hans': `\u{6807}\u{5FD7}`,
    'zh-hant': `\u{6A19}\u{8A8C}`,
    en: `Sign`
};
const $b11db1b62d4a8f76$export$5dfe3e64e45bfc48 = {
    ar: `\u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}`,
    de: `Signatur`,
    es: `Firma`,
    fa: `\u{627}\u{645}\u{636}\u{627}`,
    fil: `Lagda`,
    fr: `Signature`,
    hi: `\u{926}\u{938}\u{94D}\u{200D}\u{924}\u{916}\u{93C}\u{924} \u{926}\u{947}\u{916}\u{93F}\u{90F}\u{964}`,
    ht: `Siyati`,
    it: `Firma`,
    ja: `\u{7F72}\u{540D}`,
    ko: `\u{C2DC}\u{ADF8}\u{B2C8}\u{CC98}`,
    mww: `Kos Npe`,
    ps: `\u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9}`,
    pt: `Assinatura`,
    'pt-pt': `Assinatura`,
    ru: `\u{41F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Saini`,
    so: `Saxiixa`,
    th: `\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637}`,
    vi: `Ch\u{1EEF} k\xfd`,
    'zh-hans': `\u{7B7E}\u{540D}`,
    'zh-hant': `\u{7C3D}\u{540D}`,
    en: `Signature`
};
const $b11db1b62d4a8f76$export$6277c530245ba075 = {
    ar: `\u{62A}\u{645} \u{628}\u{627}\u{644}\u{641}\u{639}\u{644} \u{62A}\u{642}\u{62F}\u{64A}\u{645} \u{62A}\u{648}\u{642}\u{64A}\u{639} \u{644}\u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{624}\u{627}\u{644}. \u{644}\u{637}\u{644}\u{628} \u{62A}\u{648}\u{642}\u{64A}\u{639} \u{62C}\u{62F}\u{64A}\u{62F}\u{60C} \u{627}\u{62D}\u{630}\u{641} \u{623}\u{648}\u{644}\u{627} \u{623}\u{64A} \u{62A}\u{648}\u{642}\u{64A}\u{639}\u{627}\u{62A} \u{645}\u{648}\u{62C}\u{648}\u{62F}\u{629} \u{641}\u{64A} \u{647}\u{630}\u{627} `,
    de: `F\xfcr diese Frage wurde bereits eine Unterschrift vorgelegt. Um eine neue Signatur anzufordern, l\xf6schen Sie zun\xe4chst alle bestehenden Signaturen darin `,
    es: `Ya se ha proporcionado una firma para esta pregunta. Para solicitar una nueva firma, primero elimina cualquier firma existente en este `,
    fa: `\u{628}\u{631}\u{627}\u{6CC} \u{627}\u{6CC}\u{646} \u{633}\u{624}\u{627}\u{644} \u{642}\u{628}\u{644}\u{627} \u{627}\u{645}\u{636}\u{627}\u{6CC}\u{6CC} \u{627}\u{631}\u{627}\u{626}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{628}\u{631}\u{627}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{62C}\u{62F}\u{6CC}\u{62F}\u{60C} \u{627}\u{628}\u{62A}\u{62F}\u{627} \u{647}\u{631} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{631}\u{627} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{628}\u{62E}\u{634} \u{62D}\u{630}\u{641} \u{6A9}\u{646}\u{6CC}\u{62F} `,
    fil: `Isang lagda ang ibinigay para sa tanong na ito. Upang humiling ng bagong lagda, tanggalin muna ang anumang umiiral na lagda dito `,
    fr: `Une signature a d\xe9j\xe0 \xe9t\xe9 fournie pour cette question. Pour demander une nouvelle signature, supprimez d\u{2019}abord toutes les signatures existantes dans ce site `,
    hi: `\u{907}\u{938} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{90F}\u{915} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{92A}\u{939}\u{932}\u{947} \u{939}\u{940} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{928} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E} \u{91A}\u{941}\u{915}\u{93E} \u{939}\u{948}\u{964} \u{928}\u{90F} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{93E} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F}, \u{92A}\u{939}\u{932}\u{947} \u{907}\u{938}\u{92E}\u{947}\u{902} \u{92E}\u{94C}\u{91C}\u{942}\u{926} \u{915}\u{93F}\u{938}\u{940} \u{92D}\u{940} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{94B} \u{939}\u{91F}\u{93E} \u{926}\u{947}\u{902} `,
    ht: `Yo deja bay yon siyati pou kesyon sa a. Pou mande yon nouvo siyati, premye efase nenp\xf2t ki siyati ki deja egziste nan sa a `,
    it: `\xc8 gi\xe0 stata fornita una firma per questa domanda. Per richiedere una nuova firma, prima elimina tutte le firme esistenti in questo `,
    ja: `\u{3053}\u{306E}\u{8CEA}\u{554F}\u{306B}\u{306F}\u{3059}\u{3067}\u{306B}\u{7F72}\u{540D}\u{304C}\u{63D0}\u{4F9B}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}\u{65B0}\u{3057}\u{3044}\u{7F72}\u{540D}\u{3092}\u{8981}\u{6C42}\u{3059}\u{308B}\u{306B}\u{306F}\u{3001}\u{307E}\u{305A}\u{3053}\u{306E}\u{7F72}\u{540D}\u{5185}\u{306E}\u{65E2}\u{5B58}\u{306E}\u{7F72}\u{540D}\u{3092}\u{524A}\u{9664}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044} `,
    ko: `\u{C774} \u{C9C8}\u{BB38}\u{C5D0} \u{B300}\u{D55C} \u{C11C}\u{BA85}\u{C740} \u{C774}\u{BBF8} \u{C81C}\u{CD9C}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C0C8} \u{C11C}\u{BA85}\u{C744} \u{C694}\u{CCAD}\u{D558}\u{B824}\u{BA74} \u{BA3C}\u{C800} \u{C774} \u{C0AC}\u{C774}\u{D2B8}\u{C5D0} \u{C788}\u{B294} \u{AE30}\u{C874} \u{C11C}\u{BA85}\u{C744} \u{C0AD}\u{C81C}\u{D558}\u{C138}\u{C694} `,
    mww: `Twb tau muab ib daim ntawv kos npe rau lo lus nug no. Txhawm rau thov kev kos npe tshiab, ua ntej rho tawm cov kos npe uas twb muaj lawm hauv qhov no `,
    ps: `\u{62F} \u{62F}\u{6D0} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{6D0} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{645}\u{62E}\u{6A9}\u{6D0} \u{648}\u{631}\u{6A9}\u{693}\u{644} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}. \u{62F} \u{646}\u{648}\u{6CC} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{63A}\u{648}\u{69A}\u{62A}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647}\u{60C} \u{644}\u{648}\u{645}\u{693}\u{6CC} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647} \u{67E}\u{647} \u{62F}\u{6D0} \u{6A9}\u{6D0} \u{62D}\u{630}\u{641} \u{6A9}\u{693}\u{626} `,
    pt: `Uma assinatura j\xe1 foi fornecida para essa pergunta. Para solicitar uma nova assinatura, primeiro exclua quaisquer assinaturas existentes neste `,
    'pt-pt': `J\xe1 foi fornecida uma assinatura para esta quest\xe3o. Para solicitar uma nova assinatura, primeiro elimine quaisquer assinaturas existentes neste `,
    ru: `\u{41F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C} \u{43D}\u{430} \u{44D}\u{442}\u{43E}\u{442} \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441} \u{443}\u{436}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{430}. \u{427}\u{442}\u{43E}\u{431}\u{44B} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{438}\u{442}\u{44C} \u{43D}\u{43E}\u{432}\u{443}\u{44E} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}, \u{441}\u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{435} \u{432}\u{441}\u{435} \u{441}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{438}\u{435} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438} \u{432} \u{44D}\u{442}\u{43E}\u{439} `,
    sm: `Ua uma ona tuuina atu se saini mo lenei fesili. Ina ia talosagaina se saini fou, tape muamua soo se saini o loo i ai i lenei `,
    so: `Saxiix hore ayaa loo bixiyay su'aashan. Si aad u codsato saxiix cusub, marka hore tirtir saxiixyada hore ee ku jira `,
    th: `\u{E21}\u{E35}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E04}\u{E4D}\u{E32}\u{E16}\u{E32}\u{E21}\u{E19}\u{E35}\u{E49}\u{E41}\u{E25}\u{E49}\u{E27} \u{E2B}\u{E32}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E02}\u{E2D}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E43}\u{E2B}\u{E21}\u{E48} \u{E43}\u{E2B}\u{E49}\u{E25}\u{E1A}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E17}\u{E35}\u{E48}\u{E21}\u{E35}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E43}\u{E19}\u{E19}\u{E35}\u{E49}\u{E01}\u{E48}\u{E2D}\u{E19} `,
    ur: `\u{627}\u{633} \u{633}\u{648}\u{627}\u{644} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{67E}\u{6C1}\u{644}\u{6D2} \u{6C1}\u{6CC} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{6CC}\u{6D2} \u{62C}\u{627} \u{686}\u{6A9}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4} \u{646}\u{626}\u{6D2} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2}\u{60C} \u{67E}\u{6C1}\u{644}\u{6D2} \u{627}\u{633} \u{645}\u{6CC}\u{6BA} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{62D}\u{630}\u{641} \u{6A9}\u{631} \u{62F}\u{6CC}\u{6BA} `,
    vi: `M\u{1ED9}t ch\u{1EEF} k\xfd \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c cung c\u{1EA5}p cho c\xe2u h\u{1ECF}i n\xe0y. \u{110}\u{1EC3} y\xeau c\u{1EA7}u ch\u{1EEF} k\xfd m\u{1EDB}i, tr\u{1B0}\u{1EDB}c ti\xean h\xe3y x\xf3a m\u{1ECD}i ch\u{1EEF} k\xfd hi\u{1EC7}n c\xf3 trong `,
    'zh-hans': `\u{8FD9}\u{4E2A}\u{95EE}\u{9898}\u{5DF2}\u{7ECF}\u{6709}\u{4EBA}\u{7B7E}\u{540D}\u{4E86}\u{3002}\u{8981}\u{8BF7}\u{6C42}\u{65B0}\u{7684}\u{7B7E}\u{540D}\u{FF0C}\u{9996}\u{5148}\u{5220}\u{9664}\u{8BE5}\u{7B7E}\u{540D}\u{4E2D}\u{6240}\u{6709}\u{73B0}\u{6709}\u{7684}\u{7B7E}\u{540D} `,
    'zh-hant': `\u{6B64}\u{554F}\u{984C}\u{5DF2}\u{63D0}\u{4F9B}\u{7C3D}\u{540D}\u{3002}\u{8981}\u{7533}\u{8ACB}\u{65B0}\u{7684}\u{7C3D}\u{7AE0}\u{FF0C}\u{8ACB}\u{5148}\u{522A}\u{9664}\u{6B64}\u{4E2D}\u{6240}\u{6709}\u{73FE}\u{6709}\u{7684}\u{7C3D}\u{7AE0} `,
    en: `A signature has already been provided for this question. To request a new signature, first delete any existing signatures in this `
};
const $b11db1b62d4a8f76$export$e9238169b157a165 = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{649} \u{648}\u{62B}\u{64A}\u{642}\u{629} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}.`,
    de: `Unterschriftsdokument nicht gefunden.`,
    es: `Documento de firma no encontrado.`,
    fa: `\u{633}\u{646}\u{62F} \u{627}\u{645}\u{636}\u{627} \u{67E}\u{6CC}\u{62F}\u{627} \u{646}\u{634}\u{62F}.`,
    fil: `Hindi natagpuan ang dokumento ng lagda.`,
    fr: `Document de signature non trouv\xe9.`,
    hi: `\u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932}\u{93E}.`,
    ht: `Dokiman siyati pa jwenn`,
    it: `Documento di firma non trovato.`,
    ja: `\u{7F72}\u{540D}\u{66F8}\u{985E}\u{304C}\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C11C}\u{BA85} \u{BB38}\u{C11C}\u{B97C} \u{CC3E}\u{C9C0} \u{BABB}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Daim ntawv kos npe tsis pom.`,
    ps: `\u{62F} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{633}\u{646}\u{62F} \u{646}\u{647} \u{62F}\u{6CC} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{634}\u{648}\u{6CC}.`,
    pt: `Documento de assinatura n\xe3o encontrado.`,
    'pt-pt': `Documento de assinatura n\xe3o encontrado.`,
    ru: `\u{414}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442} \u{441} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}\u{44E} \u{43D}\u{435} \u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}.`,
    sm: `E le o maua le pepa o faamatalaga o le saini.`,
    so: `Dukumentiga saxiixa lama helin.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637}\u{6CC} \u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{644}\u{6CC}\u{6D4}`,
    vi: `Kh\xf4ng t\xecm th\u{1EA5}y t\xe0i li\u{1EC7}u ch\u{1EEF} k\xfd.`,
    'zh-hans': `\u{627E}\u{4E0D}\u{5230}\u{7B7E}\u{540D}\u{6587}\u{4EF6}\u{3002}`,
    'zh-hant': `\u{627E}\u{4E0D}\u{5230}\u{7C3D}\u{540D}\u{6587}\u{4EF6}\u{3002}`,
    en: `Signature document not found.`
};
const $b11db1b62d4a8f76$export$bfbd4dde5c6712ef = {
    ar: `\u{633}\u{64A}\u{646}\u{62A}\u{647}\u{64A} \u{635}\u{644}\u{627}\u{62D}\u{64A}\u{629} \u{631}\u{627}\u{628}\u{637} \u{627}\u{644}\u{646}\u{645}\u{648}\u{630}\u{62C} \u{628}\u{639}\u{62F} 7 \u{623}\u{64A}\u{627}\u{645}. \u{623}\u{64A} \u{634}\u{62E}\u{635} \u{64A}\u{633}\u{62A}\u{644}\u{645} \u{627}\u{644}\u{631}\u{627}\u{628}\u{637} \u{633}\u{64A}\u{62A}\u{645}\u{643}\u{646} \u{645}\u{646} \u{627}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{649} \u{627}\u{644}\u{646}\u{645}\u{648}\u{630}\u{62C} \u{62D}\u{62A}\u{649} \u{64A}\u{646}\u{62A}\u{647}\u{64A} \u{635}\u{644}\u{627}\u{62D}\u{64A}\u{62A}\u{647} \u{623}\u{648} \u{64A}\u{643}\u{645}\u{644}.`,
    de: `Der Link zum Formular l\xe4uft nach 7 Tagen ab. Jeder, der den Link erh\xe4lt, kann auf das Formular zugreifen, bis es abl\xe4uft oder ausgef\xfcllt ist.`,
    es: `El enlace al formulario caducar\xe1 despu\xe9s de 7 d\xedas. Cualquiera que reciba el enlace podr\xe1 acceder al formulario hasta que expire o se complete.`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9} \u{641}\u{631}\u{645} \u{67E}\u{633} \u{627}\u{632} \u{6F7} \u{631}\u{648}\u{632} \u{645}\u{646}\u{642}\u{636}\u{6CC} \u{645}\u{6CC} \u{634}\u{648}\u{62F}. \u{647}\u{631} \u{6A9}\u{633}\u{6CC} \u{6A9}\u{647} \u{644}\u{6CC}\u{646}\u{6A9} \u{631}\u{627} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{646}\u{62F}\u{60C} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{62A}\u{627} \u{632}\u{645}\u{627}\u{646} \u{627}\u{646}\u{642}\u{636}\u{627} \u{6CC}\u{627} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{641}\u{631}\u{645} \u{628}\u{647} \u{622}\u{646} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{62F}\u{627}\u{634}\u{62A}\u{647} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: `Ang link sa form ay mag-e-expire pagkatapos ng 7 araw. Ang sinumang makakatanggap ng link ay maaaring ma-access ang form hanggang sa mag-expire ito o makumpleto.`,
    fr: `Le lien vers le formulaire expirera apr\xe8s 7 jours. Toute personne recevant le lien pourra acc\xe9der au formulaire jusqu\u{2019}\xe0 son expiration ou sa remplissage.`,
    hi: `\u{92B}\u{949}\u{930}\u{94D}\u{92E} \u{915}\u{93E} \u{932}\u{93F}\u{902}\u{915} 7 \u{926}\u{93F}\u{928}\u{94B}\u{902} \u{915}\u{947} \u{92C}\u{93E}\u{926} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{91C}\u{93E}\u{90F}\u{917}\u{93E}\u{964} \u{932}\u{93F}\u{902}\u{915} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{930}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{93E} \u{915}\u{94B}\u{908} \u{92D}\u{940} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F} \u{92B}\u{949}\u{930}\u{94D}\u{92E} \u{915}\u{94B} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B}\u{928}\u{947} \u{92F}\u{93E} \u{92A}\u{942}\u{930}\u{93E} \u{939}\u{94B}\u{928}\u{947} \u{924}\u{915} \u{90F}\u{915}\u{94D}\u{938}\u{947}\u{938} \u{915}\u{930} \u{938}\u{915}\u{947}\u{917}\u{93E}\u{964}`,
    ht: `Lyen ki mennen nan f\xf2m nan ap ekspire apre 7 jou. Nenp\xf2t moun k ap resevwa lyen an ap kapab jwenn aks\xe8 nan f\xf2m lan jiskaske li ekspire oswa fini.`,
    it: `Il link al modulo scade dopo 7 giorni. Chiunque riceva il link potr\xe0 accedere al modulo fino alla sua scadenza o completamento.`,
    ja: `\u{30D5}\u{30A9}\u{30FC}\u{30E0}\u{3078}\u{306E}\u{30EA}\u{30F3}\u{30AF}\u{306F}7\u{65E5}\u{5F8C}\u{306B}\u{671F}\u{9650}\u{5207}\u{308C}\u{306B}\u{306A}\u{308A}\u{307E}\u{3059}\u{3002}\u{30EA}\u{30F3}\u{30AF}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{3063}\u{305F}\u{4EBA}\u{306F}\u{3001}\u{30D5}\u{30A9}\u{30FC}\u{30E0}\u{304C}\u{6709}\u{52B9}\u{671F}\u{9650}\u{306B}\u{306A}\u{308B}\u{304B}\u{5B8C}\u{4E86}\u{3059}\u{308B}\u{307E}\u{3067}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C591}\u{C2DD} \u{B9C1}\u{D06C}\u{B294} 7\u{C77C} \u{D6C4}\u{C5D0} \u{B9CC}\u{B8CC}\u{B429}\u{B2C8}\u{B2E4}. \u{B9C1}\u{D06C}\u{B97C} \u{BC1B}\u{C740} \u{C0AC}\u{B78C}\u{C740} \u{C591}\u{C2DD}\u{C774} \u{B9CC}\u{B8CC}\u{B418}\u{AC70}\u{B098} \u{C644}\u{B8CC}\u{B420} \u{B54C}\u{AE4C}\u{C9C0} \u{C811}\u{ADFC}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov txuas rau daim foos yuav tas sij hawm tom qab 7 hnub. Txhua tus neeg uas tau txais qhov txuas yuav tuaj yeem nkag mus rau daim foos kom txog thaum nws tas sijhawm lossis ua tiav.`,
    ps: `\u{62F} \u{641}\u{648}\u{631}\u{645} \u{644}\u{6CC}\u{646}\u{6A9} \u{628}\u{647} \u{644}\u{647} \u{6F7} \u{648}\u{631}\u{681}\u{648} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{647} \u{62E}\u{62A}\u{645} \u{634}\u{6CC}. \u{647}\u{631} \u{685}\u{648}\u{6A9} \u{686}\u{6D0} \u{644}\u{6CC}\u{646}\u{6A9} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{693}\u{6CC}\u{60C} \u{6A9}\u{648}\u{644}\u{6CC} \u{634}\u{6CC} \u{641}\u{648}\u{631}\u{645}\u{647} \u{62A}\u{631} \u{647}\u{63A}\u{647} \u{648}\u{62E}\u{62A}\u{647} \u{648}\u{6AB}\u{648}\u{631}\u{6CC} \u{686}\u{6D0} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{6CC}\u{696}\u{6CC} \u{6CC}\u{627} \u{628}\u{634}\u{67E}\u{693} \u{634}\u{6CC}.`,
    pt: `O link para o formul\xe1rio expirar\xe1 ap\xf3s 7 dias. Qualquer pessoa que receber o link poder\xe1 acessar o formul\xe1rio at\xe9 que ele expire ou seja preenchido.`,
    'pt-pt': `O link para o formul\xe1rio expira ap\xf3s 7 dias. Qualquer pessoa que receba o link poder\xe1 aceder ao formul\xe1rio at\xe9 expirar ou ser preenchido.`,
    ru: `\u{421}\u{441}\u{44B}\u{43B}\u{43A}\u{430} \u{43D}\u{430} \u{444}\u{43E}\u{440}\u{43C}\u{443} \u{438}\u{441}\u{442}\u{435}\u{447}\u{451}\u{442} \u{447}\u{435}\u{440}\u{435}\u{437} 7 \u{434}\u{43D}\u{435}\u{439}. \u{41B}\u{44E}\u{431}\u{43E}\u{439}, \u{43A}\u{442}\u{43E} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443}, \u{441}\u{43C}\u{43E}\u{436}\u{435}\u{442} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{43A} \u{444}\u{43E}\u{440}\u{43C}\u{435} \u{434}\u{43E} \u{435}\u{451} \u{438}\u{441}\u{442}\u{435}\u{447}\u{435}\u{43D}\u{438}\u{44F} \u{441}\u{440}\u{43E}\u{43A}\u{430} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{438}\u{43B}\u{438} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F}.`,
    sm: `O le feso'ota'iga i le fomu o le a fa'amutaina pe a mae'a le 7 aso. So'o se tasi e mauaina le feso'ota'iga o le a mafai ona maua le fomu se'ia mae'a pe fa'amae'aina.`,
    so: `Xiriirka foomka wuxuu dhacayaa 7 maalmood kadib. Qof kasta oo helaya link-ka wuxuu heli karaa foomka ilaa uu dhaco ama la dhammeeyo.`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E44}\u{E1B}\u{E22}\u{E31}\u{E07}\u{E41}\u{E1A}\u{E1A}\u{E1F}\u{E2D}\u{E23}\u{E4C}\u{E21}\u{E08}\u{E30}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38}\u{E2B}\u{E25}\u{E31}\u{E07}\u{E08}\u{E32}\u{E01} 7 \u{E27}\u{E31}\u{E19} \u{E17}\u{E38}\u{E01}\u{E04}\u{E19}\u{E17}\u{E35}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E08}\u{E30}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E41}\u{E1A}\u{E1A}\u{E1F}\u{E2D}\u{E23}\u{E4C}\u{E21}\u{E44}\u{E14}\u{E49}\u{E08}\u{E19}\u{E01}\u{E27}\u{E48}\u{E32}\u{E08}\u{E30}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{641}\u{627}\u{631}\u{645} \u{6A9}\u{627} \u{644}\u{646}\u{6A9} 7 \u{62F}\u{646} \u{628}\u{639}\u{62F} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{62C}\u{627}\u{626}\u{6D2} \u{6AF}\u{627}\u{6D4} \u{62C}\u{648} \u{628}\u{6BE}\u{6CC} \u{644}\u{646}\u{6A9} \u{648}\u{635}\u{648}\u{644} \u{6A9}\u{631}\u{6D2} \u{6AF}\u{627}\u{60C} \u{648}\u{6C1} \u{641}\u{627}\u{631}\u{645} \u{62A}\u{6A9} \u{627}\u{633} \u{648}\u{642}\u{62A} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{631} \u{633}\u{6A9}\u{6D2} \u{6AF}\u{627} \u{62C}\u{628} \u{62A}\u{6A9} \u{6CC}\u{6C1} \u{62E}\u{62A}\u{645} \u{646}\u{6C1} \u{6C1}\u{648} \u{62C}\u{627}\u{626}\u{6D2} \u{6CC}\u{627} \u{645}\u{6A9}\u{645}\u{644} \u{646}\u{6C1} \u{6C1}\u{648} \u{62C}\u{627}\u{626}\u{6D2}\u{6D4}`,
    vi: `Li\xean k\u{1EBF}t \u{111}\u{1EBF}n bi\u{1EC3}u m\u{1EAB}u s\u{1EBD} h\u{1EBF}t h\u{1EA1}n sau 7 ng\xe0y. B\u{1EA5}t k\u{1EF3} ai nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c li\xean k\u{1EBF}t s\u{1EBD} c\xf3 th\u{1EC3} truy c\u{1EAD}p bi\u{1EC3}u m\u{1EAB}u cho \u{111}\u{1EBF}n khi n\xf3 h\u{1EBF}t h\u{1EA1}n ho\u{1EB7}c ho\xe0n th\xe0nh.`,
    'zh-hans': `\u{8868}\u{683C}\u{94FE}\u{63A5}\u{5C06}\u{5728}7\u{5929}\u{540E}\u{5931}\u{6548}\u{3002}\u{6536}\u{5230}\u{94FE}\u{63A5}\u{7684}\u{4EBA}\u{90FD}\u{53EF}\u{4EE5}\u{8BBF}\u{95EE}\u{8BE5}\u{8868}\u{683C}\u{FF0C}\u{76F4}\u{5230}\u{8868}\u{683C}\u{8FC7}\u{671F}\u{6216}\u{586B}\u{5199}\u{5B8C}\u{6BD5}\u{3002}`,
    'zh-hant': `\u{8868}\u{683C}\u{9023}\u{7D50}\u{5C07}\u{65BC}7\u{5929}\u{5F8C}\u{5931}\u{6548}\u{3002}\u{4EFB}\u{4F55}\u{6536}\u{5230}\u{9023}\u{7D50}\u{7684}\u{4EBA}\u{90FD}\u{80FD}\u{5B58}\u{53D6}\u{8A72}\u{8868}\u{683C}\u{FF0C}\u{76F4}\u{5230}\u{8868}\u{683C}\u{904E}\u{671F}\u{6216}\u{5B8C}\u{6210}\u{70BA}\u{6B62}\u{3002}`,
    en: `The link to the form will expire after 7 days. Anyone receiving the link will be able to access the form until it expires or is completed.`
};
const $b11db1b62d4a8f76$export$41a9ee080c52dfb4 = {
    ar: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} أرسل لك هذا النموذج لتوقيعه. راجع المعلومات أدناه <a href="#sign-button">ووقع في الأسفل</a>. إذا كان لديك أسئلة، تواصل ${senderGivenName} عبر البريد الإلكتروني <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. ستنتهي صلاحية هذا النموذج ${expires}`,
    de: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} hat Ihnen dieses Formular zum Unterschreiben geschickt. Lesen Sie die untenstehenden Informationen und <a href="#sign-button">unterschreiben Sie unten</a>. Wenn Sie Fragen haben, kontaktieren ${senderGivenName} per E-Mail unter <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Dieses Formular läuft ${expires}`,
    es: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} te envió este formulario para que firmes. Revisa la información de abajo y <a href="#sign-button">firma al final</a>. Si tienes preguntas, contacta ${senderGivenName} por correo electrónico <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulario caducará ${expires}`,
    fa: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} این فرم را برای امضا فرستاد. اطلاعات زیر را مرور کنید و <a href="#sign-button">در پایین امضا</a> کنید. اگر سوالی دارید، از طریق ایمیل با ${senderGivenName} به <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> تماس بگیرید. این فرم ${expires} منقضی خواهد شد.`,
    fil: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`Ipinadala sa iyo ${senderName} ang form na ito upang pirmahan. Suriin ang impormasyon sa ibaba at <a href="#sign-button">mag-sign sa ibaba</a>. Kung mayroon kang mga katanungan, makipag-ugnay kay ${senderGivenName} sa pamamagitan ng email sa <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Ang form na ito ay mag-e-expire ${expires}`,
    fr: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} t’a envoyé ce formulaire à signer. Consultez les informations ci-dessous et <a href="#sign-button">signez en bas</a>. Si vous avez des questions, contactez ${senderGivenName} par email à <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Ce formulaire expirera ${expires}`,
    hi: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} ने आपको यह फॉर्म साइन करने के लिए भेजा है। नीचे दी गई जानकारी की समीक्षा करें और <a href="#sign-button">नीचे हस्ताक्षर करें</a>। यदि आपके कोई प्रश्न हैं, तो <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> ईमेल के माध्यम से ${senderGivenName} संपर्क करें। यह फॉर्म ${expires} समाप्त हो जाएगा।`,
    ht: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} voye ou fòm sa a pou siyen. Revize enfòmasyon ki anba yo epi <a href="#sign-button">siyen nan pati anba a</a>. Si ou gen kesyon, kontakte ${senderGivenName} pa imèl nan <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Fòm sa a ap ekspire ${expires}`,
    it: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} ti ha mandato questo modulo da firmare. Consulta le informazioni qui sotto e <a href="#sign-button">firma in fondo</a>. Se hai domande, contatta ${senderGivenName} via email al <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Questo modulo scadrà ${expires}`,
    ja: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} この書類に署名を求めて送った。以下の情報をよく確認し、 <a href="#sign-button">最後に署名してください</a>。ご質問がある場合は、 ${senderGivenName} にメールでご連絡ください。 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>。このフォームは ${expires}で期限切れとなります。`,
    ko: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} 이 서류를 보냈습니다. 아래 정보를 검토하고 <a href="#sign-button">하단에 서명해</a> 주세요. 궁금한 점이 있으면 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> 로 이메일을 통해 ${senderGivenName}에게 연락해 주세요. 이 양식은 ${expires}에 만료됩니다.`,
    mww: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} tau xa daim ntawv no rau koj kos npe. Txheeb xyuas cov ntaub ntawv hauv qab no thiab <a href="#sign-button">kos npe rau hauv qab</a>. Yog tias koj muaj lus nug, hu rau ${senderGivenName} ntawm email ntawm <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Daim ntawv no yuav tas sij hawm ${expires}`,
    ps: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} تا ته دا فورمه د لاسلیک لپاره راولېږله. لاندې معلومات وګورئ او <a href="#sign-button">په پای کې لاسلیک</a> کړئ. که پوښتنې لرئ، ${senderGivenName} ته په ایمیل کې <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. دا فورمه به ${expires} پای ته ورسېږی.`,
    pt: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} enviou este formulário para você assinar. Revise as informações abaixo e <a href="#sign-button">assine no final</a>. Se tiver dúvidas, entre em contato ${senderGivenName} por e-mail <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulário expirará ${expires}`,
    'pt-pt': (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} enviou-lhe este formulário para assinar. Consulte a informação abaixo e <a href="#sign-button">assine no final</a>. Se tiver dúvidas, contacte ${senderGivenName} por email <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulário expira ${expires}`,
    ru: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} прислал тебе эту форму для подписи. Ознакомьтесь с информацией ниже и <a href="#sign-button">распишитесь внизу</a>. Если у вас есть вопросы, свяжитесь ${senderGivenName} по электронной почте <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Эта форма истекает ${expires}`,
    sm: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`Na auina atu ${senderName} te oe lenei fomu e saini ai. Toe iloilo le faamatalaga o loo i lalo ma <a href="#sign-button">saini i le pito i lalo</a>. Afai ei ai ni au fesili, fa'afeso'ota'i ${senderGivenName} e ala i le imeli i le <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. O lenei fomu o le a muta ${expires}`,
    so: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} ayaa kuu soo diray foomkan si aad u saxiixdo. Eeg macluumaadka hoose oo <a href="#sign-button">saxiix hoos</a>. Haddii aad su'aalo qabto, ${senderGivenName} email <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Foomkan wuxuu dhici ${expires}`,
    th: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName}ส่งแบบฟอร์มนี้ให้คุณลงนาม ตรวจสอบข้อมูลด้านล่างและ<a href="#sign-button">ลงชื่อที่ด้านล่าง</a> หากคุณมีคําถาม โปรดติดต่อ${senderGivenName}ทางอีเมลที่ <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> แบบฟอร์มนี้จะหมดอายุใน${expires}`,
    ur: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} نے تمہیں یہ فارم دستخط کرنے کے لیے بھیجا ہے۔ نیچے دی گئی معلومات کا جائزہ لیں اور <a href="#sign-button">نیچے دستخط کریں۔</a> اگر آپ کے کوئی سوالات ہیں تو ${senderGivenName} سے ای میل <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> پر رابطہ کریں۔ یہ فارم ${expires} ختم ہو جائے گا۔`,
    vi: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} đã gửi cho bạn mẫu này để ký. Xem lại thông tin bên dưới và <a href="#sign-button">ký tên ở dưới cùng</a>. Nếu bạn có thắc mắc, hãy liên hệ với ${senderGivenName} qua email theo số <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Biểu mẫu này sẽ hết hạn vào ${expires}`,
    'zh-hans': (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} 寄给你这份表格让你签字。请查看以下信息并在 <a href="#sign-button">底部签名</a>。如有疑问，请通过电子邮件联系 ${senderGivenName} ，邮箱 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>。该表格将于 ${expires}）到期。`,
    'zh-hant': (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} 寄給你這份表格要你簽名。請參考以下資訊並在 <a href="#sign-button">底部簽名</a>。如有疑問，請透過電子郵件聯絡 ${senderGivenName} ，地址為 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>。此表格將於 ${expires}）到期。`,
    en: (senderName, senderGivenName, senderEmail, expires)=>$b11db1b62d4a8f76$var$html`${senderName} sent you this form to sign. Review the information below and <a href="#sign-button">sign at the bottom</a>. If you have questions, contact ${senderGivenName} via email at <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. This form will expire ${expires}.`
};
const $b11db1b62d4a8f76$export$52f5c9f1417c37d7 = {
    ar: `\u{644}\u{644}\u{625}\u{631}\u{633}\u{627}\u{644} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{647}\u{627}\u{62A}\u{641}\u{643}\u{60C} \u{627}\u{645}\u{633}\u{62D} \u{631}\u{645}\u{632} QR \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{62A}\u{637}\u{628}\u{64A}\u{642} \u{627}\u{644}\u{643}\u{627}\u{645}\u{64A}\u{631}\u{627}.`,
    de: `Um mit Ihrem Handy zu senden, scannen Sie den QR-Code mit Ihrer Kamera-App.`,
    es: `Para enviar con tu tel\xe9fono, escanea el c\xf3digo QR con la aplicaci\xf3n de la c\xe1mara.`,
    fa: `\u{628}\u{631}\u{627}\u{6CC} \u{627}\u{631}\u{633}\u{627}\u{644} \u{628}\u{627} \u{6AF}\u{648}\u{634}\u{6CC} \u{62E}\u{648}\u{62F}\u{60C} \u{6A9}\u{62F} QR \u{631}\u{627} \u{628}\u{627} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{62F}\u{648}\u{631}\u{628}\u{6CC}\u{646} \u{627}\u{633}\u{6A9}\u{646} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Upang magpadala gamit ang iyong telepono, i-scan ang QR code gamit ang iyong camera app.`,
    fr: `Pour envoyer avec votre t\xe9l\xe9phone, scannez le code QR avec votre application cam\xe9ra.`,
    hi: `\u{905}\u{92A}\u{928}\u{947} \u{92B}\u{93C}\u{94B}\u{928} \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{915}\u{947} \u{92D}\u{947}\u{91C}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F}, \u{905}\u{92A}\u{928}\u{947} \u{915}\u{948}\u{92E}\u{930}\u{93E} \u{910}\u{92A} \u{938}\u{947} \u{915}\u{94D}\u{92F}\u{942}\u{906}\u{930} \u{915}\u{94B}\u{921} \u{915}\u{94B} \u{938}\u{94D}\u{915}\u{948}\u{928} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Pou voye l\xe8 l s\xe8vi av\xe8k telef\xf2n ou, eskane k\xf2d QR la ak app kamera ou.`,
    it: `Per inviare con il telefono, scansiona il codice QR con l'app della fotocamera.`,
    ja: `\u{30B9}\u{30DE}\u{30DB}\u{3067}\u{9001}\u{4FE1}\u{3059}\u{308B}\u{306B}\u{306F}\u{3001}\u{30AB}\u{30E1}\u{30E9}\u{30A2}\u{30D7}\u{30EA}\u{3067}QR\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{30B9}\u{30AD}\u{30E3}\u{30F3}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{D734}\u{B300}\u{D3F0}\u{C73C}\u{B85C} \u{BCF4}\u{B0B4}\u{B824}\u{BA74} \u{CE74}\u{BA54}\u{B77C} \u{C571}\u{C73C}\u{B85C} QR \u{CF54}\u{B4DC}\u{B97C} \u{C2A4}\u{CE94}\u{D558}\u{C138}\u{C694}.`,
    mww: `Txhawm rau xa koj lub xov tooj, luam theej duab QR code nrog koj lub koob yees duab app.`,
    ps: `\u{62F} \u{62E}\u{67E}\u{644} \u{645}\u{648}\u{628}\u{627}\u{6CC}\u{644} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{62F} \u{644}\u{6CC}\u{696}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647}\u{60C} QR \u{6A9}\u{648}\u{689} \u{62F} \u{62E}\u{67E}\u{644} \u{6A9}\u{645}\u{631}\u{6D0} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{633}\u{631}\u{647} \u{633}\u{6A9}\u{6CC}\u{646} \u{6A9}\u{693}\u{626}.`,
    pt: `Para enviar pelo celular, escaneie o c\xf3digo QR com o aplicativo da c\xe2mera.`,
    'pt-pt': `Para enviar usando o telem\xf3vel, digitalize o c\xf3digo QR com a aplica\xe7\xe3o da c\xe2mara.`,
    ru: `\u{427}\u{442}\u{43E}\u{431}\u{44B} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{441} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{430}, \u{43E}\u{442}\u{441}\u{43A}\u{430}\u{43D}\u{438}\u{440}\u{443}\u{439}\u{442}\u{435} QR-\u{43A}\u{43E}\u{434} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{43A}\u{430}\u{43C}\u{435}\u{440}\u{44B}.`,
    sm: `Ina ia lafoina e fa'aaoga ai lau telefoni, fa'ata'ita'i le QR code ma lau mea pu'eata polokalama.`,
    so: `Si aad u dirto adigoo adeegsanaya taleefankaaga, baar koodhka QR adigoo adeegsanaya app-ka kamaraddaada.`,
    th: `\u{E2B}\u{E32}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E42}\u{E14}\u{E22}\u{E43}\u{E0A}\u{E49}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C} \u{E43}\u{E2B}\u{E49}\u{E2A}\u{E41}\u{E01}\u{E19}\u{E04}\u{E34}\u{E27}\u{E2D}\u{E32}\u{E23}\u{E4C}\u{E42}\u{E04}\u{E49}\u{E14}\u{E14}\u{E49}\u{E27}\u{E22}\u{E41}\u{E2D}\u{E1E}\u{E01}\u{E25}\u{E49}\u{E2D}\u{E07}\u{E16}\u{E48}\u{E32}\u{E22}\u{E23}\u{E39}\u{E1B}`,
    ur: `\u{627}\u{67E}\u{646}\u{6D2} \u{641}\u{648}\u{646} \u{633}\u{6D2} \u{628}\u{6BE}\u{6CC}\u{62C}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2}\u{60C} \u{627}\u{67E}\u{646}\u{6D2} \u{6A9}\u{6CC}\u{645}\u{631}\u{6C1} \u{627}\u{6CC}\u{67E} \u{633}\u{6D2} QR \u{6A9}\u{648}\u{688} \u{627}\u{633}\u{6A9}\u{6CC}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `\u{110}\u{1EC3} g\u{1EED}i b\u{1EB1}ng \u{111}i\u{1EC7}n tho\u{1EA1}i c\u{1EE7}a b\u{1EA1}n, h\xe3y qu\xe9t m\xe3 QR b\u{1EB1}ng \u{1EE9}ng d\u{1EE5}ng m\xe1y \u{1EA3}nh c\u{1EE7}a b\u{1EA1}n.`,
    'zh-hans': `\u{7528}\u{624B}\u{673A}\u{53D1}\u{9001}\u{65F6}\u{FF0C}\u{7528}\u{76F8}\u{673A}\u{5E94}\u{7528}\u{626B}\u{63CF}\u{4E8C}\u{7EF4}\u{7801}\u{3002}`,
    'zh-hant': `\u{8981}\u{7528}\u{624B}\u{6A5F}\u{767C}\u{9001}\u{FF0C}\u{8ACB}\u{7528}\u{76F8}\u{6A5F}App\u{6383}\u{63CF}QR\u{78BC}\u{3002}`,
    en: `To send using your phone, scan the QR code with your camera app.`
};
const $b11db1b62d4a8f76$export$d1ea8bcea30c0fe = {
    ar: `\u{627}\u{646}\u{62A}\u{647}\u{62A} \u{635}\u{644}\u{627}\u{62D}\u{64A}\u{629} \u{637}\u{644}\u{628} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}`,
    de: `Unterschriftsanfrage abgelaufen`,
    es: `Solicitud de firma expirada`,
    fa: `\u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{627}\u{645}\u{636}\u{627} \u{645}\u{646}\u{642}\u{636}\u{6CC} \u{634}\u{62F}`,
    fil: `Nag-expire na ang kahilingan sa lagda`,
    fr: `Demande de signature expir\xe9e`,
    hi: `\u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927} \u{915}\u{940} \u{938}\u{92E}\u{92F} \u{938}\u{940}\u{92E}\u{93E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{917}\u{908}`,
    ht: `Demann siyati ekspire`,
    it: `Richiesta di firma scaduta`,
    ja: `\u{7F72}\u{540D}\u{7533}\u{8ACB}\u{304C}\u{671F}\u{9650}\u{5207}\u{308C}\u{3068}\u{306A}\u{308A}\u{307E}\u{3057}\u{305F}`,
    ko: `\u{C11C}\u{BA85} \u{C694}\u{CCAD}\u{C774} \u{B9CC}\u{B8CC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Kev thov kos npe tas sij hawm`,
    ps: `\u{62F} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{647} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{6D0}\u{62F}\u{647}`,
    pt: `Pedido de assinatura expirado`,
    'pt-pt': `Pedido de assinatura expirado`,
    ru: `\u{417}\u{430}\u{43F}\u{440}\u{43E}\u{441} \u{43D}\u{430} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C} \u{438}\u{441}\u{442}\u{451}\u{43A}`,
    sm: `Ua uma le aoga o le talosaga mo saini`,
    so: `Codsiga saxiixa wuu dhacay`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E02}\u{E2D}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{6AF}\u{626}\u{6CC}`,
    vi: `Y\xeau c\u{1EA7}u ch\u{1EEF} k\xfd \u{111}\xe3 h\u{1EBF}t h\u{1EA1}n`,
    'zh-hans': `\u{7B7E}\u{540D}\u{8BF7}\u{6C42}\u{5DF2}\u{8FC7}\u{671F}`,
    'zh-hant': `\u{7C3D}\u{540D}\u{7533}\u{8ACB}\u{5DF2}\u{904E}\u{671F}`,
    en: `Signature request expired`
};
const $b11db1b62d4a8f76$export$c8e972f46484194e = {
    ar: (when)=>$b11db1b62d4a8f76$var$html`<p>انتهى هذا الطلب للتوقيع ${when}.</p>`,
    de: (when)=>$b11db1b62d4a8f76$var$html`<p>Diese Unterschriftsanfrage ist ${when} abgelaufen.</p>`,
    es: (when)=>$b11db1b62d4a8f76$var$html`<p>Esta solicitud de firma ${when}.</p>`,
    fa: (when)=>$b11db1b62d4a8f76$var$html`<p>این درخواست امضا ${when} منقضی شده.</p>`,
    fil: (when)=>$b11db1b62d4a8f76$var$html`<p>Ang kahilingan na ito para sa lagda ay nag-expire ${when}.</p>`,
    fr: (when)=>$b11db1b62d4a8f76$var$html`<p>Cette demande de signature a ${when}.</p>`,
    hi: (when)=>$b11db1b62d4a8f76$var$html`<p>हस्ताक्षर के लिए यह अनुरोध ${when} समाप्त हो गया था।</p>`,
    ht: (when)=>$b11db1b62d4a8f76$var$html`<p>Demann sa a pou siyati ekspire ${when}</p>`,
    it: (when)=>$b11db1b62d4a8f76$var$html`<p>Questa richiesta di firma è ${when}.</p>`,
    ja: (when)=>$b11db1b62d4a8f76$var$html`<p>この署名請求は ${when}期限切れです。</p>`,
    ko: (when)=>$b11db1b62d4a8f76$var$html`<p>서명 요청은 ${when} 만료되었습니다.</p>`,
    mww: (when)=>$b11db1b62d4a8f76$var$html`<p>Qhov kev thov kos npe no tau tas sijhawm ${when}.</p>`,
    ps: (when)=>$b11db1b62d4a8f76$var$html`<p>دا د لاسلیک غوښتنه ${when} پای ته رسېدلې.</p>`,
    pt: (when)=>$b11db1b62d4a8f76$var$html`<p>Esse pedido de assinatura ${when}.</p>`,
    'pt-pt': (when)=>$b11db1b62d4a8f76$var$html`<p>Este pedido de assinatura ${when}.</p>`,
    ru: (when)=>$b11db1b62d4a8f76$var$html`<p>Этот запрос на подпись истёк ${when}.</p>`,
    sm: (when)=>$b11db1b62d4a8f76$var$html`<p>O lenei talosaga mo le saini na faamutaina ${when}.</p>`,
    so: (when)=>$b11db1b62d4a8f76$var$html`<p>Codsigan saxiixa wuxuu dhacay ${when}.</p>`,
    th: (when)=>$b11db1b62d4a8f76$var$html`<p>คําขอลายเซ็นนี้หมดอายุเมื่อ ${when}</p>`,
    ur: (when)=>$b11db1b62d4a8f76$var$html`<p>یہ دستخط کی درخواست ${when} ختم ہو چکی ہے۔</p>`,
    vi: (when)=>$b11db1b62d4a8f76$var$html`<p>Yêu cầu chữ ký này đã hết hạn ${when}.</p>`,
    'zh-hans': (when)=>$b11db1b62d4a8f76$var$html`<p>这个签名请求在 ${when}过期了。</p>`,
    'zh-hant': (when)=>$b11db1b62d4a8f76$var$html`<p>這個簽名申請在 ${when}過期。</p>`,
    en: (when)=>$b11db1b62d4a8f76$var$html`<p>This request for signature expired ${when}.</p>`
};
const $b11db1b62d4a8f76$export$3ec6aefd3434ce48 = {
    ar: `\u{637}\u{644}\u{628}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}`,
    de: `Unterschriftsanfragen`,
    es: `Solicitudes de firma`,
    fa: `\u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{647}\u{627}\u{6CC} \u{627}\u{645}\u{636}\u{627}`,
    fil: `Email Address *`,
    fr: `Demandes de signature`,
    hi: `\u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927}`,
    ht: `Demann siyati`,
    it: `Richieste di firma`,
    ja: `\u{7F72}\u{540D}\u{8981}\u{6C42}`,
    ko: `\u{C11C}\u{BA85} \u{C694}\u{CCAD}`,
    mww: `Kev thov kos npe`,
    ps: `\u{62F} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{6D0}`,
    pt: `Pedidos de assinatura`,
    'pt-pt': `Pedidos de assinatura`,
    ru: `\u{417}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{44B} \u{43D}\u{430} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Talosaga saini`,
    so: `Codsiyada saxiixa`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E02}\u{E2D}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA}`,
    vi: `Y\xeau c\u{1EA7}u ch\u{1EEF} k\xfd`,
    'zh-hans': `\u{7B7E}\u{540D}\u{8BF7}\u{6C42}`,
    'zh-hant': `\u{7C3D}\u{540D}\u{8ACB}\u{6C42}`,
    en: `Signature requests`
};
const $b11db1b62d4a8f76$export$945006ae9f8dcf14 = {
    ar: (login)=>`\u{633}\u{62C}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{628}\u{627}\u{633}\u{645} ${login}`,
    de: (login)=>`Eingetragen als ${login}`,
    es: (login)=>`Iniciado como ${login}`,
    fa: (login)=>`\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} ${login}`,
    fil: (login)=>`Naka-sign in bilang ${login}`,
    fr: (login)=>`Enregistr\xe9 sous le nom ${login}`,
    hi: (login)=>`${login} \u{915}\u{947} \u{930}\u{942}\u{92A} \u{92E}\u{947}\u{902} \u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{915}\u{93F}\u{92F}\u{93E}`,
    ht: (login)=>`Siyen nan k\xf2m ${login}`,
    it: (login)=>`Registrato come ${login}`,
    ja: (login)=>`${login}\u{540D}\u{7FA9}\u{3067}\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}`,
    ko: (login)=>`${login}\u{C73C}\u{B85C} \u{B85C}\u{ADF8}\u{C778}\u{B428}`,
    mww: (login)=>`Kos npe rau hauv raws li ${login}`,
    ps: (login)=>`\u{62F} ${login} \u{67E}\u{647} \u{646}\u{648}\u{645} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{634}\u{648}\u{6CC}`,
    pt: (login)=>`Registrado como ${login}`,
    'pt-pt': (login)=>`Assinado como ${login}`,
    ru: (login)=>`\u{420}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{43F}\u{43E}\u{434} ${login}`,
    sm: (login)=>`Saini i totonu o ${login}`,
    so: (login)=>`Waxaa lagu saxiixay ${login}`,
    th: (login)=>`\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E43}\u{E19}\u{E10}\u{E32}\u{E19}\u{E30} ${login}`,
    ur: (login)=>`${login} \u{6A9}\u{6D2} \u{646}\u{627}\u{645} \u{633}\u{6D2} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: (login)=>`\u{110}\u{103}ng ${login} c\xe1ch John`,
    'zh-hans': (login)=>`\u{767B}\u{5F55} ${login}`,
    'zh-hant': (login)=>`\u{767B}\u{5165}\u{6642}\u{4EE5} ${login}`,
    en: (login)=>`Signed in as ${login}`
};
const $b11db1b62d4a8f76$export$eb268e40dcbc150b = {
    ar: (cumulus)=>`\u{623}\u{646}\u{62A} \u{645}\u{633}\u{62C}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{625}\u{644}\u{649} ${cumulus}.`,
    de: (cumulus)=>`Du bist bei ${cumulus} angemeldet.`,
    es: (cumulus)=>`Est\xe1s registrado en ${cumulus}.`,
    fa: (cumulus)=>`\u{634}\u{645}\u{627} \u{648}\u{627}\u{631}\u{62F} ${cumulus} \u{634}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: (cumulus)=>`Naka-sign ka na sa ${cumulus}.`,
    fr: (cumulus)=>`Vous \xeates inscrit \xe0 ${cumulus}.`,
    hi: (cumulus)=>`\u{906}\u{92A} ${cumulus} \u{92E}\u{947}\u{902} \u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{939}\u{948}\u{902}\u{964}`,
    ht: (cumulus)=>`Ou siyen nan ${cumulus}.`,
    it: (cumulus)=>`Sei registrato in ${cumulus}.`,
    ja: (cumulus)=>`\u{3042}\u{306A}\u{305F}\u{306F} ${cumulus}\u{306B}\u{767B}\u{9332}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (cumulus)=>`\u{B2F9}\u{C2E0}\u{C740} ${cumulus}\u{C5D0} \u{B85C}\u{ADF8}\u{C778}\u{B418}\u{C5B4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (cumulus)=>`Koj tau kos npe rau hauv ${cumulus}.`,
    ps: (cumulus)=>`\u{62A}\u{647} ${cumulus} \u{6A9}\u{6D0} \u{62B}\u{628}\u{62A} \u{634}\u{648}\u{6CC} \u{6CC}\u{6D0}.`,
    pt: (cumulus)=>`Voc\xea est\xe1 registrado na ${cumulus}.`,
    'pt-pt': (cumulus)=>`Est\xe1s registado na ${cumulus}.`,
    ru: (cumulus)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{44B} \u{432} ${cumulus}.`,
    sm: (cumulus)=>`Ua e saini i ${cumulus}.`,
    so: (cumulus)=>`Waxaad ku jirtaa ${cumulus}.`,
    th: (cumulus)=>`\u{E04}\u{E38}\u{E13}\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49} ${cumulus}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: (cumulus)=>`\u{622}\u{67E} ${cumulus} \u{645}\u{6CC}\u{6BA} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (cumulus)=>`B\u{1EA1}n \u{111}\xe3 \u{111}\u{103}ng nh\u{1EAD}p ${cumulus}.`,
    'zh-hans': (cumulus)=>`\u{4F60}\u{5DF2}\u{767B}\u{5F55} ${cumulus}\u{3002}`,
    'zh-hant': (cumulus)=>`\u{4F60}\u{5DF2}\u{767B}\u{5165} ${cumulus}\u{3002}`,
    en: (cumulus)=>`You are signed into ${cumulus}.`
};
const $b11db1b62d4a8f76$export$c0241daf8ee1d1ce = {
    ar: `\u{623}\u{646}\u{62A} \u{645}\u{633}\u{62C}\u{644}\u{629} \u{62E}\u{627}\u{631}\u{62C} Cumulus. \u{623}\u{631}\u{627}\u{643}\u{645} \u{644}\u{627}\u{62D}\u{642}\u{627}!`,
    de: `Du bist bei Cumulus ausgetragen. Wir sehen uns!`,
    es: `Est\xe1s registrado fuera de Cumulus. \xa1Nos vemos!`,
    fa: `\u{634}\u{645}\u{627} \u{627}\u{632} Cumulus \u{62E}\u{627}\u{631}\u{62C} \u{634}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}. \u{645}\u{6CC} \u{628}\u{6CC}\u{646}\u{645}\u{62A}!`,
    fil: `Naka-sign out ka na sa Cumulus. See you around!`,
    fr: `Vous \xeates d\xe9connect\xe9 de Cumulus. \xc0 plus tard !`,
    hi: `\u{906}\u{92A}\u{928}\u{947} \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{94D}\u{92F}\u{932}\u{938} \u{938}\u{947} \u{938}\u{93E}\u{907}\u{928} \u{906}\u{909}\u{91F} \u{915}\u{93F}\u{92F}\u{93E} \u{939}\u{948}\u{964} \u{92B}\u{93F}\u{930} \u{92E}\u{93F}\u{932}\u{924}\u{947} \u{939}\u{948}\u{902}!`,
    ht: `Ou siyen soti nan Cumulus W\xe8 ou alantou!`,
    it: `Sei stato registrato fuori da Cumulus. Ci vediamo in giro!`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306F}Cumulus\u{304B}\u{3089}\u{30B5}\u{30A4}\u{30F3}\u{30A2}\u{30A6}\u{30C8}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}\u{307E}\u{305F}\u{4F1A}\u{3044}\u{307E}\u{3057}\u{3087}\u{3046}!`,
    ko: `\u{B2F9}\u{C2E0}\u{C740} Cumulus\u{C5D0}\u{C11C} \u{B85C}\u{ADF8}\u{C544}\u{C6C3}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{B610} \u{BD10}\u{C694}!`,
    mww: `Koj tau kos npe tawm ntawm Cumulus. Pom koj nyob ib puag ncig!`,
    ps: `\u{62A}\u{647} \u{62F} \u{6A9}\u{648}\u{645}\u{6CC}\u{648}\u{644}\u{633} \u{685}\u{62E}\u{647} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{634}\u{648}\u{6CC} \u{6CC}\u{6D0}. \u{62F} \u{628}\u{6CC}\u{627} \u{644}\u{6CC}\u{62F}\u{644}\u{648} \u{67E}\u{647} \u{647}\u{6CC}\u{644}\u{647}!`,
    pt: `Voc\xea est\xe1 registrado para sair da Cumulus. At\xe9 mais!`,
    'pt-pt': `Est\xe1s desligado da Cumulus. At\xe9 \xe0 pr\xf3xima!`,
    ru: `\u{412}\u{44B} \u{432}\u{44B}\u{448}\u{43B}\u{438} \u{438}\u{437} Cumulus. \u{423}\u{432}\u{438}\u{434}\u{438}\u{43C}\u{441}\u{44F}!`,
    sm: `Ua e saini mai Cumulus. Toe fetaui!`,
    so: `Waxaad ka baxday Cumulus. An isku aragno meelaha!`,
    th: `\u{E04}\u{E38}\u{E13}\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E2D}\u{E2D}\u{E01}\u{E08}\u{E32}\u{E01} Cumulus \u{E41}\u{E25}\u{E49}\u{E27} \u{E41}\u{E25}\u{E49}\u{E27}\u{E1E}\u{E1A}\u{E01}\u{E31}\u{E19}\u{E43}\u{E2B}\u{E21}\u{E48}!`,
    ur: `\u{622}\u{67E} Cumulus \u{633}\u{6D2} \u{633}\u{627}\u{626}\u{646} \u{622}\u{624}\u{679} \u{6C1}\u{648} \u{686}\u{6A9}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4} \u{67E}\u{6BE}\u{631} \u{645}\u{644}\u{6CC}\u{6BA} \u{6AF}\u{6D2}!`,
    vi: `B\u{1EA1}n \u{111}\xe3 \u{111}\u{103}ng xu\u{1EA5}t kh\u{1ECF}i Cumulus. H\u{1EB9}n g\u{1EB7}p l\u{1EA1}i!`,
    'zh-hans': `\u{4F60}\u{5DF2}\u{7ECF}\u{88AB}Cumulus\u{7B7E}\u{51FA}\u{4E86}\u{3002}\u{56DE}\u{5934}\u{89C1}\u{FF01}`,
    'zh-hant': `\u{4F60}\u{5DF2}\u{7D93}\u{88AB}Cumulus\u{767B}\u{51FA}\u{3002}\u{56DE}\u{982D}\u{898B}\u{FF01}`,
    en: `You are signed out of Cumulus. See you around!`
};
const $b11db1b62d4a8f76$export$df7d62b22f2942d4 = {
    ar: `\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644}`,
    de: `Anmelden`,
    es: `Iniciar sesi\xf3n`,
    fa: `\u{648}\u{631}\u{648}\u{62F}`,
    fil: `Mag-sign in`,
    fr: `Connexion`,
    hi: `\u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Antre`,
    it: `Accedi`,
    ja: `\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}`,
    ko: `\u{B85C}\u{ADF8}\u{C778}`,
    mww: `Sau npe nkag mus`,
    ps: `\u{62F}\u{646}\u{646}\u{647} \u{634}\u{647}`,
    pt: `Fa\xe7a login`,
    'pt-pt': `Iniciar sess\xe3o`,
    ru: `\u{412}\u{43E}\u{439}\u{442}\u{438}`,
    sm: `Saini`,
    so: `Gal`,
    th: `\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}`,
    ur: `\u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{103}ng nh\u{1EAD}p`,
    'zh-hans': `\u{767B}\u{5F55}`,
    'zh-hant': `\u{767B}\u{5165}`,
    en: `Sign in`
};
const $b11db1b62d4a8f76$export$d50f92be4c216615 = {
    ar: `\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{628}\u{646}\u{62C}\u{627}\u{62D}`,
    de: `Anmeldung erfolgreich`,
    es: `Inicio de sesi\xf3n exitoso`,
    fa: `\u{648}\u{631}\u{648}\u{62F} \u{645}\u{648}\u{641}\u{642}\u{6CC}\u{62A} \u{622}\u{645}\u{6CC}\u{632}`,
    fil: `Mag-sign in nang matagumpay`,
    fr: `Connexion r\xe9ussie`,
    hi: `\u{938}\u{92B}\u{932} \u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Siyen nan siks\xe8`,
    it: `Accesso riuscito`,
    ja: `\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}\u{6210}\u{529F}`,
    ko: `\u{B85C}\u{ADF8}\u{C778} \u{C131}\u{ACF5}`,
    mww: `Kos npe rau hauv kev vam meej`,
    ps: `\u{646}\u{646}\u{648}\u{62A}\u{644} \u{628}\u{631}\u{6CC}\u{627}\u{644}\u{6CC} \u{634}\u{648}`,
    pt: `Iniciar sess\xe3o com sucesso`,
    'pt-pt': `Iniciar sess\xe3o bem-sucedida`,
    ru: `\u{412}\u{43E}\u{439}\u{442}\u{438} \u{443}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E}`,
    sm: `Saini manuia`,
    so: `Saxiix guul leh`,
    th: `\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E2A}\u{E4D}\u{E32}\u{E40}\u{E23}\u{E47}\u{E08}`,
    ur: `\u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{627}\u{645}\u{6CC}\u{627}\u{628} \u{6C1}\u{648}\u{627}`,
    vi: `\u{110}\u{103}ng nh\u{1EAD}p th\xe0nh c\xf4ng`,
    'zh-hans': `\u{767B}\u{5F55}\u{6210}\u{529F}`,
    'zh-hant': `\u{767B}\u{5165}\u{6210}\u{529F}`,
    en: `Sign in successful`
};
const $b11db1b62d4a8f76$export$ede211102672aa31 = {
    ar: (provider)=>`\u{633}\u{62C}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{628}\u{631}\u{64A}\u{62F}\u{643} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{648}\u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631} \u{644}\u{631}\u{628}\u{637} \u{62D}\u{633}\u{627}\u{628} ${provider} \u{627}\u{644}\u{62E}\u{627}\u{635} \u{628}\u{643}.`,
    de: (provider)=>`Melden Sie sich mit Ihrer E-Mail und Ihrem Passwort an, um Ihr ${provider} zu verkn\xfcpfen.`,
    es: (provider)=>`Inicia sesi\xf3n con tu correo electr\xf3nico y contrase\xf1a para conectar tu cuenta ${provider} .`,
    fa: (provider)=>`\u{628}\u{627} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{648} \u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631} \u{62E}\u{648}\u{62F} \u{648}\u{627}\u{631}\u{62F} \u{634}\u{648}\u{6CC}\u{62F} \u{62A}\u{627} \u{62D}\u{633}\u{627}\u{628} ${provider} \u{62E}\u{648}\u{62F} \u{631}\u{627} \u{645}\u{62A}\u{635}\u{644} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: (provider)=>`Mag-sign in gamit ang iyong email at password upang ikonekta ang iyong ${provider} account.`,
    fr: (provider)=>`Connectez-vous avec votre adresse e-mail et votre mot de passe pour connecter votre compte ${provider} .`,
    hi: (provider)=>`\u{905}\u{92A}\u{928}\u{93E} ${provider} \u{916}\u{93E}\u{924}\u{93E} \u{915}\u{928}\u{947}\u{915}\u{94D}\u{91F} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{92A}\u{928}\u{947} \u{908}\u{92E}\u{947}\u{932} \u{914}\u{930} \u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} \u{938}\u{947} \u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{915}\u{930}\u{947}\u{902}.`,
    ht: (provider)=>`Siyen nan ak im\xe8l ou ak modpas ou konekte kont ${provider} ou.`,
    it: (provider)=>`Accedi con email e password per collegare il tuo account ${provider} .`,
    ja: (provider)=>`Google ${provider} \u{63A5}\u{7D9A}\u{3059}\u{308B}\u{306B}\u{306F}\u{3001}\u{30E1}\u{30FC}\u{30EB}\u{30A2}\u{30C9}\u{30EC}\u{30B9}\u{3068}\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}\u{3067}\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: (provider)=>`\u{C774}\u{BA54}\u{C77C}\u{ACFC} \u{BE44}\u{BC00}\u{BC88}\u{D638}\u{B85C} \u{B85C}\u{ADF8}\u{C778}\u{D558}\u{C5EC} ${provider} \u{ACC4}\u{C815}\u{C744} \u{C5F0}\u{ACB0}\u{D558}\u{C138}\u{C694}.`,
    mww: (provider)=>`Kos npe rau hauv nrog koj tus email thiab lo lus zais los txuas koj tus account ${provider} .`,
    ps: (provider)=>`\u{62F} \u{62E}\u{67E}\u{644} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{627}\u{648} \u{67E}\u{627}\u{633}\u{648}\u{631}\u{689} \u{633}\u{631}\u{647} \u{646}\u{646}\u{648}\u{62A}\u{644} \u{648}\u{6A9}\u{693}\u{626} \u{62A}\u{631}\u{685}\u{648} ${provider} \u{62D}\u{633}\u{627}\u{628} \u{648}\u{635}\u{644} \u{6A9}\u{693}\u{626}.`,
    pt: (provider)=>`Fa\xe7a login com seu e-mail e senha para conectar sua conta ${provider} .`,
    'pt-pt': (provider)=>`Inicie sess\xe3o com o seu email e palavra-passe para ligar a sua conta ${provider} .`,
    ru: (provider)=>`\u{412}\u{43E}\u{439}\u{434}\u{438}\u{442}\u{435} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{447}\u{442}\u{44B} \u{438} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44F}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C} \u{441}\u{432}\u{43E}\u{439} ${provider} .`,
    sm: (provider)=>`Saini i totonu ma lau imeli ma le upu faataga e fesootai ai lau ${provider} account.`,
    so: (provider)=>`Gali adigoo isticmaalaya email-kaaga iyo erayga sirta ah si aad ugu xirmaan ${provider} .`,
    th: (provider)=>`\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E14}\u{E49}\u{E27}\u{E22}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E41}\u{E25}\u{E30}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E21}\u{E15}\u{E48}\u{E2D}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35} ${provider}`,
    ur: (provider)=>`\u{627}\u{67E}\u{646}\u{6D2} \u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{627}\u{648}\u{631} \u{67E}\u{627}\u{633} \u{648}\u{631}\u{688} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{62A}\u{627}\u{6A9}\u{6C1} ${provider} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{6A9}\u{646}\u{6CC}\u{6A9}\u{679} \u{6A9}\u{631} \u{633}\u{6A9}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (provider)=>`\u{110}\u{103}ng nh\u{1EAD}p b\u{1EB1}ng email v\xe0 m\u{1EAD}t kh\u{1EA9}u \u{111}\u{1EC3} k\u{1EBF}t n\u{1ED1}i t\xe0i kho\u{1EA3}n ${provider} c\u{1EE7}a b\u{1EA1}n.`,
    'zh-hans': (provider)=>`\u{4F7F}\u{7528}\u{60A8}\u{7684}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{548C}\u{5BC6}\u{7801}\u{767B}\u{5F55}\u{4EE5}\u{8FDE}\u{63A5} ${provider} \u{8D26}\u{6237}\u{3002}`,
    'zh-hant': (provider)=>`\u{8ACB}\u{7528}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{548C}\u{5BC6}\u{78BC}\u{767B}\u{5165}\u{FF0C}\u{9023}\u{7D50}\u{4F60}\u{7684} ${provider} \u{5E33}\u{865F}\u{3002}`,
    en: (provider)=>`Sign in with your email and password to connect your ${provider} account.`
};
const $b11db1b62d4a8f76$export$12c93f49b1bc9e53 = {
    ar: `\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62E}\u{631}\u{648}\u{62C}`,
    de: `Abmelden`,
    es: `Desconectarse`,
    fa: `\u{62E}\u{631}\u{648}\u{62C}`,
    fil: `Mag-sign out`,
    fr: `D\xe9connectez-vous`,
    hi: `\u{938}\u{93E}\u{907}\u{928} \u{906}\u{909}\u{91F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Siyen soti`,
    it: `Disconnettiti`,
    ja: `\u{30B5}\u{30A4}\u{30F3}\u{30A2}\u{30A6}\u{30C8}`,
    ko: `\u{B85C}\u{ADF8}\u{C544}\u{C6C3}`,
    mww: `Kos npe tawm`,
    ps: `\u{648}\u{62A}\u{644}`,
    pt: `Sair`,
    'pt-pt': `Desligar`,
    ru: `\u{412}\u{44B}\u{445}\u{43E}\u{434}`,
    sm: `Saini i fafo`,
    so: `Ka bax`,
    th: `\u{E2D}\u{E2D}\u{E01}\u{E08}\u{E32}\u{E01}\u{E23}\u{E30}\u{E1A}\u{E1A}`,
    ur: `\u{633}\u{627}\u{626}\u{646} \u{622}\u{624}\u{679} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{103}ng xu\u{1EA5}t`,
    'zh-hans': `\u{7B7E}\u{51FA}`,
    'zh-hant': `\u{767B}\u{51FA}`,
    en: `Sign out`
};
const $b11db1b62d4a8f76$export$d9d7a1f536fc1e69 = {
    ar: `\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62E}\u{631}\u{648}\u{62C} \u{628}\u{646}\u{62C}\u{627}\u{62D}`,
    de: `Erfolgreich ausloggen`,
    es: `Cierre de sesi\xf3n exitoso`,
    fa: `\u{62E}\u{631}\u{648}\u{62C} \u{645}\u{648}\u{641}\u{642}`,
    fil: `Mag-sign out nang matagumpay`,
    fr: `D\xe9connexion r\xe9ussie`,
    hi: `\u{938}\u{92B}\u{932} \u{938}\u{93E}\u{907}\u{928} \u{906}\u{909}\u{91F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Siyen soti siks\xe8`,
    it: `Disconnettimento riuscito`,
    ja: `\u{30B5}\u{30A4}\u{30F3}\u{30A2}\u{30A6}\u{30C8}\u{6210}\u{529F}`,
    ko: `\u{B85C}\u{ADF8}\u{C544}\u{C6C3} \u{C131}\u{ACF5}`,
    mww: `Kos npe tawm ua tiav`,
    ps: `\u{67E}\u{647} \u{628}\u{631}\u{6CC}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{628} \u{633}\u{631}\u{647} \u{648}\u{648}\u{62A}\u{646}\u{647}`,
    pt: `Desconectar com sucesso`,
    'pt-pt': `Desligar com sucesso`,
    ru: `\u{423}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{44B}\u{439} \u{432}\u{44B}\u{445}\u{43E}\u{434}`,
    sm: `Saini i fafo ma le manuia`,
    so: `Si guul leh uga bax`,
    th: `\u{E2D}\u{E2D}\u{E01}\u{E08}\u{E32}\u{E01}\u{E23}\u{E30}\u{E1A}\u{E1A}\u{E2A}\u{E4D}\u{E32}\u{E40}\u{E23}\u{E47}\u{E08}`,
    ur: `\u{6A9}\u{627}\u{645}\u{6CC}\u{627}\u{628}\u{6CC} \u{633}\u{6D2} \u{633}\u{627}\u{626}\u{646} \u{622}\u{624}\u{679} \u{6A9}\u{631}\u{646}\u{627}`,
    vi: `\u{110}\u{103}ng xu\u{1EA5}t th\xe0nh c\xf4ng`,
    'zh-hans': `\u{7B7E}\u{51FA}\u{6210}\u{529F}`,
    'zh-hant': `\u{7C3D}\u{51FA}\u{6210}\u{529F}`,
    en: `Sign out successful`
};
const $b11db1b62d4a8f76$export$2b2c3d59b1f8dfd9 = {
    ar: `\u{623}\u{646}\u{62A} \u{627}\u{644}\u{622}\u{646} \u{648}\u{642}\u{639} \u{62E}\u{627}\u{631}\u{62C} \u{634}\u{631}\u{643}\u{629} Cumulus.`,
    de: `Du bist jetzt bei Cumulus ausgeloggt.`,
    es: `Ahora est\xe1s registrado en Cumulus.`,
    fa: `\u{634}\u{645}\u{627} \u{627}\u{6A9}\u{646}\u{648}\u{646} \u{627}\u{632} Cumulus \u{62E}\u{627}\u{631}\u{62C} \u{634}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: `Ngayon ay naka-sign out ka na sa Cumulus.`,
    fr: `Vous \xeates maintenant d\xe9connect\xe9 de Cumulus.`,
    hi: `\u{905}\u{92C} \u{906}\u{92A} \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{94D}\u{92F}\u{932}\u{938} \u{938}\u{947} \u{938}\u{93E}\u{907}\u{928} \u{906}\u{909}\u{91F} \u{939}\u{94B} \u{917}\u{90F} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Ou se kounye a siyen soti nan cumulus`,
    it: `Ora sei registrato fuori da Cumulus.`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306F}Cumulus\u{304B}\u{3089}\u{30B5}\u{30A4}\u{30F3}\u{30A2}\u{30A6}\u{30C8}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774}\u{C81C} Cumulus\u{C5D0}\u{C11C} \u{ACC4}\u{C57D}\u{C744} \u{C885}\u{B8CC}\u{D558}\u{C168}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Koj tam sim no kos npe tawm ntawm Cumulus.`,
    ps: `\u{62A}\u{647} \u{627}\u{648}\u{633} \u{62F} \u{6A9}\u{648}\u{645}\u{6CC}\u{648}\u{644}\u{633} \u{685}\u{62E}\u{647} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{634}\u{648}\u{6CC} \u{6CC}\u{6D0}.`,
    pt: `Agora voc\xea est\xe1 registrado para sair da Cumulus.`,
    'pt-pt': `Agora est\xe1 desligado da Cumulus.`,
    ru: `\u{422}\u{435}\u{43F}\u{435}\u{440}\u{44C} \u{432}\u{44B} \u{432}\u{44B}\u{448}\u{43B}\u{438} \u{438}\u{437} Cumulus.`,
    sm: `O lenei ua e saini ese mai Cumulus.`,
    so: `Hadda waad ka baxday Cumulus.`,
    th: `\u{E15}\u{E2D}\u{E19}\u{E19}\u{E35}\u{E49}\u{E04}\u{E38}\u{E13}\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E2D}\u{E2D}\u{E01}\u{E08}\u{E32}\u{E01} Cumulus \u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{622}\u{67E} \u{627}\u{628} Cumulus \u{633}\u{6D2} \u{633}\u{627}\u{626}\u{646} \u{622}\u{624}\u{679} \u{6C1}\u{648} \u{686}\u{6A9}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `B\xe2y gi\u{1EDD} b\u{1EA1}n \u{111}\xe3 \u{111}\u{103}ng xu\u{1EA5}t kh\u{1ECF}i Cumulus.`,
    'zh-hans': `\u{4F60}\u{73B0}\u{5728}\u{5DF2}\u{7ECF}\u{88AB}Cumulus\u{7B7E}\u{51FA}\u{4E86}\u{3002}`,
    'zh-hant': `\u{4F60}\u{73FE}\u{5728}\u{5DF2}\u{7D93}\u{7C3D}\u{51FA} Cumulus\u{3002}`,
    en: `You are now signed out of Cumulus.`
};
const $b11db1b62d4a8f76$export$c5f3019e79d09a30 = {
    ar: `\u{633}\u{62C}\u{644}`,
    de: `Melden Sie sich an`,
    es: `Reg\xedstrate`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `Inscrivez-vous`,
    hi: `\u{928}\u{93E}\u{92E} \u{932}\u{93F}\u{916}\u{94B}`,
    ht: `Enskri`,
    it: `Iscriviti`,
    ja: `\u{30B5}\u{30A4}\u{30F3}\u{30A2}\u{30C3}\u{30D7}`,
    ko: `\u{AC00}\u{C785}\u{D558}\u{AE30}`,
    mww: `Cuv npe`,
    ps: `\u{6AB}\u{689}\u{648}\u{646} \u{648}\u{6A9}\u{693}\u{647}`,
    pt: `Inscreva-se`,
    'pt-pt': `Inscreva-se`,
    ru: `\u{417}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{438}\u{440}\u{443}\u{439}\u{442}\u{435}\u{441}\u{44C}`,
    sm: `Resitala`,
    so: `Diiwaangeli`,
    th: `\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}`,
    ur: `\u{633}\u{627}\u{626}\u{646} \u{627}\u{67E} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{103}ng k\xfd`,
    'zh-hans': `\u{6CE8}\u{518C}`,
    'zh-hant': `\u{8A3B}\u{518A}`,
    en: `Sign up`
};
const $b11db1b62d4a8f76$export$34a14b598dafa3c0 = {
    ar: (cumulus)=>`\u{633}\u{62C}\u{644} \u{641}\u{64A} ${cumulus}`,
    de: (cumulus)=>`Melden Sie sich f\xfcr ${cumulus} an`,
    es: (cumulus)=>`Ap\xfantate a ${cumulus}`,
    fa: (cumulus)=>`\u{628}\u{631}\u{627}\u{6CC} ${cumulus} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: (cumulus)=>`Mag-sign up para sa ${cumulus}`,
    fr: (cumulus)=>`Inscrivez-vous \xe0 ${cumulus}`,
    hi: (cumulus)=>`${cumulus} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{93E}\u{907}\u{928} \u{905}\u{92A} \u{915}\u{930}\u{947}\u{902}`,
    ht: (cumulus)=>`Enskri pou ${cumulus}`,
    it: (cumulus)=>`Iscriviti a ${cumulus}`,
    ja: (cumulus)=>`${cumulus}\u{306B}\u{767B}\u{9332}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: (cumulus)=>`${cumulus}\u{C5D0} \u{AC00}\u{C785}\u{D558}\u{C138}\u{C694}`,
    mww: (cumulus)=>`Sau npe rau ${cumulus}`,
    ps: (cumulus)=>`${cumulus} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{648}\u{6A9}\u{693}\u{626}`,
    pt: (cumulus)=>`Inscreva-se no ${cumulus}`,
    'pt-pt': (cumulus)=>`Inscreva-se no ${cumulus}`,
    ru: (cumulus)=>`\u{417}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{438}\u{440}\u{443}\u{439}\u{442}\u{435}\u{441}\u{44C} \u{43D}\u{430} ${cumulus}`,
    sm: (cumulus)=>`Saini mo ${cumulus}`,
    so: (cumulus)=>`Isdiiwaangeli ${cumulus}`,
    th: (cumulus)=>`\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19} ${cumulus}`,
    ur: (cumulus)=>`${cumulus} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{633}\u{627}\u{626}\u{646} \u{627}\u{67E} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: (cumulus)=>`\u{110}\u{103}ng k\xfd ${cumulus}`,
    'zh-hans': (cumulus)=>`\u{6CE8}\u{518C} ${cumulus}`,
    'zh-hant': (cumulus)=>`\u{8A3B}\u{518A} ${cumulus}`,
    en: (cumulus)=>`Sign up for ${cumulus}`
};
const $b11db1b62d4a8f76$export$6954622ee2e42563 = {
    ar: $b11db1b62d4a8f76$var$html`بالنقر على "التسجيل"، فإنك توافق على <a class="target-subtle" href="/terms" target="_blank">شروط الاستخدام</a> <a class="target-subtle" href="/privacy" target="_blank">وسياسة الخصوصية</a> الخاصة بنا. سنرسل لك أحيانا رسائل إلكترونية متعلقة بالحساب.`,
    de: $b11db1b62d4a8f76$var$html`Indem Sie auf "Registrieren" klicken, stimmen Sie unseren <a class="target-subtle" href="/terms" target="_blank">Nutzungsbedingungen</a> und <a class="target-subtle" href="/privacy" target="_blank">Datenschutzrichtlinien</a> zu. Gelegentlich senden wir Ihnen kontobezogene E-Mails.`,
    es: $b11db1b62d4a8f76$var$html`Al hacer clic en "Regístrate", aceptas nuestros <a class="target-subtle" href="/terms" target="_blank">Términos de Uso</a> y <a class="target-subtle" href="/privacy" target="_blank">Política de Privacidad</a>. De vez en cuando te enviaremos correos electrónicos relacionados con la cuenta.`,
    fa: $b11db1b62d4a8f76$var$html`با کلیک روی «ثبت نام»، شما با <a class="target-subtle" href="/terms" target="_blank">شرایط استفاده</a> و <a class="target-subtle" href="/privacy" target="_blank">سیاست حفظ حریم خصوصی</a> ما موافقت می کنید. گاهی اوقات ایمیل های مرتبط با حساب کاربری برایتان ارسال می کنیم.`,
    fil: $b11db1b62d4a8f76$var$html`Sa pamamagitan ng pag-click sa "Mag-sign up", sumasang-ayon ka sa aming <a class="target-subtle" href="/terms" target="_blank">Mga Tuntunin ng Paggamit</a> at <a class="target-subtle" href="/privacy" target="_blank">Patakaran sa Pagkapribado</a>. Paminsan-minsan ay magpapadala kami sa iyo ng mga email na may kaugnayan sa account.`,
    fr: $b11db1b62d4a8f76$var$html`En cliquant sur « S’inscrire », vous acceptez nos <a class="target-subtle" href="/terms" target="_blank">Conditions d’utilisation</a> et notre <a class="target-subtle" href="/privacy" target="_blank">Politique de confidentialité</a>. Nous vous enverrons parfois des emails liés à votre compte.`,
    hi: $b11db1b62d4a8f76$var$html`"साइन अप" पर क्लिक करके, आप हमारी <a class="target-subtle" href="/terms" target="_blank">उपयोग की शर्तों</a> और <a class="target-subtle" href="/privacy" target="_blank">गोपनीयता नीति</a> से सहमत होते हैं। हम कभी-कभी आपको खाते से संबंधित ईमेल भेजेंगे.`,
    ht: $b11db1b62d4a8f76$var$html`Lè w klike sou "Enskri", ou dakò ak <a class="target-subtle" href="/terms" target="_blank">nou an Regleman pou Itilize</a> ak <a class="target-subtle" href="/privacy" target="_blank">Règleman sou enfòmasyon prive</a>. Nou pral voye ba ou Imèl kont ki gen rapò ak detanzantan.`,
    it: $b11db1b62d4a8f76$var$html`Cliccando su "Iscriviti", accetti i <a class="target-subtle" href="/terms" target="_blank">nostri Termini di Utilizzo</a> e <a class="target-subtle" href="/privacy" target="_blank">l'Informativa sulla Privacy</a>. Occasionalmente ti invieremo email relative all'account.`,
    ja: $b11db1b62d4a8f76$var$html`「サインアップ」をクリックすると<a class="target-subtle" href="/terms" target="_blank">、利用規約および</a><a class="target-subtle" href="/privacy" target="_blank">プライバシーポリシー</a>に同意したことになります。時折、アカウント関連のメールをお送りします。`,
    ko: $b11db1b62d4a8f76$var$html`"가입"을 클릭하면 이용 <a class="target-subtle" href="/terms" target="_blank">약관</a> 과 <a class="target-subtle" href="/privacy" target="_blank">개인정보처리방침</a>에 동의하는 것으로 간주됩니다. 가끔 계정 관련 이메일을 보내드릴 예정입니다.`,
    mww: $b11db1b62d4a8f76$var$html`Los ntawm nias "Sau npe", koj pom zoo rau peb <a class="target-subtle" href="/terms" target="_blank">Cov Lus Cog Tseg ntawm Kev Siv</a> thiab <a class="target-subtle" href="/privacy" target="_blank">Txoj Cai Tswjfwm Ntiag Tug</a>. Peb mam li qee zaum xa koj cov email ntsig txog tus account.`,
    ps: $b11db1b62d4a8f76$var$html`د "ثبت نام" په کلیک کولو سره، تاسو زموږ <a class="target-subtle" href="/terms" target="_blank">د کارونې شرایطو</a> او <a class="target-subtle" href="/privacy" target="_blank">محرمیت پالیسۍ سره موافقه کوئ</a>. موږ به کله ناکله تا ته د حساب اړوند ایمیلونه واستوو.`,
    pt: $b11db1b62d4a8f76$var$html`Ao clicar em "Cadastrar", você concorda com nossos <a class="target-subtle" href="/terms" target="_blank">Termos de Uso</a> e <a class="target-subtle" href="/privacy" target="_blank">Política de Privacidade</a>. Ocasionalmente, enviaremos e-mails relacionados à sua conta.`,
    'pt-pt': $b11db1b62d4a8f76$var$html`Ao clicar em "Registar-se", concorda com os nossos <a class="target-subtle" href="/terms" target="_blank">Termos de Utilização</a> e <a class="target-subtle" href="/privacy" target="_blank">Política de Privacidade</a>. Ocasionalmente, enviamos-lhe emails relacionados com a conta.`,
    ru: $b11db1b62d4a8f76$var$html`Нажав «Зарегистрироваться», вы соглашаетесь с нашими <a class="target-subtle" href="/terms" target="_blank">Условиями использования</a> и <a class="target-subtle" href="/privacy" target="_blank">Политикой конфиденциальности</a>. Иногда мы отправляем вам письма, связанные с аккаунтом.`,
    sm: $b11db1b62d4a8f76$var$html`I le kilikiina o le "Saini i luga", ua e malilie i a matou <a class="target-subtle" href="/terms" target="_blank">Tuutuuga o Fa'aaoga ma Fa'alilolilo</a> <a class="target-subtle" href="/privacy" target="_blank">Faiga Fa'avae</a>. O nisi taimi matou te lafoina atu ia te oe imeli e feso'ota'i ma teuga tupe.`,
    so: $b11db1b62d4a8f76$var$html`Adigoo gujinaya "Isdiiwaangelin", waxaad ogolaatay <a class="target-subtle" href="/terms" target="_blank">Shuruudaha Isticmaalka</a> iyo <a class="target-subtle" href="/privacy" target="_blank">Siyaasadda Asturnaanta</a>. Mararka qaar waxaan kuu soo diri doonaa emails la xiriira akoonka.`,
    th: $b11db1b62d4a8f76$var$html`เมื่อคลิก "ลงทะเบียน" แสดงว่าคุณยอมรับ <a class="target-subtle" href="/terms" target="_blank">ข้อกําหนดการใช้งาน</a> และ <a class="target-subtle" href="/privacy" target="_blank">นโยบายความเป็นส่วนตัว</a>ของเรา เราจะส่งอีเมลเกี่ยวกับบัญชีให้คุณเป็นครั้งคราว`,
    ur: $b11db1b62d4a8f76$var$html`"سائن اپ" پر کلک کر کے، آپ ہماری <a class="target-subtle" href="/terms" target="_blank">شرائط استعمال</a> اور <a class="target-subtle" href="/privacy" target="_blank">پرائیویسی پالیسی</a> سے اتفاق کرتے ہیں۔ ہم کبھی کبھار آپ کو اکاؤنٹ سے متعلق ای میلز بھیجیں گے۔`,
    vi: $b11db1b62d4a8f76$var$html`Bằng cách nhấp vào "Đăng ký", bạn đồng ý với <a class="target-subtle" href="/terms" target="_blank">Điều khoản sử dụng</a> và <a class="target-subtle" href="/privacy" target="_blank">Chính sách quyền riêng tư</a> của chúng tôi. Thỉnh thoảng, chúng tôi sẽ gửi cho bạn các email liên quan đến tài khoản.`,
    'zh-hans': $b11db1b62d4a8f76$var$html`点击“注册”即表示您同意我们的 <a class="target-subtle" href="/terms" target="_blank">使用条款</a> 和 <a class="target-subtle" href="/privacy" target="_blank">隐私政策</a>。我们偶尔会向您发送与账户相关的邮件。`,
    'zh-hant': $b11db1b62d4a8f76$var$html`點擊「註冊」即表示您同意我們的 <a class="target-subtle" href="/terms" target="_blank">使用條款</a> 及 <a class="target-subtle" href="/privacy" target="_blank">隱私政策</a>。我們偶爾會寄送與帳戶相關的電子郵件給您。`,
    en: $b11db1b62d4a8f76$var$html`By clicking "Sign up", you agree to our <a class="target-subtle" href="/terms" target="_blank">Terms of Use</a> and <a class="target-subtle" href="/privacy" target="_blank">Privacy Policy</a>. We’ll occasionally send you account related emails.`
};
const $b11db1b62d4a8f76$export$9feabe39d774db92 = {
    ar: `\u{648}\u{642}\u{639} \u{628}\u{62A}\u{648}\u{642}\u{64A}\u{639}\u{643} \u{627}\u{644}\u{627}\u{641}\u{62A}\u{631}\u{627}\u{636}\u{64A}`,
    de: `Unterschreiben Sie mit Ihrer Standardsignatur`,
    es: `Firma con tu firma predeterminada`,
    fa: `\u{628}\u{627} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636} \u{62E}\u{648}\u{62F} \u{627}\u{645}\u{636}\u{627} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Mag-sign gamit ang iyong default na lagda`,
    fr: `Signez avec votre signature par d\xe9faut`,
    hi: `\u{905}\u{92A}\u{928}\u{947} \u{921}\u{93F}\u{92B}\u{93C}\u{949}\u{932}\u{94D}\u{91F} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Siyen ak siyati default ou`,
    it: `Firma con la tua firma predefinita`,
    ja: `\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}\u{306E}\u{7F72}\u{540D}\u{3067}\u{7F72}\u{540D}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{AE30}\u{BCF8} \u{C11C}\u{BA85}\u{C73C}\u{B85C} \u{C11C}\u{BA85}\u{D558}\u{C138}\u{C694}`,
    mww: `Kos npe nrog koj lub neej ntawd kos npe`,
    ps: `\u{62F} \u{62E}\u{67E}\u{644} \u{627}\u{635}\u{644}\u{6CC} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{633}\u{631}\u{647} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{648}\u{6A9}\u{693}\u{626}`,
    pt: `Assine com sua assinatura padr\xe3o`,
    'pt-pt': `Assine com a sua assinatura padr\xe3o`,
    ru: `\u{41F}\u{43E}\u{434}\u{43F}\u{438}\u{448}\u{438}\u{442}\u{435}\u{441}\u{44C} \u{441}\u{432}\u{43E}\u{435}\u{439} \u{441}\u{442}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{442}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}\u{44E}`,
    sm: `Saini i lau saini faaletonu`,
    so: `Saxiix saxiixaaga caadiga ah`,
    th: `\u{E25}\u{E07}\u{E19}\u{E32}\u{E21}\u{E14}\u{E49}\u{E27}\u{E22}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{627}\u{67E}\u{646}\u{6D2} \u{688}\u{6CC}\u{641}\u{627}\u{644}\u{679} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `K\xfd b\u{1EB1}ng ch\u{1EEF} k\xfd m\u{1EB7}c \u{111}\u{1ECB}nh c\u{1EE7}a b\u{1EA1}n`,
    'zh-hans': `\u{7528}\u{4F60}\u{7684}\u{9ED8}\u{8BA4}\u{7B7E}\u{540D}\u{7B7E}\u{540D}`,
    'zh-hant': `\u{7528}\u{4F60}\u{7684}\u{9810}\u{8A2D}\u{7C3D}\u{540D}\u{7C3D}\u{540D}`,
    en: `Sign with your default signature`
};
const $b11db1b62d4a8f76$export$234c584cd96079ce = {
    ar: `1 \u{645}\u{644}\u{62D}\u{642}`,
    de: `1 Anhang`,
    es: `1 Anexo`,
    fa: `\u{6F1} \u{636}\u{645}\u{6CC}\u{645}\u{647}`,
    fil: `1 attachment`,
    fr: `1 pi\xe8ce jointe`,
    hi: `1 \u{938}\u{902}\u{932}\u{917}\u{94D}\u{928}\u{915}`,
    ht: `1 atachman`,
    it: `1 Allegazione`,
    ja: `1 \u{30A2}\u{30BF}\u{30C3}\u{30C1}\u{30E1}\u{30F3}\u{30C8}`,
    ko: `1 \u{BD80}\u{CC29}\u{BB3C}`,
    mww: `1 txuas`,
    ps: `\u{6F1} \u{636}\u{645}\u{6CC}\u{645}\u{647}`,
    pt: `1 Anexo`,
    'pt-pt': `1 anexo`,
    ru: `1 \u{43F}\u{440}\u{438}\u{43A}\u{440}\u{435}\u{43F}\u{43B}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `1 fa'apipi'i`,
    so: `1 Lifaaq`,
    th: `1 \u{E2A}\u{E34}\u{E48}\u{E07}\u{E17}\u{E35}\u{E48}\u{E41}\u{E19}\u{E1A}\u{E21}\u{E32}`,
    ur: `1 \u{645}\u{646}\u{633}\u{644}\u{6A9}\u{6C1}`,
    vi: `1 t\u{1EC7}p \u{111}\xednh k\xe8m`,
    'zh-hans': `1 \u{9644}\u{4EF6}`,
    'zh-hant': `1 \u{9644}\u{4EF6}`,
    en: `1 attachment`
};
const $b11db1b62d4a8f76$export$8d7756e137af3a86 = {
    ar: `\u{645}\u{633}\u{627}\u{647}\u{645} \u{648}\u{627}\u{62D}\u{62F}`,
    de: `1 Mitwirkender`,
    es: `1 colaborador`,
    fa: `\u{6F1} \u{645}\u{634}\u{627}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: `1 nag-ambag`,
    fr: `1 contributeur`,
    hi: `1 \u{92F}\u{94B}\u{917}\u{926}\u{93E}\u{928}\u{915}\u{930}\u{94D}\u{924}\u{93E}`,
    ht: `1 kontribit\xe8`,
    it: `1 collaboratore`,
    ja: `1\u{540D}\u{306E}\u{5BC4}\u{7A3F}\u{8005}`,
    ko: `1\u{BA85}\u{C758} \u{AE30}\u{C5EC}\u{C790}`,
    mww: `1 tus neeg koom tes`,
    ps: `\u{6F1} \u{647}\u{645}\u{6A9}\u{627}\u{631}`,
    pt: `1 colaborador`,
    'pt-pt': `1 colaborador`,
    ru: `1 \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}`,
    sm: `1 tagata fai saofaga`,
    so: `1 ka qaybqaate`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E23}\u{E48}\u{E27}\u{E21}\u{E43}\u{E2B}\u{E49}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25} 1 \u{E04}\u{E19}`,
    ur: `1 \u{645}\u{639}\u{627}\u{648}\u{646}`,
    vi: `1 ng\u{1B0}\u{1EDD}i \u{111}\xf3ng g\xf3p`,
    'zh-hans': `1\u{4F4D}\u{8D21}\u{732E}\u{8005}`,
    'zh-hant': `1\u{4F4D}\u{8CA2}\u{737B}\u{8005}`,
    en: `1 contributor`
};
const $b11db1b62d4a8f76$export$4822b96394899afb = {
    ar: `\u{646}\u{633}\u{62E}\u{629} \u{633}\u{627}\u{628}\u{642}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629}`,
    de: `1 Fr\xfchere Version`,
    es: `1 Versi\xf3n anterior`,
    fa: `\u{6F1} \u{646}\u{633}\u{62E}\u{647} \u{642}\u{628}\u{644}\u{6CC}`,
    fil: `1 naunang bersyon`,
    fr: `1 Version ant\xe9rieure`,
    hi: `1 \u{92A}\u{941}\u{930}\u{93E}\u{928}\u{93E} \u{938}\u{902}\u{938}\u{94D}\u{915}\u{930}\u{923}`,
    ht: `1 v\xe8syon pi bon\xe8`,
    it: `1 Versione precedente`,
    ja: `1 \u{521D}\u{671F}\u{306E}\u{30D0}\u{30FC}\u{30B8}\u{30E7}\u{30F3}`,
    ko: `1 \u{C774}\u{C804} \u{BC84}\u{C804}`,
    mww: `1 ua ntej version`,
    ps: `\u{6F1} \u{67E}\u{62E}\u{648}\u{627}\u{646}\u{6CD} \u{646}\u{633}\u{62E}\u{647}`,
    pt: `1 Vers\xe3o anterior`,
    'pt-pt': `1 Vers\xe3o anterior`,
    ru: `1 \u{420}\u{430}\u{43D}\u{43D}\u{44F}\u{44F} \u{432}\u{435}\u{440}\u{441}\u{438}\u{44F}`,
    sm: `1 lomiga muamua`,
    so: `1 nooc hore`,
    th: `1 \u{E40}\u{E27}\u{E2D}\u{E23}\u{E4C}\u{E0A}\u{E31}\u{E48}\u{E19}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: `1 \u{67E}\u{631}\u{627}\u{646}\u{627} \u{648}\u{631}\u{698}\u{646}`,
    vi: `1 Phi\xean b\u{1EA3}n c\u{169} h\u{1A1}n`,
    'zh-hans': `1 \u{65E9}\u{671F}\u{7248}\u{672C}`,
    'zh-hant': `1 \u{65E9}\u{671F}\u{7248}\u{672C}`,
    en: `1 earlier version`
};
const $b11db1b62d4a8f76$export$a639cc9893796305 = {
    ar: `1 \u{627}\u{644}\u{62A}\u{646}\u{638}\u{64A}\u{645}`,
    de: `1 Organisation`,
    es: `1 Organizaci\xf3n`,
    fa: `\u{6F1} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: `1 organisasyon`,
    fr: `1 Organisation`,
    hi: `1 \u{938}\u{902}\u{917}\u{920}\u{928}`,
    ht: `1 \xf2ganizasyon`,
    it: `1 Organizzazione`,
    ja: `1 \u{7D44}\u{7E54}`,
    ko: `1 \u{C870}\u{C9C1}`,
    mww: `1 lub koom haum`,
    ps: `\u{6F1} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    pt: `1 Organiza\xe7\xe3o`,
    'pt-pt': `1 Organiza\xe7\xe3o`,
    ru: `1 \u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `1 faalapotopotoga`,
    so: `1 Urur`,
    th: `1 \u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `1 \u{62A}\u{646}\u{638}\u{6CC}\u{645}`,
    vi: `1 T\u{1ED5} ch\u{1EE9}c`,
    'zh-hans': `1 \u{7EC4}\u{7EC7}`,
    'zh-hant': `1 \u{7D44}\u{7E54}`,
    en: `1 organization`
};
const $b11db1b62d4a8f76$export$60c7c9a86a4ee833 = {
    ar: `\u{645}\u{634}\u{627}\u{631}\u{643} \u{648}\u{627}\u{62D}\u{62F}`,
    de: `1 Teilnehmer`,
    es: `1 participante`,
    fa: `\u{6F1} \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: `1 kalahok`,
    fr: `1 participant`,
    hi: `1 \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{940}`,
    ht: `1 patisipan`,
    it: `1 partecipante`,
    ja: `\u{53C2}\u{52A0}\u{8005}1\u{540D}`,
    ko: `\u{CC38}\u{AC00}\u{C790} 1\u{BA85}`,
    mww: `1 tus neeg koom nrog`,
    ps: `\u{6F1} \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644}`,
    pt: `1 participante`,
    'pt-pt': `1 participante`,
    ru: `1 \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}`,
    sm: `1 tagata auai`,
    so: `1 ka qaybgale`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21} 1 \u{E04}\u{E19}`,
    ur: `1 \u{634}\u{631}\u{6CC}\u{6A9}`,
    vi: `1 ng\u{1B0}\u{1EDD}i tham gia`,
    'zh-hans': `1\u{540D}\u{53C2}\u{4E0E}\u{8005}`,
    'zh-hant': `1\u{540D}\u{53C3}\u{8207}\u{8005}`,
    en: `1 participant`
};
const $b11db1b62d4a8f76$export$3a9d0270e8a39565 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{642}\u{639}`,
    de: `Standort`,
    es: `Emplazamiento`,
    fa: `\u{645}\u{62D}\u{648}\u{637}\u{647}`,
    fil: `Email Address *`,
    fr: `Site`,
    hi: `\u{938}\u{93E}\u{907}\u{91F}`,
    ht: `Sit`,
    it: `Sito`,
    ja: `\u{907A}\u{8DE1}`,
    ko: `\u{BD80}\u{C9C0}`,
    mww: `Qhov chaw`,
    ps: `\u{681}\u{627}\u{6CC}`,
    pt: `Local`,
    'pt-pt': `Local`,
    ru: `\u{41C}\u{435}\u{441}\u{442}\u{43E}`,
    sm: `Nofoaga`,
    so: `Goobta`,
    th: `\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}`,
    ur: `\u{645}\u{642}\u{627}\u{645}`,
    vi: `\u{110}\u{1ECB}a \u{111}i\u{1EC3}m`,
    'zh-hans': `\u{9057}\u{5740}`,
    'zh-hant': `\u{5730}\u{9EDE}`,
    en: `Site`
};
const $b11db1b62d4a8f76$export$47be4670711d8c15 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{627}\u{642}\u{639}`,
    de: `St\xe4tten`,
    es: `Lugares`,
    fa: `\u{645}\u{6A9}\u{627}\u{646} \u{647}\u{627}`,
    fil: `Mga Site`,
    fr: `Sites`,
    hi: `\u{938}\u{93E}\u{907}\u{91F}\u{947}\u{902}`,
    ht: `Sit yo`,
    it: `Siti`,
    ja: `\u{907A}\u{8DE1}`,
    ko: `\u{C720}\u{C801}\u{C9C0}`,
    mww: `Cov chaw`,
    ps: `\u{681}\u{627}\u{6CC}\u{648}\u{646}\u{647}`,
    pt: `Locais`,
    'pt-pt': `Locais`,
    ru: `\u{41E}\u{431}\u{44A}\u{435}\u{43A}\u{442}\u{44B}`,
    sm: `Nofoaga`,
    so: `Goobaha`,
    th: `\u{E44}\u{E0B}\u{E15}\u{E4C}`,
    ur: `\u{645}\u{642}\u{627}\u{645}\u{627}\u{62A}`,
    vi: `Trang web`,
    'zh-hans': `\u{9057}\u{5740}`,
    'zh-hant': `\u{666F}\u{9EDE}`,
    en: `Sites`
};
const $b11db1b62d4a8f76$export$48f5de395b14c85a = {
    ar: `\u{631}\u{648}\u{627}\u{628}\u{637} \u{639}\u{644}\u{649} \u{645}\u{633}\u{62A}\u{648}\u{649} \u{627}\u{644}\u{645}\u{648}\u{642}\u{639}`,
    de: `Siteweite Links`,
    es: `Enlaces a nivel de sitio`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9} \u{647}\u{627}\u{6CC} \u{633}\u{631}\u{627}\u{633}\u{631}\u{6CC} \u{633}\u{627}\u{6CC}\u{62A}`,
    fil: `Mga link sa buong site`,
    fr: `Liens \xe0 l\u{2019}\xe9chelle du site`,
    hi: `\u{938}\u{93E}\u{907}\u{91F}-\u{935}\u{94D}\u{92F}\u{93E}\u{92A}\u{940} \u{932}\u{93F}\u{902}\u{915}`,
    ht: `Sit laj\xe8-lyen`,
    it: `Collegamenti a livello di sito`,
    ja: `\u{30B5}\u{30A4}\u{30C8}\u{5168}\u{4F53}\u{306E}\u{30EA}\u{30F3}\u{30AF}`,
    ko: `\u{C0AC}\u{C774}\u{D2B8} \u{C804}\u{CCB4} \u{B9C1}\u{D06C}`,
    mww: `Qhov chaw txuas thoob plaws`,
    ps: `\u{62F} \u{67C}\u{648}\u{644}\u{6D0} \u{633}\u{627}\u{6CC}\u{67C} \u{644}\u{6CC}\u{646}\u{6A9}\u{648}\u{646}\u{647}`,
    pt: `Links em todo o site`,
    'pt-pt': `Liga\xe7\xf5es em todo o site`,
    ru: `\u{421}\u{441}\u{44B}\u{43B}\u{43A}\u{438} \u{43D}\u{430} \u{432}\u{435}\u{441}\u{44C} \u{441}\u{430}\u{439}\u{442}`,
    sm: `Feso'ota'iga lautele`,
    so: `Xiriirro guud oo goobta ah`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E17}\u{E31}\u{E48}\u{E27}\u{E17}\u{E31}\u{E49}\u{E07}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}`,
    ur: `\u{633}\u{627}\u{626}\u{679} \u{628}\u{6BE}\u{631} \u{6A9}\u{6D2} \u{631}\u{648}\u{627}\u{628}\u{637}`,
    vi: `\u{110}\u{1B0}\u{1EDD}ng li\xean k\u{1EBF}t tr\xean to\xe0n trang web`,
    'zh-hans': `\u{5168}\u{7AD9}\u{94FE}\u{63A5}`,
    'zh-hant': `\u{5168}\u{7AD9}\u{9023}\u{7D50}`,
    en: `Site-wide links`
};
const $b11db1b62d4a8f76$export$152c4be1b3779f87 = {
    ar: `\u{639}\u{631}\u{636} \u{631}\u{645}\u{632} QR \u{635}\u{63A}\u{64A}\u{631}`,
    de: `Kleiner QR-Code anzeigen`,
    es: `Ver peque\xf1o c\xf3digo QR`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{6A9}\u{62F} QR \u{6A9}\u{648}\u{686}\u{6A9}`,
    fil: `Tingnan ang maliit na QR code`,
    fr: `Voir un petit code QR`,
    hi: `\u{91B}\u{94B}\u{91F}\u{93E} \u{915}\u{94D}\u{92F}\u{942}\u{906}\u{930} \u{915}\u{94B}\u{921} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `Gade ti k\xf2d QR`,
    it: `Visualizza il piccolo codice QR`,
    ja: `\u{5C0F}\u{3055}\u{306A}QR\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{8868}\u{793A}`,
    ko: `\u{C791}\u{C740} QR \u{CF54}\u{B4DC} \u{BCF4}\u{AE30}`,
    mww: `Saib me me QR code`,
    ps: `\u{6A9}\u{648}\u{686}\u{646}\u{6CC} QR \u{6A9}\u{648}\u{689} \u{648}\u{6AB}\u{648}\u{631}\u{626}`,
    pt: `Veja o pequeno c\xf3digo QR`,
    'pt-pt': `Ver pequeno c\xf3digo QR`,
    ru: `\u{41F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440} \u{43C}\u{430}\u{43B}\u{43E}\u{433}\u{43E} QR-\u{43A}\u{43E}\u{434}\u{430}`,
    sm: `Va'ai la'ititi QR code`,
    so: `Eeg QR code yar`,
    th: `\u{E14}\u{E39}\u{E23}\u{E2B}\u{E31}\u{E2A} QR \u{E02}\u{E19}\u{E32}\u{E14}\u{E40}\u{E25}\u{E47}\u{E01}`,
    ur: `\u{686}\u{6BE}\u{648}\u{679}\u{627} QR \u{6A9}\u{648}\u{688} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Xem m\xe3 QR nh\u{1ECF}`,
    'zh-hans': `\u{67E5}\u{770B}\u{5C0F}\u{578B}\u{4E8C}\u{7EF4}\u{7801}`,
    'zh-hant': `\u{67E5}\u{770B}\u{5C0F}\u{578B} QR \u{78BC}`,
    en: `View small QR code`
};
const $b11db1b62d4a8f76$export$7cdd8cc46aec9c24 = {
    ar: `\u{627}\u{643}\u{62A}\u{645}\u{644} \u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{647}\u{627}\u{62A}\u{641} (SMS)`,
    de: `Telefon- (SMS) Anmeldung abgeschlossen`,
    es: `Inscripci\xf3n telef\xf3nica (SMS) completada`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{62A}\u{644}\u{641}\u{646}\u{6CC} (\u{67E}\u{6CC}\u{627}\u{645}\u{6A9}) \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{634}\u{62F}`,
    fil: `Nakumpleto ang pagpapatala sa telepono (SMS)`,
    fr: `Inscription au t\xe9l\xe9phone (SMS) termin\xe9e`,
    hi: `\u{92B}\u{94B}\u{928} (\u{90F}\u{938}\u{90F}\u{92E}\u{90F}\u{938}) \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{928} \u{92A}\u{942}\u{930}\u{93E} \u{939}\u{94B} \u{917}\u{92F}\u{93E} \u{939}\u{948}`,
    ht: `Enskripsyon nan telef\xf2n (SMS) fini`,
    it: `Iscrizione telefonica (SMS) completata`,
    ja: `\u{96FB}\u{8A71}(SMS)\u{767B}\u{9332}\u{5B8C}\u{4E86}`,
    ko: `\u{C804}\u{D654}(SMS) \u{B4F1}\u{B85D} \u{C644}\u{B8CC}`,
    mww: `Kev sau npe hu xov tooj (SMS) tiav`,
    ps: `\u{62F} \u{67C}\u{6CC}\u{644}\u{6CC}\u{641}\u{648}\u{646} (SMS) \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{628}\u{634}\u{67E}\u{693}\u{647} \u{634}\u{648}\u{647}`,
    pt: `Inscri\xe7\xe3o por telefone (SMS) conclu\xedda`,
    'pt-pt': `Inscri\xe7\xe3o por telefone (SMS) conclu\xedda`,
    ru: `\u{420}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{43F}\u{43E} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{443} (SMS) \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{430}`,
    sm: `Ua maea le lesitala i le telefoni (SMS)`,
    so: `Diiwaangelinta telefoonka (SMS) waa la dhammeeyay`,
    th: `\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E17}\u{E32}\u{E07}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C} (SMS) \u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{641}\u{648}\u{646} (\u{627}\u{6CC}\u{633} \u{627}\u{6CC}\u{645} \u{627}\u{6CC}\u{633}) \u{6A9}\u{627} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{645}\u{6A9}\u{645}\u{644} \u{6C1}\u{648} \u{6AF}\u{6CC}\u{627}`,
    vi: `\u{110}\u{103}ng k\xfd qua \u{111}i\u{1EC7}n tho\u{1EA1}i (SMS) \u{111}\xe3 ho\xe0n t\u{1EA5}t`,
    'zh-hans': `\u{7535}\u{8BDD}\u{FF08}\u{77ED}\u{4FE1}\u{FF09}\u{6CE8}\u{518C}\u{5B8C}\u{6210}`,
    'zh-hant': `\u{96FB}\u{8A71}\u{FF08}SMS\u{FF09}\u{767B}\u{8A18}\u{5B8C}\u{6210}`,
    en: `Phone (SMS) enrollment completed`
};
const $b11db1b62d4a8f76$export$471961a7c731b50b = {
    ar: (cumulus)=>`\u{627}\u{631}\u{628}\u{637} \u{627}\u{644}\u{634}\u{631}\u{643}\u{627}\u{621} \u{648}\u{627}\u{644}\u{641}\u{631}\u{642}\u{60C} \u{648}\u{634}\u{627}\u{631}\u{643} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}\u{60C} \u{648}\u{625}\u{62F}\u{627}\u{631}\u{629} \u{627}\u{644}\u{639}\u{645}\u{644}\u{627}\u{621}\u{60C} \u{648}\u{623}\u{62C}\u{631}\u{64A} \u{627}\u{644}\u{62A}\u{642}\u{64A}\u{64A}\u{645}\u{627}\u{62A}\u{60C} \u{648}\u{623}\u{62C}\u{631}\u{64A} \u{627}\u{644}\u{625}\u{62D}\u{627}\u{644}\u{627}\u{62A}\u{60C} \u{648}\u{62A}\u{62A}\u{628}\u{639} \u{627}\u{644}\u{641}\u{639}\u{627}\u{644}\u{64A}\u{627}\u{62A}\u{60C} \u{648}\u{623}\u{643}\u{62B}\u{631} \u{645}\u{646} \u{630}\u{644}\u{643}. \u{627}\u{633}\u{62A}\u{628}\u{62F}\u{644} \u{62C}\u{62F}\u{627}\u{648}\u{644} \u{627}\u{644}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{648}\u{627}\u{644}\u{648}\u{631}\u{642} \u{648}\u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{628}\u{633}\u{64A}\u{631} \u{639}\u{645}\u{644} ${cumulus} \u{60C} \u{648}\u{627}\u{644}\u{646}\u{645}\u{627}\u{630}\u{62C} \u{627}\u{644}\u{622}\u{644}\u{64A}\u{629}\u{60C} \u{648}\u{627}\u{644}\u{627}\u{633}\u{62A}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A}\u{60C} \u{648}\u{627}\u{644}\u{645}\u{647}\u{627}\u{645}.`,
    de: (cumulus)=>`Vernetzen Sie Partner und Teams, teilen Sie Informationen, verwalten Sie Kunden, f\xfchren Sie Bewertungen durch, geben Sie Empfehlungen, verfolgen Sie Ereignisse und mehr. Ersetzen Sie Tabellenkalkulationen, Papier und E-Mails durch ${cumulus} , automatisierte Formulare, Umfragen und Aufgaben.`,
    es: (cumulus)=>`Conecta socios y equipos, comparte informaci\xf3n, gestiona clientes, realiza evaluaciones, haz referencias, registra eventos y mucho m\xe1s. Sustituye hojas de c\xe1lculo, papel y correos electr\xf3nicos por flujos de trabajo ${cumulus} , formularios automatizados, encuestas y tareas.`,
    fa: (cumulus)=>`\u{634}\u{631}\u{6A9}\u{627} \u{648} \u{62A}\u{6CC}\u{645} \u{647}\u{627} \u{631}\u{627} \u{628}\u{647} \u{647}\u{645} \u{645}\u{62A}\u{635}\u{644} \u{6A9}\u{646}\u{6CC}\u{62F}\u{60C} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{631}\u{627} \u{628}\u{647} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{628}\u{6AF}\u{630}\u{627}\u{631}\u{6CC}\u{62F}\u{60C} \u{645}\u{634}\u{62A}\u{631}\u{6CC}\u{627}\u{646} \u{631}\u{627} \u{645}\u{62F}\u{6CC}\u{631}\u{6CC}\u{62A} \u{6A9}\u{646}\u{6CC}\u{62F}\u{60C} \u{627}\u{631}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{62F}\u{647}\u{6CC}\u{62F}\u{60C} \u{627}\u{631}\u{62C}\u{627}\u{639} \u{62F}\u{647}\u{6CC}\u{62F}\u{60C} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{647}\u{627} \u{631}\u{627} \u{67E}\u{6CC}\u{6AF}\u{6CC}\u{631}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{645}\u{648}\u{627}\u{631}\u{62F} \u{62F}\u{6CC}\u{6AF}\u{631}. \u{635}\u{641}\u{62D}\u{627}\u{62A} \u{6AF}\u{633}\u{62A}\u{631}\u{62F}\u{647}\u{60C} \u{6A9}\u{627}\u{63A}\u{630} \u{648} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{647}\u{627} \u{631}\u{627} \u{628}\u{627} \u{62C}\u{631}\u{6CC}\u{627}\u{646} \u{647}\u{627}\u{6CC} \u{6A9}\u{627}\u{631}\u{6CC} ${cumulus} \u{60C} \u{641}\u{631}\u{645} \u{647}\u{627}\u{6CC} \u{62E}\u{648}\u{62F}\u{6A9}\u{627}\u{631}\u{60C} \u{646}\u{638}\u{631}\u{633}\u{646}\u{62C}\u{6CC} \u{647}\u{627} \u{648} \u{648}\u{638}\u{627}\u{6CC}\u{641} \u{62C}\u{627}\u{6CC}\u{6AF}\u{632}\u{6CC}\u{646} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: (cumulus)=>`Ikonekta ang mga kasosyo at koponan, magbahagi ng impormasyon, pamahalaan ang mga kliyente, magsagawa ng mga pagtatasa, gumawa ng mga referral, subaybayan ang mga kaganapan, at marami pa. Palitan ang mga spreadsheet, papel, at email ng mga daloy ng trabaho ${cumulus} , awtomatikong mga form, survey, at gawain.`,
    fr: (cumulus)=>`Connectez partenaires et \xe9quipes, partagez des informations, g\xe9rez des clients, effectuez des \xe9valuations, faites des recommandations, suivez les \xe9v\xe9nements, et bien plus encore. Remplacez les tableaux Tableur, papier et e-mails par des flux de travail ${cumulus} , des formulaires automatis\xe9s, des enqu\xeates et des t\xe2ches.`,
    hi: (cumulus)=>`\u{92D}\u{93E}\u{917}\u{940}\u{926}\u{93E}\u{930}\u{94B}\u{902} \u{914}\u{930} \u{91F}\u{940}\u{92E}\u{94B}\u{902} \u{915}\u{94B} \u{915}\u{928}\u{947}\u{915}\u{94D}\u{91F} \u{915}\u{930}\u{947}\u{902}, \u{91C}\u{93E}\u{928}\u{915}\u{93E}\u{930}\u{940} \u{938}\u{93E}\u{91D}\u{93E} \u{915}\u{930}\u{947}\u{902}, \u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915}\u{94B}\u{902} \u{915}\u{93E} \u{92A}\u{94D}\u{930}\u{92C}\u{902}\u{927}\u{928} \u{915}\u{930}\u{947}\u{902}, \u{906}\u{915}\u{932}\u{928} \u{915}\u{930}\u{947}\u{902}, \u{930}\u{947}\u{92B}\u{930}\u{932} \u{915}\u{930}\u{947}\u{902}, \u{918}\u{91F}\u{928}\u{93E}\u{913}\u{902} \u{915}\u{94B} \u{91F}\u{94D}\u{930}\u{948}\u{915} \u{915}\u{930}\u{947}\u{902}, \u{914}\u{930} \u{92C}\u{939}\u{941}\u{924} \u{915}\u{941}\u{91B}\u{964} \u{938}\u{94D}\u{92A}\u{94D}\u{930}\u{947}\u{921}\u{936}\u{940}\u{91F}, \u{92A}\u{947}\u{92A}\u{930} \u{914}\u{930} \u{908}\u{92E}\u{947}\u{932} \u{915}\u{94B} ${cumulus} \u{935}\u{930}\u{94D}\u{915}\u{92B}\u{93C}\u{94D}\u{932}\u{94B}\u{91C}\u{93C}, \u{938}\u{94D}\u{935}\u{91A}\u{93E}\u{932}\u{93F}\u{924} \u{92B}\u{93C}\u{949}\u{930}\u{94D}\u{92E}, \u{938}\u{930}\u{94D}\u{935}\u{947}\u{915}\u{94D}\u{937}\u{923} \u{914}\u{930} \u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{94B}\u{902} \u{938}\u{947} \u{92C}\u{926}\u{932}\u{947}\u{902}\u{964}`,
    ht: (cumulus)=>`Konekte patn\xe8 ak ekip, pataje enf\xf2masyon, jere kliyan, f\xe8 evalyasyon yo, f\xe8 referans, swiv ev\xe8nman ak plis ank\xf2. Ranplase calcul, papye, ak Im\xe8l ak ${cumulus} workflows, f\xf2m otomatik, sondaj, ak travay.`,
    it: (cumulus)=>`Connetti partner e team, condividi informazioni, gestisci i clienti, conduci valutazioni, effettua referenze, monitora eventi e altro ancora. Sostituisci fogli di calcolo, carta ed email con flussi di lavoro ${cumulus} , moduli automatizzati, sondaggi e attivit\xe0.`,
    ja: (cumulus)=>`\u{30D1}\u{30FC}\u{30C8}\u{30CA}\u{30FC}\u{3084}\u{30C1}\u{30FC}\u{30E0}\u{306E}\u{3064}\u{306A}\u{304C}\u{308A}\u{3001}\u{60C5}\u{5831}\u{5171}\u{6709}\u{3001}\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}\u{7BA1}\u{7406}\u{3001}\u{8A55}\u{4FA1}\u{306E}\u{5B9F}\u{65BD}\u{3001}\u{7D39}\u{4ECB}\u{3001}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306E}\u{8FFD}\u{8DE1}\u{306A}\u{3069}\u{3002}\u{30B9}\u{30D7}\u{30EC}\u{30C3}\u{30C9}\u{30B7}\u{30FC}\u{30C8}\u{3084}\u{7D19}\u{3001}\u{30E1}\u{30FC}\u{30EB}\u{3092} ${cumulus} \u{306E}\u{30EF}\u{30FC}\u{30AF}\u{30D5}\u{30ED}\u{30FC}\u{3001}\u{81EA}\u{52D5}\u{30D5}\u{30A9}\u{30FC}\u{30E0}\u{3001}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}\u{3001}\u{30BF}\u{30B9}\u{30AF}\u{306B}\u{7F6E}\u{304D}\u{63DB}\u{3048}\u{307E}\u{3057}\u{3087}\u{3046}\u{3002}`,
    ko: (cumulus)=>`\u{D30C}\u{D2B8}\u{B108}\u{C640} \u{D300}\u{C744} \u{C5F0}\u{ACB0}\u{D558}\u{ACE0}, \u{C815}\u{BCF4}\u{B97C} \u{ACF5}\u{C720}\u{D558}\u{BA70}, \u{ACE0}\u{AC1D}\u{C744} \u{AD00}\u{B9AC}\u{D558}\u{ACE0}, \u{D3C9}\u{AC00}\u{B97C} \u{C2E4}\u{C2DC}\u{D558}\u{ACE0}, \u{CD94}\u{CC9C}\u{C744} \u{D558}\u{BA70}, \u{C774}\u{BCA4}\u{D2B8} \u{CD94}\u{C801} \u{B4F1}\u{C744} \u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C2A4}\u{D504}\u{B808}\u{B4DC}\u{C2DC}\u{D2B8}, \u{C885}\u{C774}, \u{C774}\u{BA54}\u{C77C}\u{C744} ${cumulus} \u{C6CC}\u{D06C}\u{D50C}\u{B85C}\u{C6B0}, \u{C790}\u{B3D9}\u{D654} \u{C591}\u{C2DD}, \u{C124}\u{BB38}\u{C870}\u{C0AC}, \u{C791}\u{C5C5}\u{C73C}\u{B85C} \u{B300}\u{CCB4}\u{D558}\u{C138}\u{C694}.`,
    mww: (cumulus)=>`Txuas cov neeg koom tes thiab pab pawg, sib qhia cov ntaub ntawv, tswj cov neeg siv khoom, ua cov kev ntsuam xyuas, xa mus, taug qab cov xwm txheej, thiab lwm yam. Hloov cov ntawv qhia, ntawv, thiab email nrog ${cumulus} workflows, tsis siv neeg daim ntawv, kev tshawb fawb thiab cov haujlwm.`,
    ps: (cumulus)=>`\u{634}\u{631}\u{6CC}\u{6A9}\u{627}\u{646} \u{627}\u{648} \u{67C}\u{6CC}\u{645}\u{648}\u{646}\u{647} \u{633}\u{631}\u{647} \u{648}\u{635}\u{644} \u{6A9}\u{693}\u{626}\u{60C} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{634}\u{631}\u{6CC}\u{6A9} \u{6A9}\u{693}\u{626}\u{60C} \u{645}\u{634}\u{62A}\u{631}\u{6CC}\u{627}\u{646} \u{645}\u{62F}\u{6CC}\u{631}\u{6CC}\u{62A} \u{6A9}\u{693}\u{626}\u{60C} \u{627}\u{631}\u{632}\u{648}\u{646}\u{6D0} \u{62A}\u{631}\u{633}\u{631}\u{647} \u{6A9}\u{693}\u{626}\u{60C} \u{631}\u{627}\u{62C}\u{639} \u{6A9}\u{648}\u{644} \u{648}\u{6A9}\u{693}\u{626}\u{60C} \u{67E}\u{6CC}\u{69A}\u{6D0} \u{62A}\u{639}\u{642}\u{6CC}\u{628} \u{6A9}\u{693}\u{626}\u{60C} \u{627}\u{648} \u{646}\u{648}\u{631}. \u{633}\u{67E}\u{631}\u{6CC}\u{689}\u{634}\u{6CC}\u{67C}\u{648}\u{646}\u{647}\u{60C} \u{6A9}\u{627}\u{63A}\u{630}\u{648}\u{646}\u{647}\u{60C} \u{627}\u{648} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}\u{648}\u{646}\u{647} \u{62F} ${cumulus} \u{6A9}\u{627}\u{631}\u{6CC} \u{6A9}\u{627}\u{631}\u{6CC}\u{60C} \u{627}\u{62A}\u{648}\u{645}\u{627}\u{62A} \u{641}\u{648}\u{631}\u{645}\u{648}\u{646}\u{648}\u{60C} \u{633}\u{631}\u{648}\u{6D0} \u{6AB}\u{627}\u{646}\u{648} \u{627}\u{648} \u{62F}\u{646}\u{62F}\u{648} \u{633}\u{631}\u{647} \u{628}\u{62F}\u{644} \u{6A9}\u{693}\u{626}.`,
    pt: (cumulus)=>`Conecte parceiros e equipes, compartilhe informa\xe7\xf5es, gerencie clientes, realize avalia\xe7\xf5es, fa\xe7a indica\xe7\xf5es, acompanhe eventos e muito mais. Substitua planilhas, papel e e-mails por fluxos de trabalho ${cumulus} , formul\xe1rios automatizados, pesquisas e tarefas.`,
    'pt-pt': (cumulus)=>`Ligue parceiros e equipas, partilhe informa\xe7\xf5es, gere clientes, realize avalia\xe7\xf5es, fa\xe7a refer\xeancias, acompanhe eventos e muito mais. Substitua folhas de c\xe1lculo, papel e emails por fluxos de trabalho ${cumulus} , formul\xe1rios automatizados, inqu\xe9ritos e tarefas.`,
    ru: (cumulus)=>`\u{421}\u{43E}\u{435}\u{434}\u{438}\u{43D}\u{44F}\u{439}\u{442}\u{435} \u{43F}\u{430}\u{440}\u{442}\u{43D}\u{435}\u{440}\u{43E}\u{432} \u{438} \u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{44B}, \u{434}\u{435}\u{43B}\u{438}\u{442}\u{435}\u{441}\u{44C} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{435}\u{439}, \u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{44F}\u{439}\u{442}\u{435} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{43C}\u{438}, \u{43F}\u{440}\u{43E}\u{432}\u{43E}\u{434}\u{438}\u{442}\u{435} \u{43E}\u{446}\u{435}\u{43D}\u{43A}\u{438}, \u{434}\u{435}\u{43B}\u{430}\u{439}\u{442}\u{435} \u{440}\u{435}\u{43A}\u{43E}\u{43C}\u{435}\u{43D}\u{434}\u{430}\u{446}\u{438}\u{438}, \u{43E}\u{442}\u{441}\u{43B}\u{435}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F} \u{438} \u{43C}\u{43D}\u{43E}\u{433}\u{43E}\u{435} \u{434}\u{440}\u{443}\u{433}\u{43E}\u{435}. \u{417}\u{430}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{435} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{44B}\u{435} \u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B}, \u{431}\u{443}\u{43C}\u{430}\u{433}\u{443} \u{438} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{443}\u{44E} \u{43F}\u{43E}\u{447}\u{442}\u{443} \u{43D}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{438}\u{435} ${cumulus} , \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{437}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{444}\u{43E}\u{440}\u{43C}\u{44B}, \u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{44B} \u{438} \u{437}\u{430}\u{434}\u{430}\u{447}\u{438}.`,
    sm: (cumulus)=>`Fa'afeso'ota'i pa'aga ma 'au, fefa'asoaa'i fa'amatalaga, fa'atautaia tagata fa'atau, fa'atautaia iloiloga, faia fa'asino mea, siaki mea na tutupu, ma sili atu. Suia spreadsheets, pepa, ma imeli i ${cumulus} workflows, otometi fomu, su'esu'ega, ma galuega.`,
    so: (cumulus)=>`Isku xir la-hawlgalayaasha iyo kooxaha, wadaag macluumaadka, maareeya macaamiisha, samee qiimeyn, samee tixraacyo, la soco dhacdooyinka, iyo waxyaabo kale. Bedel xaashiyaha xisaabta, warqadda, iyo emails-ka adigoo adeegsanaya ${cumulus} , foomamka otomaatiga ah, sahanno, iyo hawlo.`,
    th: (cumulus)=>`\u{E40}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E21}\u{E15}\u{E48}\u{E2D}\u{E04}\u{E39}\u{E48}\u{E04}\u{E49}\u{E32}\u{E41}\u{E25}\u{E30}\u{E17}\u{E35}\u{E21} \u{E41}\u{E1A}\u{E48}\u{E07}\u{E1B}\u{E31}\u{E19}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25} \u{E08}\u{E31}\u{E14}\u{E01}\u{E32}\u{E23}\u{E25}\u{E39}\u{E01}\u{E04}\u{E49}\u{E32} \u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E21}\u{E34}\u{E19} \u{E41}\u{E19}\u{E30}\u{E19}\u{E4D}\u{E32} \u{E15}\u{E34}\u{E14}\u{E15}\u{E32}\u{E21}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21} \u{E41}\u{E25}\u{E30}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E46} \u{E41}\u{E17}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E40}\u{E1B}\u{E23}\u{E14}\u{E0A}\u{E35}\u{E15} \u{E01}\u{E23}\u{E30}\u{E14}\u{E32}\u{E29} \u{E41}\u{E25}\u{E30}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E14}\u{E49}\u{E27}\u{E22}\u{E40}\u{E27}\u{E34}\u{E23}\u{E4C}\u{E01}\u{E42}\u{E1F}\u{E25}\u{E27}\u{E4C} ${cumulus} \u{E41}\u{E1A}\u{E1A}\u{E1F}\u{E2D}\u{E23}\u{E4C}\u{E21}\u{E2D}\u{E31}\u{E15}\u{E42}\u{E19}\u{E21}\u{E31}\u{E15}\u{E34} \u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E4D}\u{E32}\u{E23}\u{E27}\u{E08} \u{E41}\u{E25}\u{E30}\u{E07}\u{E32}\u{E19}`,
    ur: (cumulus)=>`\u{634}\u{631}\u{627}\u{6A9}\u{62A} \u{62F}\u{627}\u{631}\u{648}\u{6BA} \u{627}\u{648}\u{631} \u{679}\u{6CC}\u{645}\u{648}\u{6BA} \u{6A9}\u{648} \u{62C}\u{648}\u{691}\u{6CC}\u{6BA}\u{60C} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{6A9}\u{627} \u{62A}\u{628}\u{627}\u{62F}\u{644}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{60C} \u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679}\u{633} \u{6A9}\u{627} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{60C} \u{62C}\u{627}\u{626}\u{632}\u{6D2} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{60C} \u{631}\u{6CC}\u{641}\u{631}\u{644}\u{632} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{60C} \u{627}\u{6CC}\u{648}\u{646}\u{679}\u{633} \u{6A9}\u{648} \u{679}\u{631}\u{6CC}\u{6A9} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{60C} \u{627}\u{648}\u{631} \u{628}\u{6C1}\u{62A} \u{6A9}\u{686}\u{6BE}\u{6D4} \u{627}\u{633}\u{67E}\u{631}\u{6CC}\u{688}\u{634}\u{6CC}\u{679}\u{633}\u{60C} \u{67E}\u{6CC}\u{67E}\u{631}\u{60C} \u{627}\u{648}\u{631} \u{627}\u{6CC} \u{645}\u{6CC}\u{644}\u{632} \u{6A9}\u{648} ${cumulus} \u{648}\u{631}\u{6A9} \u{641}\u{644}\u{648}\u{60C} \u{62E}\u{648}\u{62F}\u{6A9}\u{627}\u{631} \u{641}\u{627}\u{631}\u{645}\u{648}\u{6BA}\u{60C} \u{633}\u{631}\u{648}\u{6D2}\u{60C} \u{627}\u{648}\u{631} \u{6A9}\u{627}\u{645}\u{648}\u{6BA} \u{633}\u{6D2} \u{62A}\u{628}\u{62F}\u{6CC}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (cumulus)=>`K\u{1EBF}t n\u{1ED1}i \u{111}\u{1ED1}i t\xe1c v\xe0 nh\xf3m, chia s\u{1EBB} th\xf4ng tin, qu\u{1EA3}n l\xfd kh\xe1ch h\xe0ng, ti\u{1EBF}n h\xe0nh \u{111}\xe1nh gi\xe1, gi\u{1EDB}i thi\u{1EC7}u, theo d\xf5i s\u{1EF1} ki\u{1EC7}n, v.v. Thay th\u{1EBF} b\u{1EA3}ng t\xednh, gi\u{1EA5}y v\xe0 email b\u{1EB1}ng quy tr\xecnh l\xe0m vi\u{1EC7}c ${cumulus} , bi\u{1EC3}u m\u{1EAB}u, kh\u{1EA3}o s\xe1t v\xe0 nhi\u{1EC7}m v\u{1EE5} t\u{1EF1} \u{111}\u{1ED9}ng.`,
    'zh-hans': (cumulus)=>`\u{8FDE}\u{63A5}\u{5408}\u{4F5C}\u{4F19}\u{4F34}\u{548C}\u{56E2}\u{961F}\u{FF0C}\u{5206}\u{4EAB}\u{4FE1}\u{606F}\u{FF0C}\u{7BA1}\u{7406}\u{5BA2}\u{6237}\u{FF0C}\u{8FDB}\u{884C}\u{8BC4}\u{4F30}\u{FF0C}\u{8FDB}\u{884C}\u{63A8}\u{8350}\u{FF0C}\u{8DDF}\u{8E2A}\u{4E8B}\u{4EF6}\u{FF0C}\u{7B49}\u{7B49}\u{3002}\u{7528} ${cumulus} \u{7684}\u{5DE5}\u{4F5C}\u{6D41}\u{7A0B}\u{3001}\u{81EA}\u{52A8}\u{5316}\u{8868}\u{5355}\u{3001}\u{8C03}\u{67E5}\u{548C}\u{4EFB}\u{52A1}\u{53D6}\u{4EE3}\u{7535}\u{5B50}\u{8868}\u{683C}\u{3001}\u{7EB8}\u{8D28}\u{548C}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{3002}`,
    'zh-hant': (cumulus)=>`\u{9023}\u{7D50}\u{5408}\u{4F5C}\u{5925}\u{4F34}\u{8207}\u{5718}\u{968A}\u{3001}\u{5206}\u{4EAB}\u{8CC7}\u{8A0A}\u{3001}\u{7BA1}\u{7406}\u{5BA2}\u{6236}\u{3001}\u{9032}\u{884C}\u{8A55}\u{4F30}\u{3001}\u{8F49}\u{4ECB}\u{3001}\u{8FFD}\u{8E64}\u{4E8B}\u{4EF6}\u{7B49}\u{591A}\u{9805}\u{670D}\u{52D9}\u{3002}\u{7528} ${cumulus} \u{5DE5}\u{4F5C}\u{6D41}\u{7A0B}\u{3001}\u{81EA}\u{52D5}\u{5316}\u{8868}\u{55AE}\u{3001}\u{8ABF}\u{67E5}\u{548C}\u{4EFB}\u{52D9}\u{53D6}\u{4EE3}\u{8A66}\u{7B97}\u{8868}\u{3001}\u{7D19}\u{672C}\u{548C}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{3002}`,
    en: (cumulus)=>`Connect partners and teams, share information, manage clients, conduct assessments, make referrals, track events, and more. Replace spreadsheets, paper, and emails with ${cumulus} workflows, automated forms, surveys, and tasks.`
};
const $b11db1b62d4a8f76$export$aeb30d0c2a766d3 = {
    ar: (cumulus)=>`\u{645}\u{627} \u{627}\u{644}\u{630}\u{64A} \u{64A}\u{645}\u{643}\u{646}\u{643} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} ${cumulus} \u{644}\u{647} \u{623}\u{64A}\u{636}\u{627}\u{61F}`,
    de: (cumulus)=>`Wof\xfcr k\xf6nnte man ${cumulus} sonst noch verwenden?`,
    es: (cumulus)=>`\xbfPara qu\xe9 m\xe1s podr\xedas usar ${cumulus} ?`,
    fa: (cumulus)=>`\u{628}\u{631}\u{627}\u{6CC} \u{686}\u{647} \u{6A9}\u{627}\u{631}\u{647}\u{627}\u{6CC} \u{62F}\u{6CC}\u{6AF}\u{631}\u{6CC} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{6CC}\u{62F} ${cumulus} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}\u{61F}`,
    fil: (cumulus)=>`Ano pa ang maaari mong gamitin ang ${cumulus} para sa?`,
    fr: (cumulus)=>`\xc0 quoi pourriez-vous faire ${cumulus} ?`,
    hi: (cumulus)=>`\u{906}\u{92A} ${cumulus} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{914}\u{930} \u{915}\u{93F}\u{938} \u{932}\u{93F}\u{90F} \u{915}\u{930} \u{938}\u{915}\u{924}\u{947} \u{939}\u{948}\u{902}?`,
    ht: (cumulus)=>`Ki l\xf2t bagay ou ta ka itilize ${cumulus} pou?`,
    it: (cumulus)=>`Cos'altro potresti usare ${cumulus} ?`,
    ja: (cumulus)=>`${cumulus}\u{306F}\u{4ED6}\u{306B}\u{4F55}\u{306B}\u{4F7F}\u{3048}\u{308B}\u{3067}\u{3057}\u{3087}\u{3046}\u{304B}?`,
    ko: (cumulus)=>`${cumulus}\u{B97C} \u{B2E4}\u{B978} \u{C6A9}\u{B3C4}\u{B85C} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C788}\u{C744}\u{AE4C}\u{C694}?`,
    mww: (cumulus)=>`Dab tsi ntxiv koj tuaj yeem siv ${cumulus} rau?`,
    ps: (cumulus)=>`\u{62A}\u{647} \u{646}\u{648}\u{631} \u{685}\u{647} \u{644}\u{67E}\u{627}\u{631}\u{647} ${cumulus} \u{6A9}\u{627}\u{631}\u{648}\u{644}\u{6CC} \u{634}\u{6D0}\u{61F}`,
    pt: (cumulus)=>`Para que mais voc\xea poderia usar ${cumulus} ?`,
    'pt-pt': (cumulus)=>`Para que mais poderias usar ${cumulus} ?`,
    ru: (cumulus)=>`\u{414}\u{43B}\u{44F} \u{447}\u{435}\u{433}\u{43E} \u{435}\u{449}\u{451} ${cumulus} ?`,
    sm: (cumulus)=>`O le a se isi mea e mafai ona e fa'aaogaina ${cumulus} mo?`,
    so: (cumulus)=>`Maxaa kale oo ${cumulus} loo isticmaali karaa?`,
    th: (cumulus)=>`\u{E04}\u{E38}\u{E13}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E43}\u{E0A}\u{E49} ${cumulus} \u{E17}\u{E4D}\u{E32}\u{E2D}\u{E30}\u{E44}\u{E23}\u{E44}\u{E14}\u{E49}\u{E2D}\u{E35}\u{E01}?`,
    ur: (cumulus)=>`${cumulus} \u{6A9}\u{648} \u{627}\u{648}\u{631} \u{6A9}\u{633} \u{6A9}\u{627}\u{645} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631} \u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{61F}`,
    vi: (cumulus)=>`B\u{1EA1}n c\xf3 th\u{1EC3} s\u{1EED} d\u{1EE5}ng ${cumulus} \u{111}\u{1EC3} l\xe0m g\xec kh\xe1c?`,
    'zh-hans': (cumulus)=>`${cumulus}\u{8FD8}\u{80FD}\u{505A}\u{4EC0}\u{4E48}\u{FF1F}`,
    'zh-hant': (cumulus)=>`${cumulus} \u{9084}\u{80FD}\u{7528}\u{4F86}\u{505A}\u{4EC0}\u{9EBC}\u{FF1F}`,
    en: (cumulus)=>`What else could you use ${cumulus} for?`
};
const $b11db1b62d4a8f76$export$ffc352a26526998f = {
    ar: `\u{627}\u{644}\u{62D}\u{644}\u{648}\u{644}`,
    de: `L\xf6sungen`,
    es: `Soluciones`,
    fa: `\u{631}\u{627}\u{647} \u{62D}\u{644} \u{647}\u{627}`,
    fil: `Mga Solusyon`,
    fr: `Solutions`,
    hi: `\u{938}\u{92E}\u{93E}\u{927}\u{93E}\u{928}`,
    ht: `Solisyon yo`,
    it: `Soluzioni`,
    ja: `\u{89E3}\u{6C7A}\u{7B56}`,
    ko: `\u{D574}\u{ACB0}\u{CC45}`,
    mww: `Kev daws teeb meem`,
    ps: `\u{62D}\u{644} \u{644}\u{627}\u{631}\u{6D0}`,
    pt: `Solu\xe7\xf5es`,
    'pt-pt': `Solu\xe7\xf5es`,
    ru: `\u{420}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Fofo`,
    so: `Xalalka`,
    th: `\u{E42}\u{E0B}\u{E25}\u{E39}\u{E0A}\u{E31}\u{E48}\u{E19}`,
    ur: `\u{62D}\u{644}`,
    vi: `Gi\u{1EA3}i ph\xe1p`,
    'zh-hans': `\u{89E3}\u{51B3}\u{65B9}\u{6848}`,
    'zh-hant': `\u{89E3}\u{6C7A}\u{65B9}\u{6848}`,
    en: `Solutions`
};
const $b11db1b62d4a8f76$export$f725eab7abaa007d = {
    ar: $b11db1b62d4a8f76$var$html`حدث خطأ ما. لقد سجلنا الخطأ. يرجى <a class="Link--primary text-bold" href="/support">التواصل مع الدعم</a> إذا استمرت المشكلة.`,
    de: $b11db1b62d4a8f76$var$html`Etwas ist schiefgelaufen. Wir haben den Fehler protokolliert. Bitte <a class="Link--primary text-bold" href="/support">kontaktieren Sie den Support,</a> falls das Problem weiterhin besteht.`,
    es: $b11db1b62d4a8f76$var$html`Algo salió mal. Hemos registrado el error. Por favor <a class="Link--primary text-bold" href="/support">, contacta con el soporte</a> si el problema persiste.`,
    fa: $b11db1b62d4a8f76$var$html`یه چیزی اشتباه پیش اومد. ما خطا را ثبت کرده ایم. لطفا اگر مشکل ادامه داشت <a class="Link--primary text-bold" href="/support">با پشتیبانی تماس بگیرید</a> .`,
    fil: $b11db1b62d4a8f76$var$html`May nangyaring mali. Na-log na namin ang error. Mangyaring <a class="Link--primary text-bold" href="/support">makipag-ugnay sa suporta</a> kung magpapatuloy ang isyu.`,
    fr: $b11db1b62d4a8f76$var$html`Quelque chose a mal tourné. Nous avons enregistré l’erreur. Merci <a class="Link--primary text-bold" href="/support">de contacter le support</a> si le problème persiste.`,
    hi: $b11db1b62d4a8f76$var$html`कुछ गलत हो गया। हमने त्रुटि लॉग कर दी है। यदि समस्या बनी रहती है तो <a class="Link--primary text-bold" href="/support">कृपया समर्थन से संपर्क करें</a> ।`,
    ht: $b11db1b62d4a8f76$var$html`Yon bagay ale mal. Nou te anrejistre erè a Tanpri <a class="Link--primary text-bold" href="/support">kontakte sipò</a> si pwoblèm nan pèsiste.`,
    it: $b11db1b62d4a8f76$var$html`Qualcosa è andato storto. Abbiamo registrato l'errore. Per <a class="Link--primary text-bold" href="/support">favore, contatta l'assistenza</a> se il problema persiste.`,
    ja: $b11db1b62d4a8f76$var$html`何かがうまくいかなかった。エラーは記録済みです。問題が続く場合は <a class="Link--primary text-bold" href="/support">サポートにご連絡</a> ください。`,
    ko: $b11db1b62d4a8f76$var$html`뭔가 잘못됐어. 오류를 기록했습니다. 문제가 계속되면 <a class="Link--primary text-bold" href="/support">고객 지원에 연락</a> 해 주세요.`,
    mww: $b11db1b62d4a8f76$var$html`Ib yam dab tsi mus tsis ncaj ncees lawm. Peb tau teev qhov yuam kev. Thov <a class="Link--primary text-bold" href="/support">hu rau kev txhawb nqa</a> yog tias qhov teeb meem tseem nyob.`,
    ps: $b11db1b62d4a8f76$var$html`یو څه غلط شول. موږ تېروتنه ثبت کړې ده. مهربانی وکړئ که ستونزه دوام ولری، <a class="Link--primary text-bold" href="/support">له ملاتړ سره اړیکه ونیسئ</a> .`,
    pt: $b11db1b62d4a8f76$var$html`Algo deu errado. Registramos o erro. Por favor <a class="Link--primary text-bold" href="/support">, entre em contato com o suporte</a> se o problema persistir.`,
    'pt-pt': $b11db1b62d4a8f76$var$html`Algo correu mal. Já registámos o erro. Por favor <a class="Link--primary text-bold" href="/support">, contacte o suporte</a> se o problema persistir.`,
    ru: $b11db1b62d4a8f76$var$html`Что-то пошло не так. Мы зафиксировали ошибку. Пожалуйста <a class="Link--primary text-bold" href="/support">, свяжитесь с поддержкой</a> , если проблема сохраняется.`,
    sm: $b11db1b62d4a8f76$var$html`Sa i ai se mea na sese. Ua matou fa'amauina le mea sese. <a class="Link--primary text-bold" href="/support">Fa'amolemole fa'afeso'ota'i le lagolago pe</a> a fa'aauau pea le fa'afitauli.`,
    so: $b11db1b62d4a8f76$var$html`Waxbaa qaldamay. Waxaan diiwaangelinay qaladka. Fadlan <a class="Link--primary text-bold" href="/support">la xiriir taageerada</a> haddii arrintu sii jirto.`,
    th: $b11db1b62d4a8f76$var$html`มีบางอย่างผิดพลาด เราได้บันทึกข้อผิดพลาดแล้ว โปรดติดต่อ <a class="Link--primary text-bold" href="/support">ฝ่ายสนับสนุน</a> หากปัญหายังคงอยู่`,
    ur: $b11db1b62d4a8f76$var$html`کچھ غلط ہو گیا۔ ہم نے ایرر کو لاگ کر لیا ہے۔ اگر مسئلہ برقرار رہے تو <a class="Link--primary text-bold" href="/support">براہ کرم سپورٹ سے رابطہ کریں۔</a>`,
    vi: $b11db1b62d4a8f76$var$html`Đã xảy ra sự cố. Chúng tôi đã ghi lại lỗi. Vui lòng <a class="Link--primary text-bold" href="/support">liên hệ với bộ phận hỗ trợ</a> nếu sự cố vẫn tiếp diễn.`,
    'zh-hans': $b11db1b62d4a8f76$var$html`出了点问题。我们已经记录了错误。如果问题依旧，请联系 <a class="Link--primary text-bold" href="/support">客服</a> 。`,
    'zh-hant': $b11db1b62d4a8f76$var$html`出了問題。我們已經記錄錯誤。如果問題持續，請 <a class="Link--primary text-bold" href="/support">聯絡客服</a> 。`,
    en: $b11db1b62d4a8f76$var$html`Something went wrong. We've logged the error. Please <a class="Link--primary text-bold" href="/support">contact support</a> if the issue persists.`
};
const $b11db1b62d4a8f76$export$eebe030e6f9fc49 = {
    ar: `\u{627}\u{644}\u{62A}\u{631}\u{62A}\u{64A}\u{628}`,
    de: `Sortieren`,
    es: `Ordenar`,
    fa: `\u{645}\u{631}\u{62A}\u{628} \u{6A9}\u{646}`,
    fil: `Ayusin`,
    fr: `Trier`,
    hi: `\u{915}\u{94D}\u{930}\u{92E}\u{92C}\u{926}\u{94D}\u{927} \u{915}\u{930}\u{947}\u{902}`,
    ht: `S\xf2t`,
    it: `Ordina`,
    ja: `\u{30BD}\u{30FC}\u{30C8}`,
    ko: `\u{C815}\u{B82C}`,
    mww: `Txheeb`,
    ps: `Sort`,
    pt: `Sortem`,
    'pt-pt': `Ordenar`,
    ru: `\u{421}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{430}`,
    sm: `Fa'avasega`,
    so: `Kala sooc`,
    th: `\u{E40}\u{E23}\u{E35}\u{E22}\u{E07}\u{E25}\u{E4D}\u{E32}\u{E14}\u{E31}\u{E1A}`,
    ur: `\u{62A}\u{631}\u{62A}\u{6CC}\u{628}`,
    vi: `S\u{1EAF}p x\u{1EBF}p`,
    'zh-hans': `\u{6392}\u{5E8F}`,
    'zh-hant': `\u{6392}\u{5E8F}`,
    en: `Sort`
};
const $b11db1b62d4a8f76$export$b0002ad409eb5cbd = {
    ar: `\u{631}\u{642}\u{645} \u{627}\u{644}\u{636}\u{645}\u{627}\u{646} \u{627}\u{644}\u{627}\u{62C}\u{62A}\u{645}\u{627}\u{639}\u{64A}`,
    de: `SSN`,
    es: `SSN`,
    fa: `\u{634}\u{645}\u{627}\u{631}\u{647} \u{62A}\u{623}\u{645}\u{6CC}\u{646} \u{627}\u{62C}\u{62A}\u{645}\u{627}\u{639}\u{6CC}`,
    fil: `SSN`,
    fr: `Num\xe9ro de s\xe9curit\xe9 sociale`,
    hi: `\u{90F}\u{938}\u{90F}\u{938}\u{90F}\u{928}`,
    ht: `SSN`,
    it: `SSN`,
    ja: `\u{793E}\u{4F1A}\u{4FDD}\u{969C}\u{756A}\u{53F7}(SSN)`,
    ko: `SSN`,
    mww: `SSN`,
    ps: `SSN`,
    pt: `SSN`,
    'pt-pt': `SSN`,
    ru: `SSN`,
    sm: `SSN`,
    so: `SSN`,
    th: `\u{E40}\u{E2D}\u{E2A}\u{E40}\u{E2D}\u{E2A}\u{E40}\u{E2D}\u{E47}\u{E19}`,
    ur: `SSN`,
    vi: `SSN`,
    'zh-hans': `\u{793E}\u{4F1A}\u{5B89}\u{5168}\u{53F7}\u{7801}`,
    'zh-hant': `\u{793E}\u{6703}\u{5B89}\u{5168}\u{865F}\u{78BC}`,
    en: `SSN`
};
const $b11db1b62d4a8f76$export$7557153287b73f82 = {
    ar: `\u{627}\u{644}\u{637}\u{627}\u{642}\u{645}`,
    de: `Personal`,
    es: `Personal`,
    fa: `\u{6A9}\u{627}\u{631}\u{6A9}\u{646}\u{627}\u{646}`,
    fil: `Mga Tauhan`,
    fr: `Personnel`,
    hi: `\u{938}\u{94D}\u{91F}\u{93E}\u{92B}\u{93C}`,
    ht: `Anplwaye yo`,
    it: `Personale`,
    ja: `\u{30B9}\u{30BF}\u{30C3}\u{30D5}`,
    ko: `\u{AD50}\u{C9C1}\u{C6D0}`,
    mww: `Cov neeg ua hauj lwm`,
    ps: `\u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Equipe`,
    'pt-pt': `Equipa`,
    ru: `\u{41F}\u{435}\u{440}\u{441}\u{43E}\u{43D}\u{430}\u{43B}`,
    sm: `Aufaigaluega`,
    so: `Shaqaalaha`,
    th: `\u{E1A}\u{E38}\u{E04}\u{E25}\u{E32}\u{E01}\u{E23}`,
    ur: `\u{639}\u{645}\u{644}\u{6C1}`,
    vi: `Nh\xe2n s\u{1EF1}`,
    'zh-hans': `\u{5DE5}\u{4F5C}\u{4EBA}\u{5458}`,
    'zh-hant': `\u{6559}\u{8077}\u{54E1}`,
    en: `Staff`
};
const $b11db1b62d4a8f76$export$2eb5eac799b52763 = {
    ar: `\u{627}\u{628}\u{62F}\u{623}`,
    de: `Start`,
    es: `Comienzo`,
    fa: `\u{634}\u{631}\u{648}\u{639}`,
    fil: `Simulan`,
    fr: `D\xe9but`,
    hi: `\u{91A}\u{94C}\u{902}\u{915}`,
    ht: `K\xf2manse`,
    it: `Inizio`,
    ja: `\u{958B}\u{59CB}`,
    ko: `\u{C2DC}\u{C791}`,
    mww: `pib`,
    ps: `\u{67E}\u{6CC}\u{644} \u{6A9}\u{693}\u{647}`,
    pt: `Comece`,
    'pt-pt': `In\xedcio`,
    ru: `\u{41D}\u{430}\u{447}\u{430}\u{43B}\u{43E}`,
    sm: `Amata`,
    so: `Bilow`,
    th: `\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}`,
    ur: `\u{634}\u{631}\u{648}\u{639} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `B\u{1EAF}t \u{111}\u{1EA7}u`,
    'zh-hans': `\u{5F00}\u{59CB}`,
    'zh-hant': `\u{958B}\u{59CB}`,
    en: `Start`
};
const $b11db1b62d4a8f76$export$5f39c8ed730140a6 = {
    ar: `\u{62A}\u{648}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{628}\u{62F}\u{627}\u{64A}\u{629} \u{648}\u{627}\u{644}\u{646}\u{647}\u{627}\u{64A}\u{629}`,
    de: `Start- und Endtermine`,
    es: `Fechas de inicio y fin`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{647}\u{627}\u{6CC} \u{634}\u{631}\u{648}\u{639} \u{648} \u{67E}\u{627}\u{6CC}\u{627}\u{646}`,
    fil: `Mga Petsa ng Pagsisimula at Pagtatapos`,
    fr: `Dates de d\xe9but et de fin`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{914}\u{930} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{924}\u{93F}\u{925}\u{93F}\u{92F}\u{93E}\u{902}`,
    ht: `K\xf2manse & Fen dat`,
    it: `Date di inizio e fine`,
    ja: `\u{958B}\u{59CB}\u{65E5}\u{3068}\u{7D42}\u{4E86}\u{65E5}`,
    ko: `\u{C2DC}\u{C791}\u{C77C}\u{ACFC} \u{C885}\u{B8CC}\u{C77C}\u{B3C4}`,
    mww: `Pib & hnub xaus`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{644} \u{627}\u{648} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{6D0}`,
    pt: `Datas de in\xedcio e fim`,
    'pt-pt': `Datas de in\xedcio e fim`,
    ru: `\u{414}\u{430}\u{442}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Aso amata ma fa'ai'u`,
    so: `Taariikhaha bilowga iyo dhammaadka`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E41}\u{E25}\u{E30}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{622}\u{63A}\u{627}\u{632} \u{627}\u{648}\u{631} \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{6CC}\u{6BA}`,
    vi: `Ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u v\xe0 ng\xe0y k\u{1EBF}t th\xfac`,
    'zh-hans': `\u{5F00}\u{59CB}\u{4E0E}\u{7ED3}\u{675F}\u{65E5}\u{671F}`,
    'zh-hant': `\u{958B}\u{59CB}\u{8207}\u{7D50}\u{675F}\u{65E5}\u{671F}`,
    en: `Start & end dates`
};
const $b11db1b62d4a8f76$export$9504159bc7ac9a88 = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{628}\u{62F}\u{621}`,
    de: `Startdatum`,
    es: `Fecha de inicio`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{634}\u{631}\u{648}\u{639}`,
    fil: `Petsa ng pagsisimula`,
    fr: `Date de d\xe9but`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915}`,
    ht: `K\xf2manse dat`,
    it: `Data di inizio`,
    ja: `\u{958B}\u{59CB}\u{65E5}`,
    ko: `\u{C2DC}\u{C791}\u{C77C}`,
    mww: `Hnub pib`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{644} \u{646}\u{6D0}\u{67C}\u{647}`,
    pt: `Data de in\xedcio`,
    'pt-pt': `Data de in\xedcio`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}`,
    sm: `Aso amata`,
    so: `Taariikhda bilowga`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}`,
    ur: `\u{622}\u{63A}\u{627}\u{632} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u`,
    'zh-hans': `\u{5F00}\u{59CB}\u{65E5}\u{671F}`,
    'zh-hant': `\u{958B}\u{59CB}\u{65E5}\u{671F}`,
    en: `Start date`
};
const $b11db1b62d4a8f76$export$88c17563ef32d480 = {
    ar: `\u{62A}\u{648}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{628}\u{62F}\u{621}/\u{627}\u{644}\u{646}\u{647}\u{627}\u{64A}\u{629}`,
    de: `Start-/Endtermine`,
    es: `Fechas de inicio/final`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{647}\u{627}\u{6CC} \u{634}\u{631}\u{648}\u{639}/\u{67E}\u{627}\u{6CC}\u{627}\u{646}`,
    fil: `Mga petsa ng pagsisimula / pagtatapos`,
    fr: `Dates de d\xe9but/fin`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D}/\u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{924}\u{93F}\u{925}\u{93F}\u{92F}\u{93E}\u{902}`,
    ht: `K\xf2manse / fen dat`,
    it: `Date di inizio/fine`,
    ja: `\u{958B}\u{59CB}\u{30FB}\u{7D42}\u{4E86}\u{65E5}`,
    ko: `\u{C2DC}\u{C791}/\u{C885}\u{B8CC} \u{B0A0}\u{C9DC}`,
    mww: `Hnub pib/xaus`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{644}/\u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{6D0}`,
    pt: `Datas de in\xedcio/t\xe9rmino`,
    'pt-pt': `Datas de in\xedcio/fim`,
    ru: `\u{414}\u{430}\u{442}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Aso amata / fa'ai'u`,
    so: `Taariikhaha bilowga/dhammaadka`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}/\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{634}\u{631}\u{648}\u{639}/\u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{6CC}\u{6BA}`,
    vi: `Ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u/k\u{1EBF}t th\xfac`,
    'zh-hans': `\u{5F00}\u{59CB}/\u{7ED3}\u{675F}\u{65E5}\u{671F}`,
    'zh-hant': `\u{958B}\u{59CB}/\u{7D50}\u{675F}\u{65E5}\u{671F}`,
    en: `Start/end dates`
};
const $b11db1b62d4a8f76$export$ab8bca3dde5867c7 = {
    ar: `\u{648}\u{642}\u{62A} \u{627}\u{644}\u{628}\u{62F}\u{621}`,
    de: `Startzeit`,
    es: `Hora de inicio`,
    fa: `\u{632}\u{645}\u{627}\u{646} \u{634}\u{631}\u{648}\u{639}`,
    fil: `Email Address *`,
    fr: `Heure de d\xe9but`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{938}\u{92E}\u{92F}`,
    ht: `K\xf2manse tan`,
    it: `Orario di inizio`,
    ja: `\u{958B}\u{59CB}\u{6642}\u{9593}`,
    ko: `\u{C2DC}\u{C791} \u{C2DC}\u{AC04}`,
    mww: `Lub sijhawm pib`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{644} \u{648}\u{62E}\u{62A}`,
    pt: `Hor\xe1rio de in\xedcio`,
    'pt-pt': `Hora de in\xedcio`,
    ru: `\u{412}\u{440}\u{435}\u{43C}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430}`,
    sm: `Taimi amata`,
    so: `Waqtiga bilowga`,
    th: `\u{E40}\u{E27}\u{E25}\u{E32}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}`,
    ur: `\u{634}\u{631}\u{648}\u{639} \u{6C1}\u{648}\u{646}\u{6D2} \u{6A9}\u{627} \u{648}\u{642}\u{62A}`,
    vi: `Th\u{1EDD}i gian b\u{1EAF}t \u{111}\u{1EA7}u`,
    'zh-hans': `\u{5F00}\u{8D5B}\u{65F6}\u{95F4}`,
    'zh-hant': `\u{958B}\u{8CFD}\u{6642}\u{9593}`,
    en: `Start time`
};
const $b11db1b62d4a8f76$export$d5c4d5d164503cfb = {
    ar: `\u{627}\u{644}\u{62F}\u{648}\u{644}\u{629}`,
    de: `Bundesstaat`,
    es: `Estado`,
    fa: `\u{627}\u{6CC}\u{627}\u{644}\u{62A}`,
    fil: `Estado`,
    fr: `\xc9tat`,
    hi: `\u{930}\u{93E}\u{91C}\u{94D}\u{92F}`,
    ht: `Eta`,
    it: `Stato`,
    ja: `\u{5DDE}`,
    ko: `\u{AD6D}\u{AC00}`,
    mww: `Lub xeev`,
    ps: `\u{627}\u{6CC}\u{627}\u{644}\u{62A}`,
    pt: `Estado`,
    'pt-pt': `Estado`,
    ru: `\u{428}\u{442}\u{430}\u{442}`,
    sm: `Setete`,
    so: `Gobolka`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}`,
    ur: `\u{631}\u{6CC}\u{627}\u{633}\u{62A}`,
    vi: `Ti\u{1EC3}u bang`,
    'zh-hans': `\u{5DDE}\u{9645}`,
    'zh-hant': `\u{5DDE}`,
    en: `State`
};
const $b11db1b62d4a8f76$export$51027e8a6e256ee6 = {
    ar: `\u{648}\u{643}\u{627}\u{644}\u{629} \u{627}\u{644}\u{62F}\u{648}\u{644}\u{629}`,
    de: `Staatliche Beh\xf6rde`,
    es: `Agencia Estatal`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62F}\u{648}\u{644}\u{62A}\u{6CC}`,
    fil: `Ahensya ng Estado`,
    fr: `Agence d\u{2019}\xc9tat`,
    hi: `\u{930}\u{93E}\u{91C}\u{94D}\u{92F} \u{90F}\u{91C}\u{947}\u{902}\u{938}\u{940}`,
    ht: `Ajans Leta`,
    it: `Agenzia statale`,
    ja: `\u{56FD}\u{5BB6}\u{6A5F}\u{95A2}`,
    ko: `\u{AD6D}\u{AC00} \u{AE30}\u{AD00}`,
    mww: `Lub Xeev Lub Koom Haum`,
    ps: `\u{62F}\u{648}\u{644}\u{62A}\u{6CC} \u{627}\u{62F}\u{627}\u{631}\u{647}`,
    pt: `Ag\xeancia Estatal`,
    'pt-pt': `Ag\xeancia Estatal`,
    ru: `\u{413}\u{43E}\u{441}\u{443}\u{434}\u{430}\u{440}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{43E}\u{435} \u{430}\u{433}\u{435}\u{43D}\u{442}\u{441}\u{442}\u{432}\u{43E}`,
    sm: `Ofisa o le Setete`,
    so: `Hay'adda Gobolka`,
    th: `\u{E2B}\u{E19}\u{E48}\u{E27}\u{E22}\u{E07}\u{E32}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E23}\u{E31}\u{E10}`,
    ur: `\u{631}\u{6CC}\u{627}\u{633}\u{62A}\u{6CC} \u{627}\u{6CC}\u{62C}\u{646}\u{633}\u{6CC}`,
    vi: `C\u{1A1} quan nh\xe0 n\u{1B0}\u{1EDB}c`,
    'zh-hans': `\u{56FD}\u{5BB6}\u{673A}\u{6784}`,
    'zh-hant': `\u{570B}\u{5BB6}\u{6A5F}\u{69CB}`,
    en: `State Agency`
};
const $b11db1b62d4a8f76$export$2f37891188d02837 = {
    ar: `\u{627}\u{644}\u{628}\u{64A}\u{627}\u{646}`,
    de: `Aussage`,
    es: `Enunciado`,
    fa: `\u{628}\u{6CC}\u{627}\u{646}\u{6CC}\u{647}`,
    fil: `Pahayag`,
    fr: `\xc9nonc\xe9`,
    hi: `\u{935}\u{915}\u{94D}\u{924}\u{935}\u{94D}\u{200D}\u{92F}`,
    ht: `Deklarasyon`,
    it: `Enunciato`,
    ja: `\u{547D}\u{984C}`,
    ko: `\u{C9C4}\u{C220}`,
    mww: `Lus Qhia`,
    ps: `\u{628}\u{6CC}\u{627}\u{646}`,
    pt: `Enunciado`,
    'pt-pt': `Enunciado`,
    ru: `\u{423}\u{442}\u{432}\u{435}\u{440}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Fa'amatalaga`,
    so: `Bayaanka`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E41}\u{E16}\u{E25}\u{E07}`,
    ur: `\u{628}\u{6CC}\u{627}\u{646}`,
    vi: `Ph\xe1t bi\u{1EC3}u`,
    'zh-hans': `\u{547D}\u{9898}`,
    'zh-hant': `\u{9673}\u{8FF0}`,
    en: `Statement`
};
const $b11db1b62d4a8f76$export$ffaf319918250682 = {
    ar: `\u{627}\u{644}\u{62A}\u{635}\u{631}\u{64A}\u{62D}\u{627}\u{62A}`,
    de: `Aussagen`,
    es: `Declaraciones`,
    fa: `\u{628}\u{6CC}\u{627}\u{646}\u{6CC}\u{647} \u{647}\u{627}`,
    fil: `Mga Pahayag`,
    fr: `D\xe9clarations`,
    hi: `\u{915}\u{925}\u{928}`,
    ht: `Deklarasyon yo`,
    it: `Dichiarazioni`,
    ja: `\u{58F0}\u{660E}`,
    ko: `\u{C9C4}\u{C220}`,
    mww: `Lus Qhia`,
    ps: `\u{628}\u{6CC}\u{627}\u{646}\u{648}\u{646}\u{647}`,
    pt: `Declara\xe7\xf5es`,
    'pt-pt': `Declara\xe7\xf5es`,
    ru: `\u{423}\u{442}\u{432}\u{435}\u{440}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Fa'amatalaga`,
    so: `Bayaanno`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E41}\u{E16}\u{E25}\u{E07}`,
    ur: `\u{628}\u{6CC}\u{627}\u{646}\u{627}\u{62A}`,
    vi: `Ph\xe1t bi\u{1EC3}u`,
    'zh-hans': `\u{9648}\u{8FF0}`,
    'zh-hant': `\u{9673}\u{8FF0}`,
    en: `Statements`
};
const $b11db1b62d4a8f76$export$a3e65ac984ddaa02 = {
    ar: (label)=>`${label} \u{645}\u{637}\u{644}\u{648}\u{628}\u{629}. \u{623}\u{62F}\u{62E}\u{644} \u{639}\u{646}\u{648}\u{627}\u{646} \u{634}\u{627}\u{631}\u{639} \u{648}\u{633}\u{64A}\u{645}\u{644}\u{623} \u{627}\u{644}\u{628}\u{627}\u{642}\u{64A} \u{62A}\u{644}\u{642}\u{627}\u{626}\u{64A}\u{627}.`,
    de: (label)=>`${label} ist vorgeschrieben. Geben Sie eine Stra\xdfenadresse ein, der Rest wird automatisch ausgef\xfcllt.`,
    es: (label)=>`Se requiere ${label}. Introduce una direcci\xf3n y el resto se completar\xe1 autom\xe1ticamente.`,
    fa: (label)=>`${label} \u{627}\u{644}\u{632}\u{627}\u{645}\u{6CC} \u{627}\u{633}\u{62A}. \u{6CC}\u{6A9} \u{622}\u{62F}\u{631}\u{633} \u{62E}\u{6CC}\u{627}\u{628}\u{627}\u{646} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{628}\u{642}\u{6CC}\u{647} \u{628}\u{647} \u{637}\u{648}\u{631} \u{62E}\u{648}\u{62F}\u{6A9}\u{627}\u{631} \u{67E}\u{631} \u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: (label)=>`Kinakailangan ang ${label}. Magpasok ng isang address ng kalye at ang natitira ay awtomatikong punan.`,
    fr: (label)=>`${label} est obligatoire. Entrez une adresse et le reste se remplira automatiquement.`,
    hi: (label)=>`${label} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964} \u{90F}\u{915} \u{938}\u{921}\u{93C}\u{915} \u{915}\u{93E} \u{92A}\u{924}\u{93E} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{92C}\u{93E}\u{915}\u{940} \u{905}\u{92A}\u{928}\u{947} \u{906}\u{92A} \u{92D}\u{930} \u{91C}\u{93E}\u{90F}\u{917}\u{93E}\u{964}`,
    ht: (label)=>`${label} obligatwa. Antre yon adr\xe8s lari ak r\xe8s la pral ranpli otomatikman.`,
    it: (label)=>`${label} . Inserisci un indirizzo e il resto si completer\xe0 automaticamente.`,
    ja: (label)=>`${label} \u{5FC5}\u{9808}\u{3067}\u{3059}\u{3002}\u{4F4F}\u{6240}\u{3092}\u{5165}\u{529B}\u{3059}\u{308C}\u{3070}\u{3001}\u{4ED6}\u{306E}\u{90E8}\u{5206}\u{306F}\u{81EA}\u{52D5}\u{7684}\u{306B}\u{57CB}\u{3081}\u{3089}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: (label)=>`${label} )\u{AC00} \u{D544}\u{C218}\u{C785}\u{B2C8}\u{B2E4}. \u{AC70}\u{B9AC} \u{C8FC}\u{C18C}\u{B97C} \u{C785}\u{B825}\u{D558}\u{BA74} \u{B098}\u{BA38}\u{C9C0}\u{B294} \u{C790}\u{B3D9}\u{C73C}\u{B85C} \u{CC44}\u{C6CC}\u{C9D1}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} yuav tsum tau ua. Sau ib txoj kev chaw nyob thiab tus so yuav sau cia li.`,
    ps: (label)=>`${label} \u{627}\u{693}\u{6CC}\u{646} \u{62F}\u{6CC}. \u{62F} \u{6A9}\u{648}\u{685}\u{6D0} \u{67E}\u{62A}\u{647} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626} \u{627}\u{648} \u{67E}\u{627}\u{62A}\u{6D0} \u{628}\u{647} \u{67E}\u{647} \u{627}\u{648}\u{62A}\u{648}\u{645}\u{627}\u{62A} \u{689}\u{648}\u{644} \u{689}\u{6A9} \u{634}\u{6CC}.`,
    pt: (label)=>`${label} \xe9 exigido. Digite um endere\xe7o e o restante ser\xe1 preenchido automaticamente.`,
    'pt-pt': (label)=>`${label} \xe9 obrigat\xf3rio. Introduza uma morada e o resto ser\xe1 preenchido automaticamente.`,
    ru: (label)=>`${label} \u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{443}\u{43B}\u{438}\u{447}\u{43D}\u{44B}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441}, \u{438} \u{43E}\u{441}\u{442}\u{430}\u{43B}\u{44C}\u{43D}\u{44B}\u{435} \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{44F}\u{44E}\u{442}\u{441}\u{44F}.`,
    sm: (label)=>`E mana'omia le ${label}. Ulufale i se tuatusi auala ma o le a otometi lava ona fa'atumu le vaega o totoe.`,
    so: (label)=>`${label} ayaa loo baahan yahay. Geli cinwaanka waddada, inta kalena si toos ah ayay u buuxin doonaan.`,
    th: (label)=>`${label} \u{E1B}\u{E49}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E41}\u{E25}\u{E30}\u{E2A}\u{E48}\u{E27}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E2B}\u{E25}\u{E37}\u{E2D}\u{E08}\u{E30}\u{E01}\u{E23}\u{E2D}\u{E01}\u{E42}\u{E14}\u{E22}\u{E2D}\u{E31}\u{E15}\u{E42}\u{E19}\u{E21}\u{E31}\u{E15}\u{E34}`,
    ur: (label)=>`${label} \u{644}\u{627}\u{632}\u{645}\u{6CC} \u{6C1}\u{6D2}\u{6D4} \u{627}\u{633}\u{679}\u{631}\u{6CC}\u{679} \u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{628}\u{627}\u{642}\u{6CC} \u{62E}\u{648}\u{62F} \u{628}\u{62E}\u{648}\u{62F} \u{628}\u{6BE}\u{631} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA} \u{6AF}\u{6D2}\u{6D4}`,
    vi: (label)=>`${label} l\xe0 b\u{1EAF}t bu\u{1ED9}c. Nh\u{1EAD}p \u{111}\u{1ECB}a ch\u{1EC9} \u{111}\u{1B0}\u{1EDD}ng ph\u{1ED1} v\xe0 ph\u{1EA7}n c\xf2n l\u{1EA1}i s\u{1EBD} t\u{1EF1} \u{111}\u{1ED9}ng \u{111}i\u{1EC1}n.`,
    'zh-hans': (label)=>`\u{5DDE}${label}\u{8BF4}\u{660E}\u{3002}\u{8F93}\u{5165}\u{8857}\u{9053}\u{5730}\u{5740}\u{FF0C}\u{5176}\u{4ED6}\u{5730}\u{5740}\u{4F1A}\u{81EA}\u{52A8}\u{586B}\u{5199}\u{3002}`,
    'zh-hant': (label)=>`\u{5DDE}${label}\u{3002}\u{8F38}\u{5165}\u{8857}\u{9053}\u{5730}\u{5740}\u{FF0C}\u{5176}\u{4ED6}\u{5730}\u{5740}\u{6703}\u{81EA}\u{52D5}\u{586B}\u{5BEB}\u{3002}`,
    en: (label)=>`${label} is required. Enter a street address and the rest will fill in automatically.`
};
const $b11db1b62d4a8f76$export$12cf1b7764815e0f = {
    ar: `\u{627}\u{644}\u{62D}\u{627}\u{644}\u{629}`,
    de: `Status`,
    es: `Estado`,
    fa: `\u{648}\u{636}\u{639}\u{6CC}\u{62A}`,
    fil: `Katayuan`,
    fr: `Statut`,
    hi: `\u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F}`,
    ht: `Estati`,
    it: `Stato`,
    ja: `\u{73FE}\u{72B6}`,
    ko: `\u{D604}\u{D669}`,
    mww: `Cov xwm txheej`,
    ps: `\u{648}\u{636}\u{639}\u{6CC}\u{62A}`,
    pt: `Status`,
    'pt-pt': `Estado`,
    ru: `\u{421}\u{442}\u{430}\u{442}\u{443}\u{441}`,
    sm: `Tulaga`,
    so: `Xaaladda`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}`,
    ur: `\u{62D}\u{6CC}\u{62B}\u{6CC}\u{62A}`,
    vi: `Tr\u{1EA1}ng th\xe1i`,
    'zh-hans': `\u{73B0}\u{72B6}`,
    'zh-hant': `\u{73FE}\u{6CC1}`,
    en: `Status`
};
const $b11db1b62d4a8f76$export$1f89b864013015b4 = {
    ar: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} اعتبارا من ${statusDate}</span>`,
    de: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} am ${statusDate}</span>`,
    es: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} a ${statusDate}</span>`,
    fa: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} شده تا ${statusDate}</span>`,
    fil: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} noong ${statusDate}</span>`,
    fr: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} au ${statusDate}</span>`,
    hi: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${statusDate} तक ${status}</span>`,
    ht: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} ${statusDate}</span>`,
    it: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} al ${statusDate}</span>`,
    ja: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${statusDate}日をもって${status}</span>`,
    ko: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${statusDate}일 ${status}</span>`,
    mww: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} raws li ${statusDate}</span>`,
    ps: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>د ${statusDate} پورې ${status}</span>`,
    pt: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} em ${statusDate}</span>`,
    'pt-pt': (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} a ${statusDate}</span>`,
    ru: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} по состоянию на ${statusDate}</span>`,
    sm: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} i le ${statusDate}</span>`,
    so: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} ilaa ${statusDate}</span>`,
    th: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} ณ วันที่ ${statusDate}</span>`,
    ur: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${statusDate} تک ${status}</span>`,
    vi: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} kể từ ngày ${statusDate}</span>`,
    'zh-hans': (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>截至${statusDate}${status}</span>`,
    'zh-hant': (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>於${statusDate}日${status}</span>`,
    en: (status, statusDate)=>$b11db1b62d4a8f76$var$html`<span>${status} as of ${statusDate}</span>`
};
const $b11db1b62d4a8f76$export$7a733e8549484409 = {
    ar: `\u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{634}\u{627}\u{631}\u{639}`,
    de: `Stra\xdfenadresse`,
    es: `Direcci\xf3n`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{62E}\u{6CC}\u{627}\u{628}\u{627}\u{646}`,
    fil: `Email Address`,
    fr: `Adresse de rue`,
    hi: `\u{938}\u{921}\u{93C}\u{915} \u{915}\u{93E} \u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s lari`,
    it: `Indirizzo`,
    ja: `\u{4F4F}\u{6240}`,
    ko: `\u{AC70}\u{B9AC} \u{C8FC}\u{C18C}`,
    mww: `Chaw nyob ntawm txoj kev`,
    ps: `\u{62F} \u{6A9}\u{648}\u{685}\u{6D0} \u{67E}\u{62A}\u{647}`,
    pt: `Endere\xe7o da rua`,
    'pt-pt': `Endere\xe7o`,
    ru: `\u{410}\u{434}\u{440}\u{435}\u{441} \u{443}\u{43B}\u{438}\u{446}\u{44B}`,
    sm: `Tuatusi o le auala`,
    so: `Cinwaanka waddada`,
    th: `\u{E17}\u{E35}\u{E48}\u{E15}\u{E31}\u{E49}\u{E07}`,
    ur: `\u{6AF}\u{644}\u{6CC} \u{6A9}\u{627} \u{67E}\u{62A}\u{6C1}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} \u{111}\u{1B0}\u{1EDD}ng ph\u{1ED1}`,
    'zh-hans': `\u{8857}\u{9053}\u{5730}\u{5740}`,
    'zh-hant': `\u{8857}\u{9053}\u{5730}\u{5740}`,
    en: `Street address`
};
const $b11db1b62d4a8f76$export$16e4a72732f4def6 = {
    ar: (cumulus)=>`\u{627}\u{628}\u{62F}\u{623} \u{628}\u{643}\u{62A}\u{627}\u{628}\u{629} \u{639}\u{646}\u{648}\u{627}\u{646} \u{634}\u{627}\u{631}\u{639} \u{648}\u{633}\u{64A}\u{645}\u{644}\u{623} ${cumulus} \u{627}\u{644}\u{628}\u{627}\u{642}\u{64A}`,
    de: (cumulus)=>`Fang an, eine Stra\xdfenadresse einzugeben, und ${cumulus} f\xfcllt den Rest aus`,
    es: (cumulus)=>`Empieza a escribir una direcci\xf3n y ${cumulus} completar\xe1 el resto`,
    fa: (cumulus)=>`\u{634}\u{631}\u{648}\u{639} \u{628}\u{647} \u{62A}\u{627}\u{6CC}\u{67E} \u{6CC}\u{6A9} \u{622}\u{62F}\u{631}\u{633} \u{62E}\u{6CC}\u{627}\u{628}\u{627}\u{646} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} ${cumulus} \u{628}\u{642}\u{6CC}\u{647} \u{631}\u{627} \u{67E}\u{631} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F}`,
    fil: (cumulus)=>`Simulan ang pag-type ng address ng kalye at ${cumulus} ang natitira`,
    fr: (cumulus)=>`Commencez \xe0 taper une adresse et ${cumulus} compl\xe9tera le reste`,
    hi: (cumulus)=>`\u{90F}\u{915} \u{938}\u{921}\u{93C}\u{915} \u{915}\u{93E} \u{92A}\u{924}\u{93E} \u{91F}\u{93E}\u{907}\u{92A} \u{915}\u{930}\u{928}\u{93E} \u{936}\u{941}\u{930}\u{942} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} ${cumulus} \u{92C}\u{93E}\u{915}\u{940} \u{915}\u{94B} \u{92D}\u{930} \u{926}\u{947}\u{917}\u{93E}`,
    ht: (cumulus)=>`K\xf2manse tape yon adr\xe8s lari ak ${cumulus} pral ranpli r\xe8s la`,
    it: (cumulus)=>`Inizia a digitare un indirizzo e ${cumulus} completer\xe0 il resto`,
    ja: (cumulus)=>`\u{4F4F}\u{6240}\u{3092}\u{5165}\u{529B}\u{3057}\u{59CB}\u{3081}\u{308C}\u{3070} ${cumulus} \u{304C}\u{6B8B}\u{308A}\u{3092}\u{57CB}\u{3081}\u{3066}\u{304F}\u{308C}\u{307E}\u{3059}`,
    ko: (cumulus)=>`\u{AC70}\u{B9AC} \u{C8FC}\u{C18C}\u{B97C} \u{D0C0}\u{C774}\u{D551}\u{D558}\u{AE30} \u{C2DC}\u{C791}\u{D558}\u{BA74} ${cumulus} \u{AC00} \u{B098}\u{BA38}\u{C9C0}\u{B97C} \u{CC44}\u{C6CC}\u{C904} \u{AC70}\u{C608}\u{C694}`,
    mww: (cumulus)=>`Pib ntaus ib txoj kev chaw nyob thiab ${cumulus} yuav sau rau hauv tus so`,
    ps: (cumulus)=>`\u{62F} \u{6A9}\u{648}\u{685}\u{6D0} \u{67E}\u{62A}\u{647} \u{67C}\u{627}\u{6CC}\u{67E} \u{6A9}\u{693}\u{647} \u{627}\u{648} ${cumulus} \u{628}\u{647} \u{67E}\u{627}\u{62A}\u{6D0} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{689}\u{6A9} \u{6A9}\u{693}\u{6CC}`,
    pt: (cumulus)=>`Comece a digitar um endere\xe7o e ${cumulus} preenche o restante`,
    'pt-pt': (cumulus)=>`Comece a escrever uma morada e ${cumulus} preenche o resto`,
    ru: (cumulus)=>`\u{41D}\u{430}\u{447}\u{43D}\u{438}\u{442}\u{435} \u{432}\u{432}\u{43E}\u{434}\u{438}\u{442}\u{44C} \u{443}\u{43B}\u{438}\u{447}\u{43D}\u{44B}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441}, ${cumulus} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442} \u{43E}\u{441}\u{442}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435}`,
    sm: (cumulus)=>`Amata ona taina se tuatusi o le auala ma o le a faatumuina e ${cumulus} le vaega o totoe`,
    so: (cumulus)=>`Bilow inaad qorto cinwaanka waddada, ${cumulus} ayaa buuxin doonta inta kale`,
    th: (cumulus)=>`\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E41}\u{E25}\u{E30} ${cumulus} \u{E08}\u{E30}\u{E01}\u{E23}\u{E2D}\u{E01}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E17}\u{E35}\u{E48}\u{E40}\u{E2B}\u{E25}\u{E37}\u{E2D}`,
    ur: (cumulus)=>`\u{627}\u{633}\u{679}\u{631}\u{6CC}\u{679} \u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633} \u{679}\u{627}\u{626}\u{67E} \u{6A9}\u{631}\u{646}\u{627} \u{634}\u{631}\u{648}\u{639} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} ${cumulus} \u{628}\u{627}\u{642}\u{6CC} \u{628}\u{6BE}\u{631} \u{62F}\u{6D2} \u{6AF}\u{627}`,
    vi: (cumulus)=>`B\u{1EAF}t \u{111}\u{1EA7}u nh\u{1EAD}p \u{111}\u{1ECB}a ch\u{1EC9} \u{111}\u{1B0}\u{1EDD}ng ph\u{1ED1} v\xe0 ${cumulus} s\u{1EBD} \u{111}i\u{1EC1}n v\xe0o ph\u{1EA7}n c\xf2n l\u{1EA1}i`,
    'zh-hans': (cumulus)=>`\u{5F00}\u{59CB}\u{8F93}\u{5165}\u{8857}\u{9053}\u{5730}\u{5740}\u{FF0C} ${cumulus} \u{4F1A}\u{5E2E}\u{4F60}\u{586B}\u{8865}\u{5269}\u{4E0B}\u{7684}`,
    'zh-hant': (cumulus)=>`\u{958B}\u{59CB}\u{8F38}\u{5165}\u{8857}\u{9053}\u{5730}\u{5740}\u{FF0C} ${cumulus} \u{6703}\u{5E6B}\u{4F60}\u{586B}\u{88DC}\u{5269}\u{4E0B}\u{7684}`,
    en: (cumulus)=>`Start typing a street address and ${cumulus} will fill in the rest`
};
const $b11db1b62d4a8f76$export$cd19dd7fc7738c62 = {
    ar: `\u{627}\u{644}\u{623}\u{633}\u{644}\u{648}\u{628}`,
    de: `Stil`,
    es: `Estilo`,
    fa: `\u{633}\u{628}\u{6A9}`,
    fil: `Estilo`,
    fr: `Style`,
    hi: `\u{935}\u{930}\u{94D}\u{924}\u{93F}\u{915}\u{93E}`,
    ht: `Style`,
    it: `Stile`,
    ja: `\u{30B9}\u{30BF}\u{30A4}\u{30EB}`,
    ko: `\u{C2A4}\u{D0C0}\u{C77C}`,
    mww: `Qauv`,
    ps: `\u{633}\u{628}\u{6A9}`,
    pt: `Estilo`,
    'pt-pt': `Estilo`,
    ru: `\u{421}\u{442}\u{438}\u{43B}\u{44C}`,
    sm: `Sitaili`,
    so: `Qaabka`,
    th: `\u{E2A}\u{E44}\u{E15}\u{E25}\u{E4C}`,
    ur: `\u{627}\u{646}\u{62F}\u{627}\u{632}`,
    vi: `Phong c\xe1ch`,
    'zh-hans': `\u{98CE}\u{683C}`,
    'zh-hant': `\u{98A8}\u{683C}`,
    en: `Style`
};
const $b11db1b62d4a8f76$export$770a7072c65bfb8b = {
    ar: `\u{627}\u{644}\u{62A}\u{635}\u{645}\u{64A}\u{645} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{645}\u{627}\u{631}\u{643}\u{62F}\u{627}\u{648}\u{646} \u{645}\u{62F}\u{639}\u{648}\u{645}`,
    de: `Styling mit Markdown wird unterst\xfctzt`,
    es: `Se soporta el estilismo con Markdown`,
    fa: `\u{637}\u{631}\u{627}\u{62D}\u{6CC} \u{628}\u{627} \u{645}\u{627}\u{631}\u{6A9} \u{62F}\u{627}\u{648}\u{646} \u{67E}\u{634}\u{62A}\u{6CC}\u{628}\u{627}\u{646}\u{6CC} \u{645}\u{6CC} \u{634}\u{648}\u{62F}`,
    fil: `Sinusuportahan ang pag-istilo gamit ang Markdown`,
    fr: `Le styling avec Markdown est support\xe9`,
    hi: `\u{92E}\u{93E}\u{930}\u{94D}\u{915}\u{921}\u{93E}\u{909}\u{928} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{938}\u{94D}\u{91F}\u{93E}\u{907}\u{932}\u{93F}\u{902}\u{917} \u{938}\u{92E}\u{930}\u{94D}\u{925}\u{93F}\u{924} \u{939}\u{948}`,
    ht: `Manier ak Markdown sip\xf2te`,
    it: `Lo stile con Markdown \xe8 supportato`,
    ja: `Markdown\u{306B}\u{3088}\u{308B}\u{30B9}\u{30BF}\u{30A4}\u{30EA}\u{30F3}\u{30B0}\u{3082}\u{30B5}\u{30DD}\u{30FC}\u{30C8}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}`,
    ko: `Markdown \u{C2A4}\u{D0C0}\u{C77C}\u{B9C1}\u{B3C4} \u{C9C0}\u{C6D0}\u{D569}\u{B2C8}\u{B2E4}`,
    mww: `Styling nrog Markdown tau txais kev txhawb nqa`,
    ps: `\u{62F} Markdown \u{633}\u{631}\u{647} \u{689}\u{6CC}\u{632}\u{627}\u{6CC}\u{646} \u{645}\u{644}\u{627}\u{62A}\u{693} \u{6A9}\u{6CC}\u{696}\u{6CC}`,
    pt: `O estilo com Markdown \xe9 suportado`,
    'pt-pt': `O estilo com Markdown \xe9 suportado`,
    ru: `\u{41F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{435}\u{442}\u{441}\u{44F} \u{441}\u{442}\u{438}\u{43B}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{441} Markdown`,
    sm: `E lagolagoina le fa'ata'ita'iga ma le Markdown`,
    so: `Naqshadeynta Markdown waa la taageeraa`,
    th: `\u{E23}\u{E2D}\u{E07}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E08}\u{E31}\u{E14}\u{E41}\u{E15}\u{E48}\u{E07}\u{E17}\u{E23}\u{E07}\u{E1C}\u{E21}\u{E14}\u{E49}\u{E27}\u{E22} Markdown`,
    ur: `\u{645}\u{627}\u{631}\u{6A9} \u{688}\u{627}\u{624}\u{646} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{627}\u{633}\u{679}\u{627}\u{626}\u{644}\u{646}\u{6AF} \u{6A9}\u{6CC} \u{62D}\u{645}\u{627}\u{6CC}\u{62A} \u{6A9}\u{6CC} \u{62C}\u{627}\u{62A}\u{6CC} \u{6C1}\u{6D2}`,
    vi: `H\u{1ED7} tr\u{1EE3} t\u{1EA1}o ki\u{1EC3}u b\u{1EB1}ng Markdown`,
    'zh-hans': `\u{652F}\u{6301}Markdown\u{6837}\u{5F0F}`,
    'zh-hant': `\u{652F}\u{63F4}\u{4F7F}\u{7528} Markdown \u{7684}\u{6A23}\u{5F0F}\u{8A2D}\u{8A08}`,
    en: `Styling with Markdown is supported`
};
const $b11db1b62d4a8f76$export$1867f1fb86ca52 = {
    ar: `\u{634}\u{642}\u{629} / \u{62C}\u{646}\u{627}\u{62D} / \u{648}\u{62D}\u{62F}\u{629}`,
    de: `Wohnung / Suite / Einheit`,
    es: `Apartamento / suite / unidad`,
    fa: `\u{622}\u{67E}\u{627}\u{631}\u{62A}\u{645}\u{627}\u{646} / \u{633}\u{648}\u{626}\u{6CC}\u{62A} / \u{648}\u{627}\u{62D}\u{62F}`,
    fil: `Apartment / suite / unit`,
    fr: `Appartement / suite / unit\xe9`,
    hi: `\u{905}\u{92A}\u{93E}\u{930}\u{94D}\u{91F}\u{92E}\u{947}\u{902}\u{91F}/\u{938}\u{941}\u{907}\u{91F}/\u{92F}\u{942}\u{928}\u{93F}\u{91F}`,
    ht: `Apatman / suite / inite`,
    it: `Appartamento / suite / unit\xe0`,
    ja: `\u{30A2}\u{30D1}\u{30FC}\u{30C8}\u{30E1}\u{30F3}\u{30C8}/\u{30B9}\u{30A4}\u{30FC}\u{30C8}/\u{30E6}\u{30CB}\u{30C3}\u{30C8}`,
    ko: `\u{C544}\u{D30C}\u{D2B8} / \u{C2A4}\u{C704}\u{D2B8}\u{B8F8} / \u{C720}\u{B2DB}`,
    mww: `Chav tsev / suite / chav tsev`,
    ps: `\u{627}\u{67E}\u{627}\u{631}\u{62A}\u{645}\u{627}\u{646} / \u{633}\u{648}\u{6CC}\u{67C} / \u{648}\u{627}\u{62D}\u{62F}`,
    pt: `Apartamento / su\xedte / unidade`,
    'pt-pt': `Apartamento / suite / unidade`,
    ru: `\u{41A}\u{432}\u{430}\u{440}\u{442}\u{438}\u{440}\u{430} / \u{43B}\u{44E}\u{43A}\u{441} / \u{43A}\u{432}\u{430}\u{440}\u{442}\u{438}\u{440}\u{430}`,
    sm: `Fale mautotogi / suite / iunite`,
    so: `Guri / qol / unug`,
    th: `\u{E2D}\u{E1E}\u{E32}\u{E23}\u{E4C}\u{E17}\u{E40}\u{E21}\u{E19}\u{E17}\u{E4C} / \u{E2B}\u{E49}\u{E2D}\u{E07}\u{E2A}\u{E27}\u{E35}\u{E17} / \u{E22}\u{E39}\u{E19}\u{E34}\u{E15}`,
    ur: `\u{627}\u{67E}\u{627}\u{631}\u{679}\u{645}\u{646}\u{679} / \u{633}\u{648}\u{626}\u{679} / \u{6CC}\u{648}\u{646}\u{679}`,
    vi: `C\u{103}n h\u{1ED9} / suite / c\u{103}n h\u{1ED9}`,
    'zh-hans': `\u{516C}\u{5BD3} / \u{5957}\u{623F} / \u{5355}\u{5143}`,
    'zh-hant': `\u{516C}\u{5BD3}/\u{5957}\u{623F}/\u{55AE}\u{4F4D}`,
    en: `Apartment / suite / unit`
};
const $b11db1b62d4a8f76$export$e45e1052e4defba = {
    ar: `\u{627}\u{644}\u{62A}\u{642}\u{62F}\u{64A}\u{645}`,
    de: `Einreichen`,
    es: `Enviar`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `Soumettre`,
    hi: `\u{91C}\u{92E}\u{93E} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Soum\xe8t`,
    it: `Invia`,
    ja: `\u{63D0}\u{51FA}`,
    ko: `\u{C81C}\u{CD9C}\u{D558}\u{C138}\u{C694}`,
    mww: `zwm`,
    ps: `\u{648}\u{693}\u{627}\u{646}\u{62F}\u{6D0} \u{6A9}\u{693}\u{647}`,
    pt: `Enviar`,
    'pt-pt': `Submeter`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C}`,
    sm: `Alu e ave i totonu`,
    so: `Gudbi`,
    th: `\u{E2A}\u{E48}\u{E07}`,
    ur: `\u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{648}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `G\u{1EED}i`,
    'zh-hans': `\u{63D0}\u{4EA4}`,
    'zh-hant': `\u{63D0}\u{4EA4}`,
    en: `Submit`
};
const $b11db1b62d4a8f76$export$47596adf6caa9a84 = {
    ar: `\u{62A}\u{645} \u{627}\u{644}\u{62A}\u{642}\u{62F}\u{64A}\u{645}`,
    de: `Eingereicht`,
    es: `Enviado`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644} \u{634}\u{62F}\u{647}`,
    fil: `Isinumite`,
    fr: `Soumis`,
    hi: `\u{938}\u{92C}\u{92E}\u{93F}\u{91F} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Soum\xe8t`,
    it: `Inviato`,
    ja: `\u{63D0}\u{51FA}`,
    ko: `\u{C81C}\u{CD9C}\u{B428}`,
    mww: `Xa`,
    ps: `\u{633}\u{67E}\u{627}\u{631}\u{644} \u{634}\u{648}\u{6CC}`,
    pt: `Submetido`,
    'pt-pt': `Submetido`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{43E}`,
    sm: `Auina atu`,
    so: `La gudbiyey`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{627}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `\u{110}\xe3 g\u{1EED}i`,
    'zh-hans': `\u{63D0}\u{4EA4}`,
    'zh-hant': `\u{63D0}\u{4EA4}`,
    en: `Submitted`
};
const $b11db1b62d4a8f76$export$5959138f6dc63705 = {
    ar: `\u{625}\u{631}\u{633}\u{627}\u{644} \u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{645}\u{648}\u{627}\u{639}\u{64A}\u{62F}`,
    de: `Stundenzettel einreichen`,
    es: `Enviar la hoja de horas`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646} \u{628}\u{646}\u{62F}\u{6CC}`,
    fil: `Email Address *`,
    fr: `Soumettre la feuille de temps`,
    hi: `\u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{91C}\u{92E}\u{93E} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Soum\xe8t Timesheet`,
    it: `Invia il foglio orario`,
    ja: `\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{3092}\u{63D0}\u{51FA}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C} \u{C81C}\u{CD9C}`,
    mww: `Xa daim ntawv qhia sijhawm`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647} \u{648}\u{633}\u{67E}\u{627}\u{631}\u{626}`,
    pt: `Envie a folha de ponto`,
    'pt-pt': `Submeter folha de horas`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}`,
    sm: `Auina atu le pepa o taimi`,
    so: `Soo gudbi jadwalka waqtiga`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}`,
    ur: `\u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{648}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `G\u{1EED}i b\u{1EA3}ng ch\u{1EA5}m c\xf4ng`,
    'zh-hans': `\u{63D0}\u{4EA4}\u{5DE5}\u{65F6}\u{8868}`,
    'zh-hant': `\u{63D0}\u{4EA4}\u{5DE5}\u{6642}\u{8868}`,
    en: `Submit timesheet`
};
const $b11db1b62d4a8f76$export$227e06aea85a8240 = {
    ar: `\u{642}\u{62F}\u{645} \u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{62F}\u{648}\u{627}\u{645} \u{644}\u{644}\u{645}\u{648}\u{627}\u{641}\u{642}\u{629} \u{639}\u{644}\u{64A}\u{647}`,
    de: `Stundenzettel zur Genehmigung einreichen`,
    es: `Env\xeda la hoja de horas para su aprobaci\xf3n`,
    fa: `\u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646} \u{628}\u{646}\u{62F}\u{6CC} \u{631}\u{627} \u{628}\u{631}\u{627}\u{6CC} \u{62A}\u{623}\u{6CC}\u{6CC}\u{62F} \u{627}\u{631}\u{633}\u{627}\u{644} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Magsumite ng timesheet para sa pag-apruba`,
    fr: `Soumettez la feuille de temps pour approbation`,
    hi: `\u{905}\u{928}\u{941}\u{92E}\u{94B}\u{926}\u{928} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{91C}\u{92E}\u{93E} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Soum\xe8t Timesheet pou apwobasyon`,
    it: `Invia il foglio presenze per l'approvazione`,
    ja: `\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{3092}\u{627F}\u{8A8D}\u{306E}\u{305F}\u{3081}\u{306B}\u{63D0}\u{51FA}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{C2B9}\u{C778}\u{C744} \u{C704}\u{D574} \u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C}\u{B97C} \u{C81C}\u{CD9C}\u{D558}\u{C138}\u{C694}`,
    mww: `Xa daim ntawv teev sijhawm rau kev pom zoo`,
    ps: `\u{62F} \u{62A}\u{627}\u{6CC}\u{6CC}\u{62F} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647} \u{648}\u{633}\u{67E}\u{627}\u{631}\u{626}`,
    pt: `Envie a folha de ponto para aprova\xe7\xe3o`,
    'pt-pt': `Submeta a folha de horas para aprova\xe7\xe3o`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{44C}\u{442}\u{435} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{434}\u{43B}\u{44F} \u{443}\u{442}\u{432}\u{435}\u{440}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Auina atu le pepa o taimi mo le faamaoniga`,
    so: `Soo gudbi jadwalka waqtiga si loo ansixiyo`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E02}\u{E2D}\u{E2D}\u{E19}\u{E38}\u{E21}\u{E31}\u{E15}\u{E34}`,
    ur: `\u{645}\u{646}\u{638}\u{648}\u{631}\u{6CC} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{648}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `G\u{1EED}i b\u{1EA3}ng ch\u{1EA5}m c\xf4ng \u{111}\u{1EC3} ph\xea duy\u{1EC7}t`,
    'zh-hans': `\u{63D0}\u{4EA4}\u{5DE5}\u{65F6}\u{8868}\u{4EE5}\u{4F9B}\u{5BA1}\u{6279}`,
    'zh-hant': `\u{63D0}\u{4EA4}\u{5DE5}\u{6642}\u{8868}\u{4EE5}\u{4F9B}\u{6838}\u{51C6}`,
    en: `Submit timesheet for approval`
};
const $b11db1b62d4a8f76$export$111b9e9b1ab035e9 = {
    ar: `\u{627}\u{634}\u{62A}\u{631}\u{643}`,
    de: `Abonnieren`,
    es: `Suscr\xedbete`,
    fa: `\u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `Abonnez-vous`,
    hi: `\u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{932}\u{947}\u{902}`,
    ht: `Ab\xf2nman`,
    it: `Abbonati`,
    ja: `\u{8CFC}\u{8AAD}`,
    ko: `\u{AD6C}\u{B3C5}\u{D558}\u{C138}\u{C694}`,
    mww: `Sau npe yuav`,
    ps: `\u{6AB}\u{689}\u{648}\u{646} \u{648}\u{6A9}\u{693}\u{626}`,
    pt: `Assine`,
    'pt-pt': `Subscreva`,
    ru: `\u{41F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{442}\u{44C}\u{441}\u{44F}`,
    sm: `Lesitala`,
    so: `Isdiiwaangeli`,
    th: `\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}`,
    ur: `\u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{103}ng k\xfd`,
    'zh-hans': `\u{8BA2}\u{9605}`,
    'zh-hant': `\u{8A02}\u{95B1}`,
    en: `Subscribe`
};
const $b11db1b62d4a8f76$export$5eec64cb77d7c11a = {
    ar: `\u{645}\u{634}\u{62A}\u{631}\u{643}`,
    de: `Abonniert`,
    es: `Suscrito`,
    fa: `\u{645}\u{634}\u{62A}\u{631}\u{6A9} \u{634}\u{62F}\u{647}`,
    fil: `Email Address *`,
    fr: `Abonn\xe9`,
    hi: `\u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{932}\u{940}`,
    ht: `Ab\xf2nman`,
    it: `Abbonato`,
    ja: `\u{8CFC}\u{8AAD}\u{8005}`,
    ko: `\u{AD6C}\u{B3C5} \u{C644}\u{B8CC}`,
    mww: `Sau npe`,
    ps: `\u{6AB}\u{689}\u{648}\u{646} \u{634}\u{648}\u{6CC}`,
    pt: `Assinado`,
    'pt-pt': `Subscrevido`,
    ru: `\u{41F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}`,
    sm: `Lesitala`,
    so: `Isdiiwaangeliyey`,
    th: `\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}`,
    ur: `\u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `\u{110}\xe3 \u{111}\u{103}ng k\xfd`,
    'zh-hans': `\u{8BA2}\u{9605}`,
    'zh-hant': `\u{8A02}\u{95B1}\u{4E2D}`,
    en: `Subscribed`
};
const $b11db1b62d4a8f76$export$820673857d24e132 = {
    ar: `\u{627}\u{644}\u{645}\u{634}\u{62A}\u{631}\u{643}\u{648}\u{646}`,
    de: `Abonnenten`,
    es: `Suscriptores`,
    fa: `\u{645}\u{634}\u{62A}\u{631}\u{6A9}\u{6CC}\u{646}`,
    fil: `Mga Tagasuskribi`,
    fr: `Abonn\xe9s`,
    hi: `\u{905}\u{902}\u{936}\u{926}\u{93E}\u{928}`,
    ht: `Abonn\xe9s yo`,
    it: `Abbonati`,
    ja: `\u{52A0}\u{5165}\u{8005}`,
    ko: `\u{AD6C}\u{B3C5}\u{C790}`,
    mww: `Cov neeg rau npe`,
    ps: `\u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644}`,
    pt: `Assinantes`,
    'pt-pt': `Assinantes`,
    ru: `\u{41F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{447}\u{438}\u{43A}\u{438}`,
    sm: `Tagata fai saofaga`,
    so: `Macaamiisha`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}`,
    ur: `\u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628}\u{631}\u{632}`,
    vi: `Ng\u{1B0}\u{1EDD}i \u{111}\u{103}ng k\xfd`,
    'zh-hans': `\u{8BA2}\u{9605}\u{8005}`,
    'zh-hant': `\u{8A02}\u{95B1}\u{8005}`,
    en: `Subscribers`
};
const $b11db1b62d4a8f76$export$83683a52fe785bc5 = {
    ar: (count)=>`${count} \u{645}\u{634}\u{62A}\u{631}\u{643}\u{627}`,
    de: (count)=>`${count} Abonnenten`,
    es: (count)=>`${count} suscriptores`,
    fa: (count)=>`${count} \u{645}\u{634}\u{62A}\u{631}\u{6A9}`,
    fil: (count)=>`${count} mga tagasuskribi`,
    fr: (count)=>`${count} abonn\xe9s`,
    hi: (count)=>`${count} \u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915}`,
    ht: (count)=>`${count} abonn\xe9s`,
    it: (count)=>`${count} abbonati`,
    ja: (count)=>`${count} \u{4EBA}\u{306E}\u{52A0}\u{5165}\u{8005}`,
    ko: (count)=>`${count} \u{BA85}`,
    mww: (count)=>`${count} tus neeg rau npe`,
    ps: (count)=>`${count} \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644}`,
    pt: (count)=>`${count} assinantes`,
    'pt-pt': (count)=>`${count} subscritores`,
    ru: (count)=>`${count} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{447}\u{438}\u{43A}\u{43E}\u{432}`,
    sm: (count)=>`${count} tagata fai saofaga`,
    so: (count)=>`${count} macaamiil`,
    th: (count)=>`\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01} ${count} \u{E04}\u{E19}`,
    ur: (count)=>`${count} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628}\u{631}\u{632}`,
    vi: (count)=>`${count} ng\u{1B0}\u{1EDD}i \u{111}\u{103}ng k\xfd`,
    'zh-hans': (count)=>`${count} \u{540D}\u{8BA2}\u{9605}\u{8005}`,
    'zh-hant': (count)=>`${count} \u{540D}\u{8A02}\u{95B1}\u{8005}`,
    en: (count)=>`${count} subscribers`
};
const $b11db1b62d4a8f76$export$c56fede01e2ac3b9 = {
    ar: `\u{627}\u{644}\u{644}\u{627}\u{62D}\u{642}\u{629}`,
    de: `Suffix`,
    es: `Sufijo`,
    fa: `\u{67E}\u{633}\u{648}\u{646}\u{62F}`,
    fil: `Suffix`,
    fr: `Suffixe`,
    hi: `\u{905}\u{928}\u{941}\u{932}\u{917}\u{94D}\u{200D}\u{928}`,
    ht: `Sifiks`,
    it: `Suffisso`,
    ja: `\u{63A5}\u{5C3E}\u{8F9E}`,
    ko: `\u{C811}\u{BBF8}\u{C0AC}`,
    mww: `suffix`,
    ps: `\u{67E}\u{633}\u{648}\u{646}\u{62F}`,
    pt: `Sufixo`,
    'pt-pt': `Sufixo`,
    ru: `\u{421}\u{443}\u{444}\u{444}\u{438}\u{43A}\u{441}`,
    sm: `Suffix`,
    so: `Dhammaad`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E15}\u{E48}\u{E2D}\u{E17}\u{E49}\u{E32}\u{E22}`,
    ur: `\u{644}\u{627}\u{62D}\u{642}\u{6C1}`,
    vi: `H\u{1EAD}u t\u{1ED1}`,
    'zh-hans': `\u{540E}\u{7F00}`,
    'zh-hant': `\u{5F8C}\u{7DB4}`,
    en: `Suffix`
};
const $b11db1b62d4a8f76$export$fd9f456d77941a4 = {
    ar: `\u{627}\u{644}\u{645}\u{644}\u{62E}\u{635}`,
    de: `Zusammenfassung`,
    es: `Resumen`,
    fa: `\u{62E}\u{644}\u{627}\u{635}\u{647}`,
    fil: `Buod`,
    fr: `R\xe9sum\xe9`,
    hi: `\u{938}\u{93E}\u{930}\u{93E}\u{902}\u{936}`,
    ht: `Rezime`,
    it: `Sommario`,
    ja: `\u{6982}\u{8981}`,
    ko: `\u{C694}\u{C57D}`,
    mww: `Ntsiab lus`,
    ps: `\u{644}\u{646}\u{689}\u{6CC}\u{632}`,
    pt: `Resumo`,
    'pt-pt': `Resumo`,
    ru: `\u{41A}\u{440}\u{430}\u{442}\u{43A}\u{43E}\u{435} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Aotelega`,
    so: `Soo koobid`,
    th: `\u{E2A}\u{E23}\u{E38}\u{E1B}`,
    ur: `\u{62E}\u{644}\u{627}\u{635}\u{6C1}`,
    vi: `T\xf3m t\u{1EAF}t`,
    'zh-hans': `\u{6458}\u{8981}`,
    'zh-hant': `\u{6458}\u{8981}`,
    en: `Summary`
};
const $b11db1b62d4a8f76$export$b8784963d833b7d4 = {
    ar: `\u{64A}\u{634}\u{631}\u{641} \u{639}\u{644}\u{649} \u{645}\u{646}\u{638}\u{645}\u{629} \u{62A}\u{634}\u{627}\u{631}\u{643} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `\xdcberwacht eine Organisation, die an dieser Aktivit\xe4t teilnimmt.`,
    es: `Supervisa a una organizaci\xf3n que participa en esta actividad.`,
    fa: `\u{646}\u{638}\u{627}\u{631}\u{62A} \u{628}\u{631} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{634}\u{631}\u{6A9}\u{62A} \u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `Pangasiwaan ang isang organisasyon na nakikilahok sa aktibidad na ito.`,
    fr: `Supervise une organisation participant \xe0 cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92E}\u{947}\u{902} \u{92D}\u{93E}\u{917} \u{932}\u{947}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{940} \u{926}\u{947}\u{916}\u{930}\u{947}\u{916} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Sip\xe8vize yon \xf2ganizasyon k ap patisipe nan aktivite sa a.`,
    it: `Supervisiona un'organizzazione che partecipa a questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306B}\u{53C2}\u{52A0}\u{3059}\u{308B}\u{7D44}\u{7E54}\u{3092}\u{76E3}\u{7763}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{CC38}\u{C5EC}\u{D558}\u{B294} \u{C870}\u{C9C1}\u{C744} \u{AC10}\u{B3C5}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Saib xyuas ib lub koom haum uas koom nrog txoj haujlwm no.`,
    ps: `\u{647}\u{63A}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{685}\u{627}\u{631}\u{6CC} \u{686}\u{6D0} \u{67E}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D0} \u{628}\u{631}\u{62E}\u{647} \u{627}\u{62E}\u{644}\u{6CC}.`,
    pt: `Supervisiona uma organiza\xe7\xe3o que participa dessa atividade.`,
    'pt-pt': `Supervisiona uma organiza\xe7\xe3o que participa nesta atividade.`,
    ru: `\u{41A}\u{443}\u{440}\u{438}\u{440}\u{443}\u{435}\u{442} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44E}, \u{443}\u{447}\u{430}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{443}\u{44E} \u{432} \u{44D}\u{442}\u{43E}\u{439} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}.`,
    sm: `Vaavaaia se faalapotopotoga o loo auai i lenei gaoioiga.`,
    so: `Waxay kormeertaa urur ka qayb qaadanaya hawshan.`,
    th: `\u{E01}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E1A}\u{E14}\u{E39}\u{E41}\u{E25}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{62D}\u{635}\u{6C1} \u{644}\u{6CC}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6CC} \u{646}\u{6AF}\u{631}\u{627}\u{646}\u{6CC} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Gi\xe1m s\xe1t m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c tham gia ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{76D1}\u{7763}\u{53C2}\u{4E0E}\u{8BE5}\u{6D3B}\u{52A8}\u{7684}\u{7EC4}\u{7EC7}\u{3002}`,
    'zh-hant': `\u{76E3}\u{7763}\u{53C3}\u{8207}\u{6B64}\u{6D3B}\u{52D5}\u{7684}\u{7D44}\u{7E54}\u{3002}`,
    en: `Supervises an organization participating in this activity.`
};
const $b11db1b62d4a8f76$export$7260ef100fa55b7c = {
    ar: (project)=>`\u{64A}\u{634}\u{631}\u{641} \u{639}\u{644}\u{649} \u{645}\u{634}\u{631}\u{648}\u{639} ${project} .`,
    de: (project)=>`\xdcberwacht das ${project} .`,
    es: (project)=>`Supervisa el proyecto ${project} .`,
    fa: (project)=>`\u{646}\u{638}\u{627}\u{631}\u{62A} \u{628}\u{631} \u{67E}\u{631}\u{648}\u{698}\u{647} ${project} .`,
    fil: (project)=>`Pangangasiwa sa ${project} .`,
    fr: (project)=>`Supervise le projet ${project} .`,
    hi: (project)=>`${project} \u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E} \u{915}\u{940} \u{926}\u{947}\u{916}\u{930}\u{947}\u{916} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (project)=>`Sip\xe8vize pwoj\xe8 ${project} la.`,
    it: (project)=>`Supervisiona il progetto ${project} .`,
    ja: (project)=>`${project}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{3092}\u{76E3}\u{7763}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: (project)=>`${project} \u{D504}\u{B85C}\u{C81D}\u{D2B8}\u{B97C} \u{AC10}\u{B3C5}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (project)=>`Saib xyuas txoj haujlwm ${project} .`,
    ps: (project)=>`\u{62F} ${project} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{685}\u{627}\u{631}\u{6CC}.`,
    pt: (project)=>`Supervisiona o projeto ${project} .`,
    'pt-pt': (project)=>`Supervisiona o projeto ${project} .`,
    ru: (project)=>`\u{41A}\u{443}\u{440}\u{438}\u{440}\u{443}\u{435}\u{442} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442} ${project} .`,
    sm: (project)=>`Va'ava'aia le poloketi ${project} .`,
    so: (project)=>`Waxay kormeertaa mashruuca ${project} karo.`,
    th: (project)=>`\u{E14}\u{E39}\u{E41}\u{E25}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}${project}`,
    ur: (project)=>`${project} \u{6A9}\u{6D2} \u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2} \u{6A9}\u{6CC} \u{646}\u{6AF}\u{631}\u{627}\u{646}\u{6CC} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (project)=>`Gi\xe1m s\xe1t d\u{1EF1} \xe1n ${project} .`,
    'zh-hans': (project)=>`\u{76D1}\u{7763} ${project} \u{9879}\u{76EE}\u{3002}`,
    'zh-hant': (project)=>`\u{76E3}\u{7763} ${project} \u{8A08}\u{756B}\u{3002}`,
    en: (project)=>`Supervises the ${project} project.`
};
const $b11db1b62d4a8f76$export$911dda8e10c12221 = {
    ar: `\u{627}\u{644}\u{62F}\u{639}\u{645}`,
    de: `Unterst\xfctzung`,
    es: `Apoyo`,
    fa: `\u{67E}\u{634}\u{62A}\u{6CC}\u{628}\u{627}\u{646}\u{6CC}`,
    fil: `Suporta`,
    fr: `Soutien`,
    hi: `\u{91C}\u{940}\u{935}\u{93F}\u{915}\u{93E}`,
    ht: `Sip\xf2`,
    it: `Supporto`,
    ja: `\u{652F}\u{63F4}`,
    ko: `\u{C9C0}\u{C6D0}`,
    mww: `Kev them nyiaj yug`,
    ps: `\u{645}\u{644}\u{627}\u{62A}\u{693}`,
    pt: `Apoio`,
    'pt-pt': `Apoio`,
    ru: `\u{41F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{430}`,
    sm: `Lagolago`,
    so: `Taageero`,
    th: `\u{E01}\u{E32}\u{E23}\u{E2A}\u{E19}\u{E31}\u{E1A}\u{E2A}\u{E19}\u{E38}\u{E19}`,
    ur: `\u{62D}\u{645}\u{627}\u{6CC}\u{62A}`,
    vi: `H\u{1ED7} tr\u{1EE3}`,
    'zh-hans': `\u{652F}\u{6301}`,
    'zh-hant': `\u{652F}\u{6301}`,
    en: `Support`
};
const $b11db1b62d4a8f76$export$547fa6c1c303b781 = {
    ar: `\u{62A}\u{645} \u{62A}\u{639}\u{644}\u{64A}\u{642} \u{627}\u{644}\u{625}\u{64A}\u{642}\u{627}\u{641}`,
    de: `Suspendiert`,
    es: `Suspendido`,
    fa: `\u{62A}\u{639}\u{644}\u{6CC}\u{642} \u{634}\u{62F}\u{647}`,
    fil: `Sinuspinde`,
    fr: `Suspendu`,
    hi: `\u{928}\u{93F}\u{932}\u{902}\u{92C}\u{93F}\u{924}`,
    ht: `Sispansyon`,
    it: `Sospesi`,
    ja: `\u{505C}\u{8077}\u{4E2D}`,
    ko: `\u{C815}\u{C9C0}`,
    mww: `raug tshem tawm`,
    ps: `\u{62A}\u{639}\u{644}\u{6CC}\u{642} \u{634}\u{648}\u{6CC}`,
    pt: `Suspenso`,
    'pt-pt': `Suspenso`,
    ru: `\u{41E}\u{442}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{451}\u{43D}\u{43D}\u{44B}\u{439}`,
    sm: `Fa'amalolo`,
    so: `Joojiyay`,
    th: `\u{E16}\u{E39}\u{E01}\u{E23}\u{E30}\u{E07}\u{E31}\u{E1A}`,
    ur: `\u{645}\u{639}\u{637}\u{644}`,
    vi: `T\u{1EA1}m ng\u{1B0}ng`,
    'zh-hans': `\u{505C}\u{8D5B}`,
    'zh-hant': `\u{505C}\u{8CFD}`,
    en: `Suspended`
};
const $b11db1b62d4a8f76$export$db54828cd8994902 = {
    ar: `\u{646}\u{638}\u{627}\u{645} \u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{642}`,
    de: `Aufh\xe4ngung`,
    es: `Suspensi\xf3n`,
    fa: `\u{62A}\u{639}\u{644}\u{6CC}\u{642}`,
    fil: `Suspensyon`,
    fr: `Suspension`,
    hi: `\u{928}\u{93F}\u{932}\u{902}\u{92C}\u{928}`,
    ht: `Sispansyon`,
    it: `Sospensioni`,
    ja: `\u{30B5}\u{30B9}\u{30DA}\u{30F3}\u{30B7}\u{30E7}\u{30F3}`,
    ko: `\u{C11C}\u{C2A4}\u{D39C}\u{C158}`,
    mww: `Kev ncua`,
    ps: `\u{62A}\u{639}\u{644}\u{6CC}\u{642}`,
    pt: `Suspens\xe3o`,
    'pt-pt': `Suspens\xe3o`,
    ru: `\u{41F}\u{43E}\u{434}\u{432}\u{435}\u{441}\u{43A}\u{430}`,
    sm: `Fa'amalolo`,
    so: `Joojinta`,
    th: `\u{E01}\u{E32}\u{E23}\u{E23}\u{E30}\u{E07}\u{E31}\u{E1A}`,
    ur: `\u{645}\u{639}\u{637}\u{644}\u{6CC}`,
    vi: `\u{110}\xecnh ch\u{1EC9}`,
    'zh-hans': `\u{60AC}\u{6302}`,
    'zh-hant': `\u{61F8}\u{540A}\u{7CFB}\u{7D71}`,
    en: `Suspension`
};
const $b11db1b62d4a8f76$export$9a1e89f8dab4343 = {
    ar: `\u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{642}\u{627}\u{62A}`,
    de: `Aufh\xe4ngungen`,
    es: `Suspensiones`,
    fa: `\u{62A}\u{639}\u{644}\u{6CC}\u{642} \u{647}\u{627}`,
    fil: `Mga Suspensyon`,
    fr: `Suspensions`,
    hi: `\u{928}\u{93F}\u{932}\u{902}\u{92C}\u{928}`,
    ht: `Sispansyon`,
    it: `Sospensioni`,
    ja: `\u{30B5}\u{30B9}\u{30DA}\u{30F3}\u{30B7}\u{30E7}\u{30F3}`,
    ko: `\u{C11C}\u{C2A4}\u{D39C}\u{C158}`,
    mww: `Kev Ncua Kev Kawm Ntawv`,
    ps: `\u{62A}\u{639}\u{644}\u{6CC}\u{642} \u{634}\u{648}\u{6CC}`,
    pt: `Suspens\xf5es`,
    'pt-pt': `Suspens\xf5es`,
    ru: `\u{41F}\u{43E}\u{434}\u{432}\u{435}\u{441}\u{43A}\u{438}`,
    sm: `Fa'amalolo`,
    so: `Joojinta`,
    th: `\u{E01}\u{E32}\u{E23}\u{E23}\u{E30}\u{E07}\u{E31}\u{E1A}`,
    ur: `\u{645}\u{639}\u{637}\u{644}\u{6CC}\u{627}\u{6BA}`,
    vi: `\u{110}\xecnh ch\u{1EC9}`,
    'zh-hans': `\u{60AC}\u{6302}`,
    'zh-hant': `\u{61F8}\u{639B}\u{7CFB}\u{7D71}`,
    en: `Suspensions`
};
const $b11db1b62d4a8f76$export$35592e87641eee6 = {
    ar: `\u{627}\u{633}\u{62A}\u{628}\u{62F}\u{627}\u{644}...`,
    de: `Tauschen...`,
    es: `Intercambiar...`,
    fa: `\u{62A}\u{639}\u{648}\u{6CC}\u{636}...`,
    fil: `Palitan ...`,
    fr: `\xc9changer...`,
    hi: `\u{935}\u{93F}\u{928}\u{93F}\u{92E}\u{92F} \u{915}\u{930}\u{928}\u{93E}\u{964}\u{964}\u{964}`,
    ht: `Swap ...`,
    it: `Scambia...`,
    ja: `\u{30B9}\u{30EF}\u{30C3}\u{30D7}...`,
    ko: `\u{C2A4}\u{C651}...`,
    mww: `Sib pauv...`,
    ps: `\u{628}\u{62F}\u{644}\u{648}\u{644}...`,
    pt: `Trocar...`,
    'pt-pt': `Trocar...`,
    ru: `\u{41E}\u{431}\u{43C}\u{435}\u{43D}...`,
    sm: `Fesuia'i...`,
    so: `Isweydaarsi...`,
    th: `\u{E2A}\u{E25}\u{E31}\u{E1A}...`,
    ur: `\u{628}\u{62F}\u{644}\u{648}...`,
    vi: `Ho\xe1n \u{111}\u{1ED5}i...`,
    'zh-hans': `\u{4EA4}\u{6362}......`,
    'zh-hant': `\u{4EA4}\u{63DB}......`,
    en: `Swap...`
};
const $b11db1b62d4a8f76$export$84313ca5bb99db28 = {
    ar: `\u{62A}\u{628}\u{62F}\u{64A}\u{644} \u{627}\u{644}\u{62F}\u{645}\u{62C} \u{648}\u{627}\u{644}\u{627}\u{633}\u{62A}\u{645}\u{631}\u{627}\u{631} \u{641}\u{64A} \u{627}\u{644}...`,
    de: `Tauschen, zusammenf\xfchren und behalten...`,
    es: `Intercambiar, fusionar y mantener...`,
    fa: `\u{62A}\u{639}\u{648}\u{6CC}\u{636}\u{60C} \u{627}\u{62F}\u{63A}\u{627}\u{645} \u{648} \u{646}\u{6AF}\u{647} \u{62F}\u{627}\u{634}\u{62A}\u{646}...`,
    fil: `Swap, pagsamahin at panatilihin ...`,
    fr: `\xc9changer, fusionner et garder...`,
    hi: `\u{938}\u{94D}\u{935}\u{948}\u{92A}, \u{92E}\u{930}\u{94D}\u{91C} \u{914}\u{930} \u{915}\u{940}\u{92A}...`,
    ht: `Swap rantre & kenbe...`,
    it: `Scambia, fondi e tieni...`,
    ja: `\u{30B9}\u{30EF}\u{30C3}\u{30D7}\u{3001}\u{30DE}\u{30FC}\u{30B8}\u{3001}\u{305D}\u{3057}\u{3066}\u{30AD}\u{30FC}\u{30D7}...`,
    ko: `\u{C2A4}\u{C651}, \u{D569}\u{BCD1}, \u{ADF8}\u{B9AC}\u{ACE0} \u{C720}\u{C9C0}...`,
    mww: `Swap merge & khaws cia ...`,
    ps: `\u{62A}\u{628}\u{627}\u{62F}\u{644}\u{647} \u{6CC}\u{648}\u{681}\u{627}\u{6CC} \u{6A9}\u{693}\u{647} \u{627}\u{648} \u{648}\u{633}\u{627}\u{62A}\u{647}...`,
    pt: `Trocar, mesclar e manter...`,
    'pt-pt': `Trocar, fundir e manter...`,
    ru: `\u{41E}\u{431}\u{43C}\u{435}\u{43D}, \u{441}\u{43B}\u{438}\u{44F}\u{43D}\u{438}\u{435} \u{438} \u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{438}\u{435}...`,
    sm: `Fa'apipi'i fa'apipi'i ma fa'apipi'i ...`,
    so: `Is-weydaarsi, isku dar, oo sii hay...`,
    th: `\u{E2A}\u{E25}\u{E31}\u{E1A}\u{E1C}\u{E2A}\u{E32}\u{E19}\u{E41}\u{E25}\u{E30}\u{E40}\u{E01}\u{E47}\u{E1A}...`,
    ur: `\u{62A}\u{628}\u{62F}\u{6CC}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{60C} \u{645}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{628}\u{631}\u{642}\u{631}\u{627}\u{631} \u{631}\u{6A9}\u{6BE}\u{6CC}\u{6BA}...`,
    vi: `Ho\xe1n \u{111}\u{1ED5}i, h\u{1EE3}p nh\u{1EA5}t v\xe0 gi\u{1EEF}...`,
    'zh-hans': `\u{4EA4}\u{6362}\u{5408}\u{5E76}\u{5E76}\u{4FDD}\u{6301}......`,
    'zh-hant': `\u{4EA4}\u{63DB}\u{5408}\u{4F75}\u{4E26}\u{4FDD}\u{6301}......`,
    en: `Swap merge & keep...`
};
const $b11db1b62d4a8f76$export$5f009e0fa3d2cf28 = {
    ar: `\u{646}\u{638}\u{627}\u{645} \u{627}\u{644}\u{627}\u{641}\u{62A}\u{631}\u{627}\u{636}\u{64A}`,
    de: `Systemstandard`,
    es: `Sistema predeterminado`,
    fa: `\u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636} \u{633}\u{6CC}\u{633}\u{62A}\u{645}`,
    fil: `System Default`,
    fr: `Par d\xe9faut syst\xe8me`,
    hi: `\u{938}\u{93F}\u{938}\u{94D}\u{91F}\u{92E} \u{921}\u{93F}\u{92B}\u{93C}\u{949}\u{932}\u{94D}\u{91F}`,
    ht: `Sist\xe8m Default`,
    it: `Sistema predefinito`,
    ja: `\u{30B7}\u{30B9}\u{30C6}\u{30E0}\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}`,
    ko: `\u{C2DC}\u{C2A4}\u{D15C} \u{AE30}\u{BCF8} \u{C0C1}\u{D0DC}`,
    mww: `System Default`,
    ps: `\u{633}\u{6CC}\u{633}\u{67C}\u{645} \u{689}\u{6CC}\u{641}\u{627}\u{644}\u{67C}`,
    pt: `Sistema Padr\xe3o`,
    'pt-pt': `Padr\xe3o do Sistema`,
    ru: `\u{421}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{430} \u{43F}\u{43E} \u{443}\u{43C}\u{43E}\u{43B}\u{447}\u{430}\u{43D}\u{438}\u{44E}`,
    sm: `Fa'aletonu o le Faiga`,
    so: `Nidaamka Default`,
    th: `\u{E04}\u{E48}\u{E32}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E23}\u{E30}\u{E1A}\u{E1A}`,
    ur: `\u{633}\u{633}\u{679}\u{645} \u{688}\u{6CC}\u{641}\u{627}\u{644}\u{679}`,
    vi: `M\u{1EB7}c \u{111}\u{1ECB}nh h\u{1EC7} th\u{1ED1}ng`,
    'zh-hans': `\u{7CFB}\u{7EDF}\u{9ED8}\u{8BA4}`,
    'zh-hant': `\u{7CFB}\u{7D71}\u{9810}\u{8A2D}`,
    en: `System Default`
};
const $b11db1b62d4a8f76$export$34939fd411dd88a8 = {
    ar: `\u{627}\u{644}\u{645}\u{647}\u{645}\u{629}`,
    de: `Aufgabe`,
    es: `Tarea`,
    fa: `\u{648}\u{638}\u{6CC}\u{641}\u{647}`,
    fil: `Gawain`,
    fr: `T\xe2che`,
    hi: `\u{928}\u{93F}\u{92F}\u{924} \u{915}\u{93E}\u{930}\u{94D}\u{92F}`,
    ht: `Travay la`,
    it: `Compito`,
    ja: `\u{4EFB}\u{52D9}`,
    ko: `\u{C784}\u{BB34}`,
    mww: `Tes haujlwm`,
    ps: `\u{62F}\u{646}\u{62F}\u{647}`,
    pt: `Tarefa`,
    'pt-pt': `Tarefa`,
    ru: `\u{417}\u{430}\u{434}\u{430}\u{447}\u{430}`,
    sm: `Galuega`,
    so: `Hawl`,
    th: `\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6A9}\u{627}\u{645}`,
    vi: `Nhi\u{1EC7}m v\u{1EE5}`,
    'zh-hans': `\u{4EFB}\u{52A1}`,
    'zh-hant': `\u{4EFB}\u{52D9}`,
    en: `Task`
};
const $b11db1b62d4a8f76$export$21f7f01186ae91a2 = {
    ar: `\u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644}\u{627}\u{62A}`,
    de: `Telekommunikation`,
    es: `Telecomunicaciones`,
    fa: `\u{645}\u{62E}\u{627}\u{628}\u{631}\u{627}\u{62A}`,
    fil: `Email Address *`,
    fr: `T\xe9l\xe9com`,
    hi: `\u{926}\u{942}\u{930}\u{938}\u{902}\u{91A}\u{93E}\u{930}`,
    ht: `Telecom`,
    it: `Telecomunicazioni`,
    ja: `\u{30C6}\u{30EC}\u{30B3}\u{30E0}`,
    ko: `\u{D1B5}\u{C2E0}`,
    mww: `Telecom`,
    ps: `\u{67C}\u{6CC}\u{644}\u{6CC}\u{6A9}\u{627}\u{645}`,
    pt: `Telecomunica\xe7\xf5es`,
    'pt-pt': `Telecomunica\xe7\xf5es`,
    ru: `\u{422}\u{435}\u{43B}\u{435}\u{43A}\u{43E}\u{43C}`,
    sm: `Feso'ota'iga`,
    so: `Telecom`,
    th: `\u{E42}\u{E17}\u{E23}\u{E04}\u{E21}\u{E19}\u{E32}\u{E04}\u{E21}`,
    ur: `\u{679}\u{6CC}\u{644}\u{6CC} \u{6A9}\u{627}\u{645}`,
    vi: `Vi\u{1EC5}n th\xf4ng`,
    'zh-hans': `\u{7535}\u{4FE1}`,
    'zh-hant': `\u{96FB}\u{4FE1}`,
    en: `Telecom`
};
const $b11db1b62d4a8f76$export$3417ff84b5e88121 = {
    ar: `10 \u{623}\u{645}\u{64A}\u{627}\u{644}`,
    de: `10 Meilen`,
    es: `10 millas`,
    fa: `\u{6F1}\u{6F0} \u{645}\u{627}\u{6CC}\u{644}`,
    fil: `10 milya`,
    fr: `10 miles`,
    hi: `10 \u{92E}\u{940}\u{932}`,
    ht: `10 mil`,
    it: `10 miglia`,
    ja: `10\u{30DE}\u{30A4}\u{30EB}`,
    ko: `10\u{B9C8}\u{C77C}`,
    mww: `10 mais`,
    ps: `\u{6F1}\u{6F0} \u{645}\u{6CC}\u{644}\u{647}`,
    pt: `10 milhas`,
    'pt-pt': `10 milhas`,
    ru: `10 \u{43C}\u{438}\u{43B}\u{44C}`,
    sm: `10 maila`,
    so: `10 mayl`,
    th: `16.1 \u{E01}\u{E21}.`,
    ur: `10 \u{645}\u{6CC}\u{644}`,
    vi: `10 d\u{1EB7}m`,
    'zh-hans': `10\u{82F1}\u{91CC}`,
    'zh-hant': `10\u{82F1}\u{91CC}`,
    en: `10 miles`
};
const $b11db1b62d4a8f76$export$35a00d15fe7d4e8 = {
    ar: `\u{634}\u{631}\u{648}\u{637} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645}`,
    de: `Nutzungsbedingungen`,
    es: `T\xe9rminos de uso`,
    fa: `\u{634}\u{631}\u{627}\u{6CC}\u{637} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647}`,
    fil: `Mga Tuntunin ng Paggamit`,
    fr: `Conditions d\u{2019}utilisation`,
    hi: `\u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{940} \u{936}\u{930}\u{94D}\u{924}\u{947}\u{902}`,
    ht: `Regleman pou Itilize`,
    it: `Termini di utilizzo`,
    ja: `\u{5229}\u{7528}\u{898F}\u{7D04}`,
    ko: `\u{C774}\u{C6A9} \u{C57D}\u{AD00}`,
    mww: `Cov ntsiab lus ntawm Kev Siv`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631}\u{648}\u{646}\u{6D0} \u{634}\u{631}\u{627}\u{6CC}\u{637}`,
    pt: `Termos de Uso`,
    'pt-pt': `Termos de Utiliza\xe7\xe3o`,
    ru: `\u{423}\u{441}\u{43B}\u{43E}\u{432}\u{438}\u{44F} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Tuutuuga o le Faaaogaina`,
    so: `Shuruudaha Isticmaalka`,
    th: `\u{E40}\u{E07}\u{E37}\u{E48}\u{E2D}\u{E19}\u{E44}\u{E02}\u{E01}\u{E32}\u{E23}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{6CC} \u{634}\u{631}\u{627}\u{626}\u{637}`,
    vi: `\u{110}i\u{1EC1}u kho\u{1EA3}n s\u{1EED} d\u{1EE5}ng`,
    'zh-hans': `\u{4F7F}\u{7528}\u{6761}\u{6B3E}`,
    'zh-hant': `\u{4F7F}\u{7528}\u{689D}\u{6B3E}`,
    en: `Terms of Use`
};
const $b11db1b62d4a8f76$export$b0a5b2684ddaafba = {
    ar: `\u{627}\u{644}\u{646}\u{635}`,
    de: `Text`,
    es: `Texto`,
    fa: `\u{645}\u{62A}\u{646}`,
    fil: `Text`,
    fr: `Texte`,
    hi: `\u{91F}\u{947}\u{915}\u{94D}\u{938}\u{94D}\u{91F}`,
    ht: `Mesaj t\xe8ks`,
    it: `Testo`,
    ja: `\u{672C}\u{6587}`,
    ko: `\u{BCF8}\u{BB38}`,
    mww: `Sau ntawv saum xov tooj`,
    ps: `\u{645}\u{62A}\u{646}`,
    pt: `Texto`,
    'pt-pt': `Texto`,
    ru: `\u{422}\u{435}\u{43A}\u{441}\u{442}`,
    sm: `Tusitusiga`,
    so: `Qoraalka`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}`,
    ur: `\u{645}\u{62A}\u{646}`,
    vi: `V\u{103}n b\u{1EA3}n`,
    'zh-hans': `\u{6B63}\u{6587}`,
    'zh-hant': `\u{6B63}\u{6587}`,
    en: `Text`
};
const $b11db1b62d4a8f76$export$825e8c5a8de791dd = {
    ar: (href)=>$b11db1b62d4a8f76$var$html`شكرا لمشاركتك! يمكنك إغلاق هذه الصفحة أو <a href="${href}">بدء مشاركة أخرى</a> لشخص آخر.`,
    de: (href)=>$b11db1b62d4a8f76$var$html`Vielen Dank für Ihre Einsendung! Sie können diese Seite schließen oder für jemand anderen eine <a href="${href}">neue Einreichung starten</a> .`,
    es: (href)=>$b11db1b62d4a8f76$var$html`¡Gracias por tu aportación! Puedes cerrar esta página o <a href="${href}">iniciar otra publicación</a> para otra persona.`,
    fa: (href)=>$b11db1b62d4a8f76$var$html`از ارسال شما سپاسگزاریم! می توانید این صفحه را ببندید یا <a href="${href}">ارسال دیگری برای</a> شخص دیگری شروع کنید.`,
    fil: (href)=>$b11db1b62d4a8f76$var$html`Salamat sa iyong pagsusumite! Maaari mong isara ang pahinang ito o <a href="${href}">magsimula ng panibagong pagsusumite</a> para sa iba.`,
    fr: (href)=>$b11db1b62d4a8f76$var$html`Merci pour votre contribution ! Vous pouvez fermer cette page ou <a href="${href}">en commencer une autre</a> pour quelqu’un d’autre.`,
    hi: (href)=>$b11db1b62d4a8f76$var$html`आपके सबमिशन के लिए धन्यवाद! आप इस पृष्ठ को बंद कर सकते हैं या किसी और के लिए <a href="${href}">एक और सबमिशन शुरू कर</a> सकते हैं।`,
    ht: (href)=>$b11db1b62d4a8f76$var$html`Mèsi pou soumèt ou! Ou ka fèmen paj sa a oswa <a href="${href}">kòmanse yon lòt soumèt</a> pou yon lòt moun.`,
    it: (href)=>$b11db1b62d4a8f76$var$html`Grazie per la tua segnalazione! Puoi chiudere questa pagina o <a href="${href}">iniziare un'altra pubblicazione</a> per qualcun altro.`,
    ja: (href)=>$b11db1b62d4a8f76$var$html`ご投稿ありがとうございます!このページを閉じるか、他の方のために <a href="${href}">別の投稿を始め</a> てください。`,
    ko: (href)=>$b11db1b62d4a8f76$var$html`제출해 주셔서 감사합니다! 이 페이지를 닫거나 다른 분을 위해 <a href="${href}">다른 글을 제출</a> 하실 수 있습니다.`,
    mww: (href)=>$b11db1b62d4a8f76$var$html`Ua tsaug rau koj qhov kev xa ntawv! Koj tuaj yeem kaw nplooj ntawv no lossis <a href="${href}">pib xa ntawv tshiab</a> rau lwm tus.`,
    ps: (href)=>$b11db1b62d4a8f76$var$html`ستاسو د سپارلو لپاره مننه! تاسو کولای شئ دا پاڼه وتړې یا <a href="${href}">بل چا ته بل لیکنه پیل</a> کړئ.`,
    pt: (href)=>$b11db1b62d4a8f76$var$html`Obrigado pela sua publicação! Você pode fechar esta página ou <a href="${href}">começar outra postagem</a> para outra pessoa.`,
    'pt-pt': (href)=>$b11db1b62d4a8f76$var$html`Obrigado pela sua submissão! Pode fechar esta página ou <a href="${href}">iniciar outra submissão</a> para outra pessoa.`,
    ru: (href)=>$b11db1b62d4a8f76$var$html`Спасибо за вашу публикацию! Вы можете закрыть эту страницу или <a href="${href}">начать новую работу</a> для кого-то другого.`,
    sm: (href)=>$b11db1b62d4a8f76$var$html`Fa'afetai mo lau tu'uina atu! E mafai ona e tapunia lenei itulau pe <a href="${href}">amata se isi tusiga</a> mo se isi tagata.`,
    so: (href)=>$b11db1b62d4a8f76$var$html`Waad ku mahadsan tahay soo gudbintaada! Waad xiran kartaa boggan ama <a href="${href}">waxaad bilaabi kartaa</a> qoraal kale oo qof kale ah.`,
    th: (href)=>$b11db1b62d4a8f76$var$html`ขอบคุณสําหรับการส่งโพสต์ของคุณ!คุณสามารถปิดหน้านี้หรือ <a href="${href}">เริ่มส่งโพสต์ใหม่</a> ให้กับคนอื่นได้`,
    ur: (href)=>$b11db1b62d4a8f76$var$html`آپ کی جمع کرائی گئی تحریر کا شکریہ! آپ یہ صفحہ بند کر سکتے ہیں یا کسی اور کے لیے <a href="${href}">دوسرا سبمیشن شروع</a> کر سکتے ہیں۔`,
    vi: (href)=>$b11db1b62d4a8f76$var$html`Cảm ơn bạn đã gửi bài! Bạn có thể đóng trang này hoặc <a href="${href}">bắt đầu gửi bài khác</a> cho người khác.`,
    'zh-hans': (href)=>$b11db1b62d4a8f76$var$html`感谢您的投稿！您可以关闭本页面或 <a href="${href}">为他人重新提交</a> 。`,
    'zh-hant': (href)=>$b11db1b62d4a8f76$var$html`感謝您的投稿！您可以關閉此頁面或 <a href="${href}">為他人重新投稿</a> 。`,
    en: (href)=>$b11db1b62d4a8f76$var$html`Thank you for your submission! You may close this page or <a href="${href}">start another submission</a> for someone else.`
};
const $b11db1b62d4a8f76$export$29e6fca9e5c058b6 = {
    ar: `\u{634}\u{643}\u{631}\u{627} \u{639}\u{644}\u{649} \u{631}\u{62F}\u{643}!`,
    de: `Danke f\xfcr deine Antwort!`,
    es: `\xa1Gracias por responder!`,
    fa: `\u{645}\u{645}\u{646}\u{648}\u{646} \u{6A9}\u{647} \u{67E}\u{627}\u{633}\u{62E} \u{62F}\u{627}\u{62F}\u{6CC}\u{62F}!`,
    fil: `Salamat sa pagtugon!`,
    fr: `Merci pour votre r\xe9ponse !`,
    hi: `\u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{915}\u{94D}\u{930}\u{93F}\u{92F}\u{93E} \u{926}\u{947}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{927}\u{928}\u{94D}\u{92F}\u{935}\u{93E}\u{926}!`,
    ht: `M\xe8si pou reponn!`,
    it: `Grazie per aver risposto!`,
    ja: `\u{3054}\u{8FD4}\u{4FE1}\u{3042}\u{308A}\u{304C}\u{3068}\u{3046}\u{3054}\u{3056}\u{3044}\u{307E}\u{3059}!`,
    ko: `\u{B2F5}\u{BCC0}\u{D574} \u{C8FC}\u{C154}\u{C11C} \u{AC10}\u{C0AC}\u{D569}\u{B2C8}\u{B2E4}!`,
    mww: `Ua tsaug rau koj teb!`,
    ps: `\u{645}\u{646}\u{646}\u{647} \u{686}\u{6D0} \u{681}\u{648}\u{627}\u{628} \u{62F}\u{6D0} \u{631}\u{627}\u{6A9}\u{693}!`,
    pt: `Obrigado por responder!`,
    'pt-pt': `Obrigado pela resposta!`,
    ru: `\u{421}\u{43F}\u{430}\u{441}\u{438}\u{431}\u{43E} \u{437}\u{430} \u{43E}\u{442}\u{432}\u{435}\u{442}!`,
    sm: `Fa'afetai mo le tali mai!`,
    so: `Waad ku mahadsan tahay jawaabta!`,
    th: `\u{E02}\u{E2D}\u{E1A}\u{E04}\u{E38}\u{E13}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E15}\u{E2D}\u{E1A}\u{E01}\u{E25}\u{E31}\u{E1A}!`,
    ur: `\u{62C}\u{648}\u{627}\u{628} \u{62F}\u{6CC}\u{646}\u{6D2} \u{6A9}\u{627} \u{634}\u{6A9}\u{631}\u{6CC}\u{6C1}!`,
    vi: `C\u{1EA3}m \u{1A1}n b\u{1EA1}n \u{111}\xe3 tr\u{1EA3} l\u{1EDD}i!`,
    'zh-hans': `\u{8C22}\u{8C22}\u{4F60}\u{7684}\u{56DE}\u{590D}\u{FF01}`,
    'zh-hant': `\u{8B1D}\u{8B1D}\u{4F60}\u{7684}\u{56DE}\u{8986}\u{FF01}`,
    en: `Thank you for responding!`
};
const $b11db1b62d4a8f76$export$4a01edaa0a874ea5 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{636}\u{648}\u{639}`,
    de: `Thema`,
    es: `Tema`,
    fa: `\u{62A}\u{645}`,
    fil: `Tema`,
    fr: `Th\xe8me`,
    hi: `\u{925}\u{940}\u{92E}`,
    ht: `T\xe8m`,
    it: `Tema`,
    ja: `\u{30C6}\u{30FC}\u{30DE}`,
    ko: `\u{C8FC}\u{C81C}`,
    mww: `Ntsiab lus`,
    ps: `\u{645}\u{648}\u{636}\u{648}\u{639}`,
    pt: `Tema`,
    'pt-pt': `Tema`,
    ru: `\u{422}\u{435}\u{43C}\u{430}`,
    sm: `Autu`,
    so: `Mawduuca`,
    th: `\u{E18}\u{E35}\u{E21}`,
    ur: `\u{645}\u{648}\u{636}\u{648}\u{639}`,
    vi: `Ch\u{1EE7} \u{111}\u{1EC1}`,
    'zh-hans': `\u{4E3B}\u{9898}`,
    'zh-hant': `\u{4E3B}\u{984C}`,
    en: `Theme`
};
const $b11db1b62d4a8f76$export$15f9ff29d697867d = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{639}\u{646}\u{627}\u{648}\u{64A}\u{646}`,
    de: `Es gibt keine Adressen`,
    es: `No hay direcciones`,
    fa: `\u{622}\u{62F}\u{631}\u{633}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang Address`,
    fr: `Il n\u{2019}y a pas d\u{2019}adresses`,
    hi: `\u{915}\u{94B}\u{908} \u{92A}\u{924}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}`,
    ht: `Pa gen adr\xe8s`,
    it: `Non ci sono indirizzi`,
    ja: `\u{4F4F}\u{6240}\u{306F}\u{5B58}\u{5728}\u{3057}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C8FC}\u{C18C}\u{B294} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj chaw nyob`,
    ps: `\u{647}\u{6CC}\u{685} \u{67E}\u{62A}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o h\xe1 endere\xe7os`,
    'pt-pt': `N\xe3o h\xe1 endere\xe7os`,
    ru: `\u{410}\u{434}\u{440}\u{435}\u{441}\u{43E}\u{432} \u{43D}\u{435}\u{442}`,
    sm: `E leai ni tuatusi`,
    so: `Cinwaano ma jiraan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{67E}\u{62A}\u{6C1} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}`,
    vi: `Kh\xf4ng c\xf3 \u{111}\u{1ECB}a ch\u{1EC9}`,
    'zh-hans': `\u{6CA1}\u{6709}\u{5730}\u{5740}`,
    'zh-hant': `\u{6C92}\u{6709}\u{5730}\u{5740}`,
    en: `There are no addresses`
};
const $b11db1b62d4a8f76$export$4f27b1c5b8f8a4ef = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{62C}\u{647}\u{627}\u{62A} \u{627}\u{62A}\u{635}\u{627}\u{644}`,
    de: `Es gibt keine Kontakte.`,
    es: `No hay contactos`,
    fa: `\u{647}\u{6CC}\u{686} \u{62A}\u{645}\u{627}\u{633}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang mga contact`,
    fr: `Il n\u{2019}y a pas de contacts`,
    hi: `\u{915}\u{94B}\u{908} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}`,
    ht: `Pa gen okenn kontak`,
    it: `Non ci sono contatti`,
    ja: `\u{63A5}\u{89E6}\u{8005}\u{306F}\u{3044}\u{306A}\u{3044}`,
    ko: `\u{C811}\u{CD09}\u{C790}\u{AC00} \u{C5C6}\u{C5B4}`,
    mww: `Tsis muaj kev sib cuag`,
    ps: `\u{647}\u{6CC}\u{685} \u{62A}\u{645}\u{627}\u{633}\u{648}\u{646}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o h\xe1 contatos`,
    'pt-pt': `N\xe3o h\xe1 contactos`,
    ru: `\u{41A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}\u{43E}\u{432} \u{43D}\u{435}\u{442}`,
    sm: `E leai ni feso'ota'iga`,
    so: `Ma jiraan xiriir`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E1C}\u{E39}\u{E49}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{631}\u{627}\u{628}\u{637}\u{6D2} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 li\xean h\u{1EC7}`,
    'zh-hans': `\u{6CA1}\u{6709}\u{63A5}\u{89E6}`,
    'zh-hant': `\u{6C92}\u{6709}\u{63A5}\u{89F8}`,
    en: `There are no contacts`
};
const $b11db1b62d4a8f76$export$9dba77cebd8c56e2 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{631}\u{633}\u{627}\u{626}\u{644} \u{628}\u{631}\u{64A}\u{62F} \u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}`,
    de: `Es gibt keine E-Mails`,
    es: `No hay correos electr\xf3nicos`,
    fa: `\u{647}\u{6CC}\u{686} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang mga email`,
    fr: `Il n\u{2019}y a pas d\u{2019}emails`,
    hi: `\u{915}\u{94B}\u{908} \u{908}\u{92E}\u{947}\u{932} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}`,
    ht: `Pa gen okenn Im\xe8l`,
    it: `Non ci sono email`,
    ja: `\u{30E1}\u{30FC}\u{30EB}\u{306F}\u{4E00}\u{5207}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C774}\u{BA54}\u{C77C}\u{C740} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj email`,
    ps: `\u{647}\u{6CC}\u{685} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}\u{648}\u{646}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o h\xe1 e-mails`,
    'pt-pt': `N\xe3o h\xe1 emails`,
    ru: `\u{41D}\u{435}\u{442} \u{43D}\u{438}\u{43A}\u{430}\u{43A}\u{438}\u{445} \u{43F}\u{438}\u{441}\u{435}\u{43C}`,
    sm: `E leai ni imeli`,
    so: `Email ma jiraan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{627}\u{6CC} \u{645}\u{6CC}\u{644}\u{632} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 email`,
    'zh-hans': `\u{6CA1}\u{6709}\u{90AE}\u{4EF6}`,
    'zh-hant': `\u{6C92}\u{6709}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}`,
    en: `There are no emails`
};
const $b11db1b62d4a8f76$export$32b271f200228df1 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{647}\u{648}\u{627}\u{62A}\u{641}`,
    de: `Es gibt keine Telefone`,
    es: `No hay tel\xe9fonos`,
    fa: `\u{62A}\u{644}\u{641}\u{646} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang Mga Telepono`,
    fr: `Il n\u{2019}y a pas de t\xe9l\xe9phones`,
    hi: `\u{915}\u{94B}\u{908} \u{92B}\u{94B}\u{928} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}`,
    ht: `Pa gen okenn telef\xf2n`,
    it: `Non ci sono telefoni`,
    ja: `\u{96FB}\u{8A71}\u{306F}\u{306A}\u{3044}`,
    ko: `\u{C804}\u{D654}\u{AE30}\u{AC00} \u{C5C6}\u{C5B4}`,
    mww: `Tsis muaj xov tooj`,
    ps: `\u{647}\u{6CC}\u{685} \u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646}\u{648}\u{646}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o h\xe1 telefones`,
    'pt-pt': `N\xe3o h\xe1 telefones`,
    ru: `\u{422}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{43E}\u{432} \u{43D}\u{435}\u{442}.`,
    sm: `E leai ni telefoni feavea'i`,
    so: `Telefoon ma jiraan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}`,
    ur: `\u{641}\u{648}\u{646} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 \u{111}i\u{1EC7}n tho\u{1EA1}i`,
    'zh-hans': `\u{6CA1}\u{6709}\u{7535}\u{8BDD}`,
    'zh-hant': `\u{6C92}\u{6709}\u{96FB}\u{8A71}`,
    en: `There are no phones`
};
const $b11db1b62d4a8f76$export$f1da8d88446217e5 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{645}\u{648}\u{627}\u{642}\u{639}`,
    de: `Es gibt keine Standorte`,
    es: `No hay sitios`,
    fa: `\u{647}\u{6CC}\u{686} \u{633}\u{627}\u{6CC}\u{62A}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang mga site`,
    fr: `Il n\u{2019}y a pas de sites`,
    hi: `\u{915}\u{94B}\u{908} \u{938}\u{93E}\u{907}\u{91F} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}`,
    ht: `Pa gen okenn sit`,
    it: `Non ci sono siti`,
    ja: `\u{30B5}\u{30A4}\u{30C8}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C0AC}\u{C774}\u{D2B8}\u{B294} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj qhov chaw`,
    ps: `\u{647}\u{6CC}\u{685} \u{681}\u{627}\u{6CC}\u{648}\u{646}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o h\xe1 locais`,
    'pt-pt': `N\xe3o existem locais`,
    ru: `\u{417}\u{434}\u{435}\u{441}\u{44C} \u{43D}\u{435}\u{442} \u{43D}\u{438}\u{43A}\u{430}\u{43A}\u{438}\u{445} \u{43E}\u{431}\u{44A}\u{435}\u{43A}\u{442}\u{43E}\u{432}`,
    sm: `E leai ni nofoaga`,
    so: `Goobaha ma jiraan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{633}\u{627}\u{626}\u{679}\u{633} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 trang web`,
    'zh-hans': `\u{6CA1}\u{6709}\u{9057}\u{5740}`,
    'zh-hant': `\u{6C92}\u{6709}\u{907A}\u{5740}`,
    en: `There are no sites`
};
const $b11db1b62d4a8f76$export$a86e9a9bd8b26f8a = {
    ar: `\u{647}\u{646}\u{627}\u{643} \u{645}\u{634}\u{643}\u{644}\u{629}`,
    de: `Es gibt ein Problem`,
    es: `Hay un problema`,
    fa: `\u{6CC}\u{647} \u{645}\u{634}\u{6A9}\u{644}\u{6CC} \u{647}\u{633}\u{62A}`,
    fil: `May problema`,
    fr: `Il y a un probl\xe8me`,
    hi: `\u{90F}\u{915} \u{938}\u{92E}\u{938}\u{94D}\u{92F}\u{93E} \u{939}\u{948}`,
    ht: `Gen yon pwobl\xe8m`,
    it: `C'\xe8 un problema`,
    ja: `\u{554F}\u{984C}\u{304C}\u{3042}\u{308B}`,
    ko: `\u{BB38}\u{C81C}\u{AC00} \u{C0DD}\u{ACBC}\u{C5B4}`,
    mww: `Muaj teeb meem`,
    ps: `\u{6CC}\u{648}\u{647} \u{633}\u{62A}\u{648}\u{646}\u{632}\u{647} \u{62F}\u{647}`,
    pt: `Tem um problema`,
    'pt-pt': `H\xe1 um problema`,
    ru: `\u{415}\u{441}\u{442}\u{44C} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{430}`,
    sm: `O loo i ai se faafitauli`,
    so: `Waxaa jira dhibaato`,
    th: `\u{E21}\u{E35}\u{E1B}\u{E31}\u{E0D}\u{E2B}\u{E32}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{645}\u{633}\u{626}\u{644}\u{6C1} \u{6C1}\u{6D2}`,
    vi: `C\xf3 m\u{1ED9}t v\u{1EA5}n \u{111}\u{1EC1}`,
    'zh-hans': `\u{51FA}\u{4E86}\u{95EE}\u{9898}`,
    'zh-hant': `\u{6709}\u{554F}\u{984C}\u{4E86}`,
    en: `There's a problem`
};
const $b11db1b62d4a8f76$export$7ea5605264efeacf = {
    ar: `\u{627}\u{644}\u{62A}\u{641}\u{643}\u{64A}\u{631}`,
    de: `Denken`,
    es: `Pensamiento`,
    fa: `\u{62A}\u{641}\u{6A9}\u{631}`,
    fil: `Pag-iisip`,
    fr: `R\xe9flexion`,
    hi: `\u{935}\u{93F}\u{91A}\u{93E}\u{930}\u{936}\u{940}\u{932}`,
    ht: `Panse`,
    it: `Pensiero`,
    ja: `\u{601D}\u{8003}`,
    ko: `\u{C0AC}\u{ACE0}`,
    mww: `Kev xav`,
    ps: `\u{641}\u{6A9}\u{631} \u{6A9}\u{648}\u{644}`,
    pt: `Pensamento`,
    'pt-pt': `Pensar`,
    ru: `\u{41C}\u{44B}\u{448}\u{43B}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Mafaufau`,
    so: `Fikirka`,
    th: `\u{E01}\u{E32}\u{E23}\u{E04}\u{E34}\u{E14}`,
    ur: `\u{633}\u{648}\u{686}`,
    vi: `Suy ngh\u{129}`,
    'zh-hans': `\u{601D}\u{8003}`,
    'zh-hant': `\u{601D}\u{8003}`,
    en: `Thinking`
};
const $b11db1b62d4a8f76$export$4a79c81a6a9bdb46 = {
    ar: `\u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{645}\u{648}\u{627}\u{639}\u{64A}\u{62F}`,
    de: `Stundenzettel`,
    es: `Hoja de horas`,
    fa: `\u{62C}\u{62F}\u{648}\u{644} \u{632}\u{645}\u{627}\u{646}\u{6CC}`,
    fil: `Timesheet`,
    fr: `Feuille de temps`,
    hi: `\u{938}\u{92E}\u{92F} \u{92A}\u{924}\u{94D}\u{930}\u{915}`,
    ht: `F\xe8y tan`,
    it: `Foglio delle ore`,
    ja: `\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}`,
    ko: `\u{D0C0}\u{C784}\u{C2DC}\u{D2B8}`,
    mww: `Daim ntawv teev sij hawm`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647}`,
    pt: `Folha de ponto`,
    'pt-pt': `Folha de Horas`,
    ru: `\u{422}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}`,
    sm: `Pepa o taimi`,
    so: `Jadwalka Waqtiga`,
    th: `\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}`,
    ur: `\u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679}`,
    vi: `B\u{1EA3}ng ch\u{1EA5}m c\xf4ng`,
    'zh-hans': `\u{65F6}\u{95F4}\u{8868}`,
    'zh-hant': `\u{6642}\u{8868}`,
    en: `Timesheet`
};
const $b11db1b62d4a8f76$export$5d38161bf2204043 = {
    ar: `\u{623}\u{624}\u{643}\u{62F} \u{628}\u{645}\u{648}\u{62C}\u{628} \u{647}\u{630}\u{627} \u{623}\u{646} \u{627}\u{644}\u{625}\u{62F}\u{62E}\u{627}\u{644}\u{627}\u{62A} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644} \u{62A}\u{645}\u{62B}\u{644} \u{628}\u{64A}\u{627}\u{646}\u{627} \u{62D}\u{642}\u{64A}\u{642}\u{64A}\u{627} \u{648}\u{62F}\u{642}\u{64A}\u{642}\u{627} \u{648}\u{643}\u{627}\u{645}\u{644}\u{627} \u{644}\u{633}\u{627}\u{639}\u{627}\u{62A} \u{627}\u{644}\u{639}\u{645}\u{644} \u{648}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{639}\u{645}\u{644}\u{60C} \u{648}\u{623}\u{641}\u{648}\u{636} \u{645}\u{639}\u{627}\u{644}\u{62C}\u{629} \u{627}\u{644}\u{633}\u{627}\u{639}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{628}\u{644}\u{63A} \u{639}\u{646}\u{647}\u{627} \u{644}\u{644}\u{62F}\u{641}\u{639}. \u{623}\u{641}\u{647}\u{645} \u{623}\u{646} \u{62A}\u{642}\u{62F}\u{64A}\u{645} \u{623}\u{648} \u{627}\u{644}\u{645}\u{648}\u{627}\u{641}\u{642}\u{629} \u{639}\u{644}\u{649} \u{623}\u{64A} \u{625}\u{62F}\u{62E}\u{627}\u{644} \u{632}\u{645}\u{646}\u{64A} \u{643}\u{627}\u{630}\u{628} \u{623}\u{648} \u{63A}\u{64A}\u{631} \u{62F}\u{642}\u{64A}\u{642} \u{623}\u{648} \u{645}\u{628}\u{627}\u{644}\u{63A} \u{641}\u{64A}\u{647} \u{642}\u{62F} \u{64A}\u{639}\u{62A}\u{628}\u{631} \u{627}\u{62D}\u{62A}\u{64A}\u{627}\u{644}\u{627} \u{648}\u{642}\u{62F} \u{64A}\u{624}\u{62F}\u{64A} \u{625}\u{644}\u{649} \u{625}\u{646}\u{647}\u{627}\u{621} \u{641}\u{648}\u{631}\u{64A} \u{648}/\u{623}\u{648} \u{645}\u{644}\u{627}\u{62D}\u{642}\u{629} \u{642}\u{636}\u{627}\u{626}\u{64A}\u{629}.`,
    de: `Hiermit best\xe4tige ich, dass die Eintr\xe4ge in diesem Datensatz eine wahre, genaue und vollst\xe4ndige Darstellung der gearbeiteten Stunden und Arbeitsaktivit\xe4ten darstellen und autorisiere, dass die gemeldeten Stunden zur Zahlung verarbeitet werden. Ich verstehe, dass die Einreichung oder Genehmigung einer falschen, ungenauen oder \xfcbertriebenen Zeiteingabe als Betrug angesehen werden kann und zu sofortiger K\xfcndigung und/oder Strafverfolgung f\xfchren kann.`,
    es: `Por la presente certifico que las entradas en este registro representan una declaraci\xf3n verdadera, precisa y completa de las horas trabajadas y actividades laborales, y autorizo que las horas reportadas sean procesadas para su pago. Entiendo que la presentaci\xf3n o aprobaci\xf3n de cualquier entrada de tiempo falsa, inexacta o inflada puede considerarse fraude y puede resultar en despido inmediato y/o procesamiento.`,
    fa: `\u{628}\u{62F}\u{6CC}\u{646} \u{648}\u{633}\u{6CC}\u{644}\u{647} \u{62A}\u{623}\u{6CC}\u{6CC}\u{62F} \u{645}\u{6CC} \u{6A9}\u{646}\u{645} \u{6A9}\u{647} \u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{647}\u{627}\u{6CC} \u{627}\u{6CC}\u{646} \u{67E}\u{631}\u{648}\u{646}\u{62F}\u{647} \u{6AF}\u{632}\u{627}\u{631}\u{634}\u{6CC} \u{648}\u{627}\u{642}\u{639}\u{6CC}\u{60C} \u{62F}\u{642}\u{6CC}\u{642} \u{648} \u{6A9}\u{627}\u{645}\u{644} \u{627}\u{632} \u{633}\u{627}\u{639}\u{627}\u{62A} \u{6A9}\u{627}\u{631}\u{6CC} \u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{6A9}\u{627}\u{631}\u{6CC} \u{647}\u{633}\u{62A}\u{646}\u{62F} \u{648} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{645}\u{6CC} \u{62F}\u{647}\u{645} \u{633}\u{627}\u{639}\u{627}\u{62A} \u{6AF}\u{632}\u{627}\u{631}\u{634} \u{634}\u{62F}\u{647} \u{628}\u{631}\u{627}\u{6CC} \u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A} \u{67E}\u{631}\u{62F}\u{627}\u{632}\u{634} \u{634}\u{648}\u{646}\u{62F}. \u{645}\u{6CC} \u{62F}\u{627}\u{646}\u{645} \u{6A9}\u{647} \u{627}\u{631}\u{633}\u{627}\u{644} \u{6CC}\u{627} \u{62A}\u{623}\u{6CC}\u{6CC}\u{62F} \u{647}\u{631}\u{6AF}\u{648}\u{646}\u{647} \u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{632}\u{645}\u{627}\u{646} \u{646}\u{627}\u{62F}\u{631}\u{633}\u{62A}\u{60C} \u{646}\u{627}\u{62F}\u{631}\u{633}\u{62A} \u{6CC}\u{627} \u{627}\u{63A}\u{631}\u{627}\u{642} \u{622}\u{645}\u{6CC}\u{632} \u{645}\u{645}\u{6A9}\u{646} \u{627}\u{633}\u{62A} \u{62A}\u{642}\u{644}\u{628} \u{645}\u{62D}\u{633}\u{648}\u{628} \u{634}\u{648}\u{62F} \u{648} \u{645}\u{646}\u{62C}\u{631} \u{628}\u{647} \u{627}\u{62E}\u{631}\u{627}\u{62C} \u{641}\u{648}\u{631}\u{6CC} \u{648}/\u{6CC}\u{627} \u{67E}\u{6CC}\u{6AF}\u{631}\u{62F} \u{642}\u{627}\u{646}\u{648}\u{646}\u{6CC} \u{6AF}\u{631}\u{62F}\u{62F}.`,
    fil: `Pinatutunayan ko na ang mga entry sa talaang ito ay kumakatawan sa totoo, tumpak, at kumpletong pahayag ng mga oras na nagtrabaho at mga aktibidad sa trabaho, at pinahihintulutan ko ang mga iniulat na oras na iproseso para sa pagbabayad. Nauunawaan ko na ang pagsusumite o pag-apruba ng anumang mali, hindi tumpak, o pinalaki na pagpasok ng oras ay maaaring ituring na pandaraya at maaaring magresulta sa agarang pagwawakas at / o pag-uusig.`,
    fr: `Je certifie par la pr\xe9sente que les entr\xe9es figurant dans ce dossier repr\xe9sentent une d\xe9claration vraie, exacte et compl\xe8te des heures travaill\xe9es et des activit\xe9s de travail, et j\u{2019}autorise le traitement des heures d\xe9clar\xe9es pour paiement. Je comprends que la soumission ou l\u{2019}approbation de toute saisie de temps fausse, inexacte ou exag\xe9r\xe9e peut \xeatre consid\xe9r\xe9e comme une fraude et entra\xeener un licenciement imm\xe9diat et/ou des poursuites.`,
    hi: `\u{92E}\u{948}\u{902} \u{90F}\u{924}\u{926}\u{94D}\u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{92A}\u{94D}\u{930}\u{92E}\u{93E}\u{923}\u{93F}\u{924} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{942}\u{902} \u{915}\u{93F} \u{907}\u{938} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{92A}\u{930} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F}\u{92F}\u{93E}\u{902} \u{915}\u{93E}\u{92E} \u{915}\u{947} \u{918}\u{902}\u{91F}\u{94B}\u{902} \u{914}\u{930} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{947} \u{90F}\u{915} \u{938}\u{91A}\u{94D}\u{91A}\u{947}, \u{938}\u{91F}\u{940}\u{915} \u{914}\u{930} \u{92A}\u{942}\u{930}\u{94D}\u{923} \u{935}\u{93F}\u{935}\u{930}\u{923} \u{915}\u{93E} \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{928}\u{93F}\u{927}\u{93F}\u{924}\u{94D}\u{935} \u{915}\u{930}\u{924}\u{940} \u{939}\u{948}\u{902}, \u{914}\u{930} \u{92E}\u{948}\u{902} \u{92D}\u{941}\u{917}\u{924}\u{93E}\u{928} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{902}\u{938}\u{93E}\u{927}\u{93F}\u{924} \u{939}\u{94B}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F} \u{915}\u{93F}\u{90F} \u{917}\u{90F} \u{918}\u{902}\u{91F}\u{94B}\u{902} \u{915}\u{94B} \u{905}\u{927}\u{93F}\u{915}\u{943}\u{924} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{942}\u{902}\u{964} \u{92E}\u{948}\u{902} \u{938}\u{92E}\u{91D}\u{924}\u{93E} \u{939}\u{942}\u{902} \u{915}\u{93F} \u{915}\u{93F}\u{938}\u{940} \u{92D}\u{940} \u{91D}\u{942}\u{920}\u{940}, \u{917}\u{932}\u{924}, \u{92F}\u{93E} \u{92C}\u{922}\u{93C}\u{940} \u{939}\u{941}\u{908} \u{938}\u{92E}\u{92F} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{94B} \u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924} \u{915}\u{930}\u{928}\u{93E} \u{92F}\u{93E} \u{905}\u{928}\u{941}\u{92E}\u{94B}\u{926}\u{928} \u{915}\u{930}\u{928}\u{93E} \u{927}\u{94B}\u{916}\u{93E}\u{927}\u{921}\u{93C}\u{940} \u{92E}\u{93E}\u{928}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948} \u{914}\u{930} \u{907}\u{938}\u{915}\u{947} \u{92A}\u{930}\u{93F}\u{923}\u{93E}\u{92E}\u{938}\u{94D}\u{935}\u{930}\u{942}\u{92A} \u{924}\u{924}\u{94D}\u{915}\u{93E}\u{932} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{914}\u{930}/\u{92F}\u{93E} \u{905}\u{92D}\u{93F}\u{92F}\u{94B}\u{91C}\u{928} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Mwen s\xe8tifye nan dokiman sa a ke antre yo nan dosye sa a reprezante yon deklarasyon rey\xe8l, egzat ak konpl\xe8 nan \xe8dtan travay ak aktivite travay, epi mwen otorize \xe8dtan yo rap\xf2te yo dwe trete pou peman. Mwen konprann ke soum\xe8t oswa apwobasyon nan nenp\xf2t ki fo, k\xf2r\xe8k, oswa gonfle antre tan ka konsidere k\xf2m fwod epi yo ka lak\xf2z revokasyon imedyat ak / oswa pouswit pouswit.`,
    it: `Certifico con la presente che le voci in questo registro rappresentano una dichiarazione vera, accurata e completa delle ore lavorate e delle attivit\xe0 lavorative, e autorizzo l'elaborazione delle ore riportate per il pagamento. Capisco che la presentazione o l'approvazione di qualsiasi inserimento di tempo falso, inaccurato o gonfiato possa essere considerata frode e comportare il licenziamento immediato e/o la procedura penale.`,
    ja: `\u{672C}\u{8A18}\u{9332}\u{306E}\u{8A18}\u{9332}\u{304C}\u{52E4}\u{52D9}\u{6642}\u{9593}\u{304A}\u{3088}\u{3073}\u{696D}\u{52D9}\u{6D3B}\u{52D5}\u{306E}\u{771F}\u{5B9F}\u{3067}\u{6B63}\u{78BA}\u{304B}\u{3064}\u{5B8C}\u{5168}\u{306A}\u{8A18}\u{8FF0}\u{3067}\u{3042}\u{308B}\u{3053}\u{3068}\u{3092}\u{3053}\u{3053}\u{306B}\u{8A3C}\u{660E}\u{3057}\u{3001}\u{5831}\u{544A}\u{3055}\u{308C}\u{305F}\u{52B4}\u{50CD}\u{6642}\u{9593}\u{306E}\u{652F}\u{6255}\u{3044}\u{51E6}\u{7406}\u{3092}\u{8A31}\u{53EF}\u{3057}\u{307E}\u{3059}\u{3002}\u{865A}\u{507D}\u{3001}\u{4E0D}\u{6B63}\u{78BA}\u{3001}\u{307E}\u{305F}\u{306F}\u{8A87}\u{5F35}\u{3055}\u{308C}\u{305F}\u{6642}\u{9593}\u{306E}\u{5165}\u{529B}\u{306E}\u{63D0}\u{51FA}\u{3084}\u{627F}\u{8A8D}\u{306F}\u{8A50}\u{6B3A}\u{3068}\u{307F}\u{306A}\u{3055}\u{308C}\u{3001}\u{5373}\u{6642}\u{89E3}\u{96C7}\u{3084}\u{8D77}\u{8A34}\u{306B}\u{3064}\u{306A}\u{304C}\u{308B}\u{53EF}\u{80FD}\u{6027}\u{304C}\u{3042}\u{308B}\u{3053}\u{3068}\u{306F}\u{7406}\u{89E3}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{AE30}\u{B85D}\u{C5D0} \u{AE30}\u{C7AC}\u{B41C} \u{D56D}\u{BAA9}\u{B4E4}\u{C774} \u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{ACFC} \u{C5C5}\u{BB34} \u{D65C}\u{B3D9}\u{C5D0} \u{B300}\u{D55C} \u{C9C4}\u{C2E4}\u{B418}\u{ACE0} \u{C815}\u{D655}\u{D558}\u{BA70} \u{C644}\u{C804}\u{D55C} \u{C9C4}\u{C220}\u{C784}\u{C744} \u{C99D}\u{BA85}\u{D558}\u{BA70}, \u{BCF4}\u{ACE0}\u{B41C} \u{C2DC}\u{AC04}\u{C5D0} \u{B300}\u{D55C} \u{C9C0}\u{AE09} \u{CC98}\u{B9AC}\u{B97C} \u{C2B9}\u{C778}\u{D569}\u{B2C8}\u{B2E4}. \u{D5C8}\u{C704}, \u{BD80}\u{C815}\u{D655}, \u{BD80}\u{D480}\u{B9B0} \u{C2DC}\u{AC04} \u{C785}\u{B825}\u{C744} \u{C81C}\u{CD9C}\u{D558}\u{AC70}\u{B098} \u{C2B9}\u{C778}\u{D558}\u{B294} \u{AC83}\u{C740} \u{C0AC}\u{AE30}\u{B85C} \u{AC04}\u{C8FC}\u{B420} \u{C218} \u{C788}\u{C73C}\u{BA70}, \u{C989}\u{AC01}\u{C801}\u{C778} \u{D574}\u{ACE0} \u{BC0F}/\u{B610}\u{B294} \u{AE30}\u{C18C}\u{B85C} \u{C774}\u{C5B4}\u{C9C8} \u{C218} \u{C788}\u{C74C}\u{C744} \u{C774}\u{D574}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Kuv lees paub ntawm no tias cov ntaub ntawv hauv cov ntaub ntawv no sawv cev rau ib daim ntawv qhia tseeb, raug, thiab tag nrho cov sij hawm ua hauj lwm thiab kev ua hauj lwm, thiab kuv tso cai rau cov sij hawm uas tau tshaj tawm los ua kom them nyiaj. Kuv nkag siab tias kev xa lossis kev pom zoo ntawm ib qho kev nkag tsis tseeb, tsis raug, lossis lub sijhawm nkag mus yuav raug suav tias yog kev dag ntxias thiab tej zaum yuav ua rau kev txiav tawm thiab / lossis raug foob tam sim ntawd.`,
    ps: `\u{632}\u{647} \u{62F}\u{644}\u{62A}\u{647} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{648}\u{645} \u{686}\u{6D0} \u{67E}\u{647} \u{62F}\u{6D0} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{6A9}\u{6D0} \u{62F}\u{627}\u{62E}\u{644}\u{6D0} \u{62F} \u{6A9}\u{627}\u{631} \u{627}\u{648} \u{6A9}\u{627}\u{631}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{648} \u{631}\u{6CC}\u{69A}\u{62A}\u{6CC}\u{646}\u{6CC}\u{60C} \u{62F}\u{642}\u{6CC}\u{642}\u{60C} \u{627}\u{648} \u{628}\u{634}\u{67E}\u{693} \u{628}\u{6CC}\u{627}\u{646} \u{62F}\u{6CC}\u{60C} \u{627}\u{648} \u{632}\u{647} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{648}\u{631}\u{6A9}\u{648}\u{645} \u{686}\u{6D0} \u{631}\u{627}\u{67E}\u{648}\u{631} \u{634}\u{648}\u{6CC} \u{633}\u{627}\u{639}\u{62A}\u{648}\u{646}\u{647} \u{62F} \u{67E}\u{6CC}\u{633}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{67E}\u{631}\u{648}\u{633}\u{633} \u{634}\u{6CC}. \u{632}\u{647} \u{67E}\u{648}\u{647}\u{6D0}\u{696}\u{645} \u{686}\u{6D0} \u{62F} \u{647}\u{631} \u{689}\u{648}\u{644} \u{63A}\u{644}\u{637}\u{60C} \u{646}\u{627}\u{633}\u{645}\u{60C} \u{6CC}\u{627} \u{645}\u{628}\u{627}\u{644}\u{63A}\u{647} \u{634}\u{648}\u{6D0} \u{648}\u{62E}\u{62A} \u{644}\u{6CC}\u{6A9}\u{646}\u{6D0} \u{633}\u{67E}\u{627}\u{631}\u{644} \u{6CC}\u{627} \u{62A}\u{635}\u{648}\u{6CC}\u{628} \u{6A9}\u{648}\u{644} \u{645}\u{645}\u{6A9}\u{646} \u{62F}\u{631}\u{63A}\u{644}\u{6CC} \u{648}\u{6AB}\u{6BC}\u{644} \u{634}\u{6CC} \u{627}\u{648} \u{633}\u{645}\u{62F}\u{633}\u{62A}\u{6CC} \u{62F} \u{62E}\u{62A}\u{645}\u{648}\u{644}\u{648} \u{627}\u{648}/\u{6CC}\u{627} \u{62A}\u{639}\u{642}\u{6CC}\u{628} \u{644}\u{627}\u{645}\u{644} \u{634}\u{6CC}.`,
    pt: `Certifico que as entradas neste registro representam uma declara\xe7\xe3o verdadeira, precisa e completa das horas trabalhadas e das atividades de trabalho, e autorizo que as horas reportadas sejam processadas para pagamento. Entendo que a submiss\xe3o ou aprova\xe7\xe3o de qualquer registro de tempo falso, impreciso ou inflado pode ser considerada fraude e pode resultar em demiss\xe3o imediata e/ou processo judicial.`,
    'pt-pt': `Certifico que as entradas neste registo representam uma declara\xe7\xe3o verdadeira, precisa e completa das horas trabalhadas e das atividades de trabalho, e autorizo o processamento das horas reportadas para pagamento. Compreendo que a submiss\xe3o ou aprova\xe7\xe3o de qualquer entrada de tempo falsa, imprecisa ou inflacionada pode ser considerada fraude e pode resultar em rescis\xe3o imediata e/ou acusa\xe7\xe3o.`,
    ru: `\u{42F} \u{43D}\u{430}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{438}\u{43C} \u{43F}\u{43E}\u{434}\u{442}\u{432}\u{435}\u{440}\u{436}\u{434}\u{430}\u{44E}, \u{447}\u{442}\u{43E} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438} \u{432} \u{434}\u{430}\u{43D}\u{43D}\u{43E}\u{43C} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{44F}\u{44E}\u{442} \u{441}\u{43E}\u{431}\u{43E}\u{439} \u{438}\u{441}\u{442}\u{438}\u{43D}\u{43D}\u{43E}\u{435}, \u{442}\u{43E}\u{447}\u{43D}\u{43E}\u{435} \u{438} \u{43F}\u{43E}\u{43B}\u{43D}\u{43E}\u{435} \u{43E}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435} \u{43E}\u{442}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{447}\u{430}\u{441}\u{43E}\u{432} \u{438} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{438}\u{445} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{439}, \u{438} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{430}\u{44E} \u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{443} \u{44D}\u{442}\u{438}\u{445} \u{447}\u{430}\u{441}\u{43E}\u{432} \u{434}\u{43B}\u{44F} \u{43E}\u{43F}\u{43B}\u{430}\u{442}\u{44B}. \u{42F} \u{43F}\u{43E}\u{43D}\u{438}\u{43C}\u{430}\u{44E}, \u{447}\u{442}\u{43E} \u{43F}\u{43E}\u{434}\u{430}\u{447}\u{430} \u{438}\u{43B}\u{438} \u{43E}\u{434}\u{43E}\u{431}\u{440}\u{435}\u{43D}\u{438}\u{435} \u{43B}\u{44E}\u{431}\u{43E}\u{439} \u{43B}\u{43E}\u{436}\u{43D}\u{43E}\u{439}, \u{43D}\u{435}\u{442}\u{43E}\u{447}\u{43D}\u{43E}\u{439} \u{438}\u{43B}\u{438} \u{437}\u{430}\u{432}\u{44B}\u{448}\u{435}\u{43D}\u{43D}\u{43E}\u{439} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{441}\u{447}\u{438}\u{442}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{43C}\u{43E}\u{448}\u{435}\u{43D}\u{43D}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{43E}\u{43C} \u{438} \u{43F}\u{440}\u{438}\u{432}\u{435}\u{441}\u{442}\u{438} \u{43A} \u{43D}\u{435}\u{43C}\u{435}\u{434}\u{43B}\u{435}\u{43D}\u{43D}\u{43E}\u{43C}\u{443} \u{443}\u{432}\u{43E}\u{43B}\u{44C}\u{43D}\u{435}\u{43D}\u{438}\u{44E} \u{438}/\u{438}\u{43B}\u{438} \u{443}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43D}\u{43E}\u{43C}\u{443} \u{43F}\u{440}\u{435}\u{441}\u{43B}\u{435}\u{434}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44E}.`,
    sm: `Ou te faamaonia atu o faamatalaga i luga o lenei faamaumauga e fai ma sui o se faamatalaga moni, sa'o, ma atoatoa o itula faigaluega ma gaoioiga faigaluega, ma ou te faatagaina itula ua lipotia mai ina ia faagaoioia mo le totogiina. Ou te malamalama o le tu'uina atu po'o le fa'amaonia o so'o se sese, le sa'o, po'o le fa'ateleina o le taimi e mafai ona manatu o se taufaasese ma e mafai ona i'u ai i le vave fa'amutaina ma / po'o le moliaga.`,
    so: `Waxaan halkan ku xaqiijinayaa in diiwaankan ay yihiin warbixin sax ah, oo dhamaystiran oo ku saabsan saacadaha shaqada iyo hawlaha shaqada, waxaanan oggolaanayaa in saacadaha la soo sheegay la farsameeyo si loo bixiyo lacag. Waxaan fahamsanahay in gudbinta ama ansixinta wakhti been ah, aan sax ahayn, ama la buufin gelin karo loo tixgelin karo khiyaano isla markaana ay keeni karto in si degdeg ah loo joojiyo iyo/ama dacwad.`,
    th: `\u{E02}\u{E49}\u{E32}\u{E1E}\u{E40}\u{E08}\u{E49}\u{E32}\u{E02}\u{E2D}\u{E23}\u{E31}\u{E1A}\u{E23}\u{E2D}\u{E07}\u{E27}\u{E48}\u{E32}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E43}\u{E19}\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E19}\u{E35}\u{E49}\u{E41}\u{E2A}\u{E14}\u{E07}\u{E16}\u{E36}\u{E07}\u{E04}\u{E4D}\u{E32}\u{E0A}\u{E35}\u{E49}\u{E41}\u{E08}\u{E07}\u{E17}\u{E35}\u{E48}\u{E41}\u{E17}\u{E49}\u{E08}\u{E23}\u{E34}\u{E07} \u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07} \u{E41}\u{E25}\u{E30}\u{E04}\u{E23}\u{E1A}\u{E16}\u{E49}\u{E27}\u{E19}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E01}\u{E31}\u{E1A}\u{E0A}\u{E31}\u{E48}\u{E27}\u{E42}\u{E21}\u{E07}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E41}\u{E25}\u{E30}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E01}\u{E32}\u{E23}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19} \u{E41}\u{E25}\u{E30}\u{E02}\u{E49}\u{E32}\u{E1E}\u{E40}\u{E08}\u{E49}\u{E32}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E0A}\u{E31}\u{E48}\u{E27}\u{E42}\u{E21}\u{E07}\u{E17}\u{E35}\u{E48}\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E0A}\u{E4D}\u{E32}\u{E23}\u{E30}\u{E40}\u{E07}\u{E34}\u{E19} \u{E02}\u{E49}\u{E32}\u{E1E}\u{E40}\u{E08}\u{E49}\u{E32}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E08}\u{E27}\u{E48}\u{E32}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E2D}\u{E19}\u{E38}\u{E21}\u{E31}\u{E15}\u{E34}\u{E01}\u{E32}\u{E23}\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E40}\u{E27}\u{E25}\u{E32}\u{E17}\u{E35}\u{E48}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E40}\u{E17}\u{E47}\u{E08} \u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E01}\u{E34}\u{E19}\u{E08}\u{E23}\u{E34}\u{E07}\u{E2D}\u{E32}\u{E08}\u{E16}\u{E37}\u{E2D}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E01}\u{E32}\u{E23}\u{E09}\u{E49}\u{E2D}\u{E42}\u{E01}\u{E07} \u{E41}\u{E25}\u{E30}\u{E2D}\u{E32}\u{E08}\u{E2A}\u{E48}\u{E07}\u{E1C}\u{E25}\u{E43}\u{E2B}\u{E49}\u{E16}\u{E39}\u{E01}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E41}\u{E25}\u{E30}/\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E16}\u{E39}\u{E01}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E04}\u{E14}\u{E35}\u{E17}\u{E31}\u{E19}\u{E17}\u{E35}`,
    ur: `\u{645}\u{6CC}\u{6BA} \u{6CC}\u{6C1}\u{627}\u{6BA} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{648}\u{6BA} \u{6A9}\u{6C1} \u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{67E}\u{631} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C}\u{627}\u{62A} \u{6A9}\u{627}\u{645} \u{6A9}\u{6D2} \u{6AF}\u{6BE}\u{646}\u{679}\u{648}\u{6BA} \u{627}\u{648}\u{631} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{648}\u{6BA} \u{6A9}\u{627} \u{62D}\u{642}\u{6CC}\u{642}\u{6CC}\u{60C} \u{62F}\u{631}\u{633}\u{62A} \u{627}\u{648}\u{631} \u{645}\u{6A9}\u{645}\u{644} \u{628}\u{6CC}\u{627}\u{646} \u{67E}\u{6CC}\u{634} \u{6A9}\u{631}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{60C} \u{627}\u{648}\u{631} \u{645}\u{6CC}\u{6BA} \u{631}\u{67E}\u{648}\u{631}\u{679} \u{634}\u{62F}\u{6C1} \u{6AF}\u{6BE}\u{646}\u{679}\u{648}\u{6BA} \u{6A9}\u{648} \u{627}\u{62F}\u{627}\u{626}\u{6CC}\u{6AF}\u{6CC} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{67E}\u{631}\u{627}\u{633}\u{6CC}\u{633} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{62F}\u{6CC}\u{62A}\u{627} \u{6C1}\u{648}\u{6BA}\u{6D4} \u{645}\u{6CC}\u{6BA} \u{633}\u{645}\u{62C}\u{6BE}\u{62A}\u{627} \u{6C1}\u{648}\u{6BA} \u{6A9}\u{6C1} \u{6A9}\u{633}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{62C}\u{6BE}\u{648}\u{679}\u{6CC}\u{60C} \u{63A}\u{644}\u{637}\u{60C} \u{6CC}\u{627} \u{628}\u{691}\u{6BE}\u{627} \u{686}\u{691}\u{6BE}\u{627} \u{6A9}\u{631} \u{62F}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{648}\u{642}\u{62A} \u{6A9}\u{6CC} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{6A9}\u{6CC} \u{645}\u{646}\u{638}\u{648}\u{631}\u{6CC} \u{641}\u{631}\u{627}\u{688} \u{633}\u{645}\u{62C}\u{6BE}\u{6CC} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{6CC} \u{6C1}\u{6D2} \u{627}\u{648}\u{631} \u{641}\u{648}\u{631}\u{6CC} \u{628}\u{631}\u{637}\u{631}\u{641}\u{6CC} \u{627}\u{648}\u{631}/\u{6CC}\u{627} \u{642}\u{627}\u{646}\u{648}\u{646}\u{6CC} \u{6A9}\u{627}\u{631}\u{631}\u{648}\u{627}\u{626}\u{6CC} \u{6A9}\u{627} \u{628}\u{627}\u{639}\u{62B} \u{628}\u{646} \u{633}\u{6A9}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `T\xf4i x\xe1c nh\u{1EAD}n r\u{1EB1}ng c\xe1c m\u{1EE5}c trong h\u{1ED3} s\u{1A1} n\xe0y \u{111}\u{1EA1}i di\u{1EC7}n cho m\u{1ED9}t tuy\xean b\u{1ED1} trung th\u{1EF1}c, ch\xednh x\xe1c v\xe0 \u{111}\u{1EA7}y \u{111}\u{1EE7} v\u{1EC1} s\u{1ED1} gi\u{1EDD} l\xe0m vi\u{1EC7}c v\xe0 ho\u{1EA1}t \u{111}\u{1ED9}ng l\xe0m vi\u{1EC7}c, v\xe0 t\xf4i cho ph\xe9p s\u{1ED1} gi\u{1EDD} \u{111}\u{1B0}\u{1EE3}c b\xe1o c\xe1o \u{111}\u{1B0}\u{1EE3}c x\u{1EED} l\xfd \u{111}\u{1EC3} thanh to\xe1n. T\xf4i hi\u{1EC3}u r\u{1EB1}ng vi\u{1EC7}c g\u{1EED}i ho\u{1EB7}c ph\xea duy\u{1EC7}t b\u{1EA5}t k\u{1EF3} m\u{1EE5}c nh\u{1EAD}p th\u{1EDD}i gian sai, kh\xf4ng ch\xednh x\xe1c ho\u{1EB7}c th\u{1ED5}i ph\u{1ED3}ng n\xe0o c\xf3 th\u{1EC3} b\u{1ECB} coi l\xe0 gian l\u{1EAD}n v\xe0 c\xf3 th\u{1EC3} d\u{1EAB}n \u{111}\u{1EBF}n vi\u{1EC7}c ch\u{1EA5}m d\u{1EE9}t v\xe0/ho\u{1EB7}c truy t\u{1ED1} ngay l\u{1EAD}p t\u{1EE9}c.`,
    'zh-hans': `\u{6211}\u{5728}\u{6B64}\u{8BC1}\u{660E}\u{672C}\u{8BB0}\u{5F55}\u{4E0A}\u{7684}\u{8BB0}\u{5F55}\u{4EE3}\u{8868}\u{4E86}\u{771F}\u{5B9E}\u{3001}\u{51C6}\u{786E}\u{4E14}\u{5B8C}\u{6574}\u{7684}\u{5DE5}\u{4F5C}\u{65F6}\u{95F4}\u{548C}\u{5DE5}\u{4F5C}\u{6D3B}\u{52A8}\u{9648}\u{8FF0}\u{FF0C}\u{5E76}\u{6388}\u{6743}\u{5BF9}\u{62A5}\u{544A}\u{5DE5}\u{65F6}\u{8FDB}\u{884C}\u{5904}\u{7406}\u{4EE5}\u{8FDB}\u{884C}\u{652F}\u{4ED8}\u{3002}\u{6211}\u{7406}\u{89E3}\u{63D0}\u{4EA4}\u{6216}\u{6279}\u{51C6}\u{4EFB}\u{4F55}\u{865A}\u{5047}\u{3001}\u{4E0D}\u{51C6}\u{786E}\u{6216}\u{5938}\u{5927}\u{7684}\u{5DE5}\u{65F6}\u{8BB0}\u{5F55}\u{53EF}\u{80FD}\u{88AB}\u{89C6}\u{4E3A}\u{6B3A}\u{8BC8}\u{FF0C}\u{53EF}\u{80FD}\u{5BFC}\u{81F4}\u{7ACB}\u{5373}\u{89E3}\u{96C7}\u{548C}/\u{6216}\u{8D77}\u{8BC9}\u{3002}`,
    'zh-hant': `\u{6211}\u{5728}\u{6B64}\u{8B49}\u{660E}\u{672C}\u{7D00}\u{9304}\u{4E0A}\u{7684}\u{8A18}\u{9304}\u{4EE3}\u{8868}\u{771F}\u{5BE6}\u{3001}\u{6E96}\u{78BA}\u{4E14}\u{5B8C}\u{6574}\u{7684}\u{5DE5}\u{4F5C}\u{6642}\u{6578}\u{53CA}\u{5DE5}\u{4F5C}\u{6D3B}\u{52D5}\u{9673}\u{8FF0}\u{FF0C}\u{4E26}\u{6388}\u{6B0A}\u{8655}\u{7406}\u{7533}\u{5831}\u{5DE5}\u{6642}\u{4EE5}\u{9032}\u{884C}\u{652F}\u{4ED8}\u{3002}\u{6211}\u{4E86}\u{89E3}\u{4EFB}\u{4F55}\u{865B}\u{5047}\u{3001}\u{4E0D}\u{6E96}\u{78BA}\u{6216}\u{8A87}\u{5927}\u{6642}\u{9593}\u{7D00}\u{9304}\u{7684}\u{63D0}\u{4EA4}\u{6216}\u{6279}\u{51C6}\u{FF0C}\u{53EF}\u{80FD}\u{88AB}\u{8996}\u{70BA}\u{8A50}\u{6B3A}\u{FF0C}\u{53EF}\u{80FD}\u{5C0E}\u{81F4}\u{7ACB}\u{5373}\u{89E3}\u{50F1}\u{53CA}/\u{6216}\u{8D77}\u{8A34}\u{3002}`,
    en: `I hereby certify that the entries on this record represent a true, accurate, and complete statement of hours worked and work activities, and I authorize the reported hours to be processed for payment. I understand that submission or approval of any false, inaccurate, or inflated time entry may be considered fraud and may result in immediate termination and/or prosecution.`
};
const $b11db1b62d4a8f76$export$217ce0b8a3f0cb49 = {
    ar: $b11db1b62d4a8f76$var$html`هل تحتاج مساعدة في جدول الساعات الخاص بك؟ اقرأ <a href="/docs">تعليمات جدول المواعيد</a>.`,
    de: $b11db1b62d4a8f76$var$html`Brauchen Sie Hilfe bei Ihrem Stundenzettel? Lies die <a href="/docs">Anweisungen zum Stundenzettel</a>.`,
    es: $b11db1b62d4a8f76$var$html`¿Necesitas ayuda con tu hoja de horas? Lee las <a href="/docs">instrucciones de la hoja de horas</a>.`,
    fa: $b11db1b62d4a8f76$var$html`نیاز به کمک برای برگه زمان بندی خود دارید؟ <a href="/docs">دستورالعمل های برگه زمان</a> بندی را بخوانید.`,
    fil: $b11db1b62d4a8f76$var$html`Kailangan mo ba ng tulong sa iyong timesheet? Basahin ang <a href="/docs">mga tagubilin sa timesheet</a>.`,
    fr: $b11db1b62d4a8f76$var$html`Besoin d’aide pour votre feuille de temps ? Lisez les <a href="/docs">instructions de la feuille de temps</a>.`,
    hi: $b11db1b62d4a8f76$var$html`अपनी टाइमशीट के साथ मदद चाहिए? <a href="/docs">टाइमशीट निर्देश</a> पढ़ें।`,
    ht: $b11db1b62d4a8f76$var$html`Bezwen èd ak Fèy tan ou? Li <a href="/docs">enstriksyon Fèy tan</a> yo`,
    it: $b11db1b62d4a8f76$var$html`Hai bisogno di aiuto con il tuo foglio presenze? Leggi <a href="/docs">le istruzioni del foglio presenze</a>.`,
    ja: $b11db1b62d4a8f76$var$html`タイムシートの助けが必要ですか? <a href="/docs">タイムシートの指示</a>を読んでください。`,
    ko: $b11db1b62d4a8f76$var$html`근무 시간표 작성에 도움이 필요하신가요? <a href="/docs">근무 시간표 설명서를 읽어보세요</a>.`,
    mww: $b11db1b62d4a8f76$var$html`Xav tau kev pab nrog koj daim ntawv teev sijhawm? Nyeem cov <a href="/docs">lus qhia txog daim ntawv teev sijhawm</a>.`,
    ps: $b11db1b62d4a8f76$var$html`د خپل وخت په جدول کې مرسته پکار ده؟ <a href="/docs">د وخت پاڼې لارښوونې</a> ولوله.`,
    pt: $b11db1b62d4a8f76$var$html`Precisa de ajuda com sua folha de ponto? Leia as <a href="/docs">instruções da folha de ponto</a>.`,
    'pt-pt': $b11db1b62d4a8f76$var$html`Precisa de ajuda com a sua folha de horas? Leia as <a href="/docs">instruções da folha de horas</a>.`,
    ru: $b11db1b62d4a8f76$var$html`Нужна помощь с табелем рабочего времени? Прочитайте <a href="/docs">инструкции к табелю рабочего времени</a>.`,
    sm: $b11db1b62d4a8f76$var$html`Mana'omia se fesoasoani i lau pepa o taimi? Faitau <a href="/docs">faatonuga o le pepa o taimi</a>.`,
    so: $b11db1b62d4a8f76$var$html`Ma u baahan tahay caawimaad waqtigaaga? Akhri <a href="/docs">tilmaamaha jadwalka waqtiga</a>.`,
    th: $b11db1b62d4a8f76$var$html`ต้องการความช่วยเหลือเกี่ยวกับไทม์ชีทของคุณหรือไม่? อ่านคําแนะนําใน<a href="/docs">ไทม์ชีท</a>`,
    ur: $b11db1b62d4a8f76$var$html`کیا آپ کو اپنے ٹائم شیٹ میں مدد چاہیے؟ <a href="/docs">ٹائم شیٹ کی ہدایاتیں</a> پڑھیں۔`,
    vi: $b11db1b62d4a8f76$var$html`Bạn cần trợ giúp về bảng chấm công? Đọc <a href="/docs">hướng dẫn bảng chấm công</a>.`,
    'zh-hans': $b11db1b62d4a8f76$var$html`需要时间表上的帮助吗？ <a href="/docs">阅读工时说明</a>。`,
    'zh-hant': $b11db1b62d4a8f76$var$html`需要工時表的協助嗎？ <a href="/docs">請閱讀工時說明</a>。`,
    en: $b11db1b62d4a8f76$var$html`Need help with your timesheet? Read the <a href="/docs">timesheet instructions</a>.`
};
const $b11db1b62d4a8f76$export$23e21e1c42b00a8b = {
    ar: $b11db1b62d4a8f76$var$html`أدخل أوقات الصباح أو المساء بفترات مدتها 15 دقيقة. أمثلة: <em>10 صباحا</em>، <em>9 مساء</em>، <em>9:15 صباحا</em>، <em>12:30 ظهرا</em>، <em>1:45 ظهرا</em>.`,
    de: $b11db1b62d4a8f76$var$html`Geben Sie die Zeiten mit AM oder PM in 15-Minuten-Intervallen ein. Beispiele: <em>10 Uhr</em>, <em>21 Uhr</em>, <em>9:15 Uhr</em>, <em>12:30 Uhr</em>, <em>13:45 Uhr</em>.`,
    es: $b11db1b62d4a8f76$var$html`Introduce los horarios con AM o PM en incrementos de 15 minutos. Ejemplos: <em>10:00</em>, <em>21:00</em>, <em>9:15,</em> <em>12:30,</em> <em>13:45.</em>`,
    fa: $b11db1b62d4a8f76$var$html`زمان های صبح یا عصر را در بازه های ۱۵ دقیقه ای وارد کنید. نمونه ها: <em>ساعت ۱۰ صبح</em>، <em>۹ شب</em>، <em>۹:۱۵ صبح</em>، <em>۱۲:۳۰ ظهر</em>، <em>۱:۴۵ بعدازظهر</em>.`,
    fil: $b11db1b62d4a8f76$var$html`Ipasok ang mga oras na may AM o PM sa 15 minutong pagtaas. Mga halimbawa: <em>10a</em>, <em>9p</em>, <em>9:15am</em>, <em>12:30pm</em>, <em>1.45pm</em>.`,
    fr: $b11db1b62d4a8f76$var$html`Entrez les heures du matin ou du soir par tranches de 15 minutes. Exemples : <em>10h</em>, <em>21h</em>, <em>9h15,</em> <em>12h30</em>, <em>13h45</em>.`,
    hi: $b11db1b62d4a8f76$var$html`15 मिनट की वृद्धि में AM या PM के साथ समय दर्ज करें। उदाहरण: <em>10a</em>, <em>9p</em>, <em>9:15am,</em> <em>12:30pm</em>, <em>1.45pm</em>.`,
    ht: $b11db1b62d4a8f76$var$html`Antre nan tan ak AM oswa PM nan 15 minit. Egzanp: <em>10a</em>, <em>9p</em>, <em>9:15am</em>, <em>12:30pm</em>, <em>1.45pm</em>.`,
    it: $b11db1b62d4a8f76$var$html`Inserisci gli orari con AM o PM in intervalli di 15 minuti. Esempi: <em>10:00</em>, <em>21:</em>00, <em>9:15,</em> <em>12:30</em>, <em>13:45</em>.`,
    ja: $b11db1b62d4a8f76$var$html`午前または午後の時刻を15分単位で入力してください。例: <em>午前10</em>時、 <em>午後9</em>時、 <em>午前9時15</em>分、 <em>午後12時30</em>分、 <em>午後1時45</em>分。`,
    ko: $b11db1b62d4a8f76$var$html`오전 또는 오후 시간을 15분 단위로 입력하세요. 예시: <em>오전 10</em>시, <em>오후 9</em><em>시, 오전 9시 15</em>분, <em>오후 12시 30</em>분, <em>오후 1시 45</em>분.`,
    mww: $b11db1b62d4a8f76$var$html`Sau cov sij hawm nrog AM lossis PM hauv 15 feeb nce ntxiv. Piv txwv: <em>10a</em>, <em>9p</em>, <em>9:15am</em>, <em>12:30pm</em>, <em>1.45pm</em>.`,
    ps: $b11db1b62d4a8f76$var$html`د AM یا PM وختونه په ۱۵ دقیقو کې داخل کړئ. بیلګې: <em>۱۰ بجې</em>، <em>۹ بجې</em>، <em>۹:۱۵ سهار</em>، <em>۱۲:۳۰ غرمه</em>، <em>۱:۴۵ ماسپښین</em>.`,
    pt: $b11db1b62d4a8f76$var$html`Insira os horários com AM ou PM em incrementos de 15 minutos. Exemplos: <em>10h</em>, <em>21h</em>, <em>9h15h</em>, <em>12h30</em>, <em>13h45</em>.`,
    'pt-pt': $b11db1b62d4a8f76$var$html`Insira os horários com AM ou PM em incrementos de 15 minutos. Exemplos: <em>10h</em>, <em>21h</em>, <em>9h15h</em>, <em>12h30</em>, <em>13h45</em>.`,
    ru: $b11db1b62d4a8f76$var$html`Вводите время с утра или вечером с интервалами по 15 минут. Примеры: <em>10:</em>00, <em>9:</em><em>15</em>, <em>12:30</em>, <em>13:45</em>.`,
    sm: $b11db1b62d4a8f76$var$html`Ulufale taimi i le AM po'o le PM i le 15-minute fa'aopoopoga. Fa'ata'ita'iga: <em>10a</em>, <em>9p</em>, <em>9:15am</em>, <em>12:30pm</em>, <em>1.45pm</em>.`,
    so: $b11db1b62d4a8f76$var$html`Geli waqtiyada subaxnimo ama galabnimo 15-daqiiqo ah. Tusaalooyin: <em>10 subaxnimo</em>, <em>9 galabnimo</em>, <em>9:15 subaxnimo</em>, <em>12:30 duhurnimo</em>, <em>1:45 duhurnimo</em>.`,
    th: $b11db1b62d4a8f76$var$html`ป้อนเวลาด้วย AM หรือ PM โดยเพิ่มทีละ 15 นาที ตัวอย่าง: <em>10a</em>, <em>9p</em>, <em>9:15 น</em>., <em>12:30 น</em>., <em>13.45 น</em>.`,
    ur: $b11db1b62d4a8f76$var$html`صبح یا شام کے اوقات 15 منٹ کے وقفوں میں درج کریں۔ مثالیں: <em>صبح 10</em>، <em>9 بجے</em>، <em>9:15 بجے</em>، <em>12:30 دوپہر</em>، <em>1:45 دوپہر</em>۔`,
    vi: $b11db1b62d4a8f76$var$html`Nhập thời gian với AM hoặc PM theo gia số 15 phút. Ví dụ: <em>10a</em>, <em>9p</em>, <em>9:15 sáng</em>, <em>12:30 trưa</em>, <em>1:45 chiều</em>.`,
    'zh-hans': $b11db1b62d4a8f76$var$html`请以15分钟为单位输入上午或下午时间。例如：<em>上午10</em>点、<em>晚上9</em><em>点、上午9点15</em>分、<em>中午12点30</em>分、<em>下午1点45</em>分。`,
    'zh-hant': $b11db1b62d4a8f76$var$html`請以 15 分鐘為單位輸入 AM 或 PM 時段。例如：<em>上午10</em>點、<em>晚上9</em><em>點、上午9點15</em>分、<em>中午12點30</em>分、<em>下午1點45</em>分。`,
    en: $b11db1b62d4a8f76$var$html`Enter times with AM or PM in 15-minute increments. Examples: <em>10a</em>, <em>9p</em>, <em>9:15am</em>, <em>12:30pm</em>, <em>1.45pm</em>.`
};
const $b11db1b62d4a8f76$export$32031607233b6094 = {
    ar: `\u{64A}\u{634}\u{62A}\u{631}\u{637} \u{62F}\u{62E}\u{648}\u{644} \u{645}\u{631}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629} \u{639}\u{644}\u{649} \u{627}\u{644}\u{623}\u{642}\u{644}. \u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{62A}\u{642}\u{62F}\u{64A}\u{645} \u{623}\u{648} \u{627}\u{644}\u{645}\u{648}\u{627}\u{641}\u{642}\u{629} \u{639}\u{644}\u{649} \u{62C}\u{62F}\u{627}\u{648}\u{644} \u{627}\u{644}\u{633}\u{627}\u{639}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{62D}\u{62A}\u{648}\u{64A} \u{639}\u{644}\u{649} \u{633}\u{627}\u{639}\u{627}\u{62A} \u{635}\u{641}\u{631}\u{64A}\u{629}.`,
    de: `Mindestens eine einmalige Teilnahme ist erforderlich. Stundenzettel mit null Stunden k\xf6nnen nicht eingereicht oder genehmigt werden.`,
    es: `Se requiere al menos una entrada puntual. No se pueden enviar ni aprobar hojas de horas sin horas.`,
    fa: `\u{62D}\u{62F}\u{627}\u{642}\u{644} \u{6CC}\u{6A9} \u{628}\u{627}\u{631} \u{648}\u{631}\u{648}\u{62F} \u{628}\u{647} \u{635}\u{648}\u{631}\u{62A} \u{6CC}\u{6A9} \u{628}\u{627}\u{631}\u{647} \u{627}\u{644}\u{632}\u{627}\u{645}\u{6CC} \u{627}\u{633}\u{62A}. \u{628}\u{631}\u{6AF}\u{647} \u{647}\u{627}\u{6CC} \u{633}\u{627}\u{639}\u{62A} \u{6A9}\u{627}\u{631}\u{6CC} \u{628}\u{62F}\u{648}\u{646} \u{633}\u{627}\u{639}\u{62A} \u{642}\u{627}\u{628}\u{644} \u{627}\u{631}\u{633}\u{627}\u{644} \u{6CC}\u{627} \u{62A}\u{623}\u{6CC}\u{6CC}\u{62F} \u{646}\u{6CC}\u{633}\u{62A}\u{646}\u{62F}.`,
    fil: `Kinakailangan ng hindi bababa sa isang beses na pagpasok. Ang mga timesheet na may zero na oras ay hindi maaaring isumite o maaprubahan.`,
    fr: `Au moins une entr\xe9e unique est requise. Les feuilles de temps sans aucune heure ne peuvent pas \xeatre soumises ni approuv\xe9es.`,
    hi: `\u{915}\u{92E} \u{938}\u{947} \u{915}\u{92E} \u{90F}\u{915} \u{92C}\u{93E}\u{930} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964} \u{936}\u{942}\u{928}\u{94D}\u{92F} \u{918}\u{902}\u{91F}\u{947} \u{935}\u{93E}\u{932}\u{940} \u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{938}\u{92C}\u{92E}\u{93F}\u{91F} \u{92F}\u{93E} \u{905}\u{928}\u{941}\u{92E}\u{94B}\u{926}\u{93F}\u{924} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{940}.`,
    ht: `Omwen yon s\xe8l fwa antre obligatwa. Timesheets ak z\xe8wo \xe8dtan pa ka soum\xe8t oswa apwouve.`,
    it: `\xc8 richiesta almeno una partecipazione puntuale. I fogli presenze con zero ore non possono essere inviati o approvati.`,
    ja: `\u{5C11}\u{306A}\u{304F}\u{3068}\u{3082}\u{4E00}\u{5EA6}\u{306F}\u{53C2}\u{52A0}\u{304C}\u{5FC5}\u{8981}\u{3067}\u{3059}\u{3002}\u{6642}\u{9593}\u{304C}\u{30BC}\u{30ED}\u{306E}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{306F}\u{63D0}\u{51FA}\u{307E}\u{305F}\u{306F}\u{627F}\u{8A8D}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{CD5C}\u{C18C} \u{D55C} \u{BC88}\u{C758} \u{CD9C}\u{C804} \u{C808}\u{CC28}\u{AC00} \u{D544}\u{C694}\u{D569}\u{B2C8}\u{B2E4}. \u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{C774} 0\u{C778} \u{D0C0}\u{C784}\u{C2DC}\u{D2B8}\u{B294} \u{C81C}\u{CD9C}\u{D558}\u{AC70}\u{B098} \u{C2B9}\u{C778}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Yuav tsum tau nkag tsawg kawg ib zaug. Cov sij hawm uas tsis muaj xoom teev xa tsis tau los yog pom zoo tsis tau.`,
    ps: `\u{644}\u{696} \u{62A}\u{631} \u{644}\u{696}\u{647} \u{6CC}\u{648} \u{681}\u{644} \u{62F}\u{627}\u{62E}\u{644}\u{6D0}\u{62F}\u{644} \u{627}\u{693}\u{6CC}\u{646} \u{62F}\u{6CC}. \u{62F} \u{635}\u{641}\u{631} \u{633}\u{627}\u{639}\u{62A}\u{648}\u{646}\u{648} \u{67C}\u{627}\u{6CC}\u{645} \u{634}\u{6CC}\u{67C}\u{648}\u{646}\u{647} \u{646}\u{647} \u{634}\u{6CC} \u{633}\u{67E}\u{627}\u{631}\u{644} \u{6A9}\u{6D0}\u{62F}\u{627}\u{6CC} \u{627}\u{648} \u{646}\u{647} \u{62A}\u{635}\u{648}\u{6CC}\u{628} \u{6A9}\u{6D0}\u{62F}\u{627}\u{6CC} \u{634}\u{6CC}.`,
    pt: `\xc9 necess\xe1rio pelo menos uma inscri\xe7\xe3o em hor\xe1rio \xfanico. Folhas de ponto com zero horas n\xe3o podem ser enviadas ou aprovadas.`,
    'pt-pt': `\xc9 obrigat\xf3rio pelo menos uma entrada pontual. Folhas de ponto com zero horas n\xe3o podem ser submetidas nem aprovadas.`,
    ru: `\u{422}\u{440}\u{435}\u{431}\u{443}\u{435}\u{442}\u{441}\u{44F} \u{445}\u{43E}\u{442}\u{44F} \u{431}\u{44B} \u{43E}\u{434}\u{438}\u{43D} \u{440}\u{430}\u{437}. \u{422}\u{430}\u{431}\u{435}\u{43B}\u{438} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{441} \u{43D}\u{443}\u{43B}\u{435}\u{43C} \u{447}\u{430}\u{441}\u{43E}\u{432} \u{43D}\u{435} \u{43C}\u{43E}\u{433}\u{443}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{44B} \u{438}\u{43B}\u{438} \u{443}\u{442}\u{432}\u{435}\u{440}\u{436}\u{434}\u{435}\u{43D}\u{44B}.`,
    sm: `E mana'omia le itiiti ifo ma le tasi le taimi e ulufale ai. E le mafai ona auina atu pe faamaonia ia pepa o taimi e leai ni itula.`,
    so: `Ugu yaraan hal mar ayaa loo baahan yahay in la geliyo. Waqtiyada leh saacado eber lama gudbin karo ama lama ansixin karo.`,
    th: `\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E02}\u{E49}\u{E32}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E19}\u{E49}\u{E2D}\u{E22}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07} \u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E2A}\u{E48}\u{E07}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E2D}\u{E19}\u{E38}\u{E21}\u{E31}\u{E15}\u{E34}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}\u{E17}\u{E35}\u{E48}\u{E21}\u{E35}\u{E0A}\u{E31}\u{E48}\u{E27}\u{E42}\u{E21}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E28}\u{E39}\u{E19}\u{E22}\u{E4C}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{6A9}\u{645} \u{627}\u{632} \u{6A9}\u{645} \u{627}\u{6CC}\u{6A9} \u{628}\u{627}\u{631} \u{627}\u{646}\u{679}\u{631}\u{6CC} \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2}\u{6D4} \u{632}\u{6CC}\u{631}\u{648} \u{622}\u{648}\u{631}\u{632} \u{648}\u{627}\u{644}\u{6CC} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679}\u{633} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{627}\u{626}\u{6CC} \u{6CC}\u{627} \u{645}\u{646}\u{638}\u{648}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `C\u{1EA7}n c\xf3 \xedt nh\u{1EA5}t m\u{1ED9}t l\u{1EA7}n nh\u{1EAD}p c\u{1EA3}nh. B\u{1EA3}ng ch\u{1EA5}m c\xf4ng kh\xf4ng c\xf3 gi\u{1EDD} kh\xf4ng th\u{1EC3} \u{111}\u{1B0}\u{1EE3}c g\u{1EED}i ho\u{1EB7}c ph\xea duy\u{1EC7}t.`,
    'zh-hans': `\u{81F3}\u{5C11}\u{9700}\u{8981}\u{4E00}\u{6B21}\u{5165}\u{573A}\u{3002}\u{5DE5}\u{65F6}\u{4E3A}\u{96F6}\u{7684}\u{5DE5}\u{65F6}\u{8868}\u{4E0D}\u{80FD}\u{63D0}\u{4EA4}\u{6216}\u{6279}\u{51C6}\u{3002}`,
    'zh-hant': `\u{81F3}\u{5C11}\u{9700}\u{53C3}\u{52A0}\u{4E00}\u{6B21}\u{3002}\u{5DE5}\u{6642}\u{70BA}\u{96F6}\u{7684}\u{5DE5}\u{6642}\u{8868}\u{7121}\u{6CD5}\u{63D0}\u{4EA4}\u{6216}\u{6838}\u{51C6}\u{3002}`,
    en: `At least one time entry is required. Timesheets with zero hours cannot be submitted or approved.`
};
const $b11db1b62d4a8f76$export$282956de952f4637 = {
    ar: (duration)=>$b11db1b62d4a8f76$var$html`الإدخالات التي تبلغ مدتها ${duration} تحتوي على أخطاء ولا يمكن دفع أجورها حتى يتم تصحيحها. راجع الأخطاء أدناه، ثم <a href="?edit">عدل جدول الأوقات</a> لتصحيحها. <strong>لا تؤخر تقديم جدول الأوقات بسبب هذه الأخطاء. قدمه في الوقت المحدد، ثم تواصل مع ممثل وكالتك في أقرب وقت ممكن لتصحيح الأخطاء.</strong>`,
    de: (duration)=>$b11db1b62d4a8f76$var$html`Einträge mit einer Gesamtlaufzeit ${duration} enthalten Fehler und können erst bezahlt werden, wenn sie korrigiert wurden. Überprüfen Sie die untenstehenden Fehler und <a href="?edit">bearbeiten Sie dann den Stundenzettel</a> , um sie zu korrigieren. <strong>Zögern Sie nicht mit der Einreichung Ihres Stundenzettels wegen dieser Fehler. Reichen Sie ihn pünktlich ein und kontaktieren Sie dann so schnell wie möglich Ihren Vertreter der Agentur, um die Fehler korrigieren zu lassen.</strong>`,
    es: (duration)=>$b11db1b62d4a8f76$var$html`Las entradas que suman ${duration} tienen errores y no pueden pagarse hasta que se corrigan. Revisa los errores a continuación y <a href="?edit">luego edita la hoja de horas</a> para corregirlos. <strong>No retrases la presentación de tu hoja de horas por estos errores. Envíala a tiempo y luego contacta con tu representante de la agencia lo antes posible para que los corrija.</strong>`,
    fa: (duration)=>$b11db1b62d4a8f76$var$html`ورودی هایی که مجموعا ${duration} طول می کشند دارای خطا هستند و تا زمانی که اصلاح نشوند، قابل پرداخت نیستند. خطاهای زیر را مرور کنید و سپس <a href="?edit">جدول زمان</a> بندی را ویرایش کنید تا اصلاح شوند. به <strong>خاطر این خطاها ارسال برگه زمان بندی خود را به تأخیر نیندازید. آن را به موقع ارسال کنید و سپس هرچه سریع تر با نماینده آژانس خود تماس بگیرید تا اشتباهات اصلاح شود.</strong>`,
    fil: (duration)=>$b11db1b62d4a8f76$var$html`Ang mga entry na may kabuuang ${duration} ay may mga error at hindi maaaring bayaran hangga't hindi ito naitama. Suriin ang mga error sa ibaba, pagkatapos ay <a href="?edit">i-edit ang timesheet</a> upang ayusin ang mga ito. <strong>Huwag ipagpaliban ang pagsusumite ng iyong timesheet dahil sa mga error na ito. Isumite ito sa tamang oras, pagkatapos ay kontakin ang kinatawan ng iyong ahensya sa lalong madaling panahon upang maitama ang mga error.</strong>`,
    fr: (duration)=>$b11db1b62d4a8f76$var$html`Les entrées ${duration} comportent des erreurs et ne peuvent être payées tant qu’elles n’ont pas été corrigées. Examinez les erreurs ci-dessous, puis <a href="?edit">modifiez la feuille de temps</a> pour les corriger. <strong>Ne retardez pas la soumission de votre feuille de temps à cause de ces erreurs. Soumettez-la à temps, puis contactez votre représentant d’agence dès que possible pour corriger les erreurs.</strong>`,
    hi: (duration)=>$b11db1b62d4a8f76$var$html`कुल ${duration} की प्रविष्टियों में त्रुटियां हैं और उन्हें ठीक किए जाने तक भुगतान नहीं किया जा सकता है। नीचे दी गई त्रुटियों की समीक्षा करें, फिर उन्हें ठीक करने <a href="?edit">के लिए टाइमशीट संपादित करें</a> । <strong>इन त्रुटियों के कारण अपनी टाइमशीट सबमिट करने में देरी न करें। इसे समय पर सबमिट करें, फिर त्रुटियों को ठीक करने के लिए जितनी जल्दी हो सके अपने एजेंसी प्रतिनिधि से संपर्क करें।</strong>`,
    ht: (duration)=>$b11db1b62d4a8f76$var$html`Antre ki totalize ${duration} gen erè epi yo pa ka peye jiskaske yo korije. Revize erè ki anba a, Lè sa a, <a href="?edit">modifye Fèy tan an</a> pou ranje yo. <strong>Pa reta soumèt Fèy tan ou paske nan erè sa yo. Soumèt li alè, Lè sa a, kontakte reprezantan ajans ou a pi vit ke posib yo korije erè yo.</strong>`,
    it: (duration)=>$b11db1b62d4a8f76$var$html`Le voci per un totale ${duration} presentano errori e non possono essere pagate finché non vengono corrette. Rivedi gli errori qui sotto, poi <a href="?edit">modifica il foglio presenze</a> per correggerli. <strong>Non ritardare l'invio del foglio presenze a causa di questi errori. Consegnalo puntualmente, poi contatta il rappresentante della tua agenzia il prima possibile per correggere gli errori.</strong>`,
    ja: (duration)=>$b11db1b62d4a8f76$var$html`合計 ${duration} のエントリーには誤りがあり、修正されるまで支払いができません。以下の誤りを確認し、タイム <a href="?edit">シートを修正</a> してください。 <strong>これらの誤りのためにタイムシートの提出を遅らせないでください。期限内に提出し、できるだけ早く代理店の担当者に連絡して誤りを修正してください。</strong>`,
    ko: (duration)=>$b11db1b62d4a8f76$var$html`총 ${duration} 분량의 입력 기록에는 오류가 있으며, 수정될 때까지 지급할 수 없습니다. 아래의 오류를 검토한 후 <a href="?edit">타임시트를 수정</a> 해 수정하세요. <strong>이러한 오류 때문에 타임시트 제출을 미루지 마세요. 제때 제출한 후 가능한 한 빨리 에이전시 담당자에게 연락하여 오류를 수정받으시기 바랍니다.</strong>`,
    mww: (duration)=>$b11db1b62d4a8f76$var$html`Cov ntawv sau tag nrho ${duration} muaj kev yuam kev thiab tsis tuaj yeem them nyiaj kom txog thaum lawv raug kho. Xyuas cov yuam kev hauv qab no, tom qab ntawd <a href="?edit">kho daim ntawv sijhawm</a> kom kho tau. <strong>Tsis txhob ncua sijhawm xa koj daim ntawv sijhawm vim cov yuam kev no. Xa nws raws sijhawm, tom qab ntawd hu rau koj tus neeg sawv cev ntawm koj lub koom haum sai li sai tau kom kho cov yuam kev.</strong>`,
    ps: (duration)=>$b11db1b62d4a8f76$var$html`ټولټال ${duration} لیکنې تېروتنې لری او تر هغه وخته پورې پیسې نه شی ورکول کېدای چې اصلاح شی. لاندې تېروتنې وګورئ، بیا <a href="?edit">د وخت پاڼه سم</a> کړئ ترڅو اصلاح یې کړئ. د <strong>دې تېروتنو له امله خپل وخت پاڼه مه ځنډوئ. پر وخت یې وسپارئ، بیا ژر تر ژره د خپلې ادارې استازی سره اړیکه ونیسئ ترڅو تېروتنې اصلاح شی.</strong>`,
    pt: (duration)=>$b11db1b62d4a8f76$var$html`Entradas ${duration} apresentam erros e não podem ser pagas até serem corrigidas. Revise os erros abaixo e <a href="?edit">depois edite a folha de ponto</a> para corrigi-los. <strong>Não atrase o envio da sua folha de ponto por causa desses erros. Envie-a no prazo e entre em contato com o representante da agência o quanto antes para corrigir os erros.</strong>`,
    'pt-pt': (duration)=>$b11db1b62d4a8f76$var$html`Entradas com ${duration} apresentam erros e não podem ser pagas até serem corrigidas. Revise os erros abaixo e <a href="?edit">depois edite a folha de horas</a> para os corrigir. <strong>Não atrase a entrega da sua folha de horas devido a esses erros. Submeta-a a tempo e contacte o representante da sua agência o mais rapidamente possível para corrigir os erros.</strong>`,
    ru: (duration)=>$b11db1b62d4a8f76$var$html`Записи общей ${duration} минут содержат ошибки и не могут быть оплачены до их исправления. Ознакомьтесь с ошибками ниже, затем <a href="?edit">отредактируйте табель</a>, чтобы их исправить. <strong>Не откладывайте отправку табеля из-за этих ошибок. Отправляйте его вовремя, а затем как можно скорее свяжитесь с представителем агентства, чтобы исправить ошибки</strong>.`,
    sm: (duration)=>$b11db1b62d4a8f76$var$html`O fa'amatalaga e ${duration} o lo'o i ai ni mea sese ma e le mafai ona totogiina se'i vagana ua fa'asa'oina. Toe iloilo mea sese o lo'o i lalo, ona <a href="?edit">fa'asa'o lea o le pepa o taimi e fa'asa'o</a> ai. <strong>Aua le fa'atuai le tu'uina atu o lau pepa o taimi ona o nei mea sese. Auina atu i le taimi sa'o, ona fa'afeso'ota'i lea o lau sui ofisa i se taimi vave e mafai ai e fa'asa'o mea sese.</strong>`,
    so: (duration)=>$b11db1b62d4a8f76$var$html`Qoraallada wadarta ${duration} waxay leeyihiin khaladaad mana la bixin karo ilaa la saxo. Dib u eeg khaladaadka hoose, kadibna <a href="?edit">wax ka beddel jadwalka</a> waqtiga si aad u saxdo. <strong>Ha dib u dhigin gudbinta jadwalka waqtigaaga sababo la xiriira khaladaadkan. Soo gudbi waqtiga waqtiga, kadibna la xiriir wakiilka hay'addaada sida ugu dhaqsaha badan si khaladaadka loo saxo.</strong>`,
    th: (duration)=>$b11db1b62d4a8f76$var$html`บันทึกที่มีความยาวรวม ${duration} จะมีข้อผิดพลาดและไม่สามารถจ่ายเงินได้จนกว่าจะได้รับการแก้ไขตรวจสอบข้อผิดพลาดด้านล่าง จากนั้น <a href="?edit">แก้ไขตารางเวลา</a> เพื่อแก้ไข <strong>อย่าล่าช้าในการส่งบันทึกเวลาเพราะข้อผิดพลาดเหล่านี้ส่งตรงเวลา จากนั้นติดต่อตัวแทนของบริษัทโดยเร็วที่สุดเพื่อแก้ไขข้อผิดพลาด</strong>`,
    ur: (duration)=>$b11db1b62d4a8f76$var$html`${duration} کی اندراجات میں غلطیاں ہوتی ہیں اور انہیں درست کیے بغیر ادائیگی نہیں کی جا سکتی۔ نیچے دی گئی غلطیوں کا جائزہ لیں، پھر انہیں درست کرنے کے لیے <a href="?edit">ٹائم شیٹ میں ترمیم</a> کریں۔ <strong>ان غلطیوں کی وجہ سے اپنی ٹائم شیٹ جمع کروانے میں تاخیر نہ کریں۔ وقت پر جمع کرواؤ، پھر جلد از جلد اپنی ایجنسی کے نمائندے سے رابطہ کریں تاکہ غلطیاں درست کی جا</strong> سکیں۔`,
    vi: (duration)=>$b11db1b62d4a8f76$var$html`Các mục ghi tổng cộng ${duration} đều có lỗi và không thể thanh toán cho đến khi được sửa. Xem lại các lỗi bên dưới, sau đó <a href="?edit">chỉnh sửa bảng chấm công</a> để khắc phục. <strong>Đừng trì hoãn việc nộp bảng chấm công chỉ vì những lỗi này. Nộp đúng hạn, sau đó liên hệ với đại diện đại lý càng sớm càng tốt để sửa lỗi.</strong>`,
    'zh-hans': (duration)=>$b11db1b62d4a8f76$var$html`总计6 ${duration} 的记录存在错误，且在纠正前无法支付。请查看下面的错误，然后 <a href="?edit">编辑工时表</a> 进行修正。 <strong>不要因为这些错误而拖延提交工时表。按时提交，然后尽快联系你的机构代表，要求纠正错误。</strong>`,
    'zh-hant': (duration)=>$b11db1b62d4a8f76$var$html`總計 ${duration} 的報案有錯誤，且在修正前無法支付。請檢視以下錯誤，然後 <a href="?edit">編輯工時表</a> 修正。 <strong>切勿因這些錯誤而延遲提交工時表。準時提交，然後盡快聯絡你的代理代表，請他們更正錯誤。</strong>`,
    en: (duration)=>$b11db1b62d4a8f76$var$html`Entries totaling ${duration} have errors and cannot be paid until they are corrected. Review the errors below, then <a href="?edit">edit the timesheet</a> to fix them. <strong>Do not delay submitting your timesheet because of these errors. Submit it on time, then contact your agency representative as soon as possible to have the errors corrected.</strong>`
};
const $b11db1b62d4a8f76$export$41bb7df7ac7e5980 = {
    ar: `\u{62C}\u{62F}\u{648}\u{644} \u{632}\u{645}\u{646}\u{64A} \u{644}\u{647}\u{630}\u{647} \u{627}\u{644}\u{641}\u{62A}\u{631}\u{629} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{628}\u{627}\u{644}\u{641}\u{639}\u{644}. \u{644}\u{627} \u{64A}\u{633}\u{645}\u{62D} \u{628}\u{648}\u{62C}\u{648}\u{62F} \u{639}\u{62F}\u{629} \u{62C}\u{62F}\u{627}\u{648}\u{644} \u{632}\u{645}\u{646}\u{64A}\u{629} \u{644}\u{646}\u{641}\u{633} \u{627}\u{644}\u{641}\u{62A}\u{631}\u{629}.`,
    de: `Ein Stundenzettel f\xfcr diesen Abrechnungszeitraum existiert bereits. Mehrere Stundenzettel f\xfcr denselben Zeitraum sind nicht erlaubt.`,
    es: `Ya existe una hoja de horas para este periodo de pago. No se permiten m\xfaltiples hojas de horas para el mismo periodo.`,
    fa: `\u{6CC}\u{6A9} \u{62C}\u{62F}\u{648}\u{644} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{6CC}\u{646} \u{62F}\u{648}\u{631}\u{647} \u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A} \u{642}\u{628}\u{644}\u{627} \u{648}\u{62C}\u{648}\u{62F} \u{62F}\u{627}\u{631}\u{62F}. \u{686}\u{646}\u{62F}\u{6CC}\u{646} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646} \u{628}\u{631}\u{627}\u{6CC} \u{6CC}\u{6A9} \u{62F}\u{648}\u{631}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{645}\u{62C}\u{627}\u{632} \u{646}\u{6CC}\u{633}\u{62A}.`,
    fil: `Umiiral na ang timesheet para sa pay period na ito. Hindi pinapayagan ang maramihang mga timesheet para sa parehong panahon.`,
    fr: `Une feuille de temps pour cette p\xe9riode de paie existe d\xe9j\xe0. Plusieurs feuilles de temps pour la m\xeame p\xe9riode ne sont pas autoris\xe9es.`,
    hi: `\u{907}\u{938} \u{935}\u{947}\u{924}\u{928} \u{905}\u{935}\u{927}\u{93F} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{90F}\u{915} \u{938}\u{92E}\u{92F} \u{92A}\u{924}\u{94D}\u{930}\u{915} \u{92A}\u{939}\u{932}\u{947} \u{938}\u{947} \u{92E}\u{94C}\u{91C}\u{942}\u{926} \u{939}\u{948}\u{964} \u{90F}\u{915} \u{939}\u{940} \u{905}\u{935}\u{927}\u{93F} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{90F}\u{915}\u{93E}\u{927}\u{93F}\u{915} \u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{964}`,
    ht: `Yon f\xe8y tan pou pery\xf2d peman sa a deja egziste. Fich tan miltip pou menm pery\xf2d la pa p\xe8m\xe8t.`,
    it: `Esiste gi\xe0 un foglio di pagamento per questo periodo di paga. Non \xe8 consentito avere pi\xf9 fogli orario per lo stesso periodo.`,
    ja: `\u{3053}\u{306E}\u{7D66}\u{4E0E}\u{671F}\u{9593}\u{306E}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{306F}\u{3059}\u{3067}\u{306B}\u{5B58}\u{5728}\u{3057}\u{307E}\u{3059}\u{3002}\u{540C}\u{3058}\u{671F}\u{9593}\u{306E}\u{8907}\u{6570}\u{306E}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{306F}\u{8A31}\u{53EF}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774} \u{AE09}\u{C5EC} \u{AE30}\u{AC04}\u{C5D0} \u{B300}\u{D55C} \u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C}\u{B294} \u{C774}\u{BBF8} \u{C874}\u{C7AC}\u{D569}\u{B2C8}\u{B2E4}. \u{AC19}\u{C740} \u{AE30}\u{AC04}\u{C5D0} \u{B300}\u{D574} \u{C5EC}\u{B7EC} \u{AC1C}\u{C758} \u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C}\u{B97C} \u{C791}\u{C131}\u{D558}\u{B294} \u{AC83}\u{C740} \u{D5C8}\u{C6A9}\u{B418}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Ib daim ntawv qhia txog lub sijhawm them nyiaj no twb muaj lawm. Tsis pub muaj ntau daim ntawv teev sij hawm rau tib lub sijhawm.`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{645}\u{639}\u{627}\u{634} \u{645}\u{648}\u{62F}\u{6D0} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647} \u{644}\u{627} \u{62F}\u{645}\u{62E}\u{647} \u{634}\u{62A}\u{647}. \u{62F} \u{6CC}\u{648}\u{6D0} \u{645}\u{648}\u{62F}\u{6D0} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{685}\u{648} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{6D0} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: `J\xe1 existe uma folha de ponto para esse per\xedodo de pagamento. N\xe3o \xe9 permitido usar m\xfaltiplos folhas de ponto para o mesmo per\xedodo.`,
    'pt-pt': `J\xe1 existe uma folha de horas para este per\xedodo de pagamento. N\xe3o \xe9 permitido usar v\xe1rias folhas de ponto para o mesmo per\xedodo.`,
    ru: `\u{422}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{434}\u{43B}\u{44F} \u{44D}\u{442}\u{43E}\u{433}\u{43E} \u{43F}\u{43B}\u{430}\u{442}\u{451}\u{436}\u{43D}\u{43E}\u{433}\u{43E} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430} \u{443}\u{436}\u{435} \u{441}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442}. \u{41D}\u{435}\u{441}\u{43A}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{435}\u{439} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{437}\u{430} \u{43E}\u{434}\u{438}\u{43D} \u{438} \u{442}\u{43E}\u{442} \u{436}\u{435} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434} \u{43D}\u{435} \u{434}\u{43E}\u{43F}\u{443}\u{441}\u{43A}\u{430}\u{44E}\u{442}\u{441}\u{44F}.`,
    sm: `Ua uma ona i ai se pepa o taimi mo lenei vaitau o totogi. E le fa'atagaina le tele o taimi mo le vaitaimi lava e tasi.`,
    so: `Jadwalka waqtiga mushaharkan hore ayaa jira. Jadwalka waqtiyada badan ee isla muddadaas lama oggola.`,
    th: `\u{E21}\u{E35}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E23}\u{E2D}\u{E1A}\u{E23}\u{E30}\u{E22}\u{E30}\u{E40}\u{E27}\u{E25}\u{E32}\u{E01}\u{E32}\u{E23}\u{E08}\u{E48}\u{E32}\u{E22}\u{E40}\u{E07}\u{E34}\u{E19}\u{E19}\u{E35}\u{E49}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E41}\u{E25}\u{E49}\u{E27} \u{E44}\u{E21}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E41}\u{E1C}\u{E48}\u{E19}\u{E40}\u{E27}\u{E25}\u{E32}\u{E2B}\u{E25}\u{E32}\u{E22}\u{E41}\u{E1C}\u{E48}\u{E19}\u{E43}\u{E19}\u{E0A}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E01}\u{E31}\u{E19}`,
    ur: `\u{627}\u{633} \u{62A}\u{646}\u{62E}\u{648}\u{627}\u{6C1} \u{6A9}\u{6CC} \u{645}\u{62F}\u{62A} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{6CC}\u{6A9} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{67E}\u{6C1}\u{644}\u{6D2} \u{633}\u{6D2} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{6C1}\u{6D2}\u{6D4} \u{627}\u{6CC}\u{6A9} \u{6C1}\u{6CC} \u{645}\u{62F}\u{62A} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{645}\u{62A}\u{639}\u{62F}\u{62F} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679}\u{633} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `B\u{1EA3}ng ch\u{1EA5}m c\xf4ng cho k\u{1EF3} tr\u{1EA3} l\u{1B0}\u{1A1}ng n\xe0y \u{111}\xe3 t\u{1ED3}n t\u{1EA1}i. Kh\xf4ng \u{111}\u{1B0}\u{1EE3}c ph\xe9p s\u{1EED} d\u{1EE5}ng nhi\u{1EC1}u b\u{1EA3}ng ch\u{1EA5}m c\xf4ng trong c\xf9ng m\u{1ED9}t kho\u{1EA3}ng th\u{1EDD}i gian.`,
    'zh-hans': `\u{8BE5}\u{5DE5}\u{8D44}\u{671F}\u{7684}\u{5DE5}\u{65F6}\u{8868}\u{5DF2}\u{7ECF}\u{5B58}\u{5728}\u{3002}\u{540C}\u{4E00}\u{671F}\u{95F4}\u{4E0D}\u{5141}\u{8BB8}\u{586B}\u{5199}\u{591A}\u{4EFD}\u{5DE5}\u{65F6}\u{8868}\u{3002}`,
    'zh-hant': `\u{9019}\u{500B}\u{85AA}\u{8CC7}\u{671F}\u{7684}\u{5DE5}\u{6642}\u{8868}\u{5DF2}\u{7D93}\u{5B58}\u{5728}\u{3002}\u{540C}\u{4E00}\u{671F}\u{9593}\u{4E0D}\u{5141}\u{8A31}\u{591A}\u{4EFD}\u{5DE5}\u{6642}\u{8868}\u{3002}`,
    en: `A timesheet for this pay period already exists. Multiple timesheets for the same period are not allowed.`
};
const $b11db1b62d4a8f76$export$7b64dad35f083c65 = {
    ar: `\u{644}\u{645} \u{62A}\u{62D}\u{641}\u{638} \u{62A}\u{63A}\u{64A}\u{64A}\u{631}\u{627}\u{62A}\u{643} \u{644}\u{623}\u{646} \u{647}\u{630}\u{647} \u{627}\u{644}\u{648}\u{631}\u{642}\u{629} \u{627}\u{644}\u{632}\u{645}\u{646}\u{64A}\u{629} \u{644}\u{645} \u{62A}\u{639}\u{62F} \u{641}\u{64A} \u{62D}\u{627}\u{644}\u{629} \u{627}\u{644}\u{645}\u{633}\u{648}\u{62F}\u{629}. \u{642}\u{62F} \u{62A}\u{643}\u{648}\u{646} \u{62A}\u{63A}\u{64A}\u{631}\u{62A} \u{628}\u{639}\u{62F} \u{641}\u{62A}\u{62D} \u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629}. \u{642}\u{645} \u{628}\u{62A}\u{62D}\u{62F}\u{64A}\u{62B} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} \u{644}\u{639}\u{631}\u{636} \u{62D}\u{627}\u{644}\u{62A}\u{647}\u{627} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}\u{629}.`,
    de: `Ihre \xc4nderungen wurden nicht gespeichert, da dieser Stundenzettel nicht mehr im Entwurfsstatus ist. Er k\xf6nnte sich ge\xe4ndert haben, nachdem Sie diese Seite ge\xf6ffnet haben. Aktualisieren Sie die Seite, um ihren aktuellen Status anzuzeigen.`,
    es: `Tus cambios no se guardaron porque esta hoja de horas ya no est\xe1 en estado de borrador. Puede que haya cambiado despu\xe9s de que abrieras esta p\xe1gina. Actualiza la p\xe1gina para ver su estado actual.`,
    fa: `\u{62A}\u{63A}\u{6CC}\u{6CC}\u{631}\u{627}\u{62A} \u{634}\u{645}\u{627} \u{630}\u{62E}\u{6CC}\u{631}\u{647} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{646}\u{62F} \u{686}\u{648}\u{646} \u{627}\u{6CC}\u{646} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646} \u{62F}\u{6CC}\u{6AF}\u{631} \u{62F}\u{631} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{67E}\u{6CC}\u{634} \u{646}\u{648}\u{6CC}\u{633} \u{646}\u{6CC}\u{633}\u{62A}. \u{645}\u{645}\u{6A9}\u{646} \u{627}\u{633}\u{62A} \u{67E}\u{633} \u{627}\u{632} \u{628}\u{627}\u{632} \u{6A9}\u{631}\u{62F}\u{646} \u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{6A9}\u{631}\u{62F}\u{647} \u{628}\u{627}\u{634}\u{62F}. \u{635}\u{641}\u{62D}\u{647} \u{631}\u{627} \u{62A}\u{627}\u{632}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F} \u{62A}\u{627} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{641}\u{639}\u{644}\u{6CC} \u{622}\u{646} \u{631}\u{627} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Hindi na-save ang iyong mga pagbabago dahil ang timesheet na ito ay wala na sa draft status. Maaaring nagbago ito matapos mong buksan ang pahinang ito. I-refresh ang pahina upang makita ang kasalukuyang status nito.`,
    fr: `Vos modifications n\u{2019}ont pas \xe9t\xe9 sauvegard\xe9es car cette feuille de temps n\u{2019}est plus en statut de brouillon. Elle a peut-\xeatre chang\xe9 apr\xe8s l\u{2019}ouverture de cette page. Rafra\xeechissez la page pour voir son statut actuel.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{92A}\u{930}\u{93F}\u{935}\u{930}\u{94D}\u{924}\u{928} \u{938}\u{939}\u{947}\u{91C}\u{947} \u{928}\u{939}\u{940}\u{902} \u{917}\u{90F} \u{925}\u{947} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{92F}\u{939} \u{938}\u{92E}\u{92F}\u{92A}\u{924}\u{94D}\u{930}\u{915} \u{905}\u{92C} \u{921}\u{94D}\u{930}\u{93E}\u{92B}\u{93C}\u{94D}\u{91F} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{92E}\u{947}\u{902} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}. \u{939}\u{94B} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948} \u{915}\u{93F} \u{92F}\u{939} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{916}\u{94B}\u{932}\u{928}\u{947} \u{915}\u{947} \u{92C}\u{93E}\u{926} \u{92A}\u{930}\u{93F}\u{935}\u{930}\u{94D}\u{924}\u{93F}\u{924} \u{939}\u{94B} \u{917}\u{92F}\u{93E} \u{939}\u{94B}. \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{915}\u{940} \u{935}\u{930}\u{94D}\u{924}\u{92E}\u{93E}\u{928} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{926}\u{947}\u{916}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{909}\u{938}\u{947} \u{924}\u{93E}\u{91C}\u{93C}\u{93E} \u{915}\u{930}\u{947}\u{902}.`,
    ht: `Chanjman ou yo pa t sove paske F\xe8y del\xe8 sa a pa nan estati bouyon ank\xf2. Li ka chanje apre ou louvri paj sa a. Rafrechi paj la pou w\xe8 estati li ye kounye a.`,
    it: `Le tue modifiche non sono state salvate perch\xe9 questo foglio orario non \xe8 pi\xf9 in stato di bozza. Potrebbe essere cambiato dopo che hai aperto questa pagina. Aggiorna la pagina per visualizzare lo stato attuale.`,
    ja: `\u{5909}\u{66F4}\u{304C}\u{4FDD}\u{5B58}\u{3055}\u{308C}\u{3066}\u{3044}\u{306A}\u{3044}\u{306E}\u{306F}\u{3001}\u{3053}\u{306E}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{304C}\u{30C9}\u{30E9}\u{30D5}\u{30C8}\u{72B6}\u{614B}\u{304B}\u{3089}\u{306A}\u{304F}\u{306A}\u{3063}\u{305F}\u{305F}\u{3081}\u{3067}\u{3059}\u{3002}\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{3092}\u{958B}\u{3044}\u{305F}\u{5F8C}\u{306B}\u{5909}\u{66F4}\u{3055}\u{308C}\u{305F}\u{53EF}\u{80FD}\u{6027}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}\u{30DA}\u{30FC}\u{30B8}\u{3092}\u{66F4}\u{65B0}\u{3057}\u{3066}\u{73FE}\u{5728}\u{306E}\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}\u{3092}\u{78BA}\u{8A8D}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{BCC0}\u{ACBD} \u{C0AC}\u{D56D}\u{C774} \u{C800}\u{C7A5}\u{B418}\u{C9C0} \u{C54A}\u{C740} \u{C774}\u{C720}\u{B294} \u{C774} \u{D0C0}\u{C784}\u{C2DC}\u{D2B8}\u{AC00} \u{B354} \u{C774}\u{C0C1} \u{CD08}\u{C548} \u{C0C1}\u{D0DC}\u{AC00} \u{C544}\u{B2C8}\u{AE30} \u{B54C}\u{BB38}\u{C785}\u{B2C8}\u{B2E4}. \u{C774} \u{D398}\u{C774}\u{C9C0}\u{B97C} \u{C5F4}\u{C5C8}\u{C744} \u{B54C} \u{BCC0}\u{ACBD}\u{B418}\u{C5C8}\u{C744} \u{C218}\u{B3C4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}. \u{D398}\u{C774}\u{C9C0}\u{B97C} \u{C0C8}\u{B85C}\u{ACE0}\u{CE68}\u{D558}\u{C5EC} \u{D604}\u{C7AC} \u{C0C1}\u{D0DC}\u{B97C} \u{D655}\u{C778}\u{D558}\u{C138}\u{C694}.`,
    mww: `Koj cov kev hloov tsis tau khaws cia vim daim ntawv sijhawm no tsis nyob hauv qhov xwm txheej draft lawm. Tej zaum nws tau hloov tom qab koj qhib nplooj ntawv no. Rov kho nplooj ntawv kom pom nws qhov xwm txheej tam sim no.`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{628}\u{62F}\u{644}\u{648}\u{646}\u{648}\u{646}\u{647} \u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{646}\u{647} \u{634}\u{648}\u{644} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62F}\u{627} \u{67C}\u{627}\u{6CC}\u{645} \u{634}\u{6CC}\u{67C} \u{646}\u{648}\u{631} \u{62F} \u{645}\u{633}\u{648}\u{62F}\u{6D0} \u{62D}\u{627}\u{644}\u{62A} \u{6A9}\u{6D0} \u{646}\u{647} \u{62F}\u{6CC}. \u{6A9}\u{6D0}\u{62F}\u{627}\u{6CC} \u{634}\u{6CC} \u{62F}\u{627} \u{644}\u{647} \u{647}\u{63A}\u{647} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{647} \u{628}\u{62F}\u{644} \u{634}\u{648}\u{6CC} \u{648}\u{6CC} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{62F}\u{627} \u{67E}\u{627}\u{6BC}\u{647} \u{62E}\u{644}\u{627}\u{635}\u{647} \u{6A9}\u{693}\u{647}. \u{67E}\u{627}\u{6BC}\u{647} \u{62A}\u{627}\u{632}\u{647} \u{6A9}\u{693}\u{626} \u{62A}\u{631}\u{685}\u{648} \u{627}\u{648}\u{633}\u{646}\u{6CC} \u{62D}\u{627}\u{644}\u{62A} \u{648}\u{648}\u{6CC}\u{646}\u{6CC}.`,
    pt: `Suas altera\xe7\xf5es n\xe3o foram salvas porque essa folha de ponto n\xe3o est\xe1 mais em status de rascunho. Pode ter mudado depois que voc\xea abriu esta p\xe1gina. Atualize a p\xe1gina para ver seu status atual.`,
    'pt-pt': `As suas altera\xe7\xf5es n\xe3o foram guardadas porque esta folha de horas j\xe1 n\xe3o est\xe1 em estado de rascunho. Pode ter mudado depois de abrir esta p\xe1gina. Atualize a p\xe1gina para ver o seu estado atual.`,
    ru: `\u{412}\u{430}\u{448}\u{438} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{43D}\u{435} \u{431}\u{44B}\u{43B}\u{438} \u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{44B}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{44D}\u{442}\u{43E}\u{442} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{43D}\u{435} \u{43D}\u{430}\u{445}\u{43E}\u{434}\u{438}\u{442}\u{441}\u{44F} \u{432} \u{447}\u{435}\u{440}\u{43D}\u{43E}\u{432}\u{438}\u{43A}\u{435}. \u{412}\u{43E}\u{437}\u{43C}\u{43E}\u{436}\u{43D}\u{43E}, \u{43E}\u{43D} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{438}\u{43B}\u{441}\u{44F} \u{43F}\u{43E}\u{441}\u{43B}\u{435} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{438}\u{44F} \u{44D}\u{442}\u{43E}\u{439} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{44B}. \u{41E}\u{431}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{435} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{443}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{443}\u{432}\u{438}\u{434}\u{435}\u{442}\u{44C} \u{435}\u{451} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}.`,
    sm: `E le'i sefeina au suiga ona o lenei pepa o taimi e le o toe i ai i le tulaga o le fa'ata'ita'iga. Atonu na suia ina ua uma ona e tatalaina lenei itulau. Fa'afouina le itulau e va'ai ai i lona tulaga o lo'o i ai nei.`,
    so: `Isbeddelladaada lama keydinin sababtoo ah jadwalkan waqtigan hadda ma jiro qoraal cusub. Waxaa laga yaabaa inuu isbeddelay ka dib markii aad boggan furtay. Cusbooneysii bogga si aad u aragto xaaladdiisa hadda.`,
    th: `\u{E01}\u{E32}\u{E23}\u{E40}\u{E1B}\u{E25}\u{E35}\u{E48}\u{E22}\u{E19}\u{E41}\u{E1B}\u{E25}\u{E07}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E16}\u{E39}\u{E01}\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E41}\u{E1C}\u{E48}\u{E19}\u{E40}\u{E27}\u{E25}\u{E32}\u{E19}\u{E35}\u{E49}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E43}\u{E19}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E23}\u{E48}\u{E32}\u{E07}\u{E2D}\u{E35}\u{E01}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}\u{E2D}\u{E32}\u{E08}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E40}\u{E1B}\u{E25}\u{E35}\u{E48}\u{E22}\u{E19}\u{E41}\u{E1B}\u{E25}\u{E07}\u{E2B}\u{E25}\u{E31}\u{E07}\u{E08}\u{E32}\u{E01}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E40}\u{E1B}\u{E34}\u{E14}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}\u{E23}\u{E35}\u{E40}\u{E1F}\u{E23}\u{E0A}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E14}\u{E39}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E1B}\u{E31}\u{E08}\u{E08}\u{E38}\u{E1A}\u{E31}\u{E19}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{628}\u{62F}\u{6CC}\u{644}\u{6CC}\u{627}\u{6BA} \u{645}\u{62D}\u{641}\u{648}\u{638} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{626}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{6CC}\u{6C1} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{627}\u{628} \u{688}\u{631}\u{627}\u{641}\u{679} \u{627}\u{633}\u{679}\u{6CC}\u{679}\u{633} \u{645}\u{6CC}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4} \u{645}\u{645}\u{6A9}\u{646} \u{6C1}\u{6D2} \u{6A9}\u{6C1} \u{6CC}\u{6C1} \u{622}\u{67E} \u{6A9}\u{6D2} \u{627}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{6A9}\u{648} \u{6A9}\u{6BE}\u{648}\u{644}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{628}\u{639}\u{62F} \u{628}\u{62F}\u{644} \u{6AF}\u{626}\u{6CC} \u{6C1}\u{648}\u{6D4} \u{635}\u{641}\u{62D}\u{6C1} \u{6A9}\u{648} \u{62A}\u{627}\u{632}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{62A}\u{627}\u{6A9}\u{6C1} \u{627}\u{633} \u{6A9}\u{6CC} \u{645}\u{648}\u{62C}\u{648}\u{62F}\u{6C1} \u{62D}\u{627}\u{644}\u{62A} \u{62F}\u{6CC}\u{6A9}\u{6BE} \u{633}\u{6A9}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `C\xe1c thay \u{111}\u{1ED5}i c\u{1EE7}a b\u{1EA1}n kh\xf4ng \u{111}\u{1B0}\u{1EE3}c l\u{1B0}u v\xec b\u{1EA3}ng ch\u{1EA5}m c\xf4ng n\xe0y kh\xf4ng c\xf2n \u{1EDF} tr\u{1EA1}ng th\xe1i b\u{1EA3}n nh\xe1p. C\xf3 th\u{1EC3} n\xf3 \u{111}\xe3 thay \u{111}\u{1ED5}i sau khi b\u{1EA1}n m\u{1EDF} trang n\xe0y. L\xe0m m\u{1EDB}i trang \u{111}\u{1EC3} xem tr\u{1EA1}ng th\xe1i hi\u{1EC7}n t\u{1EA1}i.`,
    'zh-hans': `\u{4F60}\u{7684}\u{66F4}\u{6539}\u{672A}\u{88AB}\u{4FDD}\u{5B58}\u{FF0C}\u{56E0}\u{4E3A}\u{8BE5}\u{5DE5}\u{65F6}\u{8868}\u{5DF2}\u{4E0D}\u{518D}\u{5904}\u{4E8E}\u{8349}\u{7A3F}\u{72B6}\u{6001}\u{3002}\u{5B83}\u{53EF}\u{80FD}\u{5728}\u{4F60}\u{6253}\u{5F00}\u{6B64}\u{9875}\u{9762}\u{540E}\u{53D1}\u{751F}\u{4E86}\u{53D8}\u{5316}\u{3002}\u{5237}\u{65B0}\u{9875}\u{9762}\u{4EE5}\u{67E5}\u{770B}\u{5176}\u{5F53}\u{524D}\u{72B6}\u{6001}\u{3002}`,
    'zh-hant': `\u{60A8}\u{7684}\u{8B8A}\u{66F4}\u{672A}\u{88AB}\u{5132}\u{5B58}\u{FF0C}\u{56E0}\u{70BA}\u{6B64}\u{5DE5}\u{6642}\u{8868}\u{5DF2}\u{4E0D}\u{518D}\u{8655}\u{65BC}\u{8349}\u{7A3F}\u{72C0}\u{614B}\u{3002}\u{60A8}\u{958B}\u{555F}\u{6B64}\u{9801}\u{9762}\u{5F8C}\u{FF0C}\u{8B8A}\u{66F4}\u{53EF}\u{80FD}\u{5DF2}\u{767C}\u{751F}\u{8B8A}\u{66F4}\u{3002}\u{91CD}\u{65B0}\u{6574}\u{7406}\u{9801}\u{9762}\u{4EE5}\u{67E5}\u{770B}\u{5176}\u{76EE}\u{524D}\u{72C0}\u{614B}\u{3002}`,
    en: `Your changes were not saved because this timesheet is no longer in draft status. It may have changed after you opened this page. Refresh the page to view its current status.`
};
const $b11db1b62d4a8f76$export$cc42c5d77cd42ca8 = {
    ar: `\u{62C}\u{62F}\u{627}\u{648}\u{644} \u{632}\u{645}\u{646}\u{64A}\u{629}`,
    de: `Stundenzettel`,
    es: `Hojas de horas`,
    fa: `\u{62C}\u{62F}\u{648}\u{644} \u{647}\u{627}\u{6CC} \u{632}\u{645}\u{627}\u{646}\u{6CC}`,
    fil: `Mga Timesheet`,
    fr: `Feuilles de temps`,
    hi: `\u{938}\u{92E}\u{92F} \u{92A}\u{924}\u{94D}\u{930}\u{915}`,
    ht: `Timesheets`,
    it: `Fogli temporali`,
    ja: `\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}`,
    ko: `\u{D0C0}\u{C784}\u{C2DC}\u{D2B8}`,
    mww: `Cov ntawv teev sijhawm`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{6D0}`,
    pt: `Folhas de ponto`,
    'pt-pt': `Folhas de horas`,
    ru: `\u{422}\u{430}\u{431}\u{435}\u{43B}\u{438} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}`,
    sm: `Pepa o taimi`,
    so: `Jadwalka Waqtiga`,
    th: `\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}`,
    ur: `\u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679}\u{633}`,
    vi: `B\u{1EA3}ng ch\u{1EA5}m c\xf4ng`,
    'zh-hans': `\u{65F6}\u{95F4}\u{8868}`,
    'zh-hant': `\u{5DE5}\u{6642}\u{8868}`,
    en: `Timesheets`
};
const $b11db1b62d4a8f76$export$ee8e05c614779857 = {
    ar: (days)=>`\u{62A}\u{646}\u{62A}\u{647}\u{64A} \u{641}\u{62A}\u{631}\u{629} \u{627}\u{644}\u{62F}\u{641}\u{639} \u{628}\u{639}\u{62F} ${days}. \u{627}\u{646}\u{62A}\u{638}\u{631} \u{62D}\u{62A}\u{649} \u{64A}\u{62A}\u{645} \u{625}\u{62F}\u{62E}\u{627}\u{644} \u{62C}\u{645}\u{64A}\u{639} \u{633}\u{627}\u{639}\u{627}\u{62A} \u{641}\u{62A}\u{631}\u{629} \u{627}\u{644}\u{62F}\u{641}\u{639} \u{627}\u{644}\u{643}\u{627}\u{645}\u{644}\u{629} \u{642}\u{628}\u{644} \u{627}\u{644}\u{62A}\u{642}\u{62F}\u{64A}\u{645}. \u{64A}\u{633}\u{645}\u{62D} \u{641}\u{642}\u{637} \u{628}\u{648}\u{62C}\u{648}\u{62F} \u{62C}\u{62F}\u{648}\u{644} \u{632}\u{645}\u{646}\u{64A} \u{648}\u{627}\u{62D}\u{62F} \u{644}\u{643}\u{644} \u{645}\u{648}\u{638}\u{641} \u{641}\u{64A} \u{643}\u{644} \u{641}\u{62A}\u{631}\u{629} \u{631}\u{627}\u{62A}\u{628}.`,
    de: (days)=>`Die Abrechnungsperiode endet in ${days}. Warte, bis alle Stunden des vollen Abrechnungszeitraums eingetragen wurden, bevor du einreichst. Es ist pro Gehaltsperiode nur ein Stundenzettel pro Mitarbeiter erlaubt.`,
    es: (days)=>`El periodo de pago termina en ${days}. Espera a que se hayan introducido todas las horas del periodo completo de pago antes de enviar. Solo se permite una hoja de horas por empleado por periodo de pago.`,
    fa: (days)=>`\u{62F}\u{648}\u{631}\u{647} \u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A} \u{62F}\u{631} ${days} \u{628}\u{647} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{645}\u{6CC} \u{631}\u{633}\u{62F}. \u{635}\u{628}\u{631} \u{6A9}\u{646}\u{6CC}\u{62F} \u{62A}\u{627} \u{62A}\u{645}\u{627}\u{645} \u{633}\u{627}\u{639}\u{627}\u{62A} \u{62F}\u{648}\u{631}\u{647} \u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A} \u{6A9}\u{627}\u{645}\u{644} \u{648}\u{627}\u{631}\u{62F} \u{634}\u{648}\u{62F} \u{648} \u{633}\u{67E}\u{633} \u{627}\u{631}\u{633}\u{627}\u{644} \u{6A9}\u{646}\u{6CC}\u{62F}. \u{641}\u{642}\u{637} \u{6CC}\u{6A9} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{647}\u{631} \u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F} \u{62F}\u{631} \u{647}\u{631} \u{62F}\u{648}\u{631}\u{647} \u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A} \u{645}\u{62C}\u{627}\u{632} \u{627}\u{633}\u{62A}.`,
    fil: (days)=>`Ang panahon ng sweldo ay magtatapos sa ${days}. Maghintay hanggang sa maipasok ang lahat ng oras para sa buong panahon ng suweldo bago isumite. Isang timesheet lamang ang pinapayagan sa bawat empleyado sa bawat panahon ng suweldo.`,
    fr: (days)=>`La p\xe9riode de paie se termine dans ${days}. Attendez que toutes les heures de la p\xe9riode de paie compl\xe8te soient entr\xe9es avant de soumettre. Une seule feuille de temps par employ\xe9 par p\xe9riode de paie est autoris\xe9e.`,
    hi: (days)=>`\u{935}\u{947}\u{924}\u{928} \u{905}\u{935}\u{927}\u{93F} ${days} \u{92E}\u{947}\u{902} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{91C}\u{93E}\u{924}\u{940} \u{939}\u{948}\u{964} \u{91C}\u{92E}\u{93E} \u{915}\u{930}\u{928}\u{947} \u{938}\u{947} \u{92A}\u{939}\u{932}\u{947} \u{92A}\u{942}\u{930}\u{94D}\u{923} \u{935}\u{947}\u{924}\u{928} \u{905}\u{935}\u{927}\u{93F} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{92D}\u{940} \u{918}\u{902}\u{91F}\u{947} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{93F}\u{90F} \u{91C}\u{93E}\u{928}\u{947} \u{924}\u{915} \u{92A}\u{94D}\u{930}\u{924}\u{940}\u{915}\u{94D}\u{937}\u{93E} \u{915}\u{930}\u{947}\u{902}\u{964} \u{92A}\u{94D}\u{930}\u{924}\u{93F} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{92A}\u{94D}\u{930}\u{924}\u{93F} \u{935}\u{947}\u{924}\u{928} \u{905}\u{935}\u{927}\u{93F} \u{915}\u{947}\u{935}\u{932} \u{90F}\u{915} \u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{939}\u{948}\u{964}`,
    ht: (days)=>`Pery\xf2d peman an fini nan ${days}. Tann jiskaske tout \xe8dtan pou pery\xf2d peman konpl\xe8 a antre anvan ou soum\xe8t Se s\xe8lman yon F\xe8y tan pou chak anplwaye pou chak pery\xf2d peman p\xe8m\xe8t.`,
    it: (days)=>`Il periodo di paga termina tra ${days}. Aspetta che tutte le ore dell'intero periodo di paga siano state inserite prima di inviare. \xc8 consentito solo un foglio presenze per dipendente per periodo di paga.`,
    ja: (days)=>`\u{7D66}\u{4E0E}\u{671F}\u{9593}\u{306F} ${days}\u{306B}\u{7D42}\u{4E86}\u{3057}\u{307E}\u{3059}\u{3002}\u{5168}\u{7D66}\u{4E0E}\u{671F}\u{9593}\u{306E}\u{3059}\u{3079}\u{3066}\u{306E}\u{52E4}\u{52D9}\u{6642}\u{9593}\u{3092}\u{5165}\u{529B}\u{3057}\u{7D42}\u{3048}\u{308B}\u{307E}\u{3067}\u{3001}\u{63D0}\u{51FA}\u{3092}\u{5F85}\u{3061}\u{307E}\u{3057}\u{3087}\u{3046}\u{3002}\u{7D66}\u{4E0E}\u{671F}\u{9593}\u{3054}\u{3068}\u{306B}\u{5F93}\u{696D}\u{54E1}1\u{4EBA}\u{3042}\u{305F}\u{308A}\u{306E}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{306F}1\u{679A}\u{307E}\u{3067}\u{3057}\u{304B}\u{8A31}\u{53EF}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (days)=>`\u{AE09}\u{C5EC} \u{AE30}\u{AC04}\u{C740} ${days} \u{D6C4}\u{C5D0} \u{C885}\u{B8CC}\u{B429}\u{B2C8}\u{B2E4}. \u{C804}\u{CCB4} \u{AE09}\u{C5EC} \u{AE30}\u{AC04}\u{C758} \u{BAA8}\u{B4E0} \u{C2DC}\u{AC04}\u{C744} \u{C785}\u{B825}\u{D55C} \u{D6C4} \u{C81C}\u{CD9C}\u{D558}\u{C138}\u{C694}. \u{AE09}\u{C5EC} \u{AE30}\u{AC04}\u{B2F9} \u{C9C1}\u{C6D0}\u{B2F9} \u{D55C} \u{C7A5}\u{C758} \u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C}\u{B9CC} \u{D5C8}\u{C6A9}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: (days)=>`Lub sijhawm them nyiaj xaus rau ${days}. Tos kom txog thaum tag nrho cov xuab moos rau lub sijhawm them tag nrho tau nkag mus ua ntej xa mus. Tsuas tso cai rau ib daim ntawv teev sijhawm rau ib tus neeg ua haujlwm rau ib lub sijhawm them nyiaj.`,
    ps: (days)=>`\u{62F} \u{645}\u{639}\u{627}\u{634} \u{645}\u{648}\u{62F}\u{647} \u{67E}\u{647} ${days} \u{6A9}\u{6D0} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{631}\u{633}\u{6CC}\u{696}\u{6CC}. \u{62A}\u{631} \u{647}\u{63A}\u{647} \u{648}\u{62E}\u{62A}\u{647} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{631} \u{648}\u{6A9}\u{693}\u{626} \u{686}\u{6D0} \u{62F} \u{628}\u{634}\u{67E}\u{693} \u{645}\u{639}\u{627}\u{634} \u{645}\u{648}\u{62F}\u{647} \u{67C}\u{648}\u{644} \u{633}\u{627}\u{639}\u{62A}\u{648}\u{646}\u{647} \u{62B}\u{628}\u{62A} \u{634}\u{6CC}\u{60C} \u{628}\u{6CC}\u{627} \u{6CC}\u{6D0} \u{633}\u{67E}\u{627}\u{631}\u{644} \u{648}\u{6A9}\u{693}\u{626}. \u{647}\u{631} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{62A}\u{647} \u{67E}\u{647} \u{647}\u{631} \u{645}\u{639}\u{627}\u{634} \u{645}\u{648}\u{62F}\u{647} \u{6A9}\u{6D0} \u{6CC}\u{648}\u{627}\u{632}\u{6D0} \u{6CC}\u{648} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: (days)=>`O per\xedodo de pagamento termina em ${days}. Espere at\xe9 que todas as horas do per\xedodo completo de pagamento sejam inseridas antes de enviar. Apenas uma folha de ponto por funcion\xe1rio por per\xedodo de pagamento \xe9 permitida.`,
    'pt-pt': (days)=>`O per\xedodo de pagamento termina em ${days}. Espere at\xe9 que todas as horas do per\xedodo completo de pagamento tenham sido introduzidas antes de submeter. Apenas uma folha de horas por funcion\xe1rio por per\xedodo de pagamento \xe9 permitida.`,
    ru: (days)=>`\u{41F}\u{43B}\u{430}\u{442}\u{451}\u{436}\u{43D}\u{44B}\u{439} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434} \u{437}\u{430}\u{43A}\u{430}\u{43D}\u{447}\u{438}\u{432}\u{430}\u{435}\u{442}\u{441}\u{44F} ${days}. \u{41F}\u{43E}\u{434}\u{43E}\u{436}\u{434}\u{438}\u{442}\u{435}, \u{43F}\u{43E}\u{43A}\u{430} \u{43D}\u{435} \u{431}\u{443}\u{434}\u{443}\u{442} \u{432}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{44B} \u{432}\u{441}\u{435} \u{447}\u{430}\u{441}\u{44B} \u{43F}\u{43E}\u{43B}\u{43D}\u{43E}\u{433}\u{43E} \u{43F}\u{43B}\u{430}\u{442}\u{451}\u{436}\u{43D}\u{43E}\u{433}\u{43E} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430}, \u{43F}\u{440}\u{435}\u{436}\u{434}\u{435} \u{447}\u{435}\u{43C} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{44F}\u{442}\u{44C} \u{437}\u{430}\u{44F}\u{432}\u{43A}\u{443}. \u{41D}\u{430} \u{43A}\u{430}\u{436}\u{434}\u{43E}\u{433}\u{43E} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{430} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{43E} \u{438}\u{43C}\u{435}\u{442}\u{44C} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{43E}\u{434}\u{438}\u{43D} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{437}\u{430} \u{43A}\u{430}\u{436}\u{434}\u{44B}\u{439} \u{43F}\u{43B}\u{430}\u{442}\u{451}\u{436}\u{43D}\u{44B}\u{439} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}.`,
    sm: (days)=>`O le vaitaimi o le totogi e fa'amutaina i totonu o ${days}. Faatali seia oo ina taina i totonu itula uma mo le vaitau atoa o le totogi a o lei auina atu. E na'o le tasi le taimi mo le tagata faigaluega i le vaitaimi totogi e fa'atagaina.`,
    so: (days)=>`Muddada mushaharka waxay ku dhammaanaysaa ${days} gudahood. Sug ilaa saacadaha oo dhan ee muddada mushaarka buuxa la geliyo ka hor intaadan gudbin. Kaliya hal xaashi waqti oo shaqaale ah ayaa la oggol yahay xilliga mushaharka.`,
    th: (days)=>`\u{E23}\u{E30}\u{E22}\u{E30}\u{E40}\u{E27}\u{E25}\u{E32}\u{E01}\u{E32}\u{E23}\u{E08}\u{E48}\u{E32}\u{E22}\u{E40}\u{E07}\u{E34}\u{E19}\u{E08}\u{E30}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E43}\u{E19} ${days} \u{E23}\u{E2D}\u{E08}\u{E19}\u{E01}\u{E27}\u{E48}\u{E32}\u{E08}\u{E30}\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E30}\u{E22}\u{E30}\u{E40}\u{E27}\u{E25}\u{E32}\u{E01}\u{E32}\u{E23}\u{E08}\u{E48}\u{E32}\u{E22}\u{E40}\u{E07}\u{E34}\u{E19}\u{E40}\u{E15}\u{E47}\u{E21}\u{E08}\u{E4D}\u{E32}\u{E19}\u{E27}\u{E19}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2A}\u{E48}\u{E07} \u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E41}\u{E1C}\u{E48}\u{E19}\u{E40}\u{E27}\u{E25}\u{E32}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E41}\u{E1C}\u{E48}\u{E19}\u{E15}\u{E48}\u{E2D}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E15}\u{E48}\u{E2D}\u{E23}\u{E2D}\u{E1A}\u{E23}\u{E30}\u{E22}\u{E30}\u{E40}\u{E27}\u{E25}\u{E32}\u{E01}\u{E32}\u{E23}\u{E08}\u{E48}\u{E32}\u{E22}\u{E40}\u{E07}\u{E34}\u{E19}\u{E40}\u{E17}\u{E48}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}`,
    ur: (days)=>`\u{62A}\u{646}\u{62E}\u{648}\u{627}\u{6C1} \u{6A9}\u{6CC} \u{645}\u{62F}\u{62A} ${days} \u{645}\u{6CC}\u{6BA} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{62C}\u{627}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4} \u{645}\u{6A9}\u{645}\u{644} \u{627}\u{62F}\u{627}\u{626}\u{6CC}\u{6AF}\u{6CC} \u{6A9}\u{6CC} \u{645}\u{62F}\u{62A} \u{6A9}\u{6D2} \u{62A}\u{645}\u{627}\u{645} \u{6AF}\u{6BE}\u{646}\u{679}\u{6D2} \u{62F}\u{627}\u{62E}\u{644} \u{6C1}\u{648}\u{646}\u{6D2} \u{62A}\u{6A9} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{631} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{60C} \u{67E}\u{6BE}\u{631} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{648}\u{627}\u{626}\u{6CC}\u{6BA}\u{6D4} \u{641}\u{6CC} \u{645}\u{644}\u{627}\u{632}\u{645} \u{641}\u{6CC} \u{62A}\u{646}\u{62E}\u{648}\u{627}\u{6C1} \u{6A9}\u{6CC} \u{645}\u{62F}\u{62A} \u{645}\u{6CC}\u{6BA} \u{635}\u{631}\u{641} \u{627}\u{6CC}\u{6A9} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (days)=>`Th\u{1EDD}i h\u{1EA1}n tr\u{1EA3} l\u{1B0}\u{1A1}ng k\u{1EBF}t th\xfac sau ${days}. Ch\u{1EDD} cho \u{111}\u{1EBF}n khi t\u{1EA5}t c\u{1EA3} c\xe1c gi\u{1EDD} \u{111}\u{1EC3} nh\u{1EAD}p \u{111}\u{1EA7}y \u{111}\u{1EE7} th\u{1EDD}i h\u{1EA1}n thanh to\xe1n tr\u{1B0}\u{1EDB}c khi g\u{1EED}i. Ch\u{1EC9} cho ph\xe9p m\u{1ED9}t b\u{1EA3}ng ch\u{1EA5}m c\xf4ng cho m\u{1ED7}i nh\xe2n vi\xean trong m\u{1ED7}i k\u{1EF3} tr\u{1EA3} l\u{1B0}\u{1A1}ng.`,
    'zh-hans': (days)=>`\u{53D1}\u{85AA}\u{671F}\u{5C06}\u{5728} ${days}\u{540E}\u{7ED3}\u{675F}\u{3002}\u{8BF7}\u{7B49}\u{6240}\u{6709}\u{5DE5}\u{8D44}\u{5468}\u{671F}\u{7684}\u{5DE5}\u{65F6}\u{90FD}\u{586B}\u{5199}\u{5B8C}\u{6BD5}\u{540E}\u{518D}\u{63D0}\u{4EA4}\u{3002}\u{6BCF}\u{4E2A}\u{5DE5}\u{8D44}\u{5468}\u{671F}\u{6BCF}\u{4F4D}\u{5458}\u{5DE5}\u{53EA}\u{80FD}\u{586B}\u{5199}\u{4E00}\u{4EFD}\u{5DE5}\u{65F6}\u{8868}\u{3002}`,
    'zh-hant': (days)=>`\u{85AA}\u{8CC7}\u{671F}\u{9084}\u{6709} ${days}\u{5C31}\u{7D50}\u{675F}\u{4E86}\u{3002}\u{8ACB}\u{7B49}\u{6240}\u{6709}\u{85AA}\u{8CC7}\u{671F}\u{9593}\u{7684}\u{5DE5}\u{6642}\u{90FD}\u{8F38}\u{5165}\u{5B8C}\u{7562}\u{5F8C}\u{518D}\u{63D0}\u{4EA4}\u{3002}\u{6BCF}\u{500B}\u{85AA}\u{8CC7}\u{671F}\u{6BCF}\u{4F4D}\u{54E1}\u{5DE5}\u{53EA}\u{5141}\u{8A31}\u{4E00}\u{5F35}\u{5DE5}\u{6642}\u{8868}\u{3002}`,
    en: (days)=>`The pay period ends in ${days}. Wait until all hours for the full pay period have been entered before submitting. Only one timesheet per employee per pay period is allowed.`
};
const $b11db1b62d4a8f76$export$24d7027629fb8fb1 = {
    ar: `\u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Titel`,
    es: `T\xedtulo`,
    fa: `\u{639}\u{646}\u{648}\u{627}\u{646}`,
    fil: `Pamagat`,
    fr: `Titre`,
    hi: `\u{936}\u{940}\u{930}\u{94D}\u{937}\u{915}`,
    ht: `Title`,
    it: `Titolo`,
    ja: `\u{30BF}\u{30A4}\u{30C8}\u{30EB}`,
    ko: `\u{C81C}\u{BAA9}`,
    mww: `Npe`,
    ps: `\u{633}\u{631}\u{644}\u{6CC}\u{6A9}`,
    pt: `T\xedtulo`,
    'pt-pt': `T\xedtulo`,
    ru: `\u{41D}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Ulutala`,
    so: `Cinwaanka`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E23}\u{E37}\u{E48}\u{E2D}\u{E07}`,
    ur: `\u{639}\u{646}\u{648}\u{627}\u{646}`,
    vi: `Ti\xeau \u{111}\u{1EC1}`,
    'zh-hans': `\u{6807}\u{9898}`,
    'zh-hant': `\u{6A19}\u{984C}`,
    en: `Title`
};
const $b11db1b62d4a8f76$export$3aa2ba6fa839e15a = {
    ar: `\u{62D}\u{62A}\u{649} \u{627}\u{644}\u{622}\u{646}`,
    de: `Bis heute`,
    es: `Hasta la fecha`,
    fa: `\u{62A}\u{627} \u{628}\u{647} \u{627}\u{645}\u{631}\u{648}\u{632}`,
    fil: `Hanggang ngayon`,
    fr: `\xc0 ce jour`,
    hi: `\u{906}\u{91C} \u{924}\u{915}`,
    ht: `Jiska dat`,
    it: `Ad oggi`,
    ja: `\u{73FE}\u{5728}\u{307E}\u{3067}`,
    ko: `\u{D604}\u{C7AC}\u{AE4C}\u{C9C0}`,
    mww: `Txog rau hnub no`,
    ps: `\u{62A}\u{631} \u{627}\u{648}\u{633}\u{647}`,
    pt: `At\xe9 o momento`,
    'pt-pt': `At\xe9 \xe0 data`,
    ru: `\u{41D}\u{430} \u{441}\u{435}\u{433}\u{43E}\u{434}\u{43D}\u{44F}\u{448}\u{43D}\u{438}\u{439} \u{434}\u{435}\u{43D}\u{44C}`,
    sm: `E oo mai i le taimi nei`,
    so: `Ilaa hadda`,
    th: `\u{E08}\u{E19}\u{E16}\u{E36}\u{E07}\u{E1B}\u{E31}\u{E08}\u{E08}\u{E38}\u{E1A}\u{E31}\u{E19}`,
    ur: `\u{627}\u{628} \u{62A}\u{6A9}`,
    vi: `T\xednh \u{111}\u{1EBF}n nay`,
    'zh-hans': `\u{8FC4}\u{4ECA}\u{4E3A}\u{6B62}`,
    'zh-hant': `\u{81F3}\u{4ECA}`,
    en: `To date`
};
const $b11db1b62d4a8f76$export$335410424c25f5c3 = {
    ar: `\u{642}\u{627}\u{626}\u{645}\u{629} \u{627}\u{644}\u{62A}\u{628}\u{62F}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{646}\u{633}\u{62F}\u{644}\u{629}`,
    de: `Umschalt-Dropdown-Men\xfc`,
    es: `Desplegable de alternancia`,
    fa: `\u{6A9}\u{634}\u{648}\u{6CC}\u{6CC} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{648}\u{636}\u{639}\u{6CC}\u{62A}`,
    fil: `Toggle dropdown`,
    fr: `Menu d\xe9roulant \xe0 basculer`,
    hi: `\u{921}\u{94D}\u{930}\u{949}\u{92A}\u{921}\u{93E}\u{909}\u{928} \u{91F}\u{949}\u{917}\u{932} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Toggle dropdown`,
    it: `Menu a tendina toggle`,
    ja: `\u{30C8}\u{30B0}\u{30EB}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{30C0}\u{30A6}\u{30F3}`,
    ko: `\u{D1A0}\u{AE00} \u{B4DC}\u{B86D}\u{B2E4}\u{C6B4}`,
    mww: `Toggle dropdown`,
    ps: `\u{62F} \u{67C}\u{648}\u{6AB}\u{644} \u{689}\u{631}\u{627}\u{67E} \u{689}\u{627}\u{648}\u{646}`,
    pt: `Menu suspenso para alternar`,
    'pt-pt': `Menu suspenso de alternar`,
    ru: `\u{412}\u{44B}\u{43F}\u{430}\u{434}\u{430}\u{44E}\u{449}\u{435}\u{435} \u{43C}\u{435}\u{43D}\u{44E} \u{43F}\u{435}\u{440}\u{435}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Toggle dropdown`,
    so: `Toggle dropdown`,
    th: `\u{E2A}\u{E25}\u{E31}\u{E1A}\u{E14}\u{E23}\u{E2D}\u{E1B}\u{E14}\u{E32}\u{E27}\u{E19}\u{E4C}`,
    ur: `\u{679}\u{648}\u{6AF}\u{644} \u{688}\u{631}\u{627}\u{67E} \u{688}\u{627}\u{624}\u{646}`,
    vi: `Chuy\u{1EC3}n \u{111}\u{1ED5}i menu th\u{1EA3} xu\u{1ED1}ng`,
    'zh-hans': `\u{5207}\u{6362}\u{4E0B}\u{62C9}\u{83DC}\u{5355}`,
    'zh-hant': `\u{5207}\u{63DB}\u{4E0B}\u{62C9}\u{9078}\u{55AE}`,
    en: `Toggle dropdown`
};
const $b11db1b62d4a8f76$export$b216620a6709d9c7 = {
    ar: `\u{627}\u{644}\u{628}\u{62D}\u{62B} \u{641}\u{64A} \u{627}\u{644}\u{62A}\u{628}\u{62F}\u{64A}\u{644}`,
    de: `Umschalt-Suche`,
    es: `Alternar b\xfasqueda`,
    fa: `\u{62C}\u{633}\u{62A}\u{62C}\u{648}\u{6CC} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{648}\u{636}\u{639}\u{6CC}\u{62A}`,
    fil: `Email Address *`,
    fr: `Basculer la recherche`,
    hi: `\u{916}\u{94B}\u{91C} \u{91F}\u{949}\u{917}\u{932} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Toggle rech\xe8ch`,
    it: `Ricerca a toggle`,
    ja: `\u{30C8}\u{30B0}\u{30EB}\u{691C}\u{7D22}`,
    ko: `\u{D1A0}\u{AE00} \u{AC80}\u{C0C9}`,
    mww: `Toggle nrhiav`,
    ps: `\u{62F} \u{67C}\u{648}\u{6AB}\u{644} \u{644}\u{67C}\u{648}\u{646}`,
    pt: `Alternar busca`,
    'pt-pt': `Alternar pesquisa`,
    ru: `\u{41F}\u{43E}\u{438}\u{441}\u{43A} \u{43F}\u{43E} \u{43F}\u{435}\u{440}\u{435}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{44E}`,
    sm: `Toggle search`,
    so: `Raadinta beddelka`,
    th: `\u{E2A}\u{E25}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}`,
    ur: `\u{679}\u{648}\u{6AF}\u{644} \u{633}\u{631}\u{686}`,
    vi: `Chuy\u{1EC3}n \u{111}\u{1ED5}i t\xecm ki\u{1EBF}m`,
    'zh-hans': `\u{5207}\u{6362}\u{641C}\u{7D22}`,
    'zh-hant': `\u{5207}\u{63DB}\u{641C}\u{5C0B}`,
    en: `Toggle search`
};
const $b11db1b62d4a8f76$export$91d193269850f490 = {
    ar: `\u{62A}\u{628}\u{62F}\u{64A}\u{644} \u{627}\u{644}\u{634}\u{631}\u{64A}\u{637} \u{627}\u{644}\u{62C}\u{627}\u{646}\u{628}\u{64A}`,
    de: `Seitenleiste umschalten`,
    es: `Barra lateral alternar`,
    fa: `\u{6A9}\u{644}\u{6CC}\u{62F} \u{6A9}\u{646}\u{627}\u{631}\u{6CC} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{648}\u{636}\u{639}\u{6CC}\u{62A}`,
    fil: `I-toggle sidebar`,
    fr: `Barre-encadr\xe9 basculante`,
    hi: `\u{938}\u{93E}\u{907}\u{921}\u{92C}\u{93E}\u{930} \u{91F}\u{949}\u{917}\u{932} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Toggle ank\xe8t lateral`,
    it: `Barra laterale toggle`,
    ja: `\u{30B5}\u{30A4}\u{30C9}\u{30D0}\u{30FC}\u{3092}\u{5207}\u{308A}\u{66FF}\u{3048}\u{308B}`,
    ko: `\u{D1A0}\u{AE00} \u{C0AC}\u{C774}\u{B4DC}\u{BC14}`,
    mww: `Toggle sidebar`,
    ps: `\u{633}\u{627}\u{6CC}\u{689}\u{628}\u{627}\u{631} \u{67C}\u{648}\u{6AB}\u{644} \u{6A9}\u{693}\u{626}`,
    pt: `Barra lateral alternar`,
    'pt-pt': `Barra lateral de alternar`,
    ru: `\u{411}\u{43E}\u{43A}\u{43E}\u{432}\u{430}\u{44F} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44C} \u{43F}\u{435}\u{440}\u{435}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Toggle sidebar`,
    so: `Toggle sidebar`,
    th: `\u{E2A}\u{E25}\u{E31}\u{E1A}\u{E41}\u{E16}\u{E1A}\u{E14}\u{E49}\u{E32}\u{E19}\u{E02}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{633}\u{627}\u{626}\u{6CC}\u{688}\u{628}\u{627}\u{631} \u{6A9}\u{648} \u{679}\u{648}\u{6AF}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Chuy\u{1EC3}n \u{111}\u{1ED5}i thanh b\xean`,
    'zh-hans': `\u{5207}\u{6362}\u{4FA7}\u{8FB9}\u{680F}`,
    'zh-hant': `\u{5207}\u{63DB}\u{5074}\u{908A}\u{6B04}`,
    en: `Toggle sidebar`
};
const $b11db1b62d4a8f76$export$6b5428a07839d4c2 = {
    ar: `\u{62A}\u{628}\u{62F}\u{64A}\u{644} \u{642}\u{627}\u{626}\u{645}\u{629} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{629}`,
    de: `Statusmen\xfc umschalten`,
    es: `Alternar men\xfa de estado`,
    fa: `\u{645}\u{646}\u{648}\u{6CC} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{648}\u{636}\u{639}\u{6CC}\u{62A}`,
    fil: `I-toggle ang menu ng katayuan`,
    fr: `Basculer le menu d\u{2019}\xe9tat`,
    hi: `\u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{92E}\u{947}\u{928}\u{942} \u{91F}\u{949}\u{917}\u{932} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Toggle meni estati`,
    it: `Attiva il menu di stato`,
    ja: `\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{306E}\u{5207}\u{308A}\u{66FF}\u{3048}`,
    ko: `\u{C0C1}\u{D0DC} \u{BA54}\u{B274} \u{D1A0}\u{AE00}`,
    mww: `Toggle cov xwm txheej ntawv qhia zaub mov`,
    ps: `\u{62F} \u{62D}\u{627}\u{644}\u{62A} \u{645}\u{6CC}\u{646}\u{648} \u{67C}\u{648}\u{6AB}\u{644} \u{6A9}\u{693}\u{626}`,
    pt: `Alternar menu de status`,
    'pt-pt': `Alternar menu de estado`,
    ru: `\u{41C}\u{435}\u{43D}\u{44E} \u{43F}\u{435}\u{440}\u{435}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{44F} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{430}`,
    sm: `Toggle status menu`,
    so: `Toggle status menu`,
    th: `\u{E2A}\u{E25}\u{E31}\u{E1A}\u{E40}\u{E21}\u{E19}\u{E39}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}`,
    ur: `\u{679}\u{648}\u{6AF}\u{644} \u{627}\u{633}\u{679}\u{6CC}\u{679}\u{633} \u{645}\u{6CC}\u{646}\u{648}`,
    vi: `Chuy\u{1EC3}n \u{111}\u{1ED5}i menu tr\u{1EA1}ng th\xe1i`,
    'zh-hans': `\u{5207}\u{6362}\u{72B6}\u{6001}\u{83DC}\u{5355}`,
    'zh-hant': `\u{5207}\u{63DB}\u{72C0}\u{614B}\u{9078}\u{55AE}`,
    en: `Toggle status menu`
};
const $b11db1b62d4a8f76$export$dae0630060ed6275 = {
    ar: `\u{627}\u{644}\u{623}\u{639}\u{644}\u{649}`,
    de: `Top`,
    es: `Arriba`,
    fa: `\u{62A}\u{627}\u{67E}`,
    fil: `Tuktok`,
    fr: `Haut`,
    hi: `\u{936}\u{940}\u{930}\u{94D}\u{937}`,
    ht: `T\xe8t`,
    it: `Top`,
    ja: `\u{30C8}\u{30C3}\u{30D7}`,
    ko: `\u{C0C1}\u{B2E8}`,
    mww: `Sab saum toj`,
    ps: `\u{67E}\u{648}\u{631}\u{62A}\u{647}`,
    pt: `Topo`,
    'pt-pt': `Topo`,
    ru: `\u{412}\u{435}\u{440}\u{445}`,
    sm: `Luga`,
    so: `Top`,
    th: `\u{E14}\u{E49}\u{E32}\u{E19}\u{E1A}\u{E19}`,
    ur: `\u{627}\u{648}\u{67E}\u{631}`,
    vi: `\u{110}\u{1EA7}u trang`,
    'zh-hans': `\u{9876}\u{90E8}`,
    'zh-hant': `\u{9802}\u{7AEF}`,
    en: `Top`
};
const $b11db1b62d4a8f76$export$1f2a4d0e9bccd4 = {
    ar: `\u{627}\u{644}\u{645}\u{62C}\u{645}\u{648}\u{639}`,
    de: `Gesamt`,
    es: `Total`,
    fa: `\u{6A9}\u{644}`,
    fil: `Kabuuang`,
    fr: `Total`,
    hi: `\u{915}\u{941}\u{932}`,
    ht: `Total`,
    it: `Totale`,
    ja: `\u{5408}\u{8A08}`,
    ko: `\u{CD1D}`,
    mww: `Tag Nrho`,
    ps: `\u{67C}\u{648}\u{644}`,
    pt: `Total`,
    'pt-pt': `Total`,
    ru: `Total`,
    sm: `Aofai`,
    so: `Wadarta guud`,
    th: `\u{E23}\u{E27}\u{E21}`,
    ur: `\u{6A9}\u{644}`,
    vi: `T\u{1ED5}ng c\u{1ED9}ng`,
    'zh-hans': `\u{603B}\u{8BA1}`,
    'zh-hant': `\u{7E3D}\u{8A08}`,
    en: `Total`
};
const $b11db1b62d4a8f76$export$1f6e2becdbb4d59a = {
    ar: `\u{625}\u{62C}\u{645}\u{627}\u{644}\u{64A} \u{627}\u{644}\u{633}\u{627}\u{639}\u{627}\u{62A}`,
    de: `Gesamtstunden`,
    es: `Horas totales`,
    fa: `\u{6A9}\u{644} \u{633}\u{627}\u{639}\u{627}\u{62A} \u{6A9}\u{627}\u{631}\u{6CC}`,
    fil: `Kabuuang oras`,
    fr: `Heures totales`,
    hi: `\u{915}\u{941}\u{932} \u{918}\u{902}\u{91F}\u{947}`,
    ht: `Total \xe8dtan`,
    it: `Ore totali`,
    ja: `\u{7DCF}\u{52B4}\u{50CD}\u{6642}\u{9593}`,
    ko: `\u{CD1D} \u{ADFC}\u{BB34} \u{C2DC}\u{AC04}`,
    mww: `Tag nrho cov xuab moos`,
    ps: `\u{67C}\u{648}\u{644} \u{633}\u{627}\u{639}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Horas totais`,
    'pt-pt': `Horas totais`,
    ru: `\u{41E}\u{431}\u{449}\u{435}\u{435} \u{43A}\u{43E}\u{43B}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{43E} \u{447}\u{430}\u{441}\u{43E}\u{432}`,
    sm: `Aofai o itula`,
    so: `Saacadaha guud`,
    th: `\u{E0A}\u{E31}\u{E48}\u{E27}\u{E42}\u{E21}\u{E07}\u{E23}\u{E27}\u{E21}`,
    ur: `\u{6A9}\u{644} \u{627}\u{648}\u{642}\u{627}\u{62A}`,
    vi: `T\u{1ED5}ng s\u{1ED1} gi\u{1EDD}`,
    'zh-hans': `\u{603B}\u{5DE5}\u{65F6}`,
    'zh-hant': `\u{7E3D}\u{5DE5}\u{6642}`,
    en: `Total hours`
};
const $b11db1b62d4a8f76$export$1d443b6ab9339ffe = {
    ar: `\u{625}\u{62C}\u{645}\u{627}\u{644}\u{64A} \u{627}\u{644}\u{62C}\u{644}\u{633}\u{627}\u{62A}`,
    de: `Gesamtzahl der Sitzungen`,
    es: `Total de sesiones`,
    fa: `\u{6A9}\u{644} \u{62C}\u{644}\u{633}\u{627}\u{62A}`,
    fil: `Kabuuang mga sesyon`,
    fr: `Total des sessions`,
    hi: `\u{915}\u{941}\u{932} \u{938}\u{924}\u{94D}\u{930}`,
    ht: `Sesyon total`,
    it: `Totale delle sessioni`,
    ja: `\u{7DCF}\u{30BB}\u{30C3}\u{30B7}\u{30E7}\u{30F3}\u{6570}`,
    ko: `\u{CD1D} \u{C138}\u{C158} \u{C218}`,
    mww: `Tag nrho cov rooj sib tham`,
    ps: `\u{67C}\u{648}\u{644} \u{63A}\u{648}\u{646}\u{689}\u{6D0}`,
    pt: `Total de sess\xf5es`,
    'pt-pt': `Total de sess\xf5es`,
    ru: `\u{41E}\u{431}\u{449}\u{435}\u{435} \u{43A}\u{43E}\u{43B}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{43E} \u{441}\u{435}\u{441}\u{441}\u{438}\u{439}`,
    sm: `Aofai o sauniga`,
    so: `Wadarta kalfadhiyada`,
    th: `\u{E08}\u{E4D}\u{E32}\u{E19}\u{E27}\u{E19}\u{E40}\u{E0B}\u{E2A}\u{E0A}\u{E31}\u{E19}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{6A9}\u{644} \u{633}\u{6CC}\u{634}\u{646}\u{632}`,
    vi: `T\u{1ED5}ng s\u{1ED1} phi\xean l\xe0m vi\u{1EC7}c`,
    'zh-hans': `\u{603B}\u{573A}\u{6B21}`,
    'zh-hant': `\u{7E3D}\u{5834}\u{6B21}`,
    en: `Total sessions`
};
const $b11db1b62d4a8f76$export$89940308ff58a7f9 = {
    ar: `\u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631} \u{644}\u{645}\u{631}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629} \u{645}\u{639}\u{62A}\u{645}\u{62F}\u{629} \u{639}\u{644}\u{649} \u{627}\u{644}\u{632}\u{645}\u{646} (TOTP)`,
    de: `Zeitbasiertes Einmalpasswort (TOTP)`,
    es: `Contrase\xf1a de un solo uso basada en el tiempo (TOTP)`,
    fa: `\u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631} \u{6CC}\u{6A9} \u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641} \u{645}\u{628}\u{62A}\u{646}\u{6CC} \u{628}\u{631} \u{632}\u{645}\u{627}\u{646} (TOTP)`,
    fil: `Time-based One-Time Password (TOTP)`,
    fr: `Mot de passe \xe0 usage unique bas\xe9 sur le temps (TOTP)`,
    hi: `\u{938}\u{92E}\u{92F}-\u{906}\u{927}\u{93E}\u{930}\u{93F}\u{924} \u{935}\u{928}-\u{91F}\u{93E}\u{907}\u{92E} \u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} (TOTP)`,
    ht: `Tan ki baze sou yon s\xe8l-fwa modpas (TOTP)`,
    it: `Password Uniusa Basata sul Tempo (TOTP)`,
    ja: `\u{6642}\u{9593}\u{30D9}\u{30FC}\u{30B9}\u{306E}\u{30EF}\u{30F3}\u{30BF}\u{30A4}\u{30E0}\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}(TOTP)`,
    ko: `\u{C2DC}\u{AC04} \u{AE30}\u{BC18} \u{C77C}\u{D68C}\u{C6A9} \u{BE44}\u{BC00}\u{BC88}\u{D638}(TOTP)`,
    mww: `Lub sij hawm raws li ib lub sij hawm lo lus zais (TOTP)`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{631} \u{628}\u{646}\u{633}\u{67C} \u{6CC}\u{648} \u{681}\u{644} \u{631}\u{645}\u{632} (TOTP)`,
    pt: `Senha \xdanica Baseada em Tempo (TOTP)`,
    'pt-pt': `Palavra-passe \xfanica baseada no tempo (TOTP)`,
    ru: `\u{41E}\u{434}\u{43D}\u{43E}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{44B}\u{439} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44C} \u{43D}\u{430} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} (TOTP)`,
    sm: `Taimi Fa'avae Tasi-Taimi Fa'aupuga (TOTP)`,
    so: `Erayga Sirta Keliya ee Waqtiga ku saleysan (TOTP)`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E15}\u{E32}\u{E21}\u{E40}\u{E27}\u{E25}\u{E32} (TOTP)`,
    ur: `\u{648}\u{642}\u{62A} \u{67E}\u{631} \u{645}\u{628}\u{646}\u{6CC} \u{627}\u{6CC}\u{6A9} \u{648}\u{642}\u{62A}\u{6CC} \u{67E}\u{627}\u{633} \u{648}\u{631}\u{688} (TOTP)`,
    vi: `M\u{1EAD}t kh\u{1EA9}u d\xf9ng m\u{1ED9}t l\u{1EA7}n d\u{1EF1}a tr\xean th\u{1EDD}i gian (TOTP)`,
    'zh-hans': `\u{57FA}\u{4E8E}\u{65F6}\u{95F4}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{5BC6}\u{7801}\u{FF08}TOTP\u{FF09}`,
    'zh-hant': `\u{57FA}\u{65BC}\u{6642}\u{9593}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{5BC6}\u{78BC}\u{FF08}TOTP\u{FF09}`,
    en: `Time-based One-Time Password (TOTP)`
};
const $b11db1b62d4a8f76$export$bf9fe1d3dbe2373c = {
    ar: `\u{627}\u{643}\u{62A}\u{645}\u{644} \u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{641}\u{64A} \u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631} \u{627}\u{644}\u{632}\u{645}\u{646}\u{64A}\u{629} \u{627}\u{644}\u{648}\u{627}\u{62D}\u{62F}\u{629} (TOTP)!`,
    de: `Anmeldung zum zeitbasierten Einmalpasswort (TOTP) abgeschlossen!`,
    es: `\xa1Inscripci\xf3n con la Contrase\xf1a de Un Solo Uso (TOTP) basada en tiempo completada!`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631} \u{6CC}\u{6A9} \u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641} \u{645}\u{628}\u{62A}\u{646}\u{6CC} \u{628}\u{631} \u{632}\u{645}\u{627}\u{646} (TOTP) \u{6A9}\u{627}\u{645}\u{644} \u{634}\u{62F}!`,
    fil: `Kumpleto na ang pagpapatala ng One-Time Password (TOTP) na nakabatay sa oras!`,
    fr: `Inscription au mot de passe \xe0 usage unique (TOTP) bas\xe9 sur le temps termin\xe9e !`,
    hi: `\u{938}\u{92E}\u{92F}-\u{906}\u{927}\u{93E}\u{930}\u{93F}\u{924} \u{935}\u{928}-\u{91F}\u{93E}\u{907}\u{92E} \u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} (TOTP) \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{928} \u{92A}\u{942}\u{930}\u{94D}\u{923}!`,
    ht: `Tan ki baze sou yon s\xe8l-fwa modpas (TOTP) enskripsyon konpl\xe8!`,
    it: `Iscrizione completata alla Password Unica Basata sul Tempo (TOTP)!`,
    ja: `\u{6642}\u{9593}\u{30D9}\u{30FC}\u{30B9}\u{306E}\u{30EF}\u{30F3}\u{30BF}\u{30A4}\u{30E0}\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}(TOTP)\u{767B}\u{9332}\u{5B8C}\u{4E86}!`,
    ko: `\u{C2DC}\u{AC04} \u{AE30}\u{BC18} \u{C77C}\u{D68C}\u{C6A9} \u{BE44}\u{BC00}\u{BC88}\u{D638}(TOTP) \u{B4F1}\u{B85D} \u{C644}\u{B8CC}!`,
    mww: `Sij hawm raws li One-Time Password (TOTP) sau npe tiav lawm!`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{631} \u{628}\u{646}\u{633}\u{67C} \u{6CC}\u{648} \u{681}\u{644} \u{67E}\u{627}\u{633}\u{648}\u{631}\u{689} (TOTP) \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{628}\u{634}\u{67E}\u{693}\u{647} \u{634}\u{648}\u{647}!`,
    pt: `Inscri\xe7\xe3o com Senha \xdanica Baseada em Tempo (TOTP) conclu\xedda!`,
    'pt-pt': `Inscri\xe7\xe3o com Palavra-Passe \xdanica (TOTP) baseada no tempo conclu\xedda!`,
    ru: `\u{420}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{43E}\u{434}\u{43D}\u{43E}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{43E}\u{433}\u{43E} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44F} (TOTP) \u{43F}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{430}!`,
    sm: `Ua mae'a le lesitalaina o le Time-Based One-Time Password (TOTP)!`,
    so: `Diiwaangelinta Furaha Sirta Hal Mar (TOTP) ee ku saleysan waqtiga ayaa dhammaatay!`,
    th: `\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E15}\u{E32}\u{E21}\u{E40}\u{E27}\u{E25}\u{E32} (TOTP) \u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}!`,
    ur: `\u{679}\u{627}\u{626}\u{645} \u{628}\u{6CC}\u{633}\u{688} \u{648}\u{646} \u{679}\u{627}\u{626}\u{645} \u{67E}\u{627}\u{633} \u{648}\u{631}\u{688} (TOTP) \u{6A9}\u{627} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{645}\u{6A9}\u{645}\u{644}!`,
    vi: `\u{110}\u{103}ng k\xfd M\u{1EAD}t kh\u{1EA9}u d\xf9ng m\u{1ED9}t l\u{1EA7}n theo th\u{1EDD}i gian (TOTP) \u{111}\xe3 ho\xe0n t\u{1EA5}t!`,
    'zh-hans': `\u{57FA}\u{4E8E}\u{65F6}\u{95F4}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{5BC6}\u{7801}\u{FF08}TOTP\u{FF09}\u{6CE8}\u{518C}\u{5B8C}\u{6210}\u{FF01}`,
    'zh-hant': `\u{57FA}\u{65BC}\u{6642}\u{9593}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{5BC6}\u{78BC}\u{FF08}TOTP\u{FF09}\u{8A3B}\u{518A}\u{5B8C}\u{6210}\u{FF01}`,
    en: `Time-based One-Time Password (TOTP) enrollment complete!`
};
const $b11db1b62d4a8f76$export$5dc26a93401cd7ec = {
    ar: (activityHref)=>$b11db1b62d4a8f76$var$html`طلبك قيد المعالجة. تتبع التقدم والوصول إلى الوثيقة المكتمل حول <a href="${activityHref}">النشاط</a>. قد يستغرق الأمر دقيقة أو دقيقتين لإرسال الرسائل الإلكترونية إلى المستلمين.`,
    de: (activityHref)=>$b11db1b62d4a8f76$var$html`Deine Anfrage wird gerade bearbeitet. Verfolgen Sie den Fortschritt und greifen Sie auf das ausgefüllte Dokument zur <a href="${activityHref}">Aktivität</a> zu. Es kann ein oder zwei Minuten dauern, bis E-Mails an die Empfänger gesendet werden.`,
    es: (activityHref)=>$b11db1b62d4a8f76$var$html`Tu solicitud está en proceso. Haz un seguimiento del progreso y accede al documento completado sobre la <a href="${activityHref}">actividad</a>. Puede que los correos electrónicos se envíen a los destinatarios tardar uno o dos minutos.`,
    fa: (activityHref)=>$b11db1b62d4a8f76$var$html`درخواست شما در حال پردازش است. پیشرفت را پیگیری کنید و به سند تکمیل <a href="${activityHref}">شده فعالیت</a> دسترسی پیدا کنید. ممکن است یک یا دو دقیقه طول بکشد تا ایمیل ها به گیرندگان ارسال شود.`,
    fil: (activityHref)=>$b11db1b62d4a8f76$var$html`Pinoproseso ang iyong kahilingan. Subaybayan ang pag-unlad at i-access ang nakumpletong dokumento sa <a href="${activityHref}">aktibidad</a>. Maaaring tumagal ng isa o dalawang minuto bago maipadala ang mga email sa mga tatanggap.`,
    fr: (activityHref)=>$b11db1b62d4a8f76$var$html`Votre demande est en cours de traitement. Suivez l’avancement et accédez au document complété sur <a href="${activityHref}">l’activité</a>. Il peut falloir une minute ou deux pour que les emails soient envoyés aux destinataires.`,
    hi: (activityHref)=>$b11db1b62d4a8f76$var$html`आपका अनुरोध संसाधित हो रहा है। प्रगति को ट्रैक करें और <a href="${activityHref}">गतिविधि</a> पर पूर्ण दस्तावेज़ तक पहुंचें। प्राप्तकर्ताओं को ईमेल भेजने में एक या दो मिनट लग सकते हैं।`,
    ht: (activityHref)=>$b11db1b62d4a8f76$var$html`Demann ou an ap trete Swiv pwogrè ak jwenn aksè nan dokiman an ranpli sou <a href="${activityHref}">aktivite</a> a. Li ka pran yon minit oswa de pou imèl yo dwe voye bay moun k ap resevwa yo.`,
    it: (activityHref)=>$b11db1b62d4a8f76$var$html`La tua richiesta è in fase di elaborazione. Monitorare i progressi e accedere al documento completato <a href="${activityHref}">sull'attività</a>. Potrebbero volerci uno o due minuti prima che le email vengano inviate ai destinatari.`,
    ja: (activityHref)=>$b11db1b62d4a8f76$var$html`あなたのリクエストは処理中です。進捗を追跡し、 <a href="${activityHref}">活動</a>に関する完成した文書にアクセスしましょう。メールが受信者に送信されるまでに1〜2分かかることもあります。`,
    ko: (activityHref)=>$b11db1b62d4a8f76$var$html`귀하의 요청은 처리 중입니다. 진행 상황을 추적하고 <a href="${activityHref}">활동</a>에 관한 완성된 문서에 접근할 수 있습니다. 이메일이 수신자에게 전달되기까지 한두 분이 걸릴 수 있습니다.`,
    mww: (activityHref)=>$b11db1b62d4a8f76$var$html`Koj qhov kev thov tab tom ua tiav. Taug qab kev nce qib thiab nkag mus rau daim ntawv ua tiav ntawm <a href="${activityHref}">qhov kev ua ub no</a>. Tej zaum nws yuav siv sijhawm ib feeb lossis ob feeb rau cov email xa mus rau cov neeg tau txais.`,
    ps: (activityHref)=>$b11db1b62d4a8f76$var$html`ستا غوښتنه پروسس کېږی. پرمختګ تعقیب کړئ او د <a href="${activityHref}">فعالیت</a> بشپړ شوی سند ته لاسرسی ولرئ. ممکن یو یا دوه دقیقې وخت ونیسی چې ایمیلونه ترلاسه کوونکو ته واستول شی.`,
    pt: (activityHref)=>$b11db1b62d4a8f76$var$html`Seu pedido está sendo processado. Acompanhe o progresso e acesse o documento concluído na <a href="${activityHref}">atividade</a>. Pode levar um ou dois minutos para que os e-mails sejam enviados aos destinatários.`,
    'pt-pt': (activityHref)=>$b11db1b62d4a8f76$var$html`O seu pedido está a ser processado. Acompanhe o progresso e aceda ao documento concluído na <a href="${activityHref}">atividade</a>. Pode demorar um ou dois minutos até que os emails sejam enviados aos destinatários.`,
    ru: (activityHref)=>$b11db1b62d4a8f76$var$html`Ваш запрос обрабатывается. Отслеживайте прогресс и получайте доступ к завершённому документу <a href="${activityHref}">по заданию</a>. Письмо может занять минуту или две, чтобы отправить получателям.`,
    sm: (activityHref)=>$b11db1b62d4a8f76$var$html`O loo faagaoioia lau talosaga. Siaki le alualu i luma ma faaaoga le pepa o faamatalaga ua maea i luga o le <a href="${activityHref}">gaoioiga</a>. Atonu e alu ai se minute pe lua mo le auina atu o imeli i tagata e mauaina.`,
    so: (activityHref)=>$b11db1b62d4a8f76$var$html`Codsigaaga waa la shaqeynayaa. La soco horumarka oo hel dukumentiga la dhammeystiray <a href="${activityHref}">ee hawsha</a>. Waxay qaadan kartaa hal daqiiqo ama labo in email-yada loo diro dadka qaata.`,
    th: (activityHref)=>$b11db1b62d4a8f76$var$html`คําขอของคุณกําลังดําเนินการ ติดตามความคืบหน้าและเข้าถึงเอกสารที่เสร็จสมบูรณ์เกี่ยวกับ <a href="${activityHref}">กิจกรรม</a> อาจใช้เวลาหนึ่งหรือสองนาทีในการส่งอีเมลไปยังผู้รับ`,
    ur: (activityHref)=>$b11db1b62d4a8f76$var$html`آپ کی درخواست پراسیس ہو رہی ہے۔ <a href="${activityHref}">سرگرمی</a> کی پیش رفت کو ٹریک کریں اور مکمل شدہ دستاویز تک رسائی حاصل کریں۔ ای میلز وصول کنندگان کو بھیجنے میں ایک یا دو منٹ لگ سکتے ہیں۔`,
    vi: (activityHref)=>$b11db1b62d4a8f76$var$html`Yêu cầu của bạn đang được xử lý. Theo dõi tiến độ và truy cập tài liệu đã hoàn thành về <a href="${activityHref}">hoạt động</a>. Có thể mất một hoặc hai phút để email được gửi đến người nhận.`,
    'zh-hans': (activityHref)=>$b11db1b62d4a8f76$var$html`您的请求正在处理中。跟踪进度并访问活动的完成 <a href="${activityHref}">文档。</a>邮件发送到收件人可能需要一两分钟。`,
    'zh-hant': (activityHref)=>$b11db1b62d4a8f76$var$html`您的申請正在處理中。追蹤進度並取得完成 <a href="${activityHref}">的文件。</a>郵件寄送給收件人可能需要一兩分鐘。`,
    en: (activityHref)=>$b11db1b62d4a8f76$var$html`Your request is processing. Track progress and access the completed document on the <a href="${activityHref}">activity</a>. It may take a minute or two for emails to be sent to the recipients.`
};
const $b11db1b62d4a8f76$export$622bc2fa47b3620 = {
    ar: $b11db1b62d4a8f76$var$html`تحرير الملف الشخصي معطل في موقع التدريب. قم بتعديل ملفك الشخصي في <a href="https://cumulus.care/settings/profile">موقع الإنتاج</a> وسيتم مزامنة تغييراتك مع موقع التدريب خلال عشر دقائق.`,
    de: $b11db1b62d4a8f76$var$html`Profilbearbeitung ist auf der Schulungsseite deaktiviert. Bearbeiten Sie Ihr Profil auf der <a href="https://cumulus.care/settings/profile">Produktionsseite</a> und Ihre Änderungen werden innerhalb von zehn Minuten mit dem Trainingsstandort synchronisiert.`,
    es: $b11db1b62d4a8f76$var$html`La edición de perfil está deshabilitada en el sitio de formación. Edita tu perfil en el <a href="https://cumulus.care/settings/profile">lugar de producción</a> y tus cambios se sincronizarán con el lugar de formación en menos de diez minutos.`,
    fa: $b11db1b62d4a8f76$var$html`ویرایش پروفایل در سایت آموزشی غیرفعال است. پروفایل خود را در <a href="https://cumulus.care/settings/profile">سایت تولید</a> ویرایش کنید و تغییرات شما ظرف ده دقیقه با سایت آموزش همگام سازی خواهد شد.`,
    fil: $b11db1b62d4a8f76$var$html`Hindi pinagana ang pag-edit ng profile sa site ng pagsasanay. I-edit ang iyong profile sa <a href="https://cumulus.care/settings/profile">site ng produksyon</a> at ang iyong mga pagbabago ay mai-synchronize sa site ng pagsasanay sa loob ng sampung minuto.`,
    fr: $b11db1b62d4a8f76$var$html`L’édition de profil est désactivée sur le site de formation. Modifiez votre profil sur le <a href="https://cumulus.care/settings/profile">site de production</a> et vos modifications seront synchronisées avec le site de formation en dix minutes.`,
    hi: $b11db1b62d4a8f76$var$html`प्रोफ़ाइल संपादन प्रशिक्षण साइट पर अक्षम किया गया है। <a href="https://cumulus.care/settings/profile">उत्पादन साइट</a> पर अपनी प्रोफ़ाइल संपादित करें और आपके परिवर्तन दस मिनट के भीतर प्रशिक्षण साइट पर सिंक्रनाइज़ हो जाएंगे।`,
    ht: $b11db1b62d4a8f76$var$html`Pwofil koreksyon se enfim sou sit la fòmasyon Edite pwofil ou sou <a href="https://cumulus.care/settings/profile">sit pwodiksyon</a> an ak chanjman ou yo pral senkronize nan sit fòmasyon an nan dis minit.`,
    it: $b11db1b62d4a8f76$var$html`La modifica del profilo è disabilitata sul sito di formazione. Modifica il tuo profilo sul <a href="https://cumulus.care/settings/profile">sito di produzione</a> e le tue modifiche saranno sincronizzate con il sito di formazione entro dieci minuti.`,
    ja: $b11db1b62d4a8f76$var$html`トレーニングサイトではプロフィール編集が無効になっています。 <a href="https://cumulus.care/settings/profile">本番サイト</a> でプロフィールを編集すれば、変更内容は10分以内にトレーニングサイトに同期されます。`,
    ko: $b11db1b62d4a8f76$var$html`교육 사이트에서는 프로필 편집이 비활성화되어 있습니다. <a href="https://cumulus.care/settings/profile">운영 사이트</a> 에서 프로필을 편집하면 변경 사항이 10분 이내에 교육 사이트와 동기화됩니다.`,
    mww: $b11db1b62d4a8f76$var$html`Profile editing yog xiam oob qhab ntawm qhov chaw cob qhia. Kho koj qhov profile ntawm qhov <a href="https://cumulus.care/settings/profile">chaw tsim</a> khoom thiab koj cov kev hloov pauv yuav raug synchronized rau qhov chaw cob qhia tsis pub dhau kaum feeb.`,
    ps: $b11db1b62d4a8f76$var$html`د روزنې په سایټ کې د پروفایل ایډیټ کول غیر فعال دی. خپل پروفایل په <a href="https://cumulus.care/settings/profile">تولیدی سایټ</a> کې ایډیټ کړئ او ستاسو بدلونونه به په لسو دقیقو کې د روزنې سایټ سره همغږی شی.`,
    pt: $b11db1b62d4a8f76$var$html`A edição de perfil está desativada no site de treinamento. Edite seu perfil no <a href="https://cumulus.care/settings/profile">local de produção</a> e suas mudanças serão sincronizadas com o local de treinamento em dez minutos.`,
    'pt-pt': $b11db1b62d4a8f76$var$html`A edição de perfil está desativada no site de formação. Edita o teu perfil no <a href="https://cumulus.care/settings/profile">local de produção</a> e as tuas alterações serão sincronizadas com o local de formação em dez minutos.`,
    ru: $b11db1b62d4a8f76$var$html`Редактирование профиля отключено на обучающем сайте. Отредактируйте свой профиль на <a href="https://cumulus.care/settings/profile">производственном сайте</a> , и ваши изменения будут синхронизированы с обучающим сайтом в течение десяти минут.`,
    sm: $b11db1b62d4a8f76$var$html`E le mafai ona faasa'oina le talaaga otooto i luga o le saite o aoaoga. Faasa'o lou talaaga otooto i luga o le <a href="https://cumulus.care/settings/profile">saite o le gaosiga</a> ma o le a faalaugatasia au suiga i le saite o aoaoga i totonu o le sefulu minute.`,
    so: $b11db1b62d4a8f76$var$html`Tafatirka profile-ka waa la joojiyay goobta tababarka. Wax ka beddel profile-kaaga <a href="https://cumulus.care/settings/profile">goobta wax-soo-saarka</a> , isbeddelkaaga waxaa lagu waafajin doonaa goobta tababarka muddo toban daqiiqo gudahood ah.`,
    th: $b11db1b62d4a8f76$var$html`การแก้ไขโปรไฟล์ถูกปิดใช้งานในไซต์การฝึกอบรม แก้ไขโปรไฟล์ของคุณบน <a href="https://cumulus.care/settings/profile">ไซต์การผลิต</a> และการเปลี่ยนแปลงของคุณจะถูกซิงโครไนซ์กับไซต์การฝึกอบรมภายในสิบนาที`,
    ur: $b11db1b62d4a8f76$var$html`تربیتی سائٹ پر پروفائل ایڈیٹنگ غیر فعال ہے۔ <a href="https://cumulus.care/settings/profile">پروڈکشن سائٹ</a> پر اپنا پروفائل ایڈٹ کریں اور آپ کی تبدیلیاں دس منٹ کے اندر ٹریننگ سائٹ کے ساتھ ہم آہنگ ہو جائیں گی۔`,
    vi: $b11db1b62d4a8f76$var$html`Chỉnh sửa hồ sơ bị tắt trên trang web đào tạo. Chỉnh sửa hồ sơ của bạn trên <a href="https://cumulus.care/settings/profile">trang web sản xuất</a> và các thay đổi của bạn sẽ được đồng bộ hóa với trang web đào tạo trong vòng mười phút.`,
    'zh-hans': $b11db1b62d4a8f76$var$html`培训网站上的个人资料编辑功能已关闭。在 <a href="https://cumulus.care/settings/profile">生产站点</a> 编辑你的个人资料，你的更改将在十分钟内同步到培训站点。`,
    'zh-hant': $b11db1b62d4a8f76$var$html`培訓網站上的個人檔案編輯功能已關閉。在 <a href="https://cumulus.care/settings/profile">生產網站上</a> 編輯你的個人檔案，你的變更會在十分鐘內同步到訓練網站。`,
    en: $b11db1b62d4a8f76$var$html`Profile editing is disabled on the training site. Edit your profile on the <a href="https://cumulus.care/settings/profile">production site</a> and your changes will be synchronized to the training site within ten minutes.`
};
const $b11db1b62d4a8f76$export$e2256549c43609c6 = {
    ar: $b11db1b62d4a8f76$var$html`<span class="text-bold">هذا الموقع مخصص لأغراض التدريب فقط.</span> راجع <a href="/docs/training-site">الوثائق</a> لمزيد من المعلومات أو توجه <a href="https://cumulus.care/">إلى موقع الإنتاج</a>.`,
    de: $b11db1b62d4a8f76$var$html`<span class="text-bold">Diese Seite dient ausschließlich Schulungszwecken.</span> Weitere Informationen finden Sie in der <a href="/docs/training-site">Dokumentation</a> oder besuchen Sie den <a href="https://cumulus.care/">Produktionsstandort</a>.`,
    es: $b11db1b62d4a8f76$var$html`<span class="text-bold">Este sitio es únicamente para fines de formación.</span> Consulta la <a href="/docs/training-site">documentación</a> para más información o acude al <a href="https://cumulus.care/">lugar de producción</a>.`,
    fa: $b11db1b62d4a8f76$var$html`<span class="text-bold">این سایت صرفا برای اهداف آموزشی است.</span> برای اطلاعات بیشتر به <a href="/docs/training-site">مستندات</a> مراجعه کنید یا به <a href="https://cumulus.care/">محل تولید</a> مراجعه کنید.`,
    fil: $b11db1b62d4a8f76$var$html`<span class="text-bold">Ang site na ito ay para sa mga layunin ng pagsasanay lamang.</span> Sumangguni sa <a href="/docs/training-site">dokumentasyon</a> para sa karagdagang impormasyon o pumunta sa <a href="https://cumulus.care/">site ng produksyon</a>.`,
    fr: $b11db1b62d4a8f76$var$html`<span class="text-bold">Ce site est uniquement destiné à la formation.</span> Consultez la <a href="/docs/training-site">documentation</a> pour plus d’informations ou rendez-vous sur <a href="https://cumulus.care/">le site de production</a>.`,
    hi: $b11db1b62d4a8f76$var$html`<span class="text-bold">यह साइट केवल प्रशिक्षण उद्देश्यों के लिए है।</span> अधिक जानकारी के लिए <a href="/docs/training-site">दस्तावेज़</a> देखें या <a href="https://cumulus.care/">उत्पादन स्थल</a> पर जाएँ।`,
    ht: $b11db1b62d4a8f76$var$html`<span class="text-bold">Sit sa a se pou rezon fòmasyon sèlman.</span> Al gade nan <a href="/docs/training-site">dokiman</a> an pou plis enfòmasyon oswa ale nan <a href="https://cumulus.care/">sit pwodiksyon</a> an.`,
    it: $b11db1b62d4a8f76$var$html`<span class="text-bold">Questo sito è solo a scopo di formazione.</span> Consulta la <a href="/docs/training-site">documentazione</a> per maggiori informazioni o vai al <a href="https://cumulus.care/">sito di produzione</a>.`,
    ja: $b11db1b62d4a8f76$var$html`<span class="text-bold">このサイトはトレーニング目的のみを目的としています。</span> 詳細は <a href="/docs/training-site">ドキュメント</a> を参照するか、 <a href="https://cumulus.care/">生産現場</a>をご覧ください。`,
    ko: $b11db1b62d4a8f76$var$html`<span class="text-bold">이 사이트는 교육 목적으로만 운영됩니다.</span> 자세한 내용은 <a href="/docs/training-site">문서를</a> 참조하거나 <a href="https://cumulus.care/">생산 현장</a>을 방문하세요.`,
    mww: $b11db1b62d4a8f76$var$html`<span class="text-bold">Lub xaib no yog rau kev cob qhia xwb.</span> Saib cov <a href="/docs/training-site">ntaub ntawv</a> rau cov ntaub ntawv ntxiv lossis mus rau qhov <a href="https://cumulus.care/">chaw tsim</a> khoom.`,
    ps: $b11db1b62d4a8f76$var$html`<span class="text-bold">دا سایټ یوازې د روزنې لپاره دی.</span> د نورو معلوماتو لپاره <a href="/docs/training-site">اسنادو</a> ته مراجعه وکړئ یا <a href="https://cumulus.care/">د تولید سایټ</a> ته لاړ شئ.`,
    pt: $b11db1b62d4a8f76$var$html`<span class="text-bold">Este site é apenas para fins de treinamento.</span> Consulte a <a href="/docs/training-site">documentação</a> para mais informações ou vá ao <a href="https://cumulus.care/">local de produção</a>.`,
    'pt-pt': $b11db1b62d4a8f76$var$html`<span class="text-bold">Este site destina-se apenas a fins de formação.</span> Consulte a <a href="/docs/training-site">documentação</a> para mais informações ou dirija-se ao <a href="https://cumulus.care/">local de produção</a>.`,
    ru: $b11db1b62d4a8f76$var$html`<span class="text-bold">Этот сайт предназначен исключительно для учебных целей.</span> Обратитесь к <a href="/docs/training-site">документации</a> для получения дополнительной информации или посетите <a href="https://cumulus.care/">производственный сайт</a>.`,
    sm: $b11db1b62d4a8f76$var$html`<span class="text-bold">O lenei 'upega tafa'ilagi e mo na'o a'oa'oga fa'amoemoega.</span> Va'ai i le <a href="/docs/training-site">fa'amaumauga</a> mo nisi fa'amatalaga pe alu i le <a href="https://cumulus.care/">nofoaga o gaosiga</a>.`,
    so: $b11db1b62d4a8f76$var$html`<span class="text-bold">Boggan waxaa loogu talagalay ujeeddooyin tababar oo kaliya.</span> Eeg <a href="/docs/training-site">dukumentiyada</a> wixii macluumaad dheeraad ah ama booqo <a href="https://cumulus.care/">goobta soo saarista</a>.`,
    th: $b11db1b62d4a8f76$var$html`<span class="text-bold">เว็บไซต์นี้มีวัตถุประสงค์เพื่อการฝึกอบรมเท่านั้น</span> โปรดดู<a href="/docs/training-site">เอกสารประกอบ</a>สําหรับข้อมูลเพิ่มเติมหรือไปที่<a href="https://cumulus.care/">ไซต์การผลิต</a>`,
    ur: $b11db1b62d4a8f76$var$html`<span class="text-bold">یہ سائٹ صرف تربیتی مقاصد کے لیے ہے۔</span> مزید معلومات کے لیے <a href="/docs/training-site">دستاویزات</a> دیکھیں یا <a href="https://cumulus.care/">پروڈکشن سائٹ</a> پر جائیں۔`,
    vi: $b11db1b62d4a8f76$var$html`<span class="text-bold">Trang web này chỉ dành cho mục đích đào tạo.</span> Tham khảo <a href="/docs/training-site">tài liệu</a> để biết thêm thông tin hoặc truy cập <a href="https://cumulus.care/">trang web sản xuất</a>.`,
    'zh-hans': $b11db1b62d4a8f76$var$html`<span class="text-bold">本网站仅供培训用途。</span> 更多信息请参阅 <a href="/docs/training-site">文档</a> 或访问 <a href="https://cumulus.care/">制作现场</a>。`,
    'zh-hant': $b11db1b62d4a8f76$var$html`<span class="text-bold">本網站僅供培訓用途。</span> 請參閱 <a href="/docs/training-site">文件</a> 以獲得更多資訊，或前往 <a href="https://cumulus.care/">製作現場</a>。`,
    en: $b11db1b62d4a8f76$var$html`<span class="text-bold">This site is for training purposes only.</span> Refer to the <a href="/docs/training-site">documentation</a> for more information or go to the <a href="https://cumulus.care/">production site</a>.`
};
const $b11db1b62d4a8f76$export$7a4cb986ff99752 = {
    ar: $b11db1b62d4a8f76$var$html`تم تعطيل تسجيل الحساب الجديد في موقع التدريب. سجل في <a href="https://cumulus.care/sign-up">موقع الإنتاج</a> وسيتم مزامنة حسابك مع موقع التدريب خلال عشر دقائق.`,
    de: $b11db1b62d4a8f76$var$html`Die Registrierung eines neuen Kontos ist auf der Trainingsseite deaktiviert. Melde dich auf der <a href="https://cumulus.care/sign-up">Produktionsseite</a> an und dein Konto wird innerhalb von zehn Minuten mit dem Trainingsstandort synchronisiert.`,
    es: $b11db1b62d4a8f76$var$html`El registro de nueva cuenta está deshabilitado en la página de formación. Regístrate en el <a href="https://cumulus.care/sign-up">sitio de producción</a> y tu cuenta estará sincronizada con el lugar de entrenamiento en menos de diez minutos.`,
    fa: $b11db1b62d4a8f76$var$html`ثبت نام حساب جدید در سایت آموزشی غیرفعال شده است. در <a href="https://cumulus.care/sign-up">سایت تولید</a> ثبت نام کنید و حساب شما ظرف ده دقیقه با محل آموزش همگام سازی خواهد شد.`,
    fil: $b11db1b62d4a8f76$var$html`Hindi pinagana ang pagpaparehistro ng bagong account sa site ng pagsasanay. Mag-sign up sa <a href="https://cumulus.care/sign-up">site ng produksyon</a> at ang iyong account ay mai-synchronize sa site ng pagsasanay sa loob ng sampung minuto.`,
    fr: $b11db1b62d4a8f76$var$html`L’enregistrement du nouveau compte est désactivé sur le site de formation. Inscrivez-vous sur le <a href="https://cumulus.care/sign-up">site de production</a> et votre compte sera synchronisé avec le site de formation en dix minutes.`,
    hi: $b11db1b62d4a8f76$var$html`प्रशिक्षण साइट पर नया खाता पंजीकरण अक्षम कर दिया गया है। <a href="https://cumulus.care/sign-up">उत्पादन स्थल</a> पर साइन अप करें और आपका खाता दस मिनट के भीतर प्रशिक्षण स्थल पर सिंक्रनाइज़ हो जाएगा।`,
    ht: $b11db1b62d4a8f76$var$html`Nouvo enskripsyon kont se enfim sou sit la fòmasyon Enskri sou <a href="https://cumulus.care/sign-up">sit la pwodiksyon</a> ak kont ou pral senkronize nan sit fòmasyon an nan dis minit.`,
    it: $b11db1b62d4a8f76$var$html`La registrazione del nuovo account è disabilitata sul sito di formazione. Iscriviti sul <a href="https://cumulus.care/sign-up">sito di produzione</a> e il tuo account sarà sincronizzato con il sito di formazione entro dieci minuti.`,
    ja: $b11db1b62d4a8f76$var$html`トレーニングサイトでは新規アカウント登録が無効になっています。 <a href="https://cumulus.care/sign-up">本番サイト</a> に登録すれば、10分以内にアカウントがトレーニングサイトと同期されます。`,
    ko: $b11db1b62d4a8f76$var$html`교육 사이트에서는 신규 계정 등록이 비활성화되어 있습니다. <a href="https://cumulus.care/sign-up">운영 사이트</a> 에서 가입하면 10분 이내에 귀하의 계정이 교육 사이트와 동기화됩니다.`,
    mww: $b11db1b62d4a8f76$var$html`Kev sau npe tus account tshiab yog xiam oob qhab ntawm qhov chaw cob qhia. Sau npe rau ntawm qhov <a href="https://cumulus.care/sign-up">chaw tsim</a> khoom thiab koj tus account yuav raug synchronized rau qhov chaw cob qhia tsis pub dhau kaum feeb.`,
    ps: $b11db1b62d4a8f76$var$html`د روزنې سایټ کې د نوی حساب ثبتول غیر فعال دی. په <a href="https://cumulus.care/sign-up">تولیدی سایټ</a> کې نوم لیکنه وکړئ او ستاسو حساب به په لسو دقیقو کې د روزنې ځای سره همغږی شی.`,
    pt: $b11db1b62d4a8f76$var$html`O registro da nova conta está desativado no site de treinamento. Cadastre-se no <a href="https://cumulus.care/sign-up">local de produção</a> e sua conta será sincronizada com o local de treinamento em dez minutos.`,
    'pt-pt': $b11db1b62d4a8f76$var$html`O registo da nova conta está desativado no site de formação. Registe-se no <a href="https://cumulus.care/sign-up">local de produção</a> e a sua conta será sincronizada com o local de treino em dez minutos.`,
    ru: $b11db1b62d4a8f76$var$html`Регистрация нового аккаунта на обучающем сайте отключена. Зарегистрируйтесь на <a href="https://cumulus.care/sign-up">производственном сайте</a> , и ваш аккаунт будет синхронизирован с обучающим сайтом в течение десяти минут.`,
    sm: $b11db1b62d4a8f76$var$html`O le lesitalaina o le faitotoa fou e le mafai ona lesitalaina i luga o le saite o aoaoga. Saini i luga o le <a href="https://cumulus.care/sign-up">'upega tafa'ilagi o le gaosiga</a> ma o lau teuga tupe o le a fa'afeso'ota'i i le nofoaga o a'oa'oga i totonu o le sefulu minute.`,
    so: $b11db1b62d4a8f76$var$html`Diiwaangelinta akoonka cusub waa la joojiyay goobta tababarka. Iska diiwaangeli <a href="https://cumulus.care/sign-up">goobta wax-soo-saarka</a> , xisaabtaadana waxaa lagu waafajin doonaa goobta tababarka muddo toban daqiiqo gudahood.`,
    th: $b11db1b62d4a8f76$var$html`การลงทะเบียนบัญชีใหม่ถูกปิดใช้งานบนเว็บไซต์การฝึกอบรม ลงทะเบียนบนเว็บไซต์ <a href="https://cumulus.care/sign-up">การผลิต</a> และบัญชีของคุณจะถูกซิงโครไนซ์กับไซต์การฝึกอบรมภายในสิบนาที`,
    ur: $b11db1b62d4a8f76$var$html`ٹریننگ سائٹ پر نیا اکاؤنٹ رجسٹریشن غیر فعال کر دیا گیا ہے۔ <a href="https://cumulus.care/sign-up">پروڈکشن سائٹ</a> پر سائن اپ کریں اور آپ کا اکاؤنٹ دس منٹ کے اندر تربیتی سائٹ کے ساتھ ہم آہنگ ہو جائے گا۔`,
    vi: $b11db1b62d4a8f76$var$html`Đăng ký tài khoản mới bị vô hiệu hóa trên trang web đào tạo. Đăng ký trên <a href="https://cumulus.care/sign-up">trang web sản xuất</a> và tài khoản của bạn sẽ được đồng bộ hóa với trang web đào tạo trong vòng mười phút.`,
    'zh-hans': $b11db1b62d4a8f76$var$html`培训网站上的新账户注册功能已被禁用。在 <a href="https://cumulus.care/sign-up">生产网站</a> 注册，你的账户将在十分钟内同步到培训网站。`,
    'zh-hant': $b11db1b62d4a8f76$var$html`培訓網站上的新帳號註冊功能已被停用。在 <a href="https://cumulus.care/sign-up">生產線上</a> 註冊，帳號將在十分鐘內同步到培訓網站。`,
    en: $b11db1b62d4a8f76$var$html`New account registration is disabled on the training site. Sign up on the <a href="https://cumulus.care/sign-up">production site</a> and your account will be synchronized to the training site within ten minutes.`
};
const $b11db1b62d4a8f76$export$f6962c03b9511845 = {
    ar: (cumulus)=>`\u{645}\u{631}\u{62D}\u{628}\u{627} \u{628}\u{643}\u{645} \u{641}\u{64A} \u{645}\u{648}\u{642}\u{639} \u{62A}\u{62F}\u{631}\u{64A}\u{628} ${cumulus} !`,
    de: (cumulus)=>`Willkommen auf der ${cumulus} !`,
    es: (cumulus)=>`\xa1Bienvenidos al sitio de entrenamiento ${cumulus} !`,
    fa: (cumulus)=>`\u{628}\u{647} \u{633}\u{627}\u{6CC}\u{62A} \u{622}\u{645}\u{648}\u{632}\u{634}\u{6CC} ${cumulus} \u{62E}\u{648}\u{634} \u{622}\u{645}\u{62F}\u{6CC}\u{62F}!`,
    fil: (cumulus)=>`Maligayang pagdating sa site ng pagsasanay ${cumulus} !`,
    fr: (cumulus)=>`Bienvenue sur le site d\u{2019}entra\xeenement ${cumulus} !`,
    hi: (cumulus)=>`${cumulus} \u{92A}\u{94D}\u{930}\u{936}\u{93F}\u{915}\u{94D}\u{937}\u{923} \u{938}\u{94D}\u{925}\u{932} \u{92E}\u{947}\u{902} \u{906}\u{92A}\u{915}\u{93E} \u{938}\u{94D}\u{935}\u{93E}\u{917}\u{924} \u{939}\u{948}!`,
    ht: (cumulus)=>`Byenveni nan sit f\xf2masyon ${cumulus} la!`,
    it: (cumulus)=>`Benvenuti nel sito di addestramento ${cumulus} !`,
    ja: (cumulus)=>`${cumulus}\u{30C8}\u{30EC}\u{30FC}\u{30CB}\u{30F3}\u{30B0}\u{30B5}\u{30A4}\u{30C8}\u{3078}\u{3088}\u{3046}\u{3053}\u{305D}!`,
    ko: (cumulus)=>`${cumulus} \u{D6C8}\u{B828}\u{C7A5}\u{C5D0} \u{C624}\u{C2E0} \u{AC83}\u{C744} \u{D658}\u{C601}\u{D569}\u{B2C8}\u{B2E4}!`,
    mww: (cumulus)=>`Zoo siab txais tos rau ${cumulus} kev cob qhia qhov chaw!`,
    ps: (cumulus)=>`\u{62F} ${cumulus} \u{62F} \u{631}\u{648}\u{632}\u{646}\u{6D0} \u{681}\u{627}\u{6CC} \u{62A}\u{647} \u{69A}\u{647} \u{631}\u{627}\u{63A}\u{644}\u{627}\u{633}\u{62A}!`,
    pt: (cumulus)=>`Bem-vindo ao site de treinamento ${cumulus} !`,
    'pt-pt': (cumulus)=>`Bem-vindo ao local de treino ${cumulus} !`,
    ru: (cumulus)=>`\u{414}\u{43E}\u{431}\u{440}\u{43E} \u{43F}\u{43E}\u{436}\u{430}\u{43B}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{43D}\u{430} \u{442}\u{440}\u{435}\u{43D}\u{438}\u{440}\u{43E}\u{432}\u{43E}\u{447}\u{43D}\u{443}\u{44E} ${cumulus} !`,
    sm: (cumulus)=>`Fa'afeiloa'i i le 'upega tafa'ilagi a'oa'oga ${cumulus} !`,
    so: (cumulus)=>`Ku soo dhawoow goobta tababarka ${cumulus} !`,
    th: (cumulus)=>`\u{E22}\u{E34}\u{E19}\u{E14}\u{E35}\u{E15}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E31}\u{E1A}\u{E2A}\u{E39}\u{E48}\u{E44}\u{E0B}\u{E15}\u{E4C}\u{E01}\u{E32}\u{E23}\u{E1D}\u{E36}\u{E01}\u{E2D}\u{E1A}\u{E23}\u{E21} ${cumulus} !`,
    ur: (cumulus)=>`${cumulus} \u{62A}\u{631}\u{628}\u{6CC}\u{62A}\u{6CC} \u{633}\u{627}\u{626}\u{679} \u{67E}\u{631} \u{62E}\u{648}\u{634} \u{622}\u{645}\u{62F}\u{6CC}\u{62F}!`,
    vi: (cumulus)=>`Ch\xe0o m\u{1EEB}ng b\u{1EA1}n \u{111}\u{1EBF}n v\u{1EDB}i trang web \u{111}\xe0o t\u{1EA1}o ${cumulus} !`,
    'zh-hans': (cumulus)=>`\u{6B22}\u{8FCE}\u{6765}\u{5230} ${cumulus} \u{8BAD}\u{7EC3}\u{57FA}\u{5730}\u{FF01}`,
    'zh-hant': (cumulus)=>`\u{6B61}\u{8FCE}\u{4F86}\u{5230} ${cumulus} \u{8A13}\u{7DF4}\u{57FA}\u{5730}\u{FF01}`,
    en: (cumulus)=>`Welcome to the ${cumulus} training site!`
};
const $b11db1b62d4a8f76$export$5af50732e0f3df9b = {
    ar: `\u{646}\u{639}\u{645}\u{644} \u{639}\u{644}\u{649} \u{62A}\u{648}\u{641}\u{64A}\u{631} \u{62A}\u{631}\u{62C}\u{645}\u{629} \u{644}\u{644}\u{63A}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{62F}\u{631}\u{62C}\u{629} \u{623}\u{62F}\u{646}\u{627}\u{647}. \u{633}\u{62A}\u{638}\u{647}\u{631} \u{627}\u{644}\u{645}\u{646}\u{627}\u{637}\u{642} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{648}\u{642}\u{639} \u{627}\u{644}\u{62A}\u{64A} \u{644}\u{645} \u{62A}\u{62A}\u{631}\u{62C}\u{645} \u{628}\u{639}\u{62F} \u{625}\u{644}\u{649} \u{627}\u{644}\u{644}\u{63A}\u{629} \u{627}\u{644}\u{625}\u{646}\u{62C}\u{644}\u{64A}\u{632}\u{64A}\u{629}.`,
    de: `Wir arbeiten daran, \xdcbersetzungen f\xfcr die unten aufgef\xfchrten Sprachen bereitzustellen. Bereiche der Seite, die noch nicht \xfcbersetzt wurden, erscheinen auf Englisch.`,
    es: `Estamos trabajando en proporcionar traducci\xf3n para los idiomas que se enumeran a continuaci\xf3n. Las \xe1reas del sitio que a\xfan no han sido traducidas aparecer\xe1n en ingl\xe9s.`,
    fa: `\u{645}\u{627} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{6A9}\u{627}\u{631} \u{628}\u{631} \u{631}\u{648}\u{6CC} \u{627}\u{631}\u{627}\u{626}\u{647} \u{62A}\u{631}\u{62C}\u{645}\u{647} \u{628}\u{631}\u{627}\u{6CC} \u{632}\u{628}\u{627}\u{646} \u{647}\u{627}\u{6CC} \u{641}\u{647}\u{631}\u{633}\u{62A} \u{634}\u{62F}\u{647} \u{62F}\u{631} \u{632}\u{6CC}\u{631} \u{647}\u{633}\u{62A}\u{6CC}\u{645}. \u{628}\u{62E}\u{634} \u{647}\u{627}\u{6CC}\u{6CC} \u{627}\u{632} \u{633}\u{627}\u{6CC}\u{62A} \u{6A9}\u{647} \u{647}\u{646}\u{648}\u{632} \u{62A}\u{631}\u{62C}\u{645}\u{647} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{646}\u{62F}\u{60C} \u{628}\u{647} \u{632}\u{628}\u{627}\u{646} \u{627}\u{646}\u{6AF}\u{644}\u{6CC}\u{633}\u{6CC} \u{645}\u{646}\u{62A}\u{634}\u{631} \u{62E}\u{648}\u{627}\u{647}\u{646}\u{62F} \u{634}\u{62F}.`,
    fil: `Nagtatrabaho kami sa pagbibigay ng pagsasalin para sa mga wika na nakalista sa ibaba. Ang mga bahagi ng site na hindi pa isinalin ay lilitaw sa Ingles.`,
    fr: `Nous travaillons \xe0 fournir des traductions pour les langues list\xe9es ci-dessous. Les zones du site qui n\u{2019}ont pas encore \xe9t\xe9 traduites appara\xeetront en anglais.`,
    hi: `\u{939}\u{92E} \u{928}\u{940}\u{91A}\u{947} \u{938}\u{942}\u{91A}\u{940}\u{92C}\u{926}\u{94D}\u{927} \u{92D}\u{93E}\u{937}\u{93E}\u{913}\u{902} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{928}\u{941}\u{935}\u{93E}\u{926} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{928} \u{915}\u{930}\u{928}\u{947} \u{92A}\u{930} \u{915}\u{93E}\u{92E} \u{915}\u{930} \u{930}\u{939}\u{947} \u{939}\u{948}\u{902}\u{964} \u{938}\u{93E}\u{907}\u{91F} \u{915}\u{947} \u{91C}\u{93F}\u{928} \u{915}\u{94D}\u{937}\u{947}\u{924}\u{94D}\u{930}\u{94B}\u{902} \u{915}\u{93E} \u{905}\u{92D}\u{940} \u{924}\u{915} \u{905}\u{928}\u{941}\u{935}\u{93E}\u{926} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{939}\u{948}, \u{935}\u{947} \u{905}\u{902}\u{917}\u{94D}\u{930}\u{947}\u{91C}\u{940} \u{92E}\u{947}\u{902} \u{926}\u{93F}\u{916}\u{93E}\u{908} \u{926}\u{947}\u{902}\u{917}\u{947}\u{964}`,
    ht: `Nap travay pou bay tradiksyon pou lang ki nan lis anba yo. Z\xf2n nan sit la ki pa gen ank\xf2 yo te tradui yo pral par\xe8t nan lang angle.`,
    it: `Stiamo lavorando per fornire traduzioni per le lingue elencate di seguito. Le aree del sito che non sono ancora state tradotte appariranno in inglese.`,
    ja: `\u{4EE5}\u{4E0B}\u{306B}\u{6319}\u{3052}\u{308B}\u{8A00}\u{8A9E}\u{306E}\u{7FFB}\u{8A33}\u{63D0}\u{4F9B}\u{306B}\u{53D6}\u{308A}\u{7D44}\u{3093}\u{3067}\u{3044}\u{307E}\u{3059}\u{3002}\u{307E}\u{3060}\u{7FFB}\u{8A33}\u{3055}\u{308C}\u{3066}\u{3044}\u{306A}\u{3044}\u{30B5}\u{30A4}\u{30C8}\u{306E}\u{4E00}\u{90E8}\u{306F}\u{82F1}\u{8A9E}\u{3067}\u{63B2}\u{8F09}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C544}\u{B798}\u{C5D0} \u{B098}\u{C5F4}\u{B41C} \u{C5B8}\u{C5B4}\u{B4E4}\u{C5D0} \u{B300}\u{D55C} \u{BC88}\u{C5ED}\u{C744} \u{C81C}\u{ACF5}\u{D558}\u{AE30} \u{C704}\u{D574} \u{B178}\u{B825}\u{D558}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C544}\u{C9C1} \u{BC88}\u{C5ED}\u{B418}\u{C9C0} \u{C54A}\u{C740} \u{BD80}\u{C9C0} \u{B0B4} \u{C77C}\u{BD80} \u{C9C0}\u{C5ED}\u{C740} \u{C601}\u{C5B4}\u{B85C} \u{ACF5}\u{AC1C}\u{B420} \u{C608}\u{C815}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Peb tab tom ua haujlwm ntawm kev muab kev txhais lus rau cov lus teev hauv qab no. Thaj chaw ntawm lub xaib uas tseem tsis tau txhais yuav tshwm sim ua lus Askiv.`,
    ps: `\u{645}\u{648}\u{696} \u{62F} \u{644}\u{627}\u{646}\u{62F}\u{6D0} \u{6CC}\u{627}\u{62F}\u{648} \u{698}\u{628}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{698}\u{628}\u{627}\u{693}\u{647} \u{628}\u{631}\u{627}\u{628}\u{631}\u{648}\u{644}\u{648} \u{6A9}\u{627}\u{631} \u{6A9}\u{648}\u{648}. \u{62F} \u{633}\u{627}\u{6CC}\u{67C} \u{647}\u{63A}\u{647} \u{628}\u{631}\u{62E}\u{6D0} \u{686}\u{6D0} \u{644}\u{627} \u{62A}\u{631} \u{627}\u{648}\u{633}\u{647} \u{646}\u{647} \u{62F}\u{6CC} \u{698}\u{628}\u{627}\u{693}\u{644} \u{634}\u{648}\u{6CC}\u{60C} \u{628}\u{647} \u{67E}\u{647} \u{627}\u{646}\u{6AB}\u{644}\u{6CC}\u{633}\u{6CC} \u{698}\u{628}\u{647} \u{62E}\u{67E}\u{631}\u{647} \u{634}\u{6CC}.`,
    pt: `Estamos trabalhando para fornecer tradu\xe7\xe3o para os idiomas listados abaixo. \xc1reas do site que ainda n\xe3o foram traduzidas aparecer\xe3o em ingl\xeas.`,
    'pt-pt': `Estamos a trabalhar para fornecer tradu\xe7\xe3o para as l\xednguas listadas abaixo. \xc1reas do site que ainda n\xe3o foram traduzidas aparecer\xe3o em ingl\xeas.`,
    ru: `\u{41C}\u{44B} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{430}\u{435}\u{43C} \u{43D}\u{430}\u{434} \u{43F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43C} \u{43F}\u{435}\u{440}\u{435}\u{432}\u{43E}\u{434}\u{430} \u{434}\u{43B}\u{44F} \u{43F}\u{435}\u{440}\u{435}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{445} \u{43D}\u{438}\u{436}\u{435} \u{44F}\u{437}\u{44B}\u{43A}\u{43E}\u{432}. \u{427}\u{430}\u{441}\u{442}\u{438} \u{441}\u{430}\u{439}\u{442}\u{430}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{435} \u{435}\u{449}\u{451} \u{43D}\u{435} \u{431}\u{44B}\u{43B}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{44B}, \u{431}\u{443}\u{434}\u{443}\u{442} \u{43E}\u{43F}\u{443}\u{431}\u{43B}\u{438}\u{43A}\u{43E}\u{432}\u{430}\u{43D}\u{44B} \u{43D}\u{430} \u{430}\u{43D}\u{433}\u{43B}\u{438}\u{439}\u{441}\u{43A}\u{43E}\u{43C} \u{44F}\u{437}\u{44B}\u{43A}\u{435}.`,
    sm: `O lo'o matou galulue i le tu'uina atu o fa'aliliuga mo gagana o lo'o lisiina atu i lalo. O vaega o le saite e le'i faaliliuina o le a faaali mai i le gagana Peretania.`,
    so: `Waxaan ka shaqeyneynaa bixinta turjumaadda luqadaha hoos ku xusan. Qaybo ka mid ah goobta aan weli la tarjumin ayaa lagu arki doonaa Ingiriis.`,
    th: `\u{E40}\u{E23}\u{E32}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E41}\u{E1B}\u{E25}\u{E20}\u{E32}\u{E29}\u{E32}\u{E17}\u{E35}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}\u{E44}\u{E27}\u{E49}\u{E14}\u{E49}\u{E32}\u{E19}\u{E25}\u{E48}\u{E32}\u{E07} \u{E1E}\u{E37}\u{E49}\u{E19}\u{E17}\u{E35}\u{E48}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E41}\u{E1B}\u{E25}\u{E08}\u{E30}\u{E1B}\u{E23}\u{E32}\u{E01}\u{E0F}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E20}\u{E32}\u{E29}\u{E32}\u{E2D}\u{E31}\u{E07}\u{E01}\u{E24}\u{E29}`,
    ur: `\u{6C1}\u{645} \u{646}\u{6CC}\u{686}\u{6D2} \u{62F}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{632}\u{628}\u{627}\u{646}\u{648}\u{6BA} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{62A}\u{631}\u{62C}\u{645}\u{6C1} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{631}\u{646}\u{6D2} \u{67E}\u{631} \u{6A9}\u{627}\u{645} \u{6A9}\u{631} \u{631}\u{6C1}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4} \u{633}\u{627}\u{626}\u{679} \u{6A9}\u{6D2} \u{648}\u{6C1} \u{62D}\u{635}\u{6D2} \u{62C}\u{648} \u{627}\u{628}\u{6BE}\u{6CC} \u{62A}\u{6A9} \u{62A}\u{631}\u{62C}\u{645}\u{6C1} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{626}\u{6D2}\u{60C} \u{627}\u{646}\u{6AF}\u{631}\u{6CC}\u{632}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{634}\u{627}\u{626}\u{639} \u{6C1}\u{648}\u{6BA} \u{6AF}\u{6D2}\u{6D4}`,
    vi: `Ch\xfang t\xf4i \u{111}ang l\xe0m vi\u{1EC7}c \u{111}\u{1EC3} cung c\u{1EA5}p b\u{1EA3}n d\u{1ECB}ch cho c\xe1c ng\xf4n ng\u{1EEF} \u{111}\u{1B0}\u{1EE3}c li\u{1EC7}t k\xea d\u{1B0}\u{1EDB}i \u{111}\xe2y. C\xe1c khu v\u{1EF1}c c\u{1EE7}a trang web ch\u{1B0}a \u{111}\u{1B0}\u{1EE3}c d\u{1ECB}ch s\u{1EBD} xu\u{1EA5}t hi\u{1EC7}n b\u{1EB1}ng ti\u{1EBF}ng Anh.`,
    'zh-hans': `\u{6211}\u{4EEC}\u{6B63}\u{5728}\u{4E3A}\u{4E0B}\u{5217}\u{8BED}\u{8A00}\u{63D0}\u{4F9B}\u{7FFB}\u{8BD1}\u{670D}\u{52A1}\u{3002}\u{5C1A}\u{672A}\u{7FFB}\u{8BD1}\u{7684}\u{7F51}\u{7AD9}\u{533A}\u{57DF}\u{5C06}\u{4EE5}\u{82F1}\u{6587}\u{5F62}\u{5F0F}\u{5448}\u{73B0}\u{3002}`,
    'zh-hant': `\u{6211}\u{5011}\u{6B63}\u{5728}\u{70BA}\u{4E0B}\u{5217}\u{8A9E}\u{8A00}\u{63D0}\u{4F9B}\u{7FFB}\u{8B6F}\u{670D}\u{52D9}\u{3002}\u{5C1A}\u{672A}\u{7FFB}\u{8B6F}\u{7684}\u{7DB2}\u{7AD9}\u{5340}\u{57DF}\u{5C07}\u{4EE5}\u{82F1}\u{6587}\u{5448}\u{73FE}\u{3002}`,
    en: `We're working on providing translation for the languages listed below. Areas of the site which have not yet been translated will appear in English.`
};
const $b11db1b62d4a8f76$export$cf852b8d22fa3909 = {
    ar: `\u{647}\u{644} \u{62A}\u{648}\u{627}\u{62C}\u{647} \u{645}\u{634}\u{643}\u{644}\u{629} \u{641}\u{64A} \u{645}\u{633}\u{62D} \u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{62C}\u{627}\u{628}\u{629} \u{627}\u{644}\u{633}\u{631}\u{64A}\u{639}\u{629}\u{61F}`,
    de: `Probleme beim Scannen des QR-Codes?`,
    es: `\xbfProblemas para escanear el c\xf3digo QR?`,
    fa: `\u{645}\u{634}\u{6A9}\u{644} \u{62F}\u{631} \u{627}\u{633}\u{6A9}\u{646} \u{6A9}\u{62F} QR \u{62F}\u{627}\u{631}\u{6CC}\u{62F}\u{61F}`,
    fil: `Problema sa pag-scan ng QR code?`,
    fr: `Probl\xe8me pour scanner le code QR ?`,
    hi: `\u{915}\u{94D}\u{92F}\u{942}\u{906}\u{930} \u{915}\u{94B}\u{921} \u{938}\u{94D}\u{915}\u{948}\u{928} \u{915}\u{930}\u{928}\u{947} \u{92E}\u{947}\u{902} \u{92A}\u{930}\u{947}\u{936}\u{93E}\u{928}\u{940}?`,
    ht: `Pwobl\xe8m pou eskane k\xf2d la QR?`,
    it: `Problemi a scansionare il codice QR?`,
    ja: `QR\u{30B3}\u{30FC}\u{30C9}\u{306E}\u{30B9}\u{30AD}\u{30E3}\u{30F3}\u{306B}\u{554F}\u{984C}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{304B}?`,
    ko: `QR \u{CF54}\u{B4DC} \u{C2A4}\u{CE94}\u{C5D0} \u{BB38}\u{C81C}\u{AC00} \u{C788}\u{B098}\u{C694}?`,
    mww: `Teeb meem luam theej duab QR code?`,
    ps: `\u{62F} QR \u{6A9}\u{648}\u{689} \u{633}\u{6A9}\u{6CC}\u{646} \u{6A9}\u{648}\u{644}\u{648} \u{6A9}\u{6D0} \u{633}\u{62A}\u{648}\u{646}\u{632}\u{647} \u{62F}\u{647}\u{61F}`,
    pt: `Problemas para escanear o c\xf3digo QR?`,
    'pt-pt': `Problemas a digitalizar o c\xf3digo QR?`,
    ru: `\u{41F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{44B} \u{441} \u{441}\u{43A}\u{430}\u{43D}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43C} QR-\u{43A}\u{43E}\u{434}\u{430}?`,
    sm: `Fa'afitauli i le su'esu'eina o le QR code?`,
    so: `Dhibaato ku saabsan baaritaanka QR code-ka?`,
    th: `\u{E21}\u{E35}\u{E1B}\u{E31}\u{E0D}\u{E2B}\u{E32}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E41}\u{E01}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A} QR?`,
    ur: `\u{6A9}\u{6CC}\u{627} \u{6A9}\u{6CC}\u{648} \u{622}\u{631} \u{6A9}\u{648}\u{688} \u{627}\u{633}\u{6A9}\u{6CC}\u{646} \u{6A9}\u{631}\u{646}\u{6D2} \u{645}\u{6CC}\u{6BA} \u{645}\u{634}\u{6A9}\u{644} \u{67E}\u{6CC}\u{634} \u{622}\u{626}\u{6CC}\u{61F}`,
    vi: `S\u{1EF1} c\u{1ED1} khi qu\xe9t m\xe3 QR?`,
    'zh-hans': `\u{626B}\u{63CF}\u{4E8C}\u{7EF4}\u{7801}\u{6709}\u{95EE}\u{9898}\u{5417}\u{FF1F}`,
    'zh-hant': `\u{6383}\u{63CF} QR \u{78BC}\u{6709}\u{56F0}\u{96E3}\u{55CE}\u{FF1F}`,
    en: `Trouble scanning the QR code?`
};
const $b11db1b62d4a8f76$export$2e7a42a0b41ee2fb = {
    ar: (date, time)=>`\u{627}\u{644}\u{623}\u{639}\u{62F}\u{627}\u{62F} ${date} \u{2014} ${time}`,
    de: (date, time)=>`Ausgaben f\xfcr ${date} \u{2013} ${time}`,
    es: (date, time)=>`N\xfameros para ${date} \u{2014} ${time}`,
    fa: (date, time)=>`\u{634}\u{645}\u{627}\u{631}\u{647} \u{647}\u{627} \u{628}\u{631}\u{627}\u{6CC} ${date} \u{2014} ${time}`,
    fil: (date, time)=>`Mga isyu para sa ${date} \u{2014} ${time}`,
    fr: (date, time)=>`Num\xe9ros pour ${date} 5 \u{2014} ${time}`,
    hi: (date, time)=>`${date} - ${time} \u{932}\u{93F}\u{90F} \u{92E}\u{941}\u{926}\u{94D}\u{926}\u{947}`,
    ht: (date, time)=>`Pwobl\xe8m pou ${date} \u{2014} ${time}`,
    it: (date, time)=>`Numeri per ${date} \u{2014} ${time}`,
    ja: (date, time)=>`5 ${date} \u{306E}\u{53F7} \u{2014} ${time}`,
    ko: (date, time)=>`\u{D1A0} ${date} \u{C77C} \u{2014} ${time}`,
    mww: (date, time)=>`Cov teeb meem rau ${date} \u{2014} ${time}`,
    ps: (date, time)=>`\u{62F} ${date} \u{2014} ${time} \u{6AB}\u{6BC}\u{6D0}`,
    pt: (date, time)=>`Edi\xe7\xf5es para ${date} \u{2014} ${time}`,
    'pt-pt': (date, time)=>`Edi\xe7\xf5es para ${date} \u{2014} ${time}`,
    ru: (date, time)=>`\u{412}\u{44B}\u{43F}\u{443}\u{441}\u{43A}\u{438} \u{434}\u{43B}\u{44F} ${date} \u{2014} ${time}`,
    sm: (date, time)=>`Lomiga mo ${date} \u{2014} ${time}`,
    so: (date, time)=>`Arrimaha ${date} \u{2014} ${time}`,
    th: (date, time)=>`\u{E1B}\u{E31}\u{E0D}\u{E2B}\u{E32}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A} ${date} \u{2014} ${time}`,
    ur: (date, time)=>`${date} \u{2014} ${time} \u{628}\u{62C}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{634}\u{645}\u{627}\u{631}\u{6D2}`,
    vi: (date, time)=>`C\xe1c v\u{1EA5}n \u{111}\u{1EC1} cho ${date} - ${time}`,
    'zh-hans': (date, time)=>`5${date} \u{2014} ${time}\u{7684}\u{95EE}\u{9898}`,
    'zh-hant': (date, time)=>`\u{9031}${date} \u{2014} ${time} \u{7684}\u{671F}\u{520A}`,
    en: (date, time)=>`Issues for ${date} \u{2014} ${time}`
};
const $b11db1b62d4a8f76$export$be8263556fe45262 = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644} \u{644}\u{64A}\u{633} \u{636}\u{645}\u{646} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{628}\u{62F}\u{627}\u{64A}\u{629} \u{648}\u{646}\u{647}\u{627}\u{64A}\u{629} \u{633}\u{62C}\u{644} \u{627}\u{644}\u{645}\u{64A}\u{632}\u{627}\u{646}\u{64A}\u{629} \u{623}\u{648} \u{623}\u{646} \u{627}\u{644}\u{645}\u{64A}\u{632}\u{627}\u{646}\u{64A}\u{629} \u{641}\u{64A} \u{62D}\u{627}\u{644}\u{629} \u{625}\u{644}\u{63A}\u{627}\u{621}.`,
    de: `Das Arbeitsdatum liegt nicht im Budget-Datensatz f\xfcr Anfangs- und Enddaten oder das Budget ist im Status "storniert".`,
    es: `La fecha de trabajo no est\xe1 dentro de las fechas de inicio y fin del registro presupuestario o el presupuesto est\xe1 en estado de cancelado.`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631} \u{62F}\u{631} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{647}\u{627}\u{6CC} \u{634}\u{631}\u{648}\u{639} \u{648} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{631}\u{6A9}\u{648}\u{631}\u{62F} \u{628}\u{648}\u{62F}\u{62C}\u{647} \u{646}\u{6CC}\u{633}\u{62A} \u{6CC}\u{627} \u{628}\u{648}\u{62F}\u{62C}\u{647} \u{62F}\u{631} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{644}\u{63A}\u{648} \u{642}\u{631}\u{627}\u{631} \u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `Ang petsa ng trabaho ay wala sa loob ng mga petsa ng pagsisimula at pagtatapos ng talaan ng badyet o ang badyet ay nasa katayuan ng kinansela.`,
    fr: `La date de travail ne figure pas dans les dates de d\xe9but et de fin des registres budg\xe9taires ou le budget est en \xe9tat d\u{2019}annulation.`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{92C}\u{91C}\u{91F} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{914}\u{930} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{924}\u{93F}\u{925}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{947} \u{92D}\u{940}\u{924}\u{930} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948} \u{92F}\u{93E} \u{92C}\u{91C}\u{91F} \u{930}\u{926}\u{94D}\u{926} \u{915}\u{940} \u{917}\u{908} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{92E}\u{947}\u{902} \u{939}\u{948}.`,
    ht: `Dat travay la pa nan dat k\xf2mansman ak fen dosye bidj\xe8 oswa bidj\xe8 a nan estati anile`,
    it: `La data di lavoro non rientra nelle date di inizio e fine del registro del bilancio o il budget \xe8 in stato di annullamento.`,
    ja: `\u{4F5C}\u{696D}\u{65E5}\u{304C}\u{4E88}\u{7B97}\u{8A18}\u{9332}\u{306E}\u{958B}\u{59CB}\u{65E5}\u{304A}\u{3088}\u{3073}\u{7D42}\u{4E86}\u{65E5}\u{306B}\u{542B}\u{307E}\u{308C}\u{3066}\u{3044}\u{306A}\u{3044}\u{304B}\u{3001}\u{4E88}\u{7B97}\u{304C}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{72B6}\u{614B}\u{3067}\u{3059}\u{3002}`,
    ko: `\u{C791}\u{C5C5} \u{B0A0}\u{C9DC}\u{AC00} \u{C608}\u{C0B0} \u{AE30}\u{B85D}\u{C758} \u{C2DC}\u{C791}\u{C77C}\u{ACFC} \u{C885}\u{B8CC}\u{C77C}\u{C5D0} \u{D3EC}\u{D568}\u{B418}\u{C9C0} \u{C54A}\u{AC70}\u{B098} \u{C608}\u{C0B0}\u{C774} \u{CDE8}\u{C18C}\u{B41C} \u{C0C1}\u{D0DC}\u{C77C} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Hnub ua hauj lwm tsis nyob rau hauv cov ntaub ntawv pib thiab xaus los yog cov peev nyiaj yog nyob rau hauv cov ntaub ntawv muab tshem tawm.`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6D0}\u{67C}\u{647} \u{62F} \u{628}\u{648}\u{62F}\u{6CC}\u{62C}\u{6D0} \u{62F} \u{67E}\u{6CC}\u{644} \u{627}\u{648} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{648} \u{6A9}\u{6D0} \u{646}\u{647} \u{62F}\u{647} \u{627}\u{648} \u{646}\u{647} \u{647}\u{645} \u{628}\u{648}\u{62F}\u{6CC}\u{62C}\u{647} \u{644}\u{63A}\u{648}\u{647} \u{634}\u{648}\u{6D0} \u{62F}\u{647}.`,
    pt: `A data de trabalho n\xe3o est\xe1 dentro das datas de in\xedcio e t\xe9rmino do registro or\xe7ament\xe1rio ou o or\xe7amento est\xe1 em status de cancelado.`,
    'pt-pt': `A data de trabalho n\xe3o est\xe1 dentro das datas de in\xedcio e fim do registo or\xe7amental ou o or\xe7amento est\xe1 em estado de cancelamento.`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{43D}\u{435} \u{441}\u{43E}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442} \u{434}\u{430}\u{442}\u{435} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F} \u{431}\u{44E}\u{434}\u{436}\u{435}\u{442}\u{43D}\u{44B}\u{445} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{435}\u{439}, \u{43B}\u{438}\u{431}\u{43E} \u{431}\u{44E}\u{434}\u{436}\u{435}\u{442} \u{43D}\u{430}\u{445}\u{43E}\u{434}\u{438}\u{442}\u{441}\u{44F} \u{432} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{435} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{44B}.`,
    sm: `O le aso faigaluega e le o i totonu o le faamaumauga o le paketi e amata ma faamuta ai pe o loo faaleaogaina foi le paketi.`,
    so: `Taariikhda shaqada kuma jirto taariikhaha bilowga iyo dhammaadka diiwaanka miisaaniyadda ama miisaaniyadda waa la kansalay.`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E44}\u{E21}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E20}\u{E32}\u{E22}\u{E43}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E41}\u{E25}\u{E30}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E07}\u{E1A}\u{E1B}\u{E23}\u{E30}\u{E21}\u{E32}\u{E13} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E07}\u{E1A}\u{E1B}\u{E23}\u{E30}\u{E21}\u{E32}\u{E13}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E43}\u{E19}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}`,
    ur: `\u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{628}\u{62C}\u{679} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{6D2} \u{622}\u{63A}\u{627}\u{632} \u{627}\u{648}\u{631} \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{648}\u{6BA} \u{645}\u{6CC}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2} \u{6CC}\u{627} \u{628}\u{62C}\u{679} \u{645}\u{646}\u{633}\u{648}\u{62E} \u{634}\u{62F}\u{6C1} \u{62D}\u{627}\u{644}\u{62A} \u{645}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ng\xe0y l\xe0m vi\u{1EC7}c kh\xf4ng n\u{1EB1}m trong ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u v\xe0 ng\xe0y k\u{1EBF}t th\xfac c\u{1EE7}a b\u{1EA3}n ghi ng\xe2n s\xe1ch ho\u{1EB7}c ng\xe2n s\xe1ch \u{1EDF} tr\u{1EA1}ng th\xe1i h\u{1EE7}y b\u{1ECF}.`,
    'zh-hans': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{4E0D}\u{5728}\u{9884}\u{7B97}\u{8BB0}\u{5F55}\u{7684}\u{5F00}\u{59CB}\u{548C}\u{7ED3}\u{675F}\u{65E5}\u{671F}\u{5185}\u{FF0C}\u{6216}\u{8005}\u{9884}\u{7B97}\u{5904}\u{4E8E}\u{53D6}\u{6D88}\u{72B6}\u{6001}\u{3002}`,
    'zh-hant': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{4E0D}\u{5728}\u{9810}\u{7B97}\u{8A18}\u{9304}\u{7684}\u{958B}\u{59CB}\u{8207}\u{7D50}\u{675F}\u{65E5}\u{671F}\u{5167}\u{FF0C}\u{6216}\u{662F}\u{9810}\u{7B97}\u{8655}\u{65BC}\u{53D6}\u{6D88}\u{72C0}\u{614B}\u{3002}`,
    en: `The work date is not within the budget record start and end dates or the budget is in cancelled status.`
};
const $b11db1b62d4a8f76$export$75b16899548a5feb = {
    ar: `\u{627}\u{644}\u{645}\u{64A}\u{632}\u{627}\u{646}\u{64A}\u{629} \u{63A}\u{64A}\u{631} \u{646}\u{634}\u{637}\u{629} \u{641}\u{64A} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644}`,
    de: `Budget am Arbeitstag nicht aktiv`,
    es: `Presupuesto no activo en la fecha de trabajo`,
    fa: `\u{628}\u{648}\u{62F}\u{62C}\u{647} \u{62F}\u{631} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{641}\u{639}\u{627}\u{644} \u{646}\u{6CC}\u{633}\u{62A}`,
    fil: `Hindi aktibo ang badyet sa petsa ng trabaho`,
    fr: `Budget non actif \xe0 la date de travail`,
    hi: `\u{915}\u{93E}\u{92E} \u{915}\u{940} \u{924}\u{93E}\u{930}\u{940}\u{916} \u{92A}\u{930} \u{92C}\u{91C}\u{91F} \u{938}\u{915}\u{94D}\u{930}\u{93F}\u{92F} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Bidj\xe8 pa aktif nan dat travay`,
    it: `Budget non attivo alla data di lavoro`,
    ja: `\u{4F5C}\u{696D}\u{65E5}\u{306E}\u{4E88}\u{7B97}\u{306F}\u{6709}\u{52B9}\u{3067}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{ADFC}\u{BB34}\u{C77C}\u{C5D0} \u{C608}\u{C0B0}\u{C774} \u{D65C}\u{C131}\u{D654}\u{B418}\u{C9C0} \u{C54A}\u{C74C}`,
    mww: `Nyiaj txiag tsis siv rau hnub ua hauj lwm`,
    ps: `\u{628}\u{648}\u{62F}\u{6CC}\u{62C}\u{647} \u{62F} \u{6A9}\u{627}\u{631} \u{67E}\u{647} \u{646}\u{6D0}\u{67C}\u{647} \u{641}\u{639}\u{627}\u{644}\u{647} \u{646}\u{647} \u{62F}\u{647}`,
    pt: `Or\xe7amento n\xe3o ativo na data de trabalho`,
    'pt-pt': `Or\xe7amento n\xe3o ativo na data de trabalho`,
    ru: `\u{411}\u{44E}\u{434}\u{436}\u{435}\u{442} \u{43D}\u{435} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{435}\u{43D} \u{43D}\u{430} \u{434}\u{435}\u{43D}\u{44C} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}`,
    sm: `E le o galue le paketi i le aso faigaluega`,
    so: `Miisaaniyadda ma firfircoon maalinta shaqada`,
    th: `\u{E07}\u{E1A}\u{E1B}\u{E23}\u{E30}\u{E21}\u{E32}\u{E13}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E43}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{628}\u{62C}\u{679} \u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{67E}\u{631} \u{641}\u{639}\u{627}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}`,
    vi: `Ng\xe2n s\xe1ch kh\xf4ng ho\u{1EA1}t \u{111}\u{1ED9}ng v\xe0o ng\xe0y l\xe0m vi\u{1EC7}c`,
    'zh-hans': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{9884}\u{7B97}\u{672A}\u{751F}\u{6548}`,
    'zh-hant': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{9810}\u{7B97}\u{672A}\u{751F}\u{6548}`,
    en: `Budget not active on work date`
};
const $b11db1b62d4a8f76$export$fd281b1432d4cd44 = {
    ar: `\u{64A}\u{63A}\u{637}\u{64A} \u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{642} \u{627}\u{644}\u{627}\u{642}\u{62A}\u{635}\u{627}\u{62F}\u{64A} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644}.`,
    de: `Eine Budgetaussetzung deckt den Arbeitstermin ab.`,
    es: `Una suspensi\xf3n presupuestaria cubre la fecha de trabajo.`,
    fa: `\u{62A}\u{639}\u{644}\u{6CC}\u{642} \u{628}\u{648}\u{62F}\u{62C}\u{647} \u{627}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{631}\u{627} \u{67E}\u{648}\u{634}\u{634} \u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Ang suspensyon ng badyet ay sumasaklaw sa petsa ng trabaho.`,
    fr: `Une suspension budg\xe9taire couvre la date de travail.`,
    hi: `\u{90F}\u{915} \u{92C}\u{91C}\u{91F} \u{928}\u{93F}\u{932}\u{902}\u{92C}\u{928} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{915}\u{94B} \u{915}\u{935}\u{930} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Yon sispansyon bidj\xe8 kouvri dat travay la.`,
    it: `Una sospensione di budget copre la data di lavoro.`,
    ja: `\u{4E88}\u{7B97}\u{306E}\u{4E00}\u{6642}\u{505C}\u{6B62}\u{306F}\u{4F5C}\u{696D}\u{65E5}\u{3092}\u{30AB}\u{30D0}\u{30FC}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C608}\u{C0B0} \u{C815}\u{C9C0}\u{AC00} \u{ADFC}\u{BB34}\u{C77C}\u{C744} \u{BCF4}\u{C7A5}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Ib qho kev ncua nyiaj txiag them rau hnub ua haujlwm.`,
    ps: `\u{62F} \u{628}\u{648}\u{62F}\u{6CC}\u{62C}\u{6D0} \u{62A}\u{639}\u{644}\u{6CC}\u{642} \u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6D0}\u{67C}\u{647} \u{67E}\u{648}\u{69A}\u{6CC}.`,
    pt: `Uma suspens\xe3o or\xe7ament\xe1ria cobre a data de trabalho.`,
    'pt-pt': `Uma suspens\xe3o or\xe7amental cobre a data de trabalho.`,
    ru: `\u{41F}\u{440}\u{438}\u{43E}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43A}\u{430} \u{431}\u{44E}\u{434}\u{436}\u{435}\u{442}\u{430} \u{43F}\u{43E}\u{43A}\u{440}\u{44B}\u{432}\u{430}\u{435}\u{442} \u{434}\u{430}\u{442}\u{443} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}.`,
    sm: `O le fa'amalologa o le paketi e aofia ai le aso faigaluega.`,
    so: `Joojinta miisaaniyadda waxay daboolaysaa taariikhda shaqada.`,
    th: `\u{E01}\u{E32}\u{E23}\u{E23}\u{E30}\u{E07}\u{E31}\u{E1A}\u{E07}\u{E1A}\u{E1B}\u{E23}\u{E30}\u{E21}\u{E32}\u{E13}\u{E04}\u{E23}\u{E2D}\u{E1A}\u{E04}\u{E25}\u{E38}\u{E21}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{628}\u{62C}\u{679} \u{645}\u{639}\u{637}\u{644}\u{6CC} \u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{648} \u{6A9}\u{648}\u{631} \u{6A9}\u{631}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `\u{110}\xecnh ch\u{1EC9} ng\xe2n s\xe1ch bao g\u{1ED3}m ng\xe0y l\xe0m vi\u{1EC7}c.`,
    'zh-hans': `\u{9884}\u{7B97}\u{6682}\u{505C}\u{6DB5}\u{76D6}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    'zh-hant': `\u{9810}\u{7B97}\u{66AB}\u{505C}\u{5247}\u{6DB5}\u{84CB}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    en: `A budget suspension covers the work date.`
};
const $b11db1b62d4a8f76$export$3625fea9f696da61 = {
    ar: `\u{62A}\u{645} \u{62A}\u{639}\u{644}\u{64A}\u{642} \u{627}\u{644}\u{645}\u{64A}\u{632}\u{627}\u{646}\u{64A}\u{629}`,
    de: `Haushalt ausgesetzt`,
    es: `Presupuesto suspendido`,
    fa: `\u{628}\u{648}\u{62F}\u{62C}\u{647} \u{62A}\u{639}\u{644}\u{6CC}\u{642} \u{634}\u{62F}`,
    fil: `Sinuspinde ang badyet`,
    fr: `Budget suspendu`,
    hi: `\u{92C}\u{91C}\u{91F} \u{928}\u{93F}\u{932}\u{902}\u{92C}\u{93F}\u{924}`,
    ht: `Bidj\xe8 sispann`,
    it: `Bilancio sospeso`,
    ja: `\u{4E88}\u{7B97}\u{505C}\u{6B62}`,
    ko: `\u{C608}\u{C0B0} \u{C815}\u{C9C0}`,
    mww: `Pob nyiaj tau raug tshem tawm`,
    ps: `\u{628}\u{648}\u{62F}\u{6CC}\u{62C}\u{647} \u{681}\u{646}\u{689}\u{648}\u{644} \u{634}\u{648}\u{6D0}`,
    pt: `Or\xe7amento suspenso`,
    'pt-pt': `Or\xe7amento suspenso`,
    ru: `\u{411}\u{44E}\u{434}\u{436}\u{435}\u{442} \u{43F}\u{440}\u{438}\u{43E}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}`,
    sm: `Fa'amalolo le paketi`,
    so: `Miisaaniyadda waa la hakiyay`,
    th: `\u{E07}\u{E1A}\u{E1B}\u{E23}\u{E30}\u{E21}\u{E32}\u{E13}\u{E16}\u{E39}\u{E01}\u{E23}\u{E30}\u{E07}\u{E31}\u{E1A}`,
    ur: `\u{628}\u{62C}\u{679} \u{645}\u{639}\u{637}\u{644}`,
    vi: `Ng\xe2n s\xe1ch b\u{1ECB} t\u{1EA1}m ng\u{1B0}ng`,
    'zh-hans': `\u{9884}\u{7B97}\u{6682}\u{505C}`,
    'zh-hant': `\u{9810}\u{7B97}\u{66AB}\u{505C}`,
    en: `Budget suspended`
};
const $b11db1b62d4a8f76$export$9655f0f44ea5e4b2 = {
    ar: `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{62A}\u{634}\u{63A}\u{64A}\u{644} \u{627}\u{644}\u{62A}\u{62D}\u{642}\u{642} \u{645}\u{646} \u{635}\u{62D}\u{629} \u{627}\u{644}\u{631}\u{648}\u{627}\u{62A}\u{628} \u{644}\u{623}\u{646} \u{625}\u{639}\u{62F}\u{627}\u{62F} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639} \u{627}\u{644}\u{645}\u{637}\u{644}\u{648}\u{628} \u{645}\u{641}\u{642}\u{648}\u{62F}.`,
    de: `Die Lohnabrechnungsvalidierung kann nicht durchgef\xfchrt werden, da die erforderliche Projektkonfiguration fehlt.`,
    es: `La validaci\xf3n de n\xf3minas no puede ejecutarse porque falta la configuraci\xf3n requerida del proyecto.`,
    fa: `\u{627}\u{639}\u{62A}\u{628}\u{627}\u{631}\u{633}\u{646}\u{62C}\u{6CC} \u{62D}\u{642}\u{648}\u{642} \u{648} \u{62F}\u{633}\u{62A}\u{645}\u{632}\u{62F} \u{642}\u{627}\u{628}\u{644} \u{627}\u{62C}\u{631}\u{627} \u{646}\u{6CC}\u{633}\u{62A} \u{632}\u{6CC}\u{631}\u{627} \u{67E}\u{6CC}\u{6A9}\u{631}\u{628}\u{646}\u{62F}\u{6CC} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{645}\u{648}\u{631}\u{62F} \u{646}\u{6CC}\u{627}\u{632} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `Hindi maaaring tumakbo ang pagpapatunay ng payroll dahil nawawala ang kinakailangang pagsasaayos ng proyekto.`,
    fr: `La validation de la paie ne peut pas s\u{2019}ex\xe9cuter car la configuration requise du projet manque.`,
    hi: `\u{92D}\u{941}\u{917}\u{924}\u{93E}\u{928} \u{938}\u{902}\u{92C}\u{927}\u{940} \u{92E}\u{93E}\u{928}\u{94D}\u{92F}\u{924}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{91A}\u{932} \u{938}\u{915}\u{924}\u{940} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915} \u{92A}\u{94D}\u{930}\u{94B}\u{91C}\u{947}\u{915}\u{94D}\u{91F} \u{915}\u{949}\u{928}\u{94D}\u{92B}\u{93C}\u{93F}\u{917}\u{930}\u{947}\u{936}\u{928} \u{905}\u{928}\u{941}\u{92A}\u{932}\u{92C}\u{94D}\u{927} \u{939}\u{948}\u{964}`,
    ht: `Validation pew\xf2l pa ka kouri paske konfigirasyon pwoj\xe8 mande yo manke.`,
    it: `La validazione delle buste paga non pu\xf2 essere eseguita perch\xe9 manca la configurazione richiesta del progetto.`,
    ja: `\u{5FC5}\u{8981}\u{306A}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{69CB}\u{6210}\u{304C}\u{6B20}\u{843D}\u{3057}\u{3066}\u{3044}\u{308B}\u{305F}\u{3081}\u{3001}\u{7D66}\u{4E0E}\u{691C}\u{8A3C}\u{306F}\u{5B9F}\u{884C}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{AE09}\u{C5EC} \u{AC80}\u{C99D}\u{C740} \u{D544}\u{C694}\u{D55C} \u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{AD6C}\u{C131}\u{C774} \u{C5C6}\u{C5B4} \u{C2E4}\u{D589}\u{B420} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Payroll validation tsis tuaj yeem khiav vim tias qhov yuav tsum tau teeb tsa qhov project yog ploj lawm.`,
    ps: `\u{62F} \u{645}\u{639}\u{627}\u{634} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{646}\u{634}\u{6CC} \u{686}\u{644}\u{648}\u{644} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{627}\u{693}\u{6CC}\u{646} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{646}\u{634}\u{62A}\u{647}.`,
    pt: `A valida\xe7\xe3o de folha de pagamento n\xe3o pode ser executada porque falta a configura\xe7\xe3o necess\xe1ria do projeto.`,
    'pt-pt': `A valida\xe7\xe3o de sal\xe1rios n\xe3o pode ser executada porque falta a configura\xe7\xe3o necess\xe1ria do projeto.`,
    ru: `\u{412}\u{430}\u{43B}\u{438}\u{434}\u{430}\u{446}\u{438}\u{44F} \u{437}\u{430}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43D}\u{43E}\u{439} \u{43F}\u{43B}\u{430}\u{442}\u{44B} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{430}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{43E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442} \u{43D}\u{435}\u{43E}\u{431}\u{445}\u{43E}\u{434}\u{438}\u{43C}\u{430}\u{44F} \u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{430}.`,
    sm: `E le mafai ona faagaoioia le faamaoniga o le totogi ona o loo misi le faatulagaga o le galuega faatino e manaomia.`,
    so: `Hubinta mushaharka ma socon karto sababtoo ah qaabeynta mashruuca ee loo baahan yahay waa maqan tahay.`,
    th: `\u{E01}\u{E32}\u{E23}\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E04}\u{E27}\u{E32}\u{E21}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E02}\u{E2D}\u{E07}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}\u{E40}\u{E07}\u{E34}\u{E19}\u{E40}\u{E14}\u{E37}\u{E2D}\u{E19}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E44}\u{E14}\u{E49}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E15}\u{E31}\u{E49}\u{E07}\u{E04}\u{E48}\u{E32}\u{E04}\u{E2D}\u{E19}\u{E1F}\u{E34}\u{E01}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E08}\u{E4D}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19}`,
    ur: `\u{67E}\u{6D2} \u{631}\u{648}\u{644} \u{648}\u{6CC}\u{644}\u{6CC}\u{688}\u{6CC}\u{634}\u{646} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{686}\u{644} \u{633}\u{6A9}\u{62A}\u{6CC} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{645}\u{637}\u{644}\u{648}\u{628}\u{6C1} \u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679} \u{6A9}\u{646}\u{641}\u{6CC}\u{6AF}\u{631}\u{6CC}\u{634}\u{646} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `X\xe1c th\u{1EF1}c b\u{1EA3}ng l\u{1B0}\u{1A1}ng kh\xf4ng th\u{1EC3} ch\u{1EA1}y v\xec thi\u{1EBF}u c\u{1EA5}u h\xecnh d\u{1EF1} \xe1n b\u{1EAF}t bu\u{1ED9}c.`,
    'zh-hans': `\u{5DE5}\u{8D44}\u{9A8C}\u{8BC1}\u{65E0}\u{6CD5}\u{8FD0}\u{884C}\u{FF0C}\u{56E0}\u{4E3A}\u{7F3A}\u{5C11}\u{6240}\u{9700}\u{7684}\u{9879}\u{76EE}\u{914D}\u{7F6E}\u{3002}`,
    'zh-hant': `\u{85AA}\u{8CC7}\u{9A57}\u{8B49}\u{7121}\u{6CD5}\u{57F7}\u{884C}\u{FF0C}\u{56E0}\u{70BA}\u{7F3A}\u{5C11}\u{6240}\u{9700}\u{7684}\u{5C08}\u{6848}\u{8A2D}\u{5B9A}\u{3002}`,
    en: `Payroll validation cannot run because required project configuration is missing.`
};
const $b11db1b62d4a8f76$export$9772f7646f49bde5 = {
    ar: `\u{62E}\u{637}\u{623} \u{641}\u{64A} \u{62A}\u{643}\u{648}\u{64A}\u{646} \u{627}\u{644}\u{631}\u{648}\u{627}\u{62A}\u{628}`,
    de: `Konfigurationsfehler in der Lohnabrechnung`,
    es: `Error de configuraci\xf3n de n\xf3mina`,
    fa: `\u{62E}\u{637}\u{627}\u{6CC} \u{67E}\u{6CC}\u{6A9}\u{631}\u{628}\u{646}\u{62F}\u{6CC} \u{62D}\u{642}\u{648}\u{642} \u{648} \u{62F}\u{633}\u{62A}\u{645}\u{632}\u{62F}`,
    fil: `Error sa pagsasaayos ng payroll`,
    fr: `Erreur de configuration de la paie`,
    hi: `\u{92A}\u{947}\u{930}\u{94B}\u{932} \u{915}\u{949}\u{928}\u{94D}\u{92B}\u{93C}\u{93F}\u{917}\u{930}\u{947}\u{936}\u{928} \u{924}\u{94D}\u{930}\u{941}\u{91F}\u{93F}`,
    ht: `Er\xe8 konfigirasyon pew\xf2l`,
    it: `Errore di configurazione del libro paga`,
    ja: `\u{7D66}\u{4E0E}\u{8A2D}\u{5B9A}\u{30A8}\u{30E9}\u{30FC}`,
    ko: `\u{AE09}\u{C5EC} \u{AD6C}\u{C131} \u{C624}\u{B958}`,
    mww: `Them nyiaj teeb tsa yuam kev`,
    ps: `\u{62F} \u{645}\u{639}\u{627}\u{634} \u{644}\u{6CC}\u{633}\u{62A} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{62A}\u{6D0}\u{631}\u{648}\u{62A}\u{646}\u{647}`,
    pt: `Erro de configura\xe7\xe3o da folha de pagamento`,
    'pt-pt': `Erro de configura\xe7\xe3o da folha de pagamento`,
    ru: `\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{438} \u{440}\u{430}\u{441}\u{447}\u{435}\u{442}\u{430} \u{437}\u{430}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43D}\u{43E}\u{439} \u{43F}\u{43B}\u{430}\u{442}\u{44B}`,
    sm: `Mea sese i le faatulagaga o le totogi`,
    so: `Khalad qaabeynta mushaharka`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E04}\u{E48}\u{E32}\u{E40}\u{E07}\u{E34}\u{E19}\u{E40}\u{E14}\u{E37}\u{E2D}\u{E19}`,
    ur: `\u{67E}\u{6D2} \u{631}\u{648}\u{644} \u{6A9}\u{646}\u{641}\u{6CC}\u{6AF}\u{631}\u{6CC}\u{634}\u{646} \u{6A9}\u{6CC} \u{63A}\u{644}\u{637}\u{6CC}`,
    vi: `L\u{1ED7}i c\u{1EA5}u h\xecnh b\u{1EA3}ng l\u{1B0}\u{1A1}ng`,
    'zh-hans': `\u{5DE5}\u{8D44}\u{914D}\u{7F6E}\u{9519}\u{8BEF}`,
    'zh-hant': `\u{85AA}\u{8CC7}\u{8A2D}\u{5B9A}\u{932F}\u{8AA4}`,
    en: `Payroll configuration error`
};
const $b11db1b62d4a8f76$export$7b769932442d3500 = {
    ar: `\u{647}\u{646}\u{627}\u{643} \u{62C}\u{62F}\u{648}\u{644} \u{632}\u{645}\u{646}\u{64A} \u{622}\u{62E}\u{631} \u{644}\u{646}\u{641}\u{633} \u{627}\u{644}\u{645}\u{648}\u{638}\u{641}\u{60C} \u{648}\u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644}\u{60C} \u{648}\u{641}\u{62A}\u{631}\u{629} \u{627}\u{644}\u{631}\u{627}\u{62A}\u{628}.`,
    de: `Es gibt einen weiteren Stundenzettel f\xfcr denselben Mitarbeiter, Arbeitgeber und Gehaltszeitraum.`,
    es: `Hay otra hoja de horas para el mismo empleado, empleador y periodo de pago.`,
    fa: `\u{6CC}\u{6A9} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{62F}\u{6CC}\u{6AF}\u{631} \u{628}\u{631}\u{627}\u{6CC} \u{647}\u{645}\u{627}\u{646} \u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F}\u{60C} \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627} \u{648} \u{62F}\u{648}\u{631}\u{647} \u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A} \u{648}\u{62C}\u{648}\u{62F} \u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `May isa pang timesheet para sa parehong empleyado, employer, at pay period.`,
    fr: `Il existe une autre feuille de temps pour le m\xeame employ\xe9, employeur et p\xe9riode de paie.`,
    hi: `\u{90F}\u{915} \u{939}\u{940} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940}, \u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{914}\u{930} \u{935}\u{947}\u{924}\u{928} \u{905}\u{935}\u{927}\u{93F} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{90F}\u{915} \u{914}\u{930} \u{938}\u{92E}\u{92F} \u{92A}\u{924}\u{94D}\u{930}\u{915} \u{939}\u{948}\u{964}`,
    ht: `Gen yon l\xf2t F\xe8y tan pou menm anplwaye, anplway\xe8, ak pery\xf2d peye.`,
    it: `C'\xe8 un altro foglio orario per lo stesso dipendente, datore di lavoro e periodo di paga.`,
    ja: `\u{540C}\u{3058}\u{5F93}\u{696D}\u{54E1}\u{3001}\u{96C7}\u{7528}\u{4E3B}\u{3001}\u{7D66}\u{4E0E}\u{671F}\u{9593}\u{306E}\u{5225}\u{306E}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{AC19}\u{C740} \u{C9C1}\u{C6D0}, \u{ACE0}\u{C6A9}\u{C8FC}, \u{AE09}\u{C5EC} \u{AE30}\u{AC04}\u{C5D0} \u{B300}\u{D55C} \u{B610} \u{B2E4}\u{B978} \u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C}\u{AC00} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Muaj lwm daim ntawv teev sij hawm rau tib tug neeg ua hauj lwm, tus tswv hauj lwm, thiab lub sij hawm them nyiaj.`,
    ps: `\u{62F} \u{647}\u{645}\u{627}\u{63A}\u{647} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}\u{60C} \u{6A9}\u{627}\u{631}\u{6AB}\u{645}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC}\u{60C} \u{627}\u{648} \u{62F} \u{645}\u{639}\u{627}\u{634} \u{62F}\u{648}\u{631}\u{6D0} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{628}\u{644}\u{647} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647} \u{647}\u{645} \u{634}\u{62A}\u{647}.`,
    pt: `Existe outra folha de ponto para o mesmo empregado, empregador e per\xedodo de pagamento.`,
    'pt-pt': `Existe outra folha de horas para o mesmo empregado, empregador e per\xedodo de pagamento.`,
    ru: `\u{415}\u{441}\u{442}\u{44C} \u{435}\u{449}\u{451} \u{43E}\u{434}\u{438}\u{43D} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{434}\u{43B}\u{44F} \u{442}\u{43E}\u{433}\u{43E} \u{436}\u{435} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{430}, \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{438} \u{43F}\u{43B}\u{430}\u{442}\u{451}\u{436}\u{43D}\u{43E}\u{433}\u{43E} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{430}.`,
    sm: `O loo i ai se isi pepa o taimi mo le tagata faigaluega lava lea e tasi, pule o le galuega, ma le vaitaimi o totogi.`,
    so: `Waxaa jira jadwal kale oo shaqo oo loogu talagalay isla shaqaalaha, shaqo-bixiyaha, iyo muddada mushaharka.`,
    th: `\u{E21}\u{E35}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19} \u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07} \u{E41}\u{E25}\u{E30}\u{E07}\u{E27}\u{E14}\u{E01}\u{E32}\u{E23}\u{E08}\u{E48}\u{E32}\u{E22}\u{E40}\u{E07}\u{E34}\u{E19}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E01}\u{E31}\u{E19}`,
    ur: `\u{627}\u{633}\u{6CC} \u{645}\u{644}\u{627}\u{632}\u{645}\u{60C} \u{622}\u{62C}\u{631}\u{60C} \u{627}\u{648}\u{631} \u{62A}\u{646}\u{62E}\u{648}\u{627}\u{6C1} \u{6A9}\u{6CC} \u{645}\u{62F}\u{62A} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{6CC}\u{6A9} \u{627}\u{648}\u{631} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{628}\u{6BE}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `C\xf3 m\u{1ED9}t b\u{1EA3}ng ch\u{1EA5}m c\xf4ng kh\xe1c cho c\xf9ng m\u{1ED9}t nh\xe2n vi\xean, ng\u{1B0}\u{1EDD}i s\u{1EED} d\u{1EE5}ng lao \u{111}\u{1ED9}ng v\xe0 k\u{1EF3} tr\u{1EA3} l\u{1B0}\u{1A1}ng.`,
    'zh-hans': `\u{540C}\u{4E00}\u{5458}\u{5DE5}\u{3001}\u{96C7}\u{4E3B}\u{548C}\u{5DE5}\u{8D44}\u{5468}\u{671F}\u{8FD8}\u{6709}\u{53E6}\u{4E00}\u{4EFD}\u{5DE5}\u{65F6}\u{8868}\u{3002}`,
    'zh-hant': `\u{540C}\u{4E00}\u{54E1}\u{5DE5}\u{3001}\u{96C7}\u{4E3B}\u{548C}\u{85AA}\u{8CC7}\u{671F}\u{9593}\u{9084}\u{6709}\u{53E6}\u{4E00}\u{5F35}\u{5DE5}\u{6642}\u{8868}\u{3002}`,
    en: `There is another timesheet for the same employee, employer, and pay period.`
};
const $b11db1b62d4a8f76$export$28c89f95f96f9972 = {
    ar: `\u{62C}\u{62F}\u{648}\u{644} \u{632}\u{645}\u{646}\u{64A} \u{645}\u{643}\u{631}\u{631}`,
    de: `Doppelter Stundenzettel`,
    es: `Hoja de horas duplicada`,
    fa: `\u{62C}\u{62F}\u{648}\u{644} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{62A}\u{6A9}\u{631}\u{627}\u{631}\u{6CC}`,
    fil: `Duplicate timesheet`,
    fr: `Feuille de temps dupliqu\xe9e`,
    hi: `\u{921}\u{941}\u{92A}\u{94D}\u{932}\u{93F}\u{915}\u{947}\u{91F} \u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F}`,
    ht: `F\xe8y tan kopi`,
    it: `Foglio orario duplicato`,
    ja: `\u{91CD}\u{8907}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}`,
    ko: `\u{C911}\u{BCF5} \u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C}`,
    mww: `Daim ntawv qhia sijhawm theej tawm`,
    ps: `\u{62A}\u{6A9}\u{631}\u{627}\u{631}\u{6CC} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647}`,
    pt: `Folha de ponto duplicada`,
    'pt-pt': `Folha de horas duplicada`,
    ru: `\u{414}\u{443}\u{431}\u{43B}\u{438}\u{440}\u{443}\u{44E}\u{449}\u{438}\u{439} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}`,
    sm: `Pepa o taimi faaluaina`,
    so: `Jadwalka waqtiga ee la isku dayo`,
    th: `\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}\u{E17}\u{E35}\u{E48}\u{E0B}\u{E49}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E19}`,
    ur: `\u{688}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{679} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679}`,
    vi: `B\u{1EA3}ng ch\u{1EA5}m c\xf4ng tr\xf9ng l\u{1EB7}p`,
    'zh-hans': `\u{91CD}\u{590D}\u{5DE5}\u{65F6}\u{8868}`,
    'zh-hant': `\u{91CD}\u{8907}\u{5DE5}\u{6642}\u{8868}`,
    en: `Duplicate timesheet`
};
const $b11db1b62d4a8f76$export$a81191e7f0bf0755 = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644} \u{644}\u{64A}\u{633} \u{636}\u{645}\u{646} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{628}\u{62F}\u{621} \u{648}\u{646}\u{647}\u{627}\u{64A}\u{629} \u{633}\u{62C}\u{644} \u{627}\u{644}\u{645}\u{648}\u{638}\u{641}.`,
    de: `Das Arbeitsdatum ist nicht in den Anfangs- und Enddaten der Mitarbeiter enthalten.`,
    es: `La fecha de trabajo no est\xe1 dentro de las fechas de inicio y finalizaci\xf3n del registro de empleados.`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{62F}\u{631} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{634}\u{631}\u{648}\u{639} \u{648} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{633}\u{648}\u{627}\u{628}\u{642} \u{6A9}\u{627}\u{631}\u{6A9}\u{646}\u{627}\u{646} \u{646}\u{6CC}\u{633}\u{62A}.`,
    fil: `Ang petsa ng trabaho ay wala sa loob ng mga petsa ng pagsisimula at pagtatapos ng talaan ng empleyado.`,
    fr: `La date de travail ne figure pas dans les dates de d\xe9but et de fin des dossiers des employ\xe9s.`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{914}\u{930} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{924}\u{93F}\u{925}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{947} \u{92D}\u{940}\u{924}\u{930} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{964}`,
    ht: `Dat travay la pa nan dat k\xf2mansman ak fen dosye anplwaye yo.`,
    it: `La data di lavoro non rientra nelle date di inizio e fine del registro dei dipendenti.`,
    ja: `\u{4F5C}\u{696D}\u{65E5}\u{306F}\u{5F93}\u{696D}\u{54E1}\u{8A18}\u{9332}\u{306E}\u{958B}\u{59CB}\u{65E5}\u{3068}\u{7D42}\u{4E86}\u{65E5}\u{306E}\u{4E2D}\u{306B}\u{306F}\u{542B}\u{307E}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{ADFC}\u{BB34}\u{C77C}\u{C740} \u{C9C1}\u{C6D0} \u{AE30}\u{B85D}\u{C758} \u{C2DC}\u{C791}\u{C77C}\u{ACFC} \u{C885}\u{B8CC}\u{C77C}\u{C5D0} \u{D3EC}\u{D568}\u{B418}\u{C5B4} \u{C788}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Hnub ua hauj lwm tsis nyob rau hauv cov neeg ua hauj lwm cov ntaub ntawv pib thiab hnub xaus.`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6D0}\u{67C}\u{647} \u{62F} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{648} \u{62F} \u{67E}\u{6CC}\u{644} \u{627}\u{648} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{648} \u{6A9}\u{6D0} \u{646}\u{647} \u{62F}\u{647}.`,
    pt: `A data de trabalho n\xe3o est\xe1 dentro das datas de in\xedcio e t\xe9rmino do registro do funcion\xe1rio.`,
    'pt-pt': `A data de trabalho n\xe3o est\xe1 dentro das datas de in\xedcio e fim do registo do funcion\xe1rio.`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{43D}\u{435} \u{443}\u{43A}\u{430}\u{437}\u{430}\u{43D}\u{430} \u{432} \u{434}\u{430}\u{442}\u{435} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{43E}\u{432}.`,
    sm: `O le aso faigaluega e le o i totonu o le faamaumauga o le tagata faigaluega aso amata ma aso faamutaina.`,
    so: `Taariikhda shaqada kuma jirto taariikhaha bilowga iyo dhammaadka diiwaanka shaqaalaha.`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E44}\u{E21}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E20}\u{E32}\u{E22}\u{E43}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E41}\u{E25}\u{E30}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{645}\u{644}\u{627}\u{632}\u{645}\u{6CC}\u{646} \u{6A9}\u{6D2} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{6D2} \u{622}\u{63A}\u{627}\u{632} \u{627}\u{648}\u{631} \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{648}\u{6BA} \u{645}\u{6CC}\u{6BA} \u{634}\u{627}\u{645}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ng\xe0y l\xe0m vi\u{1EC7}c kh\xf4ng n\u{1EB1}m trong ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u v\xe0 ng\xe0y k\u{1EBF}t th\xfac b\u{1EA3}n ghi nh\xe2n vi\xean.`,
    'zh-hans': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{4E0D}\u{5728}\u{5458}\u{5DE5}\u{8BB0}\u{5F55}\u{7684}\u{5F00}\u{59CB}\u{548C}\u{7ED3}\u{675F}\u{65E5}\u{671F}\u{5185}\u{3002}`,
    'zh-hant': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{4E0D}\u{5728}\u{54E1}\u{5DE5}\u{7D00}\u{9304}\u{7684}\u{958B}\u{59CB}\u{8207}\u{7D50}\u{675F}\u{65E5}\u{671F}\u{5167}\u{3002}`,
    en: `The work date is not within the employee record start and end dates.`
};
const $b11db1b62d4a8f76$export$1954f0bad3006996 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{638}\u{641} \u{63A}\u{64A}\u{631} \u{646}\u{634}\u{637} \u{641}\u{64A} \u{645}\u{648}\u{639}\u{62F} \u{627}\u{644}\u{639}\u{645}\u{644}`,
    de: `Mitarbeiter am Arbeitstag nicht aktiv`,
    es: `Empleado no activo en la fecha de trabajo`,
    fa: `\u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F} \u{62F}\u{631} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{641}\u{639}\u{627}\u{644} \u{646}\u{6CC}\u{633}\u{62A}`,
    fil: `Hindi aktibo ang empleyado sa petsa ng trabaho`,
    fr: `Employ\xe9 non actif \xe0 la date de travail`,
    hi: `\u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{92A}\u{930} \u{938}\u{915}\u{94D}\u{930}\u{93F}\u{92F} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}`,
    ht: `Anplwaye pa aktif nan dat travay`,
    it: `Dipendente non attivo durante la data di lavoro`,
    ja: `\u{52E4}\u{52D9}\u{65E5}\u{306B}\u{5F93}\u{696D}\u{54E1}\u{304C}\u{6D3B}\u{52D5}\u{3057}\u{3066}\u{3044}\u{306A}\u{3044}`,
    ko: `\u{ADFC}\u{BB34}\u{C77C}\u{C5D0} \u{D65C}\u{B3D9}\u{D558}\u{C9C0} \u{C54A}\u{C740} \u{C9C1}\u{C6D0}`,
    mww: `Tus neeg ua hauj lwm tsis ua hauj lwm rau hnub ua hauj lwm`,
    ps: `\u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{62F} \u{6A9}\u{627}\u{631} \u{67E}\u{647} \u{646}\u{6D0}\u{67C}\u{647} \u{641}\u{639}\u{627}\u{644} \u{646}\u{647} \u{62F}\u{6CC}`,
    pt: `Funcion\xe1rio n\xe3o ativo na data de trabalho`,
    'pt-pt': `Funcion\xe1rio n\xe3o ativo na data de trabalho`,
    ru: `\u{421}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A} \u{43D}\u{435} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{435}\u{43D} \u{432} \u{434}\u{435}\u{43D}\u{44C} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}`,
    sm: `E le o toaga le tagata faigaluega i le aso faigaluega`,
    so: `Shaqaale aan firfircoonayn maalinta shaqada`,
    th: `\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E44}\u{E21}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E43}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{645}\u{644}\u{627}\u{632}\u{645} \u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{67E}\u{631} \u{641}\u{639}\u{627}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Nh\xe2n vi\xean kh\xf4ng ho\u{1EA1}t \u{111}\u{1ED9}ng v\xe0o ng\xe0y l\xe0m vi\u{1EC7}c`,
    'zh-hans': `\u{5458}\u{5DE5}\u{5728}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{672A}\u{88AB}\u{6FC0}\u{6D3B}`,
    'zh-hant': `\u{54E1}\u{5DE5}\u{5728}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{672A}\u{5728}\u{8077}`,
    en: `Employee not active on work date`
};
const $b11db1b62d4a8f76$export$e6906ceb93e1a56c = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644} \u{644}\u{64A}\u{633} \u{636}\u{645}\u{646} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{628}\u{62F}\u{621} \u{648}\u{646}\u{647}\u{627}\u{64A}\u{629} \u{633}\u{62C}\u{644} \u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644}.`,
    de: `Das Arbeitsdatum ist nicht in den Anfangs- und Enddaten des Arbeitgebers enthalten.`,
    es: `La fecha de trabajo no est\xe1 dentro de las fechas de inicio y finalizaci\xf3n del registro del empleador.`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{62F}\u{631} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{634}\u{631}\u{648}\u{639} \u{648} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{633}\u{648}\u{627}\u{628}\u{642} \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627} \u{646}\u{6CC}\u{633}\u{62A}.`,
    fil: `Ang petsa ng trabaho ay wala sa loob ng mga petsa ng pagsisimula at pagtatapos ng employer record.`,
    fr: `La date de travail ne figure pas dans les dates de d\xe9but et de fin des dossiers de l\u{2019}employeur.`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{914}\u{930} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{924}\u{93F}\u{925}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{947} \u{92D}\u{940}\u{924}\u{930} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{964}`,
    ht: `Dat travay la pa nan dat k\xf2mansman ak fen dosye anplway\xe8 a.`,
    it: `La data di lavoro non rientra nelle date di inizio e fine del registro del datore di lavoro.`,
    ja: `\u{52E4}\u{52D9}\u{65E5}\u{306F}\u{96C7}\u{7528}\u{4E3B}\u{8A18}\u{9332}\u{306E}\u{958B}\u{59CB}\u{65E5}\u{3068}\u{7D42}\u{4E86}\u{65E5}\u{306E}\u{4E2D}\u{306B}\u{542B}\u{307E}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{ADFC}\u{BB34}\u{C77C}\u{C740} \u{ACE0}\u{C6A9}\u{C8FC} \u{AE30}\u{B85D}\u{C758} \u{C2DC}\u{C791}\u{C77C}\u{ACFC} \u{C885}\u{B8CC}\u{C77C}\u{C5D0} \u{D3EC}\u{D568}\u{B418}\u{C5B4} \u{C788}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Hnub ua hauj lwm tsis nyob rau hauv qhov chaw ua hauj lwm cov ntaub ntawv pib thiab xaus.`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6CC}\u{67C}\u{647} \u{62F} \u{6A9}\u{627}\u{631}\u{6AB}\u{645}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC} \u{62F} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{62F} \u{67E}\u{6CC}\u{644} \u{627}\u{648} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{648} \u{6A9}\u{6D0} \u{646}\u{647} \u{62F}\u{647}.`,
    pt: `A data de trabalho n\xe3o est\xe1 dentro do registro do empregador, datas de in\xedcio e t\xe9rmino.`,
    'pt-pt': `A data de trabalho n\xe3o est\xe1 dentro do registo do empregador, datas de in\xedcio e t\xe9rmino.`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{43D}\u{435} \u{441}\u{43E}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442} \u{434}\u{430}\u{442}\u{435} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F} \u{432} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F}.`,
    sm: `O le aso faigaluega e le o i totonu o le faamaumauga o le falefaigaluega o aso amata ma aso e faaiu ai.`,
    so: `Taariikhda shaqada kuma jirto taariikhaha bilowga iyo dhammaadka diiwaanka shaqo-bixiyaha.`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E44}\u{E21}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E20}\u{E32}\u{E22}\u{E43}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E41}\u{E25}\u{E30}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E02}\u{E2D}\u{E07}\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{622}\u{62C}\u{631} \u{6A9}\u{6D2} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{6D2} \u{622}\u{63A}\u{627}\u{632} \u{627}\u{648}\u{631} \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{648}\u{6BA} \u{645}\u{6CC}\u{6BA} \u{634}\u{627}\u{645}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ng\xe0y l\xe0m vi\u{1EC7}c kh\xf4ng n\u{1EB1}m trong ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u v\xe0 ng\xe0y k\u{1EBF}t th\xfac h\u{1ED3} s\u{1A1} c\u{1EE7}a ch\u{1EE7} lao \u{111}\u{1ED9}ng.`,
    'zh-hans': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{4E0D}\u{5728}\u{96C7}\u{4E3B}\u{8BB0}\u{5F55}\u{7684}\u{5F00}\u{59CB}\u{548C}\u{7ED3}\u{675F}\u{65E5}\u{671F}\u{5185}\u{3002}`,
    'zh-hant': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{4E0D}\u{5728}\u{96C7}\u{4E3B}\u{7D00}\u{9304}\u{7684}\u{958B}\u{59CB}\u{548C}\u{7D50}\u{675F}\u{65E5}\u{671F}\u{5167}\u{3002}`,
    en: `The work date is not within the employer record start and end dates.`
};
const $b11db1b62d4a8f76$export$2a3d22ceb400b017 = {
    ar: `\u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644} \u{63A}\u{64A}\u{631} \u{646}\u{634}\u{637} \u{641}\u{64A} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644}`,
    de: `Arbeitgeber am Arbeitstag nicht aktiv`,
    es: `El empleador no est\xe1 activo en la fecha de trabajo`,
    fa: `\u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627} \u{62F}\u{631} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{641}\u{639}\u{627}\u{644} \u{646}\u{6CC}\u{633}\u{62A}`,
    fil: `Employer hindi aktibo sa petsa ng trabaho`,
    fr: `Employeur non actif lors de la date de travail`,
    hi: `\u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{92A}\u{930} \u{938}\u{915}\u{94D}\u{930}\u{93F}\u{92F} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}`,
    ht: `Anplway\xe8 pa aktif nan dat travay`,
    it: `Datore di lavoro non attivo durante la data di lavoro`,
    ja: `\u{52E4}\u{52D9}\u{65E5}\u{306B}\u{52E4}\u{52D9}\u{3057}\u{3066}\u{3044}\u{306A}\u{3044}\u{96C7}\u{7528}\u{4E3B}`,
    ko: `\u{ADFC}\u{BB34}\u{C77C}\u{C5D0} \u{ACE0}\u{C6A9}\u{C8FC}\u{AC00} \u{D65C}\u{B3D9}\u{D558}\u{C9C0} \u{C54A}\u{C74C}`,
    mww: `Chaw ua hauj lwm tsis ua hauj lwm rau hnub ua hauj lwm`,
    ps: `\u{6A9}\u{627}\u{631}\u{6AB}\u{645}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC} \u{62F} \u{6A9}\u{627}\u{631} \u{67E}\u{647} \u{648}\u{631}\u{681} \u{641}\u{639}\u{627}\u{644} \u{646}\u{647} \u{62F}\u{6CC}`,
    pt: `Empregador n\xe3o ativo na data de trabalho`,
    'pt-pt': `Empregador n\xe3o ativo na data de trabalho`,
    ru: `\u{420}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44C} \u{43D}\u{435} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{435}\u{43D} \u{432} \u{434}\u{435}\u{43D}\u{44C} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}`,
    sm: `E le o toaga le pule o le galuega i le aso faigaluega`,
    so: `Shaqaaluhu ma firfircoon taariikhda shaqada`,
    th: `\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}\u{E44}\u{E21}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E43}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{622}\u{62C}\u{631} \u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{67E}\u{631} \u{641}\u{639}\u{627}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}`,
    vi: `Ng\u{1B0}\u{1EDD}i s\u{1EED} d\u{1EE5}ng lao \u{111}\u{1ED9}ng kh\xf4ng ho\u{1EA1}t \u{111}\u{1ED9}ng v\xe0o ng\xe0y l\xe0m vi\u{1EC7}c`,
    'zh-hans': `\u{96C7}\u{4E3B}\u{5728}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{672A}\u{5728}\u{804C}`,
    'zh-hant': `\u{96C7}\u{4E3B}\u{5728}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{672A}\u{5728}\u{8077}`,
    en: `Employer not active on work date`
};
const $b11db1b62d4a8f76$export$de68bb7834b96c76 = {
    ar: `\u{627}\u{644}\u{645}\u{635}\u{631}\u{648}\u{641}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{631}\u{627}\u{643}\u{645}\u{64A}\u{629} \u{644}\u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644} \u{644}\u{647}\u{630}\u{647} \u{627}\u{644}\u{62A}\u{641}\u{648}\u{64A}\u{636} \u{623}\u{643}\u{628}\u{631} \u{645}\u{646} \u{627}\u{644}\u{645}\u{628}\u{644}\u{63A} \u{627}\u{644}\u{645}\u{635}\u{631}\u{62D} \u{628}\u{647}.`,
    de: `Die kumulierte Arbeitgeberkosten f\xfcr diese Dienstgenehmigung sind h\xf6her als der genehmigte Betrag.`,
    es: `El gasto acumulado del empleador para esta autorizaci\xf3n de servicio es mayor que la cantidad autorizada.`,
    fa: `\u{647}\u{632}\u{6CC}\u{646}\u{647} \u{62A}\u{62C}\u{645}\u{639}\u{6CC} \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{6CC}\u{646} \u{645}\u{62C}\u{648}\u{632} \u{62E}\u{62F}\u{645}\u{627}\u{62A} \u{628}\u{6CC}\u{634}\u{62A}\u{631} \u{627}\u{632} \u{645}\u{628}\u{644}\u{63A} \u{645}\u{62C}\u{627}\u{632} \u{627}\u{633}\u{62A}.`,
    fil: `Ang pinagsama-samang gastusin ng employer para sa pahintulot sa serbisyong ito ay mas malaki kaysa sa awtorisadong halaga.`,
    fr: `La charge cumul\xe9e de l\u{2019}employeur pour cette autorisation de service est sup\xe9rieure au montant autoris\xe9.`,
    hi: `\u{907}\u{938} \u{938}\u{947}\u{935}\u{93E} \u{92A}\u{94D}\u{930}\u{93E}\u{927}\u{93F}\u{915}\u{930}\u{923} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{902}\u{91A}\u{92F}\u{940} \u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{935}\u{94D}\u{92F}\u{92F} \u{905}\u{927}\u{93F}\u{915}\u{943}\u{924} \u{930}\u{93E}\u{936}\u{93F} \u{938}\u{947} \u{905}\u{927}\u{93F}\u{915} \u{939}\u{948}\u{964}`,
    ht: `Depans anplway\xe8 kimilatif pou otorizasyon s\xe8vis sa a pi gran pase kantite lajan otorize a.`,
    it: `La spesa cumulativa del datore di lavoro per questa autorizzazione al servizio \xe8 superiore all'importo autorizzato.`,
    ja: `\u{3053}\u{306E}\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{627F}\u{8A8D}\u{306E}\u{305F}\u{3081}\u{306E}\u{96C7}\u{7528}\u{4E3B}\u{306E}\u{7D2F}\u{7A4D}\u{8CBB}\u{7528}\u{306F}\u{3001}\u{8A8D}\u{53EF}\u{3055}\u{308C}\u{305F}\u{91D1}\u{984D}\u{3092}\u{4E0A}\u{56DE}\u{3063}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{C11C}\u{BE44}\u{C2A4} \u{C2B9}\u{C778}\u{C5D0} \u{B300}\u{D55C} \u{ACE0}\u{C6A9}\u{C8FC} \u{B204}\u{C801} \u{BE44}\u{C6A9}\u{C774} \u{C2B9}\u{C778}\u{B41C} \u{AE08}\u{C561}\u{BCF4}\u{B2E4} \u{B9CE}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tus tswv hauj lwm cov nqi rau qhov kev tso cai no yog ntau tshaj qhov uas tau tso cai.`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{62E}\u{62F}\u{645}\u{62A} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62F} \u{6A9}\u{627}\u{631}\u{6AB}\u{645}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC} \u{67C}\u{648}\u{644}\u{6CC}\u{632} \u{644}\u{6AB}\u{69A}\u{62A} \u{62F} \u{645}\u{62C}\u{627}\u{632} \u{645}\u{642}\u{62F}\u{627}\u{631} \u{685}\u{62E}\u{647} \u{632}\u{6CC}\u{627}\u{62A} \u{62F}\u{6CC}.`,
    pt: `A despesa acumulada do empregador para essa autoriza\xe7\xe3o de servi\xe7o \xe9 maior do que o valor autorizado.`,
    'pt-pt': `A despesa acumulada do empregador para esta autoriza\xe7\xe3o de servi\xe7o \xe9 superior ao montante autorizado.`,
    ru: `\u{421}\u{43E}\u{432}\u{43E}\u{43A}\u{443}\u{43F}\u{43D}\u{44B}\u{435} \u{440}\u{430}\u{441}\u{445}\u{43E}\u{434}\u{44B} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{43D}\u{430} \u{44D}\u{442}\u{43E} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{435} \u{43F}\u{440}\u{435}\u{432}\u{44B}\u{448}\u{430}\u{44E}\u{442} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{451}\u{43D}\u{43D}\u{443}\u{44E} \u{441}\u{443}\u{43C}\u{43C}\u{443}.`,
    sm: `O le aofaiga o tupe faaalu a le falefaigaluega mo lenei faatagaga o le auaunaga e sili atu nai lo le aofaiga ua faatagaina.`,
    so: `Kharashka guud ee shaqo-bixiyaha ee oggolaanshaha adeeggan waa ka badan yahay qadarka la oggol yahay.`,
    th: `\u{E04}\u{E48}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E08}\u{E48}\u{E32}\u{E22}\u{E2A}\u{E30}\u{E2A}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E19}\u{E38}\u{E21}\u{E31}\u{E15}\u{E34}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}\u{E19}\u{E35}\u{E49}\u{E21}\u{E32}\u{E01}\u{E01}\u{E27}\u{E48}\u{E32}\u{E08}\u{E4D}\u{E32}\u{E19}\u{E27}\u{E19}\u{E40}\u{E07}\u{E34}\u{E19}\u{E17}\u{E35}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{648}\u{633} \u{622}\u{62A}\u{6BE}\u{648}\u{631}\u{627}\u{626}\u{632}\u{6CC}\u{634}\u{646} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{645}\u{62C}\u{645}\u{648}\u{639}\u{6CC} \u{622}\u{62C}\u{631} \u{6A9}\u{627} \u{62E}\u{631}\u{686} \u{645}\u{62C}\u{627}\u{632} \u{631}\u{642}\u{645} \u{633}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Chi ph\xed t\xedch l\u{169}y c\u{1EE7}a ng\u{1B0}\u{1EDD}i s\u{1EED} d\u{1EE5}ng lao \u{111}\u{1ED9}ng cho vi\u{1EC7}c \u{1EE7}y quy\u{1EC1}n d\u{1ECB}ch v\u{1EE5} n\xe0y l\u{1EDB}n h\u{1A1}n s\u{1ED1} ti\u{1EC1}n \u{111}\u{1B0}\u{1EE3}c \u{1EE7}y quy\u{1EC1}n.`,
    'zh-hans': `\u{96C7}\u{4E3B}\u{4E3A}\u{8BE5}\u{670D}\u{52A1}\u{6388}\u{6743}\u{6240}\u{4EA7}\u{751F}\u{7684}\u{7D2F}\u{8BA1}\u{8D39}\u{7528}\u{9AD8}\u{4E8E}\u{6388}\u{6743}\u{91D1}\u{989D}\u{3002}`,
    'zh-hant': `\u{96C7}\u{4E3B}\u{70BA}\u{6B64}\u{670D}\u{52D9}\u{6388}\u{6B0A}\u{6240}\u{652F}\u{4ED8}\u{7684}\u{7D2F}\u{7A4D}\u{8CBB}\u{7528}\u{8D85}\u{904E}\u{6838}\u{51C6}\u{91D1}\u{984D}\u{3002}`,
    en: `The cumulative employer expense for this service authorization is greater than the authorized amount.`
};
const $b11db1b62d4a8f76$export$bb88b244cbbc19c0 = {
    ar: `\u{645}\u{628}\u{644}\u{63A} \u{627}\u{644}\u{62A}\u{641}\u{648}\u{64A}\u{636} \u{627}\u{644}\u{630}\u{64A} \u{62A}\u{62C}\u{627}\u{648}\u{632}`,
    de: `Genehmigungsbetrag \xfcberschritten`,
    es: `Cantidad de autorizaci\xf3n superada`,
    fa: `\u{645}\u{628}\u{644}\u{63A} \u{645}\u{62C}\u{627}\u{632} \u{62A}\u{62C}\u{627}\u{648}\u{632} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Lumampas sa halaga ng awtorisasyon`,
    fr: `Montant d\u{2019}autorisation d\xe9pass\xe9`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{927}\u{93F}\u{915}\u{930}\u{923} \u{930}\u{93E}\u{936}\u{93F} \u{92A}\u{93E}\u{930} \u{939}\u{94B} \u{917}\u{908}`,
    ht: `Kantite otorizasyon depase`,
    it: `Somma di autorizzazione superata`,
    ja: `\u{627F}\u{8A8D}\u{91D1}\u{984D}\u{8D85}\u{904E}`,
    ko: `\u{C2B9}\u{C778} \u{AE08}\u{C561} \u{CD08}\u{ACFC}`,
    mww: `Tus nqi tso cai tshaj`,
    ps: `\u{62F} \u{627}\u{62C}\u{627}\u{632}\u{6D0} \u{627}\u{646}\u{62F}\u{627}\u{632}\u{647} \u{632}\u{6CC}\u{627}\u{62A}\u{647} \u{634}\u{648}\u{6D0}`,
    pt: `Valor da autoriza\xe7\xe3o excedido`,
    'pt-pt': `Montante de autoriza\xe7\xe3o excedido`,
    ru: `\u{421}\u{443}\u{43C}\u{43C}\u{430} \u{430}\u{432}\u{442}\u{43E}\u{440}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{43F}\u{440}\u{435}\u{432}\u{44B}\u{448}\u{435}\u{43D}\u{430}`,
    sm: `Ua silia le aofaiga o le faatagaga`,
    so: `Tirada oggolaanshuhu wuu dhaafay`,
    th: `\u{E40}\u{E01}\u{E34}\u{E19}\u{E08}\u{E4D}\u{E32}\u{E19}\u{E27}\u{E19}\u{E40}\u{E07}\u{E34}\u{E19}\u{E2D}\u{E19}\u{E38}\u{E21}\u{E31}\u{E15}\u{E34}`,
    ur: `\u{627}\u{62C}\u{627}\u{632}\u{62A} \u{6A9}\u{6CC} \u{631}\u{642}\u{645} \u{633}\u{6D2} \u{62A}\u{62C}\u{627}\u{648}\u{632} \u{6A9}\u{631} \u{6AF}\u{626}\u{6CC}`,
    vi: `V\u{1B0}\u{1EE3}t qu\xe1 s\u{1ED1} ti\u{1EC1}n \u{1EE7}y quy\u{1EC1}n`,
    'zh-hans': `\u{6388}\u{6743}\u{91D1}\u{989D}\u{8D85}\u{652F}`,
    'zh-hant': `\u{6388}\u{6B0A}\u{91D1}\u{984D}\u{8D85}\u{904E}\u{3002}`,
    en: `Authorization amount exceeded`
};
const $b11db1b62d4a8f76$export$68f3cfd64c80ba19 = {
    ar: `\u{627}\u{644}\u{645}\u{635}\u{631}\u{648}\u{641}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{631}\u{627}\u{643}\u{645}\u{64A}\u{629} \u{639}\u{644}\u{649} \u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644} \u{644}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{642}\u{635}\u{649} \u{627}\u{644}\u{645}\u{637}\u{628}\u{642} \u{623}\u{643}\u{628}\u{631} \u{645}\u{646} \u{645}\u{628}\u{644}\u{63A} \u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{639}\u{644}\u{649} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}.`,
    de: `Die kumulierten Arbeitgeberkosten f\xfcr die betreffende Obergrenze sind h\xf6her als der Obergrenzbetrag.`,
    es: `El gasto acumulado del empleador para el tope aplicable es mayor que el importe del tope salarial.`,
    fa: `\u{647}\u{632}\u{6CC}\u{646}\u{647} \u{62A}\u{62C}\u{645}\u{639}\u{6CC} \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627} \u{628}\u{631}\u{627}\u{6CC} \u{633}\u{642}\u{641} \u{642}\u{627}\u{628}\u{644} \u{627}\u{639}\u{645}\u{627}\u{644} \u{628}\u{6CC}\u{634}\u{62A}\u{631} \u{627}\u{632} \u{645}\u{628}\u{644}\u{63A} \u{633}\u{642}\u{641} \u{627}\u{633}\u{62A}.`,
    fil: `Ang pinagsama-samang gastusin ng employer para sa naaangkop na cap ay mas malaki kaysa sa halaga ng cap.`,
    fr: `La charge cumul\xe9e de l\u{2019}employeur pour le plafond applicable est sup\xe9rieure au montant du plafond.`,
    hi: `\u{932}\u{93E}\u{917}\u{942} \u{915}\u{948}\u{92A} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{902}\u{91A}\u{92F}\u{940} \u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{935}\u{94D}\u{92F}\u{92F} \u{915}\u{948}\u{92A} \u{930}\u{93E}\u{936}\u{93F} \u{938}\u{947} \u{905}\u{927}\u{93F}\u{915} \u{939}\u{948}\u{964}`,
    ht: `Depans anplway\xe8 kimilatif pou plafon aplikab la pi gran pase kantite lajan an bouchon.`,
    it: `La spesa cumulativa del datore di lavoro per il tetto applicabile \xe8 superiore all'importo del cap.`,
    ja: `\u{9069}\u{7528}\u{3055}\u{308C}\u{308B}\u{4E0A}\u{9650}\u{306E}\u{7D2F}\u{7A4D}\u{96C7}\u{7528}\u{4E3B}\u{8CBB}\u{7528}\u{306F}\u{4E0A}\u{9650}\u{984D}\u{3092}\u{4E0A}\u{56DE}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C801}\u{C6A9} \u{C0C1}\u{D55C}\u{C120}\u{C5D0} \u{B300}\u{D55C} \u{B204}\u{C801} \u{ACE0}\u{C6A9}\u{C8FC} \u{BE44}\u{C6A9}\u{C774} \u{C0C1}\u{D55C}\u{C120} \u{AE08}\u{C561}\u{BCF4}\u{B2E4} \u{D07D}\u{B2C8}\u{B2E4}.`,
    mww: `Tus nqi ntawm tus tswv hauj lwm rau qhov siv tau yog ntau dua tus nqi cap.`,
    ps: `\u{62F} \u{62A}\u{637}\u{628}\u{6CC}\u{642} \u{634}\u{648}\u{6CC} \u{62D}\u{62F} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62F} \u{6A9}\u{627}\u{631}\u{6AB}\u{645}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC} \u{67C}\u{648}\u{644}\u{6CC}\u{632} \u{644}\u{6AB}\u{69A}\u{62A} \u{62F} \u{62D}\u{62F} \u{644}\u{647} \u{62D}\u{62F} \u{685}\u{62E}\u{647} \u{632}\u{6CC}\u{627}\u{62A} \u{62F}\u{6CC}.`,
    pt: `A despesa acumulada do empregador para o teto aplic\xe1vel \xe9 maior que o valor do teto.`,
    'pt-pt': `A despesa acumulada do empregador para o limite aplic\xe1vel \xe9 superior ao montante do teto.`,
    ru: `\u{421}\u{43E}\u{432}\u{43E}\u{43A}\u{443}\u{43F}\u{43D}\u{44B}\u{435} \u{440}\u{430}\u{441}\u{445}\u{43E}\u{434}\u{44B} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{43F}\u{43E} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{43C}\u{43E}\u{43C}\u{443} \u{43B}\u{438}\u{43C}\u{438}\u{442}\u{443} \u{43F}\u{440}\u{435}\u{432}\u{44B}\u{448}\u{430}\u{44E}\u{442} \u{441}\u{443}\u{43C}\u{43C}\u{443} \u{43F}\u{43E}\u{442}\u{43E}\u{43B}\u{43A}\u{430}.`,
    sm: `O le aofaiga o tupe faaalu a le falefaigaluega mo le tapulaa e faatatau i ai e sili atu nai lo le aofaiga o le tapulaa.`,
    so: `Kharashka guud ee shaqo-bixiyaha ee xadka la khuseeyo waa ka badan yahay xadka.`,
    th: `\u{E04}\u{E48}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E08}\u{E48}\u{E32}\u{E22}\u{E2A}\u{E30}\u{E2A}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E40}\u{E1E}\u{E14}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E32}\u{E01}\u{E01}\u{E27}\u{E48}\u{E32}\u{E08}\u{E4D}\u{E32}\u{E19}\u{E27}\u{E19}\u{E40}\u{E07}\u{E34}\u{E19}\u{E2A}\u{E39}\u{E07}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{642}\u{627}\u{628}\u{644} \u{627}\u{637}\u{644}\u{627}\u{642} \u{62D}\u{62F} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{645}\u{62C}\u{645}\u{648}\u{639}\u{6CC} \u{622}\u{62C}\u{631} \u{6A9}\u{627} \u{62E}\u{631}\u{686} \u{6A9}\u{6CC}\u{67E} \u{6A9}\u{6CC} \u{631}\u{642}\u{645} \u{633}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{6C1}\u{648}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Chi ph\xed t\xedch l\u{169}y c\u{1EE7}a ch\u{1EE7} lao \u{111}\u{1ED9}ng cho gi\u{1EDB}i h\u{1EA1}n \xe1p d\u{1EE5}ng l\u{1EDB}n h\u{1A1}n s\u{1ED1} ti\u{1EC1}n gi\u{1EDB}i h\u{1EA1}n.`,
    'zh-hans': `\u{9002}\u{7528}\u{4E0A}\u{9650}\u{7684}\u{7D2F}\u{8BA1}\u{96C7}\u{4E3B}\u{8D39}\u{7528}\u{5927}\u{4E8E}\u{4E0A}\u{9650}\u{91D1}\u{989D}\u{3002}`,
    'zh-hant': `\u{9069}\u{7528}\u{4E0A}\u{9650}\u{7684}\u{7D2F}\u{7A4D}\u{96C7}\u{4E3B}\u{8CBB}\u{7528}\u{9AD8}\u{65BC}\u{4E0A}\u{9650}\u{91D1}\u{984D}\u{3002}`,
    en: `The cumulative employer expense for the applicable cap is greater than the cap amount.`
};
const $b11db1b62d4a8f76$export$d8166a20356d13a4 = {
    ar: `\u{645}\u{628}\u{644}\u{63A} \u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{642}\u{635}\u{649} \u{627}\u{644}\u{630}\u{64A} \u{62A}\u{645} \u{62A}\u{62C}\u{627}\u{648}\u{632}\u{647}`,
    de: `Obergrenze \xfcberschritten`,
    es: `Mayor cantidad de tope salarial`,
    fa: `\u{633}\u{642}\u{641} \u{633}\u{642}\u{641} \u{62A}\u{62C}\u{627}\u{648}\u{632} \u{634}\u{62F}\u{647}`,
    fil: `Lumampas ang halaga ng cap`,
    fr: `Montant du plafond d\xe9pass\xe9`,
    hi: `\u{915}\u{948}\u{92A} \u{930}\u{93E}\u{936}\u{93F} \u{92A}\u{93E}\u{930} \u{939}\u{94B} \u{917}\u{908}`,
    ht: `Limit kantite lajan depase`,
    it: `Somma del tetto massimo superata`,
    ja: `\u{4E0A}\u{9650}\u{984D}\u{8D85}\u{904E}`,
    ko: `\u{C0C1}\u{D55C}\u{C120} \u{CD08}\u{ACFC}`,
    mww: `Cap npaum li cas tshaj`,
    ps: `\u{62F} \u{62D}\u{62F} \u{62D}\u{62F} \u{685}\u{62E}\u{647} \u{632}\u{6CC}\u{627}\u{62A} \u{634}\u{648}\u{6CC}`,
    pt: `Valor do teto salarial ultrapassado`,
    'pt-pt': `Valor do teto salarial ultrapassado`,
    ru: `\u{421}\u{443}\u{43C}\u{43C}\u{430} \u{43F}\u{43E}\u{442}\u{43E}\u{43B}\u{43A}\u{430} \u{43F}\u{440}\u{435}\u{432}\u{44B}\u{448}\u{435}\u{43D}\u{430}`,
    sm: `O le aofaiga o le tapulaa ua sili atu`,
    so: `Xadka xadka la dhaafay`,
    th: `\u{E40}\u{E01}\u{E34}\u{E19}\u{E08}\u{E4D}\u{E32}\u{E19}\u{E27}\u{E19}\u{E2A}\u{E39}\u{E07}\u{E2A}\u{E38}\u{E14}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}`,
    ur: `\u{6A9}\u{6CC}\u{67E} \u{6A9}\u{6CC} \u{631}\u{642}\u{645} \u{633}\u{6D2} \u{62A}\u{62C}\u{627}\u{648}\u{632} \u{6A9}\u{631} \u{6AF}\u{626}\u{6CC}`,
    vi: `V\u{1B0}\u{1EE3}t qu\xe1 s\u{1ED1} ti\u{1EC1}n gi\u{1EDB}i h\u{1EA1}n`,
    'zh-hans': `\u{8D85}\u{8FC7}\u{4E0A}\u{9650}\u{91D1}\u{989D}`,
    'zh-hant': `\u{4E0A}\u{9650}\u{8D85}\u{904E}\u{4E0A}\u{9650}`,
    en: `Cap amount exceeded`
};
const $b11db1b62d4a8f76$export$9836d0c66f76d3c4 = {
    ar: `\u{648}\u{644}\u{627}\u{64A}\u{629} \u{627}\u{644}\u{639}\u{645}\u{644} \u{647}\u{64A} \u{627}\u{644}\u{625}\u{642}\u{627}\u{645}\u{629} \u{627}\u{644}\u{62F}\u{627}\u{626}\u{645}\u{629} \u{623}\u{648} \u{627}\u{644}\u{631}\u{642}\u{645} \u{627}\u{644}\u{633}\u{627}\u{62F}\u{633}\u{60C} \u{648}\u{639}\u{645}\u{644} \u{627}\u{644}\u{645}\u{648}\u{638}\u{641} \u{623}\u{643}\u{62B}\u{631} \u{645}\u{646} 8 \u{633}\u{627}\u{639}\u{627}\u{62A} \u{625}\u{62C}\u{645}\u{627}\u{644}\u{64A}\u{629} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62A}\u{627}\u{631}\u{64A}\u{62E}.`,
    de: `Der Arbeitszustand ist PR oder VI, und der Mitarbeiter arbeitete an diesem Tag insgesamt mehr als 8 Stunden.`,
    es: `El estado laboral es PR o VI, y el empleado trabaj\xf3 m\xe1s de 8 horas en total en esa fecha.`,
    fa: `\u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{6A9}\u{627}\u{631}\u{6CC} PR \u{6CC}\u{627} VI \u{627}\u{633}\u{62A} \u{648} \u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{628}\u{6CC}\u{634} \u{627}\u{632} \u{6F8} \u{633}\u{627}\u{639}\u{62A} \u{6A9}\u{627}\u{631} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Ang estado ng trabaho ay PR o VI, at ang empleyado ay nagtrabaho ng higit sa 8 kabuuang oras sa petsang ito.`,
    fr: `L\u{2019}\xc9tat de travail est PR ou VI, et l\u{2019}employ\xe9 a travaill\xe9 plus de 8 heures au total \xe0 cette date.`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{92A}\u{940}\u{906}\u{930} \u{92F}\u{93E} VI \u{939}\u{948}, \u{914}\u{930} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{928}\u{947} \u{907}\u{938} \u{924}\u{93F}\u{925}\u{93F} \u{92A}\u{930} \u{915}\u{941}\u{932} 8 \u{918}\u{902}\u{91F}\u{947} \u{938}\u{947} \u{905}\u{927}\u{93F}\u{915} \u{915}\u{93E}\u{92E} \u{915}\u{93F}\u{92F}\u{93E}\u{964}`,
    ht: `Eta travay la se PR oswa VI ak anplwaye a te travay plis pase 8 \xe8dtan total nan dat sa a.`,
    it: `Lo stato lavorativo \xe8 PR o VI, e il dipendente ha lavorato pi\xf9 di 8 ore totali in questa data.`,
    ja: `\u{52B4}\u{50CD}\u{5DDE}\u{306F}PR\u{307E}\u{305F}\u{306F}VI\u{3067}\u{3042}\u{308A}\u{3001}\u{5F93}\u{696D}\u{54E1}\u{306F}\u{3053}\u{306E}\u{65E5}\u{306B}\u{5408}\u{8A08}8\u{6642}\u{9593}\u{4EE5}\u{4E0A}\u{52E4}\u{52D9}\u{3057}\u{3066}\u{3044}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{ADFC}\u{BB34} \u{C0C1}\u{D0DC}\u{B294} PR \u{B610}\u{B294} VI\u{C774}\u{BA70}, \u{D574}\u{B2F9} \u{B0A0}\u{C9DC}\u{C5D0} \u{CD1D} 8\u{C2DC}\u{AC04} \u{C774}\u{C0C1} \u{ADFC}\u{BB34}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Lub xeev ua haujlwm yog PR lossis VI, thiab tus neeg ua haujlwm tau ua haujlwm ntau dua 8 teev tag nrho rau hnub no.`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631} \u{627}\u{6CC}\u{627}\u{644}\u{62A} PR \u{6CC}\u{627} VI \u{62F}\u{6CC}\u{60C} \u{627}\u{648} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{67E}\u{647} \u{62F}\u{6D0} \u{646}\u{6D0}\u{67C}\u{647} \u{644}\u{647} \u{6F8} \u{633}\u{627}\u{639}\u{62A}\u{648}\u{646}\u{648} \u{632}\u{6CC}\u{627}\u{62A} \u{6A9}\u{627}\u{631} \u{6A9}\u{693}\u{6CC} \u{62F}\u{6CC}.`,
    pt: `O estado de trabalho \xe9 PR ou VI, e o funcion\xe1rio trabalhou mais de 8 horas no total nessa data.`,
    'pt-pt': `O estado de trabalho \xe9 PR ou VI, e o funcion\xe1rio trabalhou mais de 8 horas no total nessa data.`,
    ru: `\u{420}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{435} \u{441}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{435} \u{2014} PR \u{438}\u{43B}\u{438} VI, \u{438} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A} \u{43E}\u{442}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{430}\u{43B} \u{431}\u{43E}\u{43B}\u{435}\u{435} 8 \u{447}\u{430}\u{441}\u{43E}\u{432} \u{432} \u{43E}\u{431}\u{449}\u{435}\u{439} \u{441}\u{43B}\u{43E}\u{436}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{43D}\u{430} \u{44D}\u{442}\u{43E}\u{442} \u{434}\u{435}\u{43D}\u{44C}.`,
    sm: `O le tulaga o le galuega o le PR po'o le VI, ma o le tagata faigaluega na galue i le sili atu i le 8 itula atoa i lenei aso.`,
    so: `Xaaladda shaqada waa PR ama VI, shaqaalahuna wuxuu shaqeeyay in ka badan 8 saacadood guud ahaan taariikhdan.`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E01}\u{E32}\u{E23}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E04}\u{E37}\u{E2D} PR \u{E2B}\u{E23}\u{E37}\u{E2D} VI \u{E41}\u{E25}\u{E30}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E23}\u{E27}\u{E21}\u{E21}\u{E32}\u{E01}\u{E01}\u{E27}\u{E48}\u{E32} 8 \u{E0A}\u{E31}\u{E48}\u{E27}\u{E42}\u{E21}\u{E07}\u{E43}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62D}\u{627}\u{644}\u{62A} PR \u{6CC}\u{627} VI \u{6C1}\u{6D2}\u{60C} \u{627}\u{648}\u{631} \u{645}\u{644}\u{627}\u{632}\u{645} \u{646}\u{6D2} \u{627}\u{633} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{648} \u{6A9}\u{644} 8 \u{6AF}\u{6BE}\u{646}\u{679}\u{6D2} \u{633}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{6A9}\u{627}\u{645} \u{6A9}\u{6CC}\u{627}\u{6D4}`,
    vi: `Tr\u{1EA1}ng th\xe1i l\xe0m vi\u{1EC7}c l\xe0 PR ho\u{1EB7}c VI v\xe0 nh\xe2n vi\xean \u{111}\xe3 l\xe0m vi\u{1EC7}c t\u{1ED5}ng c\u{1ED9}ng h\u{1A1}n 8 gi\u{1EDD} v\xe0o ng\xe0y n\xe0y.`,
    'zh-hans': `\u{5DE5}\u{4F5C}\u{72B6}\u{6001}\u{4E3A}\u{6C38}\u{4E45}\u{5C45}\u{6C11}\u{FF08}PR\u{FF09}\u{6216}\u{7B2C}\u{516D}\u{72B6}\u{6001}\u{FF08}VI\u{FF09}\u{FF0C}\u{4E14}\u{5458}\u{5DE5}\u{5728}\u{8BE5}\u{65E5}\u{671F}\u{603B}\u{5171}\u{5DE5}\u{4F5C}\u{8D85}\u{8FC7}8\u{5C0F}\u{65F6}\u{3002}`,
    'zh-hant': `\u{5DE5}\u{4F5C}\u{72C0}\u{614B}\u{70BA}\u{6C38}\u{4E45}\u{5C45}\u{6C11}\u{FF08}PR\u{FF09}\u{6216}\u{7B2C}\u{516D}\u{72C0}\u{614B}\u{FF08}VI\u{FF09}\u{FF0C}\u{4E14}\u{8A72}\u{54E1}\u{5DE5}\u{5728}\u{8A72}\u{65E5}\u{671F}\u{7E3D}\u{5171}\u{5DE5}\u{4F5C}\u{8D85}\u{904E}8\u{5C0F}\u{6642}\u{3002}`,
    en: `The work state is PR or VI, and the employee worked more than 8 total hours on this date.`
};
const $b11db1b62d4a8f76$export$745e592cfe6eaf7b = {
    ar: `\u{62A}\u{62C}\u{627}\u{648}\u{632} \u{62D}\u{62F} \u{633}\u{627}\u{639}\u{627}\u{62A} \u{627}\u{644}\u{639}\u{645}\u{644} \u{627}\u{644}\u{64A}\u{648}\u{645}\u{64A}\u{629}`,
    de: `Tagesstundenlimit \xfcberschritten`,
    es: `Se supera el l\xedmite diario de horas`,
    fa: `\u{62A}\u{62C}\u{627}\u{648}\u{632} \u{627}\u{632} \u{645}\u{62D}\u{62F}\u{648}\u{62F}\u{6CC}\u{62A} \u{633}\u{627}\u{639}\u{627}\u{62A} \u{6A9}\u{627}\u{631}\u{6CC} \u{631}\u{648}\u{632}\u{627}\u{646}\u{647}`,
    fil: `Araw-araw na limitasyon ng oras na lumampas`,
    fr: `Limite d\u{2019}heures quotidienne d\xe9pass\xe9e`,
    hi: `\u{926}\u{948}\u{928}\u{93F}\u{915} \u{918}\u{902}\u{91F}\u{947} \u{915}\u{940} \u{938}\u{940}\u{92E}\u{93E} \u{92A}\u{93E}\u{930} \u{939}\u{94B} \u{917}\u{908}`,
    ht: `Limite \xe8dtan chak jou depase`,
    it: `Limite giornaliero di ore superato`,
    ja: `1\u{65E5}\u{306E}\u{6642}\u{9593}\u{5236}\u{9650}\u{3092}\u{8D85}\u{3048}\u{307E}\u{3057}\u{305F}`,
    ko: `\u{C77C}\u{C77C} \u{C2DC}\u{AC04} \u{C81C}\u{D55C} \u{CD08}\u{ACFC}`,
    mww: `Txhua hnub teev txwv dhau`,
    ps: `\u{62F} \u{648}\u{631}\u{681}\u{646}\u{6CC} \u{633}\u{627}\u{639}\u{62A} \u{62D}\u{62F} \u{685}\u{62E}\u{647} \u{632}\u{6CC}\u{627}\u{62A} \u{634}\u{648}\u{6CC}`,
    pt: `Limite di\xe1rio de horas ultrapassado`,
    'pt-pt': `Limite di\xe1rio de horas ultrapassado`,
    ru: `\u{41F}\u{440}\u{435}\u{432}\u{44B}\u{448}\u{435}\u{43D} \u{434}\u{43D}\u{435}\u{432}\u{43D}\u{43E}\u{439} \u{447}\u{430}\u{441}\u{43E}\u{432}\u{43E}\u{439} \u{43B}\u{438}\u{43C}\u{438}\u{442}`,
    sm: `Ua silia le tapulaa o itula i aso taitasi`,
    so: `Xadka saacadda maalinlaha ah waa la dhaafay`,
    th: `\u{E40}\u{E01}\u{E34}\u{E19}\u{E02}\u{E35}\u{E14}\u{E08}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E14}\u{E0A}\u{E31}\u{E48}\u{E27}\u{E42}\u{E21}\u{E07}\u{E23}\u{E32}\u{E22}\u{E27}\u{E31}\u{E19}`,
    ur: `\u{631}\u{648}\u{632}\u{627}\u{646}\u{6C1} \u{6A9}\u{6D2} \u{6AF}\u{6BE}\u{646}\u{679}\u{6D2} \u{6A9}\u{6CC} \u{62D}\u{62F} \u{633}\u{6D2} \u{62A}\u{62C}\u{627}\u{648}\u{632}`,
    vi: `V\u{1B0}\u{1EE3}t qu\xe1 gi\u{1EDB}i h\u{1EA1}n gi\u{1EDD} h\xe0ng ng\xe0y`,
    'zh-hans': `\u{6BCF}\u{65E5}\u{5DE5}\u{4F5C}\u{65F6}\u{95F4}\u{9650}\u{5236}`,
    'zh-hant': `\u{6BCF}\u{65E5}\u{6642}\u{6578}\u{8D85}\u{904E}\u{6642}\u{6578}`,
    en: `Daily hour limit exceeded`
};
const $b11db1b62d4a8f76$export$bcd8d0edac674292 = {
    ar: `\u{645}\u{648}\u{639}\u{62F} \u{627}\u{644}\u{639}\u{645}\u{644} \u{64A}\u{635}\u{627}\u{62F}\u{641} \u{623}\u{62B}\u{646}\u{627}\u{621} \u{62F}\u{62E}\u{648}\u{644} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{634}\u{641}\u{649}\u{60C} \u{628}\u{639}\u{62F} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{648}\u{642}\u{628}\u{644} \u{627}\u{644}\u{62E}\u{631}\u{648}\u{62C}.`,
    de: `Der Arbeitstermin f\xe4llt w\xe4hrend eines Krankenhausaufenthalts, nach der Aufnahme und vor der Entlassung.`,
    es: `La fecha de trabajo se realiza durante la hospitalizaci\xf3n, despu\xe9s del ingreso y antes del alta.`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{62F}\u{631} \u{632}\u{645}\u{627}\u{646} \u{628}\u{633}\u{62A}\u{631}\u{6CC} \u{634}\u{62F}\u{646} \u{62F}\u{631} \u{628}\u{6CC}\u{645}\u{627}\u{631}\u{633}\u{62A}\u{627}\u{646}\u{60C} \u{67E}\u{633} \u{627}\u{632} \u{67E}\u{630}\u{6CC}\u{631}\u{634} \u{648} \u{642}\u{628}\u{644} \u{627}\u{632} \u{62A}\u{631}\u{62E}\u{6CC}\u{635} \u{62A}\u{639}\u{6CC}\u{6CC}\u{646} \u{645}\u{6CC} \u{634}\u{648}\u{62F}.`,
    fil: `Ang petsa ng trabaho ay bumabagsak sa panahon ng pag-ospital, pagkatapos ng pagpasok at bago ang paglabas.`,
    fr: `La date de travail tombe pendant une hospitalisation, apr\xe8s l\u{2019}admission et avant la sortie.`,
    hi: `\u{915}\u{93E}\u{92E} \u{915}\u{940} \u{924}\u{93E}\u{930}\u{940}\u{916} \u{905}\u{938}\u{94D}\u{92A}\u{924}\u{93E}\u{932} \u{92E}\u{947}\u{902} \u{92D}\u{930}\u{94D}\u{924}\u{940} \u{939}\u{94B}\u{928}\u{947} \u{915}\u{947} \u{926}\u{94C}\u{930}\u{93E}\u{928}, \u{92A}\u{94D}\u{930}\u{935}\u{947}\u{936} \u{915}\u{947} \u{92C}\u{93E}\u{926} \u{914}\u{930} \u{91B}\u{941}\u{91F}\u{94D}\u{91F}\u{940} \u{938}\u{947} \u{92A}\u{939}\u{932}\u{947} \u{906}\u{924}\u{940} \u{939}\u{948}\u{964}`,
    ht: `Dat travay la tonbe pandan yon lopital, apre admisyon ak anvan egzeyate.`,
    it: `La data di lavoro cade durante il ricovero, dopo il ricovero e prima della dimissione.`,
    ja: `\u{4F5C}\u{696D}\u{65E5}\u{306F}\u{5165}\u{9662}\u{4E2D}\u{3001}\u{5165}\u{9662}\u{5F8C}\u{3001}\u{9000}\u{9662}\u{524D}\u{306B}\u{8A72}\u{5F53}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{ADFC}\u{BB34} \u{B0A0}\u{C9DC}\u{B294} \u{C785}\u{C6D0} \u{C911}, \u{C785}\u{C6D0} \u{D6C4}, \u{D1F4}\u{C6D0} \u{C804}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Hnub ua haujlwm poob rau thaum mus pw hauv tsev kho mob, tom qab nkag mus thiab ua ntej tawm mus.`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6CC}\u{67C}\u{647} \u{62F} \u{631}\u{648}\u{63A}\u{62A}\u{648}\u{646} \u{62A}\u{647} \u{62F} \u{628}\u{633}\u{62A}\u{648} \u{67E}\u{631} \u{645}\u{647}\u{627}\u{644}\u{60C} \u{62F} \u{62F}\u{627}\u{62E}\u{644}\u{6D0}\u{62F}\u{648} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{647} \u{627}\u{648} \u{644}\u{647} \u{631}\u{62E}\u{635}\u{62A}\u{6CD} \u{645}\u{62E}\u{6A9}\u{6D0} \u{631}\u{627}\u{681}\u{6CC}.`,
    pt: `A data de trabalho ocorre durante a hospitaliza\xe7\xe3o, ap\xf3s a interna\xe7\xe3o e antes da alta.`,
    'pt-pt': `A data de trabalho ocorre durante uma hospitaliza\xe7\xe3o, ap\xf3s a admiss\xe3o e antes da alta.`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{43F}\u{440}\u{438}\u{445}\u{43E}\u{434}\u{438}\u{442}\u{441}\u{44F} \u{43D}\u{430} \u{432}\u{440}\u{435}\u{43C}\u{44F} \u{433}\u{43E}\u{441}\u{43F}\u{438}\u{442}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{43F}\u{43E}\u{441}\u{43B}\u{435} \u{433}\u{43E}\u{441}\u{43F}\u{438}\u{442}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{438} \u{434}\u{43E} \u{432}\u{44B}\u{43F}\u{438}\u{441}\u{43A}\u{438}.`,
    sm: `O le aso faigaluega e pa'\u{16B} i le taimi o le falema'i, pe a mae'a le ulufale ma a'o le'i fa'amalolo.`,
    so: `Taariikhda shaqada waxay ku beegantaa inta lagu jiro isbitaal, ka dib gelitaanka iyo ka hor inta aan la sii deyn.`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E15}\u{E23}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07}\u{E01}\u{E32}\u{E23}\u{E23}\u{E31}\u{E01}\u{E29}\u{E32}\u{E15}\u{E31}\u{E27}\u{E43}\u{E19}\u{E42}\u{E23}\u{E07}\u{E1E}\u{E22}\u{E32}\u{E1A}\u{E32}\u{E25} \u{E2B}\u{E25}\u{E31}\u{E07}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E23}\u{E31}\u{E01}\u{E29}\u{E32} \u{E41}\u{E25}\u{E30}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2D}\u{E2D}\u{E01}\u{E08}\u{E32}\u{E01}\u{E42}\u{E23}\u{E07}\u{E1E}\u{E22}\u{E32}\u{E1A}\u{E32}\u{E25}`,
    ur: `\u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6C1}\u{633}\u{67E}\u{62A}\u{627}\u{644} \u{645}\u{6CC}\u{6BA} \u{62F}\u{627}\u{62E}\u{644}\u{6D2} \u{6A9}\u{6D2} \u{62F}\u{648}\u{631}\u{627}\u{646}\u{60C} \u{62F}\u{627}\u{62E}\u{644}\u{6D2} \u{6A9}\u{6D2} \u{628}\u{639}\u{62F} \u{627}\u{648}\u{631} \u{688}\u{633}\u{686}\u{627}\u{631}\u{62C} \u{633}\u{6D2} \u{67E}\u{6C1}\u{644}\u{6D2} \u{622}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ng\xe0y l\xe0m vi\u{1EC7}c r\u{1A1}i v\xe0o th\u{1EDD}i gian nh\u{1EAD}p vi\u{1EC7}n, sau khi nh\u{1EAD}p vi\u{1EC7}n v\xe0 tr\u{1B0}\u{1EDB}c khi xu\u{1EA5}t vi\u{1EC7}n.`,
    'zh-hans': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{662F}\u{5728}\u{4F4F}\u{9662}\u{671F}\u{95F4}\u{3001}\u{5165}\u{9662}\u{540E}\u{548C}\u{51FA}\u{9662}\u{524D}\u{3002}`,
    'zh-hant': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{843D}\u{5728}\u{4F4F}\u{9662}\u{671F}\u{9593}\u{3001}\u{5165}\u{9662}\u{5F8C}\u{53CA}\u{51FA}\u{9662}\u{524D}\u{3002}`,
    en: `The work date falls during a hospitalization, after admission and before discharge.`
};
const $b11db1b62d4a8f76$export$fb30f9515bc1ef4 = {
    ar: `\u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{625}\u{644}\u{649} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{634}\u{641}\u{649}`,
    de: `Krankenhausaufenthalt`,
    es: `Hospitalizaci\xf3n`,
    fa: `\u{628}\u{633}\u{62A}\u{631}\u{6CC} \u{634}\u{62F}\u{646}`,
    fil: `Pag-ospital`,
    fr: `Hospitalisation`,
    hi: `\u{905}\u{938}\u{94D}\u{92A}\u{924}\u{93E}\u{932} \u{92E}\u{947}\u{902} \u{92D}\u{930}\u{94D}\u{924}\u{940}`,
    ht: `Hospitalisation`,
    it: `Ricovero`,
    ja: `\u{5165}\u{9662}`,
    ko: `\u{C785}\u{C6D0}`,
    mww: `Mus pw hauv tsev kho mob`,
    ps: `\u{631}\u{648}\u{63A}\u{62A}\u{648}\u{646} \u{62A}\u{647} \u{62F}\u{627}\u{62E}\u{644}\u{6D0}\u{62F}\u{644}`,
    pt: `Hospitaliza\xe7\xe3o`,
    'pt-pt': `Hospitaliza\xe7\xe3o`,
    ru: `\u{413}\u{43E}\u{441}\u{43F}\u{438}\u{442}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Falema'i`,
    so: `Isbitaal`,
    th: `\u{E01}\u{E32}\u{E23}\u{E23}\u{E31}\u{E01}\u{E29}\u{E32}\u{E43}\u{E19}\u{E42}\u{E23}\u{E07}\u{E1E}\u{E22}\u{E32}\u{E1A}\u{E32}\u{E25}`,
    ur: `\u{6C1}\u{633}\u{67E}\u{62A}\u{627}\u{644} \u{645}\u{6CC}\u{6BA} \u{62F}\u{627}\u{62E}\u{644} \u{6C1}\u{648}\u{646}\u{627}`,
    vi: `Nh\u{1EAD}p vi\u{1EC7}n`,
    'zh-hans': `\u{4F4F}\u{9662}`,
    'zh-hant': `\u{4F4F}\u{9662}`,
    en: `Hospitalization`
};
const $b11db1b62d4a8f76$export$a491ae997d51c541 = {
    ar: `\u{644}\u{627} \u{64A}\u{648}\u{62C}\u{62F} \u{646}\u{645}\u{648}\u{630}\u{62C} I-9 \u{642}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630} \u{623}\u{648} \u{645}\u{643}\u{62A}\u{645}\u{644} \u{64A}\u{63A}\u{637}\u{64A} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644}\u{60C} \u{645}\u{639} \u{627}\u{644}\u{623}\u{62E}\u{630} \u{641}\u{64A} \u{627}\u{644}\u{627}\u{639}\u{62A}\u{628}\u{627}\u{631} \u{623}\u{64A} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{645}\u{635}\u{631}\u{62D} \u{628}\u{647} \u{644}\u{644}\u{639}\u{645}\u{644} \u{62D}\u{62A}\u{649} \u{627}\u{644}\u{648}\u{635}\u{648}\u{644}.`,
    de: `Kein laufender oder abgeschlossener I-9 deckt das Arbeitsdatum ab, wobei ein bis zu arbeitendes Datum genehmigt wird.`,
    es: `Ninguna fecha de trabajo en curso o completada de la I-9 cubre la fecha de trabajo, considerando cualquier fecha autorizada para trabajar hasta la fecha de trabajo.`,
    fa: `\u{647}\u{6CC}\u{686} I-9 \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{67E}\u{6CC}\u{634}\u{631}\u{641}\u{62A} \u{6CC}\u{627} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{634}\u{62F}\u{647} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631} \u{631}\u{627} \u{67E}\u{648}\u{634}\u{634} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}\u{60C} \u{628}\u{627} \u{62F}\u{631} \u{646}\u{638}\u{631} \u{6AF}\u{631}\u{641}\u{62A}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{645}\u{62C}\u{627}\u{632} \u{628}\u{647} \u{6A9}\u{627}\u{631} \u{62A}\u{627} \u{6A9}\u{627}\u{631}.`,
    fil: `Walang in-progress o nakumpleto na I-9 na sumasaklaw sa petsa ng trabaho, isinasaalang-alang ang anumang awtorisadong-to-work-hanggang petsa.`,
    fr: `Aucun I-9 en cours ou compl\xe9t\xe9 ne couvre la date de travail, en tenant compte de toute date autoris\xe9e \xe0 travailler jusqu\u{2019}\xe0 pr\xe9sent.`,
    hi: `\u{915}\u{94B}\u{908} \u{92D}\u{940} \u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{92F}\u{93E} \u{92A}\u{942}\u{930}\u{94D}\u{923} I-9 \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{915}\u{94B} \u{915}\u{935}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}, \u{915}\u{93F}\u{938}\u{940} \u{92D}\u{940} \u{905}\u{927}\u{93F}\u{915}\u{943}\u{924}-\u{938}\u{947}-\u{915}\u{93E}\u{930}\u{94D}\u{92F}-\u{924}\u{93F}\u{925}\u{93F} \u{915}\u{94B} \u{927}\u{94D}\u{92F}\u{93E}\u{928} \u{92E}\u{947}\u{902} \u{930}\u{916}\u{924}\u{947} \u{939}\u{941}\u{90F}\u{964}`,
    ht: `Pa gen okenn nan-pwogr\xe8 oswa ranpli I-9 kouvri dat travay la, konsidere nenp\xf2t ki otorize-a-travay-jouk dat.`,
    it: `Nessun I-9 in corso o completato copre la data di lavoro, considerando qualsiasi data autorizzata a lavorare fino a quando.`,
    ja: `\u{4F5C}\u{696D}\u{4E2D}\u{307E}\u{305F}\u{306F}\u{5B8C}\u{4E86}\u{3057}\u{305F}I-9\u{306F}\u{3001}\u{627F}\u{8A8D}\u{3055}\u{308C}\u{305F}\u{4F5C}\u{696D}\u{671F}\u{9650}\u{3092}\u{8003}\u{616E}\u{3057}\u{3066}\u{305D}\u{306E}\u{4F5C}\u{696D}\u{65E5}\u{3092}\u{30AB}\u{30D0}\u{30FC}\u{3057}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C791}\u{C5C5} \u{C911}\u{C774}\u{AC70}\u{B098} \u{C644}\u{B8CC}\u{B41C} I-9\u{B294} \u{C791}\u{C5C5} \u{B0A0}\u{C9DC}\u{B97C} \u{D3EC}\u{D568}\u{D558}\u{C9C0} \u{C54A}\u{C73C}\u{BA70}, \u{C2B9}\u{C778}\u{B41C} \u{C791}\u{C5C5} \u{AC00}\u{B2A5} \u{B0A0}\u{C9DC}\u{B97C} \u{ACE0}\u{B824}\u{D560} \u{B54C}\u{B294} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj nyob rau hauv kev kawm los yog ua tiav I-9 them rau hnub ua hauj lwm, xav txog tej kev tso cai-rau-ua hauj lwm-txog rau hnub tim.`,
    ps: `\u{647}\u{6CC}\u{685} I-9 \u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6D0}\u{67C}\u{647} \u{646}\u{647} \u{67E}\u{648}\u{631}\u{647} \u{6A9}\u{648}\u{6CC} \u{627}\u{648} \u{646}\u{647} \u{647}\u{645} \u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6CC}\u{67C}\u{6D0} \u{67E}\u{648}\u{69A}\u{6CC}.`,
    pt: `Nenhum I-9 em andamento ou conclu\xeddo cobre a data de trabalho, considerando qualquer data autorizada para trabalhar at\xe9 o trabalho.`,
    'pt-pt': `Nenhum I-9 em curso ou conclu\xeddo cobre a data de trabalho, considerando qualquer data autorizada a trabalhar at\xe9 at\xe9.`,
    ru: `\u{41D}\u{438} \u{43E}\u{434}\u{438}\u{43D} \u{43D}\u{435}\u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{451}\u{43D}\u{43D}\u{44B}\u{439} \u{438}\u{43B}\u{438} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{451}\u{43D}\u{43D}\u{44B}\u{439} I-9 \u{43D}\u{435} \u{43E}\u{445}\u{432}\u{430}\u{442}\u{44B}\u{432}\u{430}\u{435}\u{442} \u{434}\u{430}\u{442}\u{443} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}, \u{443}\u{447}\u{438}\u{442}\u{44B}\u{432}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{443} \u{441} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{435}\u{43C} \u{43D}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{443} \u{434}\u{43E} \u{441}\u{440}\u{43E}\u{43A}\u{430}.`,
    sm: `E leai se I-9 o lo'o fa'aauau pe mae'a e aofia ai le aso faigaluega, mafaufau i so'o se aso fa'atagaina-e-galuega-se'ia o'o i le aso.`,
    so: `Ma jiro I-9 oo socday ama la dhammeystiray oo daboolaya taariikhda shaqada, iyadoo la tixgelinayo taariikhda la oggolaaday in la shaqeeyo.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35} I-9 \u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E04}\u{E23}\u{E2D}\u{E1A}\u{E04}\u{E25}\u{E38}\u{E21}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19} \u{E42}\u{E14}\u{E22}\u{E1E}\u{E34}\u{E08}\u{E32}\u{E23}\u{E13}\u{E32}\u{E08}\u{E32}\u{E01}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E08}\u{E19}\u{E16}\u{E36}\u{E07}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{62C}\u{627}\u{631}\u{6CC} \u{6CC}\u{627} \u{645}\u{6A9}\u{645}\u{644} \u{634}\u{62F}\u{6C1} I-9 \u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{648} \u{6A9}\u{648}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{631}\u{62A}\u{627}\u{60C} \u{62E}\u{627}\u{635} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{6A9}\u{633}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{645}\u{62C}\u{627}\u{632} \u{6A9}\u{627}\u{645} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{648} \u{645}\u{62F}\u{646}\u{638}\u{631} \u{631}\u{6A9}\u{6BE}\u{62A}\u{6D2} \u{6C1}\u{648}\u{626}\u{6D2}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 I-9 \u{111}ang ti\u{1EBF}n h\xe0nh ho\u{1EB7}c \u{111}\xe3 ho\xe0n th\xe0nh bao g\u{1ED3}m ng\xe0y l\xe0m vi\u{1EC7}c, xem x\xe9t b\u{1EA5}t k\u{1EF3} ng\xe0y n\xe0o \u{111}\u{1B0}\u{1EE3}c ph\xe9p l\xe0m vi\u{1EC7}c cho \u{111}\u{1EBF}n nay.`,
    'zh-hans': `\u{4EFB}\u{4F55}\u{6B63}\u{5728}\u{8FDB}\u{884C}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}I-9\u{8868}\u{683C}\u{90FD}\u{4E0D}\u{6DB5}\u{76D6}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{FF0C}\u{524D}\u{63D0}\u{662F}\u{4EFB}\u{4F55}\u{6388}\u{6743}\u{5DE5}\u{4F5C}\u{81F3}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    'zh-hant': `\u{4EFB}\u{4F55}\u{9032}\u{884C}\u{4E2D}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}I-9\u{8868}\u{683C}\u{90FD}\u{4E0D}\u{6DB5}\u{84CB}\u{8A72}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{FF0C}\u{8003}\u{616E}\u{4EFB}\u{4F55}\u{6388}\u{6B0A}\u{5DE5}\u{4F5C}\u{81F3}\u{65E5}\u{671F}\u{3002}`,
    en: `No in-progress or completed I-9 covers the work date, considering any authorized-to-work-until date.`
};
const $b11db1b62d4a8f76$export$cdf07e285e37da59 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{638}\u{641} \u{627}\u{644}\u{645}\u{641}\u{642}\u{648}\u{62F} I-9`,
    de: `Vermisster Mitarbeiter I-9`,
    es: `Empleado desaparecido I-9`,
    fa: `\u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F} \u{645}\u{641}\u{642}\u{648}\u{62F} \u{634}\u{62F}\u{647} I-9`,
    fil: `Nawawalang empleyado I-9`,
    fr: `Employ\xe9 disparu I-9`,
    hi: `\u{932}\u{93E}\u{92A}\u{924}\u{93E} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} I-9`,
    ht: `Anplwaye I-9 ki manke`,
    it: `Dipendente scomparso I-9`,
    ja: `\u{884C}\u{65B9}\u{4E0D}\u{660E}\u{306E}\u{5F93}\u{696D}\u{54E1}I-9`,
    ko: `\u{C2E4}\u{C885}\u{B41C} \u{C9C1}\u{C6D0} I-9`,
    mww: `Tus neeg ua hauj lwm uas ploj lawm I-9`,
    ps: `\u{648}\u{631}\u{6A9} \u{634}\u{648}\u{6CC} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} I-9`,
    pt: `Funcion\xe1rio desaparecido I-9`,
    'pt-pt': `Funcion\xe1rio desaparecido I-9`,
    ru: `\u{41F}\u{440}\u{43E}\u{43F}\u{430}\u{432}\u{448}\u{438}\u{439} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A} I-9`,
    sm: `Tagata faigaluega o lo'o misi I-9`,
    so: `Shaqaale maqan I-9`,
    th: `I-9 \u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E2B}\u{E32}\u{E22}\u{E44}\u{E1B}`,
    ur: `\u{6AF}\u{645}\u{634}\u{62F}\u{6C1} \u{645}\u{644}\u{627}\u{632}\u{645} I-9`,
    vi: `Nh\xe2n vi\xean I-9 m\u{1EA5}t t\xedch`,
    'zh-hans': `\u{5931}\u{8E2A}\u{5458}\u{5DE5}I-9`,
    'zh-hant': `\u{5931}\u{8E64}\u{54E1}\u{5DE5}I-9`,
    en: `Missing employee I-9`
};
const $b11db1b62d4a8f76$export$79e620c74a68a959 = {
    ar: `\u{644}\u{627} \u{64A}\u{63A}\u{637}\u{64A} \u{623}\u{64A} \u{645}\u{639}\u{62F}\u{644} \u{623}\u{62C}\u{631} \u{644}\u{644}\u{645}\u{648}\u{638}\u{641} \u{642}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630} \u{623}\u{648} \u{625}\u{643}\u{645}\u{627}\u{644} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644}.`,
    de: `Kein laufender oder abgeschlossener Mitarbeiterlohn deckt den Arbeitstermin ab.`,
    es: `Ninguna tasa salarial en curso o completada cubre la fecha de trabajo.`,
    fa: `\u{647}\u{6CC}\u{686} \u{646}\u{631}\u{62E} \u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{67E}\u{6CC}\u{634}\u{631}\u{641}\u{62A} \u{6CC}\u{627} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{634}\u{62F}\u{647} \u{627}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{6A9}\u{627}\u{631}\u{6A9}\u{646}\u{627}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{631}\u{627} \u{67E}\u{648}\u{634}\u{634} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Walang in-progress o nakumpleto na rate ng suweldo ng empleyado na sumasaklaw sa petsa ng trabaho.`,
    fr: `Aucun taux de r\xe9mun\xe9ration en cours ou termin\xe9 ne couvre la date de travail.`,
    hi: `\u{915}\u{94B}\u{908} \u{92D}\u{940} \u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{92F}\u{93E} \u{92A}\u{942}\u{930}\u{94D}\u{923} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{935}\u{947}\u{924}\u{928} \u{926}\u{930} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{915}\u{94B} \u{915}\u{935}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{930}\u{924}\u{940} \u{939}\u{948}\u{964}`,
    ht: `Pa gen yon pousantaj nan sal\xe8 anplwaye ki an pwogr\xe8 oswa ranpli ki kouvri dat travay la.`,
    it: `Nessuna tariffa salariale in corso o completata copre la data di lavoro.`,
    ja: `\u{9032}\u{884C}\u{4E2D}\u{306E}\u{7D66}\u{4E0E}\u{3084}\u{5B8C}\u{4E86}\u{3057}\u{305F}\u{5F93}\u{696D}\u{54E1}\u{306E}\u{7D66}\u{4E0E}\u{306F}\u{3001}\u{305D}\u{306E}\u{4F5C}\u{696D}\u{65E5}\u{3092}\u{30AB}\u{30D0}\u{30FC}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C9C4}\u{D589} \u{C911}\u{C774}\u{AC70}\u{B098} \u{C644}\u{B8CC}\u{B41C} \u{C9C1}\u{C6D0} \u{AE09}\u{C5EC} \u{C694}\u{C728}\u{C740} \u{ADFC}\u{BB34}\u{C77C}\u{C744} \u{D3EC}\u{D568}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj tus nqi them rau cov neeg ua hauj lwm tiav los yog ua tiav them rau hnub ua hauj lwm.`,
    ps: `\u{647}\u{6CC}\u{685} \u{62F} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{648} \u{62F} \u{645}\u{639}\u{627}\u{634} \u{67E}\u{647} \u{62C}\u{631}\u{6CC}\u{627}\u{646} \u{6A9}\u{6D0} \u{6CC}\u{627} \u{628}\u{634}\u{67E}\u{693} \u{634}\u{648}\u{6CC} \u{646}\u{631}\u{62E} \u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6CC}\u{67C}\u{647} \u{646}\u{647} \u{67E}\u{648}\u{69A}\u{6CC}.`,
    pt: `Nenhuma taxa de remunera\xe7\xe3o em andamento ou conclu\xedda do funcion\xe1rio cobre a data de trabalho.`,
    'pt-pt': `Nenhuma taxa salarial em curso ou conclu\xedda cobre a data de trabalho.`,
    ru: `\u{41D}\u{438} \u{43E}\u{434}\u{43D}\u{430} \u{441}\u{442}\u{430}\u{432}\u{43A}\u{430} \u{43E}\u{43F}\u{43B}\u{430}\u{442}\u{44B} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{430} \u{432} \u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{435} \u{438}\u{43B}\u{438} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{438}\u{44F} \u{43D}\u{435} \u{43E}\u{445}\u{432}\u{430}\u{442}\u{44B}\u{432}\u{430}\u{435}\u{442} \u{434}\u{430}\u{442}\u{443} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}.`,
    sm: `E leai se totogi o tagata faigaluega o lo'o fa'aauau pea pe fa'amae'aina e aofia ai le aso faigaluega.`,
    so: `Ma jiro heerka mushaharka shaqaalaha ee socda ama la dhammeystiray oo daboolaya taariikhda shaqada.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E2D}\u{E31}\u{E15}\u{E23}\u{E32}\u{E04}\u{E48}\u{E32}\u{E08}\u{E49}\u{E32}\u{E07}\u{E02}\u{E2D}\u{E07}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E04}\u{E23}\u{E2D}\u{E1A}\u{E04}\u{E25}\u{E38}\u{E21}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{632}\u{6CC}\u{631} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{6CC}\u{627} \u{645}\u{6A9}\u{645}\u{644} \u{634}\u{62F}\u{6C1} \u{645}\u{644}\u{627}\u{632}\u{645} \u{6A9}\u{6CC} \u{62A}\u{646}\u{62E}\u{648}\u{627}\u{6C1} \u{627}\u{633} \u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{648} \u{6A9}\u{648}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{631}\u{62A}\u{6CC}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 m\u{1EE9}c l\u{1B0}\u{1A1}ng c\u{1EE7}a nh\xe2n vi\xean \u{111}ang ti\u{1EBF}n h\xe0nh ho\u{1EB7}c \u{111}\xe3 ho\xe0n th\xe0nh bao g\u{1ED3}m ng\xe0y l\xe0m vi\u{1EC7}c.`,
    'zh-hans': `\u{6CA1}\u{6709}\u{4EFB}\u{4F55}\u{5728}\u{5DE5}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}\u{5458}\u{5DE5}\u{5DE5}\u{8D44}\u{6807}\u{51C6}\u{8986}\u{76D6}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    'zh-hant': `\u{5728}\u{5DE5}\u{6216}\u{5B8C}\u{6210}\u{7684}\u{54E1}\u{5DE5}\u{85AA}\u{8CC7}\u{6A19}\u{6E96}\u{4E0D}\u{6DB5}\u{84CB}\u{8A72}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    en: `No in-progress or completed employee rate of pay covers the work date.`
};
const $b11db1b62d4a8f76$export$23bd41e1a2a646b1 = {
    ar: `\u{645}\u{639}\u{62F}\u{644} \u{627}\u{644}\u{631}\u{627}\u{62A}\u{628} \u{627}\u{644}\u{645}\u{641}\u{642}\u{648}\u{62F} \u{644}\u{644}\u{645}\u{648}\u{638}\u{641}`,
    de: `Verg\xfctung fehlender Mitarbeiter`,
    es: `Tarifa salarial por empleados ausentes`,
    fa: `\u{646}\u{631}\u{62E} \u{67E}\u{631}\u{62F}\u{627}\u{62E}\u{62A} \u{6A9}\u{627}\u{631}\u{6A9}\u{646}\u{627}\u{646} \u{627}\u{632} \u{62F}\u{633}\u{62A} \u{631}\u{641}\u{62A}\u{647}`,
    fil: `Nawawalang rate ng suweldo ng empleyado`,
    fr: `Taux de r\xe9mun\xe9ration des employ\xe9s absents`,
    hi: `\u{935}\u{947}\u{924}\u{928} \u{915}\u{940} \u{917}\u{941}\u{92E} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{926}\u{930}`,
    ht: `Rate sal\xe8 anplwaye ki manke`,
    it: `Tasso di retribuzione per dipendente assente`,
    ja: `\u{5F93}\u{696D}\u{54E1}\u{306E}\u{8CC3}\u{91D1}\u{7387}\u{304C}\u{898B}\u{3064}\u{304B}\u{3089}\u{306A}\u{3044}`,
    ko: `\u{C9C1}\u{C6D0} \u{AE09}\u{C5EC} \u{C694}\u{C728} \u{B204}\u{B77D}`,
    mww: `Tus nqi them nyiaj ntawm cov neeg ua haujlwm uas ploj lawm`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{648} \u{62F} \u{645}\u{639}\u{627}\u{634} \u{646}\u{647} \u{634}\u{62A}\u{648}\u{646}`,
    pt: `Taxa salarial de funcion\xe1rio ausente`,
    'pt-pt': `Taxa salarial de empregado ausente`,
    ru: `\u{41E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{430}\u{44F} \u{441}\u{442}\u{430}\u{432}\u{43A}\u{430} \u{43E}\u{43F}\u{43B}\u{430}\u{442}\u{44B} \u{442}\u{440}\u{443}\u{434}\u{430} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{430}\u{43C}`,
    sm: `O le leai o se totogi o tagata faigaluega`,
    so: `Heerka mushaharka shaqaalaha maqan`,
    th: `\u{E2D}\u{E31}\u{E15}\u{E23}\u{E32}\u{E04}\u{E48}\u{E32}\u{E08}\u{E49}\u{E32}\u{E07}\u{E02}\u{E2D}\u{E07}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E02}\u{E32}\u{E14}\u{E2B}\u{E32}\u{E22}\u{E44}\u{E1B}`,
    ur: `\u{645}\u{644}\u{627}\u{632}\u{645}\u{6CC}\u{646} \u{6A9}\u{6CC} \u{62A}\u{646}\u{62E}\u{648}\u{627}\u{6C1} \u{6A9}\u{6CC} \u{634}\u{631}\u{62D} \u{6A9}\u{6CC} \u{6A9}\u{645}\u{6CC}`,
    vi: `Thi\u{1EBF}u t\u{1EF7} l\u{1EC7} l\u{1B0}\u{1A1}ng c\u{1EE7}a nh\xe2n vi\xean`,
    'zh-hans': `\u{5458}\u{5DE5}\u{5DE5}\u{8D44}\u{7387}\u{7F3A}\u{5931}`,
    'zh-hant': `\u{7F3A}\u{5C11}\u{54E1}\u{5DE5}\u{85AA}\u{8CC7}\u{6A19}\u{6E96}`,
    en: `Missing employee rate of pay`
};
const $b11db1b62d4a8f76$export$8a8ef337597d9c1 = {
    ar: `\u{644}\u{627} \u{64A}\u{634}\u{645}\u{644} \u{623}\u{64A} \u{62A}\u{639}\u{64A}\u{64A}\u{646} \u{644}\u{644}\u{645}\u{648}\u{638}\u{641} \u{623}\u{648} \u{627}\u{644}\u{62E}\u{62F}\u{645}\u{629} \u{623}\u{648} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644}.`,
    de: `Keine Mitarbeiter-Service-Zuordnung deckt den Mitarbeiter-, Service- und Arbeitstermin ab.`,
    es: `Ninguna asignaci\xf3n de servicio al empleado cubre al empleado, el servicio y la fecha de trabajo.`,
    fa: `\u{647}\u{6CC}\u{686} \u{645}\u{623}\u{645}\u{648}\u{631}\u{6CC}\u{62A} \u{62E}\u{62F}\u{645}\u{627}\u{62A}\u{6CC} \u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F}\u{60C} \u{62E}\u{62F}\u{645}\u{62A} \u{648} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{631}\u{627} \u{67E}\u{648}\u{634}\u{634} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Walang pagtatalaga sa serbisyo ng empleyado na sumasaklaw sa empleyado, serbisyo, at petsa ng trabaho.`,
    fr: `Aucune affectation de service aux employ\xe9s ne couvre l\u{2019}employ\xe9, le service et la date de travail.`,
    hi: `\u{915}\u{94B}\u{908} \u{92D}\u{940} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940}-\u{938}\u{947}\u{935}\u{93E} \u{905}\u{938}\u{93E}\u{907}\u{928}\u{92E}\u{947}\u{902}\u{91F} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940}, \u{938}\u{947}\u{935}\u{93E} \u{914}\u{930} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{915}\u{94B} \u{915}\u{935}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Pa gen anplwaye-s\xe8vis afektasyon ki kouvri dat anplwaye, s\xe8vis ak travay.`,
    it: `Nessuna assegnazione di servizio al dipendente copre il dipendente, il servizio e la data di lavoro.`,
    ja: `\u{5F93}\u{696D}\u{54E1}\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{5272}\u{308A}\u{5F53}\u{3066}\u{306F}\u{3001}\u{5F93}\u{696D}\u{54E1}\u{3001}\u{52E4}\u{52D9}\u{3001}\u{52E4}\u{52D9}\u{65E5}\u{3092}\u{30AB}\u{30D0}\u{30FC}\u{3057}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C9C1}\u{C6D0} \u{C11C}\u{BE44}\u{C2A4} \u{D560}\u{B2F9}\u{C740} \u{C9C1}\u{C6D0}, \u{ADFC}\u{BB34} \u{AE30}\u{AC04}, \u{ADFC}\u{BB34} \u{B0A0}\u{C9DC}\u{B97C} \u{BAA8}\u{B450} \u{D3EC}\u{D568}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj ib qho kev pabcuam rau tus neeg ua haujlwm, kev pabcuam, thiab hnub ua haujlwm.`,
    ps: `\u{647}\u{6CC}\u{685} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}-\u{62E}\u{62F}\u{645}\u{62A} \u{67C}\u{627}\u{6A9}\u{646}\u{647} \u{62F} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}\u{60C} \u{62E}\u{62F}\u{645}\u{62A}\u{60C} \u{627}\u{648} \u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6CC}\u{67C}\u{647} \u{646}\u{647} \u{67E}\u{648}\u{69A}\u{6CC}.`,
    pt: `Nenhuma designa\xe7\xe3o de servi\xe7o ao funcion\xe1rio cobre o funcion\xe1rio, o servi\xe7o e a data de trabalho.`,
    'pt-pt': `Nenhuma atribui\xe7\xe3o de servi\xe7o ao empregado cobre o empregado, o servi\xe7o e a data de trabalho.`,
    ru: `\u{41D}\u{438} \u{43E}\u{434}\u{43D}\u{43E} \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{43F}\u{43E} \u{441}\u{43B}\u{443}\u{436}\u{431}\u{435} \u{43D}\u{435} \u{43E}\u{445}\u{432}\u{430}\u{442}\u{44B}\u{432}\u{430}\u{435}\u{442} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{430}, \u{441}\u{43B}\u{443}\u{436}\u{431}\u{443} \u{438} \u{434}\u{430}\u{442}\u{443} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}.`,
    sm: `E leai se tofiga o auaunaga a tagata faigaluega e aofia ai le tagata faigaluega, auaunaga, ma le aso faigaluega.`,
    so: `Shaqo shaqaale ma daboolayso taariikhda shaqaalaha, adeegga, iyo taariikhda shaqada.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E04}\u{E23}\u{E2D}\u{E1A}\u{E04}\u{E25}\u{E38}\u{E21}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19} \u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23} \u{E41}\u{E25}\u{E30}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{645}\u{644}\u{627}\u{632}\u{645}-\u{633}\u{631}\u{648}\u{633} \u{627}\u{633}\u{627}\u{626}\u{646}\u{645}\u{646}\u{679} \u{645}\u{644}\u{627}\u{632}\u{645}\u{60C} \u{633}\u{631}\u{648}\u{633} \u{627}\u{648}\u{631} \u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{648} \u{6A9}\u{648}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{631}\u{62A}\u{6CC}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 ph\xe2n c\xf4ng d\u{1ECB}ch v\u{1EE5} nh\xe2n vi\xean n\xe0o bao g\u{1ED3}m nh\xe2n vi\xean, d\u{1ECB}ch v\u{1EE5} v\xe0 ng\xe0y l\xe0m vi\u{1EC7}c.`,
    'zh-hans': `\u{6CA1}\u{6709}\u{4EFB}\u{4F55}\u{5458}\u{5DE5}\u{670D}\u{52A1}\u{4EFB}\u{52A1}\u{6DB5}\u{76D6}\u{5458}\u{5DE5}\u{3001}\u{670D}\u{52A1}\u{548C}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    'zh-hant': `\u{6C92}\u{6709}\u{4EFB}\u{4F55}\u{54E1}\u{5DE5}\u{670D}\u{52D9}\u{4EFB}\u{52D9}\u{6DB5}\u{84CB}\u{54E1}\u{5DE5}\u{3001}\u{670D}\u{52D9}\u{53CA}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    en: `No employee-service assignment covers the employee, service, and work date.`
};
const $b11db1b62d4a8f76$export$f41df784537a569d = {
    ar: `\u{62E}\u{62F}\u{645}\u{629} \u{627}\u{644}\u{645}\u{648}\u{638}\u{641}\u{64A}\u{646} \u{627}\u{644}\u{645}\u{641}\u{642}\u{648}\u{62F}\u{629}`,
    de: `Vermisste Mitarbeiterleistung`,
    es: `Servicio de empleados desaparecidos`,
    fa: `\u{63A}\u{6CC}\u{628}\u{62A} \u{62E}\u{62F}\u{645}\u{627}\u{62A} \u{6A9}\u{627}\u{631}\u{6A9}\u{646}\u{627}\u{646}`,
    fil: `Nawawalang serbisyo ng empleyado`,
    fr: `Service des employ\xe9s disparus`,
    hi: `\u{917}\u{941}\u{92E} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{938}\u{947}\u{935}\u{93E}`,
    ht: `S\xe8vis anplwaye ki manke`,
    it: `Servizio per dipendenti assenti`,
    ja: `\u{5F93}\u{696D}\u{54E1}\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{306E}\u{6B20}\u{843D}`,
    ko: `\u{C9C1}\u{C6D0} \u{C11C}\u{BE44}\u{C2A4} \u{B204}\u{B77D}`,
    mww: `Uas ploj lawm cov neeg ua hauj lwm kev pab cuam`,
    ps: `\u{62F} \u{648}\u{631}\u{6A9} \u{634}\u{648}\u{6CC} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{62E}\u{62F}\u{645}\u{62A}`,
    pt: `Servi\xe7o de funcion\xe1rios desaparecidos`,
    'pt-pt': `Servi\xe7o de funcion\xe1rios desaparecidos`,
    ru: `\u{41E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{430}\u{44F} \u{441}\u{43B}\u{443}\u{436}\u{431}\u{430} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{43E}\u{432}`,
    sm: `Auaunaga a tagata faigaluega o loo misi`,
    so: `Adeegga shaqaalaha maqan`,
    th: `\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E02}\u{E32}\u{E14}\u{E2B}\u{E32}\u{E22}\u{E44}\u{E1B}`,
    ur: `\u{6AF}\u{645}\u{634}\u{62F}\u{6C1} \u{645}\u{644}\u{627}\u{632}\u{645} \u{633}\u{631}\u{648}\u{633}`,
    vi: `Thi\u{1EBF}u d\u{1ECB}ch v\u{1EE5} nh\xe2n vi\xean`,
    'zh-hans': `\u{7F3A}\u{5931}\u{7684}\u{5458}\u{5DE5}\u{670D}\u{52A1}`,
    'zh-hant': `\u{54E1}\u{5DE5}\u{670D}\u{52D9}\u{7F3A}\u{5931}`,
    en: `Missing employee service`
};
const $b11db1b62d4a8f76$export$5ae49b98e6f0ad89 = {
    ar: `\u{644}\u{627} \u{64A}\u{648}\u{62C}\u{62F} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}\u{627}\u{62A} \u{627}\u{642}\u{62A}\u{637}\u{627}\u{639} \u{62D}\u{643}\u{648}\u{645}\u{64A}\u{629} \u{642}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630} \u{623}\u{648} \u{645}\u{643}\u{62A}\u{645}\u{644}\u{629} \u{62A}\u{63A}\u{637}\u{64A} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644} \u{645}\u{639} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{637}\u{644}\u{648}\u{628}\u{629} \u{645}\u{646} \u{627}\u{644}\u{648}\u{644}\u{627}\u{64A}\u{629}.`,
    de: `Keine laufende oder abgeschlossene staatliche Mitarbeiter-Quellenwahl deckt das Arbeitsdatum mit den erforderlichen staatlichen Informationen ab.`,
    es: `Ninguna elecci\xf3n de retenci\xf3n estatal en curso o completada cubre la fecha de trabajo con la informaci\xf3n estatal requerida.`,
    fa: `\u{647}\u{6CC}\u{686} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}\u{627}\u{62A} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{6CC}\u{627} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{634}\u{62F}\u{647} \u{6A9}\u{633}\u{631} \u{627}\u{6CC}\u{627}\u{644}\u{62A}\u{6CC} \u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F}\u{60C} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{628}\u{627} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{627}\u{6CC}\u{627}\u{644}\u{62A}\u{6CC} \u{645}\u{648}\u{631}\u{62F} \u{646}\u{6CC}\u{627}\u{632} \u{631}\u{627} \u{67E}\u{648}\u{634}\u{634} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Walang in-progress o nakumpleto na employee state withholding election na sumasaklaw sa petsa ng trabaho na may kinakailangang impormasyon ng estado.`,
    fr: `Aucune retenue d\u{2019}\xc9tat en cours ou compl\xe9t\xe9e par l\u{2019}employ\xe9 ne couvre la date de travail avec les informations requises sur l\u{2019}\xc9tat.`,
    hi: `\u{915}\u{94B}\u{908} \u{92D}\u{940} \u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{92F}\u{93E} \u{92A}\u{942}\u{930}\u{94D}\u{923} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{930}\u{93E}\u{91C}\u{94D}\u{92F} \u{91A}\u{941}\u{928}\u{93E}\u{935} \u{915}\u{94B} \u{930}\u{94B}\u{915}\u{924}\u{93E} \u{939}\u{948} \u{91C}\u{94B} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915} \u{930}\u{93E}\u{91C}\u{94D}\u{92F} \u{915}\u{940} \u{91C}\u{93E}\u{928}\u{915}\u{93E}\u{930}\u{940} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{915}\u{94B} \u{915}\u{935}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Pa gen okenn eleksyon ki f\xe8t an pwogr\xe8 oswa ki ranpli leta anplwaye kouvri dat travay la ak enf\xf2masyon leta yo mande yo.`,
    it: `Nessuna elezione di ritenzione statale in corso o completata copre la data di lavoro con le informazioni statali richieste.`,
    ja: `\u{9032}\u{884C}\u{4E2D}\u{307E}\u{305F}\u{306F}\u{5B8C}\u{4E86}\u{3057}\u{305F}\u{5F93}\u{696D}\u{54E1}\u{306E}\u{5DDE}\u{306E}\u{5DEE}\u{3057}\u{6B62}\u{3081}\u{652F}\u{6255}\u{3044}\u{9078}\u{629E}\u{306F}\u{3001}\u{5FC5}\u{8981}\u{306A}\u{5DDE}\u{60C5}\u{5831}\u{3092}\u{542B}\u{3080}\u{4F5C}\u{696D}\u{65E5}\u{3092}\u{30AB}\u{30D0}\u{30FC}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C9C4}\u{D589} \u{C911}\u{C774}\u{AC70}\u{B098} \u{C644}\u{B8CC}\u{B41C} \u{C9C1}\u{C6D0} \u{C8FC} \u{BCF4}\u{B958} \u{C120}\u{AC70}\u{B294} \u{ADFC}\u{BB34}\u{C77C}\u{ACFC} \u{D544}\u{C694}\u{D55C} \u{C8FC} \u{C815}\u{BCF4}\u{B97C} \u{BAA8}\u{B450} \u{D3EC}\u{D568}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj kev xaiv tsa ua haujlwm tiav lossis ua tiav ntawm cov neeg ua haujlwm hauv lub xeev them rau hnub ua haujlwm nrog cov ntaub ntawv hauv lub xeev uas yuav tsum tau ua.`,
    ps: `\u{647}\u{6CC}\u{685} \u{631}\u{648}\u{627}\u{646} \u{6CC}\u{627} \u{628}\u{634}\u{67E}\u{693} \u{634}\u{648}\u{6CC} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{648} \u{627}\u{6CC}\u{627}\u{644}\u{62A} \u{62F} \u{645}\u{62E}\u{646}\u{6CC}\u{648}\u{6CC} \u{67C}\u{627}\u{6A9}\u{646}\u{6D0} \u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6CC}\u{67C}\u{647} \u{62F} \u{627}\u{693}\u{6CC}\u{646}\u{648} \u{627}\u{6CC}\u{627}\u{644}\u{62A}\u{6CC} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}\u{648} \u{633}\u{631}\u{647} \u{646}\u{647} \u{67E}\u{648}\u{69A}\u{6CC}.`,
    pt: `Nenhuma elei\xe7\xe3o de reten\xe7\xe3o estadual em andamento ou conclu\xedda cobre a data de trabalho com as informa\xe7\xf5es estaduais exigidas.`,
    'pt-pt': `Nenhuma elei\xe7\xe3o de reten\xe7\xe3o estadual em curso ou conclu\xedda cobre a data de trabalho com a informa\xe7\xe3o estadual exigida.`,
    ru: `\u{41D}\u{438} \u{43E}\u{434}\u{438}\u{43D} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439} \u{438}\u{43B}\u{438} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{451}\u{43D}\u{43D}\u{44B}\u{439} \u{432}\u{44B}\u{431}\u{43E}\u{440} \u{43F}\u{43E} \u{443}\u{434}\u{435}\u{440}\u{436}\u{430}\u{43D}\u{438}\u{44E} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{43E}\u{432} \u{43D}\u{435} \u{43E}\u{445}\u{432}\u{430}\u{442}\u{44B}\u{432}\u{430}\u{435}\u{442} \u{434}\u{430}\u{442}\u{443} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{441} \u{43D}\u{435}\u{43E}\u{431}\u{445}\u{43E}\u{434}\u{438}\u{43C}\u{43E}\u{439} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{435}\u{439} \u{448}\u{442}\u{430}\u{442}\u{430}.`,
    sm: `E leai se palota o le taofia o le setete o tagata faigaluega e aofia ai le aso faigaluega ma fa'amatalaga mana'omia a le setete.`,
    so: `Ma jiro doorasho gobol oo shaqaale oo socota ama la dhammeystiray oo daboolaya taariikhda shaqada iyadoo la adeegsanayo macluumaadka gobolka ee loo baahan yahay.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E15}\u{E31}\u{E49}\u{E07}\u{E01}\u{E32}\u{E23}\u{E2B}\u{E31}\u{E01} \u{E13} \u{E17}\u{E35}\u{E48}\u{E08}\u{E48}\u{E32}\u{E22}\u{E02}\u{E2D}\u{E07}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E04}\u{E23}\u{E2D}\u{E1A}\u{E04}\u{E25}\u{E38}\u{E21}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E14}\u{E49}\u{E27}\u{E22}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E02}\u{E2D}\u{E07}\u{E23}\u{E31}\u{E10}\u{E17}\u{E35}\u{E48}\u{E08}\u{E4D}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{62C}\u{627}\u{631}\u{6CC} \u{6CC}\u{627} \u{645}\u{6A9}\u{645}\u{644} \u{634}\u{62F}\u{6C1} \u{645}\u{644}\u{627}\u{632}\u{645} \u{631}\u{6CC}\u{627}\u{633}\u{62A}\u{6CC} \u{648}\u{62F}\u{6C1}\u{648}\u{644}\u{688}\u{646}\u{6AF} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{645}\u{637}\u{644}\u{648}\u{628}\u{6C1} \u{631}\u{6CC}\u{627}\u{633}\u{62A}\u{6CC} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{648} \u{6A9}\u{648}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{631}\u{62A}\u{627}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 cu\u{1ED9}c b\u{1EA7}u c\u{1EED} kh\u{1EA5}u l\u{1B0}u c\u{1EE7}a ti\u{1EC3}u bang nh\xe2n vi\xean \u{111}ang ti\u{1EBF}n h\xe0nh ho\u{1EB7}c \u{111}\xe3 ho\xe0n th\xe0nh bao g\u{1ED3}m ng\xe0y l\xe0m vi\u{1EC7}c v\u{1EDB}i th\xf4ng tin ti\u{1EC3}u bang b\u{1EAF}t bu\u{1ED9}c.`,
    'zh-hans': `\u{6CA1}\u{6709}\u{4EFB}\u{4F55}\u{6B63}\u{5728}\u{8FDB}\u{884C}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}\u{5458}\u{5DE5}\u{5DDE}\u{9884}\u{6263}\u{9009}\u{62E9}\u{6DB5}\u{76D6}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{53CA}\u{6240}\u{9700}\u{5DDE}\u{4FE1}\u{606F}\u{3002}`,
    'zh-hant': `\u{4EFB}\u{4F55}\u{9032}\u{884C}\u{4E2D}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}\u{54E1}\u{5DE5}\u{5DDE}\u{7D1A}\u{9810}\u{6263}\u{6C7A}\u{5B9A}\u{FF0C}\u{90FD}\u{7121}\u{6CD5}\u{6DB5}\u{84CB}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{53CA}\u{6240}\u{9700}\u{5DDE}\u{8CC7}\u{8A0A}\u{3002}`,
    en: `No in-progress or completed employee state withholding election covers the work date with the required state information.`
};
const $b11db1b62d4a8f76$export$3a9b87d6ba85255f = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{638}\u{641} \u{627}\u{644}\u{645}\u{641}\u{642}\u{648}\u{62F} \u{641}\u{64A} \u{648}\u{644}\u{627}\u{64A}\u{629} \u{62D}\u{62C}\u{628} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}\u{627}\u{62A}`,
    de: `Fehlende staatliche Wahl zur Mitarbeiterabhaltung`,
    es: `Elecci\xf3n estatal de retenci\xf3n de empleado ausente`,
    fa: `\u{627}\u{6CC}\u{627}\u{644}\u{62A} \u{627}\u{632} \u{62F}\u{633}\u{62A} \u{62F}\u{627}\u{62F}\u{646} \u{631}\u{623}\u{6CC} \u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F}\u{627}\u{646}`,
    fil: `Nawawalang empleyado estado withholding halalan`,
    fr: `Candidat \xe0 la retenue de l\u{2019}\xc9tat pour employ\xe9 manquant`,
    hi: `\u{932}\u{93E}\u{92A}\u{924}\u{93E} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{930}\u{93E}\u{91C}\u{94D}\u{92F} \u{91A}\u{941}\u{928}\u{93E}\u{935} \u{930}\u{94B}\u{915} \u{930}\u{939}\u{93E} \u{939}\u{948}`,
    ht: `Ki manke eleksyon leta anplwaye ki manke`,
    it: `Scelta di ritenzione statale per dipendenti assenti`,
    ja: `\u{5DDE}\u{306E}\u{9078}\u{51FA}\u{5DEE}\u{3057}\u{6B20}\u{3051}`,
    ko: `\u{B204}\u{B77D}\u{B41C} \u{C9C1}\u{C6D0} \u{C8FC} \u{C120}\u{AC70} \u{BCF4}\u{B958}`,
    mww: `Ploj lawm cov neeg ua hauj lwm lub xeev txiav kev xaiv tsa`,
    ps: `\u{648}\u{631}\u{6A9} \u{634}\u{648}\u{6CC} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{62F} \u{627}\u{6CC}\u{627}\u{644}\u{62A} \u{67C}\u{627}\u{6A9}\u{646}\u{6D0} \u{646}\u{647} \u{62F}\u{6CC} \u{645}\u{646}\u{639} \u{6A9}\u{693}\u{6CC}`,
    pt: `Elei\xe7\xe3o estadual de reten\xe7\xe3o de empregado ausente`,
    'pt-pt': `Elei\xe7\xe3o estadual de reten\xe7\xe3o de empregado ausente`,
    ru: `\u{41E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{438}\u{435} \u{448}\u{442}\u{430}\u{442}\u{430} \xab\u{421}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\xbb (\u{448}\u{442}\u{430}\u{442} \u{43B}\u{438}\u{448}\u{435}\u{43D}\u{438}\u{44F} \u{432}\u{44B}\u{431}\u{43E}\u{440}\u{43E}\u{432})`,
    sm: `Missing employee state withholding election`,
    so: `Doorashada shaqaalaha maqan ee gobolka`,
    th: `\u{E01}\u{E32}\u{E23}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E15}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E31}\u{E01} \u{E13} \u{E17}\u{E35}\u{E48}\u{E08}\u{E48}\u{E32}\u{E22}\u{E02}\u{E2D}\u{E07}\u{E23}\u{E31}\u{E10}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E02}\u{E32}\u{E14}\u{E2B}\u{E32}\u{E22}\u{E44}\u{E1B}`,
    ur: `\u{644}\u{627}\u{67E}\u{62A}\u{6C1} \u{645}\u{644}\u{627}\u{632}\u{645} \u{631}\u{6CC}\u{627}\u{633}\u{62A} \u{645}\u{6CC}\u{6BA} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{631}\u{648}\u{6A9} \u{631}\u{6C1}\u{627} \u{6C1}\u{6D2}`,
    vi: `B\u{1EA7}u c\u{1EED} kh\u{1EA5}u l\u{1B0}u c\u{1EE7}a ti\u{1EC3}u bang nh\xe2n vi\xean v\u{1EAF}ng m\u{1EB7}t`,
    'zh-hans': `\u{7F3A}\u{5931}\u{7684}\u{5458}\u{5DE5}\u{5DDE}\u{7EA7}\u{4FDD}\u{7559}\u{9009}\u{4E3E}`,
    'zh-hant': `\u{7F3A}\u{5C11}\u{54E1}\u{5DE5}\u{5DDE}\u{7684}\u{5DDE}\u{969B}\u{9078}\u{64C7}`,
    en: `Missing employee state withholding election`
};
const $b11db1b62d4a8f76$export$5bfe0eab9c803898 = {
    ar: `\u{644}\u{627} \u{64A}\u{63A}\u{637}\u{64A} \u{623}\u{64A} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}\u{627}\u{62A} \u{627}\u{642}\u{62A}\u{637}\u{627}\u{639} \u{641}\u{64A}\u{62F}\u{631}\u{627}\u{644}\u{64A}\u{629} \u{644}\u{644}\u{645}\u{648}\u{638}\u{641}\u{64A}\u{646} \u{642}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630} \u{623}\u{648} \u{645}\u{643}\u{62A}\u{645}\u{644}\u{629} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644}.`,
    de: `Keine laufende oder abgeschlossene bundesinterne Mitarbeiter-Abzugswahl deckt das Arbeitsdatum ab.`,
    es: `Ninguna elecci\xf3n de retenci\xf3n federal en curso o completada cubre la fecha de trabajo.`,
    fa: `\u{647}\u{6CC}\u{686} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}\u{627}\u{62A} \u{641}\u{62F}\u{631}\u{627}\u{644} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{6CC}\u{627} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{634}\u{62F}\u{647} \u{628}\u{631}\u{627}\u{6CC} \u{6A9}\u{633}\u{631} \u{645}\u{627}\u{644}\u{6CC}\u{627}\u{62A} \u{6A9}\u{627}\u{631}\u{6A9}\u{646}\u{627}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{631}\u{627} \u{67E}\u{648}\u{634}\u{634} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Walang in-progress o nakumpleto na pederal na withholding election ng empleyado na sumasaklaw sa petsa ng trabaho.`,
    fr: `Aucune retenue f\xe9d\xe9rale en cours ou termin\xe9e ne couvre la date de travail.`,
    hi: `\u{915}\u{94B}\u{908} \u{92D}\u{940} \u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{92F}\u{93E} \u{92A}\u{942}\u{930}\u{94D}\u{923} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{938}\u{902}\u{918}\u{940}\u{92F} \u{930}\u{94B}\u{915} \u{91A}\u{941}\u{928}\u{93E}\u{935} \u{915}\u{93E}\u{92E} \u{915}\u{940} \u{924}\u{93E}\u{930}\u{940}\u{916} \u{915}\u{94B} \u{915}\u{935}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Pa gen okenn eleksyon prel\xe8vman federal anplwaye ki an pwogr\xe8 oswa ki te fini pou kouvri dat travay la.`,
    it: `Nessuna elezione federale di ritenzione in corso o completata copre la data di lavoro.`,
    ja: `\u{9032}\u{884C}\u{4E2D}\u{307E}\u{305F}\u{306F}\u{5B8C}\u{4E86}\u{3057}\u{305F}\u{9023}\u{90A6}\u{5F93}\u{696D}\u{54E1}\u{306E}\u{5DEE}\u{3057}\u{6B62}\u{3081}\u{9078}\u{629E}\u{306F}\u{3001}\u{4F5C}\u{696D}\u{65E5}\u{3092}\u{30AB}\u{30D0}\u{30FC}\u{3057}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C9C4}\u{D589} \u{C911}\u{C774}\u{AC70}\u{B098} \u{C644}\u{B8CC}\u{B41C} \u{C9C1}\u{C6D0} \u{C5F0}\u{BC29} \u{C6D0}\u{CC9C}\u{C9D5}\u{C218} \u{C120}\u{D0DD}\u{C740} \u{C791}\u{C5C5} \u{B0A0}\u{C9DC}\u{B97C} \u{D3EC}\u{D568}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj kev xaiv tsa ntawm cov neeg ua haujlwm ua tiav los yog ua tiav ntawm tsoom fwv teb chaws txiav nyiaj them rau hnub ua haujlwm.`,
    ps: `\u{647}\u{6CC}\u{685} \u{62C}\u{627}\u{631}\u{6CC} \u{6CC}\u{627} \u{628}\u{634}\u{67E}\u{693} \u{634}\u{648}\u{6CC} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{648} \u{641}\u{62F}\u{631}\u{627}\u{644}\u{6CC} \u{6A9}\u{633}\u{631} \u{67C}\u{627}\u{6A9}\u{646}\u{6D0} \u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6CC}\u{67C}\u{647} \u{646}\u{647} \u{67E}\u{648}\u{69A}\u{6CC}.`,
    pt: `Nenhuma elei\xe7\xe3o federal de reten\xe7\xe3o de empregado em andamento ou conclu\xedda cobre a data de trabalho.`,
    'pt-pt': `Nenhuma elei\xe7\xe3o de reten\xe7\xe3o federal em curso ou conclu\xedda cobre a data de trabalho.`,
    ru: `\u{41D}\u{438} \u{43E}\u{434}\u{43D}\u{43E} \u{444}\u{435}\u{434}\u{435}\u{440}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435} \u{443}\u{434}\u{435}\u{440}\u{436}\u{430}\u{43D}\u{438}\u{435} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{43E}\u{432} \u{43D}\u{435} \u{43E}\u{445}\u{432}\u{430}\u{442}\u{44B}\u{432}\u{430}\u{435}\u{442} \u{434}\u{430}\u{442}\u{443} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}.`,
    sm: `E leai se palota o le taofia o tagata faigaluega a le malo e aofia ai le aso faigaluega.`,
    so: `Ma jiro doorasho shaqo oo federaal ah oo socota ama la dhammeystiray oo daboolaya taariikhda shaqada.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E15}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E31}\u{E01} \u{E13} \u{E17}\u{E35}\u{E48}\u{E08}\u{E48}\u{E32}\u{E22}\u{E02}\u{E2D}\u{E07}\u{E23}\u{E31}\u{E10}\u{E1A}\u{E32}\u{E25}\u{E01}\u{E25}\u{E32}\u{E07}\u{E02}\u{E2D}\u{E07}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E04}\u{E23}\u{E2D}\u{E1A}\u{E04}\u{E25}\u{E38}\u{E21}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{62C}\u{627}\u{631}\u{6CC} \u{6CC}\u{627} \u{645}\u{6A9}\u{645}\u{644} \u{634}\u{62F}\u{6C1} \u{645}\u{644}\u{627}\u{632}\u{645} \u{648}\u{641}\u{627}\u{642}\u{6CC} \u{648}\u{62F}\u{6C1}\u{648}\u{644}\u{688}\u{646}\u{6AF} \u{627}\u{644}\u{6CC}\u{6A9}\u{634}\u{646} \u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{648} \u{6A9}\u{648}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{631}\u{62A}\u{627}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 cu\u{1ED9}c b\u{1EA7}u c\u{1EED} kh\u{1EA5}u l\u{1B0}u li\xean bang c\u{1EE7}a nh\xe2n vi\xean \u{111}ang ti\u{1EBF}n h\xe0nh ho\u{1EB7}c \u{111}\xe3 ho\xe0n th\xe0nh bao g\u{1ED3}m ng\xe0y l\xe0m vi\u{1EC7}c.`,
    'zh-hans': `\u{6CA1}\u{6709}\u{4EFB}\u{4F55}\u{6B63}\u{5728}\u{8FDB}\u{884C}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}\u{8054}\u{90A6}\u{5458}\u{5DE5}\u{9884}\u{6263}\u{9009}\u{4E3E}\u{6DB5}\u{76D6}\u{8BE5}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    'zh-hant': `\u{6C92}\u{6709}\u{4EFB}\u{4F55}\u{9032}\u{884C}\u{4E2D}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}\u{806F}\u{90A6}\u{54E1}\u{5DE5}\u{9810}\u{6263}\u{9078}\u{8209}\u{6DB5}\u{84CB}\u{8A72}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    en: `No in-progress or completed employee federal withholding election covers the work date.`
};
const $b11db1b62d4a8f76$export$636b565f2e286c7a = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{638}\u{641} \u{627}\u{644}\u{645}\u{641}\u{642}\u{648}\u{62F} W-4`,
    de: `Vermisster Mitarbeiter W-4`,
    es: `Empleado desaparecido W-4`,
    fa: `\u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F} \u{645}\u{641}\u{642}\u{648}\u{62F} W-4`,
    fil: `Nawawalang empleyado W-4`,
    fr: `Employ\xe9 disparu W-4`,
    hi: `\u{932}\u{93E}\u{92A}\u{924}\u{93E} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} W-4`,
    ht: `Anplwaye ki manke W-4`,
    it: `Dipendente scomparso W-4`,
    ja: `\u{884C}\u{65B9}\u{4E0D}\u{660E}\u{306E}\u{5F93}\u{696D}\u{54E1}W-4`,
    ko: `\u{C2E4}\u{C885} \u{C9C1}\u{C6D0} W-4`,
    mww: `Tus neeg ua hauj lwm uas ploj lawm W-4`,
    ps: `\u{648}\u{631}\u{6A9} \u{634}\u{648}\u{6CC} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} W-4`,
    pt: `Funcion\xe1rio desaparecido W-4`,
    'pt-pt': `Funcion\xe1rio desaparecido W-4`,
    ru: `\u{41F}\u{440}\u{43E}\u{43F}\u{430}\u{432}\u{448}\u{438}\u{439} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A} W-4`,
    sm: `Tagata faigaluega W-4 o lo'o misi`,
    so: `Shaqaale maqan W-4`,
    th: `\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E2B}\u{E32}\u{E22}\u{E44}\u{E1B} W-4`,
    ur: `\u{6AF}\u{645}\u{634}\u{62F}\u{6C1} \u{645}\u{644}\u{627}\u{632}\u{645} W-4`,
    vi: `Nh\xe2n vi\xean m\u{1EA5}t t\xedch W-4`,
    'zh-hans': `\u{5931}\u{8E2A}\u{5458}\u{5DE5}W-4\u{8868}\u{683C}`,
    'zh-hant': `\u{5931}\u{8E64}\u{54E1}\u{5DE5}W-4\u{8868}\u{683C}`,
    en: `Missing employee W-4`
};
const $b11db1b62d4a8f76$export$3e8f09c9e0d9f845 = {
    ar: `\u{644}\u{627} \u{64A}\u{648}\u{62C}\u{62F} \u{62A}\u{62D}\u{642}\u{642} \u{645}\u{643}\u{62A}\u{645}\u{644} \u{645}\u{646} \u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644} \u{623}\u{648} \u{627}\u{644}\u{62A}\u{62D}\u{642}\u{642} \u{645}\u{646} \u{631}\u{642}\u{645} \u{62A}\u{639}\u{631}\u{64A}\u{641} \u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644} \u{64A}\u{63A}\u{637}\u{64A} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644}.`,
    de: `Keine laufende oder abgeschlossene Arbeitgeber-EIN-Verifizierung deckt das Arbeitsdatum ab.`,
    es: `No hay verificaci\xf3n EIN del empleador en proceso o completada que cubra la fecha de trabajo.`,
    fa: `\u{647}\u{6CC}\u{686} \u{62A}\u{623}\u{6CC}\u{6CC}\u{62F}\u{6CC}\u{647} EIN \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{6CC}\u{627} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{634}\u{62F}\u{647} \u{62A}\u{648}\u{633}\u{637} \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{631}\u{627} \u{67E}\u{648}\u{634}\u{634} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Walang in-progress o nakumpleto na pag-verify ng EIN ng employer na sumasaklaw sa petsa ng trabaho.`,
    fr: `Aucune v\xe9rification EIN en cours ou compl\xe8te de l\u{2019}employeur ne couvre la date de travail.`,
    hi: `\u{915}\u{94B}\u{908} \u{92D}\u{940} \u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{92F}\u{93E} \u{92A}\u{942}\u{930}\u{94D}\u{923} \u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{908}\u{906}\u{908}\u{90F}\u{928} \u{938}\u{924}\u{94D}\u{92F}\u{93E}\u{92A}\u{928} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{915}\u{94B} \u{915}\u{935}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Pa gen okenn verifikasyon EIN anplway\xe8 ki an f\xe8t oswa ki te ranpli ki kouvri dat travay la.`,
    it: `Nessuna verifica EIN in corso o completata dal datore di lavoro copre la data di lavoro.`,
    ja: `\u{9032}\u{884C}\u{4E2D}\u{3084}\u{5B8C}\u{4E86}\u{3057}\u{305F}\u{96C7}\u{7528}\u{4E3B}\u{306E}EIN\u{78BA}\u{8A8D}\u{306F}\u{3001}\u{305D}\u{306E}\u{52E4}\u{52D9}\u{65E5}\u{3092}\u{30AB}\u{30D0}\u{30FC}\u{3057}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C9C4}\u{D589} \u{C911}\u{C774}\u{AC70}\u{B098} \u{C644}\u{B8CC}\u{B41C} \u{ACE0}\u{C6A9}\u{C8FC} EIN \u{D655}\u{C778}\u{C740} \u{ADFC}\u{BB34}\u{C77C}\u{C5D0} \u{D574}\u{B2F9}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj qhov ua tiav los yog ua tiav qhov chaw ua hauj lwm EIN xyuas txog hnub ua hauj lwm.`,
    ps: `\u{647}\u{6CC}\u{685} \u{62F} \u{6A9}\u{627}\u{631} \u{681}\u{627}\u{6CC} \u{62F} EIN \u{62A}\u{627}\u{6CC}\u{6CC}\u{62F} \u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6CC}\u{67C}\u{6D0} \u{646}\u{647} \u{67E}\u{648}\u{69A}\u{6CC}.`,
    pt: `Nenhuma verifica\xe7\xe3o EIN em andamento ou conclu\xedda pelo empregador cobre a data de trabalho.`,
    'pt-pt': `Nenhuma verifica\xe7\xe3o EIN do empregador em andamento ou conclu\xedda cobre a data de trabalho.`,
    ru: `\u{41D}\u{438} \u{43E}\u{434}\u{43D}\u{430} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{430}\u{44F} \u{438}\u{43B}\u{438} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{451}\u{43D}\u{43D}\u{430}\u{44F} \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{430} EIN \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{43C} \u{43D}\u{435} \u{43E}\u{445}\u{432}\u{430}\u{442}\u{44B}\u{432}\u{430}\u{435}\u{442} \u{434}\u{430}\u{442}\u{443} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}.`,
    sm: `E leai se faamaoniga o le EIN o loo faagasolo pe ua maea e aofia ai le aso faigaluega.`,
    so: `Ma jirto xaqiijin EIN oo socota ama la dhammeystiray oo shaqo-bixiye ah oo daboolaya taariikhda shaqada.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A} EIN \u{E02}\u{E2D}\u{E07}\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E04}\u{E23}\u{E2D}\u{E1A}\u{E04}\u{E25}\u{E38}\u{E21}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{648} \u{6A9}\u{648}\u{631} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{6A9}\u{627}\u{645} \u{62C}\u{627}\u{631}\u{6CC} \u{6CC}\u{627} \u{645}\u{6A9}\u{645}\u{644} \u{634}\u{62F}\u{6C1} \u{622}\u{62C}\u{631} \u{6A9}\u{627} EIN \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{62A}\u{627}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 x\xe1c minh EIN c\u{1EE7}a ch\u{1EE7} lao \u{111}\u{1ED9}ng \u{111}ang ti\u{1EBF}n h\xe0nh ho\u{1EB7}c \u{111}\xe3 ho\xe0n th\xe0nh bao g\u{1ED3}m ng\xe0y l\xe0m vi\u{1EC7}c.`,
    'zh-hans': `\u{6CA1}\u{6709}\u{6B63}\u{5728}\u{8FDB}\u{884C}\u{6216}\u{5B8C}\u{6210}\u{7684}\u{96C7}\u{4E3B}EIN\u{6838}\u{67E5}\u{6DB5}\u{76D6}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    'zh-hant': `\u{6C92}\u{6709}\u{9032}\u{884C}\u{4E2D}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}\u{96C7}\u{4E3B}EIN\u{9A57}\u{8B49}\u{6DB5}\u{84CB}\u{8A72}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    en: `No in-progress or completed employer EIN verification covers the work date.`
};
const $b11db1b62d4a8f76$export$8e56371c071fde90 = {
    ar: `\u{627}\u{644}\u{62A}\u{62D}\u{642}\u{642} \u{645}\u{646} \u{631}\u{642}\u{645} \u{62A}\u{639}\u{631}\u{64A}\u{641} \u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644} \u{627}\u{644}\u{645}\u{641}\u{642}\u{648}\u{62F}`,
    de: `Verifizierung der EIN fehlender Arbeitgeber`,
    es: `Verificaci\xf3n EIN del empleador ausente`,
    fa: `\u{62A}\u{623}\u{6CC}\u{6CC}\u{62F}\u{6CC}\u{647} EIN \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627} \u{6A9}\u{647} \u{627}\u{632} \u{62F}\u{633}\u{62A} \u{631}\u{641}\u{62A}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Nawawalang pag-verify ng EIN ng employer`,
    fr: `V\xe9rification EIN de l\u{2019}employeur manquant`,
    hi: `\u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{908}\u{906}\u{908}\u{90F}\u{928} \u{938}\u{924}\u{94D}\u{92F}\u{93E}\u{92A}\u{928} \u{917}\u{941}\u{92E}`,
    ht: `Anplway\xe8 ki manke verifikasyon EIN`,
    it: `Verifica EIN del datore di lavoro mancante`,
    ja: `\u{96C7}\u{7528}\u{4E3B}\u{306E}EIN\u{78BA}\u{8A8D}\u{304C}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{ACE0}\u{C6A9}\u{C8FC} EIN \u{D655}\u{C778} \u{BD80}\u{C7AC}`,
    mww: `Qhov chaw ua hauj lwm uas ploj lawm EIN kev txheeb xyuas`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631}\u{6AB}\u{645}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC} \u{62F} EIN \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{648}\u{631}\u{6A9} \u{634}\u{648}\u{6CC}`,
    pt: `Verifica\xe7\xe3o EIN do empregador ausente`,
    'pt-pt': `Verifica\xe7\xe3o EIN do empregador em falta`,
    ru: `\u{41E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442} \u{43F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{43A}\u{430} EIN \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F}`,
    sm: `Misi le faamaoniga o le EIN o le pule o le galuega`,
    so: `Xaqiijinta EIN-ka ee shaqo-bixiyaha maqan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19} EIN \u{E02}\u{E2D}\u{E07}\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{622}\u{62C}\u{631} \u{6A9}\u{6CC} EIN \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{6CC} \u{6A9}\u{645}\u{6CC}`,
    vi: `Thi\u{1EBF}u x\xe1c minh EIN c\u{1EE7}a ch\u{1EE7} lao \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{7F3A}\u{5C11}\u{96C7}\u{4E3B}EIN\u{9A8C}\u{8BC1}`,
    'zh-hant': `\u{7F3A}\u{5C11}\u{96C7}\u{4E3B}EIN\u{9A57}\u{8B49}`,
    en: `Missing employer EIN verification`
};
const $b11db1b62d4a8f76$export$416d569e2ff3da3c = {
    ar: `\u{644}\u{627} \u{64A}\u{63A}\u{637}\u{64A} \u{623}\u{64A} \u{62D}\u{633}\u{627}\u{628} SIT \u{644}\u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644} \u{642}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630} \u{623}\u{648} \u{645}\u{643}\u{62A}\u{645}\u{644} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644} \u{641}\u{64A} \u{62D}\u{627}\u{644}\u{629} \u{627}\u{644}\u{627}\u{642}\u{62A}\u{637}\u{627}\u{639} \u{644}\u{644}\u{645}\u{648}\u{638}\u{641}.`,
    de: `Kein laufendes oder abgeschlossenes Arbeitgeber-SIT-Konto deckt das Arbeitsdatum f\xfcr den Zustand des Arbeitnehmers ab.`,
    es: `Ninguna cuenta SIT del empleador en curso o completada cubre la fecha de trabajo del estado de retenci\xf3n del empleado.`,
    fa: `\u{647}\u{6CC}\u{686} \u{62D}\u{633}\u{627}\u{628} SIT \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{6CC}\u{627} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{634}\u{62F}\u{647} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{627}\u{6CC}\u{627}\u{644}\u{62A} \u{6A9}\u{633}\u{631} \u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F} \u{631}\u{627} \u{67E}\u{648}\u{634}\u{634} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Walang in-progress o nakumpleto na SIT account ng employer na sumasaklaw sa petsa ng trabaho para sa estado ng withholding ng empleyado.`,
    fr: `Aucun compte SIT de l\u{2019}employeur en cours ou complet ne couvre la date de travail de l\u{2019}\xc9tat de retenue de l\u{2019}employ\xe9.`,
    hi: `\u{915}\u{94B}\u{908} \u{92D}\u{940} \u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{92F}\u{93E} \u{92A}\u{942}\u{930}\u{94D}\u{923} \u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{90F}\u{938}\u{906}\u{908}\u{91F}\u{940} \u{916}\u{93E}\u{924}\u{93E} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{915}\u{940} \u{930}\u{94B}\u{915} \u{930}\u{93E}\u{91C}\u{94D}\u{92F} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{915}\u{94B} \u{915}\u{935}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Pa gen kont SIT anplway\xe8 ki an pwogr\xe8 oswa ki konpl\xe8 kouvri dat travay pou eta prel\xe8vman anplwaye a.`,
    it: `Nessun conto SIT in corso o completato copre la data di lavoro dello stato di ritenuta dal dipendente.`,
    ja: `\u{9032}\u{884C}\u{4E2D}\u{307E}\u{305F}\u{306F}\u{5B8C}\u{4E86}\u{3057}\u{305F}\u{96C7}\u{7528}\u{4E3B}\u{306E}SIT\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{306F}\u{3001}\u{5F93}\u{696D}\u{54E1}\u{306E}\u{6E90}\u{6CC9}\u{5FB4}\u{53CE}\u{5DDE}\u{306E}\u{52E4}\u{52D9}\u{65E5}\u{3092}\u{30AB}\u{30D0}\u{30FC}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C9C4}\u{D589} \u{C911}\u{C774}\u{AC70}\u{B098} \u{C644}\u{B8CC}\u{B41C} \u{ACE0}\u{C6A9}\u{C8FC} SIT \u{ACC4}\u{C88C}\u{B294} \u{C9C1}\u{C6D0}\u{C758} \u{C6D0}\u{CC9C}\u{C9D5}\u{C218} \u{C8FC}\u{C758} \u{ADFC}\u{BB34}\u{C77C}\u{C744} \u{D3EC}\u{D568}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj ib tug tswv hauj lwm SIT account uas ua tiav los yog ua tiav rau hnub ua hauj lwm rau tus neeg ua hauj lwm lub xeev txiav nyiaj.`,
    ps: `\u{647}\u{6CC}\u{685} \u{62F} \u{6A9}\u{627}\u{631} \u{648}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} SIT \u{62D}\u{633}\u{627}\u{628} \u{62F} \u{6A9}\u{627}\u{631}\u{6AB}\u{631} \u{62F} \u{6A9}\u{645}\u{6D0} \u{6A9}\u{648}\u{644}\u{648} \u{627}\u{6CC}\u{627}\u{644}\u{62A} \u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6CC}\u{67C}\u{647} \u{646}\u{647} \u{67E}\u{648}\u{69A}\u{6CC}.`,
    pt: `Nenhuma conta SIT do empregador em andamento ou conclu\xedda cobre a data de trabalho do estado de reten\xe7\xe3o do funcion\xe1rio.`,
    'pt-pt': `Nenhuma conta SIT do empregador em andamento ou conclu\xedda cobre a data de trabalho do estado de reten\xe7\xe3o do empregado.`,
    ru: `\u{41D}\u{438} \u{43E}\u{434}\u{438}\u{43D} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439} \u{438}\u{43B}\u{438} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{451}\u{43D}\u{43D}\u{44B}\u{439} SIT \u{441}\u{447}\u{435}\u{442} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{43D}\u{435} \u{43F}\u{43E}\u{43A}\u{440}\u{44B}\u{432}\u{430}\u{435}\u{442} \u{434}\u{430}\u{442}\u{443} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{432} \u{448}\u{442}\u{430}\u{442}\u{435} \u{443}\u{434}\u{435}\u{440}\u{436}\u{430}\u{43D}\u{438}\u{44F} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{430}.`,
    sm: `E leai se teugatupe SIT o lo'o fa'aauau pea pe fa'amae'aina e aofia ai le aso faigaluega mo le setete o le taofiofia o le tagata faigaluega.`,
    so: `Ma jiro akoon SIT oo shaqo-shaqo ah oo socday ama la dhammeystiray oo daboolaya taariikhda shaqada ee gobolka uu shaqaaluhu ka xayiro.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35} SIT \u{E02}\u{E2D}\u{E07}\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E04}\u{E23}\u{E2D}\u{E1A}\u{E04}\u{E25}\u{E38}\u{E21}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E01}\u{E32}\u{E23}\u{E2B}\u{E31}\u{E01} \u{E13} \u{E17}\u{E35}\u{E48}\u{E08}\u{E48}\u{E32}\u{E22}\u{E02}\u{E2D}\u{E07}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{62C}\u{627}\u{631}\u{6CC} \u{6CC}\u{627} \u{645}\u{6A9}\u{645}\u{644} \u{634}\u{62F}\u{6C1} \u{622}\u{62C}\u{631} SIT \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{645}\u{644}\u{627}\u{632}\u{645} \u{6A9}\u{6CC} \u{648}\u{62F}\u{6C1}\u{648}\u{644}\u{688}\u{646}\u{6AF} \u{631}\u{6CC}\u{627}\u{633}\u{62A} \u{6A9}\u{6CC} \u{648}\u{631}\u{6A9} \u{688}\u{6CC}\u{679} \u{6A9}\u{648} \u{6A9}\u{648}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{631}\u{62A}\u{627}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 t\xe0i kho\u{1EA3}n SIT n\xe0o c\u{1EE7}a ch\u{1EE7} lao \u{111}\u{1ED9}ng \u{111}ang ti\u{1EBF}n h\xe0nh ho\u{1EB7}c \u{111}\xe3 ho\xe0n th\xe0nh bao g\u{1ED3}m ng\xe0y l\xe0m vi\u{1EC7}c cho tr\u{1EA1}ng th\xe1i kh\u{1EA5}u l\u{1B0}u c\u{1EE7}a nh\xe2n vi\xean.`,
    'zh-hans': `\u{6CA1}\u{6709}\u{4EFB}\u{4F55}\u{6B63}\u{5728}\u{8FDB}\u{884C}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}\u{96C7}\u{4E3B}SIT\u{8D26}\u{6237}\u{8986}\u{76D6}\u{5458}\u{5DE5}\u{6263}\u{7A0E}\u{5DDE}\u{7684}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    'zh-hant': `\u{6C92}\u{6709}\u{4EFB}\u{4F55}\u{6B63}\u{5728}\u{9032}\u{884C}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}\u{96C7}\u{4E3B}SIT\u{5E33}\u{6236}\u{6DB5}\u{84CB}\u{54E1}\u{5DE5}\u{6263}\u{7E73}\u{5DDE}\u{7684}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    en: `No in-progress or completed employer SIT account covers the work date for the employee\u{2019}s withholding state.`
};
const $b11db1b62d4a8f76$export$831ddff72683da4b = {
    ar: `\u{62D}\u{633}\u{627}\u{628} SIT \u{627}\u{644}\u{62E}\u{627}\u{635} \u{628}\u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644} \u{645}\u{641}\u{642}\u{648}\u{62F}`,
    de: `Fehlendes Arbeitgeber-SIT-Konto`,
    es: `Cuenta SIT del empleador perdida`,
    fa: `\u{646}\u{628}\u{648}\u{62F} \u{62D}\u{633}\u{627}\u{628} SIT \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627}`,
    fil: `Nawawalang SIT account ng employer`,
    fr: `Compte SIT employeur manquant`,
    hi: `\u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{90F}\u{938}\u{906}\u{908}\u{91F}\u{940} \u{916}\u{93E}\u{924}\u{93E} \u{917}\u{941}\u{92E}`,
    ht: `Kont SIT anplway\xe8 ki manke`,
    it: `Conto SIT del datore di lavoro mancante`,
    ja: `\u{96C7}\u{7528}\u{4E3B}\u{306E}SIT\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{304C}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{ACE0}\u{C6A9}\u{C8FC} SIT \u{ACC4}\u{C815} \u{B204}\u{B77D}`,
    mww: `Tus tswv hauj lwm SIT account uas ploj lawm`,
    ps: `\u{648}\u{631}\u{6A9} \u{634}\u{648}\u{6CC} \u{6A9}\u{627}\u{631}\u{6AB}\u{645}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC} SIT \u{62D}\u{633}\u{627}\u{628}`,
    pt: `Conta SIT do empregador ausente`,
    'pt-pt': `Conta SIT do empregador em falta`,
    ru: `\u{41E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442} \u{430}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442} SIT \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F}`,
    sm: `O loo misi le teugatupe a le pule o le SIT`,
    so: `Akoonka SIT ee shaqo-bixiyaha maqan`,
    th: `\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35} SIT \u{E02}\u{E2D}\u{E07}\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}\u{E2B}\u{E32}\u{E22}\u{E44}\u{E1B}`,
    ur: `\u{6AF}\u{645}\u{634}\u{62F}\u{6C1} \u{622}\u{62C}\u{631} SIT \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679}`,
    vi: `Thi\u{1EBF}u t\xe0i kho\u{1EA3}n SIT c\u{1EE7}a ch\u{1EE7} lao \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{7F3A}\u{5C11}\u{96C7}\u{4E3B}SIT\u{8D26}\u{6237}`,
    'zh-hant': `\u{7F3A}\u{5C11}\u{96C7}\u{4E3B}\u{7684} SIT \u{5E33}\u{6236}`,
    en: `Missing employer SIT account`
};
const $b11db1b62d4a8f76$export$3fd1c1d65693f4c = {
    ar: `\u{644}\u{627} \u{64A}\u{63A}\u{637}\u{64A} \u{623}\u{64A} \u{62D}\u{633}\u{627}\u{628} SUTA \u{644}\u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644} \u{642}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630} \u{623}\u{648} \u{645}\u{643}\u{62A}\u{645}\u{644} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644}.`,
    de: `Kein laufendes oder abgeschlossenes Arbeitgeber-SUTA-Konto deckt das Arbeitsdatum ab.`,
    es: `Ninguna cuenta SUTA del empleador en proceso o completada cubre la fecha de trabajo.`,
    fa: `\u{647}\u{6CC}\u{686} \u{62D}\u{633}\u{627}\u{628} SUTA \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{6CC}\u{627} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{634}\u{62F}\u{647} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{631}\u{627} \u{67E}\u{648}\u{634}\u{634} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Walang in-progress o nakumpleto na SUTA account ng employer na sumasaklaw sa petsa ng trabaho.`,
    fr: `Aucun compte SUTA de l\u{2019}employeur en cours ou complet ne couvre la date de travail.`,
    hi: `\u{915}\u{94B}\u{908} \u{92D}\u{940} \u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{92F}\u{93E} \u{92A}\u{942}\u{930}\u{94D}\u{923} \u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} SUTA \u{916}\u{93E}\u{924}\u{93E} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{915}\u{94B} \u{915}\u{935}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Pa gen kont anplway\xe8 SUTA ki nan pwogr\xe8 oswa ki te ranpli ki kouvri dat travay la.`,
    it: `Nessun conto SUTA in corso o completato copre la data di lavoro.`,
    ja: `\u{4F5C}\u{696D}\u{671F}\u{9593}\u{4E2D}\u{306E}SUTA\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{3084}\u{5B8C}\u{4E86}\u{6E08}\u{307F}\u{306E}\u{96C7}\u{7528}\u{4E3B}SUTA\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{306F}\u{3001}\u{305D}\u{306E}\u{4F5C}\u{696D}\u{65E5}\u{3092}\u{30AB}\u{30D0}\u{30FC}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C9C4}\u{D589} \u{C911}\u{C774}\u{AC70}\u{B098} \u{C644}\u{B8CC}\u{B41C} \u{ACE0}\u{C6A9}\u{C8FC} SUTA \u{ACC4}\u{C88C}\u{B294} \u{D574}\u{B2F9} \u{C791}\u{C5C5} \u{B0A0}\u{C9DC}\u{B97C} \u{D3EC}\u{D568}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj ib qho kev ua tiav los yog ua tiav ntawm tus tswv hauj lwm SUTA account them rau hnub ua haujlwm.`,
    ps: `\u{647}\u{6CC}\u{685} \u{62F} \u{6A9}\u{627}\u{631} \u{648}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} SUTA \u{62D}\u{633}\u{627}\u{628} \u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6CC}\u{67C}\u{6D0} \u{67E}\u{648}\u{69A}\u{69A} \u{646}\u{647} \u{6A9}\u{648}\u{6CC}.`,
    pt: `Nenhuma conta SUTA do empregador em andamento ou conclu\xedda cobre a data de trabalho.`,
    'pt-pt': `Nenhuma conta SUTA do empregador em andamento ou conclu\xedda cobre a data de trabalho.`,
    ru: `\u{41D}\u{438} \u{43E}\u{434}\u{438}\u{43D} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439} \u{438}\u{43B}\u{438} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{451}\u{43D}\u{43D}\u{44B}\u{439} \u{430}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F} SUTA \u{43D}\u{435} \u{43F}\u{43E}\u{43A}\u{440}\u{44B}\u{432}\u{430}\u{435}\u{442} \u{434}\u{430}\u{442}\u{443} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}.`,
    sm: `E leai se teugatupe SUTA o lo'o fa'aauau pea pe fa'amae'aina e aofia ai le aso faigaluega.`,
    so: `Ma jiro akoon SUTA oo shaqo-shaqo oo socday ama la dhammeystiray oo daboolaya taariikhda shaqada.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35} SUTA \u{E02}\u{E2D}\u{E07}\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E04}\u{E23}\u{E2D}\u{E1A}\u{E04}\u{E25}\u{E38}\u{E21}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{62C}\u{627}\u{631}\u{6CC} \u{6CC}\u{627} \u{645}\u{6A9}\u{645}\u{644} \u{634}\u{62F}\u{6C1} \u{622}\u{62C}\u{631} \u{6A9}\u{627} SUTA \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{648} \u{6A9}\u{648}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{631}\u{62A}\u{627}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 t\xe0i kho\u{1EA3}n n\xe0o c\u{1EE7}a nh\xe0 tuy\u{1EC3}n d\u{1EE5}ng \u{111}ang ti\u{1EBF}n h\xe0nh ho\u{1EB7}c \u{111}\xe3 ho\xe0n th\xe0nh bao g\u{1ED3}m ng\xe0y l\xe0m vi\u{1EC7}c.`,
    'zh-hans': `\u{6CA1}\u{6709}\u{4EFB}\u{4F55}\u{6B63}\u{5728}\u{8FDB}\u{884C}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}\u{96C7}\u{4E3B}UTA\u{8D26}\u{6237}\u{6DB5}\u{76D6}\u{8BE5}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    'zh-hant': `\u{6C92}\u{6709}\u{6B63}\u{5728}\u{9032}\u{884C}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}\u{96C7}\u{4E3B}SUTA\u{5E33}\u{6236}\u{6DB5}\u{84CB}\u{8A72}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{3002}`,
    en: `No in-progress or completed employer SUTA account covers the work date.`
};
const $b11db1b62d4a8f76$export$1884f4af1afbe6fd = {
    ar: `\u{62D}\u{633}\u{627}\u{628} \u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644} \u{627}\u{644}\u{645}\u{641}\u{642}\u{648}\u{62F} \u{641}\u{64A} \u{62D}\u{633}\u{627}\u{628} SUTA`,
    de: `SUTA-Konto fehlender Arbeitgeber`,
    es: `Cuenta SUTA del empleador desaparecida`,
    fa: `\u{62D}\u{633}\u{627}\u{628} SUTA \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627} \u{6AF}\u{645} \u{634}\u{62F}\u{647}`,
    fil: `Nawawalang SUTA account ng employer`,
    fr: `Compte SUTA employeur manquant`,
    hi: `\u{917}\u{941}\u{92E} \u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} SUTA \u{916}\u{93E}\u{924}\u{93E}`,
    ht: `Kont SUTA anplway\xe8 ki manke`,
    it: `Account SUTA del datore di lavoro mancante`,
    ja: `\u{96C7}\u{7528}\u{4E3B}\u{306E}SUTA\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{304C}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{ACE0}\u{C6A9}\u{C8FC} SUTA \u{ACC4}\u{C815} \u{B204}\u{B77D}`,
    mww: `Tus tswv hauj lwm SUTA tus account uas ploj lawm`,
    ps: `\u{648}\u{631}\u{6A9} \u{634}\u{648}\u{6CC} \u{6A9}\u{627}\u{631}\u{6AB}\u{645}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC} SUTA \u{62D}\u{633}\u{627}\u{628}`,
    pt: `Conta SUTA do empregador desaparecida`,
    'pt-pt': `Conta SUTA do empregador em falta`,
    ru: `\u{41E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{438}\u{439} \u{430}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442} SUTA \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F}`,
    sm: `O loo misi le faitotoa SUTA a le pule o le galuega`,
    so: `Xisaabta SUTA ee shaqo-shaqo ee maqan`,
    th: `\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35} SUTA \u{E02}\u{E2D}\u{E07}\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}\u{E2B}\u{E32}\u{E22}\u{E44}\u{E1B}`,
    ur: `\u{6AF}\u{645}\u{634}\u{62F}\u{6C1} \u{622}\u{62C}\u{631} \u{6A9}\u{627} SUTA \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679}`,
    vi: `Thi\u{1EBF}u t\xe0i kho\u{1EA3}n SUTA c\u{1EE7}a nh\xe0 tuy\u{1EC3}n d\u{1EE5}ng`,
    'zh-hans': `\u{7F3A}\u{5C11}\u{96C7}\u{4E3B}SUTA\u{8D26}\u{6237}`,
    'zh-hant': `\u{7F3A}\u{5C11}\u{96C7}\u{4E3B} SUTA \u{5E33}\u{6236}`,
    en: `Missing employer SUTA account`
};
const $b11db1b62d4a8f76$export$9c45b82eadd630c4 = {
    ar: `\u{644}\u{627} \u{64A}\u{63A}\u{637}\u{64A} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644} \u{623}\u{64A} \u{645}\u{639}\u{62F}\u{644} \u{636}\u{631}\u{64A}\u{628}\u{629} SUTA \u{642}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630} \u{623}\u{648} \u{627}\u{644}\u{627}\u{643}\u{62A}\u{645}\u{627}\u{644} \u{645}\u{639} \u{627}\u{644}\u{633}\u{639}\u{631} \u{648}\u{642}\u{64A}\u{645} \u{627}\u{644}\u{648}\u{644}\u{627}\u{64A}\u{629}.`,
    de: `Kein laufender oder abgeschlossener Arbeitgeber-SUTA-Steuersatz mit Steuersatz und staatlichen Werten deckt das Arbeitsdatum ab.`,
    es: `No existe la tasa impositiva SUTA del empleador en curso o completada, con la tasa y los valores estatales, que cubra la fecha de trabajo.`,
    fa: `\u{647}\u{6CC}\u{686} \u{646}\u{631}\u{62E} \u{645}\u{627}\u{644}\u{6CC}\u{627}\u{62A}\u{6CC} SUTA \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{6CC}\u{627} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{634}\u{62F}\u{647} \u{628}\u{627} \u{646}\u{631}\u{62E} \u{648} \u{627}\u{631}\u{632}\u{634} \u{647}\u{627}\u{6CC} \u{627}\u{6CC}\u{627}\u{644}\u{62A}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{631}\u{627} \u{67E}\u{648}\u{634}\u{634} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Walang in-progress o nakumpleto na rate ng buwis ng employer SUTA na may rate at mga halaga ng estado na sumasaklaw sa petsa ng trabaho.`,
    fr: `Aucun taux d\u{2019}imposition SUTA en cours ou termin\xe9 par l\u{2019}employeur, avec taux et valeurs de l\u{2019}\xc9tat, ne couvre la date de travail.`,
    hi: `\u{926}\u{930} \u{914}\u{930} \u{930}\u{93E}\u{91C}\u{94D}\u{92F} \u{92E}\u{942}\u{932}\u{94D}\u{92F}\u{94B}\u{902} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{915}\u{94B}\u{908} \u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{92F}\u{93E} \u{92A}\u{942}\u{930}\u{94D}\u{923} \u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} SUTA \u{915}\u{930} \u{926}\u{930} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{924}\u{93F}\u{925}\u{93F} \u{915}\u{94B} \u{915}\u{935}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{930}\u{924}\u{940} \u{939}\u{948}\u{964}`,
    ht: `Pa gen pousantaj taks SUTA anplway\xe8 ki an pwogr\xe8 oswa ranpli ak pousantaj ak val\xe8 eta a kouvri dat travay la.`,
    it: `Nessuna aliquota fiscale SUTA in corso o completata del datore di lavoro, con aliquote e valori statali, copre la data di lavoro.`,
    ja: `\u{9032}\u{884C}\u{4E2D}\u{307E}\u{305F}\u{306F}\u{5B8C}\u{4E86}\u{3057}\u{305F}\u{96C7}\u{7528}\u{4E3B}SUTA\u{7A0E}\u{7387}(\u{7A0E}\u{7387}\u{304A}\u{3088}\u{3073}\u{5DDE}\u{306E}\u{5024}\u{4ED8}\u{304D})\u{306F}\u{3001}\u{4F5C}\u{696D}\u{65E5}\u{3092}\u{30AB}\u{30D0}\u{30FC}\u{3057}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C9C4}\u{D589} \u{C911}\u{C774}\u{AC70}\u{B098} \u{C644}\u{B8CC}\u{B41C} \u{ACE0}\u{C6A9}\u{C8FC} SUTA \u{C138}\u{C728}\u{ACFC} \u{C138}\u{C728} \u{BC0F} \u{C8FC} \u{AC12}\u{C774} \u{C791}\u{C5C5} \u{B0A0}\u{C9DC}\u{B97C} \u{D3EC}\u{D568}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj tus nqi se uas ua tiav los yog ua tiav tus tswv hauj lwm SUTA tus nqi nrog tus nqi thiab lub xeev cov nqi them rau hnub ua haujlwm.`,
    ps: `\u{647}\u{6CC}\u{685} \u{62F} \u{6A9}\u{627}\u{631} \u{648}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{67E}\u{647} \u{62C}\u{631}\u{6CC}\u{627}\u{646} \u{6CC}\u{627} \u{628}\u{634}\u{67E}\u{693} \u{634}\u{648}\u{6CC} SUTA \u{645}\u{627}\u{644}\u{6CC}\u{647} \u{646}\u{631}\u{62E} \u{62F} \u{646}\u{631}\u{62E} \u{627}\u{648} \u{627}\u{6CC}\u{627}\u{644}\u{62A}\u{6CC} \u{627}\u{631}\u{632}\u{69A}\u{62A}\u{648}\u{646}\u{648} \u{633}\u{631}\u{647} \u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6CC}\u{67C}\u{6D0} \u{67E}\u{648}\u{69A}\u{6CC}.`,
    pt: `Nenhuma al\xedquota de imposto SUTA do empregador em andamento ou conclu\xedda, com al\xedquota e valores estaduais, cobre a data de trabalho.`,
    'pt-pt': `Nenhuma taxa de imposto SUTA do empregador em andamento ou conclu\xedda, com taxa e valores estaduais, cobre a data de trabalho.`,
    ru: `\u{41D}\u{438} \u{43E}\u{434}\u{43D}\u{430} \u{441}\u{442}\u{430}\u{432}\u{43A}\u{430} \u{43D}\u{430}\u{43B}\u{43E}\u{433}\u{430} SUTA \u{43E}\u{442} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{432} \u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{435} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{430} \u{441} \u{443}\u{447}\u{451}\u{442}\u{43E}\u{43C} \u{441}\u{442}\u{430}\u{432}\u{43A}\u{438} \u{438} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}\u{43C}\u{438} \u{448}\u{442}\u{430}\u{442}\u{430}, \u{43E}\u{445}\u{432}\u{430}\u{442}\u{44B}\u{432}\u{430}\u{44E}\u{449}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{443} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B}.`,
    sm: `E leai se lafoga SUTA o lo'o fa'aauau pea ona fa'aauau pe fa'amae'aina le fua faatatau o le setete e aofia ai le aso faigaluega.`,
    so: `Ma jiro heerka canshuurta SUTA ee shaqo-bixiyaha oo socday ama la dhammeystiray oo leh heerka iyo qiimaha gobolka oo daboolaya taariikhda shaqada.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E2D}\u{E31}\u{E15}\u{E23}\u{E32}\u{E20}\u{E32}\u{E29}\u{E35} SUTA \u{E02}\u{E2D}\u{E07}\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E2D}\u{E31}\u{E15}\u{E23}\u{E32}\u{E41}\u{E25}\u{E30}\u{E21}\u{E39}\u{E25}\u{E04}\u{E48}\u{E32}\u{E02}\u{E2D}\u{E07}\u{E23}\u{E31}\u{E10}\u{E04}\u{E23}\u{E2D}\u{E1A}\u{E04}\u{E25}\u{E38}\u{E21}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{62C}\u{627}\u{631}\u{6CC} \u{6CC}\u{627} \u{645}\u{6A9}\u{645}\u{644} \u{634}\u{62F}\u{6C1} \u{622}\u{62C}\u{631} SUTA \u{679}\u{6CC}\u{6A9}\u{633} \u{631}\u{6CC}\u{679} \u{631}\u{6CC}\u{679} \u{627}\u{648}\u{631} \u{631}\u{6CC}\u{627}\u{633}\u{62A}\u{6CC} \u{648}\u{6CC}\u{644}\u{6CC}\u{648}\u{632} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{648} \u{6A9}\u{648}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{631}\u{62A}\u{627}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 thu\u{1EBF} su\u{1EA5}t SUTA c\u{1EE7}a ch\u{1EE7} lao \u{111}\u{1ED9}ng \u{111}ang ti\u{1EBF}n h\xe0nh ho\u{1EB7}c \u{111}\xe3 ho\xe0n th\xe0nh v\u{1EDB}i t\u{1EF7} l\u{1EC7} v\xe0 gi\xe1 tr\u{1ECB} ti\u{1EC3}u bang bao g\u{1ED3}m ng\xe0y l\xe0m vi\u{1EC7}c.`,
    'zh-hans': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{6CA1}\u{6709}\u{4EFB}\u{4F55}\u{6B63}\u{5728}\u{8FDB}\u{884C}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}\u{96C7}\u{4E3B}SUTA\u{7A0E}\u{7387}\u{53CA}\u{7A0E}\u{7387}\u{548C}\u{5DDE}\u{503C}\u{3002}`,
    'zh-hant': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{4E0D}\u{5305}\u{542B}\u{4EFB}\u{4F55}\u{6B63}\u{5728}\u{9032}\u{884C}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}\u{96C7}\u{4E3B} SUTA \u{7A05}\u{7387}\u{53CA}\u{7A05}\u{7387}\u{53CA}\u{5DDE}\u{503C}\u{3002}`,
    en: `No in-progress or completed employer SUTA tax rate with rate and state values covers the work date.`
};
const $b11db1b62d4a8f76$export$cd71b685ebb6478 = {
    ar: `\u{645}\u{639}\u{62F}\u{644} \u{636}\u{631}\u{64A}\u{628}\u{629} \u{627}\u{644}\u{62A}\u{623}\u{645}\u{64A}\u{646} \u{627}\u{644}\u{635}\u{62D}\u{64A} \u{627}\u{644}\u{646}\u{627}\u{642}\u{635} \u{644}\u{635}\u{627}\u{62D}\u{628} \u{627}\u{644}\u{639}\u{645}\u{644}`,
    de: `SUTA-Steuersatz fehlender Arbeitgeber`,
    es: `Tasa impositiva SUTA del empleador ausente`,
    fa: `\u{646}\u{631}\u{62E} \u{645}\u{627}\u{644}\u{6CC}\u{627}\u{62A} SUTA \u{627}\u{632} \u{62F}\u{633}\u{62A} \u{631}\u{641}\u{62A}\u{647} \u{62A}\u{648}\u{633}\u{637} \u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627}`,
    fil: `Nawawalang rate ng buwis sa SUTA ng employer`,
    fr: `Taux d\u{2019}imposition SUTA de l\u{2019}employeur manquant`,
    hi: `\u{932}\u{93E}\u{92A}\u{924}\u{93E} \u{928}\u{93F}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} SUTA \u{915}\u{930} \u{926}\u{930}`,
    ht: `Rate taks SUTA anplway\xe8 ki manke`,
    it: `Aliquota fiscale SUTA del datore di lavoro mancante`,
    ja: `\u{96C7}\u{7528}\u{4E3B}SUTA\u{7A0E}\u{7387}\u{306E}\u{6B20}\u{843D}`,
    ko: `\u{ACE0}\u{C6A9}\u{C8FC} SUTA \u{C138}\u{C728} \u{B204}\u{B77D}`,
    mww: `Tus nqi se ntawm tus tswv hauj lwm SUTA uas ploj lawm`,
    ps: `\u{648}\u{631}\u{6A9} \u{634}\u{648}\u{6CC} \u{6A9}\u{627}\u{631}\u{6AB}\u{645}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC} \u{62F} SUTA \u{645}\u{627}\u{644}\u{6CC}\u{6D0} \u{646}\u{631}\u{62E}`,
    pt: `Al\xedquota de imposto SUTA por empregador ausente`,
    'pt-pt': `Taxa de imposto SUTA do empregador ausente`,
    ru: `\u{41E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{430}\u{44F} \u{441}\u{442}\u{430}\u{432}\u{43A}\u{430} \u{43D}\u{430}\u{43B}\u{43E}\u{433}\u{430} SUTA \u{434}\u{43B}\u{44F} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F}`,
    sm: `O lo'o misi le fua faatatau o lafoga SUTA a le pule o le galuega`,
    so: `Heerka canshuurta SUTA ee shaqo-bixiyaha maqan`,
    th: `\u{E2D}\u{E31}\u{E15}\u{E23}\u{E32}\u{E20}\u{E32}\u{E29}\u{E35} SUTA \u{E02}\u{E2D}\u{E07}\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}\u{E02}\u{E32}\u{E14}\u{E2B}\u{E32}\u{E22}\u{E44}\u{E1B}`,
    ur: `\u{6AF}\u{645}\u{634}\u{62F}\u{6C1} \u{622}\u{62C}\u{631} SUTA \u{679}\u{6CC}\u{6A9}\u{633} \u{631}\u{6CC}\u{679}`,
    vi: `Thi\u{1EBF}u thu\u{1EBF} su\u{1EA5}t SUTA c\u{1EE7}a ch\u{1EE7} lao \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{7F3A}\u{5C11}\u{96C7}\u{4E3B}SUTA\u{7A0E}\u{7387}`,
    'zh-hant': `\u{7F3A}\u{5C11}\u{96C7}\u{4E3B}\u{7684} SUTA \u{7A05}\u{7387}`,
    en: `Missing employer SUTA tax rate`
};
const $b11db1b62d4a8f76$export$ca3c2edbd135560d = {
    ar: `\u{64A}\u{637}\u{644}\u{628} \u{648}\u{62C}\u{648}\u{62F} \u{628}\u{648}\u{644}\u{64A}\u{635}\u{629} \u{62A}\u{639}\u{648}\u{64A}\u{636}\u{627}\u{62A} \u{639}\u{645}\u{627}\u{644} \u{644}\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644}\u{60C} \u{644}\u{643}\u{646} \u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{648}\u{62B}\u{64A}\u{642}\u{629} \u{642}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630} \u{623}\u{648} \u{627}\u{644}\u{645}\u{643}\u{62A}\u{645}\u{644}\u{629} \u{62A}\u{63A}\u{637}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62A}\u{627}\u{631}\u{64A}\u{62E}.`,
    de: `F\xfcr den Arbeitstermin ist eine Arbeitsunfallversicherung erforderlich, aber keine laufende oder abgeschlossene Police deckt dieses Datum ab.`,
    es: `Se requiere una p\xf3liza de compensaci\xf3n laboral para la fecha de trabajo, pero ninguna p\xf3liza en curso o completada cubre esa fecha.`,
    fa: `\u{628}\u{6CC}\u{645}\u{647} \u{62C}\u{628}\u{631}\u{627}\u{646} \u{62E}\u{633}\u{627}\u{631}\u{62A} \u{6A9}\u{627}\u{631}\u{6AF}\u{631}\u{627}\u{646} \u{628}\u{631}\u{627}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{644}\u{627}\u{632}\u{645} \u{627}\u{633}\u{62A}\u{60C} \u{627}\u{645}\u{627} \u{647}\u{6CC}\u{686} \u{628}\u{6CC}\u{645}\u{647} \u{646}\u{627}\u{645}\u{647} \u{627}\u{6CC} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{6CC}\u{627} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{622}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{631}\u{627} \u{67E}\u{648}\u{634}\u{634} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Ang isang patakaran sa kompensasyon ng mga manggagawa ay kinakailangan para sa petsa ng trabaho, ngunit walang in-progress o nakumpleto na patakaran na sumasaklaw sa petsang iyon.`,
    fr: `Une police d\u{2019}indemnisation des travailleurs est requise pour la date de travail, mais aucune police en cours ou finalis\xe9e ne couvre cette date.`,
    hi: `\u{915}\u{93E}\u{92E} \u{915}\u{940} \u{924}\u{93E}\u{930}\u{940}\u{916} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{90F}\u{915} \u{936}\u{94D}\u{930}\u{92E}\u{93F}\u{915} \u{92E}\u{941}\u{906}\u{935}\u{91C}\u{93E} \u{928}\u{940}\u{924}\u{93F} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{94B}\u{924}\u{940} \u{939}\u{948}, \u{932}\u{947}\u{915}\u{93F}\u{928} \u{915}\u{94B}\u{908} \u{92D}\u{940} \u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{92F}\u{93E} \u{92A}\u{942}\u{930}\u{94D}\u{923} \u{928}\u{940}\u{924}\u{93F} \u{909}\u{938} \u{924}\u{93E}\u{930}\u{940}\u{916} \u{915}\u{94B} \u{915}\u{935}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{930}\u{924}\u{940} \u{939}\u{948}\u{964}`,
    ht: `Yo mande yon politik konpansasyon pou travay\xe8 yo pou dat travay la, men pa gen okenn politik ki an pwogr\xe8 oswa ki fini ki kouvri dat sa a.`,
    it: `\xc8 richiesta una polizza contro l'infortunio dei lavoratori per la data di lavoro, ma nessuna polizza in corso o completata copre quella data.`,
    ja: `\u{52B4}\u{707D}\u{4FDD}\u{967A}\u{306F}\u{4F5C}\u{696D}\u{65E5}\u{306E}\u{65E5}\u{4ED8}\u{306B}\u{5FC5}\u{9808}\u{3067}\u{3059}\u{304C}\u{3001}\u{9032}\u{884C}\u{4E2D}\u{3084}\u{5B8C}\u{4E86}\u{6E08}\u{307F}\u{306E}\u{4FDD}\u{967A}\u{306F}\u{305D}\u{306E}\u{65E5}\u{4ED8}\u{3092}\u{30AB}\u{30D0}\u{30FC}\u{3057}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{ADFC}\u{B85C}\u{C77C}\u{C5D0}\u{B294} \u{C0B0}\u{C7AC} \u{BCF4}\u{C0C1} \u{BCF4}\u{D5D8}\u{C774} \u{D544}\u{C694}\u{D558}\u{C9C0}\u{B9CC}, \u{C9C4}\u{D589} \u{C911}\u{C774}\u{AC70}\u{B098} \u{C644}\u{B8CC}\u{B41C} \u{BCF4}\u{D5D8}\u{C740} \u{D574}\u{B2F9} \u{B0A0}\u{C9DC}\u{B97C} \u{D3EC}\u{D568}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Yuav tsum muaj ib txoj cai them nqi zog rau hnub ua haujlwm, tiam sis tsis muaj ib daim ntawv pov hwm uas tab tom ua tiav los yog ua tiav them rau hnub ntawd.`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6CC}\u{67C}\u{6D0} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62F} \u{6A9}\u{627}\u{631}\u{6AB}\u{631} \u{62C}\u{628}\u{631}\u{627}\u{646} \u{67E}\u{627}\u{644}\u{6CC}\u{633}\u{6CD} \u{627}\u{693}\u{6CC}\u{646} \u{62F}\u{6CC}\u{60C} \u{62E}\u{648} \u{647}\u{6CC}\u{685} \u{628}\u{634}\u{67E}\u{693} \u{634}\u{648}\u{6CC} \u{6CC}\u{627} \u{67E}\u{647} \u{62C}\u{631}\u{6CC}\u{627}\u{646} \u{6A9}\u{6D0} \u{628}\u{6CC}\u{645}\u{647} \u{62F}\u{627} \u{646}\u{6CC}\u{67C}\u{647} \u{646}\u{647} \u{67E}\u{648}\u{69A}\u{6CC}.`,
    pt: `Uma ap\xf3lice de compensa\xe7\xe3o trabalhista \xe9 necess\xe1ria para a data de trabalho, mas nenhuma ap\xf3lice em andamento ou conclu\xedda cobre essa data.`,
    'pt-pt': `\xc9 necess\xe1ria uma ap\xf3lice de compensa\xe7\xe3o laboral para a data de trabalho, mas nenhuma ap\xf3lice em curso ou conclu\xedda cobre essa data.`,
    ru: `\u{414}\u{43B}\u{44F} \u{434}\u{430}\u{442}\u{44B} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{442}\u{440}\u{435}\u{431}\u{443}\u{435}\u{442}\u{441}\u{44F} \u{43F}\u{43E}\u{43B}\u{438}\u{441} \u{43F}\u{43E} \u{43A}\u{43E}\u{43C}\u{43F}\u{435}\u{43D}\u{441}\u{430}\u{446}\u{438}\u{438} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43D}\u{438}\u{43A}\u{430}\u{43C}, \u{43D}\u{43E} \u{43D}\u{435}\u{442} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{451}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{438}\u{43B}\u{438} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{451}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{43F}\u{43E}\u{43B}\u{438}\u{441}\u{430}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{439} \u{43D}\u{435} \u{43F}\u{43E}\u{43A}\u{440}\u{44B}\u{432}\u{430}\u{435}\u{442} \u{44D}\u{442}\u{443} \u{434}\u{430}\u{442}\u{443}.`,
    sm: `E mana'omia se aiaiga fa'avae mo taui a tagata faigaluega mo le aso faigaluega, ae leai se faiga fa'avae o lo'o alualu i luma pe mae'a e aofia ai lena aso.`,
    so: `Siyaasadda magdhowga shaqaalaha ayaa loo baahan yahay taariikhda shaqada, laakiin ma jirto siyaasad socota ama la dhammeystiray oo daboolaya taariikhdaas.`,
    th: `\u{E08}\u{E4D}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E19}\u{E42}\u{E22}\u{E1A}\u{E32}\u{E22}\u{E04}\u{E48}\u{E32}\u{E15}\u{E2D}\u{E1A}\u{E41}\u{E17}\u{E19}\u{E04}\u{E19}\u{E07}\u{E32}\u{E19}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19} \u{E41}\u{E15}\u{E48}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E19}\u{E42}\u{E22}\u{E1A}\u{E32}\u{E22}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E04}\u{E23}\u{E2D}\u{E1A}\u{E04}\u{E25}\u{E38}\u{E21}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E19}\u{E31}\u{E49}\u{E19}`,
    ur: `\u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{648}\u{631}\u{6A9}\u{631}\u{632} \u{6A9}\u{645}\u{67E}\u{646}\u{633}\u{6CC}\u{634}\u{646} \u{67E}\u{627}\u{644}\u{6CC}\u{633}\u{6CC} \u{62F}\u{631}\u{6A9}\u{627}\u{631} \u{6C1}\u{648}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{60C} \u{644}\u{6CC}\u{6A9}\u{646} \u{627}\u{633} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{648} \u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{632}\u{6CC}\u{631} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{6CC}\u{627} \u{645}\u{6A9}\u{645}\u{644} \u{67E}\u{627}\u{644}\u{6CC}\u{633}\u{6CC} \u{6A9}\u{648}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{631}\u{62A}\u{6CC}\u{6D4}`,
    vi: `Ch\xednh s\xe1ch b\u{1ED3}i th\u{1B0}\u{1EDD}ng cho ng\u{1B0}\u{1EDD}i lao \u{111}\u{1ED9}ng l\xe0 b\u{1EAF}t bu\u{1ED9}c cho ng\xe0y l\xe0m vi\u{1EC7}c, nh\u{1B0}ng kh\xf4ng c\xf3 ch\xednh s\xe1ch n\xe0o \u{111}ang ti\u{1EBF}n h\xe0nh ho\u{1EB7}c \u{111}\xe3 ho\xe0n th\xe0nh bao g\u{1ED3}m ng\xe0y \u{111}\xf3.`,
    'zh-hans': `\u{5DE5}\u{4F24}\u{8D54}\u{507F}\u{4FDD}\u{9669}\u{662F}\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{7684}\u{5FC5}\u{9700}\u{FF0C}\u{4F46}\u{6CA1}\u{6709}\u{4EFB}\u{4F55}\u{6B63}\u{5728}\u{8FDB}\u{884C}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{7684}\u{4FDD}\u{5355}\u{6DB5}\u{76D6}\u{8BE5}\u{65E5}\u{671F}\u{3002}`,
    'zh-hant': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{9700}\u{6295}\u{4FDD}\u{52DE}\u{5DE5}\u{4FDD}\u{96AA}\u{FF0C}\u{4F46}\u{672A}\u{5305}\u{542B}\u{8A72}\u{65E5}\u{671F}\u{7684}\u{9032}\u{884C}\u{4E2D}\u{6216}\u{5DF2}\u{5B8C}\u{6210}\u{4FDD}\u{55AE}\u{3002}`,
    en: `A workers compensation policy is required for the work date, but no in-progress or completed policy covers that date.`
};
const $b11db1b62d4a8f76$export$c1d889bf0ab4be1d = {
    ar: `\u{628}\u{648}\u{644}\u{64A}\u{635}\u{629} \u{62A}\u{639}\u{648}\u{64A}\u{636}\u{627}\u{62A} \u{627}\u{644}\u{639}\u{645}\u{627}\u{644} \u{627}\u{644}\u{645}\u{641}\u{642}\u{648}\u{62F}\u{629}`,
    de: `Fehlende Arbeitsunfallversicherung`,
    es: `Pol\xedtica de compensaci\xf3n laboral por desaparecidos`,
    fa: `\u{628}\u{6CC}\u{645}\u{647} \u{62C}\u{628}\u{631}\u{627}\u{646} \u{62E}\u{633}\u{627}\u{631}\u{62A} \u{6A9}\u{627}\u{631}\u{6AF}\u{631}\u{627}\u{646} \u{645}\u{641}\u{642}\u{648}\u{62F}`,
    fil: `Patakaran sa kompensasyon ng mga nawawalang manggagawa`,
    fr: `Police d\u{2019}indemnisation des travailleurs disparus`,
    hi: `\u{932}\u{93E}\u{92A}\u{924}\u{93E} \u{936}\u{94D}\u{930}\u{92E}\u{93F}\u{915}\u{94B}\u{902} \u{92E}\u{941}\u{906}\u{935}\u{91C}\u{93E} \u{928}\u{940}\u{924}\u{93F}`,
    ht: `Politik konpansasyon travay\xe8 ki manke yo`,
    it: `Politica per l'indennizzo dei lavoratori assenti`,
    ja: `\u{884C}\u{65B9}\u{4E0D}\u{660E}\u{8005}\u{88DC}\u{511F}\u{4FDD}\u{967A}`,
    ko: `\u{C2E4}\u{C885} \u{C0B0}\u{C7AC} \u{BCF4}\u{C0C1} \u{C815}\u{CC45}`,
    mww: `Txoj cai them nyiaj rau cov neeg ua haujlwm uas ploj lawm`,
    ps: `\u{62F} \u{648}\u{631}\u{6A9} \u{634}\u{648}\u{6CC}\u{648} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{648} \u{62C}\u{628}\u{631}\u{627}\u{646} \u{67E}\u{627}\u{644}\u{6CC}\u{633}\u{6CD}`,
    pt: `Pol\xedtica de compensa\xe7\xe3o trabalhista desaparecida`,
    'pt-pt': `Pol\xedtica de compensa\xe7\xe3o de trabalhadores desaparecidos`,
    ru: `\u{41F}\u{43E}\u{43B}\u{438}\u{442}\u{438}\u{43A}\u{430} \u{43F}\u{43E} \u{43F}\u{440}\u{43E}\u{43F}\u{430}\u{432}\u{448}\u{438}\u{43C} \u{43A}\u{43E}\u{43C}\u{43F}\u{435}\u{43D}\u{441}\u{430}\u{446}\u{438}\u{44F}\u{43C} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{43D}\u{438}\u{43A}\u{430}\u{43C}`,
    sm: `Faiga faavae o taui o tagata faigaluega o loo misi`,
    so: `Siyaasadda magdhowga shaqaalaha ee maqan`,
    th: `\u{E19}\u{E42}\u{E22}\u{E1A}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E0A}\u{E14}\u{E40}\u{E0A}\u{E22}\u{E04}\u{E19}\u{E07}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E02}\u{E32}\u{E14}\u{E2B}\u{E32}\u{E22}\u{E44}\u{E1B}`,
    ur: `\u{6AF}\u{645}\u{634}\u{62F}\u{6C1} \u{648}\u{631}\u{6A9}\u{631}\u{632} \u{6A9}\u{645}\u{67E}\u{646}\u{633}\u{6CC}\u{634}\u{646} \u{67E}\u{627}\u{644}\u{6CC}\u{633}\u{6CC}`,
    vi: `Ch\xednh s\xe1ch b\u{1ED3}i th\u{1B0}\u{1EDD}ng cho ng\u{1B0}\u{1EDD}i lao \u{111}\u{1ED9}ng m\u{1EA5}t t\xedch`,
    'zh-hans': `\u{5931}\u{8E2A}\u{5DE5}\u{4F24}\u{8D54}\u{507F}\u{653F}\u{7B56}`,
    'zh-hant': `\u{5931}\u{8E64}\u{52DE}\u{5DE5}\u{88DC}\u{511F}\u{653F}\u{7B56}`,
    en: `Missing workers compensation policy`
};
const $b11db1b62d4a8f76$export$a246ad11ec53c3d2 = {
    ar: `\u{625}\u{62F}\u{62E}\u{627}\u{644} \u{622}\u{62E}\u{631} \u{641}\u{64A} \u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{623}\u{648}\u{642}\u{627}\u{62A} \u{644}\u{646}\u{641}\u{633} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{647}\u{644}\u{643} \u{64A}\u{62A}\u{62F}\u{627}\u{62E}\u{644} \u{645}\u{639} \u{646}\u{637}\u{627}\u{642} \u{632}\u{645}\u{646}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{639}\u{62F}\u{62F}.`,
    de: `Ein weiterer Stundenzetteleintrag f\xfcr denselben Verbraucher \xfcberschneidet sich mit dem Zeitbereich dieses Eintrags.`,
    es: `Otra entrada en la hoja de horas para el mismo consumidor coincide con el rango temporal de esta entrada.`,
    fa: `\u{6CC}\u{6A9} \u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{62F}\u{6CC}\u{6AF}\u{631} \u{62F}\u{631} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646} \u{628}\u{631}\u{627}\u{6CC} \u{647}\u{645}\u{627}\u{646} \u{645}\u{635}\u{631}\u{641} \u{6A9}\u{646}\u{646}\u{62F}\u{647} \u{628}\u{627} \u{628}\u{627}\u{632}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{627}\u{6CC}\u{646} \u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{647}\u{645}\u{67E}\u{648}\u{634}\u{627}\u{646}\u{6CC} \u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `Ang isa pang timesheet entry para sa parehong mamimili ay nag-overlap sa saklaw ng oras ng entry na ito.`,
    fr: `Une autre entr\xe9e de feuille de temps pour le m\xeame consommateur recoupe la plage de temps de cette entr\xe9e.`,
    hi: `\u{90F}\u{915} \u{939}\u{940} \u{909}\u{92A}\u{92D}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{90F}\u{915} \u{914}\u{930} \u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F} \u{907}\u{938} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{940} \u{938}\u{92E}\u{92F} \u{938}\u{940}\u{92E}\u{93E} \u{915}\u{94B} \u{913}\u{935}\u{930}\u{932}\u{948}\u{92A} \u{915}\u{930}\u{924}\u{940} \u{939}\u{948}\u{964}`,
    ht: `Yon l\xf2t antre Timesheet pou konsomat\xe8 a menm sip\xe8poze seri tan antre sa a.`,
    it: `Un'altra voce di tabella di tempo per lo stesso consumatore si sovrappone all'intervallo di tempo di questa voce.`,
    ja: `\u{540C}\u{3058}\u{6D88}\u{8CBB}\u{8005}\u{306E}\u{5225}\u{306E}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{9805}\u{76EE}\u{306F}\u{3001}\u{3053}\u{306E}\u{8A18}\u{9332}\u{306E}\u{6642}\u{9593}\u{7BC4}\u{56F2}\u{3068}\u{91CD}\u{8907}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{AC19}\u{C740} \u{C18C}\u{BE44}\u{C790}\u{C758} \u{B610} \u{B2E4}\u{B978} \u{D0C0}\u{C784}\u{C2DC}\u{D2B8} \u{D56D}\u{BAA9}\u{C774} \u{C774} \u{D56D}\u{BAA9}\u{C758} \u{C2DC}\u{AC04} \u{BC94}\u{C704}\u{C640} \u{ACB9}\u{CE69}\u{B2C8}\u{B2E4}.`,
    mww: `Lwm daim ntawv teev sij hawm nkag rau tib tus neeg siv khoom sib tshooj lub sijhawm nkag no.`,
    ps: `\u{62F} \u{647}\u{645}\u{627}\u{63A}\u{647} \u{645}\u{635}\u{631}\u{641} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{628}\u{644}\u{647} \u{67C}\u{627}\u{6CC}\u{645} \u{634}\u{6CC}\u{67C} \u{62F} \u{62F}\u{6D0} \u{644}\u{6CC}\u{6A9}\u{646}\u{6D0} \u{62F} \u{648}\u{62E}\u{62A} \u{644}\u{647} \u{62D}\u{62F}\u{648}\u{62F}\u{648} \u{633}\u{631}\u{647} \u{647}\u{645}\u{67E}\u{648}\u{634}\u{627}\u{646}\u{6CC} \u{644}\u{631}\u{6CC}.`,
    pt: `Outra entrada de folha de ponto para o mesmo consumidor se sobrep\xf5e ao intervalo de tempo desta entrada.`,
    'pt-pt': `Outra entrada de folha de horas para o mesmo consumidor sobrep\xf5e-se ao intervalo temporal desta entrada.`,
    ru: `\u{414}\u{440}\u{443}\u{433}\u{430}\u{44F} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{432} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{435} \u{434}\u{43B}\u{44F} \u{442}\u{43E}\u{433}\u{43E} \u{436}\u{435} \u{43F}\u{43E}\u{442}\u{440}\u{435}\u{431}\u{438}\u{442}\u{435}\u{43B}\u{44F} \u{43F}\u{435}\u{440}\u{435}\u{441}\u{435}\u{43A}\u{430}\u{435}\u{442}\u{441}\u{44F} \u{441} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{44B}\u{43C} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{43E}\u{43C} \u{44D}\u{442}\u{43E}\u{439} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}.`,
    sm: `O le isi timesheet entry mo le tagata fa'atau lava lea e tasi e fa'atatau i le taimi o lenei ulufale.`,
    so: `Qoraal kale oo timesheet ah oo loogu talagalay isla macaamiisha ayaa isku dhex jira waqtiga qaybtaan.`,
    th: `\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E1C}\u{E39}\u{E49}\u{E1A}\u{E23}\u{E34}\u{E42}\u{E20}\u{E04}\u{E23}\u{E32}\u{E22}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E01}\u{E31}\u{E19}\u{E17}\u{E31}\u{E1A}\u{E0B}\u{E49}\u{E2D}\u{E19}\u{E01}\u{E31}\u{E1A}\u{E0A}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}\u{E02}\u{E2D}\u{E07}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633}\u{6CC} \u{635}\u{627}\u{631}\u{641} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{6CC}\u{6A9} \u{627}\u{648}\u{631} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{627}\u{633} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{6A9}\u{6CC} \u{679}\u{627}\u{626}\u{645} \u{631}\u{6CC}\u{646}\u{62C} \u{633}\u{6D2} \u{627}\u{648}\u{648}\u{631}\u{644}\u{6CC}\u{67E} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED9}t m\u{1EE5}c nh\u{1EAD}p b\u{1EA3}ng ch\u{1EA5}m c\xf4ng kh\xe1c cho c\xf9ng m\u{1ED9}t ng\u{1B0}\u{1EDD}i ti\xeau d\xf9ng tr\xf9ng l\u{1EB7}p v\u{1EDB}i ph\u{1EA1}m vi th\u{1EDD}i gian c\u{1EE7}a m\u{1EE5}c nh\u{1EAD}p n\xe0y.`,
    'zh-hans': `\u{540C}\u{4E00}\u{6D88}\u{8D39}\u{8005}\u{7684}\u{53E6}\u{4E00}\u{6761}\u{5DE5}\u{65F6}\u{8868}\u{6761}\u{76EE}\u{4E0E}\u{8BE5}\u{6761}\u{76EE}\u{7684}\u{65F6}\u{95F4}\u{8303}\u{56F4}\u{91CD}\u{53E0}\u{3002}`,
    'zh-hant': `\u{540C}\u{4E00}\u{6D88}\u{8CBB}\u{8005}\u{7684}\u{53E6}\u{4E00}\u{4EFD}\u{5DE5}\u{6642}\u{8868}\u{689D}\u{76EE}\u{8207}\u{8A72}\u{689D}\u{76EE}\u{7684}\u{6642}\u{9593}\u{7BC4}\u{570D}\u{91CD}\u{758A}\u{3002}`,
    en: `Another timesheet entry for the same consumer overlaps this entry\u{2019}s time range.`
};
const $b11db1b62d4a8f76$export$80e4b4299988994e = {
    ar: `\u{625}\u{62F}\u{62E}\u{627}\u{644} \u{645}\u{62A}\u{62F}\u{627}\u{62E}\u{644}`,
    de: `\xdcberlappende Eintr\xe4ge`,
    es: `Entrada solapada`,
    fa: `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{647}\u{627}\u{6CC} \u{647}\u{645}\u{67E}\u{648}\u{634}\u{627}\u{646}`,
    fil: `Magkakapatong na entry`,
    fr: `Entr\xe9e chevauch\xe9e`,
    hi: `\u{913}\u{935}\u{930}\u{932}\u{948}\u{92A}\u{93F}\u{902}\u{917} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F}`,
    ht: `Sip\xe8poze antre`,
    it: `Voce sovrapposta`,
    ja: `\u{91CD}\u{8907}\u{3059}\u{308B}\u{30A8}\u{30F3}\u{30C8}\u{30EA}\u{30FC}`,
    ko: `\u{C911}\u{BCF5} \u{C9C4}\u{C785}`,
    mww: `Kev nkag sib tshooj`,
    ps: `\u{647}\u{645}\u{63A}\u{696}\u{6CC} \u{628}\u{631}\u{62E}\u{647}`,
    pt: `Entrada sobreposta`,
    'pt-pt': `Entrada sobreposta`,
    ru: `\u{41F}\u{435}\u{440}\u{435}\u{43A}\u{440}\u{44B}\u{432}\u{430}\u{44E}\u{449}\u{430}\u{44F}\u{441}\u{44F} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Overlapping entry`,
    so: `Gelitaanka is-dul saaran`,
    th: `\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E17}\u{E31}\u{E1A}\u{E0B}\u{E49}\u{E2D}\u{E19}\u{E01}\u{E31}\u{E19}`,
    ur: `\u{627}\u{648}\u{648}\u{631}\u{644}\u{6CC}\u{67E}\u{646}\u{6AF} \u{627}\u{646}\u{679}\u{631}\u{6CC}`,
    vi: `M\u{1EE5}c nh\u{1EAD}p ch\u{1ED3}ng ch\xe9o`,
    'zh-hans': `\u{91CD}\u{53E0}\u{5165}\u{53E3}`,
    'zh-hant': `\u{91CD}\u{758A}\u{689D}\u{76EE}`,
    en: `Overlapping entry`
};
const $b11db1b62d4a8f76$export$88cfe6be810eca6f = {
    ar: `\u{625}\u{62F}\u{62E}\u{627}\u{644} \u{622}\u{62E}\u{631} \u{641}\u{64A} \u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{623}\u{648}\u{642}\u{627}\u{62A} \u{644}\u{646}\u{641}\u{633} \u{627}\u{644}\u{645}\u{648}\u{638}\u{641} \u{64A}\u{62A}\u{62F}\u{627}\u{62E}\u{644} \u{645}\u{639} \u{646}\u{637}\u{627}\u{642} \u{632}\u{645}\u{646}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644}.`,
    de: `Ein weiterer Stundenzetteleintrag f\xfcr denselben Mitarbeiter \xfcberschneidet sich mit dem Zeitrahmen dieses Eintrags.`,
    es: `Otra entrada de hoja de horas para el mismo empleado coincide con el rango temporal de esta entrada.`,
    fa: `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{62F}\u{6CC}\u{6AF}\u{631}\u{6CC} \u{62F}\u{631} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646} \u{628}\u{646}\u{62F}\u{6CC} \u{647}\u{645}\u{627}\u{646} \u{6A9}\u{627}\u{631}\u{645}\u{646}\u{62F} \u{628}\u{627} \u{628}\u{627}\u{632}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{627}\u{6CC}\u{646} \u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{647}\u{645}\u{67E}\u{648}\u{634}\u{627}\u{646}\u{6CC} \u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `Ang isa pang timesheet entry para sa parehong empleyado ay nag-overlap sa saklaw ng oras ng entry na ito.`,
    fr: `Une autre entr\xe9e de feuille de temps pour le m\xeame employ\xe9 recoupe la plage horaire de cette entr\xe9e.`,
    hi: `\u{90F}\u{915} \u{939}\u{940} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{928}\u{94D}\u{92F} \u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F} \u{907}\u{938} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{940} \u{938}\u{92E}\u{92F} \u{938}\u{940}\u{92E}\u{93E} \u{915}\u{94B} \u{913}\u{935}\u{930}\u{932}\u{948}\u{92A} \u{915}\u{930}\u{924}\u{940} \u{939}\u{948}\u{964}`,
    ht: `Yon l\xf2t antre Timesheet pou anplwaye a menm sip\xe8poze seri tan antre sa a.`,
    it: `Un'altra voce del foglio orario per lo stesso dipendente si sovrappone all'intervallo di questo momento.`,
    ja: `\u{540C}\u{3058}\u{5F93}\u{696D}\u{54E1}\u{306E}\u{5225}\u{306E}\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{306E}\u{8A18}\u{9332}\u{304C}\u{3001}\u{3053}\u{306E}\u{8A18}\u{9332}\u{306E}\u{6642}\u{9593}\u{7BC4}\u{56F2}\u{3068}\u{91CD}\u{8907}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{AC19}\u{C740} \u{C9C1}\u{C6D0}\u{C758} \u{B610} \u{B2E4}\u{B978} \u{ADFC}\u{BB34} \u{C2DC}\u{AC04}\u{D45C} \u{D56D}\u{BAA9}\u{C774} \u{C774} \u{AE30}\u{B85D}\u{C758} \u{C2DC}\u{AC04} \u{BC94}\u{C704}\u{C640} \u{ACB9}\u{CE69}\u{B2C8}\u{B2E4}.`,
    mww: `Lwm lub sij hawm nkag rau tib tus neeg ua hauj lwm overlaps no nkag lub sij hawm range.`,
    ps: `\u{62F} \u{647}\u{645}\u{62F}\u{6D0} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{628}\u{644}\u{647} \u{67C}\u{627}\u{6CC}\u{645} \u{634}\u{6CC}\u{67C} \u{62F} \u{62F}\u{6D0} \u{644}\u{6CC}\u{6A9}\u{646}\u{6D0} \u{62F} \u{648}\u{62E}\u{62A} \u{644}\u{647} \u{62D}\u{62F}\u{648}\u{62F}\u{648} \u{633}\u{631}\u{647} \u{62A}\u{62F}\u{627}\u{62E}\u{644} \u{644}\u{631}\u{6CC}.`,
    pt: `Outra entrada de folha de ponto para o mesmo funcion\xe1rio se sobrep\xf5e ao intervalo de tempo dessa entrada.`,
    'pt-pt': `Outra entrada na folha de horas para o mesmo funcion\xe1rio sobrep\xf5e-se ao intervalo temporal desta entrada.`,
    ru: `\u{414}\u{440}\u{443}\u{433}\u{430}\u{44F} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{432} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{435} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{434}\u{43B}\u{44F} \u{442}\u{43E}\u{433}\u{43E} \u{436}\u{435} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{430} \u{43F}\u{435}\u{440}\u{435}\u{441}\u{435}\u{43A}\u{430}\u{435}\u{442}\u{441}\u{44F} \u{441} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{44B}\u{43C} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{43E}\u{43C} \u{44D}\u{442}\u{43E}\u{439} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}.`,
    sm: `O le isi pepa o taimi mo le tagata faigaluega lava lea e tasi e fesiligia ai le taimi o lenei ulufale.`,
    so: `Qoraal kale oo timesheet ah oo loogu talagalay isla shaqaalahaas ayaa isku dul saaran waqtiga qoraalkan.`,
    th: `\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E41}\u{E1C}\u{E48}\u{E19}\u{E40}\u{E27}\u{E25}\u{E32}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E04}\u{E19}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E01}\u{E31}\u{E19}\u{E17}\u{E31}\u{E1A}\u{E0B}\u{E49}\u{E2D}\u{E19}\u{E01}\u{E31}\u{E1A}\u{E0A}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}\u{E02}\u{E2D}\u{E07}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633}\u{6CC} \u{645}\u{644}\u{627}\u{632}\u{645} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{627}\u{6CC}\u{6A9} \u{627}\u{648}\u{631} \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{627}\u{633} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{6A9}\u{6D2} \u{648}\u{642}\u{62A} \u{6A9}\u{6CC} \u{62D}\u{62F} \u{633}\u{6D2} \u{627}\u{648}\u{648}\u{631}\u{644}\u{6CC}\u{67E} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED9}t m\u{1EE5}c nh\u{1EAD}p b\u{1EA3}ng ch\u{1EA5}m c\xf4ng kh\xe1c cho c\xf9ng m\u{1ED9}t nh\xe2n vi\xean tr\xf9ng l\u{1EB7}p v\u{1EDB}i ph\u{1EA1}m vi th\u{1EDD}i gian c\u{1EE7}a m\u{1EE5}c nh\u{1EAD}p n\xe0y.`,
    'zh-hans': `\u{540C}\u{4E00}\u{5458}\u{5DE5}\u{7684}\u{53E6}\u{4E00}\u{6761}\u{5DE5}\u{65F6}\u{8868}\u{6761}\u{76EE}\u{4E0E}\u{8BE5}\u{6761}\u{76EE}\u{7684}\u{65F6}\u{95F4}\u{8303}\u{56F4}\u{91CD}\u{53E0}\u{3002}`,
    'zh-hant': `\u{540C}\u{4E00}\u{54E1}\u{5DE5}\u{7684}\u{53E6}\u{4E00}\u{4EFD}\u{5DE5}\u{6642}\u{8A18}\u{9304}\u{8207}\u{8A72}\u{5206}\u{9304}\u{7684}\u{6642}\u{9593}\u{7BC4}\u{570D}\u{91CD}\u{758A}\u{3002}`,
    en: `Another timesheet entry for the same employee overlaps this entry\u{2019}s time range.`
};
const $b11db1b62d4a8f76$export$f4f52c4510dda60c = {
    ar: `\u{62F}\u{62E}\u{648}\u{644} \u{627}\u{644}\u{645}\u{648}\u{638}\u{641}\u{64A}\u{646} \u{627}\u{644}\u{645}\u{62A}\u{62F}\u{627}\u{62E}\u{644}`,
    de: `\xdcberlappende Mitarbeitereintr\xe4ge`,
    es: `Entrada de empleados superpuesta`,
    fa: `\u{648}\u{631}\u{648}\u{62F} \u{647}\u{645}\u{67E}\u{648}\u{634}\u{627}\u{646} \u{6A9}\u{627}\u{631}\u{6A9}\u{646}\u{627}\u{646}`,
    fil: `Magkakapatong na pagpasok ng empleyado`,
    fr: `Entr\xe9e chevauchante des employ\xe9s`,
    hi: `\u{913}\u{935}\u{930}\u{932}\u{948}\u{92A}\u{93F}\u{902}\u{917} \u{915}\u{930}\u{94D}\u{92E}\u{91A}\u{93E}\u{930}\u{940} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F}`,
    ht: `Antre anplwaye sip\xe8poze`,
    it: `Sovrapposizione di inserimento di dipendenti`,
    ja: `\u{91CD}\u{8907}\u{3059}\u{308B}\u{5F93}\u{696D}\u{54E1}\u{30A8}\u{30F3}\u{30C8}\u{30EA}\u{30FC}`,
    ko: `\u{C9C1}\u{C6D0} \u{C785}\u{C6D0} \u{C911}\u{BCF5}`,
    mww: `Cov neeg ua haujlwm nkag mus sib tshooj`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{648} \u{6AB}\u{689}\u{6D0} \u{644}\u{6CC}\u{6A9}\u{646}\u{6D0}`,
    pt: `Entrada sobreposta de funcion\xe1rios`,
    'pt-pt': `Entrada sobreposta de funcion\xe1rios`,
    ru: `\u{41F}\u{435}\u{440}\u{435}\u{43A}\u{440}\u{44B}\u{432}\u{430}\u{44E}\u{449}\u{438}\u{435}\u{441}\u{44F} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438} \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{43A}\u{43E}\u{432}`,
    sm: `Overlapping employee entry`,
    so: `Qoraallo shaqaale oo is dul saaran`,
    th: `\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E1E}\u{E19}\u{E31}\u{E01}\u{E07}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E31}\u{E1A}\u{E0B}\u{E49}\u{E2D}\u{E19}\u{E01}\u{E31}\u{E19}`,
    ur: `\u{627}\u{648}\u{648}\u{631}\u{644}\u{6CC}\u{67E}\u{646}\u{6AF} \u{645}\u{644}\u{627}\u{632}\u{645}\u{6CC}\u{646} \u{6A9}\u{6CC} \u{634}\u{645}\u{648}\u{644}\u{6CC}\u{62A}`,
    vi: `M\u{1EE5}c nh\u{1EAD}p nh\xe2n vi\xean ch\u{1ED3}ng ch\xe9o`,
    'zh-hans': `\u{5458}\u{5DE5}\u{91CD}\u{53E0}\u{5165}\u{804C}`,
    'zh-hant': `\u{54E1}\u{5DE5}\u{91CD}\u{8907}\u{8F38}\u{5165}`,
    en: `Overlapping employee entry`
};
const $b11db1b62d4a8f76$export$c21719bd2673e2d1 = {
    ar: `\u{64A}\u{634}\u{645}\u{644} \u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{639}\u{645}\u{644} \u{627}\u{644}\u{625}\u{636}\u{627}\u{641}\u{64A}\u{60C} \u{644}\u{643}\u{646} \u{627}\u{644}\u{645}\u{64A}\u{632}\u{627}\u{646}\u{64A}\u{629} \u{63A}\u{64A}\u{631} \u{645}\u{633}\u{645}\u{648}\u{62D} \u{628}\u{627}\u{644}\u{639}\u{645}\u{644} \u{627}\u{644}\u{625}\u{636}\u{627}\u{641}\u{64A}.`,
    de: `Der Eintrag beinhaltet \xdcberstunden, aber \xdcberstunden sind laut Budget nicht erlaubt.`,
    es: `La entrada incluye horas extra, pero el presupuesto no permite horas extra.`,
    fa: `\u{648}\u{631}\u{648}\u{62F} \u{634}\u{627}\u{645}\u{644} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{627}\u{631}\u{6CC} \u{627}\u{633}\u{62A}\u{60C} \u{627}\u{645}\u{627} \u{628}\u{648}\u{62F}\u{62C}\u{647} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{627}\u{631}\u{6CC} \u{631}\u{627} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Kasama sa entry ang overtime, ngunit hindi pinapayagan ng badyet ang overtime.`,
    fr: `L\u{2019}entr\xe9e inclut les heures suppl\xe9mentaires, mais le budget n\u{2019}autorise pas les heures suppl\xe9mentaires.`,
    hi: `\u{92A}\u{94D}\u{930}\u{935}\u{947}\u{936} \u{92E}\u{947}\u{902} \u{913}\u{935}\u{930}\u{91F}\u{93E}\u{907}\u{92E} \u{936}\u{93E}\u{92E}\u{93F}\u{932} \u{939}\u{948}, \u{932}\u{947}\u{915}\u{93F}\u{928} \u{92C}\u{91C}\u{91F} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{913}\u{935}\u{930}\u{91F}\u{93E}\u{907}\u{92E} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{964}`,
    ht: `Antre a gen ladan siplemant\xe8, men l\xe8 siplemant\xe8 pa p\xe8m\xe8t pa bidj\xe8 a.`,
    it: `La voce include gli straordinari, ma il budget non \xe8 consentito.`,
    ja: `\u{8A18}\u{9332}\u{306B}\u{306F}\u{6B8B}\u{696D}\u{304C}\u{542B}\u{307E}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}\u{304C}\u{3001}\u{6B8B}\u{696D}\u{306F}\u{4E88}\u{7B97}\u{3067}\u{8A8D}\u{3081}\u{3089}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774} \u{D56D}\u{BAA9}\u{C5D0}\u{B294} \u{CD08}\u{ACFC}\u{ADFC}\u{BB34}\u{AC00} \u{D3EC}\u{D568}\u{B418}\u{C9C0}\u{B9CC}, \u{C608}\u{C0B0}\u{C0C1} \u{CD08}\u{ACFC}\u{ADFC}\u{BB34}\u{B294} \u{D5C8}\u{C6A9}\u{B418}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Kev nkag mus suav nrog kev ua haujlwm dhau sijhawm, tab sis kev ua haujlwm dhau sijhawm tsis raug tso cai los ntawm pob nyiaj siv.`,
    ps: `\u{6AB}\u{689}\u{648}\u{646} \u{6A9}\u{6D0} \u{627}\u{636}\u{627}\u{641}\u{6CC} \u{648}\u{62E}\u{62A} \u{634}\u{627}\u{645}\u{644} \u{62F}\u{6CC}\u{60C} \u{62E}\u{648} \u{62F} \u{628}\u{648}\u{62F}\u{6CC}\u{62C}\u{6D0} \u{644}\u{647} \u{645}\u{62E}\u{6D0} \u{627}\u{636}\u{627}\u{641}\u{6CC} \u{648}\u{62E}\u{62A} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: `A entrada inclui horas extras, mas o or\xe7amento n\xe3o permite horas extras.`,
    'pt-pt': `A entrada inclui horas extraordin\xe1rias, mas o or\xe7amento n\xe3o permite horas extraordin\xe1rias.`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{435}\u{442} \u{441}\u{432}\u{435}\u{440}\u{445}\u{443}\u{440}\u{43E}\u{447}\u{43D}\u{44B}\u{435}, \u{43D}\u{43E} \u{441}\u{432}\u{435}\u{440}\u{445}\u{443}\u{440}\u{43E}\u{447}\u{43D}\u{44B}\u{435} \u{43D}\u{435} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{44B} \u{431}\u{44E}\u{434}\u{436}\u{435}\u{442}\u{43E}\u{43C}.`,
    sm: `O le ulufale e aofia ai ovataimi, ae e le faatagaina ovataimi e le paketi.`,
    so: `Gelitaanka waxaa ku jira saacado dheeraad ah, laakiin waqtiga dheeraadka ah ma oggola miisaaniyadda.`,
    th: `\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E23}\u{E27}\u{E21}\u{E01}\u{E32}\u{E23}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E25}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32} \u{E41}\u{E15}\u{E48}\u{E07}\u{E1A}\u{E1B}\u{E23}\u{E30}\u{E21}\u{E32}\u{E13}\u{E44}\u{E21}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E25}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}`,
    ur: `\u{62F}\u{627}\u{62E}\u{644}\u{6C1} \u{645}\u{6CC}\u{6BA} \u{627}\u{648}\u{648}\u{631} \u{679}\u{627}\u{626}\u{645} \u{634}\u{627}\u{645}\u{644} \u{6C1}\u{6D2}\u{60C} \u{644}\u{6CC}\u{6A9}\u{646} \u{628}\u{62C}\u{679} \u{645}\u{6CC}\u{6BA} \u{627}\u{648}\u{648}\u{631} \u{679}\u{627}\u{626}\u{645} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Nh\u{1EAD}p c\u{1EA3}nh bao g\u{1ED3}m l\xe0m th\xeam gi\u{1EDD}, nh\u{1B0}ng ng\xe2n s\xe1ch kh\xf4ng cho ph\xe9p l\xe0m th\xeam gi\u{1EDD}.`,
    'zh-hans': `\u{5F55}\u{5165}\u{5305}\u{62EC}\u{52A0}\u{73ED}\u{FF0C}\u{4F46}\u{9884}\u{7B97}\u{4E0D}\u{5141}\u{8BB8}\u{52A0}\u{73ED}\u{3002}`,
    'zh-hant': `\u{5831}\u{540D}\u{5305}\u{542B}\u{52A0}\u{73ED}\u{FF0C}\u{4F46}\u{9810}\u{7B97}\u{4E0D}\u{5141}\u{8A31}\u{52A0}\u{73ED}\u{3002}`,
    en: `The entry includes overtime, but overtime is not allowed by the budget.`
};
const $b11db1b62d4a8f76$export$c45fac2d0f300835 = {
    ar: `\u{627}\u{644}\u{639}\u{645}\u{644} \u{627}\u{644}\u{625}\u{636}\u{627}\u{641}\u{64A} \u{63A}\u{64A}\u{631} \u{645}\u{633}\u{645}\u{648}\u{62D} \u{628}\u{647}`,
    de: `\xdcberstunden sind nicht erlaubt`,
    es: `No se permiten horas extra`,
    fa: `\u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{627}\u{631}\u{6CC} \u{645}\u{62C}\u{627}\u{632} \u{646}\u{6CC}\u{633}\u{62A}`,
    fil: `Hindi pinapayagan ang overtime`,
    fr: `Les heures suppl\xe9mentaires non autoris\xe9es`,
    hi: `\u{913}\u{935}\u{930}\u{91F}\u{93E}\u{907}\u{92E} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}`,
    ht: `Tan siplemant\xe8 pa p\xe8m\xe8t`,
    it: `Straordinari non consentiti`,
    ja: `\u{6B8B}\u{696D}\u{7981}\u{6B62}`,
    ko: `\u{CD08}\u{ACFC} \u{ADFC}\u{BB34}\u{B294} \u{D5C8}\u{C6A9}\u{B418}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis pub ua haujlwm dhau sijhawm`,
    ps: `\u{627}\u{636}\u{627}\u{641}\u{6CC} \u{648}\u{62E}\u{62A} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{647} \u{644}\u{631}\u{6CC}`,
    pt: `Hora extra n\xe3o permitida`,
    'pt-pt': `Horas extraordin\xe1rias n\xe3o permitidas`,
    ru: `\u{421}\u{432}\u{435}\u{440}\u{445}\u{443}\u{440}\u{43E}\u{447}\u{43D}\u{44B}\u{435} \u{437}\u{430}\u{43D}\u{44F}\u{442}\u{438}\u{44F} \u{437}\u{430}\u{43F}\u{440}\u{435}\u{449}\u{435}\u{43D}\u{44B}`,
    sm: `E le faatagaina ovataimi`,
    so: `Waqti dheeri ah lama oggola`,
    th: `\u{E44}\u{E21}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E25}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}`,
    ur: `\u{627}\u{648}\u{648}\u{631} \u{679}\u{627}\u{626}\u{645} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng \u{111}\u{1B0}\u{1EE3}c ph\xe9p l\xe0m th\xeam gi\u{1EDD}`,
    'zh-hans': `\u{4E0D}\u{5141}\u{8BB8}\u{52A0}\u{65F6}`,
    'zh-hant': `\u{4E0D}\u{5141}\u{8A31}\u{52A0}\u{73ED}`,
    en: `Overtime not permitted`
};
const $b11db1b62d4a8f76$export$ab38a4004d0897a7 = {
    ar: `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{62A}\u{635}\u{646}\u{64A}\u{641} \u{647}\u{630}\u{627} \u{627}\u{644}\u{625}\u{62F}\u{62E}\u{627}\u{644} \u{641}\u{64A} \u{627}\u{644}\u{639}\u{645}\u{644} \u{627}\u{644}\u{625}\u{636}\u{627}\u{641}\u{64A} \u{644}\u{644}\u{631}\u{648}\u{627}\u{62A}\u{628} \u{62D}\u{62A}\u{649} \u{64A}\u{62A}\u{645} \u{62D}\u{644} \u{627}\u{644}\u{623}\u{62E}\u{637}\u{627}\u{621} \u{627}\u{644}\u{633}\u{627}\u{628}\u{642}\u{629} \u{641}\u{64A} \u{646}\u{641}\u{633} \u{623}\u{633}\u{628}\u{648}\u{639} \u{627}\u{644}\u{639}\u{645}\u{644}.`,
    de: `Dieser \xdcberstundeneintrag kann nicht f\xfcr die Lohnabrechnung klassifiziert werden, bis fr\xfchere Fehler in derselben Arbeitswoche behoben sind.`,
    es: `Esta entrada de horas extra no puede clasificarse para n\xf3mina hasta que se resuelvan errores anteriores en la misma semana laboral.`,
    fa: `\u{627}\u{6CC}\u{646} \u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{627}\u{631}\u{6CC} \u{62A}\u{627} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{627}\u{634}\u{62A}\u{628}\u{627}\u{647}\u{627}\u{62A} \u{642}\u{628}\u{644}\u{6CC} \u{62F}\u{631} \u{647}\u{645}\u{627}\u{646} \u{647}\u{641}\u{62A}\u{647} \u{6A9}\u{627}\u{631}\u{6CC} \u{628}\u{631}\u{637}\u{631}\u{641} \u{646}\u{634}\u{648}\u{62F}\u{60C} \u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{628}\u{631}\u{627}\u{6CC} \u{62D}\u{642}\u{648}\u{642} \u{648} \u{62F}\u{633}\u{62A}\u{645}\u{632}\u{62F} \u{637}\u{628}\u{642}\u{647} \u{628}\u{646}\u{62F}\u{6CC} \u{634}\u{648}\u{62F}.`,
    fil: `Ang overtime entry na ito ay hindi maaaring maiuri para sa payroll hangga't hindi nalutas ang mga naunang pagkakamali sa parehong linggo ng trabaho.`,
    fr: `Cette saisie des heures suppl\xe9mentaires ne peut pas \xeatre class\xe9e pour la paie tant que les erreurs ant\xe9rieures de la m\xeame semaine de travail ne sont pas r\xe9solues.`,
    hi: `\u{907}\u{938} \u{913}\u{935}\u{930}\u{91F}\u{93E}\u{907}\u{92E} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{94B} \u{92A}\u{947}\u{930}\u{94B}\u{932} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{924}\u{92C} \u{924}\u{915} \u{935}\u{930}\u{94D}\u{917}\u{940}\u{915}\u{943}\u{924} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{91C}\u{92C} \u{924}\u{915} \u{915}\u{93F} \u{90F}\u{915} \u{939}\u{940} \u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{938}\u{92A}\u{94D}\u{924}\u{93E}\u{939} \u{92E}\u{947}\u{902} \u{92A}\u{939}\u{932}\u{947} \u{915}\u{940} \u{924}\u{94D}\u{930}\u{941}\u{91F}\u{93F}\u{92F}\u{93E}\u{901} \u{939}\u{932} \u{928}\u{939}\u{940}\u{902} \u{939}\u{94B} \u{91C}\u{93E}\u{924}\u{940}\u{902}\u{964}`,
    ht: `Antre siplemant\xe8 sa a pa ka klase pou pew\xf2l jiskaske er\xe8 pi bon\xe8 nan sem\xe8n travay la menm rezoud.`,
    it: `Questa registrazione degli straordinari non pu\xf2 essere classificata per la busta paga finch\xe9 non vengono risolti errori precedenti nella stessa settimana lavorativa.`,
    ja: `\u{3053}\u{306E}\u{6B8B}\u{696D}\u{8A18}\u{9332}\u{306F}\u{3001}\u{540C}\u{3058}\u{9031}\u{306E}\u{4EE5}\u{524D}\u{306E}\u{30A8}\u{30E9}\u{30FC}\u{304C}\u{89E3}\u{6C7A}\u{3055}\u{308C}\u{308B}\u{307E}\u{3067}\u{7D66}\u{4E0E}\u{8A08}\u{7B97}\u{306B}\u{5206}\u{985E}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774} \u{CD08}\u{ACFC}\u{ADFC}\u{BB34} \u{AE30}\u{B85D}\u{C740} \u{AC19}\u{C740} \u{ADFC}\u{BB34} \u{C8FC}\u{C5D0} \u{BC1C}\u{C0DD}\u{D55C} \u{C774}\u{C804} \u{C624}\u{B958}\u{AC00} \u{D574}\u{ACB0}\u{B418}\u{AE30} \u{C804}\u{AE4C}\u{C9C0}\u{B294} \u{AE09}\u{C5EC} \u{CC98}\u{B9AC}\u{C5D0} \u{D3EC}\u{D568}\u{B418}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kev nkag mus ua haujlwm dhau no tsis tuaj yeem muab cais rau cov nyiaj them poob haujlwm kom txog thaum daws cov kev ua yuam kev ua ntej hauv tib lub limtiam ua haujlwm.`,
    ps: `\u{62F}\u{627} \u{627}\u{636}\u{627}\u{641}\u{6CC} \u{648}\u{62E}\u{62A} \u{62B}\u{628}\u{62A} \u{62A}\u{631} \u{647}\u{63A}\u{647} \u{648}\u{62E}\u{62A}\u{647} \u{67E}\u{648}\u{631}\u{6D0} \u{62F} \u{645}\u{639}\u{627}\u{634} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{637}\u{628}\u{642}\u{647} \u{628}\u{646}\u{62F}\u{6CC} \u{646}\u{634}\u{6CC} \u{6A9}\u{6D0}\u{62F}\u{627}\u{6CC} \u{62A}\u{631} \u{685}\u{648} \u{686}\u{6D0} \u{67E}\u{647} \u{647}\u{645}\u{627}\u{63A}\u{647} \u{6A9}\u{627}\u{631}\u{6CC} \u{627}\u{648}\u{646}\u{6CD} \u{6A9}\u{6D0} \u{67E}\u{62E}\u{648}\u{627}\u{646}\u{6CD} \u{62A}\u{6D0}\u{631}\u{648}\u{62A}\u{646}\u{6D0} \u{62D}\u{644} \u{646}\u{647} \u{634}\u{6CC}.`,
    pt: `Essa entrada de horas extras n\xe3o pode ser classificada para folha de pagamento at\xe9 que erros anteriores na mesma semana de trabalho sejam resolvidos.`,
    'pt-pt': `Este registo de horas extra n\xe3o pode ser classificado para processamento salarial at\xe9 que erros anteriores na mesma semana de trabalho sejam resolvidos.`,
    ru: `\u{42D}\u{442}\u{430} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{43E} \u{441}\u{432}\u{435}\u{440}\u{445}\u{443}\u{440}\u{43E}\u{447}\u{43D}\u{43E}\u{439} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{435} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{43A}\u{43B}\u{430}\u{441}\u{441}\u{438}\u{444}\u{438}\u{446}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{430} \u{434}\u{43B}\u{44F} \u{440}\u{430}\u{441}\u{447}\u{435}\u{442}\u{430} \u{437}\u{430}\u{440}\u{43F}\u{43B}\u{430}\u{442}\u{44B}, \u{43F}\u{43E}\u{43A}\u{430} \u{43D}\u{435} \u{431}\u{443}\u{434}\u{443}\u{442} \u{443}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{44B} \u{43F}\u{440}\u{435}\u{434}\u{44B}\u{434}\u{443}\u{449}\u{438}\u{435} \u{43E}\u{448}\u{438}\u{431}\u{43A}\u{438} \u{432} \u{442}\u{43E}\u{439} \u{436}\u{435} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{439} \u{43D}\u{435}\u{434}\u{435}\u{43B}\u{435}.`,
    sm: `E le mafai ona faavasegaina lenei faamaumauga o ovataimi mo le lisi o totogi sei vagana ua foia ni mea sese na muamua atu i le vaiaso faigaluega lava lea e tasi.`,
    so: `Qoraalkan saacadaha dheeraadka ah lama kala saari karo mushaharka ilaa khaladaadkii hore ee isla usbuuca shaqada la xalliyo.`,
    th: `\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E25}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}\u{E19}\u{E35}\u{E49}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E08}\u{E31}\u{E14}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}\u{E40}\u{E07}\u{E34}\u{E19}\u{E40}\u{E14}\u{E37}\u{E2D}\u{E19}\u{E44}\u{E14}\u{E49}\u{E08}\u{E19}\u{E01}\u{E27}\u{E48}\u{E32}\u{E02}\u{E49}\u{E2D}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}\u{E43}\u{E19}\u{E2A}\u{E31}\u{E1B}\u{E14}\u{E32}\u{E2B}\u{E4C}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E01}\u{E31}\u{E19}\u{E08}\u{E30}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}`,
    ur: `\u{6CC}\u{6C1} \u{627}\u{648}\u{648}\u{631} \u{679}\u{627}\u{626}\u{645} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{627}\u{633} \u{648}\u{642}\u{62A} \u{62A}\u{6A9} \u{67E}\u{6D2} \u{631}\u{648}\u{644} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{62F}\u{631}\u{62C}\u{6C1} \u{628}\u{646}\u{62F} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{627} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{627} \u{62C}\u{628} \u{62A}\u{6A9} \u{6A9}\u{6C1} \u{627}\u{633}\u{6CC} \u{648}\u{631}\u{6A9} \u{648}\u{6CC}\u{6A9} \u{645}\u{6CC}\u{6BA} \u{67E}\u{6C1}\u{644}\u{6D2} \u{6A9}\u{6CC} \u{63A}\u{644}\u{637}\u{6CC}\u{627}\u{6BA} \u{62F}\u{648}\u{631} \u{646}\u{6C1} \u{6C1}\u{648} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `M\u{1EE5}c nh\u{1EAD}p l\xe0m th\xeam gi\u{1EDD} n\xe0y kh\xf4ng th\u{1EC3} \u{111}\u{1B0}\u{1EE3}c ph\xe2n lo\u{1EA1}i v\xe0o b\u{1EA3}ng l\u{1B0}\u{1A1}ng cho \u{111}\u{1EBF}n khi c\xe1c l\u{1ED7}i tr\u{1B0}\u{1EDB}c \u{111}\xf3 trong c\xf9ng m\u{1ED9}t tu\u{1EA7}n l\xe0m vi\u{1EC7}c \u{111}\u{1B0}\u{1EE3}c gi\u{1EA3}i quy\u{1EBF}t.`,
    'zh-hans': `\u{5728}\u{89E3}\u{51B3}\u{540C}\u{5DE5}\u{4F5C}\u{5468}\u{65E9}\u{671F}\u{9519}\u{8BEF}\u{4E4B}\u{524D}\u{FF0C}\u{8FD9}\u{79CD}\u{52A0}\u{73ED}\u{8BB0}\u{5F55}\u{4E0D}\u{80FD}\u{5F52}\u{7C7B}\u{4E3A}\u{5DE5}\u{8D44}\u{5355}\u{3002}`,
    'zh-hant': `\u{6B64}\u{52A0}\u{73ED}\u{5206}\u{9304}\u{5FC5}\u{9808}\u{5148}\u{89E3}\u{6C7A}\u{540C}\u{4E00}\u{5DE5}\u{4F5C}\u{9031}\u{5167}\u{8F03}\u{65E9}\u{7684}\u{932F}\u{8AA4}\u{FF0C}\u{5426}\u{5247}\u{7121}\u{6CD5}\u{6B78}\u{985E}\u{70BA}\u{85AA}\u{8CC7}\u{3002}`,
    en: `This overtime entry cannot be classified for payroll until earlier errors in the same workweek are resolved.`
};
const $b11db1b62d4a8f76$export$766648b9c685e14a = {
    ar: `\u{627}\u{644}\u{623}\u{62E}\u{637}\u{627}\u{621} \u{627}\u{644}\u{633}\u{627}\u{628}\u{642}\u{629} \u{62A}\u{645}\u{646}\u{639} \u{62A}\u{635}\u{646}\u{64A}\u{641} \u{627}\u{644}\u{639}\u{645}\u{644} \u{627}\u{644}\u{625}\u{636}\u{627}\u{641}\u{64A}`,
    de: `Prior-Fehler blocken die \xdcberzeitklassifikation`,
    es: `Los errores previos bloquean la clasificaci\xf3n en tiempo extra`,
    fa: `\u{62E}\u{637}\u{627}\u{647}\u{627}\u{6CC} \u{642}\u{628}\u{644}\u{6CC} \u{645}\u{627}\u{646}\u{639} \u{637}\u{628}\u{642}\u{647} \u{628}\u{646}\u{62F}\u{6CC} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{627}\u{631}\u{6CC} \u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}`,
    fil: `Ang mga naunang pagkakamali ay nakaharang sa pag-uuri ng overtime`,
    fr: `Les erreurs ant\xe9rieures bloquent la classification en temps additionnel`,
    hi: `\u{92A}\u{942}\u{930}\u{94D}\u{935} \u{924}\u{94D}\u{930}\u{941}\u{91F}\u{93F}\u{92F}\u{93E}\u{901} \u{913}\u{935}\u{930}\u{91F}\u{93E}\u{907}\u{92E} \u{935}\u{930}\u{94D}\u{917}\u{940}\u{915}\u{930}\u{923} \u{915}\u{94B} \u{905}\u{935}\u{930}\u{941}\u{926}\u{94D}\u{927} \u{915}\u{930}\u{924}\u{940} \u{939}\u{948}\u{902}`,
    ht: `Er\xe8 anvan yo bloke klasifikasyon siplemant\xe8`,
    it: `Gli errori precedenti bloccano la classificazione degli overtime`,
    ja: `\u{4E8B}\u{524D}\u{8AA4}\u{308A}\u{306F}\u{5EF6}\u{9577}\u{6642}\u{9593}\u{5206}\u{985E}\u{3092}\u{30D6}\u{30ED}\u{30C3}\u{30AF}\u{3057}\u{307E}\u{3059}`,
    ko: `\u{C0AC}\u{C804} \u{C624}\u{B958}\u{B294} \u{C5F0}\u{C7A5}\u{C804} \u{BD84}\u{B958}\u{B97C} \u{CC28}\u{B2E8}\u{D569}\u{B2C8}\u{B2E4}`,
    mww: `Ua ntej yuam kev thaiv kev faib tawm sijhawm dhau sijhawm`,
    ps: `\u{645}\u{62E}\u{6A9}\u{6CC}\u{646}\u{6CC} \u{62A}\u{6D0}\u{631}\u{648}\u{62A}\u{646}\u{6D0} \u{62F} \u{627}\u{636}\u{627}\u{641}\u{6CC} \u{648}\u{62E}\u{62A} \u{637}\u{628}\u{642}\u{647} \u{628}\u{646}\u{62F}\u{6CC} \u{645}\u{62E}\u{647} \u{646}\u{6CC}\u{633}\u{6CC}`,
    pt: `Erros anteriores bloqueiam a classifica\xe7\xe3o em tempo extra`,
    'pt-pt': `Erros anteriores bloqueiam a classifica\xe7\xe3o em prolongamento`,
    ru: `\u{41F}\u{440}\u{435}\u{434}\u{44B}\u{434}\u{443}\u{449}\u{438}\u{435} \u{43E}\u{448}\u{438}\u{431}\u{43A}\u{438} \u{431}\u{43B}\u{43E}\u{43A}\u{438}\u{440}\u{443}\u{44E}\u{442} \u{43A}\u{43B}\u{430}\u{441}\u{441}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{44E} \u{43E}\u{432}\u{435}\u{440}\u{442}\u{430}\u{439}\u{43C}\u{430}`,
    sm: `O mea sese na muamua atu e poloka ai le faavasegaina o ovataimi`,
    so: `Khaladaadkii hore ayaa xannibay kala soocidda waqtiga dheeraadka ah`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}\u{E1A}\u{E25}\u{E47}\u{E2D}\u{E01}\u{E01}\u{E32}\u{E23}\u{E08}\u{E4D}\u{E32}\u{E41}\u{E19}\u{E01}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}\u{E01}\u{E32}\u{E23}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E25}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}`,
    ur: `\u{633}\u{627}\u{628}\u{642}\u{6C1} \u{63A}\u{644}\u{637}\u{6CC}\u{627}\u{6BA} \u{627}\u{648}\u{648}\u{631} \u{679}\u{627}\u{626}\u{645} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62C}\u{6C1} \u{628}\u{646}\u{62F}\u{6CC} \u{6A9}\u{648} \u{631}\u{648}\u{6A9}\u{62A}\u{6CC} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `C\xe1c l\u{1ED7}i tr\u{1B0}\u{1EDB}c \u{111}\xf3 ch\u{1EB7}n ph\xe2n lo\u{1EA1}i l\xe0m th\xeam gi\u{1EDD}`,
    'zh-hans': `\u{5148}\u{9A8C}\u{9519}\u{8BEF}\u{963B}\u{6321}\u{52A0}\u{65F6}\u{8D5B}\u{5206}\u{7C7B}`,
    'zh-hant': `\u{5148}\u{524D}\u{932F}\u{8AA4}\u{5340}\u{584A}\u{52A0}\u{6642}\u{5206}\u{985E}`,
    en: `Prior errors block overtime classification`
};
const $b11db1b62d4a8f76$export$64c56aad72790792 = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644} \u{644}\u{64A}\u{633} \u{636}\u{645}\u{646} \u{62A}\u{648}\u{627}\u{631}\u{64A}\u{62E} \u{628}\u{62F}\u{621} \u{648}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621} \u{62A}\u{641}\u{648}\u{64A}\u{636} \u{627}\u{644}\u{62E}\u{62F}\u{645}\u{629}.`,
    de: `Das Arbeitsdatum liegt nicht im Start- und Enddatum der Dienstgenehmigung.`,
    es: `La fecha de trabajo no est\xe1 dentro de las fechas de inicio y fin de la autorizaci\xf3n de servicio.`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{62F}\u{631} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{647}\u{627}\u{6CC} \u{634}\u{631}\u{648}\u{639} \u{648} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{645}\u{62C}\u{648}\u{632} \u{62E}\u{62F}\u{645}\u{62A} \u{642}\u{631}\u{627}\u{631} \u{646}\u{645}\u{6CC} \u{6AF}\u{6CC}\u{631}\u{62F}.`,
    fil: `Ang petsa ng trabaho ay hindi nasa loob ng mga petsa ng pagsisimula at pagtatapos ng pahintulot sa serbisyo.`,
    fr: `La date de travail ne correspond pas aux dates de d\xe9but et de fin de l\u{2019}autorisation de service.`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915} \u{938}\u{947}\u{935}\u{93E} \u{92A}\u{94D}\u{930}\u{93E}\u{927}\u{93F}\u{915}\u{930}\u{923} \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{914}\u{930} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915} \u{915}\u{947} \u{92D}\u{940}\u{924}\u{930} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}.`,
    ht: `Dat travay la pa nan dat otorizasyon s\xe8vis la k\xf2manse ak fen`,
    it: `La data di lavoro non rientra nelle date di inizio e fine dell'autorizzazione al servizio.`,
    ja: `\u{4F5C}\u{696D}\u{65E5}\u{306F}\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{627F}\u{8A8D}\u{306E}\u{958B}\u{59CB}\u{65E5}\u{3068}\u{7D42}\u{4E86}\u{65E5}\u{5185}\u{306B}\u{542B}\u{307E}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C791}\u{C5C5} \u{B0A0}\u{C9DC}\u{B294} \u{C11C}\u{BE44}\u{C2A4} \u{C2B9}\u{C778} \u{C2DC}\u{C791} \u{BC0F} \u{C885}\u{B8CC}\u{C77C} \u{B0B4}\u{C5D0} \u{D3EC}\u{D568}\u{B418}\u{C5B4} \u{C788}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Hnub ua hauj lwm tsis nyob rau hauv daim ntawv tso cai kev pab cuam pib thiab xaus hnub.`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6D0}\u{67C}\u{647} \u{62F} \u{62E}\u{62F}\u{645}\u{62A} \u{62F} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{62F} \u{67E}\u{6CC}\u{644} \u{627}\u{648} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{648} \u{62F}\u{646}\u{646}\u{647} \u{646}\u{647} \u{62F}\u{647}.`,
    pt: `A data de trabalho n\xe3o est\xe1 dentro das datas de in\xedcio e t\xe9rmino da autoriza\xe7\xe3o de servi\xe7o.`,
    'pt-pt': `A data de trabalho n\xe3o est\xe1 dentro das datas de in\xedcio e fim da autoriza\xe7\xe3o de servi\xe7o.`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{43D}\u{435} \u{432}\u{445}\u{43E}\u{434}\u{438}\u{442} \u{432} \u{434}\u{430}\u{442}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{44F} \u{43D}\u{430} \u{441}\u{43B}\u{443}\u{436}\u{431}\u{443}.`,
    sm: `O le aso faigaluega e le o i totonu o le aso amata ma le aso e faamuta ai le faatagaga o le auaunaga.`,
    so: `Taariikhda shaqada kuma jirto taariikhaha bilowga iyo dhammaadka ogolaanshaha adeegga.`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E44}\u{E21}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E20}\u{E32}\u{E22}\u{E43}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E41}\u{E25}\u{E30}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{633}\u{631}\u{648}\u{633} \u{622}\u{62A}\u{6BE}\u{648}\u{631}\u{627}\u{626}\u{632}\u{6CC}\u{634}\u{646} \u{6A9}\u{6D2} \u{622}\u{63A}\u{627}\u{632} \u{627}\u{648}\u{631} \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{648}\u{6BA} \u{645}\u{6CC}\u{6BA} \u{634}\u{627}\u{645}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ng\xe0y l\xe0m vi\u{1EC7}c kh\xf4ng n\u{1EB1}m trong ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u v\xe0 ng\xe0y k\u{1EBF}t th\xfac \u{1EE7}y quy\u{1EC1}n d\u{1ECB}ch v\u{1EE5}.`,
    'zh-hans': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{4E0D}\u{5728}\u{670D}\u{52A1}\u{6388}\u{6743}\u{7684}\u{5F00}\u{59CB}\u{548C}\u{7ED3}\u{675F}\u{65E5}\u{671F}\u{5185}\u{3002}`,
    'zh-hant': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{4E0D}\u{5728}\u{670D}\u{52D9}\u{6388}\u{6B0A}\u{7684}\u{958B}\u{59CB}\u{8207}\u{7D50}\u{675F}\u{65E5}\u{671F}\u{5167}\u{3002}`,
    en: `The work date is not within the service authorization start and end dates.`
};
const $b11db1b62d4a8f76$export$16c9e7432b0ec044 = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{639}\u{645}\u{644} \u{62E}\u{627}\u{631}\u{62C} \u{62A}\u{648}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{62A}\u{641}\u{648}\u{64A}\u{636}`,
    de: `Arbeitstermin au\xdferhalb der Genehmigungsdaten`,
    es: `Fecha de trabajo fuera de las fechas de autorizaci\xf3n`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{627}\u{631}\u{6CC} \u{62E}\u{627}\u{631}\u{62C} \u{627}\u{632} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{647}\u{627}\u{6CC} \u{645}\u{62C}\u{648}\u{632}`,
    fil: `Petsa ng trabaho sa labas ng mga petsa ng awtorisasyon`,
    fr: `Date de travail hors dates d\u{2019}autorisation`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{927}\u{93F}\u{915}\u{930}\u{923} \u{924}\u{93F}\u{925}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{947} \u{92C}\u{93E}\u{939}\u{930} \u{915}\u{93E}\u{930}\u{94D}\u{92F} \u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915}`,
    ht: `Dat travay andey\xf2 dat otorizasyon`,
    it: `Data di lavoro fuori dalle date di autorizzazione`,
    ja: `\u{8A31}\u{53EF}\u{65E5}\u{5916}\u{306E}\u{4F5C}\u{696D}\u{65E5}`,
    ko: `\u{C2B9}\u{C778} \u{B0A0}\u{C9DC} \u{C678}\u{C758} \u{C791}\u{C5C5} \u{B0A0}\u{C9DC}`,
    mww: `Hnub ua haujlwm sab nraud ntawm cov hnub tso cai`,
    ps: `\u{62F} \u{627}\u{62C}\u{627}\u{632}\u{6D0} \u{646}\u{6CC}\u{67C}\u{648} \u{685}\u{62E}\u{647} \u{628}\u{647}\u{631} \u{62F} \u{6A9}\u{627}\u{631} \u{646}\u{6CC}\u{67C}\u{647}`,
    pt: `Data de trabalho fora das datas de autoriza\xe7\xe3o`,
    'pt-pt': `Data de trabalho fora das datas de autoriza\xe7\xe3o`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{44B} \u{432}\u{43D}\u{435} \u{434}\u{430}\u{442}\u{44B} \u{430}\u{432}\u{442}\u{43E}\u{440}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Aso faigaluega i fafo atu o aso e faataga ai`,
    so: `Taariikhda shaqada ee ka baxsan taariikhaha oggolaanshihiisa`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E19}\u{E2D}\u{E01}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}`,
    ur: `\u{627}\u{62C}\u{627}\u{632}\u{62A} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{648}\u{6BA} \u{6A9}\u{6D2} \u{628}\u{627}\u{6C1}\u{631} \u{6A9}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y l\xe0m vi\u{1EC7}c ngo\xe0i ng\xe0y \u{1EE7}y quy\u{1EC1}n`,
    'zh-hans': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{8D85}\u{51FA}\u{6388}\u{6743}\u{65E5}\u{671F}`,
    'zh-hant': `\u{5DE5}\u{4F5C}\u{65E5}\u{671F}\u{8D85}\u{51FA}\u{6388}\u{6B0A}\u{65E5}\u{671F}`,
    en: `Work date outside authorization dates`
};
const $b11db1b62d4a8f76$export$c740e03774633827 = {
    ar: `\u{627}\u{644}\u{646}\u{648}\u{639}`,
    de: `Typ`,
    es: `Tipo`,
    fa: `\u{646}\u{648}\u{639}`,
    fil: `Uri`,
    fr: `Type`,
    hi: `\u{92A}\u{94D}\u{930}\u{915}\u{93E}\u{930}`,
    ht: `Kalite`,
    it: `Tipo`,
    ja: `\u{7A2E}\u{985E}`,
    ko: `\u{C720}\u{D615}`,
    mww: `Hom`,
    ps: `\u{689}\u{648}\u{644}`,
    pt: `Tipo`,
    'pt-pt': `Tipo`,
    ru: `\u{422}\u{438}\u{43F}`,
    sm: `Ituaiga`,
    so: `Nooca`,
    th: `\u{E0A}\u{E19}\u{E34}\u{E14}\u{E20}\u{E32}\u{E1E}\u{E40}\u{E02}\u{E35}\u{E22}\u{E19}`,
    ur: `\u{642}\u{633}\u{645}`,
    vi: `Ki\u{1EC3}u`,
    'zh-hans': `\u{7C7B}\u{578B}`,
    'zh-hant': `\u{985E}\u{578B}`,
    en: `Type`
};
const $b11db1b62d4a8f76$export$2f8dde2e869bc7b8 = {
    ar: `\u{628}\u{644}\u{627} \u{625}\u{62C}\u{627}\u{628}\u{629}`,
    de: `Unbeantwortet`,
    es: `Sin respuesta`,
    fa: `\u{628}\u{6CC} \u{67E}\u{627}\u{633}\u{62E}`,
    fil: `Hindi nasagot`,
    fr: `Sans r\xe9ponse`,
    hi: `\u{905}\u{928}\u{941}\u{924}\u{94D}\u{924}\u{930}\u{93F}\u{924}`,
    ht: `San repons`,
    it: `Senza risposta`,
    ja: `\u{8FD4}\u{4E8B}\u{306A}\u{3057}`,
    ko: `\u{B2F5}\u{BCC0} \u{C5C6}\u{C74C}`,
    mww: `Tsis teb`,
    ps: `\u{628}\u{6D0} \u{681}\u{648}\u{627}\u{628}\u{647}`,
    pt: `Sem resposta`,
    'pt-pt': `Sem resposta`,
    ru: `\u{411}\u{435}\u{437} \u{43E}\u{442}\u{432}\u{435}\u{442}\u{430}`,
    sm: `E le'i taliina`,
    so: `Jawaab la'aan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E04}\u{E4D}\u{E32}\u{E15}\u{E2D}\u{E1A}`,
    ur: `\u{62C}\u{648}\u{627}\u{628} \u{637}\u{644}\u{628}`,
    vi: `Ch\u{1B0}a \u{111}\u{1B0}\u{1EE3}c tr\u{1EA3} l\u{1EDD}i`,
    'zh-hans': `\u{65E0}\u{4EBA}\u{56DE}\u{5E94}`,
    'zh-hant': `\u{7121}\u{4EBA}\u{56DE}\u{61C9}`,
    en: `Unanswered`
};
const $b11db1b62d4a8f76$export$cf481ed232c88ae5 = {
    ar: `\u{63A}\u{64A}\u{631} \u{645}\u{62E}\u{635}\u{635}`,
    de: `Nicht zugewiesen`,
    es: `Sin asignaci\xf3n`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{62A}\u{62E}\u{635}\u{6CC}\u{635}`,
    fil: `Hindi nakatalaga`,
    fr: `Non attribu\xe9`,
    hi: `\u{905}\u{938}\u{93E}\u{907}\u{928} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Ki pa asiyen`,
    it: `Non assegnati`,
    ja: `\u{672A}\u{914D}\u{5C5E}`,
    ko: `\u{BBF8}\u{D560}\u{B2F9}`,
    mww: `tsis raug tso cai`,
    ps: `\u{63A}\u{6CC}\u{631} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC}`,
    pt: `N\xe3o atribu\xeddo`,
    'pt-pt': `N\xe3o atribu\xeddo`,
    ru: `\u{411}\u{435}\u{437} \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `E le'i tofia`,
    so: `Aan la xilsaarin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{634}\u{62F}\u{6C1}`,
    vi: `Ch\u{1B0}a \u{111}\u{1B0}\u{1EE3}c ch\u{1EC9} \u{111}\u{1ECB}nh`,
    'zh-hans': `\u{672A}\u{5206}\u{914D}`,
    'zh-hant': `\u{672A}\u{5206}\u{914D}`,
    en: `Unassigned`
};
const $b11db1b62d4a8f76$export$2b62254fb85a179f = {
    ar: `\u{63A}\u{64A}\u{631} \u{645}\u{62A}\u{648}\u{641}\u{631}`,
    de: `Nicht verf\xfcgbar`,
    es: `No disponible`,
    fa: `\u{62F}\u{631} \u{62F}\u{633}\u{62A}\u{631}\u{633} \u{646}\u{6CC}\u{633}\u{62A}`,
    fil: `Hindi magagamit`,
    fr: `Indisponible`,
    hi: `\u{905}\u{928}\u{941}\u{92A}\u{932}\u{92C}\u{94D}\u{927}`,
    ht: `Pa disponib`,
    it: `Non disponibile`,
    ja: `\u{5229}\u{7528}\u{4E0D}\u{53EF}`,
    ko: `\u{C0AC}\u{C6A9} \u{BD88}\u{AC00}`,
    mww: `Tsis muaj`,
    ps: `\u{634}\u{62A}\u{648}\u{646} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o dispon\xedvel`,
    'pt-pt': `N\xe3o dispon\xedvel`,
    ru: `\u{41D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}`,
    sm: `E le maua`,
    so: `Lama heli karo`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{62F}\u{633}\u{62A}\u{6CC}\u{627}\u{628} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 s\u{1EB5}n`,
    'zh-hans': `\u{4E0D}\u{53EF}\u{7528}`,
    'zh-hant': `\u{7121}\u{6CD5}\u{53D6}\u{5F97}`,
    en: `Unavailable`
};
const $b11db1b62d4a8f76$export$afc2b2276166ee6e = {
    ar: `\u{627}\u{644}\u{62A}\u{631}\u{627}\u{62C}\u{639}`,
    de: `R\xfcckg\xe4ngig machen`,
    es: `Deshacer`,
    fa: `\u{628}\u{627}\u{632}\u{6AF}\u{631}\u{62F}\u{627}\u{646}`,
    fil: `I-undo`,
    fr: `Annuler`,
    hi: `\u{92A}\u{942}\u{930}\u{94D}\u{935}\u{935}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Def\xe8t`,
    it: `Annulla`,
    ja: `\u{5143}\u{306B}\u{623B}\u{3059}`,
    ko: `\u{B418}\u{B3CC}\u{B9AC}\u{AE30}`,
    mww: `thim rov qab`,
    ps: `\u{628}\u{6D0}\u{631}\u{62A}\u{647} \u{648}\u{627}\u{62E}\u{644}\u{648}`,
    pt: `Desfazer`,
    'pt-pt': `Desfazer`,
    ru: `\u{41E}\u{442}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C}`,
    sm: `Toe fa'afo'i`,
    so: `Undo`,
    th: `\u{E40}\u{E25}\u{E34}\u{E01}\u{E17}\u{E4D}\u{E32}`,
    ur: `\u{648}\u{627}\u{67E}\u{633} \u{644}\u{648}\u{679}\u{646}\u{627}`,
    vi: `Ho\xe0n t\xe1c`,
    'zh-hans': `\u{64A4}\u{9500}`,
    'zh-hant': `\u{9084}\u{539F}`,
    en: `Undo`
};
const $b11db1b62d4a8f76$export$230e1efc20c8172a = {
    ar: `\u{63A}\u{64A}\u{631} \u{645}\u{639}\u{631}\u{648}\u{641}`,
    de: `Unbekannt`,
    es: `Desconocido`,
    fa: `\u{646}\u{627}\u{645}\u{634}\u{62E}\u{635}`,
    fil: `Hindi kilala`,
    fr: `Inconnu`,
    hi: `\u{905}\u{92A}\u{94D}\u{930}\u{938}\u{93F}\u{926}\u{94D}\u{918} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F}`,
    ht: `Enkoni`,
    it: `Sconosciuto`,
    ja: `\u{4E0D}\u{660E}`,
    ko: `\u{BBF8}\u{C0C1}`,
    mww: `Tsis paub`,
    ps: `\u{646}\u{627}\u{645}\u{639}\u{644}\u{648}\u{645}`,
    pt: `Desconhecido`,
    'pt-pt': `Desconhecido`,
    ru: `\u{41D}\u{435}\u{438}\u{437}\u{432}\u{435}\u{441}\u{442}\u{43D}\u{43E}`,
    sm: `E le iloa`,
    so: `Lama yaqaan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E17}\u{E23}\u{E32}\u{E1A}`,
    ur: `\u{646}\u{627}\u{645}\u{639}\u{644}\u{648}\u{645}`,
    vi: `Kh\xf4ng x\xe1c \u{111}\u{1ECB}nh`,
    'zh-hans': `\u{672A}\u{77E5}`,
    'zh-hant': `\u{672A}\u{77E5}`,
    en: `Unknown`
};
const $b11db1b62d4a8f76$export$8227558ec81276c = {
    ar: `\u{63A}\u{64A}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
    de: `Unspezifiziert`,
    es: `No especificado`,
    fa: `\u{646}\u{627}\u{645}\u{634}\u{62E}\u{635}`,
    fil: `Hindi tinukoy`,
    fr: `Non pr\xe9cis\xe9`,
    hi: `\u{905}\u{928}\u{93F}\u{930}\u{94D}\u{926}\u{93F}\u{937}\u{94D}\u{91F}`,
    ht: `Pa espesifye`,
    it: `Non specificato`,
    ja: `\u{4E0D}\u{660E}`,
    ko: `\u{BBF8}\u{C9C0}\u{C815}`,
    mww: `Tsis paub meej`,
    ps: `\u{646}\u{627}\u{645}\u{639}\u{644}\u{648}\u{645}`,
    pt: `N\xe3o especificado`,
    'pt-pt': `N\xe3o especificado`,
    ru: `\u{41D}\u{435} \u{443}\u{442}\u{43E}\u{447}\u{43D}\u{435}\u{43D}\u{43E}`,
    sm: `E le'i fa'amaonia`,
    so: `Lama cayimin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{645}\u{62A}\u{639}\u{6CC}\u{646}`,
    vi: `Kh\xf4ng x\xe1c \u{111}\u{1ECB}nh`,
    'zh-hans': `\u{672A}\u{8BF4}\u{660E}`,
    'zh-hant': `\u{672A}\u{5177}\u{9AD4}\u{8AAA}\u{660E}`,
    en: `Unspecified`
};
const $b11db1b62d4a8f76$export$5f69a1e589fa8200 = {
    ar: `\u{645}\u{648}\u{642}\u{639} \u{63A}\u{64A}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
    de: `Nicht n\xe4her bezeichneter Ort`,
    es: `Ubicaci\xf3n no especificada`,
    fa: `\u{645}\u{6A9}\u{627}\u{646} \u{646}\u{627}\u{645}\u{634}\u{62E}\u{635}`,
    fil: `Hindi tinukoy na lokasyon`,
    fr: `Emplacement non sp\xe9cifi\xe9`,
    hi: `\u{905}\u{928}\u{93F}\u{930}\u{94D}\u{926}\u{93F}\u{937}\u{94D}\u{91F} \u{938}\u{94D}\u{925}\u{93E}\u{928}`,
    ht: `Ki pa espesifye kote`,
    it: `Posizione non specificata`,
    ja: `\u{5834}\u{6240}\u{4E0D}\u{660E}`,
    ko: `\u{BBF8}\u{C9C0}\u{C815} \u{C704}\u{CE58}`,
    mww: `Qhov chaw tsis tau teev tseg`,
    ps: `\u{646}\u{627}\u{645}\u{639}\u{644}\u{648}\u{645} \u{681}\u{627}\u{6CC}`,
    pt: `Localiza\xe7\xe3o n\xe3o especificada`,
    'pt-pt': `Localiza\xe7\xe3o n\xe3o especificada`,
    ru: `\u{41D}\u{435}\u{443}\u{442}\u{43E}\u{447}\u{43D}\u{451}\u{43D}\u{43D}\u{43E}\u{435} \u{43C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Nofoaga e le'i fa'amaonia`,
    so: `Goob aan la cayimin`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{645}\u{62A}\u{639}\u{6CC}\u{646} \u{645}\u{642}\u{627}\u{645}`,
    vi: `V\u{1ECB} tr\xed kh\xf4ng x\xe1c \u{111}\u{1ECB}nh`,
    'zh-hans': `\u{672A}\u{6307}\u{5B9A}\u{5730}\u{70B9}`,
    'zh-hant': `\u{5730}\u{9EDE}\u{672A}\u{660E}`,
    en: `Unspecified location`
};
const $b11db1b62d4a8f76$export$d40a07ba4f2615ca = {
    ar: `\u{62C}\u{62F}\u{648}\u{644} \u{63A}\u{64A}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
    de: `Nicht n\xe4her spezifizierter Zeitplan`,
    es: `Calendario no especificado`,
    fa: `\u{628}\u{631}\u{646}\u{627}\u{645}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{646}\u{627}\u{645}\u{634}\u{62E}\u{635}`,
    fil: `Hindi tinukoy na iskedyul`,
    fr: `Calendrier non pr\xe9cis\xe9`,
    hi: `\u{905}\u{928}\u{93F}\u{930}\u{94D}\u{926}\u{93F}\u{937}\u{94D}\u{91F} \u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{915}\u{94D}\u{930}\u{92E}`,
    ht: `Or\xe8 ki pa espesifye`,
    it: `Programma non specificato`,
    ja: `\u{30B9}\u{30B1}\u{30B8}\u{30E5}\u{30FC}\u{30EB}\u{4E0D}\u{660E}`,
    ko: `\u{C77C}\u{C815} \u{BBF8}\u{C0C1}`,
    mww: `Tsis tau teev tseg`,
    ps: `\u{646}\u{627}\u{645}\u{639}\u{644}\u{648}\u{645} \u{645}\u{647}\u{627}\u{644}\u{648}\u{6CC}\u{634}`,
    pt: `Cronograma n\xe3o especificado`,
    'pt-pt': `Calend\xe1rio n\xe3o especificado`,
    ru: `\u{41D}\u{435}\u{443}\u{442}\u{43E}\u{447}\u{43D}\u{451}\u{43D}\u{43D}\u{43E}\u{435} \u{440}\u{430}\u{441}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Fa'asologa e le'i fa'amaonia`,
    so: `Jadwalka aan la cayimin`,
    th: `\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{645}\u{62A}\u{639}\u{6CC}\u{646} \u{634}\u{6CC}\u{688}\u{648}\u{644}`,
    vi: `L\u{1ECB}ch tr\xecnh kh\xf4ng x\xe1c \u{111}\u{1ECB}nh`,
    'zh-hans': `\u{672A}\u{6CE8}\u{660E}\u{7684}\u{8D5B}\u{7A0B}`,
    'zh-hant': `\u{672A}\u{660E}\u{78BA}\u{7684}\u{8CFD}\u{7A0B}`,
    en: `Unspecified schedule`
};
const $b11db1b62d4a8f76$export$5c09508cd75a09a2 = {
    ar: `\u{644}\u{642}\u{627}\u{62D}\u{627}\u{62A} \u{63A}\u{64A}\u{631} \u{645}\u{62D}\u{62F}\u{62F}\u{629}`,
    de: `Nicht n\xe4her bezeichnete Impfungen`,
    es: `Vacunaciones no especificadas`,
    fa: `\u{648}\u{627}\u{6A9}\u{633}\u{6CC}\u{646}\u{627}\u{633}\u{6CC}\u{648}\u{646} \u{647}\u{627}\u{6CC} \u{646}\u{627}\u{645}\u{634}\u{62E}\u{635}`,
    fil: `Mga hindi natukoy na pagbabakuna`,
    fr: `Vaccins non sp\xe9cifi\xe9s`,
    hi: `\u{905}\u{928}\u{93F}\u{930}\u{94D}\u{926}\u{93F}\u{937}\u{94D}\u{91F} \u{91F}\u{940}\u{915}\u{93E}\u{915}\u{930}\u{923}`,
    ht: `Vaksinasyon ki pa espesifye`,
    it: `Vaccinazioni non specificate`,
    ja: `\u{30EF}\u{30AF}\u{30C1}\u{30F3}\u{63A5}\u{7A2E}\u{306E}\u{7A2E}\u{985E}\u{306F}\u{4E0D}\u{660E}\u{3067}\u{3059}`,
    ko: `\u{BA85}\u{C2DC}\u{B418}\u{C9C0} \u{C54A}\u{C740} \u{BC31}\u{C2E0} \u{C811}\u{C885}`,
    mww: `Cov tshuaj tiv thaiv tsis tau teev tseg`,
    ps: `\u{646}\u{627}\u{645}\u{639}\u{644}\u{648}\u{645} \u{648}\u{627}\u{6A9}\u{633}\u{6CC}\u{646}\u{648}\u{646}\u{647}`,
    pt: `Vacina\xe7\xf5es n\xe3o especificadas`,
    'pt-pt': `Vacina\xe7\xf5es n\xe3o especificadas`,
    ru: `\u{41D}\u{435}\u{443}\u{442}\u{43E}\u{447}\u{43D}\u{451}\u{43D}\u{43D}\u{44B}\u{435} \u{432}\u{430}\u{43A}\u{446}\u{438}\u{43D}\u{44B}`,
    sm: `Tui e le'i fa'amaonia`,
    so: `Tallaallo aan la cayimin`,
    th: `\u{E01}\u{E32}\u{E23}\u{E09}\u{E35}\u{E14}\u{E27}\u{E31}\u{E04}\u{E0B}\u{E35}\u{E19}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}\u{E23}\u{E32}\u{E22}\u{E25}\u{E30}\u{E40}\u{E2D}\u{E35}\u{E22}\u{E14}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{645}\u{62A}\u{639}\u{6CC}\u{646} \u{648}\u{6CC}\u{6A9}\u{633}\u{6CC}\u{646}\u{6CC}\u{634}\u{646}`,
    vi: `Ti\xeam ch\u{1EE7}ng kh\xf4ng x\xe1c \u{111}\u{1ECB}nh`,
    'zh-hans': `\u{672A}\u{5177}\u{4F53}\u{8BF4}\u{660E}\u{7684}\u{75AB}\u{82D7}\u{63A5}\u{79CD}`,
    'zh-hant': `\u{672A}\u{5177}\u{9AD4}\u{8AAA}\u{660E}\u{7684}\u{75AB}\u{82D7}\u{63A5}\u{7A2E}`,
    en: `Unspecified vaccinations`
};
const $b11db1b62d4a8f76$export$68070717ade7a84 = {
    ar: `\u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{627}\u{634}\u{62A}\u{631}\u{627}\u{643}`,
    de: `Abmelden`,
    es: `Cancelar suscripci\xf3n`,
    fa: `\u{644}\u{63A}\u{648} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9}`,
    fil: `Email Address *`,
    fr: `D\xe9sabonnement`,
    hi: `\u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Koupe ab\xf2nman`,
    it: `Disiscriverti`,
    ja: `\u{8CFC}\u{8AAD}\u{89E3}\u{9664}`,
    ko: `\u{AD6C}\u{B3C5} \u{CDE8}\u{C18C}`,
    mww: `Tshem tawm`,
    ps: `\u{644}\u{63A}\u{648}\u{647} \u{6A9}\u{693}\u{647}`,
    pt: `Desinscri\xe7\xe3o`,
    'pt-pt': `Desassinar`,
    ru: `\u{41E}\u{442}\u{43F}\u{438}\u{441}\u{430}\u{442}\u{44C}\u{441}\u{44F}`,
    sm: `Unsubscribe`,
    so: `Ka bax isdiiwaangelinta`,
    th: `\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}`,
    ur: `\u{627}\u{646} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `H\u{1EE7}y \u{111}\u{103}ng k\xfd`,
    'zh-hans': `\u{53D6}\u{6D88}\u{8BA2}\u{9605}`,
    'zh-hant': `\u{53D6}\u{6D88}\u{8A02}\u{95B1}`,
    en: `Unsubscribe`
};
const $b11db1b62d4a8f76$export$ebe06c687744d6e6 = {
    ar: `\u{639}\u{646}\u{648}\u{627}\u{646} \u{63A}\u{64A}\u{631} \u{645}\u{648}\u{62B}\u{642}`,
    de: `Unbest\xe4tigte Adresse`,
    es: `Direcci\xf3n no verificada`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{62A}\u{623}\u{6CC}\u{6CC}\u{62F}\u{646}\u{634}\u{62F}\u{647}`,
    fil: `Hindi na-verify na address`,
    fr: `Adresse non v\xe9rifi\xe9e`,
    hi: `\u{905}\u{938}\u{924}\u{94D}\u{92F}\u{93E}\u{92A}\u{93F}\u{924} \u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s ki pa verifye`,
    it: `Indirizzo non verificato`,
    ja: `\u{672A}\u{78BA}\u{8A8D}\u{306E}\u{4F4F}\u{6240}`,
    ko: `\u{BBF8}\u{D655}\u{C778} \u{C8FC}\u{C18C}`,
    mww: `Qhov chaw nyob uas tsis tau txheeb xyuas`,
    ps: `\u{646}\u{647} \u{62A}\u{627}\u{6CC}\u{6CC}\u{62F} \u{634}\u{648}\u{6D0} \u{67E}\u{62A}\u{647}`,
    pt: `Endere\xe7o n\xe3o verificado`,
    'pt-pt': `Endere\xe7o n\xe3o verificado`,
    ru: `\u{41D}\u{435}\u{43F}\u{43E}\u{434}\u{442}\u{432}\u{435}\u{440}\u{436}\u{434}\u{451}\u{43D}\u{43D}\u{44B}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Tuatusi e le'i faamaonia`,
    so: `Cinwaan aan la xaqiijin`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{634}\u{62F}\u{6C1} \u{67E}\u{62A}\u{6C1}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} ch\u{1B0}a \u{111}\u{1B0}\u{1EE3}c x\xe1c minh`,
    'zh-hans': `\u{672A}\u{9A8C}\u{8BC1}\u{5730}\u{5740}`,
    'zh-hant': `\u{672A}\u{9A57}\u{8B49}\u{5730}\u{5740}`,
    en: `Unverified address`
};
const $b11db1b62d4a8f76$export$1057386d3f63b416 = {
    ar: `\u{642}\u{627}\u{62F}\u{645}`,
    de: `Demn\xe4chst`,
    es: `Pr\xf3ximas`,
    fa: `\u{62F}\u{631} \u{631}\u{627}\u{647}`,
    fil: `Paparating na`,
    fr: `\xc0 venir`,
    hi: `\u{906}\u{917}\u{93E}\u{92E}\u{940}`,
    ht: `Kap vini an`,
    it: `Prossime`,
    ja: `\u{4ECA}\u{5F8C}\u{306E}\u{4E88}\u{5B9A}`,
    ko: `\u{ACE7} \u{C788}\u{C744} \u{C608}\u{C815}`,
    mww: `Yav tom ntej`,
    ps: `\u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Pr\xf3ximos`,
    'pt-pt': `Pr\xf3ximos`,
    ru: `\u{412} \u{431}\u{43B}\u{438}\u{436}\u{430}\u{439}\u{448}\u{435}\u{43C} \u{431}\u{443}\u{434}\u{443}\u{449}\u{435}\u{43C}`,
    sm: `O le a sosoo ai`,
    so: `Soo socda`,
    th: `\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E08}\u{E30}\u{E21}\u{E32}\u{E16}\u{E36}\u{E07}`,
    ur: `\u{622}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{627}`,
    vi: `S\u{1EAF}p t\u{1EDB}i`,
    'zh-hans': `\u{5373}\u{5C06}\u{5230}\u{6765}`,
    'zh-hant': `\u{5373}\u{5C07}\u{63A8}\u{51FA}`,
    en: `Upcoming`
};
const $b11db1b62d4a8f76$export$57996bf9020b996b = {
    ar: `\u{639}\u{64A}\u{627}\u{62F}\u{627}\u{62A} \u{627}\u{644}\u{644}\u{642}\u{627}\u{62D}\u{627}\u{62A} \u{627}\u{644}\u{642}\u{627}\u{62F}\u{645}\u{629}`,
    de: `Bevorstehende Impfkliniken`,
    es: `Pr\xf3ximas cl\xednicas de vacunaci\xf3n`,
    fa: `\u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9} \u{647}\u{627}\u{6CC} \u{648}\u{627}\u{6A9}\u{633}\u{646} \u{622}\u{6CC}\u{646}\u{62F}\u{647}`,
    fil: `Mga paparating na klinika sa bakuna`,
    fr: `Cliniques de vaccination \xe0 venir`,
    hi: `\u{906}\u{917}\u{93E}\u{92E}\u{940} \u{935}\u{948}\u{915}\u{94D}\u{938}\u{940}\u{928} \u{915}\u{94D}\u{932}\u{940}\u{928}\u{93F}\u{915}`,
    ht: `Klinik vaksen kap vini yo`,
    it: `Prossime cliniche per la vaccinazione`,
    ja: `\u{4ECA}\u{5F8C}\u{306E}\u{30EF}\u{30AF}\u{30C1}\u{30F3}\u{30AF}\u{30EA}\u{30CB}\u{30C3}\u{30AF}`,
    ko: `\u{C608}\u{C815}\u{B41C} \u{BC31}\u{C2E0} \u{D074}\u{B9AC}\u{B2C9}`,
    mww: `Cov chaw txhaj tshuaj tiv thaiv tom ntej`,
    ps: `\u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6CC} \u{648}\u{627}\u{6A9}\u{633}\u{6CC}\u{646} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9}\u{648}\u{646}\u{647}`,
    pt: `Cl\xednicas de vacina\xe7\xe3o futuras`,
    'pt-pt': `Cl\xednicas de vacina\xe7\xe3o futuras`,
    ru: `\u{41F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{438}\u{435} \u{43A}\u{43B}\u{438}\u{43D}\u{438}\u{43A}\u{438} \u{43F}\u{43E} \u{432}\u{430}\u{43A}\u{446}\u{438}\u{43D}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Falema'i o tui o lo'o lumana'i`,
    so: `Rugaha tallaalka ee soo socda`,
    th: `\u{E04}\u{E25}\u{E34}\u{E19}\u{E34}\u{E01}\u{E27}\u{E31}\u{E04}\u{E0B}\u{E35}\u{E19}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E08}\u{E30}\u{E21}\u{E32}\u{E16}\u{E36}\u{E07}`,
    ur: `\u{622}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{648}\u{6CC}\u{6A9}\u{633}\u{6CC}\u{646} \u{6A9}\u{644}\u{6CC}\u{646}\u{6A9}\u{633}`,
    vi: `C\xe1c ph\xf2ng kh\xe1m v\u{1EAF}c-xin s\u{1EAF}p t\u{1EDB}i`,
    'zh-hans': `\u{5373}\u{5C06}\u{5F00}\u{8BBE}\u{7684}\u{75AB}\u{82D7}\u{8BCA}\u{6240}`,
    'zh-hant': `\u{5373}\u{5C07}\u{8209}\u{8FA6}\u{7684}\u{75AB}\u{82D7}\u{8A3A}\u{6240}`,
    en: `Upcoming vaccine clinics`
};
const $b11db1b62d4a8f76$export$6788e256fd63ddc4 = {
    ar: `\u{62A}\u{62D}\u{62F}\u{64A}\u{62B} \u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{642}`,
    de: `Kommentar aktualisieren`,
    es: `Comentario de actualizaci\xf3n`,
    fa: `\u{628}\u{647} \u{631}\u{648}\u{632}\u{631}\u{633}\u{627}\u{646}\u{6CC} \u{646}\u{638}\u{631}`,
    fil: `I-update ang komento`,
    fr: `Commentaire \xe0 jour`,
    hi: `\u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{940} \u{905}\u{92A}\u{921}\u{947}\u{91F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `K\xf2mant\xe8 mete ajou`,
    it: `Commento aggiornato`,
    ja: `\u{30A2}\u{30C3}\u{30D7}\u{30C7}\u{30FC}\u{30C8}\u{30B3}\u{30E1}\u{30F3}\u{30C8}`,
    ko: `\u{C5C5}\u{B370}\u{C774}\u{D2B8} \u{B313}\u{AE00}`,
    mww: `Hloov kho tawm tswv yim`,
    ps: `\u{62F} \u{646}\u{638}\u{631} \u{62A}\u{627}\u{632}\u{647} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    pt: `Coment\xe1rio de atualiza\xe7\xe3o`,
    'pt-pt': `Coment\xe1rio de atualiza\xe7\xe3o`,
    ru: `\u{41A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{439} \u{43A} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44E}`,
    sm: `Fa'afouina fa'amatalaga`,
    so: `Faallo cusbooneysiin`,
    th: `\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15}\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}`,
    ur: `\u{62A}\u{628}\u{635}\u{631}\u{6C1} \u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `C\u{1EAD}p nh\u{1EAD}t b\xecnh lu\u{1EAD}n`,
    'zh-hans': `\u{66F4}\u{65B0}\u{8BC4}\u{8BBA}`,
    'zh-hant': `\u{66F4}\u{65B0}\u{7559}\u{8A00}`,
    en: `Update comment`
};
const $b11db1b62d4a8f76$export$b7106b0b5f687fad = {
    ar: `\u{62A}\u{62D}\u{62F}\u{64A}\u{62B}`,
    de: `Aktualisiert`,
    es: `Actualizado`,
    fa: `\u{628}\u{647} \u{631}\u{648}\u{632}\u{631}\u{633}\u{627}\u{646}\u{6CC} \u{634}\u{62F}\u{647}`,
    fil: `Nai-update`,
    fr: `Mise \xe0 jour`,
    hi: `\u{905}\u{92A}\u{921}\u{947}\u{91F} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Mizajou`,
    it: `Aggiornato`,
    ja: `\u{66F4}\u{65B0}`,
    ko: `\u{C5C5}\u{B370}\u{C774}\u{D2B8}\u{B428}`,
    mww: `Hloov tshiab`,
    ps: `\u{62A}\u{627}\u{632}\u{647} \u{634}\u{648}\u{6CC}`,
    pt: `Atualizado`,
    'pt-pt': `Atualizado`,
    ru: `\u{41E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{43E}`,
    sm: `Fa'afouina`,
    so: `La cusbooneysiiyay`,
    th: `\u{E2D}\u{E31}\u{E1E}\u{E40}\u{E14}\u{E17}`,
    ur: `\u{62A}\u{627}\u{632}\u{6C1} \u{6A9}\u{627}\u{631}\u{6CC}`,
    vi: `C\u{1EAD}p nh\u{1EAD}t`,
    'zh-hans': `\u{66F4}\u{65B0}`,
    'zh-hant': `\u{66F4}\u{65B0}`,
    en: `Updated`
};
const $b11db1b62d4a8f76$export$75570ba51b29968f = {
    ar: (date)=>$b11db1b62d4a8f76$var$html`<span>تم التحديث ${date}</span>`,
    de: (date)=>$b11db1b62d4a8f76$var$html`<span>Aktualisiert ${date}</span>`,
    es: (date)=>$b11db1b62d4a8f76$var$html`<span>Actualizado ${date}</span>`,
    fa: (date)=>$b11db1b62d4a8f76$var$html`<span>${date} به روزرسانی شد</span>`,
    fil: (date)=>$b11db1b62d4a8f76$var$html`<span>Nai-update ${date}</span>`,
    fr: (date)=>$b11db1b62d4a8f76$var$html`<span>Mise à jour ${date}</span>`,
    hi: (date)=>$b11db1b62d4a8f76$var$html`<span>3 ${date} अपडेट किया गया</span>`,
    ht: (date)=>$b11db1b62d4a8f76$var$html`<span>Mizajou ${date}</span>`,
    it: (date)=>$b11db1b62d4a8f76$var$html`<span>Aggiornato ${date}</span>`,
    ja: (date)=>$b11db1b62d4a8f76$var$html`<span>${date}に更新</span>`,
    ko: (date)=>$b11db1b62d4a8f76$var$html`<span>${date} 업데이트됨</span>`,
    mww: (date)=>$b11db1b62d4a8f76$var$html`<span>Hloov tshiab ${date}</span>`,
    ps: (date)=>$b11db1b62d4a8f76$var$html`<span>${date} تازه شوی</span>`,
    pt: (date)=>$b11db1b62d4a8f76$var$html`<span>Atualizado ${date}</span>`,
    'pt-pt': (date)=>$b11db1b62d4a8f76$var$html`<span>Atualizado ${date}</span>`,
    ru: (date)=>$b11db1b62d4a8f76$var$html`<span>${date}</span>`,
    sm: (date)=>$b11db1b62d4a8f76$var$html`<span>Fa'afouina ${date}</span>`,
    so: (date)=>$b11db1b62d4a8f76$var$html`<span>La cusbooneysiiyay ${date}</span>`,
    th: (date)=>$b11db1b62d4a8f76$var$html`<span>อัพเดทเมื่อ ${date}</span>`,
    ur: (date)=>$b11db1b62d4a8f76$var$html`<span>${date} اپ ڈیٹ کیا گیا</span>`,
    vi: (date)=>$b11db1b62d4a8f76$var$html`<span>Cập nhật ${date}</span>`,
    'zh-hans': (date)=>$b11db1b62d4a8f76$var$html`<span>更新 ${date}</span>`,
    'zh-hant': (date)=>$b11db1b62d4a8f76$var$html`<span>更新 ${date}</span>`,
    en: (date)=>$b11db1b62d4a8f76$var$html`<span>Updated ${date}</span>`
};
const $b11db1b62d4a8f76$export$4ceeef0826347df8 = {
    ar: `\u{642}\u{645}\u{62A} \u{628}\u{62A}\u{62D}\u{62F}\u{64A}\u{62B} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Diese Aktivit\xe4t wurde aktualisiert.`,
    es: `He actualizado esta actividad.`,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{628}\u{647} \u{631}\u{648}\u{632}\u{631}\u{633}\u{627}\u{646}\u{6CC} \u{6A9}\u{631}\u{62F}\u{645}.`,
    fil: `Na-update ang aktibidad na ito.`,
    fr: `Mise \xe0 jour de cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{94B} \u{905}\u{92A}\u{921}\u{947}\u{91F} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}\u{964}`,
    ht: `Mizajou aktivite sa a.`,
    it: `Aggiornato questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{3092}\u{66F4}\u{65B0}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C744} \u{C5C5}\u{B370}\u{C774}\u{D2B8}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Hloov kho qhov kev ua no.`,
    ps: `\u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{627}\u{632}\u{647} \u{6A9}\u{693}.`,
    pt: `Atualizei esta atividade.`,
    'pt-pt': `Atualizei esta atividade.`,
    ru: `\u{41E}\u{431}\u{43D}\u{43E}\u{432}\u{438}\u{43B} \u{44D}\u{442}\u{443} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `Fa'afouina lenei gaoioiga.`,
    so: `Waxaan cusbooneysiiyay hawshan.`,
    th: `\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{648} \u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}\u{6D4}`,
    vi: `C\u{1EAD}p nh\u{1EAD}t ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{66F4}\u{65B0}\u{4E86}\u{6B64}\u{6D3B}\u{52A8}\u{3002}`,
    'zh-hant': `\u{66F4}\u{65B0}\u{4E86}\u{6B64}\u{6D3B}\u{52D5}\u{3002}`,
    en: `Updated this activity.`
};
const $b11db1b62d4a8f76$export$67b0dd0fc2868795 = {
    ar: `\u{62C}\u{627}\u{631}\u{64A} \u{627}\u{644}\u{62A}\u{62D}\u{62F}\u{64A}\u{62B}...`,
    de: `Aktualisierung...`,
    es: `Actualizando...`,
    fa: `\u{62F}\u{631} \u{62D}\u{627}\u{644} \u{628}\u{647} \u{631}\u{648}\u{632}\u{631}\u{633}\u{627}\u{646}\u{6CC}...`,
    fil: `Pag-update...`,
    fr: `Mise \xe0 jour...`,
    hi: `\u{905}\u{926}\u{94D}\u{92F}\u{924}\u{928} \u{915}\u{930} \u{930}\u{939}\u{93E} \u{939}\u{948}...`,
    ht: `Mete ajou...`,
    it: `Aggiornamento...`,
    ja: `\u{66F4}\u{65B0}\u{4E2D}...`,
    ko: `\u{C5C5}\u{B370}\u{C774}\u{D2B8} \u{C911}\u{C785}\u{B2C8}\u{B2E4}...`,
    mww: `Hloov tshiab...`,
    ps: `\u{62A}\u{627}\u{632}\u{647} \u{6A9}\u{648}\u{644}...`,
    pt: `Atualizando...`,
    'pt-pt': `Atualiza\xe7\xe3o...`,
    ru: `\u{41E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}...`,
    sm: `Fa'afouina ...`,
    so: `Cusbooneysiin...`,
    th: `\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15}...`,
    ur: `\u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6A9}\u{631} \u{631}\u{6C1}\u{627} \u{6C1}\u{648}\u{6BA}...`,
    vi: `\u{110}ang c\u{1EAD}p nh\u{1EAD}t...`,
    'zh-hans': `\u{66F4}\u{65B0}\u{4E2D}......`,
    'zh-hant': `\u{66F4}\u{65B0}\u{4E2D}......`,
    en: `Updating...`
};
const $b11db1b62d4a8f76$export$40913c340b574d55 = {
    ar: `\u{631}\u{641}\u{639}`,
    de: `Hochladen`,
    es: `Subida`,
    fa: `\u{628}\u{627}\u{631}\u{6AF}\u{630}\u{627}\u{631}\u{6CC}`,
    fil: `Email Address *`,
    fr: `T\xe9l\xe9verser`,
    hi: `\u{905}\u{92A}\u{932}\u{94B}\u{921} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Voye`,
    it: `Caricamento`,
    ja: `\u{30A2}\u{30C3}\u{30D7}\u{30ED}\u{30FC}\u{30C9}`,
    ko: `\u{C5C5}\u{B85C}\u{B4DC}`,
    mww: `Upload`,
    ps: `\u{627}\u{67E}\u{644}\u{648}\u{689}`,
    pt: `Upload`,
    'pt-pt': `Upload`,
    ru: `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}`,
    sm: `Fa'apipi'i`,
    so: `Soo gelin`,
    th: `\u{E2D}\u{E31}\u{E1B}\u{E42}\u{E2B}\u{E25}\u{E14}`,
    ur: `\u{627}\u{67E} \u{644}\u{648}\u{688} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA3}i l\xean`,
    'zh-hans': `\u{4E0A}\u{4F20}`,
    'zh-hant': `\u{4E0A}\u{50B3}`,
    en: `Upload`
};
const $b11db1b62d4a8f76$export$abc1de427b12d946 = {
    ar: (filename)=>`\u{62E}\u{637}\u{623} \u{641}\u{64A} \u{631}\u{641}\u{639} "${filename}".`,
    de: (filename)=>`Fehler beim Hochladen von "${filename}".`,
    es: (filename)=>`Error al subir "${filename}".`,
    fa: (filename)=>`\u{62E}\u{637}\u{627} \u{62F}\u{631} \u{628}\u{627}\u{631}\u{6AF}\u{630}\u{627}\u{631}\u{6CC} \xab${filename}\xbb.`,
    fil: (filename)=>`Error sa pag-upload ng "${filename}".`,
    fr: (filename)=>`Erreur de t\xe9l\xe9chargement de \xab ${filename} \xbb.`,
    hi: (filename)=>`"${filename} \u{905}\u{92A}\u{932}\u{94B}\u{921} \u{915}\u{930}\u{928}\u{947} \u{92E}\u{947}\u{902} \u{924}\u{94D}\u{930}\u{941}\u{91F}\u{93F}\u{964}`,
    ht: (filename)=>`Er\xe8 uploading "${filename}".`,
    it: (filename)=>`Errore nel caricamento di "${filename}".`,
    ja: (filename)=>`\u{300C}${filename}\u{300D}\u{306E}\u{30A2}\u{30C3}\u{30D7}\u{30ED}\u{30FC}\u{30C9}\u{30A8}\u{30E9}\u{30FC}\u{304C}\u{767A}\u{751F}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: (filename)=>`"${filename}" \u{C5C5}\u{B85C}\u{B4DC} \u{C624}\u{B958}.`,
    mww: (filename)=>`Yuam kev uploading "${filename}".`,
    ps: (filename)=>`\u{62F} "${filename}" \u{627}\u{67E}\u{644}\u{648}\u{689} \u{6A9}\u{6D0} \u{62A}\u{6D0}\u{631}\u{648}\u{62A}\u{646}\u{647} \u{62F}\u{647}.`,
    pt: (filename)=>`Erro ao enviar "${filename}".`,
    'pt-pt': (filename)=>`Erro ao carregar "${filename}".`,
    ru: (filename)=>`\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{43F}\u{440}\u{438} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{435} "${filename}".`,
    sm: (filename)=>`Error uploading "${filename}".`,
    so: (filename)=>`Khalad ku jira upload-ka "${filename}".`,
    th: (filename)=>`\u{E40}\u{E01}\u{E34}\u{E14}\u{E02}\u{E49}\u{E2D}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E31}\u{E1B}\u{E42}\u{E2B}\u{E25}\u{E14} "${filename}"`,
    ur: (filename)=>`"${filename}" \u{627}\u{67E}\u{644}\u{648}\u{688} \u{6A9}\u{631}\u{646}\u{6D2} \u{645}\u{6CC}\u{6BA} \u{62E}\u{631}\u{627}\u{628}\u{6CC}\u{6D4}`,
    vi: (filename)=>`L\u{1ED7}i t\u{1EA3}i l\xean "${filename}".`,
    'zh-hans': (filename)=>`\u{4E0A}\u{4F20}\u{201C}${filename}\u{201D}\u{9519}\u{8BEF}\u{3002}`,
    'zh-hant': (filename)=>`\u{4E0A}\u{50B3}\u{300C}${filename}\u{300D}\u{932F}\u{8AA4}\u{3002}`,
    en: (filename)=>`Error uploading "${filename}".`
};
const $b11db1b62d4a8f76$export$7f449188bb84ac2c = {
    ar: (index, length)=>`\u{631}\u{641}\u{639} \u{645}\u{644}\u{641}\u{627}\u{62A}\u{643}... (${index}/${length})`,
    de: (index, length)=>`Deine Dateien hochladen... (${index}/${length})`,
    es: (index, length)=>`Subiendo tus archivos... (${index}/${length})`,
    fa: (index, length)=>`\u{641}\u{627}\u{6CC}\u{644} \u{647}\u{627}\u{6CC}\u{62A}\u{627}\u{646} \u{631}\u{627} \u{622}\u{67E}\u{644}\u{648}\u{62F} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}... (${index}/${length})`,
    fil: (index, length)=>`I-upload ang Iyong Mga File ... (${index}/${length})`,
    fr: (index, length)=>`T\xe9l\xe9chargement de tes fichiers... (${index}/${length})`,
    hi: (index, length)=>`\u{905}\u{92A}\u{928}\u{940} \u{92B}\u{93C}\u{93E}\u{907}\u{932}\u{947}\u{902} \u{905}\u{92A}\u{932}\u{94B}\u{921} \u{915}\u{930} \u{930}\u{939}\u{93E} \u{939}\u{942}\u{901}... (${index}/${length})`,
    ht: (index, length)=>`T\xe9l\xe9chargement fichiers ou ... (${index}/${length})`,
    it: (index, length)=>`Caricamento dei tuoi file... (${index}/${length})`,
    ja: (index, length)=>`\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{30A2}\u{30C3}\u{30D7}\u{30ED}\u{30FC}\u{30C9}\u{4E2D}...(${index}/${length})`,
    ko: (index, length)=>`\u{D30C}\u{C77C} \u{C5C5}\u{B85C}\u{B4DC} \u{C911}... (${index}/${length})`,
    mww: (index, length)=>`Uploading koj cov ntaub ntawv... (${index}/${length})`,
    ps: (index, length)=>`\u{633}\u{62A}\u{627} \u{641}\u{627}\u{6CC}\u{644}\u{648}\u{646}\u{647} \u{627}\u{67E}\u{644}\u{648}\u{689} \u{6A9}\u{648}\u{644}... (${index}/${length})`,
    pt: (index, length)=>`Enviando seus arquivos... (${index}/${length})`,
    'pt-pt': (index, length)=>`A carregar os teus ficheiros... (${index}/${length})`,
    ru: (index, length)=>`\u{417}\u{430}\u{433}\u{440}\u{443}\u{436}\u{430}\u{44E} \u{432}\u{430}\u{448}\u{438} \u{444}\u{430}\u{439}\u{43B}\u{44B}... (${index}/${length})`,
    sm: (index, length)=>`Fa'apipi'i lau 'upega tafa'ilagi ... (${index}/${length})`,
    so: (index, length)=>`Faylashaada la gelinayaa... (${index}/${length})`,
    th: (index, length)=>`\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E2D}\u{E31}\u{E1B}\u{E42}\u{E2B}\u{E25}\u{E14}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}... (${index}/${length})`,
    ur: (index, length)=>`\u{622}\u{67E} \u{6A9}\u{6CC} \u{641}\u{627}\u{626}\u{644}\u{6CC}\u{6BA} \u{627}\u{67E}\u{644}\u{648}\u{688} \u{6A9}\u{631} \u{631}\u{6C1}\u{6D2} \u{6C1}\u{6CC}\u{6BA}... (${index}/${length})`,
    vi: (index, length)=>`\u{110}ang t\u{1EA3}i l\xean t\u{1EC7}p c\u{1EE7}a b\u{1EA1}n... (${index}/${length})`,
    'zh-hans': (index, length)=>`\u{4E0A}\u{4F20}\u{4F60}\u{7684}\u{6587}\u{4EF6}......\u{FF08}${index}/${length}\u{FF09}`,
    'zh-hant': (index, length)=>`\u{4E0A}\u{50B3}\u{4F60}\u{7684}\u{6A94}\u{6848}......\u{FF08}${index}/${length}\u{FF09}`,
    en: (index, length)=>`Uploading your files... (${index}/${length})`
};
const $b11db1b62d4a8f76$export$3888f88afabded10 = {
    ar: `\u{631}\u{641}\u{639} \u{635}\u{648}\u{631}\u{629} \u{62C}\u{62F}\u{64A}\u{62F}\u{629}`,
    de: `Neues Bild hochladen`,
    es: `Subir nueva imagen`,
    fa: `\u{622}\u{67E}\u{644}\u{648}\u{62F} \u{639}\u{6A9}\u{633} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Mag-upload ng bagong larawan`,
    fr: `T\xe9l\xe9charger une nouvelle image`,
    hi: `\u{928}\u{908} \u{924}\u{938}\u{94D}\u{935}\u{940}\u{930} \u{905}\u{92A}\u{932}\u{94B}\u{921} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Voye nouvo foto`,
    it: `Carica nuova immagine`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{5199}\u{771F}\u{3092}\u{30A2}\u{30C3}\u{30D7}\u{30ED}\u{30FC}\u{30C9}\u{3059}\u{308B}`,
    ko: `\u{C0C8} \u{C0AC}\u{C9C4} \u{C5C5}\u{B85C}\u{B4DC}`,
    mww: `Upload daim duab tshiab`,
    ps: `\u{646}\u{648}\u{6D0} \u{627}\u{646}\u{681}\u{648}\u{631} \u{67E}\u{648}\u{631}\u{62A}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Enviar nova imagem`,
    'pt-pt': `Carregar nova imagem`,
    ru: `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{438}\u{442}\u{44C} \u{43D}\u{43E}\u{432}\u{443}\u{44E} \u{444}\u{43E}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{44E}`,
    sm: `Fa'apipi'i le ata fou`,
    so: `Soo geli sawir cusub`,
    th: `\u{E2D}\u{E31}\u{E1B}\u{E42}\u{E2B}\u{E25}\u{E14}\u{E23}\u{E39}\u{E1B}\u{E20}\u{E32}\u{E1E}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{626}\u{6CC} \u{62A}\u{635}\u{648}\u{6CC}\u{631} \u{627}\u{67E}\u{644}\u{648}\u{688} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA3}i l\xean h\xecnh \u{1EA3}nh m\u{1EDB}i`,
    'zh-hans': `\u{4E0A}\u{4F20}\u{65B0}\u{56FE}\u{7247}`,
    'zh-hant': `\u{4E0A}\u{50B3}\u{65B0}\u{7167}\u{7247}`,
    en: `Upload new picture`
};
const $b11db1b62d4a8f76$export$d980d6d0d3d37526 = {
    ar: `\u{642}\u{645} \u{628}\u{631}\u{641}\u{639} \u{635}\u{648}\u{631}\u{629} \u{644}\u{646}\u{641}\u{633}\u{643} \u{644}\u{62A}\u{62E}\u{635}\u{64A}\u{635} \u{62D}\u{633}\u{627}\u{628}\u{643} \u{648}\u{645}\u{633}\u{627}\u{639}\u{62F}\u{629} \u{627}\u{644}\u{622}\u{62E}\u{631}\u{64A}\u{646} \u{639}\u{644}\u{649} \u{627}\u{644}\u{62A}\u{639}\u{631}\u{641} \u{639}\u{644}\u{64A}\u{643} \u{628}\u{633}\u{647}\u{648}\u{644}\u{629} \u{639}\u{628}\u{631} \u{627}\u{644}\u{62A}\u{637}\u{628}\u{64A}\u{642}.`,
    de: `Lade ein Foto von dir hoch, um dein Konto zu personalisieren und anderen zu helfen, dich in der App leicht wiederzuerkennen.`,
    es: `Sube una foto tuya para personalizar tu cuenta y ayudar a que los dem\xe1s te reconozcan f\xe1cilmente a trav\xe9s de la app.`,
    fa: `\u{6CC}\u{6A9} \u{639}\u{6A9}\u{633} \u{627}\u{632} \u{62E}\u{648}\u{62F}\u{62A}\u{627}\u{646} \u{628}\u{627}\u{631}\u{6AF}\u{630}\u{627}\u{631}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{62A}\u{627} \u{62D}\u{633}\u{627}\u{628} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{6CC} \u{62A}\u{627}\u{646} \u{634}\u{62E}\u{635}\u{6CC} \u{633}\u{627}\u{632}\u{6CC} \u{634}\u{648}\u{62F} \u{648} \u{628}\u{647} \u{62F}\u{6CC}\u{6AF}\u{631}\u{627}\u{646} \u{6A9}\u{645}\u{6A9} \u{6A9}\u{646}\u{6CC}\u{62F} \u{631}\u{627}\u{62D}\u{62A} \u{62A}\u{631} \u{634}\u{645}\u{627} \u{631}\u{627} \u{62F}\u{631} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{628}\u{634}\u{646}\u{627}\u{633}\u{646}\u{62F}.`,
    fil: `Mag-upload ng larawan ng iyong sarili upang i-personalize ang iyong account at tulungan ang iba na madaling makilala ka sa buong app.`,
    fr: `T\xe9l\xe9chargez une photo de vous pour personnaliser votre compte et aider les autres \xe0 vous reconna\xeetre facilement sur l\u{2019}application.`,
    hi: `\u{905}\u{92A}\u{928}\u{947} \u{916}\u{93E}\u{924}\u{947} \u{915}\u{94B} \u{935}\u{948}\u{92F}\u{915}\u{94D}\u{924}\u{93F}\u{915}\u{943}\u{924} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{92A}\u{928}\u{940} \u{90F}\u{915} \u{924}\u{938}\u{94D}\u{935}\u{940}\u{930} \u{905}\u{92A}\u{932}\u{94B}\u{921} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{926}\u{942}\u{938}\u{930}\u{94B}\u{902} \u{915}\u{94B} \u{910}\u{92A} \u{92E}\u{947}\u{902} \u{906}\u{92A}\u{915}\u{94B} \u{906}\u{938}\u{93E}\u{928}\u{940} \u{938}\u{947} \u{92A}\u{939}\u{91A}\u{93E}\u{928}\u{928}\u{947} \u{92E}\u{947}\u{902} \u{92E}\u{926}\u{926} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Voye yon foto nan t\xe8t ou p\xe8sonalize kont ou epi ede l\xf2t moun fasil rekon\xe8t ou atrav\xe8 app a.`,
    it: `Carica una foto di te stesso per personalizzare il tuo account e aiutare gli altri a riconoscerti facilmente sull'app.`,
    ja: `\u{81EA}\u{5206}\u{306E}\u{5199}\u{771F}\u{3092}\u{30A2}\u{30C3}\u{30D7}\u{30ED}\u{30FC}\u{30C9}\u{3057}\u{3066}\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{3092}\u{30D1}\u{30FC}\u{30BD}\u{30CA}\u{30E9}\u{30A4}\u{30BA}\u{3057}\u{3001}\u{30A2}\u{30D7}\u{30EA}\u{5185}\u{3067}\u{4ED6}\u{306E}\u{4EBA}\u{306B}\u{7C21}\u{5358}\u{306B}\u{8A8D}\u{8B58}\u{3055}\u{308C}\u{3084}\u{3059}\u{304F}\u{306A}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C790}\u{C2E0}\u{C758} \u{C0AC}\u{C9C4}\u{C744} \u{C62C}\u{B824} \u{ACC4}\u{C815}\u{C744} \u{AC1C}\u{C778}\u{D654}\u{D558}\u{ACE0} \u{C571} \u{C804}\u{BC18}\u{C5D0}\u{C11C} \u{B2E4}\u{B978} \u{C0AC}\u{B78C}\u{B4E4}\u{C774} \u{C27D}\u{AC8C} \u{C54C}\u{C544}\u{BCFC} \u{C218} \u{C788}\u{B3C4}\u{B85D} \u{D558}\u{C138}\u{C694}.`,
    mww: `Upload ib daim duab ntawm koj tus kheej los ua tus kheej koj tus account thiab pab lwm tus neeg yooj yim paub koj thoob plaws lub app.`,
    ps: `\u{62F} \u{62E}\u{67E}\u{644} \u{681}\u{627}\u{646} \u{639}\u{6A9}\u{633} \u{67E}\u{648}\u{631}\u{62A}\u{647} \u{6A9}\u{693}\u{626} \u{62A}\u{631}\u{685}\u{648} \u{62E}\u{67E}\u{644} \u{62D}\u{633}\u{627}\u{628} \u{634}\u{62E}\u{635}\u{6CC} \u{6A9}\u{693}\u{626} \u{627}\u{648} \u{646}\u{648}\u{631}\u{648} \u{62A}\u{647} \u{645}\u{631}\u{633}\u{62A}\u{647} \u{648}\u{6A9}\u{693}\u{626} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{67E}\u{647} \u{627}\u{633}\u{627}\u{646}\u{6CD} \u{633}\u{631}\u{647} \u{62F} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{648}\u{67E}\u{6CC}\u{698}\u{646}\u{6CC}.`,
    pt: `Envie uma foto sua para personalizar sua conta e ajudar os outros a te reconhecerem facilmente pelo aplicativo.`,
    'pt-pt': `Carrega uma foto tua para personalizar a tua conta e ajudar os outros a reconhecer-te facilmente atrav\xe9s da aplica\xe7\xe3o.`,
    ru: `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{438}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{44E} \u{444}\u{43E}\u{442}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{44E}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{435}\u{440}\u{441}\u{43E}\u{43D}\u{430}\u{43B}\u{438}\u{437}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{430}\u{43A}\u{43A}\u{430}\u{443}\u{43D}\u{442} \u{438} \u{43F}\u{43E}\u{43C}\u{43E}\u{447}\u{44C} \u{434}\u{440}\u{443}\u{433}\u{438}\u{43C} \u{43B}\u{435}\u{433}\u{43A}\u{43E} \u{443}\u{437}\u{43D}\u{430}\u{442}\u{44C} \u{432}\u{430}\u{441} \u{432} \u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{438}.`,
    sm: `Fa'apipi'i se ata o oe lava e fa'apitoa ai lau teuga tupe ma fesoasoani i isi ia faigofie ona iloa oe i luga o le app.`,
    so: `Soo geli sawirkaaga si aad akoonkaaga u shakhsiyeen oo dadka kale si fudud kuugu aqoonsadaan app-ka.`,
    th: `\u{E2D}\u{E31}\u{E1B}\u{E42}\u{E2B}\u{E25}\u{E14}\u{E23}\u{E39}\u{E1B}\u{E20}\u{E32}\u{E1E}\u{E02}\u{E2D}\u{E07}\u{E15}\u{E31}\u{E27}\u{E04}\u{E38}\u{E13}\u{E40}\u{E2D}\u{E07}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E1B}\u{E23}\u{E31}\u{E1A}\u{E41}\u{E15}\u{E48}\u{E07}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E41}\u{E25}\u{E30}\u{E0A}\u{E48}\u{E27}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E1C}\u{E39}\u{E49}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E08}\u{E14}\u{E08}\u{E4D}\u{E32}\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E07}\u{E48}\u{E32}\u{E22}\u{E14}\u{E32}\u{E22}\u{E17}\u{E31}\u{E48}\u{E27}\u{E17}\u{E31}\u{E49}\u{E07}\u{E41}\u{E2D}\u{E1B}`,
    ur: `\u{627}\u{67E}\u{646}\u{6CC} \u{62A}\u{635}\u{648}\u{6CC}\u{631} \u{627}\u{67E}\u{644}\u{648}\u{688} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{62A}\u{627}\u{6A9}\u{6C1} \u{622}\u{67E} \u{6A9}\u{627} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{630}\u{627}\u{62A}\u{6CC} \u{646}\u{648}\u{639}\u{6CC}\u{62A} \u{6A9}\u{627} \u{6C1}\u{648} \u{627}\u{648}\u{631} \u{62F}\u{648}\u{633}\u{631}\u{648}\u{6BA} \u{6A9}\u{648} \u{627}\u{6CC}\u{67E} \u{67E}\u{631} \u{622}\u{633}\u{627}\u{646}\u{6CC} \u{633}\u{6D2} \u{67E}\u{6C1}\u{686}\u{627}\u{646}\u{646}\u{6D2} \u{645}\u{6CC}\u{6BA} \u{645}\u{62F}\u{62F} \u{645}\u{644}\u{6D2}\u{6D4}`,
    vi: `T\u{1EA3}i l\xean \u{1EA3}nh c\u{1EE7}a ch\xednh b\u{1EA1}n \u{111}\u{1EC3} c\xe1 nh\xe2n h\xf3a t\xe0i kho\u{1EA3}n c\u{1EE7}a b\u{1EA1}n v\xe0 gi\xfap ng\u{1B0}\u{1EDD}i kh\xe1c d\u{1EC5} d\xe0ng nh\u{1EAD}n ra b\u{1EA1}n tr\xean \u{1EE9}ng d\u{1EE5}ng.`,
    'zh-hans': `\u{4E0A}\u{4F20}\u{4E00}\u{5F20}\u{81EA}\u{5DF1}\u{7684}\u{7167}\u{7247}\u{FF0C}\u{4E2A}\u{6027}\u{5316}\u{4F60}\u{7684}\u{8D26}\u{53F7}\u{FF0C}\u{5E2E}\u{52A9}\u{522B}\u{4EBA}\u{5728}\u{5E94}\u{7528}\u{4E2D}\u{8F7B}\u{677E}\u{8BA4}\u{51FA}\u{4F60}\u{3002}`,
    'zh-hant': `\u{4E0A}\u{50B3}\u{4E00}\u{5F35}\u{81EA}\u{5DF1}\u{7684}\u{7167}\u{7247}\u{FF0C}\u{8B93}\u{5E33}\u{865F}\u{66F4}\u{500B}\u{4EBA}\u{5316}\u{FF0C}\u{4E5F}\u{8B93}\u{5225}\u{4EBA}\u{5728}\u{6574}\u{500B}\u{61C9}\u{7528}\u{7A0B}\u{5F0F}\u{4E2D}\u{66F4}\u{5BB9}\u{6613}\u{8A8D}\u{51FA}\u{4F60}\u{3002}`,
    en: `Upload a photo of yourself to personalize your account and help others easily recognize you across the app.`
};
const $b11db1b62d4a8f76$export$7cd02a45e553bdca = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645}`,
    de: `Verwendung`,
    es: `Uso`,
    fa: `\u{6A9}\u{627}\u{631}\u{628}\u{631}\u{62F}`,
    fil: `Paggamit`,
    fr: `Utilisation`,
    hi: `\u{92A}\u{94D}\u{930}\u{92F}\u{94B}\u{917}`,
    ht: `Itilizasyon`,
    it: `Utilizzo`,
    ja: `\u{4F7F}\u{7528}\u{4F8B}`,
    ko: `\u{C0AC}\u{C6A9}`,
    mww: `Kev siv`,
    ps: `\u{6A9}\u{627}\u{631}\u{648}\u{646}\u{647}`,
    pt: `Uso`,
    'pt-pt': `Utiliza\xe7\xe3o`,
    ru: `\u{418}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Fa'aaogaina`,
    so: `Isticmaalka`,
    th: `\u{E01}\u{E32}\u{E23}\u{E43}\u{E0A}\u{E49}`,
    ur: `\u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644}`,
    vi: `S\u{1EED} d\u{1EE5}ng`,
    'zh-hans': `\u{7528}\u{9014}`,
    'zh-hant': `\u{4F7F}\u{7528}\u{60C5}\u{6CC1}`,
    en: `Usage`
};
const $b11db1b62d4a8f76$export$5375257ecc3e1ef6 = {
    ar: `\u{627}\u{644}\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}`,
    de: `Nutzer`,
    es: `Usuario`,
    fa: `\u{6A9}\u{627}\u{631}\u{628}\u{631}`,
    fil: `Gumagamit`,
    fr: `Utilisateur`,
    hi: `\u{909}\u{92A}\u{92D}\u{94B}\u{915}\u{94D}\u{924}\u{93E}`,
    ht: `Itilizat\xe8`,
    it: `Utente`,
    ja: `\u{30E6}\u{30FC}\u{30B6}\u{30FC}`,
    ko: `\u{C0AC}\u{C6A9}\u{C790}`,
    mww: `Tus neeg siv`,
    ps: `\u{6A9}\u{627}\u{631}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Usu\xe1rio`,
    'pt-pt': `Utilizador`,
    ru: `\u{41F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}`,
    sm: `Tagata fa'aaoga`,
    so: `Isticmaale`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}`,
    ur: `\u{635}\u{627}\u{631}\u{641}`,
    vi: `Ng\u{1B0}\u{1EDD}i d\xf9ng`,
    'zh-hans': `\u{7528}\u{6237}`,
    'zh-hant': `\u{4F7F}\u{7528}\u{8005}`,
    en: `User`
};
const $b11db1b62d4a8f76$export$43efe7f165617421 = {
    ar: `\u{627}\u{633}\u{645} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}`,
    de: `Benutzername`,
    es: `Nombre de usuario`,
    fa: `\u{646}\u{627}\u{645} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{6CC}`,
    fil: `Username`,
    fr: `Nom d\u{2019}utilisateur`,
    hi: `\u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E} \u{928}\u{93E}\u{92E}`,
    ht: `Non itilizat\xe8 a`,
    it: `Nome utente`,
    ja: `\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{540D}`,
    ko: `\u{C0AC}\u{C6A9}\u{C790} \u{C774}\u{B984}`,
    mww: `Tus neeg siv npe`,
    ps: `\u{6A9}\u{627}\u{631}\u{646} \u{646}\u{648}\u{645}`,
    pt: `Nome de usu\xe1rio`,
    'pt-pt': `Nome de utilizador`,
    ru: `\u{418}\u{43C}\u{44F} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F}`,
    sm: `Igoa faaaoga`,
    so: `Magaca Isticmaalaha`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}`,
    ur: `\u{6CC}\u{648}\u{632}\u{631} \u{646}\u{6CC}\u{645}`,
    vi: `T\xean \u{111}\u{103}ng nh\u{1EAD}p`,
    'zh-hans': `\u{7528}\u{6237}\u{540D}`,
    'zh-hant': `\u{7528}\u{6236}\u{540D}`,
    en: `Username`
};
const $b11db1b62d4a8f76$export$43655dd05f82e4bf = {
    ar: `\u{627}\u{633}\u{645} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645} \u{63A}\u{64A}\u{631} \u{645}\u{62A}\u{627}\u{62D}`,
    de: `Benutzername nicht verf\xfcgbar`,
    es: `Nombre de usuario no disponible`,
    fa: `\u{646}\u{627}\u{645} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{6CC} \u{62F}\u{631} \u{62F}\u{633}\u{62A}\u{631}\u{633} \u{646}\u{6CC}\u{633}\u{62A}`,
    fil: `Hindi magagamit ang username`,
    fr: `Nom d\u{2019}utilisateur indisponible`,
    hi: `\u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E} \u{928}\u{93E}\u{92E} \u{905}\u{928}\u{941}\u{92A}\u{932}\u{92C}\u{94D}\u{927}`,
    ht: `Non itilizat\xe8 pa disponib`,
    it: `Nome utente non disponibile`,
    ja: `\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{540D}\u{304C}\u{5229}\u{7528}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C0AC}\u{C6A9}\u{C790} \u{C774}\u{B984}\u{C774} \u{C81C}\u{ACF5}\u{B418}\u{C9C0} \u{C54A}\u{C74C}`,
    mww: `Username tsis muaj`,
    ps: `\u{6A9}\u{627}\u{631}\u{646} \u{646}\u{648}\u{645} \u{634}\u{62A}\u{648}\u{646} \u{646}\u{644}\u{631}\u{6CC}`,
    pt: `Nome de usu\xe1rio indispon\xedvel`,
    'pt-pt': `Nome de utilizador indispon\xedvel`,
    ru: `\u{418}\u{43C}\u{44F} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}`,
    sm: `E le o maua le igoa faaaoga`,
    so: `Magaca isticmaale lama heli karo`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E44}\u{E21}\u{E48}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6CC}\u{648}\u{632}\u{631} \u{646}\u{6CC}\u{645} \u{62F}\u{633}\u{62A}\u{6CC}\u{627}\u{628} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `T\xean ng\u{1B0}\u{1EDD}i d\xf9ng kh\xf4ng kh\u{1EA3} d\u{1EE5}ng`,
    'zh-hans': `\u{7528}\u{6237}\u{540D}\u{4E0D}\u{53EF}\u{7528}`,
    'zh-hant': `\u{7528}\u{6236}\u{540D}\u{7A31}\u{7121}\u{6CD5}\u{63D0}\u{4F9B}`,
    en: `Username unavailable`
};
const $b11db1b62d4a8f76$export$383ccceb9623a9e8 = {
    ar: `\u{623}\u{639}\u{636}\u{627}\u{621} \u{645}\u{646}\u{638}\u{645}\u{62A}\u{643} \u{648}\u{627}\u{644}\u{645}\u{62A}\u{639}\u{627}\u{648}\u{646}\u{648}\u{646} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{64A}\u{639} \u{645}\u{646} \u{645}\u{646}\u{638}\u{645}\u{627}\u{62A} \u{62E}\u{627}\u{631}\u{62C}\u{64A}\u{629}.`,
    de: `Mitglieder Ihrer Organisation und Projektmitarbeiter von externen Organisationen.`,
    es: `Miembros de tu organizaci\xf3n y colaboradores del proyecto de organizaciones externas.`,
    fa: `\u{627}\u{639}\u{636}\u{627}\u{6CC} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{634}\u{645}\u{627} \u{648} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{627}\u{646} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{627}\u{632} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{647}\u{627}\u{6CC} \u{62E}\u{627}\u{631}\u{62C}\u{6CC}.`,
    fil: `Mga miyembro ng iyong organisasyon at mga nakikipagtulungan sa proyekto mula sa mga panlabas na organisasyon.`,
    fr: `Des membres de votre organisation et des collaborateurs de projets provenant d\u{2019}organisations ext\xe9rieures.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{914}\u{930} \u{92C}\u{93E}\u{939}\u{930}\u{940} \u{938}\u{902}\u{917}\u{920}\u{928}\u{94B}\u{902} \u{915}\u{947} \u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E} \u{938}\u{939}\u{92F}\u{94B}\u{917}\u{940}\u{964}`,
    ht: `Manm \xf2ganizasyon ou ak kolaborat\xe8 pwoj\xe8 ki soti nan \xf2ganizasyon dey\xf2 yo.`,
    it: `Membri della tua organizzazione e collaboratori di progetto provenienti da organizzazioni esterne.`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3084}\u{5916}\u{90E8}\u{7D44}\u{7E54}\u{306E}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{5354}\u{529B}\u{8005}\u{3002}`,
    ko: `\u{ADC0}\u{D558}\u{C758} \u{C870}\u{C9C1} \u{AD6C}\u{C131}\u{C6D0}\u{ACFC} \u{C678}\u{BD80} \u{C870}\u{C9C1}\u{C758} \u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{D611}\u{B825}\u{C790}\u{B4E4}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Cov tswv cuab ntawm koj lub koom haum thiab cov neeg koom tes ua haujlwm los ntawm cov koom haum sab nraud.`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{63A}\u{693}\u{6CC} \u{627}\u{648} \u{62F} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{627}\u{646} \u{644}\u{647} \u{628}\u{647}\u{631}\u{646}\u{6CC}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{648}.`,
    pt: `Membros da sua organiza\xe7\xe3o e colaboradores do projeto de organiza\xe7\xf5es externas.`,
    'pt-pt': `Membros da sua organiza\xe7\xe3o e colaboradores do projeto de organiza\xe7\xf5es externas.`,
    ru: `\u{427}\u{43B}\u{435}\u{43D}\u{44B} \u{432}\u{430}\u{448}\u{435}\u{439} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{438} \u{441}\u{43E}\u{430}\u{432}\u{442}\u{43E}\u{440}\u{44B} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{43E}\u{432} \u{438}\u{437} \u{432}\u{43D}\u{435}\u{448}\u{43D}\u{438}\u{445} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{439}.`,
    sm: `Tagata o lau fa'alapotopotoga ma tagata galulue fa'atasi mai fa'alapotopotoga i fafo.`,
    so: `Xubnaha ururkaaga iyo wada-shaqeeyayaal mashruuc oo ka socda ururo dibadda ah.`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E43}\u{E19}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E41}\u{E25}\u{E30}\u{E1C}\u{E39}\u{E49}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E31}\u{E19}\u{E43}\u{E19}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}\u{E08}\u{E32}\u{E01}\u{E20}\u{E32}\u{E22}\u{E19}\u{E2D}\u{E01}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{627}\u{631}\u{6A9}\u{627}\u{646} \u{627}\u{648}\u{631} \u{628}\u{6CC}\u{631}\u{648}\u{646}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{648}\u{6BA} \u{6A9}\u{6D2} \u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679} \u{6A9}\u{6D2} \u{634}\u{631}\u{627}\u{6A9}\u{62A} \u{62F}\u{627}\u{631}\u{6D4}`,
    vi: `C\xe1c th\xe0nh vi\xean trong t\u{1ED5} ch\u{1EE9}c c\u{1EE7}a b\u{1EA1}n v\xe0 c\u{1ED9}ng t\xe1c vi\xean d\u{1EF1} \xe1n t\u{1EEB} c\xe1c t\u{1ED5} ch\u{1EE9}c b\xean ngo\xe0i.`,
    'zh-hans': `\u{4F60}\u{6240}\u{5728}\u{7EC4}\u{7EC7}\u{7684}\u{6210}\u{5458}\u{4EE5}\u{53CA}\u{6765}\u{81EA}\u{5916}\u{90E8}\u{7EC4}\u{7EC7}\u{7684}\u{9879}\u{76EE}\u{5408}\u{4F5C}\u{8005}\u{3002}`,
    'zh-hant': `\u{4F60}\u{7D44}\u{7E54}\u{7684}\u{6210}\u{54E1}\u{4EE5}\u{53CA}\u{4F86}\u{81EA}\u{5916}\u{90E8}\u{7D44}\u{7E54}\u{7684}\u{5C08}\u{6848}\u{5408}\u{4F5C}\u{8005}\u{3002}`,
    en: `Members of your organization and project collaborators from outside organizations.`
};
const $b11db1b62d4a8f76$export$62360ee1b063eeee = {
    ar: `\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629}`,
    de: `Nutzung von Aktivit\xe4ten`,
    es: `Actividades de uso`,
    fa: `\u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{627}\u{632} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}`,
    fil: `Paggamit ng mga aktibidad`,
    fr: `Utilisation des activit\xe9s`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `S\xe8vi ak aktivite yo`,
    it: `Utilizzo delle attivit\xe0`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306E}\u{5229}\u{7528}`,
    ko: `\u{D65C}\u{B3D9} \u{D65C}\u{C6A9}`,
    mww: `Siv cov kev ua ub no`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{6A9}\u{627}\u{631}\u{648}\u{644}`,
    pt: `Uso de atividades`,
    'pt-pt': `Utiliza\xe7\xe3o de atividades`,
    ru: `\u{418}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Faaaogaina o gaoioiga`,
    so: `Isticmaalka hawlaha`,
    th: `\u{E01}\u{E32}\u{E23}\u{E43}\u{E0A}\u{E49}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{646}\u{627}`,
    vi: `S\u{1EED} d\u{1EE5}ng ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    'zh-hans': `\u{6D3B}\u{52A8}\u{4F7F}\u{7528}\u{65B9}\u{6CD5}`,
    'zh-hant': `\u{6D3B}\u{52D5}\u{904B}\u{7528}`,
    en: `Using activities`
};
const $b11db1b62d4a8f76$export$c91311ccbb68ea57 = {
    ar: `\u{627}\u{644}\u{644}\u{642}\u{627}\u{62D}`,
    de: `Impfstoff`,
    es: `Vacuna`,
    fa: `\u{648}\u{627}\u{6A9}\u{633}\u{646}`,
    fil: `Bakuna`,
    fr: `Vaccin`,
    hi: `\u{935}\u{948}\u{915}\u{94D}\u{200D}\u{938}\u{940}\u{928}`,
    ht: `Vaksen`,
    it: `Vaccino`,
    ja: `\u{30EF}\u{30AF}\u{30C1}\u{30F3}`,
    ko: `\u{BC31}\u{C2E0}`,
    mww: `tshuaj tiv thaiv kab mob`,
    ps: `\u{648}\u{627}\u{6A9}\u{633}\u{64A}\u{646}`,
    pt: `Vacina`,
    'pt-pt': `Vacina`,
    ru: `\u{412}\u{430}\u{43A}\u{446}\u{438}\u{43D}\u{430}`,
    sm: `Tui`,
    so: `Tallaalka`,
    th: `\u{E27}\u{E31}\u{E04}\u{E0B}\u{E35}\u{E19}`,
    ur: `\u{648}\u{6CC}\u{6A9}\u{633}\u{6CC}\u{646}`,
    vi: `V\u{1EAF}c-xin`,
    'zh-hans': `\u{75AB}\u{82D7}`,
    'zh-hant': `\u{75AB}\u{82D7}`,
    en: `Vaccine`
};
const $b11db1b62d4a8f76$export$c311276e69c67ec6 = {
    ar: `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{637}\u{627}\u{644}\u{645}\u{627} \u{623}\u{646} \u{623}\u{646}\u{634}\u{637}\u{62A}\u{647} \u{627}\u{644}\u{641}\u{631}\u{639}\u{64A}\u{629} \u{644}\u{627} \u{62A}\u{632}\u{627}\u{644} \u{641}\u{64A} \u{62D}\u{627}\u{644}\u{629} \u{645}\u{641}\u{62A}\u{648}\u{62D}\u{629}. \u{627}\u{646}\u{62A}\u{642}\u{644} \u{625}\u{644}\u{649} \u{62A}\u{628}\u{648}\u{64A}\u{628} "\u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{631}\u{62A}\u{628}\u{637}\u{629}" \u{648}\u{623}\u{643}\u{645}\u{644} \u{623}\u{648} \u{623}\u{644}\u{63A} \u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{62F}\u{631}\u{62C}\u{629} \u{647}\u{646}\u{627}\u{643} \u{642}\u{628}\u{644} \u{625}\u{644}\u{63A}\u{627}\u{621} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Eine Aktivit\xe4t kann nicht abgebrochen werden, solange ihre Kinderaktivit\xe4ten noch offen sind. Gehen Sie zum Reiter "Assoziierte Aktivit\xe4ten" und schlie\xdfen Sie die dort aufgef\xfchrten Aktivit\xe4ten ab oder k\xfcndigen Sie diese Aktivit\xe4t, bevor Sie diese Aktivit\xe4t abbrechen.`,
    es: `Una actividad no puede ser cancelada mientras sus actividades secundarias sigan en estado abierto. Accede a la pesta\xf1a "Actividades asociadas" y completa o cancela las actividades que aparecen all\xed antes de cancelar esta actividad.`,
    fa: `\u{6CC}\u{6A9} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{644}\u{63A}\u{648} \u{634}\u{648}\u{62F} \u{62F}\u{631} \u{62D}\u{627}\u{644}\u{6CC} \u{6A9}\u{647} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{641}\u{631}\u{632}\u{646}\u{62F} \u{622}\u{646} \u{647}\u{646}\u{648}\u{632} \u{62F}\u{631} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{628}\u{627}\u{632} \u{647}\u{633}\u{62A}\u{646}\u{62F}. \u{628}\u{647} \u{62A}\u{628} \xab\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{645}\u{631}\u{62A}\u{628}\u{637}\xbb \u{628}\u{631}\u{648}\u{6CC}\u{62F} \u{648} \u{642}\u{628}\u{644} \u{627}\u{632} \u{644}\u{63A}\u{648} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{60C} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{641}\u{647}\u{631}\u{633}\u{62A} \u{634}\u{62F}\u{647} \u{62F}\u{631} \u{622}\u{646}\u{62C}\u{627} \u{631}\u{627} \u{6A9}\u{627}\u{645}\u{644} \u{6CC}\u{627} \u{644}\u{63A}\u{648} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Ang isang aktibidad ay hindi maaaring kanselahin habang ang mga aktibidad ng bata ay nasa bukas pa ring katayuan. Mag-navigate sa tab na "Mga Kaugnay na Aktibidad" at kumpletuhin o kanselahin ang mga aktibidad na nakalista doon bago kanselahin ang aktibidad na ito.`,
    fr: `Une activit\xe9 ne peut pas \xeatre annul\xe9e tant que ses activit\xe9s enfants sont encore en statut ouvert. Acc\xe9dez \xe0 l\u{2019}onglet \xab Activit\xe9s associ\xe9es \xbb et compl\xe9tez ou annulez les activit\xe9s list\xe9es avant d\u{2019}annuler cette activit\xe9.`,
    hi: `\u{915}\u{93F}\u{938}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{94B} \u{924}\u{92C} \u{930}\u{926}\u{94D}\u{926} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{91C}\u{92C} \u{909}\u{938}\u{915}\u{940} \u{91A}\u{93E}\u{907}\u{932}\u{94D}\u{921} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901} \u{905}\u{92D}\u{940} \u{92D}\u{940} \u{916}\u{941}\u{932}\u{940} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{92E}\u{947}\u{902} \u{939}\u{94B}\u{902}. "\u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901}" \u{91F}\u{948}\u{92C} \u{92A}\u{930} \u{91C}\u{93E}\u{90F}\u{901} \u{914}\u{930} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{94B} \u{930}\u{926}\u{94D}\u{926} \u{915}\u{930}\u{928}\u{947} \u{938}\u{947} \u{92A}\u{939}\u{932}\u{947} \u{935}\u{939}\u{93E}\u{902} \u{938}\u{942}\u{91A}\u{940}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{92A}\u{942}\u{930}\u{93E} \u{92F}\u{93E} \u{930}\u{926}\u{94D}\u{926} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Yon aktivite pa ka anile pandan aktivite pitit li yo toujou nan yon estati ouv\xe8. Navige nan tab la "Aktivite ki asosye yo" epi ranpli oswa anile aktivite ki nan lis la anvan anile aktivite sa a.`,
    it: `Un'attivit\xe0 non pu\xf2 essere annullata finch\xe9 le attivit\xe0 figlie sono ancora in stato aperto. Accedi alla scheda "Attivit\xe0 associate" e completa o annulla le attivit\xe0 elencate prima di cancellare questa attivit\xe0.`,
    ja: `\u{5B50}\u{6D3B}\u{52D5}\u{304C}\u{307E}\u{3060}\u{30AA}\u{30FC}\u{30D7}\u{30F3}\u{306A}\u{72B6}\u{614B}\u{3067}\u{306F}\u{3001}\u{6D3B}\u{52D5}\u{3092}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3059}\u{308B}\u{3053}\u{3068}\u{306F}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}\u{300C}\u{95A2}\u{9023}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{300D}\u{30BF}\u{30D6}\u{306B}\u{79FB}\u{52D5}\u{3057}\u{3001}\u{305D}\u{3053}\u{306B}\u{8A18}\u{8F09}\u{3055}\u{308C}\u{305F}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3059}\u{308B}\u{524D}\u{306B}\u{3001}\u{5B8C}\u{4E86}\u{307E}\u{305F}\u{306F}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C790}\u{C2DD} \u{D65C}\u{B3D9}\u{C774} \u{C544}\u{C9C1} \u{C5F4}\u{B824} \u{C788}\u{B294} \u{C0C1}\u{D0DC}\u{C778} \u{B3D9}\u{C548}\u{C5D0}\u{B294} \u{D65C}\u{B3D9}\u{C744} \u{CDE8}\u{C18C}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}. "\u{AD00}\u{B828} \u{D65C}\u{B3D9}" \u{D0ED}\u{C73C}\u{B85C} \u{C774}\u{B3D9}\u{D558}\u{C5EC} \u{D574}\u{B2F9} \u{D65C}\u{B3D9}\u{C744} \u{C644}\u{B8CC}\u{D558}\u{AC70}\u{B098} \u{CDE8}\u{C18C}\u{D55C} \u{D6C4} \u{C774} \u{D65C}\u{B3D9}\u{C744} \u{CDE8}\u{C18C}\u{D558}\u{C138}\u{C694}.`,
    mww: `Ib qho kev ua ub no tsis tuaj yeem raug tshem tawm thaum nws cov me nyuam cov kev ua ub no tseem qhib. Mus rau "Cov kev ua ub no txuam" tab thiab ua kom tiav lossis tshem tawm cov haujlwm uas tau teev tseg ua ntej tshem tawm qhov kev ua no.`,
    ps: `\u{6CC}\u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{646}\u{634}\u{6CC} \u{644}\u{63A}\u{648}\u{647} \u{6A9}\u{6D0}\u{62F}\u{627}\u{6CC} \u{62A}\u{631} \u{685}\u{648} \u{686}\u{6D0} \u{62F} \u{645}\u{627}\u{634}\u{648}\u{645} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{6CC}\u{6D0} \u{644}\u{627} \u{647}\u{645} \u{62E}\u{644}\u{627}\u{635} \u{62D}\u{627}\u{644}\u{62A} \u{6A9}\u{6D0} \u{648}\u{6CC}. \u{62F} "\u{627}\u{693}\u{648}\u{646}\u{62F}\u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{648}" \u{67C}\u{628} \u{62A}\u{647} \u{644}\u{627}\u{693} \u{634}\u{626} \u{627}\u{648} \u{647}\u{644}\u{62A}\u{647} \u{644}\u{6CC}\u{633}\u{62A} \u{634}\u{648}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{628}\u{634}\u{67E}\u{693} \u{6CC}\u{627} \u{644}\u{63A}\u{648}\u{647} \u{6A9}\u{693}\u{626} \u{645}\u{62E}\u{6A9}\u{6D0} \u{644}\u{647} \u{62F}\u{6D0} \u{686}\u{6D0} \u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{644}\u{63A}\u{648}\u{647} \u{6A9}\u{693}\u{626}.`,
    pt: `Uma atividade n\xe3o pode ser cancelada enquanto suas atividades filhas ainda estiverem em status aberto. Navegue at\xe9 a aba "Atividades Associadas" e complete ou cancele as atividades listadas l\xe1 antes de cancelar essa atividade.`,
    'pt-pt': `Uma atividade n\xe3o pode ser cancelada enquanto as suas atividades filhas ainda estiverem em estado aberto. Navegue at\xe9 ao separador "Atividades Associadas" e complete ou cancele as atividades a\xed listadas antes de cancelar esta atividade.`,
    ru: `\u{410}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{430}, \u{43F}\u{43E}\u{43A}\u{430} \u{435}\u{451} \u{434}\u{43E}\u{447}\u{435}\u{440}\u{43D}\u{438}\u{435} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{43E}\u{441}\u{442}\u{430}\u{44E}\u{442}\u{441}\u{44F} \u{432} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{435} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{43E}\u{441}\u{442}\u{438}. \u{41F}\u{435}\u{440}\u{435}\u{439}\u{434}\u{438}\u{442}\u{435} \u{43D}\u{430} \u{432}\u{43A}\u{43B}\u{430}\u{434}\u{43A}\u{443} \xab\u{421}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F}\xbb \u{438} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{438}\u{442}\u{435} \u{438}\u{43B}\u{438} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{435} \u{443}\u{43A}\u{430}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{442}\u{430}\u{43C} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F} \u{43F}\u{435}\u{440}\u{435}\u{434} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{43E}\u{439}.`,
    sm: `E le mafai ona faaleaogaina se gaoioiga a o tatala pea ana gaoioiga a tamaiti. Alu i le faailoga o le "Gaoioiga e Fesootai i ai" ma faamaea pe faaleaogaina ia gaoioiga o loo lisiina atu iina a o lei faaleaogaina lenei gaoioiga.`,
    so: `Hawl lama joojin karo inta hawlaha carruurta ay weli furan yihiin. U gudub tabka "Hawlaha La Xiriira" oo dhammee ama jooji hawlaha ku taxan ka hor intaadan joojin hawshan.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E44}\u{E14}\u{E49}\u{E43}\u{E19}\u{E02}\u{E13}\u{E30}\u{E17}\u{E35}\u{E48}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E22}\u{E48}\u{E2D}\u{E22}\u{E22}\u{E31}\u{E07}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E43}\u{E19}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E40}\u{E1B}\u{E34}\u{E14}\u{E2D}\u{E22}\u{E39}\u{E48} \u{E44}\u{E1B}\u{E17}\u{E35}\u{E48}\u{E41}\u{E17}\u{E47}\u{E1A} "\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}" \u{E41}\u{E25}\u{E30}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E43}\u{E2B}\u{E49}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}\u{E44}\u{E27}\u{E49}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{62C}\u{628} \u{62A}\u{6A9} \u{627}\u{633} \u{6A9}\u{6CC} \u{686}\u{627}\u{626}\u{644}\u{688} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{627}\u{648}\u{67E}\u{646} \u{627}\u{633}\u{679}\u{6CC}\u{679}\u{633} \u{645}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{6BA}\u{60C} \u{6A9}\u{648}\u{626}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{646}\u{633}\u{648}\u{62E} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{6CC}\u{6D4} "\u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}" \u{679}\u{6CC}\u{628} \u{67E}\u{631} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{648} \u{645}\u{646}\u{633}\u{648}\u{62E} \u{6A9}\u{631}\u{646}\u{6D2} \u{633}\u{6D2} \u{67E}\u{6C1}\u{644}\u{6D2} \u{648}\u{6C1}\u{627}\u{6BA} \u{62F}\u{631}\u{62C} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{645}\u{6A9}\u{645}\u{644} \u{6CC}\u{627} \u{645}\u{646}\u{633}\u{648}\u{62E} \u{6A9}\u{631} \u{62F}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Kh\xf4ng th\u{1EC3} h\u{1EE7}y m\u{1ED9}t ho\u{1EA1}t \u{111}\u{1ED9}ng trong khi c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng con c\u{1EE7}a n\xf3 v\u{1EAB}n \u{1EDF} tr\u{1EA1}ng th\xe1i m\u{1EDF}. \u{110}i\u{1EC1}u h\u{1B0}\u{1EDB}ng \u{111}\u{1EBF}n tab "Ho\u{1EA1}t \u{111}\u{1ED9}ng li\xean k\u{1EBF}t" v\xe0 ho\xe0n th\xe0nh ho\u{1EB7}c h\u{1EE7}y c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\u{1B0}\u{1EE3}c li\u{1EC7}t k\xea \u{1EDF} \u{111}\xf3 tr\u{1B0}\u{1EDB}c khi h\u{1EE7}y ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{6D3B}\u{52A8}\u{5728}\u{5176}\u{5B50}\u{6D3B}\u{52A8}\u{4ECD}\u{5904}\u{4E8E}\u{5F00}\u{653E}\u{72B6}\u{6001}\u{65F6}\u{FF0C}\u{4E0D}\u{80FD}\u{88AB}\u{53D6}\u{6D88}\u{3002}\u{8FDB}\u{5165}\u{201C}\u{76F8}\u{5173}\u{6D3B}\u{52A8}\u{201D}\u{6807}\u{7B7E}\u{9875}\u{FF0C}\u{5B8C}\u{6210}\u{6216}\u{53D6}\u{6D88}\u{5176}\u{4E2D}\u{5217}\u{51FA}\u{7684}\u{6D3B}\u{52A8}\u{540E}\u{518D}\u{53D6}\u{6D88}\u{8BE5}\u{6D3B}\u{52A8}\u{3002}`,
    'zh-hant': `\u{6D3B}\u{52D5}\u{5728}\u{5176}\u{5B50}\u{6D3B}\u{52D5}\u{4ECD}\u{8655}\u{65BC}\u{958B}\u{653E}\u{72C0}\u{614B}\u{6642}\u{FF0C}\u{4E0D}\u{80FD}\u{88AB}\u{53D6}\u{6D88}\u{3002}\u{8ACB}\u{524D}\u{5F80}\u{300C}\u{76F8}\u{95DC}\u{6D3B}\u{52D5}\u{300D}\u{6A19}\u{7C64}\u{FF0C}\u{5B8C}\u{6210}\u{6216}\u{53D6}\u{6D88}\u{8A72}\u{6D3B}\u{52D5}\u{524D}\u{5B8C}\u{6210}\u{6216}\u{53D6}\u{6D88}\u{8A72}\u{6D3B}\u{52D5}\u{3002}`,
    en: `An activity cannot be cancelled while its child activities are still in an open status. Navigate to the "Associated activities" tab and complete or cancel the activities listed there prior to cancelling this activity.`
};
const $b11db1b62d4a8f76$export$985ace9d45c3b85d = {
    ar: `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{625}\u{643}\u{645}\u{627}\u{644} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{637}\u{627}\u{644}\u{645}\u{627} \u{623}\u{646} \u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{641}\u{631}\u{639} \u{644}\u{627} \u{62A}\u{632}\u{627}\u{644} \u{641}\u{64A} \u{62D}\u{627}\u{644}\u{629} \u{645}\u{641}\u{62A}\u{648}\u{62D}\u{629}. \u{627}\u{646}\u{62A}\u{642}\u{644} \u{625}\u{644}\u{649} \u{62A}\u{628}\u{648}\u{64A}\u{628} "\u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{631}\u{62A}\u{628}\u{637}\u{629}" \u{648}\u{623}\u{643}\u{645}\u{644} \u{623}\u{648} \u{623}\u{644}\u{63A} \u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{62F}\u{631}\u{62C}\u{629} \u{647}\u{646}\u{627}\u{643} \u{642}\u{628}\u{644} \u{625}\u{643}\u{645}\u{627}\u{644} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Eine Aktivit\xe4t kann nicht abgeschlossen werden, solange ihre Kinderaktivit\xe4ten noch offen sind. Navigieren Sie zum Reiter "Assoziierte Aktivit\xe4ten" und schlie\xdfen Sie die dort aufgef\xfchrten Aktivit\xe4ten vor Abschluss dieser Aktivit\xe4t ab oder k\xfcndigen Sie sie ab.`,
    es: `Una actividad no puede completarse mientras sus actividades menores sigan en estado abierto. Accede a la pesta\xf1a "Actividades asociadas" y completa o cancela las actividades que aparecen all\xed antes de completar esta actividad.`,
    fa: `\u{6CC}\u{6A9} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{641}\u{631}\u{632}\u{646}\u{62F} \u{622}\u{646} \u{647}\u{646}\u{648}\u{632} \u{62F}\u{631} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{628}\u{627}\u{632} \u{647}\u{633}\u{62A}\u{646}\u{62F}\u{60C} \u{642}\u{627}\u{628}\u{644} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{646}\u{6CC}\u{633}\u{62A}. \u{628}\u{647} \u{62A}\u{628} \xab\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{645}\u{631}\u{62A}\u{628}\u{637}\xbb \u{628}\u{631}\u{648}\u{6CC}\u{62F} \u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{641}\u{647}\u{631}\u{633}\u{62A} \u{634}\u{62F}\u{647} \u{62F}\u{631} \u{622}\u{646}\u{62C}\u{627} \u{631}\u{627} \u{642}\u{628}\u{644} \u{627}\u{632} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{6CC}\u{627} \u{644}\u{63A}\u{648} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Ang isang aktibidad ay hindi maaaring makumpleto habang ang mga aktibidad ng bata ay nasa bukas na katayuan pa rin. Mag-navigate sa tab na "Mga Kaugnay na Aktibidad" at kumpletuhin o kanselahin ang mga aktibidad na nakalista doon bago makumpleto ang aktibidad na ito.`,
    fr: `Une activit\xe9 ne peut pas \xeatre achev\xe9e tant que ses activit\xe9s enfants sont encore en statut ouvert. Naviguez dans l\u{2019}onglet \xab Activit\xe9s associ\xe9es \xbb et compl\xe9tez ou annulez les activit\xe9s list\xe9es avant de terminer cette activit\xe9.`,
    hi: `\u{915}\u{94B}\u{908} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{924}\u{92C} \u{92A}\u{942}\u{930}\u{940} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{940} \u{91C}\u{92C} \u{909}\u{938}\u{915}\u{940} \u{91A}\u{93E}\u{907}\u{932}\u{94D}\u{921} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901} \u{905}\u{92D}\u{940} \u{92D}\u{940} \u{916}\u{941}\u{932}\u{940} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{92E}\u{947}\u{902} \u{939}\u{94B}\u{902}. "\u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901}" \u{91F}\u{948}\u{92C} \u{92A}\u{930} \u{91C}\u{93E}\u{90F}\u{901} \u{914}\u{930} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{94B} \u{92A}\u{942}\u{930}\u{93E} \u{915}\u{930}\u{928}\u{947} \u{938}\u{947} \u{92A}\u{939}\u{932}\u{947} \u{935}\u{939}\u{93E}\u{902} \u{938}\u{942}\u{91A}\u{940}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{92A}\u{942}\u{930}\u{93E} \u{92F}\u{93E} \u{930}\u{926}\u{94D}\u{926} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Yon aktivite pa ka konplete pandan aktivite pitit li yo toujou nan yon estati ouv\xe8. Navige nan tab "Aktivite ki asosye yo" epi ranpli oswa anile aktivite ki nan lis la anvan ou fini aktivite sa a.`,
    it: `Un'attivit\xe0 non pu\xf2 essere completata finch\xe9 le attivit\xe0 figlie sono ancora in stato aperto. Accedi alla scheda "Attivit\xe0 associate" e completa o annulla le attivit\xe0 elencate prima di completare questa attivit\xe0.`,
    ja: `\u{5B50}\u{6D3B}\u{52D5}\u{304C}\u{307E}\u{3060}\u{30AA}\u{30FC}\u{30D7}\u{30F3}\u{306A}\u{72B6}\u{614B}\u{3067}\u{306F}\u{3001}\u{6D3B}\u{52D5}\u{3092}\u{5B8C}\u{4E86}\u{3059}\u{308B}\u{3053}\u{3068}\u{306F}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}\u{300C}\u{95A2}\u{9023}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{300D}\u{30BF}\u{30D6}\u{306B}\u{79FB}\u{52D5}\u{3057}\u{3001}\u{305D}\u{3053}\u{306B}\u{8A18}\u{8F09}\u{3055}\u{308C}\u{305F}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{30AF}\u{30EA}\u{30A2}\u{307E}\u{305F}\u{306F}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3057}\u{3066}\u{304B}\u{3089}\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{5B8C}\u{4E86}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{D65C}\u{B3D9}\u{C774} \u{C790}\u{B140} \u{D65C}\u{B3D9}\u{C774} \u{C544}\u{C9C1} \u{C5F4}\u{B824} \u{C788}\u{B294} \u{C0C1}\u{D0DC}\u{C77C} \u{B54C}\u{B294} \u{C644}\u{B8CC}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}. "\u{AD00}\u{B828} \u{D65C}\u{B3D9}" \u{D0ED}\u{C73C}\u{B85C} \u{C774}\u{B3D9}\u{D558}\u{C5EC} \u{C774} \u{D65C}\u{B3D9}\u{C744} \u{C644}\u{B8CC}\u{D558}\u{AE30} \u{C804}\u{C5D0} \u{D574}\u{B2F9} \u{D65C}\u{B3D9}\u{C744} \u{C644}\u{B8CC}\u{D558}\u{AC70}\u{B098} \u{CDE8}\u{C18C}\u{D558}\u{C138}\u{C694}.`,
    mww: `Ib qho kev ua si tsis tuaj yeem ua tiav thaum nws cov kev ua ub no rau menyuam tseem qhib kev ua si. Mus rau "Cov kev ua ub no txuam" tab thiab ua kom tiav lossis tshem tawm cov kev ua ub no uas tau teev tseg ua ntej ua tiav qhov kev ua no.`,
    ps: `\u{6CC}\u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{646}\u{634}\u{6CC} \u{628}\u{634}\u{67E}\u{693}\u{6CC}\u{62F}\u{644}\u{6CC} \u{62A}\u{631} \u{685}\u{648} \u{686}\u{6D0} \u{62F} \u{645}\u{627}\u{634}\u{648}\u{645} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{6CC}\u{6D0} \u{644}\u{627} \u{647}\u{645} \u{62E}\u{644}\u{627}\u{635} \u{62D}\u{627}\u{644}\u{62A} \u{6A9}\u{6D0} \u{648}\u{6CC}. \u{62F} "\u{627}\u{693}\u{648}\u{646}\u{62F}\u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{648}" \u{67C}\u{628} \u{62A}\u{647} \u{644}\u{627}\u{693} \u{634}\u{626} \u{627}\u{648} \u{647}\u{644}\u{62A}\u{647} \u{644}\u{6CC}\u{633}\u{62A} \u{634}\u{648}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{628}\u{634}\u{67E}\u{693} \u{6CC}\u{627} \u{644}\u{63A}\u{648}\u{647} \u{6A9}\u{693}\u{626} \u{645}\u{62E}\u{6A9}\u{6D0} \u{644}\u{647} \u{62F}\u{6D0} \u{686}\u{6D0} \u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{634}\u{67E}\u{693} \u{6A9}\u{693}\u{626}.`,
    pt: `Uma atividade n\xe3o pode ser conclu\xedda enquanto suas atividades filhas ainda estiverem em status aberto. Navegue at\xe9 a aba "Atividades Associadas" e complete ou cancele as atividades listadas l\xe1 antes de concluir essa atividade.`,
    'pt-pt': `Uma atividade n\xe3o pode ser conclu\xedda enquanto as suas atividades filhas ainda estiverem em estado aberto. Navegue at\xe9 ao separador "Atividades Associadas" e complete ou cancele as atividades a\xed listadas antes de concluir esta atividade.`,
    ru: `\u{417}\u{430}\u{434}\u{430}\u{43D}\u{438}\u{435} \u{43D}\u{435}\u{43B}\u{44C}\u{437}\u{44F} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{438}\u{442}\u{44C}, \u{43F}\u{43E}\u{43A}\u{430} \u{434}\u{43E}\u{447}\u{435}\u{440}\u{43D}\u{438}\u{435} \u{437}\u{430}\u{43D}\u{44F}\u{442}\u{438}\u{44F} \u{43D}\u{430}\u{445}\u{43E}\u{434}\u{44F}\u{442}\u{441}\u{44F} \u{432} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{43E}\u{43C} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{435}. \u{41F}\u{435}\u{440}\u{435}\u{439}\u{434}\u{438}\u{442}\u{435} \u{43D}\u{430} \u{432}\u{43A}\u{43B}\u{430}\u{434}\u{43A}\u{443} \xab\u{421}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{438}\xbb \u{438} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{438}\u{442}\u{435} \u{438}\u{43B}\u{438} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{435} \u{443}\u{43A}\u{430}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{442}\u{430}\u{43C} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F} \u{434}\u{43E} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{438}\u{44F} \u{44D}\u{442}\u{43E}\u{439} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{438}.`,
    sm: `E le mafai ona faamaeaina se gaoioiga a o tatala pea ana gaoioiga a tamaiti. Alu i le faailoga o "Gaoioiga e faatatau i ai" ma faamaea pe faaleaogaina ia gaoioiga o loo lisiina iina a o lei faamaeaina lenei gaoioiga.`,
    so: `Hawl lama dhameystiri karo inta hawlaha carruurta ay weli furan yihiin. U gudub tabka "Hawlaha La Xiriira" oo dhameystir ama jooji hawlaha ku taxan ka hor intaadan dhammaystirin hawshan.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E17}\u{E4D}\u{E32}\u{E43}\u{E2B}\u{E49}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E44}\u{E14}\u{E49}\u{E43}\u{E19}\u{E02}\u{E13}\u{E30}\u{E17}\u{E35}\u{E48}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E22}\u{E48}\u{E2D}\u{E22}\u{E22}\u{E31}\u{E07}\u{E04}\u{E07}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E43}\u{E19}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E40}\u{E1B}\u{E34}\u{E14} \u{E44}\u{E1B}\u{E17}\u{E35}\u{E48}\u{E41}\u{E17}\u{E47}\u{E1A} "\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}" \u{E41}\u{E25}\u{E30}\u{E17}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}\u{E44}\u{E27}\u{E49}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E17}\u{E4D}\u{E32}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E43}\u{E2B}\u{E49}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{627}\u{633} \u{648}\u{642}\u{62A} \u{62A}\u{6A9} \u{645}\u{6A9}\u{645}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{6CC} \u{62C}\u{628} \u{62A}\u{6A9} \u{627}\u{633} \u{6A9}\u{6CC} \u{686}\u{627}\u{626}\u{644}\u{688} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{627}\u{628}\u{6BE}\u{6CC} \u{627}\u{648}\u{67E}\u{646} \u{627}\u{633}\u{679}\u{6CC}\u{679}\u{633} \u{645}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{6BA}\u{6D4} "\u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}" \u{679}\u{6CC}\u{628} \u{67E}\u{631} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{648} \u{645}\u{6A9}\u{645}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{633}\u{6D2} \u{67E}\u{6C1}\u{644}\u{6D2} \u{648}\u{6C1}\u{627}\u{6BA} \u{62F}\u{631}\u{62C} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{645}\u{6A9}\u{645}\u{644} \u{6CC}\u{627} \u{645}\u{646}\u{633}\u{648}\u{62E} \u{6A9}\u{631} \u{62F}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Kh\xf4ng th\u{1EC3} ho\xe0n th\xe0nh m\u{1ED9}t ho\u{1EA1}t \u{111}\u{1ED9}ng trong khi c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng con c\u{1EE7}a n\xf3 v\u{1EAB}n \u{1EDF} tr\u{1EA1}ng th\xe1i m\u{1EDF}. \u{110}i\u{1EC1}u h\u{1B0}\u{1EDB}ng \u{111}\u{1EBF}n tab "Ho\u{1EA1}t \u{111}\u{1ED9}ng li\xean quan" v\xe0 ho\xe0n th\xe0nh ho\u{1EB7}c h\u{1EE7}y c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\u{1B0}\u{1EE3}c li\u{1EC7}t k\xea \u{1EDF} \u{111}\xf3 tr\u{1B0}\u{1EDB}c khi ho\xe0n th\xe0nh ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{6D3B}\u{52A8}\u{5728}\u{5176}\u{5B50}\u{6D3B}\u{52A8}\u{4ECD}\u{5904}\u{4E8E}\u{5F00}\u{653E}\u{72B6}\u{6001}\u{65F6}\u{65E0}\u{6CD5}\u{5B8C}\u{6210}\u{3002}\u{5728}\u{5B8C}\u{6210}\u{6B64}\u{6D3B}\u{52A8}\u{4E4B}\u{524D}\u{FF0C}\u{8BF7}\u{8FDB}\u{5165}\u{201C}\u{5173}\u{8054}\u{6D3B}\u{52A8}\u{201D}\u{6807}\u{7B7E}\u{9875}\u{FF0C}\u{5B8C}\u{6210}\u{6216}\u{53D6}\u{6D88}\u{5176}\u{4E2D}\u{5217}\u{51FA}\u{7684}\u{6D3B}\u{52A8}\u{3002}`,
    'zh-hant': `\u{6D3B}\u{52D5}\u{5728}\u{5176}\u{5B50}\u{6D3B}\u{52D5}\u{4ECD}\u{8655}\u{65BC}\u{958B}\u{653E}\u{72C0}\u{614B}\u{6642}\u{7121}\u{6CD5}\u{5B8C}\u{6210}\u{3002}\u{8ACB}\u{524D}\u{5F80}\u{300C}\u{76F8}\u{95DC}\u{6D3B}\u{52D5}\u{300D}\u{6A19}\u{7C64}\u{FF0C}\u{5728}\u{5B8C}\u{6210}\u{6B64}\u{6D3B}\u{52D5}\u{524D}\u{5B8C}\u{6210}\u{6216}\u{53D6}\u{6D88}\u{8A72}\u{9801}\u{9762}\u{5217}\u{51FA}\u{7684}\u{6D3B}\u{52D5}\u{3002}`,
    en: `An activity cannot be completed while its child activities are still in an open status. Navigate to the "Associated activities" tab and complete or cancel the activities listed there prior to completing this activity.`
};
const $b11db1b62d4a8f76$export$a1c514477edb0163 = {
    ar: `\u{623}\u{62E}\u{637}\u{627}\u{621} \u{627}\u{644}\u{62A}\u{62D}\u{642}\u{642}`,
    de: `Validierungsfehler`,
    es: `Errores de validaci\xf3n`,
    fa: `\u{62E}\u{637}\u{627}\u{647}\u{627}\u{6CC} \u{627}\u{639}\u{62A}\u{628}\u{627}\u{631}\u{633}\u{646}\u{62C}\u{6CC}`,
    fil: `Mga error sa pagpapatunay`,
    fr: `Erreurs de validation`,
    hi: `\u{938}\u{924}\u{94D}\u{92F}\u{93E}\u{92A}\u{928} \u{924}\u{94D}\u{930}\u{941}\u{91F}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `Er\xe8 validation`,
    it: `Errori di validazione`,
    ja: `\u{691C}\u{8A3C}\u{30A8}\u{30E9}\u{30FC}`,
    ko: `\u{AC80}\u{C99D} \u{C624}\u{B958}`,
    mww: `Kev lees paub yuam kev`,
    ps: `\u{62F} \u{627}\u{639}\u{62A}\u{628}\u{627}\u{631} \u{62A}\u{6D0}\u{631}\u{648}\u{62A}\u{646}\u{6D0}`,
    pt: `Erros de valida\xe7\xe3o`,
    'pt-pt': `Erros de valida\xe7\xe3o`,
    ru: `\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{438} \u{432}\u{430}\u{43B}\u{438}\u{434}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Mea sese o le faamaoniga`,
    so: `Khaladaadka xaqiijinta`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E04}\u{E27}\u{E32}\u{E21}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{62A}\u{635}\u{62F}\u{6CC}\u{642}\u{6CC} \u{63A}\u{644}\u{637}\u{6CC}\u{627}\u{6BA}`,
    vi: `L\u{1ED7}i x\xe1c th\u{1EF1}c`,
    'zh-hans': `\u{9A8C}\u{8BC1}\u{9519}\u{8BEF}`,
    'zh-hant': `\u{9A57}\u{8B49}\u{932F}\u{8AA4}`,
    en: `Validation errors`
};
const $b11db1b62d4a8f76$export$3f23294b4a99e002 = {
    ar: `\u{627}\u{644}\u{628}\u{627}\u{626}\u{639}`,
    de: `Anbieter`,
    es: `Proveedor`,
    fa: `\u{641}\u{631}\u{648}\u{634}\u{646}\u{62F}\u{647}`,
    fil: `Nagbebenta`,
    fr: `Fournisseur`,
    hi: `\u{935}\u{93F}\u{915}\u{94D}\u{930}\u{947}\u{924}\u{93E}`,
    ht: `Vand\xe8`,
    it: `Fornitore`,
    ja: `\u{30D9}\u{30F3}\u{30C0}\u{30FC}`,
    ko: `\u{D310}\u{B9E4}\u{C790}`,
    mww: `Tus neeg muag khoom`,
    ps: `\u{67E}\u{644}\u{648}\u{631}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Fornecedor`,
    'pt-pt': `Fornecedor`,
    ru: `\u{41F}\u{440}\u{43E}\u{434}\u{430}\u{432}\u{435}\u{446}`,
    sm: `Tagata fa'atau`,
    so: `Iibiyaha`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E02}\u{E32}\u{E22}`,
    ur: `\u{648}\u{6CC}\u{646}\u{688}\u{631}`,
    vi: `Nh\xe0 cung c\u{1EA5}p`,
    'zh-hans': `\u{4F9B}\u{5E94}\u{5546}`,
    'zh-hant': `\u{4F9B}\u{61C9}\u{5546}`,
    en: `Vendor`
};
const $b11db1b62d4a8f76$export$5c704772b04618d5 = {
    ar: `\u{639}\u{646}\u{648}\u{627}\u{646} \u{645}\u{648}\u{62B}\u{642}`,
    de: `Verifizierte Adresse`,
    es: `Direcci\xf3n verificada`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{62A}\u{623}\u{6CC}\u{6CC}\u{62F}\u{634}\u{62F}\u{647}`,
    fil: `Email Address`,
    fr: `Adresse v\xe9rifi\xe9e`,
    hi: `\u{938}\u{924}\u{94D}\u{92F}\u{93E}\u{92A}\u{93F}\u{924} \u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s verifye`,
    it: `Indirizzo verificato`,
    ja: `\u{8A8D}\u{8A3C}\u{6E08}\u{307F}\u{4F4F}\u{6240}`,
    ko: `\u{D655}\u{C778}\u{B41C} \u{C8FC}\u{C18C}`,
    mww: `Qhov chaw nyob uas tau txheeb xyuas`,
    ps: `\u{62A}\u{627}\u{6CC}\u{6CC}\u{62F} \u{634}\u{648}\u{6CC} \u{67E}\u{62A}\u{647}`,
    pt: `Endere\xe7o verificado`,
    'pt-pt': `Endere\xe7o verificado`,
    ru: `\u{41F}\u{43E}\u{434}\u{442}\u{432}\u{435}\u{440}\u{436}\u{434}\u{451}\u{43D}\u{43D}\u{44B}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Tuatusi faamaonia`,
    so: `Cinwaanka la xaqiijiyay`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E35}\u{E48}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{634}\u{62F}\u{6C1} \u{67E}\u{62A}\u{6C1}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} \u{111}\xe3 x\xe1c minh`,
    'zh-hans': `\u{5DF2}\u{9A8C}\u{8BC1}\u{5730}\u{5740}`,
    'zh-hant': `\u{5DF2}\u{9A57}\u{8B49}\u{5730}\u{5740}`,
    en: `Verified address`
};
const $b11db1b62d4a8f76$export$5e47618a3dbfd90f = {
    ar: `\u{627}\u{644}\u{645}\u{62D}\u{627}\u{631}\u{628} \u{627}\u{644}\u{642}\u{62F}\u{64A}\u{645}`,
    de: `Veteran`,
    es: `Veterano`,
    fa: `\u{6A9}\u{647}\u{646}\u{647} \u{6A9}\u{627}\u{631}`,
    fil: `Beterano`,
    fr: `V\xe9t\xe9ran`,
    hi: `\u{92A}\u{941}\u{930}\u{93E}\u{928}\u{93E} \u{906}\u{926}\u{92E}\u{940}`,
    ht: `Veteran`,
    it: `Veterano`,
    ja: `\u{9000}\u{5F79}\u{8ECD}\u{4EBA}`,
    ko: `\u{BCA0}\u{D14C}\u{B791}`,
    mww: `Qub tub rog`,
    ps: `\u{62A}\u{62C}\u{631}\u{628}\u{647} \u{644}\u{631}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Veterano`,
    'pt-pt': `Veterano`,
    ru: `\u{412}\u{435}\u{442}\u{435}\u{440}\u{430}\u{43D}`,
    sm: `Veteran`,
    so: `Veteran`,
    th: `\u{E17}\u{E2B}\u{E32}\u{E23}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E28}\u{E36}\u{E01}`,
    ur: `\u{633}\u{627}\u{628}\u{642} \u{641}\u{648}\u{62C}\u{6CC}`,
    vi: `C\u{1EF1}u chi\u{1EBF}n binh`,
    'zh-hans': `\u{8001}\u{5C06}`,
    'zh-hant': `\u{8001}\u{5C07}`,
    en: `Veteran`
};
const $b11db1b62d4a8f76$export$59779707d88725c3 = {
    ar: `\u{647}\u{648}\u{64A}\u{629} \u{627}\u{644}\u{645}\u{62D}\u{627}\u{631}\u{628} \u{627}\u{644}\u{642}\u{62F}\u{64A}\u{645}`,
    de: `Veteranen-ID`,
    es: `Identificaci\xf3n de veterano`,
    fa: `\u{634}\u{646}\u{627}\u{633}\u{647} \u{6A9}\u{647}\u{646}\u{647} \u{633}\u{631}\u{628}\u{627}\u{632}`,
    fil: `ID ng Beterano`,
    fr: `Carte d\u{2019}identit\xe9 v\xe9t\xe9ran`,
    hi: `\u{935}\u{92F}\u{94B}\u{935}\u{943}\u{926}\u{94D}\u{927} \u{906}\u{908}\u{921}\u{940}`,
    ht: `Veteran ID`,
    it: `Tessera Veterano`,
    ja: `\u{9000}\u{5F79}\u{8ECD}\u{4EBA}ID`,
    ko: `\u{C7AC}\u{D5A5}\u{AD70}\u{C778} \u{C2E0}\u{BD84}\u{C99D}`,
    mww: `Qub tub rog ID`,
    ps: `\u{62F} \u{67E}\u{62E}\u{648}\u{627}\u{646}\u{6CC} \u{633}\u{631}\u{62A}\u{6D0}\u{631}\u{6CC} \u{67E}\u{6D0}\u{698}\u{646}\u{62F}\u{646}\u{647}`,
    pt: `Identifica\xe7\xe3o de Veterano`,
    'pt-pt': `Identifica\xe7\xe3o de Veterano`,
    ru: `\u{423}\u{434}\u{43E}\u{441}\u{442}\u{43E}\u{432}\u{435}\u{440}\u{435}\u{43D}\u{438}\u{435} \u{432}\u{435}\u{442}\u{435}\u{440}\u{430}\u{43D}\u{430}`,
    sm: `Veteran ID`,
    so: `Aqoonsiga Veteran`,
    th: `\u{E1A}\u{E31}\u{E15}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E08}\u{E4D}\u{E32}\u{E15}\u{E31}\u{E27}\u{E17}\u{E2B}\u{E32}\u{E23}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E28}\u{E36}\u{E01}`,
    ur: `\u{633}\u{627}\u{628}\u{642} \u{641}\u{648}\u{62C}\u{6CC} \u{634}\u{646}\u{627}\u{62E}\u{62A}\u{6CC} \u{6A9}\u{627}\u{631}\u{688}`,
    vi: `ID c\u{1EF1}u chi\u{1EBF}n binh`,
    'zh-hans': `\u{9000}\u{4F0D}\u{519B}\u{4EBA}\u{8EAB}\u{4EFD}\u{8BC1}`,
    'zh-hant': `\u{9000}\u{4F0D}\u{8ECD}\u{4EBA}\u{8B58}\u{5225}\u{8B49}`,
    en: `Veteran ID`
};
const $b11db1b62d4a8f76$export$cfeaf0cdb33173c8 = {
    ar: `\u{627}\u{644}\u{641}\u{64A}\u{62F}\u{64A}\u{648}`,
    de: `Video`,
    es: `V\xeddeo`,
    fa: `\u{648}\u{6CC}\u{62F}\u{626}\u{648}`,
    fil: `Video`,
    fr: `Vid\xe9o`,
    hi: `\u{935}\u{940}\u{921}\u{93F}\u{92F}\u{94B}`,
    ht: `Videyo`,
    it: `Video`,
    ja: `\u{30D3}\u{30C7}\u{30AA}`,
    ko: `\u{BE44}\u{B514}\u{C624}`,
    mww: `Yees duab`,
    ps: `\u{648}\u{6CC}\u{689}\u{6CC}\u{648}`,
    pt: `V\xeddeo`,
    'pt-pt': `V\xeddeo`,
    ru: `\u{412}\u{438}\u{434}\u{435}\u{43E}`,
    sm: `Vitio`,
    so: `Fiidiyow`,
    th: `\u{E27}\u{E34}\u{E14}\u{E35}\u{E42}\u{E2D}`,
    ur: `\u{648}\u{6CC}\u{688}\u{6CC}\u{648}`,
    vi: `B\u{103}ng h\xecnh`,
    'zh-hans': `\u{89C6}\u{9891}`,
    'zh-hant': `\u{5F71}\u{7247}`,
    en: `Video`
};
const $b11db1b62d4a8f76$export$7452b9f476cd7d5e = {
    ar: `\u{645}\u{646}\u{638}\u{631}`,
    de: `Ansicht`,
    es: `Vista`,
    fa: `\u{646}\u{645}\u{627}\u{6CC}`,
    fil: `Tingnan`,
    fr: `Vue`,
    hi: `\u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E}`,
    ht: `Gade`,
    it: `Vista`,
    ja: `\u{773A}\u{3081}`,
    ko: `\u{C804}\u{B9DD}`,
    mww: `Saib`,
    ps: `\u{644}\u{6CC}\u{62F}`,
    pt: `Vis\xe3o`,
    'pt-pt': `Ver`,
    ru: `\u{412}\u{438}\u{434}`,
    sm: `Va'ai`,
    so: `Muuqaal`,
    th: `\u{E14}\u{E39}`,
    ur: `\u{645}\u{646}\u{638}\u{631}`,
    vi: `Xem`,
    'zh-hans': `\u{666F}\u{89C2}`,
    'zh-hant': `\u{666F}\u{89C0}`,
    en: `View`
};
const $b11db1b62d4a8f76$export$d23eb164d6900aed = {
    ar: `\u{639}\u{631}\u{636} \u{627}\u{644}\u{62C}\u{645}\u{64A}\u{639}`,
    de: `Alle anzeigen`,
    es: `Ver todo`,
    fa: `\u{647}\u{645}\u{647} \u{631}\u{627} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Tingnan ang lahat`,
    fr: `Voir tout`,
    hi: `\u{938}\u{92D}\u{940} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `W\xe8 tout`,
    it: `Visualizza tutto`,
    ja: `\u{5168}\u{3066}\u{3092}\u{898B}\u{308B}`,
    ko: `\u{BAA8}\u{B450} \u{BCF4}\u{AE30}`,
    mww: `Saib tag nrho`,
    ps: `\u{67C}\u{648}\u{644} \u{648}\u{6AB}\u{648}\u{631}\u{626}`,
    pt: `Ver tudo`,
    'pt-pt': `Ver tudo`,
    ru: `\u{41F}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{435}\u{442}\u{44C} \u{432}\u{441}\u{451}`,
    sm: `Va'ai uma`,
    so: `Daawo dhammaan`,
    th: `\u{E14}\u{E39}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{633}\u{628} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Xem t\u{1EA5}t c\u{1EA3}`,
    'zh-hans': `\u{67E5}\u{770B}\u{5168}\u{90E8}`,
    'zh-hant': `\u{5168}\u{90E8}\u{67E5}\u{770B}`,
    en: `View all`
};
const $b11db1b62d4a8f76$export$a3f3aa51d56b0179 = {
    ar: (count)=>`${count} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{629} \u{627}\u{644}\u{634}\u{647}\u{631} \u{627}\u{644}\u{645}\u{627}\u{636}\u{64A}`,
    de: (count)=>`${count} Aufrufe im letzten Monat`,
    es: (count)=>`${count} visualizaciones el mes pasado`,
    fa: (count)=>`${count} \u{628}\u{627}\u{632}\u{62F}\u{6CC}\u{62F} \u{62F}\u{631} \u{645}\u{627}\u{647} \u{6AF}\u{630}\u{634}\u{62A}\u{647}`,
    fil: (count)=>`${count} views nakaraang buwan`,
    fr: (count)=>`${count} vues le mois dernier`,
    hi: (count)=>`\u{92A}\u{93F}\u{91B}\u{932}\u{947} \u{92E}\u{939}\u{940}\u{928}\u{947} ${count} \u{92C}\u{93E}\u{930} \u{926}\u{947}\u{916}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: (count)=>`${count} opinyon mwa pase`,
    it: (count)=>`${count} visualizzazioni lo scorso mese`,
    ja: (count)=>`\u{904E}\u{53BB}${count}\u{56DE}\u{306E}\u{95B2}\u{89A7}`,
    ko: (count)=>`\u{C9C0}\u{B09C} \u{D55C} \u{B2EC} ${count}\u{D68C} \u{C870}\u{D68C}\u{C218}`,
    mww: (count)=>`${count} views lub hli dhau los`,
    ps: (count)=>`\u{62A}\u{6D0}\u{631} \u{645}\u{6CC}\u{627}\u{634}\u{62A} ${count} \u{644}\u{6CC}\u{62F}\u{646}\u{6D0}`,
    pt: (count)=>`${count} visualiza\xe7\xf5es no m\xeas passado`,
    'pt-pt': (count)=>`${count} visualiza\xe7\xf5es no m\xeas passado`,
    ru: (count)=>`${count} \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{43E}\u{432} \u{437}\u{430} \u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{438}\u{439} \u{43C}\u{435}\u{441}\u{44F}\u{446}`,
    sm: (count)=>`${count} manatu i le masina talu ai`,
    so: (count)=>`${count} daawasho bishii la soo dhaafay`,
    th: (count)=>`${count} \u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E43}\u{E19}\u{E40}\u{E14}\u{E37}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E21}\u{E32}`,
    ur: (count)=>`\u{6AF}\u{632}\u{634}\u{62A}\u{6C1} \u{645}\u{627}\u{6C1} ${count} \u{648}\u{6CC}\u{648}\u{632}`,
    vi: (count)=>`${count} l\u{1B0}\u{1EE3}t xem th\xe1ng tr\u{1B0}\u{1EDB}c`,
    'zh-hans': (count)=>`\u{8FC7}\u{53BB}${count} \u{6B21}\u{6D4F}\u{89C8}`,
    'zh-hant': (count)=>`\u{904E}\u{53BB}${count}\u{6B21}\u{700F}\u{89BD}`,
    en: (count)=>`${count} views past month`
};
const $b11db1b62d4a8f76$export$a59ee717b24020ba = {
    ar: `\u{639}\u{631}\u{636} \u{627}\u{644}\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644} \u{648}\u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644}`,
    de: `Details anzeigen und registrieren`,
    es: `Ver detalles y registrarse`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A} \u{648} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645}`,
    fil: `Tingnan ang mga detalye at magparehistro`,
    fr: `Voir les d\xe9tails et inscrire-toi`,
    hi: `\u{935}\u{93F}\u{935}\u{930}\u{923} \u{926}\u{947}\u{916}\u{947}\u{902} \u{914}\u{930} \u{92A}\u{902}\u{91C}\u{940}\u{915}\u{930}\u{923} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Gade detay & enskri`,
    it: `Visualizza dettagli e iscriviti`,
    ja: `\u{8A73}\u{7D30}\u{3092}\u{898B}\u{308B}\u{30FB}\u{767B}\u{9332}`,
    ko: `\u{C0C1}\u{C138} \u{C815}\u{BCF4} \u{BCF4}\u{AE30} \u{BC0F} \u{B4F1}\u{B85D}`,
    mww: `Saib cov ntsiab lus & sau npe`,
    ps: `\u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A} \u{648}\u{6AB}\u{648}\u{631}\u{626} \u{627}\u{648} \u{62B}\u{628}\u{62A} \u{6A9}\u{693}\u{626}`,
    pt: `Veja detalhes e cadastro`,
    'pt-pt': `Ver detalhes e registar-se`,
    ru: `\u{41F}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{435}\u{442}\u{44C} \u{43F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{438} \u{437}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{44F}`,
    sm: `Va'ai auiliiliga & lesitala`,
    so: `Eeg faahfaahinta & diiwaangelinta`,
    th: `\u{E14}\u{E39}\u{E23}\u{E32}\u{E22}\u{E25}\u{E30}\u{E40}\u{E2D}\u{E35}\u{E22}\u{E14} & \u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}`,
    ur: `\u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{631}\u{62C}\u{633}\u{679}\u{631}\u{6CC}\u{634}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Xem chi ti\u{1EBF}t & \u{111}\u{103}ng k\xfd`,
    'zh-hans': `\u{67E5}\u{770B}\u{8BE6}\u{60C5}\u{53CA}\u{6CE8}\u{518C}`,
    'zh-hant': `\u{67E5}\u{770B}\u{8A73}\u{60C5}\u{8207}\u{8A3B}\u{518A}`,
    en: `View details & register`
};
const $b11db1b62d4a8f76$export$d73ea6b8ce21b77b = {
    ar: (event)=>`\u{639}\u{631}\u{636} \u{627}\u{644}\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644} \u{648}\u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{641}\u{64A} ${event}`,
    de: (event)=>`Details ansehen und sich f\xfcr ${event} registrieren`,
    es: (event)=>`Consulta los detalles y reg\xedstrate para ${event}`,
    fa: (event)=>`\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A} \u{648} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} ${event}`,
    fil: (event)=>`Tingnan ang mga detalye at magparehistro para sa ${event}`,
    fr: (event)=>`Voir les d\xe9tails et ${event}`,
    hi: (event)=>`\u{935}\u{93F}\u{935}\u{930}\u{923} \u{926}\u{947}\u{916}\u{947}\u{902} \u{914}\u{930} ${event} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{92A}\u{902}\u{91C}\u{940}\u{915}\u{930}\u{923} \u{915}\u{930}\u{947}\u{902}`,
    ht: (event)=>`Gade detay epi enskri pou ${event}`,
    it: (event)=>`Visualizza i dettagli e registrati per ${event}`,
    ja: (event)=>`\u{592A}${event}\u{306E}\u{8A73}\u{7D30}\u{3068}\u{767B}\u{9332}\u{306F}\u{3053}\u{3061}\u{3089}`,
    ko: (event)=>`${event}\u{AD8C} \u{C138}\u{BD80} \u{C815}\u{BCF4} \u{BCF4}\u{AE30} \u{BC0F} \u{B4F1}\u{B85D}`,
    mww: (event)=>`Saib cov ntsiab lus thiab sau npe rau ${event}`,
    ps: (event)=>`\u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A} \u{648}\u{6AB}\u{648}\u{631}\u{626} \u{627}\u{648} \u{62F} ${event} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{648}\u{6A9}\u{693}\u{626}`,
    pt: (event)=>`Veja detalhes e inscreva-se no ${event}`,
    'pt-pt': (event)=>`Veja detalhes e ${event}`,
    ru: (event)=>`\u{41F}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{435}\u{442}\u{44C} \u{43F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{438} \u{437}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{43D}\u{430} ${event}`,
    sm: (event)=>`Va'ai auiliiliga ma lesitala mo ${event}`,
    so: (event)=>`Faahfaahinta eeg oo iska diiwaangeli ${event}`,
    th: (event)=>`\u{E14}\u{E39}\u{E23}\u{E32}\u{E22}\u{E25}\u{E30}\u{E40}\u{E2D}\u{E35}\u{E22}\u{E14}\u{E41}\u{E25}\u{E30}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E40}\u{E23}\u{E35}\u{E22}\u{E19} ${event}`,
    ur: (event)=>`\u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} ${event} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{631}\u{62C}\u{633}\u{679}\u{631} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: (event)=>`Xem chi ti\u{1EBF}t v\xe0 \u{111}\u{103}ng k\xfd ${event}`,
    'zh-hans': (event)=>`\u{67E5}\u{770B}\u{8BE6}\u{60C5}\u{5E76}\u{6CE8}\u{518C}\u{592A} ${event}`,
    'zh-hant': (event)=>`\u{67E5}\u{770B}\u{8A73}\u{60C5}\u{4E26}\u{5831}\u{540D}\u{592A} ${event}`,
    en: (event)=>`View details and register for ${event}`
};
const $b11db1b62d4a8f76$export$89b1f11d297de9d4 = {
    ar: `\u{639}\u{631}\u{636} \u{627}\u{644}\u{648}\u{62B}\u{64A}\u{642}\u{629}`,
    de: `Dokument anzeigen`,
    es: `Ver documento`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{633}\u{646}\u{62F}`,
    fil: `Tingnan ang dokumento`,
    fr: `Voir le document`,
    hi: `\u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `Gade dokiman`,
    it: `Visualizza il documento`,
    ja: `\u{30C9}\u{30AD}\u{30E5}\u{30E1}\u{30F3}\u{30C8}\u{3092}\u{898B}\u{308B}`,
    ko: `\u{BB38}\u{C11C} \u{BCF4}\u{AE30}`,
    mww: `Saib daim ntawv`,
    ps: `\u{633}\u{646}\u{62F} \u{648}\u{6AB}\u{648}\u{631}\u{647}`,
    pt: `Ver documento`,
    'pt-pt': `Ver documento`,
    ru: `\u{41F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440} \u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{430}`,
    sm: `Tagai i le pepa aloaia`,
    so: `Eeg dukumentiga`,
    th: `\u{E14}\u{E39}\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}`,
    ur: `\u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Xem t\xe0i li\u{1EC7}u`,
    'zh-hans': `\u{67E5}\u{770B}\u{6587}\u{6863}`,
    'zh-hant': `\u{6AA2}\u{8996}\u{6587}\u{4EF6}`,
    en: `View document`
};
const $b11db1b62d4a8f76$export$8740f991b7b1acd8 = {
    ar: (date)=>$b11db1b62d4a8f76$var$html`تمت المشاهدة <span>${date}</span>`,
    de: (date)=>$b11db1b62d4a8f76$var$html`Vor <span>${date} angesehen</span>`,
    es: (date)=>$b11db1b62d4a8f76$var$html`Visto <span>${date}</span>`,
    fa: (date)=>$b11db1b62d4a8f76$var$html`مشاهده <span>${date}</span>`,
    fil: (date)=>$b11db1b62d4a8f76$var$html`Tiningnan <span>${date}</span>`,
    fr: (date)=>$b11db1b62d4a8f76$var$html`Vu <span>${date}</span>`,
    hi: (date)=>$b11db1b62d4a8f76$var$html`<span>${date} देखा गया</span>`,
    ht: (date)=>$b11db1b62d4a8f76$var$html`Wè <span>${date}</span>`,
    it: (date)=>$b11db1b62d4a8f76$var$html`Visualizzato <span>${date}</span>`,
    ja: (date)=>$b11db1b62d4a8f76$var$html`<span>${date}に閲覧</span>`,
    ko: (date)=>$b11db1b62d4a8f76$var$html`<span>${date} 확인함</span>`,
    mww: (date)=>$b11db1b62d4a8f76$var$html`Saib <span>${date}</span>`,
    ps: (date)=>$b11db1b62d4a8f76$var$html`<span>${date} لیدل شوی</span>`,
    pt: (date)=>$b11db1b62d4a8f76$var$html`Visualizado <span>${date}</span>`,
    'pt-pt': (date)=>$b11db1b62d4a8f76$var$html`Visualizado <span>${date}</span>`,
    ru: (date)=>$b11db1b62d4a8f76$var$html`Просмотрено <span>${date}</span>`,
    sm: (date)=>$b11db1b62d4a8f76$var$html`Maimoaina <span>${date}</span>`,
    so: (date)=>$b11db1b62d4a8f76$var$html`Waxaa la arkay <span>${date}</span>`,
    th: (date)=>$b11db1b62d4a8f76$var$html`ดูเมื่อ <span>${date}</span>`,
    ur: (date)=>$b11db1b62d4a8f76$var$html`<span>${date} دیکھا گیا</span>`,
    vi: (date)=>$b11db1b62d4a8f76$var$html`Đã xem <span>${date}</span>`,
    'zh-hans': (date)=>$b11db1b62d4a8f76$var$html`3<span>${date}查看</span>`,
    'zh-hant': (date)=>$b11db1b62d4a8f76$var$html`三<span>${date}瀏覽</span>`,
    en: (date)=>$b11db1b62d4a8f76$var$html`Viewed <span>${date}</span>`
};
const $b11db1b62d4a8f76$export$5c07886fd427343e = {
    ar: `\u{639}\u{631}\u{636} \u{628}\u{648}\u{627}\u{628}\u{629} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{64A}\u{646}`,
    de: `Teilnehmerportal anzeigen`,
    es: `Ver portal de participantes`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{67E}\u{648}\u{631}\u{62A}\u{627}\u{644} \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{6AF}\u{627}\u{646}`,
    fil: `Tingnan ang portal ng kalahok`,
    fr: `Voir le portail des participants`,
    hi: `\u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{940} \u{92A}\u{94B}\u{930}\u{94D}\u{91F}\u{932} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `Gade p\xf2tal patisipan yo`,
    it: `Visualizza il portale partecipante`,
    ja: `\u{53C2}\u{52A0}\u{8005}\u{30DD}\u{30FC}\u{30BF}\u{30EB}\u{3092}\u{898B}\u{308B}`,
    ko: `\u{CC38}\u{AC00}\u{C790} \u{D3EC}\u{D138} \u{BCF4}\u{AE30}`,
    mww: `Saib portal rau cov neeg koom`,
    ps: `\u{62F} \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644}\u{648} \u{67E}\u{648}\u{631}\u{67C}\u{644} \u{648}\u{6AB}\u{648}\u{631}\u{626}`,
    pt: `Ver portal do participante`,
    'pt-pt': `Ver portal do participante`,
    ru: `\u{41F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440} \u{43F}\u{43E}\u{440}\u{442}\u{430}\u{43B}\u{430} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{43E}\u{432}`,
    sm: `Maimoa i le faitotoa o tagata auai`,
    so: `Eeg bogga ka qaybgalayaasha`,
    th: `\u{E14}\u{E39}\u{E1E}\u{E2D}\u{E23}\u{E4C}\u{E17}\u{E31}\u{E25}\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}`,
    ur: `\u{634}\u{631}\u{6A9}\u{627}\u{621} \u{6A9}\u{627} \u{67E}\u{648}\u{631}\u{679}\u{644} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Xem c\u{1ED5}ng th\xf4ng tin ng\u{1B0}\u{1EDD}i tham gia`,
    'zh-hans': `\u{67E5}\u{770B}\u{53C2}\u{4E0E}\u{8005}\u{95E8}\u{6237}`,
    'zh-hant': `\u{67E5}\u{770B}\u{53C3}\u{8207}\u{8005}\u{5165}\u{53E3}\u{7DB2}\u{7AD9}`,
    en: `View participant portal`
};
const $b11db1b62d4a8f76$export$3253d87dc46264ae = {
    ar: `\u{639}\u{631}\u{636} \u{627}\u{644}\u{645}\u{644}\u{641} \u{627}\u{644}\u{634}\u{62E}\u{635}\u{64A}`,
    de: `Profil anzeigen`,
    es: `Ver perfil`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644}`,
    fil: `Tingnan ang profile`,
    fr: `Voir le profil`,
    hi: `\u{92A}\u{94D}\u{930}\u{94B}\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `Gade pwofil`,
    it: `Visualizza profilo`,
    ja: `\u{30D7}\u{30ED}\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{3092}\u{898B}\u{308B}`,
    ko: `\u{D504}\u{B85C}\u{D544} \u{BCF4}\u{AE30}`,
    mww: `Saib profile`,
    ps: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644} \u{648}\u{6AB}\u{648}\u{631}\u{626}`,
    pt: `Ver perfil`,
    'pt-pt': `Ver perfil`,
    ru: `\u{41F}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{435}\u{442}\u{44C} \u{43F}\u{440}\u{43E}\u{444}\u{438}\u{43B}\u{44C}`,
    sm: `Va'ai talaaga otooto`,
    so: `Muuqaalka profile`,
    th: `\u{E14}\u{E39}\u{E42}\u{E1B}\u{E23}\u{E44}\u{E1F}\u{E25}\u{E4C}`,
    ur: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{626}\u{644} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Xem h\u{1ED3} s\u{1A1}`,
    'zh-hans': `\u{67E5}\u{770B}\u{4E2A}\u{4EBA}\u{8D44}\u{6599}`,
    'zh-hant': `\u{67E5}\u{770B}\u{500B}\u{4EBA}\u{8CC7}\u{6599}`,
    en: `View profile`
};
const $b11db1b62d4a8f76$export$6729e646902b016c = {
    ar: `\u{639}\u{631}\u{636} \u{627}\u{644}\u{645}\u{644}\u{641} \u{627}\u{644}\u{634}\u{62E}\u{635}\u{64A} \u{648}\u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}`,
    de: `Profil ansehen und mehr`,
    es: `Ver perfil y m\xe1s`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644} \u{648} \u{645}\u{648}\u{627}\u{631}\u{62F} \u{628}\u{6CC}\u{634}\u{62A}\u{631}`,
    fil: `Tingnan ang profile at higit pa`,
    fr: `Voir le profil et plus encore`,
    hi: `\u{92A}\u{94D}\u{930}\u{94B}\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{914}\u{930} \u{92C}\u{939}\u{941}\u{924} \u{915}\u{941}\u{91B} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `Gade pwofil ak plis ank\xf2`,
    it: `Visualizza profilo e altro ancora`,
    ja: `\u{30D7}\u{30ED}\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{306E}\u{95B2}\u{89A7}\u{306A}\u{3069}`,
    ko: `\u{D504}\u{B85C}\u{D544} \u{BCF4}\u{AE30} \u{BC0F} \u{AE30}\u{D0C0}`,
    mww: `Saib profile thiab ntau ntxiv`,
    ps: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644} \u{627}\u{648} \u{646}\u{648}\u{631} \u{648}\u{6AB}\u{648}\u{631}\u{626}`,
    pt: `Veja o perfil e muito mais`,
    'pt-pt': `Ver perfil e muito mais`,
    ru: `\u{41F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440} \u{43F}\u{440}\u{43E}\u{444}\u{438}\u{43B}\u{44F} \u{438} \u{43C}\u{43D}\u{43E}\u{433}\u{43E}\u{435} \u{434}\u{440}\u{443}\u{433}\u{43E}\u{435}`,
    sm: `Va'ai talaaga otooto ma sili atu`,
    so: `Daawo astaamaha iyo waxyaabo kale`,
    th: `\u{E14}\u{E39}\u{E42}\u{E1B}\u{E23}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E41}\u{E25}\u{E30}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E46}`,
    ur: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{626}\u{644} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{645}\u{632}\u{6CC}\u{62F}`,
    vi: `Xem h\u{1ED3} s\u{1A1} v\xe0 h\u{1A1}n th\u{1EBF} n\u{1EEF}a`,
    'zh-hans': `\u{67E5}\u{770B}\u{4E2A}\u{4EBA}\u{8D44}\u{6599}\u{53CA}\u{66F4}\u{591A}\u{5185}\u{5BB9}`,
    'zh-hant': `\u{67E5}\u{770B}\u{500B}\u{4EBA}\u{6A94}\u{6848}\u{53CA}\u{66F4}\u{591A}\u{8CC7}\u{8A0A}`,
    en: `View profile and more`
};
const $b11db1b62d4a8f76$export$31c0e7f7086cb52b = {
    ar: `\u{639}\u{631}\u{636} \u{627}\u{644}\u{642}\u{627}\u{644}\u{628} \u{627}\u{644}\u{645}\u{62E}\u{62A}\u{627}\u{631}`,
    de: `Ausgew\xe4hlte Vorlage anzeigen`,
    es: `Ver plantilla seleccionada`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{642}\u{627}\u{644}\u{628} \u{645}\u{646}\u{62A}\u{62E}\u{628}`,
    fil: `Tingnan ang napiling template`,
    fr: `Voir le mod\xe8le s\xe9lectionn\xe9`,
    hi: `\u{91A}\u{92F}\u{928}\u{93F}\u{924} \u{91F}\u{947}\u{92E}\u{94D}\u{92A}\u{932}\u{947}\u{91F} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `Gade mod\xe8l chwazi`,
    it: `Visualizza modello selezionato`,
    ja: `\u{9078}\u{629E}\u{3057}\u{305F}\u{30C6}\u{30F3}\u{30D7}\u{30EC}\u{30FC}\u{30C8}\u{3092}\u{898B}\u{308B}`,
    ko: `\u{C120}\u{D0DD}\u{B41C} \u{D15C}\u{D50C}\u{B9BF} \u{BCF4}\u{AE30}`,
    mww: `Saib xaiv template`,
    ps: `\u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{642}\u{627}\u{644}\u{628} \u{648}\u{6AB}\u{648}\u{631}\u{647}`,
    pt: `Ver modelo selecionado`,
    'pt-pt': `Ver modelo selecionado`,
    ru: `\u{41F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{430}`,
    sm: `Tagai i le mamanu ua filifilia`,
    so: `Eeg template-ka la doortay`,
    th: `\u{E14}\u{E39}\u{E40}\u{E17}\u{E21}\u{E40}\u{E1E}\u{E25}\u{E15}\u{E17}\u{E35}\u{E48}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}`,
    ur: `\u{645}\u{646}\u{62A}\u{62E}\u{628} \u{679}\u{6CC}\u{645}\u{67E}\u{644}\u{6CC}\u{679} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Xem m\u{1EAB}u \u{111}\xe3 ch\u{1ECD}n`,
    'zh-hans': `\u{67E5}\u{770B}\u{6240}\u{9009}\u{6A21}\u{677F}`,
    'zh-hant': `\u{67E5}\u{770B}\u{6240}\u{9078}\u{7BC4}\u{672C}`,
    en: `View selected template`
};
const $b11db1b62d4a8f76$export$359e6d3e2f449197 = {
    ar: (views)=>`${views} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{629} \u{641}\u{64A} \u{627}\u{644}\u{634}\u{647}\u{631} \u{627}\u{644}\u{645}\u{627}\u{636}\u{64A}`,
    de: (views)=>`${views} Aufrufe im vergangenen Monat`,
    es: (views)=>`${views} visualizaciones en el \xfaltimo mes`,
    fa: (views)=>`${views} \u{628}\u{627}\u{632}\u{62F}\u{6CC}\u{62F} \u{62F}\u{631} \u{645}\u{627}\u{647} \u{6AF}\u{630}\u{634}\u{62A}\u{647}`,
    fil: (views)=>`${views} views sa nakaraang buwan`,
    fr: (views)=>`${views} vues le mois dernier`,
    hi: (views)=>`\u{92A}\u{93F}\u{91B}\u{932}\u{947} \u{92E}\u{939}\u{940}\u{928}\u{947} \u{92E}\u{947}\u{902} ${views} \u{92C}\u{93E}\u{930} \u{926}\u{947}\u{916}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: (views)=>`${views} opinyon nan mwa ki sot pase yo`,
    it: (views)=>`${views} visualizzazioni nell'ultimo mese`,
    ja: (views)=>`\u{904E}\u{53BB}1\u{304B}\u{6708}\u{3067}${views}\u{56DE}\u{306E}\u{95B2}\u{89A7}`,
    ko: (views)=>`\u{C9C0}\u{B09C} \u{D55C} \u{B2EC}\u{AC04} ${views}\u{D68C} \u{C870}\u{D68C}\u{C218}`,
    mww: (views)=>`${views} views nyob rau hauv lub hli dhau los`,
    ps: (views)=>`\u{67E}\u{647} \u{62A}\u{6D0}\u{631}\u{648} \u{645}\u{6CC}\u{627}\u{634}\u{62A}\u{648} ${views} \u{644}\u{6CC}\u{62F}\u{646}\u{6D0}`,
    pt: (views)=>`${views} visualiza\xe7\xf5es no \xfaltimo m\xeas`,
    'pt-pt': (views)=>`${views} visualiza\xe7\xf5es no \xfaltimo m\xeas`,
    ru: (views)=>`${views} \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{43E}\u{432} \u{437}\u{430} \u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{438}\u{439} \u{43C}\u{435}\u{441}\u{44F}\u{446}`,
    sm: (views)=>`${views} manatu i le masina talu ai`,
    so: (views)=>`${views} daawasho bishii la soo dhaafay`,
    th: (views)=>`${views} \u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E43}\u{E19}\u{E40}\u{E14}\u{E37}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E21}\u{E32}`,
    ur: (views)=>`\u{6AF}\u{632}\u{634}\u{62A}\u{6C1} \u{645}\u{6C1}\u{6CC}\u{646}\u{6D2} ${views} \u{648}\u{6CC}\u{648}\u{632}`,
    vi: (views)=>`${views} l\u{1B0}\u{1EE3}t xem trong th\xe1ng qua`,
    'zh-hans': (views)=>`\u{8FC7}\u{53BB}\u{4E00}\u{4E2A}\u{6708} ${views} \u{6B21}\u{6D4F}\u{89C8}`,
    'zh-hant': (views)=>`\u{904E}\u{53BB}\u{4E00}\u{500B}\u{6708}\u{6709}${views}\u{6B21}\u{89C0}\u{770B}`,
    en: (views)=>`${views} views in past month`
};
const $b11db1b62d4a8f76$export$e0d850e87f99a16d = {
    ar: `\u{639}\u{631}\u{636} \u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{632}\u{645}\u{646}`,
    de: `Stundenzettel anzeigen`,
    es: `Ver hoja de horas`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646}`,
    fil: `Tingnan ang timesheet`,
    fr: `Voir la feuille de temps`,
    hi: `\u{91F}\u{93E}\u{907}\u{92E}\u{936}\u{940}\u{91F} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `View Timesheet`,
    it: `Visualizza il foglio orario`,
    ja: `\u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}\u{3092}\u{898B}\u{308B}`,
    ko: `\u{D0C0}\u{C784}\u{C2DC}\u{D2B8} \u{BCF4}\u{AE30}`,
    mww: `Saib daim ntawv qhia sijhawm`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647} \u{648}\u{6AB}\u{648}\u{631}\u{626}`,
    pt: `Ver folha de ponto`,
    'pt-pt': `Ver folha de horas`,
    ru: `\u{41F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44F} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}`,
    sm: `Tagai i le pepa o taimi`,
    so: `Eeg jadwalka waqtiga`,
    th: `\u{E14}\u{E39}\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17}`,
    ur: `\u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Xem b\u{1EA3}ng ch\u{1EA5}m c\xf4ng`,
    'zh-hans': `\u{67E5}\u{770B}\u{65F6}\u{95F4}\u{8868}`,
    'zh-hant': `\u{67E5}\u{770B}\u{6642}\u{9593}\u{8868}`,
    en: `View timesheet`
};
const $b11db1b62d4a8f76$export$bfe8832eac2e8a0 = {
    ar: `\u{627}\u{644}\u{641}\u{631}\u{627}\u{63A}`,
    de: `Leere`,
    es: `Vac\xedo`,
    fa: `\u{62E}\u{644}\u{623}`,
    fil: `Walang bisa`,
    fr: `Void`,
    hi: `\u{936}\u{942}\u{928}\u{94D}\u{92F}`,
    ht: `vid`,
    it: `Void`,
    ja: `\u{865A}\u{7121}`,
    ko: `\u{ACF5}\u{D5C8}`,
    mww: `tsis muaj dab tsi`,
    ps: `\u{62A}\u{634}\u{647}`,
    pt: `Void`,
    'pt-pt': `Vazio`,
    ru: `\u{41F}\u{443}\u{441}\u{442}\u{43E}\u{442}\u{430}`,
    sm: `Gaogao`,
    so: `Void`,
    th: `\u{E42}\u{E21}\u{E06}\u{E30}`,
    ur: `\u{62E}\u{644}\u{627}`,
    vi: `H\u{1B0} kh\xf4ng`,
    'zh-hans': `\u{865A}\u{7A7A}`,
    'zh-hant': `\u{865B}\u{7121}`,
    en: `Void`
};
const $b11db1b62d4a8f76$export$fa18327b186629ef = {
    ar: `\u{637}\u{644}\u{628} \u{62A}\u{648}\u{642}\u{64A}\u{639} \u{627}\u{644}\u{641}\u{631}\u{627}\u{63A}`,
    de: `Nichtigkeitsanfrage`,
    es: `Solicitud de firma nula`,
    fa: `\u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{628}\u{627}\u{637}\u{644}`,
    fil: `Kahilingan sa lagda na walang bisa`,
    fr: `Demande de signature nulle`,
    hi: `\u{936}\u{942}\u{928}\u{94D}\u{92F} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927}`,
    ht: `Anile demann siyati`,
    it: `Richiesta di firma nulla`,
    ja: `\u{7121}\u{52B9}\u{7F72}\u{540D}\u{8981}\u{6C42}`,
    ko: `\u{BB34}\u{D6A8} \u{C11C}\u{BA85} \u{C694}\u{CCAD}`,
    mww: `Thov kos npe tsis muaj dab tsi`,
    ps: `\u{62F} \u{62E}\u{627}\u{644}\u{6CC} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{647}`,
    pt: `Solicita\xe7\xe3o de assinatura nula`,
    'pt-pt': `Pedido de assinatura nula`,
    ru: `\u{417}\u{430}\u{43F}\u{440}\u{43E}\u{441} \u{43D}\u{430} \u{430}\u{43D}\u{43D}\u{443}\u{43B}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{443}\u{44E} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Talosaga faaleaogaina o le saini`,
    so: `Codsiga saxiixa void`,
    th: `\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E04}\u{E4D}\u{E32}\u{E02}\u{E2D}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `\u{62E}\u{627}\u{644}\u{6CC} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}`,
    vi: `Y\xeau c\u{1EA7}u ch\u{1EEF} k\xfd v\xf4 hi\u{1EC7}u`,
    'zh-hans': `\u{65E0}\u{6548}\u{7B7E}\u{540D}\u{8BF7}\u{6C42}`,
    'zh-hant': `\u{7121}\u{6548}\u{7C3D}\u{540D}\u{8ACB}\u{6C42}`,
    en: `Void signature request`
};
const $b11db1b62d4a8f76$export$871dc4d84bb2dabd = {
    ar: `\u{647}\u{644} \u{623}\u{646}\u{62A} \u{645}\u{62A}\u{623}\u{643}\u{62F} \u{623}\u{646}\u{643} \u{62A}\u{631}\u{64A}\u{62F} \u{625}\u{644}\u{63A}\u{627}\u{621} \u{637}\u{644}\u{628} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639} \u{647}\u{630}\u{627}\u{61F} \u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{627}\u{644}\u{62A}\u{631}\u{627}\u{62C}\u{639} \u{639}\u{646} \u{647}\u{630}\u{627} \u{627}\u{644}\u{641}\u{639}\u{644}.`,
    de: `Bist du sicher, dass du diese Unterschriftsanfrage f\xfcr ung\xfcltig machen willst? Diese Ma\xdfnahme kann nicht r\xfcckg\xe4ngig gemacht werden.`,
    es: `\xbfEst\xe1s seguro de que quieres anular esta solicitud de firma? Esta acci\xf3n no puede deshacerse.`,
    fa: `\u{645}\u{637}\u{645}\u{626}\u{646}\u{6CC} \u{645}\u{6CC} \u{62E}\u{648}\u{627}\u{647}\u{6CC} \u{627}\u{6CC}\u{646} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{627}\u{645}\u{636}\u{627} \u{631}\u{627} \u{628}\u{627}\u{637}\u{644} \u{6A9}\u{646}\u{6CC}\u{61F} \u{627}\u{6CC}\u{646} \u{639}\u{645}\u{644} \u{642}\u{627}\u{628}\u{644} \u{628}\u{627}\u{632}\u{6AF}\u{634}\u{62A} \u{646}\u{6CC}\u{633}\u{62A}.`,
    fil: `Sigurado ka bang nais mong ipawalang-bisa ang kahilingan sa lagda na ito? Ang pagkilos na ito ay hindi maaaring ipagwalang-bahala.`,
    fr: `\xcates-vous s\xfbr de vouloir annuler cette demande de signature ? Cette action ne peut \xeatre annul\xe9e.`,
    hi: `\u{915}\u{94D}\u{92F}\u{93E} \u{906}\u{92A} \u{935}\u{93E}\u{915}\u{908} \u{907}\u{938} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927} \u{915}\u{94B} \u{930}\u{926}\u{94D}\u{926} \u{915}\u{930}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{924}\u{947} \u{939}\u{948}\u{902}? \u{907}\u{938} \u{915}\u{94D}\u{930}\u{93F}\u{92F}\u{93E} \u{915}\u{94B} \u{92A}\u{942}\u{930}\u{94D}\u{935}\u{935}\u{924} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E}.`,
    ht: `\xc8ske ou s\xe8ten ou vle anile demann siyati sa a? Aksyon sa a pa ka def\xe8t.`,
    it: `Sei sicuro di voler annullare questa richiesta di firma? Questa azione non pu\xf2 essere annullata.`,
    ja: `\u{3053}\u{306E}\u{7F72}\u{540D}\u{4F9D}\u{983C}\u{3092}\u{53D6}\u{308A}\u{6D88}\u{3057}\u{305F}\u{3044}\u{306E}\u{304B}?\u{3053}\u{306E}\u{884C}\u{52D5}\u{306F}\u{53D6}\u{308A}\u{6D88}\u{305B}\u{306A}\u{3044}\u{3002}`,
    ko: `\u{C774} \u{C11C}\u{BA85} \u{C694}\u{CCAD}\u{C744} \u{BB34}\u{D6A8}\u{B85C} \u{D558}\u{ACE0} \u{C2F6}\u{C740} \u{AC8C} \u{D655}\u{C2E4}\u{D55C}\u{AC00}\u{C694}? \u{C774} \u{D589}\u{B3D9}\u{C740} \u{B418}\u{B3CC}\u{B9B4} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Koj puas paub tseeb tias koj xav tshem tawm qhov kev thov kos npe no? Qhov kev ua no tsis tuaj yeem thim rov qab.`,
    ps: `\u{62A}\u{647} \u{689}\u{627}\u{689}\u{647} \u{6CC}\u{6D0} \u{686}\u{6D0} \u{63A}\u{648}\u{627}\u{693}\u{6D0} \u{62F}\u{627} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{647} \u{644}\u{63A}\u{648}\u{647} \u{6A9}\u{693}\u{6D0}\u{61F} \u{62F}\u{627} \u{639}\u{645}\u{644} \u{628}\u{6CC}\u{631}\u{62A}\u{647} \u{646}\u{647} \u{634}\u{6CC} \u{628}\u{62F}\u{644}\u{6CC}\u{62F}\u{644}\u{6CC}.`,
    pt: `Tem certeza de que quer anular esse pedido de assinatura? Essa a\xe7\xe3o n\xe3o pode ser desfeita.`,
    'pt-pt': `Tem a certeza de que quer anular este pedido de assinatura? Esta a\xe7\xe3o n\xe3o pode ser desfeita.`,
    ru: `\u{412}\u{44B} \u{443}\u{432}\u{435}\u{440}\u{435}\u{43D}\u{44B}, \u{447}\u{442}\u{43E} \u{445}\u{43E}\u{442}\u{438}\u{442}\u{435} \u{430}\u{43D}\u{43D}\u{443}\u{43B}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{44D}\u{442}\u{43E}\u{442} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441} \u{43D}\u{430} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}? \u{42D}\u{442}\u{43E} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435} \u{43D}\u{435}\u{43B}\u{44C}\u{437}\u{44F} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C}.`,
    sm: `E te mautinoa e te manao e faaleaogaina lenei talosaga mo le saini? O lenei faatinoga e le mafai ona toe faaleaogaina.`,
    so: `Ma hubtaa inaad rabto inaad baabi'iso codsigan saxiixa? Ficilkan lama joojin karo.`,
    th: `\u{E04}\u{E38}\u{E13}\u{E41}\u{E19}\u{E48}\u{E43}\u{E08}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E44}\u{E21}\u{E48}\u{E27}\u{E48}\u{E32}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E04}\u{E4D}\u{E32}\u{E02}\u{E2D}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E19}\u{E35}\u{E49}? \u{E01}\u{E32}\u{E23}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E19}\u{E35}\u{E49}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{6A9}\u{6CC}\u{627} \u{622}\u{67E} \u{648}\u{627}\u{642}\u{639}\u{6CC} \u{627}\u{633} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{645}\u{646}\u{633}\u{648}\u{62E} \u{6A9}\u{631}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{61F} \u{6CC}\u{6C1} \u{639}\u{645}\u{644} \u{648}\u{627}\u{67E}\u{633} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{644}\u{6CC}\u{627} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{627}\u{6D4}`,
    vi: `B\u{1EA1}n c\xf3 ch\u{1EAF}c ch\u{1EAF}n mu\u{1ED1}n v\xf4 hi\u{1EC7}u h\xf3a y\xeau c\u{1EA7}u ch\u{1EEF} k\xfd n\xe0y kh\xf4ng? H\xe0nh \u{111}\u{1ED9}ng n\xe0y kh\xf4ng th\u{1EC3} ho\xe0n t\xe1c.`,
    'zh-hans': `\u{4F60}\u{786E}\u{5B9A}\u{8981}\u{53D6}\u{6D88}\u{8FD9}\u{6B21}\u{7B7E}\u{540D}\u{8BF7}\u{6C42}\u{5417}\u{FF1F}\u{8FD9}\u{4E00}\u{884C}\u{4E3A}\u{65E0}\u{6CD5}\u{64A4}\u{9500}\u{3002}`,
    'zh-hant': `\u{4F60}\u{78BA}\u{5B9A}\u{8981}\u{53D6}\u{6D88}\u{9019}\u{500B}\u{7C3D}\u{540D}\u{8ACB}\u{6C42}\u{55CE}\u{FF1F}\u{9019}\u{7A2E}\u{884C}\u{70BA}\u{7121}\u{6CD5}\u{64A4}\u{92B7}\u{3002}`,
    en: `Are you sure you want to void this signature request? This action cannot be undone.`
};
const $b11db1b62d4a8f76$export$4056dbe56ca22d08 = {
    ar: `\u{62A}\u{645} \u{62A}\u{643}\u{644}\u{64A}\u{641} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Diese T\xe4tigkeit wurde mir zugewiesen.`,
    es: `Se me asign\xf3 esta actividad.`,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{647} \u{645}\u{646} \u{645}\u{62D}\u{648}\u{644} \u{634}\u{62F}.`,
    fil: `Inatasan siya sa aktibidad na ito.`,
    fr: `Cette activit\xe9 m\u{2019}a \xe9t\xe9 assign\xe9e.`,
    hi: `\u{92F}\u{939} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{938}\u{94C}\u{902}\u{92A}\u{940} \u{917}\u{908} \u{925}\u{940}\u{964}`,
    ht: `Yo te asiyen aktivite sa a.`,
    it: `Mi \xe8 stata assegnata questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{3092}\u{5272}\u{308A}\u{5F53}\u{3066}\u{3089}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C774} \u{BC30}\u{C815}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tau muab rau qhov kev ua no.`,
    ps: `\u{645}\u{627} \u{62A}\u{647} \u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{648}.`,
    pt: `Foi designado para essa atividade.`,
    'pt-pt': `Fui atribu\xedda a esta atividade.`,
    ru: `\u{41C}\u{43D}\u{435} \u{43F}\u{43E}\u{440}\u{443}\u{447}\u{438}\u{43B}\u{438} \u{44D}\u{442}\u{443} \u{437}\u{430}\u{434}\u{430}\u{447}\u{443}.`,
    sm: `Sa tofia i ai lenei gaoioiga.`,
    so: `Waxaa loo xilsaaray hawshan.`,
    th: `\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E17}\u{E4D}\u{E32}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{645}\u{62C}\u{6BE}\u{6D2} \u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{633}\u{648}\u{646}\u{67E}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{62A}\u{6BE}\u{6CC}\u{6D4}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c giao ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{88AB}\u{5206}\u{914D}\u{4E86}\u{8FD9}\u{9879}\u{6D3B}\u{52A8}\u{3002}`,
    'zh-hant': `\u{88AB}\u{5206}\u{914D}\u{4E86}\u{9019}\u{9805}\u{6D3B}\u{52D5}\u{3002}`,
    en: `Was assigned this activity.`
};
const $b11db1b62d4a8f76$export$3143c2b51f566b5 = {
    ar: `\u{643}\u{627}\u{646} \u{645}\u{631}\u{62A}\u{628}\u{637}\u{627} \u{628}\u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{639}\u{628}\u{631} \u{627}\u{644}\u{623}\u{62A}\u{645}\u{62A}\u{629}.`,
    de: `War mit dieser Aktivit\xe4t durch Automatisierung verbunden.`,
    es: `Estaba asociado a esta actividad mediante automatizaci\xf3n.`,
    fa: `\u{628}\u{627} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{627}\u{62A}\u{648}\u{645}\u{627}\u{633}\u{6CC}\u{648}\u{646} \u{645}\u{631}\u{62A}\u{628}\u{637} \u{628}\u{648}\u{62F}.`,
    fil: `Ito ay nauugnay sa aktibidad na ito sa pamamagitan ng automation.`,
    fr: `\xc9tait associ\xe9 \xe0 cette activit\xe9 via l\u{2019}automatisation.`,
    hi: `\u{938}\u{94D}\u{935}\u{91A}\u{93E}\u{932}\u{928} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{938}\u{947} \u{91C}\u{941}\u{921}\u{93C}\u{93E} \u{925}\u{93E}\u{964}`,
    ht: `Te asosye ak aktivite sa a atrav\xe8 automatisation.`,
    it: `Era associata a questa attivit\xe0 tramite automazione.`,
    ja: `\u{81EA}\u{52D5}\u{5316}\u{3092}\u{901A}\u{3058}\u{3066}\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306B}\u{95A2}\u{308F}\u{308A}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C790}\u{B3D9}\u{D654}\u{B97C} \u{D1B5}\u{D574} \u{C774} \u{D65C}\u{B3D9}\u{ACFC} \u{C5F0}\u{AD00}\u{B418}\u{C5B4} \u{C788}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tau txuam nrog qhov kev ua no los ntawm automation.`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{633}\u{631}\u{647} \u{62F} \u{627}\u{62A}\u{648}\u{645}\u{627}\u{62A} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{62A}\u{693}\u{627}\u{648} \u{62F}\u{631}\u{644}\u{648}\u{62F}.`,
    pt: `Estava associada a essa atividade por meio de automa\xe7\xe3o.`,
    'pt-pt': `Estava associada a esta atividade atrav\xe9s da automa\xe7\xe3o.`,
    ru: `\u{411}\u{44B}\u{43B} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D} \u{441} \u{44D}\u{442}\u{43E}\u{439} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{44E} \u{447}\u{435}\u{440}\u{435}\u{437} \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44E}.`,
    sm: `Na feso'ota'i ma lenei gaioiga e ala i le otometi.`,
    so: `Waxay la xiriirtay hawshan iyada oo loo marayo otomaatiga.`,
    th: `\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E23}\u{E30}\u{E1A}\u{E1A}\u{E2D}\u{E31}\u{E15}\u{E42}\u{E19}\u{E21}\u{E31}\u{E15}\u{E34}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{633}\u{6D2} \u{622}\u{679}\u{648}\u{645}\u{6CC}\u{634}\u{646} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{645}\u{646}\u{633}\u{644}\u{6A9} \u{62A}\u{6BE}\u{627}\u{6D4}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c li\xean k\u{1EBF}t v\u{1EDB}i ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y th\xf4ng qua t\u{1EF1} \u{111}\u{1ED9}ng h\xf3a.`,
    'zh-hans': `\u{6211}\u{901A}\u{8FC7}\u{81EA}\u{52A8}\u{5316}\u{53C2}\u{4E0E}\u{4E86}\u{8FD9}\u{9879}\u{6D3B}\u{52A8}\u{3002}`,
    'zh-hant': `\u{6211}\u{662F}\u{900F}\u{904E}\u{81EA}\u{52D5}\u{5316}\u{8207}\u{9019}\u{9805}\u{6D3B}\u{52D5}\u{7522}\u{751F}\u{95DC}\u{806F}\u{7684}\u{3002}`,
    en: `Was associated with this activity via automation.`
};
const $b11db1b62d4a8f76$export$5aac962701afc155 = {
    ar: `\u{62A}\u{645} \u{630}\u{643}\u{631}\u{647} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Wurde in dieser Aktivit\xe4t erw\xe4hnt.`,
    es: `Se mencion\xf3 en esta actividad.`,
    fa: `\u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{630}\u{6A9}\u{631} \u{634}\u{62F}\u{647} \u{628}\u{648}\u{62F}.`,
    fil: `Binanggit ito sa aktibidad na ito.`,
    fr: `A \xe9t\xe9 mentionn\xe9 dans cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92E}\u{947}\u{902} \u{909}\u{932}\u{94D}\u{932}\u{947}\u{916} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E}\u{964}`,
    ht: `Te mansyone nan aktivite sa a.`,
    it: `\xc8 stato menzionato in questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{3067}\u{8A00}\u{53CA}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0}\u{C11C} \u{C5B8}\u{AE09}\u{B41C} \u{C801}\u{C774} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tau hais nyob rau hauv qhov kev ua no.`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D0} \u{6CC}\u{627}\u{62F} \u{634}\u{648}\u{6CC} \u{648}.`,
    pt: `Foi mencionado nesta atividade.`,
    'pt-pt': `Foi mencionado nesta atividade.`,
    ru: `\u{411}\u{44B}\u{43B} \u{443}\u{43F}\u{43E}\u{43C}\u{44F}\u{43D}\u{443}\u{442} \u{432} \u{44D}\u{442}\u{43E}\u{43C} \u{437}\u{430}\u{434}\u{430}\u{43D}\u{438}\u{438}.`,
    sm: `Sa ta'ua i lenei gaoioiga.`,
    so: `Waxaa lagu xusay hawshan.`,
    th: `\u{E16}\u{E39}\u{E01}\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}\u{E43}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{630}\u{6A9}\u{631} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{62A}\u{6BE}\u{627}\u{6D4}`,
    vi: `\u{110}\xe3 \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EC1} c\u{1EAD}p trong ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    'zh-hans': `\u{5728}\u{8FD9}\u{4E2A}\u{6D3B}\u{52A8}\u{4E2D}\u{63D0}\u{5230}\u{4E86}\u{3002}`,
    'zh-hant': `\u{5728}\u{9019}\u{500B}\u{6D3B}\u{52D5}\u{4E2D}\u{88AB}\u{63D0}\u{53CA}\u{3002}`,
    en: `Was mentioned in this activity.`
};
const $b11db1b62d4a8f76$export$9502146eb1d5b0ff = {
    ar: `\u{643}\u{646}\u{62A} \u{645}\u{634}\u{62A}\u{631}\u{643}\u{627} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{639}\u{628}\u{631} \u{627}\u{644}\u{623}\u{62A}\u{645}\u{62A}\u{629}.`,
    de: `Ich habe diese Aktivit\xe4t \xfcber Automatisierung abonniert.`,
    es: `Estaba suscrito a esta actividad mediante automatizaci\xf3n.`,
    fa: `\u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{627}\u{62A}\u{648}\u{645}\u{627}\u{633}\u{6CC}\u{648}\u{646} \u{645}\u{634}\u{62A}\u{631}\u{6A9} \u{634}\u{62F}\u{645}.`,
    fil: `Nag-subscribe sa aktibidad na ito sa pamamagitan ng automation.`,
    fr: `J\u{2019}\xe9tais abonn\xe9 \xe0 cette activit\xe9 via l\u{2019}automatisation.`,
    hi: `\u{938}\u{94D}\u{935}\u{91A}\u{93E}\u{932}\u{928} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{940} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{932}\u{940} \u{917}\u{908} \u{925}\u{940}\u{964}`,
    ht: `Te ab\xf2nman nan aktivite sa a atrav\xe8 automatisation.`,
    it: `Ero iscritto a questa attivit\xe0 tramite automazione.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306F}\u{81EA}\u{52D5}\u{5316}\u{306B}\u{3088}\u{3063}\u{3066}\u{767B}\u{9332}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C790}\u{B3D9}\u{D654}\u{B97C} \u{D1B5}\u{D574} \u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{AC00}\u{C785}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tau sau npe rau qhov kev ua no los ntawm automation.`,
    ps: `\u{645}\u{627} \u{62F} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62F} \u{627}\u{62A}\u{648}\u{645}\u{627}\u{62A} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{6AB}\u{689}\u{648}\u{646} \u{6A9}\u{693}\u{6CC} \u{648}.`,
    pt: `Estava assinado nessa atividade via automa\xe7\xe3o.`,
    'pt-pt': `Estava subscrito a esta atividade atrav\xe9s de automa\xe7\xe3o.`,
    ru: `\u{41F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43B}\u{441}\u{44F} \u{43D}\u{430} \u{44D}\u{442}\u{443} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{447}\u{435}\u{440}\u{435}\u{437} \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44E}.`,
    sm: `Sa lesitala i lenei gaoioiga e ala i le otometi.`,
    so: `Waxaan ku biiray hawshan iyada oo loo marayo otomaatiga.`,
    th: `\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E23}\u{E30}\u{E1A}\u{E1A}\u{E2D}\u{E31}\u{E15}\u{E42}\u{E19}\u{E21}\u{E31}\u{E15}\u{E34}`,
    ur: `\u{645}\u{6CC}\u{6BA} \u{646}\u{6D2} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{648} \u{622}\u{679}\u{648}\u{645}\u{6CC}\u{634}\u{646} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{6A9}\u{6CC}\u{627} \u{62A}\u{6BE}\u{627}\u{6D4}`,
    vi: `\u{110}\xe3 \u{111}\u{103}ng k\xfd ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y th\xf4ng qua t\u{1EF1} \u{111}\u{1ED9}ng h\xf3a.`,
    'zh-hans': `\u{6211}\u{901A}\u{8FC7}\u{81EA}\u{52A8}\u{5316}\u{8BA2}\u{9605}\u{4E86}\u{8FD9}\u{9879}\u{6D3B}\u{52A8}\u{3002}`,
    'zh-hant': `\u{6211}\u{662F}\u{900F}\u{904E}\u{81EA}\u{52D5}\u{5316}\u{8A02}\u{95B1}\u{9019}\u{500B}\u{6D3B}\u{52D5}\u{7684}\u{3002}`,
    en: `Was subscribed to this activity via automation.`
};
const $b11db1b62d4a8f76$export$fc2792c346de2443 = {
    ar: (name)=>`\u{645}\u{631}\u{62D}\u{628}\u{627} \u{628}\u{643} ${name}`,
    de: (name)=>`Willkommen, ${name}`,
    es: (name)=>`Bienvenido, ${name}`,
    fa: (name)=>`\u{62E}\u{648}\u{634} \u{622}\u{645}\u{62F}\u{6CC}\u{60C} ${name}`,
    fil: (name)=>`Maligayang pagdating, ${name}`,
    fr: (name)=>`Bienvenue, ${name}`,
    hi: (name)=>`\u{906}\u{92A}\u{915}\u{93E} \u{938}\u{94D}\u{935}\u{93E}\u{917}\u{924} \u{939}\u{948}, ${name}`,
    ht: (name)=>`Byenveni ${name}`,
    it: (name)=>`Benvenuto, ${name}`,
    ja: (name)=>`\u{3088}\u{3046}\u{3053}\u{305D}\u{3001} ${name}`,
    ko: (name)=>`\u{D658}\u{C601}\u{D574}, ${name}`,
    mww: (name)=>`Zoo siab txais tos, ${name}`,
    ps: (name)=>`\u{69A}\u{647} \u{631}\u{627}\u{63A}\u{644}\u{627}\u{633}\u{62A}\u{60C} ${name}`,
    pt: (name)=>`Bem-vindo, ${name}`,
    'pt-pt': (name)=>`Bem-vindo, ${name}`,
    ru: (name)=>`\u{414}\u{43E}\u{431}\u{440}\u{43E} \u{43F}\u{43E}\u{436}\u{430}\u{43B}\u{43E}\u{432}\u{430}\u{442}\u{44C}, ${name}`,
    sm: (name)=>`Fa'afeiloa'i, ${name}`,
    so: (name)=>`Soo dhawoow, ${name}`,
    th: (name)=>`\u{E22}\u{E34}\u{E19}\u{E14}\u{E35}\u{E15}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E31}\u{E1A} ${name}`,
    ur: (name)=>`\u{62E}\u{648}\u{634} \u{622}\u{645}\u{62F}\u{6CC}\u{62F}\u{60C} ${name}`,
    vi: (name)=>`Ch\xe0o m\u{1EEB}ng, ${name}`,
    'zh-hans': (name)=>`\u{6B22}\u{8FCE}\u{4F60}\u{FF0C} ${name}`,
    'zh-hant': (name)=>`\u{6B61}\u{8FCE}\u{4F60}\u{FF0C} ${name}`,
    en: (name)=>`Welcome, ${name}`
};
const $b11db1b62d4a8f76$export$2bb227975174080a = {
    ar: `\u{62D}\u{628}\u{631} \u{631}\u{637}\u{628}`,
    de: `Nass-Tinte`,
    es: `Tinta h\xfameda`,
    fa: `\u{62C}\u{648}\u{647}\u{631} \u{62E}\u{6CC}\u{633}`,
    fil: `Basang tinta`,
    fr: `Encre humide`,
    hi: `\u{917}\u{940}\u{932}\u{940} \u{938}\u{94D}\u{92F}\u{93E}\u{939}\u{940}`,
    ht: `Lank mouye`,
    it: `Inchiostro umido`,
    ja: `\u{6FE1}\u{308C}\u{305F}\u{30A4}\u{30F3}\u{30AF}`,
    ko: `\u{C816}\u{C740} \u{C789}\u{D06C}`,
    mww: `number case ntub dej`,
    ps: `\u{644}\u{648}\u{646}\u{62F} \u{631}\u{646}\u{6AB}`,
    pt: `Tinta \xfamida`,
    'pt-pt': `Tinta h\xfamida`,
    ru: `\u{412}\u{43B}\u{430}\u{436}\u{43D}\u{44B}\u{435} \u{447}\u{435}\u{440}\u{43D}\u{438}\u{43B}\u{430}`,
    sm: `Vaitusi susu`,
    so: `Khad qoyan`,
    th: `\u{E2B}\u{E21}\u{E36}\u{E01}\u{E40}\u{E1B}\u{E35}\u{E22}\u{E01}`,
    ur: `\u{6AF}\u{6CC}\u{644}\u{627} \u{633}\u{6CC}\u{627}\u{6C1}\u{6CC}`,
    vi: `M\u{1EF1}c \u{1B0}\u{1EDB}t`,
    'zh-hans': `\u{6E7F}\u{58A8}\u{6C34}`,
    'zh-hant': `\u{6FD5}\u{58A8}\u{6C34}`,
    en: `Wet ink`
};
const $b11db1b62d4a8f76$export$13fb84c97e52f39c = {
    ar: (href)=>$b11db1b62d4a8f76$var$html`قمنا بتحديث <a href="${href}">شروط الاستخدام</a> الخاصة بنا.`,
    de: (href)=>$b11db1b62d4a8f76$var$html`Wir haben unsere <a href="${href}">Nutzungsbedingungen</a> aktualisiert.`,
    es: (href)=>$b11db1b62d4a8f76$var$html`Hemos actualizado nuestros <a href="${href}">Términos de Uso</a>.`,
    fa: (href)=>$b11db1b62d4a8f76$var$html`<a href="${href}">ما شرایط استفاده</a> خود را به روزرسانی کرده ایم.`,
    fil: (href)=>$b11db1b62d4a8f76$var$html`Na-update namin ang aming <a href="${href}">Mga Tuntunin sa Paggamit</a>.`,
    fr: (href)=>$b11db1b62d4a8f76$var$html`Nous avons mis à jour nos <a href="${href}">Conditions d’utilisation</a>.`,
    hi: (href)=>$b11db1b62d4a8f76$var$html`हमने अपनी <a href="${href}">उपयोग की शर्तों</a> को अपडेट कर दिया है।`,
    ht: (href)=>$b11db1b62d4a8f76$var$html`Nou te mete ajou <a href="${href}">Regleman pou Itilizasyon</a> nou an.`,
    it: (href)=>$b11db1b62d4a8f76$var$html`Abbiamo aggiornato i <a href="${href}">nostri Termini di Utilizzo</a>.`,
    ja: (href)=>$b11db1b62d4a8f76$var$html`<a href="${href}">利用規約</a>を更新しました。`,
    ko: (href)=>$b11db1b62d4a8f76$var$html`이용 <a href="${href}">약관</a>을 업데이트했습니다.`,
    mww: (href)=>$b11db1b62d4a8f76$var$html`Peb tau hloov kho peb <a href="${href}">Cov Lus Cog Tseg ntawm Kev Siv</a>.`,
    ps: (href)=>$b11db1b62d4a8f76$var$html`موږ د <a href="${href}">کارونې شرایط</a> تازه کړی دی.`,
    pt: (href)=>$b11db1b62d4a8f76$var$html`Atualizamos nossos <a href="${href}">Termos de Uso</a>.`,
    'pt-pt': (href)=>$b11db1b62d4a8f76$var$html`Atualizámos os nossos <a href="${href}">Termos de Utilização</a>.`,
    ru: (href)=>$b11db1b62d4a8f76$var$html`Мы обновили наши <a href="${href}">Условия использования</a>.`,
    sm: (href)=>$b11db1b62d4a8f76$var$html`Ua matou fa'afouina a matou <a href="${href}">tuutuuga o fa'aaogaina</a>.`,
    so: (href)=>$b11db1b62d4a8f76$var$html`Waxaan cusbooneysiinnay <a href="${href}">Shuruudaha Isticmaalka</a>.`,
    th: (href)=>$b11db1b62d4a8f76$var$html`เราได้ปรับปรุง <a href="${href}">ข้อกําหนดการใช้งาน</a>ของเราแล้ว`,
    ur: (href)=>$b11db1b62d4a8f76$var$html`ہم نے <a href="${href}">اپنی شرائط استعمال</a> کو اپ ڈیٹ کیا ہے۔`,
    vi: (href)=>$b11db1b62d4a8f76$var$html`Chúng tôi đã cập nhật <a href="${href}">Điều khoản sử dụng</a> của mình.`,
    'zh-hans': (href)=>$b11db1b62d4a8f76$var$html`我们已更新使用 <a href="${href}">条款</a>。`,
    'zh-hant': (href)=>$b11db1b62d4a8f76$var$html`我們已更新使用 <a href="${href}">條款</a>。`,
    en: (href)=>$b11db1b62d4a8f76$var$html`We've updated our <a href="${href}">Terms of Use</a>.`
};
const $b11db1b62d4a8f76$export$1ed86efeb5e4ad45 = {
    ar: `\u{628}\u{645}\u{627}\u{630}\u{627} \u{64A}\u{645}\u{643}\u{646}\u{646}\u{64A} \u{627}\u{644}\u{645}\u{633}\u{627}\u{639}\u{62F}\u{629}\u{61F}`,
    de: `Womit kann ich helfen?`,
    es: `\xbfEn qu\xe9 puedo ayudar?`,
    fa: `\u{686}\u{637}\u{648}\u{631} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{645} \u{6A9}\u{645}\u{6A9} \u{6A9}\u{646}\u{645}\u{61F}`,
    fil: `Ano ang maaari kong makatulong?`,
    fr: `Que puis-je faire ?`,
    hi: `\u{92E}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{93E} \u{92E}\u{926}\u{926} \u{915}\u{930} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{942}\u{902}?`,
    ht: `Ak kisa mwen ka ede?`,
    it: `In cosa posso aiutare?`,
    ja: `\u{4F55}\u{304B}\u{304A}\u{624B}\u{4F1D}\u{3044}\u{3067}\u{304D}\u{308B}\u{3053}\u{3068}\u{306F}\u{3042}\u{308A}\u{307E}\u{3059}\u{304B}?`,
    ko: `\u{BB34}\u{C5C7}\u{C744} \u{B3C4}\u{C640}\u{B4DC}\u{B9B4}\u{AE4C}\u{C694}?`,
    mww: `Kuv tuaj yeem pab dab tsi?`,
    ps: `\u{632}\u{647} \u{685}\u{647} \u{645}\u{631}\u{633}\u{62A}\u{647} \u{6A9}\u{648}\u{644}\u{6CC} \u{634}\u{645}\u{61F}`,
    pt: `Com o que posso ajudar?`,
    'pt-pt': `Em que posso ajudar?`,
    ru: `\u{427}\u{435}\u{43C} \u{43C}\u{43E}\u{433}\u{443} \u{43F}\u{43E}\u{43C}\u{43E}\u{447}\u{44C}?`,
    sm: `O le a se mea e mafai ona ou fesoasoani i ai?`,
    so: `Maxaan kaa caawin karaa?`,
    th: `\u{E09}\u{E31}\u{E19}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E0A}\u{E48}\u{E27}\u{E22}\u{E2D}\u{E30}\u{E44}\u{E23}\u{E44}\u{E14}\u{E49}\u{E1A}\u{E49}\u{E32}\u{E07}?`,
    ur: `\u{645}\u{6CC}\u{6BA} \u{6A9}\u{633} \u{686}\u{6CC}\u{632} \u{645}\u{6CC}\u{6BA} \u{645}\u{62F}\u{62F} \u{6A9}\u{631} \u{633}\u{6A9}\u{62A}\u{627} \u{6C1}\u{648}\u{6BA}\u{61F}`,
    vi: `T\xf4i c\xf3 th\u{1EC3} gi\xfap g\xec?`,
    'zh-hans': `\u{6211}\u{80FD}\u{5E2E}\u{4E0A}\u{4EC0}\u{4E48}\u{5FD9}\u{FF1F}`,
    'zh-hant': `\u{6211}\u{80FD}\u{5E6B}\u{5FD9}\u{4EC0}\u{9EBC}\u{FF1F}`,
    en: `What can I help with?`
};
const $b11db1b62d4a8f76$export$520aff1ed9508ef9 = {
    ar: `\u{639}\u{646}\u{62F}\u{645}\u{627}`,
    de: `Wenn`,
    es: `Cuando`,
    fa: `\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647}`,
    fil: `Kapag`,
    fr: `Quand`,
    hi: `\u{915}\u{92C}`,
    ht: `Kile`,
    it: `Quando`,
    ja: `\u{3044}\u{3064}`,
    ko: `\u{C5B8}\u{C81C}`,
    mww: `Thauj tw`,
    ps: `\u{6A9}\u{644}\u{647} \u{686}\u{6D0}`,
    pt: `Quando`,
    'pt-pt': `Quando`,
    ru: `\u{41A}\u{43E}\u{433}\u{434}\u{430}`,
    sm: `O afea`,
    so: `Goorma`,
    th: `\u{E40}\u{E21}\u{E37}\u{E48}\u{E2D}\u{E44}\u{E2B}\u{E23}\u{E48}`,
    ur: `\u{62C}\u{628}`,
    vi: `Khi n\xe0o`,
    'zh-hans': `\u{5F53}`,
    'zh-hant': `\u{7576}`,
    en: `When`
};
const $b11db1b62d4a8f76$export$faf5bc64d8debefb = {
    ar: `\u{62D}\u{64A}\u{62B}`,
    de: `Wobei`,
    es: `Donde`,
    fa: `\u{6A9}\u{647} \u{62F}\u{631} \u{622}\u{646}`,
    fil: `Kung saan`,
    fr: `O\xf9`,
    hi: `\u{915}\u{939}\u{93E}\u{902} \u{939}\u{948}`,
    ht: `Kote`,
    it: `Dove`,
    ja: `\u{3053}\u{3053}\u{3067}`,
    ko: `\u{C5EC}\u{AE30}\u{C11C}`,
    mww: `Qhov twg`,
    ps: `\u{686}\u{6CC}\u{631}\u{62A}\u{647}`,
    pt: `Onde`,
    'pt-pt': `Onde`,
    ru: `\u{413}\u{434}\u{435}`,
    sm: `O fea`,
    so: `Meesha`,
    th: `\u{E42}\u{E14}\u{E22}\u{E17}\u{E35}\u{E48}`,
    ur: `\u{62C}\u{6C1}\u{627}\u{6BA}`,
    vi: `Trong \u{111}\xf3`,
    'zh-hans': `\u{5176}\u{4E2D}`,
    'zh-hant': `\u{5176}\u{4E2D}`,
    en: `Where`
};
const $b11db1b62d4a8f76$export$3d8419edd48b3be2 = {
    ar: `\u{633}\u{64A}\u{631} \u{627}\u{644}\u{639}\u{645}\u{644}`,
    de: `Arbeitsablauf`,
    es: `Flujo de trabajo`,
    fa: `\u{631}\u{648}\u{646}\u{62F} \u{6A9}\u{627}\u{631}\u{6CC}`,
    fil: `Daloy ng Trabaho`,
    fr: `Flux de travail`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{92A}\u{94D}\u{930}\u{935}\u{93E}\u{939}`,
    ht: `Workflow`,
    it: `Flusso di lavoro`,
    ja: `\u{30EF}\u{30FC}\u{30AF}\u{30D5}\u{30ED}\u{30FC}`,
    ko: `\u{C6CC}\u{D06C}\u{D50C}\u{B85C}\u{C6B0}`,
    mww: `Workflow`,
    ps: `\u{6A9}\u{627}\u{631}\u{6CC} \u{628}\u{647}\u{6CC}\u{631}`,
    pt: `Fluxo de trabalho`,
    'pt-pt': `Fluxo de trabalho`,
    ru: `\u{420}\u{430}\u{431}\u{43E}\u{447}\u{438}\u{439} \u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}`,
    sm: `Fa'agaioiga`,
    so: `Habka Shaqada`,
    th: `\u{E40}\u{E27}\u{E34}\u{E23}\u{E4C}\u{E01}\u{E42}\u{E1F}\u{E25}\u{E27}\u{E4C}`,
    ur: `\u{648}\u{631}\u{6A9} \u{641}\u{644}\u{648}`,
    vi: `Quy tr\xecnh l\xe0m vi\u{1EC7}c`,
    'zh-hans': `\u{5DE5}\u{4F5C}\u{6D41}\u{7A0B}`,
    'zh-hant': `\u{5DE5}\u{4F5C}\u{6D41}\u{7A0B}`,
    en: `Workflow`
};
const $b11db1b62d4a8f76$export$8155d83ad7fe9d53 = {
    ar: `\u{627}\u{643}\u{62A}\u{628}`,
    de: `Schreib`,
    es: `Escribe`,
    fa: `\u{628}\u{646}\u{648}\u{6CC}\u{633}`,
    fil: `Sumulat`,
    fr: `\xc9crire`,
    hi: `\u{932}\u{93F}\u{916}\u{928}\u{93E}`,
    ht: `Ekri`,
    it: `Scrivi`,
    ja: `\u{66F8}\u{304F}`,
    ko: `\u{C4F0}\u{AE30}`,
    mww: `sau ntawv`,
    ps: `\u{648}\u{644}\u{6CC}\u{6A9}\u{647}`,
    pt: `Escreva`,
    'pt-pt': `Escrever`,
    ru: `\u{41F}\u{438}\u{448}\u{438}`,
    sm: `Tusi`,
    so: `Qor`,
    th: `\u{E40}\u{E02}\u{E35}\u{E22}\u{E19}`,
    ur: `\u{644}\u{6A9}\u{6BE}\u{648}`,
    vi: `Vi\u{1EBF}t`,
    'zh-hans': `\u{5199}`,
    'zh-hant': `\u{5BEB}`,
    en: `Write`
};
const $b11db1b62d4a8f76$export$f40e7e8c3c41d356 = {
    ar: (years, months)=>`${years} ${months} \u{623}\u{634}\u{647}\u{631}`,
    de: (years, months)=>`${years} Jahre und ${months} Monate`,
    es: (years, months)=>`${years} a\xf1os y ${months} meses`,
    fa: (years, months)=>`${years} \u{633}\u{627}\u{644} \u{648} ${months} \u{645}\u{627}\u{647}`,
    fil: (years, months)=>`${years} taon at ${months} buwan`,
    fr: (years, months)=>`${years} ans et ${months} mois`,
    hi: (years, months)=>`${years} \u{938}\u{93E}\u{932} \u{914}\u{930} ${months} \u{92E}\u{939}\u{940}\u{928}\u{947}`,
    ht: (years, months)=>`${years} ${months}`,
    it: (years, months)=>`${years} anni e ${months} mesi`,
    ja: (years, months)=>`${years}${months}`,
    ko: (years, months)=>`${years} \u{B144} ${months} \u{AC1C}\u{C6D4}`,
    mww: (years, months)=>`${years} xyoos ${months} lub hlis`,
    ps: (years, months)=>`${years} \u{6A9}\u{627}\u{644}\u{647} \u{627}\u{648} ${months} \u{645}\u{6CC}\u{627}\u{634}\u{62A}\u{6D0}`,
    pt: (years, months)=>`${years} anos e ${months} meses`,
    'pt-pt': (years, months)=>`2 ${years} ${months} meses`,
    ru: (years, months)=>`${years} \u{433}\u{43E}\u{434}\u{430} \u{438} ${months} \u{43C}\u{435}\u{441}\u{44F}\u{446}\u{430}`,
    sm: (years, months)=>`${years} tausaga ma ${months} masina`,
    so: (years, months)=>`${years} sano iyo ${months} bilood`,
    th: (years, months)=>`${years} \u{E1B}\u{E35} ${months} \u{E40}\u{E14}\u{E37}\u{E2D}\u{E19}`,
    ur: (years, months)=>`${years} \u{633}\u{627}\u{644} \u{627}\u{648}\u{631} ${months} \u{645}\u{627}\u{6C1}`,
    vi: (years, months)=>`${years} n\u{103}m ${months} th\xe1ng`,
    'zh-hans': (years, months)=>`${years}${months}`,
    'zh-hant': (years, months)=>`${years}${months}`,
    en: (years, months)=>`${years} years and ${months} months`
};
const $b11db1b62d4a8f76$export$310250c811816278 = {
    ar: `\u{646}\u{639}\u{645}`,
    de: `Ja`,
    es: `S\xed`,
    fa: `\u{628}\u{644}\u{647}`,
    fil: `Oo`,
    fr: `Oui`,
    hi: `\u{939}\u{93E}\u{901}`,
    ht: `Wi`,
    it: `S\xec`,
    ja: `\u{306F}\u{3044}`,
    ko: `\u{B124}`,
    mww: `Yog lawm`,
    ps: `\u{647}\u{648}`,
    pt: `Sim`,
    'pt-pt': `Sim`,
    ru: `\u{414}\u{430}`,
    sm: `Ioe`,
    so: `Haa`,
    th: `\u{E43}\u{E0A}\u{E48}`,
    ur: `\u{62C}\u{6CC} \u{6C1}\u{627}\u{6BA}`,
    vi: `C\xf3`,
    'zh-hans': `\u{662F}\u{7684}`,
    'zh-hant': `\u{662F}\u{7684}`,
    en: `Yes`
};
const $b11db1b62d4a8f76$export$1108f562936cb617 = {
    ar: `\u{623}\u{646}\u{62A}`,
    de: `Du`,
    es: `T\xfa`,
    fa: `\u{62A}\u{648}`,
    fil: `Ikaw`,
    fr: `Toi`,
    hi: `\u{906}\u{92A}`,
    ht: `Ou`,
    it: `Tu`,
    ja: `\u{304A}\u{524D}\u{3060}`,
    ko: `\u{B108}`,
    mww: `Koj`,
    ps: `\u{62A}\u{647}`,
    pt: `Voc\xea`,
    'pt-pt': `Tu`,
    ru: `\u{422}\u{44B}`,
    sm: `O oe`,
    so: `Adiga`,
    th: `\u{E04}\u{E38}\u{E13}`,
    ur: `\u{62A}\u{645}`,
    vi: `B\u{1EA1}n`,
    'zh-hans': `\u{4F60}`,
    'zh-hant': `\u{4F60}`,
    en: `You`
};
const $b11db1b62d4a8f76$export$eda36b340a683f39 = {
    ar: `\u{623}\u{646}\u{62A} \u{645}\u{634}\u{62A}\u{631}\u{643}`,
    de: `Sie sind abonniert`,
    es: `Est\xe1s suscrito`,
    fa: `\u{634}\u{645}\u{627} \u{645}\u{634}\u{62A}\u{631}\u{6A9} \u{647}\u{633}\u{62A}\u{6CC}\u{62F}`,
    fil: `Ikaw ay naka-subscribe`,
    fr: `Vous \xeates abonn\xe9`,
    hi: `\u{906}\u{92A}\u{928}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{932}\u{940} \u{939}\u{948}`,
    ht: `Ou ab\xf2nman`,
    it: `Sei iscritto`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306F}\u{8CFC}\u{8AAD}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}`,
    ko: `\u{AD6C}\u{B3C5}\u{D558}\u{C168}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Koj tau sau npe`,
    ps: `\u{62A}\u{627}\u{633}\u{648} \u{6AB}\u{689}\u{648}\u{646} \u{6A9}\u{693}\u{6CC} \u{6CC}\u{627}\u{633}\u{62A}`,
    pt: `Voc\xea est\xe1 inscrito`,
    'pt-pt': `Est\xe1 subscrito`,
    ru: `\u{412}\u{44B} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{44B}`,
    sm: `Ua e lesitala`,
    so: `Waad isdiiwaan gelisay`,
    th: `\u{E04}\u{E38}\u{E13}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{622}\u{67E} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{6A9}\u{631} \u{686}\u{6A9}\u{6D2} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `B\u{1EA1}n \u{111}\xe3 \u{111}\u{103}ng k\xfd`,
    'zh-hans': `\u{4F60}\u{5DF2}\u{7ECF}\u{8BA2}\u{9605}\u{4E86}`,
    'zh-hant': `\u{4F60}\u{5DF2}\u{7D93}\u{8A02}\u{95B1}\u{4E86}`,
    en: `You are subscribed`
};
const $b11db1b62d4a8f76$export$d0872991fee7ddcf = {
    ar: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`يمكنك طرح أسئلة مثل "${chatPrompt1}"، "${chatPrompt2}"، "${chatPrompt3}"، و <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">المزيد</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> يعمل بالذكاء الاصطناعي، لذا هناك أخطاء محتملة. راجع المخرجات بعناية قبل الاستخدام.`,
    de: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`Du kannst Dinge fragen wie "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" und <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">Mehr</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> wird von KI angetrieben, daher sind Fehler möglich. Überprüfen Sie die Ergebnisse vor der Anwendung sorgfältig.`,
    es: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`Puedes preguntar cosas como "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" y <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">más</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> funciona con IA, así que es posible que se cometan errores. Revisa cuidadosamente los resultados antes de usarlos.`,
    fa: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`می توانید سوالاتی مانند «${chatPrompt1}»، «${chatPrompt2}»، «${chatPrompt3}» و <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">بیشتر</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> با هوش مصنوعی کار می کند، بنابراین ممکن است اشتباه شود. قبل از استفاده، خروجی ها را با دقت بررسی کنید.`,
    fil: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`Maaari kang magtanong ng mga bagay tulad ng "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", at <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">higit pa</button>.<br>Ang <a href="/docs/assistant">${cumulusAssistant}</a> ay pinapatakbo ng AI, kaya posible ang mga pagkakamali. Suriin nang mabuti ang output bago gamitin.`,
    fr: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`Vous pouvez poser des questions comme « ${chatPrompt1} », « ${chatPrompt2} », « ${chatPrompt3} », et <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">plus</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> est alimenté par l’IA, donc des erreurs sont possibles. Examinez attentivement les résultats avant utilisation.`,
    hi: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`आप "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" जैसी चीजें पूछ सकते हैं, और <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">अधिक</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> एआई द्वारा संचालित है, इसलिए गलतियाँ संभव हैं। उपयोग करने से पहले आउटपुट की सावधानीपूर्वक समीक्षा करें।`,
    ht: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`Ou ka mande bagay tankou "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", ak <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">Plis</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> patrone pa AI, kidonk erè yo posib Revize pwodiksyon ak anpil atansyon anvan ou itilize.`,
    it: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`Puoi chiedere cose come "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" e <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">di più</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> è alimentato dall'IA, quindi sono possibili errori. Rivedi attentamente i risultati prima di usarlo.`,
    ja: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`「${chatPrompt1}」「${chatPrompt2}」「${chatPrompt3}」などを尋ねることができます。 <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">もっと</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> はAIによって動いているため、ミスは起こり得ます。使用前に出力をよく確認してください。`,
    ko: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`"${chatPrompt1}", "${chatPrompt2}하기", "${chatPrompt3} 그리고 <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">더 보기</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> 는 AI로 구동되기 때문에 실수할 수 있습니다. 사용 전에 출력물을 꼼꼼히 검토하세요.`,
    mww: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`Koj tuaj yeem nug tej yam xws li "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", thiab <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">ntau dua</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> yog powered los ntawm AI, yog li yuam kev ua tau. Xyuas cov zis ua tib zoo ua ntej siv.`,
    ps: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`تاسو کولی شئ داسې پوښتنې وکړئ لکه "${chatPrompt1}"، ${chatPrompt2}"، "${chatPrompt3} کړئ"، او <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">نور</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> د AI لخوا ځواکمن شوی، نو تېروتنې ممکن دی. د کارونې مخکې محصول په دقت سره وګوره.`,
    pt: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`Você pode perguntar coisas como "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" e <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">Mais</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> é movido por IA, então erros são possíveis. Revise cuidadosamente a produção antes de usar.`,
    'pt-pt': (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`Pode perguntar coisas como "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" e <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">mais</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> é alimentado por IA, por isso erros são possíveis. Revise cuidadosamente os resultados antes de o usar.`,
    ru: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`Вы можете спросить такие вещи, как «${chatPrompt1}», «${chatPrompt2}», «${chatPrompt3}» и <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">Подробнее</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> работает на ИИ, поэтому возможны ошибки. Внимательно проверяйте выходные данные перед использованием.`,
    sm: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`E mafai ona e fesili atu i mea e pei o le "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", ma <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">sili atu</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> e fa'amalosia e AI, o lea e mafai ai ona faia ni mea sese. Iloilo ma le faaeteete le galuega faatino a o lei faaaogaina.`,
    so: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`Waxaad weydiin kartaa waxyaabo sida "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", iyo <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">wax badan</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> waxaa ku shaqeeya AI, sidaas darteed khaladaad waa suurtagal. Si taxaddar leh u eeg natiijada ka hor intaadan isticmaalin.`,
    th: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`คุณสามารถถามสิ่งต่างๆ เช่น "สรุป${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" และ <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">เพิ่มเติม</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> ขับเคลื่อนโดย AI ดังนั้นจึงอาจเกิดข้อผิดพลาดได้ Review ผลลัพธ์อย่างรอบคอบก่อนใช้งาน`,
    ur: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`آپ ایسی باتیں پوچھ سکتے ہیں جیسے "${chatPrompt1}"، ${chatPrompt2} کریں"، "${chatPrompt3} کریں"، اور <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">مزید</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> AI سے چلتا ہے، اس لیے غلطیاں ہو سکتی ہیں۔ استعمال سے پہلے آؤٹ پٹ کو غور سے دیکھیں۔`,
    vi: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`Bạn có thể hỏi những thứ như "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" và <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">Xem thêm</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> được hỗ trợ bởi AI, vì vậy có thể xảy ra sai sót. Review đầu ra cẩn thận trước khi sử dụng.`,
    'zh-hans': (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`你可以问诸如“${chatPrompt1}”、“${chatPrompt2}”、“${chatPrompt3}”等问题 <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">更多</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> 由 AI 驱动，因此出错是有可能的。使用前仔细检查输出。`,
    'zh-hant': (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`你可以問像是「${chatPrompt1}」、「${chatPrompt2}${chatPrompt3}」等問題<button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">更多</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> 是由 AI 驅動，因此出錯是有可能的。使用前請仔細檢查輸出。`,
    en: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$b11db1b62d4a8f76$var$html`You can ask things like "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", and <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">more</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> is powered by AI, so mistakes are possible. Review output carefully before use.`
};
const $b11db1b62d4a8f76$export$575c6bbf7e1a082f = {
    ar: `\u{644}\u{642}\u{62F} \u{642}\u{62F}\u{645}\u{62A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{645}\u{648}\u{630}\u{62C} \u{645}\u{624}\u{62E}\u{631}\u{627}.`,
    de: `Du hast dieses Formular k\xfcrzlich eingereicht.`,
    es: `Has enviado este formulario recientemente.`,
    fa: `\u{634}\u{645}\u{627} \u{627}\u{6CC}\u{646} \u{641}\u{631}\u{645} \u{631}\u{627} \u{627}\u{62E}\u{6CC}\u{631}\u{627} \u{627}\u{631}\u{633}\u{627}\u{644} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: `Isinumite mo ang form na ito kamakailan.`,
    fr: `Vous avez soumis ce formulaire r\xe9cemment.`,
    hi: `\u{906}\u{92A}\u{928}\u{947} \u{92F}\u{939} \u{92B}\u{949}\u{930}\u{94D}\u{92E} \u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{938}\u{92C}\u{92E}\u{93F}\u{91F} \u{915}\u{93F}\u{92F}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Ou te soum\xe8t f\xf2m sa a d\xe8ny\xe8man.`,
    it: `Hai inviato questo modulo di recente.`,
    ja: `\u{6700}\u{8FD1}\u{3053}\u{306E}\u{30D5}\u{30A9}\u{30FC}\u{30E0}\u{3092}\u{63D0}\u{51FA}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{306D}\u{3002}`,
    ko: `\u{CD5C}\u{ADFC}\u{C5D0} \u{C774} \u{C591}\u{C2DD}\u{C744} \u{C81C}\u{CD9C}\u{D558}\u{C168}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Koj tau xa daim ntawv no tsis ntev los no.`,
    ps: `\u{62A}\u{647} \u{62F}\u{627} \u{641}\u{648}\u{631}\u{645}\u{647} \u{62A}\u{627}\u{632}\u{647} \u{648}\u{693}\u{627}\u{646}\u{62F}\u{6D0} \u{6A9}\u{693}\u{6D0} \u{62F}\u{647}.`,
    pt: `Voc\xea enviou este formul\xe1rio recentemente.`,
    'pt-pt': `Submeteste este formul\xe1rio recentemente.`,
    ru: `\u{412}\u{44B} \u{43D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{438} \u{44D}\u{442}\u{443} \u{444}\u{43E}\u{440}\u{43C}\u{443}.`,
    sm: `Na e auina mai lenei fomu talu ai nei.`,
    so: `Waxaad dhawaan soo gudbisay foomkan.`,
    th: `\u{E04}\u{E38}\u{E13}\u{E40}\u{E1E}\u{E34}\u{E48}\u{E07}\u{E2A}\u{E48}\u{E07}\u{E41}\u{E1A}\u{E1A}\u{E1F}\u{E2D}\u{E23}\u{E4C}\u{E21}\u{E19}\u{E35}\u{E49}\u{E44}\u{E1B}\u{E40}\u{E21}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E23}\u{E47}\u{E27}\u{E46} \u{E19}\u{E35}\u{E49}`,
    ur: `\u{622}\u{67E} \u{646}\u{6D2} \u{6CC}\u{6C1} \u{641}\u{627}\u{631}\u{645} \u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{648}\u{627}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `B\u{1EA1}n \u{111}\xe3 g\u{1EED}i bi\u{1EC3}u m\u{1EAB}u n\xe0y g\u{1EA7}n \u{111}\xe2y.`,
    'zh-hans': `\u{4F60}\u{6700}\u{8FD1}\u{63D0}\u{4EA4}\u{4E86}\u{8FD9}\u{4EFD}\u{8868}\u{683C}\u{3002}`,
    'zh-hant': `\u{4F60}\u{6700}\u{8FD1}\u{63D0}\u{4EA4}\u{4E86}\u{9019}\u{4EFD}\u{8868}\u{683C}\u{3002}`,
    en: `You submitted this form recently.`
};
const $b11db1b62d4a8f76$export$c854aab670665996 = {
    ar: `\u{623}\u{646}\u{62A} \u{62A}\u{62F}\u{64A}\u{631} \u{631}\u{639}\u{627}\u{64A}\u{62A}\u{643} \u{628}\u{646}\u{641}\u{633}\u{643}.`,
    de: `Du k\xfcmmerst dich selbst um deine Pflege.`,
    es: `T\xfa gestionas tu propio cuidado.`,
    fa: `\u{62E}\u{648}\u{62F}\u{62A} \u{645}\u{631}\u{627}\u{642}\u{628}\u{62A}\u{62A} \u{631}\u{627} \u{645}\u{62F}\u{6CC}\u{631}\u{6CC}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}.`,
    fil: `Ikaw ang namamahala sa iyong sariling pag-aalaga.`,
    fr: `Vous g\xe9rez vos propres soins.`,
    hi: `\u{906}\u{92A} \u{905}\u{92A}\u{928}\u{940} \u{926}\u{947}\u{916}\u{92D}\u{93E}\u{932} \u{915}\u{93E} \u{92A}\u{94D}\u{930}\u{92C}\u{902}\u{927}\u{928} \u{938}\u{94D}\u{935}\u{92F}\u{902} \u{915}\u{930}\u{924}\u{947} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Ou jere pw\xf2p swen ou.`,
    it: `Gestisci la tua cura.`,
    ja: `\u{81EA}\u{5206}\u{306E}\u{30B1}\u{30A2}\u{306F}\u{81EA}\u{5206}\u{3067}\u{7BA1}\u{7406}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C2A4}\u{C2A4}\u{B85C} \u{B3CC}\u{BD04}\u{C744} \u{AD00}\u{B9AC}\u{D558}\u{C138}\u{C694}.`,
    mww: `Koj tswj koj tus kheej kev saib xyuas.`,
    ps: `\u{62A}\u{647} \u{62E}\u{67E}\u{644}\u{647} \u{67E}\u{627}\u{645}\u{644}\u{631}\u{646}\u{647} \u{6A9}\u{648}\u{6D0}.`,
    pt: `Voc\xea gerencia seus pr\xf3prios cuidados.`,
    'pt-pt': `Tu geres os teus pr\xf3prios cuidados.`,
    ru: `\u{412}\u{44B} \u{441}\u{430}\u{43C}\u{438} \u{437}\u{430}\u{431}\u{43E}\u{442}\u{438}\u{442}\u{435}\u{441}\u{44C} \u{43E} \u{441}\u{435}\u{431}\u{435}.`,
    sm: `E te pulea lau oe lava tausiga.`,
    so: `Adigu naftaada ayaad maamushaa.`,
    th: `\u{E04}\u{E38}\u{E13}\u{E08}\u{E31}\u{E14}\u{E01}\u{E32}\u{E23}\u{E01}\u{E32}\u{E23}\u{E14}\u{E39}\u{E41}\u{E25}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E40}\u{E2D}\u{E07}`,
    ur: `\u{622}\u{67E} \u{627}\u{67E}\u{646}\u{6CC} \u{62F}\u{6CC}\u{6A9}\u{6BE} \u{628}\u{6BE}\u{627}\u{644} \u{62E}\u{648}\u{62F} \u{633}\u{646}\u{628}\u{6BE}\u{627}\u{644}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `B\u{1EA1}n t\u{1EF1} qu\u{1EA3}n l\xfd vi\u{1EC7}c ch\u{103}m s\xf3c c\u{1EE7}a m\xecnh.`,
    'zh-hans': `\u{4F60}\u{81EA}\u{5DF1}\u{7BA1}\u{7406}\u{7167}\u{987E}\u{3002}`,
    'zh-hant': `\u{4F60}\u{81EA}\u{5DF1}\u{7BA1}\u{7406}\u{7167}\u{9867}\u{3002}`,
    en: `You manage your own care.`
};
const $b11db1b62d4a8f76$export$574566b924107962 = {
    ar: `\u{645}\u{648}\u{642}\u{639}\u{643}`,
    de: `Dein Standort`,
    es: `Tu ubicaci\xf3n`,
    fa: `\u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A} \u{634}\u{645}\u{627}`,
    fil: `Email Address *`,
    fr: `Votre emplacement`,
    hi: `\u{906}\u{92A}\u{915}\u{93E} \u{938}\u{94D}\u{925}\u{93E}\u{928}`,
    ht: `Kote ou ye`,
    it: `La tua posizione`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{4F4D}\u{7F6E}`,
    ko: `\u{B2F9}\u{C2E0}\u{C758} \u{C704}\u{CE58}`,
    mww: `Koj qhov chaw nyob`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{681}\u{627}\u{6CC}`,
    pt: `Sua localiza\xe7\xe3o`,
    'pt-pt': `A sua localiza\xe7\xe3o`,
    ru: `\u{412}\u{430}\u{448}\u{435} \u{43C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Lou nofoaga`,
    so: `Goobtaada`,
    th: `\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62C}\u{6AF}\u{6C1}`,
    vi: `V\u{1ECB} tr\xed c\u{1EE7}a b\u{1EA1}n`,
    'zh-hans': `\u{4F60}\u{7684}\u{4F4D}\u{7F6E}`,
    'zh-hant': `\u{4F60}\u{7684}\u{4F4D}\u{7F6E}`,
    en: `Your location`
};
const $b11db1b62d4a8f76$export$b515f6dda739aa14 = {
    ar: `\u{645}\u{646}\u{638}\u{645}\u{627}\u{62A}\u{643}\u{645}`,
    de: `Ihre Organisationen`,
    es: `Vuestras organizaciones`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{647}\u{627}\u{6CC} \u{634}\u{645}\u{627}`,
    fil: `Ang iyong mga organisasyon`,
    fr: `Vos organisations`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928}`,
    ht: `\xd2ganizasyon ou yo`,
    it: `Le vostre organizzazioni`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{7D44}\u{7E54}`,
    ko: `\u{C5EC}\u{B7EC}\u{BD84}\u{C758} \u{C870}\u{C9C1}`,
    mww: `Koj cov koom haum`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{647}`,
    pt: `Suas organiza\xe7\xf5es`,
    'pt-pt': `As vossas organiza\xe7\xf5es`,
    ru: `\u{412}\u{430}\u{448}\u{438} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Au fa'alapotopotoga`,
    so: `Ururadaada`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{6CC}\u{6BA}`,
    vi: `T\u{1ED5} ch\u{1EE9}c c\u{1EE7}a b\u{1EA1}n`,
    'zh-hans': `\u{4F60}\u{7684}\u{7EC4}\u{7EC7}`,
    'zh-hant': `\u{4F60}\u{7684}\u{7D44}\u{7E54}`,
    en: `Your organizations`
};
const $b11db1b62d4a8f76$export$bfc24264c54d96a2 = {
    ar: `\u{645}\u{644}\u{641}\u{643} \u{627}\u{644}\u{634}\u{62E}\u{635}\u{64A}`,
    de: `Dein Profil`,
    es: `Tu perfil`,
    fa: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644} \u{634}\u{645}\u{627}`,
    fil: `Email Address *`,
    fr: `Votre profil`,
    hi: `\u{906}\u{92A}\u{915}\u{940} \u{92A}\u{94D}\u{930}\u{94B}\u{92B}\u{93C}\u{93E}\u{907}\u{932}`,
    ht: `Pwofil ou`,
    it: `Il tuo profilo`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{30D7}\u{30ED}\u{30D5}\u{30A3}\u{30FC}\u{30EB}`,
    ko: `\u{B2F9}\u{C2E0}\u{C758} \u{D504}\u{B85C}\u{D544}`,
    mww: `Koj qhov profile`,
    ps: `\u{633}\u{62A}\u{627} \u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644}`,
    pt: `Seu perfil`,
    'pt-pt': `O teu perfil`,
    ru: `\u{412}\u{430}\u{448} \u{43F}\u{440}\u{43E}\u{444}\u{438}\u{43B}\u{44C}`,
    sm: `Lau talaaga otooto`,
    so: `Profile-kaaga`,
    th: `\u{E42}\u{E1B}\u{E23}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{67E}\u{631}\u{648}\u{641}\u{627}\u{626}\u{644}`,
    vi: `H\u{1ED3} s\u{1A1} c\u{1EE7}a b\u{1EA1}n`,
    'zh-hans': `\u{4F60}\u{7684}\u{4E2A}\u{4EBA}\u{8D44}\u{6599}`,
    'zh-hant': `\u{4F60}\u{7684}\u{500B}\u{4EBA}\u{8CC7}\u{6599}`,
    en: `Your profile`
};
const $b11db1b62d4a8f76$export$6896487a24fde326 = {
    ar: `\u{627}\u{646}\u{62A}\u{647}\u{62A} \u{62C}\u{644}\u{633}\u{62A}\u{643}. \u{633}\u{62C}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{644}\u{645}\u{62A}\u{627}\u{628}\u{639}\u{629} \u{62C}\u{644}\u{633}\u{62A}\u{643}.`,
    de: `Deine Sitzung ist abgelaufen. Melden Sie sich an, um Ihre Sitzung fortzusetzen.`,
    es: `Tu sesi\xf3n ha expirado. Inicia sesi\xf3n para continuar tu sesi\xf3n.`,
    fa: `\u{62C}\u{644}\u{633}\u{647} \u{627}\u{62A} \u{645}\u{646}\u{642}\u{636}\u{6CC} \u{634}\u{62F}. \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{62F}\u{627}\u{645}\u{647} \u{62C}\u{644}\u{633}\u{647} \u{648}\u{627}\u{631}\u{62F} \u{634}\u{648}\u{6CC}\u{62F}.`,
    fil: `Nag-expire na ang session mo. Mag-sign in upang ipagpatuloy ang iyong sesyon.`,
    fr: `Ta s\xe9ance a expir\xe9. Connectez-vous pour poursuivre votre s\xe9ance.`,
    hi: `\u{906}\u{92A}\u{915}\u{93E} \u{938}\u{924}\u{94D}\u{930} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{917}\u{92F}\u{93E} \u{939}\u{948}. \u{905}\u{92A}\u{928}\u{93E} \u{938}\u{924}\u{94D}\u{930} \u{91C}\u{93E}\u{930}\u{940} \u{930}\u{916}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{915}\u{930}\u{947}\u{902}.`,
    ht: `Sesyon ou ekspire. Siyen pou w kontinye sesyon w la.`,
    it: `La tua sessione \xe8 terminata. Accedi per continuare la tua sessione.`,
    ja: `\u{30BB}\u{30C3}\u{30B7}\u{30E7}\u{30F3}\u{306F}\u{671F}\u{9650}\u{5207}\u{308C}\u{3067}\u{3059}\u{3002}\u{30BB}\u{30C3}\u{30B7}\u{30E7}\u{30F3}\u{3092}\u{7D9A}\u{3051}\u{308B}\u{306B}\u{306F}\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C138}\u{C158}\u{C774} \u{B9CC}\u{B8CC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C138}\u{C158}\u{C744} \u{ACC4}\u{C18D}\u{D558}\u{B824}\u{BA74} \u{B85C}\u{ADF8}\u{C778}\u{D558}\u{C138}\u{C694}.`,
    mww: `Koj qhov kev sib kho tas sij hawm. Kos npe rau hauv mus txuas ntxiv koj qhov kev sib kho.`,
    ps: `\u{633}\u{62A}\u{627} \u{63A}\u{648}\u{646}\u{689}\u{647} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{6D0}\u{62F}\u{647}. \u{62F} \u{62E}\u{67E}\u{644} \u{633}\u{6CC}\u{634}\u{646} \u{62F} \u{62F}\u{648}\u{627}\u{645} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{646}\u{646}\u{648}\u{681}\u{626}.`,
    pt: `Sua sess\xe3o expirou. Fa\xe7a login para continuar sua sess\xe3o de trabalho.`,
    'pt-pt': `A tua sess\xe3o expirou. Inicie sess\xe3o para continuar a sua sess\xe3o.`,
    ru: `\u{422}\u{432}\u{43E}\u{44F} \u{441}\u{435}\u{441}\u{441}\u{438}\u{44F} \u{437}\u{430}\u{43A}\u{43E}\u{43D}\u{447}\u{438}\u{43B}\u{430}\u{441}\u{44C}. \u{412}\u{43E}\u{439}\u{434}\u{438}\u{442}\u{435} \u{432} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{43E}\u{434}\u{43E}\u{43B}\u{436}\u{438}\u{442}\u{44C} \u{441}\u{435}\u{441}\u{441}\u{438}\u{44E}.`,
    sm: `Ua uma le aoga o lau sauniga. Saini i totonu e faaauau ai lau sauniga.`,
    so: `Fadhigaaga wuu dhacay. Isdiiwaangeli si aad u sii waddo fadhigaaga.`,
    th: `\u{E40}\u{E0B}\u{E2A}\u{E0A}\u{E31}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38} \u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E15}\u{E48}\u{E2D}\u{E40}\u{E0B}\u{E2A}\u{E0A}\u{E31}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{62A}\u{645}\u{6C1}\u{627}\u{631}\u{627} \u{633}\u{6CC}\u{634}\u{646} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{6AF}\u{6CC}\u{627}\u{6D4} \u{627}\u{67E}\u{646}\u{627} \u{633}\u{6CC}\u{634}\u{646} \u{62C}\u{627}\u{631}\u{6CC} \u{631}\u{6A9}\u{6BE}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{6CC}\u{6D2} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Phi\xean c\u{1EE7}a b\u{1EA1}n \u{111}\xe3 h\u{1EBF}t h\u{1EA1}n. \u{110}\u{103}ng nh\u{1EAD}p \u{111}\u{1EC3} ti\u{1EBF}p t\u{1EE5}c phi\xean c\u{1EE7}a b\u{1EA1}n.`,
    'zh-hans': `\u{4F60}\u{7684}\u{4F1A}\u{8BDD}\u{5DF2}\u{8FC7}\u{671F}\u{3002}\u{767B}\u{5F55}\u{4EE5}\u{7EE7}\u{7EED}\u{60A8}\u{7684}\u{4F1A}\u{8BDD}\u{3002}`,
    'zh-hant': `\u{4F60}\u{7684}\u{8AB2}\u{7A0B}\u{5DF2}\u{7D93}\u{7D50}\u{675F}\u{3002}\u{767B}\u{5165}\u{4EE5}\u{7E7C}\u{7E8C}\u{60A8}\u{7684}\u{8AB2}\u{7A0B}\u{3002}`,
    en: `Your session expired. Sign in to continue your session.`
};
const $b11db1b62d4a8f76$export$e89f2baa86b7e303 = {
    ar: (provider)=>`\u{644}\u{642}\u{62F} \u{633}\u{62C}\u{644}\u{62A} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{639}\u{628}\u{631} ${provider}`,
    de: (provider)=>`Du hast dich mit ${provider} angemeldet`,
    es: (provider)=>`Has iniciado sesi\xf3n con ${provider}`,
    fa: (provider)=>`\u{634}\u{645}\u{627} \u{628}\u{627} ${provider} \u{648}\u{627}\u{631}\u{62F} \u{634}\u{62F}\u{6CC}\u{62F}.`,
    fil: (provider)=>`Nag-sign in ka sa ${provider}`,
    fr: (provider)=>`Vous vous \xeates connect\xe9 avec ${provider}`,
    hi: (provider)=>`\u{906}\u{92A}\u{928}\u{947} ${provider} \u{938}\u{93E}\u{925} \u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{915}\u{93F}\u{92F}\u{93E} \u{939}\u{948}`,
    ht: (provider)=>`Ou siyen ak ${provider}`,
    it: (provider)=>`Hai effettuato l'accesso con ${provider}`,
    ja: (provider)=>`${provider}\u{3067}\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}\u{3057}\u{307E}\u{3057}\u{305F}`,
    ko: (provider)=>`${provider}\u{B85C} \u{B85C}\u{ADF8}\u{C778}\u{D558}\u{C168}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: (provider)=>`Koj tau kos npe nrog ${provider}`,
    ps: (provider)=>`\u{62A}\u{647} ${provider} \u{633}\u{631}\u{647} \u{646}\u{646}\u{648}\u{62A}\u{6D0}`,
    pt: (provider)=>`Voc\xea entrou no ${provider}`,
    'pt-pt': (provider)=>`Iniciaste sess\xe3o com ${provider}`,
    ru: (provider)=>`\u{412}\u{44B} \u{432}\u{43E}\u{448}\u{43B}\u{438} \u{432} ${provider}`,
    sm: (provider)=>`Na e saini i totonu ma ${provider}`,
    so: (provider)=>`Waxaad ku soo gashay ${provider}`,
    th: (provider)=>`\u{E04}\u{E38}\u{E13}\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E14}\u{E49}\u{E27}\u{E22} ${provider}`,
    ur: (provider)=>`\u{622}\u{67E} ${provider} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{6CC}\u{627}`,
    vi: (provider)=>`B\u{1EA1}n \u{111}\xe3 \u{111}\u{103}ng nh\u{1EAD}p b\u{1EB1}ng ${provider}`,
    'zh-hans': (provider)=>`\u{4F60}\u{7528}${provider}\u{767B}\u{5F55}\u{4E86}`,
    'zh-hant': (provider)=>`\u{4F60}\u{7528} ${provider} \u{767B}\u{5165}\u{4E86}`,
    en: (provider)=>`You signed in with ${provider}`
};
const $b11db1b62d4a8f76$export$14d9ba8651bf485 = {
    ar: `\u{627}\u{644}\u{631}\u{645}\u{632} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F}\u{64A}`,
    de: `Postleitzahl`,
    es: `C\xf3digo postal`,
    fa: `\u{6A9}\u{62F} \u{67E}\u{633}\u{62A}\u{6CC}`,
    fil: `Email Address *`,
    fr: `Code postal`,
    hi: `\u{91C}\u{93C}\u{93F}\u{92A} \u{915}\u{94B}\u{921}`,
    ht: `K\xf2d postal`,
    it: `Codice postale`,
    ja: `\u{90F5}\u{4FBF}\u{756A}\u{53F7}`,
    ko: `\u{C6B0}\u{D3B8}\u{BC88}\u{D638}`,
    mww: `Tsib tug leb qhia thaj tsam yus nyob`,
    ps: `\u{632}\u{6CC}\u{67E} \u{634}\u{641}\u{631}`,
    pt: `CEP`,
    'pt-pt': `C\xf3digo postal`,
    ru: `\u{41F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{44B}\u{439} \u{438}\u{43D}\u{434}\u{435}\u{43A}\u{441}`,
    sm: `Numera o le pusa meli`,
    so: `Lanbarka furaha`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E44}\u{E1B}\u{E23}\u{E29}\u{E13}\u{E35}\u{E22}\u{E4C}`,
    ur: `\u{632}\u{67E} \u{6A9}\u{648}\u{688}`,
    vi: `M\xe3 b\u{1B0}u ch\xednh`,
    'zh-hans': `\u{90AE}\u{653F}\u{7F16}\u{7801}`,
    'zh-hant': `\u{90F5}\u{905E}\u{5340}\u{865F}`,
    en: `Zip code`
};
const $b11db1b62d4a8f76$export$b13ba07885d8373d = {
    ar: $b11db1b62d4a8f76$var$html`<span class="sr-only">الرمز البريدي </span>الامتداد<span class="sr-only"></span>`,
    de: $b11db1b62d4a8f76$var$html`<span class="sr-only">Postleitzahl </span>Außer<span class="sr-only">Ension</span>`,
    es: $b11db1b62d4a8f76$var$html`<span class="sr-only">Código postal </span><span class="sr-only">Extensión</span>`,
    fa: $b11db1b62d4a8f76$var$html`<span class="sr-only">کد پستی </span>گسترش<span class="sr-only"></span>`,
    fil: $b11db1b62d4a8f76$var$html`<span class="sr-only">Email </span> Address *Ext<span class="sr-only">ension</span>`,
    fr: $b11db1b62d4a8f76$var$html`<span class="sr-only">Code postal </span><span class="sr-only">Extension de la direction</span>`,
    hi: $b11db1b62d4a8f76$var$html`<span class="sr-only">ज़िप कोड </span>विस्तार<span class="sr-only"></span>`,
    ht: $b11db1b62d4a8f76$var$html`<span class="sr-only">Kòd postal </span>Ext<span class="sr-only">ension</span>`,
    it: $b11db1b62d4a8f76$var$html`<span class="sr-only">Codice postale </span><span class="sr-only">Estensione</span>`,
    ja: $b11db1b62d4a8f76$var$html`<span class="sr-only">郵便番号 </span>外<span class="sr-only">延</span>`,
    ko: $b11db1b62d4a8f76$var$html`<span class="sr-only">우편번호 </span>익스텐<span class="sr-only">션</span>`,
    mww: $b11db1b62d4a8f76$var$html`<span class="sr-only">Tsib tug leb qhia thaj tsam yus nyob </span>Ext<span class="sr-only">ension</span>`,
    ps: $b11db1b62d4a8f76$var$html`<span class="sr-only">زیپ شفر </span>Ext<span class="sr-only">ension</span>`,
    pt: $b11db1b62d4a8f76$var$html`<span class="sr-only">CEP </span><span class="sr-only">Extensão</span>`,
    'pt-pt': $b11db1b62d4a8f76$var$html`<span class="sr-only">Código postal </span><span class="sr-only">Extensão</span>`,
    ru: $b11db1b62d4a8f76$var$html`<span class="sr-only">Почтовый индекс </span>Ext<span class="sr-only">ension</span>`,
    sm: $b11db1b62d4a8f76$var$html`<span class="sr-only">Numera o le pusa meli </span>Ext<span class="sr-only">ension</span>`,
    so: $b11db1b62d4a8f76$var$html`<span class="sr-only">Lanbarka furaha </span><span class="sr-only">Ballaarinta</span>`,
    th: $b11db1b62d4a8f76$var$html`<span class="sr-only">รหัสไปรษณีย์ </span>ขยาย<span class="sr-only"></span>`,
    ur: $b11db1b62d4a8f76$var$html`<span class="sr-only">زپ کوڈ </span>توسیع<span class="sr-only"></span>`,
    vi: $b11db1b62d4a8f76$var$html`<span class="sr-only">Mã bưu chính </span>Mở rộng<span class="sr-only"></span>`,
    'zh-hans': $b11db1b62d4a8f76$var$html`<span class="sr-only">邮政编码 </span>延伸<span class="sr-only"></span>`,
    'zh-hant': $b11db1b62d4a8f76$var$html`<span class="sr-only">郵遞區號 </span>延<span class="sr-only">展</span>`,
    en: $b11db1b62d4a8f76$var$html`<span class="sr-only">Zip code </span>Ext<span class="sr-only">ension</span>`
};


/* eslint-disable no-control-regex, regexp/no-control-character -- These regexes exist to match control characters, so they cannot avoid them. */ function $c5391a1f4c2c7212$export$2e2bcd8739ae039() {
    return /[\u{0}-\u{1F}"*\/:<>?\\\|]|[ .]$/gv;
}
function $c5391a1f4c2c7212$export$a0701abe10a1ba48() {
    return /^(?:con|prn|aux|nul|conin\$|conout\$|com[\d²³¹]|lpt[\d²³¹]) *(?:\..*)?$/iv;
}


// Doesn't make sense to have longer filenames
const $426ea2ef2dc61d30$var$MAX_FILENAME_LENGTH = 100;
const $426ea2ef2dc61d30$var$reRelativePath = /^\.+(\\|\/)|^\.+$/;
const $426ea2ef2dc61d30$var$reTrailingDotsAndSpaces = /[. ]+$/;
const $426ea2ef2dc61d30$var$reTrailingSpaces = / +$/;
const $426ea2ef2dc61d30$var$reWindowsReservedName = (0, $c5391a1f4c2c7212$export$a0701abe10a1ba48)();
// Remove all problematic characters except zero-width joiner (\u200D) needed for emoji
const $426ea2ef2dc61d30$var$reControlChars = /[\p{Control}\p{Format}\p{Zl}\p{Zp}\uFFF0-\uFFFF]/gu;
const $426ea2ef2dc61d30$var$reControlCharsTest = /[\p{Control}\p{Format}\p{Zl}\p{Zp}\uFFF0-\uFFFF]/u;
const $426ea2ef2dc61d30$var$isZeroWidthJoiner = (char)=>char === '\u200D';
const $426ea2ef2dc61d30$var$reRepeatedReservedCharacters = /([<>:"/\\|?*\u0000-\u001F]){2,}/g; // eslint-disable-line no-control-regex
// For validating replacement string - only truly reserved characters, not trailing spaces/periods
const $426ea2ef2dc61d30$var$reReplacementReservedCharacters = /[<>:"/\\|?*\u0000-\u001F]/; // eslint-disable-line no-control-regex
// Normalize various Unicode whitespace characters to regular space
// Using specific characters instead of \s to avoid matching regular spaces
const $426ea2ef2dc61d30$var$reUnicodeWhitespace = /[\t\n\r\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000]+/g;
let $426ea2ef2dc61d30$var$segmenter;
function $426ea2ef2dc61d30$var$getSegmenter() {
    $426ea2ef2dc61d30$var$segmenter ??= new Intl.Segmenter(undefined, {
        granularity: 'grapheme'
    });
    return $426ea2ef2dc61d30$var$segmenter;
}
function $426ea2ef2dc61d30$var$truncateFilename(filename, maxLength) {
    if (filename.length <= maxLength) return filename;
    const extensionIndex = filename.lastIndexOf('.');
    // No extension - simple truncation
    if (extensionIndex === -1) return $426ea2ef2dc61d30$var$truncateByGraphemeBudget(filename, maxLength);
    // Has extension - preserve it and truncate base
    const base = filename.slice(0, extensionIndex);
    const extension = filename.slice(extensionIndex);
    const baseBudget = Math.max(0, maxLength - extension.length);
    const truncatedBase = $426ea2ef2dc61d30$var$truncateByGraphemeBudget(base, baseBudget);
    // Strip trailing spaces from base (not periods - they're not trailing in final filename)
    return truncatedBase.replace($426ea2ef2dc61d30$var$reTrailingSpaces, '') + extension;
}
function $426ea2ef2dc61d30$var$ensureNonWindowsReservedName(filename, replacement) {
    if (!$426ea2ef2dc61d30$var$reWindowsReservedName.test(filename)) return filename;
    const extensionIndex = filename.indexOf('.');
    const base = extensionIndex === -1 ? filename : filename.slice(0, extensionIndex);
    const baseWithoutTrailingSpaces = base.replace($426ea2ef2dc61d30$var$reTrailingSpaces, '');
    const extension = extensionIndex === -1 ? '' : filename.slice(extensionIndex);
    const candidate = (baseWithoutTrailingSpaces + replacement + extension).replace($426ea2ef2dc61d30$var$reTrailingDotsAndSpaces, '');
    return $426ea2ef2dc61d30$var$reWindowsReservedName.test(candidate) ? baseWithoutTrailingSpaces + '!' + extension : candidate;
}
function $426ea2ef2dc61d30$export$2e2bcd8739ae039(string, options = {}) {
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    const replacement = options.replacement ?? '!';
    const hasReservedChars = $426ea2ef2dc61d30$var$reReplacementReservedCharacters.test(replacement);
    const hasControlChars = [
        ...replacement
    ].some((char)=>$426ea2ef2dc61d30$var$reControlCharsTest.test(char) && !$426ea2ef2dc61d30$var$isZeroWidthJoiner(char));
    if (hasReservedChars || hasControlChars) throw new Error('Replacement string cannot contain reserved filename characters');
    // Normalize to NFC first to stabilize byte representation and length calculations across platforms.
    string = string.normalize('NFC');
    // Normalize Unicode whitespace to single spaces
    string = string.replaceAll($426ea2ef2dc61d30$var$reUnicodeWhitespace, ' ');
    if (replacement.length > 0) string = string.replaceAll($426ea2ef2dc61d30$var$reRepeatedReservedCharacters, '$1');
    // Trim trailing spaces and periods (Windows rule) - do this BEFORE replacements
    // so they get stripped rather than replaced
    string = string.replace($426ea2ef2dc61d30$var$reTrailingDotsAndSpaces, '');
    string = string.replace($426ea2ef2dc61d30$var$reRelativePath, ()=>replacement);
    string = string.replace((0, $c5391a1f4c2c7212$export$2e2bcd8739ae039)(), ()=>replacement);
    string = string.replaceAll($426ea2ef2dc61d30$var$reControlChars, (char)=>$426ea2ef2dc61d30$var$isZeroWidthJoiner(char) ? char : replacement);
    // Trim trailing spaces and periods again (in case replacement created new ones)
    string = string.replace($426ea2ef2dc61d30$var$reTrailingDotsAndSpaces, '');
    // If the string is now empty, use replacement with trailing spaces/periods stripped
    if (string.length === 0) {
        string = replacement.replace($426ea2ef2dc61d30$var$reTrailingDotsAndSpaces, '');
        // If still empty and replacement wasn't explicitly empty, use '!' as fallback
        if (string.length === 0 && replacement.length > 0) string = '!';
    }
    // Truncate before Windows reserved name check (truncation can create reserved names)
    const allowedLength = typeof options.maxLength === 'number' ? options.maxLength : $426ea2ef2dc61d30$var$MAX_FILENAME_LENGTH;
    string = $426ea2ef2dc61d30$var$truncateFilename(string, allowedLength);
    // Strip trailing spaces/periods after truncation (truncation can create them)
    string = string.replace($426ea2ef2dc61d30$var$reTrailingDotsAndSpaces, '');
    // Check for Windows reserved names after truncation and stripping
    // Windows compatibility takes precedence over maxLength, so the result may exceed it
    string = $426ea2ef2dc61d30$var$ensureNonWindowsReservedName(string, replacement);
    return string;
}
function $426ea2ef2dc61d30$var$truncateByGraphemeBudget(input, budget) {
    if (input.length <= budget) return input;
    let count = 0;
    let output = '';
    for (const { segment: segment } of $426ea2ef2dc61d30$var$getSegmenter().segment(input)){
        const next = count + segment.length;
        if (next > budget) break;
        output += segment;
        count = next;
    }
    return output;
}


function $cb5704f276528297$export$3f063810d7bf01bd(array, f) {
    return array.reduce((a, b)=>((a[f(b)] = a[f(b)] || []).push(b), a), {});
}
function $cb5704f276528297$export$e439fc32198f78c5(array, key, valueFn = (item)=>item) {
    return array.reduce((accumulator, current)=>{
        accumulator[current[key]] = valueFn(current);
        return accumulator;
    }, {});
}
function $cb5704f276528297$export$eeced19e3078b2f(array, k1, k2, valueFn = (item)=>item) {
    return array.reduce((a, b)=>{
        a[b[k1]] ??= {};
        a[b[k1]][b[k2]] ??= valueFn(b);
        return a;
    }, {});
}
function $cb5704f276528297$export$1eac5cf31c6aee74(array, k1, k2, k3) {
    return array.reduce((a, b)=>{
        a[b[k1]] ??= {};
        a[b[k1]][b[k2]] ??= {};
        a[b[k1]][b[k2]][b[k3]] ??= b;
        return a;
    }, {});
}
function $cb5704f276528297$export$c6d5318223f85e84(array, property) {
    if (!array) return array;
    for (const item of array)item[property] ??= [];
    return array;
}


function $50ac586a47aeec42$export$d9ffdbc590df6d8a(a, b, locale = 'en') {
    return a.localeCompare(b, locale, {
        sensitivity: 'base'
    }) === 0;
}
function $50ac586a47aeec42$export$d8dd5bf0f45452aa(a, b, locale = 'en') {
    return a.localeCompare(b, locale, {
        sensitivity: 'base'
    });
}


// @ts-expect-error
/**
 * Copyright (C) 2017-present by Andrea Giammarchi - @WebReflection
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ const { replace: $a407f9e3395b9e28$var$replace } = '';
// escape
const $a407f9e3395b9e28$var$es = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
const $a407f9e3395b9e28$var$ca = /[&<>'"]/g;
const $a407f9e3395b9e28$var$esca = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;'
};
const $a407f9e3395b9e28$var$pe = (m)=>$a407f9e3395b9e28$var$esca[m];
const $a407f9e3395b9e28$export$4e7f196112fea3c5 = (es)=>$a407f9e3395b9e28$var$replace.call(es, $a407f9e3395b9e28$var$ca, $a407f9e3395b9e28$var$pe);
// unescape
const $a407f9e3395b9e28$var$unes = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"'
};
const $a407f9e3395b9e28$var$cape = (m)=>$a407f9e3395b9e28$var$unes[m];
const $a407f9e3395b9e28$export$e8bacd2802a88316 = (un)=>$a407f9e3395b9e28$var$replace.call(un, $a407f9e3395b9e28$var$es, $a407f9e3395b9e28$var$cape);


const $f4d1565f2a6712b7$export$acafce1f52201e8f = (0, $a407f9e3395b9e28$export$4e7f196112fea3c5);
const $f4d1565f2a6712b7$var$TEMPLATE_RESULT = Symbol.for('cumulus.templates.result');
const $f4d1565f2a6712b7$var$UNSAFE_HTML = Symbol.for('cumulus.templates.unsafe-html');
function $f4d1565f2a6712b7$export$6b6d145ec2a44ca9(value) {
    return value?.[$f4d1565f2a6712b7$var$TEMPLATE_RESULT] === true;
}
function $f4d1565f2a6712b7$export$1c5c14473d9c43aa(value) {
    return value?.[$f4d1565f2a6712b7$var$UNSAFE_HTML] === true;
}
/*#__NO_SIDE_EFFECTS__*/ function $f4d1565f2a6712b7$export$c0bb0b647f701bb5(strings, ...values) {
    return {
        [$f4d1565f2a6712b7$var$TEMPLATE_RESULT]: true,
        strings: strings,
        values: values
    };
}
function $f4d1565f2a6712b7$export$b3890eb0ae9dca99(value) {
    if (value === null || value === undefined || value === '') return '';
    if (Array.isArray(value)) {
        let result = '';
        for (const item of value)result += $f4d1565f2a6712b7$export$b3890eb0ae9dca99(item);
        return result;
    }
    if ($f4d1565f2a6712b7$export$6b6d145ec2a44ca9(value)) {
        const { strings: strings, values: values } = value;
        let result = strings[0];
        for(let i = 1; i < strings.length; i++){
            const value = values[i - 1];
            result += $f4d1565f2a6712b7$export$b3890eb0ae9dca99(value);
            result += strings[i];
        }
        return result;
    }
    if ($f4d1565f2a6712b7$export$1c5c14473d9c43aa(value)) return value.value;
    if (typeof value === 'function') throw new Error(`Cannot render function "${value.name}"\n${value.toString()}`);
    return $f4d1565f2a6712b7$export$acafce1f52201e8f(typeof value === 'string' ? value : String(value));
}
function $f4d1565f2a6712b7$export$b6e69390c23686fb(value) {
    return {
        [$f4d1565f2a6712b7$var$UNSAFE_HTML]: true,
        value: typeof value === 'string' ? value : String(value)
    };
}
function $f4d1565f2a6712b7$export$7aabe8b3a840d2fd(name, value) {
    return value === null || value === undefined || value === '' ? '' : {
        [$f4d1565f2a6712b7$var$UNSAFE_HTML]: true,
        value: `${$f4d1565f2a6712b7$export$acafce1f52201e8f(name)}="${$f4d1565f2a6712b7$export$acafce1f52201e8f(value)}"`
    };
}
function $f4d1565f2a6712b7$export$65c20e333206336e(name, value) {
    return Boolean(value) ? {
        [$f4d1565f2a6712b7$var$UNSAFE_HTML]: true,
        value: $f4d1565f2a6712b7$export$acafce1f52201e8f(name)
    } : '';
} /*
export function renderStream(value: unknown): ReadableStream<Uint8Array> {
  const abortController = new AbortController();
  return new ReadableStream<Uint8Array>({
    async start(controller) {
      const encoder = new TextEncoder();
      await pushValue(value, controller, encoder, abortController.signal);
      controller.close();
    },
    cancel() {
      abortController.abort();
    }
  });
}

async function pushValue(
  value: unknown,
  controller: ReadableStreamController<Uint8Array>,
  encoder: TextEncoder,
  signal: AbortSignal
): Promise<void> {
  if (value === null || value === undefined || value === '' || signal.aborted) {
    return;
  } else if (Array.isArray(value)) {
    for (let i = 0; i < value.length && !signal.aborted; i++) {
      await pushValue(value[i], controller, encoder, signal);
    }
  } else if (isTemplateResult(value)) {
    const { strings, values } = value;
    controller.enqueue(encoder.encode(strings[0]));
    for (let i = 1; i < strings.length; i++) {
      const value = values[i - 1];
      await pushValue(value, controller, encoder, signal);
      controller.enqueue(encoder.encode(strings[i]));
    }
  } else if (value instanceof UnsafeHTML) {
    controller.enqueue(encoder.encode(value.value));
  } else {
    controller.enqueue(
      encoder.encode(
        htmlEncode(typeof value === 'string' ? value : String(value))
      )
    );
  }
}

// async function pushStream(stream: ReadableStream<Uint8Array>, controller: StreamController, cancellationToken: CancellationToken) {
//   const reader = stream.getReader();
//   do {
//     const { value, done } = await reader.read();
//     if (done || cancellationToken.cancelled) {
//       reader.releaseLock();
//       return;
//     }
//     controller.enqueue(value);
//   } while (true);
// }
*/ 


let $65af17b6a828fccf$var$elementId = 0;
const $65af17b6a828fccf$var$prefix = 'document' in self ? 'c' : 's';
function $65af17b6a828fccf$export$9e1c824dbb29e809() {
    if ($65af17b6a828fccf$var$elementId > 99999) $65af17b6a828fccf$var$elementId = 0;
    const time = Date.now().toString().substr(7);
    return `${$65af17b6a828fccf$var$prefix}-${time}-${$65af17b6a828fccf$var$elementId++}`;
}


const $84c634e688af79ca$export$8e47d324a7a20b30 = `<path fill-rule="evenodd" d="M8.22 1.754a.25.25 0 00-.44 0L1.698 13.132a.25.25 0 00.22.368h12.164a.25.25 0 00.22-.368L8.22 1.754zm-1.763-.707c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0114.082 15H1.918a1.75 1.75 0 01-1.543-2.575L6.457 1.047zM9 11a1 1 0 11-2 0 1 1 0 012 0zm-.25-5.25a.75.75 0 00-1.5 0v2.5a.75.75 0 001.5 0v-2.5z"></path>`;
const $84c634e688af79ca$export$8876d4884ff726da = `<path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"/><path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466"/>`;
const $84c634e688af79ca$export$72f74af526a6ffa1 = `<path fill-rule="evenodd" d="M13.03 8.22a.75.75 0 010 1.06l-4.25 4.25a.75.75 0 01-1.06 0L3.47 9.28a.75.75 0 011.06-1.06l2.97 2.97V3.75a.75.75 0 011.5 0v7.44l2.97-2.97a.75.75 0 011.06 0z"></path>`;
const $84c634e688af79ca$export$b33367dcc885f1a3 = `<path d="M7.78 12.53a.75.75 0 0 1-1.06 0L2.47 8.28a.75.75 0 0 1 0-1.06l4.25-4.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L4.81 7h7.44a.75.75 0 0 1 0 1.5H4.81l2.97 2.97a.75.75 0 0 1 0 1.06Z"></path>`;
const $84c634e688af79ca$export$767fa712cf880535 = `<path xmlns="http://www.w3.org/2000/svg" d="M1.078 4A8.05 8.05 0 0 1 4 1.078 7.77 7.77 0 0 1 8 0a7.782 7.782 0 0 1 4.008 1.078A8.061 8.061 0 0 1 14.922 4 7.778 7.778 0 0 1 16 8a7.778 7.778 0 0 1-1.078 4.008 8.061 8.061 0 0 1-2.914 2.914A7.782 7.782 0 0 1 8 16a7.77 7.77 0 0 1-4-1.078A8.05 8.05 0 0 1 1.078 12.008 7.778 7.778 0 0 1 0 8a7.778 7.778 0 0 1 1.078-4ZM2.464 11.2A6.429 6.429 0 0 0 4.8 13.534 6.189 6.189 0 0 0 8 14.4a6.192 6.192 0 0 0 3.2-.864A6.461 6.461 0 0 0 13.534 11.2 6.219 6.219 0 0 0 14.4 8a6.219 6.219 0 0 0-.864-3.2A6.474 6.474 0 0 0 11.2 2.466 6.208 6.208 0 0 0 8 1.6a6.203 6.203 0 0 0-3.2.864A6.424 6.424 0 0 0 2.466 4.8 6.189 6.189 0 0 0 1.6 8a6.202 6.202 0 0 0 .864 3.2Zm4.176-6.162a.8.8 0 1 1 1.12 1.12L6.72 7.2H11.2a.8.8 0 0 1 0 1.6H6.72l1.038 1.038a.792.792 0 0 1 0 1.12.846 .846 0 0 1-.266.179A.763.763 0 0 1 7.2 11.2a.779.779 0 0 1-.306-.062.763 .763 0 0 1-.258-.179l-2.4-2.4a.8.8 0 0 1 0-1.12Z"/>`;
const $84c634e688af79ca$export$5df4efc90df1058f = `<path d="M8.22 2.97a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l2.97-2.97H3.75a.75.75 0 0 1 0-1.5h7.44L8.22 4.03a.75.75 0 0 1 0-1.06Z"></path>`;
const $84c634e688af79ca$export$9dd82c5e7dc8bd87 = `<path d="M5.22 14.78a.75.75 0 001.06-1.06L4.56 12h8.69a.75.75 0 000-1.5H4.56l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3a.75.75 0 000 1.06l3 3zm5.56-6.5a.75.75 0 11-1.06-1.06l1.72-1.72H2.75a.75.75 0 010-1.5h8.69L9.72 2.28a.75.75 0 011.06-1.06l3 3a.75.75 0 010 1.06l-3 3z"></path>`;
const $84c634e688af79ca$export$1941eca25e93ddb7 = `<path d="M7.28033 3.21967C6.98744 2.92678 6.51256 2.92678 6.21967 3.21967C5.92678 3.51256 5.92678 3.98744 6.21967 4.28033L7.28033 3.21967ZM11 8L11.5303 8.53033C11.8232 8.23744 11.8232 7.76256 11.5303 7.46967L11 8ZM6.21967 11.7197C5.92678 12.0126 5.92678 12.4874 6.21967 12.7803C6.51256 13.0732 6.98744 13.0732 7.28033 12.7803L6.21967 11.7197ZM6.21967 4.28033L10.4697 8.53033L11.5303 7.46967L7.28033 3.21967L6.21967 4.28033ZM10.4697 7.46967L6.21967 11.7197L7.28033 12.7803L11.5303 8.53033L10.4697 7.46967Z" fill="currentColor"></path>        <path d="M1.75 8H11" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"></path>`;
const $84c634e688af79ca$export$ea7efdf5db05b94a = `<path fill-rule="evenodd" d="M3.47 7.78a.75.75 0 010-1.06l4.25-4.25a.75.75 0 011.06 0l4.25 4.25a.75.75 0 01-1.06 1.06L9 4.81v7.44a.75.75 0 01-1.5 0V4.81L4.53 7.78a.75.75 0 01-1.06 0z"></path>`;
const $84c634e688af79ca$export$1d14184fc69e8cc4 = `<path d="m14.12 7.66.38-.4zm-.33-1.44-.51-.19zm-.55 5.3-.18-.51zm-10.48 0-.17.53zm.92 1.16-.54.06zm-1.8-5.02-.39-.4zm9.44-4.55-.07-.54zm1.2-.14-.07-.54zm2.46 5.54.38-.4zm-.6 2.63.18.51zm-2.2 2.74.55.06zm-2.42 1.18-.3.46zm-8.14-3.92-.18.51zm-.6-2.63-.39-.4zm.78-3.43-.51.18zm7.08-3.35.64 1.03.93-.58-.64-1.02zm4.86 6.32.85.85.77-.78-.86-.85zm.46 2.57-1.14.39.35 1.04 1.15-.4zm-7.23 3.32-1.02.65.59.93 1.01-.65zm-2.61-.11-.13-1.2-1.1.11.14 1.2zm-1.64-7.8-.4-1.13-1.03.36.4 1.14zm.7-2.52 1.2.15.13-1.09-1.2-.14zm7.96.15 1.2-.15-.13-1.08-1.2.14zm2.3 1.24-.4 1.13 1.03.37.4-1.14zm-1.9 7.73-.14 1.2 1.1.11.12-1.2zm-1.73 1.96-1.02-.65-.59.93 1.02.65zm-7.11-3.58-1.14-.4-.36 1.04 1.15.4zM1.4 8.9l.86-.85-.77-.78-.85.85zm5.08-6.14.64-1.03-.94-.57-.63 1.02zm3.04 0c1.19 1.92 2.6 3.7 4.22 5.29l.76-.78a27.47 27.47 0 0 1-4.05-5.09zm3.76 3.27a28.56 28.56 0 0 0-1.5 6.6l1.08.11c.23-2.16.71-4.29 1.45-6.34zm-.22 4.98a28.57 28.57 0 0 0-6.1 2.93l.6.93a27.46 27.46 0 0 1 5.85-2.82zm-4.03 2.93a28.56 28.56 0 0 0-6.09-2.93l-.35 1.04c2.05.7 4.02 1.65 5.85 2.82zm-4.8-1.31a28.57 28.57 0 0 0-1.5-6.6l-1.04.37a27.47 27.47 0 0 1 1.45 6.34zM2.26 8.05a28.57 28.57 0 0 0 4.22-5.29l-.93-.58a27.47 27.47 0 0 1-4.06 5.09zm2.36-4.4c2.24.27 4.51.27 6.76 0l-.13-1.08c-2.16.26-4.34.26-6.5 0zm7.96-.14c.77-.09 1.36.66 1.1 1.39l1.03.36a2.13 2.13 0 0 0-2.26-2.83zm2.01 5.39c.55.54.34 1.47-.39 1.72l.36 1.03a2.13 2.13 0 0 0 .8-3.53zm-2.95 4.93a1.04 1.04 0 0 1-1.59.76l-.59.93c1.34.85 3.1 0 3.27-1.58zm-5.7.76c-.64.42-1.5 0-1.58-.76l-1.1.11a2.13 2.13 0 0 0 3.28 1.58zM1.8 10.62a1.04 1.04 0 0 1-.4-1.72l-.76-.78a2.13 2.13 0 0 0 .8 3.53zm.52-5.72a1.04 1.04 0 0 1 1.1-1.39l.13-1.08a2.13 2.13 0 0 0-2.26 2.83zm7.5-3.74a2.13 2.13 0 0 0-3.64 0l.94.57c.4-.65 1.36-.65 1.76 0z"/>`; // fill="url(#a)"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="matrix(0 8.0923 -8.3005 0 8 8.34)" gradientUnits="userSpaceOnUse"><stop stop-color="color(display-p3 0.5783 0.7961 1.0000)" offset=".08"/><stop stop-color="#fff" offset=".22"/><stop stop-color="color(display-p3 1.0000 0.5647 0.0157)" offset=".5"/><stop stop-color="color(display-p3 1.0000 0.1804 0.3294)" offset=".64"/><stop stop-color="color(display-p3 0.7882 0.3490 0.8667)" offset=".79"/><stop stop-color="color(display-p3 0.3652 0.4097 1.0000)" offset=".93"/><stop stop-color="color(display-p3 0.0314 0.5804 1.0000)" offset="1"/></radialGradient></defs>`;
const $84c634e688af79ca$export$5a60ac14d02c69a0 = `<path d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"/>`;
const $84c634e688af79ca$export$5cba54f8115c472e = `<path d="m8 0 6.61 3h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.38l.5 2a.498.498 0 0 1-.485.62H.5a.498.498 0 0 1-.485-.62l.5-2A.5.5 0 0 1 1 13V6H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 3h.89zM3.777 3h8.447L8 1zM2 6v7h1V6zm2 0v7h2.5V6zm3.5 0v7h1V6zm2 0v7H12V6zM13 6v7h1V6zm2-1V4H1v1zm-.39 9H1.39l-.25 1h13.72z"/>`;
const $84c634e688af79ca$export$dba03d59741ce6c8 = `<path d="M8 16c.9 0 1.7-.6 1.9-1.5.1-.3-.1-.5-.4-.5h-3c-.3 0-.5.2-.4.5.2.9 1 1.5 1.9 1.5zM3 5c0-2.8 2.2-5 5-5s5 2.2 5 5v3l1.7 2.6c.2.2.3.5.3.8 0 .8-.7 1.5-1.5 1.5h-11c-.8.1-1.5-.6-1.5-1.4 0-.3.1-.6.3-.8L3 8.1V5z"></path>`;
const $84c634e688af79ca$export$43ae52d85fcc090c = `<path d="M8 16a2 2 0 001.985-1.75c.017-.137-.097-.25-.235-.25h-3.5c-.138 0-.252.113-.235.25A2 2 0 008 16z"></path><path fill-rule="evenodd" d="M8 1.5A3.5 3.5 0 004.5 5v2.947c0 .346-.102.683-.294.97l-1.703 2.556a.018.018 0 00-.003.01l.001.006c0 .002.002.004.004.006a.017.017 0 00.006.004l.007.001h10.964l.007-.001a.016.016 0 00.006-.004.016.016 0 00.004-.006l.001-.007a.017.017 0 00-.003-.01l-1.703-2.554a1.75 1.75 0 01-.294-.97V5A3.5 3.5 0 008 1.5zM3 5a5 5 0 0110 0v2.947c0 .05.015.098.042.139l1.703 2.555A1.518 1.518 0 0113.482 13H2.518a1.518 1.518 0 01-1.263-2.36l1.703-2.554A.25.25 0 003 7.947V5z"></path>`;
const $84c634e688af79ca$export$86c0dcb57a5f8c32 = `<path fill-rule="evenodd" d="M8 1.5c-.997 0-1.895.416-2.534 1.086A.75.75 0 014.38 1.55 5 5 0 0113 5v2.373a.75.75 0 01-1.5 0V5A3.5 3.5 0 008 1.5zM4.182 4.31L1.19 2.143a.75.75 0 10-.88 1.214L3 5.305v2.642a.25.25 0 01-.042.139L1.255 10.64A1.518 1.518 0 002.518 13h11.108l1.184.857a.75.75 0 10.88-1.214l-1.375-.996a1.196 1.196 0 00-.013-.01L4.198 4.321a.733.733 0 00-.016-.011zm7.373 7.19L4.5 6.391v1.556c0 .346-.102.683-.294.97l-1.703 2.556a.018.018 0 00-.003.01.015.015 0 00.005.012.017.017 0 00.006.004l.007.001h9.037zM8 16a2 2 0 001.985-1.75c.017-.137-.097-.25-.235-.25h-3.5c-.138 0-.252.113-.235.25A2 2 0 008 16z"></path>`;
const $84c634e688af79ca$export$66ee21e7ebe4d5a1 = `<path d="M3 2.5A1.5 1.5 0 0 1 4.5 1h1A1.5 1.5 0 0 1 7 2.5V5h2V2.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5v2.382a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V14.5a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 14.5v-3a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5v3A1.5 1.5 0 0 1 5.5 16h-3A1.5 1.5 0 0 1 1 14.5V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V2.5zM4.5 2a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5h-1zM6 4H4v.882a1.5 1.5 0 0 1-.83 1.342l-.894.447A.5.5 0 0 0 2 7.118V13h4v-1.293l-.854-.853A.5.5 0 0 1 5 10.5v-1A1.5 1.5 0 0 1 6.5 8h3A1.5 1.5 0 0 1 11 9.5v1a.5.5 0 0 1-.146.354l-.854.853V13h4V7.118a.5.5 0 0 0-.276-.447l-.895-.447A1.5 1.5 0 0 1 12 4.882V4h-2v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4zm4-1h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3zm4 11h-4v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14zm-8 0H2v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14z"/>`;
const $84c634e688af79ca$export$f65a0a3b7c4c12f8 = `<path fill-rule="evenodd" d="M4 2a1 1 0 00-1 1v10a1 1 0 001 1h5.5a3.5 3.5 0 001.852-6.47A3.5 3.5 0 008.5 2H4zm4.5 5a1.5 1.5 0 100-3H5v3h3.5zM5 9v3h4.5a1.5 1.5 0 000-3H5z"></path>`;
const $84c634e688af79ca$export$f881699598f135c0 = `<path d="M9.5 3.25a2.25 2.25 0 1 1 3 2.122V6A2.5 2.5 0 0 1 10 8.5H6a1 1 0 0 0-1 1v1.128a2.251 2.251 0 1 1-1.5 0V5.372a2.25 2.25 0 1 1 1.5 0v1.836A2.493 2.493 0 0 1 6 7h4a1 1 0 0 0 1-1v-.628A2.25 2.25 0 0 1 9.5 3.25Zm-6 0a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Zm8.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"></path>`;
const $84c634e688af79ca$export$a3176a3f11884722 = `<path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434L7.752.066ZM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567L4.25 7.504ZM7.5 9.933l-2.75 1.571v3.134l2.75-1.571V9.933Zm1 3.134 2.75 1.571v-3.134L8.5 9.933v3.134Zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567-2.742 1.567Zm2.242-2.433V3.504L8.5 5.076V8.21l2.75-1.572ZM7.5 8.21V5.076L4.75 3.504v3.134L7.5 8.21ZM5.258 2.643 8 4.21l2.742-1.567L8 1.076 5.258 2.643ZM15 9.933l-2.75 1.571v3.134L15 13.067V9.933ZM3.75 14.638v-3.134L1 9.933v3.134l2.75 1.571Z"/>`;
const $84c634e688af79ca$export$911e1c2902df2f21 = `<path d="M4.72.22a.75.75 0 0 1 1.06 0l1 .999a3.488 3.488 0 0 1 2.441 0l.999-1a.748.748 0 0 1 1.265.332.75.75 0 0 1-.205.729l-.775.776c.616.63.995 1.493.995 2.444v.327c0 .1-.009.197-.025.292.408.14.764.392 1.029.722l1.968-.787a.75.75 0 0 1 .556 1.392L13 7.258V9h2.25a.75.75 0 0 1 0 1.5H13v.5c0 .409-.049.806-.141 1.186l2.17.868a.75.75 0 0 1-.557 1.392l-2.184-.873A4.997 4.997 0 0 1 8 16a4.997 4.997 0 0 1-4.288-2.427l-2.183.873a.75.75 0 0 1-.558-1.392l2.17-.868A5.036 5.036 0 0 1 3 11v-.5H.75a.75.75 0 0 1 0-1.5H3V7.258L.971 6.446a.75.75 0 0 1 .558-1.392l1.967.787c.265-.33.62-.583 1.03-.722a1.677 1.677 0 0 1-.026-.292V4.5c0-.951.38-1.814.995-2.444L4.72 1.28a.75.75 0 0 1 0-1.06Zm.53 6.28a.75.75 0 0 0-.75.75V11a3.5 3.5 0 1 0 7 0V7.25a.75.75 0 0 0-.75-.75ZM6.173 5h3.654A.172.172 0 0 0 10 4.827V4.5a2 2 0 1 0-4 0v.327c0 .096.077.173.173.173Z"></path>`;
const $84c634e688af79ca$export$2809c772b85876db = `<path fill-rule="evenodd" d="M12 1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z" /><path d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4z" />`;
const $84c634e688af79ca$export$2daa3271a740c7f = `<path fill-rule="evenodd" d="M4.75 0a.75.75 0 01.75.75V2h5V.75a.75.75 0 011.5 0V2h1.25c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0113.25 16H2.75A1.75 1.75 0 011 14.25V3.75C1 2.784 1.784 2 2.75 2H4V.75A.75.75 0 014.75 0zm0 3.5h8.5a.25.25 0 01.25.25V6h-11V3.75a.25.25 0 01.25-.25h2zm-2.25 4v6.75c0 .138.112.25.25.25h10.5a.25.25 0 00.25-.25V7.5h-11z"></path>`;
const $84c634e688af79ca$export$cfe4c2456a8e9cec = `<path fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0zM0 8a8 8 0 1116 0A8 8 0 010 8zm11.78-1.72a.75.75 0 00-1.06-1.06L6.75 9.19 5.28 7.72a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l4.5-4.5z"></path>`;
const $84c634e688af79ca$export$1d8a03084661a191 = `<path clip-rule="evenodd" d="M13.78 4.22C13.9204 4.36062 13.9993 4.55125 13.9993 4.75C13.9993 4.94875 13.9204 5.13937 13.78 5.28L6.53 12.53C6.38937 12.6704 6.19875 12.7493 6 12.7493C5.80125 12.7493 5.61062 12.6704 5.47 12.53L2.22 9.28C2.08752 9.13782 2.0154 8.94978 2.01882 8.75547C2.02225 8.56117 2.10096 8.37579 2.23838 8.23837C2.37579 8.10096 2.56118 8.02225 2.75548 8.01882C2.94978 8.01539 3.13782 8.08752 3.28 8.22L6 10.94L12.72 4.22C12.8606 4.07955 13.0512 4.00066 13.25 4.00066C13.4487 4.00066 13.6394 4.07955 13.78 4.22Z" fill-rule="evenodd"></path>`;
const $84c634e688af79ca$export$6c57c2db28ec0463 = `<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z"/>`;
const $84c634e688af79ca$export$67ff0f0b11735e67 = `<path d="M12.78 5.22a.749.749 0 0 1 0 1.06l-4.25 4.25a.749.749 0 0 1-1.06 0L3.22 6.28a.749.749 0 1 1 1.06-1.06L8 8.939l3.72-3.719a.749.749 0 0 1 1.06 0Z"></path>`;
const $84c634e688af79ca$export$36dd5cc8453b5c87 = `<path d="M9.78 12.78a.75.75 0 0 1-1.06 0L4.47 8.53a.75.75 0 0 1 0-1.06l4.25-4.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L6.06 8l3.72 3.72a.75.75 0 0 1 0 1.06Z"></path>`;
const $84c634e688af79ca$export$891852c7bf1ca2c1 = `<path d="M6.22 3.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L9.94 8 6.22 4.28a.75.75 0 0 1 0-1.06Z"></path>`;
const $84c634e688af79ca$export$8f4ec4b8fe2dedbf = `<path fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 0110.535-5.096l-9.131 9.131A6.472 6.472 0 011.5 8zm2.465 5.096a6.5 6.5 0 009.131-9.131l-9.131 9.131zM8 0a8 8 0 100 16A8 8 0 008 0z"></path>`;
const $84c634e688af79ca$export$13eb9e240027a87f = `<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333" d="M6 1.667h4c.37 0 .666.297.666.666v1.334c0 .369-.297.666-.666.666H6a.665.665 0 0 1-.667-.666V2.333c0-.369.298-.666.667-.666M14.666 11a4 4 0 0 1-4 4 4 4 0 0 1-4-4 4 4 0 0 1 4-4 4 4 0 0 1 4 4M5.333 3H4a1.333 1.333 0 0 0-1.333 1.333v9.333A1.333 1.333 0 0 0 4 15h1.333m5.333-12H12a1.333 1.333 0 0 1 1.333 1.333v.555m-2.667 4.778v1.467l1.067.667"/>`;
const $84c634e688af79ca$export$def956fbe4c089ce = `<path d="M8 0a8 8 0 110 16A8 8 0 018 0zM1.5 8a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0zm7-3.25v2.992l2.028.812a.75.75 0 01-.557 1.392l-2.5-1A.751.751 0 017 8.25v-3.5a.75.75 0 011.5 0z"></path>`;
const $84c634e688af79ca$export$8df73a8168f3e24 = `<path fill-rule="evenodd" d="M4.72 3.22a.75.75 0 011.06 1.06L2.06 8l3.72 3.72a.75.75 0 11-1.06 1.06L.47 8.53a.75.75 0 010-1.06l4.25-4.25zm6.56 0a.75.75 0 10-1.06 1.06L13.94 8l-3.72 3.72a.75.75 0 101.06 1.06l4.25-4.25a.75.75 0 000-1.06l-4.25-4.25z"></path>`;
const $84c634e688af79ca$export$567379feebbba9f8 = `<path fill-rule="evenodd" d="M2 1.75C2 .784 2.784 0 3.75 0h8.5C13.216 0 14 .784 14 1.75v5a1.75 1.75 0 01-1.75 1.75h-8.5A1.75 1.75 0 012 6.75v-5zm1.75-.25a.25.25 0 00-.25.25v5c0 .138.112.25.25.25h8.5a.25.25 0 00.25-.25v-5a.25.25 0 00-.25-.25h-8.5zM0 11.25c0-.966.784-1.75 1.75-1.75h12.5c.966 0 1.75.784 1.75 1.75v3A1.75 1.75 0 0114.25 16H1.75A1.75 1.75 0 010 14.25v-3zM1.75 11a.25.25 0 00-.25.25v3c0 .138.112.25.25.25h12.5a.25.25 0 00.25-.25v-3a.25.25 0 00-.25-.25H1.75z"></path><path fill-rule="evenodd" d="M3 12.75a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zm4 0a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75z"></path>`;
const $84c634e688af79ca$export$8ce8aa57598ad27f = `<path fill-rule="evenodd" d="M2.75 2.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h2a.75.75 0 01.75.75v2.19l2.72-2.72a.75.75 0 01.53-.22h4.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25H2.75zM1 2.75C1 1.784 1.784 1 2.75 1h10.5c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0113.25 12H9.06l-2.573 2.573A1.457 1.457 0 014 13.543V12H2.75A1.75 1.75 0 011 10.25v-7.5z"></path>`;
const $84c634e688af79ca$export$a3743ca7417fb23c = `<path d="M8 16.016a7.5 7.5 0 0 0 1.962-14.74A1 1 0 0 0 9 0H7a1 1 0 0 0-.962 1.276A7.5 7.5 0 0 0 8 16.016zm6.5-7.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/><path d="m6.94 7.44 4.95-2.83-2.83 4.95-4.949 2.83 2.828-4.95z"/>`;
const $84c634e688af79ca$export$e3d4d49f14b4dd60 = `<path fill-rule="evenodd" d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z"></path><path fill-rule="evenodd" d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0114.25 11h-7.5A1.75 1.75 0 015 9.25v-7.5zm1.75-.25a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25h-7.5z"></path>`;
const $84c634e688af79ca$export$36e22210a5796abb = `<path d="M2 7.75A.75.75 0 0 1 2.75 7h10a.75.75 0 0 1 0 1.5h-10A.75.75 0 0 1 2 7.75Z"></path>`;
const $84c634e688af79ca$export$8b21631039c9cb0f = `<path d="M1.5 3.25c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5A1.75 1.75 0 0 1 5.75 7.5h-2.5A1.75 1.75 0 0 1 1.5 5.75Zm7 0c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5A1.75 1.75 0 0 1 8.5 5.75Zm-7 7c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5a1.75 1.75 0 0 1-1.75-1.75Zm7 0c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5a1.75 1.75 0 0 1-1.75-1.75ZM3.25 3a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5A.25.25 0 0 0 6 5.75v-2.5A.25.25 0 0 0 5.75 3Zm7 0a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm-7 7a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm7 0a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Z"></path>`;
const $84c634e688af79ca$export$83e001942a7b7758 = `<path d="M16 3.75v8.5a.75.75 0 0 1-1.136.643L11 10.575v.675A1.75 1.75 0 0 1 9.25 13h-7.5A1.75 1.75 0 0 1 0 11.25v-6.5C0 3.784.784 3 1.75 3h7.5c.966 0 1.75.784 1.75 1.75v.675l3.864-2.318A.75.75 0 0 1 16 3.75Zm-6.5 1a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25v6.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-6.5ZM11 8.825l3.5 2.1v-5.85l-3.5 2.1Z"></path>`;
const $84c634e688af79ca$export$c68ffe5314f9c2ba = `<path d="M13.25 1c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.75 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Zm9.03 6.03-3.25 3.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l1.97-1.97H4.75a.75.75 0 0 1 0-1.5h4.69L7.47 5.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l3.25 3.25a.75.75 0 0 1 0 1.06Z"></path>`;
const $84c634e688af79ca$export$33eb75283052a3f = `<path d="M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z"></path><path d="M7.25 7.689V2a.75.75 0 0 1 1.5 0v5.689l1.97-1.969a.749.749 0 1 1 1.06 1.06l-3.25 3.25a.749.749 0 0 1-1.06 0L4.22 6.78a.749.749 0 1 1 1.06-1.06l1.97 1.969Z"></path>`;
const $84c634e688af79ca$export$3b2c6f2708eaa4f9 = `<path d="M10.5 3a.75.75 0 0 1 .75.75v1h1a.75.75 0 0 1 0 1.5h-1v1a.75.75 0 0 1-1.5 0v-1h-1a.75.75 0 0 1 0-1.5h1v-1A.75.75 0 0 1 10.5 3Z"></path><path d="M6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25v-7.5C5 .784 5.784 0 6.75 0ZM6.5 1.75v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25Z"></path><path d="M1.75 5A1.75 1.75 0 0 0 0 6.75v7.5C0 15.216.784 16 1.75 16h7.5A1.75 1.75 0 0 0 11 14.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.25.25 0 0 1-.25.25h-7.5a.25.25 0 0 1-.25-.25v-7.5a.25.25 0 0 1 .25-.25h1.5a.75.75 0 0 0 0-1.5h-1.5Z"></path>`;
const $84c634e688af79ca$export$eea9d1a211eff38f = `<path d="M7.5 5.5a.5.5 0 0 0-1 0v.634l-.549-.317a.5.5 0 1 0-.5.866L6 7l-.549.317a.5.5 0 1 0 .5.866l.549-.317V8.5a.5.5 0 1 0 1 0v-.634l.549.317a.5.5 0 1 0 .5-.866L8 7l.549-.317a.5.5 0 1 0-.5-.866l-.549.317V5.5zm-2 4.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>`;
const $84c634e688af79ca$export$be704fe733d78a38 = `<path d="M8 2c1.981 0 3.671.992 4.933 2.078 1.27 1.091 2.187 2.345 2.637 3.023a1.62 1.62 0 0 1 0 1.798c-.45.678-1.367 1.932-2.637 3.023C11.67 13.008 9.981 14 8 14c-1.981 0-3.671-.992-4.933-2.078C1.797 10.83.88 9.576.43 8.898a1.62 1.62 0 0 1 0-1.798c.45-.677 1.367-1.931 2.637-3.022C4.33 2.992 6.019 2 8 2ZM1.679 7.932a.12.12 0 0 0 0 .136c.411.622 1.241 1.75 2.366 2.717C5.176 11.758 6.527 12.5 8 12.5c1.473 0 2.825-.742 3.955-1.715 1.124-.967 1.954-2.096 2.366-2.717a.12.12 0 0 0 0-.136c-.412-.621-1.242-1.75-2.366-2.717C10.824 4.242 9.473 3.5 8 3.5c-1.473 0-2.825.742-3.955 1.715-1.124.967-1.954 2.096-2.366 2.717ZM8 10a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 10Z"></path>`;
const $84c634e688af79ca$export$a2782246c1b1e1a5 = `<path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/><path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>`;
const $84c634e688af79ca$export$cb08b2e60a71aacf = `<path d="M.75 3h14.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5ZM3 7.75A.75.75 0 0 1 3.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 7.75Zm3 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"></path>`;
const $84c634e688af79ca$export$f4b1aa0400680e2f = `<path fill-rule="evenodd" d="M7.998 14.5c2.832 0 5-1.98 5-4.5 0-1.463-.68-2.19-1.879-3.383l-.036-.037c-1.013-1.008-2.3-2.29-2.834-4.434-.322.256-.63.579-.864.953-.432.696-.621 1.58-.046 2.73.473.947.67 2.284-.278 3.232-.61.61-1.545.84-2.403.633a2.788 2.788 0 01-1.436-.874A3.21 3.21 0 003 10c0 2.53 2.164 4.5 4.998 4.5zM9.533.753C9.496.34 9.16.009 8.77.146 7.035.75 4.34 3.187 5.997 6.5c.344.689.285 1.218.003 1.5-.419.419-1.54.487-2.04-.832-.173-.454-.659-.762-1.035-.454C2.036 7.44 1.5 8.702 1.5 10c0 3.512 2.998 6 6.498 6s6.5-2.5 6.5-6c0-2.137-1.128-3.26-2.312-4.438-1.19-1.184-2.436-2.425-2.653-4.81z"></path>`;
const $84c634e688af79ca$export$3788094f5c0d6ccf = `<path d="M4 0h5.5v1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h1V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z" /><path d="M9.5 3V0L14 4.5h-3A1.5 1.5 0 0 1 9.5 3z" /><path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z" />`;
const $84c634e688af79ca$export$58f014c1d6cdb999 = `<path d="M4 0h5.5v1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h1V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z" /><path d="M9.5 3V0L14 4.5h-3A1.5 1.5 0 0 1 9.5 3z" />`;
const $84c634e688af79ca$export$14c8aea1bc42f2e9 = `<path d="M8.753 1.502C7.07.24 4.659 1.347 4.519 3.445L4.449 4.5H3.75a.75.75 0 0 0 0 1.5h.598l-.42 6.293a1.25 1.25 0 0 1-1.674 1.092l-.247-.09a.75.75 0 0 0-.513 1.41l.248.09a2.75 2.75 0 0 0 3.683-2.402L5.852 6H7.25a.75.75 0 1 0 0-1.5H5.952l.063-.955a1.15 1.15 0 0 1 1.838-.843l.197.148a.75.75 0 1 0 .9-1.2l-.197-.148Z"/><path d="M9.636 7.665a1.5 1.5 0 0 0-2.338-.274l-.328.328a.75.75 0 0 0 1.06 1.06l.329-.328l1.192 1.937L7.22 12.72a.75.75 0 0 0 1.06 1.06l2.079-2.078l1.005 1.633a1.5 1.5 0 0 0 2.338.274l.328-.328a.75.75 0 0 0-1.06-1.06l-.329.328l-1.192-1.937L13.78 8.28a.75.75 0 0 0-1.06-1.06l-2.08 2.077l-1.004-1.632Z"/>`;
const $84c634e688af79ca$export$9c13049f489fa947 = `<path fill-rule="evenodd" d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.057.09V14l.002.008a.147.147 0 0 0 .016.033.617.617 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.619.619 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411z"/>`;
const $84c634e688af79ca$export$d223a75748fa80b3 = `<ellipse cx="7.903" cy="13.948" fill="none" stroke="currentColor" stroke-dasharray="1.13560998,3.40682995" stroke-dashoffset=".568" stroke-linecap="round" stroke-width="1.136" rx="6.432" ry="1.516"/><path fill="currentColor" d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4 4a4 4 0 1 1 4.5 3.969v5.53a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 4Z"/>`;
const $84c634e688af79ca$export$76b310fddb8e746f = `<path d="M11.93 8.5a4.002 4.002 0 0 1-7.86 0H.75a.75.75 0 0 1 0-1.5h3.32a4.002 4.002 0 0 1 7.86 0h3.32a.75.75 0 0 1 0 1.5Zm-1.43-.75a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"></path>`;
const $84c634e688af79ca$export$2034a2589eecaa5c = `<path fill-rule="evenodd" d="M1.543 7.25h2.733c.144-2.074.866-3.756 1.58-4.948.12-.197.237-.381.353-.552a6.506 6.506 0 00-4.666 5.5zm2.733 1.5H1.543a6.506 6.506 0 004.666 5.5 11.13 11.13 0 01-.352-.552c-.715-1.192-1.437-2.874-1.581-4.948zm1.504 0h4.44a9.637 9.637 0 01-1.363 4.177c-.306.51-.612.919-.857 1.215a9.978 9.978 0 01-.857-1.215A9.637 9.637 0 015.78 8.75zm4.44-1.5H5.78a9.637 9.637 0 011.363-4.177c.306-.51.612-.919.857-1.215.245.296.55.705.857 1.215A9.638 9.638 0 0110.22 7.25zm1.504 1.5c-.144 2.074-.866 3.756-1.58 4.948-.12.197-.237.381-.353.552a6.506 6.506 0 004.666-5.5h-2.733zm2.733-1.5h-2.733c-.144-2.074-.866-3.756-1.58-4.948a11.738 11.738 0 00-.353-.552 6.506 6.506 0 014.666 5.5zM8 0a8 8 0 100 16A8 8 0 008 0z"></path>`;
const $84c634e688af79ca$export$bc99159476d1c08f = `<path d="M6.368 1.01a.75.75 0 0 1 .623.859L6.57 4.5h3.98l.46-2.868a.75.75 0 0 1 1.48.237L12.07 4.5h2.18a.75.75 0 0 1 0 1.5h-2.42l-.64 4h2.56a.75.75 0 0 1 0 1.5h-2.8l-.46 2.869a.75.75 0 0 1-1.48-.237l.42-2.632H5.45l-.46 2.869a.75.75 0 0 1-1.48-.237l.42-2.632H1.75a.75.75 0 0 1 0-1.5h2.42l.64-4H2.25a.75.75 0 0 1 0-1.5h2.8l.46-2.868a.75.75 0 0 1 .858-.622ZM9.67 10l.64-4H6.33l-.64 4Z"></path>`;
const $84c634e688af79ca$export$4830e9f92637a709 = `<path fill-rule="evenodd" d="M3.75 2a.75.75 0 01.75.75V7h7V2.75a.75.75 0 011.5 0v10.5a.75.75 0 01-1.5 0V8.5h-7v4.75a.75.75 0 01-1.5 0V2.75A.75.75 0 013.75 2z"></path>`;
const $84c634e688af79ca$export$e672bf1c583698d3 = `<path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z"/>`;
const $84c634e688af79ca$export$9a0f5eb7ce2df097 = `<path fill-rule="evenodd" d="M1.643 3.143L.427 1.927A.25.25 0 000 2.104V5.75c0 .138.112.25.25.25h3.646a.25.25 0 00.177-.427L2.715 4.215a6.5 6.5 0 11-1.18 4.458.75.75 0 10-1.493.154 8.001 8.001 0 101.6-5.684zM7.75 4a.75.75 0 01.75.75v2.992l2.028.812a.75.75 0 01-.557 1.392l-2.5-1A.75.75 0 017 8.25v-3.5A.75.75 0 017.75 4z"></path>`;
const $84c634e688af79ca$export$2e2deae5fbafd37b = `<path fill-rule="evenodd" d="M8.156 1.835a.25.25 0 00-.312 0l-5.25 4.2a.25.25 0 00-.094.196v7.019c0 .138.112.25.25.25H5.5V8.25a.75.75 0 01.75-.75h3.5a.75.75 0 01.75.75v5.25h2.75a.25.25 0 00.25-.25V6.23a.25.25 0 00-.094-.195l-5.25-4.2zM6.906.664a1.75 1.75 0 012.187 0l5.25 4.2c.415.332.657.835.657 1.367v7.019A1.75 1.75 0 0113.25 15h-3.5a.75.75 0 01-.75-.75V9H7v5.25a.75.75 0 01-.75.75h-3.5A1.75 1.75 0 011 13.25V6.23c0-.531.242-1.034.657-1.366l5.25-4.2h-.001z"></path>`;
const $84c634e688af79ca$export$b05b37ff29d42ab7 = `<path d="M2.75 1h10.5a.75.75 0 0 1 0 1.5h-.75v1.25a4.75 4.75 0 0 1-1.9 3.8l-.333.25a.25.25 0 0 0 0 .4l.333.25a4.75 4.75 0 0 1 1.9 3.8v1.25h.75a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5h.75v-1.25a4.75 4.75 0 0 1 1.9-3.8l.333-.25a.25.25 0 0 0 0-.4L5.4 7.55a4.75 4.75 0 0 1-1.9-3.8V2.5h-.75a.75.75 0 0 1 0-1.5ZM11 2.5H5v1.25c0 1.023.482 1.986 1.3 2.6l.333.25c.934.7.934 2.1 0 2.8l-.333.25a3.251 3.251 0 0 0-1.3 2.6v1.25h6v-1.25a3.251 3.251 0 0 0-1.3-2.6l-.333-.25a1.748 1.748 0 0 1 0-2.8l.333-.25a3.251 3.251 0 0 0 1.3-2.6Z"></path>`;
const $84c634e688af79ca$export$9f7f274a907ba860 = `<path d="M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v9.5A1.75 1.75 0 0 1 14.25 13H8.06l-2.573 2.573A1.458 1.458 0 0 1 3 14.543V13H1.75A1.75 1.75 0 0 1 0 11.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm7 2.25v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"></path>`;
const $84c634e688af79ca$export$c0d9370d587dcb77 = `<path fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8zm6.5-.25A.75.75 0 017.25 7h1a.75.75 0 01.75.75v2.75h.25a.75.75 0 010 1.5h-2a.75.75 0 010-1.5h.25v-2h-.25a.75.75 0 01-.75-.75zM8 6a1 1 0 100-2 1 1 0 000 2z"></path>`;
const $84c634e688af79ca$export$e9d1b3cec68979dc = `<path fill-rule="evenodd" d="M5 2a.5.5 0 0 1 .5-.5c.862 0 1.573.287 2.06.566.174.099.321.198.44.286.119-.088.266-.187.44-.286A4.17 4.17 0 0 1 10.5 1.5a.5.5 0 0 1 0 1c-.638 0-1.177.213-1.564.434a3.5 3.5 0 0 0-.436.294V7.5H9a.5.5 0 0 1 0 1h-.5v4.272c.1.08.248.187.436.294.387.221.926.434 1.564.434a.5.5 0 0 1 0 1 4.17 4.17 0 0 1-2.06-.566A5 5 0 0 1 8 13.65a5 5 0 0 1-.44.285 4.17 4.17 0 0 1-2.06.566.5.5 0 0 1 0-1c.638 0 1.177-.213 1.564-.434.188-.107.335-.214.436-.294V8.5H7a.5.5 0 0 1 0-1h.5V3.228a3.5 3.5 0 0 0-.436-.294A3.17 3.17 0 0 0 5.5 2.5.5.5 0 0 1 5 2"/><path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"/>`;
const $84c634e688af79ca$export$65a1098854778a3f = `<path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2zm5 10v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2v5a2 2 0 0 1-2 2zm6-8V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2V6a2 2 0 0 1 2-2z"/>`;
const $84c634e688af79ca$export$4919767267a253b2 = `<path d="M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z"></path><path fill-rule="evenodd" d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"></path>`;
const $84c634e688af79ca$export$206d84bec3b3a5a = `<path fill-rule="evenodd" d="M6.749.097a8.054 8.054 0 012.502 0 .75.75 0 11-.233 1.482 6.554 6.554 0 00-2.036 0A.75.75 0 016.749.097zM4.345 1.693A.75.75 0 014.18 2.74a6.542 6.542 0 00-1.44 1.44.75.75 0 01-1.212-.883 8.042 8.042 0 011.769-1.77.75.75 0 011.048.166zm7.31 0a.75.75 0 011.048-.165 8.04 8.04 0 011.77 1.769.75.75 0 11-1.214.883 6.542 6.542 0 00-1.439-1.44.75.75 0 01-.165-1.047zM.955 6.125a.75.75 0 01.624.857 6.554 6.554 0 000 2.036.75.75 0 01-1.482.233 8.054 8.054 0 010-2.502.75.75 0 01.858-.624zm14.09 0a.75.75 0 01.858.624 8.057 8.057 0 010 2.502.75.75 0 01-1.482-.233 6.55 6.55 0 000-2.036.75.75 0 01.624-.857zm-13.352 5.53a.75.75 0 011.048.165 6.542 6.542 0 001.439 1.44.75.75 0 01-.883 1.212 8.04 8.04 0 01-1.77-1.769.75.75 0 01.166-1.048zm12.614 0a.75.75 0 01.165 1.048 8.038 8.038 0 01-1.769 1.77.75.75 0 11-.883-1.214 6.543 6.543 0 001.44-1.439.75.75 0 011.047-.165zm-8.182 3.39a.75.75 0 01.857-.624 6.55 6.55 0 002.036 0 .75.75 0 01.233 1.482 8.057 8.057 0 01-2.502 0 .75.75 0 01-.624-.858z"></path>`;
const $84c634e688af79ca$export$d2997daddac9b44 = `<path d="M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"></path><path d="M8 0a8 8 0 110 16A8 8 0 018 0zM1.5 8a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0z"></path>`;
const $84c634e688af79ca$export$f3edcd159701e0e2 = `<path d="M5.029 2.217a6.5 6.5 0 019.437 5.11.75.75 0 101.492-.154 8 8 0 00-14.315-4.03L.427 1.927A.25.25 0 000 2.104V5.75A.25.25 0 00.25 6h3.646a.25.25 0 00.177-.427L2.715 4.215a6.491 6.491 0 012.314-1.998zM1.262 8.169a.75.75 0 00-1.22.658 8.001 8.001 0 0014.315 4.03l1.216 1.216a.25.25 0 00.427-.177V10.25a.25.25 0 00-.25-.25h-3.646a.25.25 0 00-.177.427l1.358 1.358a6.501 6.501 0 01-11.751-3.11.75.75 0 00-.272-.506z"></path><path d="M9.06 9.06a1.5 1.5 0 11-2.12-2.12 1.5 1.5 0 012.12 2.12z"></path>`;
const $84c634e688af79ca$export$1b7e5fdaff4828f2 = `<path d="M1.5 8a6.5 6.5 0 0113 0A.75.75 0 0016 8a8 8 0 10-8 8 .75.75 0 000-1.5A6.5 6.5 0 011.5 8z"></path><path d="M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm1.5 1.75a.75.75 0 01.75-.75h5a.75.75 0 010 1.5h-5a.75.75 0 01-.75-.75zm2.75 2.25a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z"></path>`;
const $84c634e688af79ca$export$1d0ebfd290232666 = `<path d="M1.5 8a6.5 6.5 0 0113 0A.75.75 0 0016 8a8 8 0 10-8 8 .75.75 0 000-1.5A6.5 6.5 0 011.5 8z"></path><path d="M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm3.573 5.823l-2.896-2.896a.25.25 0 010-.354l2.896-2.896a.25.25 0 01.427.177V11.5h3.25a.75.75 0 010 1.5H12v2.146a.25.25 0 01-.427.177z"></path>`;
const $84c634e688af79ca$export$85393e592dc6a8af = `<path fill-rule="evenodd" d="M6 2.75A.75.75 0 016.75 2h6.5a.75.75 0 010 1.5h-2.505l-3.858 9H9.25a.75.75 0 010 1.5h-6.5a.75.75 0 010-1.5h2.505l3.858-9H6.75A.75.75 0 016 2.75z"></path>`;
const $84c634e688af79ca$export$aaae4cae2110f233 = `<path d="M8 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM1.5 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm13 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"></path>`;
const $84c634e688af79ca$export$9adb2e16f4f3e574 = `<path d="M14 13H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1zM2 5v7h12V5Z" style="stroke-width:1"/><path d="M5 10h5.5v1H5ZM3 6h1v1H3ZM5 6h1v1H5ZM7 6h1v1H7ZM9 6h1v1H9ZM3 10h1v1H3ZM3 8h1v1H3ZM5 8h1v1H5ZM7 8h1v1H7ZM11 6h2v1h-2zM11 8h2v1h-2zM9 8h1v1H9ZM11.5 10H13v1h-1.5z" stroke-width="1"/><path d="M0 0h16v16H0Z" fill="none" stroke-width="1" />`;
const $84c634e688af79ca$export$252cd6b345de9e4c = `<path d="M8 1.5c-2.363 0-4 1.69-4 3.75 0 .984.424 1.625.984 2.304l.214.253c.223.264.47.556.673.848.284.411.537.896.621 1.49a.75.75 0 0 1-1.484.211c-.04-.282-.163-.547-.37-.847a8.456 8.456 0 0 0-.542-.68c-.084-.1-.173-.205-.268-.32C3.201 7.75 2.5 6.766 2.5 5.25 2.5 2.31 4.863 0 8 0s5.5 2.31 5.5 5.25c0 1.516-.701 2.5-1.328 3.259-.095.115-.184.22-.268.319-.207.245-.383.453-.541.681-.208.3-.33.565-.37.847a.751.751 0 0 1-1.485-.212c.084-.593.337-1.078.621-1.489.203-.292.45-.584.673-.848.075-.088.147-.173.213-.253.561-.679.985-1.32.985-2.304 0-2.06-1.637-3.75-4-3.75ZM5.75 12h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM6 15.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"></path>`;
const $84c634e688af79ca$export$62783f817acd3332 = `<path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"/>`;
const $84c634e688af79ca$export$ebcd2be1028c1c9c = `<path fill-rule="evenodd" d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"></path>`;
const $84c634e688af79ca$export$67e579042ffeb67e = `<path fill-rule="evenodd" d="M2.003 2.5a.5.5 0 00-.723-.447l-1.003.5a.5.5 0 00.446.895l.28-.14V6H.5a.5.5 0 000 1h2.006a.5.5 0 100-1h-.503V2.5zM5 3.25a.75.75 0 01.75-.75h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 015 3.25zm0 5a.75.75 0 01.75-.75h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 015 8.25zm0 5a.75.75 0 01.75-.75h8.5a.75.75 0 010 1.5h-8.5a.75.75 0 01-.75-.75zM.924 10.32l.003-.004a.851.851 0 01.144-.153A.66.66 0 011.5 10c.195 0 .306.068.374.146a.57.57 0 01.128.376c0 .453-.269.682-.8 1.078l-.035.025C.692 11.98 0 12.495 0 13.5a.5.5 0 00.5.5h2.003a.5.5 0 000-1H1.146c.132-.197.351-.372.654-.597l.047-.035c.47-.35 1.156-.858 1.156-1.845 0-.365-.118-.744-.377-1.038-.268-.303-.658-.484-1.126-.484-.48 0-.84.202-1.068.392a1.858 1.858 0 00-.348.384l-.007.011-.002.004-.001.002-.001.001a.5.5 0 00.851.525zM.5 10.055l-.427-.26.427.26z"></path>`;
const $84c634e688af79ca$export$77260bda21a34df7 = `<path fill-rule="evenodd" d="M2 4a1 1 0 100-2 1 1 0 000 2zm3.75-1.5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zm0 5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zm0 5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zM3 8a1 1 0 11-2 0 1 1 0 012 0zm-1 6a1 1 0 100-2 1 1 0 000 2z"></path>`;
const $84c634e688af79ca$export$5c643f429ab0c3b4 = `<path d="m12.596 11.596-3.535 3.536a1.5 1.5 0 0 1-2.122 0l-3.535-3.536a6.5 6.5 0 1 1 9.192-9.193 6.5 6.5 0 0 1 0 9.193Zm-1.06-8.132v-.001a5 5 0 1 0-7.072 7.072L8 14.07l3.536-3.534a5 5 0 0 0 0-7.072ZM8 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 9Z"></path>`;
const $84c634e688af79ca$export$744eeee9ada60bc2 = `<path d="M4 4a4 4 0 0 1 8 0v2h.25c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-5.5C2 6.784 2.784 6 3.75 6H4Zm8.25 3.5h-8.5a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25ZM10.5 6V4a2.5 2.5 0 1 0-5 0v2Z"></path>`;
const $84c634e688af79ca$export$63cea22b3e24bc8 = `<path fill-rule="evenodd" d="M1.75 2A1.75 1.75 0 000 3.75v.736a.75.75 0 000 .027v7.737C0 13.216.784 14 1.75 14h12.5A1.75 1.75 0 0016 12.25v-8.5A1.75 1.75 0 0014.25 2H1.75zM14.5 4.07v-.32a.25.25 0 00-.25-.25H1.75a.25.25 0 00-.25.25v.32L8 7.88l6.5-3.81zm-13 1.74v6.441c0 .138.112.25.25.25h12.5a.25.25 0 00.25-.25V5.809L8.38 9.397a.75.75 0 01-.76 0L1.5 5.809z"></path>`;
const $84c634e688af79ca$export$7b9d1e4028ead863 = `<path fill-rule="evenodd" d="M14.85 3H1.15C.52 3 0 3.52 0 4.15v7.69C0 12.48.52 13 1.15 13h13.69c.64 0 1.15-.52 1.15-1.15v-7.7C16 3.52 15.48 3 14.85 3zM9 11H7V8L5.5 9.92 4 8v3H2V5h2l1.5 2L7 5h2v6zm2.99.5L9.5 8H11V5h2v3h1.5l-2.51 3.5z"></path>`;
const $84c634e688af79ca$export$f923afc8635c0b64 = `<path d="M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z"></path>`;
const $84c634e688af79ca$export$c5daf3f2ccb1ea17 = `<path fill-rule="evenodd" d="M4.75 2.37a6.5 6.5 0 006.5 11.26.75.75 0 01.75 1.298 8 8 0 113.994-7.273.754.754 0 01.006.095v1.5a2.75 2.75 0 01-5.072 1.475A4 4 0 1112 8v1.25a1.25 1.25 0 002.5 0V7.867a6.5 6.5 0 00-9.75-5.496V2.37zM10.5 8a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z"></path>`;
const $84c634e688af79ca$export$9a2d5e2a3c95aa36 = `<path d="M2.84 13.6.5 11.24 2.84 8.9l.64.64-1.71 1.7 1.7 1.72zm3.03-1.9H1.13v-.9h4.74zm7.29-4.6-.64-.64 1.71-1.7-1.7-1.72.63-.63 2.34 2.34zm1.7-1.9h-4.73v-.9h4.74zm-1.7 8.4-.64-.64 1.71-1.71-1.7-1.71.63-.64 2.34 2.35zM2.84 7.1.5 4.75l2.34-2.34.64.63-1.71 1.71 1.7 1.71zm12.03 4.6h-3.62A3.7 3.7 0 0 1 7.55 8a2.8 2.8 0 0 0-2.8-2.8H1.13v-.9h3.62A3.7 3.7 0 0 1 8.45 8a2.8 2.8 0 0 0 2.8 2.8h3.62z"/>`;
const $84c634e688af79ca$export$b15a75c898ec5eb4 = `<path fill-rule="evenodd" d="M9.598 1.591a.75.75 0 01.785-.175 7 7 0 11-8.967 8.967.75.75 0 01.961-.96 5.5 5.5 0 007.046-7.046.75.75 0 01.175-.786zm1.616 1.945a7 7 0 01-7.678 7.678 5.5 5.5 0 107.678-7.678z"></path>`;
const $84c634e688af79ca$export$a71c4501b622420d = `<path d="M7.693 1.066a.747.747 0 0 1 .614 0l7.25 3.25a.75.75 0 0 1 0 1.368L13 6.831v2.794c0 1.024-.81 1.749-1.66 2.173-.893.447-2.075.702-3.34.702-.278 0-.55-.012-.816-.036a.75.75 0 0 1 .133-1.494c.22.02.45.03.683.03 1.082 0 2.025-.221 2.67-.543.69-.345.83-.682.83-.832V7.503L8.307 8.934a.747.747 0 0 1-.614 0L4 7.28v1.663c.296.105.575.275.812.512.438.438.688 1.059.688 1.796v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-3c0-.737.25-1.358.688-1.796.237-.237.516-.407.812-.512V6.606L.443 5.684a.75.75 0 0 1 0-1.368ZM2.583 5 8 7.428 13.416 5 8 2.572ZM2.5 11.25v2.25H4v-2.25c0-.388-.125-.611-.25-.735a.697.697 0 0 0-.5-.203.707.707 0 0 0-.5.203c-.125.124-.25.347-.25.735Z"></path>`;
const $84c634e688af79ca$export$a152de9f43c69821 = `<path d="M8.53 1.22a.749.749 0 0 0-1.06 0L3.72 4.97a.749.749 0 1 0 1.06 1.06l2.47-2.469v6.689a.75.75 0 0 0 1.5 0V3.561l2.47 2.469a.749.749 0 1 0 1.06-1.06L8.53 1.22ZM3.75 13a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z"></path>`;
const $84c634e688af79ca$export$8c2fa896412d662f = `<path d="M7.47 10.78a.749.749 0 0 0 1.06 0l3.75-3.75a.749.749 0 1 0-1.06-1.06L8.75 8.439V1.75a.75.75 0 0 0-1.5 0v6.689L4.78 5.97a.749.749 0 1 0-1.06 1.06l3.75 3.75ZM3.75 13a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z"></path>`;
const $84c634e688af79ca$export$82115b98859c1168 = `<path d="M4.25 7.25a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5z"></path><path d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 10-13 0 6.5 6.5 0 0013 0z"></path>`;
const $84c634e688af79ca$export$5d50349f0efd9ba2 = `<path d="M8.5.75a.75.75 0 0 0-1.5 0v5.19L4.391 3.33a.75.75 0 1 0-1.06 1.061L5.939 7H.75a.75.75 0 0 0 0 1.5h5.19l-2.61 2.609a.75.75 0 1 0 1.061 1.06L7 9.561v5.189a.75.75 0 0 0 1.5 0V9.56l2.609 2.61a.75.75 0 1 0 1.06-1.061L9.561 8.5h5.189a.75.75 0 0 0 0-1.5H9.56l2.61-2.609a.75.75 0 0 0-1.061-1.06L8.5 5.939V.75Z"></path>`;
const $84c634e688af79ca$export$ec311e0cee1871f3 = `<path d="M0 3.75C0 2.784.784 2 1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25ZM3.5 6.25a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75Zm.75 2.25h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5Z"></path>`;
const $84c634e688af79ca$export$51f878b7e8894ba1 = `<path fill-rule="evenodd" d="M1.5 14.25c0 .138.112.25.25.25H4v-1.25a.75.75 0 01.75-.75h2.5a.75.75 0 01.75.75v1.25h2.25a.25.25 0 00.25-.25V1.75a.25.25 0 00-.25-.25h-8.5a.25.25 0 00-.25.25v12.5zM1.75 16A1.75 1.75 0 010 14.25V1.75C0 .784.784 0 1.75 0h8.5C11.216 0 12 .784 12 1.75v12.5c0 .085-.006.168-.018.25h2.268a.25.25 0 00.25-.25V8.285a.25.25 0 00-.111-.208l-1.055-.703a.75.75 0 11.832-1.248l1.055.703c.487.325.779.871.779 1.456v5.965A1.75 1.75 0 0114.25 16h-3.5a.75.75 0 01-.197-.026c-.099.017-.2.026-.303.026h-3a.75.75 0 01-.75-.75V14h-1v1.25a.75.75 0 01-.75.75h-3zM3 3.75A.75.75 0 013.75 3h.5a.75.75 0 010 1.5h-.5A.75.75 0 013 3.75zM3.75 6a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zM3 9.75A.75.75 0 013.75 9h.5a.75.75 0 010 1.5h-.5A.75.75 0 013 9.75zM7.75 9a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zM7 6.75A.75.75 0 017.75 6h.5a.75.75 0 010 1.5h-.5A.75.75 0 017 6.75zM7.75 3a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5z"></path>`;
const $84c634e688af79ca$export$1627e4883d92a099 = `<path d="M12.212 3.02a1.753 1.753 0 0 0-2.478.003l-5.83 5.83a3.007 3.007 0 0 0-.88 2.127c0 .795.315 1.551.88 2.116.567.567 1.333.89 2.126.89.79 0 1.548-.321 2.116-.89l5.48-5.48a.75.75 0 0 1 1.061 1.06l-5.48 5.48a4.492 4.492 0 0 1-3.177 1.33c-1.2 0-2.345-.487-3.187-1.33a4.483 4.483 0 0 1-1.32-3.177c0-1.195.475-2.341 1.32-3.186l5.83-5.83a3.25 3.25 0 0 1 5.553 2.297c0 .863-.343 1.691-.953 2.301L7.439 12.39c-.375.377-.884.59-1.416.593a1.998 1.998 0 0 1-1.412-.593 1.992 1.992 0 0 1 0-2.828l5.48-5.48a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-5.48 5.48a.492.492 0 0 0 0 .707.499.499 0 0 0 .352.154.51.51 0 0 0 .356-.154l5.833-5.827a1.755 1.755 0 0 0 0-2.481Z"></path>`;
const $84c634e688af79ca$export$adcaf896a7be650b = `<path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5"/>`;
const $84c634e688af79ca$export$f35f69ccfaa7b376 = `<path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001m-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708z"/>`;
const $84c634e688af79ca$export$f991bf0e9ae7ca12 = `<path fill-rule="evenodd" d="M11.013 1.427a1.75 1.75 0 012.474 0l1.086 1.086a1.75 1.75 0 010 2.474l-8.61 8.61c-.21.21-.47.364-.756.445l-3.251.93a.75.75 0 01-.927-.928l.929-3.25a1.75 1.75 0 01.445-.758l8.61-8.61zm1.414 1.06a.25.25 0 00-.354 0L10.811 3.75l1.439 1.44 1.263-1.263a.25.25 0 000-.354l-1.086-1.086zM11.189 6.25L9.75 4.81l-6.286 6.287a.25.25 0 00-.064.108l-.558 1.953 1.953-.558a.249.249 0 00.108-.064l6.286-6.286z"></path>`;
const $84c634e688af79ca$export$44b16df525422efd = `<path fill-rule="evenodd" d="M5.5 3.5a2 2 0 100 4 2 2 0 000-4zM2 5.5a3.5 3.5 0 115.898 2.549 5.507 5.507 0 013.034 4.084.75.75 0 11-1.482.235 4.001 4.001 0 00-7.9 0 .75.75 0 01-1.482-.236A5.507 5.507 0 013.102 8.05 3.49 3.49 0 012 5.5zM11 4a.75.75 0 100 1.5 1.5 1.5 0 01.666 2.844.75.75 0 00-.416.672v.352a.75.75 0 00.574.73c1.2.289 2.162 1.2 2.522 2.372a.75.75 0 101.434-.44 5.01 5.01 0 00-2.56-3.012A3 3 0 0011 4z"></path>`;
const $84c634e688af79ca$export$8339901270f1e164 = `<path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/><path fill-rule="evenodd" d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>`;
const $84c634e688af79ca$export$7ec3d824126b1aaf = `<path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Zm3.63-4.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"/>`;
const $84c634e688af79ca$export$d8257db44c09a4d8 = `<path fill-rule="evenodd" d="M10.5 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm.061 3.073a4 4 0 10-5.123 0 6.004 6.004 0 00-3.431 5.142.75.75 0 001.498.07 4.5 4.5 0 018.99 0 .75.75 0 101.498-.07 6.005 6.005 0 00-3.432-5.142z"></path>`;
const $84c634e688af79ca$export$2cb0e6b6616bbc58 = `<path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/><path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>`;
const $84c634e688af79ca$export$3d8bf5b2a943d316 = `<path d="M8 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/><path d="M1 1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h.5a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6.707L6 1.293A1 1 0 0 0 5.293 1H1Zm0 1h4.293L6 2.707A1 1 0 0 0 6.707 3H15v10h-.085a1.5 1.5 0 0 0-2.4-.63C11.885 11.223 10.554 10 8 10c-2.555 0-3.886 1.224-4.514 2.37a1.5 1.5 0 0 0-2.4.63H1V2Z"/>`;
const $84c634e688af79ca$export$84fa51e586e7b2e7 = `<path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/><path fill-rule="evenodd" d="M12.146 5.146a.5.5 0 0 1 .708 0L14 6.293l1.146-1.147a.5.5 0 0 1 .708.708L14.707 7l1.147 1.146a.5.5 0 0 1-.708.708L14 7.707l-1.146 1.147a.5.5 0 0 1-.708-.708L13.293 7l-1.147-1.146a.5.5 0 0 1 0-.708z"/>`;
const $84c634e688af79ca$export$a4621f9ac5132319 = `<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>`;
const $84c634e688af79ca$export$818cafb7937913f5 = `<path fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0zM8 0a8 8 0 100 16A8 8 0 008 0zm.75 4.75a.75.75 0 00-1.5 0v2.5h-2.5a.75.75 0 000 1.5h2.5v2.5a.75.75 0 001.5 0v-2.5h2.5a.75.75 0 000-1.5h-2.5v-2.5z"></path>`;
const $84c634e688af79ca$export$3304639b795b6ae = `<path fill-rule="evenodd" d="M7.75 2a.75.75 0 01.75.75V7h4.25a.75.75 0 110 1.5H8.5v4.25a.75.75 0 11-1.5 0V8.5H2.75a.75.75 0 010-1.5H7V2.75A.75.75 0 017.75 2z"></path>`;
const $84c634e688af79ca$export$6ccb2650cf13729e = `<path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/><path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>`;
const $84c634e688af79ca$export$b033e2eb4807deba = `<path d="M2 2h2v2H2V2Z"/><path d="M6 0v6H0V0h6ZM5 1H1v4h4V1ZM4 12H2v2h2v-2Z"/><path d="M6 10v6H0v-6h6Zm-5 1v4h4v-4H1Zm11-9h2v2h-2V2Z"/><path d="M10 0v6h6V0h-6Zm5 1v4h-4V1h4ZM8 1V0h1v2H8v2H7V1h1Zm0 5V4h1v2H8ZM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8H6Zm0 0v1H2V8H1v1H0V7h3v1h3Zm10 1h-1V7h1v2Zm-1 0h-1v2h2v-1h-1V9Zm-4 0h2v1h-1v1h-1V9Zm2 3v-1h-1v1h-1v1H9v1h3v-2h1Zm0 0h3v1h-2v1h-1v-2Zm-4-1v1h1v-2H7v1h2Z"/><path d="M7 12h1v3h4v1H7v-4Zm9 2v2h-3v-1h2v-1h1Z"/>`;
const $84c634e688af79ca$export$c5abb880dda04c02 = `<path d="M0 8a8 8 0 1116 0A8 8 0 010 8zm8-6.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM6.92 6.085h.001a.749.749 0 11-1.342-.67c.169-.339.436-.701.849-.977C6.845 4.16 7.369 4 8 4a2.756 2.756 0 011.637.525c.503.377.863.965.863 1.725 0 .448-.115.83-.329 1.15-.205.307-.47.513-.692.662-.109.072-.22.138-.313.195l-.006.004a6.24 6.24 0 00-.26.16.952.952 0 00-.276.245.75.75 0 01-1.248-.832c.184-.264.42-.489.692-.661.103-.067.207-.132.313-.195l.007-.004c.1-.061.182-.11.258-.161a.969.969 0 00.277-.245C8.96 6.514 9 6.427 9 6.25a.612.612 0 00-.262-.525A1.27 1.27 0 008 5.5c-.369 0-.595.09-.74.187a1.01 1.01 0 00-.34.398zM9 11a1 1 0 11-2 0 1 1 0 012 0z"></path>`;
const $84c634e688af79ca$export$696b0975d17cc695 = `<path fill-rule="evenodd" d="M1.75 2.5a.75.75 0 000 1.5h10.5a.75.75 0 000-1.5H1.75zm4 5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zm0 5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zM2.5 7.75a.75.75 0 00-1.5 0v6a.75.75 0 001.5 0v-6z"></path>`;
const $84c634e688af79ca$export$213ba599ab7d8ec6 = `<path fill-rule="evenodd" d="M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v3.585a.746.746 0 010 .83v8.085A1.75 1.75 0 0114.25 16H6.309a.748.748 0 01-1.118 0H1.75A1.75 1.75 0 010 14.25V6.165a.746.746 0 010-.83V1.75zM1.5 6.5v7.75c0 .138.112.25.25.25H5v-8H1.5zM5 5H1.5V1.75a.25.25 0 01.25-.25H5V5zm1.5 1.5v8h7.75a.25.25 0 00.25-.25V6.5h-8zm8-1.5h-8V1.5h7.75a.25.25 0 01.25.25V5z"></path>`;
const $84c634e688af79ca$export$22a44c3490da3c1a = `<path d="M8.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696z"/><path d="M.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696z"/>`;
const $84c634e688af79ca$export$764331b9206ca92e = `<path d="M14.064 0h.186C15.216 0 16 .784 16 1.75v.186a8.752 8.752 0 0 1-2.564 6.186l-.458.459c-.314.314-.641.616-.979.904v3.207c0 .608-.315 1.172-.833 1.49l-2.774 1.707a.749.749 0 0 1-1.11-.418l-.954-3.102a1.214 1.214 0 0 1-.145-.125L3.754 9.816a1.218 1.218 0 0 1-.124-.145L.528 8.717a.749.749 0 0 1-.418-1.11l1.71-2.774A1.748 1.748 0 0 1 3.31 4h3.204c.288-.338.59-.665.904-.979l.459-.458A8.749 8.749 0 0 1 14.064 0ZM8.938 3.623h-.002l-.458.458c-.76.76-1.437 1.598-2.02 2.5l-1.5 2.317 2.143 2.143 2.317-1.5c.902-.583 1.74-1.26 2.499-2.02l.459-.458a7.25 7.25 0 0 0 2.123-5.127V1.75a.25.25 0 0 0-.25-.25h-.186a7.249 7.249 0 0 0-5.125 2.123ZM3.56 14.56c-.732.732-2.334 1.045-3.005 1.148a.234.234 0 0 1-.201-.064.234.234 0 0 1-.064-.201c.103-.671.416-2.273 1.15-3.003a1.502 1.502 0 1 1 2.12 2.12Zm6.94-3.935c-.088.06-.177.118-.266.175l-2.35 1.521.548 1.783 1.949-1.2a.25.25 0 0 0 .119-.213ZM3.678 8.116 5.2 5.766c.058-.09.117-.178.176-.266H3.309a.25.25 0 0 0-.213.119l-1.2 1.95ZM12 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"></path>`;
const $84c634e688af79ca$export$156efc2c658872eb = `<path d="M4.75 7a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5ZM5 4.75A.75.75 0 0 1 5.75 4h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 5 4.75ZM6.75 10a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"></path><path d="M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Z"></path>`;
const $84c634e688af79ca$export$8687ffcdea58e000 = `<path fill-rule="evenodd" d="M11.5 7a4.499 4.499 0 11-8.998 0A4.499 4.499 0 0111.5 7zm-.82 4.74a6 6 0 111.06-1.06l3.04 3.04a.75.75 0 11-1.06 1.06l-3.04-3.04z"></path>`;
const $84c634e688af79ca$export$1c9c5f58b493da5e = `<path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372l2.8-7Zm-2.54 1.183L5.93 9.363 1.591 6.602l11.833-4.733Z"/><path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z"/>`;
const $84c634e688af79ca$export$8821ea1545299efc = `<path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z"/>`;
const $84c634e688af79ca$export$cf8ed5bb35a34744 = `<path fill-rule="evenodd" d="M7.429 1.525a6.593 6.593 0 011.142 0c.036.003.108.036.137.146l.289 1.105c.147.56.55.967.997 1.189.174.086.341.183.501.29.417.278.97.423 1.53.27l1.102-.303c.11-.03.175.016.195.046.219.31.41.641.573.989.014.031.022.11-.059.19l-.815.806c-.411.406-.562.957-.53 1.456a4.588 4.588 0 010 .582c-.032.499.119 1.05.53 1.456l.815.806c.08.08.073.159.059.19a6.494 6.494 0 01-.573.99c-.02.029-.086.074-.195.045l-1.103-.303c-.559-.153-1.112-.008-1.529.27-.16.107-.327.204-.5.29-.449.222-.851.628-.998 1.189l-.289 1.105c-.029.11-.101.143-.137.146a6.613 6.613 0 01-1.142 0c-.036-.003-.108-.037-.137-.146l-.289-1.105c-.147-.56-.55-.967-.997-1.189a4.502 4.502 0 01-.501-.29c-.417-.278-.97-.423-1.53-.27l-1.102.303c-.11.03-.175-.016-.195-.046a6.492 6.492 0 01-.573-.989c-.014-.031-.022-.11.059-.19l.815-.806c.411-.406.562-.957.53-1.456a4.587 4.587 0 010-.582c.032-.499-.119-1.05-.53-1.456l-.815-.806c-.08-.08-.073-.159-.059-.19a6.44 6.44 0 01.573-.99c.02-.029.086-.075.195-.045l1.103.303c.559.153 1.112.008 1.529-.27.16-.107.327-.204.5-.29.449-.222.851-.628.998-1.189l.289-1.105c.029-.11.101-.143.137-.146zM8 0c-.236 0-.47.01-.701.03-.743.065-1.29.615-1.458 1.261l-.29 1.106c-.017.066-.078.158-.211.224a5.994 5.994 0 00-.668.386c-.123.082-.233.09-.3.071L3.27 2.776c-.644-.177-1.392.02-1.82.63a7.977 7.977 0 00-.704 1.217c-.315.675-.111 1.422.363 1.891l.815.806c.05.048.098.147.088.294a6.084 6.084 0 000 .772c.01.147-.038.246-.088.294l-.815.806c-.474.469-.678 1.216-.363 1.891.2.428.436.835.704 1.218.428.609 1.176.806 1.82.63l1.103-.303c.066-.019.176-.011.299.071.213.143.436.272.668.386.133.066.194.158.212.224l.289 1.106c.169.646.715 1.196 1.458 1.26a8.094 8.094 0 001.402 0c.743-.064 1.29-.614 1.458-1.26l.29-1.106c.017-.066.078-.158.211-.224a5.98 5.98 0 00.668-.386c.123-.082.233-.09.3-.071l1.102.302c.644.177 1.392-.02 1.82-.63.268-.382.505-.789.704-1.217.315-.675.111-1.422-.364-1.891l-.814-.806c-.05-.048-.098-.147-.088-.294a6.1 6.1 0 000-.772c-.01-.147.039-.246.088-.294l.814-.806c.475-.469.679-1.216.364-1.891a7.992 7.992 0 00-.704-1.218c-.428-.609-1.176-.806-1.82-.63l-1.103.303c-.066.019-.176.011-.299-.071a5.991 5.991 0 00-.668-.386c-.133-.066-.194-.158-.212-.224L10.16 1.29C9.99.645 9.444.095 8.701.031A8.094 8.094 0 008 0zm1.5 8a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM11 8a3 3 0 11-6 0 3 3 0 016 0z"></path>`;
const $84c634e688af79ca$export$a2dbc589500a2539 = `<path fill-rule="evenodd" d="M13.5 3a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 3a3 3 0 01-5.175 2.066l-3.92 2.179a3.005 3.005 0 010 1.51l3.92 2.179a3 3 0 11-.73 1.31l-3.92-2.178a3 3 0 110-4.133l3.92-2.178A3 3 0 1115 3zm-1.5 10a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-9-5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"></path>`;
const $84c634e688af79ca$export$67b9706fd0346cbb = `<path d="m8.533.133 5.25 1.68A1.75 1.75 0 0 1 15 3.48V7c0 1.566-.32 3.182-1.303 4.682-.983 1.498-2.585 2.813-5.032 3.855a1.697 1.697 0 0 1-1.33 0c-2.447-1.042-4.049-2.357-5.032-3.855C1.32 10.182 1 8.566 1 7V3.48a1.75 1.75 0 0 1 1.217-1.667l5.25-1.68a1.748 1.748 0 0 1 1.066 0Zm-.61 1.429.001.001-5.25 1.68a.251.251 0 0 0-.174.237V7c0 1.36.275 2.666 1.057 3.859.784 1.194 2.121 2.342 4.366 3.298a.196.196 0 0 0 .154 0c2.245-.957 3.582-2.103 4.366-3.297C13.225 9.666 13.5 8.358 13.5 7V3.48a.25.25 0 0 0-.174-.238l-5.25-1.68a.25.25 0 0 0-.153 0ZM11.28 6.28l-3.5 3.5a.75.75 0 0 1-1.06 0l-1.5-1.5a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l.97.97 2.97-2.97a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"></path>`;
const $84c634e688af79ca$export$b30eb444abf03cb0 = `<path fill-rule="evenodd" d="M6.823 7.823L4.427 5.427A.25.25 0 004 5.604v4.792c0 .223.27.335.427.177l2.396-2.396a.25.25 0 000-.354z"></path><path fill-rule="evenodd" d="M1.75 0A1.75 1.75 0 000 1.75v12.5C0 15.216.784 16 1.75 16h12.5A1.75 1.75 0 0016 14.25V1.75A1.75 1.75 0 0014.25 0H1.75zM1.5 1.75a.25.25 0 01.25-.25H9.5v13H1.75a.25.25 0 01-.25-.25V1.75zM11 14.5v-13h3.25a.25.25 0 01.25.25v12.5a.25.25 0 01-.25.25H11z"></path>`;
const $84c634e688af79ca$export$276a6f6a703267d1 = `<path fill-rule="evenodd" d="M4.177 7.823l2.396-2.396A.25.25 0 017 5.604v4.792a.25.25 0 01-.427.177L4.177 8.177a.25.25 0 010-.354z"></path><path fill-rule="evenodd" d="M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0114.25 16H1.75A1.75 1.75 0 010 14.25V1.75zm1.75-.25a.25.25 0 00-.25.25v12.5c0 .138.112.25.25.25H9.5v-13H1.75zm12.5 13H11v-13h3.25a.25.25 0 01.25.25v12.5a.25.25 0 01-.25.25z"></path>`;
const $84c634e688af79ca$export$f8913d335ddc81bb = `<path d="M15.58 6.4c-1.3.09-3.14 1.37-4.07 1.79-.73.33-1.36.6-1.9.6-.57 0-.66-.4-.54-1.29.03-.2.3-1.98-1.07-1.9-.63.03-1.6.62-4.24 3.15l1.04-2.6a2.16 2.16 0 0 0-3.24-2.57l-1.38.93a.4.4 0 0 0-.12.55l.43.67a.4.4 0 0 0 .55.13l1.46-.98c.46-.29 1.01.18.81.68L.86 11.7c-.17.43.06 1.1.74 1.1a.8.8 0 0 0 .57-.23 90.97 90.97 0 0 1 5.28-4.9c-.06.71-.06 1.47.51 2.1.38.42.93.63 1.64.63.89 0 1.7-.37 2.56-.75.82-.37 2.47-1.57 3.46-1.65a.4.4 0 0 0 .38-.4v-.8a.4.4 0 0 0-.42-.4z" />`;
const $84c634e688af79ca$export$8a495e6856ec4c30 = `<path d="M8 0a8 8 0 110 16A8 8 0 018 0zM1.5 8a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0zm9.78-2.22l-5.5 5.5a.749.749 0 01-1.275-.326.749.749 0 01.215-.734l5.5-5.5a.751.751 0 011.042.018.751.751 0 01.018 1.042z"></path>`;
const $84c634e688af79ca$export$a7f606f216bfee52 = `<path fill-rule="evenodd" d="M0 4.25a.75.75 0 01.75-.75h2.5a.75.75 0 010 1.5H.75A.75.75 0 010 4.25zm0 4a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5H.75A.75.75 0 010 8.25zm0 4a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5H.75a.75.75 0 01-.75-.75zm12.927-9.677a.25.25 0 00-.354 0l-3 3A.25.25 0 009.75 6H12v6.75a.75.75 0 001.5 0V6h2.25a.25.25 0 00.177-.427l-3-3z"></path>`;
const $84c634e688af79ca$export$f4b6d034496ffda1 = `<path fill-rule="evenodd" d="M0 4.25a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5H.75A.75.75 0 010 4.25zm0 4a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5H.75A.75.75 0 010 8.25zm0 4a.75.75 0 01.75-.75h2.5a.75.75 0 010 1.5H.75a.75.75 0 01-.75-.75z"></path><path d="M13.5 10h2.25a.25.25 0 01.177.427l-3 3a.25.25 0 01-.354 0l-3-3A.25.25 0 019.75 10H12V3.75a.75.75 0 011.5 0V10z"></path>`;
const $84c634e688af79ca$export$6c3851a8b6f79415 = `<path d="M8 4a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-1 0V4.5A.5.5 0 0 1 8 4M3.732 5.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707M2 10a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 10m9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5m.754-4.246a.39.39 0 0 0-.527-.02L7.547 9.31a.91.91 0 1 0 1.302 1.258l3.434-4.297a.39.39 0 0 0-.029-.518z"/><path fill-rule="evenodd" d="M0 10a8 8 0 1 1 15.547 2.661c-.442 1.253-1.845 1.602-2.932 1.25C11.309 13.488 9.475 13 8 13c-1.474 0-3.31.488-4.615.911-1.087.352-2.49.003-2.932-1.25A8 8 0 0 1 0 10m8-7a7 7 0 0 0-6.603 9.329c.203.575.923.876 1.68.63C4.397 12.533 6.358 12 8 12s3.604.532 4.923.96c.757.245 1.477-.056 1.68-.631A7 7 0 0 0 8 3"/>`;
const $84c634e688af79ca$export$1b9a722e20d6b950 = `<path d="M3.34 7.73A7.05 7.05 0 0 0 0 6.17a7.05 7.05 0 0 0 3.34-1.56A7.06 7.06 0 0 0 4.9 1.27a7.05 7.05 0 0 0 1.56 3.34c.77.77 2.12 1.3 3.34 1.56a7.05 7.05 0 0 0-3.34 1.56 7.06 7.06 0 0 0-1.56 3.34 7.05 7.05 0 0 0-1.56-3.34zM9.51 12.73a4.22 4.22 0 0 0-2-.93 4.21 4.21 0 0 0 2-.93c.46-.46.78-1.26.93-2 .16.74.47 1.54.93 2 .46.46 1.27.78 2 .93-.73.16-1.54.47-2 .93a4.22 4.22 0 0 0-.93 2 4.21 4.21 0 0 0-.93-2zM11.08 4.57c.62-.13 1.3-.4 1.68-.78.39-.38.65-1.06.78-1.67.13.61.4 1.29.78 1.67.39.39 1.07.65 1.68.78-.61.14-1.29.4-1.68.79a3.54 3.54 0 0 0-.78 1.67 3.54 3.54 0 0 0-.78-1.67 3.54 3.54 0 0 0-1.68-.79z"/>`;
const $84c634e688af79ca$export$df1cad1bb112a50a = `<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>`;
const $84c634e688af79ca$export$b2685e5324529709 = `<path d="M7.122.392a1.75 1.75 0 0 1 1.756 0l5.003 2.902c.83.481.83 1.68 0 2.162L8.878 8.358a1.75 1.75 0 0 1-1.756 0L2.119 5.456a1.251 1.251 0 0 1 0-2.162ZM8.125 1.69a.248.248 0 0 0-.25 0l-4.63 2.685 4.63 2.685a.248.248 0 0 0 .25 0l4.63-2.685ZM1.601 7.789a.75.75 0 0 1 1.025-.273l5.249 3.044a.248.248 0 0 0 .25 0l5.249-3.044a.75.75 0 0 1 .752 1.298l-5.248 3.044a1.75 1.75 0 0 1-1.756 0L1.874 8.814A.75.75 0 0 1 1.6 7.789Zm0 3.5a.75.75 0 0 1 1.025-.273l5.249 3.044a.248.248 0 0 0 .25 0l5.249-3.044a.75.75 0 0 1 .752 1.298l-5.248 3.044a1.75 1.75 0 0 1-1.756 0l-5.248-3.044a.75.75 0 0 1-.273-1.025Z"></path>`;
const $84c634e688af79ca$export$7e54fd101e49f1c7 = `<path d="M1.65.9a.65.65 0 0 0-.65.64v4.3c0 1.93 1.4 3.52 3.23 3.83v.91a4.52 4.52 0 1 0 9.05 0v-.95a2.37 2.37 0 1 0-1.3 0v.95a3.23 3.23 0 1 1-6.46 0v-.91a3.88 3.88 0 0 0 3.23-3.82V1.54a.65.65 0 0 0-.64-.65H6.8a.65.65 0 0 0 0 1.3h.65v3.66a2.58 2.58 0 0 1-5.17 0V2.18h.65a.65.65 0 1 0 0-1.29zm10.98 5.38a1.08 1.08 0 1 1 0 2.15 1.08 1.08 0 0 1 0-2.15z" />`;
const $84c634e688af79ca$export$d0c2ff82f0790e53 = `<path d="M4.47.22A.749.749 0 015 0h6c.199 0 .389.079.53.22l4.25 4.25c.141.14.22.331.22.53v6a.749.749 0 01-.22.53l-4.25 4.25A.749.749 0 0111 16H5a.749.749 0 01-.53-.22L.22 11.53A.749.749 0 010 11V5c0-.199.079-.389.22-.53zm.84 1.28L1.5 5.31v5.38l3.81 3.81h5.38l3.81-3.81V5.31L10.69 1.5zM8 4a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 018 4zm0 8a1 1 0 110-2 1 1 0 010 2z"></path>`;
const $84c634e688af79ca$export$997a3923b24665e5 = `<path fill-rule="evenodd" d="M5.75.75A.75.75 0 016.5 0h3a.75.75 0 010 1.5h-.75v1l-.001.041a6.718 6.718 0 013.464 1.435l.007-.006.75-.75a.75.75 0 111.06 1.06l-.75.75-.006.007a6.75 6.75 0 11-10.548 0L2.72 5.03l-.75-.75a.75.75 0 011.06-1.06l.75.75.007.006A6.718 6.718 0 017.25 2.541a.756.756 0 010-.041v-1H6.5a.75.75 0 01-.75-.75zM8 14.5A5.25 5.25 0 108 4a5.25 5.25 0 000 10.5zm.389-6.7l1.33-1.33a.75.75 0 111.061 1.06L9.45 8.861A1.502 1.502 0 018 10.75a1.5 1.5 0 11.389-2.95z"></path>`;
const $84c634e688af79ca$export$af0359317e17d389 = `<path fill-rule="evenodd" d="M8 10.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM8 12a4 4 0 100-8 4 4 0 000 8zM8 0a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0V.75A.75.75 0 018 0zm0 13a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-1.5A.75.75 0 018 13zM2.343 2.343a.75.75 0 011.061 0l1.06 1.061a.75.75 0 01-1.06 1.06l-1.06-1.06a.75.75 0 010-1.06zm9.193 9.193a.75.75 0 011.06 0l1.061 1.06a.75.75 0 01-1.06 1.061l-1.061-1.06a.75.75 0 010-1.061zM16 8a.75.75 0 01-.75.75h-1.5a.75.75 0 010-1.5h1.5A.75.75 0 0116 8zM3 8a.75.75 0 01-.75.75H.75a.75.75 0 010-1.5h1.5A.75.75 0 013 8zm10.657-5.657a.75.75 0 010 1.061l-1.061 1.06a.75.75 0 11-1.06-1.06l1.06-1.06a.75.75 0 011.06 0zm-9.193 9.193a.75.75 0 010 1.06l-1.06 1.061a.75.75 0 11-1.061-1.06l1.06-1.061a.75.75 0 011.061 0z"></path>`;
const $84c634e688af79ca$export$d71853bc7259c595 = `<path d="M1.705 8.005a.75.75 0 0 1 .834.656 5.5 5.5 0 0 0 9.592 2.97l-1.204-1.204a.25.25 0 0 1 .177-.427h3.646a.25.25 0 0 1 .25.25v3.646a.25.25 0 0 1-.427.177l-1.38-1.38A7.002 7.002 0 0 1 1.05 8.84a.75.75 0 0 1 .656-.834ZM8 2.5a5.487 5.487 0 0 0-4.131 1.869l1.204 1.204A.25.25 0 0 1 4.896 6H1.25A.25.25 0 0 1 1 5.75V2.104a.25.25 0 0 1 .427-.177l1.38 1.38A7.002 7.002 0 0 1 14.95 7.16a.75.75 0 0 1-1.49.178A5.5 5.5 0 0 0 8 2.5Z"></path>`;
const $84c634e688af79ca$export$e5576969d092b404 = `<path d="M15.8 3.35 12.65.2a.68.68 0 1 0-.95.95l.38.39-1.84 1.84-1.6-1.6a.68.68 0 1 0-.95.95l.74.74-6.2 6.2a.68.68 0 0 0 0 .96l1.09 1.1L.2 14.85a.68.68 0 1 0 .95.95l3.12-3.12 1.1 1.1a.68.68 0 0 0 .96 0l6.2-6.2.74.73a.68.68 0 1 0 .95-.95l-1.6-1.6 1.85-1.84.38.38a.68.68 0 1 0 .95-.95zm-9.95 9-2.2-2.2.9-.89.57.57a.68.68 0 0 0 .95-.95L5.5 8.3l.54-.54.57.57a.68.68 0 1 0 .96-.96l-.58-.57.54-.54.58.57a.68.68 0 1 0 .95-.95l-.57-.57.89-.9 2.2 2.2-5.73 5.73zm5.82-7.54-.48-.48 1.85-1.84.47.48-1.84 1.84z"/>`;
const $84c634e688af79ca$export$f17898899b25b30f = `<path d="M1 7.775V2.75C1 1.784 1.784 1 2.75 1h5.025c.464 0 .91.184 1.238.513l6.25 6.25a1.75 1.75 0 0 1 0 2.474l-5.026 5.026a1.75 1.75 0 0 1-2.474 0l-6.25-6.25A1.752 1.752 0 0 1 1 7.775Zm1.5 0c0 .066.026.13.073.177l6.25 6.25a.25.25 0 0 0 .354 0l5.025-5.025a.25.25 0 0 0 0-.354l-6.25-6.25a.25.25 0 0 0-.177-.073H2.75a.25.25 0 0 0-.25.25ZM6 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"></path>`;
const $84c634e688af79ca$export$be57f1a2adaba6d9 = `<path fill-rule="evenodd" d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" /><path fill-rule="evenodd" d="M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3zm4.354 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z" />`;
const $84c634e688af79ca$export$3a1c536271d3060a = `<path fill-rule="evenodd" d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" /><path fill-rule="evenodd" d="M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />`;
const $84c634e688af79ca$export$ce6c9ad0562e53cc = `<path fill-rule="evenodd" d="M14.184 1.143a1.75 1.75 0 00-2.502-.57L.912 7.916a1.75 1.75 0 00-.53 2.32l.447.775a1.75 1.75 0 002.275.702l11.745-5.656a1.75 1.75 0 00.757-2.451l-1.422-2.464zm-1.657.669a.25.25 0 01.358.081l1.422 2.464a.25.25 0 01-.108.35l-2.016.97-1.505-2.605 1.85-1.26zM9.436 3.92l1.391 2.41-5.42 2.61-.942-1.63 4.97-3.39zM3.222 8.157l-1.466 1a.25.25 0 00-.075.33l.447.775a.25.25 0 00.325.1l1.598-.769-.83-1.436zm6.253 2.306a.75.75 0 00-.944-.252l-1.809.87a.75.75 0 00-.293.253L4.38 14.326a.75.75 0 101.238.848l1.881-2.75v2.826a.75.75 0 001.5 0v-2.826l1.881 2.75a.75.75 0 001.238-.848l-2.644-3.863z"></path>`;
const $84c634e688af79ca$export$19e57992350655e5 = `<path fill-rule="evenodd" d="M1 2.75A.75.75 0 011.75 2h12.5a.75.75 0 110 1.5H1.75A.75.75 0 011 2.75zm0 5A.75.75 0 011.75 7h12.5a.75.75 0 110 1.5H1.75A.75.75 0 011 7.75zM1.75 12a.75.75 0 100 1.5h12.5a.75.75 0 100-1.5H1.75z"></path>`;
const $84c634e688af79ca$export$42af681e1bc43a8b = `<path d="M7.25 11.68a4.002 4.002 0 0 1 0-7.86V.5a.75.75 0 0 1 1.5 0v3.32a4.002 4.002 0 0 1 0 7.86V15a.75.75 0 0 1-1.5 0v-3.32zM8 10.25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>`;
const $84c634e688af79ca$export$c6e11f163cc2dc47 = `<path fill-rule="evenodd" d="M6.5 1.75a.25.25 0 01.25-.25h2.5a.25.25 0 01.25.25V3h-3V1.75zm4.5 0V3h2.25a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5H5V1.75C5 .784 5.784 0 6.75 0h2.5C10.216 0 11 .784 11 1.75zM4.496 6.675a.75.75 0 10-1.492.15l.66 6.6A1.75 1.75 0 005.405 15h5.19c.9 0 1.652-.681 1.741-1.576l.66-6.6a.75.75 0 00-1.492-.149l-.66 6.6a.25.25 0 01-.249.225h-5.19a.25.25 0 01-.249-.225l-.66-6.6z"></path>`;
const $84c634e688af79ca$export$11c52108e5848752 = `<path d="M4.427 7.427l3.396 3.396a.25.25 0 00.354 0l3.396-3.396A.25.25 0 0011.396 7H4.604a.25.25 0 00-.177.427z"></path>`;
const $84c634e688af79ca$export$65802efd58dbcf80 = `<path d="M4.427 9.573l3.396-3.396a.25.25 0 01.354 0l3.396 3.396a.25.25 0 01-.177.427H4.604a.25.25 0 01-.177-.427z"></path>`;
const $84c634e688af79ca$export$e789e90053a546bb = `<path d="M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z"></path><path d="M11.78 4.72a.749.749 0 1 1-1.06 1.06L8.75 3.811V9.5a.75.75 0 0 1-1.5 0V3.811L5.28 5.78a.749.749 0 1 1-1.06-1.06l3.25-3.25a.749.749 0 0 1 1.06 0l3.25 3.25Z"></path>`;
const $84c634e688af79ca$export$574b1b76cb8c7ec6 = `<path fill-rule="evenodd" d="M10.646.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-1.902 1.902-.829 3.313a1.5 1.5 0 0 1-1.024 1.073L1.254 14.746 4.358 4.4A1.5 1.5 0 0 1 5.43 3.377l3.313-.828zm-1.8 2.908-3.173.793a.5.5 0 0 0-.358.342l-2.57 8.565 8.567-2.57a.5.5 0 0 0 .34-.357l.794-3.174-3.6-3.6z"/><path fill-rule="evenodd" d="M2.832 13.228 8 9a1 1 0 1 0-1-1l-4.228 5.168-.026.086z"/>`;
const $84c634e688af79ca$export$fb6200c7e4bc245b = `<path d="M7.75 14A1.75 1.75 0 0 1 6 12.25v-8.5C6 2.784 6.784 2 7.75 2h6.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14Zm-.25-1.75c0 .138.112.25.25.25h6.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25h-6.5a.25.25 0 0 0-.25.25ZM4.9 3.508a.75.75 0 0 1-.274 1.025.249.249 0 0 0-.126.217v6.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.75 1.75 0 0 1 3 11.25v-6.5c0-.649.353-1.214.874-1.516a.75.75 0 0 1 1.025.274ZM1.625 5.533h.001a.249.249 0 0 0-.126.217v4.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.748 1.748 0 0 1 0 10.25v-4.5a1.748 1.748 0 0 1 .873-1.516.75.75 0 1 1 .752 1.299Z"></path>`;
const $84c634e688af79ca$export$eebcc95f857de077 = `<path d="M0 1.75C0 .784.784 0 1.75 0h3.5C6.216 0 7 .784 7 1.75v3.5A1.75 1.75 0 0 1 5.25 7H4v4a1 1 0 0 0 1 1h4v-1.25C9 9.784 9.784 9 10.75 9h3.5c.966 0 1.75.784 1.75 1.75v3.5A1.75 1.75 0 0 1 14.25 16h-3.5A1.75 1.75 0 0 1 9 14.25v-.75H5A2.5 2.5 0 0 1 2.5 11V7h-.75A1.75 1.75 0 0 1 0 5.25Zm1.75-.25a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25Zm9 9a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25Z"></path>`;
const $84c634e688af79ca$export$d0029a3ee0c0e03 = `<path fill-rule="evenodd" d="M3.404 12.596a6.5 6.5 0 119.192-9.192 6.5 6.5 0 01-9.192 9.192zM2.344 2.343a8 8 0 1011.313 11.314A8 8 0 002.343 2.343zM6.03 4.97a.75.75 0 00-1.06 1.06L6.94 8 4.97 9.97a.75.75 0 101.06 1.06L8 9.06l1.97 1.97a.75.75 0 101.06-1.06L9.06 8l1.97-1.97a.75.75 0 10-1.06-1.06L8 6.94 6.03 4.97z"></path>`;
const $84c634e688af79ca$export$4d48f840957dea1b = `<path fill-rule="evenodd" d="M3.72 3.72a.75.75 0 011.06 0L8 6.94l3.22-3.22a.75.75 0 111.06 1.06L9.06 8l3.22 3.22a.75.75 0 11-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 01-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 010-1.06z"></path>`;
const $84c634e688af79ca$export$4ca6136d62cf903 = `<path fill-rule="evenodd" d="M10.561 1.5a.016.016 0 00-.01.004L3.286 8.571A.25.25 0 003.462 9H6.75a.75.75 0 01.694 1.034l-1.713 4.188 6.982-6.793A.25.25 0 0012.538 7H9.25a.75.75 0 01-.683-1.06l2.008-4.418.003-.006a.02.02 0 00-.004-.009.02.02 0 00-.006-.006L10.56 1.5zM9.504.43a1.516 1.516 0 012.437 1.713L10.415 5.5h2.123c1.57 0 2.346 1.909 1.22 3.004l-7.34 7.142a1.25 1.25 0 01-.871.354h-.302a1.25 1.25 0 01-1.157-1.723L5.633 10.5H3.462c-1.57 0-2.346-1.909-1.22-3.004L9.503.429z"></path>`;
const $84c634e688af79ca$export$243b99dab5f0afd0 = `<path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/><path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/><path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"/>`;
const $84c634e688af79ca$export$71f13b33cc62760a = `<path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/><path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/><path fill-rule="evenodd" d="M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>`;
const $84c634e688af79ca$export$49a22c2bea0a2976 = `<path d="M13 17.5a1 1 0 11-2 0 1 1 0 012 0zm-.25-8.25a.75.75 0 00-1.5 0v4.5a.75.75 0 001.5 0v-4.5z"></path><path fill-rule="evenodd" d="M9.836 3.244c.963-1.665 3.365-1.665 4.328 0l8.967 15.504c.963 1.667-.24 3.752-2.165 3.752H3.034c-1.926 0-3.128-2.085-2.165-3.752L9.836 3.244zm3.03.751a1 1 0 00-1.732 0L2.168 19.499A1 1 0 003.034 21h17.932a1 1 0 00.866-1.5L12.866 3.994z"></path>`;
const $84c634e688af79ca$export$f144ff283e2ca060 = `<path fill-rule="evenodd" d="M18.25 8.5a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 010-1.5h7.19L6.22 7.28a.75.75 0 011.06-1.06L17.5 16.44V9.25a.75.75 0 01.75-.75z"></path>`;
const $84c634e688af79ca$export$834a4c5733ec0c84 = `<path fill-rule="evenodd" d="M18.25 15.5a.75.75 0 00.75-.75v-9a.75.75 0 00-.75-.75h-9a.75.75 0 000 1.5h7.19L6.22 16.72a.75.75 0 101.06 1.06L17.5 7.56v7.19c0 .414.336.75.75.75z"></path>`;
const $84c634e688af79ca$export$57513d500dbb4ea5 = `<path fill-rule="evenodd" d="M12 1C8.318 1 5 3.565 5 7v4.539a3.25 3.25 0 01-.546 1.803l-2.2 3.299A1.518 1.518 0 003.519 19H8.5a3.5 3.5 0 107 0h4.982a1.518 1.518 0 001.263-2.36l-2.2-3.298A3.25 3.25 0 0119 11.539V7c0-3.435-3.319-6-7-6zM6.5 7c0-2.364 2.383-4.5 5.5-4.5s5.5 2.136 5.5 4.5v4.539c0 .938.278 1.854.798 2.635l2.199 3.299a.017.017 0 01.003.01l-.001.006-.004.006-.006.004-.007.001H3.518l-.007-.001-.006-.004-.004-.006-.001-.007.003-.01 2.2-3.298a4.75 4.75 0 00.797-2.635V7zM14 19h-4a2 2 0 104 0z"></path>`;
const $84c634e688af79ca$export$8f654e45e6616849 = `<path d="M3.5 3.75a.25.25 0 0 1 .25-.25h13.5a.25.25 0 0 1 .25.25v10a.75.75 0 0 0 1.5 0v-10A1.75 1.75 0 0 0 17.25 2H3.75A1.75 1.75 0 0 0 2 3.75v16.5c0 .966.784 1.75 1.75 1.75h7a.75.75 0 0 0 0-1.5h-7a.25.25 0 0 1-.25-.25V3.75Z"></path><path d="M6.25 7a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Zm-.75 4.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm16.28 4.53a.75.75 0 1 0-1.06-1.06l-4.97 4.97-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5.5-5.5Z"></path>`;
const $84c634e688af79ca$export$7f2471dddd951c39 = `<path fill-rule="evenodd" d="M13.152.682a2.25 2.25 0 012.269 0l.007.004 6.957 4.276a2.276 2.276 0 011.126 1.964v7.516c0 .81-.432 1.56-1.133 1.968l-.002.001-11.964 7.037-.004.003a2.276 2.276 0 01-2.284 0l-.026-.015-6.503-4.502a2.268 2.268 0 01-1.096-1.943V9.438c0-.392.1-.77.284-1.1l.003-.006.014-.026a2.28 2.28 0 01.82-.827h.002L13.152.681zm.757 1.295h-.001L2.648 8.616l6.248 4.247a.776.776 0 00.758-.01h.001l11.633-6.804-6.629-4.074a.75.75 0 00-.75.003zM18 9.709l-3.25 1.9v7.548L18 17.245V9.709zm1.5-.878v7.532l2.124-1.25a.777.777 0 00.387-.671V7.363L19.5 8.831zm-9.09 5.316l2.84-1.66v7.552l-3.233 1.902v-7.612c.134-.047.265-.107.391-.18l.002-.002zm-1.893 7.754V14.33a2.277 2.277 0 01-.393-.18l-.023-.014-6.102-4.147v7.003c0 .275.145.528.379.664l.025.014 6.114 4.232z"></path>`;
const $84c634e688af79ca$export$ecf27b59f07713a6 = `<path fill-rule="evenodd" d="M8.75 8a.75.75 0 00-.75.75v6.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-6.5a.75.75 0 00-.75-.75h-6.5zm.75 6.5v-5h5v5h-5z"></path><path fill-rule="evenodd" d="M15.25 1a.75.75 0 01.75.75V4h2.25c.966 0 1.75.784 1.75 1.75V8h2.25a.75.75 0 010 1.5H20v5h2.25a.75.75 0 010 1.5H20v2.25A1.75 1.75 0 0118.25 20H16v2.25a.75.75 0 01-1.5 0V20h-5v2.25a.75.75 0 01-1.5 0V20H5.75A1.75 1.75 0 014 18.25V16H1.75a.75.75 0 010-1.5H4v-5H1.75a.75.75 0 010-1.5H4V5.75C4 4.784 4.784 4 5.75 4H8V1.75a.75.75 0 011.5 0V4h5V1.75a.75.75 0 01.75-.75zm3 17.5a.25.25 0 00.25-.25V5.75a.25.25 0 00-.25-.25H5.75a.25.25 0 00-.25.25v12.5c0 .138.112.25.25.25h12.5z"></path>`;
const $84c634e688af79ca$export$10e30f44c09301bc = `<path d="M0 2.75C0 1.783.784 1 1.75 1h12.5c.967 0 1.75.783 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.457 1.457 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.189l2.72-2.719a.747.747 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm20.5 6h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5c.199 0 .39.079.53.22l2.72 2.719V19.25a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm-9.72-3.22-5 5a.747.747 0 0 1-1.06 0l-2.5-2.5a.749.749 0 1 1 1.06-1.06L7 8.689l4.47-4.469a.749.749 0 1 1 1.06 1.06Z"></path>`;
const $84c634e688af79ca$export$36333a3027a39ff0 = `<path d="M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm2-.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4Zm10 0v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z"></path>`;
const $84c634e688af79ca$export$bfbc94b2ece7eb0 = `<path d="M16.944 11h4.306a.75.75 0 0 1 0 1.5h-4.306a5.001 5.001 0 0 1-9.888 0H2.75a.75.75 0 0 1 0-1.5h4.306a5.001 5.001 0 0 1 9.888 0Zm-1.444.75a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0Z"></path>`;
const $84c634e688af79ca$export$33952fbd742aac4 = `<path fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM2.513 11.5h4.745c.1-3.037 1.1-5.49 2.093-7.204.39-.672.78-1.233 1.119-1.673C6.11 3.329 2.746 7 2.513 11.5zm4.77 1.5H2.552a9.505 9.505 0 007.918 8.377 15.698 15.698 0 01-1.119-1.673C8.413 18.085 7.47 15.807 7.283 13zm1.504 0h6.426c-.183 2.48-1.02 4.5-1.862 5.951-.476.82-.95 1.455-1.304 1.88L12 20.89l-.047-.057a13.888 13.888 0 01-1.304-1.88C9.807 17.5 8.969 15.478 8.787 13zm6.454-1.5H8.759c.1-2.708.992-4.904 1.89-6.451.476-.82.95-1.455 1.304-1.88L12 3.11l.047.057c.353.426.828 1.06 1.304 1.88.898 1.548 1.79 3.744 1.89 6.452zm1.476 1.5c-.186 2.807-1.13 5.085-2.068 6.704-.39.672-.78 1.233-1.118 1.673A9.505 9.505 0 0021.447 13h-4.731zm4.77-1.5h-4.745c-.1-3.037-1.1-5.49-2.093-7.204-.39-.672-.78-1.233-1.119-1.673 4.36.706 7.724 4.377 7.957 8.877z"></path>`;
const $84c634e688af79ca$export$1b5a510674cd8d75 = `<path d="M11.998 2.5A9.503 9.503 0 003.378 8H5.75a.75.75 0 010 1.5H2a1 1 0 01-1-1V4.75a.75.75 0 011.5 0v1.697A10.997 10.997 0 0111.998 1C18.074 1 23 5.925 23 12s-4.926 11-11.002 11C6.014 23 1.146 18.223 1 12.275a.75.75 0 011.5-.037 9.5 9.5 0 009.498 9.262c5.248 0 9.502-4.253 9.502-9.5s-4.254-9.5-9.502-9.5z"></path><path d="M12.5 7.25a.75.75 0 00-1.5 0v5.5c0 .27.144.518.378.651l3.5 2a.75.75 0 00.744-1.302L12.5 12.315V7.25z"></path>`;
const $84c634e688af79ca$export$39a30777d68f6342 = `<path d="M17.28 9.28a.75.75 0 00-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 00-1.06 1.06l3 3a.75.75 0 001.06 0l6.5-6.5z"></path><path d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zM2.5 12a9.5 9.5 0 009.5 9.5 9.5 9.5 0 009.5-9.5A9.5 9.5 0 0012 2.5 9.5 9.5 0 002.5 12z"></path>`;
const $84c634e688af79ca$export$f33c9743f53d9bae = `<path d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zM2.5 12a9.5 9.5 0 009.5 9.5 9.5 9.5 0 009.5-9.5A9.5 9.5 0 0012 2.5 9.5 9.5 0 002.5 12zm9.5 2a2 2 0 11-.001-3.999A2 2 0 0112 14z"></path>`;
const $84c634e688af79ca$export$fd71b7d70947f2b9 = `<path d="M12 13.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"></path><path d="M19.071 3.429h.001c3.905 3.905 3.905 10.237 0 14.142l-5.403 5.403a2.36 2.36 0 0 1-3.336 0l-5.375-5.375-.028-.028c-3.905-3.905-3.905-10.237 0-14.142 3.904-3.905 10.236-3.905 14.141 0ZM5.99 4.489v.001a8.5 8.5 0 0 0 0 12.02l.023.024.002.002 5.378 5.378a.859.859 0 0 0 1.214 0l5.403-5.404a8.5 8.5 0 0 0-.043-11.977A8.5 8.5 0 0 0 5.99 4.489Z"></path>`;
const $84c634e688af79ca$export$621c903272307c68 = `<path fill-rule="evenodd" d="M1.75 3A1.75 1.75 0 000 4.75v14c0 .966.784 1.75 1.75 1.75h20.5A1.75 1.75 0 0024 18.75v-14A1.75 1.75 0 0022.25 3H1.75zM1.5 4.75a.25.25 0 01.25-.25h20.5a.25.25 0 01.25.25v.852l-10.36 7a.25.25 0 01-.28 0l-10.36-7V4.75zm0 2.662V18.75c0 .138.112.25.25.25h20.5a.25.25 0 00.25-.25V7.412l-9.52 6.433c-.592.4-1.368.4-1.96 0L1.5 7.412z"></path>`;
const $84c634e688af79ca$export$cda80d001f0f5043 = `<path d="M12.292 2.06v-.001l11.25 4.75a.749.749 0 0 1 0 1.382L19 10.108V15a.75.75 0 0 1-.11.391h-.001a2.84 2.84 0 0 1-.392.482c-.249.256-.625.58-1.163.896-1.08.638-2.776 1.23-5.334 1.23-.673 0-1.286-.041-1.846-.113a.75.75 0 0 1 .192-1.487c.492.063 1.042.1 1.654.1 2.317 0 3.746-.533 4.572-1.021.31-.178.596-.397.849-.65l.079-.085V10.74l-5.208 2.2a.75.75 0 0 1-.584 0L5.75 10.424v3.17c.502.129.96.391 1.327.758.579.578.923 1.41.923 2.428v4.5a.761.761 0 0 1-.345.634 2.157 2.157 0 0 1-.21.117 3.923 3.923 0 0 1-.52.213A6.121 6.121 0 0 1 5 22.532a6.092 6.092 0 0 1-1.925-.288 4.065 4.065 0 0 1-.52-.213 1.816 1.816 0 0 1-.22-.124.757.757 0 0 1-.335-.624v-4.5c0-1.02.344-1.85.923-2.43a2.904 2.904 0 0 1 1.327-.757V9.793L.458 8.19a.75.75 0 0 1 0-1.38l11.25-4.75a.75.75 0 0 1 .584 0ZM12 11.436 21.322 7.5 12 3.564 2.678 7.5ZM5 15c-.377 0-.745.141-1.017.413-.265.265-.483.7-.483 1.368v4.022c.299.105.797.228 1.5.228s1.201-.123 1.5-.228V16.78c0-.669-.218-1.103-.483-1.368A1.433 1.433 0 0 0 5 15Z"></path>`;
const $84c634e688af79ca$export$ff9b16d1219fcc0a = `<path d="M7.25 12a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zM6.5 9.25a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zM7.25 5a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zM10 12.75a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zm.75-4.25a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zM10 5.75a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zM14.25 12a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zm-.75-2.75a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zM14.25 5a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5z"></path><path fill-rule="evenodd" d="M3 20a2 2 0 002 2h3.75a.75.75 0 00.75-.75V19h3v2.25c0 .414.336.75.75.75H17c.092 0 .183-.006.272-.018a.758.758 0 00.166.018H21.5a2 2 0 002-2v-7.625a2 2 0 00-.8-1.6l-1-.75a.75.75 0 10-.9 1.2l1 .75a.5.5 0 01.2.4V20a.5.5 0 01-.5.5h-2.563c.041-.16.063-.327.063-.5V3a2 2 0 00-2-2H5a2 2 0 00-2 2v17zm2 .5a.5.5 0 01-.5-.5V3a.5.5 0 01.5-.5h12a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-3v-2.25a.75.75 0 00-.75-.75h-4.5a.75.75 0 00-.75.75v2.25H5z"></path>`;
const $84c634e688af79ca$export$555a75e14f058996 = `<path fill-rule="evenodd" d="M12.876.64a1.75 1.75 0 00-1.75 0l-8.25 4.762a1.75 1.75 0 00-.875 1.515v9.525c0 .625.334 1.203.875 1.515l8.25 4.763a1.75 1.75 0 001.75 0l8.25-4.762a1.75 1.75 0 00.875-1.516V6.917a1.75 1.75 0 00-.875-1.515L12.876.639zm-1 1.298a.25.25 0 01.25 0l7.625 4.402-7.75 4.474-7.75-4.474 7.625-4.402zM3.501 7.64v8.803c0 .09.048.172.125.216l7.625 4.402v-8.947L3.501 7.64zm9.25 13.421l7.625-4.402a.25.25 0 00.125-.216V7.639l-7.75 4.474v8.947z"></path>`;
const $84c634e688af79ca$export$5a3e17ae14a6e634 = `<path fill-rule="evenodd" d="M12 2.5a5.5 5.5 0 00-3.096 10.047 9.005 9.005 0 00-5.9 8.18.75.75 0 001.5.045 7.5 7.5 0 0114.993 0 .75.75 0 101.499-.044 9.005 9.005 0 00-5.9-8.181A5.5 5.5 0 0012 2.5zM8 8a4 4 0 118 0 4 4 0 01-8 0z"></path>`;
const $84c634e688af79ca$export$2d8c7b156eade6e0 = `<path d="M3 2.75A2.75 2.75 0 0 1 5.75 0h14.5a.75.75 0 0 1 .75.75v20.5a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1 0-1.5h5.25v-4H6A1.5 1.5 0 0 0 4.5 18v.75c0 .716.43 1.334 1.05 1.605a.75.75 0 0 1-.6 1.374A3.251 3.251 0 0 1 3 18.75ZM19.5 1.5H5.75c-.69 0-1.25.56-1.25 1.25v12.651A2.989 2.989 0 0 1 6 15h13.5Z"></path><path d="M7 18.25a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5.01a.25.25 0 0 1-.397.201l-2.206-1.604a.25.25 0 0 0-.294 0L7.397 23.46a.25.25 0 0 1-.397-.2v-5.01Z"></path>`;
const $84c634e688af79ca$export$650e6e0bb930af3d = `<path fill-rule="evenodd" d="M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0120.25 22H3.75A1.75 1.75 0 012 20.25V3.75zM3.5 9v11.25c0 .138.112.25.25.25H7.5V9h-4zm4-1.5h-4V3.75a.25.25 0 01.25-.25H7.5v4zM9 9v11.5h11.25a.25.25 0 00.25-.25V9H9zm11.5-1.5H9v-4h11.25a.25.25 0 01.25.25V7.5z"></path>`;
const $84c634e688af79ca$export$fc296c5b33ee4678 = `<path d="M20 5.5a3.498 3.498 0 0 1-6.062 2.385l-5.112 3.021a3.498 3.498 0 0 1 0 2.188l5.112 3.021a3.5 3.5 0 1 1-.764 1.29l-5.112-3.02a3.499 3.499 0 1 1-3.843-5.642 3.499 3.499 0 0 1 3.843.872l5.112-3.021A3.5 3.5 0 1 1 20 5.5Zm-1.5 13a2 2 0 1 0-3.999-.001 2 2 0 0 0 3.999.001Zm0-13a2 2 0 1 0-3.999-.001A2 2 0 0 0 18.5 5.5ZM5.5 14a2 2 0 1 0 .001-3.999A2 2 0 0 0 5.5 14Z"></path>`;
const $84c634e688af79ca$export$e2895d44046646a0 = `<path fill-rule="evenodd" d="M.408 15.13a2 2 0 01.59-2.642L17.038 1.33a2 2 0 012.85.602l2.828 4.644a2 2 0 01-.851 2.847l-17.762 8.43a2 2 0 01-2.59-.807L.408 15.13zm5.263-4.066l7.842-5.455 2.857 4.76-8.712 4.135-1.987-3.44zm-1.235.86L1.854 13.72a.5.5 0 00-.147.66l1.105 1.915a.5.5 0 00.648.201l2.838-1.347-1.862-3.225zm13.295-2.2L14.747 4.75l3.148-2.19a.5.5 0 01.713.151l2.826 4.644a.5.5 0 01-.212.712l-3.49 1.656z"></path><path d="M17.155 22.87a.75.75 0 00.226-1.036l-4-6.239a.75.75 0 00-.941-.278l-2.75 1.25a.75.75 0 00-.318.274l-3.25 4.989a.75.75 0 001.256.819l3.131-4.806.51-.232v5.64a.75.75 0 101.5 0v-6.22l3.6 5.613a.75.75 0 001.036.226z"></path>`;
const $84c634e688af79ca$export$edee47a68ecb4770 = `<path d="M4 20.25V18a.75.75 0 0 1 1.5 0v2.25c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V18a.75.75 0 0 1 1.5 0v2.25A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25Z"></path><path d="M5.22 9.53a.749.749 0 0 1 0-1.06l6.25-6.25a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 1 1-1.06 1.06l-4.97-4.969V16.75a.75.75 0 0 1-1.5 0V4.561L6.28 9.53a.749.749 0 0 1-1.06 0Z"></path>`;
const $84c634e688af79ca$export$db80f3ef24ef3261 = `<path fill-rule="evenodd" d="M1.757 10.243a6 6 0 118.486-8.486 6 6 0 01-8.486 8.486zM6 4.763l-2-2L2.763 4l2 2-2 2L4 9.237l2-2 2 2L9.237 8l-2-2 2-2L8 2.763l-2 2z"></path>`;
const $84c634e688af79ca$export$bf3944942cf67ec4 = `<path fill-rule="evenodd" d="M6 0a6 6 0 100 12A6 6 0 006 0zm3 5H3v2h6V5z"></path>`;
const $84c634e688af79ca$export$58f7cbe4956d191c = ()=>{
    const a = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    const b = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    const c = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    return `<linearGradient id="${a}" x1="24" x2="24" y1="6.708" y2="14.977" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#eba600"/><stop offset="1" stop-color="#c28200"/></linearGradient><path fill="url(#${a})" d="M24.414,10.414l-2.536-2.536C21.316,7.316,20.553,7,19.757,7L5,7C3.895,7,3,7.895,3,9l0,30	c0,1.105,0.895,2,2,2l38,0c1.105,0,2-0.895,2-2V13c0-1.105-0.895-2-2-2l-17.172,0C25.298,11,24.789,10.789,24.414,10.414z"/><linearGradient id="${b}" x1="24" x2="24" y1="10.854" y2="40.983" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ffd869"/><stop offset="1" stop-color="#fec52b"/></linearGradient><path fill="url(#${b})" d="M21.586,14.414l3.268-3.268C24.947,11.053,25.074,11,25.207,11H43c1.105,0,2,0.895,2,2v26	c0,1.105-0.895,2-2,2H5c-1.105,0-2-0.895-2-2V15.5C3,15.224,3.224,15,3.5,15h16.672C20.702,15,21.211,14.789,21.586,14.414z"/><path fill="#c28200" d="M36,11.5v1c0,0.276-0.224,0.5-0.5,0.5H34c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h1.5	C35.776,11,36,11.224,36,11.5z M34,14c0-0.552-0.448-1-1-1h-1.5c-0.276,0-0.5,0.224-0.5,0.5v1c0,0.276,0.224,0.5,0.5,0.5H33	C33.552,15,34,14.552,34,14z M33,16c0,0.552,0.448,1,1,1h1.5c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5H34	C33.448,15,33,15.448,33,16z M34,18c0-0.552-0.448-1-1-1h-1.5c-0.276,0-0.5,0.224-0.5,0.5v1c0,0.276,0.224,0.5,0.5,0.5H33	C33.552,19,34,18.552,34,18z M33,20c0,0.552,0.448,1,1,1h1.5c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5H34	C33.448,19,33,19.448,33,20z M33,24c0,0.552,0.448,1,1,1h1.5c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5H34	C33.448,23,33,23.448,33,24z M34,22c0-0.552-0.448-1-1-1h-1.5c-0.276,0-0.5,0.224-0.5,0.5v1c0,0.276,0.224,0.5,0.5,0.5H33	C33.552,23,34,22.552,34,22z"/><linearGradient id="${c}" x1="33.5" x2="33.5" y1="25.944" y2="37.581" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#4b4b4b"/><stop offset="1" stop-color="#3b3b3b"/></linearGradient><path fill="url(#${c})" d="M36.128,26.848C36.055,26.358,35.635,26,35.139,26h-3.279c-0.495,0-0.915,0.358-0.988,0.848	C30.603,28.65,30,32.761,30,33.5c0,1.933,1.567,3.5,3.5,3.5s3.5-1.567,3.5-3.5C37,32.761,36.397,28.65,36.128,26.848z M33.5,35	c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S34.328,35,33.5,35z"/>`;
};
const $84c634e688af79ca$export$29cc6e2997da5d20 = ()=>{
    const a = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    return `<rect width="16" height="9" x="28" y="15" fill="#21a366"/><path fill="#185c37" d="M44,24H12v16c0,1.105,0.895,2,2,2h28c1.105,0,2-0.895,2-2V24z"/><rect width="16" height="9" x="28" y="24" fill="#107c42"/><rect width="16" height="9" x="12" y="15" fill="#3fa071"/><path fill="#33c481" d="M42,6H28v9h16V8C44,6.895,43.105,6,42,6z"/><path fill="#21a366" d="M14,6h14v9H12V8C12,6.895,12.895,6,14,6z"/><path d="M22.319,13H12v24h10.319C24.352,37,26,35.352,26,33.319V16.681C26,14.648,24.352,13,22.319,13z" opacity=".05"/><path d="M22.213,36H12V13.333h10.213c1.724,0,3.121,1.397,3.121,3.121v16.425	C25.333,34.603,23.936,36,22.213,36z" opacity=".07"/><path d="M22.106,35H12V13.667h10.106c1.414,0,2.56,1.146,2.56,2.56V32.44C24.667,33.854,23.52,35,22.106,35z" opacity=".09"/><linearGradient id="${a}" x1="4.725" x2="23.055" y1="14.725" y2="33.055" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#18884f"/><stop offset="1" stop-color="#0b6731"/></linearGradient><path fill="url(#${a})" d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"/><path fill="#fff" d="M9.807,19h2.386l1.936,3.754L16.175,19h2.229l-3.071,5l3.141,5h-2.351l-2.11-3.93L11.912,29H9.526	l3.193-5.018L9.807,19z"/>`;
};
const $84c634e688af79ca$export$d9a0bc075772ac34 = ()=>{
    const a = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    return `<path fill="#d35230" d="M8,24c0,9.941,8.059,18,18,18s18-8.059,18-18H26H8z"/><path fill="#ff8f6b" d="M26,6v18h18C44,14.059,35.941,6,26,6z"/><path fill="#ed6c47" d="M26,6C16.059,6,8,14.059,8,24h18V6z"/><path d="M26,16.681C26,14.648,24.352,13,22.319,13H11.774C9.417,16.044,8,19.852,8,24	c0,5.116,2.145,9.723,5.571,13h8.747C24.352,37,26,35.352,26,33.319V16.681z" opacity=".05"/><path d="M22.213,13.333H11.525C9.32,16.321,8,20.002,8,24c0,4.617,1.753,8.814,4.611,12h9.602	c1.724,0,3.121-1.397,3.121-3.121V16.454C25.333,14.731,23.936,13.333,22.213,13.333z" opacity=".07"/><path d="M22.106,13.667H11.276C9.218,16.593,8,20.151,8,24c0,4.148,1.417,7.956,3.774,11h10.332	c1.414,0,2.56-1.146,2.56-2.56V16.227C24.667,14.813,23.52,13.667,22.106,13.667z" opacity=".09"/><linearGradient id="${a}" x1="4.586" x2="22.77" y1="14.586" y2="32.77" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ca4e2a"/><stop offset="1" stop-color="#b63016"/></linearGradient><path fill="url(#${a})" d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"/><path fill="#fff" d="M14.673,19.012H10v10h2.024v-3.521H14.3c1.876,0,3.397-1.521,3.397-3.397v-0.058	C17.697,20.366,16.343,19.012,14.673,19.012z M15.57,22.358c0,0.859-0.697,1.556-1.556,1.556h-1.99v-3.325h1.99	c0.859,0,1.556,0.697,1.556,1.556V22.358z"/>`;
};
const $84c634e688af79ca$export$c0a3bce27570b6d0 = ()=>{
    const a = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    const b = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    const c = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    const d = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    const e = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    return `<linearGradient id="${a}" x1="28" x2="28" y1="14.966" y2="6.45" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#42a3f2"/><stop offset="1" stop-color="#42a4eb"/></linearGradient><path fill="url(#${a})" d="M42,6H14c-1.105,0-2,0.895-2,2v7.003h32V8C44,6.895,43.105,6,42,6z"/><linearGradient id="${b}" x1="28" x2="28" y1="42" y2="33.054" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#11408a"/><stop offset="1" stop-color="#103f8f"/></linearGradient><path fill="url(#${b})" d="M12,33.054V40c0,1.105,0.895,2,2,2h28c1.105,0,2-0.895,2-2v-6.946H12z"/><linearGradient id="${c}" x1="28" x2="28" y1="-15.46" y2="-15.521" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#3079d6"/><stop offset="1" stop-color="#297cd2"/></linearGradient><path fill="url(#${c})" d="M12,15.003h32v9.002H12V15.003z"/><linearGradient id="${d}" x1="12" x2="44" y1="28.53" y2="28.53" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#1d59b3"/><stop offset="1" stop-color="#195bbc"/></linearGradient><path fill="url(#${d})" d="M12,24.005h32v9.05H12V24.005z"/><path d="M22.319,13H12v24h10.319C24.352,37,26,35.352,26,33.319V16.681C26,14.648,24.352,13,22.319,13z" opacity=".05"/><path d="M22.213,36H12V13.333h10.213c1.724,0,3.121,1.397,3.121,3.121v16.425	C25.333,34.603,23.936,36,22.213,36z" opacity=".07"/><path d="M22.106,35H12V13.667h10.106c1.414,0,2.56,1.146,2.56,2.56V32.44C24.667,33.854,23.52,35,22.106,35z" opacity=".09"/><linearGradient id="${e}" x1="4.744" x2="23.494" y1="14.744" y2="33.493" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#256ac2"/><stop offset="1" stop-color="#1247ad"/></linearGradient><path fill="url(#${e})" d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"/><path fill="#fff" d="M18.403,19l-1.546,7.264L15.144,19h-2.187l-1.767,7.489L9.597,19H7.641l2.344,10h2.352l1.713-7.689	L15.764,29h2.251l2.344-10H18.403z"/>`;
};
const $84c634e688af79ca$export$159b3fe6c427bb44 = ()=>{
    const a = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    const b = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    return `<linearGradient id="${a}" x1="6.949" x2="35.445" y1="6.949" y2="35.445" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fede00"/><stop offset="1" stop-color="#ffd000"/></linearGradient><path fill="url(#${a})" d="M29,42H8c-1.105,0-2-0.895-2-2V8c0-1.105,0.895-2,2-2h32c1.105,0,2,0.895,2,2v21L29,42z"/><linearGradient id="${b}" x1="29.592" x2="35.671" y1="29.592" y2="35.671" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#4b4b4b"/><stop offset="1" stop-color="#3b3b3b"/></linearGradient><path fill="url(#${b})" d="M31,29h11L29,42V31C29,29.895,29.895,29,31,29z"/><line x1="13" x2="35" y1="18" y2="18" fill="none" stroke="#e8ba13" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><line x1="13" x2="35" y1="24" y2="24" fill="none" stroke="#e8ba13" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><line x1="13" x2="23" y1="30" y2="30" fill="none" stroke="#e8ba13" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/>`;
};
const $84c634e688af79ca$export$65168b0c06a6c4ec = ()=>{
    // const a =newElementId();
    return `<path fill="#b30b00" d="M38,42H10c-2.209,0-4-1.791-4-4V10c0-2.209,1.791-4,4-4h28c2.209,0,4,1.791,4,4v28	C42,40.209,40.209,42,38,42z"/><path fill="#fff" d="M35.241,26.799c-1.692-1.757-6.314-1.041-7.42-0.911c-1.627-1.562-2.734-3.45-3.124-4.101	c0.586-1.757,0.976-3.515,1.041-5.402c0-1.627-0.651-3.385-2.473-3.385c-0.651,0-1.237,0.391-1.562,0.911	c-0.781,1.367-0.456,4.101,0.781,6.899c-0.716,2.018-1.367,3.97-3.189,7.42c-1.888,0.781-5.858,2.604-6.183,4.556	c-0.13,0.586,0.065,1.172,0.521,1.627C14.088,34.805,14.673,35,15.259,35c2.408,0,4.751-3.32,6.379-6.118	c1.367-0.456,3.515-1.107,5.663-1.497c2.538,2.213,4.751,2.538,5.923,2.538c1.562,0,2.148-0.651,2.343-1.237	C35.892,28.036,35.697,27.32,35.241,26.799z M33.614,27.905c-0.065,0.456-0.651,0.911-1.692,0.651	c-1.237-0.325-2.343-0.911-3.32-1.692c0.846-0.13,2.734-0.325,4.101-0.065C33.224,26.929,33.744,27.254,33.614,27.905z M22.744,14.497c0.13-0.195,0.325-0.325,0.521-0.325c0.586,0,0.716,0.716,0.716,1.302c-0.065,1.367-0.325,2.734-0.781,4.036	C22.224,16.905,22.419,15.083,22.744,14.497z M22.614,27.124c0.521-1.041,1.237-2.864,1.497-3.645	c0.586,0.976,1.562,2.148,2.083,2.669C26.194,26.213,24.176,26.604,22.614,27.124z M18.774,29.728	c-1.497,2.473-3.059,4.036-3.905,4.036c-0.13,0-0.26-0.065-0.391-0.13c-0.195-0.13-0.26-0.325-0.195-0.586	C14.478,32.136,16.17,30.899,18.774,29.728z"/>`;
};
const $84c634e688af79ca$export$96888ae35506642f = ()=>{
    const a = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    const b = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    return `<path fill="#50e6ff" d="M40,6H8C6.895,6,6,6.895,6,8v30c0,1.105,0.895,2,2,2h32c1.105,0,2-0.895,2-2V8 C42,6.895,41.105,6,40,6z"/><linearGradient id="${a}" x1="18" x2="42" y1="32.093" y2="32.093" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#3ccbf4"/><stop offset="1" stop-color="#1fa0e5"/></linearGradient><path fill="url(#${a})" d="M32.065,23.065c-1.149-1.149-3.005-1.174-4.185-0.057L18,32.368V42h22c1.105,0,2-0.895,2-2 v-7L32.065,23.065z"/><circle cx="30.5" cy="14.5" r="3.5" fill="#fff8de"/><linearGradient id="${b}" x1="23.91" x2="23.91" y1="18.186" y2="42" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#28afea"/><stop offset="1" stop-color="#0b88da"/></linearGradient><path fill="url(#${b})" d="M8,42h32c0.811,0,1.507-0.485,1.82-1.18L20.065,19.065c-1.149-1.149-3.005-1.174-4.185-0.057 L6,28.368V40C6,41.105,6.895,42,8,42z"/>`;
};
const $84c634e688af79ca$export$bb84843656fecdd6 = ()=>{
    const a = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    const b = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    return `<radialGradient id="${a}" cx="50.744" cy="33.882" r="23.827" gradientTransform="matrix(1.0244 0 0 1.0645 -1.098 -1.58)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#bd8af5"/><stop offset=".137" stop-color="#b88bf5"/><stop offset=".309" stop-color="#a88ff3"/><stop offset=".499" stop-color="#8f96f2"/><stop offset=".702" stop-color="#6b9eef"/><stop offset=".913" stop-color="#3eaaec"/><stop offset="1" stop-color="#29afea"/></radialGradient><path fill="url(#${a})" d="M43,41H5c-1.105,0-2-0.895-2-2V10c0-1.105,0.895-2,2-2h38c1.105,0,2,0.895,2,2v29	C45,40.105,44.105,41,43,41z"/><linearGradient id="${b}" x1="21" x2="21" y1="20.753" y2="41.352" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#124787"/><stop offset=".923" stop-color="#173b75"/><stop offset="1" stop-color="#173a73"/></linearGradient><path fill="url(#${b})" d="M19.715,21.715c-1.223-1.223-3.206-1.223-4.429,0L3,34v5c0,1.105,0.895,2,2,2h34	L19.715,21.715z"/><path fill="#436dcd" d="M43,41c1.105,0,2-0.895,2-2v-1L32.715,25.715c-1.223-1.223-3.206-1.223-4.429,0L13,41H43z"/><path fill="#fff" d="M41,16h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C42,15.552,41.552,16,41,16z"/><path fill="#fff" d="M41,23h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C42,22.552,41.552,23,41,23z"/><path fill="#fff" d="M41,30h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C42,29.552,41.552,30,41,30z"/><path fill="#fff" d="M41,37h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C42,36.552,41.552,37,41,37z"/><path fill="#fff" d="M9,16H7c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C10,15.552,9.552,16,9,16z"/><path fill="#fff" d="M9,23H7c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C10,22.552,9.552,23,9,23z"/><path fill="#fff" d="M9,30H7c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C10,29.552,9.552,30,9,30z"/><path fill="#fff" d="M9,37H7c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C10,36.552,9.552,37,9,37z"/>`;
};
const $84c634e688af79ca$export$cfe0d2093124992d = ()=>{
    const a = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    const b = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    // return `<linearGradient id="${a}" x1="64" x2="64" y1="36.83" y2="104.33" gradientUnits="userSpaceOnUse"><stop stop-color="#ffc107" offset="0"/><stop stop-color="#ffd54f" offset="1"/></linearGradient><linearGradient id="${a}" x1="64" x2="64" y1="8.46" y2="72.15" gradientUnits="userSpaceOnUse"><stop stop-color="#ffe082" offset="0"/><stop stop-color="#ffca28" offset=".99"/></linearGradient><path d="M120 104H8c-2.2 0-4-1.8-4-4V28c0-2.2 1.8-4 4-4h112c2.2 0 4 1.8 4 4v72c0 2.2-1.8 4-4 4z" fill="url(#${a})" transform="translate(2.67 2.67) scale(.33333)"/><path d="M124 30.2V28c0-2.2-1.8-4-4-4H8c-2.2 0-4 1.8-4 4v2l59.9 46.1z" fill="url(#${b})" transform="translate(2.67 2.67) scale(.33333)"/><g fill="#ffb300" stroke-width="3"><path d="M17.37 23.27 4.67 37.13a1.2 1.2 0 0 1-.6-.83l12.6-13.73zM43.93 36.43c-.1.34-.33.6-.66.77L30.6 23.23l.73-.66z"/><path d="M44 12.33v1.27L23.97 28.67 4 13.53V12.3l19.97 15.13z"/></g><path d="M42.67 11.67c.2 0 .33.16.33.33v24c0 .2-.13.33-.33.33H5.33c-.2 0-.33-.13-.33-.33V12c0-.17.13-.33.33-.33zm0-1H5.33C4.6 10.67 4 11.27 4 12v24c0 .73.6 1.33 1.33 1.33h37.34c.73 0 1.33-.6 1.33-1.33V12c0-.73-.6-1.33-1.33-1.33z" fill="#444" opacity=".2"/>`;
    return `<linearGradient id="${a}" x1="16" x2="16" y2="23.27" gradientTransform="scale(1.25)" gradientUnits="userSpaceOnUse"><stop stop-color="#fac227" offset="0"/><stop stop-color="#faa627" offset="1"/></linearGradient><linearGradient id="${b}" x1="16" x2="16" y2="14.79" gradientTransform="scale(1.25)" gradientUnits="userSpaceOnUse"><stop stop-color="#fce4b1" offset="0"/><stop stop-color="#ffd272" offset="1"/></linearGradient><path d="M36.36 0H3.64C1.63 0 0 1.63 0 3.64v21.81c0 2.01 1.63 3.64 3.64 3.64h32.72c2.01 0 3.64-1.63 3.64-3.64V3.64C40 1.63 38.37 0 36.36 0z" fill="url(#${a})" transform="translate(4 9.45)"/><path d="M36.36 0H3.64a3.6 3.6 0 0 0-2.57 1.07l16.36 16.36a3.6 3.6 0 0 0 3.96.79 3.6 3.6 0 0 0 1.18-.8L38.94 1.08A3.6 3.6 0 0 0 36.36 0z" clip-rule="evenodd" fill="url(#${b})" fill-rule="evenodd" transform="translate(4 9.45)"/>`;
};
function $84c634e688af79ca$export$1ca1ec8b29a4ce27(content, classesOrArgs) {
    let classes;
    let hidden;
    let target;
    let ariaHidden;
    let ariaLabel;
    let size;
    let viewBox;
    let octicon;
    if (classesOrArgs === undefined || typeof classesOrArgs === 'string') {
        classes = classesOrArgs || '';
        hidden = false;
        target = '';
        ariaHidden = true;
        ariaLabel = '';
        size = '1em';
        viewBox = 16;
        octicon = true;
    } else {
        classes = classesOrArgs.classes || '';
        hidden = classesOrArgs.hidden || false;
        target = classesOrArgs.target || '';
        ariaHidden = classesOrArgs.ariaHidden || true;
        ariaLabel = classesOrArgs.ariaLabel || '';
        size = classesOrArgs.size ?? '1em';
        viewBox = classesOrArgs.viewBox ?? 16;
        octicon = classesOrArgs.octicon ?? true;
    }
    if (octicon) classes = 'octicon ' + classes;
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${size}"
    height="${size}"
    class="${classes}"
    viewBox="0 0 ${viewBox} ${viewBox}"
    ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('hidden', hidden)}
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-hidden', ariaHidden ? 'true' : null)}
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-label', ariaLabel)}
  >
    ${(0, $f4d1565f2a6712b7$export$b6e69390c23686fb)(content)}
  </svg>`;
}
const $84c634e688af79ca$export$22aebbff0935e083 = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 1000 1000"
  width="1em"
  height="1em"
  class="octicon"
  aria-hidden="true"
>
  <path
    d="M292.92 3.5c-53.2 2.51-89.53 11-121.29 23.48-32.87 12.81-60.73 30-88.45 57.82s-44.79 55.7-57.51 88.62c-12.31 31.83-20.65 68.19-23 121.42S-.2 365.18.06 500.96.92 653.76 3.5 707.1c2.54 53.19 11 89.51 23.48 121.28 12.83 32.87 30 60.72 57.83 88.45s55.69 44.76 88.69 57.5c31.8 12.29 68.17 20.67 121.39 23s70.35 2.87 206.09 2.61 152.83-.86 206.16-3.39 89.46-11.05 121.24-23.47c32.87-12.86 60.74-30 88.45-57.84s44.77-55.74 57.48-88.68c12.32-31.8 20.69-68.17 23-121.35 2.33-53.37 2.88-70.41 2.62-206.17s-.87-152.78-3.4-206.1-11-89.53-23.47-121.32c-12.85-32.87-30-60.7-57.82-88.45s-55.74-44.8-88.67-57.48c-31.82-12.31-68.17-20.7-121.39-23S634.83-.2 499.04.06 346.25.9 292.92 3.5m5.84 903.88c-48.75-2.12-75.22-10.22-92.86-17-23.36-9-40-19.88-57.58-37.29s-28.38-34.11-37.5-57.42c-6.85-17.64-15.1-44.08-17.38-92.83-2.48-52.69-3-68.51-3.29-202s.22-149.29 2.53-202c2.08-48.71 10.23-75.21 17-92.84 9-23.39 19.84-40 37.29-57.57s34.1-28.39 57.43-37.51c17.62-6.88 44.06-15.06 92.79-17.38 52.73-2.5 68.53-3 202-3.29s149.31.21 202.06 2.53c48.71 2.12 75.22 10.19 92.83 17 23.37 9 40 19.81 57.57 37.29s28.4 34.07 37.52 57.45c6.89 17.57 15.07 44 17.37 92.76 2.51 52.73 3.08 68.54 3.32 202s-.23 149.31-2.54 202c-2.13 48.75-10.21 75.23-17 92.89-9 23.35-19.85 40-37.31 57.56s-34.09 28.38-57.43 37.5c-17.6 6.87-44.07 15.07-92.76 17.39-52.73 2.48-68.53 3-202.05 3.29s-149.27-.25-202-2.53m407.6-674.61a60 60 0 1 0 59.88-60.1 60 60 0 0 0-59.88 60.1M243.27 500.5c.28 141.8 115.44 256.49 257.21 256.22S757.02 641.3 756.75 499.5 641.29 242.98 499.5 243.26 243 358.72 243.27 500.5m90.06-.18a166.67 166.67 0 1 1 167 166.34 166.65 166.65 0 0 1-167-166.34"
  />
</svg>`;
const $84c634e688af79ca$export$5602d9a6ccbec32b = {
    'google-oauth2': (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    aria-hidden="true"
    class="octicon"
  >
    <g clip-path="url(#a)">
      <path
        fill="#ea4335"
        d="M8 3.167c1.18 0 2.237.406 3.07 1.2l2.284-2.284C11.967.793 10.157 0 8 0A8 8 0 0 0 .854 4.407l2.66 2.063c.63-1.897 2.4-3.303 4.486-3.303"
      />
      <path
        fill="#4285f4"
        d="M15.66 8.183c0-.523-.05-1.03-.127-1.516H8v3.006h4.313a3.72 3.72 0 0 1-1.593 2.394l2.577 2c1.503-1.394 2.363-3.454 2.363-5.884"
      />
      <path
        fill="#fbbc05"
        d="M3.51 9.53A4.9 4.9 0 0 1 3.257 8c0-.533.09-1.047.253-1.53L.85 4.407A8 8 0 0 0 0 8a7.9 7.9 0 0 0 .853 3.593z"
      />
      <path
        fill="#34a853"
        d="M8 16c2.16 0 3.977-.71 5.297-1.937l-2.577-2c-.717.484-1.64.767-2.72.767-2.087 0-3.857-1.407-4.49-3.303L.85 11.59A8 8 0 0 0 8 16"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath>
    </defs>
  </svg>`,
    apple: (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    aria-hidden="true"
    class="octicon"
  >
    <g clip-path="url(#a)">
      <path
        fill="currentColor"
        d="M8.088 4.354c.656 0 1.478-.444 1.968-1.035.443-.536.767-1.284.767-2.033 0-.101-.01-.203-.028-.286-.73.028-1.608.49-2.134 1.109-.416.47-.795 1.21-.795 1.967 0 .111.019.222.028.259.046.01.12.019.194.019m-2.31 11.178c.897 0 1.294-.6 2.412-.6 1.136 0 1.385.581 2.383.581.98 0 1.635-.905 2.254-1.792.693-1.016.98-2.014.998-2.06-.065-.018-1.94-.785-1.94-2.938 0-1.866 1.478-2.707 1.561-2.771-.979-1.404-2.466-1.441-2.873-1.441-1.1 0-1.995.665-2.559.665-.61 0-1.413-.628-2.365-.628C3.84 4.548 2 6.044 2 8.87c0 1.755.684 3.612 1.524 4.813.72 1.016 1.35 1.848 2.254 1.848"
      />
    </g>
    <defs>
      <clipPath id="a"><path d="M0 0h16v16H0z" /></clipPath>
    </defs>
  </svg>`,
    yahoo: (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1387 1233"
    width="1em"
    height="1em"
    aria-hidden="true"
    class="octicon"
  >
    <path
      fill="#5f01d1"
      d="M0 300.1h264.5l154 394 156-394H832l-387.8 932.7H185.1l106.1-247.1zm1131.8 314.8H843.4L1099.4 0h287.3zM919 994.2c-88.6 0-160.2-71.6-160.2-160.2S830.4 673.8 919 673.8s160.2 71.6 160.2 160.2-71.6 160.2-160.2 160.2"
    />
  </svg>`
};


const $d5d33444928aec88$export$eaf979886d81968c = [
    'activity',
    'activity_definition',
    'claim_submission',
    'payer_file',
    'user'
];
const $d5d33444928aec88$export$5bccd096041570b4 = [
    'activities',
    'activity-definitions',
    'claim-submissions',
    'payer-files',
    'users'
];
const $d5d33444928aec88$export$3b981eac32477b40 = {
    activity: 'activities',
    activity_definition: 'activity-definitions',
    claim_submission: 'claim-submissions',
    payer_file: 'payer-files',
    user: 'users'
};
const $d5d33444928aec88$export$dc056cc4b4df1c55 = {
    activities: 'activity',
    'activity-definitions': 'activity_definition',
    'claim-submissions': 'claim_submission',
    'payer-files': 'payer_file',
    users: 'user'
};
const $d5d33444928aec88$var$oneMb = 1000000;
const $d5d33444928aec88$export$e8852085401b0377 = [
    {
        category: (locale)=>(0, $b11db1b62d4a8f76$export$6a584c99ae610576)[locale],
        extensions: [
            'gif'
        ],
        contentType: 'image/gif',
        maxBytes: 10 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$96888ae35506642f),
        disposition: 'inline'
    },
    {
        category: (locale)=>(0, $b11db1b62d4a8f76$export$6a584c99ae610576)[locale],
        extensions: [
            'jpeg',
            'jpg'
        ],
        contentType: 'image/jpeg',
        maxBytes: 10 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$96888ae35506642f),
        disposition: 'inline'
    },
    {
        category: (locale)=>(0, $b11db1b62d4a8f76$export$6a584c99ae610576)[locale],
        extensions: [
            'png'
        ],
        contentType: 'image/png',
        maxBytes: 10 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$96888ae35506642f),
        disposition: 'inline'
    },
    {
        category: (locale)=>(0, $b11db1b62d4a8f76$export$6a584c99ae610576)[locale],
        extensions: [
            'svg'
        ],
        contentType: 'image/svg+xml',
        maxBytes: $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$96888ae35506642f),
        disposition: 'inline'
    },
    {
        category: (locale)=>(0, $b11db1b62d4a8f76$export$6a584c99ae610576)[locale],
        extensions: [
            'tif',
            'tiff'
        ],
        contentType: 'image/tiff',
        maxBytes: 10 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$96888ae35506642f),
        disposition: 'inline'
    },
    {
        category: (locale)=>(0, $b11db1b62d4a8f76$export$cfeaf0cdb33173c8)[locale],
        extensions: [
            'mov'
        ],
        contentType: 'video/quicktime',
        maxBytes: 100 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$bb84843656fecdd6),
        disposition: 'inline'
    },
    {
        category: (locale)=>(0, $b11db1b62d4a8f76$export$cfeaf0cdb33173c8)[locale],
        extensions: [
            'mp4'
        ],
        contentType: 'video/mp4',
        maxBytes: 100 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$bb84843656fecdd6),
        disposition: 'inline'
    },
    {
        category: (locale)=>(0, $b11db1b62d4a8f76$export$cfeaf0cdb33173c8)[locale],
        extensions: [
            'webm'
        ],
        contentType: 'video/webm',
        maxBytes: 100 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$bb84843656fecdd6),
        disposition: 'inline'
    },
    {
        category: ()=>'Excel',
        extensions: [
            'csv'
        ],
        contentType: 'text/csv',
        maxBytes: 50 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$29cc6e2997da5d20),
        disposition: 'attachment'
    },
    {
        category: ()=>'Word',
        extensions: [
            'doc'
        ],
        contentType: 'application/msword',
        maxBytes: 25 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$c0a3bce27570b6d0),
        disposition: 'attachment'
    },
    {
        category: ()=>'Word',
        extensions: [
            'docx'
        ],
        contentType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        maxBytes: 25 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$c0a3bce27570b6d0),
        disposition: 'attachment'
    },
    {
        category: ()=>'PDF',
        extensions: [
            'pdf'
        ],
        contentType: 'application/pdf',
        maxBytes: 50 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$65168b0c06a6c4ec),
        disposition: 'inline'
    },
    {
        category: ()=>'PowerPoint',
        extensions: [
            'pptx'
        ],
        contentType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        maxBytes: 25 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$d9a0bc075772ac34),
        disposition: 'attachment'
    },
    {
        category: (locale)=>(0, $b11db1b62d4a8f76$export$b0a5b2684ddaafba)[locale],
        extensions: [
            'txt',
            '999',
            '277',
            '835',
            'rmt',
            'era'
        ],
        contentType: 'text/plain',
        maxBytes: 25 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$159b3fe6c427bb44),
        disposition: 'inline'
    },
    {
        category: ()=>'Excel',
        extensions: [
            'xls'
        ],
        contentType: 'application/vnd.ms-excel',
        maxBytes: 25 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$29cc6e2997da5d20),
        disposition: 'attachment'
    },
    {
        category: ()=>'Excel',
        extensions: [
            'xlsx'
        ],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        maxBytes: 25 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$29cc6e2997da5d20),
        disposition: 'attachment'
    },
    {
        category: ()=>'Zip',
        extensions: [
            'zip'
        ],
        contentType: 'application/zip',
        maxBytes: 25 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$58f7cbe4956d191c),
        disposition: 'attachment'
    },
    {
        category: (locale)=>(0, $b11db1b62d4a8f76$export$535dc873d3acbcb5)[locale],
        extensions: [
            'eml'
        ],
        contentType: 'message/rfc822',
        maxBytes: 25 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$cfe0d2093124992d),
        disposition: 'attachment'
    },
    {
        category: (locale)=>(0, $b11db1b62d4a8f76$export$535dc873d3acbcb5)[locale],
        extensions: [
            'msg'
        ],
        contentType: 'application/vnd.ms-outlook',
        maxBytes: 25 * $d5d33444928aec88$var$oneMb,
        icon48: (0, $84c634e688af79ca$export$cfe0d2093124992d),
        disposition: 'attachment'
    }
];
const $d5d33444928aec88$export$fd303ce11c8d3ac2 = {
    'application/x-zip-compressed': 'application/zip',
    'application/zip-compressed': 'application/zip'
};
const $d5d33444928aec88$export$a165e7d53b154032 = {
    '999': 'text/plain',
    '277': 'text/plain',
    '835': 'text/plain',
    rmt: 'text/plain',
    era: 'text/plain'
};
const $d5d33444928aec88$export$eeb27369891ab017 = Object.values((0, $cb5704f276528297$export$3f063810d7bf01bd)($d5d33444928aec88$export$e8852085401b0377, (x)=>x.category((0, $12c3f7ece07822ce$export$d7f512c98c859244)))).sort((a, b)=>(0, $50ac586a47aeec42$export$d8dd5bf0f45452aa)(a[0].category((0, $12c3f7ece07822ce$export$d7f512c98c859244)), b[0].category((0, $12c3f7ece07822ce$export$d7f512c98c859244))));
const $d5d33444928aec88$export$765f51da3aaa6d7a = (0, $cb5704f276528297$export$e439fc32198f78c5)($d5d33444928aec88$export$e8852085401b0377, 'contentType');
const $d5d33444928aec88$export$1d5ffa38c010beaf = $d5d33444928aec88$export$e8852085401b0377.reduce((acc, type)=>{
    for (const extension of type.extensions)acc[extension] = type;
    return acc;
}, {});
const $d5d33444928aec88$export$f76cdb99ddb8b1db = $d5d33444928aec88$export$e8852085401b0377.reduce((acc, type)=>acc.concat(type.extensions), []).sort();
const $d5d33444928aec88$export$900ffc5245513099 = new RegExp(`^/attachments/(?:${$d5d33444928aec88$export$5bccd096041570b4.join('|')})/([0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12})/([0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12})\\.(?:${$d5d33444928aec88$export$f76cdb99ddb8b1db.join('|')})$`);
function $d5d33444928aec88$export$d8aa1d63406bf679({ owner_slug: owner_slug, owner_id: owner_id, attachment_id: attachment_id }) {
    const ownerPath = `/attachments/${owner_slug}/${owner_id}`;
    return attachment_id ? `${ownerPath}/${attachment_id}` : ownerPath;
}
function $d5d33444928aec88$export$5f74b27d3eb12cdd({ authorizedPath: authorizedPath, owner_slug: owner_slug, owner_id: owner_id, attachment_id: attachment_id }) {
    return authorizedPath === $d5d33444928aec88$export$d8aa1d63406bf679({
        owner_slug: owner_slug,
        owner_id: owner_id
    }) || authorizedPath === $d5d33444928aec88$export$d8aa1d63406bf679({
        owner_slug: owner_slug,
        owner_id: owner_id,
        attachment_id: attachment_id
    });
}
function $d5d33444928aec88$export$e664a7e29bcdaa29(owner_slug, owner_id, attachments, body) {
    return attachments.filter((a)=>a.property_id || body.indexOf(`(/attachments/${owner_slug}/${owner_id}/${a.attachment_id}.`) !== -1);
}
function $d5d33444928aec88$export$5f7821c344028c56(basename) {
    const index = basename.lastIndexOf('.');
    if (index === -1) return '';
    return basename.substr(index + 1).toLowerCase();
}
function $d5d33444928aec88$export$fa302515f2a866ab(filename) {
    return (0, $426ea2ef2dc61d30$export$2e2bcd8739ae039)(filename, {
        replacement: '-',
        maxLength: 100
    });
}
function $d5d33444928aec88$export$85861430feffd419(locale, filename) {
    const sanitized = $d5d33444928aec88$export$fa302515f2a866ab(filename);
    if (sanitized.length === 0) return {
        valid: false,
        reason: (0, $b11db1b62d4a8f76$export$91e9ba9f3f646b82)[locale](filename)
    };
    if (sanitized[0] === '.') return {
        valid: false,
        reason: (0, $b11db1b62d4a8f76$export$91e9ba9f3f646b82)[locale](filename)
    };
    const extension = $d5d33444928aec88$export$5f7821c344028c56(sanitized);
    if (extension.length === 0) return {
        valid: false,
        reason: (0, $b11db1b62d4a8f76$export$df24ac9db9ed80e4)[locale](filename)
    };
    const type = $d5d33444928aec88$export$e8852085401b0377.find((type)=>type.extensions.includes(extension.toLowerCase()));
    if (!type) return {
        valid: false,
        reason: (0, $b11db1b62d4a8f76$export$a61f4000938e5ea3)[locale](extension, filename, $d5d33444928aec88$export$f76cdb99ddb8b1db.join(', '))
    };
    return {
        valid: true,
        filename: sanitized,
        extension: extension.toLowerCase(),
        originalFilename: filename,
        type: type
    };
}
function $d5d33444928aec88$export$2afbadb17474b14c(locale, filename, type, sizeBytes) {
    if (sizeBytes === 0) return {
        valid: false,
        reason: (0, $b11db1b62d4a8f76$export$c4b05ddd15bcedcd)[locale](filename)
    };
    if (sizeBytes > type.maxBytes) return {
        valid: false,
        reason: (0, $b11db1b62d4a8f76$export$20aa924aeb55054c)[locale](filename, type.extensions[0], `${type.maxBytes / $d5d33444928aec88$var$oneMb}MB`)
    };
    return {
        valid: true
    };
}

/// <reference path="declarations.d.ts" />
/**
 * Unexpected response from a dependency.
 */ class $d089c140e1929c78$export$ea86d8b2c6b5cbfd extends Error {
    status;
    /**
   * @param {Response} response
   * @param {string?} text
   */ constructor({ url: url, status: status, statusText: statusText, headers: headers }, text){
        super(`${$d089c140e1929c78$var$sanitizeUrl(url)} responded with ${status}: ${statusText}\nHeaders: ${JSON.stringify(Object.fromEntries(headers), null, 2)}${text ? '\n' + text : ''}`);
        this.name = this.constructor.name;
        this.status = status;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
    }
}
function $d089c140e1929c78$var$sanitizeUrl(url) {
    try {
        const parsed = new URL(url);
        for (const key of [
            'token',
            'key',
            'access_token',
            'client_id',
            'client_secret'
        ])if (parsed.searchParams.has(key)) parsed.searchParams.set(key, 'redacted');
        url = parsed.href;
    } catch  {}
    if (url.length > 2500) return url.substr(0, 2500) + ` [URL truncated to 2500 characters. Original length: ${url.length}]`;
    return url;
}



// keep ref in case user translates page.
const $c74c4f773f8a11f2$var$originalLang = document.documentElement.lang;
function $c74c4f773f8a11f2$export$180605366c04f0cd() {
    return $c74c4f773f8a11f2$var$originalLang;
}





const $8f2070e09d7bee6a$var$sessionExpiredModalId = 'session-expired-modal';
function $8f2070e09d7bee6a$var$displaySessionExpiredModal() {
    if (document.getElementById($8f2070e09d7bee6a$var$sessionExpiredModalId)) return;
    const locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
    document.body.insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<modal-content id="${$8f2070e09d7bee6a$var$sessionExpiredModalId}" force-submit>
        <div class="Box Box--width-md anim-fade-in fast">
          <div class="Box-header">
            <h3 class="Box-title">${(0, $b11db1b62d4a8f76$export$403a32688f6224ee)[locale]}</h3>
          </div>
          <div class="Box-body">
            <p>${(0, $b11db1b62d4a8f76$export$6896487a24fde326)[locale]}</p>
            ${REQUIRES_AUTHENTICATION === 'standard' ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<a
                    class="btn btn-primary target-subtle"
                    href="/auth/sign-in?redirect_uri=${location.origin}/auth/signed-in"
                    target="_blank"
                    modal-dismiss
                  >
                    ${(0, $b11db1b62d4a8f76$export$df7d62b22f2942d4)[locale]}
                  </a>` : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<a
                    class="btn btn-primary"
                    href="${location.pathname}${location.search}"
                  >
                    ${(0, $b11db1b62d4a8f76$export$df7d62b22f2942d4)[locale]}
                  </a>`}
          </div>
        </div>
      </modal-content>`));
}
function $8f2070e09d7bee6a$export$91cdf58e199a84d0({ status: status, url: url }) {
    if (status === 401 && new URL(url, location.origin).origin === location.origin) {
        $8f2070e09d7bee6a$var$displaySessionExpiredModal();
        return true;
    }
    return false;
}
let $8f2070e09d7bee6a$var$checkSessionDebounce = 0;
function $8f2070e09d7bee6a$var$scheduleCheckSession() {
    clearTimeout($8f2070e09d7bee6a$var$checkSessionDebounce);
    $8f2070e09d7bee6a$var$checkSessionDebounce = setTimeout($8f2070e09d7bee6a$var$checkSession, 100);
}
let $8f2070e09d7bee6a$var$checkingSession = false;
async function $8f2070e09d7bee6a$var$checkSession() {
    clearTimeout($8f2070e09d7bee6a$var$checkSessionDebounce);
    if ($8f2070e09d7bee6a$var$checkingSession) return;
    $8f2070e09d7bee6a$var$checkingSession = true;
    try {
        const response = await fetch(new URL('/auth/check-session', location.origin), {
            method: 'GET'
        });
        if ($8f2070e09d7bee6a$export$91cdf58e199a84d0(response)) return;
        if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response);
        document.getElementById($8f2070e09d7bee6a$var$sessionExpiredModalId)?.remove();
    } finally{
        $8f2070e09d7bee6a$var$checkingSession = false;
    }
}
// Coalesce activity into at most one request every five minutes.
const $8f2070e09d7bee6a$var$keepAliveIntervalMs = 300000;
let $8f2070e09d7bee6a$var$keepAliveTimeout = 0;
let $8f2070e09d7bee6a$var$lastKeepAliveRequestSettledMs = Date.now();
let $8f2070e09d7bee6a$var$keepingAlive = false;
async function $8f2070e09d7bee6a$var$keepAlive() {
    clearTimeout($8f2070e09d7bee6a$var$keepAliveTimeout);
    $8f2070e09d7bee6a$var$keepAliveTimeout = 0;
    if (document.visibilityState !== 'visible') return;
    if ($8f2070e09d7bee6a$var$keepingAlive) return;
    $8f2070e09d7bee6a$var$keepingAlive = true;
    try {
        const response = await fetch(new URL('/auth/keep-alive', location.origin), {
            method: 'POST'
        });
        if ($8f2070e09d7bee6a$export$91cdf58e199a84d0(response)) return;
        if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response);
        document.getElementById($8f2070e09d7bee6a$var$sessionExpiredModalId)?.remove();
    } catch (err) {
        console.error(err);
    } finally{
        $8f2070e09d7bee6a$var$lastKeepAliveRequestSettledMs = Date.now();
        $8f2070e09d7bee6a$var$keepingAlive = false;
    }
}
function $8f2070e09d7bee6a$var$scheduleKeepAlive(now) {
    if ($8f2070e09d7bee6a$var$keepAliveTimeout) return;
    const requestAtMs = $8f2070e09d7bee6a$var$lastKeepAliveRequestSettledMs + $8f2070e09d7bee6a$var$keepAliveIntervalMs;
    const delayMs = Math.max(0, requestAtMs - now);
    $8f2070e09d7bee6a$var$keepAliveTimeout = setTimeout($8f2070e09d7bee6a$var$keepAlive, delayMs);
}
function $8f2070e09d7bee6a$var$onActivity(event) {
    if (!event.isTrusted || document.visibilityState !== 'visible') return;
    const now = Date.now();
    if (now - $8f2070e09d7bee6a$var$lastKeepAliveRequestSettledMs >= $8f2070e09d7bee6a$var$keepAliveIntervalMs) $8f2070e09d7bee6a$var$keepAlive();
    else $8f2070e09d7bee6a$var$scheduleKeepAlive(now);
}
if (REQUIRES_AUTHENTICATION) {
    // When user comes back to the tab, do a check for UX correctness.
    document.addEventListener('visibilitychange', ()=>{
        if (document.visibilityState === 'visible') $8f2070e09d7bee6a$var$checkSession();
    });
    // Activity keeps alive
    addEventListener('pointerdown', $8f2070e09d7bee6a$var$onActivity, {
        passive: true
    });
    addEventListener('keydown', $8f2070e09d7bee6a$var$onActivity);
    addEventListener('touchstart', $8f2070e09d7bee6a$var$onActivity, {
        passive: true
    });
    addEventListener('scroll', $8f2070e09d7bee6a$var$onActivity, {
        capture: true,
        passive: true
    });
    // Errors check session
    addEventListener('remote-input-error', (event)=>{
        if (event.target instanceof Element && event.target.tagName === 'REMOTE-INPUT') $8f2070e09d7bee6a$var$scheduleCheckSession();
    });
    // https://github.com/github/include-fragment-element/blob/main/src/include-fragment-element.ts#L261
    // https://github.com/github/auto-complete-element/blob/main/src/autocomplete.ts#L232
    addEventListener('error', (event)=>{
        if (event.target instanceof Element && [
            'INCLUDE-FRAGMENT',
            'AUTO-COMPLETE'
        ].includes(event.target.tagName)) $8f2070e09d7bee6a$var$scheduleCheckSession();
    }, {
        capture: true
    });
}


addEventListener('file-attachment-accept', (event)=>{
    const locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
    for (const attachment of event.detail.attachments){
        const result = (0, $d5d33444928aec88$export$85861430feffd419)(locale, attachment.file.name);
        if (!result.valid) {
            event.preventDefault();
            alert(result.reason);
            return;
        }
        // https://developer.mozilla.org/en-US/docs/Web/API/Blob/type
        // Note: Based on the current implementation, browsers won't actually read
        // the bytestream of a file to determine its media type. It is assumed based
        // on the file extension; a PNG image file renamed to .txt would give
        // "text/plain" and not "image/png". Moreover, blob.type is generally reliable
        // only for common file types like images, HTML documents, audio and video.
        // Uncommon file extensions would return an empty string. Client configuration
        // (for instance, the Windows Registry) may result in unexpected values even
        // for common types. Developers are advised not to rely on this property as a
        // sole validation scheme.
        // if (result.type.contentType !== attachment.file.type) {
        //   event.preventDefault();
        //   alert(
        //     `Invalid file content type ${JSON.stringify(
        //       attachment.file.type
        //     )}. Expected: "${result.type.contentType}".`
        //   );
        //   return;
        // }
        const sizeResult = (0, $d5d33444928aec88$export$2afbadb17474b14c)(locale, attachment.file.name, result.type, attachment.file.size);
        if (!sizeResult.valid) {
            event.preventDefault();
            alert(sizeResult.reason);
            return;
        }
        attachment.name = result.filename;
    }
});
async function $4ab5d79d76486e1b$export$14d3a7d22f26659e({ locale: locale, attachments: attachments, uploadUrl: uploadUrl, attachmentSaved: attachmentSaved, jwt: jwt }) {
    for (const attachment of attachments){
        attachment.saving(0);
        uploadUrl.searchParams.set('filename', attachment.name);
        const headers = new Headers();
        const uploadRequestInit = {
            method: 'POST',
            body: attachment.file,
            headers: headers
        };
        if (jwt) headers.set('Authorization', `Bearer ${jwt}`);
        // ensure content-type header is provided in scenarios where browser doesn't compute it automatically.
        if (attachment.file.type === '') {
            const extension = (0, $d5d33444928aec88$export$5f7821c344028c56)(attachment.file.name);
            const contentType = (0, $d5d33444928aec88$export$1d5ffa38c010beaf)[extension].contentType;
            headers.set('content-type', contentType);
        }
        let response = await fetch(uploadUrl, uploadRequestInit);
        if (response.status >= 500 && response.status < 600) {
            response.text().then((text)=>{
                throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, text);
            });
            await new Promise((resolve)=>setTimeout(resolve, 3000));
            uploadUrl.searchParams.set('retry', '1');
            response = await fetch(uploadUrl, uploadRequestInit);
        }
        if ((0, $8f2070e09d7bee6a$export$91cdf58e199a84d0)(response)) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
        if (!response.ok) {
            alert((0, $b11db1b62d4a8f76$export$abc1de427b12d946)[locale](attachment.name));
            throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
        }
        const responseBody = await response.json();
        const { id: id, href: href, download_href: download_href, name: name } = responseBody;
        attachment.saved({
            id: id,
            href: href,
            name: name
        });
        attachmentSaved(attachment, download_href, responseBody);
    }
} /*
async function uploadAttachment(attachment: Attachment, href: string) {
  const xhr = await new Promise<XMLHttpRequest>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    // xhr.withCredentials = true;
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.open('POST', href, true);
    xhr.onloadstart = () => attachment.saving(0);
    xhr.upload.onprogress = e => {
      if (e.lengthComputable) {
        attachment.saving(Math.round((e.loaded / e.total) * 100));
      }
    };
    xhr.onload = () => resolve(xhr);
    xhr.onerror = reject;
    xhr.send(attachment.file);
  });
  if (xhr.status === 201) {
    const { id, href, name } = JSON.parse(xhr.responseText);
    attachment.saved({ id, href, name });
  } else {
    throw new XhrDependencyError(xhr);
  }
}

class XhrDependencyError extends DependencyError {
  constructor(xhr: XMLHttpRequest) {
    super(
      {
        url: xhr.responseURL,
        status: xhr.status,
        statusText: xhr.statusText,
        headers: XhrDependencyError.parseXhrHeaders(xhr)
      },
      xhr.responseText
    );
    this.name = this.constructor.name;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    }
  }

  static parseXhrHeaders(xhr: XMLHttpRequest) {
    const headers = new Headers();
    // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/getAllResponseHeaders#examples
    const lines = xhr
      .getAllResponseHeaders()
      .trim()
      .split(/[\r\n]+/);
    for (const line of lines) {
      const [name, ...value] = line.split(': ');
      headers.append(name, value.join(': '));
    }
    return headers;
  }
}
*/ 


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $d6c5a61e077d7968$var$extendStatics = function(d, b) {
    $d6c5a61e077d7968$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $d6c5a61e077d7968$var$extendStatics(d, b);
};
function $d6c5a61e077d7968$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $d6c5a61e077d7968$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d6c5a61e077d7968$export$18ce0697a983be9b = function() {
    $d6c5a61e077d7968$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d6c5a61e077d7968$export$18ce0697a983be9b.apply(this, arguments);
};
function $d6c5a61e077d7968$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d6c5a61e077d7968$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d6c5a61e077d7968$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d6c5a61e077d7968$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $d6c5a61e077d7968$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $d6c5a61e077d7968$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $d6c5a61e077d7968$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $d6c5a61e077d7968$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d6c5a61e077d7968$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d6c5a61e077d7968$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $d6c5a61e077d7968$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $d6c5a61e077d7968$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $d6c5a61e077d7968$export$45d3717a4c69092e(o, m, p);
}
function $d6c5a61e077d7968$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d6c5a61e077d7968$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d6c5a61e077d7968$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d6c5a61e077d7968$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d6c5a61e077d7968$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d6c5a61e077d7968$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $d6c5a61e077d7968$export$10c90e4f7922046c(v) {
    return this instanceof $d6c5a61e077d7968$export$10c90e4f7922046c ? (this.v = v, this) : new $d6c5a61e077d7968$export$10c90e4f7922046c(v);
}
function $d6c5a61e077d7968$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d6c5a61e077d7968$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d6c5a61e077d7968$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d6c5a61e077d7968$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $d6c5a61e077d7968$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d6c5a61e077d7968$export$19a8beecd37a4c45 === "function" ? $d6c5a61e077d7968$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d6c5a61e077d7968$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $d6c5a61e077d7968$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $d6c5a61e077d7968$var$ownKeys = function(o) {
    $d6c5a61e077d7968$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $d6c5a61e077d7968$var$ownKeys(o);
};
function $d6c5a61e077d7968$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $d6c5a61e077d7968$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $d6c5a61e077d7968$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $d6c5a61e077d7968$var$__setModuleDefault(result, mod);
    return result;
}
function $d6c5a61e077d7968$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d6c5a61e077d7968$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $d6c5a61e077d7968$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $d6c5a61e077d7968$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $d6c5a61e077d7968$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $d6c5a61e077d7968$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $d6c5a61e077d7968$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $d6c5a61e077d7968$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $d6c5a61e077d7968$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $d6c5a61e077d7968$export$2e2bcd8739ae039 = {
    __extends: $d6c5a61e077d7968$export$a8ba968b8961cb8a,
    __assign: $d6c5a61e077d7968$export$18ce0697a983be9b,
    __rest: $d6c5a61e077d7968$export$3c9a16f847548506,
    __decorate: $d6c5a61e077d7968$export$29e00dfd3077644b,
    __param: $d6c5a61e077d7968$export$d5ad3fd78186038f,
    __esDecorate: $d6c5a61e077d7968$export$3a84e1ae4e97e9b0,
    __runInitializers: $d6c5a61e077d7968$export$d831c04e792af3d,
    __propKey: $d6c5a61e077d7968$export$6a2a36740a146cb8,
    __setFunctionName: $d6c5a61e077d7968$export$d1a06452d3489bc7,
    __metadata: $d6c5a61e077d7968$export$f1db080c865becb9,
    __awaiter: $d6c5a61e077d7968$export$1050f835b63b671e,
    __generator: $d6c5a61e077d7968$export$67ebef60e6f28a6,
    __createBinding: $d6c5a61e077d7968$export$45d3717a4c69092e,
    __exportStar: $d6c5a61e077d7968$export$f33643c0debef087,
    __values: $d6c5a61e077d7968$export$19a8beecd37a4c45,
    __read: $d6c5a61e077d7968$export$8d051b38c9118094,
    __spread: $d6c5a61e077d7968$export$afc72e2116322959,
    __spreadArrays: $d6c5a61e077d7968$export$6388937ca91ccae8,
    __spreadArray: $d6c5a61e077d7968$export$1216008129fb82ed,
    __await: $d6c5a61e077d7968$export$10c90e4f7922046c,
    __asyncGenerator: $d6c5a61e077d7968$export$e427f37a30a4de9b,
    __asyncDelegator: $d6c5a61e077d7968$export$bbd80228419bb833,
    __asyncValues: $d6c5a61e077d7968$export$e3b29a3d6162315f,
    __makeTemplateObject: $d6c5a61e077d7968$export$4fb47efe1390b86f,
    __importStar: $d6c5a61e077d7968$export$c21735bcef00d192,
    __importDefault: $d6c5a61e077d7968$export$da59b14a69baef04,
    __classPrivateFieldGet: $d6c5a61e077d7968$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $d6c5a61e077d7968$export$d40a35129aaff81f,
    __classPrivateFieldIn: $d6c5a61e077d7968$export$81fdc39f203e4e04,
    __addDisposableResource: $d6c5a61e077d7968$export$88ac25d8e944e405,
    __disposeResources: $d6c5a61e077d7968$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $d6c5a61e077d7968$export$889dfb5d17574b0b
};


function $01be4901a49decd2$export$f99d9bd271f9a30e(a, b) {
    const typeofa = typeof a;
    if (typeofa !== typeof b) return false;
    const aIsArray = Array.isArray(a);
    const bIsArray = Array.isArray(b);
    if (aIsArray !== bIsArray) return false;
    if (aIsArray) {
        const length = a.length;
        if (length !== b.length) return false;
        for(let i = 0; i < length; i++){
            if (!$01be4901a49decd2$export$f99d9bd271f9a30e(a[i], b[i])) return false;
        }
        return true;
    }
    if (typeofa === 'object') {
        if (!a || !b) return a === b;
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        const length = aKeys.length;
        if (length !== bKeys.length) return false;
        for (const k of aKeys){
            if (!Object.prototype.hasOwnProperty.call(b, k)) return false;
            if (!$01be4901a49decd2$export$f99d9bd271f9a30e(a[k], b[k])) return false;
        }
        return true;
    }
    return a === b;
}


function $15c3a9d0e0e44af6$export$cf01591f74e45a26(p) {
    return encodeURI($15c3a9d0e0e44af6$export$f892d8cbc7e1927d(p));
}
function $15c3a9d0e0e44af6$export$f892d8cbc7e1927d(p) {
    return p.replace(/~/g, '~0').replace(/\//g, '~1');
}


const $628b461cfddf549f$export$cdd7a38695256453 = {
    additionalItems: true,
    unevaluatedItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    unevaluatedProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
const $628b461cfddf549f$export$2acd2b12eada2059 = {
    prefixItems: true,
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
const $628b461cfddf549f$export$e75e529205893455 = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependentSchemas: true
};
const $628b461cfddf549f$export$77628d62a5643601 = {
    id: true,
    $id: true,
    $ref: true,
    $schema: true,
    $anchor: true,
    $vocabulary: true,
    $comment: true,
    default: true,
    enum: true,
    const: true,
    required: true,
    dependentRequired: true,
    type: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
let $628b461cfddf549f$export$f7916c58665fc533 = typeof self !== 'undefined' && self.location && self.location.origin !== 'null' ? new URL(self.location.origin + self.location.pathname + location.search) : new URL('https://github.com/cfworker');
function $628b461cfddf549f$export$113cba6086f872e2(schema, lookup = Object.create(null), baseURI = $628b461cfddf549f$export$f7916c58665fc533, basePointer = '') {
    if (schema && typeof schema === 'object' && !Array.isArray(schema)) {
        const id = schema.$id || schema['id'];
        if (id) {
            const url = new URL(id, baseURI.href);
            if (url.hash.length > 1) lookup[url.href] = schema;
            else {
                url.hash = '';
                if (basePointer === '') baseURI = url;
                else $628b461cfddf549f$export$113cba6086f872e2(schema, lookup, baseURI);
            }
        }
    } else if (schema !== true && schema !== false) return lookup;
    const schemaURI = baseURI.href + (basePointer ? '#' + basePointer : '');
    if (lookup[schemaURI] !== undefined && lookup[schemaURI] !== schema) throw new Error(`Duplicate schema URI "${schemaURI}".`);
    lookup[schemaURI] = schema;
    if (schema === true || schema === false) return lookup;
    if (schema.__absolute_uri__ === undefined) Object.defineProperty(schema, '__absolute_uri__', {
        enumerable: false,
        value: schemaURI
    });
    if (schema.$ref && schema.__absolute_ref__ === undefined) {
        const url = new URL(schema.$ref, baseURI.href);
        url.hash = url.hash;
        Object.defineProperty(schema, '__absolute_ref__', {
            enumerable: false,
            value: url.href
        });
    }
    if (schema.$recursiveRef && schema.__absolute_recursive_ref__ === undefined) {
        const url = new URL(schema.$recursiveRef, baseURI.href);
        url.hash = url.hash;
        Object.defineProperty(schema, '__absolute_recursive_ref__', {
            enumerable: false,
            value: url.href
        });
    }
    if (schema.$anchor) {
        const url = new URL('#' + schema.$anchor, baseURI.href);
        lookup[url.href] = schema;
    }
    for(let key in schema){
        if ($628b461cfddf549f$export$77628d62a5643601[key]) continue;
        const keyBase = `${basePointer}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`;
        const subSchema = schema[key];
        if (Array.isArray(subSchema)) {
            if ($628b461cfddf549f$export$2acd2b12eada2059[key]) {
                const length = subSchema.length;
                for(let i = 0; i < length; i++)$628b461cfddf549f$export$113cba6086f872e2(subSchema[i], lookup, baseURI, `${keyBase}/${i}`);
            }
        } else if ($628b461cfddf549f$export$e75e529205893455[key]) for(let subKey in subSchema)$628b461cfddf549f$export$113cba6086f872e2(subSchema[subKey], lookup, baseURI, `${keyBase}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(subKey)}`);
        else $628b461cfddf549f$export$113cba6086f872e2(subSchema, lookup, baseURI, keyBase);
    }
    return lookup;
}


const $1ecce3c2faf95ef0$var$DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
const $1ecce3c2faf95ef0$var$DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $1ecce3c2faf95ef0$var$TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
const $1ecce3c2faf95ef0$var$HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
const $1ecce3c2faf95ef0$var$URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
const $1ecce3c2faf95ef0$var$URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
const $1ecce3c2faf95ef0$var$URL_ = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu;
const $1ecce3c2faf95ef0$var$UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
const $1ecce3c2faf95ef0$var$JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
const $1ecce3c2faf95ef0$var$JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
const $1ecce3c2faf95ef0$var$RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
const $1ecce3c2faf95ef0$var$EMAIL = (input)=>{
    if (input[0] === '"') return false;
    const [name, host, ...rest] = input.split('@');
    if (!name || !host || rest.length !== 0 || name.length > 64 || host.length > 253) return false;
    if (name[0] === '.' || name.endsWith('.') || name.includes('..')) return false;
    if (!/^[a-z0-9.-]+$/i.test(host) || !/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+$/i.test(name)) return false;
    return host.split('.').every((part)=>/^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/i.test(part));
};
const $1ecce3c2faf95ef0$var$IPV4 = /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/;
const $1ecce3c2faf95ef0$var$IPV6 = /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i;
const $1ecce3c2faf95ef0$var$DURATION = (input)=>input.length > 1 && input.length < 80 && (/^P\d+([.,]\d+)?W$/.test(input) || /^P[\dYMDTHS]*(\d[.,]\d+)?[YMDHS]$/.test(input) && /^P([.,\d]+Y)?([.,\d]+M)?([.,\d]+D)?(T([.,\d]+H)?([.,\d]+M)?([.,\d]+S)?)?$/.test(input));
function $1ecce3c2faf95ef0$var$bind(r) {
    return r.test.bind(r);
}
const $1ecce3c2faf95ef0$export$d9468344d3651243 = {
    date: $1ecce3c2faf95ef0$var$date,
    time: $1ecce3c2faf95ef0$var$time.bind(undefined, false),
    'date-time': $1ecce3c2faf95ef0$var$date_time,
    duration: $1ecce3c2faf95ef0$var$DURATION,
    uri: $1ecce3c2faf95ef0$var$uri,
    'uri-reference': $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$URIREF),
    'uri-template': $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$URITEMPLATE),
    url: $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$URL_),
    email: $1ecce3c2faf95ef0$var$EMAIL,
    hostname: $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$HOSTNAME),
    ipv4: $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$IPV4),
    ipv6: $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$IPV6),
    regex: $1ecce3c2faf95ef0$var$regex,
    uuid: $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$UUID),
    'json-pointer': $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$JSON_POINTER),
    'json-pointer-uri-fragment': $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$JSON_POINTER_URI_FRAGMENT),
    'relative-json-pointer': $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$RELATIVE_JSON_POINTER)
};
function $1ecce3c2faf95ef0$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $1ecce3c2faf95ef0$var$date(str) {
    const matches = str.match($1ecce3c2faf95ef0$var$DATE);
    if (!matches) return false;
    const yearPart = matches[1];
    const monthPart = matches[2];
    const dayPart = matches[3];
    if (!yearPart || !monthPart || !dayPart) return false;
    const year = +yearPart;
    const month = +monthPart;
    const day = +dayPart;
    const maxDay = month == 2 && $1ecce3c2faf95ef0$var$isLeapYear(year) ? 29 : $1ecce3c2faf95ef0$var$DAYS[month];
    return month >= 1 && month <= 12 && day >= 1 && maxDay !== undefined && day <= maxDay;
}
function $1ecce3c2faf95ef0$var$time(full, str) {
    const matches = str.match($1ecce3c2faf95ef0$var$TIME);
    if (!matches) return false;
    const hourPart = matches[1];
    const minutePart = matches[2];
    const secondPart = matches[3];
    if (!hourPart || !minutePart || !secondPart) return false;
    const hour = +hourPart;
    const minute = +minutePart;
    const second = +secondPart;
    const timeZone = !!matches[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour == 23 && minute == 59 && second == 60) && (!full || timeZone);
}
const $1ecce3c2faf95ef0$var$DATE_TIME_SEPARATOR = /t|\s/i;
function $1ecce3c2faf95ef0$var$date_time(str) {
    const [datePart, timePart, extra] = str.split($1ecce3c2faf95ef0$var$DATE_TIME_SEPARATOR);
    return datePart !== undefined && timePart !== undefined && extra === undefined && $1ecce3c2faf95ef0$var$date(datePart) && $1ecce3c2faf95ef0$var$time(true, timePart);
}
const $1ecce3c2faf95ef0$var$NOT_URI_FRAGMENT = /\/|:/;
const $1ecce3c2faf95ef0$var$URI_PATTERN = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
function $1ecce3c2faf95ef0$var$uri(str) {
    return $1ecce3c2faf95ef0$var$NOT_URI_FRAGMENT.test(str) && $1ecce3c2faf95ef0$var$URI_PATTERN.test(str);
}
const $1ecce3c2faf95ef0$var$Z_ANCHOR = /[^\\]\\Z/;
function $1ecce3c2faf95ef0$var$regex(str) {
    if ($1ecce3c2faf95ef0$var$Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str, 'u');
        return true;
    } catch (e) {
        return false;
    }
}



function $7121b206e03ba7d7$export$e383d1c74f4e3b67(s) {
    let result = 0;
    let length = s.length;
    let index = 0;
    let charCode;
    while(index < length){
        result++;
        charCode = s.charCodeAt(index++);
        if (charCode >= 0xd800 && charCode <= 0xdbff && index < length) {
            charCode = s.charCodeAt(index);
            if ((charCode & 0xfc00) == 0xdc00) index++;
        }
    }
    return result;
}


function $629fab7fb0c19ec3$var$hasOwnProperty(instance, key) {
    return Object.prototype.hasOwnProperty.call(instance, key);
}
function $629fab7fb0c19ec3$var$decimalInteger(value) {
    const coefficientAndExponent = Math.abs(value).toString().split('e');
    const coefficient = coefficientAndExponent[0];
    const exponent = coefficientAndExponent[1] ?? '0';
    const point = coefficient.indexOf('.');
    const fractionLength = point === -1 ? 0 : coefficient.length - point - 1;
    return [
        BigInt(coefficient.replace('.', '')),
        Number(exponent) - fractionLength
    ];
}
function $629fab7fb0c19ec3$var$isMultipleOf(instance, divisor) {
    if (!Number.isFinite(instance) || !Number.isFinite(divisor) || divisor <= 0) return false;
    const [instanceCoefficient, instanceExponent] = $629fab7fb0c19ec3$var$decimalInteger(instance);
    const [divisorCoefficient, divisorExponent] = $629fab7fb0c19ec3$var$decimalInteger(divisor);
    const exponentDifference = instanceExponent - divisorExponent;
    if (exponentDifference >= 0) return instanceCoefficient * 10n ** BigInt(exponentDifference) % divisorCoefficient === 0n;
    return instanceCoefficient % (divisorCoefficient * 10n ** BigInt(-exponentDifference)) === 0n;
}
function $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, schema, draft = '2019-09', lookup = (0, $628b461cfddf549f$export$113cba6086f872e2)(schema), shortCircuit = true, recursiveAnchor = null, instanceLocation = '#', schemaLocation = '#', evaluated = Object.create(null)) {
    if (schema === true) return {
        valid: true,
        errors: []
    };
    if (schema === false) return {
        valid: false,
        errors: [
            {
                instanceLocation: instanceLocation,
                keyword: 'false',
                keywordLocation: instanceLocation,
                error: 'False boolean schema.'
            }
        ]
    };
    const rawInstanceType = typeof instance;
    let instanceType;
    switch(rawInstanceType){
        case 'boolean':
        case 'number':
        case 'string':
            instanceType = rawInstanceType;
            break;
        case 'object':
            if (instance === null) instanceType = 'null';
            else if (Array.isArray(instance)) instanceType = 'array';
            else instanceType = 'object';
            break;
        default:
            throw new Error(`Instances of "${rawInstanceType}" type are not supported.`);
    }
    const { $ref: $ref, $recursiveRef: $recursiveRef, $recursiveAnchor: $recursiveAnchor, type: $type, const: $const, enum: $enum, required: $required, not: $not, anyOf: $anyOf, allOf: $allOf, oneOf: $oneOf, if: $if, then: $then, else: $else, format: $format, properties: $properties, patternProperties: $patternProperties, additionalProperties: $additionalProperties, unevaluatedProperties: $unevaluatedProperties, minProperties: $minProperties, maxProperties: $maxProperties, propertyNames: $propertyNames, dependentRequired: $dependentRequired, dependentSchemas: $dependentSchemas, dependencies: $dependencies, prefixItems: $prefixItems, items: $items, additionalItems: $additionalItems, unevaluatedItems: $unevaluatedItems, contains: $contains, minContains: $minContains, maxContains: $maxContains, minItems: $minItems, maxItems: $maxItems, uniqueItems: $uniqueItems, minimum: $minimum, maximum: $maximum, exclusiveMinimum: $exclusiveMinimum, exclusiveMaximum: $exclusiveMaximum, multipleOf: $multipleOf, minLength: $minLength, maxLength: $maxLength, pattern: $pattern, __absolute_ref__: __absolute_ref__, __absolute_recursive_ref__: __absolute_recursive_ref__ } = schema;
    const errors = [];
    if ($recursiveAnchor === true && recursiveAnchor === null) recursiveAnchor = schema;
    if ($recursiveRef === '#') {
        const refSchema = recursiveAnchor === null ? lookup[__absolute_recursive_ref__] : recursiveAnchor;
        const keywordLocation = `${schemaLocation}/$recursiveRef`;
        const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, recursiveAnchor === null ? schema : recursiveAnchor, draft, lookup, shortCircuit, refSchema, instanceLocation, keywordLocation, evaluated);
        if (!result.valid) errors.push({
            instanceLocation: instanceLocation,
            keyword: '$recursiveRef',
            keywordLocation: keywordLocation,
            error: 'A subschema had errors.'
        }, ...result.errors);
    }
    if ($ref !== undefined) {
        const uri = __absolute_ref__ || $ref;
        const refSchema = lookup[uri];
        if (refSchema === undefined) {
            let message = `Unresolved $ref "${$ref}".`;
            if (__absolute_ref__ && __absolute_ref__ !== $ref) message += `  Absolute URI "${__absolute_ref__}".`;
            message += `\nKnown schemas:\n- ${Object.keys(lookup).join('\n- ')}`;
            throw new Error(message);
        }
        const keywordLocation = `${schemaLocation}/$ref`;
        const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, refSchema, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, keywordLocation, evaluated);
        if (!result.valid) errors.push({
            instanceLocation: instanceLocation,
            keyword: '$ref',
            keywordLocation: keywordLocation,
            error: 'A subschema had errors.'
        }, ...result.errors);
        if (draft === '4' || draft === '7') return {
            valid: errors.length === 0,
            errors: errors
        };
    }
    if (Array.isArray($type)) {
        let length = $type.length;
        let valid = false;
        for(let i = 0; i < length; i++)if (instanceType === $type[i] || $type[i] === 'integer' && instanceType === 'number' && instance % 1 === 0 && instance === instance) {
            valid = true;
            break;
        }
        if (!valid) errors.push({
            instanceLocation: instanceLocation,
            keyword: 'type',
            keywordLocation: `${schemaLocation}/type`,
            error: `Instance type "${instanceType}" is invalid. Expected "${$type.join('", "')}".`
        });
    } else if ($type === 'integer') {
        if (instanceType !== 'number' || instance % 1 || instance !== instance) errors.push({
            instanceLocation: instanceLocation,
            keyword: 'type',
            keywordLocation: `${schemaLocation}/type`,
            error: `Instance type "${instanceType}" is invalid. Expected "${$type}".`
        });
    } else if ($type !== undefined && instanceType !== $type) errors.push({
        instanceLocation: instanceLocation,
        keyword: 'type',
        keywordLocation: `${schemaLocation}/type`,
        error: `Instance type "${instanceType}" is invalid. Expected "${$type}".`
    });
    if ($const !== undefined) {
        if (instanceType === 'object' || instanceType === 'array') {
            if (!(0, $01be4901a49decd2$export$f99d9bd271f9a30e)(instance, $const)) errors.push({
                instanceLocation: instanceLocation,
                keyword: 'const',
                keywordLocation: `${schemaLocation}/const`,
                error: `Instance does not match ${JSON.stringify($const)}.`
            });
        } else if (instance !== $const) errors.push({
            instanceLocation: instanceLocation,
            keyword: 'const',
            keywordLocation: `${schemaLocation}/const`,
            error: `Instance does not match ${JSON.stringify($const)}.`
        });
    }
    if ($enum !== undefined) {
        if (instanceType === 'object' || instanceType === 'array') {
            if (!$enum.some((value)=>(0, $01be4901a49decd2$export$f99d9bd271f9a30e)(instance, value))) errors.push({
                instanceLocation: instanceLocation,
                keyword: 'enum',
                keywordLocation: `${schemaLocation}/enum`,
                error: `Instance does not match any of ${JSON.stringify($enum)}.`
            });
        } else if (!$enum.some((value)=>instance === value)) errors.push({
            instanceLocation: instanceLocation,
            keyword: 'enum',
            keywordLocation: `${schemaLocation}/enum`,
            error: `Instance does not match any of ${JSON.stringify($enum)}.`
        });
    }
    if ($not !== undefined) {
        const keywordLocation = `${schemaLocation}/not`;
        const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, $not, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, keywordLocation);
        if (result.valid) errors.push({
            instanceLocation: instanceLocation,
            keyword: 'not',
            keywordLocation: keywordLocation,
            error: 'Instance matched "not" schema.'
        });
    }
    let subEvaluateds = [];
    if ($anyOf !== undefined) {
        const keywordLocation = `${schemaLocation}/anyOf`;
        const errorsLength = errors.length;
        let anyValid = false;
        for (const [i, subSchema] of $anyOf.entries()){
            const subEvaluated = Object.create(evaluated);
            const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, subSchema, draft, lookup, shortCircuit, $recursiveAnchor === true ? recursiveAnchor : null, instanceLocation, `${keywordLocation}/${i}`, subEvaluated);
            errors.push(...result.errors);
            anyValid = anyValid || result.valid;
            if (result.valid) subEvaluateds.push(subEvaluated);
        }
        if (anyValid) errors.length = errorsLength;
        else errors.splice(errorsLength, 0, {
            instanceLocation: instanceLocation,
            keyword: 'anyOf',
            keywordLocation: keywordLocation,
            error: 'Instance does not match any subschemas.'
        });
    }
    if ($allOf !== undefined) {
        const keywordLocation = `${schemaLocation}/allOf`;
        const errorsLength = errors.length;
        let allValid = true;
        for (const [i, subSchema] of $allOf.entries()){
            const subEvaluated = Object.create(evaluated);
            const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, subSchema, draft, lookup, shortCircuit, $recursiveAnchor === true ? recursiveAnchor : null, instanceLocation, `${keywordLocation}/${i}`, subEvaluated);
            errors.push(...result.errors);
            allValid = allValid && result.valid;
            if (result.valid) subEvaluateds.push(subEvaluated);
        }
        if (allValid) errors.length = errorsLength;
        else errors.splice(errorsLength, 0, {
            instanceLocation: instanceLocation,
            keyword: 'allOf',
            keywordLocation: keywordLocation,
            error: `Instance does not match every subschema.`
        });
    }
    if ($oneOf !== undefined) {
        const keywordLocation = `${schemaLocation}/oneOf`;
        const errorsLength = errors.length;
        const matches = $oneOf.filter((subSchema, i)=>{
            const subEvaluated = Object.create(evaluated);
            const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, subSchema, draft, lookup, shortCircuit, $recursiveAnchor === true ? recursiveAnchor : null, instanceLocation, `${keywordLocation}/${i}`, subEvaluated);
            errors.push(...result.errors);
            if (result.valid) subEvaluateds.push(subEvaluated);
            return result.valid;
        }).length;
        if (matches === 1) errors.length = errorsLength;
        else errors.splice(errorsLength, 0, {
            instanceLocation: instanceLocation,
            keyword: 'oneOf',
            keywordLocation: keywordLocation,
            error: `Instance does not match exactly one subschema (${matches} matches).`
        });
    }
    if (instanceType === 'object' || instanceType === 'array') Object.assign(evaluated, ...subEvaluateds);
    if ($if !== undefined) {
        const keywordLocation = `${schemaLocation}/if`;
        const conditionResult = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, $if, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, keywordLocation, evaluated).valid;
        if (conditionResult) {
            if ($then !== undefined) {
                const thenResult = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, $then, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${schemaLocation}/then`, evaluated);
                if (!thenResult.valid) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: 'if',
                    keywordLocation: keywordLocation,
                    error: `Instance does not match "then" schema.`
                }, ...thenResult.errors);
            }
        } else if ($else !== undefined) {
            const elseResult = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, $else, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${schemaLocation}/else`, evaluated);
            if (!elseResult.valid) errors.push({
                instanceLocation: instanceLocation,
                keyword: 'if',
                keywordLocation: keywordLocation,
                error: `Instance does not match "else" schema.`
            }, ...elseResult.errors);
        }
    }
    if (instanceType === 'object') {
        if ($required !== undefined) {
            for (const key of $required)if (!$629fab7fb0c19ec3$var$hasOwnProperty(instance, key)) errors.push({
                instanceLocation: instanceLocation,
                keyword: 'required',
                keywordLocation: `${schemaLocation}/required`,
                error: `Instance does not have required property "${key}".`
            });
        }
        const keys = Object.keys(instance);
        if ($minProperties !== undefined && keys.length < $minProperties) errors.push({
            instanceLocation: instanceLocation,
            keyword: 'minProperties',
            keywordLocation: `${schemaLocation}/minProperties`,
            error: `Instance does not have at least ${$minProperties} properties.`
        });
        if ($maxProperties !== undefined && keys.length > $maxProperties) errors.push({
            instanceLocation: instanceLocation,
            keyword: 'maxProperties',
            keywordLocation: `${schemaLocation}/maxProperties`,
            error: `Instance does not have at least ${$maxProperties} properties.`
        });
        if ($propertyNames !== undefined) {
            const keywordLocation = `${schemaLocation}/propertyNames`;
            for(const key in instance){
                const subInstancePointer = `${instanceLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`;
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(key, $propertyNames, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, keywordLocation);
                if (!result.valid) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: 'propertyNames',
                    keywordLocation: keywordLocation,
                    error: `Property name "${key}" does not match schema.`
                }, ...result.errors);
            }
        }
        if ($dependentRequired !== undefined) {
            const keywordLocation = `${schemaLocation}/dependantRequired`;
            for(const key in $dependentRequired)if ($629fab7fb0c19ec3$var$hasOwnProperty(instance, key)) {
                const required = $dependentRequired[key];
                for (const dependantKey of required)if (!$629fab7fb0c19ec3$var$hasOwnProperty(instance, dependantKey)) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: 'dependentRequired',
                    keywordLocation: keywordLocation,
                    error: `Instance has "${key}" but does not have "${dependantKey}".`
                });
            }
        }
        if ($dependentSchemas !== undefined) for (const [key, dependentSchema] of Object.entries($dependentSchemas)){
            const keywordLocation = `${schemaLocation}/dependentSchemas`;
            if ($629fab7fb0c19ec3$var$hasOwnProperty(instance, key)) {
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, dependentSchema, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${keywordLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`, evaluated);
                if (!result.valid) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: 'dependentSchemas',
                    keywordLocation: keywordLocation,
                    error: `Instance has "${key}" but does not match dependant schema.`
                }, ...result.errors);
            }
        }
        if ($dependencies !== undefined) {
            const keywordLocation = `${schemaLocation}/dependencies`;
            for(const key in $dependencies)if ($629fab7fb0c19ec3$var$hasOwnProperty(instance, key)) {
                const propsOrSchema = $dependencies[key];
                if (Array.isArray(propsOrSchema)) {
                    for (const dependantKey of propsOrSchema)if (!$629fab7fb0c19ec3$var$hasOwnProperty(instance, dependantKey)) errors.push({
                        instanceLocation: instanceLocation,
                        keyword: 'dependencies',
                        keywordLocation: keywordLocation,
                        error: `Instance has "${key}" but does not have "${dependantKey}".`
                    });
                } else {
                    const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, propsOrSchema, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${keywordLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`);
                    if (!result.valid) errors.push({
                        instanceLocation: instanceLocation,
                        keyword: 'dependencies',
                        keywordLocation: keywordLocation,
                        error: `Instance has "${key}" but does not match dependant schema.`
                    }, ...result.errors);
                }
            }
        }
        const thisEvaluated = Object.create(null);
        let stop = false;
        if ($properties !== undefined) {
            const keywordLocation = `${schemaLocation}/properties`;
            for (const [key, propertySchema] of Object.entries($properties)){
                if (!$629fab7fb0c19ec3$var$hasOwnProperty(instance, key)) continue;
                const subInstancePointer = `${instanceLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`;
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[key], propertySchema, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, `${keywordLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`);
                thisEvaluated[key] = true;
                if (result.valid) evaluated[key] = true;
                else {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation: instanceLocation,
                        keyword: 'properties',
                        keywordLocation: keywordLocation,
                        error: `Property "${key}" does not match schema.`
                    }, ...result.errors);
                    if (stop) break;
                }
            }
        }
        if (!stop && $patternProperties !== undefined) {
            const keywordLocation = `${schemaLocation}/patternProperties`;
            for (const [pattern, subSchema] of Object.entries($patternProperties)){
                const regex = new RegExp(pattern, 'u');
                for(const key in instance){
                    if (!regex.test(key)) continue;
                    const subInstancePointer = `${instanceLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`;
                    const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[key], subSchema, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, `${keywordLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(pattern)}`);
                    thisEvaluated[key] = true;
                    if (result.valid) evaluated[key] = true;
                    else {
                        stop = shortCircuit;
                        errors.push({
                            instanceLocation: instanceLocation,
                            keyword: 'patternProperties',
                            keywordLocation: keywordLocation,
                            error: `Property "${key}" matches pattern "${pattern}" but does not match associated schema.`
                        }, ...result.errors);
                    }
                }
            }
        }
        if (!stop && $additionalProperties !== undefined) {
            const keywordLocation = `${schemaLocation}/additionalProperties`;
            for(const key in instance){
                if (thisEvaluated[key]) continue;
                const subInstancePointer = `${instanceLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`;
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[key], $additionalProperties, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, keywordLocation);
                if (result.valid) evaluated[key] = true;
                else {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation: instanceLocation,
                        keyword: 'additionalProperties',
                        keywordLocation: keywordLocation,
                        error: `Property "${key}" does not match additional properties schema.`
                    }, ...result.errors);
                }
            }
        } else if (!stop && $unevaluatedProperties !== undefined) {
            const keywordLocation = `${schemaLocation}/unevaluatedProperties`;
            for(const key in instance)if (!evaluated[key]) {
                const subInstancePointer = `${instanceLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`;
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[key], $unevaluatedProperties, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, keywordLocation);
                if (result.valid) evaluated[key] = true;
                else errors.push({
                    instanceLocation: instanceLocation,
                    keyword: 'unevaluatedProperties',
                    keywordLocation: keywordLocation,
                    error: `Property "${key}" does not match unevaluated properties schema.`
                }, ...result.errors);
            }
        }
    } else if (instanceType === 'array') {
        if ($maxItems !== undefined && instance.length > $maxItems) errors.push({
            instanceLocation: instanceLocation,
            keyword: 'maxItems',
            keywordLocation: `${schemaLocation}/maxItems`,
            error: `Array has too many items (${instance.length} > ${$maxItems}).`
        });
        if ($minItems !== undefined && instance.length < $minItems) errors.push({
            instanceLocation: instanceLocation,
            keyword: 'minItems',
            keywordLocation: `${schemaLocation}/minItems`,
            error: `Array has too few items (${instance.length} < ${$minItems}).`
        });
        const length = instance.length;
        let i = 0;
        let stop = false;
        if ($prefixItems !== undefined) {
            const keywordLocation = `${schemaLocation}/prefixItems`;
            const length2 = Math.min($prefixItems.length, length);
            for(; i < length2; i++){
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[i], $prefixItems[i], draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, `${keywordLocation}/${i}`);
                evaluated[i] = true;
                if (!result.valid) {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation: instanceLocation,
                        keyword: 'prefixItems',
                        keywordLocation: keywordLocation,
                        error: `Items did not match schema.`
                    }, ...result.errors);
                    if (stop) break;
                }
            }
        }
        if ($items !== undefined) {
            const keywordLocation = `${schemaLocation}/items`;
            if (Array.isArray($items)) {
                const length2 = Math.min($items.length, length);
                for(; i < length2; i++){
                    const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[i], $items[i], draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, `${keywordLocation}/${i}`);
                    evaluated[i] = true;
                    if (!result.valid) {
                        stop = shortCircuit;
                        errors.push({
                            instanceLocation: instanceLocation,
                            keyword: 'items',
                            keywordLocation: keywordLocation,
                            error: `Items did not match schema.`
                        }, ...result.errors);
                        if (stop) break;
                    }
                }
            } else for(; i < length; i++){
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[i], $items, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, keywordLocation);
                evaluated[i] = true;
                if (!result.valid) {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation: instanceLocation,
                        keyword: 'items',
                        keywordLocation: keywordLocation,
                        error: `Items did not match schema.`
                    }, ...result.errors);
                    if (stop) break;
                }
            }
            if (!stop && $additionalItems !== undefined) {
                const keywordLocation = `${schemaLocation}/additionalItems`;
                for(; i < length; i++){
                    const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[i], $additionalItems, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, keywordLocation);
                    evaluated[i] = true;
                    if (!result.valid) {
                        stop = shortCircuit;
                        errors.push({
                            instanceLocation: instanceLocation,
                            keyword: 'additionalItems',
                            keywordLocation: keywordLocation,
                            error: `Items did not match additional items schema.`
                        }, ...result.errors);
                    }
                }
            }
        }
        if ($contains !== undefined) {
            if (length === 0 && $minContains === undefined) errors.push({
                instanceLocation: instanceLocation,
                keyword: 'contains',
                keywordLocation: `${schemaLocation}/contains`,
                error: `Array is empty. It must contain at least one item matching the schema.`
            });
            else if ($minContains !== undefined && length < $minContains) errors.push({
                instanceLocation: instanceLocation,
                keyword: 'minContains',
                keywordLocation: `${schemaLocation}/minContains`,
                error: `Array has less items (${length}) than minContains (${$minContains}).`
            });
            else {
                const keywordLocation = `${schemaLocation}/contains`;
                const errorsLength = errors.length;
                let contained = 0;
                for(let j = 0; j < length; j++){
                    const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[j], $contains, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${j}`, keywordLocation);
                    if (result.valid) {
                        evaluated[j] = true;
                        contained++;
                    } else errors.push(...result.errors);
                }
                if (contained >= ($minContains || 0)) errors.length = errorsLength;
                if ($minContains === undefined && contained === 0) errors.splice(errorsLength, 0, {
                    instanceLocation: instanceLocation,
                    keyword: 'contains',
                    keywordLocation: keywordLocation,
                    error: `Array does not contain item matching schema.`
                });
                else if ($minContains !== undefined && contained < $minContains) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: 'minContains',
                    keywordLocation: `${schemaLocation}/minContains`,
                    error: `Array must contain at least ${$minContains} items matching schema. Only ${contained} items were found.`
                });
                else if ($maxContains !== undefined && contained > $maxContains) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: 'maxContains',
                    keywordLocation: `${schemaLocation}/maxContains`,
                    error: `Array may contain at most ${$maxContains} items matching schema. ${contained} items were found.`
                });
            }
        }
        if (!stop && $unevaluatedItems !== undefined) {
            const keywordLocation = `${schemaLocation}/unevaluatedItems`;
            for(i; i < length; i++){
                if (evaluated[i]) continue;
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[i], $unevaluatedItems, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, keywordLocation);
                evaluated[i] = true;
                if (!result.valid) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: 'unevaluatedItems',
                    keywordLocation: keywordLocation,
                    error: `Items did not match unevaluated items schema.`
                }, ...result.errors);
            }
        }
        if ($uniqueItems) for(let j = 0; j < length; j++){
            const a = instance[j];
            const ao = typeof a === 'object' && a !== null;
            for(let k = 0; k < length; k++){
                if (j === k) continue;
                const b = instance[k];
                const bo = typeof b === 'object' && b !== null;
                if (a === b || ao && bo && (0, $01be4901a49decd2$export$f99d9bd271f9a30e)(a, b)) {
                    errors.push({
                        instanceLocation: instanceLocation,
                        keyword: 'uniqueItems',
                        keywordLocation: `${schemaLocation}/uniqueItems`,
                        error: `Duplicate items at indexes ${j} and ${k}.`
                    });
                    j = Number.MAX_SAFE_INTEGER;
                    k = Number.MAX_SAFE_INTEGER;
                }
            }
        }
    } else if (instanceType === 'number') {
        if (draft === '4') {
            if ($minimum !== undefined && ($exclusiveMinimum === true && instance <= $minimum || instance < $minimum)) errors.push({
                instanceLocation: instanceLocation,
                keyword: 'minimum',
                keywordLocation: `${schemaLocation}/minimum`,
                error: `${instance} is less than ${$exclusiveMinimum ? 'or equal to ' : ''} ${$minimum}.`
            });
            if ($maximum !== undefined && ($exclusiveMaximum === true && instance >= $maximum || instance > $maximum)) errors.push({
                instanceLocation: instanceLocation,
                keyword: 'maximum',
                keywordLocation: `${schemaLocation}/maximum`,
                error: `${instance} is greater than ${$exclusiveMaximum ? 'or equal to ' : ''} ${$maximum}.`
            });
        } else {
            if ($minimum !== undefined && instance < $minimum) errors.push({
                instanceLocation: instanceLocation,
                keyword: 'minimum',
                keywordLocation: `${schemaLocation}/minimum`,
                error: `${instance} is less than ${$minimum}.`
            });
            if ($maximum !== undefined && instance > $maximum) errors.push({
                instanceLocation: instanceLocation,
                keyword: 'maximum',
                keywordLocation: `${schemaLocation}/maximum`,
                error: `${instance} is greater than ${$maximum}.`
            });
            if ($exclusiveMinimum !== undefined && instance <= $exclusiveMinimum) errors.push({
                instanceLocation: instanceLocation,
                keyword: 'exclusiveMinimum',
                keywordLocation: `${schemaLocation}/exclusiveMinimum`,
                error: `${instance} is less than ${$exclusiveMinimum}.`
            });
            if ($exclusiveMaximum !== undefined && instance >= $exclusiveMaximum) errors.push({
                instanceLocation: instanceLocation,
                keyword: 'exclusiveMaximum',
                keywordLocation: `${schemaLocation}/exclusiveMaximum`,
                error: `${instance} is greater than or equal to ${$exclusiveMaximum}.`
            });
        }
        if ($multipleOf !== undefined) {
            if (!$629fab7fb0c19ec3$var$isMultipleOf(instance, $multipleOf)) errors.push({
                instanceLocation: instanceLocation,
                keyword: 'multipleOf',
                keywordLocation: `${schemaLocation}/multipleOf`,
                error: `${instance} is not a multiple of ${$multipleOf}.`
            });
        }
    } else if (instanceType === 'string') {
        const length = $minLength === undefined && $maxLength === undefined ? 0 : (0, $7121b206e03ba7d7$export$e383d1c74f4e3b67)(instance);
        if ($minLength !== undefined && length < $minLength) errors.push({
            instanceLocation: instanceLocation,
            keyword: 'minLength',
            keywordLocation: `${schemaLocation}/minLength`,
            error: `String is too short (${length} < ${$minLength}).`
        });
        if ($maxLength !== undefined && length > $maxLength) errors.push({
            instanceLocation: instanceLocation,
            keyword: 'maxLength',
            keywordLocation: `${schemaLocation}/maxLength`,
            error: `String is too long (${length} > ${$maxLength}).`
        });
        if ($pattern !== undefined && !new RegExp($pattern, 'u').test(instance)) errors.push({
            instanceLocation: instanceLocation,
            keyword: 'pattern',
            keywordLocation: `${schemaLocation}/pattern`,
            error: `String does not match pattern.`
        });
        if ($format !== undefined && (0, $1ecce3c2faf95ef0$export$d9468344d3651243)[$format] && !(0, $1ecce3c2faf95ef0$export$d9468344d3651243)[$format](instance)) errors.push({
            instanceLocation: instanceLocation,
            keyword: 'format',
            keywordLocation: `${schemaLocation}/format`,
            error: `String does not match format "${$format}".`
        });
    }
    return {
        valid: errors.length === 0,
        errors: errors
    };
}


const $b78c044e3d911d2e$export$5c333a116e949cdd = Date.UTC(1900, 0, 1);
const $b78c044e3d911d2e$export$a75f2bff57811055 = Date.UTC(3000, 11, 31);
function $b78c044e3d911d2e$export$7660134aa4da2247(value) {
    if (value.trim() === '') return undefined;
    const regex = /^\s*(\d{1,2})\s*[.,-\/]\s*(\d{1,2})(?:\s*[.,-\/]\s*(\d{2,4}))?\s*$/;
    const match = regex.exec(value);
    if (!match) return undefined;
    const [, month, day, year] = match;
    const date = new Date();
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    if (year) {
        let yearn = parseInt(year, 10);
        if (yearn <= date.getFullYear() + 2 - 2000) yearn += 2000;
        else if (yearn < 100) yearn += 1900;
        else if (yearn < 1000) yearn *= 10;
        date.setFullYear(yearn);
    }
    if (month) date.setMonth(parseInt(month, 10) - 1);
    if (day) date.setDate(parseInt(day, 10));
    return date;
}
const $b78c044e3d911d2e$var$userTimeRegex = /^(?<hour>0?[1-9]|1[0-2])(?:\s*[:.]\s*(?<minute>[0-5]\d))?\s*(?<period>[ap])\.?(?:\s*m\.?)?$/i;
function $b78c044e3d911d2e$export$ca3f99600512f983(value) {
    value = value.trim();
    if (value === '') return null;
    const match = $b78c044e3d911d2e$var$userTimeRegex.exec(value);
    if (!match?.groups) return null;
    let hour = Number(match.groups.hour);
    const minute = match.groups.minute ? Number(match.groups.minute) : 0;
    const period = match.groups.period.toLowerCase();
    if (period === 'a') {
        if (hour === 12) hour = 0;
    } else if (hour !== 12) hour += 12;
    return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
}
function $b78c044e3d911d2e$export$b0932c69ff376ad3(dob, today = new Date()) {
    let years = today.getUTCFullYear() - dob.getUTCFullYear();
    let months = today.getUTCMonth() - dob.getUTCMonth();
    if (months < 0 || months === 0 && today.getUTCDate() < dob.getUTCDate()) years--;
    if (months < 0) months += 12;
    return {
        years: years,
        months: months
    };
}
function $b78c044e3d911d2e$export$dd412b56f1e4d8aa(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}
const $b78c044e3d911d2e$export$d0bc05622ca27791 = /^(\d{1,4}) days? (ago|from now)$/;
function $b78c044e3d911d2e$export$aebd7d4ffee5ebdd(value) {
    return value === 'Today' || value === 'Yesterday' || value === 'Tomorrow' || $b78c044e3d911d2e$export$d0bc05622ca27791.test(value);
}
function $b78c044e3d911d2e$export$5729bdcef1c036db(today, value) {
    if (value === 'Today') return today;
    if (value === 'Yesterday') return $b78c044e3d911d2e$export$dd412b56f1e4d8aa(today, -1).getTime();
    if (value === 'Tomorrow') return $b78c044e3d911d2e$export$dd412b56f1e4d8aa(today, 1).getTime();
    const [, rawN, rawDir] = $b78c044e3d911d2e$export$d0bc05622ca27791.exec(value) || [];
    const n = parseInt(rawN, 10);
    if (!isFinite(n) || n < 1 || n > 9999) return undefined;
    const dir = rawDir === 'ago' ? -1 : 1;
    return $b78c044e3d911d2e$export$dd412b56f1e4d8aa(today, dir * n).getTime();
}
const $b78c044e3d911d2e$export$41d8fd8f1a1513f = new Intl.DateTimeFormat('en-us', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
});
const $b78c044e3d911d2e$export$6aa1a8800137fac7 = new Intl.DateTimeFormat('en-us', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: 'UTC'
});
const $b78c044e3d911d2e$export$faf60e60fca9bed1 = new Intl.DateTimeFormat('en-us', {
    weekday: 'long'
});
function $b78c044e3d911d2e$export$f41928ddf8b27367(value) {
    // Validate basic pattern
    if (!/^\d\d:\d\d$/.test(value)) return {
        value: value,
        success: false
    };
    let [hours, minutes] = value.split(':').map(Number);
    // Validate numeric ranges (00-23 for hours, 00-59 for minutes)
    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return {
        value: value,
        success: false
    };
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return {
        value: `${hours}:${String(minutes).padStart(2, '0')} ${period}`,
        success: true
    };
}
function $b78c044e3d911d2e$export$c451b6cac1dafab2(time) {
    let [hours, minutes] = time.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
}
function $b78c044e3d911d2e$export$af7c4989823a7ea4(start, end) {
    return Math.floor((end.getTime() - start.getTime()) / 86400000);
}
function $b78c044e3d911d2e$export$770039c4b251b19(date, monthsToAdd) {
    function positiveModulo(value, divisor) {
        return (value % divisor + divisor) % divisor;
    }
    function makeUTCDate(year, month, day, hours, minutes, seconds, milliseconds) {
        // Date.UTC treats years 0-99 as 1900-1999.
        // Adding 400 preserves leap-year behavior because the Gregorian calendar repeats every 400 years.
        const safeYear = year >= 0 && year <= 99 ? year + 400 : year;
        const result = new Date(Date.UTC(safeYear, month, day, hours, minutes, seconds, milliseconds));
        if (safeYear !== year) result.setUTCFullYear(year);
        return result;
    }
    function daysInUTCMonth(year, month) {
        return makeUTCDate(year, month + 1, 0, 0, 0, 0, 0).getUTCDate();
    }
    const originalYear = date.getUTCFullYear();
    const originalMonth = date.getUTCMonth();
    const originalDay = date.getUTCDate();
    const absoluteMonth = originalYear * 12 + originalMonth + monthsToAdd;
    const targetYear = Math.floor(absoluteMonth / 12);
    const targetMonth = positiveModulo(absoluteMonth, 12);
    // SQL Server date range is 0001-01-01 through 9999-12-31.
    // Adjust this if your expression language intentionally allows JS's wider Date range.
    if (targetYear < 1 || targetYear > 9999) return null;
    const targetDay = Math.min(originalDay, daysInUTCMonth(targetYear, targetMonth));
    const result = makeUTCDate(targetYear, targetMonth, targetDay, date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    return Number.isFinite(result.getTime()) ? result : null;
}


var $3ce7c51d883dfdd6$export$821b31be3f8372e3 = /*#__PURE__*/ function(PersonOrganizationAssociationType) {
    PersonOrganizationAssociationType[PersonOrganizationAssociationType["Creator"] = 1] = "Creator";
    PersonOrganizationAssociationType[PersonOrganizationAssociationType["Activity"] = 2] = "Activity";
    PersonOrganizationAssociationType[PersonOrganizationAssociationType["Consent"] = 4] = "Consent";
    return PersonOrganizationAssociationType;
}({});
const $3ce7c51d883dfdd6$var$medicareBeneficiaryIdAlphabeticCharacterClass = 'ACDEFGHJKMNPQRTUVWXYacdefghjkmnpqrtuvwxy';
const $3ce7c51d883dfdd6$var$medicareBeneficiaryIdCharacterClass = `${$3ce7c51d883dfdd6$var$medicareBeneficiaryIdAlphabeticCharacterClass}0-9`;
const $3ce7c51d883dfdd6$export$5acb7eee7822054c = `^[1-9][${$3ce7c51d883dfdd6$var$medicareBeneficiaryIdAlphabeticCharacterClass}]` + `[${$3ce7c51d883dfdd6$var$medicareBeneficiaryIdCharacterClass}][0-9](?:` + `[${$3ce7c51d883dfdd6$var$medicareBeneficiaryIdAlphabeticCharacterClass}]` + `[${$3ce7c51d883dfdd6$var$medicareBeneficiaryIdCharacterClass}][0-9]` + `[${$3ce7c51d883dfdd6$var$medicareBeneficiaryIdAlphabeticCharacterClass}]{2}[0-9]{2}|` + `-[${$3ce7c51d883dfdd6$var$medicareBeneficiaryIdAlphabeticCharacterClass}]` + `[${$3ce7c51d883dfdd6$var$medicareBeneficiaryIdCharacterClass}][0-9]-` + `[${$3ce7c51d883dfdd6$var$medicareBeneficiaryIdAlphabeticCharacterClass}]{2}[0-9]{2})$`;
const $3ce7c51d883dfdd6$export$2997b42a82810d9a = `^[${$3ce7c51d883dfdd6$var$medicareBeneficiaryIdCharacterClass}-]{3,13}$`;
function $3ce7c51d883dfdd6$export$47a9f243ee57fb25(value) {
    return typeof value === 'string' ? value.trim().replaceAll('-', '').toUpperCase() : value;
}
const $3ce7c51d883dfdd6$export$a9a1eac9c459ab32 = {
    male: 0,
    female: 1,
    other: 2,
    unknown: -1
};
const $3ce7c51d883dfdd6$export$579409da2a52ea29 = [
    {
        choice_id: 0,
        locale: 'en',
        name: 'English'
    },
    {
        choice_id: 45,
        locale: 'sq',
        name: 'Albanian'
    },
    {
        choice_id: 1,
        locale: 'ar',
        name: 'Arabic'
    },
    {
        choice_id: 2,
        locale: 'bn',
        name: 'Bengali'
    },
    {
        choice_id: 3,
        locale: 'bs',
        name: 'Bosnian'
    },
    {
        choice_id: 4,
        locale: 'bg',
        name: 'Bulgarian'
    },
    {
        choice_id: 5,
        locale: 'zh',
        name: 'Chinese'
    },
    {
        choice_id: 55,
        locale: 'chk',
        name: 'Chuukese'
    },
    {
        choice_id: 6,
        locale: 'hr',
        name: 'Croatian'
    },
    {
        choice_id: 7,
        locale: 'cs',
        name: 'Czech'
    },
    {
        choice_id: 8,
        locale: 'da',
        name: 'Danish'
    },
    {
        choice_id: 9,
        locale: 'nl',
        name: 'Dutch'
    },
    {
        choice_id: 10,
        locale: 'et',
        name: 'Estonian'
    },
    {
        choice_id: 46,
        locale: 'fa',
        name: 'Farsi'
    },
    {
        choice_id: 11,
        locale: 'fil',
        name: 'Filipino'
    },
    {
        choice_id: 12,
        locale: 'fi',
        name: 'Finnish'
    },
    {
        choice_id: 13,
        locale: 'fr',
        name: 'French'
    },
    {
        choice_id: 14,
        locale: 'fy',
        name: 'Frisian'
    },
    {
        choice_id: 15,
        locale: 'de',
        name: 'German'
    },
    {
        choice_id: 16,
        locale: 'el',
        name: 'Greek'
    },
    {
        choice_id: 17,
        locale: 'ht',
        name: 'Haitian Creole'
    },
    {
        choice_id: 18,
        locale: 'hi',
        name: 'Hindi'
    },
    {
        choice_id: 19,
        locale: 'hmn',
        name: 'Hmong'
    },
    {
        choice_id: 20,
        locale: 'is',
        name: 'Icelandic'
    },
    {
        choice_id: 21,
        locale: 'it',
        name: 'Italian'
    },
    {
        choice_id: 22,
        locale: 'ja',
        name: 'Japanese'
    },
    {
        choice_id: 54,
        locale: 'km',
        name: 'Khmer'
    },
    {
        choice_id: 47,
        locale: 'rw',
        name: 'Kinyarwanda'
    },
    {
        choice_id: 23,
        locale: 'ko',
        name: 'Korean'
    },
    {
        choice_id: 24,
        locale: 'lv',
        name: 'Latvian'
    },
    {
        choice_id: 48,
        locale: 'lir',
        name: 'Liberian Kreyol'
    },
    {
        choice_id: 49,
        locale: 'ln',
        name: 'Lingala'
    },
    {
        choice_id: 25,
        locale: 'lt',
        name: 'Lithuanian'
    },
    {
        choice_id: 53,
        locale: 'ne',
        name: 'Nepali'
    },
    {
        choice_id: 26,
        locale: 'no',
        name: 'Norwegian'
    },
    {
        choice_id: 27,
        locale: 'ps',
        name: 'Pashto'
    },
    {
        choice_id: 28,
        locale: 'fa',
        name: 'Persian'
    },
    {
        choice_id: 29,
        locale: 'pl',
        name: 'Polish'
    },
    {
        choice_id: 30,
        locale: 'pt',
        name: 'Portuguese'
    },
    {
        choice_id: 31,
        locale: 'pa',
        name: 'Punjabi'
    },
    {
        choice_id: 32,
        locale: 'ro',
        name: 'Romanian'
    },
    {
        choice_id: 33,
        locale: 'ru',
        name: 'Russian'
    },
    {
        choice_id: 34,
        locale: 'sm',
        name: 'Samoan'
    },
    {
        choice_id: 35,
        locale: 'sr',
        name: 'Serbian'
    },
    {
        choice_id: 36,
        locale: 'sk',
        name: 'Slovakian'
    },
    {
        choice_id: 37,
        locale: 'sl',
        name: 'Slovenian'
    },
    {
        choice_id: 38,
        locale: 'so',
        name: 'Somali'
    },
    {
        choice_id: 39,
        locale: 'es',
        name: 'Spanish'
    },
    {
        choice_id: 50,
        locale: 'sw',
        name: 'Swahili'
    },
    {
        choice_id: 40,
        locale: 'sv',
        name: 'Swedish'
    },
    {
        choice_id: 56,
        locale: 'tl',
        name: 'Tagalog'
    },
    {
        choice_id: 41,
        locale: 'te',
        name: 'Telugu'
    },
    {
        choice_id: 42,
        locale: 'th',
        name: 'Thai'
    },
    {
        choice_id: 51,
        locale: 'tr',
        name: 'Turkish'
    },
    {
        choice_id: 52,
        locale: 'uk',
        name: 'Ukrainian'
    },
    {
        choice_id: 43,
        locale: 'ur',
        name: 'Urdu'
    },
    {
        choice_id: 44,
        locale: 'vi',
        name: 'Vietnamese'
    }
];
const $3ce7c51d883dfdd6$export$f5a9da98b58e894 = 2;
const $3ce7c51d883dfdd6$export$9657669ee60b4be0 = [
    {
        label: 'Female',
        choice_id: 1,
        fhirCode: 'female'
    },
    {
        label: 'Male',
        choice_id: 0,
        fhirCode: 'male'
    },
    {
        label: 'Other',
        choice_id: $3ce7c51d883dfdd6$export$f5a9da98b58e894,
        fhirCode: 'oth'
    },
    {
        label: 'Prefer not to answer',
        choice_id: 31,
        fhirCode: 'asked-declined'
    }
];
const $3ce7c51d883dfdd6$export$b43c9e3faf0aba5c = [
    {
        label: 'Hispanic or Latino',
        choice_id: 1,
        fhirCode: '2135-2'
    },
    {
        label: 'Not Hispanic or Latino',
        choice_id: 0,
        fhirCode: '2186-5'
    },
    {
        label: 'Prefer not to answer',
        choice_id: 31,
        fhirCode: 'ASKU'
    }
];
const $3ce7c51d883dfdd6$export$4600759e6cedf2ab = [
    {
        label: 'American Indian or Alaska Native',
        choice_id: 0,
        exclusive: false,
        fhirCode: '1002-5'
    },
    {
        label: 'Asian',
        choice_id: 1,
        exclusive: false,
        fhirCode: '2028-9'
    },
    {
        label: 'Black or African American',
        choice_id: 2,
        exclusive: false,
        fhirCode: '2054-5'
    },
    {
        label: 'Native Hawaiian or Other Pacific Islander',
        choice_id: 3,
        exclusive: false,
        fhirCode: '2076-8'
    },
    {
        label: 'White',
        choice_id: 4,
        exclusive: false,
        fhirCode: '2106-3'
    },
    {
        label: 'Prefer not to answer',
        choice_id: 31,
        exclusive: true,
        fhirCode: 'ASKU'
    }
];
const $3ce7c51d883dfdd6$export$41dc40aecf6ed9c3 = [
    {
        label: 'Heterosexual',
        choice_id: 0
    },
    {
        label: 'Homosexual',
        choice_id: 1
    },
    {
        label: 'Bisexual',
        choice_id: 2
    },
    {
        label: 'Other',
        choice_id: 3
    },
    {
        label: 'Prefer not to answer',
        choice_id: 31
    }
];
const $3ce7c51d883dfdd6$export$160e4329619a95c1 = [
    {
        label: 'Married',
        choice_id: 0,
        fhirCode: 'M'
    },
    {
        label: 'Never married',
        choice_id: 1,
        fhirCode: 'S'
    },
    {
        label: 'Separated',
        choice_id: 2,
        fhirCode: 'L'
    },
    {
        label: 'Divorced',
        choice_id: 3,
        fhirCode: 'D'
    },
    {
        label: 'Widowed',
        choice_id: 4,
        fhirCode: 'W'
    },
    {
        label: 'Prefer not to answer',
        choice_id: 31,
        fhirCode: 'UNK'
    }
];
const $3ce7c51d883dfdd6$export$5704fb055ad06540 = [
    {
        label: 'Female',
        choice_id: 1
    },
    {
        label: 'Male',
        choice_id: 0
    },
    {
        label: 'Other',
        choice_id: 2
    },
    {
        label: 'Non-binary',
        choice_id: 3
    },
    {
        label: 'Transgender female',
        choice_id: 5
    },
    {
        label: 'Transgender male',
        choice_id: 4
    },
    {
        label: "Don't know",
        choice_id: 6
    },
    {
        label: 'Prefer not to answer',
        choice_id: 31
    }
];
const $3ce7c51d883dfdd6$export$d7ceeaae600d195b = [
    'Jr.',
    'Sr.',
    'II',
    'III',
    'IV',
    'V',
    'R.N.',
    'L.P.N.',
    'M.S.W.',
    'Ph.D.',
    'M.D.',
    'D.O.',
    'Esq.'
];


// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $60b0cb81f60b04f1$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    const BASE_MAP = new Uint8Array(256);
    for(let j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(let i = 0; i < ALPHABET.length; i++){
        const x = ALPHABET.charAt(i);
        const xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    const BASE = ALPHABET.length;
    const LEADER = ALPHABET.charAt(0);
    const FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    const iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        // eslint-disable-next-line no-empty
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
        if (source.length === 0) return '';
        // Skip & count leading zeroes.
        let zeroes = 0;
        let length = 0;
        let pbegin = 0;
        const pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        const size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        const b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            let carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            let i = 0;
            for(let it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        let it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        let str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return new Uint8Array();
        let psz = 0;
        // Skip and count leading '1's.
        let zeroes = 0;
        let length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        const size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        const b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Find code of next character
            const charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            let carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            let i = 0;
            for(let it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        let it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        const vch = new Uint8Array(zeroes + (size - it4));
        let j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        const buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error('Non-base' + BASE + ' character');
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $60b0cb81f60b04f1$export$2e2bcd8739ae039 = $60b0cb81f60b04f1$var$base;


const $52ec208b1be5af58$var$base58Alphabet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
const $52ec208b1be5af58$var$base58 = (0, $60b0cb81f60b04f1$export$2e2bcd8739ae039)($52ec208b1be5af58$var$base58Alphabet);
const $52ec208b1be5af58$var$UUID_BYTE_LENGTH = 16;
const $52ec208b1be5af58$var$MIN_BASE58_UUID_LENGTH = 16;
const $52ec208b1be5af58$var$MAX_BASE58_UUID_LENGTH = 22;
const $52ec208b1be5af58$var$uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const $52ec208b1be5af58$var$bth = [];
for(let i = 0; i < 256; i++)$52ec208b1be5af58$var$bth[i] = (i + 0x100).toString(16).slice(1);
function $52ec208b1be5af58$export$7077a352e654daea(s) {
    return $52ec208b1be5af58$var$base58.encode($52ec208b1be5af58$var$parseUuid(s));
}
function $52ec208b1be5af58$export$13d9777f790da32(s) {
    if (typeof s !== 'string') throw new TypeError('Expected string');
    // Cheap rejection before running base-x decode.
    // Valid base-x encodings of exactly 16 UUID bytes are 16..22 chars.
    if (s.length < $52ec208b1be5af58$var$MIN_BASE58_UUID_LENGTH || s.length > $52ec208b1be5af58$var$MAX_BASE58_UUID_LENGTH) throw new TypeError(`Invalid base58 UUID length: ${s.length}`);
    const bytes = $52ec208b1be5af58$var$base58.decode(s);
    if (bytes.length !== $52ec208b1be5af58$var$UUID_BYTE_LENGTH) throw new TypeError(`Invalid base58 UUID byte length: ${bytes.length}`);
    return $52ec208b1be5af58$var$stringifyUuid(bytes);
}
function $52ec208b1be5af58$var$stringifyUuid(arr) {
    if (!(arr instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
    if (arr.length !== $52ec208b1be5af58$var$UUID_BYTE_LENGTH) throw new TypeError('Expected 16 bytes');
    return $52ec208b1be5af58$var$bth[arr[0]] + $52ec208b1be5af58$var$bth[arr[1]] + $52ec208b1be5af58$var$bth[arr[2]] + $52ec208b1be5af58$var$bth[arr[3]] + '-' + $52ec208b1be5af58$var$bth[arr[4]] + $52ec208b1be5af58$var$bth[arr[5]] + '-' + $52ec208b1be5af58$var$bth[arr[6]] + $52ec208b1be5af58$var$bth[arr[7]] + '-' + $52ec208b1be5af58$var$bth[arr[8]] + $52ec208b1be5af58$var$bth[arr[9]] + '-' + $52ec208b1be5af58$var$bth[arr[10]] + $52ec208b1be5af58$var$bth[arr[11]] + $52ec208b1be5af58$var$bth[arr[12]] + $52ec208b1be5af58$var$bth[arr[13]] + $52ec208b1be5af58$var$bth[arr[14]] + $52ec208b1be5af58$var$bth[arr[15]];
}
function $52ec208b1be5af58$var$parseUuid(s) {
    if (!$52ec208b1be5af58$var$uuidRegex.test(s)) throw new TypeError('Invalid uuid');
    const hex = s.replaceAll('-', '');
    const arr = new Uint8Array($52ec208b1be5af58$var$UUID_BYTE_LENGTH);
    for(let i = 0; i < $52ec208b1be5af58$var$UUID_BYTE_LENGTH; i++)arr[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
    return arr;
}


const $5e22b13d8e41f6dd$export$688d13a530c5dcbc = new Intl.NumberFormat('en-us', {});
const $5e22b13d8e41f6dd$export$4670d0ed237a9270 = new Intl.NumberFormat('en-us', {
    style: 'currency',
    currency: 'USD'
});
const $5e22b13d8e41f6dd$export$82fb8ba313c9dbb0 = new Intl.NumberFormat('en-us', {
    style: 'percent'
});
const $5e22b13d8e41f6dd$export$24b6a663def24ecb = new Intl.NumberFormat('en-us', {
    notation: 'compact',
    compactDisplay: 'short'
});
const $5e22b13d8e41f6dd$export$8ce5ed5e47477d75 = new Intl.NumberFormat('en-us', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact'
});
const $5e22b13d8e41f6dd$export$2918518777706bf8 = new Intl.NumberFormat('en-us', {
    style: 'percent',
    notation: 'compact'
});
function $5e22b13d8e41f6dd$export$a3992db8dd0fd9e6(value, precision) {
    if (!Number.isFinite(value)) throw new TypeError('Value must be a finite number');
    if (!Number.isInteger(precision) || precision < 0) throw new TypeError('Precision must be a non-negative integer');
    const sign = value < 0 ? -1 : 1;
    const abs = Math.abs(value);
    const shifted = Number(`${abs}e${precision}`);
    const rounded = Math.round(shifted);
    const result = sign * Number(`${rounded}e${-precision}`);
    return Object.is(result, -0) ? 0 : result;
}
function $5e22b13d8e41f6dd$export$dd91a1966a303b99(value, precision) {
    if (!Number.isFinite(value)) throw new TypeError(`Value must be a finite number: ${value}`);
    if (!Number.isInteger(precision) || precision < 0) throw new TypeError(`Precision must be a non-negative integer: ${precision}`);
    const shifted = Number(`${value}e${precision}`);
    if (!Number.isFinite(shifted)) throw new RangeError(`Cannot ceil number: value ${value} with precision ${precision} is outside the supported range`);
    const tolerance = Number.EPSILON * Math.max(1, Math.abs(shifted));
    const ceiled = Math.ceil(shifted - tolerance);
    const result = Number(`${ceiled}e${-precision}`);
    if (!Number.isFinite(result)) throw new RangeError(`Cannot ceil number: value ${value} with precision ${precision} produced a non-finite result`);
    return Object.is(result, -0) ? 0 : result;
}




const $2b5d94bf448cfcef$export$1854a57995e68990 = /^\s*(.*((p|post)[-.\s]*(o|off|office)[-.\s]*(b|box|bin)[-.\s]*)|.*((p|post)[-.\s]*(o|off|office)[-.\s]*)|.*((p|post)[-.\s]*(b|box|bin)[-.\s]*)|(box|bin)[-.\s]*)(#|n|num|number)?\s*\d+/i;
function $2b5d94bf448cfcef$export$338eada492427913(q) {
    return q.match($2b5d94bf448cfcef$export$1854a57995e68990)?.[0]?.trim().toUpperCase().replace(/post/i, 'Post').replace(/office/i, 'Office').replace(/box/i, 'Box') ?? '';
}
function $2b5d94bf448cfcef$export$8fecc3029e4bae36(precision) {
    return precision === 'Subaddress' || precision === 'PointAddress' || precision === 'StreetAddress' || precision === 'POI';
}
const $2b5d94bf448cfcef$export$3650e4ad787ea880 = [
    '',
    'Subaddress',
    'PointAddress',
    'StreetAddress',
    'StreetInt',
    'StreetAddressExt',
    'DistanceMarker',
    'StreetMidBlock',
    'StreetName',
    'Locality',
    'PostalLoc',
    'PostalExt',
    'Postal',
    'POI',
    'LatLong',
    'XY',
    'YX',
    'MGRS',
    'USNG'
];
const $2b5d94bf448cfcef$export$d30a285adb132bc8 = {
    City: 'city',
    'Primary Postal': 'postal_code',
    Region: 'region_abbr',
    Subregion: 'subregion'
};
function $2b5d94bf448cfcef$export$df322274cb6efbe1(address) {
    address.precision = '';
    address.street_address = '';
    address.street_address = '';
    address.sub_address = '';
    address.neighborhood = '';
    address.district = '';
    address.metro_area = '';
    address.city = '';
    address.region = '';
    address.region_abbr = '';
    address.subregion = '';
    address.postal_code = '';
    address.postal_code_ext = '';
    address.country = '';
    address.entry_x = 0;
    address.entry_y = 0;
    address.rooftop_x = 0;
    address.rooftop_y = 0;
}



var $62b1af6d38ebce27$export$9f5bdfa4eeb4bc7e = /*#__PURE__*/ function(ContactType) {
    ContactType[ContactType["Unknown"] = 4096] = "Unknown";
    ContactType[ContactType["EmergencyContact"] = 1] = "EmergencyContact";
    ContactType[ContactType["Employer"] = 2] = "Employer";
    ContactType[ContactType["FederalAgency"] = 4] = "FederalAgency";
    ContactType[ContactType["InsuranceCompany"] = 8] = "InsuranceCompany";
    ContactType[ContactType["NextOfKin"] = 16] = "NextOfKin";
    ContactType[ContactType["StateAgency"] = 32] = "StateAgency";
    ContactType[ContactType["PrimaryEmergencyContact"] = 1048576] = "PrimaryEmergencyContact";
    ContactType[ContactType["Billing"] = 64] = "Billing";
    ContactType[ContactType["Administrative"] = 128] = "Administrative";
    ContactType[ContactType["HumanResource"] = 256] = "HumanResource";
    ContactType[ContactType["Payor"] = 512] = "Payor";
    ContactType[ContactType["Patient"] = 1024] = "Patient";
    ContactType[ContactType["Press"] = 2048] = "Press";
    ContactType[ContactType["Site"] = 262144] = "Site";
    ContactType[ContactType["PrimarySite"] = 524288] = "PrimarySite";
    return ContactType;
}({});
const $62b1af6d38ebce27$export$4c75d574fa86190 = [
    {
        id: 1048576,
        fhirCode: 'C',
        label: (0, $b11db1b62d4a8f76$export$c9238058729ccab6)
    },
    {
        id: 1,
        fhirCode: 'C',
        label: (0, $b11db1b62d4a8f76$export$e6d3bbcb6498fe45)
    },
    {
        id: 16,
        fhirCode: 'N',
        label: (0, $b11db1b62d4a8f76$export$f5494529e20e3385)
    },
    {
        id: 2,
        fhirCode: 'E',
        label: (0, $b11db1b62d4a8f76$export$f26cbd52422ea099)
    },
    {
        id: 4,
        fhirCode: 'F',
        label: (0, $b11db1b62d4a8f76$export$70154fb96da70b31)
    },
    {
        id: 32,
        fhirCode: 'S',
        label: (0, $b11db1b62d4a8f76$export$51027e8a6e256ee6)
    },
    {
        id: 8,
        fhirCode: 'I',
        label: (0, $b11db1b62d4a8f76$export$df8757b11bea02f0)
    },
    {
        id: 4096,
        fhirCode: 'U',
        label: (0, $b11db1b62d4a8f76$export$230e1efc20c8172a)
    }
];
const $62b1af6d38ebce27$export$2a7ee7224f7cfe9c = [
    {
        id: 64,
        fhirCode: 'BILL',
        label: (0, $b11db1b62d4a8f76$export$58faafdea4528c0c)
    },
    {
        id: 128,
        fhirCode: 'ADMIN',
        label: (0, $b11db1b62d4a8f76$export$3bd695ac39288245)
    },
    {
        id: 256,
        fhirCode: 'HR',
        label: (0, $b11db1b62d4a8f76$export$66ac5ac68c1dcca4)
    },
    {
        id: 512,
        fhirCode: 'PAYOR',
        label: (0, $b11db1b62d4a8f76$export$2cea9b5b0a64eca3)
    },
    {
        id: 1024,
        fhirCode: 'PATINF',
        label: (0, $b11db1b62d4a8f76$export$ab57077c7aa64ad3)
    },
    {
        id: 2048,
        fhirCode: 'PRESS',
        label: (0, $b11db1b62d4a8f76$export$f8432d94cae4776c)
    }
];



function $15a966c9a3403e81$export$caef59cbf5b7a7d4({ last_name: last_name, first_name: first_name, middle_name: middle_name, suffix: suffix, nickname: nickname }) {
    return (first_name ? first_name + ' ' : '') + (middle_name ? middle_name + ' ' : '') + (nickname ? `"${nickname}" ` : '') + last_name + (suffix ? ', ' + suffix : '');
}
function $15a966c9a3403e81$export$b580f1dfaaa8cdab({ last_name: last_name, first_name: first_name, middle_name: middle_name, suffix: suffix, nickname: nickname }) {
    return last_name + (first_name || middle_name || nickname ? ', ' + first_name + (first_name && nickname ? ' ' : '') + (nickname ? `"${nickname}"` : '') + ((first_name || nickname) && middle_name ? ' ' + middle_name : middle_name) : '') + (suffix ? ', ' + suffix : '');
}
function $15a966c9a3403e81$var$getAddressQuery(address) {
    const { street_address: street_address, sub_address: sub_address, city: city, region_abbr: region_abbr, postal_code: postal_code, postal_code_ext: postal_code_ext } = address;
    let query = street_address || '';
    if (street_address && sub_address) query += (query ? ', ' : '') + sub_address;
    if (city) query += (query ? ', ' : '') + city;
    if (region_abbr) query += (query ? ', ' : '') + region_abbr;
    if (postal_code) query += (query ? ' ' : '') + postal_code + (postal_code_ext ? '-' + postal_code_ext : '');
    return query;
}
function $15a966c9a3403e81$var$getMapUrl(address, type) {
    const query = $15a966c9a3403e81$var$getAddressQuery(address);
    const url = new URL(type === 'search' ? 'https://www.google.com/maps/search/' : 'https://www.google.com/maps/dir/');
    url.searchParams.set('api', '1');
    url.searchParams.set(type === 'search' ? 'query' : 'destination', query);
    return url;
}
function $15a966c9a3403e81$export$16324af849cc98bd(address, link = true, omitSubregion = false) {
    const { street_address: street_address, sub_address: sub_address, city: city, region_abbr: region_abbr, postal_code: postal_code, postal_code_ext: postal_code_ext, subregion: subregion } = address;
    let formatted = street_address || '';
    if (sub_address) formatted += (formatted ? ', ' : '') + sub_address;
    if (city) formatted += (formatted ? ', ' : '') + city;
    if (region_abbr) formatted += (formatted ? ', ' : '') + region_abbr;
    if (postal_code) formatted += (formatted ? ' ' : '') + postal_code + (postal_code_ext ? '-' + postal_code_ext : '');
    const parts = [];
    if (formatted) {
        if (link) {
            let linkClass;
            if (link === true || link === 'primary') linkClass = 'Link--primary';
            else if (link === 'secondary') linkClass = 'Link--secondary';
            parts.push((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<a
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('class', linkClass)}
          href="${$15a966c9a3403e81$var$getMapUrl(address, 'search')}"
          >${formatted}</a
        >`);
        } else parts.push(formatted);
    }
    if (subregion && !omitSubregion) {
        if (parts.length) parts.push(' - ');
        parts.push((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="no-wrap">County: ${subregion}</span>`);
    }
    return parts;
}
function $15a966c9a3403e81$export$26fab7c7c56386a9(address, includeSubregion = true) {
    const { street_address: street_address, sub_address: sub_address, city: city, region_abbr: region_abbr, postal_code: postal_code, postal_code_ext: postal_code_ext, subregion: subregion } = address;
    let formatted = street_address || '';
    if (sub_address) formatted += (formatted ? ', ' : '') + sub_address;
    if (city) formatted += (formatted ? ', ' : '') + city;
    if (region_abbr) formatted += (formatted ? ', ' : '') + region_abbr;
    if (postal_code) formatted += (formatted ? ' ' : '') + postal_code + (postal_code_ext ? '-' + postal_code_ext : '');
    if (subregion && includeSubregion) {
        if (formatted) formatted += ' - ';
        formatted += `County: ${subregion}`;
    }
    return formatted;
}
function $15a966c9a3403e81$export$ff1216816de7f138(phone, link = true) {
    if (link) {
        let linkClass;
        if (link === true || link === 'primary') linkClass = 'Link--primary';
        else if (link === 'secondary') linkClass = 'Link--secondary';
        return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`${phone.type ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="color-fg-muted">${phone.type + ' '}</span>` : null}<a
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('class', linkClass)}
        href="tel:${phone.number.replaceAll(/[^\d]/g, '')}"
        >${phone.number}${phone.extension ? ' ext ' + phone.extension : ''}</a
      >`;
    }
    return `${phone.type ? phone.type + ': ' : ''}${phone.number}${phone.extension ? ' ext ' + phone.extension : ''}`;
}
function $15a966c9a3403e81$export$2b79b564cdea702d(email, link = true, copy = true) {
    const copyButton = copy ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`&nbsp;<clipboard-copy
          class="btn-octicon d-print-none ml-n1 mt-n1 mb-n1 mr-n1 f6"
          style="vertical-align: baseline;"
          aria-label="Copy email"
          value="${email.email}"
          >${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$e3d4d49f14b4dd60))}</clipboard-copy
        >` : null;
    if (link) {
        let linkClass;
        if (link === true || link === 'primary') linkClass = 'Link--primary';
        else if (link === 'secondary') linkClass = 'Link--secondary';
        return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`${email.type ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="color-fg-muted">${email.type + ' '}</span>` : null}<a ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('class', linkClass)} href="mailto:${email.email}"
        >${email.email}</a
      >${copyButton}`;
    }
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`${email.type ? email.type + ': ' : ''}${email.email}${copyButton}`;
}
function $15a966c9a3403e81$export$9496e8a7688d3d34(locale, item, contactTypes, link = 'secondary') {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="d-flex flex-column gap-1 lh-condensed">
    <span class="d-flex gap-1 flex-items-center flex-wrap">
      <span>${item.name}</span>
      ${contactTypes.filter((x)=>x.id & item.type && x.id !== (0, $62b1af6d38ebce27$export$9f5bdfa4eeb4bc7e).PrimaryEmergencyContact).map(({ id: id, label: label })=>(0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="Label"
              >${id === (0, $62b1af6d38ebce27$export$9f5bdfa4eeb4bc7e).EmergencyContact ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span
                        class="d-item-has-primary-emergency-contact-checked"
                        >${(0, $b11db1b62d4a8f76$export$c860bd028d704467)[locale]}</span
                      >${' '}` : null}${label[locale]}</span
            >`)}
    </span>
    ${item.description ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="f6">${item.description}</span>` : null}
    <span class="f6 color-fg-muted d-flex flex-wrap gap-2 d-none-empty"
      >${item.phones?.map((x)=>(0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span>${$15a966c9a3403e81$export$ff1216816de7f138(x, link)}</span>`)}${item.emails?.map((x)=>(0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span>${$15a966c9a3403e81$export$2b79b564cdea702d(x, link)}</span>`)}</span
    >
    ${item.addresses?.map((x)=>(0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="f6 color-fg-muted">${$15a966c9a3403e81$export$16324af849cc98bd(x, link)}</span>`)}
  </span>`;
}
function $15a966c9a3403e81$export$c4d8c2c033da1ba(locale, precision) {
    const precise = (0, $2b5d94bf448cfcef$export$8fecc3029e4bae36)(precision ?? '');
    const text = precise ? (0, $b11db1b62d4a8f76$export$453f74456d906753)[locale] : (0, $b11db1b62d4a8f76$export$14627eadadec29ea)[locale];
    const iconContent = precise ? (0, $84c634e688af79ca$export$9c13049f489fa947) : (0, $84c634e688af79ca$export$d223a75748fa80b3);
    const classname = precise ? 'text-bold color-fg-success' : 'color-fg-muted';
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="d-inline-flex gap-1 flex-items-center ${classname}"
    >${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)(iconContent)}<span>${text}</span></span
  >`;
}


const $6941fa4b8204d0aa$var$_standardProperties = {
    OPERATION: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ORIGINAL_ACTIVITY_STATUS: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ORIGINAL_ACTIVITY_START_DATE: {
        property_id: 0,
        type: 'date',
        choice_type: 'none'
    },
    ORIGINAL_ACTIVITY_END_DATE: {
        property_id: 0,
        type: 'date',
        choice_type: 'none'
    },
    ORIGINAL_ACTIVITY_ASSIGNEE_USER: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ORIGINAL_ACTIVITY_ASSIGNEE_ORGANIZATION: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_ID: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_DEFINITION_ID: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_STATUS: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_PROJECT: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_CREATE_DATE: {
        property_id: 0,
        type: 'date',
        choice_type: 'none'
    },
    ACTIVITY_START_DATE: {
        property_id: 0,
        type: 'date',
        choice_type: 'none'
    },
    ACTIVITY_END_DATE: {
        property_id: 0,
        type: 'date',
        choice_type: 'none'
    },
    ACTIVITY_CREATE_USER: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_CREATE_USER_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_CREATE_USER_FIRST_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_CREATE_USER_LAST_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_CREATE_USER_EMAIL: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_CREATE_ORGANIZATION: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_ASSIGNEE_USER: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_ASSIGNEE_USER_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_ASSIGNEE_USER_FIRST_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_ASSIGNEE_USER_LAST_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_ASSIGNEE_USER_EMAIL: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_ASSIGNEE_USER_PRIMARY_PHONE_NUMBER: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_ASSIGNEE_USER_TITLE: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_ASSIGNEE_ORGANIZATION: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_PRIMARY_PHONE_NUMBER: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_PRIMARY_EMAIL_ADDRESS: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_PRIMARY_PHYSICAL_CITY: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_PRIMARY_PHYSICAL_COUNTY: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_PRIMARY_PHYSICAL_STATE: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_PRIMARY_PHYSICAL_STREET_ADDRESS: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_PRIMARY_PHYSICAL_SUB_ADDRESS: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_PRIMARY_PHYSICAL_ZIP: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_PRIMARY_PHYSICAL_ZIP_EXT: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_CREATE_ORGANIZATION: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    ACTIVITY_IS_CLAIMED: {
        property_id: 0,
        type: 'bit',
        choice_type: 'none'
    },
    PERSON_LAST_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_FIRST_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_MIDDLE_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_FIRST_LAST_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_DOB: {
        property_id: 0,
        type: 'date',
        choice_type: 'none'
    },
    PERSON_SSN: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_SSN_AREA: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_SSN_GROUP: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_SSN_SERIAL: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_ID: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_VETERAN_ID: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_MEDICAID_ID: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_SCSEP_PARTICIPANT_ID: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_GENDER: {
        property_id: 0,
        type: 'int',
        choice_type: 'single',
        choices: (0, $3ce7c51d883dfdd6$export$9657669ee60b4be0).map(({ choice_id: choice_id, label: label })=>({
                choice_id: choice_id,
                score: 0,
                label: label,
                prompt: '',
                exclusive: false
            }))
    },
    PERSON_SEXUAL_ORIENTATION: {
        property_id: 0,
        type: 'int',
        choice_type: 'single',
        choices: (0, $3ce7c51d883dfdd6$export$41dc40aecf6ed9c3).map(({ choice_id: choice_id, label: label })=>({
                choice_id: choice_id,
                score: 0,
                label: label,
                prompt: '',
                exclusive: false
            }))
    },
    PERSON_RACE: {
        property_id: 0,
        type: 'int',
        choice_type: 'multiple',
        choices: (0, $3ce7c51d883dfdd6$export$4600759e6cedf2ab).map(({ choice_id: choice_id, label: label, exclusive: exclusive })=>({
                choice_id: choice_id,
                score: 0,
                label: label,
                prompt: '',
                exclusive: exclusive
            }))
    },
    PERSON_ETHNICITY: {
        property_id: 0,
        type: 'int',
        choice_type: 'single',
        choices: (0, $3ce7c51d883dfdd6$export$b43c9e3faf0aba5c).map(({ choice_id: choice_id, label: label })=>({
                choice_id: choice_id,
                score: 0,
                label: label,
                prompt: '',
                exclusive: false
            }))
    },
    PERSON_MARITAL_STATUS: {
        property_id: 0,
        type: 'int',
        choice_type: 'single',
        choices: (0, $3ce7c51d883dfdd6$export$160e4329619a95c1).map(({ choice_id: choice_id, label: label })=>({
                choice_id: choice_id,
                score: 0,
                label: label,
                prompt: '',
                exclusive: false
            }))
    },
    PERSON_PRIMARY_LANGUAGE: {
        property_id: 0,
        type: 'int',
        choice_type: 'single',
        choices: (0, $3ce7c51d883dfdd6$export$579409da2a52ea29).map(({ choice_id: choice_id, name: label })=>({
                choice_id: choice_id,
                score: 0,
                label: label,
                prompt: '',
                exclusive: false
            }))
    },
    PERSON_PRIMARY_PHONE_NUMBER: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_PRIMARY_PHONE_AREA: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_PRIMARY_PHONE_EXCHANGE: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_PRIMARY_PHONE_SUBSCRIBER: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_PRIMARY_EMAIL_ADDRESS: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_PRIMARY_RESIDENCE_STREET_ADDRESS: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_PRIMARY_RESIDENCE_SUB_ADDRESS: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_PRIMARY_RESIDENCE_CITY: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_PRIMARY_RESIDENCE_STATE: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_PRIMARY_RESIDENCE_ZIP: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_PRIMARY_RESIDENCE_ZIP_EXT: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    PERSON_PRIMARY_RESIDENCE_COUNTY: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    CURRENT_USER_LAST_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    CURRENT_USER_FIRST_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    CURRENT_USER_NAME: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    CURRENT_USER: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    CURRENT_USER_EMAIL: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    CURRENT_USER_ROLE: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    },
    CURRENT_ORGANIZATION: {
        property_id: 0,
        type: 'varchar100',
        choice_type: 'none'
    }
};
const $6941fa4b8204d0aa$export$7442465335b8f729 = $6941fa4b8204d0aa$var$_standardProperties;
const $6941fa4b8204d0aa$var$standardPropertiesById = {};
Object.keys($6941fa4b8204d0aa$export$7442465335b8f729).forEach((key, i)=>{
    const property_id = i * -1 - 1;
    $6941fa4b8204d0aa$export$7442465335b8f729[key].property_id = property_id;
    $6941fa4b8204d0aa$var$standardPropertiesById[property_id] = $6941fa4b8204d0aa$export$7442465335b8f729[key];
});
function $6941fa4b8204d0aa$var$parseExpressionDate(date) {
    if (!date) return new Date(NaN);
    switch(date.length){
        case 23:
            return new Date(date + 'Z');
        case 10:
            return new Date(date + 'T00:00:00.000Z');
        default:
            return new Date(date);
    }
}
function $6941fa4b8204d0aa$export$8997869c3c457b82(scopeData, activityId) {
    if (!activityId) return null;
    const activity = scopeData.activities[activityId];
    if (!activity) return null;
    const personId = activity.subject_person_id;
    return {
        activity: activity,
        person: personId ? scopeData.people[personId] ?? null : null,
        get responses () {
            return scopeData.responses[activityId] ??= {};
        },
        set responses (value){
            scopeData.responses[activityId] = value;
        },
        rucaLookup: personId ? scopeData.rucaLookup[personId] ?? [] : [],
        areaOfPersistentUnemploymentLookup: personId ? scopeData.areaOfPersistentUnemploymentLookup[personId] ?? [] : []
    };
}
function $6941fa4b8204d0aa$export$a8c07971d4517bfc(scopeData) {
    const scope = $6941fa4b8204d0aa$export$8997869c3c457b82(scopeData, scopeData.activityIds[0]);
    if (!scope) throw new Error('Unable to locate current activity expression scope.');
    return scope;
}
const $6941fa4b8204d0aa$var$emptyActivityExpressionScopeData = ()=>({
        activityIds: [],
        activities: {},
        people: {},
        responses: {},
        rucaLookup: {},
        areaOfPersistentUnemploymentLookup: {}
    });
class $6941fa4b8204d0aa$export$9d93b05ddd43b392 {
    currentUser;
    identifierValues;
    properties;
    scopeData;
    operation;
    canViewActivityTypes;
    selectedTemplates;
    hasVisiblePredecessors;
    scopeIndex;
    referencedActivityId;
    activityScopeCache;
    static forActivity({ currentUser: currentUser, properties: properties, scopeData: scopeData, operation: operation }) {
        return new $6941fa4b8204d0aa$export$9d93b05ddd43b392(currentUser, {}, properties, scopeData, operation, [], []);
    }
    static forPrepareDocuments({ currentUser: currentUser, properties: properties, scopeData: scopeData, selectedTemplates: selectedTemplates }) {
        return new $6941fa4b8204d0aa$export$9d93b05ddd43b392(currentUser, {}, properties, scopeData, 'view', [], selectedTemplates);
    }
    static forDashboard({ currentUser: currentUser, identifierValues: identifierValues, canViewActivityTypes: canViewActivityTypes }) {
        return new $6941fa4b8204d0aa$export$9d93b05ddd43b392(currentUser, identifierValues, {}, $6941fa4b8204d0aa$var$emptyActivityExpressionScopeData(), 'view', canViewActivityTypes, []);
    }
    constructor(currentUser, identifierValues, properties, scopeData, operation, canViewActivityTypes, selectedTemplates){
        this.currentUser = currentUser;
        this.identifierValues = identifierValues;
        this.properties = properties;
        this.scopeData = scopeData;
        this.operation = operation;
        this.canViewActivityTypes = canViewActivityTypes;
        this.selectedTemplates = selectedTemplates;
        this.hasVisiblePredecessors = false;
        this.scopeIndex = 0;
        this.referencedActivityId = null;
        this.activityScopeCache = new Map();
        this.contextualIdentifiers = {
            DAY: 0,
            MONTH: 1,
            YEAR: 2,
            QUARTER: 3,
            WEEK: 4,
            WEEKDAY: 5
        };
        this.functions = {
            SELECTED: (property_id, ...codes)=>{
                const response = this.getResponseValue(property_id);
                if (response === undefined || response === null) return false;
                if (typeof response !== 'number') throw new Error(`Expected numeric response. ${JSON.stringify(response)}`);
                const property = this.properties[property_id] ?? $6941fa4b8204d0aa$var$standardPropertiesById[property_id];
                if (!property) throw new Error(`Expression references ${property_id} but wasn't included in scope.`);
                if (property.choice_type === 'multiple') return (codes.reduce((m, shift)=>m + 2 ** shift, 0) & response) !== 0;
                else return codes.some((code)=>response === code);
            },
            SELECTED_CHOICE_ID: (property_id)=>{
                const response = this.getResponseValue(property_id);
                if (response === undefined || response === null) return null;
                if (typeof response !== 'number' || !Number.isInteger(response)) throw new Error(`Expected integer response. ${JSON.stringify(response)}`);
                const property = this.properties[property_id] ?? $6941fa4b8204d0aa$var$standardPropertiesById[property_id];
                if (!property) throw new Error(`Expression references ${property_id} but wasn't included in scope.`);
                if (property.choice_type !== 'single') throw new Error(`SELECTED_CHOICE_ID can only be used with single choice properties.`);
                return response;
            },
            VALUE: (property_id)=>{
                const response = this.getResponseValue(property_id);
                if (response === null || response === undefined) return null;
                if (typeof response !== 'number' || !Number.isInteger(response)) return response;
                const property = this.properties[property_id] ?? $6941fa4b8204d0aa$var$standardPropertiesById[property_id];
                if (!property) throw new Error(`Expression references ${property_id} but wasn't included in scope.`);
                if (property.choice_type === 'multiple') return property.choices?.filter((c)=>(2 ** c.choice_id & response) !== 0).reduce((sum, c)=>{
                    return sum ? `${sum}, ${c.label}` : c.label;
                }, null) ?? null;
                else if (property.choice_type === 'single') return property.choices?.find((c)=>c.choice_id === response)?.label ?? null;
                else return response;
            },
            ANSWERED: (property_id)=>{
                const response = this.getResponseValue(property_id);
                return response !== null && response !== undefined && response !== '';
            },
            SCORE: (property_id, ...choice_ids)=>{
                const response = this.getResponseValue(property_id);
                if (response === undefined || response === null) return NaN;
                if (typeof response !== 'number') throw new Error(`Expected numeric response. ${JSON.stringify(response)}`);
                const property = this.properties[property_id] ?? $6941fa4b8204d0aa$var$standardPropertiesById[property_id];
                if (!property) throw new Error(`Expression references ${property_id} but wasn't included in scope.`);
                if (property.choice_type === 'multiple') return property.choices?.filter((c)=>choice_ids.length === 0 || choice_ids.includes(c.choice_id)).filter((c)=>(2 ** c.choice_id & response) !== 0).reduce((sum, c)=>sum + c.score, 0) ?? NaN;
                else if (property.choice_type === 'single') return property.choices?.filter((c)=>choice_ids.length === 0 || choice_ids.includes(c.choice_id)).find((c)=>c.choice_id === response)?.score ?? NaN;
                else return response;
            },
            COUNTIF: (...args)=>{
                let count = 0;
                for (const arg of args)if (arg) count++;
                return count;
            },
            ANY: (...args)=>{
                return args.some((x)=>x);
            },
            ROUND: (value1, digits = 0)=>{
                if (typeof value1 !== 'number' || !Number.isFinite(value1)) return null;
                if (!Number.isInteger(digits) || digits < 0) return null;
                return (0, $5e22b13d8e41f6dd$export$a3992db8dd0fd9e6)(value1, digits);
            },
            FLOOR: (value1)=>{
                if (typeof value1 !== 'number' || !Number.isFinite(value1)) return null;
                return Math.floor(value1);
            },
            CEILING: (value1)=>{
                if (typeof value1 !== 'number' || !Number.isFinite(value1)) return null;
                return Math.ceil(value1);
            },
            MIN: (v1, v2)=>{
                if (typeof v1 !== 'number' || !Number.isFinite(v1) || typeof v2 !== 'number' || !Number.isFinite(v2)) return null;
                return Math.min(v1, v2);
            },
            MAX: (v1, v2)=>{
                if (typeof v1 !== 'number' || !Number.isFinite(v1) || typeof v2 !== 'number' || !Number.isFinite(v2)) return null;
                return Math.max(v1, v2);
            },
            ABS: (value1)=>{
                if (typeof value1 !== 'number' || !Number.isFinite(value1)) return null;
                return Math.abs(value1);
            },
            SIGN: (value1)=>{
                if (typeof value1 !== 'number' || !Number.isFinite(value1)) return null;
                return value1 > 0 ? 1 : value1 < 0 ? -1 : 0;
            },
            NOW: ()=>new Date(new Date().toLocaleString('en-US', {
                    timeZone: 'America/New_York'
                })).toISOString(),
            AGE: (dob, asOf)=>{
                const parsedDob = $6941fa4b8204d0aa$var$parseExpressionDate(dob);
                const parsedAsOf = $6941fa4b8204d0aa$var$parseExpressionDate(asOf);
                if (!isFinite(parsedDob.getTime()) || !isFinite(parsedAsOf.getTime())) return null;
                return (0, $b78c044e3d911d2e$export$b0932c69ff376ad3)(parsedDob, parsedAsOf).years;
            },
            DATEADD: (part, value1, date)=>{
                const parsed = $6941fa4b8204d0aa$var$parseExpressionDate(date);
                const { DAY: DAY, MONTH: MONTH, QUARTER: QUARTER, YEAR: YEAR, WEEK: WEEK } = this.contextualIdentifiers;
                if (![
                    DAY,
                    MONTH,
                    QUARTER,
                    YEAR,
                    WEEK
                ].includes(part) || typeof value1 !== 'number' || !Number.isInteger(value1) || !isFinite(parsed.getTime())) return null;
                // https://www.npmjs.com/package/dateadd?activeTab=code
                switch(part){
                    case DAY:
                    case WEEK:
                        if (part === WEEK) value1 *= 7;
                        return new Date(parsed.setUTCDate(parsed.getUTCDate() + value1)).toISOString();
                    case MONTH:
                    case QUARTER:
                    case YEAR:
                        if (part === QUARTER) value1 *= 3;
                        else if (part === YEAR) value1 *= 12;
                        return (0, $b78c044e3d911d2e$export$770039c4b251b19)(parsed, value1)?.toISOString() ?? null;
                    default:
                        throw new Error(`Unexpected date part: ${part}`);
                }
            },
            DATEDIFF: (part, start, end)=>{
                const parsedStart = $6941fa4b8204d0aa$var$parseExpressionDate(start);
                const parsedEnd = $6941fa4b8204d0aa$var$parseExpressionDate(end);
                const { DAY: DAY, MONTH: MONTH, QUARTER: QUARTER, YEAR: YEAR, WEEK: WEEK } = this.contextualIdentifiers;
                if (![
                    DAY,
                    MONTH,
                    QUARTER,
                    YEAR,
                    WEEK
                ].includes(part) || !isFinite(parsedStart.getTime()) || !isFinite(parsedEnd.getTime())) return null;
                switch(part){
                    case DAY:
                        return (0, $b78c044e3d911d2e$export$af7c4989823a7ea4)(parsedStart, parsedEnd);
                    case WEEK:
                        {
                            const weeks = Math.floor((parsedEnd.getTime() - parsedStart.getTime()) / 604800000);
                            return weeks + (parsedStart.getUTCDay() > parsedEnd.getUTCDay() ? 1 : 0);
                        }
                    case MONTH:
                    case QUARTER:
                        {
                            let result = (parsedEnd.getUTCFullYear() - parsedStart.getUTCFullYear()) * 12 + parsedEnd.getUTCMonth() - parsedStart.getUTCMonth();
                            if (part === QUARTER) result = Math.floor(result / 3);
                            return result;
                        }
                    case YEAR:
                        return parsedEnd.getUTCFullYear() - parsedStart.getUTCFullYear();
                    default:
                        throw new Error(`Unexpected date part: ${part}`);
                }
            },
            DATEPART: (part, date)=>{
                const parsed = $6941fa4b8204d0aa$var$parseExpressionDate(date);
                const { DAY: DAY, MONTH: MONTH, QUARTER: QUARTER, YEAR: YEAR, WEEK: WEEK, WEEKDAY: WEEKDAY } = this.contextualIdentifiers;
                if (![
                    DAY,
                    MONTH,
                    QUARTER,
                    YEAR,
                    WEEK,
                    WEEKDAY
                ].includes(part) || !isFinite(parsed.getTime())) return null;
                switch(part){
                    case DAY:
                        return parsed.getUTCDate();
                    case WEEK:
                        {
                            const jan1 = new Date(Date.UTC(parsed.getUTCFullYear()));
                            const dayOfYear = (parsed.getTime() - jan1.getTime()) / 86400000;
                            return Math.floor(dayOfYear / 7) + 1 + (jan1.getUTCDay() > parsed.getUTCDay() ? 1 : 0);
                        }
                    case MONTH:
                        return parsed.getUTCMonth() + 1;
                    case QUARTER:
                        return Math.floor(parsed.getUTCMonth() / 3) + 1;
                    case YEAR:
                        return parsed.getUTCFullYear();
                    case WEEKDAY:
                        return parsed.getUTCDay() + 1;
                    default:
                        throw new Error(`Unexpected date part: ${part}`);
                }
            },
            DATETRUNC: (part, date)=>{
                const parsed = $6941fa4b8204d0aa$var$parseExpressionDate(date);
                const { DAY: DAY, MONTH: MONTH, QUARTER: QUARTER, YEAR: YEAR, WEEK: WEEK } = this.contextualIdentifiers;
                if (![
                    DAY,
                    MONTH,
                    QUARTER,
                    YEAR,
                    WEEK
                ].includes(part) || !isFinite(parsed.getTime())) return null;
                switch(part){
                    case DAY:
                        return new Date(Date.UTC(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate())).toISOString();
                    case WEEK:
                        return new Date(Date.UTC(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate() - parsed.getUTCDay())).toISOString();
                    case MONTH:
                        return new Date(Date.UTC(parsed.getUTCFullYear(), parsed.getUTCMonth(), 1)).toISOString();
                    case QUARTER:
                        return new Date(Date.UTC(parsed.getUTCFullYear(), Math.floor(parsed.getUTCMonth() / 3) * 3, 1)).toISOString();
                    case YEAR:
                        return new Date(Date.UTC(parsed.getUTCFullYear(), 0, 1)).toISOString();
                    default:
                        throw new Error(`Unexpected date part: ${part}`);
                }
            },
            EOMONTH: (date)=>{
                const parsed = $6941fa4b8204d0aa$var$parseExpressionDate(date);
                if (!isFinite(parsed.getTime())) return null;
                const endOfMonth = new Date(Date.UTC(parsed.getUTCFullYear(), parsed.getUTCMonth() + 1, 0));
                return endOfMonth.toISOString();
            },
            DATE: (value1)=>{
                const parsed = $6941fa4b8204d0aa$var$parseExpressionDate(value1);
                if (!isFinite(parsed.getTime())) return null;
                return parsed.toISOString();
            },
            IF: (condition, trueValue, falseValue)=>{
                return condition ? trueValue : falseValue;
            },
            LOWER: (s)=>{
                return s?.toLowerCase() ?? null;
            },
            UPPER: (s)=>{
                return s?.toUpperCase() ?? null;
            },
            RURAL: (date)=>{
                const scope = this.getActivityScope();
                if (!scope) return null;
                const { rucaLookup: rucaLookup } = scope;
                const parsed = $6941fa4b8204d0aa$var$parseExpressionDate(date);
                if (!isFinite(parsed.getTime())) return null;
                return (rucaLookup.find((x)=>$6941fa4b8204d0aa$var$parseExpressionDate(x.start_date).getTime() <= parsed.getTime())?.primary_code ?? 0) >= 4;
            },
            AREA_OF_PERSISTENT_UNEMPLOYMENT: (date)=>{
                const scope = this.getActivityScope();
                if (!scope) return null;
                const { areaOfPersistentUnemploymentLookup: areaOfPersistentUnemploymentLookup } = scope;
                const parsed = $6941fa4b8204d0aa$var$parseExpressionDate(date);
                if (!isFinite(parsed.getTime())) return null;
                return areaOfPersistentUnemploymentLookup.find((x)=>$6941fa4b8204d0aa$var$parseExpressionDate(x.start_date).getTime() <= parsed.getTime())?.persistent_unemployment ?? false;
            },
            HAS_VISIBLE_PREDECESSORS: ()=>{
                // console.log(`HAS_VISIBLE_PREDECESSORS: ${this.hasVisiblePredecessors}`);
                return this.hasVisiblePredecessors;
            },
            DEBUG: (label, value1)=>{
                console.log(`EXPRESSION DEBUG ${label}: ${value1}`);
                return value1;
            },
            CAN_VIEW_ACTIVITY_TYPE: (type)=>{
                return this.canViewActivityTypes?.includes(type) ?? null;
            },
            MID (value1, start, length) {
                if (typeof value1 !== 'string') return null;
                if (typeof start !== 'number' || !isFinite(start)) return null;
                if (length !== undefined && (typeof length !== 'number' || !isFinite(length))) return null;
                if (length !== undefined && length <= 0) return '';
                start = start < 1 ? 1 : start;
                return value1.substr(start - 1, length);
            },
            LEFT (value1, length) {
                if (typeof value1 !== 'string') return null;
                if (typeof length !== 'number' || !isFinite(length)) return null;
                if (length <= 0) return '';
                return value1.substr(0, length);
            },
            RIGHT (value1, length) {
                if (typeof value1 !== 'string') return null;
                if (typeof length !== 'number' || !isFinite(length)) return null;
                if (length <= 0) return '';
                return value1.slice(-1 * length);
            },
            MATCH (value1, ...args) {
                if (value1 === null || value1 === undefined || typeof value1 !== 'string' && typeof value1 !== 'number' || typeof value1 === 'number' && !isFinite(value1)) return null;
                return args.includes(value1);
            },
            SWITCH (value1, ...args) {
                if (value1 === null || value1 === undefined) return null;
                for(let i = 0; i < args.length; i += 2){
                    if (args[i] === value1) return args[i + 1];
                }
                return args.length % 2 === 0 ? null : args[args.length - 1];
            },
            IFS (...args) {
                const hasElse = args.length % 2 !== 0;
                const pairLength = hasElse ? args.length - 1 : args.length;
                for(let i = 0; i < pairLength; i += 2){
                    if (args[i]) return args[i + 1];
                }
                return hasElse ? args[args.length - 1] : null;
            },
            TEXT (value1) {
                if (value1 === null || value1 === undefined) return null;
                return String(value1);
            },
            FORMAT_DATE (date, format) {
                const parsed = $6941fa4b8204d0aa$var$parseExpressionDate(date);
                if (!isFinite(parsed.getTime())) return null;
                // not handling time zones!!!
                switch(format){
                    case 'yyyy-MM-dd':
                        return new Date(parsed).toISOString().substr(0, 10);
                    case 'M/d/yyyy':
                        return (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format(new Date(parsed));
                    default:
                        return null;
                }
            },
            URL_ENCODE (value1) {
                if (typeof value1 !== 'string') return null;
                return encodeURIComponent(value1);
            },
            URL_PARAMS (...values) {
                const p = new URLSearchParams();
                let k, v;
                for(let i = 0; i < values.length; i += 2){
                    k = values[i];
                    v = values[i + 1];
                    if (typeof k === 'string' && k.length > 0 && typeof v === 'string' && v.length > 0) p.append(k, v);
                }
                return p.toString();
            },
            UUID_TO_BASE58 (value1) {
                if (typeof value1 !== 'string') return null;
                if (!(0, $629fab7fb0c19ec3$export$a22775fa5e2eebd9)(value1, {
                    type: 'string',
                    format: 'uuid'
                }).valid) return null;
                return (0, $52ec208b1be5af58$export$7077a352e654daea)(value1);
            },
            COALESCE (value1, value2) {
                return value1 ?? value2 ?? null;
            },
            SIGNATURE (_value) {
                return null;
            },
            SIGNATURE_DATE (_value) {
                return null;
            },
            SELECTED_TEMPLATES: (separator)=>{
                if (typeof separator !== 'string') return null;
                return this.selectedTemplates.join(separator);
            }
        };
    }
    get currentActivityId() {
        return this.referencedActivityId ?? this.scopeData.activityIds[this.scopeIndex];
    }
    getActivityScope(activityId = this.currentActivityId) {
        if (!activityId) return null;
        let scope = this.activityScopeCache.get(activityId);
        if (!scope) {
            scope = $6941fa4b8204d0aa$export$8997869c3c457b82(this.scopeData, activityId) ?? undefined;
            if (scope) this.activityScopeCache.set(activityId, scope);
        }
        return scope ?? null;
    }
    getResponseValue(property_id) {
        switch(property_id){
            case $6941fa4b8204d0aa$export$7442465335b8f729.OPERATION.property_id:
                return this.operation;
            case $6941fa4b8204d0aa$export$7442465335b8f729.CURRENT_USER_NAME.property_id:
                return `${this.currentUser.given_name} ${this.currentUser.family_name}`.trim();
            case $6941fa4b8204d0aa$export$7442465335b8f729.CURRENT_USER_LAST_NAME.property_id:
                return this.currentUser.family_name;
            case $6941fa4b8204d0aa$export$7442465335b8f729.CURRENT_USER_FIRST_NAME.property_id:
                return this.currentUser.given_name;
            case $6941fa4b8204d0aa$export$7442465335b8f729.CURRENT_USER.property_id:
                return this.currentUser.user_login;
            case $6941fa4b8204d0aa$export$7442465335b8f729.CURRENT_USER_EMAIL.property_id:
                return this.currentUser.email;
            case $6941fa4b8204d0aa$export$7442465335b8f729.CURRENT_USER_ROLE.property_id:
                return this.currentUser.role;
            case $6941fa4b8204d0aa$export$7442465335b8f729.CURRENT_ORGANIZATION.property_id:
                return this.currentUser.organization_login;
        }
        const scope = this.getActivityScope();
        if (!scope) return null;
        const { activity: activity, person: person, responses: responses } = scope;
        if (property_id >= 0) return responses[`p${property_id}`];
        switch(property_id){
            case $6941fa4b8204d0aa$export$7442465335b8f729.ORIGINAL_ACTIVITY_STATUS.property_id:
                return activity.original_status;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ORIGINAL_ACTIVITY_START_DATE.property_id:
                return activity.original_start_date;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ORIGINAL_ACTIVITY_END_DATE.property_id:
                return activity.original_end_date;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ORIGINAL_ACTIVITY_ASSIGNEE_USER.property_id:
                return activity.original_assignee_user;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ORIGINAL_ACTIVITY_ASSIGNEE_ORGANIZATION.property_id:
                return activity.original_assignee_organization;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_ID.property_id:
                return activity.activity_id;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_DEFINITION_ID.property_id:
                return activity.activity_definition_id;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_STATUS.property_id:
                return activity.status;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_IS_CLAIMED.property_id:
                return activity.is_claimed;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_PROJECT.property_id:
                return activity.project_login;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_CREATE_DATE.property_id:
                return activity.create_date;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_START_DATE.property_id:
                return activity.start_date;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_END_DATE.property_id:
                return activity.end_date;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_CREATE_USER.property_id:
                return activity.create_user;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_CREATE_USER_NAME.property_id:
                return `${activity.create_user_first_name} ${activity.create_user_last_name}`.trim();
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_CREATE_USER_FIRST_NAME.property_id:
                return activity.create_user_first_name;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_CREATE_USER_LAST_NAME.property_id:
                return activity.create_user_last_name;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_CREATE_USER_EMAIL.property_id:
                return activity.create_user_email;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_CREATE_ORGANIZATION.property_id:
                return activity.create_organization;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_ASSIGNEE_USER.property_id:
                return activity.assignee_user;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_ASSIGNEE_USER_NAME.property_id:
                return activity.assignee_user_last_name ? `${activity.assignee_user_first_name} ${activity.assignee_user_last_name}`.trim() : null;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_ASSIGNEE_USER_FIRST_NAME.property_id:
                return activity.assignee_user_first_name;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_ASSIGNEE_USER_LAST_NAME.property_id:
                return activity.assignee_user_last_name;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_ASSIGNEE_USER_EMAIL.property_id:
                return activity.assignee_user_email;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_ASSIGNEE_USER_PRIMARY_PHONE_NUMBER.property_id:
                return activity.assignee_user_primary_phone_number;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_ASSIGNEE_USER_TITLE.property_id:
                return activity.assignee_user_title;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_ASSIGNEE_ORGANIZATION.property_id:
                return activity.assignee_organization;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_PRIMARY_PHONE_NUMBER.property_id:
                return activity.primary_phone_number;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_PRIMARY_EMAIL_ADDRESS.property_id:
                return activity.primary_email_address;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_PRIMARY_PHYSICAL_STREET_ADDRESS.property_id:
                return activity.primary_physical_street_address;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_PRIMARY_PHYSICAL_SUB_ADDRESS.property_id:
                return activity.primary_physical_sub_address;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_PRIMARY_PHYSICAL_CITY.property_id:
                return activity.primary_physical_city;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_PRIMARY_PHYSICAL_STATE.property_id:
                return activity.primary_physical_state;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_PRIMARY_PHYSICAL_ZIP.property_id:
                return activity.primary_physical_zip;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_PRIMARY_PHYSICAL_ZIP_EXT.property_id:
                return activity.primary_physical_zip_ext;
            case $6941fa4b8204d0aa$export$7442465335b8f729.ACTIVITY_PRIMARY_PHYSICAL_COUNTY.property_id:
                return activity.primary_physical_subregion;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_CREATE_ORGANIZATION.property_id:
                return person?.create_organization;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_NAME.property_id:
                return person ? (0, $15a966c9a3403e81$export$caef59cbf5b7a7d4)(person) : null;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_FIRST_LAST_NAME.property_id:
                return `${person?.first_name ?? ''} ${person?.last_name ?? ''}`.trim() || null;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_LAST_NAME.property_id:
                return person?.last_name;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_FIRST_NAME.property_id:
                return person?.first_name;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_MIDDLE_NAME.property_id:
                return person?.middle_name;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_DOB.property_id:
                return person?.dob;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_SSN.property_id:
                return person?.ssn;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_SSN_AREA.property_id:
                return person?.ssn?.substr(0, 3);
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_SSN_GROUP.property_id:
                return person?.ssn?.substr('xxx-'.length, 2);
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_SSN_SERIAL.property_id:
                return person?.ssn?.substr('xxx-xx-'.length, 4);
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_ID.property_id:
                return person?.person_id;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_VETERAN_ID.property_id:
                return person?.veteran_id;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_MEDICAID_ID.property_id:
                return person?.medicaid_id;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_SCSEP_PARTICIPANT_ID.property_id:
                return person?.scsep_participant_id;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_GENDER.property_id:
                return person?.gender;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_SEXUAL_ORIENTATION.property_id:
                return person?.sexual_orientation;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_RACE.property_id:
                return person?.race;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_ETHNICITY.property_id:
                return person?.ethnicity;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_MARITAL_STATUS.property_id:
                return person?.marital_status;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_PRIMARY_LANGUAGE.property_id:
                return person?.primary_language;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_PRIMARY_PHONE_NUMBER.property_id:
                return person?.primary_phone_number;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_PRIMARY_PHONE_AREA.property_id:
                return person?.primary_phone_number?.substr('('.length, 3);
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_PRIMARY_PHONE_EXCHANGE.property_id:
                return person?.primary_phone_number?.substr('(xxx) '.length, 3);
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_PRIMARY_PHONE_SUBSCRIBER.property_id:
                return person?.primary_phone_number?.substr('(xxx) xxx-'.length, 4);
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_PRIMARY_EMAIL_ADDRESS.property_id:
                return person?.primary_email_address;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_STREET_ADDRESS.property_id:
                return person?.primary_residence_street_address;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_SUB_ADDRESS.property_id:
                return person?.primary_residence_sub_address;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_CITY.property_id:
                return person?.primary_residence_city;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_STATE.property_id:
                return person?.primary_residence_region_abbr;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_ZIP.property_id:
                return person?.primary_residence_postal_code;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_ZIP_EXT.property_id:
                return person?.primary_residence_postal_code_ext;
            case $6941fa4b8204d0aa$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_COUNTY.property_id:
                return person?.primary_residence_subregion;
            default:
                return undefined;
        }
    }
    contextualIdentifiers;
    functions;
    resolveFunction(name) {
        if (Object.hasOwn(this.functions, name)) return this.functions[name];
        return undefined;
    }
    resolveIdentifier(name) {
        if (Object.hasOwn($6941fa4b8204d0aa$export$7442465335b8f729, name)) return $6941fa4b8204d0aa$export$7442465335b8f729[name].property_id;
        if (Object.hasOwn(this.contextualIdentifiers, name)) return this.contextualIdentifiers[name];
        if (Object.hasOwn(this.identifierValues, name)) return this.identifierValues[name];
        return null;
    }
    ascendScope(levels) {
        const original = this.scopeIndex;
        this.scopeIndex += levels;
        return ()=>{
            this.scopeIndex = original;
        };
    }
    enterReferencedScope(propertyId) {
        const response = this.getResponseValue(propertyId);
        if (typeof response !== 'string') return null;
        const referencedActivityId = response.toLowerCase();
        if (!this.getActivityScope(referencedActivityId)) return null;
        const original = this.referencedActivityId;
        this.referencedActivityId = referencedActivityId;
        return ()=>{
            this.referencedActivityId = original;
        };
    }
}
function $6941fa4b8204d0aa$export$61b73397e464436e(propertyType, { type: type, ast: ast }, context) {
    const result = $6941fa4b8204d0aa$export$3191fa0ae67b450c(ast, context);
    if (result === null) return null;
    switch(type){
        case 'boolean':
            // int used because there's no boolean/bit response table.
            return Boolean(result) ? 1 : 0;
        case 'int':
            {
                const value1 = Math.floor(Number(result));
                if (!isFinite(value1)) return null;
                return value1;
            }
        // @ts-expect-error
        case 'currency':
        case 'decimal':
            {
                const value1 = Number(result);
                if (!isFinite(value1)) return null;
                return propertyType === 'currency' ? (0, $5e22b13d8e41f6dd$export$a3992db8dd0fd9e6)(value1, 2) : value1;
            }
        case 'string':
            return String(result);
        case 'date':
        case 'datetime':
            {
                const value1 = $6941fa4b8204d0aa$var$parseExpressionDate(result);
                if (!isFinite(value1.getTime())) return null;
                return value1.toISOString();
            }
        default:
            throw new Error(`unsupported expression type "${type}"`);
    }
}
const $6941fa4b8204d0aa$var$binops = {
    '||': function(a, b) {
        return a || b;
    },
    '&&': function(a, b) {
        return a && b;
    },
    // '|': function (a, b) {
    //   return a | b;
    // },
    // '^': function (a, b) {
    //   return a ^ b;
    // },
    // '&': function (a, b) {
    //   return a & b;
    // },
    '==': function(a, b) {
        return a == b;
    },
    '!=': function(a, b) {
        return a != b;
    },
    // '===': function (a, b) {
    //   return a === b;
    // },
    // '!==': function (a, b) {
    //   return a !== b;
    // },
    '<': function(a, b) {
        return a < b;
    },
    '>': function(a, b) {
        return a > b;
    },
    '<=': function(a, b) {
        return a <= b;
    },
    '>=': function(a, b) {
        return a >= b;
    },
    // '<<': function (a, b) {
    //   return a << b;
    // },
    // '>>': function (a, b) {
    //   return a >> b;
    // },
    // '>>>': function (a, b) {
    //   return a >>> b;
    // },
    '+': function(a, b) {
        return a + b;
    },
    '-': function(a, b) {
        return a - b;
    },
    '*': function(a, b) {
        return a * b;
    },
    '/': function(a, b) {
        return a / b;
    },
    '%': function(a, b) {
        return a % b;
    }
};
const $6941fa4b8204d0aa$var$unops = {
    '-': function(a) {
        return -a;
    },
    // '+': function (a) {
    //   return +a;
    // },
    // '~': function (a) {
    //   return ~a;
    // },
    '!': function(a) {
        return !a;
    }
};
function $6941fa4b8204d0aa$export$3191fa0ae67b450c(node, context) {
    switch(node.type){
        // case 'ArrayExpression':
        //   return evaluateArray(node.elements, context);
        case 'BinaryExpression':
            {
                const left = $6941fa4b8204d0aa$export$3191fa0ae67b450c(node.left, context);
                if (node.operator === '||') return left || $6941fa4b8204d0aa$export$3191fa0ae67b450c(node.right, context);
                else if (node.operator === '&&') return left && $6941fa4b8204d0aa$export$3191fa0ae67b450c(node.right, context);
                if (typeof left === 'number' && !isFinite(left)) return null;
                const right = $6941fa4b8204d0aa$export$3191fa0ae67b450c(node.right, context);
                if (typeof right === 'number' && !isFinite(right)) return null;
                if ((left === null || right === null) && ![
                    '==',
                    '!='
                ].includes(node.operator)) // don't allow null coercion for non-equality operators.
                return null;
                {
                    // hack: ensure string comparisons of date strings use equal length strings. Need to use Date instances internally.
                    const dateString = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}\.\d+Z)?$/i;
                    if (typeof left === 'string' && typeof right === 'string' && left.length !== right.length && dateString.test(left) && dateString.test(right)) return $6941fa4b8204d0aa$var$binops[node.operator]((left + 'T00:00:00.000Z').substr(0, 24), (right + 'T00:00:00.000Z').substr(0, 24));
                }
                return $6941fa4b8204d0aa$var$binops[node.operator](left, right);
            }
        case 'CallExpression':
            {
                const callee = node.callee;
                if (callee.type !== 'Identifier') return undefined;
                const name = callee.name.toUpperCase();
                if (name === 'ANCESTOR') {
                    const levels = node.arguments[1]?.value ?? 1;
                    const restoreScope = context.ascendScope(levels);
                    try {
                        return $6941fa4b8204d0aa$export$3191fa0ae67b450c(node.arguments[0], context);
                    } finally{
                        restoreScope();
                    }
                }
                if (name === 'REFERENCED') {
                    const propertyId = $6941fa4b8204d0aa$export$3191fa0ae67b450c(node.arguments[0], context);
                    if (typeof propertyId !== 'number' || !Number.isInteger(propertyId)) return null;
                    const restoreScope = context.enterReferencedScope(propertyId);
                    if (!restoreScope) return null;
                    try {
                        return $6941fa4b8204d0aa$export$3191fa0ae67b450c(node.arguments[1], context);
                    } finally{
                        restoreScope();
                    }
                }
                const fn = context.resolveFunction(name);
                if (typeof fn !== 'function') return undefined;
                return fn.apply(null, node.arguments.map((node)=>$6941fa4b8204d0aa$export$3191fa0ae67b450c(node, context)));
            // // Coerce callee name to uppercase.
            // callee.name = callee.name.toUpperCase();
            // const fn = evaluateExpression(callee, scope);
            // if (typeof fn !== 'function') {
            //   return undefined;
            // }
            // return fn.apply(
            //   null,
            //   node.arguments.map(node =>
            //     evaluateExpression(node as CoreExpression, scope)
            //   )
            // );
            }
        // case 'ConditionalExpression':
        //   return legacyEvaluate(node.test as CoreExpression, context)
        //     ? legacyEvaluate(node.consequent as CoreExpression, context)
        //     : legacyEvaluate(node.alternate as CoreExpression, context);
        case 'Identifier':
            return context.resolveIdentifier(node.name.toUpperCase());
        case 'Literal':
            return node.value;
        // case 'MemberExpression':
        //   return evaluateMember(node, context)[1];
        // case 'ThisExpression':
        //   return context;
        case 'UnaryExpression':
            return $6941fa4b8204d0aa$var$unops[node.operator]($6941fa4b8204d0aa$export$3191fa0ae67b450c(node.argument, context));
        default:
            throw new Error(`Unexpected node type "${node.type}".`);
    }
}





const $fc2f5b0b15619892$export$3afeb5d84de67746 = 5000;
const $fc2f5b0b15619892$export$6f590997daae8459 = 1000;
const $fc2f5b0b15619892$export$c57951f25361d453 = 1460;
function $fc2f5b0b15619892$export$16e142ce02215086(text) {
    return `section-` + text.toLowerCase().replace(/[^a-z0-9]+/g, '-');
}
const $fc2f5b0b15619892$export$16b104bd64f9fad8 = [
    'individual-referral',
    'individual-task',
    'individual-questionnaire',
    'individual-episode',
    'individual-encounter',
    'individual-consent',
    'individual-relationship',
    'organization-agency',
    'organization-site',
    'organization-task',
    'organization-questionnaire',
    'organization-event',
    'organization-period'
];
const $fc2f5b0b15619892$var$individualActivityTypes = new Set($fc2f5b0b15619892$export$16b104bd64f9fad8.filter((x)=>x.startsWith('individual-')));
function $fc2f5b0b15619892$export$f635b8a078bb67e5(type) {
    return !!type && $fc2f5b0b15619892$var$individualActivityTypes.has(type);
}
const $fc2f5b0b15619892$var$contactInfoActivityTypes = new Set([
    'organization-event',
    'organization-agency',
    'organization-site'
]);
function $fc2f5b0b15619892$export$6d95ef8de79fb37d(type) {
    return $fc2f5b0b15619892$var$contactInfoActivityTypes.has(type);
}
const $fc2f5b0b15619892$var$userTitleRequiredActivityTypes = new Set([
    'organization-event',
    'organization-agency',
    'organization-site',
    'organization-period'
]);
function $fc2f5b0b15619892$export$de9f4a2aa2c3b8d9(type) {
    return $fc2f5b0b15619892$var$userTitleRequiredActivityTypes.has(type);
}
const $fc2f5b0b15619892$var$userTitleOptionalActivityTypes = new Set([
    'individual-referral',
    'individual-task',
    'organization-task'
]);
function $fc2f5b0b15619892$export$ab17fc41dd2656f0(type) {
    return $fc2f5b0b15619892$var$userTitleOptionalActivityTypes.has(type);
}
function $fc2f5b0b15619892$export$a22d308f9efaa123({ type: type, flags: flags }) {
    return $fc2f5b0b15619892$export$de9f4a2aa2c3b8d9(type) || (flags & 2048) > 0;
}
const $fc2f5b0b15619892$var$endDateAlwaysRequiredActivityTypes = new Set([
    'organization-event',
    'individual-consent',
    'organization-period'
]);
function $fc2f5b0b15619892$export$93b7907fd45b5aca(type) {
    return !!type && $fc2f5b0b15619892$var$endDateAlwaysRequiredActivityTypes.has(type);
}
function $fc2f5b0b15619892$export$a94a7861f82ee3e6(type, status) {
    return status === 'completed' || status === 'cancelled' || $fc2f5b0b15619892$export$93b7907fd45b5aca(type);
}
const $fc2f5b0b15619892$var$dueDateActivityTypes = new Set([
    'individual-referral',
    'individual-task',
    'individual-questionnaire',
    'organization-task',
    'organization-questionnaire'
]);
function $fc2f5b0b15619892$export$431862b62533b4ed(type) {
    return !!type && $fc2f5b0b15619892$var$dueDateActivityTypes.has(type);
}
function $fc2f5b0b15619892$export$9af179e9fa96c860(type) {
    return type.startsWith('organization-');
}
function $fc2f5b0b15619892$export$ef4c97c204fe0aad(type) {
    return $fc2f5b0b15619892$export$9af179e9fa96c860(type) || type !== 'individual-episode' && type !== 'individual-relationship';
}
function $fc2f5b0b15619892$export$c32c251f479d6ab4(type) {
    return type === 'individual-questionnaire' || type === 'individual-task' || type === 'individual-episode' || type === 'individual-referral';
}
function $fc2f5b0b15619892$export$400fb7d64a2f4fed(type) {
    switch(type){
        case 'individual-questionnaire':
            return 'QuestionnaireResponse';
        case 'individual-referral':
            return 'ServiceRequest';
        case 'individual-task':
            return 'Task';
        case 'organization-event':
            return 'Task';
        case 'organization-agency':
            return 'Organization';
        case 'organization-questionnaire':
            return 'QuestionnaireResponse';
        case 'organization-task':
            return 'Task';
        default:
            throw new Error(`Unexpected activity type: ${type}`);
    }
}
function $fc2f5b0b15619892$export$eeeefc19bf3b1d71(locale, type) {
    switch(type){
        case 'individual-consent':
            return (0, $b11db1b62d4a8f76$export$7c1b73b3fc2f0159)[locale];
        case 'individual-encounter':
            return (0, $b11db1b62d4a8f76$export$1f61287e5d30e3cf)[locale];
        case 'individual-episode':
            return (0, $b11db1b62d4a8f76$export$9ea0062ee8a62693)[locale];
        case 'individual-questionnaire':
            return (0, $b11db1b62d4a8f76$export$375f6e4643646315)[locale];
        case 'individual-referral':
            return (0, $b11db1b62d4a8f76$export$ff6a452cc674d674)[locale];
        case 'individual-task':
            return (0, $b11db1b62d4a8f76$export$e31ed6ed548e255b)[locale];
        case 'individual-relationship':
            return (0, $b11db1b62d4a8f76$export$f04072ad92ec82d0)[locale];
        case 'organization-agency':
            return (0, $b11db1b62d4a8f76$export$8d7a72727b917368)[locale];
        case 'organization-site':
            return (0, $b11db1b62d4a8f76$export$3a9d0270e8a39565)[locale];
        case 'organization-event':
            return (0, $b11db1b62d4a8f76$export$d23e7a1502780659)[locale];
        case 'organization-period':
            return (0, $b11db1b62d4a8f76$export$94c8daae5f9ab256)[locale];
        case 'organization-questionnaire':
            return (0, $b11db1b62d4a8f76$export$fc6d25d72e8dca9c)[locale];
        case 'organization-task':
            return (0, $b11db1b62d4a8f76$export$a38a7850cefdb2b2)[locale];
        default:
            throw new Error(`Unexpected type "${type}".`);
    }
}
function $fc2f5b0b15619892$export$ceffb4d349db604e(locale, type) {
    switch(type){
        case 'individual-consent':
            return (0, $b11db1b62d4a8f76$export$1aab9202c7b650e6)[locale];
        case 'individual-encounter':
            return (0, $b11db1b62d4a8f76$export$aac1b84c33b9a082)[locale];
        case 'individual-episode':
            return (0, $b11db1b62d4a8f76$export$b1642650037543f)[locale];
        case 'individual-questionnaire':
            return (0, $b11db1b62d4a8f76$export$a9202f9fc8a3c137)[locale];
        case 'individual-referral':
            return (0, $b11db1b62d4a8f76$export$90f6380a62d43dd9)[locale];
        case 'individual-task':
            return (0, $b11db1b62d4a8f76$export$dad853a619f75d14)[locale];
        case 'individual-relationship':
            return (0, $b11db1b62d4a8f76$export$cc63ffe88c29fbfb)[locale];
        case 'organization-agency':
            return (0, $b11db1b62d4a8f76$export$c679b7129661e5e0)[locale];
        case 'organization-site':
            return (0, $b11db1b62d4a8f76$export$8a207254b784b0a6)[locale];
        case 'organization-event':
            return (0, $b11db1b62d4a8f76$export$fd5fa5d7e2f6be5d)[locale];
        case 'organization-period':
            return (0, $b11db1b62d4a8f76$export$6d10fa154c9a0e20)[locale];
        case 'organization-questionnaire':
            return (0, $b11db1b62d4a8f76$export$d010d50b14e45bda)[locale];
        case 'organization-task':
            return (0, $b11db1b62d4a8f76$export$f20156ec63e0a45d)[locale];
        default:
            throw new Error(`Unexpected type "${type}".`);
    }
}
var $fc2f5b0b15619892$export$91d5aadb43f971b9 = /*#__PURE__*/ function(ActivityDefinitionFlags) {
    ActivityDefinitionFlags[ActivityDefinitionFlags["Root"] = 1] = "Root";
    ActivityDefinitionFlags[ActivityDefinitionFlags["Discretionary"] = 2] = "Discretionary";
    ActivityDefinitionFlags[ActivityDefinitionFlags["PermitAnonymous"] = 4] = "PermitAnonymous";
    ActivityDefinitionFlags[ActivityDefinitionFlags["Public"] = 8] = "Public";
    ActivityDefinitionFlags[ActivityDefinitionFlags["Copies"] = 16] = "Copies";
    ActivityDefinitionFlags[ActivityDefinitionFlags["OrganizationSpecific"] = 32] = "OrganizationSpecific";
    ActivityDefinitionFlags[ActivityDefinitionFlags["HasAddresses"] = 64] = "HasAddresses";
    ActivityDefinitionFlags[ActivityDefinitionFlags["HasPhones"] = 128] = "HasPhones";
    ActivityDefinitionFlags[ActivityDefinitionFlags["HasEmails"] = 256] = "HasEmails";
    ActivityDefinitionFlags[ActivityDefinitionFlags["HasContacts"] = 512] = "HasContacts";
    ActivityDefinitionFlags[ActivityDefinitionFlags["HasDueDate"] = 1024] = "HasDueDate";
    ActivityDefinitionFlags[ActivityDefinitionFlags["HasTitle"] = 2048] = "HasTitle";
    ActivityDefinitionFlags[ActivityDefinitionFlags["AllowOverlap"] = 4096] = "AllowOverlap";
    return ActivityDefinitionFlags;
}({});
function $fc2f5b0b15619892$export$b7ad88df7d5fa33a(status) {
    switch(status){
        case 'draft':
            return 'draft';
        case 'ready':
        case 'in-progress':
            return 'active';
        case 'completed':
            return 'completed';
        case 'on-hold':
            return 'on-hold';
        case 'cancelled':
            return 'revoked';
        default:
            throw new Error(`Unexpected activity status: ${status}`);
    }
}
function $fc2f5b0b15619892$export$dbd89b202c05893d(status) {
    switch(status){
        // non-standard
        case 'draft':
        case 'ready':
        case 'on-hold':
        case 'cancelled':
            return [
                status
            ];
        // standard
        case 'entered-in-error':
            return [
                'cancelled'
            ];
        case 'in-progress':
            return [
                'draft',
                'ready',
                'in-progress'
            ];
        case 'stopped':
            return [
                'on-hold'
            ];
        case 'completed':
            return [
                'completed'
            ];
        default:
            return [];
    }
}
function $fc2f5b0b15619892$export$6ba6a38b66086ebc(status) {
    switch(status){
        // non-standard
        case 'ready':
        case 'in-progress':
        case 'cancelled':
            return [
                status
            ];
        // standard
        case 'draft':
            return [
                'draft'
            ];
        case 'active':
            return [
                'in-progress',
                'ready'
            ];
        case 'completed':
            return [
                'completed'
            ];
        case 'on-hold':
            return [
                'on-hold'
            ];
        case 'revoked':
            return [
                'cancelled'
            ];
        default:
            return [];
    }
}
function $fc2f5b0b15619892$export$84050dc6d268062c(status) {
    switch(status){
        case 'draft':
            return [
                'draft'
            ];
        case 'ready':
            return [
                'ready'
            ];
        case 'cancelled':
            return [
                'cancelled'
            ];
        case 'in-progress':
            return [
                'in-progress'
            ];
        case 'on-hold':
            return [
                'on-hold'
            ];
        case 'completed':
            return [
                'completed'
            ];
        default:
            return [];
    }
}
function $fc2f5b0b15619892$export$7ee376c5137809a2(status) {
    switch(status){
        // non-standard
        case 'draft':
        case 'ready':
            return [
                status
            ];
        // standard
        case 'planned':
            return [
                'draft'
            ];
        case 'in-progress':
            return [
                'in-progress'
            ];
        case 'cancelled':
        case 'discontinued':
        case 'entered-in-error':
            return [
                'cancelled'
            ];
        case 'active':
            return [
                'in-progress'
            ];
        case 'on-hold':
            return [
                'on-hold'
            ];
        case 'discharged':
        case 'completed':
            return [
                'completed'
            ];
        default:
            return [];
    }
}
function $fc2f5b0b15619892$export$f0276a5d9f64ed8b(status) {
    switch(status){
        // non-standard
        case 'draft':
        case 'ready':
        case 'in-progress':
        case 'completed':
            return [
                status
            ];
        // standard
        case 'planned':
            return [
                'draft'
            ];
        case 'waitlist':
            return [
                'ready'
            ];
        case 'entered-in-error':
        case 'cancelled':
            return [
                'cancelled'
            ];
        case 'active':
            return [
                'in-progress'
            ];
        case 'on-hold':
            return [
                'on-hold'
            ];
        case 'finished':
            return [
                'completed'
            ];
        default:
            return [];
    }
}
const $fc2f5b0b15619892$export$6a8ec8f89e2ebfdf = {
    draft: 'muted',
    ready: 'open',
    'in-progress': 'open',
    completed: 'done',
    'on-hold': 'attention',
    cancelled: 'closed'
};
const $fc2f5b0b15619892$export$b59e5e84dadfd247 = {
    draft: 'State--draft',
    ready: 'State--open',
    'in-progress': 'State--open',
    completed: 'State--merged',
    'on-hold': 'color-bg-attention-emphasis color-fg-on-emphasis',
    cancelled: 'State--closed'
};
const $fc2f5b0b15619892$export$60edd6b2fdd9764b = {
    draft: (0, $84c634e688af79ca$export$206d84bec3b3a5a),
    ready: (0, $84c634e688af79ca$export$d2997daddac9b44),
    'in-progress': (0, $84c634e688af79ca$export$f3edcd159701e0e2),
    completed: (0, $84c634e688af79ca$export$4919767267a253b2),
    'on-hold': (0, $84c634e688af79ca$export$def956fbe4c089ce),
    cancelled: (0, $84c634e688af79ca$export$8a495e6856ec4c30)
};
const $fc2f5b0b15619892$export$3ea354565a224eba = {
    draft: 'ready',
    ready: 'in-progress',
    'in-progress': 'completed',
    completed: 'in-progress',
    cancelled: 'ready',
    'on-hold': 'in-progress'
};
const $fc2f5b0b15619892$export$d009ce1991333b4e = [
    {
        id: 'draft',
        title: (0, $b11db1b62d4a8f76$export$f3f08f4011de90bf),
        is_open: true,
        description: (0, $b11db1b62d4a8f76$export$dfc3117aefd0fe77)
    },
    // { id: 'requested', title: 'Requested',is_open: true, reasons: [] },
    // { id: 'received', title: 'Received',is_open: true, reasons: [] },
    // { id: 'accepted', title: 'Accepted',is_open: true, reasons: [] },
    // { id: 'rejected', title: 'Rejected',is_open: true, reasons: [] },
    {
        id: 'ready',
        title: (0, $b11db1b62d4a8f76$export$f8107b180cdf43b3),
        is_open: true,
        description: (0, $b11db1b62d4a8f76$export$fc65ca123a4d95d5)
    },
    {
        id: 'in-progress',
        title: (0, $b11db1b62d4a8f76$export$e3df7b8d35edbd9d),
        is_open: true,
        description: (0, $b11db1b62d4a8f76$export$878e78a909bcb42c)
    },
    {
        id: 'completed',
        title: (0, $b11db1b62d4a8f76$export$49b81392f6018765),
        is_open: false,
        description: (0, $b11db1b62d4a8f76$export$ecd960c60eeecfdb)
    },
    {
        id: 'cancelled',
        title: (0, $b11db1b62d4a8f76$export$c6aa1bfa918ebf18),
        is_open: false,
        description: (0, $b11db1b62d4a8f76$export$de87c35595e5d750)
    },
    {
        id: 'on-hold',
        title: (0, $b11db1b62d4a8f76$export$9f13a839d14cd3a4),
        is_open: true,
        description: (0, $b11db1b62d4a8f76$export$46d49c80898a4f02)
    }
];
const $fc2f5b0b15619892$export$cfa4e26f21007dcc = $fc2f5b0b15619892$export$d009ce1991333b4e.filter((x)=>x.is_open).map((x)=>x.id);
const $fc2f5b0b15619892$export$db8da96cb205ed52 = $fc2f5b0b15619892$export$d009ce1991333b4e.reduce((p, c)=>{
    p[c.id] = c.title;
    return p;
}, {});
const $fc2f5b0b15619892$export$3a24fd37b05a2ffe = [
    {
        sort: 'start-asc',
        label: (0, $b11db1b62d4a8f76$export$2eb5eac799b52763),
        ariaLabel: (0, $b11db1b62d4a8f76$export$765b926830e4f6a5)
    },
    {
        sort: 'start-desc',
        label: (0, $b11db1b62d4a8f76$export$2eb5eac799b52763),
        ariaLabel: (0, $b11db1b62d4a8f76$export$10c6e283027663f4)
    },
    {
        sort: 'end-asc',
        label: (0, $b11db1b62d4a8f76$export$e39a77fcdb881a0d),
        ariaLabel: (0, $b11db1b62d4a8f76$export$68ee5e97498a5881)
    },
    {
        sort: 'end-desc',
        label: (0, $b11db1b62d4a8f76$export$e39a77fcdb881a0d),
        ariaLabel: (0, $b11db1b62d4a8f76$export$86b7c879f7775f06)
    },
    {
        sort: 'created-asc',
        label: (0, $b11db1b62d4a8f76$export$3638f35b5780d612),
        ariaLabel: (0, $b11db1b62d4a8f76$export$86d05dcef079cc14)
    },
    {
        sort: 'created-desc',
        label: (0, $b11db1b62d4a8f76$export$3638f35b5780d612),
        ariaLabel: (0, $b11db1b62d4a8f76$export$6fd132dad37489aa)
    },
    {
        sort: 'updated-asc',
        label: (0, $b11db1b62d4a8f76$export$b7106b0b5f687fad),
        ariaLabel: (0, $b11db1b62d4a8f76$export$bda66586c2970932)
    },
    {
        sort: 'updated-desc',
        label: (0, $b11db1b62d4a8f76$export$b7106b0b5f687fad),
        ariaLabel: (0, $b11db1b62d4a8f76$export$7e0f74c500a6d00)
    },
    {
        sort: 'due-asc',
        label: (0, $b11db1b62d4a8f76$export$c8a4223ddf73b309),
        ariaLabel: (0, $b11db1b62d4a8f76$export$d0810dde2fad6b9a)
    },
    {
        sort: 'definition-asc',
        label: (0, $b11db1b62d4a8f76$export$7b385c33eaf64565),
        ariaLabel: (0, $b11db1b62d4a8f76$export$7b385c33eaf64565)
    }
];
const $fc2f5b0b15619892$export$53da8b8d5cf73999 = 'start-desc';
const $fc2f5b0b15619892$export$9165947634754ea5 = 30;
var $fc2f5b0b15619892$export$ab2f16cb08a3fd18 = /*#__PURE__*/ function(ActivityOrganizationAssociationType) {
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["Creator"] = 1] = "Creator";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["Assignee"] = 2] = "Assignee";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["Mentioned"] = 4] = "Mentioned";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["ProjectSupervisor"] = 8] = "ProjectSupervisor";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["OrganizationSupervisor"] = 16] = "OrganizationSupervisor";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["Automatic"] = 32] = "Automatic";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["Contract"] = 64] = "Contract";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["AssociatedActivity"] = 128] = "AssociatedActivity";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["Consent"] = 256] = "Consent";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["ReferencingActivity"] = 512] = "ReferencingActivity";
    return ActivityOrganizationAssociationType;
}({});
var $fc2f5b0b15619892$export$3f127d6e382cc218 = /*#__PURE__*/ function(ActivityParticipantType) {
    ActivityParticipantType[ActivityParticipantType["Creator"] = 1] = "Creator";
    ActivityParticipantType[ActivityParticipantType["Updator"] = 2] = "Updator";
    ActivityParticipantType[ActivityParticipantType["Assignee"] = 4] = "Assignee";
    ActivityParticipantType[ActivityParticipantType["Commentor"] = 8] = "Commentor";
    ActivityParticipantType[ActivityParticipantType["Mentioned"] = 16] = "Mentioned";
    ActivityParticipantType[ActivityParticipantType["TeamMentioned"] = 32] = "TeamMentioned";
    ActivityParticipantType[ActivityParticipantType["Manual"] = 64] = "Manual";
    ActivityParticipantType[ActivityParticipantType["Automatic"] = 128] = "Automatic";
    return ActivityParticipantType;
}({});
function $fc2f5b0b15619892$export$de80be383d29285f(locale, activityType, subscriber) {
    const subscribed = subscriber?.subscribed ?? false;
    const type = subscriber?.type ?? 0;
    const displayType = $fc2f5b0b15619892$export$eeeefc19bf3b1d71(locale, activityType).toLocaleLowerCase(locale);
    if (!subscriber) return (0, $b11db1b62d4a8f76$export$a07a7cb78e70dc7)[locale](displayType);
    else if (!subscribed) return (0, $b11db1b62d4a8f76$export$870104d5b672042c)[locale](displayType);
    else if (type & 64) return (0, $b11db1b62d4a8f76$export$a34bc0eefd7e0f6)[locale](displayType);
    else if (type & 1) return (0, $b11db1b62d4a8f76$export$d1d1e7344faf74a9)[locale](displayType);
    else if (type & 4) return (0, $b11db1b62d4a8f76$export$a9564ee2df9884f7)[locale](displayType);
    else if (type & 8) return (0, $b11db1b62d4a8f76$export$3f7a9c0c6b45d6d2)[locale](displayType);
    else if (type & 16) return (0, $b11db1b62d4a8f76$export$d5792a6242510aa5)[locale](displayType);
    else if (type & 2) return (0, $b11db1b62d4a8f76$export$cc74ec0e2bf1c390)[locale](displayType);
    else if (type & 32) return (0, $b11db1b62d4a8f76$export$94b61b888e588ac2)[locale](displayType);
    else if (type & 128) return (0, $b11db1b62d4a8f76$export$9e80186c98919fd3)[locale](displayType);
    else throw new Error(`Unexpected subscriber type ${type}`);
}
const $fc2f5b0b15619892$export$823653c22c406b00 = {
    status: 1,
    assignee: 2,
    comment: 4
};
const $fc2f5b0b15619892$export$6579d67e23b63336 = 'activity-subscription-button';
const $fc2f5b0b15619892$export$8e709ea29df8a2f1 = 'email-notify-status';
const $fc2f5b0b15619892$export$e2e1c67e97d17ec2 = 'email-notify-assignee';
const $fc2f5b0b15619892$export$db83f36fdd193499 = 'email-notify-comment';
const $fc2f5b0b15619892$var$defaultRequiredExpression = {
    type: 'boolean',
    ast: {
        type: 'BinaryExpression',
        operator: '==',
        left: {
            type: 'CallExpression',
            arguments: [
                {
                    type: 'Identifier',
                    name: 'ACTIVITY_STATUS'
                }
            ],
            callee: {
                type: 'Identifier',
                name: 'VALUE'
            }
        },
        right: {
            type: 'Literal',
            value: 'completed',
            raw: "'completed'"
        }
    }
};
function $fc2f5b0b15619892$export$d89c0470e9f1cc7e(elements, expressionContext, callback) {
    let hiddenHeadingLevel = Number.MAX_SAFE_INTEGER;
    let visibleConsecutiveHeadingLevel = Number.MAX_SAFE_INTEGER;
    for (const el of elements){
        const visible = !(el.visibility && !(0, $6941fa4b8204d0aa$export$61b73397e464436e)('bit', el.visibility, expressionContext));
        // console.log(
        //   `Element ${el.index}, level ${el.level}, visible ${visible} - hiddenHeadingLevel ${hiddenHeadingLevel}`
        // );
        if (el.type === 'heading') {
            // when multiple headings of the same level appear consecutively, only one of them has to be visible
            // for the subsequent fields to be visible.
            visibleConsecutiveHeadingLevel = visible || el.level === visibleConsecutiveHeadingLevel ? el.level : Number.MAX_SAFE_INTEGER;
            if (el.level <= hiddenHeadingLevel) hiddenHeadingLevel = visible || el.level === visibleConsecutiveHeadingLevel ? Number.MAX_SAFE_INTEGER : el.level;
        } else visibleConsecutiveHeadingLevel = Number.MAX_SAFE_INTEGER;
        const required = el.required && Boolean((0, $6941fa4b8204d0aa$export$61b73397e464436e)('bit', el.required_expression ?? $fc2f5b0b15619892$var$defaultRequiredExpression, expressionContext));
        const readonly = !!el.readonly_expression && Boolean((0, $6941fa4b8204d0aa$export$61b73397e464436e)('bit', el.readonly_expression, expressionContext));
        const visibleWithHeading = visible && el.level < hiddenHeadingLevel;
        callback(el, visibleWithHeading, required, readonly);
        if (el.type === 'heading') {
            if (visibleWithHeading) expressionContext.hasVisiblePredecessors = false;
        } else expressionContext.hasVisiblePredecessors ||= visibleWithHeading;
    // console.log(
    //   `${el.index.toString().padStart(3, ' ')} ${el.type.padEnd(15, ' ')} | visible: ${visibleWithHeading.toString().padEnd(5, ' ')} | hasVisiblePredecessors: ${scope.hasVisiblePredecessors.toString().padEnd(5, ' ')} | ${el.type === 'heading' ? el.text : ''}`
    // );
    }
}
function $fc2f5b0b15619892$export$80ddb1e8ba36c18f({ organization_login: organization_login, activityDefinition: { activity_definition_id: activity_definition_id, type: type, flags: flags, parents: parents }, parent_person_id: parent_person_id, parent_activity_id: parent_activity_id, child_person_id: child_person_id, title: title, comment_body: comment_body, assignee: assignee, start_date: start_date, end_date: end_date, due_date: due_date, prefill_activity_id: prefill_activity_id, referring_event_activity_id: referring_event_activity_id, modal: modal, element_index: element_index, responses: responses, associate_activity_id: associate_activity_id }) {
    // Params accepted by the destination activity detail page.
    const destParams = new URLSearchParams();
    // Params used for navigation prior to reaching the activity detail page.
    const navParams = new URLSearchParams();
    if (associate_activity_id) navParams.set('associate_activity_id', associate_activity_id);
    else {
        destParams.set('activity_definition_id', activity_definition_id);
        navParams.set('activity_definition_id', activity_definition_id);
        if (title) {
            destParams.set('title', title);
            navParams.set('activity_title', title);
        }
        if (comment_body) {
            destParams.set('comment_body', comment_body);
            navParams.set('activity_comment_body', comment_body);
        }
        if (assignee) {
            destParams.set('assignee', assignee);
            navParams.set('activity_assignee', assignee);
        }
        if (start_date) {
            destParams.set('start_date', start_date);
            navParams.set('activity_start_date', start_date);
        }
        if (end_date) {
            destParams.set('end_date', end_date);
            navParams.set('activity_end_date', end_date);
        }
        if (due_date) {
            destParams.set('due_date', due_date);
            navParams.set('activity_due_date', due_date);
        }
        if (prefill_activity_id) {
            destParams.set('prefill_activity_id', prefill_activity_id);
            navParams.set('prefill_activity_id', prefill_activity_id);
        }
        if (referring_event_activity_id) {
            destParams.set('referring_event_activity_id', referring_event_activity_id);
            navParams.set('referring_event_activity_id', referring_event_activity_id);
        }
        if (modal) destParams.set('modal', 'true');
        if (element_index !== undefined) destParams.set('element-index', element_index.toString());
        for (const [k, v] of Object.entries(responses ?? {}))if (v !== null && v !== undefined) {
            destParams.set(`property-${k}`, v);
            navParams.set(`property-${k}`, v);
        }
    }
    const root = (flags & 1) > 0;
    const permitAnonymous = (flags & 4) > 0;
    // INDIVIDUAL
    if ($fc2f5b0b15619892$export$f635b8a078bb67e5(type) && !(!parent_person_id && permitAnonymous)) {
        // PERSON IDENTIFIED?
        if (parent_person_id) {
            if (root) {
                if (associate_activity_id) return `/${organization_login}/people/${(0, $52ec208b1be5af58$export$7077a352e654daea)(parent_person_id)}/activities/${(0, $52ec208b1be5af58$export$7077a352e654daea)(associate_activity_id)}?action=associate`;
                else return `/${organization_login}/people/${(0, $52ec208b1be5af58$export$7077a352e654daea)(parent_person_id)}/activities/new?${destParams}`;
            } else {
                if (parent_activity_id) {
                    destParams.set('parent_activity_id', parent_activity_id);
                    navParams.set('parent_activity_id', parent_activity_id);
                    if (type === 'individual-relationship') {
                        if (child_person_id) {
                            if (associate_activity_id) return `/${organization_login}/people/${(0, $52ec208b1be5af58$export$7077a352e654daea)(child_person_id)}/activities/${(0, $52ec208b1be5af58$export$7077a352e654daea)(associate_activity_id)}?action=associate&parent_activity_id=${encodeURIComponent(parent_activity_id)}`;
                            else return `/${organization_login}/people/${(0, $52ec208b1be5af58$export$7077a352e654daea)(child_person_id)}/activities/new?${destParams}`;
                        } else {
                            navParams.set('parent_person_id', parent_person_id);
                            return `/${organization_login}/people/?${navParams}`;
                        }
                    } else {
                        if (associate_activity_id) return `/${organization_login}/people/${(0, $52ec208b1be5af58$export$7077a352e654daea)(parent_person_id)}/activities/${(0, $52ec208b1be5af58$export$7077a352e654daea)(associate_activity_id)}?action=associate&parent_activity_id=${encodeURIComponent(parent_activity_id)}`;
                        else return `/${organization_login}/people/${(0, $52ec208b1be5af58$export$7077a352e654daea)(parent_person_id)}/activities/new?${destParams}`;
                    }
                } else if (parents?.find((x)=>$fc2f5b0b15619892$export$f635b8a078bb67e5(x.type))) return `/${organization_login}/people/${(0, $52ec208b1be5af58$export$7077a352e654daea)(parent_person_id)}/activities/?${navParams}`;
                else return `/${organization_login}/activities/?${navParams}`;
            }
        } else return `/${organization_login}/people/?${navParams}`;
    }
    // ORGANIZATION (or anonymous)
    if (root) return `/${organization_login}/activities/new?${destParams}`;
    else {
        if (parent_activity_id) {
            destParams.set('parent_activity_id', parent_activity_id);
            return `/${organization_login}/activities/new?${destParams}`;
        } else return `/${organization_login}/activities/?${navParams}`;
    }
}
function $fc2f5b0b15619892$export$1ff92de98417a845({ activityDefinitionLookup: activityDefinitionLookup, person_id: person_id, associated_activity: associated_activity, require_associated_person: require_associated_person = true, require_associated_activity: require_associated_activity = true }) {
    const associatedActivityDefiniton = activityDefinitionLookup.find((x)=>x.activity_definition_id === associated_activity?.activity_definition_id);
    if (associated_activity && !associatedActivityDefiniton) throw new Error(`Unable to find associated activity definition with id "${associated_activity.activity_definition_id}".`);
    const results = [];
    for (const x of activityDefinitionLookup){
        // discretionary?
        if ((x.flags & 2) === 0) continue;
        const individual = $fc2f5b0b15619892$export$f635b8a078bb67e5(x.type);
        // individual activity? require person, anonymous, or not require associated.
        if (individual && !person_id && (x.flags & 4) === 0 && require_associated_person) continue;
        // organization activity? ensure person is not set.
        if (!individual && person_id) continue;
        // associated activity provided? ensure child and ensure parents permit the specified associated activity.
        if (associated_activity && !((x.flags & 1) === 0 && associated_activity.project_id === x.project_id && x.parents?.find((p)=>p.activity_definition_id === associated_activity.activity_definition_id))) continue;
        // root?
        if ((x.flags & 1) > 0 && !associated_activity) {
            results.push(x);
            continue;
        }
        // child...
        // child, but no parents?
        if (!x.parents?.length) continue;
        // organization child with individual parent?
        if (!$fc2f5b0b15619892$export$f635b8a078bb67e5(x.type) && x.parents?.find((p)=>$fc2f5b0b15619892$export$f635b8a078bb67e5(p.type))) continue;
        // TEMP: individual child with unknown organization parent?
        // Need to enhance activity list....
        if ($fc2f5b0b15619892$export$f635b8a078bb67e5(x.type) && !associated_activity && x.parents?.find((p)=>!$fc2f5b0b15619892$export$f635b8a078bb67e5(p.type))) continue;
        // child with associated activity?
        if (associated_activity?.project_id === x.project_id && x.parents?.find((y)=>y.activity_definition_id === associated_activity.activity_definition_id)) {
            results.push(x);
            continue;
        }
        // child without associated activity?
        if (!associated_activity && !require_associated_activity) {
            results.push(x);
            continue;
        }
    }
    const today = new Date(new Date().toLocaleString('en-US', {
        timeZone: 'America/New_York'
    })).toISOString().substr(0, 10);
    const active = [];
    const inactive = [];
    for (const x of results)if (x.start_date <= today && x.end_date >= today) active.push(x);
    else inactive.push(x);
    return {
        active: active,
        inactive: inactive
    };
}
function $fc2f5b0b15619892$export$1a6824b3d7fd3414(activityDefinitionLookup) {
    let count = 0;
    for (const x of activityDefinitionLookup)if (x.type === 'individual-referral') {
        count++;
        if (count > 4) return true;
    }
    return false;
}



function $fd1cd71095fc7279$export$7ad13431816ff1fa(value) {
    const array = [];
    for(let shift = 0; shift < 32; shift++)if ((value & 2 ** shift) !== 0) array.push(shift);
    return array;
}
function $fd1cd71095fc7279$export$ad3694445957bc72(array) {
    let value = 0;
    for (const shift of array)value += 2 ** shift;
    return value;
}



function $c1de6d172f4f6f9e$export$36f1754b1616884a(type) {
    switch(type){
        case 'activity':
            return 'activities';
        case 'activity_definition':
            return 'activity-definitions';
        case 'person':
            return 'people';
        case 'form':
            return 'activities';
        case 'task':
            return 'activities';
        case 'organization':
            return 'organizations';
        case 'report':
        case 'dashboard':
            return 'reports';
        case 'user_organization':
            return 'members';
        case 'task_definition':
            return 'task-definitions';
        case 'form_design':
            return 'form-designs';
        case 'service_authorization':
            return 'service-authorizations';
        case 'organization_project':
        default:
            throw new Error(`Unexpected type "${type}`);
    }
}
function $c1de6d172f4f6f9e$export$8398a3e81384ac66(value) {
    return value === undefined || value === null || value === '';
}
function $c1de6d172f4f6f9e$export$b69667b9fc24675e({ locale: locale, property: property, value: value, showScore: showScore, activities: activities }) {
    if ($c1de6d172f4f6f9e$export$8398a3e81384ac66(value)) return (0, $b11db1b62d4a8f76$export$2f8dde2e869bc7b8)[locale];
    switch(property.choice_type){
        case 'single':
            {
                const choices = property.choices;
                if (!choices) throw new Error('Property.choices expected.');
                const choice = choices.find((c)=>c.choice_id === value);
                if (!choice) return String(value);
                if (showScore && choices.some((c)=>c.score !== 0)) return `${choice.label} (score ${choice.score})`;
                return choice.label;
            }
        case 'multiple':
            {
                const choices = property.choices;
                if (!choices) throw new Error('Property.choices expected.');
                if (typeof value !== 'number') return String(value);
                const selected = (0, $fd1cd71095fc7279$export$7ad13431816ff1fa)(value).map((id)=>choices.find((c)=>c.choice_id === id)).filter((x)=>x !== undefined);
                const labels = selected.map((c)=>c.label).join(', ');
                if (showScore && choices.some((c)=>c.score !== 0)) return `${labels} (score ${selected.reduce((acc, c)=>acc + c.score, 0)})`;
                return labels;
            }
    }
    switch(property.type){
        case 'date':
            if (typeof value !== 'string') return String(value);
            return (0, $b78c044e3d911d2e$export$6aa1a8800137fac7).format(new Date(value.length === 10 ? value + 'T00:00:00.000Z' : value));
        case 'decimal':
            if (typeof value !== 'number') return String(value);
            return (0, $5e22b13d8e41f6dd$export$688d13a530c5dcbc).format(value);
        case 'int':
            if (typeof value !== 'number') return String(value);
            return value >= 1900 || value < 2100 // don't use commas when the int might be a year
             ? value.toString() : (0, $5e22b13d8e41f6dd$export$688d13a530c5dcbc).format(value);
        case 'varchar100':
        case 'varcharmax':
            if (typeof value !== 'string') return String(value);
            if (property.format === 14) return (0, $b78c044e3d911d2e$export$f41928ddf8b27367)(value).value;
            return value;
        case 'bit':
            return value ? (0, $b11db1b62d4a8f76$export$310250c811816278)[locale] : (0, $b11db1b62d4a8f76$export$9692d1a0658a3861)[locale];
        case 'currency':
            if (typeof value !== 'number') return String(value);
            return (0, $5e22b13d8e41f6dd$export$4670d0ed237a9270).format(value);
        case 'activity':
            {
                if (typeof value !== 'string') return String(value);
                const activity = activities.find((a)=>a.activity_id === value);
                return activity?.title ?? value;
            }
        case 'attachment':
            if (typeof value !== 'number') return String(value);
            return value === 1 ? (0, $b11db1b62d4a8f76$export$9c74c928b7f96fab)[locale] : (0, $b11db1b62d4a8f76$export$a9eeb925e66f3fef)[locale](value);
        case 'signature':
            if (typeof value !== 'number') return String(value);
            return value === 1 ? (0, $b11db1b62d4a8f76$export$5b2dff051546c71)[locale] : (0, $b11db1b62d4a8f76$export$88044af7e8639ccb)[locale](value);
        case 'medications':
            if (typeof value !== 'number') return String(value);
            return value === 1 ? (0, $b11db1b62d4a8f76$export$1ff6720e765bd764)[locale] : (0, $b11db1b62d4a8f76$export$814fd764a5b35e2f)[locale](value);
        default:
            throw new Error(`getPropertyDisplayValue not implemented for type: "${property.type}"; calculated: "${property.calculated}"; choice_type: "${property.choice_type}";`);
    }
}
var $c1de6d172f4f6f9e$export$ac1cd9a3e24492e7 = /*#__PURE__*/ function(PropertyFormat) {
    PropertyFormat[PropertyFormat["None"] = 0] = "None";
    PropertyFormat[PropertyFormat["Email"] = 1] = "Email";
    PropertyFormat[PropertyFormat["FEIN"] = 2] = "FEIN";
    PropertyFormat[PropertyFormat["Phone"] = 3] = "Phone";
    PropertyFormat[PropertyFormat["SSN"] = 4] = "SSN";
    PropertyFormat[PropertyFormat["Zip"] = 5] = "Zip";
    PropertyFormat[PropertyFormat["Zip4"] = 6] = "Zip4";
    PropertyFormat[PropertyFormat["Address"] = 7] = "Address";
    PropertyFormat[PropertyFormat["URL"] = 8] = "URL";
    PropertyFormat[PropertyFormat["RelativeURL"] = 9] = "RelativeURL";
    PropertyFormat[PropertyFormat["ICD10Code"] = 10] = "ICD10Code";
    PropertyFormat[PropertyFormat["ICD10CodeDescription"] = 11] = "ICD10CodeDescription";
    PropertyFormat[PropertyFormat["HCPCSCode"] = 12] = "HCPCSCode";
    PropertyFormat[PropertyFormat["HCPCSCodeDescription"] = 13] = "HCPCSCodeDescription";
    PropertyFormat[PropertyFormat["Time"] = 14] = "Time";
    PropertyFormat[PropertyFormat["RegionAbbreviation"] = 15] = "RegionAbbreviation";
    PropertyFormat[PropertyFormat["City"] = 16] = "City";
    PropertyFormat[PropertyFormat["Subregion"] = 17] = "Subregion";
    PropertyFormat[PropertyFormat["TimeZone"] = 18] = "TimeZone";
    return PropertyFormat;
}({});
const $c1de6d172f4f6f9e$export$73a8cd8fe3f87586 = [
    {
        type: null,
        choice_type: null,
        value: 0,
        label: 'None'
    },
    {
        type: 'varchar100',
        choice_type: 'none',
        value: 7,
        label: 'Address'
    },
    {
        type: 'varchar100',
        choice_type: 'none',
        value: 1,
        label: 'Email'
    },
    {
        type: 'varchar100',
        choice_type: 'none',
        value: 2,
        label: 'FEIN'
    },
    {
        type: 'varchar100',
        choice_type: 'none',
        value: 3,
        label: 'Phone'
    },
    {
        type: 'varchar100',
        choice_type: 'none',
        value: 4,
        label: 'SSN'
    },
    {
        type: 'varcharmax',
        choice_type: 'none',
        value: 8,
        label: 'URL'
    },
    {
        type: 'varcharmax',
        choice_type: 'none',
        value: 9,
        label: 'URL (relative)'
    },
    {
        type: 'varchar100',
        choice_type: 'none',
        value: 5,
        label: 'Zip'
    },
    {
        type: 'varchar100',
        choice_type: 'none',
        value: 6,
        label: 'Zip+4'
    },
    {
        type: 'varchar100',
        choice_type: 'none',
        value: 10,
        label: 'ICD-10 Code'
    },
    {
        type: 'varcharmax',
        choice_type: 'none',
        value: 11,
        label: 'ICD-10 Code Description'
    },
    {
        type: 'varchar100',
        choice_type: 'none',
        value: 12,
        label: 'HCPCS Code'
    },
    {
        type: 'varchar100',
        choice_type: 'none',
        value: 13,
        label: 'HCPCS Code Description'
    },
    {
        type: 'varchar100',
        choice_type: 'none',
        value: 14,
        label: 'Time (HH:MM AM/PM)'
    },
    {
        type: 'varchar100',
        choice_type: 'big-single',
        value: 15,
        label: 'Region Abbreviation'
    },
    {
        type: 'varchar100',
        choice_type: 'big-single',
        value: 16,
        label: 'City'
    },
    {
        type: 'varchar100',
        choice_type: 'big-single',
        value: 17,
        label: 'Subregion'
    },
    {
        type: 'varchar100',
        choice_type: 'big-single',
        value: 18,
        label: 'Time Zone'
    }
];
const $c1de6d172f4f6f9e$export$463907730aed6aef = {
    [0]: null,
    [1]: {
        min: 4,
        max: 100
    },
    [2]: {
        min: 10,
        max: 10,
        mask: '##-#######',
        regex: /^\d{2}-\d{7}$/
    },
    [3]: {
        min: 14,
        max: 14
    },
    [4]: {
        min: 11,
        max: 11,
        mask: '###-##-####',
        regex: /\d{3}-\d{2}-\d{4}$/
    },
    [5]: {
        min: 5,
        max: 5,
        mask: '#####',
        regex: /^\d{5}$/
    },
    [6]: {
        min: 5,
        max: 9,
        mask: '#####-####',
        regex: /^\d{5}(?:-\d{4})?$/
    },
    [7]: {
        min: 0,
        max: 100
    },
    [8]: {
        min: 13,
        max: 2000
    },
    [9]: {
        min: 1,
        max: 2000
    },
    [10]: {
        min: 3,
        max: 8
    },
    [11]: {
        min: 0,
        max: 400
    },
    [12]: {
        min: 5,
        max: 5
    },
    [13]: {
        min: 1,
        max: 28
    },
    [14]: {
        min: 5,
        max: 5
    },
    [15]: {
        min: 2,
        max: 2
    },
    [16]: {
        min: 1,
        max: 100
    },
    [17]: {
        min: 1,
        max: 100
    },
    [18]: {
        min: 1,
        max: 64
    }
};
function $c1de6d172f4f6f9e$export$34d61295a3a678(args) {
    const { value: value, format: format } = args;
    if (typeof value !== 'string') return false;
    return format === 8 && value.toLowerCase().startsWith('https://') && URL.canParse(value) || format === 9 && value.length > 0 && value.startsWith('/') && URL.canParse(value, 'https://cumulus.care');
}
const $c1de6d172f4f6f9e$export$3f9e8a95c406046 = {
    person: {
        person_id: 5722,
        last_name: 1,
        first_name: 2,
        middle_name: 3,
        suffix: 4862,
        nickname: 4863,
        addresses: 4,
        phones: 5,
        emails: 6,
        gender: 7,
        gender_identity: 1990,
        sexual_orientation: 1009,
        race: 1010,
        ethnicity: 1011,
        marital_status: 1085,
        primary_language: 1012,
        dob: 8,
        external_id: 106,
        full_name: 45,
        ssn: 1055,
        veteran_id: 1056,
        medicaid_id: 1092,
        medicare_beneficiary_id: 7340,
        agingis_id: 2705,
        scsep_participant_id: 3826,
        primary_physical: {
            address: 48,
            city: 50,
            region_abbr: 51,
            subregion: 52,
            postal_code: 53,
            street_address: 82,
            sub_address: 83,
            postal_code_ext: 84,
            is_precise: 164
        },
        primary_mailing: {
            address: 49,
            city: 75,
            region_abbr: 76,
            subregion: 77,
            postal_code: 78,
            street_address: 79,
            sub_address: 80,
            postal_code_ext: 81,
            is_precise: 165
        },
        primary_phone: {
            formatted: 85,
            type: 86,
            number: 87,
            extension: 88
        },
        primary_email: {
            formatted: 89,
            type: 90,
            email: 91
        },
        create_date: 54,
        create_organization_id: 55,
        create_user_id: 56,
        update_date: 57,
        update_organization_id: 58,
        update_user_id: 59,
        user_id: 2171,
        user_email_address: 6374,
        user_email_address_matches: 6375,
        open_participant_portal_invitation: 5855
    },
    user_organization: {
        family_name: 168,
        given_name: 169,
        login: 170,
        email: 171,
        projects: 172,
        organization_id: 173,
        is_active: 7708,
        role_id: 342,
        primary_phone: {
            formatted: 174,
            type: 175,
            number: 176,
            extension: 177
        },
        last_login_date: 4515,
        title: 5720,
        description: 5721
    },
    activity: {
        activity_id: 5724,
        activity_record: 7868,
        parent_activity_id: 5725,
        subject_person_id: 5723,
        activity_definition_id: 243,
        create_date: 244,
        create_organization_id: 245,
        create_user_id: 246,
        start_date: 247,
        end_date: 248,
        status: 251,
        status_date: 252,
        update_date: 253,
        due_date: 2647,
        update_organization_id: 254,
        update_user_id: 255,
        project_id: 257,
        assignee_id: 258,
        assignee_user_id: 259,
        assignee_organization_id: 260,
        assignee_active: 7465,
        assignment_datetime: 1673,
        contract_id: 432,
        type: 261,
        sctid: 262,
        create_dow: 263,
        subscribed: 264,
        comment_create_user_id: 265,
        comment_create_date: 3140,
        comment_mentioned_user_id: 266,
        comment_text: 3141,
        title: 276,
        primary_physical: {
            address: 267,
            city: 268,
            region_abbr: 269,
            subregion: 270,
            postal_code: 271,
            street_address: 272,
            sub_address: 273,
            postal_code_ext: 274,
            is_precise: 275
        },
        primary_phone: {
            formatted: 2535,
            type: 2536,
            number: 2537,
            extension: 2538
        },
        primary_email: {
            formatted: 2539,
            type: 2540,
            email: 2541
        },
        assignee_organization_primary_physical: {
            address: 277,
            city: 278,
            region_abbr: 279,
            subregion: 280,
            postal_code: 281,
            street_address: 282,
            sub_address: 283,
            postal_code_ext: 284,
            is_precise: 285
        },
        assignee_organization_primary_email: {
            formatted: 1086,
            type: 1087,
            email: 1088
        },
        assignee_role_id: 286,
        create_organization_primary_physical: {
            address: 287,
            city: 288,
            region_abbr: 289,
            subregion: 290,
            postal_code: 291,
            street_address: 292,
            sub_address: 293,
            postal_code_ext: 294,
            is_precise: 295
        },
        create_organization_primary_email: {
            formatted: 1089,
            type: 1090,
            email: 1091
        },
        attachment_count: 408,
        most_recent_attachment_date: 5107,
        consent_granted: 1303,
        service_authorization_service_id: 6988,
        is_claimed: 7110,
        timesheet: {
            has_timesheet_error: 6631,
            timesheet_error_codes: 6632,
            highest_priority_timesheet_error_code: 7455,
            timesheet_error_sort_rank: 7456,
            has_exported_timesheet_error: 7099,
            exported_timesheet_error_codes: 7100,
            timesheet_total_hours: 6709,
            timesheet_total_minutes: 6710,
            timesheet_exported_minutes: 7786,
            timesheet_exported_hours: 7787
        },
        group_programming: {
            // episode
            participant_event_enrollment_link: 7611,
            participant_email: 4762,
            participant_phone: 4763,
            // event
            workshop_logo: 7527,
            event_description: 7524,
            event_additional_information: 4759,
            event_facilitators: 7530,
            event_location: 6041,
            session_format: 6026,
            meeting_link: 7464,
            meeting_id: 7531,
            meeting_passcode: 7532,
            session_language: 6033,
            session_days_of_week: 6038,
            session_start_time: 4701,
            session_end_time: 5373,
            number_of_sessions_per_week: 6039,
            total_sessions: 6040,
            minimum_participants: 6052,
            maximum_participants: 5600,
            registration_period_begins: 5374,
            registration_period_ends: 5375,
            event_contact_phone: 7528,
            event_contact_email: 7529,
            reminder_1: 7635,
            reminder_2: 7636,
            post_event_reminder_1: 7662,
            post_event_reminder_2: 7663
        }
    },
    organization_project: {
        organization_id: 324,
        project_id: 325,
        project_join_date: 326,
        is_active: 327,
        is_admin: 341,
        contracted_by_organization_id: 7520,
        classification: 2010,
        fein: 2011,
        primary_phone: {
            formatted: 5004,
            type: 5005,
            number: 5006,
            extension: 5007
        },
        primary_physical: {
            address: 332,
            city: 333,
            region_abbr: 334,
            subregion: 335,
            postal_code: 336,
            street_address: 337,
            sub_address: 338,
            postal_code_ext: 339,
            is_precise: 340
        }
    },
    fms: {
        pay_schedule: 6034,
        pay_period: 2601,
        timesheet_submitted_by: 6056,
        timesheet_submitted_by_employee_choice_id: 0,
        timesheet_submitted_by_employer_choice_id: 1,
        timesheet_approved_date: 6903,
        work_timezone: 6027,
        service_cost: 6087,
        provider: 6086,
        invoice_attachment: 6416,
        budget_suspension_reason: 5539
    }
};
const $c1de6d172f4f6f9e$export$be5da72c1132278d = {};
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.primary_physical).forEach((x)=>$c1de6d172f4f6f9e$export$be5da72c1132278d[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.primary_physical);
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.assignee_organization_primary_physical).forEach((x)=>$c1de6d172f4f6f9e$export$be5da72c1132278d[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.assignee_organization_primary_physical);
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.create_organization_primary_physical).forEach((x)=>$c1de6d172f4f6f9e$export$be5da72c1132278d[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.create_organization_primary_physical);
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.person.primary_physical).forEach((x)=>$c1de6d172f4f6f9e$export$be5da72c1132278d[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.person.primary_physical);
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.person.primary_mailing).forEach((x)=>$c1de6d172f4f6f9e$export$be5da72c1132278d[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.person.primary_mailing);
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.organization_project.primary_physical).forEach((x)=>$c1de6d172f4f6f9e$export$be5da72c1132278d[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.organization_project.primary_physical);
const $c1de6d172f4f6f9e$export$57f8d18cc41ddb41 = {};
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.person.primary_phone).forEach((x)=>$c1de6d172f4f6f9e$export$57f8d18cc41ddb41[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.person.primary_phone);
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.primary_phone).forEach((x)=>$c1de6d172f4f6f9e$export$57f8d18cc41ddb41[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.primary_phone);
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.user_organization.primary_phone).forEach((x)=>$c1de6d172f4f6f9e$export$57f8d18cc41ddb41[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.user_organization.primary_phone);
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.organization_project.primary_phone).forEach((x)=>$c1de6d172f4f6f9e$export$57f8d18cc41ddb41[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.organization_project.primary_phone);
const $c1de6d172f4f6f9e$export$5786dfc88873b340 = {};
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.person.primary_email).forEach((x)=>$c1de6d172f4f6f9e$export$5786dfc88873b340[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.person.primary_email);
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.primary_email).forEach((x)=>$c1de6d172f4f6f9e$export$5786dfc88873b340[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.primary_email);
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.assignee_organization_primary_email).forEach((x)=>$c1de6d172f4f6f9e$export$5786dfc88873b340[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.assignee_organization_primary_email);
Object.values($c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.create_organization_primary_email).forEach((x)=>$c1de6d172f4f6f9e$export$5786dfc88873b340[x] = $c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.create_organization_primary_email);
$c1de6d172f4f6f9e$export$5786dfc88873b340[$c1de6d172f4f6f9e$export$3f9e8a95c406046.user_organization.email] = {
    email: $c1de6d172f4f6f9e$export$3f9e8a95c406046.user_organization.email
};
const $c1de6d172f4f6f9e$export$a83037be00b92f3e = {
    [16]: 'City',
    [15]: 'Region',
    [17]: 'Subregion',
    [5]: 'Primary Postal'
};
const $c1de6d172f4f6f9e$export$cc0d55d7ff08492f = {
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.primary_physical.city]: 'City',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.primary_physical.postal_code]: 'Primary Postal',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.primary_physical.region_abbr]: 'Region',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.primary_physical.subregion]: 'Subregion',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.assignee_organization_primary_physical.city]: 'City',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.assignee_organization_primary_physical.postal_code]: 'Primary Postal',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.assignee_organization_primary_physical.region_abbr]: 'Region',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.assignee_organization_primary_physical.subregion]: 'Subregion',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.create_organization_primary_physical.city]: 'City',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.create_organization_primary_physical.postal_code]: 'Primary Postal',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.create_organization_primary_physical.region_abbr]: 'Region',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.activity.create_organization_primary_physical.subregion]: 'Subregion',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.person.primary_physical.city]: 'City',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.person.primary_physical.postal_code]: 'Primary Postal',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.person.primary_physical.region_abbr]: 'Region',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.person.primary_physical.subregion]: 'Subregion',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.organization_project.primary_physical.city]: 'City',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.organization_project.primary_physical.postal_code]: 'Primary Postal',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.organization_project.primary_physical.region_abbr]: 'Region',
    [$c1de6d172f4f6f9e$export$3f9e8a95c406046.organization_project.primary_physical.subregion]: 'Subregion'
};
const $c1de6d172f4f6f9e$export$1497f5791e8774bc = {
    uniqueidentifier: {
        'big-single': {
            display_type: 'Single choice (ID lookup)',
            type: 'uniqueidentifier',
            choice_type: 'big-single',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    activity: {
        'big-single': {
            display_type: 'Activity field',
            type: 'activity',
            choice_type: 'big-single',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    attachment: {
        none: {
            display_type: 'Attachment',
            type: 'attachment',
            choice_type: 'none',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    signature: {
        none: {
            display_type: 'Signature',
            type: 'signature',
            choice_type: 'none',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    medications: {
        none: {
            display_type: 'Medications',
            type: 'medications',
            choice_type: 'none',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    varchar100: {
        none: {
            display_type: 'Text',
            type: 'varchar100',
            choice_type: 'none',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 100,
            defaultMax: 50
        },
        'big-single': {
            display_type: 'Single choice (text lookup)',
            type: 'varchar100',
            choice_type: 'big-single',
            format: 15,
            report_column: true,
            report_filter: true,
            report_sort: true,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 100,
            defaultMax: 50
        }
    },
    varcharmax: {
        none: {
            display_type: 'Long text',
            type: 'varcharmax',
            choice_type: 'none',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 10000,
            defaultMax: 200
        }
    },
    int: {
        none: {
            display_type: 'Integer',
            type: 'int',
            choice_type: 'none',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: -100000000,
            defaultMin: 0,
            max: 100000000,
            defaultMax: 100
        },
        single: {
            display_type: 'Single choice',
            type: 'int',
            choice_type: 'single',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: true,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        },
        multiple: {
            display_type: 'Multiple choice',
            type: 'int',
            choice_type: 'multiple',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: true,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    bit: {
        none: {
            display_type: 'Boolean',
            type: 'bit',
            choice_type: 'none',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        },
        single: {
            display_type: 'Boolean',
            type: 'bit',
            choice_type: 'single',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: true,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    currency: {
        none: {
            display_type: 'Currency',
            type: 'currency',
            choice_type: 'none',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: -100000000,
            defaultMin: 0,
            max: 100000000,
            defaultMax: 10000
        }
    },
    date: {
        none: {
            display_type: 'Date',
            type: 'date',
            choice_type: 'none',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    decimal: {
        none: {
            display_type: 'Decimal',
            type: 'decimal',
            choice_type: 'none',
            format: 0,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: -100000000,
            defaultMin: 0,
            max: 100000000,
            defaultMax: 10000
        }
    }
};
const $c1de6d172f4f6f9e$export$d903fab3e128a936 = Object.values($c1de6d172f4f6f9e$export$1497f5791e8774bc).reduce((acc, pt)=>{
    for (const ct of Object.values(pt))acc[ct.display_type] = ct;
    return acc;
}, {});



function $e2bf3f8a63f9de76$var$computeChartArc(startAngle, endAngle, outerRadius, innerRadius) {
    startAngle = startAngle * Math.PI / 180;
    endAngle = endAngle * Math.PI / 180;
    const sinAlpha = Math.sin(startAngle);
    const cosAlpha = Math.cos(startAngle);
    const sinBeta = Math.sin(endAngle);
    const cosBeta = Math.cos(endAngle);
    const largeArc = endAngle - startAngle > Math.PI;
    const P = {
        x: outerRadius + outerRadius * sinAlpha,
        y: outerRadius - outerRadius * cosAlpha
    };
    const Q = {
        x: outerRadius + outerRadius * sinBeta,
        y: outerRadius - outerRadius * cosBeta
    };
    const R = {
        x: outerRadius + innerRadius * sinBeta,
        y: outerRadius - innerRadius * cosBeta
    };
    const S = {
        x: outerRadius + innerRadius * sinAlpha,
        y: outerRadius - innerRadius * cosAlpha
    };
    return `M${P.x}, ${P.y} A${outerRadius},${outerRadius} 0 ${largeArc ? '1' : '0'} 1 ${Q.x},${Q.y} L${R.x},${R.y} A${innerRadius},${innerRadius} 0 ${largeArc ? '1' : '0'} 0 ${S.x},${S.y} Z`;
}
function $e2bf3f8a63f9de76$export$3194dcd7e2b21417(percentage, backgroundColor = 'var(--color-accent-subtle)', innerRadius = 5) {
    const b = $e2bf3f8a63f9de76$var$computeChartArc(0, 359.99, 8, innerRadius);
    const f = $e2bf3f8a63f9de76$var$computeChartArc(0, 359.99 * percentage, 8, innerRadius);
    return `<path fill="${backgroundColor}" d="${b}" /><path fill="currentColor" d="${f}" />`;
}





const $9d0d00e92a99c512$export$a5cacc05f5e9f20c = [
    {
        choice_id: 2,
        label: 'Non-profit'
    },
    {
        choice_id: 1,
        label: 'For-profit'
    },
    {
        choice_id: 0,
        label: 'Government'
    }
];
const $9d0d00e92a99c512$export$8e77a375f9a5908e = [
    'Owner',
    'Admin',
    'Writer',
    'Reader'
];
const $9d0d00e92a99c512$export$c1da4857cafcfd90 = {
    Owner: 'a0000000-0000-0000-0000-000000000001',
    Admin: 'a0000000-0000-0000-0000-000000000002',
    Writer: 'a0000000-0000-0000-0000-000000000003',
    Reader: 'a0000000-0000-0000-0000-000000000004'
};
function $9d0d00e92a99c512$export$3da2623e77b27bff(user, expected_role) {
    switch(expected_role){
        case 'Owner':
            return user.role_id === $9d0d00e92a99c512$export$c1da4857cafcfd90.Owner;
        case 'Admin':
            return user.role_id === $9d0d00e92a99c512$export$c1da4857cafcfd90.Owner || user.role_id === $9d0d00e92a99c512$export$c1da4857cafcfd90.Admin;
        case 'Writer':
            return user.role_id === $9d0d00e92a99c512$export$c1da4857cafcfd90.Owner || user.role_id === $9d0d00e92a99c512$export$c1da4857cafcfd90.Admin || user.role_id === $9d0d00e92a99c512$export$c1da4857cafcfd90.Writer;
        default:
            throw new Error(`Invalid expected_role: ${JSON.stringify(expected_role)}`);
    }
}
function $9d0d00e92a99c512$export$395c839b544cebaf(alias, expected_role) {
    switch(expected_role){
        case 'Owner':
            return `[${alias}].role_id = convert(uniqueidentifier, '${$9d0d00e92a99c512$export$c1da4857cafcfd90.Owner}')`;
        case 'Admin':
            return `[${alias}].role_id in (convert(uniqueidentifier, '${$9d0d00e92a99c512$export$c1da4857cafcfd90.Owner}'), convert(uniqueidentifier, '${$9d0d00e92a99c512$export$c1da4857cafcfd90.Admin}'))`;
        case 'Writer':
            return `[${alias}].role_id <> convert(uniqueidentifier, '${$9d0d00e92a99c512$export$c1da4857cafcfd90.Reader}')`;
        default:
            throw new Error(`Invalid expected_role: ${JSON.stringify(expected_role)}`);
    }
}
function $9d0d00e92a99c512$export$99a392609bf9c4bc(users) {
    return users.reduce((p, c)=>{
        p[c.user_id] ??= {};
        p[c.user_id][c.organization_id] = c;
        return p;
    }, {});
}
function $9d0d00e92a99c512$export$dfb4b9c7c4ff56e4(users) {
    return users.reduce((p, c)=>{
        p[c.user_id] ??= {};
        p[c.user_id][c.organization_id] = c;
        return p;
    }, {});
}
function $9d0d00e92a99c512$export$dbf22db7e3af8185(entity) {
    return {
        user_id: entity.create_user_id,
        user_login: entity.create_user_login,
        user_name: entity.create_user_name,
        user_avatar_id: entity.create_user_avatar_id,
        organization_id: entity.create_organization_id,
        organization_login: entity.create_organization_login,
        organization_name: entity.create_organization_name,
        organization_avatar_id: entity.create_organization_avatar_id,
        is_active: entity.create_user_is_active,
        is_ooo: entity.create_user_is_ooo
    };
}
function $9d0d00e92a99c512$export$6d3fb84f784b8446(entity) {
    return {
        user_id: entity.assignee_user_id,
        user_login: entity.assignee_user_login,
        user_name: entity.assignee_user_name,
        user_avatar_id: entity.assignee_user_avatar_id,
        organization_id: entity.assignee_organization_id,
        organization_login: entity.assignee_organization_login,
        organization_name: entity.assignee_organization_name,
        organization_avatar_id: entity.assignee_organization_avatar_id,
        is_active: entity.assignee_user_is_active,
        is_ooo: entity.assignee_user_is_ooo
    };
}





// https://laurentpayot.github.io/minidenticons/
// https://github.com/laurentpayot/minidenticons/blob/main/minidenticons.js

// density of 4 for the lowest probability of collision
const $eaf5a3bb0191e989$var$SQUARE_DENSITY = 4;
// 18 different colors only for easy distinction
const $eaf5a3bb0191e989$var$COLORS_NB = 18;
const $eaf5a3bb0191e989$var$DEFAULT_SATURATION = 80;
const $eaf5a3bb0191e989$var$DEFAULT_LIGHTNESS = 50;
// 32 bit FNV-1a hash parameters
const $eaf5a3bb0191e989$var$FNV_PRIME = 16777619;
const $eaf5a3bb0191e989$var$OFFSET_BASIS = 2166136261;
// based on the FNV-1a hash algorithm, modified for *signed* 32 bit integers http://www.isthe.com/chongo/tech/comp/fnv/index.html
function $eaf5a3bb0191e989$var$simpleHash(str) {
    return str.split('')// >>> 0 for 32 bit unsigned integer conversion https://2ality.com/2012/02/js-integers.html
    .reduce((hash, char)=>((hash ^ char.charCodeAt(0)) >>> 0) * $eaf5a3bb0191e989$var$FNV_PRIME, $eaf5a3bb0191e989$var$OFFSET_BASIS);
}
function $eaf5a3bb0191e989$export$f94e576f8dfe1808(entity, size, classes = null, id = null, fluid = false, saturation = $eaf5a3bb0191e989$var$DEFAULT_SATURATION, lightness = $eaf5a3bb0191e989$var$DEFAULT_LIGHTNESS) {
    const hash = $eaf5a3bb0191e989$var$simpleHash(entity.id);
    // dividing hash by FNV_PRIME to get last XOR result for better color randomness (will be an integer except for empty string hash)
    const hue = hash / $eaf5a3bb0191e989$var$FNV_PRIME % $eaf5a3bb0191e989$var$COLORS_NB * (360 / $eaf5a3bb0191e989$var$COLORS_NB);
    const rects = [
        ...Array(entity.id ? 25 : 0).keys()
    ]// 2 + ((3 * 5 - 1) - modulo) to concentrate squares at the center
    .map((i)=>hash % (16 - i % 15) < $eaf5a3bb0191e989$var$SQUARE_DENSITY ? `<rect x="${i > 14 ? 7 - ~~(i / 5) : ~~(i / 5)}" y="${i % 5}" width="1" height="1"/>` : '').join('');
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-1.5 -1.5 8 8"
    style="fill: hsl(${hue} ${saturation}% ${lightness}%)"
    fill="hsl(${hue} ${saturation}% ${lightness}%)"
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('class', classes)}
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('id', id)}
    alt="${entity.login}"
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('width', fluid ? null : size.toFixed())}
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('height', fluid ? null : size.toFixed())}
  >
    ${(0, $f4d1565f2a6712b7$export$b6e69390c23686fb)(rects)}
  </svg>`;
}



function $5e661eb678df6c20$export$dd0e4d48d7766a39({ size: size, classes: classes, bimi: bimi = false, id: id } = {}) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`${bimi ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<?xml version="1.0" encoding="UTF-8" standalone="yes" ?>` : null}<svg
      xmlns="http://www.w3.org/2000/svg"
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('version', bimi ? '1.2' : null)}
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('baseProfile', bimi ? 'tiny-ps' : null)}
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('width', size?.toString())}
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('height', size?.toString())}
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-hidden', bimi ? null : 'true')}
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('class', classes)}
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('id', id)}
      viewBox="0 0 22.3 22.3"
    >
      ${bimi ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<title>Cumulus</title>` : null}
      <path
        d="m19.95687607 3.4897178-4.15 3.92c-.03-.03-.06-.07-.1-.11a5.407 5.407 0 0 0-1.8-1.2 5.583 5.583 0 0 0-4.1000005 0c-.01.01-.01.01-.02.01l-2.16-5.27999998c.01 0 .02-.01.03-.01a11.167 11.167 0 0 1 8.4000005 0 11.228 11.228 0 0 1 3.69 2.44999998c.07.07.14.14.21.22z"
        fill="#033d8b"
      />
      <path
        d="M9.78687557 6.1097178a5.453 5.453 0 0 0-1.78 1.19 5.413 5.413 0 0 0-1.60001 3.8600002h-5.70999a11.297 11.297 0 0 1 .81999-4.2000002 11.202 11.202 0 0 1 6.11001-6.12999998Z"
        fill="#0969da"
      />
      <path
        d="m9.78687557 16.199718-2.16 5.29a11.394 11.394 0 0 1-3.66001-2.44 11.126 11.126 0 0 1-2.45-3.69 11.298 11.298 0 0 1-.81999-4.2h5.70999a5.348 5.348 0 0 0 .4 2.05 5.506 5.506 0 0 0 2.98001 2.99z"
        fill="#54aeff"
      />
      <path
        d="m19.95487607 18.830718-4.145-3.922c-.03.032-.062.067-.102.104a5.435 5.435 0 0 1-1.8 1.199 5.5 5.5 0 0 1-4.1040005 0l-.015-.008-2.16 5.282.03.012a11.147 11.147 0 0 0 12.0860005-2.45l.002-.003c.067-.067.136-.137.208-.214z"
        fill="#b6e3ff"
      />
    </svg>`;
}


const $bf14acff41ebd7eb$export$754b6febe722cea4 = 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa';
const $bf14acff41ebd7eb$export$c88105ae160deaf9 = '00000000-0000-0000-0000-000000000000';
const $bf14acff41ebd7eb$export$c04e8e4d40520792 = '00000099-0000-0000-0000-000000000000';
const $bf14acff41ebd7eb$export$5d44f27c7abdcda9 = '00000077-0000-0000-0000-000000000000';
const $bf14acff41ebd7eb$export$5ff5ade51e1b8b9d = {
    type: 'user',
    anonymous: true,
    id: $bf14acff41ebd7eb$export$754b6febe722cea4,
    auth0_id: 'auth0|000000000000000000000000',
    auth0_connection: '',
    login: 'External',
    roles: [],
    email: 'external@cumulus.care',
    email_verified: true,
    given_name: 'External',
    family_name: 'External',
    name: 'External',
    avatar_id: '',
    is_ooo: false,
    eula_accepted: new Date().toISOString()
};
const $bf14acff41ebd7eb$export$12ad83c1dd9d429c = {
    status: 1,
    assignee: 2,
    comment: 4
};



const $70595cf5de31f094$export$8e791bf7fac21718 = /@cumulus\.care$/i;
const $70595cf5de31f094$export$f582d29a2accd675 = /@registered-apps\.cumulus\.care$/i;
const $70595cf5de31f094$export$f94a40361869b200 = /^CumulusSupport/i;
const $70595cf5de31f094$export$a2b50cedadabfd42 = `This account belongs to a Cumulus support staff member. It is used to perform updates requested by customers.`;
function $70595cf5de31f094$export$7b636ee1d1553fbd(email, classes) {
    return email.match($70595cf5de31f094$export$8e791bf7fac21718) && !email.includes('+') ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="Label Label--sponsors ${classes}">Staff</span>` : email.match($70595cf5de31f094$export$f582d29a2accd675) ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="Label Label--attention ${classes}">App</span>` : null;
}



const $cdfaf3b5836da68d$export$65bbdb088890cb21 = {
    sizes: [
        16,
        20,
        24,
        32,
        40,
        48,
        64,
        80,
        128,
        160,
        256,
        320,
        512,
        640,
        1024
    ],
    maxSize: 2048,
    type: 'image/jpeg'
};
function $cdfaf3b5836da68d$export$638a2d9f8df3c648(size) {
    if (size >= 640) return size;
    return size * 2;
}
function $cdfaf3b5836da68d$export$345c5736c8054f22(entity, size, classes = null, fluid = false) {
    const id = null;
    let content;
    if (!entity || entity.id === (0, $bf14acff41ebd7eb$export$754b6febe722cea4)) content = $cdfaf3b5836da68d$var$anonymousAvatar(size, 'Avatar-image', id, fluid);
    else if (entity.id === (0, $bf14acff41ebd7eb$export$c88105ae160deaf9) || entity.id === (0, $bf14acff41ebd7eb$export$c04e8e4d40520792) || entity.id === (0, $bf14acff41ebd7eb$export$5d44f27c7abdcda9) || (0, $70595cf5de31f094$export$f94a40361869b200).test(entity.login)) content = (0, $5e661eb678df6c20$export$dd0e4d48d7766a39)({
        classes: 'Avatar-image Avatar-image--logo'
    });
    else if (entity.avatar_id) content = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<img
      class="Avatar-image"
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('id', id)}
      src="${$cdfaf3b5836da68d$export$e594fdbb182de2fb(entity.avatar_id, $cdfaf3b5836da68d$export$638a2d9f8df3c648(size))}"
      alt="${entity.login}"
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('width', fluid ? null : size.toFixed())}
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('height', fluid ? null : size.toFixed())}
      loading="lazy"
    />`;
    else content = (0, $eaf5a3bb0191e989$export$f94e576f8dfe1808)(entity, size, 'Avatar-image', id, fluid);
    const status = entity?.id === (0, $bf14acff41ebd7eb$export$754b6febe722cea4) || entity?.id === (0, $bf14acff41ebd7eb$export$c88105ae160deaf9) ? 'none' : entity?.status ?? 'none';
    let statusIcon;
    const statusSize = size === 20 ? '45%' : size <= 48 ? '40%' : size <= 64 ? '30%' : '25%';
    switch(status){
        case 'inactive':
            statusIcon = (0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$db80f3ef24ef3261), {
                classes: 'Avatar-status color-fg-danger',
                size: statusSize,
                viewBox: 12,
                octicon: false
            });
            break;
        case 'out-of-office':
            statusIcon = (0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$767fa712cf880535), {
                classes: 'Avatar-status color-fg-ooo',
                size: statusSize,
                octicon: false
            });
            break;
        default:
            statusIcon = null;
    }
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span
    class="Avatar ${classes}"
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('style', fluid ? null : `width: ${size}px; height: ${size}px`)}
    >${content}${statusIcon}</span
  >`;
}
function $cdfaf3b5836da68d$export$e594fdbb182de2fb(avatar_id, size) {
    return `/image-delivery/${avatar_id}/${size}`;
}
function $cdfaf3b5836da68d$var$anonymousAvatar(size, classes = null, id = null, fluid = false) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<svg
    viewBox="0 0 16 16"
    class="${classes} color-bg-subtle color-fg-muted"
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('id', id)}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    alt="anonymous"
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('width', fluid ? null : size.toFixed())}
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('height', fluid ? null : size.toFixed())}
    style="padding: 8%"
  >
    <path
      fill-rule="evenodd"
      d="M13 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM3.022 13h9.956a.274.274 0 0 0 .014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 0 0 .022.004zm9.974.056v-.002.002zM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
    ></path>
  </svg>`;
}




function $26a15d9ae0572150$export$c5bed7b44bfbfae7(user, { avatar: renderAvatar = true, organization: organization = false, text: text = true, popoverDirection: popoverDirection = 'right', size: size = 20, project_id: project_id = null, activity_id: activity_id = null, muted: muted = false } = {}) {
    if (!user) return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="text-italic">Deleted user</span>`;
    const auser = {
        type: 'user',
        id: user.user_id,
        login: user.user_login,
        avatar_id: user.user_avatar_id,
        status: user.is_active ? user.is_ooo ? 'out-of-office' : 'none' : user.organization_id !== (0, $bf14acff41ebd7eb$export$5d44f27c7abdcda9) ? 'inactive' : 'none'
    };
    const label = user.user_login + (organization ? ` (${user.organization_login})` : '');
    const params = new URLSearchParams();
    if (project_id) params.set('project_id', project_id);
    if (activity_id) params.set('activity_id', activity_id);
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<details
    class="details-reset details-overlay position-relative d-inline-flex color-fg-default"
  >
    <summary
      class="text-bold${muted ? ' color-fg-muted' : ''}"
      aria-label="${label}"
    >
      ${renderAvatar ? (0, $cdfaf3b5836da68d$export$345c5736c8054f22)(auser, size) : null}
      <span class="Truncate${text ? '' : ' sr-only'}">
        <span class="Truncate-text d-print-none" style="max-width: 140px;"
          >${user.user_login}</span
        ><span class="Truncate-text d-screen-none" style="max-width: 140px;"
          >${user.user_name}</span
        >${organization ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="Truncate-text" style="max-width: 140px;"
                  >(${user.organization_login}</span
                >)` : ''}
      </span>
    </summary>
    <details-menu
      src="/api/organizations/${user.organization_id}/members/${user.user_id}?${params}"
      preload
      class="Popover lh-default ${popoverDirection === 'left' ? 'right-sm-0' : 'left-sm-0'}${text ? '' : popoverDirection === 'left' ? ' mr-sm-n2' : ' ml-sm-n2'}"
      style="top: 100%"
    >
      <div
        class="Popover-message Popover-message--large Popover-message--${popoverDirection === 'left' ? 'top-right' : 'top-left'} p-3 mt-sm-2 Box color-shadow-large d-flex gap-2"
      >
        <include-fragment>
          <div class="py-3 d-flex flex-justify-center">
            <div class="spinner-border f1 color-fg-muted"></div>
          </div>
        </include-fragment>
      </div>
    </details-menu>
  </details>`;
}


function $457490243c387ab4$export$4d926e2ce7d3c83d(status, classes = '') {
    return (0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $fc2f5b0b15619892$export$60edd6b2fdd9764b)[status], `color-fg-${(0, $fc2f5b0b15619892$export$6a8ec8f89e2ebfdf)[status]} ${classes}`);
}
function $457490243c387ab4$export$76dce95b982175c(status, locale) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<a
    class="State State--small ${(0, $fc2f5b0b15619892$export$b59e5e84dadfd247)[status]} d-flex flex-items-center gap-1"
    href="#activity-status-field"
    id="activity-status-label"
    activity-behavior="edit-details"
    >${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $fc2f5b0b15619892$export$60edd6b2fdd9764b)[status], 'f5')}
    ${(0, $fc2f5b0b15619892$export$db8da96cb205ed52)[status][locale]}</a
  >`;
}
function $457490243c387ab4$export$d7f64797de8530af({ locale: locale, organization_login: organization_login, status: status, visibleProperties: visibleProperties, answeredProperties: answeredProperties, parentActivity: parentActivity }) {
    const labelClass = 'Label Label--large d-flex flex-items-center gap-1';
    const labels = [
        $457490243c387ab4$export$76dce95b982175c(status, locale)
    ];
    if (visibleProperties > 0) labels.push((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span
        class="${labelClass} text-lowercase"
        id="activity-progress-label"
        >${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $e2bf3f8a63f9de76$export$3194dcd7e2b21417)(answeredProperties / visibleProperties), 'f5 color-fg-accent')}
        ${answeredProperties} of ${visibleProperties}
        ${(0, $b11db1b62d4a8f76$export$989066564c2ca33b)[locale]}</span
      >`);
    if (parentActivity) labels.push((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<a
        class="${labelClass} Link--primary"
        id="activity-parent-label"
        href="${$457490243c387ab4$export$620192cfafae60b2(parentActivity, organization_login)}"
        >${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$eebcc95f857de077), 'color-fg-accent')}<span
          class="Truncate"
          style="max-width: 12rem"
          ><span class="Truncate-text"
            >${parentActivity.title || parentActivity.definition_title}${parentActivity.subject_person_id && parentActivity.child_subject_person_id !== parentActivity.subject_person_id ? ` - ${parentActivity.subject_person_full_name}` : null}</span
          ></span
        ></a
      >`);
    return labels;
}
function $457490243c387ab4$export$50a410d93c2a929d(locale, organization_login, today, activity, isReadOnly, modalButton = true, displayPerson = false, compact = true, href) {
    const button = modalButton ? $457490243c387ab4$export$80f9f4cade29226f(locale, organization_login, activity.subject_person_id, activity.activity_id, isReadOnly) : '';
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`
    <li class="Box-row d-flex gap-2 flex-items-center">
      ${$457490243c387ab4$export$866e1de5a920f777(locale, organization_login, today, activity, compact, displayPerson, undefined, href)}
      ${button}
    </li>
  `;
}
function $457490243c387ab4$export$866e1de5a920f777(locale, organization_login, today, activity, compact, displayPerson = false, propertyValues, href = $457490243c387ab4$export$620192cfafae60b2(activity, organization_login), additionalContent) {
    const readyInProgressOnHold = [
        'ready',
        'in-progress',
        'on-hold'
    ].includes(activity.status);
    const statusTitle = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="text-bold color-fg-default"
    >${(0, $fc2f5b0b15619892$export$db8da96cb205ed52)[activity.status][locale]}</span
  >`;
    const title = activity.title.length ? `${activity.title} - ${activity.definition_title}` : activity.definition_title;
    let dateInfo;
    if ((0, $fc2f5b0b15619892$export$431862b62533b4ed)(activity.type) && (activity.flags & (0, $fc2f5b0b15619892$export$91d5aadb43f971b9).HasDueDate) > 0 && readyInProgressOnHold) {
        const due_date = new Date(activity.due_date);
        let dueDateStatusColor = 'color-fg-muted';
        if (readyInProgressOnHold && due_date <= today) dueDateStatusColor = 'color-fg-severe';
        else if (readyInProgressOnHold && due_date <= (0, $b78c044e3d911d2e$export$dd412b56f1e4d8aa)(today, 2)) dueDateStatusColor = 'color-fg-attention';
        dateInfo = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="${dueDateStatusColor}"
      >${(0, $b11db1b62d4a8f76$export$8a23b76271eff460)[locale]((0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format(new Date(activity.due_date)))}</span
    >`;
    } else dateInfo = activity.start_date === activity.end_date ? (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format(new Date(activity.start_date)) : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`${(0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format(new Date(activity.start_date))} -
          ${activity.end_date ? (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format(new Date(activity.end_date)) : (0, $b11db1b62d4a8f76$export$8227558ec81276c)[locale]}`;
    let assignee;
    if (activity.assignee_user_id) assignee = (0, $b11db1b62d4a8f76$export$16256a8f0e357bc4)[locale](compact ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<a
            href="/users/${activity.assignee_user_login}"
            class="Link--secondary text-bold"
            >${activity.assignee_user_login}
            (${activity.assignee_organization_login})</a
          >` : (0, $26a15d9ae0572150$export$c5bed7b44bfbfae7)((0, $9d0d00e92a99c512$export$6d3fb84f784b8446)(activity), {
        organization: true,
        project_id: activity.project_id,
        popoverDirection: 'left'
    }));
    else assignee = (0, $b11db1b62d4a8f76$export$16256a8f0e357bc4)[locale]((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="text-bold"
        >${activity.assignee_organization_login}</span
      >`);
    const person = displayPerson && activity.subject_person_id ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="${compact ? 'f6' : ''}"
          ><a
            class="Link--primary text-bold"
            href="/${organization_login}/people/${(0, $52ec208b1be5af58$export$7077a352e654daea)(activity.subject_person_id)}"
            >${activity.subject_person_full_name}</a
          >
          ${activity.subject_person_primary_physical?.replace(/^(, )+/g, '').replaceAll(', , ', ', ').replaceAll('  ', ' ').trim()}</span
        >` : null;
    const address = (0, $fc2f5b0b15619892$export$6d95ef8de79fb37d)(activity.type) && (activity.flags & (0, $fc2f5b0b15619892$export$91d5aadb43f971b9).HasAddresses) > 0 && activity.primary_physical ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="${compact ? 'f6' : ''}"
          >${activity.primary_physical.replace(/^(, )+/g, '').replaceAll(', , ', ', ').replaceAll('  ', ' ').trim()}</span
        >` : null;
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`
    ${$457490243c387ab4$export$4d926e2ce7d3c83d(activity.status, `f4 align-self-start${compact ? '' : ' mt-1'}`)}
    <span
      class="flex-1 d-flex flex-column gap-1 color-fg-muted flex-shrink"
      style="min-width: 0"
    >
      <span class="${compact ? 'h5' : 'h4'}">
        <a class="Link--primary" href="${href}"
          >${title} | ${activity.project_login}</a
        >
        <span class="Label color-fg-default"
          >${(0, $fc2f5b0b15619892$export$eeeefc19bf3b1d71)(locale, activity.type)}</span
        >
      </span>
      ${person}${address}
      <span class="${compact ? 'f6' : ''}">
        ${statusTitle} · ${dateInfo} · ${assignee}
      </span>
      ${!compact && (activity.comment_count || activity.attachment_count) ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="f6">
              ${activity.comment_count ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`${activity.comment_count === 1 ? (0, $b11db1b62d4a8f76$export$e0f8ffeffb71452)[locale] : (0, $b11db1b62d4a8f76$export$abf4bfeea8a809b3)[locale](activity.comment_count)}` : null}
              ${activity.comment_count && activity.attachment_count ? '-' : null}
              ${activity.attachment_count ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`${activity.attachment_count === 1 ? (0, $b11db1b62d4a8f76$export$234c584cd96079ce)[locale] : (0, $b11db1b62d4a8f76$export$dd7aa9dbdc015ba1)[locale](activity.attachment_count)}` : null}
            </span>` : null}
      ${propertyValues ? $457490243c387ab4$var$activityListItemBodyPreviewPropertiesTemplate(locale, propertyValues) : null}
      ${additionalContent}
    </span>
  `;
}
function $457490243c387ab4$var$activityListItemBodyPreviewPropertiesTemplate(_locale, propertyValues) {
    return propertyValues.length ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<div class="color-fg-default">
        ${propertyValues.map((x)=>{
        let { type: type, value: value, label: label } = x;
        if ((0, $c1de6d172f4f6f9e$export$34d61295a3a678)(x)) return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<div class="PropertyRow PropertyCell">
              <a href="${value}">${label}</a>
            </div>`;
        if (x.format === (0, $c1de6d172f4f6f9e$export$ac1cd9a3e24492e7).Time) value = (0, $b78c044e3d911d2e$export$f41928ddf8b27367)(value).value;
        return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<div
            class="PropertyRow ${x.value === 'Unanswered' ? 'color-fg-muted' : ''}"
          >
            <div class="PropertyCell">${label}</div>
            <div
              class="PropertyCell ${type === 'varcharmax' ? 'line-clamp-3' : ''}"
            >
              ${value}
            </div>
          </div>`;
    })}
      </div>` : null;
}
function $457490243c387ab4$export$620192cfafae60b2(activity, organization_login) {
    return activity.subject_person_id ? `/${organization_login}/people/${(0, $52ec208b1be5af58$export$7077a352e654daea)(activity.subject_person_id)}/activities/${(0, $52ec208b1be5af58$export$7077a352e654daea)(activity.activity_id)}` : `/${organization_login}/activities/${(0, $52ec208b1be5af58$export$7077a352e654daea)(activity.activity_id)}`;
}
function $457490243c387ab4$export$c6a9dbb9b354dbf9({ locale: locale, organization_login: organization_login, person_id: person_id, parent_activity_id: parent_activity_id, activityDefinition: activityDefinition, elementIndex: elementIndex, requiresSubmit: requiresSubmit, buttonClasses: buttonClasses }) {
    const src = (0, $fc2f5b0b15619892$export$80ddb1e8ba36c18f)({
        organization_login: organization_login,
        activityDefinition: activityDefinition,
        parent_person_id: person_id,
        parent_activity_id: parent_activity_id,
        modal: true,
        element_index: elementIndex
    });
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<modal-controller src="${src}">
    <button
      class="${buttonClasses}"
      type="button"
      ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('data-requires-submit', requiresSubmit)}
    >
      <span>${(0, $b11db1b62d4a8f76$export$baff25308003b0cc)[locale]}</span>
    </button>
    <template slot="template"><include-fragment></include-fragment></template>
  </modal-controller>`;
}
function $457490243c387ab4$export$80f9f4cade29226f(locale, organization_login, person_id, activity_id, isReadOnly, classes = '') {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<modal-controller
    src="/${organization_login}/people/${(0, $52ec208b1be5af58$export$7077a352e654daea)(person_id)}/activities/${(0, $52ec208b1be5af58$export$7077a352e654daea)(activity_id)}?modal=true"
  >
    <button class="btn btn-sm ${classes}" type="button">
      ${isReadOnly ? (0, $b11db1b62d4a8f76$export$7452b9f476cd7d5e)[locale] : (0, $b11db1b62d4a8f76$export$dad4342a62c89f83)[locale]}
    </button>
    <template slot="template">
      <include-fragment></include-fragment>
    </template>
  </modal-controller>`;
}
function $457490243c387ab4$export$385c659e35a543c6(locale, name, required, label, value) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('class', value ? null : 'text-italic color-fg-muted')}
      >${value?.title ?? (0, $b11db1b62d4a8f76$export$13ddb5340ae7eaf3)[locale]}</span
    ><input
      id="${name}"
      class="sr-only"
      type="text"
      name="${name}"
      ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
      aria-label="${label}"
      value="${value?.activity_id}"
      activity_start_date="${value?.start_date}"
      activity_end_date="${value?.end_date}"
      data-target="activity-select.input"
      data-action="focus:activity-select#inputFocused"
      tabindex="-1"
    />`;
}
function $457490243c387ab4$export$76b148a8346024c3(locale, name, required, value) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('class', value ? null : 'text-italic color-fg-muted')}
      >${value?.service_title ?? (0, $b11db1b62d4a8f76$export$13ddb5340ae7eaf3)[locale]}</span
    ><input
      id="${name}"
      class="sr-only"
      type="text"
      name="${name}"
      ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
      aria-label="${(0, $b11db1b62d4a8f76$export$f2b0a648ca23158c)[locale]}"
      value="${value?.service_authorization_id}"
      data-target="service-authorization-select.input"
      data-action="focus:service-authorization-select#inputFocused"
      tabindex="-1"
    />`;
}

var $91beb2998e956c83$export$3988ae62b71be9a3;
var $91beb2998e956c83$export$adaa4cf7ef1b65be;
var $91beb2998e956c83$export$ef7acd7185315e22;
var $91beb2998e956c83$var$hasExcape = /~/;
var $91beb2998e956c83$var$escapeMatcher = /~[01]/g;
function $91beb2998e956c83$var$escapeReplacer(m) {
    switch(m){
        case '~1':
            return '/';
        case '~0':
            return '~';
    }
    throw new Error('Invalid tilde escape: ' + m);
}
function $91beb2998e956c83$var$untilde(str) {
    if (!$91beb2998e956c83$var$hasExcape.test(str)) return str;
    return str.replace($91beb2998e956c83$var$escapeMatcher, $91beb2998e956c83$var$escapeReplacer);
}
function $91beb2998e956c83$var$setter(obj, pointer, value) {
    var part;
    var hasNextPart;
    for(var p = 1, len = pointer.length; p < len;){
        if (pointer[p] === 'constructor' || pointer[p] === 'prototype' || pointer[p] === '__proto__') return obj;
        part = $91beb2998e956c83$var$untilde(pointer[p++]);
        hasNextPart = len > p;
        if (typeof obj[part] === 'undefined') {
            // support setting of /-
            if (Array.isArray(obj) && part === '-') part = obj.length;
            // support nested objects/array when setting values
            if (hasNextPart) {
                if (pointer[p] !== '' && pointer[p] < Infinity || pointer[p] === '-') obj[part] = [];
                else obj[part] = {};
            }
        }
        if (!hasNextPart) break;
        obj = obj[part];
    }
    var oldValue = obj[part];
    if (value === undefined) delete obj[part];
    else obj[part] = value;
    return oldValue;
}
function $91beb2998e956c83$var$compilePointer(pointer) {
    if (typeof pointer === 'string') {
        pointer = pointer.split('/');
        if (pointer[0] === '') return pointer;
        throw new Error('Invalid JSON pointer.');
    } else if (Array.isArray(pointer)) {
        for (const part of pointer){
            if (typeof part !== 'string' && typeof part !== 'number') throw new Error('Invalid JSON pointer. Must be of type string or number.');
        }
        return pointer;
    }
    throw new Error('Invalid JSON pointer.');
}
function $91beb2998e956c83$var$get(obj, pointer) {
    if (typeof obj !== 'object') throw new Error('Invalid input object.');
    pointer = $91beb2998e956c83$var$compilePointer(pointer);
    var len = pointer.length;
    if (len === 1) return obj;
    for(var p = 1; p < len;){
        obj = obj[$91beb2998e956c83$var$untilde(pointer[p++])];
        if (len === p) return obj;
        if (typeof obj !== 'object' || obj === null) return undefined;
    }
}
function $91beb2998e956c83$var$set(obj, pointer, value) {
    if (typeof obj !== 'object') throw new Error('Invalid input object.');
    pointer = $91beb2998e956c83$var$compilePointer(pointer);
    if (pointer.length === 0) throw new Error('Invalid JSON pointer for set.');
    return $91beb2998e956c83$var$setter(obj, pointer, value);
}
function $91beb2998e956c83$var$compile(pointer) {
    var compiled = $91beb2998e956c83$var$compilePointer(pointer);
    return {
        get: function(object) {
            return $91beb2998e956c83$var$get(object, compiled);
        },
        set: function(object, value) {
            return $91beb2998e956c83$var$set(object, compiled, value);
        }
    };
}
$91beb2998e956c83$export$3988ae62b71be9a3 = $91beb2998e956c83$var$get;
$91beb2998e956c83$export$adaa4cf7ef1b65be = $91beb2998e956c83$var$set;
$91beb2998e956c83$export$ef7acd7185315e22 = $91beb2998e956c83$var$compile;


const $3ed036a8a521a6d8$var$suspectRx = /"(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])"\s*:/;
function $3ed036a8a521a6d8$export$98e6a39c04603d36(text, ...args) {
    // Normalize arguments
    const firstOptions = typeof args[0] === 'object' && args[0];
    const reviver = args.length > 1 || !firstOptions ? args[0] : undefined;
    const options = args.length > 1 && args[1] || firstOptions || {};
    // Parse normally, allowing exceptions
    const obj = JSON.parse(text, reviver);
    // options.protoAction: 'error' (default) / 'remove' / 'ignore'
    if (options.protoAction === 'ignore') return obj;
    // Ignore null and non-objects
    if (!obj || typeof obj !== 'object') return obj;
    // Check original string for potential exploit
    if (!$3ed036a8a521a6d8$var$suspectRx.test(text)) return obj;
    // Scan result for proto keys
    $3ed036a8a521a6d8$export$c87d910e63d22ed6(obj, options);
    return obj;
}
function $3ed036a8a521a6d8$export$c87d910e63d22ed6(obj, options = {}) {
    let next = [
        obj
    ];
    while(next.length){
        const nodes = next;
        next = [];
        for (const node of nodes){
            if (Object.hasOwn(node, '__proto__')) {
                if (options.protoAction !== 'remove') throw new SyntaxError('Object contains forbidden prototype property');
                delete node.__proto__;
            }
            for(const key in node){
                const value = node[key];
                if (value && typeof value === 'object') next.push(node[key]);
            }
        }
    }
}
function $3ed036a8a521a6d8$export$b48ee232557adc37(text, reviver) {
    try {
        return $3ed036a8a521a6d8$export$98e6a39c04603d36(text, reviver);
    } catch  {
        return null;
    }
}






/**
 * @implements {IHooks}
 */ class $cec7b3c0f35c015b$var$Hooks {
    /**
	 * @callback HookCallback
	 * @this {*|Jsep} this
	 * @param {Jsep} env
	 * @returns: void
	 */ /**
	 * Adds the given callback to the list of callbacks for the given hook.
	 *
	 * The callback will be invoked when the hook it is registered for is run.
	 *
	 * One callback function can be registered to multiple hooks and the same hook multiple times.
	 *
	 * @param {string|object} name The name of the hook, or an object of callbacks keyed by name
	 * @param {HookCallback|boolean} callback The callback function which is given environment variables.
	 * @param {?boolean} [first=false] Will add the hook to the top of the list (defaults to the bottom)
	 * @public
	 */ add(name, callback, first) {
        if (typeof arguments[0] != 'string') // Multiple hook callbacks, keyed by name
        for(let name in arguments[0])this.add(name, arguments[0][name], arguments[1]);
        else (Array.isArray(name) ? name : [
            name
        ]).forEach(function(name) {
            this[name] = this[name] || [];
            if (callback) this[name][first ? 'unshift' : 'push'](callback);
        }, this);
    }
    /**
	 * Runs a hook invoking all registered callbacks with the given environment variables.
	 *
	 * Callbacks will be invoked synchronously and in the order in which they were registered.
	 *
	 * @param {string} name The name of the hook.
	 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
	 * @public
	 */ run(name, env) {
        this[name] = this[name] || [];
        this[name].forEach(function(callback) {
            callback.call(env && env.context ? env.context : env, env);
        });
    }
}
/**
 * @implements {IPlugins}
 */ class $cec7b3c0f35c015b$var$Plugins {
    constructor(jsep){
        this.jsep = jsep;
        this.registered = {};
    }
    /**
	 * @callback PluginSetup
	 * @this {Jsep} jsep
	 * @returns: void
	 */ /**
	 * Adds the given plugin(s) to the registry
	 *
	 * @param {object} plugins
	 * @param {string} plugins.name The name of the plugin
	 * @param {PluginSetup} plugins.init The init function
	 * @public
	 */ register(...plugins) {
        plugins.forEach((plugin)=>{
            if (typeof plugin !== 'object' || !plugin.name || !plugin.init) throw new Error('Invalid JSEP plugin format');
            if (this.registered[plugin.name]) // already registered. Ignore.
            return;
            plugin.init(this.jsep);
            this.registered[plugin.name] = plugin;
        });
    }
}
//     JavaScript Expression Parser (JSEP) 1.6.0
//     JSEP may be freely distributed under the MIT License
//     https://ericsmekens.github.io/jsep/
class $cec7b3c0f35c015b$export$90f6e7cc0133c961 {
    /**
	 * @returns {string}
	 */ static get version() {
        // To be filled in by the template
        return '1.6.0';
    }
    /**
	 * @returns {string}
	 */ static toString() {
        return 'JavaScript Expression Parser (JSEP) v' + $cec7b3c0f35c015b$export$90f6e7cc0133c961.version;
    }
    // ==================== CONFIG ================================
    /**
	 * @method addUnaryOp
	 * @param {string} op_name The name of the unary op to add
	 * @returns {Jsep}
	 */ static addUnaryOp(op_name) {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len = Math.max(op_name.length, $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len);
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.unary_ops[op_name] = 1;
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method jsep.addBinaryOp
	 * @param {string} op_name The name of the binary op to add
	 * @param {number} precedence The precedence of the binary op (can be a float). Higher number = higher precedence
	 * @param {boolean} [isRightAssociative=false] whether operator is right-associative
	 * @returns {Jsep}
	 */ static addBinaryOp(op_name, precedence, isRightAssociative) {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len = Math.max(op_name.length, $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len);
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops[op_name] = precedence;
        if (isRightAssociative) $cec7b3c0f35c015b$export$90f6e7cc0133c961.right_associative.add(op_name);
        else $cec7b3c0f35c015b$export$90f6e7cc0133c961.right_associative.delete(op_name);
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method addIdentifierChar
	 * @param {string} char The additional character to treat as a valid part of an identifier
	 * @returns {Jsep}
	 */ static addIdentifierChar(char) {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.additional_identifier_chars.add(char);
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method addLiteral
	 * @param {string} literal_name The name of the literal to add
	 * @param {*} literal_value The value of the literal
	 * @returns {Jsep}
	 */ static addLiteral(literal_name, literal_value) {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.literals[literal_name] = literal_value;
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeUnaryOp
	 * @param {string} op_name The name of the unary op to remove
	 * @returns {Jsep}
	 */ static removeUnaryOp(op_name) {
        delete $cec7b3c0f35c015b$export$90f6e7cc0133c961.unary_ops[op_name];
        if (op_name.length === $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len) $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len = $cec7b3c0f35c015b$export$90f6e7cc0133c961.getMaxKeyLen($cec7b3c0f35c015b$export$90f6e7cc0133c961.unary_ops);
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeAllUnaryOps
	 * @returns {Jsep}
	 */ static removeAllUnaryOps() {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.unary_ops = {};
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len = 0;
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeIdentifierChar
	 * @param {string} char The additional character to stop treating as a valid part of an identifier
	 * @returns {Jsep}
	 */ static removeIdentifierChar(char) {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.additional_identifier_chars.delete(char);
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeBinaryOp
	 * @param {string} op_name The name of the binary op to remove
	 * @returns {Jsep}
	 */ static removeBinaryOp(op_name) {
        delete $cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops[op_name];
        if (op_name.length === $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len) $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len = $cec7b3c0f35c015b$export$90f6e7cc0133c961.getMaxKeyLen($cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops);
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.right_associative.delete(op_name);
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeAllBinaryOps
	 * @returns {Jsep}
	 */ static removeAllBinaryOps() {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops = {};
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len = 0;
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeLiteral
	 * @param {string} literal_name The name of the literal to remove
	 * @returns {Jsep}
	 */ static removeLiteral(literal_name) {
        delete $cec7b3c0f35c015b$export$90f6e7cc0133c961.literals[literal_name];
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeAllLiterals
	 * @returns {Jsep}
	 */ static removeAllLiterals() {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.literals = {};
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    // ==================== END CONFIG ============================
    /**
	 * @returns {string}
	 */ get char() {
        return this.expr.charAt(this.index);
    }
    /**
	 * @returns {number}
	 */ get code() {
        return this.expr.charCodeAt(this.index);
    }
    /**
	 * @param {string} expr a string with the passed in express
	 * @returns Jsep
	 */ constructor(expr){
        // `index` stores the character number we are currently at
        // All of the gobbles below will modify `index` as we move along
        this.expr = expr;
        this.index = 0;
    }
    /**
	 * static top-level parser
	 * @returns {jsep.Expression}
	 */ static parse(expr) {
        return new $cec7b3c0f35c015b$export$90f6e7cc0133c961(expr).parse();
    }
    /**
	 * Get the longest key length of any object
	 * @param {object} obj
	 * @returns {number}
	 */ static getMaxKeyLen(obj) {
        return Math.max(0, ...Object.keys(obj).map((k)=>k.length));
    }
    /**
	 * `ch` is a character code in the next three functions
	 * @param {number} ch
	 * @returns {boolean}
	 */ static isDecimalDigit(ch) {
        return ch >= 48 && ch <= 57; // 0...9
    }
    /**
	 * Returns the precedence of a binary operator or `0` if it isn't a binary operator. Can be float.
	 * @param {string} op_val
	 * @returns {number}
	 */ static binaryPrecedence(op_val) {
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops[op_val] || 0;
    }
    /**
	 * Looks for start of identifier
	 * @param {number} ch
	 * @returns {boolean}
	 */ static isIdentifierStart(ch) {
        return ch >= 65 && ch <= 90 || // A...Z
        ch >= 97 && ch <= 122 || // a...z
        ch >= 128 && !$cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops[String.fromCharCode(ch)] || // any non-ASCII that is not an operator
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.additional_identifier_chars.has(String.fromCharCode(ch)); // additional characters
    }
    /**
	 * @param {number} ch
	 * @returns {boolean}
	 */ static isIdentifierPart(ch) {
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierStart(ch) || $cec7b3c0f35c015b$export$90f6e7cc0133c961.isDecimalDigit(ch);
    }
    /**
	 * throw error at index of the expression
	 * @param {string} message
	 * @throws
	 */ throwError(message) {
        const error = new Error(message + ' at character ' + this.index);
        error.index = this.index;
        error.description = message;
        throw error;
    }
    /**
	 * Run a given hook
	 * @param {string} name
	 * @param {jsep.Expression|false} [node]
	 * @returns {?jsep.Expression}
	 */ runHook(name, node) {
        if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.hooks[name]) {
            const env = {
                context: this,
                node: node
            };
            $cec7b3c0f35c015b$export$90f6e7cc0133c961.hooks.run(name, env);
            return env.node;
        }
        return node;
    }
    /**
	 * Runs a given hook until one returns a node
	 * @param {string} name
	 * @returns {?jsep.Expression}
	 */ searchHook(name) {
        if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.hooks[name]) {
            const env = {
                context: this
            };
            $cec7b3c0f35c015b$export$90f6e7cc0133c961.hooks[name].find(function(callback) {
                callback.call(env.context, env);
                return env.node;
            });
            return env.node;
        }
    }
    /**
	 * Push `index` up to the next non-space character
	 */ gobbleSpaces() {
        let ch = this.code;
        // Whitespace
        while(ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.SPACE_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.TAB_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.LF_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.CR_CODE)ch = this.expr.charCodeAt(++this.index);
        this.runHook('gobble-spaces');
    }
    /**
	 * Top-level method to parse all expressions and returns compound or single node
	 * @returns {jsep.Expression}
	 */ parse() {
        this.runHook('before-all');
        const nodes = this.gobbleExpressions();
        // If there's only one expression just try returning the expression
        const node = nodes.length === 1 ? nodes[0] : {
            type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.COMPOUND,
            body: nodes
        };
        return this.runHook('after-all', node);
    }
    /**
	 * top-level parser (but can be reused within as well)
	 * @param {number} [untilICode]
	 * @returns {jsep.Expression[]}
	 */ gobbleExpressions(untilICode) {
        let nodes = [], ch_i, node;
        while(this.index < this.expr.length){
            ch_i = this.code;
            // Expressions can be separated by semicolons, commas, or just inferred without any
            // separators
            if (ch_i === $cec7b3c0f35c015b$export$90f6e7cc0133c961.SEMCOL_CODE || ch_i === $cec7b3c0f35c015b$export$90f6e7cc0133c961.COMMA_CODE) this.index++; // ignore separators
            else {
                // Try to gobble each expression individually
                if (node = this.gobbleExpression()) nodes.push(node);
                else if (this.index < this.expr.length) {
                    if (ch_i === untilICode) break;
                    this.throwError('Unexpected "' + this.char + '"');
                }
            }
        }
        return nodes;
    }
    /**
	 * The main parsing function.
	 * @returns {?jsep.Expression}
	 */ gobbleExpression() {
        const node = this.searchHook('gobble-expression') || this.gobbleBinaryExpression();
        this.gobbleSpaces();
        return this.runHook('after-expression', node);
    }
    /**
	 * Search for the operation portion of the string (e.g. `+`, `===`)
	 * Start by taking the longest possible binary operations (3 characters: `===`, `!==`, `>>>`)
	 * and move down from 3 to 2 to 1 character until a matching binary operation is found
	 * then, return that binary operation
	 * @returns {string|boolean}
	 */ gobbleBinaryOp() {
        this.gobbleSpaces();
        let to_check = this.expr.substr(this.index, $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len);
        let tc_len = to_check.length;
        while(tc_len > 0){
            // Don't accept a binary op when it is an identifier.
            // Binary ops that start with a identifier-valid character must be followed
            // by a non identifier-part valid character
            if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops.hasOwnProperty(to_check) && (!$cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierStart(this.code) || this.index + to_check.length < this.expr.length && !$cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierPart(this.expr.charCodeAt(this.index + to_check.length)))) {
                this.index += tc_len;
                return to_check;
            }
            to_check = to_check.substr(0, --tc_len);
        }
        return false;
    }
    /**
	 * This function is responsible for gobbling an individual expression,
	 * e.g. `1`, `1+2`, `a+(b*2)-Math.sqrt(2)`
	 * @returns {?jsep.BinaryExpression}
	 */ gobbleBinaryExpression() {
        let node, biop, prec, stack, biop_info, left, right, i, cur_biop;
        // First, try to get the leftmost thing
        // Then, check to see if there's a binary operator operating on that leftmost thing
        // Don't gobbleBinaryOp without a left-hand-side
        left = this.gobbleToken();
        if (!left) return left;
        biop = this.gobbleBinaryOp();
        // If there wasn't a binary operator, just return the leftmost node
        if (!biop) return left;
        // Otherwise, we need to start a stack to properly place the binary operations in their
        // precedence structure
        biop_info = {
            value: biop,
            prec: $cec7b3c0f35c015b$export$90f6e7cc0133c961.binaryPrecedence(biop),
            right_a: $cec7b3c0f35c015b$export$90f6e7cc0133c961.right_associative.has(biop)
        };
        right = this.gobbleToken();
        if (!right) this.throwError("Expected expression after " + biop);
        stack = [
            left,
            biop_info,
            right
        ];
        // Properly deal with precedence using [recursive descent](http://www.engr.mun.ca/~theo/Misc/exp_parsing.htm)
        while(biop = this.gobbleBinaryOp()){
            prec = $cec7b3c0f35c015b$export$90f6e7cc0133c961.binaryPrecedence(biop);
            if (prec === 0) {
                this.index -= biop.length;
                break;
            }
            biop_info = {
                value: biop,
                prec: prec,
                right_a: $cec7b3c0f35c015b$export$90f6e7cc0133c961.right_associative.has(biop)
            };
            cur_biop = biop;
            // Reduce: make a binary expression from the three topmost entries.
            const comparePrev = (prev)=>biop_info.right_a && prev.right_a ? prec > prev.prec : prec <= prev.prec;
            while(stack.length > 2 && comparePrev(stack[stack.length - 2])){
                right = stack.pop();
                biop = stack.pop().value;
                left = stack.pop();
                node = {
                    type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.BINARY_EXP,
                    operator: biop,
                    left: left,
                    right: right
                };
                stack.push(node);
            }
            node = this.gobbleToken();
            if (!node) this.throwError("Expected expression after " + cur_biop);
            stack.push(biop_info, node);
        }
        i = stack.length - 1;
        node = stack[i];
        while(i > 1){
            node = {
                type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.BINARY_EXP,
                operator: stack[i - 1].value,
                left: stack[i - 2],
                right: node
            };
            i -= 2;
        }
        return node;
    }
    /**
	 * An individual part of a binary expression:
	 * e.g. `foo.bar(baz)`, `1`, `"abc"`, `(a % 2)` (because it's in parenthesis)
	 * @returns {boolean|jsep.Expression}
	 */ gobbleToken() {
        let ch, to_check, tc_len, node;
        this.gobbleSpaces();
        node = this.searchHook('gobble-token');
        if (node) return this.runHook('after-token', node);
        ch = this.code;
        if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.isDecimalDigit(ch) || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE) // Char code 46 is a dot `.` which can start off a numeric literal
        return this.gobbleNumericLiteral();
        if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.SQUOTE_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.DQUOTE_CODE) // Single or double quotes
        node = this.gobbleStringLiteral();
        else if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.OBRACK_CODE) node = this.gobbleArray();
        else {
            to_check = this.expr.substr(this.index, $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len);
            tc_len = to_check.length;
            while(tc_len > 0){
                // Don't accept an unary op when it is an identifier.
                // Unary ops that start with a identifier-valid character must be followed
                // by a non identifier-part valid character
                if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.unary_ops.hasOwnProperty(to_check) && (!$cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierStart(this.code) || this.index + to_check.length < this.expr.length && !$cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierPart(this.expr.charCodeAt(this.index + to_check.length)))) {
                    this.index += tc_len;
                    const argument = this.gobbleToken();
                    if (!argument) this.throwError('missing unaryOp argument');
                    return this.runHook('after-token', {
                        type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.UNARY_EXP,
                        operator: to_check,
                        argument: argument,
                        prefix: true
                    });
                }
                to_check = to_check.substr(0, --tc_len);
            }
            if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierStart(ch)) {
                node = this.gobbleIdentifier();
                if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.literals.hasOwnProperty(node.name)) node = {
                    type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.LITERAL,
                    value: $cec7b3c0f35c015b$export$90f6e7cc0133c961.literals[node.name],
                    raw: node.name
                };
                else if (node.name === $cec7b3c0f35c015b$export$90f6e7cc0133c961.this_str) node = {
                    type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.THIS_EXP
                };
            } else if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.OPAREN_CODE) node = this.gobbleGroup();
        }
        if (!node) return this.runHook('after-token', false);
        node = this.gobbleTokenProperty(node);
        return this.runHook('after-token', node);
    }
    /**
	 * Gobble properties of of identifiers/strings/arrays/groups.
	 * e.g. `foo`, `bar.baz`, `foo['bar'].baz`
	 * It also gobbles function calls:
	 * e.g. `Math.acos(obj.angle)`
	 * @param {jsep.Expression} node
	 * @returns {jsep.Expression}
	 */ gobbleTokenProperty(node) {
        this.gobbleSpaces();
        let ch = this.code;
        while(ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.OBRACK_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.OPAREN_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.QUMARK_CODE){
            let optional;
            if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.QUMARK_CODE) {
                if (this.expr.charCodeAt(this.index + 1) !== $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE) break;
                optional = true;
                this.index += 2;
                this.gobbleSpaces();
                ch = this.code;
            }
            this.index++;
            if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.OBRACK_CODE) {
                node = {
                    type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.MEMBER_EXP,
                    computed: true,
                    object: node,
                    property: this.gobbleExpression()
                };
                if (!node.property) this.throwError('Unexpected "' + this.char + '"');
                this.gobbleSpaces();
                ch = this.code;
                if (ch !== $cec7b3c0f35c015b$export$90f6e7cc0133c961.CBRACK_CODE) this.throwError('Unclosed [');
                this.index++;
            } else if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.OPAREN_CODE) // A function call is being made; gobble all the arguments
            node = {
                type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.CALL_EXP,
                'arguments': this.gobbleArguments($cec7b3c0f35c015b$export$90f6e7cc0133c961.CPAREN_CODE),
                callee: node
            };
            else if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE || optional) {
                if (optional) this.index--;
                this.gobbleSpaces();
                node = {
                    type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.MEMBER_EXP,
                    computed: false,
                    object: node,
                    property: this.gobbleIdentifier()
                };
            }
            if (optional) node.optional = true;
             // else leave undefined for compatibility with esprima
            this.gobbleSpaces();
            ch = this.code;
        }
        return node;
    }
    /**
	 * Parse simple numeric literals: `12`, `3.4`, `.5`. Do this by using a string to
	 * keep track of everything in the numeric literal and then calling `parseFloat` on that string
	 * @returns {jsep.Literal}
	 */ gobbleNumericLiteral() {
        let number = '', ch, chCode;
        while($cec7b3c0f35c015b$export$90f6e7cc0133c961.isDecimalDigit(this.code))number += this.expr.charAt(this.index++);
        if (this.code === $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE) {
            number += this.expr.charAt(this.index++);
            while($cec7b3c0f35c015b$export$90f6e7cc0133c961.isDecimalDigit(this.code))number += this.expr.charAt(this.index++);
        }
        ch = this.char;
        if (ch === 'e' || ch === 'E') {
            number += this.expr.charAt(this.index++);
            ch = this.char;
            if (ch === '+' || ch === '-') number += this.expr.charAt(this.index++);
            while($cec7b3c0f35c015b$export$90f6e7cc0133c961.isDecimalDigit(this.code))number += this.expr.charAt(this.index++);
            if (!$cec7b3c0f35c015b$export$90f6e7cc0133c961.isDecimalDigit(this.expr.charCodeAt(this.index - 1))) this.throwError('Expected exponent (' + number + this.char + ')');
        }
        chCode = this.code;
        // Check to make sure this isn't a variable name that start with a number (123abc)
        if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierStart(chCode)) this.throwError('Variable names cannot start with a number (' + number + this.char + ')');
        else if (chCode === $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE || number.length === 1 && number.charCodeAt(0) === $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE) this.throwError('Unexpected period');
        return {
            type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.LITERAL,
            value: parseFloat(number),
            raw: number
        };
    }
    /**
	 * Parses a string literal, staring with single or double quotes with basic support for escape codes
	 * e.g. `"hello world"`, `'this is\nJSEP'`
	 * @returns {jsep.Literal}
	 */ gobbleStringLiteral() {
        let str = '';
        const startIndex = this.index;
        const quote = this.expr.charAt(this.index++);
        let closed = false;
        while(this.index < this.expr.length){
            let ch = this.expr.charAt(this.index++);
            if (ch === quote) {
                closed = true;
                break;
            } else if (ch === '\\') {
                // Check for all of the common escape codes
                ch = this.expr.charAt(this.index++);
                switch(ch){
                    case 'n':
                        str += '\n';
                        break;
                    case 'r':
                        str += '\r';
                        break;
                    case 't':
                        str += '\t';
                        break;
                    case 'b':
                        str += '\b';
                        break;
                    case 'f':
                        str += '\f';
                        break;
                    case 'v':
                        str += '\x0B';
                        break;
                    default:
                        str += ch;
                }
            } else str += ch;
        }
        if (!closed) this.throwError('Unclosed quote after "' + str + '"');
        return {
            type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.LITERAL,
            value: str,
            raw: this.expr.substring(startIndex, this.index)
        };
    }
    /**
	 * Gobbles only identifiers
	 * e.g.: `foo`, `_value`, `$x1`
	 * Also, this function checks if that identifier is a literal:
	 * (e.g. `true`, `false`, `null`) or `this`
	 * @returns {jsep.Identifier}
	 */ gobbleIdentifier() {
        let ch = this.code, start = this.index;
        if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierStart(ch)) this.index++;
        else this.throwError('Unexpected ' + this.char);
        while(this.index < this.expr.length){
            ch = this.code;
            if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierPart(ch)) this.index++;
            else break;
        }
        return {
            type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.IDENTIFIER,
            name: this.expr.slice(start, this.index)
        };
    }
    /**
	 * Gobbles a list of arguments within the context of a function call
	 * or array literal. This function also assumes that the opening character
	 * `(` or `[` has already been gobbled, and gobbles expressions and commas
	 * until the terminator character `)` or `]` is encountered.
	 * e.g. `foo(bar, baz)`, `my_func()`, or `[bar, baz]`
	 * @param {number} termination
	 * @returns {jsep.Expression[]}
	 */ gobbleArguments(termination) {
        const args = [];
        let closed = false;
        let separator_count = 0;
        while(this.index < this.expr.length){
            this.gobbleSpaces();
            let ch_i = this.code;
            if (ch_i === termination) {
                closed = true;
                this.index++;
                if (termination === $cec7b3c0f35c015b$export$90f6e7cc0133c961.CPAREN_CODE && separator_count && separator_count >= args.length) this.throwError('Unexpected token ' + String.fromCharCode(termination));
                break;
            } else if (ch_i === $cec7b3c0f35c015b$export$90f6e7cc0133c961.COMMA_CODE) {
                this.index++;
                separator_count++;
                if (separator_count !== args.length) {
                    if (termination === $cec7b3c0f35c015b$export$90f6e7cc0133c961.CPAREN_CODE) this.throwError('Unexpected token ,');
                    else if (termination === $cec7b3c0f35c015b$export$90f6e7cc0133c961.CBRACK_CODE) for(let arg = args.length; arg < separator_count; arg++)args.push(null);
                }
            } else if (args.length !== separator_count && separator_count !== 0) // NOTE: `&& separator_count !== 0` allows for either all commas, or all spaces as arguments
            this.throwError('Expected comma');
            else {
                const node = this.gobbleExpression();
                if (!node || node.type === $cec7b3c0f35c015b$export$90f6e7cc0133c961.COMPOUND) this.throwError('Expected comma');
                args.push(node);
            }
        }
        if (!closed) this.throwError('Expected ' + String.fromCharCode(termination));
        return args;
    }
    /**
	 * Responsible for parsing a group of things within parentheses `()`
	 * that have no identifier in front (so not a function call)
	 * This function assumes that it needs to gobble the opening parenthesis
	 * and then tries to gobble everything within that parenthesis, assuming
	 * that the next thing it should see is the close parenthesis. If not,
	 * then the expression probably doesn't have a `)`
	 * @returns {boolean|jsep.Expression}
	 */ gobbleGroup() {
        this.index++;
        let nodes = this.gobbleExpressions($cec7b3c0f35c015b$export$90f6e7cc0133c961.CPAREN_CODE);
        if (this.code === $cec7b3c0f35c015b$export$90f6e7cc0133c961.CPAREN_CODE) {
            this.index++;
            if (nodes.length === 1) return nodes[0];
            else if (!nodes.length) return false;
            else return {
                type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.SEQUENCE_EXP,
                expressions: nodes
            };
        } else this.throwError('Unclosed (');
    }
    /**
	 * Responsible for parsing Array literals `[1, 2, 3]`
	 * This function assumes that it needs to gobble the opening bracket
	 * and then tries to gobble the expressions as arguments.
	 * @returns {jsep.ArrayExpression}
	 */ gobbleArray() {
        this.index++;
        return {
            type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.ARRAY_EXP,
            elements: this.gobbleArguments($cec7b3c0f35c015b$export$90f6e7cc0133c961.CBRACK_CODE)
        };
    }
}
// Static fields:
const $cec7b3c0f35c015b$var$hooks = new $cec7b3c0f35c015b$var$Hooks();
Object.assign($cec7b3c0f35c015b$export$90f6e7cc0133c961, {
    hooks: $cec7b3c0f35c015b$var$hooks,
    plugins: new $cec7b3c0f35c015b$var$Plugins($cec7b3c0f35c015b$export$90f6e7cc0133c961),
    // Node Types
    // ----------
    // This is the full set of types that any JSEP node can be.
    // Store them here to save space when minified
    COMPOUND: 'Compound',
    SEQUENCE_EXP: 'SequenceExpression',
    IDENTIFIER: 'Identifier',
    MEMBER_EXP: 'MemberExpression',
    LITERAL: 'Literal',
    THIS_EXP: 'ThisExpression',
    CALL_EXP: 'CallExpression',
    UNARY_EXP: 'UnaryExpression',
    BINARY_EXP: 'BinaryExpression',
    ARRAY_EXP: 'ArrayExpression',
    TAB_CODE: 9,
    LF_CODE: 10,
    CR_CODE: 13,
    SPACE_CODE: 32,
    PERIOD_CODE: 46,
    COMMA_CODE: 44,
    SQUOTE_CODE: 39,
    DQUOTE_CODE: 34,
    OPAREN_CODE: 40,
    CPAREN_CODE: 41,
    OBRACK_CODE: 91,
    CBRACK_CODE: 93,
    QUMARK_CODE: 63,
    SEMCOL_CODE: 59,
    COLON_CODE: 58,
    // Operations
    // ----------
    // Use a quickly-accessible map to store all of the unary operators
    // Values are set to `1` (it really doesn't matter)
    unary_ops: {
        '-': 1,
        '!': 1,
        '~': 1,
        '+': 1
    },
    // Also use a map for the binary operations but set their values to their
    // binary precedence for quick reference (higher number = higher precedence)
    // see [Order of operations](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Operator_Precedence)
    binary_ops: {
        '||': 1,
        '??': 1,
        '&&': 2,
        '|': 3,
        '^': 4,
        '&': 5,
        '==': 6,
        '!=': 6,
        '===': 6,
        '!==': 6,
        '<': 7,
        '>': 7,
        '<=': 7,
        '>=': 7,
        '<<': 8,
        '>>': 8,
        '>>>': 8,
        '+': 9,
        '-': 9,
        '*': 10,
        '/': 10,
        '%': 10,
        '**': 11
    },
    // sets specific binary_ops as right-associative
    right_associative: new Set([
        '**'
    ]),
    // Additional valid identifier chars, apart from a-z, A-Z and 0-9 (except on the starting char)
    additional_identifier_chars: new Set([
        '$',
        '_'
    ]),
    // Literals
    // ----------
    // Store the values to return for the various literals we may encounter
    literals: {
        'true': true,
        'false': false,
        'null': null
    },
    // Except for `this`, which is special. This could be changed to something like `'self'` as well
    this_str: 'this'
});
$cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len = $cec7b3c0f35c015b$export$90f6e7cc0133c961.getMaxKeyLen($cec7b3c0f35c015b$export$90f6e7cc0133c961.unary_ops);
$cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len = $cec7b3c0f35c015b$export$90f6e7cc0133c961.getMaxKeyLen($cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops);
// Backward Compatibility:
const $cec7b3c0f35c015b$export$2e2bcd8739ae039 = (expr)=>new $cec7b3c0f35c015b$export$90f6e7cc0133c961(expr).parse();
const $cec7b3c0f35c015b$var$stdClassProps = Object.getOwnPropertyNames(class Test {
});
Object.getOwnPropertyNames($cec7b3c0f35c015b$export$90f6e7cc0133c961).filter((prop)=>!$cec7b3c0f35c015b$var$stdClassProps.includes(prop) && $cec7b3c0f35c015b$export$2e2bcd8739ae039[prop] === undefined).forEach((m)=>{
    $cec7b3c0f35c015b$export$2e2bcd8739ae039[m] = $cec7b3c0f35c015b$export$90f6e7cc0133c961[m];
});
$cec7b3c0f35c015b$export$2e2bcd8739ae039.Jsep = $cec7b3c0f35c015b$export$90f6e7cc0133c961; // allows for const { Jsep } = require('jsep');
const $cec7b3c0f35c015b$var$CONDITIONAL_EXP = 'ConditionalExpression';
var $cec7b3c0f35c015b$var$ternary = {
    name: 'ternary',
    init (jsep) {
        // Ternary expression: test ? consequent : alternate
        jsep.hooks.add('after-expression', function gobbleTernary(env) {
            if (env.node && this.code === jsep.QUMARK_CODE) {
                this.index++;
                const test = env.node;
                const consequent = this.gobbleExpression();
                if (!consequent) this.throwError('Expected expression');
                this.gobbleSpaces();
                if (this.code === jsep.COLON_CODE) {
                    this.index++;
                    const alternate = this.gobbleExpression();
                    if (!alternate) this.throwError('Expected expression');
                    env.node = {
                        type: $cec7b3c0f35c015b$var$CONDITIONAL_EXP,
                        test: test,
                        consequent: consequent,
                        alternate: alternate
                    };
                    // check for operators of higher priority than ternary (i.e. assignment)
                    // jsep sets || at 1, and assignment at 0.9, and conditional should be between them
                    if (test.operator && jsep.binary_ops[test.operator] <= 0.9) {
                        let newTest = test;
                        while(newTest.right.operator && jsep.binary_ops[newTest.right.operator] <= 0.9)newTest = newTest.right;
                        env.node.test = newTest.right;
                        newTest.right = env.node;
                        env.node = test;
                    }
                } else this.throwError('Expected :');
            }
        });
    }
};
// Add default plugins:
$cec7b3c0f35c015b$export$2e2bcd8739ae039.plugins.register($cec7b3c0f35c015b$var$ternary);




const $6d4649a4b0d9f10a$var$expressionReturnTypes = [
    'boolean',
    'date',
    'datetime',
    'int',
    'decimal',
    'string'
];
function $6d4649a4b0d9f10a$export$b6b5b1f15bbc92d6(value) {
    return $6d4649a4b0d9f10a$var$expressionReturnTypes.includes(value);
}
const $6d4649a4b0d9f10a$export$3b8a04534ed45870 = {
    boolean: [
        'boolean'
    ],
    date: [
        'datetime',
        'date'
    ],
    datetime: [
        'datetime',
        'date'
    ],
    int: [
        'decimal',
        'int'
    ],
    decimal: [
        'decimal',
        'int'
    ],
    string: [
        'string'
    ]
};
const $6d4649a4b0d9f10a$export$aa217010c5d1d474 = {
    boolean: [
        'bit'
    ],
    date: [
        'date'
    ],
    datetime: [
        'date'
    ],
    int: [
        'int',
        'currency',
        'decimal'
    ],
    decimal: [
        'decimal',
        'currency'
    ],
    string: [
        'varchar100',
        'varcharmax'
    ]
};
function $6d4649a4b0d9f10a$export$966a32651da2813f({ value: value }) {
    if (typeof value === 'boolean') return 'boolean';
    if (typeof value === 'number') return Number.isInteger(value) ? 'int' : 'decimal';
    if (typeof value === 'string') return 'string';
    return null;
}
function $6d4649a4b0d9f10a$export$ac328571283a1f88(expression) {
    try {
        return {
            valid: true,
            node: (0, $cec7b3c0f35c015b$export$2e2bcd8739ae039)(expression)
        };
    } catch (e) {
        if (e instanceof Error && 'description' in e && typeof e.description === 'string' && 'index' in e && typeof e.index === 'number') return {
            valid: false,
            reason: e.description
        };
        return {
            valid: false,
            reason: `Invalid expression "${expression}"`
        };
    }
}
function $6d4649a4b0d9f10a$var$parenthesize(node, ancestors, opts) {
    const precedence = {
        '!': 14,
        '*': 12,
        '/': 12,
        '%': 12,
        '+': 11,
        '-': 11,
        '>': 9,
        '<': 9,
        '>=': 9,
        '<=': 9,
        '==': 8,
        '!=': 8,
        '&&': 4,
        '||': 3
    };
    const printed = $6d4649a4b0d9f10a$export$8fc0a65b8428632a(node, ancestors, opts);
    const parent = ancestors[0];
    if (!parent) return printed;
    if (node.type === 'BinaryExpression' && (parent.type === 'BinaryExpression' || parent.type === 'UnaryExpression') && precedence[node.operator] < precedence[parent.operator] || node.type === 'BinaryExpression' && parent.type === 'BinaryExpression' && (parent.operator === '/' || parent.operator === '%') && parent.right === node && precedence[node.operator] <= precedence[parent.operator]) return `(${printed})`;
    return printed;
}
function $6d4649a4b0d9f10a$export$6d3f45a3236b671b(calleeName, ...args) {
    return `${calleeName}(${args.join(', ')})`;
}
function $6d4649a4b0d9f10a$export$8fc0a65b8428632a(node, ancestors = [], { printIdentifier: printIdentifier = (node)=>node.name.toUpperCase(), printLiteral: printLiteral = (node)=>typeof node.value === 'string' ? `'${node.value.replaceAll(`'`, `\\'`)}'` : node.value.toString(), wrapDenominator: wrapDenominator = (printed)=>printed, printCallExpression: printCallExpression = $6d4649a4b0d9f10a$export$6d3f45a3236b671b } = {}) {
    switch(node.type){
        case 'BinaryExpression':
            {
                const { left: left, right: right, operator: operator } = node;
                const leftResult = $6d4649a4b0d9f10a$var$parenthesize(left, [
                    node,
                    ...ancestors
                ], {
                    printIdentifier: printIdentifier,
                    printLiteral: printLiteral,
                    wrapDenominator: wrapDenominator,
                    printCallExpression: printCallExpression
                });
                const rightResult = $6d4649a4b0d9f10a$var$parenthesize(right, [
                    node,
                    ...ancestors
                ], {
                    printIdentifier: printIdentifier,
                    printLiteral: printLiteral,
                    wrapDenominator: wrapDenominator,
                    printCallExpression: printCallExpression
                });
                if (operator === '/' || operator === '%') return `${leftResult} ${operator} ${wrapDenominator(rightResult)}`;
                return `${leftResult} ${operator} ${rightResult}`;
            }
        case 'CallExpression':
            {
                const callee = node.callee;
                if (callee.type !== 'Identifier') throw new Error(`Expected Identifier, got ${callee.type}.`);
                return printCallExpression(callee.name.toUpperCase(), ...node.arguments.map((arg)=>$6d4649a4b0d9f10a$export$8fc0a65b8428632a(arg, [
                        node,
                        ...ancestors
                    ], {
                        printIdentifier: printIdentifier,
                        printLiteral: printLiteral,
                        wrapDenominator: wrapDenominator,
                        printCallExpression: printCallExpression
                    })));
            }
        case 'Identifier':
            return printIdentifier(node, ancestors);
        case 'UnaryExpression':
            {
                const { operator: operator, argument: argument } = node;
                return `${operator}${$6d4649a4b0d9f10a$var$parenthesize(argument, [
                    node,
                    ...ancestors
                ], {
                    printIdentifier: printIdentifier,
                    printLiteral: printLiteral,
                    wrapDenominator: wrapDenominator,
                    printCallExpression: printCallExpression
                })}`;
            }
        case 'Literal':
            return printLiteral(node);
        default:
            throw new Error(`Unexpected node type "${node.type}".`);
    }
}



function $4b520c18e6d520ac$export$ce555e23b0c0b6f2({ parameter: parameter, properties: properties, parseExpression: parseExpression }) {
    switch(parameter.type){
        case 'expression':
            return parseExpression(parameter.expression);
        case 'literal-date':
        case 'month-date':
        case 'select-date':
            return {
                valid: true,
                type: 'date'
            };
        case 'literal-number':
            return {
                valid: true,
                type: 'decimal'
            };
        case 'select-number':
            return {
                valid: true,
                type: parameter.values.every((x)=>Number.isInteger(x.value)) ? 'int' : 'decimal'
            };
        case 'activity':
        case 'user':
        case 'organization':
        case 'project':
        case 'choice':
            return {
                valid: false,
                reason: `Invalid parameter reference "${parameter.name}" - ${parameter.type} parameters are not supported in formulas.`
            };
        case 'subquery':
        case 'report-subquery':
            {
                const { type: type } = (0, $413788c7d08dddf5$export$13d77bb70d7b9d75)(parameter, properties);
                if (type) return {
                    valid: true,
                    type: type
                };
                return {
                    valid: false,
                    reason: `Invalid parameter reference "${parameter.name}". Unable to determine data type.`
                };
            }
        default:
            throw new Error(`Unexpected parameter type "${parameter.type}".`);
    }
}


const $28bf66f5acd2204d$export$44a23670a5e38db4 = {
    DATEADD: [
        'YEAR',
        'QUARTER',
        'MONTH',
        'DAY',
        'WEEK'
    ],
    DATEDIFF: [
        'YEAR',
        'QUARTER',
        'MONTH',
        'DAY',
        'WEEK'
    ],
    DATETRUNC: [
        'YEAR',
        'QUARTER',
        'MONTH',
        'DAY',
        'WEEK'
    ],
    DATEPART: [
        'YEAR',
        'QUARTER',
        'MONTH',
        'DAY',
        'WEEK',
        'WEEKDAY'
    ]
};
const $28bf66f5acd2204d$var$functions = {
    ABS: {
        returnType: (num)=>num.type,
        minArguments: 1,
        arguments: [
            {
                type: 'value',
                valueType: [
                    'int',
                    'decimal'
                ]
            }
        ]
    },
    DATEADD: {
        returnType: (_part, _num, date)=>date.type,
        minArguments: 3,
        arguments: [
            {
                type: 'identifier',
                values: $28bf66f5acd2204d$export$44a23670a5e38db4.DATEADD
            },
            {
                type: 'value',
                valueType: [
                    'int',
                    'decimal'
                ]
            },
            {
                type: 'value',
                valueType: [
                    'date',
                    'datetime'
                ]
            }
        ]
    },
    DATEDIFF: {
        returnType: ()=>'int',
        minArguments: 3,
        arguments: [
            {
                type: 'identifier',
                values: $28bf66f5acd2204d$export$44a23670a5e38db4.DATEDIFF
            },
            {
                type: 'value',
                valueType: [
                    'date',
                    'datetime'
                ]
            },
            {
                type: 'value',
                valueType: [
                    'date',
                    'datetime'
                ]
            }
        ]
    },
    DATEPART: {
        returnType: ()=>'int',
        minArguments: 2,
        arguments: [
            {
                type: 'identifier',
                values: $28bf66f5acd2204d$export$44a23670a5e38db4.DATEPART
            },
            {
                type: 'value',
                valueType: [
                    'date',
                    'datetime'
                ]
            }
        ]
    },
    DATETRUNC: {
        returnType: ()=>'date',
        minArguments: 2,
        arguments: [
            {
                type: 'identifier',
                values: $28bf66f5acd2204d$export$44a23670a5e38db4.DATETRUNC
            },
            {
                type: 'value',
                valueType: [
                    'date',
                    'datetime'
                ]
            }
        ]
    },
    CEILING: {
        returnType: ()=>'int',
        minArguments: 1,
        arguments: [
            {
                type: 'value',
                valueType: [
                    'int',
                    'decimal'
                ]
            }
        ]
    },
    EOMONTH: {
        returnType: ()=>'date',
        minArguments: 1,
        arguments: [
            {
                type: 'value',
                valueType: [
                    'date',
                    'datetime'
                ]
            },
            {
                type: 'value',
                valueType: [
                    'int',
                    'decimal'
                ]
            }
        ]
    },
    DATE: {
        returnType: ()=>'date',
        minArguments: 1,
        arguments: [
            {
                type: 'literal',
                validate: (value)=>typeof value === 'string' && isFinite(Date.parse(value)) && /^\d{4}-\d{1,2}-\d{1,2}$/.test(value) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string in the format of "YYYY-MM-DD"`
                    }
            }
        ]
    },
    FLOOR: {
        returnType: ()=>'int',
        minArguments: 1,
        arguments: [
            {
                type: 'value',
                valueType: [
                    'int',
                    'decimal'
                ]
            }
        ]
    },
    NOW: {
        returnType: ()=>'datetime',
        minArguments: 0,
        arguments: []
    },
    ROUND: {
        returnType: (_num, len)=>len?.node.type === 'Literal' && len.node.value === 0 ? 'int' : 'decimal',
        minArguments: 1,
        arguments: [
            {
                type: 'value',
                valueType: [
                    'int',
                    'decimal'
                ]
            },
            {
                type: 'value',
                valueType: [
                    'int'
                ],
                values: [
                    0,
                    1,
                    2,
                    3
                ]
            }
        ]
    },
    SIGN: {
        returnType: ()=>'int',
        minArguments: 1,
        arguments: [
            {
                type: 'value',
                valueType: [
                    'int',
                    'decimal'
                ]
            }
        ]
    },
    MIN: {
        returnType: (...args)=>args.some((x)=>x.type === 'decimal') ? 'decimal' : 'int',
        minArguments: 2,
        arguments: [
            {
                type: 'value',
                valueType: [
                    'int',
                    'decimal'
                ]
            },
            {
                type: 'value',
                valueType: [
                    'int',
                    'decimal'
                ]
            }
        ]
    },
    MAX: {
        returnType: (...args)=>args.some((x)=>x.type === 'decimal') ? 'decimal' : 'int',
        minArguments: 2,
        arguments: [
            {
                type: 'value',
                valueType: [
                    'int',
                    'decimal'
                ]
            },
            {
                type: 'value',
                valueType: [
                    'int',
                    'decimal'
                ]
            }
        ]
    },
    AGE: {
        returnType: ()=>'int',
        minArguments: 2,
        arguments: [
            {
                type: 'value',
                valueType: [
                    'date',
                    'datetime'
                ]
            },
            {
                type: 'value',
                valueType: [
                    'date',
                    'datetime'
                ]
            }
        ]
    }
};
function $28bf66f5acd2204d$export$d3e6063dac94c921(reason) {
    return {
        valid: false,
        reason: `Formula is too complex (${reason}).`
    };
}
function $28bf66f5acd2204d$var$validateReportExpression({ node: node, context: context, depth: depth = 1 }) {
    if (depth > (0, $413788c7d08dddf5$export$f258709b40073be1).expressionMaxExpandedDepth) return $28bf66f5acd2204d$export$d3e6063dac94c921('depth');
    context.budget.nodes++;
    if (context.budget.nodes > (0, $413788c7d08dddf5$export$f258709b40073be1).expressionMaxExpandedNodes) return $28bf66f5acd2204d$export$d3e6063dac94c921('length');
    const expandExpressionReferences = (referenceNode, expression)=>{
        const name = referenceNode.name.toUpperCase();
        if (context.ancestorNames.length >= (0, $413788c7d08dddf5$export$f258709b40073be1).expressionMaxReferenceDepth) return $28bf66f5acd2204d$export$d3e6063dac94c921('references');
        let parseResult = context.budget.parsedExpressions.get(expression);
        if (!parseResult) {
            parseResult = (0, $6d4649a4b0d9f10a$export$ac328571283a1f88)(expression);
            context.budget.parsedExpressions.set(expression, parseResult);
        }
        if (!parseResult.valid) return {
            valid: false,
            reason: `Referenced identifier "${name}" has an invalid expression. ${parseResult.reason}`
        };
        Object.keys(referenceNode).forEach((key)=>delete referenceNode[key]);
        Object.assign(referenceNode, structuredClone(parseResult.node));
        const newContext = {
            ...context,
            ancestorNames: [
                ...context.ancestorNames,
                name
            ]
        };
        return $28bf66f5acd2204d$var$validateReportExpression({
            node: referenceNode,
            context: newContext,
            depth: depth
        });
    };
    switch(node.type){
        case 'BinaryExpression':
            {
                const { left: left, right: right, operator: operator } = node;
                if ([
                    '+',
                    '-',
                    '*',
                    '/',
                    '%'
                ].includes(operator)) {
                    const leftResult = $28bf66f5acd2204d$var$validateReportExpression({
                        node: left,
                        context: context,
                        depth: depth + 1
                    });
                    if (leftResult.valid === false) return leftResult;
                    if (leftResult.type !== 'int' && leftResult.type !== 'decimal') return {
                        valid: false,
                        reason: `The expression "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(left, [])}" cannot be used with the "${operator}" operator because it does not evaluate to a number.`
                    };
                    const rightResult = $28bf66f5acd2204d$var$validateReportExpression({
                        node: right,
                        context: context,
                        depth: depth + 1
                    });
                    if (rightResult.valid === false) return rightResult;
                    if (rightResult.type !== 'int' && rightResult.type !== 'decimal') return {
                        valid: false,
                        reason: `The expression "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(left, [])}" cannot be used with the "${operator}" operator because it does not evaluate to a number.`
                    };
                    if (operator === '/' || leftResult.type === 'decimal' || rightResult.type === 'decimal') return {
                        valid: true,
                        type: 'decimal'
                    };
                    else return {
                        valid: true,
                        type: leftResult.type
                    };
                }
                return {
                    valid: false,
                    reason: `Invalid expression "${operator}".`
                };
            }
        case 'CallExpression':
            {
                const callee = node.callee;
                if (callee.type !== 'Identifier') return {
                    valid: false,
                    reason: `Invalid expression.`
                };
                const fn = $28bf66f5acd2204d$var$functions[callee.name.toUpperCase()];
                if (!fn) return {
                    valid: false,
                    reason: `Invalid expression "${callee.name}".`
                };
                if (fn.minArguments > node.arguments.length) return {
                    valid: false,
                    reason: `Too few arguments for "${callee.name}" function. Expected ${fn.minArguments === fn.arguments.length ? fn.minArguments : `${fn.minArguments} - ${fn.arguments.length}`}.`
                };
                if (node.arguments.length > fn.arguments.length) return {
                    valid: false,
                    reason: `Too many arguments for "${callee.name}" function. Expected ${fn.minArguments === fn.arguments.length ? fn.minArguments : `${fn.minArguments} - ${fn.arguments.length}`}.`
                };
                const argTypes = [];
                for(let i = 0; i < node.arguments.length; i++){
                    const arg = fn.arguments[i];
                    const argNode = node.arguments[i];
                    if (arg.type === 'identifier') {
                        if (argNode.type !== 'Identifier' || !arg.values.includes(argNode.name.toUpperCase())) return {
                            valid: false,
                            reason: `Invalid argument ${i + 1} for ${callee.name}. Expected ${arg.values.join(', ')}.`
                        };
                        argTypes.push(null);
                    } else if (arg.type === 'literal') {
                        if (argNode.type === 'UnaryExpression' && argNode.operator === '-' && argNode.argument.type === 'Literal' && typeof argNode.argument.value === 'number' && Number.isFinite(argNode.argument.value)) {
                            const result = arg.validate(argNode.argument.value * -1);
                            if (!result.valid) return result;
                        } else if (argNode.type !== 'Literal') return {
                            valid: false,
                            reason: `Invalid argument "${argNode.raw}" in "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(node)}". Expected a literal value.`
                        };
                        else {
                            const result = arg.validate(argNode.value);
                            if (!result.valid) return result;
                        }
                    } else if (arg.type === 'value') {
                        const result = $28bf66f5acd2204d$var$validateReportExpression({
                            node: argNode,
                            context: context,
                            depth: depth + 1
                        });
                        if (result.valid === false) return result;
                        if (!arg.valueType.includes(result.type)) return {
                            valid: false,
                            reason: `Invalid argument ${i + 1} for ${callee.name}. Expected ${arg.valueType[0]}.`
                        };
                        if (arg.values && (argNode.type !== 'Literal' || !arg.values.includes(argNode.value))) return {
                            valid: false,
                            reason: `Invalid argument ${i + 1} for ${callee.name}. Expected ${arg.values.join(', ')}.`
                        };
                        argTypes.push(result.type);
                    } else throw new Error(`Unexpected argument type "${arg.type}".`);
                }
                return {
                    valid: true,
                    type: fn.returnType(...node.arguments.map((node, i)=>({
                            node: node,
                            type: argTypes[i]
                        })))
                };
            }
        case 'Identifier':
            {
                const name = node.name.toUpperCase();
                if (context.ancestorNames.includes(name)) return {
                    valid: false,
                    reason: `Reference to "${name}" creates a circular reference.`
                };
                if ($28bf66f5acd2204d$export$46414ef88ad64d2d.test(name)) {
                    if (context.ancestorNames.some((x)=>(0, $413788c7d08dddf5$export$99da40ee05a17718).test(x))) return {
                        valid: false,
                        reason: `Column reference "${name}" is invalid. Columns cannot be referenced in a parameter formula.`
                    };
                    const index = $28bf66f5acd2204d$export$316f5031e169bd62(name);
                    if (index >= context.columns.length) return {
                        valid: false,
                        reason: `Invalid column reference "${name}". Column does not exist.`
                    };
                    const column = context.columns[index];
                    if (column.type === 'expression') return expandExpressionReferences(node, column.expression);
                    const { type: type, property: property } = $28bf66f5acd2204d$export$bf02abf02e552bba(column, context.properties);
                    if (type) return {
                        valid: true,
                        type: type
                    };
                    const descriptor = property ? `${column.type === 'subquery' ? (0, $413788c7d08dddf5$export$78c94180fed6d79f)[column.aggregate] + ' ' : ''}"${property.label}"` : `Column ${name}`;
                    return {
                        valid: false,
                        reason: `Invalid column reference "${name}". ${descriptor} is not eligible for use in formulas.`
                    };
                }
                if ((0, $413788c7d08dddf5$export$99da40ee05a17718).test(name)) {
                    const parameter = context.parameters.find((x)=>x.name === name);
                    if (!parameter) return {
                        valid: false,
                        reason: `Invalid parameter reference "${name}".`
                    };
                    return (0, $4b520c18e6d520ac$export$ce555e23b0c0b6f2)({
                        parameter: parameter,
                        properties: context.properties,
                        parseExpression: (expression)=>expandExpressionReferences(node, expression)
                    });
                }
                return {
                    valid: false,
                    reason: `Invalid expression "${name}".`
                };
            }
        case 'UnaryExpression':
            {
                const { operator: operator, argument: argument } = node;
                if (operator !== '-' || argument.type !== 'Literal') return {
                    valid: false,
                    reason: `Invalid expression "${operator}".`
                };
                const result = $28bf66f5acd2204d$var$validateReportExpression({
                    node: argument,
                    context: context,
                    depth: depth + 1
                });
                if (result.valid === false) return result;
                if (result.type !== 'decimal' && result.type !== 'int') return {
                    valid: false,
                    reason: `Cannot negate ${result.type} expression.`
                };
                return result;
            }
        case 'Literal':
            {
                const { value: value, raw: raw } = node;
                if (typeof value === 'number' && isFinite(value) && value >= -100000000 && value <= 100000000) return {
                    valid: true,
                    type: Number.isInteger(value) ? 'int' : 'decimal'
                };
                return {
                    valid: false,
                    reason: `Invalid expression "${raw}".`
                };
            }
        default:
            return {
                valid: false,
                reason: 'Invalid expression.'
            };
    }
}
function $28bf66f5acd2204d$export$9c93ed85bbc3de64(index) {
    if (index < 0 || index >= (0, $413788c7d08dddf5$export$f258709b40073be1).columns) throw new RangeError(`Report column index ${JSON.stringify(index)} must be between 0 and ${(0, $413788c7d08dddf5$export$f258709b40073be1).columns}.`);
    let s = '';
    index += 1; // convert to 1-based
    while(index > 0){
        index -= 1;
        s = String.fromCharCode(index % 26 + 65) + s;
        index = Math.floor(index / 26);
    }
    return s;
}
const $28bf66f5acd2204d$export$46414ef88ad64d2d = /^[A-Z]{1,2}$/;
function $28bf66f5acd2204d$export$316f5031e169bd62(name) {
    if (!$28bf66f5acd2204d$export$46414ef88ad64d2d.test(name)) throw new Error(`Identifier ${JSON.stringify(name)} is not a valid report column identifier.`);
    return [
        ...name
    ].reduce((n, c)=>n * 26 + (c.charCodeAt(0) & 31), 0) - 1;
}
function $28bf66f5acd2204d$export$9692209d71b8f134({ name: name, expression: expression, getDefinitionInfo: getDefinitionInfo }) {
    const parseResult = (0, $6d4649a4b0d9f10a$export$ac328571283a1f88)(expression);
    if (!parseResult.valid) return parseResult;
    const { node: node } = parseResult;
    const originalNode = structuredClone(node);
    const result = $28bf66f5acd2204d$var$validateReportExpression({
        node: node,
        context: {
            ancestorNames: [
                name
            ],
            ...getDefinitionInfo(),
            budget: {
                nodes: 0,
                parsedExpressions: new Map()
            }
        }
    });
    if (!result.valid) return result;
    const permitted = [
        'int',
        'decimal',
        'date',
        'datetime'
    ];
    if (!permitted.includes(result.type)) return {
        valid: false,
        reason: `Expression results of type ${result.type} are not supported. Expected: ${permitted.join(', ')}.`
    };
    return {
        valid: true,
        node: node,
        originalNode: originalNode,
        type: result.type
    };
}
function $28bf66f5acd2204d$export$bca390bebf24647e(definition) {
    const formulas = [
        ...definition.parameters.map((parameter, index)=>({
                parameter: parameter,
                index: index
            })).filter((item)=>item.parameter.type === 'expression').map(({ parameter: parameter, index: index })=>({
                name: parameter.name.toUpperCase(),
                expression: parameter.expression,
                path: `definition/parameters/${index}/expression`
            })),
        ...definition.columns.map((column, index)=>({
                column: column,
                index: index
            })).filter((item)=>item.column.type === 'expression').map(({ column: column, index: index })=>({
                name: $28bf66f5acd2204d$export$9c93ed85bbc3de64(index),
                expression: column.expression,
                path: `definition/columns/${index}/expression`
            }))
    ];
    const formulasByName = new Map(formulas.map((formula)=>[
            formula.name,
            formula
        ]));
    const memo = new Map();
    const visiting = new Set();
    const check = (complexity)=>{
        if (complexity.nodes > (0, $413788c7d08dddf5$export$f258709b40073be1).expressionMaxExpandedNodes) return {
            ...$28bf66f5acd2204d$export$d3e6063dac94c921('length')
        };
        if (complexity.depth > (0, $413788c7d08dddf5$export$f258709b40073be1).expressionMaxExpandedDepth) return {
            ...$28bf66f5acd2204d$export$d3e6063dac94c921('depth')
        };
        if (complexity.referenceDepth > (0, $413788c7d08dddf5$export$f258709b40073be1).expressionMaxReferenceDepth) return {
            ...$28bf66f5acd2204d$export$d3e6063dac94c921('references')
        };
        return {
            valid: true,
            ...complexity
        };
    };
    const analyzeNode = (node)=>{
        switch(node.type){
            case 'BinaryExpression':
                {
                    const left = analyzeNode(node.left);
                    if (!left.valid) return left;
                    const right = analyzeNode(node.right);
                    if (!right.valid) return right;
                    return check({
                        nodes: 1 + left.nodes + right.nodes,
                        depth: 1 + Math.max(left.depth, right.depth),
                        referenceDepth: Math.max(left.referenceDepth, right.referenceDepth)
                    });
                }
            case 'CallExpression':
                {
                    let nodes = 1;
                    let depth = 1;
                    let referenceDepth = 0;
                    for (const argument of node.arguments){
                        const result = analyzeNode(argument);
                        if (!result.valid) return result;
                        nodes += result.nodes;
                        depth = Math.max(depth, 1 + result.depth);
                        referenceDepth = Math.max(referenceDepth, result.referenceDepth);
                    }
                    return check({
                        nodes: nodes,
                        depth: depth,
                        referenceDepth: referenceDepth
                    });
                }
            case 'Identifier':
                {
                    const referencedFormula = formulasByName.get(node.name.toUpperCase());
                    if (!referencedFormula) return {
                        valid: true,
                        nodes: 1,
                        depth: 1,
                        referenceDepth: 0
                    };
                    const referenced = analyzeFormula(referencedFormula.name);
                    if (!referenced.valid) return referenced;
                    return check({
                        // Count the authored reference as work in addition to its expansion.
                        nodes: 1 + referenced.nodes,
                        depth: referenced.depth,
                        referenceDepth: 1 + referenced.referenceDepth
                    });
                }
            case 'UnaryExpression':
                {
                    const argument = analyzeNode(node.argument);
                    if (!argument.valid) return argument;
                    return check({
                        nodes: 1 + argument.nodes,
                        depth: 1 + argument.depth,
                        referenceDepth: argument.referenceDepth
                    });
                }
            case 'Literal':
                return {
                    valid: true,
                    nodes: 1,
                    depth: 1,
                    referenceDepth: 0
                };
            default:
                return {
                    valid: false,
                    reason: 'Invalid formula expression.'
                };
        }
    };
    function analyzeFormula(name) {
        const cached = memo.get(name);
        if (cached) return cached;
        if (visiting.has(name)) return {
            valid: false,
            reason: `Reference to "${name}" creates a circular reference.`
        };
        const formula = formulasByName.get(name);
        if (formula.expression.trim() === '' && $28bf66f5acd2204d$export$46414ef88ad64d2d.test(name)) {
            const empty = {
                valid: true,
                nodes: 1,
                depth: 1,
                referenceDepth: 1
            };
            memo.set(name, empty);
            return empty;
        }
        const parsed = (0, $6d4649a4b0d9f10a$export$ac328571283a1f88)(formula.expression);
        if (!parsed.valid) return {
            valid: false,
            reason: `Formula "${name}" has an invalid expression. ${parsed.reason}`
        };
        visiting.add(name);
        const result = analyzeNode(parsed.node);
        visiting.delete(name);
        if (!result.valid) return result;
        const checked = check({
            nodes: result.nodes,
            depth: result.depth,
            referenceDepth: Math.max(1, result.referenceDepth)
        });
        memo.set(name, checked);
        return checked;
    }
    for (const formula of formulas){
        const result = analyzeFormula(formula.name);
        if (!result.valid) return {
            ...result,
            path: formula.path
        };
    }
    return {
        valid: true
    };
}
function $28bf66f5acd2204d$export$49e0f493cc4d655f(value, map) {
    if (value === '') return null;
    let node;
    try {
        node = (0, $cec7b3c0f35c015b$export$2e2bcd8739ae039)(value);
    } catch  {
        return null;
    }
    if ($28bf66f5acd2204d$var$tryTranslateReportExpressionColumnReferences(node, map)) return node;
    return null;
}
function $28bf66f5acd2204d$var$tryTranslateReportExpressionColumnReferences(node, map) {
    switch(node.type){
        case 'BinaryExpression':
            {
                const { left: left, right: right } = node;
                return $28bf66f5acd2204d$var$tryTranslateReportExpressionColumnReferences(left, map) && $28bf66f5acd2204d$var$tryTranslateReportExpressionColumnReferences(right, map);
            }
        case 'CallExpression':
            {
                let translated = true;
                for (const arg of node.arguments)translated &&= $28bf66f5acd2204d$var$tryTranslateReportExpressionColumnReferences(arg, map);
                return translated;
            }
        case 'Identifier':
            {
                const deletedName = 'DELETED';
                const name = node.name.toUpperCase();
                if ($28bf66f5acd2204d$export$46414ef88ad64d2d.test(name)) {
                    const index = $28bf66f5acd2204d$export$316f5031e169bd62(name);
                    const new_index = map[index];
                    if (new_index === null) node.name = deletedName;
                    else node.name = $28bf66f5acd2204d$export$9c93ed85bbc3de64(new_index);
                    return true;
                } else return true;
            }
        case 'UnaryExpression':
        case 'Literal':
            return true;
        default:
            return false;
    }
}
function $28bf66f5acd2204d$export$bf02abf02e552bba(column, properties) {
    const getPropertyType = (property)=>{
        switch(property.type){
            case 'int':
                return {
                    type: 'int',
                    property: property
                };
            case 'currency':
            case 'decimal':
                return {
                    type: 'decimal',
                    property: property
                };
            case 'date':
                return {
                    type: 'datetime',
                    property: property
                };
            case 'bit':
                return {
                    type: 'boolean',
                    property: property
                };
            case 'varchar100':
            case 'varcharmax':
                return {
                    type: 'string',
                    property: property
                };
            default:
                return {
                    type: null,
                    property: property
                };
        }
    };
    switch(column.type){
        case 'standard':
            {
                const property = properties.find((p)=>p.property_id === column.property_id);
                if (!property) throw new Error(`Unable to find standard property ${column.property_id}.`);
                if ((0, $413788c7d08dddf5$export$2dff0e8aabc7fdcc).includes(property.property_id) || property.choice_type !== 'none') return {
                    type: null,
                    property: property
                };
                return getPropertyType(property);
            }
        case 'expression':
            return {
                type: null
            };
        case 'subquery':
            {
                if (column.aggregate === 'count') return {
                    type: 'int'
                };
                const aggregateResultType = (0, $413788c7d08dddf5$export$3604b59051dae160)[column.aggregate];
                switch(aggregateResultType){
                    case 'decimal':
                        return {
                            type: 'decimal'
                        };
                    case 'int':
                        return {
                            type: 'int'
                        };
                    case 'inherit-number':
                    case 'inherit':
                        {
                            const property = properties.find((p)=>p.property_id === column.subquery_property_id);
                            if (!property) throw new Error(`Unable to find subquery property ${column.subquery_property_id}.`);
                            return getPropertyType(property);
                        }
                    default:
                        throw new Error(`Unexpected aggregate result type "${aggregateResultType}" for subquery property ${column.subquery_property_id}.`);
                }
            }
        default:
            throw new Error(`Unexpected column type "${column.type}".`);
    }
}



const $a778f1b6bd4bd30d$var$uuid_schema = {
    type: 'string',
    pattern: '^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$' // ensure lower-case
};
const $a778f1b6bd4bd30d$export$132ea886f1bee90 = {
    type: 'object',
    additionalProperties: false,
    required: [
        'id',
        'title'
    ],
    properties: {
        id: $a778f1b6bd4bd30d$var$uuid_schema,
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 300
        }
    }
};
const $a778f1b6bd4bd30d$export$3a1eda45101b1f09 = {
    type: 'object',
    additionalProperties: false,
    required: [
        'id',
        'title'
    ],
    properties: {
        id: {
            type: 'integer',
            minimum: -2
        },
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 250
        }
    }
};





const $413788c7d08dddf5$export$ba4f7c3b25ff4061 = 5000;
const $413788c7d08dddf5$export$dfbb11200c55b885 = [
    'activity',
    'person',
    'user_organization',
    'organization_project'
];
const $413788c7d08dddf5$export$ffda6d73471681a0 = {
    activity: {
        singular: (0, $b11db1b62d4a8f76$export$7b385c33eaf64565),
        plural: (0, $b11db1b62d4a8f76$export$c649626dc103486),
        description: (0, $b11db1b62d4a8f76$export$8e4ca99cc58f6f3e),
        included: [
            'person'
        ],
        icon: (0, $84c634e688af79ca$export$d2997daddac9b44),
        subqueries: [
            {
                value: 'root-activity',
                text: 'Root activity'
            },
            {
                value: 'root-descendant-activities',
                text: 'Root activity & descendants'
            },
            {
                value: 'parent-activity',
                text: 'Parent activity'
            },
            {
                value: 'child-activities',
                text: 'Child activities'
            },
            {
                value: 'person-activities',
                text: `Person's activities`
            },
            {
                value: 'sibling-activities',
                text: 'Sibling activities'
            },
            {
                value: 'referenced-activities',
                text: 'Referenced activities'
            },
            {
                value: 'second-degree-referenced-activities',
                text: 'Second-degree referenced activities'
            },
            {
                value: 'referenced-root-descendant-activities',
                text: 'Referenced root activities & descendants'
            },
            {
                value: 'referencing-activities',
                text: 'Referencing activities'
            },
            {
                value: 'grandparent-activity',
                text: 'Grandparent activity'
            },
            {
                value: 'grandchild-activities',
                text: 'Grandchild activities (deprecated)'
            }
        ]
    },
    organization_project: {
        singular: (0, $b11db1b62d4a8f76$export$2a505cf562ed1f0f),
        plural: (0, $b11db1b62d4a8f76$export$1465cd6a5dc70bb9),
        description: (0, $b11db1b62d4a8f76$export$60f60aa90d727a55),
        included: [],
        icon: (0, $84c634e688af79ca$export$51f878b7e8894ba1),
        subqueries: [
            {
                value: 'assigned-activities',
                text: 'Assigned activities'
            },
            {
                value: 'contracted-activities',
                text: 'Contracted activities'
            },
            {
                value: 'created-activities',
                text: 'Created activities'
            },
            {
                value: 'organization-project-users',
                text: 'Organization project users'
            }
        ]
    },
    person: {
        singular: (0, $b11db1b62d4a8f76$export$e81e1f6da08081e8),
        plural: (0, $b11db1b62d4a8f76$export$9a0b973819fb310),
        description: (0, $b11db1b62d4a8f76$export$90a412476a587834),
        included: [],
        icon: (0, $84c634e688af79ca$export$44b16df525422efd),
        subqueries: [
            {
                value: 'child-activities',
                text: 'Activities'
            }
        ]
    },
    user_organization: {
        singular: (0, $b11db1b62d4a8f76$export$875c8af227bd90db),
        plural: (0, $b11db1b62d4a8f76$export$875c8af227bd90db),
        description: (0, $b11db1b62d4a8f76$export$383ccceb9623a9e8),
        included: [],
        icon: (0, $84c634e688af79ca$export$3d8bf5b2a943d316),
        subqueries: [
            {
                value: 'assigned-activities',
                text: 'Assigned activities'
            },
            {
                value: 'created-activities',
                text: 'Created activities'
            }
        ]
    }
};
var $413788c7d08dddf5$export$fbac3d2f26b21a45 = /*#__PURE__*/ function(ReportSharedWith) {
    ReportSharedWith[ReportSharedWith["None"] = 0] = "None";
    ReportSharedWith[ReportSharedWith["Organization"] = 1] = "Organization";
    ReportSharedWith[ReportSharedWith["Project"] = 2] = "Project";
    ReportSharedWith[ReportSharedWith["ProjectContractedOrganizations"] = 3] = "ProjectContractedOrganizations";
    ReportSharedWith[ReportSharedWith["ProjectDirectlyContractedOrganizations"] = 4] = "ProjectDirectlyContractedOrganizations";
    ReportSharedWith[ReportSharedWith["SpecificOrganizations"] = 5] = "SpecificOrganizations";
    ReportSharedWith[ReportSharedWith["SpecificUsers"] = 6] = "SpecificUsers";
    return ReportSharedWith;
}({});
const $413788c7d08dddf5$export$ec623b127a8c6d17 = [
    'table',
    'dashboard'
];
const $413788c7d08dddf5$export$16e3502ebc32b20f = {
    '=': 'Equal to',
    '<>': 'Not equal to',
    '<': 'Less than',
    '<=': 'Less than or equal to',
    '>': 'Greater than',
    '>=': 'Greater than or equal to',
    in: 'Any of',
    'not in': 'None of',
    startswith: 'Starts with',
    notstartswith: 'Does not start with',
    contains: 'Contains',
    notcontains: 'Does not contain',
    blank: 'Is blank/unanswered',
    notblank: 'Is not blank/unanswered'
};
const $413788c7d08dddf5$export$cc43c7363164eb92 = Object.assign({}, $413788c7d08dddf5$export$16e3502ebc32b20f, {
    '<': 'Before',
    '<=': 'On or before',
    '>': 'After',
    '>=': 'On or after'
});
const $413788c7d08dddf5$export$ccbce4efa7f8029b = /*@__PURE__*/ Object.keys($413788c7d08dddf5$export$16e3502ebc32b20f);
const $413788c7d08dddf5$export$80f624d7e49719a5 = [
    '=',
    '<>',
    '>',
    '>=',
    '<',
    '<='
];
function $413788c7d08dddf5$export$4477c442bd5c2a6d(op) {
    return $413788c7d08dddf5$export$80f624d7e49719a5.includes(op);
}
function $413788c7d08dddf5$export$398604a469f7de9a(op, a, b) {
    if (typeof a !== typeof b) throw new Error(`Expected typeof a "${typeof a}" to match typeof "${typeof b}".`);
    switch(op){
        case '<':
            return a < b;
        case '<=':
            return a <= b;
        case '<>':
            return a !== b;
        case '=':
            return a === b;
        case '>':
            return a > b;
        case '>=':
            return a >= b;
        default:
            throw new Error(`Unexpected operator "${op}"`);
    }
}
const $413788c7d08dddf5$export$f96a750883d122bd = [
    'count',
    'count-distinct',
    'sum',
    'min',
    'max',
    'avg',
    'median',
    'stdev',
    'var',
    'last-created',
    'last-started',
    'last-ended',
    'first-created',
    'first-started',
    'first-ended'
];
const $413788c7d08dddf5$export$3604b59051dae160 = {
    count: 'int',
    'count-distinct': 'int',
    sum: 'inherit-number',
    min: 'inherit',
    max: 'inherit',
    avg: 'decimal',
    median: 'decimal',
    stdev: 'decimal',
    var: 'decimal',
    'last-created': 'inherit',
    'last-started': 'inherit',
    'last-ended': 'inherit',
    'first-created': 'inherit',
    'first-started': 'inherit',
    'first-ended': 'inherit'
};
const $413788c7d08dddf5$var$discreteValueAggregateFunctions = [
    'min',
    'max',
    'last-created',
    'last-started',
    'last-ended',
    'first-created',
    'first-started',
    'first-ended'
];
function $413788c7d08dddf5$export$30b73a7e32416e4a(value) {
    return $413788c7d08dddf5$var$discreteValueAggregateFunctions.includes(value);
}
const $413788c7d08dddf5$var$inheritTypeAggregateFunctions = [
    'sum',
    'min',
    'max',
    'last-created',
    'last-started',
    'last-ended',
    'first-created',
    'first-started',
    'first-ended'
];
function $413788c7d08dddf5$export$8228957a7ccdeb15(value) {
    return $413788c7d08dddf5$var$inheritTypeAggregateFunctions.includes(value);
}
const $413788c7d08dddf5$export$b042dddb068285f3 = {
    'last-created': (alias)=>`${alias}.[create_datetime] desc`,
    'last-started': (alias)=>`${alias}.[start_date] desc`,
    'last-ended': (alias)=>`${alias}.[end_date] desc, ${alias}.[start_date] desc`,
    'first-created': (alias)=>`${alias}.[create_datetime] asc`,
    'first-started': (alias)=>`${alias}.[start_date] asc`,
    'first-ended': (alias)=>`${alias}.[end_date] asc, ${alias}.[start_date] asc`
};
const $413788c7d08dddf5$export$d49918c49ed303c4 = [
    'count-distinct',
    'sum',
    'avg',
    'median',
    'stdev',
    'var',
    'min',
    'max',
    'last-created',
    'last-started',
    'last-ended',
    'first-created',
    'first-started',
    'first-ended'
];
const $413788c7d08dddf5$export$3b6f3277d945000d = [
    'sum',
    'avg',
    'median',
    'stdev',
    'var',
    'min',
    'max'
];
const $413788c7d08dddf5$export$fea7054315128246 = {
    count: [],
    'count-distinct': [
        'uniqueidentifier',
        'varchar100',
        'int',
        'bit',
        'currency',
        'decimal',
        'date',
        'activity'
    ],
    sum: [
        'int',
        'currency',
        'decimal'
    ],
    avg: [
        'int',
        'currency',
        'decimal'
    ],
    median: [
        'int',
        'currency',
        'decimal'
    ],
    stdev: [
        'int',
        'currency',
        'decimal'
    ],
    var: [
        'int',
        'currency',
        'decimal'
    ],
    min: [
        'uniqueidentifier',
        'varchar100',
        'int',
        'bit',
        'currency',
        'decimal',
        'date'
    ],
    max: [
        'uniqueidentifier',
        'varchar100',
        'int',
        'bit',
        'currency',
        'decimal',
        'date'
    ],
    'last-created': [
        'uniqueidentifier',
        'varchar100',
        'varcharmax',
        'int',
        'bit',
        'currency',
        'decimal',
        'date',
        'activity'
    ],
    'last-started': [
        'uniqueidentifier',
        'varchar100',
        'varcharmax',
        'int',
        'bit',
        'currency',
        'decimal',
        'date',
        'activity'
    ],
    'last-ended': [
        'uniqueidentifier',
        'varchar100',
        'varcharmax',
        'int',
        'bit',
        'currency',
        'decimal',
        'date',
        'activity'
    ],
    'first-created': [
        'uniqueidentifier',
        'varchar100',
        'varcharmax',
        'int',
        'bit',
        'currency',
        'decimal',
        'date',
        'activity'
    ],
    'first-started': [
        'uniqueidentifier',
        'varchar100',
        'varcharmax',
        'int',
        'bit',
        'currency',
        'decimal',
        'date',
        'activity'
    ],
    'first-ended': [
        'uniqueidentifier',
        'varchar100',
        'varcharmax',
        'int',
        'bit',
        'currency',
        'decimal',
        'date',
        'activity'
    ]
};
const $413788c7d08dddf5$export$78c94180fed6d79f = {
    count: 'Count',
    'count-distinct': 'Distinct count',
    sum: 'Sum',
    min: 'Minimum',
    max: 'Maximum',
    avg: 'Average',
    median: 'Median',
    stdev: 'Standard deviation',
    var: 'Variance',
    'last-created': 'Most recently created',
    'last-started': 'Most recently started',
    'last-ended': 'Most recently ended',
    'first-created': 'Earliest created',
    'first-started': 'Earliest started',
    'first-ended': 'Earliest ended'
};
const $413788c7d08dddf5$export$2dff0e8aabc7fdcc = [
    // custom:
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.attachment_count,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_id,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_dow,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.subscribed,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.comment_create_user_id,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.comment_mentioned_user_id,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_physical.is_precise,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.is_precise,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_physical.is_precise,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_mailing.is_precise,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_physical.is_precise,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_mailing.is_precise,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.projects,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_physical.is_precise,
    // composite:
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_physical.address,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.address,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_physical.address,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_email.formatted,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_email.formatted,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_phone.formatted,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_email.formatted,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_physical.address,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_mailing.address,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_phone.formatted,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_email.formatted,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.primary_phone.formatted,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_phone.formatted,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_physical.address
];
function $413788c7d08dddf5$export$3cb1b09c699eed1(column, property, expressionType) {
    // no grouping for composite props or properties whose choice type is not 'single' or 'none'.
    if ($413788c7d08dddf5$export$2dff0e8aabc7fdcc.includes(property?.property_id ?? NaN) || property?.response && !([
        'none',
        'single',
        'multiple'
    ].includes(property.choice_type) || property.type === 'activity')) return [
        'none'
    ];
    // grouping only for activity properties.
    if (property?.type === 'activity') return [
        'none',
        'group'
    ];
    if (property?.choice_type === 'single') return [
        'none',
        'group',
        ...$413788c7d08dddf5$export$d49918c49ed303c4
    ];
    if (property?.choice_type === 'multiple') return [
        'none',
        ...$413788c7d08dddf5$export$d49918c49ed303c4
    ];
    if (property && column.type === 'standard' || property && column.type === 'subquery' && $413788c7d08dddf5$var$discreteValueAggregateFunctions.includes(column.aggregate)) switch(property.type){
        case 'date':
            return [
                'none',
                'group',
                'count',
                'count-distinct',
                'max',
                'min'
            ];
        case 'currency':
        case 'int':
        case 'decimal':
            return [
                'none',
                'group',
                'count',
                'count-distinct',
                'sum',
                'avg',
                'median',
                'stdev',
                'var',
                'max',
                'min'
            ];
        case 'varchar100':
            return [
                'none',
                'group',
                'count',
                'count-distinct',
                'max',
                'min'
            ];
        case 'varcharmax':
            return [
                'none'
            ];
        case 'bit':
            return [
                'none',
                'group'
            ];
        case 'uniqueidentifier':
            return [
                'none',
                'group',
                'count',
                'count-distinct',
                'max',
                'min'
            ];
        default:
            return [
                'none'
            ];
    }
    else if (column.type === 'subquery') switch(column.aggregate){
        case 'sum':
        case 'count':
        case 'count-distinct':
        case 'avg':
        case 'median':
        case 'stdev':
        case 'var':
            return [
                'none',
                'sum',
                'avg',
                'median',
                'stdev',
                'var',
                'max',
                'min'
            ];
        default:
            return [
                'none'
            ];
    }
    else if (column.type === 'expression') switch(expressionType){
        case 'date':
        case 'datetime':
            return [
                'none',
                'group',
                'max',
                'min'
            ];
        case 'int':
        case 'decimal':
            return [
                'none',
                ...expressionType === 'int' ? [
                    'group'
                ] : [],
                'sum',
                'avg',
                'median',
                'stdev',
                'var',
                'max',
                'min'
            ];
        case 'string':
            return [
                'none',
                'group'
            ];
        case 'boolean':
        default:
            return [
                'none'
            ];
    }
    else return [
        'none'
    ];
}
const $413788c7d08dddf5$export$fd54d9a8ae729fbf = /*@__PURE__*/ new Map([
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.first_name,
        'empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.middle_name,
        'empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.suffix,
        'empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.nickname,
        'empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.gender,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.gender_identity,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.sexual_orientation,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.race,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.ethnicity,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.marital_status,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_language,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.dob,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_phone.number,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_phone.extension,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_physical.street_address,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_physical.sub_address,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_physical.city,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_physical.region_abbr,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_physical.subregion,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_physical.postal_code,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_mailing.street_address,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_mailing.sub_address,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_mailing.city,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_mailing.region_abbr,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_mailing.subregion,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_mailing.postal_code,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_email.email,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.ssn,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.veteran_id,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.medicaid_id,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.medicare_beneficiary_id,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.agingis_id,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.scsep_participant_id,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.user_id,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.user_email_address,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.open_participant_portal_invitation,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.parent_activity_id,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.subject_person_id,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.end_date,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.due_date,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_user_id,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.service_authorization_service_id,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_phone.number,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_phone.extension,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_physical.street_address,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_physical.sub_address,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_physical.city,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_physical.region_abbr,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_physical.subregion,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_physical.postal_code,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.street_address,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.sub_address,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.city,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.region_abbr,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.subregion,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.postal_code,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_physical.street_address,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_physical.sub_address,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_physical.city,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_physical.region_abbr,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_physical.subregion,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_physical.postal_code,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.classification,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.fein,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_phone.number,
        'null'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_phone.extension,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_physical.street_address,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_physical.sub_address,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_physical.city,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_physical.region_abbr,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_physical.subregion,
        'null-or-empty-string'
    ],
    [
        (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_physical.postal_code,
        'null-or-empty-string'
    ]
]);
function $413788c7d08dddf5$export$fa24b530c7fccc85(property) {
    if (property.response) return 'null';
    return $413788c7d08dddf5$export$fd54d9a8ae729fbf.get(property.property_id);
}
const $413788c7d08dddf5$export$f258709b40073be1 = {
    parameters: 30,
    filters: 15,
    sorts: 4,
    columns: 35,
    inItems: 75,
    shares: 20,
    filtersOnSameField: 8,
    expressionMaxLength: 100,
    expressionMaxExpandedNodes: 256,
    expressionMaxExpandedDepth: 32,
    expressionMaxReferenceDepth: 16,
    expressionMaxGeneratedSqlLength: 32768,
    parameterSelectItems: 24,
    parameterNameMaxLength: 30,
    parameterLabelMaxLength: 20,
    parameterDescriptionMaxLength: 200
};
const $413788c7d08dddf5$export$578da1e890e33f2 = {
    me: {
        id: 'b0000000-0000-0000-0000-000000000000',
        title: '@Me'
    },
    myOrganization: {
        id: 'b0000000-0000-0000-0000-000000000001',
        title: '@My Organization'
    },
    createUser: {
        id: 'b0000000-0000-0000-0000-000000000002',
        title: '@Creator'
    },
    createOrganization: {
        id: 'b0000000-0000-0000-0000-000000000003',
        title: '@Creator Organization'
    },
    allUsers: {
        id: 'b0000000-0000-0000-0000-000000000004',
        title: '@All Users'
    },
    allOrganizations: {
        id: 'b0000000-0000-0000-0000-000000000005',
        title: '@All Organizations'
    },
    allActivities: {
        id: 'b0000000-0000-0000-0000-000000000006',
        title: '@All Activities'
    },
    allProjects: {
        id: 'b0000000-0000-0000-0000-000000000007',
        title: '@All Projects'
    },
    allChoices: {
        id: -1,
        title: '@All Choices'
    },
    unansweredChoice: {
        id: -2,
        title: '@Unanswered'
    },
    myOrganizationCity: {
        id: '@MyOrganizationCity',
        title: `@My Organization's City`
    },
    myOrganizationState: {
        id: '@MyOrganizationState',
        title: `@My Organization's State`
    },
    myOrganizationCounty: {
        id: '@MyOrganizationCounty',
        title: `@My Organization's County`
    },
    myOrganizationContracts: {
        id: '@MyOrganizationContracts',
        title: `@My Organization's Contracts`
    }
};
const $413788c7d08dddf5$export$40ac6cdb7593af40 = 'ffffffff-eeee-dddd-cccc-aaaaaaaaaaaa';
function $413788c7d08dddf5$export$bea42d731e2b5580(report, userOrganization) {
    if (report.create_user_id === userOrganization.user_id && report.create_organization_id === userOrganization.organization_id && (0, $9d0d00e92a99c512$export$3da2623e77b27bff)(userOrganization, 'Writer')) return false;
    if (report.is_shared !== 0 && userOrganization.organization_id === report.create_organization_id && (0, $9d0d00e92a99c512$export$3da2623e77b27bff)(userOrganization, 'Admin')) return false;
    return true;
}
const $413788c7d08dddf5$export$bc527ea0389902ad = [
    'root-activity',
    'root-descendant-activities',
    'grandparent-activity',
    'parent-activity',
    'child-activities',
    'grandchild-activities',
    'referenced-activities',
    'second-degree-referenced-activities',
    'referenced-root-descendant-activities',
    'referencing-activities',
    'person-activities',
    'sibling-activities',
    'assigned-activities',
    'created-activities',
    'contracted-activities',
    'organization-project-users',
    'activity',
    'person',
    'user_organization',
    'organization_project'
];
function $413788c7d08dddf5$export$b65695534a22e57d(association) {
    return association === 'root-activity' || association === 'grandparent-activity' || association === 'parent-activity';
}
const $413788c7d08dddf5$export$416b29773ad00249 = {
    'root-activity': 'activity',
    'root-descendant-activities': 'activity',
    'grandparent-activity': 'activity',
    'parent-activity': 'activity',
    'child-activities': 'activity',
    'grandchild-activities': 'activity',
    'referenced-activities': 'activity',
    'second-degree-referenced-activities': 'activity',
    'referenced-root-descendant-activities': 'activity',
    'referencing-activities': 'activity',
    'person-activities': 'activity',
    'sibling-activities': 'activity',
    'assigned-activities': 'activity',
    'created-activities': 'activity',
    'contracted-activities': 'activity',
    'organization-project-users': 'user_organization',
    activity: 'activity',
    person: 'person',
    user_organization: 'user_organization',
    organization_project: 'organization_project'
};
function $413788c7d08dddf5$export$5c5d0ff25a8e814f(columns) {
    const useGrouping = columns.some((c)=>c.grouping.type !== 'none');
    if (useGrouping) {
        for (const column of columns)if (column.grouping.type === 'none') column.sort = null;
    }
    columns.filter((x)=>x.sort).sort((a, b)=>+a.sort[0] - +b.sort[0]).slice(0, 4).forEach((x, i)=>{
        x.sort = `${i}/${x.sort.split('/')[1]}`;
    });
    if (!columns.some((x)=>x.sort)) {
        const first = columns.find((x)=>!useGrouping || x.grouping.type !== 'none');
        if (first) first.sort = '0/asc';
    }
}
const $413788c7d08dddf5$export$cc1aa38ac6389ee9 = [
    {
        value: '',
        text: 'None'
    },
    {
        value: '0/asc',
        text: 'Ascending (1)',
        group: 'Primary sort'
    },
    {
        value: '0/desc',
        text: 'Descending (1)',
        group: 'Primary sort'
    },
    {
        value: '1/asc',
        text: 'Ascending (2)',
        group: 'Secondary sort'
    },
    {
        value: '1/desc',
        text: 'Descending (2)',
        group: 'Secondary sort'
    },
    {
        value: '2/asc',
        text: 'Ascending (3)',
        group: 'Third sort'
    },
    {
        value: '2/desc',
        text: 'Descending (3)',
        group: 'Third sort'
    },
    {
        value: '3/asc',
        text: 'Ascending (4)',
        group: 'Fourth sort'
    },
    {
        value: '3/desc',
        text: 'Descending (4)',
        group: 'Fourth sort'
    }
];
function $413788c7d08dddf5$export$dd858183bec0ba71(label) {
    return label.toLowerCase().includes('[hidden]');
}
function $413788c7d08dddf5$export$52e8fef74ca2c3f(index, column, entity_type, properties) {
    if (column.type === 'subquery' || column.type === 'expression') return column.label || `Column ${(0, $28bf66f5acd2204d$export$9c93ed85bbc3de64)(index)}`;
    const property = properties[column.property_id];
    return column.label || $413788c7d08dddf5$export$233f7d0145f2eab8(entity_type, property);
}
const $413788c7d08dddf5$export$99da40ee05a17718 = /^\$[A-Z][A-Z0-9_]{0,28}$/;
const $413788c7d08dddf5$export$96912a5d52a37815 = /^\$RP\d+_/;
const $413788c7d08dddf5$export$4944b09c92821236 = [
    'organization-event',
    'organization-agency',
    'organization-site',
    'organization-period'
];
function $413788c7d08dddf5$export$b73bfbf6fdaaef10(parameter) {
    return parameter.type === 'expression' || parameter.type === 'subquery' || parameter.type === 'report-subquery';
}
const $413788c7d08dddf5$export$c365c01fc93c1363 = [
    'expression',
    'literal-date',
    'month-date',
    'literal-number',
    'select-date',
    'select-number',
    'activity',
    'user',
    'organization',
    'project',
    'choice',
    'subquery',
    'report-subquery'
];
const $413788c7d08dddf5$export$d03a77ff9f0df745 = {
    expression: 'Formula',
    'literal-date': 'Date',
    'month-date': 'Month',
    'literal-number': 'Number',
    'select-date': 'Date pick list',
    'select-number': 'Number pick list',
    activity: 'Activities',
    user: 'Users',
    organization: 'Organizations',
    project: 'Projects',
    choice: 'Choice question',
    subquery: 'Data lookup',
    'report-subquery': 'Report lookup'
};
var $413788c7d08dddf5$export$9df03d41453bd752 = /*#__PURE__*/ function(ReportSubscriptionJobState) {
    ReportSubscriptionJobState[ReportSubscriptionJobState["Scheduled"] = 0] = "Scheduled";
    ReportSubscriptionJobState[ReportSubscriptionJobState["Processing"] = 1] = "Processing";
    ReportSubscriptionJobState[ReportSubscriptionJobState["Complete"] = 2] = "Complete";
    ReportSubscriptionJobState[ReportSubscriptionJobState["Exception"] = 3] = "Exception";
    ReportSubscriptionJobState[ReportSubscriptionJobState["Expired"] = 4] = "Expired";
    return ReportSubscriptionJobState;
}({});
const $413788c7d08dddf5$export$f0656e6b02897626 = {
    activity: {
        parameters: [],
        columns: [
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.activity_definition_id,
                grouping: {
                    type: 'none'
                },
                sort: null
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.status,
                grouping: {
                    type: 'none'
                },
                sort: null
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_id,
                grouping: {
                    type: 'none'
                },
                sort: null
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_user_id,
                grouping: {
                    type: 'none'
                },
                sort: null
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.start_date,
                grouping: {
                    type: 'none'
                },
                sort: '0/desc'
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.end_date,
                grouping: {
                    type: 'none'
                },
                sort: null
            }
        ],
        filters: [
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.status,
                operator: 'in',
                value: (0, $fc2f5b0b15619892$export$cfa4e26f21007dcc).map((id)=>({
                        id: id,
                        title: (0, $fc2f5b0b15619892$export$db8da96cb205ed52)[id][0, $12c3f7ece07822ce$export$d7f512c98c859244]
                    }))
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_user_id,
                operator: 'in',
                value: [
                    $413788c7d08dddf5$export$578da1e890e33f2.me
                ]
            }
        ],
        dashboard_elements: []
    },
    person: {
        parameters: [],
        columns: [
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.full_name,
                grouping: {
                    type: 'none'
                },
                sort: '0/asc'
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.dob,
                grouping: {
                    type: 'none'
                },
                sort: null
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.gender,
                grouping: {
                    type: 'none'
                },
                sort: null
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_physical.address,
                grouping: {
                    type: 'none'
                },
                sort: null
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.create_user_id,
                grouping: {
                    type: 'none'
                },
                sort: null
            }
        ],
        filters: [
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.create_organization_id,
                operator: 'in',
                value: [
                    $413788c7d08dddf5$export$578da1e890e33f2.myOrganization
                ]
            }
        ],
        dashboard_elements: []
    },
    user_organization: {
        parameters: [],
        columns: [
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.organization_id,
                grouping: {
                    type: 'none'
                },
                sort: null
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.login,
                grouping: {
                    type: 'none'
                },
                sort: null
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.family_name,
                grouping: {
                    type: 'none'
                },
                sort: '0/asc'
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.given_name,
                grouping: {
                    type: 'none'
                },
                sort: '1/asc'
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.email,
                grouping: {
                    type: 'none'
                },
                sort: null
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.primary_phone.formatted,
                grouping: {
                    type: 'none'
                },
                sort: null
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.projects,
                grouping: {
                    type: 'none'
                },
                sort: null
            }
        ],
        filters: [
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.organization_id,
                operator: 'in',
                value: [
                    $413788c7d08dddf5$export$578da1e890e33f2.myOrganization
                ]
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.is_active,
                operator: '=',
                value: true
            }
        ],
        dashboard_elements: []
    },
    organization_project: {
        parameters: [],
        columns: [
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.organization_id,
                grouping: {
                    type: 'none'
                },
                sort: '0/asc'
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.project_id,
                grouping: {
                    type: 'none'
                },
                sort: null
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.project_join_date,
                grouping: {
                    type: 'none'
                },
                sort: null
            },
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_physical.region_abbr,
                grouping: {
                    type: 'none'
                },
                sort: null
            }
        ],
        filters: [
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.is_active,
                operator: '=',
                value: true
            }
        ],
        dashboard_elements: []
    }
};
const $413788c7d08dddf5$export$e8a3b3d1dac2a917 = ()=>({
        parameters: [
            {
                type: 'literal-date',
                name: '$START_DATE',
                label: 'Start Date',
                value: `${new Date().getFullYear()}-01-01`
            },
            {
                type: 'literal-date',
                name: '$END_DATE',
                label: 'End Date',
                value: `${new Date().getFullYear()}-12-31`
            }
        ],
        columns: [
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.start_date,
                grouping: {
                    type: 'none'
                },
                sort: '0/asc'
            }
        ],
        filters: [
            {
                type: 'standard',
                property_id: (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.start_date,
                operator: '<',
                value: new Date((0, $b78c044e3d911d2e$export$5c333a116e949cdd)).toISOString().substr(0, 10)
            }
        ],
        dashboard_elements: []
    });
function $413788c7d08dddf5$export$f91313b44e1447ea(definition) {
    const ids = new Set();
    const add = (item)=>{
        if (item.type === 'subquery') {
            if (item.aggregate !== 'count') ids.add(item.subquery_property_id);
            item.filters?.forEach(add);
        } else if (item.type === 'report-subquery') {
            if (item.aggregate !== 'count') ids.add(item.subquery_property_id);
        } else if (item.type === 'choice') ids.add(item.property_id);
        else if (item.type === 'standard') ids.add(item.property_id);
    };
    definition.filters.forEach(add);
    definition.columns.forEach(add);
    definition.parameters.forEach(add);
    return Array.from(ids).sort();
}
function $413788c7d08dddf5$export$b9602297fb14846d(definition) {
    return definition.parameters.filter((p)=>p.type === 'report-subquery').map((p)=>p.report_id).filter((x)=>typeof x === 'string' && x !== '').filter((x, i, a)=>a.indexOf(x) === i);
}
function $413788c7d08dddf5$export$ec490844106e84e7(definition) {
    const ids = definition.dashboard_elements.map((x)=>x.type === 'report' ? x.report_id : x.type === 'metric' ? [
            x.value_report_id,
            x.goal_report_id
        ] : x.type === 'report-links' ? x.reports.map((r)=>r.report_id) : null).flat().filter((x)=>typeof x === 'string' && x !== '').concat($413788c7d08dddf5$export$b9602297fb14846d(definition));
    return ids.filter((x, i, a)=>a.indexOf(x) === i);
}
function $413788c7d08dddf5$export$1cb9d0e306afe7a7(definition, associatedReports) {
    const reports = new Map(associatedReports.map((r)=>[
            r.report_id,
            r
        ]));
    const referencedReportIds = new Set();
    const visit = (definition)=>{
        for (const report_id of $413788c7d08dddf5$export$b9602297fb14846d(definition)){
            if (referencedReportIds.has(report_id)) continue;
            referencedReportIds.add(report_id);
            const report = reports.get(report_id);
            if (report?.definition) visit(report.definition);
        }
    };
    visit(definition);
    return associatedReports.filter((r)=>referencedReportIds.has(r.report_id));
}
function $413788c7d08dddf5$export$233f7d0145f2eab8(entity, property) {
    let label = property.label;
    if (property.response || property.entity_type === entity) return label;
    if (!/^[A-Z][A-Z]/.test(label)) label = label.toLowerCase();
    const entitySingular = $413788c7d08dddf5$export$ffda6d73471681a0[property.entity_type].singular[0, $12c3f7ece07822ce$export$d7f512c98c859244];
    return `${entitySingular} ${label}`;
}
function $413788c7d08dddf5$export$156328d95560793b(filter, property) {
    const aggregate = filter.type === 'standard' ? 'max' : filter.aggregate;
    const resultType = $413788c7d08dddf5$export$3604b59051dae160[aggregate];
    switch(resultType){
        case 'decimal':
        case 'int':
        case 'inherit-number':
            return [
                ...$413788c7d08dddf5$export$80f624d7e49719a5
            ];
        case 'inherit':
            {
                if (!property) return [];
                let ops;
                switch(property.type){
                    case 'signature':
                    case 'medications':
                    case 'attachment':
                        ops = [];
                        break;
                    case 'currency':
                    case 'date':
                    case 'decimal':
                    case 'int':
                        if (property.choice_type === 'none') ops = [
                            '=',
                            '<',
                            '<=',
                            '>',
                            '>='
                        ];
                        else ops = [
                            'in',
                            'not in'
                        ];
                        break;
                    case 'varchar100':
                        if (property.choice_type === 'none') ops = [
                            '=',
                            '<',
                            '<=',
                            '>',
                            '>=',
                            'startswith',
                            'notstartswith',
                            'contains',
                            'notcontains'
                        ];
                        else ops = [
                            'in',
                            'not in'
                        ];
                        break;
                    case 'varcharmax':
                        ops = [
                            '=',
                            'startswith',
                            'notstartswith',
                            'contains',
                            'notcontains'
                        ];
                        break;
                    case 'uniqueidentifier':
                        if (property.choice_type === 'none') throw new Error(`Expected uniqueidentifier property to have choice_type ("${property.property_id}").`);
                        ops = [
                            'in',
                            'not in'
                        ];
                        break;
                    case 'bit':
                        ops = [
                            '='
                        ];
                        break;
                    case 'activity':
                        ops = [
                            'in',
                            'not in'
                        ];
                        break;
                    default:
                        throw new Error(`Unsupported property type "${property.type}".`);
                }
                if ($413788c7d08dddf5$export$fa24b530c7fccc85(property)) ops.push('blank', 'notblank');
                return ops;
            }
        default:
            throw new Error(`Unexpected aggregate function result type "${resultType}".`);
    }
}
function $413788c7d08dddf5$export$bce341c22388011b(filter, property, operator) {
    const aggregate = filter.type === 'standard' ? 'max' : filter.aggregate;
    const resultType = $413788c7d08dddf5$export$3604b59051dae160[aggregate];
    switch(resultType){
        case 'decimal':
        case 'int':
            return {
                type: resultType,
                choice_type: 'none'
            };
        case 'inherit-number':
        case 'inherit':
            if (!property) return null;
            switch(property.type){
                case 'medications':
                case 'signature':
                case 'attachment':
                    if (operator === 'blank' || operator === 'notblank') return 'blank';
                    return null;
                case 'bit':
                case 'currency':
                case 'date':
                case 'decimal':
                case 'int':
                case 'varchar100':
                case 'varcharmax':
                case 'uniqueidentifier':
                case 'activity':
                    if (operator === 'blank' || operator === 'notblank') return 'blank';
                    return property;
                default:
                    throw new Error(`Unsupported property type "${property.type}".`);
            }
        default:
            throw new Error(`Unexpected aggregate function result type "${resultType}".`);
    }
}
const $413788c7d08dddf5$export$457cf8f69ee54250 = {
    single_choice: 'single_choice',
    multiple_choice: 'multiple_choice',
    boolean: 'boolean',
    date: 'date',
    decimal: 'decimal',
    currency: 'currency',
    int: 'int',
    row_href: 'row_href',
    composite_address: 'composite_address',
    composite_email: 'composite_email',
    composite_phone: 'composite_phone',
    value_map: 'value_map',
    link: 'link',
    time: 'time'
};
function $413788c7d08dddf5$export$13d77bb70d7b9d75(parameter, properties) {
    if (parameter.aggregate === 'count') return {
        type: 'int'
    };
    const aggregateResultType = $413788c7d08dddf5$export$3604b59051dae160[parameter.aggregate];
    switch(aggregateResultType){
        case 'decimal':
            return {
                type: 'decimal'
            };
        case 'int':
            return {
                type: 'int'
            };
        case 'inherit-number':
        case 'inherit':
            {
                const property = properties.find((p)=>p.property_id === parameter.subquery_property_id);
                if (!property) throw new Error(`Unable to find subquery property ${parameter.subquery_property_id}.`);
                switch(property.type){
                    case 'int':
                        return {
                            type: 'int',
                            property: property
                        };
                    case 'currency':
                    case 'decimal':
                        return {
                            type: 'decimal',
                            property: property
                        };
                    case 'date':
                        return {
                            type: 'datetime',
                            property: property
                        };
                    case 'bit':
                        return {
                            type: 'boolean',
                            property: property
                        };
                    case 'varchar100':
                    case 'varcharmax':
                        return {
                            type: 'string',
                            property: property
                        };
                    default:
                        return {
                            type: null,
                            property: property
                        };
                }
            }
        default:
            throw new Error(`Unexpected aggregate result type "${aggregateResultType}" for subquery property ${parameter.subquery_property_id}.`);
    }
}
function $413788c7d08dddf5$export$292a5b8f6eaffa0b(selected_parameter_values, parameter_output_values) {
    return {
        ...selected_parameter_values ?? {},
        ...Object.entries(parameter_output_values).reduce((acc, [key, value])=>{
            if (value !== null) acc[key] = value;
            return acc;
        }, {})
    };
}
function $413788c7d08dddf5$export$619b3092022ea8ea(parent, parameters) {
    const { parameter_types: parameter_types, parameter_values: parameter_values } = parent;
    const inherited = {};
    for (const parameter of parameters){
        const { name: name, type: type } = parameter;
        if (type === 'expression' || type === 'subquery' || type === 'report-subquery') continue;
        if (type === 'activity' || type === 'organization' || type === 'project' || type === 'user' || type === 'choice') {
            const match = parent.parameters.find((p)=>{
                if (p.name !== name || p.type !== type) return false;
                if (p.type === 'choice') return parameter.type === 'choice' && p.property_id === parameter.property_id;
                if (p.type === 'activity') return parameter.type === 'activity' && p.activity_definition_id === parameter.activity_definition_id;
                return true;
            });
            if (match) inherited[name] = parameter_values[name] ?? match.value;
            continue;
        }
        if ((type === 'literal-date' || type === 'month-date' || type === 'select-date') && [
            'date',
            'datetime'
        ].includes(parameter_types[name])) {
            inherited[name] = parameter_values[name];
            continue;
        }
        if ((type === 'literal-number' || type === 'select-number') && [
            'int',
            'decimal'
        ].includes(parameter_types[name])) {
            inherited[name] = parameter_values[name];
            continue;
        }
    }
    return inherited;
}
function $413788c7d08dddf5$export$8731bf6742d09f4c(search, parameter_values) {
    for (const [key, value] of Object.entries(parameter_values)){
        const name = `parameter_${key.substr(1).toLowerCase()}`;
        if (typeof value === 'string') search.set(name, value);
        else if (typeof value === 'number') search.set(name, value.toString());
        else if (Array.isArray(value)) search.set(name, JSON.stringify(value));
    }
    return search;
}
function $413788c7d08dddf5$export$8e08adbb69aa1ec5(search, parameters) {
    const parameter_values = {};
    const prefix = 'parameter_';
    let count = 0;
    for (let [key, value] of search){
        value = value.trim();
        if (!key.toLowerCase().startsWith(prefix) || value === '') continue;
        const name = '$' + key.substr(prefix.length).toUpperCase();
        const parameter = parameters.find((p)=>p.name === name);
        switch(parameter?.type){
            case 'literal-date':
            case 'month-date':
            case 'select-date':
                if ((0, $629fab7fb0c19ec3$export$a22775fa5e2eebd9)(value, {
                    type: 'string',
                    format: 'date'
                })) {
                    parameter_values[name] = value;
                    count++;
                }
                continue;
            case 'literal-number':
            case 'select-number':
                {
                    const number = parseFloat(value);
                    if (isFinite(number)) {
                        parameter_values[name] = number;
                        count++;
                    }
                    continue;
                }
            case 'activity':
            case 'user':
            case 'organization':
            case 'project':
                {
                    let raw;
                    try {
                        raw = JSON.parse(value);
                    } catch  {
                        continue;
                    }
                    if ((0, $629fab7fb0c19ec3$export$a22775fa5e2eebd9)(raw, {
                        type: 'array',
                        minItems: 1,
                        maxItems: $413788c7d08dddf5$export$f258709b40073be1.inItems,
                        items: (0, $a778f1b6bd4bd30d$export$132ea886f1bee90)
                    }).valid) {
                        parameter_values[name] = raw;
                        count++;
                    }
                    continue;
                }
            case 'choice':
                {
                    let raw;
                    try {
                        raw = JSON.parse(value);
                    } catch  {
                        continue;
                    }
                    if ((0, $629fab7fb0c19ec3$export$a22775fa5e2eebd9)(raw, {
                        type: 'array',
                        minItems: 1,
                        maxItems: $413788c7d08dddf5$export$f258709b40073be1.inItems,
                        items: (0, $a778f1b6bd4bd30d$export$3a1eda45101b1f09)
                    }).valid) {
                        parameter_values[name] = raw;
                        count++;
                    }
                    continue;
                }
        }
    }
    return {
        parameter_values: parameter_values,
        count: count
    };
}
const $413788c7d08dddf5$export$16e3170b54ac652e = [
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_phone.type,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_phone.type,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_email.type,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_email.type,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_email.type,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.primary_phone.type,
    (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_phone.type
];
function $413788c7d08dddf5$export$e203b3e7bd2cf06a({ filters: filters, columns: columns, parameters: parameters }) {
    const map = {
        [(0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.start_date]: {
            min: 'first-started',
            max: 'last-started'
        },
        [(0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.end_date]: {
            min: 'first-ended',
            max: 'last-ended'
        },
        [(0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_date]: {
            min: 'first-created',
            max: 'last-created'
        }
    };
    const rewrite = (subquery)=>{
        if (subquery.type !== 'subquery' && subquery.type !== 'report-subquery' || subquery.aggregate !== 'min' && subquery.aggregate !== 'max' || ![
            (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.start_date,
            (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.end_date,
            (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_date
        ].includes(subquery.subquery_property_id)) return;
        const { aggregate: aggregate, subquery_property_id: subquery_property_id } = subquery;
        subquery.aggregate = map[subquery_property_id][aggregate];
        if ('filters' in subquery) for (const item of subquery.filters ?? [])rewrite(item);
    };
    for (const item of [
        ...filters,
        ...columns,
        ...parameters
    ])rewrite(item);
}


const $6980cc602f309497$var$PARSED_FORM_DATA = Symbol('PARSED_FORM_DATA');
function $6980cc602f309497$export$ae2b2db16f8c0171(data) {
    if (data[$6980cc602f309497$var$PARSED_FORM_DATA]) return data[$6980cc602f309497$var$PARSED_FORM_DATA];
    const obj = Object.create(null);
    const accruedMasks = Object.create(null);
    for (const [key, value] of data){
        let [pointer, type, ...args] = key.split(':');
        if (value instanceof File) {
            const { name: name, size: size, type: type } = value;
            const parsedFile = {
                name: name,
                size: size,
                type: type
            };
            Object.defineProperty(parsedFile, 'file', {
                enumerable: false,
                value: value
            });
            (0, $91beb2998e956c83$export$adaa4cf7ef1b65be)(obj, '/' + pointer, parsedFile);
            continue;
        }
        if (typeof value !== 'string') throw new Error(`Unexpected value type: ${value}`);
        let parsedValue = value// https://www.w3.org/MarkUp/html-spec/html-spec_8.html#SEC8.2.1
        // The form field names and values are escaped: space characters are replaced by '+', and then
        // reserved characters are escaped as per [URL]; that is, non-alphanumeric characters are
        // replaced by `%HH', a percent sign and two hexadecimal digits representing the ASCII code of
        // the character. Line breaks, as in multi-line text field values, are represented as CR LF
        // pairs, i.e. `%0D%0A'.
        .replaceAll('\r\n', '\n');
        type ||= pointer.endsWith('_id') ? 'nullstring' : 'string';
        if (args.includes('parametric') && (0, $413788c7d08dddf5$export$99da40ee05a17718).test(value)) {
            parsedValue = value;
            (0, $91beb2998e956c83$export$adaa4cf7ef1b65be)(obj, '/' + pointer, parsedValue);
            continue;
        }
        switch(type){
            case 'string':
                parsedValue = value;
                break;
            case 'nullstring':
                parsedValue = value === '' ? null : value;
                break;
            case 'boolean':
                parsedValue = value === 'true';
                break;
            case 'number':
                parsedValue = value === '' ? null : parseFloat(value);
                break;
            case 'integer':
                parsedValue = value === '' ? null : parseInt(value, 10);
                break;
            case 'mask-shift':
                {
                    const current = accruedMasks[pointer] ?? 0;
                    parsedValue = current + 2 ** parseInt(value, 10);
                    accruedMasks[pointer] = parsedValue;
                    break;
                }
            case 'mask-sum':
                {
                    const current = accruedMasks[pointer] ?? 0;
                    parsedValue = current + parseInt(value, 10);
                    accruedMasks[pointer] = parsedValue;
                    break;
                }
            case 'date':
                {
                    if (value === '') {
                        parsedValue = null;
                        break;
                    }
                    if (args.includes('relative') && (0, $b78c044e3d911d2e$export$aebd7d4ffee5ebdd)(value)) {
                        parsedValue = value;
                        break;
                    }
                    const d = new Date(value);
                    if (isFinite(d.getTime()) && d.getTime() >= (0, $b78c044e3d911d2e$export$5c333a116e949cdd) && d.getTime() <= (0, $b78c044e3d911d2e$export$a75f2bff57811055)) {
                        parsedValue = d.toISOString().substr(0, 10);
                        break;
                    }
                    parsedValue = null;
                    break;
                }
            case 'month-date':
                {
                    if (value === '') {
                        parsedValue = null;
                        break;
                    }
                    const d = new Date(`${value}-01`);
                    if (isFinite(d.getTime()) && d.getTime() >= (0, $b78c044e3d911d2e$export$5c333a116e949cdd) && d.getTime() <= (0, $b78c044e3d911d2e$export$a75f2bff57811055)) {
                        parsedValue = d.toISOString().substr(0, 10);
                        break;
                    }
                    parsedValue = null;
                    break;
                }
            case 'time':
                parsedValue = (0, $b78c044e3d911d2e$export$ca3f99600512f983)(value);
                break;
            case 'json':
                parsedValue = (0, $3ed036a8a521a6d8$export$b48ee232557adc37)(value);
                break;
            default:
                throw new Error(`Unexpected type directive "${type}" in "${key}".`);
        }
        (0, $91beb2998e956c83$export$adaa4cf7ef1b65be)(obj, '/' + pointer, parsedValue);
    }
    data[$6980cc602f309497$var$PARSED_FORM_DATA] = obj;
    return obj;
}




function $134dd8a762545151$export$10eb477033c32543(locale, responses, propertyMap, dependencies) {
    return dependencies.map((property_id)=>{
        const property = propertyMap[property_id];
        if (!property) return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<li class="color-fg-danger">
        Unknown property ${property_id}
      </li>`;
        const label = property.label;
        const response = responses[`p${property_id}`];
        const answered = response !== undefined && response !== null;
        const displayValue = (0, $c1de6d172f4f6f9e$export$b69667b9fc24675e)({
            property: property,
            value: response,
            locale: locale,
            showScore: true,
            activities: []
        });
        return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`
      <li class="${answered ? 'color-fg-success' : ''}">
        ${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$1d8a03084661a191), answered ? '' : 'v-hidden')} ${label}:
        <em>${displayValue}</em>
      </li>
    `;
    });
}



const $159e4db42da5d545$var$controllers = new WeakSet();
function $159e4db42da5d545$export$2385a24977818dd0(controller) {
    $159e4db42da5d545$var$controllers.add(controller);
    if (controller.shadowRoot) $159e4db42da5d545$export$f5153ed4b04fdf21(controller.shadowRoot);
    $159e4db42da5d545$var$bindElements(controller);
    $159e4db42da5d545$export$905ee29d742fce(controller.ownerDocument);
}
function $159e4db42da5d545$export$f5153ed4b04fdf21(root) {
    $159e4db42da5d545$var$bindElements(root);
    $159e4db42da5d545$export$905ee29d742fce(root);
}
const $159e4db42da5d545$var$observers = new WeakMap();
function $159e4db42da5d545$export$905ee29d742fce(el = document) {
    if ($159e4db42da5d545$var$observers.has(el)) return $159e4db42da5d545$var$observers.get(el);
    let closed = false;
    const observer = new MutationObserver((mutations)=>{
        for (const mutation of mutations){
            if (mutation.type === 'attributes' && mutation.target instanceof Element) $159e4db42da5d545$var$bindActions(mutation.target);
            else if (mutation.type === 'childList' && mutation.addedNodes.length) {
                for (const node of mutation.addedNodes)if (node instanceof Element) $159e4db42da5d545$var$bindElements(node);
            }
        }
    });
    observer.observe(el, {
        childList: true,
        subtree: true,
        attributeFilter: [
            'data-action'
        ]
    });
    const subscription = {
        get closed () {
            return closed;
        },
        unsubscribe () {
            closed = true;
            $159e4db42da5d545$var$observers.delete(el);
            observer.disconnect();
        }
    };
    $159e4db42da5d545$var$observers.set(el, subscription);
    return subscription;
}
function $159e4db42da5d545$var$bindElements(root) {
    for (const el of root.querySelectorAll('[data-action]'))$159e4db42da5d545$var$bindActions(el);
    // Also bind the controller to itself
    if (root instanceof Element && root.hasAttribute('data-action')) $159e4db42da5d545$var$bindActions(root);
}
// Bind a single function to all events to avoid anonymous closure performance penalty.
function $159e4db42da5d545$var$handleEvent(event) {
    const el = event.currentTarget;
    for (const binding of $159e4db42da5d545$var$bindings(el))if (event.type === binding.type) {
        const controller = el.closest(binding.tag);
        if ($159e4db42da5d545$var$controllers.has(controller) && typeof controller[binding.method] === 'function') controller[binding.method](event);
        const root = el.getRootNode();
        if (root instanceof ShadowRoot && $159e4db42da5d545$var$controllers.has(root.host) && root.host.matches(binding.tag)) {
            const shadowController = root.host;
            if (typeof shadowController[binding.method] === 'function') shadowController[binding.method](event);
        }
    }
}
function* $159e4db42da5d545$var$bindings(el) {
    for (const action of (el.getAttribute('data-action') || '').trim().split(/\s+/)){
        const eventSep = action.lastIndexOf(':');
        const methodSep = Math.max(0, action.lastIndexOf('#')) || action.length;
        yield {
            type: action.slice(0, eventSep),
            tag: action.slice(eventSep + 1, methodSep),
            method: action.slice(methodSep + 1) || 'handleEvent'
        };
    }
}
function $159e4db42da5d545$var$bindActions(el) {
    for (const binding of $159e4db42da5d545$var$bindings(el))el.addEventListener(binding.type, $159e4db42da5d545$var$handleEvent);
}


const $89c72635121fe752$export$7e9152eee80b168f = (str)=>String(typeof str === 'symbol' ? str.description : str).replace(/([A-Z]($|[a-z]))/g, '-$1').replace(/--/g, '-').replace(/^-|-$/, '').toLowerCase();
const $89c72635121fe752$export$6e0977d6448738a4 = (str, type = 'property')=>{
    const dashed = $89c72635121fe752$export$7e9152eee80b168f(str);
    if (!dashed.includes('-')) throw new DOMException(`${type}: ${String(str)} is not a valid ${type} name`, 'SyntaxError');
    return dashed;
};


function $ffcf580ef90d17f8$export$6503ec6e8aabbaf(classObject, name) {
    const tagName = name || (0, $89c72635121fe752$export$7e9152eee80b168f)(classObject.name).replace(/-element$/, '');
    try {
        window.customElements.define(tagName, classObject);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window[classObject.name] = customElements.get(tagName);
    } catch (e) {
        // The only reason for window.customElements.define to throw a `NotSupportedError`
        // is if the element has already been defined.
        if (!(e instanceof DOMException && e.name === 'NotSupportedError')) throw e;
    }
    return classObject;
}


/**
 * findTarget will run `querySelectorAll` against the given controller, plus
 * its shadowRoot, returning any the first child that:
 *
 *  - Matches the selector of `[data-target~="tag.name"]` where tag is the
 *  tagName of the given HTMLElement, and `name` is the given `name` argument.
 *
 *  - Closest ascendant of the element, that matches the tagname of the
 *  controller, is the specific instance of the controller itself - in other
 *  words it is not nested in other controllers of the same type.
 *
 */ function $77fe3787e15eb027$export$7b12e7cdde3e579d(controller, name) {
    const tag = controller.tagName.toLowerCase();
    if (controller.shadowRoot) for (const el of controller.shadowRoot.querySelectorAll(`[data-target~="${tag}.${name}"]`)){
        if (!el.closest(tag)) return el;
    }
    for (const el of controller.querySelectorAll(`[data-target~="${tag}.${name}"]`)){
        if (el.closest(tag) === controller) return el;
    }
}
function $77fe3787e15eb027$export$e6c09e60297821e4(controller, name) {
    const tag = controller.tagName.toLowerCase();
    const targets = [];
    if (controller.shadowRoot) {
        for (const el of controller.shadowRoot.querySelectorAll(`[data-targets~="${tag}.${name}"]`))if (!el.closest(tag)) targets.push(el);
    }
    for (const el of controller.querySelectorAll(`[data-targets~="${tag}.${name}"]`))if (el.closest(tag) === controller) targets.push(el);
    return targets;
}





function $b3a0e8a56f0f8cc8$export$8360d16b03002d26(element) {
    for (const template of element.querySelectorAll('template[data-shadowroot]'))if (template.parentElement === element) element.attachShadow({
        mode: template.getAttribute('data-shadowroot') === 'closed' ? 'closed' : 'open'
    }).append(template.content.cloneNode(true));
}




const $eb3c1389b956a11c$var$attrKey = 'attr';
function $eb3c1389b956a11c$export$7aabe8b3a840d2fd(proto, key) {
    (0, $9e554c3b768f72a7$export$6990040ee07315)(proto, $eb3c1389b956a11c$var$attrKey).add(key);
}
/**
 * initializeAttrs is called with a set of class property names (if omitted, it
 * will look for any properties tagged with the `@attr` decorator). With this
 * list it defines property descriptors for each property that map to `data-*`
 * attributes on the HTMLElement instance.
 *
 * It works around Native Class Property semantics - which are equivalent to
 * calling `Object.defineProperty` on the instance upon creation, but before
 * `constructor()` is called.
 *
 * If a class property is assigned to the class body, it will infer the type
 * (using `typeof`) and define an appropriate getter/setter combo that aligns
 * to that type. This means class properties assigned to Numbers can only ever
 * be Numbers, assigned to Booleans can only ever be Booleans, and assigned to
 * Strings can only ever be Strings.
 *
 * This is automatically called as part of `@controller`. If a class uses the
 * `@controller` decorator it should not call this manually.
 */ const $eb3c1389b956a11c$var$initialized = new WeakSet();
function $eb3c1389b956a11c$export$798400a729264cd9(instance, names) {
    if ($eb3c1389b956a11c$var$initialized.has(instance)) return;
    $eb3c1389b956a11c$var$initialized.add(instance);
    const proto = Object.getPrototypeOf(instance);
    const prefix = proto?.constructor?.attrPrefix ?? 'data-';
    if (!names) names = (0, $9e554c3b768f72a7$export$6990040ee07315)(proto, $eb3c1389b956a11c$var$attrKey);
    for (const key of names){
        const value = instance[key];
        const name = (0, $89c72635121fe752$export$6e0977d6448738a4)(`${prefix}${key}`);
        let descriptor = {
            configurable: true,
            get () {
                return this.getAttribute(name) || '';
            },
            set (newValue) {
                this.setAttribute(name, newValue || '');
            }
        };
        if (typeof value === 'number') descriptor = {
            configurable: true,
            get () {
                return Number(this.getAttribute(name) || 0);
            },
            set (newValue) {
                this.setAttribute(name, newValue);
            }
        };
        else if (typeof value === 'boolean') descriptor = {
            configurable: true,
            get () {
                return this.hasAttribute(name);
            },
            set (newValue) {
                this.toggleAttribute(name, newValue);
            }
        };
        Object.defineProperty(instance, key, descriptor);
        if (key in instance && !instance.hasAttribute(name)) descriptor.set.call(instance, value);
    }
}
function $eb3c1389b956a11c$export$ed3b9fa3b306413c(classObject) {
    let observed = classObject.observedAttributes || [];
    const prefix = classObject.attrPrefix ?? 'data-';
    const attrToAttributeName = (name)=>(0, $89c72635121fe752$export$6e0977d6448738a4)(`${prefix}${name}`);
    Object.defineProperty(classObject, 'observedAttributes', {
        configurable: true,
        get () {
            return [
                ...(0, $9e554c3b768f72a7$export$6990040ee07315)(classObject.prototype, $eb3c1389b956a11c$var$attrKey)
            ].map(attrToAttributeName).concat(observed);
        },
        set (attributes) {
            observed = attributes;
        }
    });
}


const $ad59128f5070c7aa$var$dynamicElements = new Map();
const $ad59128f5070c7aa$var$ready = new Promise((resolve)=>{
    if (document.readyState !== 'loading') resolve();
    else document.addEventListener('readystatechange', ()=>resolve(), {
        once: true
    });
});
const $ad59128f5070c7aa$var$firstInteraction = new Promise((resolve)=>{
    const controller = new AbortController();
    controller.signal.addEventListener('abort', ()=>resolve());
    const listenerOptions = {
        once: true,
        passive: true,
        signal: controller.signal
    };
    const handler = ()=>controller.abort();
    document.addEventListener('mousedown', handler, listenerOptions);
    // eslint-disable-next-line github/require-passive-events
    document.addEventListener('touchstart', handler, listenerOptions);
    document.addEventListener('keydown', handler, listenerOptions);
    document.addEventListener('pointerdown', handler, listenerOptions);
});
const $ad59128f5070c7aa$var$visible = (tagName)=>new Promise((resolve)=>{
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries)if (entry.isIntersecting) {
                resolve();
                observer.disconnect();
                return;
            }
        }, {
            // Currently the threshold is set to 256px from the bottom of the viewport
            // with a threshold of 0.1. This means the element will not load until about
            // 2 keyboard-down-arrow presses away from being visible in the viewport,
            // giving us some time to fetch it before the contents are made visible
            rootMargin: '0px 0px 256px 0px',
            threshold: 0.01
        });
        for (const el of document.querySelectorAll(tagName))observer.observe(el);
    });
const $ad59128f5070c7aa$var$strategies = {
    ready: ()=>$ad59128f5070c7aa$var$ready,
    firstInteraction: ()=>$ad59128f5070c7aa$var$firstInteraction,
    visible: $ad59128f5070c7aa$var$visible
};
const $ad59128f5070c7aa$var$pendingElements = new Set();
let $ad59128f5070c7aa$var$scanTimer = null;
function $ad59128f5070c7aa$var$scan(element) {
    $ad59128f5070c7aa$var$pendingElements.add(element);
    if ($ad59128f5070c7aa$var$scanTimer != null) return;
    $ad59128f5070c7aa$var$scanTimer = requestAnimationFrame(()=>{
        $ad59128f5070c7aa$var$scanTimer = null;
        const elements = new Set($ad59128f5070c7aa$var$pendingElements);
        $ad59128f5070c7aa$var$pendingElements.clear();
        if (!$ad59128f5070c7aa$var$dynamicElements.size) return;
        outer: for (const el of elements)for (const tagName of $ad59128f5070c7aa$var$dynamicElements.keys()){
            const child = el instanceof Element && el.matches(tagName) ? el : el.querySelector(tagName);
            if (customElements.get(tagName) || child) {
                const strategyName = child?.getAttribute('data-load-on') || 'ready';
                const strategy = strategyName in $ad59128f5070c7aa$var$strategies ? $ad59128f5070c7aa$var$strategies[strategyName] : $ad59128f5070c7aa$var$strategies.ready;
                // eslint-disable-next-line github/no-then
                for (const cb of $ad59128f5070c7aa$var$dynamicElements.get(tagName) || [])strategy(tagName).then(cb);
                $ad59128f5070c7aa$var$dynamicElements.delete(tagName);
                if (!$ad59128f5070c7aa$var$dynamicElements.size) break outer;
            }
        }
    });
}
let $ad59128f5070c7aa$var$elementLoader;
function $ad59128f5070c7aa$export$f44ed0cb636dc95(tagNameOrObj, singleCallback) {
    if (typeof tagNameOrObj === 'string' && singleCallback) tagNameOrObj = {
        [tagNameOrObj]: singleCallback
    };
    for (const [tagName, callback] of Object.entries(tagNameOrObj)){
        if (!$ad59128f5070c7aa$var$dynamicElements.has(tagName)) $ad59128f5070c7aa$var$dynamicElements.set(tagName, new Set());
        $ad59128f5070c7aa$var$dynamicElements.get(tagName).add(callback);
    }
    $ad59128f5070c7aa$export$d1203567a167490e(document);
}
function $ad59128f5070c7aa$export$d1203567a167490e(target) {
    $ad59128f5070c7aa$var$elementLoader || ($ad59128f5070c7aa$var$elementLoader = new MutationObserver((mutations)=>{
        if (!$ad59128f5070c7aa$var$dynamicElements.size) return;
        for (const mutation of mutations){
            for (const node of mutation.addedNodes)if (node instanceof Element) $ad59128f5070c7aa$var$scan(node);
        }
    }));
    $ad59128f5070c7aa$var$scan(target);
    $ad59128f5070c7aa$var$elementLoader.observe(target, {
        subtree: true,
        childList: true
    });
}


const $9e554c3b768f72a7$var$symbol = Symbol.for('catalyst');
class $9e554c3b768f72a7$export$442891cd14dc451a {
    constructor(classObject, elementName){
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const delegate = this;
        const connectedCallback = classObject.prototype.connectedCallback;
        classObject.prototype.connectedCallback = function() {
            delegate.connectedCallback(this, connectedCallback);
        };
        const disconnectedCallback = classObject.prototype.disconnectedCallback;
        classObject.prototype.disconnectedCallback = function() {
            delegate.disconnectedCallback(this, disconnectedCallback);
        };
        const attributeChangedCallback = classObject.prototype.attributeChangedCallback;
        classObject.prototype.attributeChangedCallback = function(name, oldValue, newValue) {
            delegate.attributeChangedCallback(this, name, oldValue, newValue, attributeChangedCallback);
        };
        let observedAttributes = classObject.observedAttributes || [];
        Object.defineProperty(classObject, 'observedAttributes', {
            configurable: true,
            get () {
                return delegate.observedAttributes(this, observedAttributes);
            },
            set (attributes) {
                observedAttributes = attributes;
            }
        });
        (0, $eb3c1389b956a11c$export$ed3b9fa3b306413c)(classObject);
        (0, $ffcf580ef90d17f8$export$6503ec6e8aabbaf)(classObject, elementName);
    }
    observedAttributes(instance, observedAttributes) {
        return observedAttributes;
    }
    connectedCallback(instance, connectedCallback) {
        instance.toggleAttribute('data-catalyst', true);
        customElements.upgrade(instance);
        (0, $b3a0e8a56f0f8cc8$export$8360d16b03002d26)(instance);
        (0, $eb3c1389b956a11c$export$798400a729264cd9)(instance);
        (0, $159e4db42da5d545$export$2385a24977818dd0)(instance);
        connectedCallback?.call(instance);
        if (instance.shadowRoot) {
            (0, $159e4db42da5d545$export$f5153ed4b04fdf21)(instance.shadowRoot);
            (0, $ad59128f5070c7aa$export$d1203567a167490e)(instance.shadowRoot);
        }
    }
    disconnectedCallback(element, disconnectedCallback) {
        disconnectedCallback?.call(element);
    }
    attributeChangedCallback(instance, name, oldValue, newValue, attributeChangedCallback) {
        (0, $eb3c1389b956a11c$export$798400a729264cd9)(instance);
        if (name !== 'data-catalyst' && attributeChangedCallback) attributeChangedCallback.call(instance, name, oldValue, newValue);
    }
}
function $9e554c3b768f72a7$export$6990040ee07315(proto, name) {
    if (!Object.prototype.hasOwnProperty.call(proto, $9e554c3b768f72a7$var$symbol)) {
        const parent = proto[$9e554c3b768f72a7$var$symbol];
        const map = proto[$9e554c3b768f72a7$var$symbol] = new Map();
        if (parent) for (const [key, value] of parent)map.set(key, new Set(value));
    }
    const map = proto[$9e554c3b768f72a7$var$symbol];
    if (!map.has(name)) map.set(name, new Set());
    return map.get(name);
}


function $dbc93f05a5c2ccff$export$44271b4f0c6a3563(proto, key) {
    (0, $9e554c3b768f72a7$export$6990040ee07315)(proto, 'target').add(key);
    Object.defineProperty(proto, key, {
        configurable: true,
        get () {
            return (0, $77fe3787e15eb027$export$7b12e7cdde3e579d)(this, key);
        }
    });
}
function $dbc93f05a5c2ccff$export$121e5dccf103a51e(proto, key) {
    (0, $9e554c3b768f72a7$export$6990040ee07315)(proto, 'targets').add(key);
    Object.defineProperty(proto, key, {
        configurable: true,
        get () {
            return (0, $77fe3787e15eb027$export$e6c09e60297821e4)(this, key);
        }
    });
}



function $435094da9351c1d8$export$de3b759ab07e4403(classObjectOrName) {
    if (typeof classObjectOrName === 'string') return (classObject)=>{
        new (0, $9e554c3b768f72a7$export$442891cd14dc451a)(classObject, classObjectOrName);
    };
    new (0, $9e554c3b768f72a7$export$442891cd14dc451a)(classObjectOrName);
}










function $62e6ccab3b6d2483$export$361afa7bac659960(locale, alertId = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)(), classes = 'span-12 width-full') {
    const headingId = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    // note: getErrorAlert looks for flash with ul as last child
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<div
    class="flash flash-error py-2 ${classes}"
    id="${alertId}"
    role="group"
    tabindex="-1"
    aria-labelledby="${headingId}"
    hidden
  >
    <h2 style="font-size: 1em;" id="${headingId}">
      ${(0, $b11db1b62d4a8f76$export$a86e9a9bd8b26f8a)[locale]}
    </h2>
    <ul class="pl-3"></ul>
  </div>`;
}

var $3b0dc6b84c86f123$export$5c65f956a8d65120 = /*#__PURE__*/ function(ValidationErrorCode) {
    ValidationErrorCode["EmailUndeliverable"] = "email-undeliverable";
    ValidationErrorCode["ReCaptchaFailed"] = "recaptcha-failed";
    ValidationErrorCode["PasswordTooWeak"] = "password-too-weak";
    ValidationErrorCode["PasswordTooCommon"] = "password-too-common";
    ValidationErrorCode["LoginUnavailable"] = "login-unavailable";
    ValidationErrorCode["EmailAlreadyRegistered"] = "email-already-registered";
    ValidationErrorCode["EmailAlreadyVerified"] = "email-already-verified";
    ValidationErrorCode["EmailNotRegistered"] = "email-not-registered";
    ValidationErrorCode["UserAlreadyOrganizationMember"] = "user-already-organization-member";
    ValidationErrorCode["CannotInviteYourself"] = "cannot-invite-yourself";
    ValidationErrorCode["UserAlreadyInvited"] = "user-already-invited";
    ValidationErrorCode["InvitationEmailSentTooRecently"] = "invitation-email-sent-too-recently";
    ValidationErrorCode["DuplicateName"] = "duplicate-name";
    ValidationErrorCode["ReferencesPreventDeletion"] = "references-prevent-deletion";
    ValidationErrorCode["OrganizationAlreadyInvited"] = "organization-already-invited";
    ValidationErrorCode["OrganizationAlreadyProjectMember"] = "organization-already-project-member";
    return ValidationErrorCode;
}({});
const $3b0dc6b84c86f123$export$34f98ade51897c1e = {
    ["email-undeliverable"]: 'Email address is undeliverable. Contact support for assistance if you believe this to be an error.',
    ["password-too-weak"]: 'Password is too weak.',
    ["password-too-common"]: 'Password is too common.',
    ["recaptcha-failed"]: 'Activity flagged by bot detection. Contact support for assistance if you believe this to be an error.',
    ["login-unavailable"]: '"{value}" is unavailable. {label} must be unique.',
    ["email-already-registered"]: 'Email already registered.',
    ["email-already-verified"]: 'Email already verified. Go ahead and sign-in.',
    ["email-not-registered"]: 'No account matching specified email.',
    ["user-already-organization-member"]: 'User is already a member of the organization.',
    ["cannot-invite-yourself"]: 'You cannot invite yourself.',
    ["user-already-invited"]: 'User already invited.',
    ["invitation-email-sent-too-recently"]: 'Invitation emails cannot be sent more than once per hour.',
    ["duplicate-name"]: '{label} must be unique.',
    ["references-prevent-deletion"]: 'Unable to delete. Record is in use.',
    ["organization-already-invited"]: '"{value}" has already been invited to the project.',
    ["organization-already-project-member"]: 'The organization is already a member of the project.'
};
const $3b0dc6b84c86f123$export$3b74fc4995751e90 = 'validation-error';
function $3b0dc6b84c86f123$export$939b1e8f8fdbed84(obj) {
    return !!obj && typeof obj === 'object' && 'type' in obj && obj.type === $3b0dc6b84c86f123$export$3b74fc4995751e90 && 'message' in obj && typeof obj.message === 'string';
}

const $e82d6689c5c2f33e$export$1514431ed310ac1b = 30;
const $e82d6689c5c2f33e$export$c26822de30dcb83e = /^[a-zA-Z\d](?:[a-zA-Z\d]|-(?=[a-zA-Z\d])){0,29}$/;
const $e82d6689c5c2f33e$export$49a9f30d59ee31c2 = new RegExp($e82d6689c5c2f33e$export$c26822de30dcb83e.source.substr(1, $e82d6689c5c2f33e$export$c26822de30dcb83e.source.length - 2)).source;
const $e82d6689c5c2f33e$var$markdownTerminators = /[\s\\`*^[\]!&<>{}$%@~\-+=:\/_\,\.\?();]/.source;
const $e82d6689c5c2f33e$export$bcd7648bc82e2622 = new RegExp(`(^|${$e82d6689c5c2f33e$var$markdownTerminators})(@${$e82d6689c5c2f33e$export$49a9f30d59ee31c2}/${$e82d6689c5c2f33e$export$49a9f30d59ee31c2})(?:$|${$e82d6689c5c2f33e$var$markdownTerminators})`, 'g');
const $e82d6689c5c2f33e$export$b8d98489a2ee4ef9 = new RegExp(`(^|${$e82d6689c5c2f33e$var$markdownTerminators})(@${$e82d6689c5c2f33e$export$49a9f30d59ee31c2})/(${$e82d6689c5c2f33e$export$49a9f30d59ee31c2})($|${$e82d6689c5c2f33e$var$markdownTerminators})`, 'g');
const $e82d6689c5c2f33e$export$dbb5f91a13f35b86 = /^[a-f0-9]{24}$/;
const $e82d6689c5c2f33e$export$c1524f9be65f4b8a = 14;
const $e82d6689c5c2f33e$export$9ea34356f788bd3a = 70; // auth0 limit is 72
function $e82d6689c5c2f33e$export$8b31925e9d45d86(name) {
    return `:${name}([a-zA-Z\\d](?:[a-zA-Z\\d]|-(?=[a-zA-Z\\d])){0,29})`;
}






function $d926988b2eed7310$export$8ab937f042a29230(target) {
    return target instanceof HTMLSelectElement || target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement;
}
function $d926988b2eed7310$export$51ca0221714b36af(target) {
    if (target instanceof HTMLTextAreaElement || target instanceof HTMLInputElement && (target.type === 'text' || target.type === 'email')) {
        const newValue = target.value.normalize('NFC').trim();
        if (newValue !== target.value) target.value = newValue;
    }
}
function $d926988b2eed7310$var$escapeRegex(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}
function $d926988b2eed7310$var$getPointerSiblingRegex(pointer) {
    const [, base, name] = /(^.*\/)(?:\d+)(\/[^:]*)/.exec(pointer) ?? [];
    if (base === undefined || name === undefined) throw new Error(`Unexpected pointer "${pointer}" for sibling expression.`);
    const source = `^${$d926988b2eed7310$var$escapeRegex(base)}\\d+${$d926988b2eed7310$var$escapeRegex(name)}(?::|$)`;
    return new RegExp(source);
}
function $d926988b2eed7310$export$3ef28703d495bc16(input) {
    const r = $d926988b2eed7310$var$getPointerSiblingRegex(input.name);
    return Array.from(input.form.elements).filter($d926988b2eed7310$export$8ab937f042a29230).filter((el)=>r.test(el.name));
}
function $d926988b2eed7310$export$7d38c4fd1103f2c4(form, disabled) {
    for (const element of form.elements)if (element instanceof HTMLButtonElement && element.type === 'submit' && !element.hasAttribute('name')) element.toggleAttribute('disabled', disabled);
}
function $d926988b2eed7310$export$7f9cba67632f8265(form, busy) {
    for (const element of form.elements)if (element instanceof HTMLButtonElement && element.type === 'submit') element.classList.toggle('btn-busy', busy);
}
function $d926988b2eed7310$export$d711e159ced15444(form) {
    for (const element of form.elements)if (element instanceof HTMLButtonElement && element.type === 'submit' && element.hasAttribute('new') && element.lastElementChild instanceof HTMLSpanElement) element.lastElementChild.textContent = element.getAttribute('new') || (0, $b11db1b62d4a8f76$export$f093e2a834170186)[(0, $c74c4f773f8a11f2$export$180605366c04f0cd)()];
}
function $d926988b2eed7310$export$2d71e4ce1d783c30(form) {
    const disabled = Array.from(form.elements).filter((el)=>$d926988b2eed7310$export$8ab937f042a29230(el) && el.disabled);
    for (const el of disabled)el.disabled = false;
    const data = new FormData(form);
    for (const el of disabled)el.disabled = true;
    return data;
}
function $d926988b2eed7310$export$18cb2924d47bc4a1(iterable) {
    for (const _ of iterable)return false;
    return true;
}


const $84fd3dc30499b2d0$export$56264cd4b3cf388f = 'form-validate';
const $84fd3dc30499b2d0$export$4ad0f6b40344a757 = 'form-validation-error';
const $84fd3dc30499b2d0$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
function $84fd3dc30499b2d0$export$236350842f3cd9bc(input) {
    const labelElement = (input.type === 'checkbox' || input.type === 'radio' ? input.closest('fieldset')?.querySelector('legend') : null) ?? input.labels?.[0];
    const textElement = labelElement?.querySelector('[data-label-text]') ?? labelElement;
    const label = textElement?.textContent ?? input.getAttribute('aria-label');
    if (!label) throw new Error(`${input.nodeName} name="${input.name}" id="${input.id}" has no associated label.`);
    return label.trim();
}
function $84fd3dc30499b2d0$var$getGroup(input) {
    const group = input.closest('.form-group');
    if (!group) throw new Error(`${input.nodeName} type="${input.type}" name="${input.name}" id="${input.id}" is not within a .form-group. Parent #${input.parentElement?.id} ${input.parentElement?.className}`);
    return group;
}
function $84fd3dc30499b2d0$var$getBody(input) {
    const body = input.closest('.form-group-body');
    if (!body) throw new Error(`${input.nodeName} name="${input.name}" id="${input.id}" is not within a .form-group-body`);
    return body;
}
function $84fd3dc30499b2d0$var$createErrorAlert(form) {
    const formLayout = form.classList.contains('row') ? form : form.querySelector('.row') ?? form;
    formLayout.insertAdjacentHTML('afterbegin', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $62e6ccab3b6d2483$export$361afa7bac659960)($84fd3dc30499b2d0$var$locale)));
    return formLayout.firstElementChild;
}
function $84fd3dc30499b2d0$var$getErrorAlert(form, warn = false) {
    const id = form.getAttribute('error-alert');
    const errorAlert = id ? document.getElementById(id) : form.querySelector('.flash:is(.flash-error, .flash-warn):has(ul:last-child)') ?? $84fd3dc30499b2d0$var$createErrorAlert(form);
    if (!errorAlert) throw new Error(`getErrorAlert: No element with id="${id}" found.`);
    errorAlert.classList.toggle('flash-warn', warn);
    errorAlert.classList.toggle('flash-error', !warn);
    const title = errorAlert.firstElementChild;
    title.textContent = warn ? (0, $b11db1b62d4a8f76$export$145bab8279e1c23d)[$84fd3dc30499b2d0$var$locale] : (0, $b11db1b62d4a8f76$export$a86e9a9bd8b26f8a)[$84fd3dc30499b2d0$var$locale];
    return {
        errorAlert: errorAlert,
        errorList: errorAlert.lastElementChild
    };
}
function $84fd3dc30499b2d0$var$createErrorNote(input) {
    const note = document.createElement('p');
    note.id = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    note.hidden = true;
    note.toggleAttribute('validation-note');
    input.setAttribute('aria-describedby', `${note.id} ${input.getAttribute('aria-describedby') || ''}`);
    note.classList.add('note', 'error');
    $84fd3dc30499b2d0$var$getBody(input).after(note);
    return note;
}
function $84fd3dc30499b2d0$export$e0ddcd48746f2dd9(input, message) {
    const note = input.ariaDescribedByElements?.find((el)=>el.hasAttribute('validation-note')) ?? $84fd3dc30499b2d0$var$createErrorNote(input);
    note.textContent = message;
    note.toggleAttribute('hidden', !message);
}
function $84fd3dc30499b2d0$export$2e85a6f149681784(input, label) {
    if (input.closest('[validate-required]')?.getAttribute('validate-required') === 'false') return null;
    const customMessage = input.getAttribute('validate-required-message');
    if (input.required && input.value.trim() === '' && !(input instanceof HTMLSelectElement && (input.options.length === 0 || input.options.length === 1 && input.options[0].value === '')) && input.type !== 'checkbox' && input.type !== 'radio') return customMessage ? customMessage.replaceAll('{label}', label) : (0, $b11db1b62d4a8f76$export$433bde3ee140c661)[$84fd3dc30499b2d0$var$locale](label);
    if (input.type === 'checkbox') {
        const items = input.form?.elements.namedItem(input.name);
        if (!items || !(items instanceof RadioNodeList) || items.item(items.length - 1) !== input || Array.from(items).find((x)=>x.checked)) return null;
        return customMessage ? customMessage.replaceAll('{label}', label) : (0, $b11db1b62d4a8f76$export$433bde3ee140c661)[$84fd3dc30499b2d0$var$locale](label);
    }
    if (input.type === 'radio') {
        const items = input.form?.elements.namedItem(input.name);
        if (!items || !(items instanceof RadioNodeList) || items.item(items.length - 1) !== input || Array.from(items).find((x)=>x.checked && x.value.length)) return null;
        return customMessage ? customMessage.replaceAll('{label}', label) : (0, $b11db1b62d4a8f76$export$433bde3ee140c661)[$84fd3dc30499b2d0$var$locale](label);
    }
    return null;
}
function $84fd3dc30499b2d0$var$validatePattern(input, label) {
    if (input.validity.patternMismatch) return input.getAttribute('pattern-message') ?? (0, $b11db1b62d4a8f76$export$dd0340f9174b778)[$84fd3dc30499b2d0$var$locale](label);
    return null;
}
function $84fd3dc30499b2d0$var$validateStep(input, label) {
    if (input.validity.stepMismatch) {
        const stepString = input.getAttribute('step');
        const step = parseInt(stepString, 10);
        if (!stepString || !Number.isInteger(step)) // failsafe for bad state.
        return `${label} has invalid increment.`;
        if (input.type === 'time') return (0, $b11db1b62d4a8f76$export$4f13f582f2377533)[$84fd3dc30499b2d0$var$locale](label, step / 60);
        if (step === 1) return (0, $b11db1b62d4a8f76$export$cd31f99195471735)[$84fd3dc30499b2d0$var$locale](label);
        return (0, $b11db1b62d4a8f76$export$b79fa817bdc814b1)[$84fd3dc30499b2d0$var$locale](label, step);
    }
    return null;
}
function $84fd3dc30499b2d0$var$validateLoginPattern(input, label) {
    if (input.validity.valid && input.hasAttribute('validate-login') && input.value && !(0, $e82d6689c5c2f33e$export$c26822de30dcb83e).test(input.value)) return (0, $b11db1b62d4a8f76$export$110dcc8e73edbe8a)[$84fd3dc30499b2d0$var$locale](label);
    return null;
}
function $84fd3dc30499b2d0$export$520d31645f260e07(input) {
    return input.value.length > 0 && !input.validity.typeMismatch && !input.validity.patternMismatch && URL.canParse(input.value);
}
function $84fd3dc30499b2d0$var$validateUrl(input, label) {
    if (input.type === 'url' && input.value && !$84fd3dc30499b2d0$export$520d31645f260e07(input)) return (0, $b11db1b62d4a8f76$export$6c61a0cedd6edf45)[$84fd3dc30499b2d0$var$locale](label);
    return null;
}
function $84fd3dc30499b2d0$var$validateEmail(input, label) {
    if (input.type === 'email' && input.value && input.validity.typeMismatch) return (0, $b11db1b62d4a8f76$export$17cc4069ead581d4)[$84fd3dc30499b2d0$var$locale](label);
    return null;
}
function $84fd3dc30499b2d0$var$validateMinLength(input, label) {
    if ((input instanceof HTMLTextAreaElement || input instanceof HTMLInputElement) && // input.validity.tooShort
    input.minLength !== -1 && input.value.length !== 0 && input.value.length < input.minLength) return (0, $b11db1b62d4a8f76$export$9138bb72343fb2ba)[$84fd3dc30499b2d0$var$locale](label, input.minLength);
    return null;
}
function $84fd3dc30499b2d0$var$validateMaxLength(input, label) {
    if ((input instanceof HTMLTextAreaElement || input instanceof HTMLInputElement) && // input.validity.tooLong
    input.maxLength !== -1 && input.value.length !== 0 && input.value.length > input.maxLength) return (0, $b11db1b62d4a8f76$export$eefaf1eea407a083)[$84fd3dc30499b2d0$var$locale](label, input.maxLength);
    return null;
}
function $84fd3dc30499b2d0$var$validateMin(input, label) {
    if (input instanceof HTMLInputElement && input.value.length !== 0 && input.validity.rangeUnderflow) return (0, $b11db1b62d4a8f76$export$76d1215b01ac474d)[$84fd3dc30499b2d0$var$locale](label, input.getAttribute('min'));
    return null;
}
function $84fd3dc30499b2d0$var$validateMax(input, label) {
    if (input instanceof HTMLInputElement && input.validity.rangeOverflow) return (0, $b11db1b62d4a8f76$export$7090c56f2894c141)[$84fd3dc30499b2d0$var$locale](label, input.getAttribute('max'));
    return null;
}
function $84fd3dc30499b2d0$var$validateLessOrEqual(input, label) {
    let otherId;
    let other;
    let dateValue;
    let otherDateValue;
    let timeValue;
    let otherTimeValue;
    const lte = input.hasAttribute('validate-less-or-equal');
    const isValid = (a, b)=>{
        return a < b || lte && a <= b;
    };
    if (input instanceof HTMLInputElement && input.value.length !== 0 && (otherId = input.getAttribute('validate-less-or-equal') ?? input.getAttribute('validate-less')) && (other = document.getElementById(otherId)) && other instanceof HTMLInputElement && other.value.length !== 0 && other.type === input.type && (input.type === 'number' && !isValid(input.valueAsNumber, other.valueAsNumber) || input.type === 'time' && input.valueAsDate && other.valueAsDate && !isValid(input.valueAsDate, other.valueAsDate) || input.type === 'text' && input.name.includes(':time') && other.type === 'text' && other.name.includes(':time') && (timeValue = (0, $b78c044e3d911d2e$export$ca3f99600512f983)(input.value)) && timeValue && (otherTimeValue = (0, $b78c044e3d911d2e$export$ca3f99600512f983)(other.value)) && otherTimeValue && !// special case to allow end time of midnight to be considered greater than start time of the same day
    (otherTimeValue === '00:00' && timeValue > '00:00') && !isValid(timeValue, otherTimeValue) || input.type === 'text' && input.closest('date-input') && other.closest('date-input') && (dateValue = (0, $b78c044e3d911d2e$export$7660134aa4da2247)(input.value)) && dateValue && (otherDateValue = (0, $b78c044e3d911d2e$export$7660134aa4da2247)(other.value)) && otherDateValue && !isValid(dateValue, otherDateValue))) {
        const otherLabel = $84fd3dc30499b2d0$export$236350842f3cd9bc(other);
        return (lte ? (0, $b11db1b62d4a8f76$export$5d0a69f765a632f4) : (0, $b11db1b62d4a8f76$export$ebdc8e5d5931ff1b))[$84fd3dc30499b2d0$var$locale](label, otherLabel);
    }
    return null;
}
function $84fd3dc30499b2d0$var$validateMaxSiblings(input, _label) {
    if (!input.validity.valid || !input.hasAttribute('validate-max-items')) return null;
    const max = +input.getAttribute('validate-max-items');
    const items = (0, $d926988b2eed7310$export$3ef28703d495bc16)(input).filter((x)=>!(x instanceof HTMLInputElement && x.type === 'radio' && !x.checked));
    if (items.length > max && items.slice(max).includes(input)) return (0, $b11db1b62d4a8f76$export$22ec1f3944b408e9)[$84fd3dc30499b2d0$var$locale](max);
    return null;
}
function $84fd3dc30499b2d0$var$validateUniqueSiblings(input, label) {
    if (!input.validity.valid || !input.hasAttribute('validate-unique') || !input.value || input instanceof HTMLInputElement && input.type === 'radio' && !input.checked) return null;
    const items = (0, $d926988b2eed7310$export$3ef28703d495bc16)(input);
    const rawMax = input.getAttribute('validate-unique') || '1';
    const max = parseInt(rawMax, 10);
    if (isNaN(max)) return null;
    if (items.filter((x)=>(0, $50ac586a47aeec42$export$d9ffdbc590df6d8a)(x.value, input.value) && !(x instanceof HTMLInputElement && x.type === 'radio' && !x.checked)).indexOf(input) >= max) return max === 1 ? (0, $b11db1b62d4a8f76$export$edb12e2f2b2628ce)[$84fd3dc30499b2d0$var$locale](label) : (0, $b11db1b62d4a8f76$export$18d990bed133506d)[$84fd3dc30499b2d0$var$locale](label, max);
    return null;
}
const $84fd3dc30499b2d0$var$validators = [
    $84fd3dc30499b2d0$export$2e85a6f149681784,
    $84fd3dc30499b2d0$var$validateStep,
    $84fd3dc30499b2d0$var$validateMinLength,
    $84fd3dc30499b2d0$var$validateMaxLength,
    $84fd3dc30499b2d0$var$validateMin,
    $84fd3dc30499b2d0$var$validateMax,
    $84fd3dc30499b2d0$var$validateUrl,
    $84fd3dc30499b2d0$var$validateLoginPattern,
    $84fd3dc30499b2d0$var$validatePattern,
    $84fd3dc30499b2d0$var$validateEmail,
    $84fd3dc30499b2d0$var$validateLessOrEqual,
    $84fd3dc30499b2d0$var$validateMaxSiblings,
    $84fd3dc30499b2d0$var$validateUniqueSiblings
];
function $84fd3dc30499b2d0$export$86f1725708ac86dc(validator) {
    $84fd3dc30499b2d0$var$validators.push(validator);
}
function $84fd3dc30499b2d0$var$canValidate(target) {
    return (0, $d926988b2eed7310$export$8ab937f042a29230)(target) && target.type !== 'hidden' && !(target.type === 'radio' && !target.required) && !(target.type === 'checkbox' && !target.required);
}
async function $84fd3dc30499b2d0$export$ed692cabb252e59b(form, displayValidity = true, scope = form) {
    const errors = [];
    const { errorAlert: errorAlert, errorList: errorList } = $84fd3dc30499b2d0$var$getErrorAlert(form, displayValidity === 'info');
    if (displayValidity) {
        errorAlert.hidden = true;
        errorList.innerHTML = '';
    }
    // sometimes a group has multiple inputs. Track which ones we've removed the errored class from.
    const clearedGroups = new Set();
    for (const input of form.elements){
        if (scope !== form && !scope.contains(input) || !$84fd3dc30499b2d0$var$canValidate(input)) continue;
        const label = $84fd3dc30499b2d0$export$236350842f3cd9bc(input);
        const group = $84fd3dc30499b2d0$var$getGroup(input);
        if (displayValidity) {
            $84fd3dc30499b2d0$export$e0ddcd48746f2dd9(input, '');
            if (!clearedGroups.has(group)) {
                group.classList.remove('errored');
                clearedGroups.add(group);
            }
        }
        for (const validator of $84fd3dc30499b2d0$var$validators){
            const message = validator(input, label);
            if (!message) continue;
            if (!form.dispatchEvent(new CustomEvent($84fd3dc30499b2d0$export$4ad0f6b40344a757, {
                bubbles: true,
                cancelable: true,
                detail: {
                    validator: validator,
                    form: form,
                    group: group,
                    input: input,
                    label: label,
                    message: message
                }
            }))) continue;
            errors.push({
                input: input,
                message: message
            });
            if (displayValidity) {
                $84fd3dc30499b2d0$export$e0ddcd48746f2dd9(input, message);
                group.classList.toggle('errored', displayValidity === true);
                const linkTarget = $84fd3dc30499b2d0$var$getFirstInputWithName(input) ?? input.closest('.form-group-body')?.querySelector('[id]');
                if (linkTarget) linkTarget.style.scrollMarginTop = `${Math.max(linkTarget.offsetTop - group.offsetTop, 60)}px`;
                errorList.insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<li>
              <a class="Link--primary" href="#${linkTarget?.id}">${message}</a>
            </li>`));
            }
            break;
        }
    }
    const validateEvent = new CustomEvent($84fd3dc30499b2d0$export$56264cd4b3cf388f, {
        bubbles: true,
        detail: {
            errors: []
        }
    });
    form.dispatchEvent(validateEvent);
    errors.push(...validateEvent.detail.errors);
    for (const error of validateEvent.detail.errors){
        if (error.input) {
            $84fd3dc30499b2d0$export$e0ddcd48746f2dd9(error.input, error.message);
            $84fd3dc30499b2d0$var$getGroup(error.input).classList.add('errored');
        }
        errorList.insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<li>
          ${error.input ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<a class="Link--primary" href="#${error.input.id}"
                  >${error.message}</a
                >` : error.message}
        </li>`));
    }
    if (errors.length === 0) return {
        valid: true
    };
    if (displayValidity) {
        errorAlert.hidden = false;
        errorAlert.focus();
    }
    return {
        valid: false,
        errors: errors
    };
}
function $84fd3dc30499b2d0$var$getFirstInputWithName(input) {
    if (input instanceof HTMLInputElement && (input.type === 'checkbox' || input.type === 'radio')) {
        input = input.form?.querySelector(`[name="${input.name}"][type="${input.type}"]`) ?? input;
        return input;
    } else return input;
}
function $84fd3dc30499b2d0$export$b7702f01a27b2311(target) {
    if (!$84fd3dc30499b2d0$var$canValidate(target) && // scenario where a server validation error was added for something that is not normally client-side validated
    !(target instanceof HTMLInputElement && target.closest('.form-group.errored'))) return;
    $84fd3dc30499b2d0$export$e0ddcd48746f2dd9(target, '');
    $84fd3dc30499b2d0$var$getGroup(target).classList.remove('errored');
    const { errorAlert: errorAlert, errorList: errorList } = $84fd3dc30499b2d0$var$getErrorAlert(target.form);
    errorList.querySelectorAll(`a[href="#${target.id}"],a[href="#${$84fd3dc30499b2d0$var$getFirstInputWithName(target).id}"],a[href="#${target.closest('.form-group-body')?.querySelector('[id]')?.id}"]`).forEach((a)=>a.parentElement.remove());
    if (!errorList.firstElementChild) errorAlert.hidden = true;
}
function $84fd3dc30499b2d0$export$7977be5e446db387(form, body) {
    if (!(0, $3b0dc6b84c86f123$export$939b1e8f8fdbed84)(body)) {
        $84fd3dc30499b2d0$export$dd5ae15f22741a23(form);
        return;
    }
    let { property: property, message: message } = body;
    const { errorAlert: errorAlert, errorList: errorList } = $84fd3dc30499b2d0$var$getErrorAlert(form);
    let input = null;
    if (property) for(let i = 0; i < form.elements.length; i++){
        let el = form.elements.item(i);
        if (el instanceof RadioNodeList) el = el.item(0);
        if (el.matches(`:is([name="${property}"],[name^="${property}:"]):not([type="hidden"])`)) {
            input = el;
            break;
        }
    }
    if ((0, $d926988b2eed7310$export$8ab937f042a29230)(input)) {
        const label = $84fd3dc30499b2d0$export$236350842f3cd9bc(input);
        message = message.replaceAll('{label}', label).replaceAll('{value}', input.value);
        $84fd3dc30499b2d0$export$e0ddcd48746f2dd9(input, message);
        const group = $84fd3dc30499b2d0$var$getGroup(input);
        group.classList.add('errored');
        input.style.scrollMarginTop = `${Math.max(input.offsetTop - group.offsetTop, 60)}px`;
        errorList.insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<li>
          <a
            class="Link--primary"
            href="#${input.id || input.closest('.form-group-body')?.querySelector('[id]')?.id}"
            >${message}</a
          >
        </li>`));
    } else errorList.insertAdjacentHTML(`beforeend`, (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<li>${message}</li>`));
    errorAlert.hidden = false;
    errorAlert.focus();
}
function $84fd3dc30499b2d0$export$dd5ae15f22741a23(form) {
    const { errorAlert: errorAlert, errorList: errorList } = $84fd3dc30499b2d0$var$getErrorAlert(form);
    errorList.insertAdjacentHTML(`beforeend`, (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<li>${(0, $b11db1b62d4a8f76$export$f725eab7abaa007d)[$84fd3dc30499b2d0$var$locale]}</li>`));
    errorAlert.hidden = false;
    errorAlert.focus();
}


var $c8a57f0e46e579cb$exports = {};
var $95c5dfe6050132a6$exports = {};
"use strict";
$95c5dfe6050132a6$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $c8a57f0e46e579cb$var$url = new URL(import.meta.resolve("8OSea"));
$c8a57f0e46e579cb$exports = $95c5dfe6050132a6$exports($c8a57f0e46e579cb$var$url.toString(), $c8a57f0e46e579cb$var$url.origin, true);


async function $4eefab57ad9ba157$export$65304d575d5cb543(csv, name, form, lowerCaseKeys = false, transform) {
    const worker = new Worker($c8a57f0e46e579cb$exports);
    await new Promise((resolve)=>worker.addEventListener('message', resolve, {
            once: true
        }));
    const instruction = {
        csv: csv,
        lowerCaseKeys: lowerCaseKeys,
        transform: transform
    };
    worker.postMessage(instruction);
    const event = await new Promise((resolve)=>worker.addEventListener('message', resolve, {
            once: true
        }));
    worker.terminate();
    if (event.data.type === 'csv-error') {
        const error = {
            type: 'validation-error',
            message: `Error opening "${name}". Ensure the file is a valid CSV file.`
        };
        (0, $84fd3dc30499b2d0$export$7977be5e446db387)(form, error);
        return {
            error: true
        };
    }
    return {
        error: false,
        data: event.data.data
    };
}



var $f17ab4f03a3a503d$exports = {};

let $f17ab4f03a3a503d$var$url = new URL(import.meta.resolve("huV3b"));
$f17ab4f03a3a503d$exports = $95c5dfe6050132a6$exports($f17ab4f03a3a503d$var$url.toString(), $f17ab4f03a3a503d$var$url.origin, true);


async function $359745fdaf4956d1$export$bf2e8542514694ef(arrayBuffer, name, form, lowerCaseKeys = false, transform) {
    const worker = new Worker($f17ab4f03a3a503d$exports);
    await new Promise((resolve)=>worker.addEventListener('message', resolve, {
            once: true
        }));
    const instruction = {
        arrayBuffer: await arrayBuffer,
        lowerCaseKeys: lowerCaseKeys,
        transform: transform
    };
    worker.postMessage(instruction);
    const event = await new Promise((resolve)=>worker.addEventListener('message', resolve, {
            once: true
        }));
    worker.terminate();
    if (event.data.type === 'xlsx-error') {
        const error = {
            type: 'validation-error',
            message: `Error opening "${name}". Ensure the file is a valid Excel file.`
        };
        (0, $84fd3dc30499b2d0$export$7977be5e446db387)(form, error);
        return {
            error: true
        };
    }
    return {
        error: false,
        data: event.data.data
    };
}




function $80a2320123ddcd02$export$89348ae70780cd7a(element) {
    const event = new Event('change', {
        bubbles: true
    });
    element.dispatchEvent(event);
    return event;
}
function $80a2320123ddcd02$export$9657601bf1e130ee(element) {
    'scrollIntoViewIfNeeded' in element && typeof element.scrollIntoViewIfNeeded === 'function' ? element.scrollIntoViewIfNeeded() : element.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
    });
}
function $80a2320123ddcd02$export$956fd4dade47957a(element) {
    if (!element) return false;
    const selector = ':is(select,input,textarea,button:is(.btn,.btn-octicon,.btn-link),a,summary):not([hidden],[type="hidden"],.sr-only,[readonly],[tabindex="-1"],[data-action*="click:editable-list#removeListItem"],.btn-close)';
    const target = element instanceof HTMLElement && element.matches(selector) ? element : element.querySelector(selector);
    if (target) {
        if (target instanceof HTMLInputElement) target.select();
        else if (target instanceof HTMLTextAreaElement) target.setSelectionRange(target.value.length, target.value.length);
        target.focus();
        return true;
    }
    return false;
}
function $80a2320123ddcd02$export$e3607ec2d7a891c4(element, classname) {
    if (element.classList.contains(classname)) {
        element.classList.remove(classname);
        setTimeout($80a2320123ddcd02$export$e3607ec2d7a891c4, 0, element, classname);
        return;
    }
    element.classList.add(classname);
    const remove = ()=>element.classList.remove(classname);
    element.addEventListener('animationend', remove);
    element.addEventListener('animationcancel', remove);
}




let $64c6cd85abd03778$var$loaded = undefined;
function $64c6cd85abd03778$export$29933d84054794ee() {
    if ($64c6cd85abd03778$var$loaded === undefined) $64c6cd85abd03778$var$loaded = new Promise((resolve, reject)=>{
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
        script.onload = ()=>resolve();
        script.onerror = reject;
        document.head.appendChild(script);
    });
    return $64c6cd85abd03778$var$loaded;
}
async function $64c6cd85abd03778$var$recaptchaReady() {
    await $64c6cd85abd03778$export$29933d84054794ee();
    return new Promise((resolve)=>grecaptcha.ready(resolve));
}
async function $64c6cd85abd03778$export$e84dc4729f1af205(action = 'submit') {
    await $64c6cd85abd03778$var$recaptchaReady;
    return grecaptcha.execute(RECAPTCHA_SITE_KEY, {
        action: action
    });
}




const $ab6f099c20a34e1f$export$d97beb036594a815 = 'form-before-validate-submit';
const $ab6f099c20a34e1f$export$ee9f6aa6c23bab6c = 'form-before-submit';
const $ab6f099c20a34e1f$export$7acd55e6ec74c9ed = 'form-after-submit';
const $ab6f099c20a34e1f$export$707ab90452beb68e = 'form-after-submit-data';
const $ab6f099c20a34e1f$export$45a4a6ccc6565969 = 'form-server-validation-error';
class $ab6f099c20a34e1f$export$eff824212e04ca3f extends HTMLElement {
    submitting = null;
    initialData = new FormData();
    toDispose = [];
    isDirty = false;
    commitTimeout = 0;
    mutationTimeout = 0;
    observer;
    busyCount = 0;
    busyPromise = undefined;
    resolveBusyPromise = ()=>{};
    constructor(){
        super();
    }
    get isNew() {
        return this.hasAttribute('new');
    }
    get canSubmit() {
        return this.isDirty || this.isNew;
    }
    get unloadPromptRequired() {
        return this.isDirty && this.getAttribute('unload-prompt') !== 'false';
    }
    setBusy(work) {
        if (this.busyCount === 0) this.busyPromise = new Promise((resolve)=>{
            this.resolveBusyPromise = resolve;
        });
        this.busyCount++;
        work.finally(()=>{
            this.busyCount--;
            if (this.busyCount === 0) {
                this.busyPromise = undefined;
                this.resolveBusyPromise();
            }
        });
    }
    connectedCallback() {
        const form = this.parentElement;
        if (!(form instanceof HTMLFormElement)) return;
        form.setAttribute('novalidate', '');
        this.initialData = (0, $d926988b2eed7310$export$2d71e4ce1d783c30)(form);
        this.subscribe(window, 'input', this);
        this.subscribe(window, 'change', this);
        this.subscribe(window, 'mousedown', this);
        this.subscribe(form, 'submit', this);
        this.subscribe(window, 'keydown', this);
        this.subscribe(form, 'details-menu-selected', this);
        this.subscribe(form, 'auto-complete-change', this);
        this.observer = new MutationObserver(()=>{
            clearTimeout(this.mutationTimeout);
            this.mutationTimeout = setTimeout(()=>this.setDirty(), 300);
        });
        this.observer.observe(form, {
            subtree: true,
            childList: true
        });
        (0, $d926988b2eed7310$export$7d38c4fd1103f2c4)(form, !this.isNew);
        if (this.hasAttribute('recaptcha')) {
            (0, $64c6cd85abd03778$export$29933d84054794ee)();
            if (!form.querySelector('[href^="https://policies.google.com"]')) form.insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<p class="note m-0 lh-default">
              ${(0, $b11db1b62d4a8f76$export$9783dfaf4b8f5180)[(0, $c74c4f773f8a11f2$export$180605366c04f0cd)()]}
            </p>`));
        }
    }
    disconnectedCallback() {
        clearTimeout(this.commitTimeout);
        clearTimeout(this.mutationTimeout);
        for (const dispose of this.toDispose)dispose();
        this.observer?.disconnect();
        window.removeEventListener('beforeunload', this);
    }
    subscribe(target, type, listener) {
        const options = {
            capture: type === 'details-menu-selected'
        };
        target.addEventListener(type, listener, options);
        this.toDispose.push(()=>target.removeEventListener(type, listener, options));
    }
    setDirty() {
        const form = this.parentElement;
        const initial = new URLSearchParams(this.initialData).toString();
        const current = new URLSearchParams((0, $d926988b2eed7310$export$2d71e4ce1d783c30)(form)).toString();
        this.isDirty = current !== initial;
        (0, $d926988b2eed7310$export$7d38c4fd1103f2c4)(form, !this.canSubmit);
        // https://web.dev/articles/bfcache
        window.removeEventListener('beforeunload', this);
        if (this.unloadPromptRequired) window.addEventListener('beforeunload', this);
    }
    acceptChanges() {
        const form = this.parentElement;
        this.initialData = (0, $d926988b2eed7310$export$2d71e4ce1d783c30)(form);
        this.setDirty();
    }
    confirmImplicitSubmit() {
        const message = this.getAttribute('implicit-submit-confirmation');
        return message ? Promise.resolve(confirm(message)) : Promise.resolve(true);
    }
    handleEvent(event) {
        switch(event.type){
            case 'submit':
                this.handleSubmitEvent(event);
                break;
            case 'beforeunload':
                this.handleUnloadEvent(event);
                break;
            case 'input':
                this.scheduleCommit(event);
                break;
            case 'change':
            case 'mousedown':
                this.commit(event);
                break;
            case 'auto-complete-change':
                this.commit({
                    type: 'change',
                    target: event.target.inputElement
                });
                break;
            case 'keydown':
                this.handleKeyDown(event);
                break;
            case 'details-menu-selected':
                this.setDirty();
                break;
            default:
                throw new Error(`Unexpected event "${event.type}".`);
        }
    }
    isFormValueElementEvent(event) {
        return (0, $d926988b2eed7310$export$8ab937f042a29230)(event.target) && event.target.form === this.parentElement;
    }
    scheduleCommit(event) {
        if (!this.isFormValueElementEvent(event)) return;
        (0, $84fd3dc30499b2d0$export$b7702f01a27b2311)(event.target);
        clearTimeout(this.commitTimeout);
        this.commitTimeout = setTimeout(this.commit, 300, event);
    }
    commit = (event)=>{
        if (!this.isFormValueElementEvent(event)) return;
        const { type: type, target: target } = event;
        const normalized = target instanceof HTMLTextAreaElement || target instanceof HTMLInputElement && [
            'text',
            'email'
        ].includes(target.type) ? target.value.normalize('NFC').trim() : target.value;
        // Normalize on change.
        if (type === 'change' && target.value !== normalized) target.value = normalized;
        // Workaround change normalization interfering with spellcheck corrections on Edge Windows
        // by normalizing early, on mousedown.
        // https://support.cumulus.care/a/tickets/2778
        if (type === 'mousedown') {
            if (target.value !== normalized) {
                target.value = normalized;
                // Dispatch change, which will call commit() again.
                (0, $80a2320123ddcd02$export$89348ae70780cd7a)(target);
            }
            // Stop processing the commit.
            return;
        }
        (0, $84fd3dc30499b2d0$export$b7702f01a27b2311)(target);
        clearTimeout(this.commitTimeout);
        this.setDirty();
    };
    async handleUnloadEvent(event) {
        if (!this.unloadPromptRequired) return;
        event.preventDefault();
        event.returnValue = 'You have unsaved work.'; // browser overrides this text
    }
    handleKeyDown(event) {
        if (!(event.ctrlKey || event.metaKey) || event.shiftKey || event.altKey || event.key !== 's' || event.defaultPrevented || this.getAttribute('submit-shortcut') === 'false' || this.getAttribute('unload-prompt') === 'false') return;
        const closestBehavior = event.target instanceof Element && event.target.closest('form')?.querySelector('form-behavior');
        if (closestBehavior && closestBehavior !== this) return;
        event.preventDefault();
        if ((0, $d926988b2eed7310$export$8ab937f042a29230)(event.target)) {
            event.target.blur();
            event.target.focus();
        }
        this.setDirty();
        if (!this.canSubmit) return;
        const form = this.parentElement;
        form.requestSubmit();
    }
    async handleSubmitEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        this.submit(event.submitter);
    }
    submit(submitter) {
        if (!this.submitting) this.submitting = this.submitInternal(submitter);
        return this.submitting;
    }
    async submitInternal(submitter) {
        await this.busyPromise;
        const form = this.parentElement;
        const recaptcha = this.hasAttribute('recaptcha');
        try {
            (0, $d926988b2eed7310$export$7f9cba67632f8265)(form, true);
            const beforeValidateSubmitEvent = new CustomEvent($ab6f099c20a34e1f$export$d97beb036594a815, {
                bubbles: true,
                cancelable: true,
                detail: {
                    form: form
                }
            });
            if (!this.dispatchEvent(beforeValidateSubmitEvent)) return;
            const body = (0, $d926988b2eed7310$export$2d71e4ce1d783c30)(form);
            if (submitter?.hasAttribute('name') && submitter.hasAttribute('value')) body.set(submitter.getAttribute('name'), submitter.getAttribute('value'));
            const [{ valid: valid }, recaptchaToken] = await Promise.all([
                (0, $84fd3dc30499b2d0$export$ed692cabb252e59b)(form),
                recaptcha ? (0, $64c6cd85abd03778$export$e84dc4729f1af205)() : Promise.resolve(null)
            ]);
            if (!valid) return;
            const beforeSubmitEvent = new CustomEvent($ab6f099c20a34e1f$export$ee9f6aa6c23bab6c, {
                detail: body,
                bubbles: true,
                cancelable: true
            });
            if (!this.dispatchEvent(beforeSubmitEvent)) return;
            const afterSubmitEvent = new CustomEvent($ab6f099c20a34e1f$export$7acd55e6ec74c9ed, {
                detail: body,
                bubbles: true
            });
            if (!form.hasAttribute('action')) {
                this.dispatchEvent(afterSubmitEvent);
                return;
            }
            const method = submitter?.getAttribute('formmethod') ?? form.method;
            const action = submitter?.getAttribute('formaction') ?? form.action;
            if (method === 'get' && this.hasAttribute('navigation')) {
                const params = new URLSearchParams(body);
                this.navigate(this.getAttribute('navigation'), `${form.action}?${params}`);
                return;
            }
            const url = new URL(action || location.href, location.origin);
            const init = {
                method: method,
                body: body
            };
            if (url.searchParams.has('_method')) {
                init.method = url.searchParams.get('_method');
                url.searchParams.delete('_method');
            }
            if (init.method === 'get') {
                delete init.body;
                for (const [key, value] of body){
                    if (typeof value !== 'string') throw new Error(`Cannot use non-string value in GET request.`);
                    url.searchParams.set(key, value);
                }
            }
            if (init.method === 'delete' && (0, $d926988b2eed7310$export$18cb2924d47bc4a1)(body.keys())) delete init.body; // cloudflare throws 400 when DELETE is used with form data body.
            const request = new Request(url.href, init);
            if (this.hasAttribute('authorization')) request.headers.set('authorization', `Bearer ${this.getAttribute('authorization')}`);
            if (recaptchaToken) request.headers.set('recaptcha-token', recaptchaToken);
            if (this.hasAttribute('accept')) request.headers.set('accept', this.getAttribute('accept'));
            const response = await fetch(request);
            (0, $d926988b2eed7310$export$7f9cba67632f8265)(form, false);
            if (response.ok) {
                if (submitter?.hasAttribute('name')) body.delete(submitter.getAttribute('name'));
                this.initialData = body;
                this.removeAttribute('new');
                form.action = response.headers.get('x-cumulus-form-action') ?? form.action;
                this.setDirty();
                (0, $d926988b2eed7310$export$d711e159ced15444)(form);
                this.dispatchEvent(afterSubmitEvent);
                this.dispatchEvent(new CustomEvent($ab6f099c20a34e1f$export$707ab90452beb68e, {
                    detail: response,
                    bubbles: true
                }));
                this.navigate(response.headers.get('navigation') ?? this.getAttribute('navigation'), response.headers.get('location'));
            } else if (response.status === 400) {
                const body = response.headers.get('content-type') === 'application/json' ? await response.json() : null;
                (0, $84fd3dc30499b2d0$export$7977be5e446db387)(form, body);
                this.dispatchEvent(new CustomEvent($ab6f099c20a34e1f$export$45a4a6ccc6565969, {
                    bubbles: true
                }));
            } else if (!(0, $8f2070e09d7bee6a$export$91cdf58e199a84d0)(response)) (0, $84fd3dc30499b2d0$export$dd5ae15f22741a23)(form);
        } finally{
            this.submitting = null;
            (0, $d926988b2eed7310$export$7f9cba67632f8265)(form, false);
        }
    }
    navigate(navigation, href) {
        switch(navigation){
            case null:
                break;
            case 'follow':
                if (href) location.href = href;
                break;
            case 'replace':
                if (href) location.replace(href);
                break;
            case 'replace-state':
                if (href) history.replaceState(undefined, '', href);
                break;
            case 'modal':
                if (href) {
                    const frag = document.createElement('include-fragment');
                    frag.src = href;
                    const modal = document.createElement('modal-content');
                    modal.append(frag);
                    document.body.append(modal);
                }
                break;
            case 'reload':
                location.reload();
                break;
            default:
                throw new Error(`Unexpected submit attribute value.`);
        }
    }
}
if (!window.customElements.get('form-behavior')) {
    window.FormBehaviorElement = $ab6f099c20a34e1f$export$eff824212e04ca3f;
    window.customElements.define('form-behavior', $ab6f099c20a34e1f$export$eff824212e04ca3f);
}









var $09b21c92f652e598$export$902eb194f883041a = 2, $09b21c92f652e598$export$aca53469ff012f69 = 3, $09b21c92f652e598$export$8af5e2d4f952c9f0 = 4, $09b21c92f652e598$export$4b4c4ef3a93a84d8 = 5, $09b21c92f652e598$export$67379271b4d26982 = 6, $09b21c92f652e598$export$230d7efa1736763e = 7, $09b21c92f652e598$export$329adfa5d98f30d5 = 8, $09b21c92f652e598$export$cf55d1bff75690da = 9, $09b21c92f652e598$export$3d914d751c5a82b8 = 10, $09b21c92f652e598$export$59510b5000cc9845 = 11, $09b21c92f652e598$export$5885cc5c5726058b = 12, $09b21c92f652e598$export$166201854b6928 = 13, $09b21c92f652e598$export$7f506b34fdef1832 = 14, $09b21c92f652e598$export$2f339926cb9fdf8b = 15, $09b21c92f652e598$export$57525e83c912026f = 16, $09b21c92f652e598$export$b395009ca7f092c7 = 17, $09b21c92f652e598$export$633927de1c6436f9 = 18, $09b21c92f652e598$export$74f94c628b84d921 = 19, $09b21c92f652e598$export$afa7aa09bb57d54f = 20, $09b21c92f652e598$export$893a2be9220efb8b = 21, $09b21c92f652e598$export$bb0a446c22f826c7 = 22, $09b21c92f652e598$export$add304fab23e505a = 23, $09b21c92f652e598$export$85059ac6bee8a624 = 24, $09b21c92f652e598$export$8ffe6fa0f85bec13 = 25, $09b21c92f652e598$export$6b636bdca7063f33 = 26, $09b21c92f652e598$export$88a597d0c7ae97b = 27, $09b21c92f652e598$export$1aad44a7533f8ad8 = 28, $09b21c92f652e598$export$fc88ff6ef7948967 = 29, $09b21c92f652e598$export$86319a0886767dcb = 30, $09b21c92f652e598$export$8df7bf301eafa719 = 31;
var $09b21c92f652e598$export$74921a9774a80542 = 1, $09b21c92f652e598$export$ed91b2a31d0810c8 = 2, $09b21c92f652e598$export$ce37e184d908d785 = 4, $09b21c92f652e598$export$be74dcf36d511131 = 8, $09b21c92f652e598$export$21c466265830bc3a = 16;
function $09b21c92f652e598$var$ee(e) {
    switch(e){
        case $09b21c92f652e598$export$74921a9774a80542:
            return "href";
        case $09b21c92f652e598$export$ed91b2a31d0810c8:
            return "src";
        case $09b21c92f652e598$export$ce37e184d908d785:
            return "class";
        case $09b21c92f652e598$export$be74dcf36d511131:
            return "checked";
        case $09b21c92f652e598$export$21c466265830bc3a:
            return "start";
    }
}
var $09b21c92f652e598$var$ne = (e)=>{
    switch(e){
        case 1:
            return 3;
        case 2:
            return 4;
        case 3:
            return 5;
        case 4:
            return 6;
        case 5:
            return 7;
        default:
            return 8;
    }
}, $09b21c92f652e598$var$te = $09b21c92f652e598$var$ne;
var $09b21c92f652e598$var$O = 24;
function $09b21c92f652e598$export$8f49e4af10703ce3(e) {
    let c = new Uint32Array($09b21c92f652e598$var$O);
    return c[0] = 1, {
        renderer: e,
        text: "",
        pending: "",
        tokens: c,
        len: 0,
        token: 1,
        fence_end: 0,
        blockquote_idx: 0,
        hr_char: "",
        hr_chars: 0,
        fence_start: 0,
        spaces: new Uint8Array($09b21c92f652e598$var$O),
        indent: "",
        indent_len: 0,
        table_state: 0
    };
}
function $09b21c92f652e598$export$1bb76c36683ac7c2(e) {
    e.pending.length > 0 && $09b21c92f652e598$export$fd28f50634d220c2(e, `
`);
}
function $09b21c92f652e598$var$a(e) {
    e.text.length !== 0 && (e.renderer.add_text(e.renderer.data, e.text), e.text = "");
}
function $09b21c92f652e598$var$_(e) {
    e.len -= 1, e.token = e.tokens[e.len], e.renderer.end_token(e.renderer.data);
}
function $09b21c92f652e598$var$i(e, c) {
    (e.tokens[e.len] === 24 || e.tokens[e.len] === 23) && c !== 25 && $09b21c92f652e598$var$_(e), e.len += 1, e.tokens[e.len] = c, e.token = c, e.renderer.add_token(e.renderer.data, c);
}
function $09b21c92f652e598$var$re(e, c, n) {
    for(; n <= e.len;){
        if (e.tokens[n] === c) return n;
        n += 1;
    }
    return -1;
}
function $09b21c92f652e598$var$l(e, c) {
    for(e.fence_start = 0; e.len > c;)$09b21c92f652e598$var$_(e);
}
function $09b21c92f652e598$var$u(e, c) {
    let n = 0;
    for(let t = 0; t <= e.len && (c -= e.spaces[t], !(c < 0)); t += 1)switch(e.tokens[t]){
        case 9:
        case 10:
        case 20:
        case 25:
            n = t;
            break;
    }
    for(; e.len > n;)$09b21c92f652e598$var$_(e);
    return c;
}
function $09b21c92f652e598$var$A(e, c) {
    let n = -1, t = -1;
    for(let s = e.blockquote_idx + 1; s <= e.len; s += 1)if (e.tokens[s] === 25) {
        if (e.indent_len < e.spaces[s]) {
            t = -1;
            break;
        }
        t = s;
    } else e.tokens[s] === c && (n = s);
    return t === -1 ? n === -1 ? ($09b21c92f652e598$var$l(e, e.blockquote_idx), $09b21c92f652e598$var$i(e, c), !0) : ($09b21c92f652e598$var$l(e, n), !1) : ($09b21c92f652e598$var$l(e, t), $09b21c92f652e598$var$i(e, c), !0);
}
function $09b21c92f652e598$var$g(e, c) {
    $09b21c92f652e598$var$i(e, 25), e.spaces[e.len] = e.indent_len + c, $09b21c92f652e598$var$E(e), e.token = 103;
}
function $09b21c92f652e598$var$E(e) {
    e.indent = "", e.indent_len = 0, e.pending = "";
}
function $09b21c92f652e598$var$N(e) {
    switch(e){
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return !0;
        default:
            return !1;
    }
}
function $09b21c92f652e598$var$ie(e) {
    switch(e){
        case 32:
        case 58:
        case 59:
        case 41:
        case 44:
        case 33:
        case 46:
        case 63:
        case 93:
        case 10:
            return !0;
        default:
            return !1;
    }
}
function $09b21c92f652e598$var$se(e) {
    return $09b21c92f652e598$var$N(e) || $09b21c92f652e598$var$ie(e);
}
function $09b21c92f652e598$export$fd28f50634d220c2(e, c) {
    for (let n of c){
        if (e.token === 101) {
            switch(n){
                case " ":
                    e.indent_len += 1;
                    continue;
                case "	":
                    e.indent_len += 4;
                    continue;
            }
            let s = $09b21c92f652e598$var$u(e, e.indent_len);
            e.indent_len = 0, e.token = e.tokens[e.len], s > 0 && $09b21c92f652e598$export$fd28f50634d220c2(e, " ".repeat(s));
        }
        let t = e.pending + n;
        switch(e.token){
            case 21:
            case 1:
            case 20:
            case 24:
            case 23:
                switch(e.pending[0]){
                    case void 0:
                        e.pending = n;
                        continue;
                    case " ":
                        e.pending = n, e.indent += " ", e.indent_len += 1;
                        continue;
                    case "	":
                        e.pending = n, e.indent += "	", e.indent_len += 4;
                        continue;
                    case `
`:
                        if (e.tokens[e.len] === 25 && e.token === 21) {
                            $09b21c92f652e598$var$_(e), $09b21c92f652e598$var$E(e), e.pending = n;
                            continue;
                        }
                        $09b21c92f652e598$var$l(e, e.blockquote_idx), $09b21c92f652e598$var$E(e), e.blockquote_idx = 0, e.fence_start = 0, e.pending = n;
                        continue;
                    case "#":
                        switch(n){
                            case "#":
                                if (e.pending.length < 6) {
                                    e.pending = t;
                                    continue;
                                }
                                break;
                            case " ":
                                $09b21c92f652e598$var$u(e, e.indent_len), $09b21c92f652e598$var$i(e, $09b21c92f652e598$var$te(e.pending.length)), $09b21c92f652e598$var$E(e);
                                continue;
                        }
                        break;
                    case ">":
                        {
                            let r = $09b21c92f652e598$var$re(e, 20, e.blockquote_idx + 1);
                            r === -1 ? ($09b21c92f652e598$var$l(e, e.blockquote_idx), e.blockquote_idx += 1, e.fence_start = 0, $09b21c92f652e598$var$i(e, 20)) : e.blockquote_idx = r, $09b21c92f652e598$var$E(e), e.pending = n;
                            continue;
                        }
                    case "-":
                    case "*":
                    case "_":
                        if (e.hr_chars === 0 && (e.hr_chars = 1, e.hr_char = e.pending), e.hr_chars > 0) {
                            switch(n){
                                case e.hr_char:
                                    e.hr_chars += 1, e.pending = t;
                                    continue;
                                case " ":
                                    e.pending = t;
                                    continue;
                                case `
`:
                                    if (e.hr_chars < 3) break;
                                    $09b21c92f652e598$var$u(e, e.indent_len), e.renderer.add_token(e.renderer.data, 22), e.renderer.end_token(e.renderer.data), $09b21c92f652e598$var$E(e), e.hr_chars = 0;
                                    continue;
                            }
                            e.hr_chars = 0;
                        }
                        if (e.pending[0] !== "_" && e.pending[1] === " ") {
                            $09b21c92f652e598$var$A(e, 23), $09b21c92f652e598$var$g(e, 2), $09b21c92f652e598$export$fd28f50634d220c2(e, t.slice(2));
                            continue;
                        }
                        break;
                    case "`":
                        if (e.pending.length < 3) {
                            if (n === "`") {
                                e.pending = t, e.fence_start = t.length;
                                continue;
                            }
                            e.fence_start = 0;
                            break;
                        }
                        switch(n){
                            case "`":
                                e.pending.length === e.fence_start ? (e.pending = t, e.fence_start = t.length) : ($09b21c92f652e598$var$i(e, 2), $09b21c92f652e598$var$E(e), e.fence_start = 0, $09b21c92f652e598$export$fd28f50634d220c2(e, t));
                                continue;
                            case `
`:
                                $09b21c92f652e598$var$u(e, e.indent_len), $09b21c92f652e598$var$i(e, 10), e.pending.length > e.fence_start && e.renderer.set_attr(e.renderer.data, $09b21c92f652e598$export$ce37e184d908d785, e.pending.slice(e.fence_start)), $09b21c92f652e598$var$E(e), e.token = 101;
                                continue;
                            default:
                                e.pending = t;
                                continue;
                        }
                    case "+":
                        if (n !== " ") break;
                        $09b21c92f652e598$var$A(e, 23), $09b21c92f652e598$var$g(e, 2);
                        continue;
                    case "0":
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                        if (e.pending[e.pending.length - 1] === ".") {
                            if (n !== " ") break;
                            $09b21c92f652e598$var$A(e, 24) && e.pending !== "1." && e.renderer.set_attr(e.renderer.data, $09b21c92f652e598$export$21c466265830bc3a, e.pending.slice(0, -1)), $09b21c92f652e598$var$g(e, e.pending.length + 1);
                            continue;
                        } else {
                            let r = n.charCodeAt(0);
                            if (r === 46 || $09b21c92f652e598$var$N(r)) {
                                e.pending = t;
                                continue;
                            }
                        }
                        break;
                    case "|":
                        $09b21c92f652e598$var$l(e, e.blockquote_idx), $09b21c92f652e598$var$i(e, 27), $09b21c92f652e598$var$i(e, 28), e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                        continue;
                }
                let s = t;
                if (e.token === 21) e.token = e.tokens[e.len], e.renderer.add_token(e.renderer.data, 21), e.renderer.end_token(e.renderer.data);
                else if (e.indent_len >= 4) {
                    let r = 0;
                    for(; r < 4; r += 1)if (e.indent[r] === "	") {
                        r = r + 1;
                        break;
                    }
                    s = e.indent.slice(r) + t, $09b21c92f652e598$var$i(e, 9);
                } else $09b21c92f652e598$var$i(e, 2);
                $09b21c92f652e598$var$E(e), $09b21c92f652e598$export$fd28f50634d220c2(e, s);
                continue;
            case 27:
                if (e.table_state === 1) switch(n){
                    case "-":
                    case " ":
                    case "|":
                    case ":":
                        e.pending = t;
                        continue;
                    case `
`:
                        e.table_state = 2, e.pending = "";
                        continue;
                    default:
                        $09b21c92f652e598$var$_(e), e.table_state = 0;
                        break;
                }
                else switch(e.pending){
                    case "|":
                        $09b21c92f652e598$var$i(e, 28), e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                        continue;
                    case `
`:
                        $09b21c92f652e598$var$_(e), e.pending = "", e.table_state = 0, $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                        continue;
                }
                break;
            case 28:
                switch(e.pending){
                    case "":
                        break;
                    case "|":
                        $09b21c92f652e598$var$i(e, 29), $09b21c92f652e598$var$_(e), e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                        continue;
                    case `
`:
                        $09b21c92f652e598$var$_(e), e.table_state = Math.min(e.table_state + 1, 2), e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                        continue;
                    default:
                        $09b21c92f652e598$var$i(e, 29), $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                        continue;
                }
                break;
            case 29:
                if (e.pending === "|") {
                    $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                    continue;
                }
                break;
            case 9:
                switch(t){
                    case `
    `:
                    case `
   	`:
                    case `
  	`:
                    case `
 	`:
                    case `
	`:
                        e.text += `
`, e.pending = "";
                        continue;
                    case `
`:
                    case `
 `:
                    case `
  `:
                    case `
   `:
                        e.pending = t;
                        continue;
                    default:
                        e.pending.length !== 0 ? ($09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = n) : e.text += n;
                        continue;
                }
            case 10:
                switch(n){
                    case "`":
                        e.pending = t;
                        continue;
                    case `
`:
                        if (t.length === e.fence_start + e.fence_end + 1) {
                            $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = "", e.fence_start = 0, e.fence_end = 0, e.token = 101;
                            continue;
                        }
                        e.token = 101;
                        break;
                    case " ":
                        if (e.pending[0] === `
`) {
                            e.pending = t, e.fence_end += 1;
                            continue;
                        }
                        break;
                }
                e.text += e.pending, e.pending = n, e.fence_end = 1;
                continue;
            case 11:
                switch(n){
                    case "`":
                        t.length === e.fence_start + +(e.pending[0] === " ") ? ($09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = "", e.fence_start = 0) : e.pending = t;
                        continue;
                    case `
`:
                        e.text += e.pending, e.pending = "", e.token = 21, e.blockquote_idx = 0, $09b21c92f652e598$var$a(e);
                        continue;
                    case " ":
                        e.text += e.pending, e.pending = n;
                        continue;
                    default:
                        e.text += t, e.pending = "";
                        continue;
                }
            case 103:
                switch(e.pending.length){
                    case 0:
                        if (n !== "[") break;
                        e.pending = t;
                        continue;
                    case 1:
                        if (n !== " " && n !== "x") break;
                        e.pending = t;
                        continue;
                    case 2:
                        if (n !== "]") break;
                        e.pending = t;
                        continue;
                    case 3:
                        if (n !== " ") break;
                        e.renderer.add_token(e.renderer.data, 26), e.pending[1] === "x" && e.renderer.set_attr(e.renderer.data, $09b21c92f652e598$export$be74dcf36d511131, ""), e.renderer.end_token(e.renderer.data), e.pending = " ";
                        continue;
                }
                e.token = e.tokens[e.len], e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, t);
                continue;
            case 14:
            case 15:
                {
                    let r = "*", d = 12;
                    if (e.token === 15 && (r = "_", d = 13), r === e.pending) {
                        if ($09b21c92f652e598$var$a(e), r === n) {
                            $09b21c92f652e598$var$_(e), e.pending = "";
                            continue;
                        }
                        $09b21c92f652e598$var$i(e, d), e.pending = n;
                        continue;
                    }
                    break;
                }
            case 12:
            case 13:
                {
                    let r = "*", d = 14;
                    switch(e.token === 13 && (r = "_", d = 15), e.pending){
                        case r:
                            r === n ? e.tokens[e.len - 1] === d ? e.pending = t : ($09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, d), e.pending = "") : ($09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = n);
                            continue;
                        case r + r:
                            let R = e.token;
                            $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), $09b21c92f652e598$var$_(e), r !== n ? ($09b21c92f652e598$var$i(e, R), e.pending = n) : e.pending = "";
                            continue;
                    }
                    break;
                }
            case 16:
                if (t === "~~") {
                    $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = "";
                    continue;
                }
                break;
            case 105:
                n === `
` ? ($09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 30), e.pending = "") : (e.token = e.tokens[e.len], e.pending[0] === "\\" ? e.text += "[" : e.text += "$$", e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, n));
                continue;
            case 30:
                if (t === "\\]" || t === "$$") {
                    $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = "";
                    continue;
                }
                break;
            case 31:
                if (t === "\\)" || e.pending[0] === "$") {
                    $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), n === ")" ? e.pending = "" : e.pending = n;
                    continue;
                }
                break;
            case 102:
                t === "http://" || t === "https://" ? ($09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 18), e.pending = t, e.text = t) : "http:/"[e.pending.length] === n || "https:/"[e.pending.length] === n ? e.pending = t : (e.token = e.tokens[e.len], $09b21c92f652e598$export$fd28f50634d220c2(e, n));
                continue;
            case 17:
            case 19:
                if (e.pending === "]") {
                    $09b21c92f652e598$var$a(e), n === "(" ? e.pending = t : ($09b21c92f652e598$var$_(e), e.pending = n);
                    continue;
                }
                if (e.pending[0] === "]" && e.pending[1] === "(") {
                    if (n === ")") {
                        let r = e.token === 17 ? $09b21c92f652e598$export$74921a9774a80542 : $09b21c92f652e598$export$ed91b2a31d0810c8, d = e.pending.slice(2);
                        e.renderer.set_attr(e.renderer.data, r, d), $09b21c92f652e598$var$_(e), e.pending = "";
                    } else e.pending += n;
                    continue;
                }
                break;
            case 18:
                n === " " || n === `
` || n === "\\" ? (e.renderer.set_attr(e.renderer.data, $09b21c92f652e598$export$74921a9774a80542, e.pending), $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = n) : (e.text += n, e.pending = t);
                continue;
            case 104:
                if (t.startsWith("<br")) {
                    if (t.length === 3 || n === " " || n === "/" && (t.length === 4 || e.pending[e.pending.length - 1] === " ")) {
                        e.pending = t;
                        continue;
                    }
                    if (n === ">") {
                        $09b21c92f652e598$var$a(e), e.token = e.tokens[e.len], e.renderer.add_token(e.renderer.data, 21), e.renderer.end_token(e.renderer.data), e.pending = "";
                        continue;
                    }
                }
                e.token = e.tokens[e.len], e.text += "<", e.pending = e.pending.slice(1), $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                continue;
        }
        switch(e.pending[0]){
            case "\\":
                if (e.token === 19 || e.token === 30 || e.token === 31) break;
                switch(n){
                    case "(":
                        $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 31), e.pending = "";
                        continue;
                    case "[":
                        e.token = 105, e.pending = t;
                        continue;
                    case `
`:
                        e.pending = n;
                        continue;
                    default:
                        let s1 = n.charCodeAt(0);
                        e.pending = "", e.text += $09b21c92f652e598$var$N(s1) || s1 >= 65 && s1 <= 90 || s1 >= 97 && s1 <= 122 ? t : n;
                        continue;
                }
            case `
`:
                switch(e.token){
                    case 19:
                    case 30:
                    case 31:
                        break;
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                        $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$l(e, e.blockquote_idx), e.blockquote_idx = 0, e.pending = n;
                        continue;
                    default:
                        $09b21c92f652e598$var$a(e), e.pending = n, e.token = 21, e.blockquote_idx = 0;
                        continue;
                }
                break;
            case "<":
                if (e.token !== 19 && e.token !== 30 && e.token !== 31) {
                    $09b21c92f652e598$var$a(e), e.pending = t, e.token = 104;
                    continue;
                }
                break;
            case "`":
                if (e.token === 19) break;
                n === "`" ? (e.fence_start += 1, e.pending = t) : (e.fence_start += 1, $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 11), e.text = n === " " || n === `
` ? "" : n, e.pending = "");
                continue;
            case "_":
            case "*":
                {
                    if (e.token === 19 || e.token === 30 || e.token === 31 || e.token === 14) break;
                    let s = 12, r = 14, d = e.pending[0];
                    if (d === "_" && (s = 13, r = 15), e.pending.length === 1) {
                        if (d === n) {
                            e.pending = t;
                            continue;
                        }
                        if (n !== " " && n !== `
`) {
                            $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, s), e.pending = n;
                            continue;
                        }
                    } else {
                        if (d === n) {
                            $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, r), $09b21c92f652e598$var$i(e, s), e.pending = "";
                            continue;
                        }
                        if (n !== " " && n !== `
`) {
                            $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, r), e.pending = n;
                            continue;
                        }
                    }
                    break;
                }
            case "~":
                if (e.token !== 19 && e.token !== 16) {
                    if (e.pending === "~") {
                        if (n === "~") {
                            e.pending = t;
                            continue;
                        }
                    } else if (n !== " " && n !== `
`) {
                        $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 16), e.pending = n;
                        continue;
                    }
                }
                break;
            case "$":
                if (e.token !== 19 && e.token !== 16 && e.pending === "$") {
                    if (n === "$") {
                        e.token = 105, e.pending = t;
                        continue;
                    } else {
                        if ($09b21c92f652e598$var$se(n.charCodeAt(0))) break;
                        $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 31), e.pending = n;
                        continue;
                    }
                }
                break;
            case "[":
                if (e.token !== 19 && e.token !== 17 && e.token !== 30 && e.token !== 31 && n !== "]") {
                    $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 17), e.pending = n;
                    continue;
                }
                break;
            case "!":
                if (e.token !== 19 && n === "[") {
                    $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 19), e.pending = "";
                    continue;
                }
                break;
            case " ":
                if (e.pending.length === 1 && n === " ") continue;
                break;
        }
        if (e.token !== 19 && e.token !== 17 && e.token !== 30 && e.token !== 31 && n === "h" && (e.pending === " " || e.pending === "")) {
            e.text += e.pending, e.pending = n, e.token = 102;
            continue;
        }
        e.text += e.pending, e.pending = n;
    }
    $09b21c92f652e598$var$a(e);
}
function $09b21c92f652e598$export$13f0775b4d8e3ff(e) {
    return {
        add_token: $09b21c92f652e598$var$oe,
        end_token: $09b21c92f652e598$var$de,
        add_text: $09b21c92f652e598$var$Ee,
        set_attr: $09b21c92f652e598$var$le,
        data: {
            nodes: [
                e,
                ,
                ,
                ,
                , 
            ],
            index: 0
        }
    };
}
function $09b21c92f652e598$var$oe(e, c) {
    let n = e.nodes[e.index], t;
    switch(c){
        case 1:
            return;
        case 20:
            t = document.createElement("blockquote");
            break;
        case 2:
            t = document.createElement("p");
            break;
        case 21:
            t = document.createElement("br");
            break;
        case 22:
            t = document.createElement("hr");
            break;
        case 3:
            t = document.createElement("h1");
            break;
        case 4:
            t = document.createElement("h2");
            break;
        case 5:
            t = document.createElement("h3");
            break;
        case 6:
            t = document.createElement("h4");
            break;
        case 7:
            t = document.createElement("h5");
            break;
        case 8:
            t = document.createElement("h6");
            break;
        case 12:
        case 13:
            t = document.createElement("em");
            break;
        case 14:
        case 15:
            t = document.createElement("strong");
            break;
        case 16:
            t = document.createElement("s");
            break;
        case 11:
            t = document.createElement("code");
            break;
        case 18:
        case 17:
            t = document.createElement("a");
            break;
        case 19:
            t = document.createElement("img");
            break;
        case 23:
            t = document.createElement("ul");
            break;
        case 24:
            t = document.createElement("ol");
            break;
        case 25:
            t = document.createElement("li");
            break;
        case 26:
            let s = t = document.createElement("input");
            s.type = "checkbox", s.disabled = !0;
            break;
        case 9:
        case 10:
            n = n.appendChild(document.createElement("pre")), t = document.createElement("code");
            break;
        case 27:
            t = document.createElement("table");
            break;
        case 28:
            switch(n.children.length){
                case 0:
                    n = n.appendChild(document.createElement("thead"));
                    break;
                case 1:
                    n = n.appendChild(document.createElement("tbody"));
                    break;
                default:
                    n = n.children[1];
            }
            t = document.createElement("tr");
            break;
        case 29:
            t = document.createElement(n.parentElement?.tagName === "THEAD" ? "th" : "td");
            break;
        case 30:
            t = document.createElement("equation-block");
            break;
        case 31:
            t = document.createElement("equation-inline");
            break;
    }
    e.nodes[++e.index] = n.appendChild(t);
}
function $09b21c92f652e598$var$de(e) {
    e.index -= 1;
}
function $09b21c92f652e598$var$Ee(e, c) {
    e.nodes[e.index].appendChild(document.createTextNode(c));
}
function $09b21c92f652e598$var$le(e, c, n) {
    e.nodes[e.index].setAttribute($09b21c92f652e598$var$ee(c), n);
}





const $43dd9e4a1201e515$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
const $43dd9e4a1201e515$export$b9a20415b25a91f7 = 'invoke-assistant';
class $43dd9e4a1201e515$export$2e2bcd8739ae039 extends HTMLElement {
    initialized = false;
    disconnectedController = null;
    get src() {
        return this.getAttribute('src');
    }
    connectedCallback() {
        this.disconnectedController = new AbortController();
        addEventListener($43dd9e4a1201e515$export$b9a20415b25a91f7, (event)=>{
            this.hidden = false;
            this.field.value = event.detail.prompt;
            this.field.focus();
            this.form.requestSubmit();
        }, {
            signal: this.disconnectedController.signal
        });
    }
    disconnectedCallback() {
        this.disconnectedController?.abort();
        this.disconnectedController = null;
    }
    textAreaKeyDown(event) {
        // handle command+enter (mac) and ctrl+enter (windows)
        if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
            event.preventDefault();
            this.form.requestSubmit();
        }
    }
    async init() {
        if (this.initialized) return;
        this.initialized = true;
        const url = new URL(this.src, location.origin);
        url.searchParams.set('type', 'init');
        const response = await fetch(url.origin + url.pathname, {
            method: 'POST',
            body: url.searchParams
        });
        if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response);
    }
    async submit(event) {
        event.preventDefault();
        const message = (event.detail.get('suggested-message') ?? event.detail.get('message')).trim();
        if (!message) return;
        const restart_conversation = event.detail.has('suggested-message');
        this.initialized = true;
        const assistantMarkdownBodyId = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
        this.horizontalRule.hidden = false;
        this.form.insertAdjacentHTML('afterend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<div class="align-self-start mr-6">
            <span class="f6">Cumulus Assistant</span>
            <div
              class="border rounded color-bg-default p-3 pr-5 markdown-body f5 position-relative"
              id="${assistantMarkdownBodyId}"
            >
              <span>${(0, $b11db1b62d4a8f76$export$7ea5605264efeacf)[$43dd9e4a1201e515$var$locale]}</span
              ><span class="AnimatedEllipsis"></span>
            </div>
          </div>
          <div class="align-self-end ml-6">
            <span class="f6 color-fg-accent">${(0, $b11db1b62d4a8f76$export$1108f562936cb617)[$43dd9e4a1201e515$var$locale]}</span>
            <div
              class="border rounded color-bg-accent color-border-accent element-changed-animation p-3 markdown-body f5"
            >
              <p class="wb-break-word ws-pre-wrap">${message}</p>
            </div>
          </div>`));
        const markdownBody = document.getElementById(assistantMarkdownBodyId);
        const renderer = (0, $09b21c92f652e598$export$13f0775b4d8e3ff)(markdownBody);
        const markdownParser = (0, $09b21c92f652e598$export$8f49e4af10703ce3)(renderer);
        // pause before busying the submit buttons
        await new Promise((resolve)=>setTimeout(resolve));
        let received = '';
        try {
            (0, $d926988b2eed7310$export$7f9cba67632f8265)(this.form, true);
            this.field.disabled = true;
            this.field.value = message;
            const url = new URL(this.src, location.origin);
            url.searchParams.set('type', 'message');
            url.searchParams.set('role', 'user');
            url.searchParams.set('content', message);
            if (restart_conversation) url.searchParams.set('restart_conversation', 'true');
            if (message.trim() === '/system') {
                const response = await fetch(url);
                if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response);
                received = await response.text();
                markdownBody.innerHTML = '';
                (0, $09b21c92f652e598$export$fd28f50634d220c2)(markdownParser, received);
                return;
            }
            const shouldBuffer = (text)=>{
                return text.endsWith('<') || text.endsWith('<N') || text.endsWith('<NL');
            };
            await new Promise((resolve, reject)=>{
                const source = new EventSource(url.href, {
                    withCredentials: true
                });
                let buffer = '';
                source.addEventListener('error', ()=>{
                    source.close();
                    reject(new Error('EventSource error'));
                });
                source.addEventListener('message', (event)=>{
                    if (event.data === '[DONE]') {
                        if (buffer.length > 0) (0, $09b21c92f652e598$export$fd28f50634d220c2)(markdownParser, buffer.replaceAll('<NL>', '\n'));
                        source.close();
                        resolve();
                        return;
                    }
                    if (received.length === 0) markdownBody.innerHTML = '';
                    let { response: chunk } = JSON.parse(event.data);
                    if (chunk !== undefined) {
                        if (typeof chunk === 'number') chunk = chunk.toString();
                        // // model sometimes sends "- " without a preceding newline
                        // if (/\d$/.test(received) && /^- /.test(chunk)) {
                        //   chunk = '\n' + chunk;
                        // }
                        received += chunk;
                        buffer += chunk;
                        if (!shouldBuffer(buffer)) {
                            (0, $09b21c92f652e598$export$fd28f50634d220c2)(markdownParser, buffer.replaceAll('<NL>', '\n'));
                            buffer = '';
                        }
                    }
                });
            });
            received = received.replaceAll('<NL>', '\n');
            if (received.length === 0) throw new Error('Empty response');
            url.searchParams.set('role', 'assistant');
            url.searchParams.set('content', received);
            url.searchParams.delete('restart_conversation');
            const response = await fetch(url.origin + url.pathname, {
                method: 'POST',
                body: url.searchParams
            });
            if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response);
        } catch (err) {
            if (received.length === 0) markdownBody.innerHTML = '';
            markdownBody.insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<p class="text-italic">${(0, $b11db1b62d4a8f76$export$f725eab7abaa007d)[$43dd9e4a1201e515$var$locale]}</p>`));
            throw err;
        } finally{
            this.field.disabled = false;
            this.field.focus();
            (0, $09b21c92f652e598$export$1bb76c36683ac7c2)(markdownParser);
            (0, $80a2320123ddcd02$export$9657601bf1e130ee)(markdownBody.parentElement);
            (0, $d926988b2eed7310$export$7f9cba67632f8265)(this.form, false);
            if (received.length) {
                this.field.value = '';
                markdownBody.insertAdjacentHTML('afterbegin', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<clipboard-copy
              class="btn-octicon position-absolute top-0 right-0 p-2 m-0"
              value="${received}"
              aria-label="${(0, $b11db1b62d4a8f76$export$5f486e535de293fa)[$43dd9e4a1201e515$var$locale]}"
              >${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$e3d4d49f14b4dd60))}</clipboard-copy
            >`));
            }
        }
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $43dd9e4a1201e515$export$2e2bcd8739ae039.prototype, "form", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $43dd9e4a1201e515$export$2e2bcd8739ae039.prototype, "field", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $43dd9e4a1201e515$export$2e2bcd8739ae039.prototype, "horizontalRule", void 0);
$43dd9e4a1201e515$export$2e2bcd8739ae039 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('assistant-chat-controller')
], $43dd9e4a1201e515$export$2e2bcd8739ae039);



const $92bbe4a5fa06c12f$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
const $92bbe4a5fa06c12f$var$detailsTabState = {};
const $92bbe4a5fa06c12f$var$printHash = '#:print:';
class $92bbe4a5fa06c12f$export$2e2bcd8739ae039 extends HTMLElement {
    assignmentRuleTimeout = 0;
    inputTimeout = 0;
    location = new URL(location.href);
    detachedAbortController;
    handleChangeRevision = 0;
    pendingStatusChange = false;
    activityFormSnapshotLoads = new Map();
    async connectedCallback() {
        this.detachedAbortController = new AbortController();
        if (location.hash.startsWith($92bbe4a5fa06c12f$var$printHash)) {
            const behavior = location.hash.substr($92bbe4a5fa06c12f$var$printHash.length);
            history.replaceState(undefined, '', location.pathname + location.search);
            let includeFragment;
            while(includeFragment = this.querySelector('include-fragment[src]'))await new Promise((resolve)=>includeFragment.addEventListener('include-fragment-replaced', resolve, {
                    once: true
                }));
            this.doBehavior(behavior);
        }
        this.resolveFieldLinks();
        const clickHandler = async (event)=>{
            const behavior = event.target instanceof Element && event.target.closest('[activity-behavior]')?.getAttribute('activity-behavior') || '';
            this.doBehavior(behavior, event);
        };
        addEventListener('click', clickHandler, {
            capture: true,
            signal: this.detachedAbortController.signal
        });
        const popstateHandler = (event)=>{
            if (event.state === $92bbe4a5fa06c12f$var$detailsTabState) this.editElements();
            else {
                const url = new URL(location.href);
                if (url.origin + url.pathname + url.search !== this.location.origin + this.location.pathname + this.location.search) location.reload();
            }
        };
        addEventListener('popstate', popstateHandler, {
            signal: this.detachedAbortController.signal
        });
    }
    disconnectedCallback() {
        this.detachedAbortController?.abort();
        this.detachedAbortController = undefined;
    }
    get newCommentTextArea() {
        return this.form.elements.namedItem('comment_body');
    }
    get formBehavior() {
        return this.form.querySelector('form-behavior');
    }
    async doBehavior(behavior, event) {
        switch(behavior){
            case 'edit-details':
                {
                    event?.preventDefault();
                    const focusTarget = event?.target instanceof HTMLAnchorElement && event.target.getAttribute('href')?.startsWith('#') && document.getElementById(event.target.getAttribute('href').substr(1)) || null;
                    this.editElements(focusTarget);
                    return;
                }
            case 'print-summary':
            case 'print-summary-with-comments':
            case 'print-details':
                {
                    if (location.pathname.endsWith('/new')) {
                        await new Promise((resolve)=>this.addEventListener((0, $ab6f099c20a34e1f$export$7acd55e6ec74c9ed), resolve, {
                                once: true
                            }));
                        await new Promise((resolve)=>setTimeout(resolve, 50));
                    }
                    const { origin: origin, pathname: pathname, search: search } = location;
                    const actualIsDetails = pathname.endsWith('/details');
                    const requestedIsDetails = behavior === 'print-details';
                    if (actualIsDetails === requestedIsDetails) {
                        this.printCommentsItems.forEach((el)=>el.classList.toggle('d-print-none', behavior !== 'print-summary-with-comments'));
                        print();
                        addEventListener('afterprint', ()=>this.printCommentsItems.forEach((el)=>el.classList.add('d-print-none')));
                    } else {
                        const requestedPathname = actualIsDetails ? pathname.substr(0, pathname.length - 8) : pathname + '/details';
                        location.href = `${origin}${requestedPathname}${search}${$92bbe4a5fa06c12f$var$printHash}${behavior}`;
                    }
                    return;
                }
            default:
                if (behavior) throw new Error(`Unexpected activity-behavior "${behavior}".`);
        }
    }
    handleValidationError(event) {
        if (event.detail.group.hasAttribute('form-element') && event.detail.group.classList.contains('form-element--skipped')) event.preventDefault();
        else this.editElements();
    }
    handleServerValidationError() {
        this.editElements();
    }
    editElements = (elementToFocus)=>{
        if (this.elementsContainer?.hidden) {
            this.elementsContainer.hidden = false;
            this.elementsSummaryContainer.remove(); // todo: fix duplicate heading ids
            history.pushState($92bbe4a5fa06c12f$var$detailsTabState, '', location.pathname + '/details' + this.location.search);
            this.location = new URL(location.href);
            document.querySelector('.UnderlineNav-item[aria-current="page"]')?.setAttribute('aria-current', 'false');
            document.querySelector('.UnderlineNav-item[href$="/details"]')?.setAttribute('aria-current', 'page');
        }
        if (elementToFocus) elementToFocus.scrollIntoView({
            block: elementToFocus.clientHeight > window.innerHeight * 0.8 ? 'start' : 'center'
        });
        (0, $80a2320123ddcd02$export$956fd4dade47957a)(elementToFocus ?? this.elementsContainer);
        if (elementToFocus?.parentElement instanceof HTMLDetailsElement && !elementToFocus.parentElement.open) {
            elementToFocus.parentElement.open = true;
            elementToFocus.parentElement.dispatchEvent(new ToggleEvent('toggle', {
                bubbles: true,
                newState: 'open',
                oldState: 'closed'
            }));
        }
    };
    focusElement(event) {
        event.preventDefault();
        const idish = event.currentTarget instanceof Element && event.currentTarget.getAttribute('element-identifier');
        let el = this.querySelector(`[form-element="${idish}"],[name="${idish}"],[name^="${idish}:"],[id="${idish}"]`);
        if (el instanceof HTMLInputElement && el.type === 'hidden') el = el.parentElement;
        this.editElements(el);
        el?.closest('.form-group')?.classList.add('element-changed-animation--fast');
        return el;
    }
    focusElementAndOpenModal(event) {
        const el = this.focusElement(event);
        el?.querySelector('modal-controller')?.open();
    }
    assignToMe() {
        this.editElements();
        this.assigneePicker.assignToMeAndSave();
    }
    async activitySaved(event) {
        // Reset comment textarea and its preview tab.
        const scrollNewCommentIntoView = this.newCommentTextArea.value.trim() !== '' && this.newCommentTextArea.defaultValue === '';
        this.newCommentTextArea.value = '';
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.newCommentTextArea);
        this.querySelectorAll('markdown-editor tab-container').forEach((el)=>{
            if (el.tabIndex === 0) el.selectTab(0);
        });
        // Switch to PUT mode body
        if (this.creationFields) this.creationFields.remove();
        // Previous steps will have artifically dirtied the form... accept those changes.
        this.form.querySelector('form-behavior')?.acceptChanges();
        // Remove process flash (assumes save completed the process)
        document.getElementById('process-flash')?.remove();
        const html = await event.detail.text();
        this.timelineContainer.innerHTML = html;
        const subscribersContent = this.timelineContainer.querySelector('[id="subscribers-content"]');
        if (subscribersContent) this.subscribersSection.replaceWith(subscribersContent.content);
        const attachmentsContent = this.timelineContainer.querySelector('[id="attachments-content"]');
        if (attachmentsContent) this.attachmentsSection.replaceWith(attachmentsContent.content);
        const eventEnrollmentLinkContent = this.timelineContainer.querySelector('[id="event-enrollment-link-content"]');
        if (eventEnrollmentLinkContent) this.eventEnrollmentLinkSection?.replaceWith(eventEnrollmentLinkContent.content);
        const eventQuestionnairesContent = this.timelineContainer.querySelector('[id="event-questionnaires-content"]');
        if (eventQuestionnairesContent) this.eventQuestionnairesSection?.replaceWith(eventQuestionnairesContent.content);
        const railActivitySendingRequestsContent = this.timelineContainer.querySelector('[id="rail-activity-sending-requests-content"]');
        if (railActivitySendingRequestsContent) this.railActivitySendingRequests?.replaceWith(railActivitySendingRequestsContent.content);
        const tabNavContent = this.timelineContainer.querySelector('[id="activity-tabnav-content"]');
        if (tabNavContent) document.getElementById('header-tabnav')?.replaceWith(tabNavContent.content);
        this.timelineContainer.querySelectorAll('[id^="attachment-question-"]').forEach((template)=>{
            this.querySelector(`[form-element="${template.id.substr('attachment-question-'.length)}"]`)?.replaceWith(template.content);
        });
        this.addAnotherContent?.removeAttribute('hidden');
        if (scrollNewCommentIntoView) {
            const item = this.timelineContainer.querySelector('.TimelineItem-body:has(.markdown-body)');
            if (item) // Scroll on next tick because scrolling immediately will interfere with requires-submit link clicks.
            setTimeout((0, $80a2320123ddcd02$export$9657601bf1e130ee), 0, item);
        }
        // Previous steps will have artifically dirtied the form... accept those changes.
        this.form.querySelector('form-behavior')?.acceptChanges();
    }
    statusFocus({ target: target }) {
        // clear status id from hash after it receives focus.
        if (target instanceof Element && target.id === location.hash.substr(1)) history.replaceState(undefined, '', location.pathname + location.search);
    }
    recommendationValueInputFocused({ target: target }) {
        target instanceof Element && target.closest('.form-group').querySelector('button,a').focus();
    }
    async subscriptionUpdated(event) {
        const html = await event.detail.text();
        const template = document.createElement('template');
        template.innerHTML = html;
        this.subscribersSection.replaceWith(template.content);
    }
    async editComment(event) {
        const item = this.getTimelineItem(event);
        if (!item) return;
        const markdownContent = item.querySelector('.markdown-body');
        const activity_comment_id = markdownContent.getAttribute('activity_comment_id');
        const markdown = markdownContent.getAttribute('source-markdown') ?? '';
        const fragment = this.editCommentTemplate.content.cloneNode(true);
        const form = fragment.firstElementChild;
        form.action = `/api/organizations/${this.organization_id}/activities/${this.activity_id}/comments/${activity_comment_id}?_method=PUT`;
        const bodyTextArea = form.elements.namedItem('body');
        bodyTextArea.value = markdown;
        item.append(fragment);
        item.querySelector('.TimelineItem-body').hidden = true;
        await new Promise((resolve)=>setTimeout(resolve));
        (0, $80a2320123ddcd02$export$9657601bf1e130ee)(bodyTextArea);
        bodyTextArea.focus();
    }
    keyDown(event) {
        // When a user presses tab after editing an number/text input and the
        // subsequent field becomes visible due to conditional logic,
        // focus will skip the newly visible field.
        // The following code forces evaluation of the form state early to circumvent the issue.
        if (event.key === 'Tab' && document.activeElement instanceof HTMLInputElement && document.activeElement.type === 'number') this.handleChange(event);
    }
    editCommentKeyDown(event) {
        if (event.key === 'Escape') {
            event.preventDefault();
            this.cancelCommentEdit(event);
        }
    }
    cancelCommentEdit(event) {
        const item = this.getTimelineItem(event);
        if (!item) return;
        const form = event.target instanceof Element && event.target.closest('form');
        if (form) form.remove();
        item.querySelector('.TimelineItem-body').hidden = false;
    }
    async deleteComment(event) {
        const item = this.getTimelineItem(event);
        if (!item) return;
        if (!confirm('Are you sure you want to delete this comment?')) return;
        const markdownContent = item.querySelector('.markdown-body');
        const activity_comment_id = markdownContent.getAttribute('activity_comment_id');
        const response = await fetch(`/api/organizations/${this.organization_id}/activities/${this.activity_id}/comments/${activity_comment_id}`, {
            method: 'DELETE'
        });
        if (response.ok) item.remove();
    }
    async quoteReply(event) {
        const item = this.getTimelineItem(event);
        if (!item) return;
        const markdown = item.querySelector('.markdown-body')?.getAttribute('source-markdown') ?? '';
        const prompt = `[enter your reply here]`;
        const blockquote = `> ${markdown.split(/\r?\n/).join('\n> ')}\n\n`;
        const start = blockquote.length;
        this.newCommentTextArea.value = blockquote + prompt;
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.newCommentTextArea);
        await new Promise((resolve)=>setTimeout(resolve));
        this.newCommentTextArea.scrollIntoView({
            behavior: 'smooth'
        });
        this.newCommentTextArea.focus();
        this.newCommentTextArea.setSelectionRange(start, this.newCommentTextArea.value.length);
    }
    getTimelineItem(event) {
        return event.target instanceof Element && event.target.closest('.TimelineItem');
    }
    _elementsAndProperties;
    getElementsAndProperties(json) {
        if (!this._elementsAndProperties) {
            const { elements: elements, properties: properties, activityDefinition: activityDefinition, currentUser: currentUser, scopeData: scopeData } = JSON.parse(json);
            this._elementsAndProperties = {
                activityDefinition: activityDefinition,
                elements: elements,
                propertyMap: (0, $cb5704f276528297$export$e439fc32198f78c5)(properties, 'property_id'),
                currentUser: currentUser,
                scopeData: scopeData
            };
        }
        return this._elementsAndProperties;
    }
    loadActivityFormSnapshot(form_snapshot_json, form_snapshot_integrity, referenced_activity_ids) {
        const key = `${form_snapshot_integrity}:${referenced_activity_ids.join(',')}`;
        let loading = this.activityFormSnapshotLoads.get(key);
        if (!loading) {
            loading = (async ()=>{
                const response = await fetch(`/api/organizations/${this.organization_id}/activity-expression-definition`, {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        form_snapshot_json: form_snapshot_json,
                        form_snapshot_integrity: form_snapshot_integrity,
                        referenced_activity_ids: referenced_activity_ids
                    }),
                    signal: this.detachedAbortController?.signal
                });
                if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
                return await response.json();
            })().finally(()=>{
                this.activityFormSnapshotLoads.delete(key);
            });
            this.activityFormSnapshotLoads.set(key, loading);
        }
        return loading;
    }
    handleInput(event) {
        const { target: target } = event;
        if (target instanceof HTMLInputElement && [
            'text',
            'number'
        ].includes(target.type) || target instanceof HTMLTextAreaElement) {
            clearTimeout(this.inputTimeout);
            this.inputTimeout = setTimeout(()=>this.handleChange(event), 300);
        }
    }
    nextEventIndex = 0;
    log(event, ...args) {
        if (new URLSearchParams(location.search).has('debug')) {
            const name = event.target instanceof Element && event.target.getAttribute('name') || '(name missing)';
            event.__log_index__ ??= this.nextEventIndex++;
            const index = event.__log_index__;
            console.info(`Handle ${event.type} #${index} on ${name}`, ...args);
        }
    }
    async handleChange(event) {
        const revision = ++this.handleChangeRevision;
        this.log(event, 'Enter handleChange');
        try {
            clearTimeout(this.inputTimeout);
            const formData = (0, $d926988b2eed7310$export$2d71e4ce1d783c30)(this.form);
            const isModal = this.closest('modal-content');
            if (event.type === 'change' && event.target instanceof HTMLInputElement && event.target.name === 'status') this.pendingStatusChange = true;
            const parsed = (0, $6980cc602f309497$export$ae2b2db16f8c0171)(formData);
            const { responses: responses = {}, form_snapshot_json: form_snapshot_json, form_snapshot_integrity: form_snapshot_integrity, status: status, start_date: start_date, end_date: end_date } = parsed;
            const { activityDefinition: { type: type, duration_days: duration_days }, elements: elements, propertyMap: propertyMap, currentUser: currentUser, scopeData: scopeData } = this.getElementsAndProperties(form_snapshot_json);
            const missingActivityIds = new Set();
            for (const property of Object.values(propertyMap)){
                const value = responses[`p${property.property_id}`];
                if (property.type === 'activity' && typeof value === 'string' && value && !scopeData.activities[value]) missingActivityIds.add(value);
            }
            if (missingActivityIds.size > 0) {
                const loading = this.loadActivityFormSnapshot(form_snapshot_json, form_snapshot_integrity, Array.from(missingActivityIds).sort());
                this.formBehavior?.setBusy(loading);
                const encoded = await loading;
                if (revision !== this.handleChangeRevision) return;
                const formSnapshotJsonInput = this.form.elements.namedItem('form_snapshot_json');
                const formSnapshotIntegrityInput = this.form.elements.namedItem('form_snapshot_integrity');
                if (!(formSnapshotJsonInput instanceof HTMLInputElement) || !(formSnapshotIntegrityInput instanceof HTMLInputElement)) throw new Error('Unable to locate activity form snapshot inputs.');
                formSnapshotJsonInput.value = encoded.form_snapshot_json;
                formSnapshotIntegrityInput.value = encoded.form_snapshot_integrity;
                this._elementsAndProperties = undefined;
                await this.handleChange(event);
                return;
            }
            const statusChanged = this.pendingStatusChange;
            this.pendingStatusChange = false;
            if (statusChanged && status) {
                // defer validation until after questions have been updated with required status.
                clearTimeout(this.assignmentRuleTimeout);
                this.assignmentRuleTimeout = setTimeout(()=>{
                    (0, $84fd3dc30499b2d0$export$ed692cabb252e59b)(this.form, 'info');
                    this.formBehavior.setBusy(this.applyAssignmentRule(formData));
                    if (!isModal) {
                        const statusLabel = document.getElementById('activity-status-label');
                        statusLabel.insertAdjacentHTML('afterend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $457490243c387ab4$export$76dce95b982175c)(status, $92bbe4a5fa06c12f$var$locale)));
                        statusLabel.remove();
                    }
                }, 0);
            }
            const currentScope = (0, $6941fa4b8204d0aa$export$a8c07971d4517bfc)(scopeData);
            currentScope.responses = responses;
            if (status) currentScope.activity.status = status;
            currentScope.activity.start_date = start_date ?? new Date().toISOString().substr(0, 10);
            currentScope.activity.end_date = end_date ?? null;
            if (this.assigneePicker) {
                currentScope.activity.assignee_organization = this.assigneePicker.value?.organization_login ?? null;
                currentScope.activity.assignee_user = this.assigneePicker.value?.user_login ?? null;
                currentScope.activity.assignee_user_first_name = this.assigneePicker.value?.user_first_name ?? null;
                currentScope.activity.assignee_user_last_name = this.assigneePicker.value?.user_last_name ?? null;
            }
            const primaryPhone = 'phones' in parsed ? parsed.phones.find((x)=>x.is_primary) : null;
            currentScope.activity.primary_phone_number = primaryPhone?.number ?? null;
            const primaryEmail = 'emails' in parsed ? parsed.emails.find((x)=>x.is_primary) : null;
            currentScope.activity.primary_email_address = primaryEmail?.email ?? null;
            const primaryPhysical = 'addresses' in parsed ? parsed.addresses.find((x)=>x.is_primary_physical) : null;
            currentScope.activity.primary_physical_street_address = primaryPhysical?.street_address ?? null;
            currentScope.activity.primary_physical_sub_address = primaryPhysical?.sub_address ?? null;
            currentScope.activity.primary_physical_city = primaryPhysical?.city ?? null;
            currentScope.activity.primary_physical_state = primaryPhysical?.region_abbr ?? null;
            currentScope.activity.primary_physical_zip = primaryPhysical?.postal_code ?? null;
            currentScope.activity.primary_physical_zip_ext = primaryPhysical?.postal_code_ext ?? null;
            currentScope.activity.primary_physical_subregion = primaryPhysical?.subregion ?? null;
            const expressionContext = (0, $6941fa4b8204d0aa$export$9d93b05ddd43b392).forActivity({
                currentUser: currentUser,
                properties: propertyMap,
                scopeData: scopeData,
                operation: 'view'
            });
            const startDateInput = this.form.elements.namedItem('start_date:date');
            const endDateInput = this.form.elements.namedItem('end_date:date');
            const dueDateInput = this.form.elements.namedItem('due_date:date');
            // Set end date required on status change.
            // Set end date value based on whether the status is opened or closed.
            if (statusChanged && endDateInput instanceof HTMLInputElement && !endDateInput.disabled) {
                const required = (0, $fc2f5b0b15619892$export$a94a7861f82ee3e6)(type, status ?? currentScope.activity.status);
                endDateInput.setAttribute('validate-required', String(required));
                const newEndDateValue = required ? (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format(new Date()) : '';
                if (!!endDateInput.value !== !!newEndDateValue) {
                    endDateInput.classList.remove('element-changed-animation');
                    endDateInput.value = newEndDateValue;
                    (0, $80a2320123ddcd02$export$89348ae70780cd7a)(endDateInput);
                    setTimeout(()=>endDateInput.classList.add('element-changed-animation'), 0);
                    this.log(event, 'Exit handleChange - end date changed');
                    return; // dispatchChange will trigger handleChange again.
                }
            }
            // if start date or end date changed, and end date is before start date, update the date to match
            if (event.type === 'change' && startDateInput instanceof HTMLInputElement && endDateInput instanceof HTMLInputElement && endDateInput.value && // document.activeElement !== startDateInput &&
            // document.activeElement !== endDateInput &&
            (event.target === startDateInput || event.target === endDateInput) && !endDateInput.disabled) {
                const startDate = (0, $b78c044e3d911d2e$export$7660134aa4da2247)(startDateInput.value);
                const endDate = (0, $b78c044e3d911d2e$export$7660134aa4da2247)(endDateInput.value);
                if (startDate && endDate && startDate > endDate) {
                    const input = event.target === startDateInput ? endDateInput : startDateInput;
                    const value = event.target === startDateInput ? startDate : endDate;
                    input.classList.remove('element-changed-animation');
                    input.value = (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format(value);
                    (0, $80a2320123ddcd02$export$89348ae70780cd7a)(input);
                    setTimeout(()=>input.classList.add('element-changed-animation'), 0);
                    this.log(event, 'Exit handleChange - start or end date changed');
                    return; // dispatchChange will trigger handleChange again.
                }
            }
            // if start date changed, update due date
            if (event.type === 'change' && startDateInput instanceof HTMLInputElement && dueDateInput instanceof HTMLInputElement && // document.activeElement !== startDateInput &&
            // document.activeElement !== dueDateInput &&
            event.target === startDateInput && !startDateInput.disabled) {
                const startDate = (0, $b78c044e3d911d2e$export$7660134aa4da2247)(startDateInput.value);
                if (startDate) {
                    const value = (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format((0, $b78c044e3d911d2e$export$dd412b56f1e4d8aa)(startDate, duration_days));
                    if (dueDateInput.value !== value) {
                        dueDateInput.classList.remove('element-changed-animation');
                        dueDateInput.value = value;
                        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(dueDateInput);
                        setTimeout(()=>dueDateInput.classList.add('element-changed-animation'), 0);
                        this.log(event, 'Exit handleChange - due date changed');
                        return; // dispatchChange will trigger handleChange again.
                    }
                }
            }
            let visibleProperties = formData.has('title') ? 1 : 0;
            let answeredProperties = formData.get('title') ? 1 : 0;
            let changed = null;
            (0, $fc2f5b0b15619892$export$d89c0470e9f1cc7e)(elements, expressionContext, (el, visible, currentlyRequired)=>{
                if (changed) return;
                if (visible && el.type === 'property') {
                    visibleProperties++;
                    if ((responses[`p${el.property_id}`] ?? '') !== '') answeredProperties++;
                }
                const element = this.form.querySelector(`[form-element="${el.index}"]`);
                if (!element) {
                    if (el.type === 'recommendation' || el.type === 'event-activity') return;
                    throw new Error(`Unable to locate element corresponding to "${el.index}" ("${el.type}").`);
                }
                const summaryElements = this.querySelectorAll(`[summary-element="${el.index}"]`);
                // show/hide elements based on their visibility expression.
                summaryElements.forEach((el)=>el.toggleAttribute('hidden', !visible));
                element.classList.toggle('form-element--skipped', !visible);
                if (el.type === 'heading') {
                    const navLink = this.headingNavLinks.find((x)=>x.getAttribute('element') === el.index.toString());
                    if (navLink) navLink.hidden = !visible;
                }
                // synchronize required state.
                element.setAttribute('validate-required', String(currentlyRequired && visible));
                if (el.type !== 'property') return;
                const property = propertyMap[el.property_id];
                if (!property) throw new Error(`Unable to get property with id "${el.property_id}" from property array.`);
                const { property_id: property_id, type: type, calculated: calculated, expression: expression, format: format } = property;
                // clear data from skipped fields.
                if (!visible) {
                    if (responses[`p${property_id}`] !== undefined) {
                        if (responses[`p${property_id}`] !== '' && responses[`p${property_id}`] !== null) this.log(event, `Clearing ${property.label} (${property_id}) - current value ${JSON.stringify(responses[`p${property_id}`])}`);
                        $92bbe4a5fa06c12f$var$setActivityElementValue(element, property, undefined);
                        delete responses[`p${property_id}`];
                    }
                    return;
                }
                // update calculated fields.
                if (!calculated || !expression) return;
                let value = (0, $6941fa4b8204d0aa$export$61b73397e464436e)(type, expression, expressionContext);
                if (responses[`p${property_id}`] !== value) {
                    this.log(event, `Calculated field ${property.label} (${property_id}) changed to ${value}`);
                    changed = $92bbe4a5fa06c12f$var$setActivityElementValue(element, property, value);
                    this.log(event, 'Changed input', changed);
                    responses[`p${property_id}`] = value;
                    const outputElement = element.querySelector('[calculated-value]');
                    if (format === (0, $c1de6d172f4f6f9e$export$ac1cd9a3e24492e7).URL || format === (0, $c1de6d172f4f6f9e$export$ac1cd9a3e24492e7).RelativeURL) {
                        if ((0, $c1de6d172f4f6f9e$export$34d61295a3a678)({
                            value: value,
                            format: format
                        })) {
                            outputElement.ariaDisabled = 'false';
                            outputElement.setAttribute('href', value);
                        } else {
                            outputElement.ariaDisabled = 'true';
                            outputElement.removeAttribute('href');
                        }
                    } else {
                        const unanswered = (0, $c1de6d172f4f6f9e$export$8398a3e81384ac66)(value);
                        outputElement.classList.toggle('text-mono', !unanswered);
                        outputElement.classList.toggle('text-italic', unanswered);
                        outputElement.classList.toggle('color-fg-muted', unanswered);
                        outputElement.textContent = (0, $c1de6d172f4f6f9e$export$b69667b9fc24675e)({
                            locale: $92bbe4a5fa06c12f$var$locale,
                            property: property,
                            value: value,
                            showScore: false,
                            activities: []
                        });
                        document.querySelector(`clipboard-copy[for="${outputElement.id}"]`)?.classList.toggle('v-hidden', unanswered);
                    }
                } else this.log(event, `Calculated field ${property.label} (${property_id}) remained ${value}`);
                const detailsContent = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $134dd8a762545151$export$10eb477033c32543)((0, $c74c4f773f8a11f2$export$180605366c04f0cd)(), responses, propertyMap, element.getAttribute('references')?.split(',').map(Number) ?? []));
                const detailsListElement = element.querySelector('details ul');
                if (detailsListElement.innerHTML !== detailsContent) detailsListElement.innerHTML = detailsContent;
            });
            if (changed) {
                this.log(event, `Displatching change for ${changed.getAttribute('name')}`);
                (0, $80a2320123ddcd02$export$89348ae70780cd7a)(changed);
                return;
            }
            if (!isModal) {
                const progressLabel = document.getElementById('activity-progress-label');
                if (progressLabel) progressLabel.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $e2bf3f8a63f9de76$export$3194dcd7e2b21417)(answeredProperties / visibleProperties), 'f5 color-fg-accent')}
            ${answeredProperties} of ${visibleProperties} ${(0, $b11db1b62d4a8f76$export$989066564c2ca33b)[$92bbe4a5fa06c12f$var$locale]}`);
            }
        } finally{
            this.log(event, 'Exit handleChange');
        }
    }
    applyAssignmentRule = async (body)=>{
        this.assigneePicker.summary.classList.remove('btn-updated');
        const controller = new AbortController();
        setTimeout(()=>controller.abort('timeout'), 5000);
        const url = new URL(this.status_assignment_src, location.origin);
        url.searchParams.set('contract_id', this.form.elements.namedItem('contract_id').value);
        const response = await fetch(`${url.pathname}${url.search}`, {
            method: 'POST',
            body: body,
            signal: controller.signal
        });
        if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response);
        if (response.status !== 200) return;
        const html = await response.text();
        this.assigneePicker.summary.querySelector('[data-menu-button]').innerHTML = html;
        this.assigneePicker.select();
        this.assigneePicker.summary.classList.add('btn-updated');
        const subscribersTemplate = this.assigneePicker.querySelector('#automatic-subscribers');
        this.form.elements.namedItem('subscribers:json').replaceWith(subscribersTemplate.content);
        const contractsTemplate = this.assigneePicker.querySelector('#assignment-rule-contract');
        this.assigneePicker.contractFormGroupContainer.innerHTML = '';
        this.assigneePicker.contractFormGroupContainer.append(contractsTemplate.content);
    };
    busyUploadingVaccineSurvey = false;
    async handleRailKeydown({ key: key, shiftKey: shiftKey, target: target }) {
        if (this.busyUploadingVaccineSurvey || !shiftKey || key !== '?' || !(target instanceof HTMLAnchorElement) || !target.getAttribute('href')?.startsWith('/attachments/')) return;
        const associatedTab = document.querySelector('.UnderlineNav-item[href$="/associated"]');
        if (!associatedTab) throw new Error('Unable to find associated tab.');
        const counter = associatedTab.querySelector('.Counter');
        if (counter?.textContent?.trim()?.replace(/^0$/g, '')) {
            if (!confirm(`PRESS CANCEL! Event already has ${counter.textContent.trim()} associated activities. Only press OK if you are sure you want to upload a new set of vaccine surveys.`)) return;
        }
        this.busyUploadingVaccineSurvey = true;
        target.classList.add('btn-busy');
        try {
            const name = target.title;
            const form = this.closest('activity-controller').form;
            const attachmentResponse = await fetch(target.href + '?noredirect');
            if (!attachmentResponse.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(attachmentResponse, await attachmentResponse.text());
            const result = name.endsWith('.csv') ? await (0, $4eefab57ad9ba157$export$65304d575d5cb543)(await attachmentResponse.text(), name, form) : await (0, $359745fdaf4956d1$export$bf2e8542514694ef)(await attachmentResponse.arrayBuffer(), name, form);
            if (result.error || result.data === null || !Array.isArray(result.data)) throw new Error(`Unable to read data from ${name}.`);
            else if (result.data.length === 0) throw new Error(`No data found in ${name}.`);
            console.table(result.data);
            const response = await fetch(`/api/organizations/${this.organization_id}/activities/${this.activity_id}/upload-vaccine-surveys`, {
                method: 'POST',
                body: JSON.stringify(result.data),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
            const errors = await response.json();
            if (errors.length) {
                console.table(errors);
                throw new Error('Data validation errors. See console for details.');
            } else alert(`Vaccine surveys uploaded.`);
        } catch (err) {
            this.busyUploadingVaccineSurvey = false;
            alert(err);
            throw err;
        } finally{
            target.classList.remove('btn-busy');
            if (this.busyUploadingVaccineSurvey) {
                target.textContent = 'Refresh page & confirm count before proceeding';
                target.classList.add('color-fg-danger');
                target.removeAttribute('href');
            }
        }
    }
    resolveFieldLinks() {
        document.querySelectorAll('[href^="#field:"]').forEach((a)=>{
            const property_id = a.getAttribute('href').substr(7);
            const control = this.form.querySelector([
                `[name="responses/p${property_id}"][id]:not([type="hidden"])`,
                `[name^="responses/p${property_id}:"][id]:not([type="hidden"])`,
                `[calculated-value^="responses/p${property_id}:"]`
            ].join(','));
            if (!control) {
                console.log(`no input for ${property_id}`);
                return;
            }
            const group = control.closest('.form-group');
            if (!group) {
                console.log(`no group for ${property_id}`);
                return;
            }
            control.style.scrollMarginTop = `${Math.max(control.offsetTop - group.offsetTop, 60)}px`;
            a.href = `#${control.id}`;
            if (this.elementsContainer?.hidden) a.addEventListener('click', ()=>{
                this.editElements(control);
            });
        });
        document.querySelectorAll('[href^="#associated:person"],[href^="#associated:parent-person-details"],[href^="#associated:parent-person"],[href^="#associated:person-details"],[href^="#associated:parent-activity"]').forEach((a)=>{
            const association = a.getAttribute('href').substr(12);
            switch(association){
                case 'person':
                    a.href = this.dataset.person_href ?? '';
                    break;
                case 'person-details':
                    a.href = (this.dataset.person_href ?? '') + '/details';
                    break;
                case 'parent-person':
                case 'parent-person-details':
                    a.href = this.dataset.parent_person_href ? this.dataset.parent_person_href + (association === 'parent-person-details' ? '/details' : '') : a.href;
                    break;
                case 'parent-activity':
                    a.href = this.dataset.parent_activity_href || a.href;
                    break;
            }
        });
        document.querySelectorAll('[href^="#status:"]').forEach((a)=>{
            const status = a.getAttribute('href').substr(8);
            if (!(0, $fc2f5b0b15619892$export$d009ce1991333b4e).some((x)=>x.id === status)) return;
            a.role = 'button';
            a.addEventListener('click', (event)=>{
                event.preventDefault();
                this.editElements();
                const radios = this.form.elements.namedItem('status');
                for(let i = radios.length - 1; i >= 0; i--){
                    const radio = radios.item(i);
                    if (radio.value === status) {
                        radio.click();
                        break;
                    }
                }
            });
        });
        document.querySelectorAll('[href^="#print:"]').forEach((a)=>{
            const behavior = a.getAttribute('href').substr(7);
            if (![
                'summary',
                'summary-with-comments',
                'details',
                'default'
            ].includes(behavior)) return;
            a.role = 'button';
            if (behavior === 'default') a.addEventListener('click', (event)=>{
                event.preventDefault();
                print();
            });
            else {
                a.setAttribute('activity-behavior', `print-${behavior}`);
                a.toggleAttribute('data-requires-submit', true);
                a.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span>${a.textContent}</span>`);
                a.addEventListener('click', (event)=>{
                    event.preventDefault();
                });
            }
        });
        document.querySelectorAll('[href^="#assistant:"]').forEach((a)=>{
            const prompt = decodeURIComponent(a.getAttribute('href').substr(11));
            a.role = 'button';
            a.addEventListener('click', (event)=>{
                event.preventDefault();
                const invokeEvent = new CustomEvent((0, $43dd9e4a1201e515$export$b9a20415b25a91f7), {
                    detail: {
                        prompt: prompt
                    },
                    bubbles: true
                });
                dispatchEvent(invokeEvent);
            });
        });
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "form", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "elementsContainer", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "elementsSummaryContainer", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "creationFields", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "timelineContainer", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "editCommentTemplate", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "subscribersSection", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "attachmentsSection", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "eventEnrollmentLinkSection", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "eventQuestionnairesSection", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "railActivitySendingRequests", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "addAnotherContent", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "assigneePicker", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "assigneePrintContainer", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "headingNavLinks", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "printCommentsItems", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $eb3c1389b956a11c$export$7aabe8b3a840d2fd)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "organization_id", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $eb3c1389b956a11c$export$7aabe8b3a840d2fd)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "activity_id", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $eb3c1389b956a11c$export$7aabe8b3a840d2fd)
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039.prototype, "status_assignment_src", void 0);
$92bbe4a5fa06c12f$export$2e2bcd8739ae039 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('activity-controller')
], $92bbe4a5fa06c12f$export$2e2bcd8739ae039);
function $92bbe4a5fa06c12f$var$setActivityElementValue(element, property, value) {
    let changed = null;
    if (!property.calculated && property.type === 'int' && property.choice_type !== 'none') {
        const inputs = element.querySelectorAll(`[name="responses/p${property.property_id}"],[name^="responses/p${property.property_id}:"]`);
        let checkedFn;
        if (property.choice_type === 'multiple') {
            if (typeof value === 'number') value = (0, $fd1cd71095fc7279$export$7ad13431816ff1fa)(value);
            if (Array.isArray(value)) checkedFn = (x)=>x.checked = value.find((v)=>String(v) === x.value);
            else checkedFn = (x)=>x.checked = x.value === '';
        } else checkedFn = (x)=>x.checked = x.value === String(value);
        inputs.forEach((x)=>{
            if (x instanceof HTMLSelectElement) {
                x.value = String(value ?? '');
                return;
            }
            const checked = checkedFn(x);
            if (checked !== x.checked) {
                changed = x;
                x.checked = checked;
            }
        });
    } else {
        const input = element.querySelector(`[name="responses/p${property.property_id}"],[name^="responses/p${property.property_id}:"]`);
        if (property.type === 'date') {
            if (value) value = new Date(value);
            if (value instanceof Date) value = (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format(value);
        }
        value = (value ?? '').toString();
        if (input.value !== value) {
            changed = input;
            input.value = value;
        }
    }
    return changed;
}








const $8cc5ae33f12b8590$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
const $8cc5ae33f12b8590$export$94a24a4e724aa571 = 'activity-select-change';
class $8cc5ae33f12b8590$export$2e2bcd8739ae039 extends HTMLElement {
    get remoteInput() {
        return this.querySelector('remote-input');
    }
    get parent_activity_definition_id() {
        return this.getAttribute('parent_activity_definition_id');
    }
    get activity_definition_id() {
        return this.getAttribute('activity_definition_id');
    }
    get organization_id() {
        return this.getAttribute('organization_id');
    }
    get activity_id() {
        return this.input.value || null;
    }
    get start_date() {
        return this.input.getAttribute('activity_start_date') || null;
    }
    get end_date() {
        return this.input.getAttribute('activity_end_date') || null;
    }
    get name() {
        return this.getAttribute('name');
    }
    get required() {
        return this.hasAttribute('required');
    }
    get label() {
        return this.getAttribute('label');
    }
    get period() {
        return this.hasAttribute('period');
    }
    get menuButton() {
        return this.querySelector('summary [data-menu-button]');
    }
    connectedCallback() {
        addEventListener($8cc5ae33f12b8590$export$94a24a4e724aa571, this);
        this.addEventListener('focus', this, {
            capture: true
        });
    }
    disconnectedCallback() {
        removeEventListener($8cc5ae33f12b8590$export$94a24a4e724aa571, this);
        this.removeEventListener('focus', this, {
            capture: true
        });
    }
    handleEvent(event) {
        switch(event.type){
            case $8cc5ae33f12b8590$export$94a24a4e724aa571:
                {
                    if (event.target === this || !(event.target instanceof $8cc5ae33f12b8590$export$2e2bcd8739ae039)) return;
                    if (this.parent_activity_definition_id !== event.target.activity_definition_id) return;
                    // update remote-input.src
                    const remoteInput = this.remoteInput;
                    const url = new URL(remoteInput.src, location.origin);
                    url.searchParams.delete('parent_activity_id');
                    const activity_id = event.target.activity_id;
                    if (activity_id) url.searchParams.set('parent_activity_id', activity_id);
                    remoteInput.src = url.href;
                    // clear selected value
                    this.clear();
                    return;
                }
            case 'focus':
                {
                    const remoteInput = this.remoteInput;
                    const url = new URL(remoteInput.src, location.origin);
                    const form = this.closest('form');
                    const startDateInput = form?.elements.namedItem('start_date:date');
                    if (startDateInput instanceof HTMLInputElement && isFinite(Date.parse(startDateInput.value))) url.searchParams.set('start_date', new Date(startDateInput.value).toISOString().substr(0, 10));
                    if (remoteInput.src !== url.href) remoteInput.src = url.href;
                    return;
                }
            default:
                throw new Error(`Unhandled event: ${event.type}`);
        }
    }
    detailsMenuSelected() {
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.input);
        this.dispatchEvent(new CustomEvent($8cc5ae33f12b8590$export$94a24a4e724aa571, {
            bubbles: true
        }));
        const activity_id = this.activity_id;
        this.preview?.remove();
        if (activity_id) this.insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<include-fragment
            src="/api/organizations/${this.organization_id}/activities/${this.activity_id}/summary-card?target=activity-select.preview"
            accept="text/fragment+html"
            class="d-flex gap-2 flex-items-center flex-justify-center py-4 color-fg-muted color-bg-inset rounded"
            data-target="activity-select.preview"
            role="status"
          >
            <span class="spinner-border"></span>
            <span>${(0, $b11db1b62d4a8f76$export$25a57b30938bf753)[$8cc5ae33f12b8590$var$locale]}</span>
          </include-fragment>`));
        if (this.period) {
            const start_date = this.start_date;
            const end_date = this.end_date;
            const form = this.closest('form');
            const startDateInput = form?.elements.namedItem('start_date:date');
            const endDateInput = form?.elements.namedItem('end_date:date');
            const dueDateInput = form?.elements.namedItem('due_date:date');
            if (form && startDateInput instanceof HTMLInputElement && endDateInput instanceof HTMLInputElement && dueDateInput instanceof HTMLInputElement) {
                startDateInput.value = start_date ? (0, $b78c044e3d911d2e$export$6aa1a8800137fac7).format(new Date(start_date + 'T00:00:00.000Z')) : '';
                endDateInput.value = end_date ? (0, $b78c044e3d911d2e$export$6aa1a8800137fac7).format(new Date(end_date + 'T00:00:00.000Z')) : '';
                dueDateInput.value = endDateInput.value;
                (0, $80a2320123ddcd02$export$89348ae70780cd7a)(startDateInput);
                (0, $80a2320123ddcd02$export$89348ae70780cd7a)(endDateInput);
                (0, $80a2320123ddcd02$export$89348ae70780cd7a)(dueDateInput);
            }
        }
    }
    inputFocused() {
        this.querySelector('summary')?.click();
    }
    clear() {
        // clear value
        if (this.activity_id) {
            this.menuButton.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $457490243c387ab4$export$385c659e35a543c6)($8cc5ae33f12b8590$var$locale, this.name, this.required, this.label));
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.input);
            this.dispatchEvent(new CustomEvent($8cc5ae33f12b8590$export$94a24a4e724aa571, {
                bubbles: true
            }));
        }
        // clear preview
        this.preview?.remove();
        // clear menu filter and results
        const filterInput = this.remoteInput.input;
        filterInput.value = '';
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(filterInput);
        this.querySelector('SelectMenu-list').innerHTML = '';
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $8cc5ae33f12b8590$export$2e2bcd8739ae039.prototype, "preview", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $8cc5ae33f12b8590$export$2e2bcd8739ae039.prototype, "input", void 0);
$8cc5ae33f12b8590$export$2e2bcd8739ae039 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('activity-select')
], $8cc5ae33f12b8590$export$2e2bcd8739ae039);








const $5d91820497566546$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
class $5d91820497566546$var$AddressScopeElement extends HTMLElement {
    connectedCallback() {
        this.addEventListener('combobox-commit', this.onCommit);
        this.addEventListener('input', this.onInput);
        this.addEventListener('change', this.onChange);
        this.autocomplete.fetchOnEmpty = false;
    }
    disconnectedCallback() {
        this.removeEventListener('combobox-commit', this.onCommit);
        this.removeEventListener('input', this.onInput);
        this.removeEventListener('change', this.onChange);
    }
    onAutocompleteInputBlur() {
        // Close the dropdown on blur.
        // Timeout ensures this doesn't interfere with blurs that occur when selecting a suggestion.
        setTimeout(()=>{
            if (this.autocomplete.open) this.autocomplete.open = false;
        }, 300); // do not reduce without testing quickly toggling between autocomplete suggestions with mouse.
    }
    onAutocompleteLoadEnd() {
        // Don't open the dropdown when the input is not focused.
        if (document.activeElement !== this.autocomplete.inputElement) setTimeout(()=>{
            if (this.autocomplete.open) this.autocomplete.open = false;
        }, 0);
    }
    onChange = ()=>{};
    onCommit = async ({ target: target })=>{
        if (!(target instanceof HTMLElement)) return;
        try {
            this.fieldset.disabled = true;
            const suggestion = JSON.parse(target.getAttribute('data-autocomplete-data'));
            const postOfficeBox = target.getAttribute('data-autocomplete-post-office-box');
            const manual = suggestion.magicKey === 'MANUAL';
            let candidate;
            if (manual) {
                candidate = {
                    street_address: suggestion.text,
                    sub_address: '',
                    city: '',
                    region: '',
                    region_abbr: '',
                    postal_code: '',
                    postal_code_ext: '',
                    country: '',
                    neighborhood: '',
                    district: '',
                    metro_area: '',
                    entry_x: '',
                    entry_y: '',
                    rooftop_x: '',
                    rooftop_y: '',
                    precision: '',
                    subregion: ''
                };
                for (const input of this.manual_inputs)input.disabled = false;
            } else {
                const params = new URLSearchParams({
                    q: suggestion.text,
                    'magic-key': suggestion.magicKey,
                    'for-storage': 'true'
                });
                const response = await fetch(`/api/addresses/candidates?${params}`);
                if ((0, $8f2070e09d7bee6a$export$91cdf58e199a84d0)(response)) return;
                if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response);
                const candidates = await response.json();
                candidate = candidates[0];
                if (postOfficeBox) candidate.street_address = postOfficeBox;
            }
            for (let [key, value] of Object.entries(candidate)){
                if (key === 'postal_code' && candidate.postal_code_ext) value = `${value}-${candidate.postal_code_ext}`;
                const input = this.getInput(key);
                if (input instanceof HTMLInputElement) {
                    const newValue = String(value ?? '');
                    if (input.value !== newValue) {
                        input.value = newValue;
                        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(input);
                        (0, $80a2320123ddcd02$export$e3607ec2d7a891c4)(input, 'element-changed-animation--fast');
                    }
                }
            }
            this.rooftop_map_link.href = `https://www.google.com/maps/search/?api=1&query=${candidate.rooftop_y},${candidate.rooftop_x}`;
            this.rooftop_map_link.hidden = !candidate.rooftop_x || !candidate.rooftop_y;
            this.entry_map_link.href = `https://www.google.com/maps/search/?api=1&query=${candidate.entry_y},${candidate.entry_x}`;
            this.entry_map_link.hidden = !candidate.entry_x || !candidate.entry_y;
            this.updatePrecision(candidate.precision);
        } finally{
            this.fieldset.disabled = false;
            this.sub_address.focus();
        }
    };
    getInput(key) {
        return this.querySelector(`[name$="/${key}"],[name*="/${key}:"]`);
    }
    onInput = ({ target: target })=>{
        if (!(target instanceof HTMLInputElement) || target.type === 'checkbox' || target.name.includes('/sub_address')) return;
        this.updatePrecision('');
        this.rooftop_map_link.hidden = true;
        this.entry_map_link.hidden = true;
        const toClear = [
            'precision',
            'neighborhood',
            'district',
            'metro_area',
            'entry_x',
            'entry_y',
            'rooftop_x',
            'rooftop_y'
        ];
        if (target.name.includes('/region_abbr')) {
            toClear.push('region');
            toClear.push('country');
        }
        for (const key of toClear){
            const input = this.getInput(key);
            if (input instanceof HTMLInputElement) {
                input.value = '';
                (0, $80a2320123ddcd02$export$e3607ec2d7a891c4)(input, 'element-changed-animation--fast');
            }
        }
    };
    updatePrecision(precision) {
        this.precision_summary.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $15a966c9a3403e81$export$c4d8c2c033da1ba)($5d91820497566546$var$locale, precision));
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5d91820497566546$var$AddressScopeElement.prototype, "autocomplete", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5d91820497566546$var$AddressScopeElement.prototype, "fieldset", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5d91820497566546$var$AddressScopeElement.prototype, "sub_address", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5d91820497566546$var$AddressScopeElement.prototype, "precision_summary", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5d91820497566546$var$AddressScopeElement.prototype, "rooftop_map_link", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5d91820497566546$var$AddressScopeElement.prototype, "entry_map_link", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $5d91820497566546$var$AddressScopeElement.prototype, "manual_inputs", void 0);
$5d91820497566546$var$AddressScopeElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('address-scope')
], $5d91820497566546$var$AddressScopeElement);





class $d8c3eefaa2480577$export$e9e220b14ab953c3 extends HTMLElement {
    get value() {
        const raw = this.summary.querySelector('[data-value]').getAttribute('data-value');
        return JSON.parse(raw);
    }
    focusMenu() {
        this.remoteInput.input.focus();
    }
    select() {
        const value = this.value;
        const organization_id = value?.organization_id ?? '';
        const organization_login = value?.organization_login ?? '';
        const user_id = value?.user_id ?? '';
        const user_login = value?.user_login ?? '';
        const user_first_name = value?.user_first_name ?? '';
        const user_last_name = value?.user_last_name ?? '';
        let change = false;
        if (this.organizationIdInput.value !== organization_id) {
            change = true;
            this.organizationIdInput.value = organization_id;
            this.organizationLoginInput?.setAttribute('value', organization_login);
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.organizationIdInput);
            if (this.contractFormGroupContainer) {
                const template = organization_id ? this.suggestions.querySelector(`[data-contracts-for="${organization_id}"]`) : this.suggestions.querySelector('[data-create-organization-contracts]');
                if (template instanceof HTMLTemplateElement) {
                    this.contractFormGroupContainer.innerHTML = '';
                    this.contractFormGroupContainer.append(template.content);
                }
            }
        }
        if (this.userIdInput.value !== user_id) {
            change = true;
            this.userIdInput.value = user_id;
            this.userLoginInput?.setAttribute('value', user_login);
            this.userFirstNameInput?.setAttribute('value', user_first_name);
            this.userLastNameInput?.setAttribute('value', user_last_name);
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.userIdInput);
            this.assignToMeButton?.parentElement?.toggleAttribute('hidden', user_id !== '');
        }
        if (this.remoteInput.input?.value) {
            this.remoteInput.input.value = '';
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.remoteInput.input);
        }
        if (change) this.dispatchEvent(new CustomEvent('assignee-change', {
            bubbles: true,
            detail: value
        }));
    }
    remoteSuccess() {
    // formerly used to insert a clear selection button
    }
    assignToMeAndSave() {
        if (!this.assignToMeMenuItem) throw new Error('assignToMeMenuItem not found');
        this.suggestions.innerHTML = '';
        this.suggestions.append(this.assignToMeMenuItem.content.cloneNode(true));
        this.suggestions.querySelector('button')?.click();
        this.summary.focus();
        this.userIdInput.form?.requestSubmit();
    }
    toggleProximityTab(event) {
        const button = event.currentTarget;
        const useProximity = button === this.proximityNearbyButton;
        this.proximityAnywhereButton.ariaSelected = String(!useProximity);
        this.proximityNearbyButton.ariaSelected = String(useProximity);
        const proximityUnavailableMessage = this.proximityUnavailableMessage;
        const proximityUnavailable = useProximity && Boolean(proximityUnavailableMessage);
        this.remoteInput.toggleAttribute('hidden', proximityUnavailable);
        this.suggestions.toggleAttribute('hidden', proximityUnavailable);
        proximityUnavailableMessage?.toggleAttribute('hidden', !proximityUnavailable);
        if (proximityUnavailable) {
            button.focus();
            return;
        }
        const url = new URL(this.remoteInput.src, location.origin);
        url.searchParams.set('proximity', String(useProximity));
        this.remoteInput.src = url.toString();
        this.remoteInput.input.focus();
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.remoteInput.input);
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "userIdInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "userLoginInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "userFirstNameInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "userLastNameInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "organizationIdInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "organizationLoginInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "summary", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "remoteInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "suggestions", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "contractFormGroupContainer", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "assignToMeMenuItem", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "assignToMeButton", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "proximityAnywhereButton", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "proximityNearbyButton", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d8c3eefaa2480577$export$e9e220b14ab953c3.prototype, "proximityUnavailableMessage", void 0);
$d8c3eefaa2480577$export$e9e220b14ab953c3 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('assignee-picker')
], $d8c3eefaa2480577$export$e9e220b14ab953c3);








function $503bc3493e67da1d$export$495f1fafaa7af669({ locale: locale, readonly: readonly = false, display: display, inserted_property_id: inserted_property_id, versions: versions }) {
    if (versions.length === 0) return null;
    const extension = (0, $d5d33444928aec88$export$5f7821c344028c56)(versions[0].name);
    const type = (0, $d5d33444928aec88$export$1d5ffa38c010beaf)[extension];
    if (!type) throw new Error(`Unknown attachment type for extension ${extension}`);
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<attachment-group
    class="d-flex flex-column gap-1 lh-condensed${display === 'card' ? ' py-1 px-2 border rounded color-bg-default' : ''}"
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('style', display === 'card' ? `min-width: 250px; max-width: 350px` : null)}
    display="${display}"
    versions="${JSON.stringify(versions)}"
    version-count="${versions.length}"
  >
    ${inserted_property_id ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
            type="hidden"
            name="attachments/-:json"
            value=${JSON.stringify({
        attachment_id: versions[0].id,
        property_id: inserted_property_id
    })}
          />` : null}
    <span
      class="d-flex gap-3 ${display === 'signature' ? 'align-items-start' : 'align-items-center'} flex-justify-between"
    >
      ${display === 'signature' ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<img
              class="signature-image"
              src="${versions[0].href}"
              alt="Signature"
              style="height: 40px"
            />` : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<a
              class="Link--primary Truncate text-bold"
              href="${versions[0].href}"
              title="${versions[0].name}"
            >
              <span class="Truncate-text">
                ${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)(type.icon48(), {
        size: 18,
        viewBox: 48
    })}
                ${versions[0].name}</span
              >
            </a>`}
      ${readonly ? null : $503bc3493e67da1d$var$deleteButton(locale, versions[0])}
    </span>
    <span class="color-fg-muted text-capitalize-first-letter">
      <relative-time datetime="${versions[0].date_iso}"></relative-time>
      by ${(0, $f4d1565f2a6712b7$export$b6e69390c23686fb)(versions[0].user_unsafe_html)}
    </span>
    ${versions.length < 2 ? null : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<details class="details-reset">
            <summary class="color-fg-muted f6">
              ${versions.length - 1 === 1 ? (0, $b11db1b62d4a8f76$export$4822b96394899afb)[locale] : (0, $b11db1b62d4a8f76$export$a7ad54c5a26c2c49)[locale](versions.length - 1)}
              <span class="dropdown-caret"></span>
            </summary>
            <span class="pl-3 d-flex flex-column gap-1 mt-1">
              ${versions.slice(1).map((x)=>display === 'signature' ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span
                        class="d-flex gap-3 align-items-start flex-justify-between"
                      >
                        <img
                          class="signature-image"
                          src="${x.href}"
                          alt="Signature"
                          style="height: 40px"
                        />
                        ${readonly ? null : $503bc3493e67da1d$var$deleteButton(locale, x)}
                      </span>
                      <span class="color-fg-muted text-capitalize-first-letter">
                        <relative-time datetime="${x.date_iso}"></relative-time>
                        by ${(0, $f4d1565f2a6712b7$export$b6e69390c23686fb)(x.user_unsafe_html)}
                      </span>` : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span
                      class="d-flex flex-items-center gap-3 flex-justify-between color-fg-muted"
                    >
                      <span
                        ><a
                          class="Link--primary text-capitalize-first-letter"
                          href="${x.href}"
                          ><relative-time
                            datetime="${x.date_iso}"
                          ></relative-time
                        ></a>
                        <span>by</span>
                        ${(0, $f4d1565f2a6712b7$export$b6e69390c23686fb)(x.user_unsafe_html)}</span
                      >
                      ${readonly ? null : $503bc3493e67da1d$var$deleteButton(locale, x)}
                    </span>`)}
            </span>
          </details>`}
  </attachment-group>`;
}
function $503bc3493e67da1d$var$deleteButton(locale, { id: id, name: name }) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<button
    type="button"
    class="btn-octicon btn-octicon-danger mt-n1 mb-n1 ml-n1 mr-n1"
    aria-label="${(0, $b11db1b62d4a8f76$export$9279b045541daaab)[locale](name)}"
    data-action="click:attachment-group#deleteClick"
    attachment-id="${id}"
  >
    ${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$c6e11f163cc2dc47))}
  </button>`;
}







const $3acf142b6af1d8e0$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
class $3acf142b6af1d8e0$var$AttachmentQuestionElement extends HTMLElement {
    get property_id() {
        return parseInt(this.getAttribute('property-id'), 10);
    }
    async attachmentAccepted(event) {
        const attachments = event.detail.attachments;
        const uploadUrl = new URL(this.getAttribute('upload-href'), location.origin);
        let count = this.valueInput.value ? this.valueInput.valueAsNumber : 0;
        try {
            this.fileInput.disabled = true;
            this.fileInput.labels?.[0].classList.add('btn-busy');
            await (0, $4ab5d79d76486e1b$export$14d3a7d22f26659e)({
                locale: $3acf142b6af1d8e0$var$locale,
                attachments: attachments,
                uploadUrl: uploadUrl,
                attachmentSaved: (attachment)=>{
                    count++;
                    this.emptyContent.hidden = true;
                    this.content.insertAdjacentHTML('afterbegin', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $503bc3493e67da1d$export$495f1fafaa7af669)({
                        locale: $3acf142b6af1d8e0$var$locale,
                        readonly: false,
                        display: 'card',
                        inserted_property_id: this.property_id,
                        versions: [
                            {
                                id: attachment.id,
                                name: attachment.name,
                                href: attachment.href,
                                date_iso: new Date().toISOString(),
                                user_unsafe_html: 'you'
                            }
                        ]
                    })));
                }
            });
        } finally{
            this.fileInput.disabled = false;
            this.fileInput.labels?.[0].classList.remove('btn-busy');
            this.fileInput.focus();
            this.valueInput.value = count.toString();
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.valueInput);
        }
    }
    valueInputFocused() {
        this.fileInput.focus();
    }
    decrementCount() {
        if (this.valueInput.value === '1') {
            this.valueInput.value = '';
            this.emptyContent.hidden = false;
        } else this.valueInput.value = (parseInt(this.valueInput.value, 10) - 1).toString();
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.valueInput);
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $3acf142b6af1d8e0$var$AttachmentQuestionElement.prototype, "fileInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $3acf142b6af1d8e0$var$AttachmentQuestionElement.prototype, "valueInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $3acf142b6af1d8e0$var$AttachmentQuestionElement.prototype, "fileAttachmentElement", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $3acf142b6af1d8e0$var$AttachmentQuestionElement.prototype, "content", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $3acf142b6af1d8e0$var$AttachmentQuestionElement.prototype, "emptyContent", void 0);
$3acf142b6af1d8e0$var$AttachmentQuestionElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('attachment-question')
], $3acf142b6af1d8e0$var$AttachmentQuestionElement);
class $3acf142b6af1d8e0$var$AttachmentGroupElement extends HTMLElement {
    connectedCallback() {
        addEventListener('attachment-delete', this);
    }
    disconnectedCallback() {
        removeEventListener('attachment-delete', this);
    }
    get display() {
        return this.getAttribute('display');
    }
    versions() {
        return JSON.parse(this.getAttribute('versions'));
    }
    deleteClick(event) {
        const attachment_id = event.target instanceof Element && event.target.closest('button')?.getAttribute('attachment-id');
        if (!attachment_id) throw new Error('Delete attachment: expected attachment id.');
        const name = this.versions().find((x)=>x.id === attachment_id)?.name;
        if (!name) throw new Error('Delete attachment: versions did not contain attachment id.');
        if (confirm(this.display === 'signature' ? (0, $b11db1b62d4a8f76$export$30aaf2514f0013cf)[$3acf142b6af1d8e0$var$locale] : (0, $b11db1b62d4a8f76$export$4a4b0db14c023cd8)[$3acf142b6af1d8e0$var$locale](name))) this.dispatchEvent(new CustomEvent('attachment-delete', {
            bubbles: true,
            detail: {
                attachment_id: attachment_id,
                logged: false,
                display: this.display
            }
        }));
    }
    handleEvent(event) {
        if (!event.detail.logged) {
            event.detail.logged = true;
            const controller = document.querySelector('activity-controller');
            if (!controller) throw new Error('Expected activity-controller.');
            controller.form.insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
            type="hidden"
            name="delete_attachments/-:json"
            value=${JSON.stringify({
                attachment_id: event.detail.attachment_id
            })}
          />`));
            if (event.detail.display !== 'signature') {
                const heading = controller.attachmentsSection.querySelector('h2');
                if (heading) {
                    const count = +heading.getAttribute('attachment-count') - 1;
                    heading.setAttribute('attachment-count', count.toString());
                    if (count === 0) controller.attachmentsSection.innerHTML = '';
                    heading.textContent = count === 1 ? (0, $b11db1b62d4a8f76$export$234c584cd96079ce)[$3acf142b6af1d8e0$var$locale] : (0, $b11db1b62d4a8f76$export$dd7aa9dbdc015ba1)[$3acf142b6af1d8e0$var$locale](count);
                }
            }
        }
        const versions = this.versions();
        const index = versions.findIndex((v)=>v.id === event.detail.attachment_id);
        if (index === -1) return;
        versions.splice(index, 1);
        (this.closest('attachment-question') ?? this.closest('signature-question'))?.decrementCount();
        // re-render the attachment group
        this.insertAdjacentHTML('afterend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $503bc3493e67da1d$export$495f1fafaa7af669)({
            locale: $3acf142b6af1d8e0$var$locale,
            readonly: false,
            display: this.display,
            versions: versions
        })));
        this.remove();
    }
}
$3acf142b6af1d8e0$var$AttachmentGroupElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('attachment-group')
], $3acf142b6af1d8e0$var$AttachmentGroupElement);



function $5b412f9892858f85$export$e4f5fb782e2ac71d(text, textToMark) {
    if (textToMark.length === 0) return text;
    const index = text.toLowerCase().indexOf(textToMark.toLowerCase());
    if (index === -1) return text;
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`${text.substr(0, index)}<mark>${text.substr(index, textToMark.length)}</mark>${text.substr(index + textToMark.length)}`;
}




class $f9be3432210c00ed$export$c93b5c132cf05ac3 extends HTMLElement {
    abortResolveController;
    get autocomplete() {
        return this.closest('auto-complete');
    }
    connectedCallback() {
        this.disconnectController = new AbortController();
        const signal = this.disconnectController.signal;
        const autocomplete = this.autocomplete;
        if (!autocomplete) return;
        // the github auto-complete element always sets autocomplete to off, which may not be appropriate.
        if (this.hasAttribute('autocomplete')) requestAnimationFrame(()=>autocomplete.inputElement?.setAttribute('autocomplete', this.getAttribute('autocomplete') ?? 'off'));
        if (autocomplete.src === '/use-events') autocomplete.fetchResult = $f9be3432210c00ed$var$dispatchAutoCompleteProvide;
        autocomplete.inputElement?.addEventListener('blur', ()=>{
            // Close the dropdown on blur.
            // Timeout ensures this doesn't interfere with blurs that occur when selecting a suggestion.
            setTimeout(()=>{
                if (autocomplete.open) autocomplete.open = false;
            }, 300); // do not reduce without testing quickly toggling between autocomplete suggestions with mouse.
        }, {
            signal: signal
        });
        autocomplete.addEventListener('auto-complete-change', ()=>{
            if (autocomplete.inputElement?.value.endsWith(' ')) // trigger input event to fetch new suggestions
            autocomplete.inputElement.dispatchEvent(new CustomEvent('input', {
                bubbles: true
            }));
        }, {
            signal: signal
        });
        const relatedInput = this.hasAttribute('for') ? document.getElementById(this.getAttribute('for')) : this.firstElementChild;
        if (relatedInput instanceof HTMLInputElement || relatedInput instanceof HTMLTextAreaElement) {
            const relatedInputKey = this.getAttribute('for-key') ?? 'id';
            autocomplete.addEventListener('combobox-commit', ({ target: target })=>{
                this.abortResolveController?.abort();
                if (!(target instanceof HTMLElement)) return;
                let data = JSON.parse(target.getAttribute('data-autocomplete-data'));
                if ('magicKey' in data) {
                    const autocomplete = this.autocomplete;
                    const input = autocomplete.inputElement;
                    const suggestion = data.text;
                    const params = new URLSearchParams({
                        q: data.text,
                        'magic-key': data.magicKey,
                        'for-storage': 'true'
                    });
                    data = {
                        id: '',
                        title: ''
                    };
                    const resolveAddress = async ()=>{
                        input.labels[0].insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="spinner-border color-fg-muted ml-2"></span>`));
                        const spinner = input.labels[0].lastElementChild;
                        this.abortResolveController = new AbortController();
                        const signal = this.abortResolveController.signal;
                        const response = await fetch(`/api/addresses/candidates?${params}`, {
                            signal: signal
                        });
                        spinner.remove();
                        if ((0, $8f2070e09d7bee6a$export$91cdf58e199a84d0)(response)) return;
                        if (signal.aborted) return;
                        if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response);
                        const [candidate] = await response.json();
                        const category = new URL(autocomplete.src, location.href).searchParams.get('category');
                        const field = (0, $2b5d94bf448cfcef$export$d30a285adb132bc8)[category];
                        const id = candidate[field];
                        const title = suggestion;
                        input.value = relatedInputKey === 'id' ? title : id;
                        relatedInput.value = relatedInputKey === 'id' ? id : title;
                        relatedInput.dataset.displayValue = relatedInputKey === 'id' ? title : id;
                        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(input);
                    };
                    resolveAddress();
                }
                const { id: id, title: title } = data;
                relatedInput.value = relatedInputKey === 'id' ? id : title;
                relatedInput.dataset.displayValue = relatedInputKey === 'id' ? title : id;
                target.setAttribute('data-autocomplete-value', relatedInputKey === 'id' ? title : id);
            }, {
                signal: signal,
                capture: true
            });
            autocomplete.inputElement?.addEventListener('change', ()=>{
                const current = autocomplete.inputElement.value;
                if (current !== relatedInput.dataset.displayValue) {
                    autocomplete.inputElement.value = '';
                    relatedInput.value = '';
                    relatedInput.dataset.displayValue = '';
                }
            }, {
                signal: signal
            });
            // make sure the input element can be searched.
            const maxLength = autocomplete.inputElement?.maxLength ?? 100;
            if (maxLength < 20) {
                autocomplete.inputElement.addEventListener('focus', ()=>autocomplete.inputElement.maxLength = 30, {
                    signal: signal,
                    capture: true
                });
                autocomplete.inputElement.addEventListener('blur', ()=>{
                    autocomplete.inputElement.maxLength = maxLength;
                }, {
                    signal: signal,
                    capture: true
                });
            }
        }
    }
    disconnectedCallback() {
        this.disconnectController.abort();
    }
}
async function $f9be3432210c00ed$var$dispatchAutoCompleteProvide(_url) {
    const provided = [];
    const provide = (result)=>{
        provided.push(result);
    };
    const relatedTarget = this.inputElement;
    this.dispatchEvent(new CustomEvent('auto-complete-provide', {
        bubbles: true,
        detail: {
            relatedTarget: relatedTarget,
            provide: provide
        }
    }));
    const results = await Promise.all(provided);
    return (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)(results.flatMap((x)=>x.suggestions).map(({ id: id, title: title })=>(0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<li
            role="option"
            class="autocomplete-item"
            data-autocomplete-value="${id}"
            data-autocomplete-data="${JSON.stringify({
            id: id,
            title: title
        })}"
          >
            ${(0, $5b412f9892858f85$export$e4f5fb782e2ac71d)(title, relatedTarget.value)}
          </li>`));
}
if (!window.customElements.get('auto-complete-behavior')) {
    window.AutoCompleteBehaviorElement = $f9be3432210c00ed$export$c93b5c132cf05ac3;
    window.customElements.define('auto-complete-behavior', $f9be3432210c00ed$export$c93b5c132cf05ac3);
}





function $0cc28ac8708b4f9d$export$e1e9fa9aba80de8b(item, disabled) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`
    <li
      role="option"
      aria-selected="true"
      id="${(0, $65af17b6a828fccf$export$9e1c824dbb29e809)()}"
      class="autocomplete-list-box-item autocomplete-list-box-item-option"
      data-list-box-value="${JSON.stringify(item)}"
    >
      ${item.title}
      <button
        class="btn-close"
        tabindex="-1"
        type="button"
        aria-label="Delete ${item.title}"
        title="Delete"
        data-list-box-delete
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('hidden', disabled)}
      ></button>
    </li>
  `;
}
function $0cc28ac8708b4f9d$export$c8ce1c1a107990cc({ id: id, label: label, name: name, value: value, required: required, autocompleteSrc: autocompleteSrc, disabled: disabled, parametric: parametric }) {
    if (!name.endsWith(':json')) throw new Error(`Unexpected <list-box> input name "${name}". Name should end with ":json" directive.`);
    const autocompleteListId = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<autocomplete-list-box
    class="d-block"
    ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
    ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('parametric', parametric)}
    data-action="
        combobox-commit:autocomplete-list-box#comboboxCommit
        list-box-item-delete:autocomplete-list-box#listBoxItemDelete
        auto-complete-results-html-rendered:autocomplete-list-box#resultsAdded
      "
  >
    <auto-complete
      class="d-block position-relative"
      src="${autocompleteSrc}"
      for="${autocompleteListId}"
      data-target="autocomplete-list-box.autocomplete"
      fetch-on-empty
    >
      <list-box
        class="d-block form-control input-sm use-focus-within p-0 cursor-text"
        data-action="click:autocomplete-list-box#focusAutocompleteInput"
        multiple
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
      >
        <ul
          aria-label="${label}"
          class="autocomplete-list-box-list"
          data-target="autocomplete-list-box.list"
        >
          ${(value ?? []).map((x)=>$0cc28ac8708b4f9d$export$e1e9fa9aba80de8b(x, disabled))}
          <li
            class="autocomplete-list-box-item flex-1"
            data-target="autocomplete-list-box.autocompleteInputItem"
          >
            <input
              class="autocomplete-list-box-input"
              id="${id}"
              type="search"
              maxlength="200"
              ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required && (value ?? []).length === 0)}
              ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
              aria-label="Value"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              data-target="autocomplete-list-box.autocompleteInput"
              data-action="keydown:autocomplete-list-box#handleInputKeyDown"
            />
          </li>
        </ul>
      </list-box>
      <ul id="${autocompleteListId}" class="autocomplete-results" hidden></ul>
    </auto-complete>
    <input
      type="hidden"
      name="${name}"
      value="${JSON.stringify(value)}"
      data-target="autocomplete-list-box.valueInput"
    />
  </autocomplete-list-box>`;
}









const $f3fc72dd1f3291ac$var$definitionsMap = new Map();
const $f3fc72dd1f3291ac$var$propertiesMap = new Map();
function $f3fc72dd1f3291ac$export$acd79bbf6f49afea(form) {
    let definition = $f3fc72dd1f3291ac$var$definitionsMap.get(form);
    let properties = $f3fc72dd1f3291ac$var$propertiesMap.get(form);
    if (definition && properties) ;
    else {
        // console.log('not cached');
        definition = (0, $6980cc602f309497$export$ae2b2db16f8c0171)((0, $d926988b2eed7310$export$2d71e4ce1d783c30)(form)).definition;
        definition.parameters ??= [];
        definition.parameters.forEach((p, i)=>{
            p.name = p.name.toUpperCase();
            if (!(0, $413788c7d08dddf5$export$99da40ee05a17718).test(p.name)) p.name = `$PARAMETER_${i}`;
        });
        properties = Array.from(form.querySelectorAll('[data-property^="{"]')).map((el)=>JSON.parse(el.dataset.property)).filter((x, i, a)=>a.findIndex((y)=>y.property_id === x.property_id) === i);
        $f3fc72dd1f3291ac$var$definitionsMap.set(form, definition);
        $f3fc72dd1f3291ac$var$propertiesMap.set(form, properties);
        Promise.resolve().then(()=>{
            $f3fc72dd1f3291ac$var$definitionsMap.delete(form);
            $f3fc72dd1f3291ac$var$propertiesMap.delete(form);
        });
    }
    return {
        definition: definition,
        properties: properties
    };
}


function $82003cd051bc5cad$export$149e10162b59b4e2(input) {
    return $82003cd051bc5cad$var$getInputParameters(input).filteredParameters;
}
function $82003cd051bc5cad$export$9c08897bbef487d2(input, values) {
    for (const value of values){
        if (!(0, $413788c7d08dddf5$export$99da40ee05a17718).test(value)) continue;
        const { parameters: parameters, filteredParameters: filteredParameters, hint: hint } = $82003cd051bc5cad$var$getInputParameters(input);
        if (!parameters.some((p)=>p.name === value)) return {
            valid: false,
            message: `Invalid parameter reference. Unknown parameter "${value}".`
        };
        if (!filteredParameters.some((p)=>p.name === value)) return {
            valid: false,
            message: `Invalid parameter reference.${hint ? ` Parameter "${value}" is not of type ${hint}.` : ''}`
        };
    }
    return {
        valid: true
    };
}
function $82003cd051bc5cad$var$getInputParameters(input) {
    // todo: request via event.
    if (!input.form) throw new Error('Input is not form associated.');
    const { definition: definition, properties: properties } = (0, $f3fc72dd1f3291ac$export$acd79bbf6f49afea)(input.form);
    const { columns: columns, parameters: parameters } = definition;
    // parameters are used in filters, so we need to know the type of filter to determine which types of parameters are valid.
    const filterPointer = '/' + input.name.split('/').slice(0, -1).join('/');
    const filter = (0, $91beb2998e956c83$export$3988ae62b71be9a3)({
        definition: definition
    }, filterPointer);
    if (!filter) throw new Error(`Unable to locate filter associated with parameter reference "${filterPointer}".`);
    const parameterTypes = [];
    const types = [];
    let hint = undefined;
    let property_id;
    if (filter.type === 'standard') property_id = filter.property_id;
    else if (filter.aggregate !== 'count' && // typescript hack
    (0, $413788c7d08dddf5$export$30b73a7e32416e4a)(filter.aggregate)) property_id = filter.subquery_property_id;
    else {
        parameterTypes.push('literal-number', 'select-number');
        types.push('int', 'decimal');
        hint = 'number';
    }
    if (property_id) {
        const property = properties.find((p)=>p.property_id === property_id);
        if (!property) throw new Error(`Unable to locate property associated with filter "${filterPointer}" with property_id ${property_id}.`);
        switch(property.type){
            case 'currency':
            case 'decimal':
            case 'int':
                if (property.type === 'int' && (property.choice_type === 'single' || property.choice_type === 'multiple')) {
                    parameterTypes.push('choice');
                    hint = 'choice';
                    break;
                }
                if (property.choice_type !== 'none') break;
                parameterTypes.push('literal-number', 'select-number');
                types.push('int', 'decimal');
                hint = 'number';
                break;
            case 'date':
                parameterTypes.push('literal-date', 'month-date', 'select-date');
                types.push('date', 'datetime');
                hint = 'date';
                break;
            case 'uniqueidentifier':
                switch(property.property_id){
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.activity_record:
                        parameterTypes.push('activity');
                        hint = 'activity';
                        break;
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.project_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.projects:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.project_id:
                        parameterTypes.push('project');
                        hint = 'project';
                        break;
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.create_organization_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.update_organization_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).user_organization.organization_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.update_organization_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.organization_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.contracted_by_organization_id:
                        parameterTypes.push('organization');
                        hint = 'organization';
                        break;
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.user_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.create_user_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.update_user_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_user_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.update_user_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_user_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.comment_create_user_id:
                    case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.comment_mentioned_user_id:
                        parameterTypes.push('user');
                        hint = 'user';
                        break;
                }
                break;
        }
    }
    const filteredParameters = [];
    for (const parameter of parameters){
        if (parameter.type === 'choice' && parameterTypes.includes(parameter.type) && parameter.property_id === property_id) filteredParameters.push(parameter);
        else if (parameter.type !== 'choice' && parameterTypes.includes(parameter.type)) filteredParameters.push(parameter);
        else if (parameter.type === 'expression' && types.length) {
            const result = (0, $28bf66f5acd2204d$export$9692209d71b8f134)({
                name: parameter.name,
                expression: parameter.expression,
                getDefinitionInfo: ()=>({
                        columns: columns,
                        parameters: parameters,
                        properties: properties
                    })
            });
            if (result.valid && types.includes(result.type)) filteredParameters.push(parameter);
        } else if ((parameter.type === 'subquery' || parameter.type === 'report-subquery') && types.length) {
            const { type: type } = (0, $413788c7d08dddf5$export$13d77bb70d7b9d75)(parameter, properties);
            if (type && types.includes(type)) filteredParameters.push(parameter);
        }
    }
    return {
        parameterTypes: parameterTypes,
        types: types,
        hint: hint,
        definition: definition,
        properties: properties,
        parameters: parameters,
        filteredParameters: filteredParameters
    };
}




// fire event when results html is added to the menu
// https://github.com/github/auto-complete-element/blob/8df0008b15af3dc5064db09e15533b77e3f70033/src/autocomplete.ts#L209
const $2dcd098aa4874545$var$standardIdentifyOptions = (0, $17d439654615f6cc$export$2e2bcd8739ae039).prototype.identifyOptions;
(0, $17d439654615f6cc$export$2e2bcd8739ae039).prototype.identifyOptions = function(...args) {
    this.container.dispatchEvent(new CustomEvent('auto-complete-results-html-rendered', {
        bubbles: true,
        detail: {
            results: this.results,
            query: this.input.value.trim()
        }
    }));
    $2dcd098aa4874545$var$standardIdentifyOptions.call(this, ...args);
};
class $2dcd098aa4874545$var$AutocompleteListBoxElement extends HTMLElement {
    get parametric() {
        return this.hasAttribute('parametric');
    }
    connectedCallback() {
        document.body.addEventListener('focus', this, {
            capture: true
        });
        document.body.addEventListener('click', this);
    }
    disconnectedCallback() {
        document.body.removeEventListener('focus', this, {
            capture: true
        });
        document.body.removeEventListener('click', this);
    }
    getValue() {
        const current = Array.from(this.list.querySelectorAll('[data-list-box-value]')).map((el)=>JSON.parse(el.getAttribute('data-list-box-value')));
        if (current.length === 0) return null;
        return current;
    }
    synchronize() {
        if (this.hasAttribute('required') && !this.list.querySelectorAll('[data-list-box-value]').length) this.autocompleteInput.required = true;
        else this.autocompleteInput.required = false;
        this.valueInput.value = JSON.stringify(this.getValue());
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.valueInput);
    }
    clear() {
        this.list.querySelectorAll('[data-list-box-value]').forEach((el)=>el.remove());
        this.synchronize();
    }
    handleInputKeyDown(event) {
        if (event.key === 'Enter' && this.autocompleteInput.value.length) {
            event.preventDefault();
            return;
        }
        if (event.key === 'Backspace' && this.autocompleteInput.value === '' && this.autocompleteInputItem.previousElementSibling instanceof HTMLElement && !event.metaKey && !event.altKey && !event.ctrlKey && !event.shiftKey) {
            this.autocompleteInputItem.previousElementSibling.click();
            this.list.dispatchEvent(new KeyboardEvent(event.type, event));
        }
    }
    async comboboxCommit(event) {
        this.autocomplete.value = '';
        if (!(event.target instanceof Element)) return;
        let value = JSON.parse(event.target.getAttribute('data-autocomplete-data'));
        let item;
        if ('magicKey' in value) {
            const params = new URLSearchParams({
                q: value.text,
                'magic-key': value.magicKey,
                'for-storage': 'true'
            });
            this.autocompleteInputItem.insertAdjacentHTML('beforebegin', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<li
            class="autocomplete-list-box-item autocomplete-list-box-item-option"
          >
            <span class="spinner-border color-fg-muted"></span>
          </li>`));
            const spinner = this.autocompleteInputItem.previousElementSibling;
            const response = await fetch(`/api/addresses/candidates?${params}`);
            spinner.remove();
            if ((0, $8f2070e09d7bee6a$export$91cdf58e199a84d0)(response)) return;
            if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response);
            const [candidate] = await response.json();
            const category = new URL(this.autocomplete.src, location.href).searchParams.get('category');
            const field = (0, $2b5d94bf448cfcef$export$d30a285adb132bc8)[category];
            item = {
                id: candidate[field],
                title: candidate[field]
            };
        } else item = value;
        const current = this.getValue() || [];
        if (current.find((x)=>x.id === item.id)) return;
        this.autocompleteInputItem.insertAdjacentHTML('beforebegin', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $0cc28ac8708b4f9d$export$e1e9fa9aba80de8b)(item, false)));
        this.synchronize();
        this.focusAutocompleteInput();
    }
    listBoxItemDelete() {
        if (this.list.querySelectorAll('[data-list-box-value]').length === 0) this.autocompleteInput.focus();
        Promise.resolve().then(()=>this.synchronize());
    }
    focusAutocompleteInput() {
        this.autocompleteInput.focus();
    }
    handleEvent(event) {
        if ([
            'focus',
            'click'
        ].includes(event.type) && !this.contains(event.target)) {
            this.autocompleteInput.value = '';
            this.autocomplete.open = false;
        }
    }
    resultsAdded(event) {
        if (!this.parametric || !this.valueInput?.form) return;
        const { results: results, query: query } = event.detail;
        const parameters = (0, $82003cd051bc5cad$export$149e10162b59b4e2)(this.valueInput).filter((x)=>x.name.toLowerCase().includes(query.toLowerCase()));
        if (!parameters?.length) return;
        results.insertAdjacentHTML('afterbegin', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)(parameters.map(({ name: name })=>(0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<li
              role="option"
              class="autocomplete-item"
              data-autocomplete-value="${name}"
              data-autocomplete-data="${JSON.stringify({
                id: name,
                title: name
            })}"
            >
              ${(0, $5b412f9892858f85$export$e4f5fb782e2ac71d)(name, query)}
            </li>`)));
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $2dcd098aa4874545$var$AutocompleteListBoxElement.prototype, "list", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $2dcd098aa4874545$var$AutocompleteListBoxElement.prototype, "autocomplete", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $2dcd098aa4874545$var$AutocompleteListBoxElement.prototype, "valueInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $2dcd098aa4874545$var$AutocompleteListBoxElement.prototype, "autocompleteInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $2dcd098aa4874545$var$AutocompleteListBoxElement.prototype, "autocompleteInputItem", void 0);
$2dcd098aa4874545$var$AutocompleteListBoxElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('autocomplete-list-box')
], $2dcd098aa4874545$var$AutocompleteListBoxElement);
(0, $84fd3dc30499b2d0$export$86f1725708ac86dc)((input, _label)=>{
    if (input instanceof HTMLInputElement && input.getAttribute('data-target')?.includes('autocomplete-list-box.autocompleteInput')) {
        const box = input.closest('autocomplete-list-box');
        if (!box || !box.parametric || box.autocompleteInput !== input) return null;
        const items = JSON.parse(box.valueInput.value);
        if (items.length === 0) return null;
        const result = (0, $82003cd051bc5cad$export$9c08897bbef487d2)(box.valueInput, items.map((x)=>x.id));
        return result.valid ? null : result.message;
    }
    return null;
});




const $b52acf796209d39a$var$billingClaimPrimaryStatusIcons = {
    unsubmitted: (0, $84c634e688af79ca$export$36e22210a5796abb),
    '837_pending': (0, $84c634e688af79ca$export$def956fbe4c089ce),
    '837_accepted': (0, $84c634e688af79ca$export$cfe4c2456a8e9cec),
    '837_accepted_with_errors': (0, $84c634e688af79ca$export$8e47d324a7a20b30),
    '837_partially_accepted': (0, $84c634e688af79ca$export$8e47d324a7a20b30),
    '837_rejected': (0, $84c634e688af79ca$export$d0029a3ee0c0e03),
    received: (0, $84c634e688af79ca$export$d2997daddac9b44),
    accepted_for_adjudication: (0, $84c634e688af79ca$export$cfe4c2456a8e9cec),
    forwarded: (0, $84c634e688af79ca$export$1c9c5f58b493da5e),
    rejected: (0, $84c634e688af79ca$export$d0029a3ee0c0e03),
    acknowledged: (0, $84c634e688af79ca$export$cfe4c2456a8e9cec),
    unremitted: (0, $84c634e688af79ca$export$def956fbe4c089ce),
    paid: (0, $84c634e688af79ca$export$cfe4c2456a8e9cec),
    partially_paid: (0, $84c634e688af79ca$export$8e47d324a7a20b30),
    denied: (0, $84c634e688af79ca$export$82115b98859c1168),
    zero_paid: (0, $84c634e688af79ca$export$d0029a3ee0c0e03),
    reversal: (0, $84c634e688af79ca$export$22a44c3490da3c1a)
};
function $b52acf796209d39a$export$9981951a630ceb68(status) {
    return $b52acf796209d39a$var$billingClaimPrimaryStatusIcons[status];
}
const $b52acf796209d39a$export$cc09d3510acf7ab4 = {
    unsubmitted: 'color-fg-muted',
    '837_pending': 'color-fg-muted',
    '837_accepted': 'color-fg-success',
    '837_accepted_with_errors': 'color-fg-attention',
    '837_partially_accepted': 'color-fg-attention',
    '837_rejected': 'color-fg-danger',
    received: 'color-fg-success',
    accepted_for_adjudication: 'color-fg-success',
    forwarded: 'color-fg-success',
    rejected: 'color-fg-danger',
    acknowledged: 'color-fg-success',
    unremitted: 'color-fg-muted',
    paid: 'color-fg-success',
    partially_paid: 'color-fg-attention',
    denied: 'color-fg-danger',
    zero_paid: 'color-fg-danger',
    reversal: 'color-fg-attention'
};





class $57fe493949b5746c$export$cd175f1e676ad8c5 extends HTMLElement {
    grid;
    rowData;
    connectedCallback() {
        agGrid.LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);
        if (this.grid) return;
        const rowData = this.rowData ??= this.readRowData();
        this.grid = agGrid.createGrid(this.gridHost, $57fe493949b5746c$export$4423dbd56f646d75(rowData, this.getGridOptions(rowData)));
    }
    disconnectedCallback() {
        this.grid?.destroy();
        this.grid = undefined;
    }
    readRowData() {
        const rowData = JSON.parse(this.rowDataScript.textContent ?? '[]');
        this.rowDataScript.remove();
        return rowData;
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $57fe493949b5746c$export$cd175f1e676ad8c5.prototype, "rowDataScript", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $57fe493949b5746c$export$cd175f1e676ad8c5.prototype, "gridHost", void 0);
function $57fe493949b5746c$export$4423dbd56f646d75(rowData, options) {
    const { defaultColDef: defaultColDef, rowClassRules: rowClassRules, onFirstDataRendered: onFirstDataRendered, ...overrides } = options;
    return {
        rowModelType: 'clientSide',
        rowData: rowData,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            minWidth: 110,
            suppressHeaderMenuButton: true,
            ...defaultColDef
        },
        rowClassRules: {
            'color-bg-subtle': ({ rowIndex: rowIndex })=>rowIndex % 2 !== 0,
            ...rowClassRules
        },
        cellSelection: true,
        popupParent: document.body,
        getContextMenuItems: ()=>[
                'copy',
                'copyWithHeaders'
            ],
        onFirstDataRendered: onFirstDataRendered ?? (({ api: api })=>api.sizeColumnsToFit()),
        ...overrides
    };
}



function $351a75c58523baeb$export$2ca3ffb384919372(href, value, fallbackText = '') {
    if (!href) {
        const span = document.createElement('span');
        span.textContent = value === null || value === undefined ? '' : String(value);
        return span;
    }
    const text = value === null || value === undefined ? fallbackText : `${value}`;
    const link = document.createElement('a');
    link.href = href;
    link.textContent = text;
    return link;
}
function $351a75c58523baeb$export$e802828074a0736e(code, description) {
    if (!code) return '';
    const container = document.createElement('span');
    const codeElement = document.createElement('span');
    codeElement.className = 'text-bold';
    codeElement.textContent = code;
    container.append(codeElement);
    if (description) {
        const descriptionElement = document.createElement('span');
        descriptionElement.className = 'd-block color-fg-muted';
        descriptionElement.textContent = description;
        container.append(descriptionElement);
    }
    return container;
}
function $351a75c58523baeb$export$dd6cce92da24784f(code, description) {
    return [
        code,
        description
    ].filter(Boolean).join(' ');
}
function $351a75c58523baeb$export$33708deee81cf1d8(start, end) {
    if (!start || !end) return '';
    if (start === end) return $351a75c58523baeb$export$f1c5692dadbf0f5b(start);
    return `${$351a75c58523baeb$export$f1c5692dadbf0f5b(start)} - ${$351a75c58523baeb$export$f1c5692dadbf0f5b(end)}`;
}
function $351a75c58523baeb$export$f1c5692dadbf0f5b(value) {
    if (!value || typeof value !== 'string') return '';
    return (0, $b78c044e3d911d2e$export$6aa1a8800137fac7).format(new Date(`${value}T00:00:00Z`));
}


class $5ec87f54512df8cb$var$ClaimBatchClaimsElement extends (0, $57fe493949b5746c$export$cd175f1e676ad8c5) {
    getGridOptions() {
        const columnDefs = [
            {
                field: 'submitter_claim_control_number',
                headerName: 'Claim',
                cellRenderer: ({ data: data, node: node, value: value })=>{
                    if (node?.footer) return 'Total';
                    return (0, $351a75c58523baeb$export$2ca3ffb384919372)(data?.claim_href, value);
                },
                width: 135,
                minWidth: 135,
                suppressSizeToFit: true
            },
            {
                field: 'person_full_name',
                headerName: 'Person',
                tooltipField: 'person_full_name',
                flex: 1,
                minWidth: 200
            },
            {
                colId: 'primary_status',
                headerName: 'Status',
                valueGetter: ({ data: data, node: node })=>node?.footer ? '' : data?.primary_status_label ?? '',
                cellRenderer: $5ec87f54512df8cb$var$claimPrimaryStatusRenderer,
                tooltipField: 'primary_status_description',
                width: 190,
                minWidth: 160
            },
            {
                field: 'primary_adjustment_code',
                headerName: 'Adjustment',
                tooltipField: 'primary_adjustment_description',
                width: 140
            },
            {
                field: 'primary_remark_code',
                headerName: 'Remark',
                tooltipField: 'primary_remark_description',
                width: 120
            },
            {
                colId: 'latest_remittance_claim_status',
                headerName: '835 payer status',
                valueGetter: ({ data: data, node: node })=>{
                    if (node?.footer) return '';
                    if (!data?.latest_remittance_claim_status_code) return 'No matching 835';
                    return data.latest_remittance_claim_status_description ?? data.latest_remittance_claim_status_code;
                },
                tooltipField: 'latest_remittance_claim_status_description',
                width: 210
            },
            {
                colId: 'latest_claim_acknowledgment_status',
                headerName: '277 acknowledgment',
                valueGetter: ({ data: data, node: node })=>{
                    if (node?.footer) return '';
                    if (!data?.latest_claim_acknowledgment_category_code) return 'No matching 277';
                    const category = data.latest_claim_acknowledgment_category_description ?? data.latest_claim_acknowledgment_category_code;
                    const status = data.latest_claim_acknowledgment_status_description ?? data.latest_claim_acknowledgment_status_code;
                    return status ? `${category}: ${status}` : category;
                },
                tooltipValueGetter: ({ data: data })=>data?.latest_claim_acknowledgment_effective_date ? `Effective ${(0, $351a75c58523baeb$export$f1c5692dadbf0f5b)(data.latest_claim_acknowledgment_effective_date)}` : '',
                width: 240
            },
            {
                field: 'authorization_number',
                headerName: 'Authorization number',
                tooltipField: 'authorization_number',
                width: 190
            },
            {
                field: 'subscriber_id',
                headerName: 'Subscriber ID',
                width: 160
            },
            {
                colId: 'subscriber_name',
                headerName: 'Subscriber',
                valueGetter: ({ data: data })=>data ? (0, $15a966c9a3403e81$export$caef59cbf5b7a7d4)({
                        first_name: data.subscriber_first_name ?? '',
                        middle_name: data.subscriber_middle_name ?? '',
                        last_name: data.subscriber_last_name,
                        suffix: '',
                        nickname: ''
                    }) : '',
                flex: 1,
                minWidth: 200
            },
            {
                colId: 'statement_period',
                headerName: 'Statement period',
                valueGetter: ({ data: data })=>(0, $351a75c58523baeb$export$33708deee81cf1d8)(data?.statement_period_start, data?.statement_period_end),
                width: 190
            },
            {
                field: 'service_line_count',
                headerName: 'Lines',
                type: 'numericColumn',
                valueFormatter: ({ value: value })=>$5ec87f54512df8cb$var$formatNumber(value),
                aggFunc: 'sum',
                width: 110
            },
            {
                field: 'total_charge_amount',
                headerName: 'Billed',
                type: 'numericColumn',
                valueFormatter: ({ value: value })=>$5ec87f54512df8cb$var$formatCurrency(value),
                aggFunc: 'sum',
                width: 130
            },
            {
                field: 'paid_amount',
                headerName: 'Paid',
                type: 'numericColumn',
                valueFormatter: ({ value: value })=>$5ec87f54512df8cb$var$formatCurrency(value),
                aggFunc: 'sum',
                width: 130
            },
            {
                field: 'adjustment_amount',
                headerName: 'Adjustments',
                type: 'numericColumn',
                valueFormatter: ({ value: value })=>$5ec87f54512df8cb$var$formatCurrency(value),
                aggFunc: 'sum',
                width: 145
            },
            {
                field: 'remittance_issue_count',
                headerName: 'Issues',
                type: 'numericColumn',
                valueFormatter: ({ value: value })=>$5ec87f54512df8cb$var$formatNumber(value),
                aggFunc: 'sum',
                width: 110
            },
            {
                field: 'activity_count',
                headerName: 'Activities',
                type: 'numericColumn',
                valueFormatter: ({ value: value })=>$5ec87f54512df8cb$var$formatNumber(value),
                aggFunc: 'sum',
                width: 125
            }
        ];
        return {
            getRowId: ({ data: data })=>data.claim_id,
            columnDefs: columnDefs,
            rowClassRules: {
                'color-bg-subtle': ({ node: node, rowIndex: rowIndex })=>!!node.footer || rowIndex % 2 !== 0,
                'text-bold': ({ node: node })=>!!node.footer
            },
            grandTotalRow: 'pinnedBottom'
        };
    }
}
$5ec87f54512df8cb$var$ClaimBatchClaimsElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('claim-batch-claims')
], $5ec87f54512df8cb$var$ClaimBatchClaimsElement);
function $5ec87f54512df8cb$var$claimPrimaryStatusRenderer({ data: data, node: node }) {
    if (node?.footer || !data) return '';
    const status = document.createElement('span');
    status.className = 'd-inline-flex flex-items-center gap-1 width-full min-width-0';
    status.insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $b52acf796209d39a$export$9981951a630ceb68)(data.primary_status), `${(0, $b52acf796209d39a$export$cc09d3510acf7ab4)[data.primary_status]} flex-shrink-0`)));
    const label = document.createElement('span');
    label.className = 'overflow-ellipses min-width-0';
    label.textContent = data.primary_status_label;
    status.append(label);
    return status;
}
function $5ec87f54512df8cb$var$formatNumber(value) {
    return (0, $5e22b13d8e41f6dd$export$688d13a530c5dcbc).format(Number(value ?? 0));
}
function $5ec87f54512df8cb$var$formatCurrency(value) {
    return (0, $5e22b13d8e41f6dd$export$4670d0ed237a9270).format(Number(value ?? 0));
}






const $40aec600837c333f$var$billingEffectLabels = {
    none: 'No billing impact',
    affects_amount: 'Amount affected',
    exclude_source: "Source won't bill",
    exclude_claim: "Claim won't bill",
    block_batch: 'Blocks batch'
};
const $40aec600837c333f$var$reviewLevelLabels = {
    info: 'Info',
    attention: 'Attention',
    action: 'Action'
};
const $40aec600837c333f$var$reviewLevelClasses = {
    info: 'Label',
    attention: 'Label Label--attention',
    action: 'Label Label--danger'
};
const $40aec600837c333f$var$autoHeightRowLimit = 40;
class $40aec600837c333f$var$ClaimBatchPreviewIssuesElement extends (0, $57fe493949b5746c$export$cd175f1e676ad8c5) {
    getGridOptions(rowData) {
        const useAutoHeight = rowData.length <= $40aec600837c333f$var$autoHeightRowLimit;
        this.gridHost.style.height = useAutoHeight ? '' : '75vh';
        const columnDefs = [
            {
                field: 'review_level',
                headerName: 'Review',
                valueFormatter: ({ value: value })=>$40aec600837c333f$var$isReviewLevel(value) ? $40aec600837c333f$var$reviewLevelLabels[value] : value,
                cellRenderer: ({ value: value })=>{
                    if (!$40aec600837c333f$var$isReviewLevel(value)) return value ?? '';
                    const label = document.createElement('span');
                    label.className = $40aec600837c333f$var$reviewLevelClasses[value];
                    label.textContent = $40aec600837c333f$var$reviewLevelLabels[value];
                    return label;
                },
                width: 125
            },
            {
                field: 'billing_effect',
                headerName: 'Billing effect',
                valueFormatter: ({ value: value })=>$40aec600837c333f$var$isBillingEffect(value) ? $40aec600837c333f$var$billingEffectLabels[value] : value,
                width: 170
            },
            {
                field: 'message',
                headerName: 'Message',
                wrapText: true,
                autoHeight: true,
                flex: 2,
                minWidth: 280,
                tooltipField: 'message'
            },
            {
                field: 'code',
                headerName: 'Code',
                width: 230
            },
            {
                field: 'activity_id',
                headerName: 'Activity',
                cellRenderer: ({ data: data, value: value })=>{
                    if (!value || !data?.activity_href) return '';
                    const link = document.createElement('a');
                    link.className = 'Link--primary';
                    link.href = data.activity_href;
                    link.textContent = `${data.activity_definition_title} - ${(0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format(new Date(data.activity_start_date))} - ${data.person_full_name}`;
                    return link;
                },
                width: 290
            }
        ];
        return {
            getRowId: ({ data: data })=>data.row_id,
            columnDefs: columnDefs,
            defaultColDef: {
                minWidth: 120
            },
            domLayout: useAutoHeight ? 'autoHeight' : 'normal'
        };
    }
}
$40aec600837c333f$var$ClaimBatchPreviewIssuesElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('claim-batch-preview-issues')
], $40aec600837c333f$var$ClaimBatchPreviewIssuesElement);
function $40aec600837c333f$var$isBillingEffect(value) {
    return value === 'none' || value === 'affects_amount' || value === 'exclude_source' || value === 'exclude_claim' || value === 'block_batch';
}
function $40aec600837c333f$var$isReviewLevel(value) {
    return value === 'info' || value === 'attention' || value === 'action';
}



class $2500074c6514556c$export$6348a873744bbf39 extends HTMLElement {
    clearCheckedRadioTimeout = 0;
    connectedCallback() {
        this.addEventListener('change', this, true);
        this.addEventListener('click', this);
        this.addEventListener('keydown', this);
        this.addEventListener('keyup', this);
        this.setTabindexes();
    }
    disconnectedCallback() {
        this.removeEventListener('change', this, true);
        this.removeEventListener('click', this);
        this.removeEventListener('keydown', this);
        this.removeEventListener('keyup', this);
    }
    handleEvent(event) {
        if (event.type === 'click' && event.target instanceof HTMLElement && event.target.closest('legend')) {
            this.querySelector('[tabindex="0"]')?.focus();
            return;
        }
        if (event.target instanceof HTMLInputElement && (event.target.type === 'checkbox' || event.target.type === 'radio')) switch(event.type){
            case 'click':
                if (event.target.type === 'radio' && event.target.checked) {
                    // Click happens before the change event.
                    // Wait for the change event to fire, if it does, we do not need to clear the radio because it just became checked.
                    const checkedRadio = event.target;
                    clearTimeout(this.clearCheckedRadioTimeout);
                    this.clearCheckedRadioTimeout = setTimeout(()=>{
                        checkedRadio.checked = false;
                        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(checkedRadio);
                    });
                }
                return;
            case 'change':
                clearTimeout(this.clearCheckedRadioTimeout);
                this.handleExclusive(event);
                this.setTabindexes();
                return;
            case 'keydown':
                switch(event.key){
                    case 'ArrowUp':
                    case 'ArrowLeft':
                        event.preventDefault();
                        this.moveFocus(event.target, -1);
                        return;
                    case 'ArrowDown':
                    case 'ArrowRight':
                        event.preventDefault();
                        this.moveFocus(event.target, 1);
                        return;
                }
                return;
            case 'keyup':
                switch(event.key){
                    case ' ':
                        if (event.target.type === 'radio' && event.target.checked) {
                            event.preventDefault();
                            event.target.checked = false;
                            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(event.target);
                        }
                        return;
                }
                return;
        }
    }
    moveFocus(from, delta) {
        const inputs = Array.from(this.querySelectorAll('input[type="checkbox"],input[type="radio"]'));
        let index = inputs.indexOf(from) + delta;
        if (index < 0) index = inputs.length - 1;
        else if (index >= inputs.length) index = 0;
        const to = inputs[index];
        to.focus();
        if (to.checked) {
            from.tabIndex = -1;
            to.tabIndex = 0;
        }
    }
    setTabindexes() {
        const inputs = this.querySelectorAll('input[type="checkbox"],input[type="radio"]');
        let x = undefined;
        for (const input of inputs){
            if (!x) {
                input.tabIndex = 0;
                x = input;
            } else if (x && !x.checked && input.checked) {
                input.tabIndex = 0;
                x.tabIndex = -1;
                x = input;
            } else input.tabIndex = -1;
        }
    }
    handleExclusive({ target: target }) {
        if (target instanceof HTMLInputElement && target.type === 'checkbox' && target.checked) {
            const isExclusive = target.hasAttribute('exclusive');
            const inputs = Array.from(this.querySelectorAll(`input[name="${target.name}"]`));
            /**
       * 1. checked an exclusive: uncheck everything else
       * 2. check non-exclusive: uncheck all exclusive
       */ for (const input of inputs){
                if (input === target) continue;
                if (isExclusive && input.checked || input.checked && input.hasAttribute('exclusive')) input.checked = false;
            }
        }
    }
}
if (!window.customElements.get('choice-group')) {
    window.ChoiceGroupElement = $2500074c6514556c$export$6348a873744bbf39;
    window.customElements.define('choice-group', $2500074c6514556c$export$6348a873744bbf39);
}






class $9ee662ab51d3ba87$export$6846e9b06047e0c8 extends (0, $ef6a8c01f13c245c$export$c06ca7125051d4c8) {
    disconnected = new AbortController();
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', async ()=>{
            if (this.value) return;
            const url = this.getAttribute('url');
            if (!url) return;
            this.classList.add('btn-busy');
            let response;
            try {
                response = await fetch(location.origin + '/go', {
                    method: 'POST',
                    body: JSON.stringify({
                        url: url
                    })
                });
            } finally{
                this.classList.remove('btn-busy');
            }
            if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
            const data = await response.json();
            this.value = data.url;
            this.click();
        }, {
            signal: this.disconnected.signal
        });
    }
    disconnectedCallback() {
        this.disconnected.abort();
    }
}
$9ee662ab51d3ba87$export$6846e9b06047e0c8 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('copy-shortened-link')
], $9ee662ab51d3ba87$export$6846e9b06047e0c8);







class $bf8e8a8bf6fe4927$var$DashboardControllerElement extends HTMLElement {
    busy = false;
    connectedCallback() {
        this.key = JSON.parse(this.keyScript.textContent);
        this.parameter_types = JSON.parse(this.getAttribute('parameter_types'));
        const date_loaded = document.getElementById('dashboard-refresh-time')?.getAttribute('datetime');
        if (date_loaded && Date.now() - new Date(date_loaded).getTime() > 360000 // 6 minutes
        ) this.refresh(true);
    }
    async submitParameters(event) {
        event.preventDefault();
        const behavior = event.target;
        await Promise.resolve();
        await this.refresh(false);
        behavior.acceptChanges();
    }
    propagateParameters(parameter_values) {
        for (const element of this.elements){
            const element_type = element.getAttribute('element-type');
            if (element_type === 'report') {
                const parameter_names_json = element.getAttribute('inherited-parameter-names');
                if (!parameter_names_json) continue;
                const grid = element.querySelector('report-grid');
                if (!grid) continue;
                const parameter_names = JSON.parse(parameter_names_json);
                for (const name of parameter_names){
                    const value = parameter_values[name];
                    if (value === undefined || value === null) continue;
                    const input = grid.parametersForm.querySelector(`input[name^="parameter_values/${name}:"]`);
                    if (!(input instanceof HTMLInputElement)) throw new Error(`Expected report-grid parameter input for inherited parameter "${name}".`);
                    input.value = Array.isArray(value) ? JSON.stringify(value) : value.toString();
                }
            } else if (element_type === 'report-links') for (const anchor of element.querySelectorAll('a[inherited-parameter-names]')){
                const parameter_names_json = anchor.getAttribute('inherited-parameter-names');
                const parameter_names = JSON.parse(parameter_names_json);
                const inherited_parameter_values = Object.fromEntries(Object.entries(parameter_values).filter(([key])=>parameter_names.includes(key)));
                anchor.search = (0, $413788c7d08dddf5$export$8731bf6742d09f4c)(new URL(anchor.href, location.href).searchParams, inherited_parameter_values).toString();
            }
        }
    }
    async refresh(cardsOnly) {
        if (this.busy) return;
        this.busy = true;
        const url = this.getAttribute('refresh-source');
        const { parameter_values: selected_parameter_values = {} } = (0, $6980cc602f309497$export$ae2b2db16f8c0171)(new FormData(this.parametersForm));
        let response;
        try {
            (0, $d926988b2eed7310$export$7f9cba67632f8265)(this.parametersForm, true);
            for (const element of this.elements)element.classList.add('shimmer');
            response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    key: this.key,
                    parameter_values: selected_parameter_values
                })
            });
        } finally{
            (0, $d926988b2eed7310$export$7f9cba67632f8265)(this.parametersForm, false);
            for (const element of this.elements)element.classList.remove('shimmer');
            this.busy = false;
        }
        if (!response.ok) {
            (0, $84fd3dc30499b2d0$export$7977be5e446db387)(this.parametersForm);
            throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
        }
        const locationUrl = new URL(location.href);
        (0, $413788c7d08dddf5$export$8731bf6742d09f4c)(locationUrl.searchParams, selected_parameter_values);
        history.replaceState(null, '', locationUrl.href);
        const { elements: elements, parameter_values: calculated_parameter_values, date_loaded: date_loaded } = await response.json();
        document.getElementById('dashboard-refresh-time')?.setAttribute('datetime', date_loaded + 'Z');
        const parameter_values = (0, $413788c7d08dddf5$export$292a5b8f6eaffa0b)(selected_parameter_values, calculated_parameter_values);
        this.propagateParameters(parameter_values);
        for(let index = 0; index < this.elements.length; index++){
            const element = this.elements[index];
            const element_type = element.getAttribute('element-type');
            const result = elements[index];
            if (!result || result.type !== element_type) // Element mismatch, reload the page. Can happen while editing the dashboard.
            location.reload();
            element.hidden = !result.visible;
            if (result.template) {
                element.insertAdjacentHTML('afterend', result.template);
                element.remove();
            } else switch(result.type){
                case 'report':
                    if (result.visible && !cardsOnly) {
                        const grid = element.querySelector('report-grid');
                        grid?.submitParameters();
                    }
            }
        }
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $bf8e8a8bf6fe4927$var$DashboardControllerElement.prototype, "keyScript", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $bf8e8a8bf6fe4927$var$DashboardControllerElement.prototype, "parametersForm", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $bf8e8a8bf6fe4927$var$DashboardControllerElement.prototype, "elements", void 0);
$bf8e8a8bf6fe4927$var$DashboardControllerElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('dashboard-controller')
], $bf8e8a8bf6fe4927$var$DashboardControllerElement);










const $78c38210ed01f2ef$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
class $78c38210ed01f2ef$var$DateInputElement extends HTMLElement {
    get relative() {
        return this.hasAttribute('relative');
    }
    get parametric() {
        return this.hasAttribute('parametric');
    }
    showPicker() {
        if (this.input.value === '') this.pickerInput.valueAsDate = null;
        else if (this.relative && (0, $b78c044e3d911d2e$export$aebd7d4ffee5ebdd)(this.input.value)) this.pickerInput.valueAsDate = new Date((0, $b78c044e3d911d2e$export$5729bdcef1c036db)(Date.now(), this.input.value) ?? Date.now());
        else if (this.parametric && (0, $413788c7d08dddf5$export$99da40ee05a17718).test(this.input.value)) this.pickerInput.valueAsDate = null;
        else this.pickerInput.valueAsDate = (0, $b78c044e3d911d2e$export$7660134aa4da2247)(this.input.value) ?? null;
        this.pickerInput.ariaLabel = `${(0, $84fd3dc30499b2d0$export$236350842f3cd9bc)(this.input)} picker`;
        this.pickerInput.hidden = false;
        requestAnimationFrame(()=>this.pickerInput.showPicker());
    }
    suggestionSelected() {
        return Array.from(this.input.list.children).map((o)=>o.value).includes(this.input.value);
    }
    handlePickerInputChange(_event) {
        let value = '';
        if (this.pickerInput.value) {
            // simplify valueAsDate / UTC handling.
            const [year, month, day] = this.pickerInput.value.split('-');
            value = `${+month}/${+day}/${year}`;
        }
        if (this.input.value !== value) {
            this.input.value = value;
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.input);
        }
    }
    handleInputChange(event) {
        if (event.isTrusted && this.input.value) {
            const date = (0, $b78c044e3d911d2e$export$7660134aa4da2247)(this.input.value);
            if (date) {
                const month = date.getMonth() + 1;
                const day = date.getDate();
                const year = date.getFullYear();
                this.input.value = `${month}/${day}/${year}`;
            } else if (this.parametric && (0, $413788c7d08dddf5$export$99da40ee05a17718).test(this.input.value.trim().toUpperCase())) this.input.value = this.input.value.trim().toUpperCase();
            else this.relative && (0, $b78c044e3d911d2e$export$aebd7d4ffee5ebdd)(this.input.value);
        }
    }
    updateSuggestions() {
        let suggestions = $78c38210ed01f2ef$var$getNumberSuggestions(this.input, this.relative);
        if (!suggestions.length) suggestions = $78c38210ed01f2ef$var$getWordSuggestions(this.input, this.relative, this.parametric);
        let option = this.input.list.firstElementChild;
        for (const suggestion of suggestions){
            option ??= document.createElement('option');
            option.value = suggestion.id.toString();
            option.textContent = suggestion.title;
            if (!option.parentElement) this.input.list.append(option);
            option = option.nextElementSibling;
        }
        while(option){
            const next = option.nextElementSibling;
            option.remove();
            option = next;
        }
    // if (
    //   event.type === 'input' &&
    //   event.isTrusted &&
    //   this.input.value &&
    //   (parseUserDate(this.input.value) ||
    //     (this.parametric &&
    //       identifierRegex.test(this.input.value.trim().toUpperCase())) ||
    //     (this.parametric && isRelativeDate(this.input.value)))
    // ) {
    //   dispatchChange(this.input);
    // }
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $78c38210ed01f2ef$var$DateInputElement.prototype, "input", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $78c38210ed01f2ef$var$DateInputElement.prototype, "pickerInput", void 0);
$78c38210ed01f2ef$var$DateInputElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('date-input')
], $78c38210ed01f2ef$var$DateInputElement);
function $78c38210ed01f2ef$var$getWordSuggestions(input, relative, parametric) {
    if (/[0-9/]/.test(input.value)) return [];
    const today = new Date();
    return [
        ...parametric ? (0, $82003cd051bc5cad$export$149e10162b59b4e2)(input).map((x)=>({
                id: x.name,
                title: x.name
            })) : [],
        {
            title: `Today${relative ? '' : ` (${(0, $b78c044e3d911d2e$export$faf60e60fca9bed1).format(today)})`}`,
            id: relative ? 'Today' : (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format(today)
        },
        {
            title: `Yesterday${relative ? '' : ` (${(0, $b78c044e3d911d2e$export$faf60e60fca9bed1).format((0, $b78c044e3d911d2e$export$dd412b56f1e4d8aa)(today, -1))})`}`,
            id: relative ? 'Yesterday' : (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format((0, $b78c044e3d911d2e$export$dd412b56f1e4d8aa)(today, -1))
        },
        {
            title: `Tomorrow${relative ? '' : ` (${(0, $b78c044e3d911d2e$export$faf60e60fca9bed1).format((0, $b78c044e3d911d2e$export$dd412b56f1e4d8aa)(today, 1))})`}`,
            id: relative ? 'Tomorrow' : (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format((0, $b78c044e3d911d2e$export$dd412b56f1e4d8aa)(today, 1))
        }
    ];
}
function $78c38210ed01f2ef$var$getNumberSuggestions(input, relative) {
    const [, rawN] = /^\s*@?\s*(\d+)\s*$/.exec(input.value) || [];
    const n = parseInt(rawN, 10);
    const today = new Date();
    const initialDate = relative ? null : (0, $b78c044e3d911d2e$export$7660134aa4da2247)(input.defaultValue);
    if (n > 0 && n <= 9999) {
        const unit = n === 1 ? 'day' : 'days';
        return [
            {
                title: `${n} ${unit} ago${relative ? '' : ` (${(0, $b78c044e3d911d2e$export$faf60e60fca9bed1).format((0, $b78c044e3d911d2e$export$dd412b56f1e4d8aa)(today, 0 - n))})`}`,
                id: relative ? n === 1 ? 'Yesterday' : `${n} ${unit} ago` : (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format((0, $b78c044e3d911d2e$export$dd412b56f1e4d8aa)(today, 0 - n))
            },
            {
                title: `${n} ${unit} from now${relative ? '' : ` (${(0, $b78c044e3d911d2e$export$faf60e60fca9bed1).format((0, $b78c044e3d911d2e$export$dd412b56f1e4d8aa)(today, n))})`}`,
                id: relative ? n === 1 ? 'Tomorrow' : `${n} ${unit} from now` : (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format((0, $b78c044e3d911d2e$export$dd412b56f1e4d8aa)(today, n))
            },
            ...initialDate ? [
                {
                    title: `${n} ${unit} from ${(0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format(initialDate)} (${(0, $b78c044e3d911d2e$export$faf60e60fca9bed1).format((0, $b78c044e3d911d2e$export$dd412b56f1e4d8aa)(initialDate, n))})`,
                    id: (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format((0, $b78c044e3d911d2e$export$dd412b56f1e4d8aa)(initialDate, n))
                }
            ] : []
        ];
    }
    return [];
}
(0, $84fd3dc30499b2d0$export$86f1725708ac86dc)((input, label)=>{
    if (input instanceof HTMLInputElement && input.type === 'text' && input.value.length && input.parentElement instanceof $78c38210ed01f2ef$var$DateInputElement) {
        const value = input.value;
        if (input.parentElement.relative && (0, $b78c044e3d911d2e$export$aebd7d4ffee5ebdd)(value)) return null;
        if (input.parentElement.parametric) {
            const result = (0, $82003cd051bc5cad$export$9c08897bbef487d2)(input, [
                value
            ]);
            return result.valid ? null : result.message;
        }
        const parsed = Date.parse(value);
        if (!isFinite(parsed)) return (0, $b11db1b62d4a8f76$export$b18ef22a06052160)[$78c38210ed01f2ef$var$locale](label);
        const local = new Date(parsed);
        const date = Date.UTC(local.getFullYear(), local.getMonth(), local.getDate());
        if (date >= (0, $b78c044e3d911d2e$export$5c333a116e949cdd) && date <= (0, $b78c044e3d911d2e$export$a75f2bff57811055)) return null;
        return (0, $b11db1b62d4a8f76$export$b18ef22a06052160)[$78c38210ed01f2ef$var$locale](label);
    }
    return null;
});









const $f54abecb3b1d2953$export$675da22fdc41408c = 'modal-dismiss';
function $f54abecb3b1d2953$var$focusable(el) {
    const result = (el instanceof HTMLButtonElement || el instanceof HTMLInputElement || el instanceof HTMLSelectElement || el instanceof HTMLTextAreaElement || el instanceof HTMLAnchorElement || el instanceof HTMLElement && el.tagName === 'SUMMARY') && el.isConnected && el.tabIndex >= 0 && !el.disabled && !el.hidden && el.offsetWidth > 0 && el.offsetHeight > 0 && el.type !== 'hidden';
    return result;
}
function $f54abecb3b1d2953$var$autofocus(container) {
    let target = Array.from(container.querySelectorAll('[autofocus]')).filter($f54abecb3b1d2953$var$focusable)[0];
    if (!target && container.firstElementChild instanceof (0, $4941bdcfe743ed78$export$2e2bcd8739ae039)) {
        container.firstElementChild.addEventListener('include-fragment-replaced', ()=>$f54abecb3b1d2953$var$autofocus(container), {
            once: true
        });
        return;
    }
    if (!target) {
        target = container;
        container.setAttribute('tabindex', '-1');
    }
    target.focus();
}
let $f54abecb3b1d2953$var$hideCount = 0;
function $f54abecb3b1d2953$var$hideBodyScrollbar() {
    $f54abecb3b1d2953$var$hideCount++;
    if ($f54abecb3b1d2953$var$hideCount > 1) return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = document.documentElement.clientWidth;
    const bodyStyle = document.body.style;
    bodyStyle.paddingRight = `${Math.abs(window.innerWidth - documentWidth)}px`;
    bodyStyle.overflow = 'hidden';
}
function $f54abecb3b1d2953$var$unhideBodyScrollbar() {
    $f54abecb3b1d2953$var$hideCount--;
    if ($f54abecb3b1d2953$var$hideCount > 0) return;
    const bodyStyle = document.body.style;
    bodyStyle.paddingRight = '';
    bodyStyle.overflow = '';
}
class $f54abecb3b1d2953$export$973593ccecb6664f extends HTMLElement {
    activeElement;
    get controller() {
        const id = this.getAttribute('controller-id');
        return id ? document.getElementById(id) : null;
    }
    connectedCallback() {
        this.setAttribute('role', 'dialog');
        this.setAttribute('aria-modal', 'true');
        this.setAriaLabelledBy();
        $f54abecb3b1d2953$var$hideBodyScrollbar();
        this.activeElement = document.activeElement;
        setTimeout($f54abecb3b1d2953$var$autofocus, 0, this);
        this.addEventListener('keydown', this);
        this.addEventListener('click', this);
        this.addEventListener((0, $ab6f099c20a34e1f$export$7acd55e6ec74c9ed), this);
        addEventListener('focus', this, true);
        this.addEventListener('include-fragment-replaced', this, true);
    }
    disconnectedCallback() {
        $f54abecb3b1d2953$var$unhideBodyScrollbar();
        if (this.activeElement instanceof HTMLElement && this.activeElement.isConnected && $f54abecb3b1d2953$var$focusable(this.activeElement)) // this.ownerDocument.documentElement.style.scrollBehavior = 'auto';
        this.activeElement.focus();
        this.removeEventListener('keydown', this);
        this.removeEventListener('click', this);
        this.removeEventListener((0, $ab6f099c20a34e1f$export$7acd55e6ec74c9ed), this);
        removeEventListener('focus', this, true);
        this.removeEventListener('include-fragment-replaced', this, true);
    }
    async handleEvent(event) {
        const { target: target } = event;
        switch(event.type){
            case 0, $ab6f099c20a34e1f$export$7acd55e6ec74c9ed:
                await new Promise((resolve)=>setTimeout(resolve));
                this.remove();
                break;
            case 'keydown':
                if (!(event instanceof KeyboardEvent)) return;
                if (this.hasAttribute('force-submit')) return;
                if (event.key === 'Escape' || event.key === 'Esc') {
                    event.stopPropagation();
                    if (this.canDismiss()) this.remove();
                }
                break;
            case 'click':
                if (!this.hasAttribute('force-submit') && (target === this || target instanceof Element && target.closest('[modal-dismiss]')) && this.canDismiss()) {
                    if (target instanceof Element && target.closest('button[type="submit"]')) await new Promise((resolve)=>setTimeout(resolve));
                    this.remove();
                }
                break;
            case 'focus':
                if (target instanceof Element && (this.compareDocumentPosition(target) & Node.DOCUMENT_POSITION_CONTAINED_BY) === 0 && target.closest('modal-content') === null) {
                    event.preventDefault();
                    Array.from(this.querySelectorAll('a,button,input,select,summary,textarea')).filter($f54abecb3b1d2953$var$focusable)[0]?.focus();
                }
                break;
            case 'include-fragment-replaced':
                this.setAriaLabelledBy();
                break;
            default:
                throw new Error(`Unexpected event type "${event.type}".`);
        }
    }
    setAriaLabelledBy() {
        const heading = this.querySelector('h1,h2,h3,h4,h5,h6');
        if (heading) {
            if (!heading.id) heading.id = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
            this.setAttribute('aria-labelledby', heading.id);
        }
    }
    canDismiss() {
        return this.dispatchEvent(new CustomEvent($f54abecb3b1d2953$export$675da22fdc41408c, {
            bubbles: true,
            cancelable: true
        }));
    }
}
if (!window.customElements.get('modal-content')) {
    window.ModalContentElement = $f54abecb3b1d2953$export$973593ccecb6664f;
    window.customElements.define('modal-content', $f54abecb3b1d2953$export$973593ccecb6664f);
}



function $c5fa10be6d037960$export$4820f16af6be735(content) {
    return new Promise((resolve)=>{
        document.body.insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<modal-content>${content}</modal-content>`));
        const modal = document.body.lastElementChild;
        const handleSubmit = (event)=>{
            dispose();
            modal.remove();
            resolve({
                submitted: true,
                formData: event.detail,
                data: (0, $6980cc602f309497$export$ae2b2db16f8c0171)(event.detail)
            });
        };
        const handleClose = ()=>{
            dispose();
            resolve({
                submitted: false
            });
        };
        const dispose = ()=>{
            modal.removeEventListener((0, $ab6f099c20a34e1f$export$7acd55e6ec74c9ed), handleSubmit);
            modal.removeEventListener((0, $f54abecb3b1d2953$export$675da22fdc41408c), handleClose);
        };
        modal.addEventListener((0, $ab6f099c20a34e1f$export$7acd55e6ec74c9ed), handleSubmit);
        modal.addEventListener((0, $f54abecb3b1d2953$export$675da22fdc41408c), handleClose);
    });
}



class $c7bf7fdac4cfd3d4$export$1ffd6d40eedae5b3 extends HTMLElement {
    async fileSelected({ target: target }) {
        if (!(target instanceof HTMLInputElement) || !target.files || target.files.length === 0) return;
        const file = target.files[0];
        const url = URL.createObjectURL(file);
        try {
            target.disabled = true;
            const result = await (0, $c5fa10be6d037960$export$4820f16af6be735)($c7bf7fdac4cfd3d4$var$avatarCropModalTemplate(url));
            if (!result.submitted) return;
            target.labels?.item(1).classList.add('btn-busy');
            const { x: x, y: y, width: width, height: height } = result.data;
            if (width !== height) throw new Error('Dimensions must be square.');
            const sourceImage = new Image();
            await new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onloadend = ()=>{
                    sourceImage.src = reader.result;
                    resolve();
                };
                reader.readAsDataURL(file);
            });
            const size = (0, $cdfaf3b5836da68d$export$65bbdb088890cb21).maxSize;
            const quality = 1;
            const type = (0, $cdfaf3b5836da68d$export$65bbdb088890cb21).type;
            const canvas = document.createElement('canvas');
            canvas.width = size;
            canvas.height = size;
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(sourceImage, x, y, width, height, 0, 0, size, size);
            const blob = await new Promise((resolve)=>canvas.toBlob(resolve, type, quality));
            if (!blob) throw new Error('canvas.toBlob resolved with null');
            const body = new FormData();
            body.set('file', blob, file.name);
            const action = this.getAttribute('action');
            if (!action) throw new Error('action attribute required.');
            const actionUrl = new URL(action, location.origin);
            let response = await fetch(actionUrl, {
                method: 'PUT',
                body: body
            });
            if (response.status >= 500 && response.status < 600) {
                response.text().then((text)=>{
                    throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, text);
                });
                await new Promise((resolve)=>setTimeout(resolve, 3000));
                actionUrl.searchParams.set('retry', '1');
                response = await fetch(actionUrl, {
                    method: 'PUT',
                    body: body
                });
            }
            if ((0, $8f2070e09d7bee6a$export$91cdf58e199a84d0)(response)) return;
            if (!response.ok) {
                alert('Upload failed. Please try again later.');
                throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
            }
            location.reload();
        } finally{
            target.disabled = false;
            target.value = '';
            URL.revokeObjectURL(url);
            target.labels?.item(1).classList.remove('btn-busy');
        }
    }
}
$c7bf7fdac4cfd3d4$export$1ffd6d40eedae5b3 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('edit-avatar')
], $c7bf7fdac4cfd3d4$export$1ffd6d40eedae5b3);
function $c7bf7fdac4cfd3d4$var$avatarCropModalTemplate(url) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<form
    class="Box d-flex flex-column anim-fade-in fast"
    style="max-height: calc(100vh - 48px - 48px)"
  >
    <form-behavior new></form-behavior>
    <div class="Box-header">
      <h3 class="Box-title">Crop your new profile picture</h3>
    </div>
    <div class="Box-body overflow-auto">
      <image-crop src="${url}" rounded style="max-width: 400px">
        <input type="hidden" data-image-crop-input="x" name="x" />
        <input type="hidden" data-image-crop-input="y" name="y" />
        <input type="hidden" data-image-crop-input="width" name="width" />
        <input type="hidden" data-image-crop-input="height" name="height" />
      </image-crop>
    </div>
    <div class="Box-footer">
      <button type="submit" class="btn btn-primary" autofocus>
        <span>Save profile picture</span>
      </button>
      <button type="button" class="btn" modal-dismiss>Cancel</button>
    </div>
  </form>`;
}








class $62491b8ea938a046$export$c0762fb6e6e5d033 extends HTMLElement {
    connectedCallback() {
        this.addEventListener('paste', this.handlePaste);
    }
    disconnectedCallback() {
        this.removeEventListener('paste', this.handlePaste);
    }
    safariBug(list) {
        // https://support.cumulus.care/a/tickets/1992
        list.style.zoom = '1';
        setTimeout(()=>list.style.zoom = '');
    }
    handlePaste = (event)=>{
        let li = event.target instanceof HTMLInputElement && event.target.closest('li');
        if (!li) return;
        if (li.closest('editable-list') !== this) return;
        const rows = (event.clipboardData?.getData('text/plain') ?? '').split(/\r?\n/).map((row)=>row.split('\t').map((cell)=>cell.trim()));
        if (rows.length < 2) return;
        event.preventDefault();
        let startInputIndex = NaN;
        let focusTarget;
        for (const row of rows){
            if (!li) li = this.addListItem();
            let col = 0;
            let inputIndex = 0;
            for (const input of li.querySelectorAll('input')){
                if (row.length > col && input.form && [
                    'text',
                    'email',
                    'number'
                ].includes(input.type) && getComputedStyle(input).display !== 'none' && (inputIndex >= startInputIndex || input === event.target)) {
                    if (input === event.target) startInputIndex = inputIndex;
                    input.value = row[col];
                    (0, $80a2320123ddcd02$export$89348ae70780cd7a)(input);
                    focusTarget = input;
                    col++;
                }
                inputIndex++;
            }
            li = li.nextElementSibling;
        }
        focusTarget?.focus();
        focusTarget && (0, $80a2320123ddcd02$export$9657601bf1e130ee)(focusTarget);
    };
    removeListItem(event) {
        const target = event.target;
        const item = target.closest('li');
        this.removeListItemInternal(item);
    }
    removeListItemEnsureNonEmpty(event) {
        const target = event.target;
        const item = target.closest('li');
        const list = item.parentElement;
        this.removeListItem(event);
        if (list.children.length === 0) this.addListItem();
    }
    removeAllListItems() {
        const list = this.querySelector('ol,ul');
        if (!list) return;
        for (const item of Array.from(list.children))this.removeListItemInternal(item);
    }
    removeListItemInternal(item) {
        item.querySelectorAll('.form-group.errored input:not([type="hidden"])').forEach((input)=>{
            if (input.form) (0, $84fd3dc30499b2d0$export$b7702f01a27b2311)(input);
        });
        const list = item.parentElement;
        const index = Array.from(list.children).indexOf(item);
        let next = item.nextElementSibling;
        (0, $80a2320123ddcd02$export$956fd4dade47957a)(item.previousElementSibling) || (0, $80a2320123ddcd02$export$956fd4dade47957a)(this);
        item.remove();
        this.synchronizeBlankslate();
        const listName = this.getAttribute('name');
        let i = index;
        while(next){
            $62491b8ea938a046$var$updatePointers(next, listName, i);
            $62491b8ea938a046$var$updateCounters(next, this.counters ?? [], i);
            next = next.nextElementSibling;
            i++;
        }
        this.dispatchEvent(new CustomEvent('editable-list-change', {
            bubbles: true,
            detail: {
                indexes: [
                    ...Array(list.children.length + 1).keys()
                ].reduce((p, c)=>{
                    p[c] = c === index ? null : c < index ? c : c - 1;
                    return p;
                }, {})
            }
        }));
        this.safariBug(list);
    }
    moveListItemUp(event) {
        const target = event.target;
        const item = target.closest('li');
        const list = item.parentElement;
        const index = Array.from(list.children).indexOf(item);
        const previous = item.previousElementSibling;
        const listName = this.getAttribute('name');
        if (previous) {
            this.rowHighlightClass && item.classList.remove(this.rowHighlightClass);
            item.remove();
            previous.before(item);
            $62491b8ea938a046$var$updatePointers(item, listName, index - 1);
            $62491b8ea938a046$var$updateCounters(item, this.counters ?? [], index - 1);
            $62491b8ea938a046$var$updatePointers(previous, listName, index);
            $62491b8ea938a046$var$updateCounters(previous, this.counters ?? [], index);
            target.focus();
            this.dispatchEvent(new CustomEvent('editable-list-change', {
                bubbles: true,
                detail: {
                    indexes: [
                        ...Array(list.children.length).keys()
                    ].reduce((p, c)=>{
                        p[c] = c === index - 1 ? index : c === index ? index - 1 : c;
                        return p;
                    }, {})
                }
            }));
            this.rowHighlightClass && item.classList.add(this.rowHighlightClass);
        }
    }
    moveListItemDown(event) {
        const target = event.target;
        const item = target.closest('li');
        const list = item.parentElement;
        const index = Array.from(list.children).indexOf(item);
        const next = item.nextElementSibling;
        const listName = this.getAttribute('name');
        if (next) {
            this.rowHighlightClass && item.classList.remove(this.rowHighlightClass);
            item.remove();
            next.after(item);
            $62491b8ea938a046$var$updatePointers(item, listName, index + 1);
            $62491b8ea938a046$var$updateCounters(item, this.counters ?? [], index + 1);
            $62491b8ea938a046$var$updatePointers(next, listName, index);
            $62491b8ea938a046$var$updateCounters(next, this.counters ?? [], index);
            target.focus();
            this.dispatchEvent(new CustomEvent('editable-list-change', {
                bubbles: true,
                detail: {
                    indexes: [
                        ...Array(list.children.length).keys()
                    ].reduce((p, c)=>{
                        p[c] = c === index + 1 ? index : c === index ? index + 1 : c;
                        return p;
                    }, {})
                }
            }));
            this.rowHighlightClass && item.classList.add(this.rowHighlightClass);
        }
    }
    moveListItemTop(event) {
        const target = event.target;
        const item = target.closest('li');
        const list = item.parentElement;
        const index = Array.from(list.children).indexOf(item);
        const first = list.firstElementChild;
        const listName = this.getAttribute('name');
        if (first && first !== item) {
            this.rowHighlightClass && item.classList.remove(this.rowHighlightClass);
            item.remove();
            first.before(item);
            for(let i = 0; i <= index; i++){
                $62491b8ea938a046$var$updatePointers(list.children.item(i), listName, i);
                $62491b8ea938a046$var$updateCounters(list.children.item(i), this.counters ?? [], i);
            }
            target.focus();
            this.dispatchEvent(new CustomEvent('editable-list-change', {
                bubbles: true,
                detail: {
                    indexes: [
                        ...Array(list.children.length).keys()
                    ].reduce((p, c)=>{
                        p[c] = c === index ? 0 : c < index ? c - 1 : c;
                        return p;
                    }, {})
                }
            }));
            this.rowHighlightClass && item.classList.add(this.rowHighlightClass);
        }
    }
    moveListItemBottom(event) {
        const target = event.target;
        const item = target.closest('li');
        const list = item.parentElement;
        const index = Array.from(list.children).indexOf(item);
        const last = list.lastElementChild;
        const listName = this.getAttribute('name');
        if (last && last !== item) {
            this.rowHighlightClass && item.classList.remove(this.rowHighlightClass);
            item.remove();
            last.after(item);
            for(let i = index; i < list.children.length; i++){
                $62491b8ea938a046$var$updatePointers(list.children.item(i), listName, i);
                $62491b8ea938a046$var$updateCounters(list.children.item(i), this.counters ?? [], i);
            }
            target.focus();
            this.dispatchEvent(new CustomEvent('editable-list-change', {
                bubbles: true,
                detail: {
                    indexes: [
                        ...Array(list.children.length).keys()
                    ].reduce((p, c)=>{
                        p[c] = c < index ? c : c === index ? list.children.length - 1 : c - 1;
                        return p;
                    }, {})
                }
            }));
            this.rowHighlightClass && item.classList.add(this.rowHighlightClass);
        }
    }
    editListItem(event) {
        const target = event.target;
        const item = target.closest('li');
        item.classList.add('Editable--editing');
        (0, $80a2320123ddcd02$export$956fd4dade47957a)(item);
    }
    duplicateListItem(event) {
        const target = event.target;
        const item = target.closest('li');
        this.rowHighlightClass && item.classList.remove(this.rowHighlightClass);
        const template = document.createElement('template');
        const clone = item.cloneNode(true);
        const itemSelects = item.querySelectorAll('select');
        const cloneSelects = clone.querySelectorAll('select');
        for(let i = 0; i < itemSelects.length; i++){
            cloneSelects[i].querySelector('[selected]')?.removeAttribute('selected');
            cloneSelects[i].querySelector(`[value="${itemSelects[i].hasAttribute('data-clone-value') ? itemSelects[i].getAttribute('data-clone-value') : itemSelects[i].value}"]`)?.toggleAttribute('selected', true);
        }
        template.content.append(clone);
        return this.insertListItemInternal(template, item);
    }
    addListItem() {
        return this.insertListItemInternal(this.itemTemplate);
    }
    addSecondaryListItem() {
        return this.insertListItemInternal(this.secondaryItemTemplate);
    }
    addTertiaryListItem() {
        return this.insertListItemInternal(this.tertiaryItemTemplate);
    }
    insertListItemInternal(itemTemplate, after) {
        const list = this.querySelector('ol,ul');
        if (!list || !itemTemplate) return null;
        const maxItems = parseInt(this.getAttribute('max-items') ?? '', 10);
        if (Number.isInteger(maxItems) && list.children.length >= maxItems) {
            const label = document.getElementById(list.getAttribute('aria-labelledby') ?? 'undefined-labelledby-id')?.innerText ?? list.getAttribute('aria-label') ?? 'items';
            alert(`The maximum number of ${label} is ${maxItems}.`);
            return;
        }
        const fragment = $62491b8ea938a046$export$75a0370f3222215a(itemTemplate);
        let index;
        if (after) {
            after.after(fragment);
            index = Array.from(list.children).indexOf(after) + 1;
        } else {
            list.append(fragment);
            index = list.children.length - 1;
        }
        this.synchronizeBlankslate();
        const inserted = list.children.item(index);
        (0, $80a2320123ddcd02$export$956fd4dade47957a)(inserted);
        let restIndex = index;
        while(restIndex < list.children.length){
            $62491b8ea938a046$export$ae91b67ff38afcc3(list.children.item(restIndex));
            restIndex++;
        }
        inserted.querySelectorAll('input[type="checkbox"][data-action*="change:editable-list#handlePrimaryChanged"]').forEach((input)=>{
            input.checked = !(0, $d926988b2eed7310$export$3ef28703d495bc16)(input).filter((input)=>input.matches('[data-action*="change:editable-list#handlePrimaryChanged"]')).some((el)=>el.checked);
        });
        this.dispatchEvent(new CustomEvent('editable-list-change', {
            bubbles: true,
            detail: {
                indexes: Array.from({
                    length: list.children.length
                }).map((_, index)=>index).reduce((p, c)=>{
                    p[c] = c < index ? c : c + 1;
                    return p;
                }, {})
            }
        }));
        this.safariBug(list);
        this.rowHighlightClass && inserted.classList.add(this.rowHighlightClass);
        (0, $80a2320123ddcd02$export$9657601bf1e130ee)(inserted);
        return inserted;
    }
    synchronizeBlankslate() {
        const list = this.querySelector('ol,ul');
        if (!list || !this.blankslateTemplate) return;
        if (list.children.length > 1 && this.blankslate) this.blankslate.remove();
        else if (list.children.length === 0) {
            const fragment = $62491b8ea938a046$export$75a0370f3222215a(this.blankslateTemplate);
            list.append(fragment);
        }
    }
    handlePrimaryChanged({ target: target }) {
        if (target.checked) (0, $d926988b2eed7310$export$3ef28703d495bc16)(target).filter((el)=>el.matches('[data-action*="change:editable-list#handlePrimaryChanged"]')).forEach((el)=>{
            el.checked = el === target;
        });
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $62491b8ea938a046$export$c0762fb6e6e5d033.prototype, "itemTemplate", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $62491b8ea938a046$export$c0762fb6e6e5d033.prototype, "secondaryItemTemplate", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $62491b8ea938a046$export$c0762fb6e6e5d033.prototype, "tertiaryItemTemplate", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $62491b8ea938a046$export$c0762fb6e6e5d033.prototype, "blankslate", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $62491b8ea938a046$export$c0762fb6e6e5d033.prototype, "blankslateTemplate", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $62491b8ea938a046$export$c0762fb6e6e5d033.prototype, "counters", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $eb3c1389b956a11c$export$7aabe8b3a840d2fd)
], $62491b8ea938a046$export$c0762fb6e6e5d033.prototype, "rowHighlightClass", void 0);
$62491b8ea938a046$export$c0762fb6e6e5d033 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('editable-list')
], $62491b8ea938a046$export$c0762fb6e6e5d033);
const $62491b8ea938a046$var$referenceAttributes = [
    'for',
    'aria-labelledby',
    'aria-describedby',
    'aria-owns',
    'data-toggle-for',
    'form',
    'list',
    'input',
    'error-alert',
    'validate-less-or-equal',
    'validate-less'
];
function $62491b8ea938a046$export$75a0370f3222215a(template) {
    const fragment = template.content.cloneNode(true);
    for (const el of Array.from(fragment.querySelectorAll('[id]'))){
        const newId = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
        for (const attr of $62491b8ea938a046$var$referenceAttributes)for (const ref of fragment.querySelectorAll(`[${attr}~="${el.id}"]`)){
            const current = ref.getAttribute(attr);
            const updated = current.split(/\s+/).map((v)=>v === el.id ? newId : v).join(' ');
            // console.log(`${attr} "${current}" "${updated}"`);
            ref.setAttribute(attr, updated);
        }
        el.id = newId;
    }
    return fragment;
}
function $62491b8ea938a046$export$ae91b67ff38afcc3(el) {
    let li = el.closest('li') ?? null;
    let editableList = li?.closest('editable-list') ?? null;
    const updates = [];
    while(editableList && li){
        const listName = editableList.getAttribute('name');
        const index = Array.prototype.indexOf.call(li.parentElement.children, li);
        updates.unshift({
            listName: listName,
            index: index
        });
        $62491b8ea938a046$var$updateCounters(li, editableList.counters ?? [], index);
        li = editableList.closest('li');
        editableList = li?.closest('editable-list') ?? null;
    }
    for (const { listName: listName, index: index } of updates)$62491b8ea938a046$var$updatePointers(el, listName, index);
}
function $62491b8ea938a046$var$updatePointer(el, listName, index) {
    const suffix = el.getAttribute('name').replace(listName, '').replace(/^\/\d+/, '');
    el.setAttribute('name', `${listName}/${index}${suffix}`);
}
function $62491b8ea938a046$var$updatePointers(el, listName, index) {
    const selector = `[name^="${listName}/"]`;
    if (el.matches(selector)) $62491b8ea938a046$var$updatePointer(el, listName, index);
    el.querySelectorAll(selector).forEach((el)=>$62491b8ea938a046$var$updatePointer(el, listName, index));
}
function $62491b8ea938a046$var$updateCounters(el, counters, index) {
    for (const counter of counters)if (el.contains(counter)) counter.textContent = String(index + 1);
}








class $14713a6cc31152e9$var$ExcelAttachmentElement extends HTMLElement {
    async attachmentAccepted(event) {
        const attachments = event.detail.attachments;
        const autoSubmit = this.getAttribute('auto-submit') !== 'false';
        this.valueInput.value = '';
        this.filenameInput.value = '';
        (0, $84fd3dc30499b2d0$export$b7702f01a27b2311)(this.valueInput);
        (0, $84fd3dc30499b2d0$export$b7702f01a27b2311)(this.filenameInput);
        try {
            this.fileInput.disabled = true;
            this.fileInput.labels?.[0].classList.add('btn-busy');
            const file = attachments[0].file;
            const transform = this.hasAttribute('transform') ? JSON.parse(this.getAttribute('transform')) : undefined;
            const result = file.type === 'text/csv' || file.name.toLowerCase().endsWith('.csv') ? await (0, $4eefab57ad9ba157$export$65304d575d5cb543)(await file.text(), file.name, this.valueInput.form, this.getAttribute('lower-case-keys') === 'true', transform) : await (0, $359745fdaf4956d1$export$bf2e8542514694ef)(await file.arrayBuffer(), file.name, this.valueInput.form, this.getAttribute('lower-case-keys') === 'true', transform);
            if (result.error || result.data === null || !Array.isArray(result.data)) {
                this.fileInput.value = '';
                return;
            }
            this.valueInput.value = JSON.stringify(result.data);
            this.filenameInput.value = file.name;
            if (autoSubmit) await this.querySelector('form-behavior')?.submit();
        } finally{
            this.fileInput.disabled = false;
            this.fileInput.labels?.[0].classList.remove('btn-busy');
            this.fileInput.focus();
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.valueInput);
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.filenameInput);
        }
    }
    valueInputFocused() {
        this.fileInput.focus();
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $14713a6cc31152e9$var$ExcelAttachmentElement.prototype, "fileInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $14713a6cc31152e9$var$ExcelAttachmentElement.prototype, "valueInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $14713a6cc31152e9$var$ExcelAttachmentElement.prototype, "filenameInput", void 0);
$14713a6cc31152e9$var$ExcelAttachmentElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('excel-attachment')
], $14713a6cc31152e9$var$ExcelAttachmentElement);


const $53c5e6461ac6ee8d$export$4a61b9856b3d6ba6 = 'expression-scope-request';
function $53c5e6461ac6ee8d$export$c7f7ebb90c2d4375(expr) {
    if (expr.type === 'UnaryExpression' && expr.operator === '!') return expr.argument;
    const negated = {
        type: 'UnaryExpression',
        operator: '!',
        argument: expr,
        prefix: true
    };
    return negated;
}





const $429c97a54779edde$var$allExpressionUsages = [
    'property-calculation',
    'activity-element-visibility',
    'activity-element-required',
    'activity-element-readonly',
    'activity-readonly',
    'activity-validation-rule',
    'pdf-template-visibility',
    'pdf-template-field-mapping',
    'pdf-template-signer-mapping',
    'dashboard-element-visibility',
    'dashboard-metric-value',
    'dashboard-metric-rule'
];
const $429c97a54779edde$var$activityExpressionUsages = [
    'property-calculation',
    'activity-element-visibility',
    'activity-element-required',
    'activity-element-readonly',
    'activity-readonly',
    'activity-validation-rule',
    'pdf-template-field-mapping',
    'pdf-template-signer-mapping',
    'pdf-template-visibility'
];
const $429c97a54779edde$var$functions = {
    SELECTED: {
        returnType: ()=>'boolean',
        minArguments: 2,
        maxArguments: 33,
        restArgument: true,
        arguments: [
            {
                type: 'property-reference',
                validate: (property)=>[
                        'single',
                        'multiple'
                    ].includes(property.choice_type) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Property ${property.property_id} is not a single or multiple choice property.`
                    }
            },
            {
                type: 'choice-reference'
            }
        ],
        usage: $429c97a54779edde$var$activityExpressionUsages
    },
    SELECTED_CHOICE_ID: {
        returnType: ()=>'int',
        minArguments: 1,
        maxArguments: 1,
        restArgument: true,
        arguments: [
            {
                type: 'property-reference',
                validate: (property)=>[
                        'single'
                    ].includes(property.choice_type) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Property ${property.property_id} is not a single choice property.`
                    }
            }
        ],
        usage: $429c97a54779edde$var$activityExpressionUsages
    },
    COUNTIF: {
        returnType: ()=>'int',
        minArguments: 1,
        maxArguments: 15,
        restArgument: true,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'boolean' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected boolean.`
                    }
            }
        ]
    },
    ANY: {
        returnType: ()=>'boolean',
        minArguments: 2,
        maxArguments: 15,
        restArgument: true,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'boolean' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected boolean.`
                    }
            },
            {
                type: 'value',
                validate: (type)=>type === 'boolean' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected boolean.`
                    }
            }
        ]
    },
    VALUE: {
        returnType: ({ context: { properties: properties }, args: args })=>{
            const node = args[0];
            let property = undefined;
            if (node.type === 'Literal') property = properties[node.value];
            else property = (0, $6941fa4b8204d0aa$export$7442465335b8f729)[node.name.toUpperCase()];
            if (!property) throw new Error(`Unable to locate property for "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(node)}".`);
            switch(property?.type){
                case 'signature':
                case 'medications':
                case 'attachment':
                case 'int':
                    if (property.choice_type === 'none') return 'int';
                    return 'string';
                case 'currency':
                case 'decimal':
                    return 'decimal';
                case 'bit':
                    return 'boolean';
                case 'varchar100':
                case 'varcharmax':
                case 'activity':
                    return 'string';
                case 'date':
                    return 'date';
                default:
                    throw new Error(`Unexepected property type "${property?.type}" used in "VALUE(${node.value})" expression.`);
            }
        },
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'property-reference',
                validate: (property)=>[
                        'varchar100',
                        'varcharmax',
                        'int',
                        'bit',
                        'currency',
                        'decimal',
                        'date',
                        'activity'
                    ].includes(property.type) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Property ${property.property_id} is not a text, boolean, date, int, decimal, or currency property.`
                    }
            }
        ],
        usage: [
            ...$429c97a54779edde$var$activityExpressionUsages,
            'dashboard-element-visibility'
        ]
    },
    ANSWERED: {
        returnType: ()=>'boolean',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'property-reference',
                validate: ()=>({
                        valid: true
                    })
            }
        ],
        usage: $429c97a54779edde$var$activityExpressionUsages
    },
    SCORE: {
        returnType: ()=>'int',
        minArguments: 1,
        maxArguments: 32,
        restArgument: true,
        arguments: [
            {
                type: 'property-reference',
                validate: (property)=>[
                        'single',
                        'multiple'
                    ].includes(property.choice_type) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Property ${property.property_id} is not a single or multiple choice property.`
                    }
            },
            {
                type: 'choice-reference'
            }
        ],
        usage: $429c97a54779edde$var$activityExpressionUsages
    },
    ABS: {
        returnType: ({ valueTypes: [type] })=>type,
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'decimal' || type === 'int' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            }
        ]
    },
    SIGN: {
        returnType: ()=>'int',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'decimal' || type === 'int' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            }
        ]
    },
    ROUND: {
        returnType: ({ args: [, len] })=>!len || len.type == 'Literal' && len.value === 0 ? 'int' : 'decimal',
        minArguments: 1,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'decimal' || type === 'int' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            },
            {
                type: 'literal',
                validate: (value)=>typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= 3 ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected integer between 0 and 3`
                    }
            }
        ]
    },
    FLOOR: {
        returnType: ()=>'int',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'decimal' || type === 'int' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            }
        ]
    },
    CEILING: {
        returnType: ()=>'int',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'decimal' || type === 'int' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            }
        ]
    },
    MIN: {
        returnType: ({ valueTypes: valueTypes })=>valueTypes.includes('decimal') ? 'decimal' : 'int',
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'decimal' || type === 'int' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            },
            {
                type: 'value',
                validate: (type)=>type === 'decimal' || type === 'int' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            }
        ]
    },
    MAX: {
        returnType: ({ valueTypes: valueTypes })=>valueTypes.includes('decimal') ? 'decimal' : 'int',
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'decimal' || type === 'int' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            },
            {
                type: 'value',
                validate: (type)=>type === 'decimal' || type === 'int' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            }
        ]
    },
    NOW: {
        returnType: ()=>'datetime',
        minArguments: 0,
        maxArguments: 0,
        restArgument: false,
        arguments: [],
        usage: $429c97a54779edde$var$allExpressionUsages.filter((x)=>x !== 'property-calculation')
    },
    AGE: {
        returnType: ()=>'int',
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'date' || type === 'datetime' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            },
            {
                type: 'value',
                validate: (type)=>type === 'date' || type === 'datetime' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    DATEADD: {
        returnType: ({ valueTypes: valueTypes })=>valueTypes.at(-1),
        minArguments: 3,
        maxArguments: 3,
        restArgument: false,
        arguments: [
            {
                type: 'contextual-identifier',
                validate: (name)=>[
                        'DAY',
                        'MONTH',
                        'QUARTER',
                        'YEAR',
                        'WEEK'
                    ].includes(name.toUpperCase()) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected "DAY", "WEEK", "MONTH", "QUARTER", or "YEAR"`
                    }
            },
            {
                type: 'value',
                validate: (type)=>type === 'int' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected integer`
                    }
            },
            {
                type: 'value',
                validate: (type)=>type === 'date' || type === 'datetime' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    DATEDIFF: {
        returnType: ()=>'int',
        minArguments: 3,
        maxArguments: 3,
        restArgument: false,
        arguments: [
            {
                type: 'contextual-identifier',
                validate: (name)=>[
                        'DAY',
                        'MONTH',
                        'QUARTER',
                        'YEAR',
                        'WEEK'
                    ].includes(name.toUpperCase()) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected "DAY", "WEEK", "MONTH", "QUARTER", or "YEAR"`
                    }
            },
            {
                type: 'value',
                validate: (type)=>type === 'date' || type === 'datetime' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            },
            {
                type: 'value',
                validate: (type)=>type === 'date' || type === 'datetime' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    DATEPART: {
        returnType: ()=>'int',
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: 'contextual-identifier',
                validate: (name)=>[
                        'DAY',
                        'MONTH',
                        'QUARTER',
                        'YEAR',
                        'WEEK',
                        'WEEKDAY'
                    ].includes(name.toUpperCase()) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected "DAY", "WEEK", "WEEKDAY", "MONTH", "QUARTER", or "YEAR"`
                    }
            },
            {
                type: 'value',
                validate: (type)=>type === 'date' || type === 'datetime' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    DATETRUNC: {
        returnType: ()=>'date',
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: 'contextual-identifier',
                validate: (name)=>[
                        'DAY',
                        'MONTH',
                        'QUARTER',
                        'YEAR',
                        'WEEK'
                    ].includes(name.toUpperCase()) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected "DAY", "WEEK", "MONTH", "QUARTER", or "YEAR"`
                    }
            },
            {
                type: 'value',
                validate: (type)=>type === 'date' || type === 'datetime' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    EOMONTH: {
        returnType: ()=>'datetime',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'date' || type === 'datetime' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    DATE: {
        returnType: ()=>'date',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'literal',
                validate: (value)=>typeof value === 'string' && isFinite(Date.parse(value)) && /^\d{4}-\d{2}-\d{2}$/.test(value) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string in the format of "YYYY-MM-DD"`
                    }
            }
        ]
    },
    IF: {
        returnType: ({ valueTypes: [, type1, type2 = type1] })=>type1 === type2 ? type1 : (0, $6d4649a4b0d9f10a$export$3b8a04534ed45870)[type1][0],
        minArguments: 2,
        maxArguments: 3,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'boolean' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected boolean`
                    }
            },
            {
                type: 'value',
                validate: ()=>({
                        valid: true
                    })
            },
            {
                type: 'value',
                validate: (type2, [, type1])=>(0, $6d4649a4b0d9f10a$export$3b8a04534ed45870)[type1].includes(type2) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected arguments of the same type.`
                    }
            }
        ]
    },
    LOWER: {
        returnType: ()=>'string',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'string' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string`
                    }
            }
        ]
    },
    UPPER: {
        returnType: ()=>'string',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'string' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string`
                    }
            }
        ]
    },
    RURAL: {
        returnType: ()=>'boolean',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'date' || type === 'datetime' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ],
        usage: $429c97a54779edde$var$activityExpressionUsages
    },
    AREA_OF_PERSISTENT_UNEMPLOYMENT: {
        returnType: ()=>'boolean',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'date' || type === 'datetime' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ],
        usage: $429c97a54779edde$var$activityExpressionUsages
    },
    HAS_VISIBLE_PREDECESSORS: {
        returnType: ()=>'boolean',
        minArguments: 0,
        maxArguments: 0,
        restArgument: false,
        arguments: [],
        usage: [
            'activity-element-visibility'
        ]
    },
    DEBUG: {
        returnType: ({ valueTypes: valueTypes })=>valueTypes.at(-1),
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: 'literal',
                validate: (value)=>typeof value === 'string' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected debug label to be string literal.`
                    }
            },
            {
                type: 'value',
                validate: ()=>({
                        valid: true
                    })
            }
        ]
    },
    CAN_VIEW_ACTIVITY_TYPE: {
        returnType: ()=>'boolean',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'literal',
                validate: (value)=>typeof value === 'string' && (0, $fc2f5b0b15619892$export$16b104bd64f9fad8).includes(value) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected activity type to be one of '${(0, $fc2f5b0b15619892$export$16b104bd64f9fad8).join(', ')}'.`
                    }
            }
        ],
        usage: [
            'dashboard-element-visibility'
        ]
    },
    MID: {
        returnType: ()=>'string',
        minArguments: 2,
        maxArguments: 3,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'string' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string`
                    }
            },
            {
                type: 'literal',
                validate: (value)=>typeof value === 'number' && Number.isInteger(value) && value > 1 ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected integer greater than or equal to 1`
                    }
            },
            {
                type: 'literal',
                validate: (value)=>typeof value === 'number' && Number.isInteger(value) && value >= 0 ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected integer greater than or equal to 0`
                    }
            }
        ]
    },
    LEFT: {
        returnType: ()=>'string',
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'string' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string`
                    }
            },
            {
                type: 'literal',
                validate: (value)=>typeof value === 'number' && Number.isInteger(value) && value >= 0 ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected integer greater than or equal to 0`
                    }
            }
        ]
    },
    RIGHT: {
        returnType: ()=>'string',
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'string' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string`
                    }
            },
            {
                type: 'literal',
                validate: (value)=>typeof value === 'number' && Number.isInteger(value) && value >= 0 ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected integer greater than or equal to 0`
                    }
            }
        ]
    },
    MATCH: {
        returnType: ()=>'boolean',
        minArguments: 2,
        maxArguments: 40,
        restArgument: true,
        arguments: [
            {
                type: 'value',
                validate: (type)=>type === 'string' || type === 'int' || type === 'decimal' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string, int or decimal`
                    }
            },
            {
                type: 'value',
                validate: (type, valueTypes)=>type === valueTypes[0] ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected ${valueTypes[0]}`
                    }
            }
        ]
    },
    /* logical1, value1, logical2, value2, logical3, value3 */ SWITCH: {
        returnType: ({ valueTypes: valueTypes })=>valueTypes[2],
        minArguments: 4,
        maxArguments: 100,
        restArgument: true,
        arguments: [
            {
                type: 'value',
                validate: (type, valueTypes, index, length)=>{
                    if (index === 0 || index === 2) return {
                        valid: true
                    };
                    else if (index % 2 === 0 || length % 2 === 0 && index === length - 1) {
                        if ((0, $6d4649a4b0d9f10a$export$3b8a04534ed45870)[type].includes(valueTypes[2])) return {
                            valid: true
                        };
                        else return {
                            valid: false,
                            reason: `Expected ${valueTypes[2]} but got ${type}`
                        };
                    } else {
                        if ((0, $6d4649a4b0d9f10a$export$3b8a04534ed45870)[type].includes(valueTypes[0])) return {
                            valid: true
                        };
                        else return {
                            valid: false,
                            reason: `Expected ${valueTypes[0]} but got ${type}`
                        };
                    }
                }
            }
        ]
    },
    IFS: {
        returnType: ({ valueTypes: valueTypes })=>valueTypes[1],
        minArguments: 2,
        maxArguments: 30,
        restArgument: true,
        arguments: [
            {
                type: 'value',
                validate: (type, valueTypes, index, length)=>{
                    if (index === 1) return {
                        valid: true
                    };
                    if (index === length - 1 && length % 2 !== 0) {
                        if ((0, $6d4649a4b0d9f10a$export$3b8a04534ed45870)[type].includes(valueTypes[1])) return {
                            valid: true
                        };
                        return {
                            valid: false,
                            reason: `Expected ${valueTypes[1]} but got ${type}`
                        };
                    }
                    if (index % 2 === 0) {
                        if (type === 'boolean') return {
                            valid: true
                        };
                        else return {
                            valid: false,
                            reason: `Expected boolean but got ${type}`
                        };
                    }
                    if ((0, $6d4649a4b0d9f10a$export$3b8a04534ed45870)[type].includes(valueTypes[1])) return {
                        valid: true
                    };
                    else return {
                        valid: false,
                        reason: `Expected ${valueTypes[1]} but got ${type}`
                    };
                }
            }
        ]
    },
    REFERENCED: {
        returnType: ({ valueTypes: valueTypes })=>valueTypes[0],
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: 'property-reference',
                validate: (property)=>property.type === 'activity' ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Property ${property.property_id} is not an activity property.`
                    }
            },
            {
                type: 'value',
                validate: ()=>({
                        valid: true
                    })
            }
        ],
        usage: $429c97a54779edde$var$activityExpressionUsages
    },
    ANCESTOR: {
        returnType: ({ valueTypes: valueTypes })=>valueTypes[0],
        minArguments: 1,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: ()=>({
                        valid: true
                    })
            },
            {
                type: 'literal',
                validate: (value)=>{
                    if (typeof value === 'number' && Number.isInteger(value) && value > 0 && value <= 3) return {
                        valid: true
                    };
                    return {
                        valid: false,
                        reason: `Expected ancestor number to be an integer between 1 and 3.`
                    };
                }
            }
        ],
        usage: $429c97a54779edde$var$activityExpressionUsages
    },
    TEXT: {
        returnType: ()=>'string',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>{
                    if ([
                        'boolean',
                        'int',
                        'decimal'
                    ].includes(type)) return {
                        valid: true
                    };
                    return {
                        valid: false,
                        reason: `Expected boolean, integer, or decimal but got ${type}`
                    };
                }
            }
        ]
    },
    FORMAT_DATE: {
        returnType: ()=>'string',
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>{
                    if ([
                        'date',
                        'datetime'
                    ].includes(type)) return {
                        valid: true
                    };
                    return {
                        valid: false,
                        reason: `Expected date or datetime but got ${type}`
                    };
                }
            },
            {
                type: 'literal',
                validate: (value)=>{
                    const formats = [
                        'yyyy-MM-dd',
                        'M/d/yyyy'
                    ];
                    if (typeof value === 'string' && formats.includes(value)) return {
                        valid: true
                    };
                    return {
                        valid: false,
                        reason: `Expected "${formats.join('", "')}" but got ${value}`
                    };
                }
            }
        ]
    },
    URL_ENCODE: {
        returnType: ()=>'string',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>{
                    if (type === 'string') return {
                        valid: true
                    };
                    return {
                        valid: false,
                        reason: `Expected string but got ${type}`
                    };
                }
            }
        ]
    },
    URL_PARAMS: {
        returnType: ()=>'string',
        minArguments: 2,
        maxArguments: 50,
        restArgument: true,
        arguments: [
            {
                type: 'value',
                validate: (type)=>{
                    if (type === 'string') return {
                        valid: true
                    };
                    return {
                        valid: false,
                        reason: `Expected string but got ${type}`
                    };
                }
            }
        ]
    },
    UUID_TO_BASE58: {
        returnType: ()=>'string',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>{
                    if (type === 'string') return {
                        valid: true
                    };
                    return {
                        valid: false,
                        reason: `Expected string but got ${type}`
                    };
                }
            }
        ]
    },
    COALESCE: {
        returnType: ({ valueTypes: [type1, type2] })=>type1 === type2 ? type1 : (0, $6d4649a4b0d9f10a$export$3b8a04534ed45870)[type1][0],
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: ()=>({
                        valid: true
                    })
            },
            {
                type: 'value',
                validate: (type2, [type1])=>(0, $6d4649a4b0d9f10a$export$3b8a04534ed45870)[type1].includes(type2) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected arguments of the same type.`
                    }
            }
        ]
    },
    SIGNATURE: {
        returnType: ()=>'string',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (_type, _valueTypes, _index, _length, node)=>{
                    if (node.type === 'Identifier') return {
                        valid: true
                    };
                    return {
                        valid: false,
                        reason: `Expected signer identifier`
                    };
                }
            }
        ],
        usage: [
            'pdf-template-field-mapping'
        ]
    },
    SIGNATURE_DATE: {
        returnType: ()=>'string',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (_type, _valueTypes, _index, _length, node)=>{
                    if (node.type === 'Identifier') return {
                        valid: true
                    };
                    return {
                        valid: false,
                        reason: `Expected signer identifier`
                    };
                }
            }
        ],
        usage: [
            'pdf-template-field-mapping'
        ]
    },
    SELECTED_TEMPLATES: {
        returnType: ()=>'string',
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: 'value',
                validate: (type)=>{
                    if (type === 'string') return {
                        valid: true
                    };
                    return {
                        valid: false,
                        reason: `Expected string but got ${type}`
                    };
                }
            }
        ],
        usage: [
            'pdf-template-field-mapping'
        ]
    }
};
function $429c97a54779edde$export$d3b7d152e56a4849(properties, wrapper = (label)=>`{{{${label}}}}`) {
    return (calleeName, ...args)=>{
        const fn = $429c97a54779edde$var$functions[calleeName.toUpperCase()];
        if (!fn) return (0, $6d4649a4b0d9f10a$export$6d3f45a3236b671b)(calleeName, ...args);
        const printedArgs = [];
        let property = undefined;
        for(let i = 0; i < args.length; i++){
            const argInfo = i < fn.arguments.length ? fn.arguments[i] : fn.restArgument ? fn.arguments[fn.arguments.length - 1] : null;
            if (!argInfo || argInfo.type !== 'property-reference' && argInfo.type !== 'choice-reference') {
                printedArgs.push(args[i]);
                continue;
            }
            const value = +args[i];
            if (!Number.isInteger(value)) {
                printedArgs.push(args[i]);
                continue;
            }
            if (argInfo.type === 'property-reference') {
                property = properties[value];
                if (!property) {
                    printedArgs.push(args[i]);
                    continue;
                }
                printedArgs.push(`${args[i]} ${wrapper(property.label)}`);
            } else if (argInfo.type === 'choice-reference' && property) {
                const choice = property.choices?.find((c)=>c.choice_id === value);
                if (!choice) {
                    printedArgs.push(args[i]);
                    continue;
                }
                printedArgs.push(`${args[i]} ${wrapper(choice.label)}`);
            } else printedArgs.push(args[i]);
        }
        return (0, $6d4649a4b0d9f10a$export$6d3f45a3236b671b)(calleeName, ...printedArgs);
    };
}
function $429c97a54779edde$var$validateActivityExpression({ node: node, context: context, ancestors: ancestors }) {
    switch(node.type){
        case 'BinaryExpression':
            {
                const { left: left, right: right, operator: operator } = node;
                const types = {
                    '+': [
                        'int',
                        'decimal',
                        'string'
                    ],
                    '-': [
                        'int',
                        'decimal'
                    ],
                    '*': [
                        'int',
                        'decimal'
                    ],
                    '/': [
                        'int',
                        'decimal'
                    ],
                    '%': [
                        'int',
                        'decimal'
                    ],
                    '&&': [
                        'boolean'
                    ],
                    '||': [
                        'boolean'
                    ],
                    '>': [
                        'int',
                        'decimal',
                        'date',
                        'datetime'
                    ],
                    '>=': [
                        'int',
                        'decimal',
                        'date',
                        'datetime'
                    ],
                    '<': [
                        'int',
                        'decimal',
                        'date',
                        'datetime'
                    ],
                    '<=': [
                        'int',
                        'decimal',
                        'date',
                        'datetime'
                    ],
                    '==': [
                        'int',
                        'decimal',
                        'date',
                        'datetime',
                        'string',
                        'boolean'
                    ],
                    '!=': [
                        'int',
                        'decimal',
                        'date',
                        'datetime',
                        'string',
                        'boolean'
                    ]
                }[operator];
                if (!types) return {
                    valid: false,
                    reason: `Invalid operator "${operator}" in expression "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(node)}".`
                };
                const leftResult = $429c97a54779edde$var$validateActivityExpression({
                    node: left,
                    context: context,
                    ancestors: [
                        node,
                        ...ancestors
                    ]
                });
                if (leftResult.valid === false) return leftResult;
                if (!context.scanReferences && !types.includes(leftResult.type)) return {
                    valid: false,
                    reason: `The expression "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(left, [])}" (${leftResult.type}) cannot be used with the "${operator}" operator because it does not evaluate to one of the following types: ${types.join(', ')}.`
                };
                const rightResult = $429c97a54779edde$var$validateActivityExpression({
                    node: right,
                    context: context,
                    ancestors: [
                        node,
                        ...ancestors
                    ]
                });
                if (rightResult.valid === false) return rightResult;
                if (!context.scanReferences) {
                    if (!types.includes(rightResult.type)) return {
                        valid: false,
                        reason: `The expression "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(right, [])}" (${rightResult.type}) cannot be used with the "${operator}" operator because it does not evaluate to one of the following types: ${types.join(', ')}.`
                    };
                    if (!(0, $6d4649a4b0d9f10a$export$3b8a04534ed45870)[leftResult.type].includes(rightResult.type)) return {
                        valid: false,
                        reason: `The expression "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(right, [])}" (${rightResult.type}) does not match the type of the expression on the left side of the "${operator}" operator (${(0, $6d4649a4b0d9f10a$export$3b8a04534ed45870)[leftResult.type].join(', ')}).`
                    };
                }
                if ([
                    '&&',
                    '||',
                    '>',
                    '>=',
                    '<',
                    '<=',
                    '==',
                    '!='
                ].includes(operator)) return {
                    valid: true,
                    type: 'boolean'
                };
                else if (operator === '/' || leftResult.type === 'decimal' || rightResult.type === 'decimal') return {
                    valid: true,
                    type: 'decimal'
                };
                else return {
                    valid: true,
                    type: leftResult.type
                };
            }
        case 'CallExpression':
            {
                // Ensure callee is literal.
                const callee = node.callee;
                if (callee.type !== 'Identifier') return {
                    valid: false,
                    reason: `Invalid expression.`
                };
                // Coerce callee name to uppercase.
                callee.name = callee.name.toUpperCase();
                // Ensure callee is supported function.
                const fn = $429c97a54779edde$var$functions[callee.name];
                if (!fn) return {
                    valid: false,
                    reason: `Invalid expression "${callee.name}".`
                };
                if ([
                    'ANCESTOR',
                    'REFERENCED'
                ].includes(callee.name) && ancestors.some((ancestor)=>{
                    if (ancestor.type !== 'CallExpression') return false;
                    const ancestorCallee = ancestor.callee;
                    return ancestorCallee.type === 'Identifier' && ancestorCallee.name.toUpperCase() === 'REFERENCED';
                })) return {
                    valid: false,
                    reason: `The function "${callee.name}" cannot be used inside the second argument of "REFERENCED".`
                };
                // Ensure function is allowed in this usage context.
                if (fn.usage && context.usage && !fn.usage.includes(context.usage)) return {
                    valid: false,
                    reason: `The function "${callee.name}" cannot be used in this context.`
                };
                // Ensure signature callees are not nested in other expressions.
                if ([
                    'SIGNATURE',
                    'SIGNATURE_DATE'
                ].includes(callee.name) && ancestors.length > 0) return {
                    valid: false,
                    reason: `Function "${callee.name}" cannot be nested inside another expression.`
                };
                // Ensure minimum number of arguments.
                if (fn.minArguments > node.arguments.length) return {
                    valid: false,
                    reason: `Too few arguments for "${callee.name}" function. Expected ${fn.minArguments === fn.arguments.length ? fn.minArguments : fn.minArguments > fn.arguments.length ? `at least ${fn.minArguments}` : `${fn.minArguments} - ${fn.arguments.length}`}.`
                };
                // Ensure maximum number of arguments.
                if (fn.maxArguments < node.arguments.length) return {
                    valid: false,
                    reason: `Too many arguments for "${callee.name}" function. Expected at most ${fn.maxArguments} arguments.`
                };
                // Validate each argument.
                let property = undefined;
                const valueTypes = [];
                for(let i = 0; i < node.arguments.length; i++){
                    const argInfo = i < fn.arguments.length ? fn.arguments[i] : fn.restArgument ? fn.arguments[fn.arguments.length - 1] : null;
                    if (!argInfo) throw new Error(`Invalid function definition. Unable to find argument definition for argument ${i} of ${callee.name}. Check maxArguments and restArgument properties.`);
                    const argNode = node.arguments[i];
                    switch(argInfo.type){
                        case 'property-reference':
                            if (argNode.type === 'Identifier' && Object.hasOwn((0, $6941fa4b8204d0aa$export$7442465335b8f729), argNode.name.toUpperCase())) property = (0, $6941fa4b8204d0aa$export$7442465335b8f729)[argNode.name.toUpperCase()];
                            else if (argNode.type === 'Literal' && typeof argNode.value === 'number' && Number.isInteger(argNode.value)) {
                                property = context.properties[argNode.value];
                                if (!context.references.includes(argNode.value)) context.references.push(argNode.value);
                            } else return {
                                valid: false,
                                reason: `Invalid argument "${argNode.raw ?? argNode.name}" in "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(node)}". Expected an integer property id or one of the following: ${Object.getOwnPropertyNames((0, $6941fa4b8204d0aa$export$7442465335b8f729)).join(', ')}.`
                            };
                            if (!context.scanReferences) {
                                if (!property) return {
                                    valid: false,
                                    reason: `Invalid argument "${argNode.raw}" in "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(node)}". Property ${argNode.value} does not appear on this record.`
                                };
                                const result = argInfo.validate(property);
                                if (!result.valid) return result;
                            }
                            continue;
                        case 'choice-reference':
                            if (argNode.type !== 'Literal' || typeof argNode.value !== 'number' || !Number.isInteger(argNode.value)) return {
                                valid: false,
                                reason: `Invalid argument "${argNode.raw}" in "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(node)}". Expected integer choice id.`
                            };
                            if (!context.scanReferences) {
                                if (!property) throw new Error(`Invalid function definition. Argument ${i} of ${callee.name} is a choice reference but there's no preceding property reference.`);
                                if (!property.choices?.some((c)=>c.choice_id === argNode.value)) return {
                                    valid: false,
                                    reason: `Invalid choice id "${argNode.raw}" in "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(node)}". Valid choice IDs: ${property.choices?.map((x)=>x.choice_id).join(', ')}.`
                                };
                            }
                            continue;
                        case 'literal':
                            {
                                if (argNode.type === 'UnaryExpression' && argNode.operator === '-' && argNode.argument.type === 'Literal' && typeof argNode.argument.value === 'number' && Number.isFinite(argNode.argument.value)) {
                                    const result = argInfo.validate(argNode.argument.value * -1);
                                    if (!result.valid) return result;
                                    continue;
                                }
                                if (argNode.type !== 'Literal') return {
                                    valid: false,
                                    reason: `Invalid argument "${argNode.raw}" in "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(node)}". Expected a literal value.`
                                };
                                const result = argInfo.validate(argNode.value);
                                if (!result.valid) return result;
                                continue;
                            }
                        case 'value':
                            {
                                const result = $429c97a54779edde$var$validateActivityExpression({
                                    node: argNode,
                                    context: context,
                                    ancestors: [
                                        node,
                                        ...ancestors
                                    ]
                                });
                                if (result.valid === false) return result;
                                const result2 = argInfo.validate(result.type, valueTypes, i, node.arguments.length, argNode);
                                if (!result2.valid && !context.scanReferences) return result2;
                                valueTypes.push(result.type);
                                continue;
                            }
                        case 'contextual-identifier':
                            {
                                if (argNode.type !== 'Identifier') return {
                                    valid: false,
                                    reason: `Invalid argument "${argNode.raw}" in "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(node)}". Expected an identifier.`
                                };
                                const result = argInfo.validate(argNode.name);
                                if (!result.valid) return result;
                                continue;
                            }
                        default:
                            throw new Error(`Unexpected argument type "${argInfo.type}".`);
                    }
                }
                return {
                    valid: true,
                    type: context.scanReferences ? 'int' : fn.returnType({
                        context: context,
                        args: node.arguments,
                        valueTypes: valueTypes
                    })
                };
            }
        case 'UnaryExpression':
            {
                const { operator: operator, argument: argument } = node;
                if (operator !== '-' && operator !== '!') return {
                    valid: false,
                    reason: `Invalid expression "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(node)}".`
                };
                const result = $429c97a54779edde$var$validateActivityExpression({
                    node: argument,
                    context: context,
                    ancestors: [
                        node,
                        ...ancestors
                    ]
                });
                if (result.valid === false) return result;
                if (operator === '-') {
                    if (context.scanReferences) return {
                        valid: true,
                        type: 'int'
                    };
                    if (result.type !== 'decimal' && result.type !== 'int') return {
                        valid: false,
                        reason: `Cannot negate "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(node)}" expression.`
                    };
                    return {
                        valid: true,
                        type: result.type
                    };
                } else {
                    if (context.scanReferences) return {
                        valid: true,
                        type: 'boolean'
                    };
                    if (result.type !== 'boolean') return {
                        valid: false,
                        reason: `Cannot negate "${(0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(node)}" expression.`
                    };
                    return {
                        valid: true,
                        type: 'boolean'
                    };
                }
            }
        case 'Literal':
            {
                const { value: value, raw: raw } = node;
                if (typeof value === 'number' && isFinite(value) && value >= -100000000 && value <= 100000000) return {
                    valid: true,
                    type: value % 1 === 0 ? 'int' : 'decimal'
                };
                if (typeof value === 'boolean') return {
                    valid: true,
                    type: 'boolean'
                };
                if (typeof value === 'string') return {
                    valid: true,
                    type: 'string'
                };
                return {
                    valid: false,
                    reason: `Invalid expression "${raw}".`
                };
            }
        case 'Identifier':
            {
                const name = node.name.toUpperCase();
                if (context.identifiers[name]) return {
                    valid: true,
                    type: context.identifiers[name]
                };
                return {
                    valid: false,
                    reason: `Invalid expression "${name}".`
                };
            }
        default:
            return {
                valid: false,
                reason: 'Invalid expression.'
            };
    }
}
function $429c97a54779edde$var$parseExpression(expression) {
    try {
        return {
            valid: true,
            node: (0, $cec7b3c0f35c015b$export$2e2bcd8739ae039)(expression)
        };
    } catch (e) {
        if (e instanceof Error && 'description' in e && typeof e.description === 'string' && 'index' in e && typeof e.index === 'number') return {
            valid: false,
            reason: e.description
        };
        return {
            valid: false,
            reason: `Invalid expression "${expression}"`
        };
    }
}
function $429c97a54779edde$export$8da72883fbab6547({ expression: expression, getContext: getContext }) {
    const parseResult = $429c97a54779edde$var$parseExpression(expression);
    if (!parseResult.valid) return parseResult;
    const { node: node } = parseResult;
    const originalNode = structuredClone(node);
    const result = $429c97a54779edde$var$validateActivityExpression({
        node: node,
        context: {
            ...getContext()
        },
        ancestors: []
    });
    if (!result.valid) return result;
    return {
        valid: true,
        node: node,
        originalNode: originalNode,
        type: result.type
    };
}




class $f000c905ad3941aa$export$f9765a67b1be7546 extends HTMLElement {
    timeout = 0;
    connectedCallback() {
        this.addEventListener('change', this);
        this.addEventListener('blur', this);
        this.addEventListener('keydown', this);
    }
    disconnectedCallback() {
        this.removeEventListener('change', this);
        this.removeEventListener('blur', this);
        this.removeEventListener('keydown', this);
    }
    get input() {
        return this.querySelector('input');
    }
    get allowedTypes() {
        return this.getAttribute('allowed-types')?.split(/\s+/g).filter((0, $6d4649a4b0d9f10a$export$b6b5b1f15bbc92d6)) ?? [];
    }
    get usage() {
        return this.getAttribute('usage');
    }
    handleEvent(event) {
        if (event.target === this.input) {
            if (event instanceof KeyboardEvent) {
                if (event.key === 'Enter') event.preventDefault();
                else return;
            }
            if (event.isTrusted) {
                clearTimeout(this.timeout);
                this.processChange();
            }
        } else {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(this.processChange, 300);
        }
    }
    processChange = ()=>{
        if (this.input.value.trim() === '') return;
        const result = $f000c905ad3941aa$var$parseAndValidate(this.input, this.allowedTypes, this.usage);
        if (!result.valid) {
            setTimeout(()=>{
                (0, $84fd3dc30499b2d0$export$e0ddcd48746f2dd9)(this.input, result.reason);
                this.closest('.form-group')?.classList.add('errored');
            });
            return;
        }
        const formatted = (0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(result.originalNode);
        if (this.input.value !== formatted) {
            this.input.value = formatted;
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.input);
        }
    };
}
if (!window.customElements.get('expression-input')) {
    window.ExpressionInput = $f000c905ad3941aa$export$f9765a67b1be7546;
    window.customElements.define('expression-input', $f000c905ad3941aa$export$f9765a67b1be7546);
}
function $f000c905ad3941aa$var$parseAndValidate(input, allowedTypes, usage) {
    const event = new CustomEvent((0, $53c5e6461ac6ee8d$export$4a61b9856b3d6ba6), {
        bubbles: true,
        cancelable: true,
        detail: {
            identifiers: {}
        }
    });
    if (input.dispatchEvent(event)) return {
        valid: false,
        reason: 'Expression scope request was not handled.'
    };
    const context = {
        properties: {},
        references: [],
        scanReferences: false,
        identifiers: event.detail.identifiers,
        usage: usage
    };
    const result = (0, $429c97a54779edde$export$8da72883fbab6547)({
        expression: input.value,
        getContext: ()=>context
    });
    if (!result.valid) return {
        valid: false,
        reason: result.reason
    };
    if (allowedTypes.includes(result.type)) return result;
    return {
        valid: false,
        reason: `Expression must result in a ${allowedTypes.join(' / ')}.`
    };
}
(0, $84fd3dc30499b2d0$export$86f1725708ac86dc)((input)=>{
    let exp;
    if (input instanceof HTMLInputElement && input.type === 'text' && input.value.trim() !== '' && (exp = input.closest('expression-input'))) {
        const result = $f000c905ad3941aa$var$parseAndValidate(input, exp.allowedTypes, exp.usage);
        if (!result.valid) return result.reason;
    }
    return null;
});




class $ba634303a1d5908b$export$9437640b5217dd0f extends HTMLElement {
    connectedCallback() {
        if ('geolocation' in navigator) this.button?.addEventListener('click', this);
        else this.button?.remove();
        this.autocomplete?.addEventListener('combobox-commit', this);
    }
    disconnectedCallback() {
        this.button?.removeEventListener('click', this);
        this.autocomplete?.removeEventListener('combobox-commit', this);
    }
    handleEvent({ type: type, target: target }) {
        switch(type){
            case 'click':
                this.geolocate();
                return;
            case 'combobox-commit':
                {
                    if (!(target instanceof HTMLElement)) return;
                    const value = JSON.parse(target.getAttribute('data-autocomplete-data'));
                    const form = document.createElement('form');
                    form.method = 'POST';
                    form.action = '/api/location/magic-key';
                    form.hidden = true;
                    form.onformdata = ({ formData: formData })=>{
                        formData.set('q', value.text);
                        formData.set('magic_key', value.magicKey);
                        formData.set('redirect_uri', location.pathname + location.search);
                    };
                    document.body.append(form);
                    form.submit();
                    return;
                }
            default:
                throw new Error(`Unhandled event type: ${type}`);
        }
    }
    async geolocate() {
        let position;
        try {
            position = await new Promise((resolve, reject)=>navigator.geolocation.getCurrentPosition(resolve, reject, {
                    enableHighAccuracy: true,
                    maximumAge: 300000
                }));
        } catch (err) {
            let code = -1;
            if (err instanceof GeolocationPositionError) code = err.code;
            switch(code){
                case GeolocationPositionError.PERMISSION_DENIED:
                    break;
                case GeolocationPositionError.POSITION_UNAVAILABLE:
                    alert('Position unavailable');
                    break;
                case GeolocationPositionError.TIMEOUT:
                    alert('Timed out while retrieving position.');
                    break;
                default:
                    alert('Error getting position.');
                    break;
            }
            return;
        }
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/api/location/reverse-geocode';
        form.hidden = true;
        form.onformdata = ({ formData: formData })=>{
            formData.set('latitude:number', position.coords.latitude.toString());
            formData.set('longitude:number', position.coords.longitude.toString());
            formData.set('redirect_uri', location.pathname + location.search);
        };
        document.body.append(form);
        form.submit();
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ba634303a1d5908b$export$9437640b5217dd0f.prototype, "button", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ba634303a1d5908b$export$9437640b5217dd0f.prototype, "autocomplete", void 0);
$ba634303a1d5908b$export$9437640b5217dd0f = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('geolocation-controller')
], $ba634303a1d5908b$export$9437640b5217dd0f);




class $f2fcbc46d8f4b350$var$InsertAdjacentHtmlElement extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        addEventListener((0, $ab6f099c20a34e1f$export$707ab90452beb68e), this.afterSubmit);
    }
    disconnectedCallback() {
        removeEventListener((0, $ab6f099c20a34e1f$export$707ab90452beb68e), this.afterSubmit);
    }
    afterSubmit = async (event)=>{
        const { detail: response, target: target } = event;
        if (!(this.contains(target) || target instanceof (0, $ab6f099c20a34e1f$export$eff824212e04ca3f) && target.parentElement?.id === this.getAttribute('form'))) return;
        const element = this.ownerDocument.getElementById(this.getAttribute('element'));
        const position = this.getAttribute('position');
        const setFocus = this.hasAttribute('set-focus');
        const text = await response.text();
        const template = document.createElement('template');
        template.innerHTML = text;
        const content = template.content.cloneNode(true);
        const firstControl = content.querySelector('input,select,textarea');
        const firstElement = content.firstElementChild;
        switch(position){
            case 'afterbegin':
                element.prepend(content);
                break;
            case 'afterend':
                element.after(content);
                break;
            case 'beforebegin':
                element.before(content);
                break;
            case 'beforeend':
                element.append(content);
                break;
            case 'replace':
                element.after(content);
                element.remove();
                break;
            default:
                throw new Error(`Unexpected position: "${position}"`);
        }
        if (firstControl) (0, $80a2320123ddcd02$export$89348ae70780cd7a)(firstControl);
        if (setFocus) (0, $80a2320123ddcd02$export$956fd4dade47957a)(firstElement);
    };
}
if (!window.customElements.get('insert-adjacent-html')) {
    window.InsertAdjacentHtmlElement = $f2fcbc46d8f4b350$var$InsertAdjacentHtmlElement;
    window.customElements.define('insert-adjacent-html', $f2fcbc46d8f4b350$var$InsertAdjacentHtmlElement);
}





class $8eadb8739ae4299a$export$4b9f8fa2c586d82a extends HTMLElement {
    get disabled() {
        return this.hasAttribute('disabled');
    }
    connectedCallback() {
        this.list = this.firstElementChild;
        this.list.setAttribute('role', 'listbox');
        this.list.setAttribute('aria-multiselectable', this.hasAttribute('multiple').toString());
        this.ensureActiveDescendent();
        this.list.addEventListener('keydown', this);
        this.list.addEventListener('click', this);
        this.observer = new MutationObserver(()=>this.ensureActiveDescendent());
        this.observer.observe(this.list, {
            childList: true
        });
    }
    disconnectedCallback() {
        this.list.removeEventListener('keydown', this);
        this.list.removeEventListener('click', this);
        this.observer.disconnect();
    }
    handleEvent(event) {
        switch(event.type){
            case 'keydown':
                this.handleKeyDown(event);
                break;
            case 'click':
                this.handleClick(event);
                break;
            default:
                throw new Error(`Unexpected event type: "${event.type}".`);
        }
    }
    handleKeyDown(event) {
        if (event.target !== this.list) return;
        if (event.shiftKey || event.metaKey || event.altKey || event.ctrlKey) return;
        if (!this.activeDescendant) return;
        switch(event.key){
            case 'Enter':
                if (this.clickActiveDescendant()) event.preventDefault();
                break;
            case 'ArrowDown':
            case 'ArrowRight':
                this.navigate(1);
                event.preventDefault();
                break;
            case 'ArrowUp':
            case 'ArrowLeft':
                this.navigate(-1);
                event.preventDefault();
                break;
            case 'Delete':
            case 'Backspace':
                if (this.disabled) return;
                if (this.deleteActiveDescendant()) event.preventDefault();
                break;
        }
    }
    handleClick(event) {
        const del = event.target instanceof Element && event.target.closest('[data-list-box-delete]') && !this.disabled;
        const option = event.target instanceof Element && event.target.closest('[role="option"]');
        if (!option) return;
        this.identifyOptions();
        this.list.setAttribute('aria-activedescendant', option.id);
        let result;
        if (del) result = this.deleteActiveDescendant();
        else result = this.clickActiveDescendant();
        if (result) event.preventDefault();
    }
    clickActiveDescendant() {
        const active = this.activeDescendant;
        if (!active) return false;
        const event = new CustomEvent('list-box-item-click', {
            bubbles: true,
            detail: active
        });
        this.dispatchEvent(event);
        // todo: set aria-selected
        return !event.defaultPrevented;
    }
    deleteActiveDescendant() {
        const active = this.activeDescendant;
        if (!active) return false;
        const event = new CustomEvent('list-box-item-delete', {
            bubbles: true,
            detail: active
        });
        this.dispatchEvent(event);
        if (event.defaultPrevented) return false;
        this.navigate(-1);
        active.remove();
        this.ensureActiveDescendent();
        return true;
    }
    get activeDescendant() {
        const id = this.list.getAttribute('aria-activedescendant');
        if (!id) return null;
        return this.list.querySelector('#' + id);
    }
    activate(option) {
        Array.from(this.list.querySelectorAll('[role="option"]')).filter((x)=>x !== option).forEach((x)=>x.removeAttribute('data-list-box-active'));
        this.list.setAttribute('aria-activedescendant', option.id);
        option.setAttribute('data-list-box-active', 'true');
    }
    navigate(delta) {
        this.identifyOptions();
        const options = Array.from(this.list.querySelectorAll('[role="option"]'));
        const active = this.activeDescendant;
        let index = options.indexOf(active);
        index = Math.min(options.length - 1, Math.max(0, index + delta));
        this.activate(options[index]);
    }
    identifyOptions() {
        this.list.querySelectorAll('[role="option"]:not([id])').forEach((x)=>x.id = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)());
    }
    ensureActiveDescendent() {
        this.identifyOptions();
        const option = this.activeDescendant || this.list.querySelector('[role="option"][aria-selected="true"]') || this.list.querySelector('[role="option"]');
        if (option) {
            this.activate(option);
            this.list.setAttribute('tabindex', '0');
        } else {
            this.list.removeAttribute('aria-activedescendant');
            this.list.removeAttribute('tabindex');
        }
    }
}
$8eadb8739ae4299a$export$4b9f8fa2c586d82a = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('list-box')
], $8eadb8739ae4299a$export$4b9f8fa2c586d82a);


const $f829e6702c1260cf$export$9488ee68e59e0b92 = /(?:[-@*_~`#>\]|])|(?:\d\.)/;







let $47b1ba4602100a4f$var$emojiPromise = null;
async function $47b1ba4602100a4f$var$findEmoji(text, src) {
    if (!$47b1ba4602100a4f$var$emojiPromise) $47b1ba4602100a4f$var$emojiPromise = fetch(src).then((r)=>{
        if ((0, $8f2070e09d7bee6a$export$91cdf58e199a84d0)(r)) {
            $47b1ba4602100a4f$var$emojiPromise = null;
            return [];
        }
        return r.json();
    });
    if (text.length === 0) return [
        {
            id: '+1',
            text: [],
            value: "\uD83D\uDC4D"
        },
        {
            id: '-1',
            text: [],
            value: "\uD83D\uDC4E"
        },
        {
            id: '100',
            text: [],
            value: "\uD83D\uDCAF"
        },
        {
            id: 'cry',
            text: [],
            value: "\uD83D\uDE22"
        },
        {
            id: 'heart',
            text: [],
            value: "\u2764\uFE0F"
        }
    ];
    const emoji = await $47b1ba4602100a4f$var$emojiPromise;
    text = text.toLowerCase();
    const suggestions = [];
    let i = 0;
    while(i < emoji.length && suggestions.length < 5){
        if (emoji[i].text.find((t)=>t.startsWith(text))) suggestions.push(emoji[i]);
        i++;
    }
    return suggestions;
}
const $47b1ba4602100a4f$var$fragment = document.createElement('ul');
$47b1ba4602100a4f$var$fragment.setAttribute('aria-label', 'Results');
$47b1ba4602100a4f$var$fragment.className = 'suggester suggester-container';
$47b1ba4602100a4f$var$fragment.setAttribute('role', 'listbox');
let $47b1ba4602100a4f$var$mentionFetchController;
async function $47b1ba4602100a4f$var$provideMention(mentionsSrc, text) {
    $47b1ba4602100a4f$var$mentionFetchController?.abort('superseded');
    $47b1ba4602100a4f$var$mentionFetchController = new AbortController();
    const url = new URL(mentionsSrc, location.origin);
    url.searchParams.set('q', text);
    const response = await fetch(url, {
        signal: $47b1ba4602100a4f$var$mentionFetchController.signal,
        headers: {
            accept: 'text/fragment+html'
        }
    });
    if ((0, $8f2070e09d7bee6a$export$91cdf58e199a84d0)(response)) return '';
    if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response);
    return response.text();
}
let $47b1ba4602100a4f$var$previewFetchController;
async function $47b1ba4602100a4f$var$previewMarkdown(previewSrc, markdown) {
    $47b1ba4602100a4f$var$previewFetchController?.abort('superseded');
    $47b1ba4602100a4f$var$previewFetchController = undefined;
    if (markdown.trim().length === 0) return (0, $b11db1b62d4a8f76$export$fff7de9eec117c98)[(0, $c74c4f773f8a11f2$export$180605366c04f0cd)()];
    if (!(0, $f829e6702c1260cf$export$9488ee68e59e0b92).test(markdown)) return (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`${markdown}`);
    $47b1ba4602100a4f$var$previewFetchController = new AbortController();
    const url = new URL(previewSrc, location.origin);
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            accept: 'text/fragment+html'
        },
        body: JSON.stringify(markdown),
        signal: $47b1ba4602100a4f$var$previewFetchController.signal
    });
    if ((0, $8f2070e09d7bee6a$export$91cdf58e199a84d0)(response)) return `<p class="text-italic">Unable to render markdown preview: session is expired</p>`;
    if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response);
    return response.text();
}
class $47b1ba4602100a4f$export$8d00bac029d641e5 extends HTMLElement {
    markdownToPreview = undefined;
    selectionStart = undefined;
    connectedCallback() {
        this.addEventListener('change', this);
        this.addEventListener('input', this);
        this.addEventListener('tab-container-changed', this);
        this.addEventListener('text-expander-change', this, {
            capture: true
        });
        this.addEventListener('text-expander-value', this, {
            capture: true
        });
        this.addEventListener('text-expander-committed', this, {
            capture: true
        });
        this.addEventListener('file-attachment-accepted', this);
        this.addEventListener('blur', this, {
            capture: true
        });
        this.markdownToPreview = this.querySelector('text-expander textarea')?.value ?? undefined;
    }
    disconnectedCallback() {
        this.removeEventListener('change', this);
        this.removeEventListener('input', this);
        this.removeEventListener('tab-container-changed', this);
        this.removeEventListener('text-expander-change', this, {
            capture: true
        });
        this.removeEventListener('text-expander-value', this, {
            capture: true
        });
        this.removeEventListener('text-expander-committed', this, {
            capture: true
        });
        this.removeEventListener('file-attachment-accepted', this);
        this.removeEventListener('blur', this, {
            capture: true
        });
    }
    handleEvent(event) {
        const { type: type, target: target } = event;
        switch(type){
            case 'text-expander-committed':
            case 'change':
            case 'input':
                if (!(target instanceof HTMLTextAreaElement)) return;
                this.invalidatePreview(target.value);
                this.selectionStart = target.selectionStart;
                return;
            case 'tab-container-changed':
                this.preview();
                return;
            case 'text-expander-value':
                {
                    const { detail: detail } = event;
                    const value = detail.item.getAttribute('data-value');
                    detail.value = value;
                    return;
                }
            case 'text-expander-change':
                {
                    const { detail: { key: key, provide: provide, text: text } } = event;
                    if (key === ':') provide(this.provideEmoji(text));
                    if (key === '@') {
                        const mentionsSrc = this.getAttribute('mentions-src');
                        if (mentionsSrc) provide(this.provideMention(mentionsSrc, text));
                    }
                    return;
                }
            case 'file-attachment-accepted':
                this.fileAttachmentAccepted(event);
                return;
            case 'blur':
                if (event.target instanceof HTMLTextAreaElement) this.selectionStart = event.target.selectionStart;
                return;
            default:
                throw new Error(`Unexpected event type "${type}".`);
        }
    }
    provideEmoji(text) {
        return $47b1ba4602100a4f$var$findEmoji(text, this.getAttribute('emoji-src')).then((emoji)=>{
            $47b1ba4602100a4f$var$fragment.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)(emoji.map((x)=>(0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<li role="option" data-value="${x.value}">
              ${x.value} ${x.id}
            </li>`));
            return {
                matched: emoji.length > 0,
                fragment: $47b1ba4602100a4f$var$fragment
            };
        });
    }
    provideMention(mentionsSrc, text) {
        return $47b1ba4602100a4f$var$provideMention(mentionsSrc, text).then((html)=>{
            $47b1ba4602100a4f$var$fragment.innerHTML = html;
            return {
                matched: $47b1ba4602100a4f$var$fragment.childElementCount > 0,
                fragment: $47b1ba4602100a4f$var$fragment
            };
        });
    }
    get markdownBody() {
        const el = this.querySelector('.markdown-body');
        if (!el) throw new Error('Missing .markdown-body element.');
        return el;
    }
    async preview() {
        if (this.markdownToPreview === undefined) return;
        const md = this.markdownToPreview;
        this.markdownToPreview = undefined;
        const src = this.getAttribute('preview-src');
        const html = await $47b1ba4602100a4f$var$previewMarkdown(src, md);
        this.markdownBody.innerHTML = html;
    }
    invalidatePreview(value) {
        const markdownBody = this.markdownBody;
        this.markdownToPreview = value;
        markdownBody.setAttribute('source-markdown', value);
        markdownBody.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<div class="py-3 d-flex flex-justify-center">
        <div class="spinner-border f1 color-fg-muted"></div>
      </div>`);
    }
    async fileAttachmentAccepted(event) {
        const locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
        const fileAttachmentElement = event.target instanceof HTMLElement && event.target;
        if (!fileAttachmentElement) throw new Error('Missing file attachment element');
        const uploadHref = fileAttachmentElement.getAttribute('upload-href');
        if (!uploadHref) throw new Error('Missing upload href');
        const uploadUrl = new URL(uploadHref, location.origin);
        const attachments = event.detail.attachments;
        const fileLabelContentSpan = fileAttachmentElement.hasAttribute('data-file-label-content-id') && document.getElementById(fileAttachmentElement.getAttribute('data-file-label-content-id'));
        if (!fileLabelContentSpan) throw new Error('Missing file label content span');
        const textarea = fileAttachmentElement.querySelector('textarea');
        if (!textarea) throw new Error('Missing textarea');
        if (document.activeElement !== textarea) textarea.focus();
        let interval = 0;
        const progressSpan = document.createElement('span');
        progressSpan.append(document.createElement('span'), document.createTextNode(' '), document.createElement('span'));
        progressSpan.firstElementChild.classList.add('spinner-border', 'color-fg-muted');
        const setProgress = ()=>{
            const index = attachments.filter((attachment)=>attachment.isSaved() || attachment.isSaving()).length;
            progressSpan.lastElementChild.textContent = (0, $b11db1b62d4a8f76$export$7f449188bb84ac2c)[locale](index, attachments.length);
        };
        setProgress();
        const attachmentSaved = (attachment)=>{
            const { id: id, name: name, href: href } = attachment;
            const start = this.selectionStart ?? textarea.selectionStart;
            const end = this.selectionStart ?? textarea.selectionEnd;
            const prefix = start > 0 ? '  \n' : '';
            textarea.setRangeText(`${prefix}${attachment.isImage() ? '!' : ''}[${name}](${href})  `, start, end, 'end');
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(textarea);
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'attachments/-/attachment_id';
            input.value = id;
            textarea.form?.insertAdjacentElement('beforeend', input);
        };
        try {
            fileLabelContentSpan.hidden = true;
            fileLabelContentSpan.after(progressSpan);
            interval = setInterval(setProgress, 50);
            await (0, $4ab5d79d76486e1b$export$14d3a7d22f26659e)({
                locale: locale,
                attachments: attachments,
                uploadUrl: uploadUrl,
                attachmentSaved: attachmentSaved
            });
        } finally{
            progressSpan.remove();
            fileLabelContentSpan.hidden = false;
            clearInterval(interval);
        }
    }
}
if (!window.customElements.get('markdown-editor')) {
    window.MarkdownEditorElement = $47b1ba4602100a4f$export$8d00bac029d641e5;
    window.customElements.define('markdown-editor', $47b1ba4602100a4f$export$8d00bac029d641e5);
}


var $c5abc2fad9c78aa4$var$I = Object.defineProperty;
var $c5abc2fad9c78aa4$var$P = (n, e, s)=>e in n ? $c5abc2fad9c78aa4$var$I(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : n[e] = s;
var $c5abc2fad9c78aa4$var$A = (n, e, s)=>$c5abc2fad9c78aa4$var$P(n, typeof e != "symbol" ? e + "" : e, s);
const $c5abc2fad9c78aa4$export$625550452a3fa3ec = {
    "#": {
        pattern: /[0-9]/
    },
    "@": {
        pattern: /[a-zA-Z]/
    },
    "*": {
        pattern: /[a-zA-Z0-9]/
    }
}, $c5abc2fad9c78aa4$var$N = (n, e, s)=>n.replaceAll(e, "").replace(s, ".").replace("..", ".").replace(/[^.\d]/g, ""), $c5abc2fad9c78aa4$var$w = (n, e, s)=>{
    var t;
    return new Intl.NumberFormat(((t = s.number) == null ? void 0 : t.locale) ?? "en", {
        minimumFractionDigits: n,
        maximumFractionDigits: e,
        roundingMode: "trunc"
    });
}, $c5abc2fad9c78aa4$var$S = (n, e = !0, s)=>{
    var g, v, k, h;
    const t = ((g = s.number) == null ? void 0 : g.unsigned) !== !0 && n.startsWith("-") ? "-" : "", r = ((v = s.number) == null ? void 0 : v.fraction) ?? 0;
    let a = $c5abc2fad9c78aa4$var$w(0, r, s);
    const c = a.formatToParts(1000.12), p = ((k = c.find((o)=>o.type === "group")) == null ? void 0 : k.value) ?? " ", d = ((h = c.find((o)=>o.type === "decimal")) == null ? void 0 : h.value) ?? ".", i = $c5abc2fad9c78aa4$var$N(n, p, d);
    if (Number.isNaN(parseFloat(i))) return t;
    const m = i.split(".");
    if (m[1] != null && m[1].length >= 1) {
        const o = m[1].length <= r ? m[1].length : r;
        a = $c5abc2fad9c78aa4$var$w(o, r, s);
    }
    let l = a.format(parseFloat(i));
    return e ? r > 0 && i.endsWith(".") && !i.slice(0, -1).includes(".") && (l += d) : l = $c5abc2fad9c78aa4$var$N(l, p, d), t + l;
}, $c5abc2fad9c78aa4$var$C = (n)=>JSON.parse(n.replaceAll("'", '"')), $c5abc2fad9c78aa4$var$T = (n, e = {})=>{
    const s = {
        ...e
    };
    n.dataset.maska != null && n.dataset.maska !== "" && (s.mask = $c5abc2fad9c78aa4$var$F(n.dataset.maska)), n.dataset.maskaEager != null && (s.eager = $c5abc2fad9c78aa4$var$E(n.dataset.maskaEager)), n.dataset.maskaReversed != null && (s.reversed = $c5abc2fad9c78aa4$var$E(n.dataset.maskaReversed)), n.dataset.maskaTokensReplace != null && (s.tokensReplace = $c5abc2fad9c78aa4$var$E(n.dataset.maskaTokensReplace)), n.dataset.maskaTokens != null && (s.tokens = $c5abc2fad9c78aa4$var$W(n.dataset.maskaTokens));
    const t = {};
    return n.dataset.maskaNumberLocale != null && (t.locale = n.dataset.maskaNumberLocale), n.dataset.maskaNumberFraction != null && (t.fraction = parseInt(n.dataset.maskaNumberFraction)), n.dataset.maskaNumberUnsigned != null && (t.unsigned = $c5abc2fad9c78aa4$var$E(n.dataset.maskaNumberUnsigned)), (n.dataset.maskaNumber != null || Object.values(t).length > 0) && (s.number = t), s;
}, $c5abc2fad9c78aa4$var$E = (n)=>n !== "" ? !!JSON.parse(n) : !0, $c5abc2fad9c78aa4$var$F = (n)=>n.startsWith("[") && n.endsWith("]") ? $c5abc2fad9c78aa4$var$C(n) : n, $c5abc2fad9c78aa4$var$W = (n)=>{
    if (n.startsWith("{") && n.endsWith("}")) return $c5abc2fad9c78aa4$var$C(n);
    const e = {};
    return n.split("|").forEach((s)=>{
        const t = s.split(":");
        e[t[0]] = {
            pattern: $c5abc2fad9c78aa4$var$x() ? new RegExp(t[1], "u") : new RegExp(t[1]),
            optional: t[2] === "optional",
            multiple: t[2] === "multiple",
            repeated: t[2] === "repeated"
        };
    }), e;
}, $c5abc2fad9c78aa4$var$x = ()=>{
    try {
        return new RegExp("\\p{L}", "u"), !0;
    } catch  {
        return !1;
    }
};
class $c5abc2fad9c78aa4$export$407448d2b89b1813 {
    constructor(e = {}){
        $c5abc2fad9c78aa4$var$A(this, "opts", {});
        $c5abc2fad9c78aa4$var$A(this, "memo", /* @__PURE__ */ new Map());
        const s = {
            ...e
        };
        if (s.tokens != null) {
            s.tokens = s.tokensReplace ? {
                ...s.tokens
            } : {
                ...$c5abc2fad9c78aa4$export$625550452a3fa3ec,
                ...s.tokens
            };
            for (const t of Object.values(s.tokens))typeof t.pattern == "string" && (t.pattern = $c5abc2fad9c78aa4$var$x() ? new RegExp(t.pattern, "u") : new RegExp(t.pattern));
        } else s.tokens = $c5abc2fad9c78aa4$export$625550452a3fa3ec;
        Array.isArray(s.mask) && (s.mask.length > 1 ? s.mask = [
            ...s.mask
        ].sort((t, r)=>t.length - r.length) : s.mask = s.mask[0] ?? ""), s.mask === "" && (s.mask = null), this.opts = s;
    }
    masked(e) {
        return this.process(String(e), this.findMask(String(e)));
    }
    unmasked(e) {
        return this.process(String(e), this.findMask(String(e)), !1);
    }
    isEager() {
        return this.opts.eager === !0;
    }
    isReversed() {
        return this.opts.reversed === !0;
    }
    completed(e) {
        const s = this.findMask(String(e));
        if (this.opts.mask == null || s == null) return !1;
        const t = this.process(String(e), s).length;
        return typeof this.opts.mask == "string" ? t >= this.opts.mask.length : t >= s.length;
    }
    findMask(e) {
        const s = this.opts.mask;
        if (s == null) return null;
        if (typeof s == "string") return s;
        if (typeof s == "function") return s(e);
        const t = this.process(e, s.slice(-1).pop() ?? "", !1);
        return s.find((r)=>this.process(e, r, !1).length >= t.length) ?? "";
    }
    escapeMask(e) {
        const s = [], t = [];
        return e.split("").forEach((r, a)=>{
            r === "!" && e[a - 1] !== "!" ? t.push(a - t.length) : s.push(r);
        }), {
            mask: s.join(""),
            escaped: t
        };
    }
    process(e, s, t = !0) {
        if (this.opts.number != null) return $c5abc2fad9c78aa4$var$S(e, t, this.opts);
        if (s == null) return e;
        const r = `v=${e},mr=${s},m=${t ? 1 : 0}`;
        if (this.memo.has(r)) return this.memo.get(r);
        const { mask: a, escaped: c } = this.escapeMask(s), p = [], d = this.opts.tokens != null ? this.opts.tokens : {}, i = this.isReversed() ? -1 : 1, m = this.isReversed() ? "unshift" : "push", l = this.isReversed() ? 0 : a.length - 1, g = this.isReversed() ? ()=>o > -1 && u > -1 : ()=>o < a.length && u < e.length, v = (b)=>!this.isReversed() && b <= l || this.isReversed() && b >= l;
        let k, h = -1, o = this.isReversed() ? a.length - 1 : 0, u = this.isReversed() ? e.length - 1 : 0, M = !1;
        for(; g();){
            const b = a.charAt(o), f = d[b], y = (f == null ? void 0 : f.transform) != null ? f.transform(e.charAt(u)) : e.charAt(u);
            if (!c.includes(o) && f != null ? (y.match(f.pattern) != null ? (p[m](y), f.repeated ? (h === -1 ? h = o : o === l && o !== h && (o = h - i), l === h && (o -= i)) : f.multiple && (M = !0, o -= i), o += i) : f.multiple ? M && (o += i, u -= i, M = !1) : y === k ? k = void 0 : f.optional && (o += i, u -= i), u += i) : (t && !this.isEager() && p[m](b), y === b && !this.isEager() ? u += i : k = b, this.isEager() || (o += i)), this.isEager()) for(; v(o) && (d[a.charAt(o)] == null || c.includes(o));){
                if (t) {
                    if (p[m](a.charAt(o)), e.charAt(u) === a.charAt(o)) {
                        o += i, u += i;
                        continue;
                    }
                } else a.charAt(o) === e.charAt(u) && (u += i);
                o += i;
            }
        }
        return this.memo.set(r, p.join("")), this.memo.get(r);
    }
}
const $c5abc2fad9c78aa4$export$2408f22a0fab9ae5 = [
    "text",
    "search",
    "url",
    "tel",
    "password"
];
class $c5abc2fad9c78aa4$export$3a1a48c8f6ef640e {
    constructor(e, s = {}){
        $c5abc2fad9c78aa4$var$A(this, "items", /* @__PURE__ */ new Map());
        $c5abc2fad9c78aa4$var$A(this, "eventAbortController");
        $c5abc2fad9c78aa4$var$A(this, "onInput", (e)=>{
            if (e instanceof CustomEvent && e.type === "input" && !e.isTrusted && !e.bubbles) return;
            const s = e.target, t = this.items.get(s);
            if (t === void 0) return;
            const r = "inputType" in e && e.inputType.startsWith("delete"), a = t.isEager(), c = r && a && t.unmasked(s.value) === "" ? "" : s.value;
            this.fixCursor(s, r, ()=>this.setValue(s, c));
        });
        this.options = s, this.eventAbortController = new AbortController(), this.init(this.getInputs(e));
    }
    update(e = {}) {
        this.options = {
            ...e
        }, this.init(Array.from(this.items.keys()));
    }
    updateValue(e) {
        var s;
        e.value !== "" && e.value !== ((s = this.processInput(e)) == null ? void 0 : s.masked) && this.setValue(e, e.value);
    }
    destroy() {
        this.eventAbortController.abort(), this.items.clear();
    }
    init(e) {
        const s = this.getOptions(this.options);
        for (const t of e){
            if (!$c5abc2fad9c78aa4$export$2408f22a0fab9ae5.includes(t.type)) return;
            if (!this.items.has(t)) {
                const { signal: a } = this.eventAbortController;
                t.addEventListener("input", this.onInput, {
                    capture: !0,
                    signal: a
                });
            }
            const r = new $c5abc2fad9c78aa4$export$407448d2b89b1813($c5abc2fad9c78aa4$var$T(t, s));
            this.items.set(t, r), queueMicrotask(()=>this.updateValue(t));
        }
    }
    getInputs(e) {
        return typeof e == "string" ? Array.from(document.querySelectorAll(e)) : "length" in e ? Array.from(e) : [
            e
        ];
    }
    getOptions(e) {
        const { onMaska: s, preProcess: t, postProcess: r, ...a } = e;
        return a;
    }
    fixCursor(e, s, t) {
        var g, v, k;
        const r = e.selectionStart, a = e.value;
        if (t(), r === null || r === a.length && !s) return;
        const c = e.value, p = a.slice(0, r), d = c.slice(0, r), i = (g = this.processInput(e, p)) == null ? void 0 : g.unmasked, m = (v = this.processInput(e, d)) == null ? void 0 : v.unmasked;
        if (i === void 0 || m === void 0) return;
        let l = r;
        if (p !== d) {
            if (s) l += c.length - a.length;
            else if (i.length === 0) l = 0;
            else {
                l = c.length;
                for(let h = 1; h <= c.length; h++)if ((((k = this.processInput(e, c.slice(0, h))) == null ? void 0 : k.unmasked) ?? "").length >= i.length) {
                    l = h;
                    break;
                }
            }
        }
        e.setSelectionRange(l, l);
    }
    setValue(e, s) {
        const t = this.processInput(e, s);
        t !== void 0 && (e.value = t.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((r)=>r(t)) : this.options.onMaska(t)), e.dispatchEvent(new CustomEvent("maska", {
            detail: t
        })), e.dispatchEvent(new CustomEvent("input", {
            detail: t.masked
        })));
    }
    processInput(e, s) {
        const t = this.items.get(e);
        if (t === void 0) return;
        let r = s ?? e.value;
        this.options.preProcess != null && (r = this.options.preProcess(r));
        let a = t.masked(r);
        return this.options.postProcess != null && (a = this.options.postProcess(a)), {
            masked: a,
            unmasked: t.unmasked(r),
            completed: t.completed(r)
        };
    }
}




class $c02878b915d9f7dc$export$c655c6fc8d11b048 extends HTMLElement {
    mask;
    connectedCallback() {
        const pattern = this.getAttribute('pattern');
        if (pattern && this.firstElementChild instanceof HTMLInputElement) this.mask = new (0, $c5abc2fad9c78aa4$export$3a1a48c8f6ef640e)(this.firstElementChild, {
            mask: pattern
        });
    }
    disconnectedCallback() {
        this.mask?.destroy();
    }
}
if (!window.customElements.get('mask-input')) {
    window.MaskInputElement = $c02878b915d9f7dc$export$c655c6fc8d11b048;
    window.customElements.define('mask-input', $c02878b915d9f7dc$export$c655c6fc8d11b048);
}




const $903670d025332df5$export$511f44e01e024619 = [
    {
        id: 'taking-as-directed',
        title: 'Taking as directed'
    },
    {
        id: 'taking-not-as-directed',
        title: 'Not taking as directed'
    },
    {
        id: 'on-hold-as-directed',
        title: 'On hold per instructions'
    },
    {
        id: 'on-hold-not-as-directed',
        title: 'On hold against instructions'
    },
    {
        id: 'stopped-as-directed',
        title: 'Stopped as prescribed'
    },
    {
        id: 'stopped-not-as-directed',
        title: 'Stopped against instructions'
    },
    {
        id: 'unknown',
        title: 'Unknown'
    }
];
const $903670d025332df5$export$a8bce9498e67d565 = {
    'taking-as-directed': null,
    'taking-not-as-directed': 'danger',
    'on-hold-as-directed': null,
    'on-hold-not-as-directed': 'danger',
    'stopped-as-directed': null,
    'stopped-not-as-directed': 'danger',
    unknown: 'attention'
};
const $903670d025332df5$export$614987c2a84b2ba5 = {
    'taking-as-directed': (0, $84c634e688af79ca$export$1d8a03084661a191),
    'taking-not-as-directed': (0, $84c634e688af79ca$export$8e47d324a7a20b30),
    'on-hold-as-directed': (0, $84c634e688af79ca$export$adcaf896a7be650b),
    'on-hold-not-as-directed': (0, $84c634e688af79ca$export$8e47d324a7a20b30),
    'stopped-as-directed': (0, $84c634e688af79ca$export$d0c2ff82f0790e53),
    'stopped-not-as-directed': (0, $84c634e688af79ca$export$8e47d324a7a20b30),
    unknown: (0, $84c634e688af79ca$export$c5abb880dda04c02)
};
const $903670d025332df5$export$f7cb4f8454f0ce34 = {
    medications_count: 40,
    name: 300,
    brand_name: 150,
    display_name: 600,
    form: 150,
    strength: 100,
    route: 50,
    dose_and_frequency: 100,
    prescriber: 50,
    notes: 300
};
function $903670d025332df5$export$54acbb69c3b90fd2({ organization_id: organization_id, person_id: person_id, activity_id: activity_id, medication: medication }) {
    /*
  /api/medications/autocomplete/:drugbank_pcid/:mode(strengths|routes|forms)
  */ const base = `/api/organizations/${organization_id}/medications/autocomplete`;
    const search = new URLSearchParams();
    if (person_id) search.set('person_id', person_id);
    if (activity_id) search.set('activity_id', activity_id);
    const { drugbank_level: level, drugbank_pcid: pcid, strength: strength, route: route, form: form } = medication ?? {};
    if (!pcid || strength && route && form) return `${base}?${search}`;
    if (!strength) return `${base}/${pcid}/strengths?${search}`;
    if (!route) return `${base}/${pcid}/routes?${search}`;
    if (!form) return `${base}/${pcid}/forms?${search}`;
    throw new Error(`Invalid drugbank_level: ${level}`);
}




/*
keydown -> esc -> resets to medication name search, but only when value is empty
*/ class $dabf1640eccf4b9d$var$MedicationInputElement extends HTMLElement {
    get organization_id() {
        return this.getAttribute('organization_id');
    }
    get person_id() {
        return this.getAttribute('person_id');
    }
    get activity_id() {
        return this.getAttribute('activity_id');
    }
    focusSearchInput() {
        this.autocomplete.inputElement?.focus();
    }
    searchInputFocused({ isTrusted: isTrusted }) {
        this.#log('searchInputFocused', isTrusted);
    }
    searchInputBlurred() {
        this.#log('searchInputBlurred');
        // Close the dropdown on blur.
        // Timeout ensures this doesn't interfere with blurs that occur when selecting a suggestion.
        setTimeout(()=>{
            if (this.autocomplete.open) this.autocomplete.open = false;
            this.autocomplete.inputElement.value = '';
        }, 300); // do not reduce without testing quickly toggling between autocomplete suggestions with mouse.
    }
    async searchInputKeydown(event) {
        const { key: key, shiftKey: shiftKey, metaKey: metaKey, altKey: altKey, ctrlKey: ctrlKey } = event;
        this.#log('searchInputKeydown', key);
        if (shiftKey || metaKey || altKey || ctrlKey) return;
        if (key === 'Backspace') {
            this.stepBack();
            return;
        }
    }
    searchInputChanged() {
        this.#log('searchInputChanged', this.autocomplete.inputElement?.value);
    }
    onAutocompleteLoadStart() {
        this.#log('onAutocompleteLoadStart', this.autocomplete.inputElement?.value);
    }
    onAutocompleteLoadEnd() {
        this.#log('onAutocompleteLoadEnd', this.autocomplete.forElement?.childElementCount);
        this.autocomplete.forElement?.classList.remove('btn-busy');
        // Don't open the dropdown when the input is not focused.
        if (document.activeElement !== this.autocomplete.inputElement) setTimeout(()=>{
            if (this.autocomplete.open) {
                this.#log('CLOSE');
                this.autocomplete.open = false;
            }
        }, 0);
    }
    onAutocompleteChange() {
        this.#log('onAutocompleteChange', this.autocomplete.inputElement?.value);
    }
    async onAutocompleteCommit({ target: target }) {
        if (!(target instanceof HTMLElement)) return;
        const data = JSON.parse(target.getAttribute('data-autocomplete-data'));
        this.#log('onAutocompleteCommit');
        this.apply(data);
    }
    async stepBack() {
        if (this.autocomplete.inputElement?.disabled) return;
        const drugbank_pcid = this.drugbank_pcid.value;
        if (this.autocomplete.inputElement.value.length === 0 && drugbank_pcid) {
            this.autocomplete.open = false;
            if (this.drugbank_level.value === '1' || this.brand_name.value && this.drugbank_level.value === '2') {
                this.apply(null);
                return;
            }
            try {
                this.displaySpan.parentElement?.classList.add('btn-busy');
                const response = await fetch(new URL(`/api/medications/product-concepts/${drugbank_pcid}/parents`, location.origin));
                if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
                const parents = await response.json();
                // console.table(
                //   parents.map(({ brand_name, form, route, strength, name }) => ({
                //     brand_name,
                //     route,
                //     form,
                //     strength,
                //     name
                //   }))
                // );
                // console.table([
                //   {
                //     brand_name: this.brand_name.value,
                //     route: this.route.value,
                //     form: this.form.value,
                //     strength: this.strength.value,
                //     name: this.name.value
                //   }
                // ]);
                this.apply(parents.find((x)=>{
                    // name, strength, route, form
                    if ((x.brand_name ?? '') !== this.brand_name.value) return false;
                    if (this.form.value) return (x.route ?? '') === this.route.value && (x.strength ?? '') === this.strength.value;
                    else if (this.route.value) return (x.strength ?? '') === this.strength.value && (x.form ?? '') === this.form.value;
                    return true;
                }) ?? null);
            } catch  {
                this.apply(null);
            } finally{
                this.displaySpan.parentElement?.classList.remove('btn-busy');
            }
        }
    }
    apply(data) {
        this.#log('apply', JSON.stringify(data, null, 2));
        // set selection.
        this.displaySpan.textContent = data?.name?.substr(0, (0, $903670d025332df5$export$f7cb4f8454f0ce34).name) ?? '';
        this.drugbank_pcid.value = data?.drugbank_pcid ?? '';
        this.drugbank_level.value = data?.drugbank_level.toString() ?? '';
        this.name.value = data?.name?.substr(0, (0, $903670d025332df5$export$f7cb4f8454f0ce34).name) ?? '';
        this.display_name.value = data?.display_name?.substr(0, (0, $903670d025332df5$export$f7cb4f8454f0ce34).display_name) ?? '';
        this.brand_name.value = data?.brand_name?.substr(0, (0, $903670d025332df5$export$f7cb4f8454f0ce34).brand_name) ?? '';
        this.strength.value = data?.strength?.substr(0, (0, $903670d025332df5$export$f7cb4f8454f0ce34).strength) ?? '';
        this.route.value = data?.route?.substr(0, (0, $903670d025332df5$export$f7cb4f8454f0ce34).route) ?? '';
        this.form.value = data?.form?.substr(0, (0, $903670d025332df5$export$f7cb4f8454f0ce34).form) ?? '';
        this.rxcui.value = data?.rxcui?.toString() ?? '';
        if (data?.dose_and_frequency) {
            const input = this.closest('li')?.querySelector('input[name$="/dose_and_frequency"]');
            if (input) {
                input.value = data.dose_and_frequency;
                (0, $80a2320123ddcd02$export$89348ae70780cd7a)(input);
            }
        }
        if (data?.prescriber) {
            const input = this.closest('li')?.querySelector('input[name$="/prescriber"]');
            if (input) {
                input.value = data.prescriber;
                (0, $80a2320123ddcd02$export$89348ae70780cd7a)(input);
            }
        }
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.drugbank_pcid);
        // clear the search input.
        this.autocomplete.value = '';
        // clear the required input - so required validation will fire.
        this.valueInput.value = '';
        if (data?.drugbank_level === (data?.brand_name ? 5 : 4)) {
            // disable search
            this.autocomplete.src = '';
            this.autocomplete.open = false;
            // put a value in the required input so that the form will validate.
            this.valueInput.value = data.name;
            return;
        }
        // update the autocomplete source.
        this.autocomplete.src = (0, $903670d025332df5$export$54acbb69c3b90fd2)({
            organization_id: this.organization_id,
            person_id: this.person_id,
            activity_id: this.activity_id,
            medication: data
        });
        // refocus the input element, to prevent onAutocompleteLoadEnd from closing the menu.
        // this can happen when the user clicks on a result instead of using the keyboard.
        this.autocomplete.inputElement?.focus();
        // start a new search
        this.autocomplete.inputElement?.dispatchEvent(new CustomEvent('focus'));
        // keep the menu open and set it busy.
        this.autocomplete.open = true;
        this.autocomplete.forElement?.classList.add('btn-busy');
    }
    #log(...args) {
        if (location.hostname === 'local.cumulus.care') console.log('[medication-input]', ...args, this.autocomplete.src);
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dabf1640eccf4b9d$var$MedicationInputElement.prototype, "displaySpan", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dabf1640eccf4b9d$var$MedicationInputElement.prototype, "autocomplete", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dabf1640eccf4b9d$var$MedicationInputElement.prototype, "drugbank_pcid", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dabf1640eccf4b9d$var$MedicationInputElement.prototype, "drugbank_level", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dabf1640eccf4b9d$var$MedicationInputElement.prototype, "display_name", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dabf1640eccf4b9d$var$MedicationInputElement.prototype, "name", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dabf1640eccf4b9d$var$MedicationInputElement.prototype, "brand_name", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dabf1640eccf4b9d$var$MedicationInputElement.prototype, "strength", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dabf1640eccf4b9d$var$MedicationInputElement.prototype, "route", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dabf1640eccf4b9d$var$MedicationInputElement.prototype, "form", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dabf1640eccf4b9d$var$MedicationInputElement.prototype, "rxcui", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dabf1640eccf4b9d$var$MedicationInputElement.prototype, "valueInput", void 0);
$dabf1640eccf4b9d$var$MedicationInputElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('medication-input')
], $dabf1640eccf4b9d$var$MedicationInputElement);






const $b02cc3d0102fbd56$var$fragment = document.createElement('ul');
$b02cc3d0102fbd56$var$fragment.setAttribute('aria-label', 'Suggestions');
$b02cc3d0102fbd56$var$fragment.className = 'suggester suggester-container mt-1';
$b02cc3d0102fbd56$var$fragment.setAttribute('role', 'listbox');
class $b02cc3d0102fbd56$var$MedicationListQuestionElement extends HTMLElement {
    drugDrugInteractionsTimeout = 0;
    checkDrugDrugInteractions() {
        const ids = this.drugbankProductConceptInputs.map((x)=>x.value).filter((x)=>x).join(',');
        if (ids === this.getAttribute('drugbank-pcids')) return;
        clearTimeout(this.drugDrugInteractionsTimeout);
        setTimeout(async ()=>{
            const params = new URLSearchParams([
                [
                    'drugbank_pcids',
                    ids
                ],
                [
                    'target',
                    'medication-list-question.drugDrugInteractionsContent'
                ]
            ]);
            const url = new URL(`/api/medications/interactions?${params}`, location.origin);
            const response = await fetch(url);
            if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
            const el = this.drugDrugInteractionsContent;
            el.insertAdjacentHTML('afterend', await response.text());
            el.remove();
            this.setAttribute('drugbank-pcids', ids);
        }, 300);
    }
    valueInputFocused() {
        this.addButton.focus();
    }
    updateValueElement() {
        const newValue = String(this.listElement.children.length || ''); // encode zero as empty string
        if (this.valueInput.value !== newValue) {
            this.valueInput.value = newValue;
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.valueInput);
        }
    }
    providePrescribers({ detail: { provide: provide, relatedTarget: relatedTarget } }) {
        const q = relatedTarget.value.trim().toLowerCase();
        provide(Promise.resolve({
            suggestions: this.prescriberInputs.filter((x)=>x !== relatedTarget).map((x)=>x.value.trim()).filter((x, i, a)=>a.findIndex((y)=>(0, $50ac586a47aeec42$export$d9ffdbc590df6d8a)(y, x)) === i).filter((x)=>x.toLowerCase().includes(q)).sort((a, b)=>{
                const ai = $b02cc3d0102fbd56$var$clampIndex(a.toLowerCase().indexOf(q));
                const bi = $b02cc3d0102fbd56$var$clampIndex(b.toLowerCase().indexOf(q));
                return ai - bi || (0, $50ac586a47aeec42$export$d8dd5bf0f45452aa)(a, b);
            }).map((id)=>({
                    id: id,
                    title: id
                }))
        }));
    }
    provideAdherence({ detail: { provide: provide, relatedTarget: relatedTarget } }) {
        const q = relatedTarget.value.trim().toLowerCase();
        provide(Promise.resolve({
            suggestions: q.length === 0 ? (0, $903670d025332df5$export$511f44e01e024619) : (0, $903670d025332df5$export$511f44e01e024619).filter((x)=>x.title.toLowerCase().includes(q)).sort((a, b)=>{
                const ai = $b02cc3d0102fbd56$var$clampIndex(a.title.toLowerCase().indexOf(q));
                const bi = $b02cc3d0102fbd56$var$clampIndex(b.title.toLowerCase().indexOf(q));
                return ai - bi || (0, $50ac586a47aeec42$export$d8dd5bf0f45452aa)(a.title, b.title);
            })
        }));
    }
    provideFrequency({ detail: { provide: provide, relatedTarget: relatedTarget } }) {
        const pattern = /^ *(?:(take|give|apply|instill|inject|inhale) +)?(\d+(?:\.\d+|\/\d+)?)(?: +)?(\w+)?( +)?(\w+)?( +)?(\w+)?( +)?/i;
        const q = relatedTarget.value; // do not trim
        const [, verb, quantity, unit, unitDelim, route, routeDelim, frequency, frequencyDelim] = q.match(pattern) ?? [];
        this.#log(JSON.stringify({
            verb: verb,
            quantity: quantity,
            unit: unit,
            unitDelim: unitDelim,
            route: route,
            routeDelim: routeDelim,
            frequency: frequency,
            frequencyDelim: frequencyDelim
        }, null, 2));
        let options;
        let term;
        let template;
        if (frequencyDelim || $b02cc3d0102fbd56$var$frequencies.some((f)=>f.abbr === frequency)) {
            // completed - no suggestions
            options = [];
            term = '';
            template = ()=>'';
        } else if (routeDelim || $b02cc3d0102fbd56$var$routes.some((r)=>r.abbr === route?.toLowerCase())) {
            // suggest frequencies
            options = $b02cc3d0102fbd56$var$frequencies;
            term = frequency;
            template = ({ abbr: abbr })=>[
                    verb,
                    quantity,
                    unit,
                    route,
                    abbr
                ].join(' ').trim();
        } else if (unitDelim || $b02cc3d0102fbd56$var$units.some((u)=>u.abbr === unit)) {
            // suggest routes
            const routeSubset = $b02cc3d0102fbd56$var$units.find((x)=>x.abbr === unit.toLowerCase())?.routes;
            options = routeSubset ? $b02cc3d0102fbd56$var$routes.filter((x)=>routeSubset.includes(x.abbr)) : $b02cc3d0102fbd56$var$routes;
            term = route;
            template = ({ abbr: abbr })=>[
                    verb,
                    quantity,
                    unit,
                    abbr
                ].join(' ').trim() + ' ';
        } else if (quantity) {
            // suggest units
            const drugbankRoute = relatedTarget.closest('li')?.querySelector('input[name*="/route:"]')?.value ?? '';
            const unitSubset = $b02cc3d0102fbd56$var$routeToUnits[drugbankRoute] ?? [];
            options = $b02cc3d0102fbd56$var$units.filter((x)=>unitSubset.length === 0 || unitSubset.includes(x.abbr)).map((x)=>quantity === '1' ? x : {
                    abbr: x.abbr,
                    def: x.def + 's'
                });
            term = unit;
            template = ({ abbr: abbr })=>[
                    verb,
                    quantity,
                    abbr
                ].join(' ').trim() + ' ';
        } else {
            // no suggestions- do not need to suggest verbs, they're optional.
            options = [];
            term = '';
            template = ()=>'';
        }
        if (term) {
            const lowerTerm = term.toLowerCase();
            options = options.filter((x)=>x.abbr.toLowerCase().includes(term) || x.def.toLowerCase().includes(lowerTerm)).sort((a, b)=>{
                const ai = Math.min($b02cc3d0102fbd56$var$clampIndex(a.abbr.toLowerCase().indexOf(lowerTerm)), $b02cc3d0102fbd56$var$clampIndex(a.def.toLowerCase().indexOf(lowerTerm)));
                const bi = Math.min($b02cc3d0102fbd56$var$clampIndex(b.abbr.toLowerCase().indexOf(lowerTerm)), $b02cc3d0102fbd56$var$clampIndex(b.def.toLowerCase().indexOf(lowerTerm)));
                return ai - bi || (0, $50ac586a47aeec42$export$d8dd5bf0f45452aa)(a.abbr, b.abbr);
            });
        }
        provide(Promise.resolve({
            suggestions: options.map((x)=>({
                    id: template(x),
                    title: `${x.abbr}: ${x.def}`
                }))
        }));
    }
    #log(..._args) {
        if (location.hostname === 'local.cumulus.care') console.log('[medication-list-question]', ..._args);
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b02cc3d0102fbd56$var$MedicationListQuestionElement.prototype, "valueInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b02cc3d0102fbd56$var$MedicationListQuestionElement.prototype, "listElement", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b02cc3d0102fbd56$var$MedicationListQuestionElement.prototype, "addButton", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b02cc3d0102fbd56$var$MedicationListQuestionElement.prototype, "prescriberList", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $b02cc3d0102fbd56$var$MedicationListQuestionElement.prototype, "prescriberInputs", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $b02cc3d0102fbd56$var$MedicationListQuestionElement.prototype, "drugbankProductConceptInputs", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b02cc3d0102fbd56$var$MedicationListQuestionElement.prototype, "drugDrugInteractionsContent", void 0);
$b02cc3d0102fbd56$var$MedicationListQuestionElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('medication-list-question')
], $b02cc3d0102fbd56$var$MedicationListQuestionElement);
function $b02cc3d0102fbd56$var$clampIndex(n) {
    return n === -1 ? Number.MAX_SAFE_INTEGER : n;
}
// drugbank routes to units
const $b02cc3d0102fbd56$var$routeToUnits = {
    'Auricular (otic)': [
        'gtt',
        'mL'
    ],
    Buccal: [
        'tab',
        'mg',
        'mL'
    ],
    Conjunctival: [
        'gtt',
        'mL'
    ],
    Cutaneous: [
        'g',
        'mL',
        'patch'
    ],
    Dental: [
        'g',
        'mg',
        'mL'
    ],
    'Electro-osmosis': [
        'mg',
        'mL'
    ],
    Endocervical: [
        'g',
        'mg',
        'mL'
    ],
    Endosinusial: [
        'gtt',
        'mL'
    ],
    Endotracheal: [
        'mg',
        'mL'
    ],
    Enteral: [
        'tab',
        'cap',
        'mg',
        'mL'
    ],
    Epidural: [
        'mg',
        'mL',
        'IU'
    ],
    Extracorporeal: [
        'mg',
        'mL'
    ],
    Hemodialysis: [
        'mg',
        'mL',
        'IU'
    ],
    Infiltration: [
        'mg',
        'mL'
    ],
    Interstitial: [
        'mg',
        'mL'
    ],
    'Intra-amniotic': [
        'mg',
        'mL'
    ],
    'Intra-arterial': [
        'mg',
        'mL',
        'IU',
        'vial'
    ],
    'Intra-articular': [
        'mg',
        'mL'
    ],
    Intrabiliary: [
        'mg',
        'mL'
    ],
    Intrabronchial: [
        'mg',
        'mL',
        'puff'
    ],
    Intrabursal: [
        'mg',
        'mL'
    ],
    Intracardiac: [
        'mg',
        'mL',
        'IU'
    ],
    Intracaudal: [
        'mg',
        'mL'
    ],
    Intracavernous: [
        'mg',
        'mL'
    ],
    Intracavitary: [
        'mg',
        'mL'
    ],
    Intracerebral: [
        'mg',
        'mL'
    ],
    Intracisternal: [
        'mg',
        'mL'
    ],
    Intracoronary: [
        'mg',
        'mL'
    ],
    Intradermal: [
        'mg',
        'mL',
        'unit'
    ],
    Intradiscal: [
        'mg',
        'mL'
    ],
    Intraduodenal: [
        'mg',
        'mL'
    ],
    Intragastric: [
        'mg',
        'mL'
    ],
    Intraileal: [
        'mg',
        'mL'
    ],
    Intralesional: [
        'mg',
        'mL'
    ],
    Intramuscular: [
        'mg',
        'mL',
        'unit',
        'IU',
        'vial',
        'amp'
    ],
    Intraocular: [
        'gtt',
        'mg',
        'mL'
    ],
    Intraperitoneal: [
        'mg',
        'mL',
        'IU'
    ],
    Intrapleural: [
        'mg',
        'mL'
    ],
    Intrapulmonary: [
        'mg',
        'mL',
        'puff'
    ],
    Intraspinal: [
        'mg',
        'mL',
        'IU'
    ],
    Intrasynovial: [
        'mg',
        'mL'
    ],
    Intrathecal: [
        'mg',
        'mL'
    ],
    Intratumor: [
        'mg',
        'mL'
    ],
    Intrauterine: [
        'mg',
        'mL',
        'IU'
    ],
    Intravenous: [
        'mg',
        'mL',
        'unit',
        'IU',
        'vial',
        'amp'
    ],
    'Intravenous bolus': [
        'mg',
        'mL',
        'unit',
        'IU',
        'vial',
        'amp'
    ],
    'Intravenous drip': [
        'mg',
        'mL',
        'unit',
        'IU'
    ],
    Nasal: [
        'gtt',
        'mg',
        'mL',
        'puff'
    ],
    Nasogastric: [
        'mg',
        'mL'
    ],
    Ophthalmic: [
        'gtt',
        'mg',
        'mL'
    ],
    Oral: [
        'tab',
        'cap',
        'mg',
        'mL'
    ],
    Oropharyngeal: [
        'mg',
        'mL'
    ],
    Parenteral: [
        'mg',
        'mL',
        'unit',
        'IU',
        'vial',
        'amp'
    ],
    Percutaneous: [
        'g',
        'mL',
        'patch'
    ],
    Periodontal: [
        'mg',
        'mL'
    ],
    Rectal: [
        'mg',
        'mL',
        'supp'
    ],
    'Respiratory (inhalation)': [
        'mg',
        'mL',
        'puff'
    ],
    'Soft tissue': [
        'mg',
        'mL'
    ],
    Subcutaneous: [
        'mg',
        'mL',
        'unit',
        'IU',
        'vial',
        'amp'
    ],
    Sublingual: [
        'tab',
        'mg'
    ],
    Submucosal: [
        'mg',
        'mL'
    ],
    Topical: [
        'g',
        'mL',
        'patch'
    ],
    Transdermal: [
        'mg',
        'mL',
        'patch'
    ],
    Transmucosal: [
        'mg',
        'mL'
    ],
    Urethral: [
        'mg',
        'mL',
        'supp'
    ],
    Vaginal: [
        'mg',
        'mL',
        'g',
        'supp'
    ] // Creams, tablets, suppositories
};
// Unit abbreviations
const $b02cc3d0102fbd56$var$units = [
    {
        abbr: 'tab',
        def: 'Tablet',
        routes: [
            'po',
            'sl',
            'pr'
        ]
    },
    {
        abbr: 'cap',
        def: 'Capsule',
        routes: [
            'po',
            'sl',
            'pr'
        ]
    },
    {
        abbr: 'gtt',
        def: 'Drop',
        routes: [
            'po',
            'sl',
            'pr',
            'iv',
            'top',
            'od',
            'os',
            'ou',
            'ad',
            'as',
            'au'
        ]
    },
    {
        abbr: 'mcg',
        def: 'Microgram',
        routes: [
            'po',
            'iv',
            'im',
            'sc',
            'inh'
        ]
    },
    {
        abbr: 'mg',
        def: 'Milligram',
        routes: [
            'po',
            'iv',
            'im',
            'sc',
            'inh',
            'top',
            'pr'
        ]
    },
    {
        abbr: 'g',
        def: 'Gram',
        routes: [
            'po',
            'top',
            'pr'
        ]
    },
    {
        abbr: 'mEq',
        def: 'Milliequivalent',
        routes: [
            'po',
            'iv'
        ]
    },
    {
        abbr: 'mL',
        def: 'Milliliter',
        routes: [
            'po',
            'iv',
            'im',
            'sc',
            'id',
            'pr',
            'top',
            'inh'
        ]
    },
    {
        abbr: 'unit',
        def: 'Unit',
        routes: [
            'sc',
            'iv',
            'im'
        ]
    },
    {
        abbr: 'puff',
        def: 'Puff',
        routes: [
            'inh',
            'nasal'
        ]
    },
    {
        abbr: 'patch',
        def: 'Transdermal Patch',
        routes: [
            'transdermal',
            'top'
        ]
    },
    {
        abbr: 'IU',
        def: 'International Unit',
        routes: [
            'iv',
            'im',
            'sc'
        ]
    },
    {
        abbr: 'supp',
        def: 'Suppository',
        routes: [
            'pr',
            'vag'
        ]
    },
    {
        abbr: 'amp',
        def: 'Ampule',
        routes: [
            'iv',
            'im',
            'sc'
        ]
    },
    {
        abbr: 'vial',
        def: 'Vial',
        routes: [
            'iv',
            'im',
            'sc'
        ]
    } // Administer 1 vial IM q4w
];
// Route of Administration Abbreviations
const $b02cc3d0102fbd56$var$routes = [
    {
        abbr: 'po',
        def: 'By mouth'
    },
    {
        abbr: 'sl',
        def: 'Sublingual'
    },
    {
        abbr: 'im',
        def: 'Intramuscular'
    },
    {
        abbr: 'iv',
        def: 'Intravenous'
    },
    {
        abbr: 'sc',
        def: 'Subcutaneous'
    },
    {
        abbr: 'pr',
        def: 'Per rectum'
    },
    {
        abbr: 'id',
        def: 'Intradermal'
    },
    {
        abbr: 'inh',
        def: 'Inhaled'
    },
    {
        abbr: 'top',
        def: 'Topical'
    },
    {
        abbr: 'od',
        def: 'Right eye'
    },
    {
        abbr: 'os',
        def: 'Left eye'
    },
    {
        abbr: 'ou',
        def: 'Both eyes'
    },
    {
        abbr: 'ad',
        def: 'Right ear'
    },
    {
        abbr: 'as',
        def: 'Left ear'
    },
    {
        abbr: 'au',
        def: 'Both ears'
    } // Instill 2 gtt AU bid
];
// Time & Frequency Abbreviations
const $b02cc3d0102fbd56$var$frequencies = [
    {
        abbr: 'qd',
        def: 'Once daily'
    },
    {
        abbr: 'bid',
        def: 'Twice daily'
    },
    {
        abbr: 'tid',
        def: 'Three times daily'
    },
    {
        abbr: 'qid',
        def: 'Four times daily'
    },
    // { abbr: 'qod', def: 'Every other day (discouraged)' }, // Take 1 tab po qod
    {
        abbr: 'qam',
        def: 'Every morning'
    },
    {
        abbr: 'qpm',
        def: 'Every evening'
    },
    {
        abbr: 'qhs',
        def: 'Every night at bedtime'
    },
    {
        abbr: 'q1h',
        def: 'Every hour'
    },
    {
        abbr: 'q2h',
        def: 'Every 2 hours'
    },
    {
        abbr: 'q3h',
        def: 'Every 3 hours'
    },
    {
        abbr: 'q4h',
        def: 'Every 4 hours'
    },
    {
        abbr: 'q6h',
        def: 'Every 6 hours'
    },
    {
        abbr: 'q8h',
        def: 'Every 8 hours'
    },
    {
        abbr: 'qwk',
        def: 'Every week'
    },
    {
        abbr: 'prn',
        def: 'As needed'
    },
    {
        abbr: 'stat',
        def: 'Immediately'
    },
    {
        abbr: 'ac',
        def: 'Before meals'
    },
    {
        abbr: 'pc',
        def: 'After meals'
    } // Take 1 tab po PC
];




class $ab14b351307fabed$export$f58ae03993ef5132 extends HTMLElement {
    templateSlot;
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: 'open'
        });
        this.templateSlot = document.createElement('slot');
        this.templateSlot.name = 'template';
        shadow.append(document.createElement('slot'), this.templateSlot);
    }
    connectedCallback() {
        this.querySelector('button')?.addEventListener('click', this);
        if (this.hasAttribute('open-modal')) this.open();
    }
    disconnectedCallback() {
        this.querySelector('button')?.removeEventListener('click', this);
    }
    handleEvent(event) {
        if (event.target instanceof Element && event.target.closest(':disabled')) return;
        this.open();
    }
    open() {
        const document1 = this.ownerDocument;
        const template = this.templateSlot.assignedElements()[0];
        const src = this.getAttribute('src');
        let content;
        if (!template) {
            if (src) {
                const frag = document1.createElement('include-fragment');
                frag.src = src;
                content = frag;
            } else throw new Error('Part "template" or attribute "src" is required.');
        } else if (!(template instanceof HTMLTemplateElement)) throw new Error('Part "template" is not an HTMLTemplateElement');
        else {
            content = template.content.cloneNode(true);
            if (src) content.querySelector('include-fragment').src = src;
        }
        if (!this.id) this.id = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
        const modal = document1.createElement('modal-content');
        modal.setAttribute('controller-id', this.id);
        modal.append(content);
        document1.body.append(modal);
    }
}
if (!window.customElements.get('modal-controller')) {
    window.ModalControllerElement = $ab14b351307fabed$export$f58ae03993ef5132;
    window.customElements.define('modal-controller', $ab14b351307fabed$export$f58ae03993ef5132);
}






class $992042a088c325cf$export$5bfad2f7bf9699f7 extends HTMLElement {
    get parametric() {
        return this.hasAttribute('parametric');
    }
    connectedCallback() {
        this.addEventListener('change', this);
        this.addEventListener('blur', this, {
            capture: true
        });
        if (this.hasAttribute('parametric')) this.addEventListener('focus', this, {
            capture: true
        });
    }
    disconnectedCallback() {
        this.removeEventListener('change', this);
        this.removeEventListener('blur', this, {
            capture: true
        });
        this.removeEventListener('focus', this, {
            capture: true
        });
    }
    handleEvent(event) {
        const input = event.target instanceof HTMLInputElement && event.target === this.firstElementChild && event.target;
        if (!input) return;
        if (event.type === 'change' || event.type === 'blur') {
            const value = parseFloat(input.value);
            if (!isFinite(value)) {
                if (this.parametric && (0, $413788c7d08dddf5$export$99da40ee05a17718).test(input.value.toUpperCase())) input.value = input.value.toUpperCase();
                return;
            }
            // format the value to the specified number of digits
            const minimumFractionDigits = parseInt(this.getAttribute('minimum-fraction-digits') ?? '0', 10);
            const maximumFractionDigits = parseInt(this.getAttribute('maximum-fraction-digits') ?? minimumFractionDigits.toString(), 10);
            const formatted = new Intl.NumberFormat('en-us', {
                useGrouping: false,
                minimumFractionDigits: minimumFractionDigits,
                maximumFractionDigits: maximumFractionDigits,
                roundingMode: 'floor'
            }).format(value);
            if (input.value !== formatted) {
                input.value = formatted;
                (0, $80a2320123ddcd02$export$89348ae70780cd7a)(input);
            }
        } else if (event.type === 'focus') {
            if (!this.parametric || !input.list || !input.form) return;
            const parameters = (0, $82003cd051bc5cad$export$149e10162b59b4e2)(input);
            if (!parameters?.length) return;
            input.list.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)(parameters.map((x)=>(0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<option value="${x.name}">${x.name}</option>`));
        }
    }
}
if (!window.customElements.get('number-input')) {
    window.NumberInputElement = $992042a088c325cf$export$5bfad2f7bf9699f7;
    window.customElements.define('number-input', $992042a088c325cf$export$5bfad2f7bf9699f7);
}
(0, $84fd3dc30499b2d0$export$86f1725708ac86dc)((input, label)=>{
    if (input instanceof HTMLInputElement && input.type === 'text' && input.value.length && input.parentElement instanceof $992042a088c325cf$export$5bfad2f7bf9699f7) {
        const value = input.value;
        if (input.parentElement.parametric) {
            const result = (0, $82003cd051bc5cad$export$9c08897bbef487d2)(input, [
                value
            ]);
            return result.valid ? null : result.message;
        }
        const num = parseFloat(value);
        if (isFinite(num)) return null;
        return `${label} is invalid.`;
    }
    return null;
});




class $ef98f2e1a04a7e57$export$dcd314c2ee8251f2 extends HTMLElement {
    #observer = new ResizeObserver(()=>this.scheduleUpdate());
    #timeout = 0;
    connectedCallback() {
        this.#observer.observe(this);
        this.update();
    }
    disconnectedCallback() {
        this.#observer.disconnect();
    }
    scheduleUpdate() {
        clearTimeout(this.#timeout);
        this.#timeout = setTimeout(()=>this.update(), 0);
    }
    update() {
        clearTimeout(this.#timeout);
        for (const item of this.items)item.hidden = false;
        this.more.hidden = true;
        this.moreMenuList.innerHTML = '';
        if (this.itemsContainer.scrollWidth <= this.itemsContainer.clientWidth) return;
        this.more.hidden = false;
        for(let i = this.items.length - 1; i >= 0; i--){
            const item = this.items[i];
            const overflowItem = item.cloneNode(true);
            overflowItem.removeAttribute('data-targets');
            overflowItem.role = 'menuitem';
            overflowItem.className = 'SelectMenu-item';
            this.moreMenuList.prepend(overflowItem);
            item.hidden = true;
            if (this.itemsContainer.scrollWidth <= this.itemsContainer.clientWidth) break;
        }
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ef98f2e1a04a7e57$export$dcd314c2ee8251f2.prototype, "more", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ef98f2e1a04a7e57$export$dcd314c2ee8251f2.prototype, "moreMenuList", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ef98f2e1a04a7e57$export$dcd314c2ee8251f2.prototype, "itemsContainer", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $ef98f2e1a04a7e57$export$dcd314c2ee8251f2.prototype, "items", void 0);
$ef98f2e1a04a7e57$export$dcd314c2ee8251f2 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('overflow-nav')
], $ef98f2e1a04a7e57$export$dcd314c2ee8251f2);


class $5041e7687f8b0989$export$58667bf9645f93c6 extends HTMLElement {
    connectedCallback() {
        this.addEventListener('input', $5041e7687f8b0989$var$setParam);
    }
    disconnectedCallback() {
        this.removeEventListener('input', $5041e7687f8b0989$var$setParam);
    }
}
function $5041e7687f8b0989$var$setParam({ target: target }) {
    if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) {
        const url = new URL(location.href);
        if (target.value === '') url.searchParams.delete(target.name);
        else url.searchParams.set(target.name, target.value);
        if (url.href !== location.href) history.replaceState(null, '', url.href);
    }
}
if (!window.customElements.get('param-input')) {
    window.ParamInputElement = $5041e7687f8b0989$export$58667bf9645f93c6;
    window.customElements.define('param-input', $5041e7687f8b0989$export$58667bf9645f93c6);
}






class $90ad0ed41ee6741b$var$PayerFileClaimAcknowledgmentsElement extends (0, $57fe493949b5746c$export$cd175f1e676ad8c5) {
    getGridOptions() {
        const columnDefs = [
            {
                field: 'submitter_claim_control_number',
                headerName: 'Claim',
                cellRenderer: ({ data: data, value: value })=>(0, $351a75c58523baeb$export$2ca3ffb384919372)(data?.claim_href, value, 'View claim'),
                width: 135,
                minWidth: 135,
                suppressSizeToFit: true
            },
            {
                colId: 'patient',
                headerName: 'Patient',
                valueGetter: ({ data: data })=>$90ad0ed41ee6741b$var$patientName(data),
                tooltipValueGetter: ({ data: data })=>$90ad0ed41ee6741b$var$patientName(data),
                flex: 1,
                minWidth: 190
            },
            {
                field: 'effective_date',
                headerName: 'Effective',
                valueFormatter: ({ value: value })=>(0, $351a75c58523baeb$export$f1c5692dadbf0f5b)(value),
                width: 130
            },
            {
                colId: 'category',
                headerName: 'Category',
                valueGetter: ({ data: data })=>(0, $351a75c58523baeb$export$dd6cce92da24784f)(data?.category_code, data?.category_description),
                cellRenderer: ({ data: data })=>(0, $351a75c58523baeb$export$e802828074a0736e)(data?.category_code, data?.category_description),
                tooltipField: 'category_description',
                wrapText: true,
                autoHeight: true,
                flex: 2,
                minWidth: 360
            },
            {
                colId: 'status',
                headerName: 'Status',
                valueGetter: ({ data: data })=>(0, $351a75c58523baeb$export$dd6cce92da24784f)(data?.status_code, data?.status_description),
                cellRenderer: ({ data: data })=>(0, $351a75c58523baeb$export$e802828074a0736e)(data?.status_code, data?.status_description),
                tooltipField: 'status_description',
                wrapText: true,
                autoHeight: true,
                flex: 1,
                minWidth: 250
            },
            {
                field: 'status_message',
                headerName: 'Message',
                tooltipField: 'status_message',
                wrapText: true,
                autoHeight: true,
                flex: 2,
                minWidth: 320
            },
            {
                field: 'payer_claim_control_number',
                headerName: 'Payer claim control',
                tooltipField: 'payer_claim_control_number',
                width: 220
            },
            {
                field: 'clearinghouse_trace_number',
                headerName: 'Trace',
                tooltipField: 'clearinghouse_trace_number',
                width: 180
            }
        ];
        return {
            getRowId: ({ data: data })=>data.claim_acknowledgment_entry_id,
            columnDefs: columnDefs
        };
    }
}
$90ad0ed41ee6741b$var$PayerFileClaimAcknowledgmentsElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('payer-file-claim-acknowledgments')
], $90ad0ed41ee6741b$var$PayerFileClaimAcknowledgmentsElement);
function $90ad0ed41ee6741b$var$patientName(row) {
    return [
        row?.patient_first_name,
        row?.patient_last_name
    ].filter(Boolean).join(' ');
}







class $2e48b32306707fd7$var$PayerFileRemittanceClaimsElement extends (0, $57fe493949b5746c$export$cd175f1e676ad8c5) {
    getGridOptions() {
        const columnDefs = [
            {
                field: 'submitter_claim_control_number',
                headerName: 'Claim',
                cellRenderer: ({ data: data, value: value })=>(0, $351a75c58523baeb$export$2ca3ffb384919372)(data?.claim_href, value),
                width: 135,
                minWidth: 135,
                suppressSizeToFit: true
            },
            {
                field: 'person_full_name',
                headerName: 'Person',
                tooltipField: 'person_full_name',
                flex: 1,
                minWidth: 190
            },
            {
                colId: 'claim_batch',
                headerName: 'Claim batch',
                valueGetter: ({ data: data })=>$2e48b32306707fd7$var$claimBatchLabel(data),
                cellRenderer: $2e48b32306707fd7$var$claimBatchRenderer,
                tooltipValueGetter: ({ data: data })=>$2e48b32306707fd7$var$claimBatchTooltip(data),
                wrapText: true,
                autoHeight: true,
                flex: 1,
                minWidth: 230
            },
            {
                colId: 'status',
                headerName: 'Status',
                valueGetter: ({ data: data })=>(0, $351a75c58523baeb$export$dd6cce92da24784f)(data?.claim_status_code, data?.claim_status_description),
                cellRenderer: ({ data: data })=>(0, $351a75c58523baeb$export$e802828074a0736e)(data?.claim_status_code, data?.claim_status_description),
                tooltipField: 'claim_status_description',
                wrapText: true,
                autoHeight: true,
                flex: 1,
                minWidth: 230
            },
            {
                field: 'adjudication_date',
                headerName: 'Adjudication',
                valueFormatter: ({ value: value })=>(0, $351a75c58523baeb$export$f1c5692dadbf0f5b)(value),
                width: 145
            },
            {
                field: 'submitted_charge_amount',
                headerName: 'Submitted',
                type: 'numericColumn',
                valueFormatter: ({ value: value })=>$2e48b32306707fd7$var$formatCurrency(value),
                width: 135
            },
            {
                field: 'paid_amount',
                headerName: 'Paid',
                type: 'numericColumn',
                valueFormatter: ({ value: value })=>$2e48b32306707fd7$var$formatCurrency(value),
                width: 125
            },
            {
                field: 'patient_responsibility_amount',
                headerName: 'Patient responsibility',
                type: 'numericColumn',
                valueFormatter: ({ value: value })=>$2e48b32306707fd7$var$formatCurrency(value),
                width: 190
            },
            {
                field: 'payer_claim_control_number',
                headerName: 'Payer claim control',
                tooltipField: 'payer_claim_control_number',
                width: 220
            }
        ];
        return {
            getRowId: ({ data: data })=>data.remittance_claim_id,
            columnDefs: columnDefs
        };
    }
}
$2e48b32306707fd7$var$PayerFileRemittanceClaimsElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('payer-file-remittance-claims')
], $2e48b32306707fd7$var$PayerFileRemittanceClaimsElement);
function $2e48b32306707fd7$var$claimBatchLabel(row) {
    if (!row?.claim_batch_id) return 'Unmatched';
    return [
        row.claim_configuration_title ?? 'Claim batch',
        (0, $351a75c58523baeb$export$33708deee81cf1d8)(row.billing_period_start, row.billing_period_end),
        row.project_login
    ].filter(Boolean).join(' ');
}
function $2e48b32306707fd7$var$claimBatchRenderer({ data: data }) {
    if (!data?.claim_batch_id || !data.claim_batch_href) {
        const unmatched = document.createElement('span');
        unmatched.className = 'color-fg-muted';
        unmatched.textContent = 'Unmatched';
        return unmatched;
    }
    const container = document.createElement('span');
    const link = document.createElement('a');
    link.href = data.claim_batch_href;
    link.textContent = data.claim_configuration_title ?? 'View claim batch';
    container.append(link);
    const context = [
        (0, $351a75c58523baeb$export$33708deee81cf1d8)(data.billing_period_start, data.billing_period_end),
        data.project_login
    ].filter(Boolean).join(" \xb7 ");
    if (context) {
        const contextElement = document.createElement('span');
        contextElement.className = 'd-block color-fg-muted';
        contextElement.textContent = context;
        container.append(contextElement);
    }
    return container;
}
function $2e48b32306707fd7$var$claimBatchTooltip(row) {
    if (!row?.claim_batch_id) return 'No matching Cumulus claim';
    return [
        (0, $351a75c58523baeb$export$33708deee81cf1d8)(row.billing_period_start, row.billing_period_end),
        row.project_login
    ].filter(Boolean).join(" \xb7 ");
}
function $2e48b32306707fd7$var$formatCurrency(value) {
    if (value === null || value === undefined || value === '') return '';
    return (0, $5e22b13d8e41f6dd$export$4670d0ed237a9270).format(Number(value));
}






class $920337ed2e589901$export$d864f015ee5ac896 extends HTMLElement {
    async fileAttachmentAccepted(event) {
        const uploadHref = this.getAttribute('upload-href');
        if (!uploadHref) throw new Error('Missing upload href');
        const uploadUrl = new URL(uploadHref, location.origin);
        const payerFileId = crypto.randomUUID();
        uploadUrl.searchParams.set('owner_id', payerFileId);
        try {
            this.fileInput.disabled = true;
            this.fileInput.labels?.forEach((label)=>label.classList.add('btn-busy'));
            await (0, $4ab5d79d76486e1b$export$14d3a7d22f26659e)({
                locale: (0, $c74c4f773f8a11f2$export$180605366c04f0cd)(),
                attachments: event.detail.attachments,
                uploadUrl: uploadUrl,
                attachmentSaved: ({ id: id })=>{
                    const { origin: origin, pathname: pathname } = location;
                    location.href = `${origin}${pathname}/new?payer_file_id=${encodeURIComponent(payerFileId)}&attachment_id=${encodeURIComponent(id)}`;
                }
            });
        } finally{
            this.fileInput.disabled = false;
            this.fileInput.labels?.forEach((label)=>label.classList.remove('btn-busy'));
        }
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $920337ed2e589901$export$d864f015ee5ac896.prototype, "fileInput", void 0);
$920337ed2e589901$export$d864f015ee5ac896 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('payer-file-upload')
], $920337ed2e589901$export$d864f015ee5ac896);












function $0f19b6a07911d9cc$export$8e2ee32c32a0ef22(attrs = {}) {
    let value = '';
    if (attrs.value instanceof Date) value = (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format(attrs.value);
    else if (attrs.value) value = attrs.value;
    const inputId = attrs.id ?? (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    const listId = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    // js will set label of hidden input and unhide
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`
    <input
      type="date"
      form="undefined-form"
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('value', attrs.value instanceof Date ? attrs.value.toISOString().substr(0, 10) : null)}
      tabindex="-1"
      hidden
      data-target="date-input.pickerInput"
      data-action="change:date-input#handlePickerInputChange"
      style="
        width: 0;
        max-width: 0;
        max-height: 1px;
        margin-bottom: -4px;
        align-self: end;
        overflow: hidden;
        -webkit-appearance: none;
        padding: 0;
        border: none;
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
      "
    />
    <input
      class="form-control ${attrs.small ? 'input-sm' : ''} mr-1"
      id="${inputId}"
      type="text"
      autocomplete="${attrs.autocomplete ?? 'off'}"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      list="${listId}"
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('name', attrs.name)}
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('value', value)}
      ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', attrs.required)}
      ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', attrs.disabled)}
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', attrs.form)}
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-label', attrs.ariaLabel)}
      ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', attrs.describedBy)}
      ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', attrs.autofocus)}
      ${attrs.inputAttrs?.map((x, i)=>[
            i == 0 ? null : ' ',
            x
        ])}
      data-target="date-input.input ${attrs.target}"
      data-action="${[
        'change:date-input#handleInputChange',
        'blur:date-input#handleInputChange',
        'input:date-input#updateSuggestions',
        'focus:date-input#updateSuggestions',
        attrs.action
    ].join(' ')}"
    />
    <datalist id="${listId}"></datalist>
    <button
      class="btn ${attrs.small ? 'btn-sm' : ''} d-print-none"
      type="button"
      aria-label="Show calendar"
      data-action="click:date-input#showPicker"
      ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('hidden', attrs.disabled)}
    >
      ${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$2daa3271a740c7f))}
    </button>
  `;
}



function $13cfdc572434acbd$export$6db68b231e9eddb6(locale) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`&nbsp;<span
      class="form-group-required-asterisk"
      title="${(0, $b11db1b62d4a8f76$export$bf155eef9c17fa3b)[locale]}"
      ><span aria-hidden="true">*</span
      ><span class="sr-only">(required)</span></span
    >`;
}
function $13cfdc572434acbd$export$bdc7259586f8f739(config) {
    let { locale: locale = (0, $12c3f7ece07822ce$export$d7f512c98c859244), name: name, label: label, required: required = false, classes: classes = '', headerClasses: headerClasses = '', description: description, describedBy: describedBy, attrs: attrs, disabled: disabled = false, id: id = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)(), form: form, small: small = false, target: target, action: action, inputAttrs: inputAttrs, autofocus: autofocus = false } = config;
    const descriptionId = description ? (0, $65af17b6a828fccf$export$9e1c824dbb29e809)() : '';
    describedBy = describedBy ? descriptionId ? `${describedBy} ${descriptionId}` : describedBy : descriptionId;
    const desc = description ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<p class="note" id="${descriptionId}">${description}</p>` : null;
    let input;
    switch(config.type){
        case 'name':
        case 'text':
        case 'search':
            {
                const { value: value = '', spellcheck: spellcheck = true, maxLength: maxLength, minLength: minLength, autocomplete: autocomplete = 'off', autocompleteList: autocompleteList, inputClasses: inputClasses, inputWrapper: inputWrapper = (content)=>content } = config;
                input = inputWrapper((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
            class="form-control${small ? ' input-sm' : ''}${inputClasses ? ` ${inputClasses}` : ''}"
            id="${id}"
            name="${name}"
            type="${config.type === 'search' ? 'search' : 'text'}"
            value="${value}"
            spellcheck="${spellcheck}"
            autocomplete="${autocomplete}"
            autocapitalize="${config.type === 'name' ? 'words' : config.type === 'search' ? 'off' : 'sentences'}"
            maxlength="${maxLength}"
            ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('minlength', minLength?.toString())}
            ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
            ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
            ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
            ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
            ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
            ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
            ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
            ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : ' ',
                        x
                    ])}
          />${autocompleteList}`);
                break;
            }
        case 'email':
            {
                const { value: value = '', autocomplete: autocomplete = 'off', maxLength: maxLength = 256 } = config;
                input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? ' input-sm' : ''}"
        id="${id}"
        name="${name}"
        type="email"
        value="${value}"
        autocomplete="${autocomplete}"
        minlength="4"
        maxlength="${maxLength}"
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : ' ',
                        x
                    ])}
      />`;
                break;
            }
        case 'url':
            {
                const { value: value = '', https: https = true, minLength: minLength = 14, maxLength: maxLength, autocomplete: autocomplete = 'off' } = config;
                const anchorId = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
                input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<url-field class="d-flex gap-1">
        <input
          class="form-control${small ? ' input-sm' : ''}"
          id="${id}"
          name="${name}"
          type="url"
          value="${value}"
          autocomplete="${autocomplete}"
          pattern="${https ? 'https' : 'http(s)?'}://.*"
          minlength="${minLength}"
          maxlength="${maxLength}"
          ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
          ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
          ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
          data-target="url-field.input ${target}"
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
          ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : ' ',
                        x
                    ])}
        />
        <clipboard-copy
          class="btn${small ? ' btn-sm' : ''}"
          for="${id}"
          aria-label="${(0, $b11db1b62d4a8f76$export$5f486e535de293fa)[locale]}"
          aria-disabled="${!value}"
          data-target="url-field.copy"
          >${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$e3d4d49f14b4dd60))}</clipboard-copy
        >
        <a
          class="btn${small ? ' btn-sm' : ''}"
          aria-label="${(0, $b11db1b62d4a8f76$export$41e323ff2c7efe95)[locale]}"
          aria-disabled="${!value}"
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('href', value)}
          id="${anchorId}"
          data-target="url-field.anchor"
          >${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$5df4efc90df1058f))}</a
        >
      </url-field>`;
                break;
            }
        case 'login':
            {
                const { value: value = '', maxLength: maxLength = (0, $e82d6689c5c2f33e$export$1514431ed310ac1b), autocomplete: autocomplete = 'off' } = config;
                input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? ' input-sm' : ''}"
        id="${id}"
        name="${name}"
        type="text"
        value="${value}"
        autocomplete="${autocomplete}"
        maxlength="${maxLength}"
        validate-login
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : ' ',
                        x
                    ])}
      />`;
                break;
            }
        case 'password':
            {
                const autocomplete = 'new-password';
                input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? ' input-sm' : ''}"
        id="${id}"
        name="${name}"
        type="password"
        autocomplete="${autocomplete}"
        minlength="${0, $e82d6689c5c2f33e$export$c1524f9be65f4b8a}"
        maxlength="${0, $e82d6689c5c2f33e$export$9ea34356f788bd3a}"
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : ' ',
                        x
                    ])}
      />`;
                break;
            }
        case 'textarea':
            {
                const { value: value = '', spellcheck: spellcheck = true, maxLength: maxLength, minLength: minLength, rows: rows = Math.min(Math.max(Math.floor(maxLength / 125), 1), 8), placeholder: placeholder, inputClasses: inputClasses } = config;
                input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<textarea
        class="form-control${small ? ' input-sm' : ''} field-sizing-content ${`textarea-rows-${rows}`} ${inputClasses}"
        id="${id}"
        name="${name}"
        autocapitalize="sentences"
        autocomplete="off"
        maxlength="${maxLength}"
        spellcheck="${spellcheck}"
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('minlength', minLength?.toString())}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('placeholder', placeholder)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : ' ',
                        x
                    ])}
      >
${value}</textarea>`;
                break;
            }
        case 'select':
            {
                const { value: value = '', options: options, inputClasses: inputClasses } = config;
                const opts = $13cfdc572434acbd$export$d3199b8dddc55be(options, value);
                if (options.length === 0) {
                    classes += ' form-group--empty-select';
                    opts.unshift($13cfdc572434acbd$var$selectOptionTemplate('', '', '', false));
                } else if (!required && !options.find((x)=>x.value === '')) opts.unshift($13cfdc572434acbd$var$selectOptionTemplate('', '', value, false));
                input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<select
        class="form-select${small ? ' select-sm' : ''} ${inputClasses}"
        id="${id}"
        name="${name}"
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : ' ',
                        x
                    ])}
      >
        ${opts}
      </select>`;
                break;
            }
        case 'rich-select':
            {
                const { value: value = '', options: options, small: small, menuWidthClass: menuWidthClass, summaryId: summaryId } = config;
                const opts = Array.from(options);
                const none = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="color-fg-muted text-italic">None</span>`;
                if (opts.length === 0) {
                    classes += ' form-group--empty-select';
                    opts.unshift({
                        value: '',
                        text: none,
                        disabled: disabled
                    });
                } else if (!required && !opts.find((x)=>x.value === '')) opts.unshift({
                    value: '',
                    text: none,
                    disabled: disabled
                });
                const cur = opts.find((o)=>o.value === value);
                if (!cur) throw new Error(`Option with value matching ${JSON.stringify(value)} not found.`);
                const summaryContent = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="sr-only">${label}:</span>
        <span class="flex-1" data-menu-button style="min-width: 0"
          >${cur.text}</span
        >
        <span class="dropdown-caret"></span>`;
                if (disabled) input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span
          class="form-control${small ? ' input-sm' : ''} d-flex flex-items-center gap-2"
          disabled
          >${summaryContent}</span
        >`;
                else {
                    const filterTargetId = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
                    input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<details
          class="details-reset details-overlay position-relative"
          id="${id}"
        >
          <summary
            class="form-control${small ? ' input-sm' : ''} d-flex flex-items-center gap-2"
            style="scroll-margin-top: 60px"
            ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('id', summaryId)}
            ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
            ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
            ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
            ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
          >
            ${summaryContent}
          </summary>
          <details-menu
            class="SelectMenu min-width-full ${opts.length > 6 ? 'SelectMenu--hasFilter' : ''}"
            role="menu"
          >
            <div class="SelectMenu-modal min-width-full ${menuWidthClass}">
              <header class="SelectMenu-header">
                <h3 class="SelectMenu-title">Select ${label}</h3>
                <button
                  class="SelectMenu-closeButton"
                  type="button"
                  data-toggle-for="${id}"
                  aria-label="Close menu"
                >
                  ${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$4d48f840957dea1b))}
                </button>
              </header>
              <filter-input
                class="SelectMenu-filter"
                aria-owns="${filterTargetId}"
                ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('hidden', opts.length <= 6)}
              >
                <input
                  class="SelectMenu-input form-control"
                  type="text"
                  autofocus
                  autocomplete="off"
                  placeholder="Filter"
                  aria-label="Filter"
                  form="undefined-form"
                />
              </filter-input>
              <div
                class="SelectMenu-list"
                id="${filterTargetId}"
                data-filter-list
              >
                ${opts.map((o)=>(0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<label
                      class="SelectMenu-item"
                      role="menuitemradio"
                      aria-checked="${o.value === value}"
                      tabindex="0"
                    >
                      ${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$1d8a03084661a191), 'SelectMenu-icon SelectMenu-icon--check f4')}
                      <input
                        class="sr-only"
                        type="radio"
                        name="${name}"
                        value="${o.value}"
                        tabindex="-1"
                        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('checked', o.value === value)}
                        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
                        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
                        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
                        ${inputAttrs?.map((x, i)=>[
                                i == 0 ? null : ' ',
                                x
                            ])}
                      />
                      ${o.description ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span
                              ><span
                                data-menu-button-contents
                                style="min-width: 0"
                                >${o.text}</span
                              ><span
                                class="text-normal color-fg-muted f6 d-block"
                                style="min-width: 0"
                                >${o.description}</span
                              ></span
                            >` : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span
                              data-menu-button-contents
                              style="min-width: 0"
                              >${o.text}</span
                            >`}
                    </label>`)}
              </div>
            </div>
          </details-menu>
        </details>`;
                }
                break;
            }
        case 'remote-rich-select':
            {
                const { value: value, src: src, small: small, menuAction: menuAction, footerContent: footerContent, menuWidthClass: menuWidthClass, summaryId: summaryId } = config;
                const summaryContent = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="sr-only">${label}:</span>
        <span class="flex-1" data-menu-button style="min-width: 0"
          >${value}</span
        >
        <span class="dropdown-caret"></span>`;
                if (disabled) input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span
          class="form-control${small ? ' input-sm' : ''} d-flex flex-items-center gap-2"
          disabled
          >${summaryContent}</span
        >`;
                else {
                    const filterTargetId = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
                    input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<details
          class="details-reset details-overlay position-relative"
          id="${id}"
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
        >
          <summary
            class="form-control${small ? ' input-sm' : ''} d-flex flex-items-center gap-2"
            ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('id', summaryId)}
            ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
            ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
          >
            ${summaryContent}
          </summary>
          <details-menu
            class="SelectMenu SelectMenu--hasFilter min-width-full"
            role="menu"
            ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', menuAction)}
          >
            <div class="SelectMenu-modal min-width-full ${menuWidthClass}">
              <header class="SelectMenu-header">
                <h3 class="SelectMenu-title">Select ${label}</h3>
                <button
                  class="SelectMenu-closeButton"
                  type="button"
                  data-toggle-for="${id}"
                  aria-label="Close menu"
                >
                  ${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$4d48f840957dea1b))}
                </button>
              </header>
              <remote-input
                class="SelectMenu-filter"
                aria-owns="${filterTargetId}"
                src="${src}"
              >
                <input
                  class="SelectMenu-input form-control"
                  type="text"
                  autofocus
                  autocomplete="off"
                  placeholder="Search..."
                  aria-label="Search"
                  maxlength="100"
                  form="undefined-form"
                />
              </remote-input>
              <div class="SelectMenu-list" id="${filterTargetId}"></div>
              ${footerContent ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<footer class="SelectMenu-footer">
                      ${footerContent}
                    </footer>` : null}
            </div>
          </details-menu>
        </details>`;
                }
                break;
            }
        case 'date':
            {
                const { value: value = null, relative: relative = false, parametric: parametric = false, autocomplete: autocomplete } = config;
                input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<date-input
        class="d-flex position-relative"
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('relative', relative)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('parametric', parametric)}
        >${(0, $0f19b6a07911d9cc$export$8e2ee32c32a0ef22)({
                    id: id,
                    name: name,
                    value: value,
                    required: required,
                    disabled: disabled,
                    autofocus: autofocus,
                    form: form,
                    small: small,
                    target: target,
                    action: action,
                    inputAttrs: inputAttrs,
                    autocomplete: autocomplete,
                    describedBy: describedBy
                })}</date-input
      >`;
                break;
            }
        case 'month':
            {
                const { value: value = '', autocomplete: autocomplete = 'off' } = config;
                input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? ' input-sm' : ''}"
        id="${id}"
        name="${name}"
        type="month"
        autocomplete="${autocomplete}"
        value="${value ?? ''}"
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : ' ',
                        x
                    ])}
      />`;
                break;
            }
        case 'time':
            {
                const { value: value = '', autocomplete: autocomplete = 'off', step: step } = config;
                input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? ' input-sm' : ''}"
        id="${id}"
        name="${name}"
        type="time"
        autocomplete="${autocomplete}"
        value="${value}"
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('step', step?.toString())}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : ' ',
                        x
                    ])}
      />`;
                break;
            }
        case 'integer':
        case 'currency':
        case 'number':
            {
                const { value: value, min: min, max: max } = config;
                const minimumFractionDigits = config.type === 'number' ? config.minimumFractionDigits : config.type === 'integer' ? 0 : 2;
                const maximumFractionDigits = config.type === 'number' ? config.maximumFractionDigits : config.type === 'integer' ? 0 : 2;
                input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? ' input-sm' : ''}${config.type === 'currency' ? ' form-control-currency' : ''}"
        id="${id}"
        name="${name}"
        type="number"
        autocomplete="off"
        value="${value === undefined ? '' : config.type === 'integer' ? value : new Intl.NumberFormat('en-us', {
                    useGrouping: false,
                    minimumFractionDigits: minimumFractionDigits,
                    maximumFractionDigits: maximumFractionDigits,
                    roundingMode: 'floor'
                }).format(value)}"
        step="${config.type === 'integer' ? '1' : 'any'}"
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('min', min?.toString())}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('max', max?.toString())}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : ' ',
                        x
                    ])}
      />`;
                if (config.type === 'currency' || config.type === 'number') input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<number-input
          minimum-fraction-digits="${minimumFractionDigits}"
          maximum-fraction-digits="${maximumFractionDigits}"
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('class', config.type === 'currency' ? 'form-control-symbol-container' : null)}
          >${input}${config.type === 'currency' ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="form-control-symbol" aria-hidden="true"
                  >$</span
                >` : null}</number-input
        >`;
                break;
            }
        case 'tel':
            {
                const { value: value = '', autocomplete: autocomplete = 'off' } = config;
                input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<mask-input pattern="(###) ###-####">
        <input
          class="form-control${small ? ' input-sm' : ''}"
          id="${id}"
          name="${name}"
          type="tel"
          autocomplete="${autocomplete}"
          value="${value}"
          maxlength="14"
          pattern="^\\(\\d{3}\\) \\d{3}-\\d{4}$"
          ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
          ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
          ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
          ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : ' ',
                        x
                    ])}
        />
      </mask-input>`;
                break;
            }
        case 'zip':
            {
                const { value: value = '', autocomplete: autocomplete = 'off' } = config;
                input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<mask-input pattern="#####-####">
        <input
          class="form-control${small ? ' input-sm' : ''}"
          id="${id}"
          name="${name}"
          type="text"
          autocomplete="${autocomplete}"
          value="${value}"
          maxlength="10"
          pattern="^\\d{5}(?:-\\d{4})?$"
          ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
          ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
          ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
          ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : ' ',
                        x
                    ])}
        />
      </mask-input>`;
                break;
            }
        case 'numeric-code':
            {
                const { value: value = '', maxLength: maxLength, minLength: minLength } = config;
                input = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? ' input-sm' : ''}"
        id="${id}"
        name="${name}"
        type="tel"
        autocomplete="off"
        value="${value}"
        pattern="^\\d+$"
        maxlength="${maxLength}"
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('minlength', minLength?.toString())}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : ' ',
                        x
                    ])}
      />`;
                break;
            }
        default:
            throw new Error(`Unexpected form group type`);
    }
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<div
    class="form-group break-inside-avoid ${classes}"
    ${attrs?.map((x, i)=>[
            i == 0 ? null : ' ',
            x
        ])}
  >
    <label class="form-group-header d-inline-block ${headerClasses}" for="${id}"
      ><span data-label-text>${label}</span>${required && (config.type !== 'select' || config.type === 'select' && config.options.some((x)=>x.value === '')) && config.type !== 'rich-select' ? $13cfdc572434acbd$export$6db68b231e9eddb6(locale) : null}
    </label>
    <div class="form-group-body">${input}</div>
    ${desc}
  </div>`;
}
function $13cfdc572434acbd$export$a347ff2415ee3093({ label: label, name: name, checked: checked, disabled: disabled, description: description, classes: classes, attrs: attrs, form: form, target: target, action: action, inputAttrs: inputAttrs, autofocus: autofocus, required: required, id: id = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)(), trueValue: trueValue = true, falseValue: falseValue = false, selectedContent: selectedContent }) {
    const labelContent = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span data-label-text>${label}</span>`;
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<div
    class="form-group ${classes}"
    ${attrs?.map((x, i)=>[
            i == 0 ? null : ' ',
            x
        ])}
  >
    <div class="form-group-body">
      <label
        class="d-inline-flex ${description ? 'flex-items-start' : 'flex-items-center'} gap-1"
        for="${id}"
      >
        <input
          type="hidden"
          name="${name}"
          value="${falseValue}"
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
        />
        <input
          id="${id}"
          class="flex-shrink-0${description ? ' mt-1' : ''}"
          type="checkbox"
          name="${name}"
          value="${trueValue}"
          ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('checked', checked)}
          ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
          ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
          ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-target', target)}
          ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
          ${inputAttrs?.map((x, i)=>[
            i == 0 ? null : ' ',
            x
        ])}
        />
        ${description ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="d-flex flex-column">
                ${labelContent}
                <span class="color-fg-muted f6 text-normal"
                  >${description}</span
                >
              </span>` : labelContent}</label
      >
      ${selectedContent ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<div class="ml-3 display-if-preceding-checked">
              ${selectedContent}
            </div>` : null}
    </div>
  </div>`;
}
function $13cfdc572434acbd$export$227eadb0dfb7a1({ locale: locale = (0, $12c3f7ece07822ce$export$d7f512c98c859244), form: form, small: small, isNew: isNew, label: label = isNew ? (0, $b11db1b62d4a8f76$export$baff25308003b0cc)[locale] : (0, $b11db1b62d4a8f76$export$f093e2a834170186)[locale], describedBy: describedBy } = {}) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<button
    type="submit"
    class="btn btn-primary${small ? ' btn-sm' : ''} justify-self-start d-print-none"
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
    ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('new', isNew)}
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
    disabled
  >
    <span class="saved-indicator"></span>
    <span>${label}</span>
  </button>`;
}
function* $13cfdc572434acbd$export$9720603651db00f5(items, valueProperty, textProperty) {
    for (const item of items){
        const value = String(item[valueProperty]);
        const text = String(item[textProperty]);
        yield {
            value: value,
            text: text
        };
    }
}
function $13cfdc572434acbd$var$selectOptionsTemplate(items, selectedValue) {
    return items.map(({ value: value, text: text, disabled: disabled = false })=>$13cfdc572434acbd$var$selectOptionTemplate(text, value, selectedValue, disabled));
}
function $13cfdc572434acbd$export$d3199b8dddc55be(options, value) {
    const opts = [];
    for (const [group, items] of Object.entries((0, $cb5704f276528297$export$3f063810d7bf01bd)(options, (x)=>x.group ?? '')))if (group) opts.push((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<optgroup label="${group}">
          ${$13cfdc572434acbd$var$selectOptionsTemplate(items, value)}
        </optgroup>`);
    else opts.push(...$13cfdc572434acbd$var$selectOptionsTemplate(items, value));
    return opts;
}
function $13cfdc572434acbd$var$selectOptionTemplate(text, value, selectedValue, disabled) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<option
    value="${value}"
    ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('selected', value === selectedValue)}
    ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
  >
    ${text}
  </option>`;
}
function $13cfdc572434acbd$export$403e83ebb3fcef38({ label: label, name: name, options: options, multiple: multiple, value: value, required: required = false, disabled: disabled = false, description: description, classes: classes, attrs: attrs, form: form, autofocus: autofocus = false, locale: locale = (0, $12c3f7ece07822ce$export$d7f512c98c859244), formGroupBodyLayoutClasses: formGroupBodyLayoutClasses, blockChoices: blockChoices = false }) {
    let printOnlyDesc = false;
    if (!description) {
        printOnlyDesc = true;
        description = multiple ? (0, $b11db1b62d4a8f76$export$2beae1cfd23206a)[locale] : (0, $b11db1b62d4a8f76$export$24bd8284d2d99ce0)[locale];
    }
    const descId = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    const desc = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<p
    id="${descId}"
    class="note text-normal mt-0 mb-2${printOnlyDesc ? ' d-screen-none' : ''}"
  >
    ${description}
  </p>`;
    const inline = options.length <= 5 && !options.some((c)=>c.description) && options.reduce((acc, c)=>acc + c.text.length, 0) <= 40;
    const type = multiple ? 'checkbox' : 'radio';
    const choices = [];
    for (const option of options){
        const checked = option.value === value || Array.isArray(value) && value.includes(option.value);
        choices.push($13cfdc572434acbd$var$choiceTemplate({
            type: type,
            name: name,
            value: option.value,
            label: option.text,
            description: option.description,
            checked: checked,
            exclusive: option.exclusive ?? false,
            required: required,
            disabled: disabled || (option.disabled ?? false),
            describedBy: '',
            form: form,
            autofocus: autofocus,
            inputId: option.id ?? (0, $65af17b6a828fccf$export$9e1c824dbb29e809)(),
            selectedContent: option.selectedContent,
            action: option.action,
            hidden: option.hidden,
            attrs: option.attrs,
            block: blockChoices
        }));
    }
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<fieldset
    class="form-group break-inside-avoid ${classes}"
    ${attrs?.map((x, i)=>[
            i == 0 ? null : ' ',
            x
        ])}
    ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', printOnlyDesc ? undefined : descId)}
  >
    <legend
      class="form-group-header text-bold ${printOnlyDesc ? 'mb-print-0' : 'mb-0'}"
    >
      <span data-label-text>${label}</span>${required ? $13cfdc572434acbd$export$6db68b231e9eddb6(locale) : null}
    </legend>
    ${desc}
    <choice-group
      class="form-group-body ${formGroupBodyLayoutClasses ?? `d-flex flex-items-start ${inline ? 'gap-3 flex-wrap' : 'flex-column gap-2'}`}"
    >
      ${!required && !multiple ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input type="hidden" name="${name}" value="" />` : null}
      ${choices}
    </choice-group>
  </fieldset>`;
}
function $13cfdc572434acbd$var$choiceTemplate({ type: type, name: name, value: value, label: label, checked: checked, description: description, exclusive: exclusive, required: required, disabled: disabled, describedBy: describedBy, form: form, autofocus: autofocus, inputId: inputId, selectedContent: selectedContent, action: action, hidden: hidden, attrs: attrs, block: block = false }) {
    const labelContent = (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span
    data-label-text
    class="${value ? '' : 'text-italic'}"
    >${label}</span
  >`;
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<label
      class="text-normal ${block ? 'd-flex' : 'd-inline-flex'} ${description ? 'flex-items-start' : 'flex-items-center'} gap-1${value === '' ? ' d-print-none' : ''}"
      for="${inputId}"
      ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('hidden', hidden)}
    >
      <input
        id="${inputId}"
        class="flex-shrink-0${description ? ' mt-1' : ''}"
        type="${type}"
        name="${name}"
        value="${value}"
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('checked', checked)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('exclusive', exclusive)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('required', required)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
        ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('autofocus', autofocus)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('aria-describedby', describedBy)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('form', form)}
        ${(0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('data-action', action)}
        ${attrs}
      />
      ${description ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="d-flex flex-column">
              ${labelContent}
              <span class="color-fg-muted f6">${description}</span>
            </span>` : labelContent}</label
    >${selectedContent ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<div class="ml-3 display-if-preceding-checked">
            ${selectedContent}
          </div>` : null}`;
}
function $13cfdc572434acbd$export$3763611e2da0fe5(label, prompt) {
    const map = {
        'first name': 'given-name',
        'last name': 'family-name',
        email: 'email',
        'phone number': 'tel-national',
        'date of birth': 'bday',
        address: 'address-line1',
        'address 2': 'address-line2'
    };
    return map[prompt.toLowerCase()] ?? map[label.toLowerCase()];
}

const $f2fb4fb7bbc3d253$export$a19cb25f70157f03 = [
    'text',
    'checkbox',
    'radiobutton',
    'combobox'
];
function $f2fb4fb7bbc3d253$export$a21edca62b26ba76(type) {
    return $f2fb4fb7bbc3d253$export$a19cb25f70157f03.includes(type);
}
const $f2fb4fb7bbc3d253$export$7defd296b624b3cd = {
    text: [
        'string',
        'int',
        'decimal',
        'date',
        'datetime'
    ],
    checkbox: [
        'boolean'
    ],
    radiobutton: [
        'boolean'
    ],
    combobox: [
        'string'
    ]
};
var $f2fb4fb7bbc3d253$export$eaa4a3488d888408 = /*#__PURE__*/ function(PdfSigningMethod) {
    PdfSigningMethod[PdfSigningMethod["Basic"] = 0] = "Basic";
    PdfSigningMethod[PdfSigningMethod["WetInk"] = 1] = "WetInk";
    PdfSigningMethod[PdfSigningMethod["KBA"] = 2] = "KBA";
    return PdfSigningMethod;
}({});
const $f2fb4fb7bbc3d253$export$fb0c14d299b34fb9 = 4;
const $f2fb4fb7bbc3d253$export$f496fc2861c4e0a5 = 10;
const $f2fb4fb7bbc3d253$export$5068647521773aba = 4;
const $f2fb4fb7bbc3d253$export$cf7c18b96ec4c589 = 612;
const $f2fb4fb7bbc3d253$export$b8606a4fb69802de = 792;
const $f2fb4fb7bbc3d253$var$PDF_SIZE_TOLERANCE = 0.5;
function $f2fb4fb7bbc3d253$export$41b342ccc941bdb5(width, height) {
    return Math.abs(width - $f2fb4fb7bbc3d253$export$cf7c18b96ec4c589) < $f2fb4fb7bbc3d253$var$PDF_SIZE_TOLERANCE && Math.abs(height - $f2fb4fb7bbc3d253$export$b8606a4fb69802de) < $f2fb4fb7bbc3d253$var$PDF_SIZE_TOLERANCE;
}
function $f2fb4fb7bbc3d253$export$a7b6275dedb771ff(width, height) {
    return width.toString().length > 7 || height.toString().length > 7;
}



var $ff386d0bbf603089$exports = {};

let $ff386d0bbf603089$var$url = new URL(import.meta.resolve("1AYVQ"));
$ff386d0bbf603089$exports = $95c5dfe6050132a6$exports($ff386d0bbf603089$var$url.toString(), $ff386d0bbf603089$var$url.origin, true);


async function $7c5b76d207f7edb7$export$a83fbdcef2db12b3(instruction) {
    const worker = new Worker($ff386d0bbf603089$exports);
    await new Promise((resolve)=>worker.addEventListener('message', resolve, {
            once: true
        }));
    worker.postMessage(instruction);
    const event = await new Promise((resolve)=>worker.addEventListener('message', resolve, {
            once: true
        }));
    worker.terminate();
    if (event.data.type === 'pdf-error') throw new $7c5b76d207f7edb7$export$cd4c841c37939f78(event.data.message);
    return event.data.data;
}
class $7c5b76d207f7edb7$export$cd4c841c37939f78 extends Error {
    userMessage;
    constructor(userMessage){
        super(`Error processing PDF instruction: ${userMessage}`), this.userMessage = userMessage;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
    }
}






const $8b5013bbbded2ad1$var$annotationFieldSelector = 'section[data-annotation-id] [data-element-id]:is(input, select, textarea)';
class $8b5013bbbded2ad1$export$bb62d6a389bc814 extends HTMLElement {
    static nextInstance = 0;
    pdfLoaded = Promise.withResolvers();
    viewerApplication;
    annotationEditorUIManager;
    detachedController;
    viewerOptionsConfigured = false;
    instance = $8b5013bbbded2ad1$export$bb62d6a389bc814.nextInstance++;
    connectedCallback() {
        this.detachedController = new AbortController();
        this.ownerDocument.addEventListener('webviewerloaded', this.handleWebViewerLoaded, {
            signal: this.detachedController.signal
        });
    }
    disconnectedCallback() {
        this.detachedController?.abort();
    }
    handleWebViewerLoaded = (event)=>{
        const source = event.detail?.source;
        if (source !== this.iframe.contentWindow) return;
        // PDF.js dispatches webviewerloaded before initializing the viewer so
        // embedders can configure AppOptions before preferences and viewer
        // components are created.
        const options = source.PDFViewerApplicationOptions;
        options.set('disablePreferences', true);
        options.set('defaultUrl', '');
        options.set('enableSignatureEditor', false);
        if (!this.hasAttribute('restore-position')) {
            options.set('viewOnLoad', 1); // 1 = initial position
            options.set('defaultZoomValue', 'auto');
            options.set('sidebarViewOnLoad', 0); // 0 = none
            options.set('scrollModeOnLoad', 0); // 0 = vertical scrolling
            options.set('spreadModeOnLoad', 0); // 0 = no spreads
        }
        this.viewerOptionsConfigured = true;
    };
    async iframeLoaded() {
        this.log('IFrame loaded');
        const iframe = this.iframe;
        const viewerWindow = iframe.contentWindow;
        if (!viewerWindow) throw new Error('Expected iframe contentWindow');
        if (!this.viewerOptionsConfigured) throw new Error('Expected PDF viewer options to be configured before initialization');
        viewerWindow.document.documentElement.toggleAttribute('cumulus--hide-tools', true);
        const viewerApplication = this.viewerApplication = viewerWindow.PDFViewerApplication;
        const pdfFile = iframe.getAttribute('data-pdf-file') ?? new URL(viewerWindow.location.href).searchParams.get('file');
        // Prevent edits to PDF from interrupting beforeunload event.
        viewerApplication._hasChanges = ()=>false;
        // intercept load
        this.log('Intercepting PDF load');
        const standardLoad = viewerApplication.load;
        const interceptedLoad = Promise.withResolvers();
        viewerApplication.load = (pdfDocument)=>{
            this.log('PDF load intercepted');
            viewerApplication.load = standardLoad;
            (async ()=>{
                try {
                    // Intercept setValue
                    const standardSetValue = pdfDocument.annotationStorage.setValue;
                    pdfDocument.annotationStorage.setValue = (id, value)=>{
                        this.log('annotationStorage.setValue', id, value);
                        standardSetValue.call(pdfDocument.annotationStorage, id, value);
                        const el = viewerWindow.document.querySelector(`[data-element-id="${id}"]`);
                        if (this.isAnnotationField(el)) this.onAnnotationFieldChange?.(viewerApplication, id, el);
                    };
                    await this.onPdfDocumentLoaded?.(pdfDocument);
                    standardLoad.call(viewerApplication, pdfDocument);
                    interceptedLoad.resolve();
                } catch (error) {
                    interceptedLoad.reject(error);
                }
            })();
        };
        viewerApplication.eventBus.on('annotationeditoruimanager', (args)=>{
            this.annotationEditorUIManager = args.uiManager;
            this.log('AnnotationEditorUIManager ready');
            this.onAnnotationEditorUiManager?.(args);
        }, {
            signal: this.detachedController?.signal
        });
        viewerApplication.eventBus.on('annotationeditorlayerrendered', ()=>{
            this.log('Annotation editor layer rendered');
            this.onAnnotationEditorLayerRendered?.(viewerApplication);
        }, {
            signal: this.detachedController?.signal
        });
        if (this.hasAttribute('readonly')) viewerApplication.eventBus.on('annotationlayerrendered', ()=>{
            this.iframe.contentDocument?.querySelectorAll($8b5013bbbded2ad1$var$annotationFieldSelector).forEach((el)=>{
                if (this.isAnnotationField(el)) el.disabled = true;
            });
        }, {
            signal: this.detachedController?.signal
        });
        await this.viewerApplication.initializedPromise;
        this.log('Viewer application initialized');
        if (pdfFile) {
            this.log('Opening PDF file', pdfFile);
            await viewerApplication.open({
                url: pdfFile
            });
            await interceptedLoad.promise;
        }
        await this.viewerApplication.pdfLoadingTask?.promise;
        this.log('Loading task resolved');
        // Prevent drop from updating the PDF document.
        viewerApplication.appConfig.mainContainer.addEventListener('drop', (event)=>{
            event.preventDefault();
            event.stopPropagation();
            this.log('Drop event stopped');
        }, {
            capture: true,
            signal: this.detachedController?.signal
        });
        // Field events
        viewerApplication.appConfig.viewerContainer.addEventListener('click', this.handleAnnotationClick, {
            signal: this.detachedController?.signal
        });
        viewerApplication.appConfig.viewerContainer.addEventListener('focus', this.handleAnnotationFocus, {
            capture: true,
            signal: this.detachedController?.signal
        });
        this.iframe.contentWindow?.window.addEventListener('keydown', this.handleKeydown, {
            capture: true,
            signal: this.detachedController?.signal
        });
        this.viewerApplication.eventBus.on('annotationeditormodechanged', ()=>{
            this.log('Annotation editor mode changed', this.viewerApplication.pdfViewer.annotationEditorMode);
            this.onAnnotationEditorModeChanged?.(this.viewerApplication);
        });
        const firstPagePromise = viewerApplication.pdfViewer.firstPagePromise;
        if (!firstPagePromise) throw new Error('Expected PDF viewer firstPagePromise');
        await firstPagePromise;
        this.log('First page loaded');
        const pagesPromise = viewerApplication.pdfViewer.pagesPromise;
        if (!pagesPromise) throw new Error('Expected PDF viewer pagesPromise');
        await pagesPromise;
        this.log('All pages loaded');
        this.pdfLoaded.resolve(viewerApplication);
        this.onPdfLoaded?.(viewerApplication);
    }
    isAnnotationField(target) {
        return target && 'matches' in target && typeof target.matches === 'function' && target.matches($8b5013bbbded2ad1$var$annotationFieldSelector);
    }
    handleAnnotationClick = async (event)=>{
        this.log('Annotation clicked');
        const target = event.target;
        if (!this.isAnnotationField(target) || !this.viewerApplication) return;
        // Make radios uncheckable.
        if (target.type === 'radio' && target instanceof this.iframe.contentWindow.window.HTMLInputElement && target.checked) {
            // Click happens before the change event.
            // Wait for the change event to fire, if it does, we do not need to clear the radio because it just became checked.
            const timeout = setTimeout(()=>{
                target.checked = false;
                (0, $80a2320123ddcd02$export$89348ae70780cd7a)(target);
            });
            target.addEventListener('change', ()=>clearTimeout(timeout), {
                once: true,
                capture: true
            });
        }
        this.onAnnotationFieldClick?.(this.viewerApplication, target, event);
    };
    handleAnnotationFocus = async (event)=>{
        this.log('Annotation focused');
        const target = event.target;
        if (!this.isAnnotationField(target) || !this.viewerApplication) return;
        this.onAnnotationFieldFocus?.(this.viewerApplication, target, event);
    };
    handleKeydown = (event)=>{
        if (!(event.ctrlKey || event.metaKey) || event.shiftKey || event.altKey || event.key !== 's' || event.defaultPrevented || !this.viewerApplication) return;
        event.preventDefault();
        event.stopImmediatePropagation(); // Prevents the default save dialog from opening.
        const target = event.target;
        if (this.isAnnotationField(target)) {
            target.blur();
            target.focus();
        }
        this.onCtrlS?.(this.viewerApplication);
    };
    log(...data) {
        console.log(`PDF_VIEWER_${this.instance}`, ...data);
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $8b5013bbbded2ad1$export$bb62d6a389bc814.prototype, "iframe", void 0);


class $b82b08e5003c3436$export$44e254a6b1fb3cc1 extends (0, $8b5013bbbded2ad1$export$bb62d6a389bc814) {
    acroForm = new Map();
    fieldsById = {};
    fieldOutlineTimeout = 0;
    removeFieldOutline;
    viewerOutlineTimeout = 0;
    removeViewerOutline;
    onAnnotationEditorUiManager = undefined;
    onPdfLoaded = undefined;
    connectedCallback() {
        super.connectedCallback();
        // Fix nested scroll issues.
        addEventListener('click', ()=>$b82b08e5003c3436$var$fixScrollTop('click event'));
        addEventListener('focus', ()=>$b82b08e5003c3436$var$fixScrollTop('focus event'), {
            capture: true
        });
        this.validatePdf();
        // defer loading PDF until page is visible to workaround issue where the load intercept isn't set in time.
        // we probably need to call load explicitly instead of relying on the file url parameter in the iframe src attribute.
        const load = ()=>this.iframe.setAttribute('src', this.iframe.getAttribute('deferred-src'));
        if (document.visibilityState === 'visible') load();
        else document.addEventListener('visibilitychange', load, {
            once: true
        });
    }
    async validatePdf() {
        const url = this.getAttribute('src');
        const response = await fetch(url);
        if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
        const data = await response.arrayBuffer();
        try {
            await (0, $7c5b76d207f7edb7$export$a83fbdcef2db12b3)({
                type: 'load',
                data: new Uint8Array(data)
            });
        } catch (err) {
            if (err instanceof (0, $7c5b76d207f7edb7$export$cd4c841c37939f78)) alert(`PDF file may be corrupt.\nUse https://www.ilovepdf.com/repair-pdf to repair the file.\nFailing step: ${err.userMessage}`);
            throw err;
        }
    }
    tabChanged() {}
    onAnnotationEditorModeChanged(_viewerApplication) {}
    async onPdfDocumentLoaded(pdfDocument) {
        this.log('pdf-template onPdfDocumentLoaded');
        setTimeout(this.checkPageSizes.bind(this), 100, pdfDocument);
        // If new, set title and end page.
        if (this.form.querySelector('form-behavior[new]')) {
            const { info: info } = await pdfDocument.getMetadata();
            this.titleInput.value = this.titleInput.value || info.Title || '';
            this.endPageInput.value = pdfDocument.numPages.toString();
            this.form.firstElementChild.acceptChanges();
        }
        // Set max page numbers.
        this.startPageInput.max = pdfDocument.numPages.toString();
        this.endPageInput.max = pdfDocument.numPages.toString();
        // Get form.
        const acroForm = await pdfDocument.getFieldObjects();
        // If there are no fields, let them know, and return.
        if (!acroForm || !Array.from(acroForm.values()).some((fields)=>fields.some((field)=>(0, $f2fb4fb7bbc3d253$export$a21edca62b26ba76)(field.type) && field.editable && !field.hidden))) {
            this.noFieldsFlash.hidden = false;
            this.fieldsTabPanel.insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input type="hidden" name="mapping/fields:json" value="[]" />`));
            this.form.firstElementChild.acceptChanges();
            return;
        }
        this.acroForm = acroForm;
        this.fieldsById = Array.from(acroForm.values()).flat().reduce((acc, field)=>{
            acc[field.id] = field;
            return acc;
        }, {});
        this.iframe.contentWindow?.document.documentElement.toggleAttribute('cumulus--pdf-template', true);
        await this.renderMappingFields(pdfDocument);
    }
    async checkPageSizes(pdfDocument) {
        const messages = [];
        for(let i = 1; i <= pdfDocument.numPages; i++){
            const page = await pdfDocument.getPage(i);
            const { width: width, height: height } = page.getViewport({
                scale: 1
            });
            if ((0, $f2fb4fb7bbc3d253$export$a7b6275dedb771ff)(width, height)) messages.push(`Page ${i} is ${width} x ${height} points (too many decimals places).`);
            else if (!(0, $f2fb4fb7bbc3d253$export$41b342ccc941bdb5)(width, height)) messages.push(`Page ${i} is ${width} x ${height} points (outside tolerance).`);
        }
        if (messages.length) alert(`\u{26A0}\u{FE0F} Some pages are not US Letter size.
Expected: 8.5" x 11" (${(0, $f2fb4fb7bbc3d253$export$cf7c18b96ec4c589)} x ${(0, $f2fb4fb7bbc3d253$export$b8606a4fb69802de)} points).
${messages.join('\n')}

Signature controls may not be positioned correctly when pages are irregularly sized.

Try resizing the pages using Adobe Acrobat's
[Use print production] -> [Set page sizes] tool.

If you continue to see this message, use Adobe Acrobat to create a new blank US Letter page, then copy the contents of the irregularly sized page into the new blank page. Finally, delete the irregularly sized page.`);
    }
    onCtrlS(_viewerApplication) {
        this.form.requestSubmit();
    }
    onAnnotationFieldClick(viewerApplication, target, event) {
        this.handleAnnotationFieldClickOrFocus(viewerApplication, target, event);
    }
    onAnnotationFieldFocus(viewerApplication, target, event) {
        this.handleAnnotationFieldClickOrFocus(viewerApplication, target, event);
    }
    async handleAnnotationFieldClickOrFocus(_viewerApplication, target, _event) {
        if (this.tabContainer.activePanel !== this.fieldsTabPanel) {
            this.tabContainer.selectTab(1);
            target.focus();
        }
        const id = `acro-field-${target.dataset.elementId}`;
        const element = document.getElementById(id);
        clearTimeout(this.fieldOutlineTimeout);
        this.removeFieldOutline?.();
        this.removeFieldOutline = undefined;
        await new Promise((resolve)=>setTimeout(resolve, 0));
        element.classList.add('element-changed-animation');
        this.removeFieldOutline = ()=>element.classList.remove('element-changed-animation');
        this.fieldOutlineTimeout = setTimeout(this.removeFieldOutline, 2050);
        (0, $80a2320123ddcd02$export$9657601bf1e130ee)(element);
        $b82b08e5003c3436$var$fixScrollTop('handleAnnotationClick - scrollIntoView');
    }
    onAnnotationFieldChange(viewerApplication, id) {
        const pdfDocument = viewerApplication.pdfDocument;
        if (!pdfDocument) throw new Error('Expected a loaded PDF document');
        // sync all fields with the same name.
        const name = this.fieldsById[id].name;
        const fields = this.acroForm.get(name)?.filter((field)=>(0, $f2fb4fb7bbc3d253$export$a21edca62b26ba76)(field.type)) ?? [];
        for (const field of fields){
            const initialValue = field.value;
            const override = pdfDocument.annotationStorage.getValue(field.id, {});
            // console.log(name, id, initialValue, override, field);
            const value = override?.value ?? initialValue;
            const element = document.getElementById(`acro-field-value-${field.id}`);
            if (!element) {
                if (this.renderingFields) return;
                throw new Error(`No Cumulus field for ${field.id}`);
            }
            element.value = typeof value === 'boolean' && [
                'checkbox',
                'radiobutton'
            ].includes(field.type) ? value ? 'On' : 'Off' : String(value);
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(element);
            if (field.id === id && !this.renderingFields) {
                (0, $80a2320123ddcd02$export$9657601bf1e130ee)(element);
                $b82b08e5003c3436$var$fixScrollTop('handleAnnotationChange - scrollIntoView');
            }
        }
    }
    syncFieldMappedStatus(annotationInput, printedExpression) {
        const value = printedExpression.trim();
        annotationInput.classList.toggle('cumulus-mapped', value !== '');
        annotationInput.title = value;
    }
    async syncAcroField(event) {
        if (!this.viewerApplication) return;
        if (event.target instanceof HTMLAnchorElement) event.preventDefault();
        const viewerApplication = this.viewerApplication;
        const target = event.target;
        const id = target.getAttribute('element-id');
        const field = this.fieldsById[id];
        // render page if not already rendered
        const page = viewerApplication.pdfViewer.getPageView(field.page);
        viewerApplication.appConfig.toolbar.pageNumber.value = String(field.page + 1);
        viewerApplication.appConfig.toolbar.pageNumber.dispatchEvent(new Event('change', {
            bubbles: true
        }));
        // viewerApplication.eventBus.dispatch('pagenumberchanged', {
        //   source: self,
        //   value: field.page! + 1
        // });
        if (page.renderingState !== 3 /* PDFRenderingStates.FINISHED */ ) await Promise.all([
            new Promise((resolve)=>viewerApplication.eventBus.on('pagerendered', resolve, {
                    once: true,
                    signal: this.detachedController?.signal
                })),
            new Promise((resolve)=>viewerApplication.eventBus.on('annotationlayerrendered', resolve, {
                    once: true,
                    signal: this.detachedController?.signal
                }))
        ]);
        const element = viewerApplication.appConfig.viewerContainer.querySelector(`[data-element-id="${id}"]`);
        if (event.type === 'change') this.syncFieldMappedStatus(element, target.value);
        else {
            // click (on anchor) or expression focus/blur
            // focus (which will scroll field into view) OR only scroll into view
            if (target instanceof HTMLAnchorElement) {
                element.focus();
                $b82b08e5003c3436$var$fixScrollTop('syncAcroField - focus');
            } else {
                (0, $80a2320123ddcd02$export$9657601bf1e130ee)(element);
                $b82b08e5003c3436$var$fixScrollTop('syncAcroField - scrollIntoView');
            }
            // remove previous outline
            clearTimeout(this.viewerOutlineTimeout);
            this.removeViewerOutline?.();
            this.removeViewerOutline = undefined;
            if (event.type !== 'blur') {
                // outline current field
                await new Promise((resolve)=>setTimeout(resolve, 0));
                element.classList.add('active-field-outline');
                this.removeViewerOutline = ()=>element.classList.remove('active-field-outline', 'active-field-outline--fade');
                // enqueue outline removal
                if (target instanceof HTMLAnchorElement) {
                    element.classList.add('active-field-outline--fade');
                    this.viewerOutlineTimeout = setTimeout(this.removeViewerOutline, 2050);
                }
            }
        }
    }
    onAnnotationEditorLayerRendered(viewerApplication) {
        for (const { id: id } of Array.from(this.acroForm.values()).flat().filter((x)=>(0, $f2fb4fb7bbc3d253$export$a21edca62b26ba76)(x.type))){
            const annotationInput = viewerApplication.appConfig.viewerContainer.querySelector(`[data-element-id="${id}"]`);
            if (!annotationInput) continue;
            const expressionInput = this.form.querySelector(`textarea[element-id="${id}"]`);
            if (!expressionInput) continue;
            this.syncFieldMappedStatus(annotationInput, expressionInput.value);
        }
    }
    renderingFields = false;
    renderMappingFields(pdfDocument) {
        this.log('renderingMappingFields');
        this.renderingFields = true;
        const dataFields = JSON.parse(this.fieldsScript.textContent);
        let templates = [];
        for (const name of $b82b08e5003c3436$var$getNamesInPositionOrder(this.acroForm)){
            const fields = this.acroForm.get(name)?.filter((field)=>(0, $f2fb4fb7bbc3d253$export$a21edca62b26ba76)(field.type)) ?? [];
            for (const field of fields){
                const index = templates.length;
                const dataField = dataFields.find((dataField)=>dataField.id === field.id) ?? dataFields.find((dataField)=>dataField.name === field.name && dataField.export_values === field.exportValues && dataField.type === field.type);
                if (dataField && dataField.value !== field.value) pdfDocument.annotationStorage.setValue(field.id, {
                    value: field.type === 'checkbox' || field.type === 'radiobutton' ? dataField.value === 'On' : dataField.value
                });
                const isDuplicate = field !== fields.find((x)=>x.name === field.name && x.exportValues === field.exportValues && x.type === field.type);
                templates.push((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<section
            id="acro-field-${field.id}"
            class="rounded-1 p-3 mt-n3 ml-n3 mb-n3 mr-n3"
          >
            <h3 class="f4 mb-2">
              ${field.editable === false || field.hidden === true ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`${$b82b08e5003c3436$var$breakAcroFieldName(field.name)}
                    ${field.type === 'radiobutton' && field.exportValues ? `/ ${field.exportValues}` : null}` : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<a
                      class="Link--primary"
                      href="#"
                      tabindex="-1"
                      element-id="${field.id}"
                      data-action="click:pdf-template#syncAcroField"
                      >${$b82b08e5003c3436$var$breakAcroFieldName(field.name)}${field.type === 'radiobutton' && field.exportValues ? ` / ${field.exportValues}` : null}</a
                    >`}
              <span class="Label Label--primary text-capitalize"
                >${field.type}</span
              >
              ${field.type === 'text' && field.charLimit ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="Label"
                      >${field.charLimit} characters</span
                    >` : null}
              ${field.type === 'text' && field.multiline ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="Label">Multiline</span>` : null}
              ${field.editable === false ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="Label Label--attention">Read only</span>` : null}
              ${field.hidden === true ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="Label Label--attention">Hidden</span>` : null}
              ${field.actions && Object.values(field.actions).flat().length ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="Label Label--attention">Scripted</span>` : null}
              ${isDuplicate ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span class="Label Label--danger">Duplicate</span>` : null}
            </h3>
            ${(0, $13cfdc572434acbd$export$bdc7259586f8f739)({
                    type: 'textarea',
                    label: 'Mapping',
                    value: dataField?.expression ? (0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(dataField.expression.ast) : '',
                    maxLength: 3000,
                    disabled: this.titleInput.disabled,
                    spellcheck: false,
                    rows: 2,
                    name: `mapping/fields/${index}/expression:nullstring`,
                    inputAttrs: [
                        (0, $f4d1565f2a6712b7$export$7aabe8b3a840d2fd)('element-id', field.id)
                    ],
                    action: 'focus:pdf-template#syncAcroField blur:pdf-template#syncAcroField change:pdf-template#syncAcroField',
                    classes: 'position-relative',
                    headerClasses: 'sr-only'
                })}
            <details class="details-reset">
              <summary class="note" tabindex="-1">Details</summary>
              <div class="d-flex flex-column gap-3 mt-2 ml-3">
                ${(0, $13cfdc572434acbd$export$bdc7259586f8f739)({
                    type: field.multiline === true ? 'textarea' : 'text',
                    label: 'Value',
                    value: dataField ? dataField.value : field.value,
                    maxLength: field.type === 'text' && field.charLimit ? field.charLimit : 300,
                    name: `mapping/fields/${index}/value`,
                    disabled: true,
                    id: `acro-field-value-${field.id}`
                })}
                <pre><code class="p-3 f6 overflow-auto">${JSON.stringify(field, null, 2)}</code></pre>
              </div>
            </details>
            <input
              type="hidden"
              name="mapping/fields/${index}/name"
              value="${field.name}"
            />
            <input
              type="hidden"
              name="mapping/fields/${index}/type"
              value="${field.type}"
            />
            <input
              type="hidden"
              name="mapping/fields/${index}/id"
              value="${field.id}"
            />
            <input
              type="hidden"
              name="mapping/fields/${index}/page:integer"
              value="${field.page}"
            />
            ${field.editable === undefined ? null : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
                    type="hidden"
                    name="mapping/fields/${index}/editable:boolean"
                    value="${field.editable}"
                  />`}
            ${field.hidden === undefined ? null : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
                    type="hidden"
                    name="mapping/fields/${index}/hidden:boolean"
                    value="${field.hidden}"
                  />`}
            ${field.multiline === undefined ? null : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
                    type="hidden"
                    name="mapping/fields/${index}/multiline:boolean"
                    value="${field.multiline}"
                  />`}
            ${field.charLimit === undefined ? null : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
                    type="hidden"
                    name="mapping/fields/${index}/charlimit:integer"
                    value="${field.charLimit}"
                  />`}
            ${field.exportValues === undefined ? null : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
                    type="hidden"
                    name="mapping/fields/${index}/export_values"
                    value="${field.exportValues}"
                  />`}
            ${field.defaultValue === undefined ? null : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
                    type="hidden"
                    name="mapping/fields/${index}/default_value"
                    value="${field.defaultValue}"
                  />`}
          </section>`);
            }
        }
        this.fieldsTabPanel.insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)(templates));
        this.form.firstElementChild.acceptChanges();
        this.renderingFields = false;
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b82b08e5003c3436$export$44e254a6b1fb3cc1.prototype, "form", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b82b08e5003c3436$export$44e254a6b1fb3cc1.prototype, "titleInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b82b08e5003c3436$export$44e254a6b1fb3cc1.prototype, "startPageInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b82b08e5003c3436$export$44e254a6b1fb3cc1.prototype, "endPageInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b82b08e5003c3436$export$44e254a6b1fb3cc1.prototype, "noFieldsFlash", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b82b08e5003c3436$export$44e254a6b1fb3cc1.prototype, "fieldsScript", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b82b08e5003c3436$export$44e254a6b1fb3cc1.prototype, "fieldsTabPanel", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b82b08e5003c3436$export$44e254a6b1fb3cc1.prototype, "signaturesTabPanel", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b82b08e5003c3436$export$44e254a6b1fb3cc1.prototype, "tabContainer", void 0);
$b82b08e5003c3436$export$44e254a6b1fb3cc1 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('pdf-template')
], $b82b08e5003c3436$export$44e254a6b1fb3cc1);
function $b82b08e5003c3436$var$getNamesInPositionOrder(acroForm) {
    return Array.from(acroForm.values()).flat().filter((widget)=>(0, $f2fb4fb7bbc3d253$export$a21edca62b26ba76)(widget.type)).map((widget)=>({
            page: widget.page ?? 1000,
            name: widget.name,
            rect: widget.rect ?? [
                0,
                0
            ] // fallback if rect is missing
        })).sort((a, b)=>{
        // sort by page ascending, then Y descending (top to bottom), then X ascending (left to right)
        const dp = a.page - b.page;
        const dy = b.rect[1] - a.rect[1];
        return dp !== 0 ? dp : dy !== 0 ? dy : a.rect[0] - b.rect[0];
    }).map((widget)=>widget.name).filter((x, i, a)=>a.indexOf(x) === i); // remove duplicates
}
function $b82b08e5003c3436$var$breakAcroFieldName(name) {
    return name.trim().split(/\]\./g).map((x, i)=>i === 0 ? x : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`]<wbr />.${x}`);
}
function $b82b08e5003c3436$var$fixScrollTop(message) {
    if (document.documentElement.scrollTop > 0) {
        document.documentElement.scrollTop = 0;
        console.log('fixScrollTop', message);
    }
    setTimeout($b82b08e5003c3436$var$fixScrollTop, 0, message + ' + timeout');
}







class $536787a3c6a576cf$export$31e2876c6bd23725 extends HTMLElement {
    async fileAttachmentAccepted(event) {
        const uploadHref = this.getAttribute('upload-href');
        if (!uploadHref) throw new Error('Missing upload href');
        const uploadUrl = new URL(uploadHref, location.origin);
        const locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
        const attachments = event.detail.attachments;
        try {
            this.fileInput.disabled = true;
            this.fileInput.labels?.forEach((label)=>label.classList.add('btn-busy'));
            await (0, $4ab5d79d76486e1b$export$14d3a7d22f26659e)({
                locale: locale,
                attachments: attachments,
                uploadUrl: uploadUrl,
                attachmentSaved: ({ id: id })=>{
                    const copyTemplateId = this.getAttribute('copy-template-id');
                    const params = new URLSearchParams();
                    if (copyTemplateId) params.set('copy_template_id', copyTemplateId);
                    if (this.hasAttribute('delete-original')) params.set('delete_original', 'true');
                    const { origin: origin, pathname: pathname } = location;
                    location.href = `${origin}${pathname.substr(0, pathname.indexOf('/pdf-templates') + 14)}/${(0, $52ec208b1be5af58$export$7077a352e654daea)(id)}?${params}`;
                }
            });
        } finally{
            this.fileInput.disabled = false;
            this.fileInput.labels?.forEach((label)=>label.classList.remove('btn-busy'));
        }
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $536787a3c6a576cf$export$31e2876c6bd23725.prototype, "fileInput", void 0);
$536787a3c6a576cf$export$31e2876c6bd23725 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('pdf-template-upload')
], $536787a3c6a576cf$export$31e2876c6bd23725);






const $55276d1402d44ed1$var$rasterDpi = 200;
const $55276d1402d44ed1$var$rasterJpegQuality = 0.92;
const $55276d1402d44ed1$var$annotationModeEnableStorage = 3;
class $55276d1402d44ed1$export$9bf81fc16d2d903d extends (0, $8b5013bbbded2ad1$export$bb62d6a389bc814) {
    filledPromise = Promise.withResolvers();
    signatureFields = [];
    onAnnotationFieldClick;
    onAnnotationFieldFocus;
    onCtrlS;
    onAnnotationEditorLayerRendered;
    onAnnotationEditorUiManager;
    onAnnotationEditorModeChanged;
    onAnnotationFieldChange;
    connectedCallback() {
        super.connectedCallback();
        const src = this.iframe.getAttribute('deferred-src');
        if (src) this.iframe.setAttribute('src', src);
    }
    async onPdfDocumentLoaded(pdfDocument) {
        const values = JSON.parse(this.valuesScript.textContent);
        this.log('Getting field objects');
        const acroForm = await pdfDocument.getFieldObjects();
        if (!acroForm) {
            this.log('No field objects');
            this.filledPromise.resolve();
            return;
        }
        this.log('Filling form');
        for (const { id: id, name: name, type: type, export_values: export_values, value: value } of values){
            const fieldsOfType = acroForm.get(name)?.filter((field)=>field.type === type) ?? [];
            const fieldsById = fieldsOfType.filter((field)=>field.id === id);
            const fields = fieldsById.length ? fieldsById : fieldsOfType.filter((field)=>field.exportValues === export_values);
            if (!fields?.length) {
                console.warn(`Field ${name} with export value ${export_values} not found`);
                continue;
            }
            if (value && /^\[[sd]:[a-z]:r *\]$/.test(value)) {
                this.signatureFields.push(...fields.map((field)=>({
                        field: field,
                        value: value
                    })));
                continue;
            }
            for (const field of fields){
                if (field.value === value) continue;
                pdfDocument.annotationStorage.setValue(field.id, {
                    value: field.type === 'checkbox' || field.type === 'radiobutton' ? value === 'On' : value ?? undefined
                });
            }
        }
        this.log('Filled form');
        this.filledPromise.resolve();
    }
    onPdfLoaded() {
        this.iframe.contentWindow?.addEventListener('change', (event)=>{
            if (this.isAnnotationField(event.target)) this.dispatchEvent(new CustomEvent('pdf-viewer-user-field-changed', {
                bubbles: true
            }));
        });
    }
    async save({ rasterizeEncrypted: rasterizeEncrypted = false } = {}) {
        // Keep using the viewer save path rather than PDFDocumentProxy.saveDocument
        // directly: downloadOrSave also commits active editors and dispatches the
        // PDF scripting WillSave/DidSave events. Capture that path's output rather
        // than downloading it.
        // https://github.com/mozilla/pdf.js/blob/v6.4.299/web/app.js
        const [viewerApplication] = await Promise.all([
            this.pdfLoaded.promise,
            this.filledPromise.promise
        ]);
        let data;
        const downloadManager = viewerApplication.downloadManager;
        viewerApplication.downloadManager = {
            download (d) {
                data = d;
            }
        };
        try {
            await viewerApplication.downloadOrSave();
        } finally{
            viewerApplication.downloadManager = downloadManager;
        }
        const pdfDocument = viewerApplication.pdfDocument;
        // PDF.js can open encrypted PDFs, but its saved bytes remain encrypted.
        // EncryptFilterName identifies an encrypted document even when it doesn't
        // declare any permission restrictions, so rebuild those pages from their
        // rendered output before pdf-lib merges them.
        if (rasterizeEncrypted && pdfDocument) {
            const { info: info } = await pdfDocument.getMetadata();
            if (info.EncryptFilterName !== null) return this.rasterize(pdfDocument);
        }
        return Uint8Array.from(data);
    }
    async rasterize(pdfDocument) {
        const pages = [];
        const scale = $55276d1402d44ed1$var$rasterDpi / 72;
        const renderDocument = this.iframe.contentDocument;
        if (!renderDocument) throw new Error('Unable to access PDF viewer document');
        for(let pageNumber = 1; pageNumber <= pdfDocument.numPages; pageNumber++){
            const page = await pdfDocument.getPage(pageNumber);
            const pageSize = page.getViewport({
                scale: 1
            });
            const viewport = page.getViewport({
                scale: scale
            });
            // PDF.js installs embedded fonts in the viewer iframe's FontFaceSet.
            // Render there so the canvas can resolve those temporary font families.
            const canvas = renderDocument.createElement('canvas');
            canvas.width = Math.ceil(viewport.width);
            canvas.height = Math.ceil(viewport.height);
            const context = canvas.getContext('2d');
            if (!context) throw new Error('Unable to create canvas context for encrypted PDF');
            await page.render({
                canvasContext: context,
                viewport: viewport,
                annotationMode: $55276d1402d44ed1$var$annotationModeEnableStorage,
                annotationStorage: pdfDocument.annotationStorage,
                background: 'white'
            }).promise;
            const blob = await new Promise((resolve, reject)=>canvas.toBlob((value)=>value ? resolve(value) : reject(new Error('Unable to render encrypted PDF page')), 'image/jpeg', $55276d1402d44ed1$var$rasterJpegQuality));
            pages.push({
                data: new Uint8Array(await blob.arrayBuffer()),
                width: pageSize.width,
                height: pageSize.height
            });
        }
        return (0, $7c5b76d207f7edb7$export$a83fbdcef2db12b3)({
            type: 'rasterize',
            pages: pages
        });
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $55276d1402d44ed1$export$9bf81fc16d2d903d.prototype, "valuesScript", void 0);
$55276d1402d44ed1$export$9bf81fc16d2d903d = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('pdf-viewer')
], $55276d1402d44ed1$export$9bf81fc16d2d903d);








var $cbe64abf67d111f6$exports = {};

let $cbe64abf67d111f6$var$url = new URL(import.meta.resolve("1UFJY"));
$cbe64abf67d111f6$exports = $95c5dfe6050132a6$exports($cbe64abf67d111f6$var$url.toString(), $cbe64abf67d111f6$var$url.origin, true);


async function $8613879cbd8f8afe$export$45dd46e8f031b200(files, comment) {
    const worker = new Worker($cbe64abf67d111f6$exports);
    await new Promise((resolve)=>worker.addEventListener('message', resolve, {
            once: true
        }));
    const zippable = files.reduce((acc, { filename: filename, data: data })=>{
        acc[filename] = data;
        return acc;
    }, {});
    worker.postMessage({
        files: zippable,
        comment: comment
    });
    const event = await new Promise((resolve)=>worker.addEventListener('message', resolve, {
            once: true
        }));
    worker.terminate();
    if (event.data.type === 'zip-error') throw new Error('Error creating ZIPs.');
    return event.data.data;
}



class $a1bcbf2f50d52bc3$export$8820d0a37b88b23d extends HTMLElement {
    current = 0;
    hasChanges = false;
    isSubmitting = false;
    selectTemplate(event) {
        const index = +event.target.value;
        if (index === this.current) return;
        this.viewerElements[this.current].classList.add('v-hidden');
        this.editTemplateLinks[this.current].hidden = true;
        this.current = index;
        this.viewerElements[this.current].classList.remove('v-hidden');
        this.editTemplateLinks[this.current].hidden = false;
    }
    cancelSend() {
        this.reviewPanel.classList.remove('v-hidden');
        this.confirmPanel.hidden = true;
    }
    async submit(event) {
        event.preventDefault();
        if (this.isSubmitting) return;
        const submitType = event.detail.get('type');
        if (submitType === 'confirm-send') {
            this.reviewPanel.classList.add('v-hidden');
            this.confirmPanel.hidden = false;
            return;
        }
        try {
            this.isSubmitting = true;
            await Promise.resolve();
            (0, $d926988b2eed7310$export$7f9cba67632f8265)(this.primaryForm, true);
            (0, $d926988b2eed7310$export$7f9cba67632f8265)(this.confirmPanel, true);
            let filename = this.primaryForm.elements.namedItem('filename').value.trim();
            const itemInfos = JSON.parse(this.itemInfos.textContent);
            const items = await Promise.all(this.viewerElements.map(async (el, i)=>{
                const info = itemInfos[i];
                if (el instanceof (0, $55276d1402d44ed1$export$9bf81fc16d2d903d)) {
                    if (info.type !== 'pdf') throw new Error(`Expected PDF item, got ${info.type}`);
                    const data = await el.save({
                        rasterizeEncrypted: submitType !== 'zip'
                    });
                    return {
                        type: 'pdf',
                        title: info.title,
                        filename: info.filename,
                        start_page: info.start_page,
                        end_page: info.end_page,
                        readonly: info.readonly,
                        data: data,
                        remove_fields: submitType === 'send' || submitType === 'pdf-for-send' ? el.signatureFields.map(({ field: field })=>field.name) : undefined,
                        right_signature_placeholders: submitType === 'send' || submitType === 'pdf-for-send' ? el.signatureFields.map(({ field: field, value: value })=>{
                            const page_index = field.page;
                            const [x1, y1] = field.rect;
                            const x = x1;
                            let y;
                            const size = 14;
                            if (value.startsWith('[s')) {
                                y = y1 + 4;
                                value = value.replace(']', '              ]');
                            } else {
                                y = y1 + 3;
                                value = value.replace(']', '              ]');
                            }
                            return {
                                value: value,
                                page_index: page_index,
                                x: x,
                                y: y,
                                size: size
                            };
                        }) : undefined
                    };
                } else {
                    if (info.type !== 'image') throw new Error(`Expected image item, got ${info.type}`);
                    const response = await fetch(info.cors_url);
                    if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
                    const data = await response.arrayBuffer();
                    return {
                        type: 'image',
                        filename: info.filename,
                        data: new Uint8Array(data),
                        group: info.group,
                        content_type: info.content_type
                    };
                }
            }));
            if (submitType === 'zip') {
                if (!/\.zip$/i.test(filename)) filename += '.zip';
                const data = await (0, $8613879cbd8f8afe$export$45dd46e8f031b200)(items.map(({ filename: filename, data: data })=>({
                        filename: filename,
                        data: data
                    })), 'Created by ' + this.getAttribute('user_name') + ' at ' + this.getAttribute('organization_name'));
                const url = URL.createObjectURL(new Blob([
                    data
                ], {
                    type: 'application/zip'
                }));
                $a1bcbf2f50d52bc3$var$download(url, (0, $d5d33444928aec88$export$fa302515f2a866ab)(filename));
                return;
            }
            if (!/\.pdf$/i.test(filename)) filename += '.pdf';
            const data = await (0, $7c5b76d207f7edb7$export$a83fbdcef2db12b3)({
                type: 'merge',
                debug: submitType === 'pdf-for-send',
                resize_to_letter: submitType === 'send' || submitType === 'pdf-for-send',
                title: filename,
                author: this.getAttribute('user_name') + ' at ' + this.getAttribute('organization_name'),
                items: items
            });
            const blob = new Blob([
                data
            ], {
                type: 'application/pdf'
            });
            if (submitType === 'pdf' || submitType === 'pdf-for-send') {
                const url = URL.createObjectURL(blob);
                $a1bcbf2f50d52bc3$var$download(url, (0, $d5d33444928aec88$export$fa302515f2a866ab)(filename));
                return;
            } else if (submitType === 'send') {
                const body = (0, $d926988b2eed7310$export$2d71e4ce1d783c30)(this.confirmPanel);
                body.append('file', blob, filename);
                const response = await fetch(`${location.origin}/api/activity-sending-requests`, {
                    method: 'POST',
                    body: body
                });
                if (!response.ok) {
                    (0, $84fd3dc30499b2d0$export$dd5ae15f22741a23)(this.confirmPanel);
                    throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
                }
                this.confirmPanel.hidden = true;
                this.sentPanel.hidden = false;
                // prevent further unload warnings
                this.hasChanges = false;
                this.querySelectorAll('form-behavior').forEach((el)=>el.disconnectedCallback());
            } else throw new Error(`Unexpected submit type: ${submitType}`);
        } finally{
            (0, $d926988b2eed7310$export$7f9cba67632f8265)(this.primaryForm, false);
            (0, $d926988b2eed7310$export$7f9cba67632f8265)(this.confirmPanel, false);
            this.isSubmitting = false;
        }
    }
    pdfFieldChanged() {
        if (this.hasChanges) return;
        this.hasChanges = true;
        window.addEventListener('beforeunload', (event)=>{
            event.preventDefault();
            event.returnValue = 'You have unsaved work.'; // browser overrides this text
        });
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $a1bcbf2f50d52bc3$export$8820d0a37b88b23d.prototype, "viewerElements", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $a1bcbf2f50d52bc3$export$8820d0a37b88b23d.prototype, "itemInfos", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $a1bcbf2f50d52bc3$export$8820d0a37b88b23d.prototype, "editTemplateLinks", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $a1bcbf2f50d52bc3$export$8820d0a37b88b23d.prototype, "primaryForm", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $a1bcbf2f50d52bc3$export$8820d0a37b88b23d.prototype, "reviewPanel", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $a1bcbf2f50d52bc3$export$8820d0a37b88b23d.prototype, "confirmPanel", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $a1bcbf2f50d52bc3$export$8820d0a37b88b23d.prototype, "sentPanel", void 0);
$a1bcbf2f50d52bc3$export$8820d0a37b88b23d = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('prepare-pdf-documents')
], $a1bcbf2f50d52bc3$export$8820d0a37b88b23d);
function $a1bcbf2f50d52bc3$var$download(blobUrl, filename) {
    const a = document.createElement('a');
    if (!a.click) throw new Error('download: "a.click()" is not supported.');
    a.href = blobUrl;
    a.target = '_parent';
    // Use a.download if available. This increases the likelihood that
    // the file is downloaded instead of opened by another PDF plugin.
    if ('download' in a) a.download = filename;
    // <a> must be in the document for recent Firefox versions,
    // otherwise .click() is ignored.
    (document.body || document.documentElement).append(a);
    a.click();
    a.remove();
}





class $51e5200ea0fe250c$export$b64fa31f87d70dc7 extends HTMLElement {
    selectTemplates(event) {
        const target = event.target;
        const select = target.dataset.select;
        const checkboxes = Array.from(this.form.elements.namedItem('template'));
        const newValue = !checkboxes.every((checkbox)=>checkbox.disabled || checkbox.checked === (checkbox.dataset.labels?.split(',').includes(select) ?? false));
        for (const checkbox of checkboxes){
            if (!(checkbox instanceof HTMLInputElement)) throw new Error('Expected HTMLInputElement');
            if (checkbox.disabled) continue;
            switch(select){
                case 'all':
                    checkbox.checked = true;
                    break;
                case 'none':
                    checkbox.checked = false;
                    break;
                default:
                    checkbox.checked = (checkbox.dataset.labels?.split(',').includes(select) ?? false) === newValue;
                    break;
            }
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(checkbox);
        }
    }
    filterTemplates(event) {
        const target = event.target;
        const label = target.dataset.filterLabel.toLowerCase();
        target.parentElement?.querySelectorAll('[aria-current]').forEach((el)=>{
            el.removeAttribute('aria-current');
        });
        target.setAttribute('aria-current', 'true');
        const checkboxes = this.form.elements.namedItem('template');
        for (const checkbox of checkboxes){
            if (!(checkbox instanceof HTMLInputElement)) throw new Error('Expected HTMLInputElement');
            const visible = label === 'all' || checkbox.dataset.labels?.toLowerCase().split(',').includes(label);
            if (!visible && checkbox.checked || visible && !checkbox.checked) {
                checkbox.checked = !checkbox.checked;
                (0, $80a2320123ddcd02$export$89348ae70780cd7a)(checkbox);
            }
            checkbox.closest('label')?.toggleAttribute('hidden', !visible);
        }
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $51e5200ea0fe250c$export$b64fa31f87d70dc7.prototype, "form", void 0);
$51e5200ea0fe250c$export$b64fa31f87d70dc7 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('select-pdf-templates')
], $51e5200ea0fe250c$export$b64fa31f87d70dc7);







class $0fcfb41d6d068a63$export$5ebdec4bfbe94776 extends HTMLElement {
    disconnectController;
    refreshTimeout = 0;
    lastFingerprint;
    get form() {
        return this.closest('form');
    }
    connectedCallback() {
        const form = this.form;
        if (!form) return;
        this.lastFingerprint = $0fcfb41d6d068a63$var$getFingerprint((0, $d926988b2eed7310$export$2d71e4ce1d783c30)(form));
        this.disconnectController?.abort();
        this.disconnectController = new AbortController();
        form.addEventListener('change', this.scheduleRefresh, {
            signal: this.disconnectController.signal
        });
        form.addEventListener('editable-list-change', this.scheduleRefresh, {
            signal: this.disconnectController.signal
        });
    }
    disconnectedCallback() {
        this.disconnectController?.abort();
    }
    refresh = async ()=>{
        const body = (0, $d926988b2eed7310$export$2d71e4ce1d783c30)(this.form);
        const currentFingerprint = $0fcfb41d6d068a63$var$getFingerprint(body);
        if (this.lastFingerprint === currentFingerprint) return;
        const result = await (0, $84fd3dc30499b2d0$export$ed692cabb252e59b)(this.form, false);
        if (!result.valid) return;
        this.lastFingerprint = currentFingerprint;
        const url = new URL(this.getAttribute('src'), location.origin);
        const response = await fetch(url, {
            method: 'POST',
            body: body
        });
        if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
        const html = await response.text();
        const template = document.createElement('template');
        template.innerHTML = html;
        this.replaceWith(template.content);
    };
    scheduleRefresh = ()=>{
        clearTimeout(this.refreshTimeout);
        this.refreshTimeout = setTimeout(this.refresh, 300);
    };
}
$0fcfb41d6d068a63$export$5ebdec4bfbe94776 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('person-matches')
], $0fcfb41d6d068a63$export$5ebdec4bfbe94776);
function $0fcfb41d6d068a63$var$getFingerprint(formData) {
    const { first_name: first_name, last_name: last_name, dob: dob, ssn: ssn, medicaid_id: medicaid_id, veteran_id: veteran_id, agingis_id: agingis_id, scsep_participant_id: scsep_participant_id, external_id: external_id, emails: emails, phones: phones } = (0, $6980cc602f309497$export$ae2b2db16f8c0171)(formData);
    return [
        first_name,
        last_name,
        dob,
        ssn,
        medicaid_id,
        veteran_id,
        agingis_id,
        scsep_participant_id,
        external_id,
        ...emails.map((e)=>e.email),
        ...phones.map((p)=>p.number)
    ].join('/');
}






class $aff81e5db26f3050$var$ReportBackedSubqueryParameterElement extends HTMLElement {
    updateAggregation() {
        const remote = this.aggregationTargetFormGroup.querySelector('remote-input');
        const propertyInput = this.aggregationTargetFormGroup.querySelector('input[name^="definition/"]');
        if (!remote || !propertyInput) return;
        const url = new URL(remote.getAttribute('src'), location.origin);
        const original_entity_type = url.searchParams.get('entity_type');
        const original_aggregate = url.searchParams.get('aggregate');
        const entity_type = this.sourceReportEntityType;
        const entity_type_changed = original_entity_type !== entity_type;
        const aggregate_result_changed = (0, $413788c7d08dddf5$export$3604b59051dae160)[original_aggregate] !== (0, $413788c7d08dddf5$export$3604b59051dae160)[this.aggregateSelect.value];
        if (entity_type_changed || aggregate_result_changed) this.clearPropertyInput(propertyInput);
        if (!entity_type || this.aggregateSelect.value === 'count') {
            this.aggregationTargetFormGroup.hidden = true;
            propertyInput.required = false;
        } else {
            this.aggregationTargetFormGroup.hidden = false;
            propertyInput.required = true;
        }
        if (entity_type) this.updatePropertySuggestionSrc(entity_type);
    }
    get sourceReportEntityType() {
        const input = this.querySelector('input[name$="/report_id:nullstring"]');
        return input?.dataset.reportEntityType ?? null;
    }
    clearPropertyInput(propertyInput) {
        propertyInput.value = '';
        propertyInput.removeAttribute('value');
        propertyInput.removeAttribute('data-property');
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(propertyInput);
        propertyInput.previousElementSibling.className = 'color-fg-muted text-italic';
        propertyInput.previousElementSibling.textContent = 'Select field...';
    }
    updatePropertySuggestionSrc(entity_type) {
        const remote = this.aggregationTargetFormGroup.querySelector('remote-input');
        const url = new URL(remote.getAttribute('src'), location.origin);
        url.searchParams.set('entity_type', entity_type);
        url.searchParams.set('association', entity_type);
        url.searchParams.set('aggregate', this.aggregateSelect.value);
        remote.setAttribute('src', `${url.pathname}?${url.searchParams}`);
        const remoteFilterInput = remote.firstElementChild;
        remoteFilterInput.value = '';
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(remoteFilterInput);
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $aff81e5db26f3050$var$ReportBackedSubqueryParameterElement.prototype, "aggregateSelect", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $aff81e5db26f3050$var$ReportBackedSubqueryParameterElement.prototype, "aggregationTargetFormGroup", void 0);
$aff81e5db26f3050$var$ReportBackedSubqueryParameterElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('report-backed-subquery-parameter')
], $aff81e5db26f3050$var$ReportBackedSubqueryParameterElement);





class $7e8ab0f178a9e6db$var$ReportActivityParameterElement extends HTMLElement {
    get organizationId() {
        return this.getAttribute('organization-id');
    }
    handleActivityDefinitionChange() {
        const activityDefinitionId = this.definitionSelect.value;
        if (!activityDefinitionId) return;
        const autocomplete = this.querySelector('auto-complete');
        if (!autocomplete) throw new Error('Expected activity parameter autocomplete element.');
        const src = new URL(autocomplete.getAttribute('src'), location.href);
        src.pathname = `/api/organizations/${this.organizationId}/activity_definitions/${activityDefinitionId}/activity-select-suggestions`;
        autocomplete.setAttribute('src', `${src.pathname}?${src.searchParams}`);
        const listBox = this.querySelector('autocomplete-list-box');
        const valueInput = listBox?.querySelector('[data-target="autocomplete-list-box.valueInput"]');
        let value = null;
        try {
            value = valueInput?.value ? JSON.parse(valueInput.value) : null;
        } catch  {
            value = null;
        }
        const onlyAllActivities = value?.length === 1 && value[0].id === (0, $413788c7d08dddf5$export$578da1e890e33f2).allActivities.id;
        if (!onlyAllActivities) listBox?.clear?.();
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $7e8ab0f178a9e6db$var$ReportActivityParameterElement.prototype, "definitionSelect", void 0);
$7e8ab0f178a9e6db$var$ReportActivityParameterElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('report-activity-parameter')
], $7e8ab0f178a9e6db$var$ReportActivityParameterElement);





class $a8fa249533346289$var$ReportChoiceParameterElement extends HTMLElement {
    get property() {
        const input = this.propertySelect.querySelector('summary input');
        const value = input?.value;
        if (!value) return null;
        return JSON.parse(input.getAttribute('data-property'));
    }
    handlePropertyChange() {
        const property = this.property;
        if (!property) return;
        const autocomplete = this.querySelector('auto-complete');
        if (!autocomplete) throw new Error('Expected choice parameter autocomplete element.');
        const src = new URL(autocomplete.getAttribute('src'), location.href);
        if (src.searchParams.get('property_id') === property.property_id.toString()) return;
        src.searchParams.set('property_id', property.property_id.toString());
        autocomplete.setAttribute('src', `${src.pathname}?${src.searchParams}`);
        const listBox = this.querySelector('autocomplete-list-box');
        const valueInput = listBox?.querySelector('[data-target="autocomplete-list-box.valueInput"]');
        let value = null;
        try {
            value = valueInput?.value ? JSON.parse(valueInput.value) : null;
        } catch  {
            value = null;
        }
        const onlyPropertyIndependentWildcard = value?.length === 1 && (value[0].id === (0, $413788c7d08dddf5$export$578da1e890e33f2).allChoices.id || value[0].id === (0, $413788c7d08dddf5$export$578da1e890e33f2).unansweredChoice.id);
        if (!onlyPropertyIndependentWildcard) listBox?.clear?.();
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $a8fa249533346289$var$ReportChoiceParameterElement.prototype, "propertySelect", void 0);
$a8fa249533346289$var$ReportChoiceParameterElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('report-choice-parameter')
], $a8fa249533346289$var$ReportChoiceParameterElement);





class $7bdf4540474ac0e6$var$ReportColumnElement extends HTMLElement {
    // When the property, aggregate function, or expression type changed, update the grouping/summarization select options
    updateSummarizationOptions() {
        const propertyInput = this.propertyFormGroup?.querySelector('[data-property]');
        const property = propertyInput ? JSON.parse(propertyInput.getAttribute('data-property')) : null;
        const column = {
            type: this.typeInput.value,
            aggregate: this.aggregateSelect?.value
        };
        const groupingOptions = (0, $413788c7d08dddf5$export$3cb1b09c699eed1)(column, property, this.expressionInput?.expressionType ?? null);
        const options = (0, $13cfdc572434acbd$export$d3199b8dddc55be)(groupingOptions.map((g)=>({
                text: g === 'none' ? 'None' : g === 'group' ? 'Group' : (0, $413788c7d08dddf5$export$78c94180fed6d79f)[g],
                value: g,
                group: [
                    'none',
                    'group'
                ].includes(g) ? undefined : 'Summarization functions'
            })), groupingOptions.includes(this.groupingSelect.value) ? this.groupingSelect.value : 'none');
        this.groupingSelect.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)(options);
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $7bdf4540474ac0e6$var$ReportColumnElement.prototype, "typeInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $7bdf4540474ac0e6$var$ReportColumnElement.prototype, "propertyFormGroup", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $7bdf4540474ac0e6$var$ReportColumnElement.prototype, "groupingSelect", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $7bdf4540474ac0e6$var$ReportColumnElement.prototype, "aggregateSelect", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $7bdf4540474ac0e6$var$ReportColumnElement.prototype, "expressionInput", void 0);
$7bdf4540474ac0e6$var$ReportColumnElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('report-column')
], $7bdf4540474ac0e6$var$ReportColumnElement);









class $8cb82ae70312c60f$var$ReportConfigurationElement extends HTMLElement {
    previewTimeout = 0;
    previewController = undefined;
    connectedCallback() {
        if (this.previewContainer) this.preview();
        this.addEventListener('details-menu-selected', this, true);
    }
    disconnectedCallback() {
        this.removeEventListener('details-menu-selected', this, true);
    }
    handleEvent(event) {
        switch(event.type){
            case 'details-menu-selected':
                this.enqueuePreview(event);
                if (event.target instanceof Element && event.target.querySelector('[name^="is_shared:"],[name^="project_id"]')) this.handleSharedWithChanged(!!event.target.querySelector('[name^="is_shared:"]'));
                break;
        }
    }
    get type() {
        return this.getAttribute('entity-type');
    }
    get organization_id() {
        return this.getAttribute('organization-id');
    }
    get previewStatusContainer() {
        return document.getElementById(this.getAttribute('preview-status'));
    }
    validateConfiguration() {
        return (0, $84fd3dc30499b2d0$export$ed692cabb252e59b)(this.form, true, this);
    }
    setLoadingPreview() {
        this.previewContainer.innerHTML = `<h2 class="p-3"><span>Loading</span><span class="AnimatedEllipsis"></span></h2>`;
        this.previewStatusContainer.innerHTML = `<span class="AnimatedEllipsis"></span>`;
        this.querySelectorAll('output[report-parameter-value-output]').forEach((el)=>el.innerHTML = `<span>Loading</span><span class="AnimatedEllipsis"></span>`);
    }
    setPreviewValidationError() {
        this.previewContainer.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`
      <h2 class="p-3">Validation error</h2>
    `);
        this.previewStatusContainer.textContent = '0';
        this.querySelectorAll('output[report-parameter-value-output]').forEach((el)=>el.innerHTML = '');
    }
    setPreviewServerError(sessionExpired) {
        this.previewContainer.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`
      <h2 class="p-3">
        ${sessionExpired ? 'Session expired' : 'Error loading report preview.'}
      </h2>
    `);
        this.previewStatusContainer.textContent = '0';
        this.querySelectorAll('output[report-parameter-value-output]').forEach((el)=>el.innerHTML = '');
    }
    setPreviewResults(fragment) {
        this.previewContainer.innerHTML = fragment;
        const parameter_values = this.previewContainer.querySelector('dashboard-controller[parameter_values]')?.getAttribute('parameter_values');
        if (parameter_values) {
            this.previewStatusContainer.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$1d8a03084661a191), 'color-fg-success'));
            this.previewParameterValues(JSON.parse(parameter_values));
        }
    }
    onReportGridRowsLoaded(event) {
        if (event.target instanceof Element && event.target.closest('dashboard-controller')) // ignore events originating from a dashboard grid.
        return;
        const { count: count, parameter_values: parameter_values } = event.detail;
        this.previewStatusContainer.textContent = (0, $5e22b13d8e41f6dd$export$688d13a530c5dcbc).format(count);
        this.previewParameterValues(parameter_values);
    }
    previewParameterValues(parameter_values) {
        this.querySelectorAll('output[report-parameter-value-output]').forEach((el)=>{
            el.innerHTML = '';
            const li = el.closest('li');
            const name = li?.querySelector('input[name$="/name"]')?.value;
            if (name && name in parameter_values) el.textContent = parameter_values[name]?.toString() ?? 'NULL';
        });
    }
    enqueuePreview(event) {
        if (event.target instanceof Element && event.target.closest('form') !== this.form) return;
        clearTimeout(this.previewTimeout);
        this.previewTimeout = setTimeout(()=>this.preview(), 300);
    }
    async preview() {
        clearTimeout(this.previewTimeout);
        const { valid: valid } = await (0, $84fd3dc30499b2d0$export$ed692cabb252e59b)(this.form, false, this.previewFields);
        if (!valid) return;
        if (this.previewController) this.previewController.abort('superseded');
        this.setLoadingPreview();
        const data = (0, $d926988b2eed7310$export$2d71e4ce1d783c30)(this.form);
        data.set('title', 'Preview');
        const body = new URLSearchParams(data);
        this.previewController = new AbortController();
        const response = await fetch(`/api/organizations/${this.organization_id}/reports/preview`, {
            method: 'POST',
            body: body,
            signal: this.previewController.signal
        });
        this.previewController = undefined;
        if (response.ok) {
            const fragment = await response.text();
            this.setPreviewResults(fragment);
        } else if (response.status === 400) this.setPreviewValidationError();
        else this.setPreviewServerError((0, $8f2070e09d7bee6a$export$91cdf58e199a84d0)(response));
    }
    columnSortChanged(event) {
        const target = event.target;
        for (const select of this.columnSortSelects)if (select !== target && select.value[0] >= (target.value[0] ?? '0') && select.value !== '') select.value = '';
        $8cb82ae70312c60f$var$updateColumnSortOptions(target, this.columnSortSelects);
    }
    columnSortFocused(event) {
        const target = event.target;
        $8cb82ae70312c60f$var$updateColumnSortOptions(target, this.columnSortSelects);
    }
    handleExpressionScopeRequest(event) {
        event.preventDefault();
        const { definition: { parameters: parameters }, properties: properties } = (0, $f3fc72dd1f3291ac$export$acd79bbf6f49afea)(this.form);
        for (const parameter of parameters){
            if (!(0, $413788c7d08dddf5$export$99da40ee05a17718).test(parameter.name)) continue;
            const result = (0, $4b520c18e6d520ac$export$ce555e23b0c0b6f2)({
                parameter: parameter,
                properties: properties,
                parseExpression: (expression)=>(0, $28bf66f5acd2204d$export$9692209d71b8f134)({
                        name: parameter.name,
                        expression: expression,
                        getDefinitionInfo: ()=>({
                                columns: [],
                                parameters: parameters,
                                properties: properties
                            })
                    })
            });
            if (result.valid) event.detail.identifiers[parameter.name] = result.type;
        }
    }
    async handleSharedWithChanged(is_shared_changed) {
        await new Promise((resolve)=>setTimeout(resolve)); // wait for value to commit.
        const projectIdInput = this.querySelector('[name="project_id"]:checked');
        if (!(projectIdInput instanceof HTMLInputElement)) throw new Error('Expected project_id input element');
        const isSharedInput = this.querySelector('[name^="is_shared:"]:checked');
        if (!(isSharedInput instanceof HTMLInputElement)) throw new Error('Expected is_shared input element');
        const is_shared = +isSharedInput.value;
        this.sharesFormGroup.hidden = is_shared !== (0, $413788c7d08dddf5$export$fbac3d2f26b21a45).SpecificOrganizations && is_shared !== (0, $413788c7d08dddf5$export$fbac3d2f26b21a45).SpecificUsers;
        const box = this.sharesFormGroup.querySelector('autocomplete-list-box');
        if (!box) throw new Error('Expected autocomplete-list-box element');
        if (is_shared_changed) box.clear();
        if (!this.sharesFormGroup.hidden) {
            this.sharesFormGroup.querySelector('.form-label').textContent = `Shared with ${is_shared === (0, $413788c7d08dddf5$export$fbac3d2f26b21a45).SpecificOrganizations ? 'organizations' : 'users'}`;
            const [path] = box.autocomplete.src.split('?');
            box.autocomplete.src = `${path}?with=${is_shared}${projectIdInput.value ? `&project_id=${projectIdInput.value}` : ''}`;
        }
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $8cb82ae70312c60f$var$ReportConfigurationElement.prototype, "form", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $8cb82ae70312c60f$var$ReportConfigurationElement.prototype, "previewFields", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $8cb82ae70312c60f$var$ReportConfigurationElement.prototype, "previewContainer", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $8cb82ae70312c60f$var$ReportConfigurationElement.prototype, "columnSortSelects", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $8cb82ae70312c60f$var$ReportConfigurationElement.prototype, "sharesFormGroup", void 0);
$8cb82ae70312c60f$var$ReportConfigurationElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('report-configuration')
], $8cb82ae70312c60f$var$ReportConfigurationElement);
function $8cb82ae70312c60f$var$updateColumnSortOptions(target, selects) {
    const max = Math.max(...selects.map((x)=>+(x.value[0] ?? '-1'))) + (target.value ? 1 : 2);
    for (const option of target.options)option.disabled = option.value > max.toString();
}






class $008a206262ce75a1$export$1f6a6ab45fe37b4d extends HTMLElement {
    editableList = null;
    timeout = 0;
    connectedCallback() {
        this.addEventListener('change', this);
        this.addEventListener('blur', this);
        this.addEventListener('keydown', this);
        this.editableList = this.closest('editable-list');
        this.editableList?.addEventListener('change', this);
        this.editableList?.addEventListener('details-menu-selected', this, {
            capture: true
        });
        this.editableList?.addEventListener('editable-list-change', this);
    }
    disconnectedCallback() {
        this.removeEventListener('change', this);
        this.removeEventListener('blur', this);
        this.removeEventListener('keydown', this);
        this.editableList?.removeEventListener('change', this);
        this.editableList?.removeEventListener('details-menu-selected', this, {
            capture: true
        });
        this.editableList?.removeEventListener('editable-list-change', this);
    }
    get input() {
        return this.querySelector('input');
    }
    // get note() {
    //   return this.closest('.form-group')!.querySelector('.note:not(.error)')!;
    // }
    get expressionType() {
        return this.getAttribute('expression-type');
    }
    set expressionType(value) {
        if (value === null) this.removeAttribute('expression-type');
        else this.setAttribute('expression-type', value);
        this.dispatchEvent(new CustomEvent('report-expression-changed'));
    }
    handleEvent(event) {
        if (event.type === 'editable-list-change') {
            if (event.target !== this.editableList) return;
            const indexes = event.detail.indexes;
            const node = (0, $28bf66f5acd2204d$export$49e0f493cc4d655f)(this.input.value, indexes);
            if (node) {
                clearTimeout(this.timeout);
                this.input.value = (0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(node);
                this.processChange();
                (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.input);
            }
        } else if (event.target === this.input) {
            if (event instanceof KeyboardEvent) {
                if (event.key === 'Enter') event.preventDefault();
                else return;
            }
            if (event.isTrusted) {
                clearTimeout(this.timeout);
                this.processChange();
            }
        } else {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(this.processChange, 300);
        }
    }
    processChange = ()=>{
        if (this.input.value.trim() === '') {
            // this.note.innerHTML = render(expressionHelpText);
            this.expressionType = null;
            return;
        }
        const result = $008a206262ce75a1$var$parseAndValidate(this.input);
        if (!result.valid) {
            setTimeout(()=>{
                (0, $84fd3dc30499b2d0$export$e0ddcd48746f2dd9)(this.input, result.reason);
                this.closest('.form-group')?.classList.add('errored');
            });
            this.expressionType = null;
            return;
        }
        const formatted = (0, $6d4649a4b0d9f10a$export$8fc0a65b8428632a)(result.originalNode);
        if (this.input.value !== formatted) {
            this.input.value = formatted;
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.input);
        }
        this.expressionType = result.type;
    };
}
if (!window.customElements.get('report-expression-input')) {
    window.ReportExpressionInputElement = $008a206262ce75a1$export$1f6a6ab45fe37b4d;
    window.customElements.define('report-expression-input', $008a206262ce75a1$export$1f6a6ab45fe37b4d);
}
function $008a206262ce75a1$var$parseAndValidate(input) {
    let name;
    if (input.name.includes('/parameters/')) {
        const raw = input.closest('li')?.querySelector('input[name$="/name"]')?.value?.toUpperCase();
        if (raw && (0, $413788c7d08dddf5$export$99da40ee05a17718).test(raw)) name = raw;
        else name = `$PARAMETER_${parseInt(input.name.split('/')[2], 10)}`;
    } else if (input.name.includes('/columns/')) name = (0, $28bf66f5acd2204d$export$9c93ed85bbc3de64)(parseInt(input.name.split('/')[2], 10));
    else return {
        valid: false,
        reason: 'Unable to locate name associated with formula.'
    };
    return (0, $28bf66f5acd2204d$export$9692209d71b8f134)({
        name: name,
        expression: input.value,
        getDefinitionInfo: ()=>{
            const { definition: { columns: columns, parameters: parameters }, properties: properties } = (0, $f3fc72dd1f3291ac$export$acd79bbf6f49afea)(input.form);
            return {
                columns: columns,
                parameters: parameters,
                properties: properties
            };
        }
    });
}
(0, $84fd3dc30499b2d0$export$86f1725708ac86dc)((input)=>{
    if (input instanceof HTMLInputElement && input.type === 'text' && input.value.length && input.parentElement instanceof $008a206262ce75a1$export$1f6a6ab45fe37b4d) {
        const result = $008a206262ce75a1$var$parseAndValidate(input);
        if (!result.valid) return result.reason;
    }
    return null;
});









function $2f915ffe05c9fc45$var$booleanFilterValueTemplate(value, choices, name, controlId, disabled) {
    choices = choices || [
        {
            choice_id: 0,
            exclusive: 0,
            label: 'No'
        },
        {
            choice_id: 1,
            exclusive: 0,
            label: 'Yes'
        }
    ];
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`
    <select
      id="${controlId}"
      class="form-select select-sm"
      name="${name}:boolean"
      aria-label="Value"
      ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
    >
      ${choices.map((c)=>(0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`
          <option
            value="${Boolean(c.choice_id)}"
            ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('selected', value === Boolean(c.choice_id))}
          >
            ${c.label}
          </option>
        `)}
    </select>
  `;
}
function $2f915ffe05c9fc45$var$dateFilterValueTemplate(value, name, controlId, disabled) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`
    <date-input class="d-flex position-relative" relative parametric>
      ${(0, $0f19b6a07911d9cc$export$8e2ee32c32a0ef22)({
        name: `${name}:date:relative:parametric`,
        required: true,
        ariaLabel: 'Value',
        value: value,
        small: true,
        id: controlId,
        disabled: disabled
    })}
    </date-input>
  `;
}
function $2f915ffe05c9fc45$var$stringFilterValueTemplate(value, name, controlId, disabled) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
    id="${controlId}"
    type="text"
    name="${name}"
    class="form-control input-sm"
    aria-label="Value"
    value="${value}"
    maxlength="100"
    required
    autocomplete="off"
    autocorrect="off"
    autocapitalize="on"
    spellcheck="false"
    ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
  />`;
}
function $2f915ffe05c9fc45$var$numberFilterValueTemplate(value, type, name, controlId, disabled) {
    const listId = (0, $65af17b6a828fccf$export$9e1c824dbb29e809)();
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<number-input
    minimum-fraction-digits="${type === 'currency' ? 2 : 0}"
    maximum-fraction-digits="${type === 'int' ? 0 : 2}"
    parametric
    ><input
      id="${controlId}"
      type="text"
      name="${name}:integer:parametric"
      class="form-control input-sm"
      aria-label="Value"
      value="${value === null ? '' : value}"
      required
      ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('disabled', disabled)}
      list="${listId}" />
    <datalist id="${listId}"></datalist
  ></number-input>`;
}
function $2f915ffe05c9fc45$var$listBoxFilterValueTemplate(organization_id, entity_type, property, filter, name, controlId, disabled, wildcards) {
    if (property.choice_type !== 'big-single' && property.choice_type !== 'big-multiple' && !(property.response && [
        'single',
        'multiple'
    ].includes(property.choice_type)) && property.property_id !== (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.gender && property.property_id !== (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.gender_identity && property.property_id !== (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.sexual_orientation && property.property_id !== (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.race && property.property_id !== (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.ethnicity && property.property_id !== (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.marital_status && property.property_id !== (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_language && property.property_id !== (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.type && property.property_id !== (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_dow) throw new Error(`Property ${property.property_id} is not supported in list box.`);
    let src;
    switch(property.property_id){
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_physical.city:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_physical.postal_code:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_physical.region_abbr:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.primary_physical.subregion:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.city:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.postal_code:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.region_abbr:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.subregion:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_physical.city:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_physical.postal_code:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_physical.region_abbr:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.create_organization_primary_physical.subregion:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_physical.city:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_physical.postal_code:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_physical.region_abbr:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).person.primary_physical.subregion:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_physical.city:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_physical.postal_code:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_physical.region_abbr:
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).organization_project.primary_physical.subregion:
            {
                const params = new URLSearchParams({
                    category: (0, $c1de6d172f4f6f9e$export$cc0d55d7ff08492f)[property.property_id],
                    wildcards: wildcards.toString()
                });
                src = `/api/addresses/suggestions?${params}`;
                break;
            }
        case (0, $c1de6d172f4f6f9e$export$3f9e8a95c406046).activity.sctid:
            {
                const params = new URLSearchParams({
                    'semantic-tag': 'procedure',
                    control: 'autocomplete'
                });
                src = `/api/snomed/concepts?${params}`;
                break;
            }
        default:
            {
                if (property.type === 'varchar100' && property.choice_type === 'big-single' && (0, $c1de6d172f4f6f9e$export$a83037be00b92f3e)[property.format]) {
                    const params = new URLSearchParams({
                        category: (0, $c1de6d172f4f6f9e$export$a83037be00b92f3e)[property.format],
                        wildcards: wildcards.toString()
                    });
                    src = `/api/addresses/suggestions?${params}`;
                    break;
                }
                const params = new URLSearchParams({
                    property_id: property.property_id.toString(),
                    operator: filter.operator,
                    wildcards: wildcards.toString(),
                    entity_type: entity_type
                });
                src = `/api/organizations/${organization_id}/reports/filter-suggestions?${params}`;
                break;
            }
    }
    return (0, $0cc28ac8708b4f9d$export$c8ce1c1a107990cc)({
        id: controlId,
        label: 'Value',
        name: `${name}:json`,
        value: filter.value,
        required: true,
        autocompleteSrc: src,
        disabled: disabled,
        parametric: wildcards
    });
}
function $2f915ffe05c9fc45$export$cf33aefe7f9b5b61(organization_id, entity_type, property, filter, name, controlId, disabled, wildcards) {
    if (!(0, $413788c7d08dddf5$export$156328d95560793b)(filter, property).includes(filter.operator)) return null;
    const info = (0, $413788c7d08dddf5$export$bce341c22388011b)(filter, property, filter.operator);
    if (info === null) return null;
    if (info === 'blank') return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
      type="hidden"
      name="${name}"
      value="${filter.operator}"
    />`;
    switch(info.type){
        case 'date':
            {
                let value;
                if (filter.value === null) value = null;
                else if (typeof filter.value === 'number') value = new Date(filter.value);
                else if (typeof filter.value === 'string') {
                    if ((0, $b78c044e3d911d2e$export$aebd7d4ffee5ebdd)(filter.value)) value = filter.value;
                    else if ((0, $413788c7d08dddf5$export$99da40ee05a17718).test(filter.value.toUpperCase())) // toUpperCase handles dev data before uppercase was enforced.
                    value = filter.value.toUpperCase();
                    else value = new Date(filter.value);
                } else throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
                return $2f915ffe05c9fc45$var$dateFilterValueTemplate(value, name, controlId, disabled);
            }
        case 'bit':
            if (filter.value !== null && typeof filter.value !== 'boolean') throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
            if (!property) throw new Error(`Expected property for ${info.type} filter filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
            return $2f915ffe05c9fc45$var$booleanFilterValueTemplate(filter.value === null ? true : filter.value, property.choices, name, controlId, disabled);
        case 'varchar100':
        case 'varcharmax':
            if (info.choice_type === 'none') {
                if (filter.value !== null && typeof filter.value !== 'string') throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
                return $2f915ffe05c9fc45$var$stringFilterValueTemplate(filter.value || '', name, controlId, disabled);
            } else {
                if (!property) throw new Error(`Expected property for ${info.type} filter filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
                return $2f915ffe05c9fc45$var$listBoxFilterValueTemplate(organization_id, entity_type, property, filter, name, controlId, disabled, wildcards);
            }
        case 'activity':
        case 'uniqueidentifier':
            if (info.choice_type === 'none') throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
            else {
                if (!property) throw new Error(`Expected property for ${info.type} filter filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
                return $2f915ffe05c9fc45$var$listBoxFilterValueTemplate(organization_id, entity_type, property, filter, name, controlId, disabled, wildcards);
            }
        case 'int':
            if (info.choice_type === 'none') {
                if (filter.value !== null && typeof filter.value !== 'number' && !(typeof filter.value === 'string' && (0, $413788c7d08dddf5$export$99da40ee05a17718).test(filter.value))) throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
                return $2f915ffe05c9fc45$var$numberFilterValueTemplate(filter.value, 'int', name, controlId, disabled);
            } else {
                if (!property) throw new Error(`Expected property for ${info.type} filter filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
                return $2f915ffe05c9fc45$var$listBoxFilterValueTemplate(organization_id, entity_type, property, filter, name, controlId, disabled, wildcards);
            }
        case 'decimal':
        case 'currency':
            if (filter.value !== null && typeof filter.value !== 'number' && !(typeof filter.value === 'string' && (0, $413788c7d08dddf5$export$99da40ee05a17718).test(filter.value))) throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
            return $2f915ffe05c9fc45$var$numberFilterValueTemplate(filter.value, info.type, name, controlId, disabled);
        default:
            throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
    }
}



class $0bfd723e93262dd0$var$ReportFilterElement extends HTMLElement {
    get organization_id() {
        return this.getAttribute('organization-id');
    }
    get entity_type() {
        return this.getAttribute('entity-type');
    }
    get valueElementID() {
        return this.getAttribute('value-element-id');
    }
    get valueFormGroup() {
        return this.valueContainer.closest('.form-group');
    }
    get type() {
        return this.typeInput.value;
    }
    get property() {
        const input = this.propertySelect.querySelector('summary input');
        const value = input?.value;
        if (!value) return null;
        return JSON.parse(input.getAttribute('data-property'));
    }
    get operator() {
        return this.operatorSelect.value;
    }
    set operator(value) {
        this.operatorSelect.value = value;
    }
    get aggregate() {
        return this.aggregateSelect?.value;
    }
    get operatorFormGroup() {
        return this.operatorSelect.closest('.form-group');
    }
    handleLeftSideChange() {
        const filter = {
            type: this.type,
            aggregate: this.aggregate
        };
        const property = this.property;
        const ops = (0, $413788c7d08dddf5$export$156328d95560793b)(filter, property);
        // coerce operator
        let current = this.operator;
        this.operator = current = ops.includes(current) ? current : ops[0];
        // show/hide operator select
        this.operatorFormGroup.hidden = ops.length === 0;
        this.operatorSelect.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)(ops.map((op)=>(0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<option value="${op}" ${(0, $f4d1565f2a6712b7$export$65c20e333206336e)('selected', op === current)}>
            ${property?.type === 'date' ? (0, $413788c7d08dddf5$export$cc43c7363164eb92)[op] : (0, $413788c7d08dddf5$export$16e3502ebc32b20f)[op]}
          </option>`));
        this.setValueInput();
    }
    handleOperatorChange() {
        if (this.operator === 'blank' || this.operator === 'notblank' || this.valueFormGroup?.hidden) this.setValueInput();
    }
    setValueInput() {
        const nameBase = this.getAttribute('name');
        const wildcards = this.getAttribute('wildcards') === 'true';
        const property = this.property;
        const property_id = property?.property_id;
        const operator = this.operator;
        const filter = this.type === 'standard' ? {
            type: 'standard',
            property_id: property_id,
            operator: operator,
            value: null
        } : {
            type: 'subquery',
            aggregate: this.aggregate,
            operator: operator,
            subquery_property_id: property_id,
            value: null
        };
        const valueTemplate = (0, $2f915ffe05c9fc45$export$cf33aefe7f9b5b61)(this.organization_id, this.entity_type, property, filter, `${nameBase}/value`, this.valueElementID, false, wildcards);
        this.valueContainer.closest('.form-group').hidden = !valueTemplate || this.operator === 'blank' || this.operator === 'notblank';
        this.valueContainer.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)(valueTemplate);
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $0bfd723e93262dd0$var$ReportFilterElement.prototype, "typeInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $0bfd723e93262dd0$var$ReportFilterElement.prototype, "propertySelect", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $0bfd723e93262dd0$var$ReportFilterElement.prototype, "aggregateSelect", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $0bfd723e93262dd0$var$ReportFilterElement.prototype, "operatorSelect", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $0bfd723e93262dd0$var$ReportFilterElement.prototype, "valueContainer", void 0);
$0bfd723e93262dd0$var$ReportFilterElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('report-filter')
], $0bfd723e93262dd0$var$ReportFilterElement);



function $03f92b280c8e4126$export$3cb52831b17ccdb3(max) {
    if (!Number.isInteger(max) || max < 1) throw new Error('max must be an integer greater than or equal to 1');
    let active = 0;
    const queue = [];
    function drain() {
        while(active < max && queue.length > 0){
            const run = queue.shift();
            run();
        }
    }
    return function limit(task) {
        return new Promise((resolve, reject)=>{
            const run = ()=>{
                active++;
                Promise.resolve().then(task).then(resolve, reject).finally(()=>{
                    active--;
                    drain();
                });
            };
            queue.push(run);
            drain();
        });
    };
}





function $c1b48b0050081e30$export$65a4cef24bc84ad2() {
    return new Promise((resolve)=>{
        if (document.visibilityState === 'visible') {
            resolve();
            return;
        }
        document.addEventListener('visibilitychange', ()=>resolve(), {
            once: true,
            passive: true
        });
    });
}
function $c1b48b0050081e30$export$a5ad41187e479ecf(element, options = {
    threshold: 0.01
}) {
    return new Promise((resolve)=>{
        new IntersectionObserver((entries, observer)=>{
            for (const { isIntersecting: isIntersecting } of entries)if (isIntersecting) {
                observer.disconnect();
                resolve();
            }
        }, options).observe(element);
    });
}


const $cbb6fd30410eef97$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
const $cbb6fd30410eef97$var$limit = (0, $03f92b280c8e4126$export$3cb52831b17ccdb3)(2);
const $cbb6fd30410eef97$var$datetimeFormat = new Intl.DateTimeFormat((0, $12c3f7ece07822ce$export$d7f512c98c859244), {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
});
function $cbb6fd30410eef97$var$reportLinkValue(value, colDef) {
    const base58UuidLinkPath = colDef?.context?.base58_uuid_link_path;
    if (typeof value !== 'string') return '';
    if (typeof base58UuidLinkPath !== 'string') return value;
    try {
        return new URL(`${base58UuidLinkPath}${(0, $52ec208b1be5af58$export$7077a352e654daea)(value)}`, location.origin).href;
    } catch  {
        return '';
    }
}
const $cbb6fd30410eef97$var$columnTypes = {
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).single_choice]: {
        valueFormatter: ({ value: value, colDef: colDef })=>{
            if (typeof value === 'number') ;
            else if (typeof value === 'boolean') value = value ? 1 : 0;
            else return value;
            const choices = colDef?.context?.choices;
            return choices?.find((c)=>c.choice_id === value)?.label;
        }
    },
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).multiple_choice]: {
        valueFormatter: ({ value: value, colDef: colDef })=>{
            if (typeof value !== 'number') return value;
            const choices = colDef?.context?.choices;
            return choices?.filter((c)=>(2 ** c.choice_id & value) !== 0).map((c)=>c.label).join(', ');
        }
    },
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).boolean]: {
        valueFormatter: ({ value: value })=>{
            if (typeof value !== 'boolean' && value !== 0 && value !== 1) return value;
            return value ? (0, $b11db1b62d4a8f76$export$310250c811816278)[$cbb6fd30410eef97$var$locale] : (0, $b11db1b62d4a8f76$export$9692d1a0658a3861)[$cbb6fd30410eef97$var$locale];
        }
    },
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).date]: {
        valueFormatter: ({ value: value })=>{
            if (typeof value !== 'string' || value === '') return value;
            if (value.length === 10) {
                const ds = value.split('-').map((s)=>parseInt(s, 10));
                ds[1] = ds[1] - 1; // js month is zero-based month
                const d = new Date(ds[0], ds[1], ds[2]);
                return (0, $b78c044e3d911d2e$export$41d8fd8f1a1513f).format(d);
            }
            const d = new Date(value + (value.endsWith('Z') ? '' : 'Z'));
            return $cbb6fd30410eef97$var$datetimeFormat.format(d);
        }
    },
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).decimal]: {
        valueFormatter: ({ value: value })=>{
            if (typeof value !== 'number') return value;
            return (0, $5e22b13d8e41f6dd$export$688d13a530c5dcbc).format(value);
        }
    },
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).currency]: {
        valueFormatter: ({ value: value })=>{
            if (typeof value !== 'number') return value;
            return (0, $5e22b13d8e41f6dd$export$4670d0ed237a9270).format(value);
        }
    },
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).int]: {
        valueFormatter: ({ value: value })=>{
            if (typeof value !== 'number') return value;
            // hack: don't use commas when the int might be a year
            if (value >= 1900 || value < 2100) return value;
            return (0, $5e22b13d8e41f6dd$export$688d13a530c5dcbc).format(value);
        }
    },
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).row_href]: {
        cellRenderer: ({ value: value, colDef: colDef })=>{
            const a = document.createElement('a');
            a.className = 'btn btn-sm';
            a.href = value;
            a.textContent = colDef?.cellRendererParams?.title ?? (0, $b11db1b62d4a8f76$export$41e323ff2c7efe95)[$cbb6fd30410eef97$var$locale];
            a.style.marginTop = '-6px';
            return a;
        },
        valueFormatter: ({ value: value })=>{
            return location.origin + value;
        }
    },
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).link]: {
        cellRenderer: ({ value: value, colDef: colDef })=>{
            value = $cbb6fd30410eef97$var$reportLinkValue(value, colDef);
            if ((0, $c1de6d172f4f6f9e$export$34d61295a3a678)({
                value: value,
                format: colDef.context.link_format
            })) {
                const a = document.createElement('a');
                a.href = value;
                a.textContent = colDef?.headerName ?? value;
                return a;
            }
            return '';
        },
        valueFormatter: ({ value: value, colDef: colDef })=>$cbb6fd30410eef97$var$reportLinkValue(value, colDef)
    },
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).time]: {
        cellRenderer: ({ value: value })=>{
            if (typeof value === 'string' && value.length) {
                value = (0, $b78c044e3d911d2e$export$f41928ddf8b27367)(value).value;
                const time = document.createElement('time');
                time.dateTime = value;
                time.textContent = value;
                return time;
            }
            return '';
        }
    },
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).composite_address]: {
        cellRenderer: ({ colDef: colDef, data: row })=>{
            const map = colDef.context.composite_address_map;
            const address = {
                street_address: row[map['street_address']],
                sub_address: row[map['sub_address']],
                city: row[map['city']],
                region_abbr: row[map['region_abbr']],
                subregion: row[map['subregion']],
                postal_code: row[map['postal_code']],
                postal_code_ext: row[map['postal_code_ext']]
            };
            return (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $15a966c9a3403e81$export$16324af849cc98bd)(address, true));
        },
        valueGetter: ({ colDef: colDef, data: row })=>{
            const map = colDef.context.composite_address_map;
            const address = {
                street_address: row[map['street_address']],
                sub_address: row[map['sub_address']],
                city: row[map['city']],
                region_abbr: row[map['region_abbr']],
                subregion: row[map['subregion']],
                postal_code: row[map['postal_code']],
                postal_code_ext: row[map['postal_code_ext']]
            };
            return (0, $15a966c9a3403e81$export$26fab7c7c56386a9)(address);
        }
    },
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).composite_phone]: {
        cellRenderer: ({ colDef: colDef, data: row })=>{
            const map = colDef.context.composite_phone_map;
            const phone = {
                type: row[map['type']],
                number: row[map['number']],
                extension: row[map['extension']]
            };
            if (phone.type && phone.number) return (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $15a966c9a3403e81$export$ff1216816de7f138)(phone, true));
            return '';
        },
        valueGetter: ({ colDef: colDef, data: row })=>{
            const map = colDef.context.composite_phone_map;
            const phone = {
                type: row[map['type']],
                number: row[map['number']],
                extension: row[map['extension']]
            };
            if (phone.type && phone.number) return (0, $15a966c9a3403e81$export$ff1216816de7f138)(phone, false);
            return '';
        }
    },
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).composite_email]: {
        cellRenderer: ({ colDef: colDef, data: row })=>{
            const map = colDef.context.composite_email_map;
            const email = {
                type: row[map['type'] ?? 'zzz-nothing-matches-this-key'],
                email: row[map['email']]
            };
            if (email.type && email.email) return (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $15a966c9a3403e81$export$2b79b564cdea702d)(email, true, false));
            if (email.email) {
                const a = document.createElement('a');
                a.href = `mailto:${email.email}`;
                a.className = 'Link--primary';
                a.textContent = email.email;
                return a;
            }
            return '';
        },
        valueGetter: ({ colDef: colDef, data: row })=>{
            const map = colDef.context.composite_email_map;
            const email = {
                type: row[map['type'] ?? 'zzz-nothing-matches-this-key'],
                email: row[map['email']]
            };
            if (email.type && email.email) return `${email.type}: ${email.email}`;
            if (email.email) return email.email;
            return '';
        }
    },
    [(0, $413788c7d08dddf5$export$457cf8f69ee54250).value_map]: {
        valueFormatter: ({ value: value, colDef: colDef })=>{
            const map = colDef.context.value_map;
            return map[value] ?? value;
        }
    }
};
class $cbb6fd30410eef97$var$ReportGridElement extends HTMLElement {
    grid;
    connectedCallback() {
        agGrid.LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);
        if (this.closest('[hidden]')) return;
        this.initialize();
    }
    disconnectedCallback() {
        this.grid?.destroy();
    }
    initialize() {
        if (this.grid) return;
        const initialVisiblePromise = (0, $c1b48b0050081e30$export$65a4cef24bc84ad2)().then(()=>(0, $c1b48b0050081e30$export$a5ad41187e479ecf)(this));
        const options = JSON.parse(this.optionsScript.textContent);
        this.key = JSON.parse(this.keyScript.textContent);
        this.optionsScript.remove();
        options.getContextMenuItems = ()=>{
            return [
                'copy'
            ];
        };
        options.cellSelection = true;
        options.popupParent = document.body;
        options.columnTypes = $cbb6fd30410eef97$var$columnTypes;
        options.rowModelType = 'serverSide';
        options.skipHeaderOnAutoSize = true;
        options.suppressColumnVirtualisation = true;
        options.rowClassRules = {
            'color-bg-subtle': ({ rowIndex: rowIndex })=>rowIndex % 2 !== 0
        };
        options.defaultColDef = Object.assign(options.defaultColDef ?? {}, {
            headerComponentParams: {
                template: (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<div class="ag-cell-label-container" role="presentation">
            <span
              data-ref="eMenu"
              class="ag-header-icon ag-header-cell-menu-button"
              aria-hidden="true"
            ></span>
            <span
              data-ref="eFilterButton"
              class="ag-header-icon ag-header-cell-filter-button"
              aria-hidden="true"
            ></span>
            <div
              data-ref="eLabel"
              class="ag-header-cell-label"
              role="presentation"
            >
              <span
                data-ref="eText"
                class="ag-header-cell-text line-clamp-4"
              ></span>
              <span
                data-ref="eFilter"
                class="ag-header-icon ag-header-label-icon ag-filter-icon"
                aria-hidden="true"
              ></span>
              <span
                data-ref="eSortAsc"
                class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon"
                style="--ag-icon-size: 14px"
                aria-hidden="true"
              ></span>
              <span
                data-ref="eSortDesc"
                class="ag-header-icon ag-header-label-icon ag-sort-descending-icon"
                style="--ag-icon-size: 14px"
                aria-hidden="true"
              ></span>
              <!-- <span
                data-ref="eSortNone"
                class="ag-header-icon ag-header-label-icon ag-sort-none-icon"
                style="--ag-icon-size: 14px"
                aria-hidden="true"
              ></span> -->
              <span
                data-ref="eSortOrder"
                class="ag-sort-order"
                style="position: relative; bottom: -8px; left: -4px; font-size: 0.625rem"
                aria-hidden="true"
              ></span>
            </div>
          </div>`)
            }
        });
        options.serverSideDatasource = {
            getRows: async ({ request: { startRow: startRow, endRow: endRow, sortModel: sortModel }, success: success, fail: fail })=>{
                await initialVisiblePromise;
                await $cbb6fd30410eef97$var$limit(async ()=>{
                    const url = this.getAttribute('row-source');
                    const { parameter_values: parameter_values = {} } = (0, $6980cc602f309497$export$ae2b2db16f8c0171)(new FormData(this.parametersForm));
                    const response = await fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            startRow: startRow,
                            endRow: endRow,
                            sortModel: sortModel.slice(0, (0, $413788c7d08dddf5$export$f258709b40073be1).sorts),
                            key: this.key,
                            parameter_values: parameter_values
                        })
                    });
                    if (!response.ok) {
                        fail();
                        return;
                    }
                    const detail = await response.json();
                    success({
                        rowData: detail.rows,
                        rowCount: detail.count
                    });
                    this.dispatchEvent(new CustomEvent('report-grid-rows-loaded', {
                        detail: detail,
                        bubbles: true
                    }));
                });
            }
        };
        const grid = this.grid = agGrid.createGrid(this.gridContainer, options);
        grid.addEventListener('firstDataRendered', ()=>{
            setTimeout(()=>{
                const columns = grid.getAllDisplayedColumns();
                const widths = columns.map((c)=>c.getActualWidth());
                const columnsWidth = widths.reduce((a, b)=>a + b, 0);
                const gridWidth = this.clientWidth;
                if (columnsWidth > gridWidth - 16) return;
                const available = gridWidth - columnsWidth;
                const start = columns[0].getColId() === 'navigation' ? 1 : 0;
                const utilized = widths.slice(start).reduce((a, b)=>a + b, 0);
                const newWidths = [];
                for(let i = start; i < columns.length; i++){
                    const current = widths[i];
                    const ratio = current / utilized;
                    const newWidth = Math.min(current + available * ratio, Math.max(current, 500));
                    newWidths.push({
                        key: columns[i].getColId(),
                        newWidth: newWidth
                    });
                }
                grid.setColumnWidths(newWidths);
            });
        });
    }
    submitParameters(event) {
        event?.preventDefault();
        event?.target?.acceptChanges();
        if (event?.detail.get('download-csv') === 'true') {
            event.detail.delete('download-csv');
            const action = this.getAttribute('csv-action');
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = action;
            form.style.display = 'none';
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'key';
            input.value = this.key;
            form.appendChild(input);
            for (const [key, value] of event.detail.entries()){
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = value;
                form.appendChild(input);
            }
            document.body.appendChild(form);
            form.submit();
            form.remove();
            return;
        }
        if (this.grid) {
            this.grid.refreshServerSide({
                purge: true
            });
            if (event) {
                const { parameter_values: parameter_values = {} } = (0, $6980cc602f309497$export$ae2b2db16f8c0171)(new FormData(this.parametersForm));
                const locationUrl = new URL(location.href);
                (0, $413788c7d08dddf5$export$8731bf6742d09f4c)(locationUrl.searchParams, parameter_values);
                history.replaceState(null, '', locationUrl.href);
            }
        } else this.initialize();
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $cbb6fd30410eef97$var$ReportGridElement.prototype, "optionsScript", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $cbb6fd30410eef97$var$ReportGridElement.prototype, "keyScript", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $cbb6fd30410eef97$var$ReportGridElement.prototype, "gridContainer", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $cbb6fd30410eef97$var$ReportGridElement.prototype, "parametersForm", void 0);
$cbb6fd30410eef97$var$ReportGridElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('report-grid')
], $cbb6fd30410eef97$var$ReportGridElement);






class $35646ab919641f21$var$ReportSubqueryAggregationElement extends HTMLElement {
    updateAggregation() {
        const remote = this.aggregationTargetFormGroup.querySelector('remote-input');
        const url = new URL(remote.getAttribute('src'), location.origin);
        const original_entity_type = url.searchParams.get('entity_type');
        const original_aggregate = url.searchParams.get('aggregate');
        const entity_type = (0, $413788c7d08dddf5$export$416b29773ad00249)[this.associationSelect.value];
        const entity_type_changed = original_entity_type !== entity_type;
        const aggregate_result_changed = (0, $413788c7d08dddf5$export$3604b59051dae160)[original_aggregate] !== (0, $413788c7d08dddf5$export$3604b59051dae160)[this.aggregateSelect.value];
        const propertyInput = this.aggregationTargetFormGroup.querySelector('input[name^="definition/"]');
        if (entity_type_changed || aggregate_result_changed) this.clearPropertyInput(propertyInput);
        // reset filters and aggregate if entity type changed
        if (entity_type_changed) {
            this.aggregateSelect.value = 'count';
            this.closest('li')?.querySelector('editable-list[name$="/filters"]')?.removeAllListItems();
        }
        const aggregateGroup = this.aggregateSelect.closest('.form-group');
        if ((0, $413788c7d08dddf5$export$b65695534a22e57d)(this.associationSelect.value)) {
            aggregateGroup.hidden = true;
            if (this.aggregateSelect.value !== 'max') {
                this.aggregateSelect.value = 'max';
                (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.aggregateSelect);
            }
        } else if (aggregateGroup.hidden) {
            aggregateGroup.hidden = false;
            if (this.aggregateSelect.value !== 'count') {
                this.aggregateSelect.value = 'count';
                (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.aggregateSelect);
            }
        }
        if (this.aggregateSelect.value === 'count') {
            // hide the property input
            this.aggregationTargetFormGroup.hidden = true;
            propertyInput.required = false;
        } else {
            // show the property input
            this.aggregationTargetFormGroup.hidden = false;
            propertyInput.required = true;
        }
        // update the property input's remote input
        this.updatePropertySuggestionSrc();
    }
    clearPropertyInput(propertyInput) {
        propertyInput.value = '';
        propertyInput.removeAttribute('value');
        propertyInput.removeAttribute('data-property');
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(propertyInput);
        propertyInput.previousElementSibling.className = 'color-fg-muted text-italic';
        propertyInput.previousElementSibling.textContent = 'Select field...';
    }
    updatePropertySuggestionSrc() {
        const entity_type = (0, $413788c7d08dddf5$export$416b29773ad00249)[this.associationSelect.value];
        const editableList = this.closest('li')?.querySelector('editable-list[name$="filters"]');
        const containers = [
            this.aggregationTargetFormGroup,
            editableList?.itemTemplate?.content
        ].filter((x)=>x !== undefined);
        for (const container of containers){
            const remote = container.querySelector('remote-input');
            const url = new URL(remote.getAttribute('src'), location.origin);
            url.searchParams.set('entity_type', entity_type);
            url.searchParams.set('association', this.associationSelect.value);
            url.searchParams.set('aggregate', this.aggregateSelect.value);
            remote.setAttribute('src', `${url.pathname}?${url.searchParams}`);
            const remoteFilterInput = remote.firstElementChild;
            remoteFilterInput.value = '';
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(remoteFilterInput);
        }
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $35646ab919641f21$var$ReportSubqueryAggregationElement.prototype, "associationSelect", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $35646ab919641f21$var$ReportSubqueryAggregationElement.prototype, "aggregateSelect", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $35646ab919641f21$var$ReportSubqueryAggregationElement.prototype, "aggregationTargetFormGroup", void 0);
$35646ab919641f21$var$ReportSubqueryAggregationElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('report-subquery-aggregation')
], $35646ab919641f21$var$ReportSubqueryAggregationElement);



const $86d5a6bf9e174c59$export$947168b430e57c8 = {
    service_authorizations_count: 100,
    service_authorization_caps_count: 52,
    maxAmount: 1000000
};








const $bc8c4b9ea739c558$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
// const columnTypes: Record<string, AgGrid.ColTypeDef> = {};
class $bc8c4b9ea739c558$var$ServiceAuthorizationCapsElement extends HTMLElement {
    grid;
    connectedCallback() {
        agGrid.LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);
        addEventListener('hashchange', this);
        this.initialize();
        this.input.form.addEventListener((0, $ab6f099c20a34e1f$export$d97beb036594a815), this);
        this.input.form.addEventListener((0, $84fd3dc30499b2d0$export$56264cd4b3cf388f), this);
    }
    disconnectedCallback() {
        removeEventListener('hashchange', this);
        this.grid?.destroy();
        this.input.form.removeEventListener((0, $ab6f099c20a34e1f$export$d97beb036594a815), this);
        this.input.form.removeEventListener((0, $84fd3dc30499b2d0$export$56264cd4b3cf388f), this);
    }
    handleEvent(event) {
        switch(event.type){
            case 'hashchange':
                this.focusCellForLocationHash();
                return;
            case 0, $ab6f099c20a34e1f$export$d97beb036594a815:
                this.grid?.stopEditing();
                return;
            case 0, $84fd3dc30499b2d0$export$56264cd4b3cf388f:
                {
                    const errors = event.detail.errors;
                    const { start_date: authStartDate, end_date: authEndDate } = this.getAuthorizationInfo();
                    const gridRows = [];
                    this.grid?.forEachNode((node)=>{
                        if (typeof node.rowIndex === 'number' && node.data) gridRows.push({
                            rowIndex: node.rowIndex,
                            data: node.data
                        });
                    });
                    const invalidCell = (rowIndex, colKey, message)=>{
                        // this.grid?.startEditingCell({ rowIndex, colKey });
                        this.grid?.deselectAll();
                        this.grid?.clearRangeSelection();
                        this.grid?.addCellRange({
                            rowStartIndex: rowIndex,
                            rowEndIndex: rowIndex,
                            columnStart: colKey,
                            columnEnd: colKey
                        });
                        this.grid?.setFocusedCell(rowIndex, colKey);
                        errors.push({
                            message: message
                        });
                    };
                    for (const row of gridRows){
                        const { rowIndex: rowIndex, data: data } = row;
                        if (rowIndex > (0, $86d5a6bf9e174c59$export$947168b430e57c8).service_authorization_caps_count) {
                            invalidCell(rowIndex, 'start_date', `Cannot have more than ${(0, $86d5a6bf9e174c59$export$947168b430e57c8).service_authorization_caps_count} caps.`);
                            return;
                        }
                        if (!data.start_date) {
                            invalidCell(rowIndex, 'start_date', 'Cap start date is required.');
                            return;
                        }
                        if (!data.end_date) {
                            invalidCell(rowIndex, 'end_date', 'Cap end date is required.');
                            return;
                        }
                        if (data.amount === null || data.amount === undefined) {
                            invalidCell(rowIndex, 'amount', 'Cap amount is required.');
                            return;
                        }
                        if (data.amount < 0) {
                            invalidCell(rowIndex, 'amount', 'Cap amount must be non-negative.');
                            return;
                        }
                        if (data.amount > (0, $86d5a6bf9e174c59$export$947168b430e57c8).maxAmount) {
                            invalidCell(rowIndex, 'amount', `Cap amount cannot exceed ${(0, $5e22b13d8e41f6dd$export$4670d0ed237a9270).format((0, $86d5a6bf9e174c59$export$947168b430e57c8).maxAmount)}.`);
                            return;
                        }
                        if (data.approved_overage_amount === null || data.approved_overage_amount === undefined) {
                            invalidCell(rowIndex, 'approved_overage_amount', 'Approved overage is required.');
                            return;
                        }
                        if (data.approved_overage_amount < 0) {
                            invalidCell(rowIndex, 'approved_overage_amount', 'Approved overage must be non-negative.');
                            return;
                        }
                        if (data.approved_overage_amount > (0, $86d5a6bf9e174c59$export$947168b430e57c8).maxAmount) {
                            invalidCell(rowIndex, 'approved_overage_amount', `Approved overage cannot exceed ${(0, $5e22b13d8e41f6dd$export$4670d0ed237a9270).format((0, $86d5a6bf9e174c59$export$947168b430e57c8).maxAmount)}.`);
                            return;
                        }
                        const capStartDate = new Date(data.start_date + 'T00:00:00Z');
                        const capEndDate = new Date(data.end_date + 'T00:00:00Z');
                        if (authStartDate && capStartDate < authStartDate) {
                            invalidCell(rowIndex, 'start_date', `Cap start date must be on or after authorization start date.`);
                            return;
                        }
                        if (authEndDate && capEndDate > authEndDate) {
                            invalidCell(rowIndex, 'end_date', `Cap end date must be on or before authorization end date.`);
                            return;
                        }
                        if (capStartDate > capEndDate) {
                            invalidCell(rowIndex, 'start_date', 'Cap start date must be on or before cap end date.');
                            return;
                        }
                    }
                    return;
                }
        }
    }
    initialize() {
        if (this.grid) return;
        const rowData = JSON.parse(this.input.value);
        const disabled = this.hasAttribute('disabled');
        const showExternal = rowData.some((item)=>item.external_usage);
        // const initialVisiblePromise = documentVisible().then(() =>
        //   elementVisible(this)
        // );
        const dateValueFormatter = ({ value: value })=>{
            if (!value) return '';
            return (0, $b78c044e3d911d2e$export$6aa1a8800137fac7).format(new Date(value + 'T00:00:00Z'));
        };
        const dateValueParser = ({ newValue: newValue })=>{
            if (!newValue) return '';
            const date = (0, $b78c044e3d911d2e$export$7660134aa4da2247)(newValue);
            return date ? date.toISOString().slice(0, 10) : null; // return null to reject
        };
        const getBalance = (data)=>typeof data?.amount === 'number' && isFinite(data.amount) && typeof data.usage === 'number' && isFinite(data.usage) ? data.amount - data.usage // approved overage should not affect the balance or cumulative balance.
             : null;
        const amountValueParser = ({ newValue: newValue })=>{
            if (typeof newValue === 'number' && isFinite(newValue)) return newValue;
            if (typeof newValue !== 'string') return null;
            const trimmedValue = newValue.trim();
            if (!trimmedValue) return null;
            const isNegativeByParens = trimmedValue.startsWith('(') && trimmedValue.endsWith(')');
            const normalizedValue = trimmedValue.replace(/,/g, '').replace(/[^0-9.-]/g, '');
            if (!normalizedValue) return null;
            const parsed = parseFloat(normalizedValue);
            if (!isFinite(parsed)) return null;
            return isNegativeByParens ? -Math.abs(parsed) : parsed;
        };
        const options = {
            rowModelType: 'clientSide',
            rowData: rowData,
            getRowId: ({ data: data })=>data.service_authorization_cap_id,
            columnDefs: [
                {
                    colId: 'start_date',
                    field: 'start_date',
                    headerName: (0, $b11db1b62d4a8f76$export$9504159bc7ac9a88)[$bc8c4b9ea739c558$var$locale],
                    valueFormatter: dateValueFormatter,
                    valueParser: dateValueParser,
                    cellEditorParams: {
                        useFormatter: true,
                        maxLength: 20
                    },
                    width: 120,
                    editable: !disabled
                },
                {
                    colId: 'end_date',
                    field: 'end_date',
                    headerName: (0, $b11db1b62d4a8f76$export$5ac70ff8a5f1a5bf)[$bc8c4b9ea739c558$var$locale],
                    valueFormatter: dateValueFormatter,
                    valueParser: dateValueParser,
                    cellEditorParams: {
                        useFormatter: true,
                        maxLength: 20
                    },
                    width: 120,
                    editable: !disabled,
                    cellDataType: 'text'
                },
                {
                    colId: 'amount',
                    field: 'amount',
                    headerName: (0, $b11db1b62d4a8f76$export$8325dd816b79073b)[$bc8c4b9ea739c558$var$locale],
                    type: 'rightAligned',
                    valueFormatter: ({ value: value })=>typeof value === 'number' && isFinite(value) ? (0, $5e22b13d8e41f6dd$export$4670d0ed237a9270).format(value) : String(value ?? ''),
                    valueParser: amountValueParser,
                    width: 140,
                    editable: !disabled,
                    cellDataType: 'number',
                    aggFunc: 'sum'
                },
                {
                    colId: 'approved_overage_amount',
                    field: 'approved_overage_amount',
                    headerName: 'Approved overage',
                    type: 'rightAligned',
                    valueFormatter: ({ value: value })=>typeof value === 'number' && isFinite(value) ? (0, $5e22b13d8e41f6dd$export$4670d0ed237a9270).format(value) : String(value ?? ''),
                    valueParser: amountValueParser,
                    width: 140,
                    editable: !disabled,
                    cellDataType: 'number',
                    aggFunc: 'sum'
                },
                {
                    colId: 'usage',
                    field: 'usage',
                    headerName: (0, $b11db1b62d4a8f76$export$7cd02a45e553bdca)[$bc8c4b9ea739c558$var$locale],
                    type: 'rightAligned',
                    valueFormatter: ({ value: value })=>typeof value === 'number' && isFinite(value) ? (0, $5e22b13d8e41f6dd$export$4670d0ed237a9270).format(value) : String(value ?? ''),
                    width: 140,
                    aggFunc: 'sum'
                },
                {
                    colId: 'balance',
                    headerName: (0, $b11db1b62d4a8f76$export$344c4ed476f79fd1)[$bc8c4b9ea739c558$var$locale],
                    type: 'rightAligned',
                    valueGetter: ({ data: data })=>getBalance(data),
                    valueFormatter: ({ value: value })=>typeof value === 'number' && isFinite(value) ? (0, $5e22b13d8e41f6dd$export$4670d0ed237a9270).format(value) : String(value ?? ''),
                    width: 140,
                    aggFunc: 'sum'
                },
                {
                    colId: 'cumulative_balance',
                    headerName: (0, $b11db1b62d4a8f76$export$ecc1ea6da30d4fe9)[$bc8c4b9ea739c558$var$locale],
                    type: 'rightAligned',
                    valueGetter: ({ api: api, data: data, node: node })=>{
                        if (!data?.start_date || node?.footer) return null;
                        let total = 0;
                        api.forEachNode((rowNode)=>{
                            if (rowNode.footer || !rowNode.data?.start_date || rowNode.data.start_date >= data.start_date) return;
                            const balance = getBalance(rowNode.data);
                            if (typeof balance === 'number' && isFinite(balance)) total += balance;
                        });
                        return total;
                    },
                    valueFormatter: ({ value: value })=>typeof value === 'number' && isFinite(value) ? (0, $5e22b13d8e41f6dd$export$4670d0ed237a9270).format(value) : String(value ?? ''),
                    width: 170
                },
                {
                    colId: 'external_usage',
                    field: 'external_usage',
                    headerName: (0, $b11db1b62d4a8f76$export$e3a6c49230b600d)[$bc8c4b9ea739c558$var$locale],
                    type: 'rightAligned',
                    valueFormatter: ({ value: value })=>(0, $5e22b13d8e41f6dd$export$4670d0ed237a9270).format(value),
                    width: 140,
                    hide: !showExternal,
                    aggFunc: 'sum'
                },
                {
                    colId: 'external_id',
                    field: 'external_id',
                    headerName: (0, $b11db1b62d4a8f76$export$71cd312d72359181)[$bc8c4b9ea739c558$var$locale],
                    width: 100,
                    hide: !showExternal
                },
                {
                    colId: 'actions',
                    headerName: (0, $b11db1b62d4a8f76$export$5be663618fa0493a)[$bc8c4b9ea739c558$var$locale],
                    flex: 1,
                    sortable: false,
                    filter: false,
                    cellRenderer: (params)=>{
                        if (params.node.footer || disabled) return null;
                        return (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<button
                class="btn-octicon btn-octicon-danger"
                type="button"
                aria-label="${(0, $b11db1b62d4a8f76$export$168e7f4521755dda)[$bc8c4b9ea739c558$var$locale]}"
                data-grid-action="delete"
              >
                ${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$c6e11f163cc2dc47))}
              </button>`);
                    },
                    suppressNavigable: true,
                    cellRendererParams: {
                        suppressMouseEventHandling: ()=>true
                    }
                }
            ],
            defaultColDef: {
                suppressHeaderMenuButton: true
            },
            rowClassRules: {
                'color-bg-subtle': ({ rowIndex: rowIndex })=>rowIndex % 2 !== 0
            },
            suppressExcelExport: true,
            suppressCsvExport: true,
            domLayout: 'autoHeight',
            popupParent: document.body,
            undoRedoCellEditing: true,
            undoRedoCellEditingLimit: 20,
            singleClickEdit: true,
            stopEditingWhenCellsLoseFocus: true,
            cellSelection: disabled ? false : {
                enableColumnSelection: false,
                handle: {
                    mode: 'fill',
                    direction: 'y'
                }
            },
            onCellClicked: disabled ? undefined : this.onCellClicked,
            rowSelection: {
                mode: 'multiRow',
                checkboxes: false,
                headerCheckbox: false,
                enableClickSelection: false,
                copySelectedRows: false
            },
            processDataFromClipboard: disabled ? undefined : this.processDataFromClipboard,
            onCellValueChanged: ()=>{
                this.refreshBalanceDependentCells();
                this.syncInputValue();
            },
            onModelUpdated: this.refreshCumulativeBalance,
            onRowDataUpdated: this.syncInputValue,
            onFirstDataRendered: ()=>this.focusCellForLocationHash(),
            grandTotalRow: 'pinnedBottom'
        };
        this.grid = agGrid.createGrid(this.gridHost, options);
    }
    addCap() {
        const id = crypto.randomUUID();
        this.grid?.applyTransaction({
            add: [
                {
                    service_authorization_cap_id: id,
                    start_date: null,
                    end_date: null,
                    amount_type: 'money',
                    amount: null,
                    usage: 0,
                    approved_overage_amount: 0,
                    external_usage: 0
                }
            ]
        });
        this.grid?.setFocusedCell(this.grid.getRowNode(id).rowIndex, 'start_date');
    }
    addCaps(event) {
        const button = event.currentTarget;
        const type = button.value;
        const { start_date: start_date, end_date: end_date, amount: amount } = this.getAuthorizationInfo();
        if (!start_date || !end_date || start_date > end_date || amount === null) {
            alert('Please enter a valid authorization start date, end date, and amount before creating monthly caps.');
            return;
        }
        const toDateString = (value)=>value.toISOString().slice(0, 10);
        const startOfMonth = (value)=>new Date(Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), 1));
        const endOfMonth = (value)=>new Date(Date.UTC(value.getUTCFullYear(), value.getUTCMonth() + 1, 0));
        const maxDate = (a, b)=>a > b ? a : b;
        const minDate = (a, b)=>a < b ? a : b;
        const countWeekdaysInclusive = (rangeStart, rangeEnd)=>{
            let count = 0;
            const day = new Date(rangeStart);
            while(day <= rangeEnd){
                const weekDay = day.getUTCDay();
                if (weekDay !== 0 && weekDay !== 6) count++;
                day.setUTCDate(day.getUTCDate() + 1);
            }
            return count;
        };
        const add = [];
        const monthRanges = [];
        let monthPointer = startOfMonth(start_date);
        const endMonth = startOfMonth(end_date);
        while(monthPointer <= endMonth){
            const monthStart = maxDate(start_date, startOfMonth(monthPointer));
            const monthEnd = minDate(end_date, endOfMonth(monthPointer));
            monthRanges.push({
                start: monthStart,
                end: monthEnd
            });
            monthPointer = new Date(Date.UTC(monthPointer.getUTCFullYear(), monthPointer.getUTCMonth() + 1, 1));
        }
        if (!monthRanges.length) return;
        const cents = Math.round(amount * 100);
        const weights = monthRanges.map(({ start: start, end: end })=>{
            if (type === 'calendar-day-prorated') return (0, $b78c044e3d911d2e$export$af7c4989823a7ea4)(start, end) + 1;
            if (type === 'workday-prorated') return countWeekdaysInclusive(start, end);
            return 1;
        });
        const totalWeight = weights.reduce((acc, current)=>acc + current, 0);
        if (totalWeight <= 0) {
            alert('Unable to create caps for this date range.');
            return;
        }
        const capCents = monthRanges.map((_range, index)=>{
            if (index === monthRanges.length - 1) return 0;
            return Math.round(cents * weights[index] / totalWeight);
        });
        const allocatedCents = capCents.reduce((acc, current)=>acc + current, 0);
        capCents[capCents.length - 1] = cents - allocatedCents;
        monthRanges.forEach(({ start: start, end: end }, index)=>{
            add.push({
                service_authorization_cap_id: crypto.randomUUID(),
                start_date: toDateString(start),
                end_date: toDateString(end),
                amount_type: 'money',
                amount: capCents[index] / 100,
                usage: 0,
                approved_overage_amount: 0,
                external_usage: 0
            });
        });
        this.grid?.applyTransaction({
            add: add
        });
    }
    focusCellForLocationHash() {
        const match = location.hash.match(/^#cap:(\d{4}-\d{2}-\d{2})$/);
        const grid = this.grid;
        if (!grid || !match) return;
        const capStartDate = match[1];
        let rowIndex = null;
        grid.forEachNodeAfterFilterAndSort((node)=>{
            if (rowIndex === null && typeof node.rowIndex === 'number' && node.data?.start_date === capStartDate) rowIndex = node.rowIndex;
        });
        if (rowIndex === null) return;
        const colKey = 'approved_overage_amount';
        grid.ensureIndexVisible(rowIndex, 'middle');
        grid.deselectAll();
        grid.clearCellSelection();
        grid.addCellRange({
            rowStartIndex: rowIndex,
            rowEndIndex: rowIndex,
            columnStart: colKey,
            columnEnd: colKey
        });
        grid.setFocusedCell(rowIndex, colKey);
    }
    refreshCumulativeBalance = ()=>{
        this.grid?.refreshCells({
            columns: [
                'cumulative_balance'
            ],
            force: true
        });
    };
    refreshBalanceDependentCells = ()=>{
        this.grid?.refreshCells({
            columns: [
                'balance',
                'cumulative_balance',
                'actions'
            ],
            force: true
        });
    };
    getRows() {
        const rows = [];
        this.grid?.forEachNode((node)=>{
            if (node.data) rows.push(node.data);
        });
        return rows;
    }
    syncInputValue = ()=>{
        if (!this.grid) return;
        const rowData = this.getRows();
        this.input.value = JSON.stringify(rowData);
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.input);
    };
    onCellClicked = (params)=>{
        const action = params.event?.target instanceof Element && params.event.target.closest('[data-grid-action]')?.getAttribute('data-grid-action');
        if (action === 'delete') {
            if (params.data) {
                if (params.data.external_usage) {
                    alert('Cannot delete cap with external usage.');
                    return;
                }
                params.api.applyTransaction({
                    remove: [
                        params.data
                    ]
                });
            }
        }
    };
    processDataFromClipboard = (params)=>{
        const data = [
            ...params.data
        ];
        const emptyLastRow = data[data.length - 1][0] === '' && data[data.length - 1].length === 1;
        if (emptyLastRow) data.splice(data.length - 1, 1);
        const lastIndex = params.api.getDisplayedRowCount() - 1;
        const focusedCell = params.api.getFocusedCell();
        const focusedIndex = focusedCell.rowIndex;
        if (focusedIndex + data.length - 1 > lastIndex) {
            const resultLastIndex = focusedIndex + (data.length - 1);
            const numRowsToAdd = resultLastIndex - lastIndex;
            const rowsToAdd = [];
            for(let i = 0; i < numRowsToAdd; i++)rowsToAdd.push({
                service_authorization_cap_id: crypto.randomUUID(),
                start_date: null,
                end_date: null,
                amount_type: 'money',
                amount: null,
                usage: 0,
                approved_overage_amount: 0,
                external_usage: 0
            });
            params.api.applyTransaction({
                add: rowsToAdd
            });
        }
        return data;
    };
    getAuthorizationInfo() {
        // M/d/yyyy
        const start_date_string = this.input.form.elements.namedItem('start_date:date').value;
        // yyyy-MM-dd (local)
        const start_date_local = (0, $b78c044e3d911d2e$export$7660134aa4da2247)(start_date_string);
        // M/d/yyyy
        const end_date_string = this.input.form.elements.namedItem('end_date:date').value;
        // yyyy-MM-dd (local)
        const end_date_local = (0, $b78c044e3d911d2e$export$7660134aa4da2247)(end_date_string);
        // UTC
        const start_date = start_date_local ? new Date(start_date_local.toISOString().substr(0, 10)) : null;
        // UTC
        const end_date = end_date_local ? new Date(end_date_local.toISOString().substr(0, 10)) : null;
        const amount_string = this.input.form.elements.namedItem('amount:number').value;
        let amount = null;
        if (amount_string) {
            const parsed = parseFloat(amount_string);
            if (isFinite(parsed)) amount = parsed;
        }
        return {
            start_date: start_date,
            end_date: end_date,
            amount: amount
        };
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $bc8c4b9ea739c558$var$ServiceAuthorizationCapsElement.prototype, "gridHost", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $bc8c4b9ea739c558$var$ServiceAuthorizationCapsElement.prototype, "input", void 0);
$bc8c4b9ea739c558$var$ServiceAuthorizationCapsElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('service-authorization-caps')
], $bc8c4b9ea739c558$var$ServiceAuthorizationCapsElement);








const $09e41758f0394487$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
const $09e41758f0394487$export$d0ebe8f7b0583dcf = 'service-authorization-select-change';
class $09e41758f0394487$export$2e2bcd8739ae039 extends HTMLElement {
    get remoteInput() {
        return this.querySelector('remote-input');
    }
    get organization_id() {
        return this.getAttribute('organization_id');
    }
    get service_authorization_id() {
        return this.input.value || null;
    }
    get name() {
        return this.getAttribute('name');
    }
    get required() {
        return this.hasAttribute('required');
    }
    get menuButton() {
        return this.querySelector('summary [data-menu-button]');
    }
    connectedCallback() {
        this.addEventListener('focus', this, {
            capture: true
        });
    }
    disconnectedCallback() {
        this.removeEventListener('focus', this, {
            capture: true
        });
    }
    handleEvent(event) {
        switch(event.type){
            case 'focus':
                {
                    const remoteInput = this.remoteInput;
                    const url = new URL(remoteInput.src, location.origin);
                    const form = this.closest('form');
                    const startDateInput = form?.elements.namedItem('start_date:date');
                    if (startDateInput instanceof HTMLInputElement && isFinite(Date.parse(startDateInput.value))) url.searchParams.set('start_date', new Date(startDateInput.value).toISOString().substr(0, 10));
                    if (remoteInput.src !== url.href) remoteInput.src = url.href;
                    return;
                }
            default:
                throw new Error(`Unhandled event: ${event.type}`);
        }
    }
    detailsMenuSelected() {
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.input);
        this.dispatchEvent(new CustomEvent($09e41758f0394487$export$d0ebe8f7b0583dcf, {
            bubbles: true
        }));
        const service_authorization_id = this.service_authorization_id;
        this.preview?.remove();
        if (service_authorization_id) this.insertAdjacentHTML('beforeend', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<include-fragment
            src="/api/organizations/${this.organization_id}/service-authorizations/${this.service_authorization_id}/summary-card?target=service-authorization-select.preview"
            accept="text/fragment+html"
            class="d-flex gap-2 flex-items-center flex-justify-center py-4 color-fg-muted color-bg-inset rounded"
            data-target="service-authorization-select.preview"
            role="status"
          >
            <span class="spinner-border"></span>
            <span>${(0, $b11db1b62d4a8f76$export$25a57b30938bf753)[$09e41758f0394487$var$locale]}</span>
          </include-fragment>`));
    }
    inputFocused() {
        this.querySelector('summary')?.click();
    }
    clear() {
        // clear value
        if (this.service_authorization_id) {
            this.menuButton.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $457490243c387ab4$export$76b148a8346024c3)($09e41758f0394487$var$locale, this.name, this.required));
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.input);
            this.dispatchEvent(new CustomEvent($09e41758f0394487$export$d0ebe8f7b0583dcf, {
                bubbles: true
            }));
        }
        // clear preview
        this.preview?.remove();
        // clear menu filter and results
        const filterInput = this.remoteInput.input;
        filterInput.value = '';
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(filterInput);
        this.querySelector('SelectMenu-list').innerHTML = '';
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $09e41758f0394487$export$2e2bcd8739ae039.prototype, "preview", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $09e41758f0394487$export$2e2bcd8739ae039.prototype, "input", void 0);
$09e41758f0394487$export$2e2bcd8739ae039 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('service-authorization-select')
], $09e41758f0394487$export$2e2bcd8739ae039);




const $857938da083c864c$export$de3a936f575807 = 'sidebar-collapsed';
const $857938da083c864c$var$collapsedClass = 'Sidebar--collapsed';
class $857938da083c864c$export$dcd314c2ee8251f2 extends HTMLElement {
    #prefersCollapsed = false;
    get prefersCollapsed() {
        return this.#prefersCollapsed;
    }
    set prefersCollapsed(value) {
        this.#prefersCollapsed = value;
        document.cookie = `sidebar-collapsed=${value};path=/;${location.protocol === 'https:' ? 'secure;' : ''}samesite=lax;max-age=31536000`;
    }
    connectedCallback() {
        this.#prefersCollapsed = this.classList.contains($857938da083c864c$var$collapsedClass);
    }
    disconnectedCallback() {
        this.toggleWindowSubscriptions(false);
    }
    toggleWindowSubscriptions(value) {
        const method = value ? 'addEventListener' : 'removeEventListener';
        window[method]('focus', this.restoreCollapsedState, true);
        window[method]('click', this.restoreCollapsedState);
    }
    toggleExpanded() {
        this.prefersCollapsed = this.toggleCollapsedClass();
    }
    toggleCollapsedClass(add = !this.classList.contains($857938da083c864c$var$collapsedClass)) {
        const current = this.classList.contains($857938da083c864c$var$collapsedClass);
        if (add !== current) {
            this.classList.toggle($857938da083c864c$var$collapsedClass, add);
            this.dispatchEvent(new CustomEvent($857938da083c864c$export$de3a936f575807, {
                detail: add,
                bubbles: true
            }));
        }
        return add;
    }
    activateSearch() {
        this.toggleCollapsedClass(false);
        this.searchInput.focus();
        this.toggleWindowSubscriptions(true);
    }
    restoreCollapsedState = ({ target: target })=>{
        if (target instanceof Node && !this.contains(target)) {
            this.toggleCollapsedClass(this.prefersCollapsed);
            this.toggleWindowSubscriptions(false);
        }
    };
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $857938da083c864c$export$dcd314c2ee8251f2.prototype, "searchInput", void 0);
$857938da083c864c$export$dcd314c2ee8251f2 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('side-bar')
], $857938da083c864c$export$dcd314c2ee8251f2);





/*!
 * Signature Pad v5.1.4 | https://github.com/szimek/signature_pad
 * (c) 2026 Szymon Nowak | Released under the MIT license
 */ // src/point.ts
var $bb6f6b25baebfb25$var$Point = class {
    x;
    y;
    pressure;
    time;
    constructor(x, y, pressure, time){
        if (isNaN(x) || isNaN(y)) throw new Error(`Point is invalid: (${x}, ${y})`);
        this.x = +x;
        this.y = +y;
        this.pressure = pressure || 0;
        this.time = time || Date.now();
    }
    distanceTo(start) {
        return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
    }
    equals(other) {
        return this.x === other.x && this.y === other.y && this.pressure === other.pressure && this.time === other.time;
    }
    velocityFrom(start) {
        return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 0;
    }
};
// src/bezier.ts
var $bb6f6b25baebfb25$var$Bezier = class _Bezier {
    constructor(startPoint, control2, control1, endPoint, startWidth, endWidth){
        this.startPoint = startPoint;
        this.control2 = control2;
        this.control1 = control1;
        this.endPoint = endPoint;
        this.startWidth = startWidth;
        this.endWidth = endWidth;
    }
    startPoint;
    control2;
    control1;
    endPoint;
    startWidth;
    endWidth;
    static fromPoints(points, widths) {
        const c2 = this.calculateControlPoints(points[0], points[1], points[2]).c2;
        const c3 = this.calculateControlPoints(points[1], points[2], points[3]).c1;
        return new _Bezier(points[1], c2, c3, points[2], widths.start, widths.end);
    }
    static calculateControlPoints(s1, s2, s3) {
        const dx1 = s1.x - s2.x;
        const dy1 = s1.y - s2.y;
        const dx2 = s2.x - s3.x;
        const dy2 = s2.y - s3.y;
        const m1 = {
            x: (s1.x + s2.x) / 2,
            y: (s1.y + s2.y) / 2
        };
        const m2 = {
            x: (s2.x + s3.x) / 2,
            y: (s2.y + s3.y) / 2
        };
        const l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
        const l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
        const dxm = m1.x - m2.x;
        const dym = m1.y - m2.y;
        const k = l1 + l2 == 0 ? 0 : l2 / (l1 + l2);
        const cm = {
            x: m2.x + dxm * k,
            y: m2.y + dym * k
        };
        const tx = s2.x - cm.x;
        const ty = s2.y - cm.y;
        return {
            c1: new $bb6f6b25baebfb25$var$Point(m1.x + tx, m1.y + ty),
            c2: new $bb6f6b25baebfb25$var$Point(m2.x + tx, m2.y + ty)
        };
    }
    // Returns approximated length. Code taken from https://www.lemoda.net/maths/bezier-length/index.html.
    length() {
        const steps = 10;
        let length = 0;
        let px;
        let py;
        for(let i = 0; i <= steps; i += 1){
            const t = i / steps;
            const cx = this.point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
            const cy = this.point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
            if (i > 0) {
                const xdiff = cx - px;
                const ydiff = cy - py;
                length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
            }
            px = cx;
            py = cy;
        }
        return length;
    }
    // Calculate parametric value of x or y given t and the four point coordinates of a cubic bezier curve.
    point(t, start, c1, c2, end) {
        return start * (1 - t) * (1 - t) * (1 - t) + 3 * c1 * (1 - t) * (1 - t) * t + 3 * c2 * (1 - t) * t * t + end * t * t * t;
    }
};
// src/signature_event_target.ts
var $bb6f6b25baebfb25$var$SignatureEventTarget = class {
    /* tslint:disable: variable-name */ _et;
    /* tslint:enable: variable-name */ constructor(){
        try {
            this._et = new EventTarget();
        } catch  {
            this._et = document;
        }
    }
    addEventListener(type, listener, options) {
        this._et.addEventListener(type, listener, options);
    }
    dispatchEvent(event) {
        return this._et.dispatchEvent(event);
    }
    removeEventListener(type, callback, options) {
        this._et.removeEventListener(type, callback, options);
    }
};
// src/throttle.ts
function $bb6f6b25baebfb25$var$throttle(fn, wait = 250) {
    let previous = 0;
    let timeout = null;
    let result;
    let storedContext;
    let storedArgs;
    const later = ()=>{
        previous = Date.now();
        timeout = null;
        result = fn.apply(storedContext, storedArgs);
        if (!timeout) {
            storedContext = null;
            storedArgs = [];
        }
    };
    return function wrapper(...args) {
        const now = Date.now();
        const remaining = wait - (now - previous);
        storedContext = this;
        storedArgs = args;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = fn.apply(storedContext, storedArgs);
            if (!timeout) {
                storedContext = null;
                storedArgs = [];
            }
        } else if (!timeout) timeout = window.setTimeout(later, remaining);
        return result;
    };
}
// src/signature_pad.ts
var $bb6f6b25baebfb25$export$2e2bcd8739ae039 = class _SignaturePad extends $bb6f6b25baebfb25$var$SignatureEventTarget {
    /* tslint:enable: variable-name */ constructor(canvas, options = {}){
        super();
        this.canvas = canvas;
        this.velocityFilterWeight = options.velocityFilterWeight || 0.7;
        this.minWidth = options.minWidth || 0.5;
        this.maxWidth = options.maxWidth || 2.5;
        this.throttle = options.throttle ?? 16;
        this.minDistance = options.minDistance ?? 5;
        this.dotSize = options.dotSize || 0;
        this.penColor = options.penColor || "black";
        this.backgroundColor = options.backgroundColor || "rgba(0,0,0,0)";
        this.compositeOperation = options.compositeOperation || "source-over";
        this.canvasContextOptions = options.canvasContextOptions ?? {};
        this._strokeMoveUpdate = this.throttle ? $bb6f6b25baebfb25$var$throttle(_SignaturePad.prototype._strokeUpdate, this.throttle) : _SignaturePad.prototype._strokeUpdate;
        this._handleMouseDown = this._handleMouseDown.bind(this);
        this._handleMouseMove = this._handleMouseMove.bind(this);
        this._handleMouseUp = this._handleMouseUp.bind(this);
        this._handleTouchStart = this._handleTouchStart.bind(this);
        this._handleTouchMove = this._handleTouchMove.bind(this);
        this._handleTouchEnd = this._handleTouchEnd.bind(this);
        this._handlePointerDown = this._handlePointerDown.bind(this);
        this._handlePointerMove = this._handlePointerMove.bind(this);
        this._handlePointerUp = this._handlePointerUp.bind(this);
        this._handlePointerCancel = this._handlePointerCancel.bind(this);
        this._handleTouchCancel = this._handleTouchCancel.bind(this);
        this._ctx = canvas.getContext("2d", this.canvasContextOptions);
        this.clear();
        this.on();
    }
    canvas;
    // Public stuff
    dotSize;
    minWidth;
    maxWidth;
    penColor;
    minDistance;
    velocityFilterWeight;
    compositeOperation;
    backgroundColor;
    throttle;
    canvasContextOptions;
    // Private stuff
    /* tslint:disable: variable-name */ _ctx;
    _drawingStroke = false;
    _isEmpty = true;
    _dataUrl;
    _dataUrlOptions;
    _lastPoints = [];
    // Stores up to 4 most recent points; used to generate a new curve
    _data = [];
    // Stores all points in groups (one group per line or dot)
    _lastVelocity = 0;
    _lastWidth = 0;
    _strokeMoveUpdate;
    _strokePointerId;
    clear() {
        const { _ctx: ctx, canvas: canvas } = this;
        ctx.fillStyle = this.backgroundColor;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        this._data = [];
        this._reset(this._getPointGroupOptions());
        this._isEmpty = true;
        this._dataUrl = void 0;
        this._dataUrlOptions = void 0;
        this._strokePointerId = void 0;
    }
    redraw() {
        const data = this._data;
        const dataUrl = this._dataUrl;
        const dataUrlOptions = this._dataUrlOptions;
        this.clear();
        if (dataUrl) this.fromDataURL(dataUrl, dataUrlOptions);
        this.fromData(data, {
            clear: false
        });
    }
    fromDataURL(dataUrl, options = {}) {
        return new Promise((resolve, reject)=>{
            const image = new Image();
            const ratio = options.ratio || window.devicePixelRatio || 1;
            const width = options.width || this.canvas.width / ratio;
            const height = options.height || this.canvas.height / ratio;
            const xOffset = options.xOffset || 0;
            const yOffset = options.yOffset || 0;
            this._reset(this._getPointGroupOptions());
            image.onload = ()=>{
                this._ctx.drawImage(image, xOffset, yOffset, width, height);
                resolve();
            };
            image.onerror = (error)=>{
                reject(error);
            };
            image.crossOrigin = "anonymous";
            image.src = dataUrl;
            this._isEmpty = false;
            this._dataUrl = dataUrl;
            this._dataUrlOptions = {
                ...options
            };
        });
    }
    toDataURL(type = "image/png", encoderOptions) {
        switch(type){
            case "image/svg+xml":
                if (typeof encoderOptions !== "object") encoderOptions = void 0;
                return `data:image/svg+xml;base64,${btoa(this.toSVG(encoderOptions))}`;
            default:
                if (typeof encoderOptions !== "number") encoderOptions = void 0;
                return this.canvas.toDataURL(type, encoderOptions);
        }
    }
    on() {
        this.canvas.style.touchAction = "none";
        this.canvas.style.msTouchAction = "none";
        this.canvas.style.userSelect = "none";
        this.canvas.style.webkitUserSelect = "none";
        const isIOS = /Macintosh/.test(navigator.userAgent) && "ontouchstart" in document;
        if (window.PointerEvent && !isIOS) this._handlePointerEvents();
        else {
            this._handleMouseEvents();
            if ("ontouchstart" in window) this._handleTouchEvents();
        }
    }
    off() {
        this.canvas.style.touchAction = "auto";
        this.canvas.style.msTouchAction = "auto";
        this.canvas.style.userSelect = "auto";
        this.canvas.style.webkitUserSelect = "auto";
        this.canvas.removeEventListener("pointerdown", this._handlePointerDown);
        this.canvas.removeEventListener("mousedown", this._handleMouseDown);
        this.canvas.removeEventListener("touchstart", this._handleTouchStart);
        this._removeMoveUpEventListeners();
    }
    _getListenerFunctions() {
        const canvasWindow = window.document === this.canvas.ownerDocument ? window : this.canvas.ownerDocument.defaultView ?? this.canvas.ownerDocument;
        return {
            addEventListener: canvasWindow.addEventListener.bind(canvasWindow),
            removeEventListener: canvasWindow.removeEventListener.bind(canvasWindow)
        };
    }
    _removeMoveUpEventListeners() {
        const { removeEventListener: removeEventListener } = this._getListenerFunctions();
        removeEventListener("pointermove", this._handlePointerMove);
        removeEventListener("pointerup", this._handlePointerUp);
        removeEventListener("pointercancel", this._handlePointerCancel);
        removeEventListener("mousemove", this._handleMouseMove);
        removeEventListener("mouseup", this._handleMouseUp);
        removeEventListener("touchmove", this._handleTouchMove);
        removeEventListener("touchend", this._handleTouchEnd);
        removeEventListener("touchcancel", this._handleTouchCancel);
    }
    isEmpty() {
        return this._isEmpty;
    }
    fromData(pointGroups, { clear: clear = true } = {}) {
        if (clear) this.clear();
        this._fromData(pointGroups, this._drawCurve.bind(this), this._drawDot.bind(this), this._drawLine.bind(this));
        this._data = this._data.concat(pointGroups);
    }
    toData() {
        return this._data;
    }
    _isLeftButtonPressed(event, only) {
        if (only) return event.buttons === 1;
        return (event.buttons & 1) === 1;
    }
    _pointerEventToSignatureEvent(event) {
        return {
            event: event,
            type: event.type,
            x: event.clientX,
            y: event.clientY,
            pressure: "pressure" in event ? event.pressure : 0
        };
    }
    _touchEventToSignatureEvent(event) {
        const touch = event.changedTouches[0];
        return {
            event: event,
            type: event.type,
            x: touch.clientX,
            y: touch.clientY,
            pressure: touch.force
        };
    }
    // Event handlers
    _handleMouseDown(event) {
        if (!this._isLeftButtonPressed(event, true) || this._drawingStroke) return;
        this._strokeBegin(this._pointerEventToSignatureEvent(event));
    }
    _handleMouseMove(event) {
        if (!this._isLeftButtonPressed(event, true) || !this._drawingStroke) {
            this._strokeEnd(this._pointerEventToSignatureEvent(event), false);
            return;
        }
        this._strokeMoveUpdate(this._pointerEventToSignatureEvent(event));
    }
    _handleMouseUp(event) {
        if (this._isLeftButtonPressed(event)) return;
        this._strokeEnd(this._pointerEventToSignatureEvent(event));
    }
    _handleTouchStart(event) {
        if (event.targetTouches.length !== 1 || this._drawingStroke) return;
        if (event.cancelable) event.preventDefault();
        this._strokeBegin(this._touchEventToSignatureEvent(event));
    }
    _handleTouchMove(event) {
        if (event.targetTouches.length !== 1) return;
        if (event.cancelable) event.preventDefault();
        if (!this._drawingStroke) {
            this._strokeEnd(this._touchEventToSignatureEvent(event), false);
            return;
        }
        this._strokeMoveUpdate(this._touchEventToSignatureEvent(event));
    }
    _handleTouchEnd(event) {
        if (event.targetTouches.length !== 0) return;
        if (event.cancelable) event.preventDefault();
        this._strokeEnd(this._touchEventToSignatureEvent(event));
    }
    _handlePointerCancel(event) {
        if (!this._allowPointerId(event)) return;
        event.preventDefault();
        this._strokeEnd(this._pointerEventToSignatureEvent(event), false);
    }
    _handleTouchCancel(event) {
        if (event.cancelable) event.preventDefault();
        this._strokeEnd(this._touchEventToSignatureEvent(event), false);
    }
    _getPointerId(event) {
        return event.persistentDeviceId || event.pointerId;
    }
    _allowPointerId(event, allowUndefined = false) {
        if (typeof this._strokePointerId === "undefined") return allowUndefined;
        return this._getPointerId(event) === this._strokePointerId;
    }
    _handlePointerDown(event) {
        if (this._drawingStroke || !this._isLeftButtonPressed(event) || !this._allowPointerId(event, true)) return;
        this._strokePointerId = this._getPointerId(event);
        event.preventDefault();
        this._strokeBegin(this._pointerEventToSignatureEvent(event));
    }
    _handlePointerMove(event) {
        if (!this._allowPointerId(event)) return;
        if (!this._isLeftButtonPressed(event, true) || !this._drawingStroke) {
            this._strokeEnd(this._pointerEventToSignatureEvent(event), false);
            return;
        }
        event.preventDefault();
        this._strokeMoveUpdate(this._pointerEventToSignatureEvent(event));
    }
    _handlePointerUp(event) {
        if (this._isLeftButtonPressed(event) || !this._allowPointerId(event)) return;
        event.preventDefault();
        this._strokeEnd(this._pointerEventToSignatureEvent(event));
    }
    _getPointGroupOptions(group) {
        return {
            penColor: group && "penColor" in group ? group.penColor : this.penColor,
            dotSize: group && "dotSize" in group ? group.dotSize : this.dotSize,
            minWidth: group && "minWidth" in group ? group.minWidth : this.minWidth,
            maxWidth: group && "maxWidth" in group ? group.maxWidth : this.maxWidth,
            velocityFilterWeight: group && "velocityFilterWeight" in group ? group.velocityFilterWeight : this.velocityFilterWeight,
            compositeOperation: group && "compositeOperation" in group ? group.compositeOperation : this.compositeOperation
        };
    }
    // Private methods
    _strokeBegin(event) {
        const cancelled = !this.dispatchEvent(new CustomEvent("beginStroke", {
            detail: event,
            cancelable: true
        }));
        if (cancelled) return;
        const { addEventListener: addEventListener } = this._getListenerFunctions();
        switch(event.event.type){
            case "mousedown":
                addEventListener("mousemove", this._handleMouseMove, {
                    passive: false
                });
                addEventListener("mouseup", this._handleMouseUp, {
                    passive: false
                });
                break;
            case "touchstart":
                addEventListener("touchmove", this._handleTouchMove, {
                    passive: false
                });
                addEventListener("touchend", this._handleTouchEnd, {
                    passive: false
                });
                addEventListener("touchcancel", this._handleTouchCancel, {
                    passive: false
                });
                break;
            case "pointerdown":
                addEventListener("pointermove", this._handlePointerMove, {
                    passive: false
                });
                addEventListener("pointerup", this._handlePointerUp, {
                    passive: false
                });
                addEventListener("pointercancel", this._handlePointerCancel, {
                    passive: false
                });
                break;
            default:
        }
        this._drawingStroke = true;
        const pointGroupOptions = this._getPointGroupOptions();
        const newPointGroup = {
            ...pointGroupOptions,
            points: []
        };
        this._data.push(newPointGroup);
        this._reset(pointGroupOptions);
        this._strokeUpdate(event);
    }
    _strokeUpdate(event) {
        if (!this._drawingStroke) return;
        if (this._data.length === 0) {
            this._strokeBegin(event);
            return;
        }
        this.dispatchEvent(new CustomEvent("beforeUpdateStroke", {
            detail: event
        }));
        const point = this._createPoint(event.x, event.y, event.pressure);
        const lastPointGroup = this._data[this._data.length - 1];
        const lastPoints = lastPointGroup.points;
        const lastPoint = lastPoints.length > 0 && lastPoints[lastPoints.length - 1];
        const isLastPointTooClose = lastPoint ? point.distanceTo(lastPoint) <= this.minDistance : false;
        const pointGroupOptions = this._getPointGroupOptions(lastPointGroup);
        if (!lastPoint || !(lastPoint && isLastPointTooClose)) {
            const curve = this._addPoint(point, pointGroupOptions);
            if (!lastPoint) this._drawDot(point, pointGroupOptions);
            else if (curve) this._drawCurve(curve, pointGroupOptions);
            lastPoints.push({
                time: point.time,
                x: point.x,
                y: point.y,
                pressure: point.pressure
            });
        }
        this.dispatchEvent(new CustomEvent("afterUpdateStroke", {
            detail: event
        }));
    }
    _strokeEnd(event, shouldUpdate = true) {
        this._removeMoveUpEventListeners();
        if (!this._drawingStroke) return;
        if (shouldUpdate) this._strokeUpdate(event);
        this._drawingStroke = false;
        this._strokePointerId = void 0;
        this.dispatchEvent(new CustomEvent("endStroke", {
            detail: event
        }));
    }
    _handlePointerEvents() {
        this._drawingStroke = false;
        this.canvas.addEventListener("pointerdown", this._handlePointerDown, {
            passive: false
        });
    }
    _handleMouseEvents() {
        this._drawingStroke = false;
        this.canvas.addEventListener("mousedown", this._handleMouseDown, {
            passive: false
        });
    }
    _handleTouchEvents() {
        this.canvas.addEventListener("touchstart", this._handleTouchStart, {
            passive: false
        });
    }
    // Called when a new line is started
    _reset(options) {
        this._lastPoints = [];
        this._lastVelocity = 0;
        this._lastWidth = (options.minWidth + options.maxWidth) / 2;
        this._ctx.fillStyle = options.penColor;
        this._ctx.globalCompositeOperation = options.compositeOperation;
    }
    _createPoint(x, y, pressure) {
        const rect = this.canvas.getBoundingClientRect();
        return new $bb6f6b25baebfb25$var$Point(x - rect.left, y - rect.top, pressure, /* @__PURE__ */ new Date().getTime());
    }
    // Add point to _lastPoints array and generate a new curve if there are enough points (i.e. 3)
    _addPoint(point, options) {
        const { _lastPoints: _lastPoints } = this;
        _lastPoints.push(point);
        if (_lastPoints.length > 2) {
            if (_lastPoints.length === 3) _lastPoints.unshift(_lastPoints[0]);
            const widths = this._calculateCurveWidths(_lastPoints[1], _lastPoints[2], options);
            const curve = $bb6f6b25baebfb25$var$Bezier.fromPoints(_lastPoints, widths);
            _lastPoints.shift();
            return curve;
        }
        return null;
    }
    _calculateCurveWidths(startPoint, endPoint, options) {
        const velocity = options.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - options.velocityFilterWeight) * this._lastVelocity;
        const newWidth = this._strokeWidth(velocity, options);
        const widths = {
            end: newWidth,
            start: this._lastWidth
        };
        this._lastVelocity = velocity;
        this._lastWidth = newWidth;
        return widths;
    }
    _strokeWidth(velocity, options) {
        return Math.max(options.maxWidth / (velocity + 1), options.minWidth);
    }
    _drawCurveSegment(x, y, width) {
        const ctx = this._ctx;
        ctx.moveTo(x, y);
        ctx.arc(x, y, width, 0, 2 * Math.PI, false);
        this._isEmpty = false;
    }
    _drawCurve(curve, options) {
        const ctx = this._ctx;
        const widthDelta = curve.endWidth - curve.startWidth;
        const drawSteps = Math.ceil(curve.length()) * 2;
        ctx.beginPath();
        ctx.fillStyle = options.penColor;
        for(let i = 0; i < drawSteps; i += 1){
            const t = i / drawSteps;
            const tt = t * t;
            const ttt = tt * t;
            const u = 1 - t;
            const uu = u * u;
            const uuu = uu * u;
            let x = uuu * curve.startPoint.x;
            x += 3 * uu * t * curve.control1.x;
            x += 3 * u * tt * curve.control2.x;
            x += ttt * curve.endPoint.x;
            let y = uuu * curve.startPoint.y;
            y += 3 * uu * t * curve.control1.y;
            y += 3 * u * tt * curve.control2.y;
            y += ttt * curve.endPoint.y;
            const width = Math.min(curve.startWidth + ttt * widthDelta, options.maxWidth);
            this._drawCurveSegment(x, y, width);
        }
        ctx.closePath();
        ctx.fill();
    }
    _getDotSize(options) {
        return options.dotSize > 0 ? options.dotSize : (options.minWidth + options.maxWidth) / 2;
    }
    _drawDot(point, options) {
        const ctx = this._ctx;
        const width = this._getDotSize(options);
        ctx.beginPath();
        this._drawCurveSegment(point.x, point.y, width);
        ctx.closePath();
        ctx.fillStyle = options.penColor;
        ctx.fill();
    }
    _drawLine(startPoint, endPoint, options) {
        const ctx = this._ctx;
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(startPoint.x, startPoint.y);
        ctx.lineTo(endPoint.x, endPoint.y);
        ctx.lineWidth = this._getDotSize(options) * 2;
        ctx.lineCap = "round";
        ctx.strokeStyle = options.penColor;
        ctx.stroke();
        ctx.restore();
        this._isEmpty = false;
    }
    _fromData(pointGroups, drawCurve, drawDot, drawLine) {
        for (const group of pointGroups){
            const { points: points } = group;
            const pointGroupOptions = this._getPointGroupOptions(group);
            if (points.length > 2) for(let j = 0; j < points.length; j += 1){
                const basicPoint = points[j];
                const point = new $bb6f6b25baebfb25$var$Point(basicPoint.x, basicPoint.y, basicPoint.pressure, basicPoint.time);
                if (j === 0) this._reset(pointGroupOptions);
                const curve = this._addPoint(point, pointGroupOptions);
                if (curve) drawCurve(curve, pointGroupOptions);
            }
            else if (points.length === 2) {
                this._reset(pointGroupOptions);
                drawLine(points[0], points[1], pointGroupOptions);
            } else {
                this._reset(pointGroupOptions);
                drawDot(points[0], pointGroupOptions);
            }
        }
    }
    toSVG({ includeBackgroundColor: includeBackgroundColor = false, includeDataUrl: includeDataUrl = false } = {}) {
        const pointGroups = this._data;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const minX = 0;
        const minY = 0;
        const maxX = this.canvas.width / ratio;
        const maxY = this.canvas.height / ratio;
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        svg.setAttribute("viewBox", `${minX} ${minY} ${maxX} ${maxY}`);
        svg.setAttribute("width", maxX.toString());
        svg.setAttribute("height", maxY.toString());
        if (includeBackgroundColor && this.backgroundColor) {
            const rect = document.createElement("rect");
            rect.setAttribute("width", "100%");
            rect.setAttribute("height", "100%");
            rect.setAttribute("fill", this.backgroundColor);
            svg.appendChild(rect);
        }
        if (includeDataUrl && this._dataUrl) {
            const ratio2 = this._dataUrlOptions?.ratio || window.devicePixelRatio || 1;
            const width = this._dataUrlOptions?.width || this.canvas.width / ratio2;
            const height = this._dataUrlOptions?.height || this.canvas.height / ratio2;
            const xOffset = this._dataUrlOptions?.xOffset || 0;
            const yOffset = this._dataUrlOptions?.yOffset || 0;
            const image = document.createElement("image");
            image.setAttribute("x", xOffset.toString());
            image.setAttribute("y", yOffset.toString());
            image.setAttribute("width", width.toString());
            image.setAttribute("height", height.toString());
            image.setAttribute("preserveAspectRatio", "none");
            image.setAttribute("href", this._dataUrl);
            svg.appendChild(image);
        }
        this._fromData(pointGroups, (curve, { penColor: penColor })=>{
            const path = document.createElement("path");
            if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
                const attr = `M ${curve.startPoint.x.toFixed(3)},${curve.startPoint.y.toFixed(3)} C ${curve.control1.x.toFixed(3)},${curve.control1.y.toFixed(3)} ${curve.control2.x.toFixed(3)},${curve.control2.y.toFixed(3)} ${curve.endPoint.x.toFixed(3)},${curve.endPoint.y.toFixed(3)}`;
                path.setAttribute("d", attr);
                path.setAttribute("stroke-width", (curve.endWidth * 2.25).toFixed(3));
                path.setAttribute("stroke", penColor);
                path.setAttribute("fill", "none");
                path.setAttribute("stroke-linecap", "round");
                svg.appendChild(path);
            }
        }, (point, { penColor: penColor, dotSize: dotSize, minWidth: minWidth, maxWidth: maxWidth })=>{
            const circle = document.createElement("circle");
            const size = dotSize > 0 ? dotSize : (minWidth + maxWidth) / 2;
            circle.setAttribute("r", size.toString());
            circle.setAttribute("cx", point.x.toString());
            circle.setAttribute("cy", point.y.toString());
            circle.setAttribute("fill", penColor);
            svg.appendChild(circle);
        }, (startPoint, endPoint, options)=>{
            const line = document.createElement("line");
            line.setAttribute("x1", startPoint.x.toString());
            line.setAttribute("y1", startPoint.y.toString());
            line.setAttribute("x2", endPoint.x.toString());
            line.setAttribute("y2", endPoint.y.toString());
            line.setAttribute("stroke", options.penColor);
            line.setAttribute("stroke-width", (this._getDotSize(options) * 2).toString());
            line.setAttribute("stroke-linecap", "round");
            svg.appendChild(line);
        });
        return svg.outerHTML;
    }
};




class $dbea3aa2a327b5c1$var$SignaturePadElement extends HTMLElement {
    connectedCallback() {
        this.signaturePad = new (0, $bb6f6b25baebfb25$export$2e2bcd8739ae039)(this.canvas);
        this.signaturePad.addEventListener('endStroke', ()=>this.endStroke());
        addEventListener('resize', this.resizeCanvas);
        this.resizeCanvas();
    }
    disconnectedCallback() {
        this.signaturePad.removeEventListener('endStroke', ()=>this.endStroke());
        removeEventListener('resize', this.resizeCanvas);
    }
    setRequired(active) {
        this.typeSignatureInput.required = active === 'type-signature';
        this.drawSignatureInput.required = active === 'draw-signature';
        // clear validation
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.typeSignatureInput);
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.drawSignatureInput);
    }
    tabContainerChanged(event) {
        const typeSignatureTabActive = event.tab?.id === 'tab-type-signature';
        this.setRequired(typeSignatureTabActive ? 'type-signature' : 'draw-signature');
        this.resizeCanvas();
    }
    updateDrawSignatureInputValue() {
        const value = this.signaturePad.isEmpty() ? '' : this.signaturePad.toDataURL('image/png');
        if (this.drawSignatureInput.value !== value) {
            this.drawSignatureInput.value = value;
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.drawSignatureInput);
        }
    }
    endStroke() {
        this.updateDrawSignatureInputValue();
    }
    undo() {
        const data = this.signaturePad.toData();
        if (data) {
            data.pop();
            this.signaturePad.fromData(data);
            this.updateDrawSignatureInputValue();
        }
    }
    resizeCanvas = ()=>{
        const canvas = this.canvas;
        if (canvas.closest('[hidden]')) return;
        const { width: oldWidth, height: oldHeight, ratio: oldRatio } = canvas;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const width = canvas.offsetWidth * ratio;
        const height = canvas.offsetHeight * ratio;
        if (canvas.width !== oldWidth || canvas.height !== oldHeight || ratio !== oldRatio) {
            canvas.width = width;
            canvas.height = height;
            canvas.ratio = ratio;
            canvas.getContext('2d')?.scale(ratio, ratio);
            this.signaturePad.clear();
        }
    };
    handleTypeSignatureInput() {
        const value = this.typeSignatureInput.value;
        if (value.length === 0) return;
        const firstLetter = value.charAt(0);
        if (firstLetter === firstLetter.toUpperCase()) return;
        const start = this.typeSignatureInput.selectionStart;
        const end = this.typeSignatureInput.selectionEnd;
        this.typeSignatureInput.value = firstLetter.toUpperCase() + value.slice(1);
        this.typeSignatureInput.setSelectionRange(start, end);
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.typeSignatureInput);
    }
    handleDrawSignatureInputFocus() {
        this.undoButton.focus();
    }
    handleFontButtonClick(event) {
        const button = event.target instanceof Element && event.target.closest('button');
        if (!button) return;
        const { font_family: font_family, size: size } = JSON.parse(button.value);
        this.typeSignatureInput.style.fontFamily = font_family;
        this.typeSignatureInput.style.fontSize = `${size}px`;
        button.closest('details-menu')?.querySelectorAll('[aria-checked]').forEach((b)=>b.setAttribute('aria-checked', 'false'));
        button.setAttribute('aria-checked', 'true');
    }
    async submit(event) {
        event.preventDefault();
        const { set_default_signature: set_default_signature } = (0, $6980cc602f309497$export$ae2b2db16f8c0171)(event.detail);
        // wait for form to finish clearing btn-busy before we re-add it
        await new Promise((resolve)=>setTimeout(resolve));
        try {
            this.submitButton.classList.add('btn-busy');
            const canvas = document.createElement('canvas');
            if (this.querySelector('.tabnav-tab[aria-selected="true"]')?.id === 'tab-type-signature') {
                const ctx = canvas.getContext('2d');
                const { fontSize: fontSize, fontFamily: fontFamily } = this.typeSignatureInput.style;
                const font = `${+fontSize.substr(0, 2) * 2}px ${fontFamily}`;
                ctx.font = font;
                ctx.textBaseline = 'top';
                const { actualBoundingBoxLeft: actualBoundingBoxLeft, actualBoundingBoxRight: actualBoundingBoxRight, actualBoundingBoxAscent: actualBoundingBoxAscent, actualBoundingBoxDescent: actualBoundingBoxDescent } = ctx.measureText(this.typeSignatureInput.value);
                canvas.width = actualBoundingBoxRight - actualBoundingBoxLeft;
                canvas.height = actualBoundingBoxAscent + actualBoundingBoxDescent;
                ctx.font = font;
                ctx.textBaseline = 'top';
                ctx.fillText(this.typeSignatureInput.value, actualBoundingBoxLeft, actualBoundingBoxAscent);
            } else {
                const groups = this.signaturePad.toData();
                const points = groups.map((g)=>g.points).flat();
                const minX = Math.max(-4, Math.min(...points.map((p)=>p.x - 4)));
                const minY = Math.max(-4, Math.min(...points.map((p)=>p.y - 4)));
                const maxX = Math.min(this.canvas.width / 2 + 4, Math.max(...points.map((p)=>p.x + 4)));
                const maxY = Math.min(this.canvas.height / 2 + 4, Math.max(...points.map((p)=>p.y + 4)));
                console.log(minX, maxX, this.canvas.width, minY, maxY, this.canvas.height);
                for (const point of points){
                    point.x -= minX;
                    point.y -= minY;
                }
                canvas.width = (maxX - minX) * 2;
                canvas.height = (maxY - minY) * 2;
                canvas.getContext('2d')?.scale(2, 2);
                const pad = new (0, $bb6f6b25baebfb25$export$2e2bcd8739ae039)(canvas);
                pad.fromData(groups);
            }
            const blob = await new Promise((resolve)=>canvas.toBlob(resolve, 'image/png'));
            const modal = this.closest('modal-content');
            modal?.controller?.dispatchEvent(new CustomEvent('signature-accepted', {
                bubbles: true,
                detail: {
                    blob: blob,
                    set_default_signature: set_default_signature
                }
            }));
            modal?.remove();
        } catch (err) {
            (0, $84fd3dc30499b2d0$export$7977be5e446db387)(this.typeSignatureInput.form);
            throw err;
        } finally{
            this.submitButton.classList.remove('btn-busy');
        }
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dbea3aa2a327b5c1$var$SignaturePadElement.prototype, "canvas", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dbea3aa2a327b5c1$var$SignaturePadElement.prototype, "typeSignatureInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dbea3aa2a327b5c1$var$SignaturePadElement.prototype, "drawSignatureInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dbea3aa2a327b5c1$var$SignaturePadElement.prototype, "submitButton", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dbea3aa2a327b5c1$var$SignaturePadElement.prototype, "undoButton", void 0);
$dbea3aa2a327b5c1$var$SignaturePadElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('signature-pad')
], $dbea3aa2a327b5c1$var$SignaturePadElement);






function $a4c25caa5669ea32$export$365d3f09bda4fd2c({ locale: locale, src: src, attachment_id: attachment_id, inserted_property_id: inserted_property_id, readonly: readonly = false }) {
    return (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<span
    class="d-flex flex-items-start gap-2"
    attachment-id="${attachment_id}"
  >
    <img src="${src}" alt="Signature" style="height: 40px" />
    ${inserted_property_id ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<input
            type="hidden"
            name="attachments/-:json"
            value=${JSON.stringify({
        attachment_id: attachment_id,
        property_id: inserted_property_id
    })}
          />` : null}
    ${readonly ? null : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<button
            type="button"
            class="btn-octicon btn-octicon-danger mt-n1 mb-n1 ml-n1 mr-n1"
            aria-label="${(0, $b11db1b62d4a8f76$export$31a34480861da9d9)[locale]}"
            data-action="click:signature-question#deleteSignature"
          >
            ${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$c6e11f163cc2dc47))}
          </button>`}
  </span>`;
}
function $a4c25caa5669ea32$export$67089e03b19318ed(locale, default_signature_href) {
    return default_signature_href ? (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<button
          class="SelectMenu-item d-block"
          type="button"
          role="menuitem"
          data-action="click:signature-question#signWithDefaultSignature"
        >
          <span class="text-bold d-block"
            >${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$f8913d335ddc81bb), 'SelectMenu-icon color-fg-accent')}
            <span class="f5 text-bold"
              >${(0, $b11db1b62d4a8f76$export$9feabe39d774db92)[locale]}</span
            ></span
          >
          <img
            class="signature-image d-block width-full my-3 px-3"
            src="${default_signature_href}"
            alt
          />
        </button>
        <button
          class="SelectMenu-item d-block btn-octicon-danger"
          type="button"
          role="menuitem"
          data-action="click:signature-question#resetDefaultSignature"
        >
          ${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$c6e11f163cc2dc47), 'SelectMenu-icon')}
          <span>${(0, $b11db1b62d4a8f76$export$51e87c4ec4bfa4c8)[locale]}</span>
        </button>` : (0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<div class="SelectMenu-blankslate">
        ${(0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)((0, $84c634e688af79ca$export$f8913d335ddc81bb), {
        classes: 'color-fg-muted f2'
    })}
        <h4 class="my-2">${(0, $b11db1b62d4a8f76$export$c3b2af361dc85df7)[locale]}</h4>
        <p class="mb-3 color-fg-muted">
          ${(0, $b11db1b62d4a8f76$export$4f405bdda60d10a2)[locale]}
        </p>
      </div>`;
}








const $b050cabf666a056d$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
class $b050cabf666a056d$var$SignatureQuestionElement extends HTMLElement {
    objectUrls = [];
    get property_id() {
        return parseInt(this.getAttribute('property-id'), 10);
    }
    get user_id() {
        return this.getAttribute('user-id');
    }
    get uploadUrl() {
        return new URL(this.getAttribute('upload-href'), location.origin);
    }
    connectedCallback() {
        addEventListener('default-signature-updated', this);
    }
    disconnectedCallback() {
        this.objectUrls.forEach(URL.revokeObjectURL);
        removeEventListener('default-signature-updated', this);
    }
    handleEvent(event) {
        if (event.type === 'default-signature-updated') this.selectMenuList.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $a4c25caa5669ea32$export$67089e03b19318ed)($b050cabf666a056d$var$locale, event.detail.href));
    }
    async signatureAccepted({ detail: { set_default_signature: set_default_signature, blob: blob } }) {
        try {
            this.signaturePadButton.classList.add('btn-busy');
            const file = new File([
                blob
            ], 'signature.png', {
                type: 'image/png'
            });
            const attachment = new (0, $60111cd6ea196be2$export$71e4db985cfcf9e3)(file);
            attachment.name = file.name;
            await (0, $4ab5d79d76486e1b$export$14d3a7d22f26659e)({
                locale: $b050cabf666a056d$var$locale,
                attachments: [
                    attachment
                ],
                uploadUrl: this.uploadUrl,
                attachmentSaved: ()=>{}
            });
            const href = URL.createObjectURL(blob);
            this.objectUrls.unshift(href);
            this.appendAttachment(attachment.id, attachment.name, href);
            if (set_default_signature) {
                const userAttachment = new (0, $60111cd6ea196be2$export$71e4db985cfcf9e3)(file);
                userAttachment.name = file.name;
                (0, $4ab5d79d76486e1b$export$14d3a7d22f26659e)({
                    locale: $b050cabf666a056d$var$locale,
                    attachments: [
                        userAttachment
                    ],
                    uploadUrl: new URL(`/attachments?owner_type=user&owner_id=${this.user_id}`, location.origin),
                    attachmentSaved: ()=>{}
                }).then(()=>fetch('/api/settings/default-signature', {
                        method: 'POST',
                        headers: {
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({
                            attachment_id: userAttachment.id
                        })
                    })).then(async (response)=>{
                    if ((0, $8f2070e09d7bee6a$export$91cdf58e199a84d0)(response)) return;
                    if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
                    this.dispatchEvent(new CustomEvent('default-signature-updated', {
                        bubbles: true,
                        detail: {
                            href: href
                        }
                    }));
                });
            }
        } finally{
            this.signaturePadButton.classList.remove('btn-busy');
            this.signaturePadButton.focus();
        }
    }
    appendAttachment(id, name, href) {
        this.emptyContent.hidden = true;
        this.content.insertAdjacentHTML('afterbegin', (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $503bc3493e67da1d$export$495f1fafaa7af669)({
            locale: $b050cabf666a056d$var$locale,
            readonly: false,
            display: 'signature',
            inserted_property_id: this.property_id,
            versions: [
                {
                    id: id,
                    name: name,
                    date_iso: new Date().toISOString(),
                    href: href,
                    user_unsafe_html: 'you'
                }
            ]
        })));
        let count = this.valueInput.value ? this.valueInput.valueAsNumber : 0;
        count++;
        this.valueInput.value = count.toString();
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.valueInput);
    }
    async signWithDefaultSignature() {
        try {
            this.signaturePadButton.classList.add('btn-busy');
            const { owner_id: owner_id, owner_type: owner_type } = Object.fromEntries(this.uploadUrl.searchParams);
            const response = await fetch(`${location.origin}/api/sign-with-default-signature`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    owner_type: owner_type,
                    owner_id: owner_id
                })
            });
            if ((0, $8f2070e09d7bee6a$export$91cdf58e199a84d0)(response)) return;
            if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
            const { id: id, href: href, download_href: download_href, name: name } = await response.json();
            this.appendAttachment(id, name, download_href ?? href);
        } finally{
            this.signaturePadButton.classList.remove('btn-busy');
        }
    }
    async resetDefaultSignature() {
        try {
            this.signaturePadButton.classList.add('btn-busy');
            const response = await fetch(`${location.origin}/api/settings/default-signature`, {
                method: 'DELETE'
            });
            if ((0, $8f2070e09d7bee6a$export$91cdf58e199a84d0)(response)) return;
            if (!response.ok) throw new (0, $d089c140e1929c78$export$ea86d8b2c6b5cbfd)(response, await response.text());
            this.dispatchEvent(new CustomEvent('default-signature-updated', {
                bubbles: true,
                detail: {
                    href: null
                }
            }));
        } finally{
            this.signaturePadButton.classList.remove('btn-busy');
        }
    }
    valueInputFocused() {
        this.signaturePadButton.focus();
    }
    decrementCount() {
        if (this.valueInput.value === '1') {
            this.valueInput.value = '';
            this.emptyContent.hidden = false;
        } else this.valueInput.value = (parseInt(this.valueInput.value, 10) - 1).toString();
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(this.valueInput);
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b050cabf666a056d$var$SignatureQuestionElement.prototype, "signaturePadButton", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b050cabf666a056d$var$SignatureQuestionElement.prototype, "valueInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b050cabf666a056d$var$SignatureQuestionElement.prototype, "content", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b050cabf666a056d$var$SignatureQuestionElement.prototype, "emptyContent", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $b050cabf666a056d$var$SignatureQuestionElement.prototype, "selectMenuList", void 0);
$b050cabf666a056d$var$SignatureQuestionElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('signature-question')
], $b050cabf666a056d$var$SignatureQuestionElement);







const $c54ef520e8ab04a0$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
class $c54ef520e8ab04a0$var$SignatureSubmitterElement extends HTMLElement {
    objectUrls = [];
    get uploadUrl() {
        return new URL(this.getAttribute('upload-href'), location.origin);
    }
    get property_id() {
        return parseInt(this.getAttribute('property-id'), 10);
    }
    get jwt() {
        return this.getAttribute('jwt');
    }
    disconnectedCallback() {
        this.objectUrls.forEach(URL.revokeObjectURL);
    }
    async signatureAccepted({ detail: { blob: blob } }) {
        try {
            this.signaturePadButton.classList.add('btn-busy');
            const file = new File([
                blob
            ], 'signature.png', {
                type: 'image/png'
            });
            const attachment = new (0, $60111cd6ea196be2$export$71e4db985cfcf9e3)(file);
            attachment.name = file.name;
            await (0, $4ab5d79d76486e1b$export$14d3a7d22f26659e)({
                locale: $c54ef520e8ab04a0$var$locale,
                attachments: [
                    attachment
                ],
                uploadUrl: this.uploadUrl,
                attachmentSaved: ()=>{},
                jwt: this.jwt ?? ''
            });
            const href = URL.createObjectURL(blob);
            this.objectUrls.unshift(href);
            this.input.value = attachment.id;
            this.closest('form')?.requestSubmit();
        } catch (err) {
            console.error(err);
            return;
        } finally{
            this.signaturePadButton.classList.remove('btn-busy');
            this.signaturePadButton.focus();
        }
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $c54ef520e8ab04a0$var$SignatureSubmitterElement.prototype, "signaturePadButton", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $c54ef520e8ab04a0$var$SignatureSubmitterElement.prototype, "input", void 0);
$c54ef520e8ab04a0$var$SignatureSubmitterElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('signature-submitter')
], $c54ef520e8ab04a0$var$SignatureSubmitterElement);


class $39d6ed54664f18a6$export$50241aa08d3f66b4 extends HTMLElement {
    disconnectController;
    connectedCallback() {
        this.disconnectController = new AbortController();
        this.addEventListener('click', ()=>this.toggle(), {
            signal: this.disconnectController.signal,
            once: true
        });
    }
    disconnectedCallback() {
        this.disconnectController?.abort();
    }
    toggle() {
        this.textContent = this.getAttribute('value') ?? '[Value missing]';
    }
}
if (!window.customElements.get('ssn-reveal')) {
    window.SsnRevealElement = $39d6ed54664f18a6$export$50241aa08d3f66b4;
    window.customElements.define('ssn-reveal', $39d6ed54664f18a6$export$50241aa08d3f66b4);
}



class $908c1de2e0e53e67$export$e8dc149a419cc43a extends HTMLElement {
    connectedCallback() {
        this.setAttribute('role', 'alert');
        addEventListener((0, $ab6f099c20a34e1f$export$ee9f6aa6c23bab6c), this);
        addEventListener((0, $ab6f099c20a34e1f$export$7acd55e6ec74c9ed), this);
    }
    disconnectedCallback() {
        removeEventListener((0, $ab6f099c20a34e1f$export$ee9f6aa6c23bab6c), this);
        removeEventListener((0, $ab6f099c20a34e1f$export$7acd55e6ec74c9ed), this);
    }
    handleEvent(event) {
        if (event.target instanceof Element && event.target.closest(`[id="${this.getAttribute('for')}"]`)) this.hidden = event.type === (0, $ab6f099c20a34e1f$export$ee9f6aa6c23bab6c);
    }
}
if (!window.customElements.get('submit-alert')) {
    window.SubmitAlertElement = $908c1de2e0e53e67$export$e8dc149a419cc43a;
    window.customElements.define('submit-alert', $908c1de2e0e53e67$export$e8dc149a419cc43a);
}





class $bd7b8451db721b20$var$SwapControllerElement extends HTMLElement {
    swap({ target: target }) {
        const value = target && 'value' in target && typeof target.value === 'string' ? target.value : null;
        {
            const template = this.templates.find((t)=>t.getAttribute('data-value') === value);
            if (template) {
                const fragment = (0, $62491b8ea938a046$export$75a0370f3222215a)(template);
                const nodes = Array.from(fragment.children);
                const current = this.target;
                current.after(fragment);
                current.remove();
                nodes.forEach((0, $62491b8ea938a046$export$ae91b67ff38afcc3));
            }
        }
        {
            const template = this.secondaryTemplates.find((t)=>t.getAttribute('data-value') === value);
            if (template) {
                const fragment = (0, $62491b8ea938a046$export$75a0370f3222215a)(template);
                const nodes = Array.from(fragment.children);
                const current = this.secondaryTarget;
                current.after(fragment);
                current.remove();
                nodes.forEach((0, $62491b8ea938a046$export$ae91b67ff38afcc3));
            }
        }
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $bd7b8451db721b20$var$SwapControllerElement.prototype, "target", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $bd7b8451db721b20$var$SwapControllerElement.prototype, "templates", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $bd7b8451db721b20$var$SwapControllerElement.prototype, "secondaryTarget", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $bd7b8451db721b20$var$SwapControllerElement.prototype, "secondaryTemplates", void 0);
$bd7b8451db721b20$var$SwapControllerElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('swap-controller')
], $bd7b8451db721b20$var$SwapControllerElement);






const $974afe6104f534be$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
(0, $84fd3dc30499b2d0$export$86f1725708ac86dc)((input, label)=>{
    if (input instanceof HTMLInputElement && input.type === 'text' && input.value.length && input.name.includes(':time')) {
        const value = input.value.trim();
        if (value.length === 0) return null;
        const parsed = (0, $b78c044e3d911d2e$export$ca3f99600512f983)(value);
        if (!parsed) return (0, $b11db1b62d4a8f76$export$410707f7b09eb086)[$974afe6104f534be$var$locale](label);
    }
    return null;
});






class $fc9a9c667fc02b40$export$2e2bcd8739ae039 extends HTMLElement {
    changeMode(event) {
        const button = event.currentTarget;
        this.querySelectorAll('[data-timeline-mode][aria-selected]').forEach((el)=>{
            el.setAttribute('aria-selected', String(el === button));
        });
        this.reload();
    }
    changeSort(event) {
        const button = event.currentTarget;
        const sort = button.dataset.timelineSort;
        button.setAttribute('aria-label', sort === 'asc' ? 'Sort ascending' : 'Sort descending');
        button.dataset.timelineSort = sort === 'asc' ? 'desc' : 'asc';
        button.setAttribute('cookie-value', sort === 'asc' ? '' : 'asc');
        button.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $84c634e688af79ca$export$1ca1ec8b29a4ce27)(sort === 'asc' ? (0, $84c634e688af79ca$export$f4b6d034496ffda1) : (0, $84c634e688af79ca$export$a7f606f216bfee52)));
        this.reload();
    }
    toggleAssistant() {
        this.assistant.hidden = !this.assistant.hidden;
        if (!this.assistant.hidden) (0, $80a2320123ddcd02$export$956fd4dade47957a)(this.assistant);
    }
    reload() {
        this.searchInput.value = '';
        const remote = this.searchInput.closest('remote-input');
        // Setting src, even to the same value, will cause the remote input to reload because it will invoke
        // fetchResults with checkCurrentQuery=false.
        // https://github.com/github/remote-input-element/blob/dcb027c993790dbfd4ac50e0c65c29a0c73f5780/src/index.ts#L20
        remote.setAttribute('src', remote.src);
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $fc9a9c667fc02b40$export$2e2bcd8739ae039.prototype, "searchInput", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $fc9a9c667fc02b40$export$2e2bcd8739ae039.prototype, "assistant", void 0);
$fc9a9c667fc02b40$export$2e2bcd8739ae039 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('timeline-controller')
], $fc9a9c667fc02b40$export$2e2bcd8739ae039);









const $1cfd3c9cd76d9feb$var$locale = (0, $c74c4f773f8a11f2$export$180605366c04f0cd)();
class $1cfd3c9cd76d9feb$export$2e2bcd8739ae039 extends HTMLElement {
    get pay_period_activity_id() {
        return this.getAttribute('pay_period_activity_id');
    }
    set pay_period_activity_id(value) {
        if (value) this.setAttribute('pay_period_activity_id', value);
        else this.removeAttribute('pay_period_activity_id');
    }
    connectedCallback() {
        addEventListener((0, $8cc5ae33f12b8590$export$94a24a4e724aa571), this);
    }
    disconnectedCallback() {
        removeEventListener((0, $8cc5ae33f12b8590$export$94a24a4e724aa571), this);
    }
    handleEvent(event) {
        const { type: type, target: target } = event;
        switch(type){
            case 0, $8cc5ae33f12b8590$export$94a24a4e724aa571:
                {
                    if (!(target instanceof (0, $8cc5ae33f12b8590$export$2e2bcd8739ae039)) || !target.period || target.activity_id === this.pay_period_activity_id) return;
                    this.pay_period_activity_id = target.activity_id;
                    if (!this.pay_period_activity_id) {
                        this.innerHTML = '';
                        return;
                    }
                    const url = new URL(this.getAttribute('src'), location.origin);
                    url.searchParams.set('pay_period_activity_id', this.pay_period_activity_id);
                    this.innerHTML = (0, $f4d1565f2a6712b7$export$b3890eb0ae9dca99)((0, $f4d1565f2a6712b7$export$c0bb0b647f701bb5)`<include-fragment
            src="${url.pathname + url.search}"
            accept="text/fragment+html"
            class="d-flex gap-2 flex-items-center flex-justify-center py-12 color-fg-muted color-bg-inset rounded"
            data-target="activity-select.preview"
            role="status"
          >
            <span class="spinner-border"></span>
            <span>${(0, $b11db1b62d4a8f76$export$25a57b30938bf753)[$1cfd3c9cd76d9feb$var$locale]}</span>
          </include-fragment>`);
                    return;
                }
            default:
                throw new Error(`Unhandled event: ${event.type}`);
        }
    }
    appendEntryDeletionComment(event) {
        const deletionComment = event.currentTarget instanceof HTMLElement && event.currentTarget.dataset.deletionComment;
        if (!deletionComment) return;
        const form = this.closest('form');
        const comment = form?.elements.namedItem('comment_body');
        if (!(comment instanceof HTMLTextAreaElement)) return;
        comment.value += `${comment.value ? '\n' : ''}${deletionComment}`;
        (0, $80a2320123ddcd02$export$89348ae70780cd7a)(comment);
    }
}
$1cfd3c9cd76d9feb$export$2e2bcd8739ae039 = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('timesheet-entries')
], $1cfd3c9cd76d9feb$export$2e2bcd8739ae039);




class $834bfa877620eb76$var$UppercaseTextInput extends HTMLElement {
    connectedCallback() {
        this.addEventListener('change', this);
    }
    disconnectedCallback() {
        this.removeEventListener('change', this);
    }
    handleEvent(event) {
        if (event.target instanceof HTMLInputElement && event.target.type === 'text' && event.target.value !== event.target.value.toUpperCase()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            event.target.value = event.target.value.toUpperCase();
            (0, $80a2320123ddcd02$export$89348ae70780cd7a)(event.target);
        }
    }
}
(0, $84fd3dc30499b2d0$export$86f1725708ac86dc)((input, label)=>{
    if (input instanceof HTMLInputElement && input.type === 'text' && input.value.length && input.parentElement instanceof $834bfa877620eb76$var$UppercaseTextInput && input.value !== input.value.toUpperCase()) return `${label} must be all uppercase letters.`;
    return null;
});
if (!window.customElements.get('uppercase-text-input')) {
    window.UppercaseTextInput = $834bfa877620eb76$var$UppercaseTextInput;
    window.customElements.define('uppercase-text-input', $834bfa877620eb76$var$UppercaseTextInput);
}





class $4dcba90f4ee94249$var$UrlFieldElement extends HTMLElement {
    disconnected;
    connectedCallback() {
        this.disconnected = new AbortController();
        const options = {
            signal: this.disconnected.signal
        };
        this.input.addEventListener('change', ()=>this.update(), options);
        this.input.addEventListener('input', ()=>this.update(), options);
        this.update();
    }
    disconnectedCallback() {
        this.disconnected?.abort();
    }
    update() {
        const valid = (0, $84fd3dc30499b2d0$export$520d31645f260e07)(this.input);
        this.anchor.ariaDisabled = this.copy.ariaDisabled = String(!valid);
        if (valid) this.anchor.href = this.input.value;
        else this.anchor.removeAttribute('href');
        this.copy.tabIndex = valid ? 0 : -1;
    }
}
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $4dcba90f4ee94249$var$UrlFieldElement.prototype, "input", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $4dcba90f4ee94249$var$UrlFieldElement.prototype, "copy", void 0);
(0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $4dcba90f4ee94249$var$UrlFieldElement.prototype, "anchor", void 0);
$4dcba90f4ee94249$var$UrlFieldElement = (0, $d6c5a61e077d7968$export$29e00dfd3077644b)([
    (0, $435094da9351c1d8$export$de3b759ab07e4403)('url-field')
], $4dcba90f4ee94249$var$UrlFieldElement);






class $eed88219b0d9247d$export$3024f3bfb62054a3 {
    constructor(trie){
        this.children = [];
        this.parent = trie;
    }
    delete(value) {
        const index = this.children.indexOf(value);
        if (index === -1) return false;
        this.children = this.children.slice(0, index).concat(this.children.slice(index + 1));
        if (this.children.length === 0) this.parent.delete(this);
        return true;
    }
    add(value) {
        this.children.push(value);
        return this;
    }
}
class $eed88219b0d9247d$export$4e51cba2d60a1772 {
    constructor(trie){
        this.parent = null;
        this.children = {};
        this.parent = trie || null;
    }
    get(edge) {
        return this.children[edge];
    }
    insert(edges) {
        let currentNode = this;
        for(let i = 0; i < edges.length; i += 1){
            const edge = edges[i];
            let nextNode = currentNode.get(edge);
            if (i === edges.length - 1) {
                if (nextNode instanceof $eed88219b0d9247d$export$4e51cba2d60a1772) {
                    currentNode.delete(nextNode);
                    nextNode = null;
                }
                if (!nextNode) {
                    nextNode = new $eed88219b0d9247d$export$3024f3bfb62054a3(currentNode);
                    currentNode.children[edge] = nextNode;
                }
                return nextNode;
            } else {
                if (nextNode instanceof $eed88219b0d9247d$export$3024f3bfb62054a3) nextNode = null;
                if (!nextNode) {
                    nextNode = new $eed88219b0d9247d$export$4e51cba2d60a1772(currentNode);
                    currentNode.children[edge] = nextNode;
                }
            }
            currentNode = nextNode;
        }
        return currentNode;
    }
    delete(node) {
        for(const edge in this.children){
            const currentNode = this.children[edge];
            if (currentNode === node) {
                const success = delete this.children[edge];
                if (Object.keys(this.children).length === 0 && this.parent) this.parent.delete(this);
                return success;
            }
        }
        return false;
    }
}
const $eed88219b0d9247d$var$macosSymbolLayerKeys = {
    ["\xa1"]: '1',
    ["\u2122"]: '2',
    ["\xa3"]: '3',
    ["\xa2"]: '4',
    ["\u221E"]: '5',
    ["\xa7"]: '6',
    ["\xb6"]: '7',
    ["\u2022"]: '8',
    ["\xaa"]: '9',
    ["\xba"]: '0',
    ["\u2013"]: '-',
    ["\u2260"]: '=',
    ["\u2044"]: '!',
    ["\u20AC"]: '@',
    ["\u2039"]: '#',
    ["\u203A"]: '$',
    ["\uFB01"]: '%',
    ["\uFB02"]: '^',
    ["\u2021"]: '&',
    ["\xb0"]: '*',
    ["\xb7"]: '(',
    ["\u201A"]: ')',
    ["\u2014"]: '_',
    ["\xb1"]: '+',
    ["\u0153"]: 'q',
    ["\u2211"]: 'w',
    ["\xae"]: 'r',
    ["\u2020"]: 't',
    ["\xa5"]: 'y',
    ["\xf8"]: 'o',
    ["\u03C0"]: 'p',
    ["\u201C"]: '[',
    ["\u2018"]: ']',
    ["\xab"]: '\\',
    ["\u0152"]: 'Q',
    ["\u201E"]: 'W',
    ["\xb4"]: 'E',
    ["\u2030"]: 'R',
    ["\u02C7"]: 'T',
    ["\xc1"]: 'Y',
    ["\xa8"]: 'U',
    ["\u02C6"]: 'I',
    ["\xd8"]: 'O',
    ["\u220F"]: 'P',
    ["\u201D"]: '{',
    ["\u2019"]: '}',
    ["\xbb"]: '|',
    ["\xe5"]: 'a',
    ["\xdf"]: 's',
    ["\u2202"]: 'd',
    ["\u0192"]: 'f',
    ["\xa9"]: 'g',
    ["\u02D9"]: 'h',
    ["\u2206"]: 'j',
    ["\u02DA"]: 'k',
    ["\xac"]: 'l',
    ["\u2026"]: ';',
    ["\xe6"]: "'",
    ["\xc5"]: 'A',
    ["\xcd"]: 'S',
    ["\xce"]: 'D',
    ["\xcf"]: 'F',
    ["\u02DD"]: 'G',
    ["\xd3"]: 'H',
    ["\xd4"]: 'J',
    ["\uF8FF"]: 'K',
    ["\xd2"]: 'L',
    ["\xda"]: ':',
    ["\xc6"]: '"',
    ["\u03A9"]: 'z',
    ["\u2248"]: 'x',
    ["\xe7"]: 'c',
    ["\u221A"]: 'v',
    ["\u222B"]: 'b',
    ["\xb5"]: 'm',
    ["\u2264"]: ',',
    ["\u2265"]: '.',
    ["\xf7"]: '/',
    ["\xb8"]: 'Z',
    ["\u02DB"]: 'X',
    ["\xc7"]: 'C',
    ["\u25CA"]: 'V',
    ["\u0131"]: 'B',
    ["\u02DC"]: 'N',
    ["\xc2"]: 'M',
    ["\xaf"]: '<',
    ["\u02D8"]: '>',
    ["\xbf"]: '?'
};
const $eed88219b0d9247d$var$macosUppercaseLayerKeys = {
    ['`']: '~',
    ['1']: '!',
    ['2']: '@',
    ['3']: '#',
    ['4']: '$',
    ['5']: '%',
    ['6']: '^',
    ['7']: '&',
    ['8']: '*',
    ['9']: '(',
    ['0']: ')',
    ['-']: '_',
    ['=']: '+',
    ['[']: '{',
    [']']: '}',
    ['\\']: '|',
    [';']: ':',
    ["'"]: '"',
    [',']: '<',
    ['.']: '>',
    ['/']: '?',
    ['q']: 'Q',
    ['w']: 'W',
    ['e']: 'E',
    ['r']: 'R',
    ['t']: 'T',
    ['y']: 'Y',
    ['u']: 'U',
    ['i']: 'I',
    ['o']: 'O',
    ['p']: 'P',
    ['a']: 'A',
    ['s']: 'S',
    ['d']: 'D',
    ['f']: 'F',
    ['g']: 'G',
    ['h']: 'H',
    ['j']: 'J',
    ['k']: 'K',
    ['l']: 'L',
    ['z']: 'Z',
    ['x']: 'X',
    ['c']: 'C',
    ['v']: 'V',
    ['b']: 'B',
    ['n']: 'N',
    ['m']: 'M'
};
const $eed88219b0d9247d$var$syntheticKeyNames = {
    ' ': 'Space',
    '+': 'Plus'
};
function $eed88219b0d9247d$export$675b475d602780dc(event, platform = navigator.platform) {
    var _a, _b, _c;
    const { ctrlKey: ctrlKey, altKey: altKey, metaKey: metaKey, shiftKey: shiftKey, key: key } = event;
    const hotkeyString = [];
    const modifiers = [
        ctrlKey,
        altKey,
        metaKey,
        shiftKey
    ];
    for (const [i, mod] of modifiers.entries())if (mod) hotkeyString.push($eed88219b0d9247d$var$modifierKeyNames[i]);
    if (!$eed88219b0d9247d$var$modifierKeyNames.includes(key)) {
        const altNormalizedKey = hotkeyString.includes('Alt') && $eed88219b0d9247d$var$matchApplePlatform.test(platform) ? (_a = $eed88219b0d9247d$var$macosSymbolLayerKeys[key]) !== null && _a !== void 0 ? _a : key : key;
        const shiftNormalizedKey = hotkeyString.includes('Shift') && $eed88219b0d9247d$var$matchApplePlatform.test(platform) ? (_b = $eed88219b0d9247d$var$macosUppercaseLayerKeys[altNormalizedKey]) !== null && _b !== void 0 ? _b : altNormalizedKey : altNormalizedKey;
        const syntheticKey = (_c = $eed88219b0d9247d$var$syntheticKeyNames[shiftNormalizedKey]) !== null && _c !== void 0 ? _c : shiftNormalizedKey;
        hotkeyString.push(syntheticKey);
    }
    return hotkeyString.join('+');
}
const $eed88219b0d9247d$var$modifierKeyNames = [
    'Control',
    'Alt',
    'Meta',
    'Shift'
];
function $eed88219b0d9247d$export$e8d1c6663be136b1(hotkey, platform) {
    let result;
    result = $eed88219b0d9247d$var$localizeMod(hotkey, platform);
    result = $eed88219b0d9247d$var$sortModifiers(result);
    return result;
}
const $eed88219b0d9247d$var$matchApplePlatform = /Mac|iPod|iPhone|iPad/i;
function $eed88219b0d9247d$var$localizeMod(hotkey, platform) {
    var _a;
    const ssrSafeWindow = typeof window === 'undefined' ? undefined : window;
    const safePlatform = (_a = platform !== null && platform !== void 0 ? platform : ssrSafeWindow === null || ssrSafeWindow === void 0 ? void 0 : ssrSafeWindow.navigator.platform) !== null && _a !== void 0 ? _a : '';
    const localModifier = $eed88219b0d9247d$var$matchApplePlatform.test(safePlatform) ? 'Meta' : 'Control';
    return hotkey.replace('Mod', localModifier);
}
const $eed88219b0d9247d$var$orderedModifiers = {
    Control: 0,
    Alt: 1,
    Meta: 2,
    Shift: 3
};
function $eed88219b0d9247d$var$sortModifiers(hotkey) {
    return hotkey.split('+').sort((a, b)=>{
        var _a, _b;
        return ((_a = $eed88219b0d9247d$var$orderedModifiers[a]) !== null && _a !== void 0 ? _a : Infinity) - ((_b = $eed88219b0d9247d$var$orderedModifiers[b]) !== null && _b !== void 0 ? _b : Infinity);
    }).join('+');
}
const $eed88219b0d9247d$var$SEQUENCE_DELIMITER = ' ';
class $eed88219b0d9247d$export$3f9c3ffe4833e2df {
    constructor({ onReset: onReset } = {}){
        this._path = [];
        this.timer = null;
        this.onReset = onReset;
    }
    get path() {
        return this._path;
    }
    get sequence() {
        return this._path.join($eed88219b0d9247d$var$SEQUENCE_DELIMITER);
    }
    registerKeypress(event) {
        this._path = [
            ...this._path,
            $eed88219b0d9247d$export$675b475d602780dc(event)
        ];
        this.startTimer();
    }
    reset() {
        var _a;
        this.killTimer();
        this._path = [];
        (_a = this.onReset) === null || _a === void 0 || _a.call(this);
    }
    killTimer() {
        if (this.timer != null) window.clearTimeout(this.timer);
        this.timer = null;
    }
    startTimer() {
        this.killTimer();
        this.timer = window.setTimeout(()=>this.reset(), $eed88219b0d9247d$export$3f9c3ffe4833e2df.CHORD_TIMEOUT);
    }
}
$eed88219b0d9247d$export$3f9c3ffe4833e2df.CHORD_TIMEOUT = 1500;
function $eed88219b0d9247d$export$b109b10146e8f9ba(sequence) {
    return sequence.split($eed88219b0d9247d$var$SEQUENCE_DELIMITER).map((h)=>$eed88219b0d9247d$export$e8d1c6663be136b1(h)).join($eed88219b0d9247d$var$SEQUENCE_DELIMITER);
}
function $eed88219b0d9247d$var$isFormField(element) {
    if (!(element instanceof HTMLElement)) return false;
    const name = element.nodeName.toLowerCase();
    const type = (element.getAttribute('type') || '').toLowerCase();
    return name === 'select' || name === 'textarea' || name === 'input' && type !== 'submit' && type !== 'reset' && type !== 'checkbox' && type !== 'radio' && type !== 'file' || element.isContentEditable;
}
function $eed88219b0d9247d$var$fireDeterminedAction(el, path) {
    const delegateEvent = new CustomEvent('hotkey-fire', {
        cancelable: true,
        detail: {
            path: path
        }
    });
    const cancelled = !el.dispatchEvent(delegateEvent);
    if (cancelled) return;
    if ($eed88219b0d9247d$var$isFormField(el)) el.focus();
    else el.click();
}
function $eed88219b0d9247d$var$expandHotkeyToEdges(hotkey) {
    const output = [];
    let acc = [
        ''
    ];
    let commaIsSeparator = false;
    for(let i = 0; i < hotkey.length; i++){
        if (commaIsSeparator && hotkey[i] === ',') {
            output.push(acc);
            acc = [
                ''
            ];
            commaIsSeparator = false;
            continue;
        }
        if (hotkey[i] === $eed88219b0d9247d$var$SEQUENCE_DELIMITER) {
            acc.push('');
            commaIsSeparator = false;
            continue;
        } else if (hotkey[i] === '+') commaIsSeparator = false;
        else commaIsSeparator = true;
        acc[acc.length - 1] += hotkey[i];
    }
    output.push(acc);
    return output.map((h)=>h.map((k)=>$eed88219b0d9247d$export$e8d1c6663be136b1(k)).filter((k)=>k !== '')).filter((h)=>h.length > 0);
}
const $eed88219b0d9247d$var$hotkeyRadixTrie = new $eed88219b0d9247d$export$4e51cba2d60a1772();
const $eed88219b0d9247d$var$elementsLeaves = new WeakMap();
let $eed88219b0d9247d$var$currentTriePosition = $eed88219b0d9247d$var$hotkeyRadixTrie;
const $eed88219b0d9247d$var$sequenceTracker = new $eed88219b0d9247d$export$3f9c3ffe4833e2df({
    onReset () {
        $eed88219b0d9247d$var$currentTriePosition = $eed88219b0d9247d$var$hotkeyRadixTrie;
    }
});
function $eed88219b0d9247d$var$keyDownHandler(event) {
    if (event.defaultPrevented) return;
    if (!(event.target instanceof Node)) return;
    if ($eed88219b0d9247d$var$isFormField(event.target)) {
        const target = event.target;
        if (!target.id) return;
        if (!target.ownerDocument.querySelector(`[data-hotkey-scope="${target.id}"]`)) return;
    }
    const newTriePosition = $eed88219b0d9247d$var$currentTriePosition.get($eed88219b0d9247d$export$675b475d602780dc(event));
    if (!newTriePosition) {
        $eed88219b0d9247d$var$sequenceTracker.reset();
        return;
    }
    $eed88219b0d9247d$var$sequenceTracker.registerKeypress(event);
    $eed88219b0d9247d$var$currentTriePosition = newTriePosition;
    if (newTriePosition instanceof $eed88219b0d9247d$export$3024f3bfb62054a3) {
        const target = event.target;
        let shouldFire = false;
        let elementToFire;
        const formField = $eed88219b0d9247d$var$isFormField(target);
        for(let i = newTriePosition.children.length - 1; i >= 0; i -= 1){
            elementToFire = newTriePosition.children[i];
            const scope = elementToFire.getAttribute('data-hotkey-scope');
            if (!formField && !scope || formField && target.id === scope) {
                shouldFire = true;
                break;
            }
        }
        if (elementToFire && shouldFire) {
            $eed88219b0d9247d$var$fireDeterminedAction(elementToFire, $eed88219b0d9247d$var$sequenceTracker.path);
            event.preventDefault();
        }
        $eed88219b0d9247d$var$sequenceTracker.reset();
    }
}
function $eed88219b0d9247d$export$4b3e715f166fdd78(element, hotkey) {
    if (Object.keys($eed88219b0d9247d$var$hotkeyRadixTrie.children).length === 0) document.addEventListener('keydown', $eed88219b0d9247d$var$keyDownHandler);
    const hotkeys = $eed88219b0d9247d$var$expandHotkeyToEdges(hotkey || element.getAttribute('data-hotkey') || '');
    const leaves = hotkeys.map((h)=>$eed88219b0d9247d$var$hotkeyRadixTrie.insert(h).add(element));
    $eed88219b0d9247d$var$elementsLeaves.set(element, leaves);
}
function $eed88219b0d9247d$export$a846c21fa8a8ce67(element) {
    const leaves = $eed88219b0d9247d$var$elementsLeaves.get(element);
    if (leaves && leaves.length) for (const leaf of leaves)leaf && leaf.delete(element);
    if (Object.keys($eed88219b0d9247d$var$hotkeyRadixTrie.children).length === 0) document.removeEventListener('keydown', $eed88219b0d9247d$var$keyDownHandler);
}


const $55d1963e90be71be$var$attrName = 'data-hotkey';
function $55d1963e90be71be$var$installSubtree(element = document.documentElement) {
    if (element.hasAttribute($55d1963e90be71be$var$attrName)) (0, $eed88219b0d9247d$export$4b3e715f166fdd78)(element);
    for (const el of element.querySelectorAll(`[${$55d1963e90be71be$var$attrName}]`))(0, $eed88219b0d9247d$export$4b3e715f166fdd78)(el);
}
const $55d1963e90be71be$var$observer = new MutationObserver((mutations)=>{
    for (const mutation of mutations){
        if (mutation.type === 'attributes' && mutation.target instanceof HTMLElement) (0, $eed88219b0d9247d$export$4b3e715f166fdd78)(mutation.target);
        else if (mutation.type === 'childList' && mutation.addedNodes.length) {
            for (const node of mutation.addedNodes)if (node instanceof HTMLElement) $55d1963e90be71be$var$installSubtree(node);
        }
    }
});
$55d1963e90be71be$var$observer.observe(document, {
    childList: true,
    subtree: true,
    attributeFilter: [
        $55d1963e90be71be$var$attrName
    ]
});
$55d1963e90be71be$var$installSubtree();



addEventListener('click', async (event)=>{
    const target = event.target;
    if (!(target instanceof Element)) return;
    // todo... switch all these to "click-behavior" attributes
    // data-requires-submit
    {
        const button = target.closest('[data-requires-submit]:is(button, a, label, summary)');
        const requiresSubmit = button && (button.closest('modal-content')?.querySelector('form-behavior:not([unload-prompt="false"])') ?? document.querySelector('form-behavior:not([unload-prompt="false"])'));
        if (requiresSubmit?.canSubmit) {
            event.preventDefault();
            event.stopPropagation();
            if (!await requiresSubmit.confirmImplicitSubmit()) return;
            button.classList.add('btn-busy');
            await requiresSubmit.submit();
            button.classList.remove('btn-busy');
            if (requiresSubmit.canSubmit) // prevent further processing of subsequent behaviors below.
            return;
            const clickable = target.closest('button, a, label, summary');
            if (clickable instanceof HTMLAnchorElement && !clickable.target && (event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1)) {
                clickable.setAttribute('target', '_blank');
                clickable.click();
                clickable.removeAttribute('target');
            } else clickable?.click();
        }
    }
    target.closest('.js-flash-close') && target.closest('.flash')?.remove();
    target.closest('[data-dismiss]') && document.getElementById(target.closest('[data-dismiss]').getAttribute('data-dismiss'))?.remove();
    // data-toggle-for attribute
    {
        const toggle = target.closest('[data-toggle-for]');
        if (toggle) {
            const id = toggle.getAttribute('data-toggle-for');
            if (id) {
                const toggleTarget = document.getElementById(id);
                if (toggleTarget) toggleTarget.toggleAttribute('open', !toggleTarget.hasAttribute('open'));
            }
        }
    }
    // cookie set
    {
        const button = target.closest(':is(button,a)[cookie-name][cookie-value][cookie-max-age]');
        if (button) {
            const name = button.getAttribute('cookie-name');
            const value = button.getAttribute('cookie-value');
            const maxAge = button.getAttribute('cookie-max-age');
            if (name) document.cookie = `${name}=${value};path=/;${location.protocol === 'https:' ? 'secure;' : ''};samesite=lax;max-age=${maxAge}`;
        }
    }
    // print button
    {
        const button = target.closest('[click-behavior="print"]');
        if (button) print();
    }
    // reveal element
    {
        const button = target.closest('[click-behavior="reveal"]');
        if (button) {
            const id = button.getAttribute('aria-controls');
            const element = id && document.getElementById(id);
            if (element) {
                element.hidden = false;
                (0, $80a2320123ddcd02$export$9657601bf1e130ee)(element);
                (0, $80a2320123ddcd02$export$956fd4dade47957a)(element);
            }
        }
    }
    // hide element
    {
        const button = target.closest('[click-behavior="hide"]');
        if (button) {
            const id = button.getAttribute('aria-controls');
            const element = id && document.getElementById(id);
            if (element) element.hidden = true;
        }
    }
}, true);
// addEventListener(
//   'mouseover',
//   ({ target }) => {
//     const details =
//       target instanceof HTMLElement &&
//       target.closest<HTMLDetailsElement>(
//         'details[data-hover-open]:not([open])'
//       );
//     if (details) {
//       console.log(details);
//       details.open = true;
//       details.lastElementChild?.addEventListener(
//         'mouseleave',
//         () => setTimeout(() => (details.open = false)),
//         {
//           once: true,
//           passive: true
//         }
//       );
//     }
//   }
//   // true
//   //{ capture: true, passive: true }
// );
addEventListener('clipboard-copy', ({ target: target })=>{
    if (!(target instanceof HTMLElement)) return;
    target.classList.add('btn-copied');
    setTimeout(()=>target.classList.remove('btn-copied'), 1000);
});
const $8fefd74466994e6f$var$organizationHeader = document.getElementById('sticky-organization-header');
if ($8fefd74466994e6f$var$organizationHeader) {
    const small = matchMedia('screen and (min-width: 544px)');
    const handler = ()=>{
        const scrolled = document.documentElement.scrollTop > 0 && small.matches && $8fefd74466994e6f$var$organizationHeader.getBoundingClientRect().top === 0;
        $8fefd74466994e6f$var$organizationHeader.classList.toggle('border-bottom', scrolled);
        $8fefd74466994e6f$var$organizationHeader.classList.toggle('color-shadow-medium', scrolled);
    };
    addEventListener('scroll', handler, {
        passive: true
    });
    small.addEventListener('change', handler, {
        passive: true
    });
    handler();
}
function $8fefd74466994e6f$var$getHighchartsThemeClass() {
    const colorMode = document.documentElement.getAttribute('data-color-mode');
    const theme = document.documentElement.getAttribute('data-light-theme') ?? 'light';
    return colorMode === 'auto' ? 'highcharts-auto' : theme.startsWith('dark') ? 'highcharts-dark' : 'highcharts-light';
}
document.getElementById('theme-select')?.addEventListener('details-menu-selected', (event)=>{
    const theme = event.detail.relatedTarget.getAttribute('theme') ?? 'auto';
    document.documentElement.setAttribute('data-color-mode', theme === 'auto' ? 'auto' : 'light');
    document.documentElement.setAttribute('data-light-theme', theme === 'auto' ? 'light' : theme);
    const sidebar = document.querySelector('side-bar');
    const sidebarThemeMap = {
        light: 'dark',
        light_high_contrast: 'dark_high_contrast',
        dark: 'dark',
        dark_dimmed: 'dark_dimmed',
        dark_high_contrast: 'dark_high_contrast',
        dark_colorblind: 'dark_colorblind',
        light_colorblind: 'dark_colorblind',
        dark_tritanopia: 'dark_tritanopia',
        light_tritanopia: 'dark_tritanopia',
        auto: 'dark'
    };
    sidebar?.setAttribute('data-color-mode', theme === 'auto' ? 'auto' : 'light');
    sidebar?.setAttribute('data-light-theme', sidebarThemeMap[theme]);
    document.cookie = 'theme=' + theme + ';path=/;' + (location.protocol === 'https:' ? 'secure;' : '') + 'samesite=lax;max-age=31536000';
    const highchartsThemeClass = $8fefd74466994e6f$var$getHighchartsThemeClass();
    document.querySelectorAll('.highcharts-container').forEach((container)=>{
        container.classList.remove('highcharts-auto', 'highcharts-light', 'highcharts-dark');
        container.classList.add(highchartsThemeClass);
    });
});
// if the selected details menu item has an input whose name attribute
// is missing, apply the current input's name
addEventListener('details-menu-select', (event)=>{
    let contents = event.detail.relatedTarget.querySelector('[data-menu-button-contents]');
    if (contents instanceof HTMLTemplateElement) contents = contents.content;
    const input = contents?.querySelector('input:not([name])');
    const current = event.target instanceof (0, $8449f1a811eb81cd$export$2e2bcd8739ae039) && event.target.closest('details')?.firstElementChild?.querySelector('input');
    if (input && current) input.name = current.name;
}, true);
addEventListener('keydown', (event)=>{
    if (event.key === ' ' && event.target instanceof HTMLAnchorElement && event.target.getAttribute('role') === 'button') {
        event.preventDefault();
        event.target.click();
    }
});


//# sourceMappingURL=manifest.4f761362.js.map
